
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("kFGm5", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $ee7Ev = parcelRequire("ee7Ev");

var $3zPPS = parcelRequire("3zPPS");

var $4bGgA = parcelRequire("4bGgA");

var $i31gq = parcelRequire("i31gq");

var $8BG5F = parcelRequire("8BG5F");

var $224h2 = parcelRequire("224h2");

var $5YL8y = parcelRequire("5YL8y");
/** Used to compose bitmasks for cloning. */ var $f0c87dd638da6507$var$CLONE_DEEP_FLAG = 1, $f0c87dd638da6507$var$CLONE_FLAT_FLAG = 2, $f0c87dd638da6507$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $f0c87dd638da6507$var$omit = $224h2(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $kJvGp(paths, function(path) {
        path = $4bGgA(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $i31gq(object, $5YL8y(object), result);
    if (isDeep) result = $ee7Ev(result, $f0c87dd638da6507$var$CLONE_DEEP_FLAG | $f0c87dd638da6507$var$CLONE_FLAT_FLAG | $f0c87dd638da6507$var$CLONE_SYMBOLS_FLAG, $8BG5F);
    var length = paths.length;
    while(length--)$3zPPS(result, paths[length]);
    return result;
});
module.exports = $f0c87dd638da6507$var$omit;

});
parcelRegister("3zPPS", function(module, exports) {

var $4bGgA = parcelRequire("4bGgA");

var $iTvqy = parcelRequire("iTvqy");

var $2wKO3 = parcelRequire("2wKO3");

var $cNyDu = parcelRequire("cNyDu");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $29acd9759e1173c0$var$baseUnset(object, path) {
    path = $4bGgA(path, object);
    object = $2wKO3(object, path);
    return object == null || delete object[$cNyDu($iTvqy(path))];
}
module.exports = $29acd9759e1173c0$var$baseUnset;

});
parcelRegister("2wKO3", function(module, exports) {

var $dS3e6 = parcelRequire("dS3e6");

var $jADKY = parcelRequire("jADKY");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $1d72e0aabaa913d7$var$parent(object, path) {
    return path.length < 2 ? object : $dS3e6(object, $jADKY(path, 0, -1));
}
module.exports = $1d72e0aabaa913d7$var$parent;

});


parcelRegister("8BG5F", function(module, exports) {

var $jtsd5 = parcelRequire("jtsd5");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $64426db23baa732e$var$customOmitClone(value) {
    return $jtsd5(value) ? undefined : value;
}
module.exports = $64426db23baa732e$var$customOmitClone;

});


parcelRegister("8dloj", function(module, exports) {

var $7Smv0 = parcelRequire("7Smv0");

var $224h2 = parcelRequire("224h2");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $5fb02174d73b0468$var$pick = $224h2(function(object, paths) {
    return object == null ? {} : $7Smv0(object, paths);
});
module.exports = $5fb02174d73b0468$var$pick;

});
parcelRegister("7Smv0", function(module, exports) {

var $h5G5y = parcelRequire("h5G5y");

var $cj1vT = parcelRequire("cj1vT");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $5bbf076b50457091$var$basePick(object, paths) {
    return $h5G5y(object, paths, function(value, path) {
        return $cj1vT(object, path);
    });
}
module.exports = $5bbf076b50457091$var$basePick;

});


parcelRegister("gpO36", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $bf35cdd4cc1c7094$export$882461b6382ed46c, (v) => $bf35cdd4cc1c7094$export$882461b6382ed46c = v);
var $bf35cdd4cc1c7094$export$882461b6382ed46c;
var $bf35cdd4cc1c7094$export$757ceba2d55c277e;
'use strict';

var $lEfVV = parcelRequire("lEfVV");
var $bf35cdd4cc1c7094$var$i;
$bf35cdd4cc1c7094$export$882461b6382ed46c = $lEfVV.createRoot;
$bf35cdd4cc1c7094$export$757ceba2d55c277e = $lEfVV.hydrateRoot;

});

parcelRegister("ek61b", function(module, exports) {

$parcel$export(module.exports, "LooselyLazy", () => $24e2f4e62a7f86de$export$33c5f161e1d4706);

var $2zUto = parcelRequire("2zUto");

var $8dNND = parcelRequire("8dNND");

var $lMjVs = parcelRequire("lMjVs");
var $a5cKA = parcelRequire("a5cKA");

var $k7qTz = parcelRequire("k7qTz");
const $24e2f4e62a7f86de$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $8dNND.setConfig)(config);
        (0, $lMjVs.LISTENERS).length = 0;
        (0, $a5cKA.setCurrent)(0);
        if (!(0, $k7qTz.isNodeEnvironment)()) (0, $2zUto.collect)();
    }
};

});
parcelRegister("2zUto", function(module, exports) {

$parcel$export(module.exports, "collect", () => $7b558a1b40ccc192$export$bb44f104e3c54dae);

var $8dNND = parcelRequire("8dNND");

var $3z0jW = parcelRequire("3z0jW");

var $7W5iL = parcelRequire("7W5iL");

var $lqHTf = parcelRequire("lqHTf");
const $7b558a1b40ccc192$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $8dNND.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $8dNND.MODE).RENDER ? (0, $7W5iL.cloneElements)(markers[i], lazyBegin) : (0, $lqHTf.refElements)(markers[i], lazyBegin);
        if ((0, $3z0jW.COLLECTED).has(lazyBegin)) (0, $3z0jW.COLLECTED).get(lazyBegin).push(value);
        else (0, $3z0jW.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("7W5iL", function(module, exports) {

$parcel$export(module.exports, "cloneElements", () => $e2c455271f876ba2$export$c42217d53a7ebafb);
const $e2c455271f876ba2$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("lqHTf", function(module, exports) {

$parcel$export(module.exports, "refElements", () => $a4a0131b3d56cd3c$export$c69443129766a7fc);
const $a4a0131b3d56cd3c$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});



parcelRegister("9lmTX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a22cac565d88251d$export$2e2bcd8739ae039);

var $3FyZ4 = parcelRequire("3FyZ4");

var $eIp1n = parcelRequire("eIp1n");

var $6WXNs = parcelRequire("6WXNs");
const $a22cac565d88251d$var$transformApplication = (application)=>{
    switch(application){
        case 0, $eIp1n.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $eIp1n.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $eIp1n.JIRA_CORE:
            return 'jira-core';
        case 0, $eIp1n.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $eIp1n.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $a22cac565d88251d$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $6WXNs.FREE_EDITION:
            return 'jedi';
        case 0, $6WXNs.STANDARD_EDITION:
            return 'standard';
        case 0, $6WXNs.PREMIUM_EDITION:
            return 'premium';
        case 0, $6WXNs.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $a22cac565d88251d$var$transformAction = (action, wasExperienceSuccesful)=>{
    if (action !== undefined) return action;
    return wasExperienceSuccesful ? 'taskSuccess' : 'taskFail';
};
const $a22cac565d88251d$var$createAnalyticsEvent = ({ experience: experience, wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, field: field, hasEdit: hasEdit, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: $a22cac565d88251d$var$transformAction(action, wasExperienceSuccesful),
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            task: experience,
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...location ? {
                reason: location
            } : {},
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...field ? {
                field: field
            } : {},
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...typeof hasEdit === 'boolean' ? {
                hasEdit: hasEdit
            } : {},
            analyticsSource: analyticsSource,
            application: $a22cac565d88251d$var$transformApplication(application),
            edition: $a22cac565d88251d$var$transformEdition(edition)
        }
    });
var /**
 * @param {String} experienceDescription.experience
 * @param {Boolean} experienceDescription.wasExperienceSuccesful - Deprecated: Instead set `action` to `taskSuccess` (previously `true`), `taskFail` (previously `false`) or `taskAbort`
 * @param {Action} experienceDescription.action
 * @param {String} experienceDescription.location
 * @param {String} experienceDescription.field
 * @param {String} experienceDescription.hasEdit
 * @param {String} experienceDescription.analyticsSource
 * @param {String} experienceDescription.application
 * @param {Application} experienceDescription.edition
 * @param {ApplicationEdition} experienceDescription.additionalAttributes
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$a22cac565d88251d$export$2e2bcd8739ae039 = (experienceDescription)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $a22cac565d88251d$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};

});

parcelRegister("gXEQH", function(module, exports) {

$parcel$export(module.exports, "routeAnalyticsAttributes", () => $d518287b36cbf350$export$c71778b3a4356b04);

var $keguF = parcelRequire("keguF");

var $77Wva = parcelRequire("77Wva");
const $d518287b36cbf350$export$c71778b3a4356b04 = Object.defineProperties({}, {
    routeName: {
        enumerable: true,
        get: (0, $keguF.getRouteName)
    },
    userLocation: {
        enumerable: true,
        get: (0, $keguF.getUserLocation)
    },
    previousSubProduct: {
        enumerable: true,
        get: (0, $keguF.getPreviousSubProduct)
    },
    isProjectAdmin: {
        enumerable: true,
        get: (0, $77Wva.getIsProjectAdmin)
    }
});

});
parcelRegister("77Wva", function(module, exports) {

$parcel$export(module.exports, "getIsProjectAdmin", () => $6b9122e612958aea$export$34ff06260ad17f2b);
$parcel$export(module.exports, "setIsProjectAdmin", () => $6b9122e612958aea$export$d53e6d79d3fa5f31);
let $6b9122e612958aea$var$projectAdmin = null;
const $6b9122e612958aea$export$34ff06260ad17f2b = ()=>{
    // Initialised as null, this likely means we aren't in a
    // project route and the listener hasn't been rendered
    if ($6b9122e612958aea$var$projectAdmin == null || !$6b9122e612958aea$var$projectAdmin.loading && $6b9122e612958aea$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
    if ($6b9122e612958aea$var$projectAdmin.loading === true) return 'LOADING';
    return Boolean($6b9122e612958aea$var$projectAdmin.isProjectAdmin);
};
const $6b9122e612958aea$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
    $6b9122e612958aea$var$projectAdmin = projectAdminState;
};

});


parcelRegister("80E03", function(module, exports) {

var $WBLbN = parcelRequire("WBLbN");

if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("kQSGw"));
    const isDevMode = false;
    (0, $WBLbN.defaults).devtools = isDevMode && (()=>({
            serialize: {
                // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
                replacer: (key, value)=>value instanceof HTMLElement ? {
                        data: {
                            tagName: value.tagName,
                            className: value.className,
                            id: value.id,
                            __SANITIZED__: true
                        },
                        __serializedType__: 'HTMLElement'
                    } : value
            }
        }));
    (0, $WBLbN.defaults).batchUpdates = !false;
    Object.freeze((0, $WBLbN.defaults));
    $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
}

});
parcelRegister("kQSGw", function(module, exports) {
const $f2e3153aecef516a$var$style = document.createElement('style');
$f2e3153aecef516a$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;-webkit-text-decoration-skip-ink:auto;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.006em;color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.003em;color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ol ul:not(:first-child),ul ol:not(:first-child),ol ol:not(:first-child){margin-top:var(--ds-space-050,4px)}p:first-child,ul:first-child,ol:first-child,dl:first-child,h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child,h6:first-child,blockquote:first-child,pre:first-child,form:first-child,table:first-child{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,"SFMono-Medium","SF Mono","Segoe UI Mono","Roboto Mono","Ubuntu Mono",Menlo,Consolas,Courier,monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:1px var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{--lightningcss-light:initial;--lightningcss-dark: ;color-scheme:light}[data-color-mode=dark]{--lightningcss-light: ;--lightningcss-dark:initial;color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:2px solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,th:first-child{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
document.querySelector('head').appendChild($f2e3153aecef516a$var$style);

});


parcelRegister("8R80x", function(module, exports) {

$parcel$export(module.exports, "getPlaceholdersFromHTML", () => $c9ae2df088b0cf45$export$9e9f35acc3af3a9a);
$parcel$export(module.exports, "EntryPointPlaceholderContext", () => $c9ae2df088b0cf45$export$b5b377bb81310c48);
$parcel$export(module.exports, "EntryPointPlaceholder", () => $c9ae2df088b0cf45$export$db2828f683d11042);

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");
function $c9ae2df088b0cf45$export$9e9f35acc3af3a9a() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return new Map(Array.from(placeholders, (el)=>[
            el.dataset.epPlaceholderId,
            el.innerHTML
        ]));
}
const $c9ae2df088b0cf45$export$b5b377bb81310c48 = /*#__PURE__*/ (0, $eUqFw.createContext)(new Map());
function $c9ae2df088b0cf45$export$db2828f683d11042({ children: children, entryPoint: entryPoint, fallback: originalFallback, name: name, ...placeholderProps }) {
    const { root: root } = entryPoint;
    const hasMounted = (0, $eUqFw.useRef)(false);
    const placeholders = (0, $eUqFw.useContext)($c9ae2df088b0cf45$export$b5b377bb81310c48);
    const ssrFallback = placeholders.get(name);
    const [fallback, setFallback] = (0, $eUqFw.useState)(!ssrFallback || root.getModuleIfRequired() ? originalFallback : // eslint-disable-next-line react/no-danger
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: ssrFallback
        },
        "data-ep-placeholder-id": name
    }));
    const lastOriginalFallback = (0, $eUqFw.useRef)(originalFallback);
    lastOriginalFallback.current = originalFallback;
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (hasMounted.current && placeholders.has(name)) {
            placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        }
    }, [
        entryPoint,
        name,
        placeholders,
        setFallback
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const onComplete = ()=>{
            if (placeholders.has(name)) placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        };
        const unsubscribe = root.onComplete(onComplete, onComplete);
        return ()=>{
            unsubscribe();
            onComplete();
        };
    }, [
        name,
        placeholders,
        root
    ]);
    (0, $eUqFw.useEffect)(()=>{
        hasMounted.current = true;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        fallback: fallback,
        name: name,
        ...placeholderProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-ep-placeholder-id": name
    }, children));
}

});

parcelRegister("d16Bc", function(module, exports) {

$parcel$export(module.exports, "initPlatformFeatureFlags", () => $00f2fa4abeba3937$export$2d291317456ada16);

var $XHGTv = parcelRequire("XHGTv");

var $eI5EY = parcelRequire("eI5EY");

var $1ybV0 = parcelRequire("1ybV0");
const $00f2fa4abeba3937$export$2d291317456ada16 = ([isOverride, resolver])=>{
    if ((0, $1ybV0.ff)('fix_jira_ssr_platform_ff_oxim4')) (0, $XHGTv.setBooleanFeatureFlagResolver)((flagKey)=>isOverride(flagKey) ? resolver(flagKey) : (0, $eI5EY.fg)(flagKey) || (0, $1ybV0.ff)(flagKey));
};

});

parcelRegister("6U1dF", function(module, exports) {

$parcel$export(module.exports, "NonCritical", () => $7c939f739e44c405$export$20fd89b1bf707b1a);
$parcel$export(module.exports, "default", () => $7c939f739e44c405$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $h3mHU = parcelRequire("h3mHU");
const $7c939f739e44c405$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eUqFw.useState)(true);
    const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (timerThreshold != null) setTimeout(()=>{
            setHasThresholdTimerExpired(true);
        }, timerThreshold);
    }, [
        timerThreshold
    ]);
    if (!isFirstRun || isReady || hasThresholdTimerExpired) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    }
    return null;
};
const $7c939f739e44c405$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c939f739e44c405$export$83d969795398ec56, props));
/**
 * Delays rendering its children until the page is deemed ready, optimizing for a smoother initial load. Suitable for content that is not immediately necessary.
 */ const $7c939f739e44c405$var$NonCriticalComponent = (props)=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eUqFw.useState)(true);
    if (!isFirstRun || isReady) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    }
    return null;
};
const $7c939f739e44c405$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c939f739e44c405$var$NonCriticalComponent, props));
var $7c939f739e44c405$export$2e2bcd8739ae039 = $7c939f739e44c405$var$NonCriticalComponent;

});
parcelRegister("h3mHU", function(module, exports) {

$parcel$export(module.exports, "useSpaStatePageReady", () => $76cb153a8803a558$export$ea2491906b753456);
$parcel$export(module.exports, "SpaStatePageReady", () => $76cb153a8803a558$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $76cb153a8803a558$export$41e70078eeddaddc);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $WBLbN = parcelRequire("WBLbN");

var $lcJyp = parcelRequire("lcJyp");

var $cfLkw = parcelRequire("cfLkw");
const $76cb153a8803a558$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    return {
        isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
    };
};
const $76cb153a8803a558$export$ea2491906b753456 = (0, $WBLbN.createHook)((0, $cfLkw.default), {
    selector: $76cb153a8803a558$export$e6897aa59ee7aee5
});
const $76cb153a8803a558$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppReady
        }));
const $76cb153a8803a558$export$41e70078eeddaddc = ({ comparer: comparer })=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppReady,
            args: comparer
        }));

});
parcelRegister("3viaK", function(module, exports) {

$parcel$export(module.exports, "default", () => $114bcd9b637bc682$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");
// eslint-disable-next-line jira/react/no-class-components
class $114bcd9b637bc682$var$OpTrigger extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(this.props.args, nextProps.args);
    }
    componentDidUpdate() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $114bcd9b637bc682$export$2e2bcd8739ae039 = $114bcd9b637bc682$var$OpTrigger;

});

parcelRegister("lcJyp", function(module, exports) {

$parcel$export(module.exports, "SpaStateSubscriber", () => $847fac6342ee5df8$export$fd52daf2a3c1ec68);
$parcel$export(module.exports, "SpaStateActionsSubscriber", () => $847fac6342ee5df8$export$3dfa91988c213fbc);
$parcel$export(module.exports, "useSpaState", () => $847fac6342ee5df8$export$a57865516f6345d1);
$parcel$export(module.exports, "useSpaStateActions", () => $847fac6342ee5df8$export$b134752525935b78);

var $WBLbN = parcelRequire("WBLbN");

var $cfLkw = parcelRequire("cfLkw");
const $847fac6342ee5df8$export$fd52daf2a3c1ec68 = (0, $WBLbN.createSubscriber)((0, $cfLkw.default));
const $847fac6342ee5df8$export$3dfa91988c213fbc = (0, $WBLbN.createSubscriber)((0, $cfLkw.default), {
    selector: null
});
const $847fac6342ee5df8$export$a57865516f6345d1 = (0, $WBLbN.createHook)((0, $cfLkw.default));
const $847fac6342ee5df8$export$b134752525935b78 = (0, $WBLbN.createHook)((0, $cfLkw.default), {
    selector: null
});

});
parcelRegister("cfLkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e76bb655f4dbc8c$export$2e2bcd8739ae039);

var $hompL = parcelRequire("hompL");

var $WBLbN = parcelRequire("WBLbN");

var $a2pDC = parcelRequire("a2pDC");
const $7e76bb655f4dbc8c$export$d4c72bab9d6cc13a = {
    transitionCheckTimestamp: -1,
    currentPage: {
        uuid: false ? '' : (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
        startTime: typeof performance !== 'undefined' && performance.timing !== undefined && performance.timing.navigationStart || 0,
        apps: {},
        userLocation: ''
    },
    visitedPages: [],
    navigation: {
        isCollapsed: false,
        viewId: 'noView',
        viewType: '',
        projectType: null,
        isInitialEventSent: false,
        pageId: null,
        nextViewId: ''
    }
};
const $7e76bb655f4dbc8c$var$store = (0, $WBLbN.createStore)({
    name: 'spa-state',
    initialState: $7e76bb655f4dbc8c$export$d4c72bab9d6cc13a,
    actions: $a2pDC
});
var $7e76bb655f4dbc8c$export$2e2bcd8739ae039 = $7e76bb655f4dbc8c$var$store;

});
parcelRegister("a2pDC", function(module, exports) {

$parcel$export(module.exports, "setAppStart", () => (parcelRequire("gKuw7")).setAppStart);
$parcel$export(module.exports, "setAppReady", () => (parcelRequire("gKuw7")).setAppReady);
$parcel$export(module.exports, "setAppStartWithAppId", () => (parcelRequire("gKuw7")).setAppStartWithAppId);
$parcel$export(module.exports, "setAppReadyWithAppId", () => (parcelRequire("gKuw7")).setAppReadyWithAppId);
$parcel$export(module.exports, "setAppErrorReady", () => (parcelRequire("gKuw7")).setAppErrorReady);
$parcel$export(module.exports, "setTimeoutReady", () => (parcelRequire("gKuw7")).setTimeoutReady);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => (parcelRequire("gKuw7")).setTimeoutReadyWithAppId);
$parcel$export(module.exports, "resetCurrentPage", () => (parcelRequire("gKuw7")).resetCurrentPage);
$parcel$export(module.exports, "setResourceMetrics", () => (parcelRequire("gKuw7")).setResourceMetrics);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $gKuw7 = parcelRequire("gKuw7");

});
parcelRegister("gKuw7", function(module, exports) {

$parcel$export(module.exports, "resetCurrentPage", () => $1354b0144a8be88b$export$5639685a1fb81722);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => $1354b0144a8be88b$export$8a98548dad2fa97b);
$parcel$export(module.exports, "setTimeoutReady", () => $1354b0144a8be88b$export$b9cc4378ea785421);
$parcel$export(module.exports, "setAppStartWithAppId", () => $1354b0144a8be88b$export$9d528722f2ff2999);
$parcel$export(module.exports, "setAppStart", () => $1354b0144a8be88b$export$71192061050856ad);
$parcel$export(module.exports, "setAppReadyWithAppId", () => $1354b0144a8be88b$export$6a25429a42d30f9a);
$parcel$export(module.exports, "setAppReady", () => $1354b0144a8be88b$export$fc59cc4ed9bba7cd);
$parcel$export(module.exports, "setAppErrorReady", () => $1354b0144a8be88b$export$aff63c1e41443b6a);
$parcel$export(module.exports, "setResourceMetrics", () => $1354b0144a8be88b$export$8ad155d489dcf34d);

var $hompL = parcelRequire("hompL");

var $acbV3 = parcelRequire("acbV3");

var $1ybV0 = parcelRequire("1ybV0");

var $keguF = parcelRequire("keguF");

var $4fyxC = parcelRequire("4fyxC");

var $4nnPJ = parcelRequire("4nnPJ");
const $1354b0144a8be88b$export$7bd623b29ec8e1eb = 10000;
const $1354b0144a8be88b$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        performance.mark('resetCurrentPage');
        (0, $acbV3.browserMetrics).startPageLoad({
            isInitial: false
        });
        (0, $4fyxC.default)(nextRouteUfoName, nextRouteName);
        if ((0, $1ybV0.ff)('uip.ufo')) {
            (0, $4nnPJ.GlobalPageLoadExperience).abort({
                force: true
            });
            (0, $4nnPJ.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
        }
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
            currentPage: {
                uuid: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                apps: {},
                startTime: Date.now(),
                userLocation: ''
            },
            visitedPages: [
                ...currentState.visitedPages,
                {
                    ...currentState.currentPage
                }
            ],
            transitionCheckTimestamp: 0
        });
    };
const $1354b0144a8be88b$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
            const apps = {
                ...currentPage.apps
            };
            if (apps[appId] && apps[appId].expectingTimeout) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            timeoutTime: timeoutTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        }
    };
const $1354b0144a8be88b$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$8a98548dad2fa97b(appId, timeoutTime));
    };
const $1354b0144a8be88b$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
            const timeoutId = setTimeout(()=>{
                dispatch($1354b0144a8be88b$export$8a98548dad2fa97b(appId));
            }, $1354b0144a8be88b$export$7bd623b29ec8e1eb);
            const updatedPage = {
                ...currentPage,
                userLocation: (0, $keguF.getUserLocation)(),
                apps: {
                    ...currentPage.apps,
                    [appId]: {
                        startTime: startTime,
                        expectingTimeout: timeoutId
                    }
                }
            };
            setState({
                // @ts-expect-error - TS2322 - Type '{ userLocation: string; apps: { [x: string]: AppState | { startTime: number; expectingTimeout: NodeJS.Timeout; }; }; uuid: string; startTime: number; resources?: ResourceMetrics[] | undefined; }' is not assignable to type 'PageTiming'.
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$9d528722f2ff2999(appId, startTime));
    };
const $1354b0144a8be88b$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
            const apps = {
                ...currentPage.apps
            };
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(currentPage.apps[appId].expectingTimeout);
            const updatedPage = {
                ...currentPage,
                apps: {
                    ...apps,
                    [appId]: {
                        ...apps[appId],
                        endTime: endTime,
                        expectingTimeout: 0
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$6a25429a42d30f9a(appId, endTime));
    };
const $1354b0144a8be88b$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
            const updatedPage = {
                ...currentPage,
                apps: {
                    'error-page': {
                        endTime: Date.now()
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            currentPage: {
                ...currentState.currentPage,
                resources: [
                    ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                    resourceMetrics
                ]
            }
        });
    };

});






parcelRegister("h97Af", function(module, exports) {

$parcel$export(module.exports, "default", () => $97ef913b7770c56a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6iz4v = parcelRequire("6iz4v");
const $97ef913b7770c56a$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
    const renderRef = (0, $eUqFw.useRef)(false);
    if (!renderRef.current) {
        renderRef.current = true;
        (0, $6iz4v.setMark)(metricKey);
        onSet && onSet();
    }
    return null;
};
var $97ef913b7770c56a$export$2e2bcd8739ae039 = $97ef913b7770c56a$var$PerformanceMark;

});

parcelRegister("ibSOG", function(module, exports) {

$parcel$export(module.exports, "PageContainer", () => $ae84b0fa7dce8133$export$5f86df0ee0a255b5);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");

var $6WwlF = parcelRequire("6WwlF");

var $h97Af = parcelRequire("h97Af");

var $0cdA8 = parcelRequire("0cdA8");

var $9zysr = parcelRequire("9zysr");

var $4u3Wx = parcelRequire("4u3Wx");

var $Qx7Xg = parcelRequire("Qx7Xg");

var $cB0s9 = parcelRequire("cB0s9");

var $b00xW = parcelRequire("b00xW");

var $dWu0t = parcelRequire("dWu0t");

var $6FP8W = parcelRequire("6FP8W");

var $hwyJ1 = parcelRequire("hwyJ1");


var $14yu2 = parcelRequire("14yu2");

var $egmX2 = parcelRequire("egmX2");

var $8WuJm = parcelRequire("8WuJm");

var $bQiKj = parcelRequire("bQiKj");

var $2B87Z = parcelRequire("2B87Z");

var $69Ipc = parcelRequire("69Ipc");

var $5Wexj = parcelRequire("5Wexj");

var $jG5np = parcelRequire("jG5np");

var $kqXZB = parcelRequire("kqXZB");

var $l8xBK = parcelRequire("l8xBK");

var $eymfV = parcelRequire("eymfV");

var $4LQUt = parcelRequire("4LQUt");

var $fpQ73 = parcelRequire("fpQ73");

var $1cu0z = parcelRequire("1cu0z");
const $ae84b0fa7dce8133$var$mainWrapperStyles = {
    root: "_4t3i1osq _1e0c1txw _2lx21bp4 _9beo1bgi",
    themed: "_11q71o10 _11q31r52"
};
/**
 * These test IDs are used in pollinator tests. Do not change lightly.
 */ const $ae84b0fa7dce8133$var$ROOT_TEST_ID = 'page-layout.root';
const $ae84b0fa7dce8133$var$MAIN_TEST_ID = 'page-layout.main';
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $ae84b0fa7dce8133$var$PageContainerNew = ({ id: id, locale: locale, baseUrl: baseUrl, children: children, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
    const [isChromeless] = (0, $4u3Wx.useIsChromeless)();
    const [isFullscreen] = (0, $Qx7Xg.useIsFullscreen)();
    const { hasTheming: hasTheming } = (0, $6WwlF.useBusinessLookAndFeel)();
    const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, $14yu2.useBannerJsmPackagingUpdates)();
    const pageContainerPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$898b6208220685b0), (0, $7688150c048b38d1$export$e2bc63118050de32), (0, $7688150c048b38d1$export$59f83d43fe209319), true, false);
    }, []);
    const mainWrapper = (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.Main), {
            isFixed: true,
            testId: $ae84b0fa7dce8133$var$MAIN_TEST_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                $ae84b0fa7dce8133$var$mainWrapperStyles.root,
                hasTheming && $ae84b0fa7dce8133$var$mainWrapperStyles.themed
            ])
        }, isJsmPackagingUpdatesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $egmX2.BannerJsmPackagingUpdateAsync), null), content));
    const showBanner = !isChromeless && !isFullscreen;
    const showTopNav = !isChromeless && !isFullscreen;
    const showSidebar = !isChromeless && !isFullscreen;
    const showHorizontalNav = !isChromeless;
    const showRightSidebar = !isChromeless && !isFullscreen;
    const showLayoutRemoteStateUpdater = !isChromeless && !isFullscreen;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$e2bc63118050de32)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1cu0z.ThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jG5np.GlobalContainers), {
        id: id,
        locale: locale,
        baseUrl: baseUrl,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.PageLayout), {
        skipLinksLabel: "",
        testId: $ae84b0fa7dce8133$var$ROOT_TEST_ID
    }, showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "banner",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69Ipc.Banner), null)), showTopNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "top-nav",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LQUt.TopNav), null)), showSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eymfV.Sidebar), null)), mainWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, showHorizontalNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqXZB.HorizontalNav), null), children)), showRightSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l8xBK.RightSidebar), null)), showLayoutRemoteStateUpdater && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraPageContainerV2",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cB0s9.LayoutRemoteStateUpdater), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Wexj.GlobalComponents), {
        sharedGlobalComponents: (0, $bQiKj.sharedLayout).globalComponents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b00xW.GlobalBottomRightCornerContainer), null))));
};
/**
 * Serves as a comprehensive layout manager, orchestrating the assembly of global containers,
 * navigation components, and performance metrics into a cohesive page structure. It enhances user
 * interface by conditionally incorporating additional UI elements and ensures a uniform
 * appearance and behavior across pages through global styling. Moreover, it facilitates
 * performance optimization and analytics integration for improved user experience and
 * insights.
 */ const $ae84b0fa7dce8133$var$PageContainerOld = ({ id: id, locale: locale, baseUrl: baseUrl, children: children, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
    const HorizontalNavComponent = (0, $dWu0t.useHorizontalNavComponent)();
    const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, $14yu2.useBannerJsmPackagingUpdates)();
    const pageContainerPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$898b6208220685b0), (0, $7688150c048b38d1$export$e2bc63118050de32), (0, $7688150c048b38d1$export$59f83d43fe209319), true, false);
    }, []);
    let contentChildren = isJsmPackagingUpdatesEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $egmX2.BannerJsmPackagingUpdateAsync), null), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    if (HorizontalNavComponent != null) contentChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqXZB.HorizontalNavWrapper), {
        navComponent: HorizontalNavComponent
    }, isJsmPackagingUpdatesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $egmX2.BannerJsmPackagingUpdateAsync), null), children);
    const panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fpQ73.FullHeight), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.PageLayout), {
        skipLinksLabel: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "banner",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69Ipc.Banner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "top-nav",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LQUt.TopNav), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.LeftPanel), {
        width: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.Content), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "sidebar",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eymfV.Sidebar), null)), contentChildren, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l8xBK.RightSidebar), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "page-container",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cB0s9.LayoutRemoteStateUpdater), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Wexj.GlobalComponents), {
        sharedGlobalComponents: (0, $bQiKj.sharedLayout).globalComponents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b00xW.GlobalBottomRightCornerContainer), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$e2bc63118050de32)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1cu0z.ThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jG5np.GlobalContainers), {
        id: id,
        locale: locale,
        baseUrl: baseUrl,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, panelContent)));
};
const $ae84b0fa7dce8133$export$5f86df0ee0a255b5 = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $ae84b0fa7dce8133$var$PageContainerNew, $ae84b0fa7dce8133$var$PageContainerOld);

});
parcelRegister("6WwlF", function(module, exports) {

$parcel$export(module.exports, "useBusinessLookAndFeel", () => $7836b6e7c7b98ca3$export$ad3385faee9e435a);

var $b3nmi = parcelRequire("b3nmi");

var $exb0h = parcelRequire("exb0h");

var $kLSws = parcelRequire("kLSws");

var $dWu0t = parcelRequire("dWu0t");

var $6FP8W = parcelRequire("6FP8W");

var $10fdS = parcelRequire("10fdS");

var $bEe6y = parcelRequire("bEe6y");
const $7836b6e7c7b98ca3$export$ad3385faee9e435a = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const HorizontalNavComponent = (0, $dWu0t.useHorizontalNavComponent)();
    const isBusinessRouteGroup = route.group === (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS);
    const hasProjectViewNavigation = (0, $6FP8W.getWillShowNav4)() ? HorizontalNavComponent != null : HorizontalNavComponent === (0, $b3nmi.AsyncHorizontalProjectNav) || HorizontalNavComponent === (0, $b3nmi.AsyncHorizontalOverviewNav) || HorizontalNavComponent === (0, $bEe6y.AsyncHorizontalSoftwareProjectNav) || HorizontalNavComponent === (0, $kLSws.AsyncHorizontalNavPlans);
    const hasTheming = (0, $6FP8W.getWillShowNav4)() ? HorizontalNavComponent === (0, $b3nmi.AsyncHorizontalProjectNav) || HorizontalNavComponent === (0, $b3nmi.AsyncHorizontalOverviewNav) || route.name === (0, $exb0h.ROUTE_NAMES_ISSUE) : hasProjectViewNavigation;
    // Routes showing a themed insetlayout are:
    // - all routes with the business project view navigation
    // - except for the routes with business group (as they already cater for the theme)
    const isInset = hasTheming && !isBusinessRouteGroup;
    return {
        isInset: isInset,
        hasTheming: hasTheming,
        hasProjectViewNavigation: hasProjectViewNavigation
    };
};

});
parcelRegister("b3nmi", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalProjectNav", () => $9702ab3631bfd06d$export$862dd1c0126bb181);
$parcel$export(module.exports, "AsyncHorizontalOverviewNav", () => $9702ab3631bfd06d$export$beabdf5c49f01377);
/* eslint-disable jira/import/webpack-magic-comment-entries */ 
var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");

var $6VZoe = parcelRequire("6VZoe");

const $9702ab3631bfd06d$var$LazyHorizontalProjectNav = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("bRTUX")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/project-navigation/index.tsx"
});
const $9702ab3631bfd06d$export$862dd1c0126bb181 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9702ab3631bfd06d$var$LazyHorizontalProjectNav, null));

const $9702ab3631bfd06d$var$LazyHorizontalOverviewNav = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("3aryZ")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/overview-navigation/index.tsx"
});
const $9702ab3631bfd06d$export$beabdf5c49f01377 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9702ab3631bfd06d$var$LazyHorizontalOverviewNav, null));

});
parcelRegister("bRTUX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("lIxVq")
]).then(()=>parcelRequire('4XF6i'));

});

parcelRegister("3aryZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("g9yoo")
]).then(()=>parcelRequire('iiqLF'));

});


parcelRegister("exb0h", function(module, exports) {

$parcel$export(module.exports, "ROUTE_GROUPS_ARCHIVE_ISSUES", () => $67f07001968fe110$export$1ba937db1fe6ef01);
$parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_BUSINESS", () => $67f07001968fe110$export$bbf08d4d25df5504);
$parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_SOFTWARE", () => $67f07001968fe110$export$e3e759b7f50aaee1);
$parcel$export(module.exports, "ROUTE_GROUPS_COMPONENTS", () => $67f07001968fe110$export$89337611b52bc9a3);
$parcel$export(module.exports, "ROUTE_GROUPS_CONNECT", () => $67f07001968fe110$export$3d7937b12eb9e5d5);
$parcel$export(module.exports, "ROUTE_GROUPS_DASHBOARD", () => $67f07001968fe110$export$7a3d181d86fce9e6);
$parcel$export(module.exports, "ROUTE_GROUPS_DEVOPS", () => $67f07001968fe110$export$7a22726acd7d6021);
$parcel$export(module.exports, "ROUTE_GROUPS_DIRECTORIES", () => $67f07001968fe110$export$f3f4a9f53ba00861);
$parcel$export(module.exports, "ROUTE_GROUPS_EOC", () => $67f07001968fe110$export$112d69653b2f1d8b);
$parcel$export(module.exports, "ROUTE_GROUPS_ERRORS", () => $67f07001968fe110$export$74e0426b66571086);
$parcel$export(module.exports, "ROUTE_GROUPS_GLOBAL_SETTINGS", () => $67f07001968fe110$export$c2e20e142c95c1ce);
$parcel$export(module.exports, "ROUTE_GROUPS_HELP_CENTER_SETTINGS", () => $67f07001968fe110$export$f8cea29bebf098c);
$parcel$export(module.exports, "ROUTE_GROUPS_HOME", () => $67f07001968fe110$export$5801ef8dfc9a2f70);
$parcel$export(module.exports, "ROUTE_GROUPS_ISSUE", () => $67f07001968fe110$export$7246838143f848f3);
$parcel$export(module.exports, "ROUTE_GROUPS_ISSUE_NAVIGATOR", () => $67f07001968fe110$export$54f96702980a2f87);
$parcel$export(module.exports, "ROUTE_GROUPS_LEGACY", () => $67f07001968fe110$export$5566db8fbd042fc4);
$parcel$export(module.exports, "ROUTE_GROUPS_MARKETPLACE", () => $67f07001968fe110$export$656d0cc2c67b2708);
$parcel$export(module.exports, "ROUTE_GROUPS_PEOPLE_PROFILES", () => $67f07001968fe110$export$bfdbcebc4c81b043);
$parcel$export(module.exports, "ROUTE_GROUPS_PERSONAL_SETTINGS", () => $67f07001968fe110$export$82021d71ad19e227);
$parcel$export(module.exports, "ROUTE_GROUPS_PLAN_SETTINGS", () => $67f07001968fe110$export$6f266218a6973848);
$parcel$export(module.exports, "ROUTE_GROUPS_POLARIS", () => $67f07001968fe110$export$a846fcaeeea8e0ff);
$parcel$export(module.exports, "ROUTE_GROUPS_PROFORMA", () => $67f07001968fe110$export$6c87a9dff4e7a2de);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC", () => $67f07001968fe110$export$ab79970dcfac06a1);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CORE", () => $67f07001968fe110$export$d1a70f80bb22f18a);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK", () => $67f07001968fe110$export$bd925e9fcb6ce37f);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE", () => $67f07001968fe110$export$86509a1baabd62ee);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE_BOARDS", () => $67f07001968fe110$export$98823ed9eedfc756);
$parcel$export(module.exports, "ROUTE_GROUPS_REDIRECTS", () => $67f07001968fe110$export$da8d13fe1ccd5c09);
$parcel$export(module.exports, "ROUTE_GROUPS_SERVICEDESK", () => $67f07001968fe110$export$78fb2f6176b7c6b8);
$parcel$export(module.exports, "ROUTE_GROUPS_SOFTWARE", () => $67f07001968fe110$export$26efaec7a7a8b361);
$parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY", () => $67f07001968fe110$export$88041353cc69458d);
$parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PLANS_DIRECTORY", () => $67f07001968fe110$export$f88d57dcb03ba452);
$parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY", () => $67f07001968fe110$export$e8aa63af071c2da9);
$parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK", () => $67f07001968fe110$export$b114d0da2ebcff6c);
$parcel$export(module.exports, "ROUTE_NAMES_BOARDS_DIRECTORY", () => $67f07001968fe110$export$29cc94b8cea5c920);
$parcel$export(module.exports, "ROUTE_NAMES_BROWSE_PROJECT_REDIRECT", () => $67f07001968fe110$export$4d1b45005cdcfb39);
$parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_BOARD", () => $67f07001968fe110$export$a42ea04fdf53eeaf);
$parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_CLASSIC_REPORTS", () => $67f07001968fe110$export$ca4c5f5b3e2daa18);
$parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_REPORTS", () => $67f07001968fe110$export$d58a5411a2ac6260);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_ONBOARDING_GET_STARTED", () => $67f07001968fe110$export$24514ee19772b5af);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR", () => $67f07001968fe110$export$ec333dd1d6a8b38);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT", () => $67f07001968fe110$export$ed495fbad44791af);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY", () => $67f07001968fe110$export$5281552f8109b7c0);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE", () => $67f07001968fe110$export$6e8473713ed4557a);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS", () => $67f07001968fe110$export$cbdd5c24d69b2cb1);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS", () => $67f07001968fe110$export$e7f012f402be01ea);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD", () => $67f07001968fe110$export$b34d3882b42d660d);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED", () => $67f07001968fe110$export$ed869c60c6a56182);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR", () => $67f07001968fe110$export$5013269f29c75b37);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED", () => $67f07001968fe110$export$fc8b48319e993d43);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM", () => $67f07001968fe110$export$d6e60a2059f028d);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER", () => $67f07001968fe110$export$3d589aae17a00bc9);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT", () => $67f07001968fe110$export$bd92ef03b23dd672);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED", () => $67f07001968fe110$export$fa7fc44c718fc850);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST", () => $67f07001968fe110$export$1dffaf831e01e2b4);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED", () => $67f07001968fe110$export$5f8187412dd60f35);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SAMPLE_ONBOARDING", () => $67f07001968fe110$export$3d2c1c04d18f6c43);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT", () => $67f07001968fe110$export$cd22a5d8f560a1d8);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY", () => $67f07001968fe110$export$cad1b1aa5ce26bbc);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY_EMBED", () => $67f07001968fe110$export$ee073463b4144367);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE", () => $67f07001968fe110$export$ea034943499772ea);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED", () => $67f07001968fe110$export$19bc888bcf37d22d);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT", () => $67f07001968fe110$export$e0746183e11767fb);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CODE", () => $67f07001968fe110$export$3e2d215ce157adc8);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS", () => $67f07001968fe110$export$8a8485bb05daf40b);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", () => $67f07001968fe110$export$a2799b01de5bb62);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_FEATURES", () => $67f07001968fe110$export$2d4f89c4b1ee3640);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT", () => $67f07001968fe110$export$75609d3416c31f79);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_NOTIFICATION_EMAIL", () => $67f07001968fe110$export$79793dc26e0b7b1a);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_OPSGENIE", () => $67f07001968fe110$export$2eda7466fbfdef43);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS", () => $67f07001968fe110$export$417297669917ee1a);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", () => $67f07001968fe110$export$8c79f3309ac0737);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", () => $67f07001968fe110$export$ef71a22e7befd35c);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_EDIT_FORMS", () => $67f07001968fe110$export$62ba1e294f5007c1);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_FORMS", () => $67f07001968fe110$export$a4315324546ecc89);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_TOOLCHAIN", () => $67f07001968fe110$export$a653cf6d478b3df1);
$parcel$export(module.exports, "ROUTE_NAMES_COMPASS_PRODUCT_SETTINGS", () => $67f07001968fe110$export$b0f268fe53a03e98);
$parcel$export(module.exports, "ROUTE_NAMES_CONFLUENCE_PRODUCT_SETTINGS", () => $67f07001968fe110$export$f4160b48e4ab8f39);
$parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL", () => $67f07001968fe110$export$608f359cf8b08d2e);
$parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_INVALID", () => $67f07001968fe110$export$8bfbf790fe89f8d3);
$parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT", () => $67f07001968fe110$export$d7011d1ed949f970);
$parcel$export(module.exports, "ROUTE_NAMES_CONNECT_PROJECT", () => $67f07001968fe110$export$bd2506db44585db6);
$parcel$export(module.exports, "ROUTE_NAMES_CREATE_PROJECT", () => $67f07001968fe110$export$200fa5ad16f8c112);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD", () => $67f07001968fe110$export$a296bb962bea95b5);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY", () => $67f07001968fe110$export$b9960c143c0414eb);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE", () => $67f07001968fe110$export$411171d2fcaefaea);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_EDIT", () => $67f07001968fe110$export$ee104ed514f63003);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_SELECTED", () => $67f07001968fe110$export$9233f9ddcecd3062);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW", () => $67f07001968fe110$export$b3240ec044a6c70f);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW_EMBED", () => $67f07001968fe110$export$2463c779e12367e3);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_WALLBOARD", () => $67f07001968fe110$export$dd3e5187eae2abe9);
$parcel$export(module.exports, "ROUTE_NAMES_DEVOPS_CONNECTED_PROJECT", () => $67f07001968fe110$export$38ca7e07048a5bfd);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING", () => $67f07001968fe110$export$48749e87cc44a5a5);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_CREATE", () => $67f07001968fe110$export$21c230ef79df9e9);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_DETAIL", () => $67f07001968fe110$export$d2d813dd057a8352);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_API_KEY_MANAGEMENT", () => $67f07001968fe110$export$54ed2374d14a7e88);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ASSIGN_CUSTOM_ROLES", () => $67f07001968fe110$export$58368fe796f5ecb4);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_AUTOMATIONS", () => $67f07001968fe110$export$bbb4032f8f259109);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_CUSTOM_ROLES", () => $67f07001968fe110$export$5b17b30c2dd69cf2);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERTS", () => $67f07001968fe110$export$d18d0b9a9e85e59c);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL", () => $67f07001968fe110$export$5126a481501fc518);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL", () => $67f07001968fe110$export$40e720d8c26e6804);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_MAINTENANCE", () => $67f07001968fe110$export$dc8ac1f7e9373a32);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORTS", () => $67f07001968fe110$export$8ca3e3f0326ba27f);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD", () => $67f07001968fe110$export$c3d17be12795c864);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_HEARTBEATS", () => $67f07001968fe110$export$9cd1c70eda5cae15);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL", () => $67f07001968fe110$export$99f769b27f537a72);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL_DETAIL", () => $67f07001968fe110$export$5c5fe79d3f9ec214);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATIONS", () => $67f07001968fe110$export$901b974cf0954c88);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_CREATE", () => $67f07001968fe110$export$b2dd23a345bd5cb3);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_DETAIL", () => $67f07001968fe110$export$8ae7cbc0a73f9351);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LIST", () => $67f07001968fe110$export$8057ebe7fb7f7f8d);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LOG", () => $67f07001968fe110$export$a22387b9744e62e3);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_MAINTENANCE", () => $67f07001968fe110$export$f6fefa9d2e5bbda1);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL", () => $67f07001968fe110$export$e6de4aa6c719d2b);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL_REDIRECT", () => $67f07001968fe110$export$b195ada84b7e695f);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW", () => $67f07001968fe110$export$1800d32171b754a6);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS", () => $67f07001968fe110$export$d22a153bfcbaaaa0);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_PERMISSIONS", () => $67f07001968fe110$export$a9a41c76994b6ae9);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_POLICIES", () => $67f07001968fe110$export$5bd6f2569c3cfd5c);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS", () => $67f07001968fe110$export$dc70eff53ff26c70);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_TEAM", () => $67f07001968fe110$export$1fe2ca96b360df19);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE", () => $67f07001968fe110$export$1ff01e77517a80b0);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS", () => $67f07001968fe110$export$de3f8f3198f8213a);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS_DETAIL", () => $67f07001968fe110$export$b2cb569d360db382);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERTS", () => $67f07001968fe110$export$da985e953465731f);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS", () => $67f07001968fe110$export$b7eee2afd0a5c6b9);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING", () => $67f07001968fe110$export$9b6c84986db47d98);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE", () => $67f07001968fe110$export$89276f76fdd700d6);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL", () => $67f07001968fe110$export$ea64769f19da8c95);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS", () => $67f07001968fe110$export$4a584839d9a9eb6f);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD", () => $67f07001968fe110$export$27d27c817eeb97cc);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL", () => $67f07001968fe110$export$9f533c13cfb48a8f);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATIONS", () => $67f07001968fe110$export$6889e571e5aa6ba6);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE", () => $67f07001968fe110$export$bdd811277711c53d);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL", () => $67f07001968fe110$export$c7b51c0e8ad6f77a);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST", () => $67f07001968fe110$export$a348fc7f3b4cfe34);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG", () => $67f07001968fe110$export$a4eff769c94da831);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_POLICIES", () => $67f07001968fe110$export$7c928ca9c9822772);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_UNLOCK_OPERATIONS", () => $67f07001968fe110$export$b48311a8f24f4b63);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_WHO_IS_ON_CALL", () => $67f07001968fe110$export$20649eac204f7661);
$parcel$export(module.exports, "ROUTE_NAMES_ERRORS_NOT_FOUND", () => $67f07001968fe110$export$62170875a111d729);
$parcel$export(module.exports, "ROUTE_NAMES_EXTERNAL_IMPORT", () => $67f07001968fe110$export$2928f3d69e7ac609);
$parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY", () => $67f07001968fe110$export$259e18cafd820487);
$parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY_SECURE", () => $67f07001968fe110$export$4b8f333757e638a4);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN", () => $67f07001968fe110$export$ac4f65a14002f892);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN_SETTINGS", () => $67f07001968fe110$export$c73ddc4b44ccb359);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_FIELD_CONTEXTUAL_CONFIGURATION", () => $67f07001968fe110$export$7ad826b482229119);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_GLOBAL", () => $67f07001968fe110$export$3df864df9b639033);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_PROJECT", () => $67f07001968fe110$export$7d67bf4077ebe18d);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE", () => $67f07001968fe110$export$5ff797dfd5df551f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG", () => $67f07001968fe110$export$8a66ba1da5efa2c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR", () => $67f07001968fe110$export$eadf5aff28def565);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT", () => $67f07001968fe110$export$8f9c045e8fd449b7);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_MAIL_SETTINGS", () => $67f07001968fe110$export$1bf439327974644b);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CONTACT_ADMINISTRATOR", () => $67f07001968fe110$export$e2a9d163770d0d46);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS", () => $67f07001968fe110$export$21b497c57bcd299a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_ASSOCIATE", () => $67f07001968fe110$export$8d4d1f7df6e5d4e4);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_CONFIGURE", () => $67f07001968fe110$export$df5ca261227a6052);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_DELETE", () => $67f07001968fe110$export$9f2f4303259b8508);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_EDIT", () => $67f07001968fe110$export$7fd53fe07eecc273);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_MANAGE", () => $67f07001968fe110$export$c8e9ba2b5bc9dab2);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_TRANSLATE", () => $67f07001968fe110$export$e05a6c9e9b9b0c48);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EXPLICIT_FIELD_ASSOCIATION_PROJECT_LIST", () => $67f07001968fe110$export$f9759b206b651b1f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES", () => $67f07001968fe110$export$7a337a2687b5d5e3);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS", () => $67f07001968fe110$export$a41998c1a3572e41);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_CONFIGURE", () => $67f07001968fe110$export$2c9fe9e6005a9c36);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_COPY", () => $67f07001968fe110$export$5d8d82ff1de3586e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES", () => $67f07001968fe110$export$8a0ed100d885c17c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_CONFIGURE", () => $67f07001968fe110$export$1c7041445acf79e8);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_COPY", () => $67f07001968fe110$export$e4712523d95125f6);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_DELETE", () => $67f07001968fe110$export$7401274ad357ff94);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT", () => $67f07001968fe110$export$6984b21077857555);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT_ENTRY", () => $67f07001968fe110$export$5a2dae98f768aedf);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_VIEW", () => $67f07001968fe110$export$5eef1c6eb1388ac0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS", () => $67f07001968fe110$export$69bcf2c26d45e030);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_GLOBAL_PERMISSIONS", () => $67f07001968fe110$export$ba1417cf5de80f81);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES", () => $67f07001968fe110$export$fdcfcb2e2eb16afd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_ACTIVATE", () => $67f07001968fe110$export$5d3e6bffd6b5abfe);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DEACTIVATE", () => $67f07001968fe110$export$5c676bbb7e3aae9e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DELETE", () => $67f07001968fe110$export$8bb013ced097489a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_EDIT", () => $67f07001968fe110$export$e384ae6a87fadedd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH", () => $67f07001968fe110$export$8f55a911c4bd95bf);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_VIEW", () => $67f07001968fe110$export$d7b98892cb31fba5);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_ADD", () => $67f07001968fe110$export$8be4b203f526b2cd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_DELETE", () => $67f07001968fe110$export$df09947903c514c4);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_EDIT", () => $67f07001968fe110$export$cf4a57a81e0bfbca);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_ADD", () => $67f07001968fe110$export$bc64365bbb09c05e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_DELETE", () => $67f07001968fe110$export$5b12571311ebe766);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_EDIT", () => $67f07001968fe110$export$56dc46fe1de63994);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW", () => $67f07001968fe110$export$65af0e5a36d4b4e9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES", () => $67f07001968fe110$export$dec448f9d2e50c90);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_ADD", () => $67f07001968fe110$export$9ff4144e1dcf9fa4);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_DELETE", () => $67f07001968fe110$export$8aab6fb9a62dda95);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_EDIT", () => $67f07001968fe110$export$9f804a2650117f51);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES", () => $67f07001968fe110$export$7dd4b916600f670);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_DELETE", () => $67f07001968fe110$export$c1b40a8a70c0aafa);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_EDIT", () => $67f07001968fe110$export$ff10d812380db045);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_TRANSLATE", () => $67f07001968fe110$export$8deeffdf8dfed878);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES", () => $67f07001968fe110$export$561687f2fa9b9cc9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS", () => $67f07001968fe110$export$691d30818c14141c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DEFAULT", () => $67f07001968fe110$export$8fa58495105f8fb0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DELETE", () => $67f07001968fe110$export$8304c57494d82ffd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_EDIT", () => $67f07001968fe110$export$353609deec72a2ba);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_TRANSLATE", () => $67f07001968fe110$export$1cb56e4c132ac8fd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_EDIT", () => $67f07001968fe110$export$5fe3eec0a6bda09);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_ADD", () => $67f07001968fe110$export$12b56880d6fb7ac7);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_DELETE", () => $67f07001968fe110$export$9986e8be82998857);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_EDIT", () => $67f07001968fe110$export$3280ec16231916af);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES", () => $67f07001968fe110$export$54885d105d1e2b37);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_ADD", () => $67f07001968fe110$export$f34d87c870f3bf43);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_DELETE", () => $67f07001968fe110$export$4108ebf71e36e461);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_EDIT", () => $67f07001968fe110$export$d42ec33a6e69686e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES", () => $67f07001968fe110$export$8d2cfabd01e2feaa);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES_TRANSLATE", () => $67f07001968fe110$export$d0fe3726dffeca80);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE", () => $67f07001968fe110$export$b4aa4b2b8fb7267a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE_EDIT", () => $67f07001968fe110$export$3743711165f5dd4f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES", () => $67f07001968fe110$export$5df6f81deab9567c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_ADD", () => $67f07001968fe110$export$b3db2a2ee8a9a8e4);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_CONFIGURE", () => $67f07001968fe110$export$d5fc8cd4b3fd2b84);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_COPY", () => $67f07001968fe110$export$a03360d8b616ef34);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_DELETE", () => $67f07001968fe110$export$336e54edc189df7f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT", () => $67f07001968fe110$export$53572e9a81205523);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT_ITEM", () => $67f07001968fe110$export$b71f2ef452117a2a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS", () => $67f07001968fe110$export$f79745fee583cd62);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_COPY", () => $67f07001968fe110$export$2281663e19f399c1);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_DELETE", () => $67f07001968fe110$export$38c52d8c5e5dad29);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_EDIT", () => $67f07001968fe110$export$10babc3f11b4e6e2);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY", () => $67f07001968fe110$export$adf2f51c41b4e22a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY_REDIRECT", () => $67f07001968fe110$export$11b217754d4c7d24);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS", () => $67f07001968fe110$export$3414f0d81f1c11d);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_DISABLE", () => $67f07001968fe110$export$5574c73a9a5878ca);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_EDIT", () => $67f07001968fe110$export$cb2626c385b72992);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_TRANSLATE", () => $67f07001968fe110$export$fa7aa7cabc3ec459);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TIME_TRACKING", () => $67f07001968fe110$export$8b0450672651ef67);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES", () => $67f07001968fe110$export$ef510a15f840e437);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_DELETE", () => $67f07001968fe110$export$bc159fa4984a907f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_EDIT", () => $67f07001968fe110$export$47bfbce13af95d24);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES", () => $67f07001968fe110$export$c8cb78e94cd3f83c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ADD_OR_COPY", () => $67f07001968fe110$export$4496279df22177be);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ASSOCIATE", () => $67f07001968fe110$export$afdfef5d17c56988);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_DELETE", () => $67f07001968fe110$export$ac9b4b1136300033);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES", () => $67f07001968fe110$export$4aa31dc2a6d4f2ee);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_CONFIGURE", () => $67f07001968fe110$export$c56f5509b93eba68);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_COPY", () => $67f07001968fe110$export$dd9462e97e11637a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_DELETE", () => $67f07001968fe110$export$11f8c53e10f63cfb);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_EDIT", () => $67f07001968fe110$export$758ad3ad6916c9f6);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_ENTITY", () => $67f07001968fe110$export$9d65a754315eb617);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_TRANSLATE", () => $67f07001968fe110$export$564b665f6ca740dd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW", () => $67f07001968fe110$export$256fc89c38c1b9e9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT", () => $67f07001968fe110$export$ddeae77164bfac0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES", () => $67f07001968fe110$export$fa2b355372963545);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES_EDIT", () => $67f07001968fe110$export$45511e437e54fa02);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION", () => $67f07001968fe110$export$ad76895f03f27a7c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION_META_ATTRIBUTES", () => $67f07001968fe110$export$1c291d65a59b1636);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD", () => $67f07001968fe110$export$d9bb14d665bfeea5);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE", () => $67f07001968fe110$export$8b44cb3da7b8f857);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME", () => $67f07001968fe110$export$9ca6a09e1518d3bb);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD", () => $67f07001968fe110$export$4c211b3188348679);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE", () => $67f07001968fe110$export$24757bb1837e33af);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL", () => $67f07001968fe110$export$95b5d0bd29a3a076);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW", () => $67f07001968fe110$export$d55d4330b58683da);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP", () => $67f07001968fe110$export$f4d5833f0b40a26b);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR", () => $67f07001968fe110$export$c78577545f514ca8);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERMISSION_SCHEMES", () => $67f07001968fe110$export$253eb3db7152d010);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_APPLICATION_LINKS", () => $67f07001968fe110$export$16b4392a63a3eacf);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_DVCS", () => $67f07001968fe110$export$b2d5a7bc804ed9c9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_SDMAIL", () => $67f07001968fe110$export$f870832f94ca5009);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_STATUS_PAGE", () => $67f07001968fe110$export$8b3a1b2e8e954dc2);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_DELETE", () => $67f07001968fe110$export$15603150075c3d64);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_EDIT", () => $67f07001968fe110$export$92536fe760c41862);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_VIEW", () => $67f07001968fe110$export$3f4d05032349dae0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SHARED_DASHBOARDS", () => $67f07001968fe110$export$8ff94a2e5f98315f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_NOTIFICATION_HELPER", () => $67f07001968fe110$export$c906c6946fef5d99);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_PERMISSION_HELPER", () => $67f07001968fe110$export$a1916b723e186494);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_ATTACHMENTS", () => $67f07001968fe110$export$5070b4c974017f28);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS", () => $67f07001968fe110$export$bee7f9f93cb74124);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_ADD", () => $67f07001968fe110$export$efe4008073ab3b69);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_DELETE", () => $67f07001968fe110$export$9e40228f1c62d4d9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_EDIT", () => $67f07001968fe110$export$223f8094878fea34);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_LEXORANK_MANAGEMENT", () => $67f07001968fe110$export$2f589c572415c043);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_SERVICES", () => $67f07001968fe110$export$8cc394a1f5ca4ac0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_WEBHOOKS", () => $67f07001968fe110$export$a11311cd333dae90);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_BULK_MAIL", () => $67f07001968fe110$export$2b2f159267202dcc);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_ADVANCED_SETTINGS", () => $67f07001968fe110$export$c5a6874288d2e609);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_EDIT_SETTINGS", () => $67f07001968fe110$export$55dd30b027c838fe);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GLOBAL_PERMISSIONS", () => $67f07001968fe110$export$aee9c7dbf672403c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_BACKUP_MANAGER", () => $67f07001968fe110$export$75f2fbd33e76028e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_CLOUD_OR_SERVER_IMPORT", () => $67f07001968fe110$export$ca57c3dfefb2c826);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT", () => $67f07001968fe110$export$8f2e6f133c022a59);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_CSV", () => $67f07001968fe110$export$bcd741cf5a35ece8);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_JSON", () => $67f07001968fe110$export$bfd8ab4625d5c275);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_TRELLO", () => $67f07001968fe110$export$750a33c4058af733);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ISSUE_COLLECTORS", () => $67f07001968fe110$export$1b66c7594340363f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_DELETE_MAIL_HANDLER", () => $67f07001968fe110$export$fe2fa966509db649);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_INCOMING_MAIL", () => $67f07001968fe110$export$373b97e8d136f558);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_OUTGOING_MAIL", () => $67f07001968fe110$export$64909bb6f2181592);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_SEND_MAIL", () => $67f07001968fe110$export$53d6ade2eaa2ae84);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_GLOBAL_PERMISSIONS_OLD", () => $67f07001968fe110$export$e49d7a1ddf301d09);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES", () => $67f07001968fe110$export$9469cfde1d14fcac);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS", () => $67f07001968fe110$export$be2e231547dca6dd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_GROUPS", () => $67f07001968fe110$export$ad6f28bbfe57d0a0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_USERS", () => $67f07001968fe110$export$2fb73d5c1c0e7186);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_DELETE", () => $67f07001968fe110$export$46b4f43d6ece38fc);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_EDIT", () => $67f07001968fe110$export$49d1c20d84d46735);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_USAGE", () => $67f07001968fe110$export$265062715b11a1ef);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SHARED_FILTERS", () => $67f07001968fe110$export$e9f5eae9444c9b46);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_TROUBLESHOOTING_AUDIT_LOG", () => $67f07001968fe110$export$e19bf9459d6eba56);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER", () => $67f07001968fe110$export$40097704c31872d8);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_DASHBOARD_EDIT", () => $67f07001968fe110$export$dcdf0405aa7e2078);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_LOOK_AND_FEEL", () => $67f07001968fe110$export$fb75113636566d39);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_PREFERENCES_APPLY", () => $67f07001968fe110$export$e27baa0c7747e67f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_USER_DEFAULTS", () => $67f07001968fe110$export$40d189100899f572);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS", () => $67f07001968fe110$export$341933b279728599);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_NOTIFICATIONS", () => $67f07001968fe110$export$ae4b815061537207);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_EMAIL", () => $67f07001968fe110$export$5cd0dd5a6be6aa2b);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_KNOWLEDGE_BASE", () => $67f07001968fe110$export$bee46016693b19dc);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPES", () => $67f07001968fe110$export$c39a25878c902e0a);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPE_FIELDS", () => $67f07001968fe110$export$6eaa6ce8101f6468);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_WEB_PORTAL", () => $67f07001968fe110$export$2e90ab5aa3463c0d);
$parcel$export(module.exports, "ROUTE_NAMES_HOME_ONBOARDING_REDIRECT", () => $67f07001968fe110$export$d70320ae3b4d9e43);
$parcel$export(module.exports, "ROUTE_NAMES_HOME_REDIRECT", () => $67f07001968fe110$export$b2b57cde1fa39bf5);
$parcel$export(module.exports, "ROUTE_NAMES_ISSUE", () => $67f07001968fe110$export$e8e3b3a04b70a016);
$parcel$export(module.exports, "ROUTE_NAMES_ISSUE_CREATE_EMBED", () => $67f07001968fe110$export$1a3116351e4f3550);
$parcel$export(module.exports, "ROUTE_NAMES_ISSUE_EMBED", () => $67f07001968fe110$export$6e2629d41c380b47);
$parcel$export(module.exports, "ROUTE_NAMES_JIRA_SEARCH", () => $67f07001968fe110$export$ced38e55e6d33a4e);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES", () => $67f07001968fe110$export$d61d16755cb40ff3);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR", () => $67f07001968fe110$export$bb6392f1b2e80781);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY", () => $67f07001968fe110$export$6fd25e722e91a0d8);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES", () => $67f07001968fe110$export$18f32f825e7a5a6f);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES", () => $67f07001968fe110$export$b17f22f274f4cd5e);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE", () => $67f07001968fe110$export$285854ec33f7cc);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY", () => $67f07001968fe110$export$77cf9c44bbdaa05b);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE", () => $67f07001968fe110$export$d6f1b92110a16f2a);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS", () => $67f07001968fe110$export$fea47b97c6086336);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS", () => $67f07001968fe110$export$264d0a2b60d052cd);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_LANDING", () => $67f07001968fe110$export$991ba0c465b48539);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH", () => $67f07001968fe110$export$904b472d57dee40d);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH_ARTICLES", () => $67f07001968fe110$export$bbe98dfa7f6a1e4a);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SETUP", () => $67f07001968fe110$export$8cfdaccf43a32440);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_ALL_REPORTS", () => $67f07001968fe110$export$37bd400c00057d64);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BACKLOG", () => $67f07001968fe110$export$eb66bd587b5f093d);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BOARD", () => $67f07001968fe110$export$521baa72494c2a67);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_GENERAL", () => $67f07001968fe110$export$ca255c93be51d5bc);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_PROJECT", () => $67f07001968fe110$export$51e45f736a60769b);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CUSTOM_REPORT", () => $67f07001968fe110$export$e64c3c8f45d7eb28);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_FALLBACK", () => $67f07001968fe110$export$5475ba822739444a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN", () => $67f07001968fe110$export$8483f5c57513e386);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_ISSUE", () => $67f07001968fe110$export$93c4d1960660bdb3);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_QUICKSEARCH", () => $67f07001968fe110$export$a5421dcc88027406);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS", () => $67f07001968fe110$export$81d5ef2e5cb06446);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_CUSTOMERS", () => $67f07001968fe110$export$77f5621cd10b53c5);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_GETTING_STARTED", () => $67f07001968fe110$export$41008c2b014795bf);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_JIRA_AUTOMATION", () => $67f07001968fe110$export$3001841111579cf2);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_KNOWLEDGE", () => $67f07001968fe110$export$28dc2fac9c08502e);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES", () => $67f07001968fe110$export$4487dfcd6dce7088);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES_MANAGE", () => $67f07001968fe110$export$c344587fa7092e8c);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS", () => $67f07001968fe110$export$3fbd487079a23c0f);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS_CUSTOM", () => $67f07001968fe110$export$d6822df31c37b21a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_FALLBACK", () => $67f07001968fe110$export$d39bcac6fced7707);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE", () => $67f07001968fe110$export$da975f212e8a3e43);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE_PAGES", () => $67f07001968fe110$export$6e6feddeb62a0825);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_WIDGETS", () => $67f07001968fe110$export$d7df906c2ffbeab4);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PIN", () => $67f07001968fe110$export$c71836085985a7d3);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES", () => $67f07001968fe110$export$a17a19a9de903839);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_BAMBOO", () => $67f07001968fe110$export$e66c1e847a52ebb5);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE", () => $67f07001968fe110$export$f0254c80025ed0fc);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE_CONFIG", () => $67f07001968fe110$export$1d4a64220d5b474d);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS", () => $67f07001968fe110$export$8af215d394bc18c1);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_ADD", () => $67f07001968fe110$export$b6b536a795b08b39);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_HELP", () => $67f07001968fe110$export$59cde094247fca1a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_VIEW", () => $67f07001968fe110$export$d27bf19e22921164);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_CONFIG", () => $67f07001968fe110$export$3467807847c0a87d);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", () => $67f07001968fe110$export$1996eeee6a067f1c);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DELETE", () => $67f07001968fe110$export$ec7cb9394e8994c9);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV", () => $67f07001968fe110$export$f01730982626c4af);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT", () => $67f07001968fe110$export$9d1758ddc1563e90);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS", () => $67f07001968fe110$export$ecff223feb9d08be);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS_ASSOCIATE", () => $67f07001968fe110$export$487bc26cddb34312);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT", () => $67f07001968fe110$export$118290072826cd87);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY", () => $67f07001968fe110$export$e5994b7b1acebe82);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY_ASSOCIATE", () => $67f07001968fe110$export$84b0e53f785e02cf);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES", () => $67f07001968fe110$export$d58992a667105ce8);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES_ASSOCIATE", () => $67f07001968fe110$export$bb1cea2d23743f65);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS", () => $67f07001968fe110$export$76dac5f55ab3705e);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS_ASSOCIATE", () => $67f07001968fe110$export$a7c4adb03bc6e997);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_OPSGENIE", () => $67f07001968fe110$export$2dc565d0b2334780);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE", () => $67f07001968fe110$export$28687a1181a7676f);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS", () => $67f07001968fe110$export$2e74a7026073fa54);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS_ASSOCIATE", () => $67f07001968fe110$export$58fdfc78d176c564);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS", () => $67f07001968fe110$export$cb8548f16119b181);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS_ASSOCIATE", () => $67f07001968fe110$export$66e3f6af203a567f);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SUMMARY", () => $67f07001968fe110$export$658e7e21f1c7b69b);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS", () => $67f07001968fe110$export$1fa628a4527d424c);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE", () => $67f07001968fe110$export$c2989c5c00f9f64b);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REDIRECT", () => $67f07001968fe110$export$2d21e5416485b195);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_AVERAGE_AGE", () => $67f07001968fe110$export$e514491aa85dd54a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CONFIG", () => $67f07001968fe110$export$d9662297242bfcb5);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CREATED_VS_RESOLVED", () => $67f07001968fe110$export$2a53516b15393945);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_DEVELOPER_WORKLOAD", () => $67f07001968fe110$export$62e00190aa938a43);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_PIE", () => $67f07001968fe110$export$22a3924a6eab79ab);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RECENTLY_CREATED", () => $67f07001968fe110$export$677cf3d89d18bb74);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RESOLUTION_TIME", () => $67f07001968fe110$export$7eef86163449ad98);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY", () => $67f07001968fe110$export$8f56061e1403fa5a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_SINCE", () => $67f07001968fe110$export$adeb429de8df1e02);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_TRACKING_REPORT", () => $67f07001968fe110$export$931d6222073b5708);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_VERSION_WORKLOAD", () => $67f07001968fe110$export$2106f1ac8ba807e1);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_WORKLOAD_PIE", () => $67f07001968fe110$export$36678521a86f620b);
$parcel$export(module.exports, "ROUTE_NAMES_LOGIN_EMBED", () => $67f07001968fe110$export$55248356780fc584);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE", () => $67f07001968fe110$export$cd84c5a333c8d16a);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE_PUBLIC", () => $67f07001968fe110$export$624af6f61b05f55);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_APP_REQUESTS", () => $67f07001968fe110$export$2ed9525182145b82);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_INDEX", () => $67f07001968fe110$export$7fb2b42fc4e7df8b);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_MANAGE_APPS", () => $67f07001968fe110$export$fa962db82ae571b2);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_PROMOTIONS", () => $67f07001968fe110$export$e145bf76b1aef705);
$parcel$export(module.exports, "ROUTE_NAMES_NOTIFICATION_LOGS", () => $67f07001968fe110$export$8febbfb647e4c8b9);
$parcel$export(module.exports, "ROUTE_NAMES_OPSGENIE_SCHEDULE", () => $67f07001968fe110$export$4b34f3d336f4ccd2);
$parcel$export(module.exports, "ROUTE_NAMES_PEOPLE_INDEX", () => $67f07001968fe110$export$a979a5c1f5e3631c);
$parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS", () => $67f07001968fe110$export$ffcbf91dfadffd0);
$parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL", () => $67f07001968fe110$export$1807a39cc63b856c);
$parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS", () => $67f07001968fe110$export$2be8d3c6fedd5276);
$parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS", () => $67f07001968fe110$export$6268da7263eb670d);
$parcel$export(module.exports, "ROUTE_NAMES_PLANS_DIRECTORY", () => $67f07001968fe110$export$93bd4a896a0fc581);
$parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_EDIT", () => $67f07001968fe110$export$2b9b1bfb538ab810);
$parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_LIST", () => $67f07001968fe110$export$d1217085321b2648);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_COLLECTIONS", () => $67f07001968fe110$export$39624171b7c8a10a);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_IDEAS", () => $67f07001968fe110$export$1654cd6813e90e6b);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_INSIGHTS", () => $67f07001968fe110$export$33059cd02df2febd);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ONBOARDING", () => $67f07001968fe110$export$1d746ff2bc48ceb4);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_PLAYS", () => $67f07001968fe110$export$145c578104a45fd2);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ROOMS", () => $67f07001968fe110$export$a51df1bc877c58e5);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_ACCESS", () => $67f07001968fe110$export$45208fff8de46880);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_GLOBAL_FIELDS", () => $67f07001968fe110$export$c710a35d40378fa5);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_UNLICENSED", () => $67f07001968fe110$export$15d6b93ff5273ce3);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_AUTHENTICATION_SETTINGS", () => $67f07001968fe110$export$e26f2863c7ccd504);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS", () => $67f07001968fe110$export$496da9aa0fe819ff);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_COMPLIANCE", () => $67f07001968fe110$export$f7bbc23b5f8e2d3b);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CONFIGURATION", () => $67f07001968fe110$export$53ce69fb34f6d286);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CUSTOMER_ACCESS", () => $67f07001968fe110$export$b6e861786143eb1b);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_EMAIL_REQUESTS", () => $67f07001968fe110$export$f7e3d3b413c017e1);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_FEATURE_USAGE", () => $67f07001968fe110$export$b84d34b8175abde5);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS", () => $67f07001968fe110$export$50e4e3e5231fb74f);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS", () => $67f07001968fe110$export$39d913ae557ba8f3);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_KB_PERMISSIONS", () => $67f07001968fe110$export$a2d9bcceac584c93);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS", () => $67f07001968fe110$export$eb2e5f1608ec8b32);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION", () => $67f07001968fe110$export$9ac90b948c53bf58);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_STORAGE_MANAGEMENT", () => $67f07001968fe110$export$bb5665894498893f);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_CLASSIC_BUSINESS", () => $67f07001968fe110$export$fc61479fdfdd263a);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_SERVICEDESK", () => $67f07001968fe110$export$5ae82b891e42770e);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_SOFTWARE", () => $67f07001968fe110$export$8dcc46e162f2235b);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_CLASSIC_BUSINESS", () => $67f07001968fe110$export$a934caa57ac0ac0b);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SERVICEDESK", () => $67f07001968fe110$export$25a4e6c77f91c259);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SOFTWARE", () => $67f07001968fe110$export$2a9a9bab313fd713);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_CLASSIC_BUSINESS", () => $67f07001968fe110$export$82ad2da638fc34d8);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SERVICEDESK", () => $67f07001968fe110$export$ff67cffdbd881a41);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SOFTWARE", () => $67f07001968fe110$export$c41c7d73df3fc08c);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_CLASSIC_BUSINESS", () => $67f07001968fe110$export$65f234e4799edddc);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SERVICEDESK", () => $67f07001968fe110$export$215ea4e7405fa88c);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SOFTWARE", () => $67f07001968fe110$export$927b1972180d9cc4);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY", () => $67f07001968fe110$export$ff1365ce4d652337);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA", () => $67f07001968fe110$export$79b30013cbfdee04);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE", () => $67f07001968fe110$export$33c2dcc7c7abc45e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_REDIRECT", () => $67f07001968fe110$export$a6ef20aa08a533b1);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_COMPONENTS", () => $67f07001968fe110$export$5908e15483da8a45);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_DIRECTORY_REDIRECT", () => $67f07001968fe110$export$a3812f6f4e60d897);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR", () => $67f07001968fe110$export$3c8c119f40a061a9);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC", () => $67f07001968fe110$export$47e034646abefdb2);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE", () => $67f07001968fe110$export$f36f4cf8b17f250f);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_NOT_FOUND", () => $67f07001968fe110$export$841e880a0d425b3e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_PAGES", () => $67f07001968fe110$export$1fde4a6e7df24a97);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION", () => $67f07001968fe110$export$69335bf8b709edc7);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS", () => $67f07001968fe110$export$946b472f7559a889);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS", () => $67f07001968fe110$export$373fdf6888021ed0);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS_REDIRECT", () => $67f07001968fe110$export$d6a5f13a3d30923c);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPROVALS", () => $67f07001968fe110$export$adfff93b0b015409);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS", () => $67f07001968fe110$export$404de4ddea701cff);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS_FIELDS", () => $67f07001968fe110$export$596e1f6f6f4997b2);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION", () => $67f07001968fe110$export$8da0e4cdbdd0cd0b);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DATA_CLASSIFICATIONS", () => $67f07001968fe110$export$d610a17dff3a01fa);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DEFAULT_REDIRECT", () => $67f07001968fe110$export$284db5107f3db516);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS", () => $67f07001968fe110$export$fbce46826eefc586);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FIELDS", () => $67f07001968fe110$export$c86b29c76317ac6f);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS", () => $67f07001968fe110$export$3160b86e1b5dc391);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES", () => $67f07001968fe110$export$690c0080c930fca);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES_WORKFLOW", () => $67f07001968fe110$export$171ba8c33c05c4ef);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS", () => $67f07001968fe110$export$e2f2c23286c3255c);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS_ISSUE_LOGS", () => $67f07001968fe110$export$5a262d40e10207a1);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL", () => $67f07001968fe110$export$ab790cb87175797e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_JIRA_FORM_BUILDER", () => $67f07001968fe110$export$db780b39656c673a);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_PROJECT_FORMS", () => $67f07001968fe110$export$a77cb4dafc511d3);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS", () => $67f07001968fe110$export$253fd82874264ee4);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS_NEXTGEN", () => $67f07001968fe110$export$eaf9ab4ec0c25813);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_APPS_FIELDS", () => $67f07001968fe110$export$574bcdf6b73fcf1f);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT", () => $67f07001968fe110$export$a14853dfff8da872);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_NOTIFICATIONS", () => $67f07001968fe110$export$ba8fd0e6db8d3e08);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_PERMISSIONS", () => $67f07001968fe110$export$1c74da1e52e6d212);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS", () => $67f07001968fe110$export$d416059b17fe7d4e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_WIDGET_SETTINGS", () => $67f07001968fe110$export$d5a3a037d2760bb7);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN", () => $67f07001968fe110$export$eb187d42a7448d45);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_DETAILS", () => $67f07001968fe110$export$688de32d31fc70f5);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS", () => $67f07001968fe110$export$13d770f8814d480a);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES", () => $67f07001968fe110$export$3a628f9376166ffb);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES_FIELDS", () => $67f07001968fe110$export$649dafa225625f30);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS", () => $67f07001968fe110$export$dbfe76dd37018b2);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL", () => $67f07001968fe110$export$20db7bb9d1bd8b38);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATION_EMAIL", () => $67f07001968fe110$export$a1fa8e6e125780ae);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS", () => $67f07001968fe110$export$fc6b949fd2bc782d);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES", () => $67f07001968fe110$export$c940f866ac7760a0);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES_FIELDS", () => $67f07001968fe110$export$184d4979f6f9fe7e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES", () => $67f07001968fe110$export$959f50de166cc45e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES_FIELDS", () => $67f07001968fe110$export$b13b8c8bb4e30a75);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS", () => $67f07001968fe110$export$40d6fc2b9a4f09d2);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_APPS_FIELDS", () => $67f07001968fe110$export$cc1af211e3feda50);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_AUTOMATION", () => $67f07001968fe110$export$3873539001f5aed7);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CARD", () => $67f07001968fe110$export$89fcbafce559080b);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CSM", () => $67f07001968fe110$export$c3f05da9e4e13249);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CUSTOM_FILTERS", () => $67f07001968fe110$export$619694ab37142384);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_DETAILS", () => $67f07001968fe110$export$cb89b516b9cf418b);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_FEATURES", () => $67f07001968fe110$export$50680f54e95bb859);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_INSIGHTS", () => $67f07001968fe110$export$194c2b4da7e38757);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_REDIRECT", () => $67f07001968fe110$export$962d838817f090f8);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_ROADMAP", () => $67f07001968fe110$export$eacbdb340a470309);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_SWIMLANES", () => $67f07001968fe110$export$6a7782d87a21425d);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_TIMELINE", () => $67f07001968fe110$export$c2f56336162e799e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DATA_CLASSIFICATIONS", () => $67f07001968fe110$export$ba419378ad70624e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DETAILS", () => $67f07001968fe110$export$62f38c589a73d386);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FIELDS", () => $67f07001968fe110$export$77c8066c0822f152);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FEATURES", () => $67f07001968fe110$export$90900ebfa6f48861);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ISSUE_TYPES", () => $67f07001968fe110$export$93ff02c205edd1a8);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", () => $67f07001968fe110$export$db7f5d93be70ee30);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", () => $67f07001968fe110$export$432229516b7f82da);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL", () => $67f07001968fe110$export$8f554d4ef9f084c0);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_OPSGENIE", () => $67f07001968fe110$export$6b2b99b0055772a3);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_TOOLCHAIN", () => $67f07001968fe110$export$83c7a51057be6264);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS", () => $67f07001968fe110$export$46706d786aab3829);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_VERSIONS", () => $67f07001968fe110$export$b690025ef7e3cf6c);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD", () => $67f07001968fe110$export$ea48cc6bf1183d11);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG", () => $67f07001968fe110$export$930e4881302bbd54);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED", () => $67f07001968fe110$export$375801b708576466);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD", () => $67f07001968fe110$export$5b1e8463bd590143);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED", () => $67f07001968fe110$export$1606662a398a24be);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_LAST_VISITED_PROJECT_REDIRECT", () => $67f07001968fe110$export$c5b19a37e49ceb28);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_REPORT", () => $67f07001968fe110$export$c46680afe70295f3);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_UIF_BACKLOG", () => $67f07001968fe110$export$831fc7eba98b58c9);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG", () => $67f07001968fe110$export$4061c0c586f3b7c8);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BOARD", () => $67f07001968fe110$export$99e0abd8ba1de289);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_REPORT", () => $67f07001968fe110$export$cd96a6a0cc4831ab);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS", () => $67f07001968fe110$export$db1b3d2fee80859);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY", () => $67f07001968fe110$export$b0f3f3214ab1b150);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_BOARDS", () => $67f07001968fe110$export$fb4e3ee7e7c21e9f);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CALENDAR", () => $67f07001968fe110$export$8c8f03e75b6708ac);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CALENDAR_EAP", () => $67f07001968fe110$export$2e93790099768be5);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR", () => $67f07001968fe110$export$3c3d8caf61c9aa0c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS", () => $67f07001968fe110$export$f9cc808094ce0ddd);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE", () => $67f07001968fe110$export$9bde4a0b155f2972);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT", () => $67f07001968fe110$export$a52f5ffbbe135078);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA", () => $67f07001968fe110$export$e6773bf0fbccdb9c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION", () => $67f07001968fe110$export$8e3dd8487a7b65bd);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION", () => $67f07001968fe110$export$258b44fcc29a5961);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS", () => $67f07001968fe110$export$ea1146ebce07be6d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT", () => $67f07001968fe110$export$53731240ce2d3b76);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE", () => $67f07001968fe110$export$956eb40834ddee22);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT", () => $67f07001968fe110$export$9057470ebf41169);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME", () => $67f07001968fe110$export$c42e107c5275b36);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE", () => $67f07001968fe110$export$3e7c6a54a9d2267a);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE", () => $67f07001968fe110$export$c3e2697b35a149c4);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT", () => $67f07001968fe110$export$288c7dd61dd0c291);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA", () => $67f07001968fe110$export$37161a981d69c891);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION", () => $67f07001968fe110$export$cfe61aa92a4d585d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION", () => $67f07001968fe110$export$9ed512ab4c81669c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT", () => $67f07001968fe110$export$37a9bdd8513f462d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT", () => $67f07001968fe110$export$f01162415f3a2ee3);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2", () => $67f07001968fe110$export$860dd13b1e836ed8);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS", () => $67f07001968fe110$export$5eaf1dce55090ff3);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS", () => $67f07001968fe110$export$1fe309e7cdbd1c1);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS", () => $67f07001968fe110$export$fcd9750494ff0236);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_EARLY_ACCESS_ITSM", () => $67f07001968fe110$export$ad856b38e93b93b2);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE", () => $67f07001968fe110$export$a833209ca71d2e56);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INCIDENTS", () => $67f07001968fe110$export$829d1776460a6ad3);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INDEX", () => $67f07001968fe110$export$d30ab2da08d8b7b9);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUE", () => $67f07001968fe110$export$3c71889849aeaa08);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUES", () => $67f07001968fe110$export$354bf2df81f6ffb0);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ITSM_SAMPLE_SPACE", () => $67f07001968fe110$export$f8880b461acd270d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_JIRA_AUTOMATION", () => $67f07001968fe110$export$876055c0ede2f8df);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS", () => $67f07001968fe110$export$bf493c66e34711c8);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE", () => $67f07001968fe110$export$212f6e2c7c2a53bb);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE", () => $67f07001968fe110$export$7c28c6e8d8a6545);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE", () => $67f07001968fe110$export$8d55b6ef2cd92f8c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS", () => $67f07001968fe110$export$f7fbe9a4717b7a50);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS", () => $67f07001968fe110$export$8c800f176d079d28);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2", () => $67f07001968fe110$export$1c5fbcbfc0923176);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE", () => $67f07001968fe110$export$59644e5d8d69a016);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT", () => $67f07001968fe110$export$c7074ebe0ca83f98);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE", () => $67f07001968fe110$export$2b4737953287a354);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING", () => $67f07001968fe110$export$e7a8d6d534c5e2fe);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW", () => $67f07001968fe110$export$5dcba309e2bfa88b);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW", () => $67f07001968fe110$export$2d961b0101f8733e);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_CONVERSION", () => $67f07001968fe110$export$195fe2558f1a8591);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON", () => $67f07001968fe110$export$1b3cf68be370a45b);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE", () => $67f07001968fe110$export$45c35381e5da2232);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT", () => $67f07001968fe110$export$d479ba53b9bf65a);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE", () => $67f07001968fe110$export$ccd12890649c59cc);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING", () => $67f07001968fe110$export$8c84064031188e80);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW", () => $67f07001968fe110$export$46c6fef035fbe8ba);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_NEW", () => $67f07001968fe110$export$6fb23ec5a12d5c24);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REDIRECT", () => $67f07001968fe110$export$156b2dfbd87d576f);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS", () => $67f07001968fe110$export$6961f1ed0407cb26);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM", () => $67f07001968fe110$export$ba284efd679bf637);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE", () => $67f07001968fe110$export$e48a3df597407767);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT", () => $67f07001968fe110$export$c73718d4a6efea1d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE", () => $67f07001968fe110$export$ed454783ba1bacb9);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE", () => $67f07001968fe110$export$48f6285d4729ca9d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION", () => $67f07001968fe110$export$8066418cead2d2ef);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE", () => $67f07001968fe110$export$b3db7857ac710a89);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE", () => $67f07001968fe110$export$d574810e3edad044);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY", () => $67f07001968fe110$export$be4b2ffade787316);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE", () => $67f07001968fe110$export$3caf79b5f4be02d7);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD", () => $67f07001968fe110$export$29bc361328055683);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES", () => $67f07001968fe110$export$a4a5a333fe874d97);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_NEW", () => $67f07001968fe110$export$2193b681ac1ae132);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT", () => $67f07001968fe110$export$f1bfd5b3918619a9);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS", () => $67f07001968fe110$export$a4c4f7898d6b914a);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_NEW", () => $67f07001968fe110$export$6cffae90b9277bb);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT", () => $67f07001968fe110$export$17e76ebd53424ed5);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_EDIT", () => $67f07001968fe110$export$b1329dc26a81a277);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_NEW", () => $67f07001968fe110$export$e1cba0bfe330f5c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS", () => $67f07001968fe110$export$8e68c55c334de101);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICES", () => $67f07001968fe110$export$5cb7cfba189a0240);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICE_DETAILS", () => $67f07001968fe110$export$d28aab4a6d6f1d0d);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_AUTOMATION", () => $67f07001968fe110$export$1cf56e2d6c4edb35);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG", () => $67f07001968fe110$export$27c1770584d7e3fe);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS", () => $67f07001968fe110$export$22e0ebdea08537f7);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_RECOMMENDATIONS", () => $67f07001968fe110$export$4db732436e4edfaf);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_VIEW_CUSTOM_FIELDS", () => $67f07001968fe110$export$e832418dbed0717e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS", () => $67f07001968fe110$export$ee09be798f0e4471);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT", () => $67f07001968fe110$export$653bf90ae3578f21);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT", () => $67f07001968fe110$export$9da4125a0c62444d);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP", () => $67f07001968fe110$export$fbcc0fd9b402bb12);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES", () => $67f07001968fe110$export$e74fe5bd41e23fbd);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT", () => $67f07001968fe110$export$1a93e63ddbe4aa06);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR", () => $67f07001968fe110$export$3b6dbbe49882589d);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS", () => $67f07001968fe110$export$eb01394789016fd4);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT", () => $67f07001968fe110$export$f17f4523583fa8e5);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS", () => $67f07001968fe110$export$eaa4d6eec75a6778);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT", () => $67f07001968fe110$export$dcc96e4abbdc0d39);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG", () => $67f07001968fe110$export$9eaf39ba5a56c72a);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG_EMBED", () => $67f07001968fe110$export$495be3320b67814a);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS", () => $67f07001968fe110$export$25752eb5bb5e3d32);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS_EMBED", () => $67f07001968fe110$export$f116716aedb35e10);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR", () => $67f07001968fe110$export$36fffb6b49d9f31d);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC", () => $67f07001968fe110$export$a6d07be4ff318f84);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC_EMBED", () => $67f07001968fe110$export$a9a43f1114df1ad9);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_EMBED", () => $67f07001968fe110$export$3a4c7a521a900b4d);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT", () => $67f07001968fe110$export$9dcf51a9040a4fd6);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT_EMBED", () => $67f07001968fe110$export$a74f9f6bd0d4fb26);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE", () => $67f07001968fe110$export$f8cb86acf6b74661);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE_CLASSIC", () => $67f07001968fe110$export$2d3d850c64058bfb);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS", () => $67f07001968fe110$export$af6b51164f66908b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC", () => $67f07001968fe110$export$12efc96fc9c9fb34);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM", () => $67f07001968fe110$export$6ab1901e04e623ba);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_CLASSIC", () => $67f07001968fe110$export$bccc7d0812737c4e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_BUILDER", () => $67f07001968fe110$export$458fb992f2637a20);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC", () => $67f07001968fe110$export$c9c9c64f68ba51e3);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT", () => $67f07001968fe110$export$50264cbc90a39f19);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC", () => $67f07001968fe110$export$b9d0cbe0888fa72e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS", () => $67f07001968fe110$export$b8045610416fa8ca);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC", () => $67f07001968fe110$export$8e80136ad13099e3);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS", () => $67f07001968fe110$export$b5fe44c0bc324494);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC", () => $67f07001968fe110$export$7a4f52d9060a20d2);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR", () => $67f07001968fe110$export$d6a9e4695952522e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST", () => $67f07001968fe110$export$deab88d0814c564b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC", () => $67f07001968fe110$export$906faff110f898ef);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC_EMBED", () => $67f07001968fe110$export$ab3f2a34a3b0db87);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_EMBED", () => $67f07001968fe110$export$4ed84a2011fdc400);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_NEXTGEN_REDIRECT", () => $67f07001968fe110$export$f7b286b39bf6051b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING", () => $67f07001968fe110$export$6c4337c0332c8c7f);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED", () => $67f07001968fe110$export$e7c78887745b2326);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE", () => $67f07001968fe110$export$3805e4f07dca7584);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC", () => $67f07001968fe110$export$f77254983320e888);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR", () => $67f07001968fe110$export$2e784832f1c6bb);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED", () => $67f07001968fe110$export$7f97fa79520a4c5b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES", () => $67f07001968fe110$export$9e53cdb1ac02195c);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT", () => $67f07001968fe110$export$7a821e22be2c2f14);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT_EMBED", () => $67f07001968fe110$export$ca8966ef80bfafc6);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS", () => $67f07001968fe110$export$e7423156dba31a7c);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_RELEASES", () => $67f07001968fe110$export$cba7e383b2409c7b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER", () => $67f07001968fe110$export$d5378fb71d5242c0);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS", () => $67f07001968fe110$export$4b16b72c72da8833);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES", () => $67f07001968fe110$export$10114d78cefb1f53);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE", () => $67f07001968fe110$export$92fe23ed30100817);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES", () => $67f07001968fe110$export$e824495554c83069);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PERMISSIONS", () => $67f07001968fe110$export$8df2e9efdd625a44);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PLAN_INFO", () => $67f07001968fe110$export$aeb4d3006e298033);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS", () => $67f07001968fe110$export$e15d3c40985c4b53);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES", () => $67f07001968fe110$export$1d8c84454fd2d571);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS", () => $67f07001968fe110$export$db61a12efb59745c);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCENARIOS", () => $67f07001968fe110$export$2da67fb5bd6bc2ee);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCHEDULING", () => $67f07001968fe110$export$182e0167fd960de6);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY", () => $67f07001968fe110$export$2d9e2484ee02e7da);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY_EMBED", () => $67f07001968fe110$export$b7fff19fd89b617f);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TEAMS", () => $67f07001968fe110$export$ea23f150f64e8a4e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE", () => $67f07001968fe110$export$116338bd93f78ad0);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE_EMBED", () => $67f07001968fe110$export$c9cd65a78227cf18);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PRESENTATION_TOOLKIT_REPORT", () => $67f07001968fe110$export$7a4b4b66d7637fbb);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_RELEASE_NOTES", () => $67f07001968fe110$export$d75d93e5d44182cc);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS", () => $67f07001968fe110$export$cc3027ae3767801);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN", () => $67f07001968fe110$export$3492ce83b8884e0e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP", () => $67f07001968fe110$export$b4798b7e62733393);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL", () => $67f07001968fe110$export$388685c701d6e0d3);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE", () => $67f07001968fe110$export$5ff4d2d4257ea2b0);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME", () => $67f07001968fe110$export$fa83895c1eac55e7);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC", () => $67f07001968fe110$export$5c82bb95a06a1846);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY", () => $67f07001968fe110$export$c725b9c7e11dd69e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC", () => $67f07001968fe110$export$90594f89c675ba05);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY", () => $67f07001968fe110$export$ae0d999dd2bdd59b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REQUESTS", () => $67f07001968fe110$export$43bbf6935a91d277);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC", () => $67f07001968fe110$export$92e23977438282b2);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP", () => $67f07001968fe110$export$296115eb5b7129d3);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC", () => $67f07001968fe110$export$17574f41c3925d64);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_REDIRECT", () => $67f07001968fe110$export$955692fbfe35fc16);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY", () => $67f07001968fe110$export$30af3a767b8ad2d8);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC", () => $67f07001968fe110$export$f47d664298c2c2f0);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE", () => $67f07001968fe110$export$1714b5ad9b672bc7);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC", () => $67f07001968fe110$export$c9634bf15518a3a1);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL", () => $67f07001968fe110$export$3b5eb3ea8cbeeed);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT", () => $67f07001968fe110$export$c29d90ae9a4b648e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH", () => $67f07001968fe110$export$8f2717a951373c25);
$parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_CONFIGURATION", () => $67f07001968fe110$export$831acb5098f5706d);
$parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT", () => $67f07001968fe110$export$d218cda46c433fe1);
$parcel$export(module.exports, "ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK", () => $67f07001968fe110$export$61147168ac2833f9);
$parcel$export(module.exports, "ROUTE_NAMES_TRASH_PLANS_DIRECTORY", () => $67f07001968fe110$export$9fe0117c0fd486a8);
$parcel$export(module.exports, "ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY", () => $67f07001968fe110$export$a49474778d15635d);
$parcel$export(module.exports, "ROUTE_NAMES_USER_SEGMENTATION", () => $67f07001968fe110$export$af3296e54e7fb362);
$parcel$export(module.exports, "ROUTE_NAMES_YOUR_WORK", () => $67f07001968fe110$export$281f2e01ee9e4977);
/**
 * SPA ROUTES
 *
 * This should contain only 3 things:
 *
 *  1. ROUTE_GROUPS - strings that represent the FULL route-group name (not a substring of the actual route-group name).
 *  2. ROUTE_NAMES - strings that represent the FULL route name (not a substring of the actual route name).
 *  3. The types for 1 & 2.
 *
 * This file is used in the following unit tests:
 *  - jira/src/packages/navigation-apps/sidebar-nav4/context/src/common/utils/selected-path/routeToSelectedPath.test.tsx
 *
 * Therefore, any changes to this file is highly-likely to break the unit test(s).
 * If that happens, DON'T PANIC.
 * There will usually be a simple solution to fix the test(s).
 * The failing test-suite will have suggestions on how to fix the breaking-test(s).
 */ const $67f07001968fe110$export$1ba937db1fe6ef01 = 'archive-issues';
const $67f07001968fe110$export$3fd002e197e83a30 = 'arj-settings';
const $67f07001968fe110$export$bbf08d4d25df5504 = 'classic-business';
const $67f07001968fe110$export$e3e759b7f50aaee1 = 'classic-software';
const $67f07001968fe110$export$89337611b52bc9a3 = 'components';
const $67f07001968fe110$export$3d7937b12eb9e5d5 = 'connect';
const $67f07001968fe110$export$7a3d181d86fce9e6 = 'dashboard';
const $67f07001968fe110$export$294c878a3842c859 = 'dashboards';
const $67f07001968fe110$export$7a22726acd7d6021 = 'devops';
const $67f07001968fe110$export$f3f4a9f53ba00861 = 'directories';
const $67f07001968fe110$export$112d69653b2f1d8b = 'eoc';
const $67f07001968fe110$export$74e0426b66571086 = 'errors';
const $67f07001968fe110$export$c2e20e142c95c1ce = 'global-settings';
const $67f07001968fe110$export$f8cea29bebf098c = 'helpcenter-settings';
const $67f07001968fe110$export$5801ef8dfc9a2f70 = 'home';
const $67f07001968fe110$export$7246838143f848f3 = 'issue';
const $67f07001968fe110$export$54f96702980a2f87 = 'issue-navigator';
const $67f07001968fe110$export$5566db8fbd042fc4 = 'legacy';
const $67f07001968fe110$export$20344ad17b5fca86 = 'legacy-jsd-settings';
const $67f07001968fe110$export$656d0cc2c67b2708 = 'marketplace';
const $67f07001968fe110$export$bfdbcebc4c81b043 = 'people-profiles';
const $67f07001968fe110$export$82021d71ad19e227 = 'personal-settings';
const $67f07001968fe110$export$6f266218a6973848 = 'plan-settings';
const $67f07001968fe110$export$a846fcaeeea8e0ff = 'polaris';
const $67f07001968fe110$export$6c87a9dff4e7a2de = 'proforma';
const $67f07001968fe110$export$ab79970dcfac06a1 = 'project-settings-classic';
const $67f07001968fe110$export$d1a70f80bb22f18a = 'project-settings-core';
const $67f07001968fe110$export$bd925e9fcb6ce37f = 'project-settings-servicedesk';
const $67f07001968fe110$export$86509a1baabd62ee = 'project-settings-software';
const $67f07001968fe110$export$98823ed9eedfc756 = 'project-settings-software-boards';
const $67f07001968fe110$export$da8d13fe1ccd5c09 = 'redirects';
const $67f07001968fe110$export$78fb2f6176b7c6b8 = 'servicedesk';
const $67f07001968fe110$export$d4a2a2e87da2135a = 'services';
const $67f07001968fe110$export$26efaec7a7a8b361 = 'software';
const $67f07001968fe110$export$db781fb68c08f7e2 = 'versions';
const $67f07001968fe110$export$88041353cc69458d = 'archived-issues-directory';
const $67f07001968fe110$export$f88d57dcb03ba452 = 'archived-plans-directory';
const $67f07001968fe110$export$e8aa63af071c2da9 = 'archived-projects-directory';
const $67f07001968fe110$export$b114d0da2ebcff6c = 'archived-project-direct-link';
const $67f07001968fe110$export$29cc94b8cea5c920 = 'boards-directory';
const $67f07001968fe110$export$4d1b45005cdcfb39 = 'browse-project-redirect';
const $67f07001968fe110$export$a42ea04fdf53eeaf = 'next-gen-business-board';
const $67f07001968fe110$export$ca4c5f5b3e2daa18 = 'business-classic-reports';
const $67f07001968fe110$export$d58a5411a2ac6260 = 'next-gen-business-reports';
const $67f07001968fe110$export$24514ee19772b5af = `${$67f07001968fe110$export$bbf08d4d25df5504}-onboarding-get-started`;
const $67f07001968fe110$export$ec333dd1d6a8b38 = `${$67f07001968fe110$export$bbf08d4d25df5504}-overview-calendar`;
const $67f07001968fe110$export$ed495fbad44791af = `${$67f07001968fe110$export$bbf08d4d25df5504}-overview-redirect`;
const $67f07001968fe110$export$5281552f8109b7c0 = `${$67f07001968fe110$export$bbf08d4d25df5504}-overview-summary`;
const $67f07001968fe110$export$6e8473713ed4557a = `${$67f07001968fe110$export$bbf08d4d25df5504}-overview-timeline`;
const $67f07001968fe110$export$cbdd5c24d69b2cb1 = `${$67f07001968fe110$export$bbf08d4d25df5504}-approvals`;
const $67f07001968fe110$export$e7f012f402be01ea = `${$67f07001968fe110$export$bbf08d4d25df5504}-attachments`;
const $67f07001968fe110$export$b34d3882b42d660d = `${$67f07001968fe110$export$bbf08d4d25df5504}-board`;
const $67f07001968fe110$export$ed869c60c6a56182 = `${$67f07001968fe110$export$bbf08d4d25df5504}-board-embed`;
const $67f07001968fe110$export$5013269f29c75b37 = `${$67f07001968fe110$export$bbf08d4d25df5504}-calendar`;
const $67f07001968fe110$export$fc8b48319e993d43 = `${$67f07001968fe110$export$bbf08d4d25df5504}-calendar-embed`;
const $67f07001968fe110$export$40903feb5b038923 = `${$67f07001968fe110$export$bbf08d4d25df5504}-files`;
const $67f07001968fe110$export$d6e60a2059f028d = `${$67f07001968fe110$export$bbf08d4d25df5504}-form`;
const $67f07001968fe110$export$3d589aae17a00bc9 = `${$67f07001968fe110$export$bbf08d4d25df5504}-form-builder`;
const $67f07001968fe110$export$bd92ef03b23dd672 = `${$67f07001968fe110$export$bbf08d4d25df5504}-form-submit`;
const $67f07001968fe110$export$fa7fc44c718fc850 = `${$67f07001968fe110$export$bbf08d4d25df5504}-form-submit-embed`;
const $67f07001968fe110$export$1dffaf831e01e2b4 = `${$67f07001968fe110$export$bbf08d4d25df5504}-list`;
const $67f07001968fe110$export$5f8187412dd60f35 = `${$67f07001968fe110$export$bbf08d4d25df5504}-list-embed`;
const $67f07001968fe110$export$3d2c1c04d18f6c43 = `${$67f07001968fe110$export$bbf08d4d25df5504}-sample-onboarding`;
const $67f07001968fe110$export$cd22a5d8f560a1d8 = `${$67f07001968fe110$export$bbf08d4d25df5504}-shortcut`;
const $67f07001968fe110$export$cad1b1aa5ce26bbc = `${$67f07001968fe110$export$bbf08d4d25df5504}-summary`;
const $67f07001968fe110$export$ee073463b4144367 = `${$67f07001968fe110$export$bbf08d4d25df5504}-summary-embed`;
const $67f07001968fe110$export$ea034943499772ea = `${$67f07001968fe110$export$bbf08d4d25df5504}-timeline`;
const $67f07001968fe110$export$19bc888bcf37d22d = `${$67f07001968fe110$export$bbf08d4d25df5504}-timeline-embed`;
const $67f07001968fe110$export$e0746183e11767fb = `${$67f07001968fe110$export$bbf08d4d25df5504}-redirect`;
const $67f07001968fe110$export$3e2d215ce157adc8 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-code`;
const $67f07001968fe110$export$8a8485bb05daf40b = `${$67f07001968fe110$export$d1a70f80bb22f18a}-proforma-project-forms`;
const $67f07001968fe110$export$a2799b01de5bb62 = `${$67f07001968fe110$export$ab79970dcfac06a1}-data-classifications`;
const $67f07001968fe110$export$1bc2b66dcb07293a = `${$67f07001968fe110$export$e3e759b7f50aaee1}-details`;
const $67f07001968fe110$export$2d4f89c4b1ee3640 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-features`;
const $67f07001968fe110$export$75609d3416c31f79 = `${$67f07001968fe110$export$ab79970dcfac06a1}-issue-layout`;
const $67f07001968fe110$export$79793dc26e0b7b1a = `${$67f07001968fe110$export$e3e759b7f50aaee1}-notifications-notification-email`;
const $67f07001968fe110$export$2eda7466fbfdef43 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-link-opsgenie`;
const $67f07001968fe110$export$417297669917ee1a = `${$67f07001968fe110$export$e3e759b7f50aaee1}-details`;
const $67f07001968fe110$export$8c79f3309ac0737 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-notifications`;
const $67f07001968fe110$export$ef71a22e7befd35c = `${$67f07001968fe110$export$e3e759b7f50aaee1}-notifications-issue-logs`;
const $67f07001968fe110$export$62ba1e294f5007c1 = `${$67f07001968fe110$export$86509a1baabd62ee}-proforma-edit-forms`;
const $67f07001968fe110$export$a4315324546ecc89 = `${$67f07001968fe110$export$86509a1baabd62ee}-proforma-project-forms`;
const $67f07001968fe110$export$a653cf6d478b3df1 = `${$67f07001968fe110$export$86509a1baabd62ee}-toolchain-company-managed`;
const $67f07001968fe110$export$b0f268fe53a03e98 = 'compass-product-settings';
const $67f07001968fe110$export$f4160b48e4ab8f39 = 'confluence-product-settings';
const $67f07001968fe110$export$608f359cf8b08d2e = 'connect-general';
const $67f07001968fe110$export$8bfbf790fe89f8d3 = 'connect-general-invalid';
const $67f07001968fe110$export$d7011d1ed949f970 = 'connect-general-service-desk-project';
const $67f07001968fe110$export$bd2506db44585db6 = 'connect-project';
const $67f07001968fe110$export$200fa5ad16f8c112 = 'create-project';
const $67f07001968fe110$export$21702f145fe1bbb0 = 'customer-service-accounts';
const $67f07001968fe110$export$a296bb962bea95b5 = 'dashboard';
const $67f07001968fe110$export$b9960c143c0414eb = 'dashboards-directory';
const $67f07001968fe110$export$411171d2fcaefaea = 'dashboards-directory-secure';
const $67f07001968fe110$export$ee104ed514f63003 = 'dashboard-edit';
const $67f07001968fe110$export$9233f9ddcecd3062 = 'dashboard-selected';
const $67f07001968fe110$export$b3240ec044a6c70f = 'dashboard-view';
const $67f07001968fe110$export$2463c779e12367e3 = 'dashboard-view-embed';
const $67f07001968fe110$export$dd3e5187eae2abe9 = 'dashboard-wallboard';
const $67f07001968fe110$export$38ca7e07048a5bfd = 'devops-connected-project';
const $67f07001968fe110$export$a9044bbb0247378d = 'eoc-alerts';
const $67f07001968fe110$export$ae7376e552380ac0 = 'eoc-alert-detail';
const $67f07001968fe110$export$48749e87cc44a5a5 = 'eoc-alert-issue-syncing';
const $67f07001968fe110$export$21c230ef79df9e9 = 'eoc-alert-issue-syncing-create';
const $67f07001968fe110$export$d2d813dd057a8352 = 'eoc-alert-issue-syncing-detail';
const $67f07001968fe110$export$54ed2374d14a7e88 = 'eoc-api-key-management';
const $67f07001968fe110$export$58368fe796f5ecb4 = 'eoc-assign-custom-roles';
const $67f07001968fe110$export$bbb4032f8f259109 = 'eoc-automations';
const $67f07001968fe110$export$5b17b30c2dd69cf2 = 'eoc-custom-roles';
const $67f07001968fe110$export$d18d0b9a9e85e59c = 'eoc-global-alerts';
const $67f07001968fe110$export$5126a481501fc518 = 'eoc-global-alert-detail';
const $67f07001968fe110$export$40e720d8c26e6804 = 'eoc-global-group-detail';
const $67f07001968fe110$export$dc8ac1f7e9373a32 = 'eoc-global-maintenance';
const $67f07001968fe110$export$8ca3e3f0326ba27f = 'eoc-global-reports';
const $67f07001968fe110$export$c3d17be12795c864 = 'eoc-global-report-dashboard';
const $67f07001968fe110$export$9cd1c70eda5cae15 = 'eoc-heartbeats';
const $67f07001968fe110$export$99f769b27f537a72 = 'eoc-incoming-call';
const $67f07001968fe110$export$5c5fe79d3f9ec214 = 'eoc-incoming-call-detail';
const $67f07001968fe110$export$901b974cf0954c88 = 'eoc-integrations';
const $67f07001968fe110$export$b2dd23a345bd5cb3 = 'eoc-integration-create';
const $67f07001968fe110$export$8ae7cbc0a73f9351 = 'eoc-integration-detail';
const $67f07001968fe110$export$8057ebe7fb7f7f8d = 'eoc-integration-list';
const $67f07001968fe110$export$a22387b9744e62e3 = 'eoc-integration-log';
const $67f07001968fe110$export$f6fefa9d2e5bbda1 = 'eoc-maintenance';
const $67f07001968fe110$export$e6de4aa6c719d2b = 'eoc-on-call';
const $67f07001968fe110$export$b195ada84b7e695f = `${$67f07001968fe110$export$e6de4aa6c719d2b}-redirect`;
const $67f07001968fe110$export$1800d32171b754a6 = 'eoc-overview';
const $67f07001968fe110$export$d22a153bfcbaaaa0 = 'eoc-overview-all-teams';
const $67f07001968fe110$export$a9a41c76994b6ae9 = 'eoc-permissions';
const $67f07001968fe110$export$5bd6f2569c3cfd5c = 'eoc-policies';
const $67f07001968fe110$export$dc70eff53ff26c70 = 'eoc-reports';
const $67f07001968fe110$export$1fe2ca96b360df19 = 'eoc-reports-team';
const $67f07001968fe110$export$1ff01e77517a80b0 = 'eoc-reports-unsubscribe';
const $67f07001968fe110$export$de3f8f3198f8213a = 'eoc-role-based-notifications';
const $67f07001968fe110$export$b2cb569d360db382 = 'eoc-role-based-notifications-detail';
const $67f07001968fe110$export$c4531cbbea51b6a1 = 'eoc-settings';
const $67f07001968fe110$export$da985e953465731f = 'eoc-team-alerts';
const $67f07001968fe110$export$b7eee2afd0a5c6b9 = 'eoc-team-alert-detail';
const $67f07001968fe110$export$9b6c84986db47d98 = 'eoc-team-alert-issue-syncing';
const $67f07001968fe110$export$89276f76fdd700d6 = 'eoc-team-alert-issue-syncing-create';
const $67f07001968fe110$export$ea64769f19da8c95 = 'eoc-team-alert-issue-syncing-detail';
const $67f07001968fe110$export$4a584839d9a9eb6f = 'eoc-team-customer-logs';
const $67f07001968fe110$export$27d27c817eeb97cc = 'eoc-team-customer-logs-download';
const $67f07001968fe110$export$9f533c13cfb48a8f = 'eoc-team-group-detail';
const $67f07001968fe110$export$6889e571e5aa6ba6 = 'eoc-team-integrations';
const $67f07001968fe110$export$bdd811277711c53d = 'eoc-team-integration-create';
const $67f07001968fe110$export$c7b51c0e8ad6f77a = 'eoc-team-integration-detail';
const $67f07001968fe110$export$a348fc7f3b4cfe34 = 'eoc-team-integration-list';
const $67f07001968fe110$export$a4eff769c94da831 = 'eoc-team-integration-log';
const $67f07001968fe110$export$7c928ca9c9822772 = 'eoc-team-policies';
const $67f07001968fe110$export$b48311a8f24f4b63 = 'eoc-unlock-operations';
const $67f07001968fe110$export$20649eac204f7661 = 'eoc-who-is-on-call';
const $67f07001968fe110$export$62170875a111d729 = 'errors-not-found';
const $67f07001968fe110$export$2928f3d69e7ac609 = 'external-import';
const $67f07001968fe110$export$259e18cafd820487 = 'filters-directory';
const $67f07001968fe110$export$4b8f333757e638a4 = 'filters-directory-secure';
const $67f07001968fe110$export$ac4f65a14002f892 = 'forge-spa-admin';
const $67f07001968fe110$export$c73ddc4b44ccb359 = 'forge-spa-admin-settings';
const $67f07001968fe110$export$7ad826b482229119 = 'forge-spa-field-context-config';
const $67f07001968fe110$export$3df864df9b639033 = 'forge-spa-global';
const $67f07001968fe110$export$7d67bf4077ebe18d = 'forge-spa-project';
const $67f07001968fe110$export$5ff797dfd5df551f = 'forge-spa-servicedesk-queue';
const $67f07001968fe110$export$8a66ba1da5efa2c = 'global-admin-helper-email-notifications-log';
const $67f07001968fe110$export$eadf5aff28def565 = 'global-issue-navigator';
const $67f07001968fe110$export$8f9c045e8fd449b7 = 'global-issue-navigator-browse-issue-redirect';
const $67f07001968fe110$export$1bf439327974644b = 'global-mail-settings';
const $67f07001968fe110$export$e2a9d163770d0d46 = 'global-settings-contact-administrator';
const $67f07001968fe110$export$21b497c57bcd299a = 'global-settings-issues-custom-fields-view';
const $67f07001968fe110$export$8d4d1f7df6e5d4e4 = 'global-settings-issues-custom-fields-associate';
const $67f07001968fe110$export$df5ca261227a6052 = 'global-settings-issues-custom-fields-config';
const $67f07001968fe110$export$9f2f4303259b8508 = 'global-settings-issues-custom-fields-delete';
const $67f07001968fe110$export$7fd53fe07eecc273 = 'global-settings-issues-custom-fields-edit';
const $67f07001968fe110$export$c8e9ba2b5bc9dab2 = 'global-settings-issues-custom-fields-manage';
const $67f07001968fe110$export$e05a6c9e9b9b0c48 = 'global-settings-issues-custom-fields-translate';
const $67f07001968fe110$export$f9759b206b651b1f = 'global-settings-issues-explicit-field-association-project-list';
const $67f07001968fe110$export$7a337a2687b5d5e3 = 'global-settings-issues-edit-permissions-schemes';
const $67f07001968fe110$export$a41998c1a3572e41 = 'global-settings-issues-fieldlayouts-view';
const $67f07001968fe110$export$2c9fe9e6005a9c36 = 'global-settings-issues-fieldview';
const $67f07001968fe110$export$5d8d82ff1de3586e = 'global-settings-issues-fieldlayouts-copy';
const $67f07001968fe110$export$8a0ed100d885c17c = 'global-settings-issues-fieldlayouts-schemes-view';
const $67f07001968fe110$export$1c7041445acf79e8 = 'global-settings-issues-fieldlayouts-schemes-config';
const $67f07001968fe110$export$e4712523d95125f6 = 'global-settings-issues-fieldlayouts-schemes-copy';
const $67f07001968fe110$export$7401274ad357ff94 = 'global-settings-issues-fieldlayouts-schemes-delete';
const $67f07001968fe110$export$6984b21077857555 = 'global-settings-issues-fieldlayouts-schemes-edit';
const $67f07001968fe110$export$5a2dae98f768aedf = 'global-settings-issues-fieldlayouts-schemes-entity';
const $67f07001968fe110$export$5eef1c6eb1388ac0 = 'global-settings-issues-fieldlayouts-config';
const $67f07001968fe110$export$69bcf2c26d45e030 = 'global-settings-issues-form-data-connections';
const $67f07001968fe110$export$ba1417cf5de80f81 = 'global-settings-global-permissions';
const $67f07001968fe110$export$fdcfcb2e2eb16afd = 'global-settings-issues-linktypes-view';
const $67f07001968fe110$export$5d3e6bffd6b5abfe = 'global-settings-issues-linktypes-activate';
const $67f07001968fe110$export$5c676bbb7e3aae9e = 'global-settings-issues-linktypes-deactivate';
const $67f07001968fe110$export$8bb013ced097489a = 'global-settings-issues-linktypes-delete';
const $67f07001968fe110$export$e384ae6a87fadedd = 'global-settings-issues-linktypes-edit';
const $67f07001968fe110$export$8f55a911c4bd95bf = 'global-settings-issues-new-issue-search';
const $67f07001968fe110$export$d7b98892cb31fba5 = 'global-settings-issues-new-issue-view';
const $67f07001968fe110$export$8be4b203f526b2cd = 'global-settings-issues-notification-add';
const $67f07001968fe110$export$df09947903c514c4 = 'global-settings-issues-notification-delete';
const $67f07001968fe110$export$cf4a57a81e0bfbca = 'global-settings-issues-notification-edit';
const $67f07001968fe110$export$bc64365bbb09c05e = 'global-settings-issues-notification-scheme-add';
const $67f07001968fe110$export$5b12571311ebe766 = 'global-settings-issues-notification-scheme-delete';
const $67f07001968fe110$export$56dc46fe1de63994 = 'global-settings-issues-notification-scheme-edit';
const $67f07001968fe110$export$65af0e5a36d4b4e9 = 'global-settings-issues-notification-view';
const $67f07001968fe110$export$dec448f9d2e50c90 = 'global-settings-issues-permissions-schemes-view';
const $67f07001968fe110$export$9ff4144e1dcf9fa4 = 'global-settings-issues-permissions-schemes-add';
const $67f07001968fe110$export$8aab6fb9a62dda95 = 'global-settings-issues-permissions-schemes-delete';
const $67f07001968fe110$export$9f804a2650117f51 = 'global-settings-issues-permissions-schemes-edit';
const $67f07001968fe110$export$7dd4b916600f670 = 'global-settings-issues-priorities';
const $67f07001968fe110$export$c1b40a8a70c0aafa = 'global-settings-issues-priorities-delete';
const $67f07001968fe110$export$ff10d812380db045 = 'global-settings-issues-priorities-edit';
const $67f07001968fe110$export$8deeffdf8dfed878 = 'global-settings-issues-priorities-translations';
const $67f07001968fe110$export$561687f2fa9b9cc9 = 'global-settings-issues-priority-schemes';
const $67f07001968fe110$export$691d30818c14141c = 'global-settings-issues-resolutions';
const $67f07001968fe110$export$8fa58495105f8fb0 = 'global-settings-issues-resolutions-default';
const $67f07001968fe110$export$8304c57494d82ffd = 'global-settings-issues-resolutions-delete';
const $67f07001968fe110$export$353609deec72a2ba = 'global-settings-issues-resolutions-edit';
const $67f07001968fe110$export$1cb56e4c132ac8fd = 'global-settings-issues-resolutions-translations';
const $67f07001968fe110$export$5fe3eec0a6bda09 = 'global-settings-issues-security-edit';
const $67f07001968fe110$export$12b56880d6fb7ac7 = 'global-settings-issues-security-level-add';
const $67f07001968fe110$export$9986e8be82998857 = 'global-settings-issues-security-level-delete';
const $67f07001968fe110$export$3280ec16231916af = 'global-settings-issues-security-level-edit';
const $67f07001968fe110$export$54885d105d1e2b37 = 'global-settings-issues-security-schemes';
const $67f07001968fe110$export$f34d87c870f3bf43 = 'global-settings-issues-security-schemes-add';
const $67f07001968fe110$export$4108ebf71e36e461 = 'global-settings-issues-security-schemes-delete';
const $67f07001968fe110$export$d42ec33a6e69686e = 'global-settings-issues-security-schemes-edit';
const $67f07001968fe110$export$8d2cfabd01e2feaa = 'global-settings-issues-statuses';
const $67f07001968fe110$export$d0fe3726dffeca80 = 'global-settings-issues-statuses-translations';
const $67f07001968fe110$export$b4aa4b2b8fb7267a = 'global-settings-issues-field-configure';
const $67f07001968fe110$export$3743711165f5dd4f = 'global-settings-issues-field-configure-edit';
const $67f07001968fe110$export$5df6f81deab9567c = 'global-settings-issues-field-schemes-view';
const $67f07001968fe110$export$b3db2a2ee8a9a8e4 = 'global-settings-issues-field-schemes-add';
const $67f07001968fe110$export$d5fc8cd4b3fd2b84 = 'global-settings-issues-field-schemes-configure';
const $67f07001968fe110$export$a03360d8b616ef34 = 'global-settings-issues-field-schemes-copy';
const $67f07001968fe110$export$336e54edc189df7f = 'global-settings-issues-field-schemes-delete';
const $67f07001968fe110$export$53572e9a81205523 = 'global-settings-issues-field-schemes-edit';
const $67f07001968fe110$export$b71f2ef452117a2a = 'global-settings-issues-field-schemes-edit-item';
const $67f07001968fe110$export$f79745fee583cd62 = 'global-settings-issues-field-screens';
const $67f07001968fe110$export$2281663e19f399c1 = 'global-settings-issues-field-copy';
const $67f07001968fe110$export$38c52d8c5e5dad29 = 'global-settings-issues-field-delete';
const $67f07001968fe110$export$10babc3f11b4e6e2 = 'global-settings-issues-field-edit';
const $67f07001968fe110$export$adf2f51c41b4e22a = 'global-settings-issues-hierarchy-view';
const $67f07001968fe110$export$11b217754d4c7d24 = 'global-settings-issues-hierarchy-redirect';
const $67f07001968fe110$export$3414f0d81f1c11d = 'global-settings-issues-subtasks-manage';
const $67f07001968fe110$export$5574c73a9a5878ca = 'global-settings-issues-subtasks-disable';
const $67f07001968fe110$export$cb2626c385b72992 = 'global-settings-issues-subtasks-edit';
const $67f07001968fe110$export$fa7aa7cabc3ec459 = 'global-settings-issues-subtasks-tranlations';
const $67f07001968fe110$export$8b0450672651ef67 = 'global-settings-issues-time-tracking';
const $67f07001968fe110$export$ef510a15f840e437 = 'global-settings-issues-types-view';
const $67f07001968fe110$export$bc159fa4984a907f = 'global-settings-issues-types-delete';
const $67f07001968fe110$export$47bfbce13af95d24 = 'global-settings-issues-types-edit';
const $67f07001968fe110$export$c8cb78e94cd3f83c = 'global-settings-issues-types-schemes-manage';
const $67f07001968fe110$export$4496279df22177be = 'global-settings-issues-types-schemes-option';
const $67f07001968fe110$export$afdfef5d17c56988 = 'global-settings-issues-types-schemes-associate-default';
const $67f07001968fe110$export$ac9b4b1136300033 = 'global-settings-issues-types-schemes-option-delete';
const $67f07001968fe110$export$4aa31dc2a6d4f2ee = 'global-settings-issues-types-screen-schemes-view';
const $67f07001968fe110$export$c56f5509b93eba68 = 'global-settings-issues-types-screen-schemes-configure';
const $67f07001968fe110$export$dd9462e97e11637a = 'global-settings-issues-types-screen-schemes-copy';
const $67f07001968fe110$export$11f8c53e10f63cfb = 'global-settings-issues-types-screen-schemes-delete';
const $67f07001968fe110$export$758ad3ad6916c9f6 = 'global-settings-issues-types-screen-schemes-edit';
const $67f07001968fe110$export$9d65a754315eb617 = 'global-settings-issues-types-screen-schemes-entity';
const $67f07001968fe110$export$564b665f6ca740dd = 'global-settings-issues-types-translations';
const $67f07001968fe110$export$256fc89c38c1b9e9 = 'global-settings-issues-workflows-pages';
const $67f07001968fe110$export$ddeae77164bfac0 = 'global-settings-issues-workflow-edit';
const $67f07001968fe110$export$fa2b355372963545 = 'global-settings-issues-workflows-schemes-view';
const $67f07001968fe110$export$45511e437e54fa02 = 'global-settings-issues-workflows-schemes-edit';
const $67f07001968fe110$export$ad76895f03f27a7c = 'global-settings-issues-workflow-transition';
const $67f07001968fe110$export$1c291d65a59b1636 = 'global-settings-issues-workflow-transition-meta-attributes';
const $67f07001968fe110$export$d9bb14d665bfeea5 = 'global-settings-migrations-dashboard';
const $67f07001968fe110$export$8b44cb3da7b8f857 = 'global-settings-migrations-focus-page';
const $67f07001968fe110$export$9ca6a09e1518d3bb = 'global-settings-migrations-home';
const $67f07001968fe110$export$4c211b3188348679 = 'global-settings-performance-custom-field';
const $67f07001968fe110$export$24757bb1837e33af = 'global-settings-performance-issue';
const $67f07001968fe110$export$95b5d0bd29a3a076 = 'global-settings-performance-metric-detail';
const $67f07001968fe110$export$d55d4330b58683da = 'global-settings-performance-overview';
const $67f07001968fe110$export$f4d5833f0b40a26b = 'global-settings-performance-project-cleanup';
const $67f07001968fe110$export$c78577545f514ca8 = 'global-settings-performance-project-role-actor';
const $67f07001968fe110$export$253eb3db7152d010 = 'global-settings-permissions-schemes';
const $67f07001968fe110$export$16b4392a63a3eacf = 'global-settings-products-applinks';
const $67f07001968fe110$export$b2d5a7bc804ed9c9 = 'global-settings-products-dvcs';
const $67f07001968fe110$export$f870832f94ca5009 = 'global-settings-products-sdmail';
const $67f07001968fe110$export$8b3a1b2e8e954dc2 = 'global-settings-products-jsd-status';
const $67f07001968fe110$export$15603150075c3d64 = 'global-settings-projects-categories-delete';
const $67f07001968fe110$export$92536fe760c41862 = 'global-settings-projects-categories-edit';
const $67f07001968fe110$export$3f4d05032349dae0 = 'global-settings-projects-categories-view';
const $67f07001968fe110$export$8ff94a2e5f98315f = 'global-settings-system-shared-dashboards';
const $67f07001968fe110$export$c906c6946fef5d99 = 'global-settings-system-helper-notification';
const $67f07001968fe110$export$a1916b723e186494 = 'global-settings-system-helper-permission';
const $67f07001968fe110$export$5070b4c974017f28 = 'global-settings-system-attachments';
const $67f07001968fe110$export$bee7f9f93cb74124 = 'global-settings-system-events';
const $67f07001968fe110$export$efe4008073ab3b69 = 'global-settings-system-events-add';
const $67f07001968fe110$export$9e40228f1c62d4d9 = 'global-settings-system-events-delete';
const $67f07001968fe110$export$223f8094878fea34 = 'global-settings-system-events-edit';
const $67f07001968fe110$export$2f589c572415c043 = 'global-settings-system-lexorank';
const $67f07001968fe110$export$8cc394a1f5ca4ac0 = 'global-settings-system-services';
const $67f07001968fe110$export$a11311cd333dae90 = 'global-settings-system-webhooks';
const $67f07001968fe110$export$2b2f159267202dcc = 'global-settings-system-bulk-mail';
const $67f07001968fe110$export$c5a6874288d2e609 = 'global-settings-system-application-advanced';
const $67f07001968fe110$export$55dd30b027c838fe = 'global-settings-system-application-edit';
const $67f07001968fe110$export$aee9c7dbf672403c = 'global-settings-system-global-permissions';
const $67f07001968fe110$export$75f2fbd33e76028e = 'global-settings-system-export';
const $67f07001968fe110$export$ca57c3dfefb2c826 = 'global-settings-system-import-cloud';
const $67f07001968fe110$export$8f2e6f133c022a59 = 'global-settings-system-import-external';
const $67f07001968fe110$export$bcd741cf5a35ece8 = 'global-settings-system-import-csv';
const $67f07001968fe110$export$bfd8ab4625d5c275 = 'global-settings-system-import-json';
const $67f07001968fe110$export$750a33c4058af733 = 'global-settings-system-import-trello';
const $67f07001968fe110$export$1b66c7594340363f = 'global-settings-system-collectors';
const $67f07001968fe110$export$fe2fa966509db649 = 'global-settings-system-delete-mail-handler';
const $67f07001968fe110$export$373b97e8d136f558 = 'global-settings-system-mail-incoming';
const $67f07001968fe110$export$64909bb6f2181592 = 'global-settings-system-mail-outgoing';
const $67f07001968fe110$export$53d6ade2eaa2ae84 = 'global-settings-system-mail-send';
const $67f07001968fe110$export$e49d7a1ddf301d09 = 'global-settings-system-permissions';
const $67f07001968fe110$export$9469cfde1d14fcac = 'global-settings-system-roles-view';
const $67f07001968fe110$export$be2e231547dca6dd = 'global-settings-system-roles-actors';
const $67f07001968fe110$export$ad6f28bbfe57d0a0 = 'global-settings-system-roles-actors-groups';
const $67f07001968fe110$export$2fb73d5c1c0e7186 = 'global-settings-system-roles-actors-users';
const $67f07001968fe110$export$46b4f43d6ece38fc = 'global-settings-system-roles-delete';
const $67f07001968fe110$export$49d1c20d84d46735 = 'global-settings-system-roles-edit';
const $67f07001968fe110$export$265062715b11a1ef = 'global-settings-system-roles-usage';
const $67f07001968fe110$export$e9f5eae9444c9b46 = 'global-settings-system-shared-filters';
const $67f07001968fe110$export$e19bf9459d6eba56 = 'global-settings-system-auditing';
const $67f07001968fe110$export$40097704c31872d8 = 'global-settings-system-ui-announcement-banner';
const $67f07001968fe110$export$dcdf0405aa7e2078 = 'global-settings-system-ui-dashboard-edit';
const $67f07001968fe110$export$fb75113636566d39 = 'global-settings-system-look';
const $67f07001968fe110$export$e27baa0c7747e67f = 'global-settings-system-ui-default-user-preferences-apply';
const $67f07001968fe110$export$40d189100899f572 = 'global-settings-system-default-settings';
const $67f07001968fe110$export$341933b279728599 = $67f07001968fe110$export$f8cea29bebf098c;
const $67f07001968fe110$export$ae4b815061537207 = `${$67f07001968fe110$export$f8cea29bebf098c}-customer-notifications`;
const $67f07001968fe110$export$5cd0dd5a6be6aa2b = `${$67f07001968fe110$export$f8cea29bebf098c}-email`;
const $67f07001968fe110$export$bee46016693b19dc = `${$67f07001968fe110$export$f8cea29bebf098c}-kb`;
const $67f07001968fe110$export$c39a25878c902e0a = `${$67f07001968fe110$export$f8cea29bebf098c}-unassigned-ticket-types-config`;
const $67f07001968fe110$export$6eaa6ce8101f6468 = `${$67f07001968fe110$export$f8cea29bebf098c}-unassigned-ticket-type-fields`;
const $67f07001968fe110$export$2e90ab5aa3463c0d = `${$67f07001968fe110$export$f8cea29bebf098c}-web-portal`;
const $67f07001968fe110$export$d70320ae3b4d9e43 = 'home-onboarding-redirect';
const $67f07001968fe110$export$b2b57cde1fa39bf5 = 'home-redirect';
const $67f07001968fe110$export$e8e3b3a04b70a016 = 'issue';
const $67f07001968fe110$export$1a3116351e4f3550 = 'issue-create-embed';
const $67f07001968fe110$export$6e2629d41c380b47 = 'issue-embed';
const $67f07001968fe110$export$ced38e55e6d33a4e = 'jira-search';
const $67f07001968fe110$export$d61d16755cb40ff3 = 'knowledge-hub-all-articles';
const $67f07001968fe110$export$bb6392f1b2e80781 = 'kb-article-embed-editor';
const $67f07001968fe110$export$6fd25e722e91a0d8 = 'knowledge-hub-article-in-category';
const $67f07001968fe110$export$18f32f825e7a5a6f = 'knowledge-hub-browse-all-articles';
const $67f07001968fe110$export$b17f22f274f4cd5e = 'knowledge-hub-browse-all-categories';
const $67f07001968fe110$export$285854ec33f7cc = 'knowledge-hub-browse-view-article';
const $67f07001968fe110$export$77cf9c44bbdaa05b = 'knowledge-hub-category';
const $67f07001968fe110$export$d6f1b92110a16f2a = 'knowledge-hub-category-page';
const $67f07001968fe110$export$fea47b97c6086336 = 'knowledge-hub-drafts';
const $67f07001968fe110$export$264d0a2b60d052cd = 'knowledge-hub-suggested-topics';
const $67f07001968fe110$export$991ba0c465b48539 = 'knowledge-hub-landing';
const $67f07001968fe110$export$904b472d57dee40d = 'knowledge-hub-search';
const $67f07001968fe110$export$bbe98dfa7f6a1e4a = 'knowledge-hub-search-articles';
const $67f07001968fe110$export$8cfdaccf43a32440 = 'knowledge-hub-setup';
const $67f07001968fe110$export$37bd400c00057d64 = 'legacy-all-reports';
const $67f07001968fe110$export$eb66bd587b5f093d = 'legacy-backlog';
const $67f07001968fe110$export$521baa72494c2a67 = 'legacy-board';
const $67f07001968fe110$export$ca255c93be51d5bc = 'legacy-connect-general';
const $67f07001968fe110$export$51e45f736a60769b = 'legacy-connect-project';
const $67f07001968fe110$export$2da88c0583f7fff0 = 'legacy-core-reports';
const $67f07001968fe110$export$e64c3c8f45d7eb28 = 'legacy-custom-report';
const $67f07001968fe110$export$5475ba822739444a = 'legacy-fallback';
const $67f07001968fe110$export$8483f5c57513e386 = 'legacy-gin';
const $67f07001968fe110$export$93c4d1960660bdb3 = 'legacy-gin-issue';
const $67f07001968fe110$export$a5421dcc88027406 = 'legacy-gin-quicksearch';
const $67f07001968fe110$export$81d5ef2e5cb06446 = 'legacy-gin-subscriptions';
const $67f07001968fe110$export$bf4001a5c23bef67 = 'legacy-issue';
const $67f07001968fe110$export$77f5621cd10b53c5 = 'legacy-jsd-customers';
const $67f07001968fe110$export$93a199a38574778b = 'legacy-jsd-customer-permissions';
const $67f07001968fe110$export$41008c2b014795bf = 'legacy-jsd-getting-started';
const $67f07001968fe110$export$3001841111579cf2 = 'legacy-jsd-jira-automation';
const $67f07001968fe110$export$28dc2fac9c08502e = 'legacy-jsd-knowledge';
const $67f07001968fe110$export$4487dfcd6dce7088 = 'legacy-jsd-queues';
const $67f07001968fe110$export$c344587fa7092e8c = 'legacy-jsd-queues-manage';
const $67f07001968fe110$export$3fbd487079a23c0f = 'legacy-jsd-reports';
const $67f07001968fe110$export$d6822df31c37b21a = 'legacy-jsd-reports-custom';
const $67f07001968fe110$export$d39bcac6fced7707 = 'legacy-jsd-settings-fallback';
const $67f07001968fe110$export$da975f212e8a3e43 = 'legacy-jsd-settings-language';
const $67f07001968fe110$export$6e6feddeb62a0825 = 'legacy-jsd-settings-language-pages';
const $67f07001968fe110$export$d3822e148f92bddb = 'legacy-jsd-settings-portal-pages';
const $67f07001968fe110$export$d7df906c2ffbeab4 = 'legacy-jsd-widgets';
const $67f07001968fe110$export$c71836085985a7d3 = 'legacy-pin';
const $67f07001968fe110$export$a17a19a9de903839 = 'legacy-project-releases';
const $67f07001968fe110$export$e66c1e847a52ebb5 = 'legacy-project-releases-bamboo';
const $67f07001968fe110$export$f0254c80025ed0fc = 'legacy-project-releases-note';
const $67f07001968fe110$export$1d4a64220d5b474d = 'legacy-project-releases-note-config';
const $67f07001968fe110$export$8af215d394bc18c1 = 'legacy-project-settings-collectors';
const $67f07001968fe110$export$b6b536a795b08b39 = 'legacy-project-settings-collectors-add';
const $67f07001968fe110$export$59cde094247fca1a = 'legacy-project-settings-collectors-help';
const $67f07001968fe110$export$d27bf19e22921164 = 'legacy-project-settings-collectors-view';
const $67f07001968fe110$export$3467807847c0a87d = 'legacy-project-settings-config';
const $67f07001968fe110$export$1996eeee6a067f1c = 'project-settings-classic-data-classifications';
const $67f07001968fe110$export$ec7cb9394e8994c9 = 'legacy-project-settings-delete';
const $67f07001968fe110$export$f01730982626c4af = 'legacy-project-settings-dev';
const $67f07001968fe110$export$9d1758ddc1563e90 = 'legacy-project-settings-edit';
const $67f07001968fe110$export$ecff223feb9d08be = 'legacy-project-settings-fields';
const $67f07001968fe110$export$487bc26cddb34312 = 'legacy-project-settings-fields-associate';
const $67f07001968fe110$export$118290072826cd87 = 'legacy-project-settings-issue-layout';
const $67f07001968fe110$export$e5994b7b1acebe82 = 'legacy-project-settings-issue-security';
const $67f07001968fe110$export$84b0e53f785e02cf = 'legacy-project-settings-issue-security-associate';
const $67f07001968fe110$export$d58992a667105ce8 = 'legacy-project-settings-issue-types';
const $67f07001968fe110$export$bb1cea2d23743f65 = 'legacy-project-settings-issue-types-associate';
const $67f07001968fe110$export$76dac5f55ab3705e = 'legacy-project-settings-notifications';
const $67f07001968fe110$export$a7c4adb03bc6e997 = 'legacy-project-settings-notifications-associate';
const $67f07001968fe110$export$2dc565d0b2334780 = 'legacy-project-settings-opsgenie';
const $67f07001968fe110$export$28687a1181a7676f = 'legacy-project-settings-people';
const $67f07001968fe110$export$2e74a7026073fa54 = 'legacy-project-settings-permissions';
const $67f07001968fe110$export$58fdfc78d176c564 = 'legacy-project-settings-permissions-associate';
const $67f07001968fe110$export$cb8548f16119b181 = 'legacy-project-settings-screens';
const $67f07001968fe110$export$66e3f6af203a567f = 'legacy-project-settings-screens-associate';
const $67f07001968fe110$export$658e7e21f1c7b69b = 'legacy-project-settings-summary';
const $67f07001968fe110$export$1fa628a4527d424c = 'legacy-project-settings-workflows';
const $67f07001968fe110$export$c2989c5c00f9f64b = 'legacy-project-settings-workflows-associate';
const $67f07001968fe110$export$2d21e5416485b195 = 'legacy-redirect';
const $67f07001968fe110$export$e514491aa85dd54a = 'legacy-reports-average-age-report';
const $67f07001968fe110$export$d9662297242bfcb5 = 'legacy-reports-configure';
const $67f07001968fe110$export$2a53516b15393945 = 'legacy-reports-created-vs-resolved-report';
const $67f07001968fe110$export$62e00190aa938a43 = 'legacy-reports-developer-workload-report';
const $67f07001968fe110$export$22a3924a6eab79ab = 'legacy-reports-pie-report';
const $67f07001968fe110$export$677cf3d89d18bb74 = 'legacy-reports-recently-created-report';
const $67f07001968fe110$export$7eef86163449ad98 = 'legacy-reports-resolution-time-report';
const $67f07001968fe110$export$8f56061e1403fa5a = 'legacy-reports-single-level-group-by-report';
const $67f07001968fe110$export$adeb429de8df1e02 = 'legacy-reports-time-since-report';
const $67f07001968fe110$export$931d6222073b5708 = 'legacy-reports-time-tracking-report';
const $67f07001968fe110$export$2106f1ac8ba807e1 = 'legacy-reports-version-workload-report';
const $67f07001968fe110$export$36678521a86f620b = 'legacy-reports-workload-pie-report';
const $67f07001968fe110$export$55248356780fc584 = 'login-embed';
const $67f07001968fe110$export$cd84c5a333c8d16a = 'global-settings-addons-emcee';
const $67f07001968fe110$export$624af6f61b05f55 = 'addons-emcee-public';
const $67f07001968fe110$export$2ed9525182145b82 = 'marketplace-app-requests';
const $67f07001968fe110$export$7fb2b42fc4e7df8b = 'marketplace-index';
const $67f07001968fe110$export$fa962db82ae571b2 = 'global-settings-addons-upm';
const $67f07001968fe110$export$e145bf76b1aef705 = 'marketplace-promotions';
const $67f07001968fe110$export$8febbfb647e4c8b9 = 'notification-logs';
const $67f07001968fe110$export$4b34f3d336f4ccd2 = 'opsgenie-schedule';
const $67f07001968fe110$export$a979a5c1f5e3631c = 'people-index';
const $67f07001968fe110$export$ffcbf91dfadffd0 = 'personal-settings';
const $67f07001968fe110$export$1807a39cc63b856c = 'personal-settings-general';
const $67f07001968fe110$export$2be8d3c6fedd5276 = 'personal-settings-notifications';
const $67f07001968fe110$export$6268da7263eb670d = 'personal-settings-ops-notifications';
const $67f07001968fe110$export$93bd4a896a0fc581 = 'plans-directory';
const $67f07001968fe110$export$2b9b1bfb538ab810 = 'project-settings-playbooks-edit';
const $67f07001968fe110$export$d1217085321b2648 = 'project-settings-playbooks-list';
const $67f07001968fe110$export$39624171b7c8a10a = 'polaris-collections';
const $67f07001968fe110$export$1654cd6813e90e6b = 'polaris-ideas';
const $67f07001968fe110$export$33059cd02df2febd = 'polaris-insights';
const $67f07001968fe110$export$1d746ff2bc48ceb4 = 'polaris-onboarding';
const $67f07001968fe110$export$145c578104a45fd2 = 'polaris-plays';
const $67f07001968fe110$export$a51df1bc877c58e5 = 'polaris-rooms';
const $67f07001968fe110$export$45208fff8de46880 = 'polaris-settings-access';
const $67f07001968fe110$export$c710a35d40378fa5 = 'polaris-settings-global-fields';
const $67f07001968fe110$export$15d6b93ff5273ce3 = 'polaris-unlicensed';
const $67f07001968fe110$export$e26f2863c7ccd504 = 'products-jsm-authentication-settings';
const $67f07001968fe110$export$496da9aa0fe819ff = 'products-jsm-chatops-and-videos-tools';
const $67f07001968fe110$export$f7bbc23b5f8e2d3b = 'products-jsm-compliance';
const $67f07001968fe110$export$53ce69fb34f6d286 = 'products-jsm-configuration';
const $67f07001968fe110$export$b6e861786143eb1b = 'products-jsm-customer-access';
const $67f07001968fe110$export$f7e3d3b413c017e1 = 'products-jsm-email-requests';
const $67f07001968fe110$export$b84d34b8175abde5 = 'products-jsm-feature-usage';
const $67f07001968fe110$export$50e4e3e5231fb74f = 'products-jsm-global-ops-reports';
const $67f07001968fe110$export$39d913ae557ba8f3 = 'products-jsm-incident-management-tools';
const $67f07001968fe110$export$a2d9bcceac584c93 = 'products-jsm-kb-permissions';
const $67f07001968fe110$export$eb2e5f1608ec8b32 = 'products-jsm-organizations';
const $67f07001968fe110$export$9ac90b948c53bf58 = 'products-jsw-configuration';
const $67f07001968fe110$export$bb5665894498893f = 'products-jsw-storage-management';
const $67f07001968fe110$export$fc61479fdfdd263a = 'classic-business-proforma-export';
const $67f07001968fe110$export$5ae82b891e42770e = 'servicedesk-proforma-export';
const $67f07001968fe110$export$8dcc46e162f2235b = 'software-proforma-export';
const $67f07001968fe110$export$a934caa57ac0ac0b = 'classic-business-proforma-issue-forms-direct';
const $67f07001968fe110$export$25a4e6c77f91c259 = 'servicedesk-proforma-issue-forms-direct';
const $67f07001968fe110$export$2a9a9bab313fd713 = 'software-proforma-issue-forms-direct';
const $67f07001968fe110$export$82ad2da638fc34d8 = 'classic-business-proforma-issue-forms-direct-embed';
const $67f07001968fe110$export$ff67cffdbd881a41 = 'servicedesk-proforma-issue-forms-direct-embed';
const $67f07001968fe110$export$c41c7d73df3fc08c = 'software-proforma-issue-forms-direct-embed';
const $67f07001968fe110$export$65f234e4799edddc = 'classic-business-proforma-issue-forms-general';
const $67f07001968fe110$export$215ea4e7405fa88c = 'servicedesk-proforma-issue-forms-general';
const $67f07001968fe110$export$927b1972180d9cc4 = 'software-proforma-issue-forms-general';
const $67f07001968fe110$export$ff1365ce4d652337 = 'projects-directory';
const $67f07001968fe110$export$79b30013cbfdee04 = 'projects-directory-legacy-path-spa';
const $67f07001968fe110$export$33c2dcc7c7abc45e = 'projects-directory-manage';
const $67f07001968fe110$export$a6ef20aa08a533b1 = 'projects-redirect';
const $67f07001968fe110$export$5908e15483da8a45 = 'project-components';
const $67f07001968fe110$export$a3812f6f4e60d897 = 'project-directory-redirect';
const $67f07001968fe110$export$3c8c119f40a061a9 = 'issue-navigator';
const $67f07001968fe110$export$47e034646abefdb2 = 'issue-navigator-classic';
const $67f07001968fe110$export$f36f4cf8b17f250f = 'issue-navigator-core';
const $67f07001968fe110$export$841e880a0d425b3e = 'project-not-found';
const $67f07001968fe110$export$1fde4a6e7df24a97 = 'project-pages';
const $67f07001968fe110$export$69335bf8b709edc7 = 'project-settings-automation';
const $67f07001968fe110$export$946b472f7559a889 = 'project-settings-components';
const $67f07001968fe110$export$373fdf6888021ed0 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-access`;
const $67f07001968fe110$export$d6a5f13a3d30923c = `${$67f07001968fe110$export$d1a70f80bb22f18a}-access-redirect`;
const $67f07001968fe110$export$adfff93b0b015409 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-approvals`;
const $67f07001968fe110$export$404de4ddea701cff = `${$67f07001968fe110$export$d1a70f80bb22f18a}-apps`;
const $67f07001968fe110$export$596e1f6f6f4997b2 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-apps-fields`;
const $67f07001968fe110$export$8da0e4cdbdd0cd0b = `${$67f07001968fe110$export$d1a70f80bb22f18a}-automation`;
const $67f07001968fe110$export$d610a17dff3a01fa = `${$67f07001968fe110$export$d1a70f80bb22f18a}-data-classifications`;
const $67f07001968fe110$export$284db5107f3db516 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-redirect`;
const $67f07001968fe110$export$fbce46826eefc586 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-details`;
const $67f07001968fe110$export$c86b29c76317ac6f = `${$67f07001968fe110$export$d1a70f80bb22f18a}-fields`;
const $67f07001968fe110$export$3160b86e1b5dc391 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-forge-apps`;
const $67f07001968fe110$export$690c0080c930fca = `${$67f07001968fe110$export$d1a70f80bb22f18a}-issuetypes`;
const $67f07001968fe110$export$171ba8c33c05c4ef = `${$67f07001968fe110$export$d1a70f80bb22f18a}-issuetypes-workflow`;
const $67f07001968fe110$export$e2f2c23286c3255c = `${$67f07001968fe110$export$d1a70f80bb22f18a}-notifications`;
const $67f07001968fe110$export$5a262d40e10207a1 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-notifications-issue-logs`;
const $67f07001968fe110$export$ab790cb87175797e = `${$67f07001968fe110$export$d1a70f80bb22f18a}-notifications-notification-email`;
const $67f07001968fe110$export$db780b39656c673a = `${$67f07001968fe110$export$d1a70f80bb22f18a}-proforma-jira-form-builder`;
const $67f07001968fe110$export$a77cb4dafc511d3 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-proforma-project-forms`;
const $67f07001968fe110$export$253fd82874264ee4 = `${$67f07001968fe110$export$86509a1baabd62ee}-forge-apps`;
const $67f07001968fe110$export$eaf9ab4ec0c25813 = `${$67f07001968fe110$export$86509a1baabd62ee}-apps-forge`;
const $67f07001968fe110$export$574bcdf6b73fcf1f = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-apps-fields`;
const $67f07001968fe110$export$a14853dfff8da872 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-chat`;
const $67f07001968fe110$export$ba8fd0e6db8d3e08 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-customer-notifications`;
const $67f07001968fe110$export$1c74da1e52e6d212 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-customer-permissions`;
const $67f07001968fe110$export$d416059b17fe7d4e = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-email`;
const $67f07001968fe110$export$d5a3a037d2760bb7 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-widget`;
const $67f07001968fe110$export$eb187d42a7448d45 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-internal-notifications-nextGen`;
const $67f07001968fe110$export$688de32d31fc70f5 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-details`;
const $67f07001968fe110$export$13d770f8814d480a = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-forge-apps`;
const $67f07001968fe110$export$3a628f9376166ffb = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-itsm-ticket-types-config`;
const $67f07001968fe110$export$649dafa225625f30 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-itsm-ticket-type-fields`;
const $67f07001968fe110$export$dbfe76dd37018b2 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-notifications`;
const $67f07001968fe110$export$20db7bb9d1bd8b38 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-notifications-notification-email`;
const $67f07001968fe110$export$a1fa8e6e125780ae = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-notification-email`;
const $67f07001968fe110$export$fc6b949fd2bc782d = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-portal-settings`;
const $67f07001968fe110$export$c940f866ac7760a0 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-ticket-types-config`;
const $67f07001968fe110$export$184d4979f6f9fe7e = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-ticket-type-fields`;
const $67f07001968fe110$export$959f50de166cc45e = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-unassigned-ticket-types-config`;
const $67f07001968fe110$export$b13b8c8bb4e30a75 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-unassigned-ticket-type-fields`;
const $67f07001968fe110$export$40d6fc2b9a4f09d2 = 'project-settings-software-access';
const $67f07001968fe110$export$cc1af211e3feda50 = `${$67f07001968fe110$export$86509a1baabd62ee}-apps-fields`;
const $67f07001968fe110$export$3873539001f5aed7 = 'project-settings-software-automation';
const $67f07001968fe110$export$89fcbafce559080b = 'project-settings-software-boards-card';
const $67f07001968fe110$export$c3f05da9e4e13249 = 'project-settings-software-boards-csm';
const $67f07001968fe110$export$619694ab37142384 = 'project-settings-software-boards-custom-filters';
const $67f07001968fe110$export$cb89b516b9cf418b = 'project-settings-software-boards-details';
const $67f07001968fe110$export$50680f54e95bb859 = 'project-settings-software-boards-features';
const $67f07001968fe110$export$194c2b4da7e38757 = 'project-settings-software-boards-insights';
const $67f07001968fe110$export$962d838817f090f8 = 'project-settings-software-boards-redirect';
const $67f07001968fe110$export$eacbdb340a470309 = 'project-settings-software-boards-roadmap';
const $67f07001968fe110$export$6a7782d87a21425d = 'project-settings-software-boards-swimlanes';
const $67f07001968fe110$export$c2f56336162e799e = 'project-settings-software-boards-timeline';
const $67f07001968fe110$export$ba419378ad70624e = 'project-settings-software-data-classifications';
const $67f07001968fe110$export$62f38c589a73d386 = 'project-settings-software-details';
const $67f07001968fe110$export$77c8066c0822f152 = `${$67f07001968fe110$export$86509a1baabd62ee}-fields`;
const $67f07001968fe110$export$90900ebfa6f48861 = 'project-settings-software-next-gen-features';
const $67f07001968fe110$export$93ff02c205edd1a8 = 'project-settings-software-issuetypes';
const $67f07001968fe110$export$db7f5d93be70ee30 = `${$67f07001968fe110$export$86509a1baabd62ee}-notifications`;
const $67f07001968fe110$export$432229516b7f82da = `${$67f07001968fe110$export$86509a1baabd62ee}-notifications-issue-logs`;
const $67f07001968fe110$export$8f554d4ef9f084c0 = 'project-settings-software-notifications-notification-email';
const $67f07001968fe110$export$6b2b99b0055772a3 = `${$67f07001968fe110$export$86509a1baabd62ee}-link-opsgenie`;
const $67f07001968fe110$export$83c7a51057be6264 = `${$67f07001968fe110$export$86509a1baabd62ee}-toolchain-team-managed`;
const $67f07001968fe110$export$46706d786aab3829 = 'project-settings-versions';
const $67f07001968fe110$export$b690025ef7e3cf6c = 'project-versions';
const $67f07001968fe110$export$ea48cc6bf1183d11 = 'rapidboard';
const $67f07001968fe110$export$930e4881302bbd54 = 'rapidboard-backlog';
const $67f07001968fe110$export$375801b708576466 = 'rapidboard-backlog-embed';
const $67f07001968fe110$export$5b1e8463bd590143 = 'rapidboard-board';
const $67f07001968fe110$export$1606662a398a24be = 'rapidboard-board-embed';
const $67f07001968fe110$export$83a890b48b63829a = 'rapidboard-board-pretty-url-redirect';
const $67f07001968fe110$export$c5b19a37e49ceb28 = 'rapidboard-last-visited-project-redirect';
const $67f07001968fe110$export$c46680afe70295f3 = 'rapidboard-report';
const $67f07001968fe110$export$831fc7eba98b58c9 = 'rapidboard-uif-backlog';
const $67f07001968fe110$export$4061c0c586f3b7c8 = 'rapidboard-user-backlog';
const $67f07001968fe110$export$99e0abd8ba1de289 = 'rapidboard-user-board';
const $67f07001968fe110$export$cd96a6a0cc4831ab = 'rapidboard-user-report';
const $67f07001968fe110$export$db1b3d2fee80859 = 'servicedesk-atlassian-analytics';
const $67f07001968fe110$export$b0f3f3214ab1b150 = 'servicedesk-project-summary';
const $67f07001968fe110$export$fb4e3ee7e7c21e9f = 'servicedesk-boards';
const $67f07001968fe110$export$8c8f03e75b6708ac = 'servicedesk-calendar';
const $67f07001968fe110$export$2e93790099768be5 = 'servicedesk-calendar-eap';
const $67f07001968fe110$export$3c3d8caf61c9aa0c = 'servicedesk-change-calendar';
const $67f07001968fe110$export$f9cc808094ce0ddd = 'servicedesk-cmdb-assets';
const $67f07001968fe110$export$9bde4a0b155f2972 = 'servicedesk-cmdb-configure';
const $67f07001968fe110$export$a52f5ffbbe135078 = 'servicedesk-cmdb-object';
const $67f07001968fe110$export$e6773bf0fbccdb9c = 'servicedesk-cmdb-object-schema';
const $67f07001968fe110$export$8e3dd8487a7b65bd = 'servicedesk-cmdb-object-schema-configuration';
const $67f07001968fe110$export$258b44fcc29a5961 = 'servicedesk-cmdb-object-type-configuration';
const $67f07001968fe110$export$ea1146ebce07be6d = 'servicedesk-cmdb-assets-reports';
const $67f07001968fe110$export$53731240ce2d3b76 = 'servicedesk-cmdb-assets-reports-default-redirect';
const $67f07001968fe110$export$956eb40834ddee22 = 'servicedesk-cmdb-assets-reports-unsubscribe';
const $67f07001968fe110$export$9057470ebf41169 = 'servicedesk-cmdb-manage-object-schemas';
const $67f07001968fe110$export$c42e107c5275b36 = 'servicedesk-cmdb-insight';
const $67f07001968fe110$export$3e7c6a54a9d2267a = 'servicedesk-cmdb-configure';
const $67f07001968fe110$export$c3e2697b35a149c4 = 'servicedesk-cmdb-landing-page';
const $67f07001968fe110$export$288c7dd61dd0c291 = 'servicedesk-cmdb-object';
const $67f07001968fe110$export$37161a981d69c891 = 'servicedesk-cmdb-object-schema';
const $67f07001968fe110$export$cfe61aa92a4d585d = 'servicedesk-cmdb-object-schema-configuration';
const $67f07001968fe110$export$9ed512ab4c81669c = 'servicedesk-cmdb-object-type-configuration';
const $67f07001968fe110$export$37a9bdd8513f462d = 'servicedesk-connect-project';
const $67f07001968fe110$export$f01162415f3a2ee3 = 'servicedesk-create-project';
const $67f07001968fe110$export$860dd13b1e836ed8 = 'servicedesk-customers-v2';
const $67f07001968fe110$export$5eaf1dce55090ff3 = 'servicedesk-customer-details';
const $67f07001968fe110$export$1fe309e7cdbd1c1 = 'servicedesk-customer-service-escalations';
const $67f07001968fe110$export$fcd9750494ff0236 = 'servicedesk-customer-service-products';
const $67f07001968fe110$export$ad856b38e93b93b2 = 'servicedesk-early-access-itsm';
const $67f07001968fe110$export$a833209ca71d2e56 = 'servicedesk-getting-started-page';
const $67f07001968fe110$export$829d1776460a6ad3 = 'servicedesk-incidents';
const $67f07001968fe110$export$d30ab2da08d8b7b9 = 'servicedesk-index';
const $67f07001968fe110$export$3c71889849aeaa08 = 'servicedesk-issue';
const $67f07001968fe110$export$354bf2df81f6ffb0 = 'servicedesk-issues';
const $67f07001968fe110$export$f8880b461acd270d = 'servicedesk-itsm-sample-space';
const $67f07001968fe110$export$876055c0ede2f8df = 'servicedesk-automation';
const $67f07001968fe110$export$bf493c66e34711c8 = 'servicedesk-kb-requests-reports';
const $67f07001968fe110$export$212f6e2c7c2a53bb = 'servicedesk-kb-requests-reports-time-scale-issue';
const $67f07001968fe110$export$7c28c6e8d8a6545 = 'servicedesk-kb-requests-reports-time-scale';
const $67f07001968fe110$export$8d55b6ef2cd92f8c = 'servicedesk-oncall-schedule';
const $67f07001968fe110$export$f7fbe9a4717b7a50 = 'servicedesk-organizations';
const $67f07001968fe110$export$8c800f176d079d28 = 'servicedesk-organization-details';
const $67f07001968fe110$export$1c5fbcbfc0923176 = 'servicedesk-organization_v2';
const $67f07001968fe110$export$59644e5d8d69a016 = 'servicedesk-practice-custom-and-issue';
const $67f07001968fe110$export$c7074ebe0ca83f98 = 'servicedesk-practice-edit';
const $67f07001968fe110$export$2b4737953287a354 = 'servicedesk-practice-issue';
const $67f07001968fe110$export$e7a8d6d534c5e2fe = 'servicedesk-practice-landing';
const $67f07001968fe110$export$5dcba309e2bfa88b = 'servicedesk-practice-manage-view';
const $67f07001968fe110$export$2d961b0101f8733e = 'servicedesk-practice-new';
const $67f07001968fe110$export$195fe2558f1a8591 = 'servicedesk-project-conversion';
const $67f07001968fe110$export$1b3cf68be370a45b = 'servicedesk-queues-addon';
const $67f07001968fe110$export$45c35381e5da2232 = 'servicedesk-queues-custom-and-issue';
const $67f07001968fe110$export$d479ba53b9bf65a = 'servicedesk-queues-edit';
const $67f07001968fe110$export$ccd12890649c59cc = 'servicedesk-queues-issue';
const $67f07001968fe110$export$8c84064031188e80 = 'servicedesk-queues-landing';
const $67f07001968fe110$export$46c6fef035fbe8ba = 'servicedesk-queues-manage-view';
const $67f07001968fe110$export$6fb23ec5a12d5c24 = 'servicedesk-queues-new';
const $67f07001968fe110$export$156b2dfbd87d576f = 'servicedesk-redirect';
const $67f07001968fe110$export$6961f1ed0407cb26 = 'servicedesk-reports';
const $67f07001968fe110$export$ba284efd679bf637 = 'servicedesk-reports-custom';
const $67f07001968fe110$export$e48a3df597407767 = 'servicedesk-reports-custom-create';
const $67f07001968fe110$export$c73718d4a6efea1d = 'servicedesk-reports-custom-edit';
const $67f07001968fe110$export$ed454783ba1bacb9 = 'servicedesk-reports-custom-time-scale-issue';
const $67f07001968fe110$export$48f6285d4729ca9d = 'servicedesk-reports-custom-time-scale';
const $67f07001968fe110$export$8066418cead2d2ef = 'servicedesk-reports-satisfaction';
const $67f07001968fe110$export$b3db7857ac710a89 = 'servicedesk-reports-satisfaction-time-scale-issue';
const $67f07001968fe110$export$d574810e3edad044 = 'servicedesk-reports-satisfaction-time-scale';
const $67f07001968fe110$export$be4b2ffade787316 = 'servicedesk-reports-summary';
const $67f07001968fe110$export$3caf79b5f4be02d7 = 'servicedesk-reports-type';
const $67f07001968fe110$export$29bc361328055683 = 'servicedesk-reports-workload';
const $67f07001968fe110$export$a4a5a333fe874d97 = 'servicedesk-services';
const $67f07001968fe110$export$2193b681ac1ae132 = 'servicedesk-services-new';
const $67f07001968fe110$export$f1bfd5b3918619a9 = 'servicedesk-services-without-project';
const $67f07001968fe110$export$a4c4f7898d6b914a = 'servicedesk-service-details';
const $67f07001968fe110$export$6cffae90b9277bb = 'servicedesk-service-details-new';
const $67f07001968fe110$export$17e76ebd53424ed5 = 'servicedesk-service-details-without-project';
const $67f07001968fe110$export$b1329dc26a81a277 = 'servicedesk-service-modal-edit';
const $67f07001968fe110$export$e1cba0bfe330f5c = 'servicedesk-service-modal-new';
const $67f07001968fe110$export$8e68c55c334de101 = 'servicedesk-sla-settings';
const $67f07001968fe110$export$5cb7cfba189a0240 = 'service-hub-services';
const $67f07001968fe110$export$d28aab4a6d6f1d0d = 'service-hub-service-details';
const $67f07001968fe110$export$1cf56e2d6c4edb35 = 'global-automation';
const $67f07001968fe110$export$27c1770584d7e3fe = 'global-settings-issues-cmdb-field-config';
const $67f07001968fe110$export$22e0ebdea08537f7 = 'admin-oauth-credentials';
const $67f07001968fe110$export$4db732436e4edfaf = 'recommendations';
const $67f07001968fe110$export$e832418dbed0717e = 'view-custom-fields';
const $67f07001968fe110$export$ee09be798f0e4471 = 'software-advanced-roadmaps';
const $67f07001968fe110$export$653bf90ae3578f21 = 'software-advanced-roadmaps-getting-started-redirect';
const $67f07001968fe110$export$9da4125a0c62444d = 'software-advanced-roadmaps-redirect';
const $67f07001968fe110$export$fbcc0fd9b402bb12 = 'software-advanced-roadmaps-setup';
const $67f07001968fe110$export$e74fe5bd41e23fbd = `${$67f07001968fe110$export$3fd002e197e83a30}-dependencies`;
const $67f07001968fe110$export$1a93e63ddbe4aa06 = `${$67f07001968fe110$export$3fd002e197e83a30}-dependencies-redirect`;
const $67f07001968fe110$export$3b6dbbe49882589d = `${$67f07001968fe110$export$3fd002e197e83a30}-financial-year`;
const $67f07001968fe110$export$eb01394789016fd4 = `${$67f07001968fe110$export$3fd002e197e83a30}-loading-limits`;
const $67f07001968fe110$export$f17f4523583fa8e5 = `${$67f07001968fe110$export$3fd002e197e83a30}-loading-limits-redirect`;
const $67f07001968fe110$export$eaa4d6eec75a6778 = `${$67f07001968fe110$export$3fd002e197e83a30}-permissions`;
const $67f07001968fe110$export$dcc96e4abbdc0d39 = `${$67f07001968fe110$export$3fd002e197e83a30}-permissions-redirect`;
const $67f07001968fe110$export$9eaf39ba5a56c72a = 'software-backlog';
const $67f07001968fe110$export$495be3320b67814a = 'software-backlog-embed';
const $67f07001968fe110$export$25752eb5bb5e3d32 = 'software-boards';
const $67f07001968fe110$export$f116716aedb35e10 = 'software-boards-embed';
const $67f07001968fe110$export$36fffb6b49d9f31d = 'software-calendar';
const $67f07001968fe110$export$a6d07be4ff318f84 = 'software-calendar-classic';
const $67f07001968fe110$export$a9a43f1114df1ad9 = 'software-calendar-classic-embed';
const $67f07001968fe110$export$3a4c7a521a900b4d = 'software-calendar-embed';
const $67f07001968fe110$export$9dcf51a9040a4fd6 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-proforma-issue-forms-direct`;
const $67f07001968fe110$export$a74f9f6bd0d4fb26 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-proforma-issue-forms-direct-embed`;
const $67f07001968fe110$export$f8cb86acf6b74661 = 'software-code';
const $67f07001968fe110$export$2d3d850c64058bfb = 'software-code-classic';
const $67f07001968fe110$export$af6b51164f66908b = 'software-deployments';
const $67f07001968fe110$export$12efc96fc9c9fb34 = 'software-deployments-classic';
const $67f07001968fe110$export$6ab1901e04e623ba = 'software-form';
const $67f07001968fe110$export$bccc7d0812737c4e = 'software-form-classic';
const $67f07001968fe110$export$458fb992f2637a20 = 'software-form-builder';
const $67f07001968fe110$export$c9c9c64f68ba51e3 = 'software-form-builder-classic';
const $67f07001968fe110$export$50264cbc90a39f19 = 'software-form-submit';
const $67f07001968fe110$export$b9d0cbe0888fa72e = 'software-form-submit-classic';
const $67f07001968fe110$export$b8045610416fa8ca = 'software-goals';
const $67f07001968fe110$export$8e80136ad13099e3 = 'software-goals-classic';
const $67f07001968fe110$export$b5fe44c0bc324494 = 'software-incidents';
const $67f07001968fe110$export$7a4f52d9060a20d2 = 'software-incidents-classic';
const $67f07001968fe110$export$d6a9e4695952522e = 'software-issue-navigator';
const $67f07001968fe110$export$deab88d0814c564b = 'software-list';
const $67f07001968fe110$export$906faff110f898ef = 'software-list-classic';
const $67f07001968fe110$export$ab3f2a34a3b0db87 = 'software-list-classic-embed';
const $67f07001968fe110$export$4ed84a2011fdc400 = 'software-list-embed';
const $67f07001968fe110$export$f7b286b39bf6051b = 'software-nextgen-redirect';
const $67f07001968fe110$export$6c4337c0332c8c7f = 'software-onboarding';
const $67f07001968fe110$export$e7c78887745b2326 = 'software-onboarding-get-started';
const $67f07001968fe110$export$3805e4f07dca7584 = 'software-periscope';
const $67f07001968fe110$export$f77254983320e888 = 'software-periscope-classic';
const $67f07001968fe110$export$2e784832f1c6bb = 'software-plan-calendar';
const $67f07001968fe110$export$7f97fa79520a4c5b = 'software-plan-calendar-embed';
const $67f07001968fe110$export$9e53cdb1ac02195c = 'software-plan-dependencies';
const $67f07001968fe110$export$7a821e22be2c2f14 = 'software-plan-increment';
const $67f07001968fe110$export$ca8966ef80bfafc6 = 'software-plan-increment-embed';
const $67f07001968fe110$export$e7423156dba31a7c = 'software-plan-increments';
const $67f07001968fe110$export$cba7e383b2409c7b = 'software-plan-releases';
const $67f07001968fe110$export$d5378fb71d5242c0 = `${$67f07001968fe110$export$6f266218a6973848}-auto-scheduler`;
const $67f07001968fe110$export$4b16b72c72da8833 = `${$67f07001968fe110$export$6f266218a6973848}-custom-fields`;
const $67f07001968fe110$export$10114d78cefb1f53 = `${$67f07001968fe110$export$6f266218a6973848}-exclusion-rules`;
const $67f07001968fe110$export$92fe23ed30100817 = `${$67f07001968fe110$export$6f266218a6973848}-find-your-issue`;
const $67f07001968fe110$export$e824495554c83069 = `${$67f07001968fe110$export$6f266218a6973848}-issue-sources`;
const $67f07001968fe110$export$8df2e9efdd625a44 = `${$67f07001968fe110$export$6f266218a6973848}-permissions`;
const $67f07001968fe110$export$aeb4d3006e298033 = `${$67f07001968fe110$export$6f266218a6973848}-plan-info`;
const $67f07001968fe110$export$e15d3c40985c4b53 = `${$67f07001968fe110$export$6f266218a6973848}-program-boards`;
const $67f07001968fe110$export$1d8c84454fd2d571 = `${$67f07001968fe110$export$6f266218a6973848}-removed-issues`;
const $67f07001968fe110$export$db61a12efb59745c = `${$67f07001968fe110$export$6f266218a6973848}-saved-views`;
const $67f07001968fe110$export$2da67fb5bd6bc2ee = `${$67f07001968fe110$export$6f266218a6973848}-scenarios`;
const $67f07001968fe110$export$182e0167fd960de6 = `${$67f07001968fe110$export$6f266218a6973848}-scheduling`;
const $67f07001968fe110$export$2d9e2484ee02e7da = 'software-plan-summary';
const $67f07001968fe110$export$b7fff19fd89b617f = 'software-plan-summary-embed';
const $67f07001968fe110$export$ea23f150f64e8a4e = 'software-plan-teams';
const $67f07001968fe110$export$116338bd93f78ad0 = 'software-plan-timeline';
const $67f07001968fe110$export$c9cd65a78227cf18 = 'software-advanced-roadmaps-embed';
const $67f07001968fe110$export$7a4b4b66d7637fbb = 'software-presentation-toolkit-report';
const $67f07001968fe110$export$d75d93e5d44182cc = 'software-release-notes';
const $67f07001968fe110$export$cc3027ae3767801 = 'software-reports';
const $67f07001968fe110$export$3492ce83b8884e0e = 'software-reports-burndown';
const $67f07001968fe110$export$b4798b7e62733393 = 'software-reports-burnup';
const $67f07001968fe110$export$388685c701d6e0d3 = 'software-reports-control';
const $67f07001968fe110$export$5ff4d2d4257ea2b0 = 'software-reports-cumulative';
const $67f07001968fe110$export$fa83895c1eac55e7 = 'software-reports-cycle-time';
const $67f07001968fe110$export$5c82bb95a06a1846 = 'software-reports-cycle-time-classic';
const $67f07001968fe110$export$c725b9c7e11dd69e = 'software-reports-deployment-frequency';
const $67f07001968fe110$export$90594f89c675ba05 = 'software-reports-deployment-frequency-classic';
const $67f07001968fe110$export$ae0d999dd2bdd59b = 'software-reports-velocity';
const $67f07001968fe110$export$43bbf6935a91d277 = 'software-requests';
const $67f07001968fe110$export$92e23977438282b2 = 'software-requests-classic';
const $67f07001968fe110$export$296115eb5b7129d3 = 'software-roadmap';
const $67f07001968fe110$export$17574f41c3925d64 = 'software-roadmap-classic';
const $67f07001968fe110$export$955692fbfe35fc16 = 'software-roadmap-redirect';
const $67f07001968fe110$export$30af3a767b8ad2d8 = 'software-security';
const $67f07001968fe110$export$f47d664298c2c2f0 = 'software-security-classic';
const $67f07001968fe110$export$1714b5ad9b672bc7 = 'software-timeline';
const $67f07001968fe110$export$c9634bf15518a3a1 = 'software-timeline-classic';
const $67f07001968fe110$export$3b5eb3ea8cbeeed = 'software-version-detail';
const $67f07001968fe110$export$c29d90ae9a4b648e = 'software-version-detail-legacy-redirect';
const $67f07001968fe110$export$8f2717a951373c25 = 'software-version-detail-no-tab-path';
const $67f07001968fe110$export$831acb5098f5706d = 'system-configuration-general';
const $67f07001968fe110$export$d218cda46c433fe1 = 'system-dashboard-edit';
const $67f07001968fe110$export$61147168ac2833f9 = 'trashed-plan-direct-link';
const $67f07001968fe110$export$9fe0117c0fd486a8 = 'trash-plans-directory';
const $67f07001968fe110$export$a49474778d15635d = 'trash-projects-directory';
const $67f07001968fe110$export$af3296e54e7fb362 = 'user-segmentation';
const $67f07001968fe110$export$281f2e01ee9e4977 = 'your-work';

});

parcelRegister("kLSws", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavPlans", () => $245a320c345a7203$export$84e1a5f003939496);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $gGtKh = parcelRequire("gGtKh");

const $245a320c345a7203$var$LazyHorizontalPlansNav = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("7XewV")).then(({ HorizontalPlansNav: HorizontalPlansNav })=>HorizontalPlansNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-plans/src/ui/index.tsx"
});
const $245a320c345a7203$export$84e1a5f003939496 = ({ store: store })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-software-plans-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($245a320c345a7203$var$LazyHorizontalPlansNav, {
        store: store
    }));

});
parcelRegister("7XewV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("2k0t5")),
    $d1Cng("dsiAd"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("69IeS")
]).then(()=>parcelRequire('jwhxa'));

});
parcelRegister("1f3I0", function(module, exports) {
"use strict";

var $kmVhr = parcelRequire("kmVhr");
module.exports = $kmVhr(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("kmVhr", function(module, exports) {
"use strict";
var $ed424b6c80f23bb9$var$cachedBundles = {};
var $ed424b6c80f23bb9$var$cachedPreloads = {};
var $ed424b6c80f23bb9$var$cachedPrefetches = {};
function $ed424b6c80f23bb9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $ed424b6c80f23bb9$var$cachedPreloads;
        case 'prefetch':
            return $ed424b6c80f23bb9$var$cachedPrefetches;
        default:
            return $ed424b6c80f23bb9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $ed424b6c80f23bb9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("dWu0t", function(module, exports) {

$parcel$export(module.exports, "useHorizontalNavComponent", () => $c641efd495101387$export$205771a0e64e4c7c);

var $b3nmi = parcelRequire("b3nmi");

var $7ZZxN = parcelRequire("7ZZxN");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $4u3Wx = parcelRequire("4u3Wx");

var $6FP8W = parcelRequire("6FP8W");

var $10fdS = parcelRequire("10fdS");

var $bNe1g = parcelRequire("bNe1g");

var $ddT06 = parcelRequire("ddT06");

var $bEe6y = parcelRequire("bEe6y");

var $lB25E = parcelRequire("lB25E");

const $c641efd495101387$export$965942f8308cd740 = (0, $lB25E.createRouterSelector)((state)=>(0, $ddT06.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(state.query.config));
const $c641efd495101387$export$205771a0e64e4c7c = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: projectData } = (0, $bNe1g.useProjectContext)();
    const hasBoardSettingsPageQueryParam = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eI5EY.fg)('jira_hide_horizontal_nav_on_board_settings_pages') && $c641efd495101387$export$965942f8308cd740();
    // chromeless mode is handled in page-container package with nav4
    if (!(0, $6FP8W.getWillShowNav4)()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isChromeless] = (0, $4u3Wx.useIsChromeless)();
        if (isChromeless) return null;
    }
    if (route.navigation?.horizontal == null) return null;
    // Shared horizontal navigation routes that currently live in business projects on prod
    // but we want to remove horizontal navigation on with the navigation redesign
    if (route.navigation.horizontal === (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba)) {
        if ((0, $6FP8W.getWillShowNav4)()) return null;
        switch(projectData?.projectType){
            case 0, $7ZZxN.CORE_PROJECT:
                return 0, $b3nmi.AsyncHorizontalProjectNav;
            default:
                return null;
        }
    }
    // Board settings pages should not show the horizontal nav.
    // This is a workaround due to the fact that the software CMP board/backlog pages share the same route name
    // as the board settings pages. This code should be removed once the board settings pages have
    // their own dedicated route names.
    if (route.group === (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE) && hasBoardSettingsPageQueryParam && (0, $6FP8W.getWillShowNav4)() && (0, $1ybV0.ff)('simplified-boards-milestone-2_07hbk')) return null;
    if (route.navigation.horizontal === (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)) switch(projectData?.projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return 0, $b3nmi.AsyncHorizontalProjectNav;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if ((0, $6FP8W.getWillShowNav4)()) return 0, $bEe6y.AsyncHorizontalSoftwareProjectNav;
            return null;
        default:
            return null;
    }
    // TODO: Remove this during jira_nav4 cleanup
    if ('onlyShowHorziontalOnNav4' in route.navigation && route.navigation.onlyShowHorziontalOnNav4) return (0, $6FP8W.getWillShowNav4)() ? route.navigation.horizontal : null;
    if ('horizontalFeatureFlag' in route.navigation) switch(route.navigation.horizontalFeatureFlag){
        // Society: "Use a constant!"
        // Me: no! I was told to inline my feature flags!
        case 'jsm_views_of_work_phase_1':
            return (0, $eI5EY.fg)('jsm_views_of_work_phase_1') ? route.navigation.horizontal : null;
        default:
            {
                // a little bit of magic to ensure that we handle all feature flags defined in
                // HorizontalFeatureFlags - if the switch statement is missing a case, this line
                // will cause a compile error.
                const exhaustiveCheck = route.navigation.horizontalFeatureFlag;
                return exhaustiveCheck;
            }
    }
    return route.navigation.horizontal;
};

});
parcelRegister("4u3Wx", function(module, exports) {

$parcel$export(module.exports, "useIsChromeless", () => $958ecff90d5df897$export$c88b74884f5222ba);

var $WBLbN = parcelRequire("WBLbN");

var $53ucm = parcelRequire("53ucm");
const $958ecff90d5df897$export$c88b74884f5222ba = (0, $WBLbN.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>state.isChromeless
});

});
parcelRegister("53ucm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $775b7b0f5d2674bd$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $775b7b0f5d2674bd$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $775b7b0f5d2674bd$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $775b7b0f5d2674bd$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $775b7b0f5d2674bd$export$99e05a60cac05e86);

var $WBLbN = parcelRequire("WBLbN");

var $3roBA = parcelRequire("3roBA");
const $775b7b0f5d2674bd$export$539e68c09584883a = 240;
const $775b7b0f5d2674bd$export$b92df8810d2fcd01 = 0;
const $775b7b0f5d2674bd$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $775b7b0f5d2674bd$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $775b7b0f5d2674bd$export$b8cdfd44cddaf07 = (0, $WBLbN.createStore)({
    initialState: $775b7b0f5d2674bd$var$initialState,
    actions: $3roBA.actions,
    name: 'JiraLayoutStore'
});
const $775b7b0f5d2674bd$export$6136bc3b9858cff4 = (0, $WBLbN.createHook)($775b7b0f5d2674bd$export$b8cdfd44cddaf07, {
    selector: null
});
const $775b7b0f5d2674bd$var$detailPanelWidthStore = (0, $WBLbN.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $775b7b0f5d2674bd$export$95fd7b6da3b9bbb0 = (0, $WBLbN.createHook)($775b7b0f5d2674bd$var$detailPanelWidthStore);
const $775b7b0f5d2674bd$export$99e05a60cac05e86 = (0, $WBLbN.createActionsHook)($775b7b0f5d2674bd$var$detailPanelWidthStore);

});
parcelRegister("3roBA", function(module, exports) {

$parcel$export(module.exports, "actions", () => $7de3ed8fccc77236$export$e324594224ef24da);

var $3OanE = parcelRequire("3OanE");

var $gDr9R = parcelRequire("gDr9R");

var $aoZTG = parcelRequire("aoZTG");

var $c2xTD = parcelRequire("c2xTD");

var $f9nrb = parcelRequire("f9nrb");

var $hqpfO = parcelRequire("hqpfO");
const $7de3ed8fccc77236$export$e324594224ef24da = {
    setIsChromeless: // global
    $aoZTG.setIsChromeless,
    setIsFullscreen: $c2xTD.setIsFullscreen,
    showBanner: // banner
    $3OanE.showBanner,
    dismissCurrentBanner: $3OanE.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $f9nrb.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $hqpfO.setRightSidebarState,
    openRightSidebar: $hqpfO.openRightSidebar,
    closeRightSidebar: $hqpfO.closeRightSidebar,
    closeAllRightSidebar: $hqpfO.closeAllRightSidebar,
    closeCurrentRightSidebar: $hqpfO.closeCurrentRightSidebar,
    minimiseRightSidebar: $hqpfO.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $gDr9R.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $gDr9R.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $gDr9R.removeBottomRightCornerPortal
};

});
parcelRegister("3OanE", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $1ca96d140cb009a0$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $1ca96d140cb009a0$export$a45bccc0cc9ac424);
const $1ca96d140cb009a0$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $1ca96d140cb009a0$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($1ca96d140cb009a0$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("gDr9R", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $ce70661c3da7d088$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $ce70661c3da7d088$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $ce70661c3da7d088$export$928bf7e228ce06d2);
const $ce70661c3da7d088$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $ce70661c3da7d088$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $ce70661c3da7d088$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("aoZTG", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $1199e64f89ce3554$export$1998c4816ad37edb);
const $1199e64f89ce3554$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("c2xTD", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $440583623bc138b8$export$9c73b2f282069160);
const $440583623bc138b8$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("f9nrb", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $a9b20025b1de3529$export$3e0fd2d894ef83c8);
const $a9b20025b1de3529$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});

parcelRegister("hqpfO", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $bea3cfbec26c4bd1$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $bea3cfbec26c4bd1$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $bea3cfbec26c4bd1$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $bea3cfbec26c4bd1$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $bea3cfbec26c4bd1$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $bea3cfbec26c4bd1$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $bea3cfbec26c4bd1$export$c8dafe074328c4ca);

var $hTLlD = parcelRequire("hTLlD");
const $bea3cfbec26c4bd1$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $bea3cfbec26c4bd1$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $bea3cfbec26c4bd1$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $bea3cfbec26c4bd1$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $bea3cfbec26c4bd1$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $bea3cfbec26c4bd1$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $bea3cfbec26c4bd1$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});




parcelRegister("6FP8W", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4", () => $e5b4e2555c56df61$export$f1ce4aa22fe8768a);

var $eI5EY = parcelRequire("eI5EY");

var $3NndS = parcelRequire("3NndS");

var $7gqcr = parcelRequire("7gqcr");
const $e5b4e2555c56df61$export$f1ce4aa22fe8768a = ()=>(0, $eI5EY.fg)('jira_nav4') && ((0, $3NndS.getWillShowNav4ForDogfooding)() || (0, $7gqcr.getWillShowNav4ForEap)());

});
parcelRegister("3NndS", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4ForDogfooding", () => $9b32d569fdd7ede7$export$9ca0d92d31816d4f);

var $eI5EY = parcelRequire("eI5EY");

var $6mXXc = parcelRequire("6mXXc");

var $4w69E = parcelRequire("4w69E");
const $9b32d569fdd7ede7$export$9ca0d92d31816d4f = ()=>{
    if (!(0, $eI5EY.fg)('jira_nav4_dogfooding')) return false;
    const phase1 = (0, $eI5EY.fg)('jira_nav4_dogfooding_phase-1');
    const phase2 = (0, $eI5EY.fg)('jira_nav4_dogfooding_phase-2');
    const phase3 = !(phase1 || phase2);
    return phase3 || phase2 && !(0, $6mXXc.getIsNav4UserOptOut)() || phase1 && !(0, $6mXXc.getIsNav4UserOptOut)() && !(0, $4w69E.getIsRouteExcludedForDogfoodingPhase1)();
};

});
parcelRegister("6mXXc", function(module, exports) {

$parcel$export(module.exports, "getMetaBoolean", () => $0f9292b7433a6030$export$9683360b0ae70629);
$parcel$export(module.exports, "getIsNav4UserOptOut", () => $0f9292b7433a6030$export$3fbfe0fdf05e0f9f);

var $jqvCZ = parcelRequire("jqvCZ");

var $6rW04 = parcelRequire("6rW04");

var $73h4w = parcelRequire("73h4w");
const $0f9292b7433a6030$export$9683360b0ae70629 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((name)=>(0, $6rW04.default)(`ajs-${name}`) === 'true');
const $0f9292b7433a6030$export$7d046765d192af80 = ()=>$0f9292b7433a6030$export$9683360b0ae70629((0, $73h4w.IS_ADMIN));
const $0f9292b7433a6030$export$ba89637357392be6 = ()=>$0f9292b7433a6030$export$9683360b0ae70629((0, $73h4w.IS_NAV4_USER_OPT_IN));
const $0f9292b7433a6030$export$3fbfe0fdf05e0f9f = ()=>$0f9292b7433a6030$export$9683360b0ae70629((0, $73h4w.IS_NAV4_USER_OPT_OUT));

});
parcelRegister("73h4w", function(module, exports) {

$parcel$export(module.exports, "IS_ADMIN", () => $189e57aa9da8fba2$export$4261d5d429e288ec);
$parcel$export(module.exports, "IS_NAV4_USER_OPT_IN", () => $189e57aa9da8fba2$export$153ded4d539b820d);
$parcel$export(module.exports, "IS_NAV4_USER_OPT_OUT", () => $189e57aa9da8fba2$export$9c962957701a4fe8);
$parcel$export(module.exports, "NAV4_ROLLOUT_NONE", () => $189e57aa9da8fba2$export$3b602cac1f385c06);
const $189e57aa9da8fba2$export$4261d5d429e288ec = 'is-admin';
const $189e57aa9da8fba2$export$153ded4d539b820d = 'is-nav4-user-opt-in';
const $189e57aa9da8fba2$export$9c962957701a4fe8 = 'is-nav4-user-opt-out';
const $189e57aa9da8fba2$export$3b602cac1f385c06 = {
    stage: 'none'
};
const $189e57aa9da8fba2$export$9cd4b8dc5f7153b8 = {
    NONE: 'none',
    DOGFOODING: 'dogfooding',
    EAP: 'eap',
    BETA: 'beta',
    GA: 'ga'
};

});


parcelRegister("4w69E", function(module, exports) {

$parcel$export(module.exports, "getIsRouteExcludedForDogfoodingPhase1", () => $a835037471be3efc$export$f0abfe25b95778e3);

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");
const $a835037471be3efc$var$JPD_COLLECTIONS_OVERVIEW_REGEX = new RegExp('^/jira/polaris/roadmaps(/)*$');
const $a835037471be3efc$export$f0abfe25b95778e3 = ()=>{
    if (false) return false;
    const pathname = $a835037471be3efc$var$getPathname();
    if (!(0, $1ybV0.ff)('polaris.sidebar-v4') && (pathname.includes('/jira/polaris/') || pathname.includes('/secure/JiraProductDiscoveryEmbedded') || pathname.includes('/jira/discovery/'))) return true;
    if (pathname.includes('/jira/polaris/roadmaps')) {
        const isJpdCollectionsOverview = $a835037471be3efc$var$JPD_COLLECTIONS_OVERVIEW_REGEX.test(pathname);
        if (isJpdCollectionsOverview && (0, $eI5EY.fg)('jpd-sidebar-v4-for-roadmaps-overview')) // do not exclude collection overview route
        return false;
        // if main gate for roadmaps is disabled then exclude route
        if (!(0, $eI5EY.fg)('jpd-sidebar-v4-for-roadmaps')) return true;
    }
    return false;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $a835037471be3efc$var$getPathname = ()=>window.location.pathname;

});


parcelRegister("7gqcr", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4ForEap", () => $573057de52461800$export$393f53ae320de085);

var $eI5EY = parcelRequire("eI5EY");

var $6mXXc = parcelRequire("6mXXc");
const $573057de52461800$export$393f53ae320de085 = ()=>(0, $eI5EY.fg)('jira_nav4_eap') && !(0, $6mXXc.getIsNav4UserOptOut)();

});


parcelRegister("10fdS", function(module, exports) {

$parcel$export(module.exports, "useCurrentRoute", () => $ddc2f4c28203b504$export$c4b7ea2942f2d0e);
$parcel$export(module.exports, "useRouteByName", () => $ddc2f4c28203b504$export$d69a946e2d0a1c12);
$parcel$export(module.exports, "usePreviousRouterState", () => $ddc2f4c28203b504$export$1e5fb68306bd0b92);

var $lB25E = parcelRequire("lB25E");

var $keguF = parcelRequire("keguF");
const $ddc2f4c28203b504$export$c4b7ea2942f2d0e = (0, $lB25E.createRouterSelector)((state)=>state.route);
const $ddc2f4c28203b504$export$d69a946e2d0a1c12 = (0, $lB25E.createRouterSelector)((state, routeName)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.routes.find(({ name: name })=>name === routeName) ?? null);
const $ddc2f4c28203b504$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
        name: name,
        path: path,
        query: query,
        exact: exact
    });
const $ddc2f4c28203b504$export$1e5fb68306bd0b92 = ()=>{
    // Force updates whenever the current route changes
    (0, $lB25E.useRouter)();
    return (0, $keguF.getPreviousRouterState)();
};

});

parcelRegister("bNe1g", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $a10c8c1f49371370$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $a10c8c1f49371370$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $a10c8c1f49371370$export$a85f6b5857d2176);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ixwgj = parcelRequire("ixwgj");
const $a10c8c1f49371370$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $ixwgj.projectContextResourceWithCache), customContext);
    const updateCache = (0, $eUqFw.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $a10c8c1f49371370$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $a10c8c1f49371370$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $a10c8c1f49371370$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $a10c8c1f49371370$export$8f31c2503e1efa93();
    return children(projectContext);
};

});
parcelRegister("iZJHG", function(module, exports) {

$parcel$export(module.exports, "useResourceWithCustomRouterContext", () => $8cce526bdc89f636$export$61dad767cf446185);

var $8LJqN = parcelRequire("8LJqN");

var $eI5EY = parcelRequire("eI5EY");

var $lB25E = parcelRequire("lB25E");

var $dUsMe = parcelRequire("dUsMe");
/**
 * DUMMY_ROUTE needs to be used by default, because `route` must not be undefined, it is required/used internally by RRR, e.g. in findRouterContext() on createRouterContext() call.
 * If `route` is undefined, those will throw runtime exceptions.
 * `project-sidebar-navigation-resource/software-cmp-nav-synchronizer/index.tsx` uses dummy route as well.
 *
 * Jfyi, createProjectRouteRouterContext() function in JSW uses dummy route, with :projectKey in its path (that resource fetch function uses)
 */ const $8cce526bdc89f636$var$DUMMY_ROUTE = {
    name: 'DUMMY_ROUTE_NAME',
    path: '/projects/:projectKey/dummyroute'
};
/**
 * Reusable hook, to pass *custom context* to the React router resource
 */ const $8cce526bdc89f636$var$useResourceWithCustomRouterContextOld = (resource, customRouterContext, _ = {})=>{
    let useResourceArgCustomContext;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $8cce526bdc89f636$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) useResourceArgCustomContext = {
            routerContext: (0, $lB25E.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const resourceResponse = (0, $lB25E.useResource)(resource, useResourceArgCustomContext);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $dUsMe.useInitFetchResource)(resourceResponse, !customRouterContext);
    return resourceResponse;
};
/**
 * Allows for router resources to be to be fetched on a route that doesn't include the required router params. A custom router context can be passed to the resource to fetch the data.
 * The resource will be automatically fetched via `refresh()` when the component mounts, unless disabled via `options.autoFetch = false`. If you don't need this behaviour, use `useResource` instead.
 */ function $8cce526bdc89f636$var$useResourceWithCustomRouterContextWithOptions(resource, customRouterContext, options = {}) {
    let resourceOptions;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $8cce526bdc89f636$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
            routerContext: (0, $lB25E.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const { shouldPrefetch: shouldPrefetch } = options;
    const resourceResponse = (0, $lB25E.useResource)(resource, resourceOptions);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $dUsMe.usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
    return resourceResponse;
}
const $8cce526bdc89f636$export$61dad767cf446185 = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('fix_useinitresource_data_bug'), $8cce526bdc89f636$var$useResourceWithCustomRouterContextWithOptions, $8cce526bdc89f636$var$useResourceWithCustomRouterContextOld);

});
parcelRegister("8LJqN", function(module, exports) {

$parcel$export(module.exports, "functionWithCondition", () => $96fc75653c9b207d$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $96fc75653c9b207d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $96fc75653c9b207d$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $96fc75653c9b207d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});

parcelRegister("dUsMe", function(module, exports) {

$parcel$export(module.exports, "useInitFetchResource", () => $e60431eaa4374b0b$export$5b98692301d8680);
$parcel$export(module.exports, "usePrefetchableResource", () => $e60431eaa4374b0b$export$99f17ace416cfe75);

var $eUqFw = parcelRequire("eUqFw");
const $e60431eaa4374b0b$export$5b98692301d8680 = (resource, skipInitFetch = false)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, ...rest } = resource;
    (0, $eUqFw.useEffect)(()=>{
        if (skipInitFetch) return;
        if (!data && !loading && !error && refresh) refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        refresh: refresh,
        ...rest
    };
};
function $e60431eaa4374b0b$export$99f17ace416cfe75(resource, shouldPrefetch) {
    (0, $eUqFw.useEffect)(()=>{
        if (!shouldPrefetch) return;
        // "false" is a valid value for data here. We only want to trigger a refresh if data is null or undefined.
        if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("ixwgj", function(module, exports) {

$parcel$export(module.exports, "projectContextResource", () => $97b06b2828b1be93$export$27ad0d75c619be68);
$parcel$export(module.exports, "projectContextResourceWithCache", () => $97b06b2828b1be93$export$d75816e37af81473);

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");


const $97b06b2828b1be93$var$getDataLoader = ()=>(parcelRequire("8FY9p"));
const $97b06b2828b1be93$export$27ad0d75c619be68 = (0, $lB25E.createResource)({
    type: (0, $e9754370217fd66e$export$80a60a092d9ab81),
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return projectKey || projectId;
    },
    getDataLoader: $97b06b2828b1be93$var$getDataLoader,
    maxAge: 1800000
});
const $97b06b2828b1be93$export$d75816e37af81473 = $97b06b2828b1be93$export$27ad0d75c619be68;

});
parcelRegister("9zYls", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyId", () => $5d8459da4a60e5c9$export$1f7213d0f9054f06);
const $5d8459da4a60e5c9$export$1f7213d0f9054f06 = (match, query)=>{
    // handle reports legacy url or project settings details
    const projectId = query.selectedProjectId || query.pid || query.projectId || query['project.id'];
    const projectKey = match.params.projectKey || query.projectKey || query['project.key'] || (match.params.issueKey || '').split('-')[0];
    return {
        projectKey: projectKey,
        projectId: projectId
    };
};

});

const $e9754370217fd66e$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("8FY9p", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cLVTX").then(()=>parcelRequire('6oUEv'));

});



parcelRegister("ddT06", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_METRICS_HISTOGRAM", () => $12a3433d60ba6dc8$export$128e24da52662cdd);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION", () => $12a3433d60ba6dc8$export$efdecbe4c9f1cd2c);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION_ANALYTICS_ID", () => $12a3433d60ba6dc8$export$7cadd2a48a9ff918);
$parcel$export(module.exports, "DEFAULT_LEVEL_ONE_NAME", () => $12a3433d60ba6dc8$export$a546b6d48878ce6f);
$parcel$export(module.exports, "BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES", () => $12a3433d60ba6dc8$export$8cc83ae2b6885e0);
$parcel$export(module.exports, "boardSettingsQueryConfigParamValues", () => $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3);
$parcel$export(module.exports, "SETTINGS_CONFIG", () => $12a3433d60ba6dc8$export$2a56ee2f9c41b5a7);
$parcel$export(module.exports, "EDIT_BOARD_CONFIG", () => $12a3433d60ba6dc8$export$b893894941c14e43);
$parcel$export(module.exports, "ADMINISTER_PARENT_PROJECT", () => $12a3433d60ba6dc8$export$d14d5a7c294329c5);
$parcel$export(module.exports, "USER_PICKER_PROJECT_PERMISSION_KEY", () => $12a3433d60ba6dc8$export$1e63b013f0e45de0);
$parcel$export(module.exports, "ADMINISTER_PROJECT_PERMISSION_KEY", () => $12a3433d60ba6dc8$export$68030ac1ea4abd4c);
$parcel$export(module.exports, "BACKLOG_FEATURE_KEY", () => $12a3433d60ba6dc8$export$e1671d3447ddd5ad);
$parcel$export(module.exports, "SPRINTS_FEATURE_KEY", () => $12a3433d60ba6dc8$export$46efc2c8d8106cff);
$parcel$export(module.exports, "FEATURE_ENABLED_STATUS", () => $12a3433d60ba6dc8$export$a1046f102eae498);
const $12a3433d60ba6dc8$export$128e24da52662cdd = '1000_1500_2000_2500_3000_4000';
const $12a3433d60ba6dc8$export$efdecbe4c9f1cd2c = '2QE2xWf0TpDbYpk4oY9aQr';
const $12a3433d60ba6dc8$export$7cadd2a48a9ff918 = `${$12a3433d60ba6dc8$export$efdecbe4c9f1cd2c}.config-disabled-section.article.analytics`;
const $12a3433d60ba6dc8$export$a546b6d48878ce6f = 'Epic';
const $12a3433d60ba6dc8$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES = [
    'cardColors',
    'cardLayout',
    'columns',
    'default',
    'estimation',
    'filter',
    'swimlanes',
    'time',
    'timelineConfig',
    'quickFilters',
    'insightsConfig',
    'dateFields'
];
const $12a3433d60ba6dc8$export$8cc83ae2b6885e0 = new Set($12a3433d60ba6dc8$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES);
const $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3 = Object.fromEntries($12a3433d60ba6dc8$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES.map((key)=>[
        key,
        key
    ]));
const $12a3433d60ba6dc8$export$2a56ee2f9c41b5a7 = {
    default: {
        configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.filter,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    filter: {
        configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.filter,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    columns: {
        configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.columns,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    swimlanes: {
        configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.swimlanes,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    quickFilters: {
        configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.quickFilters,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    cardColors: {
        configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.cardColors,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    cardLayout: {
        configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.cardLayout,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    estimation: {
        configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.estimation,
        jsmAllowed: false,
        userLocatedBoardAllowed: true,
        kanbanAllowed: false
    },
    time: {
        configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.time,
        jsmAllowed: false,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    },
    timelineConfig: {
        configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.timelineConfig,
        jsmAllowed: false,
        userLocatedBoardAllowed: false,
        kanbanAllowed: true
    },
    insightsConfig: {
        configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.insightsConfig,
        jsmAllowed: false,
        userLocatedBoardAllowed: false,
        kanbanAllowed: false
    },
    dateFields: {
        configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.dateFields,
        jsmAllowed: true,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true
    }
};
const $12a3433d60ba6dc8$export$773ca4f5fb67778b = 60000;
const $12a3433d60ba6dc8$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
const $12a3433d60ba6dc8$export$d14d5a7c294329c5 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
'ADMINISTER_PARENT_PROJECT';
const $12a3433d60ba6dc8$export$1e63b013f0e45de0 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
'USER_PICKER';
const $12a3433d60ba6dc8$export$68030ac1ea4abd4c = 'ADMINISTER';
const $12a3433d60ba6dc8$export$e1671d3447ddd5ad = 'BACKLOG';
const $12a3433d60ba6dc8$export$46efc2c8d8106cff = 'SPRINTS';
const $12a3433d60ba6dc8$export$a1046f102eae498 = 'ENABLED';
const $12a3433d60ba6dc8$export$450e5ddc9f1ff901 = 'DISABLED';

});

parcelRegister("bEe6y", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalSoftwareProjectNav", () => $1f8792707b4b0d16$export$128d5d79815580ca);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $gGtKh = parcelRequire("gGtKh");

const $1f8792707b4b0d16$var$LazyHorizontalSoftwareProjectNav = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("3Lv1i")).then(({ HorizontalSoftwareProjectNav: HorizontalSoftwareProjectNav })=>HorizontalSoftwareProjectNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-software/src/ui/index.tsx"
});
const $1f8792707b4b0d16$export$128d5d79815580ca = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-software-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f8792707b4b0d16$var$LazyHorizontalSoftwareProjectNav, null));

});
parcelRegister("3Lv1i", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bnyRr")
]).then(()=>parcelRequire('kUyw6'));

});


const $afb3b9e0346cd1fd$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $afb3b9e0346cd1fd$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';



parcelRegister("9zysr", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $cbf8ee3071697856$export$6e8ea24b15199873);

var $eUqFw = parcelRequire("eUqFw");
function $cbf8ee3071697856$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("Qx7Xg", function(module, exports) {

$parcel$export(module.exports, "useIsFullscreen", () => $1de01b52c6b501b2$export$d397eccea5f37b0a);

var $WBLbN = parcelRequire("WBLbN");

var $53ucm = parcelRequire("53ucm");
const $1de01b52c6b501b2$export$d397eccea5f37b0a = (0, $WBLbN.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>state.isFullscreen
});

});

parcelRegister("cB0s9", function(module, exports) {

$parcel$export(module.exports, "LayoutRemoteStateUpdater", () => $7eb87e9a268eb6a6$export$b9f3a70460995c32);

var $eUqFw = parcelRequire("eUqFw");

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $9zysr = parcelRequire("9zysr");

var $6FP8W = parcelRequire("6FP8W");

var $hwyJ1 = parcelRequire("hwyJ1");

var $1NIhY = parcelRequire("1NIhY");


var $dxcfv = parcelRequire("dxcfv");

var $lB25E = parcelRequire("lB25E");

var $53ucm = parcelRequire("53ucm");

var $kpmC0 = parcelRequire("kpmC0");

var $bUi2Q = parcelRequire("bUi2Q");

var $bXcr7 = parcelRequire("bXcr7");
/**
 * Synchronizes the layout's local state with the remote server to ensure consistency across sessions.
 * It monitors changes in the layout, such as sidebar adjustments, and updates the server accordingly.
 * Critical errors encountered during the update process are captured and reported to facilitate
 * troubleshooting and continuous improvement. This component plays a pivotal role in maintaining
 * a seamless user experience by ensuring that layout preferences are consistently reflected.
 */ const $7eb87e9a268eb6a6$var$LayoutRemoteStateUpdaterOld = ()=>{
    // left-sidebar
    const { leftSidebarState: leftSidebarState } = (0, $hwyJ1.usePageLayoutResize)();
    const { isFlyoutOpen: isFlyoutOpen, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
    const resolvedLeftSidebarWidth = Math.max(leftSidebarWidth, (0, $53ucm.DEFAULT_LEFT_SIDEBAR_WIDTH));
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $53ucm.useLayoutStoreActions)();
    const isCollapsed = leftSidebarState.isLeftSidebarCollapsed;
    // right-sidebar
    const rightSidebarState = (0, $bUi2Q.useRightSidebarState)();
    const accountId = (0, $dxcfv.useAccountId)();
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)((0, $1NIhY.navigationUiStateResource));
    const isLayoutStateReady = leftSidebarWidth !== 0 && leftSidebarState.lastLeftSidebarWidth !== 0;
    (0, $eUqFw.useEffect)(()=>{
        if (!isLayoutStateReady) return;
        if (error) return;
        setLeftSidebarState({
            width: resolvedLeftSidebarWidth,
            isCollapsed: isCollapsed,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            isFlyoutOpen: isFlyoutOpen,
            isVisible: true
        });
    }, [
        error,
        isCollapsed,
        isFlyoutOpen,
        isLayoutStateReady,
        resolvedLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const updateData = (0, $eUqFw.useCallback)(async ()=>{
        if (loading) return;
        if (error) return;
        if (!isLayoutStateReady) return;
        const remoteData = {
            ...data,
            leftSidebar: {
                width: resolvedLeftSidebarWidth,
                isCollapsed: isLeftSidebarCollapsed
            },
            rightSidebar: rightSidebarState
        };
        if (accountId) try {
            await (0, $48bs8.setUserProperties)(accountId, (0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $guiFP.default)({
                error: e,
                meta: {
                    id: 'updateServerLayoutState',
                    packageName: 'jiraLayoutController',
                    teamName: 'magma'
                }
            });
        }
    }, [
        accountId,
        data,
        error,
        isLayoutStateReady,
        isLeftSidebarCollapsed,
        loading,
        resolvedLeftSidebarWidth,
        rightSidebarState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        updateData();
    }, [
        isLeftSidebarCollapsed,
        resolvedLeftSidebarWidth,
        updateData
    ]);
    return null;
};
/**
 * The old layout remote state updater used a hook to subscribe to the DS left sidebar state,
 * and would then update the `react-sweet-state` store as well as the remote state.
 *
 * Now the side nav integration is wired to update the `react-sweet-state` store directly,
 * and this will just update the remote state. This is because the new side nav does not expose its
 * state through a hook. We can change this in the future if necessary.
 *
 * In the future, we could also consider moving the remote update logic into the `react-sweet-state`
 * action which updates the left sidebar, removing the need for a subscriber like this.
 */ const $7eb87e9a268eb6a6$var$LayoutRemoteStateUpdaterNew = ()=>{
    const accountId = (0, $dxcfv.useAccountId)();
    const leftSidebar = (0, $kpmC0.useLeftSidebarState)();
    const rightSidebar = (0, $bUi2Q.useRightSidebarState)();
    const isLeftSidebarCollapsed = leftSidebar.isCollapsed;
    const leftSidebarWidth = leftSidebar.width;
    (0, $eUqFw.useEffect)(()=>{
        if (!accountId) return;
        (0, $bXcr7.setRemoteLayoutState)({
            accountId: accountId,
            state: {
                rightSidebar: rightSidebar,
                leftSidebar: {
                    isCollapsed: isLeftSidebarCollapsed,
                    width: leftSidebarWidth
                }
            }
        });
    }, [
        accountId,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        rightSidebar
    ]);
    return null;
};
const $7eb87e9a268eb6a6$export$b9f3a70460995c32 = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $7eb87e9a268eb6a6$var$LayoutRemoteStateUpdaterNew, $7eb87e9a268eb6a6$var$LayoutRemoteStateUpdaterOld);

});
parcelRegister("48bs8", function(module, exports) {

$parcel$export(module.exports, "getUserPropertiesUrl", () => $016bb9e2a17179ab$export$f474e53c8191800a);
$parcel$export(module.exports, "setUserProperties", () => $016bb9e2a17179ab$export$d0e176862bf869b8);
$parcel$export(module.exports, "getUserProperty", () => $016bb9e2a17179ab$export$b3126db2ef6e34ed);

var $axhXb = parcelRequire("axhXb");

var $7byHA = parcelRequire("7byHA");
const $016bb9e2a17179ab$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $016bb9e2a17179ab$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>fetch($016bb9e2a17179ab$export$f474e53c8191800a(accountId, propertyKey), {
        ...(0, $axhXb.default),
        method: 'PUT',
        body: data
    });
const $016bb9e2a17179ab$export$b3126db2ef6e34ed = (accountId, propertyKey)=>fetch($016bb9e2a17179ab$export$f474e53c8191800a(accountId, propertyKey), (0, $axhXb.default)).then((res)=>{
        if (res.status === 200) return res.json();
        return res.text().then((errResp)=>{
            throw new (0, $7byHA.default)(res.status, errResp);
        });
    }).then((data)=>data.value);

});
parcelRegister("axhXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1543ae6d5c00264$export$2e2bcd8739ae039);
const $d1543ae6d5c00264$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'x-atlassian-force-account-id': 'true',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};
var $d1543ae6d5c00264$export$2e2bcd8739ae039 = $d1543ae6d5c00264$var$defaultOptions;

});


parcelRegister("hwyJ1", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $2da01f2b2b9a411b$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $2da01f2b2b9a411b$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $2da01f2b2b9a411b$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $2da01f2b2b9a411b$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebarWithoutResize", () => $2da01f2b2b9a411b$export$43ae342508cf8cc9);
$parcel$export(module.exports, "LeftSidebar", () => $2da01f2b2b9a411b$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $2da01f2b2b9a411b$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $2da01f2b2b9a411b$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $2da01f2b2b9a411b$export$84d58c19c21f637f);
$parcel$export(module.exports, "useCustomSkipLink", () => $2da01f2b2b9a411b$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $2da01f2b2b9a411b$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $2da01f2b2b9a411b$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $2da01f2b2b9a411b$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $2da01f2b2b9a411b$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $2da01f2b2b9a411b$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $2da01f2b2b9a411b$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $2da01f2b2b9a411b$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $2da01f2b2b9a411b$export$d697087c06fd5e25);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $ahaFU = parcelRequire("ahaFU");
var $ho1Ek = parcelRequire("ho1Ek");
var $780tS = parcelRequire("780tS");
var $1EvZ6 = parcelRequire("1EvZ6");
var $66hOn = parcelRequire("66hOn");
var $2Lkx0 = parcelRequire("2Lkx0");
var $hNH8O = parcelRequire("hNH8O");
var $4NoTP = parcelRequire("4NoTP");
var $epaF7 = parcelRequire("epaF7");
var $mtJGd = parcelRequire("mtJGd");
var $jnGaC = parcelRequire("jnGaC");
var $GP1qj = parcelRequire("GP1qj");
var $ikQZw = parcelRequire("ikQZw");

var $6FP8W = parcelRequire("6FP8W");

var $8RCsc = parcelRequire("8RCsc");
var $kWfO4 = parcelRequire("kWfO4");
var $i3WpJ = parcelRequire("i3WpJ");
var $exw0h = parcelRequire("exw0h");
var $aXlvz = parcelRequire("aXlvz");
var $iHNtK = parcelRequire("iHNtK");
var $c91OB = parcelRequire("c91OB");
function $2da01f2b2b9a411b$export$6d1402fb58384e4f(props) {
    return (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aXlvz.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4NoTP.default), props);
}
function $2da01f2b2b9a411b$export$3b4e64e77073e307(props) {
    return (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kWfO4.Banner), {
        UNSAFE_height: props.height,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ahaFU.default), props);
}
function $2da01f2b2b9a411b$export$8a421bddecb2bf5b(props) {
    return (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c91OB.TopBar), {
        UNSAFE_height: props.height,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jnGaC.default), props);
}
function $2da01f2b2b9a411b$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $6FP8W.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1EvZ6.default), props);
}
function $2da01f2b2b9a411b$export$43ae342508cf8cc9(props) {
    return (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iHNtK.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Lkx0.default), props);
}
function $2da01f2b2b9a411b$export$3cabf771c4f2de(props) {
    return (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iHNtK.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66hOn.default), props);
}
function $2da01f2b2b9a411b$export$861edd1ccea2f746(props) {
    return (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i3WpJ.Main), {
        isFixed: props.isFixed,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hNH8O.default), props);
}
function $2da01f2b2b9a411b$export$7c6e2c02157bb7d2(props) {
    return (0, $6FP8W.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $780tS.default), props);
}
function $2da01f2b2b9a411b$export$84d58c19c21f637f(props) {
    return (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8RCsc.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $mtJGd.default), props);
}
function $2da01f2b2b9a411b$export$364a989a35814102(props) {
    return (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $exw0h.Panel), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epaF7.default), props);
}
const $2da01f2b2b9a411b$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $6FP8W.getWillShowNav4)() ? {} : (0, $GP1qj.useCustomSkipLink)(id, title, index);
const $2da01f2b2b9a411b$export$94561f6055639ef7 = ()=>(0, $6FP8W.getWillShowNav4)() ? {} : (0, $ikQZw.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $2da01f2b2b9a411b$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
const $2da01f2b2b9a411b$export$10c7104037a7af62 = ()=>(0, $6FP8W.getWillShowNav4)() ? $2da01f2b2b9a411b$var$mockPageLayoutResize : (0, $ikQZw.usePageLayoutResize)();
const $2da01f2b2b9a411b$export$991ef8098f87814a = (0, $ho1Ek.BANNER_HEIGHT);
const $2da01f2b2b9a411b$export$7eaf986ecb4d5cac = (0, $ho1Ek.LEFT_PANEL_WIDTH);
const $2da01f2b2b9a411b$export$e95b388ca8c92019 = (0, $ho1Ek.LEFT_SIDEBAR_WIDTH);
const $2da01f2b2b9a411b$export$2ab8b83eed76656c = (0, $ho1Ek.RIGHT_PANEL_WIDTH);
const $2da01f2b2b9a411b$export$ac017575d43f5da = (0, $ho1Ek.RIGHT_SIDEBAR_WIDTH);
const $2da01f2b2b9a411b$export$d697087c06fd5e25 = (0, $ho1Ek.TOP_NAVIGATION_HEIGHT);

});
parcelRegister("ahaFU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6e67e66af393013$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
const $e6e67e66af393013$var$bannerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $ho1Ek.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.BANNER)
});
const $e6e67e66af393013$var$bannerFixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'fixed',
    zIndex: 2,
    insetBlockStart: 0,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $ho1Ek.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $ho1Ek.LEFT_PANEL_WIDTH)
});
/**
 * __Banner__
 *
 * Provides a slot for a Banner within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $e6e67e66af393013$var$Banner = (props)=>{
    const { children: children, height: height = (0, $ho1Ek.DEFAULT_BANNER_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
    const bannerHeight = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_BANNER_HEIGHT), height, shouldPersistHeight);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_BANNER_HEIGHT)]: bannerHeight
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_BANNER_HEIGHT)]: 0
            });
        };
    }, [
        bannerHeight
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $e6e67e66af393013$var$bannerStyles,
                isFixed && $e6e67e66af393013$var$bannerFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('banner')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_BANNER_HEIGHT),
            value: bannerHeight
        }), children));
};
var $e6e67e66af393013$export$2e2bcd8739ae039 = $e6e67e66af393013$var$Banner;

});
parcelRegister("ho1Ek", function(module, exports) {

$parcel$export(module.exports, "VAR_LEFT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$cbfb0f5b2869b17b);
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$a30f2e00489a8957);
$parcel$export(module.exports, "VAR_RIGHT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$c103b605cd368aed);
$parcel$export(module.exports, "VAR_RIGHT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$fa34f417972d6341);
$parcel$export(module.exports, "VAR_TOP_NAVIGATION_HEIGHT", () => $9bfcd1a3e554435a$export$3a6a779d9181047c);
$parcel$export(module.exports, "VAR_BANNER_HEIGHT", () => $9bfcd1a3e554435a$export$bcd94a6a792e7f96);
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_FLYOUT", () => $9bfcd1a3e554435a$export$b6744d31294864fd);
$parcel$export(module.exports, "DIMENSIONS", () => $9bfcd1a3e554435a$export$d67ac355184b7646);
$parcel$export(module.exports, "LEFT_PANEL", () => $9bfcd1a3e554435a$export$344062f7cfc9528e);
$parcel$export(module.exports, "RIGHT_PANEL", () => $9bfcd1a3e554435a$export$c7139cc2d6110b5f);
$parcel$export(module.exports, "BANNER", () => $9bfcd1a3e554435a$export$238d30785c4bca84);
$parcel$export(module.exports, "TOP_NAVIGATION", () => $9bfcd1a3e554435a$export$bec6dca2e63de4ae);
$parcel$export(module.exports, "CONTENT", () => $9bfcd1a3e554435a$export$d1213e82613ff4df);
$parcel$export(module.exports, "DEFAULT_BANNER_HEIGHT", () => $9bfcd1a3e554435a$export$be83e7118304b28e);
$parcel$export(module.exports, "DEFAULT_TOP_NAVIGATION_HEIGHT", () => $9bfcd1a3e554435a$export$4a98ee0bd1ae362);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$539e68c09584883a);
$parcel$export(module.exports, "DEFAULT_RIGHT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$b92df8810d2fcd01);
$parcel$export(module.exports, "DEFAULT_RIGHT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$c3e41153b9288bcf);
$parcel$export(module.exports, "DEFAULT_LEFT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$c4d6152f86ea28f6);
$parcel$export(module.exports, "COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$46acf8758e9e2636);
$parcel$export(module.exports, "MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$70740f5ad8360a78);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH", () => $9bfcd1a3e554435a$export$991d5285ad765a3d);
$parcel$export(module.exports, "MIN_LEFT_SIDEBAR_DRAG_THRESHOLD", () => $9bfcd1a3e554435a$export$6949d4f32b161684);
$parcel$export(module.exports, "MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH", () => $9bfcd1a3e554435a$export$d6e7e8af042815bb);
$parcel$export(module.exports, "TRANSITION_DURATION", () => $9bfcd1a3e554435a$export$3749e1104328fde4);
$parcel$export(module.exports, "FLYOUT_DELAY", () => $9bfcd1a3e554435a$export$1074d925b0b82be5);
$parcel$export(module.exports, "PAGE_LAYOUT_LS_KEY", () => $9bfcd1a3e554435a$export$451e84a45a9e4a75);
$parcel$export(module.exports, "IS_SIDEBAR_DRAGGING", () => $9bfcd1a3e554435a$export$802bb2c050f3db5c);
$parcel$export(module.exports, "IS_SIDEBAR_COLLAPSING", () => $9bfcd1a3e554435a$export$5e5e1875c3fd8f4f);
$parcel$export(module.exports, "GRAB_AREA_LINE_SELECTOR", () => $9bfcd1a3e554435a$export$70c702a8c5895f03);
$parcel$export(module.exports, "GRAB_AREA_SELECTOR", () => $9bfcd1a3e554435a$export$48a43f91e4becf4e);
$parcel$export(module.exports, "RESIZE_BUTTON_SELECTOR", () => $9bfcd1a3e554435a$export$dac2fb31a9f6844d);
$parcel$export(module.exports, "RESIZE_CONTROL_SELECTOR", () => $9bfcd1a3e554435a$export$9ecd22db14e6c70e);
$parcel$export(module.exports, "PAGE_LAYOUT_SLOT_SELECTOR", () => $9bfcd1a3e554435a$export$5253dd9707b8c3ba);
$parcel$export(module.exports, "DEFAULT_I18N_PROPS_SKIP_LINKS", () => $9bfcd1a3e554435a$export$206a08f7f8beb554);
$parcel$export(module.exports, "PAGE_LAYOUT_CONTAINER_SELECTOR", () => $9bfcd1a3e554435a$export$659ee746b31b360d);
$parcel$export(module.exports, "LEFT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$f963aecf2d4465bd);
$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$750459958906793);
$parcel$export(module.exports, "LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$f897e1ed9f8ed251);
$parcel$export(module.exports, "RIGHT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$b44ab66843c05a69);
$parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", () => $9bfcd1a3e554435a$export$aeff86a16f13529);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $9bfcd1a3e554435a$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "LEFT_SIDEBAR_FLYOUT_WIDTH", () => $9bfcd1a3e554435a$export$d2fa14f05b61e66);
// dimension vars
const $9bfcd1a3e554435a$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $9bfcd1a3e554435a$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $9bfcd1a3e554435a$export$c103b605cd368aed = 'rightSidebarWidth';
const $9bfcd1a3e554435a$export$fa34f417972d6341 = 'rightPanelWidth';
const $9bfcd1a3e554435a$export$3a6a779d9181047c = 'topNavigationHeight';
const $9bfcd1a3e554435a$export$bcd94a6a792e7f96 = 'bannerHeight';
const $9bfcd1a3e554435a$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $9bfcd1a3e554435a$export$d67ac355184b7646 = [
    $9bfcd1a3e554435a$export$cbfb0f5b2869b17b,
    $9bfcd1a3e554435a$export$fa34f417972d6341,
    $9bfcd1a3e554435a$export$bcd94a6a792e7f96,
    $9bfcd1a3e554435a$export$3a6a779d9181047c,
    $9bfcd1a3e554435a$export$a30f2e00489a8957,
    $9bfcd1a3e554435a$export$c103b605cd368aed
];
const $9bfcd1a3e554435a$export$344062f7cfc9528e = 'left-panel';
const $9bfcd1a3e554435a$export$c7139cc2d6110b5f = 'right-panel';
const $9bfcd1a3e554435a$export$238d30785c4bca84 = 'banner';
const $9bfcd1a3e554435a$export$bec6dca2e63de4ae = 'top-navigation';
const $9bfcd1a3e554435a$export$d1213e82613ff4df = 'content';
const $9bfcd1a3e554435a$export$2d8180803f50fc5 = 'main';
const $9bfcd1a3e554435a$export$50ea883ba6f28ff5 = 'left-sidebar';
const $9bfcd1a3e554435a$export$7bf43119a6b49ddb = 'right-sidebar';
const $9bfcd1a3e554435a$export$be83e7118304b28e = 56;
const $9bfcd1a3e554435a$export$4a98ee0bd1ae362 = 56;
const $9bfcd1a3e554435a$export$539e68c09584883a = 240;
const $9bfcd1a3e554435a$export$b92df8810d2fcd01 = 280;
const $9bfcd1a3e554435a$export$c3e41153b9288bcf = 368;
const $9bfcd1a3e554435a$export$c4d6152f86ea28f6 = 368;
const $9bfcd1a3e554435a$export$46acf8758e9e2636 = 20;
const $9bfcd1a3e554435a$export$70740f5ad8360a78 = 16;
const $9bfcd1a3e554435a$export$f562af313cda0684 = 80;
const $9bfcd1a3e554435a$export$991d5285ad765a3d = 240;
const $9bfcd1a3e554435a$export$6949d4f32b161684 = 200;
const $9bfcd1a3e554435a$export$d6e7e8af042815bb = 350;
const $9bfcd1a3e554435a$export$3749e1104328fde4 = 300;
const $9bfcd1a3e554435a$export$1074d925b0b82be5 = 200;
const $9bfcd1a3e554435a$export$24d54fc362d78805 = 'expandedLeftSidebarWidth';
const $9bfcd1a3e554435a$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $9bfcd1a3e554435a$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $9bfcd1a3e554435a$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $9bfcd1a3e554435a$export$60b3bc5d4ac00d5e = 'data-is-flyout-open';
const $9bfcd1a3e554435a$export$70c702a8c5895f03 = 'data-grab-area-line';
const $9bfcd1a3e554435a$export$48a43f91e4becf4e = 'data-grab-area';
const $9bfcd1a3e554435a$export$dac2fb31a9f6844d = 'data-resize-button';
const $9bfcd1a3e554435a$export$9ecd22db14e6c70e = 'data-resize-control';
const $9bfcd1a3e554435a$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $9bfcd1a3e554435a$export$206a08f7f8beb554 = 'Skip to:';
const $9bfcd1a3e554435a$export$659ee746b31b360d = 'data-layout-container';
const $9bfcd1a3e554435a$export$f963aecf2d4465bd = `var(--${$9bfcd1a3e554435a$export$cbfb0f5b2869b17b}, 0px)`;
const $9bfcd1a3e554435a$export$750459958906793 = `var(--${$9bfcd1a3e554435a$export$fa34f417972d6341}, 0px)`;
const $9bfcd1a3e554435a$export$f897e1ed9f8ed251 = `var(--${$9bfcd1a3e554435a$export$a30f2e00489a8957}, 0px)`;
const $9bfcd1a3e554435a$export$b44ab66843c05a69 = `var(--${$9bfcd1a3e554435a$export$c103b605cd368aed}, 0px)`;
const $9bfcd1a3e554435a$export$aeff86a16f13529 = `var(--${$9bfcd1a3e554435a$export$3a6a779d9181047c}, 0px)`;
const $9bfcd1a3e554435a$export$ed7cc0d417ee89e = `var(--${$9bfcd1a3e554435a$export$bcd94a6a792e7f96}, 0px)`;
const $9bfcd1a3e554435a$export$d2fa14f05b61e66 = `var(--${$9bfcd1a3e554435a$export$b6744d31294864fd}, ${$9bfcd1a3e554435a$export$991d5285ad765a3d}px)`;

});

parcelRegister("a353s", function(module, exports) {

$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $0a6a711fa684a053$export$f8355a2df0f4a946);
$parcel$export(module.exports, "getGridStateFromStorage", () => $0a6a711fa684a053$export$d95e99d8116d17dc);
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $0a6a711fa684a053$export$17e3760e0b35f1cd);
$parcel$export(module.exports, "resolveDimension", () => $0a6a711fa684a053$export$74732e47915c7839);
$parcel$export(module.exports, "getLeftPanelWidth", () => $0a6a711fa684a053$export$b089e01213f07bd);
$parcel$export(module.exports, "getLeftSidebarPercentage", () => $0a6a711fa684a053$export$2bca58b6ee823bf7);
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $0a6a711fa684a053$export$e895e3e8b708ae2a);
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $0a6a711fa684a053$export$218ece2c32b7db0e);

var $ho1Ek = parcelRequire("ho1Ek");

var $5o7nc = parcelRequire("5o7nc");
const $0a6a711fa684a053$export$576dabd404a1ed99 = (0, $ho1Ek.DIMENSIONS).reduce((acc, currentValue)=>({
        ...acc,
        [currentValue]: 0
    }), {});
const $0a6a711fa684a053$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $5o7nc.default)().getItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $5o7nc.default)().setItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};
const $0a6a711fa684a053$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $5o7nc.default)().getItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY)) || '{}');
    return storageValue[key];
};
const $0a6a711fa684a053$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $5o7nc.default)().getItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $5o7nc.default)().setItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};
const $0a6a711fa684a053$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = $0a6a711fa684a053$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
const $0a6a711fa684a053$export$b089e01213f07bd = ()=>{
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, $ho1Ek.LEFT_PANEL_WIDTH)}`), 10) || 0;
};
const $0a6a711fa684a053$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
    const total = (currentWidth - (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) / (maxWidth - (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
const $0a6a711fa684a053$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $ho1Ek.PAGE_LAYOUT_SLOT_SELECTOR)]: slotName
    });
const $0a6a711fa684a053$export$218ece2c32b7db0e = (slotName)=>`[${0, $ho1Ek.PAGE_LAYOUT_SLOT_SELECTOR}='${slotName}']`;

});
parcelRegister("5o7nc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d809f573a3653667$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $d809f573a3653667$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};
const $d809f573a3653667$var$safeLocalStorage = ()=>{
    if ($d809f573a3653667$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $d809f573a3653667$export$2e2bcd8739ae039 = $d809f573a3653667$var$safeLocalStorage;

});


parcelRegister("cXUwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $06373a48b343ca71$export$2e2bcd8739ae039);

var $a353s = parcelRequire("a353s");
const $06373a48b343ca71$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $a353s.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $a353s.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $06373a48b343ca71$export$2e2bcd8739ae039 = $06373a48b343ca71$var$publishGridState;

});

parcelRegister("6cmgz", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $73ff71be83e0ab1c$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinks", () => $73ff71be83e0ab1c$export$c9d9cb2ee9590f87);
$parcel$export(module.exports, "useSkipLink", () => $73ff71be83e0ab1c$export$89d9323301efc7d6);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $73ff71be83e0ab1c$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $5Q9wj.default),
    unregisterSkipLink: (0, $5Q9wj.default)
});
const $73ff71be83e0ab1c$export$c9d9cb2ee9590f87 = ()=>(0, $eUqFw.useContext)($73ff71be83e0ab1c$export$4c5cc3b14c7678a);
const $73ff71be83e0ab1c$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $73ff71be83e0ab1c$export$c9d9cb2ee9590f87();
    (0, $eUqFw.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("gl6Cr", function(module, exports) {

$parcel$export(module.exports, "default", () => $769062fa7cdcfd96$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

const $769062fa7cdcfd96$var$focusStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $769062fa7cdcfd96$var$sidebarFocusStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $769062fa7cdcfd96$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($769062fa7cdcfd96$var$sidebarFocusStyles) : css($769062fa7cdcfd96$var$focusStyles)
        }));
};
var $769062fa7cdcfd96$export$2e2bcd8739ae039 = $769062fa7cdcfd96$var$SlotFocusRing;

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "B600", () => $73a5c9d720aa66e1$export$67f15409e87642a1);
$parcel$export($73a5c9d720aa66e1$exports, "B700", () => $73a5c9d720aa66e1$export$f0539dbc42dbb067);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
$parcel$export($73a5c9d720aa66e1$exports, "T30", () => $73a5c9d720aa66e1$export$d2adc5dedf09fced);
$parcel$export($73a5c9d720aa66e1$exports, "L50", () => $73a5c9d720aa66e1$export$f51762073d2bb381);
$parcel$export($73a5c9d720aa66e1$exports, "L75", () => $73a5c9d720aa66e1$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$67f15409e87642a1 = '#669DF1';
const $73a5c9d720aa66e1$export$f0539dbc42dbb067 = '#8FB8F6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $73a5c9d720aa66e1$export$d2adc5dedf09fced = '#292A2E';
const $73a5c9d720aa66e1$export$f51762073d2bb381 = '#94C748';
const $73a5c9d720aa66e1$export$95e26d54def96891 = '#B3DF72';


parcelRegister("8cbHW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5df357f02f294910$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Ywu9 = parcelRequire("4Ywu9");
/**
 * Hoists slot dimension styles to the root element.
 */ const $5df357f02f294910$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $4Ywu9.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", null, style));
};
var $5df357f02f294910$export$2e2bcd8739ae039 = $5df357f02f294910$var$SlotDimensions;

});


parcelRegister("780tS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1254209de2b99d0a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");
const $1254209de2b99d0a$var$contentStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.CONTENT)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $1254209de2b99d0a$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: $1254209de2b99d0a$var$contentStyles
    }, children);
};
var $1254209de2b99d0a$export$2e2bcd8739ae039 = $1254209de2b99d0a$var$Content;

});

parcelRegister("1EvZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cee1fe777273abc5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
const $cee1fe777273abc5$var$leftPanelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.LEFT_PANEL)
});
const $cee1fe777273abc5$var$leftPanelFixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.LEFT_PANEL_WIDTH),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: 0
});
/**
 * __Left panel__
 *
 * Provides a slot for a left panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $cee1fe777273abc5$var$LeftPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $ho1Ek.DEFAULT_LEFT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const leftPanelWidth = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_LEFT_PANEL_WIDTH), width, shouldPersistWidth);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_LEFT_PANEL_WIDTH)]: leftPanelWidth
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_LEFT_PANEL_WIDTH)]: 0
            });
        };
    }, [
        leftPanelWidth
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $cee1fe777273abc5$var$leftPanelStyles,
                isFixed && $cee1fe777273abc5$var$leftPanelFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('left-panel')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_LEFT_PANEL_WIDTH),
            value: leftPanelWidth
        }), children));
};
var $cee1fe777273abc5$export$2e2bcd8739ae039 = $cee1fe777273abc5$var$LeftPanel;

});

parcelRegister("66hOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba986c6a8de8190f$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $kVO3J = parcelRequire("kVO3J");


var $eT0WN = parcelRequire("eT0WN");


var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $ikQZw = parcelRequire("ikQZw");
var $6cmgz = parcelRequire("6cmgz");

var $3QLIJ = parcelRequire("3QLIJ");

var $cJoHg = parcelRequire("cJoHg");

var $c9QmQ = parcelRequire("c9QmQ");

var $bxILY = parcelRequire("bxILY");

var $8cbHW = parcelRequire("8cbHW");
const $ba986c6a8de8190f$var$openBackdropStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: `var(--ds-blanket, ${(0, $73a5c9d720aa66e1$export$486ab785e4bac3c6)})`,
    opacity: 1
});
const $ba986c6a8de8190f$var$hiddenBackdropStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `opacity ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
});
/**
 * __Left sidebar__
 *
 * Provides a slot for a left sidebar within the PageLayout.
 *
 * On smaller viewports, the left sidebar can no longer be expanded.  Instead, expanding it will
 * put it into our "flyout mode" to lay overtop (which in desktop is explicitly a hover state).
 * This ensures the contents behind do not reflow oddly and allows for a better experience
 * resizing between mobile and desktop.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $ba986c6a8de8190f$var$LeftSidebar = (props)=>{
    const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
    const flyoutTimerRef = (0, $eUqFw.useRef)();
    const mouseOverEventRef = (0, $eUqFw.useRef)();
    const leftSideBarRef = (0, $eUqFw.useRef)(null);
    const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $eUqFw.useContext)((0, $ikQZw.SidebarResizeContext));
    const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth } = leftSidebarState;
    const isLocked = flyoutLockCount > 0;
    const isLockedRef = (0, $eUqFw.useRef)(isLocked);
    const mouseXRef = (0, $eUqFw.useRef)(0);
    const handlerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        isLockedRef.current = isLocked;
        // I tried a one-time `mousemove` handler that gets attached
        // when the lock releases. This is not robust because
        // the mouse can stay still after release (e.g. using keyboard)
        // and the sidebar will erroneously stay open.
        //
        // The following solution is likely less performant but more robust.
        if (isLocked && !handlerRef.current) {
            handlerRef.current = (event)=>{
                mouseXRef.current = event.clientX;
            };
            document.addEventListener('mousemove', handlerRef.current);
        }
        if (!isLocked && handlerRef.current) {
            if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
            document.removeEventListener('mousemove', handlerRef.current);
            handlerRef.current = null;
        }
        return ()=>{
            if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
        };
    }, [
        isLocked,
        lastLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const _width = Math.max(width || 0, (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH));
    const collapsedStateOverrideOpen = collapsedState === 'expanded';
    let leftSidebarWidthOnMount;
    if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT), _width, !width);
    else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH);
    else leftSidebarWidthOnMount = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH), _width, !width || !collapsedStateOverrideOpen && (0, $a353s.getGridStateFromStorage)('isLeftSidebarCollapsed'));
    // Update state from cache on mount
    (0, $eUqFw.useEffect)(()=>{
        const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, $a353s.getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
        const cachedGridState = (0, $a353s.getGridStateFromStorage)('gridState') || {};
        let leftSidebarWidth = !width && cachedGridState[0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT], (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
        const lastLeftSidebarWidth = !width && cachedGridState[0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT], (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
        if (cachedCollapsedState) leftSidebarWidth = (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH);
        setLeftSidebarState({
            isFlyoutOpen: false,
            isResizing: isResizing,
            isLeftSidebarCollapsed: cachedCollapsedState,
            leftSidebarWidth: leftSidebarWidth,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            flyoutLockCount: 0,
            isFixed: isFixed
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Every time other than mount,
    // update the local storage and css variables.
    const notFirstRun = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (notFirstRun.current) {
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth || leftSidebarWidthOnMount,
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT)]: lastLeftSidebarWidth
            });
            (0, $a353s.mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
        }
        if (!notFirstRun.current) notFirstRun.current = true;
        return ()=>{
            removeMouseOverListener();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        id
    ]);
    const onMouseOver = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)}] *`);
        if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
        event.persist();
        flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
        if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
            const leftSidebar = leftSideBarRef.current;
            if (leftSidebar === null || isLockedRef.current) return;
            if (!leftSidebar.contains(event.target)) {
                flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                onFlyoutCollapse && onFlyoutCollapse();
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                removeMouseOverListener();
            }
        };
        document.addEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
        flyoutTimerRef.current = setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: true
                }));
            onFlyoutExpand && onFlyoutExpand();
        }, (0, $ho1Ek.FLYOUT_DELAY));
    };
    const removeMouseOverListener = ()=>{
        mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
    };
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    const onMouseLeave = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)}] *`);
        if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
        onFlyoutCollapse && onFlyoutCollapse();
        setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
        }, (0, $ho1Ek.FLYOUT_DELAY));
    };
    const mobileMediaQuery = (0, $eT0WN.UNSAFE_useMediaQuery)('below.sm');
    const openMobileFlyout = (0, $eUqFw.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: true
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    const closeMobileFlyout = (0, $eUqFw.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (!current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: false
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    (0, $eT0WN.UNSAFE_useMediaQuery)('below.sm', (event)=>{
        setLeftSidebarState((current)=>{
            if (event.matches && !current.isLeftSidebarCollapsed) // Sidebar was previously open when resizing downwards, convert the sidebar being open to a flyout being open
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: current.leftSidebarWidth,
                isFlyoutOpen: true
            };
            else if (!event.matches && current.isFlyoutOpen) // The user is resizing "upwards", eg. going from mobile to desktop.
            // Flyout was previously open, let's keep it open by moving to the un-collapsed sidebar instead
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: false,
                leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)),
                isFlyoutOpen: false
            };
            return current;
        });
    });
    // Close the flyout when the "escape" key is pressed.
    (0, $kVO3J.default)({
        onClose: closeMobileFlyout,
        isDisabled: !isFlyoutOpen
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, mobileMediaQuery?.matches && /**
     * On desktop, the `onClick` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $ba986c6a8de8190f$var$hiddenBackdropStyles,
            isFlyoutOpen && $ba986c6a8de8190f$var$openBackdropStyles
        ],
        onClick: closeMobileFlyout
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $c9QmQ.default), {
        ref: leftSideBarRef,
        testId: testId,
        onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
        onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
        onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
        id: id,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
        variableName: (0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH),
        value: notFirstRun.current ? leftSidebarWidth : leftSidebarWidthOnMount,
        mobileValue: (0, $ho1Ek.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $cJoHg.default), {
        isFixed: isFixed,
        isFlyoutOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bxILY.default), {
        isFlyoutOpen: isFlyoutOpen,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        hasCollapsedState: !notFirstRun.current && collapsedState === 'collapsed',
        testId: testId && `${testId}-resize-children-wrapper`
    }, children), /*#__PURE__*/ (0, $byn9U.jsx)((0, $3QLIJ.default), {
        testId: testId,
        valueTextLabel: valueTextLabel,
        resizeGrabAreaLabel: resizeGrabAreaLabel,
        resizeButtonLabel: resizeButtonLabel,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    }))));
};
var $ba986c6a8de8190f$export$2e2bcd8739ae039 = $ba986c6a8de8190f$var$LeftSidebar;

});
const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

parcelRegister("ikQZw", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeContext", () => $9a41c619a58ecd93$export$aa5a712eea4c2ae8);
$parcel$export(module.exports, "usePageLayoutResize", () => $9a41c619a58ecd93$export$10c7104037a7af62);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $9a41c619a58ecd93$export$94561f6055639ef7);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9a41c619a58ecd93$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true
};
const $9a41c619a58ecd93$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $5Q9wj.default),
    collapseLeftSidebar: (0, $5Q9wj.default),
    leftSidebarState: $9a41c619a58ecd93$var$leftSidebarState,
    setLeftSidebarState: (0, $5Q9wj.default),
    toggleLeftSidebar: (0, $5Q9wj.default)
});
const $9a41c619a58ecd93$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $eUqFw.useContext)($9a41c619a58ecd93$export$aa5a712eea4c2ae8);
    return context;
};
const $9a41c619a58ecd93$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $eUqFw.useContext)($9a41c619a58ecd93$export$aa5a712eea4c2ae8);
    (0, $eUqFw.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};

});

parcelRegister("3QLIJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf1435c6e64160e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $8yx6O = parcelRequire("8yx6O");

var $eT0WN = parcelRequire("eT0WN");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $ikQZw = parcelRequire("ikQZw");

var $e1gck = parcelRequire("e1gck");

var $i4a2R = parcelRequire("i4a2R");

var $4xMfW = parcelRequire("4xMfW");
function $2cf1435c6e64160e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2cf1435c6e64160e$var$cssSelector = {
    [(0, $ho1Ek.RESIZE_CONTROL_SELECTOR)]: true
};
const $2cf1435c6e64160e$var$resizeControlStyles = {
    name: "ow3ovp",
    styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
};
const $2cf1435c6e64160e$var$showResizeButtonStyles = {
    name: "1a6byq5",
    styles: "--ds--resize-button--opacity:1"
};
// @ts-expect-error adding `!important` to style rules is currently a type error
const $2cf1435c6e64160e$var$globalResizingStyles = {
    name: "e4avm6",
    styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
};
const $2cf1435c6e64160e$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
    const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $eUqFw.useContext)((0, $ikQZw.SidebarResizeContext));
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
    const sidebarWidth = (0, $eUqFw.useRef)(leftSidebarState[0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH]);
    // Distance of mouse from left sidebar onMouseDown
    const offset = (0, $eUqFw.useRef)(0);
    const keyboardEventTimeout = (0, $eUqFw.useRef)();
    const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $eUqFw.useState)(false);
    const unbindEvents = (0, $eUqFw.useRef)(null);
    const mobileMediaQuery = (0, $eT0WN.UNSAFE_useMediaQuery)('below.sm');
    // Used in some cases to ensure function references don't have to change
    // TODO: more functions could use `stableSidebarState` rather than `leftSidebarState`
    const stableSidebarState = (0, $eUqFw.useRef)(leftSidebarState);
    (0, $eUqFw.useEffect)(()=>{
        stableSidebarState.current = leftSidebarState;
    }, [
        leftSidebarState
    ]);
    const toggleSideBar = (0, $eUqFw.useCallback)((event)=>{
        // don't cascade down to the LeftSidebarOuter
        event?.stopPropagation();
        toggleLeftSidebar();
    }, [
        toggleLeftSidebar
    ]);
    const onMouseDown = (event)=>{
        if (isLeftSidebarCollapsed) return;
        // Only allow left (primary) clicks to trigger resize as we've received
        // bug reports about right click unexpectedly beginning a resize.
        if (event.button !== 0) return;
        // It is possible for a mousedown to fire during a resize
        // Example: the user presses another pointer button while dragging
        if (leftSidebarState.isResizing) // the resize will be cancelled by our global event listeners
        return;
        offset.current = event.clientX - leftSidebarState[0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH] - (0, $a353s.getLeftPanelWidth)();
        unbindEvents.current = (0, $74BVL.bindAll)(window, [
            {
                type: 'mousemove',
                listener: function(event) {
                    onUpdateResize({
                        clientX: event.clientX
                    });
                }
            },
            {
                type: 'mouseup',
                listener: onFinishResizing
            },
            {
                type: 'mousedown',
                // this mousedown event listener is being added in the bubble phase
                // on a higher event target than the resize handle.
                // This means that the original mousedown event that triggers a resize
                // can hit this mousedown handler. To get around that, we only call
                // `onFinishResizing` after an animation frame so we don't pick up the original event
                // Alternatives:
                // 1. Add the window 'mousedown' event listener in the capture phase
                // 👎 A 'mousedown' during a resize would trigger a new resize to start
                // 2. Do 1. and call `event.preventDefault()`, then check for `event.defaultPrevented` inside
                // the grab handle `onMouseDown`
                // 👎 Not ideal to cancel events if we don't have to
                listener: (()=>{
                    let hasFramePassed = false;
                    requestAnimationFrame(()=>{
                        hasFramePassed = true;
                    });
                    return function listener() {
                        if (hasFramePassed) onFinishResizing();
                    };
                })()
            },
            {
                type: 'visibilitychange',
                listener: onFinishResizing
            },
            // A 'click' event should never be hit as the 'mouseup' will come first and cause
            // these event listeners to be unbound. I just added 'click' for extreme safety (paranoia)
            {
                type: 'click',
                listener: onFinishResizing
            },
            {
                type: 'keydown',
                listener: (event)=>{
                    // Can cancel resizing by pressing "Escape"
                    // Will return sidebar to the same size it was before the resizing started
                    if (event.key === 'Escape') {
                        sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH));
                        document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
                        onFinishResizing();
                    }
                }
            }
        ]);
        document.documentElement.setAttribute((0, $ho1Ek.IS_SIDEBAR_DRAGGING), 'true');
        const newLeftbarState = {
            ...leftSidebarState,
            isResizing: true
        };
        setLeftSidebarState(newLeftbarState);
        onResizeStart && onResizeStart(newLeftbarState);
    };
    const onResizeOffLeftOfScreen = ()=>{
        onUpdateResize.cancel();
        unbindEvents.current?.();
        unbindEvents.current = null;
        document.documentElement.removeAttribute((0, $ho1Ek.IS_SIDEBAR_DRAGGING));
        offset.current = 0;
        collapseLeftSidebar(undefined, true);
    };
    // It is important that `onUpdateResize` is a stable function reference, so that:
    // 1. we ensure we are correctly throttling with `requestAnimationFrame`
    // 2. that a `onUpdateResize` will cancel the one and only pending frame
    // To help ensure `onUpdateResize` is stable, we are putting the last state into a ref
    const [onUpdateResize] = (0, $eUqFw.useState)(()=>(0, $8yx6O.default)(({ clientX: clientX })=>{
            // Allow the sidebar to be 50% of the available page width
            const maxWidth = Math.round(window.innerWidth / 2);
            const leftPanelWidth = (0, $a353s.getLeftPanelWidth)();
            const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
            const hasResizedOffLeftOfScreen = clientX < 0;
            if (hasResizedOffLeftOfScreen) {
                onResizeOffLeftOfScreen();
                return;
            }
            const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH) - leftSidebarWidth - leftPanelWidth);
            sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH));
            document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
        }));
    const onFinishResizing = ()=>{
        if (isLeftSidebarCollapsed) return;
        document.documentElement.removeAttribute((0, $ho1Ek.IS_SIDEBAR_DRAGGING));
        // TODO: the control flow is pretty strange as the first codepath which calls `collapseLeftSidebar()`
        // does not return an updated state snapshot.
        let updatedLeftSidebarState = null;
        // If it is dragged to below the threshold,
        // collapse the navigation
        if (sidebarWidth.current < (0, $ho1Ek.MIN_LEFT_SIDEBAR_DRAG_THRESHOLD)) {
            // TODO: for this codepath, `onCollapse` occurs before `onResizeEnd` which seems wrong
            document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`);
            collapseLeftSidebar(undefined, true);
        } else if (sidebarWidth.current > (0, $ho1Ek.MIN_LEFT_SIDEBAR_DRAG_THRESHOLD) && sidebarWidth.current < (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) {
            document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)}px`);
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)
            };
            setLeftSidebarState(updatedLeftSidebarState);
        } else {
            // otherwise resize it to the desired width
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: sidebarWidth.current,
                lastLeftSidebarWidth: sidebarWidth.current
            };
            setLeftSidebarState(updatedLeftSidebarState);
        }
        unbindEvents.current?.();
        unbindEvents.current = null;
        onUpdateResize.cancel();
        sidebarWidth.current = 0;
        offset.current = 0;
        // TODO: no idea why this is in an animation frame
        requestAnimationFrame(()=>{
            setIsGrabAreaFocused(false);
            // Note: the `collapseSidebar` codepath does not return state, so we need to pull it from the ref
            onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
        });
    };
    const onKeyDown = (event)=>{
        if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
        const { key: key } = event;
        const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
        const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
        const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
        if (isSpaceOrEnter) {
            toggleSideBar(event);
            event.preventDefault();
        }
        if (isLeftOrTopArrow || isRightOrBottomArrow) {
            event.preventDefault(); // prevent content scroll
            onResizeStart && onResizeStart(leftSidebarState);
            const step = 10;
            const stepValue = isLeftOrTopArrow ? -step : step;
            const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
            const maxWidth = Math.round(window.innerWidth / 2) - (0, $a353s.getLeftPanelWidth)();
            const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
            let width = leftSidebarWidth + stepValue;
            if (width <= (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) {
                width = (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH);
                document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH) - 20}px`);
            } else if (width > maxWidth) {
                width = maxWidth;
                document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${maxWidth + 20}px`);
            } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH);
            // Nesting the setTimeout within requestAnimationFrame helps
            // the browser schedule the setTimeout call in an efficient manner
            requestAnimationFrame(()=>{
                keyboardEventTimeout.current = window.setTimeout(()=>{
                    keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                    document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${width}px`);
                    const updatedLeftSidebarState = {
                        ...leftSidebarState,
                        [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: width,
                        lastLeftSidebarWidth: width
                    };
                    setLeftSidebarState(updatedLeftSidebarState);
                    onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                }, 50);
            });
        }
    };
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        setIsGrabAreaFocused(true);
    }, []);
    const onBlur = (0, $eUqFw.useCallback)(()=>{
        setIsGrabAreaFocused(false);
    }, []);
    const resizeButton = {
        render: (Component, props)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, props),
        ...overrides && overrides.ResizeButton
    };
    // This width is calculated once only on mount.
    // This means resizing the window will cause this value to be incorrect for screen reader users,
    // however this comes with a substantial performance gain and so is considered acceptable.
    const maxAriaWidth = (0, $eUqFw.useMemo)(()=>{
        const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
        return Math.round(innerWidth / 2) - (0, $a353s.getLeftPanelWidth)();
    }, []);
    const leftSidebarPercentageExpanded = (0, $a353s.getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...$2cf1435c6e64160e$var$cssSelector,
        css: [
            $2cf1435c6e64160e$var$resizeControlStyles,
            (isGrabAreaFocused || isLeftSidebarCollapsed) && $2cf1435c6e64160e$var$showResizeButtonStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4xMfW.default), {
        testId: testId && `${testId}-shadow`
    }), // Only show the GrabArea if we're not on the mobile viewport
    !mobileMediaQuery?.matches && /*#__PURE__*/ (0, $byn9U.jsx)((0, $e1gck.default), {
        isDisabled: isLeftSidebarCollapsed,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        label: resizeGrabAreaLabel,
        valueTextLabel: valueTextLabel,
        leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}-grab-area`
    }), resizeButton.render((0, $i4a2R.default), {
        isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
        label: resizeButtonLabel,
        onClick: toggleSideBar,
        testId: testId && `${testId}-resize-button`
    })), leftSidebarState.isResizing ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.Global), {
        styles: $2cf1435c6e64160e$var$globalResizingStyles
    }) : null);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2cf1435c6e64160e$export$2e2bcd8739ae039 = $2cf1435c6e64160e$var$ResizeControl;

});
parcelRegister("e1gck", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a25b5d5d6a7f6f0$export$2e2bcd8739ae039);
/* eslint-disable react/react-in-jsx-scope */ /**
                                               * @jsxRuntime classic
                                               * @jsx jsx
                                               */ 
var $byn9U = parcelRequire("byn9U");


var $ho1Ek = parcelRequire("ho1Ek");
function $8a25b5d5d6a7f6f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $8a25b5d5d6a7f6f0$var$varLineColor = '--ds-line';
const $8a25b5d5d6a7f6f0$var$grabAreaStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: "var(--ds-space-200, 16px)",
    height: '100%',
    padding: 0,
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'ew-resize',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:focus': {
        outline: 0
    },
    '&:enabled:hover, &:enabled:focus, &:enabled:active': {
        [$8a25b5d5d6a7f6f0$var$varLineColor]: `var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`
    }
});
const $8a25b5d5d6a7f6f0$var$grabAreaCollapsedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
    padding: 0,
    position: 'absolute',
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'default',
    insetBlockEnd: 0
});
const $8a25b5d5d6a7f6f0$var$lineStyles = {
    name: "w4swnc",
    styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
};
const $8a25b5d5d6a7f6f0$var$grabAreaLineSelector = {
    [(0, $ho1Ek.GRAB_AREA_LINE_SELECTOR)]: true
};
const $8a25b5d5d6a7f6f0$var$grabAreaSelector = {
    [(0, $ho1Ek.GRAB_AREA_SELECTOR)]: true
};
const $8a25b5d5d6a7f6f0$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>/*#__PURE__*/ (0, $byn9U.jsx)("button", {
        ...$8a25b5d5d6a7f6f0$var$grabAreaSelector,
        "aria-label": label,
        "data-testid": testId,
        disabled: isDisabled,
        "aria-hidden": isLeftSidebarCollapsed,
        type: "button",
        // The slider role is applied to a button to utilize the native
        // interactive and disabled functionality on the resize slider. While a
        // range input would be more semantically accurate, it does not affect
        // usability.
        role: "slider",
        css: [
            $8a25b5d5d6a7f6f0$var$grabAreaStyles,
            isLeftSidebarCollapsed && $8a25b5d5d6a7f6f0$var$grabAreaCollapsedStyles
        ],
        "aria-orientation": "vertical",
        "aria-valuenow": leftSidebarPercentageExpanded,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        ...rest
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8a25b5d5d6a7f6f0$var$lineStyles,
        ...$8a25b5d5d6a7f6f0$var$grabAreaLineSelector
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8a25b5d5d6a7f6f0$export$2e2bcd8739ae039 = $8a25b5d5d6a7f6f0$var$GrabArea;

});

parcelRegister("i4a2R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dae62e53e3b7495$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $gIpo4 = parcelRequire("gIpo4");


var $5LHuc = parcelRequire("5LHuc");

var $4Ywu9 = parcelRequire("4Ywu9");


var $ho1Ek = parcelRequire("ho1Ek");
function $2dae62e53e3b7495$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2dae62e53e3b7495$var$increaseHitAreaStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'absolute',
    insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
    insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
});
const $2dae62e53e3b7495$var$mobileStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        opacity: 1
    }
});
const $2dae62e53e3b7495$var$resizeIconButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: 24,
    height: 24,
    padding: "var(--ds-space-0, 0px)",
    position: 'absolute',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- TODO: https://product-fabric.atlassian.net/browse/DSP-3392; this boxShadow needs further investigation, along with the hover and active background colors.
    boxShadow: `0 0 0 1px ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)}, 0 2px 4px 1px ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)}`,
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    cursor: 'pointer',
    insetBlockStart: "var(--ds-space-400, 32px)",
    insetInlineStart: 0,
    /**
   * The fallback value of 0 ensures that the button is hidden by default,
   * unless some parent (or the button itself) overrides it.
   */ opacity: `var(--ds--resize-button--opacity,0)`,
    outline: 0,
    transform: 'translateX(-50%)',
    transition: `
    background-color ${(0, $5LHuc.smallDurationMs)}ms linear,
    color ${(0, $5LHuc.smallDurationMs)}ms linear,
    opacity ${(0, $5LHuc.mediumDurationMs)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)}
  `,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        backgroundColor: `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`,
        color: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active, :focus': {
        backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
        color: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
        opacity: 1
    }
});
const $2dae62e53e3b7495$var$resizeIconButtonExpandedStyles = {
    name: "1bl2513",
    styles: "transform:rotate(180deg);transform-origin:7px"
};
const $2dae62e53e3b7495$var$preventDefault = (event)=>event.preventDefault();
const $2dae62e53e3b7495$var$cssSelector = {
    [(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)]: true
};
const $2dae62e53e3b7495$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("button", {
        ...$2dae62e53e3b7495$var$cssSelector,
        "aria-expanded": !isLeftSidebarCollapsed,
        "aria-label": label,
        type: "button",
        // The error goes away when we remove the spread ...props
        css: [
            $2dae62e53e3b7495$var$resizeIconButtonStyles,
            $2dae62e53e3b7495$var$mobileStyles,
            !isLeftSidebarCollapsed && $2dae62e53e3b7495$var$resizeIconButtonExpandedStyles
        ],
        "data-testid": testId,
        // Prevents focus staying attached to the button when pressed
        onMouseDown: $2dae62e53e3b7495$var$preventDefault,
        ...props
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gIpo4))), {
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $2dae62e53e3b7495$var$increaseHitAreaStyles
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2dae62e53e3b7495$export$2e2bcd8739ae039 = $2dae62e53e3b7495$var$ResizeButton;

});

parcelRegister("4xMfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f6598dc29fb8ee8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $1RrwL = parcelRequire("1RrwL");
const $6f6598dc29fb8ee8$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
const $6f6598dc29fb8ee8$var$direction = 'to left';
const $6f6598dc29fb8ee8$var$transitionDuration = '0.22s';
const $6f6598dc29fb8ee8$var$shadowStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: 3,
    position: 'absolute',
    background: `var(--ds-border, ${`linear-gradient(${$6f6598dc29fb8ee8$var$direction}, ${$6f6598dc29fb8ee8$var$colorStops})`})`,
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: -1,
    opacity: 0.5,
    pointerEvents: 'none',
    transitionDuration: $6f6598dc29fb8ee8$var$transitionDuration,
    transitionProperty: 'left, opacity, width',
    transitionTimingFunction: (0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)
});
const $6f6598dc29fb8ee8$var$draggingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: 6,
    background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$6f6598dc29fb8ee8$var$direction}, ${$6f6598dc29fb8ee8$var$colorStops})`})`,
    insetInlineStart: "var(--ds-space-negative-075, -6px)",
    opacity: 0.8
});
const $6f6598dc29fb8ee8$var$Shadow = ({ testId: testId })=>{
    const isDragging = (0, $1RrwL.default)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: [
            $6f6598dc29fb8ee8$var$shadowStyles,
            isDragging && $6f6598dc29fb8ee8$var$draggingStyles
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6f6598dc29fb8ee8$export$2e2bcd8739ae039 = $6f6598dc29fb8ee8$var$Shadow;

});
parcelRegister("1RrwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34927c3d83b90ce$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ho1Ek = parcelRequire("ho1Ek");
const $f34927c3d83b90ce$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $ho1Ek.IS_SIDEBAR_DRAGGING)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $f34927c3d83b90ce$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $eUqFw.useState)($f34927c3d83b90ce$var$getIsDragging);
    (0, $eUqFw.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($f34927c3d83b90ce$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $ho1Ek.IS_SIDEBAR_DRAGGING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $f34927c3d83b90ce$export$2e2bcd8739ae039 = $f34927c3d83b90ce$var$useIsSidebarDragging;

});



parcelRegister("cJoHg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4edc19a03a491edc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $8YJjX = parcelRequire("8YJjX");

var $4Ywu9 = parcelRequire("4Ywu9");

var $ho1Ek = parcelRequire("ho1Ek");

var $1RrwL = parcelRequire("1RrwL");
function $4edc19a03a491edc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $4edc19a03a491edc$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
const $4edc19a03a491edc$var$mobileStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $ho1Ek.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $ho1Ek.BANNER_HEIGHT)} + ${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $ho1Ek.LEFT_PANEL_WIDTH)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
    }
});
const $4edc19a03a491edc$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $ho1Ek.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $ho1Ek.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $4edc19a03a491edc$var$fixedInnerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $ho1Ek.LEFT_SIDEBAR_WIDTH)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $ho1Ek.BANNER_HEIGHT)} + ${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $ho1Ek.LEFT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
});
const $4edc19a03a491edc$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $4edc19a03a491edc$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $4edc19a03a491edc$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $4edc19a03a491edc$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $1RrwL.default)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            // mobile viewport styles
            $4edc19a03a491edc$var$mobileStyles,
            isFlyoutOpen && $4edc19a03a491edc$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $4edc19a03a491edc$var$staticInnerStyles,
            isFixed && $4edc19a03a491edc$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $4edc19a03a491edc$var$fixedInnerFlyoutStyles,
            isDragging && $4edc19a03a491edc$var$draggingStyles,
            $4edc19a03a491edc$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4edc19a03a491edc$export$2e2bcd8739ae039 = $4edc19a03a491edc$var$LeftSidebarInner;

});

parcelRegister("c9QmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a594c1cfdafacace$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8YJjX = parcelRequire("8YJjX");

var $4Ywu9 = parcelRequire("4Ywu9");

var $ho1Ek = parcelRequire("ho1Ek");

var $1RrwL = parcelRequire("1RrwL");

var $a353s = parcelRequire("a353s");

var $ikQZw = parcelRequire("ikQZw");

var $gl6Cr = parcelRequire("gl6Cr");
function $a594c1cfdafacace$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $a594c1cfdafacace$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
const $a594c1cfdafacace$var$mobileStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $ho1Ek.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $ho1Ek.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
            content: "''"
        }
    }
});
const $a594c1cfdafacace$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $a594c1cfdafacace$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.LEFT_SIDEBAR_WIDTH),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $a594c1cfdafacace$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $a594c1cfdafacace$var$fixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $ho1Ek.LEFT_SIDEBAR_WIDTH)}`,
        content: "''"
    }
});
const $a594c1cfdafacace$var$flyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
const $a594c1cfdafacace$var$flyoutFixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH)
});
const $a594c1cfdafacace$var$selector = (0, $a353s.getPageLayoutSlotSelector)('left-sidebar');
const $a594c1cfdafacace$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $1RrwL.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $eUqFw.useContext)((0, $ikQZw.SidebarResizeContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                // mobile viewport styles
                $a594c1cfdafacace$var$mobileStyles,
                isFlyoutOpen && $a594c1cfdafacace$var$mobileFlyoutStyles,
                // generic styles
                $a594c1cfdafacace$var$outerStyles,
                isFixed && $a594c1cfdafacace$var$fixedStyles,
                isFlyoutOpen && $a594c1cfdafacace$var$flyoutStyles,
                isFlyoutOpen && isFixed && $a594c1cfdafacace$var$flyoutFixedStyles,
                isDragging && $a594c1cfdafacace$var$draggingStyles,
                $a594c1cfdafacace$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$a594c1cfdafacace$var$selector
        }, children));
};
const $a594c1cfdafacace$var$LeftSidebarOuter = /*#__PURE__*/ (0, $eUqFw.forwardRef)($a594c1cfdafacace$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a594c1cfdafacace$export$2e2bcd8739ae039 = $a594c1cfdafacace$var$LeftSidebarOuter;

});

parcelRegister("bxILY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1473b5175591b507$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $8YJjX = parcelRequire("8YJjX");

var $ho1Ek = parcelRequire("ho1Ek");

var $eeFjl = parcelRequire("eeFjl");
function $1473b5175591b507$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $1473b5175591b507$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
/**
 * The transition duration is intentionally set to 0ms.
 *
 * A transition is being used here to delay the setting of
 * opacity and visibility so that it syncs collapsing sidebar.
 */ const $1473b5175591b507$var$hideLeftSidebarContentsStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: 0,
    transition: `opacity 0ms linear, visibility 0ms linear`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `${(0, $ho1Ek.TRANSITION_DURATION) - 100}ms`,
    visibility: 'hidden'
});
const $1473b5175591b507$var$resizableChildrenWrapperStyles = {
    name: "xz78rr",
    styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
};
const $1473b5175591b507$var$fixedChildrenWrapperStyles = {
    name: "ax3w45",
    styles: "min-width:240px;height:100%"
};
const $1473b5175591b507$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
    const isCollapsing = (0, $eeFjl.default)();
    const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
    const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $1473b5175591b507$var$resizableChildrenWrapperStyles,
            isHidden && $1473b5175591b507$var$hideLeftSidebarContentsStyles,
            $1473b5175591b507$var$prefersReducedMotionStyles
        ],
        "aria-hidden": isHidden,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1473b5175591b507$var$fixedChildrenWrapperStyles
    }, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1473b5175591b507$export$2e2bcd8739ae039 = $1473b5175591b507$var$ResizableChildrenWrapper;

});
parcelRegister("eeFjl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c649bebf5f6629$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ho1Ek = parcelRequire("ho1Ek");
const $f4c649bebf5f6629$var$getIsCollapsing = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $ho1Ek.IS_SIDEBAR_COLLAPSING)) === 'true';
};
const $f4c649bebf5f6629$var$useIsSidebarCollapsing = ()=>{
    const [isCollapsing, setIsCollapsing] = (0, $eUqFw.useState)($f4c649bebf5f6629$var$getIsCollapsing);
    (0, $eUqFw.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsCollapsing($f4c649bebf5f6629$var$getIsCollapsing);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $ho1Ek.IS_SIDEBAR_COLLAPSING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isCollapsing;
};
var $f4c649bebf5f6629$export$2e2bcd8739ae039 = $f4c649bebf5f6629$var$useIsSidebarCollapsing;

});



parcelRegister("2Lkx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddeb7ceda1832e15$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $cJoHg = parcelRequire("cJoHg");

var $c9QmQ = parcelRequire("c9QmQ");

var $8cbHW = parcelRequire("8cbHW");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $ddeb7ceda1832e15$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH), width, shouldPersistWidth);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $c9QmQ.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
        variableName: (0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $cJoHg.default), {
        isFixed: isFixed
    }, children));
};
var $ddeb7ceda1832e15$export$2e2bcd8739ae039 = $ddeb7ceda1832e15$var$LeftSidebarWithoutResize;

});

parcelRegister("hNH8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaee6b83a63d3216$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8YJjX = parcelRequire("8YJjX");


var $ho1Ek = parcelRequire("ho1Ek");

var $1RrwL = parcelRequire("1RrwL");

var $a353s = parcelRequire("a353s");

var $ikQZw = parcelRequire("ikQZw");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");
function $eaee6b83a63d3216$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $eaee6b83a63d3216$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
const $eaee6b83a63d3216$var$mainStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
});
const $eaee6b83a63d3216$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $eaee6b83a63d3216$var$flyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT)}, ${(0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH)}px) + ${(0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $eaee6b83a63d3216$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $1RrwL.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $eUqFw.useContext)((0, $ikQZw.SidebarResizeContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("main", {
            "data-testid": testId,
            css: [
                $eaee6b83a63d3216$var$mainStyles,
                isDragging && $eaee6b83a63d3216$var$draggingStyles,
                isFlyoutOpen && !isFixed && $eaee6b83a63d3216$var$flyoutStyles,
                $eaee6b83a63d3216$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('main')
        }, children));
};
var $eaee6b83a63d3216$export$2e2bcd8739ae039 = $eaee6b83a63d3216$var$Main;

});

parcelRegister("4NoTP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ecc4fbcc1004c95$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4Ywu9 = parcelRequire("4Ywu9");

var $ho1Ek = parcelRequire("ho1Ek");

var $lDBEs = parcelRequire("lDBEs");
var $5cR7w = parcelRequire("5cR7w");

var $dFFYu = parcelRequire("dFFYu");
const $5ecc4fbcc1004c95$var$pageLayoutSelector = {
    [(0, $ho1Ek.PAGE_LAYOUT_CONTAINER_SELECTOR)]: true
};
const $5ecc4fbcc1004c95$var$gridTemplateAreasMobile = `
${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.BANNER)}"
  ${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.TOP_NAVIGATION)}"
  ${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.CONTENT)}"
 `;
const $5ecc4fbcc1004c95$var$gridTemplateAreas = `
${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.BANNER)} ${(0, $ho1Ek.RIGHT_PANEL)}"
  ${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.TOP_NAVIGATION)} ${(0, $ho1Ek.RIGHT_PANEL)}"
${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.CONTENT)} ${(0, $ho1Ek.RIGHT_PANEL)}"
 `;
const $5ecc4fbcc1004c95$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $5ecc4fbcc1004c95$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $ho1Ek.LEFT_PANEL_WIDTH)} minmax(0, 1fr) ${(0, $ho1Ek.RIGHT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $ho1Ek.BANNER_HEIGHT)} ${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)} auto`,
    outline: 'none'
});
const $5ecc4fbcc1004c95$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $5ecc4fbcc1004c95$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $ho1Ek.LEFT_PANEL_WIDTH)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $5ecc4fbcc1004c95$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $ho1Ek.DEFAULT_I18N_PROPS_SKIP_LINKS), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5cR7w.SkipLinksController), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dFFYu.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...$5ecc4fbcc1004c95$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $5ecc4fbcc1004c95$var$gridStyles,
            $5ecc4fbcc1004c95$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lDBEs.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $5ecc4fbcc1004c95$export$2e2bcd8739ae039 = $5ecc4fbcc1004c95$var$PageLayout;

});
parcelRegister("lDBEs", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeController", () => $d470ef5b352c70d4$export$850bd1bba41f1448);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $8YJjX = parcelRequire("8YJjX");

var $eT0WN = parcelRequire("eT0WN");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $ikQZw = parcelRequire("ikQZw");
const $d470ef5b352c70d4$var$handleDataAttributesAndCb = (callback = (0, $5Q9wj.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $ho1Ek.IS_SIDEBAR_COLLAPSING));
    callback(leftSidebarState);
};
const $d470ef5b352c70d4$var$leftSidebarSelector = (0, $a353s.getPageLayoutSlotCSSSelector)('left-sidebar');
const $d470ef5b352c70d4$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $eUqFw.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $eUqFw.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $eUqFw.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $eUqFw.useRef)(null);
    const mobileMediaQuery = (0, $eT0WN.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $eUqFw.useCallback)(()=>{
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery?.matches) {
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            transition.current?.complete();
            $d470ef5b352c70d4$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        transition.current?.action === 'expand') return;
        // flush existing transition
        transition.current?.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $d470ef5b352c70d4$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($d470ef5b352c70d4$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $8YJjX.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $74BVL.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth
    ]);
    const collapseLeftSidebar = (0, $eUqFw.useCallback)((event, collapseWithoutTransition)=>{
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery?.matches) {
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            transition.current?.complete();
            $d470ef5b352c70d4$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        transition.current?.action === 'collapse') return;
        // flush existing transition
        transition.current?.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $ho1Ek.IS_SIDEBAR_COLLAPSING), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $d470ef5b352c70d4$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($d470ef5b352c70d4$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $8YJjX.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $74BVL.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth
    ]);
    /**
	 * Conditionally toggle the expanding or collapsing the sidebars.
	 * This supports our mobile flyout mode as well.
	 */ const toggleLeftSidebar = (0, $eUqFw.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $eUqFw.useEffect)(function mount() {
        return function unmount() {
            transition.current?.abort();
        };
    }, []);
    const context = (0, $eUqFw.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ikQZw.SidebarResizeContext).Provider, {
        value: context
    }, children);
};

});

parcelRegister("5cR7w", function(module, exports) {

$parcel$export(module.exports, "SkipLinksController", () => $4539942660e627fc$export$da7be99d6a868f3d);

var $eUqFw = parcelRequire("eUqFw");

var $ho1Ek = parcelRequire("ho1Ek");

var $6cmgz = parcelRequire("6cmgz");
const $4539942660e627fc$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $ho1Ek.PAGE_LAYOUT_SLOT_SELECTOR)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
	 * If they are tied it is because one (or both) is
	 * a custom skiplink with a set index.
	 *
	 * Give the custom skiplink priority.
	 */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $4539942660e627fc$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $eUqFw.useState)([]);
    const registerSkipLink = (0, $eUqFw.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($4539942660e627fc$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $eUqFw.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6cmgz.SkipLinksContext).Provider, {
        value: context
    }, children);
};

});

parcelRegister("dFFYu", function(module, exports) {

$parcel$export(module.exports, "SkipLinkWrapper", () => $7927022d7be1354d$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $byn9U = parcelRequire("byn9U");

var $5OdZ3 = parcelRequire("5OdZ3");

var $8YJjX = parcelRequire("8YJjX");


var $ho1Ek = parcelRequire("ho1Ek");

var $6cmgz = parcelRequire("6cmgz");
function $7927022d7be1354d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $7927022d7be1354d$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
const $7927022d7be1354d$var$skipLinkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-250, 10px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, white)",
    border: 'none',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)}, 0 2px 10px ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)}, 0 0 20px -4px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`,
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $7927022d7be1354d$var$skipLinkHeadingStyles = {
    name: "16ceglb",
    styles: "font-weight:600"
};
const $7927022d7be1354d$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $7927022d7be1354d$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $7927022d7be1354d$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $7927022d7be1354d$var$assignIndex(num + 1, arr);
};
const $7927022d7be1354d$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $6cmgz.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
            const listIndex = $7927022d7be1354d$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $ho1Ek.PAGE_LAYOUT_CONTAINER_SELECTOR)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
    const label = skipLinksLabel || (0, $ho1Ek.DEFAULT_I18N_PROPS_SKIP_LINKS);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $7927022d7be1354d$var$skipLinkStyles,
            $7927022d7be1354d$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $byn9U.jsx)("p", {
        css: $7927022d7be1354d$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $byn9U.jsx)("ol", {
        css: $7927022d7be1354d$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $byn9U.jsx)($7927022d7be1354d$export$ef95c37428582a65, {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle))));
};
const $7927022d7be1354d$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $7927022d7be1354d$var$handleBlur);
};
const $7927022d7be1354d$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $7927022d7be1354d$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $7927022d7be1354d$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("li", {
        css: $7927022d7be1354d$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5OdZ3.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $7927022d7be1354d$var$focusTargetRef(href)
    }, children));
};

});


parcelRegister("epaF7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed7898ff788c8bd5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
const $ed7898ff788c8bd5$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.RIGHT_PANEL)
});
const $ed7898ff788c8bd5$var$fixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.RIGHT_PANEL_WIDTH),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineEnd: 0
});
/**
 * __Right panel__
 *
 * Provides a slot for a right panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $ed7898ff788c8bd5$var$RightPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $ho1Ek.DEFAULT_RIGHT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightPanelWidth = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_RIGHT_PANEL_WIDTH), width, shouldPersistWidth);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_RIGHT_PANEL_WIDTH)]: rightPanelWidth
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_RIGHT_PANEL_WIDTH)]: 0
            });
        };
    }, [
        rightPanelWidth
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $ed7898ff788c8bd5$var$baseStyles,
                isFixed && $ed7898ff788c8bd5$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('right-panel')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_RIGHT_PANEL_WIDTH),
            value: rightPanelWidth
        }), children));
};
var $ed7898ff788c8bd5$export$2e2bcd8739ae039 = $ed7898ff788c8bd5$var$RightPanel;

});

parcelRegister("mtJGd", function(module, exports) {

$parcel$export(module.exports, "default", () => $01bb915aea8f70d5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
function $01bb915aea8f70d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $01bb915aea8f70d5$var$fixedInnerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.RIGHT_SIDEBAR_WIDTH),
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $ho1Ek.BANNER_HEIGHT)} + ${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: `calc(${(0, $ho1Ek.RIGHT_PANEL_WIDTH)})`
});
const $01bb915aea8f70d5$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $01bb915aea8f70d5$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: (0, $ho1Ek.RIGHT_SIDEBAR_WIDTH)
});
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $01bb915aea8f70d5$var$fixedOuterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $ho1Ek.RIGHT_SIDEBAR_WIDTH),
        content: "''"
    }
});
/**
 * __Right sidebar__
 *
 * Provides a slot for a right sidebar within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $01bb915aea8f70d5$var$RightSidebar = (props)=>{
    const { children: children, width: width = (0, $ho1Ek.DEFAULT_RIGHT_SIDEBAR_WIDTH), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightSidebarWidth = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_RIGHT_SIDEBAR_WIDTH), width, shouldPersistWidth);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_RIGHT_SIDEBAR_WIDTH)]: rightSidebarWidth
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_RIGHT_SIDEBAR_WIDTH)]: 0
            });
        };
    }, [
        rightSidebarWidth,
        id
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), {
        isSidebar: true
    }, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-testid": testId,
            css: [
                $01bb915aea8f70d5$var$outerStyles,
                isFixed && $01bb915aea8f70d5$var$fixedOuterStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('right-sidebar')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_RIGHT_SIDEBAR_WIDTH),
            value: rightSidebarWidth
        }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                isFixed && $01bb915aea8f70d5$var$fixedInnerStyles,
                !isFixed && $01bb915aea8f70d5$var$staticInnerStyles
            ]
        }, children)));
};
var $01bb915aea8f70d5$export$2e2bcd8739ae039 = $01bb915aea8f70d5$var$RightSidebar;

});

parcelRegister("jnGaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0177ccf962ce75b6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
const $0177ccf962ce75b6$var$topNavigationStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $ho1Ek.TOP_NAVIGATION_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.TOP_NAVIGATION)
});
const $0177ccf962ce75b6$var$fixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $ho1Ek.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $ho1Ek.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $ho1Ek.LEFT_PANEL_WIDTH)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $0177ccf962ce75b6$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $ho1Ek.DEFAULT_TOP_NAVIGATION_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_TOP_NAVIGATION_HEIGHT), height, shouldPersistHeight);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_TOP_NAVIGATION_HEIGHT)]: topNavigationHeight
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_TOP_NAVIGATION_HEIGHT)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $0177ccf962ce75b6$var$topNavigationStyles,
                isFixed && $0177ccf962ce75b6$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_TOP_NAVIGATION_HEIGHT),
            value: topNavigationHeight
        }), children));
};
var $0177ccf962ce75b6$export$2e2bcd8739ae039 = $0177ccf962ce75b6$var$TopNavigation;

});

parcelRegister("GP1qj", function(module, exports) {

$parcel$export(module.exports, "useCustomSkipLink", () => $40616bd8cab79850$export$ee6b12c2613bdf8e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $6cmgz = parcelRequire("6cmgz");
const $40616bd8cab79850$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $6cmgz.useSkipLinks)();
    (0, $eUqFw.useEffect)(()=>{
        registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle,
            listIndex: listIndex
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        listIndex,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("8RCsc", function(module, exports) {

$parcel$export(module.exports, "Aside", () => $a9f4d5b3db3f99b5$export$ac3bdfe4cb17f64e);
/* aside.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $d7Ieg = parcelRequire("d7Ieg");

var $4Ywu9 = parcelRequire("4Ywu9");

var $fFyfw = parcelRequire("fFyfw");

var $lo97w = parcelRequire("lo97w");

var $3gqKb = parcelRequire("3gqKb");

var $59HcT = parcelRequire("59HcT");

var $5ahFM = parcelRequire("5ahFM");

var $1dw3N = parcelRequire("1dw3N");
const $a9f4d5b3db3f99b5$var$panelSplitterResizingVar = '--n_asdRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $a9f4d5b3db3f99b5$var$asideWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $a9f4d5b3db3f99b5$var$asideWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
const $a9f4d5b3db3f99b5$var$styles = {
    root: "_nd5lns35 _vchhusvi _kqswh2mm _glte1kzp _ndwch9n0",
    fixedContentArea: "_152t1l7u _1reo1wug _18m91wug _165t1run _13wn1if8"
};
function $a9f4d5b3db3f99b5$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixed, defaultWidth: defaultWidth = 330, label: label = 'Aside', testId: testId, id: id }) {
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)((0, $3gqKb.DangerouslyHoistSlotSizes));
    const UID = (0, $1dw3N.usePrefixedUID)();
    const CID = id ? id : UID;
    (0, $fFyfw.useSkipLink)(CID, label);
    const ref = (0, $eUqFw.useRef)(null);
    const [width, setWidth] = (0, $eUqFw.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const previousWidthProp = (0, $d7Ieg.default)(defaultWidth);
    /**
   * Updates the width state based on changes to `defaultWidth`.
   * This is temporary and needed to support the current usage in Jira, and will be removed once it is no longer needed.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $eUqFw.useEffect)(()=>{
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    // Putting the warning in a separate effect to avoid adding `previousWidthProp` as an effect dependency when updating width.
    (0, $eUqFw.useEffect)(()=>{}, [
        defaultWidth,
        previousWidthProp
    ]);
    const asideVariableWidth = `clamp(${$a9f4d5b3db3f99b5$var$asideWidthSlotBounds.min}, ${width}px, ${$a9f4d5b3db3f99b5$var$asideWidthSlotBounds.max})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("aside", {
        id: CID,
        "data-layout-slot": true,
        "aria-label": label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            $a9f4d5b3db3f99b5$var$styles.root,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $lo97w.asideVar)]: asideVariableWidth
        },
        "data-testid": testId,
        ref: ref
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $lo97w.UNSAFE_asideLayoutVar),
        value: "0px",
        mediaQuery: (0, $4Ywu9.media).above.md,
        responsiveValue: asideVariableWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ahFM.PanelSplitterProvider), {
        panelRef: ref,
        panelWidth: width,
        onCompleteResize: setWidth,
        resizeBounds: $a9f4d5b3db3f99b5$var$asideWidthResizeBounds,
        resizingCssVar: $a9f4d5b3db3f99b5$var$panelSplitterResizingVar,
        position: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            isFixed && $a9f4d5b3db3f99b5$var$styles.fixedContentArea
        ])
    }, children)));
}

});
parcelRegister("fFyfw", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $cff4951634cb48b3$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLink", () => $cff4951634cb48b3$export$89d9323301efc7d6);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $cff4951634cb48b3$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerSkipLink: (0, $5Q9wj.default),
    unregisterSkipLink: (0, $5Q9wj.default)
});
const $cff4951634cb48b3$export$c9d9cb2ee9590f87 = ()=>(0, $eUqFw.useContext)($cff4951634cb48b3$export$4c5cc3b14c7678a);
const $cff4951634cb48b3$export$89d9323301efc7d6 = (id, label, listIndex)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $cff4951634cb48b3$export$c9d9cb2ee9590f87();
    (0, $eUqFw.useEffect)(()=>{
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        label,
        listIndex,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("lo97w", function(module, exports) {

$parcel$export(module.exports, "sideNavVar", () => $634907d7dcb9cf8e$export$951bf5156e86d974);
$parcel$export(module.exports, "asideVar", () => $634907d7dcb9cf8e$export$594e6a30db7c057e);
$parcel$export(module.exports, "panelVar", () => $634907d7dcb9cf8e$export$db0c2e1d744fb281);
$parcel$export(module.exports, "bannerMountedVar", () => $634907d7dcb9cf8e$export$515a0b1baafe906c);
$parcel$export(module.exports, "topBarMountedVar", () => $634907d7dcb9cf8e$export$a96e934b2a1eeee);
$parcel$export(module.exports, "UNSAFE_topBarVar", () => $634907d7dcb9cf8e$export$f4afb213f937404c);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $634907d7dcb9cf8e$export$26354f9814213292);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $634907d7dcb9cf8e$export$6bfc931a04ec5741);
$parcel$export(module.exports, "UNSAFE_asideLayoutVar", () => $634907d7dcb9cf8e$export$bbbace2ff0c7ae1b);
$parcel$export(module.exports, "UNSAFE_panelLayoutVar", () => $634907d7dcb9cf8e$export$753bf7651b25db91);
$parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", () => $634907d7dcb9cf8e$export$6460bd6a2446260);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", () => $634907d7dcb9cf8e$export$3055529fab2b4edf);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", () => $634907d7dcb9cf8e$export$166d8fd766c3eb92);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $634907d7dcb9cf8e$export$951bf5156e86d974 = '--n_sNvw';
const $634907d7dcb9cf8e$export$594e6a30db7c057e = '--n_asDw';
const $634907d7dcb9cf8e$export$db0c2e1d744fb281 = '--n_pnlW';
const $634907d7dcb9cf8e$export$515a0b1baafe906c = '--n_bnrM';
const $634907d7dcb9cf8e$export$a96e934b2a1eeee = '--n_tbrM';
const $634907d7dcb9cf8e$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tbrM, 0px))`;
const $634907d7dcb9cf8e$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tbrM, 0px))`;
const $634907d7dcb9cf8e$export$f4afb213f937404c = '--topNavigationHeight';
const $634907d7dcb9cf8e$export$26354f9814213292 = '--bannerHeight';
const $634907d7dcb9cf8e$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $634907d7dcb9cf8e$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $634907d7dcb9cf8e$export$753bf7651b25db91 = '--rightPanelWidth';
const $634907d7dcb9cf8e$export$6460bd6a2446260 = `calc(var(${$634907d7dcb9cf8e$export$26354f9814213292}, 0px) + var(${$634907d7dcb9cf8e$export$f4afb213f937404c}, 0px))`;
const $634907d7dcb9cf8e$export$3055529fab2b4edf = `var(${$634907d7dcb9cf8e$export$6bfc931a04ec5741}, 0px)`;
const $634907d7dcb9cf8e$export$166d8fd766c3eb92 = `calc(var(${$634907d7dcb9cf8e$export$bbbace2ff0c7ae1b}, 0px) + var(${$634907d7dcb9cf8e$export$753bf7651b25db91}, 0px))`;
const $634907d7dcb9cf8e$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    topBarBorder: 3,
    sideNav: 2,
    contentBlockBorder: 2,
    contentInlineBorder: 1,
    panelSmallViewports: 1
};

});

parcelRegister("3gqKb", function(module, exports) {

$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $2e1d151264f22441$export$66e2c1a0115af861);

var $eUqFw = parcelRequire("eUqFw");
const $2e1d151264f22441$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);

});

parcelRegister("59HcT", function(module, exports) {

$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $71e37afe5eb208b7$export$cfa3cd08d675e56e);
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $71e37afe5eb208b7$export$9f45a1325e3cdfb8);

var $eUqFw = parcelRequire("eUqFw");

var $aXlvz = parcelRequire("aXlvz");
const $71e37afe5eb208b7$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", null, `#${(0, $aXlvz.gridRootId)} { ${variableName}: ${value}px }`);
const $71e37afe5eb208b7$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $71e37afe5eb208b7$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$71e37afe5eb208b7$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$71e37afe5eb208b7$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", null, style));
};

});
parcelRegister("aXlvz", function(module, exports) {

$parcel$export(module.exports, "gridRootId", () => $e23a0d59e56b6e8e$export$a6d827031bcb31d1);
$parcel$export(module.exports, "Root", () => $e23a0d59e56b6e8e$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $49NXB = parcelRequire("49NXB");

var $6Ox7A = parcelRequire("6Ox7A");

var $hSCF4 = parcelRequire("hSCF4");

var $3gqKb = parcelRequire("3gqKb");

var $fU1fm = parcelRequire("fU1fm");

var $gonCh = parcelRequire("gonCh");

var $33BiM = parcelRequire("33BiM");
const $e23a0d59e56b6e8e$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $e23a0d59e56b6e8e$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};
function $e23a0d59e56b6e8e$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId }) {
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        var child;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $33BiM.SideNavVisibilityProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gonCh.SideNavToggleButtonProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fU1fm.SideNavFlyoutLockProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Ox7A.HomeActionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3gqKb.DangerouslyHoistSlotSizes).Provider, {
        value: UNSAFE_dangerouslyHoistSlotSizes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSCF4.SkipLinksProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49NXB.SkipLinksContainer), {
        label: skipLinksLabel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            $e23a0d59e56b6e8e$var$styles.root,
            xcss
        ]),
        id: $e23a0d59e56b6e8e$export$a6d827031bcb31d1,
        "data-testid": testId
    }, children)))))));
}

});
parcelRegister("49NXB", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContainer", () => $9db07f1ca581a75c$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1Yimi = parcelRequire("1Yimi");

var $1cxMg = parcelRequire("1cxMg");

var $cLbGO = parcelRequire("cLbGO");
// TODO (BLU-3215): Fix avoid using ts-ignore
const $9db07f1ca581a75c$var$styles = {
    root: "_18s8v47k _1rjcu2gc _18zr12x7 _kqsw1n9t _1pby1mrw _11q71bhr _2rkoglpi _16qs1cd0 _1e02qkuk _tzy4idpf _t9ec1i34 _1digjh3g _gtjaidpf _1mygkb7n _66dk1kli",
    skipLinkList: "_1x8w11lx _2mzuglyw _1pfh1b66 _bozg1sck"
};
// Correctly typed handler for use with native DOM events
const $9db07f1ca581a75c$var$handleBlur = (event)=>{
    if (!(event.target instanceof Element)) return;
    event.target.removeAttribute('tabindex');
    event.target.removeEventListener('blur', $9db07f1ca581a75c$var$handleBlur);
};
const $9db07f1ca581a75c$var$escapeHandler = (event)=>{
    if (event.key === 'Escape') {
        const activeElement = document.activeElement;
        if (activeElement !== null) activeElement.blur();
    }
};
const $9db07f1ca581a75c$var$attachEscHandler = ()=>window.addEventListener('keydown', $9db07f1ca581a75c$var$escapeHandler, false);
const $9db07f1ca581a75c$var$removeEscHandler = ()=>window.removeEventListener('keydown', $9db07f1ca581a75c$var$escapeHandler, false);
const $9db07f1ca581a75c$export$fce25a0c32fbc1e1 = ({ label: label })=>{
    const sortedSkipLinks = (0, $1cxMg.useSortedSkipLinks)();
    if (sortedSkipLinks.length === 0) return null;
    const emptyLabelOverride = !!label?.match(/^\s+$/);
    return /*#__PURE__*/ $eUqFw.createElement("div", {
        onFocus: $9db07f1ca581a75c$var$attachEscHandler,
        onBlur: $9db07f1ca581a75c$var$removeEscHandler,
        className: (0, $7JEyt.default)([
            $9db07f1ca581a75c$var$styles.root
        ])
    }, emptyLabelOverride ? null : /*#__PURE__*/ $eUqFw.createElement((0, $1Yimi.default), {
        weight: "medium"
    }, label), /*#__PURE__*/ $eUqFw.createElement("ol", {
        className: (0, $7JEyt.default)([
            $9db07f1ca581a75c$var$styles.skipLinkList
        ])
    }, sortedSkipLinks.map(({ id: id, label: label })=>/*#__PURE__*/ $eUqFw.createElement((0, $cLbGO.SkipLink), {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, label))));
};

});
parcelRegister("1cxMg", function(module, exports) {

$parcel$export(module.exports, "SkipLinksDataContext", () => $d0fce90ab267e67c$export$e9ab38ce6147d3d2);
$parcel$export(module.exports, "useSortedSkipLinks", () => $d0fce90ab267e67c$export$b0b0d4fc1b356759);

var $eUqFw = parcelRequire("eUqFw");
const $d0fce90ab267e67c$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $eUqFw.createContext)([]);
const $d0fce90ab267e67c$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $d0fce90ab267e67c$var$assignIndex(num + 1, arr);
};
const $d0fce90ab267e67c$var$sortSkipLinks = (arr)=>{
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
        const listIndex = $d0fce90ab267e67c$var$assignIndex(idx, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIdx
    ].sort((a, b)=>a.listIndex - b.listIndex);
};
const $d0fce90ab267e67c$export$b0b0d4fc1b356759 = ()=>{
    const skipLinksData = (0, $eUqFw.useContext)($d0fce90ab267e67c$export$e9ab38ce6147d3d2);
    return (0, $eUqFw.useMemo)(()=>{
        return $d0fce90ab267e67c$var$sortSkipLinks(skipLinksData);
    }, [
        skipLinksData
    ]);
};

});

parcelRegister("cLbGO", function(module, exports) {

$parcel$export(module.exports, "SkipLink", () => $43d99785e2aa1928$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4kMup = parcelRequire("4kMup");
const $43d99785e2aa1928$var$styles = {
    skipLinkListItem: "_1pfhze3t"
};
const $43d99785e2aa1928$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $43d99785e2aa1928$var$assignIndex(num + 1, arr);
};
const $43d99785e2aa1928$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $43d99785e2aa1928$var$handleBlur);
};
const $43d99785e2aa1928$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $43d99785e2aa1928$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $43d99785e2aa1928$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ $eUqFw.createElement("li", {
        className: (0, $7JEyt.default)([
            $43d99785e2aa1928$var$styles.skipLinkListItem
        ])
    }, /*#__PURE__*/ $eUqFw.createElement((0, $4kMup.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $43d99785e2aa1928$var$focusTargetRef(href)
    }, children));
};

});


parcelRegister("6Ox7A", function(module, exports) {

$parcel$export(module.exports, "HomeActionsProvider", () => $726f2d22e63943f9$export$8b9089606266983e);

var $eUqFw = parcelRequire("eUqFw");

var $idDgv = parcelRequire("idDgv");
const $726f2d22e63943f9$export$8b9089606266983e = ({ children: children })=>{
    const [element, setElement] = (0, $eUqFw.useState)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idDgv.HomeActionsElement).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idDgv.HomeActionsAttachRef).Provider, {
        value: setElement
    }, children));
};

});
parcelRegister("idDgv", function(module, exports) {

$parcel$export(module.exports, "HomeActionsElement", () => $5ad3a401b16a7c96$export$4128169e0878a41d);
$parcel$export(module.exports, "HomeActionsAttachRef", () => $5ad3a401b16a7c96$export$762fcfeaa67873eb);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $5ad3a401b16a7c96$export$4128169e0878a41d = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $5ad3a401b16a7c96$export$762fcfeaa67873eb = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $5Q9wj.default));

});


parcelRegister("hSCF4", function(module, exports) {

$parcel$export(module.exports, "SkipLinksProvider", () => $08bc73fcd53878b8$export$fe514f9f7b03d46f);

var $eUqFw = parcelRequire("eUqFw");

var $fFyfw = parcelRequire("fFyfw");

var $1cxMg = parcelRequire("1cxMg");
const $08bc73fcd53878b8$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
const $08bc73fcd53878b8$export$fe514f9f7b03d46f = ({ children: children })=>{
    const [links, setLinks] = (0, $eUqFw.useState)([]);
    const registerSkipLink = (0, $eUqFw.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($08bc73fcd53878b8$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $eUqFw.useCallback)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    }, []);
    const contextValue = (0, $eUqFw.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fFyfw.SkipLinksContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1cxMg.SkipLinksDataContext).Provider, {
        value: links
    }, children));
};

});

parcelRegister("fU1fm", function(module, exports) {

$parcel$export(module.exports, "SideNavFlyoutLockProvider", () => $faf8735a79bb7589$export$7003dd76deb92ad);

var $eUqFw = parcelRequire("eUqFw");

var $fgdRB = parcelRequire("fgdRB");
const $faf8735a79bb7589$export$7003dd76deb92ad = ({ children: children })=>{
    // State is used so that we re-render subscribers when the flyout lock count changes.
    // Otherwise we could get into a situation where all flyout locks are removed, but the flyout stays open as
    // nothing has triggered it to update.
    const [flyoutLock, setFlyoutLock] = (0, $eUqFw.useState)(0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fgdRB.FlyoutLockCount).Provider, {
        value: flyoutLock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fgdRB.SetFlyoutLockCount).Provider, {
        value: setFlyoutLock
    }, children));
};

});
parcelRegister("fgdRB", function(module, exports) {

$parcel$export(module.exports, "FlyoutLockCount", () => $5014f5f8354c54eb$export$962eb1e8d553c86f);
$parcel$export(module.exports, "SetFlyoutLockCount", () => $5014f5f8354c54eb$export$52e873d56b3942a3);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $5014f5f8354c54eb$export$962eb1e8d553c86f = /*#__PURE__*/ (0, $eUqFw.createContext)(0);
const $5014f5f8354c54eb$export$52e873d56b3942a3 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $5Q9wj.default));

});


parcelRegister("gonCh", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $24ba3345c27da1a9$export$ceb8e60e9790fc0f);

var $eUqFw = parcelRequire("eUqFw");

var $dzFRa = parcelRequire("dzFRa");
const $24ba3345c27da1a9$export$ceb8e60e9790fc0f = ({ children: children })=>{
    const [element, setElement] = (0, $eUqFw.useState)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dzFRa.SideNavToggleButtonElement).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dzFRa.SideNavToggleButtonAttachRef).Provider, {
        value: setElement
    }, children));
};

});
parcelRegister("dzFRa", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonElement", () => $bfe4bbf980492158$export$9c1768094bef896);
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", () => $bfe4bbf980492158$export$fb8fa9a80240785e);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $bfe4bbf980492158$export$9c1768094bef896 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $bfe4bbf980492158$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $5Q9wj.default));

});


parcelRegister("33BiM", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityProvider", () => $9fd9fc9aed4e4a0c$export$aac8e996360f6ad9);

var $eUqFw = parcelRequire("eUqFw");

var $iER3z = parcelRequire("iER3z");
const $9fd9fc9aed4e4a0c$export$aac8e996360f6ad9 = ({ children: children })=>{
    const [visibleOnDesktop, setVisibleOnDesktop] = (0, $eUqFw.useState)(null);
    const [visibleOnMobile, setVisibleOnMobile] = (0, $eUqFw.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iER3z.SideNavDesktopVisibility).Provider, {
        value: visibleOnDesktop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iER3z.SetSideNavDesktopVisibility).Provider, {
        value: setVisibleOnDesktop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iER3z.SideNavMobileVisibility).Provider, {
        value: visibleOnMobile
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iER3z.SetSideNavMobileVisibility).Provider, {
        value: setVisibleOnMobile
    }, children))));
};

});
parcelRegister("iER3z", function(module, exports) {

$parcel$export(module.exports, "SideNavDesktopVisibility", () => $4dcee95967128e39$export$1771e3b63861d206);
$parcel$export(module.exports, "SideNavMobileVisibility", () => $4dcee95967128e39$export$c5f483eeea865395);
$parcel$export(module.exports, "SetSideNavDesktopVisibility", () => $4dcee95967128e39$export$5edca135c5bde4af);
$parcel$export(module.exports, "SetSideNavMobileVisibility", () => $4dcee95967128e39$export$64be6ca751606276);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $4dcee95967128e39$export$1771e3b63861d206 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $4dcee95967128e39$export$c5f483eeea865395 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const $4dcee95967128e39$export$5edca135c5bde4af = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $5Q9wj.default));
const $4dcee95967128e39$export$64be6ca751606276 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $5Q9wj.default));

});




parcelRegister("5ahFM", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterProvider", () => $4dc8d8bb906fc7d0$export$f662bfb764348932);
/* provider.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bAHwD = parcelRequire("bAHwD");
const $4dc8d8bb906fc7d0$var$styles = {
    panelChildrenWrapper: "_1reo1wug _18m91wug _4t3i1osq _1e0c1txw _2lx21bp4"
};
const $4dc8d8bb906fc7d0$export$f662bfb764348932 = ({ panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, position: position = 'end', isEnabled: isEnabled = true, children: children })=>{
    const portalRef = (0, $eUqFw.useRef)(null);
    const context = (0, $eUqFw.useMemo)(()=>({
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            resizeBounds: resizeBounds,
            portalRef: portalRef,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled
        }), [
        isEnabled,
        onCompleteResize,
        panelRef,
        panelWidth,
        position,
        resizeBounds,
        resizingCssVar
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ $eUqFw.createElement((0, $bAHwD.PanelSplitterContext).Provider, {
        value: context
    }, /*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            $4dc8d8bb906fc7d0$var$styles.panelChildrenWrapper
        ])
    }, children)), /*#__PURE__*/ $eUqFw.createElement("div", {
        ref: portalRef
    }));
};

});
parcelRegister("bAHwD", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterContext", () => $889134b4296ac497$export$7a4054f2c546f2cd);

var $eUqFw = parcelRequire("eUqFw");
const $889134b4296ac497$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});


parcelRegister("1dw3N", function(module, exports) {

$parcel$export(module.exports, "usePrefixedUID", () => $fd6f80f14992a59d$export$86433d4fd18455f4);

var $1UENk = parcelRequire("1UENk");
const $fd6f80f14992a59d$export$86433d4fd18455f4 = (prefix = 'element')=>`${prefix}-${(0, $1UENk.useId)()}`;

});


parcelRegister("kWfO4", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $c13415591b3596f4$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $fFyfw = parcelRequire("fFyfw");

var $lo97w = parcelRequire("lo97w");

var $3gqKb = parcelRequire("3gqKb");

var $59HcT = parcelRequire("59HcT");

var $1dw3N = parcelRequire("1dw3N");
const $c13415591b3596f4$var$styles = {
    root: "_nd5ldkfm _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat _1reo15vq _18m915vq"
};
function $c13415591b3596f4$export$3b4e64e77073e307({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 64, label: label = 'Banner', testId: testId, id: id }) {
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)((0, $3gqKb.DangerouslyHoistSlotSizes));
    const UID = (0, $1dw3N.usePrefixedUID)();
    const CID = id ? id : UID;
    (0, $fFyfw.useSkipLink)(CID, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: CID,
        role: "banner",
        "data-layout-slot": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            $c13415591b3596f4$var$styles.root,
            xcss
        ]),
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.HoistCssVarToLocalGrid), {
        variableName: (0, $lo97w.bannerMountedVar),
        value: UNSAFE_height
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $lo97w.UNSAFE_bannerVar),
        value: UNSAFE_height
    }), children);
}

});

parcelRegister("i3WpJ", function(module, exports) {

$parcel$export(module.exports, "Main", () => $6db13c767a4e108f$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $fFyfw = parcelRequire("fFyfw");

var $fXDWV = parcelRequire("fXDWV");

var $1dw3N = parcelRequire("1dw3N");

var $cg5FJ = parcelRequire("cg5FJ");
const $6db13c767a4e108f$var$styles = {
    root: "_nd5l1gzg _19121cl4 _qwfh1wug",
    mainCurvedCorner: "_1orwi2wt",
    fixedContentArea: "_152t1l7u _1reo1wug _18m91wug _165t1run _13wn1if8"
};
const $6db13c767a4e108f$var$contentBorderStyles = {
    largeViewportTop: "_vchhusvi _mqm2zgxb _1e0cglyw _p3z31gzg _18911gzg _14611gzg _f0zu1mrw _4t3i1run _152t1l7u _lcxvglyw _kqsw1if8 _1pbycs5v _dm2518uv",
    largeViewportLeft: "_vchhusvi _izbqoyrj _191wzgxb _1s1gi2wt _1e0cglyw _p3z31gzg _18911gzg _14611gzg _f0zu1mrw _4t3i1run _152t1l7u _lcxvglyw _kqsw1if8 _1pbykb7n _dm2518uv",
    curvedBorder: "_1s1gi2wt _h7aloyrj"
};
function $6db13c767a4e108f$export$861edd1ccea2f746({ children: children, isFixed: isFixed, xcss: xcss, label: label = 'Main Content', testId: testId, id: id }) {
    const UID = (0, $1dw3N.usePrefixedUID)();
    const CID = id ? id : UID;
    const { visibleOnDesktop: isSideNavVisibleOnDesktop } = (0, $fXDWV.useSideNavVisibility)();
    (0, $fFyfw.useSkipLink)(CID, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: CID,
        "data-layout-slot": true,
        "aria-label": label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            $6db13c767a4e108f$var$styles.root,
            isSideNavVisibleOnDesktop && $6db13c767a4e108f$var$styles.mainCurvedCorner,
            isFixed && $6db13c767a4e108f$var$styles.fixedContentArea,
            xcss
        ]),
        role: "main",
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cg5FJ.MainStickyContext).Provider, {
        value: Boolean(isFixed)
    }, children)), isSideNavVisibleOnDesktop && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // CALL OUT: If this component is NOT mounted then the border around the
        // content area on large viewports will NOT be rendered.
        "data-layout-slot": true,
        className: (0, $7JEyt.default)([
            $6db13c767a4e108f$var$contentBorderStyles.largeViewportLeft
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-layout-slot": true,
        className: (0, $7JEyt.default)([
            $6db13c767a4e108f$var$contentBorderStyles.largeViewportTop,
            isSideNavVisibleOnDesktop && $6db13c767a4e108f$var$contentBorderStyles.curvedBorder
        ])
    }));
}

});
parcelRegister("fXDWV", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibility", () => $8163baf14e0483b1$export$4a602ad7e09bdb2c);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $iER3z = parcelRequire("iER3z");
const $8163baf14e0483b1$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const visibleOnDesktop = (0, $eUqFw.useContext)((0, $iER3z.SideNavDesktopVisibility));
    const setVisibleOnDesktop = (0, $eUqFw.useContext)((0, $iER3z.SetSideNavDesktopVisibility));
    const visibleOnMobile = (0, $eUqFw.useContext)((0, $iER3z.SideNavMobileVisibility));
    const setVisibleOnMobile = (0, $eUqFw.useContext)((0, $iER3z.SetSideNavMobileVisibility));
    const [isSideNavVisible, setIsSideNavVisible] = (0, $eUqFw.useState)(!defaultCollapsed);
    (0, $eUqFw.useEffect)(()=>{
        const isSideNavVisibleOnDesktop = visibleOnDesktop === null ? !defaultCollapsed : visibleOnDesktop;
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        setIsSideNavVisible(mediaQueryList.matches ? isSideNavVisibleOnDesktop : visibleOnMobile);
        // reactive screen size changes
        return (0, $74BVL.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavVisible(mediaQueryList.matches ? isSideNavVisibleOnDesktop : visibleOnMobile);
            }
        });
    }, [
        defaultCollapsed,
        visibleOnDesktop,
        visibleOnMobile
    ]);
    const showSideNav = (0, $eUqFw.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        matches ? setVisibleOnDesktop(true) : setVisibleOnMobile(true);
    }, [
        setVisibleOnDesktop,
        setVisibleOnMobile
    ]);
    return {
        visibleOnDesktop: visibleOnDesktop === null ? !defaultCollapsed : visibleOnDesktop,
        visibleOnMobile: visibleOnMobile,
        setVisibleOnDesktop: setVisibleOnDesktop,
        setVisibleOnMobile: setVisibleOnMobile,
        isSideNavVisible: isSideNavVisible,
        showSideNav: showSideNav
    };
};

});

parcelRegister("cg5FJ", function(module, exports) {

$parcel$export(module.exports, "MainStickyContext", () => $47528b693182cd21$export$3b369e2c6c1ec840);

var $eUqFw = parcelRequire("eUqFw");
const $47528b693182cd21$export$3b369e2c6c1ec840 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);

});


parcelRegister("exw0h", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $602b112f7d8b4af7$export$2ddb90ad54e5f587);
/* panel.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $4Ywu9 = parcelRequire("4Ywu9");

var $fFyfw = parcelRequire("fFyfw");

var $lo97w = parcelRequire("lo97w");

var $3gqKb = parcelRequire("3gqKb");

var $59HcT = parcelRequire("59HcT");

var $5ahFM = parcelRequire("5ahFM");

var $1dw3N = parcelRequire("1dw3N");
const $602b112f7d8b4af7$var$panelSplitterResizingVar = '--n_pnlRsz';
const $602b112f7d8b4af7$var$panelWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $602b112f7d8b4af7$var$panelWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
const $602b112f7d8b4af7$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3i1run _kqsw1if8 _152t1l7u _1bsb1adv _14b54rrg _1dhy1c6w _9sns1wug",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq"
};
function $602b112f7d8b4af7$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365, label: label = 'Panel', testId: testId, id: id, xcss: xcss }) {
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)((0, $3gqKb.DangerouslyHoistSlotSizes));
    const UID = (0, $1dw3N.usePrefixedUID)();
    const CID = id ? id : UID;
    (0, $fFyfw.useSkipLink)(CID, label);
    const ref = (0, $eUqFw.useRef)(null);
    const [width, setWidth] = (0, $eUqFw.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $eUqFw.useRef)(defaultWidth);
    /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $eUqFw.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    const panelVariableWidth = `clamp(${$602b112f7d8b4af7$var$panelWidthSlotBounds.min}, ${width}px, ${$602b112f7d8b4af7$var$panelWidthSlotBounds.max})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
        id: CID,
        "data-layout-slot": true,
        "aria-label": label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $7JEyt.default)([
            $602b112f7d8b4af7$var$styles.root,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $lo97w.panelVar)]: panelVariableWidth
        },
        "data-testid": testId,
        ref: ref
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $lo97w.UNSAFE_panelLayoutVar),
        value: "0px",
        mediaQuery: (0, $4Ywu9.media).above.lg,
        responsiveValue: panelVariableWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ahFM.PanelSplitterProvider), {
        panelRef: ref,
        panelWidth: width,
        onCompleteResize: setWidth,
        resizeBounds: $602b112f7d8b4af7$var$panelWidthResizeBounds,
        resizingCssVar: $602b112f7d8b4af7$var$panelSplitterResizingVar,
        position: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $602b112f7d8b4af7$var$styles.scrollContainer
        ])
    }, children)));
}

});

parcelRegister("iHNtK", function(module, exports) {

$parcel$export(module.exports, "SideNav", () => $6146f4ee5c281fb0$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $iZQWz = parcelRequire("iZQWz");
var $gbGcd = parcelRequire("gbGcd");

var $XHGTv = parcelRequire("XHGTv");

var $4Ywu9 = parcelRequire("4Ywu9");

var $iGOPs = parcelRequire("iGOPs");

var $idDgv = parcelRequire("idDgv");

var $fFyfw = parcelRequire("fFyfw");

var $lo97w = parcelRequire("lo97w");

var $3gqKb = parcelRequire("3gqKb");

var $59HcT = parcelRequire("59HcT");

var $5ahFM = parcelRequire("5ahFM");

var $1dw3N = parcelRequire("1dw3N");

var $fgdRB = parcelRequire("fgdRB");

var $dzFRa = parcelRequire("dzFRa");

var $fXDWV = parcelRequire("fXDWV");

var $ilfLI = parcelRequire("ilfLI");

var $iP6ac = parcelRequire("iP6ac");
const $6146f4ee5c281fb0$var$panelSplitterResizingVar = '--n_snvRsz';
const $6146f4ee5c281fb0$var$widthResizeBounds = {
    min: '160px',
    max: '50vw'
};
const $6146f4ee5c281fb0$var$sideNavFlyoutCloseDelayMs = 400;
/**
 * Returns the current state of the side nav based on the provided props.
 * It has been ordered to ensure that the flyout state is least prioritised over the other toggled visibility states
 */ const $6146f4ee5c281fb0$var$getSideNavState = ({ visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile, isFlyoutVisible: isFlyoutVisible })=>{
    if (visibleOnDesktop && visibleOnMobile) return 'idle';
    if (!visibleOnMobile && visibleOnDesktop) return 'hiddenMobileOnly';
    if (!visibleOnDesktop && isFlyoutVisible) return 'flyout';
    if (visibleOnMobile && !visibleOnDesktop) return 'hiddenDesktopOnly';
    return 'hiddenMobileAndDesktop';
};
const $6146f4ee5c281fb0$var$styles = {
    root: "_bfhk1bhr _16qs1cd0 _nd5l1b6c _4t3i1run _152t1l7u _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _4ap3vuon _scbpglyw _qilnk0mc",
    flyout: "_4ap31bhr _scbp1cd0 _qiln1gzg",
    interactionSurface: "_1bsb1osq _4t3i1osq",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw"
};
/**
 * This component is used while rolling out the refactor to the side nav flyout lock.
 * It will be cleaned up once the rollout is complete.
 *
 * https://jplat.atlassian.net/browse/BLU-4636
 * https://switcheroo.atlassian.com/ui/gates/fa57329a-7759-4128-975c-7d6f5e7e4f60/key/platform_design_system_team_layering_observer
 */ function $6146f4ee5c281fb0$var$SideNavInternalLegacy({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Side Navigation', onExpand: onExpand, onCollapse: onCollapse, id: id }) {
    const UID = (0, $1dw3N.usePrefixedUID)();
    const CID = id ? id : UID;
    (0, $fFyfw.useSkipLink)(CID, label);
    const { visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile, setVisibleOnDesktop: setVisibleOnDesktop } = (0, $fXDWV.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const [width, setWidth] = (0, $eUqFw.useState)(defaultWidth);
    const clampedWidth = `clamp(${$6146f4ee5c281fb0$var$widthResizeBounds.min}, ${width}px, ${$6146f4ee5c281fb0$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)((0, $3gqKb.DangerouslyHoistSlotSizes));
    const navRef = (0, $eUqFw.useRef)(null);
    const toggleButtonElement = (0, $eUqFw.useContext)((0, $dzFRa.SideNavToggleButtonElement));
    const homeActionsElement = (0, $eUqFw.useContext)((0, $idDgv.HomeActionsElement));
    const devTimeOnlyAttributes = {};
    const [isFlyoutActive, setIsFlyoutActive] = (0, $eUqFw.useState)(false);
    const flyoutLockCount = (0, $eUqFw.useContext)((0, $fgdRB.FlyoutLockCount));
    const isFlyoutLocked = flyoutLockCount > 0;
    // The flyout is open if:
    // a. The user has actively hovered over the flyout areas (side nav toggle button, side nav), or
    // b. The flyout is locked open by a flyout lock
    const isFlyoutVisible = isFlyoutActive || isFlyoutLocked;
    const sideNavState = $6146f4ee5c281fb0$var$getSideNavState({
        visibleOnDesktop: visibleOnDesktop,
        visibleOnMobile: visibleOnMobile,
        isFlyoutVisible: isFlyoutVisible
    });
    // A timeout reference is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
    // us to cancel the close if the user mouses back in.
    const closeFlyoutTimerRef = (0, $eUqFw.useRef)(null);
    const cancelPendingFlyoutClose = (0, $eUqFw.useCallback)(()=>{
        if (closeFlyoutTimerRef.current) {
            clearTimeout(closeFlyoutTimerRef.current);
            closeFlyoutTimerRef.current = null;
        }
    }, []);
    const openFlyout = (0, $eUqFw.useCallback)(()=>{
        cancelPendingFlyoutClose();
        setIsFlyoutActive(true);
    }, [
        cancelPendingFlyoutClose
    ]);
    // Starts a timer to close the flyout after a delay. It will only start a new timer if one isn't already pending.
    const tryStartCloseFlyoutTimer = (0, $eUqFw.useCallback)(()=>{
        if (closeFlyoutTimerRef.current) // There is already a close timer pending, so we won't need to start another one.
        return;
        closeFlyoutTimerRef.current = setTimeout(()=>{
            closeFlyoutTimerRef.current = null;
            setIsFlyoutActive(false);
        }, $6146f4ee5c281fb0$var$sideNavFlyoutCloseDelayMs);
    }, []);
    const toggleVisibility = (0, $iP6ac.useToggleSideNav)();
    // Sync the visibility in context with the local state value after SSR hydration, as it contains the default value from props
    (0, $eUqFw.useEffect)(()=>{
        setVisibleOnDesktop(visibleOnDesktop);
    }, [
        setVisibleOnDesktop,
        visibleOnDesktop
    ]);
    (0, $ilfLI.useSideNavVisibilityCallbacks)({
        onExpand: onExpand,
        onCollapse: onCollapse,
        visibleOnDesktop: visibleOnDesktop,
        visibleOnMobile: visibleOnMobile
    });
    (0, $eUqFw.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $74BVL.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (visibleOnMobile && !visibleOnDesktop) toggleVisibility();
                }
            }
        });
    }, [
        toggleVisibility,
        visibleOnDesktop,
        visibleOnMobile
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $74BVL.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (visibleOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) openFlyout();
            }
        });
    }, [
        openFlyout,
        toggleButtonElement,
        visibleOnDesktop
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $74BVL.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                tryStartCloseFlyoutTimer();
            }
        });
    }, [
        tryStartCloseFlyoutTimer,
        isFlyoutVisible,
        toggleButtonElement
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $74BVL.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (visibleOnDesktop || !isFlyoutVisible) return;
                // If the user mouses back over the side nav we want to cancel any pending flyout close timers
                cancelPendingFlyoutClose();
                // If the user mouses over the side nav while it was locked, we want to keep it open
                if (isFlyoutLocked) {
                    const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                    if (matches) openFlyout();
                }
            }
        });
    }, [
        cancelPendingFlyoutClose,
        isFlyoutLocked,
        isFlyoutVisible,
        openFlyout,
        visibleOnDesktop
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $74BVL.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                tryStartCloseFlyoutTimer();
            }
        });
    }, [
        tryStartCloseFlyoutTimer,
        isFlyoutVisible
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!homeActionsElement || !toggleButtonElement) return;
        return (0, $74BVL.bind)(homeActionsElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (visibleOnDesktop || !isFlyoutVisible) return;
                if (event.target === homeActionsElement) {
                    // The mouse is directly over the home actions container, so cancel any pending flyout closes.
                    cancelPendingFlyoutClose();
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the home actions container that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                tryStartCloseFlyoutTimer();
            }
        });
    }, [
        cancelPendingFlyoutClose,
        tryStartCloseFlyoutTimer,
        homeActionsElement,
        isFlyoutVisible,
        toggleButtonElement,
        visibleOnDesktop
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!homeActionsElement) return;
        return (0, $74BVL.bind)(homeActionsElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the home actions container, so we should close the flyout with a delay.
                tryStartCloseFlyoutTimer();
            }
        });
    }, [
        cancelPendingFlyoutClose,
        tryStartCloseFlyoutTimer,
        homeActionsElement,
        isFlyoutVisible
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return cancelPendingFlyoutClose;
    }, [
        cancelPendingFlyoutClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("nav", {
        id: CID,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $lo97w.sideNavVar)]: clampedWidth
        },
        ref: navRef,
        "data-testid": testId,
        className: (0, $7JEyt.default)([
            $6146f4ee5c281fb0$var$styles.root,
            sideNavState === 'hiddenMobileOnly' && $6146f4ee5c281fb0$var$styles.hiddenMobileOnly,
            sideNavState === 'hiddenDesktopOnly' && $6146f4ee5c281fb0$var$styles.hiddenDesktopOnly,
            sideNavState === 'hiddenMobileAndDesktop' && $6146f4ee5c281fb0$var$styles.hiddenMobileAndDesktop,
            sideNavState === 'flyout' && $6146f4ee5c281fb0$var$styles.flyout
        ])
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $lo97w.UNSAFE_sideNavLayoutVar),
        value: "0px",
        mediaQuery: (0, $4Ywu9.media).above.md,
        responsiveValue: visibleOnDesktop ? clampedWidth : 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iGOPs.InteractionSurface), {
        xcss: $6146f4ee5c281fb0$var$styles.interactionSurface
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ahFM.PanelSplitterProvider), {
        panelRef: navRef,
        panelWidth: width,
        onCompleteResize: setWidth,
        resizeBounds: $6146f4ee5c281fb0$var$widthResizeBounds,
        resizingCssVar: $6146f4ee5c281fb0$var$panelSplitterResizingVar,
        isEnabled: sideNavState === 'idle' || sideNavState === 'hiddenMobileOnly'
    }, children)));
}
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $6146f4ee5c281fb0$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Side Navigation', onExpand: onExpand, onCollapse: onCollapse, id: id }) {
    const UID = (0, $1dw3N.usePrefixedUID)();
    const CID = id ? id : UID;
    (0, $fFyfw.useSkipLink)(CID, label);
    const { visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile, setVisibleOnDesktop: setVisibleOnDesktop } = (0, $fXDWV.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const [width, setWidth] = (0, $eUqFw.useState)(defaultWidth);
    const clampedWidth = `clamp(${$6146f4ee5c281fb0$var$widthResizeBounds.min}, ${width}px, ${$6146f4ee5c281fb0$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)((0, $3gqKb.DangerouslyHoistSlotSizes));
    const navRef = (0, $eUqFw.useRef)(null);
    const toggleButtonElement = (0, $eUqFw.useContext)((0, $dzFRa.SideNavToggleButtonElement));
    const homeActionsElement = (0, $eUqFw.useContext)((0, $idDgv.HomeActionsElement));
    const devTimeOnlyAttributes = {};
    const [isFlyoutVisible, setIsFlyoutVisible] = (0, $eUqFw.useState)(false);
    const openLayerObserver = (0, $gbGcd.useOpenLayerObserver)();
    const isMousedOverFlyoutZones = (0, $eUqFw.useRef)(false);
    const sideNavState = $6146f4ee5c281fb0$var$getSideNavState({
        visibleOnDesktop: visibleOnDesktop,
        visibleOnMobile: visibleOnMobile,
        isFlyoutVisible: isFlyoutVisible
    });
    // A timeout reference is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
    // us to cancel the close if the user mouses back in.
    const closeFlyoutTimerRef = (0, $eUqFw.useRef)(null);
    const cancelPendingFlyoutClose = (0, $eUqFw.useCallback)(()=>{
        if (closeFlyoutTimerRef.current) {
            clearTimeout(closeFlyoutTimerRef.current);
            closeFlyoutTimerRef.current = null;
        }
    }, []);
    const openFlyout = (0, $eUqFw.useCallback)(()=>{
        cancelPendingFlyoutClose();
        setIsFlyoutVisible(true);
    }, [
        cancelPendingFlyoutClose
    ]);
    // Starts a timer to close the flyout after a delay. It will only start a new timer if one isn't already pending.
    const tryStartCloseFlyoutTimer = (0, $eUqFw.useCallback)(()=>{
        if (closeFlyoutTimerRef.current) // There is already a close timer pending, so we won't need to start another one.
        return;
        if (openLayerObserver.getCount() > 0) // There are open layers (e.g. popups) within the side nav - so we don't want to close the flyout.
        return;
        closeFlyoutTimerRef.current = setTimeout(()=>{
            closeFlyoutTimerRef.current = null;
            setIsFlyoutVisible(false);
        }, $6146f4ee5c281fb0$var$sideNavFlyoutCloseDelayMs);
    }, [
        openLayerObserver
    ]);
    const toggleVisibility = (0, $iP6ac.useToggleSideNav)();
    // Sync the visibility in context with the local state value after SSR hydration, as it contains the default value from props
    (0, $eUqFw.useEffect)(()=>{
        setVisibleOnDesktop(visibleOnDesktop);
    }, [
        setVisibleOnDesktop,
        visibleOnDesktop
    ]);
    (0, $ilfLI.useSideNavVisibilityCallbacks)({
        onExpand: onExpand,
        onCollapse: onCollapse,
        visibleOnDesktop: visibleOnDesktop,
        visibleOnMobile: visibleOnMobile
    });
    (0, $eUqFw.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $74BVL.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (visibleOnMobile && !visibleOnDesktop) toggleVisibility();
                }
            }
        });
    }, [
        toggleVisibility,
        visibleOnDesktop,
        visibleOnMobile
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $74BVL.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (visibleOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) {
                    openFlyout();
                    isMousedOverFlyoutZones.current = true;
                }
            }
        });
    }, [
        openFlyout,
        toggleButtonElement,
        visibleOnDesktop
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $74BVL.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                tryStartCloseFlyoutTimer();
                isMousedOverFlyoutZones.current = false;
            }
        });
    }, [
        tryStartCloseFlyoutTimer,
        isFlyoutVisible,
        toggleButtonElement
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $74BVL.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (visibleOnDesktop || !isFlyoutVisible) return;
                // If the user mouses back over the side nav we want to cancel any pending flyout close timers
                cancelPendingFlyoutClose();
                isMousedOverFlyoutZones.current = true;
            }
        });
    }, [
        cancelPendingFlyoutClose,
        isFlyoutVisible,
        visibleOnDesktop
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $74BVL.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                isMousedOverFlyoutZones.current = false;
                tryStartCloseFlyoutTimer();
            }
        });
    }, [
        cancelPendingFlyoutClose,
        isFlyoutVisible,
        tryStartCloseFlyoutTimer,
        visibleOnDesktop
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!homeActionsElement || !toggleButtonElement) return;
        return (0, $74BVL.bind)(homeActionsElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (visibleOnDesktop || !isFlyoutVisible) return;
                if (event.target === homeActionsElement) {
                    // The mouse is directly over the home actions container, so cancel any pending flyout closes.
                    cancelPendingFlyoutClose();
                    isMousedOverFlyoutZones.current = true;
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) {
                    // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                    // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                    isMousedOverFlyoutZones.current = true;
                    return;
                }
                // The user has moused over a child element of the home actions container that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                tryStartCloseFlyoutTimer();
                isMousedOverFlyoutZones.current = false;
            }
        });
    }, [
        cancelPendingFlyoutClose,
        tryStartCloseFlyoutTimer,
        homeActionsElement,
        isFlyoutVisible,
        toggleButtonElement,
        visibleOnDesktop
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!homeActionsElement) return;
        return (0, $74BVL.bind)(homeActionsElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the home actions container, so we should close the flyout with a delay.
                tryStartCloseFlyoutTimer();
                isMousedOverFlyoutZones.current = false;
            }
        });
    }, [
        cancelPendingFlyoutClose,
        tryStartCloseFlyoutTimer,
        homeActionsElement,
        isFlyoutVisible
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, top bar home actions element)
        return openLayerObserver.onChange(function onChange({ count: count }) {
            if (!isMousedOverFlyoutZones.current && count === 0) setIsFlyoutVisible(false);
        });
    }, [
        openLayerObserver
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return cancelPendingFlyoutClose;
    }, [
        cancelPendingFlyoutClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("nav", {
        id: CID,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $lo97w.sideNavVar)]: clampedWidth
        },
        ref: navRef,
        "data-testid": testId,
        className: (0, $7JEyt.default)([
            $6146f4ee5c281fb0$var$styles.root,
            sideNavState === 'hiddenMobileOnly' && $6146f4ee5c281fb0$var$styles.hiddenMobileOnly,
            sideNavState === 'hiddenDesktopOnly' && $6146f4ee5c281fb0$var$styles.hiddenDesktopOnly,
            sideNavState === 'hiddenMobileAndDesktop' && $6146f4ee5c281fb0$var$styles.hiddenMobileAndDesktop,
            sideNavState === 'flyout' && $6146f4ee5c281fb0$var$styles.flyout
        ])
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $lo97w.UNSAFE_sideNavLayoutVar),
        value: "0px",
        mediaQuery: (0, $4Ywu9.media).above.md,
        responsiveValue: visibleOnDesktop ? clampedWidth : 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iGOPs.InteractionSurface), {
        xcss: $6146f4ee5c281fb0$var$styles.interactionSurface
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ahFM.PanelSplitterProvider), {
        panelRef: navRef,
        panelWidth: width,
        onCompleteResize: setWidth,
        resizeBounds: $6146f4ee5c281fb0$var$widthResizeBounds,
        resizingCssVar: $6146f4ee5c281fb0$var$panelSplitterResizingVar,
        isEnabled: sideNavState === 'idle' || sideNavState === 'hiddenMobileOnly'
    }, children)));
}
function $6146f4ee5c281fb0$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Side Navigation', onExpand: onExpand, onCollapse: onCollapse, id: id }) {
    if ((0, $XHGTv.fg)('platform_design_system_team_layering_observer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iZQWz.OpenLayerObserver), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6146f4ee5c281fb0$var$SideNavInternal, {
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        testId: testId,
        label: label,
        onExpand: onExpand,
        onCollapse: onCollapse,
        id: id
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6146f4ee5c281fb0$var$SideNavInternalLegacy, {
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        testId: testId,
        label: label,
        onExpand: onExpand,
        onCollapse: onCollapse,
        id: id
    }, children);
}

});
parcelRegister("iZQWz", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserver", () => $18a8adb811d06870$export$97afddda23bcd287);

var $eUqFw = parcelRequire("eUqFw");

var $6N16S = parcelRequire("6N16S");
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $18a8adb811d06870$var$createInternalAPI() {
    let count = 0;
    const registry = new Set();
    function onChange(listener) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        registry.add(wrapped);
        return function unsubscribe() {
            registry.delete(wrapped);
        };
    }
    function increment() {
        count += 1;
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(registry).forEach((listener)=>listener({
                count: count
            }));
    }
    function decrement() {
        count -= 1;
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(registry).forEach((listener)=>listener({
                count: count
            }));
    }
    return {
        getCount () {
            return count;
        },
        onChange: onChange,
        increment: increment,
        decrement: decrement
    };
}
function $18a8adb811d06870$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $eUqFw.useState)(()=>$18a8adb811d06870$var$createInternalAPI());
    const parentContext = (0, $eUqFw.useContext)((0, $6N16S.OpenLayerObserverContext));
    const increment = (0, $eUqFw.useCallback)(()=>{
        internalAPI.increment();
        // If the `OpenLayerObserver` is nested, increment the layer count in the parent context as well.
        if (parentContext !== null) parentContext.increment();
    }, [
        internalAPI,
        parentContext
    ]);
    const decrement = (0, $eUqFw.useCallback)(()=>{
        internalAPI.decrement();
        // If the `OpenLayerObserver` is nested, decrement the layer count in the parent context as well.
        if (parentContext !== null) parentContext.decrement();
    }, [
        internalAPI,
        parentContext
    ]);
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            getCount: internalAPI.getCount,
            onChange: internalAPI.onChange,
            increment: increment,
            decrement: decrement
        }), [
        decrement,
        increment,
        internalAPI.getCount,
        internalAPI.onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6N16S.OpenLayerObserverContext).Provider, {
        value: contextValue
    }, children);
}

});

parcelRegister("gbGcd", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserver", () => $2f4522d925cbcfae$export$750f5b0d6c51617e);

var $eUqFw = parcelRequire("eUqFw");

var $8ynlC = parcelRequire("8ynlC");

var $6N16S = parcelRequire("6N16S");
function $2f4522d925cbcfae$export$750f5b0d6c51617e() {
    const context = (0, $eUqFw.useContext)((0, $6N16S.OpenLayerObserverContext));
    (0, $8ynlC.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
    const publicAPI = (0, $eUqFw.useMemo)(()=>({
            getCount: context.getCount,
            onChange: context.onChange
        }), [
        context.getCount,
        context.onChange
    ]);
    return publicAPI;
}

});

parcelRegister("iGOPs", function(module, exports) {

$parcel$export(module.exports, "InteractionSurface", () => $5ca46cfca5ead33c$export$b77883dd274d64b);
$parcel$export(module.exports, "InteractionConsumer", () => $5ca46cfca5ead33c$export$65f09dabf608e4ae);
/* interaction-surface.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");
// These CSS variables are "compressed" to discourage direct usage.
// Using `opacity` so that the element is still in the document flow while hidden, so that it can be part of the accessibilty tree
// when the surface is not interacted with. Use case: keeping the element in the tab order.
const $5ca46cfca5ead33c$var$opacityCssVar = '--n_sfc_o';
// `display` is used when the element should be removed from the document flow when hidden.
const $5ca46cfca5ead33c$var$displayCssVar = '--n_sfc_d';
const $5ca46cfca5ead33c$var$surfaceStyles = {
    root: "_17lff1ug _2wlvglyw _1ebb1osq _1yth1osq _1s0b1ule _1dle1ule"
};
const $5ca46cfca5ead33c$export$b77883dd274d64b = ({ children: children, xcss: xcss })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $5ca46cfca5ead33c$var$surfaceStyles.root,
            xcss
        ])
    }, children);
const $5ca46cfca5ead33c$var$behaviorStyles = {
    hideOnLeave: "_tzy41j9r",
    removeOnLeave: "_1e0c13fu"
};
const $5ca46cfca5ead33c$export$65f09dabf608e4ae = ({ children: children, testId: testId, xcss: xcss, behavior: behavior = 'hideOnLeave' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $7JEyt.default)([
            behavior === 'hideOnLeave' && $5ca46cfca5ead33c$var$behaviorStyles.hideOnLeave,
            behavior === 'removeOnLeave' && $5ca46cfca5ead33c$var$behaviorStyles.removeOnLeave,
            xcss
        ])
    }, children);

});

parcelRegister("ilfLI", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $d8021e8c6a419f80$export$1904b8f2577aba9a);

var $eUqFw = parcelRequire("eUqFw");

var $d7Ieg = parcelRequire("d7Ieg");
function $d8021e8c6a419f80$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $eUqFw.useRef)(onExpand);
    const onCollapseRef = (0, $eUqFw.useRef)(onCollapse);
    (0, $eUqFw.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousVisibleOnDesktop = (0, $d7Ieg.default)(visibleOnDesktop);
    (0, $eUqFw.useEffect)(()=>{
        if (previousVisibleOnDesktop === undefined || previousVisibleOnDesktop === visibleOnDesktop) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (visibleOnDesktop) onExpandRef.current?.({
            screen: 'desktop'
        });
        else onCollapseRef.current?.({
            screen: 'desktop'
        });
    }, [
        previousVisibleOnDesktop,
        visibleOnDesktop
    ]);
    const previousVisibleOnMobile = (0, $d7Ieg.default)(visibleOnMobile);
    (0, $eUqFw.useEffect)(()=>{
        if (previousVisibleOnMobile === undefined || previousVisibleOnMobile === visibleOnMobile) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (visibleOnMobile) onExpandRef.current?.({
            screen: 'mobile'
        });
        else onCollapseRef.current?.({
            screen: 'mobile'
        });
    }, [
        previousVisibleOnMobile,
        visibleOnMobile
    ]);
}

});

parcelRegister("iP6ac", function(module, exports) {

$parcel$export(module.exports, "useToggleSideNav", () => $fa13224f1d53efcd$export$477ee35601a0a8ce);

var $eUqFw = parcelRequire("eUqFw");

var $iER3z = parcelRequire("iER3z");
const $fa13224f1d53efcd$export$477ee35601a0a8ce = ()=>{
    const setVisibleOnDesktop = (0, $eUqFw.useContext)((0, $iER3z.SetSideNavDesktopVisibility));
    const setVisibleOnMobile = (0, $eUqFw.useContext)((0, $iER3z.SetSideNavMobileVisibility));
    const toggleSideNav = (0, $eUqFw.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setVisibleOnDesktop((prev)=>!prev);
        else setVisibleOnMobile((prev)=>!prev);
    }, [
        setVisibleOnDesktop,
        setVisibleOnMobile
    ]);
    return toggleSideNav;
};

});


parcelRegister("c91OB", function(module, exports) {

$parcel$export(module.exports, "TopBar", () => $744a2a99d0c1a33b$export$c4e96258f3b6511);
/* top-bar.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $fFyfw = parcelRequire("fFyfw");

var $cMwPC = parcelRequire("cMwPC");

var $gcRF0 = parcelRequire("gcRF0");

var $lo97w = parcelRequire("lo97w");

var $3gqKb = parcelRequire("3gqKb");

var $59HcT = parcelRequire("59HcT");

var $1dw3N = parcelRequire("1dw3N");
const $744a2a99d0c1a33b$var$styles = {
    root: "_1e0c11p5 _yv0e1mfv _18zrutpp _zulpu2gc _4cvr1h6o _bfhkvuon _vchhusvi _nd5l8cbt _4t3i2mmk _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi _1rqtc57g"
};
const $744a2a99d0c1a33b$var$contentBorderStyles = {
    smallViewportTop: "_179rzgxb _nd5l8cbt _152t1nws _lcxvglyw _kqsw1if8 _t9ec2nsj _1pby11wp _dm25glyw"
};
function $744a2a99d0c1a33b$export$c4e96258f3b6511({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 48, label: label = 'Top Bar', testId: testId, id: id, UNSAFE_theme: UNSAFE_theme }) {
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)((0, $3gqKb.DangerouslyHoistSlotSizes));
    const UID = (0, $1dw3N.usePrefixedUID)();
    const CID = id ? id : UID;
    (0, $fFyfw.useSkipLink)(CID, label);
    const customTheme = (0, $gcRF0.useCustomTheme)(UNSAFE_theme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cMwPC.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("header", {
        id: CID,
        "data-layout-slot": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            $744a2a99d0c1a33b$var$styles.root,
            xcss
        ]),
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: customTheme.isEnabled ? customTheme.style : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.HoistCssVarToLocalGrid), {
        variableName: (0, $lo97w.topBarMountedVar),
        value: UNSAFE_height
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $lo97w.UNSAFE_topBarVar),
        value: UNSAFE_height
    }), children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // CALL OUT: If this component is NOT mounted to a page then the border between
        // the top bar and main content will not be rendered.
        "data-layout-slot": true,
        className: (0, $7JEyt.default)([
            $744a2a99d0c1a33b$var$contentBorderStyles.smallViewportTop
        ])
    }));
}

});
parcelRegister("gcRF0", function(module, exports) {

$parcel$export(module.exports, "useCustomTheme", () => $5395e701c40c5989$export$c0c5f5b297b77726);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $dlAn0 = parcelRequire("dlAn0");
function $5395e701c40c5989$export$c0c5f5b297b77726(theme) {
    const style = (0, $eUqFw.useMemo)(()=>{
        /**
		 * TODO: After cleaning up this flag we may want to remove `isEnabled`
		 * and just use `Boolean(theme)` directly.
		 */ if (!(0, $XHGTv.fg)('platform_design_system_nav4_top_bar_theming')) return null;
        if (!theme) return null;
        return (0, $dlAn0.getCustomThemeStyles)(theme);
    }, [
        theme
    ]);
    if (!style) return {
        isEnabled: false
    };
    return {
        isEnabled: true,
        style: style
    };
}

});
parcelRegister("dlAn0", function(module, exports) {

$parcel$export(module.exports, "getCustomThemeStyles", () => $dd67d18165ce6a82$export$3986d75fe2da3239);

var $fLqV8 = parcelRequire("fLqV8");

var $147Cc = parcelRequire("147Cc");

var $kbRDk = parcelRequire("kbRDk");
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $dd67d18165ce6a82$var$buttonStyles = {
    light: {
        [(0, $147Cc.themedButtonBackground)]: 'transparent',
        [(0, $147Cc.themedButtonBackgroundHovered)]: '#0515240F',
        [(0, $147Cc.themedButtonBackgroundPressed)]: '#0B120E24',
        [(0, $147Cc.themedButtonBorder)]: '#0B120E24',
        [(0, $147Cc.themedButtonSelectedText)]: '#1868DB',
        [(0, $147Cc.themedButtonSelectedBackground)]: '#E9F2FE',
        [(0, $147Cc.themedButtonSelectedBackgroundHovered)]: '#CFE1FD',
        [(0, $147Cc.themedButtonSelectedBackgroundPressed)]: '#8FB8F6'
    },
    dark: {
        [(0, $147Cc.themedButtonBackground)]: 'transparent',
        [(0, $147Cc.themedButtonBackgroundHovered)]: '#CECED912',
        [(0, $147Cc.themedButtonBackgroundPressed)]: '#E3E4F21F',
        [(0, $147Cc.themedButtonBorder)]: '#E3E4F21F',
        [(0, $147Cc.themedButtonSelectedText)]: '#669DF1',
        [(0, $147Cc.themedButtonSelectedBackground)]: '#1C2B42',
        [(0, $147Cc.themedButtonSelectedBackgroundHovered)]: '#123263',
        [(0, $147Cc.themedButtonSelectedBackgroundPressed)]: '#1558BC'
    }
};
const $dd67d18165ce6a82$var$logoStyles = {
    light: {
        [(0, $fLqV8.themedLogoIcon)]: '#101214',
        [(0, $fLqV8.themedLogoText)]: '#101214'
    },
    dark: {
        [(0, $fLqV8.themedLogoIcon)]: '#FFFFFF',
        [(0, $fLqV8.themedLogoText)]: '#FFFFFF'
    }
};
function $dd67d18165ce6a82$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const isLightBackground = (0, $kbRDk.isLight)(backgroundColor);
    const color = (0, $kbRDk.getTextColor)(backgroundColor);
    const highlightTextColor = (0, $kbRDk.getTextColor)(highlightColor);
    const highlightRgb = (0, $kbRDk.hexToRGB)(highlightColor);
    return {
        backgroundColor: backgroundColor,
        color: color,
        ...$dd67d18165ce6a82$var$buttonStyles[isLightBackground ? 'light' : 'dark'],
        ...$dd67d18165ce6a82$var$logoStyles[isLightBackground ? 'light' : 'dark'],
        [(0, $147Cc.themedButtonPrimaryBackground)]: highlightColor,
        /**
		 * These interaction states are the same as nav3
		 */ [(0, $147Cc.themedButtonPrimaryBackgroundHovered)]: (0, $kbRDk.toRGBAString)(highlightRgb, 0.8),
        [(0, $147Cc.themedButtonPrimaryBackgroundPressed)]: (0, $kbRDk.toRGBAString)(highlightRgb, 0.65),
        [(0, $147Cc.themedButtonPrimaryText)]: highlightTextColor
    };
}

});
parcelRegister("kbRDk", function(module, exports) {

$parcel$export(module.exports, "toRGBAString", () => $7a21c148e999c9db$export$b597d7418f37d50a);
$parcel$export(module.exports, "hexToRGB", () => $7a21c148e999c9db$export$848d71df1f759bc);
$parcel$export(module.exports, "isLight", () => $7a21c148e999c9db$export$44af652f4cca9039);
$parcel$export(module.exports, "getTextColor", () => $7a21c148e999c9db$export$5357fe757c335c0d);
// valid hex color (with no alpha channel) - 3 or 6 digits
const $7a21c148e999c9db$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex);
function $7a21c148e999c9db$export$b597d7418f37d50a({ r: r, g: g, b: b }, alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
function $7a21c148e999c9db$export$848d71df1f759bc(hex) {
    if (!$7a21c148e999c9db$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let channels;
    if (hex.length === 4) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: hex[1].repeat(2),
        g: hex[2].repeat(2),
        b: hex[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: hex.slice(1, 3),
        g: hex.slice(3, 5),
        b: hex.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $7a21c148e999c9db$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $7a21c148e999c9db$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
	 * Normalized sRGB - each channel is between 0 and 1
	 */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
	 * linear RGB - the gamma correction of sRGB is removed and
	 * the channels correspond directly to subpixel intensity
	 */ const linear = {
        r: $7a21c148e999c9db$var$linearizeRGBChannel(normal.r),
        g: $7a21c148e999c9db$var$linearizeRGBChannel(normal.g),
        b: $7a21c148e999c9db$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
function $7a21c148e999c9db$export$d061e26956a60b0a(foreground, background) {
    if (!$7a21c148e999c9db$var$isValidHex(foreground) || !$7a21c148e999c9db$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $7a21c148e999c9db$export$848d71df1f759bc(foreground);
    const backgroundRgb = $7a21c148e999c9db$export$848d71df1f759bc(background);
    const foregroundLuminance = $7a21c148e999c9db$var$relativeLuminanceW3C(foregroundRgb);
    const backgroundLuminance = $7a21c148e999c9db$var$relativeLuminanceW3C(backgroundRgb);
    // calculate the color contrast ratio
    const brightest = Math.max(foregroundLuminance, backgroundLuminance);
    const darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $7a21c148e999c9db$var$flipLuminance = 0.179129;
function $7a21c148e999c9db$export$44af652f4cca9039(color) {
    const rgb = $7a21c148e999c9db$export$848d71df1f759bc(color);
    return $7a21c148e999c9db$var$relativeLuminanceW3C(rgb) >= $7a21c148e999c9db$var$flipLuminance;
}
function $7a21c148e999c9db$export$5357fe757c335c0d(backgroundColor) {
    if ($7a21c148e999c9db$export$44af652f4cca9039(backgroundColor)) return '#000';
    return '#FFF';
}

});





parcelRegister("1NIhY", function(module, exports) {

$parcel$export(module.exports, "navigationUiStateResource", () => $f81bf6691f07ea3e$export$14c178691841b423);
// eslint-disable-next-line jira/import-whitelist

var $5iWql = parcelRequire("5iWql");

var $lB25E = parcelRequire("lB25E");

var $jCGD5 = parcelRequire("jCGD5");

const $f81bf6691f07ea3e$var$getNavigationUiStateMemoized = (0, $5iWql.default)((atlassianAccountId)=>(0, $jCGD5.getNavigationUiState)({
        tenantContext: {
            atlassianAccountId: atlassianAccountId
        }
    }));
const $f81bf6691f07ea3e$export$14c178691841b423 = (0, $lB25E.createResource)({
    type: 'RESOURCE_TYPE_NAVIGATION_UI',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$f81bf6691f07ea3e$var$getNavigationUiStateMemoized(atlassianAccountId),
    maxAge: Infinity
});

});
parcelRegister("jCGD5", function(module, exports) {

$parcel$export(module.exports, "getNavigationUiState", () => $db77001cbd8f906b$export$29999268b070c9bd);

var $48bs8 = parcelRequire("48bs8");


var $lTttU = parcelRequire("lTttU");
const $db77001cbd8f906b$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
    const { atlassianAccountId: accountId } = tenantContext;
    let uiState = await (0, $lTttU.queryLocalStorage)();
    if (uiState || !accountId) return uiState;
    try {
        uiState = await (0, $48bs8.getUserProperty)(accountId, (0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8));
        // @ts-expect-error - TS2345 - Argument of type 'UIControllerShape | undefined' is not assignable to parameter of type 'UIControllerShape'.
        (0, $lTttU.updateLocalStorageData)(uiState);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // Don't log the error on purpose. This is very frequent for some reason :(
    }
    return uiState;
};

});
const $75b7df28d47cff7a$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $75b7df28d47cff7a$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';

parcelRegister("lTttU", function(module, exports) {

$parcel$export(module.exports, "queryLocalStorage", () => $4239519c11764e08$export$e192dcb908272d5);
$parcel$export(module.exports, "updateLocalStorageData", () => $4239519c11764e08$export$ec13c725e067146a);

var $jG2Eu = parcelRequire("jG2Eu");

var $gUUjF = parcelRequire("gUUjF");

const $4239519c11764e08$export$e7db3fa51c63bc5c = ()=>{
    if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
    return {
        setItem: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        getItem: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    };
};
const $4239519c11764e08$var$queryLocalStorageSync = ()=>{
    const localStorage = $4239519c11764e08$export$e7db3fa51c63bc5c();
    const item = localStorage.getItem((0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8));
    if (!false && item) try {
        return JSON.parse(item);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $75b7df28d47cff7a$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
    }
};
const $4239519c11764e08$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
        const item = $4239519c11764e08$var$queryLocalStorageSync();
        resolve(item);
    });
const $4239519c11764e08$export$ec13c725e067146a = (data)=>{
    const localStorage = $4239519c11764e08$export$e7db3fa51c63bc5c();
    localStorage.setItem((0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8), JSON.stringify(data));
};

});



parcelRegister("dxcfv", function(module, exports) {

$parcel$export(module.exports, "useAccountId", () => $45cd5aaa8359ff91$export$e72033e0f5baa3e);

var $gd0Sp = parcelRequire("gd0Sp");
const $45cd5aaa8359ff91$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});

parcelRegister("kpmC0", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $57fa1b4d662f99dc$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $57fa1b4d662f99dc$export$900f29014a48fb23);

var $eUqFw = parcelRequire("eUqFw");

var $hwyJ1 = parcelRequire("hwyJ1");

var $WBLbN = parcelRequire("WBLbN");

var $53ucm = parcelRequire("53ucm");
const $57fa1b4d662f99dc$var$useSweetStateLeftSidebarState = (0, $WBLbN.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $57fa1b4d662f99dc$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $57fa1b4d662f99dc$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $57fa1b4d662f99dc$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $hwyJ1.usePageLayoutResize)();
    return (0, $eUqFw.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});

parcelRegister("bUi2Q", function(module, exports) {

$parcel$export(module.exports, "useActiveRightSidebarState", () => $09e77c9f3f7f26ec$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $09e77c9f3f7f26ec$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $09e77c9f3f7f26ec$export$ebe5e907fb0bb63a);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $hqpfO = parcelRequire("hqpfO");

var $53ucm = parcelRequire("53ucm");
const $09e77c9f3f7f26ec$var$useActiveRightSidebar = (0, $WBLbN.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $hqpfO.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $09e77c9f3f7f26ec$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $09e77c9f3f7f26ec$var$useActiveRightSidebar();
    return rightSidebar;
};
const $09e77c9f3f7f26ec$var$useRightSidebar = (0, $WBLbN.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $09e77c9f3f7f26ec$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $09e77c9f3f7f26ec$var$useRightSidebar();
    return rightSidebarState;
};
const $09e77c9f3f7f26ec$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $53ucm.useLayoutStoreActions)();
    return (0, $eUqFw.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});

parcelRegister("bXcr7", function(module, exports) {

$parcel$export(module.exports, "setRemoteLayoutState", () => $5f4bcad3f92fef2e$export$ad53b565e6cd4261);

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

async function $5f4bcad3f92fef2e$export$ad53b565e6cd4261({ accountId: accountId, state: state }) {
    try {
        await (0, $48bs8.setUserProperties)(accountId, (0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8), JSON.stringify(state));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $guiFP.default)({
            error: e,
            meta: {
                id: 'updateServerLayoutState',
                packageName: 'jiraLayoutController',
                teamName: 'jfp-team'
            }
        });
    }
}

});


parcelRegister("b00xW", function(module, exports) {

$parcel$export(module.exports, "GlobalBottomRightCornerContainer", () => $50f1861a2ded8c40$export$715c8d5890c054bb);
$parcel$export(module.exports, "GlobalBottomRightCornerContainerProvider", () => $50f1861a2ded8c40$export$1e86e3484191597c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5GxEP = parcelRequire("5GxEP");

var $jK1pm = parcelRequire("jK1pm");

var $71g00 = parcelRequire("71g00");

var $bUi2Q = parcelRequire("bUi2Q");

var $53ucm = parcelRequire("53ucm");
function $50f1861a2ded8c40$export$e112b78171de7a6({ bottomOffset: bottomOffset, rightOffset: rightOffset }) {
    const [{ width: width }] = (0, $53ucm.useDetailPanelWidth)();
    const rightSidebar = (0, $bUi2Q.useActiveRightSidebarState)();
    const { registerBottomRightCornerContainer: registerBottomRightCornerContainer } = (0, $71g00.useBottomRightCornerActions)();
    const isSidebarOpen = rightSidebar && !rightSidebar.isCollapsed && !rightSidebar.isMinimised;
    const rightSidebarWidth = isSidebarOpen ? rightSidebar.width : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50f1861a2ded8c40$var$StyledContainer, {
        ref: registerBottomRightCornerContainer,
        "data-testid": "layout-controller.ui.bottom-right-corner.container.styled-container",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            right: `calc(${width + rightOffset + rightSidebarWidth}px + ${"var(--ds-space-300, 24px)"})`,
            bottom: `calc(${"var(--ds-space-300, 24px)"} + ${bottomOffset}px)`
        }
    });
}
const $50f1861a2ded8c40$export$715c8d5890c054bb = ({ bottomOffset: bottomOffset = 0, rightOffset: rightOffset = 0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "bottom-right-corner-container",
        packageName: "jira-bottom-right-corner-controller"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50f1861a2ded8c40$export$e112b78171de7a6, {
        bottomOffset: bottomOffset,
        rightOffset: rightOffset
    }));
const $50f1861a2ded8c40$export$1e86e3484191597c = ({ children: children })=>{
    const container = (0, $71g00.useBottomRightCornerContainer)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "global-bottom-right-corner"
    }, container && children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50f1861a2ded8c40$export$715c8d5890c054bb, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50f1861a2ded8c40$var$StyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1n9t _1e0c1txw _1pbyfjpv _1reoewfl _18m9ewfl _4cvresu3 _lcxvglyw",
            __cmplp.className
        ])
    });
});
$50f1861a2ded8c40$var$StyledContainer.displayName = 'StyledContainer';

});
parcelRegister("jK1pm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f009785aaee067$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6fjTb = parcelRequire("6fjTb");

var $iWLL0 = parcelRequire("iWLL0");

var $3Hphq = parcelRequire("3Hphq");

var $fYqUr = parcelRequire("fYqUr");

var $5crv8 = parcelRequire("5crv8");
/** A portion of the page we apply measurement to */ function $f6f009785aaee067$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $3Hphq.useInteractionContext)();
    const relayProfilerContext = (0, $eUqFw.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $eUqFw.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    this.getInteractionContext().addPreload((0, $fYqUr.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $fYqUr.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6fjTb.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children));
}
function $f6f009785aaee067$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5crv8.default), {
        name: segmentName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6f009785aaee067$var$JiraUFOSegmentWrapper, null, children));
}

});

parcelRegister("71g00", function(module, exports) {

$parcel$export(module.exports, "useBottomRightCornerContainer", () => $6c4868bbefcbb619$export$84542488b6b6c309);
$parcel$export(module.exports, "useBottomRightCornerActions", () => $6c4868bbefcbb619$export$de496fd0e0151c81);

var $WBLbN = parcelRequire("WBLbN");

var $53ucm = parcelRequire("53ucm");
const $6c4868bbefcbb619$export$84542488b6b6c309 = (0, $WBLbN.createStateHook)((0, $53ucm.layoutStore), {
    selector: (state)=>state.bottomRightCorner.container
});
const $6c4868bbefcbb619$export$de496fd0e0151c81 = (0, $WBLbN.createActionsHook)((0, $53ucm.layoutStore));

});


const $7688150c048b38d1$export$c9e16a15d65437 = 'navigationNext';
const $7688150c048b38d1$export$b1534bc11f201efd = 'jiraPageContainer';
const $7688150c048b38d1$export$fa4bbc89fd1f1a7 = null;
const $7688150c048b38d1$export$aa6008fe0169b864 = null;
const $7688150c048b38d1$export$39418a21fbb51487 = null;
const $7688150c048b38d1$export$7dfef0177e883b05 = 'entry.jira-spa';
const $7688150c048b38d1$var$PAGE_CONTAINER_MARK = 'jira-spa/spa-shell/page-container';
const $7688150c048b38d1$export$7114284ca03133ee = `_${$7688150c048b38d1$var$PAGE_CONTAINER_MARK}.end`;
const $7688150c048b38d1$export$21473105c510aacc = 'jira-spa/spa-shell/page-layout';
const $7688150c048b38d1$export$898b6208220685b0 = 'jira-spa/spa-shell/global-containers';
const $7688150c048b38d1$export$e2bc63118050de32 = `_${$7688150c048b38d1$export$898b6208220685b0}.start`;
const $7688150c048b38d1$export$59f83d43fe209319 = `_${$7688150c048b38d1$export$898b6208220685b0}.end`;
const $7688150c048b38d1$export$fb9876ab4228d985 = 'jira-spa/spa-shell/global-components';
const $7688150c048b38d1$export$c20831be6f780cb5 = `_${$7688150c048b38d1$export$fb9876ab4228d985}.start`;
const $7688150c048b38d1$export$398df1bca49f9884 = `_${$7688150c048b38d1$export$fb9876ab4228d985}.end`;
const $7688150c048b38d1$export$7048c99f32c60b34 = 'jira-spa/spa-shell/global-containers/app-base';
const $7688150c048b38d1$export$3c2d8af5c7577fe7 = `_${$7688150c048b38d1$export$7048c99f32c60b34}.start`;
const $7688150c048b38d1$export$aac77afee74c49d0 = `_${$7688150c048b38d1$export$7048c99f32c60b34}.end`;
const $7688150c048b38d1$export$4f341d86a3c214 = 'jira-spa/spa-shell/global-containers/router';
const $7688150c048b38d1$export$16e7ead3a8b5c366 = `_${$7688150c048b38d1$export$4f341d86a3c214}.start`;
const $7688150c048b38d1$export$c389f0b50840d5ca = `_${$7688150c048b38d1$export$4f341d86a3c214}.end`;

parcelRegister("14yu2", function(module, exports) {

$parcel$export(module.exports, "useBannerJsmPackagingUpdates", () => $24b811f575c11f96$export$a0dde3f151a99607);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $eI5EY = parcelRequire("eI5EY");

var $10fdS = parcelRequire("10fdS");

var $bNe1g = parcelRequire("bNe1g");

var $5inNC = parcelRequire("5inNC");

var $dxcfv = parcelRequire("dxcfv");

var $b9kib = parcelRequire("b9kib");
const $24b811f575c11f96$export$a0dde3f151a99607 = ()=>{
    const currentRoute = (0, $10fdS.useCurrentRoute)();
    const { data: project } = (0, $bNe1g.useProjectContext)();
    const accountId = (0, $dxcfv.useAccountId)();
    const isServiceProject = project?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
    const isInJsmBoundary = (0, $eUqFw.useMemo)(()=>(0, $b9kib.isInJsmGlobalSettingsBoundary)(currentRoute.path) || isServiceProject, [
        isServiceProject,
        currentRoute.path
    ]);
    const { shouldShow: shouldShow, dismissAnnouncement: dismissAnnouncement } = (0, $5inNC.useJsmRepackagingAnnouncementResource)(accountId);
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: isInJsmBoundary && shouldShow && (0, $eI5EY.fg)('jsm-packaging-pricing-changes-announcement'),
            dismissAnnouncement: dismissAnnouncement
        }), [
        dismissAnnouncement,
        isInJsmBoundary,
        shouldShow
    ]);
};

});
parcelRegister("5inNC", function(module, exports) {

$parcel$export(module.exports, "useJsmRepackagingAnnouncementResource", () => $f4ffcbbf83240e43$export$47d5fef12f2d184b);

var $eUqFw = parcelRequire("eUqFw");

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $lB25E = parcelRequire("lB25E");

var $abI4C = parcelRequire("abI4C");

const $f4ffcbbf83240e43$var$getDataLoader = ()=>(parcelRequire("1y5AI"));
const $f4ffcbbf83240e43$export$750cb6ed3dfc6a3 = (0, $lB25E.createResource)({
    type: 'JSM_REPACKAGING_ANNOUNCEMENT',
    getKey: ()=>'JSM_REPACKAGING_ANNOUNCEMENT',
    getDataLoader: $f4ffcbbf83240e43$var$getDataLoader,
    maxAge: Infinity
});
const $f4ffcbbf83240e43$export$47d5fef12f2d184b = (accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $lB25E.useResource)($f4ffcbbf83240e43$export$750cb6ed3dfc6a3);
    const loadingRef = (0, $eUqFw.useRef)(false);
    const errorRef = (0, $eUqFw.useRef)();
    const [userPropertiesError, setUserPropertiesError] = (0, $eUqFw.useState)();
    errorRef.current = userPropertiesError || error;
    const dismissAnnouncement = (0, $eUqFw.useCallback)(()=>{
        const announcementDismissState = {
            shouldShow: false
        };
        update(()=>({
                announcementDismissState: announcementDismissState
            }));
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $guiFP.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                        teamName: '50cent'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $48bs8.setUserProperties)(accountId, (0, $abI4C.JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY), JSON.stringify(announcementDismissState)).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                (0, $guiFP.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                        teamName: '50cent'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
    }, [
        accountId,
        update
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $eUqFw.useMemo)(()=>{
        if (errorRef.current || loading || !data || !accountId) return {
            shouldShow: false,
            dismissAnnouncement: dismissAnnouncement
        };
        const { announcementDismissState: announcementDismissState } = data;
        if (!announcementDismissState) return {
            shouldShow: false,
            dismissAnnouncement: dismissAnnouncement
        };
        return {
            ...announcementDismissState,
            dismissAnnouncement: dismissAnnouncement
        };
    }, [
        loading,
        data,
        accountId,
        dismissAnnouncement
    ]);
};

});
parcelRegister("abI4C", function(module, exports) {

$parcel$export(module.exports, "JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY", () => $bdc5420685a01953$export$d2137827dc00e559);
$parcel$export(module.exports, "DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE", () => $bdc5420685a01953$export$341176bfdf8c92);
const $bdc5420685a01953$export$d2137827dc00e559 = 'jsm-repackaging-announcement-dismiss-state';
const $bdc5420685a01953$export$341176bfdf8c92 = {
    shouldShow: true
};

});

parcelRegister("1y5AI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8r39u").then(()=>parcelRequire('2Tdce'));

});


parcelRegister("b9kib", function(module, exports) {

$parcel$export(module.exports, "isInJsmGlobalSettingsBoundary", () => $d62f0498bfab13c2$export$c28a66ae6d31a34b);
const $d62f0498bfab13c2$var$jsmGlobalSettingsPages = [
    '/jira/settings/products/jira-service-management-configuration',
    '/jira/settings/products/jira-service-management-email-requests',
    '/jira/settings/products/servicedesk/customer-access',
    '/jira/settings/products/servicedesk/authentication',
    '/jira/settings/products/servicedesk/organizations',
    '/jira/settings/products/jira-service-management-incident-management-tools',
    '/jira/settings/products/jira-service-management-compliance',
    '/jira/settings/products/servicedesk/feature-usage'
];
const $d62f0498bfab13c2$var$eocGlobalSettingsPages = [
    '/jira/settings/products/ops/roles',
    '/jira/settings/products/ops/role-assignment',
    '/jira/settings/products/ops/role-based-notifications',
    '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    '/jira/settings/products/ops/integrations',
    '/jira/settings/products/ops/syncs',
    '/jira/settings/products/ops/policies',
    '/jira/settings/products/ops/maintenance',
    '/jira/settings/products/ops/incoming-call',
    '/jira/settings/products/ops/jira-service-management-audit-logs',
    '/jira/settings/products/ops/reports'
];
const $d62f0498bfab13c2$var$isJsmGlobalSettingsPage = (route)=>$d62f0498bfab13c2$var$jsmGlobalSettingsPages.includes(route);
const $d62f0498bfab13c2$var$isEocGlobalSettingsPage = (route)=>$d62f0498bfab13c2$var$eocGlobalSettingsPages.includes(route);
const $d62f0498bfab13c2$export$c28a66ae6d31a34b = (route)=>$d62f0498bfab13c2$var$isJsmGlobalSettingsPage(route) || $d62f0498bfab13c2$var$isEocGlobalSettingsPage(route);

});


parcelRegister("egmX2", function(module, exports) {

$parcel$export(module.exports, "BannerJsmPackagingUpdateAsync", () => $65963d75ada08912$export$76c6ab35aee49900);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $gGtKh = parcelRequire("gGtKh");

const $65963d75ada08912$var$BannerTransition = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("DNKPr")).then((module)=>module.BannerJsmPackagingUpdate), {
    moduleId: "./src/packages/platform/ui/banners/jsm-packaging-updates/src/ui/banner/index.tsx"
});
const $65963d75ada08912$export$76c6ab35aee49900 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-banner-jsm-packaging-updates",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($65963d75ada08912$var$BannerTransition, null));

});
parcelRegister("DNKPr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9f9jz").then(()=>parcelRequire('e5bbJ'));

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("bQiKj", function(module, exports) {

$parcel$export(module.exports, "sharedLayout", () => $9081c29c094d647d$export$5f4dc7c98070d93e);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $2WOJv = parcelRequire("2WOJv");

var $7ZZxN = parcelRequire("7ZZxN");

var $gMtJP = parcelRequire("gMtJP");

var $d3Jbb = parcelRequire("d3Jbb");

var $69KNw = parcelRequire("69KNw");

var $2RiaW = parcelRequire("2RiaW");

var $1ZDON = parcelRequire("1ZDON");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $6xYPC = parcelRequire("6xYPC");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $dnJL9 = parcelRequire("dnJL9");

var $eI5EY = parcelRequire("eI5EY");

var $j6ken = parcelRequire("j6ken");

var $jxIns = parcelRequire("jxIns");

var $eGjiP = parcelRequire("eGjiP");

var $d8a4z = parcelRequire("d8a4z");

var $3eqbP = parcelRequire("3eqbP");

var $gbSuS = parcelRequire("gbSuS");

var $cPEpP = parcelRequire("cPEpP");

var $i9XZP = parcelRequire("i9XZP");

var $2m6cd = parcelRequire("2m6cd");

var $hEyt5 = parcelRequire("hEyt5");

var $iOtr0 = parcelRequire("iOtr0");

var $i0pNS = parcelRequire("i0pNS");

var $isbb2 = parcelRequire("isbb2");

var $5EZtQ = parcelRequire("5EZtQ");

var $cADdB = parcelRequire("cADdB");

var $dWLk9 = parcelRequire("dWLk9");

var $lFrSS = parcelRequire("lFrSS");

var $cLxEl = parcelRequire("cLxEl");

var $BRKX9 = parcelRequire("BRKX9");

var $1OfKM = parcelRequire("1OfKM");

var $6Q9xY = parcelRequire("6Q9xY");

var $egQj9 = parcelRequire("egQj9");
const $9081c29c094d647d$var$isTrialEndLockScreenExperimentEnabled = ()=>(0, $1ybV0.ff)('jsm-trial-end-lock-screen-experiment_nowmr') || (0, $1ybV0.ff)('jpd-trial-end-lock-screen-experiment');
// +owner:pdhanuka
// eslint-disable-next-line jira/ff/inline-usage
const $9081c29c094d647d$var$isPendoIntegrationEnabled = ()=>(0, $1ybV0.ff)('jira-frontend-pendo-analytics_s6sj5');

// -owner:pdhanuka
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9081c29c094d647d$var$Global = (0, $6VZoe.lazy)(()=>(parcelRequire("1YvhU")), {
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/global/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9081c29c094d647d$var$Navigation = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("9desP")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/navigation/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9081c29c094d647d$var$Trackers = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("bWhFx")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/trackers/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9081c29c094d647d$var$RemoteActions = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("V8FqF")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/remote-actions/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9081c29c094d647d$var$LazyNonCriticalDesShareLinkFlag = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("lJUyT")).then(({ NonCriticalDesShareLinkFlag: NonCriticalDesShareLinkFlag })=>NonCriticalDesShareLinkFlag), {
    ssr: false,
    moduleId: "./src/packages/growth/des-share-link/src/ui/index.tsx"
});

// No need for a whole chunk for a single component
/* eslint-disable-next-line jira/import/webpack-magic-comment-entries, jira/deprecations/no-rll-client-async-experiences */ const $9081c29c094d647d$var$AfterPaintIssuePreEval = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("gvsYN")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/after-paint-issue-preeval/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9081c29c094d647d$var$AsyncBrowserStorageControlsInit = (0, $6VZoe.lazy)(()=>(parcelRequire("z8DAf")).then(({ BrowserStorageControlsInit: BrowserStorageControlsInit })=>BrowserStorageControlsInit), {
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/browser-storage-controls-init/index.tsx"
});
const $9081c29c094d647d$var$runtimeProps = {};
const $9081c29c094d647d$var$entryPointParams = {};
const $9081c29c094d647d$export$70b554b486395223 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $cLxEl.upgradeOnboardingExperimentEntryPoint), $9081c29c094d647d$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "growth.upgradeOnboardingExperiment",
        packageName: "issue-view",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $9081c29c094d647d$var$runtimeProps
    });
};
const $9081c29c094d647d$export$3859d35c5447350b = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $5EZtQ.rovoVideoModalEntryPoint), $9081c29c094d647d$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "growth.rovoVideoPlayer",
        packageName: "rovo-video-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $9081c29c094d647d$var$runtimeProps
    });
};
const $9081c29c094d647d$export$3211958f96133af8 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $gbSuS.jiraLossAversionModalEntryPoint), $9081c29c094d647d$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "growth.jiraLossAversion",
        packageName: "jira-loss-aversion-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $9081c29c094d647d$var$runtimeProps
    });
};
const $9081c29c094d647d$export$bb0d8fff645668ce = ()=>{
    const cloudID = (0, $dWLk9.useCloudId)();
    const { data: project } = (0, $cPEpP.useProject)();
    const projectType = (0, $7ZZxN.toProjectType)(project?.type) || null;
    const productKey = (0, $7ZZxN.projectTypeToCanonicalId)(projectType);
    const deferEditionModalEntryPointParams = (0, $eUqFw.useMemo)(()=>({
            cloudId: cloudID,
            productKey: productKey
        }), [
        cloudID,
        productKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $2RiaW.jiraDeferEditionModalEntryPoint), deferEditionModalEntryPointParams);
    const onComplete = (0, $eUqFw.useCallback)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69KNw.AsyncDeferEditionEPCheckWrapper), {
        onComplete: onComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "growth.jiraDeferEditionModal",
        packageName: "jira-defer-edition-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $9081c29c094d647d$var$runtimeProps
    }));
};
const $9081c29c094d647d$var$DeferEditionModal = (0, $dnJL9.componentWithFG)('cross-flow-defer-edition-communication-gate', $9081c29c094d647d$export$bb0d8fff645668ce, ()=>null);
const $9081c29c094d647d$var$DeferRovoVideoModal = (0, $dnJL9.componentWithFG)('rovo_video_player_gate', $9081c29c094d647d$export$3859d35c5447350b, ()=>null);
const $9081c29c094d647d$var$DeferJiraLossAversionModal = (0, $dnJL9.componentWithFG)('jira_loss_aversion_standard_shared_layout_gate', $9081c29c094d647d$export$3211958f96133af8, ()=>null);
const $9081c29c094d647d$var$DesShareLinkFlag = (0, $dnJL9.componentWithFG)('jira_des_share_link_gate', $9081c29c094d647d$var$LazyNonCriticalDesShareLinkFlag, ()=>null);
const $9081c29c094d647d$var$AsyncRecommendPremiumToStandardModal = (0, $dnJL9.componentWithFG)('recommend_standard_in_jira_eot_shared_layout_', (0, $i0pNS.AsyncRecommendPremiumToStandardModalWrapper), ()=>null);
$9081c29c094d647d$var$DeferEditionModal.displayName = 'DeferEditionModal';
$9081c29c094d647d$var$DeferRovoVideoModal.displayName = 'DeferRovoVideoModal';
$9081c29c094d647d$var$DeferJiraLossAversionModal.displayName = 'DeferJiraLossAversionModal';
$9081c29c094d647d$var$DesShareLinkFlag.displayName = 'DesShareLinkFlag';
$9081c29c094d647d$var$AsyncRecommendPremiumToStandardModal.displayName = 'AsyncRecommendPremiumToStandardModal';
const $9081c29c094d647d$var$sharedGlobalComponents = [
    ...false ? [] : [
        (0, $2m6cd.MatchedRouteListener),
        (0, $hEyt5.PreviousRouterStateListener),
        (0, $6Q9xY.LoadingPhaseManager),
        (0, $j6ken.LoadingBarUIController),
        (0, $2WOJv.default),
        (0, $1OfKM.BreadcrumbAdapter),
        (0, $iOtr0.default),
        (0, $i9XZP.PageDwellAnalyticsListener),
        (0, $d8a4z.ImperativeAPI),
        (0, $egQj9.TrackClicksBeforeTTI),
        (0, $cADdB.default),
        (0, $lFrSS.AsyncUpflowIframeComponent),
        (0, $BRKX9.JiraHeritageLoader),
        $9081c29c094d647d$var$AsyncBrowserStorageControlsInit,
        ...$9081c29c094d647d$var$isPendoIntegrationEnabled() ? [
            (0, $gMtJP.AsyncPendoAnalyticsWrapper)
        ] : [],
        (0, $6xYPC.default),
        $9081c29c094d647d$var$RemoteActions,
        ...$9081c29c094d647d$var$isTrialEndLockScreenExperimentEnabled() ? [
            (0, $3eqbP.AsyncLockScreenExperimentSharedWrapper)
        ] : [],
        (0, $9zysr.componentWithCondition)(()=>(0, $eI5EY.fg)('jira_upgrade_onboarding'), $9081c29c094d647d$export$70b554b486395223, ()=>null),
        $9081c29c094d647d$var$DeferEditionModal,
        $9081c29c094d647d$var$DeferRovoVideoModal,
        $9081c29c094d647d$var$DeferJiraLossAversionModal,
        (0, $1ZDON.AsyncEndOfTrialMessageSharedWrapper),
        $9081c29c094d647d$var$DesShareLinkFlag,
        $9081c29c094d647d$var$AsyncRecommendPremiumToStandardModal
    ],
    $9081c29c094d647d$var$Global,
    $9081c29c094d647d$var$Navigation,
    $9081c29c094d647d$var$Trackers,
    $9081c29c094d647d$var$AfterPaintIssuePreEval
];
const $9081c29c094d647d$var$SafeEmbeddedConfluencePanelWithExperiments = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
    return expConfig.get('cohort', 'not-enrolled') === 'experiment' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eGjiP.SafeEmbeddedConfluencePanel), null) : null;
};
const $9081c29c094d647d$export$5f4dc7c98070d93e = (0, $isbb2.createLayout)({
    rightSidebars: [
        (0, $jxIns.SafeHelpPanel),
        (0, $d3Jbb.SafeConversationAssistantPanel),
        $9081c29c094d647d$var$SafeEmbeddedConfluencePanelWithExperiments
    ],
    globalComponents: $9081c29c094d647d$var$sharedGlobalComponents
});

});
parcelRegister("2WOJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f61d7eac9e8a3283$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxcfv = parcelRequire("dxcfv");

var $48k9t = parcelRequire("48k9t");
const $f61d7eac9e8a3283$var$CacheRegistry = ()=>{
    const accountIdLoggedInUser = (0, $dxcfv.useAccountId)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $48k9t.default).set(accountIdLoggedInUser ?? 'anonymous');
    }, [
        accountIdLoggedInUser
    ]);
    return null;
};
var $f61d7eac9e8a3283$export$2e2bcd8739ae039 = $f61d7eac9e8a3283$var$CacheRegistry;

});
parcelRegister("48k9t", function(module, exports) {

$parcel$export(module.exports, "CACHE_PREFIX", () => $619b603377692131$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $619b603377692131$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $619b603377692131$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");
let $619b603377692131$var$resolveCachePromise;
const $619b603377692131$var$cachePromise = new Promise((resolve)=>{
    $619b603377692131$var$resolveCachePromise = resolve;
});
const $619b603377692131$export$27be962d708928a = '__scope_key__';
const $619b603377692131$export$69ca515e4489d790 = 'cache_prefix';
const $619b603377692131$var$TIMEOUT = 10000;
const $619b603377692131$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $aZaPn.createLocalStorageProvider)($619b603377692131$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$619b603377692131$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $619b603377692131$export$653cd03438bb0386 = ()=>$619b603377692131$var$promiseWithMaxExecutionTime($619b603377692131$var$TIMEOUT, $619b603377692131$var$cachePromise);
const $619b603377692131$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $aZaPn.createLocalStorageProvider)($619b603377692131$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($619b603377692131$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            storage.set($619b603377692131$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $619b603377692131$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $619b603377692131$export$2e2bcd8739ae039 = $619b603377692131$var$config;

});
parcelRegister("aZaPn", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageProvider", () => $e83d7abe46867842$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $e83d7abe46867842$export$59acef2b3ab1df90);

var $jqvCZ = parcelRequire("jqvCZ");

var $avHyR = parcelRequire("avHyR");

var $kkXA4 = parcelRequire("kkXA4");
const $e83d7abe46867842$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>(0, $avHyR.createStorageProvider)(appPrefix, (0, $kkXA4.makeLocalStore)()));
const $e83d7abe46867842$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const store = (0, $kkXA4.makeLocalExpirableStore)();
    return store.namespace(appPrefix);
});

});
parcelRegister("avHyR", function(module, exports) {

$parcel$export(module.exports, "plugins", () => $e7af9f5944d51b15$export$8b3ca321c77fdea6);
$parcel$export(module.exports, "createStorageProvider", () => $e7af9f5944d51b15$export$8441605555fbd60c);

var $2y3XF = parcelRequire("2y3XF");

var $4b9NC = parcelRequire("4b9NC");
const $e7af9f5944d51b15$export$8b3ca321c77fdea6 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
    (0, $4b9NC.default)
];
const $e7af9f5944d51b15$export$8441605555fbd60c = (appPrefix, store)=>store.namespace(appPrefix);

});
parcelRegister("4b9NC", function(module, exports) {

$parcel$export(module.exports, "default", () => $19af1635632d325b$export$2e2bcd8739ae039);

var $guiFP = parcelRequire("guiFP");

var $gjqa4 = parcelRequire("gjqa4");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $19af1635632d325b$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $gjqa4.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $gjqa4.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $gjqa4.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $gjqa4.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $guiFP.default)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e,
                    skipSentry: true
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $guiFP.default)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $gjqa4.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $gjqa4.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $gjqa4.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $gjqa4.ONE_WEEK) >= (0, $gjqa4.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $gjqa4.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $19af1635632d325b$export$2e2bcd8739ae039 = $19af1635632d325b$var$cleanUpPlugin;

});
parcelRegister("gjqa4", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE", () => $cf4854539b53d7dc$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $cf4854539b53d7dc$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $cf4854539b53d7dc$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $cf4854539b53d7dc$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $cf4854539b53d7dc$export$ea28dfd9333cda2d);
const $cf4854539b53d7dc$export$6aad947bda0f3f46 = 'timestamps';
const $cf4854539b53d7dc$export$8187f416f1cc43d8 = 604800000;
const $cf4854539b53d7dc$export$6e952fa7d47190cf = 4 * $cf4854539b53d7dc$export$8187f416f1cc43d8;
const $cf4854539b53d7dc$export$da99ebca8f453abd = 22;
const $cf4854539b53d7dc$export$ea28dfd9333cda2d = 1014;

});



parcelRegister("kkXA4", function(module, exports) {

$parcel$export(module.exports, "makeLocalStore", () => $b4e518dc83f214e8$export$b2631085fe8db7af);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $b4e518dc83f214e8$export$cf816b43e73de947);

var $2y3XF = parcelRequire("2y3XF");

var $gleLd = parcelRequire("gleLd");

var $ZGlKn = parcelRequire("ZGlKn");

var $5rWiD = parcelRequire("5rWiD");

var $gpWeB = parcelRequire("gpWeB");

var $avHyR = parcelRequire("avHyR");
const $b4e518dc83f214e8$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($5rWiD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], (0, $avHyR.plugins));
const $b4e518dc83f214e8$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($5rWiD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gleLd)))
    ]);

});




parcelRegister("gMtJP", function(module, exports) {

$parcel$export(module.exports, "AsyncPendoAnalyticsWrapper", () => $b64a74411af401d0$export$1c388e7c464f3699);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $5GxEP = parcelRequire("5GxEP");

var $aR8n6 = parcelRequire("aR8n6");

const $b64a74411af401d0$var$AsyncPendoAnalytics = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("axSeT")).then(({ PendoAnalytics: PendoAnalytics })=>PendoAnalytics), {
    moduleId: "./src/packages/platform/services/pendo-analytics/src/index.tsx"
});
const $b64a74411af401d0$export$1c388e7c464f3699 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "jiraCommonPendoAnalyticsReportErrors",
        packageName: "jiraCommonPendoAnalytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        teamName: "martech",
        id: "jiraCommonPendoAnalyticsReportErrors",
        packageName: "jiraCommonPendoAnalytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b64a74411af401d0$var$AsyncPendoAnalytics, null)));

});
parcelRegister("axSeT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("dh7j2")
]).then(()=>parcelRequire('4Sylr'));

});


parcelRegister("d3Jbb", function(module, exports) {

$parcel$export(module.exports, "SafeConversationAssistantPanel", () => $13a9fb2c9a767804$export$453401d0b697d2db);

var $eUqFw = parcelRequire("eUqFw");

var $6PJBT = parcelRequire("6PJBT");


var $0cdA8 = parcelRequire("0cdA8");

var $bUi2Q = parcelRequire("bUi2Q");

var $bFzGY = parcelRequire("bFzGY");

var $6vpb8 = parcelRequire("6vpb8");
const $13a9fb2c9a767804$var$PanelInLayout = ()=>{
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $eUqFw.useState)();
    const prevPanelIdRef = (0, $eUqFw.useRef)();
    const delayRef = (0, $eUqFw.useRef)(null);
    const { closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const panelId = rightSidebarCurrentState?.panelId;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $d3227e938619716f$export$dffb4ed44e20ea9a)) {
            /**
			 * The right-sidebar is showing the conversation assistant...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== CONVERSATION_ASSISTANT_CONTAINER_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
                createAnalyticsEvent({
                    action: 'closed',
                    actionSubject: 'aiMatePanel',
                    source: 'AIMate',
                    tags: [
                        'atlaskit',
                        'aiMate'
                    ]
                }).fire((0, $6PJBT.FabricChannel).aiMate);
            }, 310);
        } else /**
			 * If the right sidebar is not showing the conversation assistant,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        createAnalyticsEvent,
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $d3227e938619716f$export$dffb4ed44e20ea9a)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6vpb8.JiraConversationAssistant), {
        onClosePanel: closeCurrentRightSidebar
    });
};
const $13a9fb2c9a767804$export$453401d0b697d2db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-conversation-assistant-panel",
        packageName: "jiraConversationAssistant"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($13a9fb2c9a767804$var$PanelInLayout, null));

});
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $d3227e938619716f$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $d3227e938619716f$export$64aee74ba59709e5 = 439; // px
const $d3227e938619716f$export$1c07393c5bb1bc27 = 439; // px
const $d3227e938619716f$export$aa3478deee7adbeb = 350; // px
const $d3227e938619716f$export$21e515a86cd1733b = 'Chat';

parcelRegister("6vpb8", function(module, exports) {

$parcel$export(module.exports, "JiraConversationAssistant", () => $477d20553922474c$export$da8473714271a41d);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hThUx = parcelRequire("hThUx");
var $7SmOI = parcelRequire("7SmOI");


var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $bUi2Q = parcelRequire("bUi2Q");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jD3pk = parcelRequire("jD3pk");

var $4rWQe = parcelRequire("4rWQe");

var $dWLk9 = parcelRequire("dWLk9");
const $477d20553922474c$var$SYNTHETIC_HEADER = 'x-issynthetic-traffic';
const $477d20553922474c$export$da8473714271a41d = ({ onClosePanel: onClosePanel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const activationId = (0, $4rWQe.useActivationId)();
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const isSyntheticTenant = (0, $6rW04.default)('ajs-is-synthetic') === 'true' || (0, $1ybV0.ff)('jsw.pollinator.tenants');
    let baseUrl = '/gateway/api/assist';
    if ((0, $1ybV0.ff)('jira.frontend.ai.mate.route.stargate.to.convo.ai')) baseUrl = '/gateway/api/assist-kotlin';
    else if ((0, $XHGTv.getBooleanFF)('platform.jira.frontend.ai.mate_route_stargate_to_stg_west')) baseUrl = '/gateway/api/assist-tester';
    const config = (0, $eUqFw.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            activationId: activationId,
            product: 'jira',
            orgId: orgId,
            experienceId: 'ai-mate',
            assistanceServiceConfig: {
                // TODO: type `AssistanceServiceConfig` should be decoupled from headers to prevent the need for other required keys which shouldn't need to be defined here (`product` and `experienceId`)
                headers: isSyntheticTenant ? {
                    [$477d20553922474c$var$SYNTHETIC_HEADER]: String(isSyntheticTenant)
                } : {},
                baseUrl: baseUrl
            }
        }), [
        cloudId,
        activationId,
        orgId,
        isSyntheticTenant,
        baseUrl
    ]);
    const handleResizeComplete = (0, $eUqFw.useCallback)((width)=>{
        openRightSidebar((0, $d3227e938619716f$export$dffb4ed44e20ea9a), width);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'aiMatePanel'
        }));
    }, [
        openRightSidebar,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7SmOI.ResizeWrapper), {
        onResizeComplete: handleResizeComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $477d20553922474c$var$conversationAssistantWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hThUx.default), {
        testId: "conversation-assistant.ui.conversation-assistant",
        onCloseChat: onClosePanel,
        config: config
    })));
};
const $477d20553922474c$var$conversationAssistantWrapperStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});

});
parcelRegister("hThUx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bae10296cd040ced$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

var $bae10296cd040ced$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("6jhOK")),
    loading: ()=>null
});

});
parcelRegister("bYKiA", function(module, exports) {
"use strict";
var $8b893642f4a42c8a$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $8b893642f4a42c8a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8b893642f4a42c8a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8b893642f4a42c8a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
var $8b893642f4a42c8a$var$ALL_INITIALIZERS = [];
var $8b893642f4a42c8a$var$READY_INITIALIZERS = [];
function $8b893642f4a42c8a$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $8b893642f4a42c8a$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $8b893642f4a42c8a$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $8b893642f4a42c8a$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $8b893642f4a42c8a$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $8b893642f4a42c8a$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $8b893642f4a42c8a$var$render(loaded, props) {
    return $eUqFw.createElement($8b893642f4a42c8a$var$resolve(loaded), props);
}
function $8b893642f4a42c8a$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $8b893642f4a42c8a$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $8b893642f4a42c8a$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $8b893642f4a42c8a$var$READY_INITIALIZERS.push(function() {
        if ($8b893642f4a42c8a$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $8b893642f4a42c8a$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $8b893642f4a42c8a$var$_classCallCheck(this, LoadableComponent);
            var _this = $8b893642f4a42c8a$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $eUqFw.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($eUqFw.Component), _class.contextTypes = {
        loadable: $1Qivz.shape({
            report: $1Qivz.func.isRequired
        })
    }, _temp;
}
function $8b893642f4a42c8a$var$Loadable(opts) {
    return $8b893642f4a42c8a$var$createLoadableComponent($8b893642f4a42c8a$var$load, opts);
}
function $8b893642f4a42c8a$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $8b893642f4a42c8a$var$createLoadableComponent($8b893642f4a42c8a$var$loadMap, opts);
}
$8b893642f4a42c8a$var$Loadable.Map = $8b893642f4a42c8a$var$LoadableMap;
var $8b893642f4a42c8a$var$Capture = function(_React$Component2) {
    $8b893642f4a42c8a$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $8b893642f4a42c8a$var$_classCallCheck(this, Capture);
        return $8b893642f4a42c8a$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $eUqFw.Children.only(this.props.children);
    };
    return Capture;
}($eUqFw.Component);
$8b893642f4a42c8a$var$Capture.propTypes = {
    report: $1Qivz.func.isRequired
};
$8b893642f4a42c8a$var$Capture.childContextTypes = {
    loadable: $1Qivz.shape({
        report: $1Qivz.func.isRequired
    }).isRequired
};
$8b893642f4a42c8a$var$Loadable.Capture = $8b893642f4a42c8a$var$Capture;
function $8b893642f4a42c8a$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $8b893642f4a42c8a$var$flushInitializers(initializers);
    });
}
$8b893642f4a42c8a$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $8b893642f4a42c8a$var$flushInitializers($8b893642f4a42c8a$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$8b893642f4a42c8a$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $8b893642f4a42c8a$var$flushInitializers($8b893642f4a42c8a$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $8b893642f4a42c8a$var$Loadable;

});

parcelRegister("6jhOK", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("RnkJu")
]).then(()=>parcelRequire('aK13m'));

});


parcelRegister("7SmOI", function(module, exports) {

$parcel$export(module.exports, "ResizeWrapper", () => $277d44fdaa74c1af$export$c7990a6594835e51);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $ho1Ek = parcelRequire("ho1Ek");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

const $277d44fdaa74c1af$var$rootStyles = (0, $1ZAYh.xcss)({
    right: 'space.0',
    display: 'flex',
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100vh - ${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)} - ${(0, $ho1Ek.BANNER_HEIGHT)})`
});
const $277d44fdaa74c1af$var$handleStyles = (0, $1ZAYh.xcss)({
    cursor: 'ew-resize',
    userSelect: 'none',
    position: 'absolute',
    top: 'space.200',
    bottom: 'space.0',
    left: 'space.0',
    width: '24px',
    borderTopLeftRadius: 'border.radius.200',
    transition: 'border 0.2s ease-in-out',
    borderLeft: '2px solid transparent',
    ':hover': {
        borderLeft: `2px solid ${"var(--ds-background-information-bold-hovered, #0055CC)"}`
    }
});
const $277d44fdaa74c1af$var$handleSpacerStyles = (0, $1ZAYh.xcss)({
    width: '24px',
    position: 'absolute',
    display: 'block',
    left: '-24px',
    top: 'space.0',
    bottom: 'space.0'
});
const $277d44fdaa74c1af$export$c7990a6594835e51 = ({ children: children, onResizeComplete: onResizeComplete, initialWidth: initialWidth = (0, $d3227e938619716f$export$64aee74ba59709e5), minWidth: minWidth = (0, $d3227e938619716f$export$64aee74ba59709e5), maxWidth: maxWidth = '50vw' })=>{
    const [width, setWidth] = (0, $eUqFw.useState)(initialWidth);
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const isDraggingRef = (0, $eUqFw.useRef)(false);
    const initialMousePositionRef = (0, $eUqFw.useRef)(0);
    const prevDistanceMovedRef = (0, $eUqFw.useRef)(0);
    const rafRef = (0, $eUqFw.useRef)(null);
    const getWrapperWidth = ()=>{
        return wrapperRef.current?.getBoundingClientRect()?.width || 0;
    };
    const handleMouseMove = (0, $eUqFw.useCallback)((event)=>{
        if (!isDraggingRef.current) return;
        const distanceMoved = event.clientX - initialMousePositionRef.current;
        let updatedWidth;
        const currentWidth = getWrapperWidth();
        // Ignore events without change
        if (distanceMoved === prevDistanceMovedRef.current || distanceMoved === 0) return;
        // Acknowledge latest direction adjustment
        prevDistanceMovedRef.current = distanceMoved;
        // Clear queued animation frame
        if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
        rafRef.current = requestAnimationFrame(()=>{
            // Update widths with upper and lower limits respected when `minWidth` and `maxWidth` are `number`
            // When `string`, we'll respect this value on the styles of the wrapper for use-cases such as '100%', '70vw' etc.
            if (distanceMoved < 0) {
                updatedWidth = currentWidth + Math.abs(distanceMoved);
                if (typeof maxWidth === 'number' && !isNaN(maxWidth)) updatedWidth = Math.min(updatedWidth, maxWidth);
            } else {
                updatedWidth = currentWidth - distanceMoved;
                if (typeof minWidth === 'number' && !isNaN(minWidth)) updatedWidth = Math.max(updatedWidth, minWidth);
            }
            setWidth(updatedWidth);
            initialMousePositionRef.current = event.clientX;
        });
    }, [
        maxWidth,
        minWidth
    ]);
    const handleMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Indicate dragging
        isDraggingRef.current = true;
        // Indicate starting point
        initialMousePositionRef.current = event.clientX;
    }, []);
    const handleMouseUp = (0, $eUqFw.useCallback)(()=>{
        if (isDraggingRef.current && onResizeComplete) onResizeComplete(wrapperRef.current?.getBoundingClientRect().width || width);
        isDraggingRef.current = false;
    }, [
        onResizeComplete,
        width
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const mouseMoveHandler = (0, $74BVL.bind)(window, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        const mouseUpHandler = (0, $74BVL.bind)(window, {
            type: 'mouseup',
            listener: handleMouseUp
        });
        return ()=>{
            mouseMoveHandler();
            mouseUpHandler();
            if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
        };
    }, [
        handleMouseMove,
        handleMouseUp
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $277d44fdaa74c1af$var$rootStyles,
        ref: wrapperRef,
        role: "presentation",
        testId: "panel-resize-wrapper",
        style: {
            width: width,
            maxWidth: maxWidth,
            minWidth: minWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "panel-resize-handle",
        onMouseDown: handleMouseDown,
        xcss: $277d44fdaa74c1af$var$handleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $277d44fdaa74c1af$var$handleSpacerStyles
    })), children);
};

});

parcelRegister("4rWQe", function(module, exports) {

$parcel$export(module.exports, "useActivationId", () => $a2ceb1e21dea3b54$export$43686faa787c943);

var $gd0Sp = parcelRequire("gd0Sp");
const $a2ceb1e21dea3b54$export$43686faa787c943 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.activationId;
};

});

parcelRegister("dWLk9", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $15ea95bdeaf03a79$export$9da0f7c65f28ed16);

var $gd0Sp = parcelRequire("gd0Sp");
const $15ea95bdeaf03a79$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});



parcelRegister("69KNw", function(module, exports) {

$parcel$export(module.exports, "AsyncDeferEditionEPCheckWrapper", () => $d4f7e79a98bf2d89$export$4fa5b26bccc7e3df);

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $aR8n6 = parcelRequire("aR8n6");

var $6VZoe = parcelRequire("6VZoe");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d4f7e79a98bf2d89$var$AsyncDeferEditionEPCheck = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("fVtGz")).then(({ EPCheck: EPCheck })=>EPCheck), {
    ssr: false,
    moduleId: "./src/packages/growth/defer-edition-modal/src/async.tsx"
});
const $d4f7e79a98bf2d89$export$4fa5b26bccc7e3df = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "defer-edition-ep-check-async",
        packageName: (0, $9a060b7ebf877081$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        teamName: (0, $9a060b7ebf877081$export$d57b6b390e78d90f),
        id: "defer-edition-ep-check-async",
        packageName: (0, $9a060b7ebf877081$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4f7e79a98bf2d89$var$AsyncDeferEditionEPCheck, props)));

});
const $9a060b7ebf877081$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $9a060b7ebf877081$export$d57b6b390e78d90f = 'transmuters-growth';
const $9a060b7ebf877081$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $9a060b7ebf877081$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $9a060b7ebf877081$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $9a060b7ebf877081$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $9a060b7ebf877081$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $9a060b7ebf877081$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $9a060b7ebf877081$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $9a060b7ebf877081$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';

parcelRegister("fVtGz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("gBePI")
]).then(()=>parcelRequire('cbtdY'));

});


parcelRegister("2RiaW", function(module, exports) {

$parcel$export(module.exports, "jiraDeferEditionModalEntryPoint", () => $4cb205dd87fc0732$export$51f384a783f47807);

var $kKOBp = parcelRequire("kKOBp");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");
const $4cb205dd87fc0732$var$Fallback = ()=>null;

const $4cb205dd87fc0732$export$51f384a783f47807 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(async ()=>{
        if (!false) return (parcelRequire("hbMlx")).then(({ DeferEditionModalComponent: DeferEditionModalComponent })=>DeferEditionModalComponent);
        return $4cb205dd87fc0732$var$Fallback;
    }, {
        moduleId: "fe342c6b"
    }),
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey })=>({
            queries: {
                deferEditionModal: {
                    parameters: (0, $kKOBp.default),
                    variables: {
                        cloudId: cloudId,
                        productKey: productKey
                    }
                }
            }
        })
});

});
parcelRegister("kKOBp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb29fd8ceb1ac78$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<538598f02d4274863e69f87ef93afee0>>
 * @relayHash b88a5c8f8a06940641d1109bbd763eff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b10c1496eb58e67afa6cdffdf558adb655a89e468a81592e6c039cccddb07ac
const $6bb29fd8ceb1ac78$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5b10c1496eb58e67afa6cdffdf558adb655a89e468a81592e6c039cccddb07ac",
        "metadata": {},
        "name": "src_DeferEditionModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6bb29fd8ceb1ac78$export$2e2bcd8739ae039 = $6bb29fd8ceb1ac78$var$node;

});

parcelRegister("hbMlx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("d1CGm")
]).then(()=>parcelRequire('6TGoA'));

});


parcelRegister("1ZDON", function(module, exports) {

$parcel$export(module.exports, "AsyncEndOfTrialMessageSharedWrapper", () => $5baceba59aeb8387$export$ae154a7bf883999f);

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $aR8n6 = parcelRequire("aR8n6");

var $6VZoe = parcelRequire("6VZoe");

var $ejxbt = parcelRequire("ejxbt");

const $5baceba59aeb8387$var$AsyncEndOfTrialMessageSharedGlobalComponent = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("4sY1W")).then(({ EndOfTrialMessageSharedGlobalComponent: EndOfTrialMessageSharedGlobalComponent })=>EndOfTrialMessageSharedGlobalComponent), {
    moduleId: "./src/packages/growth/end-of-trial/end-of-trial-message-shared-global-component/src/index.tsx"
});
const $5baceba59aeb8387$export$ae154a7bf883999f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "end-of-trial-message-shared-async",
        packageName: (0, $ejxbt.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        teamName: (0, $ejxbt.TEAM_NAME),
        id: "end-of-trial-message-shared-async",
        packageName: (0, $ejxbt.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5baceba59aeb8387$var$AsyncEndOfTrialMessageSharedGlobalComponent, null)));

});
parcelRegister("ejxbt", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $f14b50b65c21857b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $f14b50b65c21857b$export$d57b6b390e78d90f);
$parcel$export(module.exports, "STARGATE_URL", () => $f14b50b65c21857b$export$c7e6a6b283196232);
$parcel$export(module.exports, "END_OF_TRIAL_MESSAGE_AUDIENCES", () => $f14b50b65c21857b$export$1986890201f1a80);

var $7ZZxN = parcelRequire("7ZZxN");
const $f14b50b65c21857b$export$b8b9d90f9e5bd72b = '@atlassian/jira-end-of-trial-message-shared-global-component';
const $f14b50b65c21857b$export$d57b6b390e78d90f = 'transmuters-growth';
const $f14b50b65c21857b$export$c7e6a6b283196232 = '/gateway/api';
const $f14b50b65c21857b$export$1986890201f1a80 = {
    [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: [
        'jpd_standard_end_of_trial_message_day_14',
        'jpd_standard_end_of_trial_message_day_13',
        'jpd_standard_end_of_trial_message_day_12',
        'jpd_standard_end_of_trial_message_day_11',
        'jpd_standard_end_of_trial_message_day_10',
        'jpd_standard_end_of_trial_message_day_9',
        'jpd_standard_end_of_trial_message_day_8',
        'jpd_standard_end_of_trial_message_day_7',
        'jpd_standard_end_of_trial_message_day_6',
        'jpd_standard_end_of_trial_message_day_5',
        'jpd_standard_end_of_trial_message_day_4',
        'jpd_standard_end_of_trial_message_day_3',
        'jpd_standard_end_of_trial_message_day_2',
        'jpd_standard_end_of_trial_message_day_1'
    ],
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: [
        'jsm_standard_end_of_trial_message_day_14',
        'jsm_standard_end_of_trial_message_day_13',
        'jsm_standard_end_of_trial_message_day_12',
        'jsm_standard_end_of_trial_message_day_11',
        'jsm_standard_end_of_trial_message_day_10',
        'jsm_standard_end_of_trial_message_day_9',
        'jsm_standard_end_of_trial_message_day_8',
        'jsm_standard_end_of_trial_message_day_7',
        'jsm_standard_end_of_trial_message_day_6',
        'jsm_standard_end_of_trial_message_day_5',
        'jsm_standard_end_of_trial_message_day_4',
        'jsm_standard_end_of_trial_message_day_3',
        'jsm_standard_end_of_trial_message_day_2',
        'jsm_standard_end_of_trial_message_day_1'
    ]
};

});

parcelRegister("4sY1W", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("2lfvs")
]).then(()=>parcelRequire('bUM6a'));

});


parcelRegister("1HzcR", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $48716810ae87e4eb$export$ee1e46af8fa2fb93);

var $eUqFw = parcelRequire("eUqFw");

var $P6D7Q = parcelRequire("P6D7Q");

var $ioLN0 = parcelRequire("ioLN0");
const $48716810ae87e4eb$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $P6D7Q.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ioLN0.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $48716810ae87e4eb$export$54db9e88249c9162 = (0, $ioLN0.InternalEntryPointContainer);

});
parcelRegister("P6D7Q", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $f27db5d96682fc65$export$3cd1c81e13390c49);

var $eUqFw = parcelRequire("eUqFw");
const $f27db5d96682fc65$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $eUqFw.useState)(subject.getValue);
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    return entryPointReference;
};

});

parcelRegister("ioLN0", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $d11d0c1bfdfee8c0$export$5d4dc37edd8a3adb);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");
const $d11d0c1bfdfee8c0$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});


parcelRegister("6j4bv", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $82c08dfbbf99b106$export$338256068bc140fb);

var $eUqFw = parcelRequire("eUqFw");

var $hRw7O = parcelRequire("hRw7O");

var $80LCQ = parcelRequire("80LCQ");

var $fn8UB = parcelRequire("fn8UB");

var $VvIn5 = parcelRequire("VvIn5");
const $82c08dfbbf99b106$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $hRw7O.DEFAULT_OPTIONS))=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $fn8UB.useEntryPointLoadManager)(entryPoint, entryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $VvIn5.useMetricLogger)(metric);
    const entryPointActions = (0, $80LCQ.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $eUqFw.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("hRw7O", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $8aa020919bcd63f9$export$93ca5d3f8675ae4c);
const $8aa020919bcd63f9$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("80LCQ", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $5764a513c11cf0da$export$90681c8c3a56f09a);

var $eUqFw = parcelRequire("eUqFw");

var $gZ48R = parcelRequire("gZ48R");

var $hRw7O = parcelRequire("hRw7O");
const $5764a513c11cf0da$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $5764a513c11cf0da$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $hRw7O.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $hRw7O.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $eUqFw.useRef)();
    const preloadMaxAgeTimeout = (0, $eUqFw.useRef)();
    const preloadLastRequested = (0, $eUqFw.useRef)(0);
    const cancelPreload = (0, $eUqFw.useCallback)(()=>{
        if (!(0, $gZ48R.default)($5764a513c11cf0da$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $eUqFw.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $eUqFw.useCallback)(()=>{
        if ((0, $gZ48R.default)($5764a513c11cf0da$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $eUqFw.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("fn8UB", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $9075a0262fd7a4a5$export$bfae318f9651db2f);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $ln3W8 = parcelRequire("ln3W8");

var $boTUp = parcelRequire("boTUp");
const $9075a0262fd7a4a5$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $ln3W8.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $eUqFw.useRef)(true);
    const timer = (0, $eUqFw.useRef)();
    const entryPointReferenceQueue = (0, $eUqFw.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $boTUp.useEntryPointReferenceSubject)();
    const setNextUpdate = (0, $eUqFw.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        timer.current = setTimeout(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $boTUp.removeAll)(currentQueue) : (0, $boTUp.removeInactiveLoads)(currentQueue);
        }, 0);
    }, [
        setEntryPointReference
    ]);
    const load = (0, $eUqFw.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $iWLL0.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $boTUp.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $eUqFw.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $eUqFw.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            clearTimeout(timer.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $boTUp.removeAll)(entryPointReferenceQueue.current);
        }, []);
    return {
        entryPointReferenceSubject: (0, $eUqFw.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};

});
parcelRegister("ln3W8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b8bb35ae4ffc3ad$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useJiraRelayEnvironmentProvider", () => $8b8bb35ae4ffc3ad$export$83fb48644dee72f0);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $amu7D = parcelRequire("amu7D");
function $8b8bb35ae4ffc3ad$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.RelayEnvironmentProvider), {
        environment: (0, $amu7D.default)()
    }, children);
}
function $8b8bb35ae4ffc3ad$export$83fb48644dee72f0() {
    const environment = (0, $iWLL0.useRelayEnvironment)();
    return (0, $eUqFw.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("amu7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $f68576217aea2baf$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/relay-runtime

var $cNy9K = parcelRequire("cNy9K");

var $9GSiX = parcelRequire("9GSiX");
let $f68576217aea2baf$var$relayEnvironment;
function $f68576217aea2baf$export$2e2bcd8739ae039() {
    if (!$f68576217aea2baf$var$relayEnvironment) {
        const environmentConfig = (0, $9GSiX.getRelayEnvironmentConfig)();
        $f68576217aea2baf$var$relayEnvironment = new (0, $cNy9K.Environment)(environmentConfig);
    }
    return $f68576217aea2baf$var$relayEnvironment;
}

});
parcelRegister("9GSiX", function(module, exports) {

$parcel$export(module.exports, "getRelayEnvironmentConfig", () => $b823b5ac69a7954d$export$a451c85db2d1cda3);

var $9fdRu = parcelRequire("9fdRu");

var $2vvuk = parcelRequire("2vvuk");

var $isMPK = parcelRequire("isMPK");
const $b823b5ac69a7954d$export$a451c85db2d1cda3 = ()=>(0, $isMPK.getDefaultRelayEnvironmentConfig)({
        network: (0, $2vvuk.getNetwork)(),
        log: (0, $9fdRu.default),
        requiredFieldLogger: $9fdRu.requiredFieldLogger
    });

});
parcelRegister("9fdRu", function(module, exports) {

$parcel$export(module.exports, "requiredFieldLogger", () => $c152fc62c06270e5$export$1ab8b98d209afe85);
$parcel$export(module.exports, "default", () => $c152fc62c06270e5$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $gZ48R = parcelRequire("gZ48R");

var $fYqUr = parcelRequire("fYqUr");
const $c152fc62c06270e5$var$RELAY_CLIENT_ID = 'AGG';
const $c152fc62c06270e5$var$LOG_NAMESPACE = `relay.${$c152fc62c06270e5$var$RELAY_CLIENT_ID}.error.graphql`;
const $c152fc62c06270e5$var$requests = {};
const $c152fc62c06270e5$var$queries = {};
const $c152fc62c06270e5$var$resources = {};
const $c152fc62c06270e5$var$executes = {};
const $c152fc62c06270e5$var$CLEANUP_TIMEOUT = 300000; // 5 minutes
const $c152fc62c06270e5$export$1ab8b98d209afe85 = (event)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData($c152fc62c06270e5$var$LOG_NAMESPACE, '[relay required field error]', {
        kind: event.kind,
        owner: event.owner,
        fieldPath: event.fieldPath,
        message: event.kind === 'relay_resolver.error' ? event.error?.message : null
    });
};
const $c152fc62c06270e5$var$getResponseSize = (resp)=>{
    if (resp.data === undefined) return 0;
    try {
        return JSON.stringify(resp.data).length;
    } catch (e) {
        return 0;
    }
};
function $c152fc62c06270e5$export$2e2bcd8739ae039(event) {
    if ((0, $gZ48R.default)('relay_log')) return;
    switch(event.name){
        // NETWORK
        case 'network.start':
            {
                const networkStart = performance.now();
                const { networkRequestId: networkRequestId } = event;
                const { name: name } = event.params;
                const requestInfo = $c152fc62c06270e5$var$requests[networkRequestId];
                if (requestInfo == null) {
                    const newRequestInfo = {
                        name: name,
                        flushes: [],
                        start: networkStart,
                        networkStart: networkStart
                    };
                    $c152fc62c06270e5$var$queries[name] = newRequestInfo;
                    $c152fc62c06270e5$var$requests[networkRequestId] = newRequestInfo;
                    setTimeout(()=>{
                        delete $c152fc62c06270e5$var$requests[networkRequestId];
                        delete $c152fc62c06270e5$var$queries[name];
                    }, $c152fc62c06270e5$var$CLEANUP_TIMEOUT);
                } else requestInfo.networkStart = networkStart;
                break;
            }
        case 'network.next':
            {
                const requestInfo = $c152fc62c06270e5$var$requests[event.networkRequestId];
                if (requestInfo != null) {
                    const { response: response } = event;
                    const addFlush = (resp)=>{
                        if (resp.data !== null) {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const res = resp;
                            const flush = {
                                label: res.label != null ? res.label : 'root',
                                time: performance.now(),
                                size: $c152fc62c06270e5$var$getResponseSize(res)
                            };
                            requestInfo.flushes?.push(flush);
                        }
                    };
                    Array.isArray(response) ? response.forEach(addFlush) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    addFlush(response);
                }
                break;
            }
        case 'network.error':
            {
                const info = $c152fc62c06270e5$var$requests[event.networkRequestId];
                if (info != null) info.error = event.error;
                break;
            }
        case 'network.info':
            break;
        case 'network.complete':
            {
                const requestInfo = $c152fc62c06270e5$var$requests[event.networkRequestId];
                const networkComplete = performance.now();
                if (requestInfo != null) {
                    const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                    requestInfo.size = size;
                    requestInfo.networkComplete = networkComplete;
                    requestInfo.flushes = [];
                    (0, $fYqUr.addSpanToAll)('relay', requestInfo.name, [
                        {
                            name: 'network'
                        }
                    ], requestInfo.start, requestInfo.networkComplete, size);
                }
                break;
            }
        case 'network.unsubscribe':
            break;
        // SUSPENSE
        case 'suspense.fragment':
            break;
        case 'suspense.query':
            break;
        // QUERY
        case 'queryresource.fetch':
            {
                const { node: node } = event.operation.root;
                const fetchStart = performance.now();
                // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                if (node.name != null) {
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                    const { name: name } = node;
                    const requestInfo = $c152fc62c06270e5$var$queries[name];
                    if (requestInfo != null) {
                        requestInfo.fetchStart = fetchStart;
                        $c152fc62c06270e5$var$resources[event.resourceID] = requestInfo;
                    } else {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: fetchStart,
                            fetchStart: fetchStart
                        };
                        $c152fc62c06270e5$var$queries[name] = newRequestInfo;
                        $c152fc62c06270e5$var$resources[event.resourceID] = newRequestInfo;
                        setTimeout(()=>{
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                            delete $c152fc62c06270e5$var$queries[node.name];
                        }, $c152fc62c06270e5$var$CLEANUP_TIMEOUT);
                    }
                    setTimeout(()=>{
                        delete $c152fc62c06270e5$var$resources[event.resourceID];
                    }, $c152fc62c06270e5$var$CLEANUP_TIMEOUT);
                }
                break;
            }
        case 'queryresource.retain':
            {
                const requestInfo = $c152fc62c06270e5$var$resources[event.resourceID];
                if (requestInfo != null && event.profilerContext != null) {
                    requestInfo.end = performance.now();
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const context = event.profilerContext;
                    context?.retainQuery?.(requestInfo);
                }
                break;
            }
        // EXECUTE
        case 'execute.start':
            $c152fc62c06270e5$var$executes[event.executeId] = {
                name: event.params.name,
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type '"query" | "mutation" | "subscription"'.
                kind: event.params.operationKind,
                start: performance.now(),
                duration: 0
            };
            break;
        case 'execute.next':
            $c152fc62c06270e5$var$executes[event.executeId].duration += event.duration;
            break;
        case 'execute.async.module':
            break;
        case 'execute.flight.payload_deserialize':
            break;
        case 'execute.error':
            delete $c152fc62c06270e5$var$executes[event.executeId];
            break;
        case 'execute.complete':
            {
                const op = $c152fc62c06270e5$var$executes[event.executeId];
                if (op != null) {
                    op.end = performance.now();
                    delete $c152fc62c06270e5$var$executes[event.executeId];
                }
                break;
            }
        // STORE
        case 'store.publish':
            break;
        case 'store.snapshot':
            break;
        case 'store.restore':
            break;
        case 'store.gc':
            break;
        // FLUSH
        case 'store.notify.start':
            break;
        case 'store.notify.complete':
            break;
        case 'store.notify.subscription':
            break;
        // ENTRYPOINT
        case 'entrypoint.root.consume':
            break;
        default:
            break;
    }
}

});

parcelRegister("2vvuk", function(module, exports) {

$parcel$export(module.exports, "getNetwork", () => $4d8ddda0e7507868$export$7de4970ebfd8206d);

var $cNy9K = parcelRequire("cNy9K");

var $c4LxQ = parcelRequire("c4LxQ");

var $4aLdW = parcelRequire("4aLdW");

var $b3wL2 = parcelRequire("b3wL2");
const $4d8ddda0e7507868$export$7de4970ebfd8206d = ()=>{
    if ((0, $b3wL2.isSSR)()) (0, $cNy9K.Network).create((0, $c4LxQ.fetch));
    return (0, $cNy9K.Network).create((0, $c4LxQ.fetch), (0, $4aLdW.subscribe));
};

});
parcelRegister("c4LxQ", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $1a035cb2d3f2c948$export$e7aa7bc5c1b3cfb3);

var $ldoFd = parcelRequire("ldoFd");

var $2vzCR = parcelRequire("2vzCR");

var $cNy9K = parcelRequire("cNy9K");

var $XHGTv = parcelRequire("XHGTv");

var $bW292 = parcelRequire("bW292");

var $eTIsH = parcelRequire("eTIsH");

var $fVqUX = parcelRequire("fVqUX");

var $7byHA = parcelRequire("7byHA");

var $lRmyA = parcelRequire("lRmyA");

var $3lpdA = parcelRequire("3lpdA");

var $5zSUY = parcelRequire("5zSUY");

var $15ZJO = parcelRequire("15ZJO");

var $7GiRY = parcelRequire("7GiRY");

var $c7ifG = parcelRequire("c7ifG");

var $j7fph = parcelRequire("j7fph");

var $8tomX = parcelRequire("8tomX");

var $2n6bs = parcelRequire("2n6bs");

var $cmqZo = parcelRequire("cmqZo");

var $5udmX = parcelRequire("5udmX");

var $iuC8B = parcelRequire("iuC8B");

var $ixYrr = parcelRequire("ixYrr");
let $1a035cb2d3f2c948$var$redirecting = false;
const $1a035cb2d3f2c948$var$redirect = ()=>{
    const identity = (0, $bW292.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href)}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = redirectUrl;
};
// Silence error logs from queries in this list
const $1a035cb2d3f2c948$var$blocklist = [
    'issueAggQuery'
];
const $1a035cb2d3f2c948$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
    if (operationKind === 'query') return 0, $3lpdA.RETRY_ATTEMPTS_LIMIT;
    return 0;
};
const $1a035cb2d3f2c948$var$getTraceIdFromExtensions = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.request_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.request_id;
    return undefined;
};
/**
 * Given a set of options, produce a new set of options for consumption which contains
 * a combination of the given set and the default options
 * @param {RequestOptions} options
 * @returns RequestOptions
 */ const $1a035cb2d3f2c948$var$generateOptions = (options = {})=>{
    // the token fetcher returns undefined if no cookie value was found, also in SSR cookies are unavailable
    const csrfToken = !false ? (0, $5zSUY.default)() : undefined;
    // If we don't get a token, there is no point trying to add the csrf header
    const csrfTokenHeader = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(csrfToken) ? {} : {
        'atl-xsrf-token': csrfToken
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, {
        // We have to provide general options here or the headers we provide will override the default ones found
        // here /src/packages/platform/utils/fetch/src/utils/requests.js due to a shallow merge
        ...(0, $fVqUX.default),
        ...options
    }, {
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $7GiRY.default).join(','),
            ...csrfTokenHeader
        }
    });
};
const $1a035cb2d3f2c948$var$checkAuthentication = ()=>{
    if ((0, $XHGTv.getBooleanFF)('platform.mdt-zora.use-heartbeat-singleton_vzod3')) {
        if (!false && !$1a035cb2d3f2c948$var$redirecting) {
            const heartbeatService = (0, $eTIsH.getInstance)();
            if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
                $1a035cb2d3f2c948$var$redirect();
                // Set flag to prevent multiple redirects
                $1a035cb2d3f2c948$var$redirecting = true;
            }
        }
    }
};
const $1a035cb2d3f2c948$export$7bfea3c3d460ecd8 = (error)=>{
    if (error instanceof (0, $7byHA.default)) return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};
const $1a035cb2d3f2c948$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    $1a035cb2d3f2c948$var$checkAuthentication();
    if ($1a035cb2d3f2c948$var$redirecting) // Hang the request if we are redirecting - should be cleared on redirect
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return (0, $cNy9K.Observable).from(new Promise(()=>{}));
    const { name: queryName, operationKind: operationKind } = request;
    const earlyScriptPromise = !false && (0, $8tomX.claimEarlyScriptPromise)((0, $8tomX.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $ixYrr.getLoggingAndMetricsHelper)(loggingMetadata);
    return (0, $cNy9K.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            const endpoint = (0, $cmqZo.getAggEndpoint)(request, cacheConfig);
            const body = (0, $cmqZo.getRequestBody)(request, variables);
            let ssrCache = null;
            if (!false && requestID != null) ssrCache = (0, $j7fph.QueryResponseCache).get(requestID, variables);
            // On client read cache from window.SPA_STATE if available
            if (!false && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(ssrCache)) {
                sink.next(ssrCache);
                if (requestID != null) (0, $j7fph.QueryResponseCache).delete(requestID, variables);
                sink.complete();
                return;
            }
            const wrappedEarlyScriptPromise = earlyScriptPromise && (0, $3lpdA.retryOnError)(()=>(0, $lRmyA.applyErrorHandling)(earlyScriptPromise), {
                retryFunc: ()=>(0, $lRmyA.performPostRequest)(endpoint, $1a035cb2d3f2c948$var$generateOptions({
                        body: body
                    })),
                retryPredicate: $1a035cb2d3f2c948$export$7bfea3c3d460ecd8,
                retryAttempts: $1a035cb2d3f2c948$export$9dec0f42cc67f6ab(queryName, operationKind),
                onRetry: loggingAndMetrics.logErrorRetry
            });
            // Throws HttpError
            const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, $lRmyA.performPostRequestWithRetry)(endpoint, {
                ...$1a035cb2d3f2c948$var$generateOptions({
                    body: body
                }),
                retryPredicate: $1a035cb2d3f2c948$export$7bfea3c3d460ecd8,
                retryAttempts: $1a035cb2d3f2c948$export$9dec0f42cc67f6ab(queryName, operationKind),
                onRetry: (error, attempt)=>{
                    loggingAndMetrics.logErrorRetry(error, attempt);
                }
            }));
            promise.then((response)=>{
                (0, $5udmX.addTraceId)(queryName, $1a035cb2d3f2c948$var$getTraceIdFromExtensions(response));
                (0, $2n6bs.putExtensions)(queryName, response.extensions);
                // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
                const errors = response.errors || undefined;
                if (errors != null) {
                    const requestId = response?.extensions?.gateway?.request_id;
                    if (!$1a035cb2d3f2c948$var$blocklist.includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                    (0, $15ZJO.captureErrors)(errors, {
                        operationName: queryName,
                        requestId: requestId
                    });
                    if ((0, $15ZJO.isUnauthenticated)(errors)) {
                        //  Short circuit operation and handle the unauthorized errors.
                        (0, $iuC8B.showUnauthenticatedFlag)(queryName);
                        return;
                    }
                }
                if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
                // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
                // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
                // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
                response.data = null;
                // cache query response on SSR
                if (false && requestID != null) (0, $j7fph.QueryResponseCache).setWithMetadata(requestID, variables, response, loggingMetadata);
                sink.next(response);
                sink.complete();
            })// We don't await the promise so the catch block below is never
            // triggered so we need an independent catch on the promise
            .catch((error)=>{
                loggingAndMetrics.logError(error);
                sink.error(error);
            });
            if (requestID != null) (0, $c7ifG.QueryPromisesMap).set(requestID, promise);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});
parcelRegister("lRmyA", function(module, exports) {

$parcel$export(module.exports, "transformValidationErrorFromServer", () => $ec20d578245eedba$export$8e9baed7697e4959);
$parcel$export(module.exports, "applyErrorHandling", () => $ec20d578245eedba$export$e174dc943a170ff);
$parcel$export(module.exports, "performGetRequest", () => $ec20d578245eedba$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $ec20d578245eedba$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $ec20d578245eedba$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $ec20d578245eedba$export$8ef51cba9d28f819);
$parcel$export(module.exports, "performPatchRequest", () => $ec20d578245eedba$export$52be6ab13d7e758d);
$parcel$export(module.exports, "performGetRequestWithRetry", () => $ec20d578245eedba$export$659b5ee69e6eb976);
$parcel$export(module.exports, "performPutRequestWithRetry", () => $ec20d578245eedba$export$d7b48b2904a5d812);
$parcel$export(module.exports, "performPostRequestWithRetry", () => $ec20d578245eedba$export$a5717cbee13f28b7);

var $fVqUX = parcelRequire("fVqUX");


var $1ybV0 = parcelRequire("1ybV0");

var $gZ48R = parcelRequire("gZ48R");

var $7byHA = parcelRequire("7byHA");

var $bH2vr = parcelRequire("bH2vr");

var $etaBp = parcelRequire("etaBp");

var $3lpdA = parcelRequire("3lpdA");

var $jxATW = parcelRequire("jxATW");
/**
 * Transform object with field errors from JIRA to an array of FieldValidationErrors
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ec20d578245eedba$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
            field: field,
            error: fieldErrors[field]
        }));
const $ec20d578245eedba$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
    const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
    const fieldErrorsJson = json.errors ?? json.fieldErrors;
    const fieldErrors = fieldErrorsJson ? $ec20d578245eedba$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
    return new (0, $7byHA.ValidationError)(message, fieldErrors, statusCode, traceId, json);
};
const $ec20d578245eedba$var$putOptions = {
    ...(0, $fVqUX.default),
    method: 'PUT'
};
const $ec20d578245eedba$var$postOptions = {
    ...(0, $fVqUX.default),
    method: 'POST'
};
const $ec20d578245eedba$var$deleteOptions = {
    ...(0, $fVqUX.default),
    method: 'DELETE'
};
const $ec20d578245eedba$var$patchOptions = {
    ...(0, $fVqUX.default),
    method: 'PATCH'
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ec20d578245eedba$var$handleNetworkErrors = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ec20d578245eedba$var$handleErrors = (response)=>{
    const traceId = (0, $jxATW.getTraceId)(response);
    // CONTENT_TOO_LARGE errorMessage is used for Hard Limits and, we don't want to override the error message
    if ((0, $1c3fbb431a173cc6$export$9de493bcd9b1d977) === response.status || (0, $1ybV0.ff)('issue.details.hard-limits.milestone-1') && (0, $1c3fbb431a173cc6$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
        throw $ec20d578245eedba$export$8e9baed7697e4959(errorContent, response.status, traceId);
    });
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) {
            if ((0, $1ybV0.ff)('enable-returning-the-original-response_xn2bj')) throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, traceId, response);
            else throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, traceId);
        } else {
            // eslint-disable-next-line no-lonely-if
            if ((0, $1ybV0.ff)('enable-returning-the-original-response_xn2bj')) throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, undefined, response);
            else throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`);
        }
    }
    return response;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ec20d578245eedba$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $1c3fbb431a173cc6$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $ec20d578245eedba$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$22411cbfb09a5c5c = (url, options)=>{
    const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
    const executeRequest = ()=>$ec20d578245eedba$export$e174dc943a170ff(fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, requestOptions)));
    if ((0, $gZ48R.default)('platform_fetch_retries')) return executeRequest();
    return (0, $3lpdA.retryOnError)(executeRequest, {
        retryFunc: executeRequest,
        retryPredicate: retryPredicate,
        retryAttempts: retryAttempts,
        onRetry: onRetry
    });
};
const $ec20d578245eedba$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
        ...(0, $fVqUX.default),
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
        ...$ec20d578245eedba$var$putOptions,
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$692a4d9808143175 = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
        ...$ec20d578245eedba$var$postOptions,
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
        ...$ec20d578245eedba$var$deleteOptions,
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
        ...$ec20d578245eedba$var$patchOptions,
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$659b5ee69e6eb976 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...(0, $fVqUX.default),
        ...options
    });
const $ec20d578245eedba$export$d7b48b2904a5d812 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...$ec20d578245eedba$var$putOptions,
        ...options
    });
const $ec20d578245eedba$export$a5717cbee13f28b7 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...$ec20d578245eedba$var$postOptions,
        ...options
    });
const $ec20d578245eedba$export$6d01bf1146815b9b = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...$ec20d578245eedba$var$deleteOptions,
        ...options
    });
const $ec20d578245eedba$export$560989ee94ad2a20 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...$ec20d578245eedba$var$patchOptions,
        ...options
    });

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;

parcelRegister("3lpdA", function(module, exports) {

$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $689a3993c77053c8$export$81189edc9b923717);
$parcel$export(module.exports, "retryOnError", () => $689a3993c77053c8$export$f859c88bfac2cf2c);
const $689a3993c77053c8$export$81189edc9b923717 = 1;
const $689a3993c77053c8$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $689a3993c77053c8$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $689a3993c77053c8$export$81189edc9b923717 ? $689a3993c77053c8$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};

});


parcelRegister("15ZJO", function(module, exports) {

$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $2d32667fee5bd79d$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $2d32667fee5bd79d$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $2d32667fee5bd79d$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $2d32667fee5bd79d$export$1724ecfee73c4768);
/**
 * Utility methods to capture GraphQl errors and expose them to the frontend for reporting.
 * ```
 * Sample usage:
 * const id = startErrorCapture();
 * ...
 * const errors = stopErrorCapture(id);
 * ```
 */ 
var $hompL = parcelRequire("hompL");
const $2d32667fee5bd79d$var$errorCollector = new Map();
const $2d32667fee5bd79d$export$da396ad2a542b095 = 120000; // 2min
const $2d32667fee5bd79d$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $2d32667fee5bd79d$var$errorCollector.delete(key);
    }, $2d32667fee5bd79d$export$da396ad2a542b095);
};
const $2d32667fee5bd79d$export$c211170518c6d0f6 = (key = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4())=>{
    $2d32667fee5bd79d$var$errorCollector.set(key, []);
    $2d32667fee5bd79d$var$scheduleCleanup(key);
    return key;
};
const $2d32667fee5bd79d$export$e0491a0d974dadfa = (key)=>{
    const errors = $2d32667fee5bd79d$var$errorCollector.get(key);
    $2d32667fee5bd79d$var$errorCollector.delete(key);
    return errors || [];
};
const $2d32667fee5bd79d$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $2d32667fee5bd79d$var$errorCollector.forEach((value, key)=>{
        $2d32667fee5bd79d$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $2d32667fee5bd79d$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};

});

parcelRegister("7GiRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a04fa54516e5a2d1$export$2e2bcd8739ae039);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $a04fa54516e5a2d1$export$2e2bcd8739ae039 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'virtual-agent-beta',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});

parcelRegister("c7ifG", function(module, exports) {

$parcel$export(module.exports, "QueryPromisesMap", () => $a238ea58a6cce413$export$607b80f5bc6e396d);
const $a238ea58a6cce413$export$607b80f5bc6e396d = new Map();

});

parcelRegister("j7fph", function(module, exports) {

$parcel$export(module.exports, "QueryResponseCache", () => $12adf5474a181883$export$688bd21be71b9e5d);

var $9LXG4 = parcelRequire("9LXG4");

var $illlw = parcelRequire("illlw");

var $cNy9K = parcelRequire("cNy9K");

var $gUUjF = parcelRequire("gUUjF");

var $7byHA = parcelRequire("7byHA");

var $9jJAD = parcelRequire("9jJAD");
function $12adf5474a181883$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $cNy9K.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $12adf5474a181883$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $12adf5474a181883$export$be21c283b097d175 extends (0, $cNy9K.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!false) setTimeout(()=>{
            this.logUnusedPayloadErrors();
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    logUnusedPayloadErrors() {
        const loggedQueries = new Set();
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'. | TS7006 - Parameter 'response' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
        this._responses.forEach((response, key)=>{
            const queryID = $12adf5474a181883$export$1e65e863cf3a0f21(key);
            const metadata = this.requestMetadata.get(queryID);
            const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                queryName: 'unknown',
                operationKind: 'unknown'
            };
            if (!loggedQueries.has(queryName)) {
                loggedQueries.add(queryName);
                const error = new (0, $9jJAD.UnusedRelayResponseError)(queryID);
                const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $7byHA.default) ? 'network' : 'unknown';
                // Log any errors even in SSR
                (0, $gUUjF.default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                    message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($9LXG4)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                        'name'
                    ], null)
                });
            }
        });
    }
    setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $12adf5474a181883$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $12adf5474a181883$export$688bd21be71b9e5d = new $12adf5474a181883$export$be21c283b097d175({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $12adf5474a181883$export$94e535e06b7ade61 = ()=>$12adf5474a181883$export$688bd21be71b9e5d.serialize();

});
parcelRegister("9jJAD", function(module, exports) {

$parcel$export(module.exports, "UnusedRelayResponseError", () => $1b0cdf803f3ea26f$export$8431e42d062de453);
class $1b0cdf803f3ea26f$export$8431e42d062de453 extends Error {
    constructor(queryID){
        super(`Relay Query ${queryID} was made during SSR but never used in the browser`);
        this.name = 'UnusedRelayResponseError';
    }
}

});


parcelRegister("8tomX", function(module, exports) {

$parcel$export(module.exports, "getEarlyScriptPromiseKey", () => $da6663b8ee5823ed$export$1102c06c7da91223);
$parcel$export(module.exports, "claimEarlyScriptPromise", () => $da6663b8ee5823ed$export$828ac0325bce4536);
$parcel$export(module.exports, "earlyFetch", () => $da6663b8ee5823ed$export$5b55058781674413);

var $lLasf = parcelRequire("lLasf");

var $fqqil = parcelRequire("fqqil");

var $baC3k = parcelRequire("baC3k");

var $cmqZo = parcelRequire("cmqZo");
const $da6663b8ee5823ed$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
const $da6663b8ee5823ed$export$b5fbc1430cbfd6e1 = (value)=>value;
const $da6663b8ee5823ed$export$6d670d323806bb37 = new Map();
const $da6663b8ee5823ed$export$1102c06c7da91223 = (params, variables)=>{
    const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
    const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
    return `${params.name}|${String(queryId)}|${serializedVariables}`;
};
const $da6663b8ee5823ed$export$828ac0325bce4536 = (key)=>{
    const result = $da6663b8ee5823ed$export$6d670d323806bb37.get(key);
    if (result != null) $da6663b8ee5823ed$export$6d670d323806bb37.delete(key);
    return result;
};
const $da6663b8ee5823ed$export$e1336d32be02faf4 = (key, promise)=>{
    if (!$da6663b8ee5823ed$export$6d670d323806bb37.has(key)) $da6663b8ee5823ed$export$6d670d323806bb37.set(key, promise);
};
const $da6663b8ee5823ed$export$5b55058781674413 = (compiledQuery, variables, experimentalApis = [], capability)=>{
    (0, $lLasf.setMark)('jira.fe-spa.early-preload:start');
    const endpoint = (0, $cmqZo.getAggEndpoint)(compiledQuery.params);
    const body = (0, $cmqZo.getRequestBody)(compiledQuery.params, variables);
    const capabilityHeader = (0, $fqqil.getEnhancedCapabilityHeader)(capability ?? null);
    $da6663b8ee5823ed$export$e1336d32be02faf4($da6663b8ee5823ed$export$1102c06c7da91223(compiledQuery.params, variables), fetch(endpoint, {
        credentials: 'same-origin',
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'Content-Type': 'application/json',
            Accept: 'application/json,text/javascript,*/*',
            'X-ExperimentalApi': experimentalApis.join(','),
            ...(0, $baC3k.getActiveTraceHttpRequestHeaders)(endpoint),
            ...capabilityHeader ? {
                [$da6663b8ee5823ed$var$CAPABILITY_HEADER_NAME]: capabilityHeader
            } : {}
        },
        method: 'POST',
        body: body
    }).then((response)=>{
        (0, $lLasf.setMark)('jira.fe-spa.early-preload:end');
        return response;
    }));
};

});
parcelRegister("lLasf", function(module, exports) {

$parcel$export(module.exports, "setMark", () => $bbbf8be69ced3a7f$export$f7a1fb90d8604165);
$parcel$export(module.exports, "getTraceId", () => $bbbf8be69ced3a7f$export$e88cb5bfb57ce9c4);

const $bbbf8be69ced3a7f$export$f7a1fb90d8604165 = (mark)=>{
    if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
    performance.mark(mark);
};
const $bbbf8be69ced3a7f$var$TRACE_ID_HEADER = 'atl-traceid';
const $bbbf8be69ced3a7f$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $bbbf8be69ced3a7f$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($bbbf8be69ced3a7f$var$TRACE_ID_HEADER) || response.headers.get($bbbf8be69ced3a7f$var$TRACE_ID_HEADER_MICROS);

});


parcelRegister("iuC8B", function(module, exports) {

$parcel$export(module.exports, "showUnauthenticatedFlag", () => $768eb5f0fcd8b90f$export$758fcc357484571e);

var $k8Qyf = parcelRequire("k8Qyf");

var $3FyZ4 = parcelRequire("3FyZ4");

var $glrJM = parcelRequire("glrJM");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $768eb5f0fcd8b90f$var$reloadPage = ()=>window.location.reload();
const $768eb5f0fcd8b90f$var$sendAnalyticEvent = (operationName)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'showed',
            actionSubject: 'unauthorizedFlag',
            attributes: {
                operation: operationName
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $768eb5f0fcd8b90f$export$758fcc357484571e = (operationName)=>{
    (0, $k8Qyf.showFlag)({
        type: 'error',
        title: (0, $glrJM.default).title,
        description: (0, $glrJM.default).description,
        actions: [
            {
                content: (0, $glrJM.default).login,
                onClick: $768eb5f0fcd8b90f$var$reloadPage
            }
        ]
    });
    $768eb5f0fcd8b90f$var$sendAnalyticEvent(operationName);
};

});
parcelRegister("k8Qyf", function(module, exports) {

$parcel$export(module.exports, "showFlag", () => $eeec0389d5aa91e2$export$e12b2cc6b75b006b);
$parcel$export(module.exports, "dismissFlag", () => $eeec0389d5aa91e2$export$900a08a292ad23cd);
$parcel$export(module.exports, "flagService", () => $eeec0389d5aa91e2$export$dbb055af53fd81a0);
$parcel$export(module.exports, "useFlagsService", () => $eeec0389d5aa91e2$export$eee61a1aafe3884);
$parcel$export(module.exports, "useFlagService", () => $eeec0389d5aa91e2$export$dc4f8132c3090b32);
$parcel$export(module.exports, "isDismissFlag", () => $eeec0389d5aa91e2$export$14b1864d9cf0809f);
$parcel$export(module.exports, "isFlagComponent", () => $eeec0389d5aa91e2$export$d84ce5adcee46025);
$parcel$export(module.exports, "isBatchAction", () => $eeec0389d5aa91e2$export$c126d8b307b8ab86);

var $8vPhU = parcelRequire("8vPhU");

var $bbbyK = parcelRequire("bbbyK");

var $lawuT = parcelRequire("lawuT");

var $eo17r = parcelRequire("eo17r");
const $eeec0389d5aa91e2$export$e12b2cc6b75b006b = (0, $bbbyK.default)((0, $lawuT.store).dispatch);
const $eeec0389d5aa91e2$export$900a08a292ad23cd = (0, $8vPhU.default)((0, $lawuT.store).dispatch);
const $eeec0389d5aa91e2$var$dismissFlagById = (id)=>{
    $eeec0389d5aa91e2$export$900a08a292ad23cd((0, $8vPhU.dismissFlag)(id));
};
const $eeec0389d5aa91e2$var$hasFlag = (id)=>Boolean((0, $lawuT.store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
const $eeec0389d5aa91e2$export$dbb055af53fd81a0 = {
    showFlag: $eeec0389d5aa91e2$export$e12b2cc6b75b006b,
    dismissFlag: $eeec0389d5aa91e2$export$900a08a292ad23cd
};
const $eeec0389d5aa91e2$export$eee61a1aafe3884 = ()=>({
        showFlag: $eeec0389d5aa91e2$export$e12b2cc6b75b006b,
        dismissFlag: $eeec0389d5aa91e2$var$dismissFlagById,
        hasFlag: $eeec0389d5aa91e2$var$hasFlag
    });
const $eeec0389d5aa91e2$export$dc4f8132c3090b32 = ()=>$eeec0389d5aa91e2$export$dbb055af53fd81a0;
const $eeec0389d5aa91e2$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, $eo17r.DISMISS_COMMAND);
const $eeec0389d5aa91e2$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
const $eeec0389d5aa91e2$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
const $eeec0389d5aa91e2$export$63ffd7d99470afd4 = (flag)=>!$eeec0389d5aa91e2$export$14b1864d9cf0809f(flag) && !$eeec0389d5aa91e2$export$d84ce5adcee46025(flag) && !$eeec0389d5aa91e2$export$cd5f9f2b991b82d9(flag);
const $eeec0389d5aa91e2$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);

});
parcelRegister("8vPhU", function(module, exports) {

$parcel$export(module.exports, "dismissFlag", () => $39af67031ab9f922$export$900a08a292ad23cd);
$parcel$export(module.exports, "default", () => $39af67031ab9f922$export$2e2bcd8739ae039);

var $bSS3k = parcelRequire("bSS3k");

var $eo17r = parcelRequire("eo17r");
const $39af67031ab9f922$export$900a08a292ad23cd = (flagId)=>({
        command: (0, $eo17r.DISMISS_COMMAND),
        id: flagId
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$39af67031ab9f922$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
        dispatch((0, $bSS3k.dismissFlagAction)(action.id));
    };

});
parcelRegister("bSS3k", function(module, exports) {

$parcel$export(module.exports, "SHOW", () => $953f8b1833086611$export$9d04158a25ce4cd);
$parcel$export(module.exports, "show", () => $953f8b1833086611$export$57bf213be019eeb0);
$parcel$export(module.exports, "DISMISS_INSTANCE", () => $953f8b1833086611$export$b31a07d2e6382678);
$parcel$export(module.exports, "dismiss", () => $953f8b1833086611$export$abf286bbe7073aba);
$parcel$export(module.exports, "DISMISS_FLAG", () => $953f8b1833086611$export$1eb56620df104bf);
$parcel$export(module.exports, "dismissFlagAction", () => $953f8b1833086611$export$4818b3c52448050d);
$parcel$export(module.exports, "RESET", () => $953f8b1833086611$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $953f8b1833086611$export$aad8462122ac592b);
const $953f8b1833086611$export$9d04158a25ce4cd = 'state.SHOW';
const $953f8b1833086611$export$57bf213be019eeb0 = (payload)=>({
        type: $953f8b1833086611$export$9d04158a25ce4cd,
        payload: payload
    });
const $953f8b1833086611$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
const $953f8b1833086611$export$abf286bbe7073aba = (payload)=>({
        type: $953f8b1833086611$export$b31a07d2e6382678,
        payload: payload
    });
const $953f8b1833086611$export$1eb56620df104bf = 'state.DISMISS_FLAG';
const $953f8b1833086611$export$4818b3c52448050d = (payload)=>({
        type: $953f8b1833086611$export$1eb56620df104bf,
        payload: payload
    });
const $953f8b1833086611$export$4a991c87e640ef77 = 'state.RESET';
const $953f8b1833086611$export$aad8462122ac592b = ()=>({
        type: $953f8b1833086611$export$4a991c87e640ef77
    });

});

parcelRegister("eo17r", function(module, exports) {

$parcel$export(module.exports, "DISMISS_COMMAND", () => $2e7952269e32b2ae$export$e705274c5e156b93);
$parcel$export(module.exports, "toFlagId", () => $2e7952269e32b2ae$export$8184bc29de2aea90);
$parcel$export(module.exports, "fromFlagId", () => $2e7952269e32b2ae$export$188cdb77b72629d7);
const $2e7952269e32b2ae$export$e705274c5e156b93 = 'DISMISS';
const $2e7952269e32b2ae$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
const $2e7952269e32b2ae$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();

});


parcelRegister("bbbyK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7364d7b2414b4fa5$export$2e2bcd8739ae039);

var $hompL = parcelRequire("hompL");

var $bSS3k = parcelRequire("bSS3k");

var $eo17r = parcelRequire("eo17r");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7364d7b2414b4fa5$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
        // Flag is of type FlagComponent
        if (typeof flag === 'function') {
            dispatch((0, $bSS3k.show)(flag));
            return undefined;
        }
        const flagId = flag.id || (0, $eo17r.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
        const newFlag = {
            ...flag,
            id: flagId
        };
        dispatch((0, $bSS3k.show)(newFlag));
        return flagId;
    };

});

parcelRegister("lawuT", function(module, exports) {

$parcel$export(module.exports, "store", () => $58565b45d694aa17$export$6f57813fe9f31bf9);

var $l32oR = parcelRequire("l32oR");
const $58565b45d694aa17$export$6f57813fe9f31bf9 = (0, $l32oR.createStore)();

});
parcelRegister("l32oR", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $ecbe96b78b5bbffc$export$f51a9068ac82ea43);

var $8FRHo = parcelRequire("8FRHo");

var $b7i1H = parcelRequire("b7i1H");
const $ecbe96b78b5bbffc$export$f51a9068ac82ea43 = (rootEpic)=>(0, $8FRHo.default)({
        appName: 'flags',
        rootReducer: $b7i1H.default,
        rootEpic: rootEpic
    });

});
parcelRegister("8FRHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cb42e111114ce77$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $MYW4e = parcelRequire("MYW4e");

var $bd1K7 = parcelRequire("bd1K7");

var $lfZsG = parcelRequire("lfZsG");

var $czGdf = parcelRequire("czGdf");

var $jQgix = parcelRequire("jQgix");

var /**
 * Initializes a Redux store with configurations for state management and middleware integration.
 * It addresses serialization challenges with non-serializable entities and enhances debugging capabilities.
 * The custom action listener middleware offers additional control over action dispatches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$9cb42e111114ce77$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
    const actionListenerMiddleware = new (0, $jQgix.default)();
    middlewares.push(actionListenerMiddleware.perform);
    if ((0, $lfZsG.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("iFajX"));
        middlewares.push(logger);
    }
    if (rootEpic) middlewares.push((0, $bd1K7.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
        dependencies: rootEpicDependencies
    } : undefined));
    const store = (0, $huRi7.createStore)((0, $MYW4e.enableBatching)(rootReducer), initialState, (0, $czGdf.default)({
        name: appName,
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; serialize: { replacer: (key: any, value: any) => any; }; }' is not assignable to parameter of type 'DevtoolsConfig'.
        serialize: {
            // Replacer function is necessary to fix redux-devtools because some actions and state are React Elements
            // and the default serialization gets into a loop in a circular dependency somewhere in internal React properties.
            // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#serialize
            // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
            replacer: (key, value)=>{
                if (/*#__PURE__*/ (0, $eUqFw.isValidElement)(value)) {
                    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    if (value.type && value.type.displayName) // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    return `React Element <${value.type.displayName}>`;
                    return 'React Element';
                }
                // The benefit of using React + Redux + declarative API is that there is no more need to save DOM elements in store!
                // ... yet we still do. So when that happens, Redux devtools sometimes crashes because it tries to serialize circular DOM structure.
                if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                return value;
            }
        }
    })((0, $huRi7.compose)(...enhancers, (0, $huRi7.applyMiddleware)(...middlewares))));
    store.addActionListener = actionListenerMiddleware.add;
    store.removeActionListener = actionListenerMiddleware.remove;
    return store;
};

});
parcelRegister("lfZsG", function(module, exports) {

$parcel$export(module.exports, "debugEnabled", () => $bd927ad8c0ea4245$export$342c99cc1e9bc5c6);
const $bd927ad8c0ea4245$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);

});

parcelRegister("czGdf", function(module, exports) {

$parcel$export(module.exports, "default", () => $22794e51b2572269$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");
var // An extended version of redux's 'compose' method, that
// will use redux devtools chrome extension if available
// https://github.com/zalmoxisus/redux-devtools-extension
//
// The 'devtoolsConfig' parameter is an object adhering to the following API:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
// eslint-disable-next-line jira/import/no-anonymous-default-export
$22794e51b2572269$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const config = {
        ...devtoolsConfig
    };
    if (config.name != null && config.instanceId == null) config.instanceId = config.name;
    return 0, $huRi7.compose;
};

});

parcelRegister("jQgix", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7b4a5dd033617f8$export$2e2bcd8739ae039);
class $a7b4a5dd033617f8$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = [];
        this.add = (listener)=>{
            this.listeners.push(listener);
        };
        this.remove = (listener)=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
        // @ts-expect-error - TS2315 - Type 'Middleware' is not generic.
        this.perform = (api)=>(next)=>(action)=>{
                    const result = next(action);
                    this.listeners.forEach((listener)=>listener(action, api.getState()));
                    return result;
                };
    }
}

});


parcelRegister("b7i1H", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2bd228b38d69c07$export$2e2bcd8739ae039);

var $bwbFz = parcelRequire("bwbFz");

var $hompL = parcelRequire("hompL");

var $bSS3k = parcelRequire("bSS3k");
const $d2bd228b38d69c07$var$defaultState = {
    flags: []
};
var /**
 * Manages the state transitions of a notification system by handling actions such as showing
 * new notifications, dismissing notifications (either individually or by type), and
 * resetting to the default state. It uniquely prioritizes high-priority notifications,
 * ensuring they are displayed before low-priority ones, enhancing the user's
 * attention to critical alerts.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$d2bd228b38d69c07$export$2e2bcd8739ae039 = (state = $d2bd228b38d69c07$var$defaultState, action)=>{
    switch(action.type){
        case 0, $bSS3k.SHOW:
            {
                // If flag is of type FlagComponent, it is treated as high priority
                const [lowPriorityFlags, highPriorityFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($bwbFz)))([
                    {
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                        flag: action.payload
                    },
                    ...state.flags
                ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                const flags = [
                    ...highPriorityFlags,
                    ...lowPriorityFlags
                ];
                return {
                    ...state,
                    flags: flags
                };
            }
        case 0, $bSS3k.DISMISS_INSTANCE:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                };
            }
        case 0, $bSS3k.DISMISS_FLAG:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>{
                        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        if (flagInstance.flag.id) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        return flagInstance.flag.id !== id;
                        return true;
                    })
                };
            }
        case 0, $bSS3k.RESET:
            return $d2bd228b38d69c07$var$defaultState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});




parcelRegister("glrJM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1963f04f48a97eb6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1963f04f48a97eb6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "relay-fetch.services.error-flags.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "relay-fetch.services.error-flags.description",
        "defaultMessage": "Looks like you've been signed out. Try logging in again. "
    },
    login: {
        "id": "relay-fetch.services.error-flags.login",
        "defaultMessage": "Log in"
    }
});

});


parcelRegister("ixYrr", function(module, exports) {

$parcel$export(module.exports, "getLoggingAndMetricsHelper", () => $39705662ea381df8$export$726e1df8186bb981);

var $9LXG4 = parcelRequire("9LXG4");

var $illlw = parcelRequire("illlw");

var $ldoFd = parcelRequire("ldoFd");

var $gUUjF = parcelRequire("gUUjF");

var $7byHA = parcelRequire("7byHA");
const $39705662ea381df8$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
const $39705662ea381df8$export$726e1df8186bb981 = (graphqlDetails)=>{
    const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
    return {
        logNonBreakingErrors: (errors, requestId)=>{
            if (false || (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(errors) || !Array.isArray(errors)) return;
            errors.forEach((error)=>{
                error && (0, $gUUjF.default).safeErrorWithoutCustomerData($39705662ea381df8$var$LOG_NAMESPACE, '[graphql error]', {
                    queryName: queryName,
                    operationKind: operationKind,
                    errorType: 'graphql',
                    message: error.message,
                    requestId: requestId
                });
            });
        },
        logError: (error)=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                'statusCode'
            ], null);
            const errorType = error instanceof (0, $7byHA.default) ? 'network' : 'unknown';
            // Log any errors even in SSR
            (0, $gUUjF.default).safeErrorWithoutCustomerData($39705662ea381df8$var$LOG_NAMESPACE, `[${errorType} error]`, {
                message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($9LXG4)))(errorType)} error]: ${error?.message ?? ''}`,
                errorType: errorType,
                statusCode: statusCode,
                queryName: queryName,
                operationKind: operationKind,
                errorName: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                    'name'
                ], null)
            });
        },
        logErrorRetry: (error, retryAttempt)=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                'statusCode'
            ], null);
            const errorType = error instanceof (0, $7byHA.default) ? 'network' : 'unknown';
            // Log any errors even in SSR
            (0, $gUUjF.default).safeErrorWithoutCustomerData($39705662ea381df8$var$LOG_NAMESPACE, `[${errorType} error]`, {
                message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($9LXG4)))(errorType)} error]: ${error?.message ?? ''}`,
                errorType: errorType,
                statusCode: statusCode,
                queryName: queryName,
                operationKind: operationKind,
                errorName: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                    'name'
                ], null),
                retryAttempt: retryAttempt
            });
        }
    };
};

});


parcelRegister("4aLdW", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $ef96f447a7409c6e$export$ec068583843480e7);

var $cNy9K = parcelRequire("cNy9K");

var $guiFP = parcelRequire("guiFP");

var $dIOaC = parcelRequire("dIOaC");

var $lE8MM = parcelRequire("lE8MM");

var $keguF = parcelRequire("keguF");
const $ef96f447a7409c6e$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $cNy9K.Observable).create((sink)=>{
        const client = (0, $dIOaC.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            query: '',
            operationName: operationName,
            variables: variables,
            extensions: {
                pq: id
            }
        };
        let requestId;
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                // @ts-expect-error agg prop is missing on generic "extensions" type
                const aggRequestId = value?.extensions?.agg?.request_id;
                requestId = aggRequestId ?? requestId;
                // @ts-expect-error incompatible types between two libraries
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = (0, $lE8MM.getSinkError)(sinkError);
                const attributes = {
                    operationName: operationName,
                    requestId: requestId,
                    userLocation: (0, $keguF.getUserLocation)()
                };
                sink.error(errorInfo);
                (0, $guiFP.default)({
                    meta: {
                        id: 'subscription',
                        packageName: 'jiraRelaySubscription',
                        teamName: 'uip-graphql'
                    },
                    error: errorInfo,
                    attributes: attributes,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    });

});
parcelRegister("dIOaC", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $176ec127fee3e1b6$export$6bb76d6eba7e258c);

var $9RGox = parcelRequire("9RGox");

var $gZ48R = parcelRequire("gZ48R");

var $7GiRY = parcelRequire("7GiRY");


var $eliQU = parcelRequire("eliQU");
let $176ec127fee3e1b6$var$client;
const $176ec127fee3e1b6$export$6bb76d6eba7e258c = ()=>{
    if ((0, $eliQU.isSSR)() || (0, $gZ48R.default)('graphql_subscriptions')) return null;
    if (!$176ec127fee3e1b6$var$client) $176ec127fee3e1b6$var$client = (0, $9RGox.createClient)({
        url: (0, $eliQU.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $12457a63a9fa501a$export$8b012b965402e06a),
        retryAttempts: (0, $12457a63a9fa501a$export$bf6cd96e19b2987f),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $7GiRY.default).join(',')
        }
    });
    return $176ec127fee3e1b6$var$client;
};
const $176ec127fee3e1b6$export$2f0afd443356d36f = ()=>{
    $176ec127fee3e1b6$var$client = null;
};

});
const $12457a63a9fa501a$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $12457a63a9fa501a$export$bf6cd96e19b2987f = 100;
const $12457a63a9fa501a$export$1ad8434180c5936c = 300000; // 5m

parcelRegister("eliQU", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $dea6d52502362b12$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $dea6d52502362b12$export$29a72e89601dfc59);
const $dea6d52502362b12$export$48d7c418edadb60c = ()=>false ?? false;
const $dea6d52502362b12$export$29a72e89601dfc59 = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    `${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});


parcelRegister("lE8MM", function(module, exports) {

$parcel$export(module.exports, "getSinkError", () => $8f86032d91fec6de$export$ece4736473c28965);
const $8f86032d91fec6de$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    return errorInfo;
};

});


parcelRegister("b3wL2", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $624029006652488f$export$48d7c418edadb60c);
const $624029006652488f$export$48d7c418edadb60c = ()=>false ?? false;

});





parcelRegister("boTUp", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $f334fadd26cc659d$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $f334fadd26cc659d$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $f334fadd26cc659d$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $f334fadd26cc659d$export$322c8997d351da6a);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
const $f334fadd26cc659d$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $f334fadd26cc659d$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $f334fadd26cc659d$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $f334fadd26cc659d$export$322c8997d351da6a = ()=>{
    const value = (0, $eUqFw.useRef)(null);
    const subscribers = (0, $eUqFw.useRef)();
    const subscribe = (0, $eUqFw.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $eUqFw.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        (0, $lEfVV.unstable_batchedUpdates)(()=>{
            if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                subscriber(entryPointReference);
            });
        });
    }, []);
    const getValue = (0, $eUqFw.useCallback)(()=>value.current, []);
    (0, $eUqFw.useEffect)(()=>()=>{
            subscribers.current?.clear();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};

});


parcelRegister("VvIn5", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $df836dfb6cf1aa5a$export$f291ec7cea728e1);

var $eUqFw = parcelRequire("eUqFw");
const $df836dfb6cf1aa5a$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $eUqFw.useRef)(0);
    const loadStartTime = (0, $eUqFw.useRef)(0);
    const startMetric = (0, $eUqFw.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $eUqFw.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("6xYPC", function(module, exports) {

$parcel$export(module.exports, "stopLowPriorityEventDelay", () => $4b25e5ad6cfac913$export$a928755af449867);
$parcel$export(module.exports, "startLowPriorityEventDelay", () => $4b25e5ad6cfac913$export$8bb8df5a93e9525);
$parcel$export(module.exports, "default", () => $4b25e5ad6cfac913$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ICvxP = parcelRequire("ICvxP");

var $6iz4v = parcelRequire("6iz4v");

var $cbwiM = parcelRequire("cbwiM");

var $3FyZ4 = parcelRequire("3FyZ4");

var $epT40 = parcelRequire("epT40");

var $87isp = parcelRequire("87isp");

const $4b25e5ad6cfac913$var$STOP_DELAY_TIMEOUT = 10000;
let $4b25e5ad6cfac913$var$stopDelayTimeout;
let $4b25e5ad6cfac913$var$lastDelayActionPromise = (0, $3FyZ4.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
const $4b25e5ad6cfac913$export$a928755af449867 = ()=>{
    $4b25e5ad6cfac913$var$lastDelayActionPromise = $4b25e5ad6cfac913$var$lastDelayActionPromise.then((client)=>{
        if (!(0, $cbwiM.isEventDelayActive)()) return client;
        clearTimeout($4b25e5ad6cfac913$var$stopDelayTimeout);
        // stopLowPriorityEventDelay performs a flush of the delayed events,
        // so the delayed period needs to be marked as ended _before_ calling that method.
        (0, $6iz4v.setMark)((0, $9f18a423c52d71b6$export$2d91d3eed1108e72));
        (0, $cbwiM.setEventDelayActive)(false);
        client.stopLowPriorityEventDelay();
        return client;
    });
};
const $4b25e5ad6cfac913$export$8bb8df5a93e9525 = ()=>{
    $4b25e5ad6cfac913$var$lastDelayActionPromise = $4b25e5ad6cfac913$var$lastDelayActionPromise.then((client)=>{
        // If startLowPriorityEventDelay is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!(0, $cbwiM.isEventDelayActive)()) {
            (0, $ICvxP.default)((0, $9f18a423c52d71b6$export$358721a9d6125914));
            (0, $6iz4v.setMark)((0, $9f18a423c52d71b6$export$b2122dce85a27912));
        }
        client.startLowPriorityEventDelay();
        (0, $cbwiM.setEventDelayActive)(true);
        clearTimeout($4b25e5ad6cfac913$var$stopDelayTimeout);
        $4b25e5ad6cfac913$var$stopDelayTimeout = setTimeout($4b25e5ad6cfac913$export$a928755af449867, $4b25e5ad6cfac913$var$STOP_DELAY_TIMEOUT);
        return client;
    });
};
const $4b25e5ad6cfac913$export$778ebe2a4fab1ba7 = ()=>$4b25e5ad6cfac913$var$lastDelayActionPromise;
const $4b25e5ad6cfac913$var$EventDelayController = ()=>{
    const [loadedState] = (0, $epT40.default)();
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * The delay mechanism is currently locked so that only automatic exposure events
		 * can leverage it.
		 * We can remove the performance overhead of starting and stopping critical sections when
		 * these events won't be getting fired.
		 */ if (!loadedState.hasLoaded && (0, $87isp.isAutomaticExposureCollectionEnabled)()) $4b25e5ad6cfac913$export$8bb8df5a93e9525();
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
var $4b25e5ad6cfac913$export$2e2bcd8739ae039 = $4b25e5ad6cfac913$var$EventDelayController;

});
parcelRegister("ICvxP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dab3f6273aaa3f2$export$2e2bcd8739ae039);

var $hgcvd = parcelRequire("hgcvd");
var /*
 * This utility finds all performance entries that is prefixed
 * with the `prefix` and does clearMarks on each entry.
 * All the entries that are cleared will be returned
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$5dab3f6273aaa3f2$export$2e2bcd8739ae039 = (prefix)=>{
    // @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    if ((0, $hgcvd.default) && (0, $hgcvd.default).getEntries && (0, $hgcvd.default).clearMarks) return (0, $hgcvd.default)// @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    .getEntries()// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .filter((mark)=>mark.name.startsWith(prefix))// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .map((mark)=>{
        (0, $hgcvd.default).clearMarks(mark.name);
        return mark;
    });
    return [];
};

});

parcelRegister("cbwiM", function(module, exports) {

$parcel$export(module.exports, "setEventDelayActive", () => $00304183c2d9ac4d$export$9a4add6d6ddcc1a);
$parcel$export(module.exports, "isEventDelayActive", () => $00304183c2d9ac4d$export$3536b0184fa98d19);
let $00304183c2d9ac4d$var$eventDelayActive = false;
const $00304183c2d9ac4d$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
    $00304183c2d9ac4d$var$eventDelayActive = isEventDelayActive;
};
const $00304183c2d9ac4d$export$3536b0184fa98d19 = ()=>$00304183c2d9ac4d$var$eventDelayActive;

});

parcelRegister("epT40", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9158c027ae7ce81$export$2e2bcd8739ae039);

var $WBLbN = parcelRequire("WBLbN");


var $cfLkw = parcelRequire("cfLkw");
const $c9158c027ae7ce81$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    const determineHasLoaded = ()=>{
        /*
		 * During a transition, the top navigation is the only app loading. Additionally, legacy pages generally
		 * render a LegacyPage component, analytics, or nothing at all.
		 *
		 * This code ensures that the page is considered loaded when the content has finished loading in the
		 * SPA, or when the top navigation has finished loading for legacy pages.
		 *
		 * Ideally the LegacyPage component should include an app for the content, but the usage of route components
		 * in legacy routes is inconsistent and would need thorough testing. This should be good enough for now.
		 */ if (appIds.length === 1 && appIds[0] === (0, $9c22638d2f17f9db$export$3a54edb6ba4daa82)) return !__SPA__;
        return appIds.length ? appIds.filter((id)=>id !== (0, $9c22638d2f17f9db$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
    };
    const hasLoaded = determineHasLoaded();
    return {
        hasLoaded: hasLoaded
    };
};
const $c9158c027ae7ce81$var$usePageLoadedSubscriber = (0, $WBLbN.createHook)((0, $cfLkw.default), {
    selector: $c9158c027ae7ce81$export$4a361c7505f72f5c
});
var $c9158c027ae7ce81$export$2e2bcd8739ae039 = $c9158c027ae7ce81$var$usePageLoadedSubscriber;

});
const $9c22638d2f17f9db$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $9c22638d2f17f9db$export$2ee9e5a3556c1e43 = 'SIDEBAR';


const $9f18a423c52d71b6$export$358721a9d6125914 = 'event-delay-controller.';
const $9f18a423c52d71b6$export$b2122dce85a27912 = `${$9f18a423c52d71b6$export$358721a9d6125914}start`;
const $9f18a423c52d71b6$export$2d91d3eed1108e72 = `${$9f18a423c52d71b6$export$358721a9d6125914}end`;


parcelRegister("79xbN", function(module, exports) {

$parcel$export(module.exports, "expVal", () => $2783c762502a41a6$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValEquals", () => $2783c762502a41a6$export$45abdb3f977b5b14);
$parcel$export(module.exports, "UNSAFE_noExposureExp", () => $2783c762502a41a6$export$677f9fa2e1ae6fec);

var $8tM2T = parcelRequire("8tM2T");

var $9bn72 = parcelRequire("9bn72");

var $fbE19 = parcelRequire("fbE19");
function $2783c762502a41a6$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    // Handle vendorless scripts use of gates
    (0, $9bn72.UNSAFE_initIfNeeded)();
    const value = (0, $8tM2T.default).getExperimentValue(experimentName, param, defaultValue);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $fbE19.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $2783c762502a41a6$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
    return $2783c762502a41a6$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
}
class $2783c762502a41a6$var$ExperimentConfig {
    constructor(experimentName, config){
        this._experimentName = experimentName;
        this._config = config;
    }
    get(key, defaultValue, typeGuard) {
        const value = this._config.get(key, defaultValue, typeGuard);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $fbE19.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
}
const $2783c762502a41a6$var$cache = new Map();
function $2783c762502a41a6$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $2783c762502a41a6$var$cache.get(experimentName);
    if (instance == null) {
        // Handle vendorless scripts use of gates
        (0, $9bn72.UNSAFE_initIfNeeded)();
        const config = (0, $8tM2T.default).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        const fireExposure = ()=>(0, $8tM2T.default).manuallyLogExperimentExposure(experimentName);
        instance = [
            new $2783c762502a41a6$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $2783c762502a41a6$var$cache.set(experimentName, instance);
    }
    return instance;
}

});

parcelRegister("dnJL9", function(module, exports) {

$parcel$export(module.exports, "componentWithFG", () => $dcea2fa8766d9cd0$export$cf56d0f54cfcce4);

var $9zysr = parcelRequire("9zysr");

var $eI5EY = parcelRequire("eI5EY");
const $dcea2fa8766d9cd0$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $9zysr.componentWithCondition)(()=>(0, $eI5EY.fg)(gateName), ComponentTrue, ComponentFalse);

});

parcelRegister("j6ken", function(module, exports) {

$parcel$export(module.exports, "LoadingBarUIController", () => $04a03fc02281e1a8$export$39bdf67fc71ce8c8);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $d3ujX = parcelRequire("d3ujX");

var $epT40 = parcelRequire("epT40");

var $78d1w = parcelRequire("78d1w");

var $lB25E = parcelRequire("lB25E");

var $1Xxlz = parcelRequire("1Xxlz");

var $cQcOl = parcelRequire("cQcOl");
const $04a03fc02281e1a8$export$54128ad8de32b897 = ({ startLoading: startLoading, resetLoading: resetLoading, finishLoading: finishLoading })=>{
    const [loadedState] = (0, $epT40.default)();
    (0, $eUqFw.useEffect)(()=>{
        startLoading();
        return ()=>{
            resetLoading();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (loadedState.hasLoaded) finishLoading();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
/**
 * Sets up the loading bar stylesheet and controller purely in the client
 * This is a fallback if SSR fails
 *
 */ const $04a03fc02281e1a8$var$LoadingBarUI = ({ shouldRender: shouldRender, routeIdentifier: routeIdentifier })=>{
    const [actions, setActions] = (0, $eUqFw.useState)({});
    const sheetRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLStyleElement | null'.
        const loadingBarActions = (0, $d3ujX.createLoadingBarActionController)(sheetRef.current);
        setActions(loadingBarActions || {});
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLStyleElement> | undefined'.
        ref: sheetRef,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    ${(0, $1Xxlz.LOADER_STYLES_CSS_SELECTOR)} {
                        ${(0, $cQcOl.generateLoadingBarStyles)(0, (0, $1Xxlz.getLoadingBarColor)())}
                    }
                `
        }
    }), shouldRender && actions.START && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($04a03fc02281e1a8$export$54128ad8de32b897, {
        key: routeIdentifier,
        // @ts-expect-error - TS2339 - Property 'START' does not exist on type '{}'.
        startLoading: actions.START,
        // @ts-expect-error - TS2339 - Property 'RESET' does not exist on type '{}'.
        resetLoading: actions.RESET,
        // @ts-expect-error - TS2339 - Property 'FINISH' does not exist on type '{}'.
        finishLoading: actions.FINISH
    }));
};
const $04a03fc02281e1a8$export$e068deb20d61b035 = ()=>{
    let currentTransitionsCount = 0;
    let currentRouteIdentifier = '';
    let currentRouteMatch = '';
    let hasTransitioned = false;
    let key = 0;
    return (transitionsCount, routeIdentifier, routeMatch)=>{
        if (transitionsCount !== currentTransitionsCount) {
            currentTransitionsCount = transitionsCount;
            hasTransitioned = true;
        }
        if (routeIdentifier !== null && routeIdentifier !== currentRouteIdentifier || routeIdentifier === currentRouteIdentifier && routeMatch !== currentRouteMatch) {
            currentRouteIdentifier = routeIdentifier;
            currentRouteMatch = routeMatch;
            if (hasTransitioned) {
                hasTransitioned = false;
                key = currentTransitionsCount;
            }
        }
        return key;
    };
};
const $04a03fc02281e1a8$var$getUniqueTransitionKey = $04a03fc02281e1a8$export$e068deb20d61b035();
/**
 * Determines if the <LoadingBarController> should render or re-render
 * Injects dependencies into <LoadingBarController />
 *
 */ const $04a03fc02281e1a8$export$39bdf67fc71ce8c8 = ()=>{
    const [routerState] = (0, $lB25E.useRouter)();
    const [{ transitionsCount: transitionsCount }] = (0, $78d1w.useSpaStateTransition)();
    const currentRoute = routerState.route && routerState.route.name;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const loaderFailedInSSR = !window.JIRA_LOADING_BAR;
    const shouldRender = (0, $1Xxlz.getAllowedRoutes)().includes(currentRoute);
    // we generate a unique route identifier each time a transition happens
    // we use this key to force re-render of the <LoadingBarController />
    const routeIdentifier = (0, $eUqFw.useMemo)(()=>$04a03fc02281e1a8$var$getUniqueTransitionKey(transitionsCount, currentRoute, JSON.stringify(routerState.match)), [
        transitionsCount,
        currentRoute,
        routerState.match
    ]);
    // We always expect the loading bar to be initialised in SSR for any route in ALLOWED_ROUTES
    // If this doesn't happen, it means SSR failed or the loading bar code in SSR failed
    (0, $eUqFw.useEffect)(()=>{
        if (shouldRender && loaderFailedInSSR) (0, $gUUjF.default).safeWarnWithoutCustomerData('global-loading-bar', 'Loading bar failed to initialise in SSR. This may be because SSR failed or a bug in the loading bar code.');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loaderFailedInSSR
    ]);
    // If the loading bar fails to setup in SSR, we set up the action controller AND stylesheet in the client
    // We also do this if SSR renders a page that does not have the loading bar enabled (eg !shouldRender)
    if (loaderFailedInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($04a03fc02281e1a8$var$LoadingBarUI, {
        shouldRender: shouldRender,
        routeIdentifier: routeIdentifier
    });
    // if the loading bar is succesfully setup in SSR, all the client needs to do is dispatch loading actions
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (shouldRender && window.JIRA_LOADING_BAR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($04a03fc02281e1a8$export$54128ad8de32b897, {
        key: routeIdentifier,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        startLoading: window.JIRA_LOADING_BAR.START,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        resetLoading: window.JIRA_LOADING_BAR.RESET,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        finishLoading: window.JIRA_LOADING_BAR.FINISH
    });
    return null;
};

});
parcelRegister("d3ujX", function(module, exports) {

$parcel$export(module.exports, "createLoadingBarActionController", () => $e871469dab215262$export$55d67d61d9d2ad3b);
// BE VERY CAREFUL IMPORTING ANY PACKAGES IN THIS FILE
// THIS CODE IS AN INLINE FRAGMENT AND RUNS BEFORE POLYFILLS AND MAY BREAK IE

var $g0c9Y = parcelRequire("g0c9Y");
const $e871469dab215262$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
const $e871469dab215262$export$899393f3e23f724b = 15000;
const $e871469dab215262$export$7868b416d8929c55 = 40000;
const $e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR = 'body::before';
const $e871469dab215262$var$EXIT_ANIMATION_SPEED = 300;
const $e871469dab215262$export$99d4e8974a739853 = ()=>(0, $g0c9Y.getMeta)('ajs-lf-navigation-highlightcolour') || $e871469dab215262$export$53d51cc6d57e44da;
const $e871469dab215262$export$4fb8742b05de9693 = (duration)=>`
    ${$e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0.99);
        transition-duration: ${duration}ms;
        transition-timing-function: cubic-bezier(0,1,0.5,1);
    }
`;
const $e871469dab215262$export$5a43e0f09174e553 = ()=>`
    ${$e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(1);
        transition-duration: ${$e871469dab215262$var$EXIT_ANIMATION_SPEED}ms;
        animation: none;
        background-image: none;
    }
`;
const $e871469dab215262$export$6beef8c645a63156 = ()=>`
    ${$e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0);
        transition-duration: 0ms;
        animation: none;
        background-image: none;
    }
`;
const $e871469dab215262$export$610cb442736abf53 = ()=>`
    @keyframes shimmer {
        from {
            left: -80%;
            width: 80%;
        }

        to {
            left: 110%;
            width: 10%;
        }
    }
`;
const $e871469dab215262$export$959e9e99fba397f1 = (loadingBarColor)=>`
        ${$e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR} {
            transform: scaleX(1);
            transition-duration: 0ms;
            background: ${loadingBarColor};
            animation: shimmer 2s infinite;
        }
    `;
const $e871469dab215262$var$browserFocusCheck = (action)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document && document.hidden) action();
    else requestAnimationFrame(()=>{
        action();
    });
};
const $e871469dab215262$export$55d67d61d9d2ad3b = (stylesheet)=>{
    const { sheet: sheet } = stylesheet || {};
    if (!sheet) return undefined;
    let isRunning = false;
    let isDelayed = false;
    let exitAnimationTimer;
    let delayedAnimationTimer;
    let timeoutTimer;
    return {
        START: (duration = $e871469dab215262$export$899393f3e23f724b)=>{
            if (isRunning) return;
            isRunning = true;
            // requestAnimationFrame will not run until the browser tab is focused
            // if a user opens a new tab the start animation will not begin until the tab is focused
            // this can cause the loading bar css to be applied in the incorrect order
            // to solve this we remove requestAnimationFrame if the tab is not focused
            $e871469dab215262$var$browserFocusCheck(()=>{
                sheet.insertRule($e871469dab215262$export$4fb8742b05de9693(duration), sheet.cssRules.length);
            });
            // Set a new delayed animation if loader hasn't finished after `${duration}` ms
            delayedAnimationTimer = setTimeout(()=>{
                if (!isRunning) return;
                isDelayed = true;
                $e871469dab215262$var$browserFocusCheck(()=>{
                    sheet.insertRule($e871469dab215262$export$610cb442736abf53(), sheet.cssRules.length);
                    sheet.insertRule($e871469dab215262$export$959e9e99fba397f1($e871469dab215262$export$99d4e8974a739853()), sheet.cssRules.length);
                });
            }, $e871469dab215262$export$899393f3e23f724b);
            // Remove the loader if it hasn't finished after `${TIMEOUT_TIMER}` ms
            timeoutTimer = setTimeout(()=>{
                if (!isRunning) return;
                isRunning = false;
                isDelayed = false;
                $e871469dab215262$var$browserFocusCheck(()=>{
                    sheet.insertRule($e871469dab215262$export$6beef8c645a63156(), sheet.cssRules.length);
                });
                clearTimeout(exitAnimationTimer);
                clearTimeout(delayedAnimationTimer);
                clearTimeout(timeoutTimer);
            }, $e871469dab215262$export$7868b416d8929c55);
        },
        FINISH: ()=>{
            if (!isRunning) return;
            isRunning = false;
            if (isDelayed) {
                isDelayed = false;
                clearTimeout(exitAnimationTimer);
                clearTimeout(timeoutTimer);
                clearTimeout(delayedAnimationTimer);
                $e871469dab215262$var$browserFocusCheck(()=>{
                    sheet.insertRule($e871469dab215262$export$6beef8c645a63156(), sheet.cssRules.length);
                });
                return;
            }
            $e871469dab215262$var$browserFocusCheck(()=>{
                sheet.insertRule($e871469dab215262$export$5a43e0f09174e553(), sheet.cssRules.length);
            });
            exitAnimationTimer = setTimeout(()=>{
                clearTimeout(exitAnimationTimer);
                clearTimeout(timeoutTimer);
                clearTimeout(delayedAnimationTimer);
                $e871469dab215262$var$browserFocusCheck(()=>{
                    sheet.insertRule($e871469dab215262$export$6beef8c645a63156(), sheet.cssRules.length);
                });
            }, $e871469dab215262$var$EXIT_ANIMATION_SPEED + 500);
        },
        RESET: ()=>{
            isRunning = false;
            isDelayed = false;
            clearTimeout(exitAnimationTimer);
            clearTimeout(delayedAnimationTimer);
            clearTimeout(timeoutTimer);
            $e871469dab215262$var$browserFocusCheck(()=>{
                sheet.insertRule($e871469dab215262$export$6beef8c645a63156(), sheet.cssRules.length);
            });
        }
    };
};
const $e871469dab215262$var$setupLoadingBarActionController = ()=>{
    const LOADER_STYLESHEET_ID = 'loaderStylesheet';
    // @ts-expect-error - TS2322 - Type 'HTMLElement | null' is not assignable to type 'HTMLStyleElement | null'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const styleSheet = document.getElementById(LOADER_STYLESHEET_ID);
    // SSR will not attach the stylesheet for routes not included in ALLOWED_ROUTES
    if (!styleSheet || !styleSheet.sheet) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JIRA_LOADING_BAR = $e871469dab215262$export$55d67d61d9d2ad3b(styleSheet);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JIRA_LOADING_BAR && window.JIRA_LOADING_BAR.START) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JIRA_LOADING_BAR.START();
};
$e871469dab215262$var$setupLoadingBarActionController();

});
parcelRegister("g0c9Y", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $974e6ffaf05907b7$export$c47913ca32a5c6f7);
const $974e6ffaf05907b7$export$c47913ca32a5c6f7 = (name)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const node = document.querySelector(`meta[name="${name}"]`);
    const metaValue = node && node.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
};

});


parcelRegister("78d1w", function(module, exports) {

$parcel$export(module.exports, "useSpaStateTransition", () => $7f5c686fb18f00a1$export$4d1974344641a2c9);
$parcel$export(module.exports, "default", () => $7f5c686fb18f00a1$export$2e2bcd8739ae039);

var $hgcvd = parcelRequire("hgcvd");

var $WBLbN = parcelRequire("WBLbN");

var $cfLkw = parcelRequire("cfLkw");
const $7f5c686fb18f00a1$var$getNavigationStart = ()=>{
    // @ts-expect-error - TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'. | TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    const timestamp = (0, $hgcvd.default) && (0, $hgcvd.default).timing && (0, $hgcvd.default).timing.navigationStart;
    return timestamp ? new Date(timestamp).toISOString() : undefined;
};
const $7f5c686fb18f00a1$var$getLastTransition = (currentPage, visitedPages)=>{
    if (visitedPages.length === 0) return undefined;
    const collectAppNames = (page)=>Object.keys(page.apps || {}).sort();
    const appNamesToStr = (appNames)=>appNames.join('+') || '?';
    const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
    const currPage = appNamesToStr(collectAppNames(currentPage));
    return `${prevPage} > ${currPage}`;
};
const $7f5c686fb18f00a1$var$getLastTransitionStartTime = (currentPage, visitedPages)=>{
    // If there are no previously visited pages the transition didn't have a place
    if (visitedPages.length === 0) return undefined;
    return currentPage.startTime;
};
const $7f5c686fb18f00a1$export$aea217a45095ce11 = ({ visitedPages: visitedPages, currentPage: currentPage })=>({
        isInitialRender: visitedPages.length === 0,
        transitionsCount: visitedPages.length,
        lastTransition: $7f5c686fb18f00a1$var$getLastTransition(currentPage, visitedPages),
        lastTransitionStartTime: $7f5c686fb18f00a1$var$getLastTransitionStartTime(currentPage, visitedPages),
        navigationStart: $7f5c686fb18f00a1$var$getNavigationStart(),
        currentPageId: currentPage.uuid
    });
// @ts-expect-error - TS2322 - Type 'SubscriberComponent<TransitionState, BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/controllers/spa-state/src/actions/index")>, Record<...>>' is not assignable to type 'Subscriber'.
const $7f5c686fb18f00a1$var$SpaStateTransitionStateSubscriber = (0, $WBLbN.createSubscriber)((0, $cfLkw.default), {
    displayName: 'SpaStateTransitionStateSubscriber',
    selector: $7f5c686fb18f00a1$export$aea217a45095ce11
});
const $7f5c686fb18f00a1$export$4d1974344641a2c9 = (0, $WBLbN.createHook)((0, $cfLkw.default), {
    selector: $7f5c686fb18f00a1$export$aea217a45095ce11
});
var $7f5c686fb18f00a1$export$2e2bcd8739ae039 = $7f5c686fb18f00a1$var$SpaStateTransitionStateSubscriber;

});

parcelRegister("1Xxlz", function(module, exports) {

$parcel$export(module.exports, "LOADER_STYLES_CSS_SELECTOR", () => $687b423c2ce28206$export$2a3dd4ccb7b0a764);
$parcel$export(module.exports, "LOADER_STYLESHEET_ID", () => $687b423c2ce28206$export$79456f717d4431da);
$parcel$export(module.exports, "getAllowedRoutes", () => $687b423c2ce28206$export$c82eb262b97a76f1);
$parcel$export(module.exports, "getLoadingBarColor", () => $687b423c2ce28206$export$cf3a5ed89e041425);

var $5iWql = parcelRequire("5iWql");

var $exb0h = parcelRequire("exb0h");

var $6rW04 = parcelRequire("6rW04");
const $687b423c2ce28206$var$FIRST_RELEASE_ROUTES = [
    (0, $exb0h.ROUTE_NAMES_ISSUE),
    (0, $exb0h.ROUTE_NAMES_ISSUE_EMBED),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT),
    (0, $exb0h.ROUTE_NAMES_YOUR_WORK),
    (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA),
    (0, $exb0h.ROUTE_NAMES_BOARDS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY_SECURE),
    (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE),
    (0, $exb0h.ROUTE_NAMES_PROJECT_COMPONENTS),
    (0, $exb0h.ROUTE_NAMES_PROJECT_PAGES),
    (0, $exb0h.ROUTE_NAMES_PROJECT_VERSIONS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_BACKLOG),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ROADMAP),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
    (0, $exb0h.ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT)
];
const $687b423c2ce28206$export$2a3dd4ccb7b0a764 = 'body::before';
const $687b423c2ce28206$export$79456f717d4431da = 'loaderStylesheet';
const $687b423c2ce28206$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
const $687b423c2ce28206$export$c82eb262b97a76f1 = (0, $5iWql.default)(()=>{
    const ALLOWED_ROUTES = $687b423c2ce28206$var$FIRST_RELEASE_ROUTES;
    return ALLOWED_ROUTES;
});
const $687b423c2ce28206$export$cf3a5ed89e041425 = (0, $5iWql.default)(()=>(0, $6rW04.default)('ajs-lf-navigation-highlightcolour') || $687b423c2ce28206$export$53d51cc6d57e44da);

});

parcelRegister("cQcOl", function(module, exports) {

$parcel$export(module.exports, "generateLoadingBarStyles", () => $1e0ebc570d6f522b$export$3036104bc81246b1);

var $c9TLT = parcelRequire("c9TLT");

var $1Xxlz = parcelRequire("1Xxlz");
const $1e0ebc570d6f522b$export$3036104bc81246b1 = (initalProgressValue, loadingBarColor)=>`
    content: '';
    display: block;
    background: ${loadingBarColor};
    height: 3px;
    z-index: ${(0, $c9TLT.layers).navigation + 10};
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    transform: scaleX(${initalProgressValue});
    transform-origin: 0 0;
    will-change: transform;
`;
const $1e0ebc570d6f522b$export$85e33a4b3d661500 = (initialProgressValue = 0.3)=>`
        <style id=${0, $1Xxlz.LOADER_STYLESHEET_ID}>
            ${0, $1Xxlz.LOADER_STYLES_CSS_SELECTOR} {${$1e0ebc570d6f522b$export$3036104bc81246b1(initialProgressValue, (0, $1Xxlz.getLoadingBarColor)())}}
        </style>`;

});
parcelRegister("c9TLT", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $d7c0be4143e494a4$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $d7c0be4143e494a4$export$7a57f79000377ca2);
$parcel$export(module.exports, "fontSize", () => $d7c0be4143e494a4$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fontFamily", () => $d7c0be4143e494a4$export$a5975749f0374264);
$parcel$export(module.exports, "codeFontFamily", () => $d7c0be4143e494a4$export$356129969ee49c55);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $d7c0be4143e494a4$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $d7c0be4143e494a4$export$7be255094ccdc533);
$parcel$export(module.exports, "layout", () => $d7c0be4143e494a4$export$b3219800bda33a1f);

var $lcnyw = parcelRequire("lcnyw");
const $d7c0be4143e494a4$export$6d8204c2cb2e06b8 = (0, $lcnyw.gridSize)();
const $d7c0be4143e494a4$export$7a57f79000377ca2 = (0, $lcnyw.borderRadius)();
const $d7c0be4143e494a4$export$85e3c3ca0c6fb93 = (0, $lcnyw.fontSize)();
const $d7c0be4143e494a4$export$a5975749f0374264 = (0, $lcnyw.fontFamily)();
const $d7c0be4143e494a4$export$356129969ee49c55 = (0, $lcnyw.codeFontFamily)();
const $d7c0be4143e494a4$export$22dec01f2c854397 = 40;
const $d7c0be4143e494a4$export$dab5ea164c6f81a = 100;
const $d7c0be4143e494a4$export$7be255094ccdc533 = {
    banner: (0, $lcnyw.layers).navigation(),
    card: (0, $lcnyw.layers).card(),
    dialog: (0, $lcnyw.layers).dialog(),
    navigation: (0, $lcnyw.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $lcnyw.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $lcnyw.layers).navigation() - 1,
    layer: (0, $lcnyw.layers).layer(),
    blanket: (0, $lcnyw.layers).blanket(),
    modal: (0, $lcnyw.layers).modal(),
    flag: (0, $lcnyw.layers).flag(),
    spotlight: (0, $lcnyw.layers).spotlight(),
    tooltip: (0, $lcnyw.layers).tooltip(),
    mobileBanner: $d7c0be4143e494a4$export$dab5ea164c6f81a
};
const $d7c0be4143e494a4$export$b3219800bda33a1f = {
    issueIconSize: $d7c0be4143e494a4$export$6d8204c2cb2e06b8 * 2
};

});



parcelRegister("jxIns", function(module, exports) {

$parcel$export(module.exports, "SafeHelpPanel", () => $3dbb567424a9f7a3$export$cd2ada2fb14048fc);

var $eUqFw = parcelRequire("eUqFw");

var $48bs8 = parcelRequire("48bs8");

var $0cdA8 = parcelRequire("0cdA8");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");


var $antaP = parcelRequire("antaP");

var $3xHvd = parcelRequire("3xHvd");

var $bUi2Q = parcelRequire("bUi2Q");

var $dxcfv = parcelRequire("dxcfv");
const $3dbb567424a9f7a3$var$HelpPanel = ()=>{
    const [{ navigationData: navigationData, releaseNotesNotifications: releaseNotesNotifications }, { setNavigationData: setNavigationData, setReleaseNotesNotifications: setReleaseNotesNotifications }] = (0, $1zRTT.useHelpPanel)();
    const { closeRightSidebar: closeRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    const accountId = (0, $dxcfv.useAccountId)();
    (0, $eUqFw.useEffect)(()=>{
        const restoreReleaseNotesNotifications = async ()=>{
            if (accountId) try {
                // @ts-expect-error - Property 'helpPanel' does not exist on type 'unknown'.
                const { helpPanel: userPropertiesHelpPanelValue } = await (0, $48bs8.getUserProperty)(accountId, (0, $119e8efb1068ef73$export$783d7c02e3a0cbf));
                setReleaseNotesNotifications(userPropertiesHelpPanelValue.releaseNotesNotifications);
            } catch (err) {
                /* getUserProperty throws if not found */ setReleaseNotesNotifications(0);
            }
            else setReleaseNotesNotifications(0);
        };
        restoreReleaseNotesNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $antaP.RemoteStateUpdater), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3xHvd.LazyHelpPanel), {
        isOpen: !rightSidebarCurrentState?.isCollapsed,
        navigationData: navigationData,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        releaseNotesNotificationsSetter: setReleaseNotesNotifications,
        hasBeenRendered: !rightSidebarCurrentState?.isCollapsed,
        onCloseHelpPanel: closeRightSidebar
    }));
};
const $3dbb567424a9f7a3$var$HelpPanelInLayout = ()=>{
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $eUqFw.useState)();
    const prevPanelIdRef = (0, $eUqFw.useRef)();
    const delayRef = (0, $eUqFw.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $f2Poq.HELP_PANEL_ID)) {
            /**
			 * The right-sidebar is showing the help-panel...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== HELP_PANEL_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            }, 310);
        } else /**
			 * If the right sidebar is not showing the help-panel,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $f2Poq.HELP_PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3dbb567424a9f7a3$var$HelpPanel, null);
};
const $3dbb567424a9f7a3$export$cd2ada2fb14048fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-help-panel",
        packageName: "@atlassian/jira-help-panel-right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3dbb567424a9f7a3$var$HelpPanelInLayout, null));

});
parcelRegister("f2Poq", function(module, exports) {

$parcel$export(module.exports, "HELP_PANEL_VERSION", () => $482b44340b421724$export$c43c7444da662fa1);
$parcel$export(module.exports, "HELP_PANEL_ID", () => $482b44340b421724$export$e99efa3985fa3c26);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => $482b44340b421724$export$23aa6670f346c214);

var $c9TLT = parcelRequire("c9TLT");
const $482b44340b421724$export$c43c7444da662fa1 = '1';
const $482b44340b421724$export$e99efa3985fa3c26 = 'helpPanel';
const $482b44340b421724$export$23aa6670f346c214 = (0, $c9TLT.gridSize) * 46;

});

parcelRegister("1zRTT", function(module, exports) {

$parcel$export(module.exports, "useHelpPanel", () => $6594f144c6f69b94$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $6594f144c6f69b94$export$c61f56f4797e22db);

var $WBLbN = parcelRequire("WBLbN");

var $kEkov = parcelRequire("kEkov");
const $6594f144c6f69b94$export$3fe94d66377a53b8 = (0, $WBLbN.createHook)((0, $kEkov.default));
const $6594f144c6f69b94$export$c61f56f4797e22db = (0, $WBLbN.createHook)((0, $kEkov.default), {
    selector: null
});
const $6594f144c6f69b94$export$513717a84f55db1a = (0, $WBLbN.createSubscriber)((0, $kEkov.default), {
    displayName: 'HelpPanelSubscriber'
});
const $6594f144c6f69b94$export$5f4de38bd79f4446 = (0, $WBLbN.createSubscriber)((0, $kEkov.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("kEkov", function(module, exports) {

$parcel$export(module.exports, "default", () => $4af29a8a37667189$export$2e2bcd8739ae039);

var $89bO2 = parcelRequire("89bO2");

var $WBLbN = parcelRequire("WBLbN");

var $47e0j = parcelRequire("47e0j");
const $4af29a8a37667189$var$iphStorage = (0, $89bO2.createSessionStorageProvider)('iph');
const $4af29a8a37667189$var$initialState = {
    navigationData: {
        // @ts-expect-error - TS2322 - Type '"HELP_ARTICLE"' is not assignable to type 'ARTICLE_TYPE'.
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        history: $4af29a8a37667189$var$iphStorage.get('history') || []
    },
    releaseNotesNotifications: 100
};
var $4af29a8a37667189$export$2e2bcd8739ae039 = (0, $WBLbN.createStore)({
    name: 'help-panel',
    initialState: $4af29a8a37667189$var$initialState,
    actions: $47e0j
});

});
parcelRegister("89bO2", function(module, exports) {

$parcel$export(module.exports, "createSessionStorageProvider", () => $eaaf8012779da3f6$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $eaaf8012779da3f6$export$e0a2e9a062c6a695);

var $jqvCZ = parcelRequire("jqvCZ");

var $avHyR = parcelRequire("avHyR");

var $8zsxt = parcelRequire("8zsxt");
const $eaaf8012779da3f6$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>(0, $avHyR.createStorageProvider)(appPrefix, (0, $8zsxt.makeSessionStore)()));
const $eaaf8012779da3f6$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const store = (0, $8zsxt.makeSessionExpirableStore)();
    return store.namespace(appPrefix);
});

});
parcelRegister("8zsxt", function(module, exports) {

$parcel$export(module.exports, "makeSessionStore", () => $dffa4c0ba19d0eb7$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $dffa4c0ba19d0eb7$export$a8f626c8ded9a06c);

var $2y3XF = parcelRequire("2y3XF");

var $gleLd = parcelRequire("gleLd");

var $ZGlKn = parcelRequire("ZGlKn");

var $gpWeB = parcelRequire("gpWeB");

var $lyUHD = parcelRequire("lyUHD");

var $avHyR = parcelRequire("avHyR");
const $dffa4c0ba19d0eb7$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($lyUHD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], (0, $avHyR.plugins));
const $dffa4c0ba19d0eb7$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($lyUHD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gleLd)))
    ]);

});


parcelRegister("47e0j", function(module, exports) {

$parcel$export(module.exports, "setNavigationData", () => $a35d570ea28382ca$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $a35d570ea28382ca$export$cdabe01d01a8da1e);

var $89bO2 = parcelRequire("89bO2");
const $a35d570ea28382ca$var$iphStorage = (0, $89bO2.createSessionStorageProvider)('iph');
const $a35d570ea28382ca$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $a35d570ea28382ca$var$iphStorage.set('history', []);
    };
const $a35d570ea28382ca$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});



const $119e8efb1068ef73$export$783d7c02e3a0cbf = 'help_panel_ui_state';

parcelRegister("antaP", function(module, exports) {

$parcel$export(module.exports, "RemoteStateUpdater", () => $5b20896496afe0c7$export$3db011870dd4330f);

var $eUqFw = parcelRequire("eUqFw");

var $cNGJr = parcelRequire("cNGJr");

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $dxcfv = parcelRequire("dxcfv");

var $1zRTT = parcelRequire("1zRTT");

const $5b20896496afe0c7$var$DEBOUNCE_TIME = 1000;
const $5b20896496afe0c7$export$3db011870dd4330f = ()=>{
    // right-sidebar
    const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, $1zRTT.useHelpPanel)();
    const [releaseNotesNotificationsTemp, setReleaseNotesNotificationsTemp] = (0, $eUqFw.useState)(releaseNotesNotifications);
    const accountId = (0, $dxcfv.useAccountId)();
    const [debouncedUpdateData] = (0, $cNGJr.default)(async (newReleaseNotesNotifications)=>{
        const remoteData = {
            helpPanel: {
                releaseNotesNotifications: newReleaseNotesNotifications
            }
        };
        if (accountId) try {
            await (0, $48bs8.setUserProperties)(accountId, (0, $119e8efb1068ef73$export$783d7c02e3a0cbf), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $guiFP.default)({
                error: e,
                meta: {
                    id: 'updateServerHelpPanelState',
                    packageName: 'jiraHelpPanelServices',
                    teamName: 'self-help-experiences'
                }
            });
        }
    }, $5b20896496afe0c7$var$DEBOUNCE_TIME);
    (0, $eUqFw.useEffect)(()=>{
        if (releaseNotesNotificationsTemp !== releaseNotesNotifications) {
            setReleaseNotesNotificationsTemp(releaseNotesNotifications);
            debouncedUpdateData(releaseNotesNotifications);
        }
    }, [
        debouncedUpdateData,
        releaseNotesNotifications,
        releaseNotesNotificationsTemp
    ]);
    return null;
};

});
parcelRegister("cNGJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $951b3551010b091a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $951b3551010b091a$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $eUqFw.useRef)(null);
    var maxWaitArgs = (0, $eUqFw.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $eUqFw.useRef)(false);
    var functionTimeoutHandler = (0, $eUqFw.useRef)(null);
    var isComponentUnmounted = (0, $eUqFw.useRef)(false);
    var debouncedFunction = (0, $eUqFw.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $eUqFw.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $eUqFw.useEffect)(function() {
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $eUqFw.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $eUqFw.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});


parcelRegister("3xHvd", function(module, exports) {

$parcel$export(module.exports, "LazyHelpPanel", () => $a88134428dafae47$export$51c79455aef7d178);

var $eUqFw = parcelRequire("eUqFw");

var $dV4Wy = parcelRequire("dV4Wy");

var $5GxEP = parcelRequire("5GxEP");

var $aR8n6 = parcelRequire("aR8n6");

var $79xbN = parcelRequire("79xbN");

var $gGtKh = parcelRequire("gGtKh");

var $cWiVr = parcelRequire("cWiVr");

var $8WuJm = parcelRequire("8WuJm");

var $enMj3 = parcelRequire("enMj3");

var $rqehi = parcelRequire("rqehi");

var $bZhE6 = parcelRequire("bZhE6");
const $a88134428dafae47$export$51c79455aef7d178 = ({ navigationData: { articleId: articleId, history: history }, setNavigationData: setNavigationData, releaseNotesNotifications: releaseNotesNotifications, releaseNotesNotificationsSetter: releaseNotesNotificationsSetter, isOpen: isOpen, onCloseHelpPanel: onCloseHelpPanel, hasBeenRendered: hasBeenRendered, routeGroup: routeGroup, routeName: routeName })=>{
    const user = (0, $cWiVr.useCurrentUser)();
    const IPH_USE_HELP_AGGREGATOR_FLAG = (0, $79xbN.expVal)('20240422_self_help_iph_ms3_expt', 'iph_ms3_experience_display_flag', false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "help-panel",
        packageName: "jiraHelpPanel",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $enMj3.default), {
                loadingArticle: articleId.id !== ''
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "root",
        packageName: "jiraHelpPanel",
        teamName: "self-help-experiences"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $rqehi.SearchContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        tags: [
            'iph'
        ],
        sourceName: "jiraHelpPanel",
        sourceType: (0, $41ea3621645e2acc$export$9d2de6eebf7462b5),
        attributes: {
            searchService: IPH_USE_HELP_AGGREGATOR_FLAG ? 'help-aggregator' : 'algolia',
            routeGroup: routeGroup,
            routeName: routeName,
            userId: user?.data?.user?.accountId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dV4Wy.LazyWait), {
        until: hasBeenRendered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-lazy-help-panel",
        fallback: isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $enMj3.default), {
            loadingArticle: articleId.id !== ''
        }) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bZhE6.AsyncLazyHelpPanel), {
        navigationData: {
            articleId: articleId,
            history: history
        },
        releaseNotesNotificationsSetter: releaseNotesNotificationsSetter,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        isOpen: isOpen,
        onCloseHelpPanel: onCloseHelpPanel,
        routeGroup: routeGroup,
        routeName: routeName
    })))))));
};

});
parcelRegister("cWiVr", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $59f9598ada60a2a8$export$3901076af3749fa9);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");

var $lGLse = parcelRequire("lGLse");
const $59f9598ada60a2a8$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return (0, $eUqFw.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $ao0hp.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $59f9598ada60a2a8$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $59f9598ada60a2a8$var$useCurrentUserBasic();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $lGLse.useUserSubscriber)();
    (0, $eUqFw.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $59f9598ada60a2a8$export$3901076af3749fa9 = ()=>(0, $gd0Sp.useTenantContext)().isAnonymous ? $59f9598ada60a2a8$var$useCurrentUserBasic() : $59f9598ada60a2a8$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $59f9598ada60a2a8$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $59f9598ada60a2a8$export$3901076af3749fa9();
    return children(result);
};

});
parcelRegister("lGLse", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $033cdb69b2583281$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $033cdb69b2583281$export$4e61bbf568682a96);

var $WBLbN = parcelRequire("WBLbN");

var $kdNL5 = parcelRequire("kdNL5");
const $033cdb69b2583281$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $033cdb69b2583281$var$Store = (0, $WBLbN.createStore)({
    name: 'user',
    initialState: $033cdb69b2583281$var$initialState,
    actions: $kdNL5
});
const $033cdb69b2583281$export$7ff085589970ee0a = (0, $WBLbN.createContainer)($033cdb69b2583281$var$Store);
const $033cdb69b2583281$export$4e61bbf568682a96 = (0, $WBLbN.createHook)($033cdb69b2583281$var$Store);

});
parcelRegister("kdNL5", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $dd4efebc20057365$export$e7aa7bc5c1b3cfb3);

var $1TLNE = parcelRequire("1TLNE");
const $dd4efebc20057365$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $1TLNE.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("1TLNE", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $7f578fc13a1a3e40$export$8134c072fddab6a5);

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");
const $7f578fc13a1a3e40$export$8134c072fddab6a5 = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $53ciZ.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $lRmyA.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};

});




parcelRegister("enMj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dc15b871bc1035e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $8BCWs = parcelRequire("8BCWs");
const $9dc15b871bc1035e$var$HelpPanelLoading = ({ loadingArticle: loadingArticle = false })=>loadingArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BCWs.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "img",
        "aria-label": "help panel loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-250, 20px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "90%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "70%"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BCWs.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-500, 40px)",
        marginTop: "var(--ds-space-100, 8px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadignArticleList, {
        role: "img"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })))));
var $9dc15b871bc1035e$export$2e2bcd8739ae039 = $9dc15b871bc1035e$var$HelpPanelLoading;
/**
 * Header
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9dc15b871bc1035e$var$LoadingContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $9dc15b871bc1035e$var$HeaderLoading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ixncg _bfhk10nm _n7zlxs90 _1bah1yb4 _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $9dc15b871bc1035e$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9dc15b871bc1035e$var$LoadingRectangle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { contentHeight: contentHeight, marginTop: marginTop, contentWidth: contentWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_l7mdyr": (0, $9t7rW.default)(__cmplp.contentHeight),
            "--_1fj4wta": (0, $9t7rW.default)(__cmplp.marginTop),
            "--_7n1eiw": (0, $9t7rW.default)(__cmplp.contentWidth)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _2rkov77o _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk134c _1itk15g1 _12vemgnk",
            __cmplp.contentHeight != null ? "_4t3i6c59" : "_4t3ipxbi",
            __cmplp.marginTop != null ? "_19pkmye1" : "_19pku2gc",
            __cmplp.contentWidth != null ? "_1bsbwd3v" : "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $9dc15b871bc1035e$var$LoadignArticleList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _18s8v0yc _1yt4ze3t _vchhusvi",
            __cmplp.className
        ])
    });
});
const $9dc15b871bc1035e$var$LoadignArticleListItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1bsb1osq _1yt4u2gc _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8BCWs", function(module, exports) {

$parcel$export(module.exports, "HelpPanelContainer", () => $03325f336784369d$export$37cd645d7678f7d4);
$parcel$export(module.exports, "HelpPanelContainerV2", () => $03325f336784369d$export$1df7e3ebfc4c9b06);
$parcel$export(module.exports, "HelpPanelSectionMessageContainer", () => $03325f336784369d$export$9f6251c714594f23);
$parcel$export(module.exports, "HelpPanelContentContainer", () => $03325f336784369d$export$1cdb922eed7271d1);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $03325f336784369d$export$37cd645d7678f7d4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _16jlkb7n _1o9zkb7n _i0dlf1ug _1kl71osx _1reo15vq _18m915vq _2lx21bp4 _1bsb1feq _4t3i1osq _kqsw1n9t",
            __cmplp.className
        ])
    });
});
const $03325f336784369d$export$1df7e3ebfc4c9b06 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $03325f336784369d$export$37cd645d7678f7d4, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1i8v _11q71bhr",
            __cmplp.className
        ])
    });
});
const $03325f336784369d$export$9f6251c714594f23 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1yt41rfa _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $03325f336784369d$export$1cdb922eed7271d1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1tkeidpf _kqswh2mm _18m91wug _1reo15vq _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ae4v1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});


parcelRegister("rqehi", function(module, exports) {

$parcel$export(module.exports, "useSearchContext", () => $0775421d423c6e01$export$67b98b1b880a048b);
$parcel$export(module.exports, "SearchContextProvider", () => $0775421d423c6e01$export$6bd70292443463a4);

var $eUqFw = parcelRequire("eUqFw");

var $b8VQt = parcelRequire("b8VQt");
const [$0775421d423c6e01$export$67b98b1b880a048b, $0775421d423c6e01$export$70af50e847ce290a] = (0, $b8VQt.createCtx)();
const $0775421d423c6e01$export$6bd70292443463a4 = ({ children: children })=>{
    const [searchContext, setSearchContext] = (0, $eUqFw.useState)({});
    const addClickedArticleIds = (0, $eUqFw.useCallback)((query, clickedArticleId)=>{
        setSearchContext((prev)=>({
                ...prev,
                [query]: {
                    ...prev[query],
                    clickedArticleIds: prev[query]?.clickedArticleIds ? [
                        ...prev[query].clickedArticleIds,
                        clickedArticleId
                    ] : [
                        clickedArticleId
                    ]
                }
            }));
    }, []);
    const addFetchedArticleIds = (0, $eUqFw.useCallback)((query, fetchedArticles)=>{
        setSearchContext((prev)=>({
                ...prev,
                [query]: {
                    ...prev[query],
                    fetchedArticleIds: fetchedArticles
                }
            }));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0775421d423c6e01$export$70af50e847ce290a, {
        value: {
            searchContext: searchContext,
            addClickedArticleIds: addClickedArticleIds,
            addFetchedArticleIds: addFetchedArticleIds
        }
    }, children);
};

});
parcelRegister("b8VQt", function(module, exports) {

$parcel$export(module.exports, "createCtx", () => $911944d6c4e559cb$export$d653a1a643c9a98c);

var $eUqFw = parcelRequire("eUqFw");
function $911944d6c4e559cb$export$d653a1a643c9a98c() {
    const ctx = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
    function useCtx() {
        const c = (0, $eUqFw.useContext)(ctx);
        if (!c) throw new Error('useCtx must be inside a Provider with a value');
        return c;
    }
    return [
        useCtx,
        ctx.Provider
    ];
}

});


parcelRegister("bZhE6", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyHelpPanel", () => $8726324405ab1f9c$export$7ff46d33d0f13518);

var $6VZoe = parcelRequire("6VZoe");

const $8726324405ab1f9c$export$7ff46d33d0f13518 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("4ZQWs")).then(({ HelpPanel: HelpPanel })=>HelpPanel), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel/src/ui/index.tsx"
});

});
parcelRegister("4ZQWs", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("8Av70")
]).then(()=>parcelRequire('lwEqL'));

});




parcelRegister("eGjiP", function(module, exports) {

$parcel$export(module.exports, "SafeEmbeddedConfluencePanel", () => $3730299ad39def57$export$2d901a489872dd0d);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $cGCxH = parcelRequire("cGCxH");

var $fYx5D = parcelRequire("fYx5D");

var $0cdA8 = parcelRequire("0cdA8");

var $bUi2Q = parcelRequire("bUi2Q");

var $ih3cb = parcelRequire("ih3cb");
const $3730299ad39def57$var$DELAY = 310;
const $3730299ad39def57$export$2db0a2e0275af8b8 = ()=>{
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    const [{ panel: isOpen }] = (0, $fYx5D.useEmbeddedConfluenceSidePanel)();
    const [localPanelId, setLocalPanelId] = (0, $eUqFw.useState)();
    const prevPanelIdRef = (0, $eUqFw.useRef)();
    const delayRef = (0, $eUqFw.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    const { entryPointActions: entryPointActions, entryPoint: entryPoint } = (0, $ih3cb.useEmbeddedPanelEntryPoint)();
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen) entryPointActions?.load();
    }, [
        isOpen,
        entryPointActions,
        localPanelId
    ]);
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $cGCxH.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) {
            /**
			 * The right-sidebar is showing the embedded confluence content...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            // TODO: trigger close analytics event
            }, $3730299ad39def57$var$DELAY);
        } else /**
			 * If the right sidebar is not showing the embedded confluence content,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $cGCxH.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3730299ad39def57$var$panelStyles
    }, entryPoint);
};
const $3730299ad39def57$export$2d901a489872dd0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-embedded-confluence-panel",
        packageName: "jiraIssueCreateConfluenceContent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fYx5D.EmbeddedConfluenceSidepanelContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3730299ad39def57$export$2db0a2e0275af8b8, null)));
const $3730299ad39def57$var$panelStyles = (0, $1ZAYh.xcss)({
    padding: 'space.100',
    height: 'calc(100vh - (var(--topNavigationHeight, 0px) + var(--bannerHeight, 0px)))'
});

});
parcelRegister("cGCxH", function(module, exports) {

$parcel$export(module.exports, "ConfluenceFeatureKeys", () => $8c4704bc755a9560$export$746d4746bf07dd70);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_KEY", () => $8c4704bc755a9560$export$6247c7e19b71f4e);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_KEY", () => $8c4704bc755a9560$export$e34c4c923d934e7a);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY", () => $8c4704bc755a9560$export$ffe60197eb59ca73);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY", () => $8c4704bc755a9560$export$8d0c4a26241944b8);
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID", () => $8c4704bc755a9560$export$a497288e64e9a343);
const $8c4704bc755a9560$export$746d4746bf07dd70 = {
    ENABLE_CONFLUENCE_SIGNUP: 'jira.admin.confluence.enable-integrations',
    SPRINT_RETRO: 'jira.admin.confluence.enable-sprint-retros',
    CREATE_MENU_TOP_ACTIONS: 'jira.admin.confluence.enable-content-creation-issue-top-actions',
    CREATE_MENU_CONFLUENCE_CONTENT: 'jira.admin.confluence.enable-content-creation-issue-confluence-content'
};
const $8c4704bc755a9560$export$6247c7e19b71f4e = 'confluence-integration-controls';
const $8c4704bc755a9560$export$e34c4c923d934e7a = 'user-confluence-access';
const $8c4704bc755a9560$export$ffe60197eb59ca73 = 'confluence-integration-controls-session-storage';
const $8c4704bc755a9560$export$8d0c4a26241944b8 = 'confluence-permissions-session-storage';
const $8c4704bc755a9560$export$a497288e64e9a343 = 'embedded-confluence-panel-container';

});

parcelRegister("fYx5D", function(module, exports) {

$parcel$export(module.exports, "EmbeddedConfluenceSidepanelContainer", () => $57bfebfe29c272f2$export$a5c1c168018f0f16);
$parcel$export(module.exports, "useEmbeddedConfluenceSidePanel", () => $57bfebfe29c272f2$export$518aeea31a00450e);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $hJ992 = parcelRequire("hJ992");

var $bUi2Q = parcelRequire("bUi2Q");

var $WBLbN = parcelRequire("WBLbN");

var $cGCxH = parcelRequire("cGCxH");

var $kesKZ = parcelRequire("kesKZ");

var $9pYcd = parcelRequire("9pYcd");

var $02qo9 = parcelRequire("02qo9");
/**
 * Container for {@link useEmbeddedConfluenceSidePanel}. Any component that uses this hook
 * must be wrapped in this container.
 */ const $57bfebfe29c272f2$var$Container = (0, $WBLbN.createContainer)();
const $57bfebfe29c272f2$var$DefaultStore = (0, $WBLbN.createStore)({
    actions: $kesKZ.actions,
    containedBy: $57bfebfe29c272f2$var$Container,
    initialState: $kesKZ.initialState,
    name: (0, $cGCxH.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
});
const $57bfebfe29c272f2$var$NonContainerStore = (0, $WBLbN.createStore)({
    actions: $kesKZ.actions,
    initialState: $kesKZ.initialState,
    name: (0, $cGCxH.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
});
const $57bfebfe29c272f2$export$a5c1c168018f0f16 = ({ children: children })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    /*
	In order for each usage of the store to manage the same state irregardless of
	their location in the component tree, we need to wrap components in a container
	with the same scope value. This is why we use the issueKey in the scope value.
	see https://atlassian.github.io/react-sweet-state/#/advanced/container?id=scoped-data-sharing
	for more information about scoped data sharing.

	*/ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57bfebfe29c272f2$var$Container, {
        scope: `embedded-confluence-sidepanel-${issueKey}`
    }, children);
};
const $57bfebfe29c272f2$var$defaultStoreHook = (0, $WBLbN.createHook)($57bfebfe29c272f2$var$DefaultStore);
const $57bfebfe29c272f2$var$nonContainerStoreHook = (0, $WBLbN.createHook)($57bfebfe29c272f2$var$NonContainerStore);
const $57bfebfe29c272f2$export$518aeea31a00450e = (embeddedConfluenceSource)=>{
    /*
		The condition below is a temporary workaround for the Side Panel experiment to avoid
		throwing an error when the Store is not contained by a container. This logic should be removed
		once the experiment has been productionized: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/jira_issue_view_side_by_side_modeless_ep
	*/ const [embedConfluenceSidepanelConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
    const isInExperiment = embedConfluenceSidepanelConfig.get('cohort', 'not-enrolled') === 'experiment';
    const [state, { setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection, setDeferredSpaceName: setDeferredSpaceName, openSidePanel: openSidePanelAction, closeSidePanel: closeSidePanelAction }] = isInExperiment ? $57bfebfe29c272f2$var$defaultStoreHook() : $57bfebfe29c272f2$var$nonContainerStoreHook();
    const { closeRightSidebar: closeRightSidebar, openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const openSidePanel = (0, $eUqFw.useCallback)(({ contentId: contentId, contentType: contentType, data: data, hostname: hostname, isDraft: isDraft, isLive: isLive, onLinkPage: onLinkPage, onPublish: onPublish, openInModal: openInModal, mode: mode, url: url, title: title })=>{
        const { initialWidth: initialWidth, displayType: displayType } = (0, $02qo9.getDisplayInformation)();
        const shouldOpenPanel = displayType === (0, $9pYcd.DisplayTypes).PANEL;
        if (shouldOpenPanel) {
            openSidePanelAction({
                contentId: contentId,
                contentType: contentType,
                embeddedConfluenceSource: embeddedConfluenceSource,
                data: data,
                displayType: displayType,
                initialWidth: initialWidth,
                hostname: hostname,
                isDraft: isDraft,
                isLive: isLive,
                mode: mode,
                onLinkPage: onLinkPage,
                onPublish: onPublish,
                shouldOpenModal: !shouldOpenPanel,
                url: url,
                title: title
            });
            openRightSidebar((0, $cGCxH.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID), initialWidth, false, true);
        } else openInModal();
    }, [
        embeddedConfluenceSource,
        openRightSidebar,
        openSidePanelAction
    ]);
    const closeSidePanel = (0, $eUqFw.useCallback)(()=>{
        closeRightSidebar((0, $cGCxH.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID));
        closeSidePanelAction();
    }, [
        closeRightSidebar,
        closeSidePanelAction
    ]);
    return [
        state,
        {
            openSidePanel: openSidePanel,
            closeSidePanel: closeSidePanel,
            setDeferredSpaceName: setDeferredSpaceName,
            setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection
        }
    ];
};

});
parcelRegister("hJ992", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $7e3614f655e5103c$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $7e3614f655e5103c$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $7e3614f655e5103c$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $7e3614f655e5103c$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $7e3614f655e5103c$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $7e3614f655e5103c$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $7e3614f655e5103c$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $7e3614f655e5103c$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $7e3614f655e5103c$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $7e3614f655e5103c$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $7e3614f655e5103c$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $7e3614f655e5103c$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $7e3614f655e5103c$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $7e3614f655e5103c$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $7e3614f655e5103c$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $7e3614f655e5103c$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $7e3614f655e5103c$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $7e3614f655e5103c$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $7e3614f655e5103c$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $7e3614f655e5103c$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiOptInEnabled", () => $7e3614f655e5103c$export$b131d9f6da853161);
$parcel$export(module.exports, "useIsJiraIssue", () => $7e3614f655e5103c$export$cf5fc815f761fb4b);

var $eUqFw = parcelRequire("eUqFw");


var $7ZZxN = parcelRequire("7ZZxN");

var $e91YZ = parcelRequire("e91YZ");

var $guDlK = parcelRequire("guDlK");

var $6vrw7 = parcelRequire("6vrw7");

var $7HKaW = parcelRequire("7HKaW");

var $jBTMs = parcelRequire("jBTMs");

var $j3FUN = parcelRequire("j3FUN");

var $hWdjG = parcelRequire("hWdjG");
const $7e3614f655e5103c$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $hWdjG.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $7e3614f655e5103c$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $hWdjG.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $7e3614f655e5103c$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $7e3614f655e5103c$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $7e3614f655e5103c$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $hWdjG.useIssueContextStoreIsModal)();
    return isModal;
};
const $7e3614f655e5103c$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $7e3614f655e5103c$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $hWdjG.useIssueContextStoreIssueId)();
    return issueId;
};
const $7e3614f655e5103c$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $hWdjG.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $7e3614f655e5103c$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $hWdjG.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $7e3614f655e5103c$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return (0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
};
const $7e3614f655e5103c$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $hWdjG.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $7e3614f655e5103c$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $hWdjG.useIssueContextStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $7e3614f655e5103c$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $hWdjG.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $7e3614f655e5103c$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $hWdjG.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $7e3614f655e5103c$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $hWdjG.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $7e3614f655e5103c$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $hWdjG.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $7e3614f655e5103c$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $hWdjG.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $7e3614f655e5103c$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $hWdjG.useIssueContextStoreViewMode)();
    return viewMode;
};
const $7e3614f655e5103c$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $hWdjG.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $7e3614f655e5103c$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $hWdjG.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $7e3614f655e5103c$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $hWdjG.useIssueContextStoreBoardId)();
    return boardId;
};
const $7e3614f655e5103c$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $hWdjG.useIssueContextStoreBoardType)();
    return boardType;
};
const $7e3614f655e5103c$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $hWdjG.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $7e3614f655e5103c$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $hWdjG.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $7e3614f655e5103c$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $hWdjG.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $7e3614f655e5103c$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $hWdjG.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $7e3614f655e5103c$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $hWdjG.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const licenseStates = (0, $jBTMs.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $7HKaW.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $7e3614f655e5103c$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$b19f949fb9713614);
};
const $7e3614f655e5103c$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$a5132300c5214280);
};
const $7e3614f655e5103c$export$b131d9f6da853161 = ()=>{
    const [isAiOptInEnabled] = (0, $hWdjG.useIssueContextIsAiOptInEnabled)();
    return isAiOptInEnabled;
};
const $7e3614f655e5103c$export$cf5fc815f761fb4b = ()=>{
    const issueKey = $7e3614f655e5103c$export$22108eca27445997();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    return [
        (0, $7ZZxN.SOFTWARE_PROJECT),
        (0, $7ZZxN.CORE_PROJECT)
    ].some((type)=>type === projectType);
};

});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$5e91e17726e54450 = 'jiraCalendar';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("guDlK", function(module, exports) {

$parcel$export(module.exports, "useProjectKey", () => $598d4d607d97d3ec$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $598d4d607d97d3ec$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $598d4d607d97d3ec$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectContext", () => $598d4d607d97d3ec$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $598d4d607d97d3ec$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $598d4d607d97d3ec$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $598d4d607d97d3ec$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $598d4d607d97d3ec$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $598d4d607d97d3ec$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $598d4d607d97d3ec$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $598d4d607d97d3ec$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $598d4d607d97d3ec$export$80bef597b440cf71);

var $eUqFw = parcelRequire("eUqFw");

var $eIp1n = parcelRequire("eIp1n");

var $6WXNs = parcelRequire("6WXNs");

var $6vrw7 = parcelRequire("6vrw7");

var $gd0Sp = parcelRequire("gd0Sp");

var $lbuGg = parcelRequire("lbuGg");

var $9ZB9O = parcelRequire("9ZB9O");
const $598d4d607d97d3ec$export$f87be37f8e8be65 = (issueKey)=>(0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
const $598d4d607d97d3ec$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $lbuGg.useProjectContextActionStore)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $598d4d607d97d3ec$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $lbuGg.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $598d4d607d97d3ec$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $598d4d607d97d3ec$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $598d4d607d97d3ec$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $eIp1n.getApplicationForProject)(projectType);
};
const $598d4d607d97d3ec$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const application = $598d4d607d97d3ec$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $6WXNs.getEdition)(application, appEditions);
};
const $598d4d607d97d3ec$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $598d4d607d97d3ec$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $598d4d607d97d3ec$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $598d4d607d97d3ec$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $598d4d607d97d3ec$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $598d4d607d97d3ec$export$6de29d851c914935(projectKey);
    const isSimplified = $598d4d607d97d3ec$export$524ef4f6102ed540(projectKey);
    return (0, $9ZB9O.getIssueConfiguration)({
        isSimplified: isSimplified,
        projectType: projectType
    });
};
const $598d4d607d97d3ec$export$654dd2c557853fbe = (projectKey)=>{
    const [projectName] = (0, $lbuGg.useProjectContextProjectNameStore)({
        projectKey: projectKey
    });
    return projectName;
};
const $598d4d607d97d3ec$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $lbuGg.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("lbuGg", function(module, exports) {

$parcel$export(module.exports, "useProjectContextActionStore", () => $4715ac6bc4ce2fb7$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $4715ac6bc4ce2fb7$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $4715ac6bc4ce2fb7$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextProjectNameStore", () => $4715ac6bc4ce2fb7$export$9469fde70658518);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $4715ac6bc4ce2fb7$export$f73e9904779f6be5);

var $WBLbN = parcelRequire("WBLbN");

var $bAXOf = parcelRequire("bAXOf");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4715ac6bc4ce2fb7$var$initialState = {};
const $4715ac6bc4ce2fb7$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'project-context',
    initialState: $4715ac6bc4ce2fb7$var$initialState,
    actions: $bAXOf
});
const $4715ac6bc4ce2fb7$export$9afb89c1fe103bbe = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: null
});
const $4715ac6bc4ce2fb7$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $4715ac6bc4ce2fb7$export$8b09478b33186ec = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectContext
});
const $4715ac6bc4ce2fb7$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $4715ac6bc4ce2fb7$export$f2e1ed3b2b4707cb = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectType
});
const $4715ac6bc4ce2fb7$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $4715ac6bc4ce2fb7$export$9469fde70658518 = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectName
});
const $4715ac6bc4ce2fb7$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $4715ac6bc4ce2fb7$export$f73e9904779f6be5 = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getIssueTypes
});

});
parcelRegister("bAXOf", function(module, exports) {

$parcel$export(module.exports, "setProjectContext", () => $f8fc64b164fe014a$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $f8fc64b164fe014a$export$78f1c6052937615f);
const $f8fc64b164fe014a$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $f8fc64b164fe014a$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("9ZB9O", function(module, exports) {

$parcel$export(module.exports, "getIssueConfiguration", () => $78bf57e6f575c3aa$export$902f6c5cc939598a);

var $2wUFy = parcelRequire("2wUFy");

var $7ZZxN = parcelRequire("7ZZxN");
const $78bf57e6f575c3aa$export$cdbd1eb3b05729e0 = 'flagActions';
const $78bf57e6f575c3aa$export$c161a774ec2e7e56 = 'cardCoverActions';
const $78bf57e6f575c3aa$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $78bf57e6f575c3aa$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $2wUFy.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $2wUFy.default).SOFTWARE_ISSUE,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $2wUFy.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0,
            $78bf57e6f575c3aa$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $2wUFy.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $2wUFy.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $78bf57e6f575c3aa$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $2wUFy.default).MOBILE_ISSUE,
        issueActions: []
    });
const $78bf57e6f575c3aa$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $2wUFy.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (config.isSimplified) return $78bf57e6f575c3aa$export$aebf676dfa727a1c();
            return $78bf57e6f575c3aa$export$27e0678365e5dcff();
        case 0, $7ZZxN.CORE_PROJECT:
            return $78bf57e6f575c3aa$export$381ce08838c53afa();
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return $78bf57e6f575c3aa$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $78bf57e6f575c3aa$export$27e0678365e5dcff();
    }
    return $78bf57e6f575c3aa$export$27e0678365e5dcff();
};

});
parcelRegister("2wUFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $78d48529cb7f139c$export$2e2bcd8739ae039);
const $78d48529cb7f139c$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $78d48529cb7f139c$export$2e2bcd8739ae039 = $78d48529cb7f139c$var$keys;

});



parcelRegister("jBTMs", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $0a5df676eadd90b5$export$268651a63abe408a);

var $gd0Sp = parcelRequire("gd0Sp");
const $0a5df676eadd90b5$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("j3FUN", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $02df0e5ac33ae573$export$54d534cc91e54850);

var $gd0Sp = parcelRequire("gd0Sp");
const $02df0e5ac33ae573$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("hWdjG", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $c495211a89197754$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $c495211a89197754$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $c495211a89197754$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $c495211a89197754$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $c495211a89197754$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $c495211a89197754$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $c495211a89197754$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $c495211a89197754$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $c495211a89197754$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $c495211a89197754$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $c495211a89197754$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $c495211a89197754$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $c495211a89197754$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $c495211a89197754$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $c495211a89197754$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $c495211a89197754$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $c495211a89197754$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $c495211a89197754$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $c495211a89197754$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $c495211a89197754$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $c495211a89197754$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $c495211a89197754$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $c495211a89197754$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", () => $c495211a89197754$export$7e70ee570119a0a7);
$parcel$export(module.exports, "IssueContextContainer", () => $c495211a89197754$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $c495211a89197754$export$965360ae27fcae98);

var $6vrw7 = parcelRequire("6vrw7");

var $WBLbN = parcelRequire("WBLbN");

var $8d785 = parcelRequire("8d785");

var $hHM8F = parcelRequire("hHM8F");

var $fhgeS = parcelRequire("fhgeS");
const $c495211a89197754$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $6vrw7.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $fhgeS.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false
};
const $c495211a89197754$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'issue-context',
    initialState: $c495211a89197754$export$d4c72bab9d6cc13a,
    actions: $8d785.actions
});
const $c495211a89197754$var$getIssueContext = (state)=>state;
const $c495211a89197754$var$getIsModal = (state)=>state.isModal;
const $c495211a89197754$var$getIssueKey = (state)=>state.issueKey;
const $c495211a89197754$var$getIsArchived = (state)=>state.isArchived;
const $c495211a89197754$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $c495211a89197754$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $c495211a89197754$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $c495211a89197754$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $c495211a89197754$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $c495211a89197754$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $c495211a89197754$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $c495211a89197754$var$getIsLoading = (state)=>state.isLoading;
const $c495211a89197754$var$getViewMode = (state)=>state.viewMode;
const $c495211a89197754$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $c495211a89197754$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $c495211a89197754$var$getBoardId = (state)=>state.boardId;
const $c495211a89197754$var$getBoardType = (state)=>state.boardType;
const $c495211a89197754$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $c495211a89197754$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $c495211a89197754$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $c495211a89197754$var$getRapidViewId = (state)=>state.rapidViewId;
const $c495211a89197754$var$getViewScreenId = (state)=>state.viewScreenId;
const $c495211a89197754$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $c495211a89197754$export$f6e0a3ee03299fbc = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueContext
});
const $c495211a89197754$export$abdbea56d86b4aac = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesLimit)
});
const $c495211a89197754$export$326ff2b963d51c5c = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesIssueLimitUrls)
});
const $c495211a89197754$export$44bcaaabb74e402b = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueKey
});
const $c495211a89197754$export$332dcee0cf9f4e45 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueId
});
const $c495211a89197754$export$c940355b1fc6e1c4 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsArchived
});
const $c495211a89197754$export$b9eebaa1da421997 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsClassifyEditEnabled
});
const $c495211a89197754$export$daa47fd600e43a32 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsModal
});
const $c495211a89197754$export$ba2e9546ab5ba6f = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewScreenId
});
const $c495211a89197754$export$74d38d6c437efc1b = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getAnalyticsSource
});
const $c495211a89197754$export$2092528ee170d9e7 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewMap
});
const $c495211a89197754$export$57898374e6239a5a = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getMaxTokenLength
});
const $c495211a89197754$export$ff0264ec4c015dc1 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoadedWithPage
});
const $c495211a89197754$export$6c8b81f6dca8c23d = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getEstimationStatistic
});
const $c495211a89197754$export$fe7085456138f0fc = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoading
});
const $c495211a89197754$export$c339e36468c12443 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewMode
});
const $c495211a89197754$export$ef3bfa2642bb98cd = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBackButtonUrl
});
const $c495211a89197754$export$8accd063c74cd455 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueNavigatorData
});
const $c495211a89197754$export$e7edffc2a20027e7 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardId
});
const $c495211a89197754$export$48aaa3a6bc2085d7 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardType
});
const $c495211a89197754$export$4a4b96bcf5166327 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsSpaEnabled
});
const $c495211a89197754$export$bbd8ba0180545556 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getLoginRedirectUrl
});
const $c495211a89197754$export$aaa89627762c7d00 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getOnIssueKeyChange
});
const $c495211a89197754$export$796589b0ec52848a = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewId
});
const $c495211a89197754$export$7e70ee570119a0a7 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsAiOptInEnabled
});
const $c495211a89197754$export$93db6a8f3342dddf = (0, $WBLbN.createContainer)($c495211a89197754$export$6f57813fe9f31bf9);
const $c495211a89197754$export$965360ae27fcae98 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("8d785", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0a3f8ba487c482e8$export$e324594224ef24da);

var $7LyiF = parcelRequire("7LyiF");

var $hHM8F = parcelRequire("hHM8F");

var $fhgeS = parcelRequire("fhgeS");
const $0a3f8ba487c482e8$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $0a3f8ba487c482e8$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $0a3f8ba487c482e8$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $hHM8F.getChildIssuesLimit)(getState());
const $0a3f8ba487c482e8$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $0a3f8ba487c482e8$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $0a3f8ba487c482e8$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $0a3f8ba487c482e8$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $0a3f8ba487c482e8$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $0a3f8ba487c482e8$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $0a3f8ba487c482e8$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), 'MODAL');
        setState({
            viewMode: 'MODAL'
        });
    };
const $0a3f8ba487c482e8$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
        setState({
            viewMode: 'SIDEBAR'
        });
    };
const $0a3f8ba487c482e8$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $fhgeS.getViewModeFromLocalStorage)()
        });
    };
const $0a3f8ba487c482e8$export$e324594224ef24da = {
    setIssueContext: $0a3f8ba487c482e8$export$784a03c4b74da53e,
    mergeIssueContext: $0a3f8ba487c482e8$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $0a3f8ba487c482e8$export$89b6937a83edcaa6,
    getMaxTokenLength: $0a3f8ba487c482e8$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $0a3f8ba487c482e8$export$2fe981b90be13483,
    getBackButtonUrl: $0a3f8ba487c482e8$export$afce556782490aae,
    getIsSpaEnabled: $0a3f8ba487c482e8$export$711dfa096bf81f2d,
    getIssueKey: $0a3f8ba487c482e8$export$4a030f6192bebe03,
    getIsArchived: $0a3f8ba487c482e8$export$b41341ac6c74ca6,
    setDetailViewAsModal: $0a3f8ba487c482e8$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $0a3f8ba487c482e8$export$b303af51de56a0e,
    resetDetailView: $0a3f8ba487c482e8$export$75007d125f198b78
};

});
parcelRegister("7LyiF", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $7643f341d271ccc9$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $7643f341d271ccc9$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $7643f341d271ccc9$export$a13f7f627010bccd);

var $aZaPn = parcelRequire("aZaPn");
const $7643f341d271ccc9$export$25a759e49d5049db = 'issue.issue-context-service';
const $7643f341d271ccc9$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_issue_view');
const $7643f341d271ccc9$export$a13f7f627010bccd = 'view-mode';

});

parcelRegister("hHM8F", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $a9a8c93b5bcca8ab$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $a9a8c93b5bcca8ab$export$8f43520910e8128c);

var $gUUjF = parcelRequire("gUUjF");

var $7LyiF = parcelRequire("7LyiF");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $7LyiF.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $a9a8c93b5bcca8ab$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $a9a8c93b5bcca8ab$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

parcelRegister("fhgeS", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $49ad189ccd6ad8c9$export$cae7c4c591dcc261);

var $7LyiF = parcelRequire("7LyiF");
const $49ad189ccd6ad8c9$export$cae7c4c591dcc261 = ()=>(0, $7LyiF.localStorage).get((0, $7LyiF.VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';

});




parcelRegister("kesKZ", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $793b6123392d83ee$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $793b6123392d83ee$export$e324594224ef24da);

var $eDn3S = parcelRequire("eDn3S");

var $9pYcd = parcelRequire("9pYcd");
const $793b6123392d83ee$export$d4c72bab9d6cc13a = {
    confluenceData: {
        contentId: '',
        contentUrl: '',
        contentData: null,
        mode: (0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        isDraft: false,
        isLive: false
    },
    contentActions: {},
    contentType: (0, $9pYcd.ConfluenceContentTypes).PAGE,
    embeddedConfluenceSource: '',
    displayType: (0, $9pYcd.DisplayTypes).PANEL,
    panel: {
        initialWidth: 0,
        isOpen: false,
        isLoading: false
    },
    modal: {
        isOpen: false
    }
};
const $793b6123392d83ee$export$aa5d06fef96639ba = ({ contentId: contentId, contentType: contentType, embeddedConfluenceSource: embeddedConfluenceSource, data: data, displayType: displayType, initialWidth: initialWidth, hostname: hostname, isDraft: isDraft, isLive: isLive, mode: mode, onLinkPage: onLinkPage, onPublish: onPublish, shouldOpenModal: shouldOpenModal, url: url, title: title })=>({ setState: setState })=>{
        setState({
            confluenceData: {
                contentId: contentId,
                contentUrl: url,
                contentData: data,
                hostname: hostname,
                mode: mode,
                isDraft: isDraft,
                isLive: isLive,
                title: title
            },
            contentActions: {
                onLinkPage: onLinkPage,
                onPublish: onPublish
            },
            embeddedConfluenceSource: embeddedConfluenceSource,
            contentType: contentType,
            displayType: displayType,
            panel: {
                initialWidth: initialWidth,
                isOpen: !shouldOpenModal
            },
            modal: {
                isOpen: shouldOpenModal
            }
        });
    };
const $793b6123392d83ee$export$e81b26ab493ca52a = ()=>({ setState: setState })=>{
        setState($793b6123392d83ee$export$d4c72bab9d6cc13a);
    };
const $793b6123392d83ee$export$1a38f537b5932219 = (deferredSpaceName)=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                deferredSpaceName: deferredSpaceName
            },
            ...prevState
        });
    };
const $793b6123392d83ee$export$db9852cd4946540a = ({ isLoading: isLoading, isDeferSpaceSelection: isDeferSpaceSelection })=>({ setState: setState, getState: getState })=>{
        const { panel: panel, ...prevState } = getState();
        setState({
            ...prevState,
            isDeferSpaceSelection: isDeferSpaceSelection,
            panel: {
                ...panel,
                isLoading: isLoading
            }
        });
    };
const $793b6123392d83ee$export$e324594224ef24da = {
    closeSidePanel: $793b6123392d83ee$export$e81b26ab493ca52a,
    setDeferredSpaceName: $793b6123392d83ee$export$1a38f537b5932219,
    openSidePanel: $793b6123392d83ee$export$aa5d06fef96639ba,
    setIsLoadingForDeferSpaceSelection: $793b6123392d83ee$export$db9852cd4946540a
};

});
parcelRegister("eDn3S", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", () => $244f576f48d8bb4b$export$816ef638e478449a);
var $244f576f48d8bb4b$export$816ef638e478449a;
(function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
})($244f576f48d8bb4b$export$816ef638e478449a || ($244f576f48d8bb4b$export$816ef638e478449a = {}));

});

parcelRegister("9pYcd", function(module, exports) {

$parcel$export(module.exports, "ConfluenceContentTypes", () => $39eb515aa687d2a5$export$b39616d00ee96d40);
$parcel$export(module.exports, "DisplayTypes", () => $39eb515aa687d2a5$export$c294d3f3727c1a0);
const $39eb515aa687d2a5$export$b39616d00ee96d40 = {
    WHITEBOARD: 'whiteboard',
    PAGE: 'page'
};
const $39eb515aa687d2a5$export$c294d3f3727c1a0 = {
    MODAL: 'modal',
    PANEL: 'panel'
};

});


parcelRegister("02qo9", function(module, exports) {

$parcel$export(module.exports, "getDisplayInformation", () => $b84672c547e7927b$export$ee79869f97207574);

var $9pYcd = parcelRequire("9pYcd");
const $b84672c547e7927b$export$37e31995727dc8d7 = 0.5;
const $b84672c547e7927b$export$ee79869f97207574 = ()=>{
    /*
	We set the screen width to 50% of the screen width if the screen
	width is larger than 1024px because we want the Embedded Confluence in the side panel to
	take up half the screen width. The max of the side panel is 50% of the screen width and
	we are not able to set it wider. Jira Issue details panel will be forced down around 1875px
	screen width.
	If the screen width is less than 1024px, we'll set the panel width to 0 because we will be
	opening the EmbeddedContentModal instead and set displayType to Modal.
	This also assumes that we are currently on the full page version of a Jira Issue.
	*/ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1024) return {
        initialWidth: screenWidth * $b84672c547e7927b$export$37e31995727dc8d7,
        displayType: (0, $9pYcd.DisplayTypes).PANEL
    };
    return {
        initialWidth: 0,
        displayType: (0, $9pYcd.DisplayTypes).MODAL
    };
};

});


parcelRegister("ih3cb", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPanelEntryPoint", () => $8cde58005f26c88b$export$75ef2f025ecbf1de);

var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $kXU1v = parcelRequire("kXU1v");

var $fYx5D = parcelRequire("fYx5D");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aGJM1 = parcelRequire("aGJM1");

var $bczMu = parcelRequire("bczMu");

var $eq2dV = parcelRequire("eq2dV");

var $dMGT3 = parcelRequire("dMGT3");
const $8cde58005f26c88b$var$entryPointParams = {};
const $8cde58005f26c88b$export$75ef2f025ecbf1de = ()=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    const [state, actions] = (0, $fYx5D.useEmbeddedConfluenceSidePanel)();
    const { contentType: contentType, confluenceData: { contentId: contentId, contentUrl: contentUrl, hostname: hostname, isLive: isLive, isDraft: isDraft, title: title, mode: mode }, isDeferSpaceSelection: isDeferSpaceSelection, contentActions: { onLinkPage: onLinkPage }, panel: { isOpen: isOpen }, embeddedConfluenceSource: embeddedConfluenceSource } = state;
    const parentProduct = (0, $dMGT3.useParentProduct)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $aGJM1.embeddedPanelEntrypoint), $8cde58005f26c88b$var$entryPointParams);
    const embeddedConfluenceSourceForPanel = `${embeddedConfluenceSource}Panel`;
    const deferSpaceToast = (0, $1ybV0.ff)('toast_defer_space_ntufi');
    const isTemplateBrowserEnabled = (0, $1ybV0.ff)('jira.issue-view.create-confluence-page.template-browser');
    const fireAnalyticsEvent = (0, $eq2dV.useEmbeddedPageTracking)();
    const themeState = (0, $4q38b.default)();
    /*
  	If the user is on a custom domain, we need to update the
  	hostname to reflect the parentProduct's hostname. By providing the hostname
  	prop we will force EP to use the parentProduct's hostname instead of the content's hostname
  	when on a custom domain (see EP code here https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/confluence/embedded-confluence-common/src/page/parsePageProps.ts#75).
  */ const contentHostname = (0, $bczMu.setHostnameForContent)(contentUrl, hostname);
    const onContentAction = (0, $eUqFw.useCallback)((action, eventName)=>{
        fireAnalyticsEvent({
            action: action,
            eventName: eventName,
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel
        });
    }, [
        fireAnalyticsEvent,
        embeddedConfluenceSourceForPanel
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            eventName: 'closeEmbeddedConfluencePanel',
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel
        });
        entryPointActions.unload();
        actions.closeSidePanel();
    }, [
        actions,
        fireAnalyticsEvent,
        entryPointActions,
        embeddedConfluenceSourceForPanel
    ]);
    const editAllowedFeatures = (0, $eUqFw.useMemo)(()=>[
            ...isDeferSpaceSelection ? [
                'publish-modal'
            ] : [],
            ...isTemplateBrowserEnabled ? [
                'template-browser'
            ] : []
        ], [
        isDeferSpaceSelection,
        isTemplateBrowserEnabled
    ]);
    const shouldApplyEditFeatures = editAllowedFeatures.length > 0 && isDraft;
    const shouldOpenPanel = isOpen && contentUrl;
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            locale: locale,
            hasFooterLogo: false,
            isDraft: isDraft,
            isLive: isLive,
            hostname: contentHostname,
            panelTitle: title,
            navigationPolicy: undefined,
            onClose: onClose,
            onContentAction: onContentAction,
            parentProduct: parentProduct,
            spaceKey: (0, $kXU1v.parseUrl)(contentUrl)?.spaceKey,
            themeState: themeState,
            url: contentUrl,
            mode: mode,
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
            contentId: contentId,
            contentType: contentType,
            ...deferSpaceToast && {
                onPublish: actions.setDeferredSpaceName
            },
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ],
                ...shouldApplyEditFeatures && {
                    edit: editAllowedFeatures
                }
            },
            linkConfluencePage: onLinkPage
        }), [
        actions.setDeferredSpaceName,
        contentId,
        contentType,
        contentUrl,
        deferSpaceToast,
        editAllowedFeatures,
        embeddedConfluenceSourceForPanel,
        contentHostname,
        isDraft,
        isLive,
        locale,
        title,
        mode,
        onClose,
        onContentAction,
        onLinkPage,
        parentProduct,
        themeState,
        shouldApplyEditFeatures
    ]);
    return shouldOpenPanel ? {
        entryPointActions: entryPointActions,
        entryPoint: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "epPanelEntrypointContainer",
            packageName: "@atlassian/jira-issue-create-confluence-content",
            teamName: "confluence-better-together",
            runtimeProps: runtimeProps
        })
    } : {
        ref: undefined,
        entryPoint: null
    };
};

});
parcelRegister("kXU1v", function(module, exports) {

$parcel$export(module.exports, "parsePageProps", () => $3fc9cb2f517faab2$export$41eb0a358b69a9df);
$parcel$export(module.exports, "parseUrl", () => $3fc9cb2f517faab2$export$7a5253c0f62e0150);

var $78Ywx = parcelRequire("78Ywx");

var $1d3eD = parcelRequire("1d3eD");

var $iednx = parcelRequire("iednx");

var $7QVWm = parcelRequire("7QVWm");

var $eDn3S = parcelRequire("eDn3S");

var $34qd2 = parcelRequire("34qd2");
function $3fc9cb2f517faab2$export$41eb0a358b69a9df(props) {
    let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, ...passThroughProps } = props;
    const parsedAllowedFeatures = $3fc9cb2f517faab2$export$350c411f568eceb9(allowedFeatures);
    if (!url) return {
        contentId: contentId,
        hostname: hostname,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        protocol: 'https:',
        mode: mode ?? (0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        ...passThroughProps
    };
    const parsedProps = $3fc9cb2f517faab2$export$7a5253c0f62e0150(url);
    if (!parsedProps) return {
        hostname: hostname,
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        mode: mode,
        protocol: 'https:',
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        ...passThroughProps
    };
    const themeStateParsedObject = parsedProps.themeState ? (0, $iednx.themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
    // If the props are explicity passed in along with URL, those passed-in props will be overriding the URL-extract props.
    contentId = contentId || parsedProps.contentId;
    parentProduct = parentProduct || parsedProps.parentProduct;
    hostname = hostname || parsedProps.hostname || window.location.hostname;
    spaceKey = spaceKey || parsedProps.spaceKey;
    draftShareId = draftShareId || parsedProps.draftShareId;
    hash = hash || parsedProps.hash;
    themeState = themeState || themeStateParsedObject;
    let modeFromUrl;
    switch(parsedProps.route){
        case (0, $34qd2.VIEW_PAGE).name:
        case (0, $34qd2.VIEW_BLOG).name:
        case (0, $34qd2.VIEW_BLOG_DATE_LEGACY).name:
            modeFromUrl = (0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
            break;
        case (0, $34qd2.EDIT_PAGE_EMBED).name:
        case (0, $34qd2.EDIT_PAGE_V2).name:
            modeFromUrl = (0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
    }
    return {
        allowedFeatures: $3fc9cb2f517faab2$export$350c411f568eceb9(allowedFeatures),
        contentId: contentId,
        draftShareId: draftShareId,
        hash: hash,
        hostname: hostname,
        mode: mode || modeFromUrl,
        parentProduct: parentProduct,
        protocol: parsedProps.protocol,
        spaceKey: spaceKey,
        themeState: themeState,
        ...passThroughProps
    };
}
function $3fc9cb2f517faab2$export$7a5253c0f62e0150(url) {
    if (!url) return null;
    const matchedRoute = $3fc9cb2f517faab2$var$findAndMatchRoute((0, $34qd2.namedRoutes), url);
    if (!matchedRoute) return null;
    const { routeName: routeName, ...match } = matchedRoute;
    return {
        route: routeName,
        hostname: match.host,
        protocol: match.protocol,
        contentId: match.params.contentId || '',
        spaceKey: match.params.spaceKey || '',
        hash: match.hash,
        // EP currently supports only 1 parent product, no more than 1 parent product should be passed in
        parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
        draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
        themeState: match.query.themeState
    };
}
function $3fc9cb2f517faab2$var$findAndMatchRoute(routes, url) {
    for (const routeName of Object.keys(routes)){
        const pattern = routes[routeName].pattern;
        const match = $3fc9cb2f517faab2$var$matchUrl(pattern, url);
        if (match) return {
            routeName: routeName,
            ...match
        };
    }
}
function $3fc9cb2f517faab2$var$matchUrl(pattern, url) {
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($78Ywx))).parse(url, true);
    const pathname = parsed.pathname || '';
    let match = (0, $1d3eD.default)(pathname, {
        path: pattern,
        exact: true
    });
    // some of our routes need query params to match
    if (!match) match = (0, $1d3eD.default)(`${pathname}${parsed.search}`, {
        path: pattern,
        exact: true
    });
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match && match.params) for (const [key, value] of Object.entries(match.params))decodedParams[key] = value;
    return {
        url: url,
        protocol: parsed?.protocol || 'https:',
        host: parsed?.host || '',
        pathname: pathname,
        search: parsed.search || '',
        hash: parsed.hash || '',
        pattern: pattern,
        params: decodedParams,
        query: parsed.query || ''
    };
}
function $3fc9cb2f517faab2$export$350c411f568eceb9(allowedFeatures) {
    let parsedAllowedFeatures = {
        view: allowedFeatures?.view,
        edit: allowedFeatures?.edit
    };
    if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
        ...(0, $7QVWm.DEFAULT_ALLOWED_FEATURES).view,
        'edit'
    ];
    else if (Array.isArray(allowedFeatures?.view)) parsedAllowedFeatures.view = [
        ...allowedFeatures?.view,
        'edit'
    ];
    return parsedAllowedFeatures;
}

});
parcelRegister("1d3eD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e1983bddd0ee331$export$2e2bcd8739ae039);

var $43pB1 = parcelRequire("43pB1");
var $0e1983bddd0ee331$var$patternCache = {};
var $0e1983bddd0ee331$var$cacheLimit = 10000;
var $0e1983bddd0ee331$var$cacheCount = 0;
var $0e1983bddd0ee331$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $0e1983bddd0ee331$var$patternCache[cacheKey] || ($0e1983bddd0ee331$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($43pB1)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($0e1983bddd0ee331$var$cacheCount < $0e1983bddd0ee331$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $0e1983bddd0ee331$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $0e1983bddd0ee331$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $0e1983bddd0ee331$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $0e1983bddd0ee331$export$2e2bcd8739ae039 = $0e1983bddd0ee331$var$matchPath;

});
parcelRegister("43pB1", function(module, exports) {

var $e4Chz = parcelRequire("e4Chz");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $2f3b4c1d8f9b78ef$var$pathToRegexp;
module.exports.parse = $2f3b4c1d8f9b78ef$var$parse;
module.exports.compile = $2f3b4c1d8f9b78ef$var$compile;
module.exports.tokensToFunction = $2f3b4c1d8f9b78ef$var$tokensToFunction;
module.exports.tokensToRegExp = $2f3b4c1d8f9b78ef$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $2f3b4c1d8f9b78ef$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $2f3b4c1d8f9b78ef$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $2f3b4c1d8f9b78ef$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $2f3b4c1d8f9b78ef$var$escapeGroup(pattern) : asterisk ? '.*' : $2f3b4c1d8f9b78ef$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $2f3b4c1d8f9b78ef$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $2f3b4c1d8f9b78ef$var$escapeString(delimiter) + ']+?';
    return $2f3b4c1d8f9b78ef$var$escapeString(prevText) + '|(?:(?!' + $2f3b4c1d8f9b78ef$var$escapeString(prevText) + ')[^' + $2f3b4c1d8f9b78ef$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $2f3b4c1d8f9b78ef$var$compile(str, options) {
    return $2f3b4c1d8f9b78ef$var$tokensToFunction($2f3b4c1d8f9b78ef$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $2f3b4c1d8f9b78ef$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $2f3b4c1d8f9b78ef$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $2f3b4c1d8f9b78ef$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $2f3b4c1d8f9b78ef$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $2f3b4c1d8f9b78ef$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($e4Chz(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $2f3b4c1d8f9b78ef$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $2f3b4c1d8f9b78ef$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $2f3b4c1d8f9b78ef$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $2f3b4c1d8f9b78ef$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $2f3b4c1d8f9b78ef$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $2f3b4c1d8f9b78ef$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $2f3b4c1d8f9b78ef$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $2f3b4c1d8f9b78ef$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($2f3b4c1d8f9b78ef$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $2f3b4c1d8f9b78ef$var$flags(options));
    return $2f3b4c1d8f9b78ef$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $2f3b4c1d8f9b78ef$var$stringToRegexp(path, keys, options) {
    return $2f3b4c1d8f9b78ef$var$tokensToRegExp($2f3b4c1d8f9b78ef$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $2f3b4c1d8f9b78ef$var$tokensToRegExp(tokens, keys, options) {
    if (!$e4Chz(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $2f3b4c1d8f9b78ef$var$escapeString(token);
        else {
            var prefix = $2f3b4c1d8f9b78ef$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $2f3b4c1d8f9b78ef$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $2f3b4c1d8f9b78ef$var$attachKeys(new RegExp('^' + route, $2f3b4c1d8f9b78ef$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $2f3b4c1d8f9b78ef$var$pathToRegexp(path, keys, options) {
    if (!$e4Chz(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $2f3b4c1d8f9b78ef$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($e4Chz(path)) return $2f3b4c1d8f9b78ef$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $2f3b4c1d8f9b78ef$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("e4Chz", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});



parcelRegister("7QVWm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", () => $414e04f18572c2ea$export$a33327ada3a6ee4a);
$parcel$export(module.exports, "getAllowedFeatures", () => $414e04f18572c2ea$export$3207c60940c4a9b0);

var $fnopv = parcelRequire("fnopv");
var $eDn3S = parcelRequire("eDn3S");
var $414e04f18572c2ea$export$241b9888a4d565c9;
(function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
})($414e04f18572c2ea$export$241b9888a4d565c9 || ($414e04f18572c2ea$export$241b9888a4d565c9 = {}));
const $414e04f18572c2ea$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        'template-browser',
        'inline-comments'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $414e04f18572c2ea$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $414e04f18572c2ea$var$pageAllowedFeatures = {
    [(0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $414e04f18572c2ea$export$a3fda3dcee62e1cc.edit,
    [(0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $414e04f18572c2ea$export$a3fda3dcee62e1cc.view
};
const $414e04f18572c2ea$var$blogPostAllowedFeatures = {
    [(0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $414e04f18572c2ea$export$a3fda3dcee62e1cc.edit,
    [(0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $414e04f18572c2ea$export$a3fda3dcee62e1cc.view
};
const $414e04f18572c2ea$var$whiteboardAllowedFeatures = {
    [(0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $414e04f18572c2ea$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $414e04f18572c2ea$export$a3fda3dcee62e1cc.whiteboard
};
const $414e04f18572c2ea$var$contentTypeAllowedFeatures = {
    [(0, $fnopv.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $414e04f18572c2ea$var$pageAllowedFeatures,
    [(0, $fnopv.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $414e04f18572c2ea$var$blogPostAllowedFeatures,
    [(0, $fnopv.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $414e04f18572c2ea$var$whiteboardAllowedFeatures
};
const $414e04f18572c2ea$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$414e04f18572c2ea$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];

});
parcelRegister("fnopv", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", () => $d6c4986b94bc12dd$export$942a5fac9b8c9dc2);
var $d6c4986b94bc12dd$export$942a5fac9b8c9dc2;
(function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
})($d6c4986b94bc12dd$export$942a5fac9b8c9dc2 || ($d6c4986b94bc12dd$export$942a5fac9b8c9dc2 = {}));

});


parcelRegister("34qd2", function(module, exports) {

$parcel$export(module.exports, "EDIT_PAGE_EMBED", () => $50cb4ae852675291$export$e63a462ee45b57cf);
$parcel$export(module.exports, "EDIT_PAGE_V2", () => $50cb4ae852675291$export$7b1285e36c635f1f);
$parcel$export(module.exports, "VIEW_PAGE", () => $50cb4ae852675291$export$9257b5b55c8e2555);
$parcel$export(module.exports, "VIEW_BLOG", () => $50cb4ae852675291$export$91f49e7b30a9d34);
$parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", () => $50cb4ae852675291$export$bd2c9bb170b3681d);
$parcel$export(module.exports, "namedRoutes", () => $50cb4ae852675291$export$d4971375353d0454);
$parcel$export(module.exports, "EMBEDDED_PARENT_PRODUCTS", () => $50cb4ae852675291$export$5c59aa0922e65f1a);
const $50cb4ae852675291$export$e63a462ee45b57cf = {
    name: 'EDIT_PAGE_EMBED',
    pattern: '/wiki/spaces/:spaceKey/:contentType(pages)/edit-embed/:contentId(\\d+)/:contentSlug?'
};
const $50cb4ae852675291$export$7b1285e36c635f1f = {
    name: 'EDIT_PAGE_V2',
    pattern: '/wiki/spaces/:spaceKey/:contentType(pages)/edit-v2/:contentId(\\d+)/:contentSlug?'
};
const $50cb4ae852675291$export$65b723bb995d4fb6 = {
    name: 'SPACE_OVERVIEW',
    pattern: '/wiki/spaces/:spaceKey/overview'
};
const $50cb4ae852675291$export$9257b5b55c8e2555 = {
    name: 'VIEW_PAGE',
    pattern: '/wiki/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?'
};
const $50cb4ae852675291$export$91f49e7b30a9d34 = {
    name: 'VIEW_BLOG',
    pattern: '/wiki/spaces/:spaceKey/blog/:contentId(\\d+)/:contentSlug?'
};
const $50cb4ae852675291$export$bd2c9bb170b3681d = {
    name: 'VIEW_BLOG_DATE_LEGACY',
    pattern: '/wiki/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?'
};
const $50cb4ae852675291$export$d4971375353d0454 = {
    EDIT_PAGE_EMBED: $50cb4ae852675291$export$e63a462ee45b57cf,
    EDIT_PAGE_V2: $50cb4ae852675291$export$7b1285e36c635f1f,
    SPACE_OVERVIEW: $50cb4ae852675291$export$65b723bb995d4fb6,
    VIEW_PAGE: $50cb4ae852675291$export$9257b5b55c8e2555,
    VIEW_BLOG: $50cb4ae852675291$export$91f49e7b30a9d34,
    VIEW_BLOG_DATE_LEGACY: $50cb4ae852675291$export$bd2c9bb170b3681d
};
const $50cb4ae852675291$export$5c59aa0922e65f1a = {
    JSM_PORTAL: 'JSM-Portal',
    JSM: 'JSM',
    JSW: 'JSW',
    JWM: 'JWM'
};

});


parcelRegister("aGJM1", function(module, exports) {

$parcel$export(module.exports, "embeddedPanelEntrypoint", () => $f4fee34f61d7147e$export$32561f984de7bece);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $f4fee34f61d7147e$export$32561f984de7bece = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("iJY8A")), {
        moduleId: "293c24d0"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iJY8A", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("wcQ1n")
]).then(()=>parcelRequire('8snz3'));

});


parcelRegister("bczMu", function(module, exports) {

$parcel$export(module.exports, "createActivePageUrl", () => $13c13bf829800cbb$export$83c6318baef117fe);
$parcel$export(module.exports, "getURLFromConfluencePageResponse", () => $13c13bf829800cbb$export$e87b28852220b5cd);
$parcel$export(module.exports, "setHostnameForContent", () => $13c13bf829800cbb$export$8ccd4cc378896990);
$parcel$export(module.exports, "constructUrlIfCustomDomain", () => $13c13bf829800cbb$export$a63ef4c6a1286e2a);
$parcel$export(module.exports, "createLinkCreatePayload", () => $13c13bf829800cbb$export$af98278c506da0f4);

var $fEdG4 = parcelRequire("fEdG4");

var $2XxeS = parcelRequire("2XxeS");
const $13c13bf829800cbb$export$f31b9480a5e4fdcf = (uri)=>{
    if (!uri || uri === '') return '';
    const matches = uri.match(/draftShareId=([^&])*/g);
    return matches ? matches[0].split('=')[1] : '';
};
const $13c13bf829800cbb$export$be3b1ed3560ef0e6 = ({ url: url, spaceId: spaceId, spaceKey: spaceKey })=>{
    if (!(url && spaceId && spaceKey)) return '';
    return url.replace(`spaces/${spaceId}`, `spaces/${spaceKey}`);
};
const $13c13bf829800cbb$export$83c6318baef117fe = (createPayload)=>{
    const { data: data, url: url } = createPayload;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const links = data?.links;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const spaceKey = data?.spaceKey;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const spaceId = data?.spaceId;
    const linkableUrl = $13c13bf829800cbb$export$be3b1ed3560ef0e6({
        url: url,
        spaceId: spaceId,
        spaceKey: spaceKey
    });
    if (data?.subType === 'live') return `${linkableUrl}`;
    return `${linkableUrl}?draftShareId=${$13c13bf829800cbb$export$f31b9480a5e4fdcf(links?.editui)}`;
};
const $13c13bf829800cbb$export$e87b28852220b5cd = ({ id: id, spaceKey: spaceKey, hostname: hostname })=>`${hostname}/wiki/spaces/${spaceKey}/pages/edit-v2/${id}/`;
const $13c13bf829800cbb$var$isUrlCustomDomain = (parentHost, url)=>{
    const hostname = (0, $fEdG4.getHostnameFromUrl)(url);
    return (0, $2XxeS.isCustomDomain)(parentHost) || hostname && (0, $2XxeS.isCustomDomain)(hostname);
};
const $13c13bf829800cbb$export$8ccd4cc378896990 = (url, hostname)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const parentHost = window?.location?.origin || '';
    const contentHost = hostname ?? (0, $fEdG4.getHostnameFromUrl)(url);
    return $13c13bf829800cbb$var$isUrlCustomDomain(parentHost, url) ? (0, $fEdG4.getHostnameFromUrl)(parentHost) : contentHost;
};
const $13c13bf829800cbb$export$a63ef4c6a1286e2a = ({ id: id, originalDomain: originalDomain, originalUrl: originalUrl, spaceKey: spaceKey, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const currentHostname = window?.location?.origin || '';
    const hostnameFromUrl = (0, $fEdG4.getHostnameFromUrl)(originalDomain);
    const systemHostName = (0, $fEdG4.getHostnameFromUrl)(systemConfluenceAppLinkUrl);
    /*
		If content is not on the same tenant, and custom domain is enabled, we need to update the hostname
		to reflect the parentProduct's hostname
	*/ if (systemHostName !== hostnameFromUrl && $13c13bf829800cbb$var$isUrlCustomDomain(currentHostname, originalDomain)) return $13c13bf829800cbb$export$e87b28852220b5cd({
        id: id,
        spaceKey: spaceKey,
        hostname: currentHostname
    });
    return originalUrl;
};
const $13c13bf829800cbb$export$af98278c506da0f4 = (createResponse, url, space, cloudId)=>({
        url: url,
        ari: `ari:cloud:confluence:${cloudId}:page/${createResponse.id}`,
        objectId: createResponse.id,
        objectType: 'page',
        data: {
            spaceId: space.spaceId,
            spaceKey: space.spaceKey,
            spaceName: space.spaceName,
            status: createResponse.status,
            subType: createResponse.subType,
            links: createResponse._links
        }
    });

});
parcelRegister("fEdG4", function(module, exports) {

$parcel$export(module.exports, "getHostnameFromUrl", () => $ee5f489954b592fe$export$280e79c794cf814e);

var $4YFgD = parcelRequire("4YFgD");
const $ee5f489954b592fe$export$280e79c794cf814e = (url)=>(0, $4YFgD.isValidUrl)(url) ? new URL(url)?.hostname : '';

});
parcelRegister("4YFgD", function(module, exports) {

$parcel$export(module.exports, "isValidUrl", () => $b579652caee60b2f$export$bef94a5618bf18bf);
const $b579652caee60b2f$export$bef94a5618bf18bf = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};

});


parcelRegister("2XxeS", function(module, exports) {

$parcel$export(module.exports, "isCustomDomain", () => $114e25cd3035a797$export$97f4c254b641e719);
const $114e25cd3035a797$var$atlassianDomains = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $114e25cd3035a797$export$97f4c254b641e719 = (hostname)=>!$114e25cd3035a797$var$atlassianDomains.some((domain)=>hostname.endsWith(domain));

});


parcelRegister("eq2dV", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageTracking", () => $471d338f836f9c77$export$9fcd107e4ed1de75);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $ls5tj = parcelRequire("ls5tj");

var $6myYy = parcelRequire("6myYy");
const $471d338f836f9c77$export$9fcd107e4ed1de75 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const source = (0, $hJ992.useAnalyticsSource)();
    const trackEmbeddedConfluence = (0, $eUqFw.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct, linkObjectType: linkObjectType })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject ?? `${eventName}`
        });
        const attributes = {
            parentProduct: (0, $ls5tj.getParentProduct)(projectType),
            tenantEditions: tenantContext?.appEditions,
            productEntitlementDetails: tenantContext?.productEntitlementDetails,
            embeddedConfluenceSource: embeddedConfluenceSource,
            jiraIssueSurfaceArea: source,
            userHasConfluenceAccess: userHasConfluenceAccess,
            tenantHasConfluence: tenantHasConfluence,
            crossJoinStatus: crossJoinStatus,
            originProduct: originProduct,
            requestedProduct: requestedProduct,
            isSiteAdmin: tenantContext?.isSiteAdmin,
            linkObjectType: linkObjectType
        };
        (0, $6myYy.fireEmbeddedConfluenceAnalytics)({
            analyticsEvent: analyticsEvent,
            attributes: attributes,
            eventType: eventType,
            eventName: `${actionSubject ?? eventName} ${action}`
        });
    }, [
        source,
        tenantContext,
        createAnalyticsEvent
    ]);
    return trackEmbeddedConfluence;
};

});
parcelRegister("ls5tj", function(module, exports) {

$parcel$export(module.exports, "ACCESS_REQUEST_CAPABILITIES", () => $f8a0c629383095b7$export$b4e6d6efc113ca5);
$parcel$export(module.exports, "VALID_DIRECT_ACCESS_STATUS", () => $f8a0c629383095b7$export$bf1e31028b579014);
$parcel$export(module.exports, "ACCESS_DENIED_STATUSES", () => $f8a0c629383095b7$export$2fe5bb2d968b01fc);
$parcel$export(module.exports, "LICENCE_EXCEEDED_STATUS", () => $f8a0c629383095b7$export$56360b096b4b4439);
$parcel$export(module.exports, "getParentProduct", () => $f8a0c629383095b7$export$e873edb2560a07ef);

var $7ZZxN = parcelRequire("7ZZxN");




const $f8a0c629383095b7$export$b4e6d6efc113ca5 = {
    ACCESS_GRANTED: 'ACCESS_GRANTED',
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
const $f8a0c629383095b7$export$bf1e31028b579014 = [
    $f8a0c629383095b7$export$b4e6d6efc113ca5.ACCESS_EXISTS,
    $f8a0c629383095b7$export$b4e6d6efc113ca5.ACCESS_GRANTED,
    $f8a0c629383095b7$export$b4e6d6efc113ca5.PENDING_REQUEST_EXISTS
];
const $f8a0c629383095b7$export$2fe5bb2d968b01fc = [
    $f8a0c629383095b7$export$b4e6d6efc113ca5.FORBIDDEN,
    $f8a0c629383095b7$export$b4e6d6efc113ca5.DENIED_REQUEST_EXISTS
];
const $f8a0c629383095b7$export$56360b096b4b4439 = 'licence-exceeded';
const $f8a0c629383095b7$export$e873edb2560a07ef = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $7ZZxN.CORE_PROJECT:
            return 'JWM';
        default:
            return 'JSW';
    }
};

});

parcelRegister("6myYy", function(module, exports) {

$parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", () => $be7aa4fcf32865f7$export$864bc2da9014e8e9);

var $jMP2a = parcelRequire("jMP2a");
const $be7aa4fcf32865f7$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
    switch(eventType){
        case 'ui':
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
            break;
        case 'operational':
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        case 'track':
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        default:
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
            break;
    }
};

});


parcelRegister("dMGT3", function(module, exports) {

$parcel$export(module.exports, "useParentProduct", () => $e70d73b8efede62e$export$1b09c6e3737c8eb7);

var $bNe1g = parcelRequire("bNe1g");

var $ls5tj = parcelRequire("ls5tj");
const $e70d73b8efede62e$export$1b09c6e3737c8eb7 = ()=>{
    const { data: data } = (0, $bNe1g.useProjectContext)();
    const projectType = data?.projectType;
    return (0, $ls5tj.getParentProduct)(projectType);
};

});



parcelRegister("d8a4z", function(module, exports) {

$parcel$export(module.exports, "ImperativeAPI", () => $1e92f89157195fce$export$e2ad0ff52e7f8c84);

var $eUqFw = parcelRequire("eUqFw");

var $6oi2X = parcelRequire("6oi2X");

var $jwtcO = parcelRequire("jwtcO");
const $1e92f89157195fce$export$e2ad0ff52e7f8c84 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oi2X.Consumer), null, ({ getManager: getManager })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jwtcO.ImperativeAPI), {
            getItemManager: getManager
        }));

});
parcelRegister("6oi2X", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $786b8f2349f4f371$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $786b8f2349f4f371$export$b3bffd4bb7da6b8f);

var $eUqFw = parcelRequire("eUqFw");

var $kFGm5 = parcelRequire("kFGm5");

var $aptld = parcelRequire("aptld");

var $hIu0M = parcelRequire("hIu0M");
const $786b8f2349f4f371$var$Context = (0, $aptld.default)('ItemManagers');
const $786b8f2349f4f371$export$275138de3066e8b3 = 30000;
class $786b8f2349f4f371$export$2881499e37b75b9a extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($786b8f2349f4f371$var$Context.Provider, {
            value: this.manager
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            managers: {}
        };
        this.getManager = (managerKey)=>{
            const { managers: managers } = this.state;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            const manager = managers[managerKey];
            if (manager) return manager;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return new Promise((resolve, reject)=>{
                const message = `Timeout. "${(0, $hIu0M.fromManagerKey)(managerKey)}" wasn't registered after ${$786b8f2349f4f371$export$275138de3066e8b3}ms`;
                const rejectTimeoutId = setTimeout(()=>reject(new Error(message)), $786b8f2349f4f371$export$275138de3066e8b3);
                const { pendingManagers: pendingManagers } = this;
                pendingManagers[managerKey] || (pendingManagers[managerKey] = []);
                pendingManagers[managerKey].push((methods)=>{
                    clearTimeout(rejectTimeoutId);
                    resolve(methods);
                });
            });
        };
        this.registerManager = (managerKey, methods)=>{
            this.setState((previousState)=>{
                if (methods == null) return {
                    managers: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(previousState.managers, managerKey)
                };
                const managerResolvers = this.pendingManagers[managerKey];
                if (managerResolvers && managerResolvers.length) {
                    managerResolvers.forEach((resolve)=>resolve(methods));
                    managerResolvers.length = 0;
                }
                return {
                    managers: {
                        ...previousState.managers,
                        [managerKey]: Promise.resolve(methods)
                    }
                };
            });
        };
        this.pendingManagers = {};
        this.manager = {
            getManager: this.getManager,
            registerManager: this.registerManager
        };
    }
}
const { Consumer: $786b8f2349f4f371$export$b3bffd4bb7da6b8f } = $786b8f2349f4f371$var$Context;

});
parcelRegister("aptld", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb544ea99791963$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7bb544ea99791963$export$2e2bcd8739ae039 = (name)=>{
    const contextObjName = name || '';
    const defaultGetter = ()=>{
        throw new Error(`The Consumer for ${contextObjName} Context Object does not have a correct value. Maybe, it needs to be wrapped in its corresponding Provider`);
    };
    const Context = /*#__PURE__*/ (0, $eUqFw.createContext)(defaultGetter);
    const ContextConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Context.Consumer, null, (getValue)=>{
            const value = getValue();
            return props.children(value);
        });
    const ContextProvider = ({ value: value, children: children })=>{
        const getValue = ()=>value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Context.Provider, {
            value: getValue
        }, children);
    };
    ContextProvider.displayName = `${contextObjName}SafeProvider`;
    ContextConsumer.displayName = `${contextObjName}SafeConsumer`;
    // @ts-expect-error - TS2741 - Property '$$typeof' is missing in type '{ ({ value, children }: ProviderProps<T>): JSX.Element; displayName: string; }' but required in type 'ProviderExoticComponent<ProviderProps<T>>'. | TS2741 - Property '$$typeof' is missing in type '{ (props: Props<T>): JSX.Element; displayName: string; }' but required in type 'ExoticComponent<ConsumerProps<T>>'.
    return {
        Provider: ContextProvider,
        Consumer: ContextConsumer
    };
};

});

parcelRegister("hIu0M", function(module, exports) {

$parcel$export(module.exports, "fromManagerKey", () => $e9a42c652dd768fc$export$fef172a673b3ef47);
const $e9a42c652dd768fc$export$e6ee4c5f89b06a38 = (managerKey)=>managerKey;
const $e9a42c652dd768fc$export$fef172a673b3ef47 = (managerKey)=>String(managerKey);

});


parcelRegister("jwtcO", function(module, exports) {

$parcel$export(module.exports, "ImperativeAPI", () => $cf3dc24e124a7b2d$export$e2ad0ff52e7f8c84);

var $eUqFw = parcelRequire("eUqFw");

var $ds5Im = parcelRequire("ds5Im");

var $gUUjF = parcelRequire("gUUjF");

var $4u2Iz = parcelRequire("4u2Iz");

var $26xrR = parcelRequire("26xrR");

var $kpmC0 = parcelRequire("kpmC0");

var $2futN = parcelRequire("2futN");

var $hbusP = parcelRequire("hbusP");

var $hIu0M = parcelRequire("hIu0M");

var $lB25E = parcelRequire("lB25E");

var $3mRDR = parcelRequire("3mRDR");
const $cf3dc24e124a7b2d$var$ERROR_LOCATION = 'legacy.imperative-api';
const $cf3dc24e124a7b2d$export$e2ad0ff52e7f8c84 = ({ getItemManager: getItemManager })=>{
    const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $kpmC0.useLeftSidebarController)();
    const { refresh: refresh } = (0, $2futN.useProjectSidebarNavigation)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const sidebarState = (0, $kpmC0.useLeftSidebarState)();
    const sidebarRef = (0, $eUqFw.useRef)(sidebarState);
    const refreshSidebarRef = (0, $eUqFw.useRef)(refresh);
    const imperativeAPIRef = (0, $eUqFw.useRef)({
        viewIds: $3mRDR.viewIds,
        itemIds: $3mRDR.itemIds,
        expand: expandLeftSidebar,
        collapse: collapseLeftSidebar,
        isCollapsed: ()=>sidebarRef.current.isCollapsed,
        onCollapse: ()=>undefined,
        onCollapseStart: ()=>undefined,
        onCollapseEnd: ()=>undefined,
        onExpand: ()=>undefined,
        onExpandStart: ()=>undefined,
        onExpandEnd: ()=>undefined,
        onItemClick: ()=>undefined,
        setView: ()=>undefined,
        updateActiveView: ()=>undefined,
        setProjectRootView: ()=>undefined,
        getActiveViewItems: ()=>[],
        isInProjectContext: ()=>false,
        updateContext: ()=>undefined,
        updateData: ()=>{
            refreshSidebarRef.current();
        },
        getItemManager: (itemManagerKey)=>getItemManager(itemManagerKey).catch((e)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData($cf3dc24e124a7b2d$var$ERROR_LOCATION, `There was a problem getting "${(0, $hIu0M.fromManagerKey)(itemManagerKey)}" item manager`, e);
                throw e;
            }),
        createBoard: ()=>{
            (0, $26xrR.default)();
        },
        modalOpen: ()=>undefined,
        modalClose: ()=>undefined,
        navigate: (url)=>push(url)
    });
    sidebarRef.current = sidebarState;
    refreshSidebarRef.current = refresh;
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $ds5Im.loadBridgeWeak)({
            name: 'jira/navigation/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(imperativeAPIRef.current);
        });
        (0, $4u2Iz.provideNavigationApi)({
            navigate: push
        });
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hbusP.NavigationUIContainer), {
        isGlobal: true
    });
};

});
parcelRegister("ds5Im", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $1b3123f198513ce0$export$3cefda82396756a1);

var $1gau4 = parcelRequire("1gau4");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $1b3123f198513ce0$var$pollingSingleton = null;
const $1b3123f198513ce0$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $1b3123f198513ce0$var$pollingSingleton ?? (0, $1gau4.createPollingCollection)((v)=>window.require(v), 100);
    $1b3123f198513ce0$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("1gau4", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $9f3ee0cd5dcb553b$export$f163446a982a8077);

var $asu8X = parcelRequire("asu8X");

var $eFUPR = parcelRequire("eFUPR");
const $9f3ee0cd5dcb553b$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $asu8X.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $eFUPR.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $eFUPR.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("eFUPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bee8fab77b1b942$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $8bee8fab77b1b942$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $8bee8fab77b1b942$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $8bee8fab77b1b942$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});



parcelRegister("4u2Iz", function(module, exports) {

$parcel$export(module.exports, "provideNavigationApi", () => $c85bf289a3ab5991$export$26d28e8849b2805f);
$parcel$export(module.exports, "isInIframe", () => $c85bf289a3ab5991$export$9f140ed41af5108c);
$parcel$export(module.exports, "canSpaTransition", () => $c85bf289a3ab5991$export$59e771495885068f);
$parcel$export(module.exports, "getContainerApi", () => $c85bf289a3ab5991$export$91ed870fd8df2bcb);
$parcel$export(module.exports, "getNavigationApi", () => $c85bf289a3ab5991$export$da4e5a44286a0dd0);
// Old AMD key: `ac/spa-context`
// TODO: we will improve the type later when we know the code better.
let $c85bf289a3ab5991$var$containerApi = null;
let $c85bf289a3ab5991$var$navigationApi = null;
const $c85bf289a3ab5991$export$3927fb5df700a968 = (api)=>{
    $c85bf289a3ab5991$var$containerApi = api;
};
const $c85bf289a3ab5991$export$26d28e8849b2805f = (api)=>{
    $c85bf289a3ab5991$var$navigationApi = api;
};
const $c85bf289a3ab5991$export$9f140ed41af5108c = ()=>$c85bf289a3ab5991$var$containerApi !== null;
const $c85bf289a3ab5991$export$59e771495885068f = ()=>$c85bf289a3ab5991$var$navigationApi !== null;
const $c85bf289a3ab5991$export$91ed870fd8df2bcb = ()=>$c85bf289a3ab5991$var$containerApi;
const $c85bf289a3ab5991$export$da4e5a44286a0dd0 = ()=>$c85bf289a3ab5991$var$navigationApi;
const $c85bf289a3ab5991$export$6ba42130b045ede1 = ()=>{
    $c85bf289a3ab5991$var$containerApi = null;
    $c85bf289a3ab5991$var$navigationApi = null;
};

});

parcelRegister("26xrR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a46b7497e8a8ccc2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
const $a46b7497e8a8ccc2$var$amdModuleName = 'jira-agile/sidebar/create-board-adg3';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a46b7497e8a8ccc2$export$2e2bcd8739ae039 = async ()=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    const module = await (0, $2BvS3.loadBridge)({
        name: $a46b7497e8a8ccc2$var$amdModuleName
    });
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return module.openCreateBoardModal();
};

});
parcelRegister("2BvS3", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $95487c8e7b3a155f$export$df8409da353bde5a);
$parcel$export(module.exports, "loadBridgeStrict", () => (parcelRequire("2TjwK")).loadBridgeStrict);

var $2m1eH = parcelRequire("2m1eH");
var $9kx8M = parcelRequire("9kx8M");
var $e1Ms3 = parcelRequire("e1Ms3");
var $2TjwK = parcelRequire("2TjwK");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");
var $beITa = parcelRequire("beITa");
var $dPoeR = parcelRequire("dPoeR");
const $95487c8e7b3a155f$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $2m1eH.MAX_RETRIES), timeout: timeout = (0, $2m1eH.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $2TjwK.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $9kx8M.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $e1Ms3.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("2m1eH", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $b8b11bd252d35c6e$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $b8b11bd252d35c6e$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $b8b11bd252d35c6e$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $b8b11bd252d35c6e$export$37f20f0ff732fcd7);

var $gUUjF = parcelRequire("gUUjF");
const { safeErrorWithoutCustomerData: $b8b11bd252d35c6e$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $b8b11bd252d35c6e$export$ea810ce67e3c8eac } = (0, $gUUjF.default);
const $b8b11bd252d35c6e$export$1f86472c1374185a = 40;
const $b8b11bd252d35c6e$export$7bd623b29ec8e1eb = 500;
const $b8b11bd252d35c6e$export$37f20f0ff732fcd7 = true;

});

parcelRegister("9kx8M", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $91c93182e2e49d7f$export$a036f92c2465504e);

var $a0ZIR = parcelRequire("a0ZIR");

var $2m1eH = parcelRequire("2m1eH");
const $91c93182e2e49d7f$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $2m1eH.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $a0ZIR.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $a0ZIR.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("a0ZIR", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $6efa0e8ff5a3a43a$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6efa0e8ff5a3a43a$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("e1Ms3", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $7f4fa2d1428c50fa$export$20c32b4579d78b92);

var $9kx8M = parcelRequire("9kx8M");

var $ds5Im = parcelRequire("ds5Im");

var $2m1eH = parcelRequire("2m1eH");
const $7f4fa2d1428c50fa$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $2m1eH.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $ds5Im.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $9kx8M.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});

parcelRegister("2TjwK", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $b1e39bbe8c29913e$export$eba600d28decc4ac);

var $7ho7Q = parcelRequire("7ho7Q");

var $e1Ms3 = parcelRequire("e1Ms3");

var $99I0s = parcelRequire("99I0s");

var $2m1eH = parcelRequire("2m1eH");
const $b1e39bbe8c29913e$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR) })=>{
    (0, $7ho7Q.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $99I0s.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $e1Ms3.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("7ho7Q", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $4597ad555104d20c$export$9ea3ff7978093559);
const $4597ad555104d20c$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $4597ad555104d20c$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $4597ad555104d20c$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $4597ad555104d20c$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $4597ad555104d20c$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $4597ad555104d20c$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $4597ad555104d20c$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $4597ad555104d20c$var$initStats();
        // stop accumulating stats at TTI mark
        if ($4597ad555104d20c$var$isPageInteractive()) return;
        stats.requests += 1;
        $4597ad555104d20c$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$4597ad555104d20c$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $4597ad555104d20c$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("99I0s", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $ddc8a5e8a3946ea4$export$6cda16b6eff75f59);

var $a0ZIR = parcelRequire("a0ZIR");

var $6uXwV = parcelRequire("6uXwV");

var $ds5Im = parcelRequire("ds5Im");

var $2m1eH = parcelRequire("2m1eH");
const $ddc8a5e8a3946ea4$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $ds5Im.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $6uXwV.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $2m1eH.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $a0ZIR.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("6uXwV", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $94847501863943b7$export$93d9db5fbabad1b0);

var $8loyD = parcelRequire("8loyD");
let $94847501863943b7$var$isSuperBatchDependenciesLoaded = false;
const $94847501863943b7$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $94847501863943b7$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($94847501863943b7$var$isSuperBatchDependenciesLoaded || $94847501863943b7$var$isOnRapidBoardsPage()) return wrmKeys;
    $94847501863943b7$var$isSuperBatchDependenciesLoaded = true;
    return (0, $8loyD.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("8loyD", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $1708e80b7caf4372$export$f14a6b583ce9e077);
const $1708e80b7caf4372$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("4DtuZ", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $c6610675329f7ce1$export$c61060338d026f78);

var $eFUPR = parcelRequire("eFUPR");
const $c6610675329f7ce1$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WAIT_FOR_HERITAGE__ = new (0, $eFUPR.default)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});

parcelRegister("beITa", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $fc3a6026d4692cae$export$cc9d8f51375ef66a);

var $99I0s = parcelRequire("99I0s");

var $2m1eH = parcelRequire("2m1eH");
const $fc3a6026d4692cae$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR))=>(0, $99I0s.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("dPoeR", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $6e9ac89e6d17a22d$export$e53a5db19a39ed2f);

var $99I0s = parcelRequire("99I0s");

var $2m1eH = parcelRequire("2m1eH");
const $6e9ac89e6d17a22d$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR))=>(0, $99I0s.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});



parcelRegister("2futN", function(module, exports) {

$parcel$export(module.exports, "useProjectSidebarNavigation", () => $e6824b09c7b48982$export$5a85006c180fb373);
$parcel$export(module.exports, "useProjectSidebarConnectNavigation", () => $e6824b09c7b48982$export$2bed15cd7d167db5);
$parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", () => $e6824b09c7b48982$export$a9d05fc2c1d94895);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", () => $e6824b09c7b48982$export$d48e3c3556894533);
$parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", () => $e6824b09c7b48982$export$24a781cd863077aa);
$parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", () => $e6824b09c7b48982$export$e16ecd2512eb0dc7);
$parcel$export(module.exports, "useJiraSoftwareProjectNavigation", () => $e6824b09c7b48982$export$68dc0ecbea8211d2);
$parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", () => $e6824b09c7b48982$export$5cf90b625d0e1248);
$parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", () => $e6824b09c7b48982$export$d63d92edebe543d9);

var $eUqFw = parcelRequire("eUqFw");

var $7wRIc = parcelRequire("7wRIc");

var $cbmC6 = parcelRequire("cbmC6");

var $kKeF6 = parcelRequire("kKeF6");

var $iivTa = parcelRequire("iivTa");

var $kXWpU = parcelRequire("kXWpU");

var $iZJHG = parcelRequire("iZJHG");

var $lB25E = parcelRequire("lB25E");

var $cLNfQ = parcelRequire("cLNfQ");
const $e6824b09c7b48982$export$5a85006c180fb373 = (customContext)=>{
    const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $kXWpU.staticProjectSidebarNavigationResource), customContext);
    const memoizedResponse = (0, $eUqFw.useMemo)(()=>navResponse, [
        navResponse
    ]);
    (0, $cLNfQ.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
    return {
        data: memoizedResponse,
        loading: memoizedResponse != null ? false : loading,
        refresh: refresh,
        clearAll: clearAll,
        error: error,
        ...rest
    };
};
const $e6824b09c7b48982$export$2bed15cd7d167db5 = ()=>(0, $lB25E.useResource)((0, $cbmC6.staticProjectSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$a9d05fc2c1d94895 = ()=>(0, $lB25E.useResource)((0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$d48e3c3556894533 = ()=>(0, $lB25E.useResource)((0, $iivTa.staticProjectSettingsSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$24a781cd863077aa = ()=>(0, $lB25E.useResource)((0, $7wRIc.staticJSMProjectConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$e16ecd2512eb0dc7 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraWorkManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$68dc0ecbea8211d2 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraSoftwareNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$5cf90b625d0e1248 = (customContext)=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373(customContext);
    const response = data?.jiraServiceManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$d63d92edebe543d9 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraProductDiscoveryNavData || null;
    return {
        data: response,
        ...rest
    };
};

});
parcelRegister("7wRIc", function(module, exports) {

$parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", () => $1da568058e8dfab8$export$fab84295e18e9246);

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $76v64 = parcelRequire("76v64");
const $1da568058e8dfab8$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $1da568058e8dfab8$export$fab84295e18e9246 = (0, $lB25E.createResource)({
    type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
    getKey: ({ match: match, query: query })=>$1da568058e8dfab8$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $1da568058e8dfab8$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
        return navInfo;
    },
    maxAge: 300000
});

});
parcelRegister("76v64", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", () => $c603d0485f5d33bd$export$b15f9f5cf6db359e);

var $lRmyA = parcelRequire("lRmyA");
const $c603d0485f5d33bd$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
    if (projectKeyOrId == null) throw new Error('invalid identifier specified');
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
};

});


parcelRegister("cbmC6", function(module, exports) {

$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", () => $9d72696b0f8eb1a8$export$b8c6e2666f12f4bb);

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $76v64 = parcelRequire("76v64");
const $9d72696b0f8eb1a8$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $9d72696b0f8eb1a8$export$b8c6e2666f12f4bb = (0, $lB25E.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$9d72696b0f8eb1a8$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $9d72696b0f8eb1a8$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const projectHomeAddonNavInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
        return projectHomeAddonNavInfo;
    },
    maxAge: 300000
});

});

parcelRegister("kKeF6", function(module, exports) {

$parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", () => $5a0ad956b22e7be5$export$b662f3f877add30d);

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $76v64 = parcelRequire("76v64");
const $5a0ad956b22e7be5$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $5a0ad956b22e7be5$export$b662f3f877add30d = (0, $lB25E.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$5a0ad956b22e7be5$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $5a0ad956b22e7be5$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("iivTa", function(module, exports) {

$parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", () => $a5660a56dfe8a855$export$e4bf33528101348c);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", () => $a5660a56dfe8a855$export$2d5a704ae6f6b050);

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $76v64 = parcelRequire("76v64");
const $a5660a56dfe8a855$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $a5660a56dfe8a855$export$e4bf33528101348c = (0, $lB25E.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$a5660a56dfe8a855$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $a5660a56dfe8a855$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
        return navInfo;
    },
    maxAge: 300000
});
const $a5660a56dfe8a855$export$2d5a704ae6f6b050 = ()=>(0, $lB25E.useResource)($a5660a56dfe8a855$export$e4bf33528101348c);

});

parcelRegister("kXWpU", function(module, exports) {

$parcel$export(module.exports, "getIdentifier", () => $4181ab9f0d3720b7$export$adb27ddab077e944);
$parcel$export(module.exports, "staticProjectSidebarNavigationResource", () => $4181ab9f0d3720b7$export$f2dfc0f7b2d92691);
$parcel$export(module.exports, "useSidebarNavigationResource", () => $4181ab9f0d3720b7$export$b692cfadccf4e047);

var $exb0h = parcelRequire("exb0h");

var $kdp9J = parcelRequire("kdp9J");

var $ElVpH = parcelRequire("ElVpH");

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $LWmvk = parcelRequire("LWmvk");
const $4181ab9f0d3720b7$export$adb27ddab077e944 = (routeName, match, query)=>{
    /**
	 * `boardId` as an identifier should not be returned for JSM boards route,
	 * skip boards on `SERVICEDESK_BOARDS` or `SERVICEDESK_CALENDAR` route.
	 */ if (routeName === (0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS) || routeName === (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR) || query['servicedesk.serviceDeskId']) {
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return (0, $kdp9J.getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
    }
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    const boardId = (0, $ElVpH.getBoardId)(match, query);
    return (0, $kdp9J.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
};
const $4181ab9f0d3720b7$var$getRouterKey = (routeName, match, query)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = $4181ab9f0d3720b7$export$adb27ddab077e944(routeName, match, query);
    // Next-Gen software projects contain only one board. Hence, using the project key itself
    if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
    return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
};
const $4181ab9f0d3720b7$export$f2dfc0f7b2d92691 = (0, $lB25E.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
    getKey: ({ match: match, query: query, route: { name: name } })=>$4181ab9f0d3720b7$var$getRouterKey(name, match, query),
    /**
	 * is called on resource's init fetch, or .refresh()
	 */ getData: async ({ match: match, query: query, route: { name: name } })=>{
        const scopeIdentifier = $4181ab9f0d3720b7$export$adb27ddab077e944(name, match, query);
        if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
        const navInfo = await (0, $LWmvk.fetchProjectSidebarNavInfo)(scopeIdentifier);
        return navInfo;
    },
    maxAge: 300000
});
const $4181ab9f0d3720b7$export$b692cfadccf4e047 = ()=>(0, $lB25E.useResource)($4181ab9f0d3720b7$export$f2dfc0f7b2d92691);

});
parcelRegister("kdp9J", function(module, exports) {

$parcel$export(module.exports, "getScopeIdentifier", () => $004bd39330a8812e$export$68278f7cf66944f9);

const $004bd39330a8812e$export$68278f7cf66944f9 = (scope)=>{
    // We check for identifiers in order of specificity first. A board ID is more specific than a project key and so on
    const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
    let identifierType = null;
    if (scope.boardId) identifierType = (0, $718a877cd35f74b2$export$929d50f83189406c);
    else if (scope.projectKey) identifierType = (0, $718a877cd35f74b2$export$b5a308a17bc991f3);
    else if (scope.projectId) identifierType = (0, $718a877cd35f74b2$export$da6f46390e1a426f);
    return {
        identifierValue: identifierValue,
        identifierType: identifierType
    };
};

});
const $718a877cd35f74b2$export$b5a308a17bc991f3 = 'projectKey';
const $718a877cd35f74b2$export$929d50f83189406c = 'boardId';
const $718a877cd35f74b2$export$da6f46390e1a426f = 'projectId';


parcelRegister("ElVpH", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $478ce79be34a38cd$export$557c2f222778cea6);
const $478ce79be34a38cd$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];

});

parcelRegister("LWmvk", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarNavInfo", () => $586cfcaef75ec717$export$8a51470472777e11);

var $lRmyA = parcelRequire("lRmyA");
const $586cfcaef75ec717$export$8a51470472777e11 = (scopeIdentifier)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
    if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
    let queryParam = '';
    switch(identifierType){
        case 'boardId':
            queryParam = `boardId=${identifierValue}`;
            break;
        case 'projectKey':
        case 'projectId':
            queryParam = `projectIdOrKey=${identifierValue}`;
            break;
        default:
            break;
    }
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
};

});


parcelRegister("cLNfQ", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", () => $1154a45446083a64$export$780174995da89d60);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $kXWpU = parcelRequire("kXWpU");

var $lB25E = parcelRequire("lB25E");
const $1154a45446083a64$export$90dbde7e33e6e21 = ()=>null;
const $1154a45446083a64$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $lB25E.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/:projectKey/dummyroute',
        component: $1154a45446083a64$export$90dbde7e33e6e21
    }, {
        params: {
            projectKey: projectKey
        }
    }) : undefined;
const $1154a45446083a64$export$19001bab9e4b7f8f = (projectKey)=>{
    const { data: data, update: update } = (0, $lB25E.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource), {
        routerContext: $1154a45446083a64$export$d647718555c2fdd8(projectKey)
    });
    return {
        data: data,
        update: update
    };
};
const $1154a45446083a64$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $lB25E.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
        component: $1154a45446083a64$export$90dbde7e33e6e21
    }, {
        params: {
            boardId: `${boardId}`
        }
    }) : undefined;
const $1154a45446083a64$export$e2bb7877e6cec3eb = (boardId)=>{
    const { data: data, update: update } = (0, $lB25E.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource), {
        routerContext: $1154a45446083a64$export$23dc6491016cabdc(boardId)
    });
    return {
        data: data,
        update: update
    };
};
const $1154a45446083a64$export$780174995da89d60 = (latestNavInfo)=>{
    const [{ match: match, query: query, route: { name: name } }] = (0, $lB25E.useRouter)();
    const isOnBoardBasedRoute = (0, $kXWpU.getIdentifier)(name, match, query)?.identifierType === 'boardId';
    const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
    const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
    const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
    // explicitly get project data by forcing key to be project
    const { data: projectRouteNavInfo, update: updateProjectRoute } = $1154a45446083a64$export$19001bab9e4b7f8f(pKey);
    // explicitly get board data by forcing key to be board
    const { data: boardRouteNavInfo, update: updateBoardRoute } = $1154a45446083a64$export$e2bb7877e6cec3eb(boardId);
    // if software CMP project or board data is not in sync, then force update
    (0, $eUqFw.useEffect)(()=>{
        if (latestNavInfo != null && isSoftwareCMP) {
            if (isOnBoardBasedRoute && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
        }
    }, [
        isOnBoardBasedRoute,
        latestNavInfo,
        updateProjectRoute,
        updateBoardRoute,
        projectRouteNavInfo,
        boardRouteNavInfo,
        isSoftwareCMP
    ]);
};

});


parcelRegister("hbusP", function(module, exports) {

$parcel$export(module.exports, "NavigationUISubscriber", () => $5256aede416e5446$export$d3dc1c18cfde5ddd);
$parcel$export(module.exports, "NavigationUIContainer", () => $5256aede416e5446$export$339ec9ca159ad81f);

var $WBLbN = parcelRequire("WBLbN");

var $9LrYi = parcelRequire("9LrYi");
const $5256aede416e5446$export$d3dc1c18cfde5ddd = (0, $WBLbN.createSubscriber)((0, $9LrYi.default), {
    displayName: 'NavigationUISubscriber',
    selector: null
});
const $5256aede416e5446$export$339ec9ca159ad81f = (0, $WBLbN.createContainer)((0, $9LrYi.default));

});
parcelRegister("9LrYi", function(module, exports) {

$parcel$export(module.exports, "default", () => $073edb176276dfc0$export$2e2bcd8739ae039);

var $WBLbN = parcelRequire("WBLbN");

var $k9kmE = parcelRequire("k9kmE");
const $073edb176276dfc0$var$initialState = {
    collapseStart: new Set(),
    collapseEnd: new Set(),
    expandStart: new Set(),
    expandEnd: new Set()
};
var $073edb176276dfc0$export$2e2bcd8739ae039 = (0, $WBLbN.createStore)({
    name: 'navigation-ui',
    initialState: $073edb176276dfc0$var$initialState,
    actions: $k9kmE.default
});

});
parcelRegister("k9kmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e9459e5329f7e4e$export$2e2bcd8739ae039);

var $kAdm2 = parcelRequire("kAdm2");
var $d4PbU = parcelRequire("d4PbU");
var $85FUs = parcelRequire("85FUs");
var $20oC5 = parcelRequire("20oC5");
const $0e9459e5329f7e4e$var$actions = {
    collapseStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($kAdm2.default('collapseStart', cb)),
    collapseStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($85FUs.default('collapseStart', cb)),
    collapseStartClear: ()=>({ dispatch: dispatch })=>dispatch($d4PbU.default('collapseStart')),
    collapseStartRun: ()=>({ dispatch: dispatch })=>dispatch($20oC5.default('collapseStart')),
    collapseEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($kAdm2.default('collapseEnd', cb)),
    collapseEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($85FUs.default('collapseEnd', cb)),
    collapseEndClear: ()=>({ dispatch: dispatch })=>dispatch($d4PbU.default('collapseEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    collapseEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($20oC5.default('collapseEnd', cb)),
    expandStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($kAdm2.default('expandStart', cb)),
    expandStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($85FUs.default('expandStart', cb)),
    expandStartClear: ()=>({ dispatch: dispatch })=>dispatch($d4PbU.default('expandStart')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandStartRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($20oC5.default('expandStart', cb)),
    expandEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($kAdm2.default('expandEnd', cb)),
    expandEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($85FUs.default('expandEnd', cb)),
    expandEndClear: ()=>({ dispatch: dispatch })=>dispatch($d4PbU.default('expandEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($20oC5.default('expandEnd', cb)),
    clearAll: ()=>({ dispatch: dispatch })=>{
            dispatch($0e9459e5329f7e4e$var$actions.collapseStartClear());
            dispatch($0e9459e5329f7e4e$var$actions.collapseEndClear());
            dispatch($0e9459e5329f7e4e$var$actions.expandStartClear());
            dispatch($0e9459e5329f7e4e$var$actions.expandEndClear());
        }
};
var $0e9459e5329f7e4e$export$2e2bcd8739ae039 = $0e9459e5329f7e4e$var$actions;

});
parcelRegister("kAdm2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae4d62e75c39d6ec$export$2e2bcd8739ae039);

var $85FUs = parcelRequire("85FUs");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ae4d62e75c39d6ec$export$2e2bcd8739ae039 = (key, callback)=>// @ts-expect-error - TS2322 - Type '({ setState, getState, dispatch }: StoreActionApi<T>) => () => void' is not assignable to type 'Action<T, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set(getState()[key]).add(callback)
        });
        return ()=>dispatch((0, $85FUs.default)(key, callback));
    };

});
parcelRegister("85FUs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3b2c6d695815dbd$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3b2c6d695815dbd$export$2e2bcd8739ae039 = (key, callback)=>({ setState: setState, getState: getState })=>{
        if (!getState()[key]) return;
        const slice = new Set(getState()[key]);
        slice.delete(callback);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: slice
        });
    };

});


parcelRegister("d4PbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $912d7a599c33dfa4$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$912d7a599c33dfa4$export$2e2bcd8739ae039 = (key)=>({ setState: setState })=>// @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set()
        });

});

parcelRegister("20oC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c664f49a6b0027bd$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c664f49a6b0027bd$export$2e2bcd8739ae039 = (key, ...args)=>({ getState: getState })=>// @ts-expect-error - TS2339 - Property 'forEach' does not exist on type 'Set<unknown> | T[string]'. | TS7006 - Parameter 'cb' implicitly has an 'any' type.
        (getState()[key] || new Set()).forEach((cb)=>cb(...args));

});




parcelRegister("3mRDR", function(module, exports) {

$parcel$export(module.exports, "itemIds", () => $8615713aedf1e792$export$443ec49e59de3663);
$parcel$export(module.exports, "viewIds", () => $8615713aedf1e792$export$8ee2fd038785d9dc);

var $dYFw9 = parcelRequire("dYFw9");
const $8615713aedf1e792$var$ROOT = 'root/index';
const $8615713aedf1e792$var$ISSUES = 'root/issues';
const $8615713aedf1e792$var$DASHBOARDS = 'root/dashboards';
const $8615713aedf1e792$var$PORTFOLIO = 'root/portfolio';
const $8615713aedf1e792$var$WORK_SCRUM = 'work-scrum';
const $8615713aedf1e792$var$PLAN_SCRUM = 'plan-scrum';
const $8615713aedf1e792$var$WORK_KANBAN = 'work-kanban';
const $8615713aedf1e792$var$PLAN_KANBAN = 'plan-kanban';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES = 'pin-filter-myopenissues';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES = 'pin-filter-reportedbyme';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES = 'pin-filter-allissues';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES = 'pin-filter-allopenissues';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES = 'pin-filter-doneissues';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES = 'pin-filter-recentlyviewed';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES = 'pin-filter-addedrecently';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES = 'pin-filter-resolvedrecently';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES = 'pin-filter-updatedrecently';
const $8615713aedf1e792$var$AGILITY = 'project/agility/index';
const $8615713aedf1e792$var$BUSINESS = 'project/business/index';
const $8615713aedf1e792$var$OPS = 'project/ops/index';
const $8615713aedf1e792$var$SOFTWARE = 'project/software/index';
const $8615713aedf1e792$var$SOFTWARE_ISSUES = 'project/software/issues';
const $8615713aedf1e792$var$SOFTWARE_REPORTS = 'project/software/reports';
const $8615713aedf1e792$var$USER = 'user/index';
const $8615713aedf1e792$var$USER_REPORTS = 'user/reports';
const $8615713aedf1e792$var$rootProjectViewIds = {
    AGILITY: $8615713aedf1e792$var$AGILITY,
    SERVICE_DESK: $dYFw9.SERVICE_DESK,
    OPS: $8615713aedf1e792$var$OPS,
    BUSINESS: $8615713aedf1e792$var$BUSINESS,
    SOFTWARE: $8615713aedf1e792$var$SOFTWARE
};
const $8615713aedf1e792$var$rootViewIds = {
    ROOT: $8615713aedf1e792$var$ROOT,
    ISSUES: $8615713aedf1e792$var$ISSUES,
    DASHBOARDS: $8615713aedf1e792$var$DASHBOARDS,
    PORTFOLIO: $8615713aedf1e792$var$PORTFOLIO
};
const $8615713aedf1e792$export$443ec49e59de3663 = {
    WORK_SCRUM: $8615713aedf1e792$var$WORK_SCRUM,
    PLAN_SCRUM: $8615713aedf1e792$var$PLAN_SCRUM,
    WORK_KANBAN: $8615713aedf1e792$var$WORK_KANBAN,
    PLAN_KANBAN: $8615713aedf1e792$var$PLAN_KANBAN,
    PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES,
    ...(0, $dYFw9.SERVICE_DESK_ITEMS)
};
const $8615713aedf1e792$export$8ee2fd038785d9dc = {
    ...$8615713aedf1e792$var$rootViewIds,
    ...$8615713aedf1e792$var$rootProjectViewIds,
    SOFTWARE_ISSUES: $8615713aedf1e792$var$SOFTWARE_ISSUES,
    SOFTWARE_REPORTS: $8615713aedf1e792$var$SOFTWARE_REPORTS,
    SERVICE_DESK_ISSUES: $dYFw9.SERVICE_DESK_ISSUES,
    SERVICE_DESK_QUEUES: $dYFw9.SERVICE_DESK_QUEUES,
    SERVICE_DESK_REPORTS: $dYFw9.SERVICE_DESK_REPORTS,
    SERVICE_DESK_SETTINGS: $dYFw9.SERVICE_DESK_SETTINGS,
    SERVICE_DESK_LANGUAGES: $dYFw9.SERVICE_DESK_LANGUAGES,
    SERVICE_DESK_LEGACY_TICKET_TYPES: $dYFw9.SERVICE_DESK_LEGACY_TICKET_TYPES,
    SERVICE_DESK_TRANSLATIONS: $dYFw9.SERVICE_DESK_TRANSLATIONS,
    SERVICE_DESK_AUTOMATION_SUB_NAV: $dYFw9.SERVICE_DESK_AUTOMATION_SUB_NAV,
    SERVICE_DESK_KNOWLEDGE_HUB: $dYFw9.SERVICE_DESK_KNOWLEDGE_HUB,
    USER: $8615713aedf1e792$var$USER,
    USER_REPORTS: $8615713aedf1e792$var$USER_REPORTS
};

});
parcelRegister("dYFw9", function(module, exports) {

$parcel$export(module.exports, "REPORTS_IDS", () => $890d2e79149b5a80$export$1f70a76cb421b107);
$parcel$export(module.exports, "HOME_ITEMS_IDS", () => $890d2e79149b5a80$export$9afbea2cbd37e16d);
$parcel$export(module.exports, "SETTINGS_IDS", () => $890d2e79149b5a80$export$5fd6685a693e1064);
$parcel$export(module.exports, "PRACTICES_IDS", () => $890d2e79149b5a80$export$a37f4f7add086a3);
$parcel$export(module.exports, "SERVICE_DESK_ITEMS", () => $890d2e79149b5a80$export$2108a7f32cd0bb12);
$parcel$export(module.exports, "REQUEST_TYPE_PRACTICE_NAV_ONBOARDING", () => $890d2e79149b5a80$export$712b4b205a2bcf1e);
$parcel$export(module.exports, "TEAM_PRIORITY_QUEUE_ADMIN_SPOTLIGHT", () => $890d2e79149b5a80$export$aaffd3035e9d6c2d);
$parcel$export(module.exports, "STARRED_QUEUE_SPOTLIGHT", () => $890d2e79149b5a80$export$e2d46b728fe0a15a);
$parcel$export(module.exports, "SERVICE_DESK", () => $890d2e79149b5a80$export$c8c1c8c3f8ddba61);
$parcel$export(module.exports, "SERVICE_DESK_ISSUES", () => $890d2e79149b5a80$export$51fa1147c138a6ed);
$parcel$export(module.exports, "SERVICE_DESK_QUEUES", () => $890d2e79149b5a80$export$456b3cfbf5e37bd8);
$parcel$export(module.exports, "SERVICE_DESK_KNOWLEDGE_HUB", () => $890d2e79149b5a80$export$9ccc8d85b210b219);
$parcel$export(module.exports, "SERVICE_DESK_REPORTS", () => $890d2e79149b5a80$export$707771f2f7e60575);
$parcel$export(module.exports, "SERVICE_DESK_SETTINGS", () => $890d2e79149b5a80$export$a87fc635598d2d50);
$parcel$export(module.exports, "SERVICE_DESK_LEGACY_TICKET_TYPES", () => $890d2e79149b5a80$export$b6bda26b77269209);
$parcel$export(module.exports, "SERVICE_DESK_LANGUAGES", () => $890d2e79149b5a80$export$776199f9e99c88e2);
$parcel$export(module.exports, "SERVICE_DESK_TRANSLATIONS", () => $890d2e79149b5a80$export$d70ba5c124463035);
$parcel$export(module.exports, "SERVICE_DESK_AUTOMATION_SUB_NAV", () => $890d2e79149b5a80$export$9a6deaa9c1af559f);
const $890d2e79149b5a80$var$HOME_QUEUES = 'queues';
const $890d2e79149b5a80$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT = 'all-itsm-queues-spotlight';
const $890d2e79149b5a80$var$HOME_ALL_TICKETS_SPOTLIGHT = 'all-tickets-spotlight';
const $890d2e79149b5a80$var$HOME_TICKET_CATEGORIES_SPOTLIGHT = 'ticket-categories-spotlight';
const $890d2e79149b5a80$var$HOME_SERVICE_REQUESTS = 'service-requests';
const $890d2e79149b5a80$var$HOME_INCIDENTS = 'incidents';
const $890d2e79149b5a80$var$HOME_CHANGES = 'changes';
const $890d2e79149b5a80$var$HOME_PROBLEMS = 'problems';
const $890d2e79149b5a80$var$HOME_POST_INCIDENT_REVIEWS = 'post-incident-reviews';
const $890d2e79149b5a80$var$HOME_CUSTOMERS = 'customers';
const $890d2e79149b5a80$var$HOME_REPORTS = 'reports';
const $890d2e79149b5a80$var$HOME_RAISE_REQUEST = 'raise-request';
const $890d2e79149b5a80$var$HOME_ISSUES = 'issues';
const $890d2e79149b5a80$var$HOME_CUSTOMER_CHANNELS = 'customer-channels';
const $890d2e79149b5a80$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT = 'customer-channels-spotlight';
const $890d2e79149b5a80$var$HOME_JSD_CHANNELS_DIALOG = 'jsd-channels-dialog';
const $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE = 'knowledge-base';
const $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE_HUB = 'knowledge-hub';
const $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE_HUB_NESTED = 'knowledge-hub-nested';
const $890d2e79149b5a80$var$HOME_INVITE_TEAM = 'invite-team';
const $890d2e79149b5a80$var$HOME_GIVE_FEEDBACK = 'give-feedback';
const $890d2e79149b5a80$var$HOME_SERVICES = 'services';
const $890d2e79149b5a80$var$HOME_SERVICES_SPOTLIGHT = 'services-spotlight';
const $890d2e79149b5a80$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT = 'alerts-and-on-call-spotlight';
const $890d2e79149b5a80$var$HOME_CHANGE_CALENDAR_SPOTLIGHT = 'change-calendar-spotlight';
const $890d2e79149b5a80$export$1f70a76cb421b107 = {
    REPORTS_CUSTOM: 'sd-reports-custom',
    REPORTS_ADDONS: 'sd-reports-addons',
    REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions',
    REPORTS_NAV_TEAM: 'sd-reports-nav-team',
    REPORTS_NAV_KB: 'sd-reports-nav-kb'
};
const $890d2e79149b5a80$export$9afbea2cbd37e16d = {
    QUEUES: $890d2e79149b5a80$var$HOME_QUEUES,
    ALL_ITSM_QUEUES_SPOTLIGHT: $890d2e79149b5a80$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT,
    ALL_TICKETS_SPOTLIGHT: $890d2e79149b5a80$var$HOME_ALL_TICKETS_SPOTLIGHT,
    TICKET_CATEGORIES_SPOTLIGHT: $890d2e79149b5a80$var$HOME_TICKET_CATEGORIES_SPOTLIGHT,
    SERVICE_REQUEST: $890d2e79149b5a80$var$HOME_SERVICE_REQUESTS,
    INCIDENTS: $890d2e79149b5a80$var$HOME_INCIDENTS,
    CHANGES: $890d2e79149b5a80$var$HOME_CHANGES,
    PROBLEMS: $890d2e79149b5a80$var$HOME_PROBLEMS,
    CUSTOMERS: $890d2e79149b5a80$var$HOME_CUSTOMERS,
    POST_INCIDENT_REVIEWS: $890d2e79149b5a80$var$HOME_POST_INCIDENT_REVIEWS,
    REPORTS: $890d2e79149b5a80$var$HOME_REPORTS,
    RAISE_REQUEST: $890d2e79149b5a80$var$HOME_RAISE_REQUEST,
    ISSUES: $890d2e79149b5a80$var$HOME_ISSUES,
    CUSTOMER_CHANNELS: $890d2e79149b5a80$var$HOME_CUSTOMER_CHANNELS,
    CUSTOMER_CHANNELS_SPOTLIGHT: $890d2e79149b5a80$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT,
    JSD_CHANNELS_DIALOG: $890d2e79149b5a80$var$HOME_JSD_CHANNELS_DIALOG,
    KNOWLEDGE_BASE: $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE,
    KNOWLEDGE_BASE_HUB: $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE_HUB,
    KNOWLEDGE_BASE_HUB_NESTED: $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE_HUB_NESTED,
    INVITE_TEAM: $890d2e79149b5a80$var$HOME_INVITE_TEAM,
    GIVE_FEEDBACK: $890d2e79149b5a80$var$HOME_GIVE_FEEDBACK,
    SERVICES: $890d2e79149b5a80$var$HOME_SERVICES,
    SERVICES_SPOTLIGHT: $890d2e79149b5a80$var$HOME_SERVICES_SPOTLIGHT,
    ALERTS_AND_ON_CALL_SPOTLIGHT: $890d2e79149b5a80$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT,
    CHANGE_CALENDAR_SPOTLIGHT: $890d2e79149b5a80$var$HOME_CHANGE_CALENDAR_SPOTLIGHT
};
const $890d2e79149b5a80$export$304aefafb7155b23 = {
    TOP_ACTIONS: 'knowledge-hub-top-actions',
    ALL_ARTICLES: 'knowledge-hub-all-articles',
    CATEGORIES: 'knowledge-hub-categories',
    CATEGORIES_CONTEXT: 'knowledge-hub-categories-context',
    BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions',
    ADD_CATEGORY: 'knowledge-hub-new-category',
    LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback'
};
const $890d2e79149b5a80$export$5fd6685a693e1064 = {
    DETAILS: 'details',
    PEOPLE: 'people',
    ITSM_FEATURES: 'itsm-features',
    SUMMARY: 'summary',
    DELETE_PROJECT: 'delete-project',
    ISSUE_TYPES: 'issue-types',
    FEATURES: 'features',
    REQUEST_TYPES: 'sd-request-types',
    TICKET_TYPES: 'sd-ticket-types',
    CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
    LANGUAGE_SUPPORT: 'sd-language-support',
    PORTAL_SETTINGS: 'sd-portal-settings',
    EMAIL_REQUESTS: 'sd-email-requests',
    CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
    PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
    PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
    PROJECT_ASSETS_AD: 'sd-project-assets-ad',
    SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
    KNOWLEDGE_BASE: 'sd-knowledge-base',
    SLAS: 'sd-slas',
    AUTOMATION: 'sd-automation',
    PLAYBOOKS: 'playbooks',
    JIRA_AUTOMATION: 'jira-automation',
    AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
    JSD_APP_DISCOVERY: 'sd-app-discovery',
    JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
    JSD_CHANGE_MANAGEMENT: 'sd-change-management',
    WORKFLOWS: 'workflows',
    SCREENS: 'screens',
    FIELDS: 'fields',
    VERSIONS: 'versions',
    COMPONENTS: 'components',
    PERMISSIONS: 'permissions',
    ISSUE_SECURITY: 'issue-security',
    NOTIFICATIONS: 'notifications',
    HIPCHAT: 'hipchat',
    ISSUE_COLLECTORS: 'issue-collectors'
};
const $890d2e79149b5a80$export$50b1b8fc419aca98 = {
    QUEUE_NEW: 'queue-new',
    QUEUE_MANAGE: 'queue-manage',
    QUEUES_ADDONS: 'sd-queues-addons',
    QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions',
    SD_QUEUES_CUSTOM: 'sd-queues-custom'
};
const $890d2e79149b5a80$export$a37f4f7add086a3 = {
    ADDITIONAL_ITEMS: 'sd-practices-additional-items',
    CHANGES_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-changes-queue-title-spotlight',
    CHANGES_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-changes-queue-items-spotlight',
    INCIDENTS_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-incidents-queue-title-spotlight',
    INCIDENTS_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-incidents-queue-items-spotlight'
};
const $890d2e79149b5a80$export$2108a7f32cd0bb12 = {
    SERVICE_DESK: {
        HOME: $890d2e79149b5a80$export$9afbea2cbd37e16d,
        KNOWLEDGE_BASE: $890d2e79149b5a80$export$304aefafb7155b23,
        SETTINGS: $890d2e79149b5a80$export$5fd6685a693e1064,
        QUEUES: $890d2e79149b5a80$export$50b1b8fc419aca98,
        REPORTS: $890d2e79149b5a80$export$1f70a76cb421b107
    }
};
const $890d2e79149b5a80$export$712b4b205a2bcf1e = {
    PRACTICE_NAV_SPOTLIGHT: 'request-type-practice-nav-spotlight',
    UNASSIGNED_NAV_SPOTLIGHT: 'request-type-unassgined-nav-spotlight'
};
const $890d2e79149b5a80$export$aaffd3035e9d6c2d = 'jsm-team-priority-queue-admin-onboarding';
const $890d2e79149b5a80$export$e2d46b728fe0a15a = 'jsm-team-starred-onboarding';
const $890d2e79149b5a80$export$c8c1c8c3f8ddba61 = 'project/service-desk/index';
const $890d2e79149b5a80$export$51fa1147c138a6ed = 'project/service-desk/issues';
const $890d2e79149b5a80$export$456b3cfbf5e37bd8 = 'project/service-desk/queues';
const $890d2e79149b5a80$export$9ccc8d85b210b219 = 'project/service-desk/knowledge-hub';
const $890d2e79149b5a80$export$707771f2f7e60575 = 'project/service-desk/reports';
const $890d2e79149b5a80$export$a87fc635598d2d50 = 'project/service-desk/settings';
const $890d2e79149b5a80$export$b6bda26b77269209 = 'project/service-desk/legacy-ticket-types';
const $890d2e79149b5a80$export$776199f9e99c88e2 = 'project/service-desk/languages';
const $890d2e79149b5a80$export$d70ba5c124463035 = 'project/service-desk/translations';
const $890d2e79149b5a80$export$9a6deaa9c1af559f = 'project/service-desk/settings/automation-sub-nav';

});




parcelRegister("3eqbP", function(module, exports) {

$parcel$export(module.exports, "AsyncLockScreenExperimentSharedWrapper", () => $cc6580f6fb3ff169$export$129bdc881130bc9);

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $aR8n6 = parcelRequire("aR8n6");

var $6VZoe = parcelRequire("6VZoe");


const $cc6580f6fb3ff169$var$AsyncLockScreenExperimentShared = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("eAemQ")).then(({ LockScreenExperimentShared: LockScreenExperimentShared })=>LockScreenExperimentShared), {
    moduleId: "./src/packages/growth/end-of-trial/lock-screen-experiment-shared/src/index.tsx"
});
const $cc6580f6fb3ff169$export$129bdc881130bc9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "lock-screen-experiment-shared-async",
        packageName: (0, $a733f78220833320$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        teamName: (0, $a733f78220833320$export$d57b6b390e78d90f),
        id: "lock-screen-experiment-shared-async",
        packageName: (0, $a733f78220833320$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc6580f6fb3ff169$var$AsyncLockScreenExperimentShared, null)));

});
const $a733f78220833320$export$b8b9d90f9e5bd72b = '@atlassian/jira-lock-screen-experiment-shared';
const $a733f78220833320$export$d57b6b390e78d90f = 'transmuters-growth';

parcelRegister("eAemQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4aVsP").then(()=>parcelRequire('fm5VO'));

});


parcelRegister("gbSuS", function(module, exports) {

$parcel$export(module.exports, "jiraLossAversionModalEntryPoint", () => $d3b21b0cf851a9c6$export$e224c255d72cf9b5);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $d3b21b0cf851a9c6$export$e224c255d72cf9b5 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(async ()=>(parcelRequire("eyEhh")).then(({ JiraLossAversionExperiment: JiraLossAversionExperiment })=>JiraLossAversionExperiment), {
        moduleId: "35d17363"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eyEhh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h1TP1")
]).then(()=>parcelRequire('6wI7U'));

});


parcelRegister("cPEpP", function(module, exports) {

$parcel$export(module.exports, "useProject", () => $681442ce6e3ade0b$export$51b1383ef8844a7);

var $eUqFw = parcelRequire("eUqFw");

var $eWsAG = parcelRequire("eWsAG");

var $2futN = parcelRequire("2futN");
const $681442ce6e3ade0b$export$51b1383ef8844a7 = (customContext)=>{
    const { data: data, loading: loading, error: error } = (0, $2futN.useProjectSidebarNavigation)(customContext);
    const project = (0, $eUqFw.useMemo)(()=>data && (0, $eWsAG.extractData)(data), [
        data
    ]);
    return {
        data: project,
        loading: loading,
        error: error
    };
};

});
parcelRegister("eWsAG", function(module, exports) {

$parcel$export(module.exports, "getStyle", () => $994f1ddfe6829bdc$export$3d2f074408bd1b82);
$parcel$export(module.exports, "extractData", () => $994f1ddfe6829bdc$export$9df5fa0a366163d2);

var $7ZZxN = parcelRequire("7ZZxN");
const $994f1ddfe6829bdc$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, $7ZZxN.ProjectStyle).NEXT_GEN : (0, $7ZZxN.ProjectStyle).CLASSIC;
const $994f1ddfe6829bdc$var$getProject = (project)=>({
        avatarUrl: project.avatarUrls['48x48'],
        id: Number(project.id),
        isSimplified: project.simplified,
        key: project.key,
        name: project.name,
        style: $994f1ddfe6829bdc$export$3d2f074408bd1b82(project.simplified),
        type: project.projectTypeKey
    });
const $994f1ddfe6829bdc$export$9df5fa0a366163d2 = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraWorkManagementNavData.project) : null;
        case 'jira_software':
            return jiraSoftwareNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraSoftwareNavData.project) : null;
        case 'jira_service_management':
        case 'jira_customer_service':
            return jiraServiceManagementNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraServiceManagementNavData.project) : null;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraProductDiscoveryNavData.project) : null;
        case null:
        default:
            return null;
    }
};

});


parcelRegister("i9XZP", function(module, exports) {

$parcel$export(module.exports, "PageDwellAnalyticsListener", () => $f3c89b23479724f1$export$6cf89f098b551dad);

var $eUqFw = parcelRequire("eUqFw");

var $kpmC0 = parcelRequire("kpmC0");

var $10fdS = parcelRequire("10fdS");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bNe1g = parcelRequire("bNe1g");

var $h3mHU = parcelRequire("h3mHU");

var $98uAm = parcelRequire("98uAm");
const $f3c89b23479724f1$var$WAIT_DURATION = 5000;
/**
 * Dispatches AnalyticsEvent for when a user stays on a page for a set period of time
 */ const $f3c89b23479724f1$export$6cf89f098b551dad = ()=>{
    const [hasFired, setHasFired] = (0, $eUqFw.useState)(false);
    const route = (0, $10fdS.useCurrentRoute)();
    const routeName = route.name;
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const isVisible = (0, $98uAm.usePageVisibility)();
    const interval = (0, $eUqFw.useRef)(null);
    const { data: projectData } = (0, $bNe1g.useProjectContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { isCollapsed: isLeftSidebarCollapsed } = (0, $kpmC0.useLeftSidebarState)();
    (0, $eUqFw.useEffect)(()=>{
        setHasFired(false);
    }, [
        routeName
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isReady) {
            interval.current = null;
            return;
        }
        // If the page is visible, set the analytics event to run after the specified duration
        if (isVisible && !hasFired) interval.current = setTimeout(()=>{
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'page dwelled', routeName, {
                containerId: projectData?.projectId,
                containerType: projectData?.projectType,
                isLeftSidebarCollapsed: isLeftSidebarCollapsed
            });
            setHasFired(true);
        }, $f3c89b23479724f1$var$WAIT_DURATION);
        return ()=>{
            // @ts-expect-error - TS2769 - No overload matches this call.
            interval.current = clearTimeout(interval.current);
        };
    }, [
        createAnalyticsEvent,
        hasFired,
        isReady,
        isVisible,
        routeName,
        projectData?.projectId,
        projectData?.projectType,
        isLeftSidebarCollapsed
    ]);
    return null;
};

});
parcelRegister("98uAm", function(module, exports) {

$parcel$export(module.exports, "usePageVisibility", () => $628deecc3f05d159$export$6c98eb2f12f4ec61);

var $eUqFw = parcelRequire("eUqFw");

var $fEYK5 = parcelRequire("fEYK5");
const $628deecc3f05d159$export$6c98eb2f12f4ec61 = ()=>{
    const [isVisible, setIsVisible] = (0, $eUqFw.useState)((0, $fEYK5.isPageVisible)());
    (0, $eUqFw.useEffect)(()=>{
        const onVisibilityChange = ()=>setIsVisible((0, $fEYK5.isPageVisible)());
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('visibilitychange', onVisibilityChange);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);
    return isVisible;
};

});
parcelRegister("fEYK5", function(module, exports) {

$parcel$export(module.exports, "supportedVisiblityEvent", () => $72bec4f04bbd1d44$export$f7132cb36c80dad);
$parcel$export(module.exports, "isPageVisible", () => $72bec4f04bbd1d44$export$ae4f9b990bc70f70);
const $72bec4f04bbd1d44$var$visibilityMap = {
    // document property: event name
    hidden: 'visibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange',
    webkitHidden: 'webkitvisibilitychange'
};
const $72bec4f04bbd1d44$var$supportedHiddenKey = Object.keys($72bec4f04bbd1d44$var$visibilityMap).find(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Document'.
(key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
const $72bec4f04bbd1d44$export$f7132cb36c80dad = $72bec4f04bbd1d44$var$visibilityMap[$72bec4f04bbd1d44$var$supportedHiddenKey];
const $72bec4f04bbd1d44$export$ae4f9b990bc70f70 = ()=>typeof document !== 'undefined' && !document[$72bec4f04bbd1d44$var$supportedHiddenKey];

});



parcelRegister("2m6cd", function(module, exports) {

$parcel$export(module.exports, "MatchedRouteListener", () => $adf6545c3ff6605a$export$c6d9204abc182c3b);

var $eUqFw = parcelRequire("eUqFw");

var $keguF = parcelRequire("keguF");

var $lB25E = parcelRequire("lB25E");
const $adf6545c3ff6605a$export$c6d9204abc182c3b = ()=>{
    const [{ route: route, match: match }] = (0, $lB25E.useRouter)();
    (0, $eUqFw.useMemo)(()=>(0, $keguF.setMatchedRoute)(route, match), [
        route,
        match
    ]);
    return null;
};

});

parcelRegister("hEyt5", function(module, exports) {

$parcel$export(module.exports, "PreviousRouterStateListener", () => $e9e95a1ddd50ffec$export$49e28489f2124002);

var $eUqFw = parcelRequire("eUqFw");

var $hzcvF = parcelRequire("hzcvF");

var $keguF = parcelRequire("keguF");

var $lB25E = parcelRequire("lB25E");
const $e9e95a1ddd50ffec$export$3fd5ddd6b8e9a200 = ({ routerState: routerState })=>{
    const previousRouterState = (0, $hzcvF.usePrevious)(routerState);
    (0, $eUqFw.useEffect)(()=>{
        (0, $keguF.setPreviousRouterState)(previousRouterState ?? null);
    }, [
        previousRouterState
    ]);
    return null;
};
const $e9e95a1ddd50ffec$export$49e28489f2124002 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterSubscriber), null, (routerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9e95a1ddd50ffec$export$3fd5ddd6b8e9a200, {
            routerState: routerState
        })));
$e9e95a1ddd50ffec$export$49e28489f2124002.displayName = 'PreviousRouterStateListener';

});
parcelRegister("hzcvF", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $42dfce76254176f5$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousWithInitial", () => $42dfce76254176f5$export$23fbbb2e62c4a911);

var $eUqFw = parcelRequire("eUqFw");
const $42dfce76254176f5$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $42dfce76254176f5$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $eUqFw.useRef)(value);
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});


parcelRegister("iOtr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aa3a3761ea48b01$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $lgxha = parcelRequire("lgxha");

var $5omJE = parcelRequire("5omJE");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $lB25E = parcelRequire("lB25E");

var $js5iW = parcelRequire("js5iW");
/**
 * Defines the component for the `querystring-notifier` module.
 */ const $6aa3a3761ea48b01$var$QueryStringNotifier = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "querystringNotifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5omJE.default), null, (flagService)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterSubscriber), null, ({ location: { search: search } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterActions), null, ({ replace: replace })=>{
                const { showFlag: showFlag, ...query } = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search);
                if (!showFlag) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $js5iW.default)[showFlag] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
                    eventName: "querystringNotification shown",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
                    eventName: "querystringNotification notFound",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
                    op: ()=>{
                        if ((0, $js5iW.default)[showFlag]) flagService.showFlag((0, $js5iW.default)[showFlag]);
                        replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(query)}`);
                    }
                }));
            }))));
var $6aa3a3761ea48b01$export$2e2bcd8739ae039 = $6aa3a3761ea48b01$var$QueryStringNotifier;

});
parcelRegister("lgxha", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c6fb1eab8416e3f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line jira/react/no-class-components
class $7c6fb1eab8416e3f$var$OpTrigger extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $7c6fb1eab8416e3f$export$2e2bcd8739ae039 = $7c6fb1eab8416e3f$var$OpTrigger;

});

parcelRegister("5omJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e16a0c982e8c9d5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");
const $7e16a0c982e8c9d5$var$FlagServiceSubscriber = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children((0, $k8Qyf.flagService)));
var $7e16a0c982e8c9d5$export$2e2bcd8739ae039 = $7e16a0c982e8c9d5$var$FlagServiceSubscriber;

});

parcelRegister("d6f6c", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $6c42ad247d2b6151$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $6c42ad247d2b6151$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $6c42ad247d2b6151$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $6c42ad247d2b6151$export$2ccf161b817b43b);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");


var $jMP2a = parcelRequire("jMP2a");
// eslint-disable-next-line jira/react/no-class-components
class $6c42ad247d2b6151$var$FireComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $jMP2a.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $6c42ad247d2b6151$export$64eb47d7b94ba089 = (0, $2jDha.default)()($6c42ad247d2b6151$var$FireComponent);
const $6c42ad247d2b6151$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$a1562d08625f5d7e)
    });
const $6c42ad247d2b6151$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$947dac6c72b26f81)
    });
const $6c42ad247d2b6151$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$12346a674644c156)
    });
const $6c42ad247d2b6151$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

parcelRegister("js5iW", function(module, exports) {

$parcel$export(module.exports, "default", () => $da00c22705b8222e$export$2e2bcd8739ae039);

var $eo17r = parcelRequire("eo17r");

var $7mirP = parcelRequire("7mirP");
const $da00c22705b8222e$var$notificationMessages = {
    'jsw.board-not-found': {
        id: (0, $eo17r.toFlagId)('jsw.board-not-found'),
        type: 'error',
        title: (0, $7mirP.default).boardNotFound,
        description: (0, $7mirP.default).boardNotFoundDescription
    },
    'jsw.project-not-found': {
        id: (0, $eo17r.toFlagId)('jsw.project-not-found'),
        type: 'error',
        title: (0, $7mirP.default).projectNotFound,
        description: (0, $7mirP.default).projectNotFoundDescription
    }
};
var $da00c22705b8222e$export$2e2bcd8739ae039 = $da00c22705b8222e$var$notificationMessages;

});
parcelRegister("7mirP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fecba56a8f0fa28c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
// Don't confuse Intl messages with `Flag`s
const $fecba56a8f0fa28c$var$messages = (0, $90IgZ.defineMessages)({
    boardNotFound: {
        "id": "query-string-notifier.common.board-not-found",
        "defaultMessage": "Board not found"
    },
    boardNotFoundDescription: {
        "id": "query-string-notifier.common.board-not-found-description",
        "defaultMessage": "You tried to access a board that doesn't exist or that you don't have permission to see."
    },
    projectNotFound: {
        "id": "query-string-notifier.common.project-not-found",
        "defaultMessage": "Project not found"
    },
    projectNotFoundDescription: {
        "id": "query-string-notifier.common.project-not-found-description",
        "defaultMessage": "You tried to access a project that doesn't exist or that you don't have permission to see."
    }
});
var $fecba56a8f0fa28c$export$2e2bcd8739ae039 = $fecba56a8f0fa28c$var$messages;

});



parcelRegister("i0pNS", function(module, exports) {

$parcel$export(module.exports, "AsyncRecommendPremiumToStandardModalWrapper", () => $a7f9bc79f0d4187d$export$2a43717c77dd3a56);

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $aR8n6 = parcelRequire("aR8n6");

var $6VZoe = parcelRequire("6VZoe");

var $fX0ox = parcelRequire("fX0ox");

const $a7f9bc79f0d4187d$var$AsyncRecommendPremiumToStandardModalComponent = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("kGzY6")).then(({ RecommendPremiumToStandardModalComponent: RecommendPremiumToStandardModalComponent })=>RecommendPremiumToStandardModalComponent), {
    moduleId: "./src/packages/growth/recommend-premium-to-standard-modal/src/index.tsx"
});
const $a7f9bc79f0d4187d$export$2a43717c77dd3a56 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $fX0ox.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        teamName: (0, $fX0ox.TEAM_NAME),
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $fX0ox.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7f9bc79f0d4187d$var$AsyncRecommendPremiumToStandardModalComponent, null)));
};

});
parcelRegister("fX0ox", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $28d8bce3ded44043$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $28d8bce3ded44043$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ANALYTICS_SOURCE_NAME", () => $28d8bce3ded44043$export$48e1d3fa57b0a2d5);
$parcel$export(module.exports, "STARGATE_URL", () => $28d8bce3ded44043$export$c7e6a6b283196232);
$parcel$export(module.exports, "RECC_STANDARD_MESSAGE_ID", () => $28d8bce3ded44043$export$de9f5b160db96e26);
const $28d8bce3ded44043$export$b8b9d90f9e5bd72b = '@atlassian/jira-recommend-premium-to-standard-modal';
const $28d8bce3ded44043$export$d57b6b390e78d90f = 'growth-tako';
const $28d8bce3ded44043$export$48e1d3fa57b0a2d5 = 'recommendPremiumToStandard';
const $28d8bce3ded44043$export$c7e6a6b283196232 = '/gateway/api';
const $28d8bce3ded44043$export$de9f5b160db96e26 = new Map([
    [
        5,
        'prj-grace-period-recc-standard-message-1'
    ],
    [
        3,
        'prj-grace-period-recc-standard-message-2'
    ],
    [
        1,
        'prj-grace-period-recc-standard-message-3'
    ]
]);

});

parcelRegister("kGzY6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aHrtt").then(()=>parcelRequire('9yvl1'));

});


parcelRegister("isbb2", function(module, exports) {

$parcel$export(module.exports, "coalesce", () => $7465cd989816140c$export$6e5538615c060df7);
$parcel$export(module.exports, "renderGlobalComponents", () => $7465cd989816140c$export$fc28c9563350e5b8);
$parcel$export(module.exports, "createLayout", () => $7465cd989816140c$export$3dd437ade36ede40);
$parcel$export(module.exports, "composeLayouts", () => $7465cd989816140c$export$6c041b39c370853f);
$parcel$export(module.exports, "withProjectContext", () => $7465cd989816140c$export$e97a7da67a5b8ce4);

var $eUqFw = parcelRequire("eUqFw");

var $cPEpP = parcelRequire("cPEpP");

var $gGtKh = parcelRequire("gGtKh");

const $7465cd989816140c$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
const $7465cd989816140c$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
        const { displayName: displayName, name: name } = Component;
        const key = $7465cd989816140c$export$6e5538615c060df7(displayName) ?? $7465cd989816140c$export$6e5538615c060df7(name) ?? i;
        return(// TODO Only add suspense if lazy component, otherwise add suspense within component array
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: key?.toString(),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null)));
    });
const $7465cd989816140c$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
        isChromeless: isChromeless,
        globalComponents: Array.from(new Set(globalComponents)),
        rightSidebars: Array.from(new Set(rightSidebars))
    });
const $7465cd989816140c$export$6c041b39c370853f = (...layouts)=>{
    if (layouts.length === 1) return $7465cd989816140c$export$3dd437ade36ede40(layouts[0]);
    const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
            isChromeless: isChromeless,
            globalComponents: [
                ...l.globalComponents,
                ...globalComponents
            ],
            rightSidebars: [
                ...l.rightSidebars,
                ...rightSidebars
            ]
        }), {
        globalComponents: [],
        rightSidebars: [],
        isChromeless: false
    });
    return $7465cd989816140c$export$3dd437ade36ede40(layout);
};
const $7465cd989816140c$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $7465cd989816140c$var$formatPrefix = (style, type)=>{
    if (!style && !type) return 'Empty';
    if (style === 'any' && type === 'any') return 'Any';
    const formattedStyle = $7465cd989816140c$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
    if (type === 'any') return formattedStyle;
    const formattedType = $7465cd989816140c$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
    if (style === 'any') return formattedType;
    return `${formattedStyle}${formattedType}`;
};
const $7465cd989816140c$export$e97a7da67a5b8ce4 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
Component, options)=>{
    const { project: expectedProject } = options;
    const ScopedComponent = ()=>{
        const { data: project, loading: loading } = (0, $cPEpP.useProject)();
        if (loading) return null;
        if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null);
    };
    const name = $7465cd989816140c$export$6e5538615c060df7(Component.displayName) ?? $7465cd989816140c$export$6e5538615c060df7(Component.name) ?? 'Component';
    const prefix = $7465cd989816140c$var$formatPrefix(expectedProject?.style, expectedProject?.type);
    ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
    return ScopedComponent;
};

});

parcelRegister("5EZtQ", function(module, exports) {

$parcel$export(module.exports, "rovoVideoModalEntryPoint", () => $295188a6a3871459$export$2f67fedc6d5555a5);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $295188a6a3871459$export$2f67fedc6d5555a5 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(async ()=>(parcelRequire("l5cI4")).then(({ RovoVideoModal: RovoVideoModal })=>RovoVideoModal), {
        moduleId: "3a307b00"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("l5cI4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("aVqgB")
]).then(()=>parcelRequire('63tmB'));

});


parcelRegister("cADdB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4a03ce1abcffd5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k4nIh = parcelRequire("k4nIh");

var $d6f6c = parcelRequire("d6f6c");

var $ixwgj = parcelRequire("ixwgj");

var $lB25E = parcelRequire("lB25E");
/**
 * Ensures users are redirected to the correct project URL when there's a mismatch in the project key.
 * It preserves query parameters during redirection and logs the event for analytics.
 */ const $e4a03ce1abcffd5c$var$ProjectKeyRedirect = ({ FireOperationalAnalytics: FireOperationalAnalytics = (0, $d6f6c.FireOperationalAnalytics), Redirect: Redirect = (0, $lB25E.Redirect), useResource: useResource = (0, $lB25E.useResource), useRouter: useRouter = (0, $lB25E.useRouter) })=>{
    const [{ location: location, match: { params: params, url: url }, query: query }] = useRouter();
    const projectKey = params.projectKey ?? query.projectKey;
    const { data: projectContext } = useResource((0, $ixwgj.projectContextResource));
    if (!projectKey || !projectContext?.projectKey) return null;
    if (projectKey === projectContext.projectKey) return null;
    const search = {
        ...query,
        ...query.projectKey ? {
            projectKey: projectContext.projectKey
        } : {}
    };
    // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
    const queryString = (0, $k4nIh.qs).stringify(search, Object.entries(search).length > 0);
    // Just a slight risk mitigation - only do the string replace if the match param is there
    const path = params.projectKey != null ? url.replace(projectKey, projectContext.projectKey) : url;
    const to = `${path}${queryString}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FireOperationalAnalytics, {
        eventName: "ProjectKeyRedirect loaded",
        componentName: "ProjectKeyRedirect",
        attributes: {
            location: location,
            projectContext: projectContext
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: to
    }));
};
var $e4a03ce1abcffd5c$export$2e2bcd8739ae039 = $e4a03ce1abcffd5c$var$ProjectKeyRedirect;

});

parcelRegister("lFrSS", function(module, exports) {

$parcel$export(module.exports, "AsyncUpflowIframeComponent", () => $d356d361dffc7fd3$export$7f34679273a30171);

var $6VZoe = parcelRequire("6VZoe");

const $d356d361dffc7fd3$export$7f34679273a30171 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("87BxR")).then((exportedModule)=>exportedModule.UpflowIframeComponent), {
    ssr: false,
    moduleId: "./src/packages/growth/up-flow/upflow-iframe-plugin/src/main.tsx"
});

});
parcelRegister("87BxR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2zJry").then(()=>parcelRequire('7B2m0'));

});


parcelRegister("cLxEl", function(module, exports) {

$parcel$export(module.exports, "upgradeOnboardingExperimentEntryPoint", () => $6d97522dd833edb7$export$94ad1b5fd850909f);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $6d97522dd833edb7$export$94ad1b5fd850909f = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(async ()=>(parcelRequire("irf3v")).then(({ UpgradeOnboardingExperiment: UpgradeOnboardingExperiment })=>UpgradeOnboardingExperiment), {
        moduleId: "86e9ce71"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("irf3v", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("gOc4U")
]).then(()=>parcelRequire('bvwqZ'));

});


parcelRegister("BRKX9", function(module, exports) {

$parcel$export(module.exports, "JiraHeritageLoader", () => $49eb3c5692df3dbe$export$9499deca9933db5b);

var $eUqFw = parcelRequire("eUqFw");

var $4DtuZ = parcelRequire("4DtuZ");

var $8loyD = parcelRequire("8loyD");

var $10fdS = parcelRequire("10fdS");

var $h3mHU = parcelRequire("h3mHU");

var $16kIm = parcelRequire("16kIm");

var $8jPVO = parcelRequire("8jPVO");

var $kQZhv = parcelRequire("kQZhv");
const $49eb3c5692df3dbe$export$9499deca9933db5b = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [hasHeritageDownloaded, setHasHeritageDownloaded] = (0, $eUqFw.useState)(false);
    (0, $kQZhv.useWrmStatsEffects)();
    /* eslint-disable jira/wrm/no-load-bridge */ const loadJiraHeritageDependencies = (0, $eUqFw.useCallback)(()=>{
        setHasHeritageDownloaded(true);
        (0, $16kIm.asyncWrmRequire)([
            ...(0, $8loyD.jiraSuperBatchDependencies),
            ...(0, $8jPVO.getJiraHeritageDependencies)()
        ]).then(()=>(0, $4DtuZ.waitForHeritage)()?.resolve?.());
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (isReady && !hasHeritageDownloaded) loadJiraHeritageDependencies();
    }, [
        hasHeritageDownloaded,
        isReady,
        loadJiraHeritageDependencies,
        route
    ]);
    return null;
};
$49eb3c5692df3dbe$export$9499deca9933db5b.displayName = 'JiraHeritageLoader';

});
parcelRegister("16kIm", function(module, exports) {

$parcel$export(module.exports, "asyncWrmRequire", () => $0ab2873dadb9f6da$export$1024fe099ca05f05);
$parcel$export(module.exports, "asyncWrmRequireWithPrefetch", () => $0ab2873dadb9f6da$export$3ca0de203efa570e);
/* eslint-disable jira/wrm/no-load-bridge */ 
var $beITa = parcelRequire("beITa");
var $dPoeR = parcelRequire("dPoeR");
const $0ab2873dadb9f6da$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, $beITa.wrmRequire)(resourcesToRequire);
const $0ab2873dadb9f6da$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, $dPoeR.wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);

});

parcelRegister("8jPVO", function(module, exports) {

$parcel$export(module.exports, "getJiraHeritageDependencies", () => $f6b7e29d2a8831d9$export$e8f6d7acd5817fa2);
const $f6b7e29d2a8831d9$export$e8f6d7acd5817fa2 = ()=>[
        // superbatch resources
        // analytics
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        // dependencies from HeaderFooterRendering
        'wrc!jira.webresources:key-commands',
        'wrc!jira.webresources:header',
        // . dialog
        'wrc!com.atlassian.administration.atlassian-admin-quicksearch-jira:admin-quicksearch-webresources',
        // overrides for AUI, styles and bridge apis
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!jira.webresources:global-static',
        // browser metrics
        'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
        // repository shortcuts from navigation
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next',
        // issue view resources
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources-init',
        // create board dialog
        'wrc!com.pyxis.greenhopper.jira:gh-create-board-adg3-no-condition',
        // old analytics library
        'wrc!com.atlassian.analytics.analytics-client:js-events',
        // frontend cache
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:global-cache',
        // impersonation flag (logged as someone)
        'wrc!com.atlassian.crowd.user-provisioning-vertigo-plugin:impersonation-resources',
        // flag displayed when there are too many emails on the instance
        'wrc!jira.webresources:spam-protection-flags',
        // in-product announcements (displayed e.g. if there is an incident)
        'wrc!com.atlassian.pas:pas-everypage-static',
        // Bento resources
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:fileviewer',
        'wrc!com.atlassian.auiplugin:dialog2',
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:atlassian-fileviewer',
        'wrc!com.atlassian.jira.jira-issue-nav-plugin:stylesheets'
    ];

});

parcelRegister("kQZhv", function(module, exports) {

$parcel$export(module.exports, "useWrmStatsEffects", () => $daca76ea3608ba43$export$7ff53723d9d2886d);

var $eUqFw = parcelRequire("eUqFw");

var $h3mHU = parcelRequire("h3mHU");

var $78d1w = parcelRequire("78d1w");
const $daca76ea3608ba43$export$7ff53723d9d2886d = ()=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [{ transitionsCount: transitionsCount }] = (0, $78d1w.useSpaStateTransition)();
    (0, $eUqFw.useEffect)(()=>{
        if (isReady && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__ && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        !window.__WRM_INTERNAL_STATS__.isPageInteractive) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__.isPageInteractive = true;
    }, [
        isReady
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (transitionsCount > 0) // clear stats on transition
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__ = {};
    }, [
        transitionsCount
    ]);
};

});


parcelRegister("1OfKM", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbAdapter", () => $f4d7bdf212cdca0f$export$2255367d5c9162b3);

var $eUqFw = parcelRequire("eUqFw");

var $bAoTi = parcelRequire("bAoTi");
const $f4d7bdf212cdca0f$export$2255367d5c9162b3 = ()=>{
    const baseUrl = '';
    // @ts-expect-error - TS2322 - Type '{ baseUrl: string; }' is not assignable to type 'IntrinsicAttributes & Omit<PropsWithDefault, "baseUrl" | keyof InjectedProps>'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bAoTi.default), {
        baseUrl: baseUrl
    });
};

});
parcelRegister("bAoTi", function(module, exports) {

$parcel$export(module.exports, "default", () => $34d9050e380aaae9$export$2e2bcd8739ae039);

var $knPb9 = parcelRequire("knPb9");

var $3532a = parcelRequire("3532a");

var $7H4Eg = parcelRequire("7H4Eg");

var $8Of3p = parcelRequire("8Of3p");

var $l02Yw = parcelRequire("l02Yw");

var $jU94X = parcelRequire("jU94X");
var $34d9050e380aaae9$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $3532a.default), {
    LegacyApiBridge: // @ts-expect-error - Type 'FunctionComponent<Omit<PropsWithDefault, keyof AnalyticsEvents>>' is not assignable to type 'ComponentType<Props> | undefined'.
    $7H4Eg.default,
    LegacyBreadcrumbConnector: $8Of3p.default,
    LegacyBreadcrumbState: // @ts-expect-error - TS2322 - Type 'typeof LegacyBreadcrumbState' is not assignable to type 'ComponentType<LegacyBreadcrumbStateProviderProps> | undefined'.
    $jU94X.default,
    LegacyBreadcrumbRenderer: $l02Yw.default
});

});
parcelRegister("knPb9", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $e1b771d5f606c17c$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $e1b771d5f606c17c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $e1b771d5f606c17c$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $e1b771d5f606c17c$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$e1b771d5f606c17c$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $e1b771d5f606c17c$export$2e2bcd8739ae039 = $e1b771d5f606c17c$var$withInjectedProps;

});

parcelRegister("3532a", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff6ade52479ed891$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hFmdR = parcelRequire("hFmdR");

var $5GxEP = parcelRequire("5GxEP");

const $ff6ade52479ed891$var$LegacyBreadcrumbAdapter = ({ LegacyBreadcrumbRenderer: LegacyBreadcrumbRenderer, LegacyBreadcrumbState: LegacyBreadcrumbState, LegacyApiBridge: LegacyApiBridge, LegacyBreadcrumbConnector: LegacyBreadcrumbConnector })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LegacyBreadcrumbState, null, ({ api: api, state: state })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LegacyApiBridge, {
            onInsertItem: api.insertItem,
            onRemoveItem: api.removeItem,
            onSetRenderTarget: api.setTargetElement
        }), // Only activate the breadcrumb connector if there is a breadcrumb render target
        state.targetElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
            id: "legacy-breadcrumb-adapter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LegacyBreadcrumbConnector, {
            legacyTrail: state.trail
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LegacyBreadcrumbRenderer, {
            targetElement: state.targetElement
        }))));
var $ff6ade52479ed891$export$2e2bcd8739ae039 = (0, $hFmdR.AnalyticsSource)('legacyBreadcrumbs', (0, $41ea3621645e2acc$export$f636b5b56f1d624a))($ff6ade52479ed891$var$LegacyBreadcrumbAdapter);

});
parcelRegister("hFmdR", function(module, exports) {

$parcel$export(module.exports, "AnalyticsSource", () => $3d95c57ea565c569$export$6890652a1aff7d1c);
$parcel$export(module.exports, "AnalyticsSubject", () => $3d95c57ea565c569$export$ec9f54bd4341ceb);

var $1ngde = parcelRequire("1ngde");
const $3d95c57ea565c569$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, $1ngde.default)({
            source: `${name}${type}`
        })(WrappedComponent);
const $3d95c57ea565c569$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, $1ngde.default)({
            actionSubject: name,
            attributes: attributes
        })(WrappedComponent);

});


parcelRegister("7H4Eg", function(module, exports) {

$parcel$export(module.exports, "default", () => $078bdb0aa485f642$export$2e2bcd8739ae039);

var $2Enn0 = parcelRequire("2Enn0");

var $knPb9 = parcelRequire("knPb9");

var $jmX5T = parcelRequire("jmX5T");
const $078bdb0aa485f642$var$analyticsEvents = {
    onInsertItemFired: (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'insertItem'
            }
        }),
    onRemoveItemFired: (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'removeItem'
            }
        }),
    onSetRenderTargetFired: (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'render'
            }
        }),
    onOnBreadCrumbsUpdateFired: (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'onBreadCrumbsUpdate'
            }
        })
};
var $078bdb0aa485f642$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $jmX5T.default), $078bdb0aa485f642$var$analyticsEvents);

});
parcelRegister("2Enn0", function(module, exports) {

$parcel$export(module.exports, "fireOperationalAnalytics", () => $3ee3ca60c3a36803$export$79f423cc3fd39762);

var $3LiTJ = parcelRequire("3LiTJ");

var $guiFP = parcelRequire("guiFP");

var $etqm0 = parcelRequire("etqm0");

var $klunD = parcelRequire("klunD");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $3ee3ca60c3a36803$var$isNotUndefined = (a)=>a !== undefined;
const $3ee3ca60c3a36803$var$mapPayload = (payload)=>{
    const context = (0, $klunD.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $3ee3ca60c3a36803$var$isNotUndefined);
};
const $3ee3ca60c3a36803$export$79f423cc3fd39762 = (event, payload)=>{
    // Causes issues with mounting the src/packages/confluence/project-pages/src/view/examples.js component in storybook tests.
    // This is due to node_modules/@atlassiansox/analytics-web-client/dist/analytics-web-client.with-deps.js producing a reference error with the normalize function
    // This is possibly due to some scope hoisting issue with jest that is not present in the browser
    try {
        event.update({
            ...$3ee3ca60c3a36803$var$mapPayload(payload),
            analyticsType: (0, $etqm0.OPERATIONAL_EVENT_TYPE)
        }).fire();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $guiFP.default)({
            event: event,
            error: e,
            meta: {
                id: 'fireOperationalAnalytics',
                packageName: 'jiraAnalyticsWebReact',
                teamName: 'legacy-jfp-team-do-not-use'
            }
        });
    }
};

});
parcelRegister("klunD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0af4980e66497eeb$export$2e2bcd8739ae039);

var $kkgbD = parcelRequire("kkgbD");

var $i7Fym = parcelRequire("i7Fym");
var // AnalyticsDataPayload is cast to inexact type so that it can also accept subtypes
// eslint-disable-next-line jira/import/no-anonymous-default-export
$0af4980e66497eeb$export$2e2bcd8739ae039 = (payload)=>{
    const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
        tags: tags,
        containerId: containerId,
        containers: containers,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD))));
};

});


parcelRegister("jmX5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $c37f23517b903b52$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");

var $eGI9v = parcelRequire("eGI9v");

var $bDtAc = parcelRequire("bDtAc");
// eslint-disable-next-line jira/react/no-class-components
class $c37f23517b903b52$var$LegacyApiBridge extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { onInsertItem: onInsertItem, onRemoveItem: onRemoveItem, onSetRenderTarget: onSetRenderTarget, onBreadCrumbsUpdate: onBreadCrumbsUpdate } = this;
        (0, $bDtAc.default)({
            insertItem: onInsertItem,
            removeItem: onRemoveItem,
            render: onSetRenderTarget,
            onBreadCrumbsUpdate: onBreadCrumbsUpdate
        });
    }
    /* eslint-enable jira/react-no-unneeded-arrow-function-properties */ render() {
        return null;
    }
    constructor(...args){
        super(...args);
        /* eslint-disable jira/react-no-unneeded-arrow-function-properties */ this.onInsertItem = (item)=>{
            const { onInsertItem: onInsertItem, onInsertItemFired: onInsertItemFired } = this.props;
            onInsertItemFired();
            onInsertItem(item);
        };
        this.onRemoveItem = (itemId)=>{
            const { onRemoveItem: onRemoveItem, onRemoveItemFired: onRemoveItemFired } = this.props;
            onRemoveItemFired();
            onRemoveItem(itemId);
        };
        this.onSetRenderTarget = (element)=>{
            const { onSetRenderTarget: onSetRenderTarget, onSetRenderTargetFired: onSetRenderTargetFired } = this.props;
            onSetRenderTargetFired();
            onSetRenderTarget(element);
        };
        this.onBreadCrumbsUpdate = ()=>{
            const { onOnBreadCrumbsUpdateFired: onOnBreadCrumbsUpdateFired } = this.props;
            onOnBreadCrumbsUpdateFired();
            return (0, $3JafE.Observable).empty();
        };
    }
}
var $c37f23517b903b52$export$2e2bcd8739ae039 = (0, $eGI9v.default)('legacyApiBridge', {
    onInsertItemFired: 'apiMethodCalled',
    onRemoveItemFired: 'apiMethodCalled',
    onSetRenderTargetFired: 'apiMethodCalled',
    onOnBreadCrumbsUpdateFired: 'apiMethodCalled'
})($c37f23517b903b52$var$LegacyApiBridge);

});
parcelRegister("eGI9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $9208d82098460921$export$2e2bcd8739ae039);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");
const $9208d82098460921$export$871de8747c9eaa88 = (props)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            ...result,
            [key]: {
                action: props[key]
            }
        }), {});
/**
 * Augments component's callbacks with analytics event as the last attribute, but does fires them
 * @example
 * ```tsx
 * // adds componentName into AnalyticsContext and adds pre-backed 'clicked' event to onClick arguments
 *  const componentWithAnalytics('FooComponent', { onClick: 'clicked' })(Foo)
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9208d82098460921$var$componentWithAnalytics(componentName, eventActions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(WrappedComponent) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $1ngde.default)({
            componentName: componentName
        })((0, $2jDha.default)($9208d82098460921$export$871de8747c9eaa88(eventActions))(WrappedComponent));
    };
}
var $9208d82098460921$export$2e2bcd8739ae039 = $9208d82098460921$var$componentWithAnalytics;

});

parcelRegister("bDtAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $801e164601d3872a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $ds5Im = parcelRequire("ds5Im");

var $gUUjF = parcelRequire("gUUjF");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$801e164601d3872a$export$2e2bcd8739ae039 = (legacyAPI)=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $ds5Im.loadBridgeWeak)({
        name: 'jira/globalnavigator/breadcrumbs/bridge'
    }).then((bridge)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        bridge(legacyAPI);
    }).catch((err)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString()));

});



parcelRegister("8Of3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de6401c7e8172f3$export$2e2bcd8739ae039);

var $knPb9 = parcelRequire("knPb9");

var $aTgXo = parcelRequire("aTgXo");

var $hCPt9 = parcelRequire("hCPt9");

var $dpXKE = parcelRequire("dpXKE");

var $5c2C3 = parcelRequire("5c2C3");

var $1bzuc = parcelRequire("1bzuc");

var $i7f3H = parcelRequire("i7f3H");
var $5de6401c7e8172f3$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $1bzuc.default), {
    Breadcrumb: $aTgXo.default,
    ProjectBreadcrumb: $dpXKE.default,
    BoardBreadcrumb: // @ts-expect-error - TS2322 - Type '{ ({  children, boardId, boardName, isSimplifiedProject, projectId, }: BoardBreadcrumbProps): JSX.Element; defaultProps: { children: null; isSimplifiedProject: boolean; projectId: undefined; }; }' is not assignable to type 'ComponentType<Partial<BoardBreadcrumbProps>> | undefined'.
    $hCPt9.default,
    UserBreadcrumb: $5c2C3.default,
    ContextProvider: $i7f3H.default
});

});
parcelRegister("aTgXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd5d72148724b95b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $hompL = parcelRequire("hompL");

var $bfY8R = parcelRequire("bfY8R");
// eslint-disable-next-line jira/react/no-class-components
class $dd5d72148724b95b$var$BreadcrumbOps extends (0, $eUqFw.Component) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props);
        this.id = '';
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        if (false) this.onPushBreadcrumb();
    }
    componentDidMount() {
        this.onPushBreadcrumb();
    }
    componentDidUpdate(prevProps) {
        const { breadcrumb: prevBreadcrumb } = prevProps;
        const { api: api, breadcrumb: breadcrumb } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevBreadcrumb, breadcrumb)) api.updateBreadcrumb({
            id: this.id,
            ...breadcrumb
        });
    }
    componentWillUnmount() {
        const { api: api } = this.props;
        api.popBreadcrumb();
    }
    onPushBreadcrumb() {
        const { api: api, breadcrumb: breadcrumb } = this.props;
        api.pushBreadcrumb({
            id: this.id,
            ...breadcrumb
        });
    }
    render() {
        return null;
    }
}
const $dd5d72148724b95b$var$Breadcrumb = ({ breadcrumb: breadcrumb, children: children })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bfY8R.BreadcrumbActions), null, (__, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd5d72148724b95b$var$BreadcrumbOps, {
            api: actions,
            breadcrumb: breadcrumb
        }), children));
$dd5d72148724b95b$var$Breadcrumb.defaultProps = {
    children: null
};
var $dd5d72148724b95b$export$2e2bcd8739ae039 = $dd5d72148724b95b$var$Breadcrumb;

});
parcelRegister("bfY8R", function(module, exports) {

$parcel$export(module.exports, "useBreadcrumbs", () => $3e01453c51fda3d9$export$8cefe241bd876ca0);
$parcel$export(module.exports, "BreadcrumbActions", () => $3e01453c51fda3d9$export$9862c338ec0a6884);
$parcel$export(module.exports, "BreadcrumbContainer", () => $3e01453c51fda3d9$export$c7432936d9c50db7);

var $WBLbN = parcelRequire("WBLbN");
const $3e01453c51fda3d9$var$initialState = {
    trail: []
};
const $3e01453c51fda3d9$export$e324594224ef24da = {
    pushBreadcrumb: (breadcrumb)=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            setState({
                trail: [
                    ...getState().trail,
                    breadcrumb
                ]
            });
        },
    popBreadcrumb: ()=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            setState({
                trail: getState().trail.slice(0, -1)
            });
        },
    updateBreadcrumb: (breadcrumb)=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
            const newTrail = getState().trail.map((item)=>item.id === breadcrumb.id ? breadcrumb : item);
            setState({
                trail: newTrail
            });
        }
};
const $3e01453c51fda3d9$var$Store = (0, $WBLbN.createStore)({
    initialState: $3e01453c51fda3d9$var$initialState,
    actions: $3e01453c51fda3d9$export$e324594224ef24da,
    name: 'BreadcrumbSweetState'
});
const $3e01453c51fda3d9$var$_BreadcrumbSubscriber = (0, $WBLbN.createSubscriber)($3e01453c51fda3d9$var$Store);
const $3e01453c51fda3d9$export$8cefe241bd876ca0 = (0, $WBLbN.createHook)($3e01453c51fda3d9$var$Store);
const $3e01453c51fda3d9$export$9862c338ec0a6884 = (0, $WBLbN.createSubscriber)($3e01453c51fda3d9$var$Store, {
    selector: null
});
const $3e01453c51fda3d9$export$c7432936d9c50db7 = (0, $WBLbN.createContainer)($3e01453c51fda3d9$var$Store);

});


parcelRegister("hCPt9", function(module, exports) {

$parcel$export(module.exports, "default", () => $75a50236b83a41ea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aTgXo = parcelRequire("aTgXo");

var $5IARc = parcelRequire("5IARc");
const $75a50236b83a41ea$var$BoardBreadcrumb = ({ children: children, boardId: boardId, boardName: boardName, isSimplifiedProject: isSimplifiedProject, projectId: projectId })=>{
    const breadcrumb = {
        href: (0, $5IARc.createBoardUrl)(boardId),
        text: boardName,
        type: 'boardName',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToSubProject',
            containerId: projectId,
            containerType: 'project'
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: breadcrumb
    }, children);
};
$75a50236b83a41ea$var$BoardBreadcrumb.defaultProps = {
    children: null,
    isSimplifiedProject: false,
    projectId: undefined
};
var $75a50236b83a41ea$export$2e2bcd8739ae039 = $75a50236b83a41ea$var$BoardBreadcrumb;

});
parcelRegister("5IARc", function(module, exports) {

$parcel$export(module.exports, "createProjectUrl", () => $f5b81aae15d86847$export$1bdb1f038c5a2a90);
$parcel$export(module.exports, "createProjectSettingsUrl", () => $f5b81aae15d86847$export$c435fcb42a65af32);
$parcel$export(module.exports, "createBoardUrl", () => $f5b81aae15d86847$export$7037e05c8c7af6dc);

var $cqJw8 = parcelRequire("cqJw8");
const $f5b81aae15d86847$export$1bdb1f038c5a2a90 = (projectKey)=>`/browse/${encodeURIComponent(projectKey)}`;
const $f5b81aae15d86847$export$c435fcb42a65af32 = (projectKey, projectType, isSimplified)=>{
    if (isSimplified) return (0, $cqJw8.getNextgenSettingsUrl)(projectType, projectKey);
    return `/projects/${projectKey}/settings`;
};
const $f5b81aae15d86847$export$7037e05c8c7af6dc = (boardId)=>`/secure/RapidBoard.jspa?rapidView=${boardId}`;

});
parcelRegister("cqJw8", function(module, exports) {

$parcel$export(module.exports, "getNextgenSettingsUrl", () => $8bf9744795c994e7$export$26432406821aa7bf);
$parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", () => $8bf9744795c994e7$export$defee92e506aa306);
$parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", () => $8bf9744795c994e7$export$9133e09a98a043dc);
$parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", () => $8bf9744795c994e7$export$b0d20d18e0230e83);
$parcel$export(module.exports, "getClassicJSWSettingsUrl", () => $8bf9744795c994e7$export$ff0a17aa36a000df);
$parcel$export(module.exports, "getProjectSettingsDetailsUrl", () => $8bf9744795c994e7$export$16d52b9357bb73ab);
$parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", () => $8bf9744795c994e7$export$d531a9788343348f);
$parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", () => $8bf9744795c994e7$export$dad567762dae162e);
$parcel$export(module.exports, "getJcsRequestTypeLayoutSettingsUrl", () => $8bf9744795c994e7$export$8b304050f4836b59);

var $7ZZxN = parcelRequire("7ZZxN");

var $6bYiA = parcelRequire("6bYiA");

var $6ZTsa = parcelRequire("6ZTsa");

var $avawr = parcelRequire("avawr");
const $8bf9744795c994e7$export$26432406821aa7bf = (projectType, projectKey)=>{
    const products = {
        [(0, $7ZZxN.CORE_PROJECT)]: 'core',
        [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)]: 'customerservice',
        [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
        [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
    };
    const product = products[projectType];
    if (!product) {
        (0, $avawr.logError)((0, $6bYiA.PACKAGE_NAME), (0, $6ZTsa.toErrorId)('urls'), (0, $6ZTsa.toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
        // let's return classic url in that case
        return `/projects/${projectKey}/settings`;
    }
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
    return `/jira/${product}/projects/${projectKey}/settings`;
};
const $8bf9744795c994e7$var$serializeBackLink = (backLink)=>{
    if (backLink == null) return '';
    const { url: url, title: title } = backLink;
    return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
};
const $8bf9744795c994e7$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}`;
    return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;
};
const $8bf9744795c994e7$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
    return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
};
const $8bf9744795c994e7$export$b0d20d18e0230e83 = (projectKey)=>`${$8bf9744795c994e7$export$26432406821aa7bf((0, $7ZZxN.SERVICE_DESK_PROJECT), projectKey)}/automation`;
const $8bf9744795c994e7$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
const $8bf9744795c994e7$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
    const urlBase = projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && !isSimplified ? $8bf9744795c994e7$export$ff0a17aa36a000df(projectKey) : $8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey);
    return `${urlBase}/details`;
};
const $8bf9744795c994e7$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;
const $8bf9744795c994e7$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;
const $8bf9744795c994e7$export$8b304050f4836b59 = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/helpcenter/projects/${projectKey}/settings/request-types/unassigned/request-type/${requestTypeId}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;

});
parcelRegister("6bYiA", function(module, exports) {

$parcel$export(module.exports, "TASK", () => $b6aeae99b4bfc5a4$export$9355e489ad16f98e);
$parcel$export(module.exports, "BUG", () => $b6aeae99b4bfc5a4$export$bcf558c186108044);
$parcel$export(module.exports, "STORY", () => $b6aeae99b4bfc5a4$export$1ea39a3ae330045);
$parcel$export(module.exports, "EPIC", () => $b6aeae99b4bfc5a4$export$3cb4a99a332e4186);
$parcel$export(module.exports, "SUB_TASK", () => $b6aeae99b4bfc5a4$export$a06f889861f6537d);
$parcel$export(module.exports, "CUSTOM", () => $b6aeae99b4bfc5a4$export$952581bc40160893);
$parcel$export(module.exports, "TEMPLATES_WHITELIST", () => $b6aeae99b4bfc5a4$export$dff1da4a9bab6d3e);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $b6aeae99b4bfc5a4$export$39cd48613b53ce2f);
$parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$56eae1056efd4899);
$parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$ca61f05d869b2ea3);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", () => $b6aeae99b4bfc5a4$export$2ec42920a0df6b9a);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", () => $b6aeae99b4bfc5a4$export$40c10ba35ceb5c6b);
$parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", () => $b6aeae99b4bfc5a4$export$a11dccbf88784c62);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", () => $b6aeae99b4bfc5a4$export$f35dc2e6deb1692e);
$parcel$export(module.exports, "JIRA_APP_NAME", () => $b6aeae99b4bfc5a4$export$ec5d0e43836cb3c7);
$parcel$export(module.exports, "toPackageName", () => $b6aeae99b4bfc5a4$export$f31a652635bd75fe);
$parcel$export(module.exports, "PACKAGE_NAME", () => $b6aeae99b4bfc5a4$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", () => $b6aeae99b4bfc5a4$export$a2231d79966e0ccc);
$parcel$export(module.exports, "RADIO_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$28a4bdf7d9b6f9);
$parcel$export(module.exports, "USERPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$9d758b3e8c6e0ed1);
$parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$b0e37d421e006913);
$parcel$export(module.exports, "SELECT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$d77765147749db6b);
$parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$42ef68d6bd555a8d);
$parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$4db6eb15b3c529cf);
$parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$ee975373b7797e8a);
$parcel$export(module.exports, "TEXT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$aa99342cc6a8ced5);
$parcel$export(module.exports, "NUMBER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$6f327bf99e20320);
$parcel$export(module.exports, "DATETIME_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$dc64bdfdf9660a05);
$parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$e6d73ed745b9a04);
$parcel$export(module.exports, "DATE_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$d8b50f59220c7580);
$parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$3a6f0a44478f1d2);
$parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$68b76ef93df5a880);
$parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$e7773fccbeec45e6);
$parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$b45487b145c52a37);
$parcel$export(module.exports, "VERSION_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$48548129a6d117f5);
$parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$722c271a9e11cb94);
$parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$33dbe2a903610aa1);
$parcel$export(module.exports, "emptyTenantContext", () => $b6aeae99b4bfc5a4$export$ac655f5b3ff7b929);
// Issue Type Templates

var $ao0hp = parcelRequire("ao0hp");

var $lO4Or = parcelRequire("lO4Or");

var $6WXNs = parcelRequire("6WXNs");

var $6vrw7 = parcelRequire("6vrw7");

var $7HKaW = parcelRequire("7HKaW");

var $38OPi = parcelRequire("38OPi");
const $b6aeae99b4bfc5a4$export$9355e489ad16f98e = 'task';
const $b6aeae99b4bfc5a4$export$bcf558c186108044 = 'bug';
const $b6aeae99b4bfc5a4$export$1ea39a3ae330045 = 'story';
const $b6aeae99b4bfc5a4$export$3cb4a99a332e4186 = 'epic';
const $b6aeae99b4bfc5a4$export$a06f889861f6537d = 'subtask';
const $b6aeae99b4bfc5a4$export$952581bc40160893 = 'custom';
const $b6aeae99b4bfc5a4$export$dff1da4a9bab6d3e = [
    $b6aeae99b4bfc5a4$export$9355e489ad16f98e,
    $b6aeae99b4bfc5a4$export$bcf558c186108044,
    $b6aeae99b4bfc5a4$export$1ea39a3ae330045,
    $b6aeae99b4bfc5a4$export$3cb4a99a332e4186
];
const $b6aeae99b4bfc5a4$export$39cd48613b53ce2f = (0, $lO4Or.TEXT_AREA_CF_TYPE);
const $b6aeae99b4bfc5a4$export$56eae1056efd4899 = (0, $lO4Or.DESCRIPTION_TYPE);
const $b6aeae99b4bfc5a4$export$ca61f05d869b2ea3 = (0, $lO4Or.ENVIRONMENT_TYPE);
const $b6aeae99b4bfc5a4$export$2ec42920a0df6b9a = 'Story point estimate';
const $b6aeae99b4bfc5a4$export$40c10ba35ceb5c6b = 'storyPointEstimate';
const $b6aeae99b4bfc5a4$export$a4d3702d4c7481d6 = 44;
const $b6aeae99b4bfc5a4$export$8a6a961f6caf7a8b = [
    $b6aeae99b4bfc5a4$export$56eae1056efd4899,
    $b6aeae99b4bfc5a4$export$39cd48613b53ce2f,
    $b6aeae99b4bfc5a4$export$ca61f05d869b2ea3
];
const $b6aeae99b4bfc5a4$export$e27914436cc13e3c = 'Jira Software';
const $b6aeae99b4bfc5a4$export$a11dccbf88784c62 = 'Jira Service Management';
const $b6aeae99b4bfc5a4$export$9f4aa232cbb6be46 = 'Jira Work Management';
const $b6aeae99b4bfc5a4$export$b3c4739240716eb6 = 'Jira Ops';
const $b6aeae99b4bfc5a4$export$f35dc2e6deb1692e = 'Jira Product Discovery';
const $b6aeae99b4bfc5a4$export$ec5d0e43836cb3c7 = 'Jira';
const $b6aeae99b4bfc5a4$export$f31a652635bd75fe = (packageName)=>packageName;
const $b6aeae99b4bfc5a4$export$b8b9d90f9e5bd72b = $b6aeae99b4bfc5a4$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
const $b6aeae99b4bfc5a4$export$a2231d79966e0ccc = 'NEW_';
const $b6aeae99b4bfc5a4$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
const $b6aeae99b4bfc5a4$export$28a4bdf7d9b6f9 = 'radio';
const $b6aeae99b4bfc5a4$export$9d758b3e8c6e0ed1 = 'userpicker';
const $b6aeae99b4bfc5a4$export$b0e37d421e006913 = 'multiuserpicker';
const $b6aeae99b4bfc5a4$export$d77765147749db6b = 'select';
const $b6aeae99b4bfc5a4$export$42ef68d6bd555a8d = 'cascadingselect';
const $b6aeae99b4bfc5a4$export$4db6eb15b3c529cf = 'multiselect';
const $b6aeae99b4bfc5a4$export$ee975373b7797e8a = 'checkbox';
const $b6aeae99b4bfc5a4$export$aa99342cc6a8ced5 = 'text';
const $b6aeae99b4bfc5a4$export$6f327bf99e20320 = 'number';
const $b6aeae99b4bfc5a4$export$dc64bdfdf9660a05 = 'datetime';
const $b6aeae99b4bfc5a4$export$e6d73ed745b9a04 = 'projectpicker';
const $b6aeae99b4bfc5a4$export$d8b50f59220c7580 = 'date';
const $b6aeae99b4bfc5a4$export$3a6f0a44478f1d2 = 'assetspicker';
const $b6aeae99b4bfc5a4$export$68b76ef93df5a880 = 'labelpicker';
const $b6aeae99b4bfc5a4$export$e7773fccbeec45e6 = 'grouppicker';
const $b6aeae99b4bfc5a4$export$b45487b145c52a37 = 'multigrouppicker';
const $b6aeae99b4bfc5a4$export$48548129a6d117f5 = 'version';
const $b6aeae99b4bfc5a4$export$722c271a9e11cb94 = 'multiversion';
const $b6aeae99b4bfc5a4$export$33dbe2a903610aa1 = 'textarea';
const $b6aeae99b4bfc5a4$export$ac655f5b3ff7b929 = ()=>({
        appEditions: (0, $6WXNs.populateApplicationEditions)(),
        appPermissions: (0, $38OPi.populateApplicationPermissions)(),
        applicationKey: null,
        areProductSuggestionsEnabled: false,
        appUpdatesAvailable: null,
        atlassianAccountId: null,
        baseUrl: (0, $6vrw7.toBaseUrl)(''),
        cloudId: (0, $6vrw7.toCloudId)(''),
        activationId: (0, $6vrw7.toActivationId)(''),
        cloudName: (0, $6vrw7.toCloudName)(''),
        devopsProjectSignupSource: (0, $6vrw7.toDevopsProjectSignupSource)(''),
        environment: null,
        fabricActivityUrl: null,
        fabricNotificationLogUrl: null,
        fabricPfDirUrl: null,
        firstActivationDateMs: null,
        isAdmin: false,
        isAnonymous: false,
        isDevMode: false,
        isDevopsProjectCreationScenario: false,
        isMarketingOptOut: false,
        isSiteAdmin: false,
        languageTag: null,
        licenseStates: (0, $7HKaW.populateApplicationLicenseStates)(),
        licensedProducts: {},
        locale: (0, $ao0hp.defaultLocale),
        loggedInUser: null,
        productCrossSellConfig: 'unknown',
        productEntitlementDetails: null,
        productPermissionGated: {
            core: false,
            software: false,
            serviceDesk: false,
            productDiscovery: false
        },
        siteAdminStatus: 'unknown',
        userFullname: null,
        xsrfToken: null,
        hasDlpEnabled: false,
        avpWorkspaceId: null
    });

});
parcelRegister("lO4Or", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $4eac1b8021be0c88$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $4eac1b8021be0c88$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $4eac1b8021be0c88$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $4eac1b8021be0c88$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $4eac1b8021be0c88$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $4eac1b8021be0c88$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $4eac1b8021be0c88$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $4eac1b8021be0c88$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $4eac1b8021be0c88$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $4eac1b8021be0c88$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $4eac1b8021be0c88$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $4eac1b8021be0c88$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $4eac1b8021be0c88$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $4eac1b8021be0c88$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $4eac1b8021be0c88$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $4eac1b8021be0c88$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $4eac1b8021be0c88$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $4eac1b8021be0c88$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $4eac1b8021be0c88$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $4eac1b8021be0c88$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $4eac1b8021be0c88$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $4eac1b8021be0c88$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $4eac1b8021be0c88$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $4eac1b8021be0c88$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $4eac1b8021be0c88$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $4eac1b8021be0c88$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $4eac1b8021be0c88$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $4eac1b8021be0c88$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $4eac1b8021be0c88$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $4eac1b8021be0c88$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $4eac1b8021be0c88$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $4eac1b8021be0c88$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $4eac1b8021be0c88$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $4eac1b8021be0c88$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $4eac1b8021be0c88$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $4eac1b8021be0c88$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $4eac1b8021be0c88$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $4eac1b8021be0c88$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $4eac1b8021be0c88$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $4eac1b8021be0c88$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $4eac1b8021be0c88$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $4eac1b8021be0c88$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $4eac1b8021be0c88$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $4eac1b8021be0c88$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $4eac1b8021be0c88$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $4eac1b8021be0c88$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $4eac1b8021be0c88$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $4eac1b8021be0c88$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $4eac1b8021be0c88$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $4eac1b8021be0c88$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $4eac1b8021be0c88$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $4eac1b8021be0c88$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $4eac1b8021be0c88$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $4eac1b8021be0c88$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $4eac1b8021be0c88$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $4eac1b8021be0c88$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $4eac1b8021be0c88$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $4eac1b8021be0c88$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $4eac1b8021be0c88$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $4eac1b8021be0c88$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $4eac1b8021be0c88$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $4eac1b8021be0c88$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $4eac1b8021be0c88$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $4eac1b8021be0c88$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $4eac1b8021be0c88$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $4eac1b8021be0c88$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $4eac1b8021be0c88$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $4eac1b8021be0c88$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $4eac1b8021be0c88$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $4eac1b8021be0c88$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $4eac1b8021be0c88$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $4eac1b8021be0c88$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $4eac1b8021be0c88$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $4eac1b8021be0c88$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $4eac1b8021be0c88$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $4eac1b8021be0c88$export$798d2f5814884447);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $4eac1b8021be0c88$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $4eac1b8021be0c88$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $4eac1b8021be0c88$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $4eac1b8021be0c88$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $4eac1b8021be0c88$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $4eac1b8021be0c88$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $4eac1b8021be0c88$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $4eac1b8021be0c88$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $4eac1b8021be0c88$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $4eac1b8021be0c88$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $4eac1b8021be0c88$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $4eac1b8021be0c88$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $4eac1b8021be0c88$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $4eac1b8021be0c88$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $4eac1b8021be0c88$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $4eac1b8021be0c88$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $4eac1b8021be0c88$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $4eac1b8021be0c88$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $4eac1b8021be0c88$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $4eac1b8021be0c88$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $4eac1b8021be0c88$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $4eac1b8021be0c88$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $4eac1b8021be0c88$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $4eac1b8021be0c88$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $4eac1b8021be0c88$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $4eac1b8021be0c88$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $4eac1b8021be0c88$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $4eac1b8021be0c88$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $4eac1b8021be0c88$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $4eac1b8021be0c88$export$34317c2d84a93553);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $4eac1b8021be0c88$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $4eac1b8021be0c88$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $4eac1b8021be0c88$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $4eac1b8021be0c88$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $4eac1b8021be0c88$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $4eac1b8021be0c88$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $4eac1b8021be0c88$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $4eac1b8021be0c88$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $4eac1b8021be0c88$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $4eac1b8021be0c88$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $4eac1b8021be0c88$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $4eac1b8021be0c88$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $4eac1b8021be0c88$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $4eac1b8021be0c88$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $4eac1b8021be0c88$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $4eac1b8021be0c88$export$7b79405842547ccb);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $4eac1b8021be0c88$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $4eac1b8021be0c88$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $4eac1b8021be0c88$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $4eac1b8021be0c88$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $4eac1b8021be0c88$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $4eac1b8021be0c88$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $4eac1b8021be0c88$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $4eac1b8021be0c88$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $4eac1b8021be0c88$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $4eac1b8021be0c88$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $4eac1b8021be0c88$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $4eac1b8021be0c88$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $4eac1b8021be0c88$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $4eac1b8021be0c88$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $4eac1b8021be0c88$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $4eac1b8021be0c88$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $4eac1b8021be0c88$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $4eac1b8021be0c88$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $4eac1b8021be0c88$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $4eac1b8021be0c88$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $4eac1b8021be0c88$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $4eac1b8021be0c88$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $4eac1b8021be0c88$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $4eac1b8021be0c88$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $4eac1b8021be0c88$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $4eac1b8021be0c88$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $4eac1b8021be0c88$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $4eac1b8021be0c88$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $4eac1b8021be0c88$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $4eac1b8021be0c88$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $4eac1b8021be0c88$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $4eac1b8021be0c88$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $4eac1b8021be0c88$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $4eac1b8021be0c88$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $4eac1b8021be0c88$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $4eac1b8021be0c88$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $4eac1b8021be0c88$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $4eac1b8021be0c88$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $4eac1b8021be0c88$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $4eac1b8021be0c88$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $4eac1b8021be0c88$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $4eac1b8021be0c88$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $4eac1b8021be0c88$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $4eac1b8021be0c88$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $4eac1b8021be0c88$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $4eac1b8021be0c88$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $4eac1b8021be0c88$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $4eac1b8021be0c88$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $4eac1b8021be0c88$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "CONFERENCE_CALL_TYPE", () => $4eac1b8021be0c88$export$f7dcde9e9e88aff2);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $4eac1b8021be0c88$export$b5358afda8ff335e);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $4eac1b8021be0c88$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $4eac1b8021be0c88$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $4eac1b8021be0c88$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $4eac1b8021be0c88$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $4eac1b8021be0c88$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $4eac1b8021be0c88$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $4eac1b8021be0c88$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $4eac1b8021be0c88$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $4eac1b8021be0c88$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $4eac1b8021be0c88$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $4eac1b8021be0c88$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $4eac1b8021be0c88$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $4eac1b8021be0c88$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $4eac1b8021be0c88$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $4eac1b8021be0c88$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $4eac1b8021be0c88$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $4eac1b8021be0c88$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $4eac1b8021be0c88$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $4eac1b8021be0c88$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $4eac1b8021be0c88$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $4eac1b8021be0c88$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $4eac1b8021be0c88$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $4eac1b8021be0c88$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $4eac1b8021be0c88$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $4eac1b8021be0c88$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $4eac1b8021be0c88$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $4eac1b8021be0c88$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $4eac1b8021be0c88$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $4eac1b8021be0c88$export$3c3e26aadbfa2c32);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");
const $4eac1b8021be0c88$export$b144116dae474c88 = 'issue-link-search';
const $4eac1b8021be0c88$export$bc917bc699b25f75 = 'number';
const $4eac1b8021be0c88$export$5f26ca419fdffbe7 = 'string';
const $4eac1b8021be0c88$export$ce9bfd823c7e1a6d = 'datetime';
const $4eac1b8021be0c88$export$346b72b1f7cd6d5a = 'date';
const $4eac1b8021be0c88$export$b20fbcacd7942c2a = 'option2';
const $4eac1b8021be0c88$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $4eac1b8021be0c88$export$a2e8554bffc61ece = 'any';
const $4eac1b8021be0c88$export$f25cd4907cbb25b9 = 'array';
const $4eac1b8021be0c88$export$5600354b43577e17 = 'user';
const $4eac1b8021be0c88$export$5dbc9917f72d0d2a = 'group';
const $4eac1b8021be0c88$export$253649f07fb55948 = 'object';
const $4eac1b8021be0c88$export$eb39592ba5247ee7 = 'group-list';
const $4eac1b8021be0c88$export$f48a9be226105736 = 'array-string';
const $4eac1b8021be0c88$export$42e2e93fc721df5d = 'version';
const $4eac1b8021be0c88$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $4eac1b8021be0c88$export$7773375e72c953ed = 'approval-panel';
const $4eac1b8021be0c88$export$80ad0037098f3919 = 'project';
const $4eac1b8021be0c88$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $4eac1b8021be0c88$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $4eac1b8021be0c88$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $4eac1b8021be0c88$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $4eac1b8021be0c88$export$c979d9c548c05133 = 'JiraBooleanField';
const $4eac1b8021be0c88$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $4eac1b8021be0c88$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $4eac1b8021be0c88$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $4eac1b8021be0c88$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $4eac1b8021be0c88$export$b0deb225eed90fbd = 'JiraCMDBField';
const $4eac1b8021be0c88$export$add3775cfea8fde3 = 'JiraColorField';
const $4eac1b8021be0c88$export$9631d4098abab3eb = 'JiraComponentsField';
const $4eac1b8021be0c88$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $4eac1b8021be0c88$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $4eac1b8021be0c88$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $4eac1b8021be0c88$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $4eac1b8021be0c88$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $4eac1b8021be0c88$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $4eac1b8021be0c88$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $4eac1b8021be0c88$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $4eac1b8021be0c88$export$6d8da4497234455 = 'JiraEpicLinkField';
const $4eac1b8021be0c88$export$9bcfac568e4fa59c = 'JiraFlagField';
const $4eac1b8021be0c88$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $4eac1b8021be0c88$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $4eac1b8021be0c88$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $4eac1b8021be0c88$export$810709f0c5c2e9db = 'JiraLabelsField';
const $4eac1b8021be0c88$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $4eac1b8021be0c88$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $4eac1b8021be0c88$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $4eac1b8021be0c88$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $4eac1b8021be0c88$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $4eac1b8021be0c88$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $4eac1b8021be0c88$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $4eac1b8021be0c88$export$31aea7548807c6b5 = 'JiraPeopleField';
const $4eac1b8021be0c88$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $4eac1b8021be0c88$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $4eac1b8021be0c88$export$12f54499c6252188 = 'JiraProjectField';
const $4eac1b8021be0c88$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $4eac1b8021be0c88$export$c69486dd643dfb69 = 'JiraReporterField';
const $4eac1b8021be0c88$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $4eac1b8021be0c88$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $4eac1b8021be0c88$export$37f4daaa7b409554 = 'JiraRichTextField';
const $4eac1b8021be0c88$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $4eac1b8021be0c88$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $4eac1b8021be0c88$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $4eac1b8021be0c88$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $4eac1b8021be0c88$export$e40f819979b3881d = 'JiraStatusField';
const $4eac1b8021be0c88$export$6c243704a22baffe = 'JiraTeamField';
const $4eac1b8021be0c88$export$6c32429bac235203 = 'JiraTeamViewField';
const $4eac1b8021be0c88$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $4eac1b8021be0c88$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $4eac1b8021be0c88$export$37ccd11f08a93ccb = 'JiraUrlField';
const $4eac1b8021be0c88$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $4eac1b8021be0c88$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $4eac1b8021be0c88$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $4eac1b8021be0c88$export$aa815aaa741ae18 = 'JiraWatchesField';
const $4eac1b8021be0c88$export$e805f89b15d2abf4 = 'JiraAssetField';
const $4eac1b8021be0c88$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $4eac1b8021be0c88$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $4eac1b8021be0c88$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $4eac1b8021be0c88$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $4eac1b8021be0c88$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $4eac1b8021be0c88$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $4eac1b8021be0c88$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $4eac1b8021be0c88$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $4eac1b8021be0c88$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $4eac1b8021be0c88$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $4eac1b8021be0c88$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $4eac1b8021be0c88$export$c48132adab502d6b = 'JiraForgeUsersField';
const $4eac1b8021be0c88$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $4eac1b8021be0c88$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $4eac1b8021be0c88$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $4eac1b8021be0c88$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $4eac1b8021be0c88$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $4eac1b8021be0c88$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $4eac1b8021be0c88$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $4eac1b8021be0c88$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $4eac1b8021be0c88$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $4eac1b8021be0c88$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $4eac1b8021be0c88$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $4eac1b8021be0c88$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $4eac1b8021be0c88$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $4eac1b8021be0c88$export$bfcb1a91094f113a = 'JiraGoalsField';
const $4eac1b8021be0c88$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $4eac1b8021be0c88$export$798d2f5814884447 = 'forgeCustomField';
const $4eac1b8021be0c88$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $4eac1b8021be0c88$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $4eac1b8021be0c88$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $4eac1b8021be0c88$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $4eac1b8021be0c88$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $4eac1b8021be0c88$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $4eac1b8021be0c88$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $4eac1b8021be0c88$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $4eac1b8021be0c88$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $4eac1b8021be0c88$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $4eac1b8021be0c88$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $4eac1b8021be0c88$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $4eac1b8021be0c88$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $4eac1b8021be0c88$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $4eac1b8021be0c88$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $4eac1b8021be0c88$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $4eac1b8021be0c88$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $4eac1b8021be0c88$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $4eac1b8021be0c88$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $4eac1b8021be0c88$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $4eac1b8021be0c88$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $4eac1b8021be0c88$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $4eac1b8021be0c88$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $4eac1b8021be0c88$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $4eac1b8021be0c88$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $4eac1b8021be0c88$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $4eac1b8021be0c88$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $4eac1b8021be0c88$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $4eac1b8021be0c88$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $4eac1b8021be0c88$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $4eac1b8021be0c88$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $4eac1b8021be0c88$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $4eac1b8021be0c88$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $4eac1b8021be0c88$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $4eac1b8021be0c88$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $4eac1b8021be0c88$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $4eac1b8021be0c88$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $4eac1b8021be0c88$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $4eac1b8021be0c88$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $4eac1b8021be0c88$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $4eac1b8021be0c88$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $4eac1b8021be0c88$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $4eac1b8021be0c88$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $4eac1b8021be0c88$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $4eac1b8021be0c88$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $4eac1b8021be0c88$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $4eac1b8021be0c88$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $4eac1b8021be0c88$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $4eac1b8021be0c88$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $4eac1b8021be0c88$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $4eac1b8021be0c88$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $4eac1b8021be0c88$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $4eac1b8021be0c88$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $4eac1b8021be0c88$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $4eac1b8021be0c88$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $4eac1b8021be0c88$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $4eac1b8021be0c88$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $4eac1b8021be0c88$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $4eac1b8021be0c88$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $4eac1b8021be0c88$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $4eac1b8021be0c88$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $4eac1b8021be0c88$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $4eac1b8021be0c88$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $4eac1b8021be0c88$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $4eac1b8021be0c88$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $4eac1b8021be0c88$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $4eac1b8021be0c88$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $4eac1b8021be0c88$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $4eac1b8021be0c88$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $4eac1b8021be0c88$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $4eac1b8021be0c88$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $4eac1b8021be0c88$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $4eac1b8021be0c88$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $4eac1b8021be0c88$export$fba8634fd401ba8b = 'assignee';
const $4eac1b8021be0c88$export$a91aea2438afcce8 = 'reporter';
const $4eac1b8021be0c88$export$b159f8b8f27aae4c = 'duedate';
const $4eac1b8021be0c88$export$34740f8d07d23ac0 = 'priority';
const $4eac1b8021be0c88$export$43b6e33ec70f2272 = 'labels';
const $4eac1b8021be0c88$export$ff39ebd4bb12b718 = 'created';
const $4eac1b8021be0c88$export$cd8e68094cb5c3cb = 'updated';
const $4eac1b8021be0c88$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $4eac1b8021be0c88$export$37abf56f13f61ec5 = 'components';
const $4eac1b8021be0c88$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $4eac1b8021be0c88$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $4eac1b8021be0c88$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $4eac1b8021be0c88$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $4eac1b8021be0c88$export$791007408faf42f4 = 'servicedesk-incident-management';
const $4eac1b8021be0c88$export$827a1c600bac12a3 = 'devSummary';
const $4eac1b8021be0c88$export$e9ba671d077969f8 = 'releases';
const $4eac1b8021be0c88$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $4eac1b8021be0c88$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $4eac1b8021be0c88$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $4eac1b8021be0c88$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $4eac1b8021be0c88$export$a5c9f63aadcb220 = 'fixVersions';
const $4eac1b8021be0c88$export$94009605902e4fe5 = 'versions';
const $4eac1b8021be0c88$export$5e7324042f1d6b31 = 'description';
const $4eac1b8021be0c88$export$113281d03e6830ef = 'environment';
const $4eac1b8021be0c88$export$5ff798870a3dffbf = 'watches';
const $4eac1b8021be0c88$export$907219511d14ba3d = 'summary';
const $4eac1b8021be0c88$export$d09aa6a4f3538063 = 'proforma-forms';
const $4eac1b8021be0c88$export$3aca8c91b58a42e2 = 'resolution';
const $4eac1b8021be0c88$export$ccb5ffefbf8b987c = 'timetracking';
const $4eac1b8021be0c88$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $4eac1b8021be0c88$export$358267065be1e = 'status';
const $4eac1b8021be0c88$export$dcaa788c7ada56de = 'statusCategory';
const $4eac1b8021be0c88$export$ebb48b08205007c5 = 'issuetype';
const $4eac1b8021be0c88$export$5e91047fe9955d0e = 'issuekey';
const $4eac1b8021be0c88$export$3b3d0889022c85b3 = 'children-issues';
const $4eac1b8021be0c88$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $4eac1b8021be0c88$export$8fe3d5be8cb17459 = 'epic-issues';
const $4eac1b8021be0c88$export$335851d83a79891 = 'hierarchy-level-below';
const $4eac1b8021be0c88$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $4eac1b8021be0c88$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $4eac1b8021be0c88$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $4eac1b8021be0c88$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $4eac1b8021be0c88$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $4eac1b8021be0c88$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $4eac1b8021be0c88$export$7b3d247435a784fa = 'SLA_PANEL';
const $4eac1b8021be0c88$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $4eac1b8021be0c88$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $4eac1b8021be0c88$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $4eac1b8021be0c88$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $4eac1b8021be0c88$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $4eac1b8021be0c88$export$f7dcde9e9e88aff2 = 'CONFERENCE_CALL';
const $4eac1b8021be0c88$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $4eac1b8021be0c88$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $4eac1b8021be0c88$export$22f61ccc2730431f = 'similar-issues';
const $4eac1b8021be0c88$export$8bbb446f57294715 = 'subtasks';
const $4eac1b8021be0c88$export$34fcd7cb291a1e4d = 'votes';
const $4eac1b8021be0c88$export$5e93f2a57cc4ca3a = 'parent';
const $4eac1b8021be0c88$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $4eac1b8021be0c88$export$91a9dba2d38d9a6f = 'project';
const $4eac1b8021be0c88$export$df36fc05622c402 = 'worklog';
const $4eac1b8021be0c88$export$ede0a4c20124ec85 = 'timespent';
const $4eac1b8021be0c88$export$3eeb79d48fb5f667 = 'dataclassification';
const $4eac1b8021be0c88$export$45e72c9a63ab61ab = 'SENTIMENT';
const $4eac1b8021be0c88$export$99ad62164189f781 = 'ecosystemGlance';
const $4eac1b8021be0c88$export$7719ef6e9283671 = 'forgeGlance';
const $4eac1b8021be0c88$export$bfebea5ce2e1887a = 'ecosystemContext';
const $4eac1b8021be0c88$export$be8e68fb1aed253e = 'forgeContext';
const $4eac1b8021be0c88$export$84e5674890d55030 = 'issuerestriction';
const $4eac1b8021be0c88$export$326a5522a485e43d = 'security';
const $4eac1b8021be0c88$export$c9f3f01e2c535302 = 'securitylevel';
const $4eac1b8021be0c88$export$35e5652f764785bd = 'creator';
const $4eac1b8021be0c88$export$66519f3bbff1796a = 'team';
const $4eac1b8021be0c88$export$a4ee0bca77cc8463 = 'estimate';
const $4eac1b8021be0c88$export$fed53408e89e0497 = 'dueDate';
const $4eac1b8021be0c88$export$d53c26f9ce31f56b = 'targetStart';
const $4eac1b8021be0c88$export$48f82d653f85e459 = 'targetEnd';
const $4eac1b8021be0c88$export$ea5a888f39f722c7 = 'startDate';
const $4eac1b8021be0c88$export$f245bbec12cc0e40 = 'color';
const $4eac1b8021be0c88$export$aed630b4b7114a59 = 'attachment';
const $4eac1b8021be0c88$export$b50c1a8fef07104 = 'issuelinks';
const $4eac1b8021be0c88$export$ea3d72f4bb7738ba = 'timeestimate';
const $4eac1b8021be0c88$export$a4cab0124760d860 = 'comment';
const $4eac1b8021be0c88$export$734929aef118d7e2 = 'worklog';
const $4eac1b8021be0c88$export$ffbacacb07c1d46d = 'parent';
const $4eac1b8021be0c88$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $4eac1b8021be0c88$export$278c072e2f9176ab = 'aggregatetimespent';
const $4eac1b8021be0c88$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $4eac1b8021be0c88$export$fbc5ebe2e580bf8b = 'progress';
const $4eac1b8021be0c88$export$aa3b37e271efd578 = 'aggregateprogress';
const $4eac1b8021be0c88$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $4eac1b8021be0c88$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $4eac1b8021be0c88$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $4eac1b8021be0c88$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $4eac1b8021be0c88$export$34740f8d07d23ac0,
        REPORTER_TYPE: $4eac1b8021be0c88$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $4eac1b8021be0c88$export$5e7324042f1d6b31,
        LABELS_TYPE: $4eac1b8021be0c88$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $4eac1b8021be0c88$export$37abf56f13f61ec5,
        SPRINT_TYPE: $4eac1b8021be0c88$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $4eac1b8021be0c88$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $4eac1b8021be0c88$export$269d70c1b1c9fb80,
        EPIC_TYPE: $4eac1b8021be0c88$export$9f2fedcd916d2a79,
        FIX_VERSIONS_TYPE: $4eac1b8021be0c88$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $4eac1b8021be0c88$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $4eac1b8021be0c88$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $4eac1b8021be0c88$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $4eac1b8021be0c88$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $4eac1b8021be0c88$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $4eac1b8021be0c88$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $4eac1b8021be0c88$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $4eac1b8021be0c88$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $4eac1b8021be0c88$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $4eac1b8021be0c88$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $4eac1b8021be0c88$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $4eac1b8021be0c88$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $4eac1b8021be0c88$export$c7ae0622b0bd5d56,
        CONFERENCE_CALL_TYPE: $4eac1b8021be0c88$export$f7dcde9e9e88aff2,
        ASSETS_CF_TYPE: $4eac1b8021be0c88$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $4eac1b8021be0c88$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $4eac1b8021be0c88$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $4eac1b8021be0c88$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $4eac1b8021be0c88$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $4eac1b8021be0c88$export$e9ba671d077969f8,
        PARENT_CF_TYPE: $4eac1b8021be0c88$export$3e71e11f80203acb,
        BASELINE_START_CF_TYPE: $4eac1b8021be0c88$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $4eac1b8021be0c88$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $4eac1b8021be0c88$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $4eac1b8021be0c88$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $4eac1b8021be0c88$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $4eac1b8021be0c88$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $4eac1b8021be0c88$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $4eac1b8021be0c88$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $4eac1b8021be0c88$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $4eac1b8021be0c88$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $4eac1b8021be0c88$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $4eac1b8021be0c88$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $4eac1b8021be0c88$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $4eac1b8021be0c88$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $4eac1b8021be0c88$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $4eac1b8021be0c88$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $4eac1b8021be0c88$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $4eac1b8021be0c88$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $4eac1b8021be0c88$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $4eac1b8021be0c88$export$39866626496bbfc8,
        VERSION_CF_TYPE: $4eac1b8021be0c88$export$24382b4e8c58336b,
        DATE_CF_TYPE: $4eac1b8021be0c88$export$ff745f432984005d,
        GROUP_CF_TYPE: $4eac1b8021be0c88$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $4eac1b8021be0c88$export$b600addfa3355c57,
        USER_CF_TYPE: $4eac1b8021be0c88$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $4eac1b8021be0c88$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $4eac1b8021be0c88$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $4eac1b8021be0c88$export$65524be5675e57e6,
        TEAM_CF_TYPE: $4eac1b8021be0c88$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $4eac1b8021be0c88$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $4eac1b8021be0c88$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $4eac1b8021be0c88$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $4eac1b8021be0c88$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $4eac1b8021be0c88$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $4eac1b8021be0c88$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $4eac1b8021be0c88$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $4eac1b8021be0c88$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $4eac1b8021be0c88$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $4eac1b8021be0c88$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $4eac1b8021be0c88$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $4eac1b8021be0c88$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $4eac1b8021be0c88$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $4eac1b8021be0c88$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $4eac1b8021be0c88$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $4eac1b8021be0c88$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $4eac1b8021be0c88$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $4eac1b8021be0c88$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $4eac1b8021be0c88$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $4eac1b8021be0c88$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $4eac1b8021be0c88$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $4eac1b8021be0c88$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $4eac1b8021be0c88$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $4eac1b8021be0c88$export$2bbb7f69c97ea279
    };
    Object.assign(types, {
        FORGE_CONTEXT_TYPE: $4eac1b8021be0c88$export$be8e68fb1aed253e
    });
    if ((0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4')) Object.assign(types, {
        PARENT_TYPE: $4eac1b8021be0c88$export$5e93f2a57cc4ca3a
    });
    if ((0, $eI5EY.fg)('jsm-sentiment-analysis')) Object.assign(types, {
        SENTIMENT_TYPE: $4eac1b8021be0c88$export$45e72c9a63ab61ab
    });
    if ((0, $1ybV0.ff)('sentiment-custom-field')) Object.assign(types, {
        SENTIMENT_CF_TYPE: $4eac1b8021be0c88$export$c23cfbdf83daa90d
    });
    return types;
};
const $4eac1b8021be0c88$export$3c3e26aadbfa2c32 = (0, $5iWql.default)($4eac1b8021be0c88$var$getLayoutFieldTypesNonMemoized);

});


parcelRegister("6ZTsa", function(module, exports) {

$parcel$export(module.exports, "toErrorId", () => $36a0a2a2a499297e$export$706bbe4209d93dfe);
$parcel$export(module.exports, "toErrorMessage", () => $36a0a2a2a499297e$export$95506c204c060a3);
// Package name to be used in famaCatchAndLogFetchError and logError utils
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $36a0a2a2a499297e$export$706bbe4209d93dfe = (id)=>id;
const $36a0a2a2a499297e$export$95506c204c060a3 = (message)=>message;

});

parcelRegister("avawr", function(module, exports) {

$parcel$export(module.exports, "logError", () => $f57ea56200106b95$export$58da9968c3170cb1);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");
const $f57ea56200106b95$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
    // Send error log to analytics pipeline (i.e. SFX) and Sentry
    (0, $guiFP.default)({
        meta: {
            packageName: packageName,
            id: errorId,
            teamName: 'morphinecake'
        },
        attributes: {
            ...attributes,
            message: message
        },
        error: error
    });
    // Send error log to Splunk
    // We use this instead of `sendToPrivacyUnsafeSplunk` to preserve error message and custom properties
    const location = `${packageName}.${errorId}`;
    (0, $gUUjF.default).unsafeErrorWithCustomerData(location, message, error);
};

});




parcelRegister("dpXKE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e24a038ddb34e953$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $cM35R = parcelRequire("cM35R");
var $e24a038ddb34e953$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $cM35R.default));

});
parcelRegister("giAhk", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $208f42a3fdc9fe2c$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eUqFw = parcelRequire("eUqFw");

var $lxchL = parcelRequire("lxchL");

var $5JgJ2 = parcelRequire("5JgJ2");
const $208f42a3fdc9fe2c$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $208f42a3fdc9fe2c$var$getDisplayName(Component) {
    if ($208f42a3fdc9fe2c$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($208f42a3fdc9fe2c$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $208f42a3fdc9fe2c$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $5JgJ2.default)();
        const intlRef = (0, $eUqFw.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // Now is deprecated since version 2: https://github.com/formatjs/formatjs/issues/1409
            now: ()=>Date.now(),
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$208f42a3fdc9fe2c$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(WithIntl, WrappedComponent);
};

});

parcelRegister("cM35R", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa15d60f2ab7426b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aTgXo = parcelRequire("aTgXo");

var $5IARc = parcelRequire("5IARc");

var $6ulBk = parcelRequire("6ulBk");
const $fa15d60f2ab7426b$var$ProjectBreadcrumb = ({ isSimplifiedProject: isSimplifiedProject, children: children, projectKey: projectKey, projectName: projectName, projectId: projectId, intl: { formatMessage: formatMessage } })=>{
    const ProjectsBreadcrumb = {
        href: '/jira/projects',
        text: formatMessage((0, $6ulBk.default).projectsTitle),
        type: 'projectsDirectory',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToProjectsList'
        }
    };
    if (projectKey != null && projectName != null) {
        const breadcrumb = {
            href: (0, $5IARc.createProjectUrl)(projectKey),
            text: projectName,
            type: 'projectName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToProject',
                containerId: projectId,
                containerType: 'project'
            }
        };
        const ProjectNameBreadcrumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
            breadcrumb: breadcrumb
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
            breadcrumb: ProjectsBreadcrumb
        }, ProjectNameBreadcrumb);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: ProjectsBreadcrumb
    }, children);
};
$fa15d60f2ab7426b$var$ProjectBreadcrumb.defaultProps = {
    children: null,
    isSimplifiedProject: false,
    projectId: undefined,
    projectKey: undefined,
    projectName: undefined
};
var $fa15d60f2ab7426b$export$2e2bcd8739ae039 = $fa15d60f2ab7426b$var$ProjectBreadcrumb;

});
parcelRegister("6ulBk", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cb70b0ebc38fe07$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9cb70b0ebc38fe07$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title",
        "defaultMessage": "Projects"
    }
});

});



parcelRegister("5c2C3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a95e6e6f9b00b47$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aTgXo = parcelRequire("aTgXo");
const $4a95e6e6f9b00b47$var$UserBreadcrumb = ({ children: children, name: name, profileUrl: profileUrl })=>{
    const breadcrumb = {
        href: profileUrl,
        text: name,
        type: 'userName'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: breadcrumb
    }, children);
};
var $4a95e6e6f9b00b47$export$2e2bcd8739ae039 = $4a95e6e6f9b00b47$var$UserBreadcrumb;

});

parcelRegister("1bzuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $75132222441dd418$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $75132222441dd418$var$toBreadcrumbData = ({ id: id, index: index, ...legacyCrumb })=>({
        ...legacyCrumb,
        legacyId: id,
        type: 'legacy'
    });
const $75132222441dd418$var$ContextBreadcrumbs = ({ ContextProvider: ContextProvider, ProjectBreadcrumb: ProjectBreadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContextProvider, null, ({ data: data })=>{
        if (!data) return children;
        const boardBreadcrumb = data.scope ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BoardBreadcrumb, {
            boardId: data.scope.id,
            boardName: data.scope.name || 'Board'
        }, children) : children;
        return data.contextType === 'user' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UserBreadcrumb, {
            profileUrl: data.user.profileUrl,
            name: data.user.name
        }, boardBreadcrumb) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectBreadcrumb, {
            projectKey: data.project.key,
            projectName: data.project.name,
            projectId: data.project.id,
            isSimplifiedProject: data.project.isSimplified
        }, boardBreadcrumb);
    });
const $75132222441dd418$var$LegacyBreadcrumbConnector = ({ legacyTrail: legacyTrail, Breadcrumb: Breadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, ProjectBreadcrumb: ProjectBreadcrumb, ContextProvider: ContextProvider })=>{
    const accumulateBreadcrumb = (accumulatedCrumbs, currentCrumb)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Breadcrumb, {
            breadcrumb: currentCrumb
        }, accumulatedCrumbs);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75132222441dd418$var$ContextBreadcrumbs, {
        BoardBreadcrumb: BoardBreadcrumb,
        ProjectBreadcrumb: ProjectBreadcrumb,
        UserBreadcrumb: UserBreadcrumb,
        ContextProvider: ContextProvider
    }, legacyTrail.map($75132222441dd418$var$toBreadcrumbData).reverse().reduce(accumulateBreadcrumb, null));
};
var $75132222441dd418$export$2e2bcd8739ae039 = $75132222441dd418$var$LegacyBreadcrumbConnector;

});

parcelRegister("i7f3H", function(module, exports) {

$parcel$export(module.exports, "default", () => $797e4a145a4e40c7$export$2e2bcd8739ae039);

var $kFGm5 = parcelRequire("kFGm5");

var $SEaoU = parcelRequire("SEaoU");

var $lB25E = parcelRequire("lB25E");
const $797e4a145a4e40c7$export$9f27bc3417b4524d = ({ children: children })=>{
    const [boardId] = (0, $lB25E.usePathParam)('boardId');
    const [rapidView] = (0, $lB25E.useQueryParam)('rapidView');
    const [{ data: ctxData, loading: loading, error: error }] = (0, $SEaoU.useContainerContext)();
    /* Don't provide scope data if boardId does not exist in the URL as
	 * we don't want to show the board breadcrumb in this case since it
	 * indicates that we aren't in a scope context even though one may
	 * exist. */ const data = ctxData == null || boardId != null || rapidView != null ? ctxData : (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(ctxData, 'scope');
    // @ts-expect-error - TS2322 - Type 'Pick<ProjectContext | UserContext, "contextType"> | null' is not assignable to type 'ContainerContext | null'. | TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null'.
    return children({
        data: data,
        loading: loading,
        error: error
    });
};
var $797e4a145a4e40c7$export$2e2bcd8739ae039 = $797e4a145a4e40c7$export$9f27bc3417b4524d;

});
parcelRegister("SEaoU", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $753bd1908e635680$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $753bd1908e635680$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $4MmfV = parcelRequire("4MmfV");

var $kXWpU = parcelRequire("kXWpU");

var $lB25E = parcelRequire("lB25E");

var $e8UKN = parcelRequire("e8UKN");
const $753bd1908e635680$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource));
    const projectContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $753bd1908e635680$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)((0, $4MmfV.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $753bd1908e635680$export$c7066c2d215990cf = ()=>{
    const projectContext = $753bd1908e635680$var$useProjectContext();
    const userBoardContext = $753bd1908e635680$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $753bd1908e635680$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $753bd1908e635680$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$753bd1908e635680$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("4MmfV", function(module, exports) {

$parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", () => $ca35414721fafc7a$export$5839dd8142de842e);

var $gUUjF = parcelRequire("gUUjF");

var $ElVpH = parcelRequire("ElVpH");

var $lB25E = parcelRequire("lB25E");

var $9SjeY = parcelRequire("9SjeY");
const $ca35414721fafc7a$export$5839dd8142de842e = (0, $lB25E.createResource)({
    type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        if (boardId == null) return null;
        try {
            const response = await (0, $9SjeY.fetchUserBoardNavigationData)(boardId);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
            return null;
        }
    },
    maxAge: 300000
});

});
parcelRegister("9SjeY", function(module, exports) {

$parcel$export(module.exports, "fetchUserBoardNavigationData", () => $7d7ff3f2c7ca5c69$export$306fb49fca60b34);

var $lRmyA = parcelRequire("lRmyA");
const $7d7ff3f2c7ca5c69$export$306fb49fca60b34 = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
};

});


parcelRegister("e8UKN", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $4c7bf04e2602d89a$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $4c7bf04e2602d89a$export$d17fffd59c7b3c60);

var $7ZZxN = parcelRequire("7ZZxN");

var $eWsAG = parcelRequire("eWsAG");
const $4c7bf04e2602d89a$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $4c7bf04e2602d89a$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $4c7bf04e2602d89a$var$getProjectType = (projectType)=>{
    switch(projectType){
        case 'business':
            return 0, $7ZZxN.CORE_PROJECT;
        case 'software':
            return 0, $7ZZxN.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $7ZZxN.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $4c7bf04e2602d89a$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $eWsAG.extractData)(projectNavInfo);
    const scope = $4c7bf04e2602d89a$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $4c7bf04e2602d89a$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $eWsAG.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});




parcelRegister("l02Yw", function(module, exports) {

$parcel$export(module.exports, "default", () => $01f727a32ba5bcb5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $gUUjF = parcelRequire("gUUjF");

var $c76ap = parcelRequire("c76ap");
const $01f727a32ba5bcb5$var$LOCATION = 'breadcrumbs.legacy-adapter.legacy-renderer';
class $01f727a32ba5bcb5$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidCatch(error) {
        /*
            This error boundary is added to adapt to a runtime error caused by createPortal method in IE 11
        */ const { targetElement: targetElement } = this.props;
        const targetId = targetElement ? targetElement.id : 'not-found';
        (0, $gUUjF.default).safeErrorWithoutCustomerData($01f727a32ba5bcb5$var$LOCATION, `Failed to createPortal on ${targetId}`, error);
    }
    render() {
        const { targetElement: targetElement } = this.props;
        return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null), targetElement);
    }
}

});
parcelRegister("c76ap", function(module, exports) {

$parcel$export(module.exports, "default", () => $157232e24a15a7c6$export$2e2bcd8739ae039);

var $2Enn0 = parcelRequire("2Enn0");

var $knPb9 = parcelRequire("knPb9");

var $gd0Sp = parcelRequire("gd0Sp");

var $7Eg4C = parcelRequire("7Eg4C");
const $157232e24a15a7c6$var$fireAnalytics = (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
        name: 'breadcrumbRendererMounted'
    });
var $157232e24a15a7c6$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $7Eg4C.default), {
    onMount: $157232e24a15a7c6$var$fireAnalytics,
    TenantContextSubscriber: $gd0Sp.TenantContextSubscriber
});

});
parcelRegister("7Eg4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $c269d0ea4cb311cb$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eGI9v = parcelRequire("eGI9v");

var $eI5EY = parcelRequire("eI5EY");

var $6RcYY = parcelRequire("6RcYY");

var $6FP8W = parcelRequire("6FP8W");

var $bfY8R = parcelRequire("bfY8R");
// Adapt to prop type from breadcrumbs app
const $c269d0ea4cb311cb$var$mapTrailToBreadcrumbItems = (trail)=>trail.map((crumb)=>({
            ...crumb,
            target: crumb.target || '_self'
        }));
const $c269d0ea4cb311cb$var$BreadcrumbRenderer = ({ onMount: onMount })=>{
    const [{ trail: trail }] = (0, $bfY8R.useBreadcrumbs)();
    const items = (0, $eUqFw.useMemo)(()=>$c269d0ea4cb311cb$var$mapTrailToBreadcrumbItems(trail), [
        trail
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(onMount, []);
    if ((0, $6FP8W.getWillShowNav4)() && (0, $eI5EY.fg)('jira_nav4_eap_drop_1')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c269d0ea4cb311cb$var$BreadcrumbsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6RcYY.default), {
        isVisible: true,
        items: items
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c269d0ea4cb311cb$var$BreadcrumbsWrapperOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6RcYY.default), {
        isVisible: true,
        items: items
    }));
};
var $c269d0ea4cb311cb$export$2e2bcd8739ae039 = (0, $eGI9v.default)('breadcrumbsRenderer', {
    onMount: 'mounted'
})($c269d0ea4cb311cb$var$BreadcrumbRenderer);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c269d0ea4cb311cb$var$BreadcrumbsWrapperOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tke1tcg",
            __cmplp.className
        ])
    });
});
const $c269d0ea4cb311cb$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tke1tcg _nwukkwex _1o8hu22k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6RcYY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4d601e3e8e4661b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5BRby = parcelRequire("5BRby");

var $hNmmb = parcelRequire("hNmmb");
function $f4d601e3e8e4661b$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hNmmb.default), {
        isVisible: isVisible,
        items: items
    }));
}

});
parcelRegister("hNmmb", function(module, exports) {

$parcel$export(module.exports, "default", () => $dce70756fb908cd7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $jG2Eu = parcelRequire("jG2Eu");

var $bm5l8 = parcelRequire("bm5l8");
var $asKFY = parcelRequire("asKFY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $5ivsr = parcelRequire("5ivsr");

var $5bE8c = parcelRequire("5bE8c");
const $dce70756fb908cd7$export$67abef37aa2929b0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
        ...props,
        ref: ref,
        type: "a"
    }));
function $dce70756fb908cd7$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return isVisible ? // onExpand is required prop in atlaskit's breadcrumbitem component
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $asKFY.default), {
        onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(items) ? // This is needed in order to render an empty breadcrumb for SSR, to avoid visual jumping when javascript kicks in.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), {
        text: "",
        "aria-label": formatMessage((0, $5bE8c.default).breadcrumbsLabel)
    }) : items.map((breadcrumb, index)=>{
        const breadcrumbItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ivsr.default), {
            key: index,
            index: index,
            hasSeparator: true,
            text: breadcrumb.text,
            target: __SPA__ ? undefined : breadcrumb.target,
            href: breadcrumb.href,
            component: __SPA__ ? $dce70756fb908cd7$export$67abef37aa2929b0 : undefined,
            legacyId: breadcrumb.legacyId,
            type: breadcrumb.type,
            analyticsAttributes: breadcrumb.analyticsAttributes,
            analyticsFields: breadcrumb.analyticsFields
        });
        return breadcrumbItem;
    }))) : null;
}

});
parcelRegister("bm5l8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6802065d7b1f5207$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2eG9N = parcelRequire("2eG9N");

var $5eukW = parcelRequire("5eukW");

var $fwtof = parcelRequire("fwtof");
function $6802065d7b1f5207$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6802065d7b1f5207$var$itemWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    maxWidth: '100%',
    height: `${24 / 14}em`,
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    flexDirection: 'row',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:not(:last-child)::after': {
        width: '8px',
        flexShrink: 0,
        content: '"/"',
        paddingBlock: "var(--ds-space-025, 2px)",
        paddingInline: "var(--ds-space-100, 8px)",
        textAlign: 'center'
    }
});
const $6802065d7b1f5207$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $6802065d7b1f5207$var$ICON_WIDTH_ESTIMATE = 24;
const $6802065d7b1f5207$var$staticItemStyles = {
    name: "16sxe12",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-025, 2px)"
};
const $6802065d7b1f5207$var$staticItemWithTruncationStyles = /*#__PURE__*/ (0, $byn9U.css)({
    maxWidth: `var(${$6802065d7b1f5207$var$VAR_STEP_TRUNCATION_WIDTH})`
});
const $6802065d7b1f5207$var$staticItemWithoutTruncationStyles = {
    name: "1t1nv0p",
    styles: "min-width:0;flex-shrink:1"
};
const $6802065d7b1f5207$var$BreadcrumbsItem = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const buttonRef = (0, $eUqFw.useRef)(null);
    const { truncationWidth: truncationWidth, text: text, onTooltipShown: onTooltipShown, ...restButtonProps } = props;
    // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (props.iconBefore) iconWidthAllowance += $6802065d7b1f5207$var$ICON_WIDTH_ESTIMATE;
    if (props.iconAfter) iconWidthAllowance += $6802065d7b1f5207$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $fwtof.default)(truncationWidth, buttonRef.current, iconWidthAllowance);
    const buttonProps = {
        ...restButtonProps,
        ref: buttonRef,
        hasOverflow: hasOverflow
    };
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$6802065d7b1f5207$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = truncationWidth ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $5eukW.default), {
        ...buttonProps,
        css: [
            $6802065d7b1f5207$var$staticItemStyles,
            $6802065d7b1f5207$var$staticItemWithTruncationStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicItemStyles
    }, text) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $5eukW.default), {
        ...buttonProps,
        css: [
            $6802065d7b1f5207$var$staticItemStyles,
            $6802065d7b1f5207$var$staticItemWithoutTruncationStyles
        ]
    }, text);
    return /*#__PURE__*/ (0, $byn9U.jsx)("li", {
        css: $6802065d7b1f5207$var$itemWrapperStyles
    }, showTooltip ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, step) : step);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6802065d7b1f5207$export$2e2bcd8739ae039 = $6802065d7b1f5207$var$BreadcrumbsItem;

});
parcelRegister("5eukW", function(module, exports) {

$parcel$export(module.exports, "default", () => $69c4b1ea675a45cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $7u4fN = parcelRequire("7u4fN");

var $5Q9wj = parcelRequire("5Q9wj");
const $69c4b1ea675a45cb$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $69c4b1ea675a45cb$var$noop = (0, $5Q9wj.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $69c4b1ea675a45cb$var$Step = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ hasOverflow: hasOverflow = true, href: href = '#', onClick: onClickProvided = $69c4b1ea675a45cb$var$noop, analyticsContext: analyticsContext, iconBefore: iconBefore, iconAfter: iconAfter, ...props }, ref)=>{
    const handleClicked = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$69c4b1ea675a45cb$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "none",
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        href: href,
        ...props
    });
});
var $69c4b1ea675a45cb$export$2e2bcd8739ae039 = $69c4b1ea675a45cb$var$Step;

});

parcelRegister("fwtof", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae4167537c909a75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $ae4167537c909a75$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $eUqFw.useState)(true);
    const [showTooltip, setShowTooltip] = (0, $eUqFw.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $eUqFw.useEffect)(()=>{
        if (truncationWidth && buttonRefCurrent) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});


parcelRegister("asKFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fe49be245af1af9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");


var $1xCDT = parcelRequire("1xCDT");

var $f8Yph = parcelRequire("f8Yph");
function $5fe49be245af1af9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5fe49be245af1af9$var$defaultMaxItems = 8;
const $5fe49be245af1af9$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $5fe49be245af1af9$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $5fe49be245af1af9$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children;
const $5fe49be245af1af9$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $5fe49be245af1af9$var$noop = (0, $5Q9wj.default);
const $5fe49be245af1af9$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $5fe49be245af1af9$var$breadcrumbStyles = {
    name: "m6vsls",
    styles: "display:flex;margin:var(--ds-space-0, 0px);padding:var(--ds-space-0, 0px);flex-wrap:wrap"
};
const $5fe49be245af1af9$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $5fe49be245af1af9$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $5fe49be245af1af9$var$noop, analyticsContext: analyticsContext, label: label = $5fe49be245af1af9$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $5fe49be245af1af9$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $eUqFw.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $eUqFw.useState)(false);
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $5fe49be245af1af9$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealed = ()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($5fe49be245af1af9$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    };
    (0, $f8Yph.useOnRevealed)(focusFirstRevealed, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$5fe49be245af1af9$var$analyticsAttributes
    });
    const childrenArray = $5fe49be245af1af9$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $byn9U.jsx)((0, $1xCDT.default), {
                key: "ellipsis",
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $byn9U.jsx)("nav", {
        "aria-label": label,
        ref: (0, $1lQG9.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)("ol", {
        "data-testid": testId,
        css: $5fe49be245af1af9$var$breadcrumbStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`
        }
    }, breadcrumbsItems));
});
const $5fe49be245af1af9$var$Breadcrumbs = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($5fe49be245af1af9$var$InnerBreadcrumbs, {
        ...props,
        ref: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5fe49be245af1af9$export$2e2bcd8739ae039 = $5fe49be245af1af9$var$Breadcrumbs;

});
parcelRegister("1xCDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $253eb3de3ba0dc58$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7u4fN = parcelRequire("7u4fN");

var $5Q9wj = parcelRequire("5Q9wj");
function $253eb3de3ba0dc58$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $253eb3de3ba0dc58$var$noop = (0, $5Q9wj.default);
const $253eb3de3ba0dc58$var$itemWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    maxWidth: '100%',
    height: `${24 / 14}em`,
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    flexDirection: 'row',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:not(:last-child)::after': {
        width: "var(--ds-space-100, 8px)",
        flexShrink: 0,
        content: '"/"',
        paddingBlock: "var(--ds-space-025, 2px)",
        paddingInline: "var(--ds-space-100, 8px)",
        textAlign: 'center'
    }
});
const $253eb3de3ba0dc58$var$staticItemStyles = {
    name: "16sxe12",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-025, 2px)"
};
const $253eb3de3ba0dc58$var$EllipsisItem = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { onClick: onClick = $253eb3de3ba0dc58$var$noop, testId: testId, label: label } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("li", {
        css: $253eb3de3ba0dc58$var$itemWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "none",
        testId: testId,
        onClick: onClick,
        "aria-label": label,
        css: $253eb3de3ba0dc58$var$staticItemStyles
    }, "\u2026"));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$253eb3de3ba0dc58$export$2e2bcd8739ae039 = $253eb3de3ba0dc58$var$EllipsisItem;

});

parcelRegister("f8Yph", function(module, exports) {

$parcel$export(module.exports, "useOnRevealed", () => $3d09583e8ce00568$export$e9c4922b2ecf808a);

var $eUqFw = parcelRequire("eUqFw");

var $d7Ieg = parcelRequire("d7Ieg");
function $3d09583e8ce00568$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $d7Ieg.default)(isExpanded);
    (0, $eUqFw.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});


parcelRegister("5ivsr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a590e2f2ad7c58d3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bm5l8 = parcelRequire("bm5l8");

var $iMMQz = parcelRequire("iMMQz");
class $a590e2f2ad7c58d3$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            href: undefined,
            legacyId: undefined,
            type: 'unspecified',
            analyticsAttributes: {},
            analyticsFields: {}
        };
    }
    render() {
        const { index: index, text: text, target: target, href: href, component: component } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), {
            key: index,
            text: text,
            // @ts-expect-error - TS2322 - Type '(event: Event, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '(event: MouseEvent<Element, MouseEvent>) => void'.
            onClick: this.onBreadCrumbClick,
            target: target,
            href: href,
            component: component
        });
    }
    constructor(...args){
        super(...args);
        this.onBreadCrumbClick = (event, analyticsEvent)=>{
            const { legacyId: legacyId, index: index, type: type, analyticsAttributes: analyticsAttributes, analyticsFields: analyticsFields } = this.props;
            (0, $iMMQz.fireUiAnalytics)(analyticsEvent, {
                name: '',
                attributes: {
                    legacyId: legacyId,
                    // change this depth value to be zero based, once Jira home crumb is added
                    depth: index + 1,
                    type: type,
                    ...analyticsAttributes
                },
                ...analyticsFields
            });
        };
    }
}

});
parcelRegister("iMMQz", function(module, exports) {

$parcel$export(module.exports, "fireUiAnalytics", () => $087b448d474fca07$export$4909253b5bf1eed7);

var $3LiTJ = parcelRequire("3LiTJ");

var $etqm0 = parcelRequire("etqm0");

var $klunD = parcelRequire("klunD");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $087b448d474fca07$var$isNotUndefined = (a)=>a !== undefined;
const $087b448d474fca07$var$mapPayload = (payload)=>{
    const context = (0, $klunD.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $087b448d474fca07$var$isNotUndefined);
};
const $087b448d474fca07$export$4909253b5bf1eed7 = (event, payload)=>{
    event.update({
        ...$087b448d474fca07$var$mapPayload(payload),
        analyticsType: (0, $etqm0.UI_EVENT_TYPE)
    }).fire();
};

});


parcelRegister("5bE8c", function(module, exports) {

$parcel$export(module.exports, "default", () => $19d3cfff259c7c19$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $19d3cfff259c7c19$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    breadcrumbsLabel: {
        "id": "navigation-apps.breadcrumbs.aria-label",
        "defaultMessage": "Empty Breadcrumbs item"
    }
});

});






parcelRegister("jU94X", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fec23ecbb70be91$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $1fec23ecbb70be91$var$compareBreadcrumbs = (a, b)=>a.index - b.index;
const $1fec23ecbb70be91$var$defaultInitialState = {
    trail: [],
    targetElement: null
};
class $1fec23ecbb70be91$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            initialState: $1fec23ecbb70be91$var$defaultInitialState
        };
    }
    constructor(props){
        super(props);
        this.onInsertItem = (item)=>{
            this.setState((state)=>({
                    trail: [
                        ...state.trail,
                        item
                    ].sort($1fec23ecbb70be91$var$compareBreadcrumbs)
                }));
        };
        this.onRemoveItem = (id)=>{
            this.setState((state)=>({
                    trail: state.trail.filter((b)=>b.id !== id)
                }));
        };
        /* eslint-disable react/no-unused-state */ this.onTargetSet = (targetElement)=>{
            this.setState({
                targetElement: targetElement
            });
        };
        /* eslint-enable react/no-unused-state */ this.api = {
            setTargetElement: this.onTargetSet,
            insertItem: this.onInsertItem,
            removeItem: this.onRemoveItem
        };
        this.state = props.initialState;
    }
    render() {
        const { children: children } = this.props;
        return children({
            state: this.state,
            api: this.api
        });
    }
}

});



parcelRegister("6Q9xY", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $00e2f5c25335239e$export$6e4bfef9e80c7eb0);

var $eUqFw = parcelRequire("eUqFw");

var $a5cKA = parcelRequire("a5cKA");

var $epT40 = parcelRequire("epT40");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $00e2f5c25335239e$export$6e4bfef9e80c7eb0 = ()=>{
    const [{ hasLoaded: hasLoaded }] = (0, $epT40.default)();
    const { resetPhase: resetPhase, startNextPhase: startNextPhase } = (0, $a5cKA.useLazyPhase)();
    (0, $eUqFw.useEffect)(()=>{
        if (hasLoaded) {
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        } else resetPhase();
    }, [
        hasLoaded,
        resetPhase,
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("egQj9", function(module, exports) {

$parcel$export(module.exports, "TrackClicksBeforeTTI", () => $8480cc5e657aa91b$export$2846c12b8c092470);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $h3mHU = parcelRequire("h3mHU");
const $8480cc5e657aa91b$var$cleanUrl = (pathname)=>{
    let url = pathname.replace(/\/$/, '');
    // /browse redirects or sw classic redirects
    if (/\/browse\/\w+$/.test(url)) url = 'browse';
    // replaces any occurrence of two or more capital letters,
    // or one capital letter followed by a number and also
    // two or more capital letters followed by a dash and any amount of numbers
    // (should catch all project and issue keys)
    if (/[A-Z][A-Z0-9]+(-[\d]+)*/g.test(url)) url = url.replace(/[A-Z][A-Z0-9]+(-[\d]+)*/g, 'XX');
    return url;
};
/**
 * Handles the collection and processing of user interactions that occur before the page becomes fully interactive. This enhances the understanding of user behavior during the initial loading phase.
 */ const $8480cc5e657aa91b$export$2846c12b8c092470 = ()=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (!isReady) return;
        try {
            const sessionStorageItems = sessionStorage.getItem('clicks-before-tti');
            if (sessionStorageItems == null || sessionStorageItems === '') return;
            const items = JSON.parse(sessionStorageItems);
            items.forEach((item)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                let extras = {
                    elementId: item.dataId,
                    currentUrl: $8480cc5e657aa91b$var$cleanUrl(item.currentUrl),
                    bundleId: item.bundleId,
                    time: item.time
                };
                if (item.redirectUrl !== '') extras = {
                    ...extras,
                    redirectUrl: $8480cc5e657aa91b$var$cleanUrl(item.redirectUrl)
                };
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                    action: 'clicked'
                }), 'nonInteractiveElement clicked', '', extras);
            });
            sessionStorage.removeItem('clicks-before-tti');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, [
        createAnalyticsEvent,
        isReady
    ]);
    return null;
};

});

parcelRegister("1YvhU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("aCUnj")
]).then(()=>parcelRequire('es1Wq'));

});

parcelRegister("9desP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fV06J").then(()=>parcelRequire('ePK6n'));

});

parcelRegister("bWhFx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hwGR4").then(()=>parcelRequire('l6iDs'));

});

parcelRegister("V8FqF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1QTcH").then(()=>parcelRequire('4y252'));

});

parcelRegister("lJUyT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("a7aUZ")
]).then(()=>parcelRequire('2J0VA'));

});

parcelRegister("gvsYN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jZhM1").then(()=>parcelRequire('lG0uN'));

});

parcelRegister("z8DAf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fAZBS").then(()=>parcelRequire('1r7p7'));

});


parcelRegister("69Ipc", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $bc08f35853510f48$export$3b4e64e77073e307);

var $eUqFw = parcelRequire("eUqFw");

var $c9TLT = parcelRequire("c9TLT");


var $6e8MH = parcelRequire("6e8MH");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $eI5EY = parcelRequire("eI5EY");

var $4IEye = parcelRequire("4IEye");

var $4Txs1 = parcelRequire("4Txs1");

var $6FP8W = parcelRequire("6FP8W");

var $hwyJ1 = parcelRequire("hwyJ1");

var $ksulR = parcelRequire("ksulR");

var $NzrZv = parcelRequire("NzrZv");

var $7Rdn2 = parcelRequire("7Rdn2");

var $bFh4f = parcelRequire("bFh4f");

var $imSzy = parcelRequire("imSzy");

var $j3cff = parcelRequire("j3cff");

var $8fKcN = parcelRequire("8fKcN");

var $bBqV2 = parcelRequire("bBqV2");

var $4E80X = parcelRequire("4E80X");

var $jK1pm = parcelRequire("jK1pm");

var $3EdDr = parcelRequire("3EdDr");
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 */ const $bc08f35853510f48$var$TEST_ID = 'page-layout.banner';
const $bc08f35853510f48$export$496ffd8dda3bf451 = ()=>{
    const banner = (0, $ksulR.useBanner)();
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.Banner), {
        height: banner.height,
        testId: $bc08f35853510f48$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc08f35853510f48$var$BannerContent, {
        bannerName: banner.name
    }))) : null;
};
const $bc08f35853510f48$export$b5cfff585ada92ce = ()=>{
    const banner = (0, $ksulR.useBanner)();
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EdDr.ZIndexWrapper), {
        zIndex: (0, $c9TLT.layers).banner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.Banner), {
        height: banner.height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc08f35853510f48$var$BannerContent, {
        bannerName: banner.name
    })))) : null;
};
const $bc08f35853510f48$var$BannerContent = ({ bannerName: bannerName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, bannerName === (0, $NzrZv.NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Rdn2.BannerAnnouncementAsync), null), bannerName === (0, $4IEye.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Txs1.IPBlocklistingBannerAsync), null), bannerName === (0, $bBqV2.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4E80X.ReturnToMobileBanner), null), bannerName === (0, $539c74e86514eccc$export$41956b146268af93) && (0, $eI5EY.fg)('jfp-magma-cookie-controls-banner-show') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6e8MH.CookieConsentBannerAsync), null), (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && bannerName === (0, $bFh4f.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imSzy.BannerTransitionAsync), null), bannerName === (0, $j3cff.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fKcN.MailExpiryBannerAsync), null));
const $bc08f35853510f48$export$3b4e64e77073e307 = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $bc08f35853510f48$export$496ffd8dda3bf451, $bc08f35853510f48$export$b5cfff585ada92ce);

});
const $539c74e86514eccc$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $539c74e86514eccc$export$ed7cc0d417ee89e = 74;
const $539c74e86514eccc$export$ff6e18f7d82b549c = 320;

parcelRegister("6e8MH", function(module, exports) {

$parcel$export(module.exports, "CookieConsentBannerAsync", () => $6ae4df6ce003b8ba$export$f110a9cbbbd3fa3a);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ae4df6ce003b8ba$var$LazyCookieConsentBanner = (0, $6VZoe.lazy)(()=>// chunk name is async-ccb to avoid scripts with cookie/banner keywords getting blocked
    (parcelRequire("4sLoh")).then(({ CookieConsentBanner: CookieConsentBanner })=>CookieConsentBanner), {
    moduleId: "./src/packages/platform/ui/banners/cookie-consent/src/ui/banner/index.tsx"
});
const $6ae4df6ce003b8ba$export$f110a9cbbbd3fa3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6ae4df6ce003b8ba$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-cookie-consent-banner",
        packageName: "jiraCookieConsentBanner",
        teamName: "Magma"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-cookie-consent-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ae4df6ce003b8ba$var$LazyCookieConsentBanner, null))));
const $6ae4df6ce003b8ba$var$boxStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    height: '100%'
});

});
parcelRegister("4sLoh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kL0QP")
]).then(()=>parcelRequire('lEX9v'));

});


parcelRegister("4IEye", function(module, exports) {

$parcel$export(module.exports, "bannerHeight", () => $fcd3ab7edefdaf4a$export$86047f02632f9f5b);
$parcel$export(module.exports, "BANNER_NAME", () => $fcd3ab7edefdaf4a$export$41956b146268af93);

var $c9TLT = parcelRequire("c9TLT");
const $fcd3ab7edefdaf4a$export$86047f02632f9f5b = (0, $c9TLT.gridSize) * 7;
const $fcd3ab7edefdaf4a$export$41956b146268af93 = 'IP_BLOCK_LISTING_BANNER';

});

parcelRegister("4Txs1", function(module, exports) {

$parcel$export(module.exports, "IPBlocklistingBannerAsync", () => $2ebc627ad20df82b$export$fafc306b802ab39d);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ebc627ad20df82b$var$IPBlocklistingBannerComp = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("67Q6Y")).then((m)=>m.IPBlocklistingBanner), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/ip-block-listing-banner/src/main.tsx"
});
const $2ebc627ad20df82b$export$fafc306b802ab39d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-ip-block-listing-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ebc627ad20df82b$var$IPBlocklistingBannerComp, null));

});
parcelRegister("67Q6Y", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("dHXbi")
]).then(()=>parcelRequire('4hBj3'));

});


parcelRegister("ksulR", function(module, exports) {

$parcel$export(module.exports, "useBanner", () => $1c81254a40e33e49$export$de40f69ba30f2376);

var $eUqFw = parcelRequire("eUqFw");

var $N5dQV = parcelRequire("N5dQV");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $dFuN9 = parcelRequire("dFuN9");

var $4u3Wx = parcelRequire("4u3Wx");

var $4kPIV = parcelRequire("4kPIV");

var $itibb = parcelRequire("itibb");

var $9lf1N = parcelRequire("9lf1N");

var $8NAHO = parcelRequire("8NAHO");
const $1c81254a40e33e49$var$noBanner = {
    name: null,
    height: 0,
    isEnabled: false
};
const $1c81254a40e33e49$export$de40f69ba30f2376 = ()=>{
    const [isChromeless] = (0, $4u3Wx.useIsChromeless)();
    const announcement = (0, $4kPIV.useBannerAnnouncement)();
    const transition = (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') ? (0, $itibb.useBannerEocTransition)() : undefined;
    const returnToMobile = (0, $8NAHO.useBannerReturnToMobile)();
    const IPBlocklisting = (0, $dFuN9.useBannerIPBlocklisting)();
    const cookieConsent = (0, $eI5EY.fg)('jfp-magma-cookie-controls-banner-show') // eslint-disable-next-line react-hooks/rules-of-hooks
     ? (0, $N5dQV.useBannerCookieConsent)() : undefined;
    const mailExpiry = (0, $9lf1N.useBannerMailExpiry)();
    return (0, $eUqFw.useMemo)(()=>{
        // cookie consent banner has the highest priority
        if (cookieConsent?.isEnabled) return cookieConsent;
        if (isChromeless) return $1c81254a40e33e49$var$noBanner;
        if (IPBlocklisting.isEnabled) return IPBlocklisting;
        if (returnToMobile.isEnabled) return returnToMobile;
        if (announcement.isEnabled) return announcement;
        if (transition?.isEnabled) return transition;
        if (mailExpiry?.isEnabled) return mailExpiry;
        return $1c81254a40e33e49$var$noBanner;
    }, [
        cookieConsent,
        isChromeless,
        IPBlocklisting,
        returnToMobile,
        announcement,
        transition,
        mailExpiry
    ]);
};

});
parcelRegister("N5dQV", function(module, exports) {

$parcel$export(module.exports, "useBannerCookieConsent", () => $42e2ac81d60d8dce$export$c7a51b5ee06f5794);

var $eUqFw = parcelRequire("eUqFw");

var $3cif2 = parcelRequire("3cif2");
var $hM2VL = parcelRequire("hM2VL");

var $aqZcy = parcelRequire("aqZcy");

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $8yXY1 = parcelRequire("8yXY1");


var $4zIA4 = parcelRequire("4zIA4");
const $42e2ac81d60d8dce$export$5503c67b1001ec45 = (data)=>{
    try {
        const shouldShowBannerBit = (0, $aqZcy.getCookie)((0, $3cif2.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
        const shouldShowBannerBitState = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
        return data && (0, $hM2VL.shouldRenderBannerPrefetched)(data) || shouldShowBannerBitState;
    } catch (e) {
        return true;
    }
};
const $42e2ac81d60d8dce$var$useBannerCookieConsentV2 = ()=>{
    const [{ isDismissed: isDismissed, height: height }, { onShow: onShow }] = (0, $4zIA4.useCookieConsentBannerSettings)();
    const { data: data } = (0, $8yXY1.useConsentBannerUserPreferencesResource)();
    (0, $eUqFw.useEffect)(()=>{
        const shouldRender = $42e2ac81d60d8dce$export$5503c67b1001ec45(data);
        // only show banner if banner should be shown and not in iframe
        if (shouldRender && !(0, $4zIA4.isInIframe)()) onShow();
    }, [
        data,
        onShow
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: !isDismissed,
            name: (0, $539c74e86514eccc$export$41956b146268af93),
            height: height
        }), [
        isDismissed,
        height
    ]);
};
const $42e2ac81d60d8dce$var$useBannerCookieConsentV1 = ()=>{
    const [{ isDismissed: isDismissed, height: height }] = (0, $4zIA4.useCookieConsentBannerSettings)();
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: !isDismissed,
            name: (0, $539c74e86514eccc$export$41956b146268af93),
            height: height
        }), [
        isDismissed,
        height
    ]);
};
const $42e2ac81d60d8dce$export$c7a51b5ee06f5794 = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('platform.moonjelly.browser-storage-controls-v2'), $42e2ac81d60d8dce$var$useBannerCookieConsentV2, $42e2ac81d60d8dce$var$useBannerCookieConsentV1);

});
parcelRegister("3cif2", function(module, exports) {

$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $2540a478abb0fbf1$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $2540a478abb0fbf1$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $2540a478abb0fbf1$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY", () => $2540a478abb0fbf1$export$f57af01b64fc97b8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $2540a478abb0fbf1$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $2540a478abb0fbf1$export$37073d560ecebada);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $2540a478abb0fbf1$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $2540a478abb0fbf1$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $2540a478abb0fbf1$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $2540a478abb0fbf1$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $2540a478abb0fbf1$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $2540a478abb0fbf1$export$31deaeaebce525bb);

var $3K9DW = parcelRequire("3K9DW");
const $2540a478abb0fbf1$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $2540a478abb0fbf1$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $2540a478abb0fbf1$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $2540a478abb0fbf1$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $2540a478abb0fbf1$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $2540a478abb0fbf1$export$37073d560ecebada = 'atl-testing-consents';
const $2540a478abb0fbf1$export$b28b5d760fe14a21 = {
    [(0, $3K9DW.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $3K9DW.PreferenceCategory).Functional]: true,
    [(0, $3K9DW.PreferenceCategory).Marketing]: true,
    [(0, $3K9DW.PreferenceCategory).Analytics]: true,
    [(0, $3K9DW.PreferenceCategory).Unknown]: true // Includes uncategorized cookies
};
const $2540a478abb0fbf1$export$4a12f9e99971760a = {
    [(0, $3K9DW.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $3K9DW.PreferenceCategory).Functional]: false,
    [(0, $3K9DW.PreferenceCategory).Marketing]: false,
    [(0, $3K9DW.PreferenceCategory).Analytics]: false,
    [(0, $3K9DW.PreferenceCategory).Unknown]: false
};
const $2540a478abb0fbf1$export$f0fd1d13ec1d48f2 = {
    ...$2540a478abb0fbf1$export$4a12f9e99971760a,
    [(0, $3K9DW.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $3K9DW.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $2540a478abb0fbf1$export$f95182b7aa141c57 = '001';
const $2540a478abb0fbf1$export$1f25427b34f9c405 = '002';
const $2540a478abb0fbf1$export$31deaeaebce525bb = '003';

});
parcelRegister("3K9DW", function(module, exports) {

$parcel$export(module.exports, "PreferenceCategory", () => $2b9d25e8678c97bc$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $2b9d25e8678c97bc$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $2b9d25e8678c97bc$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $2b9d25e8678c97bc$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CachedKeysDataProperty", () => $2b9d25e8678c97bc$export$cd5dd043a4a3cfee);
$parcel$export(module.exports, "Status", () => $2b9d25e8678c97bc$export$96e9906d6d93a972);
let $2b9d25e8678c97bc$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
let $2b9d25e8678c97bc$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
let $2b9d25e8678c97bc$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
let $2b9d25e8678c97bc$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
let $2b9d25e8678c97bc$export$cd5dd043a4a3cfee = /*#__PURE__*/ function(CachedKeysDataProperty) {
    CachedKeysDataProperty["LocalStorage"] = "localStorageKeys";
    CachedKeysDataProperty["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataProperty["Cookies"] = "keys";
    CachedKeysDataProperty["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataProperty;
}({});
let $2b9d25e8678c97bc$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});

});


parcelRegister("hM2VL", function(module, exports) {

$parcel$export(module.exports, "shouldRenderBannerPrefetched", () => $cf093153155f39d8$export$6406464aa126433e);

var $cRRop = parcelRequire("cRRop");

var $aiuhL = parcelRequire("aiuhL");

var $jiA3Z = parcelRequire("jiA3Z");
const $cf093153155f39d8$export$6406464aa126433e = (prefetchedPreferencesData)=>{
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $aiuhL.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $jiA3Z.getBannerVisibility)(prefetchedPreferencesData) : true;
    }
    // We've been given ConsentHub response data, format it appropriately
    const consentPrefsData = (0, $cRRop.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $jiA3Z.getBannerVisibility)(consentPrefsData);
};

});
parcelRegister("cRRop", function(module, exports) {

$parcel$export(module.exports, "buildConsentPreferences", () => $95e3d9ee806ee37f$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $95e3d9ee806ee37f$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $95e3d9ee806ee37f$export$f8422650c3dec8b2);

var $8nVWJ = parcelRequire("8nVWJ");

var $jeGRo = parcelRequire("jeGRo");
const $95e3d9ee806ee37f$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $95e3d9ee806ee37f$var$POST_CONSENTS_URL = `${$95e3d9ee806ee37f$var$BASE_CONSENTS_URL}/user`;
const $95e3d9ee806ee37f$var$GET_CONSENTS_URL = `${$95e3d9ee806ee37f$var$POST_CONSENTS_URL}/consents/cookies`;
const $95e3d9ee806ee37f$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $jeGRo.serializeConsents)(consentData);
        const consentTimestamp = (0, $jeGRo.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $jeGRo.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $95e3d9ee806ee37f$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$95e3d9ee806ee37f$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $95e3d9ee806ee37f$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $8nVWJ.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $95e3d9ee806ee37f$export$bd9f5bcbf9cd947c();
    }
};
const $95e3d9ee806ee37f$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $jeGRo.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        // If there are no consents, it's a first time fill, otherwise it's an update action
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $95e3d9ee806ee37f$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$95e3d9ee806ee37f$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $95e3d9ee806ee37f$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $jeGRo.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $8nVWJ.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});
parcelRegister("jeGRo", function(module, exports) {

$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $e010923ef8ffa7b3$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $e010923ef8ffa7b3$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $e010923ef8ffa7b3$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $e010923ef8ffa7b3$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $e010923ef8ffa7b3$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $e010923ef8ffa7b3$export$3387347b75450ae1);
$parcel$export(module.exports, "StatusCodeError", () => $e010923ef8ffa7b3$export$a79c0ea3d7c2444a);

var $fpgay = parcelRequire("fpgay");

var $3cif2 = parcelRequire("3cif2");

var $k4bKv = parcelRequire("k4bKv");

var $3K9DW = parcelRequire("3K9DW");

var $eHbAt = parcelRequire("eHbAt");
const $e010923ef8ffa7b3$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $3cif2.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $e010923ef8ffa7b3$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $3cif2.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $e010923ef8ffa7b3$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($e010923ef8ffa7b3$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $e010923ef8ffa7b3$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV2ConsentToken = $e010923ef8ffa7b3$var$isLegacyGeoTargetingV2Token(consentToken);
    const isLegacyV1ConsentToken = $e010923ef8ffa7b3$var$isLegacyV1Token(consentToken);
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $e010923ef8ffa7b3$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    return false;
    const isDefaultToken = (0, $fpgay.getBoolFromBitValue)(consentToken[7]);
    return isDefaultToken;
};
const $e010923ef8ffa7b3$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $3cif2.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $3cif2.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $3K9DW.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $3K9DW.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $fpgay.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $fpgay.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $fpgay.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $e010923ef8ffa7b3$export$42a0b3fb1e53e7b9 = (consents)=>{
    var _consents$find, _consents$find2, _consents$find3, _consents$find4;
    const version = (0, $3cif2.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $fpgay.getBitValueFromBool)(!!((_consents$find = consents.find((key)=>key.key === (0, $eHbAt.ConsentHubKey).Functional)) !== null && _consents$find !== void 0 && _consents$find.granted));
    const analyticsConsent = (0, $fpgay.getBitValueFromBool)(!!((_consents$find2 = consents.find((key)=>key.key === (0, $eHbAt.ConsentHubKey).Analytics)) !== null && _consents$find2 !== void 0 && _consents$find2.granted));
    const marketingConsent = (0, $fpgay.getBitValueFromBool)(!!((_consents$find3 = consents.find((key)=>key.key === (0, $eHbAt.ConsentHubKey).Marketing)) !== null && _consents$find3 !== void 0 && _consents$find3.granted));
    const unknownConsent = (0, $fpgay.getBitValueFromBool)(!!((_consents$find4 = consents.find((key)=>key.key === (0, $eHbAt.ConsentHubKey).Unknown)) !== null && _consents$find4 !== void 0 && _consents$find4.granted));
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $e010923ef8ffa7b3$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $k4bKv.getCookie)((0, $3cif2.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $e010923ef8ffa7b3$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $e010923ef8ffa7b3$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $e010923ef8ffa7b3$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $e010923ef8ffa7b3$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $3K9DW.PreferenceCategory).StrictlyNecessary,
        (0, $3K9DW.PreferenceCategory).Functional,
        (0, $3K9DW.PreferenceCategory).Analytics,
        (0, $3K9DW.PreferenceCategory).Marketing,
        (0, $3K9DW.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $3K9DW.PreferenceCategory).StrictlyNecessary]: (0, $eHbAt.ConsentHubKey).StrictlyNecessary,
        [(0, $3K9DW.PreferenceCategory).Functional]: (0, $eHbAt.ConsentHubKey).Functional,
        [(0, $3K9DW.PreferenceCategory).Analytics]: (0, $eHbAt.ConsentHubKey).Analytics,
        [(0, $3K9DW.PreferenceCategory).Marketing]: (0, $eHbAt.ConsentHubKey).Marketing,
        [(0, $3K9DW.PreferenceCategory).Unknown]: (0, $eHbAt.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $e010923ef8ffa7b3$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $e010923ef8ffa7b3$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
class $e010923ef8ffa7b3$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $e010923ef8ffa7b3$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $e010923ef8ffa7b3$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("fpgay", function(module, exports) {

$parcel$export(module.exports, "getBitValueFromBool", () => $b375bbafcb145913$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $b375bbafcb145913$export$27647458f3cf29d2);
const $b375bbafcb145913$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $b375bbafcb145913$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("eHbAt", function(module, exports) {

$parcel$export(module.exports, "ConsentHubKey", () => $ab2e11dae8c3acb7$export$31140359b1e505cf);
// If consents are present and populated, the user is authenticated and has recorded preferences.
// If consents are present but empty, the user is authenticated and has no preferences in the system.
// If consents are not present in the DB, the user is unauthenticated and has no preferences in the system.
// currentLocale will always be present if available ("UNKNOWN" if not), regardless of auth status
// localeWhenConsented will never be relevant for unauthenticated users.
// Typical locale format: <countryCode>-<subdivisionCode> e.g. 'FR-ARA' for France, or 'US-VA' for Virginia
// There are ~30m users who do not have the modern version of their locale stored in ConsentHub (inclusive of the subdivision)
// which means we need to account for instances where we ONLY have the country code of US.
// SSR teams can look at the cached cookie result and pre-load that rather than fetching from CH
// SSR teams can look at the cached cookie result and pre-load that rather than fetching from CH
let $ab2e11dae8c3acb7$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});



parcelRegister("aiuhL", function(module, exports) {

$parcel$export(module.exports, "checkTokenVersionValidity", () => $77f313df9adbbb1f$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $77f313df9adbbb1f$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $77f313df9adbbb1f$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initialPreferencesAreMissing", () => $77f313df9adbbb1f$export$67f70eb55341bd29);
$parcel$export(module.exports, "initializePreferencesData", () => $77f313df9adbbb1f$export$7962405c3ca274b1);

var $XHGTv = parcelRequire("XHGTv");

var $fpgay = parcelRequire("fpgay");

var $3cif2 = parcelRequire("3cif2");

var $jeGRo = parcelRequire("jeGRo");

var $3K9DW = parcelRequire("3K9DW");
const $77f313df9adbbb1f$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $3cif2.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $3cif2.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $3cif2.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $3cif2.V001_SCHEMA_KEY),
        (0, $3cif2.V002_SCHEMA_KEY),
        (0, $3cif2.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $77f313df9adbbb1f$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $3cif2.V001_SCHEMA_KEY);
    return [
        version,
        (0, $fpgay.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $fpgay.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $fpgay.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $fpgay.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $77f313df9adbbb1f$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $3K9DW.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $3K9DW.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $3K9DW.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $3K9DW.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $3K9DW.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $77f313df9adbbb1f$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $3cif2.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $3K9DW.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $3K9DW.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $3K9DW.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $3K9DW.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Functional]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Analytics]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Marketing]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Unknown]),
        (0, $fpgay.getBitValueFromBool)(isDefaultConsentBit),
        (0, $fpgay.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $fpgay.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $77f313df9adbbb1f$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $jeGRo.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$77f313df9adbbb1f$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $3K9DW.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $3K9DW.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $77f313df9adbbb1f$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $3cif2.V003_SCHEMA_KEY);
    return [
        version,
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Functional]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Analytics]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Marketing]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Unknown]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $77f313df9adbbb1f$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $3K9DW.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $3K9DW.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $3K9DW.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $3K9DW.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $3K9DW.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $3K9DW.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $3K9DW.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $77f313df9adbbb1f$var$V002SpecificBitKeys = [
    (0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $3K9DW.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $3K9DW.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $3K9DW.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $3K9DW.ConsentPreferenceV2).ConsentedUnderFADP
];
const $77f313df9adbbb1f$var$V003SpecificBitKeys = [
    (0, $3K9DW.ContextualConsentProperty).ConsentsAreDefault,
    (0, $3K9DW.ContextualConsentProperty).UserIsAuthenticated,
    (0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable
];
function $77f313df9adbbb1f$export$3199823fec979bd1(userPreferences) {
    if (!(0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls-v2')) return $77f313df9adbbb1f$var$packPrefsVersion001(userPreferences);
    const isV002 = $77f313df9adbbb1f$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $77f313df9adbbb1f$var$packPrefsVersion002(userPreferences);
    const isV003 = $77f313df9adbbb1f$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $77f313df9adbbb1f$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $77f313df9adbbb1f$var$packPrefsVersion001(userPreferences);
}
function $77f313df9adbbb1f$export$8d213cb390bab4fa(userPreferencesCookie) {
    if (!(0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls-v2')) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $3cif2.V001_SCHEMA_KEY)) return $77f313df9adbbb1f$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $77f313df9adbbb1f$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $77f313df9adbbb1f$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $77f313df9adbbb1f$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $77f313df9adbbb1f$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $77f313df9adbbb1f$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $77f313df9adbbb1f$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $3K9DW.PrefetchedPreferenceState).INTERNAL) {
        if ($77f313df9adbbb1f$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $77f313df9adbbb1f$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $jeGRo.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $77f313df9adbbb1f$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $3K9DW.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});

parcelRegister("jiA3Z", function(module, exports) {

$parcel$export(module.exports, "getBannerVisibility", () => $e0cbac3259c12cbf$export$bfdb9f82a9194c1e);

var $jyzhV = parcelRequire("jyzhV");

var $fpgay = parcelRequire("fpgay");

var $3cif2 = parcelRequire("3cif2");

var $jeGRo = parcelRequire("jeGRo");

var $k4bKv = parcelRequire("k4bKv");

var $aiuhL = parcelRequire("aiuhL");
const $e0cbac3259c12cbf$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $aiuhL.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $e0cbac3259c12cbf$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $e0cbac3259c12cbf$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $fpgay.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $jeGRo.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $e0cbac3259c12cbf$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $jeGRo.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $e0cbac3259c12cbf$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $jeGRo.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $e0cbac3259c12cbf$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $e0cbac3259c12cbf$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $fpgay.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $jeGRo.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
            They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
            then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)
             UX Problem:
            Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
            But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
            is infrequent (either via Account Privacy Page or once this fallback expires in a year).
             Example:
            While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
            fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
            because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...
             We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
            to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
            persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.
             Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
            consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year
             Result: Show the banner again and hope we officially recapture consents this time around
          */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $e0cbac3259c12cbf$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $jeGRo.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $e0cbac3259c12cbf$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $jeGRo.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $e0cbac3259c12cbf$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents })=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    const fallbackConsentToken = (0, $jyzhV.isSSR)() ? fallbackConsents // When coming from SSR, we don't want to invoke `getCookie` since it will error
     : fallbackConsents || (0, $k4bKv.getCookie)((0, $3cif2.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $e0cbac3259c12cbf$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $fpgay.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $e0cbac3259c12cbf$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $e0cbac3259c12cbf$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});


parcelRegister("8yXY1", function(module, exports) {

$parcel$export(module.exports, "consentBannerUserPreferencesResource", () => $9d378f53ff5588a3$export$785c22104b6f2285);
$parcel$export(module.exports, "useConsentBannerUserPreferencesResource", () => $9d378f53ff5588a3$export$5bc7e83e85567fb4);
// eslint-disable-next-line jira/import-whitelist

var $3cif2 = parcelRequire("3cif2");

var $aqZcy = parcelRequire("aqZcy");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $lB25E = parcelRequire("lB25E");

const $9d378f53ff5588a3$export$785c22104b6f2285 = (0, $lB25E.createResource)({
    type: (0, $915023b8afa83aa8$export$c5397b7748ed6c7b),
    getKey: ()=>(0, $915023b8afa83aa8$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $aqZcy.getCookie)((0, $3cif2.ATLASSIAN_CONSENT_COOKIE_KEY));
        const fallbackConsentToken = (0, $aqZcy.getCookie)((0, $3cif2.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if ((0, $eI5EY.fg)('jfp-magma-browser-storage-bump-3')) {
            if (consentToken) return {
                consentToken: consentToken,
                fallbackConsentToken: fallbackConsentToken
            };
        } else {
            const currentLocale = (0, $aqZcy.getCookie)((0, $3cif2.ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY));
            if (consentToken && currentLocale) return {
                consentToken: consentToken,
                currentLocale: currentLocale,
                fallbackConsentToken: fallbackConsentToken
            };
        }
        const data = await (0, $lRmyA.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: true
});
const $9d378f53ff5588a3$export$5bc7e83e85567fb4 = ()=>(0, $lB25E.useResource)($9d378f53ff5588a3$export$785c22104b6f2285);

});
const $915023b8afa83aa8$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $915023b8afa83aa8$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';


parcelRegister("4zIA4", function(module, exports) {

$parcel$export(module.exports, "isInIframe", () => $1e803e8843969244$export$9f140ed41af5108c);
$parcel$export(module.exports, "useCookieConsentBannerSettings", () => $1e803e8843969244$export$ae97931560f092a4);
$parcel$export(module.exports, "useCookieConsentBannerSettingsActions", () => $1e803e8843969244$export$ecbab4dc5f9ad844);

var $k4bKv = parcelRequire("k4bKv");
var $3cif2 = parcelRequire("3cif2");

var $1ybV0 = parcelRequire("1ybV0");

var $WBLbN = parcelRequire("WBLbN");
function $1e803e8843969244$export$8d213cb390bab4fa(userPreferencesCookie) {
    // Format 0000000
    // 000 (schema version 3 digits)
    // 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
    // 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
    // 0/1 (1 digit, MARKETING cookies disabled/enabled)
    // 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
    if (userPreferencesCookie.length < 3) // Wrong format, no version
    return;
    const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
    if (version !== '001') // We support version 001 only
    return;
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        STRICTLY_NECESSARY: true,
        FUNCTIONAL: userPreferencesCookie[3] === '1',
        ANALYTICS: userPreferencesCookie[4] === '1',
        MARKETING: userPreferencesCookie[5] === '1',
        UNKNOWN: userPreferencesCookie[6] === '1'
    };
}
const $1e803e8843969244$export$1de6a888ae076ff8 = ()=>{
    if (false) return undefined;
    const packedPrefs = (0, $k4bKv.getCookie)((0, $3cif2.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
    if (!packedPrefs) return undefined;
    return $1e803e8843969244$export$8d213cb390bab4fa(packedPrefs);
};
const $1e803e8843969244$export$9f140ed41af5108c = ()=>{
    if (false) return false;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window !== window.top;
};
const $1e803e8843969244$export$aa1483cc2e197f6e = ()=>{
    if (false) return false;
    if ((0, $1ybV0.ff)('platform.moonjelly.browser-storage-controls-v2')) return true;
    return $1e803e8843969244$export$1de6a888ae076ff8() !== undefined || $1e803e8843969244$export$9f140ed41af5108c();
};
const $1e803e8843969244$export$d4c72bab9d6cc13a = {
    isDismissed: $1e803e8843969244$export$aa1483cc2e197f6e(),
    height: 0
};
const $1e803e8843969244$export$e324594224ef24da = {
    onShow: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isDismissed: false
            });
        },
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isDismissed: true
            });
        },
    setHeight: (height)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                height: height
            });
        }
};
const $1e803e8843969244$var$Store = (0, $WBLbN.createStore)({
    name: 'cookie-consent-banner',
    initialState: $1e803e8843969244$export$d4c72bab9d6cc13a,
    actions: $1e803e8843969244$export$e324594224ef24da
});
const $1e803e8843969244$export$ae97931560f092a4 = (0, $WBLbN.createHook)($1e803e8843969244$var$Store);
const $1e803e8843969244$export$ecbab4dc5f9ad844 = (0, $WBLbN.createActionsHook)($1e803e8843969244$var$Store);

});


parcelRegister("dFuN9", function(module, exports) {

$parcel$export(module.exports, "useBannerIPBlocklisting", () => $819d943e99d1c80d$export$564412c1d9cd4ccc);

var $eUqFw = parcelRequire("eUqFw");

var $ds5Im = parcelRequire("ds5Im");

var $4IEye = parcelRequire("4IEye");
const $819d943e99d1c80d$export$564412c1d9cd4ccc = ()=>{
    const [shouldShowBanner, setBannerState] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $ds5Im.loadBridgeWeak)({
            name: 'jira/global-components/ipblocklisting/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge({
                showIPBlocklistBanner: ()=>setBannerState(true),
                hideIPBlocklistBanner: ()=>setBannerState(false)
            });
        });
    }, []);
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: shouldShowBanner,
            name: (0, $4IEye.BANNER_NAME),
            height: (0, $4IEye.bannerHeight)
        }), [
        shouldShowBanner
    ]);
};

});

parcelRegister("4kPIV", function(module, exports) {

$parcel$export(module.exports, "useBannerAnnouncement", () => $3578e31f85c09ba1$export$1e775b1ab04f2888);

var $eUqFw = parcelRequire("eUqFw");

var $a5Lgz = parcelRequire("a5Lgz");

var $6yplV = parcelRequire("6yplV");

var $NzrZv = parcelRequire("NzrZv");
const $3578e31f85c09ba1$export$1e775b1ab04f2888 = ()=>{
    const { data: data } = (0, $a5Lgz.useAnnouncementBannerSettingsV4Resource)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: Boolean(data?.isEnabled) && !data?.isDismissed && (data?.visibility === 'private' && !isAnonymous || data?.visibility === 'public'),
            name: (0, $NzrZv.NAME),
            height: (0, $NzrZv.HEIGHT)
        }), [
        data?.isDismissed,
        data?.isEnabled,
        data?.visibility,
        isAnonymous
    ]);
};

});
parcelRegister("a5Lgz", function(module, exports) {

$parcel$export(module.exports, "announcementBannerSettingsV4Resource", () => $7a3ce10da4ecebac$export$8fbe7f8de07afffd);
$parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", () => $7a3ce10da4ecebac$export$6fb72f4a0c177494);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $lB25E = parcelRequire("lB25E");

var $iXfYO = parcelRequire("iXfYO");

var $jF6Sk = parcelRequire("jF6Sk");

var $6abiR = parcelRequire("6abiR");
const $7a3ce10da4ecebac$export$2a421cd16fa9a95a = (0, $lB25E.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $jF6Sk.get)(),
            (0, $6abiR.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $7a3ce10da4ecebac$export$8fbe7f8de07afffd = (0, $lB25E.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $iXfYO.get)(),
            (0, $6abiR.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $7a3ce10da4ecebac$export$43d4950a3e443fd3 = ()=>(0, $lB25E.useResource)($7a3ce10da4ecebac$export$2a421cd16fa9a95a);
const $7a3ce10da4ecebac$export$6fb72f4a0c177494 = ()=>(0, $lB25E.useResource)($7a3ce10da4ecebac$export$8fbe7f8de07afffd);

});
parcelRegister("iXfYO", function(module, exports) {

$parcel$export(module.exports, "get", () => $58a9dca49db86568$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $58a9dca49db86568$export$adaa4cf7ef1b65be);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $58a9dca49db86568$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $lRmyA.performGetRequest)('/rest/internal/4/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            content: '',
            bgColor: 'grey',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $guiFP.default)({
            meta: {
                id: 'settingsV4Get',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $58a9dca49db86568$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $lRmyA.performPostRequest)('/rest/internal/4/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'settingsV4Set',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};

});

parcelRegister("jF6Sk", function(module, exports) {

$parcel$export(module.exports, "get", () => $baaff1b2e6f1885b$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $baaff1b2e6f1885b$export$adaa4cf7ef1b65be);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

const $baaff1b2e6f1885b$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $lRmyA.performGetRequest)('/rest/internal/3/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            message: '',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'settingsGet',
            packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $baaff1b2e6f1885b$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $lRmyA.performPostRequest)('/rest/internal/3/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'settingsSet',
            packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
const $6015420733166380$export$b8b9d90f9e5bd72b = '@atlassian/jira-admin-pages-system-ui-announcement-banner-resources';
const $6015420733166380$export$5e0c0e8c940630f8 = 'private';
const $6015420733166380$export$1d5a5b6462188eb3 = 'public';


parcelRegister("6abiR", function(module, exports) {

$parcel$export(module.exports, "get", () => $5e6a63cc908ec028$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $5e6a63cc908ec028$export$adaa4cf7ef1b65be);

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

const $5e6a63cc908ec028$var$key = 'announcementBannerDismissedLast';
const $5e6a63cc908ec028$export$3988ae62b71be9a3 = async (accoundId)=>{
    try {
        return accoundId != null ? (await (0, $48bs8.getUserProperty)(accoundId, $5e6a63cc908ec028$var$key)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'userDismissGet',
            packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $5e6a63cc908ec028$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
    try {
        return await (0, $48bs8.setUserProperties)(accoundId, $5e6a63cc908ec028$var$key, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'userDismissSet',
            packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});


parcelRegister("6yplV", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $650b84b1a3eacbd8$export$bf7b5d502f6d6d3b);

var $gd0Sp = parcelRequire("gd0Sp");
const $650b84b1a3eacbd8$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("NzrZv", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $ed164e6dadc08c71$export$809d2b099693a9a8);
$parcel$export(module.exports, "NAME", () => $ed164e6dadc08c71$export$3c5e605ca7ade9f2);

var $c9TLT = parcelRequire("c9TLT");
const $ed164e6dadc08c71$export$809d2b099693a9a8 = (0, $c9TLT.gridSize) * 8;
const $ed164e6dadc08c71$export$3c5e605ca7ade9f2 = 'ANNOUNCEMENT';

});


parcelRegister("itibb", function(module, exports) {

$parcel$export(module.exports, "useBannerEocTransition", () => $60fbf3301c9b1d1e$export$b6539a8209f95b48);

var $eUqFw = parcelRequire("eUqFw");

var $hhjRL = parcelRequire("hhjRL");

var $9z07y = parcelRequire("9z07y");

var $h4Fhh = parcelRequire("h4Fhh");

var $c7H0g = parcelRequire("c7H0g");

var $1R3n5 = parcelRequire("1R3n5");

var $bFh4f = parcelRequire("bFh4f");
const $60fbf3301c9b1d1e$export$b6539a8209f95b48 = ()=>{
    const { data: data, error: error } = (0, $hhjRL.useOgConsolidationUserState)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const { isTransitionEligible: isTransitionEligible, error: tenantInfoError } = (0, $h4Fhh.useOgTenantInfo)();
    const isEnabled = Boolean((isAdmin || isSiteAdmin) && // Tenant info
    !tenantInfoError && isTransitionEligible && // User state
    !error && data && (!data.isTransitionBannerDismissed || (0, $9z07y.shouldRenderBenefitModal)({
        bannerDismissedAt: data.transitionBannerDismissedAt,
        isDismissed: data.isBenefitModalDismissed
    })));
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $bFh4f.BANNER_NAME),
            height: data && (0, $9z07y.shouldRenderBenefitModal)({
                bannerDismissedAt: data.transitionBannerDismissedAt
            }) ? 0 : (0, $bFh4f.HEIGHT)
        }), [
        data,
        isEnabled
    ]);
};

});
parcelRegister("hhjRL", function(module, exports) {

$parcel$export(module.exports, "useOgConsolidationUserState", () => $372e7078171e8517$export$c35632c02599163f);

var $eUqFw = parcelRequire("eUqFw");

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hlO97 = parcelRequire("hlO97");

var $9EQcI = parcelRequire("9EQcI");

var $gd0Sp = parcelRequire("gd0Sp");

var $lB25E = parcelRequire("lB25E");

var $3bkB6 = parcelRequire("3bkB6");
const $372e7078171e8517$export$c35632c02599163f = ()=>{
    const errorRef = (0, $eUqFw.useRef)();
    const loadingRef = (0, $eUqFw.useRef)(false);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { data: data, update: updateTransitionResource, error: transitionResourceError } = (0, $lB25E.useResource)((0, $hlO97.consolidationUserStateResource));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [userPropertiesError, setUserPropertiesError] = (0, $eUqFw.useState)();
    errorRef.current = userPropertiesError || transitionResourceError;
    const { atlassianAccountId: accountId } = (0, $gd0Sp.useTenantContext)();
    const update = (0, $eUqFw.useCallback)((newState)=>{
        if (errorRef.current) // If there is an error on resource or update, we don't want to update the state
        return Promise.reject(errorRef.current);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        let updatedData = {};
        updateTransitionResource((oldState)=>{
            updatedData = {
                ...oldState,
                ...newState
            };
            return updatedData;
        });
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $guiFP.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $48bs8.setUserProperties)(accountId, (0, $9EQcI.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY), JSON.stringify(updatedData)).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                showFlag({
                    type: 'error',
                    isAutoDismiss: true,
                    title: formatMessage((0, $3bkB6.default).errorFlagTitle)
                });
                (0, $guiFP.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
        return Promise.resolve();
    }, [
        updateTransitionResource,
        accountId,
        formatMessage,
        showFlag
    ]);
    const reopenTransitionLozenge = (0, $eUqFw.useCallback)(()=>{
        update({
            isTransitionHomeHidden: false
        });
    }, [
        update
    ]);
    return {
        data: data,
        update: update,
        error: errorRef.current,
        reopenTransitionLozenge: reopenTransitionLozenge
    };
};

});
parcelRegister("hlO97", function(module, exports) {

$parcel$export(module.exports, "consolidationUserStateResource", () => $df22f4299975551a$export$4b870505c49999ef);

var $guiFP = parcelRequire("guiFP");

var $lB25E = parcelRequire("lB25E");

var $e70K7 = parcelRequire("e70K7");

const $df22f4299975551a$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
const $df22f4299975551a$export$4b870505c49999ef = (0, $lB25E.createResource)({
    type: $df22f4299975551a$var$RESOURCE_KEY,
    getKey: ()=>$df22f4299975551a$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, $e70K7.getOgConsolidationUserState)(accountId).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'consolidationUserStateResource',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }),
    maxAge: Infinity
});

});
parcelRegister("e70K7", function(module, exports) {

$parcel$export(module.exports, "getOgConsolidationUserState", () => $f1438afaaf09dc03$export$df7594d56c9ebe57);

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $9EQcI = parcelRequire("9EQcI");
const $f1438afaaf09dc03$export$df7594d56c9ebe57 = (accountId)=>{
    if (!accountId) return Promise.resolve((0, $9EQcI.ERROR_CONSOLIDATION_USER_STATE));
    return (0, $48bs8.getUserProperty)(accountId, (0, $9EQcI.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
        if (!val || typeof val !== 'object') {
            (0, $guiFP.default)({
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: new (0, $7byHA.ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                sendToPrivacyUnsafeSplunk: true
            });
            return 0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE;
        }
        if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
            ...(0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE),
            ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE), key)))
        };
        if (!Object.keys((0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) // Missing properties will happen when adding new properties to the type,
        // we are making sure they are filled in from the defaults
        return {
            ...(0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE),
            ...val
        };
        return val;
    }).catch((error)=>{
        // Property not saved yet, so we return the default values
        if (error instanceof (0, $7byHA.default) && error.statusCode === 404) return 0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE;
        throw error;
    });
};

});
parcelRegister("9EQcI", function(module, exports) {

$parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", () => $ede4833892459008$export$1980758e2622af02);
$parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", () => $ede4833892459008$export$51d9907e9d716d);
$parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", () => $ede4833892459008$export$23da4710c3a29eae);
const $ede4833892459008$export$1980758e2622af02 = 'eoc_consolidation_user_state';
const $ede4833892459008$export$51d9907e9d716d = {
    isPromotionBannerDismissed: false,
    isWelcomeModalDisplayed: false,
    isTransitionHomeHidden: false,
    isTransitionBannerDismissed: false,
    isBroadcastWidgetDismissed: false,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: false
};
const $ede4833892459008$export$23da4710c3a29eae = {
    isPromotionBannerDismissed: true,
    isWelcomeModalDisplayed: true,
    isTransitionHomeHidden: true,
    isTransitionBannerDismissed: true,
    isBroadcastWidgetDismissed: true,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: true
};

});



parcelRegister("3bkB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd71b9db670388a5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cd71b9db670388a5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "eoc-changeboarding.controllers.use-og-consolidation-user-state.error-flag-title",
        "defaultMessage": "Something went wrong while updating user properties."
    }
});

});


parcelRegister("9z07y", function(module, exports) {

$parcel$export(module.exports, "shouldRenderBenefitModal", () => $6567c5fc28457e2a$export$25a52eb2dc74e2f9);
const $6567c5fc28457e2a$export$25a52eb2dc74e2f9 = ({ isDismissed: isDismissed, bannerDismissedAt: bannerDismissedAt })=>{
    if (!bannerDismissedAt || isDismissed) return false;
    return Math.ceil((new Date().getTime() - bannerDismissedAt) / 1000 / 60 / 60 / 24) >= 14;
};

});

parcelRegister("h4Fhh", function(module, exports) {

$parcel$export(module.exports, "useOgTenantInfo", () => $15a83583aeb31ef0$export$990ea9ff15ca04f7);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $dAKwA = parcelRequire("dAKwA");

var $fz8wa = parcelRequire("fz8wa");

var $lB25E = parcelRequire("lB25E");

var $jf8p7 = parcelRequire("jf8p7");
/**
 * This hook is used to refresh the tenant info resource when the server side
 * rendering fails due to an error or never actually happens.
 */ const $15a83583aeb31ef0$var$useConsolidationStateResourceRefresh = (tenantInfoResource)=>{
    // It is important that this ff should stop any new behaviour except for
    // safe hook calls. That's why we only do very minimal stuff here.
    const enabled = (0, $eI5EY.fg)('refresh_tenant_info_on_client_for_ssr_error');
    const { data: data, loading: loading, refresh: refresh } = tenantInfoResource;
    const isRefreshed = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (enabled && data === null && loading === false && isRefreshed.current === false) {
            refresh();
            isRefreshed.current = true;
        }
    }, [
        data,
        loading,
        refresh,
        enabled
    ]);
};
const $15a83583aeb31ef0$export$990ea9ff15ca04f7 = ()=>{
    const tenantInfoResource = (0, $lB25E.useResource)((0, $dAKwA.getConsolidationStateResource)());
    const applicationPermissions = (0, $fz8wa.useApplicationPermissions)();
    $15a83583aeb31ef0$var$useConsolidationStateResourceRefresh(tenantInfoResource);
    if (// TODO: Remove this check after the feature flag is removed
    // The refresh is handled in useConsolidationStateResourceRefresh
    // and this one is only for the old behaviour.
    !(0, $eI5EY.fg)('refresh_tenant_info_on_client_for_ssr_error') && tenantInfoResource.data === null && tenantInfoResource.loading === false && tenantInfoResource.error === null) tenantInfoResource.refresh();
    return {
        loading: tenantInfoResource.loading,
        error: tenantInfoResource.error,
        shouldUseJSM: (0, $jf8p7.checkShouldUseJSM)(tenantInfoResource.data),
        isConsolidated: (0, $jf8p7.checkIsConsolidated)(tenantInfoResource.data),
        isTransitioning: (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && (0, $jf8p7.checkIsTransitioning)(tenantInfoResource.data),
        isTransitioned: (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && (0, $jf8p7.checkIsTransitioned)(tenantInfoResource.data),
        isTransitionEligible: (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && applicationPermissions.hasServiceDeskAccess && (0, $jf8p7.checkIsTransitionEligible)(tenantInfoResource.data),
        shouldAccessUnlockOperations: (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && applicationPermissions.hasServiceDeskAccess && (0, $jf8p7.checkShouldAccessUnlockOperations)(tenantInfoResource.data),
        cohort: typeof tenantInfoResource.data === 'string' ? undefined : tenantInfoResource.data?.cohortInfo
    };
};

});
parcelRegister("dAKwA", function(module, exports) {

$parcel$export(module.exports, "getConsolidationStateResource", () => $59d64f3d4fc6187b$export$a6cf5054d4f9f5dd);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $kRdYM = parcelRequire("kRdYM");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lB25E = parcelRequire("lB25E");

var $lPDOE = parcelRequire("lPDOE");

const $59d64f3d4fc6187b$export$de6c19ae237c1eb9 = (cloudId, appPermissions)=>{
    let url = '/internal/v1/customers/tenant-info';
    if (cloudId) url = `${url}/${cloudId}`;
    else throw new Error('No tenant info exists.');
    let promise;
    if (appPermissions && appPermissions.hasServiceDeskAccess === false) {
        promise = new Promise((resolve)=>{
            resolve({
                consolidationState: (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED
            });
        });
        return promise;
    }
    if (false) promise = (0, $kRdYM.eocFetch)(url, {
        exactUrl: true,
        headers: {
            'x-ssr-service-name': (0, $eI5EY.fg)('tenant-info-issuer-change') ? 'og-customer-int-api' : 'og-apigw-atlassian-gw'
        }
    });
    else promise = (0, $kRdYM.eocFetch)('/v1/customers/tenant-info').then(({ data: data })=>data);
    if ((0, $1ybV0.ff)('eoc-tenant-info-hook_dq6ke')) return promise;
    return promise.then((response)=>response.consolidationState);
};
const $59d64f3d4fc6187b$export$a6cf5054d4f9f5dd = (forceBrowser = false)=>(0, $lB25E.createResource)({
        type: (0, $02315c431173f662$export$25ee35b01de9d734),
        getKey: ()=>'tenantInformation',
        getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions } })=>$59d64f3d4fc6187b$export$de6c19ae237c1eb9(cloudId, appPermissions),
        maxAge: Infinity,
        isBrowserOnly: forceBrowser
    });

});
parcelRegister("kRdYM", function(module, exports) {

$parcel$export(module.exports, "eocFetch", () => $7775a32a91a5ec92$export$212b9c60150b5a0a);

var $7JEKn = parcelRequire("7JEKn");

var $fYqUr = parcelRequire("fYqUr");

var $3lxlO = parcelRequire("3lxlO");
const $7775a32a91a5ec92$export$212b9c60150b5a0a = (input, init)=>{
    let headers = init?.headers ?? {};
    let body = init?.body;
    // If there is no Content-Type we should add application/json
    // and if the body is not in the BodyInit format we should stringify it
    // Native fetch accepts headers as [['key1','value1'],['key2', 'value2']] so we don't want to modify header or body in this case
    if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
        body = JSON.stringify(body);
        headers['Content-Type'] = 'application/json';
    }
    if (typeof input === 'string') input = (0, $3lxlO.withPrefix)(input, init);
    else input = {
        ...input,
        url: (0, $3lxlO.withPrefix)(input.url, init)
    };
    const errorTransformer = init?.errorTransformer ?? (0, $3lxlO.defaultErrorTransformer);
    const startTime = performance.now();
    return fetch(input, {
        headers: headers,
        ...init,
        body: body
    }).catch((error)=>{
        throw new (0, $7JEKn.NetworkError)(error.name, error);
    }).then((response)=>{
        if (!response.ok) throw new (0, $7JEKn.HTTPError)(response);
        const sanitizedUrl = (0, $3lxlO.sanitizeUrlString)((0, $3lxlO.getRequestUrl)(input));
        (0, $fYqUr.addSpanToAll)('fetch', sanitizedUrl, [
            {
                name: 'network'
            }
        ], startTime, performance.now());
        switch(init?.responseType){
            case undefined:
            case 'json':
                return response.json();
            case 'blob':
                return response.blob();
            case 'text':
                return response.text();
            case 'headers':
                return response;
        }
    }).catch((error)=>{
        if ((0, $7JEKn.isNetworkError)(error)) {
            // Put it through the transformer and throw it when ready. Note that
            // it is still safe to throw in the transformer, it will just chain up
            // on the following handlers as usual.
            const transformerResult = errorTransformer(error);
            if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                throw finalError;
            });
            else throw transformerResult;
        }
        throw error;
    });
};

});
parcelRegister("7JEKn", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $d68e2f12e365276a$export$bae979e68e4dc802);
$parcel$export(module.exports, "HTTPError", () => $d68e2f12e365276a$export$aa9d629c530f62a7);
$parcel$export(module.exports, "StreamedHTTPError", () => $d68e2f12e365276a$export$c30b5b02747d791c);
$parcel$export(module.exports, "isHTTPError", () => $d68e2f12e365276a$export$6b7a49ce9c98a2f);
$parcel$export(module.exports, "isNetworkError", () => $d68e2f12e365276a$export$476aa014e2fd89d5);
$parcel$export(module.exports, "isStreamedHTTPError", () => $d68e2f12e365276a$export$4f52fcea95c8f97d);

var $bSKtU = parcelRequire("bSKtU");
class $d68e2f12e365276a$export$bae979e68e4dc802 extends Error {
    constructor(name, cause){
        super('Network Error!');
        this.name = name;
        this.cause = cause;
    }
}
class $d68e2f12e365276a$export$aa9d629c530f62a7 extends $d68e2f12e365276a$export$bae979e68e4dc802 {
    constructor(response){
        // It is important to note that this can be shown to the user if the
        // default transformer is not used for some reason and the thrown error's
        // message is left as is.
        super((0, $bSKtU.ERROR_NAMES).HTTPError);
        this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
        this.response = response;
    }
}
class $d68e2f12e365276a$export$c30b5b02747d791c extends $d68e2f12e365276a$export$aa9d629c530f62a7 {
    constructor(cause, data, message){
        super(cause.response);
        this.cause = cause;
        this.data = data;
        this.message = message;
        this.message = message;
        this.name = (0, $bSKtU.ERROR_NAMES).StreamedHTTPError;
    }
}
const $d68e2f12e365276a$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $d68e2f12e365276a$export$aa9d629c530f62a7 || [
        (0, $bSKtU.ERROR_NAMES).HTTPError,
        (0, $bSKtU.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $d68e2f12e365276a$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $d68e2f12e365276a$export$bae979e68e4dc802 || [
        (0, $bSKtU.ERROR_NAMES).NetworkError,
        (0, $bSKtU.ERROR_NAMES).HTTPError,
        (0, $bSKtU.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $d68e2f12e365276a$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $d68e2f12e365276a$export$c30b5b02747d791c || candidate?.name === (0, $bSKtU.ERROR_NAMES).StreamedHTTPError;

});
parcelRegister("bSKtU", function(module, exports) {

$parcel$export(module.exports, "ERROR_NAMES", () => $2ded0429e5da1da0$export$daceac3b97803ce1);
var $2ded0429e5da1da0$export$daceac3b97803ce1;
(function(ERROR_NAMES) {
    ERROR_NAMES["HTTPError"] = "HTTPError";
    ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
    ERROR_NAMES["NetworkError"] = "NetworkError";
})($2ded0429e5da1da0$export$daceac3b97803ce1 || ($2ded0429e5da1da0$export$daceac3b97803ce1 = {}));

});


parcelRegister("3lxlO", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $757b9ebe01720e4f$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "withPrefix", () => $757b9ebe01720e4f$export$44188c5f179c4553);
$parcel$export(module.exports, "defaultErrorTransformer", () => $757b9ebe01720e4f$export$270fcc0e5df09fdd);
$parcel$export(module.exports, "jsmErrorTransformer", () => $757b9ebe01720e4f$export$994cc82144d28ded);
$parcel$export(module.exports, "getRequestUrl", () => $757b9ebe01720e4f$export$14619c0eed01a470);
$parcel$export(module.exports, "sanitizeUrlString", () => $757b9ebe01720e4f$export$ceb09b958e605eff);

var $8ji9h = parcelRequire("8ji9h");

var $7JEKn = parcelRequire("7JEKn");

let $757b9ebe01720e4f$var$metaCloudId;
let $757b9ebe01720e4f$var$isJSMAvailable = true;
function $757b9ebe01720e4f$export$c47913ca32a5c6f7(name) {
    const globalVariable = window ?? $parcel$global;
    if ((0, $8ji9h.isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
    if ($757b9ebe01720e4f$var$metaCloudId) return $757b9ebe01720e4f$var$metaCloudId;
    if ($757b9ebe01720e4f$var$isJSMAvailable) {
        const element = document.querySelector(`meta[name="${name}"]`);
        $757b9ebe01720e4f$var$metaCloudId = element?.getAttribute('content') ?? undefined;
        $757b9ebe01720e4f$var$isJSMAvailable = !!$757b9ebe01720e4f$var$metaCloudId;
    }
    return $757b9ebe01720e4f$var$metaCloudId;
}
function $757b9ebe01720e4f$export$5a75f4aeb58ba80f(id) {
    $757b9ebe01720e4f$var$metaCloudId = id;
}
function $757b9ebe01720e4f$export$44188c5f179c4553(input, init) {
    if (init?.exactUrl) return input;
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = $757b9ebe01720e4f$export$c47913ca32a5c6f7('ajs-cloud-id');
    if (cloudId) return (0, $875484804ad28aca$export$3414665826fa030e) + cloudId + input;
    return input;
}
// https://www.rfc-editor.org/rfc/rfc9110.html#section-8.3
// This is not a full implementation, but should skip any unknown parameters
// and match the charset if it exists. In case there are multiple (which shouldn't) we still
// match the first occurence. If only application/json is returned, utf-8 is
// assumed as we will try to parse it as utf-8 json. This is probably our best
// guess without too much effort here.
const $757b9ebe01720e4f$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
const $757b9ebe01720e4f$export$270fcc0e5df09fdd = (e)=>{
    if (e instanceof (0, $7JEKn.HTTPError)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $757b9ebe01720e4f$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $7JEKn.StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $7JEKn.StreamedHTTPError)(e, message, message));
    }
    return e;
};
const $757b9ebe01720e4f$export$994cc82144d28ded = (error)=>{
    if (error instanceof (0, $7JEKn.HTTPError)) {
        const contentType = error.response.headers.get('Content-Type');
        if (contentType && $757b9ebe01720e4f$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, $7JEKn.StreamedHTTPError)(error, data, data.errorMessages.join(',')));
        return error.response.text().then((message)=>new (0, $7JEKn.StreamedHTTPError)(error, message, message));
    }
    return error;
};
const $757b9ebe01720e4f$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
const $757b9ebe01720e4f$export$ceb09b958e605eff = (url)=>{
    const urlWithoutQueryParams = url.replace(/\?.*$/, '');
    const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
    return urlWithoutUUIDs;
};

});
parcelRegister("8ji9h", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $a0acbe87ddc44949$export$6acf61af03e62db);
const $a0acbe87ddc44949$export$6acf61af03e62db = ()=>{
    try {
        //@ts-ignore: It defined from webpack on the Jira
        return false;
    } catch (error) {
        return globalThis.false ?? false;
    }
};

});

const $875484804ad28aca$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';



parcelRegister("lPDOE", function(module, exports) {

$parcel$export(module.exports, "ConsolidationState", () => $1d60cf44e0c38c08$export$9ef498b0a11fd37d);
const $1d60cf44e0c38c08$export$9ef498b0a11fd37d = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};

});

const $02315c431173f662$export$25ee35b01de9d734 = 'EOC_TENANT';


parcelRegister("fz8wa", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $d53bf78e5b3b7ada$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $d53bf78e5b3b7ada$export$4d9cadb4042acc1b);

var $df4Sl = parcelRequire("df4Sl");

var $WBLbN = parcelRequire("WBLbN");

var $k4yit = parcelRequire("k4yit");

var $gd0Sp = parcelRequire("gd0Sp");
const $d53bf78e5b3b7ada$var$selector = (0, $df4Sl.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $d53bf78e5b3b7ada$export$d8c76f7e52d0a856 = (0, $WBLbN.createSubscriber)((0, $k4yit.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $d53bf78e5b3b7ada$var$selector
});
const $d53bf78e5b3b7ada$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});

parcelRegister("jf8p7", function(module, exports) {

$parcel$export(module.exports, "checkShouldUseJSM", () => $77654e10ad778a08$export$5e0f3a0d8463fa21);
$parcel$export(module.exports, "checkIsTransitioning", () => $77654e10ad778a08$export$d2f281fd4bf10855);
$parcel$export(module.exports, "checkIsConsolidated", () => $77654e10ad778a08$export$57f75aebff17dd1e);
$parcel$export(module.exports, "checkIsTransitioned", () => $77654e10ad778a08$export$b6461b23ee0e1471);
$parcel$export(module.exports, "checkIsTransitionEligible", () => $77654e10ad778a08$export$24040115cac5fdc3);
$parcel$export(module.exports, "checkShouldAccessUnlockOperations", () => $77654e10ad778a08$export$cd227238525e8d57);

var $lPDOE = parcelRequire("lPDOE");

const $77654e10ad778a08$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    return typeof tenantInfo === 'string' ? tenantInfo !== (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED : tenantInfo.consolidationState !== (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED;
};
const $77654e10ad778a08$export$d2f281fd4bf10855 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $lPDOE.ConsolidationState).TRANSITIONING : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).TRANSITIONING;
};
const $77654e10ad778a08$export$57f75aebff17dd1e = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $lPDOE.ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).CONSOLIDATED;
};
const $77654e10ad778a08$export$b6461b23ee0e1471 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $lPDOE.ConsolidationState).TRANSITIONED : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).TRANSITIONED;
};
const $77654e10ad778a08$export$24040115cac5fdc3 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    // even though FF is rolled out 100% if the tenantInfo is string it means we don't know the cohort info
    return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $9e5329fbcc13ca2e$export$650f6934db1290c1);
};
const $77654e10ad778a08$export$cd227238525e8d57 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    // even though FF is rolled out 100% if the tenantInfo is string it means we don't know the cohort info
    return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState !== (0, $lPDOE.ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $9e5329fbcc13ca2e$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $9e5329fbcc13ca2e$export$a101f3562b5f0742));
};

});
const $9e5329fbcc13ca2e$export$650f6934db1290c1 = 'cohort3';
const $9e5329fbcc13ca2e$export$a101f3562b5f0742 = 'cohort3.5';



parcelRegister("c7H0g", function(module, exports) {

$parcel$export(module.exports, "useIsAdmin", () => $b4b4ffdc2519fb85$export$99a5e4bc80d231ca);

var $gd0Sp = parcelRequire("gd0Sp");
const $b4b4ffdc2519fb85$export$99a5e4bc80d231ca = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.isAdmin || false;
};

});

parcelRegister("1R3n5", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $ae5c0c470cafb895$export$f9f8a5cdb0c565ef);

var $gd0Sp = parcelRequire("gd0Sp");
const $ae5c0c470cafb895$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("bFh4f", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $9b35bda76dc8f581$export$809d2b099693a9a8);
$parcel$export(module.exports, "BANNER_NAME", () => $9b35bda76dc8f581$export$41956b146268af93);

var $c9TLT = parcelRequire("c9TLT");
const $9b35bda76dc8f581$export$809d2b099693a9a8 = (0, $c9TLT.gridSize) * 6;
const $9b35bda76dc8f581$export$41956b146268af93 = 'EOC_TRANSITION';

});


parcelRegister("9lf1N", function(module, exports) {

$parcel$export(module.exports, "useBannerMailExpiry", () => $459c8882dc5ea0c1$export$3906461ac9b87d2);

var $eUqFw = parcelRequire("eUqFw");

var $8Osbm = parcelRequire("8Osbm");

var $j3cff = parcelRequire("j3cff");

var $hNg3b = parcelRequire("hNg3b");
const $459c8882dc5ea0c1$export$3906461ac9b87d2 = ()=>{
    const { responseStatus: responseStatus, state: state } = (0, $8Osbm.useIncomingMailExpiryStatus)();
    const { onStateFetch: onStateFetch } = (0, $hNg3b.useBannerActions)();
    const { isBannerShown: isBannerShown } = (0, $hNg3b.useBannerState)();
    (0, $eUqFw.useEffect)(()=>{
        if (responseStatus === 'error') {
            onStateFetch((0, $8Osbm.DEFAULT_RESPONSE));
            return;
        }
        if (responseStatus === 'success') onStateFetch(state);
    }, [
        onStateFetch,
        responseStatus,
        state
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: isBannerShown,
            name: (0, $j3cff.BANNER_NAME),
            height: (0, $j3cff.HEIGHT)
        }), [
        isBannerShown
    ]);
};

});
parcelRegister("8Osbm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RESPONSE", () => $c9c7ef93c34099a4$export$32d9db53927095d3);
$parcel$export(module.exports, "incomingMailServerExpiryStatusResource", () => $c9c7ef93c34099a4$export$369caf52ed1ad2b1);
$parcel$export(module.exports, "useIncomingMailExpiryStatus", () => $c9c7ef93c34099a4$export$283aa034b7d4e2a0);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $lB25E = parcelRequire("lB25E");

const $c9c7ef93c34099a4$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, $lRmyA.performGetRequest)((0, $6a195a4b7e83469e$export$5bf8eb915287f5f4));
const $c9c7ef93c34099a4$export$32d9db53927095d3 = {
    isAdmin: false,
    showBanner: true,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $c9c7ef93c34099a4$export$369caf52ed1ad2b1 = (0, $lB25E.createResource)({
    type: (0, $6a195a4b7e83469e$export$3b9494e0dfc4de09),
    getKey: ()=>(0, $6a195a4b7e83469e$export$f2f2f265ccc09f82),
    getData: async ()=>{
        let incomingMailServerExpiryStatus = null;
        try {
            incomingMailServerExpiryStatus = await $c9c7ef93c34099a4$var$fetchGetIncomingMailServerExpiryStatus();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'incomingMailServerExpiryStatus',
                    packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                    teamName: 'maverick'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $c9c7ef93c34099a4$export$32d9db53927095d3
        };
    },
    maxAge: 3600000
});
const $c9c7ef93c34099a4$export$283aa034b7d4e2a0 = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $lB25E.useResource)($c9c7ef93c34099a4$export$369caf52ed1ad2b1);
    const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $eUqFw.useState)(()=>{
        if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
        return $c9c7ef93c34099a4$export$32d9db53927095d3;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eUqFw.useState)('not started');
    (0, $eUqFw.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.incomingMailServerExpiryStatus) {
            setResponseStatusGet('success');
            setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.incomingMailServerExpiryStatus
    ]);
    return {
        responseStatus: responseStatusGet,
        state: incomingMailServerExpiryStatus
    };
};

});
const $6a195a4b7e83469e$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $6a195a4b7e83469e$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $6a195a4b7e83469e$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';


parcelRegister("j3cff", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $9b9b396a0fb8763d$export$809d2b099693a9a8);
$parcel$export(module.exports, "BANNER_NAME", () => $9b9b396a0fb8763d$export$41956b146268af93);

var $c9TLT = parcelRequire("c9TLT");
const $9b9b396a0fb8763d$export$809d2b099693a9a8 = (0, $c9TLT.gridSize) * 6;
const $9b9b396a0fb8763d$export$41956b146268af93 = 'MAIL_EXPIRY_REMINDER';

});

parcelRegister("hNg3b", function(module, exports) {

$parcel$export(module.exports, "useBannerActions", () => $8ca9b6dc949a6871$export$664f3e2467f0f5af);
$parcel$export(module.exports, "useBannerState", () => $8ca9b6dc949a6871$export$fa4ffa872ee90bd0);

var $WBLbN = parcelRequire("WBLbN");
const $8ca9b6dc949a6871$export$d4c72bab9d6cc13a = {
    isBannerShown: false,
    isAdmin: false,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $8ca9b6dc949a6871$export$e324594224ef24da = {
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: false
            });
        },
    onStateFetch: ({ showBanner: showBanner, isAdmin: isAdmin, OauthTypes: OauthTypes = [
        'GMAIL_OAUTH'
    ] })=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: showBanner && isAdmin,
                isAdmin: isAdmin,
                OauthTypes: OauthTypes
            });
        }
};
const $8ca9b6dc949a6871$var$Store = (0, $WBLbN.createStore)({
    name: 'mail-expiry-banner',
    initialState: $8ca9b6dc949a6871$export$d4c72bab9d6cc13a,
    actions: $8ca9b6dc949a6871$export$e324594224ef24da
});
const $8ca9b6dc949a6871$export$664f3e2467f0f5af = (0, $WBLbN.createActionsHook)($8ca9b6dc949a6871$var$Store);
const $8ca9b6dc949a6871$export$fa4ffa872ee90bd0 = (0, $WBLbN.createStateHook)($8ca9b6dc949a6871$var$Store);

});


parcelRegister("8NAHO", function(module, exports) {

$parcel$export(module.exports, "useBannerReturnToMobileState", () => $b273a992a16fb1c6$export$571311559507e90);
$parcel$export(module.exports, "useBannerReturnToMobile", () => $b273a992a16fb1c6$export$a898dd7b7ec9917a);

var $eUqFw = parcelRequire("eUqFw");

var $8q0kG = parcelRequire("8q0kG");

var $WBLbN = parcelRequire("WBLbN");

var $bBqV2 = parcelRequire("bBqV2");
const $b273a992a16fb1c6$var$initialState = {
    isEnabled: (0, $8q0kG.shouldShowReturnToMobileBanner)()
};
const $b273a992a16fb1c6$var$actions = {
    disable: ()=>({ setState: setState })=>{
            setState({
                isEnabled: false
            });
        }
};
const $b273a992a16fb1c6$var$store = (0, $WBLbN.createStore)({
    initialState: $b273a992a16fb1c6$var$initialState,
    actions: $b273a992a16fb1c6$var$actions
});
const $b273a992a16fb1c6$export$571311559507e90 = (0, $WBLbN.createHook)($b273a992a16fb1c6$var$store);
const $b273a992a16fb1c6$export$a898dd7b7ec9917a = ()=>{
    const [{ isEnabled: isEnabled }] = $b273a992a16fb1c6$export$571311559507e90();
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $bBqV2.BANNER_NAME),
            height: (0, $bBqV2.mobileBannerHeight)
        }), [
        isEnabled
    ]);
};

});
parcelRegister("bBqV2", function(module, exports) {

$parcel$export(module.exports, "mobileBannerHeight", () => $0bcd02d2e3eab317$export$aa875602f5712b77);
$parcel$export(module.exports, "BANNER_NAME", () => $0bcd02d2e3eab317$export$41956b146268af93);
$parcel$export(module.exports, "ENCODED_APPLE_APP_STORE_URL", () => $0bcd02d2e3eab317$export$698c82a2c8445300);

var $c9TLT = parcelRequire("c9TLT");
const $0bcd02d2e3eab317$export$aa875602f5712b77 = (0, $c9TLT.gridSize) * 6;
const $0bcd02d2e3eab317$export$41956b146268af93 = 'RETURN_TO_MOBILE_BANNER';
const $0bcd02d2e3eab317$export$698c82a2c8445300 = encodeURIComponent('https://itunes.apple.com/app/apple-store/id1006972087');

});



parcelRegister("7Rdn2", function(module, exports) {

$parcel$export(module.exports, "BannerAnnouncementAsync", () => $3bcbd6a43f5bed00$export$aa03f7909e0828ec);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $gGtKh = parcelRequire("gGtKh");

const $3bcbd6a43f5bed00$var$BannerAnnouncement = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("2M7hi")).then((module)=>module.BannerAnnouncement), {
    ssr: true,
    moduleId: "./src/packages/platform/ui/banners/announcement/src/ui/banner-v2/index.tsx"
});
const $3bcbd6a43f5bed00$export$aa03f7909e0828ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-platform-ui-banners-announcement",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3bcbd6a43f5bed00$var$BannerAnnouncement, null));

});
parcelRegister("2M7hi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("5okUl")
]).then(()=>parcelRequire('2JP8d'));

});


parcelRegister("imSzy", function(module, exports) {

$parcel$export(module.exports, "BannerTransitionAsync", () => $9423afe095590d92$export$8bf182764b9d2eb8);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $gGtKh = parcelRequire("gGtKh");

const $9423afe095590d92$var$BannerTransition = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("CTXO4")).then((module)=>module.BannerTransition), {
    moduleId: "./src/packages/platform/ui/banners/eoc-transition/src/ui/banner/index.tsx"
});
const $9423afe095590d92$export$8bf182764b9d2eb8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-banner-eoc-transition",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9423afe095590d92$var$BannerTransition, null));

});
parcelRegister("CTXO4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fqvm5").then(()=>parcelRequire('gIqiW'));

});


parcelRegister("8fKcN", function(module, exports) {

$parcel$export(module.exports, "MailExpiryBannerAsync", () => $964736e7e618d7bf$export$11a26ffa2d1b48ed);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $964736e7e618d7bf$var$LazyMailExpiryBanner = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("2umkg")).then(({ MailExpiryReminder: MailExpiryReminder })=>MailExpiryReminder), {
    moduleId: "./src/packages/platform/ui/banners/mail-expiry-reminder/src/ui/view.tsx"
});
const $964736e7e618d7bf$export$11a26ffa2d1b48ed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-mail-expiry-banner",
        packageName: "jiraPlatformUiMailExpiryReminder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-mail-expiry-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($964736e7e618d7bf$var$LazyMailExpiryBanner, null)));

});
parcelRegister("2umkg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9GC8O").then(()=>parcelRequire('8U4NP'));

});


parcelRegister("4E80X", function(module, exports) {

$parcel$export(module.exports, "ReturnToMobileBanner", () => $07b98091c81653c4$export$81c4f1e869d5a87);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $07b98091c81653c4$var$LazyReturnToMobileBanner = (0, $6VZoe.lazy)(()=>(parcelRequire("fJNOQ")).then(({ ReturnToMobileBanner: ReturnToMobileBanner })=>ReturnToMobileBanner), {
    moduleId: "./src/packages/platform/ui/return-to-mobile-banner/src/main.tsx"
});
const $07b98091c81653c4$export$81c4f1e869d5a87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-return-to-mobile-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($07b98091c81653c4$var$LazyReturnToMobileBanner, null));

});
parcelRegister("fJNOQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("1RB2w")
]).then(()=>parcelRequire('KEN32'));

});


parcelRegister("3EdDr", function(module, exports) {

$parcel$export(module.exports, "ZIndexWrapper", () => $30c13a56fc17fb62$export$6bdda512681a5774);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $30c13a56fc17fb62$export$6bdda512681a5774 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, top: top, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w6mvmh": (0, $9t7rW.default)(__cmplp.zIndex),
            "--_1vj9tq": (0, $9t7rW.default)(__cmplp.top)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pby1fcb _kqswh2mm _154i1ter",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5Wexj", function(module, exports) {

$parcel$export(module.exports, "GlobalComponents", () => $3828c60179ae7edc$export$461c2ed3163c74ff);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $0cdA8 = parcelRequire("0cdA8");


var $10fdS = parcelRequire("10fdS");

var $isbb2 = parcelRequire("isbb2");

var $2B87Z = parcelRequire("2B87Z");

var $idiDE = parcelRequire("idiDE");
const $3828c60179ae7edc$var$routeComponents = [];
const $3828c60179ae7edc$var$RouteGlobalComponents = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $isbb2.renderGlobalComponents)(route.layout?.globalComponents || $3828c60179ae7edc$var$routeComponents));
};
// This component is necessary to ensure that the error boundary picks up errors in the renderGlobalComponents function
const $3828c60179ae7edc$var$SharedGlobalComponents = ({ sharedGlobalComponents: sharedGlobalComponents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $isbb2.renderGlobalComponents)(sharedGlobalComponents));
const $3828c60179ae7edc$export$461c2ed3163c74ff = ({ sharedGlobalComponents: sharedGlobalComponents })=>{
    const globalComponentsPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$fb9876ab4228d985), (0, $7688150c048b38d1$export$c20831be6f780cb5), (0, $7688150c048b38d1$export$398df1bca49f9884), true, true);
    }, []);
    /**
	 * !!! DO NOT ADD INDIVIDUAL COMPONENTS TO THIS FILE !!!
	 *
	 * They should be defined as part of the `sharedGlobalComponents` constant, or defined on the route
	 * definition `layout` key.
	 *
	 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/ui/layouts/jira-shared-layout/README.md
	 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/ui/layouts/README.md
	 */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$c20831be6f780cb5)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "shared-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3828c60179ae7edc$var$SharedGlobalComponents, {
        sharedGlobalComponents: sharedGlobalComponents
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "route-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "route-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3828c60179ae7edc$var$RouteGlobalComponents, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$398df1bca49f9884),
        onSet: globalComponentsPerformanceTiming
    }));
};

});
parcelRegister("idiDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8ff5844edbd42f4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6fjTb = parcelRequire("6fjTb");

var $iWLL0 = parcelRequire("iWLL0");

var $3Hphq = parcelRequire("3Hphq");

var $2GbjR = parcelRequire("2GbjR");
const $b8ff5844edbd42f4$var$newContextWithUfoContext = (context, interactionContext)=>context && interactionContext && {
        ...context,
        getInteractionContext: ()=>interactionContext
    };
const $b8ff5844edbd42f4$var$flowRight = (functionList)=>(arg)=>functionList.reduceRight((acc, fn)=>fn(acc), arg);
const $b8ff5844edbd42f4$var$renderContextProviderIfNonNull = (Context, contextValue)=>(node)=>contextValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Context.Provider, {
            value: contextValue
        }, node) : node;
function $b8ff5844edbd42f4$var$JiraUFOLabelWrapper({ children: children }) {
    const context = (0, $3Hphq.useInteractionContext)();
    const rllProfilerContext = (0, $eUqFw.useContext)((0, $6fjTb.ProfilerContext));
    const relayProfilerContext = (0, $eUqFw.useContext)((0, $iWLL0.ProfilerContext));
    const newRllProfilerContext = (0, $eUqFw.useMemo)(()=>({
            current: $b8ff5844edbd42f4$var$newContextWithUfoContext(rllProfilerContext?.current, context)
        }), [
        context,
        rllProfilerContext
    ]);
    const newRelayProfilerContext = (0, $eUqFw.useMemo)(()=>$b8ff5844edbd42f4$var$newContextWithUfoContext(relayProfilerContext, context), [
        context,
        relayProfilerContext
    ]);
    // Produces the following but only renders a provider if its context is not null
    // <RelayProfilerContext.Provider ...>
    //   <RLLProfilerContext.Provider ...>
    //     {children}
    //   </...etc
    return $b8ff5844edbd42f4$var$flowRight([
        $b8ff5844edbd42f4$var$renderContextProviderIfNonNull((0, $iWLL0.ProfilerContext), newRelayProfilerContext),
        $b8ff5844edbd42f4$var$renderContextProviderIfNonNull((0, $6fjTb.ProfilerContext), newRllProfilerContext)
    ])(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children));
}
function $b8ff5844edbd42f4$export$2e2bcd8739ae039({ name: name, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GbjR.default), {
        name: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b8ff5844edbd42f4$var$JiraUFOLabelWrapper, null, children));
}

});
parcelRegister("2GbjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $62d629b5123bd6d6$export$2e2bcd8739ae039);

var $hST5r = parcelRequire("hST5r");
var $62d629b5123bd6d6$export$2e2bcd8739ae039 = (0, $hST5r.default);

});
parcelRegister("hST5r", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b4f053c5692d7e4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");
function $8b4f053c5692d7e4$export$2e2bcd8739ae039({ name: name, children: children }) {
    const context = (0, $3Hphq.useInteractionContext)();
    const newContext = (0, $eUqFw.useMemo)(()=>{
        if (context) return {
            ...context,
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ]
        };
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Hphq.default).Provider, {
        value: newContext
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
}

});




parcelRegister("jG5np", function(module, exports) {

$parcel$export(module.exports, "GlobalContainers", () => $00841c043dae2742$export$3b677a7048d7ae0);

var $eUqFw = parcelRequire("eUqFw");

var $hfxON = parcelRequire("hfxON");

var $3fQGY = parcelRequire("3fQGY");

var $5BRby = parcelRequire("5BRby");

var $9EHc8 = parcelRequire("9EHc8");

var $h97Af = parcelRequire("h97Af");

var $fb5Sn = parcelRequire("fb5Sn");

var $6rW04 = parcelRequire("6rW04");

var $18Cd3 = parcelRequire("18Cd3");

var $6FP8W = parcelRequire("6FP8W");


var $gXEQH = parcelRequire("gXEQH");

var $cH5Wq = parcelRequire("cH5Wq");

var $cajdb = parcelRequire("cajdb");

var $ln3W8 = parcelRequire("ln3W8");

var $jD3pk = parcelRequire("jD3pk");

var $2B87Z = parcelRequire("2B87Z");

var $gd0Sp = parcelRequire("gd0Sp");

var $hzkQm = parcelRequire("hzkQm");

var $emTse = parcelRequire("emTse");

var $zyR9K = parcelRequire("zyR9K");

var $6mtpk = parcelRequire("6mtpk");

var $agGRi = parcelRequire("agGRi");

var $hK0Sb = parcelRequire("hK0Sb");

var $f9UOp = parcelRequire("f9UOp");
const $00841c043dae2742$export$3b677a7048d7ae0 = ({ id: id, children: children, baseUrl: baseUrl, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
    const globalContainersPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$4f341d86a3c214), (0, $7688150c048b38d1$export$16e7ead3a8b5c366), (0, $7688150c048b38d1$export$c389f0b50840d5ca), true, true);
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$7048c99f32c60b34), (0, $7688150c048b38d1$export$3c2d8af5c7577fe7), (0, $7688150c048b38d1$export$aac77afee74c49d0), true, true);
    }, []);
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const MonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: `
                        body#jira {
                            overflow-x: hidden;
                            overflow-y: auto;
                        }

                        #jira-frontend {
                            background: ${"var(--ds-surface, white)"};
                        }

                        #jira_request_timing_info {
                            margin: 0;
                        }
                    `
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emTse.IntlProviders), {
        messages: messages,
        locale: locale
    }, __SPA__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $6rW04.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3fQGY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fb5Sn.default), {
        orgId: orgId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
        analyticsSource: (0, $7688150c048b38d1$export$c9e16a15d65437),
        experience: (0, $7688150c048b38d1$export$b1534bc11f201efd),
        experienceId: (0, $7688150c048b38d1$export$fa4bbc89fd1f1a7),
        application: (0, $7688150c048b38d1$export$aa6008fe0169b864),
        edition: (0, $7688150c048b38d1$export$39418a21fbb51487),
        additionalAttributes: (0, $gXEQH.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hzkQm.ErrorBoundary), {
        id: id,
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$16e7ead3a8b5c366)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Router, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfxON.default), {
        UNSAFE_isThemingDisabled: true,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$c389f0b50840d5ca)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agGRi.PageConfigContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $zyR9K.MetricsContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ln3W8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6mtpk.NavigationContainers), {
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9UOp.UserContainers), {
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hK0Sb.UiManagers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$3c2d8af5c7577fe7)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cH5Wq.PostOfficeRouterListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: "page-container-v2.nav-v3.app-base",
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$aac77afee74c49d0),
        onSet: globalContainersPerformanceTiming
    }), (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $18Cd3.SidebarNav4ControllerProvider), null, children) : children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cajdb.ScreenSpaceFlagsPlacement), null)))))))))))))));
};

});
parcelRegister("hfxON", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fca7a4faed4f95d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1SoQa = parcelRequire("1SoQa");

var $kk8oa = parcelRequire("kk8oa");
const $0fca7a4faed4f95d$var$InsideAppProviderContext = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $0fca7a4faed4f95d$export$c7dacf3845253dcf({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
    const isInsideAppProvider = (0, $eUqFw.useContext)($0fca7a4faed4f95d$var$InsideAppProviderContext);
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    const routerLinkProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SoQa.default), {
        routerLinkComponent: routerLinkComponent
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0fca7a4faed4f95d$var$InsideAppProviderContext.Provider, {
        value: true
    }, UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kk8oa.default), {
        defaultColorMode: defaultColorMode,
        defaultTheme: defaultTheme
    }, routerLinkProvider));
}
var $0fca7a4faed4f95d$export$2e2bcd8739ae039 = $0fca7a4faed4f95d$export$c7dacf3845253dcf;

});

parcelRegister("9EHc8", function(module, exports) {

$parcel$export(module.exports, "ViewExperienceTrackingProvider", () => $617962e6a5e395d0$export$a5efa46877be148f);
$parcel$export(module.exports, "SubExperienceTrackingProvider", () => $617962e6a5e395d0$export$e0241c84ce5db240);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $1YJkI = parcelRequire("1YJkI");

var $8yne0 = parcelRequire("8yne0");

var $8nLP2 = parcelRequire("8nLP2");
const $617962e6a5e395d0$export$a5efa46877be148f = ({ isExperienceReady: isExperienceReady, experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes, children: children })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nLP2.default), {
        isExperienceReady: isExperienceReady,
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: additionalAttributes
    }, children);
$617962e6a5e395d0$export$a5efa46877be148f.defaultProps = {
    isExperienceReady: true,
    experienceId: null,
    additionalAttributes: {}
};
var $617962e6a5e395d0$export$2e2bcd8739ae039 = $617962e6a5e395d0$export$a5efa46877be148f;
const $617962e6a5e395d0$export$e0241c84ce5db240 = ({ children: children, location: location, parentProviders: parentProviders })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : // DO NOT use `useContext` or `static contextType = ...` to consume this context
    // as the tree walker used in SSR does not support hooks
    // and SSR does not support `static contextType` setting
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YJkI.default).Consumer, null, (context)=>{
        if (context == null) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('experience-sub-provider.missing-provider', 'Experience sub-provider rendered without a parent provider');
            return children;
        }
        const { experienceId: experienceId } = context;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), {
            location: location,
            parentProviders: parentProviders
        }, (trackerCallbacks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nLP2.default), {
                parentTrackerCallbacks: trackerCallbacks,
                experience: location,
                experienceId: experienceId,
                analyticsSource: null,
                application: null,
                edition: null,
                isExperienceReady: true
            }, children));
    });
$617962e6a5e395d0$export$e0241c84ce5db240.defaultProps = {
    parentProviders: null
};

});
parcelRegister("8nLP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $392c2e4759c6c8b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9lmTX = parcelRequire("9lmTX");


var $1YJkI = parcelRequire("1YJkI");
class $392c2e4759c6c8b5$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            parentTrackerCallbacks: null,
            additionalAttributes: {}
        };
    }
    constructor(props){
        super(props);
        this.onPending = ()=>{
            this.pendingCount += 1;
            this.shouldTrackExperience = true;
            this.checkAndStartTimer();
        };
        this.onSuccess = ()=>{
            this.pendingCount -= 1;
            this.checkAndStartTimer();
        };
        this.onFailure = (location, additionalAttributes)=>{
            // We need to track failure *immediately*, otherwise this component may
            // be unmounted and we'd miss our chance.
            this.trackExperience({
                wasExperienceSuccesful: false,
                location: location,
                additionalAttributes: additionalAttributes
            });
        };
        this.onAbort = (location, additionalAttributes)=>{
            this.trackExperience({
                wasExperienceSuccesful: false,
                action: (0, $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8),
                location: location,
                additionalAttributes: additionalAttributes
            });
        };
        this.resetExperience();
    }
    componentDidMount() {
        this.checkAndStartTimer();
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
    }
    componentDidCatch(error) {
        // This catches any errors that bubble up to the Provider that
        // may not be caught by any ExperienceTrackers
        this.trackExperience({
            wasExperienceSuccesful: false,
            location: 'error-reached-provider',
            additionalAttributes: {
                errorMessage: error.message,
                errorName: error.name
            }
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place.
        throw error;
    }
    componentWillUnmount() {
        clearTimeout(this.timerId);
    }
    checkAndStartTimer() {
        if (this.shouldTrackExperience && this.props.isExperienceReady) this.startTimer();
    }
    startTimer() {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(()=>{
            if (this.pendingCount === 0) this.trackExperience({
                wasExperienceSuccesful: true
            });
        }, 1000);
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetExperience() {
        clearTimeout(this.timerId);
        this.timerId = undefined;
        this.shouldTrackExperience = false;
        this.hasTrackedExperience = false;
        this.pendingCount = 0;
        this.memoizedContext = {
            consumerCallbacks: {
                onPending: this.onPending,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure,
                onAbort: this.onAbort
            },
            experienceId: this.props.experienceId,
            experience: this.props.experience
        };
    }
    trackExperience({ wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, additionalAttributes: additionalAttributes }) {
        if (this.hasTrackedExperience) // We only ever want to send a single success/failure event for an experience
        return;
        this.hasTrackedExperience = true;
        const { parentTrackerCallbacks: parentTrackerCallbacks, additionalAttributes: additionalAttributesFromProps } = this.props;
        if (parentTrackerCallbacks) {
            if (wasExperienceSuccesful) parentTrackerCallbacks.onExperienceSuccess();
            else parentTrackerCallbacks.onExperienceFailure(location, {
                ...additionalAttributesFromProps,
                ...additionalAttributes
            });
        } else {
            const { experience: experience } = this.memoizedContext;
            const { analyticsSource: analyticsSource, application: application, edition: edition } = this.props;
            analyticsSource && (0, $9lmTX.default)({
                experience: experience,
                action: action,
                wasExperienceSuccesful: wasExperienceSuccesful,
                location: location,
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: {
                    ...additionalAttributesFromProps,
                    ...additionalAttributes
                }
            });
        }
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.memoizedContext.experienceId !== this.props.experienceId) this.resetExperience();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YJkI.default).Provider, {
            value: this.memoizedContext
        }, this.props.children);
    }
}

});
const $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $99e7a4e4cbcb5db0$export$b48b3d1872522384 = 'taskFail';
const $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8 = 'taskAbort';



parcelRegister("18Cd3", function(module, exports) {

$parcel$export(module.exports, "SidebarNav4ControllerProvider", () => $35192d3debbc289e$export$ec25d268893d889d);
$parcel$export(module.exports, "useSidebarNav4Controller", () => $35192d3debbc289e$export$641950c86d73374);

var $eUqFw = parcelRequire("eUqFw");

var $7uCfF = parcelRequire("7uCfF");
const $35192d3debbc289e$var$SidebarNav4ControllerContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
function $35192d3debbc289e$export$ec25d268893d889d(props) {
    const { children: children, controlledPath: initialControlledPath = null } = props;
    const [controlledPath, setControlledPath] = (0, $eUqFw.useState)(initialControlledPath); // null means "not being controlled"
    const sidebarNav4Controller = (0, $eUqFw.useMemo)(()=>({
            // is any path in Navigation a controlled one
            isControlledNav: controlledPath !== null,
            isControlledPath: (0, $7uCfF.isSelectedPath)(controlledPath ?? []),
            setControlledPath: setControlledPath
        }), [
        controlledPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35192d3debbc289e$var$SidebarNav4ControllerContext.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $35192d3debbc289e$export$641950c86d73374() {
    const context = (0, $eUqFw.useContext)($35192d3debbc289e$var$SidebarNav4ControllerContext);
    if (context == null) throw new Error('useSidebarNav4Controller must be used inside a SidebarNav4ControllerContext');
    return context;
}

});
parcelRegister("7uCfF", function(module, exports) {

$parcel$export(module.exports, "isSelectedPath", () => $62c21b20ac5de9fc$export$cdcd6885320eec31);

var $hZ5um = parcelRequire("hZ5um");
function $62c21b20ac5de9fc$export$cdcd6885320eec31(path, ...args) {
    const next = (menuId)=>{
        return (0, $hZ5um.isMenuIdList)(menuId) ? (0, $hZ5um.toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
    };
    if (args.length === 0) return next;
    return next(args[0]);
}

});
parcelRegister("hZ5um", function(module, exports) {

$parcel$export(module.exports, "toMenuIdFromMenuIdList", () => $0aa74a7539989c0c$export$253323efd0c41e72);
$parcel$export(module.exports, "isMenuIdList", () => $0aa74a7539989c0c$export$abdb8aa7ce9ed1ed);
$parcel$export(module.exports, "toMenuIdList", () => $0aa74a7539989c0c$export$d8e017f58178e379);
const $0aa74a7539989c0c$var$MENU_ID_DELIM = '   '; // Three spaces
function $0aa74a7539989c0c$export$253323efd0c41e72(menuIds) {
    return menuIds.join($0aa74a7539989c0c$var$MENU_ID_DELIM);
}
function $0aa74a7539989c0c$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
    return maybeMenuIdList.indexOf($0aa74a7539989c0c$var$MENU_ID_DELIM) !== -1;
}
function $0aa74a7539989c0c$export$d8e017f58178e379(menuIdList) {
    return menuIdList.split($0aa74a7539989c0c$var$MENU_ID_DELIM);
}

});



parcelRegister("cH5Wq", function(module, exports) {

$parcel$export(module.exports, "PostOfficeProvider", () => $a7b18f936fd35517$export$fb465b6e855c1e85);
$parcel$export(module.exports, "PostOfficeRouterListener", () => $a7b18f936fd35517$export$9f8d3084fd3d5fc0);

var $eUqFw = parcelRequire("eUqFw");

var $cPGDt = parcelRequire("cPGDt");

var $5GxEP = parcelRequire("5GxEP");

var $eI5EY = parcelRequire("eI5EY");

var $gZ48R = parcelRequire("gZ48R");

var $cPEpP = parcelRequire("cPEpP");

var $jD3pk = parcelRequire("jD3pk");

var $4rWQe = parcelRequire("4rWQe");

var $ab6rA = parcelRequire("ab6rA");

var $dWLk9 = parcelRequire("dWLk9");

var $3e9vj = parcelRequire("3e9vj");

var $1R3n5 = parcelRequire("1R3n5");

var $4xHig = parcelRequire("4xHig");

var $2j1pH = parcelRequire("2j1pH");
var $fH5K1 = parcelRequire("fH5K1");

var $lB25E = parcelRequire("lB25E");

const $a7b18f936fd35517$var$subproductToEdition = (subproduct, editions)=>{
    switch(subproduct){
        case 'core':
            return editions.core;
        case 'software':
            return editions.software;
        case 'customerService':
            return editions.customerService;
        case 'serviceDesk':
            return editions.serviceDesk;
        default:
            undefined;
    }
};
const $a7b18f936fd35517$var$JiraPostOfficeProvider = ({ children: children })=>{
    const { data: data } = (0, $cPEpP.useProject)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const activationId = (0, $4rWQe.useActivationId)();
    const locale = (0, $4xHig.useLocale)();
    const environment = (0, $3e9vj.useEnvironment)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const editions = (0, $ab6rA.useAppEditions)();
    const subproduct = data?.type;
    const edition = $a7b18f936fd35517$var$subproductToEdition(subproduct, editions);
    const workspaceAri = (0, $cPGDt.JiraWorkspaceAri).create({
        activationId: activationId,
        siteId: cloudId
    }).toString();
    const context = (0, $eUqFw.useMemo)(()=>({
            product: 'jira',
            tenantId: cloudId,
            workspaceAri: workspaceAri,
            workspaceId: activationId,
            orgId: orgId,
            subproduct: subproduct,
            isSiteAdmin: isSiteAdmin,
            locale: locale,
            productEdition: edition
        }), [
        cloudId,
        orgId,
        activationId,
        subproduct,
        isSiteAdmin,
        locale,
        workspaceAri,
        edition
    ]);
    const env = (0, $eUqFw.useMemo)(()=>$a7b18f936fd35517$export$cfacfecb20987ff1(environment), [
        environment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2j1pH.PostOfficeProvider), {
        context: {
            current: context
        },
        environment: {
            env: env
        }
    }, children);
};
const $a7b18f936fd35517$export$fb465b6e855c1e85 = ({ children: children })=>{
    // Using the Feature Gate used for the placement app-switcher-discovery-section because PostOfficeProvider is always needed when the app-switcher-discovery-section is enabled
    const isPostOfficeEnabled = !(0, $gZ48R.default)('killswitch_post_office_in_jira');
    return isPostOfficeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "postOfficeJiraProvider",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7b18f936fd35517$var$JiraPostOfficeProvider, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $a7b18f936fd35517$var$ReactResourceRouterListener = ({ children: children })=>{
    const [route] = (0, $lB25E.useRouter)();
    (0, $fH5K1.usePostOfficeRouteUpdate)([
        route.basePath,
        route.location.pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $a7b18f936fd35517$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
    const isPostOfficeEnabled = !(0, $gZ48R.default)('killswitch_post_office_in_jira');
    const isScreenSpaceFlagsEnabled = (0, $eI5EY.fg)('post-office-screen-space-overlay-jfe');
    return isPostOfficeEnabled && isScreenSpaceFlagsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7b18f936fd35517$var$ReactResourceRouterListener, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $a7b18f936fd35517$export$cfacfecb20987ff1 = (environment)=>{
    switch(environment){
        case 'dev':
        case 'staging':
            return 'staging';
        case 'prod':
            return 'production';
        case 'local':
            return 'local';
        default:
            return 'local';
    }
};

});
parcelRegister("cPGDt", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAri", () => $95f709ad54a54828$export$d4d0794234e3fd53);

var $5pMX4 = parcelRequire("5pMX4");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/workspace/manifest.ts
var $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $5pMX4.JiraWorkspaceAriResourceOwner),
    resourceType: (0, $5pMX4.JiraWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/jira/workspace/index.ts
var $95f709ad54a54828$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
};

});
parcelRegister("5pMX4", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", () => $cffaa0f78943566d$export$e52ccdf6abac8896);
$parcel$export(module.exports, "JiraWorkspaceAriResourceType", () => $cffaa0f78943566d$export$669cd5f7b3746bb);
// src/jira/workspace/types.ts
var $cffaa0f78943566d$export$e52ccdf6abac8896 = "jira", $cffaa0f78943566d$export$669cd5f7b3746bb = "workspace";

});


parcelRegister("ab6rA", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $75e408c194026ea5$export$92ed15881fc090d7);

var $gd0Sp = parcelRequire("gd0Sp");
const $75e408c194026ea5$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});

parcelRegister("3e9vj", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $f75608ebab912e29$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $f75608ebab912e29$export$b0d8f74f433a09c9);

var $gd0Sp = parcelRequire("gd0Sp");
const $f75608ebab912e29$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $f75608ebab912e29$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext?.environment || $f75608ebab912e29$var$ENVIRONMENT.PROD;
};
const $f75608ebab912e29$export$b0d8f74f433a09c9 = ()=>{
    const env = $f75608ebab912e29$export$ea7ed2425832167d();
    return env === $f75608ebab912e29$var$ENVIRONMENT.STAGING || env === $f75608ebab912e29$var$ENVIRONMENT.DEV || env === $f75608ebab912e29$var$ENVIRONMENT.LOCAL;
};

});

parcelRegister("4xHig", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $d8981c42d4d07028$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $d8981c42d4d07028$export$31652d9c30d7d3f3);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");
const $d8981c42d4d07028$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $ao0hp.defaultLocale);
};
const $d8981c42d4d07028$export$31652d9c30d7d3f3 = ()=>{
    const locale = $d8981c42d4d07028$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $eUqFw.useMemo)(()=>(0, $ao0hp.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

parcelRegister("2j1pH", function(module, exports) {

$parcel$export(module.exports, "PostOfficeProvider", () => $88465c6d4ed1a100$export$fb465b6e855c1e85);

var $eUqFw = parcelRequire("eUqFw");

var $kd0cS = parcelRequire("kd0cS");

var $2vzCR = parcelRequire("2vzCR");

var $cdoUV = parcelRequire("cdoUV");

var $3AUkT = parcelRequire("3AUkT");

var $fH5K1 = parcelRequire("fH5K1");

var $aUdcY = parcelRequire("aUdcY");

var $ima73 = parcelRequire("ima73");

var $6jATK = parcelRequire("6jATK");

var $aNFyK = parcelRequire("aNFyK");
const $88465c6d4ed1a100$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children })=>{
    const stableEnvironment = (0, $ima73.useStableObject)((0, $aNFyK.generateEnvironmentConfigWithOverrides)((0, $3AUkT.defaultEnvironmentValues), envWithOverrides));
    const stableContext = (0, $ima73.useStableObject)($88465c6d4ed1a100$var$composeConfig((0, $cdoUV.defaultPostOfficeContextValue), context.current));
    const memoizedMessagePlacementValues = (0, $eUqFw.useMemo)(()=>(0, $6jATK.createMessagePlacementValues)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3AUkT.PostOfficeEnvironmentProvider), {
        value: stableEnvironment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdoUV.InternalPostOfficeContextProvider), {
        value: stableContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUdcY.PostOfficeScreenContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6jATK.MessagePlacementProvider), {
        value: memoizedMessagePlacementValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fH5K1.RouteListenerProvider), null, children)))));
};
const $88465c6d4ed1a100$var$composeConfig = (base, ...rest)=>rest.reduce((a, v)=>(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(a, v), (0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(base));

});
parcelRegister("cdoUV", function(module, exports) {

$parcel$export(module.exports, "defaultPostOfficeContextValue", () => $ece28133cd5341bb$export$da5dc9062cba6715);
$parcel$export(module.exports, "InternalPostOfficeContextProvider", () => $ece28133cd5341bb$export$3a10495c2cd2db0c);
$parcel$export(module.exports, "PostOfficeContextProvider", () => $ece28133cd5341bb$export$b77983be89bb0a4e);
$parcel$export(module.exports, "usePostOfficeContext", () => $ece28133cd5341bb$export$5bd9099e0ae94a43);

var $eUqFw = parcelRequire("eUqFw");
const $ece28133cd5341bb$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $ece28133cd5341bb$export$a228be81fcb77b42 = (0, $eUqFw.createContext)($ece28133cd5341bb$export$da5dc9062cba6715);
const $ece28133cd5341bb$export$3a10495c2cd2db0c = $ece28133cd5341bb$export$a228be81fcb77b42.Provider;
const $ece28133cd5341bb$export$b77983be89bb0a4e = $ece28133cd5341bb$export$3a10495c2cd2db0c;
const $ece28133cd5341bb$export$5bd9099e0ae94a43 = ()=>(0, $eUqFw.useContext)($ece28133cd5341bb$export$a228be81fcb77b42);

});

parcelRegister("3AUkT", function(module, exports) {

$parcel$export(module.exports, "defaultEnvironmentValues", () => $7ecb7749eb4c19e7$export$b4ede87479bfcf09);
$parcel$export(module.exports, "PostOfficeEnvironmentProvider", () => $7ecb7749eb4c19e7$export$604607f913ef367c);
$parcel$export(module.exports, "usePostOfficeEnvironment", () => $7ecb7749eb4c19e7$export$877b97169cc75e8b);

var $eUqFw = parcelRequire("eUqFw");

const $7ecb7749eb4c19e7$export$b4ede87479bfcf09 = {
    currentEnv: 'local',
    envConfigs: {
        test: {
            remoteModule: {
                origin: (0, $57efc0e6796efd88$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $57efc0e6796efd88$export$1e9fed4c0197724c),
                pathname: (0, $57efc0e6796efd88$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        local: {
            remoteModule: {
                origin: (0, $57efc0e6796efd88$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $57efc0e6796efd88$export$1e9fed4c0197724c),
                pathname: (0, $57efc0e6796efd88$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        dev: {
            remoteModule: {
                origin: (0, $57efc0e6796efd88$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $57efc0e6796efd88$export$1e9fed4c0197724c),
                pathname: (0, $57efc0e6796efd88$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        staging: {
            remoteModule: {
                origin: (0, $57efc0e6796efd88$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $57efc0e6796efd88$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'stg-fedm-east': {
            remoteModule: {
                origin: (0, $57efc0e6796efd88$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $57efc0e6796efd88$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        production: {
            remoteModule: {
                origin: (0, $57efc0e6796efd88$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $57efc0e6796efd88$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'prod-fedm-east': {
            remoteModule: {
                origin: (0, $57efc0e6796efd88$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $57efc0e6796efd88$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        }
    }
};
const $7ecb7749eb4c19e7$export$fceca2c399b32565 = (0, $eUqFw.createContext)($7ecb7749eb4c19e7$export$b4ede87479bfcf09);
const $7ecb7749eb4c19e7$export$604607f913ef367c = $7ecb7749eb4c19e7$export$fceca2c399b32565.Provider;
const $7ecb7749eb4c19e7$export$877b97169cc75e8b = ()=>(0, $eUqFw.useContext)($7ecb7749eb4c19e7$export$fceca2c399b32565);

});
var $57efc0e6796efd88$exports = {};

$parcel$export($57efc0e6796efd88$exports, "API_ORIGIN_LOCAL", () => $57efc0e6796efd88$export$1e9fed4c0197724c);
$parcel$export($57efc0e6796efd88$exports, "API_PATHNAME_LOCAL", () => $57efc0e6796efd88$export$919a9569bce66f17);
$parcel$export($57efc0e6796efd88$exports, "API_PATHNAME_STG_PROD", () => $57efc0e6796efd88$export$d4fe3482c88e73a8);
$parcel$export($57efc0e6796efd88$exports, "REMOTE_MODULE_URI_LOCAL", () => $57efc0e6796efd88$export$67be2569ef5d7666);
$parcel$export($57efc0e6796efd88$exports, "REMOTE_MODULE_URI_STG", () => $57efc0e6796efd88$export$b49738b89db261cd);
$parcel$export($57efc0e6796efd88$exports, "REMOTE_MODULE_URI_PROD", () => $57efc0e6796efd88$export$bbd96cd490b0df63);
const $57efc0e6796efd88$export$1e9fed4c0197724c = 'http://localhost:8081';
const $57efc0e6796efd88$export$919a9569bce66f17 = '/api/v1/placements/';
const $57efc0e6796efd88$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $57efc0e6796efd88$export$67be2569ef5d7666 = 'http://localhost:9009';
const $57efc0e6796efd88$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $57efc0e6796efd88$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';


parcelRegister("fH5K1", function(module, exports) {

$parcel$export(module.exports, "usePostOfficeRouteUpdate", () => $790fef6e53edf85d$export$bb606326acdd1a64);
$parcel$export(module.exports, "RouteListenerProvider", () => $790fef6e53edf85d$export$31986273b686f5ea);

var $eUqFw = parcelRequire("eUqFw");

var $4LO0M = parcelRequire("4LO0M");

var $hotL5 = parcelRequire("hotL5");
const $790fef6e53edf85d$var$noop = ()=>{};
const $790fef6e53edf85d$var$RouteListenerContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    update: $790fef6e53edf85d$var$noop
});
const $790fef6e53edf85d$export$7a2084f4baac29a7 = ()=>(0, $4LO0M.createSimplePubSub)();
const $790fef6e53edf85d$export$72fd8977abf03d60 = ()=>(0, $eUqFw.useContext)($790fef6e53edf85d$var$RouteListenerContext);
const $790fef6e53edf85d$export$755edb1665399d41 = ()=>{
    const ref = (0, $eUqFw.useRef)();
    if (!ref.current) ref.current = $790fef6e53edf85d$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $eUqFw.useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $eUqFw.useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $790fef6e53edf85d$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $790fef6e53edf85d$export$72fd8977abf03d60();
    (0, $eUqFw.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $790fef6e53edf85d$export$31986273b686f5ea = ({ children: children })=>{
    const [route, routeUpdater] = $790fef6e53edf85d$export$755edb1665399d41();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($790fef6e53edf85d$var$RouteListenerContext.Provider, {
        value: routeUpdater
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hotL5.PostOfficeRouteProvider), route, children));
};

});
parcelRegister("4LO0M", function(module, exports) {

$parcel$export(module.exports, "createSimplePubSub", () => $361bd9501b27b3c9$export$92469b55607f005b);
const $361bd9501b27b3c9$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};

});

parcelRegister("hotL5", function(module, exports) {

$parcel$export(module.exports, "PostOfficeRouteContext", () => $1c66d0cdc9d49e28$export$f7f47a74e8b47b1f);
$parcel$export(module.exports, "PostOfficeRouteProvider", () => $1c66d0cdc9d49e28$export$89eadc6b3e5f4e9e);
$parcel$export(module.exports, "usePostOfficeRoute", () => $1c66d0cdc9d49e28$export$79301b66f7808cd8);

var $eUqFw = parcelRequire("eUqFw");

var $7GDOq = parcelRequire("7GDOq");

var $ima73 = parcelRequire("ima73");
const $1c66d0cdc9d49e28$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $1c66d0cdc9d49e28$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current) return;
        state = {
            previous: state.current,
            current: next
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $1c66d0cdc9d49e28$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $7GDOq.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $ima73.useStableObject)(route);
};
const $1c66d0cdc9d49e28$var$initialState = {
    previous: undefined,
    current: undefined
};
const $1c66d0cdc9d49e28$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$1c66d0cdc9d49e28$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined
    });
const $1c66d0cdc9d49e28$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $eUqFw.createContext)($1c66d0cdc9d49e28$var$initialState);
const $1c66d0cdc9d49e28$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $eUqFw.useRef)();
    if (!ref.current) ref.current = $1c66d0cdc9d49e28$export$98c77e1bd702ed15(props);
    const route = $1c66d0cdc9d49e28$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c66d0cdc9d49e28$export$f7f47a74e8b47b1f.Provider, {
        value: route
    }, children);
};
const $1c66d0cdc9d49e28$export$79301b66f7808cd8 = ()=>(0, $eUqFw.useContext)($1c66d0cdc9d49e28$export$f7f47a74e8b47b1f); //Route listener

});
parcelRegister("ima73", function(module, exports) {

$parcel$export(module.exports, "useStableObject", () => $6215497710656200$export$ed02d4adf2068b08);

var $eUqFw = parcelRequire("eUqFw");
function $6215497710656200$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $6215497710656200$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $eUqFw.useMemo)(()=>obj, $6215497710656200$export$cdf98ded28406f69(obj));
}

});



parcelRegister("aUdcY", function(module, exports) {

$parcel$export(module.exports, "PostOfficeScreenContextProvider", () => $b9aef2b0e7294efc$export$ca77a8cbe94108fe);
$parcel$export(module.exports, "usePostOfficeScreenPlacement", () => $b9aef2b0e7294efc$export$f51d04a086368016);

var $eUqFw = parcelRequire("eUqFw");

var $aAKZT = parcelRequire("aAKZT");
const $b9aef2b0e7294efc$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $b9aef2b0e7294efc$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    placements: $b9aef2b0e7294efc$var$initialPlacementState
});
const $b9aef2b0e7294efc$export$70e19226ddeaf957 = ()=>(0, $eUqFw.useContext)($b9aef2b0e7294efc$var$PostOfficeScreenContext);
const $b9aef2b0e7294efc$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $b9aef2b0e7294efc$export$5d27c0ee02be2a23 = ()=>(0, $eUqFw.useContext)($b9aef2b0e7294efc$var$PostOfficeScreenUpdateContext);
const $b9aef2b0e7294efc$export$ca77a8cbe94108fe = ({ children: children })=>{
    const [placements, setPlacements] = (0, $eUqFw.useState)($b9aef2b0e7294efc$var$initialPlacementState);
    const placementMount = (0, $eUqFw.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $aAKZT.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $aAKZT.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $eUqFw.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
            }), []);
    const postOfficeScreenUpdateContext = (0, $eUqFw.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $eUqFw.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9aef2b0e7294efc$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9aef2b0e7294efc$var$PostOfficeScreenContext.Provider, {
        value: postOfficeScreenContext
    }, children));
};
const $b9aef2b0e7294efc$export$f51d04a086368016 = ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $b9aef2b0e7294efc$export$5d27c0ee02be2a23();
    (0, $eUqFw.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};

});
parcelRegister("aAKZT", function(module, exports) {

$parcel$export(module.exports, "uniqueArray", () => $7cf93c11a15a7d9e$export$bbd17ecb0679edd7);
const $7cf93c11a15a7d9e$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());

});


parcelRegister("6jATK", function(module, exports) {

$parcel$export(module.exports, "createMessagePlacementValues", () => $046cbf3609a6f718$export$a28a0c048b24fc5a);
$parcel$export(module.exports, "MessagePlacementProvider", () => $046cbf3609a6f718$export$c7535f8ebc5b75a9);
$parcel$export(module.exports, "useMessagePlacementHooks", () => $046cbf3609a6f718$export$89f8e1f623d8f5ac);

var $eUqFw = parcelRequire("eUqFw");
/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $046cbf3609a6f718$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
	 * Subscribes a callback function to the pub-sub system.
	 * @param {Callback} subscriber - The callback function to subscribe.
	 * @returns A function to unsubscribe the callback.
	 */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
	 * Publishes the payload to all subscribed callbacks.
	 * @param {Callback} payload - The payload to publish to the subscribers.
	 */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $046cbf3609a6f718$export$a28a0c048b24fc5a = ()=>{
    const [onMessageDismiss, dismissMessageFromPlacement] = $046cbf3609a6f718$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $046cbf3609a6f718$var$createPubSub();
    const [onMessageViewed, markViewedFromPlacement] = $046cbf3609a6f718$var$createPubSub();
    const [onMessageClicked, markClickedFromPlacement] = $046cbf3609a6f718$var$createPubSub();
    return {
        onMessageDismiss: onMessageDismiss,
        dismissMessageFromPlacement: dismissMessageFromPlacement,
        onMessageRead: onMessageRead,
        markReadFromPlacement: markReadFromPlacement,
        onMessageViewed: onMessageViewed,
        markViewedFromPlacement: markViewedFromPlacement,
        onMessageClicked: onMessageClicked,
        markClickedFromPlacement: markClickedFromPlacement
    };
};
const $046cbf3609a6f718$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $eUqFw.createContext)($046cbf3609a6f718$export$a28a0c048b24fc5a());
const $046cbf3609a6f718$export$c7535f8ebc5b75a9 = $046cbf3609a6f718$export$ea58328f3ceee4d4.Provider;
const $046cbf3609a6f718$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($046cbf3609a6f718$export$c7535f8ebc5b75a9, {
            value: $046cbf3609a6f718$export$a28a0c048b24fc5a()
        }, children);
const $046cbf3609a6f718$export$89f8e1f623d8f5ac = ()=>(0, $eUqFw.useContext)($046cbf3609a6f718$export$ea58328f3ceee4d4);

});

parcelRegister("aNFyK", function(module, exports) {

$parcel$export(module.exports, "generateEnvironmentConfigWithOverrides", () => $85e9ace7b08ea46c$export$ae3dab16eb1fc2cc);
const $85e9ace7b08ea46c$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
    const { env: env, overrides: overrides } = environmentWithOverrides;
    return {
        currentEnv: env,
        envConfigs: {
            ...defaultEnvironmentValues.envConfigs,
            [env]: {
                remoteModule: {
                    origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                    pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                    searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                },
                api: {
                    origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                    pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                    searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                }
            }
        }
    };
};

});



parcelRegister("cajdb", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceFlagsPlacement", () => $e7a37d5e7fd181fa$export$f6564e60882bdf90);

var $eUqFw = parcelRequire("eUqFw");

var $hSOZd = parcelRequire("hSOZd");

var $eI5EY = parcelRequire("eI5EY");

var $gZ48R = parcelRequire("gZ48R");

var $hFteq = parcelRequire("hFteq");

const $e7a37d5e7fd181fa$export$f6564e60882bdf90 = ()=>{
    return !false && !(0, $gZ48R.default)((0, $bfe8fff5e78bf213$export$37d4bb5bc0e315db)) && (0, $eI5EY.fg)('post-office-screen-space-overlay-jfe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFteq.default), {
        placementId: "screen-space-flags",
        PlacementComponent: (0, $hSOZd.default),
        disableInitialData: true
    }) : null;
}; // Comment to trigger Jira cypress tests

});
parcelRegister("hSOZd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6745e19359bd5e86$export$2e2bcd8739ae039);

var $lHkHI = parcelRequire("lHkHI");

var $eUqFw = parcelRequire("eUqFw");

var $8tM2T = parcelRequire("8tM2T");

var $cNc3D = parcelRequire("cNc3D");
var $6jATK = parcelRequire("6jATK");

var $1U7NE = parcelRequire("1U7NE");
var $eo7xM = parcelRequire("eo7xM");

var $ltwi6 = parcelRequire("ltwi6");

var $bNimx = parcelRequire("bNimx");

var $6Yahf = parcelRequire("6Yahf");


var $95Lkj = parcelRequire("95Lkj");
const $6745e19359bd5e86$export$c60b43809441c5b0 = (0, $95Lkj.withScreenSpaceFlagsIntlProvider)((0, $1U7NE.createPlacementComponent)((0, $97e679571c55280b$export$a5cfae247d8360ef), ({ initialData: initialData })=>{
    const [localMessageState, setLocalMessageState] = (0, $eUqFw.useState)();
    (0, $eo7xM.useInitialData)(initialData);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked } = (0, $6jATK.useMessagePlacementHooks)();
    const handleDismiss = ({ messageInstanceId: messageInstanceId })=>{
        setLocalMessageState((current)=>current ? current.filter((e)=>e.messageInstanceId !== messageInstanceId) : undefined);
    };
    (0, $eUqFw.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss
    ]);
    (0, $eUqFw.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked
    ]);
    const activeScopes = (0, $cNc3D.usePostOfficeContextScope)({
        scopes: $bNimx.scopes
    });
    const messagesState = (0, $ltwi6.usePlacementApi)('/update-messages', {
        requestOptions: {
            method: 'POST',
            body: JSON.stringify(activeScopes)
        },
        throttleTime: 100,
        autoRefetch: {
            isEnabled: !!activeScopes.updateKey && typeof localMessageState === 'undefined',
            updateKey: activeScopes.updateKey ?? ''
        }
    });
    (0, $eUqFw.useEffect)(()=>{
        if (messagesState?.data?.messages?.length) setLocalMessageState(messagesState.data.messages);
    }, [
        messagesState.data
    ]);
    return (0, $8tM2T.default).checkGate('post-office-screen-space-flags-shadow') ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: localMessageState?.slice(0, 1).map(({ messageInstanceId: messageInstanceId, ...props })=>/*#__PURE__*/ (0, $eUqFw.createElement)((0, $6Yahf.MessageRenderer), {
                ...props,
                key: messageInstanceId,
                id: messageInstanceId,
                messageInstanceId: messageInstanceId,
                onDismissed: ()=>setLocalMessageState([])
            }))
    }) : null;
}));
var $6745e19359bd5e86$export$2e2bcd8739ae039 = $6745e19359bd5e86$export$c60b43809441c5b0;

});
parcelRegister("lHkHI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4SRlw"));

});
parcelRegister("4SRlw", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $38e595fef2d7b104$export$ffb0004e005737fa, (v) => $38e595fef2d7b104$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $38e595fef2d7b104$export$34b9dba7ce09269b, (v) => $38e595fef2d7b104$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $38e595fef2d7b104$export$25062201e9e25d76, (v) => $38e595fef2d7b104$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38e595fef2d7b104$export$ffb0004e005737fa;
var $38e595fef2d7b104$export$34b9dba7ce09269b;
var $38e595fef2d7b104$export$25062201e9e25d76;
'use strict';

var $eUqFw = parcelRequire("eUqFw");
var $38e595fef2d7b104$var$k = Symbol.for("react.element"), $38e595fef2d7b104$var$l = Symbol.for("react.fragment"), $38e595fef2d7b104$var$m = Object.prototype.hasOwnProperty, $38e595fef2d7b104$var$n = $eUqFw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $38e595fef2d7b104$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $38e595fef2d7b104$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$38e595fef2d7b104$var$m.call(a, b) && !$38e595fef2d7b104$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $38e595fef2d7b104$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $38e595fef2d7b104$var$n.current
    };
}
$38e595fef2d7b104$export$ffb0004e005737fa = $38e595fef2d7b104$var$l;
$38e595fef2d7b104$export$34b9dba7ce09269b = $38e595fef2d7b104$var$q;
$38e595fef2d7b104$export$25062201e9e25d76 = $38e595fef2d7b104$var$q;

});


parcelRegister("cNc3D", function(module, exports) {

$parcel$export(module.exports, "usePostOfficeContextScope", () => $354476e5f255abd8$export$daf66a67c26dc848);

var $eUqFw = parcelRequire("eUqFw");

var $bqxFG = parcelRequire("bqxFG");

var $cdoUV = parcelRequire("cdoUV");

var $hotL5 = parcelRequire("hotL5");

var $4LO0M = parcelRequire("4LO0M");
const $354476e5f255abd8$export$daf66a67c26dc848 = (config)=>{
    const scopeNames = $354476e5f255abd8$var$scopesNamesAsString(config.scopes);
    const matchScopes = (0, $eUqFw.useCallback)((input)=>$354476e5f255abd8$export$ec890b48cae4cc1c(config)(input), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        scopeNames
    ]);
    const [state, setState] = (0, $eUqFw.useState)($354476e5f255abd8$var$initialState);
    const route = (0, $hotL5.usePostOfficeRoute)();
    const context = (0, $cdoUV.usePostOfficeContext)();
    const next = matchScopes({
        route: route,
        context: context
    });
    $354476e5f255abd8$var$usePostOfficeScopeSpy(state, config);
    (0, $eUqFw.useEffect)(()=>{
        if ($354476e5f255abd8$export$fcc046cb16c47539({
            next: next,
            state: state
        })) setState(({ current: current })=>({
                updateKey: Math.random().toString(36).substring(2),
                current: next,
                previous: current
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $354476e5f255abd8$var$scopesNamesAsString(next)
    ]);
    return state;
};
const $354476e5f255abd8$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
const $354476e5f255abd8$var$initialState = {
    updateKey: undefined,
    current: [],
    previous: []
};
const $354476e5f255abd8$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
        const contextMatch = route?.current ? {
            route: $354476e5f255abd8$var$extractRelevantUrlFields(route.current),
            context: context
        } : {
            route: undefined,
            context: context
        };
        const inputMatch = input.when;
        return $354476e5f255abd8$var$matchScope({
            contextMatch: contextMatch,
            inputMatch: inputMatch
        });
    };
const $354476e5f255abd8$var$extractRelevantUrlFields = (route)=>{
    const { hostname: hostname, pathname: pathname } = new URL(route);
    return {
        hostname: hostname,
        pathname: pathname
    };
};
const $354476e5f255abd8$var$matchScope = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, (/*@__PURE__*/$parcel$interopDefault($bqxFG)))(contextMatch, inputMatch, (contextValue, inputValue)=>$354476e5f255abd8$var$isValueMatchDeep({
            contextValue: contextValue,
            inputValue: inputValue
        }));
const $354476e5f255abd8$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
    if (!contextValue || !inputValue) return false;
    if (typeof inputValue === 'string') return contextValue === inputValue;
    if (inputValue?.equals) return contextValue === inputValue.equals;
    if (!inputValue?.matches) return false;
    if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
    return new RegExp(inputValue.matches).test(contextValue);
};
const $354476e5f255abd8$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $354476e5f255abd8$var$matchScope({
        contextMatch: contextValue,
        inputMatch: inputValue
    }) : $354476e5f255abd8$var$isValueMatch({
        contextValue: contextValue,
        inputValue: inputValue
    });
const $354476e5f255abd8$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($354476e5f255abd8$var$createMatchScope(input)).map((scope)=>({
                name: scope.name
            }));
const $354476e5f255abd8$export$fcc046cb16c47539 = ({ next: next, state: state })=>{
    const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
    const nextSet = Array.from(new Set(next.map((e)=>e.name)));
    if (nextSet.length !== currentSet.length) return true;
    return !nextSet.every((e)=>currentSet.includes(e));
};
// Scope Spy
const $354476e5f255abd8$var$usePostOfficeScopeSpy = (state, config)=>{
    if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
        const [listen, update] = (0, $4LO0M.createSimplePubSub)();
        window.postOffice = {
            ...window.postOffice,
            scopes: {
                [config?.consoleSpy.name]: {
                    listen: listen,
                    update: update,
                    list: config.scopes
                }
            }
        };
    }
    (0, $eUqFw.useEffect)(()=>{
        if (!config?.consoleSpy) return;
        if (!window.postOffice?.scopes) return;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $354476e5f255abd8$var$scopesNamesAsString(state.current)
    ]);
};

});
parcelRegister("bqxFG", function(module, exports) {

var $fEi2Q = parcelRequire("fEi2Q");

var $lBs6Q = parcelRequire("lBs6Q");
/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */ function $851c3ddb809f167c$var$isMatchWith(object, source, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $fEi2Q(object, source, $lBs6Q(source), customizer);
}
module.exports = $851c3ddb809f167c$var$isMatchWith;

});


parcelRegister("1U7NE", function(module, exports) {

$parcel$export(module.exports, "createPlacementComponent", () => $43cb12fb9a5ceef8$export$8a57effc6307f916);

var $lHkHI = parcelRequire("lHkHI");

var $ima73 = parcelRequire("ima73");

var $2n2Lu = parcelRequire("2n2Lu");

var $9jnJv = parcelRequire("9jnJv");

var $lEMKy = parcelRequire("lEMKy");
var $CS1uA = parcelRequire("CS1uA");

var $ac5QK = parcelRequire("ac5QK");
const $43cb12fb9a5ceef8$export$eaeb39efb2b24b52 = (placementId, Component)=>(0, $ac5QK.withErrorBoundary)((props)=>{
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        const stableContext = (0, $ima73.useStableObject)(context);
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lEMKy.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $CS1uA.StableProviders), {
                route: route,
                context: stableContext,
                placement: {
                    placementId: placementId
                },
                children: /*#__PURE__*/ (0, $lHkHI.jsx)(Component, {
                    context: stableContext,
                    initialData: initialData,
                    ...componentProps
                })
            })
        });
    });
const $43cb12fb9a5ceef8$export$8a57effc6307f916 = (placementId, Component)=>{
    const placement = $43cb12fb9a5ceef8$export$eaeb39efb2b24b52(placementId, Component);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $9jnJv.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $2n2Lu.ERROR_BOUNDARY_LOCATION),
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};

});
parcelRegister("2n2Lu", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $9eee26908e97ff83$export$9c542858adf7dcd0);
$parcel$export(module.exports, "ERROR_BOUNDARY_LOCATION", () => $9eee26908e97ff83$export$71ff7382870ef1b0);
const $9eee26908e97ff83$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $9eee26908e97ff83$export$71ff7382870ef1b0 = 'create-placement-component';

});

parcelRegister("9jnJv", function(module, exports) {

$parcel$export(module.exports, "useComponentErrorHandling", () => $7da27a49d414a0df$export$3d127465d22fe4e5);

var $eUqFw = parcelRequire("eUqFw");
const $7da27a49d414a0df$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $eUqFw.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};

});

parcelRegister("lEMKy", function(module, exports) {

$parcel$export(module.exports, "PerformanceTracking", () => $1def77c04ebf76e5$export$9a335a42ce02bdb8);

var $lHkHI = parcelRequire("lHkHI");

var $8tM2T = parcelRequire("8tM2T");

var $cmorc = parcelRequire("cmorc");

var $899ny = parcelRequire("899ny");

var $k3qPd = parcelRequire("k3qPd");
const $1def77c04ebf76e5$export$9a335a42ce02bdb8 = ({ children: children, ...props })=>{
    const isUFOEnabled = (0, $8tM2T.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $k3qPd.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $cmorc.UFOv2).UFOSegment, {
        name: (0, $cmorc.UFOv2).SegmentNames.PLACEMENT,
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cmorc.UFOv2).UFOLoadHold, {
                name: (0, $cmorc.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $899ny.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
};

});
parcelRegister("cmorc", function(module, exports) {

$parcel$export(module.exports, "UFOv2", () => $e7c2bcbadfde0296$export$c91b09caa8ecbab1);

var $apShl = parcelRequire("apShl");

var $5crv8 = parcelRequire("5crv8");
const $e7c2bcbadfde0296$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: $apShl.default,
    UFOSegment: $5crv8.default
};

});

parcelRegister("899ny", function(module, exports) {

$parcel$export(module.exports, "TrackMount", () => $ab87103904aa0a29$export$21b400a8c8ebc91a);

var $lHkHI = parcelRequire("lHkHI");

var $eUqFw = parcelRequire("eUqFw");
const $ab87103904aa0a29$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $eUqFw.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: children
    });
};

});

parcelRegister("k3qPd", function(module, exports) {

$parcel$export(module.exports, "usePerformanceTracking", () => $8f1e99aea6b2311e$export$317d52099614f316);

var $eUqFw = parcelRequire("eUqFw");
const $8f1e99aea6b2311e$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(true);
    const onMount = (0, $eUqFw.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $eUqFw.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};

});


parcelRegister("CS1uA", function(module, exports) {

$parcel$export(module.exports, "StableProviders", () => $e20c0a1b6e5e1113$export$2b6596bcb1383a71);

var $lHkHI = parcelRequire("lHkHI");

var $2djSI = parcelRequire("2djSI");

var $3Pu3Z = parcelRequire("3Pu3Z");

var $46uIx = parcelRequire("46uIx");

var $dHSqG = parcelRequire("dHSqG");

var $aLvZd = parcelRequire("aLvZd");

var $lEMKy = parcelRequire("lEMKy");
const $e20c0a1b6e5e1113$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route })=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $46uIx.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dHSqG.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aLvZd.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2djSI.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3Pu3Z.StableChoreographerProvider), {
                        children: children
                    })
                })
            })
        })
    });

});
parcelRegister("2djSI", function(module, exports) {

$parcel$export(module.exports, "StableAnaltyicsProvider", () => $b759163eb7333f79$export$5a66cdc9893b43e);

var $lHkHI = parcelRequire("lHkHI");

var $dcbVh = parcelRequire("dcbVh");
const $b759163eb7333f79$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: undefined,
            b: undefined,
            t: undefined
        }
    }
};
const $b759163eb7333f79$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dcbVh.PostOfficeAnalyticsContext), {
        data: $b759163eb7333f79$var$postOfficeAnalyticsContextData,
        children: children
    });
};

});

parcelRegister("3Pu3Z", function(module, exports) {

$parcel$export(module.exports, "StableChoreographerProvider", () => $1bffbe89968ea693$export$e68b2c75bfb5682a);
$parcel$export(module.exports, "useChoreographerContext", () => $1bffbe89968ea693$export$cab5a8adbabcee23);

var $lHkHI = parcelRequire("lHkHI");

var $cdoUV = parcelRequire("cdoUV");
var $3AUkT = parcelRequire("3AUkT");

var $eUqFw = parcelRequire("eUqFw");

var $5Qtnd = parcelRequire("5Qtnd");
const $1bffbe89968ea693$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $1bffbe89968ea693$var$defaultContext = {
    choreographerEnabled: $1bffbe89968ea693$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $1bffbe89968ea693$var$ChoreographerContext = /*#__PURE__*/ (0, $eUqFw.createContext)($1bffbe89968ea693$var$defaultContext);
const $1bffbe89968ea693$export$e68b2c75bfb5682a = ({ children: children })=>{
    const [choreographerEnabled, setChoreographerEnabled] = (0, $eUqFw.useState)($1bffbe89968ea693$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $3AUkT.usePostOfficeEnvironment)();
    const context = (0, $cdoUV.usePostOfficeContext)();
    const choreographerFactory = new (0, $5Qtnd.default)(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory();
    const stableChoreographerContext = (0, $eUqFw.useMemo)(()=>({
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        }), [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    return /*#__PURE__*/ (0, $lHkHI.jsx)($1bffbe89968ea693$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext,
        children: children
    });
};
const $1bffbe89968ea693$export$cab5a8adbabcee23 = ()=>(0, $eUqFw.useContext)($1bffbe89968ea693$var$ChoreographerContext);

});
parcelRegister("5Qtnd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed38f7ed65401384$export$2e2bcd8739ae039);

var $5xY1g = parcelRequire("5xY1g");
var $67SDP = parcelRequire("67SDP");

var $1C9jQ = parcelRequire("1C9jQ");
const $ed38f7ed65401384$var$mapEnvToAnalyticsEnv = (env)=>{
    switch(env){
        case 'test':
        case 'local':
            return (0, $1C9jQ.envType).LOCAL;
        case 'dev':
            return (0, $1C9jQ.envType).DEV;
        case 'staging':
        case 'stg-fedm-east':
            return (0, $1C9jQ.envType).STAGING;
        case 'production':
        case 'prod-fedm-east':
            return (0, $1C9jQ.envType).PROD;
        default:
            return (0, $1C9jQ.envType).DEV;
    }
};
class $ed38f7ed65401384$var$ChoreographerRegistry {
    constructor(product, environment){
        this.product = product;
        this.environment = environment;
    }
    getPostOfficeChoreographerFactory() {
        if (window.choreographerRegistry === undefined) window.choreographerRegistry = new Map();
        const maybeChoreographerFactory = window.choreographerRegistry.get((0, $67SDP.ProductIds).POST_OFFICE);
        if (maybeChoreographerFactory) return maybeChoreographerFactory;
        const factory = (0, $5xY1g.choreographerFactory)((0, $67SDP.ProductIds).POST_OFFICE, $ed38f7ed65401384$var$mapEnvToAnalyticsEnv(this.environment), {
            sourceProductId: this.product
        });
        window.choreographerRegistry.set((0, $67SDP.ProductIds).POST_OFFICE, factory);
        return factory;
    }
}
var $ed38f7ed65401384$export$2e2bcd8739ae039 = $ed38f7ed65401384$var$ChoreographerRegistry;

});


parcelRegister("46uIx", function(module, exports) {

$parcel$export(module.exports, "StableContextProvider", () => $928d3c294a98aaa2$export$d4982c0a28b18f63);

var $lHkHI = parcelRequire("lHkHI");

var $cdoUV = parcelRequire("cdoUV");
var $ima73 = parcelRequire("ima73");

var $2n2Lu = parcelRequire("2n2Lu");
const $928d3c294a98aaa2$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $ima73.useStableObject)({
        ...(0, $2n2Lu.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cdoUV.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};

});

parcelRegister("dHSqG", function(module, exports) {

$parcel$export(module.exports, "StablePlacementProvider", () => $175a636d2610985e$export$e9fd288527498af6);

var $lHkHI = parcelRequire("lHkHI");

var $ima73 = parcelRequire("ima73");

var $7uOhm = parcelRequire("7uOhm");
const $175a636d2610985e$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $ima73.useStableObject)(placement);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7uOhm.PlacementProvider), {
        value: stableValue,
        children: children
    });
};

});
parcelRegister("7uOhm", function(module, exports) {

$parcel$export(module.exports, "PlacementProvider", () => $2b72fcb9f106951c$export$6272e220478c7f1d);
$parcel$export(module.exports, "usePlacementContext", () => $2b72fcb9f106951c$export$4fc0446ee742ad80);

var $lHkHI = parcelRequire("lHkHI");

var $dcbVh = parcelRequire("dcbVh");

var $aUdcY = parcelRequire("aUdcY");

var $eUqFw = parcelRequire("eUqFw");
const $2b72fcb9f106951c$export$6394bf86db095a8 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    placementId: undefined
});
const $2b72fcb9f106951c$export$6272e220478c7f1d = ({ value: value, children: children })=>{
    const memoizedValue = (0, $eUqFw.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $aUdcY.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, $lHkHI.jsx)($2b72fcb9f106951c$export$6394bf86db095a8.Provider, {
        value: memoizedValue,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dcbVh.PostOfficeAnalyticsContext), {
            data: memoizedValue,
            children: children
        })
    });
};
const $2b72fcb9f106951c$export$4fc0446ee742ad80 = ()=>(0, $eUqFw.useContext)($2b72fcb9f106951c$export$6394bf86db095a8);

});


parcelRegister("aLvZd", function(module, exports) {

$parcel$export(module.exports, "StableRouteProvider", () => $f5e32c6674acb982$export$ce13d00e696dfc96);

var $lHkHI = parcelRequire("lHkHI");

var $hotL5 = parcelRequire("hotL5");
var $ima73 = parcelRequire("ima73");

var $0ykqZ = parcelRequire("0ykqZ");
const $f5e32c6674acb982$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $0ykqZ.useLocationHref)();
    const stableRoute = (0, $ima73.useStableObject)(route ?? {
        previous: href,
        current: href
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hotL5.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};

});
parcelRegister("0ykqZ", function(module, exports) {

$parcel$export(module.exports, "useLocationHref", () => $50b5ace28c36d3a0$export$49fc3f3d8c7f99);
const $50b5ace28c36d3a0$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $50b5ace28c36d3a0$export$49fc3f3d8c7f99 = ()=>{
    return $50b5ace28c36d3a0$var$isLocationAvailable() ? globalThis.location.href : undefined;
};

});



parcelRegister("ac5QK", function(module, exports) {

$parcel$export(module.exports, "withErrorBoundary", () => $cd3540703d9250a5$export$f0c7a449e0cfaec7);

var $lHkHI = parcelRequire("lHkHI");


var $2Jz5c = parcelRequire("2Jz5c");

var $9watI = parcelRequire("9watI");
const $cd3540703d9250a5$export$f0c7a449e0cfaec7 = (Component)=>({ errorBoundaryLocation: errorBoundaryLocation, fallbackRender: fallbackRender, onError: onError, ...data })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $2Jz5c.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: error,
                    info: info
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $lHkHI.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9watI.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation
            }, onError),
            children: /*#__PURE__*/ (0, $lHkHI.jsx)(Component, {
                ...data
            })
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $662e33bb7444ae33$export$a1562d08625f5d7e = 'ui';
const $662e33bb7444ae33$export$947dac6c72b26f81 = 'track';
const $662e33bb7444ae33$export$f1d537d508d2945a = 'screen';
const $662e33bb7444ae33$export$12346a674644c156 = 'operational';
const $662e33bb7444ae33$export$b055de0e665cb20c = 'unknown';

parcelRegister("2Jz5c", function(module, exports) {

$parcel$export(module.exports, "useFirePostOfficeAnalyticsEvents", () => $94b9b30374801af4$export$57d19d18d6e255a5);

var $bFzGY = parcelRequire("bFzGY");

var $eUqFw = parcelRequire("eUqFw");
const $94b9b30374801af4$export$85183a312807388d = 'postOffice';
const $94b9b30374801af4$export$57d19d18d6e255a5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $eUqFw.useCallback)((event, attributes)=>{
        createAnalyticsEvent({
            ...event,
            side: 'client',
            attributes: {
                ...event.attributes,
                ...attributes
            }
        }).fire($94b9b30374801af4$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};

});

parcelRegister("9watI", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $6edf3afda31e6bfa$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");
'use client';
const $6edf3afda31e6bfa$export$b16d9fb1a22de840 = (0, $eUqFw.createContext)(null);
const $6edf3afda31e6bfa$var$initialState = {
    didCatch: false,
    error: null
};
class $6edf3afda31e6bfa$export$e926676385687eaf extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $6edf3afda31e6bfa$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($6edf3afda31e6bfa$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $6edf3afda31e6bfa$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($6edf3afda31e6bfa$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $eUqFw.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $eUqFw.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $eUqFw.createElement)($6edf3afda31e6bfa$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $6edf3afda31e6bfa$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $6edf3afda31e6bfa$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $6edf3afda31e6bfa$export$c052f6604b7d51fe() {
    const context = (0, $eUqFw.useContext)($6edf3afda31e6bfa$export$b16d9fb1a22de840);
    $6edf3afda31e6bfa$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $eUqFw.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $eUqFw.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $6edf3afda31e6bfa$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $eUqFw.forwardRef)((props, ref)=>(0, $eUqFw.createElement)($6edf3afda31e6bfa$export$e926676385687eaf, errorBoundaryProps, (0, $eUqFw.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});



parcelRegister("eo7xM", function(module, exports) {

$parcel$export(module.exports, "useInitialData", () => $36b8515024b793a7$export$5523c5f3222291d0);

var $eUqFw = parcelRequire("eUqFw");

var $iaPna = parcelRequire("iaPna");
const $36b8515024b793a7$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $eUqFw.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $iaPna.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};

});
parcelRegister("iaPna", function(module, exports) {

$parcel$export(module.exports, "AlreadyRunningError", () => $f398acf5736e6178$export$8c5224d3af2f3c8b);
$parcel$export(module.exports, "useData", () => $f398acf5736e6178$export$c1cf1cf4c5d51937);

var $2Jz5c = parcelRequire("2Jz5c");

var $aISWN = parcelRequire("aISWN");

var $eUqFw = parcelRequire("eUqFw");

var $f68N0 = parcelRequire("f68N0");
class $f398acf5736e6178$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $f398acf5736e6178$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $eUqFw.useState)((0, $f68N0.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $2Jz5c.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $eUqFw.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        }).then((0, $f68N0.assertResponseIsOk)).then((res)=>res.json()).then((data)=>{
            setState((0, $f68N0.toData)(data));
            fireAnalyticsEvent({
                action: 'resolved',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, $aISWN.camelCase)(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes
                }
            });
        }).catch((err)=>{
            if (err instanceof $f398acf5736e6178$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $f68N0.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, $aISWN.camelCase)(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};

});
parcelRegister("aISWN", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("f68N0", function(module, exports) {

$parcel$export(module.exports, "assertResponseIsOk", () => $5551871e452692d7$export$b3732c8ff6f9c463);
$parcel$export(module.exports, "toLoading", () => $5551871e452692d7$export$f9a5bd0ffba29ffc);
$parcel$export(module.exports, "toError", () => $5551871e452692d7$export$cc3b967c039ed3e7);
$parcel$export(module.exports, "toData", () => $5551871e452692d7$export$24a6b176bdc41ce5);
const $5551871e452692d7$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $5551871e452692d7$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($5551871e452692d7$export$18a0019e5439b209(res));
};
const $5551871e452692d7$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $5551871e452692d7$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $5551871e452692d7$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });

});



parcelRegister("ltwi6", function(module, exports) {

$parcel$export(module.exports, "usePlacementApi", () => $4bc7f5f9c6f4720b$export$201bbce8187a6e3c);

var $cdoUV = parcelRequire("cdoUV");

var $6Ptg3 = parcelRequire("6Ptg3");

var $7uOhm = parcelRequire("7uOhm");

var $q92ci = parcelRequire("q92ci");

var $eUqFw = parcelRequire("eUqFw");
const $4bc7f5f9c6f4720b$export$201bbce8187a6e3c = (path, config)=>{
    const { placementId: placementId } = (0, $7uOhm.usePlacementContext)();
    const context = (0, $cdoUV.usePostOfficeContext)();
    const fetcher = (0, $q92ci.usePlacementFetchingContext)();
    const placementApi = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        if (!placementId) return ()=>({
                isLoading: false,
                data: undefined,
                error: new Error('No placementId found, make this is used as a child of PlacementProvider')
            });
        return (0, $6Ptg3.createUsePlacement)(placementId, fetcher);
    }, [
        placementId,
        fetcher
    ]);
    return placementApi(path, context, config?.requestOptions, {
        throttleTime: config?.throttleTime,
        isEnabled: config?.autoRefetch?.isEnabled,
        deps: [
            config?.autoRefetch?.updateKey
        ]
    });
};

});
parcelRegister("6Ptg3", function(module, exports) {

$parcel$export(module.exports, "createUsePlacement", () => $91651b7b7363c321$export$ee1d67e435d25cb5);

var $7msIX = parcelRequire("7msIX");

var $eUqFw = parcelRequire("eUqFw");

var $iaPna = parcelRequire("iaPna");
const $91651b7b7363c321$var$depsIsValid = (deps)=>Array.isArray(deps);
const $91651b7b7363c321$export$ee1d67e435d25cb5 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const dependencyList = $91651b7b7363c321$var$depsIsValid(config?.deps) ? [
            ...config.deps,
            config?.isEnabled
        ] : [
            path,
            config?.isEnabled
        ];
        const timerRef = (0, $eUqFw.useRef)();
        const isRunningPromise = (0, $eUqFw.useRef)(false);
        (0, $eUqFw.useEffect)(()=>{
            return ()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            };
        }, []);
        const promiseToResolve = (0, $eUqFw.useMemo)(()=>{
            if (config?.isEnabled === false) return undefined;
            return ({ signal: signal })=>{
                if (isRunningPromise.current) return Promise.reject(new (0, $iaPna.AlreadyRunningError)());
                isRunningPromise.current = true;
                timerRef.current = setTimeout(()=>{
                    isRunningPromise.current = false;
                }, config?.throttleTime ?? 0);
                return (0, $7msIX.fetchPlacementData)(placementId, path, context, fetcher, {
                    ...requestOptions,
                    signal: signal
                });
            };
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        dependencyList);
        return (0, $iaPna.useData)(promiseToResolve, {
            analytics: {
                name: placementId,
                path: path
            }
        });
    };
};

});
parcelRegister("7msIX", function(module, exports) {

$parcel$export(module.exports, "fetchPlacementData", () => $b7ecb57dac2e1673$export$ce743d02f83ee521);
const $b7ecb57dac2e1673$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $b7ecb57dac2e1673$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $b7ecb57dac2e1673$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$b7ecb57dac2e1673$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $b7ecb57dac2e1673$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
    const defaultHeaders = {
        credentials: 'include',
        mode: 'cors',
        'Content-Type': 'application/json'
    };
    const normalizedPath = `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const contextAsSearchParams = new URLSearchParams($b7ecb57dac2e1673$var$stringifyObjectValues(context)).toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$b7ecb57dac2e1673$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return fetcher.fetch(url, {
        ...requestOptions,
        headers: {
            ...defaultHeaders,
            ...requestOptions?.headers
        }
    });
};

});


parcelRegister("q92ci", function(module, exports) {

$parcel$export(module.exports, "usePlacementFetchingContext", () => $0644c2faf1e828b4$export$e1e2cdb0425a9fa8);

var $eUqFw = parcelRequire("eUqFw");
const $0644c2faf1e828b4$export$afec669dc416ee7e = /*#__PURE__*/ (0, $eUqFw.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $0644c2faf1e828b4$export$e1e2cdb0425a9fa8 = ()=>(0, $eUqFw.useContext)($0644c2faf1e828b4$export$afec669dc416ee7e);
const $0644c2faf1e828b4$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
    const value = (0, $eUqFw.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ React.createElement($0644c2faf1e828b4$export$afec669dc416ee7e.Provider, {
        value: value
    }, children);
};

});


parcelRegister("bNimx", function(module, exports) {

$parcel$export(module.exports, "scopes", () => $1c63553e6aa91c95$export$54a06e3f4a159ad8);
const $1c63553e6aa91c95$export$54a06e3f4a159ad8 = [
    {
        name: 'all',
        when: {
            route: {
                pathname: {
                    matches: '.*'
                }
            }
        }
    },
    {
        name: 'jira/all',
        when: {
            context: {
                product: 'jira'
            }
        }
    },
    {
        name: 'jira/kanban',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'boards'
                }
            }
        }
    },
    {
        name: 'confluence/all',
        when: {
            context: {
                product: 'confluence'
            }
        }
    },
    {
        name: 'pop3/all',
        when: {
            context: {
                product: 'pop3'
            }
        }
    },
    {
        name: 'admin/all',
        when: {
            context: {
                product: 'admin'
            }
        }
    },
    {
        name: 'pop3/send-it',
        when: {
            context: {
                product: 'pop3'
            },
            route: {
                pathname: {
                    matches: 'send-it'
                }
            }
        }
    },
    {
        name: 'admin/products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'products'
                }
            }
        }
    }
];

});

parcelRegister("6Yahf", function(module, exports) {

$parcel$export(module.exports, "MessageRenderer", () => $aadd9868a5ba6817$export$2df1250b8f917a59);
/* GeneratedContentHash: 3cb6cf61e4d1a4b8f604d8bf6e1ab4815270623ad61101f536107283c030de54 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $gmS37 = parcelRequire("gmS37");

var $doy25 = parcelRequire("doy25");

var $hMMOj = parcelRequire("hMMOj");

var $hpXmM = parcelRequire("hpXmM");
const $aadd9868a5ba6817$export$e30378e28ad3e6ab = {
    ...(0, $doy25.default),
    ...(0, $hMMOj.default),
    ...(0, $hpXmM.default)
};
const { initializeMessageRenderer: $aadd9868a5ba6817$export$bce4e5106d86e473, MessageRenderer: $aadd9868a5ba6817$export$2df1250b8f917a59 } = (0, $gmS37.asMessageRenderer)($aadd9868a5ba6817$export$e30378e28ad3e6ab);

});
parcelRegister("gmS37", function(module, exports) {

$parcel$export(module.exports, "asMessageRenderer", () => $9b87afb9f9d6e2a4$export$7b7e5a348ef9a7c1);
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $lHkHI = parcelRequire("lHkHI");

var $8tM2T = parcelRequire("8tM2T");

var $ky1EM = parcelRequire("ky1EM");
var $cmorc = parcelRequire("cmorc");

var $8VKHZ = parcelRequire("8VKHZ");

var $fl8dP = parcelRequire("fl8dP");

var $fU1M2 = parcelRequire("fU1M2");

var $ekGAF = parcelRequire("ekGAF");

var $eUqFw = parcelRequire("eUqFw");

var $c7ItS = parcelRequire("c7ItS");

var $899ny = parcelRequire("899ny");

var $ac5QK = parcelRequire("ac5QK");
const $9b87afb9f9d6e2a4$export$14fe1fc3395b6e3f = ({ children: children })=>{
    const { messageViewed: messageViewed } = (0, $fU1M2.useMessageEvent)();
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $eUqFw.useCallback)(()=>{
        messageViewed();
    }, [
        messageViewed
    ]);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $899ny.TrackMount), {
        onMount: messageViewedVoidFunction,
        children: children
    });
};
const $9b87afb9f9d6e2a4$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return ({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, ...data })=>{
            const isUFOEnabled = (0, $8tM2T.default).checkGate('enable_ufo_tracking_in_post_office');
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $eUqFw.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $ky1EM.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $899ny.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $eUqFw.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $8VKHZ.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $8VKHZ.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $eUqFw.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cmorc.UFOv2).UFOLoadHold, {
                        name: (0, $cmorc.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
                        children: loadingFallback ?? null
                    }), [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $c7ItS.ChoreographerWrapper), {
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)($9b87afb9f9d6e2a4$var$FeatureFlaggedUfoWrapper, {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fl8dP.MessageContextProvider), {
                            value: {
                                messageInstanceId: messageInstanceId,
                                messageTemplateId: messageTemplateId,
                                transactionAccountId: componentProps.transactionAccountId,
                                analyticsDetails: postOffice?.analyticsDetails
                            },
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ekGAF.RecommendationProvider), {
                                value: recommendationSession ?? {},
                                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eUqFw.Suspense), {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $lHkHI.jsxs)($9b87afb9f9d6e2a4$export$14fe1fc3395b6e3f, {
                                        children: [
                                            messageSuccessComponent,
                                            /*#__PURE__*/ (0, $lHkHI.jsx)(Component, {
                                                ...componentProps
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                });
            };
            return (0, $ac5QK.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        };
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};
const $9b87afb9f9d6e2a4$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cmorc.UFOv2).UFOSegment, {
        name: (0, $cmorc.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cmorc.UFOv2).UFOSegment, {
            name: `${(0, $cmorc.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: children
    });
};

});
parcelRegister("ky1EM", function(module, exports) {

$parcel$export(module.exports, "UFOv1", () => $87eef69bc1e808aa$export$96236906ebaa7f87);

var $l3JXg = parcelRequire("l3JXg");

var $a9k1C = parcelRequire("a9k1C");
const $87eef69bc1e808aa$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $l3JXg.MessagePerformanceTracker,
    PlacementPerformanceTracker: $a9k1C.PlacementPerformanceTracker
};

});
parcelRegister("l3JXg", function(module, exports) {

$parcel$export(module.exports, "MessagePerformanceTracker", () => $932209ff11810c7d$export$ae5c73c7c4f454e6);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");

var $6hgTV = parcelRequire("6hgTV");
class $932209ff11810c7d$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $kDfSL.UFOExperience)((0, $6hgTV.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $12kyE.ExperienceTypes).Load,
            platform: {
                component: (0, $6hgTV.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $kDfSL.UFOExperience)(`${(0, $6hgTV.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $12kyE.ExperienceTypes).Load,
            platform: {
                component: (0, $6hgTV.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}

});
parcelRegister("6hgTV", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceNames", () => $db1976d9918e4545$export$cc7ddf8ca628f6f1);
$parcel$export(module.exports, "POST_OFFICE_PLATFORM_NAME", () => $db1976d9918e4545$export$6d482cfa20c9d220);
const $db1976d9918e4545$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $db1976d9918e4545$export$6d482cfa20c9d220 = 'post-office';

});


parcelRegister("a9k1C", function(module, exports) {

$parcel$export(module.exports, "PlacementPerformanceTracker", () => $a3246cec455481b0$export$8b48c2105ba0b35a);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");

var $6hgTV = parcelRequire("6hgTV");
const $a3246cec455481b0$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $a3246cec455481b0$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $12kyE.ExperienceTypes).Load,
    platform: {
        component: (0, $6hgTV.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$a3246cec455481b0$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$a3246cec455481b0$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$a3246cec455481b0$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$a3246cec455481b0$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$a3246cec455481b0$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$a3246cec455481b0$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$a3246cec455481b0$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$a3246cec455481b0$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $a3246cec455481b0$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$a3246cec455481b0$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$a3246cec455481b0$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$a3246cec455481b0$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $a3246cec455481b0$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $a3246cec455481b0$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$a3246cec455481b0$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $a3246cec455481b0$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $kDfSL.UFOExperience)((0, $6hgTV.UFOExperienceNames).PLACEMENT, $a3246cec455481b0$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $kDfSL.UFOExperience)(`${(0, $6hgTV.UFOExperienceNames).PLACEMENT}.${placementId}`, $a3246cec455481b0$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}

});


parcelRegister("8VKHZ", function(module, exports) {

$parcel$export(module.exports, "InvalidMessageTemplateIdError", () => $26070b2b62af3716$export$19cb89dd679394cb);
$parcel$export(module.exports, "MessageRendererEmptyValidationResponseError", () => $26070b2b62af3716$export$3dfc27a8d3942f4d);
var $26070b2b62af3716$export$b9722560029694e7;
(function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["HandlerValidationError"] = "HandlerValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["UnsupportedEmailError"] = "UnsupportedEmailError";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
})($26070b2b62af3716$export$b9722560029694e7 || ($26070b2b62af3716$export$b9722560029694e7 = {}));
class $26070b2b62af3716$export$46f86d28cd0a5d38 extends Error {
}
class $26070b2b62af3716$export$627bc00a5ef5f6ae extends Error {
}
class $26070b2b62af3716$export$d145ea5319863172 extends Error {
    constructor(message, code){
        super(message);
        this.code = code;
    }
}
class $26070b2b62af3716$export$f649da38897d27f7 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError");
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$c2852c1c4d9aba3e extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError");
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$4b7b4e09547e4bb3 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError");
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$360a094a97597d87 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$4d068b43eb55165b extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError");
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$ac007ee150add337 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$b79ba63f8ae791e0 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message){
        super(message, "HandlerValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$19cb89dd679394cb extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$78651662ad470cc5 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(){
        super('Message Template not found', "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$913b8e68dc7ae8fe extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(){
        super('Placement not found', "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$3dfc27a8d3942f4d extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(){
        super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$e5ccdf8bbfead7a2 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$823733742d803ae6 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$a6f2aad8fa094b39 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(accountId){
        super('Unable to get user details for the given account ID', "UnableToGetUserDetailsError");
        this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$2f1e27130c2bf271 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError");
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$d0dc094613469f2b extends $26070b2b62af3716$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message);
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$5603eab37ce562f5 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(fileType){
        super('The attachment file is not supported', "UnsupportedAttachmentType");
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$b35ca1cf49054efc extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message, email){
        super(message, "UnsupportedEmailError");
        this.name = this.constructor.name;
        this.email = email;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$e0e9aa0e9c6b37ff extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader");
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$3ad818f64601e141 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$25470bb6cba4fba0 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$ce14d445679448b6 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(message, "HydrationFailureAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$8ab4fb362168b928 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(){
        super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$2afd69f57fe5285f extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(){
        super('Recipient expander not found for mapper', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$7635d2b1a281d626 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError");
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$9e1c6d00e675bc86 extends $26070b2b62af3716$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError");
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$90bef7fa95eca3fa extends Error {
    constructor(status){
        super('Posting Mobile Notifications message failed');
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$6d1a4929f6ff1a32 extends $26070b2b62af3716$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$89bf5f64fbf0698 extends $26070b2b62af3716$export$46f86d28cd0a5d38 {
    constructor(message, error){
        super(message, {
            ...error ? {
                cause: error
            } : {}
        });
        this.error = error;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$c19fc5e8aa4e064d extends Error {
    constructor(){
        super('Ingestion source is required when custom profile is specified');
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$2d3a68dab93b8cc4 extends Error {
    constructor(){
        super('A renderRedacted function is required when redactionLevel is set to a non-null value');
        this.name = this.constructor.name;
    }
}
class $26070b2b62af3716$export$175c1dbb0d7c238a extends Error {
    constructor(status){
        super('Enqueueing email failed');
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $26070b2b62af3716$export$23fab744b3076342 extends Error {
    constructor(message, status){
        super(message);
        this.message = message;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}

});

parcelRegister("fl8dP", function(module, exports) {

$parcel$export(module.exports, "MessageContextProvider", () => $26c4d459e74f1679$export$42de33f7652dc3de);
$parcel$export(module.exports, "useMessageContext", () => $26c4d459e74f1679$export$a5b6d14a2e25725a);

var $eUqFw = parcelRequire("eUqFw");
const $26c4d459e74f1679$var$initialValue = {};
const $26c4d459e74f1679$export$b060d577040138d8 = (0, $eUqFw.createContext)($26c4d459e74f1679$var$initialValue);
const $26c4d459e74f1679$export$42de33f7652dc3de = $26c4d459e74f1679$export$b060d577040138d8.Provider;
const $26c4d459e74f1679$export$a5b6d14a2e25725a = ()=>(0, $eUqFw.useContext)($26c4d459e74f1679$export$b060d577040138d8);

});

parcelRegister("fU1M2", function(module, exports) {

$parcel$export(module.exports, "useMessageEvent", () => $a51080358c8ec1af$export$3cbbf1e81e2ecb39);

var $6jATK = parcelRequire("6jATK");
var $cdoUV = parcelRequire("cdoUV");

var $fl8dP = parcelRequire("fl8dP");

var $7uOhm = parcelRequire("7uOhm");

var $ekGAF = parcelRequire("ekGAF");

var $JNGxD = parcelRequire("JNGxD");

var $5Po57 = parcelRequire("5Po57");

var $1Soyz = parcelRequire("1Soyz");
const $a51080358c8ec1af$export$3cbbf1e81e2ecb39 = ()=>{
    if (!window.postOfficeMessageEventClient) window.postOfficeMessageEventClient = new (0, $5Po57.MessageEventClient)();
    const client = window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement } = (0, $6jATK.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $fl8dP.useMessageContext)();
    const { placementId: placementId } = (0, $7uOhm.usePlacementContext)();
    const browserContext = (0, $cdoUV.usePostOfficeContext)();
    const recommendationContext = (0, $ekGAF.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    return {
        /**
		 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
		 */ markAllAsRead: async (messages)=>{
            const messagesEventPostPayload = messages.map((message)=>{
                const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $JNGxD.MessageLifecycleContextError)();
                return {
                    messageInstanceId: message['messageInstanceId'],
                    messageTemplateId: message['messageTemplateId'],
                    type: (0, $1Soyz.InAppMessageEventType).Read,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                };
            });
            try {
                await client.markAllAsReadEvent(messagesEventPostPayload);
            } catch (error) {
                throw new (0, $JNGxD.MessageLifecycleClientError)();
            }
        },
        /**
		 * Marks a message as read. Calls sendEvent() as the API call
		 * has to happen immediately.
		 */ messageRead: async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $JNGxD.MessageLifecycleContextError)();
            markReadFromPlacement({
                messageInstanceId: messageInstanceId
            });
            try {
                await client.sendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    type: (0, $1Soyz.InAppMessageEventType).Read,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            } catch (error) {
                throw new (0, $JNGxD.MessageLifecycleClientError)();
            }
        },
        /**
		 * Marks a message as unread. Calls sendEvent() as the API call
		 * has to happen immediately.
		 */ messageUnread: async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $JNGxD.MessageLifecycleContextError)();
            try {
                await client.sendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    type: (0, $1Soyz.InAppMessageEventType).Unread,
                    placement: placementId,
                    createdAt: Date.now(),
                    context: context,
                    analyticsDetails: analyticsDetails
                });
            } catch (error) {
                throw new (0, $JNGxD.MessageLifecycleClientError)();
            }
        },
        /**
		 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
		 */ messageViewed: async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $JNGxD.MessageLifecycleContextError)();
            markViewedFromPlacement({
                messageInstanceId: messageInstanceId
            });
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: (0, $1Soyz.InAppMessageEventType).Viewed,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        },
        /**
		 * Marks a message as clicked.
		 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
		 * Message Creators should use this event if you want to enable ML reranking for your placement.
		 */ messageClicked: async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $JNGxD.MessageLifecycleContextError)();
            markClickedFromPlacement({
                messageInstanceId: messageInstanceId
            });
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: (0, $1Soyz.InAppMessageEventType).Clicked,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        },
        /**
		 * Marks a message as clicked.
		 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
		 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
		 * Message Creators should use this event if you want to enable ML reranking for your placement.
		 */ messageClickedSecondary: async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $JNGxD.MessageLifecycleContextError)();
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: (0, $1Soyz.InAppMessageEventType).ClickedSecondary,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        },
        /**
		 * Marks a message as acknowledged
		 */ messageAcknowledged: async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $JNGxD.MessageLifecycleContextError)();
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: (0, $1Soyz.InAppMessageEventType).Acknowledged,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        },
        /**
		 * Marks a message as dismissed.
		 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
		 * Message Creators should use this event if you want to enable ML reranking for your placement.
		 */ messageDismissed: async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $JNGxD.MessageLifecycleContextError)();
            dismissMessageFromPlacement({
                messageInstanceId: messageInstanceId
            });
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: (0, $1Soyz.InAppMessageEventType).Dismissed,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        }
    };
};

});
parcelRegister("ekGAF", function(module, exports) {

$parcel$export(module.exports, "RecommendationProvider", () => $d24aabcab9a7186a$export$f60e87d7b5f59562);
$parcel$export(module.exports, "useRecommendationContext", () => $d24aabcab9a7186a$export$3321c0b02f750bcc);

var $lHkHI = parcelRequire("lHkHI");

var $aw5Sy = parcelRequire("aw5Sy");

var $eUqFw = parcelRequire("eUqFw");
const $d24aabcab9a7186a$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    sessionId: undefined,
    entityId: undefined
});
const $d24aabcab9a7186a$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)($d24aabcab9a7186a$export$ba2f44035effd9c1.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aw5Sy.default), {
            data: value,
            children: children
        })
    });
};
const $d24aabcab9a7186a$export$3321c0b02f750bcc = ()=>(0, $eUqFw.useContext)($d24aabcab9a7186a$export$ba2f44035effd9c1);

});

parcelRegister("JNGxD", function(module, exports) {

$parcel$export(module.exports, "MessageLifecycleContextError", () => $902630a5f40b9db4$export$12bb62b204112f55);
$parcel$export(module.exports, "MessageLifecycleClientError", () => $902630a5f40b9db4$export$44f397e2afeb89e0);
class $902630a5f40b9db4$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $902630a5f40b9db4$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}

});

parcelRegister("5Po57", function(module, exports) {

$parcel$export(module.exports, "MessageEventClient", () => $c0e04c4a48df6918$export$ae86a6dabe385178);
const $c0e04c4a48df6918$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
const $c0e04c4a48df6918$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $c0e04c4a48df6918$var$MESSAGE_EVENTS_BATCH_SIZE = 250;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("eGvYe"));
class $c0e04c4a48df6918$export$ae86a6dabe385178 {
    async sendEvent(event) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(event)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    batchSendEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.flushBatchEvents.bind(this), $c0e04c4a48df6918$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async markAllAsReadEvent(messages) {
        this.batchEvents.push(...messages);
        await this.flushBatchEvents();
    }
    async sendMessageEvents(events) {
        const url = `${this.endpointUrl}/bulk`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $c0e04c4a48df6918$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $c0e04c4a48df6918$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendMessageEvents(batch);
            if (this.scheduledTimeout !== null) window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($c0e04c4a48df6918$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = window.setTimeout(this.flushBatchEvents.bind(this), $c0e04c4a48df6918$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendMessageEvents(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $c0e04c4a48df6918$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});
parcelRegister("eGvYe", function(module, exports) {

$parcel$export(module.exports, "Headers", () => $ab0dc99bfac00606$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $ab0dc99bfac00606$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $ab0dc99bfac00606$export$9f633d56d7ec90d3);
$parcel$export(module.exports, "DOMException", () => $ab0dc99bfac00606$export$fe58bcf938607f6a);
$parcel$export(module.exports, "fetch", () => $ab0dc99bfac00606$export$e7aa7bc5c1b3cfb3);
/* eslint-disable no-prototype-builtins */ var $ab0dc99bfac00606$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $ab0dc99bfac00606$var$support = {
    searchParams: 'URLSearchParams' in $ab0dc99bfac00606$var$g,
    iterable: 'Symbol' in $ab0dc99bfac00606$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $ab0dc99bfac00606$var$g && 'Blob' in $ab0dc99bfac00606$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $ab0dc99bfac00606$var$g,
    arrayBuffer: 'ArrayBuffer' in $ab0dc99bfac00606$var$g
};
function $ab0dc99bfac00606$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($ab0dc99bfac00606$var$support.arrayBuffer) {
    var $ab0dc99bfac00606$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $ab0dc99bfac00606$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $ab0dc99bfac00606$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $ab0dc99bfac00606$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $ab0dc99bfac00606$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $ab0dc99bfac00606$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($ab0dc99bfac00606$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $ab0dc99bfac00606$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $ab0dc99bfac00606$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$ab0dc99bfac00606$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $ab0dc99bfac00606$var$normalizeName(name);
    value = $ab0dc99bfac00606$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$ab0dc99bfac00606$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$ab0dc99bfac00606$var$normalizeName(name)];
};
$ab0dc99bfac00606$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $ab0dc99bfac00606$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$ab0dc99bfac00606$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($ab0dc99bfac00606$var$normalizeName(name));
};
$ab0dc99bfac00606$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$ab0dc99bfac00606$var$normalizeName(name)] = $ab0dc99bfac00606$var$normalizeValue(value);
};
$ab0dc99bfac00606$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$ab0dc99bfac00606$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $ab0dc99bfac00606$var$iteratorFor(items);
};
$ab0dc99bfac00606$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $ab0dc99bfac00606$var$iteratorFor(items);
};
$ab0dc99bfac00606$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $ab0dc99bfac00606$var$iteratorFor(items);
};
if ($ab0dc99bfac00606$var$support.iterable) $ab0dc99bfac00606$export$79b704688b15c0f4.prototype[Symbol.iterator] = $ab0dc99bfac00606$export$79b704688b15c0f4.prototype.entries;
function $ab0dc99bfac00606$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $ab0dc99bfac00606$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $ab0dc99bfac00606$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $ab0dc99bfac00606$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $ab0dc99bfac00606$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $ab0dc99bfac00606$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $ab0dc99bfac00606$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $ab0dc99bfac00606$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $ab0dc99bfac00606$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($ab0dc99bfac00606$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($ab0dc99bfac00606$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($ab0dc99bfac00606$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($ab0dc99bfac00606$var$support.arrayBuffer && $ab0dc99bfac00606$var$support.blob && $ab0dc99bfac00606$var$isDataView(body)) {
            this._bodyArrayBuffer = $ab0dc99bfac00606$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($ab0dc99bfac00606$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $ab0dc99bfac00606$var$isArrayBufferView(body))) this._bodyArrayBuffer = $ab0dc99bfac00606$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($ab0dc99bfac00606$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($ab0dc99bfac00606$var$support.blob) this.blob = function() {
        var rejected = $ab0dc99bfac00606$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $ab0dc99bfac00606$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($ab0dc99bfac00606$var$support.blob) return this.blob().then($ab0dc99bfac00606$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $ab0dc99bfac00606$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $ab0dc99bfac00606$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($ab0dc99bfac00606$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($ab0dc99bfac00606$var$support.formData) this.formData = function() {
        return this.text().then($ab0dc99bfac00606$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $ab0dc99bfac00606$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $ab0dc99bfac00606$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $ab0dc99bfac00606$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $ab0dc99bfac00606$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $ab0dc99bfac00606$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $ab0dc99bfac00606$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $ab0dc99bfac00606$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $ab0dc99bfac00606$export$79b704688b15c0f4(options.headers);
    this.method = $ab0dc99bfac00606$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $ab0dc99bfac00606$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$ab0dc99bfac00606$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $ab0dc99bfac00606$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $ab0dc99bfac00606$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $ab0dc99bfac00606$var$parseHeaders(rawHeaders) {
    var headers = new $ab0dc99bfac00606$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$ab0dc99bfac00606$var$Body.call($ab0dc99bfac00606$export$7fa6c5b6f8193917.prototype);
function $ab0dc99bfac00606$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $ab0dc99bfac00606$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $ab0dc99bfac00606$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$ab0dc99bfac00606$var$Body.call($ab0dc99bfac00606$export$9f633d56d7ec90d3.prototype);
$ab0dc99bfac00606$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $ab0dc99bfac00606$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $ab0dc99bfac00606$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$ab0dc99bfac00606$export$9f633d56d7ec90d3.error = function() {
    var response = new $ab0dc99bfac00606$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $ab0dc99bfac00606$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$ab0dc99bfac00606$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($ab0dc99bfac00606$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $ab0dc99bfac00606$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $ab0dc99bfac00606$export$fe58bcf938607f6a = $ab0dc99bfac00606$var$g.DOMException;
try {
    new $ab0dc99bfac00606$export$fe58bcf938607f6a();
} catch (err) {
    $ab0dc99bfac00606$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $ab0dc99bfac00606$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $ab0dc99bfac00606$export$fe58bcf938607f6a.prototype.constructor = $ab0dc99bfac00606$export$fe58bcf938607f6a;
}
function $ab0dc99bfac00606$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $ab0dc99bfac00606$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $ab0dc99bfac00606$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $ab0dc99bfac00606$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $ab0dc99bfac00606$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $ab0dc99bfac00606$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $ab0dc99bfac00606$var$g.location.href ? $ab0dc99bfac00606$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($ab0dc99bfac00606$var$support.blob) xhr.responseType = 'blob';
            else if ($ab0dc99bfac00606$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $ab0dc99bfac00606$export$79b704688b15c0f4 || $ab0dc99bfac00606$var$g.Headers && init.headers instanceof $ab0dc99bfac00606$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($ab0dc99bfac00606$var$normalizeName(name));
                xhr.setRequestHeader(name, $ab0dc99bfac00606$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$ab0dc99bfac00606$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$ab0dc99bfac00606$var$g.fetch) {
    $ab0dc99bfac00606$var$g.fetch = $ab0dc99bfac00606$export$e7aa7bc5c1b3cfb3;
    $ab0dc99bfac00606$var$g.Headers = $ab0dc99bfac00606$export$79b704688b15c0f4;
    $ab0dc99bfac00606$var$g.Request = $ab0dc99bfac00606$export$7fa6c5b6f8193917;
    $ab0dc99bfac00606$var$g.Response = $ab0dc99bfac00606$export$9f633d56d7ec90d3;
}

});


parcelRegister("1Soyz", function(module, exports) {

$parcel$export(module.exports, "InAppMessageEventType", () => $b66ccae00de002b7$export$b31ffc6f7c85f1b);
var $b66ccae00de002b7$export$b31ffc6f7c85f1b;
(function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
})($b66ccae00de002b7$export$b31ffc6f7c85f1b || ($b66ccae00de002b7$export$b31ffc6f7c85f1b = {}));

});


parcelRegister("c7ItS", function(module, exports) {

$parcel$export(module.exports, "ChoreographerWrapper", () => $a8654238a8a03320$export$8db7ba034addcd65);

var $lHkHI = parcelRequire("lHkHI");

var $8tM2T = parcelRequire("8tM2T");

var $2Jz5c = parcelRequire("2Jz5c");

var $eUqFw = parcelRequire("eUqFw");

var $3Pu3Z = parcelRequire("3Pu3Z");
const $a8654238a8a03320$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: children
    });
    return null;
};
const $a8654238a8a03320$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $3Pu3Z.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $2Jz5c.useFirePostOfficeAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $8tM2T.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $8tM2T.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled && factory) {
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $lHkHI.jsx)($a8654238a8a03320$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: children
    });
};

});


parcelRegister("doy25", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0a1e7c80440e1a2$export$2e2bcd8739ae039);
/* GeneratedContentHash: 1c81eea795b65db22117af2640553e44a6199a829d731e2f582d4993abefb68b */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eUqFw = parcelRequire("eUqFw");

var $f0a1e7c80440e1a2$export$2e2bcd8739ae039 = {
    'marketing-screen-space-flag-contentful-usecase': /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("ePxah")))
};

});
parcelRegister("ePxah", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ektcT")
]).then(()=>parcelRequire('75DKt'));

});


parcelRegister("hMMOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $619410a61c79e72a$export$2e2bcd8739ae039);
/* GeneratedContentHash: 4d32a4689c92500edf1c336e733018ff47b68304e95803187f464b342d5f6598 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eUqFw = parcelRequire("eUqFw");

var $619410a61c79e72a$export$2e2bcd8739ae039 = {
    'message-template-template': /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("dfcTR")))
};

});
parcelRegister("dfcTR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("30iFV").then(()=>parcelRequire('baWhd'));

});


parcelRegister("hpXmM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c70a96f6eda9123a$export$2e2bcd8739ae039);
/* GeneratedContentHash: 1a5276e3605ad78395d281339cb88b6cdf499079e915b878d4e4f78de51617e9 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $eUqFw = parcelRequire("eUqFw");


var $c70a96f6eda9123a$export$2e2bcd8739ae039 = {
    'test-message-inapp': /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("bWKeo"))),
    'test-message-inapp-implicit-pendo': /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("CUddK")))
};

});
parcelRegister("bWKeo", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2zhh3").then(()=>parcelRequire('cNVuG'));

});

parcelRegister("CUddK", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("a3cIi").then(()=>parcelRequire('6slu7'));

});



/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $97e679571c55280b$export$a5cfae247d8360ef = 'screen-space-flags';

parcelRegister("95Lkj", function(module, exports) {

$parcel$export(module.exports, "withScreenSpaceFlagsIntlProvider", () => $25eb1b1be7178928$export$b0eee5de066b2bf5);
/* GeneratedContentHash: e3d04393a47322d23880e298768acb64afdfd94233a58eec204386851be825fc */ /**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 *
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $gVaWg = parcelRequire("gVaWg");

var $9f6iL = parcelRequire("9f6iL");

var $c9IK1 = parcelRequire("c9IK1");

var $2TBJJ = parcelRequire("2TBJJ");
const $25eb1b1be7178928$var$loadMessagesByTeam = async (locale)=>{
    return Promise.allSettled([
        (0, $9f6iL.messagesLoader)(locale),
        (0, $c9IK1.messagesLoader)(locale),
        (0, $2TBJJ.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $25eb1b1be7178928$export$b0eee5de066b2bf5 = (Component)=>{
    return (0, $gVaWg.withIntlProvider)({
        messagesLoader: $25eb1b1be7178928$var$loadMessagesByTeam
    }, Component);
};

});
parcelRegister("gVaWg", function(module, exports) {

$parcel$export(module.exports, "withIntlProvider", () => $892a25180531af81$export$a5d940130f33be3f);

var $lHkHI = parcelRequire("lHkHI");

var $dBkw4 = parcelRequire("dBkw4");
const $892a25180531af81$export$a5d940130f33be3f = (intlProviderProps, Component)=>(props)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $dBkw4.default), {
            ...intlProviderProps,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)(Component, {
                ...props
            })
        });

});
parcelRegister("dBkw4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8ed4354d2b53cc8$export$2e2bcd8739ae039);

var $lHkHI = parcelRequire("lHkHI");

var $2Jz5c = parcelRequire("2Jz5c");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8q7ew = parcelRequire("8q7ew");
function $f8ed4354d2b53cc8$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $2Jz5c.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $5JgJ2.default)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $f8ed4354d2b53cc8$export$2e2bcd8739ae039(props) {
    const { locale: locale } = $f8ed4354d2b53cc8$var$useFetchLocale();
    const messages = (0, $8q7ew.useIntlMessages)(locale, props.messagesLoader);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3dpxL.default), {
        locale: locale,
        messages: messages,
        children: props.children
    });
}

});
parcelRegister("8q7ew", function(module, exports) {

$parcel$export(module.exports, "useIntlMessages", () => $da661c9f86c23971$export$2641ec9a2025a81f);

var $2Jz5c = parcelRequire("2Jz5c");

var $eUqFw = parcelRequire("eUqFw");
const $da661c9f86c23971$export$2641ec9a2025a81f = (locale, messageLoader)=>{
    const [messages, setMessages] = (0, $eUqFw.useState)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $2Jz5c.useFirePostOfficeAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale
    ]);
    return messages;
};

});



parcelRegister("9f6iL", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $295d1d085f77cf97$export$720676d8cac8fbb);
/* GeneratedContentHash: 20c1ed5c6fa3c6db8a451c1ebcc4d7bd8be732220a63e32a947d22655aebf9d8 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# 
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $ejihK = parcelRequire("ejihK");

var $ao10V = parcelRequire("ao10V");






























const $295d1d085f77cf97$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $ao10V.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return (await (parcelRequire("bVfrz"))).default;
        case 'da':
            return (await (parcelRequire("7YIJh"))).default;
        case 'de':
            return (await (parcelRequire("knerC"))).default;
        case 'en-GB':
            return (await (parcelRequire("5lIB2"))).default;
        case 'en-US':
            return (await (parcelRequire("jcMra"))).default;
        case 'en-XA':
            return (await (parcelRequire("g4rAO"))).default;
        case 'en-XB':
            return (await (parcelRequire("9rGp9"))).default;
        case 'en-ZZ':
            return (await (parcelRequire("brAiM"))).default;
        case 'en':
            return (await Promise.resolve((parcelRequire("ejihK")))).default;
        case 'es':
            return (await (parcelRequire("j99lf"))).default;
        case 'et':
            return (await (parcelRequire("6q0LZ"))).default;
        case 'fi':
            return (await (parcelRequire("d3eZZ"))).default;
        case 'fr':
            return (await (parcelRequire("czwEh"))).default;
        case 'hu':
            return (await (parcelRequire("jwByf"))).default;
        case 'it':
            return (await (parcelRequire("izA9p"))).default;
        case 'ja':
            return (await (parcelRequire("d0XRN"))).default;
        case 'ko':
            return (await (parcelRequire("jnUzf"))).default;
        case 'nb':
            return (await (parcelRequire("kKEPp"))).default;
        case 'nl':
            return (await (parcelRequire("bt9lm"))).default;
        case 'pl':
            return (await (parcelRequire("sVufk"))).default;
        case 'pt-BR':
            return (await (parcelRequire("cli7A"))).default;
        case 'ro':
            return (await (parcelRequire("10xP8"))).default;
        case 'ru':
            return (await (parcelRequire("hq7Pi"))).default;
        case 'sv':
            return (await (parcelRequire("gTfNN"))).default;
        case 'th':
            return (await (parcelRequire("Xp976"))).default;
        case 'tr':
            return (await (parcelRequire("8oCUd"))).default;
        case 'uk':
            return (await (parcelRequire("er30S"))).default;
        case 'vi':
            return (await (parcelRequire("klrzL"))).default;
        case 'zh-CN':
            return (await (parcelRequire("536Ou"))).default;
        case 'zh-TW':
            return (await (parcelRequire("cena5"))).default;
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($ejihK));
    }
};

});
parcelRegister("ejihK", function(module, exports) {
module.exports = JSON.parse("{\"post-office.components.in-app.step-context.default-next-button.main\":[{\"type\":0,\"value\":\"Next\"}],\"post-office.components.in-app.step-context.default-previous-button.main\":[{\"type\":0,\"value\":\"Back\"}],\"post-office.components.in-app.step-context.next-button.step-state\":[{\"type\":1,\"value\":\"currentStep\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}]}");

});

parcelRegister("bVfrz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9xVbn").then(()=>parcelRequire('56VfM'));

});

parcelRegister("7YIJh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1F7c9").then(()=>parcelRequire('eAz22'));

});

parcelRegister("knerC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2Zr4B").then(()=>parcelRequire('lOyV7'));

});

parcelRegister("5lIB2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("i135o").then(()=>parcelRequire('2CCDi'));

});

parcelRegister("jcMra", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2KJRF").then(()=>parcelRequire('1S4ZZ'));

});

parcelRegister("g4rAO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jdbma").then(()=>parcelRequire('bJYA5'));

});

parcelRegister("9rGp9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bBqfq").then(()=>parcelRequire('5q494'));

});

parcelRegister("brAiM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1mcNS").then(()=>parcelRequire('cCQMM'));

});

parcelRegister("j99lf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lokiH").then(()=>parcelRequire('dsZEf'));

});

parcelRegister("6q0LZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ptUjv").then(()=>parcelRequire('2m7q9'));

});

parcelRegister("d3eZZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jXPQC").then(()=>parcelRequire('eUBHy'));

});

parcelRegister("czwEh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("l9xUF").then(()=>parcelRequire('lzaPQ'));

});

parcelRegister("jwByf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("38WYW").then(()=>parcelRequire('cfrEA'));

});

parcelRegister("izA9p", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9DLTx").then(()=>parcelRequire('70rQw'));

});

parcelRegister("d0XRN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8EGS4").then(()=>parcelRequire('2IYXQ'));

});

parcelRegister("jnUzf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("65DdM").then(()=>parcelRequire('kMZFh'));

});

parcelRegister("kKEPp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fxm31").then(()=>parcelRequire('ceqkb'));

});

parcelRegister("bt9lm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gsGJs").then(()=>parcelRequire('dqIBi'));

});

parcelRegister("sVufk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jcxJO").then(()=>parcelRequire('9ObLB'));

});

parcelRegister("cli7A", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cRfLo").then(()=>parcelRequire('1mGiU'));

});

parcelRegister("10xP8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6d3ti").then(()=>parcelRequire('4vS58'));

});

parcelRegister("hq7Pi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8dUUG").then(()=>parcelRequire('3ZZwN'));

});

parcelRegister("gTfNN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7oXS6").then(()=>parcelRequire('joqFu'));

});

parcelRegister("Xp976", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hqEuq").then(()=>parcelRequire('hGfSV'));

});

parcelRegister("8oCUd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aVi3V").then(()=>parcelRequire('3DId8'));

});

parcelRegister("er30S", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3tiUs").then(()=>parcelRequire('2mLLr'));

});

parcelRegister("klrzL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fRG5c").then(()=>parcelRequire('garst'));

});

parcelRegister("536Ou", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jZGSE").then(()=>parcelRequire('5qgOV'));

});

parcelRegister("cena5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bmE7m").then(()=>parcelRequire('8BavD'));

});


parcelRegister("c9IK1", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $926246429e947c28$export$720676d8cac8fbb);
/* GeneratedContentHash: 20c1ed5c6fa3c6db8a451c1ebcc4d7bd8be732220a63e32a947d22655aebf9d8 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# 
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $585bi = parcelRequire("585bi");

var $ao10V = parcelRequire("ao10V");






























const $926246429e947c28$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $ao10V.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return (await (parcelRequire("de4MY"))).default;
        case 'da':
            return (await (parcelRequire("cLzFl"))).default;
        case 'de':
            return (await (parcelRequire("8WbSt"))).default;
        case 'en-GB':
            return (await (parcelRequire("44bLl"))).default;
        case 'en-US':
            return (await (parcelRequire("7yL7Y"))).default;
        case 'en-XA':
            return (await (parcelRequire("klv5b"))).default;
        case 'en-XB':
            return (await (parcelRequire("9YnhH"))).default;
        case 'en-ZZ':
            return (await (parcelRequire("abmeZ"))).default;
        case 'en':
            return (await Promise.resolve((parcelRequire("585bi")))).default;
        case 'es':
            return (await (parcelRequire("gW6iE"))).default;
        case 'et':
            return (await (parcelRequire("e0hck"))).default;
        case 'fi':
            return (await (parcelRequire("fJcch"))).default;
        case 'fr':
            return (await (parcelRequire("44OEx"))).default;
        case 'hu':
            return (await (parcelRequire("lWFED"))).default;
        case 'it':
            return (await (parcelRequire("1GAvp"))).default;
        case 'ja':
            return (await (parcelRequire("dWocn"))).default;
        case 'ko':
            return (await (parcelRequire("4xEmo"))).default;
        case 'nb':
            return (await (parcelRequire("azBPH"))).default;
        case 'nl':
            return (await (parcelRequire("7ioQB"))).default;
        case 'pl':
            return (await (parcelRequire("cIe6t"))).default;
        case 'pt-BR':
            return (await (parcelRequire("dae7Y"))).default;
        case 'ro':
            return (await (parcelRequire("cBA1e"))).default;
        case 'ru':
            return (await (parcelRequire("92wnG"))).default;
        case 'sv':
            return (await (parcelRequire("3kyLY"))).default;
        case 'th':
            return (await (parcelRequire("efvue"))).default;
        case 'tr':
            return (await (parcelRequire("8CMbg"))).default;
        case 'uk':
            return (await (parcelRequire("7hRlC"))).default;
        case 'vi':
            return (await (parcelRequire("3YcPf"))).default;
        case 'zh-CN':
            return (await (parcelRequire("a11UJ"))).default;
        case 'zh-TW':
            return (await (parcelRequire("8LBFx"))).default;
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($585bi));
    }
};

});
parcelRegister("585bi", function(module, exports) {
module.exports = JSON.parse("{\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");

});

parcelRegister("de4MY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1i1yq").then(()=>parcelRequire('7MyNE'));

});

parcelRegister("cLzFl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iztp5").then(()=>parcelRequire('cea9l'));

});

parcelRegister("8WbSt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("VTxZY").then(()=>parcelRequire('lUkFV'));

});

parcelRegister("44bLl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7H6AV").then(()=>parcelRequire('3hS5F'));

});

parcelRegister("7yL7Y", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ebMui").then(()=>parcelRequire('aF370'));

});

parcelRegister("klv5b", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("93ewd").then(()=>parcelRequire('dBuLH'));

});

parcelRegister("9YnhH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("69XoQ").then(()=>parcelRequire('lyydW'));

});

parcelRegister("abmeZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("k1b8R").then(()=>parcelRequire('71kUH'));

});

parcelRegister("gW6iE", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ZDHi0").then(()=>parcelRequire('g6eoH'));

});

parcelRegister("e0hck", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("eSgS5").then(()=>parcelRequire('aC4h9'));

});

parcelRegister("fJcch", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("b5uWs").then(()=>parcelRequire('jbRDj'));

});

parcelRegister("44OEx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("D7KXV").then(()=>parcelRequire('4jqRq'));

});

parcelRegister("lWFED", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4Tnjo").then(()=>parcelRequire('hR3oX'));

});

parcelRegister("1GAvp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9Wwu2").then(()=>parcelRequire('jDbdh'));

});

parcelRegister("dWocn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fpm0q").then(()=>parcelRequire('5MpHB'));

});

parcelRegister("4xEmo", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9otls").then(()=>parcelRequire('cNE6a'));

});

parcelRegister("azBPH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dTi4k").then(()=>parcelRequire('a8HKU'));

});

parcelRegister("7ioQB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lOZWl").then(()=>parcelRequire('972ID'));

});

parcelRegister("cIe6t", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ehhk6").then(()=>parcelRequire('k05ky'));

});

parcelRegister("dae7Y", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iR8f0").then(()=>parcelRequire('eaSzu'));

});

parcelRegister("cBA1e", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("l9Xqf").then(()=>parcelRequire('7hUyB'));

});

parcelRegister("92wnG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("f1SLD").then(()=>parcelRequire('iGfuQ'));

});

parcelRegister("3kyLY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("eIpL6").then(()=>parcelRequire('aEwo4'));

});

parcelRegister("efvue", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ljSyr").then(()=>parcelRequire('k5P18'));

});

parcelRegister("8CMbg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8rmUF").then(()=>parcelRequire('6lhum'));

});

parcelRegister("7hRlC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1puSs").then(()=>parcelRequire('aAnnJ'));

});

parcelRegister("3YcPf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("e0tlS").then(()=>parcelRequire('9424n'));

});

parcelRegister("a11UJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dDkNi").then(()=>parcelRequire('aUzWx'));

});

parcelRegister("8LBFx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("830oZ").then(()=>parcelRequire('1g22h'));

});


parcelRegister("2TBJJ", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $36cc2b943fdcaadc$export$720676d8cac8fbb);
/* GeneratedContentHash: 20c1ed5c6fa3c6db8a451c1ebcc4d7bd8be732220a63e32a947d22655aebf9d8 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8e8pE = parcelRequire("8e8pE");

var $ao10V = parcelRequire("ao10V");






























const $36cc2b943fdcaadc$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $ao10V.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return (await (parcelRequire("6U6cj"))).default;
        case 'da':
            return (await (parcelRequire("cQDK5"))).default;
        case 'de':
            return (await (parcelRequire("3mON2"))).default;
        case 'en-GB':
            return (await (parcelRequire("diMsy"))).default;
        case 'en-US':
            return (await (parcelRequire("hHM9t"))).default;
        case 'en-XA':
            return (await (parcelRequire("f2ZYn"))).default;
        case 'en-XB':
            return (await (parcelRequire("5XzvR"))).default;
        case 'en-ZZ':
            return (await (parcelRequire("isLOd"))).default;
        case 'en':
            return (await Promise.resolve((parcelRequire("8e8pE")))).default;
        case 'es':
            return (await (parcelRequire("bSVDp"))).default;
        case 'et':
            return (await (parcelRequire("jHEJp"))).default;
        case 'fi':
            return (await (parcelRequire("4beAY"))).default;
        case 'fr':
            return (await (parcelRequire("lvrjm"))).default;
        case 'hu':
            return (await (parcelRequire("90j8E"))).default;
        case 'it':
            return (await (parcelRequire("hQhCB"))).default;
        case 'ja':
            return (await (parcelRequire("brpx3"))).default;
        case 'ko':
            return (await (parcelRequire("3qzoP"))).default;
        case 'nb':
            return (await (parcelRequire("2nX6x"))).default;
        case 'nl':
            return (await (parcelRequire("i4xfq"))).default;
        case 'pl':
            return (await (parcelRequire("kQLCA"))).default;
        case 'pt-BR':
            return (await (parcelRequire("kiZcm"))).default;
        case 'ro':
            return (await (parcelRequire("40MA8"))).default;
        case 'ru':
            return (await (parcelRequire("eMLNf"))).default;
        case 'sv':
            return (await (parcelRequire("3m49a"))).default;
        case 'th':
            return (await (parcelRequire("lKcBr"))).default;
        case 'tr':
            return (await (parcelRequire("1MAO0"))).default;
        case 'uk':
            return (await (parcelRequire("dgyC6"))).default;
        case 'vi':
            return (await (parcelRequire("1UUcP"))).default;
        case 'zh-CN':
            return (await (parcelRequire("byxle"))).default;
        case 'zh-TW':
            return (await (parcelRequire("fJZy6"))).default;
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8e8pE));
    }
};

});
parcelRegister("8e8pE", function(module, exports) {
module.exports = JSON.parse("{\"admin-hub.ci-test.message-template-template-hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"ci-generation.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"ci-generation.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"ci-generation.email.body.img.alt\":[{\"type\":0,\"value\":\"This is the alt text for the image\"}],\"ci-generation.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"ci-generation.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"ci-generation.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"ci-generation.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.test-message.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\".\"}],\"post-office.test-messages.test-message-mobile-push.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-slack-notification.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"product-store-personal-use-case.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}],\"test-messages.app-switcher-discovery-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-discovery-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.in-app-example.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.jira-navigation-topbar-edition-awareness.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.redacted-email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-cdn.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-cdn.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-cdn.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-cdn.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-grouped-recipients.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hello\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-marketing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-marketing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-marketing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-marketing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-persona-email.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-persona-email.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-persona-email.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-persona-email.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-persona-email.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-persona-email.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.app.img.alt.large\":[{\"type\":0,\"value\":\"test image 2\"}],\"test-messages.test-message.app.img.alt.plant\":[{\"type\":0,\"value\":\"test image 1\"}],\"test-messages.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.redacted-email.body\":[{\"type\":0,\"value\":\"This is the redacted version of the test email message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.redacted-email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.redacted-email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.redacted-email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.redacted-email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"wac-global-nav-product-recommendation.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}]}");

});

parcelRegister("6U6cj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jtlX7").then(()=>parcelRequire('guW2U'));

});

parcelRegister("cQDK5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gqWis").then(()=>parcelRequire('1SF9f'));

});

parcelRegister("3mON2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9lEG7").then(()=>parcelRequire('gGy7y'));

});

parcelRegister("diMsy", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2CVSl").then(()=>parcelRequire('gUiWJ'));

});

parcelRegister("hHM9t", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bhCMR").then(()=>parcelRequire('4TC4P'));

});

parcelRegister("f2ZYn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4F9Ne").then(()=>parcelRequire('gf7mz'));

});

parcelRegister("5XzvR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2VZ4v").then(()=>parcelRequire('cGFxe'));

});

parcelRegister("isLOd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1AzSw").then(()=>parcelRequire('2pnPO'));

});

parcelRegister("bSVDp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("k0gXA").then(()=>parcelRequire('eyA58'));

});

parcelRegister("jHEJp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6FVxR").then(()=>parcelRequire('klf9W'));

});

parcelRegister("4beAY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dx9re").then(()=>parcelRequire('ksVPq'));

});

parcelRegister("lvrjm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bmlhu").then(()=>parcelRequire('2778C'));

});

parcelRegister("90j8E", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iTCxC").then(()=>parcelRequire('l72gi'));

});

parcelRegister("hQhCB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("f6Hc3").then(()=>parcelRequire('8CrHO'));

});

parcelRegister("brpx3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iMfy5").then(()=>parcelRequire('Lxj7d'));

});

parcelRegister("3qzoP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4ugjq").then(()=>parcelRequire('lxUDE'));

});

parcelRegister("2nX6x", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("nugEA").then(()=>parcelRequire('gakIO'));

});

parcelRegister("i4xfq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("54JtB").then(()=>parcelRequire('be5Ru'));

});

parcelRegister("kQLCA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6odJL").then(()=>parcelRequire('cjVFj'));

});

parcelRegister("kiZcm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9i0Rq").then(()=>parcelRequire('iP7Cf'));

});

parcelRegister("40MA8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7kRd2").then(()=>parcelRequire('d6EIe'));

});

parcelRegister("eMLNf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lLSPl").then(()=>parcelRequire('gMPUT'));

});

parcelRegister("3m49a", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6c7iY").then(()=>parcelRequire('lUFaI'));

});

parcelRegister("lKcBr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5ZjHE").then(()=>parcelRequire('loQxl'));

});

parcelRegister("1MAO0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("222qn").then(()=>parcelRequire('2Uwlk'));

});

parcelRegister("dgyC6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fCEZj").then(()=>parcelRequire('cxw9M'));

});

parcelRegister("1UUcP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hfweM").then(()=>parcelRequire('j4jGj'));

});

parcelRegister("byxle", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aYh2w").then(()=>parcelRequire('10pI5'));

});

parcelRegister("fJZy6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5Ofo4").then(()=>parcelRequire('eoGie'));

});




parcelRegister("hFteq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf46d07267e5e706$export$2e2bcd8739ae039);

var $lHkHI = parcelRequire("lHkHI");

var $ima73 = parcelRequire("ima73");

var $jbdGM = parcelRequire("jbdGM");

var $1U7NE = parcelRequire("1U7NE");

var $eUqFw = parcelRequire("eUqFw");

var $kKzj6 = parcelRequire("kKzj6");

const $bf46d07267e5e706$var$STABLE_OBJECT = {};
const $bf46d07267e5e706$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, Fallback: Fallback = null, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $eUqFw.useMemo)(()=>(0, $1U7NE.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $ima73.useStableObject)(placementProps ?? $bf46d07267e5e706$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jbdGM.default), {
        placementId: placementId,
        consumptionType: "local",
        onEvent: onEvent,
        disableInitialData: disableInitialData,
        children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $kKzj6.default), {
                analyticsChannel: (0, $66a0cb42624ca97a$export$85183a312807388d),
                placementId: placementId,
                onError: sharedOnEvent,
                fallback: ErrorFallback,
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eUqFw.Suspense), {
                    fallback: Fallback,
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
            })
    });
};
var $bf46d07267e5e706$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($bf46d07267e5e706$var$Placement);

});
parcelRegister("jbdGM", function(module, exports) {

$parcel$export(module.exports, "default", () => $980686dfaa44c708$export$2e2bcd8739ae039);

var $lHkHI = parcelRequire("lHkHI");

var $dcbVh = parcelRequire("dcbVh");

var $8tM2T = parcelRequire("8tM2T");

var $cdoUV = parcelRequire("cdoUV");
var $hotL5 = parcelRequire("hotL5");
var $ima73 = parcelRequire("ima73");

var $ky1EM = parcelRequire("ky1EM");
var $cmorc = parcelRequire("cmorc");

var $eUqFw = parcelRequire("eUqFw");


var $e2sJX = parcelRequire("e2sJX");

var $3fIUu = parcelRequire("3fIUu");

var $jj8Uw = parcelRequire("jj8Uw");
const $980686dfaa44c708$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
    return (0, $eUqFw.useMemo)(()=>disableInitialData ? undefined : (0, $e2sJX.requestInitialData)(placementId, context, $parcel$global.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context
    ]);
};
const $980686dfaa44c708$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = (0, $8tM2T.default).checkGate('enable_ufo_tracking_in_post_office');
    const postOfficeRoute = (0, $hotL5.usePostOfficeRoute)();
    const context = (0, $cdoUV.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $3fIUu.useBuildBasePath)();
    const stableContextWithRoute = (0, $ima73.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $eUqFw.useMemo)(()=>isUFOEnabled ? new (0, $ky1EM.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    // Callback function to listen to the different stages of the remote component and track its performance
    const remoteComponentOnEvent = (0, $eUqFw.useCallback)(({ type: type, error: error })=>{
        placementOnEvent?.({
            type: type,
            error: error
        });
        switch(type){
            case 'fetch-complete':
                ufoV1PlacementTracker?.markFetchComplete();
                break;
            case 'fetch-error':
                ufoV1PlacementTracker?.markFetchFailure(error);
                break;
            case 'render-complete':
                ufoV1PlacementTracker?.markRenderComplete();
                break;
            case 'render-error':
                ufoV1PlacementTracker?.markRenderFailure(error);
                break;
            case 'initial-data-complete':
                ufoV1PlacementTracker?.markInitialDataComplete();
                break;
            case 'initial-data-error':
                ufoV1PlacementTracker?.markInitialDataFailure(error);
                break;
            case 'component-error':
                ufoV1PlacementTracker?.markComponentFailure(error);
                break;
            case 'component-ready':
                ufoV1PlacementTracker?.markComponentReady();
                break;
            case 'unmount':
                ufoV1PlacementTracker?.markComponentAborted();
                break;
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker
    ]);
    const initialData = $980686dfaa44c708$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $eUqFw.useMemo)(()=>({
            source: (0, $2b8f21ceae0d3c5f$export$f7109619a5e9e0d6),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app',
                postOfficeFrontendVersion: $jj8Uw.version
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, $lHkHI.jsx)($980686dfaa44c708$var$FeatureFlaggedUfoWrapper, {
        placementId: placementId,
        isEnabled: isUFOEnabled,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dcbVh.PostOfficeAnalyticsContext), {
            data: placementAnalyticsContext,
            children: children({
                initialData: initialData,
                context: stableContextWithRoute,
                onEvent: remoteComponentOnEvent
            })
        })
    });
};
var $980686dfaa44c708$export$2e2bcd8739ae039 = $980686dfaa44c708$var$Placement;
const $980686dfaa44c708$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, placementId: placementId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cmorc.UFOv2).UFOSegment, {
        name: (0, $cmorc.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cmorc.UFOv2).UFOSegment, {
            name: `${(0, $cmorc.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: children
    });
};

});
const $2b8f21ceae0d3c5f$export$85183a312807388d = 'postOffice';
const $2b8f21ceae0d3c5f$export$f7109619a5e9e0d6 = 'post-office-frontend';

parcelRegister("e2sJX", function(module, exports) {

$parcel$export(module.exports, "requestInitialData", () => $122a4a26b4185ccb$export$c4c39037cc4b06ab);
const $122a4a26b4185ccb$var$defaultFetcher = (url)=>fetch(url, {
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json'
        }
    });
const $122a4a26b4185ccb$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $122a4a26b4185ccb$var$defaultFetcher, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context)).toString();
    const url = encodeURI(`${requestUrl}${placementId}?${contextAsSearchParams}`);
    // Response will be handled inside the component
    return fetcher(url);
};

});

parcelRegister("3fIUu", function(module, exports) {

$parcel$export(module.exports, "useBuildBasePath", () => $b9ba4e9aa67a7f0b$export$83d6c58b7ab7ae67);

var $7RbmX = parcelRequire("7RbmX");
var $3AUkT = parcelRequire("3AUkT");

var $eUqFw = parcelRequire("eUqFw");
const $b9ba4e9aa67a7f0b$export$83d6c58b7ab7ae67 = ()=>{
    const { currentEnv: currentEnv, envConfigs: envConfigs } = (0, $3AUkT.usePostOfficeEnvironment)();
    return (0, $eUqFw.useMemo)(()=>{
        const baseUrl = envConfigs[currentEnv].api.origin;
        // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
        const path = envConfigs[currentEnv].api.pathname ?? (0, $7RbmX.API_PATHNAME_STG_PROD);
        return {
            baseUrl: baseUrl,
            path: path
        };
    }, [
        currentEnv,
        envConfigs
    ]);
};

});
parcelRegister("7RbmX", function(module, exports) {

$parcel$export(module.exports, "API_PATHNAME_STG_PROD", () => $0acf83409a4f3740$export$d4fe3482c88e73a8);


var $cdoUV = parcelRequire("cdoUV");

var $3AUkT = parcelRequire("3AUkT");

var $ima73 = parcelRequire("ima73");

var $cNc3D = parcelRequire("cNc3D");

var $6jATK = parcelRequire("6jATK");

var $2j1pH = parcelRequire("2j1pH");

var $fH5K1 = parcelRequire("fH5K1");

var $hotL5 = parcelRequire("hotL5");

var $aUdcY = parcelRequire("aUdcY");
const { REMOTE_MODULE_URI_LOCAL: $0acf83409a4f3740$export$67be2569ef5d7666, REMOTE_MODULE_URI_PROD: $0acf83409a4f3740$export$bbd96cd490b0df63, REMOTE_MODULE_URI_STG: $0acf83409a4f3740$export$b49738b89db261cd, API_ORIGIN_LOCAL: $0acf83409a4f3740$export$1e9fed4c0197724c, API_PATHNAME_LOCAL: $0acf83409a4f3740$export$919a9569bce66f17, API_PATHNAME_STG_PROD: $0acf83409a4f3740$export$d4fe3482c88e73a8 } = $57efc0e6796efd88$exports;

});


parcelRegister("jj8Uw", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@atlassian/post-office-placement-shared\",\"version\":\"0.3.0\",\"packageManager\":\"yarn@4.2.2\",\"sideEffects\":false,\"source\":\"./src/index.ts\",\"main\":\"./dist/cjs/index.js\",\"module\":\"./dist/esm/index.js\",\"types\":\"./dist/types/index.d.ts\",\"exports\":{\".\":\"./src/index.ts\"},\"publishConfig\":{\"exports\":{\"import\":\"./dist/esm/index.js\",\"require\":\"./dist/cjs/index.js\",\"types\":\"./dist/types/index.d.ts\"}},\"repository\":{\"type\":\"git\",\"url\":\"git+https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/post-office.git\",\"directory\":\"packages/post-office-clients/post-office-placement-shared\"},\"files\":[\"README.md\",\"dist\"],\"scripts\":{\"prepack\":\"atlas packages permission grant && yarn exec parcel build\",\"publish:patch\":\"yarn version patch && yarn npm publish\",\"publish:minor\":\"yarn version minor && yarn npm publish\"},\"peerDependencies\":{\"react\":\"^16.8.0 || ^17.0.0 || ^18.2.0\",\"react-dom\":\"^16.8.0 || ^17.0.0 || ^18.2.0\"},\"dependencies\":{\"@atlaskit/analytics-namespaced-context\":\"workspace:^\",\"@atlaskit/feature-gate-js-client\":\"workspace:^\",\"@atlassian/post-office-context\":\"workspace:^\",\"@atlassian/post-office-frontend-performance-tracking\":\"workspace:^\",\"@compiled/react\":\"^0.17.3\"},\"devDependencies\":{\"@testing-library/jest-dom\":\"^6.4.2\",\"@testing-library/react\":\"14.2.1\",\"@testing-library/react-hooks\":\"^8.0.1\",\"@types/node\":\"^20.11.27\",\"@types/react\":\"^18.2.33\",\"@types/react-dom\":\"^18.2.14\",\"eslint\":\"^8.57.0\",\"jest\":\"^29.7.0\",\"jest-environment-jsdom\":\"^29.7.0\",\"npm-run-all2\":\"^5.0.0\",\"parcel\":\"^2.6.0\",\"react\":\"^18.2.0\",\"typescript\":\"~5.4.2\"},\"targets\":{\"main\":{\"optimize\":true},\"module\":{\"optimize\":true}}}");

});


parcelRegister("kKzj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d968c11dfa0f910$export$2e2bcd8739ae039);

var $lHkHI = parcelRequire("lHkHI");

var $2jDha = parcelRequire("2jDha");

var $eUqFw = parcelRequire("eUqFw");
class $6d968c11dfa0f910$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
}
var $6d968c11dfa0f910$export$2e2bcd8739ae039 = (0, $2jDha.default)()($6d968c11dfa0f910$var$ErrorBoundary);

});

const $66a0cb42624ca97a$export$85183a312807388d = 'postOffice';


const $bfe8fff5e78bf213$export$37d4bb5bc0e315db = 'killswitch_post_office_in_jira';


parcelRegister("hzkQm", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $ab1cafd93f3f60c8$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $5GxEP = parcelRequire("5GxEP");
const $ab1cafd93f3f60c8$export$e926676385687eaf = ({ children: children, id: id, withExperienceTracker: withExperienceTracker })=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: id
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        packageName: "jiraEntry",
        fallback: "page",
        withExperienceTracker: withExperienceTracker
    }, children);
};

});

parcelRegister("emTse", function(module, exports) {

$parcel$export(module.exports, "IntlProviders", () => $16e82b5829d91fbb$export$c9d8cd4516cc55a8);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $7LFzI = parcelRequire("7LFzI");
const $16e82b5829d91fbb$export$c9d8cd4516cc55a8 = ({ children: children, locale: locale, messages: messages })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7LFzI.IntlProvider), {
        messages: messages,
        locale: (0, $ao0hp.standardizeLocale)(locale)
    }, children);

});
parcelRegister("7LFzI", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", () => $deabbabd1db0af3b$export$480518999dfc4151);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
const $deabbabd1db0af3b$export$480518999dfc4151 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        ...props,
        defaultLocale: props.locale
    }, children);

});


parcelRegister("zyR9K", function(module, exports) {

$parcel$export(module.exports, "MetricsContainers", () => $d84d4b40df0a6094$export$2d1617bc0040e5d9);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $eX2O4 = parcelRequire("eX2O4");

var $gXEQH = parcelRequire("gXEQH");

var $8WuJm = parcelRequire("8WuJm");

var $1RPrZ = parcelRequire("1RPrZ");
const $d84d4b40df0a6094$export$2d1617bc0040e5d9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: (0, $gXEQH.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX2O4.ExperienceTrackerProvider), null, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "metrics-containers-subproduct-updater",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1RPrZ.SubProductUpdater), null)), children));

});
parcelRegister("eX2O4", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerProvider", () => $ac9adb88a32f4483$export$6f49c95a810d59fa);

var $eUqFw = parcelRequire("eUqFw");

var $hUYqC = parcelRequire("hUYqC");
var $1xrmr = parcelRequire("1xrmr");

var $Xah93 = parcelRequire("Xah93");
const $ac9adb88a32f4483$var$useUnmount = (callback)=>(0, $eUqFw.useEffect)(()=>callback, [
        callback
    ]);
const $ac9adb88a32f4483$export$6f49c95a810d59fa = ({ children: children })=>{
    const [experienceTracker] = (0, $eUqFw.useState)(new (0, $hUYqC.ExperienceTracker)());
    const [cleanupSliSub] = (0, $eUqFw.useState)(()=>experienceTracker.subscribe((0, $Xah93.sliSubscriber)));
    const cleanup = (0, $eUqFw.useCallback)(()=>{
        cleanupSliSub();
    }, [
        cleanupSliSub
    ]);
    $ac9adb88a32f4483$var$useUnmount(cleanup);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1xrmr.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, children);
};

});
parcelRegister("Xah93", function(module, exports) {

$parcel$export(module.exports, "sliSubscriber", () => $29a12df906341fa5$export$db0b99fe17114899);

var $3FyZ4 = parcelRequire("3FyZ4");

var $eIp1n = parcelRequire("eIp1n");

var $6WXNs = parcelRequire("6WXNs");

const $29a12df906341fa5$var$transformApplication = (application)=>{
    switch(application){
        case 0, $eIp1n.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $eIp1n.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $eIp1n.JIRA_CORE:
            return 'jira-core';
        case 0, $eIp1n.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $eIp1n.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $29a12df906341fa5$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $6WXNs.FREE_EDITION:
            return 'jedi';
        case 0, $6WXNs.STANDARD_EDITION:
            return 'standard';
        case 0, $6WXNs.PREMIUM_EDITION:
            return 'premium';
        case 0, $6WXNs.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $29a12df906341fa5$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: action,
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            // any attribute on top of this is overridable by any tracker
            task: experience,
            reason: location,
            analyticsSource: analyticsSource,
            application: $29a12df906341fa5$var$transformApplication(application),
            edition: $29a12df906341fa5$var$transformEdition(edition),
            ...errorMessage && {
                errorMessage: errorMessage
            }
        }
    });
const $29a12df906341fa5$var$reportSli = (experienceDescription)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $29a12df906341fa5$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
const $29a12df906341fa5$export$db0b99fe17114899 = (event)=>{
    const { name: name, action: action } = event;
    // @ts-expect-error - TS2339 - Property 'disableSli' does not exist on type '{}'. | TS2339 - Property 'analyticsSource' does not exist on type '{}'. | TS2339 - Property 'application' does not exist on type '{}'. | TS2339 - Property 'edition' does not exist on type '{}'. | TS2339 - Property 'location' does not exist on type '{}'.
    const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
    if (disableSli) return;
    switch(action){
        case 0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a:
            $29a12df906341fa5$var$reportSli({
                experience: name,
                action: (0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $99e7a4e4cbcb5db0$export$b48b3d1872522384:
            $29a12df906341fa5$var$reportSli({
                experience: name,
                action: (0, $99e7a4e4cbcb5db0$export$b48b3d1872522384),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                ...event.error && {
                    errorMessage: String(event.error)
                },
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8:
            $29a12df906341fa5$var$reportSli({
                experience: name,
                action: (0, $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                additionalAttributes: additionalAttributes
            });
            break;
        default:
    }
};

});


parcelRegister("1RPrZ", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $570251e3e96e8c6c$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $keguF = parcelRequire("keguF");

var $dWlsy = parcelRequire("dWlsy");
const $570251e3e96e8c6c$export$eb40d3df56aa5c53 = ()=>{
    const subProduct = (0, $dWlsy.useSubProduct)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $keguF.setSubProduct)(subProduct);
    }, [
        subProduct
    ]);
    return null;
};

});
parcelRegister("dWlsy", function(module, exports) {

$parcel$export(module.exports, "subProductFromProjectType", () => $04e11956b03ab7c2$export$246e1e2a5c86a633);
$parcel$export(module.exports, "useSubProduct", () => $04e11956b03ab7c2$export$16aa2ad52cd8992a);

var $SEaoU = parcelRequire("SEaoU");
const $04e11956b03ab7c2$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 'business':
            return 'core';
        case 'product_discovery':
        case 'software':
            return 'software';
        case 'service_desk':
            return 'serviceDesk';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            projectType;
            return 'unknown';
    }
};
const $04e11956b03ab7c2$export$16aa2ad52cd8992a = ()=>{
    const [{ data: data }] = (0, $SEaoU.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return $04e11956b03ab7c2$export$246e1e2a5c86a633(data.project.type);
};

});



parcelRegister("6mtpk", function(module, exports) {

$parcel$export(module.exports, "NavigationContainers", () => $8e55b2de8860aa3e$export$36f9ed697cae18ae);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $aZ9Tb = parcelRequire("aZ9Tb");
let $8e55b2de8860aa3e$var$Containers = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
if (!false) $8e55b2de8860aa3e$var$Containers = (0, $aZ9Tb.ClientOnlyNavigationContainers);
const $8e55b2de8860aa3e$export$36f9ed697cae18ae = ({ baseUrl: baseUrl, children: children })=>{
    (0, $asu8X.di)($8e55b2de8860aa3e$var$Containers);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8e55b2de8860aa3e$var$Containers, {
        baseUrl: baseUrl
    }, children);
};

});
parcelRegister("aZ9Tb", function(module, exports) {

$parcel$export(module.exports, "ClientOnlyNavigationContainers", () => $6d5f905fa11e966d$export$68d7c1e44acfd599);

var $eUqFw = parcelRequire("eUqFw");

var $6oi2X = parcelRequire("6oi2X");
const $6d5f905fa11e966d$export$68d7c1e44acfd599 = ({ children: children })=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oi2X.Provider), null, children);
    return null;
};

});


parcelRegister("agGRi", function(module, exports) {

$parcel$export(module.exports, "PageConfigContainers", () => $56522c3977944126$export$9c661932489b4130);

var $eUqFw = parcelRequire("eUqFw");

var $7fSR6 = parcelRequire("7fSR6");

var $6rW04 = parcelRequire("6rW04");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
const $56522c3977944126$export$9c661932489b4130 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7fSR6.ThemeContainer), {
        isGlobal: true,
        getMeta: (0, $6rW04.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleContainer), {
        titleSuffix: (0, $3fq1f.ripTitleTemplateFromMeta)((0, $6rW04.default))
    }, children));

});
parcelRegister("7fSR6", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $d3617e68561cf32c$export$93d4e7f90805808f);
$parcel$export(module.exports, "ThemeContainer", () => $d3617e68561cf32c$export$11eb671888ed6e7d);

var $WBLbN = parcelRequire("WBLbN");

var $g1FfP = parcelRequire("g1FfP");
const $d3617e68561cf32c$var$initialState = {
    navigationTheme: {
        shouldShowTitle: false,
        logoUrl: '',
        usesCustomColours: false,
        backgroundColor: '',
        highlightColor: ''
    }
};
const $d3617e68561cf32c$var$Store = (0, $WBLbN.createStore)({
    name: 'theme',
    initialState: $d3617e68561cf32c$var$initialState,
    actions: $g1FfP
});
const $d3617e68561cf32c$export$74e6aa5aeff5e82e = (0, $WBLbN.createSubscriber)($d3617e68561cf32c$var$Store);
const $d3617e68561cf32c$export$93d4e7f90805808f = (0, $WBLbN.createHook)($d3617e68561cf32c$var$Store);
const $d3617e68561cf32c$export$11eb671888ed6e7d = (0, $WBLbN.createContainer)($d3617e68561cf32c$var$Store, {
    onInit: $g1FfP.bootstrap
});

});
parcelRegister("g1FfP", function(module, exports) {

$parcel$export(module.exports, "bootstrap", () => $74d45e3f7106acfe$export$36aff1fbb4f5dfc6);
$parcel$export(module.exports, "update", () => $74d45e3f7106acfe$export$722fbec263ad908a);

const $74d45e3f7106acfe$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
        const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
        const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
        // we need to use color code directly here to compare it with hex code in meta tags
        const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $73a5c9d720aa66e1$exports).N0 || ajsHighlightColor !== (0, $73a5c9d720aa66e1$exports).B400);
        const navigationTheme = {
            shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
            usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
            backgroundColor: ajsBackgroundColor || `var(--ds-background-inverse-subtle, ${(0, $73a5c9d720aa66e1$exports).N0})`,
            highlightColor: ajsHighlightColor || `var(--ds-text-brand, ${(0, $73a5c9d720aa66e1$exports).B400})`
        };
        if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
        setState({
            navigationTheme: navigationTheme
        });
    };
const $74d45e3f7106acfe$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
        const navigationTheme = {
            ...getState().navigationTheme,
            ...item
        };
        setState({
            navigationTheme: navigationTheme
        });
    };

});


parcelRegister("1TtYL", function(module, exports) {

$parcel$export(module.exports, "useDocumentTitleActions", () => $d28b8ffe196ad843$export$57c0fda036e12d67);
$parcel$export(module.exports, "DocumentTitleContainer", () => $d28b8ffe196ad843$export$1aad43993172f16f);
$parcel$export(module.exports, "DocumentTitleSubscriber", () => $d28b8ffe196ad843$export$b88d5abf3e0bec8c);
$parcel$export(module.exports, "DocumentTitleHelper", () => $d28b8ffe196ad843$export$573bf8d2ae7d60dc);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $98Lej = parcelRequire("98Lej");

var $3fq1f = parcelRequire("3fq1f");
const $d28b8ffe196ad843$var$initialState = {
    title: '',
    defaultTitle: '',
    contextArray: []
};
const $d28b8ffe196ad843$var$Store = (0, $WBLbN.createStore)({
    name: 'document-title',
    initialState: $d28b8ffe196ad843$var$initialState,
    actions: $98Lej
});
const $d28b8ffe196ad843$export$57c0fda036e12d67 = (0, $WBLbN.createActionsHook)($d28b8ffe196ad843$var$Store);
const $d28b8ffe196ad843$export$1aad43993172f16f = (0, $WBLbN.createContainer)($d28b8ffe196ad843$var$Store, {
    displayName: 'DocumentTitleContainer'
});
const $d28b8ffe196ad843$export$b88d5abf3e0bec8c = (0, $WBLbN.createSubscriber)($d28b8ffe196ad843$var$Store, {
    displayName: 'DocumentTitleSubscriber'
});
class $d28b8ffe196ad843$export$573bf8d2ae7d60dc extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.myself = Symbol('document title identifier');
        this.props.addDocumentTitle(this.myself);
    }
    componentDidMount() {
        this.updateTitle();
    }
    componentDidUpdate() {
        this.updateTitle();
    }
    componentWillUnmount() {
        this.props.removeDocumentTitle(this.myself);
        this.updateTitle();
    }
    updateTitle() {
        if ((0, $3fq1f.checkDocumentTitle)(this.myself, this.props.contextArray)) this.props.setTitle(this.props.title);
    }
    render() {
        return null;
    }
}

});
parcelRegister("98Lej", function(module, exports) {

$parcel$export(module.exports, "setTitle", () => (parcelRequire("hzX2Z")).default);
$parcel$export(module.exports, "addDocumentTitle", () => (parcelRequire("aIEib")).addDocumentTitle);
$parcel$export(module.exports, "removeDocumentTitle", () => (parcelRequire("h3oaR")).removeDocumentTitle);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $hzX2Z = parcelRequire("hzX2Z");

var $aIEib = parcelRequire("aIEib");

var $h3oaR = parcelRequire("h3oaR");

});
parcelRegister("hzX2Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $badd7a809fe968ef$export$2e2bcd8739ae039);

var $3fq1f = parcelRequire("3fq1f");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$badd7a809fe968ef$export$2e2bcd8739ae039 = (title)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
        const state = getState();
        const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
        const newTitle = (0, $3fq1f.createTitleFromTemplate)(title, titleTemplate);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.title = newTitle;
        setState({
            ...state,
            title: newTitle
        });
    };

});
parcelRegister("3fq1f", function(module, exports) {

$parcel$export(module.exports, "createTitleFromTemplate", () => $5992d599a50ec92a$export$3795256dd54a9c9d);
$parcel$export(module.exports, "ripTitleTemplateFromMeta", () => $5992d599a50ec92a$export$b7d18105f80195c);
$parcel$export(module.exports, "checkDocumentTitle", () => $5992d599a50ec92a$export$7f8be70a0bed1bae);
const $5992d599a50ec92a$export$3795256dd54a9c9d = (title, template)=>template.replace(/%s/, title);
const $5992d599a50ec92a$export$b7d18105f80195c = (getMeta)=>getMeta('ajs-app-title');
const $5992d599a50ec92a$export$7f8be70a0bed1bae = (title, contextArray)=>{
    if (contextArray[contextArray.length - 1] === title) return true;
    return false;
};

});


parcelRegister("aIEib", function(module, exports) {

$parcel$export(module.exports, "addDocumentTitle", () => $65d14c1ffc455bbb$export$a0c188c0ea474bb8);
const $65d14c1ffc455bbb$export$a0c188c0ea474bb8 = (title)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        contextArray.push(title);
        setState({
            contextArray: contextArray
        });
    };

});

parcelRegister("h3oaR", function(module, exports) {

$parcel$export(module.exports, "removeDocumentTitle", () => $06c2c915252a36d1$export$e844009b77f80a72);
const $06c2c915252a36d1$export$e844009b77f80a72 = (title)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        setState({
            contextArray: contextArray.filter((symbol)=>symbol !== title)
        });
    };

});




parcelRegister("hK0Sb", function(module, exports) {

$parcel$export(module.exports, "UiManagers", () => $9e6e4a1178661ec4$export$41286c339a88ca24);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $7ehAr = parcelRequire("7ehAr");

var $e20LE = parcelRequire("e20LE");

var $8e3ho = parcelRequire("8e3ho");
let $9e6e4a1178661ec4$var$ClientUiManagers = (0, $eUqFw.Fragment);
if (!false) // @ts-expect-error - TS2741 - Property '$$typeof' is missing in type '({ children }: ClientUiManagersProps) => JSX.Element' but required in type 'ExoticComponent<{ children?: ReactNode; }>'.
$9e6e4a1178661ec4$var$ClientUiManagers = (0, $8e3ho.ClientUiManagers);
const $9e6e4a1178661ec4$export$41286c339a88ca24 = ({ children: children })=>{
    (0, $asu8X.di)($9e6e4a1178661ec4$var$ClientUiManagers);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e20LE.LayoutManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ehAr.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e6e4a1178661ec4$var$ClientUiManagers, null, children)));
};

});
parcelRegister("7ehAr", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbManager", () => $fb73611fabb3f59f$export$cd5073909dd92c28);

var $eUqFw = parcelRequire("eUqFw");

var $bfY8R = parcelRequire("bfY8R");
const $fb73611fabb3f59f$export$cd5073909dd92c28 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bfY8R.BreadcrumbContainer), null, children);

});

parcelRegister("e20LE", function(module, exports) {

$parcel$export(module.exports, "LayoutManager", () => $631e215ae14481e0$export$4a04ad01c410b415);

var $eUqFw = parcelRequire("eUqFw");

var $1NIhY = parcelRequire("1NIhY");

var $lB25E = parcelRequire("lB25E");

var $WBLbN = parcelRequire("WBLbN");

var $3roBA = parcelRequire("3roBA");

var $53ucm = parcelRequire("53ucm");
const $631e215ae14481e0$var$LayoutContainer = (0, $WBLbN.createContainer)((0, $53ucm.layoutStore), {
    displayName: 'JiraLayoutContainer',
    onInit: ()=>({ dispatch: dispatch }, { leftSidebar: leftSidebar, rightSidebar: rightSidebar, isChromeless: isChromeless })=>{
            dispatch((0, $3roBA.actions).setIsChromeless(isChromeless));
            dispatch((0, $3roBA.actions).setLeftSidebarState(leftSidebar));
            dispatch((0, $3roBA.actions).setRightSidebarState(rightSidebar));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { isChromeless: isChromeless })=>{
            dispatch((0, $3roBA.actions).setIsChromeless(isChromeless));
        }
});
const $631e215ae14481e0$var$DEFFAULT_RIGHT_SIDEBAR_STATE = {
    stackState: []
};
const $631e215ae14481e0$var$useIsChromeless = (0, $lB25E.createRouterSelector)((state)=>state.route.layout?.isChromeless === true || state.route.entryPoint?.()?.toString() === 'ChromelessEntryPoint');
const $631e215ae14481e0$export$4a04ad01c410b415 = ({ children: children })=>{
    const { data: data } = (0, $lB25E.useResource)((0, $1NIhY.navigationUiStateResource));
    const isChromeless = $631e215ae14481e0$var$useIsChromeless();
    const isLeftSidebarCollapsed = data?.leftSidebar?.isCollapsed ?? false;
    const leftSidebarWidth = data?.leftSidebar?.width ?? (0, $53ucm.DEFAULT_LEFT_SIDEBAR_WIDTH);
    const leftSidebar = (0, $eUqFw.useMemo)(()=>({
            isVisible: true,
            isCollapsed: isLeftSidebarCollapsed,
            width: leftSidebarWidth,
            isFlyoutOpen: false
        }), [
        isLeftSidebarCollapsed,
        leftSidebarWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($631e215ae14481e0$var$LayoutContainer, {
        isGlobal: true,
        isChromeless: isChromeless,
        leftSidebar: leftSidebar,
        rightSidebar: $631e215ae14481e0$var$DEFFAULT_RIGHT_SIDEBAR_STATE
    }, children);
};

});

parcelRegister("8e3ho", function(module, exports) {

$parcel$export(module.exports, "ClientUiManagers", () => $3490141dc4535941$export$d1db6ae5bf84e489);

var $eUqFw = parcelRequire("eUqFw");

var $aOINP = parcelRequire("aOINP");

var $plbOU = parcelRequire("plbOU");

var $dQZ5c = parcelRequire("dQZ5c");

var $k8Qyf = parcelRequire("k8Qyf");

var $jvfW6 = parcelRequire("jvfW6");

var $cH5Wq = parcelRequire("cH5Wq");

var $lbttE = parcelRequire("lbttE");
const $3490141dc4535941$export$d1db6ae5bf84e489 = ({ children: children })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $plbOU.CrossFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cH5Wq.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbttE.ProjectCreateDrawerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQZ5c.FavoriteChangeProvider), {
        onShowFlag: showFlag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvfW6.ModalContextProvider), null, children))))));
};

});
parcelRegister("plbOU", function(module, exports) {

$parcel$export(module.exports, "CrossFlowProvider", () => $cd07cb8d277928e5$export$d900e4062895cd7c);

var $eUqFw = parcelRequire("eUqFw");

var $gl6u1 = parcelRequire("gl6u1");

var $3FyZ4 = parcelRequire("3FyZ4");

var $gd0Sp = parcelRequire("gd0Sp");

var $4Vji8 = parcelRequire("4Vji8");

var $iPzab = parcelRequire("iPzab");
// DELOR-412 Remove explicit mock once we make analytics a no-op in SSR
const $cd07cb8d277928e5$var$getAnalyticsInstance = ()=>false ? Promise.resolve({
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendUIEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendOperationalEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendTrackEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendScreenEvent: ()=>{}
    }) : (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
const $cd07cb8d277928e5$export$d900e4062895cd7c = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: { cloudId: cloudId, locale: locale } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gl6u1.default), {
            cloudId: cloudId,
            // @ts-expect-error - TS2322 - Type 'Promise<typeof AnalyticsWebClient> | Promise<{ sendUIEvent: () => void; sendOperationalEvent: () => void; sendTrackEvent: () => void; sendScreenEvent: () => void; }>' is not assignable to type 'MaybePromise<AnalyticsWebClientInterface>'.
            analyticsClient: $cd07cb8d277928e5$var$getAnalyticsInstance(),
            locale: locale,
            plugins: [
                (0, $4Vji8.getContainersPlugin),
                (0, $iPzab.getUsersPlugin)
            ]
        }, children));

});
parcelRegister("gl6u1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0611a94f424d0efe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6HgZc = parcelRequire("6HgZc");

var $fbeIa = parcelRequire("fbeIa");
const $0611a94f424d0efe$var$JiraProvider = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HgZc.CrossFlowProvider), {
        ...props,
        originProduct: "jira"
    });
};
var $0611a94f424d0efe$export$2e2bcd8739ae039 = $0611a94f424d0efe$var$JiraProvider;

});
parcelRegister("6HgZc", function(module, exports) {

$parcel$export(module.exports, "CrossFlowProvider", () => $5e25fa3d562685b2$export$d900e4062895cd7c);

var $eUqFw = parcelRequire("eUqFw");

var $hXPzA = parcelRequire("hXPzA");

var $juktg = parcelRequire("juktg");

var $8tM2T = parcelRequire("8tM2T");

var $2E0s4 = parcelRequire("2E0s4");

var $bUJ3s = parcelRequire("bUJ3s");

var $l1XvG = parcelRequire("l1XvG");

var $11Onj = parcelRequire("11Onj");

var $d2Lyf = parcelRequire("d2Lyf");

var $ijZC5 = parcelRequire("ijZC5");

var $hiWux = parcelRequire("hiWux");

const $5e25fa3d562685b2$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("iEvgc")));
const $5e25fa3d562685b2$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
        const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
        // TBLZ-852: Product Store - Personal Use Case
        // go/trailblazerexperiments
        const tblz852ExperimentCohort = (0, $8tM2T.default).getExperimentValue('product_store_personal_use_case', 'cohort', 'not-enrolled', {
            fireExperimentExposure: false
        });
        const isInTblz852ExperimentCohort = tblz852ExperimentCohort === 'variation';
        // TBLZ-852
        const onCloseResolver = (0, $eUqFw.useRef)();
        const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $eUqFw.useState)(false);
        const fireEvent = (0, $eUqFw.useMemo)(()=>(0, $2E0s4.analyticsWrapper)(analyticsClient), [
            analyticsClient
        ]);
        const [requestOptions, setRequestOptions] = (0, $eUqFw.useState)();
        const onAnalyticsEvent = (0, $eUqFw.useCallback)((payload)=>{
            const gasV3Event = (0, $bUJ3s.transformEvent)(payload);
            if (gasV3Event) {
                const enrichedEvent = (0, $ijZC5.enrichWithRequestOptions)((0, $d2Lyf.enrichWithPackageDetails)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        const onHandShake = (0, $eUqFw.useCallback)((appName)=>{
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
                        action: (0, $hiWux.uiInitialized),
                        actionSubject: (0, $hiWux.crossFlowActionSubject),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: $hiWux.source
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        const onOpen = (0, $eUqFw.useCallback)((options)=>{
            /**
     * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
     * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
     */ setFirstHandshakeReceived(false);
            const analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $ijZC5.enrichWithRequestOptions)({
                    eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
                    action: (0, $hiWux.openInvoked),
                    actionSubject: (0, $hiWux.crossFlowActionSubject)
                }, options),
                context: [
                    {
                        source: $hiWux.source
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $hXPzA.Journeys).GET_STARTED && redirectToWac) {
                (0, $l1XvG.setProductSignUpLocation)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                const completionStatus = {};
                return Promise.resolve(completionStatus);
            }
            const updatedExperimentalOptions = {
                ...globalExperimentalOptions || {},
                // "globalExperimentalOptions" will be injected to EVERY crossFlow invoke
                ...options.experimentalOptions || {} // "options.experimentalOptions" takes care of passing experimentalOptions to ONE specific crossFlow invoke
            };
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise((resolve)=>{
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        const onClose = (0, $eUqFw.useCallback)((completionStatus)=>{
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        const { colorMode: colorMode } = (0, $juktg.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hXPzA.BaseCrossFlowApiProvider), {
            onOpen: onOpen
        }, children, requestOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11Onj.ErrorBoundary), {
            onAnalyticsEvent: onAnalyticsEvent,
            onError: onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IntegrationView, {
            ...baseProviderProps,
            ...requestOptions,
            onAnalyticsEvent: onAnalyticsEvent,
            originProduct: originProduct,
            theme: colorMode,
            onClose: onClose,
            onHandShake: onHandShake,
            plugins: plugins,
            env: env,
            redirectToWac: redirectToWac,
            isInTblz852ExperimentCohort: isInTblz852ExperimentCohort,
            zIndex: requestOptions.zIndex ?? 1000
        }))));
    };
const $5e25fa3d562685b2$export$d900e4062895cd7c = $5e25fa3d562685b2$export$79d79d8dd8574306($5e25fa3d562685b2$var$IntegrationView);

});
parcelRegister("2E0s4", function(module, exports) {

$parcel$export(module.exports, "analyticsWrapper", () => $1695ae3f05391a1c$export$91b4dd3bfc301325);

const $1695ae3f05391a1c$export$91b4dd3bfc301325 = (analyticsClient)=>{
    return (event)=>{
        return Promise.resolve(analyticsClient).then((client)=>{
            switch(event.eventType){
                case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
                    client.sendUIEvent(event);
                    break;
                case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
                    client.sendTrackEvent(event);
                    break;
                case 0, $662e33bb7444ae33$export$12346a674644c156:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};

});

parcelRegister("bUJ3s", function(module, exports) {

$parcel$export(module.exports, "transformEvent", () => $86a18706a692bb1d$export$3f40e8c44448be30);
// Copied from xflow-ui. We post raw analytics events (context and payload only) from xflow-ui to consumer (CFE), transform on consumer and post to gasv3.

const $86a18706a692bb1d$var$GROWTH_TAG = 'growth';
const $86a18706a692bb1d$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $86a18706a692bb1d$var$getSources = (context)=>$86a18706a692bb1d$var$extractFromEventContext([
        'source'
    ], context);
const $86a18706a692bb1d$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
        const newAttributes = {
            ...ans,
            ...contextProps
        };
        return attributes ? {
            ...newAttributes,
            ...attributes
        } : newAttributes;
    }, {});
const $86a18706a692bb1d$var$getPackageInfo = (context)=>context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $86a18706a692bb1d$var$last = (values)=>values[values.length - 1];
const $86a18706a692bb1d$export$3f40e8c44448be30 = (event)=>{
    const { context: context, payload: payload } = event;
    if (!payload) return null;
    const sources = $86a18706a692bb1d$var$getSources(context);
    const source = $86a18706a692bb1d$var$last(sources) || (0, $662e33bb7444ae33$export$b055de0e665cb20c);
    const extraAttributes = $86a18706a692bb1d$var$getExtraAttributes(context);
    const { packageName: packageName, packageVersion: packageVersion } = $86a18706a692bb1d$var$last($86a18706a692bb1d$var$getPackageInfo(context)) || {};
    const { eventType: eventType = (0, $662e33bb7444ae33$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
    const attributes = {
        packageName: packageName,
        packageVersion: packageVersion,
        ...extraAttributes,
        ...payloadAttributes
    };
    const tags = payload.tags || [];
    tags.push($86a18706a692bb1d$var$GROWTH_TAG);
    switch(eventType){
        case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
        case 0, $662e33bb7444ae33$export$12346a674644c156:
        case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};

});

parcelRegister("l1XvG", function(module, exports) {

$parcel$export(module.exports, "setProductSignUpLocation", () => $08ab6814e0b91ccb$export$2827e2473cb9a346);

var $8a0ZO = parcelRequire("8a0ZO");


var $cWAJB = parcelRequire("cWAJB");
const $08ab6814e0b91ccb$var$utmCampaignMap = {
    'atlassian-switcher': (0, $cWAJB.UtmCampaign)['atlassian-switcher']
};
const $08ab6814e0b91ccb$var$isBundledProduct = (productKey)=>{
    return [
        (0, $8a0ZO.Targets).JIRA_SOFTWARE,
        (0, $8a0ZO.Targets).JIRA_SERVICE_DESK,
        (0, $8a0ZO.Targets).JIRA_CORE,
        (0, $8a0ZO.Targets).CONFLUENCE
    ].includes(productKey);
};
const $08ab6814e0b91ccb$var$getBundleSignUpParams = (productKey)=>{
    const bundles = {
        [(0, $8a0ZO.Targets).JIRA_SOFTWARE]: 'jira-software',
        [(0, $8a0ZO.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
        [(0, $8a0ZO.Targets).JIRA_CORE]: 'jira-core',
        [(0, $8a0ZO.Targets).CONFLUENCE]: 'confluence'
    };
    // Bundles default to free
    return `bundle=${bundles[productKey]}&edition=free`;
};
const $08ab6814e0b91ccb$var$isProductWithCustomSignUpPath = (productKey)=>{
    return [
        (0, $8a0ZO.Targets).OPSGENIE
    ].includes(productKey);
};
const $08ab6814e0b91ccb$var$getProductCustomSignUpPath = (productKey)=>{
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    const links = {
        [(0, $8a0ZO.Targets).OPSGENIE]: (0, $45dad2c59b5aaad6$export$fb1e43fdafe12e9b)
    };
    return links[productKey];
};
const $08ab6814e0b91ccb$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
    return Boolean($08ab6814e0b91ccb$var$utmCampaignMap[sourceComponent]);
};
const $08ab6814e0b91ccb$var$getUtmParams = (sourceComponent, sourceContext)=>{
    let utmParams = '';
    if (sourceComponent && $08ab6814e0b91ccb$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + `utm_campaign=${$08ab6814e0b91ccb$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
        if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
    }
    return utmParams;
};
const $08ab6814e0b91ccb$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
    const wacUrl = env === 'staging' ? (0, $45dad2c59b5aaad6$export$c37558e5c67d2b01) : (0, $45dad2c59b5aaad6$export$f199baf8dfc7621e);
    const utmParams = $08ab6814e0b91ccb$var$getUtmParams(sourceComponent, sourceContext);
    let queryParams = '';
    let bundleParams = '';
    let path = (0, $45dad2c59b5aaad6$export$2a45a00073911255);
    if ($08ab6814e0b91ccb$var$isBundledProduct(productKey)) {
        path = (0, $45dad2c59b5aaad6$export$e6c04a1dd86d1c14);
        bundleParams = $08ab6814e0b91ccb$var$getBundleSignUpParams(productKey);
    } else if ($08ab6814e0b91ccb$var$isProductWithCustomSignUpPath(productKey)) path = $08ab6814e0b91ccb$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
const $08ab6814e0b91ccb$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
    const url = $08ab6814e0b91ccb$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};

});
const $45dad2c59b5aaad6$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $45dad2c59b5aaad6$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $45dad2c59b5aaad6$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $45dad2c59b5aaad6$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $45dad2c59b5aaad6$export$2a45a00073911255 = '/software';

parcelRegister("cWAJB", function(module, exports) {

$parcel$export(module.exports, "UtmCampaign", () => $7d339faa65117a6e$export$fc604aa353a97e10);
var $7d339faa65117a6e$export$fc604aa353a97e10;
(function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
})($7d339faa65117a6e$export$fc604aa353a97e10 || ($7d339faa65117a6e$export$fc604aa353a97e10 = {}));

});


parcelRegister("11Onj", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $cd98b27b730d7cfb$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");

var $hiWux = parcelRequire("hiWux");
const $cd98b27b730d7cfb$var$name = "platform-pkg";
const $cd98b27b730d7cfb$var$version = "0.0.0-use.local";
const $cd98b27b730d7cfb$var$payload = {
    eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
    action: (0, $hiWux.errorBoundaryAction),
    actionSubject: (0, $hiWux.errorBoundaryActionSubject)
};
const $cd98b27b730d7cfb$var$context = [
    {
        source: $hiWux.source
    },
    {
        packageName: $cd98b27b730d7cfb$var$name,
        packageVersion: $cd98b27b730d7cfb$var$version
    }
];
class $cd98b27b730d7cfb$export$e926676385687eaf extends (0, $eUqFw.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        this.props.onAnalyticsEvent({
            payload: $cd98b27b730d7cfb$var$payload,
            context: $cd98b27b730d7cfb$var$context
        });
        if (this.props.onError) this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}

});
parcelRegister("hiWux", function(module, exports) {

$parcel$export(module.exports, "source", () => $c053ac2f81500e34$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "errorBoundaryAction", () => $c053ac2f81500e34$export$9d8252a268f4fa72);
$parcel$export(module.exports, "errorBoundaryActionSubject", () => $c053ac2f81500e34$export$1045419caf49b395);
$parcel$export(module.exports, "crossFlowActionSubject", () => $c053ac2f81500e34$export$d54c183f56e39aa5);
$parcel$export(module.exports, "uiInitialized", () => $c053ac2f81500e34$export$e5c2c058fa8068a6);
$parcel$export(module.exports, "openInvoked", () => $c053ac2f81500e34$export$e67cdcb8867a3bd0);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $662e33bb7444ae33$export$12346a674644c156);

const $c053ac2f81500e34$export$b4d5da5f34fb77ad = 'crossFlowProvider';
const $c053ac2f81500e34$export$9d8252a268f4fa72 = 'errorCaught';
const $c053ac2f81500e34$export$1045419caf49b395 = 'errorBoundary';
const $c053ac2f81500e34$export$d54c183f56e39aa5 = 'crossFlowSupport';
const $c053ac2f81500e34$export$e5c2c058fa8068a6 = 'uiInitialized';
const $c053ac2f81500e34$export$e67cdcb8867a3bd0 = 'openInvoked';

});


parcelRegister("d2Lyf", function(module, exports) {

$parcel$export(module.exports, "enrichWithPackageDetails", () => $fb667082deecfda1$export$59518efab336a8b5);
const $fb667082deecfda1$var$version = "0.0.0-use.local";
const $fb667082deecfda1$export$84f9cf7ef89d4c26 = {
    version: $fb667082deecfda1$var$version
};
const $fb667082deecfda1$export$59518efab336a8b5 = (event)=>{
    const attributes = {
        ...event.attributes || {},
        crossFlowSupport: $fb667082deecfda1$export$84f9cf7ef89d4c26
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("ijZC5", function(module, exports) {

$parcel$export(module.exports, "enrichWithRequestOptions", () => $8d9438e2156101c5$export$a5a156dc5df42f0);
const $8d9438e2156101c5$export$a5a156dc5df42f0 = (event, requestOptions)=>{
    if (!requestOptions) return event;
    const attributes = {
        // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
        ...requestOptions.extraAnalyticsAttributes || {},
        ...event.attributes || {},
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("iEvgc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("7cPkN")
]).then(()=>parcelRequire('8uMPq'));

});



parcelRegister("4Vji8", function(module, exports) {

$parcel$export(module.exports, "getContainersPlugin", () => $d5a247609f17a49b$export$81d1d40061d190bc);
parcelRequire("fYNkJ");
var $lJsOu = parcelRequire("lJsOu");
var $fYNkJ = parcelRequire("fYNkJ");

var $e91YZ = parcelRequire("e91YZ");
const $d5a247609f17a49b$var$getCloudId = async ()=>{
    const { cloudName: cloudName, cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const containers = [
        {
            id: cloudId,
            displayName: cloudName,
            type: (0, $lJsOu.ContainerTypes).ATLASSIAN_CLOUD_ID
        }
    ];
    return {
        type: (0, $lJsOu.ContainerTypes).ATLASSIAN_CLOUD_ID,
        containers: containers
    };
};
const $d5a247609f17a49b$export$81d1d40061d190bc = (0, $fYNkJ.createGetContainersPlugin)($d5a247609f17a49b$var$getCloudId);

});
parcelRegister("fYNkJ", function(module, exports) {

$parcel$export(module.exports, "createGetContainersPlugin", () => $edac63653776ab1d$export$76378b0f825c024c);
$parcel$export(module.exports, "createGetUsersPlugin", () => $edac63653776ab1d$export$8feb7eae83cf8cd5);
$parcel$export(module.exports, "ContainerTypes", () => (parcelRequire("lJsOu")).ContainerTypes);
$parcel$export(module.exports, "UserIdTypes", () => (parcelRequire("lJsOu")).UserIdTypes);

var $lJsOu = parcelRequire("lJsOu");
const $edac63653776ab1d$export$76378b0f825c024c = (fetch)=>{
    return [
        (0, $lJsOu.PluginTypes).GetContainers,
        fetch
    ];
};
const $edac63653776ab1d$export$8feb7eae83cf8cd5 = (fetch)=>{
    return [
        (0, $lJsOu.PluginTypes).GetUsers,
        fetch
    ];
};
const $edac63653776ab1d$export$21d120847be2aff4 = (fetch)=>{
    return [
        (0, $lJsOu.PluginTypes).GetSuggestedSiteNames,
        fetch
    ];
};
const $edac63653776ab1d$export$d7c1699c6a2ca18a = (fetch)=>{
    return [
        (0, $lJsOu.PluginTypes).GetAvailableSites,
        fetch
    ];
};

});
parcelRegister("lJsOu", function(module, exports) {

$parcel$export(module.exports, "PluginTypes", () => $5cc146ce6a3f537d$export$a235a73f7b906dce);
$parcel$export(module.exports, "ContainerTypes", () => $5cc146ce6a3f537d$export$6e383182a26455ff);
$parcel$export(module.exports, "UserIdTypes", () => $5cc146ce6a3f537d$export$e391bab95adb8396);
// Data Plugin definition and utility types
const $5cc146ce6a3f537d$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
const $5cc146ce6a3f537d$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
const $5cc146ce6a3f537d$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
const $5cc146ce6a3f537d$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};

});



parcelRegister("iPzab", function(module, exports) {

$parcel$export(module.exports, "getUsersPlugin", () => $f595b9c40464a5a8$export$7c44908d2777db01);

var $fYNkJ = parcelRequire("fYNkJ");
var $lJsOu = parcelRequire("lJsOu");
const $f595b9c40464a5a8$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await fetch(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    id: value.id,
                    idType: (0, $lJsOu.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $f595b9c40464a5a8$export$7c44908d2777db01 = (0, $fYNkJ.createGetUsersPlugin)($f595b9c40464a5a8$var$getUsers);

});


parcelRegister("dQZ5c", function(module, exports) {

$parcel$export(module.exports, "FavoriteChangeContext", () => $5cd604b288cea09a$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $5cd604b288cea09a$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $5cd604b288cea09a$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $5cd604b288cea09a$export$cfa169f3278459e8);

var $aN2eF = parcelRequire("aN2eF");

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $guiFP = parcelRequire("guiFP");

var $huI7r = parcelRequire("huI7r");

var $jMP2a = parcelRequire("jMP2a");

var $dWLk9 = parcelRequire("dWLk9");

var $4Tdfn = parcelRequire("4Tdfn");

var $4PS9K = parcelRequire("4PS9K");

var $7rOmF = parcelRequire("7rOmF");

var $jrdvV = parcelRequire("jrdvV");

var $cfElQ = parcelRequire("cfElQ");

var $duxfp = parcelRequire("duxfp");
const $5cd604b288cea09a$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $5cd604b288cea09a$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $5cd604b288cea09a$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
const $5cd604b288cea09a$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $eUqFw.createContext)($5cd604b288cea09a$export$b212ddc707077772);
// supports project types only for now
const $5cd604b288cea09a$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const commitUpdate = (0, $eUqFw.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $jrdvV.PROJECTS_ITEM_TYPE)) (0, $cNy9K.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $4Tdfn.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $5cd604b288cea09a$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $5cd604b288cea09a$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $eUqFw.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $eUqFw.useCallback)((item)=>{
        setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $eUqFw.useCallback)((item, analyticsEvent)=>{
        setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $eUqFw.useCallback)((item, analyticsId, error)=>{
        setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $duxfp.errorFlag)());
        (0, $guiFP.default)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $eUqFw.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $cfElQ.default)(item);
                const typename = (0, $4PS9K.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $7rOmF.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $iWLL0.useMutation)((0, $aN2eF.default));
    const changeFavoriteMutation = (0, $eUqFw.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $4Tdfn.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $4PS9K.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $7rOmF.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $eUqFw.useCallback)((item)=>{
        setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $eUqFw.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $4PS9K.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $7rOmF.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $4Tdfn.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $4PS9K.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $7rOmF.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $eUqFw.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5cd604b288cea09a$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $5cd604b288cea09a$export$f227cdfbb355444a = $5cd604b288cea09a$export$a5d258b9665ce94b.Consumer;
const $5cd604b288cea09a$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5cd604b288cea09a$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $5cd604b288cea09a$export$cfa169f3278459e8 = ()=>(0, $eUqFw.useContext)($5cd604b288cea09a$export$a5d258b9665ce94b);

});
parcelRegister("aN2eF", function(module, exports) {

$parcel$export(module.exports, "default", () => $53c140edf81067bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f
const $53c140edf81067bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
            "metadata": {},
            "name": "viewSetFavouriteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$53c140edf81067bf$var$node.hash = "af74e48c451986374e11a5b801d5009f";
var $53c140edf81067bf$export$2e2bcd8739ae039 = $53c140edf81067bf$var$node;

});

parcelRegister("huI7r", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $c148d923211ffae9$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $c148d923211ffae9$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $c148d923211ffae9$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $c148d923211ffae9$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $c148d923211ffae9$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $c148d923211ffae9$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $c148d923211ffae9$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $c148d923211ffae9$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $c148d923211ffae9$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $c148d923211ffae9$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $c148d923211ffae9$export$8e68286aef4c3a8b = (ari)=>$c148d923211ffae9$var$ARI_REG_EXP.test(ari) || $c148d923211ffae9$var$ARI_REG_EXP_WORKSPACE.test(ari) || $c148d923211ffae9$var$ARI_REG_EXP_ACTIVATION.test(ari) || $c148d923211ffae9$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $c148d923211ffae9$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $c148d923211ffae9$export$24b47820a324e614 = (ari)=>{
    if ($c148d923211ffae9$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $c148d923211ffae9$export$e2789192113e8b07 = (ari, defaultValue = '')=>$c148d923211ffae9$export$24b47820a324e614(ari) ?? defaultValue;
const $c148d923211ffae9$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($c148d923211ffae9$export$8e68286aef4c3a8b(ari)) {
        const parts = $c148d923211ffae9$var$ARI_REG_EXP.exec(ari) || $c148d923211ffae9$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $c148d923211ffae9$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $c148d923211ffae9$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $c148d923211ffae9$export$3d8d7031a11613fd = (ari)=>{
    const config = $c148d923211ffae9$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("4PS9K", function(module, exports) {

$parcel$export(module.exports, "favoriteTypeToTypename", () => $e37d9393195ce810$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $e37d9393195ce810$export$717886a1047f1287);

var $haZ9d = parcelRequire("haZ9d");

var $jDNSq = parcelRequire("jDNSq");

var $aZApM = parcelRequire("aZApM");

var $3zsgO = parcelRequire("3zsgO");

var $csxeI = parcelRequire("csxeI");

var $8npnf = parcelRequire("8npnf");
function $e37d9393195ce810$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $e37d9393195ce810$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $e37d9393195ce810$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $e37d9393195ce810$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $e37d9393195ce810$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $8npnf.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $3zsgO.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $aZApM.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $csxeI.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $jDNSq.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $haZ9d.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $e37d9393195ce810$var$assertUnreachable(typename);
    }
};
const $e37d9393195ce810$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $e37d9393195ce810$var$assertUnreachable(typename);
    }
};
const $e37d9393195ce810$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $e37d9393195ce810$var$favoriteAriToId(typename, id),
        type: $e37d9393195ce810$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $e37d9393195ce810$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $e37d9393195ce810$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});

parcelRegister("7rOmF", function(module, exports) {

$parcel$export(module.exports, "publishFavorite", () => $5b205dfeb5d81b94$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $5b205dfeb5d81b94$export$eb04bf805f6b8fb2);

var $eUqFw = parcelRequire("eUqFw");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $5b205dfeb5d81b94$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $5b205dfeb5d81b94$var$favoritePubSub = new $5b205dfeb5d81b94$var$FavoritePubSub();
const $5b205dfeb5d81b94$export$229a24253fb568e1 = $5b205dfeb5d81b94$var$favoritePubSub.publish;
const $5b205dfeb5d81b94$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $eUqFw.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$5b205dfeb5d81b94$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});

parcelRegister("jrdvV", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $0f4349785a7b5234$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $0f4349785a7b5234$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $0f4349785a7b5234$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $0f4349785a7b5234$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $0f4349785a7b5234$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $0f4349785a7b5234$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $0f4349785a7b5234$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $0f4349785a7b5234$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $0f4349785a7b5234$export$2d63a9c2e78633c8);
const $0f4349785a7b5234$export$aade82542e73ffc8 = 'boards';
const $0f4349785a7b5234$export$a448ebfa10cebc74 = 'filters';
const $0f4349785a7b5234$export$f8099f229527572c = 'dashboards';
const $0f4349785a7b5234$export$8e58083dcbb878d = 'issues';
const $0f4349785a7b5234$export$2fd44a6cb58b66cb = 'plans';
const $0f4349785a7b5234$export$8e2cd98172988d7e = 'projects';
const $0f4349785a7b5234$export$6b0c8e47d2c7f1d9 = 'queues';
const $0f4349785a7b5234$export$9c8cfad65800ddfb = [
    $0f4349785a7b5234$export$aade82542e73ffc8,
    $0f4349785a7b5234$export$f8099f229527572c,
    $0f4349785a7b5234$export$a448ebfa10cebc74,
    $0f4349785a7b5234$export$8e58083dcbb878d,
    $0f4349785a7b5234$export$2fd44a6cb58b66cb,
    $0f4349785a7b5234$export$8e2cd98172988d7e,
    $0f4349785a7b5234$export$6b0c8e47d2c7f1d9
];
const $0f4349785a7b5234$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});

parcelRegister("cfElQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b6607d4d7fa618f$export$2e2bcd8739ae039);

var $10sp5 = parcelRequire("10sp5");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8b6607d4d7fa618f$export$2e2bcd8739ae039 = async (request)=>(0, $10sp5.updateFavorite)(request);

});
parcelRegister("10sp5", function(module, exports) {

$parcel$export(module.exports, "updateFavorite", () => $13472629d630871e$export$8c2f00130cc945dc);

var $lRmyA = parcelRequire("lRmyA");
const $13472629d630871e$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $lRmyA.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $lRmyA.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("duxfp", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $bec77f1a045d66e4$export$b9a7f1ebeaa76953);

var $jsurv = parcelRequire("jsurv");
const $bec77f1a045d66e4$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $jsurv.default)
    });

});
parcelRegister("jsurv", function(module, exports) {

$parcel$export(module.exports, "default", () => $973c51bdbf11215e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $973c51bdbf11215e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("jvfW6", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $3b08d5b0f7ce801d$export$7c9538f5f3c365e9);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $3qf87 = parcelRequire("3qf87");
function $3b08d5b0f7ce801d$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $eUqFw.useRef)(1);
    const [modals, setModals] = (0, $eUqFw.useState)([]);
    const modalContext = (0, $eUqFw.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3qf87.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, modals.map((modal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(modal.component, {
            key: modal.key,
            onClose: modal.close
        }))));
}

});
parcelRegister("3qf87", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $454708699096dc24$export$ab57792b9b6974a6);

var $eUqFw = parcelRequire("eUqFw");
const $454708699096dc24$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openModal: ()=>{}
});

});


parcelRegister("lbttE", function(module, exports) {

$parcel$export(module.exports, "ProjectCreateDrawerProvider", () => $3fbad164cde8fff4$export$9a1c5dbd93c42bca);
$parcel$export(module.exports, "ProjectCreateDrawerConsumer", () => $3fbad164cde8fff4$export$9a8662cd60931de1);
$parcel$export(module.exports, "useProjectCreateDrawer", () => $3fbad164cde8fff4$export$8172ff4ed0f75a1e);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $9CmwD = parcelRequire("9CmwD");

var $9EFi5 = parcelRequire("9EFi5");

var $lB25E = parcelRequire("lB25E");

var $cTTDV = parcelRequire("cTTDV");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $3fbad164cde8fff4$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)({
    data: {
        shouldRenderDrawer: false,
        isOpen: false,
        isNextGen: false,
        showExperienceSelection: true,
        recommendedTemplate: undefined,
        defaultSelectedTemplateKey: '',
        source: '',
        isTemplatePickerOpenInitially: false,
        isImportProjectOpenInitially: false,
        selectedProjectType: null,
        recommendationSessionId: undefined
    },
    methods: {
        open: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        close: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onCreateStarted: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        setOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        clearOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }
});
const $3fbad164cde8fff4$export$839a70d8fbc9d356 = class ProjectCreateDrawerProvider extends (0, $eUqFw.Component) {
    render() {
        const { children: children } = this.props;
        const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3fbad164cde8fff4$var$Context.Provider, {
            value: {
                data: {
                    isOpen: isOpen,
                    isNextGen: isNextGen,
                    source: source,
                    showExperienceSelection: showExperienceSelection,
                    shouldRenderDrawer: shouldRenderDrawer,
                    recommendedTemplate: recommendedTemplate,
                    defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                    isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                    isImportProjectOpenInitially: isImportProjectOpenInitially,
                    selectedProjectType: selectedProjectType,
                    recommendationSessionId: recommendationSessionId
                },
                methods: {
                    open: this.open,
                    close: this.close,
                    onSuccess: this.onSuccess,
                    onCreateStarted: this.onCreateStarted,
                    setOnCloseCallback: this.setOnCloseCallback,
                    clearOnCloseCallback: this.clearOnCloseCallback
                }
            }
        }, children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            shouldRenderDrawer: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined,
            onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onSuccess = (projectKey)=>{
            if (projectKey) {
                this.props.setLocation(projectKey.returnUrl);
                this.close(true);
            } else this.close(false);
        };
        // Callback that is called once when the drawer is closed.
        this.setOnCloseCallback = (callback)=>{
            this.setState({
                onCloseCallback: callback
            });
        };
        this.clearOnCloseCallback = ()=>{
            this.setState({
                onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
            });
        };
        this.open = (attributes = {})=>{
            // @ts-expect-error - TS2345 - Argument of type '{ isNextGen?: boolean | undefined; showExperienceSelection?: boolean | undefined; recommendedTemplate?: { templateKey: string; isSimplified: boolean; } | undefined; defaultSelectedTemplateKey?: string | undefined; ... 4 more ...; shouldRenderDrawer: true; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "source" | "isOpen" | "isNextGen" | ... 5 more ... | "isTemplatePickerOpenInitially"> | null) | Pick<...> | null'.
            this.setState({
                isOpen: true,
                shouldRenderDrawer: true,
                ...attributes
            });
        };
        this.close = (projectCreated)=>{
            const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                isImportProjectOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            if (callOnCloseCallBack) // Call the added callback
            this.state.onCloseCallback();
        };
        this.closeOld = ()=>{
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            this.state.onCloseCallback();
        };
        this.onCreateStarted = (projectKey, templateKey)=>{
            if ((0, $9CmwD.getIsJsmBlankProjectTemplate)(templateKey)) (0, $9EFi5.LazyComponent).preload();
            (0, $cTTDV.clearResourcesAssociatedWithProjectKey)(projectKey);
        };
    }
};
const $3fbad164cde8fff4$export$9a1c5dbd93c42bca = (props)=>{
    const { push: push } = (0, $lB25E.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3fbad164cde8fff4$export$839a70d8fbc9d356, {
        ...props,
        setLocation: push
    });
};
const { Consumer: $3fbad164cde8fff4$export$9a8662cd60931de1 } = $3fbad164cde8fff4$var$Context;
$3fbad164cde8fff4$var$Context.displayName = 'ProjectCreateDrawerConsumer';
const $3fbad164cde8fff4$export$8172ff4ed0f75a1e = ()=>{
    const projectCreateDrawer = (0, $eUqFw.useContext)($3fbad164cde8fff4$var$Context);
    if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
    return projectCreateDrawer;
};

});
parcelRegister("9CmwD", function(module, exports) {

$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", () => $9672b8899ab98e98$export$7492b6cc3ef89883);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$6278b41164dbde6c);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$17a2f771efabf02f);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$bd14946bcde77195);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $9672b8899ab98e98$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $9672b8899ab98e98$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $9672b8899ab98e98$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $9672b8899ab98e98$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$b0928b02ffab3875);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$fd75f6abc7861439);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$fb658bddae7f81bb);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $9672b8899ab98e98$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$7c567eb725bd36f);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $9672b8899ab98e98$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $9672b8899ab98e98$export$a062badd78c9993);
// Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $9672b8899ab98e98$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $9672b8899ab98e98$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $9672b8899ab98e98$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $9672b8899ab98e98$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $9672b8899ab98e98$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $9672b8899ab98e98$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $9672b8899ab98e98$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $9672b8899ab98e98$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $9672b8899ab98e98$export$7d9a4e0ef5194fe1 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $9672b8899ab98e98$export$477ca3550da12e43 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $9672b8899ab98e98$export$7c0307155b744916 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $9672b8899ab98e98$export$b5ab111fb8825075 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $9672b8899ab98e98$export$14139f0ec41d437e = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $9672b8899ab98e98$export$ebf7af45376deb8b = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $9672b8899ab98e98$export$7b6945581ccdab4a = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $9672b8899ab98e98$export$310a9ac5c28d65f6 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $9672b8899ab98e98$export$136d17feb2f4285d = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
const $9672b8899ab98e98$export$e288f4758e94a8cc = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
const $9672b8899ab98e98$export$4e9ac1417ba54bba = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
const $9672b8899ab98e98$export$560c9f6765bf9af4 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
const $9672b8899ab98e98$export$14d4c6dbbb62a127 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
const $9672b8899ab98e98$export$1367ee12532c525f = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
const $9672b8899ab98e98$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $9672b8899ab98e98$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $9672b8899ab98e98$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $9672b8899ab98e98$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
const $9672b8899ab98e98$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $9672b8899ab98e98$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $9672b8899ab98e98$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $9672b8899ab98e98$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $9672b8899ab98e98$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $9672b8899ab98e98$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $9672b8899ab98e98$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $9672b8899ab98e98$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $9672b8899ab98e98$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $9672b8899ab98e98$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $9672b8899ab98e98$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $9672b8899ab98e98$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $9672b8899ab98e98$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $9672b8899ab98e98$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $9672b8899ab98e98$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $9672b8899ab98e98$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $9672b8899ab98e98$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $9672b8899ab98e98$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $9672b8899ab98e98$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $9672b8899ab98e98$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $9672b8899ab98e98$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $9672b8899ab98e98$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $9672b8899ab98e98$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $9672b8899ab98e98$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $9672b8899ab98e98$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $9672b8899ab98e98$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $9672b8899ab98e98$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $9672b8899ab98e98$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $9672b8899ab98e98$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $9672b8899ab98e98$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $9672b8899ab98e98$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $9672b8899ab98e98$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $9672b8899ab98e98$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $9672b8899ab98e98$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $9672b8899ab98e98$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $9672b8899ab98e98$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $9672b8899ab98e98$export$f9776303073903dd = 'jira.polaris:roadmap';
const $9672b8899ab98e98$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
const $9672b8899ab98e98$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $9672b8899ab98e98$export$e8df553a3f519284 || T4JTemplateKey === $9672b8899ab98e98$export$8eecdf6acea9494 || T4JTemplateKey === $9672b8899ab98e98$export$9e38ad41d19608ee;
const $9672b8899ab98e98$export$a062badd78c9993 = {
    [$9672b8899ab98e98$export$e82092c4fb277f9b]: $9672b8899ab98e98$export$b0928b02ffab3875,
    [$9672b8899ab98e98$export$fd75f6abc7861439]: $9672b8899ab98e98$export$b0928b02ffab3875,
    [$9672b8899ab98e98$export$5eddf3b31dd1858f]: $9672b8899ab98e98$export$50478ee5ecbf7a4d,
    [$9672b8899ab98e98$export$fb658bddae7f81bb]: $9672b8899ab98e98$export$50478ee5ecbf7a4d
};

});

parcelRegister("9EFi5", function(module, exports) {

$parcel$export(module.exports, "LazyComponent", () => $6ae11cc3f6e45a93$export$31f1740ae531af94);
$parcel$export(module.exports, "AsyncProjectBuilderDrawer", () => $6ae11cc3f6e45a93$export$54a4eade9eae9473);
$parcel$export(module.exports, "canUseProjectBuilder", () => $6ae11cc3f6e45a93$export$ff317c5d87147a19);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $iVSJI = parcelRequire("iVSJI");

const $6ae11cc3f6e45a93$export$31f1740ae531af94 = (0, $6VZoe.lazy)(()=>(parcelRequire("hig9W")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/project-builder/src/ui/index.tsx"
});
const $6ae11cc3f6e45a93$export$54a4eade9eae9473 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "bundle-async-project-builder",
        packageName: "jira-servicedesk-project-builder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        fallback: null,
        name: "jsm-project-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ae11cc3f6e45a93$export$31f1740ae531af94, {
        isOpenInitial: !!props.isOpenInitial,
        ...props
    }))));
const $6ae11cc3f6e45a93$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;

});
parcelRegister("iVSJI", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $98f32c00711ff158$export$ac31f8f3368d6881);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $SEaoU = parcelRequire("SEaoU");

var $kJ81T = parcelRequire("kJ81T");
const $98f32c00711ff158$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $eUqFw.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
$98f32c00711ff158$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $kJ81T.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $SEaoU.useContainerContext)
};

});
parcelRegister("kJ81T", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAnalyticsContextResource", () => $f5a87dd3d6d3f919$export$d6f4f0483916919f);
$parcel$export(module.exports, "useServiceDeskAnalyticsContext", () => $f5a87dd3d6d3f919$export$bc2de1c42df30b10);

var $eUqFw = parcelRequire("eUqFw");

var $8hg3R = parcelRequire("8hg3R");

var $lB25E = parcelRequire("lB25E");


const $f5a87dd3d6d3f919$var$getDataLoader = ()=>(parcelRequire("jmi1c"));
const $f5a87dd3d6d3f919$var$ONE_DAY_IN_MILLIS = 86400000;
const $f5a87dd3d6d3f919$export$d6f4f0483916919f = (0, $lB25E.createResource)({
    type: (0, $76d1e4a47c4d6ee4$export$285b47583a5bdd0f),
    getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
    getDataLoader: $f5a87dd3d6d3f919$var$getDataLoader,
    maxAge: $f5a87dd3d6d3f919$var$ONE_DAY_IN_MILLIS
});
const $f5a87dd3d6d3f919$export$bc2de1c42df30b10 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)($f5a87dd3d6d3f919$export$d6f4f0483916919f);
    (0, $eUqFw.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("8hg3R", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyOrId", () => $07950346cbbaf790$export$43cde151f667c69e);
$parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", () => $07950346cbbaf790$export$b87af5b274141bd6);

var $9zYls = parcelRequire("9zYls");
const $07950346cbbaf790$export$43cde151f667c69e = (match)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, match.query);
    return projectKey || projectId || '';
};
const $07950346cbbaf790$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};

});

const $76d1e4a47c4d6ee4$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';

parcelRegister("jmi1c", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6G5Ft").then(()=>parcelRequire('eUv3W'));

});



parcelRegister("hig9W", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("kWrFZ"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("6Nc34")
]).then(()=>parcelRequire('1USrr'));

});


parcelRegister("cTTDV", function(module, exports) {

$parcel$export(module.exports, "clearResourcesAssociatedWithProjectKey", () => $6e401ba3b3d297e1$export$c0c81c1828c7638c);

var $guiFP = parcelRequire("guiFP");

var $lB25E = parcelRequire("lB25E");
const $6e401ba3b3d297e1$export$c0c81c1828c7638c = (projectKey)=>{
    try {
        const { storeState: storeState } = (0, $lB25E.getResourceStore)();
        const prevState = storeState.getState();
        storeState.setState({
            ...prevState,
            data: Object.fromEntries(Object.entries(prevState?.data).map(([resourceType, value])=>{
                // This will not clear resources that are keyed with project key as a subset of the key,
                // e.g. `projectKey-${projectKey}` or similar, so those resources may still have stale data.
                const { [projectKey]: _, ...rest } = value;
                return [
                    resourceType,
                    rest
                ];
            }))
        });
    } catch (e) {
        (0, $guiFP.default)({
            meta: {
                id: 'clearResourcesAssociatedWithProjectKey',
                packageName: 'jiraProjectCreateDrawerContext',
                teamName: 'helix'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: e instanceof Error ? e : new Error('Error occured in clearResourcesAssociatedWithProjectKey')
        });
    }
};

});




parcelRegister("f9UOp", function(module, exports) {

$parcel$export(module.exports, "UserContainers", () => $8d4848b02de0c2ee$export$c1b371eec908681a);

var $eUqFw = parcelRequire("eUqFw");

var $6L2se = parcelRequire("6L2se");

var $lGLse = parcelRequire("lGLse");
const $8d4848b02de0c2ee$export$c1b371eec908681a = ({ baseUrl: baseUrl, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGLse.UserContainer), {
        isGlobal: true,
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6L2se.UserPreferencesContainer), {
        isGlobal: true
    }, children));

});
parcelRegister("6L2se", function(module, exports) {

$parcel$export(module.exports, "UserPreferencesContainer", () => $39c7f00c5ab3f451$export$aa278641ded1adf);

var $WBLbN = parcelRequire("WBLbN");

var $dsC4d = parcelRequire("dsC4d");
const $39c7f00c5ab3f451$export$be74e04eaea4530 = (0, $WBLbN.createSubscriber)((0, $dsC4d.default), {
    displayName: 'UserPreferencesSubscriber'
});
const $39c7f00c5ab3f451$export$aa278641ded1adf = (0, $WBLbN.createContainer)((0, $dsC4d.default));

});
parcelRegister("dsC4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $961f40ab8b3e4548$export$2e2bcd8739ae039);

var $WBLbN = parcelRequire("WBLbN");

var $9z14H = parcelRequire("9z14H");
const $961f40ab8b3e4548$var$initialState = {
    'issue-view-experiment': {
        data: {
            value: false
        },
        loading: false,
        error: null
    }
};
var // @ts-expect-error - TS2344 - Type 'typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/user-preferences/src/actions/index")' does not satisfy the constraint 'Record<string, ActionThunk<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/user-preferences/src/actions/index")>>'.
$961f40ab8b3e4548$export$2e2bcd8739ae039 = (0, $WBLbN.createStore)({
    name: 'user-preference',
    initialState: $961f40ab8b3e4548$var$initialState,
    actions: $9z14H
});

});
parcelRegister("9z14H", function(module, exports) {

$parcel$export(module.exports, "fetch", () => (parcelRequire("h9epI")).default);
$parcel$export(module.exports, "fetchIssueCreate", () => (parcelRequire("7Pq3h")).default);
$parcel$export(module.exports, "updateExperiment", () => (parcelRequire("bZIav")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $h9epI = parcelRequire("h9epI");

var $7Pq3h = parcelRequire("7Pq3h");

var $bZIav = parcelRequire("bZIav");

});
parcelRegister("h9epI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fe76d2a970114ff$export$2e2bcd8739ae039);

var $h5sT2 = parcelRequire("h5sT2");
var /**
 * Initiates data retrieval for a user preference, ensuring no duplicate requests are made.
 * Updates the application state with retrieved data or an error, accordingly.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$3fe76d2a970114ff$export$2e2bcd8739ae039 = (preferenceKey)=>async ({ setState: setState, getState: getState }, { baseUrl: baseUrl })=>{
        const currentState = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'.
        if (currentState[preferenceKey] && currentState[preferenceKey].loading) return;
        setState({
            [preferenceKey]: {
                data: currentState.data,
                loading: true,
                error: null
            }
        });
        try {
            const data = await (0, $h5sT2.default)({
                baseUrl: baseUrl,
                preferenceKey: preferenceKey
            });
            setState({
                [preferenceKey]: {
                    data: data,
                    loading: false,
                    error: null
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                [preferenceKey]: {
                    data: getState().data,
                    loading: false,
                    error: err
                }
            });
        }
    };

});
parcelRegister("h5sT2", function(module, exports) {

$parcel$export(module.exports, "default", () => $63687d4b54057aad$export$2e2bcd8739ae039);

var $9CiFV = parcelRequire("9CiFV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$63687d4b54057aad$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, preferenceKey: preferenceKey })=>{
    try {
        const result = await (0, $9CiFV.default)(baseUrl, preferenceKey);
        return {
            value: result
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        if (e.statusCode === 404) return {
            value: undefined
        };
        throw e;
    }
};

});
parcelRegister("9CiFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca4afe9581c5212d$export$2e2bcd8739ae039);

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ca4afe9581c5212d$export$2e2bcd8739ae039 = (baseUrl, key)=>{
    const requestUrl = `${baseUrl}/rest/api/3/mypreferences?key=${key}`;
    return (0, $lRmyA.performGetRequest)(requestUrl);
};

});



parcelRegister("7Pq3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5c5efcd31332e13$export$2e2bcd8739ae039);

var $h9epI = parcelRequire("h9epI");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f5c5efcd31332e13$export$2e2bcd8739ae039 = ()=>(0, $h9epI.default)('issue-create');

});

parcelRegister("bZIav", function(module, exports) {

$parcel$export(module.exports, "default", () => $1122b82eba9b9cfc$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1122b82eba9b9cfc$export$2e2bcd8739ae039 = (experimentKey, value)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: { data: { value: boolean; }; loading: false; error: null; }; }' is not assignable to parameter of type 'Partial<State>'.
        setState({
            [experimentKey]: {
                data: {
                    value: value
                },
                loading: false,
                error: null
            }
        });
    };

});






parcelRegister("kqXZB", function(module, exports) {

$parcel$export(module.exports, "HorizontalNav", () => $cf6ef4bc9cecc99d$export$3821fe730064297d);
$parcel$export(module.exports, "HorizontalNavWrapper", () => $cf6ef4bc9cecc99d$export$8798384053a023ae);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dWu0t = parcelRequire("dWu0t");

var $dJOhP = parcelRequire("dJOhP");

var $ghXjN = parcelRequire("ghXjN");
const $cf6ef4bc9cecc99d$var$NavErrorBoundaryFallback = ()=>// null = equivalent of "unmount"
    // We should do more graceful degradation.
    // Let's review this after dogfooding:
    // Tracked https://hello.jira.atlassian.cloud/browse/SEA-3059
    null;
const $cf6ef4bc9cecc99d$export$3821fe730064297d = ()=>{
    const HorizontalNavComponent = (0, $dWu0t.useHorizontalNavComponent)();
    return HorizontalNavComponent && /*#__PURE__*/ $eUqFw.createElement((0, $dJOhP.NavErrorBoundary), {
        packageName: "page-container",
        id: "spa-horizontal-nav",
        fallback: $cf6ef4bc9cecc99d$var$NavErrorBoundaryFallback
    }, /*#__PURE__*/ $eUqFw.createElement((0, $dJOhP.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ $eUqFw.createElement((0, $ghXjN.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ $eUqFw.createElement(HorizontalNavComponent, null));
};
const $cf6ef4bc9cecc99d$export$8798384053a023ae = ({ children: children, navComponent: HorizontalNavComponent })=>{
    return /*#__PURE__*/ $eUqFw.createElement($cf6ef4bc9cecc99d$var$ThemedContainer, null, /*#__PURE__*/ $eUqFw.createElement((0, $dJOhP.NavErrorBoundary), {
        packageName: "page-container",
        id: "spa-horizontal-nav",
        fallback: $cf6ef4bc9cecc99d$var$NavErrorBoundaryFallback
    }, /*#__PURE__*/ $eUqFw.createElement((0, $dJOhP.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ $eUqFw.createElement((0, $ghXjN.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ $eUqFw.createElement(HorizontalNavComponent, null)), children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf6ef4bc9cecc99d$var$ThemedContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71o10 _11q31r52 _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dJOhP", function(module, exports) {

$parcel$export(module.exports, "NavErrorBoundary", () => $fc92a101a1384c46$export$afc779e659fd533f);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $9zysr = parcelRequire("9zysr");

var $eI5EY = parcelRequire("eI5EY");

var $6FP8W = parcelRequire("6FP8W");
function $fc92a101a1384c46$export$35c1e8d8e59e87e7() {
    return [
        // to be kept up-to-date
        // last update 2024/08/14
        // reference: https://hello.atlassian.net/wiki/spaces/JNR/pages/4001046109/Coding+for+the+nav4+rollout
        [
            'jira_nav4',
            (0, $eI5EY.fg)('jira_nav4')
        ],
        [
            'jira_nav4_dogfooding',
            (0, $eI5EY.fg)('jira_nav4_dogfooding')
        ],
        [
            'jira_nav4_dogfooding_phase-1',
            (0, $eI5EY.fg)('jira_nav4_dogfooding_phase-1')
        ],
        [
            'jira_nav4_dogfooding_phase-2',
            (0, $eI5EY.fg)('jira_nav4_dogfooding_phase-2')
        ]
    ];
}
const $fc92a101a1384c46$export$1d1321d2b374d697 = ()=>{
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};
function $fc92a101a1384c46$var$inferNavRevision() {
    // This is brittle since we have several FFs https://hello.atlassian.net/wiki/spaces/SEA/pages/3841892327/Jira+Nav+v4+Feature+Flags
    // if possible, try to pass the revision explicitly as a prop
    return (0, $6FP8W.getWillShowNav4)() ? 'v4' : 'v3';
}
function $fc92a101a1384c46$var$getExtraAttributes(_error) {
    const attributes = {
        ffs: $fc92a101a1384c46$export$35c1e8d8e59e87e7().filter(([, value])=>value).map(([key])=>key).join(),
        rev: $fc92a101a1384c46$var$inferNavRevision()
    };
    return attributes;
}
function $fc92a101a1384c46$var$getAnalyticsPayload(error, meta, navRevision) {
    const payload = {
        error: error,
        meta: {
            // intentionally fixed metas
            // so that we generate a unique event signature
            // so that we can register it in the analytics portal: https://data-portal.internal.atlassian.com/analytics/registry/67955
            // so that we get the attributes to show up in Splunk: https://splunk.paas-inf.net/en-GB/app/search/2024_sea2744_jira_nav_v4_container_navigation
            id: 'logic',
            packageName: 'JiraNav'
        },
        attributes: {
            ...$fc92a101a1384c46$var$getExtraAttributes(error),
            // forward the original meta as attributes to identify the location
            pkg: meta.packageName,
            id: meta.id,
            // if explicitly passed, override the rev
            ...navRevision && {
                rev: navRevision
            }
        },
        skipSentry: true
    };
    return payload;
}
const $fc92a101a1384c46$export$5ac21f1e947e70d6 = (props)=>{
    const { id: id, packageName: packageName, navRevision: navRevision } = props;
    const onError = (0, $eUqFw.useMemo)(()=>{
        const meta = {
            id: id,
            packageName: packageName
        };
        const _onError = (...args)=>{
            if ($fc92a101a1384c46$export$1d1321d2b374d697()) // this is a local test environment, don't send anything
            return;
            const [_, error] = args;
            (0, $guiFP.default)($fc92a101a1384c46$var$getAnalyticsPayload(error, meta, navRevision));
        };
        return _onError;
    }, [
        id,
        packageName,
        navRevision
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        ...props,
        onError: onError
    });
};
const $fc92a101a1384c46$export$afc779e659fd533f = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc92a101a1384c46$export$5ac21f1e947e70d6, props), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), props));

});

parcelRegister("ghXjN", function(module, exports) {

$parcel$export(module.exports, "TopNavigationSkipLink", () => $e6fff404e2b2ee46$export$47de2191d46337b7);
$parcel$export(module.exports, "LeftSidebarSkipLink", () => $e6fff404e2b2ee46$export$46697df0d7c5e8be);
$parcel$export(module.exports, "ProjectViewNavigationSkipLink", () => $e6fff404e2b2ee46$export$2e2fc9c237996c06);
$parcel$export(module.exports, "MainContentSkipLink", () => $e6fff404e2b2ee46$export$b1498dd122ea3284);

var $5JgJ2 = parcelRequire("5JgJ2");

var $hwyJ1 = parcelRequire("hwyJ1");

var $16pq9 = parcelRequire("16pq9");
const $e6fff404e2b2ee46$export$47de2191d46337b7 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $hwyJ1.useCustomSkipLink)('ak-jira-navigation', formatMessage((0, $16pq9.default).skipToJiraNavigation), 0);
    return null;
};
const $e6fff404e2b2ee46$export$46697df0d7c5e8be = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $hwyJ1.useCustomSkipLink)('ak-side-navigation', formatMessage((0, $16pq9.default).skipToSideNavigation), 1);
    return null;
};
const $e6fff404e2b2ee46$export$2e2fc9c237996c06 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $hwyJ1.useCustomSkipLink)('ak-project-view-navigation', formatMessage((0, $16pq9.default).skipToProjectViewNavigation), 2);
    return null;
};
const $e6fff404e2b2ee46$export$b1498dd122ea3284 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $hwyJ1.useCustomSkipLink)('ak-main-content', formatMessage((0, $16pq9.default).skipToMainContent), 3);
    return null;
};

});
parcelRegister("16pq9", function(module, exports) {

$parcel$export(module.exports, "default", () => $28122dc87949ce0e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $28122dc87949ce0e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    skipToJiraNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-jira-navigation",
        "defaultMessage": "Skip to Jira Navigation"
    },
    skipToSideNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-side-navigation",
        "defaultMessage": "Skip to Side Navigation"
    },
    skipToProjectViewNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-project-view-navigation",
        "defaultMessage": "Skip to View Navigation"
    },
    skipToMainContent: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-main-content",
        "defaultMessage": "Skip to Main Content"
    }
});

});



parcelRegister("l8xBK", function(module, exports) {

$parcel$export(module.exports, "RightSidebar", () => $e236e5cdaab70156$export$84d58c19c21f637f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $1FAd1 = parcelRequire("1FAd1");


var $8R80x = parcelRequire("8R80x");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $bUi2Q = parcelRequire("bUi2Q");

var $6FP8W = parcelRequire("6FP8W");

var $hwyJ1 = parcelRequire("hwyJ1");

var $10fdS = parcelRequire("10fdS");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $isbb2 = parcelRequire("isbb2");

var $bQiKj = parcelRequire("bQiKj");

var $2uiE3 = parcelRequire("2uiE3");

var $jK1pm = parcelRequire("jK1pm");
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */ const $e236e5cdaab70156$var$TEST_ID = 'page-layout.aside';
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $e236e5cdaab70156$var$routeComponents = [];
const $e236e5cdaab70156$var$SharedRightSidebars = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $isbb2.renderGlobalComponents)((0, $bQiKj.sharedLayout).rightSidebars));
const $e236e5cdaab70156$var$RightSidebarRouteComponents = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $isbb2.renderGlobalComponents)(route.layout?.rightSidebars || $e236e5cdaab70156$var$routeComponents));
};
const $e236e5cdaab70156$var$RightSidebarThroughEntrypoint = ()=>{
    const rightSideBarEntryPoint = (0, $1FAd1.usePageLayoutEntryPoint)((0, $d619e185f38e9ae8$export$7bf43119a6b49ddb));
    const route = (0, $10fdS.useCurrentRoute)();
    const entrypoint = (0, $eUqFw.useMemo)(()=>route.entryPoint?.(), [
        route
    ]);
    if (!entrypoint || !rightSideBarEntryPoint) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "right-sidebar-through-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-through-entrypoint",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholder), {
        name: "right-sidebar-through-entrypoint",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2uiE3.ProjectListSidebarSkeleton), null),
        /* @ts-expect-error - TS2322 - We're using JSResourceReference from @atlassian/react-async. */ entryPoint: entrypoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
        entryPointReference: rightSideBarEntryPoint,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }))));
};
const $e236e5cdaab70156$var$NewRightSidebar = ()=>{
    const lastPanelIdRef = (0, $eUqFw.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
            panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
            isClosed: rightSidebarCurrentState?.panelId == null,
            isMinimised: !!rightSidebarCurrentState?.isMinimised,
            isCollapsed: !!rightSidebarCurrentState?.isCollapsed
        });
        lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
    }, [
        createAnalyticsEvent,
        rightSidebarCurrentState?.panelId,
        rightSidebarCurrentState?.isMinimised,
        rightSidebarCurrentState?.isCollapsed
    ]);
    if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.RightSidebar), {
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0,
        testId: $e236e5cdaab70156$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-right-sidebars",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$SharedRightSidebars, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$RightSidebarRouteComponents, null)), (0, $1ybV0.ff)('server-render-projects-directory-sidebar_rj9ki') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$RightSidebarThroughEntrypoint, null))));
};
/**
 * Manages visibility and behavior of the right sidebar in the user interface, adapting to user interactions and system events. It enhances user experience by providing dynamic control over the sidebar's presentation, including features for collapsing and minimizing, alongside tracking user interactions for analytical purposes.
 */ const $e236e5cdaab70156$var$OldRightSidebar = ()=>{
    const lastPanelIdRef = (0, $eUqFw.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
            panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
            isClosed: rightSidebarCurrentState?.panelId == null,
            isMinimised: !!rightSidebarCurrentState?.isMinimised,
            isCollapsed: !!rightSidebarCurrentState?.isCollapsed
        });
        lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
    }, [
        createAnalyticsEvent,
        rightSidebarCurrentState?.panelId,
        rightSidebarCurrentState?.isMinimised,
        rightSidebarCurrentState?.isCollapsed
    ]);
    if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$RightSidebarPanelWrapper, {
        id: "right-sidebar-panel-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.RightSidebar), {
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-right-sidebars",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$SharedRightSidebars, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$RightSidebarRouteComponents, null)), (0, $1ybV0.ff)('server-render-projects-directory-sidebar_rj9ki') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$RightSidebarThroughEntrypoint, null)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e236e5cdaab70156$var$RightSidebarPanelWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1bgi _1ej2b4wl _iu1g1fl4",
            __cmplp.className
        ])
    });
});
const $e236e5cdaab70156$export$84d58c19c21f637f = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $e236e5cdaab70156$var$NewRightSidebar, $e236e5cdaab70156$var$OldRightSidebar);

});
parcelRegister("1FAd1", function(module, exports) {

$parcel$export(module.exports, "usePageLayoutEntryPoint", () => $569433a5f969d51a$export$fe1c839e8baf4110);

var $399tN = parcelRequire("399tN");

var $10fdS = parcelRequire("10fdS");
const $569433a5f969d51a$export$fe1c839e8baf4110 = (layoutField)=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const entryPointReference = (0, $399tN.useRouteEntryPoint)({
        route: route
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return entryPointReference?.entryPoints[layoutField];
};

});
parcelRegister("399tN", function(module, exports) {

$parcel$export(module.exports, "useRouteEntryPoint", () => $94d21b8ebec2d194$export$c96377f800cdddb4);

var $gglAH = parcelRequire("gglAH");
const $94d21b8ebec2d194$export$c96377f800cdddb4 = ({ route: route })=>{
    const [lastLoadedRoute] = (0, $gglAH.useLastLoadedRoute)();
    // route.entryPoint is already loaded
    if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) return lastLoadedRoute.entryPointReference;
    return null;
};

});
parcelRegister("gglAH", function(module, exports) {

$parcel$export(module.exports, "useLastLoadedRoute", () => $200515d1f24b1bb9$export$895238443fc3eae4);
$parcel$export(module.exports, "getEntryPointsStore", () => $200515d1f24b1bb9$export$fe654a734624d17f);
$parcel$export(module.exports, "getLastLoadedRoute", () => $200515d1f24b1bb9$export$5763b2305b3056df);
$parcel$export(module.exports, "getPrefetchingRoute", () => $200515d1f24b1bb9$export$7e18f3e3cbd04326);

var $WBLbN = parcelRequire("WBLbN");
const $200515d1f24b1bb9$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
        setState({
            lastLoadedRoute: {
                route: route,
                entryPointReference: entryPointReference
            }
        });
    };
const $200515d1f24b1bb9$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
        setState({
            prefetchingRoute: {
                routerContext: routerContext,
                expiresAt: expiresAt,
                entryPointReference: entryPointReference
            }
        });
    };
const $200515d1f24b1bb9$var$actions = {
    setLastLoadedRoute: $200515d1f24b1bb9$export$1cec83a23d40a9fa,
    setPrefetchingRoute: $200515d1f24b1bb9$export$bb3dc9c55f78173e
};
const $200515d1f24b1bb9$var$EntryPointsStore = (0, $WBLbN.createStore)({
    initialState: {
        lastLoadedRoute: null,
        prefetchingRoute: null
    },
    actions: $200515d1f24b1bb9$var$actions,
    name: 'react-resource-router/entry-points'
});
const $200515d1f24b1bb9$export$895238443fc3eae4 = (0, $WBLbN.createHook)($200515d1f24b1bb9$var$EntryPointsStore, {
    selector: (state)=>state.lastLoadedRoute
});
const $200515d1f24b1bb9$export$fe654a734624d17f = ()=>(0, $WBLbN.defaultRegistry).getStore($200515d1f24b1bb9$var$EntryPointsStore);
const $200515d1f24b1bb9$export$b28ecd0e4705f6b7 = ()=>$200515d1f24b1bb9$export$fe654a734624d17f().storeState.getState();
const $200515d1f24b1bb9$export$5763b2305b3056df = ()=>$200515d1f24b1bb9$export$b28ecd0e4705f6b7().lastLoadedRoute;
const $200515d1f24b1bb9$export$7e18f3e3cbd04326 = ()=>$200515d1f24b1bb9$export$b28ecd0e4705f6b7().prefetchingRoute;

});



const $d619e185f38e9ae8$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $d619e185f38e9ae8$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $d619e185f38e9ae8$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $d619e185f38e9ae8$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $d619e185f38e9ae8$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';

parcelRegister("2uiE3", function(module, exports) {

$parcel$export(module.exports, "ProjectListSidebarSkeleton", () => $7cd5cfa2bb5d5ee4$export$808c25bcc6102427);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $hn0yl = parcelRequire("hn0yl");
const $7cd5cfa2bb5d5ee4$var$customCssStyles = null;
const $7cd5cfa2bb5d5ee4$var$sidebarCssStyles = null;
const $7cd5cfa2bb5d5ee4$export$808c25bcc6102427 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1bsb1gwv _1yt41ejb _1kl71hdd _1h6db5v6 _bfhkvuon _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hn0yl))),
        className: (0, $7JEyt.default)([
            "_t6vdidpf _hr4jidpf"
        ])
    }));

});
parcelRegister("8ICxF", function(module, exports) {

$parcel$export(module.exports, "AppSkeletonImage", () => $f467e6485d9792e8$export$45b107c5dc7b51a5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $5JgJ2 = parcelRequire("5JgJ2");

var $apShl = parcelRequire("apShl");

var $h1hCM = parcelRequire("h1hCM");
const $f467e6485d9792e8$var$skeletonImageStyles = null;
const $f467e6485d9792e8$export$45b107c5dc7b51a5 = ({ src: src, className: className, containerStyles: containerStyles })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f467e6485d9792e8$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: src,
        alt: `${formatMessage((0, $h1hCM.default).loading)}...`,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _vchhusvi _1bsb1osq _1dqonqa1 _1h6d3acm _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f467e6485d9792e8$var$SkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h1hCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5b2a6284984f9f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0b5b2a6284984f9f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("hn0yl", function(module, exports) {
module.exports = new URL("project-list-sidebar-app-skeleton.tpl.35da4e26.svg", import.meta.url).toString();

});



parcelRegister("eymfV", function(module, exports) {

$parcel$export(module.exports, "Sidebar", () => $fa1d85c5358105db$export$1ba59dacbcbf90fe);

var $bckG1 = parcelRequire("bckG1");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $hTLlD = parcelRequire("hTLlD");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8fxTv = parcelRequire("8fxTv");

var $7webZ = parcelRequire("7webZ");

var $c9TLT = parcelRequire("c9TLT");

var $0cdA8 = parcelRequire("0cdA8");

var $9zysr = parcelRequire("9zysr");

var $4ksts = parcelRequire("4ksts");

var $kpmC0 = parcelRequire("kpmC0");

var $53ucm = parcelRequire("53ucm");

var $7zhpa = parcelRequire("7zhpa");

var $u0mbR = parcelRequire("u0mbR");

var $7BqbB = parcelRequire("7BqbB");

var $kpmO3 = parcelRequire("kpmO3");

var $6FP8W = parcelRequire("6FP8W");

var $bdfGI = parcelRequire("bdfGI");

var $4QXXR = parcelRequire("4QXXR");

var $hwyJ1 = parcelRequire("hwyJ1");

var $2W91Z = parcelRequire("2W91Z");

var $gGtKh = parcelRequire("gGtKh");

var $10fdS = parcelRequire("10fdS");

var $buJlM = parcelRequire("buJlM");

var $inC6u = parcelRequire("inC6u");

var $8C1im = parcelRequire("8C1im");

var $6yplV = parcelRequire("6yplV");

var $jK1pm = parcelRequire("jK1pm");

var $lWATQ = parcelRequire("lWATQ");
var $iHNtK = parcelRequire("iHNtK");

var $ghXjN = parcelRequire("ghXjN");

var $2D8YV = parcelRequire("2D8YV");

var $j6voN = parcelRequire("j6voN");
const $fa1d85c5358105db$var$SidebarNew = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const { queryReference: queryReference } = (0, $buJlM.useRelayResource)((0, $7zhpa.sidebarNav4UiStateResource));
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "nav4.sidebar.anonymous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "sidebar.anonymous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa1d85c5358105db$var$SidebarInternalAnonymous, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "nav4.sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "sidebar"
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa1d85c5358105db$var$SidebarInternal, {
        queryReference: queryReference
    }) : null));
};
const $fa1d85c5358105db$var$SidebarInternalAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const defaultCollapsed = false;
    const defaultWidth = 340;
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $53ucm.useLayoutStoreActions)();
    const onExpand = (0, $eUqFw.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: false
        });
    }, [
        setLeftSidebarState
    ]);
    const onCollapse = (0, $eUqFw.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: true
        });
    }, [
        setLeftSidebarState
    ]);
    const onResizeEnd = (0, $eUqFw.useCallback)(({ finalWidth: finalWidth })=>{
        setLeftSidebarState({
            width: finalWidth
        });
    }, [
        setLeftSidebarState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kpmO3.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iHNtK.SideNav), {
        testId: $fa1d85c5358105db$var$TEST_ID,
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        onExpand: onExpand,
        onCollapse: onCollapse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bdfGI.SidebarSelector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWATQ.PanelSplitter), {
        label: formatMessage((0, $2D8YV.messages).sideBarPanelSplitterLabel),
        onResizeEnd: onResizeEnd
    })));
};
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 */ const $fa1d85c5358105db$var$TEST_ID = 'page-layout.sidebar';
const $fa1d85c5358105db$var$SidebarInternal = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const data = (0, $iWLL0.usePreloadedQuery)((0, $bckG1.default), queryReference); /*
                                                                                               	Backend may respond with an error with the reason as Navigation UI state user property does not exist
                                                                                               	under a scenario where a new user joins an existing Jira site.
                                                                                               	When this happens, UI would not have data coming through from sidebarSelectorQuery.
                                                                                               	So, default values are used in such a case.
                                                                                               */ 
    const defaultCollapsed = data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, $7BqbB.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT);
    const defaultWidth = data?.jira?.navigationUIState?.leftSidebarWidth ?? (0, $7BqbB.LEFT_SIDEBAR_EXPANDED_MIN_WIDTH);
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $53ucm.useLayoutStoreActions)();
    const onExpand = (0, $eUqFw.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: false
        });
    }, [
        setLeftSidebarState
    ]);
    const onCollapse = (0, $eUqFw.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: true
        });
    }, [
        setLeftSidebarState
    ]);
    const onResizeEnd = (0, $eUqFw.useCallback)(({ finalWidth: finalWidth })=>{
        setLeftSidebarState({
            width: finalWidth
        });
    }, [
        setLeftSidebarState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kpmO3.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iHNtK.SideNav), {
        testId: $fa1d85c5358105db$var$TEST_ID,
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        onExpand: onExpand,
        onCollapse: onCollapse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bdfGI.SidebarSelector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $fa1d85c5358105db$var$feedbackButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8C1im.SidebarFeedbackButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWATQ.PanelSplitter), {
        label: formatMessage((0, $2D8YV.messages).sideBarPanelSplitterLabel),
        onResizeEnd: onResizeEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2W91Z.AsyncNudgeBundledUsersFlagContainer), null)));
};
const $fa1d85c5358105db$var$SIDEBAR_TEST_ID = 'ContextualNavigation';
const $fa1d85c5358105db$var$SIDEBAR_TRACE_KEY = 'sidebar';
const $fa1d85c5358105db$var$sidebarOverrides = {
    ResizeButton: {
        render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
                id: "sidebar-resize-tooltip",
                packageName: "page-container",
                fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
                name: "side_bar_button",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j6voN.AsyncResizeButtonTooltip), {
                isLeftSidebarCollapsed: props.isLeftSidebarCollapsed
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props))))
    }
};
const $fa1d85c5358105db$var$SidebarInternalOld = ({ sidebar: sidebar })=>{
    const { width: width, isCollapsed: isCollapsed } = (0, $kpmC0.useLeftSidebarState)();
    const route = (0, $10fdS.useCurrentRoute)();
    const intl = (0, $4ksts.useIntlV2)();
    const shouldNotRenderSidebarInServerSide = false && isCollapsed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "left-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa1d85c5358105db$var$SidebarStyleOverrides, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "leftSidebarSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.LeftSidebarSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.LeftSidebar), {
        isFixed: true,
        width: width,
        testId: $fa1d85c5358105db$var$SIDEBAR_TEST_ID,
        resizeButtonLabel: intl.formatMessage((0, $2D8YV.messages).sidebarNavigation),
        collapsedState: isCollapsed ? 'collapsed' : 'expanded',
        overrides: $fa1d85c5358105db$var$sidebarOverrides,
        id: "ak-side-navigation"
    }, !shouldNotRenderSidebarInServerSide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, route !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $u0mbR.SidebarStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        type: "start",
        traceKey: $fa1d85c5358105db$var$SIDEBAR_TRACE_KEY
    })), sidebar, route !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarSSRPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        type: "end",
        traceKey: $fa1d85c5358105db$var$SIDEBAR_TRACE_KEY
    }))))));
};
const $fa1d85c5358105db$var$SidebarInternalOldMemo = /*#__PURE__*/ (0, $eUqFw.memo)($fa1d85c5358105db$var$SidebarInternalOld, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))); // moved children as function outside the `Sidebar` so that the function is not re-created every time `Sidebar` is re-rendered.
const $fa1d85c5358105db$var$renderChildren = (sidebar)=>sidebar !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa1d85c5358105db$var$SidebarInternalOldMemo, {
        sidebar: sidebar
    }) : null;
const $fa1d85c5358105db$var$SidebarOld = ()=>{
    const { shouldRender: shouldRender } = (0, $kpmC0.useLeftSidebarState)();
    const route = (0, $10fdS.useCurrentRoute)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4QXXR.SidebarSelectorProvider), {
        sidebar: route.navigation?.sidebar ?? null
    }, $fa1d85c5358105db$var$renderChildren);
};
const $fa1d85c5358105db$export$1ba59dacbcbf90fe = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $fa1d85c5358105db$var$SidebarNew, $fa1d85c5358105db$var$SidebarOld); /**
                                                                                         * In the @atlaskit/page-layout, resize control uses button for
                                                                                         * the grab area. At the same time, legacy batch.css reset all
                                                                                         * the button to have a box-shadow when focused. So when user
                                                                                         * resizing the sidebar, they will see two blue lines around
                                                                                         * the grab area.
                                                                                         */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa1d85c5358105db$var$SidebarStyleOverrides = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1d7w7yr": (0, $9t7rW.default)((0, $c9TLT.layers).leftSidebar)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1pbyg9ti _14c1glyw",
            __cmplp.className
        ])
    });
});
const $fa1d85c5358105db$var$feedbackButtonContainerStyles = (0, $1ZAYh.xcss)({
    position: 'sticky',
    insetBlockEnd: 'space.0',
    marginBlockStart: 'auto'
});

});
parcelRegister("bckG1", function(module, exports) {

$parcel$export(module.exports, "default", () => $135252e9d486cd82$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6397372677267ea3c070486a779d6ada>>
 * @relayHash a62980e6f93cb5f2ad31fdebd70c38b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2b594593303f12c91ba380135535d6cde24ab3377ce6133c443e711b338621c8
const $135252e9d486cd82$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "leftSidebarWidth"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraNavigationUIStateUserProperty",
                                "kind": "LinkedField",
                                "name": "navigationUIState",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v2 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v3 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.navigationUIState.leftSidebarWidth"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2b594593303f12c91ba380135535d6cde24ab3377ce6133c443e711b338621c8",
            "metadata": {},
            "name": "sidebarSelectorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$135252e9d486cd82$var$node.hash = "e5c64c6d4b80524f3da4efcb8ecca3f4";
var $135252e9d486cd82$export$2e2bcd8739ae039 = $135252e9d486cd82$var$node;

});

parcelRegister("8fxTv", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_DROPDOWN_MARKS", () => $0e0908bb9731ec35$export$8df02628d98cae7e);
$parcel$export(module.exports, "pageSegmentStore", () => $0e0908bb9731ec35$export$26cadbe0bcaabcde);
$parcel$export(module.exports, "useNavPerformanceMetrics", () => $0e0908bb9731ec35$export$906025848d54198d);
$parcel$export(module.exports, "NavTopPerformanceMark", () => $0e0908bb9731ec35$export$b7f4caa65b0906fc);
$parcel$export(module.exports, "NavTopSSRPerformanceMark", () => $0e0908bb9731ec35$export$2c4a101f2cde4fc2);
$parcel$export(module.exports, "NavTopPerformanceReport", () => $0e0908bb9731ec35$export$c64b31449a6177d);
$parcel$export(module.exports, "NavSidebarPerformanceMark", () => $0e0908bb9731ec35$export$35b2aeea5cbc963e);
$parcel$export(module.exports, "NavSidebarSSRPerformanceMark", () => $0e0908bb9731ec35$export$14f711a2cb6a655a);
$parcel$export(module.exports, "NavSidebarPerformanceReport", () => $0e0908bb9731ec35$export$a018e347341b3640);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $lNfG4 = parcelRequire("lNfG4");

var $keguF = parcelRequire("keguF");

var $inC6u = parcelRequire("inC6u");

var $7webZ = parcelRequire("7webZ");
const $0e0908bb9731ec35$var$createTopNavPageSegment = ()=>(0, $lNfG4.metrics).pageSegmentLoad({
        key: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME),
        timings: [
            {
                key: 'ttic',
                startMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderStart,
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrStart,
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'bundle-load',
                startMark: (0, $7webZ.NAVIGATION_TOP_MARKS).bundleLoadStart,
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderStart
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $0e0908bb9731ec35$export$8df02628d98cae7e = {
    ADDONS: (0, $lNfG4.metrics).interaction({
        key: 'navigation-top.addons-dropdown-opened'
    })
};
const $0e0908bb9731ec35$var$createSidebarPageSegment = ()=>(0, $lNfG4.metrics).pageSegmentLoad({
        key: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME),
        timings: [
            {
                key: 'renderAttempt',
                startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderAttempt
            },
            {
                key: 'ttic',
                startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderStart,
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'load',
                startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadStart,
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadEnd
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $0e0908bb9731ec35$export$26cadbe0bcaabcde = (()=>{
    const segmentConstructors = {
        [(0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)]: $0e0908bb9731ec35$var$createTopNavPageSegment,
        [(0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $0e0908bb9731ec35$var$createSidebarPageSegment
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const segments = {};
    return {
        getSegment: (key)=>{
            if (!segments[key]) {
                if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                segments[key] = segmentConstructors[key]();
            }
            return segments[key];
        }
    };
})();
const $0e0908bb9731ec35$export$906025848d54198d = (segmentKey = (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME))=>{
    const startedRef = (0, $eUqFw.useRef)(false);
    const segment = (0, $eUqFw.useRef)($0e0908bb9731ec35$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
    if (!false && !startedRef.current) {
        segment && segment.startFromPageLoad();
        startedRef.current = true;
    }
    return (0, $eUqFw.useMemo)(()=>// object assign here to extend origianl segment object and save prototypes
        Object.assign(segment, {
            markSSR: (metricKey)=>{
                const tmpSsrMetricKey = `${(0, $7webZ.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                if (window.SPA_STATE) {
                    // @ts-expect-error - TS2339 - Property 'startTime' does not exist on type 'unknown'. | TS2339 - Property 'duration' does not exist on type 'unknown'.
                    const { startTime: startTime = 0, duration: duration = 0 } = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))((0, $inC6u.getRenderTraceFromSSRGlobal)(), [
                        'traces',
                        `render/${tmpSsrMetricKey}`
                    ]) || {};
                    const markTime = startTime + duration;
                    markTime && markTime > 0 && segment.mark(metricKey, markTime);
                }
            }
        }), [
        segment
    ]);
};
const $0e0908bb9731ec35$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const navSegment = $0e0908bb9731ec35$export$906025848d54198d(segmentKey);
    (0, $eUqFw.useEffect)(()=>navSegment.mark(metricKey), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return null;
};
const $0e0908bb9731ec35$var$NavigationSSRPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const tmpSsrMetricKey = `${(0, $7webZ.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
    const navSegment = $0e0908bb9731ec35$export$906025848d54198d(segmentKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>navSegment.markSSR(metricKey), []);
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        type: "end",
        traceKey: tmpSsrMetricKey
    }) : null;
};
const $0e0908bb9731ec35$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
    const navSegment = $0e0908bb9731ec35$export$906025848d54198d(segmentKey);
    (0, $eUqFw.useEffect)(()=>{
        navSegment.stop({
            customData: {
                ...customData,
                userLocation: (0, $keguF.getUserLocation)()
            }
        });
        navSegment.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $0e0908bb9731ec35$export$b7f4caa65b0906fc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$2c4a101f2cde4fc2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationSSRPerformanceMark, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$c64b31449a6177d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$35b2aeea5cbc963e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$14f711a2cb6a655a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationSSRPerformanceMark, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$a018e347341b3640 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });

});
parcelRegister("inC6u", function(module, exports) {

$parcel$export(module.exports, "RenderTracerMark", () => $eba039e5967c438d$export$54c89059bb435049);
$parcel$export(module.exports, "getRenderTraceFromSSRGlobal", () => $eba039e5967c438d$export$345f21b0287f67e5);

var $eUqFw = parcelRequire("eUqFw");

var $aeTOI = parcelRequire("aeTOI");

var $illlw = parcelRequire("illlw");

var $9I5Lq = parcelRequire("9I5Lq");

var $WBLbN = parcelRequire("WBLbN");

const $eba039e5967c438d$var$initialState = {
    start: undefined,
    traces: {}
};
let $eba039e5967c438d$var$currentTraces = {};
const $eba039e5967c438d$export$2365ecd8218e21c7 = ()=>$eba039e5967c438d$var$currentTraces;
const $eba039e5967c438d$export$5c757eaa1990d0d7 = (key)=>{
    if ($eba039e5967c438d$var$currentTraces[key]) return;
    $eba039e5967c438d$var$currentTraces[key] = {
        startTime: (0, $9I5Lq.performance).now()
    };
};
const $eba039e5967c438d$export$16854dc18f8d976 = (key)=>{
    if (!$eba039e5967c438d$var$currentTraces[key] || $eba039e5967c438d$var$currentTraces[key].duration != null) return;
    $eba039e5967c438d$var$currentTraces[key].duration = (0, $9I5Lq.performance).now() - $eba039e5967c438d$var$currentTraces[key].startTime;
};
const $eba039e5967c438d$var$actions = {
    startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            // If <RenderTracerContainer /> has not been setup with a startKey and startTime, return
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            if (traces[key]) return;
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($aeTOI)))({}, traces, {
                    [key]: {
                        startTime: time
                    }
                })
            });
        },
    endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            const trace = traces[key] || {
                startTime: 0
            };
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($aeTOI)))({}, traces, {
                    [key]: {
                        ...trace,
                        duration: time - trace.startTime
                    }
                })
            });
            $eba039e5967c438d$var$currentTraces = Object.assign($eba039e5967c438d$var$currentTraces, getState().traces);
        }
};
const $eba039e5967c438d$var$Store = (0, $WBLbN.createStore)({
    name: 'jira-render-tracer',
    initialState: $eba039e5967c438d$var$initialState,
    actions: $eba039e5967c438d$var$actions
});
const $eba039e5967c438d$var$RenderTracerActions = (0, $WBLbN.createSubscriber)($eba039e5967c438d$var$Store, {
    selector: null
});
const $eba039e5967c438d$export$719a95758870be58 = (0, $WBLbN.createHook)($eba039e5967c438d$var$Store, {
    selector: null
});
const $eba039e5967c438d$var$RenderTracerContainerBase = (0, $WBLbN.createContainer)($eba039e5967c438d$var$Store, {
    onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
            setState({
                start: startTime,
                traces: {
                    [startKey]: {
                        startTime: (0, $9I5Lq.performance).now()
                    }
                }
            });
        }
});
const $eba039e5967c438d$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eba039e5967c438d$var$RenderTracerContainerBase, {
        startKey: startKey,
        startTime: startTime
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eba039e5967c438d$export$54c89059bb435049, {
        traceKey: startKey,
        type: "end"
    }));
const $eba039e5967c438d$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eba039e5967c438d$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
        if (type === 'start') startTrace(traceKey, (0, $9I5Lq.performance).now());
        else if (type === 'end') endTrace(traceKey, (0, $9I5Lq.performance).now());
        return null;
    });
const $eba039e5967c438d$export$cba8addc8743389c = (appName = 'unknown', traces = $eba039e5967c438d$var$currentTraces)=>({
        [(0, $98d270000c5bb498$export$3c96fa14fb694e11)]: {
            data: {
                traces: traces,
                routeName: appName
            }
        }
    });
const $eba039e5967c438d$export$345f21b0287f67e5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
        (0, $98d270000c5bb498$export$3c96fa14fb694e11),
        'data'
    ], {});

});
parcelRegister("9I5Lq", function(module, exports) {

$parcel$export(module.exports, "performance", () => $cb19fd4c8632f94b$export$f2d2284f5fec51f8);
const $cb19fd4c8632f94b$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
class $cb19fd4c8632f94b$export$9a0dbed22cbf63be {
    start() {
        if (false) this.startAt = $cb19fd4c8632f94b$var$now();
    }
    now() {
        if (false) return $cb19fd4c8632f94b$var$now() - this.startAt;
        return $cb19fd4c8632f94b$var$now();
    }
    constructor(){
        this.startAt = $cb19fd4c8632f94b$var$now();
    }
}
const $cb19fd4c8632f94b$export$f2d2284f5fec51f8 = new $cb19fd4c8632f94b$export$9a0dbed22cbf63be();

});

const $98d270000c5bb498$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';


parcelRegister("7webZ", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", () => $ba1c37c8f1f8f79b$export$6635720e40ea7a7a);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", () => $ba1c37c8f1f8f79b$export$1d3c3cb357af0e86);
$parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", () => $ba1c37c8f1f8f79b$export$e7a14fa81b3c6488);
$parcel$export(module.exports, "NAVIGATION_TOP_MARKS", () => $ba1c37c8f1f8f79b$export$ad760bb9734bf93f);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", () => $ba1c37c8f1f8f79b$export$1d10ee0c85c3cb21);
const $ba1c37c8f1f8f79b$export$6635720e40ea7a7a = 'navigation.top';
const $ba1c37c8f1f8f79b$export$1d3c3cb357af0e86 = 'navigation.sidebar';
const $ba1c37c8f1f8f79b$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
const $ba1c37c8f1f8f79b$export$ad760bb9734bf93f = {
    renderStart: 'navigation-top.render.start',
    renderEnd: 'navigation-top.render.end',
    renderSsrStart: 'navigation-top.render.ssr.start',
    renderSsrEnd: 'navigation-top.render.ssr.end',
    bundleLoadStart: 'navigation-top.bundle-load.start'
};
const $ba1c37c8f1f8f79b$export$1d10ee0c85c3cb21 = {
    renderAttempt: 'navigation-sidebar.render.attempt',
    renderStart: 'navigation-sidebar.render.start',
    renderEnd: 'navigation-sidebar.render.end',
    renderSsrStart: 'navigation-sidebar.render.ssr.start',
    renderSsrEnd: 'navigation-sidebar.render.ssr.end',
    loadStart: 'navigation-sidebar.load.start',
    loadEnd: 'navigation-sidebar.load.end'
};

});


parcelRegister("4ksts", function(module, exports) {

$parcel$export(module.exports, "useIntlV2", () => $32efc9cfc8f5c011$export$d82607073b68786);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");
const $32efc9cfc8f5c011$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $5JgJ2.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $eUqFw.useMemo)(()=>{
        const modifiedIntl = {
            // Now is deprecated since version 2: https://github.com/formatjs/formatjs/issues/1409
            now: ()=>Date.now(),
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatNumber: formatNumber,
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});

parcelRegister("7zhpa", function(module, exports) {

$parcel$export(module.exports, "sidebarNav4Resource", () => $57db5858a67a5074$export$7648dc6f76f4f83d);
$parcel$export(module.exports, "sidebarNav4UiStateResource", () => $57db5858a67a5074$export$a46129bd512544d7);

var $4ursw = parcelRequire("4ursw");

var $4ZjUB = parcelRequire("4ZjUB");

var $7uCfF = parcelRequire("7uCfF");

var $buJlM = parcelRequire("buJlM");

var $hkmE9 = parcelRequire("hkmE9");

var $bckG1 = parcelRequire("bckG1");
const $57db5858a67a5074$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
const $57db5858a67a5074$export$7648dc6f76f4f83d = (0, $buJlM.createRelayResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${$57db5858a67a5074$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const initialSelectedPath = (0, $4ZjUB.getInitialSelectedPath)(routerContext);
        // console.log('Route name', routerContext.route.name);
        return {
            parameters: (0, $hkmE9.default),
            variables: {
                cloudId: cloudId,
                isAppsExpanded: (0, $7uCfF.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_APPS)),
                isDashboardsExpanded: (0, $7uCfF.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_DASHBOARDS)),
                isFiltersExpanded: (0, $7uCfF.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $7uCfF.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $7uCfF.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $7uCfF.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_OPERATIONS))
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});
const $57db5858a67a5074$export$a46129bd512544d7 = (0, $buJlM.createRelayResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_SIDEBAR_V2_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $bckG1.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("4ursw", function(module, exports) {

$parcel$export(module.exports, "CONFIGURABLE_MENU_ID", () => $520542fb506bd92b$export$7838b734e4cd5e8d);
$parcel$export(module.exports, "ENTITY_ID", () => $520542fb506bd92b$export$103ff18fe29ee1b);
$parcel$export(module.exports, "MENU_ID_APPS", () => $520542fb506bd92b$export$441cd608ea3204f4);
$parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", () => $520542fb506bd92b$export$5baa9c2e3c3931c5);
$parcel$export(module.exports, "MENU_ID_ASSETS", () => $520542fb506bd92b$export$75c65bfc98b3a6e1);
$parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", () => $520542fb506bd92b$export$8a0af92d49f1d13d);
$parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", () => $520542fb506bd92b$export$a09300d15acc958a);
$parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", () => $520542fb506bd92b$export$4d718fbd418eef5c);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS", () => $520542fb506bd92b$export$dd009509c2dabb5e);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", () => $520542fb506bd92b$export$d3da0455b4200fb2);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", () => $520542fb506bd92b$export$b9dd2b5309d19763);
$parcel$export(module.exports, "MENU_ID_FILTERS", () => $520542fb506bd92b$export$3d81af172a8e3c57);
$parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", () => $520542fb506bd92b$export$1e2599eaf0039a97);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", () => $520542fb506bd92b$export$53d274d993c9d5b5);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", () => $520542fb506bd92b$export$7661ea763be69cfa);
$parcel$export(module.exports, "MENU_ID_GOALS", () => $520542fb506bd92b$export$47c6ce6a83a59eab);
$parcel$export(module.exports, "MENU_ID_OPERATIONS", () => $520542fb506bd92b$export$ef89639b7d9c162a);
$parcel$export(module.exports, "MENU_ID_OPS_ALERTS", () => $520542fb506bd92b$export$af4ab6d4e920522a);
$parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", () => $520542fb506bd92b$export$25c40acb2c53a294);
$parcel$export(module.exports, "MENU_ID_OPS_REPORTS", () => $520542fb506bd92b$export$c7d8892f1628b844);
$parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", () => $520542fb506bd92b$export$bb19a52e3df99541);
$parcel$export(module.exports, "MENU_ID_OVERVIEWS", () => $520542fb506bd92b$export$3bd12c092f8db11b);
$parcel$export(module.exports, "MENU_ID_PLANS", () => $520542fb506bd92b$export$f2533da33c749933);
$parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", () => $520542fb506bd92b$export$8468c5b6648f4f1f);
$parcel$export(module.exports, "MENU_ID_PROJECT_APPS", () => $520542fb506bd92b$export$fed17b4c0866b97d);
$parcel$export(module.exports, "MENU_ID_PROJECTS", () => $520542fb506bd92b$export$9c5278bd360a285);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", () => $520542fb506bd92b$export$85389c606bb641dd);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", () => $520542fb506bd92b$export$4a1974b63c858e9c);
$parcel$export(module.exports, "MENU_ID_RECENT", () => $520542fb506bd92b$export$692b796030a796f3);
$parcel$export(module.exports, "MENU_ID_ROADMAPS", () => $520542fb506bd92b$export$cdc80d4b5ce0c6a);
$parcel$export(module.exports, "MENU_ID_STARRED", () => $520542fb506bd92b$export$5637ca42a4d77f32);
$parcel$export(module.exports, "MENU_ID_TEAMS", () => $520542fb506bd92b$export$d4f6fcf571f9c50);
$parcel$export(module.exports, "MENU_ID_YOUR_WORK", () => $520542fb506bd92b$export$80dc576e446bdb6b);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", () => $520542fb506bd92b$export$79c15668ed799a1b);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", () => $520542fb506bd92b$export$e299bb06c4370c0d);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", () => $520542fb506bd92b$export$713b9b0a69a79cf9);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", () => $520542fb506bd92b$export$f1d9c0f27216aa1c);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", () => $520542fb506bd92b$export$45763fa331781074);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", () => $520542fb506bd92b$export$6ee20c845dbab3e3);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", () => $520542fb506bd92b$export$b3815dd180ce5e61);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", () => $520542fb506bd92b$export$100a1a639a0db980);
// These IDs are used with the user-customisable navigation service.
const $520542fb506bd92b$export$7838b734e4cd5e8d = {
    APPS: 'jira.sidebar.apps',
    ASSETS: 'jira.sidebar.assets',
    DASHBOARDS: 'jira.sidebar.dashboards',
    FILTERS: 'jira.sidebar.filters',
    GOALS: 'jira.sidebar.goals',
    OPERATIONS: 'jira.sidebar.operations',
    OVERVIEWS: 'jira.sidebar.overviews',
    PLANS: 'jira.sidebar.plans',
    PROJECTS: 'jira.sidebar.projects',
    RECENT: 'jira.sidebar.recent',
    STARRED: 'jira.sidebar.starred',
    TEAMS: 'jira.sidebar.teams',
    ROADMAPS: 'jira.sidebar.roadmaps'
};
const $520542fb506bd92b$export$103ff18fe29ee1b = {
    ALARM_QUEUE: (id)=>`alrm_${id}`,
    APP: (id)=>`app_${id}`,
    BOARD: (id)=>`boar_${id}`,
    DASHBOARD: (id)=>`dash_${id}`,
    FILTER: (id)=>`filt_${id}`,
    FORM: (id)=>`form_${id}`,
    OVERVIEW: (id)=>`over_${id}`,
    PLAN: (id)=>`plan_${id}`,
    PROJECT: (id)=>`proj_${id}`,
    PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
    PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
    PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
    PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
    PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
    PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
    PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
    PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
    PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
    PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
    PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
    PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
    PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
    PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
    PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
    PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
    QUEUE: (id)=>`queu_${id}`
}; // We MUST use the same IDs for the same components, otherwise we run into trouble (especially with peeking / more-menu)
const $520542fb506bd92b$export$441cd608ea3204f4 = $520542fb506bd92b$export$7838b734e4cd5e8d.APPS;
const $520542fb506bd92b$export$5baa9c2e3c3931c5 = 'app_mrkt';
const $520542fb506bd92b$export$75c65bfc98b3a6e1 = $520542fb506bd92b$export$7838b734e4cd5e8d.ASSETS;
const $520542fb506bd92b$export$8a0af92d49f1d13d = 'asst_schm';
const $520542fb506bd92b$export$a09300d15acc958a = 'asst_rprt';
const $520542fb506bd92b$export$4d718fbd418eef5c = 'board-view-all';
const $520542fb506bd92b$export$dd009509c2dabb5e = $520542fb506bd92b$export$7838b734e4cd5e8d.DASHBOARDS;
const $520542fb506bd92b$export$d3da0455b4200fb2 = 'dash-view';
const $520542fb506bd92b$export$b9dd2b5309d19763 = 'dash-view-starred';
const $520542fb506bd92b$export$3d81af172a8e3c57 = $520542fb506bd92b$export$7838b734e4cd5e8d.FILTERS;
const $520542fb506bd92b$export$1e2599eaf0039a97 = 'filt-search';
const $520542fb506bd92b$export$53d274d993c9d5b5 = 'filt-view-all';
const $520542fb506bd92b$export$7661ea763be69cfa = 'filt-view-starred';
const $520542fb506bd92b$export$47c6ce6a83a59eab = $520542fb506bd92b$export$7838b734e4cd5e8d.GOALS;
const $520542fb506bd92b$export$ef89639b7d9c162a = $520542fb506bd92b$export$7838b734e4cd5e8d.OPERATIONS;
const $520542fb506bd92b$export$af4ab6d4e920522a = 'ops-alrt';
const $520542fb506bd92b$export$25c40acb2c53a294 = 'ops-over';
const $520542fb506bd92b$export$c7d8892f1628b844 = 'ops-rprt';
const $520542fb506bd92b$export$bb19a52e3df99541 = 'ops-oncl';
const $520542fb506bd92b$export$3bd12c092f8db11b = $520542fb506bd92b$export$7838b734e4cd5e8d.OVERVIEWS;
const $520542fb506bd92b$export$f2533da33c749933 = $520542fb506bd92b$export$7838b734e4cd5e8d.PLANS;
const $520542fb506bd92b$export$8468c5b6648f4f1f = 'plan-view-all';
const $520542fb506bd92b$export$fed17b4c0866b97d = 'proj-app';
const $520542fb506bd92b$export$e682260eda678e61 = 'proj-dir';
const $520542fb506bd92b$export$9c5278bd360a285 = $520542fb506bd92b$export$7838b734e4cd5e8d.PROJECTS;
const $520542fb506bd92b$export$85389c606bb641dd = 'proj-view-all';
const $520542fb506bd92b$export$4a1974b63c858e9c = 'proj-view-starred';
const $520542fb506bd92b$export$692b796030a796f3 = $520542fb506bd92b$export$7838b734e4cd5e8d.RECENT;
const $520542fb506bd92b$export$cdc80d4b5ce0c6a = $520542fb506bd92b$export$7838b734e4cd5e8d.ROADMAPS;
const $520542fb506bd92b$export$5637ca42a4d77f32 = $520542fb506bd92b$export$7838b734e4cd5e8d.STARRED;
const $520542fb506bd92b$export$d4f6fcf571f9c50 = $520542fb506bd92b$export$7838b734e4cd5e8d.TEAMS;
const $520542fb506bd92b$export$80dc576e446bdb6b = 'yrwk';
const $520542fb506bd92b$export$79c15668ed799a1b = 'sd-sett-acc';
const $520542fb506bd92b$export$e299bb06c4370c0d = 'sd-sett-req-man';
const $520542fb506bd92b$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
const $520542fb506bd92b$export$f1d9c0f27216aa1c = 'sd-sett-aut';
const $520542fb506bd92b$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
const $520542fb506bd92b$export$6ee20c845dbab3e3 = 'sd-sett-not';
const $520542fb506bd92b$export$b3815dd180ce5e61 = 'sd-sett-apps';
const $520542fb506bd92b$export$100a1a639a0db980 = 'sd-sett-ops';

});

parcelRegister("4ZjUB", function(module, exports) {

$parcel$export(module.exports, "getInitialSelectedPath", () => $bb18282f63f50e0f$export$39f409bc5f59c5e);
/**
 * Why do we need the initialSelectedPath? It all stems from the workaround that Nav4 uses
 * to SSR the initial sidebar semi-correctly, while pretending to lazy-load everything else.
 *
 * Ideally we would be able to pre-load entrypoints that we know we need to load, and lazy-load
 * the rest. This would support SSR and be performant.
 * Unfortunately, unless all of the Jira routes are loaded via entry-points, we cannot use this approach.
 *
 * The workaround is to use Relay variables to tell Relay what data to preload, and then load
 * the corresponding UI component directly (not via an entrypoint) when we have the data for it.
 * When we don't have the preloaded data, we lazy load __the same component via an entrypoint__.
 * In other words, we sacrifice bundle size (by directly including the component for the data-available
 * case), in order to get SSR benefits.
 *
 * A consequence of this approach is we have two versions of the top-level menu item components - the
 * regular version (called *Landing) and the entrypoint version (called *Default). When navigating,
 * the router's state would change, causing the components to switch around. In the UI, this would
 * cause ExpandableMenuItem components to collapse, when they were open before navigating.
 *
 * To work around THIS problem, we store a computed-version of the initial state of the router, and
 * then query this value when deciding which component to show (the *Landing or the *Default). Because if
 * the initial state doesn't change, our components won't switch around after the first render.
 */ 
var $6l6Xk = parcelRequire("6l6Xk");

var $5RIdI = parcelRequire("5RIdI");
const $bb18282f63f50e0f$export$39f409bc5f59c5e = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))((0, $5RIdI.routeToSelectedPath));

});
parcelRegister("5RIdI", function(module, exports) {

$parcel$export(module.exports, "routeToSelectedPath", () => $1411adde11c4da4f$export$a92474c098a1fd13);

var $eI5EY = parcelRequire("eI5EY");

var $lFKDm = parcelRequire("lFKDm");

var $75qb3 = parcelRequire("75qb3");

var $g2zoD = parcelRequire("g2zoD");

var $9SW3e = parcelRequire("9SW3e");

var $9jOdG = parcelRequire("9jOdG");

var $3MZLo = parcelRequire("3MZLo");

var $8LvEn = parcelRequire("8LvEn");

var $7BjZJ = parcelRequire("7BjZJ");

var $hOEfe = parcelRequire("hOEfe");

var $aDEwR = parcelRequire("aDEwR");

var $aR7J8 = parcelRequire("aR7J8");
function $1411adde11c4da4f$export$a92474c098a1fd13(routeContext) {
    const routeName = routeContext.route.name;
    if ((0, $3MZLo.topLevelConverter).routes.has(routeName)) return (0, $3MZLo.topLevelConverter).convert(routeContext);
    if ((0, $lFKDm.appsConverter).routes.has(routeName)) return (0, $lFKDm.appsConverter).convert(routeContext);
    if ((0, $75qb3.assetsConverter).routes.has(routeName)) return (0, $75qb3.assetsConverter).convert(routeContext);
    if ((0, $g2zoD.dashboardsConverter).routes.has(routeName)) return (0, $g2zoD.dashboardsConverter).convert(routeContext);
    if ((0, $9SW3e.filtersConverter).routes.has(routeName)) return (0, $9SW3e.filtersConverter).convert(routeContext);
    if ((0, $9jOdG.operationsConverter).routes.has(routeName)) return (0, $9jOdG.operationsConverter).convert(routeContext);
    if ((0, $8LvEn.overviewsConverter).routes.has(routeName)) return (0, $8LvEn.overviewsConverter).convert(routeContext);
    if ((0, $8LvEn.overviewsConverter).routes.has(routeName)) return (0, $8LvEn.overviewsConverter).convert(routeContext);
    if ((0, $7BjZJ.plansConverter).routes.has(routeName)) return (0, $7BjZJ.plansConverter).convert(routeContext);
    if ((0, $hOEfe.projectsConverter).routes.has(routeName)) return (0, $hOEfe.projectsConverter).convert(routeContext);
    if ((0, $aDEwR.roadmapsConverter).routes.has(routeName)) return (0, $aDEwR.roadmapsConverter).convert(routeContext);
    if ((0, $eI5EY.fg)('jira_nav4_eap_drop_1')) {
        if ((0, $aR7J8.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $aR7J8.serviceManagementProjectSettingsConverter).convert(routeContext);
    }
    return [];
}

});
parcelRegister("lFKDm", function(module, exports) {

$parcel$export(module.exports, "appsConverter", () => $c2789d7f7235d366$export$d017a63045c88c47);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
// TODO: verify these routes
const $c2789d7f7235d366$var$UNCERTAIN_APPS_SECTION_ROUTES = [
    (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL),
    (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_INVALID),
    (0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_GENERAL),
    (0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
    /**
	 * This one tricky, and I wish it was documented somewhere, so here you go:
	 * Among different Connect app types, there are global Connect apps and JSM Connect apps (project apps).
	 * The URL of the global app looks like this:
	 *   `/plugins/servlet/ac/catlassian/catlassian-page?project.key=IP&project.id=10154`
	 * The URL of the JSM project app looks like this (there is also another URL pattern, but it is not relevant to this case):
	 *   `/plugins/servlet/ac/catlassian/catlassian-page-A?project.key=IP&project.id=10154&servicedesk.serviceDeskId=31`
	 * They have different route names and differ only by the `servicedesk.serviceDeskId` query parameter.
	 * But here's the catch: the global app URL can also contain a `servicedesk.serviceDeskId` query parameter,
	 * it is enough for the user to navigate to a specific JSM route in order for that JSM project to be saved as the most recent project,
	 * and it looks like Connect adds that most recent project context to the URL.
	 * Once that happens, the global app route is no longer matched, the JSM one is, which brings a lot of confusion since at this point
	 * we have no idea whether the "Apps" section should be expanded or the "Projects" one, since it is possible the app lives in either of those.
	 * You can navigate to the JSW project in order to override the JSM one and that query param will disappear from the global app URL.
	 * So what we are doing here? We are adding the route to the list of global Connect apps (just like its route name suggests) and potentially return a false positive value.
	 * Later on in the code we are going to check whether the app is global or not based on the data we have (the list of apps) and fix that.
	 */ (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
    (0, $exb0h.ROUTE_NAMES_CONNECT_PROJECT)
];
const $c2789d7f7235d366$var$CERTAIN_APPS_SECTION_ROUTES = [
    (0, $exb0h.ROUTE_NAMES_FORGE_GLOBAL),
    (0, $exb0h.ROUTE_NAMES_MARKETPLACE_INDEX)
];
const $c2789d7f7235d366$export$66b32f6f30eb4b4 = new Set([
    ...$c2789d7f7235d366$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$c2789d7f7235d366$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $c2789d7f7235d366$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_APPS)
    ];
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_MARKETPLACE_INDEX:
            path.push((0, $4ursw.MENU_ID_APP_MARKETPLACE_DISCOVER));
            break;
        case 0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL:
        case 0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_INVALID:
        case 0, $exb0h.ROUTE_NAMES_FORGE_GLOBAL:
        case 0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_GENERAL:
            path.push((0, $4ursw.ENTITY_ID).APP(match.url.replace(/\/$/, '')));
            break;
        case 0, $exb0h.ROUTE_NAMES_CONNECT_PROJECT:
        case 0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_PROJECT:
            {
                const { projectKey: projectKey } = match.params;
                return [
                    (0, $4ursw.MENU_ID_PROJECTS),
                    (0, $4ursw.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        case 0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT:
            {
                const { projectKey: projectKey } = query;
                return [
                    (0, $4ursw.MENU_ID_PROJECTS),
                    (0, $4ursw.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        default:
            break;
    }
    return path;
}
const $c2789d7f7235d366$export$d017a63045c88c47 = {
    routes: $c2789d7f7235d366$export$66b32f6f30eb4b4,
    convert: $c2789d7f7235d366$var$convert
};

});

parcelRegister("75qb3", function(module, exports) {

$parcel$export(module.exports, "assetsConverter", () => $0d6ff1587c3c6377$export$6cfeba0849032a84);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $0d6ff1587c3c6377$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION)
]);
function $0d6ff1587c3c6377$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    // const { match } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_ASSETS)
    ];
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION:
            path.push((0, $4ursw.MENU_ID_ASSETS_SCHEMAS));
            break;
        // Duplicate route-names of the above routes
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION:
            path.push((0, $4ursw.MENU_ID_ASSETS_SCHEMAS));
            break;
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE:
            path.push((0, $4ursw.MENU_ID_ASSETS_REPORTS));
            break;
        default:
            break;
    }
    return path;
}
const $0d6ff1587c3c6377$export$6cfeba0849032a84 = {
    routes: $0d6ff1587c3c6377$var$routes,
    convert: $0d6ff1587c3c6377$var$convert
};

});

parcelRegister("g2zoD", function(module, exports) {

$parcel$export(module.exports, "dashboardsConverter", () => $d7c859492cb29c5d$export$6468819b4be328b1);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $d7c859492cb29c5d$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_DASHBOARD_EDIT),
    (0, $exb0h.ROUTE_NAMES_DASHBOARD_VIEW),
    (0, $exb0h.ROUTE_NAMES_DASHBOARD_WALLBOARD)
]);
function $d7c859492cb29c5d$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_DASHBOARDS)
    ];
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY:
            path.push((0, $4ursw.MENU_ID_DASHBOARDS_VIEW_ALL));
            break;
        case 0, $exb0h.ROUTE_NAMES_DASHBOARD_WALLBOARD:
            query.dashboardId && path.push((0, $4ursw.ENTITY_ID).DASHBOARD(query.dashboardId));
            break;
        default:
            {
                const dashboardId = match.params.dashboardId;
                if (dashboardId === 'last-visited') // This is not really correct. The problem is we cannot tell what the true dashboardId is in this case.
                path.push((0, $4ursw.MENU_ID_DASHBOARDS_VIEW_ALL));
                else dashboardId && path.push((0, $4ursw.ENTITY_ID).DASHBOARD(dashboardId));
                break;
            }
    }
    return path;
}
const $d7c859492cb29c5d$export$6468819b4be328b1 = {
    routes: $d7c859492cb29c5d$var$routes,
    convert: $d7c859492cb29c5d$var$convert
};

});

parcelRegister("9SW3e", function(module, exports) {

$parcel$export(module.exports, "filtersConverter", () => $d5c0946d693dd4a7$export$6e91331b5debb7c8);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $d5c0946d693dd4a7$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_ISSUE),
    (0, $exb0h.ROUTE_NAMES_LEGACY_GIN),
    (0, $exb0h.ROUTE_NAMES_LEGACY_GIN_ISSUE),
    (0, $exb0h.ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS)
]);
function $d5c0946d693dd4a7$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query, match: match } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_FILTERS)
    ];
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY:
            path.push((0, $4ursw.MENU_ID_FILTERS_VIEW_ALL));
            break;
        case 0, $exb0h.ROUTE_NAMES_ISSUE:
            {
                const filterId = query.filter || query.filterId;
                if (filterId) path.push((0, $4ursw.ENTITY_ID).FILTER(filterId));
                else if (match.params?.issueKey) {
                    const [projectKey] = (match.params?.issueKey || '').split('-'); // For this route to match, the issueKey will never be blank
                    return [
                        (0, $4ursw.MENU_ID_PROJECTS),
                        (0, $4ursw.ENTITY_ID).PROJECT(projectKey)
                    ];
                }
                break;
            }
        default:
            {
                const filterId = query.filter || query.filterId;
                // Search filters URL
                if (filterId === undefined) path.push((0, $4ursw.MENU_ID_FILTERS_SEARCH));
                else // The rest of the URLs are using a filter ID.
                // Test this case: https://buglow-jsw.jira-dev.com/secure/ViewSubscriptions.jspa?filterId=10007
                path.push((0, $4ursw.ENTITY_ID).FILTER(filterId));
                break;
            }
    }
    return path;
}
const $d5c0946d693dd4a7$export$6e91331b5debb7c8 = {
    routes: $d5c0946d693dd4a7$var$routes,
    convert: $d5c0946d693dd4a7$var$convert
};

});

parcelRegister("9jOdG", function(module, exports) {

$parcel$export(module.exports, "operationsConverter", () => $75fe864bd94cd3f5$export$7fc92455d5020e1);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $75fe864bd94cd3f5$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_EOC_AUTOMATIONS),
    (0, $exb0h.ROUTE_NAMES_EOC_CUSTOM_ROLES),
    (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_ALERTS),
    (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_REPORTS),
    (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD),
    (0, $exb0h.ROUTE_NAMES_EOC_HEARTBEATS),
    (0, $exb0h.ROUTE_NAMES_EOC_MAINTENANCE),
    (0, $exb0h.ROUTE_NAMES_EOC_ON_CALL),
    (0, $exb0h.ROUTE_NAMES_EOC_ON_CALL_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_EOC_OVERVIEW),
    (0, $exb0h.ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS),
    (0, $exb0h.ROUTE_NAMES_EOC_PERMISSIONS),
    (0, $exb0h.ROUTE_NAMES_EOC_REPORTS),
    (0, $exb0h.ROUTE_NAMES_EOC_REPORTS_TEAM),
    (0, $exb0h.ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERTS),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATIONS),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_POLICIES),
    (0, $exb0h.ROUTE_NAMES_EOC_WHO_IS_ON_CALL)
]);
function $75fe864bd94cd3f5$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_OPERATIONS)
    ];
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_EOC_WHO_IS_ON_CALL:
            path.push((0, $4ursw.MENU_ID_OPS_ON_CALL));
            break;
        case 0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_ALERTS:
        case 0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL:
            {
                path.push((0, $4ursw.MENU_ID_OPS_ALERTS));
                const { query: alarmQueue = '', view: view } = query;
                view && path.push((0, $4ursw.ENTITY_ID).ALARM_QUEUE(alarmQueue));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_REPORTS:
        case 0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD:
        case 0, $exb0h.ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE:
            path.push((0, $4ursw.MENU_ID_OPS_REPORTS));
            break;
        case 0, $exb0h.ROUTE_NAMES_EOC_AUTOMATIONS:
        case 0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL:
        case 0, $exb0h.ROUTE_NAMES_EOC_HEARTBEATS:
        case 0, $exb0h.ROUTE_NAMES_EOC_MAINTENANCE:
        case 0, $exb0h.ROUTE_NAMES_EOC_PERMISSIONS:
        case 0, $exb0h.ROUTE_NAMES_EOC_ON_CALL:
        case 0, $exb0h.ROUTE_NAMES_EOC_ON_CALL_REDIRECT:
        case 0, $exb0h.ROUTE_NAMES_EOC_OVERVIEW:
        case 0, $exb0h.ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS:
        case 0, $exb0h.ROUTE_NAMES_EOC_REPORTS:
        case 0, $exb0h.ROUTE_NAMES_EOC_REPORTS_TEAM:
        case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL:
        case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERTS:
        case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS:
        case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_POLICIES:
        case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING:
        case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE:
        case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL:
        case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATIONS:
        case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE:
        case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL:
        case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST:
        case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG:
            path.push((0, $4ursw.MENU_ID_OPS_OVERVIEW));
            break;
        default:
            break;
    }
    return path;
}
const $75fe864bd94cd3f5$export$7fc92455d5020e1 = {
    routes: $75fe864bd94cd3f5$var$routes,
    convert: $75fe864bd94cd3f5$var$convert
};

});

parcelRegister("3MZLo", function(module, exports) {

$parcel$export(module.exports, "topLevelConverter", () => $402f0b0f1023de30$export$a33f2d74a674bf8a);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $402f0b0f1023de30$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_YOUR_WORK),
    // ROUTE_NAMES_HOME_ONBOARDING_REDIRECT,
    // ROUTE_NAMES_HOME_REDIRECT
    (0, $exb0h.ROUTE_NAMES_PEOPLE_INDEX)
]);
function $402f0b0f1023de30$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_YOUR_WORK:
            path.push((0, $4ursw.MENU_ID_YOUR_WORK));
            break;
        case 0, $exb0h.ROUTE_NAMES_PEOPLE_INDEX:
            path.push((0, $4ursw.MENU_ID_TEAMS));
            break;
        default:
    }
    return path;
}
const $402f0b0f1023de30$export$a33f2d74a674bf8a = {
    routes: $402f0b0f1023de30$var$routes,
    convert: $402f0b0f1023de30$var$convert
};

});

parcelRegister("8LvEn", function(module, exports) {

$parcel$export(module.exports, "overviewsConverter", () => $3ba3852524f3e101$export$5469f6c6536ca9c5);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $3ba3852524f3e101$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE)
]);
function $3ba3852524f3e101$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_OVERVIEWS)
    ];
    routeName;
    {
        const { overviewId: overviewId } = match.params;
        overviewId && path.push((0, $4ursw.ENTITY_ID).OVERVIEW(overviewId));
    }
    return path;
}
const $3ba3852524f3e101$export$5469f6c6536ca9c5 = {
    routes: $3ba3852524f3e101$var$routes,
    convert: $3ba3852524f3e101$var$convert
};

});

parcelRegister("7BjZJ", function(module, exports) {

$parcel$export(module.exports, "plansConverter", () => $d3b6f17b8e8d1e0a$export$3bde637b58016d1);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $d3b6f17b8e8d1e0a$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_PLANS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_RELEASES),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_TEAMS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE),
    (0, $exb0h.ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK)
]);
function $d3b6f17b8e8d1e0a$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_PLANS)
    ];
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_PLANS_DIRECTORY:
        case 0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT:
            path.push((0, $4ursw.MENU_ID_PLANS_VIEW_ALL));
            break;
        case 0, $exb0h.ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK:
            break;
        default:
            {
                const { planId: planId } = match.params;
                planId && path.push((0, $4ursw.ENTITY_ID).PLAN(planId));
            }
    }
    return path;
}
const $d3b6f17b8e8d1e0a$export$3bde637b58016d1 = {
    routes: $d3b6f17b8e8d1e0a$var$routes,
    convert: $d3b6f17b8e8d1e0a$var$convert
};

});

parcelRegister("hOEfe", function(module, exports) {

$parcel$export(module.exports, "projectsConverter", () => $b1a5de79b6d642fd$export$c41b724886e5872b);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $b1a5de79b6d642fd$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_LEGACY_ALL_REPORTS),
    (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
    (0, $exb0h.ROUTE_NAMES_PROJECT_COMPONENTS),
    (0, $exb0h.ROUTE_NAMES_PROJECT_NOT_FOUND),
    (0, $exb0h.ROUTE_NAMES_PROJECT_VERSIONS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
    // Apps
    (0, $exb0h.ROUTE_NAMES_FORGE_PROJECT),
    (0, $exb0h.ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE),
    // JPD
    (0, $exb0h.ROUTE_NAMES_POLARIS_IDEAS),
    (0, $exb0h.ROUTE_NAMES_POLARIS_ONBOARDING),
    // JSW
    (0, $exb0h.ROUTE_NAMES_OPSGENIE_SCHEDULE),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_PROJECT_PAGES),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_BACKLOG),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_CODE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_CODE_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_BUILDER),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_SUBMIT),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_GOALS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_INCIDENTS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PERISCOPE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REQUESTS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED),
    // JSM
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_LANDING),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SETUP),
    (0, $exb0h.ROUTE_NAMES_NOTIFICATION_LOGS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR_EAP),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ISSUES),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_NEW),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICES),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS),
    // JWM
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_ONBOARDING_GET_STARTED)
]);
function $b1a5de79b6d642fd$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_PROJECTS)
    ];
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_POLARIS_ONBOARDING:
            break;
        case 0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY:
            path.push((0, $4ursw.MENU_ID_PROJECTS_VIEW_ALL));
            break;
        case 0, $exb0h.ROUTE_NAMES_FORGE_PROJECT:
        case 0, $exb0h.ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE:
            {
                const { projectKey: projectKey, appId: appId } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $4ursw.MENU_ID_PROJECT_APPS));
                appId && path.push((0, $4ursw.ENTITY_ID).APP(appId));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_LANDING:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SETUP:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_NOTIFICATION_LOGS:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_SUMMARY(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS:
            {
                const { projectKey: projectKey, boardId: boardId } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_VIEWS(projectKey));
                boardId && path.push((0, $4ursw.ENTITY_ID).BOARD(boardId));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR_EAP:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_VIEWS(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_CALENDAR(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_REPORTS(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ISSUES:
            {
                const { projectKey: projectKey } = match.params;
                const filterId = query.filter || query.filterId;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                if (projectKey && filterId) {
                    path.push((0, $4ursw.ENTITY_ID).PROJECT_FILTERS(projectKey));
                    path.push((0, $4ursw.ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                }
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW:
            {
                const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && practiceType && path.push((0, $4ursw.ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                queueId && path.push((0, $4ursw.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_NEW:
            {
                const { projectKey: projectKey, queueId: queueId } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $4ursw.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICES:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_SERVICES(projectKey));
                break;
            }
        default:
            {
                const { projectKey: projectKey, boardId: boardId, formId: formId } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                boardId && path.push((0, $4ursw.ENTITY_ID).BOARD(boardId));
                formId && path.push((0, $4ursw.ENTITY_ID).FORM(formId));
            }
    }
    return path;
}
const $b1a5de79b6d642fd$export$c41b724886e5872b = {
    routes: $b1a5de79b6d642fd$var$routes,
    convert: $b1a5de79b6d642fd$var$convert
};

});

parcelRegister("aDEwR", function(module, exports) {

$parcel$export(module.exports, "roadmapsConverter", () => $f25eff9fe0f71c8f$export$5761942b1e0c2dd0);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $f25eff9fe0f71c8f$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_POLARIS_COLLECTIONS)
]);
function $f25eff9fe0f71c8f$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_POLARIS_COLLECTIONS:
            path.push((0, $4ursw.MENU_ID_ROADMAPS));
            break;
        default:
    }
    return path;
}
const $f25eff9fe0f71c8f$export$5761942b1e0c2dd0 = {
    routes: $f25eff9fe0f71c8f$var$routes,
    convert: $f25eff9fe0f71c8f$var$convert
};

});

parcelRegister("aR7J8", function(module, exports) {

$parcel$export(module.exports, "serviceManagementProjectSettingsConverter", () => $daf43b36be2916dc$export$dd307ede503fe0e);

var $exb0h = parcelRequire("exb0h");

var $EFSBh = parcelRequire("EFSBh");

var $fkRbQ = parcelRequire("fkRbQ");

var $eKJh0 = parcelRequire("eKJh0");

var $39wMP = parcelRequire("39wMP");

var $4AXWs = parcelRequire("4AXWs");

var $1HCPc = parcelRequire("1HCPc");

var $4ursw = parcelRequire("4ursw");
const $daf43b36be2916dc$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE),
    (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
    (0, $EFSBh.routeGroupsProjectSettingsLegacyAutomationRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskAccessRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskFeedbackRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskFieldsRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskChatRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskEmailRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskExternalLinksRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskPortalSettingsRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskWidgetRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskChangeManagementRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskIncidentManagementRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskClassicAppsRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsVirtualAgentSettingsRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsChatRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsWidgetRoute).name,
    (0, $EFSBh.virtualAgentConversationsRoute).name,
    (0, $EFSBh.virtualAgentIntentsRoute).name,
    (0, $EFSBh.virtualAgentSettingsRoute).name,
    (0, $EFSBh.virtualAgentStandardFlowsRoute).name,
    (0, $EFSBh.projectSettingsServicedeskNotificationsEmailRoute).name,
    (0, $EFSBh.projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskAppsFieldsRoute).name,
    (0, $fkRbQ.routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute).name,
    (0, $fkRbQ.routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
    (0, $eKJh0.routeGroupsProjectSettingsServicedeskKbRoute).name,
    (0, $4AXWs.routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).name,
    (0, $4AXWs.routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
    (0, $1HCPc.routeGroupsProjectSettingsWorkflowSchemeConfigRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskIssuetypesRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsPortalRoute).name,
    (0, $EFSBh.projectSettingsServicedeskAutomationRoute).name,
    (0, $39wMP.servicedeskSlaSettingsRoute).name,
    (0, $EFSBh.routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute).name
]);
function $daf43b36be2916dc$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    switch(routeName){
        // Access Menu
        case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskAccessRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
        case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS:
        case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY:
            path.push((0, $4ursw.MENU_ID_SD_SETTINGS_ACCESS));
            break;
        // Request Management -> Request types menu
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory).name:
        case (0, $4AXWs.routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
            path.push((0, $4ursw.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, $4ursw.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
            break;
        // Request Management
        case (0, $4AXWs.routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute).name:
        case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS:
        case (0, $1HCPc.routeGroupsProjectSettingsWorkflowSchemeConfigRoute).name:
        case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS:
        case (0, $39wMP.servicedeskSlaSettingsRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskFeedbackRoute).name:
        case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskIssuetypesRoute).name:
        case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskFieldsRoute).name:
        case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS:
            path.push((0, $4ursw.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
            break;
        // Automation
        case 0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION:
        case (0, $EFSBh.routeGroupsProjectSettingsLegacyAutomationRoute).name:
        case (0, $EFSBh.projectSettingsServicedeskAutomationRoute).name:
            path.push((0, $4ursw.MENU_ID_SD_SETTINGS_AUTOMATION));
            break;
        // Channels and self-service
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskPortalSettingsRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsPortalRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskEmailRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskChatRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskWidgetRoute).name:
        case (0, $eKJh0.routeGroupsProjectSettingsServicedeskKbRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskExternalLinksRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsChatRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsWidgetRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsVirtualAgentSettingsRoute).name:
        case (0, $EFSBh.virtualAgentIntentsRoute).name:
        case (0, $EFSBh.virtualAgentStandardFlowsRoute).name:
        case (0, $EFSBh.virtualAgentConversationsRoute).name:
        case (0, $EFSBh.virtualAgentSettingsRoute).name:
            // case issueCollectors.name:
            path.push((0, $4ursw.MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
            break;
        // Operations
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskChangeManagementRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskIncidentManagementRoute).name:
            path.push((0, $4ursw.MENU_ID_SD_SETTINGS_OPERATIONS));
            break;
        // Notifications
        case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS:
        case (0, $fkRbQ.routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
        case (0, $fkRbQ.routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
        case (0, $EFSBh.projectSettingsServicedeskNotificationsEmailRoute).name:
        case (0, $EFSBh.projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute).name:
            path.push((0, $4ursw.MENU_ID_SD_SETTINGS_NOTIFICATIONS));
            break;
        // Apps
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskClassicAppsRoute).name:
        case (0, $EFSBh.routeGroupsProjectSettingsServicedeskAppsFieldsRoute).name:
            // ADD rest of the apps here
            path.push((0, $4ursw.MENU_ID_SD_SETTINGS_APPS));
            break;
        default:
            break;
    }
    return path;
}
const $daf43b36be2916dc$export$dd307ede503fe0e = {
    routes: $daf43b36be2916dc$var$routes,
    convert: $daf43b36be2916dc$var$convert
};

});
parcelRegister("EFSBh", function(module, exports) {

$parcel$export(module.exports, "getJsmProjectSettingsUrl", () => $47655043d641f00b$export$b7cec47cdf9c76f1);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIssuetypesRoute", () => $47655043d641f00b$export$666cdeccf1f430a6);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIssuetypesWorkflowRoute", () => $47655043d641f00b$export$5ed718db41f9c966);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory", () => $47655043d641f00b$export$60b14f135c03f9c7);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFieldsRoute", () => $47655043d641f00b$export$87914ccacd42ab35);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAppsFieldsRoute", () => $47655043d641f00b$export$e382068c2b8a7b9f);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskApps1Route", () => $47655043d641f00b$export$7ae67c73ac5367a8);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskDetailsRoute", () => $47655043d641f00b$export$b237f4f6820b26e9);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAccessRoute", () => $47655043d641f00b$export$f7e149bf217bbb2c);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAccessRedirectRoute", () => $47655043d641f00b$export$eb1177fbc6c41b97);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute", () => $47655043d641f00b$export$f919d82b98f9257a);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskProformaJiraFormBuilderRoute", () => $47655043d641f00b$export$ce59d5cb98345f8e);
$parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", () => $47655043d641f00b$export$1a2228d5e07202a0);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskDataClassificationsRoute", () => $47655043d641f00b$export$1596046a0b047934);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskClassicAppsRoute", () => $47655043d641f00b$export$3ab501c22b91462b);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskItsmFeaturesRoute", () => $47655043d641f00b$export$324e5a618f1ac5a1);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute", () => $47655043d641f00b$export$e6f711e47860f891);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute", () => $47655043d641f00b$export$4ef3eecacde57780);
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", () => $47655043d641f00b$export$40539cb16771014e);
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", () => $47655043d641f00b$export$1f37a1aff4f594af);
$parcel$export(module.exports, "projectSettingsServicedeskNotifications1Route", () => $47655043d641f00b$export$18c6f3890d9fd8b8);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskLanguageKeyRoute", () => $47655043d641f00b$export$d195c572a6155c05);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskLanguage1Route", () => $47655043d641f00b$export$8152b460f5961d94);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute", () => $47655043d641f00b$export$e184fa302b6981b6);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute", () => $47655043d641f00b$export$dd22cfc45fe86c35);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsEmailNextGenRoute", () => $47655043d641f00b$export$b03f0a1a580a902f);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskEmailRoute", () => $47655043d641f00b$export$d29fa1140db9296d);
$parcel$export(module.exports, "routeGroupsProjectSettingsLegacyAutomationRoute", () => $47655043d641f00b$export$abc6508b4dce2d9b);
$parcel$export(module.exports, "routeGroupsProjectSettingsVirtualAgentSettingsRoute", () => $47655043d641f00b$export$680ccfe6e5af63a8);
$parcel$export(module.exports, "virtualAgentIntentsRoute", () => $47655043d641f00b$export$1e70273fc2a407f5);
$parcel$export(module.exports, "virtualAgentStandardFlowsRoute", () => $47655043d641f00b$export$f45c942ecfcc5682);
$parcel$export(module.exports, "virtualAgentConversationsRoute", () => $47655043d641f00b$export$837f003bb6f40f9);
$parcel$export(module.exports, "virtualAgentSettingsRoute", () => $47655043d641f00b$export$80422a49e17dfd6b);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPortalRoute", () => $47655043d641f00b$export$394d5ca6ce9e5949);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskPortalSettingsRoute", () => $47655043d641f00b$export$e856498dc02e46e8);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskExternalLinksRoute", () => $47655043d641f00b$export$d0198d2da30de212);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsWidgetRoute", () => $47655043d641f00b$export$fe54e02c94ff5613);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskWidgetRoute", () => $47655043d641f00b$export$164572fb58075291);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChangeManagementRoute", () => $47655043d641f00b$export$10089d339d8e30d1);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIncidentManagementRoute", () => $47655043d641f00b$export$ff20eaee6cf19401);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsChatRoute", () => $47655043d641f00b$export$8e2543080acfc7c2);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChatRoute", () => $47655043d641f00b$export$3a3e70b8651d8d57);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannels5Route", () => $47655043d641f00b$export$77d19d35e71558b3);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFeedbackRoute", () => $47655043d641f00b$export$cd46cad965f517e2);
$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRoute", () => $47655043d641f00b$export$10bafd1256118bb8);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskRedirectRoute", () => $47655043d641f00b$export$43b5b901d4988763);

var $exb0h = parcelRequire("exb0h");
const $47655043d641f00b$var$SERVICE_DESK_PRODUCT = 'servicedesk';
const $47655043d641f00b$export$b7cec47cdf9c76f1 = (projectKey)=>`/jira/${$47655043d641f00b$var$SERVICE_DESK_PRODUCT}/projects/${projectKey || ':projectKey'}/settings`;
const $47655043d641f00b$var$jsmProjectSettingsUrl = $47655043d641f00b$export$b7cec47cdf9c76f1();
const $47655043d641f00b$export$666cdeccf1f430a6 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/issuetypes/:issueTypeId?`,
    exact: true
};
const $47655043d641f00b$export$5ed718db41f9c966 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes-workflow`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/issuetypes/:issueTypeId/:initialSection(workflow)`,
    exact: true
};
const $47655043d641f00b$export$60b14f135c03f9c7 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-request-types-work-category`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/request-types/category/:practice`,
    exact: true
};
const $47655043d641f00b$export$87914ccacd42ab35 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-fields`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/fields`,
    exact: true
};
const $47655043d641f00b$export$e382068c2b8a7b9f = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-apps-fields`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/apps/app-fields`,
    exact: true
};
const $47655043d641f00b$export$7ae67c73ac5367a8 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-apps`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/apps/:appId?`,
    exact: true
};
const $47655043d641f00b$export$b237f4f6820b26e9 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_DETAILS),
    // /settings/details
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/details`,
    exact: true
};
const $47655043d641f00b$export$f7e149bf217bbb2c = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-access`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/access`,
    exact: true
};
const $47655043d641f00b$export$eb1177fbc6c41b97 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-access-redirect`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/people`,
    exact: true
};
const $47655043d641f00b$export$f919d82b98f9257a = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-proforma-project-forms`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/forms`,
    exact: true
};
const $47655043d641f00b$export$ce59d5cb98345f8e = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-proforma-jira-form-builder`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/forms/form/:templateFormId/edit`,
    exact: true
};
const $47655043d641f00b$export$1a2228d5e07202a0 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/automate`
};
const $47655043d641f00b$export$1596046a0b047934 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-data-classifications`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/data-classifications`,
    exact: true
};
const $47655043d641f00b$export$3ab501c22b91462b = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-classic-apps`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/apps`,
    exact: true
};
const $47655043d641f00b$export$324e5a618f1ac5a1 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-features`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/itsm-features`,
    exact: true
};
const $47655043d641f00b$export$e6f711e47860f891 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-notifications-internal-notifications`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/notifications/internal-notifications`
};
const $47655043d641f00b$export$4ef3eecacde57780 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN),
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/internal-notifications`
};
const $47655043d641f00b$export$40539cb16771014e = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL),
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/notifications/notification-email`,
    exact: true
};
const $47655043d641f00b$export$1f37a1aff4f594af = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATION_EMAIL),
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/notification-email`,
    exact: true
};
const $47655043d641f00b$export$18c6f3890d9fd8b8 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS),
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/notifications`,
    exact: true
};
const $47655043d641f00b$export$d195c572a6155c05 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-language-key`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/language/:languageKey/:sidebarItemKey?`
};
const $47655043d641f00b$export$8152b460f5961d94 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-language`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/language`,
    exact: true
};
const $47655043d641f00b$export$e184fa302b6981b6 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-permissions-next-gen`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/channels/customer-permissions`,
    exact: true
};
const $47655043d641f00b$export$dd22cfc45fe86c35 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_PERMISSIONS),
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/customer-permissions`,
    exact: true
};
const $47655043d641f00b$export$b03f0a1a580a902f = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-email-next-gen`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/channels/email`,
    exact: true
};
const $47655043d641f00b$export$d29fa1140db9296d = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS),
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/email`,
    exact: true
};
const $47655043d641f00b$export$abc6508b4dce2d9b = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/automation`,
    exact: true
};
const $47655043d641f00b$export$680ccfe6e5af63a8 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/virtual-agent`,
    exact: true
};
const $47655043d641f00b$export$1e70273fc2a407f5 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-intents`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/virtual-agent/intents`,
    exact: true
};
const $47655043d641f00b$export$f45c942ecfcc5682 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-standard-flows`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/virtual-agent/standard-flows`,
    exact: true
};
const $47655043d641f00b$export$837f003bb6f40f9 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-conversations`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/virtual-agent/conversations`,
    exact: true
};
const $47655043d641f00b$export$80422a49e17dfd6b = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-settings`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/virtual-agent/settings`,
    exact: true
};
const $47655043d641f00b$export$394d5ca6ce9e5949 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-portal`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/channels/portal-settings`,
    exact: true
};
const $47655043d641f00b$export$e856498dc02e46e8 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS),
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/portal-settings/:subPath(portal-groups)?`,
    exact: true
};
const $47655043d641f00b$export$d0198d2da30de212 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-external-links`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/external-links`,
    exact: true
};
const $47655043d641f00b$export$fe54e02c94ff5613 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-widget`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/channels/widget`,
    exact: true
};
const $47655043d641f00b$export$164572fb58075291 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_WIDGET_SETTINGS),
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/widget`,
    exact: true
};
const $47655043d641f00b$export$10089d339d8e30d1 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-change-management`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/change-management`,
    exact: true
};
const $47655043d641f00b$export$ff20eaee6cf19401 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-incident-management`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/incident-management`,
    exact: true
};
const $47655043d641f00b$export$8e2543080acfc7c2 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-chat`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/channels/chat`,
    exact: true
};
const $47655043d641f00b$export$3a3e70b8651d8d57 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT),
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/chat`,
    exact: true
};
const $47655043d641f00b$export$77d19d35e71558b3 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/channels`,
    exact: true
};
const $47655043d641f00b$export$cd46cad965f517e2 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-feedback`,
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/feedback-settings`
};
const $47655043d641f00b$export$10bafd1256118bb8 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS),
    path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/apps/:appId/:envId/:route?`
};
const $47655043d641f00b$export$43b5b901d4988763 = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-redirect`,
    path: $47655043d641f00b$var$jsmProjectSettingsUrl
};

});

parcelRegister("fkRbQ", function(module, exports) {

$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute", () => $3cae002c727972f0$export$7fc567ce6cdc6b52);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute", () => $3cae002c727972f0$export$688d2c8abd7b3661);

var $exb0h = parcelRequire("exb0h");
const $3cae002c727972f0$export$5575497f0592ee94 = 'servicedesk';
const $3cae002c727972f0$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $3cae002c727972f0$export$7fc567ce6cdc6b52 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_NOTIFICATIONS),
    path: `${$3cae002c727972f0$var$projectSettingsUrl($3cae002c727972f0$export$5575497f0592ee94)}/customer-notifications`
};
const $3cae002c727972f0$export$688d2c8abd7b3661 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-notifications-customer-notifications`,
    path: `${$3cae002c727972f0$var$projectSettingsUrl($3cae002c727972f0$export$5575497f0592ee94)}/notifications/customer-notifications`
};

});

parcelRegister("eKJh0", function(module, exports) {

$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskKbRoute", () => $33a9059fcebe7f73$export$8855316927afaed1);

var $exb0h = parcelRequire("exb0h");
const $33a9059fcebe7f73$export$5575497f0592ee94 = 'servicedesk';
const $33a9059fcebe7f73$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $33a9059fcebe7f73$export$8855316927afaed1 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-kb`,
    path: `${$33a9059fcebe7f73$var$projectSettingsUrl($33a9059fcebe7f73$export$5575497f0592ee94)}/confluence-kb`,
    exact: true
};

});

parcelRegister("39wMP", function(module, exports) {

$parcel$export(module.exports, "servicedeskSlaSettingsRoute", () => $b7932788ec438e72$export$bfbf66468910573e);

var $exb0h = parcelRequire("exb0h");
const $b7932788ec438e72$export$5575497f0592ee94 = 'servicedesk';
const $b7932788ec438e72$export$bfbf66468910573e = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
    path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
};

});

parcelRegister("4AXWs", function(module, exports) {

$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute", () => $9ded92290a75756e$export$cd0f363eecbc2379);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskItsmTicketTypesConfigRoute", () => $9ded92290a75756e$export$96fd54e139924473);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute", () => $9ded92290a75756e$export$1eebd582a7db1c90);

var $exb0h = parcelRequire("exb0h");
const $9ded92290a75756e$export$5575497f0592ee94 = 'servicedesk';
const $9ded92290a75756e$export$cd0f363eecbc2379 = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-unassigned-ticket-types-config`,
    path: `/jira/${$9ded92290a75756e$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/unassigned`
};
const $9ded92290a75756e$export$96fd54e139924473 = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-ticket-types-config`,
    path: `/jira/${$9ded92290a75756e$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/category/:practice`
};
const $9ded92290a75756e$export$1eebd582a7db1c90 = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-ticket-types-config`,
    path: `/jira/${$9ded92290a75756e$export$5575497f0592ee94}/projects/:projectKey/settings/request-types`
};

});

parcelRegister("1HCPc", function(module, exports) {

$parcel$export(module.exports, "routeGroupsProjectSettingsWorkflowSchemeConfigRoute", () => $dc22772ba6709c2c$export$ad30542ae2fd7196);

var $exb0h = parcelRequire("exb0h");
const $dc22772ba6709c2c$export$ad30542ae2fd7196 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-workflow-scheme-config`,
    path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
    exact: true
};

});




parcelRegister("buJlM", function(module, exports) {

$parcel$export(module.exports, "RELAY_RESOURCE_TYPE", () => $485f6c69495cf127$export$c6c8c12c0f1d8e54);
$parcel$export(module.exports, "createRelayResource", () => $485f6c69495cf127$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $485f6c69495cf127$export$42ca7b248c7aaee);

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $6iz4v = parcelRequire("6iz4v");

var $eI5EY = parcelRequire("eI5EY");

var $amu7D = parcelRequire("amu7D");

var $15ZJO = parcelRequire("15ZJO");

var $c7ifG = parcelRequire("c7ifG");

var $lB25E = parcelRequire("lB25E");

var $5udmX = parcelRequire("5udmX");
const $485f6c69495cf127$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $485f6c69495cf127$var$getDataOld = async ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
    const measureName = `relay_resource_get_data:${type}`;
    const startMark = `relay_resource_get_data:${type}:start`;
    const endMark = `relay_resource_get_data:${type}:end`;
    (0, $6iz4v.setMark)(startMark);
    const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
    // We either have a sync query or an async one from loadParameters. Never neither
    // This is enforced by 2 aliases of this method having different types, but Typescript cannot infer that neatly, so we cast away the nullable case.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const query = parameters ?? await loadParameters?.();
    // loadQuery returns not a Promise, but Observable.
    // Resource waits until query Observable is completed and returns a queryReference
    // later queryReference could be used by usePreloadedQuery
    const queryReference = (0, $6iz4v.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $iWLL0.loadQuery)((0, $amu7D.default)(), query, variables || {}, options));
    if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
    if (queryReference.id != null) (0, $c7ifG.QueryPromisesMap).get(queryReference.id)?.then(()=>{
        (0, $6iz4v.setMark)(endMark);
        (0, $6iz4v.setMeasure)(measureName, startMark, endMark);
    });
    /**
	 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
	 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
	 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
	 * as well as subsequent fetches made by route transitions between spa-apps.
	 */ if (captureErrors) (0, $15ZJO.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
    if (captureTraceIds) (0, $5udmX.startCapturingTraceIds)(queryReference.name);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return queryReference;
};
const $485f6c69495cf127$var$getDataNew = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
    const measureName = `relay_resource_get_data:${type}`;
    const startMark = `relay_resource_get_data:${type}:start`;
    const endMark = `relay_resource_get_data:${type}:end`;
    (0, $6iz4v.setMark)(startMark);
    const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
    // loadQuery returns not a Promise, but Observable.
    // Resource waits until query Observable is completed and returns a queryReference
    // later queryReference could be used by usePreloadedQuery
    const queryReference = (0, $6iz4v.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $iWLL0.loadQuery)((0, $amu7D.default)(), parameters, variables || {}, options));
    if (false && queryReference.id != null) {
        const promise = (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        if (promise) return promise.then(()=>{
            (0, $6iz4v.setMark)(endMark);
            (0, $6iz4v.setMeasure)(measureName, startMark, endMark);
            /**
				 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
				 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
				 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
				 * as well as subsequent fetches made by route transitions between spa-apps.
				 */ if (captureErrors) (0, $15ZJO.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $5udmX.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        });
    }
    if (queryReference.id != null) (0, $c7ifG.QueryPromisesMap).get(queryReference.id)?.then(()=>{
        (0, $6iz4v.setMark)(endMark);
        (0, $6iz4v.setMeasure)(measureName, startMark, endMark);
    });
    /**
	 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
	 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
	 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
	 * as well as subsequent fetches made by route transitions between spa-apps.
	 */ if (captureErrors) (0, $15ZJO.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
    if (captureTraceIds) (0, $5udmX.startCapturingTraceIds)(queryReference.name);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return queryReference;
};
const $485f6c69495cf127$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $lB25E.createResource)({
        type: `${$485f6c69495cf127$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            // sources: https://github.com/facebook/relay/blob/4b78c7dd27b286f9ee8f5b993ccb160163956999/packages/react-relay/relay-hooks/loadQuery.js#L273
            // @ts-expect-error - TS2339 - Property 'kind' does not exist on type 'GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>'.
            if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                const preloadableConcreteRequest = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                preloadableRequest;
                ({ params: params } = preloadableConcreteRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $cNy9K.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            if ((0, $eI5EY.fg)('blu-3813-improve-ssr-hydration-of-relay')) return $485f6c69495cf127$var$getDataNew({
                routerContext: routerContext,
                customContext: customContext,
                type: type,
                getQuery: getQuery,
                captureErrors: captureErrors,
                captureTraceIds: captureTraceIds
            });
            return $485f6c69495cf127$var$getDataOld({
                routerContext: routerContext,
                customContext: customContext,
                type: type,
                loadParameters: loadParameters,
                getQuery: getQuery,
                captureErrors: captureErrors,
                captureTraceIds: captureTraceIds
            });
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly
    });
const $485f6c69495cf127$export$1cc887c62079ea32 = $485f6c69495cf127$var$createRelayResourceImpl;
const $485f6c69495cf127$export$bbe949b85c06f763 = $485f6c69495cf127$var$createRelayResourceImpl;
const $485f6c69495cf127$export$42ca7b248c7aaee = (resource, options)=>{
    const { data: queryReference, loading: loading, promise: promise } = (0, $lB25E.useResource)(resource);
    if (options?.suspendWhenLoading && loading) throw promise;
    return {
        queryReference: queryReference
    };
};

});

parcelRegister("hkmE9", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ac2903ab7cc20b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<284e84868e5e4b27cf00060ccb7e1b66>>
 * @relayHash e239eb6ba87ede2db9a418c95f5caf6b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a1a0d3f1f06e24b9bacb1d1457e2544e05e12f69cd919d3dec153fc44ad26259
const $85ac2903ab7cc20b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isDashboardsExpanded"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v13 = {
        "kind": "ScalarField",
        "name": "url"
    }, v14 = {
        "order": "DESC"
    }, v15 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v16 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "name"
    }, v18 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v20 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v21 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v22 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v23 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v10 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "alias": "projectKey",
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectType"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        },
                        v17 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "projectId"
                        },
                        v18 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "typeKey"
                                        }
                                    ],
                                    "type": "JiraNavigationItem",
                                    "abstractKey": "__isJiraNavigationItem"
                                },
                                v19 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "navigationMetadata",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "boardId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSimpleBoard"
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "JiraSoftwareProjectNavigationMetadata"
                                }
                            ]
                        },
                        {
                            "alias": "editProjectConfig",
                            "args": v20 /*: any*/ ,
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": v21 /*: any*/ ,
                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectStyle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webUrl"
                        },
                        {
                            "alias": "canEditProjectConfig",
                            "args": v20 /*: any*/ ,
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": v21 /*: any*/ ,
                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                        },
                        {
                            "alias": "canViewProjectConfig",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "VIEW_PROJECT_CONFIG"
                                }
                            ],
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": v21 /*: any*/ ,
                            "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                        },
                        v22 /*: any*/ ,
                        {
                            "args": v20 /*: any*/ ,
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": v21 /*: any*/ ,
                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "softwareBoardCount"
                        }
                    ],
                    "type": "JiraProject"
                },
                v19 /*: any*/ 
            ]
        }
    ], v24 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v25 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v7 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v28 = {
        "kind": "ScalarField",
        "name": "title"
    }, v29 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            v18 /*: any*/ ,
            v7 /*: any*/ 
        ]
    }, v30 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v10 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        v28 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        v29 /*: any*/ ,
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v19 /*: any*/ 
            ]
        }
    ], v31 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v10 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "dashboardId"
                        },
                        v28 /*: any*/ ,
                        v29 /*: any*/ 
                    ],
                    "type": "JiraDashboard"
                },
                v19 /*: any*/ 
            ]
        }
    ], v32 = [
        v7 /*: any*/ ,
        v17 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ConfigurableMenuItems"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudID",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "navKey",
                                    "value": "NAV_SIDEBAR"
                                }
                            ],
                            "concreteType": "JiraUserNavigationConfiguration",
                            "kind": "LinkedField",
                            "name": "userNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraConfigurableNavigationItem",
                                    "kind": "LinkedField",
                                    "name": "navItems",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "menuId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isVisible"
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "globalAppNavigationItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "envLabel"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppSection",
                                                                    "kind": "LinkedField",
                                                                    "name": "sections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "settingsUrl"
                                                                },
                                                                v13 /*: any*/ 
                                                            ],
                                                            "type": "JiraAppNavigationItem"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraAdvancedRoadmapsNavigation",
                            "kind": "LinkedField",
                            "name": "advancedRoadmapsNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasEditPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCreateSamplePlanPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasGlobalPlansAdminPermissions"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isProjectsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteProjects",
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v14 /*: any*/ ,
                                                "type": "PROJECT"
                                            }
                                        },
                                        v15 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v23 /*: any*/ 
                                        },
                                        v22 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentProjects",
                                    "args": [
                                        v8 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PROJECT"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v23 /*: any*/ 
                                        },
                                        v22 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementLicensing",
                                    "kind": "LinkedField",
                                    "name": "jwmLicensing",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "currentUserSeatEdition"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v14 /*: any*/ ,
                                                "type": "FILTER"
                                            }
                                        },
                                        v15 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                v17 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v18 /*: any*/ ,
                                                                v26 /*: any*/ ,
                                                                v27 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentFilters",
                                    "args": [
                                        v8 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "FILTER"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ],
                                                            "type": "JiraCustomFilter"
                                                        },
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraSystemFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "systemFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                v18 /*: any*/ ,
                                                                v26 /*: any*/ ,
                                                                v27 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouritePlans",
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v14 /*: any*/ ,
                                                "type": "PLAN"
                                            }
                                        },
                                        v15 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v30 /*: any*/ 
                                        },
                                        v22 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentPlans",
                                    "args": [
                                        v8 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PLAN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v30 /*: any*/ 
                                        },
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isDashboardsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "dashboardFavourites",
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v14 /*: any*/ ,
                                                "type": "DASHBOARD"
                                            }
                                        },
                                        v15 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v31 /*: any*/ 
                                        },
                                        v22 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "dashboardRecents",
                                    "args": [
                                        v8 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "DASHBOARD"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v31 /*: any*/ 
                                        },
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOperationsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "OpsgenieQuery",
                            "kind": "LinkedField",
                            "name": "opsgenie",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "OpsgenieSavedSearches",
                                    "kind": "LinkedField",
                                    "name": "savedSearches",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": v32 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": v32 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a1a0d3f1f06e24b9bacb1d1457e2544e05e12f69cd919d3dec153fc44ad26259",
            "metadata": {},
            "name": "L1MenuItemsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$85ac2903ab7cc20b$var$node.hash = "301906cf56b46d61420af572d827d1a7";
var $85ac2903ab7cc20b$export$2e2bcd8739ae039 = $85ac2903ab7cc20b$var$node;

});


parcelRegister("u0mbR", function(module, exports) {

$parcel$export(module.exports, "SidebarStart", () => $b1949a81125e9848$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarRenderStart", () => $b1949a81125e9848$export$ba19e3624956e66);
$parcel$export(module.exports, "SidebarReady", () => $b1949a81125e9848$export$a06ecbbe5820282);
$parcel$export(module.exports, "useSidebarFail", () => $b1949a81125e9848$export$661ed14c8f75da9f);
$parcel$export(module.exports, "useSidebarSuccess", () => $b1949a81125e9848$export$ddb17534fdfb7dc6);

var $eUqFw = parcelRequire("eUqFw");

var $8fxTv = parcelRequire("8fxTv");

var $7webZ = parcelRequire("7webZ");

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $jmt32 = parcelRequire("jmt32");

var $10fdS = parcelRequire("10fdS");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3O0Td = parcelRequire("3O0Td");

var $lB25E = parcelRequire("lB25E");

var $bgNoL = parcelRequire("bgNoL");
// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
const { useValue: $b1949a81125e9848$var$useSidebarId } = (0, $jmt32.createValueController)('sidebar-id');
const $b1949a81125e9848$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
    experience: (0, $bgNoL.SIDEBAR_EXPERIENCE),
    attributes: {
        sidebar: 'v3'
    }
};
const $b1949a81125e9848$export$6738d1299dc79710 = ()=>{
    const [{ route: route, match: match }] = (0, $lB25E.useRouter)();
    const pageId = (0, $3O0Td.usePageId)();
    const startRef = (0, $eUqFw.useRef)(Date.now());
    const onStartExperience = (0, $bDhRl.useExperienceStart)({
        experienceId: pageId,
        experience: (0, $bgNoL.SIDEBAR_EXPERIENCE),
        analyticsSource: 'Sidebar'
    });
    (0, $eUqFw.useMemo)(()=>{
        if (route.isRedirect ?? false) return;
        onStartExperience();
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        match
    ]);
    return null;
};
const $b1949a81125e9848$export$ba19e3624956e66 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderStart
    });
const $b1949a81125e9848$export$a06ecbbe5820282 = ({ id: id })=>{
    const [, setSidebarId] = $b1949a81125e9848$var$useSidebarId();
    const route = (0, $10fdS.useCurrentRoute)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const onSuccess = (0, $fDZ6r.useExperienceSuccess)($b1949a81125e9848$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
    (0, $eUqFw.useEffect)(()=>{
        setSidebarId(id);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        return ()=>setSidebarId();
    }, [
        setSidebarId,
        id
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (route.isRedirect ?? false) return;
        onSuccess();
    }, [
        onSuccess,
        route
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        // Why are we injecting the route name into the global window state?
        // We currently don't have any way to get the route name when the sidenav is rendered OUTSIDE of the SPA
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__POLLINATOR__ = {
            ...window.__POLLINATOR__,
            routeName: routeName
        };
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $jMP2a.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        routeName
    ]);
    const customData = (0, $eUqFw.useMemo)(()=>({
            route: routeName,
            sidebarId: id
        }), [
        routeName,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceReport), {
        customData: customData
    }));
};
const $b1949a81125e9848$export$661ed14c8f75da9f = ()=>{
    const onFail = (0, $4qhD6.useExperienceFail)({
        experience: (0, $bgNoL.SIDEBAR_EXPERIENCE)
    });
    return (0, $eUqFw.useCallback)((location, error)=>{
        onFail(location, error);
    }, [
        onFail
    ]);
};
const $b1949a81125e9848$export$ddb17534fdfb7dc6 = ()=>(0, $fDZ6r.useExperienceSuccess)($b1949a81125e9848$var$EXPERIENCE_SUCCESS_ATTRIBUTES);

});
parcelRegister("4qhD6", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $2f159cb06c119de7$export$606da7704d8eaf06);

var $eUqFw = parcelRequire("eUqFw");

var $cs5mh = parcelRequire("cs5mh");

var $JRB5w = parcelRequire("JRB5w");

var $gtrMw = parcelRequire("gtrMw");
const $2f159cb06c119de7$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const self = (0, $eUqFw.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $eUqFw.useCallback)((location, error, extraAttributes = {})=>{
        const { current: current } = self;
        // ignore client side errors from impacting experience metrics
        if ((0, $cs5mh.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $JRB5w.isClientFetchError)(error)) return;
        current.experienceTracker.fail({
            name: current.name,
            error: error,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                location: location
            }
        });
    }, [
        self
    ]);
};

});
parcelRegister("gtrMw", function(module, exports) {

$parcel$export(module.exports, "useExperienceContext", () => $b35642cd91fe7353$export$be8ec22ac9208049);

var $eUqFw = parcelRequire("eUqFw");

var $1xrmr = parcelRequire("1xrmr");
const $b35642cd91fe7353$export$be8ec22ac9208049 = ()=>{
    const context = (0, $eUqFw.useContext)((0, $1xrmr.ExperienceTrackerContext));
    return context;
};

});


parcelRegister("bDhRl", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $61606509e9879b1e$export$675e0d25df38d426);
$parcel$export(module.exports, "ExperienceStart", () => $61606509e9879b1e$export$f20b867e738a222c);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");

var $gtrMw = parcelRequire("gtrMw");
const $61606509e9879b1e$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
    const self = (0, $eUqFw.useRef)({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        experienceTracker: experienceTracker,
        disableSli: disableSli,
        userLocation: userLocation,
        collect: collect
    });
    self.current.experienceId = experienceId;
    self.current.experience = experience;
    self.current.timeout = timeout;
    self.current.analyticsSource = analyticsSource;
    self.current.application = application;
    self.current.edition = edition;
    self.current.experienceTracker = experienceTracker;
    self.current.userLocation = userLocation;
    self.current.collect = collect;
    return (0, $eUqFw.useCallback)(()=>{
        const { current: current } = self;
        current.experienceTracker.start({
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            id: current.experienceId,
            name: current.experience,
            timeout: current.timeout,
            attributes: {
                analyticsSource: current.analyticsSource,
                experience: current.experience,
                experienceId: current.experienceId,
                application: current.application,
                edition: current.edition,
                disableSli: current.disableSli,
                userLocation: current.userLocation
            },
            collect: current.collect,
            onSuccess: ()=>undefined
        });
    }, [
        self
    ]);
};
const $61606509e9879b1e$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
    const onStart = $61606509e9879b1e$export$675e0d25df38d426({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        disableSli: disableSli,
        collect: collect
    });
    (0, $eUqFw.useMemo)(()=>{
        onStart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onStart,
        experienceId,
        experience,
        timeout,
        analyticsSource,
        application,
        edition,
        disableSli,
        collect
    ]);
    return null;
};

});

parcelRegister("fDZ6r", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $62a77bba99475ca2$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "ExperienceSuccess", () => $62a77bba99475ca2$export$4962f3898bd5c829);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");

var $gtrMw = parcelRequire("gtrMw");
const $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT = {};
const $62a77bba99475ca2$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT })=>{
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const route = (0, $10fdS.useCurrentRoute)();
    const self = (0, $eUqFw.useRef)({
        experience: experience,
        attributes: attributes,
        experienceTracker: experienceTracker,
        route: route
    });
    self.current.route = route;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    self.current.experience = experience;
    return (0, $eUqFw.useCallback)((extraAttributes = {})=>{
        const { current: current } = self;
        if (current.route && current.route.isRedirect === true) return;
        current.experienceTracker.succeed({
            name: current.experience,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};
const $62a77bba99475ca2$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT })=>{
    const onExperienceSuccess = $62a77bba99475ca2$export$e94f0da4fc0603c6({
        experience: experience,
        attributes: attributes
    });
    (0, $eUqFw.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        attributes,
        onExperienceSuccess
    ]);
    (0, $eUqFw.useMemo)(()=>{
        if (false) onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    return null;
};

});

parcelRegister("jmt32", function(module, exports) {

$parcel$export(module.exports, "createValueController", () => $23eae1bf65d6e5ee$export$ff0ab9dd4ceb4a93);

var $WBLbN = parcelRequire("WBLbN");
const $23eae1bf65d6e5ee$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
    const actions = {
        setValue: (value)=>({ setState: setState })=>setState({
                    value: value
                })
    };
    const initialState = {
        value: defaultValue
    };
    const store = (0, $WBLbN.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ValueContainer = (0, $WBLbN.createContainer)(store);
    const selector = (state)=>state.value;
    const useValueInternal = (0, $WBLbN.createHook)(store, {
        selector: selector
    });
    const useValue = ()=>{
        const [value, { setValue: setValue }] = useValueInternal();
        return [
            value,
            setValue
        ];
    };
    return {
        ValueContainer: ValueContainer,
        useValue: useValue
    };
};

});

parcelRegister("3O0Td", function(module, exports) {

$parcel$export(module.exports, "usePageId", () => $8b00509e9968a84b$export$3434ba5eadb360dc);

var $WBLbN = parcelRequire("WBLbN");

var $cfLkw = parcelRequire("cfLkw");
const $8b00509e9968a84b$var$useSweetStatePageId = (0, $WBLbN.createHook)((0, $cfLkw.default), {
    selector: (state)=>state.currentPage.uuid
});
const $8b00509e9968a84b$export$3434ba5eadb360dc = ()=>{
    const [pageId] = $8b00509e9968a84b$var$useSweetStatePageId();
    return pageId;
};

});

parcelRegister("bgNoL", function(module, exports) {

$parcel$export(module.exports, "REPO_TYPE", () => $425fbadb5891ec48$export$399c7e6858236b4);
$parcel$export(module.exports, "LINK_TYPE", () => $425fbadb5891ec48$export$58125ce2bb1c3378);
$parcel$export(module.exports, "EMOJI_REGEX", () => $425fbadb5891ec48$export$c79ed2783644934c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", () => $425fbadb5891ec48$export$25ae65041c800c9);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", () => $425fbadb5891ec48$export$e03c9beea817d44b);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", () => $425fbadb5891ec48$export$3d575bdf28c0d17c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", () => $425fbadb5891ec48$export$af84baced6970a17);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", () => $425fbadb5891ec48$export$c767f253046b1ea7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", () => $425fbadb5891ec48$export$265b9384cc2dfbd4);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", () => $425fbadb5891ec48$export$2de77b357e71c7a7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", () => $425fbadb5891ec48$export$7de7abb92169d6c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", () => $425fbadb5891ec48$export$fd7df8bd7600c65c);
$parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", () => $425fbadb5891ec48$export$dde074e512e80dff);
$parcel$export(module.exports, "REPORTS_IDS", () => $425fbadb5891ec48$export$1f70a76cb421b107);
$parcel$export(module.exports, "SIDEBAR_EXPERIENCE", () => $425fbadb5891ec48$export$71aaf2625ee54d10);
$parcel$export(module.exports, "staticLegacyIds", () => $425fbadb5891ec48$export$f57650e6e7be03dc);
const $425fbadb5891ec48$export$399c7e6858236b4 = 'source.code.link';
const $425fbadb5891ec48$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $425fbadb5891ec48$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
const $425fbadb5891ec48$export$25ae65041c800c9 = 'pin-filter-myopenissues';
const $425fbadb5891ec48$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
const $425fbadb5891ec48$export$3d575bdf28c0d17c = 'pin-filter-allissues';
const $425fbadb5891ec48$export$af84baced6970a17 = 'pin-filter-allopenissues';
const $425fbadb5891ec48$export$c767f253046b1ea7 = 'pin-filter-doneissues';
const $425fbadb5891ec48$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
const $425fbadb5891ec48$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
const $425fbadb5891ec48$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
const $425fbadb5891ec48$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
const $425fbadb5891ec48$export$dde074e512e80dff = 'global-create-spotlight';
const $425fbadb5891ec48$export$1f70a76cb421b107 = {
    REPORTS_ADDONS: 'sd-reports-addons'
};
const $425fbadb5891ec48$export$83016cff6318a5dd = Object.freeze({
    CODE_TAB: 'CODE_TAB',
    ONCALL_TAB: 'ONCALL_TAB',
    PAGES_TAB: 'PAGES_TAB'
});
const $425fbadb5891ec48$export$f371b4c263b142af = {
    [$425fbadb5891ec48$export$83016cff6318a5dd.CODE_TAB]: 'code',
    [$425fbadb5891ec48$export$83016cff6318a5dd.ONCALL_TAB]: 'opsgenie',
    [$425fbadb5891ec48$export$83016cff6318a5dd.PAGES_TAB]: 'pages'
};
const $425fbadb5891ec48$export$b66c40cadee12a0b = 'project/agility/index';
const $425fbadb5891ec48$export$6f454e69bce3a691 = 'project/business/index';
const $425fbadb5891ec48$export$3a0f7f7a8a0b306b = 'project/ops/index';
const $425fbadb5891ec48$export$1346c9aa3cbb477d = 'project/software/index';
const $425fbadb5891ec48$export$4598dd67943205cf = 'project/software/issues';
const $425fbadb5891ec48$export$8f36e85c5afae5 = 'project/software/reports';
const $425fbadb5891ec48$export$8151e5564c0016a1 = 'attachments';
const $425fbadb5891ec48$export$4acd0d06a25e56b5 = 'eventtypes';
const $425fbadb5891ec48$export$211ab01804585e09 = 'webhooks-admin';
const $425fbadb5891ec48$export$294b9ab8545a9f36 = 'services';
const $425fbadb5891ec48$export$665efe695022359b = 'greenhopper-lexorank-manage';
const $425fbadb5891ec48$export$47fbefc73055eb9d = 'admin-helper-admin-section';
const $425fbadb5891ec48$export$76e6bd729450de52 = 'advanced_section';
const $425fbadb5891ec48$export$ac928a90c0d3daa8 = 'collectors';
const $425fbadb5891ec48$export$309ac0136b7d5dfa = 'dark_features';
const $425fbadb5891ec48$export$998f1706a6ca29b = 'general_configuration';
const $425fbadb5891ec48$export$e9af81a594543847 = 'import_export_section';
const $425fbadb5891ec48$export$bbf19cc23216c6b = 'mail_section';
const $425fbadb5891ec48$export$693dd06b18660b78 = 'security_section';
const $425fbadb5891ec48$export$c6d1221ea0bce75e = 'shared_section';
const $425fbadb5891ec48$export$c7d7c0d436dd54b1 = 'troubleshooting_and_support';
const $425fbadb5891ec48$export$af156d8e27fc5458 = 'user_interface';
const $425fbadb5891ec48$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
const $425fbadb5891ec48$export$f57650e6e7be03dc = [
    // Global Settings Static Legacy Ids
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy Ids
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation'
];

});


parcelRegister("7BqbB", function(module, exports) {

$parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", () => $c230ed31b77458b3$export$f5a7bd7eb586e4e8);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP", () => $c230ed31b77458b3$export$6a976dc7193b8a18);
$parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", () => $c230ed31b77458b3$export$9fcc53f3b36e0949);
$parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", () => $c230ed31b77458b3$export$2eb8dda9e83d33ff);
$parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", () => $c230ed31b77458b3$export$9cf873ba2e9a3ce0);
$parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", () => $c230ed31b77458b3$export$a495ba70b16d4d90);
$parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", () => $c230ed31b77458b3$export$89de709e88232646);

var $jVbWM = parcelRequire("jVbWM");

var $9NFtU = parcelRequire("9NFtU");

var $eSHsi = parcelRequire("eSHsi");

var $5sPjT = parcelRequire("5sPjT");

var $aKPxm = parcelRequire("aKPxm");

var $fHhlA = parcelRequire("fHhlA");

var $iY7zv = parcelRequire("iY7zv");

var $jomRY = parcelRequire("jomRY");

var $i2kUf = parcelRequire("i2kUf");

var $d3Jit = parcelRequire("d3Jit");

var $7jsaI = parcelRequire("7jsaI");

var $gib2Q = parcelRequire("gib2Q");

var $4ursw = parcelRequire("4ursw");

var $2LZsU = parcelRequire("2LZsU");

var $5jfU2 = parcelRequire("5jfU2");
const $c230ed31b77458b3$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
const $c230ed31b77458b3$export$d57b6b390e78d90f = 'jira-cosmos';
const $c230ed31b77458b3$export$421b92818c76ee2d = Object.values((0, $4ursw.CONFIGURABLE_MENU_ID));
const $c230ed31b77458b3$export$f5a7bd7eb586e4e8 = $c230ed31b77458b3$export$421b92818c76ee2d;
const $c230ed31b77458b3$export$6a976dc7193b8a18 = {
    [(0, $5jfU2.L1_MENU_ID).APPS]: {
        message: (0, $2LZsU.default).apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jVbWM)))
    },
    [(0, $5jfU2.L1_MENU_ID).GOALS]: {
        message: (0, $2LZsU.default).goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($iY7zv)))
    },
    [(0, $5jfU2.L1_MENU_ID).ROADMAPS]: {
        message: (0, $2LZsU.default).roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHhlA)))
    },
    [(0, $5jfU2.L1_MENU_ID).PLANS]: {
        message: (0, $2LZsU.default).plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i2kUf)))
    },
    [(0, $5jfU2.L1_MENU_ID).PROJECTS]: {
        message: (0, $2LZsU.default).projects,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jomRY)))
    },
    [(0, $5jfU2.L1_MENU_ID).FILTERS]: {
        message: (0, $2LZsU.default).filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aKPxm)))
    },
    [(0, $5jfU2.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $2LZsU.default).dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5sPjT)))
    },
    [(0, $5jfU2.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $2LZsU.default).operations,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jVbWM)))
    },
    // TODO: Update icon when implementing overviews
    [(0, $5jfU2.L1_MENU_ID).OPERATIONS]: {
        message: (0, $2LZsU.default).operations,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($d3Jit)))
    },
    [(0, $5jfU2.L1_MENU_ID).ASSETS]: {
        message: (0, $2LZsU.default).assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9NFtU)))
    },
    [(0, $5jfU2.L1_MENU_ID).TEAMS]: {
        message: (0, $2LZsU.default).teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gib2Q)))
    },
    [(0, $5jfU2.L1_MENU_ID).RECENT]: {
        message: (0, $2LZsU.default).recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eSHsi)))
    },
    [(0, $5jfU2.L1_MENU_ID).STARRED]: {
        message: (0, $2LZsU.default).starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7jsaI)))
    }
};
const $c230ed31b77458b3$export$9fcc53f3b36e0949 = 240; // in pixels
const $c230ed31b77458b3$export$6621cd553335536a = 320; // in pixels
const $c230ed31b77458b3$export$2eb8dda9e83d33ff = false;
const $c230ed31b77458b3$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
const $c230ed31b77458b3$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
const $c230ed31b77458b3$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
const $c230ed31b77458b3$export$a495ba70b16d4d90 = 'nav4-sidebar';
const $c230ed31b77458b3$export$89de709e88232646 = 25;

});
parcelRegister("9NFtU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44aca55c74a9b184f2a5b64fe5be98d8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7228ddfa5c1e3b8b$var$_react = $7228ddfa5c1e3b8b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7228ddfa5c1e3b8b$var$_UNSAFE_baseNew = $7228ddfa5c1e3b8b$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $7228ddfa5c1e3b8b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Assets".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for JSM Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7228ddfa5c1e3b8b$var$AssetsIcon = (props)=>/*#__PURE__*/ $7228ddfa5c1e3b8b$var$_react.default.createElement($7228ddfa5c1e3b8b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.59 6.409a2.25 2.25 0 0 1 0 3.182m0-3.182a2.25 2.25 0 0 0-3.181 0m3.182 0 2.598-2.598M9.591 9.59a2.25 2.25 0 0 1-3.182 0m3.182 0 2.598 2.598M6.41 9.591a2.25 2.25 0 0 1 0-3.182m0 3.182-2.6 2.598m2.598-5.78L3.81 3.811m8.378 0a1.5 1.5 0 1 0 2.122-2.122 1.5 1.5 0 0 0-2.122 2.122Zm0 8.378a1.5 1.5 0 1 0 2.122 2.122 1.5 1.5 0 0 0-2.122-2.122ZM3.811 3.811a1.5 1.5 0 1 0-2.122-2.122 1.5 1.5 0 0 0 2.122 2.122Zm0 8.378a1.5 1.5 0 1 1-2.122 2.122 1.5 1.5 0 0 1 2.122-2.122Z"/>`
    }, props));
$7228ddfa5c1e3b8b$var$AssetsIcon.displayName = 'AssetsIcon';
var $7228ddfa5c1e3b8b$var$_default = module.exports.default = $7228ddfa5c1e3b8b$var$AssetsIcon;

});

parcelRegister("fHhlA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2dbfb80dd8b5d8923ab37cee015ffdd1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6d853f834aa3b6d$var$_react = $b6d853f834aa3b6d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b6d853f834aa3b6d$var$_UNSAFE_baseNew = $b6d853f834aa3b6d$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $b6d853f834aa3b6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "FolderOpen".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for open folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6d853f834aa3b6d$var$FolderOpenIcon = (props)=>/*#__PURE__*/ $b6d853f834aa3b6d$var$_react.default.createElement($b6d853f834aa3b6d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 14.25a1 1 0 0 1-1-1V3c0-.69.56-1.25 1.25-1.25h3.25L7 3.5h5c.69 0 1.25.56 1.25 1.25v2m-11.5 7.5 2.116-7.055a.625.625 0 0 1 .599-.445h8.785m-11.5 7.5h10.57a1.25 1.25 0 0 0 1.197-.89l1.742-5.805a.625.625 0 0 0-.599-.805h-1.41"/>`
    }, props));
$b6d853f834aa3b6d$var$FolderOpenIcon.displayName = 'FolderOpenIcon';
var $b6d853f834aa3b6d$var$_default = module.exports.default = $b6d853f834aa3b6d$var$FolderOpenIcon;

});

parcelRegister("iY7zv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f76d8cc6226f5c4506902cfd524d6ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dcf3b42887852980$var$_react = $dcf3b42887852980$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dcf3b42887852980$var$_UNSAFE_baseNew = $dcf3b42887852980$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $dcf3b42887852980$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dcf3b42887852980$var$GoalIcon = (props)=>/*#__PURE__*/ $dcf3b42887852980$var$_react.default.createElement($dcf3b42887852980$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentcolor" stroke-width="1.5" d="M8 11.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z"/>`
    }, props));
$dcf3b42887852980$var$GoalIcon.displayName = 'GoalIcon';
var $dcf3b42887852980$var$_default = module.exports.default = $dcf3b42887852980$var$GoalIcon;

});

parcelRegister("i2kUf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf2cef03a1c42b52984c96f46580b3eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d218a16aa9c2bf5b$var$_react = $d218a16aa9c2bf5b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d218a16aa9c2bf5b$var$_UNSAFE_baseNew = $d218a16aa9c2bf5b$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $d218a16aa9c2bf5b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d218a16aa9c2bf5b$var$RoadmapIcon = (props)=>/*#__PURE__*/ $d218a16aa9c2bf5b$var$_react.default.createElement($d218a16aa9c2bf5b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M.75 4c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H2C1.31 6.25.75 5.69.75 5zm3 7c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25z"/>`
    }, props));
$d218a16aa9c2bf5b$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $d218a16aa9c2bf5b$var$_default = module.exports.default = $d218a16aa9c2bf5b$var$RoadmapIcon;

});

parcelRegister("d3Jit", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e63dc1773124ff24739f4bfd66f50f0d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $981eb133a81cfa54$var$_react = $981eb133a81cfa54$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $981eb133a81cfa54$var$_UNSAFE_baseNew = $981eb133a81cfa54$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $981eb133a81cfa54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Shield".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: classifications in Enterprise Trust, security in Jira (Spork)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $981eb133a81cfa54$var$ShieldIcon = (props)=>/*#__PURE__*/ $981eb133a81cfa54$var$_react.default.createElement($981eb133a81cfa54$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M14.25 4.5S10.75 3.5 8 .75C5.25 3.5 1.75 4.5 1.75 4.5 1.75 12.75 8 15.125 8 15.125S14.25 12.75 14.25 4.5Z"/>`
    }, props));
$981eb133a81cfa54$var$ShieldIcon.displayName = 'ShieldIcon';
var $981eb133a81cfa54$var$_default = module.exports.default = $981eb133a81cfa54$var$ShieldIcon;

});

parcelRegister("2LZsU", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb3d27ef5aae58cc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bb3d27ef5aae58cc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-common.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-common.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    teams: {
        "id": "navigation-apps-sidebar-nav4-common.common.teams",
        "defaultMessage": "Teams"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-common.common.assets",
        "defaultMessage": "Assets"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-common.common.plans",
        "defaultMessage": "Plans"
    },
    apps: {
        "id": "navigation-apps-sidebar-nav4-common.common.apps",
        "defaultMessage": "Apps"
    },
    operations: {
        "id": "navigation-apps-sidebar-nav4-common.common.operations",
        "defaultMessage": "Operations"
    },
    goals: {
        "id": "navigation-apps-sidebar-nav4-common.common.goals",
        "defaultMessage": "Goals"
    },
    recent: {
        "id": "navigation-apps-sidebar-nav4-common.common.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-common.common.starred",
        "defaultMessage": "Starred"
    },
    roadmaps: {
        "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
        "defaultMessage": "Roadmaps"
    }
});

});

parcelRegister("5jfU2", function(module, exports) {

$parcel$export(module.exports, "L1_MENU_ID", () => $379c098b2ef9e0bc$export$918aea3cf024d90b);

var $4ursw = parcelRequire("4ursw");
const $379c098b2ef9e0bc$export$f263c05bb04cefc9 = {
    OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
    OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
};
const $379c098b2ef9e0bc$export$bb47524d7f3cb1f8 = {
    ...(0, $4ursw.CONFIGURABLE_MENU_ID),
    BOARDS: 'jira.sidebar.boards',
    QUEUES: 'jira.sidebar.queues',
    ALL: 'jira.sidebar.all'
};
const $379c098b2ef9e0bc$export$918aea3cf024d90b = {
    YOUR_WORK: 'jira.sidebar.yourWork',
    ...(0, $4ursw.CONFIGURABLE_MENU_ID),
    ...$379c098b2ef9e0bc$export$f263c05bb04cefc9
};

});


parcelRegister("kpmO3", function(module, exports) {

$parcel$export(module.exports, "SidebarNav4ContextProvider", () => $3330e369861b2dca$export$ebf7cdfc2e83bcef);
$parcel$export(module.exports, "useSidebarNav4", () => $3330e369861b2dca$export$dc46c14934833db2);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $4ZjUB = parcelRequire("4ZjUB");

var $7uCfF = parcelRequire("7uCfF");

var $5RIdI = parcelRequire("5RIdI");
const $3330e369861b2dca$var$SidebarNav4Context = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
function $3330e369861b2dca$export$ebf7cdfc2e83bcef(props) {
    const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
    const [routerContext] = (0, $lB25E.useRouter)();
    const initialSelectedPath = (0, $4ZjUB.getInitialSelectedPath)(routerContext);
    const [selectedPath, setSelectedPath] = (0, $eUqFw.useState)(initialSelectedPath);
    // When the `routerContext` changes, we need to recalculate the selected path.
    // useLayoutEffect, so this happens before render.
    (0, $eUqFw.useLayoutEffect)(()=>{
        setSelectedPath((currentPath)=>{
            const newPath = (0, $5RIdI.routeToSelectedPath)(routerContext);
            return currentPath.toString() === newPath.toString() ? currentPath : newPath;
        });
    }, [
        routerContext
    ]);
    const sidebarNav4Controller = (0, $eUqFw.useMemo)(()=>({
            isInitialSelectedPath: isInitialSelectedPath ?? (0, $7uCfF.isSelectedPath)(initialSelectedPath),
            isSelectedPath: (0, $7uCfF.isSelectedPath)(selectedPath)
        }), [
        initialSelectedPath,
        isInitialSelectedPath,
        selectedPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3330e369861b2dca$var$SidebarNav4Context.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $3330e369861b2dca$export$dc46c14934833db2() {
    const context = (0, $eUqFw.useContext)($3330e369861b2dca$var$SidebarNav4Context);
    if (context == null) throw new Error('useSidebarNav4 must be used inside a SidebarNav4ContextProvider');
    return context;
}

});

parcelRegister("bdfGI", function(module, exports) {

$parcel$export(module.exports, "SidebarSelector", () => $33aa06698882b6b7$export$7937e2d32a777fcb);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $exb0h = parcelRequire("exb0h");

var $h4Fhh = parcelRequire("h4Fhh");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $7vTKl = parcelRequire("7vTKl");




var $kAidm = parcelRequire("kAidm");

var $lRIdH = parcelRequire("lRIdH");

var $6cv5X = parcelRequire("6cv5X");

var $fGNgi = parcelRequire("fGNgi");

var $upajt = parcelRequire("upajt");

var $6DM93 = parcelRequire("6DM93");

var $lWmpu = parcelRequire("lWmpu");

var $8BRHO = parcelRequire("8BRHO");

var $hI8UJ = parcelRequire("hI8UJ");

var $Me4cl = parcelRequire("Me4cl");

var $jn4gC = parcelRequire("jn4gC");

var $aBzna = parcelRequire("aBzna");

var $bRT5F = parcelRequire("bRT5F");

var $dAUnM = parcelRequire("dAUnM");

var $34zVc = parcelRequire("34zVc");

var $kmEf6 = parcelRequire("kmEf6");

var $4tYWR = parcelRequire("4tYWR");

var $6WLSW = parcelRequire("6WLSW");

var $9F5X0 = parcelRequire("9F5X0");

var $92Zmd = parcelRequire("92Zmd");

var $jq6Xe = parcelRequire("jq6Xe");

var $aPW8a = parcelRequire("aPW8a");

var $gBUa5 = parcelRequire("gBUa5");

var $8WuJm = parcelRequire("8WuJm");

var $bNe1g = parcelRequire("bNe1g");

var $ddT06 = parcelRequire("ddT06");

var $lB25E = parcelRequire("lB25E");
const $33aa06698882b6b7$var$ProjectSettingsSidebarSelector = ()=>{
    const { data: project, loading: loading, error: error } = (0, $bNe1g.useProjectContext)();
    let sidebar = null;
    if (loading) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null);
    if (project?.projectType === (0, $7ZZxN.CORE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRIdH.default), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kAidm.default), {
        project: project
    });
    if (project?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gBUa5.default), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aPW8a.default), {
        project: project
    });
    if (project?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fGNgi.AsyncJsmTmpProjectSettingsSidebar), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6cv5X.AsyncJsmCmpProjectSettingsSidebar), {
        project: project
    });
    if (project?.projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI8UJ.default), {
        project: project
    });
    if (project?.projectType === (0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fGNgi.AsyncJsmTmpProjectSettingsSidebar), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6cv5X.AsyncJsmCmpProjectSettingsSidebar), {
        project: project
    });
    if (error) throw error;
    if (!sidebar) throw new Error(`No project settings sidebar found for the project type: ${project?.projectType}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        containerId: project ? String(project.projectId) : undefined,
        containerType: "project"
    }, sidebar);
};
const $33aa06698882b6b7$var$InternalSidebarSelector = ()=>{
    const [{ match: { params: params }, route: route, location: location, query: query }] = (0, $lB25E.useRouter)();
    const { saveCurrentRoute: saveCurrentRoute } = (0, $aBzna.useNavigateBack)();
    const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, $dAUnM.useGlobalAppsSettingsConnectItemActive)();
    const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, $9F5X0.useGlobalSystemSettingsConnectItemActive)();
    const { isActive: isProjectSettingsConnectAppActive } = (0, $8BRHO.useIsConnectAppActive)();
    const { shouldUseJSM: shouldUseJSM } = (0, $h4Fhh.useOgTenantInfo)();
    switch(route.navigation?.sidebarId){
        case (0, $7vTKl.SIDEBAR_ID).PLAN_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6DM93.default), null);
        case (0, $7vTKl.SIDEBAR_ID).GLOBAL_APPS_SETTINGS:
            if (!location.pathname.includes('/discover')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $34zVc.default), null);
            break;
        case (0, $7vTKl.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6WLSW.default), null);
        case (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kmEf6.default), null);
        case (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS:
            if (location.pathname.includes('/jira-service-management-chatops-and-video-tools') && shouldUseJSM && (0, $eI5EY.fg)('fix_chatops_new_nav_bug')) break;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4tYWR.default), null);
        case (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $92Zmd.default), null);
        case (0, $7vTKl.SIDEBAR_ID).PERSONAL_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $upajt.default), null);
        case (0, $7vTKl.SIDEBAR_ID).HELP_CENTER_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jq6Xe.default), null);
        case (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33aa06698882b6b7$var$ProjectSettingsSidebarSelector, null);
        default:
            break;
    }
    // Project settings sidebars
    if (route.name === (0, $exb0h.ROUTE_NAMES_POLARIS_IDEAS) && params.section === 'settings' || isProjectSettingsConnectAppActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33aa06698882b6b7$var$ProjectSettingsSidebarSelector, null);
    // Board settings sidebar
    if (route.group === (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE) && (0, $ddT06.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(query.config) && (0, $1ybV0.ff)('simplified-boards-milestone-2_07hbk')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bRT5F.default), null);
    // Global settings sidebars
    if (isGlobalAppsSettingsConnectItemActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $34zVc.default), null);
    if (isGlobalSystemSettingsConnectItemActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $92Zmd.default), null);
    // the route to navigate back to will be whichever route was last displayed
    // with the default sidebar on
    saveCurrentRoute();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jn4gC.default), null);
};
const $33aa06698882b6b7$export$7937e2d32a777fcb = ()=>{
    const attributes = (0, $eUqFw.useMemo)(()=>({
            navigationLayer: (0, $98a42a181453f01b$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $8d9d60709cf91bf0$export$2ee9e5a3556c1e43),
            navState: (0, $04b88667038db790$export$2bd315ece9f68967),
            stage: (0, $Me4cl.getNav4Rollout)().stage
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBzna.NavigateBackProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33aa06698882b6b7$var$InternalSidebarSelector, null)));
};

});
parcelRegister("7vTKl", function(module, exports) {

$parcel$export(module.exports, "ADDON_ID", () => $d4390c4ef90a66f3$export$6c4866a933650d1d);
$parcel$export(module.exports, "MENU_ID", () => $d4390c4ef90a66f3$export$d4cd258d01c03112);
$parcel$export(module.exports, "SIDEBAR_ID", () => $d4390c4ef90a66f3$export$adf978edbdfaf080);
const $d4390c4ef90a66f3$export$6c4866a933650d1d = {
    DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
};
const $d4390c4ef90a66f3$export$d4cd258d01c03112 = {
    ADDONS: 'ADDONS',
    APP_SWITCHER: 'APP_SWITCHER',
    DASHBOARDS: 'DASHBOARDS',
    FILTERS: 'FILTERS',
    HELP: 'HELP',
    HOME: 'HOME',
    INSIGHT: 'INSIGHT',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PEOPLE: 'PEOPLE',
    PLANS: 'PLANS',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    ROADMAPS: 'ROADMAPS',
    SEARCH: 'SEARCH',
    SERVICE_HUB: 'SERVICE_HUB',
    SETTINGS: 'SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};
const $d4390c4ef90a66f3$export$adf978edbdfaf080 = {
    BOARD_SETTINGS: 'BOARD_SETTINGS',
    GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
    GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
    GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
    GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
    GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    PLAN_SETTINGS: 'PLAN_SETTINGS',
    PROJECT_SETTINGS: 'PROJECT_SETTINGS'
};

});

const $04b88667038db790$export$d2aa6c54a5925f01 = 'v3';
const $04b88667038db790$export$2bd315ece9f68967 = 'v4';

const $8d9d60709cf91bf0$export$2ee9e5a3556c1e43 = 'sidebar';
const $8d9d60709cf91bf0$export$793ed84f5e13fedc = 'top';
const $8d9d60709cf91bf0$export$f1c9dd0f5207dd5e = 'tab';
const $8d9d60709cf91bf0$export$b83d0ee9325a2d0a = 'projectTitle';

const $98a42a181453f01b$export$17ff3f7e02c6ac22 = 'global';
const $98a42a181453f01b$export$33d8c916a600c5e9 = 'container';

parcelRegister("kAidm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d22e3a8d8df3fc2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lShkl = parcelRequire("lShkl");

var $lWmpu = parcelRequire("lWmpu");

var $gGtKh = parcelRequire("gGtKh");

const $3d22e3a8d8df3fc2$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("97zde")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/business/company-managed/src/ui/main.tsx"
});
const $3d22e3a8d8df3fc2$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.business.company-managed",
        packageName: "jiraNavigationAppsSidebarNav4BusinessCompanyManagedProjectSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.project-settings.business.company-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3d22e3a8d8df3fc2$var$LazySidebarContent, {
        project: project
    })));
var $3d22e3a8d8df3fc2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3d22e3a8d8df3fc2$var$AsyncSidebar);

});
parcelRegister("lShkl", function(module, exports) {

$parcel$export(module.exports, "SidebarBoundary", () => $0d3c97c1767991d9$export$1edc778464f08256);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $1Fr7E = parcelRequire("1Fr7E");

var $4qhD6 = parcelRequire("4qhD6");

var $keguF = parcelRequire("keguF");

var $dQMmq = parcelRequire("dQMmq");

var $41rEp = parcelRequire("41rEp");
const $0d3c97c1767991d9$export$1edc778464f08256 = ({ children: children, id: id, packageName: packageName, teamName: teamName })=>{
    const { experience: experience, attributes: attributes } = (0, $dQMmq.useSidebarExperience)();
    const onFail = (0, $4qhD6.useExperienceFail)({
        experience: experience,
        attributes: attributes
    });
    const onAbort = (0, $1Fr7E.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
    const userLocation = (0, $keguF.getUserLocation)();
    const isNotSSR = !false;
    const extraEventData = (0, $eUqFw.useMemo)(()=>({
            userLocation: userLocation
        }), [
        userLocation
    ]);
    const fallback = (0, $eUqFw.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $41rEp.Fallback), {
            error: error
        }), []);
    const handleError = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (location, error)=>{
        const { statusCode: statusCode } = error;
        if (statusCode >= 400 && statusCode < 500) onAbort('Sidebar failed with validation error', {
            error: error
        });
        else onFail(location, error);
    }, [
        onAbort,
        onFail
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        extraEventData: extraEventData,
        fallback: fallback,
        teamName: teamName,
        onError: handleError
    }, isNotSSR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQMmq.SidebarStart), null), children);
};

});
parcelRegister("1Fr7E", function(module, exports) {

$parcel$export(module.exports, "useExperienceAbort", () => $f0f298b79da53f61$export$cc92b7ce453f4403);

var $eUqFw = parcelRequire("eUqFw");

var $gtrMw = parcelRequire("gtrMw");
const $f0f298b79da53f61$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const self = (0, $eUqFw.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $eUqFw.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};

});

parcelRegister("dQMmq", function(module, exports) {

$parcel$export(module.exports, "useSidebarExperience", () => $4c5fa2af35d08faf$export$d4fa533dfe4d7583);
$parcel$export(module.exports, "SidebarStart", () => $4c5fa2af35d08faf$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarReady", () => $4c5fa2af35d08faf$export$a06ecbbe5820282);

var $eUqFw = parcelRequire("eUqFw");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $10fdS = parcelRequire("10fdS");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3O0Td = parcelRequire("3O0Td");

var $3iMaY = parcelRequire("3iMaY");
const $4c5fa2af35d08faf$export$d4fa533dfe4d7583 = ()=>{
    const pageId = (0, $3O0Td.usePageId)();
    return (0, $eUqFw.useMemo)(()=>({
            experience: 'viewSidebarNavigation',
            experienceId: pageId,
            analyticsSource: 'Sidebar',
            attributes: {
                sidebar: 'v4'
            }
        }), [
        pageId
    ]);
};
const $4c5fa2af35d08faf$export$6738d1299dc79710 = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const { experience: experience, experienceId: experienceId, analyticsSource: analyticsSource } = $4c5fa2af35d08faf$export$d4fa533dfe4d7583();
    const onStartExperience = (0, $bDhRl.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource
    });
    (0, $eUqFw.useEffect)(()=>{
        if (route.isRedirect) return;
        onStartExperience();
    }, [
        onStartExperience,
        route
    ]);
    return null;
};
const $4c5fa2af35d08faf$export$a06ecbbe5820282 = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const { experience: experience, attributes: attributes } = $4c5fa2af35d08faf$export$d4fa533dfe4d7583();
    const onSuccessfulExperience = (0, $fDZ6r.useExperienceSuccess)({
        experience: experience,
        attributes: attributes
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const doNotRunEffects = route.isRedirect || false;
    const sidebarId = route.navigation?.sidebarId ?? 'default';
    (0, $eUqFw.useEffect)(()=>{
        if (doNotRunEffects) return;
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $jMP2a.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        doNotRunEffects,
        routeName
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (doNotRunEffects) return;
        onSuccessfulExperience();
    }, [
        doNotRunEffects,
        onSuccessfulExperience,
        route
    ]);
    const customData = (0, $eUqFw.useMemo)(()=>({
            sidebarType: sidebarId
        }), [
        sidebarId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
        data: customData
    });
};

});
parcelRegister("3iMaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac8385c71ad69743$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $ac8385c71ad69743$export$d12f56a472cdbe6c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $ac8385c71ad69743$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    (0, $eUqFw.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $ac8385c71ad69743$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $fYqUr.addCustomData)(currentInteractionId, [], data);
}

});


parcelRegister("41rEp", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $22c37e9ffaeb8603$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");

var $iH6c1 = parcelRequire("iH6c1");

var $ijwdS = parcelRequire("ijwdS");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gQtE8 = parcelRequire("gQtE8");
const $22c37e9ffaeb8603$var$styles = {
    wrapper: "_bfhkm7j4 _syaz1gjq _1yt4pxbi _y3gn1h6o _4cvr1h6o _zulpu2gc",
    error: "_2rkogqwt _bfhk1v33 _syaz131l _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66"
};
const $22c37e9ffaeb8603$export$fb8d7f40caaeea67 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $22c37e9ffaeb8603$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijwdS.default), {
        width: "40px",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, formatMessage((0, $gQtE8.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $gQtE8.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $22c37e9ffaeb8603$var$styles.error
    }, "ERROR: ", (0, $iH6c1.getErrorHash)(error)));
};

});
parcelRegister("ijwdS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d511833b787fbc99$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("33cBa")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("jo9w7")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = jx8k5z4r4cbqfnn3t56t46v9
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/jx8k5z4r4cbqfnn3t56t46v9

var $9TZf5 = parcelRequire("9TZf5");

var $jo9w7 = parcelRequire("jo9w7");

var $33cBa = parcelRequire("33cBa");
const $d511833b787fbc99$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($33cBa)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($jo9w7))
});
var $d511833b787fbc99$export$2e2bcd8739ae039 = $d511833b787fbc99$var$Illustration;
// for advanced use only
const $d511833b787fbc99$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("9TZf5", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $a7efac7c92ef32a3$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $a7efac7c92ef32a3$export$4d00e7be716a0093);

var $eUqFw = parcelRequire("eUqFw");

var $evtC7 = parcelRequire("evtC7");
function $a7efac7c92ef32a3$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $evtC7.AsImg), props);
}
function $a7efac7c92ef32a3$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7efac7c92ef32a3$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("evtC7", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $e7036c28dfac32f8$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");
// suggested defaults, the consumer is free to override
const $e7036c28dfac32f8$var$defaultStyles = null;
const $e7036c28dfac32f8$var$fillStyles = null;
const $e7036c28dfac32f8$var$autoDarkModeStyles = null;
function $e7036c28dfac32f8$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("jo9w7", function(module, exports) {
module.exports = new URL("generic-error-darkmode.3646797f.svg", import.meta.url).toString();

});

parcelRegister("33cBa", function(module, exports) {
module.exports = new URL("generic-error.f200ded6.svg", import.meta.url).toString();

});


parcelRegister("gQtE8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2ea66bf42a2d887$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d2ea66bf42a2d887$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorHeading: {
        "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("lWmpu", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $654b8fa168689c64$export$8f31e4c4a37b8e9c);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $27KYr = parcelRequire("27KYr");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");
const $654b8fa168689c64$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200",
        xcss: $654b8fa168689c64$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27KYr.default), {
        columnGap: "space.100",
        rowGap: "space.050",
        alignItems: "center",
        templateAreas: [
            'avatar name',
            'avatar type'
        ],
        templateColumns: "min-content 1fr",
        xcss: $654b8fa168689c64$var$projectHeading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$projectAvatar,
        style: {
            gridArea: 'avatar'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$projectName,
        style: {
            gridArea: 'name'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$projectType,
        style: {
            gridArea: 'type'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$menuItem
    })));
const $654b8fa168689c64$var$containerStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    padding: 'space.200'
});
const $654b8fa168689c64$var$backButton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $654b8fa168689c64$var$headingSkeleton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $654b8fa168689c64$var$projectHeading = (0, $1ZAYh.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $654b8fa168689c64$var$projectAvatar = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $654b8fa168689c64$var$projectName = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100'
});
const $654b8fa168689c64$var$projectType = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-100, 8px)",
    borderRadius: 'border.radius.100'
});
const $654b8fa168689c64$var$menuItem = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("97zde", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("eFpn4")
]).then(()=>parcelRequire('6K5Jn'));

});


parcelRegister("lRIdH", function(module, exports) {

$parcel$export(module.exports, "default", () => $72f3e3afcf63138a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lShkl = parcelRequire("lShkl");

var $lWmpu = parcelRequire("lWmpu");

var $gGtKh = parcelRequire("gGtKh");

const $72f3e3afcf63138a$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("2YSiX")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/business/team-managed/src/ui/main.tsx"
});
const $72f3e3afcf63138a$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.business.team-managed",
        packageName: "jiraNavigationAppsSidebarNav4BusinessTeamManagedProjectSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.project-settings.business.team-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72f3e3afcf63138a$var$LazySidebarContent, {
        project: project
    })));
var $72f3e3afcf63138a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($72f3e3afcf63138a$var$AsyncSidebar);

});
parcelRegister("2YSiX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("gYnAk")
]).then(()=>parcelRequire('PCihN'));

});


parcelRegister("6cv5X", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCmpProjectSettingsSidebar", () => $3d1f0cda58e163e2$export$2ce6ad449436c545);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $hzZWH = parcelRequire("hzZWH");

var $lShkl = parcelRequire("lShkl");

var $lWmpu = parcelRequire("lWmpu");

var $i2U8X = parcelRequire("i2U8X");

var $gGtKh = parcelRequire("gGtKh");

const $3d1f0cda58e163e2$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("cbV2A")).then(({ JSMCmpProjectSettingsSidebar: JSMCmpProjectSettingsSidebar })=>JSMCmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/jsm-cmp-project-settings/src/main.tsx"
});
const $3d1f0cda58e163e2$var$analyticsAttributes = {
    navVersion: '4',
    projectType: 'cmp'
};
const $3d1f0cda58e163e2$export$2ce6ad449436c545 = /*#__PURE__*/ (0, $eUqFw.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.jsm-cmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmCmpProjectSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hzZWH.ContextualAnalyticsData), {
        menuId: (0, $i2U8X.MENU_ID_JSM_SETTINGS),
        attributes: $3d1f0cda58e163e2$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.jsm-cmp-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3d1f0cda58e163e2$var$LazySidebarContent, {
        project: project
    })))));

});
parcelRegister("hzZWH", function(module, exports) {

$parcel$export(module.exports, "ContextualAnalyticsData", () => $9c9a74070e1186f3$export$198470770171c65);
$parcel$export(module.exports, "IssuesContextualAnalyticsData", () => $9c9a74070e1186f3$export$bc7f6eebc16e6127);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $8WuJm = parcelRequire("8WuJm");

var $cPEpP = parcelRequire("cPEpP");

var $eEZvV = parcelRequire("eEZvV");
const $9c9a74070e1186f3$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            navVersion: '3',
            viewId: (0, $eEZvV.generateViewId)(menuId, ...stack),
            navigationLayer: 'container',
            ...attributes
        }
    });
const $9c9a74070e1186f3$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, $cPEpP.useProject), ...rest })=>{
    const { data: project } = useProject();
    const projectConfig = (project?.isSimplified ? (0, $7ZZxN.ProjectStyle).NEXT_GEN : (0, $7ZZxN.ProjectStyle).CLASSIC) || undefined;
    const projectType = project?.type || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            projectConfig: projectConfig,
            projectType: projectType,
            navigatorScope: navigatorScope
        }
    });
};

});
parcelRegister("eEZvV", function(module, exports) {

$parcel$export(module.exports, "generateViewId", () => $ff2c3a925d418d98$export$5b5545ed894dc47a);
const $ff2c3a925d418d98$export$5b5545ed894dc47a = (...ids)=>ids.join('/');

});


parcelRegister("i2U8X", function(module, exports) {

$parcel$export(module.exports, "MENU_ID_JSM_SETTINGS", () => $4bf27e77e236c402$export$4c5fa21d31710030);
$parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", () => $4bf27e77e236c402$export$f21504b774272faa);
const $4bf27e77e236c402$export$4c5fa21d31710030 = 'project/service-desk/settings';
const $4bf27e77e236c402$export$f21504b774272faa = {
    actionSubjectId: 'projectSettingsNavigationMenuItem',
    componentType: 'fixedItem',
    level: 1
};

});

parcelRegister("cbV2A", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("3ZXB6")
]).then(()=>parcelRequire('lMLib'));

});


parcelRegister("fGNgi", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmTmpProjectSettingsSidebar", () => $5767d2f1363a3d66$export$dadf0f8c840cb26d);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $hzZWH = parcelRequire("hzZWH");

var $lShkl = parcelRequire("lShkl");

var $lWmpu = parcelRequire("lWmpu");

var $i2U8X = parcelRequire("i2U8X");

var $gGtKh = parcelRequire("gGtKh");

const $5767d2f1363a3d66$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("agxIh")).then(({ JSMTmpProjectSettingsSidebar: JSMTmpProjectSettingsSidebar })=>JSMTmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/jsm-tmp-project-settings/src/main.tsx"
});
const $5767d2f1363a3d66$var$analyticsAttributes = {
    navVersion: '4',
    projectType: 'tmp'
};
const $5767d2f1363a3d66$export$dadf0f8c840cb26d = /*#__PURE__*/ (0, $eUqFw.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.jsm-tmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmTmpProjectSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hzZWH.ContextualAnalyticsData), {
        menuId: (0, $i2U8X.MENU_ID_JSM_SETTINGS),
        attributes: $5767d2f1363a3d66$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.jsm-tmp-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5767d2f1363a3d66$var$LazySidebarContent, {
        project: project
    })))));

});
parcelRegister("agxIh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("9zj7j")
]).then(()=>parcelRequire('kKInm'));

});


parcelRegister("upajt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c052b2690ab9d4d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lShkl = parcelRequire("lShkl");

var $gGtKh = parcelRequire("gGtKh");

var $kx8ra = parcelRequire("kx8ra");

const $6c052b2690ab9d4d$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("ae7r0")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/personal-settings/src/ui/main.tsx"
});
const $6c052b2690ab9d4d$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.personal-settings",
        packageName: "jiraNavigationAppsSidebarNav4PersonalSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.personal-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kx8ra.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c052b2690ab9d4d$var$LazySidebarContent, null)));
var $6c052b2690ab9d4d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($6c052b2690ab9d4d$var$AsyncSidebar);

});
parcelRegister("kx8ra", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $ecdb6441e8b8a4f3$export$8f31e4c4a37b8e9c);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");
const $ecdb6441e8b8a4f3$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ecdb6441e8b8a4f3$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ecdb6441e8b8a4f3$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ecdb6441e8b8a4f3$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ecdb6441e8b8a4f3$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ecdb6441e8b8a4f3$var$menuItem
    })));
const $ecdb6441e8b8a4f3$var$containerStyles = (0, $1ZAYh.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $ecdb6441e8b8a4f3$var$backButton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $ecdb6441e8b8a4f3$var$headingSkeleton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $ecdb6441e8b8a4f3$var$menuItem = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("ae7r0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("amXpr")
]).then(()=>parcelRequire('deFgL'));

});


parcelRegister("6DM93", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b6bf3c085c37346$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $48TMA = parcelRequire("48TMA");

var $gGtKh = parcelRequire("gGtKh");

var $lauHq = parcelRequire("lauHq");

const $9b6bf3c085c37346$var$LazyPlanSettingsSidebar = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("fl2pg")).then(({ PlanSettingsSidebar: PlanSettingsSidebar })=>PlanSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/plan-settings/src/ui/main.tsx"
});
const $9b6bf3c085c37346$var$AsyncSidebar = ({ store: store })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48TMA.SidebarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "asyncSidebarPlanSettings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lauHq.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b6bf3c085c37346$var$LazyPlanSettingsSidebar, {
        store: store
    })));
var $9b6bf3c085c37346$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($9b6bf3c085c37346$var$AsyncSidebar);

});
parcelRegister("48TMA", function(module, exports) {

$parcel$export(module.exports, "SidebarContainer", () => $0f2d4b2633604022$export$f39f3f768bc98e3d);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");
const $0f2d4b2633604022$export$f39f3f768bc98e3d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200",
        xcss: $0f2d4b2633604022$var$containerStyles
    }, children);
const $0f2d4b2633604022$var$containerStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    padding: 'space.200'
});

});

parcelRegister("lauHq", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $4b26b6b266a549df$export$8f31e4c4a37b8e9c);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");
const $4b26b6b266a549df$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b26b6b266a549df$var$menuItem
    })));
const $4b26b6b266a549df$var$titleSkeleton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-800, 64px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});
const $4b26b6b266a549df$var$backButton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});
const $4b26b6b266a549df$var$headingSkeleton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $4b26b6b266a549df$var$menuItem = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $4b26b6b266a549df$var$subtitleItem = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    width: "var(--ds-space-1000, 80px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("fl2pg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("i5Fwo")
]).then(()=>parcelRequire('6JPBu'));

});


parcelRegister("8BRHO", function(module, exports) {

$parcel$export(module.exports, "useIsConnectAppActive", () => $d87ad2d423214fae$export$249b2e8512031cae);

var $eUqFw = parcelRequire("eUqFw");

var $aPhAZ = parcelRequire("aPhAZ");

var $lB25E = parcelRequire("lB25E");

var $7vxFY = parcelRequire("7vxFY");
const $d87ad2d423214fae$export$249b2e8512031cae = ()=>{
    const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
    const { data: connectApps, error: error, loading: loading } = (0, $7vxFY.useConnectApps)();
    const isActive = (0, $eUqFw.useMemo)(()=>Boolean((0, $aPhAZ.findItemAndStack)(connectApps, route.name, location)?.selected), [
        connectApps,
        location,
        route.name
    ]);
    return {
        isActive: isActive,
        loading: loading,
        error: error
    };
};

});
parcelRegister("aPhAZ", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $975956fa8580f4db$export$751e2e6237002565);

var $hTLlD = parcelRequire("hTLlD");

var $elGVw = parcelRequire("elGVw");
// JSPA-1062 remove qs items that might not always be there
const $975956fa8580f4db$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $975956fa8580f4db$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $975956fa8580f4db$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $elGVw.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $975956fa8580f4db$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $975956fa8580f4db$var$splitRelevantQs(itemQs);
        const sameQuery = $975956fa8580f4db$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $975956fa8580f4db$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});
parcelRegister("elGVw", function(module, exports) {

$parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", () => $8ed378d04165c01c$export$a8aac2ba4dc1f57);
$parcel$export(module.exports, "CONNECT_ROUTES_SET", () => $8ed378d04165c01c$export$c47bf667d3008c53);

var $exb0h = parcelRequire("exb0h");
const $8ed378d04165c01c$export$a8aac2ba4dc1f57 = new Set([
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT)
]);
const $8ed378d04165c01c$export$c47bf667d3008c53 = new Set([
    (0, $exb0h.ROUTE_NAMES_CONNECT_PROJECT),
    (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL),
    (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
    (0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
    (0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_GENERAL)
]);

});


parcelRegister("7vxFY", function(module, exports) {

$parcel$export(module.exports, "useConnectApps", () => $ae62cc34f2dfff3a$export$4864478dcab77643);

var $eUqFw = parcelRequire("eUqFw");

var $iivTa = parcelRequire("iivTa");

var $fcFGd = parcelRequire("fcFGd");

var $dRX6p = parcelRequire("dRX6p");
const $ae62cc34f2dfff3a$export$4864478dcab77643 = ()=>{
    const { data: connectResourceItems, error: error, loading: loading } = (0, $iivTa.useProjectSettingsSidebarConnectAddonsNavigationResource)();
    const connectApps = (0, $eUqFw.useMemo)(()=>{
        if (connectResourceItems == null) return [];
        const transformedConnectApps = [];
        for (const item of connectResourceItems){
            const transformedItem = (0, $fcFGd.transformLinkV4)(item);
            if (transformedItem && !(0, $dRX6p.LEGACY_CONNECT_ITEM_IDS).has(transformedItem.id)) transformedConnectApps.push(transformedItem);
        }
        return transformedConnectApps;
    }, [
        connectResourceItems
    ]);
    return {
        data: connectApps,
        loading: loading,
        error: error
    };
};

});
parcelRegister("fcFGd", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $a0f0f23c4ab645d6$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $a0f0f23c4ab645d6$export$27267b6b6650eaa5);
const $a0f0f23c4ab645d6$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($a0f0f23c4ab645d6$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $a0f0f23c4ab645d6$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($a0f0f23c4ab645d6$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});

parcelRegister("dRX6p", function(module, exports) {

$parcel$export(module.exports, "LEGACY_CONNECT_ITEM_IDS", () => $808535a038b46717$export$911a3d81a5d162b6);
// This is a list of known legacy connect item IDs that is used to filter out unecessary connect items
// from being rendered in the connect sections
const $808535a038b46717$export$911a3d81a5d162b6 = new Set([
    // Global Settings Static Legacy IDs
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy IDs
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation'
]);

});



parcelRegister("hI8UJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $13a9a6189146b74c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lShkl = parcelRequire("lShkl");

var $lWmpu = parcelRequire("lWmpu");

var $gGtKh = parcelRequire("gGtKh");

const $13a9a6189146b74c$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("7F1Bg")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/product-discovery/src/ui/main.tsx"
});
const $13a9a6189146b74c$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.jpd-settings",
        packageName: "jiraNavigationAppsSidebarNav4ProjectSettingsJpdSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.project-settings.jpd-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($13a9a6189146b74c$var$LazySidebarContent, {
        project: project
    })));
var $13a9a6189146b74c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($13a9a6189146b74c$var$AsyncSidebar);

});
parcelRegister("7F1Bg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("7e35E")
]).then(()=>parcelRequire('0UUjB'));

});


parcelRegister("Me4cl", function(module, exports) {

$parcel$export(module.exports, "getNav4Rollout", () => $91a40f512dd6cfb8$export$84a05d3b37ec5d2);

var $Pa86f = parcelRequire("Pa86f");

var $CAsD5 = parcelRequire("CAsD5");

var $79FCd = parcelRequire("79FCd");

var $eI5EY = parcelRequire("eI5EY");

var $73h4w = parcelRequire("73h4w");

var $h5JTd = parcelRequire("h5JTd");

var $aOLta = parcelRequire("aOLta");
const $91a40f512dd6cfb8$export$84a05d3b37ec5d2 = (0, (/*@__PURE__*/$parcel$interopDefault($Pa86f)))([
    [
        ()=>!(0, $eI5EY.fg)('jira_nav4'),
        (0, (/*@__PURE__*/$parcel$interopDefault($CAsD5)))((0, $73h4w.NAV4_ROLLOUT_NONE))
    ],
    [
        ()=>(0, $eI5EY.fg)('jira_nav4_dogfooding'),
        (0, $h5JTd.getNav4RolloutForDogfooding)
    ],
    [
        ()=>(0, $eI5EY.fg)('jira_nav4_eap'),
        (0, $aOLta.getNav4RolloutForEap)
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($79FCd))),
        (0, (/*@__PURE__*/$parcel$interopDefault($CAsD5)))((0, $73h4w.NAV4_ROLLOUT_NONE))
    ]
]);

});
parcelRegister("Pa86f", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $kJvGp = parcelRequire("kJvGp");

var $7qARj = parcelRequire("7qARj");

var $9eFtX = parcelRequire("9eFtX");
/** Error message constants. */ var $099c9f12218d31c6$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that iterates over `pairs` and invokes the corresponding
 * function of the first predicate to return truthy. The predicate-function
 * pairs are invoked with the `this` binding and arguments of the created
 * function.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Array} pairs The predicate-function pairs.
 * @returns {Function} Returns the new composite function.
 * @example
 *
 * var func = _.cond([
 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
 *   [_.stubTrue,                      _.constant('no match')]
 * ]);
 *
 * func({ 'a': 1, 'b': 2 });
 * // => 'matches A'
 *
 * func({ 'a': 0, 'b': 1 });
 * // => 'matches B'
 *
 * func({ 'a': '1', 'b': '2' });
 * // => 'no match'
 */ function $099c9f12218d31c6$var$cond(pairs) {
    var length = pairs == null ? 0 : pairs.length, toIteratee = $7qARj;
    pairs = !length ? [] : $kJvGp(pairs, function(pair) {
        if (typeof pair[1] != 'function') throw new TypeError($099c9f12218d31c6$var$FUNC_ERROR_TEXT);
        return [
            toIteratee(pair[0]),
            pair[1]
        ];
    });
    return $9eFtX(function(args) {
        var index = -1;
        while(++index < length){
            var pair = pairs[index];
            if ($5VdlS(pair[0], this, args)) return $5VdlS(pair[1], this, args);
        }
    });
}
module.exports = $099c9f12218d31c6$var$cond;

});

parcelRegister("79FCd", function(module, exports) {
/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */ function $5359a7a39025697e$var$stubTrue() {
    return true;
}
module.exports = $5359a7a39025697e$var$stubTrue;

});

parcelRegister("h5JTd", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForDogfooding", () => $f6e00cb3a2c92713$export$f1e751a9a9d68fb5);

var $Pa86f = parcelRequire("Pa86f");

var $79FCd = parcelRequire("79FCd");

var $eI5EY = parcelRequire("eI5EY");

var $6mXXc = parcelRequire("6mXXc");
const $f6e00cb3a2c92713$var$dogfoodingPhase = (phase)=>()=>phase !== 3 ? {
            stage: 'dogfooding',
            phase: phase,
            isUserOptOut: (0, $6mXXc.getIsNav4UserOptOut)()
        } : {
            stage: 'dogfooding',
            phase: phase
        };
const $f6e00cb3a2c92713$export$f1e751a9a9d68fb5 = (0, (/*@__PURE__*/$parcel$interopDefault($Pa86f)))([
    [
        ()=>(0, $eI5EY.fg)('jira_nav4_dogfooding_phase-2'),
        $f6e00cb3a2c92713$var$dogfoodingPhase(2)
    ],
    [
        ()=>(0, $eI5EY.fg)('jira_nav4_dogfooding_phase-1'),
        $f6e00cb3a2c92713$var$dogfoodingPhase(1)
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($79FCd))),
        $f6e00cb3a2c92713$var$dogfoodingPhase(3)
    ]
]);

});

parcelRegister("aOLta", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForEap", () => $464a54351f32367b$export$42dd8c002a342b8);

var $6mXXc = parcelRequire("6mXXc");
const $464a54351f32367b$export$42dd8c002a342b8 = ()=>({
        stage: 'eap',
        isUserOptOut: (0, $6mXXc.getIsNav4UserOptOut)()
    });

});


parcelRegister("jn4gC", function(module, exports) {

$parcel$export(module.exports, "default", () => $09e9e174d830d213$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lShkl = parcelRequire("lShkl");

var $gGtKh = parcelRequire("gGtKh");

const $09e9e174d830d213$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("lcmGt")).then(({ SidebarContent: SidebarContent })=>SidebarContent), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebar-content/src/index.tsx"
});
const $09e9e174d830d213$var$AsyncSidebarContent = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "asyncSidebarContent",
        packageName: "jiraNavigationAppsSidebarNav4SidebarContent",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazySidebarContent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($09e9e174d830d213$var$LazySidebarContent, null))));
$09e9e174d830d213$var$AsyncSidebarContent.displayName = 'AsyncSidebarContent';
var // Used in jira/src/packages/page-container-v2/src/common/ui/sidebar
$09e9e174d830d213$export$2e2bcd8739ae039 = $09e9e174d830d213$var$AsyncSidebarContent;

});
parcelRegister("lcmGt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("ffA5u")),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("5TdXG")
]).then(()=>parcelRequire('7gn5w'));

});


parcelRegister("aBzna", function(module, exports) {

$parcel$export(module.exports, "useNavigateBack", () => $182cd1806f8e4ce8$export$7ce1f551d78f9130);
$parcel$export(module.exports, "NavigateBackProvider", () => $182cd1806f8e4ce8$export$e1e76f4ee7f8174d);

var $eUqFw = parcelRequire("eUqFw");

var $g08Zs = parcelRequire("g08Zs");

var $lB25E = parcelRequire("lB25E");

var $8yhIn = parcelRequire("8yhIn");
const $182cd1806f8e4ce8$var$STORAGE_KEY = 'back-button-url';
const $182cd1806f8e4ce8$var$NavigateBackContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $182cd1806f8e4ce8$export$7ce1f551d78f9130 = ()=>{
    const context = (0, $eUqFw.useContext)($182cd1806f8e4ce8$var$NavigateBackContext);
    if (!context) throw new Error('useNavigateBack must be used within a NavigateBackProvider');
    return context;
};
const $182cd1806f8e4ce8$export$e1e76f4ee7f8174d = ({ children: children })=>{
    const { push: push } = (0, $lB25E.useRouterActions)();
    const [previousUrl, setPreviousUrl] = (0, $eUqFw.useState)(()=>(0, $8yhIn.storageProvider).get($182cd1806f8e4ce8$var$STORAGE_KEY));
    const saveCurrentRoute = (0, $eUqFw.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const url = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        setPreviousUrl(url);
        (0, $8yhIn.storageProvider).set($182cd1806f8e4ce8$var$STORAGE_KEY, url);
    }, []);
    const goBack = (0, $eUqFw.useCallback)(()=>push(previousUrl ?? (0, $g08Zs.jiraHomeRoute).path), [
        previousUrl,
        push
    ]);
    const value = (0, $eUqFw.useMemo)(()=>({
            saveCurrentRoute: saveCurrentRoute,
            goBack: goBack
        }), [
        saveCurrentRoute,
        goBack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($182cd1806f8e4ce8$var$NavigateBackContext.Provider, {
        value: value
    }, children);
};

});
parcelRegister("g08Zs", function(module, exports) {

$parcel$export(module.exports, "jiraHomeRoute", () => $6e7a6dff76357b07$export$11ebbd6d4e57759c);

var $exb0h = parcelRequire("exb0h");
const $6e7a6dff76357b07$export$11ebbd6d4e57759c = {
    group: (0, $exb0h.ROUTE_GROUPS_HOME),
    name: (0, $exb0h.ROUTE_NAMES_YOUR_WORK),
    path: '/jira/your-work'
};

});

parcelRegister("8yhIn", function(module, exports) {

$parcel$export(module.exports, "storageProvider", () => $e8f940483c944f4b$export$ce7751641b93537d);

var $89bO2 = parcelRequire("89bO2");
const $e8f940483c944f4b$export$ce7751641b93537d = (0, $89bO2.createSessionStorageProvider)('sidebar-navigation');

});


parcelRegister("bRT5F", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad292fe394c3d387$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lShkl = parcelRequire("lShkl");

var $gGtKh = parcelRequire("gGtKh");

var $af5or = parcelRequire("af5or");

const $ad292fe394c3d387$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("39auu")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/board/src/ui/main.tsx"
});
const $ad292fe394c3d387$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.board-settings",
        packageName: "jiraNavigationAppsSidebarNav4BoardSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.board-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $af5or.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad292fe394c3d387$var$LazySidebarContent, null)));
var $ad292fe394c3d387$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($ad292fe394c3d387$var$AsyncSidebar);

});
parcelRegister("af5or", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $3e267f52e5fdc3f5$export$8f31e4c4a37b8e9c);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");
const $3e267f52e5fdc3f5$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3e267f52e5fdc3f5$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3e267f52e5fdc3f5$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3e267f52e5fdc3f5$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3e267f52e5fdc3f5$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3e267f52e5fdc3f5$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3e267f52e5fdc3f5$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3e267f52e5fdc3f5$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3e267f52e5fdc3f5$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3e267f52e5fdc3f5$var$menuItem
    })));
const $3e267f52e5fdc3f5$var$containerStyles = (0, $1ZAYh.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $3e267f52e5fdc3f5$var$backButton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $3e267f52e5fdc3f5$var$headingSkeleton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $3e267f52e5fdc3f5$var$menuItem = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("39auu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("iEy4s")
]).then(()=>parcelRequire('fb97x'));

});


parcelRegister("dAUnM", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsConnectItems", () => $41d652e03711b107$export$f0785b98c99d344c);
$parcel$export(module.exports, "useIsAppsSettingsConnectAppModule", () => $41d652e03711b107$export$8dd86b1eb9fdf786);
$parcel$export(module.exports, "useGlobalAppsSettingsConnectItemActive", () => $41d652e03711b107$export$83008eebb9fccef3);

var $eUqFw = parcelRequire("eUqFw");

var $aPhAZ = parcelRequire("aPhAZ");

var $6nvum = parcelRequire("6nvum");

var $fcFGd = parcelRequire("fcFGd");

var $5neED = parcelRequire("5neED");

var $aoOGZ = parcelRequire("aoOGZ");

var $lB25E = parcelRequire("lB25E");
const $41d652e03711b107$var$getItems = (d)=>(0, $6nvum.getLinks)(d, [
        'admin_plugins_menu'
    ], {
        skipFilter: true
    }).filter((v)=>![
            'upm_section',
            'jpo-ws-admin'
        ].includes(v.id)) // remove sections also statically defined
    .map((0, $fcFGd.transformLink)) // Apply transformation to each link
    .filter(Boolean); // Remove falsy values
const $41d652e03711b107$export$f0785b98c99d344c = ()=>{
    const { data: data, loading: loading, error: error } = (0, $5neED.useNavigationGlobalResource)();
    const items = (0, $eUqFw.useMemo)(()=>data && $41d652e03711b107$var$getItems(data), [
        data
    ]);
    return {
        data: items,
        loading: loading,
        error: error
    };
};
const $41d652e03711b107$export$ae997bf97ec22b71 = new Set([
    'configurePage',
    'postInstallPage'
]);
const $41d652e03711b107$export$8dd86b1eb9fdf786 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $aoOGZ.useConnectGeneralResource)();
    return {
        isActive: $41d652e03711b107$export$ae997bf97ec22b71.has(data?.moduleType),
        loading: loading,
        error: error
    };
};
const $41d652e03711b107$export$83008eebb9fccef3 = ()=>{
    const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
    const { data: data, loading: loading, error: error } = $41d652e03711b107$export$f0785b98c99d344c();
    const { isActive: isAppsSettingsConnectAppModuleActive, loading: isAppsSettingsConnectAppModuleLoading, error: isAppsSettingsConnectAppModuleError } = $41d652e03711b107$export$8dd86b1eb9fdf786();
    const isActive = (0, $eUqFw.useMemo)(()=>Boolean(route && data && (0, $aPhAZ.findItemAndStack)(data, route.name, location)?.selected), [
        data,
        route,
        location
    ]);
    return {
        isActive: isActive || isAppsSettingsConnectAppModuleActive,
        loading: loading || isAppsSettingsConnectAppModuleLoading,
        error: error || isAppsSettingsConnectAppModuleError
    };
};

});
parcelRegister("6nvum", function(module, exports) {

$parcel$export(module.exports, "getLinks", () => $1528aa118566e94c$export$8054dcb2b42da45c);

var $fOTKa = parcelRequire("fOTKa");
const $1528aa118566e94c$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
        if (item.id === legacyId) return item.links;
        return item.links && $1528aa118566e94c$var$findChildLinks(item.links, legacyId);
    }).find(Boolean);
const $1528aa118566e94c$var$getLinksFromSidebar = (sidebarConfig, legacyId)=>{
    const links = legacyId != null ? $1528aa118566e94c$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
    return links || [];
};
const $1528aa118566e94c$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
    const acc = [];
    locations.forEach((location)=>{
        const links = $1528aa118566e94c$var$getLinksFromSidebar(sidebarConfig, location);
        if (omitSections === true) {
            // merge 2 arrays in good performance way
            Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
            return;
        }
        // merge 2 arrays in good performance way
        Array.prototype.push.apply(acc, links);
    });
    return acc.filter((item)=>{
        if (!item) return false;
        if (skipFilter === true) return true;
        const hasConnectPrefix = item.id && item.id.includes((0, $fOTKa.connectPrefix));
        if (hasConnectPrefix) return true;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"sd-reports-addons" | "sd-queues-addons" | "com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent"'.
        const isConnectSection = (0, $fOTKa.connectSections).includes(item.id);
        if (isConnectSection) return true;
        const isJsdConnectSection = item.id && item.id.includes((0, $fOTKa.jsdConnectPrefix));
        if (isJsdConnectSection) return true;
        return false;
    });
};

});
parcelRegister("fOTKa", function(module, exports) {

$parcel$export(module.exports, "connectPrefix", () => $e4f66a9371848a2c$export$196d83ebd873fb40);
$parcel$export(module.exports, "jsdConnectPrefix", () => $e4f66a9371848a2c$export$7fac8f726f52d70);
$parcel$export(module.exports, "connectSections", () => $e4f66a9371848a2c$export$b1c2c1fc5d10280);

var $dYFw9 = parcelRequire("dYFw9");
const $e4f66a9371848a2c$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
const $e4f66a9371848a2c$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
const $e4f66a9371848a2c$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const $e4f66a9371848a2c$var$jsdQueuesConnectSection = 'sd-queues-addons';
const $e4f66a9371848a2c$export$b1c2c1fc5d10280 = [
    $e4f66a9371848a2c$var$legacyAddonPanelLinkId,
    (0, $dYFw9.REPORTS_IDS).REPORTS_ADDONS,
    $e4f66a9371848a2c$var$jsdQueuesConnectSection
];

});


parcelRegister("5neED", function(module, exports) {

$parcel$export(module.exports, "useNavigationGlobalResource", () => $e9dba7fce6b826be$export$1e1c317ed5b99faa);

var $9CFDS = parcelRequire("9CFDS");

var $lB25E = parcelRequire("lB25E");
const $e9dba7fce6b826be$export$1e1c317ed5b99faa = ()=>{
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)((0, $9CFDS.navigationSidebarGlobalResource));
    return {
        data: data && data.response,
        loading: loading,
        error: error
    };
};

});
parcelRegister("9CFDS", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarGlobalResource", () => $979e04dcc1e8ef35$export$44e7ad3c66a3f25f);

var $hdKL9 = parcelRequire("hdKL9");

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

const $979e04dcc1e8ef35$export$44e7ad3c66a3f25f = (0, $lB25E.createResource)({
    type: (0, $892a51daa0b1294e$export$fa5743fc6a1da5d8),
    getKey: ({ match: match, query: query })=>{
        // Refresh the data if the project key or id changes
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return projectKey || projectId || '__state';
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const scope = {
            projectKey: projectKey,
            projectId: projectId
        };
        const response = await (0, $hdKL9.fetchSidebarConfig)(baseUrl, scope, false);
        return {
            response: response,
            scope: scope
        };
    },
    maxAge: 300000
});

});
parcelRegister("hdKL9", function(module, exports) {

$parcel$export(module.exports, "fetchSidebarConfig", () => $7f8c4b071371acc8$export$d1d13c4b972a22f1);

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
const $7f8c4b071371acc8$var$LOGGER_LOCATION = 'navigation-next.baskets.navigation.utils';

const $7f8c4b071371acc8$var$fetchUsingProtobuf = async (url)=>{
    try {
        const fetchProtobuf = await (parcelRequire("9sh4S"));
        if (!fetchProtobuf) (0, $gUUjF.default).safeErrorWithoutCustomerData($7f8c4b071371acc8$var$LOGGER_LOCATION, 'Error dynamically loading protobuf fetch function');
        return fetchProtobuf.default(url);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($7f8c4b071371acc8$var$LOGGER_LOCATION, 'Error fetching Sidebar Configuration protocol buffer message', err);
        throw err;
    }
};
const $7f8c4b071371acc8$export$94e808b2557f52e = (baseUrl, requestQuery, version = '2', queryParams)=>{
    const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
    const params = {
        exclude: [
            'webItems.reports',
            'webItems.home',
            'webItems.gin',
            exclude
        ].filter(Boolean).join(',')
    };
    let path = '';
    if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
    else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
    else if (identifierValue != null) path = `project/${identifierValue}`;
    else {
        path = 'product';
        const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
        // Connect apps rely on project context even for the global/product scoped webItems
        const projectIdOrKey = projectId || projectKey;
        if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
    }
    const queryString = [
        new URLSearchParams(params).toString(),
        queryParams
    ].filter(Boolean).join('&');
    return `${baseUrl}/rest/navigation/${version}/${path}?${queryString}`;
};
const $7f8c4b071371acc8$export$d1d13c4b972a22f1 = async (baseUrl, requestQuery, isServer, queryParams)=>{
    if (isServer) {
        const protoUrl = $7f8c4b071371acc8$export$94e808b2557f52e(baseUrl, requestQuery, '2.1', queryParams);
        return $7f8c4b071371acc8$var$fetchUsingProtobuf(protoUrl);
    }
    const sidebarUrl = $7f8c4b071371acc8$export$94e808b2557f52e(baseUrl, requestQuery, undefined, queryParams);
    return (0, $2OdyW.default)(sidebarUrl);
};

});
parcelRegister("9sh4S", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ioYkw").then(()=>parcelRequire('bHKJS'));

});


const $892a51daa0b1294e$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';



parcelRegister("aoOGZ", function(module, exports) {

$parcel$export(module.exports, "connectGeneralResources", () => $64e1806c7cddf26f$export$f34ab0d904621847);
$parcel$export(module.exports, "useConnectGeneralResource", () => $64e1806c7cddf26f$export$53479840ec6d4024);

var $lB25E = parcelRequire("lB25E");


const $64e1806c7cddf26f$export$f34ab0d904621847 = (0, $lB25E.createResource)({
    type: (0, $4bb561a7936efe46$export$d5eed449bb62d4c1),
    getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
        // spa-router/src/common/types.js:
        /** TODO we are supporting `undefined` here because we are currently using both
		 * this version of the `Match` type, and react-routers version (which allows for `undefined`)
		 * To fix this we should move `matchPath` to our own util so we can apply our own types, then
		 * decide if we want to support undefined types.
		 */ if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("kw0Ar"))
});
const $64e1806c7cddf26f$export$53479840ec6d4024 = ()=>(0, $lB25E.useResource)($64e1806c7cddf26f$export$f34ab0d904621847);

});
const $4bb561a7936efe46$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';

parcelRegister("kw0Ar", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5H5no").then(()=>parcelRequire('aSOAb'));

});



parcelRegister("34zVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5039b64641be55e4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lShkl = parcelRequire("lShkl");

var $cUHBb = parcelRequire("cUHBb");

var $QnfMY = parcelRequire("QnfMY");

var $gGtKh = parcelRequire("gGtKh");

const $5039b64641be55e4$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("bvuD3")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/apps/src/ui/main.tsx"
});
const $5039b64641be55e4$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.apps-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsAppsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUHBb.SidebarContent), {
        currentPageName: "apps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.global-settings.apps-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $QnfMY.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5039b64641be55e4$var$LazySidebarContent, null))));
var $5039b64641be55e4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5039b64641be55e4$var$AsyncSidebar);

});
parcelRegister("cUHBb", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $12b0a1c127d27daa$export$49e8f7b58a4df4ea);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lG0Ma = parcelRequire("lG0Ma");

var $4cPGW = parcelRequire("4cPGW");

var $72HD7 = parcelRequire("72HD7");

var $3z8wI = parcelRequire("3z8wI");
const $12b0a1c127d27daa$export$49e8f7b58a4df4ea = ({ children: children, currentPageName: currentPageName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200",
        xcss: $12b0a1c127d27daa$var$settingsHeading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        grow: "hug",
        space: "space.100",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content.header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lG0Ma.BackButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $3z8wI.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $72HD7.AsyncPageSwitcher), {
        currentPageName: currentPageName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $12b0a1c127d27daa$var$contentStyles,
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cPGW.MenuList), null, children)));
};
const $12b0a1c127d27daa$var$settingsHeading = (0, $1ZAYh.xcss)({
    position: 'sticky',
    top: 'space.0',
    paddingInline: 'space.200',
    paddingBlockStart: 'space.200',
    paddingBlockEnd: 'space.100',
    backgroundColor: 'elevation.surface',
    // @ts-expect-error this is ridiculous I don't want a z-index of 100
    zIndex: 1
});
const $12b0a1c127d27daa$var$contentStyles = (0, $1ZAYh.xcss)({
    paddingBlockStart: 'space.100',
    paddingBlockEnd: 'space.200',
    paddingInline: 'space.200'
});

});
parcelRegister("lG0Ma", function(module, exports) {

$parcel$export(module.exports, "BackButton", () => $cf107329162a3248$export$e0d897ee21382f67);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $f4v4a = parcelRequire("f4v4a");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $aBzna = parcelRequire("aBzna");

var $kPgxJ = parcelRequire("kPgxJ");
const $cf107329162a3248$export$e0d897ee21382f67 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { goBack: goBack } = (0, $aBzna.useNavigateBack)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $kPgxJ.default).tooltip),
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f4v4a))),
        label: formatMessage((0, $kPgxJ.default).label),
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
            goBack();
        }
    }));
};

});
parcelRegister("f4v4a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8eff4e7c48a4dd161566c1dd735476d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af8f53d2717afebc$var$_react = $af8f53d2717afebc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $af8f53d2717afebc$var$_UNSAFE_baseNew = $af8f53d2717afebc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $af8f53d2717afebc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af8f53d2717afebc$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $af8f53d2717afebc$var$_react.default.createElement($af8f53d2717afebc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
    }, props));
$af8f53d2717afebc$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $af8f53d2717afebc$var$_default = module.exports.default = $af8f53d2717afebc$var$ArrowLeftIcon;

});

parcelRegister("kPgxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $255fdb38950f2d8d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $255fdb38950f2d8d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltip: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.tooltip",
        "defaultMessage": "Go back"
    },
    label: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.label",
        "defaultMessage": "Navigate back to the previous page"
    }
});

});


parcelRegister("4cPGW", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $842fabd92160d209$export$d4c4e98c5044dc8);

var $1XEld = parcelRequire("1XEld");
const $842fabd92160d209$export$d4c4e98c5044dc8 = (0, $1XEld.List);

});
parcelRegister("1XEld", function(module, exports) {

$parcel$export(module.exports, "List", () => $fcbf4e01cfd96c34$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");
function $fcbf4e01cfd96c34$var$_List({ children: children, xcss: xcss }, forwardedRef) {
    const internalRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        var child;
    }, []);
    const ref = (0, $1lQG9.default)([
        internalRef,
        forwardedRef
    ]);
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ $eUqFw.createElement("div", {
        role: "list",
        ref: ref,
        className: xcss
    }, children));
}
const $fcbf4e01cfd96c34$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)($fcbf4e01cfd96c34$var$_List);
/**
 * Returns true if the child is either:
 * - a list item
 * - one or more list items wrapped only in presentational elements
 */ function $fcbf4e01cfd96c34$var$isValidChild(element) {
    /**
   * These elements are ignored by screen readers.
   */ if (element.tagName === 'STYLE' || element.tagName === 'SCRIPT') return true;
    /**
   * Recursive case:
   * If this is a presentational element (no semantics) then it is valid
   * if all of its children are valid.
   *
   * This check is currently much stricter than it needs to be
   * (only allowing `div` and not allowing an explicit role).
   *
   * We can make it looser in the future if necessary.
   */ if (element.tagName === 'DIV' && element.getAttribute('role') === null) return Array.from(element.children).every($fcbf4e01cfd96c34$var$isValidChild);
    return element.getAttribute('role') === 'listitem';
}

});


parcelRegister("72HD7", function(module, exports) {

$parcel$export(module.exports, "AsyncPageSwitcher", () => $6c80d8969b7507dc$export$3130bd98029942c);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $gGtKh = parcelRequire("gGtKh");
const $6c80d8969b7507dc$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6c80d8969b7507dc$var$headingSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6c80d8969b7507dc$var$dropdownSkeleton
    }));

const $6c80d8969b7507dc$var$LazyPageSwitcher = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("afgC5")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/common/src/common/ui/page-switcher/main.tsx"
});
const $6c80d8969b7507dc$export$3130bd98029942c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.global-settings.page-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c80d8969b7507dc$export$8f31e4c4a37b8e9c, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c80d8969b7507dc$var$LazyPageSwitcher, props));
const $6c80d8969b7507dc$var$headingSkeleton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100'
});
const $6c80d8969b7507dc$var$dropdownSkeleton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});
parcelRegister("afgC5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("793fj")
]).then(()=>parcelRequire('8fdHr'));

});


parcelRegister("3z8wI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9eb69a3778100b7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e9eb69a3778100b7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading",
        "defaultMessage": "Jira admin settings"
    }
});

});


parcelRegister("QnfMY", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $d0d5f7370b633018$export$8f31e4c4a37b8e9c);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");
const $d0d5f7370b633018$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d0d5f7370b633018$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d0d5f7370b633018$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d0d5f7370b633018$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d0d5f7370b633018$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d0d5f7370b633018$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d0d5f7370b633018$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d0d5f7370b633018$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d0d5f7370b633018$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d0d5f7370b633018$var$menuItem
    }));
const $d0d5f7370b633018$var$sectionHeading = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100',
    marginTop: 'space.100'
});
const $d0d5f7370b633018$var$menuItem = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("bvuD3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("4AXY8")
]).then(()=>parcelRequire('7lWnK'));

});


parcelRegister("kmEf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $476e30e62a087ca9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lShkl = parcelRequire("lShkl");

var $cUHBb = parcelRequire("cUHBb");

var $QnfMY = parcelRequire("QnfMY");

var $gGtKh = parcelRequire("gGtKh");

const $476e30e62a087ca9$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("1wyjN")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/issues/src/ui/main.tsx"
});
const $476e30e62a087ca9$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.issues-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsIssuesSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUHBb.SidebarContent), {
        currentPageName: "issues"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.global-settings.issues-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $QnfMY.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($476e30e62a087ca9$var$LazySidebarContent, null))));
var $476e30e62a087ca9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($476e30e62a087ca9$var$AsyncSidebar);

});
parcelRegister("1wyjN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("5BIdK")
]).then(()=>parcelRequire('bRuxW'));

});


parcelRegister("4tYWR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1b95b5088aa97e5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lShkl = parcelRequire("lShkl");

var $cUHBb = parcelRequire("cUHBb");

var $QnfMY = parcelRequire("QnfMY");

var $gGtKh = parcelRequire("gGtKh");

const $f1b95b5088aa97e5$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("lqgcb")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/products/src/ui/main.tsx"
});
const $f1b95b5088aa97e5$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.products-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProductsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUHBb.SidebarContent), {
        currentPageName: "products"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.global-settings.products-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $QnfMY.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1b95b5088aa97e5$var$LazySidebarContent, null))));
var $f1b95b5088aa97e5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($f1b95b5088aa97e5$var$AsyncSidebar);

});
parcelRegister("lqgcb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("byhZn")
]).then(()=>parcelRequire('5lK5p'));

});


parcelRegister("6WLSW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b2df53e500ae7e1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lShkl = parcelRequire("lShkl");

var $cUHBb = parcelRequire("cUHBb");

var $QnfMY = parcelRequire("QnfMY");

var $gGtKh = parcelRequire("gGtKh");

const $1b2df53e500ae7e1$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("cqRYK")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/projects/src/ui/main.tsx"
});
const $1b2df53e500ae7e1$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.projects-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProjectsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUHBb.SidebarContent), {
        currentPageName: "projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.global-settings.projects-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $QnfMY.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b2df53e500ae7e1$var$LazySidebarContent, null))));
var $1b2df53e500ae7e1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($1b2df53e500ae7e1$var$AsyncSidebar);

});
parcelRegister("cqRYK", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("1jvGc")
]).then(()=>parcelRequire('eQtcl'));

});


parcelRegister("9F5X0", function(module, exports) {

$parcel$export(module.exports, "useGlobalSystemSettingsConnectItems", () => $1144fe1f38e08ee0$export$68950d4e14439158);
$parcel$export(module.exports, "useGlobalSystemSettingsConnectItemActive", () => $1144fe1f38e08ee0$export$5efb701a2106707a);

var $eUqFw = parcelRequire("eUqFw");

var $hHbj7 = parcelRequire("hHbj7");

var $aPhAZ = parcelRequire("aPhAZ");

var $6nvum = parcelRequire("6nvum");

var $fcFGd = parcelRequire("fcFGd");

var $5neED = parcelRequire("5neED");

var $aoOGZ = parcelRequire("aoOGZ");

var $lB25E = parcelRequire("lB25E");
const $1144fe1f38e08ee0$var$getItems = (d)=>(0, $6nvum.getLinks)(d, [
        'admin_system_menu'
    ], {
        skipFilter: true
    }).map((0, $fcFGd.transformLink)) // Apply transformation to each link
    .filter(Boolean); // Remove falsy values
const $1144fe1f38e08ee0$export$68950d4e14439158 = (0, $hHbj7.withThrowOnError)(()=>{
    const { data: data, loading: loading, error: error } = (0, $5neED.useNavigationGlobalResource)();
    const items = (0, $eUqFw.useMemo)(()=>data && $1144fe1f38e08ee0$var$getItems(data), [
        data
    ]);
    return {
        data: items,
        loading: loading,
        error: error
    };
});
const $1144fe1f38e08ee0$export$5efb701a2106707a = ()=>{
    const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
    const { data: data, loading: loading, error: error } = $1144fe1f38e08ee0$export$68950d4e14439158();
    const { data: connectGeneralData, loading: connectGeneralResourceLoading, error: connectGeneralResourceError } = (0, $aoOGZ.useConnectGeneralResource)();
    const isActive = (0, $eUqFw.useMemo)(()=>Boolean(route && data && (0, $aPhAZ.findItemAndStack)(data, route.name, location)?.selected), [
        data,
        route,
        location
    ]);
    return {
        isActive: isActive || connectGeneralData?.moduleType === 'adminPages',
        loading: loading || connectGeneralResourceLoading,
        error: error || connectGeneralResourceError
    };
};

});
parcelRegister("hHbj7", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $5c8abedc1df9715b$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $asu8X = parcelRequire("asu8X");
const $5c8abedc1df9715b$var$isDataEmpty = (data)=>data == null;
function $5c8abedc1df9715b$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $asu8X.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $5c8abedc1df9715b$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});


parcelRegister("92Zmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e92f2f5982a74b52$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lShkl = parcelRequire("lShkl");

var $cUHBb = parcelRequire("cUHBb");

var $QnfMY = parcelRequire("QnfMY");

var $gGtKh = parcelRequire("gGtKh");

const $e92f2f5982a74b52$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("gekP6")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/system/src/ui/main.tsx"
});
const $e92f2f5982a74b52$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.system-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsSystemSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUHBb.SidebarContent), {
        currentPageName: "system"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.global-settings.system-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $QnfMY.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e92f2f5982a74b52$var$LazySidebarContent, null))));
var $e92f2f5982a74b52$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e92f2f5982a74b52$var$AsyncSidebar);

});
parcelRegister("gekP6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ceXlX")
]).then(()=>parcelRequire('77EGT'));

});


parcelRegister("jq6Xe", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f8d8658113235b9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lShkl = parcelRequire("lShkl");

var $48TMA = parcelRequire("48TMA");

var $gGtKh = parcelRequire("gGtKh");

var $cKF63 = parcelRequire("cKF63");

const $4f8d8658113235b9$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("j8fPs")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/help-center/src/ui/main.tsx"
});
const $4f8d8658113235b9$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.help-center-settings",
        packageName: "jiraNavigationAppsSidebarNav4HelpCenterSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48TMA.SidebarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.help-center-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cKF63.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f8d8658113235b9$var$LazySidebarContent, null))));
var $4f8d8658113235b9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($4f8d8658113235b9$var$AsyncSidebar);

});
parcelRegister("cKF63", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $9c4c2dd87b529409$export$8f31e4c4a37b8e9c);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");
const $9c4c2dd87b529409$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9c4c2dd87b529409$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9c4c2dd87b529409$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9c4c2dd87b529409$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9c4c2dd87b529409$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9c4c2dd87b529409$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9c4c2dd87b529409$var$menuItem
    })));
const $9c4c2dd87b529409$var$backButton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $9c4c2dd87b529409$var$headingSkeleton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $9c4c2dd87b529409$var$menuItem = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("j8fPs", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kjPEX")
]).then(()=>parcelRequire('dbxzr'));

});


parcelRegister("aPW8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $d04876580b04a5ef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lShkl = parcelRequire("lShkl");

var $lWmpu = parcelRequire("lWmpu");

var $gGtKh = parcelRequire("gGtKh");

const $d04876580b04a5ef$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("eHLHT")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/software/company-managed/src/ui/main.tsx"
});
const $d04876580b04a5ef$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.software.company-managed",
        packageName: "jiraNavigationAppsSidebarNav4SoftwareCompanyManagedProjectSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.project-settings.software.company-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d04876580b04a5ef$var$LazySidebarContent, {
        project: project
    })));
var $d04876580b04a5ef$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($d04876580b04a5ef$var$AsyncSidebar);

});
parcelRegister("eHLHT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("Q7U4x")
]).then(()=>parcelRequire('eKUup'));

});


parcelRegister("gBUa5", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcbb7b7d2a385bc0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lShkl = parcelRequire("lShkl");

var $lWmpu = parcelRequire("lWmpu");

var $gGtKh = parcelRequire("gGtKh");

const $fcbb7b7d2a385bc0$var$LazySidebarContent = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("j0onK")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/software/team-managed/src/ui/main.tsx"
});
const $fcbb7b7d2a385bc0$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.software.team-managed",
        packageName: "jiraNavigationAppsSidebarNav4SoftwareTeamManagedProjectSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.project-settings.software.team-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fcbb7b7d2a385bc0$var$LazySidebarContent, {
        project: project
    })));
var $fcbb7b7d2a385bc0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($fcbb7b7d2a385bc0$var$AsyncSidebar);

});
parcelRegister("j0onK", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("2XyHk")
]).then(()=>parcelRequire('hmJNm'));

});



parcelRegister("4QXXR", function(module, exports) {

$parcel$export(module.exports, "SidebarSelectorProvider", () => $2fdc1a9dd738acc8$export$6af584355cfb32c6);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $7ZZxN = parcelRequire("7ZZxN");

var $cPEpP = parcelRequire("cPEpP");

var $7Fu43 = parcelRequire("7Fu43");

var $497qU = parcelRequire("497qU");

var $1ykEC = parcelRequire("1ykEC");

var $jGUct = parcelRequire("jGUct");

var $hTlnZ = parcelRequire("hTlnZ");

var $h2JwC = parcelRequire("h2JwC");

var $fpWGf = parcelRequire("fpWGf");

var $2RJCt = parcelRequire("2RJCt");

var $2jFgb = parcelRequire("2jFgb");

var $buaC1 = parcelRequire("buaC1");

var $6cIOm = parcelRequire("6cIOm");

var $jAMQL = parcelRequire("jAMQL");

var $5w4hM = parcelRequire("5w4hM");

var $hUM03 = parcelRequire("hUM03");

var $bt7QT = parcelRequire("bt7QT");

var $lWODs = parcelRequire("lWODs");

var $iOOlt = parcelRequire("iOOlt");

var $29Nmz = parcelRequire("29Nmz");

var $bSRyW = parcelRequire("bSRyW");

var $iTYGl = parcelRequire("iTYGl");

var $2Fzrk = parcelRequire("2Fzrk");

var $8rBPw = parcelRequire("8rBPw");

var $aoOGZ = parcelRequire("aoOGZ");

var $lB25E = parcelRequire("lB25E");
const $2fdc1a9dd738acc8$var$renderProjectSidebar = ({ data: project, loading: loading })=>{
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), {
        isFull: true
    });
    if (!project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8rBPw.default), null);
    switch(project.type){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
        case 0, $7ZZxN.CUSTOMER_SERVICE_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iTYGl.default), null);
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bSRyW.default), null);
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (project.isSimplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iOOlt.default), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Fzrk.default), null);
        case 0, $7ZZxN.CORE_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $buaC1.default), null);
        default:
            // TODO: render error
            return null;
    }
};
// Since argument of `renderProjectSidebar` is similar to `props` object of a React component
// so we can convert normal function to functional component
const $2fdc1a9dd738acc8$var$ProjectSidebar = /*#__PURE__*/ (0, $eUqFw.memo)($2fdc1a9dd738acc8$var$renderProjectSidebar, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
const $2fdc1a9dd738acc8$export$6af584355cfb32c6 = ({ sidebar: sidebar, children: children })=>{
    const projectState = (0, $cPEpP.useProject)();
    const isInsightMenuSelected = (0, $h2JwC.useInsight)();
    const shouldRenderInsightObjectSchemaSidebar = (0, $h2JwC.useInsightObjectSchemaSidebar)();
    const { selected: pSelected, loading: pLoading } = (0, $2jFgb.useProjectConnectItems)();
    const { selected: prSelected, loading: prLoading } = (0, $fpWGf.useProjectReportsConnectItems)();
    const { selected: psSelected, loading: psLoading } = (0, $2RJCt.useProjectSettingsConnectItems)();
    const { selected: gSelected, loading: gLoading } = (0, $hTlnZ.useGlobalConnectItems)();
    const { selected: gsSelected, loading: gsLoading } = (0, $jGUct.useGlobalSettingsConnectItems)();
    const { selected: gssSelected, loading: gssLoading } = (0, $1ykEC.useGlobalSettingsSystemConnectItems)();
    const { data: gresData, loading: gresLoading } = (0, $lB25E.useResource)((0, $aoOGZ.connectGeneralResources));
    const { sections: fgSections, loading: fgLoading } = (0, $jAMQL.useForgeGlobalPageItems)();
    // CHOOK-247 - move to 'servicedesk-cmdb-object-schema' route in packages/routes/src/ui/spa/servicedesk/cmdb/index.js
    // once new page is rolled out. Hard-coded here since it isn't possible to have the Route navigation.sidebar
    // property change dynamically at runtime.
    if (shouldRenderInsightObjectSchemaSidebar) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWODs.default), null));
    if (isInsightMenuSelected) // fullscreen connect with no sidebar
    return null;
    if (sidebar === (0, $29Nmz.default)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29Nmz.default), null));
    if (sidebar === (0, $6cIOm.default)) {
        if (fgLoading) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), {
            isFull: true
        }));
        if (fgSections?.length) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6cIOm.default), null));
        return children(null);
    }
    if (!Array.isArray(sidebar)) {
        const Sidebar = sidebar;
        return children(Sidebar != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Sidebar, null) : null);
    }
    if (sidebar === (0, $5w4hM.genericConnectSidebars)) {
        const foundInProject = pSelected || prSelected || psSelected || [
            'jiraProjectAdminTabPanels'
        ].includes(gresData?.moduleType);
        const foundSomewhere = foundInProject || gSelected || gsSelected || gssSelected;
        const stillLoading = pLoading || prLoading || psLoading || gLoading || gsLoading || gssLoading || gresLoading;
        if (stillLoading && !foundSomewhere) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), {
            isFull: true
        }));
        if (foundInProject) {
            const projectSidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2fdc1a9dd738acc8$var$ProjectSidebar, projectState);
            return children(projectSidebar);
        }
        if (gSelected) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $497qU.default), null));
        if (gsSelected || [
            'configurePage',
            'postInstallPage'
        ].includes(gresData?.moduleType)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUM03.default), null));
        if (gssSelected || [
            'adminPages'
        ].includes(gresData?.moduleType)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bt7QT.default), null));
        // not found, assume fullscreen connect with no sidebar
        return children(null);
    }
    const projectSidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2fdc1a9dd738acc8$var$ProjectSidebar, projectState);
    return children(projectSidebar);
};

});
parcelRegister("7Fu43", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $64b74158f6952660$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $apShl = parcelRequire("apShl");
const $64b74158f6952660$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "sidebar-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64b74158f6952660$var$BackgroundedWrapper, null, isFull && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64b74158f6952660$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64b74158f6952660$var$BackgroundedWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tem _1yt4s5g3",
            __cmplp.className
        ])
    });
});
const $64b74158f6952660$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41k9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7eyVf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1046e4bd7e18e79$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8BKky = parcelRequire("8BKky");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
// Type needed on props to extract types with extract react types.
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $c1046e4bd7e18e79$var$Section = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        ...props,
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
        overrides: {
            HeadingItem: {
                cssFn: (0, $jvM56.sectionHeaderSpacingStyles)
            }
        }
    });
});
var $c1046e4bd7e18e79$export$2e2bcd8739ae039 = $c1046e4bd7e18e79$var$Section;

});
parcelRegister("jvM56", function(module, exports) {

$parcel$export(module.exports, "overrideStyleFunction", () => $451539d16e759684$export$505cedac1a39aacf);
$parcel$export(module.exports, "baseSideNavItemStyle", () => $451539d16e759684$export$aed216a85ec468ac);
$parcel$export(module.exports, "sectionHeaderSpacingStyles", () => $451539d16e759684$export$a5c27bed78cfecb9);

const $451539d16e759684$export$505cedac1a39aacf = (baseStyle, newStyle = ()=>({}))=>{
    return (state)=>{
        return [
            baseStyle(state),
            newStyle(state)
        ];
    };
};
const $451539d16e759684$var$defaultStyles = {
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
    },
    '&:active': {
        color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`
    }
};
const $451539d16e759684$var$selectedStyles = {
    backgroundColor: `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    ':visited': {
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
    },
    '&:active': {
        backgroundColor: `var(--ds-background-selected-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
    }
};
const $451539d16e759684$export$aed216a85ec468ac = ({ isSelected: isSelected, isDisabled: isDisabled })=>{
    return {
        // This padding is set to ensure that the center of the left icon
        // is approximately center aligned with the horizontal app switcher.
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-100, 8px)",
        borderRadius: "var(--ds-border-radius, 3px)",
        // -- TODO: DELETE THESE COLOR OVERRIDES WHEN CLEANING UP FALLBACK THEMING --
        // Menu and side navigation are now color aligned so they do not need this!
        // See: https://product-fabric.atlassian.net/browse/DSP-1684
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        ...!isDisabled && !isSelected && $451539d16e759684$var$defaultStyles,
        ...!isDisabled && isSelected && $451539d16e759684$var$selectedStyles,
        // -- END TODO --------------------------------------------------------------
        ['& [data-item-elem-before]']: {
            height: '1.5rem',
            width: '1.5rem'
        }
    };
};
const $451539d16e759684$export$a5c27bed78cfecb9 = ()=>{
    return {
        paddingInline: "var(--ds-space-100, 8px)"
    };
};

});


parcelRegister("gLn5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $a96e6894a019ef04$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aVkzK = parcelRequire("aVkzK");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
/**
 * __Skeleton item__
 *
 * A skeleton item can be used to reduce the perceived loading time.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#loading)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $a96e6894a019ef04$var$SkeletonItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
        cssFn: ()=>({
                ...(0, $jvM56.sectionHeaderSpacingStyles)(),
                // This doubles up & to get a higher specificity as well as to not overwite the base styles.
                '&&::before': {
                    height: '1.5rem',
                    marginRight: "var(--ds-space-200, 16px)",
                    width: '1.5rem'
                }
            }),
        ...props
    });
};
var $a96e6894a019ef04$export$2e2bcd8739ae039 = $a96e6894a019ef04$var$SkeletonItem;

});


parcelRegister("497qU", function(module, exports) {

$parcel$export(module.exports, "default", () => $113f60a6a5bc48c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $113f60a6a5bc48c3$var$LazyConnectSidebar = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("20902")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $113f60a6a5bc48c3$var$ConnectSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "connect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($113f60a6a5bc48c3$var$LazyConnectSidebar, null)));
$113f60a6a5bc48c3$var$ConnectSidebar.displayName = 'ConnectSidebar';
var $113f60a6a5bc48c3$export$2e2bcd8739ae039 = $113f60a6a5bc48c3$var$ConnectSidebar;

});
parcelRegister("9RvDp", function(module, exports) {

$parcel$export(module.exports, "SidebarBoundary", () => $a0579ef23379c6d1$export$1edc778464f08256);

var $eUqFw = parcelRequire("eUqFw");

var $8fxTv = parcelRequire("8fxTv");

var $7webZ = parcelRequire("7webZ");

var $gGtKh = parcelRequire("gGtKh");

var $4C6RK = parcelRequire("4C6RK");

var $u0mbR = parcelRequire("u0mbR");

var $7Fu43 = parcelRequire("7Fu43");
const $a0579ef23379c6d1$export$1edc778464f08256 = ({ children: children, id: id })=>{
    const onFail = (0, $u0mbR.useSidebarFail)();
    const onSuccess = (0, $u0mbR.useSidebarSuccess)();
    const onError = (0, $eUqFw.useCallback)((location, error)=>{
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
        const { statusCode: statusCode } = error;
        if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
        else onFail(location, error);
    }, [
        onFail,
        onSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4C6RK.SidebarErrorBoundary), {
        id: id,
        packageName: "jiraSpaAppsSidebarCommon",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderAttempt
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarSSRPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav-sidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), {
            isFull: true
        })
    }, children));
};

});
parcelRegister("4C6RK", function(module, exports) {

$parcel$export(module.exports, "SidebarErrorBoundary", () => $5b97a95fb0135b37$export$62853c5766dad0c4);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $keguF = parcelRequire("keguF");

var $gq8Ge = parcelRequire("gq8Ge");
const $5b97a95fb0135b37$export$62853c5766dad0c4 = (props)=>{
    const userLocation = (0, $keguF.getUserLocation)();
    const extraEventData = (0, $eUqFw.useMemo)(()=>({
            ...props.extraEventData,
            userLocation: userLocation
        }), [
        props.extraEventData,
        userLocation
    ]);
    const fallback = (0, $eUqFw.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gq8Ge.Fallback), {
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        ...props,
        extraEventData: extraEventData,
        fallback: fallback
    });
};

});
parcelRegister("gq8Ge", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $ca78cb141c4c2211$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $iH6c1 = parcelRequire("iH6c1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4EIGo = parcelRequire("4EIGo");

var $gnvfi = parcelRequire("gnvfi");
const $ca78cb141c4c2211$var$styles = {
    wrapper: "_bfhk1jdc _syaz1mjl _1yt4pxbi _y3gn1h6o _4cvr1h6o _zulpu2gc _1e0c1txw _2lx21bp4",
    error: "_2rko9j3y _1wybqk37 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
    image: "_4t3i12am"
};
const $ca78cb141c4c2211$export$fb8d7f40caaeea67 = (props)=>{
    const { error: error } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $ca78cb141c4c2211$var$styles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4EIGo))),
        className: (0, $7JEyt.default)([
            $ca78cb141c4c2211$var$styles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, formatMessage((0, $gnvfi.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $gnvfi.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("code", {
        className: (0, $7JEyt.default)([
            $ca78cb141c4c2211$var$styles.error
        ])
    }, "ERROR: ", (0, $iH6c1.getErrorHash)(error)));
};

});
parcelRegister("4EIGo", function(module, exports) {
module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();

});

parcelRegister("gnvfi", function(module, exports) {

$parcel$export(module.exports, "default", () => $525f5b24291fe557$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $525f5b24291fe557$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorHeading: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});




parcelRegister("av9ef", function(module, exports) {

$parcel$export(module.exports, "setPerformanceMarkLoadStart", () => $f6954eb5e712c16f$export$4166241bf9111f66);
$parcel$export(module.exports, "setPerformanceMarkLoadEnd", () => $f6954eb5e712c16f$export$edbd543f308bbef5);

var $8fxTv = parcelRequire("8fxTv");

var $7webZ = parcelRequire("7webZ");
const $f6954eb5e712c16f$export$4166241bf9111f66 = ()=>{
    const sideBarSegment = (0, $8fxTv.pageSegmentStore).getSegment((0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadStart);
};
const $f6954eb5e712c16f$export$edbd543f308bbef5 = ()=>{
    const sideBarSegment = (0, $8fxTv.pageSegmentStore).getSegment((0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadEnd);
};

});

parcelRegister("20902", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("8ciKp")
]).then(()=>parcelRequire('jSzUd'));

});


parcelRegister("1ykEC", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", () => $9751bf35bdfd526e$export$f601efaceb0636f4);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2z5XU = parcelRequire("2z5XU");

var $lB25E = parcelRequire("lB25E");

var $9I91h = parcelRequire("9I91h");

var $g9Ou9 = parcelRequire("g9Ou9");

var $kNXHh = parcelRequire("kNXHh");
// use memoised functions per hook to avoid re-computation between same hooks
const $9751bf35bdfd526e$var$getItemsMemo = (0, $5iWql.default)((d)=>(0, $g9Ou9.getLinks)(d, [
        'admin_system_menu'
    ], {
        skipFilter: true
    }).map((0, $kNXHh.transformLink)).filter(Boolean));
const $9751bf35bdfd526e$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $9751bf35bdfd526e$export$f601efaceb0636f4 = ()=>{
    const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2z5XU.useNavigationGlobalResource)();
    const items = (0, $eUqFw.useMemo)(()=>data && $9751bf35bdfd526e$var$getItemsMemo(data), [
        data
    ]);
    const found = (0, $eUqFw.useMemo)(()=>route && items && $9751bf35bdfd526e$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});
parcelRegister("2z5XU", function(module, exports) {

$parcel$export(module.exports, "useNavigationGlobalResource", () => $c76604c890e3e940$export$1e1c317ed5b99faa);

var $eUqFw = parcelRequire("eUqFw");

var $9CFDS = parcelRequire("9CFDS");

var $lB25E = parcelRequire("lB25E");
const $c76604c890e3e940$export$1e1c317ed5b99faa = ()=>{
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)((0, $9CFDS.navigationSidebarGlobalResource));
    const response = (0, $eUqFw.useMemo)(()=>data && data.response, [
        data
    ]);
    return {
        data: response,
        loading: loading,
        error: error
    };
};

});

parcelRegister("9I91h", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $d193dad52b41fe54$export$751e2e6237002565);

var $hTLlD = parcelRequire("hTLlD");

var $elGVw = parcelRequire("elGVw");
// JSPA-1062 remove qs items that might not always be there
const $d193dad52b41fe54$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $d193dad52b41fe54$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $d193dad52b41fe54$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $elGVw.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $d193dad52b41fe54$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $d193dad52b41fe54$var$splitRelevantQs(itemQs);
        const sameQuery = $d193dad52b41fe54$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $d193dad52b41fe54$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});

parcelRegister("g9Ou9", function(module, exports) {

$parcel$export(module.exports, "getLinks", () => $bab768b8bde7a570$export$8054dcb2b42da45c);

var $lDq4g = parcelRequire("lDq4g");

var $WYbts = parcelRequire("WYbts");
const $bab768b8bde7a570$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
    const acc = [];
    locations.forEach((location)=>{
        const links = (0, $lDq4g.getLinksFromSidebar)(sidebarConfig, location);
        if (omitSections === true) {
            // merge 2 arrays in good performance way
            Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
            return;
        }
        // merge 2 arrays in good performance way
        Array.prototype.push.apply(acc, links);
    });
    return acc.filter((item)=>{
        if (!item) return false;
        if (skipFilter === true) return true;
        const hasConnectPrefix = item.id && item.id.includes((0, $WYbts.connectPrefix));
        if (hasConnectPrefix) return true;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"sd-reports-addons" | "sd-queues-addons" | "com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent"'.
        const isConnectSection = (0, $WYbts.connectSections).includes(item.id);
        if (isConnectSection) return true;
        const isJsdConnectSection = item.id && item.id.includes((0, $WYbts.jsdConnectPrefix));
        if (isJsdConnectSection) return true;
        return false;
    });
};

});
parcelRegister("lDq4g", function(module, exports) {

$parcel$export(module.exports, "hasItemInSidebar", () => $7cfca2f550cf53a3$export$57dd40eec4c64521);
$parcel$export(module.exports, "getLinksFromSidebar", () => $7cfca2f550cf53a3$export$9b7e0e4dd8bfade8);
const $7cfca2f550cf53a3$var$findLink = (arrayOfLinks, legacyId, partialMatch = false)=>{
    if (!Array.isArray(arrayOfLinks)) return undefined;
    for(let i = 0; i < arrayOfLinks.length; i += 1){
        const link = arrayOfLinks[i];
        if (partialMatch && link.id.indexOf(legacyId) === 0) return link;
        if (link.id === legacyId) return link;
        if (link.links) {
            const linkFound = $7cfca2f550cf53a3$var$findLink(link.links, legacyId, partialMatch);
            if (linkFound) return linkFound;
        }
    }
    return undefined;
};
const $7cfca2f550cf53a3$export$f62346e9b1894488 = (sidebarConfig, legacyId, partialMatch = false)=>sidebarConfig && sidebarConfig.product && $7cfca2f550cf53a3$var$findLink(sidebarConfig.product.links, legacyId, partialMatch) || undefined;
const $7cfca2f550cf53a3$export$57dd40eec4c64521 = (sidebarConfig, legacyId, partialMatch)=>Boolean($7cfca2f550cf53a3$export$f62346e9b1894488(sidebarConfig, legacyId, partialMatch));
const $7cfca2f550cf53a3$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
        if (item.id === legacyId) return item.links;
        return item.links && $7cfca2f550cf53a3$var$findChildLinks(item.links, legacyId);
    }).find(Boolean);
const $7cfca2f550cf53a3$export$9b7e0e4dd8bfade8 = (sidebarConfig, legacyId)=>{
    const links = legacyId != null ? $7cfca2f550cf53a3$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
    return links || [];
};

});

parcelRegister("WYbts", function(module, exports) {

$parcel$export(module.exports, "connectPrefix", () => $43407c27ba6284fa$export$196d83ebd873fb40);
$parcel$export(module.exports, "jsdConnectPrefix", () => $43407c27ba6284fa$export$7fac8f726f52d70);
$parcel$export(module.exports, "connectSections", () => $43407c27ba6284fa$export$b1c2c1fc5d10280);

var $bgNoL = parcelRequire("bgNoL");
const $43407c27ba6284fa$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
const $43407c27ba6284fa$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
const $43407c27ba6284fa$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const $43407c27ba6284fa$var$jsdQueuesConnectSection = 'sd-queues-addons';
const $43407c27ba6284fa$export$b1c2c1fc5d10280 = [
    $43407c27ba6284fa$var$legacyAddonPanelLinkId,
    (0, $bgNoL.REPORTS_IDS).REPORTS_ADDONS,
    $43407c27ba6284fa$var$jsdQueuesConnectSection
];

});


parcelRegister("kNXHh", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $2d642e9f9a6a4f93$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $2d642e9f9a6a4f93$export$27267b6b6650eaa5);
const $2d642e9f9a6a4f93$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($2d642e9f9a6a4f93$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $2d642e9f9a6a4f93$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($2d642e9f9a6a4f93$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});


parcelRegister("jGUct", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsConnectItems", () => $6494416747689c30$export$f0785b98c99d344c);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2z5XU = parcelRequire("2z5XU");

var $lB25E = parcelRequire("lB25E");

var $9I91h = parcelRequire("9I91h");

var $g9Ou9 = parcelRequire("g9Ou9");

var $kNXHh = parcelRequire("kNXHh");
// use memoised functions per hook to avoid re-computation between same hooks
const $6494416747689c30$var$getItemsMemo = (0, $5iWql.default)((d)=>(0, $g9Ou9.getLinks)(d, [
        'admin_plugins_menu'
    ], {
        skipFilter: true
    })// remove sections also statically defined
    .filter((v)=>![
            'upm_section',
            'jpo-ws-admin'
        ].includes(v.id)).map((0, $kNXHh.transformLink)).filter(Boolean));
const $6494416747689c30$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $6494416747689c30$export$f0785b98c99d344c = ()=>{
    const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2z5XU.useNavigationGlobalResource)();
    const items = (0, $eUqFw.useMemo)(()=>data && $6494416747689c30$var$getItemsMemo(data), [
        data
    ]);
    const found = (0, $eUqFw.useMemo)(()=>route && items && $6494416747689c30$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("hTlnZ", function(module, exports) {

$parcel$export(module.exports, "useGlobalConnectItems", () => $c8e671af8fdbb6ce$export$ee355b2e42d6462b);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2z5XU = parcelRequire("2z5XU");

var $lB25E = parcelRequire("lB25E");

var $9I91h = parcelRequire("9I91h");

var $g9Ou9 = parcelRequire("g9Ou9");

var $kNXHh = parcelRequire("kNXHh");
// use memoised functions per hook to avoid re-computation between same hooks
const $c8e671af8fdbb6ce$var$getItemsMemo = (0, $5iWql.default)((d)=>(0, $g9Ou9.getLinks)(d, [
        'global-navigation-product'
    ]).map((0, $kNXHh.transformLink)).filter((item)=>item != null && item.items));
const $c8e671af8fdbb6ce$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $c8e671af8fdbb6ce$export$ee355b2e42d6462b = ()=>{
    const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2z5XU.useNavigationGlobalResource)();
    const sidebars = (0, $eUqFw.useMemo)(()=>data && $c8e671af8fdbb6ce$var$getItemsMemo(data), [
        data
    ]);
    const searchResult = (0, $eUqFw.useMemo)(()=>{
        let result = {
            stack: [],
            selected: null,
            title: null,
            data: null
        };
        if (sidebars != null) sidebars.some((sidebar)=>{
            const { items: items } = sidebar || {};
            if (!sidebar || !route || items == null) return false;
            const found = $c8e671af8fdbb6ce$var$findItemAndStackMemo(items, route.name, location);
            if (found) {
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'null'. | TS2322 - Type 'ConnectDataItem[]' is not assignable to type 'null'.
                result = {
                    ...found,
                    title: sidebar.name,
                    data: items
                };
                return true;
            }
            return false;
        });
        return result;
    }, [
        sidebars,
        route,
        location
    ]);
    return {
        ...searchResult,
        loading: loading,
        error: error
    };
};

});

parcelRegister("h2JwC", function(module, exports) {

$parcel$export(module.exports, "useInsight", () => $051bcb4b32f93938$export$e24dad0705701755);
$parcel$export(module.exports, "useInsightObjectSchemaSidebar", () => $051bcb4b32f93938$export$1f0bd21403710fc);

var $6FP8W = parcelRequire("6FP8W");

var $10fdS = parcelRequire("10fdS");
const $051bcb4b32f93938$export$e24dad0705701755 = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    if (route.navigation) return route.navigation.menuId === 'INSIGHT';
    return false;
};
const $051bcb4b32f93938$export$1f0bd21403710fc = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    if ((0, $6FP8W.getWillShowNav4)()) return false;
    return route.name === 'servicedesk-cmdb-object-schema';
};

});

parcelRegister("fpWGf", function(module, exports) {

$parcel$export(module.exports, "useProjectReportsConnectItems", () => $45778cdd51b28ac7$export$a1c75c386c088992);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2futN = parcelRequire("2futN");

var $lB25E = parcelRequire("lB25E");

var $9I91h = parcelRequire("9I91h");

var $kNXHh = parcelRequire("kNXHh");
const $45778cdd51b28ac7$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $45778cdd51b28ac7$export$a1c75c386c088992 = ()=>{
    const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2futN.useProjectReportsSidebarConnectNavigation)();
    const items = (0, $eUqFw.useMemo)(()=>data != null ? data.map((0, $kNXHh.transformLinkV4)).filter(Boolean) : [], [
        data
    ]);
    const found = (0, $eUqFw.useMemo)(()=>route && items && $45778cdd51b28ac7$var$findItemAndStackMemo(items, route.name, location, [
            'reports'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        error: error,
        loading: loading,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("2RJCt", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $06b43f573ecea160$export$41a50100db18b578);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2futN = parcelRequire("2futN");

var $lB25E = parcelRequire("lB25E");

var $9I91h = parcelRequire("9I91h");

var $kNXHh = parcelRequire("kNXHh");
// use memoised functions per hook to avoid re-computation between same hooks
const $06b43f573ecea160$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $06b43f573ecea160$export$41a50100db18b578 = ()=>{
    const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2futN.useProjectSettingsSidebarConnectNavigation)();
    const items = (0, $eUqFw.useMemo)(()=>data && data.map((0, $kNXHh.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $eUqFw.useMemo)(()=>route && items && $06b43f573ecea160$var$findItemAndStackMemo(items, route.name, location, [
            'settings'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("2jFgb", function(module, exports) {

$parcel$export(module.exports, "useProjectConnectItems", () => $5f83aec5eda9bdea$export$f23d0c24c77d7608);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2futN = parcelRequire("2futN");

var $lB25E = parcelRequire("lB25E");

var $9I91h = parcelRequire("9I91h");

var $kNXHh = parcelRequire("kNXHh");
const $5f83aec5eda9bdea$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $5f83aec5eda9bdea$export$f23d0c24c77d7608 = ()=>{
    const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2futN.useProjectSidebarConnectNavigation)();
    const items = (0, $eUqFw.useMemo)(()=>data && data.map((0, $kNXHh.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $eUqFw.useMemo)(()=>route && items && $5f83aec5eda9bdea$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("buaC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c95c2ed1c1661f63$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

var $6VZoe = parcelRequire("6VZoe");

const $c95c2ed1c1661f63$var$LazyCoreProjectSidebar = (0, $6VZoe.lazyForPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return Promise.resolve((parcelRequire("9urUx"))).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/business/navigation/sidebar/src/ui/index.tsx"
});
const $c95c2ed1c1661f63$var$CoreProjectSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "coreProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c95c2ed1c1661f63$var$LazyCoreProjectSidebar, null));
var $c95c2ed1c1661f63$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c95c2ed1c1661f63$var$CoreProjectSidebar);

});

parcelRegister("6cIOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffa0ed116b82264e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $ffa0ed116b82264e$var$LazyForPaintForgeGlobalPageSidebar = (0, $6VZoe.lazyForPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("lCHrb")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/forge-global-page/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ffa0ed116b82264e$var$ForgeGlobalPageSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "forgeGlobalPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ffa0ed116b82264e$var$LazyForPaintForgeGlobalPageSidebar, null)));
$ffa0ed116b82264e$var$ForgeGlobalPageSidebar.displayName = 'ForgeGlobalPageSidebar';
var $ffa0ed116b82264e$export$2e2bcd8739ae039 = $ffa0ed116b82264e$var$ForgeGlobalPageSidebar;

});
parcelRegister("lCHrb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jeOcw")
]).then(()=>parcelRequire('hBhU1'));

});


parcelRegister("jAMQL", function(module, exports) {

$parcel$export(module.exports, "useForgeGlobalPageItems", () => $9f797773fe916c88$export$ff333fd2f0bf5254);

var $eUqFw = parcelRequire("eUqFw");

var $k9Roh = parcelRequire("k9Roh");

var $jMYeN = parcelRequire("jMYeN");

var $eOutC = parcelRequire("eOutC");

var $lB25E = parcelRequire("lB25E");
const $9f797773fe916c88$export$ff333fd2f0bf5254 = ()=>{
    const [{ match: match }] = (0, $lB25E.useRouter)();
    const { data: modules, loading: loading, error: error } = (0, $k9Roh.useGlobalForgeApps)();
    const extension = (0, $eOutC.useMatchedExtension)({
        modules: modules,
        match: match
    });
    const sections = (0, $eUqFw.useMemo)(()=>extension && (0, $jMYeN.toSections)(extension), [
        extension
    ]);
    return {
        extension: extension,
        sections: sections,
        loading: loading,
        error: error
    };
};

});
parcelRegister("k9Roh", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $9b956edc956601cb$export$ed6342e0e28465a6);
$parcel$export(module.exports, "useGlobalForgeApps", () => $9b956edc956601cb$export$f834c14187f80532);

var $eUqFw = parcelRequire("eUqFw");

var $8LJqN = parcelRequire("8LJqN");

var $eI5EY = parcelRequire("eI5EY");

var $70ON1 = parcelRequire("70ON1");

var $fTsDx = parcelRequire("fTsDx");

var $l90Gp = parcelRequire("l90Gp");

var $lB25E = parcelRequire("lB25E");
const $9b956edc956601cb$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return `/jira/apps/${appId}/${envId}`;
};
const $9b956edc956601cb$var$useGlobalForgeAppsV1 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)((0, $l90Gp.forgeGlobalModuleV1Resource));
    const globalPageData = (0, $eUqFw.useMemo)(()=>data?.extensions || null, [
        data
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: globalPageData ? globalPageData.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, {})) : null,
            loading: loading,
            error: error
        }), [
        globalPageData,
        loading,
        error
    ]);
};
const $9b956edc956601cb$var$useGlobalForgeAppsV2 = ()=>(0, $lB25E.useResource)((0, $l90Gp.forgeGlobalModuleV2Resource));
const $9b956edc956601cb$export$f834c14187f80532 = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $9b956edc956601cb$var$useGlobalForgeAppsV2, $9b956edc956601cb$var$useGlobalForgeAppsV1);

});
parcelRegister("70ON1", function(module, exports) {

$parcel$export(module.exports, "parseExtensionId", () => $46692d02f47d8a1d$export$bae42cbaf7fa3e1b);
$parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", () => $46692d02f47d8a1d$export$a92b17288693d366);
const $46692d02f47d8a1d$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const [, appId, envId] = extensionId.split('/');
    return {
        appId: appId,
        envId: envId
    };
};
const $46692d02f47d8a1d$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');

});

parcelRegister("fTsDx", function(module, exports) {

$parcel$export(module.exports, "useDoesExtensionMeetConditions", () => $f49523f1e6c1d89f$export$642911220fb6609f);
$parcel$export(module.exports, "doesExtensionMeetConditions", () => $f49523f1e6c1d89f$export$b1e4ed7044e85aa3);

var $eUqFw = parcelRequire("eUqFw");

var $iPaeE = parcelRequire("iPaeE");

var $e91YZ = parcelRequire("e91YZ");

var $fz8wa = parcelRequire("fz8wa");

var $gd0Sp = parcelRequire("gd0Sp");
const $f49523f1e6c1d89f$export$642911220fb6609f = ()=>{
    const { isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const { hasCoreAccess: hasCoreAccess, hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceManagementAccess } = (0, $fz8wa.useApplicationPermissions)();
    return (0, $eUqFw.useCallback)((extension, extraContext)=>{
        const { displayConditions: displayConditions } = extension.properties;
        if (displayConditions == null) return true;
        const context = {
            ...extraContext,
            isAdmin: // User info
            isAdmin,
            isLoggedIn: !isAnonymous,
            isSiteAdmin: isSiteAdmin,
            hasCoreAccess: // App permissions
            hasCoreAccess,
            hasServiceManagementAccess: hasServiceManagementAccess,
            hasSoftwareAccess: hasSoftwareAccess
        };
        return (0, $iPaeE.doesMeetConditions)(displayConditions, context);
    }, [
        hasCoreAccess,
        hasServiceManagementAccess,
        hasSoftwareAccess,
        isAdmin,
        isAnonymous,
        isSiteAdmin
    ]);
};
const $f49523f1e6c1d89f$export$b1e4ed7044e85aa3 = (extension, extraContext)=>{
    const { displayConditions: displayConditions } = extension.properties;
    const { appPermissions: { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess }, isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const context = {
        // Whatever extension needs
        ...extraContext,
        isAdmin: // User info
        isAdmin,
        isLoggedIn: !isAnonymous,
        isSiteAdmin: isSiteAdmin,
        hasSoftwareAccess: // App permissions
        hasSoftwareAccess,
        hasServiceManagementAccess: hasServiceDeskAccess,
        hasCoreAccess: hasCoreAccess
    };
    return displayConditions ? (0, $iPaeE.doesMeetConditions)(displayConditions, context) : true;
};

});

parcelRegister("l90Gp", function(module, exports) {

$parcel$export(module.exports, "forgeAdminModuleV1Resource", () => $a5dfafe975dbf279$export$168ac1f97221e90b);
$parcel$export(module.exports, "forgeAdminModuleV2Resource", () => $a5dfafe975dbf279$export$536a08360f048bac);
$parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", () => $a5dfafe975dbf279$export$dcc98f4b36ce9223);
$parcel$export(module.exports, "forgeProjectModuleV1Resource", () => $a5dfafe975dbf279$export$ad95e2d07d6fa1a);
$parcel$export(module.exports, "forgeProjectModuleV2Resource", () => $a5dfafe975dbf279$export$1a17680eb0746291);
$parcel$export(module.exports, "forgeProjectModuleResource", () => $a5dfafe975dbf279$export$72db683c2914a65e);
$parcel$export(module.exports, "forgeProjectSettingsModuleV1Resource", () => $a5dfafe975dbf279$export$fa67d109c2a45864);
$parcel$export(module.exports, "forgeProjectSettingsModuleV2Resource", () => $a5dfafe975dbf279$export$23c2bb87c561c9db);
$parcel$export(module.exports, "forgeProjectSettingsModuleResource", () => $a5dfafe975dbf279$export$7a928d209faf75f);
$parcel$export(module.exports, "useForgeProjectSettingsModuleResource", () => $a5dfafe975dbf279$export$e81e11bbc3239153);
$parcel$export(module.exports, "forgeGlobalModuleV1Resource", () => $a5dfafe975dbf279$export$60e774d0427b56fc);
$parcel$export(module.exports, "forgeGlobalModuleV2Resource", () => $a5dfafe975dbf279$export$75f594fe5ce76af);
$parcel$export(module.exports, "getNavigationForgeGlobalPageResources", () => $a5dfafe975dbf279$export$80b2f91dabb3dd65);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleV1Resource", () => $a5dfafe975dbf279$export$b555dc3ff28ae9cc);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleV2Resource", () => $a5dfafe975dbf279$export$d2d6bc2f3bd0f942);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", () => $a5dfafe975dbf279$export$ebf5369e4dcfad00);
$parcel$export(module.exports, "forgeCustomFieldTypeResource", () => $a5dfafe975dbf279$export$e6be2f0ca0849869);

var $h1xZf = parcelRequire("h1xZf");

var $eI5EY = parcelRequire("eI5EY");

var $2Rqjr = parcelRequire("2Rqjr");

var $hsX10 = parcelRequire("hsX10");

var $cSfWg = parcelRequire("cSfWg");

var $8hg3R = parcelRequire("8hg3R");

var $jwzNs = parcelRequire("jwzNs");

var $lB25E = parcelRequire("lB25E");

var $fSEqj = parcelRequire("fSEqj");

var $iLkoO = parcelRequire("iLkoO");
const $a5dfafe975dbf279$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
    const isModuleWithAccessNarrowing = [
        (0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE),
        (0, $2Rqjr.PROJECT_PAGE_MODULE),
        (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .includes(moduleName);
    const projectIdOrKey = (0, $8hg3R.getProjectKeyOrId)(params);
    if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
        projectIdOrKey: projectIdOrKey
    };
    return null;
};
const $a5dfafe975dbf279$var$createDataGetter = (moduleName, shouldReturnANExtensions = false, createContextIds)=>(route, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>{
        const { match: params } = route;
        const dataClassification = $a5dfafe975dbf279$export$eb46cc3d7c1a6649(params, moduleName);
        const contextIds = typeof createContextIds === 'function' && createContextIds({
            cloudId: cloudId,
            activationId: activationId
        }) || undefined;
        return (0, $fSEqj.fetchForgeModule)({
            cloudId: cloudId,
            moduleName: moduleName,
            dataClassification: dataClassification,
            shouldReturnANExtensions: shouldReturnANExtensions,
            contextIds: contextIds,
            locale: locale
        });
    };
const $a5dfafe975dbf279$var$createContextIds = ({ cloudId: cloudId, activationId: activationId })=>[
        `ari:cloud:jira:${cloudId}:workspace/${activationId}`
    ];
const $a5dfafe975dbf279$export$168ac1f97221e90b = (0, $lB25E.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.ADMIN_PAGE_MODULE), false, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$536a08360f048bac = (0, $lB25E.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, $cSfWg.fetchModules)({
            cloudId: cloudId,
            types: [
                (0, $2Rqjr.ADMIN_PAGE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $2Rqjr.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$a5dfafe975dbf279$var$normalizeModules(modules[0, $2Rqjr.ADMIN_PAGE_MODULE], (0, $iLkoO.adminPageFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$var$forgeAdminModuleResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $a5dfafe975dbf279$export$536a08360f048bac, $a5dfafe975dbf279$export$168ac1f97221e90b);
const $a5dfafe975dbf279$export$dcc98f4b36ce9223 = ()=>[
        $a5dfafe975dbf279$var$forgeAdminModuleResource
    ];
const $a5dfafe975dbf279$export$ad95e2d07d6fa1a = (0, $lB25E.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.PROJECT_PAGE_MODULE), true, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$1a17680eb0746291 = (0, $lB25E.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, $cSfWg.fetchModules)({
            cloudId: cloudId,
            types: [
                (0, $2Rqjr.PROJECT_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $8hg3R.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $2Rqjr.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$a5dfafe975dbf279$var$normalizeModules(modules[0, $2Rqjr.PROJECT_PAGE_MODULE], (0, $iLkoO.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$72db683c2914a65e = (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $a5dfafe975dbf279$export$1a17680eb0746291, $a5dfafe975dbf279$export$ad95e2d07d6fa1a);
const $a5dfafe975dbf279$export$fa67d109c2a45864 = (0, $lB25E.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE), true, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$23c2bb87c561c9db = (0, $lB25E.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, $cSfWg.fetchModules)({
            cloudId: cloudId,
            types: [
                (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $8hg3R.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $2Rqjr.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$a5dfafe975dbf279$var$normalizeModules(modules[0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE], (0, $iLkoO.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$7a928d209faf75f = (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $a5dfafe975dbf279$export$23c2bb87c561c9db, $a5dfafe975dbf279$export$fa67d109c2a45864);
const $a5dfafe975dbf279$export$e81e11bbc3239153 = ()=>(0, $lB25E.useResource)($a5dfafe975dbf279$export$7a928d209faf75f);
const $a5dfafe975dbf279$export$60e774d0427b56fc = (0, $lB25E.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.GLOBAL_PAGE_MODULE), false, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$75f594fe5ce76af = (0, $lB25E.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, $cSfWg.fetchModules)({
            cloudId: cloudId,
            types: [
                (0, $2Rqjr.GLOBAL_PAGE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $2Rqjr.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$a5dfafe975dbf279$var$normalizeModules(modules[0, $2Rqjr.GLOBAL_PAGE_MODULE], (0, $iLkoO.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$var$forgeGlobalModuleResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $a5dfafe975dbf279$export$75f594fe5ce76af, $a5dfafe975dbf279$export$60e774d0427b56fc);
const $a5dfafe975dbf279$export$80b2f91dabb3dd65 = ()=>[
        $a5dfafe975dbf279$var$forgeGlobalModuleResource
    ];
const $a5dfafe975dbf279$export$b555dc3ff28ae9cc = (0, $lB25E.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE), true, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$d2d6bc2f3bd0f942 = (0, $lB25E.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, $cSfWg.fetchModules)({
            cloudId: cloudId,
            types: [
                (0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $8hg3R.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $2Rqjr.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$a5dfafe975dbf279$var$normalizeModules(modules[0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE], (0, $iLkoO.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$ebf5369e4dcfad00 = (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $a5dfafe975dbf279$export$d2d6bc2f3bd0f942, $a5dfafe975dbf279$export$b555dc3ff28ae9cc);
const $a5dfafe975dbf279$export$e6be2f0ca0849869 = (0, $lB25E.createResource)({
    type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
    getKey: ()=>'extensions',
    getData: (_route, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules') ? (0, $cSfWg.fetchModules)({
            cloudId: cloudId,
            types: [
                (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $2Rqjr.SOURCE_NAVIGATION)
        }).then((modules)=>modules[0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE]) : (0, $hsX10.default)(cloudId, [
            (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE)
        ], null, undefined, (0, $2Rqjr.SOURCE_NAVIGATION), $a5dfafe975dbf279$var$createContextIds({
            cloudId: cloudId,
            activationId: activationId
        }), locale) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        .then((modules)=>modules.extensions.jiraCustomFieldType),
    maxAge: Number.MAX_SAFE_INTEGER
});
/**
 * Makes sure modules are filtered out depending on the predicate and sorted alphabetically by title.
 */ function $a5dfafe975dbf279$var$normalizeModules(modules, filter) {
    return filter(modules).sort((a, b)=>(0, $h1xZf.alphabeticalSort)(a.properties.title, b.properties.title));
}

});
parcelRegister("h1xZf", function(module, exports) {

$parcel$export(module.exports, "alphabeticalSort", () => $cb5adf4a5b6d2436$export$89a1f01f2a7cb2a1);

var $gUUjF = parcelRequire("gUUjF");
const $cb5adf4a5b6d2436$export$89a1f01f2a7cb2a1 = (a, b)=>{
    // @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
    if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
        numeric: true,
        caseFirst: 'upper'
    });
    const typeOfA = a === null ? 'null' : typeof a;
    const typeOfB = b === null ? 'null' : typeof b;
    const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
    (0, $gUUjF.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
    return 1;
};

});

parcelRegister("2Rqjr", function(module, exports) {

$parcel$export(module.exports, "STAGING_ENVIRONMENT", () => $24e2ca1817bcdc8d$export$71acbd662c478c42);
$parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", () => $24e2ca1817bcdc8d$export$978072fd3fd149);
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", () => $24e2ca1817bcdc8d$export$ebc15d9cebfd6063);
$parcel$export(module.exports, "ISSUE_ACTION_MODULE", () => $24e2ca1817bcdc8d$export$fcc4a18f46f80f16);
$parcel$export(module.exports, "ISSUE_GLANCE_MODULE", () => $24e2ca1817bcdc8d$export$259bab989b0129d0);
$parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", () => $24e2ca1817bcdc8d$export$75f224942f595e13);
$parcel$export(module.exports, "ISSUE_PANEL_MODULE", () => $24e2ca1817bcdc8d$export$ba0968f9752844);
$parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", () => $24e2ca1817bcdc8d$export$cc20a5638825fbb0);
$parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", () => $24e2ca1817bcdc8d$export$9069d4b945c3d532);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $24e2ca1817bcdc8d$export$811b7f067a43b422);
$parcel$export(module.exports, "CUSTOM_FIELD_MODULE", () => $24e2ca1817bcdc8d$export$e3887d6bafe8a17);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", () => $24e2ca1817bcdc8d$export$7b7866c04a2ad947);
$parcel$export(module.exports, "ADMIN_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$52e4945e96bd2aa0);
$parcel$export(module.exports, "PROJECT_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$151b03356f566603);
$parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$ea0d6ac082b0d636);
$parcel$export(module.exports, "GLOBAL_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$31ac745ab2add7cc);
$parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", () => $24e2ca1817bcdc8d$export$353acf28daa75c79);
$parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", () => $24e2ca1817bcdc8d$export$25627f012b21b0b9);
$parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", () => $24e2ca1817bcdc8d$export$42d6a8740fd42e58);
$parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", () => $24e2ca1817bcdc8d$export$a7186e5a73395db4);
$parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", () => $24e2ca1817bcdc8d$export$8fbcfe84dc845d17);
$parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$8af4cb794979f60d);
$parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", () => $24e2ca1817bcdc8d$export$5592ab836d562168);
$parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", () => $24e2ca1817bcdc8d$export$842eb4236828ac9);
$parcel$export(module.exports, "SUPPORTED_MODULES", () => $24e2ca1817bcdc8d$export$9b1a91242ce2a1b7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $24e2ca1817bcdc8d$export$2b8aeda236486576);
$parcel$export(module.exports, "ENTRY_POINT_VIEW", () => $24e2ca1817bcdc8d$export$c41ce1ec1ea6e73d);
$parcel$export(module.exports, "ENTRY_POINT_CREATE", () => $24e2ca1817bcdc8d$export$b37d58c3ed77c139);
$parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", () => $24e2ca1817bcdc8d$export$ab94dbd1d02ac251);
$parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", () => $24e2ca1817bcdc8d$export$b6a67a3131c6c48d);
$parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", () => $24e2ca1817bcdc8d$export$b75dc2bfd20898fe);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", () => $24e2ca1817bcdc8d$export$8e96118a698216cb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", () => $24e2ca1817bcdc8d$export$9b72a8e9b92658fb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", () => $24e2ca1817bcdc8d$export$2d6539e7d0553ae7);
$parcel$export(module.exports, "SOURCE_UNKNOWN", () => $24e2ca1817bcdc8d$export$ecbd7135d66cb322);
$parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", () => $24e2ca1817bcdc8d$export$61d882aa7aba51c);
$parcel$export(module.exports, "SOURCE_ISSUE_VIEW", () => $24e2ca1817bcdc8d$export$46cb92762d68a048);
$parcel$export(module.exports, "SOURCE_NAVIGATION", () => $24e2ca1817bcdc8d$export$fe90e46aea58e30b);
$parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", () => $24e2ca1817bcdc8d$export$c5ccbdb9893f2a6a);
$parcel$export(module.exports, "SOURCE_ROUTER", () => $24e2ca1817bcdc8d$export$eae46a3c13473a8d);
$parcel$export(module.exports, "SOURCE_LEGACY", () => $24e2ca1817bcdc8d$export$ac11ee191d09688f);
$parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", () => $24e2ca1817bcdc8d$export$4346e4e240c84319);
$parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", () => $24e2ca1817bcdc8d$export$d719bb340dc354e4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", () => $24e2ca1817bcdc8d$export$4b6228758e800433);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", () => $24e2ca1817bcdc8d$export$70495c8cc141a7a4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", () => $24e2ca1817bcdc8d$export$bc3d408418fdf9d2);
$parcel$export(module.exports, "getEmptyExtensionsObject", () => $24e2ca1817bcdc8d$export$218a328f66b86f7d);
$parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", () => $24e2ca1817bcdc8d$export$3193d714ab54ee26);
$parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $24e2ca1817bcdc8d$export$df7774a415710cce);
$parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $24e2ca1817bcdc8d$export$51ab2784839ce348);
const $24e2ca1817bcdc8d$export$9af0088c49bdedb = 'PRODUCTION';
const $24e2ca1817bcdc8d$export$71acbd662c478c42 = 'STAGING';
const $24e2ca1817bcdc8d$export$978072fd3fd149 = 'DEVELOPMENT';
const $24e2ca1817bcdc8d$export$ebc15d9cebfd6063 = 'default';
const $24e2ca1817bcdc8d$export$fcc4a18f46f80f16 = 'jira:issueAction';
const $24e2ca1817bcdc8d$export$259bab989b0129d0 = 'jira:issueGlance';
const $24e2ca1817bcdc8d$export$75f224942f595e13 = 'jira:issueContext';
const $24e2ca1817bcdc8d$export$ba0968f9752844 = 'jira:issuePanel';
const $24e2ca1817bcdc8d$export$cc20a5638825fbb0 = 'jira:issueActivity';
const $24e2ca1817bcdc8d$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
const $24e2ca1817bcdc8d$export$811b7f067a43b422 = 'jira:uiModifications';
const $24e2ca1817bcdc8d$export$e3887d6bafe8a17 = 'jira:customField';
const $24e2ca1817bcdc8d$export$7b7866c04a2ad947 = 'jira:customFieldType';
const $24e2ca1817bcdc8d$export$52e4945e96bd2aa0 = 'jira:adminPage';
const $24e2ca1817bcdc8d$export$151b03356f566603 = 'jira:projectPage';
const $24e2ca1817bcdc8d$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
const $24e2ca1817bcdc8d$export$31ac745ab2add7cc = 'jira:globalPage';
const $24e2ca1817bcdc8d$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
const $24e2ca1817bcdc8d$export$25627f012b21b0b9 = 'jira:dashboardGadget';
const $24e2ca1817bcdc8d$export$42d6a8740fd42e58 = 'jira:workflowValidator';
const $24e2ca1817bcdc8d$export$a7186e5a73395db4 = 'jira:workflowCondition';
const $24e2ca1817bcdc8d$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
const $24e2ca1817bcdc8d$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
const $24e2ca1817bcdc8d$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
const $24e2ca1817bcdc8d$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
const $24e2ca1817bcdc8d$export$9b1a91242ce2a1b7 = [
    $24e2ca1817bcdc8d$export$fcc4a18f46f80f16,
    $24e2ca1817bcdc8d$export$259bab989b0129d0,
    $24e2ca1817bcdc8d$export$75f224942f595e13,
    $24e2ca1817bcdc8d$export$ba0968f9752844,
    $24e2ca1817bcdc8d$export$cc20a5638825fbb0,
    $24e2ca1817bcdc8d$export$9069d4b945c3d532,
    $24e2ca1817bcdc8d$export$811b7f067a43b422,
    $24e2ca1817bcdc8d$export$e3887d6bafe8a17,
    $24e2ca1817bcdc8d$export$7b7866c04a2ad947,
    $24e2ca1817bcdc8d$export$52e4945e96bd2aa0,
    $24e2ca1817bcdc8d$export$151b03356f566603,
    $24e2ca1817bcdc8d$export$ea0d6ac082b0d636,
    $24e2ca1817bcdc8d$export$31ac745ab2add7cc,
    $24e2ca1817bcdc8d$export$353acf28daa75c79,
    $24e2ca1817bcdc8d$export$25627f012b21b0b9,
    $24e2ca1817bcdc8d$export$8af4cb794979f60d,
    $24e2ca1817bcdc8d$export$5592ab836d562168,
    $24e2ca1817bcdc8d$export$842eb4236828ac9,
    $24e2ca1817bcdc8d$export$42d6a8740fd42e58,
    $24e2ca1817bcdc8d$export$a7186e5a73395db4,
    $24e2ca1817bcdc8d$export$8fbcfe84dc845d17
];
const $24e2ca1817bcdc8d$export$2b8aeda236486576 = 'edit';
const $24e2ca1817bcdc8d$export$c41ce1ec1ea6e73d = 'view';
const $24e2ca1817bcdc8d$export$b37d58c3ed77c139 = 'create';
const $24e2ca1817bcdc8d$export$ab94dbd1d02ac251 = 'contextConfig';
const $24e2ca1817bcdc8d$export$b6a67a3131c6c48d = 'none';
const $24e2ca1817bcdc8d$export$b75dc2bfd20898fe = 5;
const $24e2ca1817bcdc8d$export$8e96118a698216cb = 'native';
const $24e2ca1817bcdc8d$export$9b72a8e9b92658fb = 'basic';
const $24e2ca1817bcdc8d$export$2d6539e7d0553ae7 = 'blank';
const $24e2ca1817bcdc8d$export$ecbd7135d66cb322 = 'unknownSource';
const $24e2ca1817bcdc8d$export$61d882aa7aba51c = 'global-issue-create';
const $24e2ca1817bcdc8d$export$46cb92762d68a048 = 'issue-view';
const $24e2ca1817bcdc8d$export$fe90e46aea58e30b = 'navigation';
const $24e2ca1817bcdc8d$export$c5ccbdb9893f2a6a = 'full-page-app';
const $24e2ca1817bcdc8d$export$eae46a3c13473a8d = 'router';
const $24e2ca1817bcdc8d$export$ac11ee191d09688f = 'legacy';
const $24e2ca1817bcdc8d$export$6d00582aa947900f = 'workflow-list';
const $24e2ca1817bcdc8d$export$4346e4e240c84319 = 'organization-panel';
const $24e2ca1817bcdc8d$export$d719bb340dc354e4 = 'assets-import-type';
const $24e2ca1817bcdc8d$export$bf75cf7720bd8fde = 'transition-view';
const $24e2ca1817bcdc8d$export$4b6228758e800433 = 'jira';
const $24e2ca1817bcdc8d$export$70495c8cc141a7a4 = 'jsm';
const $24e2ca1817bcdc8d$export$bc3d408418fdf9d2 = 'cmdb';
const $24e2ca1817bcdc8d$export$a48dade1864725a = {
    jiraIssueAction: [],
    jiraIssueContext: [],
    jiraIssueGlance: [],
    jiraIssuePanel: [],
    jiraIssueActivity: [],
    jiraIssueViewBackgroundScript: [],
    jiraCustomField: [],
    jiraCustomFieldType: [],
    jiraUiModifications: [],
    jiraAdminPage: [],
    jiraGlobalPage: [],
    jiraProjectPage: [],
    jiraProjectSettingsPage: [],
    jiraDashboardBackgroundScript: [],
    jiraDashboardGadget: [],
    jiraServiceManagementQueuePage: [],
    jiraServiceManagementOrganizationPanel: [],
    jiraServiceManagementAssetsImportType: [],
    jiraWorkflowValidator: [],
    jiraWorkflowCondition: [],
    jiraWorkflowPostFunction: []
};
/**
 * The above EMPTY_EXTENSIONS_OBJECT sometimes is mutated.
 * @see getEmptyExtensionsObject
 */ const $24e2ca1817bcdc8d$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
    ...$24e2ca1817bcdc8d$export$a48dade1864725a
};
const $24e2ca1817bcdc8d$export$218a328f66b86f7d = ()=>({
        ...$24e2ca1817bcdc8d$var$STABLE_EMPTY_EXTENSIONS_OBJECT
    });
const $24e2ca1817bcdc8d$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $24e2ca1817bcdc8d$export$df7774a415710cce = 'com.atlassian.forge:';
const $24e2ca1817bcdc8d$export$51ab2784839ce348 = `${$24e2ca1817bcdc8d$export$df7774a415710cce}${$24e2ca1817bcdc8d$export$3193d714ab54ee26}`;

});

parcelRegister("hsX10", function(module, exports) {

$parcel$export(module.exports, "default", () => $df5bab9bca496d0a$export$2e2bcd8739ae039);

var $jh2R9 = parcelRequire("jh2R9");

var $fcWBJ = parcelRequire("fcWBJ");

var $cnRoI = parcelRequire("cnRoI");

var $2vzCR = parcelRequire("2vzCR");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $eTZsp = parcelRequire("eTZsp");

var $cHWHh = parcelRequire("cHWHh");

var $hRcYT = parcelRequire("hRcYT");

var $ibWQr = parcelRequire("ibWQr");

var $2Rqjr = parcelRequire("2Rqjr");

var $2NB1f = parcelRequire("2NB1f");

var $02sMi = parcelRequire("02sMi");

var $iD9au = parcelRequire("iD9au");

var $c10S5 = parcelRequire("c10S5");

var $dkvex = parcelRequire("dkvex");

var $8ZBIo = parcelRequire("8ZBIo");
const $df5bab9bca496d0a$var$moduleToVariableKey = (module)=>(0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(module);
const $df5bab9bca496d0a$export$3361e9be8093ddcc = (extensions)=>{
    const groupedExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(extensions, 'type');
    const groupedExtensionsWithMappedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($cnRoI)))(groupedExtensions, (_, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $df5bab9bca496d0a$var$moduleToVariableKey(key));
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(groupedExtensionsWithMappedKeys, (0, $2Rqjr.getEmptyExtensionsObject)());
};
const $df5bab9bca496d0a$export$44097e02a91cd11a = (extensions)=>{
    const groupedExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(extensions, 'type');
    const groupedExtensionsWithMappedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, (/*@__PURE__*/$parcel$interopDefault($cnRoI)))(groupedExtensions, (_, key)=>$df5bab9bca496d0a$var$moduleToVariableKey(key)), (0, $2Rqjr.getEmptyExtensionsObject)());
    const filteredOutDuplicatedExtensions = (0, $02sMi.filterOutDuplicatedExtensions)(groupedExtensionsWithMappedKeys);
    const allowedExtensions = (0, $2Rqjr.getEmptyExtensionsObject)();
    const accessNarrowedExtensions = (0, $2Rqjr.getEmptyExtensionsObject)();
    Object.entries(filteredOutDuplicatedExtensions).forEach(([key, module])=>{
        const allowedExtensionsMap = new Map();
        const accessNarrowedExtensionsMap = new Map();
        module.forEach((moduleItem)=>{
            if (moduleItem?.dataClassificationPolicyDecision?.status === 'BLOCKED') accessNarrowedExtensionsMap.set(moduleItem.id, moduleItem);
            else allowedExtensionsMap.set(moduleItem.id, moduleItem);
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        allowedExtensions[key] = [
            ...allowedExtensionsMap.values()
        ];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        accessNarrowedExtensions[key] = [
            ...accessNarrowedExtensionsMap.values()
        ];
    });
    return {
        extensions: allowedExtensions,
        accessNarrowedExtensions: accessNarrowedExtensions
    };
};
const $df5bab9bca496d0a$var$EXCLUDED_ERROR_TYPES = [
    (0, $eTZsp.FAILED_TO_FETCH),
    (0, $eTZsp.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $eTZsp.DATA_CLASSIFICATION_NO_ACCESS)
];
const $df5bab9bca496d0a$var$fetchModulesWithTraceId = async (cloudId, modules, dataClassification, extras, contextIds, source, locale)=>{
    if (modules.length === 0) throw new Error('No modules to fetch provided');
    const dataClassificationTags = await (0, $iD9au.getDataClassification)(dataClassification, source);
    const includeConfig = extras?.include || {};
    const query = (0, $8ZBIo.buildForgeQuery)(includeConfig);
    const variables = {
        contextIds: contextIds || [
            `ari:cloud:jira::site/${cloudId}`
        ],
        extensionsFilter: [
            {
                type: 'EXTENSION_TYPE',
                value: modules
            }
        ],
        dataClassificationTags: dataClassificationTags.map((id)=>`ari:cloud:platform::classification-tag/${id}`),
        locale: (0, $eI5EY.fg)('forge-ui-i18n-locale-enabled') ? locale : undefined
    };
    const { data: data, errors: errors, extensions: extensions } = await (0, $cHWHh.measureExecutionTimeMetrics)(()=>(0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: variables
            }),
            method: 'POST'
        }));
    const traceId = (0, $dkvex.getTraceIdFromExtensions)({
        extensions: extensions
    });
    if (errors) throw new (0, $c10S5.ForgeFetchError)(`Response ended with an error message: ${errors[0].message}`, traceId, errors);
    if (!data) throw new (0, $c10S5.ForgeFetchError)('No data returned', traceId, errors);
    if (data.extensionContexts.length < 1) throw new (0, $c10S5.ForgeFetchError)('No extensionContext returned', traceId, errors);
    return {
        data: data,
        traceId: traceId
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$df5bab9bca496d0a$export$2e2bcd8739ae039 = async (cloudId, modules, dataClassification, extras, source = (0, $2Rqjr.SOURCE_UNKNOWN), contextIds, locale)=>{
    try {
        // Just in case something goes very much wrong we don't want to call the XIS
        if (!(0, $2NB1f.canFetchForgeModules)()) return {
            extensions: (0, $2Rqjr.getEmptyExtensionsObject)(),
            accessNarrowedExtensions: (0, $2Rqjr.getEmptyExtensionsObject)()
        };
        const { data: data, traceId: traceId } = await $df5bab9bca496d0a$var$fetchModulesWithTraceId(cloudId, modules, dataClassification, extras, contextIds, source, locale);
        if (Math.random() * 100 < (0, $hRcYT.FORGE_SAMPLING_RATE)) (0, $ibWQr.fireInitializationFetchFinishedEvent)(source, {
            traceId: traceId
        });
        return $df5bab9bca496d0a$export$44097e02a91cd11a(data.extensionContexts[0].extensions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const errorType = (0, $eTZsp.getErrorType)(error);
        const traceId = (0, $dkvex.getTraceIdFromError)(error);
        (0, $ibWQr.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error,
            traceId: traceId
        });
        if ($df5bab9bca496d0a$var$EXCLUDED_ERROR_TYPES.includes(errorType)) return {
            extensions: (0, $2Rqjr.getEmptyExtensionsObject)(),
            accessNarrowedExtensions: (0, $2Rqjr.getEmptyExtensionsObject)()
        };
        throw error;
    }
};

});
parcelRegister("eTZsp", function(module, exports) {

$parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", () => $11a471eb077355bb$export$23de3198bfe70090);
$parcel$export(module.exports, "FAILED_TO_FETCH", () => $11a471eb077355bb$export$f52aa41ccd776f01);
$parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", () => $11a471eb077355bb$export$31d2ab0be67934f0);
$parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", () => $11a471eb077355bb$export$89a175d4190df42e);
$parcel$export(module.exports, "userConsentErrorRegex", () => $11a471eb077355bb$export$dddade71b333c01d);
$parcel$export(module.exports, "getErrorType", () => $11a471eb077355bb$export$e19f9f08a6d79fd2);


var $JRB5w = parcelRequire("JRB5w");

var $cs5mh = parcelRequire("cs5mh");
const $11a471eb077355bb$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504',
    GADGET_PREFERENCES: 'failed to put gadget preference: Error server response: 429'
};
const $11a471eb077355bb$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $11a471eb077355bb$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $11a471eb077355bb$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $11a471eb077355bb$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $11a471eb077355bb$export$89a175d4190df42e = 'Invoke value functions failed:';
const $11a471eb077355bb$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $11a471eb077355bb$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if ((0, $cs5mh.isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $11a471eb077355bb$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $11a471eb077355bb$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $11a471eb077355bb$export$23de3198bfe70090;
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($11a471eb077355bb$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($11a471eb077355bb$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $1c3fbb431a173cc6$export$9de493bcd9b1d977);
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $1c3fbb431a173cc6$export$fa405bbf47d510e2);
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($11a471eb077355bb$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($11a471eb077355bb$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $JRB5w.isClientFetchError)(error)) return $11a471eb077355bb$export$f52aa41ccd776f01;
    return 'OTHER';
};

});

parcelRegister("cHWHh", function(module, exports) {

$parcel$export(module.exports, "measureExecutionTimeMetrics", () => $69ad25e8e60753eb$export$a859f6866f4653e0);

var $hompL = parcelRequire("hompL");

var $eI5EY = parcelRequire("eI5EY");

var $hRcYT = parcelRequire("hRcYT");

var $d6g7g = parcelRequire("d6g7g");
const $69ad25e8e60753eb$export$a859f6866f4653e0 = async (action)=>{
    const concurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
    const shouldSendTimeMetric = Math.random() * 100 < (0, $hRcYT.FORGE_SAMPLING_RATE);
    if ((0, $eI5EY.fg)('ditto-fcf_forge_fetch_time_metric_fix')) try {
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesConcurrentFetchTime)(concurrentId).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesConcurrentFetchTime)(concurrentId).stop({
            stopTime: performance.now()
        });
        return result;
    } catch (error) {
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesConcurrentFetchTime)(concurrentId).cancel();
        throw error;
    }
    else try {
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).stop({
            stopTime: performance.now()
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).cancel();
        throw error;
    }
};

});
parcelRegister("hRcYT", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_GASV3", () => $7ddaf55383536638$export$f892f621fb508154);
$parcel$export(module.exports, "MODULE_TYPE_TRIGGER", () => $7ddaf55383536638$export$ed63b053e04e26df);
$parcel$export(module.exports, "MODULE_TYPE_EXTENSION", () => $7ddaf55383536638$export$725bacc669333eef);
$parcel$export(module.exports, "FORGE_SAMPLING_RATE", () => $7ddaf55383536638$export$d920cee73ec094d0);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $7ddaf55383536638$export$f048d91ccaf92408);
$parcel$export(module.exports, "UI_ACTIONS", () => $7ddaf55383536638$export$2b7367f125154866);
$parcel$export(module.exports, "OPERATIONAL_ACTIONS", () => $7ddaf55383536638$export$42bcca5cae2ce90b);
$parcel$export(module.exports, "TRACK_ACTIONS", () => $7ddaf55383536638$export$2af0438304d7c4b2);
// TODO ARKEN-359: uniformise GASv3/BM3 keys to use kebab lowercase
const $7ddaf55383536638$export$f892f621fb508154 = 'jiraForgeUi';
const $7ddaf55383536638$export$273f5980517336e2 = 'jiraforgeui';
const $7ddaf55383536638$export$ed63b053e04e26df = 'trigger';
const $7ddaf55383536638$export$725bacc669333eef = 'extension';
const $7ddaf55383536638$export$d920cee73ec094d0 = 10;
const $7ddaf55383536638$export$f048d91ccaf92408 = {
    FORGE_MODULES: {
        FETCH_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.forge-modules.fetch-time`,
        LOAD_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.forge-modules.load-time`
    },
    REAL_TIME_ISSUE_EVENTS: {
        INVOKE_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.real-time-issue-events.invoke-time`
    },
    MARKS: {
        TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
        TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
    }
};
const $7ddaf55383536638$export$2b7367f125154866 = {
    CLICKED: 'clicked',
    SELECTED: 'selected',
    CANCELED: 'canceled',
    ACTION_CLICKED: 'action clicked',
    COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
    REMOVE_CLICKED: 'remove clicked'
};
const $7ddaf55383536638$export$42bcca5cae2ce90b = {
    FAILED: 'failed',
    INITIALIZED: 'initialized',
    EDIT_FAILED: 'edit failed',
    ACTION_FAILED: 'action failed',
    SAVE_FAILED: 'save failed',
    REMOVE_FAILED: 'remove failed',
    UPDATE_FAILED: 'update failed'
};
const $7ddaf55383536638$export$2af0438304d7c4b2 = {
    EDITED: 'edited',
    SAVED: 'saved',
    REMOVED: 'removed',
    ACTION_SUCCEED: 'action succeed',
    UPDATE_SUCCEED: 'update succeed'
};

});

parcelRegister("d6g7g", function(module, exports) {

$parcel$export(module.exports, "forgeModulesFetchTime", () => $2f54a22cce56cf6f$export$cd129f3639657eae);
$parcel$export(module.exports, "forgeModulesConcurrentFetchTime", () => $2f54a22cce56cf6f$export$c3d8833fbea3e976);
$parcel$export(module.exports, "forgeModulesConcurrentLoadTime", () => $2f54a22cce56cf6f$export$292f3b557281044f);
$parcel$export(module.exports, "realTimeIssueEventInvokeTime", () => $2f54a22cce56cf6f$export$89ace7e2bb7d7685);
$parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", () => $2f54a22cce56cf6f$export$94f65f3b2556df23);
$parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", () => $2f54a22cce56cf6f$export$116d5e25caf0018d);
$parcel$export(module.exports, "customFieldPageSegmentLoadMetric", () => $2f54a22cce56cf6f$export$3bd38623c2543fc0);
$parcel$export(module.exports, "customFieldInteractionMetric", () => $2f54a22cce56cf6f$export$a318f99472db73c8);

var $lNfG4 = parcelRequire("lNfG4");

var $hgcvd = parcelRequire("hgcvd");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");

var $hRcYT = parcelRequire("hRcYT");
const $2f54a22cce56cf6f$export$cd129f3639657eae = (0, $lNfG4.metrics).custom({
    key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $2f54a22cce56cf6f$export$c3d8833fbea3e976 = (0, $lNfG4.metrics).concurrent.custom({
    key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $2f54a22cce56cf6f$export$292f3b557281044f = (0, $lNfG4.metrics).concurrent.custom({
    key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $2f54a22cce56cf6f$export$89ace7e2bb7d7685 = new (0, $kDfSL.UFOExperience)((0, $hRcYT.PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
async function $2f54a22cce56cf6f$export$94f65f3b2556df23(startMark, endMark, fn) {
    if (false || (0, $hgcvd.default).getEntriesByName(startMark).length > 0 || (0, $hgcvd.default).getEntriesByName(endMark).length > 0) return fn();
    (0, $hgcvd.default).mark(startMark);
    const result = await fn();
    (0, $hgcvd.default).mark(endMark);
    return result;
}
const $2f54a22cce56cf6f$export$116d5e25caf0018d = (metric, additionalTimings)=>{
    additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
            ...(0, $hgcvd.default).getEntriesByName(startMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: cleanStart,
                    cleanEnd: undefined
                })),
            ...(0, $hgcvd.default).getEntriesByName(endMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: undefined,
                    cleanEnd: cleanEnd
                }))
        ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
        metric.mark(name, startTime);
        if (cleanStart || cleanEnd) (0, $hgcvd.default).clearMarks(name);
    });
};
const $2f54a22cce56cf6f$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, $lNfG4.metrics).pageSegmentLoad({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings,
            {
                key: 'tti',
                startMark: (0, $hRcYT.PERFORMANCE_KEYS).MARKS.TTI_START,
                endMark: (0, $hRcYT.PERFORMANCE_KEYS).MARKS.TTI_END
            }
        ]
    });
const $2f54a22cce56cf6f$export$a318f99472db73c8 = (additionalTimings = [])=>(0, $lNfG4.metrics).interaction({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings
        ]
    });

});


parcelRegister("ibWQr", function(module, exports) {

$parcel$export(module.exports, "fireInitializationFetchFinishedEvent", () => $2c36a22053951caa$export$132ca822850e455f);
$parcel$export(module.exports, "fireInitializationFetchFailedEvent", () => $2c36a22053951caa$export$b5ca88b1053f1ad0);
$parcel$export(module.exports, "fireInitializationIssueViewFinishedEvent", () => $2c36a22053951caa$export$e914f7df1e4ad79b);
$parcel$export(module.exports, "fireInitializationIssueViewFailedEvent", () => $2c36a22053951caa$export$b274c658390b491b);

var $TrUS5 = parcelRequire("TrUS5");

var $cYWDh = parcelRequire("cYWDh");
const $2c36a22053951caa$var$INITIALIZATION_ACTIONS = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $2c36a22053951caa$export$917d0643b0111a02 = (0, $TrUS5.toEventId)('issueViewInitialization');
const $2c36a22053951caa$export$43e875fd63e64525 = (0, $TrUS5.toEventId)('fetchModulesInitialization');
const $2c36a22053951caa$export$132ca822850e455f = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2c36a22053951caa$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2c36a22053951caa$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2c36a22053951caa$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2c36a22053951caa$export$e914f7df1e4ad79b = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2c36a22053951caa$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });
const $2c36a22053951caa$export$b274c658390b491b = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2c36a22053951caa$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });

});
parcelRegister("TrUS5", function(module, exports) {

$parcel$export(module.exports, "toEventId", () => $157b5a46da0774f4$export$75e84ef5a3771f9a);
const $157b5a46da0774f4$export$75e84ef5a3771f9a = (value)=>value;

});

parcelRegister("cYWDh", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $6b16192b91ad756a$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireUiEvent", () => $6b16192b91ad756a$export$bed7f228c94e5f2a);
$parcel$export(module.exports, "fireTrackEvent", () => $6b16192b91ad756a$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireInitializationEvent", () => $6b16192b91ad756a$export$390a62413962e4f0);

var $3FyZ4 = parcelRequire("3FyZ4");

var $hRcYT = parcelRequire("hRcYT");

var $bBGpO = parcelRequire("bBGpO");

var $7ALvE = parcelRequire("7ALvE");

var $29pIG = parcelRequire("29pIG");
const $6b16192b91ad756a$var$createAnalyticsProps = ({ id: id, source: // Since source is required in sendOperationalEvent and sendUIEvent we need to pass here a fallback
// in case source is not provided
source = 'unknownSource', action: action, attributes: attributes })=>({
        actionSubject: `${0, $hRcYT.PACKAGE_NAME_GASV3}.${id}`,
        attributes: (0, $bBGpO.createAttributes)(attributes),
        source: source,
        action: action
    });
const $6b16192b91ad756a$var$getAnalyticsClient = async ()=>(await (0, $3FyZ4.getAnalyticsWebClientPromise)()).getInstance();
const $6b16192b91ad756a$var$sendOperationalEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendOperationalEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
const $6b16192b91ad756a$var$sendUiEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendUIEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
const $6b16192b91ad756a$var$sendTrackEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendTrackEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
const $6b16192b91ad756a$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendOperationalEvent({
        ...eventProps,
        source: (0, $bBGpO.parseSource)(source),
        action: action
    });
const $6b16192b91ad756a$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendUiEvent({
        ...eventProps,
        source: (0, $bBGpO.parseSource)(source),
        action: action
    });
const $6b16192b91ad756a$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendTrackEvent({
        ...eventProps,
        source: (0, $bBGpO.parseSource)(source),
        action: action
    });
const $6b16192b91ad756a$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
        $6b16192b91ad756a$export$a1fb57756f0de62b(action, {
            id: id,
            attributes: attributes,
            source: source
        }),
        attributes?.error && (0, $7ALvE.logError)((0, $7ALvE.ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, $29pIG.isSynthetic)().toString()}, id=${id}, source=${(0, $bBGpO.parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
    ]);

});
parcelRegister("bBGpO", function(module, exports) {

$parcel$export(module.exports, "parseSource", () => $c13c8af67eb85442$export$e98201ef9a88ba70);
$parcel$export(module.exports, "createAttributes", () => $c13c8af67eb85442$export$c7c9603a6b1fd815);

var $7PHyj = parcelRequire("7PHyj");

var $f4SFV = parcelRequire("f4SFV");

var $eTZsp = parcelRequire("eTZsp");

var $29pIG = parcelRequire("29pIG");
const $c13c8af67eb85442$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
const $c13c8af67eb85442$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $c13c8af67eb85442$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: (0, $29pIG.isSynthetic)(),
        isOverridingFragments: (0, $f4SFV.isOverridingFragments)(),
        isSSR: false
    };
    if (rawAttributes) {
        const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
        if (source) attributes.source = $c13c8af67eb85442$export$e98201ef9a88ba70(source);
        if (error) {
            attributes.error = $c13c8af67eb85442$export$78c6267359db7e73(error);
            attributes.errorType = (0, $eTZsp.getErrorType)(error);
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7PHyj)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});
parcelRegister("f4SFV", function(module, exports) {

$parcel$export(module.exports, "isOverridingFragments", () => $131b22271a46e6fc$export$1d1321d2b374d697);
const $131b22271a46e6fc$export$1d1321d2b374d697 = ()=>{
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};

});

parcelRegister("29pIG", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $4e7b61ea3e7b237b$export$947749d756ccb0a);

var $eI5EY = parcelRequire("eI5EY");

var $6rW04 = parcelRequire("6rW04");
const $4e7b61ea3e7b237b$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $6rW04.default)('ajs-is-synthetic') === 'true' || (0, $eI5EY.fg)('forge_ui_synthetic_check');

});


parcelRegister("7ALvE", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_UTIL", () => $d44e65d0fc9da8f1$export$d1e4f308040bb0d5);
$parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", () => $d44e65d0fc9da8f1$export$36f315a5c6daf40b);
$parcel$export(module.exports, "logError", () => $d44e65d0fc9da8f1$export$58da9968c3170cb1);

var $gUUjF = parcelRequire("gUUjF");

var $hRcYT = parcelRequire("hRcYT");
const $d44e65d0fc9da8f1$export$e31edcd35abe3bb1 = 'environment-mapping';
const $d44e65d0fc9da8f1$export$d1e4f308040bb0d5 = 'analytics';
const $d44e65d0fc9da8f1$export$36f315a5c6daf40b = 'custom-field-object-type';
const $d44e65d0fc9da8f1$export$6ee8198f29fffdb4 = {
    [$d44e65d0fc9da8f1$export$d1e4f308040bb0d5]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.utils.analytics`,
    [$d44e65d0fc9da8f1$export$e31edcd35abe3bb1]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
    [$d44e65d0fc9da8f1$export$36f315a5c6daf40b]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
};
const $d44e65d0fc9da8f1$export$58da9968c3170cb1 = (key, message, event)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData($d44e65d0fc9da8f1$export$6ee8198f29fffdb4[key], message, event);
};

});



parcelRegister("2NB1f", function(module, exports) {

$parcel$export(module.exports, "canFetchForgeModules", () => $54017b90132e06f5$export$bb3a4a3b8e654c08);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-legacy

var $e91YZ = parcelRequire("e91YZ");
const $54017b90132e06f5$export$bb3a4a3b8e654c08 = ()=>{
    const { isAnonymous: isAnonymous, cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    /**
	 * SMT-1142
	 * A tenant named `bob` is most likely a local/ci instance started with `./jmake run ci`.
	 * It wasn't possible to find the hostname in a reasonable timeframe so this is the most feasible solution.
	 * In case more tenants like this spawn in the future we'd need to mark these instances instead and block here.
	 */ if (String(cloudId) === 'bob') return false;
    // There is no anonymous access for now
    return !isAnonymous;
};

});

parcelRegister("02sMi", function(module, exports) {

$parcel$export(module.exports, "filterOutDuplicatedExtensions", () => $e5793a48e1add67f$export$e0393e97f15a28a5);

var $fUTZC = parcelRequire("fUTZC");

var $2Rqjr = parcelRequire("2Rqjr");
const $e5793a48e1add67f$export$e0393e97f15a28a5 = (modules)=>{
    const filteredModules = (0, $2Rqjr.getEmptyExtensionsObject)();
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(modules, (module, propName)=>{
        const moduleExtensions = new Map();
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(module, (moduleItem)=>{
            const moduleExtension = moduleExtensions.get(moduleItem.id);
            const appVersion = moduleItem?.appVersion || '0.0.0';
            const moduleAppVersion = moduleExtension?.appVersion || '0.0.0';
            if (!moduleExtension || moduleExtension && appVersion >= moduleAppVersion) moduleExtensions.set(moduleItem.id, moduleItem);
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        filteredModules[propName] = [
            ...moduleExtensions.values()
        ];
    });
    return filteredModules;
};

});

parcelRegister("iD9au", function(module, exports) {

$parcel$export(module.exports, "getDataClassification", () => $afc4148764d3af06$export$1635afa94064952c);

var $lRmyA = parcelRequire("lRmyA");

var $eTZsp = parcelRequire("eTZsp");

var $ibWQr = parcelRequire("ibWQr");

var $7i1xd = parcelRequire("7i1xd");

var $fvGQu = parcelRequire("fvGQu");
const $afc4148764d3af06$var$handleError = (err, source)=>{
    const errorMessage = err instanceof Error ? err.message : String(err);
    const error = Error(`Data classification request failed: ${errorMessage}`);
    const errorType = (0, $eTZsp.getErrorType)(error);
    // prevent fetching extensions in case of no access
    if (errorType === (0, $eTZsp.DATA_CLASSIFICATION_NO_ACCESS)) throw error;
    (0, $ibWQr.fireInitializationFetchFailedEvent)(source, {
        isSSR: false,
        errorType: errorType,
        error: error
    });
    // otherwise, optimistically fetch the extensions
    return [];
};
async function $afc4148764d3af06$var$getDataClassificationIssue(props, source) {
    try {
        const now = Date.now();
        const cachedResult = (0, $fvGQu.DataClassificationTagsCache).get(`${(0, $fvGQu.issueKeyPrefix)}-${props.issueKey}`);
        const isCacheResultTimePassed = Boolean(cachedResult && (0, $fvGQu.TTL) < now - cachedResult.timestamp);
        if (isCacheResultTimePassed || !cachedResult) {
            const data = await (0, $lRmyA.performGetRequest)(`/rest/internal/3/data-classification/resource/issue/${props.issueKey}`);
            (0, $fvGQu.DataClassificationTagsCache).set(`${(0, $fvGQu.issueKeyPrefix)}-${props.issueKey}`, {
                tags: data.tags,
                timestamp: now
            });
            return data.tags;
        }
        return cachedResult.tags;
    } catch (err) {
        return $afc4148764d3af06$var$handleError(err, source);
    }
}
async function $afc4148764d3af06$var$getDataClassificationProject(props, source) {
    try {
        const now = Date.now();
        const cachedResult = (0, $fvGQu.DataClassificationTagsCache).get(`${(0, $fvGQu.projectKeyPrefix)}-${props.projectIdOrKey}`);
        const isCacheResultTimePassed = Boolean(cachedResult && (0, $fvGQu.TTL) < now - cachedResult.timestamp);
        if (isCacheResultTimePassed || !cachedResult) {
            const data = await (0, $lRmyA.performGetRequest)(`/rest/internal/3/data-classification/resource/container/${props.projectIdOrKey}`);
            (0, $fvGQu.DataClassificationTagsCache).set(`${(0, $fvGQu.projectKeyPrefix)}-${props.projectIdOrKey}`, {
                tags: data.tags,
                timestamp: now
            });
            return data.tags;
        }
        return cachedResult.tags;
    } catch (err) {
        return $afc4148764d3af06$var$handleError(err, source);
    }
}
const $afc4148764d3af06$export$1635afa94064952c = async (props, source)=>{
    if (props !== null) {
        if ((0, $7i1xd.hasPrefetchedData)(props)) return props.tags;
        if ((0, $7i1xd.hasProjectIdOrKey)(props)) {
            const tags = await $afc4148764d3af06$var$getDataClassificationProject(props, source);
            return tags;
        }
        if ((0, $7i1xd.hasIssueKey)(props)) {
            const tags = await $afc4148764d3af06$var$getDataClassificationIssue(props, source);
            return tags;
        }
    }
    return [];
};

});
parcelRegister("7i1xd", function(module, exports) {

$parcel$export(module.exports, "hasPrefetchedData", () => $f4d16f0e4c0cff8e$export$c19d255b92c7c2da);
$parcel$export(module.exports, "hasProjectIdOrKey", () => $f4d16f0e4c0cff8e$export$494434246e5dea0d);
$parcel$export(module.exports, "hasIssueKey", () => $f4d16f0e4c0cff8e$export$b1490cfc7a90c75b);

var $1c8hB = parcelRequire("1c8hB");
const $f4d16f0e4c0cff8e$export$c19d255b92c7c2da = (props)=>props !== null && 'tags' in props && (0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(props.tags);
const $f4d16f0e4c0cff8e$export$494434246e5dea0d = (props)=>props !== null && 'projectIdOrKey' in props;
const $f4d16f0e4c0cff8e$export$b1490cfc7a90c75b = (props)=>props !== null && 'issueKey' in props;

});

parcelRegister("fvGQu", function(module, exports) {

$parcel$export(module.exports, "TTL", () => $e29cae659811c7d2$export$6ebb1381174e92a7);
$parcel$export(module.exports, "issueKeyPrefix", () => $e29cae659811c7d2$export$a040db2850f159b0);
$parcel$export(module.exports, "projectKeyPrefix", () => $e29cae659811c7d2$export$df256a06d24ff906);
$parcel$export(module.exports, "DataClassificationTagsCache", () => $e29cae659811c7d2$export$b7adc37405b5ff0d);
const $e29cae659811c7d2$export$6ebb1381174e92a7 = 60000;
const $e29cae659811c7d2$export$a040db2850f159b0 = 'issue';
const $e29cae659811c7d2$export$df256a06d24ff906 = 'project';
const $e29cae659811c7d2$export$b7adc37405b5ff0d = new Map();

});


parcelRegister("c10S5", function(module, exports) {

$parcel$export(module.exports, "ForgeFetchError", () => $be007d6d4af22f2a$export$2e3b53e53bafa);
class $be007d6d4af22f2a$export$2e3b53e53bafa extends Error {
    constructor(message, traceId, errors){
        super(message);
        this.name = $be007d6d4af22f2a$export$2e3b53e53bafa.name;
        this.traceId = traceId;
        this.statusCodes = errors?.map((graphQLError)=>graphQLError?.extensions?.statusCode).filter((x)=>x != null);
        if ('captureStackTrace' in Error) // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
        Error.captureStackTrace(this, $be007d6d4af22f2a$export$2e3b53e53bafa); // :tableflip:
    }
}

});

parcelRegister("dkvex", function(module, exports) {

$parcel$export(module.exports, "getTraceIdFromExtensions", () => $de55799bed033deb$export$eefb7f54c3b07211);
$parcel$export(module.exports, "getTraceIdFromError", () => $de55799bed033deb$export$9955d05ba83067ba);

var $7byHA = parcelRequire("7byHA");

var $c10S5 = parcelRequire("c10S5");
const $de55799bed033deb$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    const traceId = extensions?.gateway?.request_id;
    if (traceId && typeof traceId === 'string') return traceId;
    return undefined;
};
const $de55799bed033deb$export$9955d05ba83067ba = (error)=>{
    if (error instanceof (0, $c10S5.ForgeFetchError) || error instanceof (0, $7byHA.default)) return error.traceId;
    return undefined;
};

});

parcelRegister("8ZBIo", function(module, exports) {

$parcel$export(module.exports, "buildForgeQuery", () => $a2e306a4af3081df$export$497b2dc04db7bd76);

var $1ybV0 = parcelRequire("1ybV0");
const $a2e306a4af3081df$export$497b2dc04db7bd76 = (include)=>{
    const consentFields = `
    consentUrl
    currentUserConsent {
        user {
            aaid
        }
        appEnvironmentVersion {
            id
        }
        consentedAt
    }
    requiresUserConsent`;
    const scopesField = include.scopes === true ? 'scopes' : '';
    const capabilitySetField = (0, $1ybV0.ff)('platform.forge-ui.license-capability-set') ? 'capabilitySet' : '';
    const licenseFields = `
    license {
        active
        type
        supportEntitlementNumber
        trialEndDate
        subscriptionEndDate
        isEvaluation
        billingPeriod
        ccpEntitlementId
        ccpEntitlementSlug
		    ${capabilitySetField}
    }`;
    return `query jira_forge_frontendModules($contextIds: [ID!]! $extensionsFilter: [ExtensionContextsFilter!]! $dataClassificationTags: [ID!]!, $locale: String) {
        extensionContexts(contextIds: $contextIds) @optIn(to: "Access-Narrowing") {
            extensions(filter: $extensionsFilter, locale: $locale) {
                id
                appVersion
                installationId
                environmentId
                environmentType
                environmentKey
                properties
                ${licenseFields}
                ${scopesField}
                type
                __typename
                ${consentFields}
                egress {
                    type
                    addresses
                }
                dataClassificationPolicyDecision(input: {
                    dataClassificationTags: $dataClassificationTags
                }) {
                    status
                }
            }
        }
    }`;
};

});


parcelRegister("cSfWg", function(module, exports) {

$parcel$export(module.exports, "fetchModules", () => $3ac00b838e4672c8$export$24d8e11b15325c53);

var $khCLC = parcelRequire("khCLC");

var $iWLL0 = parcelRequire("iWLL0");

var $eTZsp = parcelRequire("eTZsp");

var $cHWHh = parcelRequire("cHWHh");

var $hRcYT = parcelRequire("hRcYT");

var $ibWQr = parcelRequire("ibWQr");

var $2Rqjr = parcelRequire("2Rqjr");

var $amu7D = parcelRequire("amu7D");

var $2NB1f = parcelRequire("2NB1f");

var $e3k2q = parcelRequire("e3k2q");
const $3ac00b838e4672c8$export$24d8e11b15325c53 = async (params)=>{
    const { types: types, source: source = (0, $2Rqjr.SOURCE_UNKNOWN) } = params;
    if (!(0, $2NB1f.canFetchForgeModules)()) return (0, $e3k2q.toMappedExtensions)(types, []);
    try {
        const extensions = await (0, $cHWHh.measureExecutionTimeMetrics)(()=>$3ac00b838e4672c8$export$8ff66c70be1c563a(params));
        if (Math.random() * 100 < (0, $hRcYT.FORGE_SAMPLING_RATE)) (0, $ibWQr.fireInitializationFetchFinishedEvent)(source);
        return (0, $e3k2q.toMappedExtensions)(types, extensions);
    } catch (error) {
        const errorType = (0, $eTZsp.getErrorType)(error);
        (0, $ibWQr.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        if ($3ac00b838e4672c8$export$458cbcb6374269d2.includes(errorType)) return (0, $e3k2q.toMappedExtensions)(types, []);
        throw error;
    }
};
function $3ac00b838e4672c8$export$8ff66c70be1c563a(props) {
    const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = false } = props;
    if (types.length === 0) throw new Error('No modules to fetch provided');
    return (0, $iWLL0.fetchQuery)((0, $amu7D.default)(), /* eslint-disable @atlassian/relay/unused-fields */ (0, $khCLC.default), /* eslint-enable @atlassian/relay/unused-fields */ {
        cloudId: cloudId,
        context: context,
        types: types,
        includeHidden: includeHidden,
        includeScopes: includeScopes
    }).toPromise().then((response)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.jira.forge.extensions.concat();
    });
}
const $3ac00b838e4672c8$export$458cbcb6374269d2 = [
    (0, $eTZsp.FAILED_TO_FETCH),
    (0, $eTZsp.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $eTZsp.DATA_CLASSIFICATION_NO_ACCESS)
];

});
parcelRegister("khCLC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1898485f6eb58c1d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00f75613e524ae31b8e6562d9f3105b5>>
 * @relayHash c628a7ddbc1f6e28bf1109b39c9df871
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ec904788346b73ef73ba8d21a8d7a83b02cd5e8d03190f3c9f31995997aab05
const $1898485f6eb58c1d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeHidden"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeScopes"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "types"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "context",
                "variableName": "context"
            },
            {
                "kind": "Variable",
                "name": "includeHidden",
                "variableName": "includeHidden"
            },
            {
                "kind": "Variable",
                "name": "types",
                "variableName": "types"
            }
        ],
        "concreteType": "JiraForgeExtension",
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            {
                "condition": "includeHidden",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "hiddenBy"
                    }
                ]
            },
            {
                "condition": "includeScopes",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "scopes"
                    }
                ]
            },
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "environmentId"
            },
            {
                "kind": "ScalarField",
                "name": "environmentKey"
            },
            {
                "kind": "ScalarField",
                "name": "environmentType"
            },
            {
                "kind": "ScalarField",
                "name": "installationId"
            },
            {
                "kind": "ScalarField",
                "name": "appVersion"
            },
            {
                "kind": "ScalarField",
                "name": "consentUrl"
            },
            {
                "kind": "ScalarField",
                "name": "properties"
            },
            {
                "concreteType": "JiraForgeAppEgressDeclaration",
                "kind": "LinkedField",
                "name": "egress",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "addresses"
                    },
                    v5 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraForgeExtensionLicense",
                "kind": "LinkedField",
                "name": "license",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "active"
                    },
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "supportEntitlementNumber"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "trialEndDate"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subscriptionEndDate"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isEvaluation"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "billingPeriod"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "ccpEntitlementId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "ccpEntitlementSlug"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "capabilitySet"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchModulesV2Query",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraForgeQuery",
                                    "kind": "LinkedField",
                                    "name": "forge",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v6 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.forge.extensions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.forge"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchModulesV2Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraForgeQuery",
                            "kind": "LinkedField",
                            "name": "forge",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7ec904788346b73ef73ba8d21a8d7a83b02cd5e8d03190f3c9f31995997aab05",
            "metadata": {},
            "name": "fetchModulesV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1898485f6eb58c1d$var$node.hash = "7d0cf33c9221c468dec00db8d99ae484";
var $1898485f6eb58c1d$export$2e2bcd8739ae039 = $1898485f6eb58c1d$var$node;

});

parcelRegister("e3k2q", function(module, exports) {

$parcel$export(module.exports, "toMappedExtensions", () => $9af364078de98550$export$e073e0c0d1c23345);
function $9af364078de98550$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
    const result = Object.fromEntries(requestedModules.map((type)=>[
            type,
            []
        ]));
    returnedExtensions.forEach((extension)=>{
        result[extension.type]?.push(extension);
    });
    // There is no better way to work this out and preserve a generic object response
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return result;
}

});


parcelRegister("jwzNs", function(module, exports) {

$parcel$export(module.exports, "resourceWithCondition", () => $55f07a7915bec73f$export$cac04afc5a06c544);
$parcel$export(module.exports, "resourceWithCondition2", () => $55f07a7915bec73f$export$78488a529a07cd46);
$parcel$export(module.exports, "browserOnlyResourceWithCondition", () => $55f07a7915bec73f$export$5284559c6d2f1a7b);

var $6qExu = parcelRequire("6qExu");
const $55f07a7915bec73f$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
        get type () {
            return conditionGetter() ? resourceTrue.type : (0, $6qExu.RESOURCE_TYPE_NOOP);
        },
        getKey: resourceTrue.getKey,
        get maxAge () {
            return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
        },
        getData: (routerContext, customContext)=>conditionGetter() ? resourceTrue.getData(routerContext, customContext) : Promise.resolve(null),
        maxCache: resourceTrue.maxCache,
        get isBrowserOnly () {
            return resourceTrue.isBrowserOnly;
        },
        get depends () {
            return resourceTrue.depends;
        },
        get skipBrowser () {
            return resourceTrue.skipBrowser;
        }
    };
const $55f07a7915bec73f$export$fbf6681b373be4c4 = (resource, amendments = {})=>// @ts-expect-error - TS2322 - Type 'Partial<RouteResource<any>>' is not assignable to type 'RouteResource<any>'.
    resource && // IMPORTANT - resources can be falsy in SSR "routes" build
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.defineProperties({}, {
        ...Object.getOwnPropertyDescriptors(resource),
        ...Object.getOwnPropertyDescriptors(amendments)
    });
const $55f07a7915bec73f$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $55f07a7915bec73f$export$fbf6681b373be4c4(itemTrue, {
    getKey: ()=>'DEGENERATE_KEY',
    getData: ()=>null,
    maxAge: Number.MAX_SAFE_INTEGER
}))=>// @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'RouteResource<any>': type, getKey, maxAge, getData, and 3 more.
    itemTrue && // IMPORTANT - resources can be falsy in SSR "routes" build
    Object.defineProperties({}, Object.fromEntries([
        ...Object.keys(itemTrue),
        ...Object.keys(itemFalse)
    ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
            key,
            {
                configurable: false,
                enumerable: true,
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'.
                get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
            }
        ])));
const $55f07a7915bec73f$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
        ...resource,
        get isBrowserOnly () {
            return !!conditionGetter();
        }
    };

});
parcelRegister("6qExu", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NOOP", () => $d6fba9243db8a331$export$eb37f5d331ea4de4);
$parcel$export(module.exports, "MIN_MAX_AGE", () => $d6fba9243db8a331$export$5664a170ac5a9781);
const $d6fba9243db8a331$export$eb37f5d331ea4de4 = 'NOOP';
const $d6fba9243db8a331$export$5664a170ac5a9781 = 5000;

});


parcelRegister("fSEqj", function(module, exports) {

$parcel$export(module.exports, "fetchForgeModule", () => $8729e3f9c8f23451$export$e1683e15cedb5f17);

var $jh2R9 = parcelRequire("jh2R9");

var $h1xZf = parcelRequire("h1xZf");

var $2Rqjr = parcelRequire("2Rqjr");

var $hsX10 = parcelRequire("hsX10");

var $6vrw7 = parcelRequire("6vrw7");

var $4MOAS = parcelRequire("4MOAS");
const $8729e3f9c8f23451$var$dataClassificatedModulesConfig = {
    names: new Set(),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    request: Promise.resolve({})
};
const $8729e3f9c8f23451$export$e1683e15cedb5f17 = async ({ cloudId: cloudId, moduleName: moduleName, dataClassification: dataClassification, shouldReturnANExtensions: shouldReturnANExtensions = false, contextIds: contextIds, locale: locale })=>{
    $8729e3f9c8f23451$var$dataClassificatedModulesConfig.names.add(moduleName);
    // simulate next tick so other resources could register their modules to fetch
    await new Promise((resolve)=>setTimeout(resolve, 0));
    const moduleNamesToFetch = Array.from($8729e3f9c8f23451$var$dataClassificatedModulesConfig.names);
    let extensions = [];
    let accessNarrowedExtensions = [];
    // If the fetch is not already handled
    if (moduleNamesToFetch.length > 0) {
        $8729e3f9c8f23451$var$dataClassificatedModulesConfig.names = new Set();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $8729e3f9c8f23451$var$dataClassificatedModulesConfig.request = (0, $hsX10.default)((0, $6vrw7.toCloudId)(cloudId), moduleNamesToFetch, dataClassification, undefined, (0, $2Rqjr.SOURCE_FULL_PAGE_APP), contextIds, locale).then((extensionsMap)=>extensionsMap);
    }
    const result = await $8729e3f9c8f23451$var$dataClassificatedModulesConfig.request;
    extensions = result.extensions[(0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(moduleName)];
    if (shouldReturnANExtensions) accessNarrowedExtensions = result.accessNarrowedExtensions[(0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(moduleName)];
    const getExtensionsFilter = (fullPageModuleName)=>{
        switch(fullPageModuleName){
            case 0, $2Rqjr.ADMIN_PAGE_MODULE:
                return 0, $4MOAS.adminPageFilter;
            default:
                // filtered, as we allow only one extension per module
                return 0, $4MOAS.uniqueExtensionsFilter;
        }
    };
    return {
        extensions: getExtensionsFilter(moduleName)(extensions).sort((a, b)=>(0, $h1xZf.alphabeticalSort)(a.properties.title, b.properties.title)),
        accessNarrowedExtensions: getExtensionsFilter(moduleName)(accessNarrowedExtensions).sort((a, b)=>(0, $h1xZf.alphabeticalSort)(a.properties.title, b.properties.title))
    };
};

});
parcelRegister("4MOAS", function(module, exports) {

$parcel$export(module.exports, "uniqueExtensionsFilter", () => $7eebe06f4aced941$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $7eebe06f4aced941$export$1eefd1d9cde49fd5);

var $lyOYo = parcelRequire("lyOYo");

var $70ON1 = parcelRequire("70ON1");
const $7eebe06f4aced941$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $7eebe06f4aced941$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const adminExtensions = extensions;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return [
        ...$7eebe06f4aced941$export$2b91ba95eded67f6(adminExtensions.filter(mainPageFilter)),
        ...$7eebe06f4aced941$export$2b91ba95eded67f6(adminExtensions.filter(configPageFilter)),
        ...$7eebe06f4aced941$export$2b91ba95eded67f6(adminExtensions.filter(getStartedPageFilter))
    ];
};

});


parcelRegister("iLkoO", function(module, exports) {

$parcel$export(module.exports, "uniqueExtensionsFilter", () => $460a57d30e2d873b$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $460a57d30e2d873b$export$1eefd1d9cde49fd5);

var $lyOYo = parcelRequire("lyOYo");

var $70ON1 = parcelRequire("70ON1");
const $460a57d30e2d873b$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $460a57d30e2d873b$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    return [
        ...$460a57d30e2d873b$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
        ...$460a57d30e2d873b$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
        ...$460a57d30e2d873b$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
    ];
};

});



parcelRegister("jMYeN", function(module, exports) {

$parcel$export(module.exports, "toSections", () => $eb609126a990fbb2$export$29678d1e04c0e8c4);

var $5iWql = parcelRequire("5iWql");
/**
 * Just in case someone passes a broken object we don't want to blow up the sidebar
 */ const $eb609126a990fbb2$var$normalizeSection = (section)=>({
        header: section?.header,
        pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                icon: page?.icon,
                route: page?.route,
                title: page?.title
            })) : []
    });
const $eb609126a990fbb2$export$29678d1e04c0e8c4 = (0, $5iWql.default)((extension)=>{
    const { properties: properties } = extension;
    // Only Custom UI supports subpages
    if (typeof properties.resource !== 'string') return [];
    // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.pages !== 'undefined' && properties.pages?.length) // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return [
        {
            pages: properties.pages
        }
    ].map($eb609126a990fbb2$var$normalizeSection);
    // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.sections !== 'undefined' && properties.sections?.length) // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return properties.sections.map($eb609126a990fbb2$var$normalizeSection);
    return [];
});

});

parcelRegister("eOutC", function(module, exports) {

$parcel$export(module.exports, "useMatchedExtension", () => $503fa4d7a9769196$export$13375c0abccaf6f6);
$parcel$export(module.exports, "useExtensionBasePath", () => $503fa4d7a9769196$export$25abed85383f0fbb);

var $eUqFw = parcelRequire("eUqFw");

var $70ON1 = parcelRequire("70ON1");
const $503fa4d7a9769196$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $eUqFw.useMemo)(()=>(modules || []).find((app)=>{
            const parsedExtensionId = (0, $70ON1.parseExtensionId)(app.id);
            return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
        }), [
        modules,
        match.params.appId,
        match.params.envId
    ]);
const $503fa4d7a9769196$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');

});


parcelRegister("5w4hM", function(module, exports) {

$parcel$export(module.exports, "genericProjectSidebars", () => $541e179b5fa9e509$export$d88d2d25355bc89a);
$parcel$export(module.exports, "classicBoardSidebars", () => $541e179b5fa9e509$export$c04daf123cec1f1e);
$parcel$export(module.exports, "genericConnectSidebars", () => $541e179b5fa9e509$export$844d342b575ead35);

var $497qU = parcelRequire("497qU");

var $buaC1 = parcelRequire("buaC1");

var $hUM03 = parcelRequire("hUM03");

var $bt7QT = parcelRequire("bt7QT");

var $iOOlt = parcelRequire("iOOlt");

var $iTYGl = parcelRequire("iTYGl");

var $2Fzrk = parcelRequire("2Fzrk");

var $8rBPw = parcelRequire("8rBPw");
const $541e179b5fa9e509$export$d88d2d25355bc89a = [
    (0, $buaC1.default),
    (0, $iOOlt.default),
    (0, $iTYGl.default),
    (0, $2Fzrk.default),
    (0, $8rBPw.default)
];
const $541e179b5fa9e509$export$c04daf123cec1f1e = [
    (0, $2Fzrk.default),
    (0, $8rBPw.default)
];
const $541e179b5fa9e509$export$844d342b575ead35 = [
    ...$541e179b5fa9e509$export$d88d2d25355bc89a,
    (0, $497qU.default),
    (0, $hUM03.default),
    (0, $bt7QT.default)
];

});
parcelRegister("hUM03", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1b194caac4ce1a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $ea1b194caac4ce1a$var$LazyGlobalAppsSettingsSidebar = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("76Qc1")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ea1b194caac4ce1a$var$GlobalAppsSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalAppsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ea1b194caac4ce1a$var$LazyGlobalAppsSettingsSidebar, null)));
$ea1b194caac4ce1a$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
var $ea1b194caac4ce1a$export$2e2bcd8739ae039 = $ea1b194caac4ce1a$var$GlobalAppsSettingsSidebar;

});
parcelRegister("76Qc1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("iyqJ7")
]).then(()=>parcelRequire('60IuX'));

});


parcelRegister("bt7QT", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a98b92e63b4efb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $93a98b92e63b4efb$var$LazyGlobalSystemSettingsSidebar = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("fRLTC")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $93a98b92e63b4efb$var$GlobalSystemSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalSystemSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($93a98b92e63b4efb$var$LazyGlobalSystemSettingsSidebar, null)));
$93a98b92e63b4efb$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
var $93a98b92e63b4efb$export$2e2bcd8739ae039 = $93a98b92e63b4efb$var$GlobalSystemSettingsSidebar;

});
parcelRegister("fRLTC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("SBVRB")
]).then(()=>parcelRequire('l15zb'));

});


parcelRegister("iOOlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9c5b483f80318f8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $a9c5b483f80318f8$var$LazyClassicSoftwareProjectSidebar = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("8hvAI")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a9c5b483f80318f8$var$SoftwareProjectSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a9c5b483f80318f8$var$LazyClassicSoftwareProjectSidebar, null)));
$a9c5b483f80318f8$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
var $a9c5b483f80318f8$export$2e2bcd8739ae039 = $a9c5b483f80318f8$var$SoftwareProjectSidebar;

});
parcelRegister("8hvAI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bqmoa")
]).then(()=>parcelRequire('dSgKD'));

});


parcelRegister("iTYGl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f67fc1f904f75a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $2f67fc1f904f75a4$export$5b9febabdab63fba = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("5DwZR")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});
const $2f67fc1f904f75a4$var$ServicedeskSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f67fc1f904f75a4$export$5b9febabdab63fba, null)));
$2f67fc1f904f75a4$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
var $2f67fc1f904f75a4$export$2e2bcd8739ae039 = $2f67fc1f904f75a4$var$ServicedeskSidebar;

});
parcelRegister("5DwZR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("4673m")
]).then(()=>parcelRequire('2osKk'));

});


parcelRegister("2Fzrk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9bc2c6e90de3714$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $d9bc2c6e90de3714$var$LazyClassicSoftwareProjectSidebar = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("kmwFb")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d9bc2c6e90de3714$var$ClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9bc2c6e90de3714$var$LazyClassicSoftwareProjectSidebar, null)));
$d9bc2c6e90de3714$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
var $d9bc2c6e90de3714$export$2e2bcd8739ae039 = $d9bc2c6e90de3714$var$ClassicSoftwareProjectSidebar;

});
parcelRegister("kmwFb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("iN4Tu")
]).then(()=>parcelRequire('7bWFF'));

});


parcelRegister("8rBPw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d50106f0c2df90e8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $d50106f0c2df90e8$var$LazyUserSidebar = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("9toJY")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d50106f0c2df90e8$var$UserSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d50106f0c2df90e8$var$LazyUserSidebar, null)));
$d50106f0c2df90e8$var$UserSidebar.displayName = 'UserSidebar';
var $d50106f0c2df90e8$export$2e2bcd8739ae039 = $d50106f0c2df90e8$var$UserSidebar;

});
parcelRegister("9toJY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kmOrn")
]).then(()=>parcelRequire('fPz94'));

});



parcelRegister("lWODs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a283bb034822426$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $3a283bb034822426$var$LazyInsightObjectSchemaSidebar = (0, $6VZoe.lazyForPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("1YCS6")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/insight-object-schema/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3a283bb034822426$var$InsightObjectSchemaSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "insight-object-schema-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a283bb034822426$var$LazyInsightObjectSchemaSidebar, null)));
$3a283bb034822426$var$InsightObjectSchemaSidebar.displayName = 'InsightObjectSchemaSidebar';
var $3a283bb034822426$export$2e2bcd8739ae039 = $3a283bb034822426$var$InsightObjectSchemaSidebar;

});
parcelRegister("1YCS6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("c2mHX")
]).then(()=>parcelRequire('7JPCs'));

});


parcelRegister("29Nmz", function(module, exports) {

$parcel$export(module.exports, "default", () => $884186ee0b4383e1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $884186ee0b4383e1$var$LazyPlanSidebar = (0, $6VZoe.lazyForPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("4KDfr")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/plan/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $884186ee0b4383e1$var$PlanSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "Plan"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($884186ee0b4383e1$var$LazyPlanSidebar, null)));
$884186ee0b4383e1$var$PlanSidebar.displayName = 'PlanSidebar';
var $884186ee0b4383e1$export$2e2bcd8739ae039 = $884186ee0b4383e1$var$PlanSidebar;

});
parcelRegister("4KDfr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("kzUYN")),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("4I2Cp")
]).then(()=>parcelRequire('k3Z6q'));

});


parcelRegister("bSRyW", function(module, exports) {

$parcel$export(module.exports, "default", () => $67512e4ded0c1d23$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $67512e4ded0c1d23$var$LazyPolarisProjectSidebar = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("epSXR")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/polaris/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $67512e4ded0c1d23$var$PolarisProjectSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "polarisProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($67512e4ded0c1d23$var$LazyPolarisProjectSidebar, null)));
$67512e4ded0c1d23$var$PolarisProjectSidebar.displayName = 'PolarisProjectSidebar';
var $67512e4ded0c1d23$export$2e2bcd8739ae039 = $67512e4ded0c1d23$var$PolarisProjectSidebar;

});
parcelRegister("epSXR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2jChg")
]).then(()=>parcelRequire('51gNq'));

});



parcelRegister("2W91Z", function(module, exports) {

$parcel$export(module.exports, "AsyncNudgeBundledUsersFlagContainer", () => $5ceff6512532f6e8$export$30d9dff000fbaa2d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $6VZoe = parcelRequire("6VZoe");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5ceff6512532f6e8$var$NudgeBundledUsersFlagContainer = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("1C77s")).then((module)=>module.NudgeBundledUsersXflow), {
    ssr: false,
    moduleId: "./src/packages/growth/nudge-bundled-users-to-join-connie/src/ui/index.tsx"
});
const $5ceff6512532f6e8$export$30d9dff000fbaa2d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "nudgeBundledUserFlag",
        packageName: "nudgeBundledUsersToJoinConnie",
        fallback: "unmount",
        teamName: "confluenceOnboarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nudge-bundled-users-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ceff6512532f6e8$var$NudgeBundledUsersFlagContainer, null)));

});
parcelRegister("1C77s", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7RDvS").then(()=>parcelRequire('cJqaO'));

});


parcelRegister("8C1im", function(module, exports) {

$parcel$export(module.exports, "SidebarFeedbackButton", () => $3df3ce63e21ffa04$export$b270ed097d20c023);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");

var $5XhNO = parcelRequire("5XhNO");

var $5OdZ3 = parcelRequire("5OdZ3");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1c02D = parcelRequire("1c02D");

var $irg9D = parcelRequire("irg9D");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $7BqbB = parcelRequire("7BqbB");

var $h4Mb7 = parcelRequire("h4Mb7");

var $b1is6 = parcelRequire("b1is6");

var $9Anw5 = parcelRequire("9Anw5");

var $dWLk9 = parcelRequire("dWLk9");

var $3e9vj = parcelRequire("3e9vj");

var $92kON = parcelRequire("92kON");
const $3df3ce63e21ffa04$export$b270ed097d20c023 = ()=>{
    const environment = (0, $3e9vj.useEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { openFeedbackCollector: openFeedbackCollector, closeFeedbackCollector: closeFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const onClickHandler = (0, $eUqFw.useCallback)(()=>{
        const showFeedbackTitleDetailsWithLink = (0, $h4Mb7.getWillShowNav4UserOptIn)() || (0, $b1is6.getWillShowNav4UserOptOut)();
        const formattedMessageNode = showFeedbackTitleDetailsWithLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $92kON.default).feedbackTitleDetailsWithLink,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
                        href: "/jira/settings/personal/general",
                        onClick: closeFeedbackCollector
                    }, chunks)
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $92kON.default).feedbackTitleDetailsNoLink);
        openFeedbackCollector({
            entrypointId: (0, $1c02D.ENTRYPOINT_ID_NAVIGATION_REFRESH),
            feedbackContext: [
                {
                    id: 'environment',
                    value: environment
                },
                {
                    id: 'cloud-id',
                    value: cloudId
                },
                {
                    id: 'location',
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    value: (0, $9Anw5.default)(window?.location?.href ?? '')
                }
            ],
            feedbackGroupId: (0, $7BqbB.NAV4_GENERAL_FEEDBACK_GROUP_ID),
            feedbackTitle: formatMessage((0, $92kON.default).feedbackTitle),
            feedbackTitleDetails: formattedMessageNode
        });
    }, [
        closeFeedbackCollector,
        cloudId,
        environment,
        formatMessage,
        openFeedbackCollector
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3df3ce63e21ffa04$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        shouldFitContainer: true,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($5XhNO))),
        appearance: "subtle",
        onClick: onClickHandler
    }, formatMessage((0, $92kON.default).sidebarFeedbackButtonLabel)));
};
const $3df3ce63e21ffa04$var$containerStyles = (0, $1ZAYh.xcss)({
    flex: 'none',
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    padding: 'space.150',
    background: "var(--ds-surface-raised, #FFF)"
});

});
parcelRegister("5XhNO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::60edb8db9f6bfb3658759225f550b1d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $456045a44d7bf5ef$var$_react = $456045a44d7bf5ef$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $456045a44d7bf5ef$var$_UNSAFE_baseNew = $456045a44d7bf5ef$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $456045a44d7bf5ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $456045a44d7bf5ef$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $456045a44d7bf5ef$var$_react.default.createElement($456045a44d7bf5ef$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 4.25H3c-.69 0-1.25.56-1.25 1.25v3.25C1.75 9.44 2.31 10 3 10h1.25m2.5-5.75 5.786-2.314a1.25 1.25 0 0 1 1.714 1.16v8.058a1.25 1.25 0 0 1-1.714 1.16L6.75 10m0-5.75V10m0 0h-2.5m2.5 0v4.25H5.5c-.69 0-1.25-.56-1.25-1.25v-3"/>`
    }, props));
$456045a44d7bf5ef$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $456045a44d7bf5ef$var$_default = module.exports.default = $456045a44d7bf5ef$var$MegaphoneIcon;

});

parcelRegister("1c02D", function(module, exports) {

$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $ccbba0a7f0f3304b$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $ccbba0a7f0f3304b$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $ccbba0a7f0f3304b$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $ccbba0a7f0f3304b$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $ccbba0a7f0f3304b$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $ccbba0a7f0f3304b$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $ccbba0a7f0f3304b$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $ccbba0a7f0f3304b$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", () => $ccbba0a7f0f3304b$export$5bd148c13bb23f7a);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $ccbba0a7f0f3304b$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $ccbba0a7f0f3304b$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $ccbba0a7f0f3304b$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", () => $ccbba0a7f0f3304b$export$23f6d7b16d2210c1);
$parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", () => $ccbba0a7f0f3304b$export$1b65c2053cba0686);
$parcel$export(module.exports, "EntryKeys", () => $ccbba0a7f0f3304b$export$12d01b6c311a909a);
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $ccbba0a7f0f3304b$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $ccbba0a7f0f3304b$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $ccbba0a7f0f3304b$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $ccbba0a7f0f3304b$export$4a288e389131b3de = 'b6176efc-e703-426b-b4f8-3e43ce4aa0db';
const $ccbba0a7f0f3304b$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $ccbba0a7f0f3304b$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $ccbba0a7f0f3304b$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $ccbba0a7f0f3304b$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $ccbba0a7f0f3304b$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $ccbba0a7f0f3304b$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
const $ccbba0a7f0f3304b$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $ccbba0a7f0f3304b$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $ccbba0a7f0f3304b$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $ccbba0a7f0f3304b$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $ccbba0a7f0f3304b$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
const $ccbba0a7f0f3304b$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment',
    SMART_REPLIES: 'smart-replies'
});

});

parcelRegister("irg9D", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $8d3d8a971c5329dd$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $8d3d8a971c5329dd$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $8d3d8a971c5329dd$export$c35dbf16ebe9df04);

var $WBLbN = parcelRequire("WBLbN");
const $8d3d8a971c5329dd$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined,
    customFeedbackOptions: []
};
const $8d3d8a971c5329dd$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($8d3d8a971c5329dd$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$8d3d8a971c5329dd$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $8d3d8a971c5329dd$var$Store = (0, $WBLbN.createStore)({
    name: 'feedback-collector',
    initialState: $8d3d8a971c5329dd$export$d4c72bab9d6cc13a,
    actions: $8d3d8a971c5329dd$export$e324594224ef24da
});
const $8d3d8a971c5329dd$export$4be696be8a3bff13 = (0, $WBLbN.createHook)($8d3d8a971c5329dd$var$Store);
const $8d3d8a971c5329dd$export$dfb2ee2d9e73fa48 = (0, $WBLbN.createActionsHook)($8d3d8a971c5329dd$var$Store);
const $8d3d8a971c5329dd$export$c35dbf16ebe9df04 = (0, $WBLbN.createSubscriber)($8d3d8a971c5329dd$var$Store, {
    selector: null
});

});

parcelRegister("h4Mb7", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4UserOptIn", () => $52d89fd9532d4f67$export$46a00895da9889a2);

var $eI5EY = parcelRequire("eI5EY");
const $52d89fd9532d4f67$export$46a00895da9889a2 = ()=>(0, $eI5EY.fg)('jira_nav4') && $52d89fd9532d4f67$var$getWillShowNav4UserOptInForExistingCustomers();
// Update this when the existing customers stage gets closer.
// See https://hello.atlassian.net/wiki/spaces/JNR/pages/3699574590/Rollout+technical+design+draft#User-opt-in-checkbox
const $52d89fd9532d4f67$var$getWillShowNav4UserOptInForExistingCustomers = ()=>false;

});

parcelRegister("b1is6", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4UserOptOut", () => $a8bd3e70aed7a6e6$export$acb346134ed05173);

var $eI5EY = parcelRequire("eI5EY");

var $6hzdX = parcelRequire("6hzdX");

var $3z408 = parcelRequire("3z408");
const $a8bd3e70aed7a6e6$export$acb346134ed05173 = ()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $eI5EY.fg)('jira_nav4') && ((0, $6hzdX.getWillShowNav4UserOptOutForDogfooding)() || (0, $eI5EY.fg)('jira_nav4_eap')) || // User opt out is being shared with visual refresh. It should show if visual refresh is on regardless of nav4.
    (0, $3z408.getWillShowNav4UserOptOutForVisualRefresh)();

});
parcelRegister("6hzdX", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4UserOptOutForDogfooding", () => $ec1ebc37a1c8730e$export$9edbe3a98989e15b);

var $eI5EY = parcelRequire("eI5EY");
const $ec1ebc37a1c8730e$export$9edbe3a98989e15b = ()=>(0, $eI5EY.fg)('jira_nav4_dogfooding') && ((0, $eI5EY.fg)('jira_nav4_dogfooding_phase-1') || (0, $eI5EY.fg)('jira_nav4_dogfooding_phase-2'));

});

parcelRegister("3z408", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4UserOptOutForVisualRefresh", () => $3d4201e1ff73b82c$export$17e35ae7beae962d);

var $eI5EY = parcelRequire("eI5EY");
const $3d4201e1ff73b82c$export$17e35ae7beae962d = ()=>(0, $eI5EY.fg)('visual-refresh') && ((0, $eI5EY.fg)('visual-refresh-dogfood') || (0, $eI5EY.fg)('visual-refresh-eap'));

});


parcelRegister("92kON", function(module, exports) {

$parcel$export(module.exports, "default", () => $86bb30320a718c7b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $86bb30320a718c7b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sidebarFeedbackButtonLabel: {
        "id": "sidebar-nav4-feedback-button.sidebar-feedback-button-label",
        "defaultMessage": "Give feedback on the new navigation"
    },
    feedbackTitle: {
        "id": "sidebar-nav4-feedback-button.utils.use-nav4-feedback-collector.feedback-title",
        "defaultMessage": "Help us improve the new navigation"
    },
    feedbackTitleDetailsWithLink: {
        "id": "sidebar-nav4-feedback-button.feedback-title-details",
        "defaultMessage": "We\u2019d love to hear about your experience with the new navigation. If needed, <a>you can switch back to the old navigation</a>."
    },
    feedbackTitleDetailsNoLink: {
        "id": "sidebar-nav4-feedback-button.feedback-title-details-no-link",
        "defaultMessage": "We\u2019d love to hear about your experience with the new navigation."
    }
});

});


parcelRegister("lWATQ", function(module, exports) {

$parcel$export(module.exports, "PanelSplitter", () => $294fcdaee6e5d8fd$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lEfVV = parcelRequire("lEfVV");

var $8ynlC = parcelRequire("8ynlC");

var $5Q9wj = parcelRequire("5Q9wj");

var $XHGTv = parcelRequire("XHGTv");

var $3f2za = parcelRequire("3f2za");

var $eo9PV = parcelRequire("eo9PV");
parcelRequire("iclnR");
var $hI8nZ = parcelRequire("hI8nZ");
parcelRequire("cbxSN");
var $iYy22 = parcelRequire("iYy22");
parcelRequire("jTs7k");
var $1xLt0 = parcelRequire("1xLt0");

var $4ZL0y = parcelRequire("4ZL0y");

var $lkPEe = parcelRequire("lkPEe");

var $bAHwD = parcelRequire("bAHwD");

var $4sWxn = parcelRequire("4sWxn");

var $exYPH = parcelRequire("exYPH");
const $294fcdaee6e5d8fd$var$containerStyles = {
    root: "_1e0cglyw _kqswstnw _u7coidpf _152tidpf _12ji1r31 _1qu2glyw _12y31o36 _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
const $294fcdaee6e5d8fd$var$buttonStyles = {
    grabArea: "_1bsbl52n _4t3i1osq _kqswstnw _1yt4ze3t _syaz3acm _bfhk18uv _v5645ge5 _1lww5cps _d0aluf7j _1gavfnf5 _v0vwaqb7 _30l3aqb7 _1gk412xp _o7ks12xp _9h8h16c2 _1gglglyw",
    content: "_1bsb1osq _4t3i1osq"
};
const $294fcdaee6e5d8fd$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
const $294fcdaee6e5d8fd$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, interactionName: interactionName, testId: testId })=>{
    const splitterRef = (0, $eUqFw.useRef)(null);
    const panelSplitterContext = (0, $eUqFw.useContext)((0, $bAHwD.PanelSplitterContext));
    (0, $8ynlC.default)(panelSplitterContext, 'Panel splitter context must be set');
    const { panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, portalRef: portalRef, position: position, isEnabled: isEnabled } = panelSplitterContext;
    (0, $8ynlC.default)(portalRef.current, 'Portal ref must be set');
    const direction = (0, $exYPH.useTextDirection)(portalRef.current);
    (0, $eUqFw.useEffect)(()=>{
        if (!isEnabled) return;
        const splitter = splitterRef.current;
        (0, $8ynlC.default)(splitter, 'Splitter ref must be set');
        return (0, $3f2za.combine)((0, $XHGTv.fg)('jira_nav4_eap_drop_1') ? (0, $hI8nZ.blockDraggingToIFrames)({
            element: splitter
        }) : (0, $5Q9wj.default), (0, $eo9PV.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $iYy22.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $1xLt0.preventUnhandled).start();
            },
            getInitialData () {
                (0, $8ynlC.default)(panelRef.current, 'Panel ref must be set');
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return {
                    initialWidth: (0, $4sWxn.getPixelWidth)(panelRef.current)
                };
            },
            onDragStart ({ source: source }) {
                (0, $8ynlC.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                });
            },
            onDrag ({ location: location, source: source }) {
                (0, $8ynlC.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                panelRef.current?.style.setProperty(resizingCssVar, `clamp(${resizeBounds.min}, ${(0, $4sWxn.getWidthFromDragLocation)({
                    initialWidth: source.data.initialWidth,
                    location: location,
                    direction: direction,
                    position: position
                })}px, ${resizeBounds.max})`);
            },
            onDrop ({ source: source }) {
                (0, $1xLt0.preventUnhandled).stop();
                (0, $8ynlC.default)(panelRef.current, 'Panel ref must be set');
                (0, $8ynlC.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                const finalWidth = (0, $4sWxn.getPixelWidth)(panelRef.current);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panelRef.current.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panelRef,
        resizingCssVar,
        panelWidth,
        resizeBounds,
        direction,
        position,
        isEnabled
    ]);
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ $eUqFw.createElement("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $7JEyt.default)([
            $294fcdaee6e5d8fd$var$containerStyles.root,
            position === 'start' && $294fcdaee6e5d8fd$var$containerStyles.positionStart,
            position === 'end' && $294fcdaee6e5d8fd$var$containerStyles.positionEnd
        ])
    }, /*#__PURE__*/ $eUqFw.createElement((0, $4ZL0y.default), {
        // To win the specificity war we need to use inline styles so Compiled wins over Emotion.
        // Sorry Kylor!
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            outline: 'none'
        },
        ref: splitterRef,
        xcss: $294fcdaee6e5d8fd$var$buttonStyles.grabArea,
        interactionName: interactionName,
        testId: testId
    }, /*#__PURE__*/ $eUqFw.createElement("div", {
        // Due to a Firefox bug with button element drag events we need to make the button
        // content (children) fill up the entire space of the button.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=568313#c16
        className: (0, $7JEyt.default)([
            $294fcdaee6e5d8fd$var$buttonStyles.content
        ])
    }, /*#__PURE__*/ $eUqFw.createElement((0, $lkPEe.default), null, label), /*#__PURE__*/ $eUqFw.createElement("span", {
        className: (0, $7JEyt.default)([
            $294fcdaee6e5d8fd$var$lineStyles.root
        ])
    })))), portalRef.current);
};
// Ensures that the component is only rendered on a client. Uses a `useEffect`, which is not run on servers.
const $294fcdaee6e5d8fd$var$ClientOnly = ({ children: children })=>{
    const [hasMounted, setHasMounted] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        setHasMounted(true);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement((0, $eUqFw.Fragment), null, hasMounted ? children : null);
};
const $294fcdaee6e5d8fd$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, interactionName: interactionName, testId: testId })=>/*#__PURE__*/ $eUqFw.createElement($294fcdaee6e5d8fd$var$ClientOnly, null, /*#__PURE__*/ $eUqFw.createElement($294fcdaee6e5d8fd$var$PortaledPanelSplitter, {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        interactionName: interactionName,
        testId: testId
    }));

});
parcelRegister("iclnR", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => (parcelRequire("hI8nZ")).blockDraggingToIFrames);

var $hI8nZ = parcelRequire("hI8nZ");

});
parcelRegister("hI8nZ", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => $f984940944d5a90a$export$6ae1d8fab001518c);

var $9wCS5 = parcelRequire("9wCS5");

var $jFl9L = parcelRequire("jFl9L");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $f984940944d5a90a$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $f984940944d5a90a$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $f984940944d5a90a$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($f984940944d5a90a$var$isActive) return;
    $f984940944d5a90a$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$f984940944d5a90a$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $jFl9L.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $9wCS5.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $f984940944d5a90a$var$isActive = false;
    });
}
function $f984940944d5a90a$export$6ae1d8fab001518c({ element: element }) {
    return (0, $9wCS5.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $f984940944d5a90a$var$tryStart();
        }
    });
}

});


parcelRegister("cbxSN", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("iYy22")).disableNativeDragPreview);

var $iYy22 = parcelRequire("iYy22");

});
parcelRegister("iYy22", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => $f96526f07b5b7d85$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $f96526f07b5b7d85$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $f96526f07b5b7d85$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $f96526f07b5b7d85$var$tinyTransparentImage) nativeSetDragImage($f96526f07b5b7d85$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("jTs7k", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("1xLt0")).preventUnhandled);

var $1xLt0 = parcelRequire("1xLt0");

});
parcelRegister("1xLt0", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => $6e73835b1fb5a057$export$453c0582481cc59d);

var $74BVL = parcelRequire("74BVL");

var $fURjR = parcelRequire("fURjR");
function $6e73835b1fb5a057$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $6e73835b1fb5a057$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $6e73835b1fb5a057$var$start() {
    $6e73835b1fb5a057$var$cleanup();
    $6e73835b1fb5a057$var$unbindEvents = (0, $74BVL.bindAll)(window, [
        {
            type: 'dragover',
            listener: $6e73835b1fb5a057$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $6e73835b1fb5a057$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $6e73835b1fb5a057$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $6e73835b1fb5a057$var$cleanup
        },
        ...(0, $fURjR.getBindingsForBrokenDrags)({
            onDragEnd: $6e73835b1fb5a057$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $6e73835b1fb5a057$var$cleanup() {
    $6e73835b1fb5a057$var$unbindEvents?.();
    $6e73835b1fb5a057$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $6e73835b1fb5a057$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $6e73835b1fb5a057$var$cleanup();
}
const $6e73835b1fb5a057$export$453c0582481cc59d = {
    start: $6e73835b1fb5a057$var$start,
    stop: $6e73835b1fb5a057$var$stop
};

});


parcelRegister("4sWxn", function(module, exports) {

$parcel$export(module.exports, "getWidthFromDragLocation", () => $f380bc8766318d03$export$e360234971cb95b8);
$parcel$export(module.exports, "getPixelWidth", () => $f380bc8766318d03$export$d942790ad00c41f9);
const $f380bc8766318d03$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};
const $f380bc8766318d03$export$d942790ad00c41f9 = (element)=>{
    const { width: width } = window.getComputedStyle(element);
    return parseInt(width);
};

});

parcelRegister("exYPH", function(module, exports) {

$parcel$export(module.exports, "useTextDirection", () => $4d81149f9603ea38$export$cf24a79f32f45545);

var $eUqFw = parcelRequire("eUqFw");
const $4d81149f9603ea38$export$cf24a79f32f45545 = (element)=>(0, $eUqFw.useMemo)(()=>{
        const { direction: direction } = window.getComputedStyle(element);
        return direction === 'rtl' ? 'rtl' : 'ltr';
    }, [
        element
    ]);

});


parcelRegister("2D8YV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $be3f30c8885e888c$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $be3f30c8885e888c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    sidebarNavigation: {
        "id": "page-container-v2.common.sidebar.sidebar-navigation",
        "defaultMessage": "Sidebar navigation"
    },
    sideBarPanelSplitterLabel: {
        "id": "page-container-v2.common.sidebar.side-bar-panel-splitter-label",
        "defaultMessage": "Resize side navigation panel"
    }
});

});

parcelRegister("j6voN", function(module, exports) {

$parcel$export(module.exports, "AsyncResizeButtonTooltip", () => $e7092259f8fc51fc$export$e12f5b3a390577de);

var $6VZoe = parcelRequire("6VZoe");

const $e7092259f8fc51fc$export$e12f5b3a390577de = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("3Iryw")), {
    ssr: false,
    moduleId: "./src/packages/page-container-v2/src/common/ui/sidebar/resize-button-tooltip/main.tsx"
});

});
parcelRegister("3Iryw", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lm6kY").then(()=>parcelRequire('eNPes'));

});



parcelRegister("4LQUt", function(module, exports) {

$parcel$export(module.exports, "TopNav", () => $2934d73e9d5f196a$export$41d0d88a6b0e456f);

var $eUqFw = parcelRequire("eUqFw");

var $8fxTv = parcelRequire("8fxTv");

var $7webZ = parcelRequire("7webZ");

var $5kDtB = parcelRequire("5kDtB");

var $iBTyI = parcelRequire("iBTyI");

var $eDbLL = parcelRequire("eDbLL");

var $aYtGv = parcelRequire("aYtGv");

var $c9TLT = parcelRequire("c9TLT");

var $0cdA8 = parcelRequire("0cdA8");

var $4qhD6 = parcelRequire("4qhD6");

var $9zysr = parcelRequire("9zysr");

var $eQbJ4 = parcelRequire("eQbJ4");

var $6VKSg = parcelRequire("6VKSg");

var $6FP8W = parcelRequire("6FP8W");

var $hwyJ1 = parcelRequire("hwyJ1");

var $gGtKh = parcelRequire("gGtKh");

var $inC6u = parcelRequire("inC6u");

var $jK1pm = parcelRequire("jK1pm");

var $ghXjN = parcelRequire("ghXjN");

var $3EdDr = parcelRequire("3EdDr");

var $7xu2f = parcelRequire("7xu2f");
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $2934d73e9d5f196a$var$APP_NAVIGATION_TRACE_KEY = 'app_navigation';
const $2934d73e9d5f196a$var$LegacyPageNavigationStyles = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #page-body { width: 100vw; max-width: 100%; }
                    #cloneissueprogressform { margin-top: ${(0, $c9TLT.gridSize) * 3}px; }
                    [data-testid="Content"] {margin-top: calc(${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)})!important;}
                    #view-projects-content { margin-top: calc(-1 * ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)}); } /* admin project dir hack */
                `
        }
    });
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */ const $2934d73e9d5f196a$var$TEST_ID = 'page-layout.top-nav';
const $2934d73e9d5f196a$var$NewTopNav = ()=>{
    const { shouldRender: shouldRender } = (0, $6VKSg.useTopNavState)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "nav4.topNav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "topNavigationSkipLink",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.TopNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2934d73e9d5f196a$var$LegacyPageNavigationStyles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.TopNavigation), {
        isFixed: true,
        testId: $2934d73e9d5f196a$var$TEST_ID
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBTyI.AtlassianNavigationStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "navigation.atlassian-navigation",
        packageName: "jiraPageContainerV2",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDbLL.JiraAtlassianNavigationSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7xu2f.AsyncAtlassianNavigation), null)))));
};
/**
 * This has been inlined from `@atlassian/jira-common-constants/src/page-layout`
 * because it isn't used anywhere else, and to prevent new usage.
 */ const $2934d73e9d5f196a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT = 56;
/**
 * Implements a responsive top navigation bar that adjusts for fullscreen view and renders
 * based on application state. It ensures seamless navigation experience across different
 * sections of the application while handling errors gracefully and tracking performance.
 */ const $2934d73e9d5f196a$var$OldTopNav = ()=>{
    const fullscreenRef = (0, $eUqFw.useRef)(null);
    const { isFullscreen: isFullscreen } = (0, $eQbJ4.useIsFullscreen)(fullscreenRef.current);
    const { shouldRender: shouldRender } = (0, $6VKSg.useTopNavState)();
    const onFail = (0, $4qhD6.useExperienceFail)({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MAIN)
    });
    const height = isFullscreen ? 0 : $2934d73e9d5f196a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT;
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "topNavigationSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.TopNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2934d73e9d5f196a$var$LegacyPageNavigationStyles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EdDr.ZIndexWrapper), {
        zIndex: (0, $c9TLT.layers).navigation,
        // @ts-expect-error - TS2322 - Type '{ children: Element; zIndex: 200; top: string; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, any>, any, any>> & Readonly<...> & Readonly<...>'.
        top: (0, $hwyJ1.UNSAFE_DO_NOT_USE_BANNER_HEIGHT),
        "data-fullscreen-id": "fullscreen.page-container-v2.topnav",
        ref: fullscreenRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.TopNavigation), {
        isFixed: true,
        height: height,
        id: "ak-jira-navigation"
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBTyI.AtlassianNavigationStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "navigation.atlassian-navigation",
        packageName: "jiraPageContainer",
        fallback: "flag",
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDbLL.JiraAtlassianNavigationSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavTopPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_TOP_MARKS).bundleLoadStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavTopSSRPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        type: "start",
        traceKey: $2934d73e9d5f196a$var$APP_NAVIGATION_TRACE_KEY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7xu2f.AsyncAtlassianNavigation), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        type: "end",
        traceKey: $2934d73e9d5f196a$var$APP_NAVIGATION_TRACE_KEY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavTopSSRPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrEnd
    }))))));
};
const $2934d73e9d5f196a$export$41d0d88a6b0e456f = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $2934d73e9d5f196a$var$NewTopNav, $2934d73e9d5f196a$var$OldTopNav);

});
parcelRegister("5kDtB", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $e27f7da44da2e940$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_FAV", () => $e27f7da44da2e940$export$ea341e6cc435ed40);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_VIEWED", () => $e27f7da44da2e940$export$cb66c02d110b1531);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_RECENT", () => $e27f7da44da2e940$export$22ea57e66775a6b2);
$parcel$export(module.exports, "TOP_LEVEL_ERROR_BOUNDARY_ID", () => $e27f7da44da2e940$export$4766f0c4b6fe35dc);
$parcel$export(module.exports, "NAVIGATION_ITEM_ID", () => $e27f7da44da2e940$export$1a9b265c626e9d44);
$parcel$export(module.exports, "MODAL_ID", () => $e27f7da44da2e940$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "PROFILE_SPOTLIGHT_KEY", () => $e27f7da44da2e940$export$6037915bf3452cf3);
$parcel$export(module.exports, "HELP_SPOTLIGHT_KEY", () => $e27f7da44da2e940$export$286c2faa2103eb9c);
$parcel$export(module.exports, "SEARCH_SPOTLIGHT_KEY", () => $e27f7da44da2e940$export$c0d6ac131d4391b9);
$parcel$export(module.exports, "PROJECTS_SPOTLIGHT_KEY", () => $e27f7da44da2e940$export$8d9442dfaec4086f);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MAIN", () => $e27f7da44da2e940$export$3014c5ec440d8824);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MENU", () => $e27f7da44da2e940$export$69cbedccc0df48);
$parcel$export(module.exports, "YOUR_WORK_DROPDOWN_TAB_ID", () => $e27f7da44da2e940$export$1935aad1d702494c);
$parcel$export(module.exports, "JSW_TMP_BACKLOG_BOARD_REGEXP", () => $e27f7da44da2e940$export$cc578bc72d7a7308);
const $e27f7da44da2e940$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
const $e27f7da44da2e940$export$ea341e6cc435ed40 = 15;
const $e27f7da44da2e940$export$8666f31c8873bff = 10;
const $e27f7da44da2e940$export$cb66c02d110b1531 = 10;
const $e27f7da44da2e940$export$22ea57e66775a6b2 = 5;
const $e27f7da44da2e940$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $e27f7da44da2e940$export$1a9b265c626e9d44 = {
    ADDONS: 'apps',
    CREATE: 'createIssue',
    APP_SWITCHER: 'atlassianSwitcher',
    DASHBOARDS: 'dashboards',
    FILTERS: 'filters',
    HELP: 'help',
    HELP_BADGE: 'helpBadge',
    HOME: 'home',
    INSIGHT: 'insight',
    LOGO: 'productLogo',
    NOTIFICATIONS: 'notifications',
    PEOPLE: 'people',
    PLANS: 'plans',
    PROFILE: 'profile',
    PROJECTS: 'projects',
    ROADMAPS: 'roadmaps',
    SEARCH: 'search',
    SERVICE_HUB: 'services',
    SETTINGS: 'settings',
    SIGN_IN: 'signIn',
    YOUR_WORK_DROPDOWN: 'yourWorkDropdown',
    CONVERSATION_ASSISTANT: 'conversationAssistant'
};
const $e27f7da44da2e940$export$ebdd5a8e5b1c2de5 = {
    DASHBOARD_CREATE: 'DASHBOARD_CREATE',
    KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
    PROJECT_CREATE: 'PROJECT_CREATE'
};
const $e27f7da44da2e940$export$6037915bf3452cf3 = 'profile-spotlight';
const $e27f7da44da2e940$export$286c2faa2103eb9c = 'help-spotlight';
const $e27f7da44da2e940$export$c0d6ac131d4391b9 = 'search-spotlight';
const $e27f7da44da2e940$export$8d9442dfaec4086f = 'projects-spotlight';
const $e27f7da44da2e940$export$3014c5ec440d8824 = 'viewAtlassianNavigation';
const $e27f7da44da2e940$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $e27f7da44da2e940$export$1935aad1d702494c = {
    RECENT: 'RECENT',
    BOARDS: 'BOARDS',
    QUEUES: 'QUEUES',
    ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
    ADD_FILTER: 'ADD_FILTER',
    ALERTS: 'ALERTS'
};
const $e27f7da44da2e940$export$bbaa49b5be375ff3 = 3;
const $e27f7da44da2e940$export$cc578bc72d7a7308 = /jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;
const $e27f7da44da2e940$export$9b8f5a607ecb9c5c = 'com.atlassian.jira.slack';

});

parcelRegister("iBTyI", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigationStart", () => $27c6c05e2b688f95$export$831e6a6e875b5ef8);

var $eUqFw = parcelRequire("eUqFw");

var $bDhRl = parcelRequire("bDhRl");

var $kIY50 = parcelRequire("kIY50");


var $lcJyp = parcelRequire("lcJyp");

var $3O0Td = parcelRequire("3O0Td");

var $lB25E = parcelRequire("lB25E");

var $5kDtB = parcelRequire("5kDtB");
const $27c6c05e2b688f95$export$831e6a6e875b5ef8 = ()=>{
    const [{ location: location }] = (0, $lB25E.useRouter)();
    const [, { setAppStartWithAppId: setAppStartWithAppId }] = (0, $lcJyp.useSpaStateActions)();
    const pageId = (0, $3O0Td.usePageId)();
    const startRef = (0, $eUqFw.useRef)({
        location: location,
        startTime: Date.now()
    });
    (0, $eUqFw.useMemo)(()=>{
        if (location !== startRef.current.location) startRef.current = {
            location: location,
            startTime: Date.now()
        };
    }, [
        location
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setAppStartWithAppId((0, $9c22638d2f17f9db$export$3a54edb6ba4daa82), startRef.current.startTime);
    }, [
        location,
        setAppStartWithAppId
    ]);
    return (0, $kIY50.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MAIN),
        analyticsSource: "atlassian-navigation",
        experienceId: pageId
    });
};

});
parcelRegister("kIY50", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav3", () => $21a9edbc09b4006b$export$23a7d978e17f1720);

var $6FP8W = parcelRequire("6FP8W");
const $21a9edbc09b4006b$export$23a7d978e17f1720 = ()=>!(0, $6FP8W.getWillShowNav4)();

});


parcelRegister("eDbLL", function(module, exports) {

$parcel$export(module.exports, "JiraAtlassianNavigationSkeleton", () => $dcd9958c5ab18a6d$export$38e532bc6b824200);

var $eUqFw = parcelRequire("eUqFw");

var $3g3mg = parcelRequire("3g3mg");

var $apShl = parcelRequire("apShl");

var $lStiz = parcelRequire("lStiz");
const $dcd9958c5ab18a6d$export$38e532bc6b824200 = ()=>{
    const theme = (0, $lStiz.useTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3g3mg.NavigationSkeleton), {
        theme: theme
    }));
};

});
parcelRegister("3g3mg", function(module, exports) {

$parcel$export(module.exports, "NavigationSkeleton", () => $eff777ab229b562f$export$ad5e8e6ace98cc2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");



var $iMTf6 = parcelRequire("iMTf6");
var $g668r = parcelRequire("g668r");

var $84HFD = parcelRequire("84HFD");

var $46eNd = parcelRequire("46eNd");

var $kAgsw = parcelRequire("kAgsw");

var $gHwzO = parcelRequire("gHwzO");

var $6gCu1 = parcelRequire("6gCu1");
function $eff777ab229b562f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $eff777ab229b562f$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $cbe92d4f348ad4dd$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $eff777ab229b562f$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $eff777ab229b562f$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $eff777ab229b562f$export$ad5e8e6ace98cc2 = ({ primaryItemsCount: primaryItemsCount = 4, secondaryItemsCount: secondaryItemsCount = 4, theme: theme = (0, $iMTf6.defaultTheme), showSiteName: showSiteName = false, shouldShowSearch: shouldShowSearch = true, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $g668r.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $eff777ab229b562f$var$containerStyles,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $eff777ab229b562f$var$leftStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $84HFD.IconButtonSkeleton), {
        marginLeft: 0,
        marginRight: 5,
        size: 26
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $kAgsw.ProductHomeSkeleton), {
        showSiteName: showSiteName
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $46eNd.PrimaryItemsContainerSkeleton), {
        count: primaryItemsCount
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $eff777ab229b562f$var$rightStyles
    }, shouldShowSearch && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6gCu1.SearchSkeleton), null), Array.from({
        length: secondaryItemsCount
    }, (_, index)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $84HFD.IconButtonSkeleton), {
            key: index,
            marginLeft: 0,
            marginRight: 4,
            size: 26
        })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gHwzO.ProfileSkeleton), null))));
};
var $eff777ab229b562f$export$2e2bcd8739ae039 = $eff777ab229b562f$export$ad5e8e6ace98cc2;

});
const $cbe92d4f348ad4dd$export$30fa7cc5f2690a43 = 56;
const $cbe92d4f348ad4dd$export$4033a111ca79977d = 1280;
const $cbe92d4f348ad4dd$export$24ec62cee78b7042 = 1130;
const $cbe92d4f348ad4dd$export$d8bde68ac946124f = '--ds--ans--fbc';
const $cbe92d4f348ad4dd$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $cbe92d4f348ad4dd$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $cbe92d4f348ad4dd$export$d81606c1fc5119bc = '--ds--ans--c';
const $cbe92d4f348ad4dd$export$65f656ad520ea71 = '--ds--ans--bc';

parcelRegister("84HFD", function(module, exports) {

$parcel$export(module.exports, "IconButtonSkeleton", () => $24ac6b86ea6f5c27$export$7a24471cb6f25433);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9JmWF = parcelRequire("9JmWF");
function $24ac6b86ea6f5c27$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $24ac6b86ea6f5c27$var$buttonHeight = "var(--ds-space-400, 32px)";
const $24ac6b86ea6f5c27$var$skeletonStyles = {
    name: "28gj0e",
    styles: "border-radius:var(--ds-border-radius-circle, 50%);opacity:0.15"
};
const $24ac6b86ea6f5c27$export$7a24471cb6f25433 = ({ className: className, marginLeft: marginLeft, marginRight: marginRight, size: size })=>{
    const theme = (0, $9JmWF.useTheme)();
    const dynamicStyles = {
        marginLeft: typeof marginLeft === 'number' ? marginLeft : "var(--ds-space-050, 4px)",
        marginRight: typeof marginRight === 'number' ? marginRight : 0,
        width: typeof size === 'number' ? size : $24ac6b86ea6f5c27$var$buttonHeight,
        height: typeof size === 'number' ? size : $24ac6b86ea6f5c27$var$buttonHeight,
        ...theme.mode.skeleton
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicStyles,
        css: $24ac6b86ea6f5c27$var$skeletonStyles
    });
};

});

parcelRegister("46eNd", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainerSkeleton", () => $7ae8a743368be220$export$fdfc48d2117b79a8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cX3lo = parcelRequire("cX3lo");
function $7ae8a743368be220$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7ae8a743368be220$var$primaryButtonSkeletonStyles = {
    name: "yn5kop",
    styles: "margin-inline-end:var(--ds-space-150, 12px);margin-inline-start:var(--ds-space-150, 12px)"
};
const $7ae8a743368be220$export$fdfc48d2117b79a8 = /*#__PURE__*/ (0, $eUqFw.memo)(({ count: count })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, Array.from({
        length: count
    }, (_, index)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $cX3lo.PrimaryButtonSkeleton), {
            key: index,
            css: $7ae8a743368be220$var$primaryButtonSkeletonStyles
        }))));

});
parcelRegister("cX3lo", function(module, exports) {

$parcel$export(module.exports, "PrimaryButtonSkeleton", () => $f9fcff453893d63e$export$4bc51fe36728414d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9JmWF = parcelRequire("9JmWF");
const $f9fcff453893d63e$var$paddingAll = 4;
const $f9fcff453893d63e$var$buttonHeight = 32;
const $f9fcff453893d63e$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    width: '68px',
    height: `${$f9fcff453893d63e$var$buttonHeight - $f9fcff453893d63e$var$paddingAll * 2.5}px`,
    borderRadius: "var(--ds-border-radius, 4px)",
    opacity: 0.15
});
const $f9fcff453893d63e$export$4bc51fe36728414d = (props)=>{
    const theme = (0, $9JmWF.useTheme)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $f9fcff453893d63e$var$skeletonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    });
};

});


parcelRegister("kAgsw", function(module, exports) {

$parcel$export(module.exports, "ProductHomeSkeleton", () => $6448d18649d80c24$export$3e79e535d76cce4b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $9JmWF = parcelRequire("9JmWF");

var $jvgG9 = parcelRequire("jvgG9");
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $6448d18649d80c24$var$VAR_SITE_TITLE_BG_COLOR_AFTER = '--site-title-bg-color-after';
const $6448d18649d80c24$var$productHomeButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:active': {
        backgroundColor: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus': {
        backgroundColor: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        boxShadow: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS})`,
        color: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: 0
    },
    '&:hover': {
        backgroundColor: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $6448d18649d80c24$var$productLogoStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: 120,
    maxWidth: 120,
    height: 24,
    maxHeight: 28,
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $6448d18649d80c24$var$productIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: 28,
    height: 28,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $6448d18649d80c24$var$siteTitleStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: "var(--ds-space-500, 40px)",
    alignItems: 'center',
    backgroundColor: 'transparent',
    marginInlineEnd: "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        width: '100%',
        height: 14,
        backgroundColor: `var(${$6448d18649d80c24$var$VAR_SITE_TITLE_BG_COLOR_AFTER})`,
        borderRadius: "var(--ds-border-radius, 4px)",
        content: '""'
    }
});
const $6448d18649d80c24$export$3e79e535d76cce4b = ({ showSiteName: showSiteName })=>{
    const theme = (0, $9JmWF.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const productHomeButtonDynamicStyles = (0, $jvgG9.stripEmptyProperties)({
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$6448d18649d80c24$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
    });
    const siteTitleDynamicStyles = {
        borderRight: theme.mode.productHome.borderRight,
        opacity: theme.mode.skeleton.opacity,
        [$6448d18649d80c24$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $6448d18649d80c24$var$productHomeButtonStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $6448d18649d80c24$var$productLogoStyles
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $6448d18649d80c24$var$productIconStyles
    })), showSiteName && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: siteTitleDynamicStyles,
        css: $6448d18649d80c24$var$siteTitleStyles
    }));
};

});

parcelRegister("gHwzO", function(module, exports) {

$parcel$export(module.exports, "ProfileSkeleton", () => $0a17d43c9a73388e$export$2bab43fd33adda3b);

var $eUqFw = parcelRequire("eUqFw");

var $84HFD = parcelRequire("84HFD");
const $0a17d43c9a73388e$export$2bab43fd33adda3b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84HFD.IconButtonSkeleton), {
        marginLeft: 6,
        marginRight: 6,
        size: 26
    });

});

parcelRegister("6gCu1", function(module, exports) {

$parcel$export(module.exports, "SearchSkeleton", () => $5cabc7fd981f681f$export$d8fbade3e5bbb8e0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $9JmWF = parcelRequire("9JmWF");

var $84HFD = parcelRequire("84HFD");
const $5cabc7fd981f681f$var$searchInputContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginRight: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: "var(--ds-space-250, 20px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$24ec62cee78b7042) - 1}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        display: 'none !important'
    }
});
const $5cabc7fd981f681f$var$searchInputSkeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    width: '220px',
    height: "var(--ds-space-400, 32px)",
    padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-500, 40px)"}`,
    borderRadius: "var(--ds-border-radius-200, 6px)",
    opacity: 0.15
});
const $5cabc7fd981f681f$var$searchIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$24ec62cee78b7042}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        display: 'none !important'
    }
});
const $5cabc7fd981f681f$export$d8fbade3e5bbb8e0 = ()=>{
    const theme = (0, $9JmWF.useTheme)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $5cabc7fd981f681f$var$searchInputContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $5cabc7fd981f681f$var$searchInputSkeletonStyles
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $84HFD.IconButtonSkeleton), {
        css: $5cabc7fd981f681f$var$searchIconStyles,
        marginRight: 5,
        size: 26
    }));
};

});


parcelRegister("lStiz", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $d56434d06e6d3c92$export$93d4e7f90805808f);

var $eUqFw = parcelRequire("eUqFw");

var $7slJv = parcelRequire("7slJv");

var $iX87Q = parcelRequire("iX87Q");
var $4q38b = parcelRequire("4q38b");

var $7fSR6 = parcelRequire("7fSR6");

var $3MEW8 = parcelRequire("3MEW8");

var $hS368 = parcelRequire("hS368");

var $3jHKg = parcelRequire("3jHKg");
const $d56434d06e6d3c92$var$caseInsensitiveEquals = (one, two)=>one.toLowerCase() === two.toLowerCase();
const $d56434d06e6d3c92$var$calculateBackground = (backgroundColor, isDarkMode)=>{
    // White is a proxy for 'default' when setting accent colours, we really want to default to 'elevation.surface'
    if ($d56434d06e6d3c92$var$caseInsensitiveEquals(backgroundColor, '#ffffff')) {
        // getTokenValue doesn't work in SSR thus hardcode, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
        const fallback = isDarkMode ? '#1d2125' : '#ffffff';
        // Can't be getToken() as AK Nav needs a hex string. It parses it to determine the correct text color
        return (0, $iX87Q.default)('elevation.surface', fallback);
    }
    return isDarkMode ? (0, $3jHKg.capLightness)(backgroundColor, 35) : backgroundColor;
};
const $d56434d06e6d3c92$var$useIsDarkThemeResolver = ()=>{
    // The best source of theme info. But doesn't work in SSR, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
    const { colorMode: colorMode } = (0, $4q38b.default)();
    // This works in SSR, but we need the browser to resolve 'auto', so we are wrong in SSR if 'auto' resolves to 'dark'
    const { theme: preference } = (0, $3MEW8.useThemePreference)();
    return false ? preference === 'dark' : colorMode === 'dark';
};
const $d56434d06e6d3c92$export$93d4e7f90805808f = ()=>{
    const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $7fSR6.useTheme)();
    const isDarkMode = $d56434d06e6d3c92$var$useIsDarkThemeResolver();
    const bg = (0, $eUqFw.useMemo)(()=>$d56434d06e6d3c92$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $hS368.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return (0, $7slJv.generateTheme)({
        name: 'jira',
        backgroundColor: bg,
        highlightColor: highlightColor
    });
};

});
parcelRegister("3MEW8", function(module, exports) {

$parcel$export(module.exports, "themePreferenceResource", () => $aa9979c4bb771fd9$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $aa9979c4bb771fd9$export$3416635c8aeb5bab);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");


var $YWIXh = parcelRequire("YWIXh");

const $aa9979c4bb771fd9$var$getDataLoader = ()=>(parcelRequire("6OpTH"));
const $aa9979c4bb771fd9$export$e5a423d1eb1cf1d0 = (0, $lB25E.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: $aa9979c4bb771fd9$var$getDataLoader,
    maxAge: 300000
});
const $aa9979c4bb771fd9$export$3416635c8aeb5bab = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $lB25E.useResource)($aa9979c4bb771fd9$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $eUqFw.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $6f1b3f4a1b1409cf$export$89c5cf64ad15c3ea),
            actionSubject: (0, $6f1b3f4a1b1409cf$export$9e2cc65718a61846)
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $eUqFw.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $YWIXh.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};

});
const $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $6f1b3f4a1b1409cf$export$9e2cc65718a61846 = 'themePreference';
const $6f1b3f4a1b1409cf$export$89c5cf64ad15c3ea = 'changed';

parcelRegister("YWIXh", function(module, exports) {

$parcel$export(module.exports, "setThemePreference", () => $31ba3788a5049b63$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $31ba3788a5049b63$export$2f7a12048d96237);

var $eM3G3 = parcelRequire("eM3G3");

var $guiFP = parcelRequire("guiFP");

var $cm5m0 = parcelRequire("cm5m0");

const $31ba3788a5049b63$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $cm5m0.userPreferenceAPI).set((0, $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27), theme);
    promise.catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $31ba3788a5049b63$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $cm5m0.userPreferenceAPI).get((0, $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27));
    promise.catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (theme && !(0, $eM3G3.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $guiFP.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return theme && (0, $eM3G3.ThemeOptions).includes(theme) ? theme : undefined;
};

});
parcelRegister("eM3G3", function(module, exports) {

$parcel$export(module.exports, "ThemeOptions", () => $65da877bf2b17a02$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $65da877bf2b17a02$export$2faeed762aac6741);
const $65da877bf2b17a02$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $65da877bf2b17a02$export$2faeed762aac6741 = 'light';

});

parcelRegister("cm5m0", function(module, exports) {

$parcel$export(module.exports, "userPreferenceAPI", () => $65cd88220f00e257$export$4f7929ca6b50a436);


var $lRmyA = parcelRequire("lRmyA");
const $65cd88220f00e257$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
const $65cd88220f00e257$var$get = async (key)=>{
    try {
        const result = await (0, $lRmyA.performGetRequest)($65cd88220f00e257$var$url(key));
        return result?.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef)) return null;
        throw error;
    }
};
const $65cd88220f00e257$var$set = (key, value)=>(0, $lRmyA.performPutRequest)($65cd88220f00e257$var$url(key), {
        body: JSON.stringify({
            value: value
        })
    });
const $65cd88220f00e257$var$remove = (key)=>(0, $lRmyA.performDeleteRequest)($65cd88220f00e257$var$url(key));
const $65cd88220f00e257$export$4f7929ca6b50a436 = {
    get: $65cd88220f00e257$var$get,
    set: $65cd88220f00e257$var$set,
    remove: $65cd88220f00e257$var$remove
};

});


parcelRegister("6OpTH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8mnLk")
]).then(()=>parcelRequire('foRwS'));

});


parcelRegister("hS368", function(module, exports) {

$parcel$export(module.exports, "addThemeColor", () => $d4990bb3ca3a777b$export$7b20d133831b2b0f);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
const $d4990bb3ca3a777b$var$getMetaNode = (name)=>document.querySelector(`meta[name="${name}"]`);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $d4990bb3ca3a777b$var$getHead = ()=>document.head || document.querySelector('head');
const $d4990bb3ca3a777b$export$7b20d133831b2b0f = (content)=>{
    if (!content || typeof document === 'undefined' || false) return;
    const existingMeta = $d4990bb3ca3a777b$var$getMetaNode('theme-color');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = content;
    if (existingMeta) existingMeta.replaceWith?.(meta);
    else {
        const head = $d4990bb3ca3a777b$var$getHead();
        if (head) head.appendChild?.(meta);
    }
};

});

parcelRegister("3jHKg", function(module, exports) {

$parcel$export(module.exports, "capLightness", () => $a436962de231d459$export$8b5544bab97b10dd);
const $a436962de231d459$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $a436962de231d459$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $a436962de231d459$var$rgbFromHex = (input)=>{
    const fullHex = $a436962de231d459$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $a436962de231d459$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $a436962de231d459$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $a436962de231d459$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $a436962de231d459$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $a436962de231d459$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $a436962de231d459$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $a436962de231d459$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $a436962de231d459$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $a436962de231d459$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $a436962de231d459$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $a436962de231d459$var$rgbToLch = (rgb)=>$a436962de231d459$var$labToLch($a436962de231d459$var$xyzToLab($a436962de231d459$var$rgbToXyz(rgb)));
const $a436962de231d459$var$lchToRgb = (lch)=>$a436962de231d459$var$xyzToRgb($a436962de231d459$var$labToXyz($a436962de231d459$var$lchToLab(lch)));
const $a436962de231d459$export$8b5544bab97b10dd = (color, capPercent)=>{
    const rgb = $a436962de231d459$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $a436962de231d459$var$rgbToLch(rgb);
    if (lch.l > capPercent) lch.l = $a436962de231d459$var$clamp(capPercent, 0, 100);
    return $a436962de231d459$var$rgbToHex($a436962de231d459$var$lchToRgb(lch));
};

});



parcelRegister("aYtGv", function(module, exports) {

$parcel$export(module.exports, "PAGE_LAYOUT_OFFSET_TOP", () => $479507d87baa6502$export$d60454526e2281af);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout

var $ho1Ek = parcelRequire("ho1Ek");
const $479507d87baa6502$export$d60454526e2281af = `(${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)} + ${(0, $ho1Ek.BANNER_HEIGHT)})`;

});

parcelRegister("eQbJ4", function(module, exports) {

$parcel$export(module.exports, "useIsFullscreen", () => $1ce3a272474e08c0$export$d397eccea5f37b0a);

var $eUqFw = parcelRequire("eUqFw");
const $1ce3a272474e08c0$var$fullscreenClassnameExists = (target)=>target?.classList.contains('fullscreen') ?? false;
const $1ce3a272474e08c0$export$d397eccea5f37b0a = (target)=>{
    const [isFullscreen, setIsFullscreen] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        const handleFullscreen = ()=>{
            setIsFullscreen($1ce3a272474e08c0$var$fullscreenClassnameExists(target));
        };
        const mutationObserver = new MutationObserver(handleFullscreen);
        if (target) mutationObserver.observe(target, {
            attributes: true
        });
        return ()=>mutationObserver.disconnect();
    }, [
        target
    ]);
    return {
        isFullscreen: isFullscreen
    };
};

});

parcelRegister("6VKSg", function(module, exports) {

$parcel$export(module.exports, "useTopNavState", () => $f37199ef443364d1$export$bccbd45ab793bd09);

var $WBLbN = parcelRequire("WBLbN");

var $53ucm = parcelRequire("53ucm");
const $f37199ef443364d1$var$useTopNav = (0, $WBLbN.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>({
            ...state.topNavigation,
            shouldRender: !state.isChromeless
        })
});
const $f37199ef443364d1$export$bccbd45ab793bd09 = ()=>{
    const [state] = $f37199ef443364d1$var$useTopNav();
    return state;
};

});

parcelRegister("7xu2f", function(module, exports) {

$parcel$export(module.exports, "AsyncAtlassianNavigation", () => $050373c2603582df$export$932edb7b1b20d079);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $gC7XG = parcelRequire("gC7XG");

var $cernH = parcelRequire("cernH");

var $eDbLL = parcelRequire("eDbLL");

var $hknOo = parcelRequire("hknOo");

var $1FAd1 = parcelRequire("1FAd1");


var $8R80x = parcelRequire("8R80x");

var $10fdS = parcelRequire("10fdS");

var $2B87Z = parcelRequire("2B87Z");
const $050373c2603582df$export$932edb7b1b20d079 = ()=>{
    const isUsingEntryPoint = Boolean((0, $10fdS.useCurrentRoute)().entryPoint?.());
    const topNavEntryPointReference = (0, $1FAd1.usePageLayoutEntryPoint)((0, $d619e185f38e9ae8$export$bec6dca2e63de4ae));
    (0, $eUqFw.useState)(()=>{
        if (!false && isUsingEntryPoint) /* @ts-expect-error - TS2339 - We're using JSResourceReference from @atlassian/react-async. */ (0, $gC7XG.topNavigationEntryPoint).root.onComplete(()=>{
            (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $hknOo.JS_EVAL_START))) {
                (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                break;
            }
        });
        return undefined;
    });
    return isUsingEntryPoint ? // There is already a Placeholder in parent
    // remove this one when EntryPointPlaceholder merges with Placeholder
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholder), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDbLL.JiraAtlassianNavigationSkeleton), null),
        /* @ts-expect-error - TS2322 - We're using JSResourceReference from @atlassian/react-async. */ entryPoint: (0, $gC7XG.topNavigationEntryPoint)
    }, topNavEntryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
        entryPointReference: topNavEntryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cernH.LazyAtlassianNavigation), null);
};

});
parcelRegister("gC7XG", function(module, exports) {

$parcel$export(module.exports, "topNavigationEntryPoint", () => $cb57489a3376471c$export$f780be9e138f456f);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $cb57489a3376471c$export$f780be9e138f456f = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("72E3S")), {
        moduleId: "1f1265b4"
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps
        })
});

});
parcelRegister("72E3S", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h49zL")
]).then(()=>parcelRequire('krHYB'));

});


parcelRegister("cernH", function(module, exports) {

$parcel$export(module.exports, "LazyAtlassianNavigation", () => $d0ff8bb7dfb6147e$export$4caed23aa0274abb);

var $6VZoe = parcelRequire("6VZoe");

var $hknOo = parcelRequire("hknOo");

var $2B87Z = parcelRequire("2B87Z");

const $d0ff8bb7dfb6147e$export$4caed23aa0274abb = (0, $6VZoe.lazyForPaint)(()=>{
    const bundleReady = (parcelRequire("cQOow"));
    if (!false) bundleReady.then(()=>{
        (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $hknOo.JS_EVAL_START))) {
            (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/index.tsx"
});

});
parcelRegister("cQOow", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("BfK1C")
]).then(()=>parcelRequire('6OKpM'));

});




parcelRegister("fpQ73", function(module, exports) {

$parcel$export(module.exports, "FullHeight", () => $634ce2a022efa5f0$export$33e617ec5e4e4f76);

var $eUqFw = parcelRequire("eUqFw");
const $634ce2a022efa5f0$var$styleFullHeight = {
    height: '100vh'
};
const $634ce2a022efa5f0$export$33e617ec5e4e4f76 = ({ children: children })=>// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: $634ce2a022efa5f0$var$styleFullHeight
    }, children);

});

parcelRegister("1cu0z", function(module, exports) {

$parcel$export(module.exports, "ThemeSetter", () => $d6a0f9f1b975c5d3$export$ce1303eaa27a0d3a);

var $eUqFw = parcelRequire("eUqFw");

var $hPGUE = parcelRequire("hPGUE");
var $4q38b = parcelRequire("4q38b");

var $gpo0r = parcelRequire("gpo0r");

var $3FyZ4 = parcelRequire("3FyZ4");

var $3MEW8 = parcelRequire("3MEW8");

var $lB25E = parcelRequire("lB25E");
const $d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');

const $d6a0f9f1b975c5d3$var$GlobalThemeSetter = ()=>{
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)((0, $3MEW8.themePreferenceResource));
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const [isThemeStylesInHead, setIsThemeStylesInHead] = (0, $eUqFw.useState)(false);
    const setThemeWithToken = (0, $eUqFw.useCallback)(async (theme)=>{
        if (theme !== colorMode) {
            const { loadThemeTokens: loadThemeTokens } = await (parcelRequire("f8DlR"));
            loadThemeTokens(theme);
        }
    }, [
        colorMode
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (loading || error || !data) return undefined;
        // Combine the themes 'dark', 'light' and 'auto' after @atlaskit/tokens@1.0.0
        // https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/27634
        if (data?.theme === 'auto') {
            setThemeWithToken($d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light');
            const handler = (e)=>{
                setThemeWithToken(e.matches ? 'dark' : 'light');
            };
            $d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery?.addEventListener('change', handler);
            return ()=>{
                $d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery?.removeEventListener('change', handler);
            };
        }
        if (data?.theme === 'dark' || data?.theme === 'light') setThemeWithToken(data?.theme);
        if (!data?.theme) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement.removeAttribute('data-theme');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement.removeAttribute('data-color-mode');
        }
        return undefined;
    }, [
        data,
        loading,
        error,
        setThemeWithToken
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (loading || error || !data) return;
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            if (data?.theme) client.setUIViewedAttributes({
                theme: data.theme
            });
            else client.removeUIViewedAttribute('theme');
        });
    }, [
        data,
        loading,
        error
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            client.setUIViewedAttributes({
                OStheme: $d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light'
            });
        });
    }, []);
    // @atlaskit/tokens expects the theme styles to be in the <head /> but they're
    // initally rendered in the "jira-ssr" container in the <body /> and then moved to the
    // <head />. The following prevents the styles from being re-rendered in the <body />.
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.head.querySelector('style[data-theme]')) setIsThemeStylesInHead(true);
    }, []);
    if (!data?.theme || !data?.attrs || !data?.styles) return null;
    const ssrAutoScript = (0, $hPGUE.default)(data.theme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !isThemeStylesInHead ? data.styles.map((theme)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
            key: theme.id,
            ...theme.attrs,
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: theme.css
            }
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: data.styles.map((theme)=>`document.head.appendChild(document.body.querySelector('style[data-theme="${theme.id}"]'));`).join('\n')
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: Object.entries(data.attrs).map(([key, val])=>{
                if (key === 'data-color-mode' && ssrAutoScript) return '';
                return `document.documentElement.setAttribute("${key}", "${val}");`;
            }).join('\n')
        }
    }), ssrAutoScript ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrAutoScript
        }
    }) : null);
};
const $d6a0f9f1b975c5d3$export$ce1303eaa27a0d3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6a0f9f1b975c5d3$var$GlobalThemeSetter, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gpo0r.ThemeSetter), null));

});
parcelRegister("hPGUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef76e53ed4c3c344$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $kyri3 = parcelRequire("kyri3");

var $2Mf9s = parcelRequire("2Mf9s");
/**
 * Provides a script that, when executed before paint, sets the `data-color-mode` attribute based on the current system theme,
 * to enable SSR support for automatic theme switching, avoid a flash of un-themed content on first paint.
 *
 * @param {string} colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 *
 * @returns {string} A string to be added to the innerHTML of a script tag in the document head
 */ const $ef76e53ed4c3c344$var$getSSRAutoScript = (colorMode, // TODO: This should be marked as required once safe to roll out.
contrastMode)=>{
    if (colorMode !== 'auto' && contrastMode !== 'auto') return undefined;
    const setColorMode = colorMode === 'auto' ? `\n  try {
    const darkModeMql = window.matchMedia('${0, $2Mf9s.darkModeMediaQuery}');
    const colorMode = darkModeMql.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('${0, $kyri3.COLOR_MODE_ATTRIBUTE}', colorMode);
  } catch (e) {}` : '';
    const setContrastMode = contrastMode === 'auto' && (0, $XHGTv.fg)('platform_increased-contrast-themes') ? `\n  try {
    const contrastModeMql = window.matchMedia('${0, $2Mf9s.moreContrastMediaQuery}');
    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';
    document.documentElement.setAttribute('${0, $kyri3.CONTRAST_MODE_ATTRIBUTE}', contrastMode);
  } catch (e) {}` : '';
    return `(() => {${setColorMode}${setContrastMode}})()`;
};
var $ef76e53ed4c3c344$export$2e2bcd8739ae039 = $ef76e53ed4c3c344$var$getSSRAutoScript;

});

parcelRegister("gpo0r", function(module, exports) {

$parcel$export(module.exports, "ThemeSetter", () => $76ce003e44f43d6d$export$ce1303eaa27a0d3a);

var $eUqFw = parcelRequire("eUqFw");

var $3K2Fs = parcelRequire("3K2Fs");

var $4EvIi = parcelRequire("4EvIi");

var $4e72F = parcelRequire("4e72F");

var $bcnRH = parcelRequire("bcnRH");

var $exb0h = parcelRequire("exb0h");

var $6FP8W = parcelRequire("6FP8W");

var $10fdS = parcelRequire("10fdS");
const $76ce003e44f43d6d$export$ce1303eaa27a0d3a = ()=>{
    const projectTheme = (0, $4EvIi.useProjectTheme)();
    const overviewTheme = (0, $3K2Fs.useOverviewTheme)();
    const route = (0, $10fdS.useCurrentRoute)();
    const entityTheme = (0, $eUqFw.useMemo)(()=>{
        let result = projectTheme ?? overviewTheme;
        if (result != null) {
            const isFormSubmitView = route.name === (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT) || route.name === (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED);
            // the form submit view doesn't use the project theme colors
            // since it is accessed externally to the project
            if (isFormSubmitView) result = {
                ...result,
                themeSetting: null
            };
        }
        return result;
    }, [
        projectTheme,
        overviewTheme,
        route.name
    ]);
    if ((0, $6FP8W.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcnRH.ThemeContainer), {
        isGlobal: true,
        entityTheme: entityTheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4e72F.ThemeTokensSetter), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, entityTheme != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcnRH.ThemeContainerOld), {
        isGlobal: true,
        ...entityTheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4e72F.ThemeTokensSetter), null));
};

});
parcelRegister("3K2Fs", function(module, exports) {

$parcel$export(module.exports, "useOverviewTheme", () => $88bfa969a9a43feb$export$a55763fd17eab357);

var $kar7l = parcelRequire("kar7l");

var $fzymf = parcelRequire("fzymf");
const $88bfa969a9a43feb$export$a55763fd17eab357 = ()=>{
    const { data: data } = (0, $fzymf.useOverview)();
    if (data != null) return {
        themeSetting: {
            type: 'color',
            value: data.theme ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name
        },
        entityId: `overview/${data.id}`
    };
    return null;
};

});
parcelRegister("kar7l", function(module, exports) {

$parcel$export(module.exports, "STAR_ICON_COLOR", () => $15099970f99feec5$export$9e0962e0cb41695d);
$parcel$export(module.exports, "Variables", () => $15099970f99feec5$export$8bb9d79ea938efc9);
$parcel$export(module.exports, "Tokens", () => $15099970f99feec5$export$8e1e81ac145e31be);
$parcel$export(module.exports, "BASE_THEME", () => $15099970f99feec5$export$8a6e9b3370a0f87a);
$parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", () => $15099970f99feec5$export$f286efa6bd1e8f9d);
$parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", () => $15099970f99feec5$export$97cb21c6432e07e8);
$parcel$export(module.exports, "GRADIENT_THEME", () => $15099970f99feec5$export$b124f62a6aab972);
$parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", () => $15099970f99feec5$export$9441e0d8f766c59a);
$parcel$export(module.exports, "NO_BACKGROUND_CONFIG", () => $15099970f99feec5$export$4c351ec1dc290344);
$parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", () => $15099970f99feec5$export$34373eced7ee212e);
$parcel$export(module.exports, "BACKGROUND_COLOR_CONFIGS", () => $15099970f99feec5$export$5ddfadab7b1e12c1);
$parcel$export(module.exports, "SOLID_COLOR_BACKGROUND_CONFIGS", () => $15099970f99feec5$export$349e5dbeac874253);
$parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", () => $15099970f99feec5$export$242b2d2213fedf27);
$parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", () => $15099970f99feec5$export$fe05a238062e2c3d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", () => $15099970f99feec5$export$cab9d853866386f2);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $15099970f99feec5$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", () => $15099970f99feec5$export$8e357501548afe78);
$parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", () => $15099970f99feec5$export$baaf8255c30ea280);
$parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", () => $15099970f99feec5$export$d9035bc768f8226d);
$parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", () => $15099970f99feec5$export$4810531e30462f89);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $15099970f99feec5$export$1c0b806722927549);
$parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT", () => $15099970f99feec5$export$2af5673c2fa63c55);
$parcel$export(module.exports, "NAV4_BUSINESS_NAV_HEIGHT", () => $15099970f99feec5$export$5771162cdeebfb85);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_HEIGHT", () => $15099970f99feec5$export$a1626d6d785092a2);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $15099970f99feec5$export$410e3d6221a052e);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", () => $15099970f99feec5$export$77cdace62a821419);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", () => $15099970f99feec5$export$3efe68325dd9dc02);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout

var $ho1Ek = parcelRequire("ho1Ek");


var $aYtGv = parcelRequire("aYtGv");
const $15099970f99feec5$export$b8b9d90f9e5bd72b = 'jiraBusinessThemeConstants';
const $15099970f99feec5$export$9e0962e0cb41695d = '#FFAB00';
const $15099970f99feec5$export$8bb9d79ea938efc9 = {
    BACKDROP_FILTER: '--jwm-backdrop-filter',
    COLOR_BACKGROUND_BRAND_BOLD: '--jwm-color-background-brand-bold',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--jwm-color-background-brand-bold-hovered',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--jwm-color-background-brand-bold-pressed',
    COLOR_BACKGROUND_DISABLED: '--jwm-color-background-disabled',
    COLOR_BACKGROUND_INPUT: '--jwm-background-input',
    COLOR_BACKGROUND_NEUTRAL: '--jwm-background-neutral',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: '--jwm-background-neutral-hovered',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: '--jwm-background-neutral-pressed',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--jwm-background-neutral-subtle-hovered',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--jwm-background-neutral-subtle-pressed',
    COLOR_BACKGROUND_SELECTED: '--jwm-background-selected',
    COLOR_BORDER: '--jwm-color-border',
    COLOR_BORDER_INPUT: '--jwm-color-border-input',
    COLOR_BORDER_INVERSE: '--jwm-color-border-inverse',
    COLOR_BORDER_SELECTED: '--jwm-color-border-selected',
    COLOR_ELEVATION_SURFACE: '--jwm-color-elevation-surface',
    COLOR_ICON_DANGER: '--jwm-color-icon-danger',
    COLOR_ICON_INFORMATION: '--jwm-color-icon-information',
    COLOR_ICON_SUCCESS: '--jwm-color-icon-success',
    COLOR_ICON_WARNING: '--jwm-color-icon-warning',
    COLOR_LINK: '--jwm-color-link',
    COLOR_LINK_PRESSED: '--jwm-color-link-pressed',
    COLOR_SKELETON: '--jwm-skeleton',
    COLOR_TEXT: '--jwm-color-text',
    COLOR_TEXT_DISABLED: '--jwm-color-text-disabled',
    COLOR_TEXT_INVERSE: '--jwm-color-text-inverse',
    COLOR_TEXT_SELECTED: '--jwm-color-text-selected',
    COLOR_TEXT_SUBTLE: '--jwm-color-text-subtle',
    COLOR_TEXT_SUBTLEST: '--jwm-color-text-subtlest',
    CONTENT_HEIGHT: '--jwm-content-height',
    CONTENT_WIDTH: '--jwm-content-width',
    ELEVATION_SURFACE: '--jwm-elevation-surface',
    ELEVATION_SURFACE_CONTRAST: '--jwm-elevation-surface-contrast',
    ELEVATION_SURFACE_CONTRAST_BOLDER: '--jwm-elevation-surface-contrast-bolder',
    WRAPPER_BACKGROUND: '--jwm-wrapper-background',
    WRAPPER_BORDER_RADIUS: '--jwm-wrapper-border-radius',
    WRAPPER_HEIGHT: '--jwm-wrapper-height',
    WRAPPER_PADDING: '--jwm-wrapper-padding',
    WRAPPER_WIDTH: '--jwm-wrapper-width'
};
const $15099970f99feec5$export$8e1e81ac145e31be = {
    BACKDROP_FILTER: 'var(--jwm-backdrop-filter)',
    COLOR_BACKGROUND_BRAND_BOLD: 'var(--jwm-color-background-brand-bold)',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--jwm-color-background-brand-bold-hovered)',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--jwm-color-background-brand-bold-pressed)',
    COLOR_BACKGROUND_DISABLED: 'var(--jwm-color-background-disabled)',
    COLOR_BACKGROUND_INPUT: 'var(--jwm-background-input)',
    COLOR_BACKGROUND_NEUTRAL: 'var(--jwm-background-neutral)',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--jwm-background-neutral-hovered)',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--jwm-background-neutral-pressed)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--jwm-background-neutral-subtle-hovered)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--jwm-background-neutral-subtle-pressed)',
    COLOR_BACKGROUND_SELECTED: 'var(--jwm-background-selected)',
    COLOR_BORDER: 'var(--jwm-color-border)',
    COLOR_BORDER_INPUT: 'var(--jwm-color-border-input)',
    COLOR_BORDER_INVERSE: 'var(--jwm-color-border-inverse)',
    COLOR_BORDER_SELECTED: 'var(--jwm-color-border-selected)',
    COLOR_ELEVATION_SURFACE: 'var(--jwm-color-elevation-surface)',
    COLOR_ICON_DANGER: 'var(--jwm-color-icon-danger)',
    COLOR_ICON_INFORMATION: 'var(--jwm-color-icon-information)',
    COLOR_ICON_SUCCESS: 'var(--jwm-color-icon-success)',
    COLOR_ICON_WARNING: 'var(--jwm-color-icon-warning)',
    COLOR_LINK: 'var(--jwm-color-link)',
    COLOR_LINK_PRESSED: 'var(--jwm-color-link-pressed)',
    COLOR_SKELETON: 'var(--jwm-skeleton)',
    COLOR_TEXT: 'var(--jwm-color-text)',
    COLOR_TEXT_DISABLED: 'var(--jwm-color-text-disabled)',
    COLOR_TEXT_INVERSE: 'var(--jwm-color-text-inverse)',
    COLOR_TEXT_SELECTED: 'var(--jwm-color-text-selected)',
    COLOR_TEXT_SUBTLE: 'var(--jwm-color-text-subtle)',
    COLOR_TEXT_SUBTLEST: 'var(--jwm-color-text-subtlest)',
    CONTENT_HEIGHT: 'var(--jwm-content-height)',
    CONTENT_WIDTH: 'var(--jwm-content-width)',
    ELEVATION_SURFACE: 'var(--jwm-elevation-surface)',
    ELEVATION_SURFACE_CONTRAST: 'var(--jwm-elevation-surface-contrast)',
    ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--jwm-elevation-surface-contrast-bolder)',
    WRAPPER_BACKGROUND: 'var(--jwm-wrapper-background)',
    WRAPPER_BORDER_RADIUS: 'var(--jwm-wrapper-border-radius)',
    WRAPPER_HEIGHT: 'var(--jwm-wrapper-height)',
    WRAPPER_PADDING: 'var(--jwm-wrapper-padding)',
    WRAPPER_WIDTH: 'var(--jwm-wrapper-width)'
};
const $15099970f99feec5$export$8a6e9b3370a0f87a = {
    'color.background.brand.bold': "var(--ds-background-brand-bold, #09326C)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0C66E4)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
    'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
    'color.background.input': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    'color.background.neutral': `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$exports).N30A})`,
    'color.background.neutral.hovered': `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$exports).N40A})`,
    'color.background.neutral.pressed': `var(--ds-background-neutral-pressed, ${(0, $73a5c9d720aa66e1$exports).N50A})`,
    'color.background.neutral.subtle.hovered': `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$exports).N40A})`,
    'color.background.neutral.subtle.pressed': `var(--ds-background-neutral-subtle-pressed, ${(0, $73a5c9d720aa66e1$exports).N50A})`,
    'color.background.selected': `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$exports).B400})`,
    'color.elevation.surface': `var(--ds-surface, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    'color.border': `var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N40A})`,
    'color.border.input': "var(--ds-border-input, #091E4224)",
    'color.border.inverse': `var(--ds-border-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    'color.border.selected': `var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$exports).B400})`,
    'color.icon.danger': `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R200})`,
    'color.icon.information': `var(--ds-icon-information, ${(0, $73a5c9d720aa66e1$exports).B200})`,
    'color.icon.success': `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G200})`,
    'color.icon.warning': `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
    'color.link': "var(--ds-link, #0c66e4)",
    'color.link.pressed': "var(--ds-link-pressed, #0055cc)",
    'color.skeleton': `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$exports).N20A})`,
    'color.text': `var(--ds-text, ${(0, $73a5c9d720aa66e1$exports).N800})`,
    'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
    'color.text.inverse': `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    'color.text.selected': `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$exports).B400})`,
    'color.text.subtle': `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
    'color.text.subtlest': "var(--ds-text-subtlest, #626f86)",
    'elevation.surface.contrast': 'transparent',
    'elevation.surface.contrast.bolder': 'transparent'
};
const $15099970f99feec5$export$f286efa6bd1e8f9d = {
    'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
    'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
    'color.background.input': 'rgba(255, 255, 255, 0.8)',
    'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.text.selected': `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`
};
const $15099970f99feec5$export$97cb21c6432e07e8 = {
    'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
    'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
    'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
    'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
    'color.background.input': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
    'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
    'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
    'color.background.selected': 'rgba(255, 255, 255, 0.6)',
    'color.elevation.surface': '#172b4d',
    'color.border': 'rgba(255, 255, 255, 0.14)',
    'color.border.input': 'rgba(255, 255, 255, 0.3)',
    'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
    'color.border.selected': (0, $73a5c9d720aa66e1$exports).N0,
    'color.icon.danger': (0, $73a5c9d720aa66e1$exports).N0,
    'color.icon.information': (0, $73a5c9d720aa66e1$exports).N0,
    'color.icon.success': (0, $73a5c9d720aa66e1$exports).N0,
    'color.icon.warning': (0, $73a5c9d720aa66e1$exports).N0,
    'color.skeleton': 'rgba(255,255,255,0.08)',
    'color.text': (0, $73a5c9d720aa66e1$exports).N0,
    'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
    'color.text.inverse': '#172B4D',
    // Neutral 1000
    'color.text.selected': '#172B4D',
    // Neutral 1000
    'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
    'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
};
const $15099970f99feec5$export$b124f62a6aab972 = {
    'color.link': '#CCE0FF',
    // Blue 200
    'color.link.pressed': '#E9F2FF' // Blue 100
};
const $15099970f99feec5$export$9441e0d8f766c59a = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.text.selected': `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
            'elevation.surface.contrast.bolder': `var(--ds-surface, ${(0, $73a5c9d720aa66e1$exports).N0})`
        },
        dark: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #8C9BAB)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #9FADBC)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
            'color.background.input': 'rgba(34, 39, 43, 0.8)',
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
            'color.elevation.surface': '#172b4d',
            'color.border': 'rgba(255, 255, 255, 0.14)',
            'color.border.input': 'rgba(255, 255, 255, 0.3)',
            'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
            'color.icon.danger': (0, $73a5c9d720aa66e1$exports).N0,
            'color.icon.information': (0, $73a5c9d720aa66e1$exports).N0,
            'color.icon.success': (0, $73a5c9d720aa66e1$exports).N0,
            'color.icon.warning': (0, $73a5c9d720aa66e1$exports).N0,
            'color.link': "var(--ds-text-accent-blue-bolder, #CCE0FF)",
            'color.link.pressed': "var(--ds-text-accent-blue, #85B8FF)",
            'color.skeleton': 'rgba(255,255,255,0.8)',
            'color.text': (0, $73a5c9d720aa66e1$exports).N0,
            'color.text.selected': "var(--ds-text-inverse, #1D2125)",
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #1D2125)"
        }
    }
};
// Old Colors
const $15099970f99feec5$var$WHITE_BACKGROUND_CONFIG = {
    name: 'white'
};
const $15099970f99feec5$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
    name: 'light-purple'
};
const $15099970f99feec5$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
    name: 'light-blue'
};
const $15099970f99feec5$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
    name: 'light-teal'
};
const $15099970f99feec5$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
    name: 'light-green'
};
const $15099970f99feec5$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
    name: 'light-yellow'
};
const $15099970f99feec5$var$LIGHT_RED_BACKGROUND_CONFIG = {
    name: 'light-red'
};
const $15099970f99feec5$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
    name: 'light-magenta'
};
const $15099970f99feec5$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
    name: 'light-orange'
};
const $15099970f99feec5$var$DARK_BACKGROUND_CONFIG = {
    name: 'dark'
};
const $15099970f99feec5$var$PURPLE_BACKGROUND_CONFIG = {
    name: 'purple'
};
const $15099970f99feec5$var$BLUE_BACKGROUND_CONFIG = {
    name: 'blue'
};
const $15099970f99feec5$var$TEAL_BACKGROUND_CONFIG = {
    name: 'teal'
};
const $15099970f99feec5$var$GREEN_BACKGROUND_CONFIG = {
    name: 'green'
};
const $15099970f99feec5$var$YELLOW_BACKGROUND_CONFIG = {
    name: 'yellow'
};
const $15099970f99feec5$var$RED_BACKGROUND_CONFIG = {
    name: 'red'
};
const $15099970f99feec5$var$MAGENTA_BACKGROUND_CONFIG = {
    name: 'magenta'
};
const $15099970f99feec5$var$ORANGE_BACKGROUND_CONFIG = {
    name: 'orange'
};
// New Colors
const $15099970f99feec5$var$DARKER_GRAY_BACKGROUND_CONFIG = {
    name: 'darker-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
    name: 'darker-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG = {
    name: 'darker-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG = {
    name: 'darker-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG = {
    name: 'darker-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$DARKER_LIME_BACKGROUND_CONFIG = {
    name: 'darker-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
    name: 'darker-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
    name: 'darker-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG = {
    name: 'darker-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darker-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
    name: 'darkest-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'darkest-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
    name: 'darkest-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
    name: 'darkest-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
    name: 'darkest-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_LIME_BACKGROUND_CONFIG = {
    name: 'darkest-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'darkest-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'darkest-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_RED_BACKGROUND_CONFIG = {
    name: 'darkest-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darkest-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
    name: 'lightest-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F1F2F4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'lightest-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F3F0FF',
            // Purple 100
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
    name: 'lightest-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E9F2FF',
            // Blue 100
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
    name: 'lightest-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E7F9FF',
            // Teal 100
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
    name: 'lightest-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCFFF1',
            // Green 100
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
    name: 'lightest-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#EFFFD6',
            // Lime 100
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'lightest-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF7D6',
            // Yellow 100
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'lightest-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF3EB',
            // Orange 100
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
    name: 'lightest-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECEB',
            // Red 100
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lightest-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECF8',
            // Magenta 100
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
    name: 'lighter-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCDFE4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
    name: 'lighter-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DFD8FD',
            // Purple 200
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
    name: 'lighter-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#CCE0FF',
            // Blue 200
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
    name: 'lighter-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#C6EDFB',
            // Teal 200
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
    name: 'lighter-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#BAF3DB',
            // Green 200
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
    name: 'lighter-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#D3F1A7',
            // Lime 200
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
    name: 'lighter-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F8E6A0',
            // Yellow 200
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
    name: 'lighter-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FEDEC8',
            // Orange 200
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_RED_BACKGROUND_CONFIG = {
    name: 'lighter-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFD5D2',
            // Red 200
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lighter-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FDD0EC',
            // Magenta 200
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$export$4c351ec1dc290344 = {
    name: 'no-background',
    brightness: 'high',
    theme: {
        light: $15099970f99feec5$export$8a6e9b3370a0f87a,
        dark: $15099970f99feec5$export$8a6e9b3370a0f87a
    }
};
// Gradients
const $15099970f99feec5$var$GRADIENT_GRAY_TO_BLACK_META = {
    name: 'gradient-gray-to-black',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
    name: 'gradient-dark-to-medium-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
    name: 'gradient-light-to-dark-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_BLUE_TO_TEAL_META = {
    name: 'gradient-blue-to-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
    name: 'gradient-purple-to-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
    name: 'gradient-magenta-to-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
    name: 'gradient-dark-to-light-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
    name: 'gradient-dark-to-light-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
    name: 'gradient-dark-green-to-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
    name: 'gradient-dark-to-medium-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        }
    }
};
const $15099970f99feec5$export$34373eced7ee212e = [
    $15099970f99feec5$var$WHITE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARK_BACKGROUND_CONFIG,
    $15099970f99feec5$var$PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$MAGENTA_BACKGROUND_CONFIG
];
const $15099970f99feec5$export$5ddfadab7b1e12c1 = [
    $15099970f99feec5$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
];
const $15099970f99feec5$export$349e5dbeac874253 = [
    ...$15099970f99feec5$export$5ddfadab7b1e12c1,
    $15099970f99feec5$export$4c351ec1dc290344
];
const $15099970f99feec5$export$242b2d2213fedf27 = [
    $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_RED_META,
    $15099970f99feec5$var$GRADIENT_MAGENTA_TO_ORANGE_META,
    $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
    $15099970f99feec5$var$GRADIENT_DARK_GREEN_TO_LIME_META,
    $15099970f99feec5$var$GRADIENT_BLUE_TO_TEAL_META,
    $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
    $15099970f99feec5$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
    $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
    $15099970f99feec5$var$GRADIENT_PURPLE_TO_MAGENTA_META,
    $15099970f99feec5$var$GRADIENT_GRAY_TO_BLACK_META
];
const $15099970f99feec5$export$8f118a95a310853a = [
    ...$15099970f99feec5$export$242b2d2213fedf27,
    ...$15099970f99feec5$export$349e5dbeac874253
];
const $15099970f99feec5$export$fe05a238062e2c3d = {
    white: $15099970f99feec5$export$4c351ec1dc290344,
    'light-purple': $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    'light-blue': $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    'light-teal': $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    'light-green': $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    'light-yellow': $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    'light-orange': $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    'light-red': $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    'light-magenta': $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    dark: $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    purple: $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    blue: $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG,
    teal: $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG,
    green: $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG,
    yellow: $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    orange: $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    red: $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG,
    magenta: $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG
};
const $15099970f99feec5$export$cab9d853866386f2 = $15099970f99feec5$export$4c351ec1dc290344;
const $15099970f99feec5$export$ed7cc0d417ee89e = '--jwm-banner-height';
const $15099970f99feec5$export$7009ab5fba189797 = `var(${$15099970f99feec5$export$ed7cc0d417ee89e}, 0px)`;
const $15099970f99feec5$export$8e357501548afe78 = 24;
const $15099970f99feec5$export$baaf8255c30ea280 = 95;
const $15099970f99feec5$export$d9035bc768f8226d = `calc(${$15099970f99feec5$export$baaf8255c30ea280}px + ${$15099970f99feec5$export$7009ab5fba189797})`;
const $15099970f99feec5$export$4810531e30462f89 = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$d9035bc768f8226d})`;
const $15099970f99feec5$export$1c0b806722927549 = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$d9035bc768f8226d} - ${$15099970f99feec5$export$8e357501548afe78 * 2}px)`;
const $15099970f99feec5$export$2af5673c2fa63c55 = 126;
const $15099970f99feec5$export$5771162cdeebfb85 = `calc(${$15099970f99feec5$export$2af5673c2fa63c55}px + ${$15099970f99feec5$export$7009ab5fba189797})`;
const $15099970f99feec5$export$a1626d6d785092a2 = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$5771162cdeebfb85})`;
const $15099970f99feec5$export$410e3d6221a052e = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$5771162cdeebfb85} - ${$15099970f99feec5$export$8e357501548afe78 * 2}px)`;
const $15099970f99feec5$export$77cdace62a821419 = `calc(100vw - ${(0, $ho1Ek.LEFT_PANEL_WIDTH)} - ${(0, $ho1Ek.LEFT_SIDEBAR_WIDTH)} - ${(0, $ho1Ek.RIGHT_PANEL_WIDTH)} - ${(0, $ho1Ek.RIGHT_SIDEBAR_WIDTH)}) !important`;
const $15099970f99feec5$export$3efe68325dd9dc02 = `calc(100vw - ${(0, $ho1Ek.LEFT_PANEL_WIDTH)} - ${(0, $ho1Ek.LEFT_SIDEBAR_WIDTH)} - ${(0, $ho1Ek.RIGHT_PANEL_WIDTH)} - ${(0, $ho1Ek.RIGHT_SIDEBAR_WIDTH)} - ${$15099970f99feec5$export$8e357501548afe78 * 2}px) !important`;

});

parcelRegister("fzymf", function(module, exports) {

$parcel$export(module.exports, "overviewDetailsResource", () => $a5200a1419c8dbcb$export$cd57aa046b167312);
$parcel$export(module.exports, "useOverview", () => $a5200a1419c8dbcb$export$626541a5c6f2cfa1);

var $lB25E = parcelRequire("lB25E");

var $wLx84 = parcelRequire("wLx84");
const $a5200a1419c8dbcb$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
const $a5200a1419c8dbcb$export$cd57aa046b167312 = (0, $lB25E.createResource)({
    type: $a5200a1419c8dbcb$var$RESOURCE_TYPE_KEY,
    getKey: ({ match: match })=>`${$a5200a1419c8dbcb$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
    getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, $wLx84.fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
    maxAge: 3600000
});
const $a5200a1419c8dbcb$export$626541a5c6f2cfa1 = ()=>(0, $lB25E.useResource)($a5200a1419c8dbcb$export$cd57aa046b167312);

});
parcelRegister("wLx84", function(module, exports) {

$parcel$export(module.exports, "fetchOverviewDetails", () => $218a2f4d5429f49f$export$f0395142dbdd6c61);

var $hhcsA = parcelRequire("hhcsA");

var $dlVOn = parcelRequire("dlVOn");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $huI7r = parcelRequire("huI7r");

var $3UEL2 = parcelRequire("3UEL2");

const $218a2f4d5429f49f$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
    if (!overviewId) return null;
    try {
        const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $3UEL2.QUERY),
                variables: {
                    id: (0, $huI7r.createAri)({
                        resourceOwner: 'jira',
                        cloudId: cloudId,
                        resourceType: 'project-overview',
                        resourceId: overviewId,
                        activationId: activationId
                    })
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        if (response?.data?.jira?.overview?.__typename === (0, $555b6ab3251d313a$export$62a5da7e3fa5ff88)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $hhcsA.mapOverviewFragment)(response.data.jira.overview);
        throw new (0, $dlVOn.GraphQLErrors)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        response?.data?.jira?.overview ?? response.errors);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 410 means that overviews have been migrated to plans and
        // we will show a different message on the not found page.
        if (error?.statusCode === 410) throw error;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $guiFP.default)({
                meta: {
                    id: 'overviewDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return null;
};

});
parcelRegister("hhcsA", function(module, exports) {

$parcel$export(module.exports, "mapOverviewFragment", () => $bc15f4b08a142f23$export$e79bf238de33eabb);
const $bc15f4b08a142f23$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bc15f4b08a142f23$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
        const { node: node } = edge || {};
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            isSimplified: node.projectStyle === $bc15f4b08a142f23$var$SIMPLIFIED_PROJECT_STYLE,
            isFavorite: node.isFavourite === true,
            permissions: {
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                // remove optional chaining when jwm-use-updated-graphql-querymutation-for-overview is cleaned up
                transitionIssues: node.transitionIssues?.canPerform === true,
                viewIssues: node.viewIssues.canPerform
            }
        };
    }).filter((project)=>project);
const $bc15f4b08a142f23$export$e79bf238de33eabb = (overview)=>{
    const { id: id, name: name, theme: theme, projects: projectsData } = overview;
    const projects = $bc15f4b08a142f23$var$mapProjectsNode(projectsData.edges);
    const unreachableProjectsCount = projectsData.edges.length - projects.length;
    return {
        id: id,
        name: name,
        theme: theme,
        projects: projects,
        unreachableProjectsCount: unreachableProjectsCount
    };
};

});

parcelRegister("dlVOn", function(module, exports) {

$parcel$export(module.exports, "GraphQLErrors", () => $c8c10c82db3c32ef$export$89c202e66b2de2b6);

var $hbMki = parcelRequire("hbMki");

var $1c8hB = parcelRequire("1c8hB");
// Sets the error message on this error according to the
// the GraphQL errors that are present.
const $c8c10c82db3c32ef$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `${errorMessage}\n`;
    });
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $c8c10c82db3c32ef$export$89c202e66b2de2b6 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = graphQLErrors != null ? (0, (/*@__PURE__*/$parcel$interopDefault($hbMki)))(graphQLErrors) : [];
        this.message = $c8c10c82db3c32ef$var$generateErrorMessage(this);
        this.cause = this.graphQLErrors?.[0];
        this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
        this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
    }
}

});
parcelRegister("hbMki", function(module, exports) {

var $1c8hB = parcelRequire("1c8hB");
/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $c838f35dc30c870d$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $1c8hB(value) ? value : [
        value
    ];
}
module.exports = $c838f35dc30c870d$var$castArray;

});


parcelRegister("3UEL2", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $286b893702b0066e$export$2b91517d6d5b4365);

const $286b893702b0066e$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $fd066e0e866fe0bc$export$6f4bda7ea1dcf892)}
`;

});
const $fd066e0e866fe0bc$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;


const $555b6ab3251d313a$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';




parcelRegister("4EvIi", function(module, exports) {

$parcel$export(module.exports, "useProjectTheme", () => $1782e76953ed5a6c$export$18084206b9430153);

var $eUqFw = parcelRequire("eUqFw");

var $kar7l = parcelRequire("kar7l");

var $aeIT6 = parcelRequire("aeIT6");

var $lB25E = parcelRequire("lB25E");
const $1782e76953ed5a6c$export$18084206b9430153 = ()=>{
    const { data: data } = (0, $lB25E.useResource)((0, $aeIT6.projectDetailsResource));
    return (0, $eUqFw.useMemo)(()=>{
        if (data != null) {
            const entityId = `project/${data.currentProject?.id}`;
            const themeSetting = data.themeSetting ?? {
                type: 'color',
                value: (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name
            };
            return {
                themeSetting: themeSetting,
                entityId: entityId
            };
        }
        return null;
    }, [
        data
    ]);
};

});
parcelRegister("aeIT6", function(module, exports) {

$parcel$export(module.exports, "projectDetailsResource", () => $d8cccda868228b81$export$e541d9eb202b4972);
$parcel$export(module.exports, "useProject", () => $d8cccda868228b81$export$51b1383ef8844a7);
$parcel$export(module.exports, "useMediaConfiguration", () => $d8cccda868228b81$export$ab5cf8327e07f046);

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $Qqb3l = parcelRequire("Qqb3l");
const $d8cccda868228b81$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
const $d8cccda868228b81$export$e541d9eb202b4972 = (0, $lB25E.createResource)({
    type: $d8cccda868228b81$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$d8cccda868228b81$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return (0, $Qqb3l.fetchProjectDetails)(cloudId, projectKey, projectId);
    },
    maxAge: 3600000
});
const $d8cccda868228b81$export$51b1383ef8844a7 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)($d8cccda868228b81$export$e541d9eb202b4972);
    return {
        data: data?.currentProject ?? null,
        loading: loading,
        error: error
    };
};
const $d8cccda868228b81$export$ab5cf8327e07f046 = ()=>{
    const { data: data } = (0, $lB25E.useResource)($d8cccda868228b81$export$e541d9eb202b4972);
    return data?.media ?? null;
};

});
parcelRegister("Qqb3l", function(module, exports) {

$parcel$export(module.exports, "fetchProjectDetails", () => $b6d7f500e2b72f80$export$78aa221476efa1c6);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $huI7r = parcelRequire("huI7r");


var $9RmFy = parcelRequire("9RmFy");
const $b6d7f500e2b72f80$var$EMPTY_VALUE = {
    themeSetting: null,
    media: null
};
const $b6d7f500e2b72f80$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
    const projectIdOrKey = projectId || projectKey;
    if (!projectIdOrKey) return null;
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
            body: JSON.stringify({
                query: (0, $561d2537991d9a5d$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    usingProjectKey: projectId == null,
                    projectId: projectId != null ? (0, $huI7r.createAri)({
                        resourceOwner: 'jira',
                        cloudId: cloudId,
                        resourceType: 'project',
                        resourceId: projectId
                    }) : ''
                }
            })
        });
        return (0, $9RmFy.transformData)(response.data, projectIdOrKey);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $guiFP.default)({
                meta: {
                    id: 'projectDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessProjectDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return $b6d7f500e2b72f80$var$EMPTY_VALUE;
};

});
const $561d2537991d9a5d$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  status
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  deleteIssues: action(type: DELETE_ISSUES) {
    canPerform
  }
  editIssues: action(type: EDIT_ISSUES) {
    canPerform
  }
  linkIssues: action(type: LINK_ISSUES) {
    canPerform
  }
  scheduleIssues: action(type: SCHEDULE_ISSUES) {
    canPerform
  }
  transitionIssues: action(type: TRANSITION_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $561d2537991d9a5d$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jira {
    mediaClientId(cloudId: $cloudId)
    mediaExternalEndpointUrl(cloudId: $cloudId)
  }
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
    theme: jwmActiveBackgroundByProject(projectIdOrKey: $projectIdOrKey) {
      __typename
      ... on QueryError {
        identifier
        message
        extensions {
          statusCode
          errorType
        }
      }
      ... on JiraWorkManagementBackground {
        ... on JiraWorkManagementColorBackground {
          colorValue
        }
        ... on JiraWorkManagementGradientBackground {
          gradientValue
        }
        ... on JiraWorkManagementMediaBackground {
          customBackground {
            id
            mediaApiFileId
            mediaReadToken (durationInSeconds: 600)
            sourceType
            sourceIdentifier
            altText
          }
        }
      }
    }
  }
}
${$561d2537991d9a5d$var$PROJECT_FRAGMENT}
`;

parcelRegister("9RmFy", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $402e94b0015519f9$export$3ceb62baab058c6b);
const $402e94b0015519f9$var$mapProjectNode = (node)=>{
    if (node == null) return null;
    return {
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        status: node.status,
        isSimplified: node.simplified,
        isFavorite: node.favorite === true,
        permissions: {
            administerProject: node.administerProject.canPerform,
            createIssues: node.createIssues.canPerform,
            deleteIssues: node.deleteIssues.canPerform,
            editIssues: node.editIssues.canPerform,
            linkIssues: node.linkIssues.canPerform,
            scheduleIssues: node.scheduleIssues.canPerform,
            transitionIssues: node.transitionIssues.canPerform,
            viewIssues: node.viewIssues.canPerform
        }
    };
};
const $402e94b0015519f9$var$parseThemeSetting = (data)=>{
    const theme = data?.jwmSidebar?.theme;
    if (theme?.__typename === 'JiraWorkManagementColorBackground') return {
        type: 'color',
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: theme.colorValue
    };
    if (theme?.__typename === 'JiraWorkManagementGradientBackground') return {
        type: 'color',
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: theme.gradientValue
    };
    if (theme?.__typename === 'JiraWorkManagementMediaBackground') {
        const { customBackground: customBackground } = theme;
        const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText } = customBackground;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            type: 'image',
            value: 'image',
            id: id,
            mediaApiFileId: mediaApiFileId,
            mediaReadToken: mediaReadToken,
            sourceType: sourceType,
            sourceIdentifier: sourceIdentifier,
            altText: altText
        };
    }
    return null;
};
const $402e94b0015519f9$var$parseMediaConfiguration = (data)=>{
    const clientId = data?.jira?.mediaClientId;
    const externalEndpointUrl = data?.jira?.mediaExternalEndpointUrl;
    if (clientId == null || externalEndpointUrl == null) return null;
    return {
        clientId: clientId,
        externalEndpointUrl: externalEndpointUrl
    };
};
const $402e94b0015519f9$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
        themeSetting: $402e94b0015519f9$var$parseThemeSetting(data),
        currentProject: $402e94b0015519f9$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $402e94b0015519f9$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
        projectIdOrKey: projectIdOrKey,
        media: $402e94b0015519f9$var$parseMediaConfiguration(data)
    });

});




parcelRegister("4e72F", function(module, exports) {

$parcel$export(module.exports, "ThemeTokensSetter", () => $7fcf00ff916ea46e$export$41f41c7ff10d45cd);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");


var $bcnRH = parcelRequire("bcnRH");

var $c9TLT = parcelRequire("c9TLT");

var $kar7l = parcelRequire("kar7l");

var $bOA3Q = parcelRequire("bOA3Q");

var $6FP8W = parcelRequire("6FP8W");


var $gDxeq = parcelRequire("gDxeq");
/**
 * Will merge multiple themes together, with the last theme taking precedence.
 * The first argument is the base theme, and the rest are partial themes that
 * will be merged into the base theme.
 */ function $7fcf00ff916ea46e$var$mergeThemes(theme, ...partialThemes) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, theme, ...partialThemes);
}
const $7fcf00ff916ea46e$var$buildHorizontalNavVariables = (theme)=>{
    if ((0, $6FP8W.getWillShowNav4)()) return `${0, $1508cc362255f535$export$539c074adec2188a}: ${theme['color.link']};
${0, $1508cc362255f535$export$1cfe9795423425c}: ${theme['color.background.neutral.hovered']};
${0, $1508cc362255f535$export$6f76912df5477959}: ${theme['color.link.pressed']};
${0, $1508cc362255f535$export$fac615ceaa871e35}: ${theme['color.text.subtle']};
${0, $1508cc362255f535$export$7748fdcd335afdc0}: ${theme['color.text']};
${0, $1508cc362255f535$export$88e550ed188132a7}: ${theme['color.elevation.surface']};
${0, $1508cc362255f535$export$e2e8fadb946a45d2}: ${theme['color.border.selected']};
${0, $1508cc362255f535$export$4cd72d361867c565}: ${theme['color.border']};`;
    return '';
};
const $7fcf00ff916ea46e$var$buildThemeVariables = (config, backgroundImageUrl, isDarkMode)=>{
    const applicationColorMode = isDarkMode ? 'dark' : 'light';
    const brightnessOverrides = config.brightness === 'high' && !isDarkMode ? (0, $kar7l.HIGH_BRIGHTNESS_THEME) : (0, $kar7l.LOW_BRIGHTNESS_THEME);
    const isImageConfig = config.name === 'image';
    const isGradientConfig = (0, $bOA3Q.themeManager).isGradientTheme(config.name);
    /**
   * The base theme and the custom theme get merged here, with the custom theme taking precedence.
   * If you want to override configurations globally, then you should make modifications to the
   * BASE_THEME, while if you want to customize a specific theme, then you should make modifications
   * in the theme's themselves.
   */ const theme = $7fcf00ff916ea46e$var$mergeThemes(// the base theme for the application
    (0, $kar7l.BASE_THEME), // the brightness overrides
    isImageConfig ? {} : brightnessOverrides, // gradient specific overrides
    isGradientConfig ? (0, $kar7l.GRADIENT_THEME) : {}, // The custom background configuration
    config.theme[applicationColorMode]);
    let elevationSurface = theme['elevation.surface'] ?? theme['color.elevation.surface'];
    if (backgroundImageUrl) // in dark mode, the image will be darkened by blending with a black transparent background
    elevationSurface = `url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
    else if (applicationColorMode === 'dark') {
        if ((0, $kar7l.NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig) /**
       * Add a gradient to the elevation surface for any themes in dark mode. This could be done in the
       * meta configuration but it's easier to do bulk edits here.
       */ elevationSurface = `linear-gradient(180deg, ${theme['color.elevation.surface']} 0%, ${"var(--ds-surface, #1D2125)"} 400px)`;
    }
    // Wrapper configuration
    const withWrapper = config.name !== (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name;
    const wrapperBackground = withWrapper ? `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : 'unset';
    const wrapperBorderRadius = withWrapper ? `${0, $c9TLT.gridSize}px` : '0';
    const isNav4 = (0, $6FP8W.getWillShowNav4)();
    const businessWrapperWithBackgroundHeight = isNav4 ? (0, $kar7l.NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, $kar7l.BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT);
    const businessWrapperHeight = isNav4 ? (0, $kar7l.NAV4_BUSINESS_WRAPPER_HEIGHT) : (0, $kar7l.BUSINESS_WRAPPER_HEIGHT);
    const wrapperHeight = withWrapper ? businessWrapperWithBackgroundHeight : businessWrapperHeight;
    const wrapperPadding = withWrapper ? `${0, $kar7l.BUSINESS_WRAPPER_PADDING}px` : '0';
    const wrapperWidth = withWrapper ? (0, $kar7l.BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH) : (0, $kar7l.BUSINESS_WRAPPER_WIDTH);
    return `
${(0, $kar7l.Variables).BACKDROP_FILTER}: ${isImageConfig ? 'blur(8px)' : 'none'};
${(0, $kar7l.Variables).COLOR_BACKGROUND_BRAND_BOLD}: ${theme['color.background.brand.bold']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_BRAND_BOLD_HOVERED}: ${theme['color.background.brand.bold.hovered']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_BRAND_BOLD_PRESSED}: ${theme['color.background.brand.bold.pressed']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_DISABLED}: ${theme['color.background.disabled']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_INPUT}: ${theme['color.background.input']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL}: ${theme['color.background.neutral']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL_HOVERED}: ${theme['color.background.neutral.hovered']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL_PRESSED}: ${theme['color.background.neutral.pressed']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED}: ${theme['color.background.neutral.subtle.hovered']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED}: ${theme['color.background.neutral.subtle.pressed']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_SELECTED}: ${theme['color.background.selected']};
${(0, $kar7l.Variables).COLOR_BORDER}: ${theme['color.border']};
${(0, $kar7l.Variables).COLOR_BORDER_INPUT}: ${theme['color.border.input']};
${(0, $kar7l.Variables).COLOR_BORDER_INVERSE}: ${theme['color.border.inverse']};
${(0, $kar7l.Variables).COLOR_BORDER_SELECTED}: ${theme['color.border.selected']};
${(0, $kar7l.Variables).COLOR_ELEVATION_SURFACE}: ${theme['color.elevation.surface']};
${(0, $kar7l.Variables).COLOR_ICON_DANGER}: ${theme['color.icon.danger']};
${(0, $kar7l.Variables).COLOR_ICON_INFORMATION}: ${theme['color.icon.information']};
${(0, $kar7l.Variables).COLOR_ICON_SUCCESS}: ${theme['color.icon.success']};
${(0, $kar7l.Variables).COLOR_ICON_WARNING}: ${theme['color.icon.warning']};
${(0, $kar7l.Variables).COLOR_LINK}: ${theme['color.link']};
${(0, $kar7l.Variables).COLOR_LINK_PRESSED}: ${theme['color.link.pressed']};
${(0, $kar7l.Variables).COLOR_SKELETON}: ${theme['color.skeleton']};
${(0, $kar7l.Variables).COLOR_TEXT}: ${theme['color.text']};
${(0, $kar7l.Variables).COLOR_TEXT_DISABLED}: ${theme['color.text.disabled']};
${(0, $kar7l.Variables).COLOR_TEXT_INVERSE}: ${theme['color.text.inverse']};
${(0, $kar7l.Variables).COLOR_TEXT_SELECTED}: ${theme['color.text.selected']};
${(0, $kar7l.Variables).COLOR_TEXT_SUBTLE}: ${theme['color.text.subtle']};
${(0, $kar7l.Variables).COLOR_TEXT_SUBTLEST}: ${theme['color.text.subtlest']};
${(0, $kar7l.Variables).CONTENT_HEIGHT}: ${businessWrapperHeight};
${(0, $kar7l.Variables).CONTENT_WIDTH}: ${0, $kar7l.BUSINESS_WRAPPER_WIDTH};
${(0, $kar7l.Variables).ELEVATION_SURFACE}: ${elevationSurface};
${(0, $kar7l.Variables).ELEVATION_SURFACE_CONTRAST}: ${theme['elevation.surface.contrast']};
${(0, $kar7l.Variables).ELEVATION_SURFACE_CONTRAST_BOLDER}: ${theme['elevation.surface.contrast.bolder']};
${(0, $kar7l.Variables).WRAPPER_BACKGROUND}: ${wrapperBackground};
${(0, $kar7l.Variables).WRAPPER_BORDER_RADIUS}: ${wrapperBorderRadius};
${(0, $kar7l.Variables).WRAPPER_HEIGHT}: ${wrapperHeight};
${(0, $kar7l.Variables).WRAPPER_PADDING}: ${wrapperPadding};
${(0, $kar7l.Variables).WRAPPER_WIDTH}: ${wrapperWidth};
${$7fcf00ff916ea46e$var$buildHorizontalNavVariables(theme)}`;
};
const $7fcf00ff916ea46e$export$41f41c7ff10d45cd = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const [{ themeSetting: themeSetting }] = (0, $bcnRH.useThemeHook)();
    const backgroundConfig = (0, $bOA3Q.themeManager).get({
        themeSetting: themeSetting,
        enableImages: true
    });
    const backgroundImageUrl = (0, $gDxeq.useBackgroundImageUrl)(themeSetting);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `:root{ ${$7fcf00ff916ea46e$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, false)} }
        [data-color-mode=dark]{ ${$7fcf00ff916ea46e$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, true)} }`
        }
    }));
});

});
parcelRegister("bcnRH", function(module, exports) {

$parcel$export(module.exports, "ThemeContainerOld", () => $0f9ed0aa218118d3$export$c6e50a832af54243);
$parcel$export(module.exports, "ThemeContainer", () => $0f9ed0aa218118d3$export$11eb671888ed6e7d);
$parcel$export(module.exports, "useThemeHook", () => $0f9ed0aa218118d3$export$b95ba2c6b597cfbb);
$parcel$export(module.exports, "useThemeSetting", () => $0f9ed0aa218118d3$export$87d26f94ea053d38);
$parcel$export(module.exports, "useSelectedThemeSetting", () => $0f9ed0aa218118d3$export$4ba6f9d407e18961);

var $hTLlD = parcelRequire("hTLlD");

var $bOA3Q = parcelRequire("bOA3Q");

var $WBLbN = parcelRequire("WBLbN");
const $0f9ed0aa218118d3$var$setTheme = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if ((0, $bOA3Q.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(themeSetting?.value, newTheme?.value)) setState({
            entityId: entityId,
            selectedThemeSetting: selectedThemeSetting,
            themeSetting: newTheme
        });
    };
const $0f9ed0aa218118d3$var$setSelectedThemeSetting = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if (newTheme === null || (0, $bOA3Q.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(selectedThemeSetting?.type === 'image' ? selectedThemeSetting?.id : selectedThemeSetting?.value, newTheme?.type === 'image' ? newTheme?.id : newTheme?.value)) setState({
            entityId: entityId,
            themeSetting: themeSetting,
            selectedThemeSetting: newTheme
        });
    };
const $0f9ed0aa218118d3$var$actions = {
    setTheme: $0f9ed0aa218118d3$var$setTheme,
    setSelectedThemeSetting: $0f9ed0aa218118d3$var$setSelectedThemeSetting
};
const $0f9ed0aa218118d3$var$initialState = {
    themeSetting: null,
    selectedThemeSetting: null,
    entityId: ''
};
const $0f9ed0aa218118d3$var$Store = (0, $WBLbN.createStore)({
    initialState: $0f9ed0aa218118d3$var$initialState,
    actions: $0f9ed0aa218118d3$var$actions,
    name: 'BusinessTheme'
});
const $0f9ed0aa218118d3$export$c6e50a832af54243 = (0, $WBLbN.createContainer)($0f9ed0aa218118d3$var$Store, {
    onInit: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme),
    onUpdate: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme)
});
const $0f9ed0aa218118d3$export$11eb671888ed6e7d = (0, $WBLbN.createContainer)($0f9ed0aa218118d3$var$Store, {
    onInit: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
            setState(entityTheme ?? $0f9ed0aa218118d3$var$initialState);
        },
    onUpdate: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
            setState(entityTheme ?? $0f9ed0aa218118d3$var$initialState);
        }
});
const $0f9ed0aa218118d3$export$b95ba2c6b597cfbb = (0, $WBLbN.createHook)($0f9ed0aa218118d3$var$Store);
const $0f9ed0aa218118d3$var$getThemeSetting = (0, $WBLbN.createSelector)((state)=>state.themeSetting, (themeSetting)=>themeSetting);
const $0f9ed0aa218118d3$export$87d26f94ea053d38 = (0, $WBLbN.createHook)($0f9ed0aa218118d3$var$Store, {
    selector: $0f9ed0aa218118d3$var$getThemeSetting
});
const $0f9ed0aa218118d3$var$getSelectedThemeSetting = (0, $WBLbN.createSelector)((state)=>state.selectedThemeSetting, (selectedThemeSetting)=>selectedThemeSetting);
const $0f9ed0aa218118d3$export$4ba6f9d407e18961 = (0, $WBLbN.createHook)($0f9ed0aa218118d3$var$Store, {
    selector: $0f9ed0aa218118d3$var$getSelectedThemeSetting
});

});
parcelRegister("bOA3Q", function(module, exports) {

$parcel$export(module.exports, "themeManager", () => $24bff9bf7f80d721$export$aba92a7f3273f617);
$parcel$export(module.exports, "generateMediaImageUrl", () => $24bff9bf7f80d721$export$fe2402bbc6ac3125);

var $kar7l = parcelRequire("kar7l");
/**
 * This is a temporary class that will be used to transition between the old
 * and new theme systems. Once the old theme system is removed, this class
 * will be removed as well.
 */ class $24bff9bf7f80d721$var$ThemeManager {
    init() {
        (0, $kar7l.GRADIENT_BACKGROUND_CONFIGS).forEach((theme)=>{
            this.gradients.set(theme.name, theme);
            this.gradientNames.add(theme.name);
        });
        (0, $kar7l.SOLID_COLOR_BACKGROUND_CONFIGS).forEach((theme)=>{
            this.colors.set(theme.name, theme);
            this.colorNames.add(theme.name);
        });
        (0, $kar7l.BACKGROUND_CONFIGS_OLD).forEach((theme)=>{
            this.oldColorNames.add(theme.name);
        });
    }
    isColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.colorNames.has(themeName);
    }
    isOldColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.oldColorNames.has(themeName);
    }
    isGradientTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.gradientNames.has(themeName);
    }
    isImageTheme(themeSetting) {
        return themeSetting.type === 'image';
    }
    getGradient(themeName) {
        return this.gradients.get(themeName);
    }
    getColor(themeName) {
        return this.colors.get(themeName);
    }
    /**
	 * Gets the theme meta for the given theme setting and version.
	 * This is used because we want to handle cases where users get flag
	 * variations during rollout that change what background is allowed.
	 * For example, if you have a new background color, but the flag is off,
	 * we want to revert back to the default background color instead.
	 * @param themeSetting the name setting with its type and value.
	 * @param enableImages determines if image backgrounds are enabled.
	 * @returns the meta information for the theme.
	 */ get({ themeSetting: themeSetting, enableImages: enableImages }) {
        if (!themeSetting) return 0, $kar7l.DEFAULT_BACKGROUND_CONFIG;
        if (enableImages && themeSetting.type === 'image') return 0, $kar7l.IMAGE_BACKGROUND_CONFIG;
        if (this.isGradientTheme(themeSetting.value)) return this.getGradient(themeSetting.value) ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG);
        if (this.isColorTheme(themeSetting.value)) return this.getColor(themeSetting.value) ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG);
        // we have an old color on the image version
        return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $kar7l.OLD_TO_NEW_BACKGROUND_CONFIG_MAP)[themeSetting.value] ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG));
    }
    constructor(){
        this.gradients = new Map();
        this.gradientNames = new Set();
        this.colors = new Map();
        this.colorNames = new Set();
        this.oldColorNames = new Set();
        this.isValidTheme = (themeSetting)=>this.isColorTheme(themeSetting.value) || this.isOldColorTheme(themeSetting.value) || this.isGradientTheme(themeSetting.value) || this.isImageTheme(themeSetting);
    }
}
const $24bff9bf7f80d721$export$aba92a7f3273f617 = new $24bff9bf7f80d721$var$ThemeManager();
$24bff9bf7f80d721$export$aba92a7f3273f617.init();
function $24bff9bf7f80d721$export$fe2402bbc6ac3125({ mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaEndpoint: mediaEndpoint, ...queryParams }) {
    const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);
    url.searchParams.append('client', mediaClientId);
    Object.entries(queryParams).forEach(([param, value])=>url.searchParams.append(param, String(value)));
    return url.toString();
}

});


const $1508cc362255f535$export$d1b9ea3245b6a5de = 2;
const $1508cc362255f535$export$d07bba395c9390f1 = 36;
const $1508cc362255f535$export$29911ec08ab2ca2d = 5;
const $1508cc362255f535$export$b61e6f89a9db76de = 12;
const $1508cc362255f535$export$7fd2e391116c6ef5 = 9;
const $1508cc362255f535$export$e1633e494d305bfb = 'MORE';
const $1508cc362255f535$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $1508cc362255f535$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $1508cc362255f535$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $1508cc362255f535$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $1508cc362255f535$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $1508cc362255f535$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $1508cc362255f535$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $1508cc362255f535$export$4cd72d361867c565 = '--horizontal-navigation-color-border';

parcelRegister("gDxeq", function(module, exports) {

$parcel$export(module.exports, "useBackgroundImageUrl", () => $1b8d41c84ad2c647$export$16f28a2a10ece447);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $ifH0n = parcelRequire("ifH0n");

var $bOA3Q = parcelRequire("bOA3Q");

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");

var $aeIT6 = parcelRequire("aeIT6");
const $1b8d41c84ad2c647$export$16f28a2a10ece447 = (themeSetting)=>{
    (0, $asu8X.di)(URL, fetch);
    const media = (0, $aeIT6.useMediaConfiguration)();
    const lowResUrl = (0, $eUqFw.useMemo)(()=>media && themeSetting?.type === 'image' ? (0, $bOA3Q.generateMediaImageUrl)({
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            mediaApiFileId: themeSetting.mediaApiFileId,
            token: themeSetting.mediaReadToken,
            mediaEndpoint: 'image',
            width: 1000,
            'max-age': Number.MAX_SAFE_INTEGER
        }) : null, [
        media,
        themeSetting
    ]);
    const [imageUrl, setImageUrl] = (0, $eUqFw.useState)(lowResUrl);
    const currentThemeId = (0, $eUqFw.useRef)(null);
    currentThemeId.current = themeSetting?.type === 'image' ? themeSetting.id : null;
    (0, $eUqFw.useEffect)(()=>{
        setImageUrl(lowResUrl);
        // if we don't have an image theme, do nothing
        if (!media || themeSetting?.type !== 'image') return;
        // build a new URL to the /binary path
        const binaryUrl = (0, $bOA3Q.generateMediaImageUrl)({
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            mediaApiFileId: themeSetting.mediaApiFileId,
            mediaEndpoint: 'binary',
            'max-age': Number.MAX_SAFE_INTEGER
        });
        // send a request to fetch the image with the binary URL with bearer token authentication
        fetch(binaryUrl.toString(), {
            headers: {
                Authorization: `Bearer ${themeSetting.mediaReadToken}`
            }
        }).then((response)=>response.blob()).then((blob)=>{
            const objectUrl = URL.createObjectURL(blob);
            if (currentThemeId.current === themeSetting.id) {
                setImageUrl(objectUrl);
                // send viewing analytics to Unsplash for Unsplash images
                if (themeSetting.sourceType === 'UNSPLASH' && themeSetting.sourceIdentifier) (0, $ifH0n.unsplashTracker).trackImage(themeSetting.sourceIdentifier);
            }
        }).catch((error)=>{
            // only fire error analytics if the error is not a client fetch error (e.g. network error, aborted)
            if (!(0, $JRB5w.isClientFetchError)(error)) (0, $guiFP.default)({
                meta: {
                    id: 'fetchBinaryBackgroundImage',
                    packageName: 'jiraBusinessThemeComponents',
                    teamName: 'work-management-frontier'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        themeSetting,
        media,
        lowResUrl
    ]);
    return imageUrl;
};

});
parcelRegister("ifH0n", function(module, exports) {

$parcel$export(module.exports, "unsplashTracker", () => $8eb46b17b2c5777f$export$1869e04dbed4c16c);

var $aYAw7 = parcelRequire("aYAw7");

var $dxIU5 = parcelRequire("dxIU5");
const $8eb46b17b2c5777f$var$APP_ID = '7066';
const $8eb46b17b2c5777f$export$ca6dda5263526f75 = `https://views.unsplash.com/v?app_id=${$8eb46b17b2c5777f$var$APP_ID}`;
const $8eb46b17b2c5777f$var$MAX_URL_LENGTH = 2083; // the maximum length of a URL in most browsers
const $8eb46b17b2c5777f$var$ID_LENGTH = 12; // the length of an unsplash image id
const $8eb46b17b2c5777f$export$28219189b23a0628 = Math.floor($8eb46b17b2c5777f$var$MAX_URL_LENGTH / $8eb46b17b2c5777f$var$ID_LENGTH);
/**
 * This class is responsible for tracking unsplash images that are displayed in the app.
 * This is needed for legal reasons to comply with the Unsplash API terms of service.
 * It will track the image when it is displayed and then track it again every 10 minutes.
 */ class $8eb46b17b2c5777f$var$UnsplashTracker {
    /**
	 * Send a request to the Unsplash API to track the image views.
	 * This will send a request for all the images in the queue.
	 * If the request fails, the images will be added back to the queue.
	 */ send() {
        if (this.queue.size === 0) return;
        const imageIds = Array.from(this.queue);
        this.queue.clear();
        (0, (/*@__PURE__*/$parcel$interopDefault($aYAw7)))(imageIds, $8eb46b17b2c5777f$export$28219189b23a0628).forEach((chunkIds)=>{
            const url = `${$8eb46b17b2c5777f$export$ca6dda5263526f75}&photoId=${chunkIds.join(',')}`;
            const now = new Date();
            imageIds.forEach((imageId)=>{
                this.trackedImages.set(imageId, now);
            });
            const handleFailure = ()=>{
                // if the request fails, add the image ids back to the queue
                imageIds.forEach((imageId)=>{
                    this.queue.add(imageId);
                    this.trackedImages.delete(imageId);
                });
            };
            fetch(url).then((response)=>{
                if (!response.ok) handleFailure();
            }).catch(()=>handleFailure());
        });
    }
    /**
	 * Track an image view. This will add the image to the queue to be tracked.
	 * If the image was tracked less than 10 minutes ago, it will not be added to the queue.
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns void
	 */ trackImage(sourceIdentifier) {
        const imageId = sourceIdentifier.split('-').pop(); // photo-1696144706485-ff7825ec8481 -> ff7825ec8481
        if (!imageId) return;
        const lastTracked = this.trackedImages.get(imageId);
        if (lastTracked && Date.now() - lastTracked.getTime() < this.trackingInterval) return;
        this.queue.add(imageId);
        this.sendDebounced();
    }
    /**
	 * Track an image view while it is in the viewport. This will track the image when it is displayed
	 * and then track it again every 10 minutes.
	 * @param element The element that contains the image
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns A function to stop tracking the image
	 */ trackWhileInViewport(element, sourceIdentifier) {
        let trackIntervalId = null;
        const observer = new IntersectionObserver((entry)=>{
            if (entry[0].isIntersecting && !trackIntervalId) {
                $8eb46b17b2c5777f$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                trackIntervalId = window.setInterval(()=>{
                    $8eb46b17b2c5777f$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                }, this.trackingInterval + 10); // extra 10ms to ensure the interval is always greater than 10 minutes
            } else if (trackIntervalId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearInterval(trackIntervalId);
        }, {
            rootMargin: '0px',
            threshold: 1.0
        });
        observer.observe(element);
        return ()=>{
            observer.disconnect();
            if (trackIntervalId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearInterval(trackIntervalId);
        };
    }
    static getInstance() {
        if (!$8eb46b17b2c5777f$var$UnsplashTracker.instance) $8eb46b17b2c5777f$var$UnsplashTracker.instance = new $8eb46b17b2c5777f$var$UnsplashTracker();
        return $8eb46b17b2c5777f$var$UnsplashTracker.instance;
    }
    constructor(){
        this.trackedImages = new Map();
        this.trackingInterval = 600000 // 10 minutes
        ;
        this.queue = new Set();
        this.sendDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(this.send, 1000);
    }
}
const $8eb46b17b2c5777f$export$1869e04dbed4c16c = $8eb46b17b2c5777f$var$UnsplashTracker.getInstance();

});
parcelRegister("aYAw7", function(module, exports) {

var $jADKY = parcelRequire("jADKY");

var $3P7i5 = parcelRequire("3P7i5");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7fdbd58793adf3d8$var$nativeCeil = Math.ceil, $7fdbd58793adf3d8$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $7fdbd58793adf3d8$var$chunk(array, size, guard) {
    if (guard ? $3P7i5(array, size, guard) : size === undefined) size = 1;
    else size = $7fdbd58793adf3d8$var$nativeMax($hNahz(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($7fdbd58793adf3d8$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $jADKY(array, index, index += size);
    return result;
}
module.exports = $7fdbd58793adf3d8$var$chunk;

});





parcelRegister("f8DlR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2etjo").then(()=>parcelRequire('eAAlI'));

});



parcelRegister("cEX90", function(module, exports) {

$parcel$export(module.exports, "ThemedContentLayout", () => $82d01d0a73f3012e$export$c2c3c7c0b13a1f9d);
$parcel$export(module.exports, "BusinessWrapper", () => $82d01d0a73f3012e$export$17220b5b22a6586);
/* BusinessWrapper.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eI5EY = parcelRequire("eI5EY");

var $8rQuz = parcelRequire("8rQuz");

var $3zjRf = parcelRequire("3zjRf");
const $82d01d0a73f3012e$var$styles = {
    rootOld: "_kqswh2mm",
    root: "_kqswh2mm _1pbyidpf",
    fullHeight: "_1tkeidpf _4t3i1osq",
    insetRoot: "_1yt4y22u",
    insetRootVisualRefresh: "_ca0qv47k",
    insetContainer: "_2rkolsi6 _bfhk8q8z"
};
const $82d01d0a73f3012e$export$c2c3c7c0b13a1f9d = ({ children: children, appearance: appearance })=>/*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            (0, $eI5EY.fg)('jwm_fix_popup_broken_with_custom_background') && $82d01d0a73f3012e$var$styles.root,
            !(0, $eI5EY.fg)('jwm_fix_popup_broken_with_custom_background') && $82d01d0a73f3012e$var$styles.rootOld,
            $82d01d0a73f3012e$var$styles.fullHeight,
            appearance === 'inset' && $82d01d0a73f3012e$var$styles.insetRoot,
            (0, $8rQuz.isVisualRefreshEnabled)() && appearance === 'inset' && $82d01d0a73f3012e$var$styles.insetRootVisualRefresh
        ])
    }, /*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            $82d01d0a73f3012e$var$styles.fullHeight,
            appearance === 'inset' && $82d01d0a73f3012e$var$styles.insetContainer
        ])
    }, children));
const $82d01d0a73f3012e$export$17220b5b22a6586 = ({ withWhiteBackground: withWhiteBackground, children: children })=>{
    if (withWhiteBackground) return /*#__PURE__*/ $eUqFw.createElement((0, $3zjRf.OuterWrapperWithBackground), null, /*#__PURE__*/ $eUqFw.createElement((0, $3zjRf.InnerWrapperWithBackground), null, children));
    return /*#__PURE__*/ $eUqFw.createElement((0, $3zjRf.OuterWrapper), null, /*#__PURE__*/ $eUqFw.createElement((0, $3zjRf.InnerWrapper), null, children));
};

});
parcelRegister("8rQuz", function(module, exports) {

$parcel$export(module.exports, "isVisualRefreshEnabled", () => $867146288cf212f8$export$48345cb467db19b6);

var $eI5EY = parcelRequire("eI5EY");

var $6mXXc = parcelRequire("6mXXc");
/*
 *  This is a similar implementation to Nav4
 *  (ref: src/packages/navigation-apps/sidebar-nav4/rollout/src/common/utils/get-will-show-nav4/get-will-show-nav4-for-eap/index.tsx)
 *  to accommodate the complex rollout logic of the visual refresh.
 */ // We have to use a DUMMY_CONDITION to not trigger ESLint errors.
const $867146288cf212f8$var$DUMMY_CONDITION = true;
const $867146288cf212f8$export$48345cb467db19b6 = ()=>(0, $eI5EY.fg)('visual-refresh') && // Kill switch for the entire rollout of the visual refresh
    ($867146288cf212f8$var$isVisualRefreshInDogfooding() || $867146288cf212f8$var$isVisualRefreshInEAP() || $867146288cf212f8$var$isVisualRefreshInOpenBeta());
// Used for the dogfooding of the visual refresh
const $867146288cf212f8$var$isVisualRefreshInDogfooding = ()=>(0, $eI5EY.fg)('visual-refresh-dogfood') && !(0, $6mXXc.getIsNav4UserOptOut)();
// Used for the EAP of the visual refresh
const $867146288cf212f8$var$isVisualRefreshInEAP = ()=>(0, $eI5EY.fg)('visual-refresh-eap') && !(0, $6mXXc.getIsNav4UserOptOut)();
// Used for the OpenBeta of the visual refresh
// TODO: Implement the OpenBeta experiment
const $867146288cf212f8$var$isVisualRefreshInOpenBeta = ()=>$867146288cf212f8$var$DUMMY_CONDITION && (0, $eI5EY.fg)('visual-refresh-open-beta');

});

parcelRegister("3zjRf", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $d2afd9eae3f40ab2$export$edaaad985a878983);
$parcel$export(module.exports, "OuterWrapperWithBackground", () => $d2afd9eae3f40ab2$export$69c6ec128d3729c9);
$parcel$export(module.exports, "InnerWrapper", () => $d2afd9eae3f40ab2$export$f185744748c379a7);
$parcel$export(module.exports, "InnerWrapperWithBackground", () => $d2afd9eae3f40ab2$export$2e149d12a18af14b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9zysr = parcelRequire("9zysr");

var $6FP8W = parcelRequire("6FP8W");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $d2afd9eae3f40ab2$var$Nav3OuterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _154i1jzz",
            __cmplp.className
        ])
    });
});
const $d2afd9eae3f40ab2$var$Nav4OuterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _154ieda8",
            __cmplp.className
        ])
    });
});
const $d2afd9eae3f40ab2$export$edaaad985a878983 = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $d2afd9eae3f40ab2$var$Nav4OuterWrapper, $d2afd9eae3f40ab2$var$Nav3OuterWrapper);
const $d2afd9eae3f40ab2$export$69c6ec128d3729c9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $d2afd9eae3f40ab2$export$edaaad985a878983, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4y22u",
            __cmplp.className
        ])
    });
});
const $d2afd9eae3f40ab2$export$f185744748c379a7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2d3f1oc1 _japi1mcq _iu1g1fl4 _fok81wug _q7c11wug",
            __cmplp.className
        ])
    });
});
const $d2afd9eae3f40ab2$export$2e149d12a18af14b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $d2afd9eae3f40ab2$export$f185744748c379a7, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkolsi6 _bfhk8q8z _2d3f1yz2 _japi1e8k",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1n0H8", function(module, exports) {

$parcel$export(module.exports, "addLeadingSlash", () => $0ff87a68793148e2$export$5b4913142e03bca8, (v) => $0ff87a68793148e2$export$5b4913142e03bca8 = v);
$parcel$export(module.exports, "hasBasename", () => $0ff87a68793148e2$export$10497c7ce66fcb84, (v) => $0ff87a68793148e2$export$10497c7ce66fcb84 = v);
$parcel$export(module.exports, "stripBasename", () => $0ff87a68793148e2$export$b69e3301ce081aa3, (v) => $0ff87a68793148e2$export$b69e3301ce081aa3 = v);
$parcel$export(module.exports, "stripTrailingSlash", () => $0ff87a68793148e2$export$d95b4586d238a081, (v) => $0ff87a68793148e2$export$d95b4586d238a081 = v);
$parcel$export(module.exports, "parsePath", () => $0ff87a68793148e2$export$8ccf933b0513f8d0, (v) => $0ff87a68793148e2$export$8ccf933b0513f8d0 = v);
$parcel$export(module.exports, "createPath", () => $0ff87a68793148e2$export$fe53371bee54353d, (v) => $0ff87a68793148e2$export$fe53371bee54353d = v);
var $0ff87a68793148e2$export$1e511d4a378977f5;
var $0ff87a68793148e2$export$5b4913142e03bca8;
var $0ff87a68793148e2$export$79c5b1569e3be9e6;
var $0ff87a68793148e2$export$10497c7ce66fcb84;
var $0ff87a68793148e2$export$b69e3301ce081aa3;
var $0ff87a68793148e2$export$d95b4586d238a081;
var $0ff87a68793148e2$export$8ccf933b0513f8d0;
var $0ff87a68793148e2$export$fe53371bee54353d;
'use strict';
$0ff87a68793148e2$export$1e511d4a378977f5 = true;
var $0ff87a68793148e2$var$addLeadingSlash = $0ff87a68793148e2$export$5b4913142e03bca8 = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
};
var $0ff87a68793148e2$var$stripLeadingSlash = $0ff87a68793148e2$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
};
var $0ff87a68793148e2$var$hasBasename = $0ff87a68793148e2$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};
var $0ff87a68793148e2$var$stripBasename = $0ff87a68793148e2$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
    return $0ff87a68793148e2$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};
var $0ff87a68793148e2$var$stripTrailingSlash = $0ff87a68793148e2$export$d95b4586d238a081 = function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};
var $0ff87a68793148e2$var$parsePath = $0ff87a68793148e2$export$8ccf933b0513f8d0 = function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
};
var $0ff87a68793148e2$var$createPath = $0ff87a68793148e2$export$fe53371bee54353d = function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
    return path;
};

});

parcelRegister("3oscM", function(module, exports) {

$parcel$export(module.exports, "calcRapidBoardResetState", () => $c71ed4be82b11f4e$export$2350ed3ff6c1a082);
$parcel$export(module.exports, "getApdexMatchObject", () => $c71ed4be82b11f4e$export$47e434f08768932b);
$parcel$export(module.exports, "calcRapidBoardResetStateV2", () => $c71ed4be82b11f4e$export$dbd9185166d0d04c);
$parcel$export(module.exports, "isValidRoute", () => $c71ed4be82b11f4e$export$9f3e656a7f6a3adc);

var $exb0h = parcelRequire("exb0h");
const $c71ed4be82b11f4e$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
            rapidBoardPaths = [
                (0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)
            ];
            resetDone = true;
            break;
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT:
            if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                resetDone = false;
                break;
            }
            if (!useStoredSettings && rapidBoardPaths.indexOf((0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
            rapidBoardPaths = [];
            break;
        default:
            resetDone = false;
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $c71ed4be82b11f4e$export$47e434f08768932b = (match, route)=>{
    let cleanMatch = {
        ...match,
        params: {
            ...match.params
        },
        query: {
            ...match.query
        }
    };
    if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
        const { params: params, query: query } = match;
        const paramKeys = params && Object.keys(params);
        const queryKeys = query && Object.keys(query);
        const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
        const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
        if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
        if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
    });
    if (match.query && match.query.view && match.query.view === 'detail') // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
    cleanMatch.query.view = undefined;
    if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
    cleanMatch = {
        ...cleanMatch,
        url: ''
    };
    return cleanMatch;
};
const $c71ed4be82b11f4e$export$dbd9185166d0d04c = (boardPaths, routeName, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
            rapidBoardPaths = [];
            resetDone = true;
            break;
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT:
            // use search to navigate to board
            if (rapidBoardPaths.includes((0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) || rapidBoardPaths.includes('useStoredSettings')) {
                resetDone = true;
                rapidBoardPaths = [];
                break;
            } else if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                break;
            } else {
                rapidBoardPaths = [];
                break;
            }
        default:
            if (rapidBoardPaths.includes((0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT))) {
                resetDone = true;
                rapidBoardPaths = [];
            }
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $c71ed4be82b11f4e$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
    if (state) {
        const { currentPage: currentPage, visitedPages: visitedPages } = state;
        const visitedPageLength = visitedPages.length;
        if (currentPage && currentPage.apps[appId]) return true;
        if (visitedPageLength === 0 || searchDepth <= 0) return false;
        for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
            if (visitedPages[visitedPageLength - i].apps[appId]) return true;
        }
    }
    return false;
};
const $c71ed4be82b11f4e$export$9f3e656a7f6a3adc = (routeToCheck)=>{
    switch(routeToCheck.name){
        case 0, $exb0h.ROUTE_NAMES_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_ISSUE_EMBED:
        case 0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR:
        case 0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC:
        case 0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ISSUES:
            return true;
        default:
            return false;
    }
};

});

parcelRegister("gdW04", function(module, exports) {

$parcel$export(module.exports, "RemoteActionsContainer", () => $9cc563ab6643b6b8$export$28c2e4c663a86266);
$parcel$export(module.exports, "useRemoteActions", () => $9cc563ab6643b6b8$export$333357b3de3e67a0);
$parcel$export(module.exports, "useRemoteActionsData", () => $9cc563ab6643b6b8$export$3cc006661ae2a759);
$parcel$export(module.exports, "useMeta", () => $9cc563ab6643b6b8$export$3fb9275d3845bd5a);
$parcel$export(module.exports, "useRemoteActionsStoreActions", () => $9cc563ab6643b6b8$export$3fd21eaf97df4718);

var $WBLbN = parcelRequire("WBLbN");

var $cqV4U = parcelRequire("cqV4U");
// jira freezes the global defaults object
if (!Object.isFrozen((0, $WBLbN.defaults))) (0, $WBLbN.defaults).devtools = false;
const $9cc563ab6643b6b8$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        meta: {},
        remoteActions: {},
        lastUpdatedAt: 0,
        isLoaded: false,
        product: undefined
    },
    actions: $cqV4U.actions,
    name: 'remoteActionsStore'
});
const $9cc563ab6643b6b8$export$28c2e4c663a86266 = (0, $WBLbN.createContainer)($9cc563ab6643b6b8$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $cqV4U.actions).initStore());
        }
});
const $9cc563ab6643b6b8$export$333357b3de3e67a0 = (selector)=>(0, $WBLbN.createHook)($9cc563ab6643b6b8$var$Store, {
        selector: selector
    })();
const $9cc563ab6643b6b8$export$3cc006661ae2a759 = (0, $WBLbN.createStateHook)($9cc563ab6643b6b8$var$Store, {
    selector: (state)=>state.remoteActions
});
const $9cc563ab6643b6b8$export$3fb9275d3845bd5a = (0, $WBLbN.createStateHook)($9cc563ab6643b6b8$var$Store, {
    selector: (state)=>state.meta
});
const $9cc563ab6643b6b8$export$3fd21eaf97df4718 = (0, $WBLbN.createActionsHook)($9cc563ab6643b6b8$var$Store);

});
parcelRegister("cqV4U", function(module, exports) {

$parcel$export(module.exports, "actions", () => $cd3fa27215f8b638$export$e324594224ef24da);

var $dnvcc = parcelRequire("dnvcc");

var $4t7Nl = parcelRequire("4t7Nl");

var $51DAc = parcelRequire("51DAc");

var $1xne4 = parcelRequire("1xne4");
const $cd3fa27215f8b638$export$e324594224ef24da = {
    processRemoteActions: $51DAc.processRemoteActions,
    saveActionPerformedAttempt: $1xne4.saveActionPerformedAttempt,
    initStore: $4t7Nl.initStore,
    clearActionId: $dnvcc.clearActionId
};

});
parcelRegister("dnvcc", function(module, exports) {

$parcel$export(module.exports, "clearActionId", () => $7b090ca5222c318b$export$8d8b492eefa9efba);

var $fLzjp = parcelRequire("fLzjp");
const $7b090ca5222c318b$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
        const { meta: meta } = getState();
        const newMeta = {
            ...meta
        };
        delete newMeta[actionId];
        setState({
            meta: newMeta
        });
        (0, $fLzjp.writeRemoteActionsMetasToLocalStorage)(product, meta);
    };

});
parcelRegister("fLzjp", function(module, exports) {

$parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", () => $6e7cfc6bf9421aef$export$a221266a05084986);
$parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", () => $6e7cfc6bf9421aef$export$7228aaade919a8b6);
const $6e7cfc6bf9421aef$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
const $6e7cfc6bf9421aef$export$a221266a05084986 = (product)=>{
    try {
        return JSON.parse(localStorage.getItem(`${$6e7cfc6bf9421aef$export$b9e25d3c75cffd71}.${product}`) || '{}');
    } catch (e) {
        console.warn('Could not load from localStorage', e);
        return {};
    }
};
const $6e7cfc6bf9421aef$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
    try {
        localStorage.setItem(`${$6e7cfc6bf9421aef$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
    } catch (e) {
        console.warn('Could not load from localStorage', e);
    }
};

});


parcelRegister("4t7Nl", function(module, exports) {

$parcel$export(module.exports, "initStore", () => $1e87662f3b55ae48$export$41f27b3823a442c6);

var $fLzjp = parcelRequire("fLzjp");
const $1e87662f3b55ae48$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
        // TODO Async read from Localstorage.
        setState({
            meta: (0, $fLzjp.readRemoteActionsMetasFromLocalStorage)(product),
            isLoaded: true,
            product: product
        });
    };

});

parcelRegister("51DAc", function(module, exports) {

$parcel$export(module.exports, "processRemoteActions", () => $134be2d45ea963a7$export$15e69d1dd38ccaa3);

var $ibqTf = parcelRequire("ibqTf");
const $134be2d45ea963a7$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
        const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
        if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) // data has not been updated, nothing to do
        return;
        const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
            if ((0, $ibqTf.shouldProcessRemoteAction)(remoteAction)) {
                const shouldAddAction = remoteAction.conditions.every((condition)=>(0, $ibqTf.isActionConditionSatisfied)(productData, condition));
                if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
            }
            // no updates
            return updatedRemoteActions;
        }, {});
        setState({
            meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                newMeta[id] = meta[id];
                return newMeta;
            }, {}),
            remoteActions: remoteActions,
            lastUpdatedAt: Date.now()
        });
    };

});
parcelRegister("ibqTf", function(module, exports) {

$parcel$export(module.exports, "isActionConditionSatisfied", () => $cca0479d0b04fa6d$export$9262d8191a70c677);
$parcel$export(module.exports, "shouldProcessRemoteAction", () => $cca0479d0b04fa6d$export$c7cc93192d09a3d7);

var $fLduT = parcelRequire("fLduT");
const $cca0479d0b04fa6d$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
const $cca0479d0b04fa6d$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
const $cca0479d0b04fa6d$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
    try {
        const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
        const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
        const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
        if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
        if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
    } catch (error) {
        console.warn('error while parsing a build key', error);
    }
    return false;
};
const $cca0479d0b04fa6d$export$9262d8191a70c677 = (productData, condition)=>{
    switch(condition.type){
        case (0, $fLduT.ConditionType).buildRange:
            return $cca0479d0b04fa6d$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition);
        case (0, $fLduT.ConditionType).featureFlag:
            return $cca0479d0b04fa6d$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
        case (0, $fLduT.ConditionType).featureGate:
            return $cca0479d0b04fa6d$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
        default:
            return false;
    }
};
const $cca0479d0b04fa6d$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;

});
parcelRegister("fLduT", function(module, exports) {

$parcel$export(module.exports, "ConditionType", () => $fe90e03a6e8a0345$export$748d1c753cdf4bfd);
var $fe90e03a6e8a0345$export$748d1c753cdf4bfd;
(function(ConditionType) {
    ConditionType["featureFlag"] = "featureFlag";
    ConditionType["featureGate"] = "featureGate";
    ConditionType["buildRange"] = "buildRange";
})($fe90e03a6e8a0345$export$748d1c753cdf4bfd || ($fe90e03a6e8a0345$export$748d1c753cdf4bfd = {}));

});



parcelRegister("1xne4", function(module, exports) {

$parcel$export(module.exports, "saveActionPerformedAttempt", () => $4d7f44cfab8f48a4$export$e3144a2e886e0e77);

var $fLzjp = parcelRequire("fLzjp");
const $4d7f44cfab8f48a4$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
        const { meta: meta, product: product } = getState();
        const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
        const updatedMetas = {
            ...meta,
            [actionId]: {
                lastPerformAttemptedAt: Date.now(),
                attemptCounts: currentAttemptCount + 1
            }
        };
        setState({
            meta: updatedMetas
        });
        // Can not happen.
        if (!product) throw new Error('Product is not defined.');
        (0, $fLzjp.writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
    };

});



parcelRegister("3dxBh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b1c4436e864f401$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ICvxP = parcelRequire("ICvxP");

var $6iz4v = parcelRequire("6iz4v");

var $3viaK = parcelRequire("3viaK");

var $6xYPC = parcelRequire("6xYPC");

var $87isp = parcelRequire("87isp");


var $0S0fK = parcelRequire("0S0fK");

var $1cNJ6 = parcelRequire("1cNJ6");
class $8b1c4436e864f401$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { children: children, pageId: pageId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0S0fK.default).Provider, {
            // @ts-expect-error - TS2322 - Type '{ pageId: string; onReady: (metricKeyForInitialRender: string, metricKeyForTransition: string, extra: { [key: string]: string | number | boolean; } | undefined, metric: BM3Metric) => void; onCustomMark: (markName: string) => void; }' is not assignable to type 'string'.
            value: {
                pageId: pageId,
                onReady: this.onReady,
                onCustomMark: this.onCustomMark
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: this.onStart,
            args: [
                pageId
            ]
        }), children));
    }
    constructor(...args){
        super(...args);
        this.customMarks = [];
        this.onStart = ()=>{
            (0, $ICvxP.default)((0, $37f655a4e4d5690e$export$56940a9488e85199));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$45c4b6bf7935c69a));
        };
        this.onCustomMark = (markName)=>{
            (0, $6iz4v.setMark)((0, $1cNJ6.getPrefixedMarkName)(markName));
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
            this.customMarks.push(markName);
        };
        this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
            metric.stop({
                customData: extra
            });
            if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
        };
    }
}

});
const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("0S0fK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f943d45ee0ecaf49$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $f943d45ee0ecaf49$var$contextName = 'SpaApdexAnalytics';
var $f943d45ee0ecaf49$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.createContext)($f943d45ee0ecaf49$var$contextName);

});

parcelRegister("1cNJ6", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $c844db40c28c8d19$export$c8f0e9837e7e9425);

const $c844db40c28c8d19$export$c8f0e9837e7e9425 = (name)=>`${0, $37f655a4e4d5690e$export$56940a9488e85199}${name}`;

});


parcelRegister("iJHZm", function(module, exports) {

$parcel$export(module.exports, "SpaStateContainer", () => $a6f32366b1daf5c0$export$e9a92b877fe80e80);
$parcel$export(module.exports, "SpaStateAppStart", () => $a6f32366b1daf5c0$export$d18dd27183a635c);
$parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", () => $a6f32366b1daf5c0$export$95a2912d76fb5433);
$parcel$export(module.exports, "SpaStatePageReady", () => $a6f32366b1daf5c0$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $a6f32366b1daf5c0$export$41e70078eeddaddc);
$parcel$export(module.exports, "SpaStatePageErrorReady", () => $a6f32366b1daf5c0$export$2583aa269898885c);
$parcel$export(module.exports, "getSpaStateLastUserLocation", () => $a6f32366b1daf5c0$export$6e9ab893e97cccef);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $lB25E = parcelRequire("lB25E");

var $WBLbN = parcelRequire("WBLbN");

var $lcJyp = parcelRequire("lcJyp");

var $cfLkw = parcelRequire("cfLkw");
const $a6f32366b1daf5c0$export$e9a92b877fe80e80 = (0, $WBLbN.createContainer)((0, $cfLkw.default));
const $a6f32366b1daf5c0$export$d18dd27183a635c = ()=>{
    const startRef = (0, $eUqFw.useRef)(Date.now());
    const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, $lcJyp.useSpaState)();
    (0, $eUqFw.useMemo)(()=>{
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visitedPages
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setAppStart(startRef.current);
    }, [
        setAppStart,
        visitedPages
    ]);
    return null;
};
const $a6f32366b1daf5c0$var$useRouterMatchSelector = (0, $lB25E.createRouterSelector)((state)=>state.match);
const $a6f32366b1daf5c0$var$useSpaStatePagesCount = (0, $WBLbN.createHook)((0, $cfLkw.default), {
    selector: ({ visitedPages: visitedPages })=>visitedPages.length
});
const $a6f32366b1daf5c0$export$95a2912d76fb5433 = ()=>{
    const match = $a6f32366b1daf5c0$var$useRouterMatchSelector();
    const [count, { setAppStart: setAppStart }] = $a6f32366b1daf5c0$var$useSpaStatePagesCount();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6f32366b1daf5c0$export$ada7e0ec445851a2, {
        visitedPagesLength: count,
        onSetAppStart: setAppStart,
        match: match
    });
};
const $a6f32366b1daf5c0$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppReady
        }));
const $a6f32366b1daf5c0$export$41e70078eeddaddc = ({ comparer: comparer } /* TODO - this should be using only the actions subscriber not state+actions subscriber */ )=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppReady,
            args: comparer
        }));
const $a6f32366b1daf5c0$export$2583aa269898885c = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppErrorReady: setAppErrorReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppErrorReady
        }));
class $a6f32366b1daf5c0$export$ada7e0ec445851a2 extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(props, state) {
        const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
        const matchHasChanged = props.match !== state.match;
        const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
        if (setAppStart) props.onSetAppStart(Date.now());
        // On transition visitedPageLength will always change before match, the only exception is when there is page
        // ids (e.g. issue types). When redirecting, the length doesn't change while the match changes (from issuetype to issuetype/xxxxx).
        // so if match changed without visitedPageLength changing, cache the new match and wait for both to update.
        if (setAppStart || !visitedPageLengthHasChanged) return {
            started: true,
            visitedPagesLength: props.visitedPagesLength,
            match: props.match
        };
        // if visitedPageLength changed, ignore and wait for update in match (which will trigger setAppStart next)
        return state;
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        /** so the challenge we are facing is that, we need to reset page when there's a visitedPagesLength change and a route change,
	 * but they don't always happen at the the same time during the current spa router situation. The following code does this:
	 *
	 * if first render: set app start
	 *
	 * if subsequently render with only visitedPagesLength change, ignore this updates, cache the old visitedPagesLength,
	 * wait for incoming match change
	 *
	 * if subsequently render with only match change, ignore this updates, cache the old match, wait for incoming
	 * visitedPagesLength change
	 *
	 *  if incoming changes contain both route and length change, we update state and start app
	 *
	 */ this.state = {
            visitedPagesLength: 0,
            started: false,
            match: null
        };
    }
}
const $a6f32366b1daf5c0$export$6e9ab893e97cccef = ()=>{
    const { visitedPages: visitedPages } = (0, $WBLbN.defaultRegistry).getStore((0, $cfLkw.default)).storeState.getState();
    return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
};

});

parcelRegister("geFaw", function(module, exports) {

$parcel$export(module.exports, "StrictMode", () => $5551fe9c9ab4b7c0$export$5f8d39834fd61797);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");
const $5551fe9c9ab4b7c0$export$5f8d39834fd61797 = ({ children: children })=>{
    // otherwise if the feature flag is enabled/or force opt-in, use React.StrictMode
    return (0, $1ybV0.ff)('jfp.magma.enable-strict-mode') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).StrictMode, null, children) : children;
};

});

parcelRegister("gTSbo", function(module, exports) {

$parcel$export(module.exports, "Router", () => $cff2cba3bfe91f62$export$55185c17a0fcbe46);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $8W8mY = parcelRequire("8W8mY");
const $cff2cba3bfe91f62$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
    const pluginsWithOverride = (0, $8W8mY.usePlugins)({
        resourceContext: props.resourceContext,
        resourceData: props.resourceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Router), {
        plugins: pluginsWithOverride,
        ...props
    }, children);
};

});
parcelRegister("8W8mY", function(module, exports) {

$parcel$export(module.exports, "usePlugins", () => $e161d30d7f706347$export$c41e96fd89bc6106);

var $eUqFw = parcelRequire("eUqFw");

var $eoTRo = parcelRequire("eoTRo");

var $amu7D = parcelRequire("amu7D");

var $gd0Sp = parcelRequire("gd0Sp");

var $dW81L = parcelRequire("dW81L");
const $e161d30d7f706347$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    // make sure "plugins" are created only once, ignore prop change/rerender
    const [pluginsWithOverride] = (0, $eUqFw.useState)(()=>{
        const jiraPlugins = [];
        const resourcesPlugin = (0, $dW81L.createResourcesPlugin)({
            context: resourceContext,
            resourceData: resourceData
        });
        jiraPlugins.push(resourcesPlugin);
        jiraPlugins.push((0, $eoTRo.createEntryPointsPlugin)({
            environment: (0, $amu7D.default)(),
            entryPointParams: {
                tenantContext: tenantContext
            }
        }));
        return jiraPlugins;
    });
    return pluginsWithOverride;
};

});
parcelRegister("eoTRo", function(module, exports) {

$parcel$export(module.exports, "createEntryPointsPlugin", () => $8908df19809cff0a$export$33586718f82f356f);

var $iWLL0 = parcelRequire("iWLL0");

var $4Wbcp = parcelRequire("4Wbcp");

var $gglAH = parcelRequire("gglAH");

var $kP52E = parcelRequire("kP52E");
const $8908df19809cff0a$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams })=>({
        id: 'entry-points-plugin',
        routeLoad: ({ context: context })=>{
            const entryPoint = context.route.entryPoint?.();
            const prefetchingRoute = (0, $gglAH.getPrefetchingRoute)();
            let entryPointReference = null;
            if (entryPoint) {
                // check if route EntryPoint is already prefethed right before being loaded
                if (prefetchingRoute && (0, $4Wbcp.isSameRouteMatch)({
                    prevContextMatch: prefetchingRoute.routerContext.match,
                    nextContextMatch: context.match
                }) && !(0, $4Wbcp.isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                else entryPointReference = (0, $iWLL0.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, entryPoint, {
                    context: context,
                    ...entryPointParams
                });
            }
            // saving entryPointReference helps to prevent cases when same EntryPoint is fetched multiple times
            // important when fetchPolicy=network-only is used
            (0, $gglAH.getEntryPointsStore)().actions.setLastLoadedRoute({
                route: context.route,
                entryPointReference: entryPointReference
            });
            return {
                entryPoint: entryPointReference
            };
        },
        routePrefetch: ({ nextContext: nextContext })=>{
            const entryPoint = nextContext.route.entryPoint?.();
            if (entryPoint) {
                const prevPrefetchingRoute = (0, $gglAH.getPrefetchingRoute)();
                // check if EntryPoint is already prefetched and not expired
                if (prevPrefetchingRoute && (0, $4Wbcp.isSameRouteMatch)({
                    prevContextMatch: prevPrefetchingRoute.routerContext.match,
                    nextContextMatch: nextContext.match
                }) && !(0, $4Wbcp.isExpired)(prevPrefetchingRoute.expiresAt)) return;
                const entryPointReference = (0, $iWLL0.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, entryPoint, {
                    context: nextContext,
                    ...entryPointParams
                });
                (0, $gglAH.getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: (0, $4Wbcp.getExpiresAt)(),
                    entryPointReference: entryPointReference
                });
            } else (0, $gglAH.getEntryPointsStore)().actions.setPrefetchingRoute({
                routerContext: nextContext,
                expiresAt: 0,
                entryPointReference: null
            });
        },
        waitForEntryPoint: ()=>{
            const lastLoadedRoute = (0, $gglAH.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $kP52E.waitForEntryPoint)(entryPointReference);
            return Promise.resolve();
        }
    });

});
parcelRegister("4Wbcp", function(module, exports) {

$parcel$export(module.exports, "getExpiresAt", () => $7b677faf33f0c24f$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "isExpired", () => $7b677faf33f0c24f$export$57947cfd429801a2);
$parcel$export(module.exports, "isSameRouteMatch", () => $7b677faf33f0c24f$export$5997e70fc4543270);
const $7b677faf33f0c24f$export$37d3126be6549b13 = 10000;
const $7b677faf33f0c24f$export$b65d7ba7fbf150f1 = ()=>$7b677faf33f0c24f$export$37d3126be6549b13 + Date.now();
const $7b677faf33f0c24f$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
const $7b677faf33f0c24f$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $7b677faf33f0c24f$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $7b677faf33f0c24f$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $7b677faf33f0c24f$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});

parcelRegister("kP52E", function(module, exports) {

$parcel$export(module.exports, "waitForEntryPoint", () => $865808bba2ff8fa0$export$944f853f194e5dd5);

var $c7ifG = parcelRequire("c7ifG");
const $865808bba2ff8fa0$export$944f853f194e5dd5 = (entryPointConfig)=>{
    const promises = [];
    try {
        entryPointConfig.getComponent();
    } catch (err) {
        if (err instanceof Promise) promises.push(err);
        else throw err;
    }
    const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
    if (queries) Object.keys(queries).forEach((key)=>{
        if (queries[key].id) {
            const queryPromise = (0, $c7ifG.QueryPromisesMap).get(String(queries[key].id));
            if (queryPromise) promises.push(queryPromise);
        }
    });
    if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
        const nestedEntryPointPromise = $865808bba2ff8fa0$export$944f853f194e5dd5(entryPoints[key]);
        promises.push(nestedEntryPointPromise);
    });
    return Promise.allSettled(promises);
};

});


parcelRegister("dW81L", function(module, exports) {

$parcel$export(module.exports, "createResourcesPlugin", () => $9aee4cd38ce58613$export$23ed892c481a96fe);

var $e2YXo = parcelRequire("e2YXo");

var $l0jNy = parcelRequire("l0jNy");
const $9aee4cd38ce58613$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $9aee4cd38ce58613$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $e2YXo.getResourceStore)().actions;
    const nextResources = (0, $l0jNy.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $9aee4cd38ce58613$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $e2YXo.getResourceStore)().actions;
    const nextResources = (0, $l0jNy.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $9aee4cd38ce58613$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $e2YXo.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $9aee4cd38ce58613$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $9aee4cd38ce58613$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $9aee4cd38ce58613$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $e2YXo.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $e2YXo.getResourceStore)().actions;
            const nextResources = (0, $l0jNy.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $e2YXo.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("l0jNy", function(module, exports) {

$parcel$export(module.exports, "getResourcesForNextLocation", () => $334bbc6cfe5a6fd8$export$7cbbc763e2f3d65d);

var $8JMlp = parcelRequire("8JMlp");

var $3DChr = parcelRequire("3DChr");
const $334bbc6cfe5a6fd8$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $3DChr.routeHasResources)(nextRoute)) return [];
    if ((0, $3DChr.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $8JMlp.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $8JMlp.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("8JMlp", function(module, exports) {

$parcel$export(module.exports, "getResourceIdentifier", () => $3e60e0806526708a$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $3e60e0806526708a$export$cd7fbe7e979df558);
const $3e60e0806526708a$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $3e60e0806526708a$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$3e60e0806526708a$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("3DChr", function(module, exports) {

$parcel$export(module.exports, "routeHasResources", () => $135cafef8578dfeb$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $135cafef8578dfeb$export$221027ff1aa38f82);
const $135cafef8578dfeb$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $135cafef8578dfeb$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});





parcelRegister("9DIQe", function(module, exports) {

$parcel$export(module.exports, "JiraRouterLinkConfiguration", () => $f7d9123ec5eaca80$export$a580704a2f3cfca);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $f7d9123ec5eaca80$export$a580704a2f3cfca = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    if (// Links can be initially rendered with `href` not defined in some cases
    !href || typeof href === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
        ref: ref,
        href: href || '#',
        ...rest
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
        ref: ref,
        href: href.href,
        to: href.to,
        replace: href.replace,
        params: href.params,
        query: href.query,
        prefetch: href.prefetch,
        ...rest
    }, children);
});

});

parcelRegister("efFTI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLayout", () => $f4bfbc079ef4e42a$export$e6aef6083548e882);

var $dVvIP = parcelRequire("dVvIP");

var $isbb2 = parcelRequire("isbb2");
const $f4bfbc079ef4e42a$export$e6aef6083548e882 = (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout));

});
parcelRegister("dVvIP", function(module, exports) {

$parcel$export(module.exports, "globalLayout", () => $d3e020a4d042f679$export$929cb72e7acb7fd9);

var $isbb2 = parcelRequire("isbb2");
const $d3e020a4d042f679$var$rightSidebars = ()=>[];
const $d3e020a4d042f679$export$929cb72e7acb7fd9 = (0, $isbb2.createLayout)({
    rightSidebars: $d3e020a4d042f679$var$rightSidebars()
});

});


parcelRegister("bMm60", function(module, exports) {

$parcel$export(module.exports, "createEntry", () => $ed0b59c4afa4514b$export$344b9c9ab5e66c9a);
const $ed0b59c4afa4514b$export$344b9c9ab5e66c9a = (baseRoute, opts)=>{
    if (typeof opts === 'function') throw new Error('Passing a funciton to createEntry is only available in the route-experiment variant');
    return Object.assign(baseRoute, opts);
};

});

parcelRegister("hHrVM", function(module, exports) {

$parcel$export(module.exports, "getModernIssueTransitionResources", () => $c6a3d716ac1fee91$export$e1afa08027b1e44b);
$parcel$export(module.exports, "getNavigationResources", () => $c6a3d716ac1fee91$export$75cffd1aaecf4a2c);
$parcel$export(module.exports, "getUserBoardNavigationResources", () => $c6a3d716ac1fee91$export$c57dc1ea7f76f91f);
$parcel$export(module.exports, "getNavigationSidebarProjectResource", () => $c6a3d716ac1fee91$export$c4cf7264f95bae78);
$parcel$export(module.exports, "getNavigationSidebarPlanResources", () => $c6a3d716ac1fee91$export$af2259a87f79645d);
$parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", () => $c6a3d716ac1fee91$export$a103e99ad51f7bc3);
$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $c6a3d716ac1fee91$export$808691f5a412afa3);
// eslint-disable-next-line jira/import-whitelist

var $a5Lgz = parcelRequire("a5Lgz");

var $1ybV0 = parcelRequire("1ybV0");

var $l90Gp = parcelRequire("l90Gp");

var $6OTFM = parcelRequire("6OTFM");

var $4MmfV = parcelRequire("4MmfV");

var $I0t4m = parcelRequire("I0t4m");

var $cbmC6 = parcelRequire("cbmC6");

var $iivTa = parcelRequire("iivTa");

var $kXWpU = parcelRequire("kXWpU");

var $eJCK9 = parcelRequire("eJCK9");

var $7zhpa = parcelRequire("7zhpa");

var $6FP8W = parcelRequire("6FP8W");

var $hawmT = parcelRequire("hawmT");

var $8yXY1 = parcelRequire("8yXY1");

var $cpkr0 = parcelRequire("cpkr0");

var $hlO97 = parcelRequire("hlO97");

var $dAKwA = parcelRequire("dAKwA");

var $jlBE2 = parcelRequire("jlBE2");

var $ellXt = parcelRequire("ellXt");

var $8Osbm = parcelRequire("8Osbm");

var $h0Ytu = parcelRequire("h0Ytu");

var $6XOSh = parcelRequire("6XOSh");

var $jD3pk = parcelRequire("jD3pk");

var $l6RYU = parcelRequire("l6RYU");

var $9CFDS = parcelRequire("9CFDS");

var $1NIhY = parcelRequire("1NIhY");

var $gF5SK = parcelRequire("gF5SK");

var $fKYF0 = parcelRequire("fKYF0");

var $ixwgj = parcelRequire("ixwgj");

var $grsJA = parcelRequire("grsJA");

var $3vlQh = parcelRequire("3vlQh");

var $3MEW8 = parcelRequire("3MEW8");

var $4uxD3 = parcelRequire("4uxD3");

var $jwzNs = parcelRequire("jwzNs");
const $c6a3d716ac1fee91$var$getNewIssueTransitionExperienceInJiraLabsVariation = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', [
        'OFF',
        'BY_DEFAULT_USER_OPT_IN',
        'BY_DEFAULT_USER_OPT_OUT'
    ]);
const $c6a3d716ac1fee91$var$isModernIssueTransitionSettingEnabled = ()=>{
    const variation = $c6a3d716ac1fee91$var$getNewIssueTransitionExperienceInJiraLabsVariation();
    return variation !== 'OFF';
};
const $c6a3d716ac1fee91$var$conditionalGicOptInStatusResource = (0, $jwzNs.resourceWithCondition)(()=>(0, $1ybV0.ff)('project.config.pce.modern.global-issue-create'), (0, $ellXt.gicOptInStatusResources));
const $c6a3d716ac1fee91$var$conditionalIssueTransitionOptInStatusResource = (0, $jwzNs.resourceWithCondition)($c6a3d716ac1fee91$var$isModernIssueTransitionSettingEnabled, (0, $6XOSh.issueTransitionOptInStatusResource));
const $c6a3d716ac1fee91$var$conditionalGicSmartFieldsOptoutResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr'), (0, $jlBE2.gicSmartFieldsFeatureResource));
const $c6a3d716ac1fee91$var$conditionalConsentBannerUserPreferencesResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('platform.moonjelly.browser-storage-controls-v2'), (0, $8yXY1.consentBannerUserPreferencesResource));
const $c6a3d716ac1fee91$export$e1afa08027b1e44b = ()=>[
        $c6a3d716ac1fee91$var$conditionalIssueTransitionOptInStatusResource,
        (0, $h0Ytu.issueTransitionChangeboardingPreferencesResource)
    ];
// There is a best effort duplicate removal in the `getRoutes` function but it
// only works if the resources have the same instance. b/c resourceWithCondition2
// will create a new reference each time it is run, by keeping this outside the
// route factory, we can ensure that the duplicate removal works when it is used
// in multiple places.
const $c6a3d716ac1fee91$var$dedupableConditionalResources = [
    (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, $hlO97.consolidationUserStateResource)),
    (0, $jwzNs.resourceWithCondition2)((0, $6FP8W.getWillShowNav4), (0, $7zhpa.sidebarNav4Resource)),
    (0, $jwzNs.resourceWithCondition2)((0, $6FP8W.getWillShowNav4), (0, $7zhpa.sidebarNav4UiStateResource))
];
const $c6a3d716ac1fee91$export$75cffd1aaecf4a2c = ()=>[
        (0, $1NIhY.navigationUiStateResource),
        (0, $hawmT.navigationPlansVisibilityResource),
        (0, $4uxD3.userHomepageResource),
        $c6a3d716ac1fee91$var$conditionalGicOptInStatusResource,
        (0, $a5Lgz.announcementBannerSettingsV4Resource),
        $c6a3d716ac1fee91$var$conditionalConsentBannerUserPreferencesResource,
        ...$c6a3d716ac1fee91$var$dedupableConditionalResources,
        (0, $jD3pk.organizationIdResource),
        (0, $3MEW8.themePreferenceResource),
        ...$c6a3d716ac1fee91$export$e1afa08027b1e44b(),
        (0, $fKYF0.persistentIssueCreateModalViewResource),
        $c6a3d716ac1fee91$var$conditionalGicSmartFieldsOptoutResource,
        (0, $8Osbm.incomingMailServerExpiryStatusResource),
        (0, $grsJA.rovoEntitlementResource)
    ];
const $c6a3d716ac1fee91$export$c57dc1ea7f76f91f = ()=>[
        (0, $4MmfV.staticJSWUserBoardSidebarNavigationResource)
    ];
const $c6a3d716ac1fee91$export$c4cf7264f95bae78 = ()=>[
        (0, $3vlQh.incidentExperimentTraitResource),
        (0, $ixwgj.projectContextResource),
        (0, $l90Gp.forgeProjectModuleResource),
        (0, $eJCK9.staticSidebarShortcutsResource),
        (0, $kXWpU.staticProjectSidebarNavigationResource),
        (0, $cbmC6.staticProjectSidebarConnectAddonsNavigationResource),
        (0, $6OTFM.staticSoftwareProjectHorizontalNavResource)
    ];
const $c6a3d716ac1fee91$export$af2259a87f79645d = ()=>[
        (0, $I0t4m.staticPlanSidebarNavigationResource)
    ];
const $c6a3d716ac1fee91$export$a103e99ad51f7bc3 = ()=>[
        (0, $9CFDS.navigationSidebarGlobalResource),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $cpkr0.checkApiKeyManagementKeysResource)()
    ];
const $c6a3d716ac1fee91$export$808691f5a412afa3 = ()=>[
        (0, $gF5SK.newIssueViewTransitionLockInStatusResource),
        (0, $l6RYU.navigationSidebarAutomationLegacyEnabledResource),
        (0, $ixwgj.projectContextResourceWithCache),
        (0, $l90Gp.forgeProjectSettingsModuleResource),
        (0, $iivTa.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

});
parcelRegister("6OTFM", function(module, exports) {

$parcel$export(module.exports, "staticSoftwareProjectHorizontalNavResource", () => $e315884b683b3230$export$c5680a2101ae5345);

var $jDNSq = parcelRequire("jDNSq");

var $8npnf = parcelRequire("8npnf");

var $kdp9J = parcelRequire("kdp9J");

var $gUUjF = parcelRequire("gUUjF");

var $6FP8W = parcelRequire("6FP8W");

var $com8B = parcelRequire("com8B");

var $buJlM = parcelRequire("buJlM");

var $djXuz = parcelRequire("djXuz");

var $ElVpH = parcelRequire("ElVpH");

var $9zYls = parcelRequire("9zYls");

var $jwzNs = parcelRequire("jwzNs");
const $e315884b683b3230$var$getProjectAri = (projectId, cloudId)=>{
    try {
        return projectId ? (0, $8npnf.JiraProjectAri).create({
            siteId: cloudId,
            projectId: String(projectId)
        }).toString() : '';
    } catch (err) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('navigation-apps.resources.software-horizontal-navigation', 'Failed to get project ari');
        return '';
    }
};
const $e315884b683b3230$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: tenantContext })=>{
    let scope;
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    const boardId = (0, $ElVpH.getBoardId)(match, query);
    const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
    if (isTMPBoardRoute) // TMP software projects always use projectKey even on board routes because they only have one board
    scope = (0, $kdp9J.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId
    });
    else scope = (0, $kdp9J.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
    const boardAri = scope.identifierType === 'boardId' ? (0, $jDNSq.JiraSoftwareBoardAri).create({
        siteId: tenantContext.cloudId,
        boardId: String(match.params.boardId)
    }).toString() : null;
    const projectAri = $e315884b683b3230$var$getProjectAri(projectId, tenantContext.cloudId);
    const containerNavigationInput = boardAri || projectAri ? {
        scopeId: String(boardAri || projectAri)
    } : {
        projectKeyQuery: {
            cloudId: tenantContext.cloudId,
            projectKey: projectKey
        }
    };
    // We need to create a placeholder ID if one doesn't exist, as it is a required argument for the JiraBoard query
    const boardAriTemp = boardId ? (0, $jDNSq.JiraSoftwareBoardAri).create({
        siteId: tenantContext.cloudId,
        boardId: boardId
    }).toString() : (0, $jDNSq.JiraSoftwareBoardAri).create({
        siteId: tenantContext.cloudId,
        boardId: '0'
    }).toString();
    return {
        parameters: (0, $djXuz.default),
        variables: {
            cloudId: tenantContext.cloudId,
            projectKey: projectKey,
            projectAri: projectAri,
            boardId: boardAriTemp,
            containerNavigationInput: containerNavigationInput,
            first: (0, $com8B.NAVIGATION_ITEMS_PAGE_SIZE),
            useProjectKey: Boolean(projectKey),
            useProjectAri: Boolean(projectAri),
            hasBoardId: Boolean(boardId),
            isTmpRoute: Boolean(isTMPBoardRoute)
        },
        options: {
            fetchPolicy: 'store-and-network'
        }
    };
};
const $e315884b683b3230$export$c5680a2101ae5345 = (0, $jwzNs.resourceWithCondition2)(()=>(0, $6FP8W.getWillShowNav4)(), (0, $buJlM.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_PROJECT_QUERY',
    getQuery: $e315884b683b3230$export$71eec30d9db46a56
}));

});
parcelRegister("com8B", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_ITEMS_PAGE_SIZE", () => $992003ad8c7a0558$export$4653cda61a4943d6);
$parcel$export(module.exports, "TAB_UNDERLINE_HEIGHT", () => $992003ad8c7a0558$export$d1b9ea3245b6a5de);
$parcel$export(module.exports, "TAB_HEIGHT", () => $992003ad8c7a0558$export$d07bba395c9390f1);
$parcel$export(module.exports, "TAB_GAP", () => $992003ad8c7a0558$export$b61e6f89a9db76de);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports


const $992003ad8c7a0558$export$4653cda61a4943d6 = 75;
const $992003ad8c7a0558$export$d1b9ea3245b6a5de = 2;
const $992003ad8c7a0558$export$d07bba395c9390f1 = 36;
const $992003ad8c7a0558$export$29911ec08ab2ca2d = 5;
const $992003ad8c7a0558$export$b61e6f89a9db76de = 12;
const $992003ad8c7a0558$export$7fd2e391116c6ef5 = 9;
const $992003ad8c7a0558$export$e1633e494d305bfb = 'MORE';

});

parcelRegister("djXuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $70d6cbbebfbb8fd5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9ab68691276dfb049d592779c70bacb>>
 * @relayHash 45acd10b6ad33e22a13040d5c4fbed9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 82bac835e30354bbb78d1e441b23588d10ecb22afba1a3dd0aeb233947ff4165
const $70d6cbbebfbb8fd5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasBoardId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTmpRoute"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useProjectAri"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useProjectKey"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "containerNavigationInput"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v12 = {
        "kind": "ScalarField",
        "name": "scopeId"
    }, v13 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v14 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v15 = [
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v18 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v19 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v20 = {
        "kind": "ScalarField",
        "name": "key"
    }, v21 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v22 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v23 = {
        "alias": "canEditProjectConfig",
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v22 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v24 = {
        "alias": "canViewProjectConfig",
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "VIEW_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v22 /*: any*/ ,
        "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
    }, v25 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v26 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v27 = [
        {
            "kind": "FragmentSpread",
            "name": "projectHeader_horizontalNavHeader"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_navigationKitTabList_TabList_projectFragment"
        },
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ ,
        v23 /*: any*/ ,
        v24 /*: any*/ ,
        v25 /*: any*/ ,
        v26 /*: any*/ 
    ], v28 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v29 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v30 = {
        "kind": "ScalarField",
        "name": "id"
    }, v31 = {
        "kind": "ScalarField",
        "name": "label"
    }, v32 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v33 = {
        "kind": "ScalarField",
        "name": "url"
    }, v34 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": [
            v30 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v36 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v37 = {
        "kind": "ScalarField",
        "name": "boardType"
    }, v38 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v39 = [
        v29 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v36 /*: any*/ ,
                v16 /*: any*/ ,
                v11 /*: any*/ ,
                v37 /*: any*/ ,
                {
                    "concreteType": "JiraFavouriteValue",
                    "kind": "LinkedField",
                    "name": "favouriteValue",
                    "plural": false,
                    "selections": [
                        v38 /*: any*/ ,
                        v30 /*: any*/ 
                    ]
                },
                v26 /*: any*/ 
            ],
            "type": "JiraBoard"
        },
        v35 /*: any*/ 
    ], v40 = [
        {
            "kind": "LinkedField",
            "name": "mostRecentlyViewedBoard",
            "plural": false,
            "selections": v39 /*: any*/ 
        },
        v30 /*: any*/ 
    ], v41 = [
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v19 /*: any*/ ,
        v25 /*: any*/ ,
        v23 /*: any*/ ,
        v30 /*: any*/ ,
        {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        },
        v38 /*: any*/ ,
        v18 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "webUrl"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        v24 /*: any*/ ,
        v26 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "navigationMetadata",
            "plural": false,
            "selections": [
                v29 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v36 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isSimpleBoard"
                        },
                        v30 /*: any*/ 
                    ],
                    "type": "JiraSoftwareProjectNavigationMetadata"
                }
            ]
        },
        {
            "kind": "LinkedField",
            "name": "mostRecentlyViewedBoard",
            "plural": false,
            "selections": [
                v29 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v36 /*: any*/ ,
                        v37 /*: any*/ 
                    ],
                    "type": "JiraBoard"
                },
                v35 /*: any*/ 
            ]
        },
        v20 /*: any*/ ,
        v21 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiHorizontalSoftwareProjectNavQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v10 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_navigationKitTabList_TabList_containerFragment"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_navigationKitAddTab_AddTab"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "args": v13 /*: any*/ ,
                                                    "concreteType": "JiraNavigationItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "navigationItems",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "ui_navigationKitTabList_TabList_tabsFragment"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.containerNavigation"
                            },
                            {
                                "condition": "isTmpRoute",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "boardId",
                                                "variableName": "boardId"
                                            },
                                            v14 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "hasBoardId",
                                                "variableName": "hasBoardId"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "projectAri",
                                                "variableName": "projectAri"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "projectKey",
                                                "variableName": "projectKey"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "useProjectAri",
                                                "variableName": "useProjectAri"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "useProjectKey",
                                                "variableName": "useProjectKey"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "boardHeader_horizontalNavHeader"
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "alias": "projectDataByKey",
                                            "args": v15 /*: any*/ ,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProjectByKey",
                                            "plural": false,
                                            "selections": v27 /*: any*/ 
                                        },
                                        "action": "THROW",
                                        "path": "jira.projectDataByKey"
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "condition": "useProjectAri",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "alias": "projectDataById",
                                                    "args": v28 /*: any*/ ,
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "jiraProject",
                                                    "plural": false,
                                                    "selections": v27 /*: any*/ 
                                                },
                                                "action": "THROW",
                                                "path": "jira.projectDataById"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v9 /*: any*/ ,
                v8 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiHorizontalSoftwareProjectNavQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                v29 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraContainerNavigationResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v30 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDefault"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                },
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v31 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRemove"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canSetAsDefault"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        v32 /*: any*/ ,
                                                                                        v33 /*: any*/ ,
                                                                                        v34 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v33 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appType"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v26 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNavigationItem",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                v35 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "isTmpRoute",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "hasBoardId",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "id",
                                                    "variableName": "boardId"
                                                }
                                            ],
                                            "kind": "LinkedField",
                                            "name": "jiraBoard",
                                            "plural": false,
                                            "selections": v39 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "condition": "hasBoardId",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "alias": "projectDataByKey",
                                                    "args": v15 /*: any*/ ,
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "jiraProjectByKey",
                                                    "plural": false,
                                                    "selections": v40 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "useProjectAri",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "condition": "hasBoardId",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "alias": "projectDataById",
                                                    "args": v28 /*: any*/ ,
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "jiraProject",
                                                    "plural": false,
                                                    "selections": v40 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "projectDataByKey",
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": v41 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "useProjectAri",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "projectDataById",
                                            "args": v28 /*: any*/ ,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProject",
                                            "plural": false,
                                            "selections": v41 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "82bac835e30354bbb78d1e441b23588d10ecb22afba1a3dd0aeb233947ff4165",
            "metadata": {},
            "name": "uiHorizontalSoftwareProjectNavQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$70d6cbbebfbb8fd5$var$node.hash = "742b31215677c39447507dac79ff03b0";
var $70d6cbbebfbb8fd5$export$2e2bcd8739ae039 = $70d6cbbebfbb8fd5$var$node;

});


parcelRegister("I0t4m", function(module, exports) {

$parcel$export(module.exports, "staticPlanSidebarNavigationResource", () => $481e4ad580b3240b$export$e7e6c1b9d8d5ea7);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $lB25E = parcelRequire("lB25E");

var $kZ7vG = parcelRequire("kZ7vG");
const $481e4ad580b3240b$var$getRouterKey = (match)=>{
    if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
    return 'none';
};
const $481e4ad580b3240b$export$e7e6c1b9d8d5ea7 = (0, $lB25E.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
    getKey: ({ match: match })=>$481e4ad580b3240b$var$getRouterKey(match),
    getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
        if (planId == null || scenarioId == null) return null;
        return (0, $kZ7vG.fetchPlanSidebarNavInfo)(planId, scenarioId);
    },
    maxAge: 300000
});

});
parcelRegister("kZ7vG", function(module, exports) {

$parcel$export(module.exports, "fetchPlanSidebarNavInfo", () => $ffd9df53dda0b988$export$a49729698cfc5310);

var $lRmyA = parcelRequire("lRmyA");
const $ffd9df53dda0b988$var$requestSideBarInfo = (planId, scenarioId)=>(0, $lRmyA.performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
const $ffd9df53dda0b988$export$a49729698cfc5310 = (planId, scenarioId)=>{
    if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
    if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
    return $ffd9df53dda0b988$var$requestSideBarInfo(planId, scenarioId);
};

});


parcelRegister("eJCK9", function(module, exports) {

$parcel$export(module.exports, "staticSidebarShortcutsResource", () => $9e1e6b174c3d84b9$export$4847c29b4786b3b4);

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $iVoS5 = parcelRequire("iVoS5");
const $9e1e6b174c3d84b9$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $9e1e6b174c3d84b9$export$4847c29b4786b3b4 = (0, $lB25E.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
    getKey: ({ match: match, query: query })=>$9e1e6b174c3d84b9$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $9e1e6b174c3d84b9$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const shortcuts = await (0, $iVoS5.fetchShortcuts)(projectKeyOrId);
        return shortcuts;
    },
    maxAge: 300000
});

});
parcelRegister("iVoS5", function(module, exports) {

$parcel$export(module.exports, "fetchShortcuts", () => $72b9eb1ede36e333$export$49d696bf2525d700);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");
const $72b9eb1ede36e333$export$49d696bf2525d700 = (projectKeyOrId)=>{
    try {
        return (0, $2OdyW.default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'fetchProjectShortcuts',
            packageName: 'jiraNavigationAppsResources'
        });
        throw error;
    }
};

});


parcelRegister("hawmT", function(module, exports) {

$parcel$export(module.exports, "navigationPlansVisibilityResource", () => $a93019de4376d1a2$export$fa475a9581133779);
$parcel$export(module.exports, "useNavigationPlansVisibility", () => $a93019de4376d1a2$export$4524245d4e74edb2);
$parcel$export(module.exports, "useNavigationViewPlansPermission", () => $a93019de4376d1a2$export$98eef08fd4586a4);
$parcel$export(module.exports, "useNavigationEditPlansPermission", () => $a93019de4376d1a2$export$525db876ed776e0d);
$parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", () => $a93019de4376d1a2$export$54805a2120a31ad0);

var $gUUjF = parcelRequire("gUUjF");

var $79xbN = parcelRequire("79xbN");

var $2OdyW = parcelRequire("2OdyW");

var $eIp1n = parcelRequire("eIp1n");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");

var $lB25E = parcelRequire("lB25E");

const $a93019de4376d1a2$export$fa475a9581133779 = (0, $lB25E.createResource)({
    type: (0, $b5f6b10e2be29709$export$9260ddb6dfeafd7b),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return false;
            const response = await (0, $2OdyW.default)(`${tenantContext.baseUrl}/rest/jpo/1.0/navigation/simple`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $b5f6b10e2be29709$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
        }
        return false;
    },
    maxAge: Infinity
});
const $a93019de4376d1a2$export$4524245d4e74edb2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    const appEditions = (0, $ab6rA.useAppEditions)();
    const jswEdition = (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), appEditions);
    let isVisible = false;
    if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
    if (isVisible && jswEdition === (0, $6WXNs.FREE_EDITION)) {
        const shouldHidePlans = (0, $79xbN.expVal)('hide_plans_tab_for_jira_free', 'shouldHidePlansTab', false);
        return [
            !shouldHidePlans
        ];
    }
    return [
        isVisible
    ];
};
const $a93019de4376d1a2$export$98eef08fd4586a4 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    let hasEditOrViewPermissions = false;
    if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
    return [
        hasEditOrViewPermissions
    ];
};
const $a93019de4376d1a2$export$525db876ed776e0d = ()=>{
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    let canEditPlans = false;
    if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
    return canEditPlans;
};
const $a93019de4376d1a2$export$54805a2120a31ad0 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    let isAdvancedRoadmapsTrial = false;
    if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
    return isAdvancedRoadmapsTrial;
};

});
const $b5f6b10e2be29709$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $b5f6b10e2be29709$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';


parcelRegister("cpkr0", function(module, exports) {

$parcel$export(module.exports, "checkApiKeyManagementKeysResource", () => $0913ae43ba61e45d$export$b16eaa5246afc9b6);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $kRdYM = parcelRequire("kRdYM");

var $jf8p7 = parcelRequire("jf8p7");


var $lB25E = parcelRequire("lB25E");

const $0913ae43ba61e45d$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, isTransitioning, appPermissions)=>{
    if (!isTransitioning || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
    return (0, $kRdYM.eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
};
const $0913ae43ba61e45d$export$b16eaa5246afc9b6 = ()=>(0, $lB25E.createResource)({
        type: (0, $be0f36e5e3d53287$export$5879151f0d972f18),
        getKey: ()=>'check-api-key-management-keys',
        getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const tenantInfo = await dependencies[0, $02315c431173f662$export$25ee35b01de9d734]?.promise;
            const isTransitioning = (0, $jf8p7.checkIsTransitioning)(tenantInfo);
            return $0913ae43ba61e45d$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, isTransitioning, appPermissions);
        },
        maxAge: Infinity,
        isBrowserOnly: true,
        depends: [
            (0, $02315c431173f662$export$25ee35b01de9d734)
        ]
    });

});
const $be0f36e5e3d53287$export$5879151f0d972f18 = 'EOC_CHECK_API_KEY';


parcelRegister("jlBE2", function(module, exports) {

$parcel$export(module.exports, "gicSmartFieldsFeatureResource", () => $4ec33ba6cfdbce95$export$ee94bb1f59b07e35);
$parcel$export(module.exports, "useIsSmartFieldsOptIn", () => $4ec33ba6cfdbce95$export$3870b1ff1b155c73);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $cm5m0 = parcelRequire("cm5m0");

var $lB25E = parcelRequire("lB25E");

const $4ec33ba6cfdbce95$export$ee94bb1f59b07e35 = (0, $lB25E.createResource)({
    type: (0, $af92d8ab297d74d2$export$6f0555de4f60e84e),
    getKey: ()=>(0, $af92d8ab297d74d2$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            const data = await (0, $cm5m0.userPreferenceAPI).get((0, $af92d8ab297d74d2$export$b94951a11282ae6a));
            if (!data) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false
            };
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If value has never been set, we expect a 404
            if (error.statusCode === 404) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false
            };
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'gicSmartFieldsFeatureResource',
                    packageName: (0, $af92d8ab297d74d2$export$b8b9d90f9e5bd72b),
                    teamName: 'deliveroo'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            hasUserOptedOut: false,
            hasUserDismissedReadMore: false
        };
    },
    maxAge: Number.MAX_VALUE
});
const $4ec33ba6cfdbce95$export$3870b1ff1b155c73 = ()=>{
    const { data: data, update: update, loading: loading } = (0, $lB25E.useResource)($4ec33ba6cfdbce95$export$ee94bb1f59b07e35);
    const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
    const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
    const dismissReadMore = (0, $eUqFw.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                hasUserDismissedReadMore: true
            }));
    }, [
        update
    ]);
    return {
        isSmartFieldsOptIn: loading ? null : currentOptInStatus,
        isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
        dismissReadMore: dismissReadMore,
        loading: loading
    };
};

});
const $af92d8ab297d74d2$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $af92d8ab297d74d2$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key'; // value is global for user
const $af92d8ab297d74d2$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $af92d8ab297d74d2$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';


parcelRegister("ellXt", function(module, exports) {

$parcel$export(module.exports, "gicOptInStatusResources", () => $d1ab65e118ce0b83$export$14c89b6b6a261524);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");

var $lB25E = parcelRequire("lB25E");

const $d1ab65e118ce0b83$export$14c89b6b6a261524 = (0, $lB25E.createResource)({
    type: (0, $937f75d7d64d5d05$export$fe522736b61f6709),
    getKey: ()=>'gic_optin_status',
    getData: async ()=>{
        let gicOptInStatus = null;
        try {
            gicOptInStatus = await (0, $lRmyA.performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.statusCode !== 404) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
        }
        return {
            gicOptInStatus: gicOptInStatus ?? {
                isEnabled: false
            }
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $937f75d7d64d5d05$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';


parcelRegister("h0Ytu", function(module, exports) {

$parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", () => $a8290ca1941fd80d$export$1b6468a6eb7d9b09);
$parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", () => $a8290ca1941fd80d$export$e21c345b2538e96e);

var $eUqFw = parcelRequire("eUqFw");

var $6G5mG = parcelRequire("6G5mG");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $lB25E = parcelRequire("lB25E");

var $058mG = parcelRequire("058mG");
const $a8290ca1941fd80d$export$1b6468a6eb7d9b09 = (0, $lB25E.createResource)({
    type: (0, $058mG.RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
    getKey: ()=>(0, $058mG.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
    getData: async ()=>{
        let modalViewCount = 0;
        try {
            const apiResult = await (0, $lRmyA.performGetRequest)((0, $058mG.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
            if ((0, $eI5EY.fg)('modern_issue_transition_enable_benefits_modal')) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(apiResult, 'value') || !(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(apiResult, 'benefitsModalValue')) {
                    const error = new Error('Invalid preference value');
                    (0, $guiFP.default)({
                        meta: {
                            id: 'issueTransitionChangeboardingPreferencesResource',
                            packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
                return {
                    numberOfTimesUserHasSeenChangeboarding: Number(apiResult.value) || 0,
                    benefitsModal: {
                        isDisabled: apiResult?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: apiResult?.benefitsModal?.nextDateToShowBenefitsModal || null
                    }
                };
            }
            if (typeof apiResult !== 'object' || !(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(apiResult, 'value')) {
                const error = new Error('Invalid preference value');
                (0, $guiFP.default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } else {
                modalViewCount = Number(apiResult.value);
                return {
                    numberOfTimesUserHasSeenChangeboarding: modalViewCount
                };
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) {
                if ((0, $eI5EY.fg)('modern_issue_transition_enable_benefits_modal')) return {
                    numberOfTimesUserHasSeenChangeboarding: 0,
                    benefitsModal: {
                        isDisabled: false,
                        nextDateToShowBenefitsModal: null
                    }
                };
                return {
                    numberOfTimesUserHasSeenChangeboarding: 0
                };
            }
            (0, $guiFP.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesResource',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            numberOfTimesUserHasSeenChangeboarding: modalViewCount,
            benefitsModal: {
                isDisabled: true,
                nextDateToShowBenefitsModal: null
            }
        };
    }
});
const $a8290ca1941fd80d$export$e21c345b2538e96e = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $lB25E.useResource)($a8290ca1941fd80d$export$1b6468a6eb7d9b09);
    const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $eUqFw.useState)(()=>{
        if ((0, $eI5EY.fg)('modern_issue_transition_enable_benefits_modal')) return {
            numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
            benefitsModal: {
                isDisabled: Boolean(data?.benefitsModal?.isDisabled),
                nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
            }
        };
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
        return 0, $058mG.USER_SEEN_CARDINALITY_UNKNOWN;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eUqFw.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $eUqFw.useState)('not started');
    const updateIssueTranstitionChangeboardingPreferences = (0, $eUqFw.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        const body = typeof updates !== 'number' && (0, $eI5EY.fg)('modern_issue_transition_enable_benefits_modal') ? {
            value: updates?.numberOfTimesUserHasSeenChangeboarding,
            benefitsModal: {
                isDisabled: updates?.benefitsModal?.isDisabled,
                nextDateToShowBenefitsModal: updates?.benefitsModal?.nextDateToShowBenefitsModal
            }
        } : {
            value: updates
        };
        try {
            await (0, $lRmyA.performPutRequest)((0, $058mG.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                body: JSON.stringify(body)
            });
            setResponseStatusPut('success');
            let updateData;
            if (typeof updates !== 'number' && (0, $eI5EY.fg)('modern_issue_transition_enable_benefits_modal')) updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates?.numberOfTimesUserHasSeenChangeboarding,
                benefitsModal: {
                    isDisabled: updates?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(updates?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            };
            if (typeof updates === 'number') updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates
            };
            update(()=>updateData);
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if ((0, $eI5EY.fg)('modern_issue_transition_enable_benefits_modal')) {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference({
                numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                benefitsModal: {
                    isDisabled: data?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            });
            return;
        }
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.numberOfTimesUserHasSeenChangeboarding,
        data?.benefitsModal?.isDisabled,
        data?.benefitsModal?.nextDateToShowBenefitsModal
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionChangeboardingPreference
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTranstitionChangeboardingPreferences
        }
    };
};

});
parcelRegister("058mG", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", () => $0ce11008f44b5e39$export$d66d4b761db3d20f);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", () => $0ce11008f44b5e39$export$79fd70b908f71ddd);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", () => $0ce11008f44b5e39$export$e5007258addba8aa);
$parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", () => $0ce11008f44b5e39$export$91880069e7e73b18);
$parcel$export(module.exports, "DURATION_IN_DAYS_DEFAULT", () => $0ce11008f44b5e39$export$9ccdfd91f2512a27);
const $0ce11008f44b5e39$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
const $0ce11008f44b5e39$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
const $0ce11008f44b5e39$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
const $0ce11008f44b5e39$export$91880069e7e73b18 = -1;
const $0ce11008f44b5e39$export$9ccdfd91f2512a27 = 14;

});


parcelRegister("6XOSh", function(module, exports) {

$parcel$export(module.exports, "issueTransitionOptInStatusResource", () => $839ddb0b122518f6$export$5fbcf4d7a6d9c477);
$parcel$export(module.exports, "useIssueTransitionLabsOptIn", () => $839ddb0b122518f6$export$bc11d4816053db5c);

var $eUqFw = parcelRequire("eUqFw");

var $dfBCt = parcelRequire("dfBCt");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $lB25E = parcelRequire("lB25E");


var $ZKxj9 = parcelRequire("ZKxj9");
/*
 * API Contract: https://hello.atlassian.net/wiki/spaces/JIE/pages/2983777277/Issue+Transition+Jira+Labs+Toggle+for+Legacy+Experience+Backend+API#API-Contract
 */ const $839ddb0b122518f6$var$fetchGetIssueTransitionOptInState = async ()=>(0, $lRmyA.performGetRequest)((0, $62811791007d8b59$export$466b1c60da56c8ca));
const $839ddb0b122518f6$export$5fbcf4d7a6d9c477 = (0, $lB25E.createResource)({
    type: (0, $62811791007d8b59$export$eb01e12fc3db65c0),
    getKey: ()=>(0, $62811791007d8b59$export$a964df7bc15d81e),
    getData: async ()=>{
        let issueTransitionOptInStatus = null;
        const isModernIssueTransitionSRBCohort = (0, $eI5EY.fg)('issue-transition-customisation-for-srb') || (0, $dfBCt.isFedRamp)();
        const isModernITSRenderEnabled = (0, $1ybV0.ff)('render-modern-issue-transition_cxt0z') || (0, $dfBCt.isFedRamp)();
        if (!isModernITSRenderEnabled) return {
            issueTransitionOptInStatus: {
                isEnabled: false,
                expiryTime: -1
            }
        };
        if (isModernIssueTransitionSRBCohort) return {
            issueTransitionOptInStatus: {
                isEnabled: true
            }
        };
        try {
            issueTransitionOptInStatus = await $839ddb0b122518f6$var$fetchGetIssueTransitionOptInState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'issueTransitionOptInStatusResource',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, $ZKxj9.default)()
        };
    },
    maxAge: Number.MAX_VALUE
});
const $839ddb0b122518f6$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, $lRmyA.performPutRequest)((0, $62811791007d8b59$export$466b1c60da56c8ca), {
        body: JSON.stringify(payload)
    });
const $839ddb0b122518f6$export$bc11d4816053db5c = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $lB25E.useResource)($839ddb0b122518f6$export$5fbcf4d7a6d9c477);
    const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $eUqFw.useState)(()=>{
        if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
        return (0, $ZKxj9.default)();
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eUqFw.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $eUqFw.useState)('not started');
    const updateIssueTransitionOptInStatus = (0, $eUqFw.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        try {
            const updatedPreferences = await $839ddb0b122518f6$var$fetchModifyIssueTransitionOptInState(updates);
            setResponseStatusPut('success');
            update(()=>({
                    issueTransitionOptInStatus: updatedPreferences
                }));
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                error: err,
                meta: {
                    id: 'issueTransitionOptInStatusUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.issueTransitionOptInStatus) {
            setResponseStatusGet('success');
            setIssueTransitionOptInState(data.issueTransitionOptInStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.issueTransitionOptInStatus
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionLabsOptInState
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTransitionOptInStatus
        }
    };
};

});
const $62811791007d8b59$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $62811791007d8b59$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $62811791007d8b59$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $62811791007d8b59$export$880a78695d76498e = 8;

parcelRegister("ZKxj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $99072b8c90c9105d$export$2e2bcd8739ae039);

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");
const $99072b8c90c9105d$var$FF_POSSIBLE_VALUES = [
    'OFF',
    'BY_DEFAULT_USER_OPT_IN',
    'BY_DEFAULT_USER_OPT_OUT'
];
const $99072b8c90c9105d$var$getDefaultIssueTransitionLabsOptInState = ()=>{
    const isModernITSRenderEnabled = (0, $1ybV0.ff)('render-modern-issue-transition_cxt0z') || (0, $dfBCt.isFedRamp)();
    if (!isModernITSRenderEnabled) return {
        isEnabled: false,
        expiryTime: -1
    };
    const isModernIssueTransitionSRBCohort = (0, $eI5EY.fg)('issue-transition-customisation-for-srb') || (0, $dfBCt.isFedRamp)();
    if (isModernIssueTransitionSRBCohort) return {
        isEnabled: true
    };
    const isExplicitlyUseTurnedOff = (0, $1ybV0.getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', $99072b8c90c9105d$var$FF_POSSIBLE_VALUES) === 'BY_DEFAULT_USER_OPT_OUT';
    return isExplicitlyUseTurnedOff ? {
        isEnabled: false,
        expiryTime: -1
    } : {
        isEnabled: true
    };
};
var $99072b8c90c9105d$export$2e2bcd8739ae039 = $99072b8c90c9105d$var$getDefaultIssueTransitionLabsOptInState;

});


parcelRegister("l6RYU", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", () => $694329614259616a$export$fa191d7d71460a98);

var $e91YZ = parcelRequire("e91YZ");

var $lRmyA = parcelRequire("lRmyA");

var $lB25E = parcelRequire("lB25E");

const $694329614259616a$export$fa191d7d71460a98 = (0, $lB25E.createResource)({
    type: (0, $05abdcb8189088ad$export$fd4fc70ec71927d1),
    getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
    getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
        const defaultValue = {
            enabled: true
        };
        if (!licensedProducts || !licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
        const { enabled: enabled } = await (0, $lRmyA.performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
        return {
            enabled: enabled
        };
    },
    maxAge: Infinity
});

});
const $05abdcb8189088ad$export$fd4fc70ec71927d1 = 'AUTOMATION_IS_LEGACY_ENABLED';


parcelRegister("gF5SK", function(module, exports) {

$parcel$export(module.exports, "newIssueViewTransitionLockInStatusResource", () => $43a0964905230dcb$export$babbf5bfbc4d268c);
$parcel$export(module.exports, "DEFAULT_TO_OLD_ISSUE_VIEW", () => $43a0964905230dcb$export$f269c0bf10ad77e2);
$parcel$export(module.exports, "useNewIssueViewLockedInStatus", () => $43a0964905230dcb$export$3b09097f2a423abd);

var $lB25E = parcelRequire("lB25E");


const $43a0964905230dcb$export$babbf5bfbc4d268c = (0, $lB25E.createResource)({
    type: (0, $bf1b1f026fde1439$export$fdb92aeacda42553),
    getKey: ()=>'newIssueViewTransitionLockingStatus',
    getDataLoader: ()=>(parcelRequire("jEcQ4")),
    maxAge: Number.MAX_VALUE
});
const $43a0964905230dcb$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $43a0964905230dcb$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $43a0964905230dcb$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';
const $43a0964905230dcb$export$3b09097f2a423abd = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $lB25E.useResource)($43a0964905230dcb$export$babbf5bfbc4d268c);

});
const $bf1b1f026fde1439$export$fdb92aeacda42553 = 'NEW_ISSUE_VIEW_LOCK_IN_STATUS';

parcelRegister("jEcQ4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4VHyJ").then(()=>parcelRequire('e1dkv'));

});


parcelRegister("fKYF0", function(module, exports) {

$parcel$export(module.exports, "persistentIssueCreateModalViewResource", () => $9179d1c8af5062b2$export$266a039a005e8314);

var $lB25E = parcelRequire("lB25E");


const $9179d1c8af5062b2$export$266a039a005e8314 = (0, $lB25E.createResource)({
    type: (0, $9cf0ecd2babadcc5$export$f658cfd591eb583e),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("75Uv8")),
    maxAge: Number.MAX_VALUE
});

});
const $9cf0ecd2babadcc5$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $9cf0ecd2babadcc5$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $9cf0ecd2babadcc5$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';

parcelRegister("75Uv8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8V0MZ").then(()=>parcelRequire('9HgCP'));

});


parcelRegister("grsJA", function(module, exports) {

$parcel$export(module.exports, "rovoEntitlementResource", () => $75c646b84cc2b8ad$export$a0974cf24d16bc5d);
$parcel$export(module.exports, "useRovoEntitlementResource", () => $75c646b84cc2b8ad$export$b9cee3799212b85a);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $lB25E = parcelRequire("lB25E");

const $75c646b84cc2b8ad$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
const $75c646b84cc2b8ad$var$fetchRovoEntitlement = async (cloudId)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $3fb9e0f992806b04$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        // handle GraphQL errors
        if (response.errors) (0, $guiFP.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            isRovoEnabled: response.data?.jira?.isRovoEnabled ?? null
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        isRovoEnabled: null
    };
};
const $75c646b84cc2b8ad$export$a0974cf24d16bc5d = (0, $lB25E.createResource)({
    type: $75c646b84cc2b8ad$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getKey: ()=>$75c646b84cc2b8ad$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$75c646b84cc2b8ad$var$fetchRovoEntitlement(cloudId),
    maxAge: Infinity
});
const $75c646b84cc2b8ad$export$b9cee3799212b85a = ()=>(0, $lB25E.useResource)($75c646b84cc2b8ad$export$a0974cf24d16bc5d);

});
const $3fb9e0f992806b04$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
  }
}
`;


parcelRegister("3vlQh", function(module, exports) {

$parcel$export(module.exports, "incidentsInitialPageChecksResource", () => $51abc3777a1ecce4$export$b2b94ce8ba590cc8);
$parcel$export(module.exports, "incidentsCustomFieldIdResource", () => $51abc3777a1ecce4$export$e81d7afef87ae597);
$parcel$export(module.exports, "incidentExperimentTraitResource", () => $51abc3777a1ecce4$export$31c6945718067be3);

var $lB25E = parcelRequire("lB25E");


const $51abc3777a1ecce4$export$b2b94ce8ba590cc8 = (0, $lB25E.createResource)({
    type: (0, $8c440df88740d3a4$export$9018fdf9116edd9b),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("1RW2T"))
});

const $51abc3777a1ecce4$export$e81d7afef87ae597 = (0, $lB25E.createResource)({
    type: (0, $8c440df88740d3a4$export$508a7d8e5c6b1bf),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("jiByF"))
});

const $51abc3777a1ecce4$export$31c6945718067be3 = (0, $lB25E.createResource)({
    type: (0, $8c440df88740d3a4$export$1d954e05e596a51e),
    getKey: ()=>'incident_experiment_traits',
    getDataLoader: ()=>(parcelRequire("bKVfu")),
    maxAge: Number.MAX_SAFE_INTEGER
});

});
const $8c440df88740d3a4$export$9018fdf9116edd9b = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $8c440df88740d3a4$export$508a7d8e5c6b1bf = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $8c440df88740d3a4$export$1d954e05e596a51e = 'INCIDENT_EXPERIMENT_TRAITS';

parcelRegister("1RW2T", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("a5Zg4").then(()=>parcelRequire('dJRnz'));

});

parcelRegister("jiByF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kb1Sj").then(()=>parcelRequire('gZWJg'));

});

parcelRegister("bKVfu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8856W").then(()=>parcelRequire('8XkTQ'));

});


parcelRegister("4uxD3", function(module, exports) {

$parcel$export(module.exports, "userHomepageResource", () => $08039d73d4df766b$export$16320dd0d1e6c145);

var $lRmyA = parcelRequire("lRmyA");

var $lB25E = parcelRequire("lB25E");

const $08039d73d4df766b$export$16320dd0d1e6c145 = (0, $lB25E.createResource)({
    type: (0, $1af1518206a530c1$export$2026a6db44b15de7),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { baseUrl: baseUrl } })=>{
        const { homepagePreference: homepagePreference } = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/internal/3/homepage/`);
        return {
            homepagePreference: homepagePreference
        };
    },
    maxAge: Infinity
});

});
const $1af1518206a530c1$export$2026a6db44b15de7 = 'USER_HOMEPAGE';



parcelRegister("dgH3j", function(module, exports) {

$parcel$export(module.exports, "LazyNotFoundErrorPage", () => $a19888271aae3277$export$57c5c0b5a0cdb5b7);
$parcel$export(module.exports, "default", () => $a19888271aae3277$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $a19888271aae3277$export$57c5c0b5a0cdb5b7 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("acWud")), {
    moduleId: "./src/packages/spa-apps/error-pages/not-found/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a19888271aae3277$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a19888271aae3277$export$57c5c0b5a0cdb5b7,
        pageId: "errors-404",
        shouldShowSpinner: false
    });

});
parcelRegister("59o4i", function(module, exports) {

$parcel$export(module.exports, "LazyPage", () => $c08c786619b91fbf$export$a18c9c3dd309b8e6);

var $eUqFw = parcelRequire("eUqFw");

var $foc4i = parcelRequire("foc4i");

var $gUUjF = parcelRequire("gUUjF");

var $gGtKh = parcelRequire("gGtKh");

var $10fdS = parcelRequire("10fdS");

var $3dxBh = parcelRequire("3dxBh");

var $iJHZm = parcelRequire("iJHZm");
const $c08c786619b91fbf$var$LOCATION = 'lazy-page';
const $c08c786619b91fbf$export$fb85bbdbfb3e6869 = ()=>null;
const $c08c786619b91fbf$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const Skeleton = route.skeleton || (shouldShowSpinner ? (0, $foc4i.default) : $c08c786619b91fbf$export$fb85bbdbfb3e6869);
    (0, $eUqFw.useEffect)(()=>{
        if (route.isRedirect) (0, $gUUjF.default).safeWarnWithoutCustomerData($c08c786619b91fbf$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazy_page_redirect",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Page, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dxBh.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazy_page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Page, null))));
};

});
parcelRegister("foc4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a5746f64449d35$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $apShl = parcelRequire("apShl");
function $e1a5746f64449d35$export$2e2bcd8739ae039({ testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "legacy-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1a5746f64449d35$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1a5746f64449d35$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large",
        testId: testId
    }))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e1a5746f64449d35$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $e1a5746f64449d35$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wpz1h6o",
            __cmplp.className
        ])
    });
});

});


parcelRegister("acWud", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("fNhrE")
]).then(()=>parcelRequire('a7YYz'));

});


parcelRegister("7nM1S", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("godxh")
]).then(()=>parcelRequire('aaWUF'));

});

parcelRegister("go9vj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("9GJax")
]).then(()=>parcelRequire('c2Xkt'));

});

parcelRegister("1toPN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("bdzSn")
]).then(()=>parcelRequire('k4ELZ'));

});

parcelRegister("6ddy1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8ODSr").then(()=>parcelRequire('i7Ah9'));

});

parcelRegister("drCAA", function(module, exports) {

$parcel$export(module.exports, "advancedRoadmapsReduxStoreStateResource", () => $262a5ef8a7385098$export$6ca262338f199e4b);
$parcel$export(module.exports, "advancedRoadmapsScenarioIdResource", () => $262a5ef8a7385098$export$aec847b4ce72891);
$parcel$export(module.exports, "advancedRoadmapsPlanPageInitialChecksResource", () => $262a5ef8a7385098$export$7431e46c7ad56c3d);
$parcel$export(module.exports, "advancedRoadmapsPlanReportPageInitialChecksResource", () => $262a5ef8a7385098$export$bf0c5395c73cc255);
$parcel$export(module.exports, "advancedRoadmapsLastVisitedProgramBoardIdResource", () => $262a5ef8a7385098$export$f5b159e1fb19e04e);

var $ldoFd = parcelRequire("ldoFd");

var $lRmyA = parcelRequire("lRmyA");

var $lB25E = parcelRequire("lB25E");

const $262a5ef8a7385098$export$6ca262338f199e4b = (0, $lB25E.createResource)({
    type: 'ADVANCED_ROADMAPS_REDUX_STORE_STATE',
    getKey: ({ match: match })=>{
        const { params: params, query: query } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        if (params.reportId != null) return params.reportId;
        if (query.r != null) return query.r;
        throw new Error('Unable to get resource key for ADVANCED_ROADMAPS_REDUX_STORE_STATE.');
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getData: async ()=>undefined,
    isBrowserOnly: true,
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $262a5ef8a7385098$export$aec847b4ce72891 = (0, $lB25E.createResource)({
    type: (0, $cf932f69308616f2$export$a0893d695ebee984),
    getKey: ({ query: query })=>`scenarioId_${query.id}`,
    getData: async ({ query: query })=>{
        const planId = query.id;
        const { id: id } = await (0, $lRmyA.performGetRequest)(`/rest/jpo/1.0/scenarios/${planId}`);
        return {
            scenarioId: id
        };
    },
    maxAge: 0
});
const $262a5ef8a7385098$export$7431e46c7ad56c3d = (0, $lB25E.createResource)({
    type: (0, $cf932f69308616f2$export$68390102872336b6),
    getKey: ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        return `planPageInitialChecks_${planId != null ? planId : ''}_${scenarioId != null ? scenarioId : ''}`;
    },
    getData: async ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"null"' and '"undefined"' have no overlap.
        if (planId == null || planId === 'null' && planId === 'undefined' && planId === '') throw new Error('Plan cannot be loaded without a planId');
        let url = `/rest/jpo/1.0/plans/${planId}/checks`;
        if (scenarioId != null && scenarioId !== 'null' && scenarioId !== 'undefined' && scenarioId !== '') url = `${url}?sid=${scenarioId}`;
        const response = await (0, $lRmyA.performGetRequest)(url);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $262a5ef8a7385098$export$bf0c5395c73cc255 = (0, $lB25E.createResource)({
    type: (0, $cf932f69308616f2$export$a00e869cafd63140),
    getKey: ({ match: match })=>`planReportPageInitialChecks_${match.params.reportId == null ? '' : match.params.reportId}`,
    getData: async ({ match: match })=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const initialPlanChecksPromise = window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        delete window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        if (initialPlanChecksPromise) {
            const response = await initialPlanChecksPromise;
            return response;
        }
        const { reportId: reportId } = match.params;
        const response = await (0, $lRmyA.performGetRequest)(`/rest/jpo/1.0/reportinfo/generic/${reportId == null ? '' : reportId}/checks`);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $262a5ef8a7385098$export$f5b159e1fb19e04e = (0, $lB25E.createResource)({
    type: (0, $cf932f69308616f2$export$179a0d35e95a4d61),
    getKey: ({ query: query, match: match })=>`lastVisitedProgramBoardId_${query.id}_${match.params.planId}_${match.params.scenarioId}`,
    getData: async ({ match: match })=>{
        // Sometimes currentPlanId isn't yet ready - we retry a few times to check if it has loaded in before making the request
        const RETRIES = 3;
        const DELAY = 500;
        const attemptFetch = async (remainingRetries)=>{
            const currentPlanId = match.params.planId;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(currentPlanId)) {
                const defaultBoardIdResponse = await (0, $lRmyA.performGetRequest)(`/rest/jpo/2.0/plans/${currentPlanId}/increments/default`);
                if (defaultBoardIdResponse === null) return {
                    boardId: null
                };
                const { id: id } = defaultBoardIdResponse;
                return {
                    boardId: id
                };
            }
            if (remainingRetries > 0) {
                await new Promise((resolve)=>setTimeout(resolve, DELAY));
                return attemptFetch(remainingRetries - 1);
            }
            throw new Error('Attempted to get the last visited program board of a plan without a plan id after multiple retries.');
        };
        return attemptFetch(RETRIES);
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});

});
const $cf932f69308616f2$export$68390102872336b6 = 'ADVANCED_ROADMAPS_PLAN_INITIAL_CHECKS';
const $cf932f69308616f2$export$a00e869cafd63140 = 'ADVANCED_ROADMAPS_REPORT_INITIAL_CHECKS';
const $cf932f69308616f2$export$a0893d695ebee984 = 'ADVANCED_ROADMAPS_SCENARIO_ID';
const $cf932f69308616f2$export$179a0d35e95a4d61 = 'ADVANCED_ROADMAPS_LAST_VISITED_PROGRAM_BOARD_ID';


parcelRegister("2nflD", function(module, exports) {

$parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", () => $931c853fe15a57ee$export$f9061628830b5175);
$parcel$export(module.exports, "fetchAdvancedRoadmapsSummaryData", () => $931c853fe15a57ee$export$2dfe99460dae6bc6);

var $2OdyW = parcelRequire("2OdyW");

var $lB25E = parcelRequire("lB25E");

var $lWLQU = parcelRequire("lWLQU");
// we have to use location.search as we want to get params dynamically and rrr doesn't support it
// more info: https://atlassian-labs.github.io/react-resource-router/#/resources/usage?id=accessing-resource-state-for-another-route-or-url
const $931c853fe15a57ee$var$getQueryParams = (routerQuery)=>{
    if (typeof window !== 'undefined') return Object.fromEntries(new URLSearchParams(window.location.search));
    return routerQuery;
};
const $931c853fe15a57ee$export$f9061628830b5175 = (0, $lB25E.createResource)({
    type: 'ADVANCED_ROADMAPS_SUMMARY_DATA',
    getKey: ({ match: match })=>{
        const { params: params } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        // Just return fallback string if on a page that doesn't have a planId or scenarioId
        return 'none';
    },
    getData: async ({ match: match, query: query })=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.__ARJ_SUMMARY_PAGE_PROMISE__) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const response = window.__ARJ_SUMMARY_PAGE_PROMISE__;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__ARJ_SUMMARY_PAGE_PROMISE__ = null;
            return response;
        }
        const { params: params } = match;
        return $931c853fe15a57ee$export$2dfe99460dae6bc6(params, query, (0, $lWLQU.AVAILABLE_CHARTS));
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $931c853fe15a57ee$export$2dfe99460dae6bc6 = async (params, query, chartTypes)=>{
    if (params.planId == null) throw new Error('Unable to get fetch data for ADVANCED_ROADMAPS_SUMMARY_DATA. planId is not defined');
    const { startDate: startDate, endDate: endDate } = $931c853fe15a57ee$var$getQueryParams(query);
    const customDateRangeParams = startDate && endDate ? {
        startDate: startDate,
        endDate: endDate
    } : {};
    const data = await (0, $2OdyW.default)('/rest/jpo/1.0/summary/data', {
        method: 'POST',
        body: JSON.stringify({
            planId: params.planId,
            scenarioId: params.scenarioId,
            chartTypes: chartTypes,
            ...customDateRangeParams
        })
    });
    return data;
};

});
parcelRegister("lWLQU", function(module, exports) {

$parcel$export(module.exports, "CHART_TYPES", () => $a9c3b544ebce997d$export$3251435144ca69e2);
$parcel$export(module.exports, "AVAILABLE_CHARTS", () => $a9c3b544ebce997d$export$79cf9c14f738d70b);
$parcel$export(module.exports, "SCHEDULING_MODES", () => $a9c3b544ebce997d$export$92daf59e30346cd2);
$parcel$export(module.exports, "CAPACITY_UNIT", () => $a9c3b544ebce997d$export$494e761f17fc60a9);
$parcel$export(module.exports, "SPRINT_STATE", () => $a9c3b544ebce997d$export$38e437924c2adbda);
const $a9c3b544ebce997d$export$3251435144ca69e2 = {
    statusCategory: 'STATUS_CATEGORY',
    issueProgress: 'ISSUE_PROGRESS',
    teamProgress: 'TEAM_PROGRESS',
    teamCapacity: 'TEAM_CAPACITY',
    blockers: 'BLOCKERS',
    highestPriority: 'HIGHEST_PRIORITY',
    unassignedIssues: 'UNASSIGNED_ISSUES',
    overlappingBlockers: 'OVERLAPPING_BLOCKERS',
    overdue: 'OVERDUE'
};
const $a9c3b544ebce997d$export$79cf9c14f738d70b = [
    $a9c3b544ebce997d$export$3251435144ca69e2.statusCategory,
    $a9c3b544ebce997d$export$3251435144ca69e2.issueProgress,
    $a9c3b544ebce997d$export$3251435144ca69e2.teamProgress,
    $a9c3b544ebce997d$export$3251435144ca69e2.teamCapacity,
    $a9c3b544ebce997d$export$3251435144ca69e2.blockers,
    $a9c3b544ebce997d$export$3251435144ca69e2.highestPriority,
    $a9c3b544ebce997d$export$3251435144ca69e2.unassignedIssues,
    $a9c3b544ebce997d$export$3251435144ca69e2.overlappingBlockers,
    $a9c3b544ebce997d$export$3251435144ca69e2.overdue
];
const $a9c3b544ebce997d$export$92daf59e30346cd2 = {
    SCRUM: 'Scrum',
    KANBAN: 'Kanban'
};
const $a9c3b544ebce997d$export$494e761f17fc60a9 = {
    HOURS: 'HOURS',
    POINTS: 'STORY_POINTS',
    DAYS: 'DAYS'
};
const $a9c3b544ebce997d$export$38e437924c2adbda = {
    CLOSED: 'CLOSED',
    ACTIVE: 'ACTIVE',
    FUTURE: 'FUTURE'
};

});


parcelRegister("692Sf", function(module, exports) {

$parcel$export(module.exports, "softwareAdvancedRoadmapsRoute", () => $d88229dbc347aa09$export$21d57208bfbf7e92);
$parcel$export(module.exports, "softwarePlanDependenciesRoute", () => $d88229dbc347aa09$export$ad8296aa5394f696);
$parcel$export(module.exports, "softwarePlanSummaryRoute", () => $d88229dbc347aa09$export$25a8cf27557a612d);
$parcel$export(module.exports, "softwarePlanCalendarRoute", () => $d88229dbc347aa09$export$ca4c39d60ec156a2);
$parcel$export(module.exports, "softwarePlanReleasesRoute", () => $d88229dbc347aa09$export$850236b64b0aa28b);
$parcel$export(module.exports, "softwarePlanTimelineRoute", () => $d88229dbc347aa09$export$61abeb6a03d23dd3);
$parcel$export(module.exports, "softwarePlanSettingsPermissionsRoute", () => $d88229dbc347aa09$export$6734c29372722a5e);
$parcel$export(module.exports, "softwarePlanSettingsSavedViewsRoute", () => $d88229dbc347aa09$export$a0fec30f475e8756);
$parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRoute", () => $d88229dbc347aa09$export$3d54c48a91a178c0);
$parcel$export(module.exports, "softwarePlanSettingsPlanInfoRoute", () => $d88229dbc347aa09$export$76e6bdc959f6fa97);
$parcel$export(module.exports, "softwarePlanSettingsSchedulingRoute", () => $d88229dbc347aa09$export$a215ef374dd2a8a9);
$parcel$export(module.exports, "softwarePlanSettingsScenariosRoute", () => $d88229dbc347aa09$export$d32efeefb944c6b7);
$parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRoute", () => $d88229dbc347aa09$export$e44088b2cc0206cf);
$parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRoute", () => $d88229dbc347aa09$export$2634cd63c73f7a35);
$parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRoute", () => $d88229dbc347aa09$export$358b0ca69a4bd731);
$parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRoute", () => $d88229dbc347aa09$export$fa18324265e4400c);
$parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRoute", () => $d88229dbc347aa09$export$ab61883f74eb27c2);
$parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRoute", () => $d88229dbc347aa09$export$8b77532ba9798e64);
$parcel$export(module.exports, "softwarePlanTeamsRoute", () => $d88229dbc347aa09$export$fc66f5c0de18ddc7);
$parcel$export(module.exports, "softwareAdvancedRoadmaps1Route", () => $d88229dbc347aa09$export$a3686c51bf984ef9);
$parcel$export(module.exports, "softwareAdvancedRoadmapsRedirectRoute", () => $d88229dbc347aa09$export$cc2401df741549fe);
$parcel$export(module.exports, "softwareAdvancedRoadmaps3Route", () => $d88229dbc347aa09$export$bd0ed90cfd1c0a55);
$parcel$export(module.exports, "softwareAdvancedRoadmapsRedirect1Route", () => $d88229dbc347aa09$export$264157b237e791ea);
$parcel$export(module.exports, "softwareAdvancedRoadmaps5Route", () => $d88229dbc347aa09$export$158bfed3a17a3f80);
$parcel$export(module.exports, "softwareAdvancedRoadmapsSetupRoute", () => $d88229dbc347aa09$export$442daaf7ae9abf13);
$parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRoute", () => $d88229dbc347aa09$export$38c76ea9ddc85b3);

var $exb0h = parcelRequire("exb0h");


const $d88229dbc347aa09$export$21d57208bfbf7e92 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
    path: '/jira/plans/:planId/scenarios/:scenarioId'
};
const $d88229dbc347aa09$export$ad8296aa5394f696 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES),
    path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies'
};
const $d88229dbc347aa09$export$25a8cf27557a612d = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY),
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary'
};
const $d88229dbc347aa09$export$ca4c39d60ec156a2 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR),
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar'
};
const $d88229dbc347aa09$export$850236b64b0aa28b = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_RELEASES),
    path: '/jira/plans/:planId/scenarios/:scenarioId/releases'
};
const $d88229dbc347aa09$export$61abeb6a03d23dd3 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE),
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline'
};
const $d88229dbc347aa09$export$6734c29372722a5e = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PERMISSIONS),
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/permissions'
};
const $d88229dbc347aa09$export$a0fec30f475e8756 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS),
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/saved-views'
};
const $d88229dbc347aa09$export$3d54c48a91a178c0 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS),
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/program-boards'
};
const $d88229dbc347aa09$export$76e6bdc959f6fa97 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PLAN_INFO),
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/plan-info'
};
const $d88229dbc347aa09$export$a215ef374dd2a8a9 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCHEDULING),
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scheduling'
};
const $d88229dbc347aa09$export$d32efeefb944c6b7 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCENARIOS),
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scenarios'
};
const $d88229dbc347aa09$export$e44088b2cc0206cf = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER),
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/auto-scheduler'
};
const $d88229dbc347aa09$export$2634cd63c73f7a35 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS),
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/custom-fields'
};
const $d88229dbc347aa09$export$358b0ca69a4bd731 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES),
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/exclusion-rules'
};
const $d88229dbc347aa09$export$fa18324265e4400c = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES),
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/issue-sources'
};
const $d88229dbc347aa09$export$ab61883f74eb27c2 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE),
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/find-your-issue'
};
const $d88229dbc347aa09$export$8b77532ba9798e64 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES),
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/removed-issues'
};
const $d88229dbc347aa09$export$fc66f5c0de18ddc7 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_TEAMS),
    path: '/jira/plans/:planId/scenarios/:scenarioId/teams'
};
const $d88229dbc347aa09$export$a3686c51bf984ef9 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
    path: '/jira/plans/:planId(\\d+)'
};
const $d88229dbc347aa09$export$cc2401df741549fe = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT),
    path: '/secure/PortfolioPlanView.jspa'
};
const $d88229dbc347aa09$export$bd0ed90cfd1c0a55 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
    path: '/jira/plans/reports/:reportId'
};
const $d88229dbc347aa09$export$264157b237e791ea = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT),
    path: '/secure/PortfolioReportView.jspa'
};
const $d88229dbc347aa09$export$158bfed3a17a3f80 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
    path: '/jira/plans/:planId/scenarios/:scenarioId/export'
};
const $d88229dbc347aa09$export$442daaf7ae9abf13 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP),
    path: '/jira/plans/:planId/setup'
};
const $d88229dbc347aa09$export$38c76ea9ddc85b3 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT),
    path: '/secure/PortfolioGettingStarted.jspa'
};

});

parcelRegister("78UVv", function(module, exports) {

$parcel$export(module.exports, "planIncrementsRoute", () => $52eda9e1a201d846$export$d0986e4bd9568b30);
$parcel$export(module.exports, "planIncrementRoute", () => $52eda9e1a201d846$export$ef33a75556fde209);
$parcel$export(module.exports, "archivedPlansRoute", () => $52eda9e1a201d846$export$29647353386ad146);
$parcel$export(module.exports, "trashedPlansRoute", () => $52eda9e1a201d846$export$b1d2299a57fca83a);
$parcel$export(module.exports, "trashedPlanDirectLinkRoute", () => $52eda9e1a201d846$export$1a9edb72cd49ca79);
$parcel$export(module.exports, "arjSettingsFinancialYearPageRoute", () => $52eda9e1a201d846$export$7208300f00a36a5f);

var $exb0h = parcelRequire("exb0h");
const $52eda9e1a201d846$export$d0986e4bd9568b30 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS),
    path: '/jira/plans/:planId/scenarios/:scenarioId/program'
};
const $52eda9e1a201d846$export$ef33a75556fde209 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT),
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId'
};
const $52eda9e1a201d846$export$29647353386ad146 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_ARCHIVED_PLANS_DIRECTORY),
    path: '/jira/plans/settings/archive'
};
const $52eda9e1a201d846$export$b1d2299a57fca83a = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_TRASH_PLANS_DIRECTORY),
    path: '/jira/plans/settings/trash'
};
const $52eda9e1a201d846$export$1a9edb72cd49ca79 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK),
    path: '/jira/plans/plan-trashed',
    exact: true
};
const $52eda9e1a201d846$export$7208300f00a36a5f = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR),
    path: '/jira/plans/settings/financial-year'
};

});

parcelRegister("5FB31", function(module, exports) {

$parcel$export(module.exports, "softwareArjSettingsDependenciesRoute", () => $f4d7ea4ec84815d2$export$e657c8aeaaf0932c);
$parcel$export(module.exports, "softwareArjSettingsDependenciesRedirectRoute", () => $f4d7ea4ec84815d2$export$b55de156ac5f7c1b);
$parcel$export(module.exports, "softwareArjSettingsLoadingLimitsRoute", () => $f4d7ea4ec84815d2$export$21eaa019c724fc9a);
$parcel$export(module.exports, "softwareArjSettingsLoadingLimitsRedirectRoute", () => $f4d7ea4ec84815d2$export$c72a1b9971af07d9);
$parcel$export(module.exports, "softwareArjSettingsPermissionsRoute", () => $f4d7ea4ec84815d2$export$6372897c47d731c0);
$parcel$export(module.exports, "softwareArjSettingsPermissionsRedirectRoute", () => $f4d7ea4ec84815d2$export$4523847db2f1a42e);

var $exb0h = parcelRequire("exb0h");
const $f4d7ea4ec84815d2$export$e657c8aeaaf0932c = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES),
    path: '/jira/plans/settings/dependencies'
};
const $f4d7ea4ec84815d2$export$b55de156ac5f7c1b = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT),
    path: '/secure/PortfolioDependencySettings.jspa'
};
const $f4d7ea4ec84815d2$export$21eaa019c724fc9a = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS),
    path: '/jira/plans/settings/loading-limits'
};
const $f4d7ea4ec84815d2$export$c72a1b9971af07d9 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT),
    path: '/secure/PortfolioLoadingLimits.jspa'
};
const $f4d7ea4ec84815d2$export$6372897c47d731c0 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS),
    path: '/jira/plans/settings/permissions'
};
const $f4d7ea4ec84815d2$export$4523847db2f1a42e = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT),
    path: '/secure/PortfolioPermissions.jspa'
};

});

parcelRegister("atRHQ", function(module, exports) {

$parcel$export(module.exports, "ScreenRedirect", () => $8157686ea09e4eda$export$fdd3e60cd227c2f7);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $78d1w = parcelRequire("78d1w");

var $lB25E = parcelRequire("lB25E");
const $8157686ea09e4eda$export$fdd3e60cd227c2f7 = ({ to: to, persistSearchParams: persistSearchParams = true })=>{
    const [{ route: route, location: location, query: query }] = (0, $lB25E.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ isInitialRender: isInitial }] = (0, $78d1w.useSpaStateTransition)();
    const eventRef = (0, $eUqFw.useRef)(createAnalyticsEvent({}));
    (0, $eUqFw.useEffect)(()=>{
        if (!route || !eventRef.current) return;
        (0, $jMP2a.fireUIAnalytics)(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        route,
        isInitial
    ]);
    if (Array.isArray(persistSearchParams)) {
        const persistParams = Object.keys(query) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((result, currentKey)=>{
            const shouldPersist = persistSearchParams.some((persistKey)=>currentKey.includes(persistKey));
            if (shouldPersist) result.push(`${currentKey}=${query[currentKey]}`);
            return result;
        }, []).join('&');
        if (persistParams !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `${to}?${persistParams}`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: to
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `${to}${persistSearchParams ? location.search : ''}`
    });
};

});

parcelRegister("7u7sK", function(module, exports) {

$parcel$export(module.exports, "CalendarSkeleton", () => $4857ea87a5142e4b$export$ebc7c47cc535837e);
$parcel$export(module.exports, "CalendarEmbedSkeleton", () => $4857ea87a5142e4b$export$bf543fe31d33292e);
$parcel$export(module.exports, "CalendarNoHeaderSkeleton", () => $4857ea87a5142e4b$export$504e7b05f3c54bf2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $dglRR = parcelRequire("dglRR");

var $aD9sS = parcelRequire("aD9sS");

var $cMQmc = parcelRequire("cMQmc");
const $4857ea87a5142e4b$var$customCssStyles = null;
const $4857ea87a5142e4b$export$ebc7c47cc535837e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dglRR)))
    });
const $4857ea87a5142e4b$export$bf543fe31d33292e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aD9sS)))
    });
const $4857ea87a5142e4b$export$504e7b05f3c54bf2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cMQmc))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("dglRR", function(module, exports) {
module.exports = new URL("calendar-app-skeleton.tpl.77b09222.svg", import.meta.url).toString();

});

parcelRegister("aD9sS", function(module, exports) {
module.exports = new URL("calendar-embed-app-skeleton.tpl.29c9a641.svg", import.meta.url).toString();

});

parcelRegister("cMQmc", function(module, exports) {
module.exports = new URL("calendar-no-header-skeleton.tpl.d6779107.svg", import.meta.url).toString();

});


parcelRegister("kY36r", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $220a22efab60ac1e$export$42f84e610f279c31);

var $eUqFw = parcelRequire("eUqFw");

var $iPDOm = parcelRequire("iPDOm");


var $gJ90Q = parcelRequire("gJ90Q");

var $j7WTV = parcelRequire("j7WTV");

var $56LD8 = parcelRequire("56LD8");
const $220a22efab60ac1e$export$42f84e610f279c31 = ({ errorMessage: errorMessage, isEmbedded: isEmbedded = false, planId: planId })=>{
    /**
	 * Clearing the early-preload promises here otherwise they get carried on to the following plan loads.
	 *
	 * The SPA app renders the ErrorScreen instead of the PlanApp when the validation fails,
	 * hence the early-preload promises did not get cleaned up.
	 */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.__ARJ_BACKLOG_PROMISE__;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.__ARJ_INFO_METADATA_PROMISE__;
    switch(errorMessage){
        case 0, $8d03d4da5621444c$export$aa64437890e7b596:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPDOm.RedirectToLoginPage), null);
        case 0, $8d03d4da5621444c$export$3fe2400c9d24940d:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJ90Q.AsyncLicenseViolationErrorPage), {
                isEmbedded: isEmbedded
            });
        case 0, $8d03d4da5621444c$export$4589763db20bfd7f:
        case 0, $8d03d4da5621444c$export$7e6358a0c21dff8c:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56LD8.AsyncNotFoundErrorPage), {
                entity: (0, $8d03d4da5621444c$export$c303e491e026ebc6),
                isEmbedded: isEmbedded
            });
        case 0, $8d03d4da5621444c$export$6519152a5f0e081:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56LD8.AsyncNotFoundErrorPage), {
                entity: (0, $8d03d4da5621444c$export$9b928fc5e710e864),
                isEmbedded: isEmbedded,
                planId: planId
            });
        case 0, $8d03d4da5621444c$export$6128dc888243fa0a:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7WTV.AsyncNoPlanPermissionErrorPage), {
                isEmbedded: isEmbedded
            });
        default:
            return null;
    }
};

});
parcelRegister("iPDOm", function(module, exports) {

$parcel$export(module.exports, "RedirectToLoginPage", () => $24cf6e57d181201a$export$938182bd3fddc3a8);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $24cf6e57d181201a$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$24cf6e57d181201a$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $24cf6e57d181201a$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $lB25E.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $lB25E.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
        const encodedParentProduct = encodeURIComponent(parentProduct || '');
        path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
    }
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($24cf6e57d181201a$export$3da29de62ed7a388, {
        to: path
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: path
    });
};

});

const $8d03d4da5621444c$export$aa64437890e7b596 = 'permission-violation';
const $8d03d4da5621444c$export$3fe2400c9d24940d = 'license-violation';
const $8d03d4da5621444c$export$4589763db20bfd7f = 'plan-not-found';
const $8d03d4da5621444c$export$6519152a5f0e081 = 'scenario-not-found';
const $8d03d4da5621444c$export$7e6358a0c21dff8c = 'report-not-found';
const $8d03d4da5621444c$export$6128dc888243fa0a = 'no-plan-permission';
const $8d03d4da5621444c$export$c303e491e026ebc6 = 'PLAN';
const $8d03d4da5621444c$export$9b928fc5e710e864 = 'SCENARIO';

parcelRegister("gJ90Q", function(module, exports) {

$parcel$export(module.exports, "AsyncLicenseViolationErrorPage", () => $8f5ef6322d0898d5$export$f5d9764f07badc4d);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $foc4i = parcelRequire("foc4i");

var $gGtKh = parcelRequire("gGtKh");

const $8f5ef6322d0898d5$var$LazyLicenseViolationErrorPage = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("4cxou")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/license-violation/index.tsx"
});
const $8f5ef6322d0898d5$export$f5d9764f07badc4d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "arj-license-violation-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f5ef6322d0898d5$var$LazyLicenseViolationErrorPage, props));

});
parcelRegister("4cxou", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("k7a6k")
]).then(()=>parcelRequire('3sYfH'));

});


parcelRegister("j7WTV", function(module, exports) {

$parcel$export(module.exports, "AsyncNoPlanPermissionErrorPage", () => $6292c7684217b71b$export$e595d2c5dfcb1d5a);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $foc4i = parcelRequire("foc4i");

var $gGtKh = parcelRequire("gGtKh");

const $6292c7684217b71b$var$LazyNoPlanPermissionErrorPage = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("lwXv0")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/no-plan-permission/index.tsx"
});
const $6292c7684217b71b$export$e595d2c5dfcb1d5a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "arj-no-plan-permission",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6292c7684217b71b$var$LazyNoPlanPermissionErrorPage, props));

});
parcelRegister("lwXv0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("g3qA9")
]).then(()=>parcelRequire('ej61u'));

});


parcelRegister("56LD8", function(module, exports) {

$parcel$export(module.exports, "AsyncNotFoundErrorPage", () => $4b17eba9ce2cb43d$export$8f6c907860218fdc);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $foc4i = parcelRequire("foc4i");

var $gGtKh = parcelRequire("gGtKh");

const $4b17eba9ce2cb43d$var$LazyNotFoundErrorPage = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("dacNG")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/not-found/index.tsx"
});
const $4b17eba9ce2cb43d$export$8f6c907860218fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "arj-not-found-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4b17eba9ce2cb43d$var$LazyNotFoundErrorPage, props));

});
parcelRegister("dacNG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("8gIej")
]).then(()=>parcelRequire('jgj8N'));

});



parcelRegister("kSiCv", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("8ePcQ")),
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("gnIGE")
]).then(()=>parcelRequire('2l3mS'));

});

parcelRegister("5pnex", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("bwmRk")),
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("pYL3A")
]).then(()=>parcelRequire('h6tmI'));

});

parcelRegister("6iNQz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("8vJAP")),
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("3uPZc")
]).then(()=>parcelRequire('7pkjG'));

});

parcelRegister("gkTS0", function(module, exports) {

$parcel$export(module.exports, "useAdvancedRoadmapsSummaryDataResource", () => $4e7b9fd5e056a541$export$263a4c831540778e);
$parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", () => (parcelRequire("2nflD")).advancedRoadmapsSummaryDataResource);

var $lB25E = parcelRequire("lB25E");

var $2nflD = parcelRequire("2nflD");


const $4e7b9fd5e056a541$export$263a4c831540778e = ()=>(0, $lB25E.useResource)((0, $2nflD.advancedRoadmapsSummaryDataResource));

});

parcelRegister("97FCh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("9RcIO")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("8F6wY")
]).then(()=>parcelRequire('aRFns'));

});

parcelRegister("aP9kF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("dxwAW")),
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("as1Nk")
]).then(()=>parcelRequire('khSpT'));

});

parcelRegister("7okz2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0717b3ae49c7e5d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $f0717b3ae49c7e5d$var$LazyGlobalProductsSettingsSidebar = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("80jot")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-products/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f0717b3ae49c7e5d$var$GlobalProductsSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalProductsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0717b3ae49c7e5d$var$LazyGlobalProductsSettingsSidebar, null)));
$f0717b3ae49c7e5d$var$GlobalProductsSettingsSidebar.displayName = 'GlobalProductsSettingsSidebar';
var $f0717b3ae49c7e5d$export$2e2bcd8739ae039 = $f0717b3ae49c7e5d$var$GlobalProductsSettingsSidebar;

});
parcelRegister("80jot", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("2YKQC")
]).then(()=>parcelRequire('gla7s'));

});


parcelRegister("2hHs5", function(module, exports) {

$parcel$export(module.exports, "issueLinkInformationResource", () => $9d58ed9c9b378fc4$export$8d8544ca08d98837);

var $lRmyA = parcelRequire("lRmyA");

var $lB25E = parcelRequire("lB25E");
const $9d58ed9c9b378fc4$var$body = {
    providers: [
        'issueLinks',
        'dependencySettings'
    ]
};
const $9d58ed9c9b378fc4$var$url = '/rest/jpo/1.0/info/query';
const $9d58ed9c9b378fc4$var$fetchIssueLinkInformation = ()=>(0, $lRmyA.performPostRequest)($9d58ed9c9b378fc4$var$url, {
        body: JSON.stringify($9d58ed9c9b378fc4$var$body)
    });
const $9d58ed9c9b378fc4$export$8d8544ca08d98837 = (0, $lB25E.createResource)({
    type: 'ISSUE_LINK_INFORMATION',
    getKey: ()=>'issue-link-information',
    getData: async ()=>$9d58ed9c9b378fc4$var$fetchIssueLinkInformation(),
    maxAge: 0
});

});

parcelRegister("7vMNl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("8nU3l")
]).then(()=>parcelRequire('lLYDp'));

});

parcelRegister("gubiX", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsResource", () => $68a24dd0c5af1f99$export$c9e47fa9b57975f5);

var $2OdyW = parcelRequire("2OdyW");

var $lB25E = parcelRequire("lB25E");

const $68a24dd0c5af1f99$export$c9e47fa9b57975f5 = (0, $lB25E.createResource)({
    type: (0, $7f69e5697ecce36f$export$cd7bb91dd2e30684),
    getKey: ()=>'loading-limits-information',
    getData: async ()=>(0, $2OdyW.default)('/rest/jpo/1.0/configuration'),
    maxAge: 0
});

});
const $7f69e5697ecce36f$export$cd7bb91dd2e30684 = 'RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS';


parcelRegister("lS6Rl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("1BO4o")),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("1ROi0")
]).then(()=>parcelRequire('94dCk'));

});

parcelRegister("bFKDs", function(module, exports) {

$parcel$export(module.exports, "grantedPermissionsResource", () => $6719c1a3cb6e3b84$export$aa3daf3280e2a2d7);
$parcel$export(module.exports, "permissionGroupsResource", () => $6719c1a3cb6e3b84$export$950060d83722e3bd);
$parcel$export(module.exports, "getGlobalPermissionPageResources", () => $6719c1a3cb6e3b84$export$a09a91246a866817);

var $lRmyA = parcelRequire("lRmyA");

var $lB25E = parcelRequire("lB25E");
const $6719c1a3cb6e3b84$var$fetchGrantedPermissions = ()=>(0, $lRmyA.performPostRequest)('/rest/roadmaps/1.0/info/query', {
        body: JSON.stringify({
            providers: [
                'permissions'
            ]
        })
    });
const $6719c1a3cb6e3b84$var$fetchPermissionGroups = ()=>(0, $lRmyA.performPostRequest)('/rest/jpo/1.0/groupsandusers', {
        body: JSON.stringify({
            includeUsers: false,
            excludedGroups: [],
            excludedUsers: [],
            query: ''
        })
    });
const $6719c1a3cb6e3b84$export$aa3daf3280e2a2d7 = (0, $lB25E.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GRANTED',
    getKey: ()=>'arj-granted-permissions',
    getData: async ()=>$6719c1a3cb6e3b84$var$fetchGrantedPermissions(),
    maxAge: 0
});
const $6719c1a3cb6e3b84$export$950060d83722e3bd = (0, $lB25E.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GROUPS',
    getKey: ()=>'arj-permission-groups',
    getData: async ()=>$6719c1a3cb6e3b84$var$fetchPermissionGroups(),
    maxAge: 0
});
const $6719c1a3cb6e3b84$export$a09a91246a866817 = ()=>[
        $6719c1a3cb6e3b84$export$aa3daf3280e2a2d7,
        $6719c1a3cb6e3b84$export$950060d83722e3bd
    ];

});

parcelRegister("c8iZb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("9iacf")
]).then(()=>parcelRequire('7cRws'));

});

parcelRegister("1IXLY", function(module, exports) {

$parcel$export(module.exports, "arjSettingsFinancialYearResource", () => $0a4ae8dde0bbec27$export$da45020eede4a793);

var $2OdyW = parcelRequire("2OdyW");

var $lB25E = parcelRequire("lB25E");

const $0a4ae8dde0bbec27$export$da45020eede4a793 = (0, $lB25E.createResource)({
    type: (0, $24ee3162ec5c4e32$export$e8e0384e95388aa3),
    getKey: ()=>'financial-year-information',
    getData: async ()=>(0, $2OdyW.default)('/rest/jpo/1.0/fiscalYear'),
    maxAge: 0
});

});
const $24ee3162ec5c4e32$export$e8e0384e95388aa3 = 'RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR';


parcelRegister("a0t0M", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bvf7s")
]).then(()=>parcelRequire('2O1O3'));

});

parcelRegister("gBtEq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("120RX")),
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("45cDo")
]).then(()=>parcelRequire('7xALK'));

});

parcelRegister("gZ4gO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("j1ukD")
]).then(()=>parcelRequire('6kwuy'));

});

parcelRegister("aROFY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("6TPFB")
]).then(()=>parcelRequire('75pp3'));

});

parcelRegister("jjQof", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kfclh").then(()=>parcelRequire('eU9Vv'));

});

parcelRegister("4uOqv", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");




module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("2Umqd")),
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("ePvPQ")),
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hYLEn")
]).then(()=>parcelRequire('lPX3R'));

});

parcelRegister("9fQ4G", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");




module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("2mb6O")),
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("1lGLx")),
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("dJ72D")
]).then(()=>parcelRequire('aoHrD'));

});

parcelRegister("bwADu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("kh1bM")),
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ptZGV")
]).then(()=>parcelRequire('8jLuY'));

});

parcelRegister("7oMPg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("cdg8w")),
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jU5cl")
]).then(()=>parcelRequire('4PQoa'));

});

parcelRegister("4SaEy", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("7oP8I")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("7UeDc")
]).then(()=>parcelRequire('2r517'));

});

parcelRegister("6jX1f", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("5WtaL")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("hY7fE")
]).then(()=>parcelRequire('8cXcl'));

});

parcelRegister("ctIcH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("4oETm")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("kXYR5")
]).then(()=>parcelRequire('9EF5X'));

});

parcelRegister("4GZod", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("j8Vqj")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("c2493")
]).then(()=>parcelRequire('iHcu1'));

});

parcelRegister("cwBdo", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("4Djtf")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("hgVla")
]).then(()=>parcelRequire('4QFbC'));

});

parcelRegister("hqCsS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("1W2DI")),
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2SvhN")
]).then(()=>parcelRequire('glloL'));

});

parcelRegister("iUDtt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("hoJwf")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("99Oli")
]).then(()=>parcelRequire('geFkB'));

});

parcelRegister("8ITG4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("5m4C2")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("dGIzi")
]).then(()=>parcelRequire('hDxMY'));

});

parcelRegister("eAHcS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("eb0fg")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("gEJuJ")
]).then(()=>parcelRequire('bjynb'));

});

parcelRegister("hA8gE", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("dRDIs")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("Ct84v")
]).then(()=>parcelRequire('lv2HB'));

});

parcelRegister("bZ6a9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("lb5Ks")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("8CrLw")
]).then(()=>parcelRequire('a9v6r'));

});

parcelRegister("5ZWNJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("4DgQX")),
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("02sgc")
]).then(()=>parcelRequire('2r58p'));

});

parcelRegister("g0ZzM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");




module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("1qTqU")),
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("8dfFH")),
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("eza3I")
]).then(()=>parcelRequire('hGGgn'));

});

parcelRegister("95ds7", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("l2PoJ")
]).then(()=>parcelRequire('l4WNO'));

});

parcelRegister("3mLaI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dwAE9").then(()=>parcelRequire('dpU8X'));

});

parcelRegister("7hF3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $707f9bf31c05907b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $707f9bf31c05907b$var$LazyGlobalProjectsSettingsSidebar = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("TFYYD")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-projects/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $707f9bf31c05907b$var$GlobalProjectsSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalProjectsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($707f9bf31c05907b$var$LazyGlobalProjectsSettingsSidebar, null)));
$707f9bf31c05907b$var$GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';
var $707f9bf31c05907b$export$2e2bcd8739ae039 = $707f9bf31c05907b$var$GlobalProjectsSettingsSidebar;

});
parcelRegister("TFYYD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("kWP1Y")
]).then(()=>parcelRequire('a6QRE'));

});


parcelRegister("1juW0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bn05E")
]).then(()=>parcelRequire('bP5Jr'));

});

parcelRegister("bAQOb", function(module, exports) {

$parcel$export(module.exports, "componentWithFF", () => $a2b6ad64f224d7cd$export$377d327ec8da8be);

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");
const $a2b6ad64f224d7cd$export$377d327ec8da8be = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)(featureFlagName), ComponentTrue, ComponentFalse);

});

parcelRegister("d1szd", function(module, exports) {

$parcel$export(module.exports, "genericProjectLayout", () => $4949b32bbf913e83$export$85dad8e9886563f6);

var $iZnNg = parcelRequire("iZnNg");

var $isbb2 = parcelRequire("isbb2");

var $csLgO = parcelRequire("csLgO");

var $soOXK = parcelRequire("soOXK");

var $7xFdb = parcelRequire("7xFdb");
const $4949b32bbf913e83$export$85dad8e9886563f6 = (0, $isbb2.composeLayouts)((0, $soOXK.classicSoftwareProjectLayout), (0, $iZnNg.coreProjectLayout), (0, $csLgO.serviceProjectLayout), (0, $soOXK.softwareProjectLayout), (0, $7xFdb.userBoardLayout));

});
parcelRegister("iZnNg", function(module, exports) {

$parcel$export(module.exports, "coreProjectLayout", () => $de69fcae9527d9e6$export$3c06ced9943ca671);

var $8QAGR = parcelRequire("8QAGR");

var $isbb2 = parcelRequire("isbb2");
const $de69fcae9527d9e6$export$3c06ced9943ca671 = (0, $isbb2.composeLayouts)((0, $8QAGR.projectLayout));

});
parcelRegister("8QAGR", function(module, exports) {

$parcel$export(module.exports, "projectLayout", () => $07993258fcc80491$export$204149bac601d20c);

var $6VZoe = parcelRequire("6VZoe");

var $i49Tf = parcelRequire("i49Tf");

var $isbb2 = parcelRequire("isbb2");

var $9dASl = parcelRequire("9dASl");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $07993258fcc80491$var$withAnyProjectContext = (Component)=>(0, $isbb2.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: 'any'
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $07993258fcc80491$var$ProjectTrackers = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("3E5s6")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
});
const $07993258fcc80491$var$ProjectFavicon = ()=>{
    (0, $9dASl.useProjectFavicon)();
    return null;
};
const $07993258fcc80491$var$rightSidebars = ()=>[];
const $07993258fcc80491$var$globalComponents = [
    $07993258fcc80491$var$withAnyProjectContext($07993258fcc80491$var$ProjectFavicon),
    $07993258fcc80491$var$withAnyProjectContext($07993258fcc80491$var$ProjectTrackers),
    $07993258fcc80491$var$withAnyProjectContext((0, $i49Tf.ProjectRouteListener))
];
const $07993258fcc80491$export$204149bac601d20c = (0, $isbb2.createLayout)({
    globalComponents: $07993258fcc80491$var$globalComponents,
    rightSidebars: $07993258fcc80491$var$rightSidebars()
});

});
parcelRegister("i49Tf", function(module, exports) {

$parcel$export(module.exports, "ProjectRouteListener", () => $badefa8fb2c95856$export$159f09d701320911);

var $eUqFw = parcelRequire("eUqFw");

var $ixwgj = parcelRequire("ixwgj");

var $c7H0g = parcelRequire("c7H0g");

var $lB25E = parcelRequire("lB25E");

var $77Wva = parcelRequire("77Wva");
const $badefa8fb2c95856$export$159f09d701320911 = ()=>{
    const isSiteAdmin = (0, $c7H0g.useIsAdmin)();
    const { data: data, loading: loading } = (0, $lB25E.useResource)((0, $ixwgj.projectContextResource));
    (0, $eUqFw.useEffect)(()=>{
        if (isSiteAdmin) (0, $77Wva.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: true
        });
        else if (data != null) (0, $77Wva.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: data.isProjectAdmin
        });
        else (0, $77Wva.setIsProjectAdmin)({
            loading: loading,
            isProjectAdmin: null
        });
    }, [
        data,
        loading,
        isSiteAdmin
    ]);
    // Cleanup when component is unmounted. This means we are no longer in a project route
    (0, $eUqFw.useEffect)(()=>()=>(0, $77Wva.setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: null
            }), []);
    return null;
};

});

parcelRegister("9dASl", function(module, exports) {

$parcel$export(module.exports, "useProjectFavicon", () => $ccc7b3b9e5ce6616$export$32abcb1f939de016);

var $eUqFw = parcelRequire("eUqFw");

var $6rW04 = parcelRequire("6rW04");

var $cPEpP = parcelRequire("cPEpP");
const $ccc7b3b9e5ce6616$export$32abcb1f939de016 = false ? ()=>undefined : ()=>{
    const { data: project } = (0, $cPEpP.useProject)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const iconEle = document.querySelector("link[rel='shortcut icon']");
    // Keep a copy of the default favicon
    const defaultFavicon = (0, $eUqFw.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
        iconEle
    ]);
    const enabled = (0, $eUqFw.useMemo)(()=>(0, $6rW04.default)('ajs-favicon-use-projecticon') === 'true', []);
    (0, $eUqFw.useEffect)(()=>{
        const favicon = project ? project.avatarUrl : defaultFavicon;
        if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = favicon;
        // Switch back to default favicon
        return ()=>{
            if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
        };
    }, [
        project,
        iconEle,
        defaultFavicon,
        enabled
    ]);
};

});

parcelRegister("3E5s6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("f2iFO")
]).then(()=>parcelRequire('hbMGV'));

});



parcelRegister("csLgO", function(module, exports) {

$parcel$export(module.exports, "serviceProjectLayout", () => $89d8cdf72602f901$export$e321cb31c875d1ba);
$parcel$export(module.exports, "rightSidebarsLayout", () => $89d8cdf72602f901$export$820f9bb834280408);

var $6VZoe = parcelRequire("6VZoe");

var $7ZZxN = parcelRequire("7ZZxN");

var $dVvIP = parcelRequire("dVvIP");

var $fBmd6 = parcelRequire("fBmd6");

var $8QAGR = parcelRequire("8QAGR");

var $isbb2 = parcelRequire("isbb2");

var $2QkFp = parcelRequire("2QkFp");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $89d8cdf72602f901$var$withServiceProjectContext = (Component)=>(0, $isbb2.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $7ZZxN.SERVICE_DESK_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $89d8cdf72602f901$var$ProjectBuilder = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("h3jf5")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $89d8cdf72602f901$var$Onboarding = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("lZB6e")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $89d8cdf72602f901$var$RightSidebars = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("6DIn6")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/index.tsx"
});
const $89d8cdf72602f901$export$e321cb31c875d1ba = (0, $isbb2.composeLayouts)((0, $8QAGR.projectLayout), {
    globalComponents: [
        $89d8cdf72602f901$var$withServiceProjectContext($89d8cdf72602f901$var$Onboarding),
        ...(0, $2QkFp.serviceProjectFirstImpressionsLayout).globalComponents.map($89d8cdf72602f901$var$withServiceProjectContext),
        $89d8cdf72602f901$var$withServiceProjectContext((0, $fBmd6.AsyncJsmCustomDomainChangeBoardingFlag)),
        $89d8cdf72602f901$var$ProjectBuilder
    ],
    rightSidebars: [
        $89d8cdf72602f901$var$withServiceProjectContext($89d8cdf72602f901$var$RightSidebars),
        ...(0, $2QkFp.serviceProjectFirstImpressionsLayout).rightSidebars.map($89d8cdf72602f901$var$withServiceProjectContext)
    ]
});
const $89d8cdf72602f901$export$820f9bb834280408 = (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), {
    rightSidebars: [
        $89d8cdf72602f901$var$RightSidebars
    ]
});

});
parcelRegister("fBmd6", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", () => $2c9f26ce5a28ec28$export$b1ef5e3da6e1959d);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2c9f26ce5a28ec28$var$LazyJsmCustomDomainChangeBoardingFlag = (0, $6VZoe.lazy)(()=>(parcelRequire("hTaQh")), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
});
const $2c9f26ce5a28ec28$export$b1ef5e3da6e1959d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2c9f26ce5a28ec28$var$LazyJsmCustomDomainChangeBoardingFlag, null)));

});
parcelRegister("hTaQh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("eNmuD"),
    $d1Cng("d3MCA")
]).then(()=>parcelRequire('j5Ut0'));

});


parcelRegister("2QkFp", function(module, exports) {

$parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", () => $28742565404e52e1$export$2562b2d784eadc10);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $1WU96 = parcelRequire("1WU96");

var $isbb2 = parcelRequire("isbb2");
const $28742565404e52e1$var$withServiceProjectAccess = (Component)=>{
    const ScopedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WU96.default), {
            hasServiceDeskAccess: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null));
    const name = (0, $isbb2.coalesce)(Component.displayName) ?? (0, $isbb2.coalesce)(Component.name) ?? 'Component';
    ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
    return ScopedComponent;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $28742565404e52e1$var$Onboarding = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("9baYT")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $28742565404e52e1$var$RightSidebars = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("3MrwS")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/index.tsx"
});
const $28742565404e52e1$export$2562b2d784eadc10 = (0, $isbb2.createLayout)({
    globalComponents: [
        $28742565404e52e1$var$withServiceProjectAccess($28742565404e52e1$var$Onboarding)
    ],
    rightSidebars: [
        $28742565404e52e1$var$withServiceProjectAccess($28742565404e52e1$var$RightSidebars)
    ]
});

});
parcelRegister("1WU96", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f8966d75f9e18f8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");

var $3ndxD = parcelRequire("3ndxD");
/**
 * Manages the visibility of child components based on user permissions within a multi-tenant environment.
 * It leverages the application's permission settings to determine access rights, ensuring components are only accessible to users with the appropriate permissions.
 * In development environments, it issues a warning when no access-related properties are provided, aiding in debug and development processes.
 */ const $4f8966d75f9e18f8$var$AppPermissionsCheck = (props)=>{
    const { appPermissions: appPermissions } = (0, $gd0Sp.useTenantContext)();
    if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
        if ((0, $3ndxD.isDevelopmentEnv)()) // eslint-disable-next-line no-console
        console.warn('AppPermissionsCheck should have defined at least one of access prop');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    }
    return null;
};
$4f8966d75f9e18f8$var$AppPermissionsCheck.defaultProps = {
    hasCoreAccess: undefined,
    hasSoftwareAccess: undefined,
    hasServiceDeskAccess: undefined
};
var $4f8966d75f9e18f8$export$2e2bcd8739ae039 = $4f8966d75f9e18f8$var$AppPermissionsCheck;

});
parcelRegister("3ndxD", function(module, exports) {

$parcel$export(module.exports, "isDevelopmentEnv", () => $4cb60d7dfaed0e5c$export$48e5fb80244b95c5);
const $4cb60d7dfaed0e5c$export$48e5fb80244b95c5 = ()=>false;

});


parcelRegister("9baYT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("lSjLj")
]).then(()=>parcelRequire('fopgZ'));

});

parcelRegister("3MrwS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("6HOXP")
]).then(()=>parcelRequire('9iDpZ'));

});


parcelRegister("h3jf5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("12gwi").then(()=>parcelRequire('UsO9m'));

});

parcelRegister("lZB6e", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hIGOt")
]).then(()=>parcelRequire('jAlsY'));

});

parcelRegister("6DIn6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("1xZoV")
]).then(()=>parcelRequire('lFtmC'));

});


parcelRegister("soOXK", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareProjectLayout", () => $da080439a4ecc697$export$3791efdd32024063);
$parcel$export(module.exports, "softwareProjectLayout", () => $da080439a4ecc697$export$9a918616afa3328c);
$parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", () => $da080439a4ecc697$export$ada52b1309832862);
$parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", () => $da080439a4ecc697$export$6c1958653c44ba37);
$parcel$export(module.exports, "softwareProjectLayoutCode", () => $da080439a4ecc697$export$ab7e607e8441dc61);

var $6VZoe = parcelRequire("6VZoe");

var $7ZZxN = parcelRequire("7ZZxN");

var $8QAGR = parcelRequire("8QAGR");

var $isbb2 = parcelRequire("isbb2");
// TODO Remove this whenever all software project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $da080439a4ecc697$var$withAnySoftwareProjectContext = (Component)=>(0, $isbb2.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $7ZZxN.SOFTWARE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $da080439a4ecc697$var$Onboarding = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("2FlU1")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $da080439a4ecc697$var$OnboardingCode = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("jrFbZ")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $da080439a4ecc697$var$RightSidebars = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("S2RQH")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $da080439a4ecc697$var$RightSidebarsCode = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("lsFX9")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/index.tsx"
});
const $da080439a4ecc697$var$SoftWareOnboarding = $da080439a4ecc697$var$withAnySoftwareProjectContext($da080439a4ecc697$var$Onboarding);
const $da080439a4ecc697$var$SoftWareOnboardingCode = $da080439a4ecc697$var$withAnySoftwareProjectContext($da080439a4ecc697$var$OnboardingCode);
const $da080439a4ecc697$var$nonSettingsRightSidebars = [
    $da080439a4ecc697$var$withAnySoftwareProjectContext($da080439a4ecc697$var$RightSidebars)
];
const $da080439a4ecc697$var$nonSettingsRightSidebarsCode = [
    $da080439a4ecc697$var$withAnySoftwareProjectContext($da080439a4ecc697$var$RightSidebarsCode)
];
const $da080439a4ecc697$var$sharedSoftwareProjectLayout = (0, $isbb2.composeLayouts)((0, $8QAGR.projectLayout), {});
const $da080439a4ecc697$export$3791efdd32024063 = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout, {
    rightSidebars: $da080439a4ecc697$var$nonSettingsRightSidebars,
    globalComponents: [
        $da080439a4ecc697$var$SoftWareOnboarding
    ]
});
const $da080439a4ecc697$export$9a918616afa3328c = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout, {
    rightSidebars: $da080439a4ecc697$var$nonSettingsRightSidebars,
    globalComponents: [
        $da080439a4ecc697$var$SoftWareOnboarding
    ]
});
const $da080439a4ecc697$export$ada52b1309832862 = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout);
const $da080439a4ecc697$export$6c1958653c44ba37 = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout);
const $da080439a4ecc697$export$ab7e607e8441dc61 = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout, {
    rightSidebars: $da080439a4ecc697$var$nonSettingsRightSidebarsCode,
    globalComponents: [
        $da080439a4ecc697$var$SoftWareOnboardingCode
    ]
});

});
parcelRegister("2FlU1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("2QXYY")
]).then(()=>parcelRequire('5nRWZ'));

});

parcelRegister("jrFbZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("4FTjM")
]).then(()=>parcelRequire('1KEra'));

});

parcelRegister("S2RQH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hsl5M")
]).then(()=>parcelRequire('epLsj'));

});

parcelRegister("lsFX9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("9LoaN")
]).then(()=>parcelRequire('ddLdL'));

});


parcelRegister("7xFdb", function(module, exports) {

$parcel$export(module.exports, "userBoardLayout", () => $104be0934152e131$export$7092b4ee86ae0b71);

var $isbb2 = parcelRequire("isbb2");
const $104be0934152e131$export$7092b4ee86ae0b71 = (0, $isbb2.createLayout)();

});


parcelRegister("4qvmP", function(module, exports) {

$parcel$export(module.exports, "getBusinessProjectResources", () => $539284efb9551a13$export$20e8c2951e444b08);
$parcel$export(module.exports, "getProjectViewResources", () => $539284efb9551a13$export$fcbe882e18ee4a35);
$parcel$export(module.exports, "getOverviewViewResources", () => $539284efb9551a13$export$21c5527b459d56fe);

var $fD1Hq = parcelRequire("fD1Hq");

var $kMmsu = parcelRequire("kMmsu");

var $f26dB = parcelRequire("f26dB");

var $fIi7o = parcelRequire("fIi7o");

var $fzymf = parcelRequire("fzymf");

var $aeIT6 = parcelRequire("aeIT6");

var $91fCW = parcelRequire("91fCW");

var $hHrVM = parcelRequire("hHrVM");

var $2JncP = parcelRequire("2JncP");
const $539284efb9551a13$var$commonResources = [
    (0, $2JncP.projectCreatePermissionsResource),
    (0, $f26dB.navigationResource)
];
const $539284efb9551a13$export$20e8c2951e444b08 = ()=>[
        ...$539284efb9551a13$var$commonResources,
        (0, $aeIT6.projectDetailsResource),
        (0, $91fCW.storageDetailsResource),
        (0, $fIi7o.navigationItemsResource)
    ];
const $539284efb9551a13$export$46471673e66df5c1 = ()=>[
        ...$539284efb9551a13$var$commonResources,
        (0, $fzymf.overviewDetailsResource)
    ];
const $539284efb9551a13$export$fcbe882e18ee4a35 = ()=>[
        ...$539284efb9551a13$export$20e8c2951e444b08(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $fD1Hq.configurationResource),
        (0, $kMmsu.fieldsResource)
    ];
const $539284efb9551a13$export$21c5527b459d56fe = ()=>[
        ...$539284efb9551a13$export$46471673e66df5c1(),
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $fD1Hq.configurationResource),
        (0, $kMmsu.fieldsResource)
    ];

});
parcelRegister("fD1Hq", function(module, exports) {

$parcel$export(module.exports, "configurationResource", () => $b3265d3008765031$export$5c4ad441346dc154);
$parcel$export(module.exports, "useRankField", () => $b3265d3008765031$export$fffa1172af8de100);
$parcel$export(module.exports, "useStartDateField", () => $b3265d3008765031$export$bf78b0881400efef);
$parcel$export(module.exports, "useIsLinkingEnabled", () => $b3265d3008765031$export$76fc5a1eecec5a35);
$parcel$export(module.exports, "useIsSubtasksEnabled", () => $b3265d3008765031$export$dca58a051cb58f03);

var $lB25E = parcelRequire("lB25E");

var $7WqaN = parcelRequire("7WqaN");
const $b3265d3008765031$var$RESOURCE_KEY = 'BUSINESS_CONFIGURATION';
const $b3265d3008765031$export$5c4ad441346dc154 = (0, $lB25E.createResource)({
    type: $b3265d3008765031$var$RESOURCE_KEY,
    getKey: ()=>$b3265d3008765031$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, $7WqaN.fetchConfiguration)(cloudId),
    maxAge: Infinity
});
const $b3265d3008765031$export$b629b793d58e3884 = ()=>(0, $lB25E.useResource)($b3265d3008765031$export$5c4ad441346dc154);
const $b3265d3008765031$export$fffa1172af8de100 = ()=>{
    const { data: data, loading: loading, error: error } = $b3265d3008765031$export$b629b793d58e3884();
    return {
        data: data?.rankField ?? null,
        loading: loading,
        error: error
    };
};
const $b3265d3008765031$export$bf78b0881400efef = ()=>{
    const { data: data, loading: loading, error: error } = $b3265d3008765031$export$b629b793d58e3884();
    return {
        data: data?.startDateField ?? null,
        loading: loading,
        error: error
    };
};
const $b3265d3008765031$export$76fc5a1eecec5a35 = ()=>{
    const { data: data } = $b3265d3008765031$export$b629b793d58e3884();
    return data?.isLinkingEnabled ?? false;
};
const $b3265d3008765031$export$dca58a051cb58f03 = ()=>{
    const { data: data } = $b3265d3008765031$export$b629b793d58e3884();
    return data?.isSubtasksEnabled ?? false;
};

});
parcelRegister("7WqaN", function(module, exports) {

$parcel$export(module.exports, "fetchConfiguration", () => $6d233c0f1331d9ce$export$9911e92fcb5c83c0);

var $dlVOn = parcelRequire("dlVOn");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");


var $6xUhC = parcelRequire("6xUhC");
const $6d233c0f1331d9ce$export$9911e92fcb5c83c0 = async (cloudId)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JiraBusinessConfiguration', {
            body: JSON.stringify({
                query: (0, $4e521ecd804aed88$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            })
        });
        if (response.data == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        return (0, $6xUhC.transformData)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessConfiguration', 'Something went wrong while fetching business configuration');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $guiFP.default)({
            meta: {
                id: 'configurationResource',
                packageName: 'jiraRouterResourcesBusinessConfiguration',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});
const $4e521ecd804aed88$export$2b91517d6d5b4365 = `
query JiraBusinessConfiguration($cloudId: ID!) {
  jira {
    rankField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: RANK) {
      fieldId
      name
    }
    startDateField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: START_DATE) {
      fieldId
      name
    }
    issueLinkTypes(cloudId: $cloudId) {
      totalCount
    }
    isSubtasksEnabled(cloudId: $cloudId)
  }
}
`;

parcelRegister("6xUhC", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $14956d34a7bd03ca$export$3ceb62baab058c6b);
const $14956d34a7bd03ca$export$3ceb62baab058c6b = (response)=>{
    let rankField = null;
    const rankFieldNode = response.data?.jira?.rankField;
    if (rankFieldNode != null) rankField = {
        id: rankFieldNode.fieldId,
        name: rankFieldNode.name
    };
    let startDateField = null;
    const startDateFieldNode = response.data?.jira?.startDateField;
    if (startDateFieldNode != null) startDateField = {
        id: startDateFieldNode.fieldId,
        name: startDateFieldNode.name
    };
    const isLinkingEnabled = (response.data?.jira?.issueLinkTypes?.totalCount ?? 0) !== 0;
    const isSubtasksEnabled = response.data?.jira?.isSubtasksEnabled ?? false;
    return {
        rankField: rankField,
        startDateField: startDateField,
        isLinkingEnabled: isLinkingEnabled,
        isSubtasksEnabled: isSubtasksEnabled
    };
};

});



parcelRegister("kMmsu", function(module, exports) {

$parcel$export(module.exports, "fieldsResource", () => $1a45b925639aee3d$export$8bca6c1954ae9308);
$parcel$export(module.exports, "useFieldsResource", () => $1a45b925639aee3d$export$c0cd85886917fe89);

var $dlVOn = parcelRequire("dlVOn");

var $huI7r = parcelRequire("huI7r");

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $eKlti = parcelRequire("eKlti");


var $3hBy0 = parcelRequire("3hBy0");
const $1a45b925639aee3d$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1a45b925639aee3d$var$handleProjectResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
    return (0, $3hBy0.transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1a45b925639aee3d$var$handleOverviewResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
    return (0, $3hBy0.transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
};
const $1a45b925639aee3d$export$8bca6c1954ae9308 = (0, $lB25E.createResource)({
    type: $1a45b925639aee3d$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        if (matchedRoute.match.params.overviewId) return `${$1a45b925639aee3d$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$1a45b925639aee3d$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        if (match.params.overviewId) return (0, $eKlti.fetchFields)((0, $26aeff854ea788a9$export$c378ca4a0e2c9fec), $1a45b925639aee3d$var$handleOverviewResponse, {
            overviewAri: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project-overview',
                resourceId: match.params.overviewId,
                activationId: activationId
            })
        });
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        return (0, $eKlti.fetchFields)((0, $26aeff854ea788a9$export$4d41378da3f70f0f), $1a45b925639aee3d$var$handleProjectResponse, {
            cloudId: cloudId,
            jqlContext: `project = '${projectIdOrKey}'`
        });
    },
    maxAge: 3600000
});
const $1a45b925639aee3d$export$c0cd85886917fe89 = ()=>(0, $lB25E.useResource)($1a45b925639aee3d$export$8bca6c1954ae9308);

});
parcelRegister("eKlti", function(module, exports) {

$parcel$export(module.exports, "fetchFields", () => $7876ddb9df2017cc$export$f3ddd735c360919);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $7876ddb9df2017cc$var$PAGE_SIZE = 100;
const $7876ddb9df2017cc$export$f3ddd735c360919 = async (query, handler, params)=>{
    try {
        const promise = (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: $7876ddb9df2017cc$var$PAGE_SIZE,
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return await handler(promise);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $guiFP.default)({
            meta: {
                id: 'fieldsResource',
                packageName: 'jiraRouterResourcesBusinessFields',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});

const $26aeff854ea788a9$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $26aeff854ea788a9$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;

parcelRegister("3hBy0", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $e766e365dbeb1f01$export$3ceb62baab058c6b);
const $e766e365dbeb1f01$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);

});


parcelRegister("f26dB", function(module, exports) {

$parcel$export(module.exports, "navigationResource", () => $2dec1e8aa31afb0b$export$62940941ee574cdc);
$parcel$export(module.exports, "useNavigationResource", () => $2dec1e8aa31afb0b$export$c17011c09e042a31);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $2dec1e8aa31afb0b$export$90749419e9042370);
$parcel$export(module.exports, "useTriggerOverviewChangeboarding", () => $2dec1e8aa31afb0b$export$30f6f0b00bf4f2f8);

var $8blac = parcelRequire("8blac");

var $huI7r = parcelRequire("huI7r");

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $gQNVa = parcelRequire("gQNVa");


const $2dec1e8aa31afb0b$export$62940941ee574cdc = (0, $lB25E.createResource)({
    type: 'BUSINESS_NAVIGATION',
    getKey: ()=>'BUSINESS_NAVIGATION',
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(projectKey)) return (0, $gQNVa.fetchNavigation)((0, $dac6815921c324c6$export$a40c5d12b8a53ba2), {
            cloudId: cloudId,
            projectKey: projectKey
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(projectId)) return (0, $gQNVa.fetchNavigation)((0, $dac6815921c324c6$export$7c9197b656229b53), {
            cloudId: cloudId,
            projectId: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project',
                resourceId: projectId
            })
        });
        return (0, $gQNVa.fetchNavigation)((0, $dac6815921c324c6$export$c378ca4a0e2c9fec), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $2dec1e8aa31afb0b$export$c17011c09e042a31 = ()=>(0, $lB25E.useResource)($2dec1e8aa31afb0b$export$62940941ee574cdc);
const $2dec1e8aa31afb0b$export$90749419e9042370 = ()=>{
    const { data: data } = $2dec1e8aa31afb0b$export$c17011c09e042a31();
    if (data === 'NOT_APPLICABLE') return false;
    return Boolean(data?.isPremiumUserSeat);
};
const $2dec1e8aa31afb0b$export$30f6f0b00bf4f2f8 = ()=>{
    const { data: data } = $2dec1e8aa31afb0b$export$c17011c09e042a31();
    if (data === 'NOT_APPLICABLE') return false;
    return Boolean(data?.showPlansOnboarding);
};

});
parcelRegister("gQNVa", function(module, exports) {

$parcel$export(module.exports, "fetchNavigation", () => $83fda10f52c953b2$export$1fc5fff73d9a570c);

var $dlVOn = parcelRequire("dlVOn");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");


var $2Y7Cf = parcelRequire("2Y7Cf");
const $83fda10f52c953b2$var$EMPTY_RESPONSE = {
    recents: [],
    favorites: [],
    hasMoreFavorite: false,
    overviews: [],
    overviewsError: null,
    isPremiumUserSeat: false,
    showPlansOnboarding: false,
    shouldHideOverviews: false
};
const $83fda10f52c953b2$export$1fc5fff73d9a570c = async (query, params)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: (0, $02a4cc31089f6443$export$3349219a88ac77cd),
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        // checking only for undefined, as null is a valid value (not applicable)
        if (response.data?.jira?.navigation === undefined) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        let areOverviewsGone = false;
        if (Array.isArray(response.errors)) // Overviews have been migrated to plans and should no longer be shown to the user
        areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
        return (0, $2Y7Cf.transformData)(response.data.jira.navigation, areOverviewsGone);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $guiFP.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesBusinessNavigation',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $83fda10f52c953b2$var$EMPTY_RESPONSE;
};

});
const $02a4cc31089f6443$export$3349219a88ac77cd = 10;
const $02a4cc31089f6443$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';

parcelRegister("2Y7Cf", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $e5db137f9c283ecc$export$3ceb62baab058c6b);

var $kar7l = parcelRequire("kar7l");


var $vsTb8 = parcelRequire("vsTb8");
const $e5db137f9c283ecc$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
const $e5db137f9c283ecc$var$PREMIUM = 'PREMIUM';
const $e5db137f9c283ecc$var$mapProjectNode = (node)=>({
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.projectStyle === $e5db137f9c283ecc$var$SIMPLIFIED_PROJECT_STYLE,
        isFavorite: node.isFavourite,
        permissions: {
            viewIssues: node.viewIssues.canPerform
        },
        defaultView: node.defaultView?.typeKey?.toLowerCase()
    });
const $e5db137f9c283ecc$var$mapOverviewNode = (node)=>({
        id: node.id,
        name: node.name,
        theme: node?.theme ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name
    });
const $e5db137f9c283ecc$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
    if (navigation == null) // not a JWM context
    return 0, $02a4cc31089f6443$export$e8958a6508ec5b71;
    let overviews = [];
    let overviewsError = null;
    const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $e5db137f9c283ecc$var$PREMIUM;
    if (isPremiumUserSeat) {
        if (navigation.overviews?.__typename === (0, $vsTb8.OVERVIEWS_SUCCESS_RESPONSE_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        overviews = navigation.overviews.edges.map((edge)=>$e5db137f9c283ecc$var$mapOverviewNode(edge.node));
        else overviewsError = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        navigation.overviews ?? new Error('Unknown overviews error');
    }
    let recents = navigation.recentProjects?.edges?.map((edge)=>$e5db137f9c283ecc$var$mapProjectNode(edge.node)) ?? [];
    const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$e5db137f9c283ecc$var$mapProjectNode(edge.node)) ?? [];
    // Remove favorited projects from the recent projects list
    recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
    const showPlansOnboarding = Boolean(navigation.jwmOverviewPlanMigrationState?.changeboardingActive);
    const shouldHideOverviews = areOverviewsGone && !showPlansOnboarding;
    return {
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
        overviews: overviews,
        overviewsError: overviewsError,
        isPremiumUserSeat: isPremiumUserSeat,
        showPlansOnboarding: showPlansOnboarding,
        shouldHideOverviews: shouldHideOverviews
    };
};

});
parcelRegister("vsTb8", function(module, exports) {

$parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", () => $8f89cb3175071b7f$export$ddf2fc82885279d);
const $8f89cb3175071b7f$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
const $8f89cb3175071b7f$export$39284f7325536558 = {
    ServiceDesk: 'SERVICE_DESK',
    Business: 'BUSINESS',
    Software: 'SOFTWARE'
};
const $8f89cb3175071b7f$export$1f66f9f05afa05a8 = {
    TeamManagedProject: 'TEAM_MANAGED_PROJECT',
    CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
};

});



const $dac6815921c324c6$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $dac6815921c324c6$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $dac6815921c324c6$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $dac6815921c324c6$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $dac6815921c324c6$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
  jwmOverviewPlanMigrationState {
    ... on JiraOverviewPlanMigrationState {
      changeboardingActive
    }
  }
}
`;
const $dac6815921c324c6$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$dac6815921c324c6$var$ProjectFragment}
${$dac6815921c324c6$var$ProjectConnectionFragment}
${$dac6815921c324c6$var$NavigationDataFragment}
${$dac6815921c324c6$var$OverviewFragment}
${$dac6815921c324c6$var$OverviewConnectionFragment}
`;
const $dac6815921c324c6$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$dac6815921c324c6$var$ProjectFragment}
${$dac6815921c324c6$var$ProjectConnectionFragment}
${$dac6815921c324c6$var$NavigationDataFragment}
${$dac6815921c324c6$var$OverviewFragment}
${$dac6815921c324c6$var$OverviewConnectionFragment}
`;
const $dac6815921c324c6$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$dac6815921c324c6$var$ProjectFragment}
${$dac6815921c324c6$var$ProjectConnectionFragment}
${$dac6815921c324c6$var$NavigationDataFragment}
${$dac6815921c324c6$var$OverviewFragment}
${$dac6815921c324c6$var$OverviewConnectionFragment}
`;


parcelRegister("fIi7o", function(module, exports) {

$parcel$export(module.exports, "navigationItemsResource", () => $e864d999bb4bb8a0$export$8446b129b5aba359);
// eslint-disable-next-line jira/import-whitelist

var $8npnf = parcelRequire("8npnf");

var $gUUjF = parcelRequire("gUUjF");

var $eI5EY = parcelRequire("eI5EY");

var $6FP8W = parcelRequire("6FP8W");

var $com8B = parcelRequire("com8B");

var $buJlM = parcelRequire("buJlM");

var $c8y7O = parcelRequire("c8y7O");

var $9zYls = parcelRequire("9zYls");
const $e864d999bb4bb8a0$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_HORIZONTAL_NAVIGATION';
const $e864d999bb4bb8a0$var$getProjectAri = (projectId, cloudId)=>{
    try {
        return projectId ? (0, $8npnf.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
    } catch (err) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesNavigationItems', 'Failed to get project ari');
        return '';
    }
};
const $e864d999bb4bb8a0$export$8446b129b5aba359 = (0, $buJlM.createRelayResource)({
    type: $e864d999bb4bb8a0$var$RESOURCE_TYPE_KEY,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        const projectIdOrKey = projectKey || projectId;
        const scopeId = $e864d999bb4bb8a0$var$getProjectAri(projectId, cloudId);
        return {
            parameters: (0, $c8y7O.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey,
                first: (0, $com8B.NAVIGATION_ITEMS_PAGE_SIZE),
                containerNavigationInput: scopeId ? {
                    scopeId: scopeId
                } : {
                    projectKeyQuery: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                useContainerNavigation: (0, $6FP8W.getWillShowNav4)() && (0, $eI5EY.fg)('custom_project_navigation_m2'),
                useNewProjectHeader: (0, $6FP8W.getWillShowNav4)() && (0, $eI5EY.fg)('common_project_actions_menu'),
                projectKey: projectKey,
                projectAri: scopeId,
                useProjectKey: Boolean(projectKey)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});

});
parcelRegister("c8y7O", function(module, exports) {

$parcel$export(module.exports, "default", () => $7232ceddc504ece4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cb59060bb617e382e02d18b387451c96>>
 * @relayHash 2d74c5f197ada6f3093273c41788be9a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 564c4bba54aaf136169eca322afbc10e1b8b603a6bd94e7f23ec1e1bc583640e
const $7232ceddc504ece4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useContainerNavigation"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useNewProjectHeader"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useProjectKey"
    }, v9 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v10 = [
        v9 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v11 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v13 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v14 = {
        "kind": "ScalarField",
        "name": "name"
    }, v15 = {
        "condition": "useNewProjectHeader",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "projectBoardHeader_horizontalNavHeader_projectFragment"
            }
        ]
    }, v16 = {
        "kind": "FragmentSpread",
        "name": "tabs_businessHorizontalNav_TabsContent_projectFragment"
    }, v17 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v18 = {
        "args": [
            v9 /*: any*/ 
        ],
        "concreteType": "JiraWorkManagementLicensing",
        "kind": "LinkedField",
        "name": "jwmLicensing",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "currentUserSeatEdition"
            }
        ]
    }, v19 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v20 = [
        v9 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "projectIdOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = {
        "kind": "ScalarField",
        "name": "id"
    }, v23 = {
        "kind": "ScalarField",
        "name": "label"
    }, v24 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v25 = {
        "kind": "ScalarField",
        "name": "url"
    }, v26 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v27 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v28 = {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v21 /*: any*/ ,
            v22 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isDefault"
            },
            {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraNavigationItem"
            },
            v23 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "canRemove"
            },
            {
                "kind": "ScalarField",
                "name": "canSetAsDefault"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "appId"
                    },
                    {
                        "concreteType": "JiraAppSection",
                        "kind": "LinkedField",
                        "name": "sections",
                        "plural": true,
                        "selections": [
                            v23 /*: any*/ ,
                            {
                                "concreteType": "JiraAppNavigationItemNestedLink",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": true,
                                "selections": [
                                    v23 /*: any*/ ,
                                    v24 /*: any*/ ,
                                    v25 /*: any*/ ,
                                    v26 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v25 /*: any*/ ,
                    v24 /*: any*/ ,
                    v26 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "appType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "envLabel"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v27 /*: any*/ 
                        ],
                        "type": "JiraNavigationItem",
                        "abstractKey": "__isJiraNavigationItem"
                    }
                ],
                "type": "JiraAppNavigationItem"
            },
            v27 /*: any*/ 
        ]
    }, v29 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v21 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ], v30 = {
        "concreteType": "QueryError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": v29 /*: any*/ 
    }, v31 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": [
            v22 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v33 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v34 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v35 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v36 = [
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "navigationMetadata",
            "plural": false,
            "selections": [
                v21 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v33 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isSimpleBoard"
                        },
                        v22 /*: any*/ 
                    ],
                    "type": "JiraSoftwareProjectNavigationMetadata"
                }
            ]
        },
        {
            "kind": "LinkedField",
            "name": "mostRecentlyViewedBoard",
            "plural": false,
            "selections": [
                v21 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v33 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "boardType"
                        }
                    ],
                    "type": "JiraBoard"
                },
                v32 /*: any*/ 
            ]
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        v22 /*: any*/ ,
        {
            "condition": "useNewProjectHeader",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                v34 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "projectStyle"
                },
                {
                    "kind": "ScalarField",
                    "name": "webUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "alias": "canEditProjectConfig",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "EDIT_PROJECT_CONFIG"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": v35 /*: any*/ ,
                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                },
                {
                    "alias": "canViewProjectConfig",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "VIEW_PROJECT_CONFIG"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": v35 /*: any*/ ,
                    "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                },
                {
                    "kind": "ScalarField",
                    "name": "softwareBoardCount"
                },
                {
                    "concreteType": "JiraBoardConnection",
                    "kind": "LinkedField",
                    "name": "boards",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraBoardEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraBoard",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v33 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteValue",
                                            "kind": "LinkedField",
                                            "name": "favouriteValue",
                                            "plural": false,
                                            "selections": [
                                                v34 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ]
                                        },
                                        v31 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v27 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "tabs_businessHorizontalNav_TabsContent_jiraQueryFragment"
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v10 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            v11 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v12 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataByKey.projectId"
                                            },
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ ,
                                            v15 /*: any*/ ,
                                            v16 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "projectDataById",
                                        "args": v17 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": [
                                            v11 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v12 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataById.projectId"
                                            },
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ ,
                                            v15 /*: any*/ ,
                                            v16 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            v18 /*: any*/ 
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v8 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v18 /*: any*/ ,
                        {
                            "condition": "useContainerNavigation",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "navigationItems",
                                    "args": v20 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "jwmSavedViewsByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        v30 /*: any*/ ,
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "navigationItems",
                                    "args": v20 /*: any*/ ,
                                    "filters": [
                                        "cloudId",
                                        "projectIdOrKey"
                                    ],
                                    "handle": "connection",
                                    "key": "tabs_jiraNavigation__navigationItems",
                                    "kind": "LinkedHandle",
                                    "name": "jwmSavedViewsByProject"
                                }
                            ]
                        },
                        {
                            "condition": "useContainerNavigation",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "input",
                                            "variableName": "containerNavigationInput"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraContainerNavigationResult"
                                        },
                                        v21 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v22 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                {
                                                    "args": [
                                                        v19 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraNavigationItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "navigationItems",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraNavigationItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        v30 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v29 /*: any*/ ,
                                            "type": "QueryError"
                                        },
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "projectDataByKey",
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": v36 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "projectDataById",
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": v36 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "564c4bba54aaf136169eca322afbc10e1b8b603a6bd94e7f23ec1e1bc583640e",
            "metadata": {},
            "name": "projectNavigation_horizontalNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7232ceddc504ece4$var$node.hash = "e138dacf58ff4b5e58b6cb7d376e97bd";
var $7232ceddc504ece4$export$2e2bcd8739ae039 = $7232ceddc504ece4$var$node;

});


parcelRegister("91fCW", function(module, exports) {

$parcel$export(module.exports, "storageDetailsResource", () => $24b210595251f2b8$export$76c871115d0c70a1);
$parcel$export(module.exports, "useStorageDetails", () => $24b210595251f2b8$export$8c295c187914aac1);

var $lB25E = parcelRequire("lB25E");

var $gs6RW = parcelRequire("gs6RW");
const $24b210595251f2b8$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_INSTANCE_STORAGE';
const $24b210595251f2b8$export$76c871115d0c70a1 = (0, $lB25E.createResource)({
    type: $24b210595251f2b8$var$RESOURCE_TYPE_KEY,
    getKey: ()=>$24b210595251f2b8$var$RESOURCE_TYPE_KEY,
    getData: async (_, { tenantContext: { appEditions: appEditions } })=>(0, $gs6RW.fetchStorageDetails)(appEditions),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $24b210595251f2b8$export$8c295c187914aac1 = ()=>(0, $lB25E.useResource)($24b210595251f2b8$export$76c871115d0c70a1);

});
parcelRegister("gs6RW", function(module, exports) {

$parcel$export(module.exports, "fetchStorageDetails", () => $f8699ff0bc3b5274$export$576d1c3de6af9760);

var $dlVOn = parcelRequire("dlVOn");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6WXNs = parcelRequire("6WXNs");

const $f8699ff0bc3b5274$export$576d1c3de6af9760 = async (appEditions)=>{
    try {
        if (appEditions?.core !== (0, $6WXNs.FREE_EDITION)) return null;
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/latest?query', {
            body: JSON.stringify({
                query: (0, $c9625ef7268a5b88$export$2b91517d6d5b4365),
                variables: {
                    productKey: 'jira-core'
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        if (response.errors != null) {
            const error = response.errors?.[0];
            const isClientError = error?.extensions?.statusCode >= 400 && error?.extensions?.statusCode < 500;
            if (!isClientError) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        }
        const usageLimit = response?.data?.attachmentStorage;
        if (usageLimit && usageLimit?.allowed) {
            const percentageUsed = Math.round(usageLimit?.used / usageLimit.allowed * 100);
            return percentageUsed;
        }
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('getStorageAmountService', 'Something went wrong while fetching storage amount');
        (0, $guiFP.default)({
            meta: {
                id: 'getStorageAmountService',
                packageName: 'jiraRouterResourcesBusinessStorageDetails',
                teamName: 'jira-warepil'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $c9625ef7268a5b88$export$2b91517d6d5b4365 = `
query Storage($productKey: String!) {
  attachmentStorage(productKey: $productKey) {
    used
    allowed
    isUnlimited
  }
}`;



parcelRegister("2JncP", function(module, exports) {

$parcel$export(module.exports, "projectCreatePermissionsResource", () => $76240f0f6e8ab8e1$export$f6c05eaea53ab4ae);
$parcel$export(module.exports, "useProjectCreatePermissionsResource", () => $76240f0f6e8ab8e1$export$2bd0d3b374549a68);

var $lB25E = parcelRequire("lB25E");


const $76240f0f6e8ab8e1$var$getDataLoader = ()=>(parcelRequire("iHpyh"));
const $76240f0f6e8ab8e1$export$f6c05eaea53ab4ae = (0, $lB25E.createResource)({
    type: (0, $3eff975f98a7cc60$export$8bc44dee8c6d28f),
    getKey: ()=>'state',
    getDataLoader: $76240f0f6e8ab8e1$var$getDataLoader,
    maxAge: Infinity
});
const $76240f0f6e8ab8e1$export$2bd0d3b374549a68 = ()=>(0, $lB25E.useResource)($76240f0f6e8ab8e1$export$f6c05eaea53ab4ae);

});
const $3eff975f98a7cc60$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';

parcelRegister("iHpyh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8avE4").then(()=>parcelRequire('45aM7'));

});



parcelRegister("eSTky", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hmZTB")
]).then(()=>parcelRequire('3c0Jo'));

});

parcelRegister("hRe6W", function(module, exports) {

$parcel$export(module.exports, "queuesNavigationItems", () => $e1c5e34342843ed0$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $e1c5e34342843ed0$export$1f9ab301771fe42e);
$parcel$export(module.exports, "issueListSsrResource", () => $e1c5e34342843ed0$export$3d03cbaac8581e65);

var $illlw = parcelRequire("illlw");

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $2Vm6a = parcelRequire("2Vm6a");

const $e1c5e34342843ed0$var$getDataLoader = ()=>(parcelRequire("ebN6x"));

const $e1c5e34342843ed0$var$getPriorityGroupDataLoader = ()=>(parcelRequire("egdVl"));

const $e1c5e34342843ed0$var$fetchIssueListDataLoader = ()=>(parcelRequire("9BNnQ"));
const $e1c5e34342843ed0$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $9zYls.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.queueId', '')}`;
const $e1c5e34342843ed0$export$4fed8be571897bef = (0, $lB25E.createResource)({
    type: (0, $2Vm6a.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
        (0, $9zYls.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $e1c5e34342843ed0$var$getDataLoader,
    maxAge: (0, $2Vm6a.ONE_DAY_IN_MILLIS)
});
const $e1c5e34342843ed0$export$1f9ab301771fe42e = (0, $lB25E.createResource)({
    type: (0, $2Vm6a.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $9zYls.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $e1c5e34342843ed0$var$getPriorityGroupDataLoader,
    maxAge: (0, $2Vm6a.ONE_DAY_IN_MILLIS),
    isBrowserOnly: true
});
const $e1c5e34342843ed0$export$3d03cbaac8581e65 = (0, $lB25E.createResource)({
    type: (0, $2Vm6a.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $e1c5e34342843ed0$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: $e1c5e34342843ed0$var$fetchIssueListDataLoader,
    maxAge: 0,
    // run this resource from server only
    skipBrowser: true
});

});
parcelRegister("2Vm6a", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $447a57e3617be5c6$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $447a57e3617be5c6$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $447a57e3617be5c6$export$2733615da5b906f0);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $447a57e3617be5c6$export$5a00268156ea5027);
const $447a57e3617be5c6$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $447a57e3617be5c6$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $447a57e3617be5c6$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $447a57e3617be5c6$export$5a00268156ea5027 = 86400000;

});

parcelRegister("ebN6x", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("886YZ").then(()=>parcelRequire('hgRsr'));

});

parcelRegister("egdVl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("d9Mq1").then(()=>parcelRequire('ioDaq'));

});

parcelRegister("9BNnQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gtAlU").then(()=>parcelRequire('c2gbR'));

});


parcelRegister("fXKgc", function(module, exports) {

$parcel$export(module.exports, "browseProjectRedirectRoute", () => $d7a8c211966f4d11$export$f9cac37753487f39);

var $exb0h = parcelRequire("exb0h");
const $d7a8c211966f4d11$export$f9cac37753487f39 = {
    group: (0, $exb0h.ROUTE_GROUPS_REDIRECTS),
    name: (0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
    path: '/browse/:projectKey([^-/]+)',
    exact: true,
    isRedirect: true
};

});

parcelRegister("4mBNF", function(module, exports) {

$parcel$export(module.exports, "RedirectToLastVisitedProjectPage", () => $ee5751782ee689e5$export$86041af020f4c959);

var $eUqFw = parcelRequire("eUqFw");

var $95ztp = parcelRequire("95ztp");
const $ee5751782ee689e5$export$86041af020f4c959 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $95ztp.default), null);

});
parcelRegister("95ztp", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f4696870f01fd9$export$2e2bcd8739ae039);

var $lB25E = parcelRequire("lB25E");

var $fNXJ9 = parcelRequire("fNXJ9");
var $79f4696870f01fd9$export$2e2bcd8739ae039 = (0, $lB25E.withRouter)((0, $fNXJ9.default));

});
parcelRegister("fNXJ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c87fe0adf992b9c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $53ciZ = parcelRequire("53ciZ");

var $hknOo = parcelRequire("hknOo");

var $ICvxP = parcelRequire("ICvxP");

var $e91YZ = parcelRequire("e91YZ");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");

var $apShl = parcelRequire("apShl");


var $7zXhs = parcelRequire("7zXhs");
const $8c87fe0adf992b9c$var$buildEndpoint = (projectKey, initialRedirect)=>`/rest/internal/2/projectlandingpage/${projectKey}${initialRedirect ? '?initialRedirect=true' : ''}`;
const $8c87fe0adf992b9c$var$allowListedSearchParams = [
    (0, $4f7acf20e25b7dd7$export$29d3926e3d72cfb),
    (0, $4f7acf20e25b7dd7$export$b3233b76460c1e7c)
];
const $8c87fe0adf992b9c$var$redirectForAnonymousUser = (projectKey, history, startTime)=>{
    const destination = `/projects/${projectKey}/issues/?filter=allissues`;
    history.replace(destination);
    // Log success
    (0, $gUUjF.default).safeInfoWithoutCustomerData((0, $4f7acf20e25b7dd7$export$25a759e49d5049db), 'History replace correctly triggered for anonymous user', {
        requestTime: (0, $7zXhs.getNow)() - startTime,
        destination: destination
    });
};
const $8c87fe0adf992b9c$export$c79af62ad7a1fe8a = (query)=>Object.fromEntries(Object.entries(query).filter(([key])=>$8c87fe0adf992b9c$var$allowListedSearchParams.some((allowedParam)=>key === allowedParam) || key.includes((0, $4f7acf20e25b7dd7$export$29d3926e3d72cfb))));
const $8c87fe0adf992b9c$export$283f1587d7a5369f = (searchQuery, queryInitializer)=>{
    const queryKeys = new URLSearchParams(searchQuery).toString();
    return queryKeys.length > 0 ? `${queryInitializer}${queryKeys}` : '';
};
class $8c87fe0adf992b9c$export$bf8d1fdc3b47a835 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { history: history, location: location, query: query, match: { params: params } } = this.props;
        // First time a project is created
        const { initial: initial } = query;
        // Clear the SSR Ready Mark if present
        (0, $ICvxP.default)((0, $hknOo.SPA_SSR_RENDERED_MARK));
        const startTime = (0, $7zXhs.getNow)();
        const projectKey = // @ts-expect-error - TS2345 - Argument of type 'string | {}' is not assignable to parameter of type 'string'.
        params.projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse((0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(location, 'search', {})).projectKey;
        if (!params.projectKey) (0, $gUUjF.default).safeInfoWithoutCustomerData((0, $4f7acf20e25b7dd7$export$25a759e49d5049db), 'queryString', {
            duration: (0, $7zXhs.getNow)() - startTime
        });
        if (projectKey) (0, $2OdyW.default)($8c87fe0adf992b9c$var$buildEndpoint(projectKey, !!initial)).then((response)=>{
            const endTime = (0, $7zXhs.getNow)();
            let searchQueryParams = '';
            const searchQuery = $8c87fe0adf992b9c$export$c79af62ad7a1fe8a(query);
            const queryInitializer = response.data.url.includes('?') ? '&' : '?';
            searchQueryParams = $8c87fe0adf992b9c$export$283f1587d7a5369f(searchQuery, queryInitializer);
            const destination = response.data.url + searchQueryParams;
            history.replace(destination);
            // Log success
            (0, $gUUjF.default).safeInfoWithoutCustomerData((0, $4f7acf20e25b7dd7$export$25a759e49d5049db), 'History replace correctly triggered', {
                requestTime: endTime - startTime,
                destination: destination
            });
        }, (error)=>{
            const endTime = (0, $7zXhs.getNow)();
            if ((0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)().isAnonymous) $8c87fe0adf992b9c$var$redirectForAnonymousUser(projectKey, history, startTime);
            else // Log failures
            (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $4f7acf20e25b7dd7$export$25a759e49d5049db), `Error on request. Request time: ${endTime - startTime}`, error);
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
            name: "last-visited-project-page-redirect"
        });
    }
}
var $8c87fe0adf992b9c$export$2e2bcd8739ae039 = $8c87fe0adf992b9c$export$bf8d1fdc3b47a835;

});
const $4f7acf20e25b7dd7$export$25a759e49d5049db = 'spa-apps.common.redirect.last-visited-project-page';
const $4f7acf20e25b7dd7$export$29d3926e3d72cfb = 'search';
const $4f7acf20e25b7dd7$export$b3233b76460c1e7c = 'showProjectBuilder';

parcelRegister("7zXhs", function(module, exports) {

$parcel$export(module.exports, "getNow", () => $fc9902cea8bd7934$export$3991332aae1fc754);
const $fc9902cea8bd7934$export$3991332aae1fc754 = ()=>Date.now();

});




parcelRegister("3IGoo", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("geef3").then(()=>parcelRequire('bMsJH'));

});

parcelRegister("fwGk6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5nuyL").then(()=>parcelRequire('gMrqM'));

});

parcelRegister("7IBv4", function(module, exports) {

$parcel$export(module.exports, "ThemedLazySkeleton", () => $3cae0559b4ea3966$export$ddeb5d943c4f17e3);
/* ThemedLazySkeleton.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $apShl = parcelRequire("apShl");

var $90G8g = parcelRequire("90G8g");
const $3cae0559b4ea3966$export$ddeb5d943c4f17e3 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cae0559b4ea3966$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "themed-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90G8g.ThemedSpinner), null))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cae0559b4ea3966$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("90G8g", function(module, exports) {

$parcel$export(module.exports, "ThemedSpinner", () => $3714b0c4b26abbc6$export$271c7b154ad6c401);
/* ThemedSpinner.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
const $3714b0c4b26abbc6$export$271c7b154ad6c401 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3714b0c4b26abbc6$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large",
        ...props,
        testId: "business-theme-components.ui.themed-spinner"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3714b0c4b26abbc6$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1xjgkwex",
            __cmplp.className
        ])
    });
});

});


parcelRegister("cOkcY", function(module, exports) {

$parcel$export(module.exports, "workflowIssuesResource", () => $8b908badba650023$export$49027035af709702);
$parcel$export(module.exports, "useWorkflowIssues", () => $8b908badba650023$export$86b7de71bf71360d);

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $g5IQt = parcelRequire("g5IQt");
const $8b908badba650023$var$RESOURCE_TYPE_KEY = 'BUSINESS_WORKFLOW_ISSUES';

const $8b908badba650023$export$49027035af709702 = (0, $lB25E.createResource)({
    type: $8b908badba650023$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$8b908badba650023$var$RESOURCE_TYPE_KEY}_${projectKey}`;
    },
    getDataLoader: ()=>Promise.resolve((parcelRequire("g5IQt"))),
    getData: (0, $g5IQt.default),
    maxAge: 1000,
    isBrowserOnly: true
});
const $8b908badba650023$export$86b7de71bf71360d = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $lB25E.useResource)($8b908badba650023$export$49027035af709702);

});
parcelRegister("g5IQt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e23c65cca34122d1$export$2e2bcd8739ae039);

var $499dl = parcelRequire("499dl");

var $6iz4v = parcelRequire("6iz4v");

var $7byHA = parcelRequire("7byHA");

var $5yh8X = parcelRequire("5yh8X");

var $1aPBP = parcelRequire("1aPBP");
const $e23c65cca34122d1$var$EMPTY_DATA = {
    workflows: [],
    lastChangedTime: null
};
function $e23c65cca34122d1$var$getEarlyPreload() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const earlyPreloadPromise = window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__ = null;
        return earlyPreloadPromise.then((response)=>{
            if (!response.success) {
                if (response.error.status === 304) throw new (0, $499dl.Unchanged)('Workflow issues have not changed since the last request');
                throw new (0, $7byHA.default)(response.error.status);
            }
            return {
                workflows: response.workflows,
                lastChangedTime: null
            };
        });
    }
    return null;
}
function $e23c65cca34122d1$var$fetchData(projectKey) {
    const earlyPreload = $e23c65cca34122d1$var$getEarlyPreload();
    if (earlyPreload !== null) return earlyPreload;
    return (0, $499dl.fetchWorkflowIssues)(projectKey);
}
async function $e23c65cca34122d1$export$2e2bcd8739ae039({ match: match }, { tenantContext: tenantContext }) {
    const { isAnonymous: isAnonymous } = tenantContext;
    if (isAnonymous) return $e23c65cca34122d1$var$EMPTY_DATA;
    try {
        (0, $6iz4v.setMark)((0, $5yh8X.prefetchApiStartMark));
        const workflows = await $e23c65cca34122d1$var$fetchData(match.params.projectKey ?? '');
        (0, $6iz4v.setMark)((0, $5yh8X.prefetchApiReadyMark));
        return workflows;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $1aPBP.createResourceError)({
            component: 'spa.view.routes.business.board-workflows.getData',
            message: 'An error was thrown while prefetching board data',
            name: 'ResourceError'
        }, error);
    }
}

});
parcelRegister("499dl", function(module, exports) {

$parcel$export(module.exports, "Unchanged", () => $2a0a0dafb1214e48$export$eccd6db33b8f6a89);
$parcel$export(module.exports, "fetchWorkflowIssues", () => $2a0a0dafb1214e48$export$17e2e8212d93f58d);

var $asu8X = parcelRequire("asu8X");


var $ZvXTS = parcelRequire("ZvXTS");

var $fVqUX = parcelRequire("fVqUX");

var $7byHA = parcelRequire("7byHA");
class $2a0a0dafb1214e48$export$eccd6db33b8f6a89 extends Error {
}
const $2a0a0dafb1214e48$export$17e2e8212d93f58d = async (projectKey, ifChangedSince)=>{
    (0, $asu8X.di)(fetch);
    try {
        (0, $ZvXTS.markViewMetric)('jwm-board', (0, $78bb8734d7176028$export$23e322eb7c526958));
        const url = `/rest/board-api/1/board/${projectKey}/workflows?excludeLabels=true`;
        const response = await fetch(url, {
            ...(0, $fVqUX.default),
            headers: ifChangedSince ? {
                'x-aif-changed-since': ifChangedSince
            } : undefined
        });
        if (!response.ok) {
            if (response.status === 304) throw new $2a0a0dafb1214e48$export$eccd6db33b8f6a89('Workflow issues have not changed since the last request');
            throw new (0, $7byHA.default)(response.status);
        }
        const lastChangedTime = response.headers.get('x-alast-changed-time');
        const workflows = await response.json();
        return {
            workflows: workflows.data,
            lastChangedTime: lastChangedTime
        };
    } finally{
        (0, $ZvXTS.markViewMetric)('jwm-board', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
    }
};

});
const $78bb8734d7176028$export$747aad128920134d = 3000;
const $78bb8734d7176028$export$e4f8d353742c04ac = 4000;
const $78bb8734d7176028$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $78bb8734d7176028$export$23e322eb7c526958 = 'REQUEST_START';
const $78bb8734d7176028$export$83ca21a50372ea3b = 'REQUEST_END';
const $78bb8734d7176028$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $78bb8734d7176028$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $78bb8734d7176028$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $78bb8734d7176028$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $78bb8734d7176028$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $78bb8734d7176028$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("ZvXTS", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", () => $1ace7e3b95066345$export$2878bf482e539059);
$parcel$export(module.exports, "markViewMetric", () => $1ace7e3b95066345$export$8d15b4fb25f90514);

var $lNfG4 = parcelRequire("lNfG4");

const $1ace7e3b95066345$var$slo = {
    fmp: {
        initial: {
            threshold: (0, $78bb8734d7176028$export$747aad128920134d)
        },
        transition: {
            threshold: (0, $78bb8734d7176028$export$747aad128920134d)
        }
    },
    tti: {
        initial: {
            threshold: (0, $78bb8734d7176028$export$e4f8d353742c04ac)
        },
        transition: {
            threshold: (0, $78bb8734d7176028$export$e4f8d353742c04ac)
        }
    }
};
const $1ace7e3b95066345$var$timings = [
    {
        key: (0, $78bb8734d7176028$export$540ffd289e5e0562),
        startMark: (0, $78bb8734d7176028$export$23e322eb7c526958),
        endMark: (0, $78bb8734d7176028$export$83ca21a50372ea3b)
    },
    {
        key: (0, $78bb8734d7176028$export$821ca6ff41f300ec),
        startMark: (0, $78bb8734d7176028$export$7b887ee35f2b465e),
        endMark: (0, $78bb8734d7176028$export$ac953882305d6102)
    },
    {
        key: (0, $78bb8734d7176028$export$7f7f60b5526c5ee3),
        startMark: (0, $78bb8734d7176028$export$b78f0bbf209e5f4),
        endMark: (0, $78bb8734d7176028$export$88ea1e280513690f)
    }
];
const $1ace7e3b95066345$export$2878bf482e539059 = {
    'approvals-view': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.approvals-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    summary: (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.summary-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'summary-embed': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.summary-view-embed',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    list: (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.list-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'list-embed': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.list-embed-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'software-list': (0, $lNfG4.metrics).pageLoad({
        key: 'jsw.list-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'software-list-embed': (0, $lNfG4.metrics).pageLoad({
        key: 'jsw.list-view-embed',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    timeline: (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.timeline-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'timeline-embed': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.timeline-embed-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    calendar: (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.calendar-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'calendar-embed': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.calendar-embed-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    form: (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.form-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'form-submit': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.form-submit-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'form-submit-embed': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.form-submit-embed-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'form-directory': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.form-directory-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    board: (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.board-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'jwm-board': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.jwm-board',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'jwm-board-embed': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.jwm-board-embed',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'jwm-pages': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.jwm-pages',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    // TODO: will be removed with sploverview-decouple-calendar-perf-metrics
    'software-plan-calendar': (0, $lNfG4.metrics).pageLoad({
        key: 'jsw.plan-calendar-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    })
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1ace7e3b95066345$var$startedMarks = {};
const $1ace7e3b95066345$export$8d15b4fb25f90514 = (view, mark)=>{
    const markKey = `${view}-${mark}`;
    // prevent overriding marks when markViewMetric() is called many times with the same param
    if ($1ace7e3b95066345$var$startedMarks[markKey]) return;
    $1ace7e3b95066345$var$startedMarks[markKey] = true;
    const metric = $1ace7e3b95066345$export$2878bf482e539059[view];
    metric?.mark(mark);
};

});


parcelRegister("5yh8X", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $b15a1f5ef3252a04$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $b15a1f5ef3252a04$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $b15a1f5ef3252a04$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $b15a1f5ef3252a04$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $b15a1f5ef3252a04$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $b15a1f5ef3252a04$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $b15a1f5ef3252a04$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $b15a1f5ef3252a04$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $b15a1f5ef3252a04$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $b15a1f5ef3252a04$export$4eb8d44ddb14424a);


var $1cNJ6 = parcelRequire("1cNJ6");
const $b15a1f5ef3252a04$export$7e50945a65dd40e = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$ff834eccc35b9089));
const $b15a1f5ef3252a04$export$17cbe723d23101d8 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$86b05e34d462ead8));
const $b15a1f5ef3252a04$export$887fadb22e7c7735 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$d6a604a7d9a390fb));
const $b15a1f5ef3252a04$export$bd099c0a906f4b3f = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$3ae43cc1782d058f));
const $b15a1f5ef3252a04$export$d23ef9e7633e30e7 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$363f6703ffa600be));
const $b15a1f5ef3252a04$export$319da6d901948a6d = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$e87b74567b79c8));
const $b15a1f5ef3252a04$export$f0b6622cdc5c7e4f = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$99fe642459a8b02));
const $b15a1f5ef3252a04$export$37e82663aa1e79a8 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$ab1f5705fc8e0571));
const $b15a1f5ef3252a04$export$21146514eacceb12 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$8c3a9046da692c35));
const $b15a1f5ef3252a04$export$4eb8d44ddb14424a = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$5aa497d1efdcc5bf));

});

parcelRegister("1aPBP", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $ab2f50dfea4673ae$export$13487d18466bc8a5);

var $gUUjF = parcelRequire("gUUjF");
class $ab2f50dfea4673ae$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $ab2f50dfea4673ae$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $ab2f50dfea4673ae$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});



parcelRegister("XJw0F", function(module, exports) {

$parcel$export(module.exports, "activityFeedResource", () => $9c7afa82c81731f6$export$928ea152e5c5de54);
$parcel$export(module.exports, "useActivityFeed", () => $9c7afa82c81731f6$export$ee1fe267047f502f);

var $1Y3Jh = parcelRequire("1Y3Jh");

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");
const $9c7afa82c81731f6$var$RESOURCE_TYPE_KEY = 'BUSINESS_ACTIVITY_FEED';
const $9c7afa82c81731f6$var$EMPTY_DATA = {
    data: [],
    pageInfo: {
        hasNextPage: false,
        endCursor: ''
    }
};
const $9c7afa82c81731f6$export$928ea152e5c5de54 = (0, $lB25E.createResource)({
    type: $9c7afa82c81731f6$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$9c7afa82c81731f6$var$RESOURCE_TYPE_KEY}_${projectKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return $9c7afa82c81731f6$var$EMPTY_DATA;
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(match, query);
        return (0, $1Y3Jh.fetchActivityFeed)(null, projectKey);
    },
    maxAge: 5000,
    isBrowserOnly: true
});
const $9c7afa82c81731f6$export$ee1fe267047f502f = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $lB25E.useResource)($9c7afa82c81731f6$export$928ea152e5c5de54);

});
parcelRegister("1Y3Jh", function(module, exports) {

$parcel$export(module.exports, "fetchActivityFeed", () => $d46a68c0a8135af1$export$967c92ed76f908b6);

var $asu8X = parcelRequire("asu8X");

var $7byHA = parcelRequire("7byHA");

var $fUPTl = parcelRequire("fUPTl");
const $d46a68c0a8135af1$var$PAGE_SIZE = 10;
const $d46a68c0a8135af1$var$CONTENT_TYPE = 'application/atom+xml; charset=UTF-8';
const $d46a68c0a8135af1$var$STREAM_PROVIDERS = 'thirdparty issues';
const $d46a68c0a8135af1$export$967c92ed76f908b6 = (after, projectKey)=>{
    (0, $asu8X.di)(fetch);
    const firstIndex = after != null ? Number(after) : 0;
    const maxResults = firstIndex + $d46a68c0a8135af1$var$PAGE_SIZE;
    return fetch(// @ts-expect-error - TS2345: Types of property 'maxResults' are incompatible. Type 'number' is not assignable to type 'string'.
    `/plugins/servlet/streams?${new URLSearchParams({
        maxResults: maxResults,
        relativeLinks: true,
        streams: `key IS ${projectKey}`,
        providers: $d46a68c0a8135af1$var$STREAM_PROVIDERS
    }).toString()}`, {
        headers: {
            'content-type': $d46a68c0a8135af1$var$CONTENT_TYPE
        }
    }).then((response)=>{
        if (!response.ok) throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`);
        return response.text();
    }).then((rawResponse)=>{
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(rawResponse, 'application/xml');
        const entries = (0, $fUPTl.transformData)(xmlDoc);
        return {
            data: entries,
            pageInfo: {
                hasNextPage: entries.length >= maxResults,
                endCursor: String(entries.length)
            }
        };
    });
};

});
parcelRegister("fUPTl", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $e2838ca29310a45c$export$3ceb62baab058c6b);
const $e2838ca29310a45c$export$3ceb62baab058c6b = (xmlDoc)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'ActivityFeedItem'.
    const result = [];
    // Typecheck with project references identifies this as error but existing typecheck is not so doesnt allow ts-expect-error, so used ts-ignore
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Type 'NodeListOf<Element>' must have a '[Symbol.iterator]()' method that returns an iterator.
    for (const entry of xmlDoc.querySelectorAll('entry')){
        const id = entry.querySelector('id')?.textContent ?? '';
        const published = entry.querySelector('published')?.textContent ?? '';
        const name = entry.querySelector('author > name')?.textContent ?? '';
        const title = entry.querySelector('title')?.textContent ?? '';
        const iconUrl = entry.querySelector('[rel="http://streams.atlassian.com/syndication/icon"]')?.getAttribute('href') ?? '';
        const content = entry.querySelector('content')?.textContent;
        const feedItem = {
            id: id,
            author: {
                name: name,
                avatarUrl: ''
            },
            published: published,
            title: title,
            iconUrl: iconUrl,
            content: content
        };
        entry.querySelectorAll('author > link[rel=photo]').forEach((link)=>{
            if (link.getAttribute('media:height') === '48') feedItem.author.avatarUrl = link.getAttribute('href') ?? '';
        });
        result.push(feedItem);
    }
    return result;
};

});



parcelRegister("dIJG1", function(module, exports) {

$parcel$export(module.exports, "summaryDataResource", () => $7c3b553078399e73$export$cdfee963587c1ea4);
$parcel$export(module.exports, "useSummaryData", () => $7c3b553078399e73$export$c82acf736eaa253c);

var $dEAew = parcelRequire("dEAew");

var $1aPBP = parcelRequire("1aPBP");

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");
const $7c3b553078399e73$var$RESOURCE_TYPE_KEY = 'BUSINESS_SUMMARY_DATA';
const $7c3b553078399e73$var$EMPTY_DATA = {
    overviewItems: null,
    issuesByStatus: null,
    issuesByPriority: null,
    issuesByAssignee: null,
    issuesByType: null
};
const $7c3b553078399e73$export$cdfee963587c1ea4 = (0, $lB25E.createResource)({
    type: $7c3b553078399e73$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$7c3b553078399e73$var$RESOURCE_TYPE_KEY}_${projectKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return $7c3b553078399e73$var$EMPTY_DATA;
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(match, query);
        const jqlContext = `project = "${projectKey}"`;
        try {
            return await (0, $dEAew.fetchSummaryPageData)({
                cloudId: cloudId,
                jqlContext: jqlContext,
                projectKey: projectKey
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            throw (0, $1aPBP.createResourceError)({
                component: 'spa.view.routes.business.summary-data.getData',
                message: `An error was thrown while prefetching the summary data. Status code: ${error?.statusCode}. Message: ${error?.message}`,
                name: 'ResourceError',
                skipSentry: isClientError
            });
        }
    },
    maxAge: 5000,
    isBrowserOnly: true
});
const $7c3b553078399e73$export$c82acf736eaa253c = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $lB25E.useResource)($7c3b553078399e73$export$cdfee963587c1ea4);

});
parcelRegister("dEAew", function(module, exports) {

$parcel$export(module.exports, "fetchSummaryPageData", () => $171e35a2047094d8$export$a3fa5b61d6f8cf86);

var $dlVOn = parcelRequire("dlVOn");

var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");


var $bQjFZ = parcelRequire("bQjFZ");

var $1l5Ta = parcelRequire("1l5Ta");
const $171e35a2047094d8$var$QUERY_NAME = 'SummaryPageData';
const $171e35a2047094d8$export$a3fa5b61d6f8cf86 = async ({ cloudId: cloudId, jqlContext: jqlContext, projectKey: projectKey })=>{
    // We must use UNSAFE_noExposureExp to check if experiment is enabled without actually firing exposure events
    const [expInlineStatusConfig] = (0, $79xbN.UNSAFE_noExposureExp)('summary_page_inline_status');
    const isExperimentSummaryPageInlineStatusEnabled = expInlineStatusConfig.get((0, $1Iui1.COHORT), (0, $1Iui1.NOT_ENROLLED)) === (0, $1Iui1.VARIATION);
    const response = await (0, $lRmyA.performPostRequest)(`/rest/gira/1/?operation=${$171e35a2047094d8$var$QUERY_NAME}`, {
        body: JSON.stringify({
            query: (0, $bQjFZ.SUMMARY_PAGE_DATA_QUERY),
            variables: {
                cloudId: cloudId,
                jqlContext: jqlContext,
                projectKey: projectKey,
                doneThisWeekJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$d5aac1de7fafa2b0)}`,
                updatedThisWeekJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$b10a33c38cc20983)}`,
                createdThisWeekJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$48eb4b4c930c6378)}`,
                dueThisWeekJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$2573f5b8014b4068)}`,
                issuesByStatusJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$8cca17e1017ba894)}`,
                issuesByPriorityJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$c49e48bfa75ab23c)}`,
                issuesByAssigneeJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$c49e48bfa75ab23c)}`,
                issuesByTypeJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$c49e48bfa75ab23c)}`,
                pagedDataPageSize: (0, $41d3054f19febaab$export$c0ecd9bd08a86184),
                isWorkflowsAndIssueTypesCountEnabled: // Parent level feature gate to control fetching of workflows and issue counts independent of experiment
                (0, $eI5EY.fg)('jira-fetch-workflow-and-issuetypes') && isExperimentSummaryPageInlineStatusEnabled
            }
        })
    });
    if (response.errors != null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
    if (response.data == null) throw new Error('GraphQL response has no data');
    return (0, $1l5Ta.transformData)(response.data);
};

});
parcelRegister("1Iui1", function(module, exports) {

$parcel$export(module.exports, "COHORT", () => $1524157debf2fd00$export$3d370c33621572df);
$parcel$export(module.exports, "NOT_ENROLLED", () => $1524157debf2fd00$export$5b7423264d48ab04);
$parcel$export(module.exports, "CONTROL", () => $1524157debf2fd00$export$43f367b3e957f219);
$parcel$export(module.exports, "EXPERIMENT", () => $1524157debf2fd00$export$9ba2bc3b1bdc1519);
$parcel$export(module.exports, "VARIATION", () => $1524157debf2fd00$export$fa04ad826acc90da);

var $1ybV0 = parcelRequire("1ybV0");
const $1524157debf2fd00$export$3d370c33621572df = 'cohort';
const $1524157debf2fd00$export$5b7423264d48ab04 = 'not-enrolled';
const $1524157debf2fd00$export$43f367b3e957f219 = 'control';
const $1524157debf2fd00$export$9ba2bc3b1bdc1519 = 'experiment';
const $1524157debf2fd00$export$fa04ad826acc90da = 'variation';
const $1524157debf2fd00$export$6486974e39493fa6 = 'variation-1';
const $1524157debf2fd00$export$7d994996134ad562 = 'variation-2';
const $1524157debf2fd00$export$795e7d69b248dcd0 = 'variation-3';
const $1524157debf2fd00$export$c9c947c57470b787 = 'variation-4';
const $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $1524157debf2fd00$export$5b7423264d48ab04,
    $1524157debf2fd00$export$43f367b3e957f219,
    $1524157debf2fd00$export$9ba2bc3b1bdc1519,
    $1524157debf2fd00$export$fa04ad826acc90da,
    $1524157debf2fd00$export$6486974e39493fa6,
    $1524157debf2fd00$export$7d994996134ad562,
    $1524157debf2fd00$export$795e7d69b248dcd0,
    $1524157debf2fd00$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1524157debf2fd00$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $1ybV0.getMultivariateFeatureFlag)(experimentFeatureFlag, $1524157debf2fd00$export$5b7423264d48ab04, validExperimentGroups);

});

const $41d3054f19febaab$export$d5aac1de7fafa2b0 = 'statusCategory = Done AND statusCategoryChangedDate >= -1w';
const $41d3054f19febaab$export$b10a33c38cc20983 = 'updatedDate >= -1w';
const $41d3054f19febaab$export$48eb4b4c930c6378 = 'createdDate >= -1w';
const $41d3054f19febaab$export$2573f5b8014b4068 = 'statusCategory != Done AND (duedate >= 0d AND duedate < 1w)';
const $41d3054f19febaab$export$8cca17e1017ba894 = '(statusCategory != Done OR (statusCategory = Done AND statusCategoryChangedDate >= -2w))';
const $41d3054f19febaab$export$c49e48bfa75ab23c = 'statusCategory != Done';
const $41d3054f19febaab$export$c0ecd9bd08a86184 = 8;
const $41d3054f19febaab$export$27f4fb65edc908d0 = `
  fragment IssuesByAssigneeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on UserField {
          userValue {
            accountId,
            avatarUrl,
            displayName
          }
        }
      }
      id,
      totalCount
    }
  }
`;
const $41d3054f19febaab$export$5b2a5373659a0414 = `
  fragment IssuesByTypeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on IssueTypeField {
              id
              name
              iconUrl
        }
      }
      id,
      totalCount
    }
  }
`;

parcelRegister("bQjFZ", function(module, exports) {

$parcel$export(module.exports, "SUMMARY_PAGE_DATA_QUERY", () => $438d71e3f7358cc6$export$7ea8f81ff5bf6361);

const $438d71e3f7358cc6$export$7ea8f81ff5bf6361 = `
  query JiraBusinessSummaryPageData($cloudId: ID!, $jqlContext: String!, $doneThisWeekJql: String!, $updatedThisWeekJql: String!, $createdThisWeekJql: String!, $dueThisWeekJql: String!, $issuesByStatusJql: String!, $issuesByPriorityJql: String!, $issuesByAssigneeJql: String!, $issuesByTypeJql: String!, $pagedDataPageSize: Int!, $projectKey: String!, $isWorkflowsAndIssueTypesCountEnabled: Boolean!) {
    jira {
      jqlBuilder(cloudId: $cloudId) {
        status: fieldValues(
          jqlTerm: "status"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
      }
      doneThisWeek: jwmViewItems(cloudId: $cloudId, jql: $doneThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      updatedThisWeek: jwmViewItems(cloudId: $cloudId, jql: $updatedThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      createdThisWeek: jwmViewItems(cloudId: $cloudId, jql: $createdThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      dueThisWeek: jwmViewItems(cloudId: $cloudId, jql: $dueThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      totalUnresolvedIssues: jwmViewItems(cloudId: $cloudId, jql: $issuesByAssigneeJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      projectIssueTypesCount: jiraProjectByKey(key: $projectKey, cloudId: $cloudId) @include(if: $isWorkflowsAndIssueTypesCountEnabled) {
        issueTypes {
          totalCount
        }
      }
    }
    issuesByStatus: jwmItemGroups(jql: $issuesByStatusJql, groupByFieldId: "status", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on StatusField {
              name
              category {
                key
              }
          }
        }
        totalCount
      }
    }
    issuesByPriority: jwmItemGroups(jql: $issuesByPriorityJql, groupByFieldId: "priority", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on PriorityField {
            iconUrl
            name
          }
        }
        totalCount
      }
    }
    issuesByAssignee: jwmItemGroups(jql: $issuesByAssigneeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
    issuesByType: jwmItemGroups(jql: $issuesByTypeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
    worklowsCount: jwmWorkflowWithIssueTypes(projectIdOrKey: $projectKey) @include(if: $isWorkflowsAndIssueTypesCountEnabled) {
      totalCount
    }
  }

  ${(0, $41d3054f19febaab$export$27f4fb65edc908d0)}
  ${(0, $41d3054f19febaab$export$5b2a5373659a0414)}
`;

});

parcelRegister("1l5Ta", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $584624ffc9ba9478$export$3ceb62baab058c6b);

var $c2uS5 = parcelRequire("c2uS5");
const $584624ffc9ba9478$export$3ceb62baab058c6b = (data)=>({
        overviewItems: {
            doneThisWeek: data.jira.doneThisWeek?.totalCount ?? 0,
            updatedThisWeek: data.jira.updatedThisWeek?.totalCount ?? 0,
            createdThisWeek: data.jira.createdThisWeek?.totalCount ?? 0,
            dueThisWeek: data.jira.dueThisWeek?.totalCount ?? 0
        },
        issuesByStatus: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data.issuesByStatus?.nodes.map((node)=>({
                id: node.id,
                count: node.totalCount,
                status: {
                    name: node.field.name,
                    jqlTerm: data.jira.jqlBuilder?.status.edges.find((status)=>status.node.displayName === node.field.name)?.node.jqlTerm,
                    category: {
                        key: node.field.category.key
                    }
                }
            })) ?? null,
        issuesByPriority: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data.issuesByPriority?.nodes.map((node)=>({
                id: node.id,
                count: node.totalCount,
                priority: {
                    name: node.field.name,
                    iconUrl: node.field.iconUrl
                }
            })) ?? null,
        issuesByAssignee: data.issuesByAssignee ? {
            ...(0, $c2uS5.transformIssuesByAssigneeData)(data.issuesByAssignee),
            totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
        } : null,
        issuesByType: data.issuesByType ? {
            ...(0, $c2uS5.transformIssuesByTypeData)(data.issuesByType),
            totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
        } : null,
        projectIssueTypesCount: data?.jira?.projectIssueTypesCount?.issueTypes?.totalCount ?? null,
        worklowsCount: data?.worklowsCount?.totalCount ?? null
    });

});
parcelRegister("c2uS5", function(module, exports) {

$parcel$export(module.exports, "transformIssuesByAssigneeData", () => $c3955638fae38514$export$cef1c6c4edf3287b);
$parcel$export(module.exports, "transformIssuesByTypeData", () => $c3955638fae38514$export$bc7f7d59cba70a26);
const $c3955638fae38514$export$cef1c6c4edf3287b = (data)=>({
        pageInfo: {
            hasNextPage: data.pageInfo.hasNextPage,
            endCursor: data.pageInfo.endCursor
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data: data.nodes.map((node)=>({
                id: node.id,
                user: node.field.userValue ? {
                    avatarUrl: node.field.userValue.avatarUrl ?? '',
                    displayName: node.field.userValue.displayName,
                    accountId: node.field.userValue.accountId
                } : null,
                count: node.totalCount
            }))
    });
const $c3955638fae38514$export$bc7f7d59cba70a26 = (data)=>({
        pageInfo: {
            hasNextPage: data.pageInfo.hasNextPage,
            endCursor: data.pageInfo.endCursor
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data: data.nodes.map((node)=>({
                id: node.id,
                issueType: node.field ? {
                    iconUrl: node.field.iconUrl,
                    name: node.field.name,
                    id: node.field.id
                } : null,
                count: node.totalCount
            }))
    });

});




parcelRegister("dY715", function(module, exports) {

$parcel$export(module.exports, "markAsBentoBundleReady", () => $badbd94d97d705a8$export$d9ff0b3329728986);

var $hknOo = parcelRequire("hknOo");

var $2B87Z = parcelRequire("2B87Z");
let $badbd94d97d705a8$var$reportedBentoBundleReady = false;
const $badbd94d97d705a8$export$d9ff0b3329728986 = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        // Mutex for reporter
        if ($badbd94d97d705a8$var$reportedBentoBundleReady) return;
        $badbd94d97d705a8$var$reportedBentoBundleReady = true;
        (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, $hknOo.JS_EVAL_START))) {
            (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
            break;
        }
    });
    return importedBundle;
};

});

parcelRegister("bQUp7", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("eNmuD"),
    $d1Cng("dsiAd"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("4l5Cw")
]).then(()=>parcelRequire('gDUp5'));

});

parcelRegister("7KNWV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("kWrFZ"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kMAKK")
]).then(()=>parcelRequire('9zAkH'));

});

parcelRegister("iD2Ab", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iztF8").then(()=>parcelRequire('81i9P'));

});

parcelRegister("96rh5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("7jaFm")),
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jc5Tv")
]).then(()=>parcelRequire('4KsXv'));

});

parcelRegister("6wsEw", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", () => $5fcf01b1512d8afb$export$73b60789ceb8e1eb);
$parcel$export(module.exports, "jiraBusinessOverviewRedirectRoute", () => $5fcf01b1512d8afb$export$5ab0e07528c31349);

var $exb0h = parcelRequire("exb0h");
const $5fcf01b1512d8afb$export$73b60789ceb8e1eb = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT),
    path: '/jira/core/projects/:projectKey',
    exact: true,
    isRedirect: true
};
const $5fcf01b1512d8afb$export$5ab0e07528c31349 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
    path: '/jira/core/overviews/:overviewId',
    exact: true,
    isRedirect: true
};

});

parcelRegister("JL6YX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8bcjs")
]).then(()=>parcelRequire('3xdch'));

});

parcelRegister("hLS6P", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("73849")
]).then(()=>parcelRequire('hNMkR'));

});

parcelRegister("7c3cQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("ggpPc")),
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("aqaOl")
]).then(()=>parcelRequire('eDUuW'));

});

parcelRegister("8ikSD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2BIYA")
]).then(()=>parcelRequire('9SpZi'));

});

parcelRegister("ghwYt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("7owPW")
]).then(()=>parcelRequire('1jI4V'));

});

parcelRegister("k5FoF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("erpOc")
]).then(()=>parcelRequire('10aZy'));

});

parcelRegister("jvImZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9pv5E").then(()=>parcelRequire('aSD11'));

});

parcelRegister("gar4m", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("12nv9")
]).then(()=>parcelRequire('5xcCk'));

});

parcelRegister("yoNhc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("4KJB9")
]).then(()=>parcelRequire('fq00b'));

});

parcelRegister("5IfHD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("aoz7O")
]).then(()=>parcelRequire('gEf2h'));

});

parcelRegister("8K9k0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("58UdU")
]).then(()=>parcelRequire('36FLn'));

});

parcelRegister("7TGsb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jw4LJ")
]).then(()=>parcelRequire('a3nYN'));

});

parcelRegister("ebtLZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("29gzI")
]).then(()=>parcelRequire('30ifj'));

});

parcelRegister("01KSG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("6hbVD")
]).then(()=>parcelRequire('e6kDB'));

});

parcelRegister("7wsPY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("lMO6f")
]).then(()=>parcelRequire('gFMRr'));

});

parcelRegister("aaBng", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("gDG2i")
]).then(()=>parcelRequire('32q0E'));

});

parcelRegister("5jPNW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("aEruT")
]).then(()=>parcelRequire('9kgc9'));

});

parcelRegister("9Ice3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("1FMdw")
]).then(()=>parcelRequire('4LoSq'));

});

parcelRegister("4HRWR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("6wB8z")
]).then(()=>parcelRequire('YEraZ'));

});

parcelRegister("gXtGo", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("hX8k8")
]).then(()=>parcelRequire('aEWvJ'));

});

parcelRegister("eJJ4Z", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2EBPP")
]).then(()=>parcelRequire('lUiUI'));

});

parcelRegister("eqzyN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2p284")
]).then(()=>parcelRequire('2aG5K'));

});

parcelRegister("kYKYa", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDataClassificationsRoute", () => $65fd74c1895e469d$export$952eefa1907e877a);

var $exb0h = parcelRequire("exb0h");
const $65fd74c1895e469d$export$952eefa1907e877a = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_DATA_CLASSIFICATIONS),
    path: '/plugins/servlet/project-config/:projectKey/data-classifications',
    exact: true
};

});

parcelRegister("74Iqa", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("bc0KZ")
]).then(()=>parcelRequire('eQMpF'));

});

parcelRegister("e3u5r", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bL7Bw")
]).then(()=>parcelRequire('3XEFg'));

});

parcelRegister("bmKiO", function(module, exports) {

$parcel$export(module.exports, "NORMAL_EARLY_ASSET_STRATEGY", () => $3e02e9822ae54785$export$137d6d169f402a59);
$parcel$export(module.exports, "AGGRESSIVE_EARLY_ASSET_STRATEGY", () => $3e02e9822ae54785$export$ad16a91905cefb0a);
const $3e02e9822ae54785$var$COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $3e02e9822ae54785$var$VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $3e02e9822ae54785$var$PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
const $3e02e9822ae54785$var$PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;
const $3e02e9822ae54785$export$137d6d169f402a59 = [
    $3e02e9822ae54785$var$VENDOR_ASSET_REGEX,
    $3e02e9822ae54785$var$PARCEL_VENDOR_ASSET_REGEX
];
const $3e02e9822ae54785$export$ad16a91905cefb0a = [
    $3e02e9822ae54785$var$VENDOR_ASSET_REGEX,
    $3e02e9822ae54785$var$COMMON_ASSET_REGEX,
    $3e02e9822ae54785$var$PARCEL_VENDOR_ASSET_REGEX,
    $3e02e9822ae54785$var$PARCEL_COMMON_ASSET_REGEX
];

});

parcelRegister("5oyzN", function(module, exports) {

$parcel$export(module.exports, "boardDetailsResource", () => $e031e9c61226a3d6$export$6c6984c55b171c5d);
$parcel$export(module.exports, "getBoardDetailsResource", () => $e031e9c61226a3d6$export$b67eabcfc08e7c62);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $jwzNs = parcelRequire("jwzNs");

var $lB25E = parcelRequire("lB25E");
const $e031e9c61226a3d6$export$90ce361a5838e31e = async (boardId)=>{
    try {
        return await (0, $2OdyW.default)(`/rest/agile/1.0/board/${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getBoardDetailsRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $e031e9c61226a3d6$export$6c6984c55b171c5d = (0, $lB25E.createResource)({
    type: 'CLASSIC_BOARD_SETTING_BOARD_DETAILS',
    getKey: (routerContext)=>routerContext.query?.config ? 'cmp-board-settings' : 'not-cmp-board-setting',
    getData: async (routerContext)=>{
        const boardId = routerContext.match.params?.boardId ?? '';
        if (routerContext.query?.config) return $e031e9c61226a3d6$export$90ce361a5838e31e(boardId);
        return null;
    }
});
const $e031e9c61226a3d6$export$b67eabcfc08e7c62 = ()=>(0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('simplified-boards-milestone-2_07hbk'), $e031e9c61226a3d6$export$6c6984c55b171c5d);

});

parcelRegister("0fOjG", function(module, exports) {

$parcel$export(module.exports, "editModelResource", () => $a1d75259a331b884$export$ab9a4786826fd2d);
$parcel$export(module.exports, "getEditModelResource", () => $a1d75259a331b884$export$5b9bac2cc4bf4511);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $jwzNs = parcelRequire("jwzNs");

var $lB25E = parcelRequire("lB25E");
const $a1d75259a331b884$export$ddbb511f9111736a = async (boardId)=>{
    try {
        return await (0, $2OdyW.default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel.json?cardLayoutConfig=false&rapidViewId=${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getEditModelRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $a1d75259a331b884$export$ab9a4786826fd2d = (0, $lB25E.createResource)({
    type: 'CLASSIC_BOARD_SETTING_EDIT_MODEL',
    getKey: (routerContext)=>routerContext.query?.config ? 'edit-model' : 'not-edit-model',
    getData: async (routerContext)=>{
        if (routerContext.query?.config) {
            const boardId = routerContext.match.params?.boardId ?? '';
            return $a1d75259a331b884$export$ddbb511f9111736a(boardId);
        }
        return null;
    }
});
const $a1d75259a331b884$export$5b9bac2cc4bf4511 = ()=>(0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('simplified-boards-milestone-2_07hbk') && !(0, $1ybV0.ff)('board-settings-graphql-refactor_cyvz9'), $a1d75259a331b884$export$ab9a4786826fd2d);

});

parcelRegister("a5edq", function(module, exports) {

$parcel$export(module.exports, "shouldLoadUIFBoardResources", () => $6535e46035956c28$export$d8d4641986a9ac7f);
$parcel$export(module.exports, "getRapidboardResources", () => $6535e46035956c28$export$3a5e56bd5231a56b);
$parcel$export(module.exports, "getRapidBoardDataResource", () => $6535e46035956c28$export$1c63de7f548f965f);
$parcel$export(module.exports, "getUIFBacklogDataResource", () => $6535e46035956c28$export$ee826506b3baa13a);

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $gFGRe = parcelRequire("gFGRe");

var $jwzNs = parcelRequire("jwzNs");

var $693rf = parcelRequire("693rf");

var $j5J5y = parcelRequire("j5J5y");

var $9fHn9 = parcelRequire("9fHn9");

var $idF17 = parcelRequire("idF17");

var $10v3r = parcelRequire("10v3r");

var $azMNr = parcelRequire("azMNr");
const $6535e46035956c28$export$d8d4641986a9ac7f = ()=>!false;
const $6535e46035956c28$export$462ca08d6ce67848 = ()=>!$6535e46035956c28$export$d8d4641986a9ac7f();
const $6535e46035956c28$export$3a5e56bd5231a56b = ()=>[
        (0, $azMNr.wrmBundleResource),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jsw.classic.board.api-calls.modern-frontend'), (0, $j5J5y.boardConfigApiResource), (0, $693rf.boardConfigResource)),
        (0, $jwzNs.resourceWithCondition2)($6535e46035956c28$export$462ca08d6ce67848, (0, $10v3r.rapidboardResource))
    ];
const $6535e46035956c28$export$1c63de7f548f965f = ()=>(0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jsw.classic.board.api-calls.modern-frontend'), (0, $9fHn9.boardDataResource), (0, $idF17.initialAllDataResource));
const $6535e46035956c28$export$ee826506b3baa13a = ()=>[
        (0, $jwzNs.resourceWithCondition2)(()=>$6535e46035956c28$export$d8d4641986a9ac7f() && !(0, $eI5EY.fg)('indexeddb_cache_for_backlog'), (0, $gFGRe.uifBacklogResourceOld)),
        (0, $jwzNs.resourceWithCondition2)(()=>$6535e46035956c28$export$d8d4641986a9ac7f() && (0, $eI5EY.fg)('indexeddb_cache_for_backlog'), (0, $gFGRe.uifBacklogResource))
    ];

});
parcelRegister("gFGRe", function(module, exports) {

$parcel$export(module.exports, "uifBacklogResourceOld", () => $1c49d4c5a02eb71e$export$db83ef0443397b85);
$parcel$export(module.exports, "uifBacklogResource", () => $1c49d4c5a02eb71e$export$c182dffb98985208);

var $lB25E = parcelRequire("lB25E");


const $1c49d4c5a02eb71e$export$db83ef0443397b85 = (0, $lB25E.createResource)({
    type: (0, $d05ef78e80305237$export$8f9824ba4409b537),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("4fYLN")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

const $1c49d4c5a02eb71e$export$c182dffb98985208 = (0, $lB25E.createResource)({
    type: (0, $d05ef78e80305237$export$d15ce4feabd76ea),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("beHu2")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

});
const $d05ef78e80305237$export$d15ce4feabd76ea = 'NEXTGEN_BACKLOG_REST';
const $d05ef78e80305237$export$8f9824ba4409b537 = 'NEXTGEN_BACKLOG_REST_OLD';

parcelRegister("4fYLN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hsO3U").then(()=>parcelRequire('ktOjl'));

});

parcelRegister("beHu2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fy9iE").then(()=>parcelRequire('5hldr'));

});


parcelRegister("693rf", function(module, exports) {

$parcel$export(module.exports, "boardConfigResource", () => $686ce37c65523aa4$export$5d16d5f1340da88f);

var $lB25E = parcelRequire("lB25E");

var $4abw7 = parcelRequire("4abw7");

const $686ce37c65523aa4$export$5d16d5f1340da88f = (0, $lB25E.createResource)({
    type: (0, $4abw7.RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("5uE7d")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("4abw7", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", () => $8d7bb0de0f14cf1f$export$88e2a0b89be042c1);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", () => $8d7bb0de0f14cf1f$export$ba075d0985968d1c);
$parcel$export(module.exports, "RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS", () => $8d7bb0de0f14cf1f$export$395f77888d07f2e0);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", () => $8d7bb0de0f14cf1f$export$4f7c4e3508fd2a07);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", () => $8d7bb0de0f14cf1f$export$3328c8e71fda97bb);
$parcel$export(module.exports, "WRM_RESOURCES_ARRAY", () => $8d7bb0de0f14cf1f$export$ef21257df3d71188);
$parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", () => $8d7bb0de0f14cf1f$export$ccd0929652c235de);
$parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", () => $8d7bb0de0f14cf1f$export$1d16bdcc94a40107);
$parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", () => $8d7bb0de0f14cf1f$export$1f599d2eef0a7281);
const $8d7bb0de0f14cf1f$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
const $8d7bb0de0f14cf1f$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
const $8d7bb0de0f14cf1f$export$395f77888d07f2e0 = 'PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS';
const $8d7bb0de0f14cf1f$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
const $8d7bb0de0f14cf1f$export$75dfa03544a19422 = 'ROADMAP';
const $8d7bb0de0f14cf1f$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
const $8d7bb0de0f14cf1f$export$ef21257df3d71188 = [
    '_super',
    'wrc!greenhopper-rapid-non-gadget',
    'wrc!gh-rapid',
    'wrc!jira.global',
    'wrc!jira.general',
    'wrc!atl.global',
    // Required to prevent an error on initial loading of reports
    'wrc!jira.webresources:header',
    // Required for Control Chart report page
    'wrc!jira.webresources:calendar',
    'wrc!jira.webresources:calendar-en',
    'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
    // Required for explicit usage of jQuery
    'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
    // Required for the styles of the toggle button when transitioning from reports to board settings
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
    // Required for the profile card in board settings, that doesn't really render because it has wrong
    // parameters and it has been broken for ages, but at least prevents noisy errors
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
    'wrc!gh-rapid-config',
    'wrc!gh-rapid-analytics',
    'wrc!gh-rapid-charts',
    'wrc!jira.webresources:mentions-feature',
    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
];
const $8d7bb0de0f14cf1f$export$ccd0929652c235de = [];
const $8d7bb0de0f14cf1f$export$1d16bdcc94a40107 = [
    'wrc!gh-rapid-lwf-board-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];
const $8d7bb0de0f14cf1f$export$1f599d2eef0a7281 = [
    'wrc!gh-rapid-backlog-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:header',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];

});

parcelRegister("5uE7d", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4uY6S").then(()=>parcelRequire('efMpc'));

});


parcelRegister("j5J5y", function(module, exports) {

$parcel$export(module.exports, "boardConfigApiResource", () => $a885dc4b32424c7f$export$dd9dec064acb0c4e);

var $1ybV0 = parcelRequire("1ybV0");

var $lB25E = parcelRequire("lB25E");

var $4abw7 = parcelRequire("4abw7");
const $a885dc4b32424c7f$var$configResourceCacheTime = ()=>(0, $1ybV0.getFeatureFlagValue)('jsw.classic.board.api-calls.config-cache-time', 0);

const $a885dc4b32424c7f$export$dd9dec064acb0c4e = (0, $lB25E.createResource)({
    type: (0, $4abw7.RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG),
    getKey: ({ match: match, query: query })=>{
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        return `rapidViewConfig-${boardId}`; // Should Also have a mode but for now lets use only id
    },
    getDataLoader: ()=>(parcelRequire("av4zI")),
    maxAge: false ? 0 : $a885dc4b32424c7f$var$configResourceCacheTime() * 1000,
    isBrowserOnly: true
});

});
parcelRegister("av4zI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("k7Uvh").then(()=>parcelRequire('2WyND'));

});


parcelRegister("9fHn9", function(module, exports) {

$parcel$export(module.exports, "boardDataResource", () => $2e783f8e2beaf754$export$138fa635416978f7);

var $lB25E = parcelRequire("lB25E");

var $4abw7 = parcelRequire("4abw7");

var $iG24k = parcelRequire("iG24k");

const $2e783f8e2beaf754$export$138fa635416978f7 = (0, $lB25E.createResource)({
    type: (0, $4abw7.RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
    getKey: ({ match: match, query: query, route: route })=>{
        const { name: name = '' } = route || {};
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        const { config: config } = query;
        const hasConfig = Boolean(config);
        let key = 'rapidBoardData';
        if ((0, $iG24k.isBoardRoute)(name)) key = `boardData-${boardId}::hasConfig=${hasConfig}`;
        else if ((0, $iG24k.isBacklogRoute)(name)) key = `backlogData-${boardId}::hasConfig=${hasConfig}`;
        return key;
    },
    getDataLoader: ()=>(parcelRequire("chLtd")),
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("iG24k", function(module, exports) {

$parcel$export(module.exports, "isBoardRoute", () => $f15ca5b1ef6eee74$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $f15ca5b1ef6eee74$export$bcb853db5e3e8054);

var $exb0h = parcelRequire("exb0h");
const $f15ca5b1ef6eee74$export$437d4d6e25681588 = (routeName)=>routeName === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD) || routeName === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED) || routeName === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BOARD) || routeName === (0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS);
const $f15ca5b1ef6eee74$export$bcb853db5e3e8054 = (routeName)=>routeName === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG) || routeName === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG) || routeName === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED);

});

parcelRegister("chLtd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("52qFn").then(()=>parcelRequire('9HiUl'));

});


parcelRegister("idF17", function(module, exports) {

$parcel$export(module.exports, "initialAllDataResource", () => $462b644b46c9bc09$export$4680aabd39eb6d1c);

var $lB25E = parcelRequire("lB25E");

var $4abw7 = parcelRequire("4abw7");

const $462b644b46c9bc09$export$4680aabd39eb6d1c = (0, $lB25E.createResource)({
    type: (0, $4abw7.RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("dCjzK")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("dCjzK", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fQHEB").then(()=>parcelRequire('i6uNI'));

});


parcelRegister("10v3r", function(module, exports) {

$parcel$export(module.exports, "rapidboardResource", () => $d0fec4ac46f6b7e1$export$d0f42a55e7c5752c);

var $lB25E = parcelRequire("lB25E");

var $4abw7 = parcelRequire("4abw7");

const $d0fec4ac46f6b7e1$export$d0f42a55e7c5752c = (0, $lB25E.createResource)({
    type: (0, $4abw7.RESOURCE_TYPE_RAPIDBOARDS_RESOURCE),
    getKey: ({ match: match })=>match.query.rapidView || '',
    getDataLoader: ()=>(parcelRequire("kXriO")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("kXriO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bD5eW").then(()=>parcelRequire('738Zn'));

});


parcelRegister("azMNr", function(module, exports) {

$parcel$export(module.exports, "wrmBundleResource", () => $9ba6db74de8b9314$export$f199d15b7cd18df1);

var $lB25E = parcelRequire("lB25E");

var $4abw7 = parcelRequire("4abw7");

const $9ba6db74de8b9314$export$f199d15b7cd18df1 = (0, $lB25E.createResource)({
    type: (0, $4abw7.RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("8XiMb")),
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("8XiMb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kSleR").then(()=>parcelRequire('kzWWa'));

});



parcelRegister("gar3N", function(module, exports) {

$parcel$export(module.exports, "devOpsProviderResource", () => $36496188b1d77e1d$export$19e58e21b24ae0d8);

var $lB25E = parcelRequire("lB25E");


const $36496188b1d77e1d$export$19e58e21b24ae0d8 = (0, $lB25E.createResource)({
    type: (0, $c5a874dd03237b43$export$5f92e516f4b78544),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("dqjd5")),
    maxAge: 60000
});
const $36496188b1d77e1d$export$b80f5852c41a5ca8 = ()=>(0, $lB25E.useResource)($36496188b1d77e1d$export$19e58e21b24ae0d8);

});
const $c5a874dd03237b43$export$5f92e516f4b78544 = 'SOFTWARE_DEVOPS_PROVIDERS';
const $c5a874dd03237b43$export$d7f081d6dd0e72fc = 'bitbucket';
const $c5a874dd03237b43$export$832d1d859726f915 = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
const $c5a874dd03237b43$export$5007979ef33118fc = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';

parcelRegister("dqjd5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lHWCq").then(()=>parcelRequire('fWjqT'));

});


parcelRegister("lY9wZ", function(module, exports) {

$parcel$export(module.exports, "classicRoadmapResource", () => $3a45f64c9dac7291$export$e755913caca1ab8e);

var $lB25E = parcelRequire("lB25E");


const $3a45f64c9dac7291$export$e755913caca1ab8e = (0, $lB25E.createResource)({
    type: (0, $1eef2c9e2260305d$export$75dfa03544a19422),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("jFK4o")),
    isBrowserOnly: true
});

});
const $1eef2c9e2260305d$export$75dfa03544a19422 = 'ROADMAP';
const $1eef2c9e2260305d$export$e905b9170ecbb599 = 'BOARD_CONTEXT_ROADMAP_SETTINGS';

parcelRegister("jFK4o", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("f3A1F").then(()=>parcelRequire('fDh5k'));

});


parcelRegister("5GEOG", function(module, exports) {

$parcel$export(module.exports, "codePageResource", () => $3e86f6d6f0d16a33$export$642ce64cf3689406);

var $exb0h = parcelRequire("exb0h");

var $buJlM = parcelRequire("buJlM");

var $9FLN2 = parcelRequire("9FLN2");

var $fUxTD = parcelRequire("fUxTD");

let $3e86f6d6f0d16a33$var$numPullRequestsToFetch = 0;
const $3e86f6d6f0d16a33$export$642ce64cf3689406 = (0, $buJlM.createRelayResource)({
    type: (0, $c019edc395b43b54$export$94a43d2ac55ac375),
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId } }) {
        const isCodeRoute = name === (0, $exb0h.ROUTE_NAMES_SOFTWARE_CODE) || name === (0, $exb0h.ROUTE_NAMES_SOFTWARE_CODE_CLASSIC);
        // Set numPullRequestsToFetch on initial call only and not on every query param change
        if (!$3e86f6d6f0d16a33$var$numPullRequestsToFetch && isCodeRoute) $3e86f6d6f0d16a33$var$numPullRequestsToFetch = (0, $fUxTD.getNumPullRequestsToFetch)(query);
        // Reset numPullRequestsToFetch when navigating away from the code page
        if (!isCodeRoute) $3e86f6d6f0d16a33$var$numPullRequestsToFetch = 0;
        return {
            parameters: (0, $9FLN2.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                pullRequestsUpdatedFrom: (0, $fUxTD.getPullRequestsUpdatedFromDate)(),
                numPullRequestsToFetch: $3e86f6d6f0d16a33$var$numPullRequestsToFetch,
                siteAri: `ari:cloud:jira::site/${cloudId}`
            }
        };
    }
});

});
parcelRegister("9FLN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ffdcfe594d87f38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<591cf68e013a4df86546cc2158428137>>
 * @relayHash 2d411cc6a91e819bc67a4fe169533d0f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 133ff17ae88c722ba1d91f8fc407b9e8f0d1a640a4c93ec27cfe43dd6ef0142b

var $dK3Dn = parcelRequire("dK3Dn");
const $3ffdcfe594d87f38$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numPullRequestsToFetch"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pullRequestsUpdatedFrom"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "siteAri"
        },
        {
            "kind": "Literal",
            "name": "providerTypes",
            "value": [
                "DEV_INFO"
            ]
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v10 = [
        v9 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "status"
    }, v12 = {
        "concreteType": "JiraConfigStateConnection",
        "kind": "LinkedField",
        "name": "config",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraConfigState",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "appId"
                    },
                    v11 /*: any*/ 
                ]
            }
        ]
    }, v13 = [
        v12 /*: any*/ 
    ], v14 = [
        v8 /*: any*/ 
    ], v15 = [
        {
            "kind": "Literal",
            "name": "appId",
            "value": "bitbucket"
        },
        v9 /*: any*/ 
    ], v16 = [
        v9 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v17 = [
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "lastModified": {
                    "direction": "DESC",
                    "priority": 1
                }
            }
        }
    ], v18 = [
        v12 /*: any*/ ,
        v6 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v20 = {
        "kind": "ScalarField",
        "name": "url"
    }, v21 = [
        v8 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "accountId"
        },
        v7 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v6 /*: any*/ 
    ], v22 = [
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainCodeInJiraUpdatedQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsDevInfoProvider",
                                            "kind": "LinkedField",
                                            "name": "devInfoProviders",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v10 /*: any*/ ,
                                                    "concreteType": "JiraAppConfigState",
                                                    "kind": "LinkedField",
                                                    "name": "configState",
                                                    "plural": false,
                                                    "selections": v13 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.providers"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v10 /*: any*/ ,
                        "concreteType": "CodeInJira",
                        "kind": "LinkedField",
                        "name": "codeInJira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CodeInJiraUserConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CodeInJiraBitbucketWorkspace",
                                                "kind": "LinkedField",
                                                "name": "ownedBitbucketWorkspaces",
                                                "plural": true,
                                                "selections": v14 /*: any*/ 
                                            },
                                            "action": "THROW",
                                            "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "codeInJira.userConfiguration"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "codeInJira"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": v16 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                    "kind": "LinkedField",
                                    "name": "repositories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v14 /*: any*/ 
                                        }
                                    ],
                                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_MainPage"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_Header"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_ConnectionPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcimprovecodepageemptystaterelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "mainCodeInJiraUpdatedQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "DevOpsProviders",
                            "kind": "LinkedField",
                            "name": "providers",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsDevInfoProvider",
                                    "kind": "LinkedField",
                                    "name": "devInfoProviders",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraAppConfigState",
                                            "kind": "LinkedField",
                                            "name": "configState",
                                            "plural": false,
                                            "selections": v18 /*: any*/ 
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "homeUrl"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "namespace"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v10 /*: any*/ ,
                    "concreteType": "CodeInJira",
                    "kind": "LinkedField",
                    "name": "codeInJira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CodeInJiraUserConfiguration",
                            "kind": "LinkedField",
                            "name": "userConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CodeInJiraBitbucketWorkspace",
                                    "kind": "LinkedField",
                                    "name": "ownedBitbucketWorkspaces",
                                    "plural": true,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "uuid"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        },
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": v18 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": v16 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                    "kind": "LinkedField",
                                    "name": "repositories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerId"
                                                                },
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "avatarUrl"
                                                                },
                                                                v20 /*: any*/ 
                                                            ],
                                                            "type": "DevOpsRepository"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                },
                                v6 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "updatedFrom",
                                                    "variableName": "pullRequestsUpdatedFrom"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "numPullRequestsToFetch"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": {
                                                "lastUpdatedSortDirection": "DESC"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-associated-pr"
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "devOpsEntityRelationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryName"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "author",
                                                                                    "plural": false,
                                                                                    "selections": v21 /*: any*/ 
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsReviewer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "reviewers",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v21 /*: any*/ 
                                                                                        },
                                                                                        v8 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "approvalStatus"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userId"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "title"
                                                                                },
                                                                                v6 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "commentCount"
                                                                                },
                                                                                v20 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsBranchInfo",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "destinationBranch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v7 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "pullRequestInternalId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "authorId"
                                                                                }
                                                                            ],
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v22 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v22 /*: any*/ ,
                                                                            "type": "ConfluencePage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v22 /*: any*/ ,
                                                                            "type": "ConfluenceSpace"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v22 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v22 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v22 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v22 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v22 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v22 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v22 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v22 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v22 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v22 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        }
                                                                    ]
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "133ff17ae88c722ba1d91f8fc407b9e8f0d1a640a4c93ec27cfe43dd6ef0142b",
            "metadata": {},
            "name": "mainCodeInJiraUpdatedQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcimprovecodepageemptystaterelayprovider": (0, $dK3Dn.default)
            }
        }
    };
}();
$3ffdcfe594d87f38$var$node.hash = "02f9224d53652182a109e4936760d09f";
var $3ffdcfe594d87f38$export$2e2bcd8739ae039 = $3ffdcfe594d87f38$var$node;

});
parcelRegister("dK3Dn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea4f423871b5b878$export$2e2bcd8739ae039);

var $79xbN = parcelRequire("79xbN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ea4f423871b5b878$export$2e2bcd8739ae039 = {
    get () {
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jira_improve_scm_onboarding');
        return expConfig.get('isEnabled', false);
    }
};

});


parcelRegister("fUxTD", function(module, exports) {

$parcel$export(module.exports, "isBitbucketProvider", () => $4b6f21ae9f331ee2$export$1f508885be28c4e);
$parcel$export(module.exports, "codeErrorBoundaryAttributes", () => $4b6f21ae9f331ee2$export$ea10bb8bdf2072e5);
$parcel$export(module.exports, "toSanitizedUrl", () => $4b6f21ae9f331ee2$export$36fdccbdcd093523);
$parcel$export(module.exports, "useIsOverflowWidth", () => $4b6f21ae9f331ee2$export$2dcd60313c8d761b);
$parcel$export(module.exports, "getPullRequestsUpdatedFromDate", () => $4b6f21ae9f331ee2$export$3784bdf6b4807521);
$parcel$export(module.exports, "getNumPullRequestsToFetch", () => $4b6f21ae9f331ee2$export$a837c7c9c7670570);

var $eUqFw = parcelRequire("eUqFw");

var $licsn = parcelRequire("licsn");

var $3jYzf = parcelRequire("3jYzf");
var $fiOXn = parcelRequire("fiOXn");

var $k4dvS = parcelRequire("k4dvS");

var $2H4pK = parcelRequire("2H4pK");
const $4b6f21ae9f331ee2$export$36ebc9cd52c6b517 = (repository)=>repository === (0, $2H4pK.RepositoryTypes).REPO_BITBUCKET;
const $4b6f21ae9f331ee2$export$1f508885be28c4e = (providerId)=>providerId === (0, $k4dvS.VcsProviderIds).BITBUCKET || providerId === (0, $k4dvS.DataDepotProviderIds).BITBUCKET_PROD || providerId === (0, $k4dvS.DataDepotProviderIds).BITBUCKET_STG;
const $4b6f21ae9f331ee2$var$shouldCountToReliability = (error)=>{
    const okayErrors = [
        ...(0, $k4dvS.nonCriticalGqlErrors),
        ...(0, $k4dvS.nonReliabilityCriticalErrors)
    ];
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"HTTP status [403] while retrieving Bitbucket repository." | "HTTP status [404] while retrieving Bitbucket repository." | "Failed to retrieve Bitbucket repository because the user wasn't authorized." | "HTTP status [429] while retrieving Bitbucket repository." | "The user does not have 'View Development Tools' permi...'.
    return !okayErrors.includes(error.message);
};
const $4b6f21ae9f331ee2$export$ea10bb8bdf2072e5 = (error)=>{
    if (error instanceof Error) return {
        countToReliability: $4b6f21ae9f331ee2$var$shouldCountToReliability(error)
    };
    return {
        countToReliability: true
    };
};
const $4b6f21ae9f331ee2$export$36fdccbdcd093523 = (url)=>(0, $licsn.sanitizeUrl)(url);
const $4b6f21ae9f331ee2$export$2dcd60313c8d761b = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref, callback)=>{
    const [isOverflow, setIsOverflow] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const { current: current } = ref;
        const trigger = ()=>{
            const hasOverflow = current.scrollWidth > current.clientWidth;
            setIsOverflow(hasOverflow);
            if (callback) callback(hasOverflow);
        };
        if (current) {
            if ('ResizeObserver' in window) new ResizeObserver(trigger).observe(current);
            trigger();
        }
    }, [
        callback,
        ref
    ]);
    return isOverflow;
};
const $4b6f21ae9f331ee2$export$3784bdf6b4807521 = ()=>(0, $3jYzf.default)((0, $fiOXn.default)(new Date(), {
        days: (0, $k4dvS.PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS)
    })).toISOString();
const $4b6f21ae9f331ee2$export$a837c7c9c7670570 = (queryParams)=>{
    const hasFilterOrSortQueryParam = Object.entries(queryParams).some(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ([key, value])=>(0, $k4dvS.queryParamsToWatch).includes(key) && value !== '');
    return hasFilterOrSortQueryParam ? (0, $k4dvS.MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY) : (0, $k4dvS.PULL_REQUESTS_TABLE_PAGE_SIZE);
};

});
parcelRegister("licsn", function(module, exports) {
'use strict';
var $f804f10f7485c34b$var$invalidPrototcolRegex = /^(%20|\s)*(javascript|data)/im;
var $f804f10f7485c34b$var$ctrlCharactersRegex = /[^\x20-\x7E]/gmi;
var $f804f10f7485c34b$var$urlSchemeRegex = /^([^:]+):/gm;
var $f804f10f7485c34b$var$relativeFirstCharacters = [
    '.',
    '/'
];
function $f804f10f7485c34b$var$isRelativeUrl(url) {
    return $f804f10f7485c34b$var$relativeFirstCharacters.indexOf(url[0]) > -1;
}
function $f804f10f7485c34b$var$sanitizeUrl(url) {
    if (!url) return 'about:blank';
    var urlScheme, urlSchemeParseResults;
    var sanitizedUrl = url.replace($f804f10f7485c34b$var$ctrlCharactersRegex, '');
    if ($f804f10f7485c34b$var$isRelativeUrl(sanitizedUrl)) return sanitizedUrl;
    urlSchemeParseResults = sanitizedUrl.match($f804f10f7485c34b$var$urlSchemeRegex);
    if (!urlSchemeParseResults) return 'about:blank';
    urlScheme = urlSchemeParseResults[0];
    if ($f804f10f7485c34b$var$invalidPrototcolRegex.test(urlScheme)) return 'about:blank';
    return sanitizedUrl;
}
module.exports = {
    sanitizeUrl: $f804f10f7485c34b$var$sanitizeUrl
};

});

parcelRegister("k4dvS", function(module, exports) {

$parcel$export(module.exports, "nonCriticalGqlErrors", () => $ed47b00d0c38c75b$export$4b1abe4db5ed7515);
$parcel$export(module.exports, "nonReliabilityCriticalErrors", () => $ed47b00d0c38c75b$export$687544614e0812da);
$parcel$export(module.exports, "cardBoxShadow", () => $ed47b00d0c38c75b$export$7527a73da794030d);
$parcel$export(module.exports, "cardBoxHoverShadow", () => $ed47b00d0c38c75b$export$2ecfdc24b216c295);
$parcel$export(module.exports, "MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY", () => $ed47b00d0c38c75b$export$f84c6b6609a3dd30);
$parcel$export(module.exports, "PULL_REQUESTS_TABLE_PAGE_SIZE", () => $ed47b00d0c38c75b$export$ea15b38f3901f518);
$parcel$export(module.exports, "PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS", () => $ed47b00d0c38c75b$export$2b8b0a4489f9147b);
$parcel$export(module.exports, "COLLAPSIBLE_REGION_ID", () => $ed47b00d0c38c75b$export$3b8f88133d28aaa6);
$parcel$export(module.exports, "REPOSITORIES_HEADER_ID", () => $ed47b00d0c38c75b$export$256a9f141103f328);
$parcel$export(module.exports, "COLLAPSIBLE_REGION_DESCRIPTION_ID", () => $ed47b00d0c38c75b$export$b0d4e90e40369b80);
$parcel$export(module.exports, "featureIdToHelpMap", () => $ed47b00d0c38c75b$export$1de4eaccc23a8747);
$parcel$export(module.exports, "FILTER_CONTAINER_TEST_ID", () => $ed47b00d0c38c75b$export$5c00a6bedc2037c8);
$parcel$export(module.exports, "NO_RESULTS_CLEAR_FILTERS_BUTTON_TEST_ID", () => $ed47b00d0c38c75b$export$f70ce14ba902adcb);
$parcel$export(module.exports, "PULL_REQUESTS_TABLE_TEST_ID", () => $ed47b00d0c38c75b$export$19381ed4387aa05b);
$parcel$export(module.exports, "PULL_REQUESTS_DYNAMIC_TABLE_TEST_ID", () => $ed47b00d0c38c75b$export$f3e116f999d4c5c1);
$parcel$export(module.exports, "PULL_REQUESTS_EMPTY_STATE_TEST_ID", () => $ed47b00d0c38c75b$export$c28f1cd40ae0394c);
$parcel$export(module.exports, "SUMMARY_CELL_TEST_ID", () => $ed47b00d0c38c75b$export$f69d7aa9c5e17d55);
$parcel$export(module.exports, "SUMMARY_CELL_TITLE_LINK_TEST_ID", () => $ed47b00d0c38c75b$export$4ed9a8a7faf641f);
$parcel$export(module.exports, "SUMMARY_CELL_TARGET_BRANCH_LINK_TEST_ID", () => $ed47b00d0c38c75b$export$c5322e755fd1028d);
$parcel$export(module.exports, "SUMMARY_CELL_REPOSITORY_LINK_TEST_ID", () => $ed47b00d0c38c75b$export$72fcd104fde041d6);
$parcel$export(module.exports, "REVIEWERS_CELL_TEST_ID", () => $ed47b00d0c38c75b$export$d8f600a480a9c2d4);
$parcel$export(module.exports, "STATUS_CELL_TEST_ID", () => $ed47b00d0c38c75b$export$9d9ab707c4e446cc);
$parcel$export(module.exports, "COMMENTS_CELL_TEST_ID", () => $ed47b00d0c38c75b$export$4da3056fdbfaf111);
$parcel$export(module.exports, "LAST_UPDATED_CELL_TEST_ID", () => $ed47b00d0c38c75b$export$e1134688b6a1032);
$parcel$export(module.exports, "PULL_REQUESTS_ERROR_STATE_TEST_ID", () => $ed47b00d0c38c75b$export$143249aa50321d51);
$parcel$export(module.exports, "REPOSITORIES_ERROR_STATE_TEST_ID", () => $ed47b00d0c38c75b$export$a46febdd3fe90de0);
$parcel$export(module.exports, "IMPROVED_SCM_CONFIG_SCREEN_ERROR_TEST_ID", () => $ed47b00d0c38c75b$export$333db4cac7ee017);
$parcel$export(module.exports, "IMPROVE_READY_TO_CONNECT_EMPTY_STATE_TEST_ID", () => $ed47b00d0c38c75b$export$5cbae081959768bd);
$parcel$export(module.exports, "REPOSITORIES_FILTER_BUTTON_TEST_ID", () => $ed47b00d0c38c75b$export$4939c117ba49bc9e);
$parcel$export(module.exports, "AUTHOR_FILTER_BUTTON_TEST_ID", () => $ed47b00d0c38c75b$export$5a92d7579dac6294);
$parcel$export(module.exports, "REVIEWERS_FILTER_BUTTON_TEST_ID", () => $ed47b00d0c38c75b$export$a77ea162c15f0290);
$parcel$export(module.exports, "STATUS_FILTER_BUTTON_TEST_ID", () => $ed47b00d0c38c75b$export$b7477204cae64b46);
$parcel$export(module.exports, "QUERY_PARAM_SUMMARY", () => $ed47b00d0c38c75b$export$39983b6fb040a5eb);
$parcel$export(module.exports, "QUERY_PARAM_AUTHORS", () => $ed47b00d0c38c75b$export$3d96f5f9ccd35be6);
$parcel$export(module.exports, "QUERY_PARAM_REVIEWERS", () => $ed47b00d0c38c75b$export$8a8927c29ab32b10);
$parcel$export(module.exports, "QUERY_PARAM_STATUS", () => $ed47b00d0c38c75b$export$3e8168848b996f7);
$parcel$export(module.exports, "QUERY_PARAM_REPOSITORIES", () => $ed47b00d0c38c75b$export$4adc519ba40b72a6);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $ed47b00d0c38c75b$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $ed47b00d0c38c75b$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "queryParamsToWatch", () => $ed47b00d0c38c75b$export$ba75fb5089c0eb0b);
$parcel$export(module.exports, "VcsProviderIds", () => $ed47b00d0c38c75b$export$7d5c3d28df5f438a);
$parcel$export(module.exports, "DataDepotProviderIds", () => $ed47b00d0c38c75b$export$7912a169c18abe9d);
$parcel$export(module.exports, "FEEDBACK_COLLECTOR_LOCATION", () => $ed47b00d0c38c75b$export$74189cec821240a6);
$parcel$export(module.exports, "eligibleForConfigurationScreenStatuses", () => $ed47b00d0c38c75b$export$3f3fc252f5066c72);
$parcel$export(module.exports, "notEligibleForConfigurationScreenStatuses", () => $ed47b00d0c38c75b$export$9ce5b1bba5f17875);
const $ed47b00d0c38c75b$export$4b1abe4db5ed7515 = [
    'HTTP status [403] while retrieving Bitbucket repository.',
    'HTTP status [404] while retrieving Bitbucket repository.',
    "Failed to retrieve Bitbucket repository because the user wasn't authorized."
];
const $ed47b00d0c38c75b$export$687544614e0812da = [
    'HTTP status [429] while retrieving Bitbucket repository.',
    "The user does not have 'View Development Tools' permission for the Jira project or the project does not exist",
    'The user does not have admin permission for the site, Jira, project or the project does not exist.',
    'Unable to get providers when contacting Jira due to 401 Unauthorized'
];
const $ed47b00d0c38c75b$export$7527a73da794030d = "var(--ds-shadow-overflow, 0 1px 1px rgb(9 30 66 / 25%), 0 0 1px 1px rgb(9 30 66 / 13%))";
const $ed47b00d0c38c75b$export$2ecfdc24b216c295 = "var(--ds-shadow-overflow, rgba(9, 30, 66, 0.31) 0px 0px 1px 0px, rgba(9, 30, 66, 0.25) 0px 8px 16px -6px)"; // we use  in package.json file, so box-shadow here must be a value, cannot use elevation
const $ed47b00d0c38c75b$export$f84c6b6609a3dd30 = 1000;
const $ed47b00d0c38c75b$export$ea15b38f3901f518 = 12;
const $ed47b00d0c38c75b$export$2b8b0a4489f9147b = 30;
const $ed47b00d0c38c75b$export$3b8f88133d28aaa6 = 'collapsible-repository-list';
const $ed47b00d0c38c75b$export$256a9f141103f328 = 'repository-list-header';
const $ed47b00d0c38c75b$export$b0d4e90e40369b80 = 'repository-list-description';
const $ed47b00d0c38c75b$export$1de4eaccc23a8747 = {
    'repository-list.pull-requests.empty-state': {
        helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
    },
    'repository-list.pull-requests.description': {
        helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
    }
};
const $ed47b00d0c38c75b$export$5c00a6bedc2037c8 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.filter-container';
const $ed47b00d0c38c75b$export$f70ce14ba902adcb = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.no-results.clearfiltersbutton';
const $ed47b00d0c38c75b$export$19381ed4387aa05b = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table';
const $ed47b00d0c38c75b$export$f3e116f999d4c5c1 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table.dynamic-table';
const $ed47b00d0c38c75b$export$c28f1cd40ae0394c = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-empty-state';
const $ed47b00d0c38c75b$export$f69d7aa9c5e17d55 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.summary-cell';
const $ed47b00d0c38c75b$export$4ed9a8a7faf641f = `${$ed47b00d0c38c75b$export$f69d7aa9c5e17d55}.title-link`;
const $ed47b00d0c38c75b$export$c5322e755fd1028d = `${$ed47b00d0c38c75b$export$f69d7aa9c5e17d55}.target-branch-link`;
const $ed47b00d0c38c75b$export$72fcd104fde041d6 = `${$ed47b00d0c38c75b$export$f69d7aa9c5e17d55}.repository-link`;
const $ed47b00d0c38c75b$export$d8f600a480a9c2d4 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.reviewers-cell';
const $ed47b00d0c38c75b$export$9d9ab707c4e446cc = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.status-cell';
const $ed47b00d0c38c75b$export$4da3056fdbfaf111 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.comments-cell';
const $ed47b00d0c38c75b$export$e1134688b6a1032 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.last-updated-cell';
const $ed47b00d0c38c75b$export$143249aa50321d51 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-error-state';
const $ed47b00d0c38c75b$export$a46febdd3fe90de0 = 'software-code-page.ui.pages.main-page.repositories.repository-error-state';
const $ed47b00d0c38c75b$export$333db4cac7ee017 = 'software-code-page.ui.pages.improved-configure-step-error-state';
const $ed47b00d0c38c75b$export$5cbae081959768bd = 'software-code-page.ui.pages.ready-to-connect-empty-state-error-state';
const $ed47b00d0c38c75b$export$4939c117ba49bc9e = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.repository-filter.filter-button';
const $ed47b00d0c38c75b$export$5a92d7579dac6294 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.author-filter.filter-button';
const $ed47b00d0c38c75b$export$a77ea162c15f0290 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.reviewers-filter.filter-button';
const $ed47b00d0c38c75b$export$b7477204cae64b46 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.status-filter.filter-button';
const $ed47b00d0c38c75b$export$39983b6fb040a5eb = 'summaryFilter';
const $ed47b00d0c38c75b$export$3d96f5f9ccd35be6 = 'authorsFilter';
const $ed47b00d0c38c75b$export$8a8927c29ab32b10 = 'reviewersFilter';
const $ed47b00d0c38c75b$export$3e8168848b996f7 = 'statusFilter';
const $ed47b00d0c38c75b$export$4adc519ba40b72a6 = 'repositoriesFilter';
const $ed47b00d0c38c75b$export$6da773286c35ef41 = 'sortKey';
const $ed47b00d0c38c75b$export$810a1f7ed2facfcb = 'sortOrder';
const $ed47b00d0c38c75b$export$ba75fb5089c0eb0b = [
    $ed47b00d0c38c75b$export$39983b6fb040a5eb,
    $ed47b00d0c38c75b$export$3d96f5f9ccd35be6,
    $ed47b00d0c38c75b$export$8a8927c29ab32b10,
    $ed47b00d0c38c75b$export$3e8168848b996f7,
    $ed47b00d0c38c75b$export$4adc519ba40b72a6,
    $ed47b00d0c38c75b$export$6da773286c35ef41,
    $ed47b00d0c38c75b$export$810a1f7ed2facfcb
];
const $ed47b00d0c38c75b$export$7d5c3d28df5f438a = {
    BITBUCKET: 'bitbucket'
};
const $ed47b00d0c38c75b$export$7912a169c18abe9d = {
    BITBUCKET_PROD: 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9',
    BITBUCKET_STG: 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N',
    GITHUB_PROD: 'com.github.integration.production',
    GITHUB_STG: 'com.github.integration.staging'
};
const $ed47b00d0c38c75b$export$74189cec821240a6 = 'jsw.code.page.header';
const $ed47b00d0c38c75b$export$3f3fc252f5066c72 = [
    'NOT_CONFIGURED',
    'NOT_SET',
    'PARTIALLY_CONFIGURED'
];
const $ed47b00d0c38c75b$export$9ce5b1bba5f17875 = [
    'CONFIGURED',
    'PROVIDER_ACTION_CONFIGURED',
    'PROVIDER_ACTION_NOT_CONFIGURED'
];

});

parcelRegister("2H4pK", function(module, exports) {

$parcel$export(module.exports, "numberToTimestamp", () => $764cbee5e2f48f11$export$9a7be8324d19a048);
$parcel$export(module.exports, "toProjectAri", () => $764cbee5e2f48f11$export$9429718a5f74f761);
$parcel$export(module.exports, "RepositoryTypes", () => $764cbee5e2f48f11$export$b5ab924fb433d9ea);
/**
 * Opaque types
 */ const $764cbee5e2f48f11$export$9a7be8324d19a048 = (time)=>{
    if (time < 0) throw new Error(`Trying to case invalid number(${time}) to Timestamp opaque type`);
    return time;
};
const $764cbee5e2f48f11$export$9429718a5f74f761 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $764cbee5e2f48f11$export$b5ab924fb433d9ea = {
    REPO_BITBUCKET: 'REPO_BITBUCKET',
    REPO_GITHUB: 'REPO_GITHUB',
    REPO_GITLAB: 'REPO_GITLAB'
};
const $764cbee5e2f48f11$export$60dabe06d83cf844 = {
    CLASSIC: 'classic',
    OAUTH: 'oauth',
    BITBUCKET: 'bitbucket'
};

});


const $c019edc395b43b54$export$94a43d2ac55ac375 = 'SOFTWARE_CODE';


parcelRegister("4pu9Z", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapClassicRoute", () => $3c28aedf6dc41886$export$79089e2853f04197);
$parcel$export(module.exports, "softwareTimelineClassicRoute", () => $3c28aedf6dc41886$export$ce5173f7e8fa932b);
$parcel$export(module.exports, "softwareCalendarClassicRoute", () => $3c28aedf6dc41886$export$f2c3b99639d54eb8);
$parcel$export(module.exports, "softwareCalendarClassicEmbedRoute", () => $3c28aedf6dc41886$export$ced2612fe5124ff8);
$parcel$export(module.exports, "softwareListClassicRoute", () => $3c28aedf6dc41886$export$1bf758507ca6b2);
$parcel$export(module.exports, "softwareListEmbedClassicRoute", () => $3c28aedf6dc41886$export$de5fcecec40b3c98);
$parcel$export(module.exports, "softwareFormBuilderClassicRoute", () => $3c28aedf6dc41886$export$f6cfee0232aa1e);
$parcel$export(module.exports, "softwareFormSubmitClassicRoute", () => $3c28aedf6dc41886$export$91d6851bf27349);
$parcel$export(module.exports, "softwareFormClassicRoute", () => $3c28aedf6dc41886$export$ae560ee5b676193d);
$parcel$export(module.exports, "softwareGoalsClassicRoute", () => $3c28aedf6dc41886$export$d12f3924cf53b545);
$parcel$export(module.exports, "rapidboardBacklogRoute", () => $3c28aedf6dc41886$export$9e1d275c8078512e);
$parcel$export(module.exports, "rapidboardBacklogEmbedRoute", () => $3c28aedf6dc41886$export$8c354886c7c664ea);
$parcel$export(module.exports, "rapidboardReportRoute", () => $3c28aedf6dc41886$export$d37f637b09fb9fda);
$parcel$export(module.exports, "softwareReportsCycleTimeClassicRoute", () => $3c28aedf6dc41886$export$1e5e610e11119ea7);
$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRoute", () => $3c28aedf6dc41886$export$92f34907c6bf7007);
$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRoute", () => $3c28aedf6dc41886$export$16987cdd084cceba);
$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRoute", () => $3c28aedf6dc41886$export$312c410cb3b49afe);
$parcel$export(module.exports, "rapidboardUserBacklogRoute", () => $3c28aedf6dc41886$export$79c2d9718e914f91);
$parcel$export(module.exports, "rapidboardUserReportRoute", () => $3c28aedf6dc41886$export$7b85bca17717def6);
$parcel$export(module.exports, "rapidboardBacklog1Route", () => $3c28aedf6dc41886$export$ff874528b0b33a61);
$parcel$export(module.exports, "rapidboardReport1Route", () => $3c28aedf6dc41886$export$d27f9ad2fc277ff9);
$parcel$export(module.exports, "softwareCodeClassicRoute", () => $3c28aedf6dc41886$export$d92cd77785d00ff);
$parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRoute", () => $3c28aedf6dc41886$export$991b1be164057e91);
$parcel$export(module.exports, "projectDirectoryRedirectRoute", () => $3c28aedf6dc41886$export$3913c8bee519225c);

var $exb0h = parcelRequire("exb0h");
const $3c28aedf6dc41886$var$jiraIssueFormCreateEndpoint = 'projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?'; // the 1 query param is "requestTypeId"
const $3c28aedf6dc41886$export$79089e2853f04197 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/roadmap'
};
const $3c28aedf6dc41886$export$ce5173f7e8fa932b = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline'
};
const $3c28aedf6dc41886$export$f2c3b99639d54eb8 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar',
    queries: [
        'date?'
    ]
};
const $3c28aedf6dc41886$export$ced2612fe5124ff8 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC_EMBED),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/embed',
    queries: [
        'date?'
    ]
};
const $3c28aedf6dc41886$export$1bf758507ca6b2 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/list'
};
const $3c28aedf6dc41886$export$de5fcecec40b3c98 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST_CLASSIC_EMBED),
    path: '/jira/software/c/projects/:projectKey/list/embed'
};
const $3c28aedf6dc41886$export$f6cfee0232aa1e = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/form/:formId/builder'
};
const $3c28aedf6dc41886$export$91d6851bf27349 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/form/:formId'
};
const $3c28aedf6dc41886$export$ae560ee5b676193d = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/form'
};
const $3c28aedf6dc41886$export$d12f3924cf53b545 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/goals'
};
const $3c28aedf6dc41886$export$9e1d275c8078512e = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog'
};
const $3c28aedf6dc41886$export$8c354886c7c664ea = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog/embed'
};
const $3c28aedf6dc41886$export$d37f637b09fb9fda = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/:chartView'
};
const $3c28aedf6dc41886$export$1e5e610e11119ea7 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/reports/cycle-time'
};
const $3c28aedf6dc41886$export$92f34907c6bf7007 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT),
    path: `/jira/software/c/${$3c28aedf6dc41886$var$jiraIssueFormCreateEndpoint}`,
    exact: true
};
const $3c28aedf6dc41886$export$16987cdd084cceba = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT_EMBED),
    path: `/jira/software/c/${$3c28aedf6dc41886$var$jiraIssueFormCreateEndpoint}/embed`,
    exact: true
};
const $3c28aedf6dc41886$export$312c410cb3b49afe = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/reports/deployment-frequency'
};
const $3c28aedf6dc41886$export$79c2d9718e914f91 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG),
    path: '/jira/people/:accountId/boards/:boardId/backlog'
};
const $3c28aedf6dc41886$export$7b85bca17717def6 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_REPORT),
    path: '/jira/people/:accountId/boards/:boardId/reports/:chartView'
};
const $3c28aedf6dc41886$export$ff874528b0b33a61 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=(planning|planning.nodetail)'
    ]
};
const $3c28aedf6dc41886$export$d27f9ad2fc277ff9 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT),
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=reporting',
        'chart'
    ]
};
const $3c28aedf6dc41886$export$d92cd77785d00ff = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_CODE_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/code'
};
const $3c28aedf6dc41886$export$991b1be164057e91 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_LAST_VISITED_PROJECT_REDIRECT),
    path: '/secure/RapidBoard.jspa',
    query: [
        'projectKey'
    ]
};
const $3c28aedf6dc41886$export$3913c8bee519225c = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_DIRECTORY_REDIRECT),
    path: '/secure/RapidBoard.jspa'
};

});

parcelRegister("1hTYf", function(module, exports) {

$parcel$export(module.exports, "IncidentsPageSkeleton", () => $05b91b3e5d90dad0$export$3105d59d9ca899bd);
$parcel$export(module.exports, "IncidentsTableSkeleton", () => $05b91b3e5d90dad0$export$7092b8ea63ebf9be);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $2aKUc = parcelRequire("2aKUc");

var $ffpXB = parcelRequire("ffpXB");
const $05b91b3e5d90dad0$var$incidentsPageSkeletonStyles = null;
const $05b91b3e5d90dad0$var$incidentsTableSkeletonStyles = null;
const $05b91b3e5d90dad0$export$3105d59d9ca899bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-page",
        className: (0, $7JEyt.default)([
            "_1bsb1x27 _4t3i1osq _ca0q1ejb _19bv1jfw _u5f31jfw _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2aKUc)))
    }));
const $05b91b3e5d90dad0$export$7092b8ea63ebf9be = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-table",
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ffpXB)))
    }));

});
parcelRegister("2aKUc", function(module, exports) {
module.exports = new URL("incidents-page-app-skeleton.tpl.5b656159.svg", import.meta.url).toString();

});

parcelRegister("ffpXB", function(module, exports) {
module.exports = new URL("incidents-page-table-skeleton.tpl.e8f337f1.svg", import.meta.url).toString();

});


parcelRegister("eRmFC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hnCla")
]).then(()=>parcelRequire('51qvE'));

});

parcelRegister("ekzJW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cGBOS")
]).then(()=>parcelRequire('dBngL'));

});

parcelRegister("gyys9", function(module, exports) {

$parcel$export(module.exports, "nextBestTaskFeatureResource", () => $73c842e85172a066$export$5d472f7d515300ca);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $lB25E = parcelRequire("lB25E");

const $73c842e85172a066$export$5d472f7d515300ca = (0, $lB25E.createResource)({
    type: (0, $74042257b0cd863d$export$6f0555de4f60e84e),
    getKey: ()=>(0, $74042257b0cd863d$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            return await (0, $lRmyA.performGetRequest)(`/rest/api/3/mypreferences?key=${(0, $74042257b0cd863d$export$b94951a11282ae6a)}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
				 * If the user has never set the preference, we auto enroll them and set the initial value to true.
				 */ return {
                hasUserOptedIn: true
            };
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: (0, $74042257b0cd863d$export$7f111648ca05f056),
                    packageName: (0, $74042257b0cd863d$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return false,
		 * this ensures if user is in the experiment cohort but later opted out, they don't revert to having the feature enabled */ return {
            hasUserOptedIn: false
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $74042257b0cd863d$export$6f0555de4f60e84e = 'RESOURCE_TYPE_NEXT_BEST_TASK_FEATURE';
const $74042257b0cd863d$export$7e7d7930e22ba39f = 'nbt-opt-in-resource-key'; // value is global for user
const $74042257b0cd863d$export$b94951a11282ae6a = 'next-best-task-feature';
const $74042257b0cd863d$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesNextBestTask';
const $74042257b0cd863d$export$7f111648ca05f056 = 'useResource.fetchNextBestTaskOptInPreference';


parcelRegister("ioEMP", function(module, exports) {

$parcel$export(module.exports, "uifBoardResource", () => $56fa80c31203146f$export$b65bcbbccad354ac);

var $lB25E = parcelRequire("lB25E");


const $56fa80c31203146f$export$b65bcbbccad354ac = (0, $lB25E.createResource)({
    type: (0, $3c069a4b56559612$export$cfae566ecf2855f8),
    getKey: ({ match: { params: { boardId: boardId } }, route: { name: routeName }, query: { config: config } })=>{
        if (config) return `uif-board::${routeName}::config`;
        if (boardId == null) return `uif-board::${routeName}::not-found`;
        return `uif-board::${routeName}::${boardId}`;
    },
    getDataLoader: ()=>(parcelRequire("4QAVu")),
    maxAge: 0
});

});
const $3c069a4b56559612$export$cfae566ecf2855f8 = 'UIF_BOARD';

parcelRegister("4QAVu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hOBob").then(()=>parcelRequire('kWTXq'));

});


parcelRegister("4PVYj", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardRoute", () => $9f593306e01ca1b5$export$131d51ca54849e97);
$parcel$export(module.exports, "classicSoftwareBoardEmbedRoute", () => $9f593306e01ca1b5$export$122afcef7dfd252);

var $exb0h = parcelRequire("exb0h");
const $9f593306e01ca1b5$export$131d51ca54849e97 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId',
    ufoName: 'classic-board'
};
const $9f593306e01ca1b5$export$122afcef7dfd252 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed',
    ufoName: 'classic-board-embed'
};

});

parcelRegister("3rNwL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("lpjx9")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("5zl0P")
]).then(()=>parcelRequire('khBdF'));

});

parcelRegister("chPFS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("fZnjh")
]).then(()=>parcelRequire('ezFY9'));

});

parcelRegister("uz1ju", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("aIMKs")
]).then(()=>parcelRequire('cEWzO'));

});

parcelRegister("bJkub", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("44rJT")
]).then(()=>parcelRequire('aXtv3'));

});

parcelRegister("jAeda", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5CHNc").then(()=>parcelRequire('lJSys'));

});

parcelRegister("dXIya", function(module, exports) {

$parcel$export(module.exports, "issueHierarchyPageResource", () => $0480c10e1548a531$export$98d50a2e19509817);

var $buJlM = parcelRequire("buJlM");

var $6ovLb = parcelRequire("6ovLb");
const $0480c10e1548a531$export$98d50a2e19509817 = (0, $buJlM.createRelayResource)({
    type: 'RESOURCE1',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $6ovLb.default),
            variables: {
                cloudId: tenantContext.cloudId
            }
        })
});

});
parcelRegister("6ovLb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae1a7f5af5d51b13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8302ec971b0cf37e40bca801469af6c9>>
 * @relayHash 6acb7af1e94f5345e9b36a8cd44c4bee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b
const $ae1a7f5af5d51b13$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "level"
    }, v4 = [
        {
            "concreteType": "JiraIssueTypeHierarchyLevel",
            "kind": "LinkedField",
            "name": "hierarchyLevel",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ]
        },
        {
            "concreteType": "JiraIssueTypeConnection",
            "kind": "LinkedField",
            "name": "cmpIssueTypes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                    "kind": "LinkedField",
                                    "name": "hierarchy",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "small"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v5 = {
        "concreteType": "JiraHierarchyConfigError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "code"
            },
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v6 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyConfigurationQuery",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueHierarchyConfigData",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": v4 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "success"
            },
            v5 /*: any*/ 
        ]
    }, v7 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyLimits",
        "kind": "LinkedField",
        "name": "issueHierarchyLimits",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "maxLevels"
            },
            {
                "kind": "ScalarField",
                "name": "nameLength"
            }
        ]
    }, v8 = {
        "args": v1 /*: any*/ ,
        "kind": "ScalarField",
        "name": "lockedIssueTypeIds"
    }, v9 = {
        "concreteType": "JiraIssueHierarchyConfigData",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": true,
        "selections": v4 /*: any*/ 
    }, v10 = {
        "concreteType": "JiraLongRunningTaskProgress",
        "kind": "LinkedField",
        "name": "taskProgress",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "kind": "ScalarField",
                "name": "progress"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainIssueHierarchyQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "saveButton_adminPagesIssueHierarchyDirectory"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "saveDialog_adminPagesIssueHierarchyDirectory"
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainIssueHierarchyQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b",
            "metadata": {},
            "name": "mainIssueHierarchyQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ae1a7f5af5d51b13$var$node.hash = "e780e64aedcd2278004df68a042f1343";
var $ae1a7f5af5d51b13$export$2e2bcd8739ae039 = $ae1a7f5af5d51b13$var$node;

});


parcelRegister("dCvLw", function(module, exports) {

$parcel$export(module.exports, "insightsBoardSettingsResource", () => $96e234735db19e83$export$527e75c8918894d5);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $JRB5w = parcelRequire("JRB5w");

var $7OWi6 = parcelRequire("7OWi6");

var $1qlgb = parcelRequire("1qlgb");

var $D8uHu = parcelRequire("D8uHu");

var $4fN5I = parcelRequire("4fN5I");

var $aND76 = parcelRequire("aND76");

var $3FyZ4 = parcelRequire("3FyZ4");

var $lB25E = parcelRequire("lB25E");

var $1hcN5 = parcelRequire("1hcN5");
const $96e234735db19e83$export$527e75c8918894d5 = (0, $lB25E.createResource)({
    type: (0, $1hcN5.RESOURCE_TYPE),
    maxAge: (0, $1hcN5.FIVE_MINS_IN_MILLS),
    getKey: ({ match: match })=>`${0, $1hcN5.KEY_PREFIX}-${String(match.params.boardId)}`,
    getData: async ({ match: match })=>{
        const boardId = Number(match.params.boardId);
        if (!Number.isInteger(boardId)) // eslint-disable-next-line @typescript-eslint/no-empty-function
        return new Promise(()=>{});
        const webAnalyticsClient = await (0, $3FyZ4.getAnalyticsWebClientPromise)();
        const actionSubject = `${(0, $1hcN5.insightsSettingsLoaderAnalytics).ACTION_SUBJECT}.${(0, $1hcN5.insightsSettingsLoaderAnalytics).ACTION_SUBJECT_ID}`;
        const analyticsClient = webAnalyticsClient.getInstance();
        if (!analyticsClient) return (0, $aND76.fetchInsightsSettings)({
            boardId: boardId
        }).then((data)=>(0, $4fN5I.withDefaults)(data.context.board.settings));
        analyticsClient.sendOperationalEvent({
            action: 'dataFetch',
            actionSubject: actionSubject,
            source: (0, $1hcN5.ANALYTICS_SOURCE),
            attributes: {
                status: (0, $D8uHu.analyticsStatuses).STARTED,
                boardId: boardId
            }
        });
        const metricsTracker = (0, $7OWi6.trackBrowserMetricsForJira)({
            browserMetricsKey: actionSubject
        });
        try {
            metricsTracker.start();
            const data = await (0, $aND76.fetchInsightsSettings)({
                boardId: boardId
            });
            analyticsClient.sendOperationalEvent({
                action: 'dataFetch',
                actionSubject: actionSubject,
                source: (0, $1hcN5.ANALYTICS_SOURCE),
                attributes: {
                    statusCodeGroup: '2xx',
                    status: (0, $D8uHu.analyticsStatuses).SUCCEEDED,
                    boardId: boardId
                }
            });
            metricsTracker.end();
            return Promise.resolve((0, $4fN5I.withDefaults)(data.context.board.settings));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            metricsTracker.cancel();
            if (!(0, $JRB5w.isClientFetchError)(error)) {
                analyticsClient.sendOperationalEvent({
                    action: 'dataFetch',
                    actionSubject: actionSubject,
                    source: (0, $1hcN5.ANALYTICS_SOURCE),
                    attributes: {
                        statusCodeGroup: (0, $1qlgb.getStatusCodeGroup)(error instanceof (0, $7byHA.default) ? error.statusCode : -1),
                        status: (0, $D8uHu.analyticsStatuses).FAILED,
                        boardId: boardId
                    }
                });
                (0, $gUUjF.default).safeErrorWithoutCustomerData(actionSubject, 'Error fetching insights settings data', error);
                throw error;
            }
            (0, $guiFP.default)({
                meta: {
                    id: actionSubject,
                    packageName: 'jiraBoardSettingsInsightsRoute',
                    teamName: 'helios-headcoach'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
});

});
parcelRegister("7OWi6", function(module, exports) {

$parcel$export(module.exports, "trackBrowserMetricsForJira", () => $11ad959b7c456982$export$d8b2320f7d41dc1d);

var $lNfG4 = parcelRequire("lNfG4");

var $isy2b = parcelRequire("isy2b");
const $11ad959b7c456982$export$d8b2320f7d41dc1d = ({ browserMetricsKey: browserMetricsKey, attributes: attributes, histogram: // Define bucket sizes for histogram. e.g.: '100_500_1000_2500_5000_10000'. Default to '500_1000_1500_4000_7000'.
histogram })=>{
    if (browserMetricsKey === null || browserMetricsKey === undefined) return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        start: ()=>{},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        end: ()=>{},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        cancel: ()=>{}
    };
    const bm3MetricsTracker = (0, $lNfG4.metrics).interaction({
        key: browserMetricsKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string | undefined; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: histogram || (0, $isy2b.DEFAULT_HISTOGRAM_BUCKETS)
        }
    });
    const startHandler = ()=>{
        bm3MetricsTracker.start();
    };
    const endHandler = ()=>{
        bm3MetricsTracker.stop({
            customData: attributes
        });
    };
    const cancelHandler = ()=>{
        bm3MetricsTracker.cancel();
    };
    return {
        start: startHandler,
        end: endHandler,
        cancel: cancelHandler
    };
};

});
parcelRegister("isy2b", function(module, exports) {

$parcel$export(module.exports, "STORE_NAME", () => $f085a1c4ef5efebe$export$cd79d01fb3d2f506);
$parcel$export(module.exports, "experiences", () => $f085a1c4ef5efebe$export$9848ee2a7d21002f);
$parcel$export(module.exports, "TIMEOUT_IN_MS", () => $f085a1c4ef5efebe$export$9ebf97d10ce21f3b);
$parcel$export(module.exports, "DEFAULT_HISTOGRAM_BUCKETS", () => $f085a1c4ef5efebe$export$e3b77a602bc4d0e6);

const $f085a1c4ef5efebe$export$cd79d01fb3d2f506 = `${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.experience-tracker-store`;
const $f085a1c4ef5efebe$export$9848ee2a7d21002f = {
    RENDER: 'render'
};
const $f085a1c4ef5efebe$export$9ebf97d10ce21f3b = 7000;
const $f085a1c4ef5efebe$export$e3b77a602bc4d0e6 = '500_1000_1500_4000_7000';

});
const $3523ef16f82a4788$export$d3996f57ffa8448f = 'jira.insights';
const $3523ef16f82a4788$export$c9290acd1ba498ff = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.board`;
const $3523ef16f82a4788$export$2fd6d7f902b01d67 = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.backlog`;
const $3523ef16f82a4788$export$8e66b21ec141a0bd = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.board-simplified`;
const $3523ef16f82a4788$export$75eb9639a5b0ba25 = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.backlog-simplified`;
const $3523ef16f82a4788$export$1269ea4f2b198811 = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.error-boundary`;



parcelRegister("1qlgb", function(module, exports) {

$parcel$export(module.exports, "getStatusCodeGroup", () => $1a861f837db6f751$export$d14e9b22afc87cb3);
$parcel$export(module.exports, "trackDataFetchAnalytics", () => $1a861f837db6f751$export$bc65acfb4b442c00);

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $JRB5w = parcelRequire("JRB5w");

var $jMP2a = parcelRequire("jMP2a");

var $D8uHu = parcelRequire("D8uHu");
const $1a861f837db6f751$export$d14e9b22afc87cb3 = (statusCode)=>{
    if (statusCode === null) return (0, $D8uHu.statusCodeGroups).UNKNOWN;
    if (statusCode >= 100 && statusCode <= 199) return (0, $D8uHu.statusCodeGroups).INFORMATIONAL_RESPONSES;
    if (statusCode >= 200 && statusCode <= 299) return (0, $D8uHu.statusCodeGroups).SUCCESS_RESPONSES;
    if (statusCode >= 300 && statusCode <= 399) return (0, $D8uHu.statusCodeGroups).REDIRECTS;
    if (statusCode >= 400 && statusCode <= 499) return (0, $D8uHu.statusCodeGroups).CLIENT_ERRORS;
    if (statusCode >= 500 && statusCode <= 599) return (0, $D8uHu.statusCodeGroups).SERVER_ERRORS;
    return (0, $D8uHu.statusCodeGroups).UNKNOWN;
};
const $1a861f837db6f751$var$includeSample = (sampleRate)=>Math.random() <= 1 / sampleRate;
const $1a861f837db6f751$var$noopAnalytics = Object.freeze({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    start: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    succeeded: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    failed: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    aborted: ()=>{}
});
const $1a861f837db6f751$export$bc65acfb4b442c00 = ({ action: action = 'dataFetch', actionSubject: actionSubject, packageName: packageName, createAnalyticsEvent: createAnalyticsEvent, sampleRate: sampleRate })=>{
    if (actionSubject == null) return $1a861f837db6f751$var$noopAnalytics;
    if (sampleRate != null && !$1a861f837db6f751$var$includeSample(sampleRate)) return $1a861f837db6f751$var$noopAnalytics;
    // Note: Operational analytics do NOT use actionSubjectId!
    const actionSubjectAndAction = `${actionSubject} ${action}`;
    return Object.freeze({
        start: ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                status: (0, $D8uHu.analyticsStatuses).STARTED,
                packageName: packageName
            });
        },
        succeeded: ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                statusCodeGroup: '2xx',
                status: (0, $D8uHu.analyticsStatuses).SUCCEEDED,
                packageName: packageName
            });
        },
        failed: (e)=>{
            const error = e !== null && e !== undefined ? e : new Error('Unknown error, e should be present');
            if (!(0, $JRB5w.isClientFetchError)(e)) {
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                    statusCodeGroup: $1a861f837db6f751$export$d14e9b22afc87cb3(error instanceof (0, $7byHA.default) ? error.statusCode : -1),
                    status: (0, $D8uHu.analyticsStatuses).FAILED,
                    packageName: packageName
                });
                return;
            }
            // No network connection error
            (0, $guiFP.default)({
                meta: {
                    id: actionSubject,
                    packageName: packageName
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        aborted: ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                status: (0, $D8uHu.analyticsStatuses).ABORTED,
                packageName: packageName
            });
        }
    });
};

});
parcelRegister("D8uHu", function(module, exports) {

$parcel$export(module.exports, "statusCodeGroups", () => $0d21864ed8a1de20$export$fddea1bcaead87d5);
$parcel$export(module.exports, "analyticsStatuses", () => $0d21864ed8a1de20$export$f0fa81eb65b496a1);
const $0d21864ed8a1de20$export$fddea1bcaead87d5 = {
    INFORMATIONAL_RESPONSES: '1xx',
    SUCCESS_RESPONSES: '2xx',
    REDIRECTS: '3xx',
    CLIENT_ERRORS: '4xx',
    SERVER_ERRORS: '5xx',
    UNKNOWN: 'unknown'
};
const $0d21864ed8a1de20$export$f0fa81eb65b496a1 = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    ABORTED: 'aborted',
    STARTED: 'started'
};

});


parcelRegister("4fN5I", function(module, exports) {

$parcel$export(module.exports, "withDefaults", () => $076c5cff5d9f9d8b$export$4df9c0969a9e0160);

var $2pKbZ = parcelRequire("2pKbZ");
const $076c5cff5d9f9d8b$var$insightsSettingsDefaultsKeys = Object.keys((0, $2pKbZ.insightsSettingsDefaults));
const $076c5cff5d9f9d8b$export$4df9c0969a9e0160 = (settings)=>{
    const insightKeys = [
        ...Object.keys(settings),
        ...$076c5cff5d9f9d8b$var$insightsSettingsDefaultsKeys
    ];
    const uniqueKeys = [
        ...new Set(insightKeys)
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const merged = uniqueKeys.reduce((result, key)=>{
        /* eslint-disable no-param-reassign */ // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'BoardInsightsSettingsResponse | Partial<Diff<BoardInsightsSettings, Record<any, any>>>'.
        result[key] = {
            ...(0, $2pKbZ.insightsSettingsDefaults)[key],
            ...settings[key]
        };
        /* eslint-enable no-param-reassign */ return result;
    }, {});
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return merged;
};

});
parcelRegister("2pKbZ", function(module, exports) {

$parcel$export(module.exports, "INSIGHTS_SETTINGS_ANALYTICS", () => $69396c33c096e9cc$export$c9b681bb814b8d21);
$parcel$export(module.exports, "INSIGHTS_SETTINGS_UPDATE_SUCCESS_FLAG_ID", () => $69396c33c096e9cc$export$f9fa93046ad61876);
$parcel$export(module.exports, "INSIGHTS_SETTINGS_UPDATE_ERROR_FLAG_ID", () => $69396c33c096e9cc$export$b9dc3d9b5ea30bf1);
$parcel$export(module.exports, "insightsSettingsLoaderAnalytics", () => $69396c33c096e9cc$export$4cefda6d846a04d4);
$parcel$export(module.exports, "insightsSettingsDefaults", () => $69396c33c096e9cc$export$a4afea03fa81b43c);
$parcel$export(module.exports, "BACKLOG_LOCATION", () => $69396c33c096e9cc$export$bdfa779dd9b3cf14);
$parcel$export(module.exports, "BOARD_LOCATION", () => $69396c33c096e9cc$export$d0dc0955ed2af099);
$parcel$export(module.exports, "hasBoardAdminPermissionAnalytics", () => $69396c33c096e9cc$export$e441e25a172c7483);
$parcel$export(module.exports, "GET_SETTINGS_ENDPOINT_TIMEOUT_WHEN_INSIGHTS_LOADING", () => $69396c33c096e9cc$export$3176caa73e046722);

var $fjTax = parcelRequire("fjTax");

var $52hWf = parcelRequire("52hWf");

var $jCgYJ = parcelRequire("jCgYJ");

var $1keuD = parcelRequire("1keuD");


var $dS37D = parcelRequire("dS37D");

var $ftkhh = parcelRequire("ftkhh");
const $69396c33c096e9cc$export$c9b681bb814b8d21 = `${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.settings`;
const $69396c33c096e9cc$export$f9fa93046ad61876 = `${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.settings.update-flag.success`;
const $69396c33c096e9cc$export$b9dc3d9b5ea30bf1 = `${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.settings.update-flag.error`;
const $69396c33c096e9cc$export$4cefda6d846a04d4 = {
    ACTION_SUBJECT: $69396c33c096e9cc$export$c9b681bb814b8d21,
    ACTION_SUBJECT_ID: 'get-settings'
};
const $69396c33c096e9cc$export$a4afea03fa81b43c = {
    [(0, $dS37D.SPRINT_COMMITMENT_BEACON_ID)]: (0, $dS37D.SPRINT_COMMITMENT_SETTINGS_DEFAULTS),
    [(0, $jCgYJ.ISSUE_TYPE_WORKLOAD_BEACON_ID)]: (0, $jCgYJ.ISSUE_TYPE_WORKLOAD_SETTINGS_DEFAULTS),
    [(0, $fjTax.BURNDOWN_BEACON_ID)]: (0, $fjTax.BURNDOWN_SETTINGS_DEFAULTS),
    [(0, $ftkhh.SPRINT_PROGRESS_BEACON_ID)]: (0, $ftkhh.SPRINT_PROGRESS_SETTINGS_DEFAULTS),
    [(0, $52hWf.EPIC_PROGRESS_BEACON_ID)]: (0, $52hWf.EPIC_PROGRESS_SETTINGS_DEFAULTS),
    [(0, $1keuD.ISSUES_FOR_ATTENTION_BEACON_ID)]: (0, $1keuD.ISSUES_FOR_ATTENTION_SETTINGS_DEFAULTS)
};
const $69396c33c096e9cc$export$bdfa779dd9b3cf14 = 'backlog';
const $69396c33c096e9cc$export$d0dc0955ed2af099 = 'board';
const $69396c33c096e9cc$export$e441e25a172c7483 = {
    ACTION_SUBJECT: $69396c33c096e9cc$export$c9b681bb814b8d21,
    ACTION_SUBJECT_ID: 'board-admin'
};
const $69396c33c096e9cc$export$3176caa73e046722 = 10000;

});
parcelRegister("fjTax", function(module, exports) {

$parcel$export(module.exports, "BURNDOWN_BEACON_ID", () => $7876d445ed2891c7$export$b2ed7cef94c6827a);
$parcel$export(module.exports, "BURNDOWN_SETTINGS_DEFAULTS", () => $7876d445ed2891c7$export$5d0b256a08333f73);
const $7876d445ed2891c7$export$b2ed7cef94c6827a = 'burndown';
const $7876d445ed2891c7$export$5d0b256a08333f73 = {
    hidden: false
};

});

parcelRegister("52hWf", function(module, exports) {

$parcel$export(module.exports, "EPIC_PROGRESS_BEACON_ID", () => $81493a83752aa6c6$export$afa5ec1deda5d045);
$parcel$export(module.exports, "EPIC_PROGRESS_SETTINGS_DEFAULTS", () => $81493a83752aa6c6$export$bd0bec9335b40176);
const $81493a83752aa6c6$export$afa5ec1deda5d045 = 'epic-progress';
const $81493a83752aa6c6$export$bd0bec9335b40176 = {
    hidden: false
};

});

parcelRegister("jCgYJ", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE_WORKLOAD_BEACON_ID", () => $a6a0cbb5163f250a$export$d09e320e96d42c8);
$parcel$export(module.exports, "ISSUE_TYPE_WORKLOAD_SETTINGS_DEFAULTS", () => $a6a0cbb5163f250a$export$efccdab5672702c8);
const $a6a0cbb5163f250a$export$d09e320e96d42c8 = 'issue-type-workload';
const $a6a0cbb5163f250a$export$efccdab5672702c8 = {
    hidden: false
};

});

parcelRegister("1keuD", function(module, exports) {

$parcel$export(module.exports, "ISSUES_FOR_ATTENTION_BEACON_ID", () => $4545d5bbd9df0ef8$export$520574b6e5f9d64a);
$parcel$export(module.exports, "ISSUES_FOR_ATTENTION_SETTINGS_DEFAULTS", () => $4545d5bbd9df0ef8$export$36b8eb4d5050cbb6);
const $4545d5bbd9df0ef8$export$520574b6e5f9d64a = 'issues-for-attention';
const $4545d5bbd9df0ef8$export$36b8eb4d5050cbb6 = {
    hidden: false
};

});

parcelRegister("dS37D", function(module, exports) {

$parcel$export(module.exports, "SPRINT_COMMITMENT_BEACON_ID", () => $dd3561373673102b$export$d52c62a328b63990);
$parcel$export(module.exports, "SPRINT_COMMITMENT_SETTINGS_DEFAULTS", () => $dd3561373673102b$export$b361fc55b75ed5af);
const $dd3561373673102b$export$d52c62a328b63990 = 'sprint-commitment';
const $dd3561373673102b$export$b361fc55b75ed5af = {
    hidden: false
};

});

parcelRegister("ftkhh", function(module, exports) {

$parcel$export(module.exports, "SPRINT_PROGRESS_BEACON_ID", () => $d690dd124fce9824$export$ac6fe62b1e8a0a52);
$parcel$export(module.exports, "SPRINT_PROGRESS_SETTINGS_DEFAULTS", () => $d690dd124fce9824$export$9f1a147e443d188);
const $d690dd124fce9824$export$ac6fe62b1e8a0a52 = 'sprint-progress';
const $d690dd124fce9824$export$9f1a147e443d188 = {
    hidden: false
};

});



parcelRegister("aND76", function(module, exports) {

$parcel$export(module.exports, "fetchInsightsSettings", () => $a9eed9dd911a5eb8$export$1b3686b537bacb54);

var $8gjGw = parcelRequire("8gjGw");
const $a9eed9dd911a5eb8$export$1b3686b537bacb54 = async ({ boardId: boardId }, options)=>(0, $8gjGw.fetchJson)(`/gateway/api/jira-insights/settings/board/${boardId}`, options);

});
parcelRegister("8gjGw", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $63986de7e8960fb5$export$6d71b655afe1638d);

var $2OdyW = parcelRequire("2OdyW");

var $2otYT = parcelRequire("2otYT");
const $63986de7e8960fb5$export$6d71b655afe1638d = async (url, options = {})=>(0, $2OdyW.default)(url, options).catch((error)=>{
        throw new (0, $2otYT.FetchUrlError)(url, error);
    });

});
parcelRegister("2otYT", function(module, exports) {

$parcel$export(module.exports, "FetchUrlError", () => $b1b20faaa84f8ec8$export$5cdfc90b27d7ab6c);

var $7byHA = parcelRequire("7byHA");

var $JRB5w = parcelRequire("JRB5w");

var $9Anw5 = parcelRequire("9Anw5");

var $7L7ae = parcelRequire("7L7ae");
const $b1b20faaa84f8ec8$var$getStatusCodeGroup = (statusCode)=>{
    if (statusCode === null) return (0, $7L7ae.statusCodeGroups).UNKNOWN;
    if (statusCode >= 100 && statusCode <= 199) return (0, $7L7ae.statusCodeGroups).INFORMATIONAL_RESPONSES;
    if (statusCode >= 200 && statusCode <= 299) return (0, $7L7ae.statusCodeGroups).SUCCESS_RESPONSES;
    if (statusCode >= 300 && statusCode <= 399) return (0, $7L7ae.statusCodeGroups).REDIRECTS;
    if (statusCode >= 400 && statusCode <= 499) return (0, $7L7ae.statusCodeGroups).CLIENT_ERRORS;
    if (statusCode >= 500 && statusCode <= 599) return (0, $7L7ae.statusCodeGroups).SERVER_ERRORS;
    return (0, $7L7ae.statusCodeGroups).UNKNOWN;
};
const $b1b20faaa84f8ec8$var$stringifySafe = (obj)=>{
    try {
        return JSON.stringify(obj);
    } catch  {
        return null;
    }
};
class $b1b20faaa84f8ec8$export$5cdfc90b27d7ab6c extends (0, $7byHA.default) {
    constructor(url, fetchError){
        if (fetchError instanceof (0, $7byHA.default)) super(fetchError.statusCode, fetchError.message, fetchError.traceId);
        else super(-1, fetchError.message);
        this.name = 'FetchUrlError';
        this.url = (0, $9Anw5.default)(url);
        this.aborted = fetchError.name === (0, $7byHA.ABORT_ERROR_NAME);
        this.isClientError = (0, $JRB5w.isClientFetchError)(fetchError) || this.statusCode === -1;
        this.statusCodeGroup = $b1b20faaa84f8ec8$var$getStatusCodeGroup(fetchError instanceof (0, $7byHA.default) ? fetchError.statusCode : null);
        // NOTE: logging does not support nested objects!
        this.cause = $b1b20faaa84f8ec8$var$stringifySafe(fetchError);
    }
}

});
parcelRegister("7L7ae", function(module, exports) {

$parcel$export(module.exports, "statusCodeGroups", () => $71f26b6747cd60d2$export$fddea1bcaead87d5);
const $71f26b6747cd60d2$export$fddea1bcaead87d5 = {
    INFORMATIONAL_RESPONSES: '1xx',
    SUCCESS_RESPONSES: '2xx',
    REDIRECTS: '3xx',
    CLIENT_ERRORS: '4xx',
    SERVER_ERRORS: '5xx',
    UNKNOWN: 'unknown'
};

});




parcelRegister("1hcN5", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE", () => $29545433a695bd7a$export$6f0555de4f60e84e);
$parcel$export(module.exports, "KEY_PREFIX", () => $29545433a695bd7a$export$711117ad6ad27992);
$parcel$export(module.exports, "insightsSettingsLoaderAnalytics", () => $29545433a695bd7a$export$4cefda6d846a04d4);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $29545433a695bd7a$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "FIVE_MINS_IN_MILLS", () => $29545433a695bd7a$export$9f0c88673545153a);

var $2pKbZ = parcelRequire("2pKbZ");
const $29545433a695bd7a$export$6f0555de4f60e84e = 'INSIGHT_SETTINGS_RESOURCE_TYPE';
const $29545433a695bd7a$export$711117ad6ad27992 = 'INSIGHT_SETTINGS_BOARD';
const $29545433a695bd7a$export$4cefda6d846a04d4 = {
    ACTION_SUBJECT: (0, $2pKbZ.INSIGHTS_SETTINGS_ANALYTICS),
    ACTION_SUBJECT_ID: 'get-settings'
};
const $29545433a695bd7a$export$f7109619a5e9e0d6 = 'insightsBoardSettingsScreen';
const $29545433a695bd7a$export$9f0c88673545153a = 300000;

});


parcelRegister("7msR2", function(module, exports) {

$parcel$export(module.exports, "NextGenBacklogSkeleton", () => $6f15cd0ce78d5d9a$export$33cd465913cf178f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9zysr = parcelRequire("9zysr");

var $8rQuz = parcelRequire("8rQuz");

var $8ICxF = parcelRequire("8ICxF");

var $eU7pV = parcelRequire("eU7pV");
const $6f15cd0ce78d5d9a$export$433c2e8574f2e911 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eU7pV)))
    });
const $6f15cd0ce78d5d9a$export$88189b56881f213e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f15cd0ce78d5d9a$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eU7pV)))
    }));
const $6f15cd0ce78d5d9a$export$33cd465913cf178f = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $6f15cd0ce78d5d9a$export$88189b56881f213e, $6f15cd0ce78d5d9a$export$433c2e8574f2e911);
// Adding this wrapper to override the border width from AppSkeletonImage
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $6f15cd0ce78d5d9a$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eU7pV", function(module, exports) {
module.exports = new URL("next-gen-backlog-app-skeleton.tpl.28e29051.svg", import.meta.url).toString();

});


parcelRegister("2b3mr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("bqk09")
]).then(()=>parcelRequire('gSV7c'));

});

parcelRegister("1fF9e", function(module, exports) {

$parcel$export(module.exports, "useSelectedConfigTab", () => $7f7e09d62164e8b6$export$9b386f1a3e61b385);
const $7f7e09d62164e8b6$export$9b386f1a3e61b385 = ()=>{
    const SELECTED_CONFIG_TAB_KEY = 'selectedConfigTab';
    const getSelectedConfigTab = ()=>localStorage.getItem(SELECTED_CONFIG_TAB_KEY) || '';
    const setSelectedConfigTab = (newConfigTab)=>localStorage.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
    return {
        getSelectedConfigTab: getSelectedConfigTab,
        setSelectedConfigTab: setSelectedConfigTab
    };
};

});

parcelRegister("ezjOd", function(module, exports) {

$parcel$export(module.exports, "deploymentPreconditionRelayResource", () => $2cde8cce0318a4d6$export$50e4eedb9e6127c8);

var $buJlM = parcelRequire("buJlM");

var $eqwtX = parcelRequire("eqwtX");

var $lB25E = parcelRequire("lB25E");


const $2cde8cce0318a4d6$export$a1c09d7f7318f85c = (0, $lB25E.createResource)({
    type: (0, $234d9f72f46eb994$export$2171160371fac588),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("k6h0b")),
    maxAge: 60000
});
const $2cde8cce0318a4d6$export$50e4eedb9e6127c8 = (0, $buJlM.createRelayResource)({
    type: (0, $234d9f72f46eb994$export$a969d0487e348031),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $eqwtX.default),
            variables: {
                cloudId: tenantContext.cloudId,
                projectKey: String(match.params.projectKey)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("eqwtX", function(module, exports) {

$parcel$export(module.exports, "default", () => $886e04029501ef9c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<946bfee09c64f3e6ddd3c9cbab07a461>>
 * @relayHash ea273678a5c985c0053babf0f185662a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2
const $886e04029501ef9c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "deploymentsFeaturePreconditionByProjectKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v1 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira.deploymentsFeaturePreconditionByProjectKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2",
            "metadata": {},
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$886e04029501ef9c$var$node.hash = "3337e3d6b76da02b643c63aacd15b239";
var $886e04029501ef9c$export$2e2bcd8739ae039 = $886e04029501ef9c$var$node;

});

const $234d9f72f46eb994$export$2171160371fac588 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION';
const $234d9f72f46eb994$export$a969d0487e348031 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION_RELAY';

parcelRegister("k6h0b", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aQcUz").then(()=>parcelRequire('7Qtbv'));

});


parcelRegister("yyqSx", function(module, exports) {

$parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", () => $d7ad054dfd872773$export$18bfef4995ec57b7);

var $dfBCt = parcelRequire("dfBCt");

var $6goyu = parcelRequire("6goyu");
const $d7ad054dfd872773$export$18bfef4995ec57b7 = ()=>(0, $6goyu.isDisableDevopsFeaturesInFedRampEnvEnabled)() && (0, $dfBCt.isFedRamp)();

});
parcelRegister("6goyu", function(module, exports) {

$parcel$export(module.exports, "isDisableDevopsFeaturesInFedRampEnvEnabled", () => $0bb8681ee65fdabd$export$a803c452d83c73b6);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1ybV0 = parcelRequire("1ybV0");
const $0bb8681ee65fdabd$export$a803c452d83c73b6 = ()=>(0, $1ybV0.ff)('core-x-fedramp-m1-disable-devops-features_ag5zy');

});


parcelRegister("fjWga", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("go06p")
]).then(()=>parcelRequire('actEI'));

});

parcelRegister("8GNim", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("d3kdQ")
]).then(()=>parcelRequire('4519u'));

});

parcelRegister("1iKNe", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dIAew").then(()=>parcelRequire('gOuDd'));

});

parcelRegister("lSBiK", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("kD0Uq")
]).then(()=>parcelRequire('cRWzT'));

});

parcelRegister("iHeQd", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $c0131ee3b9f66913$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "InsightsSkeleton", () => $c0131ee3b9f66913$export$dd0b74c715df3275);
$parcel$export(module.exports, "SuggestionsSkeleton", () => $c0131ee3b9f66913$export$91f27b306afd627b);
$parcel$export(module.exports, "WorkItemsSkeleton", () => $c0131ee3b9f66913$export$1660f3159b79b22b);
$parcel$export(module.exports, "WorkItemsVulnTabSkeleton", () => $c0131ee3b9f66913$export$5aea7d4ed03d6ea6);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hdmGS = parcelRequire("hdmGS");

var $f1zAm = parcelRequire("f1zAm");
const $c0131ee3b9f66913$export$8f31e4c4a37b8e9c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c0131ee3b9f66913$var$SpinnerContainerStyles,
        "data-testId": "software-periscope-periscope-page.ui.loading",
        "aria-label": formatMessage((0, $f1zAm.default).labelNonFinal),
        padding: "space.500"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hdmGS.PeriscopePageSkeleton), null));
};
const $c0131ee3b9f66913$export$dd0b74c715df3275 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: (0, $eI5EY.fg)('jira_periscope_new_widgets') ? $c0131ee3b9f66913$var$InsightsNewContainerStyles : $c0131ee3b9f66913$var$InsightsOldContainerStyles,
        "data-testId": "software-periscope-periscope-page.insights-ui.loading",
        "aria-label": formatMessage((0, $f1zAm.default).insightsLabelNonFinal),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hdmGS.PeriscopeInsightsSkeleton), null));
};
const $c0131ee3b9f66913$export$91f27b306afd627b = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c0131ee3b9f66913$var$SuggestionsContainerStyles,
        "data-testId": "software-periscope-periscope-page.suggestions-ui.loading",
        "aria-label": formatMessage((0, $f1zAm.default).suggestionsLabelNonFinal),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hdmGS.PeriscopeSuggestionsSkeleton), null));
};
const $c0131ee3b9f66913$export$1660f3159b79b22b = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c0131ee3b9f66913$var$WorkItemsSpinnerContainerStyles,
        "aria-label": formatMessage((0, $f1zAm.default).workItemsLabelNonFinal),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hdmGS.PeriscopeWorkItemsSkeleton), null));
};
const $c0131ee3b9f66913$export$5aea7d4ed03d6ea6 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c0131ee3b9f66913$var$WorkItemsVulnTabSpinnerContainerStyles,
        "aria-label": formatMessage((0, $f1zAm.default).workItemsVulnTabLabelNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hdmGS.DevelopmentPageWorkItemsVulnTabSkeleton), null));
};
const $c0131ee3b9f66913$var$SpinnerContainerStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden'
});
const $c0131ee3b9f66913$var$SuggestionsContainerStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    overflow: 'hidden',
    height: '650px',
    boxSizing: 'border-box'
});
const $c0131ee3b9f66913$var$InsightsOldContainerStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    width: '100%',
    height: '315px',
    boxSizing: 'border-box'
});
const $c0131ee3b9f66913$var$InsightsNewContainerStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    width: '100%',
    height: '385px',
    boxSizing: 'border-box'
});
const $c0131ee3b9f66913$var$WorkItemsSpinnerContainerStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    minWidth: '800px',
    height: '600px',
    boxSizing: 'border-box',
    overflow: 'hidden'
});
const $c0131ee3b9f66913$var$WorkItemsVulnTabSpinnerContainerStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    minWidth: '800px',
    height: '420px',
    boxSizing: 'border-box',
    overflow: 'hidden'
});

});
parcelRegister("hdmGS", function(module, exports) {

$parcel$export(module.exports, "PeriscopeSuggestionsSkeleton", () => $5cfbc0a039f0309c$export$176dfe4c14771136);
$parcel$export(module.exports, "PeriscopeWorkItemsSkeleton", () => $5cfbc0a039f0309c$export$298a6b6a251923c2);
$parcel$export(module.exports, "PeriscopePageSkeleton", () => $5cfbc0a039f0309c$export$4aecc030c4d69f74);
$parcel$export(module.exports, "PeriscopeInsightsSkeleton", () => $5cfbc0a039f0309c$export$afb44f298901be44);
$parcel$export(module.exports, "DevelopmentPageWorkItemsVulnTabSkeleton", () => $5cfbc0a039f0309c$export$8940e0b80e4066d6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $dnJL9 = parcelRequire("dnJL9");

var $8ICxF = parcelRequire("8ICxF");

var $3CYXB = parcelRequire("3CYXB");

var $92uwK = parcelRequire("92uwK");

var $4xweL = parcelRequire("4xweL");

var $hTZMm = parcelRequire("hTZMm");

var $8SyTm = parcelRequire("8SyTm");

var $2SMRn = parcelRequire("2SMRn");

var $9j4U2 = parcelRequire("9j4U2");
const $5cfbc0a039f0309c$var$PeriscopePageSkeletonStyles = null;
const $5cfbc0a039f0309c$export$74a3ef828a3116fa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-skeleton-image-periscope-page-old",
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hTZMm)))
    }));
const $5cfbc0a039f0309c$export$84896377a913e516 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-skeleton-image-periscope-page-new",
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4xweL)))
    }));
const $5cfbc0a039f0309c$export$176dfe4c14771136 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-suggestions-skeleton",
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8SyTm)))
    }));
const $5cfbc0a039f0309c$export$9e8fe8b900bf1c04 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-insights-old-skeleton",
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($92uwK)))
    }));
const $5cfbc0a039f0309c$export$8bb0d4f71559d0d5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-insights-new-skeleton",
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3CYXB)))
    }));
const $5cfbc0a039f0309c$export$298a6b6a251923c2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9j4U2)))
    }));
const $5cfbc0a039f0309c$export$4aecc030c4d69f74 = (0, $dnJL9.componentWithFG)('jira_periscope_new_widgets', $5cfbc0a039f0309c$export$84896377a913e516, $5cfbc0a039f0309c$export$74a3ef828a3116fa);
const $5cfbc0a039f0309c$export$afb44f298901be44 = (0, $dnJL9.componentWithFG)('jira_periscope_new_widgets', $5cfbc0a039f0309c$export$8bb0d4f71559d0d5, $5cfbc0a039f0309c$export$9e8fe8b900bf1c04);
const $5cfbc0a039f0309c$export$8940e0b80e4066d6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2SMRn)))
    }));

});
parcelRegister("3CYXB", function(module, exports) {
module.exports = new URL("insights-new-layout.tpl.4a3fb44d.svg", import.meta.url).toString();

});

parcelRegister("92uwK", function(module, exports) {
module.exports = new URL("insights.tpl.1e44c5ba.svg", import.meta.url).toString();

});

parcelRegister("4xweL", function(module, exports) {
module.exports = new URL("periscope-page-new-layout.tpl.243222d7.svg", import.meta.url).toString();

});

parcelRegister("hTZMm", function(module, exports) {
module.exports = new URL("periscope-page-stable.tpl.2b13b8d4.svg", import.meta.url).toString();

});

parcelRegister("8SyTm", function(module, exports) {
module.exports = new URL("suggestions.tpl.dbb32053.svg", import.meta.url).toString();

});

parcelRegister("2SMRn", function(module, exports) {
module.exports = new URL("vuln-tab-skeleton.tpl.ab369e98.svg", import.meta.url).toString();

});

parcelRegister("9j4U2", function(module, exports) {
module.exports = new URL("work-items.tpl.9ce4421e.svg", import.meta.url).toString();

});


parcelRegister("f1zAm", function(module, exports) {

$parcel$export(module.exports, "default", () => $93521ef7c0ce60b1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $93521ef7c0ce60b1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    labelNonFinal: {
        "id": "periscope.skeleton.label-non-final",
        "defaultMessage": "Loading"
    },
    suggestionsLabelNonFinal: {
        "id": "periscope.suggestions-skeleton.label-non-final",
        "defaultMessage": "Suggestions loading"
    },
    insightsLabelNonFinal: {
        "id": "periscope.insights-skeleton.label-non-final",
        "defaultMessage": "Developer insights loading"
    },
    workItemsLabelNonFinal: {
        "id": "periscope.work-items-skeleton.work-items-label-non-final",
        "defaultMessage": "Work items loading"
    },
    workItemsVulnTabLabelNonFinal: {
        "id": "periscope.work-items-skeleton.work-items-vuln-tab-label-non-final",
        "defaultMessage": "Work items vulnerability tab loading"
    }
});

});


parcelRegister("gLCMH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("LV3yE")
]).then(()=>parcelRequire('iIPAF'));

});

parcelRegister("2ijRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $63c0d8b469289537$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var /**
 * @deprecated this does not support useRef and is being moved into a new package.
 * Use @atlassian/jira-feature-flagging-utils and componentWithCondition instead.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$63c0d8b469289537$export$2e2bcd8739ae039 = (conditionGetter, ComponentTrue, ComponentFalse)=>{
    const ComponentWithCondition = (props)=>// @ts-expect-error - TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'. | TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'.
        conditionGetter() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentTrue, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentFalse, props);
    if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
    // @ts-expect-error - TS2322 - Type '{ (props: P): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<P, any>'.
    return ComponentWithCondition;
};

});

parcelRegister("drG7D", function(module, exports) {

$parcel$export(module.exports, "securityPageResource", () => $53fc164e796e61ca$export$2c5e3c161b8fe98);

var $exb0h = parcelRequire("exb0h");

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $FkKOk = parcelRequire("FkKOk");

var $fb9lE = parcelRequire("fb9lE");

const $53fc164e796e61ca$var$getNumberOfVulnerabilitiesToFetch = ()=>40;
const $53fc164e796e61ca$var$getNumberOfSecurityContainersToFetch = ()=>100;
let $53fc164e796e61ca$var$filters;
const $53fc164e796e61ca$export$2c5e3c161b8fe98 = (0, $buJlM.createRelayResource)({
    type: (0, $17300ee0074ba903$export$f24db22c3c834cb1),
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId, activationId: activationId } }) {
        const isSecRoute = name === (0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY) || name === (0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC);
        // Set filters on initial call only and not on every query param change
        if (!$53fc164e796e61ca$var$filters && isSecRoute) {
            const connectionAri = (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                resourceType: 'security-container',
                cloudId: cloudId,
                activationId: activationId,
                resourceId: ''
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            $53fc164e796e61ca$var$filters = (0, $fb9lE.getGqlFiltersFromQueryParams)(query, connectionAri);
        }
        // Reset filters when navigating away from the security page
        if (!isSecRoute) $53fc164e796e61ca$var$filters = undefined;
        return {
            parameters: (0, $FkKOk.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudAri: (0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: cloudId
                }),
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                numberOfVulnsToFetch: $53fc164e796e61ca$var$getNumberOfVulnerabilitiesToFetch(),
                getContainers: false,
                numberOfContainersToFetch: $53fc164e796e61ca$var$getNumberOfSecurityContainersToFetch(),
                filter: $53fc164e796e61ca$var$filters
            }
        };
    }
});

});
parcelRegister("FkKOk", function(module, exports) {

$parcel$export(module.exports, "default", () => $897a53634fdc58c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3b35e503bbc323d2d3ecfbb74bbd289d>>
 * @relayHash 2827aa231cab3e49f67ea40510e452a3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a1a80f3ccfe8934408165144c558b877d997fe187322dd28b0da2044aa214fed
const $897a53634fdc58c5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "getContainers"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfContainersToFetch"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfVulnsToFetch"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v8 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "totalLinkedSecurityContainerCount"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "numberOfContainersToFetch"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": v12 /*: any*/ ,
        "type": "ThirdPartySecurityContainer"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "numberOfVulnsToFetch"
    }, v16 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "and": {
                    "lastUpdated": {
                        "sort": {
                            "order": "ASC",
                            "priority": 1
                        }
                    }
                }
            }
        },
        v15 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "cloudAri"
                    },
                    {
                        "kind": "Literal",
                        "name": "providerTypes",
                        "value": [
                            "SECURITY"
                        ]
                    }
                ],
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "DevOpsSecurityProvider",
                        "kind": "LinkedField",
                        "name": "securityProviders",
                        "plural": true,
                        "selections": [
                            v17 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "appInstallationId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                            },
                            v18 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 100
                                    }
                                ],
                                "concreteType": "AriGraphRelationshipConnection",
                                "kind": "LinkedField",
                                "name": "linkedWorkspaces",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "AriGraphRelationship",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v19 /*: any*/ 
                                        ]
                                    }
                                ],
                                "storageKey": "linkedWorkspaces(first:100)"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v21 = [
        v17 /*: any*/ 
    ], v22 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "ConfluencePage"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "ConfluenceSpace"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsFeatureFlag"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsComponentDetails"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsIncidentDetails"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsPostIncidentReviewDetails"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsPullRequestDetails"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsRepository"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsSecurityVulnerabilityDetails"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraConfluenceRemoteIssueLink"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraCustomRemoteIssueLink"
    }, v34 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraIssueRemoteIssueLink"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraWebRemoteIssueLink"
    }, v36 = [
        v8 /*: any*/ ,
        v15 /*: any*/ 
    ], v37 = {
        "kind": "ScalarField",
        "name": "url"
    }, v38 = {
        "kind": "ScalarField",
        "name": "key"
    }, v39 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v40 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainSecurityInJiraQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            v8 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "getContainers",
                                                "variableName": "getContainers"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "numberOfContainersToFetch",
                                                "variableName": "numberOfContainersToFetch"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "main_softwareSecurityPage_MainPage"
                                    },
                                    v9 /*: any*/ ,
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "getContainers",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "data",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraProjectByKey.linkedSecurityContainers"
                                    },
                                    {
                                        "alias": "linkedVulnsForAnalytics",
                                        "args": v16 /*: any*/ ,
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "condition": "getContainers",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                        "kind": "LinkedField",
                                                                        "name": "vulnerability",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ThirdPartySecurityContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "securityContainer",
                                                                                "plural": false,
                                                                                "selections": v12 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.jiraProjectByKey"
                        }
                    ]
                },
                v20 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainSecurityInJiraQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v17 /*: any*/ ,
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityContainers",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        v8 /*: any*/ 
                                    ],
                                    "kind": "ScalarField",
                                    "name": "totalLinkedSecurityVulnerabilityCount"
                                },
                                {
                                    "args": v36 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                            "kind": "LinkedField",
                                                            "name": "vulnerability",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v17 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityIdentifier",
                                                                    "kind": "LinkedField",
                                                                    "name": "identifiers",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayName"
                                                                        },
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityAdditionalInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "additionalInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "content"
                                                                        },
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "status"
                                                                },
                                                                {
                                                                    "concreteType": "AriGraphRelationshipConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "linkedJiraIssues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AriGraphRelationship",
                                                                            "kind": "LinkedField",
                                                                            "name": "nodes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "to",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "data",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "idsOrAliases",
                                                                                                                    "value": [
                                                                                                                        "summary",
                                                                                                                        "assignee",
                                                                                                                        "status",
                                                                                                                        "issuetype"
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsByIdOrAlias",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "status",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusCategory",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v38 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusField"
                                                                                                                },
                                                                                                                v17 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "fieldId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "text"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "picture"
                                                                                                                                },
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "small"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "issueId"
                                                                                                        },
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "webUrl"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssue"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                v25 /*: any*/ ,
                                                                                                v26 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v29 /*: any*/ ,
                                                                                                v30 /*: any*/ ,
                                                                                                v31 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v34 /*: any*/ ,
                                                                                                v35 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                },
                                                                v17 /*: any*/ ,
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "introducedDate"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerVulnerabilityId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "securityContainerId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "severity"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "description"
                                                                }
                                                            ]
                                                        },
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                v39 /*: any*/ 
                                            ]
                                        },
                                        v40 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v36 /*: any*/ ,
                                    "filters": [
                                        "filter"
                                    ],
                                    "handle": "connection",
                                    "key": "security__linkedSecurityVulnerabilitiesByProject",
                                    "kind": "LinkedHandle",
                                    "name": "linkedSecurityVulnerabilitiesByProject"
                                },
                                {
                                    "alias": "projectHaveVulnerabilityCheck",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        }
                                    ],
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                            "kind": "LinkedField",
                                                            "name": "vulnerability",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "linkedSecurityVulnerabilitiesByProject(first:1)"
                                },
                                {
                                    "alias": "linkedVulnsForAnalytics",
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "condition": "getContainers",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "vulnerability",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "getContainers",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "icon"
                                                                                        },
                                                                                        v37 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "providerName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "lastUpdated"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v17 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ThirdPartySecurityContainer"
                                                                                },
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        v39 /*: any*/ 
                                                    ]
                                                },
                                                v40 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "security__linkedSecurityContainers",
                                            "kind": "LinkedHandle",
                                            "name": "linkedSecurityContainers"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v20 /*: any*/ 
            ]
        },
        "params": {
            "id": "a1a80f3ccfe8934408165144c558b877d997fe187322dd28b0da2044aa214fed",
            "metadata": {},
            "name": "mainSecurityInJiraQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$897a53634fdc58c5$var$node.hash = "e0029e5d1d9e6e62c9b62d69cc3a9f72";
var $897a53634fdc58c5$export$2e2bcd8739ae039 = $897a53634fdc58c5$var$node;

});

parcelRegister("fb9lE", function(module, exports) {

$parcel$export(module.exports, "getGqlFiltersFromQueryParams", () => $3db5dd4b8613bcf1$export$2af359d48d48e5f1);

var $InKsA = parcelRequire("InKsA");

var $aXpp4 = parcelRequire("aXpp4");

var $erRnF = parcelRequire("erRnF");
const $3db5dd4b8613bcf1$var$getFilterValue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
values, fieldStortKey, sortKey = (0, $aXpp4.initialVulnerabilityTableOptions).sortKey, sortOrder = (0, $aXpp4.initialVulnerabilityTableOptions).sortOrder)=>({
        ...values.length > 0 ? {
            values: values
        } : {},
        ...sortKey === fieldStortKey && {
            sort: {
                priority: 2,
                order: (0, $erRnF.parseSortDirection)(sortOrder, (0, $InKsA.AriGraphSortOrderInput).DESC)
            }
        }
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3db5dd4b8613bcf1$var$getOrDefault = (input, defaultArray)=>input.length ? input : defaultArray;
const $3db5dd4b8613bcf1$export$2af359d48d48e5f1 = (queryParams, connectionAri)=>{
    const containerValues = $3db5dd4b8613bcf1$var$getOrDefault((0, $erRnF.connectionQueryParamToFilter)(queryParams[0, $aXpp4.QUERY_PARAM_CONTAINER], connectionAri).filter(Boolean), (0, $aXpp4.initialVulnerabilityTableOptions).connectionFilter);
    const statusQueryParams = (0, $erRnF.arrayQueryParamToFilter)(queryParams[0, $aXpp4.QUERY_PARAM_VULN_STATUS]);
    return {
        and: [
            {
                lastUpdated: {
                    sort: {
                        priority: 1,
                        order: (0, $InKsA.AriGraphSortOrderInput).DESC
                    }
                },
                to_severity: $3db5dd4b8613bcf1$var$getFilterValue($3db5dd4b8613bcf1$var$getOrDefault((0, $erRnF.arrayQueryParamToFilter)(queryParams[0, $aXpp4.QUERY_PARAM_SEVERITY]).map((0, $erRnF.parseSeverity)).filter(Boolean), (0, $aXpp4.initialVulnerabilityTableOptions).severityFilter), 'severity', queryParams[0, $aXpp4.QUERY_PARAM_SORT_KEY], queryParams[0, $aXpp4.QUERY_PARAM_SORT_ORDER]),
                to_status: $3db5dd4b8613bcf1$var$getFilterValue(statusQueryParams.includes((0, $aXpp4.NO_FILTER_VULN_STATUS)) ? [] : $3db5dd4b8613bcf1$var$getOrDefault(statusQueryParams.map((0, $erRnF.parseStatus)).filter(Boolean), (0, $aXpp4.initialVulnerabilityTableOptions).statusFilter), 'status', queryParams[0, $aXpp4.QUERY_PARAM_SORT_KEY], queryParams[0, $aXpp4.QUERY_PARAM_SORT_ORDER]),
                createdAt: {
                    ...queryParams[0, $aXpp4.QUERY_PARAM_SORT_KEY] === 'introduced' && {
                        sort: {
                            priority: 2,
                            order: (0, $erRnF.parseSortDirection)(queryParams[0, $aXpp4.QUERY_PARAM_SORT_ORDER], (0, $InKsA.AriGraphSortOrderInput).DESC)
                        }
                    }
                },
                to_container: {
                    containerAri: {
                        value: {
                            ...containerValues.length > 0 ? {
                                values: containerValues
                            } : {}
                        }
                    }
                }
            }
        ]
    };
};

});
parcelRegister("InKsA", function(module, exports) {

$parcel$export(module.exports, "AriGraphSortOrderInput", () => $a96cc5854e779a88$export$3b69903df4cd6048);
const $a96cc5854e779a88$export$3b69903df4cd6048 = {
    ASC: 'ASC',
    DESC: 'DESC'
};

});

parcelRegister("aXpp4", function(module, exports) {

$parcel$export(module.exports, "QUERY_PARAM_SEARCH", () => $974dd4d6bcf6c002$export$a181206198b7f50c);
$parcel$export(module.exports, "QUERY_PARAM_CONTAINER", () => $974dd4d6bcf6c002$export$3873b20ffa21b004);
$parcel$export(module.exports, "QUERY_PARAM_SEVERITY", () => $974dd4d6bcf6c002$export$af01a3d59250f3d3);
$parcel$export(module.exports, "QUERY_PARAM_VULN_STATUS", () => $974dd4d6bcf6c002$export$c315695f017955dc);
$parcel$export(module.exports, "QUERY_PARAM_ISSUE_STATUS", () => $974dd4d6bcf6c002$export$2e69a24fe65d4109);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $974dd4d6bcf6c002$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $974dd4d6bcf6c002$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "NO_FILTER_VULN_STATUS", () => $974dd4d6bcf6c002$export$d8115099d465de4c);
$parcel$export(module.exports, "initialVulnerabilityTableOptions", () => $974dd4d6bcf6c002$export$e9b4ea84d666c490);
const $974dd4d6bcf6c002$export$a181206198b7f50c = 'search';
const $974dd4d6bcf6c002$export$3873b20ffa21b004 = 'container';
const $974dd4d6bcf6c002$export$af01a3d59250f3d3 = 'severity';
const $974dd4d6bcf6c002$export$c315695f017955dc = 'vulnerabilityStatus';
const $974dd4d6bcf6c002$export$2e69a24fe65d4109 = 'issueStatus';
const $974dd4d6bcf6c002$export$6da773286c35ef41 = 'sortKey';
const $974dd4d6bcf6c002$export$810a1f7ed2facfcb = 'sortOrder';
const $974dd4d6bcf6c002$export$d8115099d465de4c = 'NO-FILTERS';
const $974dd4d6bcf6c002$export$afbc65bcea0cf17e = {
    searchFilter: '',
    connectionFilter: [],
    severityFilter: [],
    statusFilter: [
        'OPEN'
    ],
    jiraIssueStatusFilter: []
};
const $974dd4d6bcf6c002$export$e9b4ea84d666c490 = {
    sortKey: 'severity',
    sortOrder: 'DESC',
    ...$974dd4d6bcf6c002$export$afbc65bcea0cf17e
};

});

parcelRegister("erRnF", function(module, exports) {

$parcel$export(module.exports, "arrayQueryParamToFilter", () => $896d2028fc8f9365$export$7500862c6689a767);
$parcel$export(module.exports, "arrayFilterToQueryParam", () => $896d2028fc8f9365$export$b0dee3c5bfc7249e);
$parcel$export(module.exports, "connectionFilterToQueryParam", () => $896d2028fc8f9365$export$a6950ca4fdc8498f);
$parcel$export(module.exports, "connectionQueryParamToFilter", () => $896d2028fc8f9365$export$1040034504af5b41);
$parcel$export(module.exports, "parseSeverity", () => $896d2028fc8f9365$export$3551b8a2cbdb5162);
$parcel$export(module.exports, "parseStatus", () => $896d2028fc8f9365$export$2188844eb84f7f06);
$parcel$export(module.exports, "parseSortDirection", () => $896d2028fc8f9365$export$85cf5c73b48a482e);

var $9OdO2 = parcelRequire("9OdO2");

var $eo8NR = parcelRequire("eo8NR");

var $InKsA = parcelRequire("InKsA");

var $94l3m = parcelRequire("94l3m");
const $896d2028fc8f9365$var$DELIMITER = ',';
const $896d2028fc8f9365$var$ENCODED_DELIMITER = encodeURIComponent($896d2028fc8f9365$var$DELIMITER);
// We encode the delimiter to protect the values from containing
// the same character that delimits the list.
// e.g.
// env names = ["prod,east", "prod,west"] -> "prod,east,prod,west"
const $896d2028fc8f9365$var$encodeDelimiter = (input)=>{
    const regex = new RegExp($896d2028fc8f9365$var$DELIMITER, 'g');
    return input.replace(regex, $896d2028fc8f9365$var$ENCODED_DELIMITER);
};
const $896d2028fc8f9365$var$decodeDelimiter = (input)=>{
    const regex = new RegExp($896d2028fc8f9365$var$ENCODED_DELIMITER, 'g');
    return input.replace(regex, $896d2028fc8f9365$var$DELIMITER);
};
const $896d2028fc8f9365$export$7500862c6689a767 = (queryParamString)=>queryParamString?.split($896d2028fc8f9365$var$DELIMITER)?.map($896d2028fc8f9365$var$decodeDelimiter) ?? [];
const $896d2028fc8f9365$export$b0dee3c5bfc7249e = (filterArray)=>{
    if (filterArray.length === 0) return undefined;
    return filterArray.map((entity)=>$896d2028fc8f9365$var$encodeDelimiter(entity)).join($896d2028fc8f9365$var$DELIMITER);
};
const $896d2028fc8f9365$export$a6950ca4fdc8498f = (connectionArray)=>{
    if (connectionArray.length === 0) return undefined;
    const groupedConnectionsByAppKey = connectionArray.reduce((acc, connection)=>{
        const [, , , , securityParts] = connection.split(':');
        const [, , , appKey, ...containerId] = securityParts.split('/');
        if (!acc[appKey]) acc[appKey] = [];
        acc[appKey].push(containerId.join('/'));
        return acc;
    }, {});
    return JSON.stringify(groupedConnectionsByAppKey);
};
const $896d2028fc8f9365$export$1040034504af5b41 = (queryParamString, connectionAri)=>{
    if (!queryParamString) return [];
    const groupedConnectionsByAppKey = JSON.parse(queryParamString);
    return (0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))(groupedConnectionsByAppKey, (containerIds, appKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($eo8NR)))(containerIds, (containerId)=>`${connectionAri}${appKey}/${containerId}`));
};
const $896d2028fc8f9365$export$3551b8a2cbdb5162 = (maybeSeverity)=>{
    switch(maybeSeverity?.toUpperCase()){
        case (0, $94l3m.VulnerabilitySeverityEnums).CRITICAL.toUpperCase():
            return (0, $94l3m.VulnerabilitySeverityEnums).CRITICAL;
        case (0, $94l3m.VulnerabilitySeverityEnums).HIGH.toUpperCase():
            return (0, $94l3m.VulnerabilitySeverityEnums).HIGH;
        case (0, $94l3m.VulnerabilitySeverityEnums).LOW.toUpperCase():
            return (0, $94l3m.VulnerabilitySeverityEnums).LOW;
        case (0, $94l3m.VulnerabilitySeverityEnums).MEDIUM.toUpperCase():
            return (0, $94l3m.VulnerabilitySeverityEnums).MEDIUM;
        case (0, $94l3m.VulnerabilitySeverityEnums).UNKNOWN.toUpperCase():
            return (0, $94l3m.VulnerabilitySeverityEnums).UNKNOWN;
        default:
            return undefined;
    }
};
const $896d2028fc8f9365$export$2188844eb84f7f06 = (maybeStatus)=>{
    switch(maybeStatus?.toUpperCase()){
        case (0, $94l3m.VulnerabilityStatusEnums).OPEN.toUpperCase():
            return (0, $94l3m.VulnerabilityStatusEnums).OPEN;
        case (0, $94l3m.VulnerabilityStatusEnums).UNKNOWN.toUpperCase():
            return (0, $94l3m.VulnerabilityStatusEnums).UNKNOWN;
        case (0, $94l3m.VulnerabilityStatusEnums).CLOSED.toUpperCase():
            return (0, $94l3m.VulnerabilityStatusEnums).CLOSED;
        case (0, $94l3m.VulnerabilityStatusEnums).IGNORED.toUpperCase():
            return (0, $94l3m.VulnerabilityStatusEnums).IGNORED;
        default:
            return undefined;
    }
};
const $896d2028fc8f9365$export$85cf5c73b48a482e = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case (0, $InKsA.AriGraphSortOrderInput).ASC.toUpperCase():
            return (0, $InKsA.AriGraphSortOrderInput).ASC;
        case (0, $InKsA.AriGraphSortOrderInput).DESC.toUpperCase():
            return (0, $InKsA.AriGraphSortOrderInput).DESC;
        default:
            return defaultValue;
    }
};

});
parcelRegister("9OdO2", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $eo8NR = parcelRequire("eo8NR");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $72437e2c2a373df9$var$flatMap(collection, iteratee) {
    return $hKE3p($eo8NR(collection, iteratee), 1);
}
module.exports = $72437e2c2a373df9$var$flatMap;

});
parcelRegister("eo8NR", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $7qARj = parcelRequire("7qARj");

var $iA1h1 = parcelRequire("iA1h1");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $a79a22b5b4895d6c$var$map(collection, iteratee) {
    var func = $1c8hB(collection) ? $kJvGp : $iA1h1;
    return func(collection, $7qARj(iteratee, 3));
}
module.exports = $a79a22b5b4895d6c$var$map;

});


parcelRegister("94l3m", function(module, exports) {

$parcel$export(module.exports, "VulnerabilitySeverityEnums", () => $2702828faf38eb9a$export$c1a102938d8dc10);
$parcel$export(module.exports, "VulnerabilityStatusEnums", () => $2702828faf38eb9a$export$2d6749bded378262);
const $2702828faf38eb9a$export$c1a102938d8dc10 = {
    CRITICAL: 'CRITICAL',
    HIGH: 'HIGH',
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    UNKNOWN: 'UNKNOWN'
};
const $2702828faf38eb9a$export$2d6749bded378262 = {
    CLOSED: 'CLOSED',
    IGNORED: 'IGNORED',
    OPEN: 'OPEN',
    UNKNOWN: 'UNKNOWN'
};
const $2702828faf38eb9a$export$abf926511a2b65de = {
    DAST: 'DAST',
    SAST: 'SAST',
    SCA: 'SCA',
    UNKNOWN: 'UNKNOWN'
};

});



const $17300ee0074ba903$export$f24db22c3c834cb1 = 'SOFTWARE_SECURITY';


parcelRegister("kaFCx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("eYSBU")
]).then(()=>parcelRequire('9D3yn'));

});

parcelRegister("eaP1H", function(module, exports) {

$parcel$export(module.exports, "userBoardRoute", () => $f203bcc70ddc17af$export$57a2a0fe739f16);

var $exb0h = parcelRequire("exb0h");

var $bmKiO = parcelRequire("bmKiO");
const $f203bcc70ddc17af$export$57a2a0fe739f16 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BOARD),
    path: '/jira/people/:accountId/boards/:boardId',
    preloadOptions: {
        earlyChunks: [
            'rapidboard-early-entry'
        ]
    },
    earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
};

});

parcelRegister("841Zr", function(module, exports) {

$parcel$export(module.exports, "RoadmapSkeleton", () => $258037d50c2153f1$export$66a1e8bb48359566);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $6FP8W = parcelRequire("6FP8W");

var $8ICxF = parcelRequire("8ICxF");

var $j5MyT = parcelRequire("j5MyT");

var $9rtRd = parcelRequire("9rtRd");
const $258037d50c2153f1$var$customCssStyles = null;
const $258037d50c2153f1$export$66a1e8bb48359566 = ()=>(0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($j5MyT))),
        className: (0, $7JEyt.default)([
            "_2zz1idpf"
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9rtRd))),
        className: (0, $7JEyt.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("j5MyT", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton-nav-refresh.tpl.ce6eb42e.svg", import.meta.url).toString();

});

parcelRegister("9rtRd", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton.tpl.a54a882d.svg", import.meta.url).toString();

});


parcelRegister("GuBa2", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJSWReportsResource", () => $3644fec504a7091d$export$5910307042ab3f6f);

var $ElVpH = parcelRequire("ElVpH");

var $lB25E = parcelRequire("lB25E");

var $b1r4M = parcelRequire("b1r4M");
const $3644fec504a7091d$export$5910307042ab3f6f = (0, $lB25E.createResource)({
    type: 'JIRA_SOFTWARE_REPORTS',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        if (boardId == null) return null;
        const response = await (0, $b1r4M.fetchJSWReports)(boardId);
        return response?.reports;
    },
    maxAge: 300000
});

});
parcelRegister("b1r4M", function(module, exports) {

$parcel$export(module.exports, "fetchJSWReports", () => $35f5e30d07c84550$export$a93a577d6971da2c);

var $lRmyA = parcelRequire("lRmyA");
const $35f5e30d07c84550$export$a93a577d6971da2c = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $lRmyA.performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
};

});


parcelRegister("5fOZm", function(module, exports) {

$parcel$export(module.exports, "devOpsReportPreconditionResource", () => $be1b037470026e68$export$96cb0eae1b3413f4);
$parcel$export(module.exports, "useDevOpsReportPreconditionResource", () => $be1b037470026e68$export$e9adc6103e9ed514);

var $lB25E = parcelRequire("lB25E");


const $be1b037470026e68$export$96cb0eae1b3413f4 = (0, $lB25E.createResource)({
    type: (0, $c1b3a83229b530dd$export$14c5ce449424c281),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("h06en")),
    maxAge: 60000
});
const $be1b037470026e68$export$e9adc6103e9ed514 = ()=>(0, $lB25E.useResource)($be1b037470026e68$export$96cb0eae1b3413f4);

});
const $c1b3a83229b530dd$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $c1b3a83229b530dd$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $c1b3a83229b530dd$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';

parcelRegister("h06en", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fvJyP").then(()=>parcelRequire('kQVpx'));

});


parcelRegister("c9qT1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kfzOE").then(()=>parcelRequire('hlq5E'));

});

parcelRegister("jizTM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("jpSQC")
]).then(()=>parcelRequire('aYTYW'));

});

parcelRegister("bRIfe", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("73KJ4")
]).then(()=>parcelRequire('bCKh9'));

});

parcelRegister("2Om9s", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("1exKx")
]).then(()=>parcelRequire('f36yg'));

});

parcelRegister("1Bxc8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("3dblI")
]).then(()=>parcelRequire('2JCOg'));

});

parcelRegister("h9URe", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("j4QrN")
]).then(()=>parcelRequire('hN2hf'));

});

parcelRegister("6qRbE", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("LFund")
]).then(()=>parcelRequire('3sQZZ'));

});

parcelRegister("8D7jN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bXxlB")
]).then(()=>parcelRequire('6lJS5'));

});

parcelRegister("4hDuf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("gAtlm")
]).then(()=>parcelRequire('1HgoJ'));

});

parcelRegister("itkhw", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("koXa2")
]).then(()=>parcelRequire('772Yc'));

});

parcelRegister("dr1qL", function(module, exports) {

$parcel$export(module.exports, "compassProductSettingsResource", () => $3c15fc909617c154$export$d18ff068d6c25455);
$parcel$export(module.exports, "useCompassProductSettingsResource", () => $3c15fc909617c154$export$6cbcbd11d26ae36f);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $lB25E = parcelRequire("lB25E");

const $3c15fc909617c154$export$d18ff068d6c25455 = (0, $lB25E.createResource)({
    type: (0, $aefa2beed38f2caa$export$6f0555de4f60e84e),
    getKey: ()=>'state',
    getData: async ()=>{
        try {
            const isCompassEnabledForNewProjects = await (0, $lRmyA.performGetRequest)(`/rest/api/3/application-properties?key=${(0, $aefa2beed38f2caa$export$5685d70c20140008)}`).then(({ value: value })=>value.toLowerCase().trim() === 'true');
            return {
                isCompassEnabledForNewProjects: isCompassEnabledForNewProjects
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error?.statusCode === 404) return {
                isCompassEnabledForNewProjects: true
            };
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'compassProductSettingsResource',
                    packageName: 'jiraRouterResourcesCompassProductSettings',
                    teamName: 'compass-lodestone'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
});
const $3c15fc909617c154$export$6cbcbd11d26ae36f = ()=>(0, $lB25E.useResource)($3c15fc909617c154$export$d18ff068d6c25455);

});
const $aefa2beed38f2caa$export$6f0555de4f60e84e = 'RESOURCE_TYPE_COMPASS_PRODUCT_SETTINGS';
const $aefa2beed38f2caa$export$5685d70c20140008 = 'jira.admin.compass.is-enabled-for-new-project';


parcelRegister("aSuAs", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("2lK0b")
]).then(()=>parcelRequire('hiLt4'));

});

parcelRegister("fsuEu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("lQZOk")
]).then(()=>parcelRequire('l3y9L'));

});

parcelRegister("bzNVg", function(module, exports) {

$parcel$export(module.exports, "connectProjectResources", () => $6b6ae9e1cac63317$export$7d2d082a4b91a6c7);
// eslint-disable-next-line jira/import-whitelist

var $2fEPO = parcelRequire("2fEPO");

var $kXWpU = parcelRequire("kXWpU");

var $lB25E = parcelRequire("lB25E");


const $6b6ae9e1cac63317$export$7d2d082a4b91a6c7 = (0, $lB25E.createResource)({
    type: (0, $0ac1940034966a81$export$da32d27651782c3),
    getKey: ({ query: query })=>{
        const { addonKey: addonKey, moduleKey: moduleKey } = (0, $2fEPO.transformUrlToAddonAndModuleKeys)(query);
        if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    depends: [
        (0, $kXWpU.staticProjectSidebarNavigationResource).type
    ],
    getDataLoader: ()=>(parcelRequire("kRMxB"))
});

});
parcelRegister("2fEPO", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $4720f3e3fd1eb764$export$3361e9be8093ddcc);
$parcel$export(module.exports, "extractContext", () => $4720f3e3fd1eb764$export$efdbd45f3e77a161);
$parcel$export(module.exports, "transformQueryParams", () => $4720f3e3fd1eb764$export$9e3c3f47fc3ab3d0);
$parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", () => $4720f3e3fd1eb764$export$752ef5ab3d7ab15f);

var $gUUjF = parcelRequire("gUUjF");

var $9T0Tw = parcelRequire("9T0Tw");

var $eWsAG = parcelRequire("eWsAG");
const $4720f3e3fd1eb764$export$3361e9be8093ddcc = (response)=>{
    try {
        const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
        const structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
        const context = {
            productContext: productContext,
            structuredContext: structuredContext,
            productCtx: productContext
        };
        return {
            ...response,
            ...context,
            isFullPage: response.general === '1',
            user: {
                timeZone: response.timeZone,
                uid: response.uid || undefined,
                ukey: response.ukey || undefined,
                fullName: response.fullName || undefined
            },
            targets: {
                env: {
                    resize: 'both'
                }
            },
            history: {
                state: ''
            },
            autoresize: true,
            ns: response.uniqueKey,
            containerId: `embedded-${response.uniqueKey}`,
            contextPath: response.cp,
            width: response.w || response.width,
            height: response.h || response.height
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const location = 'connect-iframe.transformer';
        (0, $gUUjF.default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
        return {
            autoresize: true,
            productCtx: undefined,
            structuredContext: undefined,
            isFullPage: true,
            history: {
                state: ''
            },
            targets: {
                env: {
                    resize: 'both'
                }
            }
        };
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4720f3e3fd1eb764$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
    const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
    return newValue !== null ? {
        [newName]: newValue
    } : null;
};
const $4720f3e3fd1eb764$export$1f8eea5a5a32169f = (contextData)=>{
    const scope = contextData && contextData.scope || null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const project = contextData && contextData.project || null;
    const projectId = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
    const boardId = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $4720f3e3fd1eb764$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
    const project = projectSidebarNavInfo && (0, $eWsAG.extractData)(projectSidebarNavInfo) || null;
    const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, $9T0Tw.extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
    const projectId = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(board, 'type', 'board.type');
    const boardId = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(board, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $4720f3e3fd1eb764$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
    const context = $4720f3e3fd1eb764$export$1f8eea5a5a32169f(contextData);
    return {
        ...query,
        ...context
    };
};
const $4720f3e3fd1eb764$export$752ef5ab3d7ab15f = (query)=>{
    const { selectedItem: selectedItem } = query;
    let addonKey = '';
    let moduleKey = '';
    if (selectedItem) {
        const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
        [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
    }
    return {
        addonKey: addonKey,
        moduleKey: moduleKey
    };
};

});
parcelRegister("9T0Tw", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $1203c12364555614$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractUserBoard", () => $1203c12364555614$export$67db9e2d1b6ed865);
const $1203c12364555614$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
    if (jiraSoftwareNavData.boardInfo == null) return null;
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: true
    };
};
const $1203c12364555614$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: false
    };
};

});


const $0ac1940034966a81$export$da32d27651782c3 = 'CONNECT_PROJECT';

parcelRegister("kRMxB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4OWud").then(()=>parcelRequire('eps5Q'));

});


parcelRegister("kbHFR", function(module, exports) {

$parcel$export(module.exports, "getServiceDeskNavigationResources", () => $d0dacb3ad4515336$export$bc0bd65e6da57c1f);
$parcel$export(module.exports, "getServiceDeskNavigationSingleResources", () => $d0dacb3ad4515336$export$41a9145ddbba28e5);
$parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", () => $d0dacb3ad4515336$export$2c543d6accc1eb9b);
$parcel$export(module.exports, "getServiceDeskSettingsResources", () => $d0dacb3ad4515336$export$7bb3c4a2f6b127fb);
$parcel$export(module.exports, "getServicedeskPageContextResources", () => $d0dacb3ad4515336$export$a8b852f03a310dc0);
$parcel$export(module.exports, "getQueuesResources", () => $d0dacb3ad4515336$export$70b97995f4d5ef9f);
$parcel$export(module.exports, "getIssueListSsrResource", () => $d0dacb3ad4515336$export$e1016cce62543991);
$parcel$export(module.exports, "getKnowledgeBaseResources", () => $d0dacb3ad4515336$export$ed87d3b71544c4ef);
$parcel$export(module.exports, "getInsightResources", () => $d0dacb3ad4515336$export$9e0cf1fab0581096);

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $l90Gp = parcelRequire("l90Gp");

var $7wRIc = parcelRequire("7wRIc");

var $2R6ft = parcelRequire("2R6ft");

var $kKeF6 = parcelRequire("kKeF6");

var $bbvOQ = parcelRequire("bbvOQ");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $kJ81T = parcelRequire("kJ81T");

var $ct0sQ = parcelRequire("ct0sQ");

var $6bQqb = parcelRequire("6bQqb");

var $eryLo = parcelRequire("eryLo");

var $hRe6W = parcelRequire("hRe6W");

var $gxqFh = parcelRequire("gxqFh");

var $k1AKH = parcelRequire("k1AKH");

var $jwzNs = parcelRequire("jwzNs");

var $cV47S = parcelRequire("cV47S");
const $d0dacb3ad4515336$export$bc0bd65e6da57c1f = ()=>[
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...$d0dacb3ad4515336$export$41a9145ddbba28e5()
    ];
const $d0dacb3ad4515336$export$41a9145ddbba28e5 = ()=>[
        ...$d0dacb3ad4515336$export$9c1c5e389bd00e56(),
        ...$d0dacb3ad4515336$export$2c543d6accc1eb9b()
    ];
const $d0dacb3ad4515336$export$9c1c5e389bd00e56 = ()=>[
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jsm.queues.sectional.healing'), (0, $hRe6W.priorityGroupResource)),
        (0, $k1AKH.featuresResource),
        (0, $2R6ft.staticSidebarJsmReportsResource)
    ];
const $d0dacb3ad4515336$export$2c543d6accc1eb9b = ()=>[
        (0, $hRe6W.queuesNavigationItems),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('ssr_nav4_queues_sidebar'), (0, $eryLo.requiredProjectProperties)),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('ssr_nav4_queues_sidebar'), (0, $eryLo.requiredFrontendProperties)),
        (0, $l90Gp.forgeServiceDeskQueueModuleResource),
        (0, $7wRIc.staticJSMProjectConnectAddonsNavigationResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $d0dacb3ad4515336$export$7bb3c4a2f6b127fb = ()=>[
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $6bQqb.servicedeskPracticesResource),
        (0, $ct0sQ.serviceDeskContextResource),
        (0, $kJ81T.serviceDeskAnalyticsContextResource),
        (0, $jwzNs.resourceWithCondition2)(()=>!(0, $dfBCt.isFedRamp)(), (0, $gxqFh.virtualAgentOnboardingResource))
    ];
const $d0dacb3ad4515336$export$a8b852f03a310dc0 = ()=>[
        (0, $ixwgj.projectContextResourceWithCache),
        (0, $ct0sQ.serviceDeskContextResource),
        (0, $kJ81T.serviceDeskAnalyticsContextResource)
    ];
const $d0dacb3ad4515336$export$70b97995f4d5ef9f = ()=>[
        ...$d0dacb3ad4515336$export$a8b852f03a310dc0(),
        ...$d0dacb3ad4515336$export$bc0bd65e6da57c1f(),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('automation-templates-team-types-refactor-m1_isj0e'), (0, $6bQqb.servicedeskPracticesResource))
    ];
const $d0dacb3ad4515336$export$e1016cce62543991 = ()=>[
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('ssr_view_queues_issuelist'), (0, $hRe6W.issueListSsrResource))
    ];
const $d0dacb3ad4515336$export$ed87d3b71544c4ef = ()=>[
        (0, $bbvOQ.kbConfluenceContextResource)
    ];
const $d0dacb3ad4515336$export$9e0cf1fab0581096 = ()=>[
        (0, $cV47S.workspaceResource)
    ];

});
parcelRegister("2R6ft", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJsmReportsResource", () => $2e9be7a412e29907$export$ec28065a31cce4ce);

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $e3vCY = parcelRequire("e3vCY");
const $2e9be7a412e29907$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $2e9be7a412e29907$export$ec28065a31cce4ce = (0, $lB25E.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
    getKey: ({ match: match, query: query })=>$2e9be7a412e29907$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $2e9be7a412e29907$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        return (0, $e3vCY.fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
    },
    maxAge: 300000
});

});
parcelRegister("e3vCY", function(module, exports) {

$parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", () => $069786dfe22ba4b1$export$c1dd51127051647d);

var $lRmyA = parcelRequire("lRmyA");
const $069786dfe22ba4b1$export$c1dd51127051647d = (projectIdOrKey)=>{
    if (projectIdOrKey == null) throw new Error('invalid project id or key');
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
};

});


parcelRegister("bbvOQ", function(module, exports) {

$parcel$export(module.exports, "kbConfluenceContextResource", () => $e70a415f97febed5$export$8b58be1423986d17);

var $lB25E = parcelRequire("lB25E");


const $e70a415f97febed5$var$getDataLoader = ()=>(parcelRequire("bvuQU"));
const $e70a415f97febed5$export$8b58be1423986d17 = (0, $lB25E.createResource)({
    type: (0, $fa79a46718d41206$export$54b5a0d1e8c78de6),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $e70a415f97febed5$var$getDataLoader,
    maxAge: Infinity
});

});
const $fa79a46718d41206$export$54b5a0d1e8c78de6 = 'KB_CONFLUENCE_CONTEXT';

parcelRegister("bvuQU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cNb0V").then(()=>parcelRequire('2H0aU'));

});


parcelRegister("ct0sQ", function(module, exports) {

$parcel$export(module.exports, "serviceDeskContextResource", () => $21cb155d8c71cb90$export$5eaaf465969a9171);

var $8hg3R = parcelRequire("8hg3R");

var $lB25E = parcelRequire("lB25E");


const $21cb155d8c71cb90$var$getDataLoader = ()=>(parcelRequire("g2zrL"));
const $21cb155d8c71cb90$export$5eaaf465969a9171 = (0, $lB25E.createResource)({
    type: (0, $826e69ec760c3796$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $8hg3R.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: $21cb155d8c71cb90$var$getDataLoader,
    maxAge: Infinity
});

});
const $826e69ec760c3796$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';

parcelRegister("g2zrL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jNeZh").then(()=>parcelRequire('kuXhx'));

});


parcelRegister("6bQqb", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticesResource", () => $b386ee585ab532da$export$2ae319305481e7de);
$parcel$export(module.exports, "useWorkCategoriesQueueSupported", () => $b386ee585ab532da$export$a86ac771006f14b3);
$parcel$export(module.exports, "useWorkCategoriesAllSupported", () => $b386ee585ab532da$export$fe081b1a59d3c818);
$parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", () => $b386ee585ab532da$export$4d46346ef0bdc6b9);

var $eUqFw = parcelRequire("eUqFw");

var $8hg3R = parcelRequire("8hg3R");

var $f1lMr = parcelRequire("f1lMr");

var $lB25E = parcelRequire("lB25E");


const $b386ee585ab532da$var$getDataLoader = ()=>(parcelRequire("8Ro9w"));
const $b386ee585ab532da$var$ONE_DAY_IN_MILLIS = 86400000;
const $b386ee585ab532da$export$2ae319305481e7de = (0, $lB25E.createResource)({
    type: (0, $73bf87f5cdbfcccc$export$45919c8f50bb1db5),
    getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
    getDataLoader: $b386ee585ab532da$var$getDataLoader,
    maxAge: $b386ee585ab532da$var$ONE_DAY_IN_MILLIS
});
const $b386ee585ab532da$var$queuesOrder = [
    ...(0, $f1lMr.WORK_CATEGORIES_QUEUE_SUPPORTED)
];
const $b386ee585ab532da$var$workCategoryOrder = [
    ...$b386ee585ab532da$var$queuesOrder,
    (0, $f1lMr.DEVELOPER_ESCALATION)
];
const $b386ee585ab532da$var$transformItsmPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $b386ee585ab532da$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $b386ee585ab532da$var$transformServiceDeskPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $b386ee585ab532da$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $b386ee585ab532da$export$a86ac771006f14b3 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $lB25E.useResource)($b386ee585ab532da$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $eUqFw.useMemo)(()=>({
            data: $b386ee585ab532da$var$transformItsmPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $b386ee585ab532da$export$fe081b1a59d3c818 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $lB25E.useResource)($b386ee585ab532da$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $eUqFw.useMemo)(()=>({
            data: $b386ee585ab532da$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $b386ee585ab532da$export$4d46346ef0bdc6b9 = ()=>{
    const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $lB25E.useResource)($b386ee585ab532da$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    (0, $eUqFw.useEffect)(()=>{
        if (!loading && !data && !error) refreshPractices();
    }, [
        data,
        error,
        loading,
        refreshPractices
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: $b386ee585ab532da$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};

});
parcelRegister("f1lMr", function(module, exports) {

$parcel$export(module.exports, "CHANGES", () => $d4363a603a2b1168$export$8598196f74460271);
$parcel$export(module.exports, "INCIDENTS", () => $d4363a603a2b1168$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "PROBLEMS", () => $d4363a603a2b1168$export$ceba70db1edb1def);
$parcel$export(module.exports, "SERVICE_REQUEST", () => $d4363a603a2b1168$export$3d1cda9bd50505e8);
$parcel$export(module.exports, "POST_INCIDENT_REVIEWS", () => $d4363a603a2b1168$export$6ebf7b6bf1c580f);
$parcel$export(module.exports, "DEVELOPER_ESCALATION", () => $d4363a603a2b1168$export$81e62964cc725098);
$parcel$export(module.exports, "NO_CATEGORY", () => $d4363a603a2b1168$export$485b1216c42d8d4);
$parcel$export(module.exports, "NO_PRACTICE", () => $d4363a603a2b1168$export$52bf3f16b7812704);
$parcel$export(module.exports, "SHORT_FORM_CHANGES", () => $d4363a603a2b1168$export$a50185c8e9fb007e);
$parcel$export(module.exports, "SHORT_FORM_INCIDENTS", () => $d4363a603a2b1168$export$a54a30a3c3cce634);
$parcel$export(module.exports, "SHORT_FORM_PROBLEMS", () => $d4363a603a2b1168$export$354f3a4c6ac0c903);
$parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", () => $d4363a603a2b1168$export$335d3ac0c367f03f);
$parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", () => $d4363a603a2b1168$export$7ffd7f2c2ae96b6f);
$parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", () => $d4363a603a2b1168$export$cb41b99ca54e6bd);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED", () => $d4363a603a2b1168$export$a2b1f8f055150f02);
$parcel$export(module.exports, "ItsmPracticeToShortForm", () => $d4363a603a2b1168$export$56c57f7ad650c45c);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP", () => $d4363a603a2b1168$export$fbf0dfd01228e38d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", () => $d4363a603a2b1168$export$45ba5f49e9509c4d);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS", () => $d4363a603a2b1168$export$45952424a7f29b99);
$parcel$export(module.exports, "CHANGES_JQL_NAME", () => $d4363a603a2b1168$export$6c24c440228eac9c);
$parcel$export(module.exports, "INCIDENTS_JQL_NAME", () => $d4363a603a2b1168$export$5b65d27ec2d28d18);
$parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", () => $d4363a603a2b1168$export$3f757c5e00588ffd);
$parcel$export(module.exports, "practiceKeyJqlNameMapping", () => $d4363a603a2b1168$export$b78213db77524b5b);

var $hVnhk = parcelRequire("hVnhk");

var $edAb7 = parcelRequire("edAb7");
const $d4363a603a2b1168$export$8598196f74460271 = 'change-management';
const $d4363a603a2b1168$export$a50b49a533b5f7bc = 'incident-management';
const $d4363a603a2b1168$export$ceba70db1edb1def = 'problem-management';
const $d4363a603a2b1168$export$3d1cda9bd50505e8 = 'service-request';
const $d4363a603a2b1168$export$6ebf7b6bf1c580f = 'post-incident-review';
const $d4363a603a2b1168$export$81e62964cc725098 = 'developer-escalation';
const $d4363a603a2b1168$export$485b1216c42d8d4 = 'no-category';
const $d4363a603a2b1168$export$f929a394dd190451 = 'no-category-new';
const $d4363a603a2b1168$export$52bf3f16b7812704 = 'no-practice'; // BERRY-1358 should consolidate into NO_CATEGORY
const $d4363a603a2b1168$export$a50185c8e9fb007e = 'changes';
const $d4363a603a2b1168$export$a54a30a3c3cce634 = 'incidents';
const $d4363a603a2b1168$export$354f3a4c6ac0c903 = 'problems';
const $d4363a603a2b1168$export$335d3ac0c367f03f = 'service-requests';
const $d4363a603a2b1168$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
const $d4363a603a2b1168$export$cb41b99ca54e6bd = 'developer-escalations';
const $d4363a603a2b1168$export$a613d808168c7b25 = [
    $d4363a603a2b1168$export$8598196f74460271,
    $d4363a603a2b1168$export$a50b49a533b5f7bc,
    $d4363a603a2b1168$export$ceba70db1edb1def,
    $d4363a603a2b1168$export$3d1cda9bd50505e8,
    $d4363a603a2b1168$export$6ebf7b6bf1c580f,
    $d4363a603a2b1168$export$81e62964cc725098
]; // /!\ defines WorkCategoryApiResource type
const $d4363a603a2b1168$export$a2b1f8f055150f02 = [
    $d4363a603a2b1168$export$3d1cda9bd50505e8,
    $d4363a603a2b1168$export$a50b49a533b5f7bc,
    $d4363a603a2b1168$export$ceba70db1edb1def,
    $d4363a603a2b1168$export$8598196f74460271,
    $d4363a603a2b1168$export$6ebf7b6bf1c580f
]; // /!\ defines WorkCategoryQueueSupported type
const $d4363a603a2b1168$export$5a9122a4028fb8ef = [
    ...$d4363a603a2b1168$export$a2b1f8f055150f02,
    $d4363a603a2b1168$export$485b1216c42d8d4
];
const $d4363a603a2b1168$export$f1b813cd23817ade = [
    $d4363a603a2b1168$export$a50185c8e9fb007e,
    $d4363a603a2b1168$export$a54a30a3c3cce634,
    $d4363a603a2b1168$export$354f3a4c6ac0c903,
    $d4363a603a2b1168$export$335d3ac0c367f03f,
    $d4363a603a2b1168$export$7ffd7f2c2ae96b6f,
    $d4363a603a2b1168$export$cb41b99ca54e6bd
]; // /!\ defines WorkCategoryShortForm type
const $d4363a603a2b1168$export$56c57f7ad650c45c = {
    [$d4363a603a2b1168$export$8598196f74460271]: $d4363a603a2b1168$export$a50185c8e9fb007e,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: $d4363a603a2b1168$export$a54a30a3c3cce634,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: $d4363a603a2b1168$export$354f3a4c6ac0c903,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: $d4363a603a2b1168$export$335d3ac0c367f03f,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: $d4363a603a2b1168$export$7ffd7f2c2ae96b6f,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: $d4363a603a2b1168$export$f929a394dd190451
};
const $d4363a603a2b1168$export$fbf0dfd01228e38d = {
    [$d4363a603a2b1168$export$8598196f74460271]: (0, $edAb7.default).changes,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: (0, $edAb7.default).serviceRequests,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: (0, $edAb7.default).problems,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: (0, $edAb7.default).incidents,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: (0, $edAb7.default).postIncidentReviews,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: (0, $edAb7.default).queues,
    [$d4363a603a2b1168$export$81e62964cc725098]: (0, $edAb7.default).developerEscalation,
    [$d4363a603a2b1168$export$52bf3f16b7812704]: (0, $edAb7.default).noCategory
};
const $d4363a603a2b1168$export$45ba5f49e9509c4d = {
    [$d4363a603a2b1168$export$8598196f74460271]: (0, $edAb7.default).changesLower,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: (0, $edAb7.default).serviceRequestsLower,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: (0, $edAb7.default).problemsLower,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: (0, $edAb7.default).incidentsLower,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: (0, $edAb7.default).postIncidentReviewsLower,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: (0, $edAb7.default).queuesLower,
    [$d4363a603a2b1168$export$81e62964cc725098]: (0, $edAb7.default).developerEscalationLower,
    [$d4363a603a2b1168$export$52bf3f16b7812704]: (0, $edAb7.default).noCategoryLower
};
const $d4363a603a2b1168$export$45952424a7f29b99 = (0, $hVnhk.getTypedKeys)($d4363a603a2b1168$export$fbf0dfd01228e38d).reduce((acc, labelMapKey)=>{
    // cannot type .indexOf() as not-string in Ts, therefore need to use .find(). And shows error if `key` in acc[key] being of wider type than the result (than ItsmPracticeCategory), therefore, need to use different keys in the `acc[queueKey] =` line
    const queueKey = $d4363a603a2b1168$export$a2b1f8f055150f02.find((key)=>key === labelMapKey);
    if (queueKey) acc[queueKey] = $d4363a603a2b1168$export$fbf0dfd01228e38d[labelMapKey];
    return acc;
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
}, {});
const $d4363a603a2b1168$export$6c24c440228eac9c = 'Changes';
const $d4363a603a2b1168$export$5b65d27ec2d28d18 = 'Incidents';
const $d4363a603a2b1168$export$51618dc8334072b = 'Problems';
const $d4363a603a2b1168$export$a34586940ac9c374 = 'Service requests';
const $d4363a603a2b1168$export$5497b62b513b7853 = 'Post-incident reviews';
const $d4363a603a2b1168$export$3f757c5e00588ffd = 'Developer escalation';
const $d4363a603a2b1168$export$b78213db77524b5b = {
    [$d4363a603a2b1168$export$8598196f74460271]: $d4363a603a2b1168$export$6c24c440228eac9c,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: $d4363a603a2b1168$export$5b65d27ec2d28d18,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: $d4363a603a2b1168$export$51618dc8334072b,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: $d4363a603a2b1168$export$a34586940ac9c374,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: $d4363a603a2b1168$export$5497b62b513b7853,
    [$d4363a603a2b1168$export$81e62964cc725098]: $d4363a603a2b1168$export$3f757c5e00588ffd
};

});
parcelRegister("hVnhk", function(module, exports) {

$parcel$export(module.exports, "hasProp", () => $6006801103a7e774$export$dd642ef726dcde21);
$parcel$export(module.exports, "getTypedKeys", () => $6006801103a7e774$export$5206d47972fefe20);
/**
 * Use to remove `TS2339: Property 'id' does not exist on type 'object'` errors, e.g. when checking/refining variable of `unknown' type
 */ const $6006801103a7e774$export$dd642ef726dcde21 = (data, prop)=>prop in data;
const $6006801103a7e774$export$5206d47972fefe20 = (obj)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(obj);
};

});

parcelRegister("edAb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $716d4f665940f429$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $716d4f665940f429$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    queues: {
        "id": "work-category.common.queues",
        "defaultMessage": "Queues"
    },
    serviceRequests: {
        "id": "work-category.common.service-requests",
        "defaultMessage": "Service requests"
    },
    incidents: {
        "id": "work-category.common.incidents",
        "defaultMessage": "Incidents"
    },
    changes: {
        "id": "work-category.common.changes",
        "defaultMessage": "Changes"
    },
    problems: {
        "id": "work-category.common.problems",
        "defaultMessage": "Problems"
    },
    postIncidentReviews: {
        "id": "work-category.common.post-incident-reviews",
        "defaultMessage": "Post-incident reviews"
    },
    noCategory: {
        "id": "work-category.common.no-category",
        "defaultMessage": "General"
    },
    queuesLower: {
        "id": "work-category.common.queues-lower",
        "defaultMessage": "queues"
    },
    serviceRequestsLower: {
        "id": "work-category.common.service-requests-lower",
        "defaultMessage": "service requests"
    },
    incidentsLower: {
        "id": "work-category.common.incidents-lower",
        "defaultMessage": "incidents"
    },
    changesLower: {
        "id": "work-category.common.changes-lower",
        "defaultMessage": "changes"
    },
    problemsLower: {
        "id": "work-category.common.problems-lower",
        "defaultMessage": "problems"
    },
    postIncidentReviewsLower: {
        "id": "work-category.common.post-incident-reviews-lower",
        "defaultMessage": "post-incident reviews"
    },
    noCategoryLower: {
        "id": "work-category.common.no-category-lower",
        "defaultMessage": "general"
    },
    developerEscalation: {
        "id": "work-category.common.developer-escalation",
        "defaultMessage": "Developer escalations"
    },
    developerEscalationLower: {
        "id": "work-category.common.developer-escalation-lower",
        "defaultMessage": "developer escalations"
    }
});

});


const $73bf87f5cdbfcccc$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';

parcelRegister("8Ro9w", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hVKSK").then(()=>parcelRequire('j7FZq'));

});


parcelRegister("eryLo", function(module, exports) {

$parcel$export(module.exports, "requiredProjectProperties", () => $c75493deb6c23e7e$export$fbeae45a65f4a5a6);
$parcel$export(module.exports, "requiredFrontendProperties", () => $c75493deb6c23e7e$export$47241956725e3029);

var $illlw = parcelRequire("illlw");

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $KBxlk = parcelRequire("KBxlk");

const $c75493deb6c23e7e$var$getRequiredProjectPropertiesDataLoader = ()=>(parcelRequire("ckpix"));
const $c75493deb6c23e7e$var$getKey = ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
    (0, $9zYls.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.issueKey', '').split('-')[0];
const $c75493deb6c23e7e$export$fbeae45a65f4a5a6 = (0, $lB25E.createResource)({
    type: (0, $KBxlk.RESOURCE_TYPE_SERVICEDESK_REQUIRED_PROJECT_PROPERTIES),
    getKey: $c75493deb6c23e7e$var$getKey,
    getDataLoader: $c75493deb6c23e7e$var$getRequiredProjectPropertiesDataLoader
});

const $c75493deb6c23e7e$var$getRequiredFrontendPropertiesDataLoader = ()=>(parcelRequire("loJkn"));
const $c75493deb6c23e7e$export$47241956725e3029 = (0, $lB25E.createResource)({
    type: (0, $KBxlk.RESOURCE_TYPE_SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES),
    getKey: $c75493deb6c23e7e$var$getKey,
    getDataLoader: $c75493deb6c23e7e$var$getRequiredFrontendPropertiesDataLoader,
    maxAge: (0, $KBxlk.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("KBxlk", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_REQUIRED_PROJECT_PROPERTIES", () => $2d2ef8b18765c6ae$export$54b53cba12671494);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES", () => $2d2ef8b18765c6ae$export$7d9318d6cfb0a4df);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $2d2ef8b18765c6ae$export$5a00268156ea5027);
const $2d2ef8b18765c6ae$export$54b53cba12671494 = 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES';
const $2d2ef8b18765c6ae$export$7d9318d6cfb0a4df = 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES';
const $2d2ef8b18765c6ae$export$5a00268156ea5027 = 86400000;

});

parcelRegister("ckpix", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6OKTx").then(()=>parcelRequire('8GFpN'));

});

parcelRegister("loJkn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aFepX").then(()=>parcelRequire('8Y0ba'));

});


parcelRegister("gxqFh", function(module, exports) {

$parcel$export(module.exports, "virtualAgentOnboardingResource", () => $32eefe0f93fd5c41$export$d39827c053fda3aa);

var $1ybV0 = parcelRequire("1ybV0");

var $buJlM = parcelRequire("buJlM");

var $kiMrZ = parcelRequire("kiMrZ");
const $32eefe0f93fd5c41$export$d39827c053fda3aa = (0, $buJlM.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $kiMrZ.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
            }
        })
});

});
parcelRegister("kiMrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $28d9f012bfa52f22$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dcf50e775b221024fd1c30e27bbb62f2>>
 * @relayHash 9459c0218f4aabda777b263e43d6af57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a0cbbb33f77ce77f01e2fbb6dc96c89baf132394dc74242534a2543aea933dda
const $28d9f012bfa52f22$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a0cbbb33f77ce77f01e2fbb6dc96c89baf132394dc74242534a2543aea933dda",
        "metadata": {},
        "name": "mainVirtualAgentSidebarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $28d9f012bfa52f22$export$2e2bcd8739ae039 = $28d9f012bfa52f22$var$node;

});


parcelRegister("k1AKH", function(module, exports) {

$parcel$export(module.exports, "featuresResource", () => $fc9160f01d8d9975$export$16f81cc9da2c6c47);

var $illlw = parcelRequire("illlw");

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");


const $fc9160f01d8d9975$var$getDataLoader = ()=>(parcelRequire("8UQqh"));
const $fc9160f01d8d9975$var$ONE_DAY_IN_MILLIS = 86400000;
const $fc9160f01d8d9975$export$16f81cc9da2c6c47 = (0, $lB25E.createResource)({
    type: (0, $ab0f134d1db7b683$export$3441b129810f29ed),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $9zYls.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $fc9160f01d8d9975$var$getDataLoader,
    maxAge: $fc9160f01d8d9975$var$ONE_DAY_IN_MILLIS
});

});
const $ab0f134d1db7b683$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';

parcelRegister("8UQqh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4Oonc").then(()=>parcelRequire('4Kk02'));

});


parcelRegister("cV47S", function(module, exports) {

$parcel$export(module.exports, "workspaceResource", () => $dac86f6ff29c4c91$export$2f02c3f971168d17);

var $lB25E = parcelRequire("lB25E");

var $aeCba = parcelRequire("aeCba");
const $dac86f6ff29c4c91$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $dac86f6ff29c4c91$export$2f02c3f971168d17 = (0, $lB25E.createResource)({
    type: $dac86f6ff29c4c91$export$9b3a4d71d46e5ee7,
    getKey: ()=>'state',
    getData: async (_, routerContext)=>{
        const workspaceId = await (0, $aeCba.default)(_, routerContext);
        return workspaceId;
    },
    maxAge: Infinity
});

});
parcelRegister("aeCba", function(module, exports) {

$parcel$export(module.exports, "isPremiumInstance", () => $5d91810a3f6a3a0a$export$abb609d3bcbb74f6);
$parcel$export(module.exports, "isLicensedPremiumUser", () => $5d91810a3f6a3a0a$export$d7b4c32773b1c643);
$parcel$export(module.exports, "default", () => $5d91810a3f6a3a0a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");

var $8PehF = parcelRequire("8PehF");

var $aSJew = parcelRequire("aSJew");

var $6WXNs = parcelRequire("6WXNs");
const $5d91810a3f6a3a0a$export$530f260cc76f04ff = (baseUrl)=>`${baseUrl}/rest/servicedesk/cmdb/latest/workspace`;
const $5d91810a3f6a3a0a$export$abb609d3bcbb74f6 = (tenantContext)=>{
    const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
    const isPremium = serviceDeskAppEdition === (0, $6WXNs.PREMIUM_EDITION);
    return isPremium;
};
const $5d91810a3f6a3a0a$export$d7b4c32773b1c643 = (tenantContext)=>{
    const { appPermissions: appPermissions } = tenantContext;
    const isPremium = $5d91810a3f6a3a0a$export$abb609d3bcbb74f6(tenantContext);
    const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    return isPremium && isLicensedUser;
};
const $5d91810a3f6a3a0a$var$transformResponse = (response)=>{
    const ids = response.results ?? [];
    return ids.length ? (0, $aSJew.toWorkspaceId)(ids[0].id) : null;
};
const $5d91810a3f6a3a0a$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
    const { baseUrl: baseUrl } = tenantContext;
    if ($5d91810a3f6a3a0a$export$d7b4c32773b1c643(tenantContext) === false || !(0, $8PehF.isCMDBEnabledInEnvironment)()) return null;
    return (0, $lRmyA.performGetRequest)($5d91810a3f6a3a0a$export$530f260cc76f04ff(baseUrl)).then($5d91810a3f6a3a0a$var$transformResponse).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
        return null;
    });
};
var $5d91810a3f6a3a0a$export$2e2bcd8739ae039 = $5d91810a3f6a3a0a$export$e1d718dfe6dad973;

});
parcelRegister("8PehF", function(module, exports) {

$parcel$export(module.exports, "isCMDBEnabledInEnvironment", () => $65623e3f6693c25d$export$6dbfb62369f79a64);

var $dfBCt = parcelRequire("dfBCt");
const $65623e3f6693c25d$export$6dbfb62369f79a64 = ()=>!(0, $dfBCt.isFedRamp)();

});

parcelRegister("aSJew", function(module, exports) {

$parcel$export(module.exports, "toSchemaId", () => $53b5a9a3e106b32f$export$d577b7f3b832f656);
$parcel$export(module.exports, "toCmdbObjectId", () => $53b5a9a3e106b32f$export$1ba342595bc7be13);
$parcel$export(module.exports, "toCmdbObjectTypeId", () => $53b5a9a3e106b32f$export$b46e25afa2bab6a);
$parcel$export(module.exports, "toObjectCommentId", () => $53b5a9a3e106b32f$export$ece2917434bb0a8c);
$parcel$export(module.exports, "toWorkspaceId", () => $53b5a9a3e106b32f$export$d002b8d7821b6b59);
$parcel$export(module.exports, "toAttributeId", () => $53b5a9a3e106b32f$export$753b5cb76981c41d);
$parcel$export(module.exports, "toObjectTypeAttributeId", () => $53b5a9a3e106b32f$export$cfd92c18cee8add7);
const $53b5a9a3e106b32f$export$d577b7f3b832f656 = (id)=>id;
const $53b5a9a3e106b32f$export$1ba342595bc7be13 = (id)=>id;
const $53b5a9a3e106b32f$export$b46e25afa2bab6a = (id)=>id;
const $53b5a9a3e106b32f$export$ece2917434bb0a8c = (id)=>id;
const $53b5a9a3e106b32f$export$d002b8d7821b6b59 = (id)=>id;
const $53b5a9a3e106b32f$export$753b5cb76981c41d = (id)=>id;
const $53b5a9a3e106b32f$export$cfd92c18cee8add7 = (id)=>id;

});




parcelRegister("3CDoJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("rX8u0").then(()=>parcelRequire('aFS9O'));

});

parcelRegister("3nYzG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jSEbY").then(()=>parcelRequire('f1UkV'));

});

parcelRegister("2FHVJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7rppT").then(()=>parcelRequire('24R0F'));

});

parcelRegister("1dv8j", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kPRh8").then(()=>parcelRequire('6t3Wv'));

});

parcelRegister("bCWHN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("cAzTV")
]).then(()=>parcelRequire('bZaKv'));

});

parcelRegister("jofpJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("cctG5")
]).then(()=>parcelRequire('4pZOP'));

});

parcelRegister("01Qi5", function(module, exports) {

$parcel$export(module.exports, "dashboardConfigAndWRMResource", () => $217791efaf6ffd9f$export$2853c0e656e89346);
$parcel$export(module.exports, "useDashboardResource", () => $217791efaf6ffd9f$export$e5e5b3f462d6a4cb);
$parcel$export(module.exports, "useMultiDashboardsResource", () => $217791efaf6ffd9f$export$6a46406b05d8d13c);
$parcel$export(module.exports, "dashboardAMDModulesResource", () => $217791efaf6ffd9f$export$ef3fa55626812fa4);
$parcel$export(module.exports, "useDashboardAMDModulesResource", () => $217791efaf6ffd9f$export$efe0eb9a44e08d38);
$parcel$export(module.exports, "dashboardReactGadgetsResource", () => $217791efaf6ffd9f$export$39804ce8cc42cd04);
$parcel$export(module.exports, "useDashboardReactGadgetsResource", () => $217791efaf6ffd9f$export$31b430e01a1caab5);
$parcel$export(module.exports, "dashboardForgeResource", () => $217791efaf6ffd9f$export$4e0719e53da01e93);
$parcel$export(module.exports, "gadgetDirectoryResource", () => $217791efaf6ffd9f$export$36c9632be21fbb06);
$parcel$export(module.exports, "useGadgetDirectoryResource", () => $217791efaf6ffd9f$export$27f4c12e781b4572);
$parcel$export(module.exports, "useDashboardForgeResource", () => $217791efaf6ffd9f$export$75ca1b431898fd09);

var $eI5EY = parcelRequire("eI5EY");

var $2Rqjr = parcelRequire("2Rqjr");

var $hsX10 = parcelRequire("hsX10");

var $cSfWg = parcelRequire("cSfWg");

var $lB25E = parcelRequire("lB25E");

var $8b1AQ = parcelRequire("8b1AQ");

var $iVB6J = parcelRequire("iVB6J");


var $2P6WI = parcelRequire("2P6WI");

var $gKtDv = parcelRequire("gKtDv");

var $6wpNP = parcelRequire("6wpNP");

var $dnvBi = parcelRequire("dnvBi");

var $g8TlX = parcelRequire("g8TlX");
const $217791efaf6ffd9f$export$2853c0e656e89346 = (0, $lB25E.createResource)({
    type: (0, $b44e2c11e9a5fc89$export$ca03ff6cc792cc16),
    getKey: $iVB6J.getKey,
    getData: (0, $gKtDv.default),
    maxAge: Infinity
});
// the type signature of promise and update is different on the useDashboardResource and useMultiDashboardsResource hook
const $217791efaf6ffd9f$var$extractFirstPromise = (promise)=>promise ? promise.then((configs)=>configs && configs[0]) : null;
const $217791efaf6ffd9f$export$e5e5b3f462d6a4cb = ()=>{
    // the response will have different signature on update, promise and clear etc
    const resourceResponse = $217791efaf6ffd9f$export$6a46406b05d8d13c();
    const { loading: loading, error: error, data: data, promise: promiseOfMultiConfigs, ...rest } = resourceResponse;
    const extractFirstUpdate = (getNewData)=>resourceResponse.update(([a])=>[
                getNewData(a)
            ]);
    // RouteResourceResponseLoading type
    if (loading) return {
        ...rest,
        error: null,
        data: null,
        promise: $217791efaf6ffd9f$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: true,
        update: extractFirstUpdate
    };
    // RouteResourceResponseError type
    if (error) return {
        ...rest,
        error: error,
        data: null,
        promise: $217791efaf6ffd9f$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: false,
        update: extractFirstUpdate
    };
    // RouteResourceResponseLoaded type
    if (data && !error) return {
        ...rest,
        loading: false,
        update: extractFirstUpdate,
        data: data[0],
        error: null,
        promise: $217791efaf6ffd9f$var$extractFirstPromise(promiseOfMultiConfigs)
    };
    // RouteResourceResponseInitial type
    return {
        ...rest,
        loading: false,
        error: error,
        data: null,
        promise: null,
        update: extractFirstUpdate
    };
};
const $217791efaf6ffd9f$export$6a46406b05d8d13c = ()=>(0, $lB25E.useResource)($217791efaf6ffd9f$export$2853c0e656e89346);
const $217791efaf6ffd9f$export$ef3fa55626812fa4 = (0, $8b1AQ.createDependentResource)({
    type: (0, $b44e2c11e9a5fc89$export$e239393fd4e2bc85),
    getKey: $iVB6J.getKey,
    depends: [
        (0, $b44e2c11e9a5fc89$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $8b1AQ.withEitherDataOrError)((data)=>{
        const { gadgets: gadgets, preloadedModuleNames: preloadedModuleNames } = data.reduce((prev, curr)=>({
                gadgets: prev.gadgets.concat(curr.gadgets),
                preloadedModuleNames: prev.preloadedModuleNames.concat(curr.preloadedModuleNames)
            }), {
            gadgets: [],
            preloadedModuleNames: []
        });
        const moduleNames = (0, $g8TlX.gadgetsToUniqueSortedAmdModules)(gadgets);
        const isPreloaded = moduleNames.every((name)=>preloadedModuleNames.includes(name));
        return {
            moduleNames: moduleNames,
            isPreloaded: isPreloaded
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, amdModules: amdModules }, b)=>(0, $8b1AQ.withEitherDataOrError)((prev, next)=>next.moduleNames.length > prev.moduleNames.length || next.moduleNames.some((name)=>amdModules?.[name] == null), ()=>true)(a, b),
    getData: (0, $2P6WI.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $217791efaf6ffd9f$export$efe0eb9a44e08d38 = ()=>(0, $lB25E.useResource)($217791efaf6ffd9f$export$ef3fa55626812fa4);
const $217791efaf6ffd9f$export$39804ce8cc42cd04 = (0, $8b1AQ.createDependentResource)({
    type: (0, $b44e2c11e9a5fc89$export$9e5db01432b13b67),
    getKey: $iVB6J.getKey,
    depends: [
        (0, $b44e2c11e9a5fc89$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $8b1AQ.withEitherDataOrError)((data)=>{
        const gadgets = data.flatMap((dashboard)=>dashboard.gadgets);
        return {
            reactGadgets: (0, $g8TlX.gadgetsToSortedReactGadgets)(gadgets)
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, reactGadgetsState: reactGadgetsState }, b)=>(0, $8b1AQ.withEitherDataOrError)((prev, next)=>JSON.stringify(next.reactGadgets) !== JSON.stringify(prev.reactGadgets) || reactGadgetsState != null && Object.values(reactGadgetsState).some((v)=>!v), ()=>true)(a, b),
    getData: (0, $dnvBi.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $217791efaf6ffd9f$export$31b430e01a1caab5 = ()=>(0, $lB25E.useResource)($217791efaf6ffd9f$export$39804ce8cc42cd04);
const $217791efaf6ffd9f$export$4e0719e53da01e93 = (0, $lB25E.createResource)({
    type: (0, $b44e2c11e9a5fc89$export$bce41807cc929d0f),
    getKey: $iVB6J.getKey,
    getData: async (_, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>{
        if ((0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules')) {
            const modules = await (0, $cSfWg.fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, $2Rqjr.DASHBOARD_GADGET_MODULE),
                    (0, $2Rqjr.DASHBOARD_BACKGROUND_SCRIPT_MODULE)
                ],
                context: {},
                includeHidden: false,
                source: (0, $2Rqjr.SOURCE_ROUTER)
            });
            return {
                gadgets: modules[0, $2Rqjr.DASHBOARD_GADGET_MODULE],
                backgroundScripts: modules[0, $2Rqjr.DASHBOARD_BACKGROUND_SCRIPT_MODULE]
            };
        }
        const contextIds = [
            `ari:cloud:jira:${cloudId}:workspace/${activationId}`
        ];
        const { extensions: extensions } = await (0, $hsX10.default)(cloudId, [
            (0, $2Rqjr.DASHBOARD_GADGET_MODULE),
            (0, $2Rqjr.DASHBOARD_BACKGROUND_SCRIPT_MODULE)
        ], null, undefined, (0, $2Rqjr.SOURCE_ROUTER), contextIds, locale);
        return {
            gadgets: extensions.jiraDashboardGadget,
            backgroundScripts: extensions.jiraDashboardBackgroundScript
        };
    },
    maxAge: Infinity
});
const $217791efaf6ffd9f$export$36c9632be21fbb06 = (0, $lB25E.createResource)({
    type: (0, $b44e2c11e9a5fc89$export$c07a25ebb6af1e84),
    getKey: ()=>'gadgetDirectoryItems',
    getData: (0, $6wpNP.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $217791efaf6ffd9f$export$27f4c12e781b4572 = ()=>(0, $lB25E.useResource)($217791efaf6ffd9f$export$36c9632be21fbb06);
const $217791efaf6ffd9f$export$75ca1b431898fd09 = ()=>(0, $lB25E.useResource)($217791efaf6ffd9f$export$4e0719e53da01e93);

});
parcelRegister("8b1AQ", function(module, exports) {

$parcel$export(module.exports, "withEitherDataOrError", () => $8a3f6d6901b27150$export$54e973088fdd59a1);
$parcel$export(module.exports, "createDependentResource", () => $8a3f6d6901b27150$export$7f8dd41bdfd85a47);
$parcel$export(module.exports, "SharedValueAggregateError", () => $8a3f6d6901b27150$export$36d5102d613df7c6);

var $lB25E = parcelRequire("lB25E");
const $8a3f6d6901b27150$export$54e973088fdd59a1 = (dataFn, errorFn)=>(...args)=>{
        const invalidArgs = args.filter((v)=>v == null || v instanceof Error);
        return invalidArgs.length ? errorFn(invalidArgs[0]) : dataFn(...args);
    };
const $8a3f6d6901b27150$export$fcdc85dfc621ec7a = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new (0, $lB25E.ResourceDependencyError)(`Cannot decode dependency "${type}", it may be missing from resource depends field`);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return resourceSlice.data;
};
const $8a3f6d6901b27150$export$bee6a631bfb54474 = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new Error(`Cannot decode dependency: "${type}" must be included in the resource depends field`);
    // prefer previous value rather than error
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { loading: loading, data: data, promise: promise, error: error } = resourceSlice;
    return loading && promise ? promise.then((v)=>v, (e)=>data ?? e) : data ?? error;
};
const $8a3f6d6901b27150$export$7f8dd41bdfd85a47 = ({ type: type, depends: depends, mapToSharedValue: mapToSharedValue, shouldUpdate: shouldUpdate, getData: getData, ...rest })=>(0, $lB25E.createResource)({
        ...rest,
        type: type,
        depends: [
            ...depends,
            type
        ],
        getData: (dataContext, storeContext)=>{
            const { dependencies: dependencies } = dataContext;
            const prevValue = $8a3f6d6901b27150$export$fcdc85dfc621ec7a(dependencies, type);
            const valuesOrPromises = depends.map((d)=>$8a3f6d6901b27150$export$bee6a631bfb54474(dependencies, d));
            const implementation = (depDataOrErrorOrNull)=>{
                const newShared = mapToSharedValue(...depDataOrErrorOrNull);
                return prevValue == null || prevValue instanceof Error || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                shouldUpdate(prevValue, newShared) ? getData(prevValue, newShared)(dataContext, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                storeContext) : prevValue;
            };
            return valuesOrPromises.some((v)=>v instanceof Promise) ? Promise.allSettled(valuesOrPromises).then((arr)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                arr.map((v)=>v.status === 'fulfilled' ? v.value : v.reason)).then(implementation) : implementation(valuesOrPromises);
        }
    });
class $8a3f6d6901b27150$export$36d5102d613df7c6 extends Error {
    constructor({ name: name, isPrefetch: isPrefetch, sharedValue: sharedValue }){
        super(`${name} is missing dependency, prefetch [${isPrefetch}] sharedValue [${sharedValue}]`);
        this.skipSentry = true;
    }
}

});

parcelRegister("iVB6J", function(module, exports) {

$parcel$export(module.exports, "getKey", () => $4e1b21534c9736b6$export$a47fb462a08de82f);

var $exb0h = parcelRequire("exb0h");

var $kEBPk = parcelRequire("kEBPk");
const $4e1b21534c9736b6$export$a47fb462a08de82f = ({ route: route, query: query, match: { params: params } })=>{
    if (route.name === (0, $exb0h.ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT)) return 0, $kEBPk.SYSTEM_DASHBOARD_ID;
    if (route.name === (0, $exb0h.ROUTE_NAMES_DASHBOARD_WALLBOARD)) // NOTE - Currently we will only load the first dashboard in the list
    return query.dashboardId?.split(',')[0];
    return params.dashboardId?.replace('last-visited', 'lastVisited') ?? query.selectPageId ?? 'lastVisited';
};

});
parcelRegister("kEBPk", function(module, exports) {

$parcel$export(module.exports, "GADGET_DISPLAY", () => $e4f2a654a0481d70$export$d7e1dfcefcde2410);
$parcel$export(module.exports, "MAXIMIZED_PARAM", () => $e4f2a654a0481d70$export$86eaa19ea940a4f5);
$parcel$export(module.exports, "CONNECT_ITEM_AMD_MODULE", () => $e4f2a654a0481d70$export$a1baea8b97610fd);
$parcel$export(module.exports, "WEB_RESOURCE_MAP", () => $e4f2a654a0481d70$export$c6d360a8456d120a);
$parcel$export(module.exports, "PRELOADED_GADGET_DATA_KEY", () => $e4f2a654a0481d70$export$30b970d16c2f5e0a);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_ID", () => $e4f2a654a0481d70$export$50eac80bcbebc737);
$parcel$export(module.exports, "DASHBOARD_HEADER_HEIGHT", () => $e4f2a654a0481d70$export$e11ffd0409aa6522);
$parcel$export(module.exports, "FOOTER_MARGIN", () => $e4f2a654a0481d70$export$4d708f4c16ae3a73);
$parcel$export(module.exports, "GADGET_LOCAL_STORAGE_NAME", () => $e4f2a654a0481d70$export$255117c9adec50a5);
$parcel$export(module.exports, "DASHBOARD_LOCAL_STORAGE_KEY_NAME", () => $e4f2a654a0481d70$export$e281465c09f561d4);
$parcel$export(module.exports, "GADGET_DEFAULT_HEIGHT", () => $e4f2a654a0481d70$export$46dd0168a7875b47);
$parcel$export(module.exports, "COLOR_MAP", () => $e4f2a654a0481d70$export$1468aefba37090f9);
$parcel$export(module.exports, "COLOR_NAME_MAP", () => $e4f2a654a0481d70$export$5d9e688e192a63ae);
$parcel$export(module.exports, "COLOR_CHECKMARK_MAP", () => $e4f2a654a0481d70$export$6906a4beef307ac4);
$parcel$export(module.exports, "MODAL_ID", () => $e4f2a654a0481d70$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "LAYOUTS", () => $e4f2a654a0481d70$export$87e50aced9c52ebb);
$parcel$export(module.exports, "GADGET_HEIGHT_UPDATE_WAIT_TIME", () => $e4f2a654a0481d70$export$b0234a47b1a4a515);
$parcel$export(module.exports, "GADGET_DRAG_CONTAINER_HEIGHT", () => $e4f2a654a0481d70$export$9674cd14c20d1c89);
$parcel$export(module.exports, "GADGET_METRICS_TYPE", () => $e4f2a654a0481d70$export$46b6c8eb53069613);
$parcel$export(module.exports, "PAGE_READY_METRIC_KEY", () => $e4f2a654a0481d70$export$464d2a6bcb398791);
$parcel$export(module.exports, "DELETE_DASHBOARD_EXPERIENCE", () => $e4f2a654a0481d70$export$4f74f1f13671c49d);
$parcel$export(module.exports, "COPY_DASHBOARD_EXPERIENCE", () => $e4f2a654a0481d70$export$3853fce65645c557);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE", () => $e4f2a654a0481d70$export$c8c77659771c38b9);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD_EXPERIENCE", () => $e4f2a654a0481d70$export$707702c47e5b9648);
$parcel$export(module.exports, "CREATE_DASHBOARD_EXPERIENCE", () => $e4f2a654a0481d70$export$efbab4efa7252143);
$parcel$export(module.exports, "VIEW_DASHBOARD_EDITABLE_EXPERIENCE", () => $e4f2a654a0481d70$export$7b6f3ec1189de156);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EXPERIENCE", () => $e4f2a654a0481d70$export$f0e105144716a420);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EMBED_EXPERIENCE", () => $e4f2a654a0481d70$export$5ba84cd082269cd5);
$parcel$export(module.exports, "VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE", () => $e4f2a654a0481d70$export$6c84c6099fed3c23);
$parcel$export(module.exports, "ADD_GADGET_EXPERIENCE", () => $e4f2a654a0481d70$export$3b17b4f7f722b1ae);
$parcel$export(module.exports, "SAVE_AMD_GADGET_CONFIG_PREFERENCES", () => $e4f2a654a0481d70$export$c8900d7e874d42ca);
$parcel$export(module.exports, "SAVE_FORGE_GADGET_CONFIG_PREFERENCES", () => $e4f2a654a0481d70$export$bac5a3e9d008da59);
$parcel$export(module.exports, "SAVE_CUSTOM_GADGET_TITLE_PREFERENCES", () => $e4f2a654a0481d70$export$18b54b2c53cf6acd);
$parcel$export(module.exports, "VIEW_WRM_GADGET_EXPERIENCE", () => $e4f2a654a0481d70$export$a3d5b76ea0c8f4ca);
$parcel$export(module.exports, "CHANGE_LAYOUT_EXPERIENCE", () => $e4f2a654a0481d70$export$7254246f25b4cbc8);
$parcel$export(module.exports, "DELETE_GADGET_EXPERIENCE", () => $e4f2a654a0481d70$export$40c4d345e57fce2d);
$parcel$export(module.exports, "VIEW_REACT_GADGET_EXPERIENCE", () => $e4f2a654a0481d70$export$43fb10a4d8374f1a);
$parcel$export(module.exports, "DASHBOARD_VIEW_SOURCENAME", () => $e4f2a654a0481d70$export$2f961c74af6d8735);
$parcel$export(module.exports, "DASHBOARD_VIEW_EMBED_SOURCENAME", () => $e4f2a654a0481d70$export$dab1096b356df1cc);
$parcel$export(module.exports, "DASHBOARD_EDIT_SOURCENAME", () => $e4f2a654a0481d70$export$32f0edca4eebb9c7);
$parcel$export(module.exports, "DASHBOARD_WALLBOARD_VIEW_SOURCENAME", () => $e4f2a654a0481d70$export$791f7067c41dc5b1);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_EDIT_SOURCENAME", () => $e4f2a654a0481d70$export$eba1a497984af3ae);
$parcel$export(module.exports, "COPY_DASHBOARD", () => $e4f2a654a0481d70$export$3578044b625436f9);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH", () => $e4f2a654a0481d70$export$48bb59a846d62ea0);
$parcel$export(module.exports, "DELETE_DASHBOARD", () => $e4f2a654a0481d70$export$e7dfbcf33cf2b19a);
$parcel$export(module.exports, "DUPLICATE_GADGET_EXPERIENCE", () => $e4f2a654a0481d70$export$fabf79b25b44377f);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD", () => $e4f2a654a0481d70$export$abba919f32a1a776);
$parcel$export(module.exports, "GADGET_ERROR_TYPE", () => $e4f2a654a0481d70$export$768dad6811159849);
$parcel$export(module.exports, "DASHBOARD_REFRESH_LOAD_BUFFER_MS", () => $e4f2a654a0481d70$export$ada294d471e7dfc3);
$parcel$export(module.exports, "REFRESH_LABEL_UPDATE_INTERVAL", () => $e4f2a654a0481d70$export$f4280aaeba4d1d08);
$parcel$export(module.exports, "CONNECT_GADGET_REFRESH_REQUEST_EVENT", () => $e4f2a654a0481d70$export$685171fdf5112bc4);
$parcel$export(module.exports, "FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT", () => $e4f2a654a0481d70$export$4d8c12b9aaeac619);
$parcel$export(module.exports, "ISSUE_SEARCH_DEFAULT_COLUMNS", () => $e4f2a654a0481d70$export$f07dac7b8de3bda);
$parcel$export(module.exports, "DEPRECATED_GADGETS_MAP", () => $e4f2a654a0481d70$export$4ac59ce79d9e7591);
$parcel$export(module.exports, "DEPRECATION_BANNER_V1", () => $e4f2a654a0481d70$export$b5d0f99a1924c478);


var $c9TLT = parcelRequire("c9TLT");

var $e1itL = parcelRequire("e1itL");
const $e4f2a654a0481d70$export$d7e1dfcefcde2410 = {
    MAXIMIZED: 'maximized',
    NORMAL: 'normal',
    HIDDEN: 'hidden'
};
const $e4f2a654a0481d70$export$86eaa19ea940a4f5 = 'maximized';
const $e4f2a654a0481d70$export$a1baea8b97610fd = 'atlassian-connect/connect-dashboard-item';
const $e4f2a654a0481d70$export$c6d360a8456d120a = {
    'jira-dashboard-items/assigned-to-me': 'com.atlassian.jira.gadgets:assigned-to-me-dashboard-item-resources',
    'jira-dashboard-items/filter-results': 'com.atlassian.jira.gadgets:filter-results-dashboard-item-resources',
    'jira-dashboard-items/createdvsresolved': 'com.atlassian.jira.gadgets:createdvsresolved-dashboard-item-resources',
    'jira-dashboard-items/favourite-filters': 'com.atlassian.jira.gadgets:favourite-filters-dashboard-item-resources',
    'jira-dashboard-items/in-progress': 'com.atlassian.jira.gadgets:in-progress-dashboard-item-resources',
    'jira-dashboard-items/stats': 'com.atlassian.jira.gadgets:stats-dashboard-item-resources',
    'jira-dashboard-items/watched': 'com.atlassian.jira.gadgets:watched-dashboard-item-resources',
    'jira-dashboard-items/labels': 'com.atlassian.jira.gadgets:labels-dashboard-item-resources',
    'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item-resources',
    'jira-dashboard-items/piechart': 'com.atlassian.jira.gadgets:piechart-dashboard-item-resources',
    'jira-dashboard-items/voted': 'com.atlassian.jira.gadgets:voted-dashboard-item-resources',
    'jira-dashboard-items/two-dimensional-stats': 'com.atlassian.jira.gadgets:two-dimensional-stats-dashboard-item-resources',
    'jira-dashboard-items/sprint-health': 'com.pyxis.greenhopper.jira:greenhopper-sprint-health-dashboard-item-resources',
    'jira-dashboard-items/sprint-days-remaining': 'com.pyxis.greenhopper.jira:greenhopper-days-remaining-dashboard-item-resources',
    'servicedesk/internal/dashboard-items/filter/filter-dashboard-item': 'com.atlassian.servicedesk.dashboard-items-plugin:spa-filter-dashboard-item-resources',
    'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'com.atlassian.servicedesk.servicedesk-reports-plugin:custom-report-dashboard-item-resources-spa',
    'jira-dashboard-items/projects': 'com.atlassian.jira.gadgets:projects-dashboard-item-resources',
    'jira-dashboard-items/issuescalendar': 'com.atlassian.jira.ext.calendar:issues-calendar-dashboard-item-resources',
    'jira-dashboard-items/activitystream': 'com.atlassian.streams.streams-jira-plugin:activitystream-dashboard-item-resources',
    'jira-dashboard-items/recently-created': 'com.atlassian.jira.gadgets:recently-created-chart-dashboard-item-resources',
    'jira-dashboard-items/resolution-time': 'com.atlassian.jira.gadgets:resolution-time-dashboard-item-resources',
    'jira-dashboard-items/timesince': 'com.atlassian.jira.gadgets:timesince-dashboard-item-resources',
    'jira-dashboard-items/spacer': 'com.atlassian.jira.gadgets:spacer-dashboard-item-resources',
    'jira-dashboard-items/sprint-burndown': 'com.pyxis.greenhopper.jira:greenhopper-sprint-burndown-dashboard-item-resources',
    'jira-dashboard-items/workload-pie-chart': 'com.atlassian.jira.gadgets:workload-pie-chart-dashboard-item-resources',
    'jira-dashboard-items/roadmap': 'com.atlassian.jira.gadgets:roadmap-dashboard-item-resources',
    'jira-dashboard-items/average-age-chart': 'com.atlassian.jira.gadgets:average-age-chart-dashboard-item-resources',
    'jira-dashboard-items/average-time-in-status-chart': 'com.atlassian.jira.gadgets:average-time-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/average-number-of-times-in-status-chart': 'com.atlassian.jira.gadgets:average-number-of-times-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/heat-map': 'com.atlassian.jira.gadgets:heat-map-dashboard-item-resources',
    'jira-dashboard-items/time-to-first-response': 'com.atlassian.jira.gadgets:time-to-first-response-dashboard-item-resources',
    'jira-dashboard-items/rapid-view': 'com.pyxis.greenhopper.jira:greenhopper-rapid-view-dashboard-item-resources',
    'jira-dashboard-items/version-report': 'com.pyxis.greenhopper.jira:greenhopper-version-report-dashboard-item-resources'
};
const $e4f2a654a0481d70$export$30b970d16c2f5e0a = 'DASHBOARD_GADGET_PRELOADED_DATA';
const $e4f2a654a0481d70$export$50eac80bcbebc737 = '10000';
const $e4f2a654a0481d70$export$e11ffd0409aa6522 = (0, $c9TLT.gridSize) * 10;
const $e4f2a654a0481d70$export$4d708f4c16ae3a73 = (0, $c9TLT.gridSize) * 2;
const $e4f2a654a0481d70$export$504bf5c8f7d402e9 = (0, $c9TLT.gridSize) * 3;
const $e4f2a654a0481d70$export$255117c9adec50a5 = 'AG.congolmerate.cookie';
const $e4f2a654a0481d70$export$e281465c09f561d4 = 'dashboard-data';
const $e4f2a654a0481d70$export$46dd0168a7875b47 = 160;
const $e4f2a654a0481d70$var$COLOR_BLUE = '#2684ff';
const $e4f2a654a0481d70$var$COLOR_RED = '#ff5630';
const $e4f2a654a0481d70$var$COLOR_YELLOW = '#ffab00';
const $e4f2a654a0481d70$var$COLOR_GREEN = '#36b37e';
const $e4f2a654a0481d70$var$COLOR_TEAL = '#00b8d9';
const $e4f2a654a0481d70$var$COLOR_PURPLE = '#6554c0';
const $e4f2a654a0481d70$var$COLOR_GRAY = '#97a0af';
const $e4f2a654a0481d70$var$COLOR_WHITE = '#ffffff';
const $e4f2a654a0481d70$export$1468aefba37090f9 = {
    color1: $e4f2a654a0481d70$var$COLOR_BLUE,
    color2: $e4f2a654a0481d70$var$COLOR_RED,
    color3: $e4f2a654a0481d70$var$COLOR_YELLOW,
    color4: $e4f2a654a0481d70$var$COLOR_GREEN,
    color5: $e4f2a654a0481d70$var$COLOR_TEAL,
    color6: $e4f2a654a0481d70$var$COLOR_PURPLE,
    color7: $e4f2a654a0481d70$var$COLOR_GRAY,
    color8: $e4f2a654a0481d70$var$COLOR_WHITE
};
const $e4f2a654a0481d70$export$5d9e688e192a63ae = {
    [$e4f2a654a0481d70$var$COLOR_BLUE]: (0, $e1itL.default).blue,
    [$e4f2a654a0481d70$var$COLOR_RED]: (0, $e1itL.default).red,
    [$e4f2a654a0481d70$var$COLOR_YELLOW]: (0, $e1itL.default).yellow,
    [$e4f2a654a0481d70$var$COLOR_GREEN]: (0, $e1itL.default).green,
    [$e4f2a654a0481d70$var$COLOR_TEAL]: (0, $e1itL.default).teal,
    [$e4f2a654a0481d70$var$COLOR_PURPLE]: (0, $e1itL.default).purple,
    [$e4f2a654a0481d70$var$COLOR_GRAY]: (0, $e1itL.default).gray,
    [$e4f2a654a0481d70$var$COLOR_WHITE]: (0, $e1itL.default).white
};
const $e4f2a654a0481d70$export$6906a4beef307ac4 = {
    color1: (0, $73a5c9d720aa66e1$exports).N10,
    color2: (0, $73a5c9d720aa66e1$exports).N10,
    color3: (0, $73a5c9d720aa66e1$exports).N500,
    color4: (0, $73a5c9d720aa66e1$exports).N10,
    color5: (0, $73a5c9d720aa66e1$exports).N500,
    color6: (0, $73a5c9d720aa66e1$exports).N10,
    color7: (0, $73a5c9d720aa66e1$exports).N10,
    color8: (0, $73a5c9d720aa66e1$exports).N500
};
const $e4f2a654a0481d70$export$ebdd5a8e5b1c2de5 = {
    EDIT_LAYOUT: 'edit-layout',
    DASHBOARD_COPY: 'dashboard-copy',
    AUTOMATIC_REFRESH: 'dashboard-automatic-refresh',
    DASHBOARD_RENAME_OR_SHARE: 'dashboard-rename-or-share',
    DASHBOARD_DELETE: 'dashboard-delete',
    CONFIGURE_WALLBOARD: 'configure-wallboard',
    DASHBOARD_CREATE: 'dashboard-create-on-dashboard-page'
};
const $e4f2a654a0481d70$export$87e50aced9c52ebb = [
    'A',
    'AA',
    'AAA',
    'BA',
    'AB'
];
const $e4f2a654a0481d70$export$b0234a47b1a4a515 = 350;
const $e4f2a654a0481d70$export$9674cd14c20d1c89 = 250;
const $e4f2a654a0481d70$export$46b6c8eb53069613 = {
    REPORT: 'REPORT_GADGET_METRICS',
    TIMEOUT: 'TIMEOUT_GADGET_METRICS'
};
const $e4f2a654a0481d70$export$464d2a6bcb398791 = 'JIRA_SPA_PAGE_READY';
const $e4f2a654a0481d70$export$4f74f1f13671c49d = 'delete-dashboard';
const $e4f2a654a0481d70$export$3853fce65645c557 = 'copy-dashboard';
const $e4f2a654a0481d70$export$c8c77659771c38b9 = 'dashboard-automatic-refresh';
const $e4f2a654a0481d70$export$707702c47e5b9648 = 'rename-or-share-dashboard';
const $e4f2a654a0481d70$export$efbab4efa7252143 = 'create-dashboard';
const $e4f2a654a0481d70$export$7b6f3ec1189de156 = 'view-dashboard-editable';
const $e4f2a654a0481d70$export$f0e105144716a420 = 'view-dashboard-readonly';
const $e4f2a654a0481d70$export$5ba84cd082269cd5 = 'view-dashboard-readonly-embed';
const $e4f2a654a0481d70$export$6c84c6099fed3c23 = 'view-dashboard-wallboard-readonly';
const $e4f2a654a0481d70$export$3b17b4f7f722b1ae = 'add-gadget';
const $e4f2a654a0481d70$export$c8900d7e874d42ca = 'save-amd-gadget-config';
const $e4f2a654a0481d70$export$bac5a3e9d008da59 = 'save-forge-gadget-config';
const $e4f2a654a0481d70$export$18b54b2c53cf6acd = 'save-custom-gadget-title-config';
const $e4f2a654a0481d70$export$a3d5b76ea0c8f4ca = 'view-wrm-gadget';
const $e4f2a654a0481d70$export$7254246f25b4cbc8 = 'change-layout';
const $e4f2a654a0481d70$export$40c4d345e57fce2d = 'delete-gadget';
const $e4f2a654a0481d70$export$43fb10a4d8374f1a = 'view-react-gadget';
const $e4f2a654a0481d70$export$2f961c74af6d8735 = 'dashboardView';
const $e4f2a654a0481d70$export$dab1096b356df1cc = 'dashboardViewEmbed';
const $e4f2a654a0481d70$export$32f0edca4eebb9c7 = 'dashboardEdit';
const $e4f2a654a0481d70$export$791f7067c41dc5b1 = 'dashboardWallboardView';
const $e4f2a654a0481d70$export$eba1a497984af3ae = 'systemDashboardEdit';
const $e4f2a654a0481d70$export$3578044b625436f9 = 'copyDashboard';
const $e4f2a654a0481d70$export$48bb59a846d62ea0 = 'automaticRefresh';
const $e4f2a654a0481d70$export$e7dfbcf33cf2b19a = 'deleteDashboard';
const $e4f2a654a0481d70$export$fabf79b25b44377f = 'duplicateGadget';
const $e4f2a654a0481d70$export$abba919f32a1a776 = 'renameOrShareDashboard';
const $e4f2a654a0481d70$export$768dad6811159849 = {
    VIEW_ERROR: 'viewError',
    EDIT_ERROR: 'editError',
    CONFIG_ERROR: 'configError',
    NOT_SUPPORTED_ERROR: 'notSupportedError'
};
const $e4f2a654a0481d70$export$f8e04d62c0b5d07e = /^endeavour\.(spa|dashboard|gadget)\.[\w-]+$/;
const $e4f2a654a0481d70$export$ada294d471e7dfc3 = 1000;
const $e4f2a654a0481d70$export$f4280aaeba4d1d08 = 30000;
const $e4f2a654a0481d70$export$685171fdf5112bc4 = 'jira_dashboard_item_refresh';
const $e4f2a654a0481d70$export$4d8c12b9aaeac619 = 'JIRA_DASHBOARD_GADGET_REFRESH';
const $e4f2a654a0481d70$export$f07dac7b8de3bda = [
    'issuetype',
    'issuekey',
    'summary',
    'priority'
];
const $e4f2a654a0481d70$export$4ac59ce79d9e7591 = {
    'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item',
    'jira-dashboard-items/heat-map': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:heat-map-gadget/gadgets/heatmap-gadget.xml',
    'jira-dashboard-items/projects': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:project-gadget/gadgets/project-gadget.xml',
    'jira-dashboard-items/labels': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:labels-gadget/gadgets/labels-gadget.xml',
    'jira-dashboard-items/roadmap': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:road-map-gadget/gadgets/roadmap-gadget.xml'
};
const $e4f2a654a0481d70$export$b5d0f99a1924c478 = 'deprecatedGadgetBannerDismissedV1';

});
parcelRegister("e1itL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb4a8cfceb6e56fe$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bb4a8cfceb6e56fe$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    blue: {
        "id": "dashboard-common.blue",
        "defaultMessage": "Blue"
    },
    red: {
        "id": "dashboard-common.red",
        "defaultMessage": "Red"
    },
    yellow: {
        "id": "dashboard-common.yellow",
        "defaultMessage": "Yellow"
    },
    green: {
        "id": "dashboard-common.green",
        "defaultMessage": "Green"
    },
    teal: {
        "id": "dashboard-common.teal",
        "defaultMessage": "Teal"
    },
    purple: {
        "id": "dashboard-common.purple",
        "defaultMessage": "Purple"
    },
    gray: {
        "id": "dashboard-common.gray",
        "defaultMessage": "Gray"
    },
    white: {
        "id": "dashboard-common.white",
        "defaultMessage": "White"
    }
});

});



const $b44e2c11e9a5fc89$export$ca03ff6cc792cc16 = 'DASHBOARD_CONFIG_AND_WRM';
const $b44e2c11e9a5fc89$export$e239393fd4e2bc85 = 'DASHBOARD_AMD_MODULES';
const $b44e2c11e9a5fc89$export$9e5db01432b13b67 = 'DASHBOARD_REACT_GADGETS';
const $b44e2c11e9a5fc89$export$dd4bac16c565acb1 = 'DASHBOARD_FORGE_GADGETS';
const $b44e2c11e9a5fc89$export$bce41807cc929d0f = 'DASHBOARD_FORGE';
const $b44e2c11e9a5fc89$export$c07a25ebb6af1e84 = 'DASHBOARD_GADGET_DIRECTORY';
const $b44e2c11e9a5fc89$export$58e1e8808435e4be = 'AVP_DASHBOARD';

parcelRegister("2P6WI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3befe6799fde3b06$export$2e2bcd8739ae039);

var $16kIm = parcelRequire("16kIm");

var $8b1AQ = parcelRequire("8b1AQ");

var $3G0rV = parcelRequire("3G0rV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3befe6799fde3b06$export$2e2bcd8739ae039 = (_maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch })=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $8b1AQ.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { moduleNames: moduleNames, isPreloaded: isPreloaded } = sharedValue;
            const maybePromiseAmdModules = isPreloaded || await (0, $3G0rV.loadAmdModules)((0, $16kIm.asyncWrmRequire), moduleNames) ? (0, $3G0rV.evalAmdModules)(moduleNames) : null;
            const amdModules = maybePromiseAmdModules instanceof Promise ? await maybePromiseAmdModules : maybePromiseAmdModules;
            return {
                sharedValue: sharedValue,
                amdModules: amdModules
            };
        })();
    };

});
parcelRegister("3G0rV", function(module, exports) {

$parcel$export(module.exports, "loadAmdModules", () => $bdb0cde0ec4f6018$export$2c79895bd69a8d54);
$parcel$export(module.exports, "evalAmdModules", () => $bdb0cde0ec4f6018$export$d74eab33af9baaea);

var $gUUjF = parcelRequire("gUUjF");

var $kEBPk = parcelRequire("kEBPk");
/**
 * Dummy implementation for a Connect gadget, as rendering and editing are
 * managed externally.
 */ class $bdb0cde0ec4f6018$var$ConnectDashboardItem {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    render() {}
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    renderEdit() {}
}
const $bdb0cde0ec4f6018$export$3bf37adbbdcafcc8 = (moduleName, retries = 5)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (typeof window.require !== 'function') throw new TypeError('window.require is not a function');
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.require(moduleName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // amd module could throw a non-Error
        if (error instanceof Error && /^No \S+$|^\S+ missing \S+$/.test(error.message)) {
            // some AMD modules have define() inside a require() block in which case the module is not immediately ready to be window.require()'d
            // this is due to the 4ms timeout in requirejs' require(), we need a retry logic here to make sure the module is loaded.
            // see the comment section for https://jdog.jira-dev.com/browse/WRM-71
            if (retries > 0) return new Promise((r)=>setTimeout(r, 100)).then(()=>$bdb0cde0ec4f6018$export$3bf37adbbdcafcc8(moduleName, retries - 1));
        }
        throw error;
    }
};
const $bdb0cde0ec4f6018$export$2c79895bd69a8d54 = async (wrmRequire, moduleNames)=>{
    if (moduleNames.length === 0) return false;
    const prefixedAmdResources = moduleNames.map((amdModule)=>(0, $kEBPk.WEB_RESOURCE_MAP)[amdModule]).map((resourceName)=>`wrc!${resourceName}`);
    try {
        // no result from the promise only the side effect of having loaded the AMD module via WRM
        await wrmRequire(prefixedAmdResources);
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.resource', `Failed to load web resources [${prefixedAmdResources.join(',')}]`, error);
        return false;
    }
};
const $bdb0cde0ec4f6018$var$getSortedModuleNamesFromTuples = (tuples)=>tuples.map(([moduleName])=>moduleName).sort((a, b)=>a.localeCompare(b)).join(',');
const $bdb0cde0ec4f6018$export$d74eab33af9baaea = (amdModuleNames)=>{
    const tuplesOrPromises = amdModuleNames.map((amdModuleName)=>{
        try {
            const module = amdModuleName === (0, $kEBPk.CONNECT_ITEM_AMD_MODULE) ? $bdb0cde0ec4f6018$var$ConnectDashboardItem : $bdb0cde0ec4f6018$export$3bf37adbbdcafcc8(amdModuleName);
            return module instanceof Promise ? module.then((v)=>[
                    amdModuleName,
                    v
                ]) : [
                amdModuleName,
                module
            ];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return Promise.reject(error);
        }
    });
    const hasPromise = tuplesOrPromises.some((entry)=>entry instanceof Promise);
    if (!hasPromise) {
        (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful synchronous bulk eval AMD modules');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Object.fromEntries(tuplesOrPromises);
    }
    return Promise.allSettled(tuplesOrPromises).then((results)=>{
        const tuples = results.map((result, i)=>{
            if (result.status === 'fulfilled') return result.value;
            const { reason: error } = result;
            const amdModuleName = amdModuleNames[i];
            const message = error instanceof Error ? error.message : String(error);
            (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD module [${amdModuleName}] with error [${message}]`, error);
            return [
                amdModuleName,
                null
            ];
        });
        const failedTuples = tuples.filter((module)=>module[1] === null);
        failedTuples.length > 0 ? (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD modules [${$bdb0cde0ec4f6018$var$getSortedModuleNamesFromTuples(failedTuples)}]`) : (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful asynchronous bulk eval AMD modules');
        return Object.fromEntries(tuples);
    });
};

});


parcelRegister("gKtDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ba5531603412124$export$2e2bcd8739ae039);

var $exb0h = parcelRequire("exb0h");

var $b32xd = parcelRequire("b32xd");

var $2VeIs = parcelRequire("2VeIs");

var $gUvw9 = parcelRequire("gUvw9");

var $2OLBQ = parcelRequire("2OLBQ");

var $hPXQA = parcelRequire("hPXQA");

var $iVB6J = parcelRequire("iVB6J");

var $g8TlX = parcelRequire("g8TlX");
const $3ba5531603412124$var$generateScriptTagAndPreloadedModuleNames = async (configs)=>{
    const gadgets = configs.flatMap((config)=>config.gadgets);
    const preloadedModuleNames = (0, $g8TlX.gadgetsToUniqueSortedAmdModules)(gadgets);
    const wrmBundleDescriptor = await (0, $gUvw9.default)(preloadedModuleNames);
    return configs.map((config)=>{
        const scriptTags = [
            wrmBundleDescriptor ? (0, $hPXQA.default)(wrmBundleDescriptor) : null,
            (0, $2OLBQ.default)(config)
        ].filter(Boolean).join('\n') || null;
        return {
            ...config,
            scriptTags: scriptTags,
            preloadedModuleNames: preloadedModuleNames
        };
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3ba5531603412124$export$2e2bcd8739ae039 = async (context)=>{
    // this is either for single dashboard/wallboard or wallboard slide show with multiple dashboards
    const { route: route, query: query } = context;
    const originalConfigs = route.name === (0, $exb0h.ROUTE_NAMES_DASHBOARD_WALLBOARD) ? await (0, $2VeIs.getDashboardsConfig)(query.dashboardId) : [
        await (0, $2VeIs.default)((0, $iVB6J.getKey)(context))
    ];
    const configs = originalConfigs.map((config)=>({
            ...config,
            gadgets: (0, $b32xd.mapToReactGadgets)(config.gadgets)
        }));
    if (!false) return configs.map((config)=>({
            ...config,
            preloadedModuleNames: []
        }));
    return $3ba5531603412124$var$generateScriptTagAndPreloadedModuleNames(configs);
};

});
parcelRegister("b32xd", function(module, exports) {

$parcel$export(module.exports, "mapToReactGadgets", () => $8925989550454392$export$c90615c5eb218d50);

var $eI5EY = parcelRequire("eI5EY");
const $8925989550454392$export$c90615c5eb218d50 = (gadgets)=>{
    const gadgetMapping = {
        ...(0, $eI5EY.fg)('endeavour_nin_filter_results_gadget') ? {
            'jira-dashboard-items/filter-results': 'react/filter-results'
        } : {},
        'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'react/custom-report',
        ...(0, $eI5EY.fg)('endeavour_nin_assigned_to_me_gadget') ? {
            'jira-dashboard-items/assigned-to-me': 'react/assigned-to-me'
        } : {},
        ...(0, $eI5EY.fg)('endeavour_nin_issues_in_progress_gadget') ? {
            'jira-dashboard-items/in-progress': 'react/issues-in-progress'
        } : {},
        ...(0, $eI5EY.fg)('endeavour_nin_voted_issues_gadget') ? {
            'jira-dashboard-items/voted': 'react/voted-issues'
        } : {},
        ...(0, $eI5EY.fg)('endeavour_nin_watched_issues_gadget') ? {
            'jira-dashboard-items/watched': 'react/watched-issues'
        } : {}
    }; // satisfies Record<string, ReactKey>; SSR image build Thread Loader doesn't understand 'satisfies'
    const isMapped = (module)=>module !== undefined && module in gadgetMapping;
    return gadgets.map((gadget)=>{
        if (isMapped(gadget.amdModule)) return {
            ...gadget,
            reactKey: gadgetMapping[gadget.amdModule],
            amdModule: undefined,
            configurable: false,
            inlineHtml: undefined
        };
        return gadget;
    });
};

});

parcelRegister("2VeIs", function(module, exports) {

$parcel$export(module.exports, "default", () => $99fd60763f19d998$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getDashboardsConfig", () => $99fd60763f19d998$export$1264b6af3adf5084);

var $2OdyW = parcelRequire("2OdyW");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$99fd60763f19d998$export$2e2bcd8739ae039 = (id)=>(0, $2OdyW.default)(`/rest/dashboards/1.0/${id}.json`);
const $99fd60763f19d998$export$1264b6af3adf5084 = (idsCsv)=>(0, $2OdyW.default)(`/rest/dashboards/1.0?dashboardId=${idsCsv}`);

});

parcelRegister("gUvw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1fab7a3f6b4bae2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $kEBPk = parcelRequire("kEBPk");

var $2OdyW = parcelRequire("2OdyW");
const $b1fab7a3f6b4bae2$var$CRITICAL_DEPENDENCIES = [
    'jira.webresources:util',
    'jira.webresources:feature-flags',
    'com.atlassian.jira.jira-atlaskit-plugin:overrides-general'
];
const $b1fab7a3f6b4bae2$var$JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b1fab7a3f6b4bae2$export$2e2bcd8739ae039 = async (moduleNames)=>{
    if (moduleNames.length === 0) return Promise.resolve(null);
    const contextsToRequire = moduleNames.map((amdModule)=>(0, $kEBPk.WEB_RESOURCE_MAP)[amdModule]);
    const payload = {
        r: [],
        c: [
            ...$b1fab7a3f6b4bae2$var$CRITICAL_DEPENDENCIES,
            ...contextsToRequire
        ],
        xc: [
            $b1fab7a3f6b4bae2$var$JIRA_HERITAGE_CRITICAL_BATCH
        ],
        xr: []
    };
    return (0, $2OdyW.default)('/rest/webResources/1.0/resources', {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};

});

parcelRegister("2OLBQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3d435382503897c$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $kEBPk = parcelRequire("kEBPk");

var $829dv = parcelRequire("829dv");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f3d435382503897c$export$2e2bcd8739ae039 = (dashboardConfig)=>{
    if (dashboardConfig.gadgets.length === 0) return null;
    const prefetches = (0, $829dv.getPrefetches)(dashboardConfig);
    const preloadLinks = prefetches.map((prefetch)=>`<link rel="preload" as="fetch" href="${prefetch.url}" crossorigin="anonymous" />`).join('\n') || null;
    const syncPrefetchUrls = prefetches.filter((prefetch)=>prefetch.isSyncLoadingSupported()).map((prefetch)=>prefetch.url);
    if (preloadLinks != null && syncPrefetchUrls.length > 0) {
        const fetchScript = `
            <script type="text/javascript" data-defer-skip>
                const preloadUrls = ${JSON.stringify(syncPrefetchUrls)};
                window['${(0, $kEBPk.PRELOADED_GADGET_DATA_KEY)}'] = {};

                preloadUrls.forEach((preloadUrl) => {
                    fetch(preloadUrl)
                        .then(res => res.json())
                        .then(data => {
                            window['${(0, $kEBPk.PRELOADED_GADGET_DATA_KEY)}'][preloadUrl] = data;
                        });
                });
            </script>
        `;
        return preloadLinks + fetchScript;
    }
    return preloadLinks;
};

});
parcelRegister("829dv", function(module, exports) {

$parcel$export(module.exports, "getPrefetches", () => $e72a0f3939c6d5ed$export$3144db3718ad5e57);

var $cUxyt = parcelRequire("cUxyt");
const $e72a0f3939c6d5ed$export$3144db3718ad5e57 = ({ gadgets: gadgets })=>{
    const lookup = (0, $cUxyt.getPrefetchDict)();
    return gadgets.flatMap((gadget)=>{
        const identifier = gadget.amdModule;
        const prefechProp = identifier != null ? lookup[identifier] : undefined;
        if (!prefechProp || !prefechProp.enabled) return [];
        const { func: func, priority: priority, isSyncLoadingSupported: isSyncLoadingSupported } = prefechProp;
        return func(gadget).map((url)=>({
                url: url,
                priority: priority,
                isSyncLoadingSupported: isSyncLoadingSupported
            }));
    });
};

});
parcelRegister("cUxyt", function(module, exports) {

$parcel$export(module.exports, "getPrefetchDict", () => $5288b615002d4c5f$export$244cea94cab19e07);

var $eI5EY = parcelRequire("eI5EY");

var $lD4Kg = parcelRequire("lD4Kg");

var $4BzVP = parcelRequire("4BzVP");

var $6jPL6 = parcelRequire("6jPL6");
const $5288b615002d4c5f$export$244cea94cab19e07 = ()=>({
        'jira-dashboard-items/activitystream': {
            func: (0, $4BzVP.getActivityStreamPrefetchLink),
            priority: (0, $lD4Kg.LOADING_PRIORITY).HIGH,
            enabled: true,
            isSyncLoadingSupported: ()=>false
        },
        'jira-dashboard-items/filter-results': {
            func: (0, $6jPL6.getFilterResultsPrefetchLink),
            priority: (0, $lD4Kg.LOADING_PRIORITY).LOW,
            enabled: !(0, $eI5EY.fg)('endeavour_nin_filter_results_gadget'),
            isSyncLoadingSupported: ()=>true
        }
    });

});
parcelRegister("lD4Kg", function(module, exports) {

$parcel$export(module.exports, "LOADING_PRIORITY", () => $bfb7cfda6fc0971f$export$cb9b1f2232733c1b);
const $bfb7cfda6fc0971f$export$cb9b1f2232733c1b = {
    HIGH: 'preload',
    LOW: 'prefetch'
};

});

parcelRegister("4BzVP", function(module, exports) {

$parcel$export(module.exports, "getActivityStreamPrefetchLink", () => $b07607e1011a103f$export$360928f5bf059a9e);

var $53ciZ = parcelRequire("53ciZ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b07607e1011a103f$var$replacer = (match, part1)=>String.fromCharCode(part1);
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#63-81
// @ts-expect-error - TS7006 - Parameter 'operatorLower' implicitly has an 'any' type.
const $b07607e1011a103f$var$getDateValue = (dateValue, operatorLower)=>{
    // make sure we're dealing with a string so we can use indexOf and split without errors
    const dateStr = `${dateValue}`;
    const operator = operatorLower.toUpperCase();
    let dateArr;
    if (dateStr.indexOf(' ') !== -1) dateArr = dateStr.split(' ');
    else if (operator === 'BETWEEN') dateArr = [
        dateValue,
        dateValue
    ];
    else dateArr = [
        dateValue
    ];
    return dateArr.map((date, index)=>{
        // make sure we're adding numbers and not concatenating strings
        const dateInt = parseInt(date, 10);
        if (operator === 'AFTER' || operator === 'BETWEEN' && index === 1) return dateInt + 86400000 - 1; // Add 23 hours, 59 minutes, 59 seconds to get to end of day
        return dateInt;
    }).join(' ');
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#20
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b07607e1011a103f$var$handleSpecialCases = (rule)=>{
    let { value: value, operator: operator } = rule;
    const { type: type } = rule;
    if (Array.isArray(value)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const encodedValues = [];
        value.forEach((val)=>{
            // additional level of encoding for spaces because otherwise the spaces
            // will be mistaken for value delimiters (STRM-1857); escape space as "_"
            // and escape any existing "_" as "\_"
            encodedValues.push(val.replace(/_/g, '\\_').replace(/ /g, '_'));
        });
        value = encodedValues.join(' ');
    }
    if (type === 'date') {
        if (operator === 'is') // back end doesn't support "IS", we have to turn it into a between
        operator = 'between';
        value = $b07607e1011a103f$var$getDateValue(value, operator);
        // We had some problems getting the date values
        // Return empty rule so it won't be included
        if (value.indexOf('NaN') !== -1) return {};
    } else if (type === 'list' || type === 'user') {
        // allow comma-separated values (in addition to space separated) for issue keys and usernames
        value = value.replace(/,/g, ' ');
        // escape underscores as "\_" (because "_" is used to escape spaces in lists)
        value = value.replace(/_/g, '\\_');
    }
    return {
        value: value,
        operator: operator
    };
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#651-683
const $b07607e1011a103f$var$getParamsFromRules = (rules)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params = {};
    const providers = JSON.parse(decodeURIComponent(rules.replace(/&#([0-9]+);/g, $b07607e1011a103f$var$replacer)))?.providers || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const enabledProviders = [];
    // @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    providers.forEach((provider)=>{
        const providerKey = provider.provider;
        const { rules: providerRules } = provider;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stringifiedRules = [];
        if (!provider.disabled) {
            if (providerKey !== 'streams') enabledProviders.push(providerKey);
            // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
            providerRules.forEach((rule)=>{
                const modifiedRuleObj = $b07607e1011a103f$var$handleSpecialCases(rule);
                const { operator: operator, value: value } = modifiedRuleObj;
                if (operator && value) stringifiedRules.push([
                    rule.rule,
                    operator.toUpperCase(),
                    value
                ].join(' '));
            });
            params[providerKey] = stringifiedRules;
        }
    });
    if (enabledProviders.length < providers.length - 1) params.providers = enabledProviders.join(' ');
    return params;
};
const $b07607e1011a103f$export$3d7deb7cf8a9de04 = (gadget)=>{
    const prefs = Object.fromEntries(gadget.userPrefs?.fields.map((field)=>[
            field.name,
            field.value
        ]) ?? []);
    const params = {
        maxResults: prefs.numofentries ?? 25,
        relativeLinks: true,
        ...prefs.rules ? $b07607e1011a103f$var$getParamsFromRules(prefs.rules) : {}
    };
    // Gadget encodes spaces as '+', rather than '%20'.  Need to replace here to match URL exactly.
    return (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(params).replace(/%20/g, '+');
};
const $b07607e1011a103f$var$ACTIVITY_STREAM_REST_URL = 'plugins/servlet/streams';
const $b07607e1011a103f$export$360928f5bf059a9e = (gadgetData)=>{
    const paramStr = $b07607e1011a103f$export$3d7deb7cf8a9de04(gadgetData);
    return [
        `/${$b07607e1011a103f$var$ACTIVITY_STREAM_REST_URL}?${paramStr}`
    ];
};

});

parcelRegister("6jPL6", function(module, exports) {

$parcel$export(module.exports, "getFilterResultsPrefetchLink", () => $7db50436578c14e4$export$947cd90004054337);

var $53ciZ = parcelRequire("53ciZ");
const $7db50436578c14e4$var$FILTER_RESULTS_REST_URL = 'rest/gadget/1.0/issueTable';
const $7db50436578c14e4$export$947cd90004054337 = (gadgetData)=>{
    const { properties: properties } = gadgetData.context.dashboardItem;
    const data = {
        num: properties.num,
        tableContext: 'jira.table.cols.dashboard',
        addDefault: false,
        columnNames: typeof properties.columnNames === 'string' ? properties.columnNames.split('|') : undefined,
        enableSorting: true,
        paging: true,
        showActions: true,
        filterId: undefined,
        jql: undefined,
        sortBy: String(properties.sortBy && properties.sortBy !== '' ? properties.sortBy : null),
        startIndex: properties.startIndex ? properties.startIndex : 0
    };
    let queryType = '';
    if (properties.filterId) {
        queryType = 'filter';
        Object.assign(data, {
            filterId: properties.filterId
        });
    } else if (properties.jql) {
        queryType = 'jql';
        Object.assign(data, {
            jql: properties.jql
        });
    }
    // IMPORTANT - type definitions are incorrect, sort is definitely an option
    // @see https://www.npmjs.com/package/query-string/v/5.1.0
    // @ts-expect-error - TS2345 - Argument of type '{ sort: boolean; }' is not assignable to parameter of type 'StringifyOptions'.
    const paramStr = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(data, {
        sort: false
    }).replace(/%20/g, '+');
    const preloadUrl = `/${$7db50436578c14e4$var$FILTER_RESULTS_REST_URL}/${queryType}?${paramStr}`;
    return [
        preloadUrl
    ];
};

});




parcelRegister("hPXQA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb5155fc87e6d561$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bb5155fc87e6d561$export$2e2bcd8739ae039 = (response)=>{
    let resourceHtml = `
        <script type="text/javascript" data-defer-skip>
            window.WRM=window.WRM||{};window.WRM._unparsedData=window.WRM._unparsedData||{};window.WRM._unparsedErrors=window.WRM._unparsedErrors||{};
            WRM._unparsedData = Object.assign({}, WRM._unparsedData, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedData))}));
            WRM._unparsedErrors = Object.assign({}, WRM._unparsedErrors, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedErrors))}));
            if(window.WRM._dataArrived)window.WRM._dataArrived();
        </script>
    `;
    response.resources.forEach((resource)=>{
        const { url: url, resourceType: resourceType, key: key } = resource;
        if (resourceType === 'CSS') {
            const cssResource = `<link
                href=${url}
                type="text/css"
                rel="stylesheet"
                media="all"
                data-wrm-key=${key}
                data-wrm-batch-type="context"
            />`;
            resourceHtml += cssResource;
        } else {
            const jsResource = `<div>
                <script
                    type="text/javascript"
                    data-initially-rendered
                    data-defer-skip
                    src=${url}
                    data-wrm-key=${key}
                    data-wrm-batch-type="context"
                ></script>
            </div>`;
            resourceHtml += jsResource;
        }
    });
    return resourceHtml;
};

});

parcelRegister("g8TlX", function(module, exports) {

$parcel$export(module.exports, "gadgetsToUniqueSortedAmdModules", () => $e7764e486e4d14ca$export$598e0ea2a7525181);
$parcel$export(module.exports, "gadgetsToSortedReactGadgets", () => $e7764e486e4d14ca$export$f98787198c197952);
// eslint-disable-next-line jira/import-whitelist

var $kEBPk = parcelRequire("kEBPk");

var $iFHrw = parcelRequire("iFHrw");
const $e7764e486e4d14ca$export$598e0ea2a7525181 = (gadgets)=>gadgets // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .map(({ amdModule: amdModule })=>amdModule) // validated below
    .filter(Boolean).filter((amdModule)=>amdModule in (0, $kEBPk.WEB_RESOURCE_MAP)).filter((v, i, a)=>a.indexOf(v) === i).sort() ?? [];
const $e7764e486e4d14ca$export$f98787198c197952 = (gadgets)=>gadgets.reduce((gadgetsAccumulator, gadget)=>{
        if (!(0, $iFHrw.isReactKey)(gadget.reactKey)) return gadgetsAccumulator;
        gadgetsAccumulator.push({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            reactKey: gadget.reactKey,
            id: gadget.id,
            userPrefs: gadget.userPrefs
        });
        return gadgetsAccumulator;
    }, []).sort((a, b)=>a.id.localeCompare(b.id));

});
parcelRegister("iFHrw", function(module, exports) {

$parcel$export(module.exports, "isReactKey", () => $3b605fb0be8c3f62$export$6acd06c99f745b49);
$parcel$export(module.exports, "default", () => $3b605fb0be8c3f62$export$2e2bcd8739ae039);

var $9aBQb = parcelRequire("9aBQb");

var $c4zGv = parcelRequire("c4zGv");

var $4j3xD = parcelRequire("4j3xD");
/** This is a gadgets definition file.  */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3b605fb0be8c3f62$var$GADGETS_DEFINITION = {
    [(0, $4j3xD.REACT_KEY).FILTER_RESULTS]: (0, $c4zGv.FILTER_RESULTS_DEFINITION),
    [(0, $4j3xD.REACT_KEY).ASSIGNED_TO_ME]: (0, $c4zGv.ASSIGNED_TO_ME_DEFINITION),
    [(0, $4j3xD.REACT_KEY).ISSUES_IN_PROGRESS]: (0, $c4zGv.ISSUES_IN_PROGRESS_DEFINITION),
    [(0, $4j3xD.REACT_KEY).VOTED_ISSUES]: (0, $c4zGv.VOTED_ISSUES_DEFINITION),
    [(0, $4j3xD.REACT_KEY).WATCHED_ISSUES]: (0, $c4zGv.WATCHED_ISSUES_DEFINITION),
    [(0, $4j3xD.REACT_KEY).CUSTOM_REPORT]: (0, $9aBQb.default)
};
function $3b605fb0be8c3f62$export$6acd06c99f745b49(key) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return !!(key && Object.values((0, $4j3xD.REACT_KEY)).includes(key));
}
var $3b605fb0be8c3f62$export$2e2bcd8739ae039 = $3b605fb0be8c3f62$var$GADGETS_DEFINITION;

});
parcelRegister("9aBQb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc73a205ebc62f2$export$2e2bcd8739ae039);

var $9lS1T = parcelRequire("9lS1T");

var $kfew2 = parcelRequire("kfew2");

var $3tTwM = parcelRequire("3tTwM");
const $9fc73a205ebc62f2$var$CUSTOM_REPORT_DEFINITION = {
    componentView: (0, $kfew2.LazyCustomReportGadgetView),
    componentEdit: (0, $9lS1T.LazyCustomReportGadgetEdit),
    getInitialState: $3tTwM.default,
    preload: $kfew2.preload
};
var $9fc73a205ebc62f2$export$2e2bcd8739ae039 = $9fc73a205ebc62f2$var$CUSTOM_REPORT_DEFINITION;

});
parcelRegister("9lS1T", function(module, exports) {

$parcel$export(module.exports, "LazyCustomReportGadgetEdit", () => $1c5d73db0512d5f4$export$475e4a6fb8f40116);

var $6VZoe = parcelRequire("6VZoe");

const $1c5d73db0512d5f4$export$475e4a6fb8f40116 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("iPomm")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/edit/main.tsx"
});

});
parcelRegister("iPomm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("hOeaP")
]).then(()=>parcelRequire('anx4a'));

});


parcelRegister("kfew2", function(module, exports) {

$parcel$export(module.exports, "LazyCustomReportGadgetView", () => $67f7de289ccacfb7$export$27df795d4f3ff173);
$parcel$export(module.exports, "preload", () => $67f7de289ccacfb7$export$513ccb98c53b8039);

var $6VZoe = parcelRequire("6VZoe");

const $67f7de289ccacfb7$export$27df795d4f3ff173 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("as4EX")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/view/main.tsx"
});
const { preload: $67f7de289ccacfb7$export$513ccb98c53b8039 } = $67f7de289ccacfb7$export$27df795d4f3ff173;

});
parcelRegister("as4EX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kgy4b").then(()=>parcelRequire('dOaCr'));

});


parcelRegister("3tTwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $53772c7af9239b80$export$2e2bcd8739ae039);
const $53772c7af9239b80$var$getInitialState = ()=>Promise.resolve({
        intervalValue: '1',
        isCustom: 'false',
        projectValue: '0',
        refresh: 'false',
        reportValue: '0',
        gadgetContentTitle: ''
    });
var $53772c7af9239b80$export$2e2bcd8739ae039 = $53772c7af9239b80$var$getInitialState;

});


parcelRegister("c4zGv", function(module, exports) {

$parcel$export(module.exports, "FILTER_RESULTS_DEFINITION", () => $fe8974f560fb24c4$export$3581891d04da6bb8);
$parcel$export(module.exports, "ASSIGNED_TO_ME_DEFINITION", () => $fe8974f560fb24c4$export$652d5a9cc2c18d2e);
$parcel$export(module.exports, "ISSUES_IN_PROGRESS_DEFINITION", () => $fe8974f560fb24c4$export$54b46348d1ed5d22);
$parcel$export(module.exports, "VOTED_ISSUES_DEFINITION", () => $fe8974f560fb24c4$export$ea96ce30d34ce354);
$parcel$export(module.exports, "WATCHED_ISSUES_DEFINITION", () => $fe8974f560fb24c4$export$5109728db227eae);

var $eUqFw = parcelRequire("eUqFw");

var $89od6 = parcelRequire("89od6");

var $dEBc2 = parcelRequire("dEBc2");

var $39pd1 = parcelRequire("39pd1");

var $7bxc3 = parcelRequire("7bxc3");

var $5t0mU = parcelRequire("5t0mU");

var $1LSbo = parcelRequire("1LSbo");

var $a5B6h = parcelRequire("a5B6h");
const $fe8974f560fb24c4$var$componentViewWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $fe8974f560fb24c4$var$componentEditWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $fe8974f560fb24c4$var$FILTER_RESULTS_CONFIG = {
    testId: 'react-issue-table-gadgets.filter-results.view'
};
const $fe8974f560fb24c4$export$3581891d04da6bb8 = {
    componentView: $fe8974f560fb24c4$var$componentViewWithAdditionalState((0, $7bxc3.IssueTableGadgetView), $fe8974f560fb24c4$var$FILTER_RESULTS_CONFIG),
    componentEdit: (0, $dEBc2.FilterResultsGadgetEdit),
    getInitialState: (0, $a5B6h.default)($fe8974f560fb24c4$var$FILTER_RESULTS_CONFIG),
    preload: (0, $7bxc3.preload)
};
const $fe8974f560fb24c4$var$ASSIGNED_TO_ME_CONFIG = {
    predeterminedJql: 'assignee = currentUser() AND statusCategory != 3 ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.assigned-to-me.view'
};
const $fe8974f560fb24c4$export$652d5a9cc2c18d2e = {
    componentView: $fe8974f560fb24c4$var$componentViewWithAdditionalState((0, $7bxc3.IssueTableGadgetView), $fe8974f560fb24c4$var$ASSIGNED_TO_ME_CONFIG),
    componentEdit: $fe8974f560fb24c4$var$componentEditWithAdditionalState((0, $89od6.AssignedToMeGadgetEdit), $fe8974f560fb24c4$var$ASSIGNED_TO_ME_CONFIG),
    getInitialState: (0, $a5B6h.default)($fe8974f560fb24c4$var$ASSIGNED_TO_ME_CONFIG),
    preload: (0, $7bxc3.preload)
};
const $fe8974f560fb24c4$var$ISSUES_IN_PROGRESS_CONFIG = {
    predeterminedJql: 'status = "In Progress" AND statusCategory != Done AND assignee = currentUser() ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.issues-in-progress.view'
};
const $fe8974f560fb24c4$export$54b46348d1ed5d22 = {
    componentView: $fe8974f560fb24c4$var$componentViewWithAdditionalState((0, $7bxc3.IssueTableGadgetView), $fe8974f560fb24c4$var$ISSUES_IN_PROGRESS_CONFIG),
    componentEdit: $fe8974f560fb24c4$var$componentEditWithAdditionalState((0, $39pd1.IssuesInProgressGadgetEdit), $fe8974f560fb24c4$var$ISSUES_IN_PROGRESS_CONFIG),
    getInitialState: (0, $a5B6h.default)($fe8974f560fb24c4$var$ISSUES_IN_PROGRESS_CONFIG),
    preload: (0, $7bxc3.preload)
};
const $fe8974f560fb24c4$var$VOTED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in votedIssues() AND statusCategory != Done ORDER BY votes DESC',
    predeterminedJqlIncludeResolved: 'issue in votedIssues() ORDER BY votes DESC',
    defaultSortPrefs: {
        field: 'votes',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.voted-issues.view'
};
const $fe8974f560fb24c4$export$ea96ce30d34ce354 = {
    componentView: $fe8974f560fb24c4$var$componentViewWithAdditionalState((0, $7bxc3.IssueTableGadgetView), $fe8974f560fb24c4$var$VOTED_ISSUES_CONFIG),
    componentEdit: $fe8974f560fb24c4$var$componentEditWithAdditionalState((0, $5t0mU.VotedIssuesGadgetEdit), $fe8974f560fb24c4$var$VOTED_ISSUES_CONFIG),
    getInitialState: (0, $a5B6h.default)($fe8974f560fb24c4$var$VOTED_ISSUES_CONFIG),
    preload: (0, $7bxc3.preload)
};
const $fe8974f560fb24c4$var$WATCHED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in watchedIssues() AND statusCategory != Done ORDER BY watchers DESC',
    predeterminedJqlIncludeResolved: 'issue in watchedIssues() ORDER BY watchers DESC',
    defaultSortPrefs: {
        field: 'watchers',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.watched-issues.view'
};
const $fe8974f560fb24c4$export$5109728db227eae = {
    componentView: $fe8974f560fb24c4$var$componentViewWithAdditionalState((0, $7bxc3.IssueTableGadgetView), $fe8974f560fb24c4$var$WATCHED_ISSUES_CONFIG),
    componentEdit: $fe8974f560fb24c4$var$componentEditWithAdditionalState((0, $1LSbo.WatchedIssuesGadgetEdit), $fe8974f560fb24c4$var$WATCHED_ISSUES_CONFIG),
    getInitialState: (0, $a5B6h.default)($fe8974f560fb24c4$var$WATCHED_ISSUES_CONFIG),
    preload: (0, $7bxc3.preload)
};

});
parcelRegister("89od6", function(module, exports) {

$parcel$export(module.exports, "AssignedToMeGadgetEdit", () => $721813e04c285890$export$3ae3568d16dc8f35);

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");

var $qZD11 = parcelRequire("qZD11");

var $6VZoe = parcelRequire("6VZoe");

const $721813e04c285890$var$LazyAssignedToMeGadgetEdit = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("kGxy4")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/assigned-to-me/edit/main.tsx"
});
const $721813e04c285890$export$3ae3568d16dc8f35 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "assigned-to-me-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qZD11.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($721813e04c285890$var$LazyAssignedToMeGadgetEdit, props));
const { preload: $721813e04c285890$export$513ccb98c53b8039 } = $721813e04c285890$var$LazyAssignedToMeGadgetEdit;

});
parcelRegister("qZD11", function(module, exports) {

$parcel$export(module.exports, "FilterResultsEditSkeleton", () => $0b5156980e63e31e$export$e10d91ce257e7374);
/* filter-results-edit.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $6QrYb = parcelRequire("6QrYb");
const $0b5156980e63e31e$var$customCssStyles = null;
const $0b5156980e63e31e$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT = '698px';
const $0b5156980e63e31e$export$e10d91ce257e7374 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6QrYb))),
        containerStyles: {
            height: $0b5156980e63e31e$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT
        },
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("6QrYb", function(module, exports) {
module.exports = new URL("filter-results-edit-skeleton.tpl.783fb7b7.svg", import.meta.url).toString();

});


parcelRegister("kGxy4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("lul3e")
]).then(()=>parcelRequire('kQk64'));

});


parcelRegister("dEBc2", function(module, exports) {

$parcel$export(module.exports, "FilterResultsGadgetEdit", () => $b5f40a0f18e4302a$export$6dfceca003c43832);

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");

var $qZD11 = parcelRequire("qZD11");

var $6VZoe = parcelRequire("6VZoe");

const $b5f40a0f18e4302a$var$LazyFilterResultsGadgetEdit = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("bJWHg")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/filter-results/edit/main.tsx"
});
const $b5f40a0f18e4302a$export$6dfceca003c43832 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "filter-results-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qZD11.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5f40a0f18e4302a$var$LazyFilterResultsGadgetEdit, props));
const { preload: $b5f40a0f18e4302a$export$513ccb98c53b8039 } = $b5f40a0f18e4302a$var$LazyFilterResultsGadgetEdit;

});
parcelRegister("bJWHg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("l7OFb")
]).then(()=>parcelRequire('3LebM'));

});


parcelRegister("39pd1", function(module, exports) {

$parcel$export(module.exports, "IssuesInProgressGadgetEdit", () => $8fd8607cd190e208$export$199fec410a0f70a2);

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");

var $qZD11 = parcelRequire("qZD11");

var $6VZoe = parcelRequire("6VZoe");

const $8fd8607cd190e208$var$LazyIssuesInProgressGadgetEdit = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("l8Tg6")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/issues-in-progress/edit/main.tsx"
});
const $8fd8607cd190e208$export$199fec410a0f70a2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issues-in-progress-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qZD11.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fd8607cd190e208$var$LazyIssuesInProgressGadgetEdit, props));
const { preload: $8fd8607cd190e208$export$513ccb98c53b8039 } = $8fd8607cd190e208$var$LazyIssuesInProgressGadgetEdit;

});
parcelRegister("l8Tg6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("dRapt")
]).then(()=>parcelRequire('4DUDi'));

});


parcelRegister("7bxc3", function(module, exports) {

$parcel$export(module.exports, "IssueTableGadgetView", () => $206dcc7b0a4c31d4$export$da0765a3c10e16a3);
$parcel$export(module.exports, "preload", () => $206dcc7b0a4c31d4$export$513ccb98c53b8039);

var $eUqFw = parcelRequire("eUqFw");

var $kEBPk = parcelRequire("kEBPk");

var $gGtKh = parcelRequire("gGtKh");

var $fuBtH = parcelRequire("fuBtH");

var $6VZoe = parcelRequire("6VZoe");

const $206dcc7b0a4c31d4$var$LazyIssueTableGadgetView = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("hTUD9")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/view/main.tsx"
});
const $206dcc7b0a4c31d4$export$da0765a3c10e16a3 = ({ customSkeletonHeightInPx: customSkeletonHeightInPx, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "filter-results-gadget-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fuBtH.FilterResultsIssueTableSkeleton), {
            height: `${customSkeletonHeightInPx ?? (0, $kEBPk.GADGET_DEFAULT_HEIGHT)}px`
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($206dcc7b0a4c31d4$var$LazyIssueTableGadgetView, {
        customSkeletonHeightInPx: customSkeletonHeightInPx,
        ...props
    }));
const { preload: $206dcc7b0a4c31d4$export$513ccb98c53b8039 } = $206dcc7b0a4c31d4$var$LazyIssueTableGadgetView;

});
parcelRegister("fuBtH", function(module, exports) {

$parcel$export(module.exports, "FilterResultsIssueTableSkeleton", () => $431e2d429e482a98$export$35d754053deeac73);
/* filter-results-issue-table.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $fDbBV = parcelRequire("fDbBV");
const $431e2d429e482a98$var$customCssStyles = null;
const $431e2d429e482a98$export$35d754053deeac73 = ({ height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fDbBV))),
        containerStyles: {
            height: height
        },
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("fDbBV", function(module, exports) {
module.exports = new URL("filter-results-issue-table-skeleton.tpl.a502204a.svg", import.meta.url).toString();

});


parcelRegister("hTUD9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("lSuz7")
]).then(()=>parcelRequire('f8xvH'));

});


parcelRegister("5t0mU", function(module, exports) {

$parcel$export(module.exports, "VotedIssuesGadgetEdit", () => $714a6d6a762522de$export$7650b85a7a54914);

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");

var $qZD11 = parcelRequire("qZD11");

var $6VZoe = parcelRequire("6VZoe");

const $714a6d6a762522de$var$LazyVotedIssuesGadgetEdit = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("64MNZ")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/voted-issues/edit/main.tsx"
});
const $714a6d6a762522de$export$7650b85a7a54914 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "voted-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qZD11.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($714a6d6a762522de$var$LazyVotedIssuesGadgetEdit, props));
const { preload: $714a6d6a762522de$export$513ccb98c53b8039 } = $714a6d6a762522de$var$LazyVotedIssuesGadgetEdit;

});
parcelRegister("64MNZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("98s5n")
]).then(()=>parcelRequire('ggY4A'));

});


parcelRegister("1LSbo", function(module, exports) {

$parcel$export(module.exports, "WatchedIssuesGadgetEdit", () => $bee6a000695cf051$export$a53864bd0bf8a85f);

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");

var $qZD11 = parcelRequire("qZD11");

var $6VZoe = parcelRequire("6VZoe");

const $bee6a000695cf051$var$LazyWatchedIssuesGadgetEdit = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("gTs4I")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/watched-issues/edit/main.tsx"
});
const $bee6a000695cf051$export$a53864bd0bf8a85f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "watched-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qZD11.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bee6a000695cf051$var$LazyWatchedIssuesGadgetEdit, props));
const { preload: $bee6a000695cf051$export$513ccb98c53b8039 } = $bee6a000695cf051$var$LazyWatchedIssuesGadgetEdit;

});
parcelRegister("gTs4I", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("3sjfY")
]).then(()=>parcelRequire('2wBw8'));

});


parcelRegister("a5B6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $233a220e67ded364$export$2e2bcd8739ae039);

var $crAWe = parcelRequire("crAWe");

var $5eBoI = parcelRequire("5eBoI");

var $hZVoZ = parcelRequire("hZVoZ");

var $CGXJj = parcelRequire("CGXJj");
const $233a220e67ded364$var$createGetInitialState = ({ predeterminedJql: predeterminedJql, predeterminedJqlIncludeResolved: predeterminedJqlIncludeResolved, defaultSortPrefs: defaultSortPrefs, testId: testId })=>async (resourceContext, userPrefs)=>{
        if (resourceContext?.tenantContext == null) throw new Error('Tenant context is not available');
        const { cloudId: cloudId, activationId: activationId } = resourceContext.tenantContext;
        const validUserPrefs = (0, $CGXJj.transformToValidUserPrefs)((0, $crAWe.decodeUserPreferences)(userPrefs));
        if (validUserPrefs.filterId === undefined && predeterminedJql === undefined && predeterminedJqlIncludeResolved === undefined) throw new Error('FilterId or JQL has to be available to be able to load the gadget initial state');
        const sortPrefs = (()=>{
            if (validUserPrefs.sortField) return {
                sortField: validUserPrefs.sortField,
                sortDirection: validUserPrefs.sortDirection
            };
            if (defaultSortPrefs) return {
                sortField: defaultSortPrefs.field,
                sortDirection: defaultSortPrefs.direction
            };
        })();
        const includeResolved = validUserPrefs.showResolved;
        const jql = includeResolved ? predeterminedJqlIncludeResolved : predeterminedJql;
        const queryReference = await (0, $hZVoZ.loadQueryWithUserPrefs)({
            ...validUserPrefs,
            ...sortPrefs
        }, (0, $5eBoI.default), cloudId, activationId, 'store-and-network', jql);
        return {
            queryReference: queryReference,
            predeterminedJql: predeterminedJql,
            defaultSortPrefs: defaultSortPrefs,
            testId: testId
        };
    };
var $233a220e67ded364$export$2e2bcd8739ae039 = $233a220e67ded364$var$createGetInitialState;

});
parcelRegister("crAWe", function(module, exports) {

$parcel$export(module.exports, "getUserPreferences", () => $080e9776d65a8494$export$ae3f5fa351e2f57a);
$parcel$export(module.exports, "decodeUserPreferences", () => $080e9776d65a8494$export$ebdfc6c2778ef8e2);

var $2OdyW = parcelRequire("2OdyW");
const $080e9776d65a8494$var$isBooleanString = (str)=>[
        'true',
        'false'
    ].includes(str.toLowerCase().trim());
const $080e9776d65a8494$var$stringToBoolean = (str)=>str.toLowerCase().trim() === 'true';
const $080e9776d65a8494$export$ae3f5fa351e2f57a = (action)=>(0, $2OdyW.default)(action);
const $080e9776d65a8494$export$ebdfc6c2778ef8e2 = (userPreferences = [])=>userPreferences.reduce((output, { value: value, name: name })=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...output,
            [name]: $080e9776d65a8494$var$isBooleanString(value) ? $080e9776d65a8494$var$stringToBoolean(value) : value
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});

});

parcelRegister("5eBoI", function(module, exports) {

$parcel$export(module.exports, "default", () => $06ce214e6711bffc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7f6dd8ab2cdd7ffd92e9a8bf07da2096>>
 * @relayHash 072c2d3cfbcc6aafbcb9ba4ac0a20463
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e85d6cfb807d294bd42503fb58b972262f39c2a071475c9ef619eca3d10d5a6

var $dbXJb = parcelRequire("dbXJb");

var $6aQ5B = parcelRequire("6aQ5B");

var $57iDA = parcelRequire("57iDA");

var $91oFA = parcelRequire("91oFA");

var $9u07e = parcelRequire("9u07e");
const $06ce214e6711bffc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNotFilterFetch"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryStatusForIssuekeyStrikethrough"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v13 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "id"
    }, v16 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v17 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v18 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v19 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v18 /*: any*/ ,
            v15 /*: any*/ 
        ]
    }, v20 = {
        "kind": "Variable",
        "name": "fieldSetIds",
        "variableName": "fieldSetIds"
    }, v21 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v22 = {
        "kind": "ScalarField",
        "name": "type"
    }, v23 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v24 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v25 = {
        "kind": "ScalarField",
        "name": "name"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v25 /*: any*/ ,
                                    v15 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v28 = [
        v25 /*: any*/ ,
        v15 /*: any*/ 
    ], v29 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v28 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    }, v30 = {
        "kind": "ScalarField",
        "name": "date"
    }, v31 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v33 = {
        "kind": "ClientExtension",
        "selections": [
            v32 /*: any*/ 
        ]
    }, v34 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "dateTime"
            }
        ],
        "type": "JiraDateTimePickerField"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v14 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "summary"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v36 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v37 = {
        "kind": "ScalarField",
        "name": "text"
    }, v38 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    v18 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v39 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v19 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v40 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v41 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1000
            }
        ],
        "concreteType": "JiraLabelConnection",
        "kind": "LinkedField",
        "name": "selectedLabelsConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraLabelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraLabel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v25 /*: any*/ 
                        ]
                    }
                ]
            },
            v40 /*: any*/ 
        ],
        "storageKey": "selectedLabelsConnection(first:1000)"
    }, v42 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "small"
                            }
                        ]
                    },
                    v25 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v43 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v44 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v14 /*: any*/ ,
                    {
                        "concreteType": "JiraSingleLineTextField",
                        "kind": "LinkedField",
                        "name": "summaryField",
                        "plural": false,
                        "selections": [
                            v37 /*: any*/ ,
                            v15 /*: any*/ 
                        ]
                    },
                    v15 /*: any*/ ,
                    {
                        "concreteType": "JiraColorField",
                        "kind": "LinkedField",
                        "name": "issueColorField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "color",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "colorKey"
                                    },
                                    v15 /*: any*/ 
                                ]
                            },
                            v15 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v43 /*: any*/ ,
                                    v25 /*: any*/ ,
                                    v15 /*: any*/ 
                                ]
                            },
                            v15 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v45 = {
        "concreteType": "JiraPriority",
        "kind": "LinkedField",
        "name": "priority",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            v15 /*: any*/ 
        ]
    }, v46 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    v14 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v47 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v28 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v48 = {
        "concreteType": "JiraSprintConnection",
        "kind": "LinkedField",
        "name": "selectedSprintsConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraSprintEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v15 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "sprintId"
                            },
                            v25 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "state"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "endDate"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v49 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "accountId"
            },
            {
                "kind": "ScalarField",
                "name": "picture"
            },
            v25 /*: any*/ ,
            v15 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "accountStatus"
            }
        ]
    }, v50 = {
        "kind": "InlineFragment",
        "selections": [
            v25 /*: any*/ ,
            {
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v28 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v51 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "json"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v52 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    v43 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v53 = [
        v40 /*: any*/ 
    ], v54 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasNextPage"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v53 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "webUrl"
                                            },
                                            v14 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v16 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v19 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v15 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v15 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v15 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueLinkField"
    }, v55 = {
        "kind": "ScalarField",
        "name": "isStoryPointField"
    }, v56 = {
        "kind": "ScalarField",
        "name": "number"
    }, v57 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v30 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v31 /*: any*/ ,
                                                        v33 /*: any*/ 
                                                    ],
                                                    "type": "JiraDatePickerField"
                                                },
                                                v34 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v33 /*: any*/ 
                                                    ],
                                                    "type": "JiraSingleLineTextField"
                                                },
                                                v38 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v41 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v33 /*: any*/ 
                                                    ],
                                                    "type": "JiraLabelsField"
                                                },
                                                v42 /*: any*/ ,
                                                v44 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v33 /*: any*/ 
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                v46 /*: any*/ ,
                                                v47 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v48 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v33 /*: any*/ 
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v49 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v31 /*: any*/ ,
                                                        v33 /*: any*/ 
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                v50 /*: any*/ ,
                                                v51 /*: any*/ ,
                                                v52 /*: any*/ ,
                                                v54 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v55 /*: any*/ ,
                                                                v56 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                v33 /*: any*/ 
                                                            ],
                                                            "type": "JiraNumberField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v58 = {
        "condition": "shouldQueryFieldSetsById",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v20 /*: any*/ ,
                    v21 /*: any*/ 
                ],
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsById",
                "plural": false,
                "selections": v57 /*: any*/ 
            }
        ]
    }, v59 = {
        "condition": "shouldQueryFieldSetsById",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "filterId",
                        "variableName": "filterId"
                    },
                    v21 /*: any*/ ,
                    {
                        "kind": "Variable",
                        "name": "namespace",
                        "variableName": "namespace"
                    },
                    {
                        "kind": "Variable",
                        "name": "viewId",
                        "variableName": "viewId"
                    }
                ],
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsForIssueSearchView",
                "plural": false,
                "selections": v57 /*: any*/ 
            }
        ]
    }, v60 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ], v61 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueTableViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issueTableView_reactIssueTableGadgets"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v12 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v11 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ ,
                v10 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueTableViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                v13 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                },
                                                {
                                                    "condition": "queryStatusForIssuekeyStrikethrough",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isResolved"
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v16 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                v15 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                v15 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        v58 /*: any*/ ,
                                                        v59 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v58 /*: any*/ ,
                                                        v59 /*: any*/ ,
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueRowFieldSets",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v22 /*: any*/ ,
                                                                                        v23 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fields",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v16 /*: any*/ ,
                                                                                                                v17 /*: any*/ ,
                                                                                                                v22 /*: any*/ ,
                                                                                                                v24 /*: any*/ ,
                                                                                                                v15 /*: any*/ ,
                                                                                                                v26 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                v29 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v30 /*: any*/ ,
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v31 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraDatePickerField"
                                                                                                                },
                                                                                                                v34 /*: any*/ ,
                                                                                                                v35 /*: any*/ ,
                                                                                                                v36 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        v25 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                v38 /*: any*/ ,
                                                                                                                v39 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v41 /*: any*/ ,
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        v25 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraLabelsField"
                                                                                                                },
                                                                                                                v42 /*: any*/ ,
                                                                                                                v44 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        v45 /*: any*/ ,
                                                                                                                        v25 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraPriorityField"
                                                                                                                },
                                                                                                                v46 /*: any*/ ,
                                                                                                                v47 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        v48 /*: any*/ ,
                                                                                                                        v25 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSprintField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v49 /*: any*/ ,
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v31 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                v50 /*: any*/ ,
                                                                                                                v51 /*: any*/ ,
                                                                                                                v52 /*: any*/ ,
                                                                                                                v54 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v55 /*: any*/ ,
                                                                                                                                v56 /*: any*/ ,
                                                                                                                                v32 /*: any*/ ,
                                                                                                                                v25 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraNumberField"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "childIssues",
                                                            "plural": false,
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "activeProjectsOnly",
                                                                                    "value": true
                                                                                },
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 10
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "issues",
                                                                            "plural": false,
                                                                            "selections": v53 /*: any*/ ,
                                                                            "storageKey": "issues(activeProjectsOnly:true,first:10)"
                                                                        }
                                                                    ],
                                                                    "type": "JiraChildIssuesWithinLimit"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "pageSize",
                                            "variableName": "first"
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": v60 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": v60 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": v60 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                v13 /*: any*/ ,
                                v20 /*: any*/ 
                            ],
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v61 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jqlTerm"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isSortable"
                                                },
                                                {
                                                    "concreteType": "JiraFieldSetPreferences",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetPreferences",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "width"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraFieldType",
                                                    "kind": "LinkedField",
                                                    "name": "fieldType",
                                                    "plural": false,
                                                    "selections": [
                                                        v61 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v40 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "isNotFilterFetch",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        v15 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8e85d6cfb807d294bd42503fb58b972262f39c2a071475c9ef619eca3d10d5a6",
            "metadata": {},
            "name": "issueTableViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider": (0, $dbXJb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider": (0, $91oFA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider": (0, $9u07e.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider": (0, $57iDA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider": (0, $6aQ5B.default)
            }
        }
    };
}();
$06ce214e6711bffc$var$node.hash = "8fd85464be4174d6fd1b827fbd8d9839";
var $06ce214e6711bffc$export$2e2bcd8739ae039 = $06ce214e6711bffc$var$node;

});
parcelRegister("dbXJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $97fcddf57bcced87$export$2e2bcd8739ae039);

var $eI5EY = parcelRequire("eI5EY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$97fcddf57bcced87$export$2e2bcd8739ae039 = {
    get () {
        return (0, $eI5EY.fg)('jsc_-_m2_hierarchy_api_updates');
    }
};

});

parcelRegister("6aQ5B", function(module, exports) {

$parcel$export(module.exports, "default", () => $55978214963118e6$export$2e2bcd8739ae039);

var $eI5EY = parcelRequire("eI5EY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$55978214963118e6$export$2e2bcd8739ae039 = {
    get () {
        return (0, $eI5EY.fg)('nin-issue-links-entry-point') ? 1 : 1000;
    }
};

});

parcelRegister("57iDA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a729f1cacf0a0605$export$2e2bcd8739ae039);

var $eI5EY = parcelRequire("eI5EY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a729f1cacf0a0605$export$2e2bcd8739ae039 = {
    get () {
        return (0, $eI5EY.fg)('nin-issue-links-entry-point');
    }
};

});

parcelRegister("91oFA", function(module, exports) {

$parcel$export(module.exports, "default", () => $545e5b28ed76abc6$export$2e2bcd8739ae039);

var $eI5EY = parcelRequire("eI5EY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$545e5b28ed76abc6$export$2e2bcd8739ae039 = {
    get () {
        return (0, $eI5EY.fg)('jira_spreadsheet_component_m1_api_updates');
    }
};

});

parcelRegister("9u07e", function(module, exports) {

$parcel$export(module.exports, "default", () => $26921f5288605cf9$export$2e2bcd8739ae039);

var $eI5EY = parcelRequire("eI5EY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$26921f5288605cf9$export$2e2bcd8739ae039 = {
    get () {
        return (0, $eI5EY.fg)('nike_chin_story_points_inline_edit');
    }
};

});


parcelRegister("hZVoZ", function(module, exports) {

$parcel$export(module.exports, "loadQueryWithUserPrefs", () => $eb1425c029f76ab4$export$700e212b8b5c678f);

var $iWLL0 = parcelRequire("iWLL0");

var $amu7D = parcelRequire("amu7D");

var $c7ifG = parcelRequire("c7ifG");

var $9eS9n = parcelRequire("9eS9n");
async function $eb1425c029f76ab4$export$700e212b8b5c678f({ filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection }, query, cloudId, activationId, fetchPolicy = 'store-or-network', jql) {
    const { variables: variables } = await (0, $9eS9n.transformToVariables)({
        userPrefs: {
            filterId: filterId,
            columnNames: columnNames,
            num: num,
            sortField: sortField,
            sortDirection: sortDirection
        },
        cloudId: cloudId,
        activationId: activationId,
        jql: jql
    });
    const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default)(), query, variables, {
        fetchPolicy: fetchPolicy
    });
    if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
    return queryReference;
}

});
parcelRegister("9eS9n", function(module, exports) {

$parcel$export(module.exports, "transformToVariables", () => $5914f8e0c9e9a85b$export$a5cefa50115212b3);

var $3zsgO = parcelRequire("3zsgO");

var $eI5EY = parcelRequire("eI5EY");

var $a4IeB = parcelRequire("a4IeB");

var $23KAk = parcelRequire("23KAk");

var $UP3K4 = parcelRequire("UP3K4");



const $5914f8e0c9e9a85b$export$a5cefa50115212b3 = async ({ userPrefs: userPrefs, cloudId: cloudId, activationId: activationId, jql: jql, fetchIssueTableJqlFields: fetchIssueTableJqlFields })=>{
    const { filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection, showResolved: showResolved } = userPrefs;
    const filterAri = !jql && filterId ? (0, $3zsgO.JiraFilterAri).create({
        filterId: filterId,
        siteId: cloudId,
        activationId: activationId
    }).toString() : '';
    const variables = {
        cloudId: cloudId,
        issueSearchInput: {
            ...jql ? {
                jql: jql
            } : {
                filterId: filterId
            }
        },
        after: null,
        first: num,
        fieldSetIds: columnNames,
        amountOfColumns: (0, $a4IeB.MAX_COLUMNS),
        shouldQueryFieldSetsById: true,
        isNotFilterFetch: !filterAri,
        filterAri: filterAri,
        queryStatusForIssuekeyStrikethrough: (0, $eI5EY.fg)('jiv-18659-query-status-for-issuekey-strikethrough')
    };
    let fieldToJqlTermMap = new Map();
    if (!sortField || !sortDirection || ![
        'ASC',
        'DESC'
    ].includes(sortDirection)) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    let jqlToModify = jql;
    if (fetchIssueTableJqlFields && !jqlToModify && filterAri) {
        const result = await fetchIssueTableJqlFields(filterAri, variables.fieldSetIds, cloudId);
        fieldToJqlTermMap = result.fieldToJqlTermMap;
        jqlToModify = result.searchJql;
    }
    if (!jqlToModify) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    // This pulls in over 600KB of code, and if it's not deferred it's eagerly loaded as
    // part of the main jira-spa route map
    const [{ JqlUtils: JqlUtils }, { default: removeFieldClauseFromJql }, { default: findClauseInAst }] = await Promise.all([
        (parcelRequire("fZhtr")),
        (parcelRequire("7jIaG")),
        (parcelRequire("hbfV4"))
    ]);
    const jqlUtils = new JqlUtils();
    const jqlTermForSortField = (0, $UP3K4.getJqlTermForField)(sortField, fieldToJqlTermMap);
    const modifiedJql = jqlUtils.jql(jqlToModify);
    const oldPrimarySortField = modifiedJql.getPrimarySortField();
    if (oldPrimarySortField) {
        // if the sort field in original filter jql is using alias, we need to pass all possible aliases in
        // so that jqlUtils knows to replace it instead of append it as a new field
        const aliases = (0, $23KAk.getAliasesForField)(jqlTermForSortField, fieldToJqlTermMap);
        // Sometimes, oldPrimarySortField from the JQL has
        // quotations around it which we should include
        const inclusiveAliases = Array.from(new Set([
            ...aliases,
            oldPrimarySortField
        ]));
        modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, inclusiveAliases);
    } else modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, []);
    let finalJql = modifiedJql.jqlString;
    if (showResolved) {
        const jast = modifiedJql.jast;
        if (jast) {
            const statusClause = findClauseInAst(jast, 'statusCategory');
            if (statusClause) finalJql = removeFieldClauseFromJql(jast, statusClause);
        }
    }
    return {
        variables: {
            ...variables,
            issueSearchInput: {
                jql: finalJql
            }
        },
        fieldToJqlTermMap: fieldToJqlTermMap
    };
};

});
parcelRegister("a4IeB", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $842e422340bc7efd$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $842e422340bc7efd$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SORT_ASC", () => $842e422340bc7efd$export$88956207daf9a17e);
$parcel$export(module.exports, "SORT_DESC", () => $842e422340bc7efd$export$bc14f97913aaf2a);
$parcel$export(module.exports, "SORT_NONE", () => $842e422340bc7efd$export$9c424bf3e8ffe64e);
$parcel$export(module.exports, "MODIFY_COLUMNS", () => $842e422340bc7efd$export$1f921c78ce6d243c);
$parcel$export(module.exports, "REORDER_COLUMNS", () => $842e422340bc7efd$export$83371d6c41a974aa);
$parcel$export(module.exports, "MOVE_COLUMN_FIRST", () => $842e422340bc7efd$export$957d455bb65919d8);
$parcel$export(module.exports, "MOVE_COLUMN_LEFT", () => $842e422340bc7efd$export$2082861c970802b0);
$parcel$export(module.exports, "MOVE_COLUMN_RIGHT", () => $842e422340bc7efd$export$21847d308b0769ad);
$parcel$export(module.exports, "MOVE_COLUMN_LAST", () => $842e422340bc7efd$export$c32913bc261af82d);
$parcel$export(module.exports, "BORDER_WIDTH", () => $842e422340bc7efd$export$e2bd4c1faded7921);
$parcel$export(module.exports, "ROW_HEIGHT", () => $842e422340bc7efd$export$88e6c5bab2ff80e8);
$parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", () => $842e422340bc7efd$export$de4c02b525d877fa);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $842e422340bc7efd$export$c3266da279aa6b84);
$parcel$export(module.exports, "ACTION_COLUMNS", () => $842e422340bc7efd$export$3dbdc5c16825be4d);
$parcel$export(module.exports, "MAX_COLUMNS", () => $842e422340bc7efd$export$7ec4af037f372df4);
$parcel$export(module.exports, "CHILD_QUERY_PAGE_SIZE", () => $842e422340bc7efd$export$d2372dfbd4e91a11);
$parcel$export(module.exports, "KNOWN_COLUMN_TYPES", () => $842e422340bc7efd$export$bbc2e8c301f97f97);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $842e422340bc7efd$export$1adf7afff96bbf16);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", () => $842e422340bc7efd$export$5575b9e0ed3ff59f);
$parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", () => $842e422340bc7efd$export$7c3f559e2ca95fa);
$parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", () => $842e422340bc7efd$export$e1a42c2fefb5af25);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", () => $842e422340bc7efd$export$bfe09a9186b98f8f);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", () => $842e422340bc7efd$export$f2540f34b796306d);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", () => $842e422340bc7efd$export$954afb0fcf5a326);
$parcel$export(module.exports, "COLUMN_OPERATION_REORDER", () => $842e422340bc7efd$export$93758649595b2d58);
$parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", () => $842e422340bc7efd$export$cad8c6a0b6e78898);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", () => $842e422340bc7efd$export$754b76ac8fa63350);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", () => $842e422340bc7efd$export$fa5c7dad7ee16383);
$parcel$export(module.exports, "DENSITY_COMPACT", () => $842e422340bc7efd$export$6c0a5a77457ca62);
$parcel$export(module.exports, "DENSITY_FULL", () => $842e422340bc7efd$export$119d8ab9a5bc4b2);
$parcel$export(module.exports, "LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE", () => $842e422340bc7efd$export$9ef77944c441ad07);
$parcel$export(module.exports, "LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE", () => $842e422340bc7efd$export$c1f680390b97c9e1);
const $842e422340bc7efd$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
const $842e422340bc7efd$export$d57b6b390e78d90f = 'empanada';
const $842e422340bc7efd$export$88956207daf9a17e = 'ASC';
const $842e422340bc7efd$export$bc14f97913aaf2a = 'DESC';
const $842e422340bc7efd$export$9c424bf3e8ffe64e = 'NONE';
const $842e422340bc7efd$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
const $842e422340bc7efd$export$83371d6c41a974aa = 'REORDER_COLUMNS';
const $842e422340bc7efd$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
const $842e422340bc7efd$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
const $842e422340bc7efd$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
const $842e422340bc7efd$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
const $842e422340bc7efd$export$e2bd4c1faded7921 = '1px';
const $842e422340bc7efd$export$cdb7fd9d999c7168 = 40;
const $842e422340bc7efd$export$88e6c5bab2ff80e8 = 40;
const $842e422340bc7efd$export$d5120333bf67ced2 = ()=>"var(--ds-space-300, 24px)";
const $842e422340bc7efd$export$a3c854b50595c804 = ()=>"var(--ds-space-050, 4px)";
const $842e422340bc7efd$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $842e422340bc7efd$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $842e422340bc7efd$export$3dbdc5c16825be4d = [
    $842e422340bc7efd$export$c3266da279aa6b84,
    $842e422340bc7efd$export$de4c02b525d877fa
];
const $842e422340bc7efd$export$7ec4af037f372df4 = 500;
const $842e422340bc7efd$export$d2372dfbd4e91a11 = 50;
const $842e422340bc7efd$export$bbc2e8c301f97f97 = {
    ASSIGNEE: 'assignee',
    DESCRIPTION: 'description',
    ENVIRONMENT: 'environment',
    EXPAND_BUTTON: '__issuetable_internal_expand_button',
    ISSUE_KEY: 'issuekey',
    ISSUE_OPERATIONS: '__issuetable_internal_meatball',
    STATUS: 'status',
    SUMMARY: 'summary',
    ISSUE_TYPE: 'issuetype',
    RESOLUTION: 'resolution',
    PARENT: 'parent',
    LABELS: 'labels',
    COMPONENTS: 'components',
    FIX_VERSIONS: 'fixVersions',
    STATUS_CATEGORY: 'statusCategory',
    PROJECT: 'project',
    READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
    SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
    TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
    EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
    CREATED: 'created',
    RESOLUTION_DATE: 'resolutiondate',
    TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
    UPDATED: 'updated',
    DUE_DATE: 'duedate',
    REPORTER: 'reporter',
    CREATOR: 'creator',
    PRIORITY: 'priority',
    AFFECTS_VERSIONS: 'versions',
    REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin',
    NUMBER: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
    STORY_POINT_ESTIMATE: 'com.pyxis.greenhopper.jira:jsw-story-points'
};
const $842e422340bc7efd$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $842e422340bc7efd$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $842e422340bc7efd$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $842e422340bc7efd$export$5575b9e0ed3ff59f = 69; // 2 x 8px cell padding + 2 x 24px icon size + 4px gap + 1px border
const $842e422340bc7efd$export$7c3f559e2ca95fa = 170;
const $842e422340bc7efd$export$e1a42c2fefb5af25 = 999;
const $842e422340bc7efd$export$bfe09a9186b98f8f = 400;
const $842e422340bc7efd$export$f2540f34b796306d = 300;
const $842e422340bc7efd$export$954afb0fcf5a326 = 450;
const $842e422340bc7efd$export$93758649595b2d58 = 'reorder';
const $842e422340bc7efd$export$cad8c6a0b6e78898 = 'resize';
const $842e422340bc7efd$export$754b76ac8fa63350 = 'FULL_HEIGHT';
const $842e422340bc7efd$export$fa5c7dad7ee16383 = 'HEADER_ONLY';
const $842e422340bc7efd$export$6c0a5a77457ca62 = 'COMPACT';
const $842e422340bc7efd$export$119d8ab9a5bc4b2 = 'FULL';
const $842e422340bc7efd$export$9ef77944c441ad07 = 'LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE';
const $842e422340bc7efd$export$c1f680390b97c9e1 = 'LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE';

});

parcelRegister("23KAk", function(module, exports) {

$parcel$export(module.exports, "getAliasesForField", () => $10e5615908db763b$export$94d69942fbe58a01);
const $10e5615908db763b$export$94d69942fbe58a01 = (field, fieldToJqlTermMap)=>{
    // provided field could be a field id, name, an alias, or a jql term
    let term = fieldToJqlTermMap.get(field);
    if (term === undefined) {
        // it may be a jql term itself
        // filter is still an experiment feature in Iterator so we do old school looping
        for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === field) {
            term = keyValuePair[1];
            break;
        }
    }
    if (term === undefined) return [];
    // we do a reverse look-up to find any other keys of this jql term, they can all be used in a jql
    const set = new Set();
    set.add(term);
    for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === term) set.add(keyValuePair[0]);
    return Array.from(set);
};

});

parcelRegister("UP3K4", function(module, exports) {

$parcel$export(module.exports, "getJqlTermForField", () => $a7e138822615b5d1$export$ef4e8b2c9bc7bd4d);

var $kUSK3 = parcelRequire("kUSK3");
const $a7e138822615b5d1$export$ef4e8b2c9bc7bd4d = (field, fieldToJqlTermMap)=>{
    const convertedField = (0, $kUSK3.convertFieldToJqlTerm)(field);
    const jqlTermForField = fieldToJqlTermMap.get(convertedField) ?? convertedField;
    return jqlTermForField;
};

});
parcelRegister("kUSK3", function(module, exports) {

$parcel$export(module.exports, "convertFieldToJqlTerm", () => $7db5cc76eb07592b$export$29f734dc2c61ea9d);
const $7db5cc76eb07592b$export$29f734dc2c61ea9d = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    // fieldName match regex for customfield_<number> exactly
    // legacy gadget may have it stored as customfield_<number> in user prefs
    if (/^customfield_\d+$/.test(fieldName)) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    return fieldName;
};

});


parcelRegister("fZhtr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8tD1c").then(()=>parcelRequire('71TnQ'));

});

parcelRegister("7jIaG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7NMRE").then(()=>parcelRequire('9kcYg'));

});

parcelRegister("hbfV4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("a7tbS").then(()=>parcelRequire('bT7m3'));

});



parcelRegister("CGXJj", function(module, exports) {

$parcel$export(module.exports, "transformToValidUserPrefs", () => $9a5470c97e0d943a$export$e9345b021afd3cc3);

var $8fUPC = parcelRequire("8fUPC");

var $c4HBH = parcelRequire("c4HBH");

var $eUTZW = parcelRequire("eUTZW");
const $9a5470c97e0d943a$export$e9345b021afd3cc3 = (rawUserPrefs)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const pageSize = parseInt(rawUserPrefs.num, 10);
    const fieldSetIds = (0, $8fUPC.convertUserPrefsToColumnNames)(rawUserPrefs.columnNames);
    const stringifiedFilterId = `${rawUserPrefs.filterId}`;
    const { sortDirection: sortDirection, sortField: sortField } = (0, $c4HBH.getSortFieldAndDirection)(rawUserPrefs.sortBy);
    const showResolved = !!rawUserPrefs.showResolved;
    return {
        filterId: (0, $eUTZW.isFilterId)(stringifiedFilterId) ? stringifiedFilterId : undefined,
        columnNames: fieldSetIds,
        num: !Number.isNaN(pageSize) ? pageSize : 10,
        sortDirection: sortDirection,
        sortField: sortField,
        showResolved: showResolved
    };
};

});
parcelRegister("8fUPC", function(module, exports) {

$parcel$export(module.exports, "convertUserPrefsToColumnNames", () => $7514a9bc6a1ab713$export$6e5cdc232ebb20cf);

var $kEBPk = parcelRequire("kEBPk");

const $7514a9bc6a1ab713$export$6e5cdc232ebb20cf = (columns)=>typeof columns === 'string' && columns !== '' && columns !== '--Default--' ? columns.split((0, $96223ade4b250f56$export$a3d4af30107c4f4d)).map((col)=>col.replaceAll((0, $96223ade4b250f56$export$952287cc7aef3a4c), (0, $96223ade4b250f56$export$a3d4af30107c4f4d))) : (0, $kEBPk.ISSUE_SEARCH_DEFAULT_COLUMNS);

});
const $96223ade4b250f56$export$dd03181e30c7d559 = 5;
const $96223ade4b250f56$export$a3d4af30107c4f4d = '|';
const $96223ade4b250f56$export$952287cc7aef3a4c = '%7C';


parcelRegister("c4HBH", function(module, exports) {

$parcel$export(module.exports, "getSortFieldAndDirection", () => $569edb8b74cacfd6$export$e535bb2dfaa4d10b);
const $569edb8b74cacfd6$export$e535bb2dfaa4d10b = (sortByFromUserPrefs)=>{
    const [sortField, sortDirection] = typeof sortByFromUserPrefs === 'string' ? sortByFromUserPrefs.split(':') : [];
    if (!sortField || sortDirection !== 'ASC' && sortDirection !== 'DESC') return {};
    return {
        sortField: sortField,
        sortDirection: sortDirection
    };
};

});

parcelRegister("eUTZW", function(module, exports) {

$parcel$export(module.exports, "isFilterId", () => $703d426818b3b844$export$23be85030bd58047);
// this is copied from NIN https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/issue-navigator/actions/common/src/utils/filters/index.tsx?at=abdc1df97c8cee2475285ab25c47a938ce99d65a
const $703d426818b3b844$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});




parcelRegister("4j3xD", function(module, exports) {

$parcel$export(module.exports, "REACT_KEY", () => $b0ef36983599a46e$export$e0e89108956f58f6);
// React gadget keys
const $b0ef36983599a46e$export$c8ae0b83405368ed = 'react/filter-results';
const $b0ef36983599a46e$export$d473668bb8826dfe = 'react/assigned-to-me';
const $b0ef36983599a46e$export$e079ced6d62149e8 = 'react/issues-in-progress';
const $b0ef36983599a46e$export$28c72363adc3f53a = 'react/voted-issues';
const $b0ef36983599a46e$export$99faee4082b644a = 'react/watched-issues';
const $b0ef36983599a46e$export$25f168992476ecb5 = 'react/custom-report';
const $b0ef36983599a46e$export$e0e89108956f58f6 = {
    FILTER_RESULTS: $b0ef36983599a46e$export$c8ae0b83405368ed,
    ASSIGNED_TO_ME: $b0ef36983599a46e$export$d473668bb8826dfe,
    ISSUES_IN_PROGRESS: $b0ef36983599a46e$export$e079ced6d62149e8,
    VOTED_ISSUES: $b0ef36983599a46e$export$28c72363adc3f53a,
    WATCHED_ISSUES: $b0ef36983599a46e$export$99faee4082b644a,
    CUSTOM_REPORT: $b0ef36983599a46e$export$25f168992476ecb5
};

});




parcelRegister("6wpNP", function(module, exports) {

$parcel$export(module.exports, "default", () => $149a9fbe364280c9$export$2e2bcd8739ae039);

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$149a9fbe364280c9$export$2e2bcd8739ae039 = async ()=>(0, $lRmyA.performGetRequest)('/rest/config/1.0/directoryitems.json');

});

parcelRegister("dnvBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad61352d29e96931$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $9hXa4 = parcelRequire("9hXa4");

var $iFHrw = parcelRequire("iFHrw");

var $8b1AQ = parcelRequire("8b1AQ");

var $OHYBb = parcelRequire("OHYBb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad61352d29e96931$export$2e2bcd8739ae039 = (maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch }, spaContext)=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $8b1AQ.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { reactGadgets: nextGadgets } = sharedValue;
            const prev = maybePrevData != null && !(maybePrevData instanceof Error) && maybePrevData.reactGadgetsState || {};
            const persistedGadgets = nextGadgets.filter(({ id: id })=>!!prev[id]);
            const gadgetsToLoad = nextGadgets.filter((gadget)=>{
                // componentEdit will be optional in the future, although currently types say that it's required
                const isConfigurable = !!(0, $iFHrw.default)[gadget.reactKey].componentEdit;
                const isUnconfigured = isConfigurable && !(0, $9hXa4.isGadgetConfigured)(gadget.userPrefs);
                return !prev[gadget.id] && !isUnconfigured;
            });
            const skippedGadgets = nextGadgets.filter((gadget)=>!prev[gadget.id] && !gadgetsToLoad.some(({ id: id })=>id === gadget.id));
            const reactGadgetsState = {
                ...Object.fromEntries(persistedGadgets.map(({ id: id })=>[
                        id,
                        prev[id]
                    ])),
                ...Object.fromEntries(skippedGadgets.map(({ id: id })=>[
                        id,
                        {}
                    ])),
                ...await (0, $OHYBb.loadReactGadgets)(gadgetsToLoad, spaContext)
            };
            return {
                sharedValue: sharedValue,
                reactGadgetsState: reactGadgetsState
            };
        })();
    };

});
parcelRegister("9hXa4", function(module, exports) {

$parcel$export(module.exports, "isGadgetConfigured", () => $63675416148f4e61$export$b625fae487818738);
const $63675416148f4e61$export$b625fae487818738 = (userPrefs)=>userPrefs?.fields.some(({ name: name, value: value })=>name === 'isConfigured' && value === 'true') ?? false;

});

parcelRegister("OHYBb", function(module, exports) {

$parcel$export(module.exports, "loadReactGadgets", () => $187d896eff766e2c$export$7e1a3455761184a2);
// eslint-disable-next-line jira/import-whitelist

var $iFHrw = parcelRequire("iFHrw");
const $187d896eff766e2c$var$preloadGadgetBundles = (reactKeys)=>reactKeys.forEach((reactKey)=>{
        (0, $iFHrw.default)[reactKey].preload();
    });
const $187d896eff766e2c$export$7e1a3455761184a2 = async (gadgets, spaContext)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const distinctReactKeys = [
        ...new Set(gadgets.map((gadget)=>gadget.reactKey))
    ];
    $187d896eff766e2c$var$preloadGadgetBundles(distinctReactKeys);
    return Object.fromEntries(await Promise.all(gadgets.map(({ id: id, reactKey: reactKey, userPrefs: userPrefs })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $iFHrw.default)[reactKey]?.getInitialState(spaContext, userPrefs?.fields || []).then((state)=>[
                id,
                state
            ], (error)=>[
                id,
                error
            ]))));
};

});



parcelRegister("lMin2", function(module, exports) {

$parcel$export(module.exports, "dashboardRoute", () => $9167559284392d0a$export$3bf0ecb39349b6ef);
$parcel$export(module.exports, "selectedDashboardRoute", () => $9167559284392d0a$export$b32070ee9554c3fb);
$parcel$export(module.exports, "dashboardEditRoute", () => $9167559284392d0a$export$b6e00d2cd7369fbd);
$parcel$export(module.exports, "dashboardWallboardRoute", () => $9167559284392d0a$export$eaa33c953ab9ca63);
$parcel$export(module.exports, "dashboardViewRoute", () => $9167559284392d0a$export$24f1b2ff97b9d3e6);
$parcel$export(module.exports, "dashboardViewEmbedRoute", () => $9167559284392d0a$export$258b5e3f294617d2);
$parcel$export(module.exports, "systemDashboardEditRoute", () => $9167559284392d0a$export$7367fb465296c7dd);

var $exb0h = parcelRequire("exb0h");
const $9167559284392d0a$export$3bf0ecb39349b6ef = {
    group: (0, $exb0h.ROUTE_GROUPS_DASHBOARD),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARD),
    path: '/secure/Dashboard.jspa'
};
const $9167559284392d0a$export$b32070ee9554c3fb = {
    group: (0, $exb0h.ROUTE_GROUPS_DASHBOARD),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARD_SELECTED),
    path: '/secure/Dashboard.jspa',
    query: [
        'selectPageId'
    ]
};
const $9167559284392d0a$export$b6e00d2cd7369fbd = {
    group: (0, $exb0h.ROUTE_GROUPS_DASHBOARD),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARD_EDIT),
    path: '/jira/dashboards/:dashboardId(\\d+)/edit',
    query: [
        'maximized?'
    ],
    exact: true
};
const $9167559284392d0a$export$eaa33c953ab9ca63 = {
    group: (0, $exb0h.ROUTE_GROUPS_DASHBOARD),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARD_WALLBOARD),
    path: '/jira/dashboards/wallboard',
    query: [
        'dashboardId',
        'cyclePeriod?',
        'transitionFx?',
        'random?'
    ],
    exact: true
};
const $9167559284392d0a$export$24f1b2ff97b9d3e6 = {
    group: (0, $exb0h.ROUTE_GROUPS_DASHBOARD),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARD_VIEW),
    path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
    query: [
        'maximized?'
    ],
    exact: true
};
const $9167559284392d0a$export$258b5e3f294617d2 = {
    group: (0, $exb0h.ROUTE_GROUPS_DASHBOARD),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARD_VIEW_EMBED),
    path: '/jira/dashboards/:dashboardId(\\d+)/embed',
    query: [],
    exact: true
};
const $9167559284392d0a$export$7367fb465296c7dd = {
    group: (0, $exb0h.ROUTE_GROUPS_DASHBOARD),
    name: (0, $exb0h.ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT),
    path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
    query: [
        'maximized?'
    ]
};

});

parcelRegister("eOycC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("dp9cf")
]).then(()=>parcelRequire('e1lGQ'));

});

parcelRegister("2Qy3v", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("fCdFg")
]).then(()=>parcelRequire('bII8J'));

});

parcelRegister("nOTUX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("gsMYl")
]).then(()=>parcelRequire('4ZoEg'));

});

parcelRegister("kZZqQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("70Gv0")
]).then(()=>parcelRequire('6R8w9'));

});

parcelRegister("ltaAs", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ag43H")
]).then(()=>parcelRequire('jPbUk'));

});

parcelRegister("dlbLv", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("1YjZ5")
]).then(()=>parcelRequire('ergSS'));

});

parcelRegister("9qTfJ", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryResource", () => $d24d57124b25e6ba$export$2646f173fa2c14f2);

var $6qExu = parcelRequire("6qExu");

var $lB25E = parcelRequire("lB25E");


const $d24d57124b25e6ba$export$2646f173fa2c14f2 = (0, $lB25E.createResource)({
    type: (0, $4a3afbc9eff76883$export$87526c4bd9c78abc),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("4enE8")),
    maxAge: (0, $6qExu.MIN_MAX_AGE)
});

});
const $4a3afbc9eff76883$export$87526c4bd9c78abc = 'BOARDS_DIRECTORY';

parcelRegister("4enE8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cHXPU").then(()=>parcelRequire('a4OMj'));

});


parcelRegister("6JBWS", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRoute", () => $13f76266b580a881$export$f0fc6f4e8be87e85);
$parcel$export(module.exports, "boardsDirectoryRedirectRoute", () => $13f76266b580a881$export$a4fba1ebd6ba91ee);

var $exb0h = parcelRequire("exb0h");
const $13f76266b580a881$export$f0fc6f4e8be87e85 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_BOARDS_DIRECTORY),
    path: '/jira/boards'
};
const $13f76266b580a881$export$a4fba1ebd6ba91ee = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: `${(0, $exb0h.ROUTE_NAMES_BOARDS_DIRECTORY)}-redirect`,
    path: '/secure/ManageRapidViews.jspa'
};

});

parcelRegister("1usDU", function(module, exports) {

$parcel$export(module.exports, "BoardsDirectorySkeleton", () => $3b79aee5955c0bc4$export$8194d6e87709f042);
$parcel$export(module.exports, "DashboardsDirectorySkeleton", () => $3b79aee5955c0bc4$export$75ef2bfed3801fb1);
$parcel$export(module.exports, "FiltersDirectorySkeleton", () => $3b79aee5955c0bc4$export$e76f94817327da1);
$parcel$export(module.exports, "ProjectsDirectorySkeleton", () => $3b79aee5955c0bc4$export$d94befb0e231760c);
$parcel$export(module.exports, "PlansDirectorySkeleton", () => $3b79aee5955c0bc4$export$6cd26a09efd6d158);

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $ldlH4 = parcelRequire("ldlH4");

var $6WbAW = parcelRequire("6WbAW");

var $hgcYw = parcelRequire("hgcYw");

var $5ylyu = parcelRequire("5ylyu");
const $3b79aee5955c0bc4$export$8194d6e87709f042 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ldlH4)))
    });
const $3b79aee5955c0bc4$export$75ef2bfed3801fb1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6WbAW)))
    });
const $3b79aee5955c0bc4$export$e76f94817327da1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hgcYw)))
    });
const $3b79aee5955c0bc4$export$d94befb0e231760c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5ylyu)))
    });
const $3b79aee5955c0bc4$export$6cd26a09efd6d158 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5ylyu)))
    });

});
parcelRegister("ldlH4", function(module, exports) {
module.exports = new URL("boards-directory-app-skeleton.tpl.e4de30a4.svg", import.meta.url).toString();

});

parcelRegister("6WbAW", function(module, exports) {
module.exports = new URL("dashboards-directory-app-skeleton.tpl.eb730072.svg", import.meta.url).toString();

});

parcelRegister("hgcYw", function(module, exports) {
module.exports = new URL("filters-directory-app-skeleton.tpl.6583ea61.svg", import.meta.url).toString();

});

parcelRegister("5ylyu", function(module, exports) {
module.exports = new URL("projects-directory-app-skeleton.tpl.a21368f6.svg", import.meta.url).toString();

});


parcelRegister("0bEtt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("7cgo9")
]).then(()=>parcelRequire('fHBlZ'));

});

parcelRegister("iREws", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryResource", () => $2052c360610b9396$export$1cf6c7815471c2a2);

var $6qExu = parcelRequire("6qExu");

var $lB25E = parcelRequire("lB25E");
const $2052c360610b9396$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY = 'DASHBOARDS_DIRECTORY';

const $2052c360610b9396$export$1cf6c7815471c2a2 = (0, $lB25E.createResource)({
    type: $2052c360610b9396$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("iG28u")),
    maxAge: (0, $6qExu.MIN_MAX_AGE)
});

});
parcelRegister("iG28u", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2dVaf").then(()=>parcelRequire('1k3Sw'));

});


parcelRegister("bLGeo", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $f1b3b12941e660c6$export$41bba408475cab16);
$parcel$export(module.exports, "dashboardsDirectoryRedirectRoute", () => $f1b3b12941e660c6$export$b96f6fb3c35a6fe5);

var $exb0h = parcelRequire("exb0h");
const $f1b3b12941e660c6$export$41bba408475cab16 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY),
    path: '/jira/dashboards'
};
const $f1b3b12941e660c6$export$b96f6fb3c35a6fe5 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE),
    path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)'
};

});

parcelRegister("1Djkn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("1XdOR")
]).then(()=>parcelRequire('33gr1'));

});

parcelRegister("iDevf", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryResource", () => $84436203ffbd14dd$export$53f99086c62225b6);

var $6qExu = parcelRequire("6qExu");

var $lB25E = parcelRequire("lB25E");


const $84436203ffbd14dd$export$53f99086c62225b6 = (0, $lB25E.createResource)({
    type: (0, $8dba0204efdc0c28$export$79e191bf6cb15284),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("3kYJi")),
    maxAge: (0, $6qExu.MIN_MAX_AGE)
});

});
const $8dba0204efdc0c28$export$79e191bf6cb15284 = 'FILTERS_DIRECTORY';

parcelRegister("3kYJi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6bzCP").then(()=>parcelRequire('d7GHs'));

});


parcelRegister("1cmFR", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRoute", () => $c5d476788b048c23$export$6350f52c8b40042d);
$parcel$export(module.exports, "filtersDirectoryRedirectRoute", () => $c5d476788b048c23$export$f4f86e1ddc30a625);
$parcel$export(module.exports, "secureFiltersDirectoryRedirectRoute", () => $c5d476788b048c23$export$50796f2aecd63181);

var $exb0h = parcelRequire("exb0h");
const $c5d476788b048c23$export$6350f52c8b40042d = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY),
    path: '/jira/filters'
};
const $c5d476788b048c23$export$f4f86e1ddc30a625 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: `${(0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY)}-redirect`,
    path: '/ManageFilters.jspa'
};
const $c5d476788b048c23$export$50796f2aecd63181 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: `${(0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY_SECURE)}-redirect`,
    path: '/secure/ManageFilters.jspa'
};

});

parcelRegister("e5dPp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("3q9eL")
]).then(()=>parcelRequire('gIH1G'));

});

parcelRegister("jsQSa", function(module, exports) {

$parcel$export(module.exports, "plansDirectoryRoute", () => $31385c3fefa30f13$export$143b4a1ef2ffc051);

var $exb0h = parcelRequire("exb0h");
const $31385c3fefa30f13$export$143b4a1ef2ffc051 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_PLANS_DIRECTORY),
    path: '/jira/plans'
};

});

parcelRegister("84RpD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("f80cy")
]).then(()=>parcelRequire('9iDly'));

});

parcelRegister("knTPF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("9DTTg")
]).then(()=>parcelRequire('4UUrD'));

});

parcelRegister("fvFzs", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $6981d6dbe7d33e2d$export$780035d9fe48eb32);
$parcel$export(module.exports, "PANEL_ID", () => $6981d6dbe7d33e2d$export$e1d562d81d0e502d);
$parcel$export(module.exports, "PROJECT_CREATE_SOURCE", () => $6981d6dbe7d33e2d$export$280536374592bda3);
$parcel$export(module.exports, "PROJECT_TYPE_TARGETS_MAP", () => $6981d6dbe7d33e2d$export$990484f4e8c06c90);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $6981d6dbe7d33e2d$export$29629758934356a6);

var $fbeIa = parcelRequire("fbeIa");

var $8fAH0 = parcelRequire("8fAH0");
const $6981d6dbe7d33e2d$export$780035d9fe48eb32 = 360;
const $6981d6dbe7d33e2d$export$e1d562d81d0e502d = 'recommendationsInProjectList';
const $6981d6dbe7d33e2d$export$675d6d49067be942 = 'recommendationsInProjectListHoverAnchor';
const $6981d6dbe7d33e2d$export$280536374592bda3 = 'recommendationsInProjectList';
const $6981d6dbe7d33e2d$export$990484f4e8c06c90 = {
    BUSINESS: (0, $fbeIa.Targets).JIRA_CORE,
    SOFTWARE: (0, $fbeIa.Targets).JIRA_SOFTWARE,
    SERVICE_DESK: (0, $fbeIa.Targets).JIRA_SERVICE_DESK,
    PRODUCT_DISCOVERY: (0, $fbeIa.Targets).JIRA_PRODUCT_DISCOVERY
};
const $6981d6dbe7d33e2d$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $8fAH0.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $8fAH0.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $8fAH0.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $8fAH0.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("45OsR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("fTqkW")
]).then(()=>parcelRequire('jNgkC'));

});

parcelRegister("610DX", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryPageResource", () => $91523910c17f4c22$export$aabb201a7f7100c5);
/* eslint-disable jira/import-whitelist */ 
var $iWLL0 = parcelRequire("iWLL0");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $daNZX = parcelRequire("daNZX");

var $3FXyY = parcelRequire("3FXyY");

var $amu7D = parcelRequire("amu7D");

var $c7ifG = parcelRequire("c7ifG");

var $buJlM = parcelRequire("buJlM");

var $vRTdL = parcelRequire("vRTdL");

var $lB25E = parcelRequire("lB25E");

const $91523910c17f4c22$export$aabb201a7f7100c5 = (0, $lB25E.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${(0, $5e9f37eb5f02fe12$export$2150caade62dc875)}`,
    getKey: ()=>'projects-directory-relay',
    // @ts-expect-error - might return null
    getData: async ({ query: query, route: route }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should temporally disable anonymous SSR until
        // the underlying auth issues have been fixed. Duplo team will push the real fix later.
        if (false && isAnonymous) return null;
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default)(), (0, $vRTdL.default), {
            cloudId: tenantContext.cloudId,
            filter: (0, $3FXyY.mapQueryToFilter)((0, $daNZX.filterInitialState), {
                cloudId: cloudId,
                query: (0, $3FXyY.sanitizeLegacyQuery)(query),
                aliases: (0, $daNZX.filterAliasMap)
            }),
            first: query?.page ? (0, $daNZX.DEFAULT_LIMIT) * (parseInt(query.page, 10) || 1) : (0, $daNZX.DEFAULT_LIMIT),
            last: (0, $daNZX.DEFAULT_LIMIT),
            isAdminSettingsContext: route.name === (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE),
            isAnonymous: isAnonymous,
            skipShouldShowRightSidebar: isAnonymous || (0, $1ybV0.ff)('server-render-projects-directory-sidebar_rj9ki'),
            isImporterDiscoveryExperimentEnabled: (0, $eI5EY.fg)('jira_importer_projects_directory_cta_gate')
        }, {
            fetchPolicy: 'network-only'
        });
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    }
});

});
parcelRegister("daNZX", function(module, exports) {

$parcel$export(module.exports, "TableColumns", () => $f73827788bb95cac$export$b0e68791ad9c52df);
$parcel$export(module.exports, "SortableColumns", () => $f73827788bb95cac$export$f9e740ef44a4c43a);
$parcel$export(module.exports, "FilterFields", () => $f73827788bb95cac$export$e38c2fbdcbc20613);
$parcel$export(module.exports, "filterAliasMap", () => $f73827788bb95cac$export$5bc0ad9873e5cd89);
$parcel$export(module.exports, "filterInitialState", () => $f73827788bb95cac$export$fcb7b3e474e67781);
$parcel$export(module.exports, "DEFAULT_LIMIT", () => $f73827788bb95cac$export$ebc5ec3267fbcf57);
$parcel$export(module.exports, "PROJECTS_DIRECTORY_EXPERIENCE", () => $f73827788bb95cac$export$7c1bd7128901e2c4);
$parcel$export(module.exports, "MANAGE_PROJECTS_DIRECTORY_EXPERIENCE", () => $f73827788bb95cac$export$72fb94bf1b8ec849);
// eslint-disable-next-line jira/import-whitelist

var $dlza3 = parcelRequire("dlza3");
const $f73827788bb95cac$export$b0e68791ad9c52df = {
    Favourites: 'favourite',
    Key: 'key',
    Name: 'name',
    Type: 'type',
    Lead: 'lead',
    Category: 'category',
    LastIssueUpdate: 'last_issue_updated_time',
    Url: 'url',
    Action: 'actions'
};
const $f73827788bb95cac$export$f9e740ef44a4c43a = [
    $f73827788bb95cac$export$b0e68791ad9c52df.Favourites,
    $f73827788bb95cac$export$b0e68791ad9c52df.Key,
    $f73827788bb95cac$export$b0e68791ad9c52df.Name,
    $f73827788bb95cac$export$b0e68791ad9c52df.Lead,
    $f73827788bb95cac$export$b0e68791ad9c52df.Category,
    $f73827788bb95cac$export$b0e68791ad9c52df.LastIssueUpdate
];
const $f73827788bb95cac$export$e38c2fbdcbc20613 = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectTypeLabel: 'ProjectTypeLabel',
    ProjectCategoryId: 'projectCategoryId',
    ProjectCategoryLabel: 'projectCategoryLabel',
    ...(0, $dlza3.DefaultFilterFields)
};
const $f73827788bb95cac$export$5bc0ad9873e5cd89 = {
    contains: $f73827788bb95cac$export$e38c2fbdcbc20613.Keyword,
    selectedProjectType: $f73827788bb95cac$export$e38c2fbdcbc20613.ProjectType,
    selectedCategory: $f73827788bb95cac$export$e38c2fbdcbc20613.ProjectCategoryId
};
const $f73827788bb95cac$export$fcb7b3e474e67781 = {
    [$f73827788bb95cac$export$e38c2fbdcbc20613.Keyword]: '',
    [$f73827788bb95cac$export$e38c2fbdcbc20613.ProjectType]: '',
    [$f73827788bb95cac$export$e38c2fbdcbc20613.ProjectTypeLabel]: '',
    [$f73827788bb95cac$export$e38c2fbdcbc20613.ProjectCategoryId]: '',
    [$f73827788bb95cac$export$e38c2fbdcbc20613.ProjectCategoryLabel]: '',
    [$f73827788bb95cac$export$e38c2fbdcbc20613.SortOrder]: 'ASC',
    [$f73827788bb95cac$export$e38c2fbdcbc20613.SortKey]: $f73827788bb95cac$export$b0e68791ad9c52df.Name,
    [$f73827788bb95cac$export$e38c2fbdcbc20613.Page]: '1'
};
const $f73827788bb95cac$export$ebc5ec3267fbcf57 = 25;
const $f73827788bb95cac$export$7c1bd7128901e2c4 = 'viewProjectsDirectoryV3';
const $f73827788bb95cac$export$72fb94bf1b8ec849 = 'viewManageProjectsDirectoryV3';

});
parcelRegister("dlza3", function(module, exports) {

$parcel$export(module.exports, "DefaultFilterFields", () => $e1b4b912fa01d011$export$7ecdd4b6ae40e139);
$parcel$export(module.exports, "createUseFilter", () => $e1b4b912fa01d011$export$ef79d9c1dcb09f8f);

var $53ciZ = parcelRequire("53ciZ");

var $guiFP = parcelRequire("guiFP");

var $WBLbN = parcelRequire("WBLbN");
const $e1b4b912fa01d011$export$7ecdd4b6ae40e139 = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
const $e1b4b912fa01d011$export$ef79d9c1dcb09f8f = (storeName, { getInitialState: getInitialState })=>{
    const actions = {
        updateFilter: (nameOrFilter, value)=>({ setState: setState, getState: getState }, { onUpdate: onUpdate })=>{
                const newFilter = typeof nameOrFilter === 'object' ? nameOrFilter : {
                    [nameOrFilter]: value
                };
                setState({
                    ...getState(),
                    [$e1b4b912fa01d011$export$7ecdd4b6ae40e139.Page]: 1,
                    ...newFilter
                });
                onUpdate(getState());
            },
        forceUpdate: ()=>({ getState: getState }, { onUpdate: onUpdate })=>onUpdate(getState())
    };
    const Store = (0, $WBLbN.createStore)({
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        initialState: {},
        actions: actions,
        name: storeName
    });
    const useFilter = (0, $WBLbN.createHook)(Store);
    const useScopedFilter = (0, $WBLbN.createHook)(Store, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        selector: (state, name)=>state[name]
    });
    const FilterContainer = (0, $WBLbN.createContainer)(Store, {
        onInit: ()=>({ setState: setState })=>{
                try {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    const routeQuery = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(window.location.search);
                    setState(getInitialState({
                        routeQuery: routeQuery
                    }));
                } catch (error) {
                    (0, $guiFP.default)({
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        error: error,
                        meta: {
                            id: 'createUseFilter',
                            packageName: 'jiraDirectoryBaseV3',
                            teamName: 'jira-cosmos'
                        }
                    });
                }
            },
        // reset initial state on unmount
        onCleanup: ()=>({ setState: setState })=>setState(getInitialState({
                    routeQuery: {}
                }))
    });
    return {
        useFilter: useFilter,
        useScopedFilter: useScopedFilter,
        FilterContainer: FilterContainer
    };
};

});


parcelRegister("3FXyY", function(module, exports) {

$parcel$export(module.exports, "sanitizeLegacyQuery", () => $f0ffb937191aeb5a$export$b6d5141c3209bd35);
$parcel$export(module.exports, "mapQueryToFilter", () => $f0ffb937191aeb5a$export$2274cd5f35844a96);

var $7ZZxN = parcelRequire("7ZZxN");

var $9yLt7 = parcelRequire("9yLt7");

var $huI7r = parcelRequire("huI7r");

var $daNZX = parcelRequire("daNZX");
const $f0ffb937191aeb5a$var$LEGACY_ALL_VALUE = 'all';
const $f0ffb937191aeb5a$export$b6d5141c3209bd35 = (query)=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $f0ffb937191aeb5a$var$LEGACY_ALL_VALUE ? (0, $daNZX.filterInitialState)[(0, $daNZX.FilterFields).ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $f0ffb937191aeb5a$var$LEGACY_ALL_VALUE ? (0, $daNZX.filterInitialState)[(0, $daNZX.FilterFields).ProjectCategoryId] : query.selectedCategory
    });
const $f0ffb937191aeb5a$export$2274cd5f35844a96 = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [(0, $daNZX.FilterFields).Keyword]: keyword, [(0, $daNZX.FilterFields).ProjectCategoryId]: projectCategoryId, [(0, $daNZX.FilterFields).ProjectType]: types, [(0, $daNZX.FilterFields).SortOrder]: sortOrder, [(0, $daNZX.FilterFields).SortKey]: sortKey } = aliases && query ? (0, $9yLt7.matchAliases)(filter, query, aliases) : filter; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) variables.projectCategoryId = (0, $huI7r.isAri)(projectCategoryId) ? projectCategoryId : (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project-category',
        resourceId: projectCategoryId
    });
    if (sortKey || sortOrder) {
        const sortByValue = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortKey && (0, $daNZX.SortableColumns).includes(sortKey) ? sortKey : (0, $daNZX.filterInitialState)[(0, $daNZX.FilterFields).SortKey];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : (0, $daNZX.filterInitialState)[(0, $daNZX.FilterFields).SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    variables.types = types.split(',') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((type)=>(0, $7ZZxN.PROJECT_TYPES).includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

});
parcelRegister("9yLt7", function(module, exports) {

$parcel$export(module.exports, "matchAliases", () => $eb4bb5ada87cd343$export$55f686d7a3507dbe);
$parcel$export(module.exports, "serializeSelectOptions", () => $eb4bb5ada87cd343$export$74a705e0bee1565b);
$parcel$export(module.exports, "serializeSelectOptionsLabel", () => $eb4bb5ada87cd343$export$eed751fcc55ddadd);
$parcel$export(module.exports, "matchValueToSelectOptions", () => $eb4bb5ada87cd343$export$17e142fa55464467);

var $aXGkF = parcelRequire("aXGkF");

var $cnRoI = parcelRequire("cnRoI");
const $eb4bb5ada87cd343$export$55f686d7a3507dbe = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $eb4bb5ada87cd343$export$40bf1812f0f07002 = (data, aliases)=>{
    const invertedAliases = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))(aliases);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cnRoI)))(data, (_, key)=>invertedAliases[key] || key);
};
const $eb4bb5ada87cd343$export$74a705e0bee1565b = (options)=>options.map((v)=>v.value).join(',');
const $eb4bb5ada87cd343$export$eed751fcc55ddadd = (options)=>options.map((v)=>v.label).join(',');
const $eb4bb5ada87cd343$export$17e142fa55464467 = (value, options)=>value ? value.split(',').map((val)=>options.find((option)=>option.value === val)).filter(Boolean) : [];

});
parcelRegister("aXGkF", function(module, exports) {

var $CAsD5 = parcelRequire("CAsD5");

var $eQ67w = parcelRequire("eQ67w");

var $3QMTK = parcelRequire("3QMTK");
/** Used for built-in method references. */ var $7fb0405f6a745d75$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7fb0405f6a745d75$var$nativeObjectToString = $7fb0405f6a745d75$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $7fb0405f6a745d75$var$invert = $eQ67w(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $7fb0405f6a745d75$var$nativeObjectToString.call(value);
    result[value] = key;
}, $CAsD5($3QMTK));
module.exports = $7fb0405f6a745d75$var$invert;

});
parcelRegister("eQ67w", function(module, exports) {

var $im19c = parcelRequire("im19c");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $acdaab61bed7cb96$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $im19c(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $acdaab61bed7cb96$var$createInverter;

});
parcelRegister("im19c", function(module, exports) {

var $piimr = parcelRequire("piimr");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $d5cb2bea9036f464$var$baseInverter(object, setter, iteratee, accumulator) {
    $piimr(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $d5cb2bea9036f464$var$baseInverter;

});





parcelRegister("vRTdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5d472e531f33745$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<75cec170ac033932dc547a56b1a3d6ac>>
 * @relayHash 30dd32919cc01646c2f07a87579c7d90
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c5bf480cfcc7e1667e0f3ca7923ae0e7fb82b6dc49abd4df64797411cc629cfd

var $cNy9K = parcelRequire("cNy9K");
const $a5d472e531f33745$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAdminSettingsContext"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isImporterDiscoveryExperimentEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipShouldShowRightSidebar"
    }, v8 = {
        "kind": "Variable",
        "name": "isAnonymous",
        "variableName": "isAnonymous"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v11 = {
        "alias": "canBrowseProjects",
        "args": [
            v10 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "type",
                "value": "BROWSE_PROJECTS"
            }
        ],
        "concreteType": "JiraPermission",
        "kind": "LinkedField",
        "name": "permission",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasPermission"
            }
        ]
    }, v12 = [
        v10 /*: any*/ 
    ], v13 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "id"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v17 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "key"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v21 = {
        "kind": "ScalarField",
        "name": "projectListRightPanelState"
    }, v22 = {
        "alias": "sidebarExperimentTemplates",
        "args": [
            v10 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "experimentKey",
                "value": "sidebarExperiment"
            }
        ],
        "concreteType": "JiraProjectListViewTemplateConnection",
        "kind": "LinkedField",
        "name": "projectListViewTemplates",
        "plural": false,
        "selections": [
            v20 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "selections": [
                {
                    "args": [
                        v8 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "isImporterDiscoveryExperimentEnabled",
                            "variableName": "isImporterDiscoveryExperimentEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "header_projectsDirectoryV3"
                },
                {
                    "args": v9 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "refinementBar_projectsDirectoryV3_Filters"
                },
                {
                    "args": v9 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "projectsList_projectsDirectoryV3_rootQueryRef"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isAdminSettingsContext",
                            "variableName": "isAdminSettingsContext"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "pageLayout_projectsDirectoryV3_ProjectDirectoryLayout"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "emptyView_projectsDirectoryV3"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "noPermissionViews_projectsDirectoryV3"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ 
                    ]
                },
                {
                    "condition": "skipShouldShowRightSidebar",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "rightPanel_projectsDirectoryV3_ShouldShowRightSidebar"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": v12 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "args": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "filter",
                                    "variableName": "filter"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "canViewIssue",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v13 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                                                },
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteValue",
                                                    "kind": "LinkedField",
                                                    "name": "favouriteValue",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ]
                                                },
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "medium"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "navigationMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardId"
                                                                },
                                                                v14 /*: any*/ 
                                                            ],
                                                            "type": "JiraSoftwareProjectNavigationMetadata"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "queueId"
                                                                }
                                                            ],
                                                            "type": "JiraServiceManagementProjectNavigationMetadata"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lead",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isUser"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v14 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "isAdminSettingsContext",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "lastUpdatedToolTipDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "COMPLETE_DATETIME_FORMAT"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                                                        },
                                                        {
                                                            "alias": "lastUpdatedDisplayDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "RELATIVE"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectUrl"
                                                },
                                                {
                                                    "alias": "canEdit",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v13 /*: any*/ ,
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "alias": "canViewProjectConfig",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v13 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "alias": "jiraProjectType",
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "alias": "jiraProjectName",
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v20 /*: any*/ ,
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHasTotal"
                                }
                            ]
                        },
                        {
                            "alias": "canContactAdmin",
                            "args": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": "jira.show.contact.administrators.form"
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        v17 /*: any*/ 
                                    ]
                                },
                                v22 /*: any*/ ,
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v19 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v12 /*: any*/ ,
                            "concreteType": "JiraProjectTypeDetailsConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjectTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectTypeDetailsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectTypeDetails",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "skipShouldShowRightSidebar",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ 
                                    ]
                                },
                                v22 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c5bf480cfcc7e1667e0f3ca7923ae0e7fb82b6dc49abd4df64797411cc629cfd",
            "metadata": {},
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a5d472e531f33745$var$node.hash = "44419374ddb19dca6c3a1596b677f976";
(0, $cNy9K.PreloadableQueryRegistry).set($a5d472e531f33745$var$node.params.id, $a5d472e531f33745$var$node);
var $a5d472e531f33745$export$2e2bcd8739ae039 = $a5d472e531f33745$var$node;

});

const $5e9f37eb5f02fe12$export$2150caade62dc875 = 'PROJECTS_DIRECTORY_RELAY';


parcelRegister("1iihP", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRoute", () => $24be186849539eb4$export$74114064f06cd71b);
$parcel$export(module.exports, "manageProjectsDirectoryRoute", () => $24be186849539eb4$export$281a4490a0f8fb4c);
$parcel$export(module.exports, "projectsDirectoryRedirectRoute", () => $24be186849539eb4$export$d44f1be3782f0fde);
$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRoute", () => $24be186849539eb4$export$c713f57300a82898);
$parcel$export(module.exports, "projectsDirectoryManageRedirectRoute", () => $24be186849539eb4$export$dbd3b6c012e8b6dc);
$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRoute", () => $24be186849539eb4$export$4531e3b2e25fad23);

var $exb0h = parcelRequire("exb0h");
const $24be186849539eb4$export$74114064f06cd71b = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY),
    path: '/jira/projects',
    exact: true
};
const $24be186849539eb4$export$281a4490a0f8fb4c = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE),
    path: '/jira/settings/projects/manage'
};
const $24be186849539eb4$export$d44f1be3782f0fde = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: `${(0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY)}-redirect`,
    path: '/projects',
    exact: true
};
const $24be186849539eb4$export$c713f57300a82898 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: `${(0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA)}-redirect`,
    path: '/secure/BrowseProjects.jspa'
};
const $24be186849539eb4$export$dbd3b6c012e8b6dc = {
    name: `${(0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE)}-redirect`,
    path: '/secure/project/ViewProjects.jspa'
};
const $24be186849539eb4$export$4531e3b2e25fad23 = {
    name: `${(0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE)}-root-redirect`,
    path: '/jira/settings/projects',
    exact: true
};

});

parcelRegister("hLiAo", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("7jovu")
]).then(()=>parcelRequire('aFSMB'));

});

parcelRegister("949tN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("k0ssa")
]).then(()=>parcelRequire('7vk58'));

});

parcelRegister("afdaT", function(module, exports) {

$parcel$export(module.exports, "resources", () => $ea442645345c77bb$export$bc99aaabaf7b70a7);

var $49L0w = parcelRequire("49L0w");

var $a0u5P = parcelRequire("a0u5P");

var $8ec5x = parcelRequire("8ec5x");

var $d3GFq = parcelRequire("d3GFq");
const $ea442645345c77bb$export$bc99aaabaf7b70a7 = {
    configuredSyncsResource: $49L0w.configuredSyncsResource,
    userAccessRightsResource: $d3GFq.userAccessRightsResource,
    getTeamResource: $8ec5x.getTeamResource,
    isCurrentSiteSyncEnabledResource: $a0u5P.isCurrentSiteSyncEnabledResource
};

});
parcelRegister("49L0w", function(module, exports) {

$parcel$export(module.exports, "configuredSyncsResource", () => $cac6daedbf87e740$export$333c290f4a1ec41c);

var $lB25E = parcelRequire("lB25E");

var $fvPbh = parcelRequire("fvPbh");

var $b5C0f = parcelRequire("b5C0f");
const $cac6daedbf87e740$export$333c290f4a1ec41c = (0, $lB25E.createResource)({
    type: 'configuredSyncsResource',
    getKey: ({ query: query, match: match })=>{
        const teamId = match.params.teamId ?? query['teamId'];
        const keyword = query['keyword'];
        const type = query['type'];
        const page = query['page'] || '1';
        const status = query['status'];
        return (0, $fvPbh.UrlHelper)('configuredSyncsResource', {
            page: page,
            keyword: keyword,
            type: type,
            status: status,
            teamId: teamId
        });
    },
    getData: (routerContext)=>(0, $b5C0f.default).getSyncs(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("fvPbh", function(module, exports) {

$parcel$export(module.exports, "UrlHelper", () => $161409b84dc89b7b$export$bacbc496e850c0a4);
const $161409b84dc89b7b$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    const qs = new URLSearchParams(q).toString();
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("b5C0f", function(module, exports) {

$parcel$export(module.exports, "default", () => $256cabacb2152299$export$2e2bcd8739ae039);

var $kRdYM = parcelRequire("kRdYM");

var $fvPbh = parcelRequire("fvPbh");

const $256cabacb2152299$var$getSyncs = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $79b21fb03724c30c$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId ?? query.teamId,
        type: query.type,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $kRdYM.eocFetch)((0, $fvPbh.UrlHelper)('/v1/entity-sync/unified', {
        ...queryParams,
        offset: offset.toString(),
        limit: (0, $79b21fb03724c30c$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $79b21fb03724c30c$export$31ecae7225aecec6)),
            itemCount: response.data.count
        }));
};
const $256cabacb2152299$var$patchSync = async (syncId, syncType, body, teamId)=>(0, $kRdYM.eocFetch)((0, $fvPbh.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $256cabacb2152299$var$deleteSync = async (syncId, syncType, teamId)=>(0, $kRdYM.eocFetch)((0, $fvPbh.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
var $256cabacb2152299$export$2e2bcd8739ae039 = {
    getSyncs: $256cabacb2152299$var$getSyncs,
    patchSync: $256cabacb2152299$var$patchSync,
    deleteSync: $256cabacb2152299$var$deleteSync
};

});
const $79b21fb03724c30c$export$31ecae7225aecec6 = 20;



parcelRegister("a0u5P", function(module, exports) {

$parcel$export(module.exports, "isCurrentSiteSyncEnabledResource", () => $bb12be681c7e5279$export$94465df791bf80);

var $lB25E = parcelRequire("lB25E");

var $dvwYP = parcelRequire("dvwYP");
const $bb12be681c7e5279$export$94465df791bf80 = (0, $lB25E.createResource)({
    type: 'isCurrentSiteSyncEnabledResource',
    getKey: ()=>`isCurrentSiteSyncEnabledResource`,
    getData: (0, $dvwYP.getIsCurrentSiteSyncEnabled),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("dvwYP", function(module, exports) {

$parcel$export(module.exports, "getIsCurrentSiteSyncEnabled", () => $dfce35dbe2c817fa$export$93fc09e39edf63d0);

var $kRdYM = parcelRequire("kRdYM");
const $dfce35dbe2c817fa$export$93fc09e39edf63d0 = ()=>(0, $kRdYM.eocFetch)(`/v1/entity-sync/is-current-site-enabled`).then((response)=>response.data.enabled);

});


parcelRegister("8ec5x", function(module, exports) {

$parcel$export(module.exports, "getTeamResource", () => $9804f9fce637e8ac$export$50271c9e7f21f10e);

var $lB25E = parcelRequire("lB25E");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $9wl4s = parcelRequire("9wl4s");
const $9804f9fce637e8ac$export$50271c9e7f21f10e = (0, $lB25E.createResource)({
    type: 'getSyncTeamResource',
    getKey: (routerContext)=>`getSyncTeamResource#${routerContext.match.params?.teamId}`,
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('getTeamResource', 'teamId should be set to fetch the team'));
        const result = await (0, $9wl4s.getTeam)(teamId);
        return result ?? null;
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("6nbVQ", function(module, exports) {

$parcel$export(module.exports, "assert", () => $d9834c637c2554ee$export$a7a9523472993e97);

var $1bJvm = parcelRequire("1bJvm");
/**
 * Throws when the condition is true
 * @param condition Condition to assert - can use type assertions thanks to ts's "asserts condition"
 * @param err An AssertionError object extending js error object
 */ const $d9834c637c2554ee$export$a7a9523472993e97 = function(condition, err) {
    if (!condition) throw err;
};

});
parcelRegister("1bJvm", function(module, exports) {

$parcel$export(module.exports, "AssertionError", () => $a0c746e7a19d2631$export$7750cdfb4db2c3d);
class $a0c746e7a19d2631$export$7750cdfb4db2c3d extends Error {
    constructor(id, message){
        super(`[${id}] ${message}`);
        this.id = id;
    }
}

});


parcelRegister("9wl4s", function(module, exports) {

$parcel$export(module.exports, "getTeam", () => $6f1514681b6fb677$export$491fe77f22ab2b51);

var $kRdYM = parcelRequire("kRdYM");
const $6f1514681b6fb677$export$491fe77f22ab2b51 = (teamId)=>(0, $kRdYM.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    }).then((response)=>response.values.filter((responder)=>!responder.deleted).at(0));

});


parcelRegister("d3GFq", function(module, exports) {

$parcel$export(module.exports, "userAccessRightsResource", () => $30ce23928bab6c7a$export$69ddc7cc64ae9a02);

var $lB25E = parcelRequire("lB25E");

var $bfOxh = parcelRequire("bfOxh");
const $30ce23928bab6c7a$export$69ddc7cc64ae9a02 = (0, $lB25E.createResource)({
    type: 'userAccessRightsResource',
    getKey: ()=>'userAccessRightsResource',
    getData: (routerContext)=>(0, $bfOxh.getUserRights)(routerContext.match.params.teamId),
    maxAge: 600000,
    isBrowserOnly: true
});

});
parcelRegister("bfOxh", function(module, exports) {

$parcel$export(module.exports, "getUserRights", () => $1d7b16941467272d$export$84e2ed279bc4e64e);

var $kRdYM = parcelRequire("kRdYM");

var $fvPbh = parcelRequire("fvPbh");
const $1d7b16941467272d$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $kRdYM.eocFetch)((0, $fvPbh.UrlHelper)(`/v1/entity-sync/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data.userAccessRights);
};

});



parcelRegister("jbEIb", function(module, exports) {

$parcel$export(module.exports, "teamResource", () => $5cbd7b7437ac3931$export$87453d709b90ccdf);
$parcel$export(module.exports, "sidebarRightsResource", () => $5cbd7b7437ac3931$export$3b3b9a5b0eddde66);
$parcel$export(module.exports, "resources", () => $5cbd7b7437ac3931$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $128yQ = parcelRequire("128yQ");
const $5cbd7b7437ac3931$export$87453d709b90ccdf = (0, $lB25E.createResource)({
    type: 'teamResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-dashboard/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('teamSidebarResource', 'teamId should be set to fetch team-dashboard'));
        return (0, $128yQ.getTeamByIdEndpoint)(teamId);
    },
    maxAge: 300000,
    isBrowserOnly: true
});
const $5cbd7b7437ac3931$export$3b3b9a5b0eddde66 = (0, $lB25E.createResource)({
    type: 'sidebarRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-dashboard/${teamId ?? ''}/sidebar-rights`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('teamSidebarResource', 'teamId should be set to fetch sidebar rights'));
        return (0, $128yQ.getSidebarRightsEndpoint)(teamId);
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $5cbd7b7437ac3931$export$bc99aaabaf7b70a7 = [
    $5cbd7b7437ac3931$export$87453d709b90ccdf,
    $5cbd7b7437ac3931$export$3b3b9a5b0eddde66
];

});
parcelRegister("128yQ", function(module, exports) {

$parcel$export(module.exports, "getTeamByIdEndpoint", () => $9787862939e447e2$export$bcb25b347f39b3f3);
$parcel$export(module.exports, "getSidebarRightsEndpoint", () => $9787862939e447e2$export$6f1f62156c62eb91);

var $kRdYM = parcelRequire("kRdYM");
const $9787862939e447e2$export$bcb25b347f39b3f3 = (teamId)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}?includeImageUrls=true`);
const $9787862939e447e2$export$6f1f62156c62eb91 = (teamId)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/menu-rights`);
};

});


parcelRegister("bTBRi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("4twcM")
]).then(()=>parcelRequire('eODRa'));

});

parcelRegister("56Sfe", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("1B0AV")
]).then(()=>parcelRequire('gv1Ea'));

});

parcelRegister("3OiSV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kWVG2")
]).then(()=>parcelRequire('76WAG'));

});

parcelRegister("5nFsF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3Zawb").then(()=>parcelRequire('cWSzA'));

});

parcelRegister("6e47L", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4bt51").then(()=>parcelRequire('g8AUr'));

});

parcelRegister("jWByM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("i9ibT")
]).then(()=>parcelRequire('33IMM'));

});

parcelRegister("3co6Q", function(module, exports) {

$parcel$export(module.exports, "apiKeysResource", () => $055abbf7cd5c4457$export$a98d5421eda11f29);
$parcel$export(module.exports, "resources", () => $055abbf7cd5c4457$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");
parcelRequire("l96PT");
var $3liNr = parcelRequire("3liNr");

var $jxDLf = parcelRequire("jxDLf");
const $055abbf7cd5c4457$export$a98d5421eda11f29 = (0, $lB25E.createResource)({
    type: 'api-key-management',
    getKey: ()=>'api-key-management',
    getData: async ({ dependencies: dependencies })=>{
        const data = await dependencies[(0, $3liNr.eocUserResource).type]?.promise;
        return (0, $jxDLf.fetchKeys)(data.accountId);
    },
    isBrowserOnly: true,
    maxCache: 0,
    maxAge: 0,
    depends: [
        (0, $3liNr.eocUserResource).type
    ]
});
const $055abbf7cd5c4457$export$bc99aaabaf7b70a7 = [
    (0, $3liNr.eocUserResource),
    $055abbf7cd5c4457$export$a98d5421eda11f29
];

});
parcelRegister("l96PT", function(module, exports) {

$parcel$export(module.exports, "eocCommonResources", () => $2c2f7e47d538624b$export$8977bbbf2f7167d2);
$parcel$export(module.exports, "eocUserResource", () => (parcelRequire("3liNr")).eocUserResource);

var $3liNr = parcelRequire("3liNr");
const $2c2f7e47d538624b$export$8977bbbf2f7167d2 = ()=>[
        (0, $3liNr.eocUserResource)
    ];

});
parcelRegister("3liNr", function(module, exports) {

$parcel$export(module.exports, "eocUserResource", () => $eb32eba6ed2be6e3$export$3a08a0bdeef86956);

var $lB25E = parcelRequire("lB25E");

var $1cezY = parcelRequire("1cezY");
const $eb32eba6ed2be6e3$export$3a08a0bdeef86956 = (0, $lB25E.createResource)({
    type: 'create-user-resource',
    getKey: ()=>'create-user-resource',
    getData: async ()=>(0, $1cezY.fetchJsmUserInfo)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("1cezY", function(module, exports) {

$parcel$export(module.exports, "fetchJsmUserInfo", () => $e7c198181a929e1f$export$7d750310098b5a7);

var $kRdYM = parcelRequire("kRdYM");
var $3lxlO = parcelRequire("3lxlO");
const $e7c198181a929e1f$var$JSM_BASE_URL = '/rest/api/3/myself';
const $e7c198181a929e1f$export$7d750310098b5a7 = ()=>{
    return (0, $kRdYM.eocFetch)($e7c198181a929e1f$var$JSM_BASE_URL, {
        exactUrl: true,
        errorTransformer: (0, $3lxlO.jsmErrorTransformer)
    });
};

});



parcelRegister("jxDLf", function(module, exports) {

$parcel$export(module.exports, "fetchKeys", () => $2ec4bce9755f87ef$export$a0d93e1b78b8e70b);
$parcel$export(module.exports, "deleteApiKey", () => $2ec4bce9755f87ef$export$d2f8649a375a4113);

var $kRdYM = parcelRequire("kRdYM");
const $2ec4bce9755f87ef$export$a0d93e1b78b8e70b = async (accountId)=>{
    return (0, $kRdYM.eocFetch)('/api-keys/web?accountId=' + accountId);
};
const $2ec4bce9755f87ef$export$d2f8649a375a4113 = async (key, accountId)=>{
    return (0, $kRdYM.eocFetch)(`/api-keys/web?apiKey=${key}&accountId=${accountId}`, {
        method: 'DELETE'
    });
};

});


parcelRegister("8UWae", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ePUZa")
]).then(()=>parcelRequire('2Eh7J'));

});

parcelRegister("lYgVS", function(module, exports) {

$parcel$export(module.exports, "rolesResource", () => $d581aab8be9310d2$export$52e29d5915d5f674);
$parcel$export(module.exports, "resources", () => $d581aab8be9310d2$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");

var $cM2LT = parcelRequire("cM2LT");
const $d581aab8be9310d2$export$52e29d5915d5f674 = (0, $lB25E.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $cM2LT.getRolesEndpoint),
    isBrowserOnly: true
});
const $d581aab8be9310d2$export$bc99aaabaf7b70a7 = [
    $d581aab8be9310d2$export$52e29d5915d5f674
];

});
parcelRegister("cM2LT", function(module, exports) {

$parcel$export(module.exports, "getUsersEndpoint", () => $54cb11edc6a84d83$export$d372f7d69e481dba);
$parcel$export(module.exports, "getFilteredUsersEndpoint", () => $54cb11edc6a84d83$export$d8f86d9603f031c0);
$parcel$export(module.exports, "getRolesEndpoint", () => $54cb11edc6a84d83$export$7d0bc1a3c689fc74);
$parcel$export(module.exports, "updateRoleOfUserEndpoint", () => $54cb11edc6a84d83$export$a0b296dc0259976f);

var $kRdYM = parcelRequire("kRdYM");

var $i5K4D = parcelRequire("i5K4D");
const $54cb11edc6a84d83$export$d372f7d69e481dba = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, query] = queryKey;
    let url = new (0, $i5K4D.URLBuilder)(`/v1/users/search`).withQueryParam('limit', limit).withQueryParam('query', query).withQueryParam('cursor', lastEvaluatedToken).build();
    return (0, $kRdYM.eocFetch)(url);
};
const $54cb11edc6a84d83$export$d8f86d9603f031c0 = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, ...filters] = queryKey;
    if (filters.length === 0) return Promise.resolve({
        lastEvaluatedToken: '',
        values: []
    });
    return (0, $kRdYM.eocFetch)('/v1/users/roles/filter', {
        method: 'POST',
        body: {
            limit: limit,
            roles: filters,
            offset: lastEvaluatedToken || 0
        }
    });
};
const $54cb11edc6a84d83$export$7d0bc1a3c689fc74 = ()=>{
    return (0, $kRdYM.eocFetch)('/v1/users/roles');
};
const $54cb11edc6a84d83$export$a0b296dc0259976f = ({ roleId: roleId, accountId: accountId })=>{
    return (0, $kRdYM.eocFetch)(`/v1/users/roles/assign`, {
        method: 'PATCH',
        body: {
            accountId: accountId,
            roleId: roleId
        }
    });
};

});
parcelRegister("i5K4D", function(module, exports) {

$parcel$export(module.exports, "URLBuilder", () => $fb57b4aadbedcc34$export$61d2e8db329a11f8);
class $fb57b4aadbedcc34$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '').map(([key, value])=>[
                key,
                value && value.toString()
            ]);
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams === '') return `${this.url}`;
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});



parcelRegister("b53YK", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("iD3Xf")
]).then(()=>parcelRequire('dMG0x'));

});

parcelRegister("hgBRY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3SMTO").then(()=>parcelRequire('5c0ul'));

});

parcelRegister("N5Dlu", function(module, exports) {

$parcel$export(module.exports, "customRolesResource", () => $bacc3bb1044c0af0$export$7140716a1b1b8e7a);
$parcel$export(module.exports, "resources", () => $bacc3bb1044c0af0$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");

var $8Z3bm = parcelRequire("8Z3bm");
const $bacc3bb1044c0af0$export$7140716a1b1b8e7a = (0, $lB25E.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $8Z3bm.getCustomRolesListEndpoint),
    isBrowserOnly: true
});
const $bacc3bb1044c0af0$export$bc99aaabaf7b70a7 = [
    $bacc3bb1044c0af0$export$7140716a1b1b8e7a
];

});
parcelRegister("8Z3bm", function(module, exports) {

$parcel$export(module.exports, "getPermissionsEndpoint", () => $21e88853787587c3$export$f97b589720c51ce1);
$parcel$export(module.exports, "createCustomRoleEndpoint", () => $21e88853787587c3$export$5a7187e04c844900);
$parcel$export(module.exports, "editCustomRoleEndpoint", () => $21e88853787587c3$export$304735a80b86192e);
$parcel$export(module.exports, "deleteCustomRoleEndpoint", () => $21e88853787587c3$export$e12995ccad013f65);
$parcel$export(module.exports, "getCustomRolesListEndpoint", () => $21e88853787587c3$export$3619edac53aa59fd);

var $kRdYM = parcelRequire("kRdYM");
const $21e88853787587c3$export$f97b589720c51ce1 = ()=>(0, $kRdYM.eocFetch)(`/v1/users/permissions`);
const $21e88853787587c3$export$5a7187e04c844900 = (newCustomRole)=>(0, $kRdYM.eocFetch)(`/v1/users/roles`, {
        method: 'POST',
        body: newCustomRole
    });
const $21e88853787587c3$export$304735a80b86192e = (updatedCustomRole)=>{
    const { id: id } = updatedCustomRole;
    return (0, $kRdYM.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'PATCH',
        body: updatedCustomRole
    });
};
const $21e88853787587c3$export$e12995ccad013f65 = (id)=>{
    return (0, $kRdYM.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'DELETE'
    });
};
const $21e88853787587c3$export$3619edac53aa59fd = ()=>(0, $kRdYM.eocFetch)(`/v1/users/roles`);

});


parcelRegister("dgtUN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("lGwLm")
]).then(()=>parcelRequire('glbcx'));

});

parcelRegister("lKYxU", function(module, exports) {

$parcel$export(module.exports, "alertDetailResource", () => $9447e3b37d12d9f1$export$f918335771807ac4);
$parcel$export(module.exports, "logTypesResource", () => $9447e3b37d12d9f1$export$f9c57ab4d5f63686);
$parcel$export(module.exports, "entityRelationTypesResource", () => $9447e3b37d12d9f1$export$a5515392cb45b9f8);
$parcel$export(module.exports, "responderStatesResource", () => $9447e3b37d12d9f1$export$c3b70747662e5932);
$parcel$export(module.exports, "resources", () => $9447e3b37d12d9f1$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");

var $dCBfF = parcelRequire("dCBfF");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $l96PT = parcelRequire("l96PT");

var $pKaTx = parcelRequire("pKaTx");
const $9447e3b37d12d9f1$export$f918335771807ac4 = (0, $lB25E.createResource)({
    type: 'alertDetailResource',
    getKey: (routerContext)=>`alertDetailResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $6nbVQ.assert)(!!alertId, new (0, $1bJvm.AssertionError)('alertDetailResource', 'alertId should be set to fetch alert-detail'));
        return (0, $pKaTx.getAlertDetail)(alertId);
    },
    isBrowserOnly: true
});
const $9447e3b37d12d9f1$export$f9c57ab4d5f63686 = (0, $lB25E.createResource)({
    type: 'logTypesResource',
    getKey: (routerContext)=>`logTypesResource#${routerContext.match.params.id}`,
    getData: async ()=>{
        return (0, $pKaTx.getAlertLogTypesEndpoint)();
    },
    isBrowserOnly: true
});
const $9447e3b37d12d9f1$export$a5515392cb45b9f8 = (0, $lB25E.createResource)({
    type: 'entityRelationTypesResource',
    getKey: (routerContext)=>`entityRelationTypesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $6nbVQ.assert)(!!alertId, new (0, $1bJvm.AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
        return (0, $pKaTx.getEntityRelationTypesEndpoint)(alertId);
    },
    isBrowserOnly: true
});
const $9447e3b37d12d9f1$export$c3b70747662e5932 = (0, $lB25E.createResource)({
    type: 'responderStatesResource',
    getKey: (routerContext)=>`responderStatesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $6nbVQ.assert)(!!alertId, new (0, $1bJvm.AssertionError)('responderStatesResource', 'alertId should be set to fetch responder states'));
        return (0, $pKaTx.getResponderStatesEndpoint)(alertId);
    },
    isBrowserOnly: true
});
const $9447e3b37d12d9f1$export$bc99aaabaf7b70a7 = [
    $9447e3b37d12d9f1$export$f918335771807ac4,
    $9447e3b37d12d9f1$export$f9c57ab4d5f63686,
    $9447e3b37d12d9f1$export$c3b70747662e5932,
    $9447e3b37d12d9f1$export$a5515392cb45b9f8,
    (0, $dCBfF.relatedAlertGroupResource),
    ...(0, $l96PT.eocCommonResources)()
];

});
parcelRegister("dCBfF", function(module, exports) {

$parcel$export(module.exports, "relatedAlertGroupResource", () => $960ef6377ca62039$export$35df14c9f0cfb113);

var $lB25E = parcelRequire("lB25E");

var $XHGTv = parcelRequire("XHGTv");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $9egwt = parcelRequire("9egwt");
const $960ef6377ca62039$export$35df14c9f0cfb113 = (0, $lB25E.createResource)({
    type: 'relatedAlertGroupResource',
    getKey: (routerContext)=>`relatedAlertGroupResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        // StatSig feature gate don't need platform prefix
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if (!(0, $XHGTv.fg)('aiops-related-alert-group')) return null;
        const alertId = routerContext.match.params?.id;
        (0, $6nbVQ.assert)(!!alertId, new (0, $1bJvm.AssertionError)('relatedAlertGroupResource', 'alertId should be set to fetch related alert-groups'));
        return (0, $9egwt.getRelatedAlertGroup)(alertId);
    },
    isBrowserOnly: true
});

});
parcelRegister("9egwt", function(module, exports) {

$parcel$export(module.exports, "getRelatedAlertGroup", () => $fbc2c188fb423d2d$export$665e34f20aad273a);

var $kRdYM = parcelRequire("kRdYM");

var $jLi3z = parcelRequire("jLi3z");
const $fbc2c188fb423d2d$export$665e34f20aad273a = (alertId)=>(0, $kRdYM.eocFetch)((0, $jLi3z.withAIOpsDomainPrefix)(`/v1/group-insights/get-group-of-alert?alertId=${alertId}`), {
        exactUrl: true
    });

});
parcelRegister("jLi3z", function(module, exports) {

$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $7cf3fb970619aa9a$export$81c70e0016508593);

var $XHGTv = parcelRequire("XHGTv");

var $3lxlO = parcelRequire("3lxlO");
const $7cf3fb970619aa9a$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $3lxlO.getMeta)('ajs-cloud-id');
    if (cloudId) return (0, $XHGTv.fg)('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});



parcelRegister("pKaTx", function(module, exports) {

$parcel$export(module.exports, "getAlertDetail", () => $310239a10105fec3$export$436b6d88c1865c54);
$parcel$export(module.exports, "getAlertLogTypesEndpoint", () => $310239a10105fec3$export$97200f7e7a7d1479);
$parcel$export(module.exports, "getResponderStatesEndpoint", () => $310239a10105fec3$export$498d1a9ea659d430);
$parcel$export(module.exports, "getEntityRelationTypesEndpoint", () => $310239a10105fec3$export$8f96130abdd7549d);

var $kRdYM = parcelRequire("kRdYM");
const $310239a10105fec3$export$436b6d88c1865c54 = (alertId)=>(0, $kRdYM.eocFetch)(`/v1/alerts/${alertId}`);
const $310239a10105fec3$export$97200f7e7a7d1479 = ()=>(0, $kRdYM.eocFetch)(`/v1/alerts/logs/types`);
const $310239a10105fec3$export$498d1a9ea659d430 = (alertId)=>(0, $kRdYM.eocFetch)(`/v1/alerts/${alertId}/responder-states`);
const $310239a10105fec3$export$8f96130abdd7549d = (alertId)=>(0, $kRdYM.eocFetch)(`/v1/alerts/${alertId}/entity-relations/relation-types`).then((res)=>({
            relationTypes: res.relationTypes.sort((a, b)=>a.label.localeCompare(b.label))
        }));

});


parcelRegister("7IFpZ", function(module, exports) {

$parcel$export(module.exports, "alertGroupingStateResource", () => $333cf2da3ada57c8$export$722cc8285202ce44);

var $lB25E = parcelRequire("lB25E");

var $2IkTC = parcelRequire("2IkTC");
const $333cf2da3ada57c8$var$emptyAlertGroupingState = {
    isEnabled: false,
    reason: null
};
const $333cf2da3ada57c8$export$722cc8285202ce44 = (0, $lB25E.createResource)({
    type: 'alertGroupingStateResource',
    getKey: ()=>'alertGroupingStateResource',
    getData: async ()=>{
        try {
            const response = await (0, $2IkTC.getGroupFeatureStatus)();
            return response;
        } catch (e) {
            // Exception handling and to return emptyState
            return $333cf2da3ada57c8$var$emptyAlertGroupingState;
        }
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("2IkTC", function(module, exports) {

$parcel$export(module.exports, "getGroupFeatureStatus", () => $70e38965fbbb19eb$export$48deee62d9dfb365);

var $1zp76 = parcelRequire("1zp76");

var $kRdYM = parcelRequire("kRdYM");

var $frSVc = parcelRequire("frSVc");
const $70e38965fbbb19eb$export$48deee62d9dfb365 = ()=>{
    const url = new (0, $1zp76.URLBuilder)((0, $frSVc.withAIOpsDomainPrefix)('/v1/aiops/feature-state')).withQueryParam('featureName', 'alert-grouping').build();
    return (0, $kRdYM.eocFetch)(url, {
        exactUrl: true
    });
};

});
parcelRegister("1zp76", function(module, exports) {

$parcel$export(module.exports, "URLBuilder", () => $399a58141a69be30$export$61d2e8db329a11f8);
class $399a58141a69be30$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '');
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});

parcelRegister("frSVc", function(module, exports) {

$parcel$export(module.exports, "validateTimeInput", () => $154beefa3085d712$export$8880da3ae4274888);
$parcel$export(module.exports, "validateBetweenInput", () => $154beefa3085d712$export$57c3e855fbf300fa);
$parcel$export(module.exports, "isInvalidDateValue", () => $154beefa3085d712$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "removeQuotes", () => $154beefa3085d712$export$dd2bdf5049bf0915);
$parcel$export(module.exports, "withQuote", () => $154beefa3085d712$export$8708814d32e406db);
$parcel$export(module.exports, "calculateTimes", () => $154beefa3085d712$export$b362bc6892126b7a);
$parcel$export(module.exports, "getDefaultFilterQuery", () => $154beefa3085d712$export$16cce822d8159876);
$parcel$export(module.exports, "isResponderAlert", () => $154beefa3085d712$export$78656db4ffc3ccd8);
$parcel$export(module.exports, "isGroupAlert", () => $154beefa3085d712$export$be2243d4df51c704);
$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $154beefa3085d712$export$81c70e0016508593);
$parcel$export(module.exports, "getCloudIdForDevEnvironment", () => $154beefa3085d712$export$fc6ce7ac2248d7f5);

var $7ueqz = parcelRequire("7ueqz");

var $3xcI8 = parcelRequire("3xcI8");

var $fiOXn = parcelRequire("fiOXn");

var $XHGTv = parcelRequire("XHGTv");

var $3lxlO = parcelRequire("3lxlO");

var $2zNYA = parcelRequire("2zNYA");
var $kussC = parcelRequire("kussC");

var $1GBJM = parcelRequire("1GBJM");

var $2fFJv = parcelRequire("2fFJv");
const $154beefa3085d712$export$8880da3ae4274888 = (intl, timeDigits, timeUnit)=>{
    if (!timeDigits) return;
    const timeDigitsNumber = parseInt(timeDigits);
    if (isNaN(timeDigitsNumber)) return intl.formatMessage((0, $1GBJM.default).validNumber);
    if (timeUnit === 'hours' && (timeDigitsNumber < 1 || timeDigitsNumber > 99999)) return intl.formatMessage((0, $1GBJM.default).hoursNotInRange);
    if (timeUnit === 'days' && (timeDigitsNumber < 1 || timeDigitsNumber > 9999)) return intl.formatMessage((0, $1GBJM.default).daysNotInRange);
    if (timeUnit === 'weeks' && (timeDigitsNumber < 1 || timeDigitsNumber > 999)) return intl.formatMessage((0, $1GBJM.default).weeksNotInRange);
    if (timeUnit === 'months' && (timeDigitsNumber < 1 || timeDigitsNumber > 99)) return intl.formatMessage((0, $1GBJM.default).monthsNotInRange);
    if (timeUnit === 'years' && (timeDigitsNumber < 1 || timeDigitsNumber > 9)) return intl.formatMessage((0, $1GBJM.default).yearsNotInRange);
};
const $154beefa3085d712$export$57c3e855fbf300fa = (intl, value)=>{
    if (value) {
        const { startDate: startDate, endDate: endDate } = value;
        if (!startDate && !endDate) return;
        if (startDate && endDate && new Date(startDate) > new Date(endDate)) return intl.formatMessage((0, $1GBJM.default).validationMessageBeforeGreaterThanAfter);
        if (value && (startDate !== '' && !(0, $7ueqz.default)(new Date(startDate)) || endDate !== '' && !(0, $7ueqz.default)(new Date(endDate)))) return intl.formatMessage((0, $1GBJM.default).validationMessageInvalidDateFormat);
    }
    return;
};
const $154beefa3085d712$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $7ueqz.default)((0, $3xcI8.default)(value)) && value !== '';
};
const $154beefa3085d712$export$dd2bdf5049bf0915 = (value)=>{
    return value.replace(/^"(.*)"$/, '$1');
};
const $154beefa3085d712$export$d4aae9ad13afd6c = (data)=>{
    return {
        ...data,
        label: data.name,
        value: data.id
    };
};
const $154beefa3085d712$export$8708814d32e406db = (value)=>{
    if ((0, $2zNYA.hasSpaceRegEx).test(value) || (0, $2zNYA.hasColonRegex).test(value)) return `${0, $kussC.STRING_LITERAL_DOUBLE_QUOTE}${value}${0, $kussC.STRING_LITERAL_DOUBLE_QUOTE}`;
    else return value;
};
const $154beefa3085d712$export$b362bc6892126b7a = (time)=>{
    if (!time) return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'all') return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'custom') return {
        from: time.from,
        to: time.to
    };
    const now = new Date();
    const subAmount = {
        [time.range]: time.value
    };
    return {
        from: (0, $fiOXn.default)(now, subAmount).getTime(),
        to: now.getTime()
    };
};
const $154beefa3085d712$export$16cce822d8159876 = (query, teamId)=>{
    if (teamId) {
        if (query) return `${0, $kussC.IDENTIFIER_RESPONDERS}: ${teamId} ${0, $kussC.LOGICAL_OPERATOR_AND} ${query}`;
        return `${0, $kussC.IDENTIFIER_RESPONDERS}: ${teamId}`;
    }
    return query;
};
const $154beefa3085d712$export$78656db4ffc3ccd8 = (alert)=>alert && alert.alertType === 'responder';
const $154beefa3085d712$export$be2243d4df51c704 = (alert)=>alert.entityType === 'group';
const $154beefa3085d712$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $3lxlO.getMeta)('ajs-cloud-id');
    if (cloudId) return (0, $XHGTv.fg)('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
    return input;
};
const $154beefa3085d712$var$isDevEnvironment = ()=>{
    return typeof $2fFJv !== 'undefined' && ($2fFJv?.env?.STORYBOOK === 'true' || $2fFJv?.env?.NODE_ENV === 'development') || window.location.hostname === 'localhost';
};
const $154beefa3085d712$export$fc6ce7ac2248d7f5 = ()=>{
    if ($154beefa3085d712$var$isDevEnvironment()) return 'abc-def-ghi-jkl';
    return undefined;
};

});
parcelRegister("2zNYA", function(module, exports) {

$parcel$export(module.exports, "TAB_KEY", () => $c678c8c7a084ba86$export$da8c7facc28740b1);
$parcel$export(module.exports, "ENTER_KEY", () => $c678c8c7a084ba86$export$4162dbd8c730437);
$parcel$export(module.exports, "ESCAPE_KEY", () => $c678c8c7a084ba86$export$728705b4513abbb5);
$parcel$export(module.exports, "SPACE_KEY", () => $c678c8c7a084ba86$export$a47625ee19580f99);
$parcel$export(module.exports, "LEFT_KEY", () => $c678c8c7a084ba86$export$ba950c21a0561bed);
$parcel$export(module.exports, "UP_KEY", () => $c678c8c7a084ba86$export$16859d5882a95fea);
$parcel$export(module.exports, "RIGHT_KEY", () => $c678c8c7a084ba86$export$4b96cad863d88376);
$parcel$export(module.exports, "DOWN_KEY", () => $c678c8c7a084ba86$export$fc0cf2556509233e);
$parcel$export(module.exports, "SUGGESTION_CARD_Y_POS", () => $c678c8c7a084ba86$export$87b2b08fc4c97f78);
$parcel$export(module.exports, "hasSpaceRegEx", () => $c678c8c7a084ba86$export$a07ca273fbeffcb8);
$parcel$export(module.exports, "hasStartingQuotesRegex", () => $c678c8c7a084ba86$export$a3aaedcec21ac282);
$parcel$export(module.exports, "hasEndingQuotesRegex", () => $c678c8c7a084ba86$export$e5ad519d04ef012a);
$parcel$export(module.exports, "hasNewLinesRegex", () => $c678c8c7a084ba86$export$7645e556e9948ecd);
$parcel$export(module.exports, "EMAIL_REGEX", () => $c678c8c7a084ba86$export$7b7637218245c8a);
$parcel$export(module.exports, "hasColonRegex", () => $c678c8c7a084ba86$export$65a2b373cb60e599);
const $c678c8c7a084ba86$export$da8c7facc28740b1 = 'Tab';
const $c678c8c7a084ba86$export$4162dbd8c730437 = 'Enter';
const $c678c8c7a084ba86$export$728705b4513abbb5 = 'Escape';
const $c678c8c7a084ba86$export$a47625ee19580f99 = ' ';
const $c678c8c7a084ba86$export$ba950c21a0561bed = 'ArrowLeft';
const $c678c8c7a084ba86$export$16859d5882a95fea = 'ArrowUp';
const $c678c8c7a084ba86$export$4b96cad863d88376 = 'ArrowRight';
const $c678c8c7a084ba86$export$fc0cf2556509233e = 'ArrowDown';
const $c678c8c7a084ba86$export$87b2b08fc4c97f78 = 28;
const $c678c8c7a084ba86$export$a07ca273fbeffcb8 = /\s/;
const $c678c8c7a084ba86$export$8866d083cd03ffd7 = /^\s|\s$/;
const $c678c8c7a084ba86$export$a3aaedcec21ac282 = /^('|")/;
const $c678c8c7a084ba86$export$e5ad519d04ef012a = /('|")$/;
const $c678c8c7a084ba86$export$7645e556e9948ecd = /(\r\n|\n|\r)/gm;
const $c678c8c7a084ba86$export$7b7637218245c8a = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $c678c8c7a084ba86$export$65a2b373cb60e599 = /:/;

});

parcelRegister("kussC", function(module, exports) {

$parcel$export(module.exports, "TOKEN_TYPES", () => $df0452e538f4db1e$export$e92b897d610f2aba);
$parcel$export(module.exports, "LEFT_PARENTHESIS", () => $df0452e538f4db1e$export$9ce7f372949a1546);
$parcel$export(module.exports, "RIGHT_PARENTHESIS", () => $df0452e538f4db1e$export$bbbb3f477a9839e0);
$parcel$export(module.exports, "OPERATOR_EQUAL_TO", () => $df0452e538f4db1e$export$ea7497008076d6d2);
$parcel$export(module.exports, "OPERATOR_GROUP_FOR_ASSISTANT", () => $df0452e538f4db1e$export$e75c84803c67e1f4);
$parcel$export(module.exports, "LOGICAL_OPERATOR_AND", () => $df0452e538f4db1e$export$61308b2610174a70);
$parcel$export(module.exports, "LOGICAL_OPERATOR_OR", () => $df0452e538f4db1e$export$1de654320eb3e523);
$parcel$export(module.exports, "BOOLEAN_LITERAL_TRUE", () => $df0452e538f4db1e$export$ff7eed6ac2251302);
$parcel$export(module.exports, "BOOLEAN_LITERAL_FALSE", () => $df0452e538f4db1e$export$4b436fec6f13b741);
$parcel$export(module.exports, "BOOLEAN_LITERAL_GROUP", () => $df0452e538f4db1e$export$8cbc171ac4843075);
$parcel$export(module.exports, "STRING_LITERAL_DOUBLE_QUOTE", () => $df0452e538f4db1e$export$347c7cb6285a1d61);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_OPEN", () => $df0452e538f4db1e$export$910131ff5cd3d496);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_CLOSED", () => $df0452e538f4db1e$export$2aa0d26cb4549272);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_ACKED", () => $df0452e538f4db1e$export$572cec90aa166025);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_SNOOZED", () => $df0452e538f4db1e$export$f94109650ec67751);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_GROUP", () => $df0452e538f4db1e$export$3a3a37e9da45a2a4);
$parcel$export(module.exports, "STRING_LITERAL_PRIORITY_GROUP", () => $df0452e538f4db1e$export$9ef3f42fa10fce44);
$parcel$export(module.exports, "NULL_LITERAL", () => $df0452e538f4db1e$export$c2b6d31a7a2d40ba);
$parcel$export(module.exports, "IDENTIFIER_ALIAS", () => $df0452e538f4db1e$export$21c480ed86e9d13);
$parcel$export(module.exports, "IDENTIFIER_CLOSED_BY", () => $df0452e538f4db1e$export$534c195089710c34);
$parcel$export(module.exports, "IDENTIFIER_DEDUPLICATION", () => $df0452e538f4db1e$export$4699ad3805947d4d);
$parcel$export(module.exports, "IDENTIFIER_ENTITY", () => $df0452e538f4db1e$export$2a30b5099ba66c99);
$parcel$export(module.exports, "IDENTIFIER_IS_SEEN", () => $df0452e538f4db1e$export$7926b4c2836db847);
$parcel$export(module.exports, "IDENTIFIER_MESSAGE", () => $df0452e538f4db1e$export$5a8895646b1d5248);
$parcel$export(module.exports, "IDENTIFIER_ASSIGNEE", () => $df0452e538f4db1e$export$4047502bdab1e205);
$parcel$export(module.exports, "IDENTIFIER_PRIORITY", () => $df0452e538f4db1e$export$5922c06b76ebb57d);
$parcel$export(module.exports, "IDENTIFIER_COMPONENTS", () => $df0452e538f4db1e$export$1122634b5d555f05);
$parcel$export(module.exports, "IDENTIFIER_SERVICES", () => $df0452e538f4db1e$export$ec912454cd7d858a);
$parcel$export(module.exports, "IDENTIFIER_RESPONDERS", () => $df0452e538f4db1e$export$44673ddac1790242);
$parcel$export(module.exports, "IDENTIFIER_SOURCE", () => $df0452e538f4db1e$export$f250d53474e801dc);
$parcel$export(module.exports, "IDENTIFIER_STATUS", () => $df0452e538f4db1e$export$43181828ba8680e4);
$parcel$export(module.exports, "IDENTIFIER_TAG", () => $df0452e538f4db1e$export$8242733866920892);
$parcel$export(module.exports, "IDENTIFIER_TINY_ID", () => $df0452e538f4db1e$export$c833829cf31052f0);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED", () => $df0452e538f4db1e$export$5f1e5c89a704810f);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED_BY", () => $df0452e538f4db1e$export$89d93eb7117999c0);
$parcel$export(module.exports, "IDENTIFIER_TEAMS", () => $df0452e538f4db1e$export$a79eb1864dd7b745);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALERT", () => $df0452e538f4db1e$export$888a9cda49b5e18c);
$parcel$export(module.exports, "IDENTIFIER_BOOLEAN_GROUP", () => $df0452e538f4db1e$export$60745b712d37edf9);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALL", () => $df0452e538f4db1e$export$b38df7dc61d42293);
$parcel$export(module.exports, "splitToTokensRegex", () => $df0452e538f4db1e$export$28041d1d2a85f002);
$parcel$export(module.exports, "isKeywordRegex", () => $df0452e538f4db1e$export$290f3472231a2ca1);
$parcel$export(module.exports, "isModifierRegex", () => $df0452e538f4db1e$export$56079d3966b6b26c);
$parcel$export(module.exports, "isComplexOperatorRegex", () => $df0452e538f4db1e$export$3f6ac43c2355116b);
$parcel$export(module.exports, "isWSRegex", () => $df0452e538f4db1e$export$b1b0fc0dc5c83a12);
$parcel$export(module.exports, "isIdentifierRegex", () => $df0452e538f4db1e$export$218cf3eb73c65394);
$parcel$export(module.exports, "isLogicalOperatorRegex", () => $df0452e538f4db1e$export$a46484930d6fa80f);
$parcel$export(module.exports, "isOperatorRegex", () => $df0452e538f4db1e$export$d48805fc5b137dc9);
/**
 * Token types
 */ const $df0452e538f4db1e$export$e92b897d610f2aba = [
    'WHITE_SPACE',
    'SEPARATOR',
    'IDENTIFIER',
    'MODIFIER',
    'KEYWORD',
    'LOGICAL_OPERATOR',
    'STRING_LITERAL',
    'NUMBER_LITERAL',
    'BOOLEAN_LITERAL',
    'NULL_LITERAL',
    'OPERATOR'
];
const $df0452e538f4db1e$export$9ce7f372949a1546 = '(';
const $df0452e538f4db1e$export$bbbb3f477a9839e0 = ')';
const $df0452e538f4db1e$export$adbc66edc544fda9 = '=';
const $df0452e538f4db1e$export$fbd271ef020db0c = '!=';
const $df0452e538f4db1e$export$ea7497008076d6d2 = ':';
const $df0452e538f4db1e$export$6d44219c9e0c2567 = '!:';
const $df0452e538f4db1e$export$f8636d23c210043c = '<';
const $df0452e538f4db1e$export$1892bd0c818db570 = '<=';
const $df0452e538f4db1e$export$386b1ae18a32d690 = '>';
const $df0452e538f4db1e$export$44a62afa61d82568 = '>=';
const $df0452e538f4db1e$export$e75c84803c67e1f4 = [
    $df0452e538f4db1e$export$adbc66edc544fda9,
    $df0452e538f4db1e$export$f8636d23c210043c,
    $df0452e538f4db1e$export$1892bd0c818db570,
    $df0452e538f4db1e$export$386b1ae18a32d690,
    $df0452e538f4db1e$export$44a62afa61d82568
];
const $df0452e538f4db1e$export$61308b2610174a70 = 'AND';
const $df0452e538f4db1e$export$1de654320eb3e523 = 'OR';
const $df0452e538f4db1e$export$184522872a5410fc = 'not';
const $df0452e538f4db1e$export$ff7eed6ac2251302 = 'true';
const $df0452e538f4db1e$export$4b436fec6f13b741 = 'false';
const $df0452e538f4db1e$export$8cbc171ac4843075 = [
    $df0452e538f4db1e$export$ff7eed6ac2251302,
    $df0452e538f4db1e$export$4b436fec6f13b741
];
const $df0452e538f4db1e$export$347c7cb6285a1d61 = '"';
const $df0452e538f4db1e$export$d84ab70dc909b702 = "'";
const $df0452e538f4db1e$export$910131ff5cd3d496 = `${$df0452e538f4db1e$export$347c7cb6285a1d61}open${$df0452e538f4db1e$export$347c7cb6285a1d61}`;
const $df0452e538f4db1e$export$2aa0d26cb4549272 = `${$df0452e538f4db1e$export$347c7cb6285a1d61}closed${$df0452e538f4db1e$export$347c7cb6285a1d61}`;
const $df0452e538f4db1e$export$572cec90aa166025 = `${$df0452e538f4db1e$export$347c7cb6285a1d61}acknowledged${$df0452e538f4db1e$export$347c7cb6285a1d61}`;
const $df0452e538f4db1e$export$f94109650ec67751 = `${$df0452e538f4db1e$export$347c7cb6285a1d61}snoozed${$df0452e538f4db1e$export$347c7cb6285a1d61}`;
const $df0452e538f4db1e$export$3a3a37e9da45a2a4 = [
    $df0452e538f4db1e$export$910131ff5cd3d496,
    $df0452e538f4db1e$export$2aa0d26cb4549272,
    $df0452e538f4db1e$export$572cec90aa166025,
    $df0452e538f4db1e$export$f94109650ec67751
];
const $df0452e538f4db1e$export$928c1edd572e94f0 = 'P1';
const $df0452e538f4db1e$export$22202070e5f64c55 = 'P2';
const $df0452e538f4db1e$export$537865d58d2072a3 = 'P3';
const $df0452e538f4db1e$export$3d5cfea3feefee83 = 'P4';
const $df0452e538f4db1e$export$fe945cac89cd21a5 = 'P5';
const $df0452e538f4db1e$export$9ef3f42fa10fce44 = [
    $df0452e538f4db1e$export$928c1edd572e94f0,
    $df0452e538f4db1e$export$22202070e5f64c55,
    $df0452e538f4db1e$export$537865d58d2072a3,
    $df0452e538f4db1e$export$3d5cfea3feefee83,
    $df0452e538f4db1e$export$fe945cac89cd21a5
];
const $df0452e538f4db1e$export$c2b6d31a7a2d40ba = 'null';
const $df0452e538f4db1e$export$5a484b762b542c13 = 'actions';
const $df0452e538f4db1e$export$21c480ed86e9d13 = 'alias';
const $df0452e538f4db1e$export$534c195089710c34 = 'closedBy';
const $df0452e538f4db1e$export$4699ad3805947d4d = 'count';
const $df0452e538f4db1e$export$7c3401d7874d69f5 = 'createdAt';
const $df0452e538f4db1e$export$afffcbd5b444e040 = 'description';
const $df0452e538f4db1e$export$e1e61c3bf43fff11 = 'details.key';
const $df0452e538f4db1e$export$aa35da9746edbfe2 = 'details.value';
const $df0452e538f4db1e$export$b620b7163533b409 = 'detailsPair';
const $df0452e538f4db1e$export$2a30b5099ba66c99 = 'entity';
const $df0452e538f4db1e$export$2bfb49435a331d16 = 'integration.name';
const $df0452e538f4db1e$export$feced558810f4b3e = 'integration.type';
const $df0452e538f4db1e$export$7926b4c2836db847 = 'isSeen';
const $df0452e538f4db1e$export$5a8895646b1d5248 = 'message';
const $df0452e538f4db1e$export$4047502bdab1e205 = 'owner';
const $df0452e538f4db1e$export$5922c06b76ebb57d = 'priority';
const $df0452e538f4db1e$export$1122634b5d555f05 = 'components';
const $df0452e538f4db1e$export$ec912454cd7d858a = 'services';
const $df0452e538f4db1e$export$44673ddac1790242 = 'responders';
const $df0452e538f4db1e$export$f250d53474e801dc = 'source';
const $df0452e538f4db1e$export$43181828ba8680e4 = 'status';
const $df0452e538f4db1e$export$a1959e1b76e880dd = 'sync.name';
const $df0452e538f4db1e$export$8417ff61f7a57db6 = 'sync.type';
const $df0452e538f4db1e$export$8242733866920892 = 'tags';
const $df0452e538f4db1e$export$c833829cf31052f0 = 'tinyId';
const $df0452e538f4db1e$export$78d4faf48faf13c2 = 'updatedAt';
const $df0452e538f4db1e$export$5f1e5c89a704810f = 'acknowledged';
const $df0452e538f4db1e$export$89d93eb7117999c0 = 'acknowledgedBy';
const $df0452e538f4db1e$export$1ee0ad656333fc23 = 'aggregatorIds';
const $df0452e538f4db1e$export$d42da2034504d6de = 'alertId';
const $df0452e538f4db1e$export$8464a15b62fb09bb = 'alertType';
const $df0452e538f4db1e$export$2f7ba2848fc019c6 = 'encrypted';
const $df0452e538f4db1e$export$86e4b68c61c8cca5 = 'encryptionId';
const $df0452e538f4db1e$export$cd9dc7ab4d04d11c = 'lastOccurredAt';
const $df0452e538f4db1e$export$8508b76d4c14d7e = 'notify';
const $df0452e538f4db1e$export$e73ddf8d219f28b7 = 'snoozedUntil';
const $df0452e538f4db1e$export$a79eb1864dd7b745 = 'teams';
const $df0452e538f4db1e$export$888a9cda49b5e18c = [
    $df0452e538f4db1e$export$5f1e5c89a704810f,
    $df0452e538f4db1e$export$89d93eb7117999c0,
    $df0452e538f4db1e$export$1ee0ad656333fc23,
    $df0452e538f4db1e$export$d42da2034504d6de,
    $df0452e538f4db1e$export$8464a15b62fb09bb,
    $df0452e538f4db1e$export$2f7ba2848fc019c6,
    $df0452e538f4db1e$export$86e4b68c61c8cca5,
    $df0452e538f4db1e$export$cd9dc7ab4d04d11c,
    $df0452e538f4db1e$export$8508b76d4c14d7e,
    $df0452e538f4db1e$export$e73ddf8d219f28b7,
    $df0452e538f4db1e$export$a79eb1864dd7b745,
    $df0452e538f4db1e$export$5a484b762b542c13,
    $df0452e538f4db1e$export$21c480ed86e9d13,
    $df0452e538f4db1e$export$534c195089710c34,
    $df0452e538f4db1e$export$4699ad3805947d4d,
    $df0452e538f4db1e$export$7c3401d7874d69f5,
    $df0452e538f4db1e$export$afffcbd5b444e040,
    $df0452e538f4db1e$export$e1e61c3bf43fff11,
    $df0452e538f4db1e$export$aa35da9746edbfe2,
    $df0452e538f4db1e$export$b620b7163533b409,
    $df0452e538f4db1e$export$2a30b5099ba66c99,
    $df0452e538f4db1e$export$2bfb49435a331d16,
    $df0452e538f4db1e$export$feced558810f4b3e,
    $df0452e538f4db1e$export$7926b4c2836db847,
    $df0452e538f4db1e$export$5a8895646b1d5248,
    $df0452e538f4db1e$export$4047502bdab1e205,
    $df0452e538f4db1e$export$5922c06b76ebb57d,
    $df0452e538f4db1e$export$44673ddac1790242,
    $df0452e538f4db1e$export$1122634b5d555f05,
    $df0452e538f4db1e$export$ec912454cd7d858a,
    $df0452e538f4db1e$export$f250d53474e801dc,
    $df0452e538f4db1e$export$43181828ba8680e4,
    $df0452e538f4db1e$export$a1959e1b76e880dd,
    $df0452e538f4db1e$export$8417ff61f7a57db6,
    $df0452e538f4db1e$export$8242733866920892,
    $df0452e538f4db1e$export$c833829cf31052f0,
    $df0452e538f4db1e$export$78d4faf48faf13c2
];
const $df0452e538f4db1e$export$60745b712d37edf9 = [
    $df0452e538f4db1e$export$5f1e5c89a704810f,
    $df0452e538f4db1e$export$7926b4c2836db847
];
const $df0452e538f4db1e$export$b38df7dc61d42293 = [
    ...$df0452e538f4db1e$export$888a9cda49b5e18c
];
/**
 * Regex definitions
 */ // The main regex to split any given query into smaller tokens.
// Please be aware that token order has a meaning here.
const $df0452e538f4db1e$var$splitToTokensCases = [
    // 1. Split single and double quotes
    ...[
        $df0452e538f4db1e$export$d84ab70dc909b702,
        $df0452e538f4db1e$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*?${i})`),
    ...[
        $df0452e538f4db1e$export$d84ab70dc909b702,
        $df0452e538f4db1e$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*)`),
    // 2. Split operators and separators
    ...[
        $df0452e538f4db1e$export$9ce7f372949a1546,
        $df0452e538f4db1e$export$bbbb3f477a9839e0,
        $df0452e538f4db1e$export$adbc66edc544fda9,
        $df0452e538f4db1e$export$fbd271ef020db0c,
        $df0452e538f4db1e$export$ea7497008076d6d2,
        $df0452e538f4db1e$export$6d44219c9e0c2567,
        $df0452e538f4db1e$export$44a62afa61d82568,
        $df0452e538f4db1e$export$386b1ae18a32d690,
        $df0452e538f4db1e$export$1892bd0c818db570,
        $df0452e538f4db1e$export$f8636d23c210043c
    ].map((i)=>`(\\${i})`),
    // 3. Split the exact keywords when it's a known literal
    // Known issue: The word boundary in the beginning does not capture letters except latin chars, digits and underscore, i.e. "+and" results to STRING_LITERAL + BOOLEAN_LITERAL
    ...[
        $df0452e538f4db1e$export$61308b2610174a70,
        $df0452e538f4db1e$export$1de654320eb3e523,
        $df0452e538f4db1e$export$ff7eed6ac2251302,
        $df0452e538f4db1e$export$4b436fec6f13b741,
        $df0452e538f4db1e$export$184522872a5410fc,
        `is\\s*null`,
        `is\\s*not\\s*null`
    ].map((i)=>`(\\b${i}(?=\\s|$))`),
    // 4. Empty spaces
    '(\\s+)'
];
const $df0452e538f4db1e$export$28041d1d2a85f002 = new RegExp($df0452e538f4db1e$var$splitToTokensCases.join('|'), 'gi');
const $df0452e538f4db1e$export$290f3472231a2ca1 = /^(is(  *)not(  *)null)$|^(is(  *)null)$/i;
const $df0452e538f4db1e$export$56079d3966b6b26c = /^not$/i;
const $df0452e538f4db1e$export$3f6ac43c2355116b = /^<=$|^>=$|^!=$|^!:$/;
const $df0452e538f4db1e$export$b1b0fc0dc5c83a12 = /^\s+$/;
const $df0452e538f4db1e$export$218cf3eb73c65394 = new RegExp($df0452e538f4db1e$export$b38df7dc61d42293.map((i)=>`^${i}$`).join('|'));
const $df0452e538f4db1e$export$a46484930d6fa80f = /^and$|^or$/i;
const $df0452e538f4db1e$export$d48805fc5b137dc9 = /^[=:<>]$/;

});

parcelRegister("1GBJM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a98d7016bf35fd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $e1a98d7016bf35fd$var$messages = (0, $90IgZ.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.alert-list.common.utils.validation-message-before-greater-than-after.no-translate`,
        defaultMessage: "'Before' field cannot be later than 'After' field.",
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.alert-list.common.utils.validation-message-invalid-date-format.no-translate`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validNumber: {
        id: `eoc.alert-list.common.utils.validation-not-number.no-translate`,
        defaultMessage: 'Enter a valid number.',
        description: 'The error message that shown when user write different chars other than numeric chars.'
    },
    hoursNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-hours-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-99999.',
        description: 'Message displayed to the user when hours value is not in range'
    },
    daysNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-days-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-9999.',
        description: 'Message displayed to the user when days value is not in range'
    },
    weeksNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-weeks-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-999.',
        description: 'Message displayed to the user when weeks value is not in range'
    },
    monthsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-months-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-99.',
        description: 'Message displayed to the user when months value is not in range'
    },
    yearsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-years-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-9.',
        description: 'Message displayed to the user when years value is not in range'
    }
});
var $e1a98d7016bf35fd$export$2e2bcd8739ae039 = $e1a98d7016bf35fd$var$messages;

});




parcelRegister("acZYh", function(module, exports) {

$parcel$export(module.exports, "compressionRatioResource", () => $aefa03606f0ddc80$export$8c912e73f758af2);

var $lB25E = parcelRequire("lB25E");

var $8inqB = parcelRequire("8inqB");
const $aefa03606f0ddc80$var$emptyCompressionBanner = {
    compressionRatio: 0,
    uniqueGroupCount: 0,
    rollingWindow: 0
};
const $aefa03606f0ddc80$export$8c912e73f758af2 = (0, $lB25E.createResource)({
    type: 'compressionRatioResource',
    getKey: ()=>'compressionRatioResource',
    getData: async ()=>{
        try {
            const response = await (0, $8inqB.getCompressionRatio)();
            return response;
        } catch (e) {
            return $aefa03606f0ddc80$var$emptyCompressionBanner;
        }
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("8inqB", function(module, exports) {

$parcel$export(module.exports, "getCompressionRatio", () => $eec2722ac05c516f$export$4991457f359db4f7);

var $kRdYM = parcelRequire("kRdYM");

var $frSVc = parcelRequire("frSVc");
const $eec2722ac05c516f$export$4991457f359db4f7 = ()=>{
    return (0, $kRdYM.eocFetch)((0, $frSVc.withAIOpsDomainPrefix)('/v1/alert-insights/compression-ratio'), {
        exactUrl: true
    });
};

});


parcelRegister("6Awrh", function(module, exports) {

$parcel$export(module.exports, "savedSearchesResource", () => $d59b12714edb599b$export$d915b849e6dd786b);

var $lB25E = parcelRequire("lB25E");

var $g1NGL = parcelRequire("g1NGL");
const $d59b12714edb599b$export$d915b849e6dd786b = (0, $lB25E.createResource)({
    type: 'savedSearchesResource',
    getKey: ()=>'savedSearchesResource',
    getData: ()=>(0, $g1NGL.getSavedSearchesEndpoint)(),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("g1NGL", function(module, exports) {

$parcel$export(module.exports, "getSavedSearchesEndpoint", () => $63b492cfd30a9daa$export$3b7b44889eb94cd0);
$parcel$export(module.exports, "createSavedSearchEndpoint", () => $63b492cfd30a9daa$export$4976332c0ec66407);
$parcel$export(module.exports, "deleteSearchEndpoint", () => $63b492cfd30a9daa$export$401da4a793944201);

var $kRdYM = parcelRequire("kRdYM");
const $63b492cfd30a9daa$export$3b7b44889eb94cd0 = ()=>{
    return (0, $kRdYM.eocFetch)('/v1/alerts/saved-searches');
};
const $63b492cfd30a9daa$export$4976332c0ec66407 = (data)=>{
    return (0, $kRdYM.eocFetch)('/v1/alerts/saved-searches', {
        method: 'POST',
        body: data
    });
};
const $63b492cfd30a9daa$export$401da4a793944201 = (id)=>{
    return (0, $kRdYM.eocFetch)(`/v1/alerts/saved-searches/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};

});


parcelRegister("lWmk8", function(module, exports) {

$parcel$export(module.exports, "uiPreferencesResource", () => $9b13c3a14c5b3d8c$export$4e143f0fe4b2e025);

var $lB25E = parcelRequire("lB25E");

var $aXcBR = parcelRequire("aXcBR");
const $9b13c3a14c5b3d8c$export$4e143f0fe4b2e025 = (0, $lB25E.createResource)({
    type: 'uiPreferencesResource',
    getKey: ()=>'uiPreferencesResource',
    getData: ()=>(0, $aXcBR.getUiPreferencesEndpoint)(),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("aXcBR", function(module, exports) {

$parcel$export(module.exports, "getUiPreferencesEndpoint", () => $c12b49eb859c068d$export$afa4854419ed2fc8);
$parcel$export(module.exports, "updateUiPreferencesEndpoint", () => $c12b49eb859c068d$export$4990793476d8f783);

var $kRdYM = parcelRequire("kRdYM");
const $c12b49eb859c068d$export$afa4854419ed2fc8 = ()=>{
    return (0, $kRdYM.eocFetch)('/v1/alerts/ui-preferences');
};
const $c12b49eb859c068d$export$4990793476d8f783 = (data)=>{
    return (0, $kRdYM.eocFetch)('/v1/alerts/ui-preferences', {
        method: 'PATCH',
        body: data
    });
};

});


parcelRegister("fnRsf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("hlUW3")
]).then(()=>parcelRequire('jdRPc'));

});

parcelRegister("fOu5W", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertDetailRoute", () => $94d55917f8391976$export$4c5c22da74ff47b1);
$parcel$export(module.exports, "eocGlobalAlertListRoute", () => $94d55917f8391976$export$29721341dde2ed3d);

var $exb0h = parcelRequire("exb0h");
const $94d55917f8391976$export$4c5c22da74ff47b1 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL),
    path: '/jira/ops/alerts/:id',
    exact: true
};
const $94d55917f8391976$export$29721341dde2ed3d = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_ALERTS),
    path: '/jira/ops/alerts',
    exact: true
};

});

parcelRegister("a2lIg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("apBhK")
]).then(()=>parcelRequire('hn0SJ'));

});

parcelRegister("8gBS8", function(module, exports) {

$parcel$export(module.exports, "groupHeaderResource", () => $422e634b6020c5b9$export$e6ba56f6b67069c8);
$parcel$export(module.exports, "aiSuggestionsResource", () => $422e634b6020c5b9$export$94675faef1d4568b);
$parcel$export(module.exports, "resources", () => $422e634b6020c5b9$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $jqQxh = parcelRequire("jqQxh");
const $422e634b6020c5b9$export$e6ba56f6b67069c8 = (0, $lB25E.createResource)({
    type: 'groupHeaderResource',
    getKey: (routerContext)=>`groupHeaderResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $6nbVQ.assert)(!!groupId, new (0, $1bJvm.AssertionError)('groupHeaderResource', 'groupId should be set to fetch group-detail-header'));
        return (0, $jqQxh.getHeaderDetails)(groupId);
    },
    isBrowserOnly: true
});
const $422e634b6020c5b9$export$94675faef1d4568b = (0, $lB25E.createResource)({
    type: 'aiSuggestionsResource',
    getKey: (routerContext)=>`aiSuggestionsResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $6nbVQ.assert)(!!groupId, new (0, $1bJvm.AssertionError)('aiSuggestionsResource', 'groupId should be set to fetch ai-suggestions for any group'));
        return (0, $jqQxh.getAISuggestions)(groupId);
    },
    isBrowserOnly: true
});
const $422e634b6020c5b9$export$bc99aaabaf7b70a7 = [
    $422e634b6020c5b9$export$e6ba56f6b67069c8,
    $422e634b6020c5b9$export$94675faef1d4568b
];

});
parcelRegister("jqQxh", function(module, exports) {

$parcel$export(module.exports, "getHeaderDetails", () => $caf9c011cf386695$export$c0f2e4bfcbff05d1);
$parcel$export(module.exports, "getAISuggestions", () => $caf9c011cf386695$export$34bb7a15a54039a5);
$parcel$export(module.exports, "addGroupAssignee", () => $caf9c011cf386695$export$bd5bdebdb6d9abb);
$parcel$export(module.exports, "actionOnGroup", () => $caf9c011cf386695$export$5353a5d2604523c0);
$parcel$export(module.exports, "getAlertCountForGroupAction", () => $caf9c011cf386695$export$b47efb0a9602f0c8);

var $kRdYM = parcelRequire("kRdYM");

var $WuXzV = parcelRequire("WuXzV");
const $caf9c011cf386695$export$c0f2e4bfcbff05d1 = (groupId)=>(0, $kRdYM.eocFetch)((0, $WuXzV.withAIOpsPrefix)(`/v1/group-insights/${groupId}`), {
        exactUrl: true
    });
const $caf9c011cf386695$export$34bb7a15a54039a5 = (groupId)=>(0, $kRdYM.eocFetch)((0, $WuXzV.withAIOpsPrefix)(`/v1/group-insights/getSimilar/${groupId}`), {
        exactUrl: true
    });
const $caf9c011cf386695$export$bd5bdebdb6d9abb = (groupId, assigneeId)=>(0, $kRdYM.eocFetch)((0, $WuXzV.withAIOpsPrefix)(`/v1/group-insights/${groupId}/add-assignee/${assigneeId}`), {
        method: 'PUT',
        exactUrl: true
    });
const $caf9c011cf386695$export$5353a5d2604523c0 = (groupId, action, payload = {})=>{
    return (0, $kRdYM.eocFetch)((0, $WuXzV.withAIOpsPrefix)(`/v1/alert-insights/bulk-action`), {
        method: 'PUT',
        exactUrl: true,
        body: {
            groupId: groupId,
            actionType: action,
            ...payload
        }
    });
};
const $caf9c011cf386695$export$b47efb0a9602f0c8 = (groupId, action)=>{
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('actionType', action);
    urlSearchParams.set('groupId', groupId);
    return (0, $kRdYM.eocFetch)((0, $WuXzV.withAIOpsPrefix)(`/v1/alert-insights/check-all-action?${urlSearchParams}`), {
        exactUrl: true
    });
};

});
parcelRegister("WuXzV", function(module, exports) {

$parcel$export(module.exports, "withAIOpsPrefix", () => $b2a7921c8454e26a$export$5ad74397753c99a2);

var $XHGTv = parcelRequire("XHGTv");

var $3lxlO = parcelRequire("3lxlO");
const $b2a7921c8454e26a$export$5ad74397753c99a2 = (input)=>{
    const cloudId = (0, $3lxlO.getMeta)('ajs-cloud-id');
    if (cloudId) return (0, $XHGTv.getBooleanFF)('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});



parcelRegister("boVHD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("kSNzt")
]).then(()=>parcelRequire('ego33'));

});

parcelRegister("3APH6", function(module, exports) {

$parcel$export(module.exports, "heartbeatsResource", () => $23364e581deb0495$export$dd38e2aa5cfda9c9);
$parcel$export(module.exports, "heartbeatsUserRightsResource", () => $23364e581deb0495$export$b5d9a0bcdfa848ce);
$parcel$export(module.exports, "resources", () => $23364e581deb0495$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");

var $b95gt = parcelRequire("b95gt");
const $23364e581deb0495$export$dd38e2aa5cfda9c9 = (0, $lB25E.createResource)({
    type: 'heartbeatsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `heartbeats/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (!teamId) return;
        return (0, $b95gt.getHeartbeatsEndpoint)(teamId);
    },
    isBrowserOnly: true
});
const $23364e581deb0495$export$b5d9a0bcdfa848ce = (0, $lB25E.createResource)({
    type: 'heartbeatsUserRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `heartbeats-user-rights/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $b95gt.getHeartbeatsUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $23364e581deb0495$export$bc99aaabaf7b70a7 = [
    $23364e581deb0495$export$dd38e2aa5cfda9c9,
    $23364e581deb0495$export$b5d9a0bcdfa848ce
];

});
parcelRegister("b95gt", function(module, exports) {

$parcel$export(module.exports, "getHeartbeatsEndpoint", () => $2dcc4e3b6e8291eb$export$c322dad372dcb08b);
$parcel$export(module.exports, "validateHeartbeatNameEndpoint", () => $2dcc4e3b6e8291eb$export$676f6aee59f124b0);
$parcel$export(module.exports, "createHeartbeatEndpoint", () => $2dcc4e3b6e8291eb$export$891ea85cc6973b32);
$parcel$export(module.exports, "updateHeartbeatEndpoint", () => $2dcc4e3b6e8291eb$export$7311481b59e02e06);
$parcel$export(module.exports, "switchHeartbeatEndpoint", () => $2dcc4e3b6e8291eb$export$5df993f1c74d7e8e);
$parcel$export(module.exports, "deleteHeartbeatEndpoint", () => $2dcc4e3b6e8291eb$export$716e365975fc2cd1);
$parcel$export(module.exports, "getHeartbeatsUserRights", () => $2dcc4e3b6e8291eb$export$26eaca11f3b4e506);
$parcel$export(module.exports, "updateAutoCreationEndpoint", () => $2dcc4e3b6e8291eb$export$38097aade6a3b234);

var $kRdYM = parcelRequire("kRdYM");
const $2dcc4e3b6e8291eb$export$c322dad372dcb08b = (teamId)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
        method: 'GET'
    });
const $2dcc4e3b6e8291eb$export$676f6aee59f124b0 = (teamId, heartbeatName)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/heartbeats/validateEmail?heartbeatName=${encodeURIComponent(heartbeatName)}`, {
        method: 'GET',
        responseType: 'headers'
    });
const $2dcc4e3b6e8291eb$export$891ea85cc6973b32 = (teamId, heartbeat)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
        method: 'POST',
        body: heartbeat
    });
const $2dcc4e3b6e8291eb$export$7311481b59e02e06 = (teamId, heartbeat)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
        method: 'PUT',
        body: heartbeat
    });
const $2dcc4e3b6e8291eb$export$5df993f1c74d7e8e = (teamId, enable, name)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/heartbeats/enable?enabled=${enable}&name=${encodeURIComponent(name)}`, {
        method: 'PATCH'
    });
const $2dcc4e3b6e8291eb$export$716e365975fc2cd1 = (teamId, name)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/heartbeats?name=${encodeURIComponent(name)}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
const $2dcc4e3b6e8291eb$export$26eaca11f3b4e506 = (teamId)=>{
    return (0, $kRdYM.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}heartbeats/rights`);
};
const $2dcc4e3b6e8291eb$export$38097aade6a3b234 = (teamId, autoCreateEnabled)=>(0, $kRdYM.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}heartbeats/updateHeartbeatAutoCreation?autoCreateEnabled=${autoCreateEnabled}`, {
        method: 'POST',
        responseType: 'headers'
    });

});


parcelRegister("jpbkT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ajR1e")
]).then(()=>parcelRequire('9REGk'));

});

parcelRegister("c0h5y", function(module, exports) {

$parcel$export(module.exports, "detailResource", () => $8f8a8e5046f0c379$export$13d78d45f8054f1e);

var $lB25E = parcelRequire("lB25E");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $fydJf = parcelRequire("fydJf");
const $8f8a8e5046f0c379$export$13d78d45f8054f1e = (0, $lB25E.createResource)({
    type: 'getDetailResource',
    getKey: ()=>'getDetailResource',
    getData: async (routerContext)=>{
        const id = routerContext.match.params?.id;
        (0, $6nbVQ.assert)(!!id, new (0, $1bJvm.AssertionError)('detailResource', 'id should be set to fetch incoming call detail'));
        return (0, $fydJf.getDetail)(id);
    },
    isBrowserOnly: true
});

});
parcelRegister("fydJf", function(module, exports) {

$parcel$export(module.exports, "getDetail", () => $b8083b8a2f18f9e3$export$d6c3faeb2ce9d297);

var $kRdYM = parcelRequire("kRdYM");

var $e4iNZ = parcelRequire("e4iNZ");
const $b8083b8a2f18f9e3$export$d6c3faeb2ce9d297 = (id)=>{
    const endpoint = `${(0, $e4iNZ.urls).incomingCall.detail.url(id)}`;
    return (0, $kRdYM.eocFetch)(endpoint);
};

});
parcelRegister("e4iNZ", function(module, exports) {

$parcel$export(module.exports, "urls", () => $6a420a74f45c180c$export$bcae9ba627f604b6);
const $6a420a74f45c180c$export$bcae9ba627f604b6 = Object.freeze({
    incomingCall: {
        url: ()=>`/v1/incoming-call`,
        detail: {
            url: (incomingCallId = ':incomingCallId')=>`${$6a420a74f45c180c$export$bcae9ba627f604b6.incomingCall.url()}/${incomingCallId}`
        }
    }
});

});



parcelRegister("ksJxY", function(module, exports) {

$parcel$export(module.exports, "listResource", () => $21dba5f757320c07$export$5ee018e9baf9d633);

var $j68Wg = parcelRequire("j68Wg");

var $6HGJt = parcelRequire("6HGJt");
const $21dba5f757320c07$export$5ee018e9baf9d633 = (0, $j68Wg.createPaginatedResource)({
    type: 'getListResource',
    getKey: ()=>'getListResource',
    getData: ()=>(0, $6HGJt.getList),
    isBrowserOnly: true
});

});
parcelRegister("j68Wg", function(module, exports) {

$parcel$export(module.exports, "createPaginatedResource", () => $48530d7fdafc340c$export$561b032e4d26d1e8);

var $lB25E = parcelRequire("lB25E");
const $48530d7fdafc340c$export$561b032e4d26d1e8 = ({ getData: getData, getKey: getKey, ...arg })=>{
    return (0, $lB25E.createResource)({
        ...arg,
        getKey: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = query['page'] || '1';
            const key = `${getKey(routerContext, customContext)}#${page}`;
            return key;
        },
        getData: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = parseInt(query['page']) || 1;
            return getData(routerContext, customContext)({
                page: page
            });
        }
    });
};

});

parcelRegister("6HGJt", function(module, exports) {

$parcel$export(module.exports, "getList", () => $e4b58ba3d4314667$export$73fffd6dda5144e);
$parcel$export(module.exports, "addIncomingCall", () => $e4b58ba3d4314667$export$cdae09ff00c893b2);

var $kRdYM = parcelRequire("kRdYM");

var $e4iNZ = parcelRequire("e4iNZ");
const $e4b58ba3d4314667$export$73fffd6dda5144e = ({ page: page })=>{
    const limit = 20;
    const offset = (page - 1) * limit;
    const params = new URLSearchParams({
        offset: `${offset}`,
        limit: `${limit}`,
        sortBy: 'name',
        sort: 'asc'
    });
    const endpoint = `${(0, $e4iNZ.urls).incomingCall.url()}?${params.toString()}`;
    return (0, $kRdYM.eocFetch)(endpoint).then(({ data: data, count: count })=>{
        return {
            data: data,
            count: Math.ceil(count / limit)
        };
    });
};
const $e4b58ba3d4314667$export$cdae09ff00c893b2 = (params)=>{
    return (0, $kRdYM.eocFetch)((0, $e4iNZ.urls).incomingCall.url(), {
        method: 'POST',
        body: params
    });
};

});


parcelRegister("g1c5G", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("3oUGf")
]).then(()=>parcelRequire('aZJA1'));

});

parcelRegister("ix1Bp", function(module, exports) {

$parcel$export(module.exports, "byokInformationResource", () => $e464316392b285a3$export$c6b84cb74d1ed3b9);

var $lB25E = parcelRequire("lB25E");

var $7hEmm = parcelRequire("7hEmm");
const $e464316392b285a3$export$c6b84cb74d1ed3b9 = (0, $lB25E.createResource)({
    type: 'byok-information-resource',
    getKey: ()=>'byok-information-resource',
    getData: async ()=>(0, $7hEmm.fetchByokInformation)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("7hEmm", function(module, exports) {

$parcel$export(module.exports, "fetchByokInformation", () => $335f42cff41d0614$export$5244b5a582b643da);

var $kRdYM = parcelRequire("kRdYM");
const $335f42cff41d0614$export$5244b5a582b643da = async ()=>{
    return (0, $kRdYM.eocFetch)('/v1/customers/byok-setting');
};

});


parcelRegister("aJvzf", function(module, exports) {

$parcel$export(module.exports, "downloadAuditLogsResource", () => $18d0a523b4a6bc1f$export$304da75014b88b78);

var $lB25E = parcelRequire("lB25E");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $6dNJS = parcelRequire("6dNJS");
const $18d0a523b4a6bc1f$export$304da75014b88b78 = (0, $lB25E.createResource)({
    type: 'download-audit-logs-resource',
    getKey: ()=>'download-audit-logs-resource',
    getData: async (routerContext)=>{
        const uniqueKey = routerContext.match.params.exportUniqueKey;
        (0, $6nbVQ.assert)(!!uniqueKey, new (0, $1bJvm.AssertionError)('downloadAuditLogs resource', 'uniqueKey must be defined'));
        return (0, $6dNJS.fetchDownloadLinkEndpoint)(uniqueKey);
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("6dNJS", function(module, exports) {

$parcel$export(module.exports, "fetchDownloadLinkEndpoint", () => $da167ef08ec783e3$export$c8df7e5942ba1d96);

var $kRdYM = parcelRequire("kRdYM");
const $da167ef08ec783e3$export$c8df7e5942ba1d96 = async (exportUniqueKey)=>{
    return (0, $kRdYM.eocFetch)(`/v1/logs/export/${exportUniqueKey}/download`, {
        responseType: 'text'
    });
};

});


parcelRegister("aDS8U", function(module, exports) {

$parcel$export(module.exports, "logsResource", () => $5aa798fbdc0131f8$export$fd88b4310d3f52ff);

var $lB25E = parcelRequire("lB25E");

var $gLEqW = parcelRequire("gLEqW");
const $5aa798fbdc0131f8$export$fd88b4310d3f52ff = (0, $lB25E.createResource)({
    type: 'ui-get-logs',
    getKey: (routerContext)=>{
        const integrationId = routerContext.match.params.integrationId;
        const urlParam = new URLSearchParams();
        Object.entries(routerContext.query).forEach(([key, value])=>{
            if (value) urlParam.set(key, value);
        });
        return !!integrationId ? `integration-${integrationId}-logs#${urlParam.toString()}` : `ui-get-logs#${urlParam.toString()}`;
    },
    getData: async (routerContext)=>{
        return (0, $gLEqW.fetchLogs)({
            fromUnit: routerContext.query?.fromUnit,
            fromValue: routerContext.query?.fromValue,
            startTimestamp: routerContext.query?.startTimestamp,
            endTimestamp: routerContext.query?.endTimestamp,
            eventCategories: routerContext.query?.eventCategories,
            levels: routerContext.query?.levels,
            size: routerContext.query?.size ?? 30,
            insertedAt: routerContext.query?.insertedAt,
            searchString: routerContext.query?.searchString,
            pageDirection: routerContext.query?.pageDirection ?? 'NEXT',
            integrationId: routerContext.match.params.integrationId
        });
    },
    maxAge: 60000,
    isBrowserOnly: true
});

});
parcelRegister("gLEqW", function(module, exports) {

$parcel$export(module.exports, "fetchLogs", () => $e6debeef07285254$export$b9fcc8145a518db4);

var $kRdYM = parcelRequire("kRdYM");

var $4CwtX = parcelRequire("4CwtX");
const $e6debeef07285254$export$b9fcc8145a518db4 = async (params)=>{
    const urlParams = (0, $4CwtX.generateLogParams)(params);
    return (0, $kRdYM.eocFetch)('/v1/logs/search?' + urlParams.toString()).then((response)=>(0, $4CwtX.postProcessLogsSearch)(urlParams, response));
};

});
parcelRegister("4CwtX", function(module, exports) {

$parcel$export(module.exports, "isValidTimePeriodFormat", () => $0fdb21918de0480a$export$2214112898027187);
$parcel$export(module.exports, "getBetweenErrorMessage", () => $0fdb21918de0480a$export$b29a6f1d6d345720);
$parcel$export(module.exports, "isValidBetweenInput", () => $0fdb21918de0480a$export$7b619dd534dac336);
$parcel$export(module.exports, "isInvalidDateValue", () => $0fdb21918de0480a$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "checkQueryIncludesValue", () => $0fdb21918de0480a$export$792d5c0a6d15a15e);
$parcel$export(module.exports, "parseGroupOptionQuery", () => $0fdb21918de0480a$export$f344cca10df5ca13);
$parcel$export(module.exports, "parseOptionQuery", () => $0fdb21918de0480a$export$100c2d7fc380fbfa);
$parcel$export(module.exports, "collectQueryParamsFromOptions", () => $0fdb21918de0480a$export$4db9080fab1bce85);
$parcel$export(module.exports, "calculateTimeBetween", () => $0fdb21918de0480a$export$42dac873831f0e2);
$parcel$export(module.exports, "generateLogParams", () => $0fdb21918de0480a$export$85293a2f3995ddcc);
$parcel$export(module.exports, "fromUnitConverter", () => $0fdb21918de0480a$export$ae02811946c03a4b);
$parcel$export(module.exports, "createBaseQuery", () => $0fdb21918de0480a$export$9a8301702bf003c4);
$parcel$export(module.exports, "calculateNewStartAndEndTimestamp", () => $0fdb21918de0480a$export$b06db0f8b326b929);
$parcel$export(module.exports, "isDetailsSectionEmpty", () => $0fdb21918de0480a$export$74cb10c4b9924e49);
$parcel$export(module.exports, "generateParamsForOneMonthInterval", () => $0fdb21918de0480a$export$130612b33e678a37);
$parcel$export(module.exports, "calculateWidthAccordingToLevel", () => $0fdb21918de0480a$export$e083dc64e00e053b);
$parcel$export(module.exports, "getSourceStringFromUrl", () => $0fdb21918de0480a$export$c6631e198cf7c0f4);
$parcel$export(module.exports, "makeMarkup", () => $0fdb21918de0480a$export$59302306c6f78677);
$parcel$export(module.exports, "postProcessLogsSearch", () => $0fdb21918de0480a$export$9a858fe3837c0be0);

var $eUqFw = parcelRequire("eUqFw");

var $1ewM9 = parcelRequire("1ewM9");

var $5Okns = parcelRequire("5Okns");

var $7ueqz = parcelRequire("7ueqz");

var $3xcI8 = parcelRequire("3xcI8");

var $fiOXn = parcelRequire("fiOXn");

var $8blac = parcelRequire("8blac");

var $ldoFd = parcelRequire("ldoFd");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $ch4Lm = parcelRequire("ch4Lm");

var $grM5e = parcelRequire("grM5e");

var $8rMiv = parcelRequire("8rMiv");

var $3izuG = parcelRequire("3izuG");
// jira-frontend/src/packages/jql-builder-basic-datetime/src/ui/utils/time-functions.tsx
const $0fdb21918de0480a$var$isNumeric = (value)=>/^\d+$/.test(value);
const $0fdb21918de0480a$export$2214112898027187 = (timeDigits, timeUnit)=>{
    return timeDigits === '' || timeDigits !== undefined && $0fdb21918de0480a$var$isNumeric(timeDigits) && parseInt(timeDigits, 10) > -1 && (0, $grM5e.RANGE_OPTIONS).includes(timeUnit);
};
const $0fdb21918de0480a$export$b29a6f1d6d345720 = (intl, value)=>{
    if (!value?.startDate && !value?.endDate) return intl.formatMessage((0, $3izuG.default).validationMessageAtLeastOneValue);
    if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return intl.formatMessage((0, $3izuG.default).validationMessageBeforeGreaterThanAfter);
    if (value && (value?.startDate !== '' && !(0, $7ueqz.default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, $7ueqz.default)(new Date(value?.endDate)))) return intl.formatMessage((0, $3izuG.default).validationMessageInvalidDateFormat);
    return undefined;
};
const $0fdb21918de0480a$export$7b619dd534dac336 = (value)=>{
    if (!value?.startDate && !value?.endDate) return false;
    if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return false;
    if (value && (value?.startDate !== '' && !(0, $7ueqz.default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, $7ueqz.default)(new Date(value?.endDate)))) return false;
    return true;
};
const $0fdb21918de0480a$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $7ueqz.default)((0, $3xcI8.default)(value)) && value !== '';
};
const $0fdb21918de0480a$export$760bb1b75585fb94 = (value)=>{
    return value.map((event)=>event.value).join(',');
};
const $0fdb21918de0480a$export$792d5c0a6d15a15e = (query, value)=>{
    return query?.includes(value.toString()) ?? false;
};
const $0fdb21918de0480a$export$f344cca10df5ca13 = (query, options)=>{
    if (!query) return [];
    const labels = [];
    options.map((option)=>{
        option.options.map((item)=>labels.push(item));
    });
    return labels.filter(({ value: value })=>$0fdb21918de0480a$export$792d5c0a6d15a15e(query, value));
};
const $0fdb21918de0480a$export$100c2d7fc380fbfa = (query, options)=>{
    if (!query) return [];
    return options.filter((label)=>query.includes(label.value.toString()));
};
const $0fdb21918de0480a$export$422789958d8174dd = (unit)=>(0, $grM5e.RANGE_OPTIONS).includes(unit);
const $0fdb21918de0480a$export$4db9080fab1bce85 = (options)=>{
    return options.map((option)=>option.value).join(',');
};
const $0fdb21918de0480a$var$isTimeQueryParamsValid = (params)=>{
    if (params.has('startTimestamp') && params.has('endTimestamp')) return true;
    else if (params.has('fromUnit') && params.has('fromValue')) return true;
    return false;
};
const $0fdb21918de0480a$export$42dac873831f0e2 = (params)=>{
    const now = new Date();
    if (!params.get('startTimestamp') && !params.get('endTimestamp') && params.get('fromUnit') && params.get('fromValue')) {
        const parsedFromValue = parseInt(params.get('fromValue') ?? '1');
        switch(params.get('fromUnit')){
            case 'HOUR':
                params.set('endTimestamp', (now.getTime() * (0, $8rMiv.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $fiOXn.default)(now, {
                    hours: parsedFromValue
                }).getTime() * (0, $8rMiv.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'DAY':
                params.set('endTimestamp', (now.getTime() * (0, $8rMiv.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $fiOXn.default)(now, {
                    days: parsedFromValue
                }).getTime() * (0, $8rMiv.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'WEEK':
                params.set('endTimestamp', (now.getTime() * (0, $8rMiv.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $fiOXn.default)(now, {
                    weeks: parsedFromValue
                }).getTime() * (0, $8rMiv.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'MONTH':
                params.set('endTimestamp', (now.getTime() * (0, $8rMiv.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $fiOXn.default)(now, {
                    months: parsedFromValue
                }).getTime() * (0, $8rMiv.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
        }
        params.delete('fromUnit');
        params.delete('fromValue');
    }
    return params;
};
const $0fdb21918de0480a$export$85293a2f3995ddcc = (params)=>{
    const urlParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value])=>{
        if (value) urlParams.append(key, decodeURI(value));
    });
    if (!$0fdb21918de0480a$var$isTimeQueryParamsValid(urlParams)) {
        // Remove time parameters if exists since they were not matched.
        urlParams.delete('fromUnit');
        urlParams.delete('fromValue');
        urlParams.delete('startTimestamp');
        urlParams.delete('endTimestamp');
        urlParams.append('fromUnit', 'DAY');
        urlParams.append('fromValue', '1');
    }
    return $0fdb21918de0480a$export$42dac873831f0e2(urlParams);
};
const $0fdb21918de0480a$var$calculateTimeDifference = (startDate, endDate)=>{
    const minutesDiff = (0, $1ewM9.default)(endDate, startDate);
    if (minutesDiff < 60) return {
        hours: 1,
        days: 0,
        weeks: 0,
        months: 0,
        years: 0
    };
    const hoursDiff = minutesDiff / 60;
    const daysDiff = minutesDiff / 60 / 24;
    const weeksDiff = minutesDiff / 60 / 24 / 7;
    const monthsDiff = minutesDiff / 60 / 24 / 7 / 4;
    return {
        hours: hoursDiff > 0 ? Math.floor(hoursDiff) : 0,
        days: daysDiff > 0 ? Math.floor(daysDiff) : 0,
        weeks: weeksDiff > 0 ? Math.floor(weeksDiff) : 0,
        months: monthsDiff > 0 ? Math.floor(monthsDiff) : 0
    };
};
const $0fdb21918de0480a$export$ae02811946c03a4b = (startDate, endDate)=>{
    const parsedStartDate = (0, $3xcI8.default)(startDate);
    const parsedEndDate = (0, $3xcI8.default)(endDate);
    const timeDifference = $0fdb21918de0480a$var$calculateTimeDifference(parsedStartDate, parsedEndDate);
    if (timeDifference.months > 0) return {
        timeUnit: 'MONTH',
        timeDigits: timeDifference.months.toString()
    };
    else if (timeDifference.weeks > 0) return {
        timeUnit: 'WEEK',
        timeDigits: timeDifference.weeks.toString()
    };
    else if (timeDifference.days > 0) return {
        timeUnit: 'DAY',
        timeDigits: timeDifference.days.toString()
    };
    else return {
        timeUnit: 'HOUR',
        timeDigits: timeDifference.hours.toString()
    };
};
const $0fdb21918de0480a$export$9a8301702bf003c4 = (query)=>{
    let searchQuery = {};
    if (query.searchString) searchQuery = {
        ...searchQuery,
        searchString: query.searchString
    };
    if (query.startTimestamp && query.endTimestamp) searchQuery = {
        ...searchQuery,
        startTimestamp: query.startTimestamp,
        endTimestamp: query.endTimestamp
    };
    if (query.timeType) searchQuery = {
        ...searchQuery,
        timeType: query.timeType
    };
    if (query.eventCategories) searchQuery = {
        ...searchQuery,
        eventCategories: query.eventCategories
    };
    if (query.levels) searchQuery = {
        ...searchQuery,
        levels: query.levels
    };
    if (query.size) searchQuery = {
        ...searchQuery,
        size: query.size
    };
    return searchQuery;
};
function $0fdb21918de0480a$export$b06db0f8b326b929(startTimestamp, endTimestamp) {
    const startDateIntValue = parseInt(startTimestamp) / (0, $8rMiv.NANOSECONDS_IN_MILLISECOND);
    const endDateIntValue = parseInt(endTimestamp) / (0, $8rMiv.NANOSECONDS_IN_MILLISECOND);
    const { timeDigits: fromValue, timeUnit: fromUnit } = $0fdb21918de0480a$export$ae02811946c03a4b((0, $5Okns.default)(startDateIntValue), (0, $5Okns.default)(endDateIntValue));
    const params = $0fdb21918de0480a$export$42dac873831f0e2(new URLSearchParams({
        fromValue: fromValue,
        fromUnit: fromUnit
    }));
    const startTimestampParams = params.get('startTimestamp');
    const endTimestampParams = params.get('endTimestamp');
    (0, $6nbVQ.assert)(!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(startTimestampParams) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(endTimestampParams), new (0, $1bJvm.AssertionError)('calculateNewStartAndEndTimestamp', 'startTimestamp and endTimestamp should not be null'));
    return {
        startTimestamp: startTimestampParams,
        endTimestamp: endTimestampParams
    };
}
const $0fdb21918de0480a$export$74cb10c4b9924e49 = (importantField, raw, isImportantFieldEmpty)=>{
    if (!importantField || !raw) return true;
    const parsedImportantField = JSON.parse(importantField);
    const parsedRaw = JSON.parse(raw);
    return ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(parsedImportantField) || isImportantFieldEmpty === true) && (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(parsedRaw);
};
const $0fdb21918de0480a$export$130612b33e678a37 = ()=>{
    const params = $0fdb21918de0480a$export$42dac873831f0e2(new URLSearchParams({
        fromUnit: 'MONTH',
        fromValue: '1'
    }));
    const startDate = params.get('startTimestamp');
    const endDate = params.get('endTimestamp');
    (0, $6nbVQ.assert)(!!startDate && !!endDate, new (0, $1bJvm.AssertionError)('generateParamsForOneMonthInterval', 'startTimestamp and endDate should not be null'));
    return {
        dateTimeValue: {
            startDate: startDate,
            endDate: endDate
        },
        timeType: (0, $ch4Lm.TimeRadioOptions).WITHIN_THE_LAST
    };
};
const $0fdb21918de0480a$export$e083dc64e00e053b = (level)=>{
    const BASE_OFFSET = 18;
    return `${(0, $8rMiv.DETAIL_ITEM_BASE_WIDTH) - level * BASE_OFFSET}px`;
};
const $0fdb21918de0480a$export$c6631e198cf7c0f4 = (search)=>{
    const splittedSearch = search.split(/source=/i);
    if (splittedSearch.length > 1) return decodeURIComponent(splittedSearch[1]);
    return '';
};
function $0fdb21918de0480a$export$59302306c6f78677(fragment, key) {
    const { nodeName: nodeName, nodeType: nodeType, childNodes: childNodes, textContent: textContent } = fragment;
    if (nodeType === Node.TEXT_NODE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
        key: key
    }, textContent);
    const children = [];
    childNodes.forEach((childNode, i)=>{
        const markup = $0fdb21918de0480a$export$59302306c6f78677(childNode, String(i));
        if (markup) children.push(markup);
    });
    switch(nodeName){
        case 'B':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", {
                key: key
            }, children);
        case 'I':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("i", {
                key: key
            }, children);
        case 'STRONG':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", {
                key: key
            }, children);
        case 'EM':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("em", {
                key: key
            }, children);
        case 'CODE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("code", {
                key: key
            }, children);
    }
    if (children.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
        key: key
    }, children[0]);
    if (children.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        key: key
    }, children);
    return null;
}
const $0fdb21918de0480a$export$9a858fe3837c0be0 = (urlParams, response)=>{
    if (urlParams.get('startTimestamp') && urlParams.get('endTimestamp')) return {
        ...response,
        data: {
            ...response.data,
            pagination: {
                ...response.data.pagination,
                calcStartDate: urlParams.get('startTimestamp'),
                calcEndDate: urlParams.get('endTimestamp')
            }
        }
    };
    return response;
};

});
parcelRegister("ch4Lm", function(module, exports) {

$parcel$export(module.exports, "TimeRadioOptions", () => $b61da2437ea42d20$export$ff1338756af30600);
var $b61da2437ea42d20$export$ff1338756af30600;
(function(TimeRadioOptions) {
    TimeRadioOptions["WITHIN_THE_LAST"] = "withinTheLast";
    TimeRadioOptions["BETWEEN"] = "between";
})($b61da2437ea42d20$export$ff1338756af30600 || ($b61da2437ea42d20$export$ff1338756af30600 = {}));

});

parcelRegister("grM5e", function(module, exports) {

$parcel$export(module.exports, "RANGE_OPTIONS", () => $cf9f503ffe400615$export$a0f3448347834e6b);
const $cf9f503ffe400615$export$a0f3448347834e6b = [
    'HOUR',
    'DAY',
    'WEEK',
    'MONTH'
];

});

parcelRegister("8rMiv", function(module, exports) {

$parcel$export(module.exports, "PAGE_SIZE_QUERY_PARAM", () => $e0e8f94b0e82b12e$export$4b254bc84a71033a);
$parcel$export(module.exports, "NANOSECONDS_IN_MILLISECOND", () => $e0e8f94b0e82b12e$export$753f41e31eccb6d7);
$parcel$export(module.exports, "getHeaderWidths", () => $e0e8f94b0e82b12e$export$8aa6dbdb947f7df1);
$parcel$export(module.exports, "DETAIL_ITEM_BASE_WIDTH", () => $e0e8f94b0e82b12e$export$1220f90483bde21);

var $XHGTv = parcelRequire("XHGTv");
const $e0e8f94b0e82b12e$export$4b254bc84a71033a = 'size';
const $e0e8f94b0e82b12e$export$753f41e31eccb6d7 = 1000000;
const $e0e8f94b0e82b12e$export$8aa6dbdb947f7df1 = (params)=>{
    const { DATE_HEADER_WIDTH: DATE_HEADER_WIDTH, CATEGORY_HEADER_WIDTH: CATEGORY_HEADER_WIDTH, TYPE_HEADER_WIDTH: TYPE_HEADER_WIDTH, ACTOR_HEADER_WIDTH: ACTOR_HEADER_WIDTH } = params.showEventCategoryField ? {
        // Widths for audit logs page
        DATE_HEADER_WIDTH: 16,
        CATEGORY_HEADER_WIDTH: 16,
        TYPE_HEADER_WIDTH: 10,
        ACTOR_HEADER_WIDTH: 16
    } : {
        // Widths for integration-specific log page
        DATE_HEADER_WIDTH: 14,
        CATEGORY_HEADER_WIDTH: 0,
        TYPE_HEADER_WIDTH: 12,
        ACTOR_HEADER_WIDTH: 22
    };
    const columnsToShow = [
        DATE_HEADER_WIDTH,
        CATEGORY_HEADER_WIDTH,
        TYPE_HEADER_WIDTH,
        ...(0, $XHGTv.getBooleanFF)('platform.pun.audit-logs-actor-column_sxmw6') ? [
            ACTOR_HEADER_WIDTH
        ] : []
    ];
    let sum = 0;
    columnsToShow.forEach((width)=>{
        sum += width;
    });
    return {
        DATE_HEADER_WIDTH: `${DATE_HEADER_WIDTH}%`,
        CATEGORY_HEADER_WIDTH: `${CATEGORY_HEADER_WIDTH}%`,
        TYPE_HEADER_WIDTH: `${TYPE_HEADER_WIDTH}%`,
        ACTOR_HEADER_WIDTH: `${ACTOR_HEADER_WIDTH}%`,
        CHANGE_SUMMARY_HEADER_WIDTH: `${100 - sum}%`
    };
};
const $e0e8f94b0e82b12e$export$1220f90483bde21 = 250;

});

parcelRegister("3izuG", function(module, exports) {

$parcel$export(module.exports, "default", () => $96d1a907ddde3fa0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $96d1a907ddde3fa0$var$messages = (0, $90IgZ.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.customer-logs.common.utils.validation-message-before-greater-than-after.no-translate`,
        defaultMessage: 'Specify a valid time range.',
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.customer-logs.common.utils.validation-message-invalid-date-format.no-translate`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validationMessageAtLeastOneValue: {
        id: `eoc.customer-logs.common.utils.validation-message-at-least-one-value.no-translate`,
        defaultMessage: 'Select at least one value.',
        description: 'Message displayed to the user when there is no selected before and end date together'
    }
});
var $96d1a907ddde3fa0$export$2e2bcd8739ae039 = $96d1a907ddde3fa0$var$messages;

});




parcelRegister("2N7LD", function(module, exports) {

$parcel$export(module.exports, "uiSettingsResource", () => $20e0201305554b19$export$f2b33518cf31cd40);

var $lB25E = parcelRequire("lB25E");

var $aZgnG = parcelRequire("aZgnG");
const $20e0201305554b19$export$f2b33518cf31cd40 = (0, $lB25E.createResource)({
    type: 'ui-settings-resource',
    getKey: ()=>'ui-settings-resource',
    getData: async ()=>(0, $aZgnG.fetchUiSettingsEndpoint)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("aZgnG", function(module, exports) {

$parcel$export(module.exports, "fetchUiSettingsEndpoint", () => $42518d5496cc98c2$export$ea2f12bcbdce2020);

var $kRdYM = parcelRequire("kRdYM");
const $42518d5496cc98c2$export$ea2f12bcbdce2020 = async ()=>{
    return (0, $kRdYM.eocFetch)('/v1/logs');
};

});


parcelRegister("90Qu9", function(module, exports) {

$parcel$export(module.exports, "resources", () => $b7e22cd03815733d$export$bc99aaabaf7b70a7);

var $jvqQz = parcelRequire("jvqQz");

var $6DMBV = parcelRequire("6DMBV");

var $7t4Su = parcelRequire("7t4Su");
const $b7e22cd03815733d$export$bc99aaabaf7b70a7 = {
    configuredIntegrationsResource: $jvqQz.configuredIntegrationsResource,
    integrationListResource: $6DMBV.integrationListResource,
    userAccessRightsResource: $7t4Su.userAccessRightsResource
};

});
parcelRegister("jvqQz", function(module, exports) {

$parcel$export(module.exports, "configuredIntegrationsResource", () => $c7fba33ddf09ea55$export$4136019b80be5917);

var $lB25E = parcelRequire("lB25E");

var $4KEIv = parcelRequire("4KEIv");

var $3ZGEi = parcelRequire("3ZGEi");

const $c7fba33ddf09ea55$export$4136019b80be5917 = (0, $lB25E.createResource)({
    type: 'configuredIntegrationsResource',
    getKey: ({ query: query, match: match })=>{
        const teamId = match.params.teamId ?? query['teamId'];
        const group = query['group'];
        const keyword = query['keyword'];
        const status = query['status'];
        const page = query['page'] || '1';
        return (0, $4KEIv.UrlHelper)((0, $6fcfee975cb7a5d5$export$bc7daa294a7c75e4), {
            [(0, $6fcfee975cb7a5d5$export$d26137cf824a9e53)]: page,
            [(0, $6fcfee975cb7a5d5$export$299579ccbdd63cbc)]: keyword,
            [(0, $6fcfee975cb7a5d5$export$d7415cfdee4bffc8)]: group,
            [(0, $6fcfee975cb7a5d5$export$ce2c93e90dda8613)]: status,
            [(0, $6fcfee975cb7a5d5$export$4e0ddb4dc97eb573)]: teamId
        });
    },
    getData: (routerContext)=>(0, $3ZGEi.default).getIntegrations(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("4KEIv", function(module, exports) {

$parcel$export(module.exports, "UrlHelper", () => $68716bcba2d1f731$export$bacbc496e850c0a4);
const $68716bcba2d1f731$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    // Using %2C in URLs causes bugs in AngularJS, so we need to replace it with comma
    const qs = new URLSearchParams(q).toString().replace(/%2C/g, ',');
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("3ZGEi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9319910972864d6$export$2e2bcd8739ae039);

var $kRdYM = parcelRequire("kRdYM");

var $4KEIv = parcelRequire("4KEIv");

const $b9319910972864d6$var$getIntegrations = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $6b3bdc667bac7f11$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId ?? query.teamId,
        group: query.group,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $kRdYM.eocFetch)((0, $4KEIv.UrlHelper)('/v3/integrations/unified', {
        ...queryParams,
        offset: offset.toString(),
        limit: (0, $6b3bdc667bac7f11$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $6b3bdc667bac7f11$export$31ecae7225aecec6)),
            itemCount: response.data.count,
            platformTeamId: response.data.platformTeamId
        }));
};
const $b9319910972864d6$var$patchIntegration = async (integrationId, integrationType, body, teamId)=>(0, $kRdYM.eocFetch)((0, $4KEIv.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $b9319910972864d6$var$deleteIntegration = async (integrationId, integrationType, teamId)=>(0, $kRdYM.eocFetch)((0, $4KEIv.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
var $b9319910972864d6$export$2e2bcd8739ae039 = {
    getIntegrations: $b9319910972864d6$var$getIntegrations,
    patchIntegration: $b9319910972864d6$var$patchIntegration,
    deleteIntegration: $b9319910972864d6$var$deleteIntegration
};

});
const $6b3bdc667bac7f11$export$31ecae7225aecec6 = 20;


const $6fcfee975cb7a5d5$export$bc7daa294a7c75e4 = 'configuredIntegrationsResource';
const $6fcfee975cb7a5d5$export$d26137cf824a9e53 = 'page';
const $6fcfee975cb7a5d5$export$299579ccbdd63cbc = 'keyword';
const $6fcfee975cb7a5d5$export$d7415cfdee4bffc8 = 'group';
const $6fcfee975cb7a5d5$export$ce2c93e90dda8613 = 'status';
const $6fcfee975cb7a5d5$export$4e0ddb4dc97eb573 = 'teamId';


parcelRegister("6DMBV", function(module, exports) {

$parcel$export(module.exports, "integrationListResource", () => $c01137b107e414a7$export$f60a40a11a6e0ee4);

var $lB25E = parcelRequire("lB25E");

var $aEFpu = parcelRequire("aEFpu");
const $c01137b107e414a7$export$f60a40a11a6e0ee4 = (0, $lB25E.createResource)({
    type: 'integrationListResource',
    getKey: ({ query: query })=>{
        const group = query['group'];
        const keyword = query['keyword'];
        return `integrationListResource?group=${group}&keyword=${keyword}`;
    },
    getData: async (routerContext)=>await (0, $aEFpu.default).getIntegrationList(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("aEFpu", function(module, exports) {

$parcel$export(module.exports, "default", () => $77685d878d0471a1$export$2e2bcd8739ae039);

var $kRdYM = parcelRequire("kRdYM");

var $4KEIv = parcelRequire("4KEIv");
const $77685d878d0471a1$var$getIntegrationList = (query, teamId)=>{
    const { keyword: keyword, group: group } = query ?? {};
    return (0, $kRdYM.eocFetch)((0, $4KEIv.UrlHelper)(`/v3/integrations/unified/supported-integrations`, {
        keyword: keyword,
        group: group,
        teamId: teamId
    })).then((response)=>{
        const { labels: labels, availableGroups: availableGroups, allTypes: allTypes, platformTeamId: platformTeamId } = response.data;
        return {
            labels: labels,
            availableGroups: availableGroups,
            allTypes: allTypes,
            platformTeamId: platformTeamId
        };
    });
};
const $77685d878d0471a1$var$getIntegrationTypes = (integrationType, teamId)=>(0, $kRdYM.eocFetch)((0, $4KEIv.UrlHelper)(`/v3/integrations/unified/${integrationType}/types`, {
        teamId: teamId
    })).then((response)=>response.data.map((integrationType)=>({
                ...integrationType,
                value: integrationType.type,
                label: integrationType.displayName
            })));
var $77685d878d0471a1$export$2e2bcd8739ae039 = {
    getIntegrationList: $77685d878d0471a1$var$getIntegrationList,
    getIntegrationTypes: $77685d878d0471a1$var$getIntegrationTypes
};

});


parcelRegister("7t4Su", function(module, exports) {

$parcel$export(module.exports, "userAccessRightsResource", () => $b7a43488c3acf6eb$export$69ddc7cc64ae9a02);

var $lB25E = parcelRequire("lB25E");

var $5WQpK = parcelRequire("5WQpK");
const $b7a43488c3acf6eb$export$69ddc7cc64ae9a02 = (0, $lB25E.createResource)({
    type: 'userAccessRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params.teamId;
        return `userAccessRightsResource#${!!teamId ? teamId : ''}`;
    },
    getData: (routerContext)=>(0, $5WQpK.getUserRights)(routerContext.match.params.teamId),
    maxAge: 3600000,
    isBrowserOnly: true
});

});
parcelRegister("5WQpK", function(module, exports) {

$parcel$export(module.exports, "getUserRights", () => $705522d8eb74c331$export$84e2ed279bc4e64e);

var $kRdYM = parcelRequire("kRdYM");

var $4KEIv = parcelRequire("4KEIv");
const $705522d8eb74c331$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $kRdYM.eocFetch)((0, $4KEIv.UrlHelper)(`/v3/integrations/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data);
};

});



parcelRegister("j3qRC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("ie5fc")
]).then(()=>parcelRequire('jvF4C'));

});

parcelRegister("6GkpX", function(module, exports) {

$parcel$export(module.exports, "maintenanceResource", () => $3602afc4f90a5ff0$export$5486c78261efb2c3);
$parcel$export(module.exports, "maintenanceUserRightsResource", () => $3602afc4f90a5ff0$export$e4c92d8948e3625);
$parcel$export(module.exports, "resources", () => $3602afc4f90a5ff0$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");

var $l96PT = parcelRequire("l96PT");

var $5YDsW = parcelRequire("5YDsW");
const $3602afc4f90a5ff0$export$5486c78261efb2c3 = (0, $lB25E.createResource)({
    type: 'maintenanceResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `maintenance/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $5YDsW.getMaintenance)(teamId);
    },
    isBrowserOnly: true
});
const $3602afc4f90a5ff0$export$e4c92d8948e3625 = (0, $lB25E.createResource)({
    type: 'maintenanceUserRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `maintenance-user-rights/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $5YDsW.getMaintenanceUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $3602afc4f90a5ff0$export$bc99aaabaf7b70a7 = [
    ...(0, $l96PT.eocCommonResources)(),
    $3602afc4f90a5ff0$export$5486c78261efb2c3,
    $3602afc4f90a5ff0$export$e4c92d8948e3625
];

});
parcelRegister("5YDsW", function(module, exports) {

$parcel$export(module.exports, "getMaintenance", () => $a58fb32ae808365f$export$9cc878e1852c5ee1);
$parcel$export(module.exports, "deleteMaintenance", () => $a58fb32ae808365f$export$f64242288df38e86);
$parcel$export(module.exports, "cancelMaintenance", () => $a58fb32ae808365f$export$2d4a5362bda1b3c1);
$parcel$export(module.exports, "changeDateAndTime", () => $a58fb32ae808365f$export$2162fcbd04e23a3d);
$parcel$export(module.exports, "getMaintenanceUserRights", () => $a58fb32ae808365f$export$60048f3b7e7bf9b9);
$parcel$export(module.exports, "createMaintenance", () => $a58fb32ae808365f$export$602dd976bd963418);
$parcel$export(module.exports, "updateMaintenance", () => $a58fb32ae808365f$export$fa55cd063e1b15c2);

var $kRdYM = parcelRequire("kRdYM");
const $a58fb32ae808365f$export$9cc878e1852c5ee1 = (teamId)=>{
    return (0, $kRdYM.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances`);
};
const $a58fb32ae808365f$export$f64242288df38e86 = (teamId, id)=>{
    return (0, $kRdYM.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $a58fb32ae808365f$export$2d4a5362bda1b3c1 = (teamId, id)=>{
    return (0, $kRdYM.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/cancel`, {
        method: 'PATCH'
    });
};
const $a58fb32ae808365f$export$2162fcbd04e23a3d = (teamId, id, endDate)=>{
    return (0, $kRdYM.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/updateEndDate`, {
        method: 'PATCH',
        body: {
            endDate: endDate
        }
    });
};
const $a58fb32ae808365f$export$60048f3b7e7bf9b9 = (teamId)=>{
    return (0, $kRdYM.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/rights`);
};
const $a58fb32ae808365f$export$602dd976bd963418 = (payload, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances` : '/v1/maintenances';
    return (0, $kRdYM.eocFetch)(url, {
        method: 'POST',
        body: payload
    });
};
const $a58fb32ae808365f$export$fa55cd063e1b15c2 = (payload, id, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances/${id}` : `/v1/maintenances/${id}`;
    return (0, $kRdYM.eocFetch)(url, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("h4iG3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("b1W8G")
]).then(()=>parcelRequire('6Gps5'));

});

parcelRegister("a7OGS", function(module, exports) {

$parcel$export(module.exports, "getTeamResource", () => $8b11999da631018c$export$50271c9e7f21f10e);
$parcel$export(module.exports, "resources", () => $8b11999da631018c$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $hrYnD = parcelRequire("hrYnD");

var $8nw4Y = parcelRequire("8nw4Y");

var $iGIOA = parcelRequire("iGIOA");
const $8b11999da631018c$export$50271c9e7f21f10e = (0, $lB25E.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('getTeamResource', 'teamId should be set to fetch on-call'));
        return (0, $iGIOA.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $8b11999da631018c$export$bc99aaabaf7b70a7 = [
    ...(0, $8nw4Y.resources),
    (0, $hrYnD.routingRulesResource),
    $8b11999da631018c$export$50271c9e7f21f10e
];

});
parcelRegister("hrYnD", function(module, exports) {

$parcel$export(module.exports, "routingRulesResource", () => $4679719dec3c59a1$export$7f38c73dca88500e);

var $lB25E = parcelRequire("lB25E");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $kV6Wt = parcelRequire("kV6Wt");
const $4679719dec3c59a1$export$7f38c73dca88500e = (0, $lB25E.createResource)({
    type: 'routingRulesResource',
    getKey: ()=>'routingRulesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('routingRulesResource', 'teamId should be set to fetch routing-rules'));
        return (0, $kV6Wt.getRoutingRules)(teamId);
    },
    isBrowserOnly: true
});

});
parcelRegister("kV6Wt", function(module, exports) {

$parcel$export(module.exports, "getRoutingRules", () => $a3abc41b5efbd90a$export$425c24c86196521);

var $kRdYM = parcelRequire("kRdYM");
const $a3abc41b5efbd90a$export$425c24c86196521 = (teamId)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/routing-rules`);

});


parcelRegister("8nw4Y", function(module, exports) {

$parcel$export(module.exports, "getSchedulesResource", () => $10e4f4584125de31$export$6b2b3e2a53cc13e2);
$parcel$export(module.exports, "getUiPreferencesResource", () => $10e4f4584125de31$export$5c6454d866055bdd);
$parcel$export(module.exports, "getScheduleRightsResource", () => $10e4f4584125de31$export$9d9ecb8586783931);
$parcel$export(module.exports, "getScheduleTimeTemplatesResource", () => $10e4f4584125de31$export$90251855f07c54b4);
$parcel$export(module.exports, "resources", () => $10e4f4584125de31$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");

var $l96PT = parcelRequire("l96PT");

var $7F7oX = parcelRequire("7F7oX");

var $knKWx = parcelRequire("knKWx");

var $8sHJO = parcelRequire("8sHJO");

var $9Wj5K = parcelRequire("9Wj5K");

var $5Qf0r = parcelRequire("5Qf0r");

var $lPNHs = parcelRequire("lPNHs");
const $10e4f4584125de31$export$6b2b3e2a53cc13e2 = (0, $lB25E.createResource)({
    type: 'getSchedulesResource',
    getKey: ()=>'getSchedulesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $9Wj5K.endpoints).getScheduleList((0, $knKWx.getTeamIdFromContext)(routerExtendedContext))
});
const $10e4f4584125de31$export$5c6454d866055bdd = (0, $lB25E.createResource)({
    type: 'getSchedulePreferencesResource',
    getKey: ()=>'getSchedulePreferencesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $5Qf0r.endpoints).getUiPreferences((0, $knKWx.getTeamIdFromContext)(routerExtendedContext))
});
const $10e4f4584125de31$export$9d9ecb8586783931 = (0, $lB25E.createResource)({
    type: 'getScheduleRightsResource',
    getKey: ()=>'getScheduleRightsResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $lPNHs.endpoints).getScheduleRights((0, $knKWx.getTeamIdFromContext)(routerExtendedContext))
});
const $10e4f4584125de31$export$90251855f07c54b4 = (0, $lB25E.createResource)({
    type: 'getScheduleTimeTemplatesResource',
    getKey: ()=>'getScheduleTimeTemplatesResourceurce',
    isBrowserOnly: true,
    getData: async ()=>(0, $8sHJO.endpoints).getScheduleTimeTemplates()
});
const $10e4f4584125de31$export$bc99aaabaf7b70a7 = [
    $10e4f4584125de31$export$6b2b3e2a53cc13e2,
    $10e4f4584125de31$export$5c6454d866055bdd,
    $10e4f4584125de31$export$9d9ecb8586783931,
    $10e4f4584125de31$export$90251855f07c54b4,
    ...(0, $7F7oX.resources),
    ...(0, $l96PT.eocCommonResources)()
];

});
parcelRegister("7F7oX", function(module, exports) {

$parcel$export(module.exports, "getTimezonesResource", () => $0ca7875ad8a4c6d9$export$7524ea9fda8149c6);
$parcel$export(module.exports, "resources", () => $0ca7875ad8a4c6d9$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");

var $lwYDo = parcelRequire("lwYDo");
const $0ca7875ad8a4c6d9$export$7524ea9fda8149c6 = (0, $lB25E.createResource)({
    type: 'getEocTimezonesResource',
    getKey: ()=>'getEocTimezonesResource',
    isBrowserOnly: true,
    getData: async ()=>(0, $lwYDo.endpoints).getTimezones()
});
const $0ca7875ad8a4c6d9$export$bc99aaabaf7b70a7 = [
    $0ca7875ad8a4c6d9$export$7524ea9fda8149c6
];

});
parcelRegister("lwYDo", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $cd6813e84946caa3$export$3a2536d80ecc00e7);

var $kRdYM = parcelRequire("kRdYM");

var $imLwO = parcelRequire("imLwO");
const $cd6813e84946caa3$var$getTimezones = async ()=>{
    const response = await (0, $kRdYM.eocFetch)((0, $imLwO.urls).customers.timezones.url(), {
        method: 'GET'
    });
    const adjusted = response.timezones.map((timezone)=>({
            ...timezone,
            offset: timezone.offset * 60000,
            currentOffset: timezone.currentOffset * 60000
        }));
    return {
        ...response,
        timezones: adjusted
    };
};
const $cd6813e84946caa3$var$getTimeTemplates = ()=>{
    return (0, $kRdYM.eocFetch)((0, $imLwO.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $cd6813e84946caa3$export$3a2536d80ecc00e7 = {
    getTimezones: $cd6813e84946caa3$var$getTimezones,
    getTimeTemplates: $cd6813e84946caa3$var$getTimeTemplates
};

});
parcelRegister("imLwO", function(module, exports) {

$parcel$export(module.exports, "urls", () => $85185533f2f0d144$export$bcae9ba627f604b6);
const $85185533f2f0d144$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            }
        }
    },
    schedules: {
        url: ()=>`/v1/schedules`,
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    }
});

});



parcelRegister("knKWx", function(module, exports) {

$parcel$export(module.exports, "getTeamIdFromContext", () => $ed17561ea4070f84$export$3ea727bebc3792bb);

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $iC1vN = parcelRequire("iC1vN");
const $ed17561ea4070f84$export$3ea727bebc3792bb = (routerContext)=>{
    const teamId = (0, $iC1vN.getSafe)(()=>routerContext.match.params.teamId, null);
    (0, $6nbVQ.assert)(!(0, $iC1vN.isEmpty)(teamId), new (0, $1bJvm.AssertionError)('eoc-schedule', 'teamId in routerContext is not defined'));
    return teamId;
};

});
parcelRegister("iC1vN", function(module, exports) {

$parcel$export(module.exports, "getSafe", () => $cb18f89d3895eece$export$fedb900c0ea4e699);
$parcel$export(module.exports, "isEmpty", () => $cb18f89d3895eece$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isNullOrUndefined", () => $cb18f89d3895eece$export$bedb7023a7733221);
$parcel$export(module.exports, "noLeadingOrTrailingSpaces", () => $cb18f89d3895eece$export$5fc068d42db64a99);

var $diPBF = parcelRequire("diPBF");
const $cb18f89d3895eece$export$fedb900c0ea4e699 = (fn, defaultValue)=>{
    try {
        return fn();
    } catch  {
        return defaultValue;
    }
};
const $cb18f89d3895eece$export$dd1bc94b04021eeb = (input)=>{
    if (input !== 0 && input !== false && !input) return true;
    if (!(input instanceof Date) && typeof input === 'object' && Object.keys(input).length === 0) return true;
    return false;
};
const $cb18f89d3895eece$export$bedb7023a7733221 = (input)=>{
    return input === null || input === undefined;
};
const $cb18f89d3895eece$export$5fc068d42db64a99 = (message)=>({ formatMessage: formatMessage })=>(value)=>{
            if (typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '))) return message ?? formatMessage((0, $diPBF.messages).nameSpaceValidationError);
        };

});
parcelRegister("diPBF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0865fee6970cc610$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $0865fee6970cc610$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    /*
   Misc common messages
  */ noOne: {
        id: 'eoc-schedule.common.no-one',
        defaultMessage: 'No one',
        description: 'Name of the user whose type is no-one.'
    },
    error: {
        id: 'eoc-schedule.common.error',
        defaultMessage: 'Error',
        description: 'Just simple error message.'
    },
    tryAgain: {
        id: 'eoc-schedule.common.try-again',
        defaultMessage: 'Try again',
        description: 'Try again message when an error occurs.'
    },
    cancel: {
        id: 'eoc-schedule.common.cancel',
        defaultMessage: 'Cancel',
        description: 'A cancel button.'
    },
    confirm: {
        id: 'eoc-schedule.common.confirm',
        defaultMessage: 'Confirm',
        description: 'A confirm button.'
    },
    addOverride: {
        id: 'eoc-schedule.common.add-override',
        defaultMessage: 'Add override',
        description: 'Adding override for a period item.'
    },
    overrideButton: {
        id: 'eoc-schedule.common.override',
        defaultMessage: 'Override',
        description: 'A override button.'
    },
    saveButton: {
        id: 'eoc-schedule.common.save',
        defaultMessage: 'Save',
        description: 'A save button.'
    },
    edit: {
        id: 'eoc-schedule.common.edit',
        defaultMessage: 'Edit',
        description: 'Button for editing schedule.'
    },
    turnOff: {
        id: 'eoc-schedule.common.turn-off',
        defaultMessage: 'Turn off',
        description: 'Button for turn-offing schedule.'
    },
    turnOn: {
        id: 'eoc-schedule.common.turn-on',
        defaultMessage: 'Turn on',
        description: 'Button for turn-on schedule.'
    },
    delete: {
        id: 'eoc-schedule.common.delete',
        defaultMessage: 'Delete',
        description: 'Button for deleting schedule or rotation.'
    },
    duplicate: {
        id: 'eoc-schedule.common.duplicate',
        defaultMessage: 'Duplicate',
        description: 'Button for duplicating schedule or rotation.'
    },
    remove: {
        id: 'eoc-schedule.common.remove',
        defaultMessage: 'Remove',
        description: 'Button for removing participant.'
    },
    start: {
        id: 'eoc-schedule.common.start',
        defaultMessage: 'Start',
        description: 'Label for start time and date.'
    },
    end: {
        id: 'eoc-schedule.common.end',
        defaultMessage: 'End',
        description: 'Label for end time and date.'
    },
    startTime: {
        id: 'eoc-schedule.common.start-time',
        defaultMessage: 'Start time',
        description: 'Label for start time and date.'
    },
    endTime: {
        id: 'eoc-schedule.common.end-time',
        defaultMessage: 'End time',
        description: 'Label for end time and date.'
    },
    startDate: {
        id: 'eoc-schedule.common.start-date',
        defaultMessage: 'Start date',
        description: 'Label for start time and date.'
    },
    endDate: {
        id: 'eoc-schedule.common.end-date',
        defaultMessage: 'End date',
        description: 'Label for end time and date.'
    },
    team: {
        id: 'eoc-schedule.common.team',
        defaultMessage: 'Team',
        description: 'Label that indicates responder is of type: Team'
    },
    escalation: {
        id: 'eoc-schedule.common.escalation',
        defaultMessage: 'Escalation',
        description: 'Label that indicates responder is of type: Escalation'
    },
    schedule: {
        id: 'eoc-schedule.common.schedule',
        defaultMessage: 'Schedule',
        description: 'Label that indicates responder is of type: Schedule'
    },
    selectionCount: {
        id: 'eoc-schedule.common.selection-count',
        defaultMessage: '{count} shifts selected',
        description: 'Indicates how many shifts are selected for override.'
    },
    quickOverrideTitle: {
        id: 'eoc-schedule.common.quick-override-title',
        defaultMessage: 'OVERRIDE',
        description: 'Title for quick override card.'
    },
    search: {
        id: 'eoc-schedule.common.search',
        defaultMessage: 'Search',
        description: 'Label of search icon that shown inside search participant field'
    },
    replaceWith: {
        id: 'eoc-schedule.common.replace-with',
        defaultMessage: 'Replace with',
        description: 'A button for opening popup for replacing a participant.'
    },
    participants: {
        id: 'eoc-schedule.common.participants',
        defaultMessage: 'Participants',
        description: 'Label for participants.'
    },
    addParticipants: {
        id: 'eoc-schedule.common.add-participants',
        defaultMessage: 'Add people, teams, and escalation policies',
        description: 'Placeholder text for auto complete field for participants (responders).'
    },
    select: {
        id: 'eoc-schedule.common.select',
        defaultMessage: 'Select',
        description: 'Label that indicates selecting.'
    },
    teamDeleted: {
        id: 'eoc-schedule.common.team-deleted',
        defaultMessage: 'Team deleted',
        description: 'Fallback responder name that suggest team is deleted.'
    },
    deletedSchedule: {
        id: 'eoc-schedule.common.deleted-schedule',
        defaultMessage: 'Deleted schedule',
        description: 'Fallback responder name that suggest schedule is deleted.'
    },
    deletedEscalation: {
        id: 'eoc-schedule.common.deleted-escalation',
        defaultMessage: 'Deleted escalation',
        description: 'Fallback responder name that suggest escalation is deleted.'
    },
    formerUser: {
        id: 'eoc-schedule.common.former-user',
        defaultMessage: 'Former user',
        description: 'Fallback responder name that suggest user is deactivated or deleted.'
    },
    discard: {
        id: 'eoc-schedule.common.discard',
        defaultMessage: 'Discard',
        description: 'Button for discarding.'
    },
    confirmProceed: {
        id: 'eoc-schedule.common.confirm-proceed',
        defaultMessage: 'Are you sure to proceed?',
        description: 'A confirmation for proceeding.'
    },
    /*
   Common validation related messages
  */ required: {
        id: 'eoc-schedule.common.required',
        defaultMessage: 'This field is required.',
        description: 'A text that informs users that field should be filled.'
    },
    noSpaceAtEndOrStart: {
        id: 'eoc-schedule.common.no-space-at-end-or-start',
        defaultMessage: 'Field cannot contain spaces at start or end.',
        description: 'A text that informs users that field cannot start or end with spaces.'
    },
    maxLength: {
        id: 'eoc-schedule.common.max-length',
        defaultMessage: 'Field cannot be longer than {max} characters.',
        description: 'A text that informs users that field should be shorter than certain length.'
    },
    maxValue: {
        id: 'eoc-schedule.common.max-value',
        defaultMessage: 'Field should be less than {max}.',
        description: 'A text that informs users that field should be less than certain value.'
    },
    minValue: {
        id: 'eoc-schedule.common.min-value',
        defaultMessage: 'Enter digit 1 or more.',
        description: 'This sentence instructs the user to input a numeric value of at least 1 digit or greater.'
    },
    timePast: {
        id: 'eoc-schedule.common.time-past',
        defaultMessage: 'Time should be later than current time.',
        description: 'Validation error that indicates time values is in past.'
    },
    startLaterEnd: {
        id: 'eoc-schedule.common.start-later-end',
        defaultMessage: 'Start time should be earlier than the end time.',
        description: 'Validation error that indicates start time is later than the end time.'
    },
    endEarlierStart: {
        id: 'eoc-schedule.common.end-earlier-start',
        defaultMessage: 'End time should be later than the start time.',
        description: 'Validation error that indicates end time is earlier than the start time.'
    },
    startEndSame: {
        id: 'eoc-schedule.common.start-end-same',
        defaultMessage: 'Start and end time cannot be same.',
        description: 'Validation error that indicates start and end time should be different.'
    },
    thirtyMinuteInterval: {
        id: 'eoc-schedule.common.thirty-minute-intervals',
        defaultMessage: 'Time should be defined as 30 minute intervals.',
        description: 'Validation error that indicates time can be in 30 minutes intervals.'
    },
    nameSpaceValidationError: {
        id: 'eoc-schedule.common.name-space-validation-error',
        defaultMessage: 'The name cannot start or end with a space.',
        description: 'Error message for name validation when it starts or ends with a space'
    }
});

});



parcelRegister("8sHJO", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $01983298890142dd$export$3a2536d80ecc00e7);

var $kRdYM = parcelRequire("kRdYM");

var $kADwe = parcelRequire("kADwe");
const $01983298890142dd$var$orderRotation = ({ scheduleId: scheduleId, after: after, rotationId: rotationId })=>{
    return (0, $kRdYM.eocFetch)((0, $kADwe.urls).schedules.scheduleId.rotations.rotationId.order.url({
        rotationId: rotationId,
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            after: after
        }
    });
};
const $01983298890142dd$var$getRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $kRdYM.eocFetch)((0, $kADwe.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'GET'
    });
};
const $01983298890142dd$var$deleteRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $kRdYM.eocFetch)((0, $kADwe.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'DELETE'
    });
};
const $01983298890142dd$var$addRotation = ({ name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, hasEndTime: hasEndTime, rotationPeriod: rotationPeriod, scheduleId: scheduleId, timeTemplateId: timeTemplateId, timingType: timingType, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
    return (0, $kRdYM.eocFetch)((0, $kADwe.urls).schedules.scheduleId.rotations.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            rotationPeriod: rotationPeriod,
            startTimeRaw: startTimeRaw,
            endTimeRaw: endTimeRaw,
            hasEndTime: hasEndTime
        }
    });
};
const $01983298890142dd$var$editRotation = ({ id: id, name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, rotationPeriod: rotationPeriod, hasEndTime: hasEndTime, timingType: timingType, scheduleId: scheduleId, timeTemplateId: timeTemplateId, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
    return (0, $kRdYM.eocFetch)((0, $kADwe.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: id
    }), {
        method: 'PUT',
        body: {
            id: id,
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            rotationPeriod: rotationPeriod,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            startTimeRaw: startTimeRaw,
            endTimeRaw: endTimeRaw,
            hasEndTime: hasEndTime
        }
    });
};
const $01983298890142dd$var$getScheduleTimeTemplates = ()=>{
    return (0, $kRdYM.eocFetch)((0, $kADwe.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $01983298890142dd$export$3a2536d80ecc00e7 = {
    deleteRotation: $01983298890142dd$var$deleteRotation,
    getRotation: $01983298890142dd$var$getRotation,
    orderRotation: $01983298890142dd$var$orderRotation,
    addRotation: $01983298890142dd$var$addRotation,
    editRotation: $01983298890142dd$var$editRotation,
    getScheduleTimeTemplates: $01983298890142dd$var$getScheduleTimeTemplates
};

});
parcelRegister("kADwe", function(module, exports) {

$parcel$export(module.exports, "urls", () => $4d45260268b4e450$export$bcae9ba627f604b6);
const $4d45260268b4e450$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            }
        }
    },
    schedules: {
        url: ()=>`/v1/schedules`,
        teams: {
            teamId: {
                url: ({ teamId: teamId } = {
                    teamId: ':teamId'
                })=>`/v1/schedules/teams/${teamId}`,
                rights: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/schedules/teams/${teamId}/rights`
                }
            }
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    },
    uiPreference: {
        schedule: {
            team: {
                teamId: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/users/ui-preference/schedule/team/${teamId}`
                }
            }
        }
    },
    onboarding: {
        completeTask: {
            url: ()=>'/v1/onboarding/complete-task'
        }
    }
});

});


parcelRegister("9Wj5K", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $d5eaae076b5aab0b$export$3a2536d80ecc00e7);

var $kRdYM = parcelRequire("kRdYM");

var $kADwe = parcelRequire("kADwe");
const $d5eaae076b5aab0b$var$getScheduleList = (teamId)=>{
    return (0, $kRdYM.eocFetch)((0, $kADwe.urls).schedules.teams.teamId.url({
        teamId: teamId
    }));
};
const $d5eaae076b5aab0b$var$updateSchedule = ({ scheduleId: scheduleId, description: description, name: name, enabled: enabled, timezone: timezone })=>{
    return (0, $kRdYM.eocFetch)((0, $kADwe.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone
        }
    });
};
const $d5eaae076b5aab0b$var$deleteSchedule = ({ scheduleId: scheduleId })=>{
    return (0, $kRdYM.eocFetch)((0, $kADwe.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'DELETE'
    });
};
const $d5eaae076b5aab0b$export$3a2536d80ecc00e7 = {
    deleteSchedule: $d5eaae076b5aab0b$var$deleteSchedule,
    getScheduleList: $d5eaae076b5aab0b$var$getScheduleList,
    updateSchedule: $d5eaae076b5aab0b$var$updateSchedule
};

});

parcelRegister("5Qf0r", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $030fe29d7fa3e786$export$3a2536d80ecc00e7);

var $kRdYM = parcelRequire("kRdYM");

var $kADwe = parcelRequire("kADwe");
const $030fe29d7fa3e786$var$getUiPreferences = (teamId)=>{
    return (0, $kRdYM.eocFetch)((0, $kADwe.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }));
};
const $030fe29d7fa3e786$var$updateUiPreferences = ({ teamId: teamId, key: key, value: value })=>{
    return (0, $kRdYM.eocFetch)((0, $kADwe.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }), {
        method: 'PATCH',
        body: {
            [key]: value
        }
    });
};
const $030fe29d7fa3e786$export$3a2536d80ecc00e7 = {
    getUiPreferences: $030fe29d7fa3e786$var$getUiPreferences,
    updateUiPreferences: $030fe29d7fa3e786$var$updateUiPreferences
};

});

parcelRegister("lPNHs", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $fe054d94e4f1dff1$export$3a2536d80ecc00e7);

var $kRdYM = parcelRequire("kRdYM");

var $kADwe = parcelRequire("kADwe");
const $fe054d94e4f1dff1$var$getScheduleRights = (teamId)=>{
    return (0, $kRdYM.eocFetch)((0, $kADwe.urls).schedules.teams.teamId.rights.url({
        teamId: teamId
    }));
};
const $fe054d94e4f1dff1$var$createSchedule = ({ description: description, name: name, teamId: teamId, timezone: timezone })=>{
    return (0, $kRdYM.eocFetch)((0, $kADwe.urls).schedules.url(), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            teamId: teamId,
            timezone: timezone,
            // Created schedules are enabled by default
            enabled: true
        }
    });
};
const $fe054d94e4f1dff1$var$cloneSchedule = ({ description: description, name: name, enabled: enabled, timezone: timezone, teamId: teamId, scheduleId: scheduleId })=>{
    return (0, $kRdYM.eocFetch)((0, $kADwe.urls).schedules.scheduleId.clone.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone,
            teamId: teamId
        }
    });
};
const $fe054d94e4f1dff1$export$3a2536d80ecc00e7 = {
    createSchedule: $fe054d94e4f1dff1$var$createSchedule,
    getScheduleRights: $fe054d94e4f1dff1$var$getScheduleRights,
    cloneSchedule: $fe054d94e4f1dff1$var$cloneSchedule
};

});


parcelRegister("iGIOA", function(module, exports) {

$parcel$export(module.exports, "getTeam", () => $1df662ecd3b905b8$export$491fe77f22ab2b51);

var $kRdYM = parcelRequire("kRdYM");
const $1df662ecd3b905b8$export$491fe77f22ab2b51 = (teamId)=>(0, $kRdYM.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });

});


parcelRegister("2t3Fl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("bqnqx")
]).then(()=>parcelRequire('8auXY'));

});

parcelRegister("4e1pR", function(module, exports) {

$parcel$export(module.exports, "getTeamsResource", () => $f97df4147236985b$export$27d854bd39923fc7);
// eslint-disable-next-line jira/import-whitelist

var $jAMe6 = parcelRequire("jAMe6");
var $jCPe6 = parcelRequire("jCPe6");

var $lB25E = parcelRequire("lB25E");
const $f97df4147236985b$export$27d854bd39923fc7 = (0, $lB25E.createResource)({
    type: (0, $jCPe6.getTeamsResource).type,
    getKey: (0, $jCPe6.getTeamsResource).getKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } })=>{
        if (!atlassianAccountId) return null;
        const shouldSeeAllTeams = isSiteAdmin || isAdmin;
        return (0, $jAMe6.getTeams)({
            queryParams: {
                accountId: !shouldSeeAllTeams ? atlassianAccountId : undefined,
                showAvatar: true
            }
        });
    },
    isBrowserOnly: true,
    maxAge: 0
});

});
parcelRegister("jAMe6", function(module, exports) {

$parcel$export(module.exports, "getTeams", () => $6f79b313ea519388$export$5a622455e94bac3);

var $kRdYM = parcelRequire("kRdYM");
const $6f79b313ea519388$export$5a622455e94bac3 = ({ url: url, queryParams: queryParams })=>{
    const params = new URLSearchParams();
    if (queryParams.keyword) params.append('keyword', queryParams.keyword);
    if (queryParams.size) params.append('size', queryParams.size.toString());
    if (queryParams.offset) params.append('offset', queryParams.offset.toString());
    if (queryParams.accountId) params.append('memberId', queryParams.accountId);
    if (queryParams.showAvatar) params.append('showAvatar', String(queryParams.showAvatar));
    if (url) return (0, $kRdYM.eocFetch)(`${url}${params.toString() ? `?${params.toString()}` : ''}`, {
        exactUrl: true
    });
    return (0, $kRdYM.eocFetch)(`/v1/teams${params.toString() ? `?${params.toString()}` : ''}`);
};

});

parcelRegister("jCPe6", function(module, exports) {

$parcel$export(module.exports, "getTeamsResource", () => $0fcdfe87755825c5$export$27d854bd39923fc7);

var $lB25E = parcelRequire("lB25E");

var $jAMe6 = parcelRequire("jAMe6");
const $0fcdfe87755825c5$export$27d854bd39923fc7 = (0, $lB25E.createResource)({
    type: 'getTeamsResource',
    getKey: ()=>'overview',
    getData: async ()=>{
        throw new Error('getData of getTeamsResource is not implemented in platform package, you should do it in your product');
    },
    isBrowserOnly: true
});

});


parcelRegister("joHFD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ib43z")
]).then(()=>parcelRequire('fKnUr'));

});

parcelRegister("3h9Fz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("1wtjK")
]).then(()=>parcelRequire('ksDxV'));

});

parcelRegister("kI7MG", function(module, exports) {

$parcel$export(module.exports, "pageAccessResource", () => $8881742388743fdd$export$b0d36f8262140e35);
$parcel$export(module.exports, "memberRolesResource", () => $8881742388743fdd$export$5c4885c1f1a535b);
$parcel$export(module.exports, "getTeamResource", () => $8881742388743fdd$export$50271c9e7f21f10e);
$parcel$export(module.exports, "customTeamRolesResource", () => $8881742388743fdd$export$ed1eb48699cf7893);
$parcel$export(module.exports, "resources", () => $8881742388743fdd$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $gcKp0 = parcelRequire("gcKp0");
const $8881742388743fdd$var$mapStatus = (status, userAccessLevel)=>{
    if (userAccessLevel === 'INTERNAL_INACTIVE') return 'suspended';
    if (status === 'REQUEST_ACCESS' || status === 'DENIED_REQUEST_EXISTS' || status === 'FORBIDDEN' || status === 'DIRECT_ACCESS') return 'invite';
    if (status === 'ACCESS_EXISTS') return 'member';
    if (status === 'PENDING_REQUEST_EXISTS') return 'pending';
    if (status === '' || status === undefined) return 'member';
    return 'invite';
};
const $8881742388743fdd$var$checkPageAccessRightsOnRouteDependency = async (dependencies)=>{
    let isAuthorizedToSeeMemberRolesPage = false;
    if (dependencies[$8881742388743fdd$var$PAGE_ACCESS_RESOURCE_TYPE]) {
        const data = await dependencies[$8881742388743fdd$var$PAGE_ACCESS_RESOURCE_TYPE].promise;
        isAuthorizedToSeeMemberRolesPage = data?.productOrTeamAdmin;
    }
    return isAuthorizedToSeeMemberRolesPage;
};
const $8881742388743fdd$var$PAGE_ACCESS_RESOURCE_TYPE = 'pageAccessResource';
const $8881742388743fdd$export$b0d36f8262140e35 = (0, $lB25E.createResource)({
    type: $8881742388743fdd$var$PAGE_ACCESS_RESOURCE_TYPE,
    getKey: ()=>'pageAccessResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('pageAccessResource', 'teamId should be set to fetch page access'));
        return (0, $gcKp0.getMemberRolesPageAccess)(teamId);
    },
    isBrowserOnly: true
});
const $8881742388743fdd$export$5c4885c1f1a535b = (0, $lB25E.createResource)({
    type: 'memberRolesResource',
    getKey: ()=>'memberRolesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        const dependencies = routerContext.dependencies;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('memberRolesResource', 'teamId should be set to fetch member-roles'));
        const isAuthorizedToSeeMemberRolesPage = await $8881742388743fdd$var$checkPageAccessRightsOnRouteDependency(dependencies);
        if (!isAuthorizedToSeeMemberRolesPage) return null;
        const gqlResponse = await (0, $gcKp0.getMembers)(teamId);
        let members = [];
        members = gqlResponse?.data.team.teamV2.members.edges.map((edge)=>edge.node.member);
        const teamMembers = await (0, $gcKp0.getRoleAndJSMLicenseInfoEndpoint)({
            platformTeamId: teamId,
            accountIds: members.map((member)=>member.accountId)
        }).then((res)=>{
            const users = members.map((user)=>{
                const userWithRole = res.teamMembers.find((userWithRole)=>userWithRole.accountId === user.accountId);
                return {
                    ...user,
                    role: userWithRole?.roleId || 'user',
                    jsmLicense: userWithRole?.jsmLicense || false,
                    jiraAdmin: userWithRole?.jiraAdmin || false,
                    invitationStatus: 'member'
                };
            });
            return users;
        });
        const membersWithoutJSMLicense = teamMembers.filter((teamMembers)=>!teamMembers.jsmLicense);
        if (membersWithoutJSMLicense.length > 0) {
            const accountIds = membersWithoutJSMLicense.map((member)=>member.accountId).join(',');
            const membersWithFullInfo = await (0, $gcKp0.getJSMInvitationStatusInfoEndpoint)({
                accountIds: accountIds
            }).then((res)=>{
                const users = teamMembers.map((user)=>{
                    const userWithInvitationStatus = res.embeddedValue.find((userWithInvitationStatus)=>userWithInvitationStatus.accountId === user.accountId);
                    return {
                        ...user,
                        invitationStatus: $8881742388743fdd$var$mapStatus(userWithInvitationStatus?.accessMode, userWithInvitationStatus?.userAccessLevel)
                    };
                });
                return users;
            }).catch((err)=>{
                return teamMembers;
            });
            return membersWithFullInfo;
        }
        return teamMembers;
    },
    isBrowserOnly: true,
    depends: [
        $8881742388743fdd$var$PAGE_ACCESS_RESOURCE_TYPE
    ]
});
const $8881742388743fdd$export$50271c9e7f21f10e = (0, $lB25E.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('getTeamResource', 'teamId should be set to fetch team info on member roles'));
        return (0, $gcKp0.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $8881742388743fdd$export$ed1eb48699cf7893 = (0, $lB25E.createResource)({
    type: 'customTeamRolesResource',
    getKey: ()=>'customRolesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        const dependencies = routerContext.dependencies;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('customTeamRolesResource', 'teamId should be set to fetch custom-team-roles'));
        const isAuthorizedToSeeMemberRolesPage = await $8881742388743fdd$var$checkPageAccessRightsOnRouteDependency(dependencies);
        if (!isAuthorizedToSeeMemberRolesPage) return null;
        return (0, $gcKp0.getCustomTeamRolesEndpoint)(teamId);
    },
    isBrowserOnly: true,
    depends: [
        $8881742388743fdd$var$PAGE_ACCESS_RESOURCE_TYPE
    ]
});
const $8881742388743fdd$export$bc99aaabaf7b70a7 = [
    $8881742388743fdd$export$5c4885c1f1a535b,
    $8881742388743fdd$export$50271c9e7f21f10e,
    $8881742388743fdd$export$ed1eb48699cf7893
];

});
parcelRegister("gcKp0", function(module, exports) {

$parcel$export(module.exports, "getMembers", () => $02a7b3055dd7fb37$export$f4931e6f9feb30c5);
$parcel$export(module.exports, "getMemberRolesPageAccess", () => $02a7b3055dd7fb37$export$95d4c4e762437fdd);
$parcel$export(module.exports, "getRoleAndJSMLicenseInfoEndpoint", () => $02a7b3055dd7fb37$export$38ab389cb64a5000);
$parcel$export(module.exports, "getJSMInvitationStatusInfoEndpoint", () => $02a7b3055dd7fb37$export$fd43007da8683026);
$parcel$export(module.exports, "getTeam", () => $02a7b3055dd7fb37$export$491fe77f22ab2b51);
$parcel$export(module.exports, "getCustomTeamRolesEndpoint", () => $02a7b3055dd7fb37$export$ebfa293eb1ef42f5);

var $kRdYM = parcelRequire("kRdYM");
var $3lxlO = parcelRequire("3lxlO");
const $02a7b3055dd7fb37$var$membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
  team {
    teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      id
      members {
        edges {
          cursor
          node {
            member {
              ... on AtlassianAccountUser {
                email
              }
              name
              picture
              accountId
              accountStatus
            }
            state
            role
          }
        }
      }
    }
  }
}
`;
const $02a7b3055dd7fb37$var$operationName = 'memberRolesTeamMembersQuery';
const $02a7b3055dd7fb37$export$f4931e6f9feb30c5 = (teamId)=>{
    const queryUrl = '/gateway/api/graphql';
    const teamAri = `ari:cloud:identity::team/${teamId}`;
    const siteId = (0, $3lxlO.getMeta)('ajs-cloud-id');
    return (0, $kRdYM.eocFetch)(queryUrl, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $02a7b3055dd7fb37$var$operationName,
            query: $02a7b3055dd7fb37$var$membersQueryV2,
            variables: {
                teamId: teamAri,
                siteId: siteId
            }
        }),
        headers: {
            'Content-Type': 'application/json',
            'X-ExperimentalApi': 'teams-beta, team-members-beta'
        },
        exactUrl: true
    });
};
const $02a7b3055dd7fb37$export$95d4c4e762437fdd = (teamId)=>(0, $kRdYM.eocFetch)(`/v1/teams/members/member-roles-page-access?platformTeamId=${teamId}`);
const $02a7b3055dd7fb37$export$38ab389cb64a5000 = ({ platformTeamId: platformTeamId, accountIds: accountIds })=>(0, $kRdYM.eocFetch)(`/v1/teams/members`, {
        method: 'POST',
        body: {
            platformTeamId: platformTeamId,
            accountIds: accountIds
        }
    });
const $02a7b3055dd7fb37$export$fd43007da8683026 = ({ accountIds: accountIds })=>(0, $kRdYM.eocFetch)(`/v1/users/access-request-capabilities?accountIds=${accountIds}`, {
        method: 'GET'
    });
const $02a7b3055dd7fb37$export$491fe77f22ab2b51 = (teamId)=>(0, $kRdYM.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });
const $02a7b3055dd7fb37$export$ebfa293eb1ef42f5 = (platformTeamId)=>(0, $kRdYM.eocFetch)(`/v1/teams/${platformTeamId}/roles`);

});


parcelRegister("cSbPW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("es4sa")
]).then(()=>parcelRequire('j4AQR'));

});

parcelRegister("gu8OT", function(module, exports) {

$parcel$export(module.exports, "teamPolicyResource", () => $ec78680d9e00e9ab$export$10d7fa513f08ef83);
$parcel$export(module.exports, "notificationPolicyResource", () => $ec78680d9e00e9ab$export$6d5f23d9118ad678);
$parcel$export(module.exports, "globalPolicyResource", () => $ec78680d9e00e9ab$export$7aed80da979a5112);
$parcel$export(module.exports, "resources", () => $ec78680d9e00e9ab$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");

var $grGsF = parcelRequire("grGsF");
const $ec78680d9e00e9ab$export$10d7fa513f08ef83 = (0, $lB25E.createResource)({
    type: 'teamPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-policy/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        // if there is no teamId, this means that we are on the global policy page.
        // so we can return null directly, instead of sending fetch request.
        if (!teamId) return null;
        return (0, $grGsF.getTeamPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $ec78680d9e00e9ab$export$6d5f23d9118ad678 = (0, $lB25E.createResource)({
    type: 'notificationPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `notification-policy/${teamId}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (!teamId) return;
        return (0, $grGsF.getNotificationPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $ec78680d9e00e9ab$export$7aed80da979a5112 = (0, $lB25E.createResource)({
    type: 'globalPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (teamId) return `global-policy/${teamId}`;
        return 'global-policy';
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $grGsF.getGlobalPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $ec78680d9e00e9ab$export$4cb385c2db8b1e99 = (0, $lB25E.createResource)({
    type: 'policyMaintenanceRightsResource',
    getKey: ()=>'policy-maintenance-rights-resource',
    getData: async ()=>{
        return (0, $grGsF.getPolicyMaintenanceRights)();
    },
    isBrowserOnly: true
});
const $ec78680d9e00e9ab$export$bc99aaabaf7b70a7 = [
    $ec78680d9e00e9ab$export$10d7fa513f08ef83,
    $ec78680d9e00e9ab$export$7aed80da979a5112,
    $ec78680d9e00e9ab$export$4cb385c2db8b1e99,
    $ec78680d9e00e9ab$export$6d5f23d9118ad678
];

});
parcelRegister("grGsF", function(module, exports) {

$parcel$export(module.exports, "getTeamPolicies", () => $51fc7c5f891b387e$export$fead0944caa1c797);
$parcel$export(module.exports, "getGlobalPolicies", () => $51fc7c5f891b387e$export$17fc7fbef061a8c3);
$parcel$export(module.exports, "getNotificationPolicies", () => $51fc7c5f891b387e$export$342525d9423e55ad);
$parcel$export(module.exports, "getPolicyMaintenanceRights", () => $51fc7c5f891b387e$export$f630cbf5586dce0a);
$parcel$export(module.exports, "updateUIPreferenceEndpoint", () => $51fc7c5f891b387e$export$6a437b43ab11275d);
$parcel$export(module.exports, "changePolicyOrderEndpoint", () => $51fc7c5f891b387e$export$57186d786c96b52a);
$parcel$export(module.exports, "enablePolicyEndpoint", () => $51fc7c5f891b387e$export$6fecd226d8e55346);
$parcel$export(module.exports, "disablePolicyEndpoint", () => $51fc7c5f891b387e$export$8c0cd218e00b7d9b);
$parcel$export(module.exports, "deletePolicyEndpoint", () => $51fc7c5f891b387e$export$f9feac6c1dcc516f);
$parcel$export(module.exports, "createPolicyEndpoint", () => $51fc7c5f891b387e$export$b0108c51b962e788);
$parcel$export(module.exports, "updatePolicyEndpoint", () => $51fc7c5f891b387e$export$8eabce250a2dd205);

var $kRdYM = parcelRequire("kRdYM");
const $51fc7c5f891b387e$export$fead0944caa1c797 = (teamId)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/policies?type=alert`);
};
const $51fc7c5f891b387e$export$17fc7fbef061a8c3 = (teamId)=>{
    if (teamId) return (0, $kRdYM.eocFetch)(`/v1/alerts/policies?preferredUITeamId=${teamId}`);
    return (0, $kRdYM.eocFetch)(`/v1/alerts/policies`);
};
const $51fc7c5f891b387e$export$342525d9423e55ad = (teamId)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/policies?type=notification`);
};
const $51fc7c5f891b387e$export$f630cbf5586dce0a = ()=>{
    return (0, $kRdYM.eocFetch)(`/v1/alerts/ui-preferences/policy-maintenance-rights`);
};
const $51fc7c5f891b387e$export$6a437b43ab11275d = ({ teamId: teamId, ...payload })=>{
    let url = `/v1/alerts/ui-preferences/policies`;
    if (teamId) url = `${url}?teamId=${teamId}`;
    return (0, $kRdYM.eocFetch)(url, {
        method: 'PATCH',
        body: payload,
        responseType: 'headers'
    });
};
const $51fc7c5f891b387e$export$57186d786c96b52a = (payload)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/order`, {
        method: 'PATCH',
        body: {
            after: payload.after
        },
        responseType: 'headers'
    });
};
const $51fc7c5f891b387e$export$6fecd226d8e55346 = (payload)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/enable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $51fc7c5f891b387e$export$8c0cd218e00b7d9b = (payload)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/disable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $51fc7c5f891b387e$export$f9feac6c1dcc516f = (payload)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $51fc7c5f891b387e$export$b0108c51b962e788 = (payload)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${payload.teamId}/policies`, {
        method: 'POST',
        body: payload
    });
};
const $51fc7c5f891b387e$export$8eabce250a2dd205 = (payload)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("4kZe2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("b1nE9")
]).then(()=>parcelRequire('1Ckuw'));

});

parcelRegister("4iKIJ", function(module, exports) {

$parcel$export(module.exports, "opsReportsResource", () => $070c1064a21b89e6$export$8498311fc7a4ab48);
$parcel$export(module.exports, "opsReportsPermissionResource", () => $070c1064a21b89e6$export$c432f280d76e2acf);
$parcel$export(module.exports, "resources", () => $070c1064a21b89e6$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $loAUy = parcelRequire("loAUy");

var $58fQV = parcelRequire("58fQV");
const $070c1064a21b89e6$export$8498311fc7a4ab48 = (0, $lB25E.createResource)({
    type: 'opsReportsResource',
    getKey: ()=>'opsReportsResource',
    getData: async ()=>{
        const settings = await (0, $58fQV.getReportSettings)();
        const api = (0, $58fQV.getDashboards);
        return {
            settings: settings,
            dashboards: settings.showReportingMaintenance ? null : await api()
        };
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $070c1064a21b89e6$export$c432f280d76e2acf = (0, $lB25E.createResource)({
    type: 'opsReportsPermissionResource',
    getKey: ({ match: match })=>{
        return `opsReportsPermissionResource-${match.params?.teamId}`;
    },
    getData: async (routerContext)=>{
        const isTeamDashboard = (0, $loAUy.isTeamReportsUrl)(routerContext.match.url);
        const teamId = routerContext.match.params?.teamId;
        (0, $6nbVQ.assert)(!isTeamDashboard || !!teamId, new (0, $1bJvm.AssertionError)('opsReportsPermissionResource', 'teamId should be set to fetch reports permissions on TeamDashboard page'));
        return (0, $58fQV.getReportRights)(teamId);
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $070c1064a21b89e6$export$bc99aaabaf7b70a7 = [
    $070c1064a21b89e6$export$8498311fc7a4ab48,
    $070c1064a21b89e6$export$c432f280d76e2acf
];

});
parcelRegister("loAUy", function(module, exports) {

$parcel$export(module.exports, "withReportingPrefix", () => $a8962a08e1e9ca69$export$c0f073d636267c44);
$parcel$export(module.exports, "isTeamReportsUrl", () => $a8962a08e1e9ca69$export$f923ac475871fcad);

var $3lxlO = parcelRequire("3lxlO");
function $a8962a08e1e9ca69$export$c0f073d636267c44(input) {
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = (0, $3lxlO.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jsm/ops/reporting/cloudId/${cloudId}/api` + input;
    return input;
}
const $a8962a08e1e9ca69$export$f923ac475871fcad = (pathName)=>pathName.startsWith('/jira/ops/teams/');

});

parcelRegister("58fQV", function(module, exports) {

$parcel$export(module.exports, "getDashboards", () => $89c55a4fa7de55b0$export$8e4b6d6c4fec08f3);
$parcel$export(module.exports, "getReportSettings", () => $89c55a4fa7de55b0$export$9114b8a872caf5d8);
$parcel$export(module.exports, "getSsoEmbedUrlEndpoint", () => $89c55a4fa7de55b0$export$8384a95746267bd8);
$parcel$export(module.exports, "getReportRights", () => $89c55a4fa7de55b0$export$f4a61c3c8c619f12);
$parcel$export(module.exports, "getAVPEmbedTokens", () => $89c55a4fa7de55b0$export$fb46892f83504a42);

var $kRdYM = parcelRequire("kRdYM");

var $loAUy = parcelRequire("loAUy");

var $dE7fR = parcelRequire("dE7fR");
const $89c55a4fa7de55b0$export$8e4b6d6c4fec08f3 = ()=>(0, $kRdYM.eocFetch)((0, $loAUy.withReportingPrefix)('/v5/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $dE7fR.opsReportsErrorTransformer
    });
const $89c55a4fa7de55b0$export$e69121e90ce0231b = ()=>(0, $kRdYM.eocFetch)((0, $loAUy.withReportingPrefix)('/v3/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $dE7fR.opsReportsErrorTransformer
    });
const $89c55a4fa7de55b0$export$9114b8a872caf5d8 = ()=>(0, $kRdYM.eocFetch)((0, $loAUy.withReportingPrefix)('/v3/reports/index'), {
        exactUrl: true,
        errorTransformer: $dE7fR.opsReportsErrorTransformer
    });
const $89c55a4fa7de55b0$export$8384a95746267bd8 = (isDarkMode, dashboardId, teamId)=>{
    const queryParam = teamId ? {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        teamId: teamId,
        // Adding time as queryParam to avoid browser caching
        // Should ideally be handled by "Cache-Control" header from server
        _: Date.now().toString()
    } : {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        _: Date.now().toString()
    };
    const url = `/v3/reports/dashboard?${new URLSearchParams(queryParam).toString()}`;
    return (0, $kRdYM.eocFetch)((0, $loAUy.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $dE7fR.opsReportsErrorTransformer
    });
};
const $89c55a4fa7de55b0$export$f4a61c3c8c619f12 = (teamId)=>{
    let url = '/v3/reports/rights';
    if (teamId) url += `?teamId=${teamId}`;
    return (0, $kRdYM.eocFetch)((0, $loAUy.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $dE7fR.opsReportsErrorTransformer
    });
};
const $89c55a4fa7de55b0$export$fb46892f83504a42 = (dashboardId, teamId)=>{
    let url = '/v3/reports/embed-token';
    return (0, $kRdYM.eocFetch)((0, $loAUy.withReportingPrefix)(url), {
        exactUrl: true,
        method: 'POST',
        body: {
            dashboardId: dashboardId,
            teamId: teamId
        },
        errorTransformer: $dE7fR.opsReportsErrorTransformer
    });
};

});
parcelRegister("dE7fR", function(module, exports) {

$parcel$export(module.exports, "opsReportsErrorTransformer", () => $d08678ce44ac424c$export$b170750bd4489531);

var $7JEKn = parcelRequire("7JEKn");
const $d08678ce44ac424c$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8)|("ISO-8859-1")|(ISO-8859-1))))/i;
const $d08678ce44ac424c$export$b170750bd4489531 = (e)=>{
    if ((0, $7JEKn.isHTTPError)(e)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $d08678ce44ac424c$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $7JEKn.StreamedHTTPError)(e, data, data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $7JEKn.StreamedHTTPError)(e, message, message));
    }
    return e;
};

});



parcelRegister("3mMNE", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("egBUa")),
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("fWdRW")
]).then(()=>parcelRequire('gznPP'));

});

parcelRegister("8tS6M", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationsResource", () => $7242f4100fb6a928$export$9a716bf20d804ec3);
$parcel$export(module.exports, "notificationDetailResource", () => $7242f4100fb6a928$export$8ad8a0a20fd0ed5a);
$parcel$export(module.exports, "resources", () => $7242f4100fb6a928$export$bc99aaabaf7b70a7);

var $lB25E = parcelRequire("lB25E");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $hcT4F = parcelRequire("hcT4F");
const $7242f4100fb6a928$export$9a716bf20d804ec3 = (0, $lB25E.createResource)({
    type: 'roleBasedNotificationsResource',
    getKey: ()=>'roleBasedNotificationsResource',
    getData: (0, $hcT4F.getRoleBasedNotificationsEndpoint),
    isBrowserOnly: true,
    maxAge: 300000
});
const $7242f4100fb6a928$export$8ad8a0a20fd0ed5a = (0, $lB25E.createResource)({
    type: 'notificationDetailResource',
    getKey: ({ match: match })=>{
        const settingId = match.params['id'];
        return `notificationDetailResource-id=${settingId}`;
    },
    getData: ({ match: match })=>{
        const settingId = match.params['id'];
        (0, $6nbVQ.assert)(!!settingId, new (0, $1bJvm.AssertionError)('notificationDetailResource', 'settingId is required'));
        return (0, $hcT4F.getRoleBasedNotificationDetailEndpoint)(settingId);
    },
    isBrowserOnly: true
});
const $7242f4100fb6a928$export$bc99aaabaf7b70a7 = [
    $7242f4100fb6a928$export$9a716bf20d804ec3,
    $7242f4100fb6a928$export$8ad8a0a20fd0ed5a
];

});
parcelRegister("hcT4F", function(module, exports) {

$parcel$export(module.exports, "getRoleBasedNotificationsEndpoint", () => $0e3dabd33bd17425$export$db67dfe9fe98cd49);
$parcel$export(module.exports, "getRoleBasedNotificationDetailEndpoint", () => $0e3dabd33bd17425$export$5522446e6d3ee73);

var $kRdYM = parcelRequire("kRdYM");
const $0e3dabd33bd17425$export$db67dfe9fe98cd49 = ()=>(0, $kRdYM.eocFetch)(`/v1/role-based-notifications`);
const $0e3dabd33bd17425$export$5522446e6d3ee73 = (settingId)=>(0, $kRdYM.eocFetch)(`/v1/role-based-notifications/${settingId}`);

});


parcelRegister("fkNXT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("lwvpE")
]).then(()=>parcelRequire('8b517'));

});

parcelRegister("cHWGN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("73kyd")
]).then(()=>parcelRequire('3rpmT'));

});

parcelRegister("ksvzS", function(module, exports) {

$parcel$export(module.exports, "transitioningDetailsResource", () => $b7ec7ac728833b3f$export$850d76e0c9ffbdeb);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $lB25E = parcelRequire("lB25E");
const $b7ec7ac728833b3f$export$7985153d37586c9a = (cloudId)=>(0, $lRmyA.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/transitioning-details`).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getTransitioningDetails',
                packageName: 'jiraRouterResourcesEocUnlockOperations',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
const $b7ec7ac728833b3f$export$850d76e0c9ffbdeb = (0, $lB25E.createResource)({
    type: 'EOC_UNLOCK_OPERATIONS',
    getKey: ()=>'eoc-unlock-operations',
    getData: async (_, { tenantContext: { cloudId: cloudId } })=>$b7ec7ac728833b3f$export$7985153d37586c9a(cloudId),
    maxAge: 0,
    isBrowserOnly: true
});

});

parcelRegister("9om2O", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("ha7fI")
]).then(()=>parcelRequire('95l0A'));

});

parcelRegister("eNkBQ", function(module, exports) {

$parcel$export(module.exports, "resources", () => $406b1f763d946835$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "widgetResources", () => $406b1f763d946835$export$bce3244764eac6e6);
$parcel$export(module.exports, "createMyTeamsResource", () => (parcelRequire("ldi2y")).createMyTeamsResource);
$parcel$export(module.exports, "createStatusResource", () => (parcelRequire("8OyG9")).createStatusResource);
$parcel$export(module.exports, "createUserTimelineResource", () => (parcelRequire("5zmGX")).createUserTimelineResource);
$parcel$export(module.exports, "createSchedulesResource", () => (parcelRequire("kmxJo")).createSchedulesResource);
parcelRequire("l96PT");
var $3liNr = parcelRequire("3liNr");

var $ldi2y = parcelRequire("ldi2y");

var $3heBy = parcelRequire("3heBy");

var $kmxJo = parcelRequire("kmxJo");

var $8OyG9 = parcelRequire("8OyG9");

var $5zmGX = parcelRequire("5zmGX");
const $406b1f763d946835$export$bc99aaabaf7b70a7 = [
    (0, $3liNr.eocUserResource),
    (0, $ldi2y.createMyTeamsResource)(),
    (0, $8OyG9.createStatusResource)(),
    (0, $3heBy.createOpsTeamsResource)()
];
const $406b1f763d946835$export$bce3244764eac6e6 = [
    ()=>(0, $3liNr.eocUserResource),
    (callback, depends)=>(0, $ldi2y.createMyTeamsResource)(callback, depends),
    (callback, depends)=>(0, $8OyG9.createStatusResource)(callback, depends),
    (callback, depends)=>(0, $5zmGX.createUserTimelineResource)(callback, depends),
    (callback, depends)=>(0, $kmxJo.createSchedulesResource)(callback, depends)
];

});
parcelRegister("ldi2y", function(module, exports) {

$parcel$export(module.exports, "createMyTeamsResource", () => $e02a76ee4e27babf$export$bf86fb90d0661bcb);

var $lB25E = parcelRequire("lB25E");

var $jMeLi = parcelRequire("jMeLi");
const $e02a76ee4e27babf$export$bf86fb90d0661bcb = (checkConsolidationOnRouteDependency, depends)=>(0, $lB25E.createResource)({
        type: 'myTeamsResource',
        getKey: ()=>'myTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $jMeLi.getMyTeamsEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("jMeLi", function(module, exports) {

$parcel$export(module.exports, "getMyTeamsEndpoint", () => $a964de975abd81a4$export$abe46da7d1f191a7);

var $kRdYM = parcelRequire("kRdYM");
const $a964de975abd81a4$export$abe46da7d1f191a7 = ()=>{
    return (0, $kRdYM.eocFetch)(`/v1/alerts/responders/suggested`);
};

});


parcelRegister("3heBy", function(module, exports) {

$parcel$export(module.exports, "createOpsTeamsResource", () => $2e1bdf83bca8c07b$export$99505a9d792f516c);

var $lB25E = parcelRequire("lB25E");

var $3JDg9 = parcelRequire("3JDg9");
const $2e1bdf83bca8c07b$export$99505a9d792f516c = (checkConsolidationOnRouteDependency, depends)=>(0, $lB25E.createResource)({
        type: 'opsTeamsResource',
        getKey: ()=>'opsTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $3JDg9.getOpsTeamsEndpoint)().then((response)=>{
                return response.values;
            });
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("3JDg9", function(module, exports) {

$parcel$export(module.exports, "getOpsTeamsEndpoint", () => $7e9cba7b673b91b5$export$7498ba30158c16cd);

var $kRdYM = parcelRequire("kRdYM");

var $2kksU = parcelRequire("2kksU");
const $7e9cba7b673b91b5$export$7498ba30158c16cd = ()=>{
    return (0, $kRdYM.eocFetch)((0, $2kksU.urls).teams.url());
};

});
parcelRegister("2kksU", function(module, exports) {

$parcel$export(module.exports, "urls", () => $c5aa61d7461e8627$export$bcae9ba627f604b6);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $c5aa61d7461e8627$export$a7c923252528b255);
$parcel$export(module.exports, "SPOTLIGHT_TOURS", () => $c5aa61d7461e8627$export$38c46ed7a5bc80a0);
$parcel$export(module.exports, "WhoIsOnCallHandler", () => $c5aa61d7461e8627$export$1e7191618d5d4548);
$parcel$export(module.exports, "WhoIsOnCallWidgetHandler", () => $c5aa61d7461e8627$export$d05bbb1ada0e07c4);
const $c5aa61d7461e8627$export$bcae9ba627f604b6 = Object.freeze({
    schedules: {
        url: ()=>`/v1/schedules`,
        user: {
            url: ()=>`${$c5aa61d7461e8627$export$bcae9ba627f604b6.schedules.url()}/user`,
            timeline: {
                url: ()=>`${$c5aa61d7461e8627$export$bcae9ba627f604b6.schedules.user.url()}/timeline`,
                export: {
                    url: ()=>`${$c5aa61d7461e8627$export$bcae9ba627f604b6.schedules.user.timeline.url()}/export`
                }
            },
            userId: {
                url: ({ userId: userId } = {
                    userId: ':userId'
                })=>`${$c5aa61d7461e8627$export$bcae9ba627f604b6.schedules.user.url()}/${userId}`
            }
        },
        onCalls: {
            url: ()=>`${$c5aa61d7461e8627$export$bcae9ba627f604b6.schedules.url()}/on-calls`
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`${$c5aa61d7461e8627$export$bcae9ba627f604b6.schedules.url()}/${scheduleId}`,
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`${$c5aa61d7461e8627$export$bcae9ba627f604b6.schedules.scheduleId.url({
                        scheduleId: scheduleId
                    })}/timeline`
            }
        }
    },
    wioc: {
        status: {
            url: ()=>`${$c5aa61d7461e8627$export$bcae9ba627f604b6.schedules.url()}/user/on-calls`
        }
    },
    teams: {
        url: ()=>`/v1/teams`
    }
});
const $c5aa61d7461e8627$export$a7c923252528b255 = {
    firstOverlappingPeriod: 'eoc-who-is-on-call_first_overlapping_period'
};
const $c5aa61d7461e8627$export$38c46ed7a5bc80a0 = {
    overlappingPeriod: 'eoc-who-is-on-call-overlapping-period'
};
class $c5aa61d7461e8627$export$1e7191618d5d4548 {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}
class $c5aa61d7461e8627$export$d05bbb1ada0e07c4 {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}

});



parcelRegister("kmxJo", function(module, exports) {

$parcel$export(module.exports, "createSchedulesResource", () => $f0d5a7b9a80ba32a$export$b5e65ca3f82b01c5);

var $lB25E = parcelRequire("lB25E");

var $4nRNC = parcelRequire("4nRNC");
const $f0d5a7b9a80ba32a$export$b5e65ca3f82b01c5 = (checkConsolidationOnRouteDependency, depends)=>(0, $lB25E.createResource)({
        type: 'schedulesResource',
        getKey: ()=>'schedulesResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $4nRNC.getSchedulesEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("4nRNC", function(module, exports) {

$parcel$export(module.exports, "getSchedulesEndpoint", () => $e2c6682c2266e098$export$e8e940098db1b988);

var $kRdYM = parcelRequire("kRdYM");

var $2kksU = parcelRequire("2kksU");
const $e2c6682c2266e098$export$e8e940098db1b988 = ()=>{
    return (0, $kRdYM.eocFetch)(`${(0, $2kksU.urls).schedules.onCalls.url()}`);
};

});


parcelRegister("8OyG9", function(module, exports) {

$parcel$export(module.exports, "createStatusResource", () => $5777af5f83f8d064$export$3d1c353e2693418c);

var $lB25E = parcelRequire("lB25E");

var $lURR1 = parcelRequire("lURR1");

var $bGRFi = parcelRequire("bGRFi");
const $5777af5f83f8d064$export$3d1c353e2693418c = (checkConsolidationOnRouteDependency, depends)=>(0, $lB25E.createResource)({
        type: 'statusResource',
        getKey: ()=>'statusResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $lURR1.getStatus)().then((0, $bGRFi.transformStatusResponse));
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("lURR1", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $3faecb3dad910045$export$b70265791d2079d4);

var $kRdYM = parcelRequire("kRdYM");

var $2kksU = parcelRequire("2kksU");
const $3faecb3dad910045$export$b70265791d2079d4 = ()=>{
    return (0, $kRdYM.eocFetch)((0, $2kksU.urls).wioc.status.url(), {
        method: 'GET'
    });
};

});

parcelRegister("bGRFi", function(module, exports) {

$parcel$export(module.exports, "transformStatusResponse", () => $09054f36e1ac6d7d$export$44a749c89534e42c);
const $09054f36e1ac6d7d$export$44a749c89534e42c = ({ currentTimeUtcMillis: currentTimeUtcMillis, onCallUntilUtcMillis: onCallUntilUtcMillis, onCallUntilOffsetMillis: onCallUntilOffsetMillis, isCurrentOnCall: isCurrentOnCall, isParticipantOfAnyRotation: isParticipantOfAnyRotation, nextOnCallEndUtcMillis: nextOnCallEndUtcMillis, nextOnCallEndOffsetMillis: nextOnCallEndOffsetMillis, nextOnCallStartUtcMillis: nextOnCallStartUtcMillis, nextOnCallStartOffsetMillis: nextOnCallStartOffsetMillis })=>{
    return {
        currentDate: currentTimeUtcMillis,
        currentShiftEnd: onCallUntilUtcMillis,
        currentShiftEndOffset: onCallUntilOffsetMillis,
        isOnCall: isCurrentOnCall,
        isParticipantOfAnyRotation: isParticipantOfAnyRotation,
        nextEndDate: nextOnCallEndUtcMillis,
        nextEndOffset: nextOnCallEndOffsetMillis,
        nextStartDate: nextOnCallStartUtcMillis,
        nextStartOffset: nextOnCallStartOffsetMillis
    };
};

});


parcelRegister("5zmGX", function(module, exports) {

$parcel$export(module.exports, "createUserTimelineResource", () => $fc888a2dc8855d41$export$a479dcc35c33def1);

var $lB25E = parcelRequire("lB25E");
parcelRequire("l96PT");
var $3liNr = parcelRequire("3liNr");

var $iVy8K = parcelRequire("iVy8K");
const $fc888a2dc8855d41$export$a479dcc35c33def1 = (checkConsolidationOnRouteDependency, depends)=>(0, $lB25E.createResource)({
        type: 'userTimelineResource',
        getKey: ()=>'userTimelineResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await dependencies[(0, $3liNr.eocUserResource).type]?.promise;
            // Since depends API types are not exported it's impossible to infer types,
            // thus we have to use casting
            const accountId = data?.accountId;
            const timezone = data?.timeZone;
            if (!accountId || !timezone) return null;
            return (0, $iVy8K.getWidgetTimeline)(accountId);
        },
        isBrowserOnly: true,
        depends: [
            ...depends ? depends : [],
            (0, $3liNr.eocUserResource).type
        ]
    });

});
parcelRegister("iVy8K", function(module, exports) {

$parcel$export(module.exports, "getWidgetTimeline", () => $d8b2f5c3c0c426d4$export$bd80cae08a85b1f0);

var $grFKL = parcelRequire("grFKL");

var $kRdYM = parcelRequire("kRdYM");

var $2kksU = parcelRequire("2kksU");

var $4Y1Ak = parcelRequire("4Y1Ak");
const $d8b2f5c3c0c426d4$export$bd80cae08a85b1f0 = (accountId)=>{
    const formattedCurrent = (0, $grFKL.default)(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSSXX");
    const urlParams = new URLSearchParams({
        currentDate: formattedCurrent,
        accountId: accountId,
        mode: 'timeline',
        timelineType: '6'
    });
    return (0, $kRdYM.eocFetch)(`${(0, $2kksU.urls).schedules.user.timeline.url()}?${urlParams.toString()}`, {
        method: 'GET'
    }).then((0, $4Y1Ak.transformUserTimelineResponse));
};

});
parcelRegister("grFKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf8f8e4d6aa69968$export$2e2bcd8739ae039);

var $1WmNj = parcelRequire("1WmNj");

var $5EElY = parcelRequire("5EElY");

var $ggskA = parcelRequire("ggskA");
function $bf8f8e4d6aa69968$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1WmNj)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $5EElY.default)((0, $ggskA.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("1WmNj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $169ce3b937cd7b12$var$cloneObject;

var $169ce3b937cd7b12$var$_index = $169ce3b937cd7b12$var$_interopRequireDefault((parcelRequire("5aZTm")));
function $169ce3b937cd7b12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $169ce3b937cd7b12$var$cloneObject(dirtyObject) {
    return (0, $169ce3b937cd7b12$var$_index.default)({}, dirtyObject);
}
module.exports = module.exports.default;

});
parcelRegister("5aZTm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3c4de5622d0e6607$var$assign;
function $3c4de5622d0e6607$var$assign(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}
module.exports = module.exports.default;

});


parcelRegister("5EElY", function(module, exports) {

$parcel$export(module.exports, "default", () => $41dffd809c16d6c3$export$2e2bcd8739ae039);

var $Yg8hb = parcelRequire("Yg8hb");

var $3bBes = parcelRequire("3bBes");

var $dPuS0 = parcelRequire("dPuS0");
var $41dffd809c16d6c3$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $41dffd809c16d6c3$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($41dffd809c16d6c3$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $dPuS0.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $3bBes.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yg8hb)))(dirtyDate, formatStr, options);
}

});
parcelRegister("Yg8hb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b521e49771b7554$var$format;

var $0b521e49771b7554$var$_index = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("ky7sH")));

var $0b521e49771b7554$var$_index2 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("1Bbnz")));

var $0b521e49771b7554$var$_index3 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("emeRN")));

var $0b521e49771b7554$var$_index4 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $0b521e49771b7554$var$_index5 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("69lef")));

var $0b521e49771b7554$var$_index6 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("frLM1")));

var $0b521e49771b7554$var$_index7 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("YdpzT")));

var $4ug6M = parcelRequire("4ug6M");

var $0b521e49771b7554$var$_index9 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $0b521e49771b7554$var$_index10 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $0b521e49771b7554$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $0b521e49771b7554$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $0b521e49771b7554$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $0b521e49771b7554$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $0b521e49771b7554$var$doubleQuoteRegExp = /''/g;
var $0b521e49771b7554$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $0b521e49771b7554$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $0b521e49771b7554$var$_index10.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || $0b521e49771b7554$var$_index2.default;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $0b521e49771b7554$var$_index9.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $0b521e49771b7554$var$_index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $0b521e49771b7554$var$_index9.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $0b521e49771b7554$var$_index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $0b521e49771b7554$var$_index4.default)(dirtyDate);
    if (!(0, $0b521e49771b7554$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $0b521e49771b7554$var$_index7.default)(originalDate);
    var utcDate = (0, $0b521e49771b7554$var$_index3.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($0b521e49771b7554$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $0b521e49771b7554$var$_index6.default[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($0b521e49771b7554$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $0b521e49771b7554$var$cleanEscapedString(substring);
        var formatter = $0b521e49771b7554$var$_index5.default[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $4ug6M.isProtectedWeekYearToken)(substring)) (0, $4ug6M.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $4ug6M.isProtectedDayOfYearToken)(substring)) (0, $4ug6M.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($0b521e49771b7554$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $0b521e49771b7554$var$cleanEscapedString(input) {
    return input.match($0b521e49771b7554$var$escapedStringRegExp)[1].replace($0b521e49771b7554$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});
parcelRegister("ky7sH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef5cc5628cfb5940$var$isValid;

var $ef5cc5628cfb5940$var$_index = $ef5cc5628cfb5940$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $ef5cc5628cfb5940$var$_index2 = $ef5cc5628cfb5940$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $ef5cc5628cfb5940$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */ function $ef5cc5628cfb5940$var$isValid(dirtyDate) {
    (0, $ef5cc5628cfb5940$var$_index2.default)(1, arguments);
    var date = (0, $ef5cc5628cfb5940$var$_index.default)(dirtyDate);
    return !isNaN(date);
}
module.exports = module.exports.default;

});
parcelRegister("8Ab9D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $63fa569256896d17$var$toDate;

var $63fa569256896d17$var$_index = $63fa569256896d17$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $63fa569256896d17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $63fa569256896d17$var$toDate(argument) {
    (0, $63fa569256896d17$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});
parcelRegister("lLZWw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd9e094e4a9a8b8d$var$requiredArgs;
function $fd9e094e4a9a8b8d$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});



parcelRegister("1Bbnz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12a212d2f4ff6049$var$_index = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("dWxGM")));

var $12a212d2f4ff6049$var$_index2 = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("hpyHJ")));

var $12a212d2f4ff6049$var$_index3 = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("loKOy")));

var $12a212d2f4ff6049$var$_index4 = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("2Jhnc")));

var $12a212d2f4ff6049$var$_index5 = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("3BeWb")));
function $12a212d2f4ff6049$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $12a212d2f4ff6049$var$locale = {
    code: 'en-US',
    formatDistance: $12a212d2f4ff6049$var$_index.default,
    formatLong: $12a212d2f4ff6049$var$_index2.default,
    formatRelative: $12a212d2f4ff6049$var$_index3.default,
    localize: $12a212d2f4ff6049$var$_index4.default,
    match: $12a212d2f4ff6049$var$_index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $12a212d2f4ff6049$var$_default = $12a212d2f4ff6049$var$locale;
module.exports.default = $12a212d2f4ff6049$var$_default;
module.exports = module.exports.default;

});
parcelRegister("dWxGM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a26ad313d3dbf920$var$formatDistance;
var $a26ad313d3dbf920$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $a26ad313d3dbf920$var$formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof $a26ad313d3dbf920$var$formatDistanceLocale[token] === 'string') result = $a26ad313d3dbf920$var$formatDistanceLocale[token];
    else if (count === 1) result = $a26ad313d3dbf920$var$formatDistanceLocale[token].one;
    else result = $a26ad313d3dbf920$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
}
module.exports = module.exports.default;

});

parcelRegister("hpyHJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cacfb1041f875450$var$_index = $cacfb1041f875450$var$_interopRequireDefault((parcelRequire("9kdSS")));
function $cacfb1041f875450$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cacfb1041f875450$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $cacfb1041f875450$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $cacfb1041f875450$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $cacfb1041f875450$var$formatLong = {
    date: (0, $cacfb1041f875450$var$_index.default)({
        formats: $cacfb1041f875450$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $cacfb1041f875450$var$_index.default)({
        formats: $cacfb1041f875450$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $cacfb1041f875450$var$_index.default)({
        formats: $cacfb1041f875450$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $cacfb1041f875450$var$_default = $cacfb1041f875450$var$formatLong;
module.exports.default = $cacfb1041f875450$var$_default;
module.exports = module.exports.default;

});
parcelRegister("9kdSS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ca0c06639ff0707$var$buildFormatLongFn;
function $6ca0c06639ff0707$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("loKOy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f940273ff769021c$var$formatRelative;
var $f940273ff769021c$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $f940273ff769021c$var$formatRelative(token, _date, _baseDate, _options) {
    return $f940273ff769021c$var$formatRelativeLocale[token];
}
module.exports = module.exports.default;

});

parcelRegister("2Jhnc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1fcd42ac6af0f70a$var$_index = $1fcd42ac6af0f70a$var$_interopRequireDefault((parcelRequire("aHQcG")));
function $1fcd42ac6af0f70a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1fcd42ac6af0f70a$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $1fcd42ac6af0f70a$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $1fcd42ac6af0f70a$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $1fcd42ac6af0f70a$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $1fcd42ac6af0f70a$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $1fcd42ac6af0f70a$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
function $1fcd42ac6af0f70a$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
}
var $1fcd42ac6af0f70a$var$localize = {
    ordinalNumber: $1fcd42ac6af0f70a$var$ordinalNumber,
    era: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1fcd42ac6af0f70a$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1fcd42ac6af0f70a$var$_default = $1fcd42ac6af0f70a$var$localize;
module.exports.default = $1fcd42ac6af0f70a$var$_default;
module.exports = module.exports.default;

});
parcelRegister("aHQcG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7cb66a0f1c81e8df$var$buildLocalizeFn;
function $7cb66a0f1c81e8df$var$buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("3BeWb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29f06a0f5c74a5cd$var$_index = $29f06a0f5c74a5cd$var$_interopRequireDefault((parcelRequire("bpnBt")));

var $29f06a0f5c74a5cd$var$_index2 = $29f06a0f5c74a5cd$var$_interopRequireDefault((parcelRequire("a2pHz")));
function $29f06a0f5c74a5cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $29f06a0f5c74a5cd$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $29f06a0f5c74a5cd$var$parseOrdinalNumberPattern = /\d+/i;
var $29f06a0f5c74a5cd$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $29f06a0f5c74a5cd$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $29f06a0f5c74a5cd$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $29f06a0f5c74a5cd$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $29f06a0f5c74a5cd$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $29f06a0f5c74a5cd$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $29f06a0f5c74a5cd$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $29f06a0f5c74a5cd$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $29f06a0f5c74a5cd$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $29f06a0f5c74a5cd$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $29f06a0f5c74a5cd$var$match = {
    ordinalNumber: (0, $29f06a0f5c74a5cd$var$_index.default)({
        matchPattern: $29f06a0f5c74a5cd$var$matchOrdinalNumberPattern,
        parsePattern: $29f06a0f5c74a5cd$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29f06a0f5c74a5cd$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29f06a0f5c74a5cd$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29f06a0f5c74a5cd$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29f06a0f5c74a5cd$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $29f06a0f5c74a5cd$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $29f06a0f5c74a5cd$var$_default = $29f06a0f5c74a5cd$var$match;
module.exports.default = $29f06a0f5c74a5cd$var$_default;
module.exports = module.exports.default;

});
parcelRegister("bpnBt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84e456a5d66783af$var$buildMatchPatternFn;
function $84e456a5d66783af$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});

parcelRegister("a2pHz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $74ee071a34dc674f$var$buildMatchFn;
function $74ee071a34dc674f$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $74ee071a34dc674f$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $74ee071a34dc674f$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $74ee071a34dc674f$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $74ee071a34dc674f$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});



parcelRegister("emeRN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a73ea6f79e2df726$var$subMilliseconds;

var $a73ea6f79e2df726$var$_index = $a73ea6f79e2df726$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $a73ea6f79e2df726$var$_index2 = $a73ea6f79e2df726$var$_interopRequireDefault((parcelRequire("ddIDm")));

var $a73ea6f79e2df726$var$_index3 = $a73ea6f79e2df726$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $a73ea6f79e2df726$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $a73ea6f79e2df726$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $a73ea6f79e2df726$var$_index3.default)(2, arguments);
    var amount = (0, $a73ea6f79e2df726$var$_index.default)(dirtyAmount);
    return (0, $a73ea6f79e2df726$var$_index2.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("4Zzm9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3a2848f4741c5f55$var$toInteger;
function $3a2848f4741c5f55$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("ddIDm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $99ff1c97c8892d76$var$addMilliseconds;

var $99ff1c97c8892d76$var$_index = $99ff1c97c8892d76$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $99ff1c97c8892d76$var$_index2 = $99ff1c97c8892d76$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $99ff1c97c8892d76$var$_index3 = $99ff1c97c8892d76$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $99ff1c97c8892d76$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $99ff1c97c8892d76$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $99ff1c97c8892d76$var$_index3.default)(2, arguments);
    var timestamp = (0, $99ff1c97c8892d76$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $99ff1c97c8892d76$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});


parcelRegister("69lef", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47a40ced54ac5b5e$var$_index = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("1eXm0")));

var $47a40ced54ac5b5e$var$_index2 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("a357h")));

var $47a40ced54ac5b5e$var$_index3 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("2NIDC")));

var $47a40ced54ac5b5e$var$_index4 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("4IzFf")));

var $47a40ced54ac5b5e$var$_index5 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("2jCJh")));

var $47a40ced54ac5b5e$var$_index6 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("a4ShE")));

var $47a40ced54ac5b5e$var$_index7 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("e1No1")));
function $47a40ced54ac5b5e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $47a40ced54ac5b5e$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $47a40ced54ac5b5e$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $47a40ced54ac5b5e$var$_index.default.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $47a40ced54ac5b5e$var$_index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $47a40ced54ac5b5e$var$_index7.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $47a40ced54ac5b5e$var$_index7.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $47a40ced54ac5b5e$var$_index4.default)(date); // Padding
        return (0, $47a40ced54ac5b5e$var$_index7.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $47a40ced54ac5b5e$var$_index7.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $47a40ced54ac5b5e$var$_index.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $47a40ced54ac5b5e$var$_index5.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $47a40ced54ac5b5e$var$_index3.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $47a40ced54ac5b5e$var$_index.default.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $47a40ced54ac5b5e$var$_index2.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $47a40ced54ac5b5e$var$_index.default.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $47a40ced54ac5b5e$var$_index.default.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $47a40ced54ac5b5e$var$_index.default.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $47a40ced54ac5b5e$var$_index.default.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $47a40ced54ac5b5e$var$_index.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $47a40ced54ac5b5e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $47a40ced54ac5b5e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $47a40ced54ac5b5e$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $47a40ced54ac5b5e$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $47a40ced54ac5b5e$var$_index7.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $47a40ced54ac5b5e$var$_index7.default)(timestamp, token.length);
    }
};
function $47a40ced54ac5b5e$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $47a40ced54ac5b5e$var$_index7.default)(minutes, 2);
}
function $47a40ced54ac5b5e$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $47a40ced54ac5b5e$var$_index7.default)(Math.abs(offset) / 60, 2);
    }
    return $47a40ced54ac5b5e$var$formatTimezone(offset, dirtyDelimiter);
}
function $47a40ced54ac5b5e$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $47a40ced54ac5b5e$var$_index7.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $47a40ced54ac5b5e$var$_index7.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $47a40ced54ac5b5e$var$_default = $47a40ced54ac5b5e$var$formatters;
module.exports.default = $47a40ced54ac5b5e$var$_default;
module.exports = module.exports.default;

});
parcelRegister("1eXm0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7523b2f31c3a54$var$_index = $0e7523b2f31c3a54$var$_interopRequireDefault((parcelRequire("e1No1")));
function $0e7523b2f31c3a54$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $0e7523b2f31c3a54$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $0e7523b2f31c3a54$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $0e7523b2f31c3a54$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $0e7523b2f31c3a54$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $0e7523b2f31c3a54$var$_default = $0e7523b2f31c3a54$var$formatters;
module.exports.default = $0e7523b2f31c3a54$var$_default;
module.exports = module.exports.default;

});
parcelRegister("e1No1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a36777d041aab5c3$var$addLeadingZeros;
function $a36777d041aab5c3$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});


parcelRegister("a357h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $750e273c1140fb1f$var$getUTCDayOfYear;

var $750e273c1140fb1f$var$_index = $750e273c1140fb1f$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $750e273c1140fb1f$var$_index2 = $750e273c1140fb1f$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $750e273c1140fb1f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $750e273c1140fb1f$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $750e273c1140fb1f$var$getUTCDayOfYear(dirtyDate) {
    (0, $750e273c1140fb1f$var$_index2.default)(1, arguments);
    var date = (0, $750e273c1140fb1f$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $750e273c1140fb1f$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("2NIDC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $20a2c88eb21c009b$var$getUTCISOWeek;

var $20a2c88eb21c009b$var$_index = $20a2c88eb21c009b$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $20a2c88eb21c009b$var$_index2 = $20a2c88eb21c009b$var$_interopRequireDefault((parcelRequire("byKqb")));

var $20a2c88eb21c009b$var$_index3 = $20a2c88eb21c009b$var$_interopRequireDefault((parcelRequire("brY09")));

var $20a2c88eb21c009b$var$_index4 = $20a2c88eb21c009b$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $20a2c88eb21c009b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $20a2c88eb21c009b$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $20a2c88eb21c009b$var$getUTCISOWeek(dirtyDate) {
    (0, $20a2c88eb21c009b$var$_index4.default)(1, arguments);
    var date = (0, $20a2c88eb21c009b$var$_index.default)(dirtyDate);
    var diff = (0, $20a2c88eb21c009b$var$_index2.default)(date).getTime() - (0, $20a2c88eb21c009b$var$_index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $20a2c88eb21c009b$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("byKqb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $86a6e0fae70def86$var$startOfUTCISOWeek;

var $86a6e0fae70def86$var$_index = $86a6e0fae70def86$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $86a6e0fae70def86$var$_index2 = $86a6e0fae70def86$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $86a6e0fae70def86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $86a6e0fae70def86$var$startOfUTCISOWeek(dirtyDate) {
    (0, $86a6e0fae70def86$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $86a6e0fae70def86$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("brY09", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8560c262329c0d69$var$startOfUTCISOWeekYear;

var $8560c262329c0d69$var$_index = $8560c262329c0d69$var$_interopRequireDefault((parcelRequire("4IzFf")));

var $8560c262329c0d69$var$_index2 = $8560c262329c0d69$var$_interopRequireDefault((parcelRequire("byKqb")));

var $8560c262329c0d69$var$_index3 = $8560c262329c0d69$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $8560c262329c0d69$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $8560c262329c0d69$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $8560c262329c0d69$var$_index3.default)(1, arguments);
    var year = (0, $8560c262329c0d69$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $8560c262329c0d69$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("4IzFf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36f6efa924cd5b42$var$getUTCISOWeekYear;

var $36f6efa924cd5b42$var$_index = $36f6efa924cd5b42$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $36f6efa924cd5b42$var$_index2 = $36f6efa924cd5b42$var$_interopRequireDefault((parcelRequire("byKqb")));

var $36f6efa924cd5b42$var$_index3 = $36f6efa924cd5b42$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $36f6efa924cd5b42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $36f6efa924cd5b42$var$getUTCISOWeekYear(dirtyDate) {
    (0, $36f6efa924cd5b42$var$_index3.default)(1, arguments);
    var date = (0, $36f6efa924cd5b42$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $36f6efa924cd5b42$var$_index2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $36f6efa924cd5b42$var$_index2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("2jCJh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1afb65f8744277f0$var$getUTCWeek;

var $1afb65f8744277f0$var$_index = $1afb65f8744277f0$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $1afb65f8744277f0$var$_index2 = $1afb65f8744277f0$var$_interopRequireDefault((parcelRequire("cyfBq")));

var $1afb65f8744277f0$var$_index3 = $1afb65f8744277f0$var$_interopRequireDefault((parcelRequire("4CnVl")));

var $1afb65f8744277f0$var$_index4 = $1afb65f8744277f0$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $1afb65f8744277f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1afb65f8744277f0$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $1afb65f8744277f0$var$getUTCWeek(dirtyDate, options) {
    (0, $1afb65f8744277f0$var$_index4.default)(1, arguments);
    var date = (0, $1afb65f8744277f0$var$_index.default)(dirtyDate);
    var diff = (0, $1afb65f8744277f0$var$_index2.default)(date, options).getTime() - (0, $1afb65f8744277f0$var$_index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $1afb65f8744277f0$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("cyfBq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9234c3639838f220$var$startOfUTCWeek;

var $9234c3639838f220$var$_index = $9234c3639838f220$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $9234c3639838f220$var$_index2 = $9234c3639838f220$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $9234c3639838f220$var$_index3 = $9234c3639838f220$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $9234c3639838f220$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $9234c3639838f220$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
    (0, $9234c3639838f220$var$_index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $9234c3639838f220$var$_index.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $9234c3639838f220$var$_index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $9234c3639838f220$var$_index2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("4CnVl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35cd44d4e287df9b$var$startOfUTCWeekYear;

var $35cd44d4e287df9b$var$_index = $35cd44d4e287df9b$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $35cd44d4e287df9b$var$_index2 = $35cd44d4e287df9b$var$_interopRequireDefault((parcelRequire("a4ShE")));

var $35cd44d4e287df9b$var$_index3 = $35cd44d4e287df9b$var$_interopRequireDefault((parcelRequire("cyfBq")));

var $35cd44d4e287df9b$var$_index4 = $35cd44d4e287df9b$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $35cd44d4e287df9b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $35cd44d4e287df9b$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $35cd44d4e287df9b$var$_index4.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $35cd44d4e287df9b$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $35cd44d4e287df9b$var$_index.default)(options.firstWeekContainsDate);
    var year = (0, $35cd44d4e287df9b$var$_index2.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $35cd44d4e287df9b$var$_index3.default)(firstWeek, dirtyOptions);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("a4ShE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $756462b7c370905f$var$getUTCWeekYear;

var $756462b7c370905f$var$_index = $756462b7c370905f$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $756462b7c370905f$var$_index2 = $756462b7c370905f$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $756462b7c370905f$var$_index3 = $756462b7c370905f$var$_interopRequireDefault((parcelRequire("cyfBq")));

var $756462b7c370905f$var$_index4 = $756462b7c370905f$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $756462b7c370905f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $756462b7c370905f$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $756462b7c370905f$var$_index4.default)(1, arguments);
    var date = (0, $756462b7c370905f$var$_index2.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $756462b7c370905f$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $756462b7c370905f$var$_index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $756462b7c370905f$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $756462b7c370905f$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});




parcelRegister("frLM1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $02e6f1480420e419$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $02e6f1480420e419$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $02e6f1480420e419$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $02e6f1480420e419$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $02e6f1480420e419$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $02e6f1480420e419$var$timeLongFormatter(timePattern, formatLong));
}
var $02e6f1480420e419$var$longFormatters = {
    p: $02e6f1480420e419$var$timeLongFormatter,
    P: $02e6f1480420e419$var$dateTimeLongFormatter
};
var $02e6f1480420e419$var$_default = $02e6f1480420e419$var$longFormatters;
module.exports.default = $02e6f1480420e419$var$_default;
module.exports = module.exports.default;

});

parcelRegister("YdpzT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b5001f709e33659$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $0b5001f709e33659$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("4ug6M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $34467589fadf6150$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $34467589fadf6150$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $34467589fadf6150$var$throwProtectedError;
var $34467589fadf6150$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $34467589fadf6150$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $34467589fadf6150$var$isProtectedDayOfYearToken(token) {
    return $34467589fadf6150$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $34467589fadf6150$var$isProtectedWeekYearToken(token) {
    return $34467589fadf6150$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $34467589fadf6150$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("3bBes", function(module, exports) {

$parcel$export(module.exports, "default", () => $251f47bafdc8ba54$export$2e2bcd8739ae039);

var $jaBXX = parcelRequire("jaBXX");

var $5eZih = parcelRequire("5eZih");
var $251f47bafdc8ba54$var$MILLISECONDS_IN_MINUTE = 60000;
var $251f47bafdc8ba54$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $251f47bafdc8ba54$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $251f47bafdc8ba54$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $251f47bafdc8ba54$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $251f47bafdc8ba54$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $251f47bafdc8ba54$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $251f47bafdc8ba54$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $251f47bafdc8ba54$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $251f47bafdc8ba54$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $251f47bafdc8ba54$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $251f47bafdc8ba54$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $251f47bafdc8ba54$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $jaBXX.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $jaBXX.default)('long', date, options);
        }
    }
};
function $251f47bafdc8ba54$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $5eZih.default)(timeZone, originalDate, true) / $251f47bafdc8ba54$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $251f47bafdc8ba54$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $251f47bafdc8ba54$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $251f47bafdc8ba54$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $251f47bafdc8ba54$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $251f47bafdc8ba54$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $251f47bafdc8ba54$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $251f47bafdc8ba54$var$formatTimezone(offset, dirtyDelimeter);
}
function $251f47bafdc8ba54$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $251f47bafdc8ba54$var$addLeadingZeros(minutes, 2);
}
var $251f47bafdc8ba54$export$2e2bcd8739ae039 = $251f47bafdc8ba54$var$formatters;

});
parcelRegister("jaBXX", function(module, exports) {

$parcel$export(module.exports, "default", () => $df4c66c7d52dabb7$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $df4c66c7d52dabb7$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $df4c66c7d52dabb7$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $df4c66c7d52dabb7$var$partsTimeZone(dtf, date) : $df4c66c7d52dabb7$var$hackyTimeZone(dtf, date);
}
function $df4c66c7d52dabb7$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $df4c66c7d52dabb7$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $df4c66c7d52dabb7$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("5eZih", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d0dce3a023aa6ff$export$2e2bcd8739ae039);

var $6lWgP = parcelRequire("6lWgP");

var $79OMl = parcelRequire("79OMl");
var $3d0dce3a023aa6ff$var$MILLISECONDS_IN_HOUR = 3600000;
var $3d0dce3a023aa6ff$var$MILLISECONDS_IN_MINUTE = 60000;
var $3d0dce3a023aa6ff$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $3d0dce3a023aa6ff$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $3d0dce3a023aa6ff$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $3d0dce3a023aa6ff$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$3d0dce3a023aa6ff$var$validateTimezone(hours)) return NaN;
        return -(hours * $3d0dce3a023aa6ff$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $3d0dce3a023aa6ff$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$3d0dce3a023aa6ff$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $3d0dce3a023aa6ff$var$MILLISECONDS_IN_HOUR + minutes * $3d0dce3a023aa6ff$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($3d0dce3a023aa6ff$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $3d0dce3a023aa6ff$var$toUtcDate(date);
        var offset = $3d0dce3a023aa6ff$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $3d0dce3a023aa6ff$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $3d0dce3a023aa6ff$var$toUtcDate(date) {
    return (0, $79OMl.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $3d0dce3a023aa6ff$var$calcOffset(date, timezoneString) {
    var tokens = (0, $6lWgP.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $79OMl.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $3d0dce3a023aa6ff$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $3d0dce3a023aa6ff$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $3d0dce3a023aa6ff$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $3d0dce3a023aa6ff$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $3d0dce3a023aa6ff$var$validIANATimezoneCache = {};
function $3d0dce3a023aa6ff$var$isValidTimezoneIANAString(timeZoneString) {
    if ($3d0dce3a023aa6ff$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $3d0dce3a023aa6ff$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("6lWgP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a01e785055169c5$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $4a01e785055169c5$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $4a01e785055169c5$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $4a01e785055169c5$var$partsOffset(dtf, date) : $4a01e785055169c5$var$hackyOffset(dtf, date);
}
var $4a01e785055169c5$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $4a01e785055169c5$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $4a01e785055169c5$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $4a01e785055169c5$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $4a01e785055169c5$var$dtfCache = {};
function $4a01e785055169c5$var$getDateTimeFormat(timeZone) {
    if (!$4a01e785055169c5$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $4a01e785055169c5$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $4a01e785055169c5$var$dtfCache[timeZone];
}

});

parcelRegister("79OMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5360c349e7d7c628$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $5360c349e7d7c628$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("dPuS0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a117fbf163453883$export$2e2bcd8739ae039);

var $4Zzm9 = parcelRequire("4Zzm9");

var $YdpzT = parcelRequire("YdpzT");

var $5eZih = parcelRequire("5eZih");

var $jElOZ = parcelRequire("jElOZ");
var $a117fbf163453883$var$MILLISECONDS_IN_HOUR = 3600000;
var $a117fbf163453883$var$MILLISECONDS_IN_MINUTE = 60000;
var $a117fbf163453883$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $a117fbf163453883$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $jElOZ.default)
};
function $a117fbf163453883$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $a117fbf163453883$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($4Zzm9)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $a117fbf163453883$var$splitDateString(argument);
    var parseYearResult = $a117fbf163453883$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $a117fbf163453883$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $a117fbf163453883$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $5eZih.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($YdpzT)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($YdpzT)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $a117fbf163453883$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $a117fbf163453883$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $a117fbf163453883$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $a117fbf163453883$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $a117fbf163453883$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $a117fbf163453883$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $a117fbf163453883$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $a117fbf163453883$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $a117fbf163453883$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $a117fbf163453883$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $a117fbf163453883$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$a117fbf163453883$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $a117fbf163453883$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$a117fbf163453883$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $a117fbf163453883$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$a117fbf163453883$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $a117fbf163453883$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$a117fbf163453883$var$validateWeekDate(year, week)) return new Date(NaN);
        return $a117fbf163453883$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $a117fbf163453883$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$a117fbf163453883$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $a117fbf163453883$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $a117fbf163453883$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $a117fbf163453883$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$a117fbf163453883$var$validateTime(hours)) return NaN;
        return hours % 24 * $a117fbf163453883$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $a117fbf163453883$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$a117fbf163453883$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $a117fbf163453883$var$MILLISECONDS_IN_HOUR + minutes * $a117fbf163453883$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $a117fbf163453883$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$a117fbf163453883$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $a117fbf163453883$var$MILLISECONDS_IN_HOUR + minutes * $a117fbf163453883$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $a117fbf163453883$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $a117fbf163453883$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $a117fbf163453883$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $a117fbf163453883$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $a117fbf163453883$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $a117fbf163453883$var$isLeapYearIndex(year);
        if (isLeapYear && date > $a117fbf163453883$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $a117fbf163453883$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $a117fbf163453883$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $a117fbf163453883$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $a117fbf163453883$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $a117fbf163453883$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("jElOZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4e2ae032a23513e$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $e4e2ae032a23513e$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $e4e2ae032a23513e$export$2e2bcd8739ae039 = $e4e2ae032a23513e$var$tzPattern;

});



parcelRegister("ggskA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd741dea01885f61$export$2e2bcd8739ae039);

var $5eZih = parcelRequire("5eZih");

var $dPuS0 = parcelRequire("dPuS0");
function $bd741dea01885f61$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $dPuS0.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $5eZih.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("4Y1Ak", function(module, exports) {

$parcel$export(module.exports, "transformUserTimelineResponse", () => $1a8df4f7e7d11794$export$78049913b79774a2);

var $cRFAu = parcelRequire("cRFAu");
const $1a8df4f7e7d11794$export$78049913b79774a2 = ({ startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, startOffsetMillis: startOffsetMillis, endOffsetMillis: endOffsetMillis, utcTimeOffsetMillis: utcTimeOffsetMillis, currentTime: currentTime, periods: periods, ...data })=>{
    return {
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        nowEpoch: currentTime,
        startOffset: startOffsetMillis,
        endOffset: endOffsetMillis,
        nowOffset: utcTimeOffsetMillis,
        data: {
            ...data,
            periods: periods.map((0, $cRFAu.fromMergedPeriodResponseToClusterPeriod))
        }
    };
};

});
parcelRegister("cRFAu", function(module, exports) {

$parcel$export(module.exports, "fromMergedPeriodResponseToClusterPeriod", () => $7292252621dcb03d$export$9b0bac75f135bd57);
const $7292252621dcb03d$export$9b0bac75f135bd57 = (mergedPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingPeriods: overlappingPeriods } = mergedPeriodResponse;
    const clusterPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingPeriods.map($7292252621dcb03d$var$fromOverlappingPeriodResponseToOverlappingPeriod)
    };
    return clusterPeriod;
};
const $7292252621dcb03d$var$fromOverlappingPeriodResponseToOverlappingPeriod = (overlappingPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingRotations: overlappingRotations, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime } = overlappingPeriodResponse;
    const overlappingPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingRotations,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime
    };
    return overlappingPeriod;
};

});





parcelRegister("79YNf", function(module, exports) {

$parcel$export(module.exports, "whoIsOnCallRoute", () => $3cc2f3cf4079e9df$export$26b06efd7311586b);

var $exb0h = parcelRequire("exb0h");
const $3cc2f3cf4079e9df$export$26b06efd7311586b = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_WHO_IS_ON_CALL),
    path: '/jira/ops/who-is-on-call',
    exact: true
};

});

parcelRegister("k7oAV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("9K5rp")
]).then(()=>parcelRequire('5FlsU'));

});

parcelRegister("4JtEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc85345805b2b6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $bdc85345805b2b6b$var$LazyGlobalIssuesSettingsSidebar = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("dlPK6")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-issues/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdc85345805b2b6b$var$GlobalIssuesSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalIssuesSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdc85345805b2b6b$var$LazyGlobalIssuesSettingsSidebar, null)));
var $bdc85345805b2b6b$export$2e2bcd8739ae039 = $bdc85345805b2b6b$var$GlobalIssuesSettingsSidebar;

});
parcelRegister("dlPK6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fSMvu").then(()=>parcelRequire('bSHNx'));

});


parcelRegister("1L86T", function(module, exports) {

$parcel$export(module.exports, "fieldContextConfigPageResource", () => $1bf4cf7967c593d5$export$686a607053a18611);

var $lB25E = parcelRequire("lB25E");


const $1bf4cf7967c593d5$export$686a607053a18611 = (0, $lB25E.createResource)({
    type: (0, $29db1182a27cfbe1$export$4b80522d38222ad),
    getKey: ()=>'data',
    getDataLoader: ()=>(parcelRequire("l28mY")),
    maxAge: 5000
});

});
const $29db1182a27cfbe1$export$4b80522d38222ad = 'FORGE_FIELD_CONTEXTUAL_CONFIG';

parcelRegister("l28mY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7gX2e").then(()=>parcelRequire('kHLvz'));

});


parcelRegister("742KF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3Zkfk").then(()=>parcelRequire('aJcP3'));

});

parcelRegister("ficsS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jYVk1").then(()=>parcelRequire('faBoH'));

});

parcelRegister("4bUpA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8OqrK").then(()=>parcelRequire('22avx'));

});

parcelRegister("dpEXh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6Chcn").then(()=>parcelRequire('1OBGZ'));

});

parcelRegister("6mnfz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5bQsi").then(()=>parcelRequire('iKl5H'));

});

parcelRegister("aUSBv", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $fde559e96dd48090$export$557c2f222778cea6);
$parcel$export(module.exports, "default", () => $fde559e96dd48090$export$2e2bcd8739ae039);

var $k4nIh = parcelRequire("k4nIh");

var $kdp9J = parcelRequire("kdp9J");

var $hmtwd = parcelRequire("hmtwd");

var $fpsBI = parcelRequire("fpsBI");

var $7l8eu = parcelRequire("7l8eu");
const $fde559e96dd48090$var$projectScopeDataMap = {
    routes: [
        // Query string
        /[&?]projectKey=(\w+)/i,
        // Service desk, business and some software
        /\/projects\/(\w+)/i,
        // Issue page (not root)
        /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
        // Project settings
        /\/plugins\/servlet\/project-config\/(\w+)/i,
        // Service Desk project settings
        /\/servicedesk\/admin\/(\w+)/i,
        // Browse project
        /\/browse\/(\w+)\/?(\?.*)?$/i
    ],
    meta: [
        // Software
        'ghx-project-key',
        // Settings
        'projectKey',
        // Reports
        'ajs-project-key'
    ]
};
const $fde559e96dd48090$var$getProjectId = (url)=>{
    const projectIdRoutes = [
        // Query string - reports
        /[&?]selectedProjectId=(\w+)/i,
        // Query string - edit project, delete project
        /[&?]pid=(\w+)/i,
        // Query string - release notes
        /[&?]projectId=(\w+)/i,
        // Query string - connect items
        /[&?]project\.id=(\w+)/i
    ];
    return projectIdRoutes.reduce((foundId, route)=>{
        if (foundId) return foundId;
        const match = url.match(route);
        if (match != null) {
            const [, projectId] = match;
            if (projectId) return projectId;
        }
        return null;
    }, null);
};
/**
 * Extracts certain data out of the URL that is required by other data providers.
 */ const $fde559e96dd48090$var$getProjectKey = (url, getMeta)=>{
    let projectKey = null;
    $fde559e96dd48090$var$projectScopeDataMap.meta.forEach((tagName)=>{
        const value = getMeta(tagName);
        if (value && projectKey == null) projectKey = value;
    });
    $fde559e96dd48090$var$projectScopeDataMap.routes.forEach((route)=>{
        const match = url.match(route);
        if (match != null && projectKey == null) [, projectKey] = match;
    });
    return projectKey || undefined;
};
const $fde559e96dd48090$export$557c2f222778cea6 = (url)=>{
    try {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, true);
        let boardId = parsed.query ? parsed.query.rapidView : null;
        if (boardId == null) {
            const match = url.match(/\/boards\/(\d+)/i);
            boardId = match ? match[1] : null;
        }
        return boardId;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return null;
    }
};
const $fde559e96dd48090$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, $hmtwd.default).some((regex)=>regex.test(url)) || (0, $7l8eu.default).some((regex)=>regex.test(url));
const $fde559e96dd48090$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
    // Project routes that have a project id in the URL
    const isProject = ()=>{
        const routes = [
            /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
            /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
            /\/secure\/ReleaseNote.jspa.+projectId/i,
            /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
        ];
        return $fde559e96dd48090$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        }) || routes.some((regex)=>regex.test(url));
    };
    return projectKey || projectId && isProject();
};
const $fde559e96dd48090$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, $fpsBI.default).some((route)=>url.match(route)) || $fde559e96dd48090$var$isProjectSettingsConnectRoute({
        getMeta: getMeta,
        url: url
    });
const $fde559e96dd48090$var$getProjectPageType = (getMeta, url)=>{
    if ($fde559e96dd48090$var$isProjectSettingsPage({
        getMeta: getMeta,
        url: url
    })) return 'settings';
    const decorator = getMeta('decorator');
    const isSettings = getMeta('is-settings-page') === 'true';
    return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fde559e96dd48090$export$2e2bcd8739ae039 = (url, getMeta)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const extractedData = {};
    const boardId = $fde559e96dd48090$export$557c2f222778cea6(url);
    if (boardId) extractedData.boardId = boardId;
    const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $fde559e96dd48090$var$getProjectKey(url, getMeta);
    if (projectKey) extractedData.projectKey = projectKey;
    const projectId = $fde559e96dd48090$var$getProjectId(url);
    if (projectId) extractedData.projectId = projectId;
    const isProject = $fde559e96dd48090$var$isProjectPage({
        getMeta: getMeta,
        projectId: projectId,
        projectKey: projectKey,
        url: url
    });
    extractedData.pageType = isProject ? $fde559e96dd48090$var$getProjectPageType(getMeta, url) : undefined;
    const identifier = (0, $kdp9J.getScopeIdentifier)({
        boardId: boardId,
        projectKey: projectKey,
        projectId: isProject ? projectId : null
    });
    // This gets around a flow inexact type error
    return {
        ...extractedData,
        ...identifier
    };
};

});
parcelRegister("hmtwd", function(module, exports) {

$parcel$export(module.exports, "default", () => $be3da143f23d41f2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $be3da143f23d41f2$export$2e2bcd8739ae039 = [
    // Regex groups: addonKey, pageKey
    /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
];

});

parcelRegister("fpsBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac811ac050e5d76c$export$2e2bcd8739ae039);

var $7l8eu = parcelRequire("7l8eu");
const $ac811ac050e5d76c$var$commonClassicProjectSettingsRoutes = [
    /\/plugins\/servlet\/project-config/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
    /\/plugins\/servlet\/project-config\/.+\/fields/i,
    /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
    /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
    /\/plugins\/servlet\/project-config\/.+\/notifications/i,
    /\/plugins\/servlet\/project-config\/.+\/permissions/i,
    /\/plugins\/servlet\/project-config\/.+\/screens/i,
    /\/plugins\/servlet\/project-config\/.+\/workflows/i,
    /\/project\/DeleteProject!default\.jspa/i,
    /\/secure\/project\/EditProject!default\.jspa/i,
    // Collectors
    /\/secure\/AddCollector/i,
    /\/secure\/InsertCollectorHelp/i,
    /\/ViewCollector!default\.jspa\?projectKey=/i,
    /\/ViewCollectors!default\.jspa\?projectKey=/i,
    // Development tools
    /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
    // Hipchat
    /\/InstallHipChat\.jspa\?projectKey=/i,
    /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
    // Forge
    /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ac811ac050e5d76c$export$2e2bcd8739ae039 = [
    ...$ac811ac050e5d76c$var$commonClassicProjectSettingsRoutes,
    /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
    ...(0, $7l8eu.default),
    // Service Desk project settings
    /\/servicedesk\/admin\/(\w+)/i,
    // SPA settings
    /\/projects\/\w+\/settings(\/\w+)*/i
];

});
parcelRegister("7l8eu", function(module, exports) {

$parcel$export(module.exports, "default", () => $840bada481eacc3a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $840bada481eacc3a$export$2e2bcd8739ae039 = [
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
];

});



parcelRegister("5oIBC", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f0696c76a3faa9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");
const $43f0696c76a3faa9$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $k8Qyf.flagService)
        });
};
var $43f0696c76a3faa9$export$2e2bcd8739ae039 = $43f0696c76a3faa9$var$withFlagService;

});

parcelRegister("2biqf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("4yFId")
]).then(()=>parcelRequire('ji9l1'));

});

parcelRegister("7pdDu", function(module, exports) {

$parcel$export(module.exports, "customFieldsDirectoryResource", () => $fa0cf43fa184c179$export$3d783f106e15b01a);

var $lB25E = parcelRequire("lB25E");


const $fa0cf43fa184c179$export$3d783f106e15b01a = (0, $lB25E.createResource)({
    type: (0, $f08d1d49f60463bc$export$f237bae095c310e7),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("1N38H"))
});

});
const $f08d1d49f60463bc$export$f237bae095c310e7 = 'CUSTOM_FIELDS_DIRECTORY';

parcelRegister("1N38H", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("68gp0").then(()=>parcelRequire('fb7JO'));

});


parcelRegister("fxuL1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("dvqZm")
]).then(()=>parcelRequire('O4z2X'));

});

parcelRegister("918eN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRouteEntry", () => $95fa90dd21f315e6$export$5519b86c9ea602e1);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $3NbZE = parcelRequire("3NbZE");
const $95fa90dd21f315e6$export$5519b86c9ea602e1 = (0, $bMm60.createEntry)((0, $3NbZE.globalSettingsIssuesExplicitFieldAssociationRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("3NbZE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRoute", () => $345c0ad7605a7ac0$export$4f2c2d125c2b811a);

var $exb0h = parcelRequire("exb0h");
const $345c0ad7605a7ac0$export$4f2c2d125c2b811a = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_EXPLICIT_FIELD_ASSOCIATION_PROJECT_LIST),
    path: '/jira/settings/issues/explicit-field-association'
};

});


parcelRegister("bhwgQ", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $d30306c96e1f2888$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "AuthenticationCheck", () => $d30306c96e1f2888$export$e9b9096e887386fe);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");

var $iPDOm = parcelRequire("iPDOm");
const $d30306c96e1f2888$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
const $d30306c96e1f2888$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ($d30306c96e1f2888$export$b8dbb7d6029c5413(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPDOm.RedirectToLoginPage), null);
    });

});

parcelRegister("9CiS9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kLhuh")
]).then(()=>parcelRequire('8qc1w'));

});

parcelRegister("fnP3y", function(module, exports) {

$parcel$export(module.exports, "smartRepliesOptInStatusResources", () => $117463b3e3a4155f$export$d9a3116994d66cfc);
$parcel$export(module.exports, "useSmartRepliesPreferencesResources", () => $117463b3e3a4155f$export$8d607fdbd07ed6ca);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $cm5m0 = parcelRequire("cm5m0");

var $lB25E = parcelRequire("lB25E");

const $117463b3e3a4155f$export$d9a3116994d66cfc = (0, $lB25E.createResource)({
    type: (0, $bdfa4165535b2c8e$export$ea895d05049da93c),
    getKey: ()=>(0, $bdfa4165535b2c8e$export$92a8ee31fa2d5df3),
    getData: async ()=>{
        let smartRepliesOptInStatus = null;
        try {
            smartRepliesOptInStatus = await (0, $cm5m0.userPreferenceAPI).get((0, $bdfa4165535b2c8e$export$92a8ee31fa2d5df3));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode !== 404) (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $bdfa4165535b2c8e$export$92a8ee31fa2d5df3), (0, $bdfa4165535b2c8e$export$b8b9d90f9e5bd72b), error);
            (0, $guiFP.default)({
                meta: {
                    id: 'smartRepliesOptInStatusResources',
                    packageName: (0, $bdfa4165535b2c8e$export$b8b9d90f9e5bd72b),
                    teamName: 'jira-warepil'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            smartRepliesOptInStatus: smartRepliesOptInStatus
        };
    },
    maxAge: Number.MAX_VALUE
});
const $117463b3e3a4155f$export$8d607fdbd07ed6ca = ()=>{
    const { data: data, refresh: refresh, loading: loading } = (0, $lB25E.useResource)($117463b3e3a4155f$export$d9a3116994d66cfc);
    return {
        isSmartRepliesPreferenceEnabled: data?.smartRepliesOptInStatus?.isEnabled ?? true,
        loading: loading,
        refreshData: refresh
    };
};

});
const $bdfa4165535b2c8e$export$92a8ee31fa2d5df3 = 'jira.user.smart_replies_feature.status';
const $bdfa4165535b2c8e$export$ea895d05049da93c = 'RESOURCE_TYPE_ISSUE_SMART_REPLIES_STATUS';
const $bdfa4165535b2c8e$export$b8b9d90f9e5bd72b = 'jiraIssueSmartRepliesPreferences';


parcelRegister("sFzm1", function(module, exports) {

$parcel$export(module.exports, "EmbedModeContext", () => $8c69a6d02011f63a$export$5eb07b3c7c0b0771);
$parcel$export(module.exports, "EmbedModeProvider", () => $8c69a6d02011f63a$export$9daaf42d62e1c430);

var $eUqFw = parcelRequire("eUqFw");
const $8c69a6d02011f63a$export$5eb07b3c7c0b0771 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const { Provider: $8c69a6d02011f63a$var$Provider } = $8c69a6d02011f63a$export$5eb07b3c7c0b0771;
const $8c69a6d02011f63a$var$handleEmbedLinkClick = (e)=>{
    const eventTarget = e.target;
    if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
    eventTarget.target = '_blank';
};
// When issue view is loaded within an iframe, it needs to follow the proper
// element elevation principles, found here: https://hello.atlassian.net/wiki/spaces/~460573267/pages/2355983526/Jira+Dark+Mode+-+UI+Guidelines#Element-elevation-basics
// Unfortunately the current elevation is set in the global-container, which is loaded before this Provider so
// we have to override the overrider to ensure that the proper elevation is set
const $8c69a6d02011f63a$var$DarkModeMonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #jira-frontend {
                        background: ${"var(--ds-surface-overlay, white)"};
                    }
                `
        }
    });
const $8c69a6d02011f63a$export$9daaf42d62e1c430 = ({ children: children })=>{
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', $8c69a6d02011f63a$var$handleEmbedLinkClick, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', $8c69a6d02011f63a$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c69a6d02011f63a$var$DarkModeMonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c69a6d02011f63a$var$Provider, {
        value: true
    }, children));
};

});

parcelRegister("dvBSb", function(module, exports) {

$parcel$export(module.exports, "issueViewRelayResource", () => $e26b3f39fd0cc4df$export$55131006e6699c0a);
$parcel$export(module.exports, "useIssueViewRelayRouteResource", () => $e26b3f39fd0cc4df$export$252bdba8c8e5f066);
// eslint-disable-next-line jira/import-whitelist

var $jBy23 = parcelRequire("jBy23");

var $2mP8r = parcelRequire("2mP8r");

var $buJlM = parcelRequire("buJlM");

var $lW5gg = parcelRequire("lW5gg");

var $9PXNH = parcelRequire("9PXNH");

var $lB25E = parcelRequire("lB25E");

var $2skem = parcelRequire("2skem");

const $e26b3f39fd0cc4df$var$getDataLoader = ()=>(parcelRequire("6ck9w"));
const $e26b3f39fd0cc4df$export$5ce473a762cc813e = (0, $lB25E.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_AGG_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getDataLoader: $e26b3f39fd0cc4df$var$getDataLoader,
    maxAge: (0, $2skem.MIN_MAX_AGE),
    isBrowserOnly: true
}));
const $e26b3f39fd0cc4df$export$55131006e6699c0a = (0, $2skem.createRelayResourceDeprecated)({
    type: 'ISSUE_RELAY_DATA',
    isBrowserOnly: true,
    captureErrors: true,
    captureTraceIds: !false,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const { match: match } = routerContext;
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        const projectKey = issueKey ? (0, $jBy23.extractProjectKey)(issueKey) : '';
        const queryVariables = {
            cloudId: cloudId,
            issueKey: issueKey || '',
            projectKey: projectKey
        };
        return {
            parameters: (0, $lW5gg.default),
            variables: {
                ...queryVariables,
                ...(0, $2mP8r.getMainIssueViewAggQueryVariables)()
            },
            // Pass over the variables that actually would trigger a reload when they are changed=
            keyVariables: {
                ...queryVariables,
                ...(0, $2mP8r.getMainIssueViewAggQueryFeatureFlagVariables)()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});
const $e26b3f39fd0cc4df$export$252bdba8c8e5f066 = (options)=>(0, $buJlM.useRelayResource)($e26b3f39fd0cc4df$export$55131006e6699c0a, options);

});
parcelRegister("jBy23", function(module, exports) {

$parcel$export(module.exports, "extractProjectKey", () => $7901038b5997e3c0$export$f1a2e4721b127828);

var $6vrw7 = parcelRequire("6vrw7");
const $7901038b5997e3c0$export$f1a2e4721b127828 = (issueKey)=>(0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);

});

parcelRegister("2mP8r", function(module, exports) {

$parcel$export(module.exports, "getMainIssueViewAggQueryFeatureFlagVariables", () => $ad8d90d6e49d6bf3$export$3dd406718c5846c6);
$parcel$export(module.exports, "getMainIssueViewAggQueryVariables", () => $ad8d90d6e49d6bf3$export$5896c8dc13246fe2);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $bKxX9 = parcelRequire("bKxX9");

var $cs6Z7 = parcelRequire("cs6Z7");

var $8c9rb = parcelRequire("8c9rb");

var $6wu6G = parcelRequire("6wu6G");
const $ad8d90d6e49d6bf3$export$3dd406718c5846c6 = ()=>({
        issueViewRelayCascadingSelectFlag: (0, $bKxX9.ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration'),
        giraAGGMigrationIsArchivedFlag: (0, $cs6Z7.getIsNewValueRequested)((0, $6wu6G.GIRA_AGG_MIGRATION_ISARCHIVED_FLAG)),
        parentInIssueViewFlag: (0, $6wu6G.isParentInIssueViewEnabled)(),
        isCompassComponentsEnabled: (0, $bKxX9.ff)('compass-components-in-jira-components_xw42u', false),
        giraAGGMigrationAttachmentsFlag: (0, $bKxX9.ff)('issue.details.gira-agg-migration-attachments_ecebe'),
        isRelayReleaseVersionFieldIssueViewIntegrationEnabled: (0, $bKxX9.ff)('issue.details.relay-release-version-field-issue-view-integration'),
        // This needs to be ff rather than fg/experiment for running "before scrips": https://atlassian.slack.com/archives/C06SJ813D8S/p1724034232723999
        issueViewRelayGoalsFlag: (0, $bKxX9.ff)('hrz-716-integrate-goal-picker-into-issue-view', false),
        giraAGGMigrationCommentsFlag: (0, $bKxX9.ff)('jiv-14067-issue.details.gira-agg-migration-comments_pzao9', false) || (0, $bKxX9.ff)('issue-jiv-14530-comments-consistency-check_x716d', false),
        isCMDBAttributeIdRemoved: (0, $bKxX9.ff)('assets-rearch-deprecate-attribute-value-id_ykukg', false),
        jsmSentimentCustomFieldFlag: (0, $bKxX9.ff)('sentiment-custom-field', false),
        isJPDPanelEnabled: (0, $bKxX9.ff)('polaris.jpd-panel-in-issue-view', false),
        issueViewRelayPriorityFieldFlag: (0, $bKxX9.ff)('relay-migration-issue-fields-priority_ri9vi', false),
        // if assignee/reporter/user is true, it represents SingleSelectUserPicker being used
        issueViewRelayAssigneeFieldFlag: (0, $bKxX9.ff)('relay-migration-issue-fields-assignee-ld', false) || (0, $bKxX9.ff)('relay-migration-issue-fields-reporter_jfzs2', false) || (0, $bKxX9.ff)('relay-migration-issue-fields-user', false),
        issueViewRelayNumberFieldFlag: (0, $bKxX9.ff)('relay-migration-issue-fields-number_q0em4', false),
        issueViewRelaySprintFieldFlag: (0, $bKxX9.ff)('relay-migration-issue-fields-sprint_jozpu', false),
        issueViewRelayAttachmentsFlag: (0, $bKxX9.ff)('relay-migration-issue-view-attachments', false),
        issueViewRelaySingleLineTextFieldFlag: (0, $bKxX9.ff)('relay-migration-issue-fields-single-line-text_in6w6', false) || (0, $bKxX9.ff)('relay-migration-issue-fields-single-line-text-message', false),
        issueViewRelayDateFieldFlag: (0, $bKxX9.ff)('relay-migration-issue-fields-date_ptj72', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsparent: (0, $bKxX9.ff)('relay-migration-issue-fields-parent_5p1ac', false),
        issueViewRelayParentFieldFlag: (0, $bKxX9.ff)('relay-migration-issue-fields-parent_5p1ac', false),
        issueViewRelayProjectFieldFlag: (0, $bKxX9.ff)('relay-migration-issue-fields-project-select_w0xem', false),
        issueViewRelayDateTimeFieldFlag: (0, $bKxX9.ff)('relay-migration-issue-fields-date-time_eaqd2', false),
        issueViewRelayMetadataFieldFlag: (0, $bKxX9.ff)('relay-migration-issue-fields-metadata_d42b0', false),
        isJPDDeliveryLinkTypeFilteringEnabled: (0, $bKxX9.ff)('polaris.jpd-panel-filter-by-delivery-link-type', false),
        issueViewRelayUrlFieldFlag: (0, $bKxX9.ff)('relay-migration-issue-fields-url_ob8uu', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-assignee-ld', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsreporterrelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-reporter_jfzs2', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsuserrelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-user', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssecuritylevelrelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-security-level_7y5uv', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscheckboxselectrelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-checkbox-select_ytl5n', false),
        issueViewRelaySummaryFieldFlag: (0, $bKxX9.ff)('relay-migration-issue-fields-summary_eog1v', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsoriginalestimaterelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-original-estimate_eb4wv', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssinglelinetextmessagerelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-single-line-text-message', false),
        issueViewRelayColorFieldFlag: (0, $bKxX9.ff)('relay-migration-issue-fields-color_wrbay', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldstimetrackingrelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-time-tracking_eefh0', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldspeoplerelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-people', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsapproversrelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-approvers', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldswatchersrelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-watchers_iqhn4', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsheaderactionsrelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-watchers_iqhn4', false) || (0, $bKxX9.ff)('relay-migration-issue-fields-security-level_7y5uv', false),
        issueViewRelayHeaders: (0, $bKxX9.ff)('relay-migration-issue-fields-watchers_iqhn4', false) || (0, $bKxX9.ff)('relay-migration-issue-fields-parent_5p1ac', false) || (0, $bKxX9.ff)('relay-migration-issue-fields-security-level_7y5uv', false),
        issueViewRelayPeopleAndApproversFieldFlag: (0, $bKxX9.ff)('relay-migration-issue-fields-people', false) || (0, $bKxX9.ff)('relay-migration-issue-fields-approvers', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscomponentsrelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-components-select_prpz1', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-multi-user', false) || (0, $bKxX9.ff)('relay-migration-issue-fields-participants', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuetypeswitcherrelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-issue-type-switcher_l0lrt', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsresolutionrelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-resolution_86iya', false),
        // TODO [RELAY]: add multi group list FF
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultigrouppickerrelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-multi-group-picker', false),
        __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsgrouppickerrelayprovider: (0, $bKxX9.ff)('relay-migration-issue-fields-group-picker', false)
    });
const $ad8d90d6e49d6bf3$export$5896c8dc13246fe2 = ()=>({
        ...$ad8d90d6e49d6bf3$export$3dd406718c5846c6(),
        ...$ad8d90d6e49d6bf3$export$afa6e4ae995b8926(),
        isPinFieldConfigurabilityEnabled: (0, $bKxX9.ff)('pin_field_exp_launch_darkly_flag_ef4mc')
    });
const $ad8d90d6e49d6bf3$export$afa6e4ae995b8926 = ()=>({
        commentTargetId: (0, $bKxX9.ff)('jiv-14067-issue.details.gira-agg-migration-comments_pzao9') || (0, $bKxX9.ff)('issue-jiv-14530-comments-consistency-check_x716d') ? (0, $8c9rb.getPermalinkId)((0, $8c9rb.COMMENTS)) || null : null
    });

});
parcelRegister("cs6Z7", function(module, exports) {

$parcel$export(module.exports, "getIsOldValueRequested", () => $712ffcbbea6809c2$export$117d07493a3c1dce);
$parcel$export(module.exports, "getIsNewValueRequested", () => $712ffcbbea6809c2$export$7cdf481ce732d27f);

var $bKxX9 = parcelRequire("bKxX9");
const $712ffcbbea6809c2$var$getConsistencyCheckFeatureFlag = (featureFlagName, defaultValue = 'OLD')=>{
    const possibleValues = [
        'NEW',
        'CHECK_RETURN_NEW',
        'CHECK',
        'OLD'
    ];
    return (0, $bKxX9.getMultivariateFeatureFlag)(featureFlagName, defaultValue, possibleValues);
};
const $712ffcbbea6809c2$export$117d07493a3c1dce = (featureFlagName)=>{
    const featureFlagValue = $712ffcbbea6809c2$var$getConsistencyCheckFeatureFlag(featureFlagName);
    return featureFlagValue === 'OLD' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};
const $712ffcbbea6809c2$export$7cdf481ce732d27f = (featureFlagName)=>{
    const featureFlagValue = $712ffcbbea6809c2$var$getConsistencyCheckFeatureFlag(featureFlagName);
    return featureFlagValue === 'NEW' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};

});

parcelRegister("8c9rb", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $227761ce6e538457$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $227761ce6e538457$export$df36fc05622c402);
$parcel$export(module.exports, "getAllUrlParams", () => $227761ce6e538457$export$dca91ad250f6b082);
$parcel$export(module.exports, "getPermalinkId", () => $227761ce6e538457$export$bf42dbba4c31080e);

var $gUUjF = parcelRequire("gUUjF");
const $227761ce6e538457$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $227761ce6e538457$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $227761ce6e538457$export$df36fc05622c402 = 'WORKLOG';
const $227761ce6e538457$export$dca91ad250f6b082 = ()=>{
    // get query string from  window
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $227761ce6e538457$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$227761ce6e538457$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $227761ce6e538457$export$dca91ad250f6b082();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$227761ce6e538457$export$b18d061fc042df1a[targetPermalinkType]];
};

});

parcelRegister("6wu6G", function(module, exports) {

$parcel$export(module.exports, "isParentInIssueViewEnabled", () => $54a10774de0b57ab$export$9c7fa56ed1fa2e15);
$parcel$export(module.exports, "isJsmTimelineEnabled", () => $54a10774de0b57ab$export$575e1bf822db15b5);
$parcel$export(module.exports, "GIRA_AGG_MIGRATION_ISARCHIVED_FLAG", () => $54a10774de0b57ab$export$f53cbe8a5052e3e0);

var $bKxX9 = parcelRequire("bKxX9");
const $54a10774de0b57ab$export$9c7fa56ed1fa2e15 = ()=>(0, $bKxX9.ff)('parent-field-in-issue-view_x4zn4', false);
const $54a10774de0b57ab$export$575e1bf822db15b5 = ()=>(0, $bKxX9.ff)('jsm-timelines-phase-2_70gja', false);
const $54a10774de0b57ab$export$f53cbe8a5052e3e0 = 'issue.details.gira-agg-migration-isarchived'; // </gchan3>

});


parcelRegister("lW5gg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f29749e4a66b033$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c184955a7ddaa4b878c71d510068be2c>>
 * @relayHash ce3f920f027f8af9d580d4abb6034849
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2c65c739b2a57f6bf302522f82fc3c14338e22c4ddb9ff35cd2f571ae3618d06

var $aRxcD = parcelRequire("aRxcD");

var $jAIJe = parcelRequire("jAIJe");

var $goaIQ = parcelRequire("goaIQ");

var $iTnLZ = parcelRequire("iTnLZ");

var $6AOBE = parcelRequire("6AOBE");

var $dET1w = parcelRequire("dET1w");

var $d234K = parcelRequire("d234K");

var $lET36 = parcelRequire("lET36");

var $8hz4I = parcelRequire("8hz4I");

var $hjjI3 = parcelRequire("hjjI3");

var $iYer3 = parcelRequire("iYer3");

var $bxZTz = parcelRequire("bxZTz");

var $bWUdL = parcelRequire("bWUdL");

var $83Kgj = parcelRequire("83Kgj");

var $6x5fo = parcelRequire("6x5fo");

var $bjYWf = parcelRequire("bjYWf");

var $j4xkx = parcelRequire("j4xkx");

var $5xKN1 = parcelRequire("5xKN1");

var $eZ1A7 = parcelRequire("eZ1A7");

var $7JvdR = parcelRequire("7JvdR");
const $8f29749e4a66b033$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2c65c739b2a57f6bf302522f82fc3c14338e22c4ddb9ff35cd2f571ae3618d06",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "jira",
                        "issueByKey",
                        "attachments"
                    ]
                }
            ]
        },
        "name": "mainIssueAggQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsparent": (0, $bxZTz.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldstimetrackingrelayprovider": (0, $5xKN1.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscheckboxselectrelayprovider": (0, $goaIQ.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscomponentsrelayprovider": (0, $iTnLZ.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsoriginalestimaterelayprovider": (0, $iYer3.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrequestparticipantsrelayprovider": (0, $8hz4I.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsgrouppickerrelayprovider": (0, $6AOBE.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultigrouppickerrelayprovider": (0, $lET36.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrelayprovider": (0, $hjjI3.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldspeoplerelayprovider": (0, $bWUdL.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsapproversrelayprovider": (0, $aRxcD.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssinglelinetextmessagerelayprovider": (0, $j4xkx.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider": (0, $jAIJe.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsreporterrelayprovider": (0, $83Kgj.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsuserrelayprovider": (0, $eZ1A7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsheaderactionsrelayprovider": (0, $dET1w.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldswatchersrelayprovider": (0, $7JvdR.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssecuritylevelrelayprovider": (0, $bjYWf.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuetypeswitcherrelayprovider": (0, $d234K.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsresolutionrelayprovider": (0, $6x5fo.default)
        }
    }
};
var $8f29749e4a66b033$export$2e2bcd8739ae039 = $8f29749e4a66b033$var$node;

});
parcelRegister("aRxcD", function(module, exports) {

$parcel$export(module.exports, "default", () => $68576836d0061b6c$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$68576836d0061b6c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-approvers');
    }
};

});

parcelRegister("jAIJe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6e3bd6ffec69581$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a6e3bd6ffec69581$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-assignee-ld');
    }
};

});

parcelRegister("goaIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8de3f45eecd9e12b$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8de3f45eecd9e12b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-checkbox-select_ytl5n');
    }
};

});

parcelRegister("iTnLZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecd5c19a64fed08b$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ecd5c19a64fed08b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-components-select_prpz1');
    }
};

});

parcelRegister("6AOBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $96b18431e7888b2e$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$96b18431e7888b2e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-group-picker');
    }
};

});

parcelRegister("dET1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $83f0d5195549333c$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$83f0d5195549333c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-security-level_7y5uv') || (0, $1ybV0.ff)('relay-migration-issue-fields-watchers_iqhn4');
    }
};

});

parcelRegister("d234K", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4cfebbad5151be2$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f4cfebbad5151be2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-issue-type-switcher_l0lrt');
    }
};

});

parcelRegister("lET36", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0450ad3b2cc13cb$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f0450ad3b2cc13cb$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-multi-group-picker');
    }
};

});

parcelRegister("8hz4I", function(module, exports) {

$parcel$export(module.exports, "default", () => $65eb49b652f3ae9f$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$65eb49b652f3ae9f$export$2e2bcd8739ae039 // TODO: add request participants cf type
 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-multi-user') || (0, $1ybV0.ff)('relay-migration-issue-fields-participants');
    }
};

});

parcelRegister("hjjI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $983647adc6a5e17a$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$983647adc6a5e17a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-multi-user') || (0, $1ybV0.ff)('relay-migration-issue-fields-participants');
    }
};

});

parcelRegister("iYer3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9179ef8f0cef589$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d9179ef8f0cef589$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-original-estimate_eb4wv');
    }
};

});

parcelRegister("bxZTz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bd70db6f6e8c0da$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6bd70db6f6e8c0da$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-parent_5p1ac');
    }
};

});

parcelRegister("bWUdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ce6cab8d8e4a94d$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3ce6cab8d8e4a94d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-people');
    }
};

});

parcelRegister("83Kgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $48bbbc03d1e11f74$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48bbbc03d1e11f74$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-reporter_jfzs2');
    }
};

});

parcelRegister("6x5fo", function(module, exports) {

$parcel$export(module.exports, "default", () => $bda72d0350b8f6d3$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bda72d0350b8f6d3$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-resolution_86iya');
    }
};

});

parcelRegister("bjYWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b101a4a8efa8859c$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b101a4a8efa8859c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-security-level_7y5uv');
    }
};

});

parcelRegister("j4xkx", function(module, exports) {

$parcel$export(module.exports, "default", () => $931194135ec3202f$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$931194135ec3202f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-single-line-text-message');
    }
};

});

parcelRegister("5xKN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd0a0178dd1cb435$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fd0a0178dd1cb435$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-time-tracking_eefh0');
    }
};

});

parcelRegister("eZ1A7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9585969859604b1$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e9585969859604b1$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-user');
    }
};

});

parcelRegister("7JvdR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bec27237df6254df$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bec27237df6254df$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('relay-migration-issue-fields-watchers_iqhn4');
    }
};

});


parcelRegister("9PXNH", function(module, exports) {

$parcel$export(module.exports, "getIssueKey", () => $e9269e5be910ba89$export$4a030f6192bebe03);
const $e9269e5be910ba89$export$4a030f6192bebe03 = (match)=>{
    const fromMatch = match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : null;
    return fromMatch;
};

});

parcelRegister("2skem", function(module, exports) {

$parcel$export(module.exports, "MIN_MAX_AGE", () => $74b0242981e8d241$export$5664a170ac5a9781);
$parcel$export(module.exports, "withResourceEarlyData", () => $74b0242981e8d241$export$22da5fb8c8200986);
$parcel$export(module.exports, "createRelayResourceDeprecated", () => $74b0242981e8d241$export$2e279339bedcd427);

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $6iz4v = parcelRequire("6iz4v");

var $1ybV0 = parcelRequire("1ybV0");

var $amu7D = parcelRequire("amu7D");

var $15ZJO = parcelRequire("15ZJO");

var $c7ifG = parcelRequire("c7ifG");

var $lB25E = parcelRequire("lB25E");

var $5udmX = parcelRequire("5udmX");
const $74b0242981e8d241$export$5664a170ac5a9781 = 5000;
const $74b0242981e8d241$export$22da5fb8c8200986 = ({ type: type, getData: next, getDataLoader: getDataLoader, ...rest })=>{
    const getData = (...args)=>{
        performance.mark(`issueViewEarlyScripts:${type}:withResourceEarlyData:called`);
        if (!false && type in window) {
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
            const promise = window[type];
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            delete window[type];
            getDataLoader && promise.then(getDataLoader);
            return promise;
        }
        if (getDataLoader) return getDataLoader().then(({ default: getDataPromise })=>getDataPromise(...args));
        return next && next(...args);
    };
    return {
        ...rest,
        type: type,
        getData: getData
    };
};
const $74b0242981e8d241$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $74b0242981e8d241$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $lB25E.createResource)({
        type: `${$74b0242981e8d241$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            const { parameters: preloadableRequest, variables: queryVariables, keyVariables: keyVariables } = getQuery(routerContext, customContext);
            // There are some variables that we don't want to trigger a reload even if they are changed, by default use 'variables', or you can also pass over
            // specific keyVariables that will trigger the reload
            const variables = (0, $1ybV0.ff)('issue-jiv-14530-comments-consistency-check_x716d') || (0, $1ybV0.ff)('jiv-14067-issue.details.gira-agg-migration-comments_pzao9') ? keyVariables || queryVariables : queryVariables;
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            // sources: https://github.com/facebook/relay/blob/4b78c7dd27b286f9ee8f5b993ccb160163956999/packages/react-relay/relay-hooks/loadQuery.js#L273
            // @ts-expect-error - TS2339 - Property 'kind' does not exist on type 'GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>'.
            if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                const preloadableConcreteRequest = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                preloadableRequest;
                ({ params: params } = preloadableConcreteRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $cNy9K.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: async (routerContext, customContext)=>{
            const measureName = `relay_resource_get_data:${type}`;
            const startMark = `relay_resource_get_data:${type}:start`;
            const endMark = `relay_resource_get_data:${type}:end`;
            (0, $6iz4v.setMark)(startMark);
            const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
            // We either have a sync query or an async one from loadParameters. Never neither
            // This is enforced by 2 aliases of this method having different types, but Typescript cannot infer that neatly, so we cast away the nullable case.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const query = parameters ?? await loadParameters?.();
            // loadQuery returns not a Promise, but Observable.
            // Resource waits until query Observable is completed and returns a queryReference
            // later queryReference could be used by usePreloadedQuery
            const queryReference = (0, $6iz4v.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $iWLL0.loadQuery)((0, $amu7D.default)(), query, variables || {}, options));
            if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
            if (queryReference.id != null) (0, $c7ifG.QueryPromisesMap).get(queryReference.id)?.then(()=>{
                (0, $6iz4v.setMark)(endMark);
                (0, $6iz4v.setMeasure)(measureName, startMark, endMark);
            });
            /**
			 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
			 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
			 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
			 * as well as subsequent fetches made by route transitions between spa-apps.
			 */ if (captureErrors) (0, $15ZJO.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $5udmX.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly
    });
const $74b0242981e8d241$export$2e279339bedcd427 = $74b0242981e8d241$var$createRelayResourceImpl;

});

parcelRegister("6ck9w", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hJsnC").then(()=>parcelRequire('hNY4a'));

});


parcelRegister("5kTYh", function(module, exports) {

$parcel$export(module.exports, "issueForgeDataResource", () => $f710e109102bd3b2$export$e28b79684fb81535);

var $9PXNH = parcelRequire("9PXNH");

var $lB25E = parcelRequire("lB25E");

var $b8iE0 = parcelRequire("b8iE0");
const $f710e109102bd3b2$export$e28b79684fb81535 = (0, $lB25E.createResource)({
    type: 'ISSUE_FORGE_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $b8iE0.default)(...args),
    isBrowserOnly: true
});

});
parcelRegister("b8iE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bacedebb064d06c$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $27Eo5 = parcelRequire("27Eo5");

var $1aPBP = parcelRequire("1aPBP");

var $9PXNH = parcelRequire("9PXNH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3bacedebb064d06c$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const issueKey = (0, $9PXNH.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const { cloudId: cloudId, activationId: activationId, locale: locale } = tenantContext;
        const data = await (0, $27Eo5.fetchIssueForgeData)(cloudId, issueKey, activationId, locale);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $1aPBP.createResourceError)({
            component: 'spa.view.routes.issue-view.forge.getData',
            message: 'An error was thrown while prefetching issue Forge data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("27Eo5", function(module, exports) {

$parcel$export(module.exports, "fetchIssueForgeData", () => $28f36679da26750f$export$44da8345d9ceca61);

var $2Rqjr = parcelRequire("2Rqjr");

var $hsX10 = parcelRequire("hsX10");

var $cqw2K = parcelRequire("cqw2K");
const $28f36679da26750f$export$7c6ea4184129ef74 = (result, type)=>result.find((extensions)=>extensions.some((extension)=>extension.type === type)) || [];
const $28f36679da26750f$export$44da8345d9ceca61 = async (cloudId, issueKey, activationId, locale)=>{
    const modulesToFetch = [
        (0, $2Rqjr.ISSUE_ACTION_MODULE),
        (0, $2Rqjr.ISSUE_GLANCE_MODULE),
        (0, $2Rqjr.ISSUE_CONTEXT_MODULE),
        (0, $2Rqjr.ISSUE_PANEL_MODULE),
        (0, $2Rqjr.ISSUE_ACTIVITY_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE),
        (0, $2Rqjr.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
        (0, $2Rqjr.UI_MODIFICATIONS_MODULE)
    ];
    const contextIds = [
        `ari:cloud:jira:${cloudId}:workspace/${activationId}`
    ];
    const result = await (0, $hsX10.default)(cloudId, modulesToFetch, {
        issueKey: issueKey
    }, {
        include: {
            scopes: true
        }
    }, (0, $2Rqjr.SOURCE_ISSUE_VIEW), contextIds, locale);
    const { extensions: extensions, accessNarrowedExtensions: accessNarrowedExtensions } = result;
    const mappedResult = {
        issueAction: extensions.jiraIssueAction || [],
        issueGlance: extensions.jiraIssueGlance || [],
        issueContext: extensions.jiraIssueContext || [],
        issuePanel: extensions.jiraIssuePanel || [],
        issueActivity: extensions.jiraIssueActivity || [],
        customField: extensions.jiraCustomField || [],
        customFieldType: extensions.jiraCustomFieldType || [],
        issueViewBackgroundScript: extensions.jiraIssueViewBackgroundScript || [],
        uiModifications: extensions.jiraUiModifications || [],
        blockedExtensions: {
            issueAction: accessNarrowedExtensions.jiraIssueAction || [],
            issueGlance: accessNarrowedExtensions.jiraIssueGlance || [],
            issueContext: accessNarrowedExtensions.jiraIssueContext || [],
            issuePanel: accessNarrowedExtensions.jiraIssuePanel || [],
            issueActivity: accessNarrowedExtensions.jiraIssueActivity || [],
            customField: accessNarrowedExtensions.jiraCustomField || [],
            customFieldType: accessNarrowedExtensions.jiraCustomFieldType || [],
            issueViewBackgroundScript: accessNarrowedExtensions.jiraIssueViewBackgroundScript || [],
            uiModifications: accessNarrowedExtensions.jiraUiModifications || []
        }
    };
    return (0, $cqw2K.dedupeContextAndGlance)(mappedResult);
};

});
parcelRegister("cqw2K", function(module, exports) {

$parcel$export(module.exports, "dedupeContextAndGlance", () => $d64b2f99c2b8c70a$export$17503ba1adfac304);
const $d64b2f99c2b8c70a$export$17503ba1adfac304 = (forgeData)=>{
    const contextInstallationIds = new Set(forgeData.issueContext?.map(({ installationId: installationId })=>installationId));
    const newGlanceItems = forgeData.issueGlance.filter(({ installationId: installationId })=>!contextInstallationIds.has(installationId));
    return {
        ...forgeData,
        issueGlance: newGlanceItems
    };
};

});




parcelRegister("iudJZ", function(module, exports) {

$parcel$export(module.exports, "issueGiraDataResource", () => $10cd2c2c1f752564$export$37badecd288c49f4);

var $9PXNH = parcelRequire("9PXNH");

var $lB25E = parcelRequire("lB25E");

var $2skem = parcelRequire("2skem");

var $danRw = parcelRequire("danRw");
const $10cd2c2c1f752564$export$37badecd288c49f4 = (0, $lB25E.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_GIRA_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $danRw.default)(...args),
    isBrowserOnly: true
}));

});
parcelRegister("danRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $42978606795502c9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $3l0Oz = parcelRequire("3l0Oz");

var $1aPBP = parcelRequire("1aPBP");

var $9PXNH = parcelRequire("9PXNH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42978606795502c9$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const issueKey = (0, $9PXNH.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const { baseUrl: baseUrl } = tenantContext;
        const data = await (0, $3l0Oz.default)(baseUrl, issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $1aPBP.createResourceError)({
            component: 'spa.view.routes.issue-view.gira.getData',
            message: 'An error was thrown while prefetching issue gira data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("3l0Oz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc2ad8759ea4740f$export$2e2bcd8739ae039);

var $lNfG4 = parcelRequire("lNfG4");

var $jBy23 = parcelRequire("jBy23");

var $gIOVj = parcelRequire("gIOVj");

var $a60Hj = parcelRequire("a60Hj");

var $kXzsJ = parcelRequire("kXzsJ");
const $cc2ad8759ea4740f$var$ISSUE_GIRA_DATA = 'issue-gira-data';
const $cc2ad8759ea4740f$var$timeToFetchIssueGiraDataMetric = (0, $lNfG4.metrics).custom({
    key: $cc2ad8759ea4740f$var$ISSUE_GIRA_DATA
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cc2ad8759ea4740f$export$2e2bcd8739ae039 = async (baseUrl, issueKey)=>{
    const projectKey = (0, $jBy23.extractProjectKey)(issueKey);
    const variables = {
        issueKey: issueKey,
        projectKey: projectKey
    };
    const payload = {
        query: (0, $gIOVj.buildIssueQuery)(),
        variables: variables,
        operationName: (0, $gIOVj.ISSUE_VIEW_INTERACTIVE_QUERY)
    };
    if ((0, $a60Hj.isInSample)()) $cc2ad8759ea4740f$var$timeToFetchIssueGiraDataMetric.start();
    try {
        const response = await (0, $kXzsJ.getClient)(baseUrl).query(payload);
        // Best-effort attempt to provide `issueId` and is not guaranteed
        const issueId = response.data?.viewIssue?.issueId;
        $cc2ad8759ea4740f$var$timeToFetchIssueGiraDataMetric.stop({
            customData: issueId ? {
                issueId: issueId
            } : null
        });
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // Cancel the metric and re-throw the error
        $cc2ad8759ea4740f$var$timeToFetchIssueGiraDataMetric.cancel();
        throw error;
    }
};

});
parcelRegister("gIOVj", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $8fd02e0075f962e8$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $8fd02e0075f962e8$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $8fd02e0075f962e8$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $8fd02e0075f962e8$export$222ae9aca08830f0);
$parcel$export(module.exports, "getGiraRequestOptions", () => $8fd02e0075f962e8$export$e1542dc7ff749de8);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $bKxX9 = parcelRequire("bKxX9");

var $k0k8C = parcelRequire("k0k8C");

var $cs6Z7 = parcelRequire("cs6Z7");

var $6wu6G = parcelRequire("6wu6G");

var $cEBFL = parcelRequire("cEBFL");

var $h9ZPQ = parcelRequire("h9ZPQ");

var $8b8FO = parcelRequire("8b8FO");

var $7IE2L = parcelRequire("7IE2L");

var $gIud4 = parcelRequire("gIud4");

var $bjRBT = parcelRequire("bjRBT");

var $iKlzi = parcelRequire("iKlzi");

var $78jDL = parcelRequire("78jDL");

var $aEsk2 = parcelRequire("aEsk2");

var $k94eC = parcelRequire("k94eC");

var $9U1Mc = parcelRequire("9U1Mc");

var $1zKic = parcelRequire("1zKic");

var $4825Q = parcelRequire("4825Q");
const $8fd02e0075f962e8$var$CREATED_ORDER_DESCENDING = '-created';
const $8fd02e0075f962e8$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $8fd02e0075f962e8$export$aefb19023b2eda55 = (_baseUrl, operation)=>`/rest/gira/1/${(0, $k0k8C.appendOperationQuery)(operation)}`;
const $8fd02e0075f962e8$var$viewIssueQuery = ()=>`
    viewIssue(issueKey: $issueKey) {
        ${(0, $cs6Z7.getIsOldValueRequested)((0, $6wu6G.GIRA_AGG_MIGRATION_ISARCHIVED_FLAG)) ? (0, $78jDL.getIsArchivedQuery)() : ''}
        canCreateSubTask
        canExportIssue
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $8b8FO.default)({
        maxResults: (0, $cEBFL.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $8fd02e0075f962e8$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $cEBFL.NUM_INITIAL_COMMENTS_TO_LOAD)),
        hydrateData: false
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $4825Q.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $cEBFL.NUM_INITIAL_WORKLOGS_TO_LOAD))
    })}
        ${(0, $gIud4.getEcosystemQuery)()}
        ${(0, $7IE2L.getContentPanelsQuery)()}
        ${(0, $gIud4.getLegacyRightWebPanelsQuery)()}
        ${(0, $bKxX9.ff)('issue.details.gira-agg-migration-attachments_ecebe') ? 'totalAttachmentsCount' : (0, $h9ZPQ.default)()}
        ${(0, $iKlzi.getContainersByTypeQuery)()}
        ${(0, $1zKic.getRemoteLinksQuery)()}
    }
`;
const $8fd02e0075f962e8$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $8fd02e0075f962e8$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
const $8fd02e0075f962e8$export$222ae9aca08830f0 = ()=>`
query ${$8fd02e0075f962e8$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$8fd02e0075f962e8$export$58eaa2ae4a5a410a()}
        ${(0, $aEsk2.default)()}
        ${$8fd02e0075f962e8$var$viewIssueQuery()}
        ${(0, $bjRBT.getJiraSettingsQuery)()}
        ${(0, $k94eC.default)()}
        ${(0, $9U1Mc.default)()}
    }

`;
const $8fd02e0075f962e8$export$e1542dc7ff749de8 = (issueKey, projectKey)=>{
    const payload = {
        operationName: $8fd02e0075f962e8$export$1780a132c0453fee,
        query: $8fd02e0075f962e8$export$222ae9aca08830f0(),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("k0k8C", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $c7bfdca12e254eb8$export$69694c3add0f6058);
const $c7bfdca12e254eb8$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("cEBFL", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $918a33e666c5e78d$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $918a33e666c5e78d$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $918a33e666c5e78d$export$aeae6fc40846cf9f);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports














const $918a33e666c5e78d$export$c46d621c29194aa4 = 5;
const $918a33e666c5e78d$export$304a6c004edb30d8 = '-created';
const $918a33e666c5e78d$export$b2e398ce246f55b3 = 5;
const $918a33e666c5e78d$export$1c36ecc9afd61c73 = '-started';
const $918a33e666c5e78d$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});

parcelRegister("h9ZPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c28c20ef01249d5c$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $c28c20ef01249d5c$export$2e2bcd8739ae039 = ()=>`attachments(orderDirection: DESC, orderField: CREATED, maxResults: 12) {
        nodes {
          id
          filename
          mimetype
          mediaApiFileId
          createdDate
          filesize
          parentName
          author {
              accountId
          }
          parentId
          hasRestrictedParent
        }
        totalCount
        deletableCount
      }
`;

});

parcelRegister("8b8FO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b9fb32e2d7fc8e2$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $8c9rb = parcelRequire("8c9rb");

var $6wu6G = parcelRequire("6wu6G");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b9fb32e2d7fc8e2$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, hydrateData: hydrateData = true })=>{
    const commentPermalinkId = (0, $8c9rb.getPermalinkId)((0, $8c9rb.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    const commentSourceParameter = (0, $1ybV0.ff)('jira_threaded_comments_prereq_631yd') ? ', requestSource: "web"' : '';
    const jiraCommentVisibility = ` jiraCommentVisibility {
    __typename
    ...on JiraRoleVisibility {
      name
    }
    ...on JiraGroupVisibility {
      group {
        groupId
        name
      }
    }
  }`;
    if ((0, $1ybV0.ff)('jiv-14067-issue.details.gira-agg-migration-comments_pzao9') && !(0, $1ybV0.ff)('issue-jiv-14530-comments-consistency-check_x716d') && !hydrateData) return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
            startIndex
        }
    `;
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}${commentSourceParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                ${jiraCommentVisibility}
                created
                updated
                jsdPublic
                bodyAdf
                jsdAuthorCanSeeRequest
				${(0, $1ybV0.ff)('jira_threaded_comments_prereq_631yd') ? 'isDeleted' : ''}
                ${(0, $1ybV0.ff)('jira_threaded_comments_prereq_631yd') ? 'parentId' : ''}
                ${(0, $1ybV0.ff)('jira_threaded_comments_prereq_631yd') ? 'replies' : ''}
                ${(0, $6wu6G.isJsmTimelineEnabled)() ? 'eventOccurredAt' : ''}
                ${(0, $6wu6G.isJsmTimelineEnabled)() ? 'jsdIncidentActivityViewHidden' : ''}
            }
            totalCount
            startIndex
			${(0, $1ybV0.ff)('jira_threaded_comments_prereq_631yd') ? 'rootCommentsCount' : ''}
        }
    `;
};

});

parcelRegister("7IE2L", function(module, exports) {

$parcel$export(module.exports, "getContentPanelsQuery", () => $431a6f81d3096fcd$export$e6f14eac549b679d);
const $431a6f81d3096fcd$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $431a6f81d3096fcd$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$431a6f81d3096fcd$var$getContentPanelNode()}
            }
        }
    }
`;
const $431a6f81d3096fcd$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$431a6f81d3096fcd$var$getContentPanelNode()}
            }
        }
    }
`;
const $431a6f81d3096fcd$export$e6f14eac549b679d = ()=>`
    ${$431a6f81d3096fcd$var$getContentPanelsConnectionQuery()}
    ${$431a6f81d3096fcd$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("gIud4", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $7b5055fce2a30c91$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $7b5055fce2a30c91$export$92c9a3dc7076af51);

var $bKxX9 = parcelRequire("bKxX9");
const $7b5055fce2a30c91$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $7b5055fce2a30c91$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      ${!(0, $bKxX9.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? `
      operations {
        name
        url: href
        icon {
          url
        }
        tooltip
        styleClass
      }` : ''}
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }    
      ${!(0, $bKxX9.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on') ? `
      backgroundScripts {
        iframe {
          addonKey
          moduleKey
          options
        }
        shouldReloadOnRefresh
      }` : ''}
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$7b5055fce2a30c91$var$getForgeQuery()}
    }
`;
const $7b5055fce2a30c91$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("bjRBT", function(module, exports) {

$parcel$export(module.exports, "getJiraSettingsQuery", () => $fc5601890f738e54$export$191f50c0f86b85ec);
const $fc5601890f738e54$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
const $fc5601890f738e54$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
const $fc5601890f738e54$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("iKlzi", function(module, exports) {

$parcel$export(module.exports, "getContainersByTypeQuery", () => $f3b1ff3f54778e3d$export$63131b2831854cc);
const $f3b1ff3f54778e3d$export$63131b2831854cc = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;

});

parcelRegister("78jDL", function(module, exports) {

$parcel$export(module.exports, "getIsArchivedQuery", () => $70934e0e589cd253$export$2b9ee7163e124831);
const $70934e0e589cd253$export$2b9ee7163e124831 = ()=>'isArchived';

});

parcelRegister("aEsk2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad384184792593f0$export$2e2bcd8739ae039);

var $hCNRu = parcelRequire("hCNRu");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad384184792593f0$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $hCNRu.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;

});
parcelRegister("hCNRu", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $64be2f4b2ff25f7a$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $64be2f4b2ff25f7a$var$nonIE11MaxTokenLength = 2 ** 16;
const $64be2f4b2ff25f7a$export$e40f2acaf1a50b00 = ()=>$64be2f4b2ff25f7a$var$nonIE11MaxTokenLength;

});


parcelRegister("k94eC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2892695ccbce2fe$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
const $c2892695ccbce2fe$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE'
    ];
const $c2892695ccbce2fe$export$f5ff20e9116b53bc = ()=>{
    const permissionKeysForArchival = [
        'ARCHIVE_ISSUES',
        'UNARCHIVE_ISSUES'
    ];
    const permissionKeys = $c2892695ccbce2fe$export$9fc40cb6f3529ef();
    if (!(0, $1ybV0.ff)('issue-unarchival_wdpb9')) return permissionKeys;
    return [
        ...permissionKeys,
        ...permissionKeysForArchival
    ];
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c2892695ccbce2fe$export$2e2bcd8739ae039 = ()=>`

    permissions(issueKey:$issueKey, keys:["${$c2892695ccbce2fe$export$f5ff20e9116b53bc().join('","')}"]) {
        key
        havePermission
    }
`;

});

parcelRegister("9U1Mc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4c00732e1b938da$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $a4c00732e1b938da$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;

});

parcelRegister("1zKic", function(module, exports) {

$parcel$export(module.exports, "getRemoteLinksQuery", () => $785a81b5a18b3dbb$export$6bbc6b72b0b57f25);
const $785a81b5a18b3dbb$export$6bbc6b72b0b57f25 = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }            
`;

});

parcelRegister("4825Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a565ae6a7a72917$export$2e2bcd8739ae039);

var $8c9rb = parcelRequire("8c9rb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a565ae6a7a72917$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = (0, $8c9rb.getPermalinkId)((0, $8c9rb.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};

});


parcelRegister("a60Hj", function(module, exports) {

$parcel$export(module.exports, "isInSample", () => $433b34397a9756c8$export$a994c91d08ead5ff);

const $433b34397a9756c8$export$a994c91d08ead5ff = (sampleRate = (0, $3e173c13cba9c734$export$9fc1f2d681a9e609))=>Math.random() <= 1 / sampleRate;

});
/**
 * Sample rates are defined as the inverse.
 * e.g. a sample rate of 100 = 1 in 100 events are sent.
 */ const $3e173c13cba9c734$export$9fc1f2d681a9e609 = 100; // 1%


parcelRegister("kXzsJ", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $04aa819d4030995f$export$6bb76d6eba7e258c);

var $2OdyW = parcelRequire("2OdyW");

var $gIOVj = parcelRequire("gIOVj");
const $04aa819d4030995f$var$makeFetchClient = (baseUrl)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $2OdyW.default)((0, $gIOVj.getGiraUrl)(baseUrl, operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            })
    });
let $04aa819d4030995f$var$client;
const $04aa819d4030995f$export$6bb76d6eba7e258c = (baseUrl)=>{
    if (!$04aa819d4030995f$var$client) $04aa819d4030995f$var$client = $04aa819d4030995f$var$makeFetchClient(baseUrl);
    return $04aa819d4030995f$var$client;
};

});




parcelRegister("kSgnh", function(module, exports) {

$parcel$export(module.exports, "issueGiraNonCriticalDataResource", () => $d12a144daa5dfc13$export$2d81f7bddf10f49e);

var $9PXNH = parcelRequire("9PXNH");

var $lB25E = parcelRequire("lB25E");

var $2skem = parcelRequire("2skem");

var $tPTRS = parcelRequire("tPTRS");
const $d12a144daa5dfc13$export$2d81f7bddf10f49e = (0, $lB25E.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_GIRA_NON_CRITICAL_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $tPTRS.default)(...args),
    isBrowserOnly: true
}));

});
parcelRegister("tPTRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e93b0b54749e5eeb$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $lwu0A = parcelRequire("lwu0A");

var $1aPBP = parcelRequire("1aPBP");

var $9PXNH = parcelRequire("9PXNH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e93b0b54749e5eeb$export$2e2bcd8739ae039 = async ({ match: match }, _)=>{
    const issueKey = (0, $9PXNH.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const data = await (0, $lwu0A.fetchIssueGiraNonCriticalData)(issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $1aPBP.createResourceError)({
            component: 'spa.view.routes.issue-view.gira-non-critical.getData',
            message: 'An error was thrown while prefetching issue gira non critical data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("lwu0A", function(module, exports) {

$parcel$export(module.exports, "nonCriticalGiraQueryExperienceTracking", () => $aea8e6a6bf82674d$export$f382deefb24f95ae);
$parcel$export(module.exports, "fetchIssueGiraNonCriticalData", () => $aea8e6a6bf82674d$export$58a9221a6c5306db);

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $ieUuV = parcelRequire("ieUuV");

var $4ceCM = parcelRequire("4ceCM");

var $kXzsJ = parcelRequire("kXzsJ");
const $aea8e6a6bf82674d$var$nonCriticalGiraQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId, isEarlyFetch: isEarlyFetch })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: isEarlyFetch ? 'issueEarlyFetchNonCriticalGiraQuery' : 'issueNonCriticalGiraQuery',
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: `Issue View ${isEarlyFetch ? 'Early Fetch ' : ''}Non Critical Gira Query`,
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $aea8e6a6bf82674d$export$f382deefb24f95ae = ({ wasExperienceSuccessful: wasExperienceSuccessful, isEarlyFetch: isEarlyFetch, error: error })=>{
    (0, $4ceCM.sendExperienceAnalytics)($aea8e6a6bf82674d$var$nonCriticalGiraQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error instanceof (0, $7byHA.default) && error.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $7byHA.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {},
        isEarlyFetch: isEarlyFetch
    }));
};
const $aea8e6a6bf82674d$var$isNonCriticalGiraQueryExperienceTrackingEnabled = ()=>(0, $1ybV0.ff)('issue.details.non-critical-gira-query-experience-tracking', false);
const $aea8e6a6bf82674d$export$58a9221a6c5306db = async (issueKey)=>{
    const variables = {
        issueKey: issueKey
    };
    const payload = {
        query: (0, $ieUuV.buildNonCriticalGiraQuery)(),
        variables: variables,
        operationName: (0, $ieUuV.ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY)
    };
    if (!$aea8e6a6bf82674d$var$isNonCriticalGiraQueryExperienceTrackingEnabled()) {
        const response = await (0, $kXzsJ.getClient)('').query(payload);
        return response;
    }
    try {
        const response = await (0, $kXzsJ.getClient)('').query(payload);
        $aea8e6a6bf82674d$export$f382deefb24f95ae({
            wasExperienceSuccessful: true,
            isEarlyFetch: false
        });
        return response;
    } catch (error) {
        $aea8e6a6bf82674d$export$f382deefb24f95ae({
            wasExperienceSuccessful: false,
            isEarlyFetch: false,
            error: error instanceof (0, $7byHA.default) ? error : undefined
        });
        throw error;
    }
};

});
parcelRegister("ieUuV", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY", () => $62451518e89bf947$export$857f1602ca5b9d99);
$parcel$export(module.exports, "buildNonCriticalGiraQuery", () => $62451518e89bf947$export$df3c3aa9d6d3f431);
$parcel$export(module.exports, "getNonCriticalGiraQueryRequestOptions", () => $62451518e89bf947$export$555194bfc9159fa3);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $bKxX9 = parcelRequire("bKxX9");

var $knMkV = parcelRequire("knMkV");
const $62451518e89bf947$export$857f1602ca5b9d99 = 'issueViewNonCriticalGiraQuery';
const $62451518e89bf947$export$df3c3aa9d6d3f431 = ()=>`
query ${$62451518e89bf947$export$857f1602ca5b9d99}($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        ${(0, $knMkV.getEcosystemQuery)()}
        ${(0, $bKxX9.ff)('issue.details.gira-agg-migration-attachments_ecebe') ? 'deletableAttachmentsCount' : ''}
    }
}`;
const $62451518e89bf947$export$555194bfc9159fa3 = (issueKey)=>({
        method: 'POST',
        body: JSON.stringify({
            operationName: $62451518e89bf947$export$857f1602ca5b9d99,
            query: $62451518e89bf947$export$df3c3aa9d6d3f431(),
            variables: {
                issueKey: issueKey
            }
        })
    });

});
parcelRegister("knMkV", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $039ea2834e0e4840$export$edefef8c65e08bd2);

var $bKxX9 = parcelRequire("bKxX9");
const $039ea2834e0e4840$export$edefef8c65e08bd2 = ()=>`
  ecosystem {
    operations {
      name
      url: href
      tooltip
      styleClass
    }
    ${(0, $bKxX9.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on') ? `
    backgroundScripts {
      iframe {
        addonKey
        moduleKey
        options
      }
      shouldReloadOnRefresh
    }` : ''}
  }
`;

});


parcelRegister("4ceCM", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $bd135bf39efe6af3$export$4a95ada1b8228562);

var $2vzCR = parcelRequire("2vzCR");

var $9lmTX = parcelRequire("9lmTX");

var $6rW04 = parcelRequire("6rW04");

var $fbE19 = parcelRequire("fbE19");
const $bd135bf39efe6af3$var$isSynthetic = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
function $bd135bf39efe6af3$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    const shard = (0, $6rW04.default)('ajs-shard');
    const region = (0, $6rW04.default)('ajs-region');
    Object.assign(additionalContext, {
        shard: shard,
        region: region
    });
    const enabledFeatureFlags = Object.fromEntries([
        ...(0, $fbE19.allFeatureFlagsAccessed)
    ].filter(([, value])=>value));
    Object.assign(additionalContext, {
        enabledFeatureFlags: enabledFeatureFlags
    });
    const synthetics = {
        additionalAttributes: {
            synthetic: $bd135bf39efe6af3$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(experienceDescription, synthetics);
    (0, $9lmTX.default)(experienceDescription);
}

});




parcelRegister("aBAel", function(module, exports) {

$parcel$export(module.exports, "fetchFeatureDataResource", () => $a5c0402ab53043be$export$ec991c565cf31550);
$parcel$export(module.exports, "getOfferingCatalogueFeaturesResource", () => $a5c0402ab53043be$export$d08a9fee651d30b2);

var $1ybV0 = parcelRequire("1ybV0");

var $jwzNs = parcelRequire("jwzNs");

var $lB25E = parcelRequire("lB25E");


const $a5c0402ab53043be$var$getDataLoader = ()=>(parcelRequire("jk8jL"));
const $a5c0402ab53043be$export$ec991c565cf31550 = (0, $lB25E.createResource)({
    type: (0, $18238e3ab68c08a3$export$23978b67a6b2068f),
    getKey: ()=>'state',
    getDataLoader: $a5c0402ab53043be$var$getDataLoader,
    maxAge: 1800000
});
const $a5c0402ab53043be$export$d08a9fee651d30b2 = ()=>[
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('offeringcataloguefeatures-resource-layer-in-frontend_o5pnu'), $a5c0402ab53043be$export$ec991c565cf31550)
    ];

});
const $18238e3ab68c08a3$export$23978b67a6b2068f = 'RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES';

parcelRegister("jk8jL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ehV6l").then(()=>parcelRequire('ThDek'));

});


parcelRegister("3JUND", function(module, exports) {

$parcel$export(module.exports, "browseIssueRoute", () => $6238162818d2e039$export$2c9c7e50a88e588b);
$parcel$export(module.exports, "browseIssueEmbedRoute", () => $6238162818d2e039$export$240aeec71c480594);

var $exb0h = parcelRequire("exb0h");

var $bmKiO = parcelRequire("bmKiO");
const $6238162818d2e039$export$2c9c7e50a88e588b = {
    group: (0, $exb0h.ROUTE_GROUPS_ISSUE),
    name: (0, $exb0h.ROUTE_NAMES_ISSUE),
    path: '/browse/:issueKey(\\w+-\\d+)(.*)?',
    query: [
        'filter?!=(.*)',
        'jql?!=(.*)'
    ],
    preloadOptions: {
        earlyChunks: [
            'issue-app-early-entry'
        ]
    },
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
};
const $6238162818d2e039$export$240aeec71c480594 = {
    group: (0, $exb0h.ROUTE_GROUPS_ISSUE),
    name: (0, $exb0h.ROUTE_NAMES_ISSUE_EMBED),
    path: '/browse/:issueKey(\\w+-\\d+)/embed',
    preloadOptions: {
        earlyChunks: [
            'issue-app-early-entry'
        ]
    },
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
};

});

parcelRegister("c4qEZ", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $d58942287640a101$export$49addbcdecb6e6ff);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $kB5wN = parcelRequire("kB5wN");

var $8ICxF = parcelRequire("8ICxF");

var $haxva = parcelRequire("haxva");
const $d58942287640a101$var$fullpageStyles = null;
const $d58942287640a101$var$modalStyles = null;
const $d58942287640a101$var$customSpacingStyles = null;
const $d58942287640a101$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $d58942287640a101$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $d58942287640a101$var$fullpageStyles : null,
        isModalView === true ? $d58942287640a101$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kB5wN.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($haxva))),
        className: (0, $7JEyt.default)([
            "_p12f1ypn _18s85ogf _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("kB5wN", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $628d22027b8eaf89$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $628d22027b8eaf89$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $628d22027b8eaf89$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $6mgGK = parcelRequire("6mgGK");

var $lB25E = parcelRequire("lB25E");

var $fruGB = parcelRequire("fruGB");
const $628d22027b8eaf89$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const { Provider: $628d22027b8eaf89$var$Provider, Consumer: $628d22027b8eaf89$var$Consumer } = $628d22027b8eaf89$export$37eeac5cc5245b18;
const $628d22027b8eaf89$export$55a90a8e865a39b5 = 700;
const $628d22027b8eaf89$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$628d22027b8eaf89$export$55a90a8e865a39b5}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $628d22027b8eaf89$var$useRouteKey() {
    const [routeState] = (0, $lB25E.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $628d22027b8eaf89$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $628d22027b8eaf89$var$useRouteKey();
    (0, $fruGB.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $fruGB.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $ebe79147dfe00ff9$export$ee15e0cd1efafcb4);
        (0, $fruGB.setCachedIsCompactValue)(defaultState, key);
    }
    const [isCompact, setIsCompact] = (0, $eUqFw.useState)(defaultState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($628d22027b8eaf89$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6mgGK.ContainerQueryObserver), {
        query: $628d22027b8eaf89$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY,
        onChange: (state)=>{
            (0, $fruGB.setCachedIsCompactValue)(state, key);
            setIsCompact(state);
        },
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($628d22027b8eaf89$var$Provider, {
        value: isCompact
    }, children));
};
const $628d22027b8eaf89$export$20feb77b5b617e44 = $628d22027b8eaf89$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $628d22027b8eaf89$var$StyledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $ebe79147dfe00ff9$export$ee15e0cd1efafcb4 = false;

parcelRegister("6mgGK", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $2f0f372a50da62d9$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $2f0f372a50da62d9$var$QueryContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
let $2f0f372a50da62d9$var$currentIdSeed = 0;
function $2f0f372a50da62d9$var$generateAttributeValue() {
    return `indicator-span-${$2f0f372a50da62d9$var$currentIdSeed++}`;
}
function $2f0f372a50da62d9$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $ebe79147dfe00ff9$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $eUqFw.useState)(defaultState);
    const handleQueryStatusChange = (0, $eUqFw.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $2f0f372a50da62d9$export$b66a67697973e01() {
    const currentState = (0, $eUqFw.useContext)($2f0f372a50da62d9$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $2f0f372a50da62d9$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $eUqFw.useMemo)(()=>$2f0f372a50da62d9$var$generateAttributeValue(), []);
    const spanRef = (0, $eUqFw.useRef)(null);
    const containerRef = (0, $eUqFw.useRef)(null);
    const currentState = $2f0f372a50da62d9$export$b66a67697973e01();
    (0, $eUqFw.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh; 
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f0f372a50da62d9$var$ContainerToBeQueried = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fruGB", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $592157d792cf61e1$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $592157d792cf61e1$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $592157d792cf61e1$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $592157d792cf61e1$var$cachedIsCompactValues = {};
let $592157d792cf61e1$var$previousRouteKey;
function $592157d792cf61e1$export$c47621d55d10906c(key) {
    return $592157d792cf61e1$var$cachedIsCompactValues[key];
}
function $592157d792cf61e1$export$568b2dd75c2027b4(isCompactValue, key) {
    $592157d792cf61e1$var$cachedIsCompactValues[key] = isCompactValue;
}
function $592157d792cf61e1$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $592157d792cf61e1$var$previousRouteKey) {
        $592157d792cf61e1$var$previousRouteKey = currentRouteKey;
        delete $592157d792cf61e1$var$cachedIsCompactValues[$592157d792cf61e1$var$previousRouteKey];
    }
}

});


parcelRegister("haxva", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.31d538db.svg", import.meta.url).toString();

});


parcelRegister("lw0Lc", function(module, exports) {

$parcel$export(module.exports, "sidebarFiltersGlobalResource", () => $956252207e550497$export$7e0b804085f0470d);

var $buJlM = parcelRequire("buJlM");

var $dRbI6 = parcelRequire("dRbI6");

var $lY2yG = parcelRequire("lY2yG");
const $956252207e550497$export$7e0b804085f0470d = (0, $lY2yG.withGiraAggAnonSsrFix)((0, $buJlM.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_FILTERS_GLOBAL',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $dRbI6.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("dRbI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d44c58f47ce4dc16$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec2895c263a0bc866c147eac067ab3d3>>
 * @relayHash 8b92a92d7973bf2a60fc85271761fceb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0fc7dfdbeee4792faa92449e364dd4b9b51f2ed2fc3bd618160e27885c980a88
const $d44c58f47ce4dc16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v5 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ],
        "type": "JiraCustomFilter"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            },
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraFilterConnection",
                            "kind": "LinkedField",
                            "name": "favouriteFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "isFavourite",
                                    "value": false
                                }
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0fc7dfdbeee4792faa92449e364dd4b9b51f2ed2fc3bd618160e27885c980a88",
            "metadata": {},
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d44c58f47ce4dc16$var$node.hash = "b5467e25277d67ce676aa25dd3a16377";
var $d44c58f47ce4dc16$export$2e2bcd8739ae039 = $d44c58f47ce4dc16$var$node;

});

parcelRegister("lY2yG", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $db78da6c364437f8$export$f4b29e78f4c0a526);
const $db78da6c364437f8$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});


parcelRegister("51qRF", function(module, exports) {

$parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", () => $9a0146f4bac170ac$export$d3efe54a881807bf);

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $kOqDJ = parcelRequire("kOqDJ");
const $9a0146f4bac170ac$export$d3efe54a881807bf = (0, $lB25E.createResource)({
    type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(match, query);
        return projectKey || 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(match, query);
        if (projectKey == null) return null;
        return (0, $kOqDJ.fetchDefaultPINFiltersNavData)(projectKey);
    },
    maxAge: 300000
});

});
parcelRegister("kOqDJ", function(module, exports) {

$parcel$export(module.exports, "fetchDefaultPINFiltersNavData", () => $367b2d3283f133ce$export$268c1bcb44a0ddd3);

var $lRmyA = parcelRequire("lRmyA");
const $367b2d3283f133ce$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
const $367b2d3283f133ce$export$268c1bcb44a0ddd3 = async (projectKey)=>{
    if (projectKey == null) throw new Error('invalid project id or key');
    const result = await (0, $lRmyA.performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
    const filterNavIds = $367b2d3283f133ce$var$extractNavIds(result);
    return {
        hasMyOpenIssues: filterNavIds.has('myopenissues'),
        hasReportedByMe: filterNavIds.has('reportedbyme'),
        hasAllIssues: filterNavIds.has('allissues'),
        hasAllOpenIssues: filterNavIds.has('allopenissues'),
        hasDoneIssues: filterNavIds.has('doneissues'),
        hasViewedRecently: filterNavIds.has('recentlyviewed'),
        hasCreatedRecently: filterNavIds.has('addedrecently'),
        hasResolvedRecently: filterNavIds.has('resolvedrecently'),
        hasUpdatedRecently: filterNavIds.has('updatedrecently')
    };
};

});


parcelRegister("62ZdZ", function(module, exports) {

$parcel$export(module.exports, "sidebarProjectIssuesResource", () => $67f901853f9a37f2$export$be31dd7adcfd2297);

var $buJlM = parcelRequire("buJlM");

var $dV4cd = parcelRequire("dV4cd");

var $lY2yG = parcelRequire("lY2yG");
const $67f901853f9a37f2$export$be31dd7adcfd2297 = (0, $lY2yG.withGiraAggAnonSsrFix)((0, $buJlM.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $dV4cd.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("dV4cd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f0180673d49314d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9654d948e0d21eca1746252fbb0b581>>
 * @relayHash 62d616b47f1dfc22a4c3e97140061306
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e
const $0f0180673d49314d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraFilterConnection",
                            "kind": "LinkedField",
                            "name": "favouriteFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "filterId"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEditable"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e",
            "metadata": {},
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0f0180673d49314d$var$node.hash = "86a313b9769c9a6a731e02bed044f4d2";
var $0f0180673d49314d$export$2e2bcd8739ae039 = $0f0180673d49314d$var$node;

});


parcelRegister("fxlTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b0c9af883eccf10$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AsyncSidebarFiltersGlobal", () => $2b0c9af883eccf10$export$1af88ebe65f50e73);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

// Legacy GIN Sidebar
const $2b0c9af883eccf10$var$LazySidebarFiltersLegacy = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("kJ8mN")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2b0c9af883eccf10$var$AsyncSidebarFiltersLegacy = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b0c9af883eccf10$var$LazySidebarFiltersLegacy, null)));
var $2b0c9af883eccf10$export$2e2bcd8739ae039 = $2b0c9af883eccf10$var$AsyncSidebarFiltersLegacy;

// Global-scope NIN sidebar
const $2b0c9af883eccf10$var$LazySidebarFiltersGlobal = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    return (parcelRequire("8itcf")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});
const $2b0c9af883eccf10$export$1af88ebe65f50e73 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b0c9af883eccf10$var$LazySidebarFiltersGlobal, null)));

});
parcelRegister("kJ8mN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("jaWtQ")
]).then(()=>parcelRequire('lS5FJ'));

});

parcelRegister("8itcf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("g3Or4")
]).then(()=>parcelRequire('j1wPf'));

});


parcelRegister("cINNO", function(module, exports) {

$parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", () => $ae6e202da237abde$export$3f6390b4131d761b);

var $lB25E = parcelRequire("lB25E");

const $ae6e202da237abde$var$getDataLoader = ()=>(parcelRequire("6COuw"));
const $ae6e202da237abde$export$3f6390b4131d761b = (0, $lB25E.createResource)({
    type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
    getKey: ()=>'ninGlobalScopeEnrolment',
    getDataLoader: $ae6e202da237abde$var$getDataLoader
});

});
parcelRegister("6COuw", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hdytc").then(()=>parcelRequire('3AaIE'));

});


parcelRegister("cWgoa", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorRelayResource", () => $7120e1887f5518bb$export$b4096f516fb93159);
$parcel$export(module.exports, "issueNavigatorFilterRelayResource", () => $7120e1887f5518bb$export$44ca3a0b25f38d83);
$parcel$export(module.exports, "issueNavigatorHydrationRelayResource", () => $7120e1887f5518bb$export$967ef0cfbd1cc946);
/* eslint-disable jira/import-whitelist */ 
var $iWLL0 = parcelRequire("iWLL0");

var $eI5EY = parcelRequire("eI5EY");

var $5as0a = parcelRequire("5as0a");

var $jccNB = parcelRequire("jccNB");

var $huI7r = parcelRequire("huI7r");

var $amu7D = parcelRequire("amu7D");

var $c7ifG = parcelRequire("c7ifG");

var $buJlM = parcelRequire("buJlM");

var $cIBDs = parcelRequire("cIBDs");

var $k7wca = parcelRequire("k7wca");

var $1zgpM = parcelRequire("1zgpM");

var $lB25E = parcelRequire("lB25E");

var $dX3ro = parcelRequire("dX3ro");

var $cCQm1 = parcelRequire("cCQm1");
const $7120e1887f5518bb$export$b4096f516fb93159 = (0, $lB25E.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${(0, $dX3ro.RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY)}`,
    getKey: ()=>'issue-navigator-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $cCQm1.getParams)(routerContext);
        const jqlOrFilterId = (0, $cCQm1.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        const maxIssuesPerPage = (0, $jccNB.getMaxIssuesPerPage)();
        const variables = {
            cloudId: tenantContext.cloudId,
            first: issueKey == null ? maxIssuesPerPage : null,
            issueSearchInput: jqlOrFilterId,
            namespace: (0, $jccNB.ISSUE_SEARCH_NAMESPACE),
            after: null,
            options: {
                issueKey: issueKey
            },
            fieldSetIds: [],
            shouldQueryFieldSetsById: false,
            filterId: Boolean(filter) && (0, $5as0a.isCustomFilter)(filter) ? filter : null,
            amountOfColumns: (0, $jccNB.MAX_AMOUNT_OF_COLUMNS),
            atlassianIntelligenceProductFeature: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $jccNB.NATURAL_LANGUAGE_TO_JQL),
            queryStatusForIssuekeyStrikethrough: (0, $eI5EY.fg)('jiv-18659-query-status-for-issuekey-strikethrough')
        };
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default)(), (0, $1zgpM.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $7120e1887f5518bb$export$44ca3a0b25f38d83 = (0, $lB25E.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${(0, $dX3ro.RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY)}`,
    getKey: ()=>'issue-navigator-filter-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { filter: filter } = (0, $cCQm1.getParams)(routerContext);
        const includeFilter = Boolean(filter) && (0, $5as0a.isFilterId)(filter);
        const variables = {
            includeFilter: includeFilter,
            filterAri: includeFilter ? (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'filter',
                resourceId: filter,
                activationId: tenantContext.activationId
            }) : ''
        };
        const options = {
            fetchPolicy: includeFilter ? 'network-only' : 'store-only'
        };
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default)(), (0, $k7wca.default), variables, options);
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $7120e1887f5518bb$export$967ef0cfbd1cc946 = (0, $lB25E.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${(0, $dX3ro.RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}`,
    getKey: ()=>'issue-navigator-hydration-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $cCQm1.getParams)(routerContext);
        const jqlOrFilterId = (0, $cCQm1.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        if ('filterId' in jqlOrFilterId) return null;
        const variables = {
            accountId: tenantContext.atlassianAccountId ?? '',
            cloudId: tenantContext.cloudId,
            includeUser: true,
            includeJira: true,
            jql: 'jql' in jqlOrFilterId && jqlOrFilterId.jql || '',
            isNinShowOutOfContextFieldsAsOnlyUnselectable: true,
            viewContext: null
        };
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default)(), (0, $cIBDs.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("5as0a", function(module, exports) {

$parcel$export(module.exports, "isCustomFilter", () => $14b81d6e722f4096$export$31180e7f1db565e5);
$parcel$export(module.exports, "isFilterId", () => $14b81d6e722f4096$export$23be85030bd58047);
const $14b81d6e722f4096$export$31180e7f1db565e5 = (filterId)=>/^\d+$/.test(filterId);
const $14b81d6e722f4096$export$887fa95a5a5cf197 = (filterId)=>/^-\d+$/.test(filterId);
const $14b81d6e722f4096$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});

parcelRegister("jccNB", function(module, exports) {

$parcel$export(module.exports, "sortDirections", () => $33b57811e830f7a0$export$73034536b9adc928);
$parcel$export(module.exports, "FilterTypes", () => $33b57811e830f7a0$export$ad2e3f13451a5d44);
$parcel$export(module.exports, "SearchInputTypes", () => $33b57811e830f7a0$export$75a31bc7c097ba4b);
$parcel$export(module.exports, "views", () => $33b57811e830f7a0$export$d0079916fe6800ac);
$parcel$export(module.exports, "defaultOrderFields", () => $33b57811e830f7a0$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", () => $33b57811e830f7a0$export$de2495608df10495);
$parcel$export(module.exports, "DEFAULT_ORDER_FIELD", () => $33b57811e830f7a0$export$393cb330f31d305c);
$parcel$export(module.exports, "DEFAULT_SORT_DIRECTION", () => $33b57811e830f7a0$export$8ea18fa9e35fdf25);
$parcel$export(module.exports, "DEFAULT_VIEW_ID", () => $33b57811e830f7a0$export$500b5c379b5c7f2e);
$parcel$export(module.exports, "MAX_ISSUES_PER_PAGE", () => $33b57811e830f7a0$export$f88f58d1a4b2078b);
$parcel$export(module.exports, "getMaxIssuesPerPage", () => $33b57811e830f7a0$export$8c67ad1f64ab5a9c);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $33b57811e830f7a0$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "PACKAGE_NAME", () => $33b57811e830f7a0$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $33b57811e830f7a0$export$d57b6b390e78d90f);
$parcel$export(module.exports, "EXPERIENCE_NAME", () => $33b57811e830f7a0$export$52919046b94109dc);
$parcel$export(module.exports, "ANALYTICS_LIST_VIEW_SOURCE_NAME", () => $33b57811e830f7a0$export$81d9767bc5c1549e);
$parcel$export(module.exports, "ANALYTICS_DETAIL_VIEW_SOURCE_NAME", () => $33b57811e830f7a0$export$524ae4278a57eea2);
$parcel$export(module.exports, "LIST_VIEW_ID", () => $33b57811e830f7a0$export$af225181779390f4);
$parcel$export(module.exports, "MAX_AMOUNT_OF_COLUMNS", () => $33b57811e830f7a0$export$608eeb3a32afef02);
$parcel$export(module.exports, "COLUMN_TYPE_EPIC_LINK", () => $33b57811e830f7a0$export$ce9e2d7c178a9557);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $33b57811e830f7a0$export$1adf7afff96bbf16);
$parcel$export(module.exports, "NATURAL_LANGUAGE_TO_JQL", () => $33b57811e830f7a0$export$55628b4c44d1522a);
$parcel$export(module.exports, "supportedOrderFields", () => $33b57811e830f7a0$export$3630aa1c4c69277f);
$parcel$export(module.exports, "getSupportedFieldForAlias", () => $33b57811e830f7a0$export$eaadab3243bf458);

var $1NJeM = parcelRequire("1NJeM");

var $a4IeB = parcelRequire("a4IeB");
const $33b57811e830f7a0$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};
const $33b57811e830f7a0$export$3f42f49c284d5b58 = {
    TODO: 2,
    COMPLETE: 3,
    IN_PROGRESS: 4
};
const $33b57811e830f7a0$export$ad2e3f13451a5d44 = {
    ID: 'filterId',
    JQL: 'filterJql'
};
const $33b57811e830f7a0$export$75a31bc7c097ba4b = {
    JQL: 'jql',
    FILTER: 'filter',
    FILTER_AND_JQL: 'filterAndJql'
};
const $33b57811e830f7a0$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};
const $33b57811e830f7a0$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $33b57811e830f7a0$export$92a576f896a9bf72 = {
    myopenissues: Symbol('myopenissues'),
    reportedbyme: Symbol('reportedbyme'),
    allopenissues: Symbol('allopenissues'),
    doneissues: Symbol('doneissues'),
    recentlyviewed: Symbol('recentlyviewed'),
    resolvedrecently: Symbol('resolvedrecently'),
    updatedrecently: Symbol('updatedrecently'),
    allissues: Symbol('allissues')
};
const $33b57811e830f7a0$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
const $33b57811e830f7a0$export$66816805c55e43b7 = 'jira.issues.preferred.layout.key';
const $33b57811e830f7a0$export$393cb330f31d305c = $33b57811e830f7a0$export$2bd49f8f262d7cbb.created;
const $33b57811e830f7a0$export$8ea18fa9e35fdf25 = $33b57811e830f7a0$export$73034536b9adc928.DESC;
const $33b57811e830f7a0$export$500b5c379b5c7f2e = 'list_default';
const $33b57811e830f7a0$export$f88f58d1a4b2078b = 50;
const $33b57811e830f7a0$export$8c67ad1f64ab5a9c = ()=>$33b57811e830f7a0$export$f88f58d1a4b2078b;
const $33b57811e830f7a0$export$9d7b852b1c962aa3 = 1000;
const $33b57811e830f7a0$export$f7109619a5e9e0d6 = 'issue-navigator-next';
const $33b57811e830f7a0$export$b8b9d90f9e5bd72b = 'jiraIssueNavigator';
const $33b57811e830f7a0$export$d57b6b390e78d90f = 'empanada';
const $33b57811e830f7a0$export$52919046b94109dc = 'showPinIssueList';
const $33b57811e830f7a0$export$81d9767bc5c1549e = 'issueNavigatorListView';
const $33b57811e830f7a0$export$524ae4278a57eea2 = 'issueNavigatorDetailView';
const $33b57811e830f7a0$export$af478702fa9b9a17 = 'user.search.mode';
const $33b57811e830f7a0$export$84f45d3374492a7c = 'BLANK';
const $33b57811e830f7a0$export$e1eb2ddab803c5ec = (0, $1NJeM.SEARCH_MODE_BASIC);
const $33b57811e830f7a0$export$af225181779390f4 = 'list_default';
const $33b57811e830f7a0$export$608eeb3a32afef02 = (0, $a4IeB.MAX_COLUMNS);
const $33b57811e830f7a0$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $33b57811e830f7a0$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $33b57811e830f7a0$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $33b57811e830f7a0$export$3630aa1c4c69277f = {
    created: {
        jqlTerm: 'created',
        fieldType: 'created',
        aliases: []
    },
    key: {
        jqlTerm: 'key',
        fieldType: 'issuekey',
        aliases: [
            'issuekey'
        ]
    },
    lastviewed: {
        jqlTerm: 'lastviewed',
        fieldType: 'lastviewed',
        aliases: []
    },
    priority: {
        jqlTerm: 'priority',
        fieldType: 'priority',
        aliases: []
    },
    resolved: {
        jqlTerm: 'resolved',
        fieldType: 'resolutiondate',
        aliases: []
    },
    status: {
        jqlTerm: 'status',
        fieldType: 'status',
        aliases: []
    },
    updated: {
        jqlTerm: 'updated',
        fieldType: 'updated',
        aliases: []
    },
    issuetype: {
        jqlTerm: 'issuetype',
        fieldType: 'issuetype',
        aliases: [
            'type'
        ]
    },
    assignee: {
        jqlTerm: 'assignee',
        fieldType: 'assignee',
        aliases: []
    },
    duedate: {
        jqlTerm: 'duedate',
        fieldType: 'duedate',
        aliases: []
    },
    reporter: {
        jqlTerm: 'reporter',
        fieldType: 'reporter',
        aliases: []
    },
    summary: {
        jqlTerm: 'summary',
        fieldType: 'summary',
        aliases: []
    }
};
const $33b57811e830f7a0$export$eaadab3243bf458 = (alias)=>Object.keys($33b57811e830f7a0$export$3630aa1c4c69277f).find((key)=>$33b57811e830f7a0$export$3630aa1c4c69277f[key]?.aliases.includes(alias));

});
parcelRegister("1NJeM", function(module, exports) {

$parcel$export(module.exports, "SEARCH_MODE_BASIC", () => $79ecc7e1457ed2bf$export$f963d14b266e4d2e);
$parcel$export(module.exports, "SEARCH_MODE_ADVANCED", () => $79ecc7e1457ed2bf$export$aad1d9eb9b751555);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_BASIC", () => $79ecc7e1457ed2bf$export$87c41a6b3123c00f);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_ADVANCED", () => $79ecc7e1457ed2bf$export$a7a000706ebc3ba8);
$parcel$export(module.exports, "DEFAULT_SEARCH_MODE", () => $79ecc7e1457ed2bf$export$e1eb2ddab803c5ec);
$parcel$export(module.exports, "mapSearchModeToAnalyticAtribute", () => $79ecc7e1457ed2bf$export$70c8f980e4a50682);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_LEFT_LOCATION", () => $79ecc7e1457ed2bf$export$4dab29e715a4e6fb);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_RIGHT_LOCATION", () => $79ecc7e1457ed2bf$export$59848395da0b4bcb);
$parcel$export(module.exports, "PACKAGE_NAME", () => $79ecc7e1457ed2bf$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $79ecc7e1457ed2bf$export$d57b6b390e78d90f);
const $79ecc7e1457ed2bf$export$f963d14b266e4d2e = 'basic';
const $79ecc7e1457ed2bf$export$aad1d9eb9b751555 = 'advanced';
const $79ecc7e1457ed2bf$export$87c41a6b3123c00f = 'BASIC';
const $79ecc7e1457ed2bf$export$a7a000706ebc3ba8 = 'ADVANCED';
const $79ecc7e1457ed2bf$export$e1eb2ddab803c5ec = $79ecc7e1457ed2bf$export$f963d14b266e4d2e;
const $79ecc7e1457ed2bf$export$70c8f980e4a50682 = {
    [$79ecc7e1457ed2bf$export$f963d14b266e4d2e]: $79ecc7e1457ed2bf$export$f963d14b266e4d2e,
    [$79ecc7e1457ed2bf$export$aad1d9eb9b751555]: 'JQL'
};
const $79ecc7e1457ed2bf$export$4dab29e715a4e6fb = 'Left';
const $79ecc7e1457ed2bf$export$59848395da0b4bcb = 'Right';
const $79ecc7e1457ed2bf$export$b8b9d90f9e5bd72b = 'jiraJqlBuilder';
const $79ecc7e1457ed2bf$export$d57b6b390e78d90f = 'empanada';

});


parcelRegister("cIBDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $58a0ca45edc55a4a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5324123194c5d99dcdf98bdf0fc7c0d5>>
 * @relayHash 3192a22253811f1a2a2e30511206336b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ced02a49e8c3383ab97232deb3bff78f7a428d9c0dc55cc8e829f0172d2726ee
const $58a0ca45edc55a4a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeJira"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeUser"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNinShowOutOfContextFieldsAsOnlyUnselectable"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = [
        v9 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = [
        v9 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v11 /*: any*/ 
    ], v13 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorName"
                },
                v11 /*: any*/ 
            ]
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "optionId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hydrateJqlBuilderQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValues"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useQuery"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValues_cascadeSelectPicker"
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v8 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "hydrateJqlQuery",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hydrateJqlBuilderQuery",
            "selections": [
                {
                    "condition": "includeUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "accountId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v12 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v8 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "hydrateJqlQuery",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jql"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "fields",
                                                            "plural": true,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraJqlField",
                                                                            "kind": "LinkedField",
                                                                            "name": "field",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v14 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraJqlSearchTemplate",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "searchTemplate",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v15 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "isNinShowOutOfContextFieldsAsOnlyUnselectable",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "shouldShowInContext"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "type"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "description"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "operators"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraFieldType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v14 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "values",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v13 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "values",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v9 /*: any*/ ,
                                                                                                v13 /*: any*/ ,
                                                                                                v14 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v15 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "small"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlProjectFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": v16 /*: any*/ ,
                                                                                                    "type": "JiraJqlStatusFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": v16 /*: any*/ ,
                                                                                                    "type": "JiraJqlStatusCategoryFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypes",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "xsmall"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlIssueTypeFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": v12 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlUserFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlPriorityFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fields",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v9 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "text"
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        v11 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlIssueFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprint",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "sprint",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "state"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "boardName"
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlSprintFieldValue"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v17 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v14 /*: any*/ ,
                                                                                                                v13 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraJqlCascadingOptionFieldValue"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraJqlQueryHydratedValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v13 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "QueryError",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "error",
                                                                                            "plural": false,
                                                                                            "selections": v10 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraJqlQueryHydratedError"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraJqlQueryHydratedField"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraJqlHydratedQuery"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "message"
                                                        }
                                                    ],
                                                    "type": "QueryError"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ced02a49e8c3383ab97232deb3bff78f7a428d9c0dc55cc8e829f0172d2726ee",
            "metadata": {},
            "name": "hydrateJqlBuilderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$58a0ca45edc55a4a$var$node.hash = "44d13fe5e219301bf9987a6926b9f257";
var $58a0ca45edc55a4a$export$2e2bcd8739ae039 = $58a0ca45edc55a4a$var$node;

});

parcelRegister("k7wca", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd2c7ab8e2e91ec6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c0dc4a342f4ce5786fbe069292419e8>>
 * @relayHash 4722fbdc72716192181bb0830d738d17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5
const $dd2c7ab8e2e91ec6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5",
            "metadata": {},
            "name": "main_FilterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$dd2c7ab8e2e91ec6$var$node.hash = "181bb07a6bafd05a2033750384a06766";
var $dd2c7ab8e2e91ec6$export$2e2bcd8739ae039 = $dd2c7ab8e2e91ec6$var$node;

});

parcelRegister("1zgpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b76afc79df7f5e5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<16983b23037882a602971fe8fd745f8c>>
 * @relayHash fb86784a7920e5e616511999de47e2aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b966803d671a9b1c48f111ca9b7512770e6f66722441a79f26e5e6658a257f2d

var $dbXJb = parcelRequire("dbXJb");

var $hXlzJ = parcelRequire("hXlzJ");

var $6aQ5B = parcelRequire("6aQ5B");

var $57iDA = parcelRequire("57iDA");

var $91oFA = parcelRequire("91oFA");

var $9u07e = parcelRequire("9u07e");
const $5b76afc79df7f5e5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianIntelligenceProductFeature"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryStatusForIssuekeyStrikethrough"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v15 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v16 = [
        v15 /*: any*/ 
    ], v17 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v18 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "feature",
                    "variableName": "atlassianIntelligenceProductFeature"
                }
            ],
            "kind": "ObjectValue",
            "name": "atlassianIntelligenceProductFeatureInput"
        },
        v15 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        v15 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "key"
    }, v22 = {
        "kind": "ScalarField",
        "name": "id"
    }, v23 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v24 = {
        "kind": "Variable",
        "name": "filterId",
        "variableName": "filterId"
    }, v25 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v26 = {
        "kind": "Variable",
        "name": "namespace",
        "variableName": "namespace"
    }, v27 = {
        "kind": "Variable",
        "name": "viewId",
        "variableName": "viewId"
    }, v28 = [
        v24 /*: any*/ ,
        v25 /*: any*/ ,
        v26 /*: any*/ ,
        v27 /*: any*/ 
    ], v29 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "name"
    }, v31 = {
        "kind": "ScalarField",
        "name": "text"
    }, v32 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v33 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v35 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v34 /*: any*/ ,
            v22 /*: any*/ 
        ]
    }, v36 = {
        "args": v28 /*: any*/ ,
        "concreteType": "JiraIssueFieldSetConnection",
        "kind": "LinkedField",
        "name": "fieldSetsForIssueSearchView",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v19 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v29 /*: any*/ ,
                                                            v30 /*: any*/ ,
                                                            v31 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v29 /*: any*/ ,
                                                            v30 /*: any*/ ,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v19 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v32 /*: any*/ ,
                                                                    v22 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v29 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v30 /*: any*/ ,
                                                                    v33 /*: any*/ ,
                                                                    v22 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v29 /*: any*/ ,
                                                            v35 /*: any*/ 
                                                        ],
                                                        "type": "JiraStatusCategoryField"
                                                    },
                                                    v22 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v37 = {
        "condition": "queryStatusForIssuekeyStrikethrough",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isResolved"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "status"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v19 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v29 /*: any*/ ,
                                            {
                                                "concreteType": "JiraStatus",
                                                "kind": "LinkedField",
                                                "name": "status",
                                                "plural": false,
                                                "selections": [
                                                    v35 /*: any*/ ,
                                                    v22 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "JiraStatusField"
                                    },
                                    v22 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "fieldsById(ids:[\"status\"])"
            }
        ]
    }, v38 = {
        "kind": "ScalarField",
        "name": "type"
    }, v39 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v40 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v41 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v30 /*: any*/ ,
                                    v22 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v42 = {
        "kind": "ScalarField",
        "name": "message"
    }, v43 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v42 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v44 = [
        v30 /*: any*/ ,
        v22 /*: any*/ 
    ], v45 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v44 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    }, v46 = {
        "kind": "ScalarField",
        "name": "date"
    }, v47 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v48 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v49 = {
        "kind": "ClientExtension",
        "selections": [
            v48 /*: any*/ 
        ]
    }, v50 = {
        "kind": "InlineFragment",
        "selections": [
            v46 /*: any*/ ,
            v30 /*: any*/ ,
            v47 /*: any*/ ,
            v49 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v51 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "dateTime"
            }
        ],
        "type": "JiraDateTimePickerField"
    }, v52 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v21 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "summary"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v53 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v54 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v34 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v55 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v35 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v56 = [
        v30 /*: any*/ 
    ], v57 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v58 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1000
            }
        ],
        "concreteType": "JiraLabelConnection",
        "kind": "LinkedField",
        "name": "selectedLabelsConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraLabelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraLabel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": v56 /*: any*/ 
                    }
                ]
            },
            v57 /*: any*/ 
        ],
        "storageKey": "selectedLabelsConnection(first:1000)"
    }, v59 = {
        "kind": "InlineFragment",
        "selections": [
            v58 /*: any*/ ,
            v30 /*: any*/ ,
            v49 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v60 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v33 /*: any*/ ,
                    v30 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v61 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v62 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v21 /*: any*/ ,
                    {
                        "concreteType": "JiraSingleLineTextField",
                        "kind": "LinkedField",
                        "name": "summaryField",
                        "plural": false,
                        "selections": [
                            v31 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    },
                    v22 /*: any*/ ,
                    {
                        "concreteType": "JiraColorField",
                        "kind": "LinkedField",
                        "name": "issueColorField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "color",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "colorKey"
                                    },
                                    v22 /*: any*/ 
                                ]
                            },
                            v22 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v61 /*: any*/ ,
                                    v30 /*: any*/ ,
                                    v22 /*: any*/ 
                                ]
                            },
                            v22 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v63 = {
        "concreteType": "JiraPriority",
        "kind": "LinkedField",
        "name": "priority",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            v22 /*: any*/ 
        ]
    }, v64 = {
        "kind": "InlineFragment",
        "selections": [
            v63 /*: any*/ ,
            v30 /*: any*/ ,
            v49 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v65 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v21 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v66 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v44 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v67 = {
        "concreteType": "JiraSprintConnection",
        "kind": "LinkedField",
        "name": "selectedSprintsConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraSprintEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v22 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "sprintId"
                            },
                            v30 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "state"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "endDate"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v68 = {
        "kind": "InlineFragment",
        "selections": [
            v67 /*: any*/ ,
            v30 /*: any*/ ,
            v49 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v69 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v70 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v71 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            v69 /*: any*/ ,
            v32 /*: any*/ ,
            v30 /*: any*/ ,
            v22 /*: any*/ ,
            v70 /*: any*/ 
        ]
    }, v72 = {
        "kind": "InlineFragment",
        "selections": [
            v30 /*: any*/ ,
            {
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v44 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v73 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v74 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v61 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v75 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v76 = [
        v57 /*: any*/ 
    ], v77 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    v75 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v76 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "webUrl"
                                            },
                                            v21 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v19 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v35 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v22 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v22 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v22 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueLinkField"
    }, v78 = {
        "kind": "ScalarField",
        "name": "isStoryPointField"
    }, v79 = {
        "kind": "ScalarField",
        "name": "number"
    }, v80 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v78 /*: any*/ ,
                    v79 /*: any*/ ,
                    v30 /*: any*/ ,
                    v49 /*: any*/ 
                ],
                "type": "JiraNumberField"
            }
        ]
    }, v81 = {
        "condition": "shouldQueryFieldSetsById",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "fieldSetIds",
                        "variableName": "fieldSetIds"
                    },
                    v25 /*: any*/ 
                ],
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsById",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    v39 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v19 /*: any*/ ,
                                                            v29 /*: any*/ ,
                                                            v38 /*: any*/ ,
                                                            v40 /*: any*/ ,
                                                            v22 /*: any*/ ,
                                                            v41 /*: any*/ ,
                                                            v43 /*: any*/ ,
                                                            v45 /*: any*/ ,
                                                            v50 /*: any*/ ,
                                                            v51 /*: any*/ ,
                                                            v52 /*: any*/ ,
                                                            v53 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v31 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v49 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            },
                                                            v54 /*: any*/ ,
                                                            v55 /*: any*/ ,
                                                            v59 /*: any*/ ,
                                                            v60 /*: any*/ ,
                                                            v62 /*: any*/ ,
                                                            v64 /*: any*/ ,
                                                            v65 /*: any*/ ,
                                                            v66 /*: any*/ ,
                                                            v68 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v71 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v47 /*: any*/ ,
                                                                    v49 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleSelectUserPickerField"
                                                            },
                                                            v72 /*: any*/ ,
                                                            v73 /*: any*/ ,
                                                            v74 /*: any*/ ,
                                                            v77 /*: any*/ ,
                                                            v80 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v82 = {
        "condition": "shouldQueryFieldSetsById",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "args": v28 /*: any*/ ,
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsForIssueSearchView",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    v39 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v29 /*: any*/ ,
                                                            v38 /*: any*/ ,
                                                            v40 /*: any*/ ,
                                                            v41 /*: any*/ ,
                                                            v43 /*: any*/ ,
                                                            v45 /*: any*/ ,
                                                            v50 /*: any*/ ,
                                                            v51 /*: any*/ ,
                                                            v52 /*: any*/ ,
                                                            v53 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v38 /*: any*/ ,
                                                                    v49 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraStatusCategory",
                                                                        "kind": "LinkedField",
                                                                        "name": "statusCategory",
                                                                        "plural": false,
                                                                        "selections": v56 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "JiraStatusCategoryField"
                                                            },
                                                            v55 /*: any*/ ,
                                                            v59 /*: any*/ ,
                                                            v62 /*: any*/ ,
                                                            v64 /*: any*/ ,
                                                            v65 /*: any*/ ,
                                                            v66 /*: any*/ ,
                                                            v68 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v38 /*: any*/ ,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v69 /*: any*/ ,
                                                                            v70 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    v47 /*: any*/ ,
                                                                    v49 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleSelectUserPickerField"
                                                            },
                                                            v72 /*: any*/ ,
                                                            v73 /*: any*/ ,
                                                            v74 /*: any*/ ,
                                                            v77 /*: any*/ ,
                                                            v80 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v83 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            v81 /*: any*/ ,
            v82 /*: any*/ 
        ]
    }, v84 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v81 /*: any*/ ,
            v82 /*: any*/ ,
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "issueRowFieldSets",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldSet",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v38 /*: any*/ ,
                                            v39 /*: any*/ ,
                                            {
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fields",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v19 /*: any*/ ,
                                                                    v29 /*: any*/ ,
                                                                    v38 /*: any*/ ,
                                                                    v40 /*: any*/ ,
                                                                    v22 /*: any*/ ,
                                                                    v41 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v45 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v46 /*: any*/ ,
                                                                            v48 /*: any*/ ,
                                                                            v30 /*: any*/ ,
                                                                            v47 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraDatePickerField"
                                                                    },
                                                                    v51 /*: any*/ ,
                                                                    v52 /*: any*/ ,
                                                                    v53 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v31 /*: any*/ ,
                                                                            v48 /*: any*/ ,
                                                                            v30 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraSingleLineTextField"
                                                                    },
                                                                    v54 /*: any*/ ,
                                                                    v55 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v58 /*: any*/ ,
                                                                            v48 /*: any*/ ,
                                                                            v30 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraLabelsField"
                                                                    },
                                                                    v60 /*: any*/ ,
                                                                    v62 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v48 /*: any*/ ,
                                                                            v63 /*: any*/ ,
                                                                            v30 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraPriorityField"
                                                                    },
                                                                    v65 /*: any*/ ,
                                                                    v66 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v48 /*: any*/ ,
                                                                            v67 /*: any*/ ,
                                                                            v30 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraSprintField"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v71 /*: any*/ ,
                                                                            v48 /*: any*/ ,
                                                                            v30 /*: any*/ ,
                                                                            v47 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraSingleSelectUserPickerField"
                                                                    },
                                                                    v72 /*: any*/ ,
                                                                    v73 /*: any*/ ,
                                                                    v74 /*: any*/ ,
                                                                    v77 /*: any*/ ,
                                                                    {
                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    v78 /*: any*/ ,
                                                                                    v79 /*: any*/ ,
                                                                                    v48 /*: any*/ ,
                                                                                    v30 /*: any*/ 
                                                                                ],
                                                                                "type": "JiraNumberField"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v85 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "childIssues",
                "plural": false,
                "selections": [
                    v19 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "activeProjectsOnly",
                                        "value": true
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 10
                                    }
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issues",
                                "plural": false,
                                "selections": v76 /*: any*/ ,
                                "storageKey": "issues(activeProjectsOnly:true,first:10)"
                            }
                        ],
                        "type": "JiraChildIssuesWithinLimit"
                    }
                ]
            }
        ]
    }, v86 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isHighlightedIssueRow"
            }
        ]
    }, v87 = {
        "kind": "ScalarField",
        "name": "totalIssueSearchResultCount"
    }, v88 = [
        {
            "kind": "Literal",
            "name": "maxCursors",
            "value": 7
        }
    ], v89 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v90 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v91 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v92 = [
        v91 /*: any*/ ,
        v89 /*: any*/ ,
        v90 /*: any*/ 
    ], v93 = {
        "concreteType": "JiraPageCursor",
        "kind": "LinkedField",
        "name": "last",
        "plural": false,
        "selections": v92 /*: any*/ 
    }, v94 = {
        "concreteType": "JiraPageCursor",
        "kind": "LinkedField",
        "name": "first",
        "plural": false,
        "selections": [
            v89 /*: any*/ ,
            v91 /*: any*/ ,
            v90 /*: any*/ 
        ]
    }, v95 = {
        "kind": "ScalarField",
        "name": "firstIssuePosition"
    }, v96 = {
        "kind": "ScalarField",
        "name": "lastIssuePosition"
    }, v97 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ],
                "type": "JiraInvalidSyntaxError"
            }
        ]
    }, v98 = {
        "kind": "ScalarField",
        "name": "isCappingIssueSearchResult"
    }, v99 = [
        v15 /*: any*/ ,
        v24 /*: any*/ ,
        v26 /*: any*/ ,
        v27 /*: any*/ 
    ], v100 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueSearchViewResult"
    }, v101 = {
        "kind": "ScalarField",
        "name": "viewId"
    }, v102 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        v25 /*: any*/ 
    ], v103 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v104 = {
        "concreteType": "JiraIssueSearchFieldSetEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraIssueSearchFieldSet",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v39 /*: any*/ ,
                    v38 /*: any*/ ,
                    v103 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isSortable"
                    },
                    {
                        "concreteType": "JiraFieldSetPreferences",
                        "kind": "LinkedField",
                        "name": "fieldSetPreferences",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "width"
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraFieldType",
                        "kind": "LinkedField",
                        "name": "fieldType",
                        "plural": false,
                        "selections": [
                            v103 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v105 = {
        "kind": "ScalarField",
        "name": "hasDefaultFieldSets"
    }, v106 = {
        "kind": "InlineFragment",
        "selections": [
            v42 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v19 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    }
                ]
            }
        ],
        "type": "QueryError"
    }, v107 = {
        "kind": "InlineFragment",
        "selections": [
            v22 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_issueQuery"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v16 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_IssueNavigator_userPreferences"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_jira"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v8 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v10 /*: any*/ ,
                v14 /*: any*/ ,
                v11 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v13 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v12 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v16 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlBuilderSearchMode"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isNaturalLanguageSpotlightTourEnabled"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": v18 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "shouldShowAtlassianIntelligence"
                        },
                        {
                            "args": v18 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "atlassianIntelligenceAction",
                            "plural": false,
                            "selections": [
                                v19 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isAccessible"
                                        }
                                    ],
                                    "type": "JiraAccessAtlassianIntelligenceFeature"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "link"
                                        }
                                    ],
                                    "type": "JiraEnableAtlassianIntelligenceDeepLink"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v20 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearchStable",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v36 /*: any*/ ,
                                                        v37 /*: any*/ ,
                                                        v83 /*: any*/ ,
                                                        v84 /*: any*/ ,
                                                        v85 /*: any*/ ,
                                                        v86 /*: any*/ 
                                                    ]
                                                },
                                                v19 /*: any*/ ,
                                                v17 /*: any*/ 
                                            ]
                                        },
                                        v87 /*: any*/ ,
                                        {
                                            "args": v88 /*: any*/ ,
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": [
                                                        v89 /*: any*/ ,
                                                        v90 /*: any*/ ,
                                                        v91 /*: any*/ 
                                                    ]
                                                },
                                                v93 /*: any*/ ,
                                                v94 /*: any*/ 
                                            ],
                                            "storageKey": "pageCursors(maxCursors:7)"
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                v95 /*: any*/ ,
                                                v96 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "firstIssueKeyFromNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastIssueKeyFromPreviousPage"
                                                }
                                            ]
                                        },
                                        v97 /*: any*/ ,
                                        v98 /*: any*/ ,
                                        v17 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v99 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewResult",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        v100 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v101 /*: any*/ ,
                                                {
                                                    "args": v102 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v104 /*: any*/ ,
                                                        v57 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                },
                                                v22 /*: any*/ ,
                                                v105 /*: any*/ 
                                            ],
                                            "type": "JiraIssueSearchView"
                                        },
                                        v106 /*: any*/ ,
                                        v107 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v20 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearch",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v89 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v36 /*: any*/ ,
                                                        v37 /*: any*/ ,
                                                        v83 /*: any*/ ,
                                                        v84 /*: any*/ ,
                                                        v85 /*: any*/ ,
                                                        v86 /*: any*/ 
                                                    ]
                                                },
                                                v19 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                v95 /*: any*/ ,
                                                v96 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v88 /*: any*/ ,
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": v92 /*: any*/ 
                                                },
                                                v93 /*: any*/ ,
                                                v94 /*: any*/ 
                                            ],
                                            "storageKey": "pageCursors(maxCursors:7)"
                                        },
                                        v87 /*: any*/ ,
                                        v97 /*: any*/ ,
                                        v98 /*: any*/ ,
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                v75 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v20 /*: any*/ ,
                                    "filters": [
                                        "cloudId",
                                        "issueSearchInput",
                                        "options"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorIssueSearchPagination__issueSearch",
                                    "kind": "LinkedHandle",
                                    "name": "issueSearch"
                                },
                                {
                                    "args": v99 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewResult",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        v100 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v101 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v105 /*: any*/ ,
                                                {
                                                    "args": v102 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v57 /*: any*/ ,
                                                        v104 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraIssueSearchView"
                                        },
                                        v106 /*: any*/ ,
                                        v107 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b966803d671a9b1c48f111ca9b7512770e6f66722441a79f26e5e6658a257f2d",
            "metadata": {},
            "name": "main_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $hXlzJ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider": (0, $dbXJb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider": (0, $91oFA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider": (0, $9u07e.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider": (0, $57iDA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider": (0, $6aQ5B.default)
            }
        }
    };
}();
$5b76afc79df7f5e5$var$node.hash = "ac2645746e8a36ff02277b3aac6b42cd";
var $5b76afc79df7f5e5$export$2e2bcd8739ae039 = $5b76afc79df7f5e5$var$node;

});
parcelRegister("hXlzJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2de0bed8baceec34$export$2e2bcd8739ae039);

var $79xbN = parcelRequire("79xbN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2de0bed8baceec34$export$2e2bcd8739ae039 = {
    get () {
        return (0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInlineIssueCreateEnabled', false);
    }
};

});


parcelRegister("dX3ro", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY", () => $fe8f646394bc81e3$export$c300d3b7f3dc697d);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY", () => $fe8f646394bc81e3$export$b99d8b4e19091835);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY", () => $fe8f646394bc81e3$export$1b65799bbeba8a33);
$parcel$export(module.exports, "defaultOrderFields", () => $fe8f646394bc81e3$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "sortDirections", () => $fe8f646394bc81e3$export$73034536b9adc928);
const $fe8f646394bc81e3$export$c300d3b7f3dc697d = 'ISSUE_NAVIGATOR_RELAY';
const $fe8f646394bc81e3$export$b99d8b4e19091835 = 'ISSUE_NAVIGATOR_FILTER_RELAY';
const $fe8f646394bc81e3$export$1b65799bbeba8a33 = 'ISSUE_NAVIGATOR_HYDRATION_RELAY';
const $fe8f646394bc81e3$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $fe8f646394bc81e3$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};

});

parcelRegister("cCQm1", function(module, exports) {

$parcel$export(module.exports, "getDefaultJqlGin", () => $a09739cd165c6ebd$export$8780b1523384f42d);
$parcel$export(module.exports, "getParams", () => $a09739cd165c6ebd$export$ec161d740909e39d);
$parcel$export(module.exports, "getJqlOrFilterId", () => $a09739cd165c6ebd$export$b968a035fc2aa57b);
/* eslint-disable jira/import-whitelist */ 
var $5as0a = parcelRequire("5as0a");

var $6vrw7 = parcelRequire("6vrw7");

var $f6ie2 = parcelRequire("f6ie2");

var $dX3ro = parcelRequire("dX3ro");
const $a09739cd165c6ebd$export$8780b1523384f42d = ()=>`ORDER BY ${(0, $dX3ro.defaultOrderFields).created} ${(0, $dX3ro.sortDirections).DESC}`;
const $a09739cd165c6ebd$export$ec161d740909e39d = ({ match: { params: params }, query: query })=>{
    const { projectKey: projectKey, issueKey: issueKey } = params;
    const { filter: filter, jql: jql } = query;
    // Default JQL when no relevant query parameter is set
    const defaultJql = projectKey !== null && projectKey !== undefined ? (0, $f6ie2.getDefaultJql)((0, $6vrw7.toProjectKey)(projectKey)) : $a09739cd165c6ebd$export$8780b1523384f42d();
    return {
        page: 1,
        jql: jql,
        issueKey: issueKey,
        projectKey: projectKey,
        filter: filter,
        defaultJql: defaultJql
    };
};
const $a09739cd165c6ebd$export$b968a035fc2aa57b = (defaultJql, jqlParam, filter, projectKey)=>{
    // If JQL param has been defined (even if it's empty) we should use it
    if (typeof jqlParam === 'string') return {
        jql: jqlParam
    };
    // If filter is non-empty then use the filter parameter
    if (typeof filter === 'string' && filter !== '') {
        if ((0, $5as0a.isFilterId)(filter)) return {
            filterId: filter
        };
        const filterJql = projectKey !== null && projectKey !== undefined ? (0, $f6ie2.mapFilterToJql)(projectKey, filter) : undefined;
        if (filterJql !== undefined) return {
            jql: filterJql
        };
    }
    // Fallback to the default JQL if neither JQL or valid filter parameters have been provided.
    return {
        jql: defaultJql
    };
};

});
parcelRegister("f6ie2", function(module, exports) {

$parcel$export(module.exports, "isFilterKey", () => $2a14197d875c29d0$export$2cad587bb603edda);
$parcel$export(module.exports, "mapFilterToJql", () => $2a14197d875c29d0$export$1d71dda738f608f);
$parcel$export(module.exports, "getDefaultJql", () => $2a14197d875c29d0$export$346d50fe8350b1d0);
$parcel$export(module.exports, "getUrlPrefix", () => $2a14197d875c29d0$export$821d4141d135e0d0);

var $53ciZ = parcelRequire("53ciZ");

var $jccNB = parcelRequire("jccNB");

var $fci12 = parcelRequire("fci12");
const $2a14197d875c29d0$export$2cad587bb603edda = (filter)=>typeof filter === 'string' && filter in (0, $fci12.Filters);
const $2a14197d875c29d0$export$1d71dda738f608f = (projectKey, filter)=>{
    if (!$2a14197d875c29d0$export$2cad587bb603edda(filter)) return undefined;
    const clauses = [
        `project = "${projectKey}"`
    ];
    let order = (0, $jccNB.DEFAULT_ORDER_FIELD);
    const direction = (0, $jccNB.DEFAULT_SORT_DIRECTION);
    switch((0, $fci12.Filters)[filter]){
        case (0, $fci12.Filters).myopenissues:
            clauses.push('assignee IN (currentUser())');
            clauses.push(`statusCategory IN (${(0, $fci12.StatusCategoryValues).TO_DO}, ${(0, $fci12.StatusCategoryValues).IN_PROGRESS})`);
            break;
        case (0, $fci12.Filters).reportedbyme:
            clauses.push('reporter IN (currentUser())');
            break;
        case (0, $fci12.Filters).allopenissues:
            clauses.push(`statusCategory IN (${(0, $fci12.StatusCategoryValues).TO_DO}, ${(0, $fci12.StatusCategoryValues).IN_PROGRESS})`);
            order = (0, $jccNB.defaultOrderFields).updated;
            break;
        case (0, $fci12.Filters).doneissues:
            clauses.push(`statusCategory = ${(0, $fci12.StatusCategoryValues).DONE}`);
            break;
        case (0, $fci12.Filters).recentlyviewed:
            order = (0, $jccNB.defaultOrderFields).lastviewed;
            break;
        case (0, $fci12.Filters).resolvedrecently:
            clauses.push('resolved >= -1w');
            order = (0, $jccNB.defaultOrderFields).updated;
            break;
        case (0, $fci12.Filters).updatedrecently:
            order = (0, $jccNB.defaultOrderFields).updated;
            break;
        case (0, $fci12.Filters).allissues:
            order = (0, $jccNB.defaultOrderFields).created;
            break;
        default:
    }
    return `${clauses.join(' AND ')} ORDER BY ${order} ${direction}`.trim();
};
const $2a14197d875c29d0$export$346d50fe8350b1d0 = (projectKey)=>`project = "${projectKey}" ORDER BY ${0, $jccNB.DEFAULT_ORDER_FIELD} ${0, $jccNB.DEFAULT_SORT_DIRECTION}`;
const $2a14197d875c29d0$export$e5b4f9d05e643346 = (search, match)=>({
        ...(0, $53ciZ.parse)(search),
        ...match && match.params
    });
const $2a14197d875c29d0$export$821d4141d135e0d0 = (url)=>{
    const match = url.match(/^(.*)\/projects.*$/);
    return (match && match[1]) ?? '';
};

});
parcelRegister("fci12", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $c4e7918aa985330a$export$92a576f896a9bf72);
$parcel$export(module.exports, "StatusCategoryValues", () => $c4e7918aa985330a$export$72d6e2acce8f36fd);
const $c4e7918aa985330a$export$92a576f896a9bf72 = {
    myopenissues: Symbol('myopenissues'),
    reportedbyme: Symbol('reportedbyme'),
    allopenissues: Symbol('allopenissues'),
    doneissues: Symbol('doneissues'),
    recentlyviewed: Symbol('recentlyviewed'),
    resolvedrecently: Symbol('resolvedrecently'),
    updatedrecently: Symbol('updatedrecently'),
    allissues: Symbol('allissues')
};
const $c4e7918aa985330a$export$72d6e2acce8f36fd = {
    TO_DO: '"To Do"',
    DONE: '"Done"',
    IN_PROGRESS: '"In Progress"'
};

});




parcelRegister("1tmBn", function(module, exports) {

$parcel$export(module.exports, "projectIssueNavigatorRoute", () => $cc4d4072d8ba1cc4$export$126b16ec65343bf);
$parcel$export(module.exports, "softwareIssueNavigatorRoute", () => $cc4d4072d8ba1cc4$export$ccfb6c4a189316bc);
$parcel$export(module.exports, "projectIssueNavigatorClassicRoute", () => $cc4d4072d8ba1cc4$export$fa71d22b1c44463b);
$parcel$export(module.exports, "servicedeskIssuesRoute", () => $cc4d4072d8ba1cc4$export$4be84a96ac761ab0);
$parcel$export(module.exports, "projectIssueNavigatorCoreRoute", () => $cc4d4072d8ba1cc4$export$e961cccd2405cdd0);
$parcel$export(module.exports, "globalIssueNavigatorRoute", () => $cc4d4072d8ba1cc4$export$f4c8e8bc55cd2008);
$parcel$export(module.exports, "globalIssueNavigator1Route", () => $cc4d4072d8ba1cc4$export$2dfbbe89ed354013);
$parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRoute", () => $cc4d4072d8ba1cc4$export$34695dccebecc6bc);

var $exb0h = parcelRequire("exb0h");
const $cc4d4072d8ba1cc4$export$126b16ec65343bf = {
    group: (0, $exb0h.ROUTE_GROUPS_ISSUE_NAVIGATOR),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
    path: '/projects/:projectKey/issues/:issueKey?'
};
const $cc4d4072d8ba1cc4$export$ccfb6c4a189316bc = {
    group: (0, $exb0h.ROUTE_GROUPS_ISSUE_NAVIGATOR),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
    path: '/jira/software/projects/:projectKey/issues/:issueKey?'
};
const $cc4d4072d8ba1cc4$export$fa71d22b1c44463b = {
    group: (0, $exb0h.ROUTE_GROUPS_ISSUE_NAVIGATOR),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/issues/:issueKey?'
};
const $cc4d4072d8ba1cc4$export$4be84a96ac761ab0 = {
    group: (0, $exb0h.ROUTE_GROUPS_ISSUE_NAVIGATOR),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ISSUES),
    path: '/jira/servicedesk/projects/:projectKey/issues/:issueKey?'
};
const $cc4d4072d8ba1cc4$export$e961cccd2405cdd0 = {
    group: (0, $exb0h.ROUTE_GROUPS_ISSUE_NAVIGATOR),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
    path: '/jira/core/projects/:projectKey/issues/:issueKey?'
};
const $cc4d4072d8ba1cc4$export$f4c8e8bc55cd2008 = {
    group: (0, $exb0h.ROUTE_GROUPS_ISSUE_NAVIGATOR),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
    path: '/issues/:issueKey?'
};
const $cc4d4072d8ba1cc4$export$2dfbbe89ed354013 = {
    group: (0, $exb0h.ROUTE_GROUPS_ISSUE_NAVIGATOR),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
    path: '/jira/issues/:issueKey?'
};
const $cc4d4072d8ba1cc4$export$34695dccebecc6bc = {
    group: (0, $exb0h.ROUTE_GROUPS_ISSUE_NAVIGATOR),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT),
    path: '/browse/:issueKey?',
    query: [
        'jql|filter'
    ]
};

});

parcelRegister("kKpAY", function(module, exports) {

$parcel$export(module.exports, "GlobalIssueNavigatorSkeleton", () => $c110d4f59d91f08b$export$51681996374b2585);
/* global-app.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $fzQ0u = parcelRequire("fzQ0u");
const $c110d4f59d91f08b$var$customCssStyles = null;
const $c110d4f59d91f08b$export$51681996374b2585 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fzQ0u))),
        className: (0, $7JEyt.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("fzQ0u", function(module, exports) {
module.exports = new URL("global-issue-navigator-skeleton.tpl.b1bf4b99.svg", import.meta.url).toString();

});


parcelRegister("iPtkN", function(module, exports) {

$parcel$export(module.exports, "ProjectIssueNavigatorSkeleton", () => $a457d53ab258e792$export$112138f5f732a994);
/* project-app.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $esTbv = parcelRequire("esTbv");
const $a457d53ab258e792$var$customCssStyles = null;
const $a457d53ab258e792$export$112138f5f732a994 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($esTbv))),
        className: (0, $7JEyt.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("esTbv", function(module, exports) {
module.exports = new URL("project-issue-navigator-skeleton.tpl.2a1718d8.svg", import.meta.url).toString();

});


parcelRegister("eMdFV", function(module, exports) {

$parcel$export(module.exports, "useGlobalScopeOptOutFlow", () => $316ead5ad3eb0883$export$f39dd0211cb78bcf);
$parcel$export(module.exports, "useGlobalScopeEnrolmentEnable", () => $316ead5ad3eb0883$export$f45d1a4e873cac44);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $1h6H8 = parcelRequire("1h6H8");

var $4D6hU = parcelRequire("4D6hU");

var $cINNO = parcelRequire("cINNO");

var $78d1w = parcelRequire("78d1w");

var $6yplV = parcelRequire("6yplV");

var $lB25E = parcelRequire("lB25E");

var $4ngas = parcelRequire("4ngas");

var $jsA3E = parcelRequire("jsA3E");
const $316ead5ad3eb0883$export$f39dd0211cb78bcf = (href)=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const redirectToGin = (0, $eUqFw.useCallback)(()=>{
        if (href) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(href);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, [
        href
    ]);
    const { renderFeedbackDialog: renderFeedbackDialog } = (0, $4ngas.default)({
        onClose: redirectToGin,
        isAdminSettingsModal: false
    });
    /**
	 * globalScopeOptOut
	 * Triggers the NIN Global Scope opt-out process, including all UI orchestration of feedback.
	 *
	 * The caller should handle "default" behaviour for when the user is already not enrolled,
	 * unless the `preventDefault` callback has been called. This allows for easy usage with links,
	 * where the onClick event's `preventDefault` can be passed.
	 *
	 * If using an event's `preventDefault`, remember to bind the event!
	 * ex: `globalScopeOptOut(event.preventDefault.bind(event));`
	 *
	 * @param {Function} preventDefault
	 */ return (0, $eUqFw.useCallback)(async (preventDefault)=>{
        // If the user has already opt-out, just allow the caller to handle the click
        if (!(0, $1ybV0.ff)('nin.global-scope_aqec8') || !(0, $1h6H8.getIsGlobalScopeEnrolmentEnabledFromLocalStorage)()) return;
        // Otherwise, take over the interaction
        preventDefault && preventDefault();
        try {
            // Update user preference and local storage
            !isAnonymous && await (0, $4D6hU.setIsGlobalScopeEnrolmentEnabledUserPreference)(false);
            (0, $1h6H8.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(false);
            renderFeedbackDialog();
            sessionStorage.setItem('showGinOptOutFlag', 'true');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag({
                type: 'error',
                title: (0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jsA3E.default).errorOptOutTitleIssueTermRefresh : (0, $jsA3E.default).errorOptOutTitle,
                description: (0, $jsA3E.default).errorOptOutDesc,
                testId: 'issue-navigator-action-meatball-menu.ui.error-flag'
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'optOutOfNin',
                    packageName: 'jiraIssueNavigatorChangeboarding',
                    teamName: 'empanada'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
        }
    }, [
        isAnonymous,
        renderFeedbackDialog,
        showFlag
    ]);
};
const $316ead5ad3eb0883$export$f45d1a4e873cac44 = ()=>{
    // We store localStorageData as state so that it's not recalculated during subsequent renders. We want that as a
    // guarantee, not just as a performance optimisation, so we're using useState rather than useMemo.
    //
    // The reason we want to guarantee it's only fetched during the initial render is that we want
    // isNinGlobalScopeEnrolmentEnabled to be stable if there's localStorageData. This can prevent a bug where fetch
    // true from localStorage, we render NIN, the resource returns false, we update local storage to false, and then
    // GinRedirect is rendered again by a parent component and localStorage now returns false and we redirect later
    // than we should.
    const [localStorageData] = (0, $eUqFw.useState)((0, $1h6H8.getIsGlobalScopeEnrolmentEnabledFromLocalStorage));
    const { data: resourceData } = (0, $lB25E.useResource)((0, $cINNO.isNinGlobalScopeEnrolmentEnabledResource));
    const [{ isInitialRender: isInitialRender }] = (0, $78d1w.useSpaStateTransition)();
    // We assume NIN global scope is enabled if this is an initial render, otherwise we rely on localStorageData if it
    // exists, otherwise we use resourceData. resourceData is async, and can block for a long time, so we optimise for
    // speed rather than correctness by trusting localStorageData.
    let isNinGlobalScopeEnrolmentEnabled;
    if (isInitialRender) isNinGlobalScopeEnrolmentEnabled = true;
    else if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = localStorageData;
    else isNinGlobalScopeEnrolmentEnabled = resourceData;
    return [
        isNinGlobalScopeEnrolmentEnabled,
        resourceData
    ];
};

});
parcelRegister("1h6H8", function(module, exports) {

$parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", () => $c81bcd3cd8865351$export$55632339cd4dae9c);
$parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", () => $c81bcd3cd8865351$export$7b78bfe0a111cecf);
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", () => $c81bcd3cd8865351$export$82b2633cf7498c5e);
$parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", () => $c81bcd3cd8865351$export$458eda2352a1e223);

var $aZaPn = parcelRequire("aZaPn");

var $gUUjF = parcelRequire("gUUjF");
const $c81bcd3cd8865351$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const $c81bcd3cd8865351$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
const $c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage = (0, $aZaPn.createLocalStorageProvider)('nin-changeboarding');
const $c81bcd3cd8865351$export$34434fbbe40a8047 = ()=>$c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.remove($c81bcd3cd8865351$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $c81bcd3cd8865351$export$55632339cd4dae9c = ()=>$c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.get($c81bcd3cd8865351$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $c81bcd3cd8865351$export$7b78bfe0a111cecf = ()=>$c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.get($c81bcd3cd8865351$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
const $c81bcd3cd8865351$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
    // In practice this is very unlikely to fail, as our local storage library checks that local storage is working
    // during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
    // existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
    try {
        $c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.set($c81bcd3cd8865351$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
        $c81bcd3cd8865351$export$34434fbbe40a8047();
    }
};
const $c81bcd3cd8865351$export$458eda2352a1e223 = ()=>{
    try {
        $c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.set($c81bcd3cd8865351$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
    }
};

});

parcelRegister("4D6hU", function(module, exports) {

$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledUserPreference", () => $569980ae425bc2f7$export$2fc59b10f256dbee);
$parcel$export(module.exports, "resetGlobalScopeForcedOptOutGinFlag", () => $569980ae425bc2f7$export$89f09c81b642e3c7);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $569980ae425bc2f7$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
const $569980ae425bc2f7$var$setGlobalScopeUserPreference = async (input)=>{
    const result = await (0, $lRmyA.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $569980ae425bc2f7$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION,
            variables: {
                input: input
            }
        })
    });
    if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${input.key}`, {
        cause: result.errors?.[0]
    });
};
const $569980ae425bc2f7$export$2fc59b10f256dbee = async (value)=>$569980ae425bc2f7$var$setGlobalScopeUserPreference({
        key: 'jira.user.nin.global.scope.enrolment',
        value: value ? 'nin' : 'gin'
    });
const $569980ae425bc2f7$export$89f09c81b642e3c7 = async ()=>$569980ae425bc2f7$var$setGlobalScopeUserPreference({
        key: 'jira.user.nin.global.scope.enrolment.flag.disabled',
        value: false
    }).catch((error)=>(0, $guiFP.default)({
            meta: {
                id: 'resetGlobalScopeGinFlag',
                packageName: 'jiraIssueNavigatorGlobalScopeEnrolment',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        }));

});

parcelRegister("4ngas", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7ca921dab456dbd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $79xbN = parcelRequire("79xbN");

var $1c02D = parcelRequire("1c02D");

var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $10fdS = parcelRequire("10fdS");

var $9Anw5 = parcelRequire("9Anw5");

var $SEaoU = parcelRequire("SEaoU");

var $gd0Sp = parcelRequire("gd0Sp");

var $iXLwW = parcelRequire("iXLwW");
const $b7ca921dab456dbd$export$3fe286306fb8ddfb = 'global-scope-issue-navigator-opt-out';
const $b7ca921dab456dbd$var$unknownAttributeValue = 'unknown';
const $b7ca921dab456dbd$export$b028e515f8f652e0 = ({ isSiteAdmin: isSiteAdmin, routeName: routeName, routeGroup: routeGroup, projectType: projectType, isProjectSimplified: isProjectSimplified, cloudId: cloudId })=>[
        {
            id: (0, $1c02D.EntryKeys).LOCATION,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            value: (0, $9Anw5.default)(window.location.href)
        },
        {
            id: (0, $1c02D.EntryKeys).REFERER,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            value: document.referrer ? (0, $9Anw5.default)(document.referrer) : ''
        },
        {
            id: (0, $1c02D.EntryKeys).USER_AGENT,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            value: navigator.userAgent
        },
        {
            id: (0, $1c02D.EntryKeys).SCREEN_RESOLUTION,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            value: `${window.screen.width} x ${window.screen.height}`
        },
        {
            id: (0, $1c02D.EntryKeys).ROUTE_NAME,
            value: routeName
        },
        {
            id: (0, $1c02D.EntryKeys).ROUTE_GROUP,
            value: routeGroup
        },
        {
            id: (0, $1c02D.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: isProjectSimplified.toString()
        },
        {
            id: (0, $1c02D.EntryKeys).IS_ADMIN,
            value: isSiteAdmin.toString()
        },
        {
            id: (0, $1c02D.EntryKeys).PROJECT_TYPE,
            value: projectType
        },
        {
            id: 'cloud-id',
            value: cloudId
        }
    ];
const $b7ca921dab456dbd$export$3a73a4e2115ebf73 = ({ isAdminSettingsModal: isAdminSettingsModal = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const titleDetails = isAdminSettingsModal ? formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iXLwW.default).titleDetailsAdminIssueTermRefresh : (0, $iXLwW.default).titleDetailsAdmin) : formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iXLwW.default).titleDetailsUserIssueTermRefresh : (0, $iXLwW.default).titleDetailsUser);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b7ca921dab456dbd$var$feedbackTitleDetailsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, titleDetails));
};
const $b7ca921dab456dbd$var$useFeedbackDialog = ({ isAdminSettingsModal: isAdminSettingsModal = false, onClose: onClose = ()=>undefined })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const route = (0, $10fdS.useCurrentRoute)();
    const [{ data: projectData }] = (0, $SEaoU.useContainerContext)();
    const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const routeGroup = route.group ?? $b7ca921dab456dbd$var$unknownAttributeValue;
    const routeName = route.name ?? $b7ca921dab456dbd$var$unknownAttributeValue;
    let projectType = $b7ca921dab456dbd$var$unknownAttributeValue;
    let isProjectSimplified = false;
    if (projectData && 'project' in projectData && projectData.project) {
        projectType = projectData.project.type;
        isProjectSimplified = projectData.project.isSimplified;
    }
    const renderFeedbackDialog = (0, $eUqFw.useCallback)(()=>{
        openFeedbackCollector({
            feedbackGroupId: $b7ca921dab456dbd$export$3fe286306fb8ddfb,
            entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR),
            onClose: onClose,
            feedbackContext: $b7ca921dab456dbd$export$b028e515f8f652e0({
                isSiteAdmin: isSiteAdmin,
                cloudId: cloudId,
                routeGroup: routeGroup,
                routeName: routeName,
                projectType: projectType,
                isProjectSimplified: isProjectSimplified
            }),
            feedbackTitle: formatMessage((0, $iXLwW.default).title),
            feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7ca921dab456dbd$export$3a73a4e2115ebf73, {
                isAdminSettingsModal: isAdminSettingsModal
            }),
            selectLabel: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iXLwW.default).reasonTitleIssueTermRefresh : (0, $iXLwW.default).reasonTitle),
            // Intentional whitespace to clear the placeholder
            // (eluding feedback dialog's empty check for this prop, which includes empty string)
            summaryPlaceholder: ' ',
            submitButtonLabel: formatMessage((0, $iXLwW.default).submitCaption),
            cancelButtonLabel: formatMessage((0, $iXLwW.default).cancelCaption),
            feedbackGroupLabels: {
                empty: {
                    selectOptionLabel: formatMessage((0, $iXLwW.default).reasonPlaceholder)
                },
                bug: {
                    fieldLabel: formatMessage((0, $iXLwW.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $iXLwW.default).reasonBug)
                },
                comment: {
                    fieldLabel: formatMessage((0, $iXLwW.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $iXLwW.default).reasonSpeed)
                },
                suggestion: {
                    fieldLabel: formatMessage((0, $iXLwW.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $iXLwW.default).reasonOthers)
                },
                question: {
                    fieldLabel: formatMessage((0, $iXLwW.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $iXLwW.default).reasonParity)
                }
            }
        });
    }, [
        openFeedbackCollector,
        onClose,
        isSiteAdmin,
        cloudId,
        routeGroup,
        routeName,
        projectType,
        isProjectSimplified,
        formatMessage,
        isAdminSettingsModal
    ]);
    return {
        renderFeedbackDialog: renderFeedbackDialog
    };
};
var $b7ca921dab456dbd$export$2e2bcd8739ae039 = $b7ca921dab456dbd$var$useFeedbackDialog;
const $b7ca921dab456dbd$var$feedbackTitleDetailsContainerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.050'
});

});
parcelRegister("iXLwW", function(module, exports) {

$parcel$export(module.exports, "default", () => $05b46a68a4098ad8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $05b46a68a4098ad8$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title",
        "defaultMessage": "Let us know why you're moving"
    },
    titleDetailsAdmin: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin",
        "defaultMessage": "You and your users will be able to use the old issue search temporarily."
    },
    titleDetailsUser: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user",
        "defaultMessage": "You'll be able to use the old issue search temporarily."
    },
    submitCaption: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.submit-caption",
        "defaultMessage": "Send feedback"
    },
    cancelCaption: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.cancel-caption",
        "defaultMessage": "Skip"
    },
    reasonTitle: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title",
        "defaultMessage": "What is your reason to go back to the old issue search?"
    },
    reasonPlaceholder: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-placeholder",
        "defaultMessage": "Select an option"
    },
    reasonParity: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-parity",
        "defaultMessage": "Features are missing"
    },
    reasonSpeed: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-speed",
        "defaultMessage": "It's slow"
    },
    reasonBug: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-bug",
        "defaultMessage": "There's a bug"
    },
    reasonOthers: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-others",
        "defaultMessage": "Others"
    },
    reasonQuestion: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-question",
        "defaultMessage": "Can you provide more details? It'll help make search better for everyone."
    },
    titleDetailsAdminIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin-issue-term-refresh",
        "defaultMessage": "You and your users will be able to use the old issue search temporarily."
    },
    titleDetailsUserIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user-issue-term-refresh",
        "defaultMessage": "You'll be able to use the old issue search temporarily."
    },
    reasonTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title-issue-term-refresh",
        "defaultMessage": "What is your reason to go back to the old issue search?"
    }
});
var $05b46a68a4098ad8$export$2e2bcd8739ae039 = $05b46a68a4098ad8$var$messages;

});


parcelRegister("jsA3E", function(module, exports) {

$parcel$export(module.exports, "default", () => $88e8eca017b28da3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $88e8eca017b28da3$var$messages = (0, $90IgZ.defineMessages)({
    errorOptOutTitle: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title",
        "defaultMessage": "We couldn't switch to the old issue search"
    },
    errorOptOutDesc: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-desc",
        "defaultMessage": "Refresh and try again."
    },
    errorOptOutTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title-issue-term-refresh",
        "defaultMessage": "We couldn't switch to the old issue search"
    }
});
var $88e8eca017b28da3$export$2e2bcd8739ae039 = $88e8eca017b28da3$var$messages;

});


parcelRegister("6Jtpt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("5gExw")
]).then(()=>parcelRequire('abz2K'));

});

parcelRegister("aYTNj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ffMHq")
]).then(()=>parcelRequire('alfJ7'));

});

parcelRegister("7z3So", function(module, exports) {

$parcel$export(module.exports, "jiraHomePageRightSidePanelResource", () => $2036c20e2fee6b44$export$9cba342d9ec5384d);

var $buJlM = parcelRequire("buJlM");

var $2rkVF = parcelRequire("2rkVF");

var $bKT2R = parcelRequire("bKT2R");
const $2036c20e2fee6b44$var$isBroadcastWidgetEnabled = ()=>false;
const $2036c20e2fee6b44$export$9cba342d9ec5384d = (0, $buJlM.createRelayResource)({
    type: (0, $bKT2R.JIRA_HOME_PAGE_RIGHT_SIDE_PANEL),
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $2rkVF.default),
            variables: {
                cloudId: tenantContext.cloudId,
                broadcastWidgetEnabled: $2036c20e2fee6b44$var$isBroadcastWidgetEnabled()
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("2rkVF", function(module, exports) {

$parcel$export(module.exports, "default", () => $71560e2826585aec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d73a7099a9295c02951eb57579b7d93>>
 * @relayHash a7e48eaea1f1087c0622f1648327271d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1
const $71560e2826585aec$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "broadcastWidgetEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_rightSidePanel_RootQuery",
            "selections": [
                {
                    "condition": "broadcastWidgetEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "main_homeBroadcastWidget_Widget"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_rightSidePanel_RootQuery",
            "selections": [
                {
                    "condition": "broadcastWidgetEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraUserBroadcastMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraUserBroadcastMessages",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraUserBroadcastMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraUserBroadcastMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "shouldDisplay"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1",
            "metadata": {},
            "name": "main_rightSidePanel_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$71560e2826585aec$var$node.hash = "174d1e9e3edb60b5684e0806b3d7342e";
var $71560e2826585aec$export$2e2bcd8739ae039 = $71560e2826585aec$var$node;

});

parcelRegister("bKT2R", function(module, exports) {

$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $824b6e53dd9ad3a1$export$750459958906793);
$parcel$export(module.exports, "RIGHT_SIDE_PANEL_EXPERIENCE", () => $824b6e53dd9ad3a1$export$2eb41e47cfa429b7);
$parcel$export(module.exports, "JIRA_HOME_PAGE_RIGHT_SIDE_PANEL", () => $824b6e53dd9ad3a1$export$6c783d91630ece21);

var $c9TLT = parcelRequire("c9TLT");
const $824b6e53dd9ad3a1$export$750459958906793 = (0, $c9TLT.gridSize) * 49;
const $824b6e53dd9ad3a1$export$2eb41e47cfa429b7 = {
    experience: 'jiraHomeRightSidePanel',
    experienceId: undefined,
    analyticsSource: 'jira-home'
};
const $824b6e53dd9ad3a1$export$6c783d91630ece21 = 'JIRA_HOME_PAGE_RIGHT_SIDE_PANEL';

});


parcelRegister("2BbQD", function(module, exports) {

$parcel$export(module.exports, "jiraHomeResourceWithCache", () => $d13e94b7c51e7401$export$1da15dc2d924240c);

var $lB25E = parcelRequire("lB25E");


const $d13e94b7c51e7401$export$1da15dc2d924240c = (0, $lB25E.createResource)({
    type: (0, $2165c8924c400a29$export$e79da7e0d9d1c1f2),
    getKey: ()=>'jira-home',
    getDataLoader: ()=>(parcelRequire("kNU6P")),
    maxAge: Infinity
});

});
const $2165c8924c400a29$export$e79da7e0d9d1c1f2 = 'JIRA_HOME';

parcelRegister("kNU6P", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("a3H0T")
]).then(()=>parcelRequire('jYBS9'));

});


parcelRegister("3yBpr", function(module, exports) {

$parcel$export(module.exports, "YourWorkSkeleton", () => $c10a5f28a6c5fd8d$export$62cf62fa23284b71);
$parcel$export(module.exports, "YourWorkItemListSkeleton", () => $c10a5f28a6c5fd8d$export$31cebe1052db844);

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $fUCcI = parcelRequire("fUCcI");

var $jVomH = parcelRequire("jVomH");
const $c10a5f28a6c5fd8d$export$62cf62fa23284b71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fUCcI)))
    });
const $c10a5f28a6c5fd8d$export$31cebe1052db844 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jVomH))),
        containerStyles: {
            maxHeight: '30em'
        }
    });

});
parcelRegister("fUCcI", function(module, exports) {
module.exports = new URL("your-work-app-skeleton.tpl.14d150b5.svg", import.meta.url).toString();

});

parcelRegister("jVomH", function(module, exports) {
module.exports = new URL("your-work-itemlist-skeleton.tpl.e9027f83.svg", import.meta.url).toString();

});


parcelRegister("gLhzs", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("fIsGv")
]).then(()=>parcelRequire('786QV'));

});

parcelRegister("9IDBB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7ROUp").then(()=>parcelRequire('gqQSP'));

});

parcelRegister("6ighq", function(module, exports) {

$parcel$export(module.exports, "findAppsRoute", () => $756f1f926c86d910$export$e264ef643451c60a);
$parcel$export(module.exports, "appRequestRoute", () => $756f1f926c86d910$export$e5429b8cad3b4991);
$parcel$export(module.exports, "promotionsRoute", () => $756f1f926c86d910$export$45df65bfacbf9a2a);

var $exb0h = parcelRequire("exb0h");
const $756f1f926c86d910$export$e264ef643451c60a = {
    group: (0, $exb0h.ROUTE_GROUPS_MARKETPLACE),
    name: (0, $exb0h.ROUTE_NAMES_MARKETPLACE_INDEX),
    path: '/jira/marketplace'
};
const $756f1f926c86d910$export$e5429b8cad3b4991 = {
    group: (0, $exb0h.ROUTE_GROUPS_MARKETPLACE),
    name: (0, $exb0h.ROUTE_NAMES_MARKETPLACE_APP_REQUESTS),
    path: '/jira/marketplace/manage/app-requests'
};
const $756f1f926c86d910$export$45df65bfacbf9a2a = {
    group: (0, $exb0h.ROUTE_GROUPS_MARKETPLACE),
    name: (0, $exb0h.ROUTE_NAMES_MARKETPLACE_PROMOTIONS),
    path: '/jira/marketplace/manage/promotions'
};

});

parcelRegister("2EiXF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("aS29e")
]).then(()=>parcelRequire('2D4FF'));

});

parcelRegister("bc7vB", function(module, exports) {

$parcel$export(module.exports, "backlogRelayResource", () => $2b408255f969730a$export$ad514b81f9e160d0);
$parcel$export(module.exports, "conditionalBacklogRelayResource", () => $2b408255f969730a$export$4a013be7938fa775);

var $1ybV0 = parcelRequire("1ybV0");

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $3mjFf = parcelRequire("3mjFf");

var $jwzNs = parcelRequire("jwzNs");

const $2b408255f969730a$export$ad514b81f9e160d0 = (0, $jwzNs.browserOnlyResourceWithCondition)(()=>false, (0, $buJlM.createRelayResource)({
    type: (0, $52b7f081c10f9d47$export$463905a04a9a75ce),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $3mjFf.default),
            variables: {
                boardId: (0, $huI7r.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        }),
    captureErrors: true
}));
const $2b408255f969730a$export$4a013be7938fa775 = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jsw.perf.critical-backlog-with-relay'), $2b408255f969730a$export$ad514b81f9e160d0);

});
parcelRegister("3mjFf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d41a02f4836bc39$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<af1752aeeac5a38b86a8d5cf173d18fb>>
 * @relayHash 010bb7cdad917d68ac7773a1dcb4ec01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f0265750b202c0ceda593f31130e4808462f54c3702123d91fff9c415016144e
const $6d41a02f4836bc39$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "state",
            "value": [
                "ACTIVE",
                "FUTURE"
            ]
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "goal"
    }, v6 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v7 = {
        "kind": "ScalarField",
        "name": "endDate"
    }, v8 = {
        "kind": "ScalarField",
        "name": "daysRemaining"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v11 = {
        "kind": "ScalarField",
        "name": "labels"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "category"
    }, v14 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v16 = {
        "kind": "ScalarField",
        "name": "flagged"
    }, v17 = {
        "kind": "ScalarField",
        "name": "done"
    }, v18 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "storyPoints"
    }, v20 = {
        "kind": "ScalarField",
        "name": "value"
    }, v21 = {
        "kind": "ScalarField",
        "name": "valueAsText"
    }, v22 = {
        "kind": "ScalarField",
        "name": "dueDate"
    }, v23 = {
        "kind": "ScalarField",
        "name": "complete"
    }, v24 = {
        "kind": "ScalarField",
        "name": "total"
    }, v25 = {
        "kind": "ScalarField",
        "name": "fixVersionsIds"
    }, v26 = {
        "kind": "ScalarField",
        "name": "sprintState"
    }, v27 = {
        "kind": "ScalarField",
        "name": "boardIssueListKey"
    }, v28 = {
        "kind": "ScalarField",
        "name": "requestColumnMigration"
    }, v29 = {
        "kind": "ScalarField",
        "name": "rankCustomFieldId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "color"
    }, v31 = {
        "kind": "ScalarField",
        "name": "permissions"
    }, v32 = {
        "kind": "ScalarField",
        "name": "hierarchyLevelType"
    }, v33 = {
        "kind": "ScalarField",
        "name": "hasRequiredFields"
    }, v34 = {
        "kind": "ScalarField",
        "name": "status"
    }, v35 = {
        "concreteType": "CurrentEstimation",
        "kind": "LinkedField",
        "name": "current",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "customFieldId"
            }
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "statisticFieldId"
    }, v37 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v38 = {
        "kind": "ScalarField",
        "name": "defaultUnit"
    }, v39 = {
        "kind": "ScalarField",
        "name": "workingDaysPerWeek"
    }, v40 = {
        "kind": "ScalarField",
        "name": "workingHoursPerDay"
    }, v41 = {
        "kind": "ScalarField",
        "name": "defaultFormat"
    }, v42 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v12 /*: any*/ 
    ], v43 = {
        "concreteType": "SoftwareCard",
        "kind": "LinkedField",
        "name": "cards",
        "plural": true,
        "selections": [
            v3 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            {
                "concreteType": "CardType",
                "kind": "LinkedField",
                "name": "type",
                "plural": false,
                "selections": v42 /*: any*/ 
            },
            {
                "concreteType": "CardStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v3 /*: any*/ ,
                    v4 /*: any*/ ,
                    v13 /*: any*/ 
                ]
            },
            {
                "kind": "LinkedField",
                "name": "assignee",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v14 /*: any*/ ,
                    v4 /*: any*/ ,
                    v15 /*: any*/ ,
                    v3 /*: any*/ 
                ]
            },
            v16 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            {
                "concreteType": "Estimate",
                "kind": "LinkedField",
                "name": "estimate",
                "plural": false,
                "selections": [
                    v19 /*: any*/ ,
                    {
                        "concreteType": "OriginalEstimate",
                        "kind": "LinkedField",
                        "name": "originalEstimate",
                        "plural": false,
                        "selections": [
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "concreteType": "CardPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v4 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v22 /*: any*/ ,
            {
                "concreteType": "ChildCardsMetadata",
                "kind": "LinkedField",
                "name": "childCardsMetadata",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v24 /*: any*/ 
                ]
            },
            v25 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "aggBacklogDataQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "Sprint",
                                    "kind": "LinkedField",
                                    "name": "sprints",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.name"
                                        },
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "concreteType": "SoftwareCard",
                                            "kind": "LinkedField",
                                            "name": "cards",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v9 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.key"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v10 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.summary"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v11 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.labels"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CardType",
                                                        "kind": "LinkedField",
                                                        "name": "type",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.type.id"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.type.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v12 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.type.iconUrl"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.type"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CardStatus",
                                                        "kind": "LinkedField",
                                                        "name": "status",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.status.id"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.status.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v13 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.status.category"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.status"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "assignee",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v14 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.sprints.cards.assignee.accountId"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.sprints.cards.assignee.name"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v15 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.sprints.cards.assignee.picture"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v16 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.flagged"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v17 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.done"
                                                },
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "Estimate",
                                                    "kind": "LinkedField",
                                                    "name": "estimate",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "OriginalEstimate",
                                                            "kind": "LinkedField",
                                                            "name": "originalEstimate",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v20 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.estimate.originalEstimate.value"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v21 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.estimate.originalEstimate.valueAsText"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "CardPriority",
                                                    "kind": "LinkedField",
                                                    "name": "priority",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.sprints.cards.priority.name"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v12 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.sprints.cards.priority.iconUrl"
                                                        }
                                                    ]
                                                },
                                                v22 /*: any*/ ,
                                                {
                                                    "concreteType": "ChildCardsMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "childCardsMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v23 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.sprints.cards.childCardsMetadata.complete"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v24 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.sprints.cards.childCardsMetadata.total"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v25 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.fixVersionsIds"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v26 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.sprintState"
                                        }
                                    ],
                                    "storageKey": "sprints(state:[\"ACTIVE\",\"FUTURE\"])"
                                },
                                "action": "THROW",
                                "path": "boardScope.sprints"
                            },
                            {
                                "concreteType": "Backlog",
                                "kind": "LinkedField",
                                "name": "backlog",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v27 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "boardScope.backlog.boardIssueListKey"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v28 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "boardScope.backlog.requestColumnMigration"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "SoftwareCard",
                                            "kind": "LinkedField",
                                            "name": "cards",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v9 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.key"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v10 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.summary"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v11 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.labels"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CardType",
                                                        "kind": "LinkedField",
                                                        "name": "type",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.type.id"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.type.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v12 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.type.iconUrl"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.type"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CardStatus",
                                                        "kind": "LinkedField",
                                                        "name": "status",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.status.id"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.status.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v13 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.status.category"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.status"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "assignee",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v14 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.backlog.cards.assignee.accountId"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.backlog.cards.assignee.name"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v15 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.backlog.cards.assignee.picture"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v16 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.flagged"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v17 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.done"
                                                },
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "Estimate",
                                                    "kind": "LinkedField",
                                                    "name": "estimate",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "OriginalEstimate",
                                                            "kind": "LinkedField",
                                                            "name": "originalEstimate",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v20 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.estimate.originalEstimate.value"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v21 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.estimate.originalEstimate.valueAsText"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "CardPriority",
                                                    "kind": "LinkedField",
                                                    "name": "priority",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.backlog.cards.priority.name"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v12 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.backlog.cards.priority.iconUrl"
                                                        }
                                                    ]
                                                },
                                                v22 /*: any*/ ,
                                                {
                                                    "concreteType": "ChildCardsMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "childCardsMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v23 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.backlog.cards.childCardsMetadata.complete"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v24 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.backlog.cards.childCardsMetadata.total"
                                                        }
                                                    ]
                                                },
                                                v25 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "boardScope.backlog.cards"
                                    }
                                ]
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cards",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.key"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v10 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.summary"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v11 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.labels"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardType",
                                                            "kind": "LinkedField",
                                                            "name": "type",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.type.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.type.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v12 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.type.iconUrl"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.type"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.status.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.status.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v13 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.status.category"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.status"
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "assignee",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v14 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cards.assignee.accountId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cards.assignee.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v15 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cards.assignee.picture"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v16 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.flagged"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v17 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.done"
                                                    },
                                                    v18 /*: any*/ ,
                                                    {
                                                        "concreteType": "Estimate",
                                                        "kind": "LinkedField",
                                                        "name": "estimate",
                                                        "plural": false,
                                                        "selections": [
                                                            v19 /*: any*/ ,
                                                            {
                                                                "concreteType": "OriginalEstimate",
                                                                "kind": "LinkedField",
                                                                "name": "originalEstimate",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v20 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.estimate.originalEstimate.value"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v21 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.estimate.originalEstimate.valueAsText"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "CardPriority",
                                                        "kind": "LinkedField",
                                                        "name": "priority",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cards.priority.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v12 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cards.priority.iconUrl"
                                                            }
                                                        ]
                                                    },
                                                    v22 /*: any*/ ,
                                                    {
                                                        "concreteType": "ChildCardsMetadata",
                                                        "kind": "LinkedField",
                                                        "name": "childCardsMetadata",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v23 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cards.childCardsMetadata.complete"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v24 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cards.childCardsMetadata.total"
                                                            }
                                                        ]
                                                    },
                                                    v25 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.cards"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v29 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.rankCustomFieldId"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CardParent",
                                    "kind": "LinkedField",
                                    "name": "cardParents",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v10 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.summary"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CardType",
                                                "kind": "LinkedField",
                                                "name": "cardType",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v4 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v12 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.iconUrl"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.cardType"
                                        },
                                        v30 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.cardParents"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CurrentUser",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v31 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.currentUser.permissions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.currentUser"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareProject",
                                    "kind": "LinkedField",
                                    "name": "projectLocation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CardType",
                                                "kind": "LinkedField",
                                                "name": "cardTypes",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v4 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v12 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.iconUrl"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v32 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.hierarchyLevelType"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v33 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.hasRequiredFields"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.cardTypes"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.projectLocation"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "BoardFeature",
                                    "kind": "LinkedField",
                                    "name": "features",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v34 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.status"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.features"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "EstimationConfig",
                                    "kind": "LinkedField",
                                    "name": "estimation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v35 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.estimation.current"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "AvailableEstimations",
                                                "kind": "LinkedField",
                                                "name": "available",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v36 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.estimation.available.statisticFieldId"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.estimation.available"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.estimation"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v37 /*: any*/ ,
                                    "concreteType": "JiraTimeTrackingSettings",
                                    "kind": "LinkedField",
                                    "name": "globalTimeTrackingSettings",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v38 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.globalTimeTrackingSettings.defaultUnit"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v39 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.globalTimeTrackingSettings.workingDaysPerWeek"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v40 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.globalTimeTrackingSettings.workingHoursPerDay"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v41 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.globalTimeTrackingSettings.defaultFormat"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.globalTimeTrackingSettings"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "aggBacklogDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "Sprint",
                            "kind": "LinkedField",
                            "name": "sprints",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v43 /*: any*/ ,
                                v26 /*: any*/ 
                            ],
                            "storageKey": "sprints(state:[\"ACTIVE\",\"FUTURE\"])"
                        },
                        {
                            "concreteType": "Backlog",
                            "kind": "LinkedField",
                            "name": "backlog",
                            "plural": false,
                            "selections": [
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                v43 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                v43 /*: any*/ ,
                                v29 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "CardParent",
                            "kind": "LinkedField",
                            "name": "cardParents",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "CardType",
                                    "kind": "LinkedField",
                                    "name": "cardType",
                                    "plural": false,
                                    "selections": v42 /*: any*/ 
                                },
                                v30 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "CurrentUser",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                v31 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "SoftwareProject",
                            "kind": "LinkedField",
                            "name": "projectLocation",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v9 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "CardType",
                                    "kind": "LinkedField",
                                    "name": "cardTypes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "BoardFeature",
                            "kind": "LinkedField",
                            "name": "features",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v34 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "EstimationConfig",
                            "kind": "LinkedField",
                            "name": "estimation",
                            "plural": false,
                            "selections": [
                                v35 /*: any*/ ,
                                {
                                    "concreteType": "AvailableEstimations",
                                    "kind": "LinkedField",
                                    "name": "available",
                                    "plural": true,
                                    "selections": [
                                        v36 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v37 /*: any*/ ,
                            "concreteType": "JiraTimeTrackingSettings",
                            "kind": "LinkedField",
                            "name": "globalTimeTrackingSettings",
                            "plural": false,
                            "selections": [
                                v38 /*: any*/ ,
                                v39 /*: any*/ ,
                                v40 /*: any*/ ,
                                v41 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f0265750b202c0ceda593f31130e4808462f54c3702123d91fff9c415016144e",
            "metadata": {},
            "name": "aggBacklogDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6d41a02f4836bc39$var$node.hash = "5066bdc9703e345e9762320044e879c8";
var $6d41a02f4836bc39$export$2e2bcd8739ae039 = $6d41a02f4836bc39$var$node;

});

const $52b7f081c10f9d47$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $52b7f081c10f9d47$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';
const $52b7f081c10f9d47$export$463905a04a9a75ce = 'NEXTGEN_BACKLOG_RELAY';


parcelRegister("gmVN5", function(module, exports) {

$parcel$export(module.exports, "backlogResource", () => $940828cbe6572373$export$31d171ba71468137);
$parcel$export(module.exports, "conditionalBacklogResource", () => $940828cbe6572373$export$c77659376558c168);

var $1ybV0 = parcelRequire("1ybV0");

var $jwzNs = parcelRequire("jwzNs");

var $lB25E = parcelRequire("lB25E");


const $940828cbe6572373$export$31d171ba71468137 = (0, $jwzNs.browserOnlyResourceWithCondition)(()=>false, (0, $lB25E.createResource)({
    type: (0, $52b7f081c10f9d47$export$a0ef589381533a7c),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("eT3FT")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
}));
const $940828cbe6572373$export$c77659376558c168 = (0, $jwzNs.resourceWithCondition2)(()=>!(0, $1ybV0.ff)('jsw.perf.critical-backlog-with-relay'), $940828cbe6572373$export$31d171ba71468137);

});
parcelRegister("eT3FT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("c9taI").then(()=>parcelRequire('k5z0l'));

});


parcelRegister("59z8J", function(module, exports) {

$parcel$export(module.exports, "customFiltersResource", () => $95f320c7eb1343f4$export$3e390340716755de);

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $gH3Un = parcelRequire("gH3Un");

var $jwzNs = parcelRequire("jwzNs");

const $95f320c7eb1343f4$export$3e390340716755de = (0, $jwzNs.browserOnlyResourceWithCondition)(()=>false, (0, $buJlM.createRelayResource)({
    type: (0, $52b7f081c10f9d47$export$faa68b3df5415bcb),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $gH3Un.default),
            variables: {
                boardId: (0, $huI7r.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    captureErrors: true
}));

});
parcelRegister("gH3Un", function(module, exports) {

$parcel$export(module.exports, "default", () => $3764437b0e4e7969$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<066895e3c0e872466470887b4350609b>>
 * @relayHash 8bb4d5e3e502ca70e90f4e1bb2f1614f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082
const $3764437b0e4e7969$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "customFilter_softwareFilters_CustomFilterRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082",
            "metadata": {},
            "name": "viewBacklogCustomFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3764437b0e4e7969$var$node.hash = "071c255f9696fe84a9c3982d42cfa5c0";
var $3764437b0e4e7969$export$2e2bcd8739ae039 = $3764437b0e4e7969$var$node;

});


parcelRegister("8zRre", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogRoute", () => $9d771d6904eb20db$export$fb454ec14936c0ab);
$parcel$export(module.exports, "softwareBacklogEmbedRoute", () => $9d771d6904eb20db$export$bc022a39c42aba2f);

var $exb0h = parcelRequire("exb0h");
const $9d771d6904eb20db$export$fb454ec14936c0ab = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_BACKLOG),
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog'
};
const $9d771d6904eb20db$export$bc022a39c42aba2f = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_BACKLOG_EMBED),
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog/embed',
    exact: true
};

});

parcelRegister("chAei", function(module, exports) {

$parcel$export(module.exports, "boardResource", () => $b59dcfcbfdcea858$export$286b76e0f2661cfb);
$parcel$export(module.exports, "customFiltersResource", () => $b59dcfcbfdcea858$export$3e390340716755de);
$parcel$export(module.exports, "boardRelayResource", () => $b59dcfcbfdcea858$export$81ac23db76b1f935);

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $entxd = parcelRequire("entxd");

var $4BxqS = parcelRequire("4BxqS");

var $jwzNs = parcelRequire("jwzNs");

var $lB25E = parcelRequire("lB25E");


const $b59dcfcbfdcea858$export$286b76e0f2661cfb = (0, $jwzNs.browserOnlyResourceWithCondition)(()=>false, (0, $lB25E.createResource)({
    type: (0, $77a7d82b9fcd593e$export$a38ac7339e3f31db),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("7VPQz")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
}));
const $b59dcfcbfdcea858$export$3e390340716755de = (0, $jwzNs.browserOnlyResourceWithCondition)(()=>false, (0, $buJlM.createRelayResource)({
    type: (0, $77a7d82b9fcd593e$export$b48bcc76a0105016),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $4BxqS.default),
            variables: {
                boardId: (0, $huI7r.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));
const $b59dcfcbfdcea858$export$81ac23db76b1f935 = (0, $jwzNs.browserOnlyResourceWithCondition)(()=>false, (0, $buJlM.createRelayResource)({
    type: (0, $77a7d82b9fcd593e$export$5cef388780439aec),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $entxd.default),
            variables: {
                boardId: (0, $huI7r.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("entxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3820b7364a3e9479$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<916f92cb49153da25a6abe2a4d651185>>
 * @relayHash 1b45667561f9430ea4e961757485983b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67
const $3820b7364a3e9479$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67",
        "metadata": {},
        "name": "boardWithRouterRelayQuery",
        "operationKind": "query",
        "text": null
    }
};
var $3820b7364a3e9479$export$2e2bcd8739ae039 = $3820b7364a3e9479$var$node;

});

parcelRegister("4BxqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $990e69fa1370085b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e40c06e874adef0395c5788a7d119a9>>
 * @relayHash fa277d121f8f09e75035802d7ede6889
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b
const $990e69fa1370085b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
        "metadata": {},
        "name": "viewBoardCustomFiltersQuery",
        "operationKind": "query",
        "text": null
    }
};
var $990e69fa1370085b$export$2e2bcd8739ae039 = $990e69fa1370085b$var$node;

});

const $77a7d82b9fcd593e$export$a38ac7339e3f31db = 'NEXTGEN_BOARD';
const $77a7d82b9fcd593e$export$b48bcc76a0105016 = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
const $77a7d82b9fcd593e$export$5cef388780439aec = 'NEXTGEN_BOARD_RELAY';

parcelRegister("7VPQz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7RdTy").then(()=>parcelRequire('gJf6D'));

});


parcelRegister("7yAHk", function(module, exports) {

$parcel$export(module.exports, "softwareBoardRoute", () => $650519e8b83fa4a8$export$9ae2c0a566d4e0f6);
$parcel$export(module.exports, "softwareBoardEmbedRoute", () => $650519e8b83fa4a8$export$f55626b64e3fcb4f);

var $exb0h = parcelRequire("exb0h");
const $650519e8b83fa4a8$export$9ae2c0a566d4e0f6 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS),
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId'
};
const $650519e8b83fa4a8$export$f55626b64e3fcb4f = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS_EMBED),
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("j7Vfn", function(module, exports) {

$parcel$export(module.exports, "NextGenBoardSkeleton", () => $971b5b15648111a5$export$25a9d0fbcb127c90);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $ehXB8 = parcelRequire("ehXB8");
const $971b5b15648111a5$var$customCssStyles = null;
const $971b5b15648111a5$export$25a9d0fbcb127c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ehXB8))),
        className: (0, $7JEyt.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("ehXB8", function(module, exports) {
module.exports = new URL("next-gen-board-app-skeleton.tpl.d10f8ca5.svg", import.meta.url).toString();

});


parcelRegister("9H2zQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("46tFu")
]).then(()=>parcelRequire('6fTlz'));

});

parcelRegister("8hvlU", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorRelayResource", () => $32e9eef2b1613b8f$export$b4096f516fb93159);
$parcel$export(module.exports, "issueNavigatorFilterRelayResource", () => $32e9eef2b1613b8f$export$44ca3a0b25f38d83);
/* eslint-disable jira/import-whitelist */ 
var $iWLL0 = parcelRequire("iWLL0");

var $eI5EY = parcelRequire("eI5EY");

var $5as0a = parcelRequire("5as0a");

var $jccNB = parcelRequire("jccNB");

var $huI7r = parcelRequire("huI7r");

var $amu7D = parcelRequire("amu7D");

var $c7ifG = parcelRequire("c7ifG");

var $buJlM = parcelRequire("buJlM");

var $k7wca = parcelRequire("k7wca");

var $1zgpM = parcelRequire("1zgpM");

var $lB25E = parcelRequire("lB25E");

var $jK0NH = parcelRequire("jK0NH");

var $cWHXY = parcelRequire("cWHXY");
const $32e9eef2b1613b8f$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_FILTER_RELAY = 'REQUEST_TAB_ISSUE_NAVIGATOR_FILTER_RELAY';
const $32e9eef2b1613b8f$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_RELAY = 'REQUEST_TAB_ISSUE_NAVIGATOR_RELAY';
const $32e9eef2b1613b8f$export$b4096f516fb93159 = (0, $lB25E.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${$32e9eef2b1613b8f$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_RELAY}`,
    getKey: ()=>'request-tab-issue-navigator-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        let projectKey = '';
        // TO-DO handle the error throw here
        try {
            const response = await (0, $cWHXY.getLatestJSMProjectRequest)();
            projectKey = response?.values?.[0]?.key;
        } catch (error) {
            /* eslint-disable no-console */ console.log(error);
        }
        const { issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $jK0NH.getParams)(routerContext, projectKey);
        const jqlOrFilterId = (0, $jK0NH.getJqlOrFilterId)(projectKey, defaultJql, jqlParam, filter);
        const maxIssuesPerPage = (0, $jccNB.getMaxIssuesPerPage)();
        const variables = {
            cloudId: tenantContext.cloudId,
            first: issueKey == null ? maxIssuesPerPage : null,
            issueSearchInput: jqlOrFilterId,
            namespace: (0, $jccNB.ISSUE_SEARCH_NAMESPACE),
            after: null,
            options: {
                issueKey: issueKey
            },
            fieldSetIds: [],
            shouldQueryFieldSetsById: false,
            viewId: (0, $jccNB.LIST_VIEW_ID),
            amountOfColumns: (0, $jccNB.MAX_AMOUNT_OF_COLUMNS),
            atlassianIntelligenceProductFeature: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $jccNB.NATURAL_LANGUAGE_TO_JQL),
            queryStatusForIssuekeyStrikethrough: (0, $eI5EY.fg)('jiv-18659-query-status-for-issuekey-strikethrough')
        };
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default)(), (0, $1zgpM.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $32e9eef2b1613b8f$export$44ca3a0b25f38d83 = (0, $lB25E.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${$32e9eef2b1613b8f$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_FILTER_RELAY}`,
    getKey: ()=>'request-tab-issue-navigator-filter-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        let projectKey = '';
        // TO-DO handle the error throw here
        try {
            const response = await (0, $cWHXY.getLatestJSMProjectRequest)();
            projectKey = response?.values?.[0]?.key;
        } catch (error) {
            /* eslint-disable no-console */ console.log(error);
        }
        const { filter: filter } = (0, $jK0NH.getParams)(routerContext, projectKey);
        const includeFilter = Boolean(filter) && (0, $5as0a.isFilterId)(filter);
        const variables = {
            includeFilter: includeFilter,
            filterAri: includeFilter ? (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'filter',
                resourceId: filter,
                activationId: tenantContext.activationId
            }) : ''
        };
        const options = {
            fetchPolicy: includeFilter ? 'network-only' : 'store-only'
        };
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default)(), (0, $k7wca.default), variables, options);
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("jK0NH", function(module, exports) {

$parcel$export(module.exports, "getParams", () => $428dd4030ad3e04b$export$ec161d740909e39d);
$parcel$export(module.exports, "getJqlOrFilterId", () => $428dd4030ad3e04b$export$b968a035fc2aa57b);
// eslint-disable-next-line jira/import-whitelist

var $5as0a = parcelRequire("5as0a");

var $6vrw7 = parcelRequire("6vrw7");

var $f6ie2 = parcelRequire("f6ie2");
const $428dd4030ad3e04b$export$ec161d740909e39d = ({ match: { params: params }, query: query }, projectKey)=>{
    const { issueKey: issueKey } = params;
    const { filter: filter, jql: jql } = query;
    // Default JQL when no relevant query parameter is set
    const defaultJql = (0, $f6ie2.getDefaultJql)((0, $6vrw7.toProjectKey)(projectKey));
    return {
        page: 1,
        jql: jql,
        issueKey: issueKey,
        projectKey: projectKey,
        filter: filter,
        defaultJql: defaultJql
    };
};
const $428dd4030ad3e04b$export$b968a035fc2aa57b = (projectKey, defaultJql, jqlParam, filter)=>{
    // If JQL param has been defined (even if it's empty) we should use it
    if (typeof jqlParam === 'string') return {
        jql: jqlParam
    };
    // If filter is non-empty then use the filter parameter
    if (typeof filter === 'string' && filter !== '') {
        if ((0, $5as0a.isFilterId)(filter)) return {
            filterId: filter
        };
        const filterJql = (0, $f6ie2.mapFilterToJql)(projectKey, filter);
        if (filterJql !== undefined) return {
            jql: filterJql
        };
    }
    // Fallback to the default JQL if neither JQL or valid filter parameters have been provided.
    return {
        jql: defaultJql
    };
};

});

parcelRegister("cWHXY", function(module, exports) {

$parcel$export(module.exports, "getLatestJSMProjectRequest", () => $55c7a9f62022262f$export$9cbf5320d7abb785);
// eslint-disable-next-line jira/import-whitelist

var $53ciZ = parcelRequire("53ciZ");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $55c7a9f62022262f$export$9cbf5320d7abb785 = async ()=>{
    try {
        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
            maxResults: '1',
            orderBy: 'lastIssueUpdatedTime',
            typeKey: 'service_desk'
        });
        const response = await (0, $lRmyA.performGetRequestWithRetry)(`/rest/api/3/project/search?${queryParams}`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // TO-DO rename the package name and get confirmation with @mantripat about error events
        (0, $guiFP.default)({
            meta: {
                id: 'getLatestJSMProjectRequest',
                packageName: 'jiraRouterResourcesSoftwareRequests'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("jw6tz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("xCpYa")
]).then(()=>parcelRequire('fk9VJ'));

});

parcelRegister("bU6C3", function(module, exports) {

$parcel$export(module.exports, "nextGenRoadmapResource", () => $ccc72973dcc1f122$export$2750f87d68dfb02a);

var $lB25E = parcelRequire("lB25E");


const $ccc72973dcc1f122$export$2750f87d68dfb02a = (0, $lB25E.createResource)({
    type: (0, $1eef2c9e2260305d$export$75dfa03544a19422),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("fHPwV")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});

});
parcelRegister("fHPwV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("49NAr").then(()=>parcelRequire('1Ojjf'));

});


parcelRegister("eoI8D", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("6mWL9")
]).then(()=>parcelRequire('3UDh4'));

});

parcelRegister("llMVF", function(module, exports) {

$parcel$export(module.exports, "versionDetailsRelayResourceCustom", () => $560cab3ebfc1480f$export$c56c5b19da4d0fd1);
/* eslint-disable jira/import-whitelist */ 
var $iWLL0 = parcelRequire("iWLL0");

var $eI5EY = parcelRequire("eI5EY");

var $huI7r = parcelRequire("huI7r");

var $amu7D = parcelRequire("amu7D");

var $c7ifG = parcelRequire("c7ifG");

var $buJlM = parcelRequire("buJlM");

var $GSP2z = parcelRequire("GSP2z");

var $yyqSx = parcelRequire("yyqSx");

var $ephMr = parcelRequire("ephMr");

var $bhwgQ = parcelRequire("bhwgQ");

var $lB25E = parcelRequire("lB25E");

const $560cab3ebfc1480f$export$c56c5b19da4d0fd1 = (0, $lB25E.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${(0, $11142c5c2c8d869a$export$9fe575a15a87a796)}`,
    // Deliberately returning the static key, not to rerun query by resource, as different key returns null queryReference shortly while the query is running, when filter query parameter is changed,
    // which is believed to be a bug in react-resource-router part, but we don't know the reason yet.
    // Context: https://atlassian.slack.com/archives/CFLN3FEF8/p1680495188086669
    // Due to the same bug, issue navigator team is doing the similar technique: src/packages/routes/src/ui/spa/issue-navigator/resources/index.tsx
    getKey: ({ match: match })=>{
        const { versionId: versionId } = match.params;
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        return `jsw-releases-version-details-main-query-relay-${parsedVersionId}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { versionId: versionId } = match.params;
        const { filters: filters, sortBy: sortBy } = (0, $ephMr.toVersionIssuesGraphQLVariables)(query);
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        const variables = {
            cloudAri: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                resourceType: 'site',
                resourceId: tenantContext.cloudId
            }),
            versionAri: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'version/activation',
                resourceId: String(`${tenantContext.activationId}/${parsedVersionId}`)
            }),
            sortBy: sortBy,
            filters: filters,
            skip: !(0, $bhwgQ.checkAuthentication)(tenantContext) || parsedVersionId.length === 0,
            isDevopsFeatureDisabledInFedRamp: (0, $yyqSx.isDevopsFeatureDisabledInFedRamp)(),
            isIssueSummarisedDeploymentsMigratedToAgs: (0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re'),
            shouldIncludeDevOpsFieldsViaAgs: !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && (0, $eI5EY.fg)('solaris_migrate_summurized_deployments_to_ags_re')
        };
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default)(), (0, $GSP2z.default), variables, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("GSP2z", function(module, exports) {

$parcel$export(module.exports, "default", () => $916216f35e148e31$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ed198248e7a2f8c1064c8c2bdfdc72b>>
 * @relayHash 9a787809eab9d8fde1269fed365db42b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 66b85b9a3472d6567a7e01af55f605d068c69092ec922f513289271ac2963505

var $jdksu = parcelRequire("jdksu");
const $916216f35e148e31$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "66b85b9a3472d6567a7e01af55f605d068c69092ec922f513289271ac2963505",
        "metadata": {},
        "name": "uiVersionDetailsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcversiondetailsshouldskipreleasenotefieldrelayprovider": (0, $jdksu.default)
        }
    }
};
var $916216f35e148e31$export$2e2bcd8739ae039 = $916216f35e148e31$var$node;

});
parcelRegister("jdksu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8803a9cf6d611497$export$2e2bcd8739ae039);

var $eI5EY = parcelRequire("eI5EY");

var $yyqSx = parcelRequire("yyqSx");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8803a9cf6d611497$export$2e2bcd8739ae039 = {
    get () {
        return (0, $eI5EY.fg)('version_details_performance_fix') || (0, $yyqSx.isDevopsFeatureDisabledInFedRamp)();
    }
};

});


parcelRegister("ephMr", function(module, exports) {

$parcel$export(module.exports, "toVersionIssuesGraphQLVariables", () => $1d70d3310ffc0569$export$72df1c7780b3e8e2);
$parcel$export(module.exports, "useVersionIssuesGraphQLVariables", () => $1d70d3310ffc0569$export$3d12d3ffbce57135);

var $iclz4 = parcelRequire("iclz4");


var $lzE4a = parcelRequire("lzE4a");

var $hTGN1 = parcelRequire("hTGN1");
const $1d70d3310ffc0569$var$accountIdToAriStr = (accountIds)=>{
    if (accountIds == null) return null;
    return accountIds.map((accountId)=>accountId === 'UNASSIGNED' ? null : `ari:cloud:identity::user/${accountId}`);
};
const $1d70d3310ffc0569$export$72df1c7780b3e8e2 = (queryParams)=>{
    const parsedQueryParams = (0, $hTGN1.parseQueryParams)(queryParams);
    return {
        filters: {
            searchStr: parsedQueryParams[0, $d7c1ea1e2a683c50$export$e39925d10cebc0b] ?? null,
            epicIds: parsedQueryParams[0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac] ?? null,
            statusCategories: parsedQueryParams[0, $d7c1ea1e2a683c50$export$c307007520232013] != null ? parsedQueryParams[0, $d7c1ea1e2a683c50$export$c307007520232013].filter((0, $lzE4a.isVersionStatusCategory)) : null,
            warningCategories: parsedQueryParams[0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd] ?? null,
            assigneeAccountIds: $1d70d3310ffc0569$var$accountIdToAriStr(parsedQueryParams[0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2])
        },
        sortBy: {
            sortByField: parsedQueryParams[0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6] ?? 'CREATED',
            order: parsedQueryParams[0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb] ?? 'ASC'
        }
    };
};
const $1d70d3310ffc0569$export$3d12d3ffbce57135 = ()=>{
    const [queryParams] = (0, $iclz4.useQueryParams)((0, $d7c1ea1e2a683c50$export$e39925d10cebc0b), (0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac), (0, $d7c1ea1e2a683c50$export$c307007520232013), (0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd), (0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2), (0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6), (0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb));
    return $1d70d3310ffc0569$export$72df1c7780b3e8e2(queryParams);
};

});
parcelRegister("iclz4", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $88391ae3fc882e87$export$b37ee0d76c6d2fbc);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $ldoFd = parcelRequire("ldoFd");

var $i7Fym = parcelRequire("i7Fym");

var $53ciZ = parcelRequire("53ciZ");

var $lB25E = parcelRequire("lB25E");
const $88391ae3fc882e87$export$b37ee0d76c6d2fbc = (...queryParamsToWatch)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, $lB25E.useRouter)();
    const queryParamsRef = (0, $eUqFw.useRef)({});
    const parsedQueryParams = (0, $eUqFw.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
            accumulator[currentValue] = query[currentValue] || undefined;
            return accumulator;
        }, {});
        // update cache only when one of requested params actually changed
        // otherwise return cached value to avoid changing return object reference
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
        return queryParamsRef.current;
    }, [
        query,
        queryParamsToWatch
    ]);
    const setQueryParams = (0, $eUqFw.useCallback)((newQueryParams, options)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
            ...query,
            ...newQueryParams
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value));
        const { updateType: updateType, ...stringifyOptions } = options ?? {};
        // @ts-expect-error - TS2559 - Type '{ sort?: false | ((a: string, b: string) => number) | undefined; }' has no properties in common with type 'StringifyOptions'.
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(parsedSearch, stringifyOptions);
        const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
        updateType === 'replace' ? replace(url) : push(url);
    }, [
        pathname,
        push,
        replace,
        query
    ]);
    return [
        parsedQueryParams,
        setQueryParams
    ];
};

});

const $d7c1ea1e2a683c50$export$e39925d10cebc0b = 'text';
const $d7c1ea1e2a683c50$export$b98a7875ddbefaac = 'epics';
const $d7c1ea1e2a683c50$export$c307007520232013 = 'statusCategory';
const $d7c1ea1e2a683c50$export$2552faed9df6a2cd = 'warnings';
const $d7c1ea1e2a683c50$export$f78d8c81fcad32a2 = 'assignee';
const $d7c1ea1e2a683c50$export$13d5b2891ca65cd6 = 'sortBy';
const $d7c1ea1e2a683c50$export$810a1f7ed2facfcb = 'sortOrder';

parcelRegister("lzE4a", function(module, exports) {

$parcel$export(module.exports, "isWarningsFilterValue", () => $43d67a39ab52f8bc$export$5c25bcf27380084);
$parcel$export(module.exports, "toWarningsFilterValue", () => $43d67a39ab52f8bc$export$ac3017cd78edb8a1);
$parcel$export(module.exports, "isVersionStatusCategory", () => $43d67a39ab52f8bc$export$3af93bbba0d4241a);
$parcel$export(module.exports, "isSortBy", () => $43d67a39ab52f8bc$export$472650e4cbd40b70);
$parcel$export(module.exports, "isSortOrder", () => $43d67a39ab52f8bc$export$dfece8cb679d32a3);

var $8Qd0L = parcelRequire("8Qd0L");
const $43d67a39ab52f8bc$export$5c25bcf27380084 = (val)=>val === 'OPEN_PULL_REQUEST' || val === 'UNREVIEWED_CODE' || val === 'FAILING_BUILD' || val === 'OPEN_REVIEW';
const $43d67a39ab52f8bc$export$ac3017cd78edb8a1 = (statusCategoryFromQueryParam)=>statusCategoryFromQueryParam.filter($43d67a39ab52f8bc$export$5c25bcf27380084);
const $43d67a39ab52f8bc$export$3af93bbba0d4241a = (val)=>val === (0, $8Qd0L.TODO) || val === (0, $8Qd0L.IN_PROGRESS) || val === (0, $8Qd0L.DONE);
const $43d67a39ab52f8bc$export$472650e4cbd40b70 = (val)=>val === 'ASSIGNEE' || val === 'CREATED' || val === 'KEY' || val === 'PRIORITY' || val === 'STATUS' || val === 'TYPE';
const $43d67a39ab52f8bc$export$dfece8cb679d32a3 = (val)=>val === 'ASC' || val === 'DESC';

});
parcelRegister("8Qd0L", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e7c4cf297fb3917f$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e7c4cf297fb3917f$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e7c4cf297fb3917f$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e7c4cf297fb3917f$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e7c4cf297fb3917f$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e7c4cf297fb3917f$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e7c4cf297fb3917f$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e7c4cf297fb3917f$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e7c4cf297fb3917f$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e7c4cf297fb3917f$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e7c4cf297fb3917f$export$d928f247c903643a);
const $e7c4cf297fb3917f$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e7c4cf297fb3917f$export$aa456a5030160740 = 'TODO';
const $e7c4cf297fb3917f$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e7c4cf297fb3917f$export$71efb3495f6084f2 = 'DONE';
const $e7c4cf297fb3917f$export$d9119300f9d9a815 = [
    $e7c4cf297fb3917f$export$6db089fe7b26f5b6,
    $e7c4cf297fb3917f$export$aa456a5030160740,
    $e7c4cf297fb3917f$export$5a9ac66c2785cc13,
    $e7c4cf297fb3917f$export$71efb3495f6084f2
];
const $e7c4cf297fb3917f$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e7c4cf297fb3917f$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e7c4cf297fb3917f$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e7c4cf297fb3917f$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e7c4cf297fb3917f$export$71efb3495f6084f2
    }
];
const $e7c4cf297fb3917f$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e7c4cf297fb3917f$export$3f42f49c284d5b58 = Object.freeze({
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.NEW]: 2,
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.DONE]: 3,
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e7c4cf297fb3917f$export$f3f919dc0f56d9eb = Object.values($e7c4cf297fb3917f$export$5d42a08d46cffe7);
const $e7c4cf297fb3917f$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e7c4cf297fb3917f$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e7c4cf297fb3917f$export$6db089fe7b26f5b6;
};
const $e7c4cf297fb3917f$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e7c4cf297fb3917f$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e7c4cf297fb3917f$export$d928f247c903643a = (key)=>$e7c4cf297fb3917f$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("hTGN1", function(module, exports) {

$parcel$export(module.exports, "isAnyFilterApplied", () => $22cfabd4be67fcf4$export$e6b3ec1d09429da8);
$parcel$export(module.exports, "parseQueryParams", () => $22cfabd4be67fcf4$export$67c4cee80a3410cd);

var $6vrw7 = parcelRequire("6vrw7");


var $lzE4a = parcelRequire("lzE4a");
const $22cfabd4be67fcf4$export$e6b3ec1d09429da8 = (parsedQueryParams)=>parsedQueryParams[0, $d7c1ea1e2a683c50$export$e39925d10cebc0b] != null && parsedQueryParams[0, $d7c1ea1e2a683c50$export$e39925d10cebc0b].length > 0 || parsedQueryParams[0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac] != null && parsedQueryParams[0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac].length > 0 || parsedQueryParams[0, $d7c1ea1e2a683c50$export$c307007520232013] != null && parsedQueryParams[0, $d7c1ea1e2a683c50$export$c307007520232013].length > 0 || parsedQueryParams[0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd] != null && parsedQueryParams[0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd].length > 0 || parsedQueryParams[0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2] != null && parsedQueryParams[0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2].length > 0;
const $22cfabd4be67fcf4$export$2a2e94972ab280d4 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).map((0, $6vrw7.toIssueId));
const $22cfabd4be67fcf4$export$fb136b568c6d78b5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).filter((0, $lzE4a.isVersionStatusCategory));
const $22cfabd4be67fcf4$export$5cb324c621ca24e8 = (paramValue)=>paramValue == null ? undefined : (0, $lzE4a.toWarningsFilterValue)(paramValue.split(',').map((str)=>str.trim()));
const $22cfabd4be67fcf4$export$6c8eda0352c7cf5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>(0, $6vrw7.toAccountId)(str.trim()));
const $22cfabd4be67fcf4$export$67c4cee80a3410cd = (paramsRaw)=>{
    const result = {};
    result[0, $d7c1ea1e2a683c50$export$e39925d10cebc0b] = paramsRaw[0, $d7c1ea1e2a683c50$export$e39925d10cebc0b];
    result[0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac] = $22cfabd4be67fcf4$export$2a2e94972ab280d4(paramsRaw[0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac]);
    result[0, $d7c1ea1e2a683c50$export$c307007520232013] = $22cfabd4be67fcf4$export$fb136b568c6d78b5(paramsRaw[0, $d7c1ea1e2a683c50$export$c307007520232013]);
    result[0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd] = $22cfabd4be67fcf4$export$5cb324c621ca24e8(paramsRaw[0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd]);
    result[0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2] = $22cfabd4be67fcf4$export$6c8eda0352c7cf5(paramsRaw[0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2]);
    result[0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6] = paramsRaw[0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6] && (0, $lzE4a.isSortBy)(paramsRaw[0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6]) ? paramsRaw[0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6] : 'CREATED';
    result[0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb] = paramsRaw[0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb] && (0, $lzE4a.isSortOrder)(paramsRaw[0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb]) ? paramsRaw[0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb] : 'ASC';
    return result;
};

});


const $11142c5c2c8d869a$export$9fe575a15a87a796 = 'PROJECTS_VERSION_DETAILS';


parcelRegister("73beW", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailRoute", () => $53dd1741f2bcaed6$export$eb3633614d0521b0);

var $exb0h = parcelRequire("exb0h");
const $53dd1741f2bcaed6$export$eb3633614d0521b0 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
    path: '/projects/:projectKey/versions/:versionId/tab/:tab',
    ufoName: 'software.version-details-page'
};
const $53dd1741f2bcaed6$export$f22288f2d2f1b9ea = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
    path: '/projects/:projectKey/versions/:versionId'
};
const $53dd1741f2bcaed6$export$3fc8dbcec208bca0 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT),
    path: '/browse/:projectKey/fixforversion/:versionId'
};

});

parcelRegister("c3DFM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("dHRnN")
]).then(()=>parcelRequire('ko4Vl'));

});

parcelRegister("c5RN6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("a71wv")
]).then(()=>parcelRequire('gEz89'));

});

parcelRegister("hNSE6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("3VVKz")
]).then(()=>parcelRequire('1x6xR'));

});

parcelRegister("bGbRd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("8SJgL")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("fe5ZN")
]).then(()=>parcelRequire('1lrw4'));

});

parcelRegister("biov4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("iYWpJ")
]).then(()=>parcelRequire('9899P'));

});

parcelRegister("eHH82", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4jfTg").then(()=>parcelRequire('dU9l0'));

});

parcelRegister("95xdG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("aLvWz")
]).then(()=>parcelRequire('hq0yf'));

});

parcelRegister("dExW6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("dmiTz")
]).then(()=>parcelRequire('d6Su9'));

});

parcelRegister("1TkEB", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesRoute", () => $f2e324964119b6ad$export$1338132568be849);

var $exb0h = parcelRequire("exb0h");
const $f2e324964119b6ad$export$1338132568be849 = {
    group: (0, $exb0h.ROUTE_GROUPS_PEOPLE_PROFILES),
    name: (0, $exb0h.ROUTE_NAMES_PEOPLE_INDEX),
    path: '/jira/people/:subPath?'
};

});

parcelRegister("lufsf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("2Lfdl"),
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2lkBM")
]).then(()=>parcelRequire('gGjAb'));

});

parcelRegister("fFJZu", function(module, exports) {

$parcel$export(module.exports, "createNotificationPreferencesResource", () => $e9bebc032ae17408$export$731980bd233a4797);
$parcel$export(module.exports, "createContactsResource", () => $e9bebc032ae17408$export$b9ca444b0be3df97);
$parcel$export(module.exports, "createMuteResource", () => $e9bebc032ae17408$export$c849cfac68bc6e80);
$parcel$export(module.exports, "createQuietHoursResource", () => $e9bebc032ae17408$export$efc5e8690061f9cc);
$parcel$export(module.exports, "createForwardingRulesResource", () => $e9bebc032ae17408$export$5314dca65b4e5888);

var $lB25E = parcelRequire("lB25E");
parcelRequire("l96PT");
var $3liNr = parcelRequire("3liNr");

var $1ZVlP = parcelRequire("1ZVlP");
const $e9bebc032ae17408$export$731980bd233a4797 = (checkConsolidationOnRouteDependency, depends)=>(0, $lB25E.createResource)({
        type: 'notificationPreferencesResource',
        getKey: ()=>'notificationPreferencesResource',
        getData: ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $1ZVlP.getNotificationPreferences)();
        },
        isBrowserOnly: true,
        depends: depends
    });
const $e9bebc032ae17408$export$b9ca444b0be3df97 = (checkConsolidationOnRouteDependency, depends)=>(0, $lB25E.createResource)({
        type: 'contactsResource',
        getKey: ()=>'contactsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await (0, $1ZVlP.getContact)();
            return data.contacts;
        },
        isBrowserOnly: true,
        depends: depends
    });
const $e9bebc032ae17408$export$c849cfac68bc6e80 = (checkConsolidationOnRouteDependency, depends)=>(0, $lB25E.createResource)({
        type: 'muteResource',
        getKey: ()=>'muteResource',
        getData: ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $1ZVlP.getMuteDetail)();
        },
        isBrowserOnly: true,
        depends: depends
    });
const $e9bebc032ae17408$export$efc5e8690061f9cc = (checkConsolidationOnRouteDependency, depends)=>(0, $lB25E.createResource)({
        type: 'quietHoursResource',
        getKey: ()=>'quietHoursResource',
        getData: ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $1ZVlP.getQuietHoursDetail)();
        },
        isBrowserOnly: true,
        depends: depends
    });
const $e9bebc032ae17408$export$5314dca65b4e5888 = (checkConsolidationOnRouteDependency, depends)=>(0, $lB25E.createResource)({
        type: 'forwardingRulesResource',
        getKey: ()=>'forwardingRulesResource',
        getData: ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $1ZVlP.getForwardingRules)().then(({ values: values })=>values);
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("1ZVlP", function(module, exports) {

$parcel$export(module.exports, "getNotificationPreferences", () => $7c6bda3d47957b11$export$60e139c3026f21bc);
$parcel$export(module.exports, "getContact", () => $7c6bda3d47957b11$export$52411745da118fc8);
$parcel$export(module.exports, "getMuteDetail", () => $7c6bda3d47957b11$export$80a4e62998a806a6);
$parcel$export(module.exports, "getQuietHoursDetail", () => $7c6bda3d47957b11$export$44a94c74f358d02f);
$parcel$export(module.exports, "getForwardingRules", () => $7c6bda3d47957b11$export$2161af98e3d645a5);

var $kRdYM = parcelRequire("kRdYM");
const $7c6bda3d47957b11$export$60e139c3026f21bc = ()=>(0, $kRdYM.eocFetch)(`/v1/users/notification-preferences`);
const $7c6bda3d47957b11$export$52411745da118fc8 = ()=>(0, $kRdYM.eocFetch)(`/v1/users/contact`);
const $7c6bda3d47957b11$export$80a4e62998a806a6 = ()=>(0, $kRdYM.eocFetch)(`/v1/users/notifications/mute`);
const $7c6bda3d47957b11$export$44a94c74f358d02f = ()=>(0, $kRdYM.eocFetch)(`/v1/users/quiet-hours/details`);
const $7c6bda3d47957b11$export$2161af98e3d645a5 = ()=>(0, $kRdYM.eocFetch)(`/v1/alerts/notifications/forwarding-rules`);

});


parcelRegister("Nf3GR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("6Sbbc")
]).then(()=>parcelRequire('eV7kw'));

});

parcelRegister("iJPUk", function(module, exports) {

$parcel$export(module.exports, "LEGACY_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$b468ccdb67523656);
$parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$693b70d1bcef8627);
$parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$21946ea4c58fd4c9);
$parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$2321c59d517801c8);
$parcel$export(module.exports, "getGeneralPersonalSettingsPath", () => $97f48d3f13d5b88e$export$db9e3ccc1e5e3317);
$parcel$export(module.exports, "getNotificationsPersonalSettingsPath", () => $97f48d3f13d5b88e$export$64a672523a583594);

var $1ybV0 = parcelRequire("1ybV0");
const $97f48d3f13d5b88e$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
const $97f48d3f13d5b88e$export$a974f4af282a75ba = '/jira/settings/personal';
const $97f48d3f13d5b88e$export$693b70d1bcef8627 = `${$97f48d3f13d5b88e$export$a974f4af282a75ba}/general`;
const $97f48d3f13d5b88e$export$21946ea4c58fd4c9 = `${$97f48d3f13d5b88e$export$a974f4af282a75ba}/notifications`;
const $97f48d3f13d5b88e$export$2321c59d517801c8 = `${$97f48d3f13d5b88e$export$a974f4af282a75ba}/alert-notifications`;
function $97f48d3f13d5b88e$export$db9e3ccc1e5e3317() {
    return (0, $1ybV0.ff)('sea-1973-personal-settings-sidebar') ? $97f48d3f13d5b88e$export$693b70d1bcef8627 : $97f48d3f13d5b88e$export$b468ccdb67523656;
}
function $97f48d3f13d5b88e$export$88a45ae8c4b1c664() {
    return (0, $1ybV0.ff)('sea-1973-personal-settings-sidebar') ? $97f48d3f13d5b88e$export$2321c59d517801c8 : $97f48d3f13d5b88e$export$b468ccdb67523656;
}
function $97f48d3f13d5b88e$export$64a672523a583594() {
    if ((0, $1ybV0.ff)('sea-1973-personal-settings-sidebar')) {
        if ((0, $1ybV0.ff)('sea-1973-notifications-hub')) return $97f48d3f13d5b88e$export$21946ea4c58fd4c9;
        return $97f48d3f13d5b88e$export$693b70d1bcef8627;
    }
    return $97f48d3f13d5b88e$export$b468ccdb67523656;
}

});

parcelRegister("7lcEz", function(module, exports) {

$parcel$export(module.exports, "legacyPersonalSettingsRoute", () => $e67c038bcafcb183$export$dd556eb586bb36b8);
$parcel$export(module.exports, "generalPersonalSettingsRoute", () => $e67c038bcafcb183$export$7a6c9715a86f906b);
$parcel$export(module.exports, "notificationsPersonalSettingsRoute", () => $e67c038bcafcb183$export$55ab09b9d6beb8be);
$parcel$export(module.exports, "opsNotificationsPersonalSettingsRoute", () => $e67c038bcafcb183$export$68ebdd4eccb7b383);
$parcel$export(module.exports, "getGeneralPersonalSettingsRouteForLink", () => $e67c038bcafcb183$export$cbf079e07fb96768);
$parcel$export(module.exports, "getNotificationsPersonalSettingsRouteForLink", () => $e67c038bcafcb183$export$9b4c78a3c84b549f);

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $iJPUk = parcelRequire("iJPUk");

var $kZJn3 = parcelRequire("kZJn3");
const $e67c038bcafcb183$export$dd556eb586bb36b8 = {
    group: (0, $exb0h.ROUTE_GROUPS_PERSONAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PERSONAL_SETTINGS),
    path: (0, $iJPUk.LEGACY_PERSONAL_SETTINGS_PATH)
};
const $e67c038bcafcb183$export$7a6c9715a86f906b = {
    group: (0, $exb0h.ROUTE_GROUPS_PERSONAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL),
    path: (0, $iJPUk.GENERAL_PERSONAL_SETTINGS_PATH)
};
const $e67c038bcafcb183$export$55ab09b9d6beb8be = {
    group: (0, $exb0h.ROUTE_GROUPS_PERSONAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS),
    path: (0, $iJPUk.NOTIFICATIONS_PERSONAL_SETTINGS_PATH),
    skeleton: (0, $kZJn3.PersonalSettingsNotificationsAppSkeleton)
};
const $e67c038bcafcb183$export$68ebdd4eccb7b383 = {
    group: (0, $exb0h.ROUTE_GROUPS_PERSONAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS),
    path: (0, $iJPUk.OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH)
};
const $e67c038bcafcb183$export$cbf079e07fb96768 = ()=>{
    if ((0, $1ybV0.ff)('sea-1973-personal-settings-sidebar')) return $e67c038bcafcb183$export$7a6c9715a86f906b;
    return $e67c038bcafcb183$export$dd556eb586bb36b8;
};
const $e67c038bcafcb183$export$9b4c78a3c84b549f = ()=>{
    if ((0, $1ybV0.ff)('sea-1973-personal-settings-sidebar')) {
        if ((0, $1ybV0.ff)('sea-1973-notifications-hub')) return $e67c038bcafcb183$export$55ab09b9d6beb8be;
        return $e67c038bcafcb183$export$7a6c9715a86f906b;
    }
    return $e67c038bcafcb183$export$dd556eb586bb36b8;
};

});
parcelRegister("kZJn3", function(module, exports) {

$parcel$export(module.exports, "PersonalSettingsNotificationsAppSkeleton", () => $0cfb08a5fcfb6db6$export$b542eb2d3193b983);
$parcel$export(module.exports, "PersonalSettingsNotificationsGlobalTableSkeleton", () => $0cfb08a5fcfb6db6$export$d58f6bbbc1838cb2);
$parcel$export(module.exports, "MimetypeSelectSkeleton", () => $0cfb08a5fcfb6db6$export$46fc11a564484c9c);
$parcel$export(module.exports, "ProjectNotificationAccordionSkeleton", () => $0cfb08a5fcfb6db6$export$8cb773cb6fc17338);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8ICxF = parcelRequire("8ICxF");

var $cxmEy = parcelRequire("cxmEy");

var $iWH0v = parcelRequire("iWH0v");

var $cSzcb = parcelRequire("cSzcb");

var $fAR4b = parcelRequire("fAR4b");
const $0cfb08a5fcfb6db6$var$maxWidthCssStyles = null;
const $0cfb08a5fcfb6db6$var$customCssStyles = null;
const $0cfb08a5fcfb6db6$export$b542eb2d3193b983 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cSzcb))),
        className: (0, $7JEyt.default)([
            "_p12f8stt _19pkidpf _2hwx1wug _otyridpf _18u01wug"
        ])
    });
const $0cfb08a5fcfb6db6$export$d58f6bbbc1838cb2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cfb08a5fcfb6db6$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cxmEy))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    }));
const $0cfb08a5fcfb6db6$export$46fc11a564484c9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cfb08a5fcfb6db6$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iWH0v))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    }));
const $0cfb08a5fcfb6db6$export$8cb773cb6fc17338 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cfb08a5fcfb6db6$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fAR4b))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0cfb08a5fcfb6db6$var$SkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71ldgin _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cxmEy", function(module, exports) {
module.exports = new URL("global-table-skeleton-with-projects.tpl.5a5d24b9.svg", import.meta.url).toString();

});

parcelRegister("iWH0v", function(module, exports) {
module.exports = new URL("mimetype-skeleton.tpl.8b750352.svg", import.meta.url).toString();

});

parcelRegister("cSzcb", function(module, exports) {
module.exports = new URL("personal-settings-notifications-app-skeleton-with-projects.tpl.d18b3c58.svg", import.meta.url).toString();

});

parcelRegister("fAR4b", function(module, exports) {
module.exports = new URL("project-accordion-skeleton.tpl.cee2df62.svg", import.meta.url).toString();

});



parcelRegister("kkmGZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $555435cd813e0645$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e3e1703a525d86dcc2e19d53184ce08>>
 * @relayHash 6bbf2c57b214609f54849cda2ea129e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9188457835dc841e15ae89ec4c1f078e2fa85d15cb55923db043827ef5491e95

var $PhJzU = parcelRequire("PhJzU");

var $5440E = parcelRequire("5440E");
const $555435cd813e0645$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v7 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "emailChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "inProductChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "kind": "ScalarField",
            "name": "category"
        }
    ], v8 = {
        "concreteType": "JiraNotificationPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueAssigned",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueUpdated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentEdited",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueMoved",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "mentionsCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "worklogCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "miscellaneousIssueEventCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_NotificationsPageAndProjectQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraNotificationGlobalPreference",
                                    "kind": "LinkedField",
                                    "name": "notificationGlobalPreference",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTable_allPreferencesData"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTableNew_allPreferencesData"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraNotificationOptions",
                                                "kind": "LinkedField",
                                                "name": "options",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceField"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesPreferenceField"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.notificationGlobalPreference.options"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.notificationGlobalPreference"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneousissueeventscombinedtyperelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ui_NotificationsPageAndProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraNotificationProjectPreferenceConnection",
                            "kind": "LinkedField",
                            "name": "allNotificationProjectPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectNotificationPreferenceEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationProjectPreferences",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "filters": [
                                "cloudId"
                            ],
                            "handle": "connection",
                            "key": "projects_allNotificationProjectPreferences",
                            "kind": "LinkedHandle",
                            "name": "allNotificationProjectPreferences"
                        },
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraNotificationGlobalPreference",
                            "kind": "LinkedField",
                            "name": "notificationGlobalPreference",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailNotificationEnabled"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "emailMimeType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailMimeTypeEditable"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyOwnChangesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleAssigneeEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleReporterEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "batchWindow"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "dailyBatchLocalTime"
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "allJiraProjectsForModal",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "notificationConfigurationState": "DEFAULT",
                                        "sortBy": {
                                            "sortBy": "NAME"
                                        }
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 5
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9188457835dc841e15ae89ec4c1f078e2fa85d15cb55923db043827ef5491e95",
            "metadata": {},
            "name": "ui_NotificationsPageAndProjectQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": (0, $PhJzU.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneousissueeventscombinedtyperelayprovider": (0, $5440E.default)
            }
        }
    };
}();
$555435cd813e0645$var$node.hash = "95b25e8050d0f39dbcfbefb15e7d633b";
var $555435cd813e0645$export$2e2bcd8739ae039 = $555435cd813e0645$var$node;

});
parcelRegister("PhJzU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0178f2cde148a91$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e0178f2cde148a91$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('jlovep-1048-add-other-issue-events-combined-notification');
    }
};

});

parcelRegister("5440E", function(module, exports) {

$parcel$export(module.exports, "default", () => $0986ce961f8838d7$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0986ce961f8838d7$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('jlovep-1048-add-other-issue-events-combined-notification');
    }
};

});


parcelRegister("bvaDO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kQloL")
]).then(()=>parcelRequire('dTASr'));

});

parcelRegister("8Rx0G", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("38uxt")
]).then(()=>parcelRequire('lH4ou'));

});

parcelRegister("6sTVt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("6Yg0K")
]).then(()=>parcelRequire('ixGLB'));

});

parcelRegister("kpP8d", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("605nj")
]).then(()=>parcelRequire('8bATJ'));

});

parcelRegister("fTgIJ", function(module, exports) {

$parcel$export(module.exports, "useIsViewPermissionsEnabled", () => $2943e3921ea7f7ba$export$a94405ffcb20c356);
$parcel$export(module.exports, "useIsCrossProjectViewsEnabled", () => $2943e3921ea7f7ba$export$34d097b1cd6f89c1);

var $1ybV0 = parcelRequire("1ybV0");

var $eIp1n = parcelRequire("eIp1n");

var $6WXNs = parcelRequire("6WXNs");

var $gd0Sp = parcelRequire("gd0Sp");
const $2943e3921ea7f7ba$export$8aa8a7878fd61770 = ()=>{
    const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const jpdEdition = (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_PRODUCT_DISCOVERY), appEditions);
    // TODO: POL-10089 use entitlements instead of the edition when it will be available
    return jpdEdition === (0, $6WXNs.toEdition)((0, $6WXNs.PREMIUM_EDITION));
};
const $2943e3921ea7f7ba$export$a94405ffcb20c356 = ()=>{
    const isPremium = $2943e3921ea7f7ba$export$8aa8a7878fd61770();
    return isPremium && (0, $1ybV0.ff)('polaris.view-permissions_plaoi');
};
const $2943e3921ea7f7ba$export$34d097b1cd6f89c1 = ()=>{
    const isPremium = $2943e3921ea7f7ba$export$8aa8a7878fd61770();
    return isPremium;
};

});

parcelRegister("4PiBX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bKLuN")
]).then(()=>parcelRequire('4rJuD'));

});

parcelRegister("36nS2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("buIif")
]).then(()=>parcelRequire('kXUas'));

});

parcelRegister("1sFiz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("kbSjk")
]).then(()=>parcelRequire('jPNkt'));

});

parcelRegister("gSdsu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("38tVF")
]).then(()=>parcelRequire('8amB0'));

});

parcelRegister("xzrGu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jze87")
]).then(()=>parcelRequire('3IAbi'));

});

parcelRegister("eNvYa", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("9m3Bu")
]).then(()=>parcelRequire('2skXt'));

});

parcelRegister("fObtr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("jd6xQ")
]).then(()=>parcelRequire('jRARI'));

});

parcelRegister("eRXem", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8wHq1")
]).then(()=>parcelRequire('fJvZ5'));

});

parcelRegister("iegUT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bhAaX")
]).then(()=>parcelRequire('dG5lO'));

});

parcelRegister("7W8Zj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("dCs6C")
]).then(()=>parcelRequire('lNgh6'));

});

parcelRegister("iJk49", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bbm3G")
]).then(()=>parcelRequire('1D9RR'));

});

parcelRegister("bD7R1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("7PrMM")
]).then(()=>parcelRequire('leJqv'));

});

parcelRegister("5Hxsh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("luL9e")
]).then(()=>parcelRequire('g04UT'));

});

parcelRegister("b1sy2", function(module, exports) {

$parcel$export(module.exports, "jsmEmailDomainsListResource", () => $56bbd55fb215fc9d$export$8e956348e5d47a3c);

var $lB25E = parcelRequire("lB25E");


const $56bbd55fb215fc9d$export$8e956348e5d47a3c = (0, $lB25E.createResource)({
    type: (0, $c700c70f47ef39d0$export$2bde433b962efbdd),
    getKey: ()=>'email-domains-list',
    isBrowserOnly: true,
    getDataLoader: ()=>(parcelRequire("9tyDS"))
});

});
const $c700c70f47ef39d0$export$2bde433b962efbdd = 'JSM_EMAIL_DOMAINS_LIST';

parcelRegister("9tyDS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("42GtE").then(()=>parcelRequire('7x8Oe'));

});


parcelRegister("bU9Sz", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationDetailsResource", () => $9581a5bd69ea081a$export$ccda79811a15bf5);

var $lB25E = parcelRequire("lB25E");


const $9581a5bd69ea081a$export$ccda79811a15bf5 = (0, $lB25E.createResource)({
    type: (0, $933183352119debb$export$52408f1a0f23569a),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("5obfi"))
});

});
const $933183352119debb$export$52408f1a0f23569a = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS';

parcelRegister("5obfi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ebcP2").then(()=>parcelRequire('f5Sa8'));

});


parcelRegister("6Oo0P", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationMembersResource", () => $50ffd00cad93b35a$export$65c7941bd3e14d00);

var $lB25E = parcelRequire("lB25E");

const $50ffd00cad93b35a$var$TEN_SECONDS_IN_MILLIS = 10000;

const $50ffd00cad93b35a$export$65c7941bd3e14d00 = (0, $lB25E.createResource)({
    type: (0, $fd311a1f9f2cab74$export$d3eec3e4b4eac6ac),
    getKey: (routerContext)=>`OrganizationMembers-${routerContext.match.params.organizationId}-${routerContext.query.page}-${routerContext.query.query}`,
    getDataLoader: ()=>(parcelRequire("8v91s")),
    maxAge: $50ffd00cad93b35a$var$TEN_SECONDS_IN_MILLIS
});

});
const $fd311a1f9f2cab74$export$d3eec3e4b4eac6ac = 'PRODUCT_JSM_ORGANIZATION_MEMBERS';

parcelRegister("8v91s", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4l0fp").then(()=>parcelRequire('3EkFo'));

});


parcelRegister("kCBYY", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationListResource", () => $c57a41c47b9114ea$export$3e38a27ad406d7f7);

var $lB25E = parcelRequire("lB25E");

const $c57a41c47b9114ea$var$TEN_SECONDS_IN_MILLIS = 10000;

const $c57a41c47b9114ea$export$3e38a27ad406d7f7 = (0, $lB25E.createResource)({
    type: (0, $20a34f52808bc16a$export$50de2841b08b875f),
    getKey: (routerContext)=>routerContext.query.page,
    getDataLoader: ()=>(parcelRequire("w7skh")),
    maxAge: $c57a41c47b9114ea$var$TEN_SECONDS_IN_MILLIS
});

});
const $20a34f52808bc16a$export$27676104f3192a88 = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST_LEGACY';
const $20a34f52808bc16a$export$50de2841b08b875f = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST';

parcelRegister("w7skh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hBqy1").then(()=>parcelRequire('1soSi'));

});


parcelRegister("d260x", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("8Zn1q")
]).then(()=>parcelRequire('4kHaH'));

});

parcelRegister("7e0QF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("jDBzr")
]).then(()=>parcelRequire('drdTe'));

});

parcelRegister("8vc2n", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationResource", () => $d725289bc895b59f$export$b6a5741c2b47fb17);

var $lB25E = parcelRequire("lB25E");


const $d725289bc895b59f$export$b6a5741c2b47fb17 = (0, $lB25E.createResource)({
    type: (0, $c05838a6b75aba60$export$73be8e1edd21e2d),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("fPwA6"))
});

});
const $c05838a6b75aba60$export$73be8e1edd21e2d = 'RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION';

parcelRegister("fPwA6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("586Gy").then(()=>parcelRequire('onrSG'));

});


parcelRegister("esxKW", function(module, exports) {

$parcel$export(module.exports, "productsJswStorageManagementResource", () => $9197cd72b798fc1f$export$2cd668845b3478bd);

var $lB25E = parcelRequire("lB25E");


const $9197cd72b798fc1f$export$2cd668845b3478bd = (0, $lB25E.createResource)({
    type: (0, $edf0bd800804270e$export$1ac222647be3baf8),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("iX7VA"))
});

});
const $edf0bd800804270e$export$1ac222647be3baf8 = 'RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT';

parcelRegister("iX7VA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1FgFN").then(()=>parcelRequire('9Zmdk'));

});


parcelRegister("i51fR", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationRoute", () => $1a461460fc9ead25$export$decdad53ba9b97af);
$parcel$export(module.exports, "productsJswConfigurationStorageManagementRoute", () => $1a461460fc9ead25$export$6e126b0e7eabff82);

var $exb0h = parcelRequire("exb0h");
const $1a461460fc9ead25$export$decdad53ba9b97af = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION),
    path: '/jira/settings/products/jira-software-configuration',
    exact: true
};
const $1a461460fc9ead25$export$6e126b0e7eabff82 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSW_STORAGE_MANAGEMENT),
    path: '/jira/settings/products/jira-software-configuration/storage-management',
    exact: true
};

});

parcelRegister("iU03p", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("ik0oR")
]).then(()=>parcelRequire('ftUY6'));

});

parcelRegister("8y1c8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("gPtOf")
]).then(()=>parcelRequire('iDcUZ'));

});

parcelRegister("aK0h7", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("KQwx0")
]).then(()=>parcelRequire('kmkOd'));

});

parcelRegister("88JsJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("cSdRg")
]).then(()=>parcelRequire('3sQmF'));

});

parcelRegister("8r1Yz", function(module, exports) {

$parcel$export(module.exports, "projectsComponentsResource", () => $45ab863d1e016743$export$557cc3eff8939b3);

var $6qExu = parcelRequire("6qExu");

var $lB25E = parcelRequire("lB25E");


const $45ab863d1e016743$export$557cc3eff8939b3 = (0, $lB25E.createResource)({
    type: (0, $95baeea28c37707a$export$ae1b86a8daeb387d),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("d99OI")),
    maxAge: (0, $6qExu.MIN_MAX_AGE)
});

});
const $95baeea28c37707a$export$ae1b86a8daeb387d = 'PROJECTS_COMPONENTS';

parcelRegister("d99OI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5MKFz").then(()=>parcelRequire('lwwcn'));

});


parcelRegister("lr08r", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cSfRL")
]).then(()=>parcelRequire('3Ht4z'));

});

parcelRegister("64DIX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("l1cSM").then(()=>parcelRequire('5WpG5'));

});

parcelRegister("jt6YF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("1eIJb")
]).then(()=>parcelRequire('6lIZU'));

});

parcelRegister("ktArR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsComponentsRoute", () => $4bf4aa65cd709577$export$79cbce13eeecd53);

var $exb0h = parcelRequire("exb0h");
const $4bf4aa65cd709577$export$79cbce13eeecd53 = {
    group: (0, $exb0h.ROUTE_GROUPS_COMPONENTS),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS),
    path: '/plugins/servlet/project-config/:projectKey/administer-components'
};

});

parcelRegister("gVIF2", function(module, exports) {

$parcel$export(module.exports, "projectVersionsRelayResource", () => $9245e1e3cc78b4c6$export$7e8aa1360f86345c);
/* eslint-disable jira/import-whitelist */ 
var $iWLL0 = parcelRequire("iWLL0");


var $i5Gzt = parcelRequire("i5Gzt");

var $amu7D = parcelRequire("amu7D");

var $c7ifG = parcelRequire("c7ifG");

var $buJlM = parcelRequire("buJlM");

var $lURnk = parcelRequire("lURnk");

var $lB25E = parcelRequire("lB25E");

const $9245e1e3cc78b4c6$export$7e8aa1360f86345c = (0, $lB25E.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${(0, $80ebda0937fcaf2d$export$59aa73792ad9507a)}`,
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `project-version-query-relay-${projectKey}`;
    },
    // @ts-expect-error - might return null
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const variables = {
            initialLoadCount: 20,
            cloudId: tenantContext.cloudId,
            projectKey: match.params.projectKey,
            filter: (0, $i5Gzt.transformStatusFromParam)(query[0, $53fd6cfbd5095c80$export$3e8168848b996f7]),
            searchString: query[0, $53fd6cfbd5095c80$export$a181206198b7f50c] || '',
            sortBy: {
                sortByField: (0, $i5Gzt.transformSortFieldFromParam)(query[0, $53fd6cfbd5095c80$export$a3482d3a8df0e725]),
                order: (0, $i5Gzt.transformSortOrderFromParam)(query[0, $53fd6cfbd5095c80$export$71089821f361e881])
            }
        };
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default)(), (0, $lURnk.default), variables, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
const $53fd6cfbd5095c80$export$a181206198b7f50c = 'contains';
const $53fd6cfbd5095c80$export$3e8168848b996f7 = 'status';
const $53fd6cfbd5095c80$export$71089821f361e881 = 'orderDirection';
const $53fd6cfbd5095c80$export$a3482d3a8df0e725 = 'orderField';
const $53fd6cfbd5095c80$export$3c5e605ca7ade9f2 = 'NAME';
const $53fd6cfbd5095c80$export$50241fe906e4f94e = 'RELEASE_DATE';
const $53fd6cfbd5095c80$export$99a467bcc22b8df9 = 'START_DATE';
const $53fd6cfbd5095c80$export$d44826c816b5619b = 'DESCRIPTION';
const $53fd6cfbd5095c80$export$34694f8d8b23ee2a = 'SEQUENCE';
const $53fd6cfbd5095c80$export$cb638d1fae624fbf = 20;
const $53fd6cfbd5095c80$export$bbcbc202f2dfa28c = 3;
const $53fd6cfbd5095c80$export$b983f2cb1f658a55 = 'RELEASED';
const $53fd6cfbd5095c80$export$cb459d726a8530a5 = 'UNRELEASED';
const $53fd6cfbd5095c80$export$c936349447a77fe0 = 'ARCHIVED';
const $53fd6cfbd5095c80$export$c5ed97509d0e2aaf = 'projectVersions';

parcelRegister("i5Gzt", function(module, exports) {

$parcel$export(module.exports, "transformStatusFromParam", () => $eb6da8f0caf0e86e$export$5760f9690301cdb);
$parcel$export(module.exports, "transformStatusToParam", () => $eb6da8f0caf0e86e$export$46595832dd863016);
$parcel$export(module.exports, "transformSortOrderFromParam", () => $eb6da8f0caf0e86e$export$1945e6d2f31e09e6);
$parcel$export(module.exports, "transformSortFieldFromParam", () => $eb6da8f0caf0e86e$export$f842a0d1846d319d);
$parcel$export(module.exports, "transformStatusToDropdownSelection", () => $eb6da8f0caf0e86e$export$7dad705635760cfe);
$parcel$export(module.exports, "getUpdatedDisplayedStatuses", () => $eb6da8f0caf0e86e$export$ce4c948ba1d53df4);
$parcel$export(module.exports, "getFormattedVersionDate", () => $eb6da8f0caf0e86e$export$5a6eeb16be7dd21d);


var $2W8po = parcelRequire("2W8po");

var $8TSnQ = parcelRequire("8TSnQ");

const $eb6da8f0caf0e86e$export$5760f9690301cdb = (input)=>{
    switch(input){
        case 'no-filter':
            return [
                (0, $8TSnQ.RELEASED),
                (0, $8TSnQ.UNRELEASED),
                (0, $8TSnQ.ARCHIVED)
            ];
        case 'all':
            return [
                (0, $8TSnQ.RELEASED),
                (0, $8TSnQ.UNRELEASED),
                (0, $8TSnQ.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $8TSnQ.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $8TSnQ.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $8TSnQ.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $8TSnQ.UNRELEASED)
                ];
            }
    }
};
const $eb6da8f0caf0e86e$export$46595832dd863016 = (input)=>{
    if (input) {
        if (input.length === 0) return 'no-filter';
        if (input.length > 2) return 'all';
        return [
            input.includes((0, $8TSnQ.RELEASED)) && [
                'released'
            ],
            input.includes((0, $8TSnQ.UNRELEASED)) && [
                'unreleased'
            ],
            input.includes((0, $8TSnQ.ARCHIVED)) && [
                'archived'
            ]
        ].filter(Boolean).join('-');
    }
    return undefined;
};
const $eb6da8f0caf0e86e$export$1945e6d2f31e09e6 = (input)=>{
    switch(input){
        case 'ASC':
            return 0, $44cab0426b6cf0d7$export$1dee026a19752d6b;
        case 'DESC':
            return 0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65;
        default:
            return 0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65;
    }
};
const $eb6da8f0caf0e86e$export$f842a0d1846d319d = (input)=>{
    switch(input){
        case 'NAME':
            return 0, $53fd6cfbd5095c80$export$3c5e605ca7ade9f2;
        case 'RELEASEDATE':
            return 0, $53fd6cfbd5095c80$export$50241fe906e4f94e;
        case 'STARTDATE':
            return 0, $53fd6cfbd5095c80$export$99a467bcc22b8df9;
        case 'DESCRIPTION':
            return 0, $53fd6cfbd5095c80$export$d44826c816b5619b;
        case 'SEQUENCE':
            return 0, $53fd6cfbd5095c80$export$34694f8d8b23ee2a;
        default:
            return 0, $53fd6cfbd5095c80$export$34694f8d8b23ee2a;
    }
};
const $eb6da8f0caf0e86e$export$7dad705635760cfe = (input)=>{
    switch(input){
        case 'no-filter':
            return [];
        case 'all':
            return [
                (0, $8TSnQ.RELEASED),
                (0, $8TSnQ.UNRELEASED),
                (0, $8TSnQ.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $8TSnQ.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $8TSnQ.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $8TSnQ.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $8TSnQ.UNRELEASED)
                ];
            }
    }
};
const $eb6da8f0caf0e86e$export$ce4c948ba1d53df4 = (displayedStatuses, selectedStatuses, newStatus)=>{
    // Handle the case when a status is selected after deselection of all in dropdown where versions in all statuses are displayed despite empty selection & deselecting a status from a full selection.
    if (displayedStatuses.length === (0, $53fd6cfbd5095c80$export$bbcbc202f2dfa28c)) {
        if (!selectedStatuses.length) return [
            newStatus
        ];
        return displayedStatuses.filter((status)=>status !== newStatus);
    }
    return displayedStatuses.includes(newStatus) ? displayedStatuses.filter((item)=>item !== newStatus) : [
        ...displayedStatuses,
        newStatus
    ];
};
const $eb6da8f0caf0e86e$export$5a6eeb16be7dd21d = (versionDate, formatDate)=>versionDate != null ? formatDate(new Date(versionDate), {
        timeZone: (0, $2W8po.VERSION_DATE_FORMAT_OPTION).timeZone,
        dateStyle: 'long'
    }) : '';

});
const $44cab0426b6cf0d7$export$1dee026a19752d6b = 'ASC';
const $44cab0426b6cf0d7$export$b6abcf7fa1d94f65 = 'DESC';

parcelRegister("2W8po", function(module, exports) {

$parcel$export(module.exports, "VERSION_DATE_FORMAT_OPTION", () => $fa8c105e2e5bf251$export$d54c0d576c2caef5);
// Used to format date string from the server to display version start date and release date
// Server only stores date without any time information such as 2023-12-31
// Use this WHENEVER displaying version start date and release date.
// If you respect local timezone without this constant, there will be a bug that will display one day early date in negative timezones.
// https://jira.atlassian.com/browse/JSWCLOUD-22316
const $fa8c105e2e5bf251$export$d54c0d576c2caef5 = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};

});

parcelRegister("8TSnQ", function(module, exports) {

$parcel$export(module.exports, "RELEASED", () => $28c4a9b02ba65731$export$b983f2cb1f658a55);
$parcel$export(module.exports, "UNRELEASED", () => $28c4a9b02ba65731$export$cb459d726a8530a5);
$parcel$export(module.exports, "ARCHIVED", () => $28c4a9b02ba65731$export$c936349447a77fe0);
const $28c4a9b02ba65731$export$b983f2cb1f658a55 = 'RELEASED';
const $28c4a9b02ba65731$export$cb459d726a8530a5 = 'UNRELEASED';
const $28c4a9b02ba65731$export$c936349447a77fe0 = 'ARCHIVED';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$28c4a9b02ba65731$export$2e2bcd8739ae039 = [
    $28c4a9b02ba65731$export$b983f2cb1f658a55,
    $28c4a9b02ba65731$export$cb459d726a8530a5,
    $28c4a9b02ba65731$export$c936349447a77fe0
];

});


parcelRegister("lURnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e018c9cd98fb548$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74a2b175327ca86eaaa6de7eb5f73ee4>>
 * @relayHash 7afccc486f9febcb3476e85d70194e77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1edab1f5d839dcbcfc4df9d209d8b451300a422ffa48ba3f34408d105b4f3c8e

var $5JaD5 = parcelRequire("5JaD5");
const $3e018c9cd98fb548$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "initialLoadCount"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "alias": "jiraProjectType",
        "kind": "ScalarField",
        "name": "projectType"
    }, v11 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v12 = {
        "kind": "Variable",
        "name": "searchString",
        "variableName": "searchString"
    }, v13 = {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v16 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v17 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v18 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v19 = [
        v11 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "initialLoadCount"
        },
        v12 /*: any*/ ,
        v13 /*: any*/ 
    ], v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v22 = [
        v21 /*: any*/ 
    ], v23 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": "DONE"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiProjectVersionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v7 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.projectId"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.key"
                                        },
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "versions",
                                                "args": [
                                                    v11 /*: any*/ ,
                                                    v12 /*: any*/ ,
                                                    v13 /*: any*/ 
                                                ],
                                                "concreteType": "JiraVersionConnection",
                                                "kind": "LinkedField",
                                                "name": "__uiProject__versions_connection",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            v14 /*: any*/ ,
                                                            v15 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v14 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "errors",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "extensions",
                                                                "plural": true,
                                                                "selections": [
                                                                    v16 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v17 /*: any*/ ,
                                                    v18 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.versions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": v19 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "table_projectVersions"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectversionsperformancefixrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "uiProjectVersionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "args": v19 /*: any*/ ,
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraVersion",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "status"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "releaseDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "overdue"
                                                        },
                                                        {
                                                            "alias": "allIssues",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "ALL"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"ALL\")"
                                                        },
                                                        {
                                                            "alias": "doneIssues",
                                                            "args": v23 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "done",
                                                            "args": v23 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "inProgress",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "IN_PROGRESS"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                        },
                                                        {
                                                            "alias": "toDo",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "TODO"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"TODO\")"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "versionId"
                                                        },
                                                        v8 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectversionsperformancefixrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "hasReleaseNote"
                                                                }
                                                            ]
                                                        },
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v19 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "searchString",
                                        "sortBy"
                                    ],
                                    "handle": "connection",
                                    "key": "uiProject__versions",
                                    "kind": "LinkedHandle",
                                    "name": "versions"
                                },
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1edab1f5d839dcbcfc4df9d209d8b451300a422ffa48ba3f34408d105b4f3c8e",
            "metadata": {
                "connection": [
                    {
                        "count": "initialLoadCount",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "jiraProjectByKey",
                            "versions"
                        ]
                    }
                ]
            },
            "name": "uiProjectVersionsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectversionsperformancefixrelayprovider": (0, $5JaD5.default)
            }
        }
    };
}();
$3e018c9cd98fb548$var$node.hash = "3bed4070fd244faac23cfc6a62e64f6c";
var $3e018c9cd98fb548$export$2e2bcd8739ae039 = $3e018c9cd98fb548$var$node;

});
parcelRegister("5JaD5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c75ebce88b32b7eb$export$2e2bcd8739ae039);

var $eI5EY = parcelRequire("eI5EY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c75ebce88b32b7eb$export$2e2bcd8739ae039 = {
    get () {
        return (0, $eI5EY.fg)('project_versions_performance_fix');
    }
};

});


const $80ebda0937fcaf2d$export$59aa73792ad9507a = 'PROJECT_VERSIONS';


parcelRegister("3pqMH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsVersionsRoute", () => $8ebe884284523590$export$cc9450e5d7579b99);

var $exb0h = parcelRequire("exb0h");
const $8ebe884284523590$export$cc9450e5d7579b99 = {
    group: (0, $exb0h.ROUTE_GROUPS_COMPONENTS),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS),
    path: '/plugins/servlet/project-config/:projectKey/administer-versions'
};

});

parcelRegister("a7kPQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("5RXIq")
]).then(()=>parcelRequire('36oPt'));

});

parcelRegister("50N5G", function(module, exports) {

$parcel$export(module.exports, "projectsRedirectRoute", () => $8bdddd1cfa5b4bd9$export$e6bc3ea427ddafb8);

var $exb0h = parcelRequire("exb0h");
const $8bdddd1cfa5b4bd9$export$e6bc3ea427ddafb8 = {
    group: (0, $exb0h.ROUTE_GROUPS_REDIRECTS),
    name: (0, $exb0h.ROUTE_NAMES_PROJECTS_REDIRECT),
    path: '/projects/:projectKey',
    query: [
        'selectedItem!=(.+)'
    ],
    exact: true
};

});

parcelRegister("6CNdU", function(module, exports) {

$parcel$export(module.exports, "componentFilterResource", () => $dba947cf9bed32c4$export$306e389909032632);
$parcel$export(module.exports, "useComponentFilterResource", () => $dba947cf9bed32c4$export$e13868d6ab2288af);

var $8hg3R = parcelRequire("8hg3R");

var $lB25E = parcelRequire("lB25E");

const $dba947cf9bed32c4$var$getDataLoader = ()=>(parcelRequire("8fdbS"));
const $dba947cf9bed32c4$export$306e389909032632 = (0, $lB25E.createResource)({
    type: 'ESCALATIONS_COMPONENT_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
    getDataLoader: $dba947cf9bed32c4$var$getDataLoader
});
const $dba947cf9bed32c4$export$e13868d6ab2288af = ()=>(0, $lB25E.useResource)($dba947cf9bed32c4$export$306e389909032632);

});
parcelRegister("8fdbS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4EN5w").then(()=>parcelRequire('arQnn'));

});


parcelRegister("d4Gv0", function(module, exports) {

$parcel$export(module.exports, "priorityFilterResource", () => $d225d78d34bde743$export$ca03c5f9fc44703e);
$parcel$export(module.exports, "usePriorityFilterResource", () => $d225d78d34bde743$export$3654f46b6bb12558);

var $8hg3R = parcelRequire("8hg3R");

var $lB25E = parcelRequire("lB25E");

const $d225d78d34bde743$var$getDataLoader = ()=>(parcelRequire("kPdT6"));
const $d225d78d34bde743$export$ca03c5f9fc44703e = (0, $lB25E.createResource)({
    type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
    getDataLoader: $d225d78d34bde743$var$getDataLoader
});
const $d225d78d34bde743$export$3654f46b6bb12558 = ()=>(0, $lB25E.useResource)((0, $lB25E.createResource)({
        type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
        getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
        getDataLoader: $d225d78d34bde743$var$getDataLoader
    }));

});
parcelRegister("kPdT6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6CNud").then(()=>parcelRequire('eAhxK'));

});


parcelRegister("1ODui", function(module, exports) {

$parcel$export(module.exports, "escalationsRoute", () => $62f3dcc5b0c1c22d$export$3d91b36833b7ddb9);

var $exb0h = parcelRequire("exb0h");
const $62f3dcc5b0c1c22d$export$3d91b36833b7ddb9 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS),
    path: '/jira/servicedesk/projects/:projectKey/escalations',
    exact: true
};

});

parcelRegister("frZnw", function(module, exports) {

$parcel$export(module.exports, "APP_NAMES", () => $02625cb43b98ccea$export$4116f3d0d9d6bed7);
$parcel$export(module.exports, "toPackageName", () => $02625cb43b98ccea$export$f31a652635bd75fe);
const $02625cb43b98ccea$export$4116f3d0d9d6bed7 = {
    ACCOUNTS: 'servicedesk.accounts',
    APP_DISCOVERY: 'servicedesk.app-discovery',
    ATLASSIAN_ANALYTICS: 'servicedesk.atlassian-analytics',
    AUTOMATION_EDIT_RULE: 'servicedesk.automation.edit-rule',
    AUTOMATION_SUMMARY: 'servicedesk.automation.summary',
    AUTOMATION_VIEW_LOG: 'servicedesk.automation.view-log',
    BOARD: 'servicedesk.board',
    BOARD_SETTINGS: 'servicedesk.board-settings',
    CALENDAR: 'servicedesk.calendar',
    PROJECT_SUMMARY: 'servicedesk.project-summary',
    CHANGE_CALENDAR: 'servicedesk.change-calendar',
    CHANGE_MANAGEMENT_SETTINGS: 'servicedesk.change-management.settings',
    CREATE_PROJECT: 'servicedesk.create-project',
    CSAT_CONFIG: 'servicedesk.csat-configuration',
    CUSTOMER_PERMISSIONS: 'servicedesk.customer-permissions',
    CONTACTS: 'servicedesk.contacts',
    CUSTOMERS: 'servicedesk.customers',
    CUSTOMER_DETAILS: 'servicedesk.customer-details',
    CUSTOMER_SERVICE_ESCALATIONS: 'servicedesk.customer-service-escalations',
    CUSTOMER_SERVICE_PRODUCTS: 'servicedesk.customer-service-products',
    INVITE_TEAM_DIALOG: 'servicedesk.invite-team-dialog',
    ISSUE_SCHEDULE_CHANGE: 'servicedesk.issue.schedule-change',
    ITSM_FEATURES_SETTINGS: 'servicedesk.itsm-features.settings',
    ITSM_SAMPLE_SPACE: 'servicedesk.itsm-sample-space',
    JOURNEYS: 'servicedesk.journeys',
    JOURNEY_CONFIG: 'servicedesk.journey-config',
    GETTING_STARTED_PAGE: 'servicedesk.getting-started-page',
    KB_BROWSE_ARTICLES: 'servicedesk.knowledge-base.browse-articles',
    KB_CATEGORY: 'servicedesk.knowledge-base.category',
    KB_DRAFTS: 'servicedesk.knowledge-base.drafts',
    KB_BROWSE_CATEGORIES: 'servicedesk.knowledge-base.browse-categories',
    KB_SUGGESTED_ARTICLES: 'servicedesk.knowledge-base.suggested-articles',
    KB_EMBED_EDITOR: 'servicedesk.knowledge-article.embed-editor',
    KB_LANDING: 'servicedesk.knowledge-base.landing',
    KB_REPORTS_REQUESTS: 'servicedesk.kb-requests.reports',
    KB_SEARCH: 'servicedesk.knowledge-base.search',
    KB_SETTINGS: 'servicedesk.knowledge.settings',
    KB_SETUP: 'servicedesk.knowledge-base.setup',
    KB_VIEW_ARTICLE: 'servicedesk.knowledge-base.view-article',
    ORGANIZATION: 'servicedesk.organization',
    ORGANIZATIONS: 'servicedesk.organizations',
    ORGANIZATION_DETAILS: 'servicedesk.organization-details',
    PORTAL_SETTINGS: 'servicedesk.portal-settings',
    QUEUES_AGENT_VIEW: 'servicedesk.queues.agent-view',
    QUEUES_EDIT_VIEW: 'servicedesk.queues.edit-view',
    QUEUES_MAIN: 'servicedesk.queues.main',
    REPORTS_CUSTOM: 'servicedesk.reports.custom',
    REPORTS_CUSTOM_CREATE: 'servicedesk.reports.custom-create',
    REPORTS_CUSTOM_EDIT: 'servicedesk.reports.custom-edit',
    REPORTS_HOME_PAGE: 'servicedesk.reports.home-page',
    REPORTS_SATISFACTION: 'servicedesk.reports.satisfaction',
    REPORTS_WORKLOAD: 'servicedesk.reports.workload',
    REQUEST_TYPES_CONFIG: 'servicedesk.request-types-config',
    REQUEST_TYPE_FIELDS: 'servicedesk.request-type-fields',
    SLA_SETTINGS: 'servicedesk.sla-settings',
    VIRTUAL_AGENT_BROWSE_CONVERSATIONS: 'servicedesk.virtual-agent.browse-conversations',
    VIRTUAL_AGENT_BROWSE_INTENTS: 'servicedesk.virtual-agent.browse-intents',
    VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS: 'servicedesk.virtual-agent.browse-standard-flows',
    VIRTUAL_AGENT_LANDING: 'servicedesk.virtual-agent.landing',
    VIRTUAL_AGENT_SETTINGS: 'servicedesk.virtual-agent.settings',
    VIRTUAL_AGENT_VIEW_INTENT: 'servicedesk.virtual-agent.view-intent',
    VIRTUAL_AGENT_VIEW_STANDARD_FLOW: 'servicedesk.virtual-agent.view-standard-flow',
    PRACTICE_CONFIG_MODULE: 'servicedesk.practice-config-module',
    CREATE_SERVICE_MODAL: 'servicedesk.create-service-modal',
    UPDATE_SERVICE_MODAL: 'servicedesk.update-service-modal',
    LANGUAGE_SETTINGS: 'servicedesk.language-settings',
    LINKED_ALERTS_MODAL: 'servicedesk.link-alerts-modal',
    INSIGHT_ASSETS_REPORTS: 'servicedesk.insight-cmdb-assets_reports',
    INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT: 'servicedesk.insight-cmdb-assets_reports_default_redirect',
    INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE: 'servicedesk.insight-cmdb-assets_reports_unsubscribe',
    INSIGHT_OBJECT_VIEW: 'servicedesk.insight-cmdb-object',
    INSIGHT_OBJECT_SCHEMA: 'servicedesk.insight-cmdb-object-schema',
    INSIGHT_OBJECT_SCHEMA_CONFIGURATION: 'servicedesk.insight-cmdb-object-schema-configuration',
    INSIGHT_OBJECT_TYPE_CONFIGURATION: 'servicedesk.insight-object-type-configuration',
    INSIGHT_GLOBAL_CONFIGURATION: 'servicedesk.insight-cmdb-global-configuration',
    INSIGHT_LANDING_PAGE: 'servicedesk.insight-cmdb-landing-page',
    CUSTOMER_NOTIFICATIONS_MAIN_VIEW: 'servicedesk.customer-notifications-settings.main-view',
    CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW: 'servicedesk.customer-notifications-settings.invite-customer-view',
    CUSTOMER_NOTIFICATIONS_RULE_VIEW: 'servicedesk.customer-notifications-settings.rule-view',
    CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW: 'servicedesk.customer-notifications-settings.template-view',
    CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW: 'servicedesk.customer-notifications-settings.unknown-view',
    SERVICES_WITHOUT_PROJECT_VIEW: 'servicedesk.services-without-project-view',
    SERVICE_DETAIL_WITHOUT_PROJECT_VIEW: 'servicedesk.service-detail-without-project-view',
    WIDGET_SETTINGS: 'servicedesk.widget-settings'
};
// To match the FE error analytics pipeline convention
const $02625cb43b98ccea$var$ANALYTICS_PACKAGE_NAMES = {
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ACCOUNTS]: 'servicedeskAccounts',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.APP_DISCOVERY]: 'serviceDeskAppDiscovery',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ATLASSIAN_ANALYTICS]: 'serviceDeskAtlassianAnalytics',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.AUTOMATION_EDIT_RULE]: 'servicedeskAutomationEditView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.AUTOMATION_SUMMARY]: 'servicedeskAutomationEditRule',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.AUTOMATION_VIEW_LOG]: 'servicedeskAutomationViewLog',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.BOARD]: 'servicedeskBoard',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.BOARD_SETTINGS]: 'servicedeskBoardSettings',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CALENDAR]: 'servicedeskCalendar',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.PROJECT_SUMMARY]: 'servicedeskProjectSummary',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CHANGE_CALENDAR]: 'servicedeskChangeCalendar',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CHANGE_MANAGEMENT_SETTINGS]: 'servicedeskChangeManagementSettings',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CREATE_PROJECT]: 'servicedeskCreateProject',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CSAT_CONFIG]: 'servicedeskCsatConfig',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CONTACTS]: 'servicedeskContacts',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_PERMISSIONS]: 'servicedeskCustomerPermissions',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMERS]: 'servicedeskCustomers',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_DETAILS]: 'servicedeskCustomerDetails',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_ESCALATIONS]: 'servicedeskCustomerServiceEscalations',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_PRODUCTS]: 'servicedeskCustomerServiceProducts',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INVITE_TEAM_DIALOG]: 'servicedeskInviteTeamDialog',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ISSUE_SCHEDULE_CHANGE]: 'servicedeskIssueScheduleChange',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ITSM_FEATURES_SETTINGS]: 'servicedeskItsmFeaturesSettings',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ITSM_SAMPLE_SPACE]: 'servicedeskItsmSampleSpace',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.JOURNEYS]: 'servicedeskJourneys',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.JOURNEY_CONFIG]: 'servicedeskJourneyConfig',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_BROWSE_ARTICLES]: 'servicedeskKnowledgeBaseBrowseArticles',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_BROWSE_CATEGORIES]: 'servicedeskKnowledgeBaseBrowseCategories',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_CATEGORY]: 'servicedeskKnowledgeBaseCategory',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_DRAFTS]: 'servicedeskKnowledgeBaseDrafts',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_SUGGESTED_ARTICLES]: 'servicedeskKnowledgeBaseSuggestedArticles',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_EMBED_EDITOR]: 'servicedeskKnowledgeBaseEmbedEditor',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_LANDING]: 'servicedeskKnowledgeBaseLanding',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_REPORTS_REQUESTS]: 'servicedeskKbRequestsReports',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_SEARCH]: 'servicedeskKnowledgeBaseSearch',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_SETTINGS]: 'servicedeskKnowledgeSettings',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_SETUP]: 'servicedeskKnowledgeBaseSetup',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_VIEW_ARTICLE]: 'servicedeskKnowledgeBaseViewArticle',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.LANGUAGE_SETTINGS]: 'servicedeskLanguageSettingsTranslations',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ORGANIZATION]: 'servicedeskOrganization',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ORGANIZATIONS]: 'servicedeskOrganizations',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ORGANIZATION_DETAILS]: 'servicedeskOrganizationDetails',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.PORTAL_SETTINGS]: 'servicedeskPortalSettings',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.QUEUES_AGENT_VIEW]: 'servicedeskQueuesAgentView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.QUEUES_EDIT_VIEW]: 'servicedeskQueuesEditView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.QUEUES_MAIN]: 'servicedeskQueuesMain',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REPORTS_CUSTOM]: 'servicedeskReportsCustom',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_CREATE]: 'servicedeskReportsCustomCreate',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_EDIT]: 'servicedeskReportsCustomEdit',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REPORTS_HOME_PAGE]: 'servicedeskReportsHomePage',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REPORTS_SATISFACTION]: 'servicedeskReportsSatisfaction',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REPORTS_WORKLOAD]: 'servicedeskReportsWorkload',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REQUEST_TYPES_CONFIG]: 'servicedeskRequestTypesConfig',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REQUEST_TYPE_FIELDS]: 'servicedeskRequestTypeFields',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.SLA_SETTINGS]: 'servicedeskSlaSettings',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_CONVERSATIONS]: 'servicedeskVirtualAgentBrowseConversations',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_INTENTS]: 'servicedeskVirtualAgentBrowseIntents',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS]: 'servicedeskVirtualAgentBrowseStandardFlows',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_LANDING]: 'servicedeskVirtualAgentLanding',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_SETTINGS]: 'servicedeskVirtualAgentSettings',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_INTENT]: 'servicedeskVirtualAgentViewIntent',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_STANDARD_FLOW]: 'servicedeskVirtualAgentViewStandardFlow',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.PRACTICE_CONFIG_MODULE]: 'servicedeskPracticeConfigModule',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CREATE_SERVICE_MODAL]: 'servicedeskCreateServiceModal',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.UPDATE_SERVICE_MODAL]: 'servicedeskUpdateServiceModal',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.LINKED_ALERTS_MODAL]: 'servicedeskLinkAlertsModal',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS]: 'servicedeskAssetsReports',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT]: 'servicedeskAssetsReportsDefaultRedirect',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE]: 'servicedeskAssetsReportsUnsubscribe',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_VIEW]: 'servicedeskObjectView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA]: 'servicedeskObjectSchema',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA_CONFIGURATION]: 'servicedeskObjectSchemaConfiguration',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_TYPE_CONFIGURATION]: 'servicedeskObjectTypeConfiguration',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_GLOBAL_CONFIGURATION]: 'servicedeskInsightGlobalConfiguration',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_LANDING_PAGE]: 'servicedeskInsightLandingPage',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_MAIN_VIEW]: 'servicedeskCustomerNotificationsMainView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW]: 'servicedeskCustomerNotificationsInviteCustomerView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_RULE_VIEW]: 'servicedeskCustomerNotificationsRuleView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW]: 'servicedeskCustomerNotificationsTemplateView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW]: 'servicedeskCustomerNotificationsUnknownView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.GETTING_STARTED_PAGE]: 'servicedeskGettingStartedPage',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.SERVICES_WITHOUT_PROJECT_VIEW]: 'servicedeskServicesWithoutProjectView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.SERVICE_DETAIL_WITHOUT_PROJECT_VIEW]: 'servicedeskServiceDetailWithoutProjectView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.WIDGET_SETTINGS]: 'servicedeskWidgetSettings'
};
const $02625cb43b98ccea$export$f31a652635bd75fe = (appName)=>$02625cb43b98ccea$var$ANALYTICS_PACKAGE_NAMES[appName];

});

parcelRegister("3udVg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("iyCXq")
]).then(()=>parcelRequire('cmyuu'));

});

parcelRegister("l2463", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hy8Om").then(()=>parcelRequire('9CbWk'));

});

parcelRegister("aP2Ra", function(module, exports) {

$parcel$export(module.exports, "PRODUCTS_PAGE_SIZE", () => $2282441d52088402$export$9e59a0b3e9d74a99);
$parcel$export(module.exports, "customerServiceProductsQueryResource", () => $2282441d52088402$export$f9257217f5333b1a);

var $buJlM = parcelRequire("buJlM");

var $f7zQj = parcelRequire("f7zQj");
const $2282441d52088402$export$9e59a0b3e9d74a99 = 50;
const $2282441d52088402$export$f9257217f5333b1a = (0, $buJlM.createRelayResource)({
    type: 'CUSTOMER_SERVICE_PRODUCTS_QUERY',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $f7zQj.default),
            variables: {
                cloudId: tenantContext.cloudId,
                first: $2282441d52088402$export$9e59a0b3e9d74a99
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("f7zQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f62540f89b850398$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4df781c51f5dfbc32b76735c59bb33af>>
 * @relayHash 081a2dfa9c4407c84bf8d024899e92b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16
const $f62540f89b850398$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = [
        v2 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcCustomerServiceProductsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "productsPage_servicedeskCustomerServiceProducts"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcCustomerServiceProductsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "entitlementsCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "handle": "connection",
                            "key": "customerServiceProducts_productConnections",
                            "kind": "LinkedHandle",
                            "name": "productConnections"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16",
            "metadata": {},
            "name": "srcCustomerServiceProductsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f62540f89b850398$var$node.hash = "3c49696a6cdc337af280ec80f957ea89";
var $f62540f89b850398$export$2e2bcd8739ae039 = $f62540f89b850398$var$node;

});


parcelRegister("f7Fx7", function(module, exports) {

$parcel$export(module.exports, "productsRoute", () => $7da75ffe8cccffc0$export$7d9d0206a326c6b5);

var $exb0h = parcelRequire("exb0h");
const $7da75ffe8cccffc0$export$7d9d0206a326c6b5 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS),
    path: '/jira/servicedesk/projects/:projectKey/products',
    exact: true
};

});

parcelRegister("90XVg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("5ZIOS")
]).then(()=>parcelRequire('12sLP'));

});

parcelRegister("hgLMC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hLLv8").then(()=>parcelRequire('6M5jd'));

});

parcelRegister("hFcCh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("6IRlF")
]).then(()=>parcelRequire('jBv2v'));

});

parcelRegister("3nZzB", function(module, exports) {

$parcel$export(module.exports, "adminOauthCredentialsResource", () => $c81d15515b138f45$export$870d7919c1ca4482);

var $lB25E = parcelRequire("lB25E");
const $c81d15515b138f45$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS = 'ADMIN_OAUTH_CREDENTIALS';

const $c81d15515b138f45$export$870d7919c1ca4482 = (0, $lB25E.createResource)({
    type: $c81d15515b138f45$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("6PPUk"))
});

});
parcelRegister("6PPUk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1zuvJ").then(()=>parcelRequire('3n5Fx'));

});


parcelRegister("fVXRl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("2qaNh")
]).then(()=>parcelRequire('cW7qg'));

});

parcelRegister("9HzdP", function(module, exports) {

$parcel$export(module.exports, "jswOnboardingResource", () => $82498fffce6b410d$export$be21a2d8a350a80);
$parcel$export(module.exports, "useJswOnboardingResource", () => $82498fffce6b410d$export$83f546a45ad58d0a);

var $lB25E = parcelRequire("lB25E");


const $82498fffce6b410d$export$be21a2d8a350a80 = (0, $lB25E.createResource)({
    type: (0, $e5669fbcf13e968c$export$692203fca66f4d77),
    getKey: ()=>'jsw_onboarding',
    getDataLoader: ()=>(parcelRequire("8EAPx"))
});
const $82498fffce6b410d$export$83f546a45ad58d0a = ()=>(0, $lB25E.useResource)($82498fffce6b410d$export$be21a2d8a350a80);

});
const $e5669fbcf13e968c$export$692203fca66f4d77 = 'RESOURCE_TYPE_SOFTWARE_ONBOARDING';

parcelRegister("8EAPx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("a9drC").then(()=>parcelRequire('4AxaM'));

});


parcelRegister("dfgyM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("5sMYF")
]).then(()=>parcelRequire('5do0f'));

});

parcelRegister("eyzDx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("d6pws")
]).then(()=>parcelRequire('atRZ7'));

});

parcelRegister("6l5vZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ajBt7")
]).then(()=>parcelRequire('iTk1o'));

});

parcelRegister("5G7YB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("ef0N1")
]).then(()=>parcelRequire('92sWm'));

});

parcelRegister("bW80q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecd3e8b46f10fa19$export$2e2bcd8739ae039);
const $ecd3e8b46f10fa19$var$applyLazyOpts = (route)=>{
    if ('lazyOpts' in route && typeof route.lazyOpts === 'function') throw new Error('applyLazyOpts can only be called on the route-experiment variant');
    return route;
};
var $ecd3e8b46f10fa19$export$2e2bcd8739ae039 = $ecd3e8b46f10fa19$var$applyLazyOpts;

});

parcelRegister("cmPGV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("2on6y")
]).then(()=>parcelRequire('5CZ3R'));

});

parcelRegister("87SmV", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationGeneralResource", () => $78dab43018269962$export$b622f7400bfafd0d);

var $lB25E = parcelRequire("lB25E");


const $78dab43018269962$export$b622f7400bfafd0d = (0, $lB25E.createResource)({
    type: (0, $975047949307b186$export$e780b172f774b673),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("954c0"))
});

});
const $975047949307b186$export$e780b172f774b673 = 'RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL';

parcelRegister("954c0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("62oBo").then(()=>parcelRequire('d2VQC'));

});


parcelRegister("bW3HI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("9A8Wk")
]).then(()=>parcelRequire('8B7hX'));

});

parcelRegister("bFoIb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("djwjs")
]).then(()=>parcelRequire('aSKSY'));

});

parcelRegister("8jcNY", function(module, exports) {

$parcel$export(module.exports, "globalPermissionsResource", () => $7590aa3190e12e2e$export$9a5d1bc1ff678482);

var $buJlM = parcelRequire("buJlM");

var $dyg99 = parcelRequire("dyg99");
const $7590aa3190e12e2e$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS = 'GLOBAL_PERMISSIONS';
const $7590aa3190e12e2e$export$9a5d1bc1ff678482 = (0, $buJlM.createRelayResource)({
    type: $7590aa3190e12e2e$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS,
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $dyg99.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("dyg99", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24c05ce0027868a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f014b4044459efb94c4edb99f926dd1>>
 * @relayHash 402a674bdd82767605c36953e2732f07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6
const $c24c05ce0027868a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_globalPermissionsAndGrantsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "globalPermissionsAndGrants",
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "getGlobalPermissionsAndGrants",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalPermissionsTable_globalPermissions"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "grantPermissionDialog_globalPermissions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.globalPermissionsAndGrants"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_globalPermissionsAndGrantsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "globalPermissionsAndGrants",
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "getGlobalPermissionsAndGrants",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraGlobalPermissionGrants",
                                            "kind": "LinkedField",
                                            "name": "globalPermissionGrants",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraGlobalPermission",
                                                    "kind": "LinkedField",
                                                    "name": "permission",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isManagedByJira"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraGroup",
                                                    "kind": "LinkedField",
                                                    "name": "groups",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "groupId"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraGlobalPermissionGrantsList"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6",
            "metadata": {},
            "name": "main_globalPermissionsAndGrantsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c24c05ce0027868a$var$node.hash = "9f1b7eb98b606c41655e4fa1f200a351";
var $c24c05ce0027868a$export$2e2bcd8739ae039 = $c24c05ce0027868a$var$node;

});


parcelRegister("3XFvl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jKdpJ")
]).then(()=>parcelRequire('1rKQL'));

});

parcelRegister("8K5zM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6af7a3459aa6a0d6$export$2e2bcd8739ae039);

var $53ciZ = parcelRequire("53ciZ");

var $lB25E = parcelRequire("lB25E");

var $8LN4D = parcelRequire("8LN4D");

const $6af7a3459aa6a0d6$var$issueTypeSchemeResource = (0, $lB25E.createResource)({
    type: (0, $664c19c2d14162db$export$1d678052bb5ae54d),
    getKey: ({ query: query })=>`${0, $664c19c2d14162db$export$41cf50ee50d5da20}-${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $8LN4D.getIssueTypeSchemes)((0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(query))
});
var $6af7a3459aa6a0d6$export$2e2bcd8739ae039 = $6af7a3459aa6a0d6$var$issueTypeSchemeResource;

});
parcelRegister("8LN4D", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeSchemes", () => $ae9b50e78849f06a$export$2844cac611eecaa7);

var $53ciZ = parcelRequire("53ciZ");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $63t1V = parcelRequire("63t1V");

var $4CFHb = parcelRequire("4CFHb");
const $ae9b50e78849f06a$export$2844cac611eecaa7 = async (qs)=>{
    const filter = (0, $4CFHb.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify((0, $4CFHb.toApiUrlTransformer)(filter));
    try {
        return await (0, $lRmyA.performGetRequest)(`/rest/api/3/issuetypescheme?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: (0, $63t1V.PACKAGE_NAME),
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("63t1V", function(module, exports) {

$parcel$export(module.exports, "SOURCE_NAME", () => $7cd5ecc17d70b2b1$export$a3821bc63538b210);
$parcel$export(module.exports, "ISSUE_TYPE_SCHEMES_TABLE", () => $7cd5ecc17d70b2b1$export$91570d508c93485d);
$parcel$export(module.exports, "ORDER", () => $7cd5ecc17d70b2b1$export$11e75bce9f7ea886);
$parcel$export(module.exports, "MAX_RESULTS", () => $7cd5ecc17d70b2b1$export$f6b2881bc1090cea);
$parcel$export(module.exports, "defaultIssueTypeSchemesFilter", () => $7cd5ecc17d70b2b1$export$625de46796f967ae);
$parcel$export(module.exports, "EMPTY_PROJECTS_PAGE", () => $7cd5ecc17d70b2b1$export$81a0343467d0e9a9);
$parcel$export(module.exports, "PACKAGE_NAME", () => $7cd5ecc17d70b2b1$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $7cd5ecc17d70b2b1$export$9ac56b2484c2d4e9);
// analytics constants

const $7cd5ecc17d70b2b1$export$a3821bc63538b210 = 'issueTypeSchemeDirectory';
const $7cd5ecc17d70b2b1$export$91570d508c93485d = 'issueTypeSchemesTable';
const $7cd5ecc17d70b2b1$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $7cd5ecc17d70b2b1$export$f6b2881bc1090cea = 10;
const $7cd5ecc17d70b2b1$export$625de46796f967ae = {
    pageNumber: 1,
    pageSize: $7cd5ecc17d70b2b1$export$f6b2881bc1090cea,
    expand: [
        'projects',
        'issueTypes'
    ],
    orderBy: 'name',
    sortDirection: (0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65)
};
const $7cd5ecc17d70b2b1$export$52adcbea6a93900f = {
    startAt: 0,
    maxResults: $7cd5ecc17d70b2b1$export$f6b2881bc1090cea,
    values: [],
    total: 0,
    isLast: true
};
const $7cd5ecc17d70b2b1$export$81a0343467d0e9a9 = {
    startAt: 0,
    maxResults: 10,
    values: [],
    total: 0,
    isLast: true
};
const $7cd5ecc17d70b2b1$export$b8b9d90f9e5bd72b = 'jiraAdminPagesIssueTypeSchemesDirectory';
const $7cd5ecc17d70b2b1$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});

});

parcelRegister("4CFHb", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $f7ec44fa76e56068$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $f7ec44fa76e56068$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $f7ec44fa76e56068$export$fb15afa686993f11);

var $4QA2B = parcelRequire("4QA2B");

var $4qDVh = parcelRequire("4qDVh");

var $63t1V = parcelRequire("63t1V");

var $2ftkx = parcelRequire("2ftkx");
const $f7ec44fa76e56068$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy
    };
};
const $f7ec44fa76e56068$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = params;
    const parsedNumber = Number.isNaN((0, $4qDVh.number).parse(pageNumber)) ? (0, $63t1V.defaultIssueTypeSchemesFilter).pageNumber : (0, $4qDVh.number).parse(pageNumber);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' ? orderBy : undefined;
    return {
        ...(0, $63t1V.defaultIssueTypeSchemesFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy
    };
};
const $f7ec44fa76e56068$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($4QA2B)))({}, filter, (0, $63t1V.defaultIssueTypeSchemesFilter));
    let requestParams = {
        maxResults: (0, $63t1V.MAX_RESULTS),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.pageNumber - 1) * (0, $63t1V.MAX_RESULTS),
        orderBy: fullFilter.orderBy,
        queryString: (0, $2ftkx.trimSearchFilter)(fullFilter.searchFilter)
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("4QA2B", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $k4hoH = parcelRequire("k4hoH");

var $3P7i5 = parcelRequire("3P7i5");

var $5ovM8 = parcelRequire("5ovM8");
/** Used for built-in method references. */ var $3877f9c0b9ba6b7b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3877f9c0b9ba6b7b$var$hasOwnProperty = $3877f9c0b9ba6b7b$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $3877f9c0b9ba6b7b$var$defaults = $9eFtX(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $3P7i5(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $5ovM8(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $k4hoH(value, $3877f9c0b9ba6b7b$var$objectProto[key]) && !$3877f9c0b9ba6b7b$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $3877f9c0b9ba6b7b$var$defaults;

});

parcelRegister("4qDVh", function(module, exports) {

$parcel$export(module.exports, "string", () => $ef46bfb1383e180b$export$22b082955e083ec3);
$parcel$export(module.exports, "bool", () => $ef46bfb1383e180b$export$87b259aa03e3d267);
$parcel$export(module.exports, "array", () => $ef46bfb1383e180b$export$2f23118c22fb2630);
$parcel$export(module.exports, "multiple", () => $ef46bfb1383e180b$export$939ddaa3205df08e);
$parcel$export(module.exports, "number", () => $ef46bfb1383e180b$export$98e628dec113755e);

var $3QMTK = parcelRequire("3QMTK");
const $ef46bfb1383e180b$export$22b082955e083ec3 = {
    stringify: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
};
const $ef46bfb1383e180b$export$87b259aa03e3d267 = {
    stringify: (value)=>String(value),
    parse: (value)=>{
        if (value === 'true') return true;
        if (value === 'false') return false;
        return undefined;
    }
};
const $ef46bfb1383e180b$export$2f23118c22fb2630 = {
    stringify: (value)=>value && Array.isArray(value) ? value.join(',') : undefined,
    parse: (value)=>typeof value === 'string' ? value?.split(',') : undefined
};
const $ef46bfb1383e180b$export$939ddaa3205df08e = {
    stringify: (value)=>{
        if (!value || !Array.isArray(value)) return undefined;
        return value.length === 1 ? value[0] : value;
    },
    parse: (value)=>value && Array.isArray(value) ? value : [
            String(value)
        ]
};
const $ef46bfb1383e180b$export$98e628dec113755e = {
    stringify: (value)=>`${value}`,
    parse: (value)=>Number(value)
};

});

parcelRegister("2ftkx", function(module, exports) {

$parcel$export(module.exports, "trimSearchFilter", () => $8183583e9a63ddca$export$ed1722f41c23aaaf);
const $8183583e9a63ddca$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $8183583e9a63ddca$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $8183583e9a63ddca$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});



const $664c19c2d14162db$export$1d678052bb5ae54d = 'ISSUE_TYPE_SCHEME_TABLE';
const $664c19c2d14162db$export$41cf50ee50d5da20 = 'ISSUE_TYPE_SCHEME_TABLE_KEY';


parcelRegister("eDggO", function(module, exports) {

$parcel$export(module.exports, "issueTypesResource", () => $2ec648873c6084df$export$614e9d897c1ef917);

var $53ciZ = parcelRequire("53ciZ");

var $lB25E = parcelRequire("lB25E");

var $KqypM = parcelRequire("KqypM");
const $2ec648873c6084df$export$614e9d897c1ef917 = (0, $lB25E.createResource)({
    type: 'GLOBAL_ADMIN_ISSUE_TYPES_DIRECTORY',
    getKey: ()=>'issue types',
    getData: async ({ query: query })=>(0, $KqypM.getIssueTypes)((0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(query))
});

});
parcelRegister("KqypM", function(module, exports) {

$parcel$export(module.exports, "getIssueTypes", () => $66311c7490a085e2$export$4cf4b24b88599615);

var $53ciZ = parcelRequire("53ciZ");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $9j32Z = parcelRequire("9j32Z");
const $66311c7490a085e2$export$4cf4b24b88599615 = async (qs)=>{
    const filter = (0, $9j32Z.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify((0, $9j32Z.toApiUrlTransformer)(filter));
    try {
        return await (0, $2OdyW.default)(`/rest/internal/3/issuetype/search?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: (0, $6a48a5e8f88398a3$export$4adfbb237b083187),
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $6a48a5e8f88398a3$export$4adfbb237b083187 = 'jiraAdminPagesIssueTypesResources';

parcelRegister("9j32Z", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $6176d2dbe39feadc$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $6176d2dbe39feadc$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toSearchFilterQsTransformer", () => $6176d2dbe39feadc$export$bcd1ab210547e2f5);
$parcel$export(module.exports, "toSortFieldFilterQsTransformer", () => $6176d2dbe39feadc$export$c114848fa733e5c4);
$parcel$export(module.exports, "toSortDirectionFilterQsTransformer", () => $6176d2dbe39feadc$export$c5d2609f8b4048d3);
$parcel$export(module.exports, "toApiUrlTransformer", () => $6176d2dbe39feadc$export$fb15afa686993f11);

var $4QA2B = parcelRequire("4QA2B");

var $53ciZ = parcelRequire("53ciZ");



var $4qDVh = parcelRequire("4qDVh");

var $jr29U = parcelRequire("jr29U");

var $64igz = parcelRequire("64igz");
const $6176d2dbe39feadc$var$sortDirectionMap = {
    [(0, $44cab0426b6cf0d7$export$1dee026a19752d6b).toLowerCase()]: (0, $44cab0426b6cf0d7$export$1dee026a19752d6b),
    [(0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65).toLowerCase()]: (0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65)
};
const $6176d2dbe39feadc$var$sortFieldMap = {
    [(0, $1043f6e43a4e5fe8$export$3c5e605ca7ade9f2).toLowerCase()]: (0, $1043f6e43a4e5fe8$export$3c5e605ca7ade9f2),
    [(0, $1043f6e43a4e5fe8$export$7673664bdc3ae979).toLowerCase()]: (0, $1043f6e43a4e5fe8$export$7673664bdc3ae979)
};
const $6176d2dbe39feadc$export$5b9f8ed2c34be88a = (filter)=>filter ? {
        page: filter.page !== undefined && filter.page >= 1 ? String(filter.page) : undefined,
        sortDirection: (0, $jr29U.fieldToParam)(filter.sortDirection),
        sortField: (0, $jr29U.fieldToParam)(filter.sortField),
        searchFilter: (0, $jr29U.trimSearchFilter)(filter.searchFilter)
    } : {};
const $6176d2dbe39feadc$export$bec67ef860c0d0e1 = (params)=>({
        page: Math.floor(Number((0, $4qDVh.number).parse(params.page))) || undefined,
        searchFilter: (0, $jr29U.trimSearchFilter)(params.searchFilter),
        sortDirection: (0, $jr29U.fieldFromParam)($6176d2dbe39feadc$var$sortDirectionMap, params.sortDirection),
        sortField: (0, $jr29U.fieldFromParam)($6176d2dbe39feadc$var$sortFieldMap, params.sortField)
    });
const $6176d2dbe39feadc$export$bcd1ab210547e2f5 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(qs);
    return parsed.searchFilter ? parsed.searchFilter : '';
};
const $6176d2dbe39feadc$export$c114848fa733e5c4 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(qs);
    return parsed.sortField && parsed.sortField === 'name' ? (0, $1043f6e43a4e5fe8$export$3c5e605ca7ade9f2) : (0, $1043f6e43a4e5fe8$export$7673664bdc3ae979);
};
const $6176d2dbe39feadc$export$c5d2609f8b4048d3 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(qs);
    return parsed.sortDirection && parsed.sortDirection === 'asc' ? (0, $44cab0426b6cf0d7$export$1dee026a19752d6b) : (0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65);
};
const $6176d2dbe39feadc$var$apiSortByMap = {
    [(0, $44cab0426b6cf0d7$export$1dee026a19752d6b)]: '',
    [(0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65)]: '-'
};
const $6176d2dbe39feadc$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($4QA2B)))({}, filter, (0, $64igz.DEFAULT_FILTER));
    // this additional mapping here is needed because the BE issue type search API already supports sorting by hierarchy level using the "type" parameter. It was decided to add mapping on frontend. More details here https://atlassian.slack.com/archives/C02HN05MC8K/p1680683395059279
    const sortFieldMapping = fullFilter.sortField === 'hierarchy-level' ? 'type' : fullFilter.sortField;
    return {
        maxResults: (0, $64igz.MAX_RESULTS),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.page - 1) * (0, $64igz.MAX_RESULTS),
        query: (0, $jr29U.trimSearchFilter)(fullFilter.searchFilter),
        // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
        orderBy: `${$6176d2dbe39feadc$var$apiSortByMap[fullFilter.sortDirection]}${sortFieldMapping}`
    };
};

});
// data field names
const $1043f6e43a4e5fe8$export$3c5e605ca7ade9f2 = 'name';
const $1043f6e43a4e5fe8$export$d44826c816b5619b = 'description';
const $1043f6e43a4e5fe8$export$b87f371cbc396fcf = 'type';
const $1043f6e43a4e5fe8$export$7673664bdc3ae979 = 'hierarchy-level';
const $1043f6e43a4e5fe8$export$68e97ee499f7c743 = 'related-schemes';
const $1043f6e43a4e5fe8$export$92a1a3b7554e9387 = 'actions';
const $1043f6e43a4e5fe8$export$23ba45d5f8d54fed = 'level-number';
const $1043f6e43a4e5fe8$export$1dc71bc9f1a3749a = 'arrow';
const $1043f6e43a4e5fe8$export$8be5a31a21d0c723 = 'level-name';
const $1043f6e43a4e5fe8$export$6ad51af4785d6548 = 'jira-issue-types';
const $1043f6e43a4e5fe8$export$20068afc6f8c1737 = 'label-space';

parcelRegister("jr29U", function(module, exports) {

$parcel$export(module.exports, "fieldToParam", () => $5811ba891269dc6c$export$7341f299e7b93e87);
$parcel$export(module.exports, "fieldFromParam", () => $5811ba891269dc6c$export$c876451e094c0060);
$parcel$export(module.exports, "trimSearchFilter", () => $5811ba891269dc6c$export$ed1722f41c23aaaf);
const $5811ba891269dc6c$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $5811ba891269dc6c$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $5811ba891269dc6c$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});

parcelRegister("64igz", function(module, exports) {

$parcel$export(module.exports, "MAX_RESULTS", () => $907956bc954ce14c$export$f6b2881bc1090cea);
$parcel$export(module.exports, "DEFAULT_FILTER", () => $907956bc954ce14c$export$6deee0e4f2fb784e);


const $907956bc954ce14c$export$f6b2881bc1090cea = 15;
const $907956bc954ce14c$export$6deee0e4f2fb784e = {
    page: 1,
    sortDirection: (0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65),
    sortField: (0, $1043f6e43a4e5fe8$export$7673664bdc3ae979)
};

});




parcelRegister("1MAZH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRoute", () => $ff5f16d5cafe9306$export$2c220ed11ae62e14);
$parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRoute", () => $ff5f16d5cafe9306$export$6236a41e09bb858a);
$parcel$export(module.exports, "globalSettingsIssueTypesRoute", () => $ff5f16d5cafe9306$export$7358263a3bbb38b1);
$parcel$export(module.exports, "globalSettingsIssueTypesSchemesRoute", () => $ff5f16d5cafe9306$export$2aba97aa663f43b3);

var $exb0h = parcelRequire("exb0h");
const $ff5f16d5cafe9306$export$2c220ed11ae62e14 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY),
    path: '/jira/settings/issues/issue-hierarchy'
};
const $ff5f16d5cafe9306$export$6236a41e09bb858a = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY_REDIRECT),
    path: '/secure/PortfolioHierarchy.jspa'
};
const $ff5f16d5cafe9306$export$7358263a3bbb38b1 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES),
    path: '/jira/settings/issues/issue-types'
};
const $ff5f16d5cafe9306$export$2aba97aa663f43b3 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES),
    path: '/jira/settings/issues/issue-type-schemes'
};

});

parcelRegister("45fT3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("bRQFd")
]).then(()=>parcelRequire('7pWWX'));

});

parcelRegister("dcxZI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("id5xb").then(()=>parcelRequire('btdQZ'));

});

parcelRegister("dJuWy", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kumT4")
]).then(()=>parcelRequire('dPzqG'));

});

parcelRegister("d2cDI", function(module, exports) {

$parcel$export(module.exports, "jsmCustomerAuthenticationSettingsResource", () => $09315850a4e6ad93$export$73134c05a3c27bd);

var $lB25E = parcelRequire("lB25E");

var $8UVuC = parcelRequire("8UVuC");

const $09315850a4e6ad93$export$73134c05a3c27bd = (0, $lB25E.createResource)({
    type: (0, $8UVuC.RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("5ueIT")),
    maxAge: (0, $8UVuC.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("8UVuC", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS", () => $e77c90d49905626d$export$6a2799d78d98b915);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $e77c90d49905626d$export$5a00268156ea5027);
const $e77c90d49905626d$export$6a2799d78d98b915 = 'JSM_CUSTOMER_AUTHENTICATION_SETTINGS';
const $e77c90d49905626d$export$5a00268156ea5027 = 86400000;

});

parcelRegister("5ueIT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8fkhS").then(()=>parcelRequire('2y6vw'));

});


parcelRegister("9zpPg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("9UD2y")
]).then(()=>parcelRequire('d8cx9'));

});

parcelRegister("eUcUT", function(module, exports) {

$parcel$export(module.exports, "jsmGlobalCustomerAccessAffectedProjectsResource", () => $06e49f10ff6a602f$export$f27acbd4701f5dfe);

var $lB25E = parcelRequire("lB25E");

const $06e49f10ff6a602f$var$ONE_DAY_IN_MILLIS = 86400000;

const $06e49f10ff6a602f$export$f27acbd4701f5dfe = (0, $lB25E.createResource)({
    type: (0, $9ba0002b4c368082$export$341f26dde034af5b),
    getKey: ()=>'affected-projects',
    getDataLoader: ()=>(parcelRequire("leYqg")),
    maxAge: $06e49f10ff6a602f$var$ONE_DAY_IN_MILLIS
});

});
const $9ba0002b4c368082$export$341f26dde034af5b = 'JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS';
const $9ba0002b4c368082$export$eb7818fb178a80b4 = 'JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS';

parcelRegister("leYqg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("65rCi").then(()=>parcelRequire('euCWi'));

});


parcelRegister("fdikA", function(module, exports) {

$parcel$export(module.exports, "jsmGlobalCustomerAccessSettingsResource", () => $ebb62170859aa532$export$b1a50ad717b4ca61);

var $lB25E = parcelRequire("lB25E");

const $ebb62170859aa532$var$ONE_DAY_IN_MILLIS = 86400000;

const $ebb62170859aa532$export$b1a50ad717b4ca61 = (0, $lB25E.createResource)({
    type: (0, $9ba0002b4c368082$export$eb7818fb178a80b4),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("hRpzz")),
    maxAge: $ebb62170859aa532$var$ONE_DAY_IN_MILLIS
});

});
parcelRegister("hRpzz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("l09R5").then(()=>parcelRequire('6kJQl'));

});


parcelRegister("ioNr7", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("dCfiZ")
]).then(()=>parcelRequire('2pFj4'));

});

parcelRegister("4lDM6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hHwgH")
]).then(()=>parcelRequire('7xeN1'));

});

parcelRegister("leDf8", function(module, exports) {

$parcel$export(module.exports, "SidebarGlobalSettingsSystem", () => $bac2e68fb50bbd0f$export$52af3150b9f64726);

var $eUqFw = parcelRequire("eUqFw");

var $4Ti3v = parcelRequire("4Ti3v");

var $u0mbR = parcelRequire("u0mbR");

var $jlT0W = parcelRequire("jlT0W");
const $bac2e68fb50bbd0f$export$52af3150b9f64726 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $u0mbR.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jlT0W.Menu), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $u0mbR.SidebarReady), {
        id: (0, $4Ti3v.SIDEBAR_ID).GLOBAL_SETTINGS_SYSTEM
    }));

});
parcelRegister("4Ti3v", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_ID", () => $7a89ae81cc6f8c6c$export$adf978edbdfaf080);
const $7a89ae81cc6f8c6c$export$adf978edbdfaf080 = {
    CONNECT: 'CONNECT',
    CORE: 'CORE',
    FILTERS: 'FILTERS',
    FILTERS_GLOBAL: 'FILTERS_GLOBAL',
    FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
    GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
    GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
    GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
    GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
    GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
    JSM: 'JSM',
    JSW_CLASSIC: 'JSW_CLASSIC',
    JSW_NEXT_GEN: 'JSW_NEXT_GEN',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    EOC_OPERATIONS: 'EOC_OPERATIONS',
    POLARIS: 'POLARIS',
    USER: 'USER',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};

});

parcelRegister("jlT0W", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $fd0713a46401c6f7$export$d9b273488cd8ce6f);

var $eUqFw = parcelRequire("eUqFw");

var $8ZwXC = parcelRequire("8ZwXC");
var $gxMC2 = parcelRequire("gxMC2");
var $8N3rk = parcelRequire("8N3rk");
var $20Dml = parcelRequire("20Dml");
var $gLn5u = parcelRequire("gLn5u");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $9kVcv = parcelRequire("9kVcv");

var $hzZWH = parcelRequire("hzZWH");

var $iaHqR = parcelRequire("iaHqR");

var $bS2FN = parcelRequire("bS2FN");

var $aWYQ8 = parcelRequire("aWYQ8");

var $10fdS = parcelRequire("10fdS");

var $edsEA = parcelRequire("edsEA");

var $cvu76 = parcelRequire("cvu76");

var $hrMrK = parcelRequire("hrMrK");

var $gS9Pi = parcelRequire("gS9Pi");

var $4VoIp = parcelRequire("4VoIp");

var $ii4v1 = parcelRequire("ii4v1");

var $lLbUm = parcelRequire("lLbUm");

var $gzoho = parcelRequire("gzoho");

var $dL8Xn = parcelRequire("dL8Xn");

var $7NvRo = parcelRequire("7NvRo");

var $kdz1U = parcelRequire("kdz1U");

var $3I29L = parcelRequire("3I29L");

var $7SUOK = parcelRequire("7SUOK");
// @ts-expect-error - TS7006 - Parameter 'route' implicitly has an 'any' type.
const $fd0713a46401c6f7$var$calculateStack = (route)=>{
    const routeName = route && route.name || '';
    if ([
        (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD),
        (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME),
        (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE)
    ].includes(routeName)) return [
        (0, $edsEA.SECTION_ID).MIGRATE_TO_CLOUD_SITE
    ];
    if ([
        (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL),
        (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW),
        (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP),
        (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR),
        (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD),
        (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE)
    ].includes(routeName)) return [
        (0, $edsEA.SECTION_ID).PERFORMANCE_AND_SCALE
    ];
    return [];
};
const $fd0713a46401c6f7$export$d9b273488cd8ce6f = ()=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: connectItems } = (0, $cvu76.useGlobalSettingsSystemConnectItems)();
    const [stack, setStack] = (0, $eUqFw.useState)($fd0713a46401c6f7$var$calculateStack(route));
    (0, $eUqFw.useEffect)(()=>{
        setStack($fd0713a46401c6f7$var$calculateStack(route));
    }, [
        route
    ]);
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    const generalConfigurationPath = navigationPath.generalConfiguration;
    if (features == null || connectItems == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const navigationContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, features.hasGeneralConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'general-configuration'
        },
        href: generalConfigurationPath,
        selectedOn: (0, $7SUOK.isGeneralConfigurationSelected)
    }, formatMessage((0, $gzoho.default).generalConfiguration)), features.hasDarkFeatures && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'dark-features'
        },
        href: navigationPath.darkFeatures,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $gzoho.default).darkFeatures)), features.hasTroubleshootingAndSupportSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kdz1U.TroubleshootingAndSupportSection), null), features.hasSecuritySection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dL8Xn.SecuritySection), null), features.hasCollectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'collectors'
        },
        href: navigationPath.issueCollectors,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $gzoho.default).issueCollectors)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4VoIp.AutomationSection), null), features.hasUserInterfaceSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3I29L.UserInterfaceSection), null), features.hasImportExportSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ii4v1.ImportExportSection), {
        stack: stack
    }), features.hasMailSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLbUm.MailSection), null), features.hasAdminHelperSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hrMrK.AdminHelperSection), null), features.hasSharedSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7NvRo.SharedSection), null), features.hasAdvancedSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gS9Pi.AdvancedSection), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aWYQ8.ConnectMenu), {
        items: connectItems,
        overrides: {
            BackMenuItem: {
                href: '/jira/settings/system/general-configuration',
                title: formatMessage((0, $gzoho.default).systemGroup)
            }
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hzZWH.ContextualAnalyticsData), {
        menuId: "global-settings/system",
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $20Dml.default), {
        label: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gxMC2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $gzoho.default).systemGroup))), (0, $1ybV0.ff)('jira-system-settings-cloud-to-cloud-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N3rk.default), {
        stack: stack,
        onChange: setStack
    }, navigationContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ZwXC.default), null, navigationContent)));
};

});
parcelRegister("8ZwXC", function(module, exports) {

$parcel$export(module.exports, "default", () => $79677661d4a83719$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dxAkq = parcelRequire("dxAkq");

var $cgrgx = parcelRequire("cgrgx");

var $3KfxB = parcelRequire("3KfxB");
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $79677661d4a83719$var$NavigationContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    const scrollbar = (0, $dxAkq.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: typedRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $3KfxB.outerContainerCSS)({
            showTopScrollIndicator: showTopScrollIndicator,
            scrollbarWidth: scrollbar.width
        }),
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: scrollbar.ref,
        css: (0, $3KfxB.innerContainerCSS)({
            showTopScrollIndicator: showTopScrollIndicator
        })
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $3KfxB.containerCSS)({
            showTopScrollIndicator: showTopScrollIndicator
        })
    }, children)));
});
var $79677661d4a83719$export$2e2bcd8739ae039 = $79677661d4a83719$var$NavigationContent;

});
parcelRegister("dxAkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $61bf491fcf88b5a3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $61bf491fcf88b5a3$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $eUqFw.useState)(0);
    const elementRef = (0, $eUqFw.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});

parcelRegister("3KfxB", function(module, exports) {

$parcel$export(module.exports, "outerContainerCSS", () => $cbf9fac083377857$export$3ff462c0176a504f);
$parcel$export(module.exports, "innerContainerCSS", () => $cbf9fac083377857$export$4d1aec15cfcfc2a4);
$parcel$export(module.exports, "containerCSS", () => $cbf9fac083377857$export$949392aeaf7d2e3a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 

var $4lTFP = parcelRequire("4lTFP");

const $cbf9fac083377857$var$scrollIndicatorMaskZIndex = 2;
const $cbf9fac083377857$var$scrollIndicatorZIndex = 1;
const $cbf9fac083377857$var$scrollIndicatorHeight = 2;
const $cbf9fac083377857$var$scrollIndicatorBorderRadius = '1px';
const $cbf9fac083377857$var$containerPadding = 8;
const $cbf9fac083377857$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $cbf9fac083377857$var$skeletonHeadingHeight = $cbf9fac083377857$var$containerPadding;
const $cbf9fac083377857$var$skeletonHeadingMarginOffset = 3;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $cbf9fac083377857$var$skeletonHeadingTopMargin = $cbf9fac083377857$var$containerPadding * 2.5 + ($cbf9fac083377857$var$itemHeadingContentHeight - $cbf9fac083377857$var$skeletonHeadingHeight) - $cbf9fac083377857$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
const $cbf9fac083377857$var$skeletonHeadingBottomMargin = $cbf9fac083377857$var$containerPadding * 0.75 + $cbf9fac083377857$var$skeletonHeadingMarginOffset;
const $cbf9fac083377857$export$3ff462c0176a504f = (opts)=>({
        // Flex is needed to ensure the overflow indicators are positioned correctly.
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        '&::before': {
            content: "''",
            display: 'block',
            left: "var(--ds-space-100, 8px)",
            right: $cbf9fac083377857$var$containerPadding + opts.scrollbarWidth,
            height: $cbf9fac083377857$var$scrollIndicatorHeight,
            borderRadius: `var(--ds-border-radius-050, ${$cbf9fac083377857$var$scrollIndicatorBorderRadius})`,
            backgroundColor: `var(${0, $653c080b5250656d$export$e8e7f51e033d4cb2}, ${`var(--ds-border, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`})`,
            position: 'absolute',
            zIndex: $cbf9fac083377857$var$scrollIndicatorZIndex
        },
        '&::after': {
            content: "''",
            position: 'absolute',
            display: 'block',
            borderRadius: `var(--ds-border-radius-050, ${$cbf9fac083377857$var$scrollIndicatorBorderRadius})`,
            flexShrink: 0,
            height: $cbf9fac083377857$var$scrollIndicatorHeight,
            left: "var(--ds-space-100, 8px)",
            right: $cbf9fac083377857$var$containerPadding + opts.scrollbarWidth,
            bottom: 0,
            zIndex: $cbf9fac083377857$var$scrollIndicatorZIndex,
            backgroundColor: `var(${0, $653c080b5250656d$export$e8e7f51e033d4cb2}, ${`var(--ds-border, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`})`
        }
    });
const $cbf9fac083377857$export$4d1aec15cfcfc2a4 = (opts)=>({
        display: 'flex',
        overflow: 'auto',
        width: '100%',
        position: 'relative',
        boxSizing: 'border-box',
        flexDirection: 'column',
        // This before pseudo element is works by being positioned at the top of this scrolling
        // container - so when you scroll down it stops "masking" the actual scroll indicator.
        ...!opts.showTopScrollIndicator && {
            '&::before': {
                borderRadius: `var(--ds-border-radius-050, ${$cbf9fac083377857$var$scrollIndicatorBorderRadius})`,
                content: "''",
                left: 0,
                right: 0,
                height: $cbf9fac083377857$var$scrollIndicatorHeight,
                backgroundColor: `var(${0, $653c080b5250656d$export$49e4dd5760b312e0}, ${`var(--ds-surface, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`})`,
                position: 'absolute',
                display: 'block',
                zIndex: $cbf9fac083377857$var$scrollIndicatorMaskZIndex
            }
        },
        // This after pseudo element abuses being a flex child and pushes itself down to the
        // very bottom of the container - doing so ends up "masking" the actual scroll indicator.
        '&::after': {
            borderRadius: `var(--ds-border-radius-050, ${$cbf9fac083377857$var$scrollIndicatorBorderRadius})`,
            content: "''",
            display: 'block',
            flexShrink: 0,
            height: $cbf9fac083377857$var$scrollIndicatorHeight,
            // This is used to "push" the element to the bottom of the flex container.
            marginTop: 'auto',
            position: 'relative',
            zIndex: $cbf9fac083377857$var$scrollIndicatorMaskZIndex,
            backgroundColor: `var(${0, $653c080b5250656d$export$49e4dd5760b312e0}, ${`var(--ds-surface, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`})`
        }
    });
const $cbf9fac083377857$export$949392aeaf7d2e3a = (opts)=>({
        // When the scroll indicator is always shown we need to add some padding
        // so the spacing between matches what it would be if the indicator was a "block" element.
        // We use margin here so any child absolutely positioned elements are positioned correctly.
        marginTop: opts.showTopScrollIndicator ? $cbf9fac083377857$var$scrollIndicatorHeight : 0,
        marginLeft: "var(--ds-space-100, 8px)",
        marginRight: "var(--ds-space-100, 8px)",
        // Enables child absolutely positioned elements to be positioned relative to this element.
        position: 'relative',
        '& [data-ds--menu--heading-item]': {
            marginBottom: "var(--ds-space-075, 6px)",
            marginTop: "var(--ds-space-200, 16px)"
        },
        '& [data-ds--menu--skeleton-heading-item]': {
            marginTop: $cbf9fac083377857$var$skeletonHeadingTopMargin,
            marginBottom: $cbf9fac083377857$var$skeletonHeadingBottomMargin
        }
    });

});
const $653c080b5250656d$export$e8e7f51e033d4cb2 = '--ds-menu-seperator-color';
const $653c080b5250656d$export$49e4dd5760b312e0 = '--ds-menu-scroll-indicator-color';



parcelRegister("gxMC2", function(module, exports) {

$parcel$export(module.exports, "default", () => $65b445d0e74737f3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $65b445d0e74737f3$var$navigationFooterStyles = (0, $1ZAYh.xcss)({
    display: 'block',
    padding: 'space.100',
    paddingBlockStart: 'space.300'
});
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $65b445d0e74737f3$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $65b445d0e74737f3$var$navigationFooterStyles,
        "data-navheader": true
    }, children);
};
var $65b445d0e74737f3$export$2e2bcd8739ae039 = $65b445d0e74737f3$var$NavigationHeader;

});

parcelRegister("8N3rk", function(module, exports) {

$parcel$export(module.exports, "ROOT_ID", () => $cc821c64d466644f$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $cc821c64d466644f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lSV8Z = parcelRequire("lSV8Z");

var $bM0x9 = parcelRequire("bM0x9");

var $9iAqW = parcelRequire("9iAqW");

var $1Z5iN = parcelRequire("1Z5iN");

var $cgrgx = parcelRequire("cgrgx");

var $C037h = parcelRequire("C037h");
function $cc821c64d466644f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cc821c64d466644f$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $cc821c64d466644f$var$nestableNavigationContentStyles = {
    name: "hxjswn",
    styles: "height:100%;position:relative;outline:none"
};
const $cc821c64d466644f$var$nestingRootStyles = {
    name: "1klp5xc",
    styles: "display:flex;width:100%;height:100%;position:absolute;flex-direction:column"
};
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $cc821c64d466644f$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $eUqFw.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator } = props;
    const [committedStack, setCommittedStack] = (0, $eUqFw.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $cc821c64d466644f$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $eUqFw.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $bM0x9.default), props, "Go back");
    const { childIdsRef: childIdsRef } = (0, $1Z5iN.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $eUqFw.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $eUqFw.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId
    });
    const context = (0, $eUqFw.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $cc821c64d466644f$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: $cc821c64d466644f$var$nestableNavigationContentStyles,
        ref: containerRef,
        tabIndex: -1,
        onClick: manageFocus
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lSV8Z.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $C037h.NestingMotion), {
        // Key is needed to have a unique react instance per stack name.
        // This enables us to easily animate it in & out with exiting persistence.
        key: currentStackId,
        enterFrom: transition === 'nesting' ? 'right' : 'left',
        exitTo: transition === 'nesting' ? 'left' : 'right',
        testId: testId && `${testId}-anim`
    }, (motion)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $cc821c64d466644f$var$nestingRootStyles,
            ...motion
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cgrgx.NestedContext).Provider, {
            // This provider is inside the NestingMotion to ensure it keeps a stale
            // reference to the previous value.
            value: context
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9iAqW.default), {
            title: "",
            id: $cc821c64d466644f$export$ec71a3379b43ae5c
        }, children)))))));
};
var $cc821c64d466644f$export$2e2bcd8739ae039 = $cc821c64d466644f$var$NestableNavigationContent;

});
parcelRegister("bM0x9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f212f85e4c65f98$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5e0pr = parcelRequire("5e0pr");


var $iaRDX = parcelRequire("iaRDX");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $4f212f85e4c65f98$var$GoBackItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ cssFn: cssFn, iconBefore: iconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5e0pr))), {
    color: "currentColor",
    LEGACY_secondaryColor: `var(--ds-surface, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $eUqFw.useState)(false);
    const onClickHandler = (0, $eUqFw.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iaRDX.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: cssFn,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $4f212f85e4c65f98$export$2e2bcd8739ae039 = $4f212f85e4c65f98$var$GoBackItem;

});
parcelRegister("5e0pr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5fe3eab097a043afd6df5fa85bf9b04>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cde93d8c91d02e4$var$_react = $3cde93d8c91d02e4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3cde93d8c91d02e4$var$_arrowLeft = $3cde93d8c91d02e4$var$_interopRequireDefault((parcelRequire("f4v4a")));

var $3cde93d8c91d02e4$var$_arrowLeftCircle = $3cde93d8c91d02e4$var$_interopRequireDefault((parcelRequire("fyp42")));
function $3cde93d8c91d02e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cde93d8c91d02e4$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $3cde93d8c91d02e4$var$_react.default.createElement($3cde93d8c91d02e4$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $3cde93d8c91d02e4$var$_arrowLeftCircle.default
    }, props));
$3cde93d8c91d02e4$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $3cde93d8c91d02e4$var$_default = module.exports.default = $3cde93d8c91d02e4$var$ArrowLeftIcon;

});
parcelRegister("fyp42", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b52d792fd039ccff$var$_react = $b52d792fd039ccff$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b52d792fd039ccff$var$_arrowLeft = $b52d792fd039ccff$var$_interopRequireDefault((parcelRequire("f4v4a")));
function $b52d792fd039ccff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b52d792fd039ccff$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $b52d792fd039ccff$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $b52d792fd039ccff$var$_arrowLeft.default
    }));
$b52d792fd039ccff$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $b52d792fd039ccff$var$_default = module.exports.default = $b52d792fd039ccff$var$ArrowLeftCircleIcon;

});


parcelRegister("iaRDX", function(module, exports) {

$parcel$export(module.exports, "default", () => $214046ccd34b0757$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $214046ccd34b0757$var$ButtonItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $jvM56.overrideStyleFunction)((0, $jvM56.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $214046ccd34b0757$export$2e2bcd8739ae039 = $214046ccd34b0757$var$ButtonItem;

});


parcelRegister("9iAqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $56cec1d16683bfce$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $50jXv = parcelRequire("50jXv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $jvM56 = parcelRequire("jvM56");

var $iaRDX = parcelRequire("iaRDX");
var $gMdj1 = parcelRequire("gMdj1");
var $8ZwXC = parcelRequire("8ZwXC");

var $8N3rk = parcelRequire("8N3rk");

var $cgrgx = parcelRequire("cgrgx");

var $1Z5iN = parcelRequire("1Z5iN");

var $kJUBw = parcelRequire("kJUBw");
const $56cec1d16683bfce$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline'
});
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $56cec1d16683bfce$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, cssFn: cssFn, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator } = (0, $cgrgx.useNestedContext)();
    const mergedStyles = (0, $jvM56.overrideStyleFunction)((0, $kJUBw.nestingItemStyle), cssFn);
    const [isInteracted, setIsInteracted] = (0, $eUqFw.useState)(false);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`
    }) || contextualBackButton;
    const context = (0, $eUqFw.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator
    ]);
    (0, $1Z5iN.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $eUqFw.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $cgrgx.NestedContext).Provider, {
        value: context
    }, stack.length >= 1 && /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        paddingBlock: "space.075",
        paddingInline: "space.100"
    }, backButton), /*#__PURE__*/ (0, $byn9U.jsx)((0, $8ZwXC.default), {
        testId: testId,
        showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1
    }, children));
    if ([
        (0, $8N3rk.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, iconAfter ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            xcss: $56cec1d16683bfce$var$iconContainerStyles,
            "data-custom-icon": true,
            as: "span"
        }, iconAfter) : null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            "data-right-arrow": true,
            xcss: $56cec1d16683bfce$var$iconContainerStyles,
            as: "span"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($50jXv))), {
            testId: testId && `${testId}--item--right-arrow`,
            color: "currentColor",
            LEGACY_secondaryColor: `var(--ds-surface, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
            label: ""
        }))),
        onClick: onClickHandler,
        isSelected: isSelected,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title,
        cssFn: mergedStyles
    };
    if (component) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gMdj1.default), {
        ...componentProps,
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iaRDX.default), componentProps);
};
var $56cec1d16683bfce$export$2e2bcd8739ae039 = $56cec1d16683bfce$var$NestingItem;

});
parcelRegister("50jXv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8270c1c0a2e3403b04642f2e4cb193b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a4c6f372f1ff0fc$var$_react = $3a4c6f372f1ff0fc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a4c6f372f1ff0fc$var$_arrowRight = $3a4c6f372f1ff0fc$var$_interopRequireDefault((parcelRequire("gTPnA")));

var $3a4c6f372f1ff0fc$var$_arrowRightCircle = $3a4c6f372f1ff0fc$var$_interopRequireDefault((parcelRequire("k4jc8")));
function $3a4c6f372f1ff0fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a4c6f372f1ff0fc$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $3a4c6f372f1ff0fc$var$_react.default.createElement($3a4c6f372f1ff0fc$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $3a4c6f372f1ff0fc$var$_arrowRightCircle.default
    }, props));
$3a4c6f372f1ff0fc$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $3a4c6f372f1ff0fc$var$_default = module.exports.default = $3a4c6f372f1ff0fc$var$ArrowRightIcon;

});
parcelRegister("gTPnA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a0af1361c1c47b464cd1f3e8c2b50c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4d9a34bffd519bc$var$_react = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c4d9a34bffd519bc$var$_UNSAFE_baseNew = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c4d9a34bffd519bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4d9a34bffd519bc$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c4d9a34bffd519bc$var$_react.default.createElement($c4d9a34bffd519bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$c4d9a34bffd519bc$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c4d9a34bffd519bc$var$_default = module.exports.default = $c4d9a34bffd519bc$var$ArrowRightIcon;

});

parcelRegister("k4jc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9c31206c0c7e54b$var$_react = $e9c31206c0c7e54b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e9c31206c0c7e54b$var$_arrowRight = $e9c31206c0c7e54b$var$_interopRequireDefault((parcelRequire("gTPnA")));
function $e9c31206c0c7e54b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e9c31206c0c7e54b$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $e9c31206c0c7e54b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $e9c31206c0c7e54b$var$_arrowRight.default
    }));
$e9c31206c0c7e54b$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $e9c31206c0c7e54b$var$_default = module.exports.default = $e9c31206c0c7e54b$var$ArrowRightCircleIcon;

});


parcelRegister("gMdj1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5254fde102c89aa1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-overrides */ 
var $eUqFw = parcelRequire("eUqFw");

var $e7PSD = parcelRequire("e7PSD");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $5254fde102c89aa1$var$CustomItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $jvM56.overrideStyleFunction)((0, $jvM56.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $5254fde102c89aa1$export$2e2bcd8739ae039 = $5254fde102c89aa1$var$CustomItem;

});

parcelRegister("1Z5iN", function(module, exports) {

$parcel$export(module.exports, "useChildIds", () => $757bdf2b7228d1ef$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $757bdf2b7228d1ef$export$ea18c2b5f0e24612);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
const $757bdf2b7228d1ef$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $eUqFw.useRef)(new Set());
    (0, $eUqFw.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $8N3rk.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $757bdf2b7228d1ef$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $eUqFw.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});

parcelRegister("kJUBw", function(module, exports) {

$parcel$export(module.exports, "nestingItemStyle", () => $a9d327ba12673c0a$export$38e770f85519b259);
const $a9d327ba12673c0a$export$4c36b5b1b67ee1e8 = {
    ['&:hover [data-custom-icon]']: {
        display: 'none'
    },
    ['&:active [data-custom-icon]']: {
        display: 'none'
    },
    ['&:focus [data-custom-icon]']: {
        display: 'none'
    },
    ['& [data-custom-icon]']: {
        display: 'inherit'
    },
    ['&:hover [data-right-arrow]']: {
        display: 'inherit'
    },
    ['&:active [data-right-arrow]']: {
        display: 'inherit'
    },
    ['&:focus [data-right-arrow]']: {
        display: 'inherit'
    },
    ['& [data-right-arrow]']: {
        display: 'none'
    }
};
const $a9d327ba12673c0a$var$disabledCSS = {
    ['[data-item-elem-after]']: {
        opacity: 0
    },
    ['& [data-right-arrow]']: {
        display: 'none'
    }
};
const $a9d327ba12673c0a$export$38e770f85519b259 = (state)=>{
    return {
        ...state.isDisabled ? $a9d327ba12673c0a$var$disabledCSS : $a9d327ba12673c0a$export$4c36b5b1b67ee1e8
    };
};

});


parcelRegister("C037h", function(module, exports) {

$parcel$export(module.exports, "NestingMotion", () => $dec7f8f6c7da8f0e$export$9e743a8c2a6b450e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $2EVgw = parcelRequire("2EVgw");
const $dec7f8f6c7da8f0e$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2EVgw.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: (_)=>(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)
    }, (innerProps, direction)=>children({
            'data-enter-from': enterFrom,
            'data-exit-to': exitTo,
            'data-testid': testId && `${testId}-${direction}`,
            ...innerProps
        }));
};

});


parcelRegister("20Dml", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d1dc06fce7952b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8jcoK = parcelRequire("8jcoK");

const $52d1dc06fce7952b$var$sidebarMinWidth = '240px';
const $52d1dc06fce7952b$var$sideNavStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: '100%',
    minWidth: $52d1dc06fce7952b$var$sidebarMinWidth,
    height: '100%',
    position: 'relative',
    flexDirection: 'column',
    backgroundColor: `var(--ds-surface, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
    overflow: 'hidden'
});
/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */ const $52d1dc06fce7952b$var$SideNavigation = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, label: label } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        css: $52d1dc06fce7952b$var$sideNavStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8jcoK.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "notch"
    }, children));
});
var $52d1dc06fce7952b$export$2e2bcd8739ae039 = $52d1dc06fce7952b$var$SideNavigation;

});

parcelRegister("1UelU", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $df864800942e4b9a$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $k4nIh = parcelRequire("k4nIh");

var $gMdj1 = parcelRequire("gMdj1");


var $lB25E = parcelRequire("lB25E");

var $8n4Bi = parcelRequire("8n4Bi");

var $lPCnq = parcelRequire("lPCnq");

var $foHkv = parcelRequire("foHkv");
const $df864800942e4b9a$var$WrapperComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df864800942e4b9a$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $df864800942e4b9a$var$customCssFn = (currentState = {})=>({
        '[data-item-title]': {
            lineHeight: 1.2
        },
        /* fixes CSS leaking from the monolith */ ...currentState.isSelected && {
            '& [data-item-title]': {
                color: "var(--ds-text-selected, rgb(12, 102, 228))"
            }
        },
        /* fixes CSS leaking from the monolith */ '&:focus, &:visited, &:active': {
            textDecoration: 'inherit',
            outline: 0
        },
        /* fixes CSS leaking from the monolith */ '&:active': {
            backgroundColor: "var(--ds-background-selected-pressed, #85B8FF)",
            boxShadow: "var(--ds-shadow-overlay, transparent)",
            '& [data-item-title]': {
                color: "var(--ds-text, rgb(66, 82, 110))"
            }
        },
        '&:focus': {
            boxShadow: `${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`} 0 0 0 2px inset`
        },
        /* fixes CSS for react-beautiful-dnd */ '&[data-rbd-draggable-id]': {
            cursor: 'pointer'
        }
    });
const $df864800942e4b9a$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, cssFn: outsideCssFn, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $foHkv.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $lB25E.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const cssFn = (0, $eUqFw.useCallback)((currentState)=>({
            ...outsideCssFn && outsideCssFn(currentState),
            ...$df864800942e4b9a$var$customCssFn(currentState),
            ...(0, $lPCnq.getCustomThemeCss)(theme)
        }), [
        theme,
        outsideCssFn
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $df864800942e4b9a$var$WrapperComponent,
        cssFn: cssFn,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined
    };
    return overrides?.CustomItem?.render(customProps) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gMdj1.default), customProps);
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df864800942e4b9a$var$ButtonItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk18uv _19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8n4Bi", function(module, exports) {

$parcel$export(module.exports, "SidebarThemeProvider", () => $3f50a441bbce6f7c$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $3f50a441bbce6f7c$export$b1a81b4626bc52c3);

var $eUqFw = parcelRequire("eUqFw");
const $3f50a441bbce6f7c$var$ThemeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3f50a441bbce6f7c$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f50a441bbce6f7c$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $3f50a441bbce6f7c$export$b1a81b4626bc52c3 = ()=>(0, $eUqFw.useContext)($3f50a441bbce6f7c$var$ThemeContext);

});

parcelRegister("lPCnq", function(module, exports) {

$parcel$export(module.exports, "getCustomThemeCss", () => $6275288bde4e93f8$export$cc5a98b66b3e9306);
const $6275288bde4e93f8$export$cc5a98b66b3e9306 = (theme)=>{
    if (theme?.navigation) {
        const { navigation: { item: item, icon: icon } } = theme;
        return {
            backgroundColor: item?.background?.default ?? undefined,
            color: item?.color?.default ?? undefined,
            '& [data-item-title]': {
                color: item?.color?.default ?? undefined
            },
            '&:hover': {
                color: item?.color?.hover ?? undefined,
                backgroundColor: item?.background?.hover ?? undefined
            },
            /* fixes CSS leaking from the monolith */ '&:focus, &:visited': {
                color: item?.color?.default
            },
            '&:active': {
                color: item?.color?.active ?? undefined,
                backgroundColor: item?.background?.active ?? undefined
            },
            '&:active [data-item-title]': {
                color: item?.color?.active ?? undefined
            },
            '&:active [data-item-elem-before]': {
                color: item?.color?.active ?? undefined
            },
            '&:focus': {
                boxShadow: item?.color?.active != null ? `${item?.color?.active} 0 0 0 2px inset` : undefined
            },
            '&[aria-current="page"]': {
                position: 'relative',
                backgroundColor: item?.background?.active ?? undefined,
                color: item?.color?.active ?? undefined
            },
            '&[aria-current="page"]:before': {
                background: item?.color?.active ?? undefined
            },
            '& [data-item-elem-after]': {
                color: icon?.secondary?.color?.hover ?? undefined
            }
        };
    }
    return {};
};

});

parcelRegister("foHkv", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $0b0be38cfe8462be$export$a81c45382e7253ac);

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $0b0be38cfe8462be$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("9kVcv", function(module, exports) {

$parcel$export(module.exports, "TitleHeader", () => $097fe38bc39869b0$export$de3705f3d2162955);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $8SnT0 = parcelRequire("8SnT0");

var $8n4Bi = parcelRequire("8n4Bi");

var $dHQr5 = parcelRequire("dHQr5");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $097fe38bc39869b0$var$overrideStyles = (currentStyles)=>({
        ...currentStyles,
        '[data-item-title]': {
            ...currentStyles['[data-item-title]'],
            whiteSpace: 'normal',
            lineHeight: 'initial'
        }
    });
const $097fe38bc39869b0$export$de3705f3d2162955 = ({ children: children })=>{
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const cssFn = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
            (0, $dHQr5.generateCustomThemeCssFn)(theme),
            $097fe38bc39869b0$var$overrideStyles
        ]), [
        theme
    ]);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SnT0.default), {
        cssFn: cssFn
    }, children);
};

});
parcelRegister("8SnT0", function(module, exports) {

$parcel$export(module.exports, "Container", () => $caa339108b3c8ef1$export$42a852a2b6b56249);
$parcel$export(module.exports, "default", () => $caa339108b3c8ef1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $jvM56 = parcelRequire("jvM56");

var $gMdj1 = parcelRequire("gMdj1");
function $caa339108b3c8ef1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $caa339108b3c8ef1$var$containerStyles = {
    name: "4bgdod",
    styles: "display:block;position:relative"
};
const $caa339108b3c8ef1$export$42a852a2b6b56249 = ({ children: children, 'data-testid': testId, ...props })=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
            className: className,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onDragStart: onDragStart,
            draggable: draggable,
            ref: ref,
            tabIndex: tabIndex,
            disabled: disabled
        }))(props);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: $caa339108b3c8ef1$var$containerStyles,
        ...safeProps
    }, children);
};
/**
 * __Header__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $caa339108b3c8ef1$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const cssFn = (0, $jvM56.overrideStyleFunction)(()=>({
            userSelect: 'auto',
            ['[data-item-title]']: {
                font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
            },
            // Will look interactive if the `component` is anything other than a div.
            'div&:hover': {
                backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
                cursor: 'default'
            },
            'div&:active': {
                backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
                color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
            }
        }), props.cssFn);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gMdj1.default), {
        ...props,
        ref: ref,
        component: props.component || $caa339108b3c8ef1$export$42a852a2b6b56249,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: cssFn,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: {
            Title: {
                render: (_, { children: children, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("h2", props, children)
            }
        }
    });
});
var $caa339108b3c8ef1$export$2e2bcd8739ae039 = $caa339108b3c8ef1$var$Header;

});

parcelRegister("dHQr5", function(module, exports) {

$parcel$export(module.exports, "generateCustomThemeCssFn", () => $4df067d0bbc9b88e$export$5ae7d20da3003de);

var $2vzCR = parcelRequire("2vzCR");

var $5vmRt = parcelRequire("5vmRt");
const $4df067d0bbc9b88e$export$5ae7d20da3003de = (theme)=>(0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
        if (theme?.navigation) {
            const { navigation: { item: item } } = theme;
            const themeStyles = {
                backgroundColor: item?.background?.default ?? undefined,
                color: item?.color?.default ?? undefined,
                '&:hover': {
                    color: item?.color?.hover ?? undefined,
                    backgroundColor: item?.background?.hover ?? undefined
                },
                '[data-item-title]': {
                    color: item?.color?.default ?? undefined
                }
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStyles, themeStyles);
        }
        return currentStyles;
    });

});
parcelRegister("5vmRt", function(module, exports) {

$parcel$export(module.exports, "castRealCSSFnToWronglyTypedCSSFn", () => $a9f42b05cf11af4c$export$3f662b014fa1806e);
function $a9f42b05cf11af4c$export$3f662b014fa1806e(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    return fn;
}
function $a9f42b05cf11af4c$export$17f32e2573d62daa(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    return fn;
}
const $a9f42b05cf11af4c$export$91011a0a572ef910 = {
    CONNECTED: 'CONNECTED',
    INCOMPLETE: 'INCOMPLETE',
    INITIAL: 'INITIAL',
    SEEN: 'SEEN',
    UNCONNECTED: 'UNCONNECTED'
};

});



parcelRegister("iaHqR", function(module, exports) {

$parcel$export(module.exports, "getSystemNavigationPaths", () => $d1f3b12800e4309b$export$76c5f80c8d9bdb0e);

var $eI5EY = parcelRequire("eI5EY");
const $d1f3b12800e4309b$export$76c5f80c8d9bdb0e = ()=>({
        generalConfiguration: '/jira/settings/system/general-configuration',
        darkFeatures: '/secure/admin/SiteDarkFeatures!default.jspa',
        issueCollectors: '/secure/admin/ViewGlobalCollectors!default.jspa',
        globalAutomation: '/jira/settings/automation',
        // troubleshooting
        troubleshootingAuditLog: '/auditing/view',
        troubleshootingPluginViewer: '/plugins/servlet/depview/plugins',
        troubleshootingModulesViewer: '/plugins/servlet/depview/modules',
        troubleshootingSystemInfo: '/secure/admin/ViewSystemInfo.jspa',
        troubleshootingIntegrityChecker: '/secure/admin/IntegrityChecker!default.jspa',
        troubleshootingLoggingProfiling: '/secure/admin/ViewLogging.jspa',
        troubleshootingSchedulerDetails: '/secure/admin/SchedulerAdmin.jspa',
        troubleshootingPerformanceAndScale: '/jira/settings/system/performance/overview',
        // security
        securityProjectRoles: '/secure/project/ViewProjectRoles.jspa',
        securityGlobalPermissions: (0, $eI5EY.fg)('olympus-global-permissions-fe-modernisation') ? '/secure/admin/global-permissions' : '/secure/admin/GlobalPermissions!default.jspa',
        // user interface
        userInterfacesUserDefaults: '/secure/admin/ViewUserDefaultSettings.jspa',
        userInterfacesEditDefaultDashboard: '/secure/admin/EditDefaultDashboard!default.jspa',
        userInterfacesLookAndFeel: '/secure/admin/LookAndFeel!default.jspa',
        userInterfacesPasAdmin: '/plugins/servlet/pas/admin',
        userInterfacesSiteAdmin: '/jira/settings/system/ui/announcement-banner',
        // import and export
        importSectionBackupManager: '/secure/admin/CloudExport.jspa',
        importSectionExternalImport: '/secure/admin/ExternalImport1.jspa',
        importSectionExternalImportNew: '/jira/settings/system/external-import',
        importSectionCloudImport: '/secure/admin/CloudImport!start.jspa?source=import_cloud',
        importSectionServerImport: '/secure/admin/CloudImport!start.jspa?source=import_server',
        importSectionMigrateCloud: '/jira/settings/system/migration/home',
        // mail
        mailSectionGlobalMailSettings: '/secure/admin/GlobalMailSettings.jspa',
        mailSectionOutgoingMail: '/secure/admin/OutgoingMailServers.jspa',
        mailSectionIncomingMail: '/secure/admin/IncomingMailServers.jspa',
        mailSectionSendMail: '/secure/admin/SendBulkMail!default.jspa',
        // admin
        adminHelperPermissionHelper: '/secure/admin/PermissionHelperAdmin.jspa',
        adminHelperNotificationHelper: '/secure/admin/NotificationHelperAdmin.jspa',
        adminHelperEmailNotificationsLogHelper: '/jira/settings/system/notification-logs',
        // shared
        sharedSectionManageFilters: '/secure/admin/filters/ViewSharedFilters.jspa',
        sharedManageDashboards: '/secure/admin/dashboards/ViewSharedDashboards.jspa',
        // advanced
        advancedSectionAttachments: '/secure/admin/ViewAttachmentSettings.jspa',
        advancedSectionEvents: '/secure/admin/ListEventTypes.jspa',
        advancedSectionWebHooks: '/plugins/servlet/webhooks',
        advancedSectionServices: '/secure/admin/ViewServices!default.jspa',
        advancedLexoRankManagement: '/secure/GHLexoRankManage.jspa?decorator=admin'
    });

});

parcelRegister("bS2FN", function(module, exports) {

$parcel$export(module.exports, "matchPathname", () => $efb2bb2763c0ed39$export$b71b01274a8bb9ec);
$parcel$export(module.exports, "matchUrlPathname", () => $efb2bb2763c0ed39$export$6bfcf8859d3bc51c);
$parcel$export(module.exports, "matchPartialUrlPathname", () => $efb2bb2763c0ed39$export$9870a2fa97808ed7);
$parcel$export(module.exports, "matchUrlExact", () => $efb2bb2763c0ed39$export$422d2a799c6e30b8);
$parcel$export(module.exports, "matchUrlParams", () => $efb2bb2763c0ed39$export$63fdecce99465869);

var $046kq = parcelRequire("046kq");
// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const $efb2bb2763c0ed39$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
const $efb2bb2763c0ed39$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$efb2bb2763c0ed39$var$cleanPath(currentUrlPath) === $efb2bb2763c0ed39$var$cleanPath(itemUrlPath);
const $efb2bb2763c0ed39$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$efb2bb2763c0ed39$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
const $efb2bb2763c0ed39$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
const $efb2bb2763c0ed39$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$efb2bb2763c0ed39$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, (/*@__PURE__*/$parcel$interopDefault($046kq)))(currentLocation.query, itemLocation.query);
const $efb2bb2763c0ed39$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $efb2bb2763c0ed39$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);

});

parcelRegister("aWYQ8", function(module, exports) {

$parcel$export(module.exports, "ConnectMenu", () => $449294194ac94025$export$19d0925d424b864a);

var $eUqFw = parcelRequire("eUqFw");

var $9ui8T = parcelRequire("9ui8T");

var $fDNHa = parcelRequire("fDNHa");
const $449294194ac94025$export$19d0925d424b864a = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '' })=>{
    const filteredItems = (0, $9ui8T.useFilteredItems)(items || null, shouldFilter);
    if (filteredItems == null || !filteredItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, filteredItems.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDNHa.ConnectItem), {
            item: item,
            key: item.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        })));
};

});
parcelRegister("9ui8T", function(module, exports) {

$parcel$export(module.exports, "useFilteredItems", () => $e919628f42726628$export$79762159776e61da);

var $eUqFw = parcelRequire("eUqFw");

var $bgNoL = parcelRequire("bgNoL");
const $e919628f42726628$export$79762159776e61da = (items, shouldFilter = true)=>(0, $eUqFw.useMemo)(()=>{
        if (!shouldFilter) return items || [];
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"services" | "collectors" | "attachments" | "eventtypes" | "webhooks-admin" | "greenhopper-lexorank-manage" | "admin-helper-admin-section" | "advanced_section" | "dark_features" | ... 74 more ... | "com.codebarrel.addons.automation__cb-automation"'.
        return items?.filter((item)=>!(0, $bgNoL.staticLegacyIds).includes(item.id)) || [];
    }, [
        items,
        shouldFilter
    ]);

});

parcelRegister("fDNHa", function(module, exports) {

$parcel$export(module.exports, "ConnectItem", () => $689f0217773f024d$export$8bb4bcea44a3c9ea);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iFXD5 = parcelRequire("iFXD5");

var $7eyVf = parcelRequire("7eyVf");

var $aqZcy = parcelRequire("aqZcy");

var $5RTd0 = parcelRequire("5RTd0");

var $422mK = parcelRequire("422mK");

var $1UelU = parcelRequire("1UelU");

var $aDEKA = parcelRequire("aDEKA");

var $9kVcv = parcelRequire("9kVcv");

var $2DHQu = parcelRequire("2DHQu");

var $bS2FN = parcelRequire("bS2FN");
const $689f0217773f024d$export$8bb4bcea44a3c9ea = ({ index: index, item: item, overrides: overrides, showIcons: showIcons, submenuId: submenuId = '', isNested: isNested = false })=>{
    const { addNew: addNew } = (0, $422mK.useConnectItemClickHistory)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const BackMenuItem = {
        ...overrides.BackMenuItem,
        onClick: (ev)=>{
            // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
            // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
            // This is to satisfy a requirement for open expandable menus to remain open
            // when users return to the project settings menu
            if (submenuId != null) {
                const cookieData = (0, $aqZcy.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                let parsedCookieData = null;
                try {
                    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                    parsedCookieData = JSON.parse(cookieData);
                } catch  {
                    // Rather than throw an error - just set the default state
                    parsedCookieData = {
                        submenuActive: false,
                        expanded: false
                    };
                }
                const newCookieData = {
                    ...parsedCookieData,
                    submenuActive: false
                };
                (0, $5RTd0.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newCookieData));
            }
            // Setting navigateOnBackMenuItemClick to true will allow backToProject link to take user to the default project page
            if (overrides?.navigateOnBackMenuItemClick !== true) ev.preventDefault();
            overrides.BackMenuItem?.onClick?.(ev);
        }
    };
    const icon = (0, $eUqFw.useMemo)(()=>{
        if (showIcons !== true) return null;
        return item.iconUrl != null && item.iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($689f0217773f024d$var$ConnectIcon, {
            src: item.iconUrl,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), {
            label: ""
        });
    }, [
        showIcons,
        item.iconUrl
    ]);
    const onItemClick = (0, $eUqFw.useCallback)((event)=>{
        // We need to check we're clicking an item inside a nested menu for a connect item.
        // if we are deep linking to a nested connect item -> we need to maintain the hiding of nav-modules
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick && isNested) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        item.url != null && addNew(item.url);
    }, [
        addNew,
        isNested,
        item.url,
        overrides
    ]);
    const onNestedMenuItemClick = (0, $eUqFw.useCallback)((event)=>{
        // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
        // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
        // This is to satisfy a requirement for open expandable menus to remain open
        // when users return to the project settings menu
        if (submenuId != null) {
            const cookieData = (0, $aqZcy.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
            if (cookieData != null) (0, $5RTd0.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify({
                ...JSON.parse(cookieData),
                submenuActive: true
            }));
        }
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        return ()=>null;
    }, [
        overrides,
        submenuId
    ]);
    if (item.section === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: item.name,
        hasSeparator: Boolean(index)
    }, (item.items || []).map((si, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($689f0217773f024d$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            overrides: {
                ...overrides,
                BackMenuItem: BackMenuItem
            },
            index: idx,
            isNested: isNested
        })));
    if (item.items) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DHQu.NestingMenuItem), {
        id: item.id,
        analytics: {
            itemId: item.id
        },
        iconBefore: icon,
        overrides: {
            ...overrides,
            BackMenuItem: BackMenuItem
        },
        title: item.name,
        onClick: onNestedMenuItemClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aDEKA.NavigationContentWrapper), {
        submenuActive: true,
        nestedMenuOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, item.name), (item.items || []).map((si, nestIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($689f0217773f024d$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            index: nestIndex,
            overrides: {
                ...overrides,
                BackMenuItem: {
                    href: item.url,
                    title: si.name,
                    onClick: (ev)=>ev.preventDefault()
                }
            },
            isNested: true
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: item.id
        },
        selectedOn: (0, $bS2FN.matchUrlExact)(),
        iconBefore: icon,
        href: item.url,
        legacyClassName: item.styleClass,
        onClick: onItemClick,
        ref: /*#__PURE__*/ (0, $eUqFw.createRef)()
    }, item.name);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $689f0217773f024d$var$ConnectIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5RTd0", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $c190ea8c356dcf3d$export$93509ff9a62ee022);

var $fT6gI = parcelRequire("fT6gI");
const $c190ea8c356dcf3d$export$93509ff9a62ee022 = (key, value, attributes)=>{
    (0, $fT6gI.setStrictlyNecessaryCookie)(key, value, attributes);
};

});
parcelRegister("fT6gI", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $b910dae8829db4f5$export$93509ff9a62ee022);

var $M2DFp = parcelRequire("M2DFp");

var $XHGTv = parcelRequire("XHGTv");

var $5mY09 = parcelRequire("5mY09");

var $8nVWJ = parcelRequire("8nVWJ");
const $b910dae8829db4f5$export$93509ff9a62ee022 = (key, value, attributes)=>{
    try {
        if ((0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls')) (0, $5mY09.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $8nVWJ.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

});


parcelRegister("422mK", function(module, exports) {

$parcel$export(module.exports, "useConnectItemClickHistory", () => $e1e0c0027f44f3f6$export$c251e3fda1cce4a3);

var $eUqFw = parcelRequire("eUqFw");
// A single instance for the entire SPA session
const $e1e0c0027f44f3f6$var$history = {
    unique: []
};
const $e1e0c0027f44f3f6$export$c251e3fda1cce4a3 = ()=>{
    const addNew = (0, $eUqFw.useCallback)((historyItem)=>{
        // Here we want to store only unique items. For example, if the add-on updates Jira hash
        // and user clicks the same navigation link we consider it as a unique navigation action
        // so we can use this info later on to rerender the iframe
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.location.href.endsWith(historyItem) === false) // @ts-expect-error - TS2339 - Property 'push' does not exist on type 'readonly []'.
        $e1e0c0027f44f3f6$var$history.unique.push(historyItem);
    }, []);
    return (0, $eUqFw.useMemo)(()=>({
            history: $e1e0c0027f44f3f6$var$history,
            addNew: addNew
        }), [
        addNew
    ]);
};
const $e1e0c0027f44f3f6$export$ef04cd58bebb0345 = ()=>{
    // @ts-expect-error TS2540: Cannot assign to 'length' because it is a read-only property.
    $e1e0c0027f44f3f6$var$history.unique.length = 0;
};

});

parcelRegister("aDEKA", function(module, exports) {

$parcel$export(module.exports, "NavigationHeaderWrapper", () => $94d555cec3b0ee42$export$bae9b35e967353d5);
$parcel$export(module.exports, "NavigationExpandableContentWrapper", () => $94d555cec3b0ee42$export$4e88508e6904469e);
$parcel$export(module.exports, "NavigationContentWrapper", () => $94d555cec3b0ee42$export$e7d691a5a9258e1b);
$parcel$export(module.exports, "NextGenIssueTypesWrapper", () => $94d555cec3b0ee42$export$f094f7aad76e4268);
$parcel$export(module.exports, "ExpandableProjectSettingsWrapper", () => $94d555cec3b0ee42$export$e38bb288d890ec2f);
$parcel$export(module.exports, "ShortCutsAndAppsWrapper", () => $94d555cec3b0ee42$export$337add4342ee7986);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");
const $94d555cec3b0ee42$export$bae9b35e967353d5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$NavigationHeaderWrapperContainer, null, props.children);
const $94d555cec3b0ee42$export$4e88508e6904469e = (props)=>{
    const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$NavigationExpandableContentWrapperContainer, {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, children);
};
const $94d555cec3b0ee42$export$e7d691a5a9258e1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$NavigationContentWrapperContainer, {
        // @ts-expect-error - TS2322 - Type '{ children: ReactNode; navModuleLabelsHidden: boolean | undefined; nestedAppOpen: boolean | undefined; context: string | undefined; submenuActive: boolean | undefined; nestedMenuOpen: boolean | undefined; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { ...; }, any>, any, any>> & Readonly<...> & Readonly<...>'.
        navModuleLabelsHidden: props.navModuleLabelsHidden,
        nestedAppOpen: props.nestedAppOpen,
        context: props.context,
        submenuActive: props.submenuActive,
        nestedMenuOpen: props.nestedMenuOpen,
        "data-component-selector": "NavigationContentWrapperContainer"
    }, props.children);
const $94d555cec3b0ee42$export$f094f7aad76e4268 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$NextGenIssueTypesWrapperContainer, null, props.children);
const $94d555cec3b0ee42$export$e38bb288d890ec2f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$ExpandableProjectContainer, null, props.children);
const $94d555cec3b0ee42$export$337add4342ee7986 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$ShortCutsAndAppsContainer, null, props.children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94d555cec3b0ee42$var$NavigationHeaderWrapperContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _1s541012 _1lfu1012",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$NavigationExpandableContentWrapperContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ykp9lh": (0, $9t7rW.default)(__cmplp.nestedAppOpen ? 'auto' : '100%'),
            "--_1qrlsbv": (0, $9t7rW.default)(Math.round((0, $c9TLT.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive && "_4t3i1qw7",
            __cmplp.submenuActive ? "_bq2uyjp0 _1n80yjp0 _di7gyjp0 _1lozyjp0" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$NavigationContentWrapperContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6w8gix": (0, $9t7rW.default)(__cmplp.nestedMenuOpen ? 0 : 7.5 * (0, $c9TLT.gridSize), "px"),
            "--_1qrlsbv": (0, $9t7rW.default)(Math.round((0, $c9TLT.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive ? "_4t3iu4z3" : "_4t3i1wug",
            __cmplp.submenuActive ? "_vnu91tcg _19iy1tcg _t6kl1tcg _shi31tcg" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
            __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$NextGenIssueTypesWrapperContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp1txs _l9o61txs _f6zi1txs",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$ExpandableProjectContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wtppxbi _df5vpxbi",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$ShortCutsAndAppsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _14tk72c6 _t3zc183y _1so4jjyb _1thc1skh _a6avqslr _dnyv1skh",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2DHQu", function(module, exports) {

$parcel$export(module.exports, "NestingMenuItem", () => $caee9921c40abec1$export$4c594f24f8e4128a);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $2vzCR = parcelRequire("2vzCR");

var $fyp42 = parcelRequire("fyp42");

var $9iAqW = parcelRequire("9iAqW");

var $4C6RK = parcelRequire("4C6RK");

var $1UelU = parcelRequire("1UelU");

var $k4ysj = parcelRequire("k4ysj");

var $cFBmm = parcelRequire("cFBmm");

var $8n4Bi = parcelRequire("8n4Bi");

var $5vmRt = parcelRequire("5vmRt");

var $hLkCn = parcelRequire("hLkCn");
const $caee9921c40abec1$var$customCssFn = (0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStateAndStyles)=>{
    const activeColor = typeof currentStateAndStyles['&:active'] === 'object' ? `${currentStateAndStyles['&:active'].color} !important` : 'inherit';
    const baseColor = typeof currentStateAndStyles['&:hover'] === 'object' ? currentStateAndStyles['&:hover'].color : 'inherit';
    const newStyle = {
        ...(0, $cFBmm.cssFn)(currentStateAndStyles),
        /* fixes CSS leaking from the monolith */ '&:visited, &:focus, &:active': {
            textDecoration: 'inherit',
            outline: 0
        },
        /* fixes CSS leaking from the monolith */ '&:active': {
            color: activeColor
        },
        /* fixes CSS leaking from the monolith */ '&:visited, &:focus': {
            color: baseColor
        },
        '& [data-item-title]': {
            color: baseColor
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStateAndStyles, newStyle);
});
const $caee9921c40abec1$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", props, props.children);
const $caee9921c40abec1$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const backButtonCssFn = (0, $k4ysj.generateBackButtonCssFn)(theme);
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $eUqFw.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $eUqFw.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fyp42))), {
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $hLkCn.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            cssFn: backButtonCssFn
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backButtonCssFn,
        backTitle
    ]);
    const renderCustomItem = (0, $eUqFw.useCallback)(({ children: itemTitle, onClick: onClick, cssFn: customItemCssFn, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9iAqW.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $caee9921c40abec1$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            cssFn: customItemCssFn ? (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
                customItemCssFn,
                $caee9921c40abec1$var$customCssFn
            ]) : $caee9921c40abec1$var$customCssFn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4C6RK.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});
parcelRegister("k4ysj", function(module, exports) {

$parcel$export(module.exports, "generateBackButtonCssFn", () => $3713137157573d1a$export$56644251c3f2ea82);
const $3713137157573d1a$export$56644251c3f2ea82 = (theme)=>()=>{
        if (theme?.navigation) {
            const { icon: icon } = theme.navigation;
            return {
                '& [data-item-elem-before], &:active span[data-item-elem-before]': {
                    color: icon?.secondary?.color?.active ?? undefined
                }
            };
        }
        return {};
    };

});

parcelRegister("cFBmm", function(module, exports) {

$parcel$export(module.exports, "cssFn", () => $3a6f1f8fdf334108$export$d722961e96b459c5);

var $2vzCR = parcelRequire("2vzCR");

var $c9TLT = parcelRequire("c9TLT");

var $5vmRt = parcelRequire("5vmRt");
const $3a6f1f8fdf334108$export$d722961e96b459c5 = (0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
    const newStyle = {
        '[data-item-elem-after] [data-right-arrow]': {
            display: 'none'
        },
        '&:hover [data-item-elem-after]': {
            '& > :not([data-right-arrow])': {
                display: 'none'
            },
            '& [data-right-arrow]': {
                display: 'flex'
            }
        },
        height: `${(0, $c9TLT.gridSize) * 5.5}px`
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStyles, newStyle);
});

});

parcelRegister("hLkCn", function(module, exports) {

$parcel$export(module.exports, "isNormalClick", () => $82cbad75889ad869$export$729f3684d5c2b9b9);
const $82cbad75889ad869$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);

});




parcelRegister("edsEA", function(module, exports) {

$parcel$export(module.exports, "SECTION_ID", () => $c6ce6d648439ff85$export$501955bd67991a25);
const $c6ce6d648439ff85$export$501955bd67991a25 = {
    MIGRATE_TO_CLOUD_SITE: 'migrate-to-cloud-site',
    PERFORMANCE_AND_SCALE: 'performance-and-scale'
};

});

parcelRegister("cvu76", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $a1011f522d4f3baa$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", () => $a1011f522d4f3baa$export$f601efaceb0636f4);

var $eUqFw = parcelRequire("eUqFw");

var $2z5XU = parcelRequire("2z5XU");

var $kIUmN = parcelRequire("kIUmN");

var $1ykEC = parcelRequire("1ykEC");

var $gd0Sp = parcelRequire("gd0Sp");

var $9Zvye = parcelRequire("9Zvye");
const $a1011f522d4f3baa$export$4a39035bacc4ed76 = (0, $kIUmN.withThrowOnError)(()=>{
    const { data: data, loading: loading, error: error } = (0, $2z5XU.useNavigationGlobalResource)();
    const { isDevMode: isDevMode, isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const extractedData = (0, $eUqFw.useMemo)(()=>data && (0, $9Zvye.extractData)(data, isDevMode, isAdmin, isSiteAdmin), [
        data,
        isDevMode,
        isAdmin,
        isSiteAdmin
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
});
const $a1011f522d4f3baa$export$f601efaceb0636f4 = (0, $kIUmN.withThrowOnError)((0, $1ykEC.useGlobalSettingsSystemConnectItems));

});
parcelRegister("kIUmN", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $f76cf1e1bf710aa4$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $asu8X = parcelRequire("asu8X");
const $f76cf1e1bf710aa4$var$isDataEmpty = (data)=>data == null;
function $f76cf1e1bf710aa4$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $asu8X.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $f76cf1e1bf710aa4$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});

parcelRegister("9Zvye", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $c73123b712e8456e$export$9df5fa0a366163d2);

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");

var $lDq4g = parcelRequire("lDq4g");
const $c73123b712e8456e$export$9df5fa0a366163d2 = (data, isDevMode, isAdmin, isSiteAdmin)=>({
        hasGeneralConfiguration: isAdmin,
        hasDarkFeatures: (0, $lDq4g.hasItemInSidebar)(data, 'dark_features'),
        hasTroubleshootingAndSupportSection: isAdmin,
        hasViewAuditing: isAdmin,
        hasPluginViewer: isDevMode && isAdmin,
        hasModulesViewer: isDevMode && isAdmin,
        hasSystemInfo: (0, $lDq4g.hasItemInSidebar)(data, 'system_info'),
        hasIntegrityChecker: (0, $lDq4g.hasItemInSidebar)(data, 'integrity_checker'),
        hasLoggingProfiling: (0, $lDq4g.hasItemInSidebar)(data, 'logging_profiling'),
        hasSchedulerDetails: (0, $lDq4g.hasItemInSidebar)(data, 'scheduler_details'),
        hasSecuritySection: isAdmin,
        hasProjectRoles: isAdmin,
        hasGlobalPermissions: isAdmin,
        hasCollectors: isAdmin,
        hasUserInterfaceSection: isAdmin,
        hasUserDefaults: isAdmin,
        hasEditDefaultDashboard: isAdmin,
        hasLookAndFeel: isAdmin,
        hasPasAdmin: (0, $lDq4g.hasItemInSidebar)(data, 'com.atlassian.pas:pas-admin-link-jira'),
        hasImportExportSection: isAdmin,
        hasBackupManager: isAdmin,
        hasExternalImport: isAdmin,
        hasRestoreSystem: (0, $lDq4g.hasItemInSidebar)(data, 'vertigo_import'),
        hasCloudImport: (0, $lDq4g.hasItemInSidebar)(data, 'vertigo_import_jira_cloud'),
        hasServerImport: (0, $lDq4g.hasItemInSidebar)(data, 'vertigo_import_jira_server'),
        hasC2CMigration: isSiteAdmin && (0, $1ybV0.ff)('jira-system-settings-cloud-to-cloud-migration') && !(0, $dfBCt.isFedRamp)(),
        hasMailSection: isAdmin,
        hasGlobalMailSettings: isAdmin,
        hasOutgoingMail: isAdmin,
        hasIncomingMail: isAdmin,
        hasSendMail: isAdmin,
        hasAdminHelperSection: isAdmin,
        hasPermissionHelper: isAdmin,
        hasNotificationHelper: isAdmin && !(0, $1ybV0.ff)('sea-1973-notifications-hub'),
        hasSharedSection: isAdmin,
        hasManageDashboards: isAdmin,
        hasManageFilters: isAdmin,
        hasEmailNotificationsLogHelper: (0, $1ybV0.ff)('platform.jlove-pulsar.jlovep-423-jsw-notification-logs-ui'),
        // advanced
        hasAdvancedSection: isAdmin,
        hasAttachments: isAdmin,
        hasEvents: isAdmin,
        hasWebHooks: isAdmin,
        hasServices: isAdmin,
        hasLexoRankManagement: (0, $lDq4g.hasItemInSidebar)(data, 'greenhopper-lexorank-manage')
    });

});


parcelRegister("hrMrK", function(module, exports) {

$parcel$export(module.exports, "AdminHelperSection", () => $3ec3bce980ffe719$export$4855b2d78f0d666a);

var $eUqFw = parcelRequire("eUqFw");

var $55pTl = parcelRequire("55pTl");

var $ffiyv = parcelRequire("ffiyv");

var $ltfxy = parcelRequire("ltfxy");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $iaHqR = parcelRequire("iaHqR");

var $bS2FN = parcelRequire("bS2FN");

var $cvu76 = parcelRequire("cvu76");

var $3aA4Y = parcelRequire("3aA4Y");
const $3ec3bce980ffe719$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY = 'blocking-invitations-log-spotlight';
const $3ec3bce980ffe719$export$4855b2d78f0d666a = ()=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $3aA4Y.default).adminHelper)
    }, features.hasPermissionHelper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'permission-helper'
        },
        href: navigationPath.adminHelperPermissionHelper,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $3aA4Y.default).permissionHelper)), features.hasNotificationHelper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'notification-helper'
        },
        href: navigationPath.adminHelperNotificationHelper,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $3aA4Y.default).notificationHelper)), features.hasEmailNotificationsLogHelper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: $3ec3bce980ffe719$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'email-notifications-log'
        },
        href: navigationPath.adminHelperEmailNotificationsLogHelper,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3ec3bce980ffe719$var$emailNotificationsLogContainerStyles
    }, (0, $1ybV0.ff)('platform.jlove-pulsar.jlovep-1538-notification-email-log-filters_4p0s1') ? formatMessage((0, $3aA4Y.default).adminEmailAuditNotificationsLog) : formatMessage((0, $3aA4Y.default).emailNotificationsLog), !(0, $1ybV0.ff)('platform.jlove-pulsar.jlovep-1472-remove-unblock-user-invites-new-lozenge_7ig5k') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "new"
    }, formatMessage((0, $3aA4Y.default).newLozenge)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
        engagementId: $3ec3bce980ffe719$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
    })));
};
const $3ec3bce980ffe719$var$emailNotificationsLogContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'space-between'
});

});
parcelRegister("3aA4Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $06605f0f5bf60fbb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $06605f0f5bf60fbb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    adminHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-helper",
        "defaultMessage": "Admin helper"
    },
    permissionHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.permission-helper",
        "defaultMessage": "Permission helper"
    },
    notificationHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.notification-helper",
        "defaultMessage": "Notification helper"
    },
    emailNotificationsLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.email-notifications-log",
        "defaultMessage": "Unblock user invites"
    },
    adminEmailAuditNotificationsLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-email-audit-notifications-log",
        "defaultMessage": "Admin email audit"
    },
    newLozenge: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.new-lozenge",
        "defaultMessage": "New"
    }
});

});


parcelRegister("gS9Pi", function(module, exports) {

$parcel$export(module.exports, "AdvancedSection", () => $03a8f2bdc5bb78e2$export$32bea920eaad7efb);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $iaHqR = parcelRequire("iaHqR");

var $bS2FN = parcelRequire("bS2FN");

var $cvu76 = parcelRequire("cvu76");

var $ks7eZ = parcelRequire("ks7eZ");
const $03a8f2bdc5bb78e2$export$32bea920eaad7efb = ()=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $ks7eZ.default).advanced)
    }, features.hasAttachments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'attachments'
        },
        href: navigationPath.advancedSectionAttachments,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $ks7eZ.default).attachments)), features.hasEvents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'events'
        },
        href: navigationPath.advancedSectionEvents,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $ks7eZ.default).events)), features.hasWebHooks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'webhooks'
        },
        href: navigationPath.advancedSectionWebHooks,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $ks7eZ.default).webhooks)), features.hasLexoRankManagement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'lexorank-management'
        },
        href: navigationPath.advancedLexoRankManagement,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $ks7eZ.default).lexorankManagement)));
};

});
parcelRegister("ks7eZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0af7d60d7973990$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d0af7d60d7973990$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    advanced: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.advanced",
        "defaultMessage": "Advanced"
    },
    attachments: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.attachments",
        "defaultMessage": "Attachments"
    },
    events: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.events",
        "defaultMessage": "Events"
    },
    webhooks: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.webhooks",
        "defaultMessage": "WebHooks"
    },
    lexorankManagement: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.lexorank-management",
        "defaultMessage": "LexoRank management"
    }
});

});


parcelRegister("4VoIp", function(module, exports) {

$parcel$export(module.exports, "AutomationSection", () => $7c3e343d2e37ccc1$export$5fa01e4d25d8e6ec);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");

var $exb0h = parcelRequire("exb0h");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $iaHqR = parcelRequire("iaHqR");

var $BRrlJ = parcelRequire("BRrlJ");
const $7c3e343d2e37ccc1$export$5fa01e4d25d8e6ec = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $BRrlJ.default).automationGroup)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        href: navigationPath.globalAutomation,
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES_SETTINGS_AUTOMATION)
        ]
    }, formatMessage((0, $BRrlJ.default).globalAutomation)));
};

});
parcelRegister("BRrlJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4343ac41ac6d948d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4343ac41ac6d948d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    automationGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.automation.automation-group",
        "defaultMessage": "Automation"
    },
    globalAutomation: {
        "id": "spa-apps-sidebar-global-settings-system.menu.automation.global-automation",
        "defaultMessage": "Global automation"
    }
});

});


parcelRegister("ii4v1", function(module, exports) {

$parcel$export(module.exports, "ImportExportSection", () => $3aa2c3bcc356e542$export$2e4cb1dc5b398447);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $iaHqR = parcelRequire("iaHqR");

var $b7Flp = parcelRequire("b7Flp");

var $bS2FN = parcelRequire("bS2FN");

var $gd0Sp = parcelRequire("gd0Sp");

var $edsEA = parcelRequire("edsEA");

var $cvu76 = parcelRequire("cvu76");

var $dAlSQ = parcelRequire("dAlSQ");

var $dcV52 = parcelRequire("dcV52");
const $3aa2c3bcc356e542$export$2e4cb1dc5b398447 = ({ stack: stack })=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isSiteAdmin: isSiteAdmin, isAdmin: isAdmin, licensedProducts: licensedProducts } = (0, $gd0Sp.useTenantContext)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const hasSupportedLicense = licensedProducts[(0, $7ZZxN.projectTypeToCanonicalId)((0, $7ZZxN.SOFTWARE_PROJECT))] || licensedProducts[(0, $7ZZxN.projectTypeToCanonicalId)((0, $7ZZxN.CORE_PROJECT))];
    const showNewExternalImport = hasSupportedLicense && (isSiteAdmin || !isAdmin || (0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $dAlSQ.default).importExportGroup)
    }, features.hasBackupManager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'cloud-export'
        },
        href: navigationPath.importSectionBackupManager,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $dAlSQ.default).backupManager)), features.hasExternalImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'external-import'
        },
        href: showNewExternalImport ? navigationPath.importSectionExternalImportNew : navigationPath.importSectionExternalImport,
        selectedOn: (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlExact)()(currentLocation, itemLocation) || showNewExternalImport && currentLocation.pathname.includes(navigationPath.importSectionExternalImport)
    }, formatMessage((0, $dAlSQ.default).externalImport)), features.hasCloudImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'cloud-import'
        },
        href: navigationPath.importSectionCloudImport,
        selectedOn: (0, $bS2FN.matchUrlExact)()
    }, formatMessage((0, $dAlSQ.default).importJiraCloud)), features.hasServerImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'server-import'
        },
        href: navigationPath.importSectionServerImport,
        selectedOn: (0, $bS2FN.matchUrlExact)()
    }, formatMessage((0, $dAlSQ.default).importJiraServer)), (0, $b7Flp.shouldRenderNesting)(features.hasC2CMigration, stack, (0, $edsEA.SECTION_ID).MIGRATE_TO_CLOUD_SITE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dcV52.MigrateCloudSiteMenuItem), null));
};

});
parcelRegister("b7Flp", function(module, exports) {

$parcel$export(module.exports, "shouldRenderNesting", () => $29014c8ea6c9a7cc$export$a35baff1c4efd3da);
const $29014c8ea6c9a7cc$export$a35baff1c4efd3da = (condition, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
stack, nestingId)=>condition === true || Boolean(stack && stack.includes(nestingId));

});

parcelRegister("dAlSQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $41e1809db484a615$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $41e1809db484a615$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    importExportGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-export-group",
        "defaultMessage": "Import and export"
    },
    backupManager: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.backup-manager",
        "defaultMessage": "Backup manager"
    },
    externalImport: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.external-import",
        "defaultMessage": "External System Import"
    },
    restoreSystem: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.restore-system",
        "defaultMessage": "Restore system"
    },
    importJiraCloud: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-cloud",
        "defaultMessage": "Import Jira Cloud"
    },
    importJiraServer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-server",
        "defaultMessage": "Import Jira Server"
    }
});

});

parcelRegister("dcV52", function(module, exports) {

$parcel$export(module.exports, "MigrateCloudSiteMenuItem", () => $cf5c12f4e57bb341$export$48e579c481d74aac);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2DHQu = parcelRequire("2DHQu");

var $iaHqR = parcelRequire("iaHqR");

var $edsEA = parcelRequire("edsEA");

var $bvI0E = parcelRequire("bvI0E");

var $bs5KZ = parcelRequire("bs5KZ");

var $48t98 = parcelRequire("48t98");
const $cf5c12f4e57bb341$export$48e579c481d74aac = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { release: release } = (0, $bvI0E.useReleaseVersion)();
    const BackMenuItem = {
        href: '/jira/settings/system/general-configuration',
        title: formatMessage((0, $bs5KZ.messages).itemBack)
    };
    const isBeta = (0, $1ybV0.ff)('jira-frontend-c2c-migrations-ga-release') ? release === 'BETA' : true;
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DHQu.NestingMenuItem), {
        analytics: {
            itemId: 'migrate-to-cloud-site'
        },
        href: navigationPath.importSectionMigrateCloud,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $bs5KZ.messages).migration), ' ', isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new"
        }, formatMessage((0, $bs5KZ.messages).migrationBetaLabel))),
        overrides: {
            BackMenuItem: BackMenuItem
        },
        id: (0, $edsEA.SECTION_ID).MIGRATE_TO_CLOUD_SITE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48t98.MigrationsMenu), null));
};

});
parcelRegister("bvI0E", function(module, exports) {

$parcel$export(module.exports, "useReleaseVersion", () => $e879e74c96d015a5$export$4ea0c46c431d5d34);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $e879e74c96d015a5$export$1a5772dc2221d2a5 = ()=>(0, $lRmyA.performGetRequest)('/rest/migration/c2c_rollout_phase');
const $e879e74c96d015a5$export$4ea0c46c431d5d34 = ()=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [release, setRelease] = (0, $eUqFw.useState)('GA');
    const [error, setError] = (0, $eUqFw.useState)();
    const fetch = async ()=>{
        try {
            setLoading(true);
            setError(undefined);
            const data = await $e879e74c96d015a5$export$1a5772dc2221d2a5();
            setRelease(data.release);
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (apiError) {
            setLoading(false);
            setError(apiError);
            (0, $guiFP.default)({
                error: apiError,
                meta: {
                    id: 'useReleaseVersion',
                    packageName: 'jiraNavigationAppsSidebarGlobalSettingsSystem',
                    teamName: 'navigation'
                }
            });
        }
    };
    (0, $eUqFw.useEffect)(()=>{
        fetch();
    }, []);
    return {
        loading: loading,
        release: release,
        error: error
    };
};

});

parcelRegister("bs5KZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $08fa4fd7be2d477d$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $08fa4fd7be2d477d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    migration: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migration",
        "defaultMessage": "Migrate cloud site"
    },
    migrationBetaLabel: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migration-beta-label",
        "defaultMessage": "Beta"
    },
    itemBack: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.item-back",
        "defaultMessage": "Back to system"
    }
});

});

parcelRegister("48t98", function(module, exports) {

$parcel$export(module.exports, "MigrationsMenu", () => $9d93503f54347e9a$export$9a2d2cb9bbe36e75);

var $eUqFw = parcelRequire("eUqFw");

var $23NQ5 = parcelRequire("23NQ5");

var $7eyVf = parcelRequire("7eyVf");

var $dfBCt = parcelRequire("dfBCt");

var $cswzZ = parcelRequire("cswzZ");

var $bKxX9 = parcelRequire("bKxX9");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $9kVcv = parcelRequire("9kVcv");

var $bS2FN = parcelRequire("bS2FN");

var $dWLk9 = parcelRequire("dWLk9");

var $7K0sS = parcelRequire("7K0sS");
const $9d93503f54347e9a$export$9a2d2cb9bbe36e75 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const [{ data: data }, { fetchCohortDetails: fetchCohortDetails }] = (0, $cswzZ.useCohortDetails)();
    const baseMigrateCloudUrl = '/jira/settings/system/migration';
    const isCohort4Enabled = (0, $bKxX9.ff)('change-management-cohort-4-ff_4bpld');
    (0, $eUqFw.useEffect)(()=>{
        fetchCohortDetails(cloudId);
    }, [
        fetchCohortDetails,
        cloudId
    ]);
    if ((0, $dfBCt.isFedRamp)()) return;
    if (data?.isCohortEnabled && (data?.cohortType === 'NEVER_USED_C2C_JIRA' || data?.cohortType === 'NOT_USED_C2C_JIRA_IN_3_MONTHS' || data?.hasOptedIn || data?.status === 'IN_PROGRESS' || data?.status === 'FAILED' || isCohort4Enabled)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'migration-home'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseMigrateCloudUrl}/home`
    }, formatMessage((0, $7K0sS.messages).title));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $7K0sS.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'migration-home'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseMigrateCloudUrl}/home`
    }, formatMessage((0, $7K0sS.messages).migrationOverview)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'plan-your-migration'
        },
        href: "https://support.atlassian.com/migration/docs/cloud-to-cloud-migration/",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            size: "small",
            label: ""
        }),
        target: "_blank"
    }, formatMessage((0, $7K0sS.messages).planYourMigration)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'manage-migrations'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseMigrateCloudUrl}/dashboard`
    }, formatMessage((0, $7K0sS.messages).manageMigrations))));
};

});
parcelRegister("cswzZ", function(module, exports) {

$parcel$export(module.exports, "useCohortDetails", () => $2b04160c8585f0d7$export$79c60a355eee7756);

var $WBLbN = parcelRequire("WBLbN");

var $8iS2S = parcelRequire("8iS2S");

var $dvjB8 = parcelRequire("dvjB8");
const $2b04160c8585f0d7$var$Store = (0, $WBLbN.createStore)({
    initialState: (0, $dvjB8.COHORT_DETAILS_DEFAULT_STATE),
    actions: $8iS2S.default,
    name: 'Migrations - Cohort details'
});
const $2b04160c8585f0d7$export$79c60a355eee7756 = (0, $WBLbN.createHook)($2b04160c8585f0d7$var$Store);

});
parcelRegister("8iS2S", function(module, exports) {

$parcel$export(module.exports, "default", () => $c800949abf1df23a$export$2e2bcd8739ae039);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $dvjB8 = parcelRequire("dvjB8");

var $6UAFb = parcelRequire("6UAFb");
const $c800949abf1df23a$export$343d10549fb4d411 = async (cloudId)=>{
    const fetchUrl = (0, $6UAFb.getCohortStatusUrl)(cloudId);
    return (0, $lRmyA.performGetRequest)(fetchUrl).catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'fetchCohortDetails',
                packageName: 'jiraC2CMigrationsCommonUtils',
                teamName: 'jira-c2c-migration'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};
const $c800949abf1df23a$export$c9cf692e1e990743 = (cloudId)=>{
    // @ts-expect-error - TS2322 - Type '({ setState }: StoreActionApi<MigrationDetailsState>) => Promise<{ data: MigrationAPIData; siteContainerSelections: readonly ["USERS"] | readonly [...]; } | undefined>' is not assignable to type 'Action<MigrationDetailsState, void, void | Promise<void>>'.
    return async ({ setState: setState, getState: getState })=>{
        const showOptInButton = (0, $6UAFb.getOptInModalStatus)();
        setState({
            showOptInButton: showOptInButton
        });
        if (getState().data || getState().loading) return undefined;
        try {
            setState({
                loading: true
            });
            const data = await $c800949abf1df23a$export$343d10549fb4d411(cloudId);
            const derivedOptInButtonStatus = !data.hasOptedIn && data.status !== 'NEVER' || showOptInButton;
            (0, $6UAFb.setOptInModalStatus)(derivedOptInButtonStatus);
            setState({
                data: data,
                loading: false,
                showOptInButton: derivedOptInButtonStatus
            });
            return {
                data: data
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                error: error,
                loading: false
            });
            return undefined;
        }
    };
};
const $c800949abf1df23a$export$e64b646bfdf4078e = (showOptInButton)=>({ setState: setState })=>{
        (0, $6UAFb.setOptInModalStatus)(showOptInButton);
        setState({
            showOptInButton: showOptInButton
        });
    };
const $c800949abf1df23a$export$aad8462122ac592b = ()=>({ setState: setState })=>{
        setState({
            ...(0, $dvjB8.COHORT_DETAILS_DEFAULT_STATE),
            data: undefined,
            error: undefined
        });
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c800949abf1df23a$export$2e2bcd8739ae039 = {
    fetchCohortDetails: $c800949abf1df23a$export$c9cf692e1e990743,
    updateShowOptInButton: $c800949abf1df23a$export$e64b646bfdf4078e,
    reset: $c800949abf1df23a$export$aad8462122ac592b
};

});
parcelRegister("dvjB8", function(module, exports) {

$parcel$export(module.exports, "COHORT_DETAILS_DEFAULT_STATE", () => $5829510d72ed2015$export$7108825eea599cbc);
$parcel$export(module.exports, "SESSION_STORAGE_KEY", () => $5829510d72ed2015$export$5200514808277ba7);
const $5829510d72ed2015$export$7108825eea599cbc = {
    loading: false,
    showOptInButton: false
};
const $5829510d72ed2015$export$5200514808277ba7 = 'C2C.MIGRATION.ADMIN.HUB.OPT.IN.BUTTON';

});

parcelRegister("6UAFb", function(module, exports) {

$parcel$export(module.exports, "getOptInModalStatus", () => $7e8dbe6bbb8ebc19$export$e69da0941df3caa9);
$parcel$export(module.exports, "setOptInModalStatus", () => $7e8dbe6bbb8ebc19$export$687080e399c5c65f);
$parcel$export(module.exports, "getCohortStatusUrl", () => $7e8dbe6bbb8ebc19$export$66a62d4e6369f93e);

var $dvjB8 = parcelRequire("dvjB8");
const $7e8dbe6bbb8ebc19$export$e69da0941df3caa9 = ()=>JSON.parse(sessionStorage.getItem((0, $dvjB8.SESSION_STORAGE_KEY)) || 'false');
const $7e8dbe6bbb8ebc19$export$687080e399c5c65f = (value)=>sessionStorage.setItem((0, $dvjB8.SESSION_STORAGE_KEY), String(value));
const $7e8dbe6bbb8ebc19$export$66a62d4e6369f93e = (cloudId)=>`/gateway/api/migrations/c2c/v1/change-management/cloud-id/${cloudId}/status`;

});



parcelRegister("7K0sS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a2dad742e1ba6e60$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a2dad742e1ba6e60$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.title",
        "defaultMessage": "Migrate cloud site"
    },
    migrationOverview: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.migration-overview",
        "defaultMessage": "Migration overview"
    },
    manageMigrations: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.manage-migrations",
        "defaultMessage": "Migration dashboard"
    },
    planYourMigration: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.plan-your-migration",
        "defaultMessage": "Plan your migration"
    }
});

});




parcelRegister("lLbUm", function(module, exports) {

$parcel$export(module.exports, "MailSection", () => $4b850ae4133842e3$export$6e0cda39522c0aa7);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $iaHqR = parcelRequire("iaHqR");

var $bS2FN = parcelRequire("bS2FN");

var $cvu76 = parcelRequire("cvu76");

var $iHYBT = parcelRequire("iHYBT");

var $8VG5B = parcelRequire("8VG5B");
const $4b850ae4133842e3$export$6e0cda39522c0aa7 = ()=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $iHYBT.default).mailGroup)
    }, features.hasGlobalMailSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'global-mail-settings'
        },
        href: navigationPath.mailSectionGlobalMailSettings,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $iHYBT.default).globalMailSettings)), features.hasOutgoingMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'outgoing-mail'
        },
        href: navigationPath.mailSectionOutgoingMail,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $iHYBT.default).outgoingMail)), features.hasIncomingMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'incoming-mail'
        },
        href: navigationPath.mailSectionIncomingMail,
        selectedOn: (0, $8VG5B.isIncomingMailSelected)
    }, formatMessage((0, $iHYBT.default).incomingMail)), features.hasSendMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'send-email'
        },
        href: navigationPath.mailSectionSendMail,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $iHYBT.default).sendEmail)));
};

});
parcelRegister("iHYBT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7634283c8e8b9c35$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7634283c8e8b9c35$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    mailGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.mail-group",
        "defaultMessage": "Mail"
    },
    globalMailSettings: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.global-mail-settings",
        "defaultMessage": "Global Mail Settings"
    },
    outgoingMail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.outgoing-mail",
        "defaultMessage": "Outgoing Mail"
    },
    incomingMail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.incoming-mail",
        "defaultMessage": "Incoming Mail"
    },
    sendEmail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.send-email",
        "defaultMessage": "Send email"
    }
});

});

parcelRegister("8VG5B", function(module, exports) {

$parcel$export(module.exports, "isIncomingMailSelected", () => $935706991ebeee78$export$3f53f72603975cb0);

var $bS2FN = parcelRequire("bS2FN");
const $935706991ebeee78$var$INCOMING_MAIL_PATH_REGEXP = /\/admin\/(\w+)Pop(Mail)?Server/i;
const $935706991ebeee78$export$3f53f72603975cb0 = (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlExact)()(currentLocation, itemLocation) || $935706991ebeee78$var$INCOMING_MAIL_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("gzoho", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e2230353ff9d9c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f8e2230353ff9d9c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    systemGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.system-group",
        "defaultMessage": "System"
    },
    generalConfiguration: {
        "id": "spa-apps-sidebar-global-settings-system.menu.general-configuration",
        "defaultMessage": "General configuration"
    },
    darkFeatures: {
        "id": "spa-apps-sidebar-global-settings-system.menu.dark-features",
        "defaultMessage": "Dark features"
    },
    issueCollectors: {
        "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors",
        "defaultMessage": "Issue collectors"
    }
});

});

parcelRegister("dL8Xn", function(module, exports) {

$parcel$export(module.exports, "SecuritySection", () => $eb924df18a7c6010$export$4f16aec1633bed7d);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $iaHqR = parcelRequire("iaHqR");

var $bS2FN = parcelRequire("bS2FN");

var $cvu76 = parcelRequire("cvu76");

var $dSsSw = parcelRequire("dSsSw");

var $gvZ8X = parcelRequire("gvZ8X");
const $eb924df18a7c6010$export$4f16aec1633bed7d = ()=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const globalPermissionsPath = navigationPath.securityGlobalPermissions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $dSsSw.default).securityGroup)
    }, features.hasProjectRoles && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'project-roles'
        },
        href: navigationPath.securityProjectRoles,
        selectedOn: (0, $gvZ8X.isProjectRolesSelected)
    }, formatMessage((0, $dSsSw.default).projectRoles)), features.hasGlobalPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'global-permissions'
        },
        href: globalPermissionsPath,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $dSsSw.default).globalPermissions)));
};

});
parcelRegister("dSsSw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec3b061d4e12a99b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ec3b061d4e12a99b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    securityGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.security-group",
        "defaultMessage": "Security"
    },
    projectRoles: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.project-roles",
        "defaultMessage": "Project roles"
    },
    globalPermissions: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.global-permissions",
        "defaultMessage": "Global permissions"
    }
});

});

parcelRegister("gvZ8X", function(module, exports) {

$parcel$export(module.exports, "isProjectRolesSelected", () => $04b6f104889e683f$export$ca9501e7fedfce90);

var $bS2FN = parcelRequire("bS2FN");
const $04b6f104889e683f$var$PROJECT_ROLES_PATH_REGEXP = /\/project\/(\w+)ProjectRole/i;
const $04b6f104889e683f$export$ca9501e7fedfce90 = (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlExact)()(currentLocation, itemLocation) || $04b6f104889e683f$var$PROJECT_ROLES_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("7NvRo", function(module, exports) {

$parcel$export(module.exports, "SharedSection", () => $3b965d50f8cd4528$export$230e518497f06fdc);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $iaHqR = parcelRequire("iaHqR");

var $bS2FN = parcelRequire("bS2FN");

var $cvu76 = parcelRequire("cvu76");

var $lwwO0 = parcelRequire("lwwO0");
const $3b965d50f8cd4528$export$230e518497f06fdc = ()=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $lwwO0.default).sharedItems)
    }, features.hasManageFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'manage-filters'
        },
        href: navigationPath.sharedSectionManageFilters,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $lwwO0.default).filters)), features.hasManageDashboards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'manage-dashboards'
        },
        href: navigationPath.sharedManageDashboards,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $lwwO0.default).dashboards)));
};

});
parcelRegister("lwwO0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c7097381edc8287$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0c7097381edc8287$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sharedItems: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-items",
        "defaultMessage": "Shared Items"
    },
    sharedFilters: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-filters",
        "defaultMessage": "Shared filters"
    },
    sharedDashboards: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-dashboards",
        "defaultMessage": "Shared dashboards"
    },
    filters: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.dashboards",
        "defaultMessage": "Dashboards"
    }
});

});


parcelRegister("kdz1U", function(module, exports) {

$parcel$export(module.exports, "TroubleshootingAndSupportSection", () => $71e9461820402186$export$dad01649916e6a2d);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $15MfS = parcelRequire("15MfS");

var $iaHqR = parcelRequire("iaHqR");

var $bS2FN = parcelRequire("bS2FN");

var $cvu76 = parcelRequire("cvu76");

var $9yHg3 = parcelRequire("9yHg3");

var $i8TI3 = parcelRequire("i8TI3");

var $jp7a0 = parcelRequire("jp7a0");
const $71e9461820402186$export$dad01649916e6a2d = ()=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { hasSiteOptimizerEntitlement: hasSiteOptimizerEntitlement } = (0, $15MfS.useSiteOptimizerCheck)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $9yHg3.default).troubleshootingGroup)
    }, features.hasViewAuditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'view-auditing'
        },
        href: navigationPath.troubleshootingAuditLog,
        selectedOn: (0, $jp7a0.isViewAuditingSelected)
    }, formatMessage((0, $9yHg3.default).auditLog)), features.hasPluginViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'plugin-viewer'
        },
        href: navigationPath.troubleshootingPluginViewer,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $9yHg3.default).pluginViewer)), features.hasModulesViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'modules-viewer'
        },
        href: navigationPath.troubleshootingModulesViewer,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $9yHg3.default).modulesViewer)), features.hasSystemInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'system-info'
        },
        href: navigationPath.troubleshootingSystemInfo,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $9yHg3.default).systemInfo)), features.hasIntegrityChecker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'integrity-checker'
        },
        href: navigationPath.troubleshootingIntegrityChecker,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $9yHg3.default).integrityChecker)), features.hasLoggingProfiling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'logging-profiling'
        },
        href: navigationPath.troubleshootingLoggingProfiling,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $9yHg3.default).loggingProfiling)), features.hasSchedulerDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'scheduler-details'
        },
        href: navigationPath.troubleshootingSchedulerDetails,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $9yHg3.default).schedulerDetails)), hasSiteOptimizerEntitlement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i8TI3.PerformanceMenuItem), null));
};

});
parcelRegister("15MfS", function(module, exports) {

$parcel$export(module.exports, "useSiteOptimizerCheck", () => $818da71bb0bbfb92$export$7df80afc329cd61);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");
const $818da71bb0bbfb92$export$e9921a980669184 = ()=>(0, $lRmyA.performGetRequest)('/rest/internal/psi/latest/licence/check');
const $818da71bb0bbfb92$export$7df80afc329cd61 = ()=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [hasEntitlement, setHasEntitlement] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)();
    const fetch = async ()=>{
        try {
            setLoading(true);
            setError(undefined);
            if ((0, $1ybV0.ff)('override-enable-performance-and-scale-admin-menu')) setHasEntitlement(true);
            else {
                const data = await $818da71bb0bbfb92$export$e9921a980669184();
                setHasEntitlement(data?.isVisible ?? false);
            }
            setLoading(false);
        } catch (apiError) {
            setLoading(false);
            setError(apiError);
        }
    };
    (0, $eUqFw.useEffect)(()=>{
        fetch();
    }, []);
    return {
        loading: loading,
        hasSiteOptimizerEntitlement: hasEntitlement,
        error: error
    };
};

});

parcelRegister("9yHg3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d15a1298c551d31f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d15a1298c551d31f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    troubleshootingGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.troubleshooting-group",
        "defaultMessage": "Troubleshooting and Support"
    },
    auditLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.audit-log",
        "defaultMessage": "Audit Log"
    },
    pluginViewer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.plugin-viewer",
        "defaultMessage": "Plugin Viewer"
    },
    modulesViewer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.modules-viewer",
        "defaultMessage": "Modules Viewer"
    },
    systemInfo: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.system-info",
        "defaultMessage": "System info"
    },
    integrityChecker: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.integrity-checker",
        "defaultMessage": "Integrity checker"
    },
    loggingProfiling: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.logging-profiling",
        "defaultMessage": "Logging profiling"
    },
    schedulerDetails: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.scheduler-details",
        "defaultMessage": "Scheduler details"
    }
});

});

parcelRegister("i8TI3", function(module, exports) {

$parcel$export(module.exports, "PerformanceMenuItem", () => $6f8ee83e9e372c3f$export$b4e98631ff0b3fb5);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $aOINP = parcelRequire("aOINP");
var $ltfxy = parcelRequire("ltfxy");
var $7zpSo = parcelRequire("7zpSo");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");


var $5JgJ2 = parcelRequire("5JgJ2");

var $2DHQu = parcelRequire("2DHQu");

var $iaHqR = parcelRequire("iaHqR");

var $jMP2a = parcelRequire("jMP2a");

var $ap7vt = parcelRequire("ap7vt");

var $dxcfv = parcelRequire("dxcfv");

var $edsEA = parcelRequire("edsEA");

var $76jM0 = parcelRequire("76jM0");

var $eTVkQ = parcelRequire("eTVkQ");

var $gX1Xl = parcelRequire("gX1Xl");
const $6f8ee83e9e372c3f$export$b4e98631ff0b3fb5 = ()=>{
    const accountId = (0, $dxcfv.useAccountId)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOptimiserSpotlightActive, setIsOptimiserSpotlightActive] = (0, $eUqFw.useState)(false);
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    const BackMenuItem = {
        href: '/jira/settings/system/general-configuration',
        title: formatMessage((0, $76jM0.default).itemBack)
    };
    const fetchSpotlightState = (0, $eUqFw.useCallback)(async ()=>{
        if (accountId != null) {
            const response = await (0, $gX1Xl.hasSeenSiteOptimiserSpotlight)(accountId);
            setIsOptimiserSpotlightActive(!response);
        }
    }, [
        accountId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        fetchSpotlightState();
    }, [
        fetchSpotlightState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "site-optimiser-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DHQu.NestingMenuItem), {
        analytics: {
            itemId: 'performance-and-scale'
        },
        href: navigationPath.troubleshootingPerformanceAndScale,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            gap: "space.050",
            justifyContent: "start",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $76jM0.default).performanceAndScale)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new"
        }, formatMessage((0, $76jM0.default).beta))),
        overrides: {
            BackMenuItem: BackMenuItem
        },
        id: (0, $edsEA.SECTION_ID).PERFORMANCE_AND_SCALE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eTVkQ.PerformanceAndScaleMenu), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, isOptimiserSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ap7vt.JiraSpotlight), {
        actions: [
            {
                onClick: (_, analyticsEvent)=>{
                    setIsOptimiserSpotlightActive(false);
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'performanceMenuItemSpotlightComplete');
                },
                text: formatMessage((0, $76jM0.default).spotlightAction)
            }
        ],
        heading: formatMessage((0, $76jM0.default).spotlightHeading),
        target: "site-optimiser-spotlight",
        key: "site-optimiser-spotlight",
        targetRadius: 3,
        targetBgColor: `var(--ds-surface, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
        dialogPlacement: "right top",
        messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.jira-spotlight.site-optimiser-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $76jM0.default).spotlightBody))));
};

});
parcelRegister("ap7vt", function(module, exports) {

$parcel$export(module.exports, "JiraSpotlight", () => $9dba2f07cab8d82f$export$e209c6be9ab8c4f4);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $jGBLd = parcelRequire("jGBLd");

var $i6lq0 = parcelRequire("i6lq0");
const $9dba2f07cab8d82f$export$e209c6be9ab8c4f4 = (props)=>{
    if ((0, $jGBLd.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6lq0.ChoreographerSpotlight), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), rest);
};

});
parcelRegister("jGBLd", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $38eaf8660dcaa871$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "environmentToEnvType", () => $38eaf8660dcaa871$export$e2cf19200849be9e);

var $1C9jQ = parcelRequire("1C9jQ");

var $EbGpR = parcelRequire("EbGpR");
function $38eaf8660dcaa871$export$a8ba9111c7eec9ac(props) {
    return !!props?.messageType && (0, $EbGpR.IntegratedChoreographerMessageTypesEnum).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    props.messageType);
}
function $38eaf8660dcaa871$export$e2cf19200849be9e(environment) {
    switch(environment){
        case 'dev':
            return (0, $1C9jQ.envType).DEV;
        case 'staging':
            return (0, $1C9jQ.envType).STAGING;
        case 'prod':
            return (0, $1C9jQ.envType).PROD;
        default:
            return (0, $1C9jQ.envType).LOCAL;
    }
}

});
parcelRegister("EbGpR", function(module, exports) {

$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0);
const $e5c6b031155cf9c2$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0 = [
    $e5c6b031155cf9c2$export$94e85cf3348f045a.ENGAGEMENT,
    $e5c6b031155cf9c2$export$94e85cf3348f045a.MARKETING
];

});


parcelRegister("i6lq0", function(module, exports) {

$parcel$export(module.exports, "ChoreographerSpotlight", () => $b80fd2570c4b1abe$export$e01943d134357d00);
// eslint-disable-next-line jira/import/no-restricted-import

var $hJJD2 = parcelRequire("hJJD2");

var $kytz8 = parcelRequire("kytz8");
const $b80fd2570c4b1abe$export$e01943d134357d00 = (0, $kytz8.withChoreographedRender)((0, $hJJD2.default));

});
parcelRegister("kytz8", function(module, exports) {

$parcel$export(module.exports, "withChoreographedRender", () => $d60c6f7c92c4fa11$export$c1160fdac17030e);

var $eUqFw = parcelRequire("eUqFw");

var $6uNFR = parcelRequire("6uNFR");
function $d60c6f7c92c4fa11$export$c1160fdac17030e(Component, options) {
    function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...props }) {
        const shouldRender = (0, $6uNFR.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props);
        if (options && options.toggleableProp) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const toggleableComponentProps = {
                ...props,
                [options.toggleableProp]: false
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, toggleableComponentProps);
        }
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    return ChoreographedComponent;
}

});
parcelRegister("6uNFR", function(module, exports) {

$parcel$export(module.exports, "getPendoPlugin", () => $dbff780bfca374d0$export$3d3a86b2d636214b);
$parcel$export(module.exports, "useChoreographer", () => $dbff780bfca374d0$export$9f0e2488ffd90f11);
$parcel$export(module.exports, "ChoreographedStatusContext", () => $dbff780bfca374d0$export$3ff96dbefca6b00d);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $dbff780bfca374d0$export$2eb1efa814fe4a);
$parcel$export(module.exports, "useChoreographedRender", () => $dbff780bfca374d0$export$2cfd68294be82811);

var $eUqFw = parcelRequire("eUqFw");

var $5xY1g = parcelRequire("5xY1g");
var $awwEG = parcelRequire("awwEG");
var $67SDP = parcelRequire("67SDP");

var $6rW04 = parcelRequire("6rW04");

var $38OPi = parcelRequire("38OPi");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $dbff780bfca374d0$var$environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment')) ?? 'prod';
const $dbff780bfca374d0$var$createChoreographerFactory = ()=>{
    if (false) return {
        useChoreographer: (..._)=>({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                startMessage: ()=>Promise.resolve(''),
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                stopMessage: ()=>{}
            })
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $5xY1g.choreographerFactory)((0, $67SDP.ProductIds).JIRA, $dbff780bfca374d0$var$environment);
};
let $dbff780bfca374d0$var$pendoPlugin;
function $dbff780bfca374d0$export$3d3a86b2d636214b(env) {
    if (!$dbff780bfca374d0$var$pendoPlugin) $dbff780bfca374d0$var$pendoPlugin = new (0, $awwEG.PendoChoreographerPlugin)(env, {
        sourceProductId: (0, $67SDP.ProductIds).JIRA
    });
    return $dbff780bfca374d0$var$pendoPlugin;
}
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ const { useChoreographer: $dbff780bfca374d0$export$9f0e2488ffd90f11 } = $dbff780bfca374d0$var$createChoreographerFactory();
const $dbff780bfca374d0$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $dbff780bfca374d0$export$2eb1efa814fe4a = ()=>(0, $eUqFw.useContext)($dbff780bfca374d0$export$3ff96dbefca6b00d);
const $dbff780bfca374d0$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $dbff780bfca374d0$export$2eb1efa814fe4a();
    const [shouldRender, setShouldRender] = (0, $eUqFw.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $dbff780bfca374d0$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!isAlreadyChoreographedAtAncestor) {
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>{
                stopMessage();
            };
        }
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage,
        isAlreadyChoreographedAtAncestor
    ]);
    return shouldRender || isAlreadyChoreographedAtAncestor;
};

});




parcelRegister("76jM0", function(module, exports) {

$parcel$export(module.exports, "default", () => $594471997def5449$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $594471997def5449$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    performanceAndScale: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale",
        "defaultMessage": "Site optimizer"
    },
    itemBack: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.item-back",
        "defaultMessage": "Back to system"
    },
    spotlightHeading: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-heading",
        "defaultMessage": "Clean up your site"
    },
    spotlightBody: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-body",
        "defaultMessage": "Remove old data that might be slowing down your site in a few clicks."
    },
    spotlightAction: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-action",
        "defaultMessage": "Ok"
    },
    beta: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.beta",
        "defaultMessage": "Beta"
    }
});

});

parcelRegister("eTVkQ", function(module, exports) {

$parcel$export(module.exports, "PerformanceAndScaleMenu", () => $263e832452d2566c$export$442d4ccb0d25fc50);

var $eUqFw = parcelRequire("eUqFw");

var $ltfxy = parcelRequire("ltfxy");

var $7eyVf = parcelRequire("7eyVf");

var $8WG7k = parcelRequire("8WG7k");

var $lBOVe = parcelRequire("lBOVe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $9kVcv = parcelRequire("9kVcv");

var $bS2FN = parcelRequire("bS2FN");

var $g0nB0 = parcelRequire("g0nB0");

var $sHa4z = parcelRequire("sHa4z");
const $263e832452d2566c$export$442d4ccb0d25fc50 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const basePerformanceUrl = '/jira/settings/system/performance';
    const allVisibleMetrics = (0, $lBOVe.getAllVisibleMetrics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $g0nB0.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'performance-overview'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${basePerformanceUrl}/overview`
    }, formatMessage((0, $g0nB0.default).overview))), allVisibleMetrics.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $g0nB0.default).allReports)
    }, allVisibleMetrics.map((metric)=>{
        if (metric.key === (0, $8WG7k.PROJECT_CLEANUP_KEY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: "project-cleanup-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
            name: (0, $sHa4z.PROJECT_CLEANUP_SPOTLIGHT_NAME)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
            analytics: {
                itemId: `performance-metric-${metric.key}`
            },
            href: `${basePerformanceUrl}/metrics/${metric.key}`,
            selectedOn: (0, $bS2FN.matchUrlPathname)(),
            key: metric.key
        }, formatMessage(metric.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sHa4z.ProjectCleanupSpotlight), null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
            analytics: {
                itemId: `performance-metric-${metric.key}`
            },
            href: `${basePerformanceUrl}/metrics/${metric.key}`,
            selectedOn: (0, $bS2FN.matchUrlPathname)(),
            key: metric.key
        }, formatMessage(metric.name));
    })));
};

});
parcelRegister("8WG7k", function(module, exports) {

$parcel$export(module.exports, "PROJECT_CLEANUP_KEY", () => $75960bfe165caecf$export$4e9bf1d386c2f0c);
$parcel$export(module.exports, "PROJECT_CLEANUP", () => $75960bfe165caecf$export$761acf34bef3a717);

var $cPhgq = parcelRequire("cPhgq");
const $75960bfe165caecf$export$4e9bf1d386c2f0c = 'projectcleanup';
const $75960bfe165caecf$export$761acf34bef3a717 = {
    key: $75960bfe165caecf$export$4e9bf1d386c2f0c,
    visible: true,
    name: (0, $cPhgq.default).nameNonFinal,
    description: (0, $cPhgq.default).descriptionNonFinal,
    tabLabels: [
        (0, $cPhgq.default).analysisNonFinal,
        (0, $cPhgq.default).activityLogNonFinal
    ],
    warningMessage: (0, $cPhgq.default).warningNonFinal,
    exceededMessage: (0, $cPhgq.default).exceededNonFinal,
    risks: [],
    mitigations: [],
    currentValueLabel: (0, $cPhgq.default).currentValueLabel,
    cleanupValueLabel: (0, $cPhgq.default).cleanupValueLabel,
    graphHeader: (0, $cPhgq.default).graphHeader,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-the-number-of-projects-in-your-site/',
    recommendationUrlText: (0, $cPhgq.default).recommendationUrlText
};

});
parcelRegister("cPhgq", function(module, exports) {

$parcel$export(module.exports, "default", () => $415a350c7923b11b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $415a350c7923b11b$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $415a350c7923b11b$var$DESCRIPTION_DESC = 'Description of the site optimizer metric.';
const $415a350c7923b11b$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $415a350c7923b11b$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $415a350c7923b11b$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $415a350c7923b11b$var$CLEANUP_VALUE_LABEL_DESC = 'Label to be shown next to the cleanup value of the metric.';
const $415a350c7923b11b$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $415a350c7923b11b$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $415a350c7923b11b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    nameNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.name-non-final",
        "defaultMessage": "Projects"
    },
    descriptionNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.description-non-final",
        "defaultMessage": "Below, we\u2019ve identified company-managed and team-managed projects in your site that can be archived or trashed because they contain no issues. Removing these projects can improve site performance and stability."
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.project-cleanup.recommendation-url-text",
        "defaultMessage": "See how we identify these projects."
    },
    analysisNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.analysis-non-final",
        "defaultMessage": "Analysis"
    },
    activityLogNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.activity-log-non-final",
        "defaultMessage": "Activity log"
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
        "defaultMessage": "Projects over time"
    },
    // Since we don't have a threshold, these messages below will be unused - keeping them purely to satisfy the Metric type
    // We should make this type more flexible in the future
    warningNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.warning-non-final",
        "defaultMessage": "The number of projects is nearing our recommended threshold."
    },
    exceededNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.exceeded-non-final",
        "defaultMessage": "There are some project..."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.project-cleanup.current-value-label",
        "defaultMessage": "Projects in your site"
    },
    cleanupValueLabel: {
        "id": "admin-pages-performance.common.assets.project-cleanup.cleanup-value-label",
        "defaultMessage": "Recommended for cleanup"
    }
});

});


parcelRegister("lBOVe", function(module, exports) {

$parcel$export(module.exports, "getAllVisibleMetrics", () => $93d909cef4928ba1$export$e6140fda06493d18);
$parcel$export(module.exports, "getMetric", () => $93d909cef4928ba1$export$ed0dc1178a679c67);
$parcel$export(module.exports, "getAllVisibleMetricKeys", () => $93d909cef4928ba1$export$1f2abf3e170d35d2);
$parcel$export(module.exports, "assertNever", () => $93d909cef4928ba1$export$cbadc5a7223772a8);

var $eI5EY = parcelRequire("eI5EY");

var $7sw6U = parcelRequire("7sw6U");

var $29cWe = parcelRequire("29cWe");

var $8WG7k = parcelRequire("8WG7k");

var $dvpny = parcelRequire("dvpny");

var $4zgfm = parcelRequire("4zgfm");
class $93d909cef4928ba1$export$9419457073a1750 {
    constructor(metrics){
        this.metrics = metrics;
    }
    getMetric(key) {
        return this.metrics.find((m)=>m.key === key);
    }
    getAllVisibleMetrics() {
        return this.metrics.filter((metric)=>metric.visible && $93d909cef4928ba1$export$898df584445641cf(metric.key));
    }
    getAllVisibleMetricsKeys() {
        return $93d909cef4928ba1$export$e6140fda06493d18().map((m)=>m.key);
    }
}
/**
 * Metric registry singleton. We should not be creating another registry.
 */ const $93d909cef4928ba1$var$REGISTRY = new $93d909cef4928ba1$export$9419457073a1750((0, $4zgfm.METRICS));
const $93d909cef4928ba1$export$ed0dc1178a679c67 = $93d909cef4928ba1$var$REGISTRY.getMetric.bind($93d909cef4928ba1$var$REGISTRY);
const $93d909cef4928ba1$export$e6140fda06493d18 = $93d909cef4928ba1$var$REGISTRY.getAllVisibleMetrics.bind($93d909cef4928ba1$var$REGISTRY);
const $93d909cef4928ba1$export$1f2abf3e170d35d2 = $93d909cef4928ba1$var$REGISTRY.getAllVisibleMetricsKeys.bind($93d909cef4928ba1$var$REGISTRY);
const $93d909cef4928ba1$export$898df584445641cf = (metricKey)=>{
    switch(metricKey){
        case 0, $8WG7k.PROJECT_CLEANUP_KEY:
            return (0, $eI5EY.fg)('site-optimizer-project-cleanup');
        case 0, $dvpny.PROJECT_ROLE_ACTOR_KEY:
        case 0, $7sw6U.CUSTOM_FIELDS_KEY:
        case 0, $29cWe.ISSUE_KEY:
            return true;
        default:
            return false;
    }
};
const $93d909cef4928ba1$export$cbadc5a7223772a8 = (_, message)=>{
    throw new Error(message);
};

});
parcelRegister("7sw6U", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_FIELDS_KEY", () => $31622d93f2040b73$export$d214286a7039b004);
$parcel$export(module.exports, "CUSTOM_FIELDS", () => $31622d93f2040b73$export$459112111ad5b136);

var $k1e0Z = parcelRequire("k1e0Z");
const $31622d93f2040b73$export$d214286a7039b004 = 'customField';
const $31622d93f2040b73$export$459112111ad5b136 = {
    key: $31622d93f2040b73$export$d214286a7039b004,
    visible: true,
    name: (0, $k1e0Z.default).name,
    description: (0, $k1e0Z.default).description,
    tabLabels: [
        (0, $k1e0Z.default).chart,
        (0, $k1e0Z.default).reviewAndAnalyze
    ],
    warningMessage: (0, $k1e0Z.default).warning,
    exceededMessage: (0, $k1e0Z.default).exceeded,
    risks: [
        (0, $k1e0Z.default).risk1
    ],
    mitigations: [],
    currentValueLabel: (0, $k1e0Z.default).currentValueLabel,
    currentValueAriaLabel: (0, $k1e0Z.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $k1e0Z.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $k1e0Z.default).thresholdValueAriaLabel,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-custom-fields/',
    recommendationUrlText: (0, $k1e0Z.default).recommendationUrlText,
    graphHeader: (0, $k1e0Z.default).graphHeader
};

});
parcelRegister("k1e0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3104a008db7c7b9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $a3104a008db7c7b9$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $a3104a008db7c7b9$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $a3104a008db7c7b9$var$CHART_DESC = 'A tab label of Custom Field Tabs, to show custom fields chart';
const $a3104a008db7c7b9$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Custom Field Tabs, to show custom fields review and analyze';
const $a3104a008db7c7b9$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $a3104a008db7c7b9$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $a3104a008db7c7b9$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $a3104a008db7c7b9$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $a3104a008db7c7b9$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $a3104a008db7c7b9$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $a3104a008db7c7b9$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $a3104a008db7c7b9$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $a3104a008db7c7b9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.custom-fields.name",
        "defaultMessage": "Custom fields"
    },
    description: {
        "id": "admin-pages-performance.common.assets.custom-fields.description",
        "defaultMessage": "Here are the custom fields in your site, including ones we think can be removed because they\u2019re not used. Removing unused fields could improve site performance and stability."
    },
    chart: {
        "id": "admin-pages-performance.common.assets.custom-fields.chart",
        "defaultMessage": "Overview"
    },
    reviewAndAnalyze: {
        "id": "admin-pages-performance.common.assets.custom-fields.review-and-analyze",
        "defaultMessage": "Analysis"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.custom-fields.warning",
        "defaultMessage": "The number of custom fields is nearing our recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.custom-fields.exceeded",
        "defaultMessage": "There are more custom fields than our recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.custom-fields.risk-1",
        "defaultMessage": "Custom fields can make searching for issues (JQL and boards) and creating issues slow."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.custom-fields.mitigation-1",
        "defaultMessage": "Edit the context for the custom field to make it visible only for specific projects."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.custom-fields.mitigation-2",
        "defaultMessage": "Limit the number of custom fields across all projects and use the same custom field in multiple projects."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.current-value-label",
        "defaultMessage": "Custom fields in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-label",
        "defaultMessage": "Recommended maximum number of custom fields"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.current-value-aria-label",
        "defaultMessage": "{number} custom fields in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of custom fields"
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.custom-fields.recommendation-url-text",
        "defaultMessage": "See how we identify these fields."
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.custom-fields.graph-header",
        "defaultMessage": "Custom fields over time"
    }
});

});


parcelRegister("29cWe", function(module, exports) {

$parcel$export(module.exports, "ISSUE_KEY", () => $63a6bddb6870ae94$export$5daa28d10e23592);
$parcel$export(module.exports, "ISSUE", () => $63a6bddb6870ae94$export$76a449e52fa0e1e8);

var $gh3p2 = parcelRequire("gh3p2");
const $63a6bddb6870ae94$export$5daa28d10e23592 = 'issue';
const $63a6bddb6870ae94$export$76a449e52fa0e1e8 = {
    key: $63a6bddb6870ae94$export$5daa28d10e23592,
    visible: true,
    name: (0, $gh3p2.default).name,
    description: (0, $gh3p2.default).description,
    tabLabels: [
        (0, $gh3p2.default).reviewAndAnalyze,
        (0, $gh3p2.default).activityLog
    ],
    warningMessage: (0, $gh3p2.default).warning,
    exceededMessage: (0, $gh3p2.default).exceeded,
    risks: [
        (0, $gh3p2.default).risk1
    ],
    mitigations: [
        (0, $gh3p2.default).mitigation1,
        (0, $gh3p2.default).mitigation2,
        (0, $gh3p2.default).mitigation3
    ],
    currentValueLabel: (0, $gh3p2.default).currentValueLabel,
    currentValueAriaLabel: (0, $gh3p2.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $gh3p2.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $gh3p2.default).thresholdValueAriaLabel,
    graphHeader: (0, $gh3p2.default).graphHeader
};

});
parcelRegister("gh3p2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d85bbb4fb87b5b3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $9d85bbb4fb87b5b3$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $9d85bbb4fb87b5b3$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $9d85bbb4fb87b5b3$var$CHART_DESC = 'A tab label of Issue Tabs, to show Issue chart';
const $9d85bbb4fb87b5b3$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Issue Tabs, to show issue review and analyze';
const $9d85bbb4fb87b5b3$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $9d85bbb4fb87b5b3$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $9d85bbb4fb87b5b3$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $9d85bbb4fb87b5b3$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $9d85bbb4fb87b5b3$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $9d85bbb4fb87b5b3$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $9d85bbb4fb87b5b3$var$ACTIVITY_LOG_DESC = 'A tab label of Activity Log Tabs, to show Issue Archival past operations';
const $9d85bbb4fb87b5b3$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $9d85bbb4fb87b5b3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.issue.name",
        "defaultMessage": "Issues"
    },
    description: {
        "id": "admin-pages-performance.common.assets.issue.description",
        "defaultMessage": "Here\u2019s a quick snapshot of the total number of issues in your site, including some that we think can be archived. Archiving unused issues can improve performance and stability of your site."
    },
    chart: {
        "id": "admin-pages-performance.common.assets.issue.chart",
        "defaultMessage": "Overview"
    },
    reviewAndAnalyze: {
        "id": "admin-pages-performance.common.assets.issue.review-and-analyze",
        "defaultMessage": "Analysis"
    },
    activityLog: {
        "id": "admin-pages-performance.common.assets.issue.activity-log",
        "defaultMessage": "Activity log"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.issue.warning",
        "defaultMessage": "The number of issues in the system is nearing our recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.issue.exceeded",
        "defaultMessage": "There are more issues in the system than our recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.issue.risk-1",
        "defaultMessage": "If you have too many issues you may find searches, automations, and workflow rules are slower than usual."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-1",
        "defaultMessage": "Delete any projects that are no longer required."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-2",
        "defaultMessage": "Disable Jira integrations that create issues you don't need."
    },
    mitigation3: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-3",
        "defaultMessage": "Delete old issues that are no longer required. Use a JQL query to find issues older than a year (\u201Ccreated < -365d order by created DESC\u201C)."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.issue.current-value-label",
        "defaultMessage": "Total current issues in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-label",
        "defaultMessage": "Recommended maximum number of issues"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.issue.current-value-aria-label",
        "defaultMessage": "{number} total current issues in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of issues"
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.issue.graph-header",
        "defaultMessage": "Issues over time"
    }
});

});


parcelRegister("dvpny", function(module, exports) {

$parcel$export(module.exports, "PROJECT_ROLE_ACTOR_KEY", () => $12bf835619f662e5$export$a570ca3f6cc5e280);
$parcel$export(module.exports, "PROJECT_ROLE_ACTOR", () => $12bf835619f662e5$export$fc3d2ee6c3fb3908);

var $k8SA5 = parcelRequire("k8SA5");
const $12bf835619f662e5$export$a570ca3f6cc5e280 = 'projectroleactor';
const $12bf835619f662e5$export$fc3d2ee6c3fb3908 = {
    key: $12bf835619f662e5$export$a570ca3f6cc5e280,
    visible: true,
    name: (0, $k8SA5.default).name,
    description: (0, $k8SA5.default).description,
    tabLabels: [
        (0, $k8SA5.default).analysis,
        (0, $k8SA5.default).activityLog
    ],
    warningMessage: (0, $k8SA5.default).warning,
    exceededMessage: (0, $k8SA5.default).exceeded,
    risks: [
        (0, $k8SA5.default).risk1
    ],
    mitigations: [
        (0, $k8SA5.default).mitigation1,
        (0, $k8SA5.default).mitigation2,
        (0, $k8SA5.default).mitigation3
    ],
    currentValueLabel: (0, $k8SA5.default).currentValueLabel,
    currentValueAriaLabel: (0, $k8SA5.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $k8SA5.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $k8SA5.default).thresholdValueAriaLabel,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-number-of-project-role-memberships/',
    recommendationUrlText: (0, $k8SA5.default).recommendationUrlText,
    graphHeader: (0, $k8SA5.default).graphHeader
};

});
parcelRegister("k8SA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfa528fdefb2c376$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically.
const $dfa528fdefb2c376$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $dfa528fdefb2c376$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $dfa528fdefb2c376$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $dfa528fdefb2c376$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $dfa528fdefb2c376$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $dfa528fdefb2c376$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $dfa528fdefb2c376$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $dfa528fdefb2c376$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $dfa528fdefb2c376$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $dfa528fdefb2c376$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $dfa528fdefb2c376$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.project-role-actor.name",
        "defaultMessage": "Project role permissions"
    },
    description: {
        "id": "admin-pages-performance.common.assets.project-role-actor.description",
        "defaultMessage": "Here's a quick snapshot of the total number of project role permissions across your site."
    },
    analysis: {
        "id": "admin-pages-performance.common.assets.project-role-actor.analysis",
        "defaultMessage": "Analysis"
    },
    activityLog: {
        "id": "admin-pages-performance.common.assets.project-role-actor.activity-log",
        "defaultMessage": "Activity log"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.project-role-actor.warning",
        "defaultMessage": "Your number of project role memberships is nearing the recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.project-role-actor.exceeded",
        "defaultMessage": "Your number of project role memberships is over the recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.project-role-actor.risk-1",
        "defaultMessage": "When the number of project role memberships (users or groups) increases, viewing, searching, and creating issues becomes slower."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-1",
        "defaultMessage": "Remove users who no longer need access to your site rather than only suspending them. Suspending users removes their permission but not their project role membership."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-2",
        "defaultMessage": "Give memberships to groups of users instead of individual users. Granting membership to a group of 50 users count as 1 membership whereas granting memberships to 50 single users counts as 50 memberships."
    },
    mitigation3: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-3",
        "defaultMessage": "Use the default project role members in your permission scheme."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.current-value-label",
        "defaultMessage": "Current project role permissions in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-label",
        "defaultMessage": "Recommended maximum number of permissions"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.current-value-aria-label",
        "defaultMessage": "{number} current project role permissions in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of permissions"
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.project-role-actor.recommendation-url-text",
        "defaultMessage": "Learn more about optimizing your project role memberships."
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
        "defaultMessage": "Project role permissions over time"
    }
});

});


parcelRegister("4zgfm", function(module, exports) {

$parcel$export(module.exports, "METRICS", () => $62ab28a8db68210b$export$3f0e99ae6e0ec541);
$parcel$export(module.exports, "RUN_ANALYSIS", () => $62ab28a8db68210b$export$769b1a9477352cf9);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS", () => $62ab28a8db68210b$export$e7e31b14c32e055a);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_DROPDOWN", () => $62ab28a8db68210b$export$d96fe00ff2b38bae);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CONFIRM", () => $62ab28a8db68210b$export$3d4bb5f187c6844e);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CANCEL", () => $62ab28a8db68210b$export$5c1079e323f5d5bd);
$parcel$export(module.exports, "TAB_CLICKED", () => $62ab28a8db68210b$export$d358fc12daa9f606);
$parcel$export(module.exports, "RECOMMENDATIONS_LOADED", () => $62ab28a8db68210b$export$60cc0c61c99a5b81);
$parcel$export(module.exports, "METRIC_CARD_CLICKED", () => $62ab28a8db68210b$export$71794f4d197278dc);
$parcel$export(module.exports, "PROJECT_ROLE_ACTOR_FILTER_BY_PROJECT", () => $62ab28a8db68210b$export$9e34afbf86922b4a);
$parcel$export(module.exports, "projectRoleActorAttributes", () => $62ab28a8db68210b$export$d6761557c91eea50);
$parcel$export(module.exports, "ARCHIVE_ISSUES_CONFIRM", () => $62ab28a8db68210b$export$4e4b9391f7936ba2);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES", () => $62ab28a8db68210b$export$70525d18051240f4);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_CANCEL", () => $62ab28a8db68210b$export$4951e0e034b50b9c);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_TRY_AGAIN", () => $62ab28a8db68210b$export$108288df7758f60c);
$parcel$export(module.exports, "VIEW_ISSUES", () => $62ab28a8db68210b$export$972d5a8da0d9f4c3);
$parcel$export(module.exports, "STOP_ISSUE_ARCHIVAL", () => $62ab28a8db68210b$export$b920363d50bcf753);
$parcel$export(module.exports, "ISSUE_UNARCHIVAL_COMPLETED", () => $62ab28a8db68210b$export$a84a5210fbad774);
$parcel$export(module.exports, "JQL_SEARCH", () => $62ab28a8db68210b$export$5c2df36fdd8476f7);
$parcel$export(module.exports, "DEFAULT_QUERY_SELECTED", () => $62ab28a8db68210b$export$77f23f1b921d5321);
$parcel$export(module.exports, "issueAnalyticsAttributes", () => $62ab28a8db68210b$export$c62a52f3f7d80ec3);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH", () => $62ab28a8db68210b$export$8daffc99348bf555);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CONFIRM", () => $62ab28a8db68210b$export$20f13a04bc3e5d74);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CANCEL", () => $62ab28a8db68210b$export$ed285e0e924b673c);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_SUCCEEDED", () => $62ab28a8db68210b$export$26f5d7eae10db511);
$parcel$export(module.exports, "customFieldAttributes", () => $62ab28a8db68210b$export$33989f74b6ba0674);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_STARTED", () => $62ab28a8db68210b$export$d39b24a650c6c79d);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_DISMISSED", () => $62ab28a8db68210b$export$eca4028936acf763);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_COMPLETED", () => $62ab28a8db68210b$export$9ba0a5caedb0ff37);
$parcel$export(module.exports, "RESTORE_ACTIVITY_LOG", () => $62ab28a8db68210b$export$7b6bf63452d40db8);
$parcel$export(module.exports, "DOWNLOAD_CSV", () => $62ab28a8db68210b$export$efdb93c7210090d1);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTERS_CLEARED", () => $62ab28a8db68210b$export$6c650be5c2b4774f);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_PROJECT", () => $62ab28a8db68210b$export$6493dd0e190d3f58);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_STALE", () => $62ab28a8db68210b$export$422673ba1cec4aed);
$parcel$export(module.exports, "PROJECT_CLEAN_UP", () => $62ab28a8db68210b$export$3a7186fc63c9e188);
$parcel$export(module.exports, "PROJECT_CLEANUP_COMPLETED", () => $62ab28a8db68210b$export$8e0b8859a3cbd9e6);
$parcel$export(module.exports, "ACTION_TRASH", () => $62ab28a8db68210b$export$342d8b9804e407c7);
$parcel$export(module.exports, "ACTION_ARCHIVE", () => $62ab28a8db68210b$export$b685f2109baf2b4f);
$parcel$export(module.exports, "ACTION_UNARCHIVE", () => $62ab28a8db68210b$export$3ac60b381ed426ca);

var $7sw6U = parcelRequire("7sw6U");

var $29cWe = parcelRequire("29cWe");

var $8WG7k = parcelRequire("8WG7k");

var $dvpny = parcelRequire("dvpny");
const $62ab28a8db68210b$export$3f0e99ae6e0ec541 = [
    // Inclusion of issues in metrics is dependent on improving mitigation strategies for issues.
    // Inclusion of issue links in metrics is dependent on improving mitigation strategies for issue links.
    // ISSUE_LINKS,
    // CUSTOM_FIELD_OPTIONS,
    (0, $7sw6U.CUSTOM_FIELDS),
    (0, $29cWe.ISSUE),
    (0, $dvpny.PROJECT_ROLE_ACTOR),
    // Inclusion of file attachments in metrics is dependent on improving mitigation strategies for file attachments.
    // FILE_ATTACHMENTS,
    (0, $8WG7k.PROJECT_CLEANUP)
];
const $62ab28a8db68210b$export$769b1a9477352cf9 = 'runAnalysis';
const $62ab28a8db68210b$export$e7e31b14c32e055a = 'deleteRecommendations';
const $62ab28a8db68210b$export$d96fe00ff2b38bae = 'deleteRecommendationsDropdown';
const $62ab28a8db68210b$export$3d4bb5f187c6844e = 'deleteRecommendationsConfirm';
const $62ab28a8db68210b$export$5c1079e323f5d5bd = 'deleteRecommendationsCancel';
const $62ab28a8db68210b$export$d358fc12daa9f606 = 'psiTab';
const $62ab28a8db68210b$export$60cc0c61c99a5b81 = 'recommendations loaded';
const $62ab28a8db68210b$export$71794f4d197278dc = 'mitigationMetricCard';
const $62ab28a8db68210b$export$9e34afbf86922b4a = 'projectRoleActorFilterByProject';
const $62ab28a8db68210b$export$d6761557c91eea50 = {
    metric: (0, $dvpny.PROJECT_ROLE_ACTOR_KEY)
};
const $62ab28a8db68210b$export$4e4b9391f7936ba2 = 'archiveIssuesConfirm';
const $62ab28a8db68210b$export$70525d18051240f4 = 'restoreIssueArchival';
const $62ab28a8db68210b$export$4951e0e034b50b9c = 'restoreIssueCancel';
const $62ab28a8db68210b$export$108288df7758f60c = 'restoreIssueTryAgain';
const $62ab28a8db68210b$export$972d5a8da0d9f4c3 = 'viewIssues';
const $62ab28a8db68210b$export$b920363d50bcf753 = 'stopIssueArchival';
const $62ab28a8db68210b$export$a84a5210fbad774 = 'restoreIssueArchival completed';
const $62ab28a8db68210b$export$5c2df36fdd8476f7 = 'jqlSearch';
const $62ab28a8db68210b$export$77f23f1b921d5321 = 'defaultQuerySelected';
const $62ab28a8db68210b$export$c62a52f3f7d80ec3 = {
    metric: (0, $29cWe.ISSUE_KEY)
};
const $62ab28a8db68210b$export$8daffc99348bf555 = 'customFieldMoveToTrash';
const $62ab28a8db68210b$export$20f13a04bc3e5d74 = 'customFieldMoveToTrashConfirm';
const $62ab28a8db68210b$export$ed285e0e924b673c = 'customFieldMoveToTrashCancel';
const $62ab28a8db68210b$export$26f5d7eae10db511 = 'customFieldMoveToTrash succeeded';
const $62ab28a8db68210b$export$33989f74b6ba0674 = {
    metric: (0, $7sw6U.CUSTOM_FIELDS).key
};
const $62ab28a8db68210b$export$d39b24a650c6c79d = 'metricPerformanceSpotlight started';
const $62ab28a8db68210b$export$eca4028936acf763 = 'metricPerformanceSpotlightDismissed';
const $62ab28a8db68210b$export$9ba0a5caedb0ff37 = 'metricPerformanceSpotlight completed';
const $62ab28a8db68210b$export$7b6bf63452d40db8 = 'restoreActivityLog';
const $62ab28a8db68210b$export$efdb93c7210090d1 = 'downloadActivityLogCsv';
const $62ab28a8db68210b$export$6c650be5c2b4774f = 'projectCleanupFiltersCleared';
const $62ab28a8db68210b$export$6493dd0e190d3f58 = 'projectCleanupFilterByProjectState';
const $62ab28a8db68210b$export$422673ba1cec4aed = 'projectCleanupFilterByStale';
const $62ab28a8db68210b$export$3a7186fc63c9e188 = 'projectCleanUp';
const $62ab28a8db68210b$export$8e0b8859a3cbd9e6 = 'projectCleanup completed';
const $62ab28a8db68210b$export$342d8b9804e407c7 = 'TRASH';
const $62ab28a8db68210b$export$b685f2109baf2b4f = 'ARCHIVE';
const $62ab28a8db68210b$export$3ac60b381ed426ca = 'UNARCHIVE';

});


parcelRegister("g0nB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e86ca693ecf70061$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e86ca693ecf70061$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.title",
        "defaultMessage": "Site optimizer"
    },
    overview: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.overview",
        "defaultMessage": "Overview"
    },
    allReports: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.all-reports",
        "defaultMessage": "All reports"
    }
});

});

parcelRegister("sHa4z", function(module, exports) {

$parcel$export(module.exports, "PROJECT_CLEANUP_SPOTLIGHT_NAME", () => $a087ea204cb3a58b$export$4150c6a7c9be0102);
$parcel$export(module.exports, "ProjectCleanupSpotlight", () => $a087ea204cb3a58b$export$6dc8afd0c00f9525);

var $eUqFw = parcelRequire("eUqFw");

var $7zpSo = parcelRequire("7zpSo");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ap7vt = parcelRequire("ap7vt");

var $hRoWk = parcelRequire("hRoWk");

var $llA5V = parcelRequire("llA5V");
const $a087ea204cb3a58b$export$4150c6a7c9be0102 = 'site-optimiser-project-cleanup-spotlight-nav';
const $a087ea204cb3a58b$export$6dc8afd0c00f9525 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $hRoWk.useProjectCleanupSpotlight)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, isProjectCleanupSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ap7vt.JiraSpotlight), {
        actions: [
            {
                onClick: ()=>setIsProjectCleanupSpotlightActive(false),
                text: formatMessage((0, $llA5V.default).spotlightAction)
            }
        ],
        heading: formatMessage((0, $llA5V.default).spotlightHeading),
        target: $a087ea204cb3a58b$export$4150c6a7c9be0102,
        key: $a087ea204cb3a58b$export$4150c6a7c9be0102,
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "right top",
        messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $llA5V.default).spotlightDescription)));
});

});
parcelRegister("hRoWk", function(module, exports) {

$parcel$export(module.exports, "useProjectCleanupSpotlight", () => $690029fa3a3acf0e$export$780bcf6e3ebf2d12);

var $eUqFw = parcelRequire("eUqFw");

var $9PoYP = parcelRequire("9PoYP");

var $dxcfv = parcelRequire("dxcfv");
// Ensure this key matches the key in the old nav in navigation-apps/sidebar package
const $690029fa3a3acf0e$var$PROPERTY_KEY = 'jira.user.settings.system.project-cleanup-onboarding-spotlight';
const $690029fa3a3acf0e$export$780bcf6e3ebf2d12 = ()=>{
    const accountId = (0, $dxcfv.useAccountId)();
    const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $eUqFw.useState)(false);
    const getHasSeenProjectCleanupSpotlight = async (id)=>{
        const response = await (0, $9PoYP.getUserProperty)({
            accountId: id,
            propertyKey: $690029fa3a3acf0e$var$PROPERTY_KEY,
            defaultValue: false
        });
        // If they have not seen the spotlight, return true and mark as shown
        if (!response.value) {
            await (0, $9PoYP.setUserProperty)({
                accountId: id,
                propertyKey: $690029fa3a3acf0e$var$PROPERTY_KEY,
                propertyValue: true
            });
            return false;
        }
        return true;
    };
    const fetchSpotlightState = (0, $eUqFw.useCallback)(async ()=>{
        if (accountId !== null) {
            const response = await getHasSeenProjectCleanupSpotlight(accountId);
            setIsProjectCleanupSpotlightActive(!response);
        }
    }, [
        accountId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        fetchSpotlightState();
    }, [
        fetchSpotlightState
    ]);
    return [
        isProjectCleanupSpotlightActive,
        setIsProjectCleanupSpotlightActive
    ];
};

});
parcelRegister("9PoYP", function(module, exports) {

$parcel$export(module.exports, "getUserProperty", () => $955a15fece231eda$export$b3126db2ef6e34ed);
$parcel$export(module.exports, "setUserProperty", () => $955a15fece231eda$export$ba821ce5e177c7ef);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $955a15fece231eda$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $955a15fece231eda$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $955a15fece231eda$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // The API deliberately returns 404 if user property is not found - we will return default value
        if (response.status === 404) return {
            key: propertyKey,
            value: defaultValue
        };
        if (response.ok) return await response.json();
        throw new Error(`Fetching ${propertyKey} user property failed.`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};
const $955a15fece231eda$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $955a15fece231eda$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $lRmyA.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'setUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("llA5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a4c7002aa377944$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3a4c7002aa377944$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    spotlightHeading: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-heading",
        "defaultMessage": "Clean out unused projects"
    },
    spotlightDescription: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-description",
        "defaultMessage": "Quickly remove inactive or empty projects to improve your site\u2019s performance. "
    },
    spotlightAction: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-action",
        "defaultMessage": "Ok"
    }
});

});



parcelRegister("gX1Xl", function(module, exports) {

$parcel$export(module.exports, "hasSeenSiteOptimiserSpotlight", () => $4ae32bdb5f090bc9$export$3ed4e8541d8ba40);

var $9PoYP = parcelRequire("9PoYP");
const $4ae32bdb5f090bc9$var$PROPERTY_KEY = 'jira.user.settings.system.site-optimizer-spotlight';
const $4ae32bdb5f090bc9$export$3ed4e8541d8ba40 = async (accountId)=>{
    const response = await (0, $9PoYP.getUserProperty)({
        accountId: accountId,
        propertyKey: $4ae32bdb5f090bc9$var$PROPERTY_KEY,
        defaultValue: false
    });
    // If they have not seen the spotlight, return true and mark as shown
    if (!response.value) {
        await (0, $9PoYP.setUserProperty)({
            accountId: accountId,
            propertyKey: $4ae32bdb5f090bc9$var$PROPERTY_KEY,
            propertyValue: true
        });
        return false;
    }
    return true;
};

});


parcelRegister("jp7a0", function(module, exports) {

$parcel$export(module.exports, "isViewAuditingSelected", () => $03f18fc8092e748a$export$6da8ca04904513f9);

var $bS2FN = parcelRequire("bS2FN");
const $03f18fc8092e748a$var$VIEW_AUDITING_PATH_REGEXP = /\/auditing\/(\w+)/i;
const $03f18fc8092e748a$export$6da8ca04904513f9 = (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlExact)()(currentLocation, itemLocation) || $03f18fc8092e748a$var$VIEW_AUDITING_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("3I29L", function(module, exports) {

$parcel$export(module.exports, "UserInterfaceSection", () => $d9f4a282c7cbc7cf$export$c4128359313d3f58);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $exb0h = parcelRequire("exb0h");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $iaHqR = parcelRequire("iaHqR");

var $bS2FN = parcelRequire("bS2FN");

var $c7H0g = parcelRequire("c7H0g");

var $cvu76 = parcelRequire("cvu76");

var $1AipL = parcelRequire("1AipL");
const $d9f4a282c7cbc7cf$export$c4128359313d3f58 = ()=>{
    const isJiraAdmin = (0, $c7H0g.useIsAdmin)();
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $1AipL.default).userInterface)
    }, features.hasUserDefaults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'user-defaults'
        },
        href: navigationPath.userInterfacesUserDefaults,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $1AipL.default).userDefaults)), features.hasEditDefaultDashboard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'edit-default-dashboard'
        },
        href: navigationPath.userInterfacesEditDefaultDashboard,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $1AipL.default).systemDashboard)), features.hasLookAndFeel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'look-and-feel'
        },
        href: navigationPath.userInterfacesLookAndFeel,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $1AipL.default).lookAndFeel)), features.hasPasAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'pas-admin-link-jira'
        },
        href: navigationPath.userInterfacesPasAdmin,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $1AipL.default).pasAdmin)), isJiraAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'announcement-banner'
        },
        href: navigationPath.userInterfacesSiteAdmin,
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER)
        ]
    }, formatMessage((0, $1AipL.default).announcementBanner)));
};

});
parcelRegister("1AipL", function(module, exports) {

$parcel$export(module.exports, "default", () => $34e717096f7a10af$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $34e717096f7a10af$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    userInterface: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-interface",
        "defaultMessage": "User Interface"
    },
    userDefaults: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-defaults",
        "defaultMessage": "Default user preferences"
    },
    systemDashboard: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.system-dashboard",
        "defaultMessage": "Default dashboard"
    },
    lookAndFeel: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.look-and-feel",
        "defaultMessage": "Look and feel"
    },
    pasAdmin: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.pas-admin",
        "defaultMessage": "Public Announcement Service"
    },
    announcementBanner: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.announcement-banner",
        "defaultMessage": "Announcement banner"
    }
});

});


parcelRegister("7SUOK", function(module, exports) {

$parcel$export(module.exports, "isGeneralConfigurationSelected", () => $15dfca461865397f$export$ba31cfa97c56eefd);

var $bS2FN = parcelRequire("bS2FN");
const $15dfca461865397f$var$APPLICATION_PROPERTIES_PATH_REGEXP = /\/admin\/(\w+)ApplicationProperties/i;
const $15dfca461865397f$export$ba31cfa97c56eefd = (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlExact)()(currentLocation, itemLocation) || $15dfca461865397f$var$APPLICATION_PROPERTIES_PATH_REGEXP.test(currentLocation.pathname);

});



parcelRegister("e2wYK", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ade3E").then(()=>parcelRequire('5Qoxh'));

});

parcelRegister("fI7ei", function(module, exports) {

$parcel$export(module.exports, "metricsOverviewPageResource", () => $c3c647546ebd6586$export$ac0b4ef4ec4987ae);

var $buJlM = parcelRequire("buJlM");

var $38Uom = parcelRequire("38Uom");
const $c3c647546ebd6586$export$ac0b4ef4ec4987ae = (0, $buJlM.createRelayResource)({
    type: 'ADMIN_PAGES_PERFORMANCE_OVERVIEW',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $38Uom.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("38Uom", function(module, exports) {

$parcel$export(module.exports, "default", () => $e90d0e4e68a4767b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67453a3e8d1ad82b31633d3df4853176>>
 * @relayHash d7a09c1a09b57c4675b8c2439ee0bd6e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d2fe73ca0b47245563666951f775b77a3a261da2aeb574c289b15d04a8a13008
const $e90d0e4e68a4767b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_adminPagesPerformance_Overview_Query",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnection",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetrics",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "main_adminPagesPerformance_OverviewPage"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.resourceUsageMetrics"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_adminPagesPerformance_Overview_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraResourceUsageMetricConnection",
                            "kind": "LinkedField",
                            "name": "resourceUsageMetrics",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraResourceUsageMetric",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "currentValue"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "warningValue"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "thresholdValue"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cleanupValue"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d2fe73ca0b47245563666951f775b77a3a261da2aeb574c289b15d04a8a13008",
            "metadata": {},
            "name": "main_adminPagesPerformance_Overview_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e90d0e4e68a4767b$var$node.hash = "65285ab59e67a0f62edb54671f986ddd";
var $e90d0e4e68a4767b$export$2e2bcd8739ae039 = $e90d0e4e68a4767b$var$node;

});


parcelRegister("ga2uX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("lJQsr")
]).then(()=>parcelRequire('m5Wpm'));

});

parcelRegister("ez4Wi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("f6Pe2")
]).then(()=>parcelRequire('9N1Sg'));

});

parcelRegister("4EVQj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("ddZe9")
]).then(()=>parcelRequire('ecfTq'));

});

parcelRegister("WjI3O", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("azCgO")
]).then(()=>parcelRequire('g953z'));

});

parcelRegister("h7R8c", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jc7P6")
]).then(()=>parcelRequire('7s4sD'));

});

parcelRegister("bWR2E", function(module, exports) {

$parcel$export(module.exports, "editPermissionSchemePageResource", () => $e9611696d488b3c2$export$2b6bb2f543863b53);

var $buJlM = parcelRequire("buJlM");

var $j2ZJ1 = parcelRequire("j2ZJ1");
const $e9611696d488b3c2$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE = 'EDIT_PERMISSION_SCHEME_PAGE';
const $e9611696d488b3c2$export$2b6bb2f543863b53 = (0, $buJlM.createRelayResource)({
    type: $e9611696d488b3c2$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $j2ZJ1.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`,
                first: 50
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("j2ZJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $271566d438978665$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e6d2609b22da674852d0d8a556caee0>>
 * @relayHash a8302edc7839549073bdffce737596f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c97cc5e281ea579c44e87ac7f80e5f399b27b3ac304b7267d4210b282a7a4b1
const $271566d438978665$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schemeId"
    }, v2 = {
        "kind": "Variable",
        "name": "schemeId",
        "variableName": "schemeId"
    }, v3 = [
        v2 /*: any*/ 
    ], v4 = {
        "kind": "ScalarField",
        "name": "isEditable"
    }, v5 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            v4 /*: any*/ 
        ]
    }, v6 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v2 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "kind": "ScalarField",
        "name": "description"
    }, v12 = {
        "kind": "ScalarField",
        "name": "text"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = [
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v13 /*: any*/ 
    ], v15 = [
        v9 /*: any*/ ,
        v13 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v3 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionCategories"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "header_editPermissionScheme"
                                            },
                                            v5 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.viewPermissionScheme"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v6 /*: any*/ ,
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "getProjectsByPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.getProjectsByPermissionScheme.edges.node.projectId"
                                                            }
                                                        ]
                                                    },
                                                    "action": "LOG",
                                                    "path": "jira.getProjectsByPermissionScheme.edges.node"
                                                }
                                            ]
                                        },
                                        "action": "LOG",
                                        "path": "jira.getProjectsByPermissionScheme.edges"
                                    }
                                ]
                            },
                            "action": "LOG",
                            "path": "jira.getProjectsByPermissionScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "configuration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "tag"
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionMessageExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "message",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionDocumentationExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "documentation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": v15 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": v15 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v13 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "totalCount"
                                                                },
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "getProjectsByPermissionScheme",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8c97cc5e281ea579c44e87ac7f80e5f399b27b3ac304b7267d4210b282a7a4b1",
            "metadata": {},
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$271566d438978665$var$node.hash = "9e1e7326d79aae057f4943753d3cd309";
var $271566d438978665$export$2e2bcd8739ae039 = $271566d438978665$var$node;

});


parcelRegister("i4OkI", function(module, exports) {

$parcel$export(module.exports, "permissionSchemePageResource", () => $16a6a6fc1d9bc0eb$export$58d9013f694fc9d0);

var $buJlM = parcelRequire("buJlM");

var $fxGo9 = parcelRequire("fxGo9");
const $16a6a6fc1d9bc0eb$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE = 'PERMISSION_SCHEME_PAGE';
const $16a6a6fc1d9bc0eb$export$58d9013f694fc9d0 = (0, $buJlM.createRelayResource)({
    type: $16a6a6fc1d9bc0eb$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $fxGo9.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("fxGo9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b1d4615581b3ab8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf59478679f84bf44b49fd41a2544ee4>>
 * @relayHash 0250f6408e8d8064d7cc97a77e2f5386
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb
const $0b1d4615581b3ab8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemeId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "schemeId",
            "variableName": "schemeId"
        }
    ], v2 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "description"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ], v9 = [
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v1 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "header_permissionScheme"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionsTable"
                                            },
                                            v2 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.viewPermissionScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v4 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb",
            "metadata": {},
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0b1d4615581b3ab8$var$node.hash = "41dd09a71a35c8ed416631b02fa73316";
var $0b1d4615581b3ab8$export$2e2bcd8739ae039 = $0b1d4615581b3ab8$var$node;

});


parcelRegister("kpCRE", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("diQgD")
]).then(()=>parcelRequire('5ZojE'));

});

parcelRegister("iP71V", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("ii2fE")
]).then(()=>parcelRequire('3u8K8'));

});

parcelRegister("415HX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRoute", () => $80c6d5cab0238cba$export$185af30f53271c10);
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", () => $80c6d5cab0238cba$export$518516cdf6b7cd83);

var $exb0h = parcelRequire("exb0h");
const $80c6d5cab0238cba$export$185af30f53271c10 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES),
    path: '/jira/settings/issues/priority-schemes'
};
const $80c6d5cab0238cba$export$518516cdf6b7cd83 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES),
    path: '/jira/settings/issues/priorities'
};

});

parcelRegister("aBYvY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("7KECY")
]).then(()=>parcelRequire('2aiJy'));

});

parcelRegister("c7KuD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("lKudi")
]).then(()=>parcelRequire('iaX98'));

});

parcelRegister("MOxZn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("iUIHQ")
]).then(()=>parcelRequire('5x7Pe'));

});

parcelRegister("8xBSc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jfQue")
]).then(()=>parcelRequire('ck4Nt'));

});

parcelRegister("9XHQi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("7hEhi")
]).then(()=>parcelRequire('lBHs5'));

});

parcelRegister("bzcVJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("6hJju")
]).then(()=>parcelRequire('hqQxd'));

});

parcelRegister("kcaE4", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRoute", () => $67e4c12bd9924041$export$6823cb5626e61bc7);
$parcel$export(module.exports, "routeNamesSystemConfigurationRedirectRoute", () => $67e4c12bd9924041$export$23418d655258dbfa);

var $exb0h = parcelRequire("exb0h");
const $67e4c12bd9924041$export$6823cb5626e61bc7 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_SYSTEM_CONFIGURATION),
    path: '/jira/settings/system/general-configuration',
    exact: true
};
const $67e4c12bd9924041$export$23418d655258dbfa = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: `${(0, $exb0h.ROUTE_NAMES_SYSTEM_CONFIGURATION)}-redirect`,
    path: '/secure/admin/ViewApplicationProperties.jspa',
    exact: true
};

});

parcelRegister("4GPTc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("e8Khf")
]).then(()=>parcelRequire('chrxL'));

});

parcelRegister("f9bq5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("adoZ8")
]).then(()=>parcelRequire('4t3gm'));

});

parcelRegister("cV7Hm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4386b43da954e2d2$export$2e2bcd8739ae039);

var $53ciZ = parcelRequire("53ciZ");

var $lB25E = parcelRequire("lB25E");

var $jnVHr = parcelRequire("jnVHr");

const $4386b43da954e2d2$var$workFlowsResource = (0, $lB25E.createResource)({
    type: (0, $810245ed2edcd973$export$b11854972ecaecc7),
    getKey: ({ query: query })=>`${0, $810245ed2edcd973$export$6602c5404301813f}-${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $jnVHr.getListWorkFlows)((0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(query))
});
var $4386b43da954e2d2$export$2e2bcd8739ae039 = $4386b43da954e2d2$var$workFlowsResource;

});
parcelRegister("jnVHr", function(module, exports) {

$parcel$export(module.exports, "getListWorkFlows", () => $419e001999630a80$export$952f5d693c3c0d4e);

var $53ciZ = parcelRequire("53ciZ");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $cagHD = parcelRequire("cagHD");

var $gU71n = parcelRequire("gU71n");
const $419e001999630a80$export$952f5d693c3c0d4e = async (qs)=>{
    const filter = (0, $gU71n.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify((0, $gU71n.toApiUrlTransformer)(filter));
    try {
        return await (0, $lRmyA.performGetRequest)(`/rest/api/3/workflow/search?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'getWorkflowsSearchAPI',
                packageName: (0, $cagHD.PACKAGE_NAME),
                teamName: 'helix'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("cagHD", function(module, exports) {

$parcel$export(module.exports, "SOURCE_NAME", () => $ebbc8a790944f941$export$a3821bc63538b210);
$parcel$export(module.exports, "WORKFLOW_NAME", () => $ebbc8a790944f941$export$a69699c3acbd94ca);
$parcel$export(module.exports, "PACKAGE_NAME", () => $ebbc8a790944f941$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "WORKFLOWS_ACTIONS", () => $ebbc8a790944f941$export$f3ab46ae5f3c01ad);
$parcel$export(module.exports, "WORKFLOWS_SCHEME", () => $ebbc8a790944f941$export$81c9aaf617cb2f01);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_JIRA_NAME", () => $ebbc8a790944f941$export$615f1d8b29794ae);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_BUILDS_WORKFLOWS_NAME", () => $ebbc8a790944f941$export$fccd4c1ce5f0896f);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $ebbc8a790944f941$export$5716e8bcb003888d);
$parcel$export(module.exports, "defaultListWorkFlowsFilter", () => $ebbc8a790944f941$export$dc5aae53031515c);
$parcel$export(module.exports, "ORDER", () => $ebbc8a790944f941$export$11e75bce9f7ea886);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $ebbc8a790944f941$export$9ac56b2484c2d4e9);
$parcel$export(module.exports, "PAGE_SIZE_CHANGE_ANALYTICS", () => $ebbc8a790944f941$export$e6613a3c77896936);
$parcel$export(module.exports, "API_PREFIX", () => $ebbc8a790944f941$export$a3f6840410eb0571);

const $ebbc8a790944f941$export$a3821bc63538b210 = 'listWorkflows';
const $ebbc8a790944f941$export$a69699c3acbd94ca = 'workflowName';
const $ebbc8a790944f941$export$b8b9d90f9e5bd72b = 'jira-admin-pages-list-workflows';
const $ebbc8a790944f941$export$f3ab46ae5f3c01ad = 'workflowsActions';
const $ebbc8a790944f941$export$81c9aaf617cb2f01 = 'workflowScheme';
const $ebbc8a790944f941$export$615f1d8b29794ae = 'jira';
const $ebbc8a790944f941$export$fccd4c1ce5f0896f = 'Builds Workflow';
const $ebbc8a790944f941$export$5716e8bcb003888d = 10;
const $ebbc8a790944f941$export$f6e7f4d903fd7165 = 'ADD_WORKFLOWS';
const $ebbc8a790944f941$export$dc5aae53031515c = {
    pageNumber: 1,
    pageSize: $ebbc8a790944f941$export$5716e8bcb003888d,
    expand: [
        'default',
        'hasDraftWorkflow',
        'schemes',
        'operations',
        'projects'
    ],
    orderBy: 'name',
    sortDirection: (0, $44cab0426b6cf0d7$export$1dee026a19752d6b),
    isActive: true
};
const $ebbc8a790944f941$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $ebbc8a790944f941$export$3c5e605ca7ade9f2 = 'NAME';
const $ebbc8a790944f941$export$b87f371cbc396fcf = 'TYPE';
const $ebbc8a790944f941$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});
const $ebbc8a790944f941$export$e6613a3c77896936 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'pageSize'
});
const $ebbc8a790944f941$export$a3f6840410eb0571 = 'gateway/api/jira/project-configuration';

});

parcelRegister("gU71n", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $59fd86c236a165ea$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $59fd86c236a165ea$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $59fd86c236a165ea$export$fb15afa686993f11);

var $4qDVh = parcelRequire("4qDVh");

var $cagHD = parcelRequire("cagHD");

var $ldklr = parcelRequire("ldklr");
const $59fd86c236a165ea$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy,
        isActive: isActive,
        pageSize: pageSize
    };
};
const $59fd86c236a165ea$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = params;
    const parsedNumber = Number.isNaN((0, $4qDVh.number).parse(pageNumber)) ? (0, $cagHD.defaultListWorkFlowsFilter).pageNumber : (0, $4qDVh.number).parse(pageNumber);
    const parsedSize = Number.isNaN((0, $4qDVh.number).parse(pageSize)) ? (0, $cagHD.defaultListWorkFlowsFilter).pageSize : (0, $4qDVh.number).parse(pageSize);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' || orderBy === 'updated' || orderBy === '-updated' ? orderBy : undefined;
    const isActiveFinal = isActive != null ? isActive === 'true' : (0, $cagHD.defaultListWorkFlowsFilter).isActive;
    return {
        ...(0, $cagHD.defaultListWorkFlowsFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        pageSize: parsedSize != null ? Number(parsedSize) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy,
        isActive: isActiveFinal
    };
};
const $59fd86c236a165ea$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = {
        ...(0, $cagHD.defaultListWorkFlowsFilter),
        ...filter
    };
    const { pageNumber: pageNumber = 1, pageSize: pageSize = (0, $cagHD.DEFAULT_PAGE_SIZE) } = fullFilter;
    let requestParams = {
        maxResults: pageSize,
        startAt: (pageNumber - 1) * pageSize,
        orderBy: fullFilter.orderBy,
        queryString: (0, $ldklr.trimSearchFilter)(fullFilter.searchFilter),
        isActive: fullFilter.isActive
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("ldklr", function(module, exports) {

$parcel$export(module.exports, "trimSearchFilter", () => $50287bb8c06d17c2$export$ed1722f41c23aaaf);
const $50287bb8c06d17c2$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $50287bb8c06d17c2$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $50287bb8c06d17c2$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});



const $810245ed2edcd973$export$b11854972ecaecc7 = 'WORKFLOWS_TABLE';
const $810245ed2edcd973$export$6602c5404301813f = 'WORKFLOWS_TABLE_KEY';


parcelRegister("32Eub", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("9HG9Z")
]).then(()=>parcelRequire('7s4ac'));

});

parcelRegister("dudew", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("idgZe").then(()=>parcelRequire('7QYqA'));

});

parcelRegister("8zjVA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("c4S7g").then(()=>parcelRequire('jku3m'));

});

parcelRegister("47r3J", function(module, exports) {

$parcel$export(module.exports, "servicedeskIssueTypesResource", () => $9e5555754d0080d2$export$191ce50629f40dbe);

var $lB25E = parcelRequire("lB25E");


const $9e5555754d0080d2$var$getDataLoader = ()=>(parcelRequire("fPqpB"));
const $9e5555754d0080d2$export$191ce50629f40dbe = (0, $lB25E.createResource)({
    type: (0, $63f82a515eeafde8$export$1ed713fe52212251),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $9e5555754d0080d2$var$getDataLoader
});

});
const $63f82a515eeafde8$export$1ed713fe52212251 = 'SERVICEDESK_ISSUE_TYPES';

parcelRegister("fPqpB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dTE5Q").then(()=>parcelRequire('gCRzh'));

});


parcelRegister("6RfAJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskPortalGroupsResource", () => $66f115839490fc3c$export$c7fb28234b909b2f);

var $lB25E = parcelRequire("lB25E");


const $66f115839490fc3c$var$getDataLoader = ()=>(parcelRequire("k9Jl0"));
const $66f115839490fc3c$var$ONE_DAY_IN_MILLIS = 86400000;
const $66f115839490fc3c$export$c7fb28234b909b2f = (0, $lB25E.createResource)({
    type: (0, $c46e3647a9aeab0e$export$4160f2c498fcd32e),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $66f115839490fc3c$var$getDataLoader,
    maxAge: $66f115839490fc3c$var$ONE_DAY_IN_MILLIS
});

});
const $c46e3647a9aeab0e$export$4160f2c498fcd32e = 'SERVICEDESK_PORTAL_GROUPS';

parcelRegister("k9Jl0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ali6S").then(()=>parcelRequire('8vud6'));

});


parcelRegister("6ErPW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("65b9H")
]).then(()=>parcelRequire('k0mRB'));

});

parcelRegister("60Ico", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("fukBQ")
]).then(()=>parcelRequire('90B3A'));

});

parcelRegister("lsy4i", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jSMUk")
]).then(()=>parcelRequire('hCfNM'));

});

parcelRegister("5Xs8s", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("g48nx")
]).then(()=>parcelRequire('vVQjF'));

});

parcelRegister("4NVcr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("lVmxt")
]).then(()=>parcelRequire('2KsIQ'));

});

parcelRegister("9urUx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5f3d9fe15c0dae80$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Ti3v = parcelRequire("4Ti3v");

var $u0mbR = parcelRequire("u0mbR");

var $agcDm = parcelRequire("agcDm");

var $emcAw = parcelRequire("emcAw");
const $5f3d9fe15c0dae80$var$MultiProjectSidebarCore = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $u0mbR.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agcDm.PerformanceMark), {
        id: (0, $agcDm.RENDER_START_MARK)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emcAw.default), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $u0mbR.SidebarReady), {
        id: (0, $4Ti3v.SIDEBAR_ID).CORE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agcDm.PerformanceMark), {
        id: (0, $agcDm.RENDER_END_MARK)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agcDm.PerformanceReport), null)));
var $5f3d9fe15c0dae80$export$2e2bcd8739ae039 = $5f3d9fe15c0dae80$var$MultiProjectSidebarCore;

});
parcelRegister("agcDm", function(module, exports) {

$parcel$export(module.exports, "RENDER_START_MARK", () => $2c9144edaf673b4b$export$8f8203e04f80aed);
$parcel$export(module.exports, "RENDER_END_MARK", () => $2c9144edaf673b4b$export$dc795f9b21e2778a);
$parcel$export(module.exports, "PerformanceMark", () => $2c9144edaf673b4b$export$b8228db3a01d9a76);
$parcel$export(module.exports, "PerformanceReport", () => $2c9144edaf673b4b$export$c97ab321326d29f7);

var $eUqFw = parcelRequire("eUqFw");

var $lNfG4 = parcelRequire("lNfG4");
const $2c9144edaf673b4b$var$JWM_SIDEBAR_SEGMENT_NAME = 'jwm.sidebar';
const $2c9144edaf673b4b$export$8f8203e04f80aed = `${$2c9144edaf673b4b$var$JWM_SIDEBAR_SEGMENT_NAME}.render.start`;
const $2c9144edaf673b4b$export$dc795f9b21e2778a = `${$2c9144edaf673b4b$var$JWM_SIDEBAR_SEGMENT_NAME}.render.end`;
const $2c9144edaf673b4b$var$segment = (0, $lNfG4.metrics).pageSegmentLoad({
    key: $2c9144edaf673b4b$var$JWM_SIDEBAR_SEGMENT_NAME,
    timings: [
        {
            key: 'tti',
            endMark: $2c9144edaf673b4b$export$dc795f9b21e2778a
        }
    ]
});
const $2c9144edaf673b4b$export$b8228db3a01d9a76 = ({ id: id })=>{
    const startedRef = (0, $eUqFw.useRef)(false);
    if (!false && !startedRef.current) {
        $2c9144edaf673b4b$var$segment.startFromPageLoad();
        startedRef.current = true;
    }
    (0, $eUqFw.useEffect)(()=>$2c9144edaf673b4b$var$segment.mark(id), [
        id
    ]);
    return null;
};
const $2c9144edaf673b4b$export$c97ab321326d29f7 = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        $2c9144edaf673b4b$var$segment.stop();
    }, []);
    return null;
};

});

parcelRegister("emcAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7cfc64baafae021$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gP3W1 = parcelRequire("gP3W1");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5cLMB = parcelRequire("5cLMB");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $f26dB = parcelRequire("f26dB");

var $6yplV = parcelRequire("6yplV");

var $lB25E = parcelRequire("lB25E");

var $57SqH = parcelRequire("57SqH");

var $lcKPv = parcelRequire("lcKPv");

var $gTasH = parcelRequire("gTasH");

var $8l70H = parcelRequire("8l70H");

var $4h0Ly = parcelRequire("4h0Ly");

var $9QtHd = parcelRequire("9QtHd");

var $439fx = parcelRequire("439fx");
const $b7cfc64baafae021$var$MultiProjectMenu = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { currentProject: currentProject, recents: recents, favorites: favorites, hasMoreFavorite: hasMoreFavorite, onFavoriteToggle: onFavoriteToggle, overviews: overviews, overviewsError: overviewsError, shouldHideOverviews: shouldHideOverviews, loading: loading } = (0, $57SqH.useSidebarData)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const isPremiumUserSeat = (0, $f26dB.useIsPremiumUserSeat)();
    const [projectState] = (0, $5cLMB.useProjectState)();
    const [{ match: { params: { projectKey: projectKey } } }] = (0, $lB25E.useRouter)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebar viewed', {
            starredProjectsCount: favorites.length,
            recentProjectsCount: recents.length,
            overviewsCount: overviews.length
        });
    // only run once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // the currentProject data gets loaded async and thus it is null while
    // transitioning between projects. To allow expanding the right current
    // project when the data has not been resolved yet, we use the project
    // key from the URL instead.
    const currentProjectKey = projectKey ?? currentProject?.key;
    const shouldDisplayOverviews = isPremiumUserSeat && !isAnonymous && !shouldHideOverviews;
    const projectsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", null, favorites.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9QtHd.default), {
        sectionId: "starred",
        projects: favorites,
        onFavoriteToggle: onFavoriteToggle,
        currentProjectKey: currentProjectKey,
        showViewAllProjects: hasMoreFavorite,
        viewAllProjectsLabel: formatMessage((0, $8l70H.default).viewAllStarred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9QtHd.default), {
        sectionId: "recent",
        projects: recents,
        onFavoriteToggle: onFavoriteToggle,
        currentProjectKey: currentProjectKey,
        showViewAllProjects: true
    }));
    const isShowingCTA = projectState?.isSampleProject === true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SidebarWrapper, {
        "aria-label": formatMessage((0, $8l70H.default).navigationLabel),
        isCrossProjectView: true
    }, shouldDisplayOverviews && (loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$OverviewsSkeleton, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4h0Ly.default), {
        overviews: overviews,
        hasError: Boolean(overviewsError)
    }))), loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ProjectsSkeleton, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $439fx.default), null), projectsContent), !loading && isShowingCTA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcKPv.CreateProjectCta), null)), (0, $eI5EY.fg)('jwm_mobile_discovery') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gP3W1.AsyncMobileDownloadPrompt), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$Footer, {
        hasMargin: true
    }, currentProject != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$Type, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.project-type"
    }, currentProject.isSimplified ? formatMessage((0, $8l70H.default).teamManagedProject) : formatMessage((0, $8l70H.default).companyManagedProject)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gTasH.default), null)));
};
const $b7cfc64baafae021$var$ItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemAvatarSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SkeletonBase, null));
const $b7cfc64baafae021$var$OverviewsSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SkeletonSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SectionHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null));
const $b7cfc64baafae021$var$ProjectsSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SkeletonSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SectionHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$CollapsibleHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$CollapsibleHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _11q7vuon",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$SidebarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "nav", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCrossProjectView: isCrossProjectView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdpxbi _19bvpxbi _u5f3pxbi _19pkr5cr _otyridpf _18u0idpf _2hwxidpf _1reo1wug _18m91wug _16jlkb7n _1o9zkb7n _i0dlf1ug _11q71mi8 _12vemgnk _1lrwy1fe _qmxj4ebz _qjkj6grs _azbnu2gc",
            __cmplp.isCrossProjectView ? "_ca0qpxbi" : "_ca0q1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$SkeletonBase = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q7iw92 _4t3i1crf _1bsbqkoa _2rko1y44 _otyrutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$SkeletonSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$SectionHeaderSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b7cfc64baafae021$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb68cl _4t3i7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$ItemSkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$ItemAvatarSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b7cfc64baafae021$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _18u0utpp _2hwxutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$CollapsibleHeaderSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b7cfc64baafae021$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbys9h _18u0u2gc _19pkutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$Footer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasMargin: hasMargin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.hasMargin && "_18s8u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$Type = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81vlj _y3gn1h6o _18s8swc3 _1tke7vkz _syaz1rc1",
            __cmplp.className
        ])
    });
});
var $b7cfc64baafae021$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b7cfc64baafae021$var$MultiProjectMenu);

});
parcelRegister("gP3W1", function(module, exports) {

$parcel$export(module.exports, "AsyncMobileDownloadPrompt", () => $67b3342293e0228e$export$64ca7d64bb703770);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");


var $ldsZq = parcelRequire("ldsZq");
const $67b3342293e0228e$var$runtimeProps = {};
const $67b3342293e0228e$var$entryPointParams = {};
const $67b3342293e0228e$export$64ca7d64bb703770 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $ldsZq.downloadMobilePromptEntryPoint), $67b3342293e0228e$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jiraBusinessDownloadMobilePrompt",
        packageName: (0, $eed20802841d894c$export$b8b9d90f9e5bd72b),
        teamName: "frontier",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $67b3342293e0228e$var$runtimeProps,
        errorFallback: "unmount"
    });
};

});
const $eed20802841d894c$export$b8b9d90f9e5bd72b = 'jiraBusinessMobileDownloadPrompt';

parcelRegister("ldsZq", function(module, exports) {

$parcel$export(module.exports, "downloadMobilePromptEntryPoint", () => $c626ef33a70c140f$export$66f4c5613c7e964);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $c626ef33a70c140f$export$66f4c5613c7e964 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("k4Zp8")), {
        moduleId: "c94481ab"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("k4Zp8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bApOA").then(()=>parcelRequire('cGSJA'));

});



parcelRegister("5cLMB", function(module, exports) {

$parcel$export(module.exports, "useJswOnboarding", () => $502e2dc73b97f226$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $502e2dc73b97f226$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $502e2dc73b97f226$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $502e2dc73b97f226$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $502e2dc73b97f226$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useShouldShowOpenMenuItem", () => $502e2dc73b97f226$export$d994ff8c0341aba1);
$parcel$export(module.exports, "useInviteToProject", () => $502e2dc73b97f226$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $502e2dc73b97f226$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $502e2dc73b97f226$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $502e2dc73b97f226$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $502e2dc73b97f226$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $502e2dc73b97f226$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $502e2dc73b97f226$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $502e2dc73b97f226$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $502e2dc73b97f226$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $502e2dc73b97f226$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $502e2dc73b97f226$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $502e2dc73b97f226$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $502e2dc73b97f226$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $502e2dc73b97f226$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $502e2dc73b97f226$export$521909e3dc7ab811);
$parcel$export(module.exports, "usePersonaExperience", () => $502e2dc73b97f226$export$8e98a1e4d2dbf1b9);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("7dRgX")).QUICKSTART_UI_STATUS);

var $9CmwD = parcelRequire("9CmwD");

var $eI5EY = parcelRequire("eI5EY");

var $WBLbN = parcelRequire("WBLbN");

var $7dRgX = parcelRequire("7dRgX");

var $c8ave = parcelRequire("c8ave");

var $lCsoa = parcelRequire("lCsoa");

var $fricC = parcelRequire("fricC");

var $5OjXh = parcelRequire("5OjXh");

var $egHFE = parcelRequire("egHFE");

const $502e2dc73b97f226$export$390f32400eaf98c9 = (0, $WBLbN.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $lCsoa.initialState,
    actions: $c8ave
});
const $502e2dc73b97f226$export$1cbc60d8dd921852 = (0, $WBLbN.createSubscriber)($502e2dc73b97f226$export$390f32400eaf98c9);
const $502e2dc73b97f226$export$7d91c0af4772787a = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9);
const $502e2dc73b97f226$export$638bfcfce1254bb8 = (0, $WBLbN.createContainer)($502e2dc73b97f226$export$390f32400eaf98c9, {});
const $502e2dc73b97f226$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $502e2dc73b97f226$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $502e2dc73b97f226$export$594f006fa6a1b2e5 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$ea14030920a5d8e6
});
const $502e2dc73b97f226$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $502e2dc73b97f226$export$c5e63e44ad178ae8 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$a943afa434e9487a
});
const $502e2dc73b97f226$export$2c3cd14fff9d6e43 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: null
});
const $502e2dc73b97f226$export$b0db7e46e369e1d9 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$9d731f44f82af09f
});
// TODO: KURO-1678, delete - The function can be removed during jsw_feedback_account_id cleanup
const $502e2dc73b97f226$var$useShouldShowOpenMenuItemHook = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.shouldRenderComponent && state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)] === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED
});
const $502e2dc73b97f226$export$d994ff8c0341aba1 = ()=>{
    const [shouldShow, { nextSetChecklistIsDismissed: nextSetChecklistIsDismissed }] = $502e2dc73b97f226$var$useShouldShowOpenMenuItemHook();
    return {
        shouldShow: shouldShow,
        setIsDismissed: nextSetChecklistIsDismissed
    };
};
const $502e2dc73b97f226$export$71de79653346a1ea = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $502e2dc73b97f226$export$61185a9266f1f57a = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN || userRole === (0, $fricC.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $502e2dc73b97f226$export$ef4747ba36826d6a = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $502e2dc73b97f226$export$522993b46d9f8266 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $eI5EY.fg)('jsw_onboarding_reactufo_qs') ? (0, $egHFE.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED : (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $502e2dc73b97f226$export$aa4ba29241532382 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $502e2dc73b97f226$export$ed5c755b733bf2b1 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $502e2dc73b97f226$export$35fe0366802512dd = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)];
        return visibility === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED && (0, $eI5EY.fg)('jsw-perf-async-add-people-modal-load');
    }
});
const $502e2dc73b97f226$export$a41ee0d3b6938099 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $502e2dc73b97f226$export$4ae7b465b076be9 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $502e2dc73b97f226$export$bf6e646c0476acad = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $502e2dc73b97f226$export$6b706bff94798d11 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $502e2dc73b97f226$export$c98db656edc5b3e1 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $502e2dc73b97f226$export$a823278ac9d1112b = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, $9CmwD.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN)
});
const $502e2dc73b97f226$export$cb9e0e8fe4df8490 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, $9CmwD.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $7dRgX.KANBAN_ONBOARDING_TASK)))
});
const $502e2dc73b97f226$export$521909e3dc7ab811 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $502e2dc73b97f226$export$f4a2be940259bf95 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});
const $502e2dc73b97f226$export$8e98a1e4d2dbf1b9 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.personaExperience
});

});
parcelRegister("7dRgX", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $3913ca223572f8d7$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $3913ca223572f8d7$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $3913ca223572f8d7$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $3913ca223572f8d7$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $3913ca223572f8d7$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $3913ca223572f8d7$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $3913ca223572f8d7$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $3913ca223572f8d7$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $3913ca223572f8d7$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $3913ca223572f8d7$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $3913ca223572f8d7$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $3913ca223572f8d7$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $3913ca223572f8d7$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "KEY_IS_DEVOPS_PROJECT", () => $3913ca223572f8d7$export$e5b557e3bbb7ec52);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $3913ca223572f8d7$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $3913ca223572f8d7$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $3913ca223572f8d7$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $3913ca223572f8d7$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $3913ca223572f8d7$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $3913ca223572f8d7$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $3913ca223572f8d7$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $3913ca223572f8d7$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $3913ca223572f8d7$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $3913ca223572f8d7$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $3913ca223572f8d7$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $3913ca223572f8d7$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $3913ca223572f8d7$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $3913ca223572f8d7$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $3913ca223572f8d7$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $3913ca223572f8d7$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $3913ca223572f8d7$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $3913ca223572f8d7$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $3913ca223572f8d7$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $3913ca223572f8d7$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $3913ca223572f8d7$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $3913ca223572f8d7$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $3913ca223572f8d7$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $3913ca223572f8d7$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $3913ca223572f8d7$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $3913ca223572f8d7$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $3913ca223572f8d7$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $3913ca223572f8d7$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $3913ca223572f8d7$export$9048315f2c03fd9d);
$parcel$export(module.exports, "GET_TO_KNOW_YOUR_TEMPLATE_TASK", () => $3913ca223572f8d7$export$a333714599f14a6);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $3913ca223572f8d7$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $3913ca223572f8d7$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $3913ca223572f8d7$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $3913ca223572f8d7$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $3913ca223572f8d7$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $3913ca223572f8d7$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $3913ca223572f8d7$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $3913ca223572f8d7$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $3913ca223572f8d7$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $3913ca223572f8d7$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $3913ca223572f8d7$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $3913ca223572f8d7$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $3913ca223572f8d7$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $3913ca223572f8d7$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $3913ca223572f8d7$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $3913ca223572f8d7$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $3913ca223572f8d7$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $3913ca223572f8d7$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $3913ca223572f8d7$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $3913ca223572f8d7$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $3913ca223572f8d7$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $3913ca223572f8d7$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $3913ca223572f8d7$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $3913ca223572f8d7$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $3913ca223572f8d7$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $3913ca223572f8d7$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $3913ca223572f8d7$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $3913ca223572f8d7$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $3913ca223572f8d7$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $3913ca223572f8d7$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $3913ca223572f8d7$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $3913ca223572f8d7$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $3913ca223572f8d7$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $3913ca223572f8d7$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $3913ca223572f8d7$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $3913ca223572f8d7$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $3913ca223572f8d7$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $3913ca223572f8d7$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $3913ca223572f8d7$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $3913ca223572f8d7$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $3913ca223572f8d7$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $3913ca223572f8d7$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $3913ca223572f8d7$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $3913ca223572f8d7$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $3913ca223572f8d7$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $3913ca223572f8d7$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $3913ca223572f8d7$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $3913ca223572f8d7$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $3913ca223572f8d7$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $3913ca223572f8d7$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $3913ca223572f8d7$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $3913ca223572f8d7$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $3913ca223572f8d7$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $3913ca223572f8d7$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $3913ca223572f8d7$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $3913ca223572f8d7$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $3913ca223572f8d7$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $3913ca223572f8d7$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $3913ca223572f8d7$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $3913ca223572f8d7$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $3913ca223572f8d7$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $3913ca223572f8d7$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $3913ca223572f8d7$export$736b40db8701ba6c);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $3913ca223572f8d7$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $3913ca223572f8d7$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $3913ca223572f8d7$export$1de5766b7e640d6b);
$parcel$export(module.exports, "DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK", () => $3913ca223572f8d7$export$8ab0859f5b30b013);
$parcel$export(module.exports, "DEVOPS_GET_TO_KNOW_JIRA_TASK", () => $3913ca223572f8d7$export$d1f6d18c6698104c);
$parcel$export(module.exports, "DEVOPS_NAVIGATE_YOUR_TOOLS_TASK", () => $3913ca223572f8d7$export$e6ee159eee7adc1c);
$parcel$export(module.exports, "DEVOPS_CAPTURE_INTEGRATIONS_TASK", () => $3913ca223572f8d7$export$dd267ca1e3cd3bad);
$parcel$export(module.exports, "DEVOPS_CREATE_AUTOMATION_RULES_TASK", () => $3913ca223572f8d7$export$f14c8bffc35200d3);
$parcel$export(module.exports, "DEVOPS_INVITE_TEAMMATES_TASK", () => $3913ca223572f8d7$export$36cc22c9997d92a);
$parcel$export(module.exports, "DEVOPS_FIND_HELP_TASK", () => $3913ca223572f8d7$export$d651cc94a46ff383);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $3913ca223572f8d7$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $3913ca223572f8d7$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $3913ca223572f8d7$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $3913ca223572f8d7$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $3913ca223572f8d7$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $3913ca223572f8d7$export$f779bbfe667acddc);
$parcel$export(module.exports, "JWM_BOARD_TASK", () => $3913ca223572f8d7$export$42a8341e3c94a2be);
$parcel$export(module.exports, "JWM_SUMMARY_TASK", () => $3913ca223572f8d7$export$e29c6a916affb308);
$parcel$export(module.exports, "JWM_INVITE_TEAM_TASK", () => $3913ca223572f8d7$export$bc193be3ff1dd519);
$parcel$export(module.exports, "JWM_PAGES_TASK", () => $3913ca223572f8d7$export$73a289f194001f88);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $3913ca223572f8d7$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $3913ca223572f8d7$export$7578902c7f420a3);

var $exb0h = parcelRequire("exb0h");

var $6vrw7 = parcelRequire("6vrw7");
const $3913ca223572f8d7$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$var$completeDevopsTaskName = (taskId)=>`devops-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $3913ca223572f8d7$export$2b3151a089bc8780 = 'jlove-makkuro';
const $3913ca223572f8d7$export$6826d33e9a2c0119 = 320;
const $3913ca223572f8d7$export$b580da85daad7757 = 'root';
const $3913ca223572f8d7$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $3913ca223572f8d7$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $3913ca223572f8d7$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $3913ca223572f8d7$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $3913ca223572f8d7$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $3913ca223572f8d7$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $3913ca223572f8d7$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $3913ca223572f8d7$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $3913ca223572f8d7$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $3913ca223572f8d7$export$e5b557e3bbb7ec52 = 'isDevopsProject';
const $3913ca223572f8d7$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $3913ca223572f8d7$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $3913ca223572f8d7$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $3913ca223572f8d7$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $3913ca223572f8d7$export$cbeb719208f32c8a = $3913ca223572f8d7$var$completeJswTaskName('add-columns-task');
const $3913ca223572f8d7$export$88c918f2cfaff86 = $3913ca223572f8d7$var$completeJswTaskName('create-project-task');
const $3913ca223572f8d7$export$abbbea7c37c93cb5 = $3913ca223572f8d7$var$completeJswTaskName('create-issue-task');
const $3913ca223572f8d7$export$2a0253cb20f48a8 = $3913ca223572f8d7$var$completeJswTaskName('create-issue-task-simplified');
const $3913ca223572f8d7$export$f97428bb4b1991ec = $3913ca223572f8d7$var$completeJswTaskName('invite-teammates-task');
const $3913ca223572f8d7$export$45eaf4204fcc7 = $3913ca223572f8d7$var$completeJswTaskName('invite-teammates-video-task');
const $3913ca223572f8d7$export$af57685e201438e8 = $3913ca223572f8d7$var$completeJswTaskName('capture-integrations-task');
const $3913ca223572f8d7$export$d6c67e9aab4e2b26 = $3913ca223572f8d7$var$completeJswTaskName('find-help-task');
const $3913ca223572f8d7$export$3de8c242d2b82f26 = $3913ca223572f8d7$var$completeJswTaskName('set-up-board-task');
const $3913ca223572f8d7$export$a01fa44f793dbfac = $3913ca223572f8d7$var$completeJswTaskName('get-mobile-app-task');
const $3913ca223572f8d7$export$6a4507e462fd41da = $3913ca223572f8d7$var$completeJswTaskName('map-out-your-project-goals');
const $3913ca223572f8d7$export$e64c1dced6ac4458 = $3913ca223572f8d7$var$completeJswTaskName('identify-small-chunks-of-work');
const $3913ca223572f8d7$export$63b0e55f9c6454ac = $3913ca223572f8d7$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $3913ca223572f8d7$export$c1effb1c8979fe22 = $3913ca223572f8d7$var$completeJswTaskName('monitor-manage-risk');
const $3913ca223572f8d7$export$d97d31d934dbb194 = $3913ca223572f8d7$var$completeJswTaskName('premium-reverse-trial-task');
const $3913ca223572f8d7$export$cafb5bd13b02056b = $3913ca223572f8d7$var$completeJswTaskName('premium-edition-overview-task');
const $3913ca223572f8d7$export$e55c18b809946e72 = $3913ca223572f8d7$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $3913ca223572f8d7$export$de5640b9ae8140a7 = $3913ca223572f8d7$var$completeJswTaskName('standard-edition-overview-task');
const $3913ca223572f8d7$export$540b5c3c4b6ce459 = $3913ca223572f8d7$var$completeJswTaskName('advanced-roadmaps-task');
const $3913ca223572f8d7$export$6f71dff531ff592 = $3913ca223572f8d7$var$completeJswTaskName('change-control-task');
const $3913ca223572f8d7$export$83255ab79e45f34f = $3913ca223572f8d7$var$completeJswTaskName('automations-task');
const $3913ca223572f8d7$export$b57d172af9ad7647 = $3913ca223572f8d7$var$completeJswTaskName('site-administrations-task');
const $3913ca223572f8d7$export$ff4c933c1fe90b68 = $3913ca223572f8d7$var$completeJswTaskName('user-management-task');
const $3913ca223572f8d7$export$3e2776d61f3662dc = $3913ca223572f8d7$var$completeJswTaskName('scrum-onboarding-task');
const $3913ca223572f8d7$export$9048315f2c03fd9d = $3913ca223572f8d7$var$completeJswTaskName('customize-site-name-task');
const $3913ca223572f8d7$export$a333714599f14a6 = $3913ca223572f8d7$var$completeJswTaskName('get-to-know-your-template-task');
const $3913ca223572f8d7$export$4145c2cec2da6f9b = $3913ca223572f8d7$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $3913ca223572f8d7$export$4957a1ad203cf6dd = $3913ca223572f8d7$var$completeJswTaskName('try-atlassian-university-task');
const $3913ca223572f8d7$export$190b5dd0a1322552 = $3913ca223572f8d7$var$completeJswTaskName('calendar-view-task');
const $3913ca223572f8d7$export$501166b25f254aab = $3913ca223572f8d7$var$completeJwmTaskName('jwm-project-summary-task');
const $3913ca223572f8d7$export$94ad6507a703f4eb = $3913ca223572f8d7$var$completeJwmTaskName('jwm-create-sample-project-task');
const $3913ca223572f8d7$export$be1c522400a1bd7c = $3913ca223572f8d7$var$completeJwmTaskName('background-color-task');
const $3913ca223572f8d7$export$2aa6e7b6e24a04f5 = $3913ca223572f8d7$var$completeJwmTaskName('calendar-task');
const $3913ca223572f8d7$export$f3b53199b07af2a1 = $3913ca223572f8d7$var$completeJwmTaskName('timeline-task');
const $3913ca223572f8d7$export$d37415ffddcf2142 = $3913ca223572f8d7$var$completeJwmTaskName('build-form-task');
const $3913ca223572f8d7$export$2ae00586da7cb606 = $3913ca223572f8d7$var$completeJwmTaskName('feedback-task');
const $3913ca223572f8d7$export$b86266e6594a97bb = $3913ca223572f8d7$var$completeJwmTaskName('feedback-sample-project-task');
const $3913ca223572f8d7$export$20bc3dc137ac1c38 = $3913ca223572f8d7$var$completeJwmTaskName('create-your-own-project-task');
const $3913ca223572f8d7$export$77071b77e2801b18 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-create-project-task');
const $3913ca223572f8d7$export$9c89f946f05d884a = $3913ca223572f8d7$var$completeJwmTaskName('share-project-task');
const $3913ca223572f8d7$export$ce8b25442735839a = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-boards');
const $3913ca223572f8d7$export$31015cf4e430c94d = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-cards');
const $3913ca223572f8d7$export$b52a7c936684cfc5 = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-import');
const $3913ca223572f8d7$export$b5555f24061f9fb = $3913ca223572f8d7$var$completeJwmTaskName('summary-and-reports-task');
const $3913ca223572f8d7$export$ff25449f34b8abf = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $3913ca223572f8d7$export$3380e677209260fe = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-key-differences');
const $3913ca223572f8d7$export$7a2fcaad1564e6b7 = $3913ca223572f8d7$var$completeJwmTaskName('get-started-list-task');
const $3913ca223572f8d7$export$da23b72d32bfad9e = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $3913ca223572f8d7$export$4b064659282e0238 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $3913ca223572f8d7$export$3ab51851f6d823e = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $3913ca223572f8d7$export$e4a1a37a9a1350ad = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $3913ca223572f8d7$export$b7f7da5e795f0327 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $3913ca223572f8d7$export$80a401c1aa47a377 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $3913ca223572f8d7$export$934ac7a251b26dc7 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $3913ca223572f8d7$export$4634f6395df3ebbe = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $3913ca223572f8d7$export$768fb41107a1e8d7 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $3913ca223572f8d7$export$d797a81bace17184 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $3913ca223572f8d7$export$746102c94db9df1f = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $3913ca223572f8d7$export$5f1efd797d65e349 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $3913ca223572f8d7$export$cccc812ccafbf11f = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $3913ca223572f8d7$export$64822db87abd8a47 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $3913ca223572f8d7$export$64f764d8be495c82 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $3913ca223572f8d7$export$24eae23dc1c68bbd = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $3913ca223572f8d7$export$50fa92eba6f82feb = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $3913ca223572f8d7$export$4155d22fe3f14cd6 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $3913ca223572f8d7$export$76813cbead887191 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $3913ca223572f8d7$export$90aab2ff89daf770 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $3913ca223572f8d7$export$a2bc0cbad2e6e605 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $3913ca223572f8d7$export$f90872a1280728bb = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $3913ca223572f8d7$export$bce644e96518cbd2 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $3913ca223572f8d7$export$241aaebffac0a3e5 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $3913ca223572f8d7$export$f9dfc43b5b31c4b7 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $3913ca223572f8d7$export$79759e9e62fb9312 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $3913ca223572f8d7$export$992d1e0dce255d19 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $3913ca223572f8d7$export$d28c1b0e5b3e768 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $3913ca223572f8d7$export$ca714ee197bed4ec = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $3913ca223572f8d7$export$faae55ceea4b6073 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $3913ca223572f8d7$export$200bc24cd120667e = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $3913ca223572f8d7$export$a0d784a48b4e886c = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $3913ca223572f8d7$export$baf5bd09b4b33b8a = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $3913ca223572f8d7$export$4702007eedbca8ab = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $3913ca223572f8d7$export$aa9d2d635ea63898 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $3913ca223572f8d7$export$2ea449225c1f6cac = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $3913ca223572f8d7$export$deb8b557e735e26a = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $3913ca223572f8d7$export$d45754df44e4c309 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $3913ca223572f8d7$export$78b2913b550edbb = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $3913ca223572f8d7$export$71243272608c58ab = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $3913ca223572f8d7$export$39a08f215c33bc39 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $3913ca223572f8d7$export$d2377f6a6fa3b49c = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $3913ca223572f8d7$export$befa8f6533309779 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $3913ca223572f8d7$export$736b40db8701ba6c = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $3913ca223572f8d7$export$99b0e09ff6f00490 = $3913ca223572f8d7$var$completeJsmTaskName('customize-your-request-types-task');
const $3913ca223572f8d7$export$2a82344eb273eeff = $3913ca223572f8d7$var$completeJsmTaskName('review-your-channels-task');
const $3913ca223572f8d7$export$1de5766b7e640d6b = $3913ca223572f8d7$var$completeJsmTaskName('invite-your-team-task');
const $3913ca223572f8d7$export$8ab0859f5b30b013 = $3913ca223572f8d7$var$completeDevopsTaskName('welcome-to-your-project-task');
const $3913ca223572f8d7$export$d1f6d18c6698104c = $3913ca223572f8d7$var$completeDevopsTaskName('get-to-know-jira-task');
const $3913ca223572f8d7$export$e6ee159eee7adc1c = $3913ca223572f8d7$var$completeDevopsTaskName('navigate-your-tools-task');
const $3913ca223572f8d7$export$dd267ca1e3cd3bad = $3913ca223572f8d7$var$completeDevopsTaskName('capture-integrations-task');
const $3913ca223572f8d7$export$f14c8bffc35200d3 = $3913ca223572f8d7$var$completeDevopsTaskName('create-automation-rules-task');
const $3913ca223572f8d7$export$36cc22c9997d92a = $3913ca223572f8d7$var$completeDevopsTaskName('invite-teammates-task');
const $3913ca223572f8d7$export$d651cc94a46ff383 = $3913ca223572f8d7$var$completeDevopsTaskName('find-help-task');
const $3913ca223572f8d7$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $3913ca223572f8d7$export$c8ab6996f562d0db = (0, $6vrw7.toAccountId)('accountId');
const $3913ca223572f8d7$export$2b5f951ad8e70cfe = $3913ca223572f8d7$var$completeJswTaskName('kanban-onboarding-task');
const $3913ca223572f8d7$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $3913ca223572f8d7$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $3913ca223572f8d7$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $3913ca223572f8d7$export$f779bbfe667acddc = [
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
    (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS)
];
const $3913ca223572f8d7$export$42a8341e3c94a2be = $3913ca223572f8d7$var$completeJwmTaskName('jwm-board-task');
const $3913ca223572f8d7$export$e29c6a916affb308 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-summary-task');
const $3913ca223572f8d7$export$bc193be3ff1dd519 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-invite-team-task');
const $3913ca223572f8d7$export$73a289f194001f88 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-pages-task');
const $3913ca223572f8d7$export$38fbac7a5bf4aa33 = [
    $3913ca223572f8d7$export$2a82344eb273eeff,
    $3913ca223572f8d7$export$99b0e09ff6f00490,
    $3913ca223572f8d7$export$1de5766b7e640d6b
];
const $3913ca223572f8d7$export$7578902c7f420a3 = [
    $3913ca223572f8d7$export$88c918f2cfaff86,
    $3913ca223572f8d7$export$6a4507e462fd41da,
    $3913ca223572f8d7$export$e64c1dced6ac4458,
    $3913ca223572f8d7$export$63b0e55f9c6454ac,
    $3913ca223572f8d7$export$c1effb1c8979fe22,
    $3913ca223572f8d7$export$cbeb719208f32c8a,
    $3913ca223572f8d7$export$abbbea7c37c93cb5,
    $3913ca223572f8d7$export$2a0253cb20f48a8,
    $3913ca223572f8d7$export$f97428bb4b1991ec,
    $3913ca223572f8d7$export$d6c67e9aab4e2b26,
    $3913ca223572f8d7$export$3de8c242d2b82f26,
    $3913ca223572f8d7$export$a01fa44f793dbfac,
    $3913ca223572f8d7$export$45eaf4204fcc7,
    $3913ca223572f8d7$export$af57685e201438e8,
    $3913ca223572f8d7$export$d97d31d934dbb194,
    $3913ca223572f8d7$export$cafb5bd13b02056b,
    $3913ca223572f8d7$export$e55c18b809946e72,
    $3913ca223572f8d7$export$de5640b9ae8140a7,
    $3913ca223572f8d7$export$540b5c3c4b6ce459,
    $3913ca223572f8d7$export$6f71dff531ff592,
    $3913ca223572f8d7$export$83255ab79e45f34f,
    $3913ca223572f8d7$export$b57d172af9ad7647,
    $3913ca223572f8d7$export$ff4c933c1fe90b68,
    $3913ca223572f8d7$export$77071b77e2801b18,
    $3913ca223572f8d7$export$94ad6507a703f4eb,
    $3913ca223572f8d7$export$501166b25f254aab,
    $3913ca223572f8d7$export$be1c522400a1bd7c,
    $3913ca223572f8d7$export$2aa6e7b6e24a04f5,
    $3913ca223572f8d7$export$f3b53199b07af2a1,
    $3913ca223572f8d7$export$d37415ffddcf2142,
    $3913ca223572f8d7$export$2ae00586da7cb606,
    $3913ca223572f8d7$export$9c89f946f05d884a,
    $3913ca223572f8d7$export$20bc3dc137ac1c38,
    $3913ca223572f8d7$export$b52a7c936684cfc5,
    $3913ca223572f8d7$export$b5555f24061f9fb,
    $3913ca223572f8d7$export$ff25449f34b8abf,
    $3913ca223572f8d7$export$3380e677209260fe,
    $3913ca223572f8d7$export$b86266e6594a97bb,
    $3913ca223572f8d7$export$8ab0859f5b30b013,
    $3913ca223572f8d7$export$d1f6d18c6698104c,
    $3913ca223572f8d7$export$e6ee159eee7adc1c,
    $3913ca223572f8d7$export$dd267ca1e3cd3bad,
    $3913ca223572f8d7$export$f14c8bffc35200d3,
    $3913ca223572f8d7$export$36cc22c9997d92a,
    $3913ca223572f8d7$export$d651cc94a46ff383,
    $3913ca223572f8d7$export$3e2776d61f3662dc,
    $3913ca223572f8d7$export$2b5f951ad8e70cfe,
    $3913ca223572f8d7$export$9048315f2c03fd9d,
    $3913ca223572f8d7$export$a333714599f14a6,
    $3913ca223572f8d7$export$4145c2cec2da6f9b,
    $3913ca223572f8d7$export$4957a1ad203cf6dd,
    $3913ca223572f8d7$export$7a2fcaad1564e6b7,
    $3913ca223572f8d7$export$42a8341e3c94a2be,
    $3913ca223572f8d7$export$e29c6a916affb308,
    $3913ca223572f8d7$export$bc193be3ff1dd519,
    $3913ca223572f8d7$export$73a289f194001f88,
    $3913ca223572f8d7$export$190b5dd0a1322552,
    $3913ca223572f8d7$export$da23b72d32bfad9e,
    $3913ca223572f8d7$export$4b064659282e0238,
    $3913ca223572f8d7$export$3ab51851f6d823e,
    $3913ca223572f8d7$export$e4a1a37a9a1350ad,
    $3913ca223572f8d7$export$b7f7da5e795f0327,
    $3913ca223572f8d7$export$80a401c1aa47a377,
    $3913ca223572f8d7$export$934ac7a251b26dc7,
    $3913ca223572f8d7$export$4634f6395df3ebbe,
    $3913ca223572f8d7$export$768fb41107a1e8d7,
    $3913ca223572f8d7$export$d797a81bace17184,
    $3913ca223572f8d7$export$746102c94db9df1f,
    $3913ca223572f8d7$export$5f1efd797d65e349,
    $3913ca223572f8d7$export$cccc812ccafbf11f,
    $3913ca223572f8d7$export$64822db87abd8a47,
    $3913ca223572f8d7$export$64f764d8be495c82,
    $3913ca223572f8d7$export$24eae23dc1c68bbd,
    $3913ca223572f8d7$export$50fa92eba6f82feb,
    $3913ca223572f8d7$export$4155d22fe3f14cd6,
    $3913ca223572f8d7$export$76813cbead887191,
    $3913ca223572f8d7$export$90aab2ff89daf770,
    $3913ca223572f8d7$export$a2bc0cbad2e6e605,
    $3913ca223572f8d7$export$f90872a1280728bb,
    $3913ca223572f8d7$export$bce644e96518cbd2,
    $3913ca223572f8d7$export$241aaebffac0a3e5,
    $3913ca223572f8d7$export$f9dfc43b5b31c4b7,
    $3913ca223572f8d7$export$79759e9e62fb9312,
    $3913ca223572f8d7$export$992d1e0dce255d19,
    $3913ca223572f8d7$export$d28c1b0e5b3e768,
    $3913ca223572f8d7$export$ca714ee197bed4ec,
    $3913ca223572f8d7$export$faae55ceea4b6073,
    $3913ca223572f8d7$export$200bc24cd120667e,
    $3913ca223572f8d7$export$a0d784a48b4e886c,
    $3913ca223572f8d7$export$baf5bd09b4b33b8a,
    $3913ca223572f8d7$export$4702007eedbca8ab,
    $3913ca223572f8d7$export$aa9d2d635ea63898,
    $3913ca223572f8d7$export$2ea449225c1f6cac,
    $3913ca223572f8d7$export$deb8b557e735e26a,
    $3913ca223572f8d7$export$d45754df44e4c309,
    $3913ca223572f8d7$export$78b2913b550edbb,
    $3913ca223572f8d7$export$71243272608c58ab,
    $3913ca223572f8d7$export$39a08f215c33bc39,
    $3913ca223572f8d7$export$d2377f6a6fa3b49c,
    $3913ca223572f8d7$export$befa8f6533309779,
    $3913ca223572f8d7$export$736b40db8701ba6c
];

});

parcelRegister("c8ave", function(module, exports) {

$parcel$export(module.exports, "changeTaskGroupParent", () => (parcelRequire("ah9g7")).nextChangeTaskGroupParent);
$parcel$export(module.exports, "goBackToPreviousTaskGroup", () => (parcelRequire("ah9g7")).nextGoBackToPreviousTaskGroup);
$parcel$export(module.exports, "setIsOpen", () => (parcelRequire("3TtLb")).setIsOpen);
$parcel$export(module.exports, "refreshAppState", () => (parcelRequire("agwlB")).refreshAppState);
$parcel$export(module.exports, "setNudgeStep", () => (parcelRequire("aI5eR")).setNudgeStep);
$parcel$export(module.exports, "addMountedNudge", () => (parcelRequire("1jaP6")).addMountedNudge);
$parcel$export(module.exports, "removeMountedNudge", () => (parcelRequire("1jaP6")).removeMountedNudge);
$parcel$export(module.exports, "setShouldRenderComponent", () => (parcelRequire("lCKeP")).setShouldRenderComponent);
$parcel$export(module.exports, "setProjectState", () => (parcelRequire("9FTSc")).setProjectState);
$parcel$export(module.exports, "setHasNudgeActive", () => (parcelRequire("iq74h")).setHasNudgeActive);
$parcel$export(module.exports, "forceHideNudge", () => (parcelRequire("cKB0H")).forceHideNudge);
$parcel$export(module.exports, "setHasEverSeenRoute", () => (parcelRequire("8n1zQ")).setHasEverSeenRoute);
$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => (parcelRequire("ioWKV")).setRoadmapIsCreateEnabled);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => (parcelRequire("ioWKV")).setRoadmapIsListEmpty);
$parcel$export(module.exports, "openNextTask", () => (parcelRequire("P9NN5")).openNextTask);
$parcel$export(module.exports, "resetIsQuickstartLoaded", () => (parcelRequire("6GDwI")).resetIsQuickstartLoaded);
$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => (parcelRequire("N3EY7")).refreshAppStateUiStatusOnly);
$parcel$export(module.exports, "nextMarkAsCompletedTask", () => (parcelRequire("g1Zgk")).nextMarkAsCompletedTask);
$parcel$export(module.exports, "nextSetChecklistItemSeen", () => (parcelRequire("dn2YB")).nextSetChecklistItemSeen);
$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => (parcelRequire("jssF8")).nextSetChecklistIsDismissed);
$parcel$export(module.exports, "nextSetChecklistIsOpen", () => (parcelRequire("ahbtR")).nextSetChecklistIsOpen);
$parcel$export(module.exports, "nextOpenTask", () => (parcelRequire("gn07r")).nextOpenTask);
$parcel$export(module.exports, "nextAutoExpand", () => (parcelRequire("7I9OF")).nextAutoExpand);
$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => (parcelRequire("cDYe7")).nextShouldShowNudgeAfterNavigation);
$parcel$export(module.exports, "nextGetTasks", () => (parcelRequire("kDmv4")).nextGetTasks);
$parcel$export(module.exports, "syncVisibilityWithLocal", () => (parcelRequire("hmvAh")).syncVisibilityWithLocal);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $ah9g7 = parcelRequire("ah9g7");

var $3TtLb = parcelRequire("3TtLb");

var $agwlB = parcelRequire("agwlB");

var $aI5eR = parcelRequire("aI5eR");

var $1jaP6 = parcelRequire("1jaP6");

var $lCKeP = parcelRequire("lCKeP");

var $9FTSc = parcelRequire("9FTSc");

var $iq74h = parcelRequire("iq74h");

var $cKB0H = parcelRequire("cKB0H");

var $8n1zQ = parcelRequire("8n1zQ");

var $ioWKV = parcelRequire("ioWKV");

var $P9NN5 = parcelRequire("P9NN5");

var $6GDwI = parcelRequire("6GDwI");

var $N3EY7 = parcelRequire("N3EY7");

var $g1Zgk = parcelRequire("g1Zgk");

var $dn2YB = parcelRequire("dn2YB");

var $jssF8 = parcelRequire("jssF8");

var $ahbtR = parcelRequire("ahbtR");

var $gn07r = parcelRequire("gn07r");

var $7I9OF = parcelRequire("7I9OF");

var $cDYe7 = parcelRequire("cDYe7");

var $kDmv4 = parcelRequire("kDmv4");

var $hmvAh = parcelRequire("hmvAh");

});
parcelRegister("ah9g7", function(module, exports) {

$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $2484e60819053729$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $2484e60819053729$export$57534cbc400a434c);

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");
const $2484e60819053729$var$setTaskGroup = (taskGroup)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: ''
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $2484e60819053729$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($2484e60819053729$var$setTaskGroup(taskGroup));
    };
const $2484e60819053729$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        const { previousTaskGroupParents: previousTaskGroupParents } = getState();
        const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $7dRgX.ROOT_TASK) : previousTaskGroupParents.pop();
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newTaskGroupParent
        };
        // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
        dispatch($2484e60819053729$var$setTaskGroup(taskGroup));
    };

});
parcelRegister("8ppHd", function(module, exports) {

$parcel$export(module.exports, "pushToBackend", () => $1733f663faa18bb1$export$583b2d2422a6757f);

var $48bs8 = parcelRequire("48bs8");

var $e91YZ = parcelRequire("e91YZ");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
const $1733f663faa18bb1$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $1733f663faa18bb1$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $48bs8.setUserProperties)($1733f663faa18bb1$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $7byHA.default)(response.status, response.statusText);
    });
const $1733f663faa18bb1$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $1733f663faa18bb1$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $1733f663faa18bb1$export$583b2d2422a6757f = async (props)=>{
    const success = await $1733f663faa18bb1$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $1733f663faa18bb1$var$trySetUserProperties(props, 2);
};

});


parcelRegister("3TtLb", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $e2436d4b85647276$export$dcf23146e0a40195);

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");
const $e2436d4b85647276$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN),
            value: isOpen
        });
    };
var $e2436d4b85647276$export$2e2bcd8739ae039 = $e2436d4b85647276$export$dcf23146e0a40195;

});
parcelRegister("5OjXh", function(module, exports) {

$parcel$export(module.exports, "getQuickstartTypeSelector", () => $6278fa6778740945$export$eae834ce0286017a);

var $7ZZxN = parcelRequire("7ZZxN");

var $7dRgX = parcelRequire("7dRgX");
const $6278fa6778740945$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
const $6278fa6778740945$export$eae834ce0286017a = (state)=>{
    if ($6278fa6778740945$export$6f17f2cb816105eb(state)) return (0, $7dRgX.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $7dRgX.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("agwlB", function(module, exports) {

$parcel$export(module.exports, "refreshAppState", () => $8d23b98670e25122$export$797c35e2e1d0d014);

var $7ZZxN = parcelRequire("7ZZxN");

var $eI5EY = parcelRequire("eI5EY");


var $9z6Oy = parcelRequire("9z6Oy");

var $jMP2a = parcelRequire("jMP2a");

var $4sxuP = parcelRequire("4sxuP");

var $6WXNs = parcelRequire("6WXNs");

var $7dRgX = parcelRequire("7dRgX");

var $6kCnW = parcelRequire("6kCnW");

var $8ppHd = parcelRequire("8ppHd");

var $lIoQU = parcelRequire("lIoQU");

var $71CzX = parcelRequire("71CzX");

var $kL6gJ = parcelRequire("kL6gJ");

var $74z6M = parcelRequire("74z6M");

var $9vuWT = parcelRequire("9vuWT");

var $egHFE = parcelRequire("egHFE");

var $jssF8 = parcelRequire("jssF8");

var $ahbtR = parcelRequire("ahbtR");

var $g1Zgk = parcelRequire("g1Zgk");

var $ah9g7 = parcelRequire("ah9g7");

var $fzDyP = parcelRequire("fzDyP");
const $8d23b98670e25122$var$allTasks = [
    ...(0, $7dRgX.allTasksExcludingJSMBusinessTasks),
    ...(0, $7dRgX.JSM_BUSINESS_TASKS)
];
const $8d23b98670e25122$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)),
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $7dRgX.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $7dRgX.QUICKSTART_TYPE)).map((type)=>(0, $7dRgX.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $7dRgX.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $6kCnW.pollBackend)({
            keys: [
                (0, $7dRgX.KEY_OPEN),
                (0, $7dRgX.KEY_DISMISSED),
                (0, $7dRgX.KEY_OPEN_TASK),
                (0, $7dRgX.KEY_TASK_GROUP),
                (0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $7dRgX.KEY_JSW_ONBOARDING),
                (0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED),
                ...$8d23b98670e25122$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        if (projectState && projectState.projectKey) updatedState.isDevOpsProject = await (0, $74z6M.getIsDevOpsProject)(projectState.projectKey);
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $7dRgX.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            Object.values((0, $7dRgX.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $7dRgX.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $7dRgX.getBackendVisibilityKey)(type)];
                else if ((0, $7dRgX.KEY_DISMISSED) in backendState && backendState[0, $7dRgX.KEY_DISMISSED]) updatedState.visibility[type] = (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $7dRgX.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $7dRgX.KEY_OPEN] ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
                if ((0, $eI5EY.fg)('jsw_onboarding_reactufo_qs')) (0, $egHFE.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $7dRgX.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $7dRgX.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $7dRgX.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $7dRgX.KEY_OPEN];
            if ((0, $7dRgX.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $7dRgX.KEY_OPEN_TASK];
            if ((0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $7dRgX.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $7dRgX.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $7dRgX.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $7dRgX.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $7dRgX.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $7dRgX.KEY_JSW_ONBOARDING] !== null && (0, $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe) in backendState[0, $7dRgX.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $7dRgX.KEY_JSW_ONBOARDING][0, $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe];
            }
        }
        if (atlassianAccountId && projectType === (0, $7ZZxN.CORE_PROJECT) && (0, $71CzX.isUserEnrolledInTailoredOnboardingExperiment)()) try {
            const analyticsEvent = createAnalyticsEvent({});
            const personaExperience = await (0, $fzDyP.getPersonaExperience)(cloudId, atlassianAccountId, (data)=>(0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState settingPersonaExperienceFromTraits', data));
            if (personaExperience) updatedState.personaExperience = personaExperience;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lIoQU.fireAPIErrorAnalytics)(error, 'fetchSiteUserPersonalization');
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if ((updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $6WXNs.PREMIUM_EDITION)) {
            dispatch((0, $ah9g7.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $7dRgX.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $9vuWT.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $jssF8.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lIoQU.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const jswTrackDeferSitenameSiteTrait = await (0, $9z6Oy.getJswTrackDeferSitenameSiteTrait)(cloudId, {
            packageName: (0, $7dRgX.PACKAGE_NAME),
            teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
        });
        setState({
            isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
        });
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $kL6gJ.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $6WXNs.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials && (0, $eI5EY.fg)('jsw_reverse_trials_feature_gate')) {
            const isOnboardingPremiumTrial = await (0, $4sxuP.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ if (!isReverseTrialForJSW && appEditions.software === (0, $6WXNs.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $ahbtR.nextSetChecklistIsOpen)(true));
            dispatch((0, $jssF8.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK) : (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
            // Go to advanced roadmaps task
            dispatch((0, $g1Zgk.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $ah9g7.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $8379f5d78bf6fb5a$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $8379f5d78bf6fb5a$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $8379f5d78bf6fb5a$export$e3884212029f7bef = 'should-show-welcome-modal';
const $8379f5d78bf6fb5a$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $8379f5d78bf6fb5a$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $8379f5d78bf6fb5a$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $8379f5d78bf6fb5a$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $8379f5d78bf6fb5a$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $8379f5d78bf6fb5a$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $8379f5d78bf6fb5a$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $8379f5d78bf6fb5a$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $8379f5d78bf6fb5a$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $8379f5d78bf6fb5a$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $8379f5d78bf6fb5a$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $8379f5d78bf6fb5a$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $8379f5d78bf6fb5a$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $8379f5d78bf6fb5a$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $8379f5d78bf6fb5a$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $8379f5d78bf6fb5a$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $8379f5d78bf6fb5a$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $8379f5d78bf6fb5a$export$468488291ccd988 = 'timelineAddItemNudge';
const $8379f5d78bf6fb5a$export$7a33548109ac931d = 'createFormNudge';
const $8379f5d78bf6fb5a$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $8379f5d78bf6fb5a$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $8379f5d78bf6fb5a$export$594d3436316492be = 'summaryViewNudge';
const $8379f5d78bf6fb5a$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $8379f5d78bf6fb5a$export$73278890f736ee6f = 'manageProjectsNudge';

parcelRegister("9z6Oy", function(module, exports) {

$parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", () => $d04aec276ef38a16$export$686752df505238be);
$parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", () => $d04aec276ef38a16$export$6da79f996c267010);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $d04aec276ef38a16$var$SITE_PERSONALIZATION_ENDPOINT = `${$d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT}/site/`;
const $d04aec276ef38a16$var$USER_PERSONALIZATION_ENDPOINT = `${$d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT}/user/`;
const $d04aec276ef38a16$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
const $d04aec276ef38a16$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
const $d04aec276ef38a16$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
        try {
            const url = endpoint + id;
            return await (0, $lRmyA.performGetRequest)(url);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'onboarding',
                    teamName: 'jlove-makkuro',
                    ...meta
                },
                attributes: {
                    subject: subject
                },
                error: error
            });
            return undefined;
        }
    };
const $d04aec276ef38a16$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
        const personalization = await fetch(id, meta);
        return personalization?.attributes?.find((att)=>att.name === traitName);
    };
const $d04aec276ef38a16$export$686752df505238be = $d04aec276ef38a16$var$getTraits($d04aec276ef38a16$var$fetchPersonalization($d04aec276ef38a16$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $d04aec276ef38a16$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
const $d04aec276ef38a16$export$6da79f996c267010 = $d04aec276ef38a16$var$getTraits($d04aec276ef38a16$var$fetchPersonalization($d04aec276ef38a16$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $d04aec276ef38a16$var$JSW_TRACK_DEFER_SITENAME_TRAIT);

});

parcelRegister("4sxuP", function(module, exports) {

$parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", () => $1907cbeebd30077d$export$d9a9dd6206da5bef);
$parcel$export(module.exports, "getOnboardingPremiumTrial", () => $1907cbeebd30077d$export$ef676f7f369f74fe);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $1lUvF = parcelRequire("1lUvF");
const $1907cbeebd30077d$var$endpoint = '/rest/onboarding/1.0/premium-trial';
const $1907cbeebd30077d$export$d9a9dd6206da5bef = async ()=>{
    try {
        // Attempt to get from localStorage
        const localStorageOnboardingPremiumTrial = (0, $1lUvF.localStorageGetOnboardingPremiumTrial)();
        const localStorageOnboardingPremiumTrialCohort = (0, $1lUvF.localStorageGetOnboardingPremiumTrialCohort)();
        if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
            premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
            reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
        };
        const response = await (0, $lRmyA.performGetRequestWithRetry)($1907cbeebd30077d$var$endpoint);
        const premiumTrialOnSignup = response?.premiumTrialOnSignup;
        const reverseTrialCohort = response?.reverseTrialCohort;
        if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
            // Set into localStorage
            (0, $1lUvF.localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
            (0, $1lUvF.localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
            return {
                premiumTrialOnSignup: premiumTrialOnSignup,
                reverseTrialCohort: reverseTrialCohort
            };
        }
        throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getOnboardingPremiumTrialWithRethrow',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $1907cbeebd30077d$export$ef676f7f369f74fe = async ()=>{
    try {
        return await $1907cbeebd30077d$export$d9a9dd6206da5bef();
    } catch (e) {
    // ignored
    }
};

});
parcelRegister("1lUvF", function(module, exports) {

$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", () => $d5d23c94342aad01$export$782df5489e5cfd1e);
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", () => $d5d23c94342aad01$export$c3378895d06b5528);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", () => $d5d23c94342aad01$export$f83a7a49524e74ad);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", () => $d5d23c94342aad01$export$f389f8ca168b4a3a);

var $aZaPn = parcelRequire("aZaPn");

var $guiFP = parcelRequire("guiFP");
const $d5d23c94342aad01$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
const $d5d23c94342aad01$export$2f93fdc3330233dc = 'reverseTrialCohort';
const $d5d23c94342aad01$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
const $d5d23c94342aad01$export$782df5489e5cfd1e = ()=>{
    try {
        const value = $d5d23c94342aad01$var$localStorage.get($d5d23c94342aad01$export$3538ee3f5c6c8b5c);
        // localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $d5d23c94342aad01$export$c3378895d06b5528 = ()=>{
    try {
        const value = $d5d23c94342aad01$var$localStorage.get($d5d23c94342aad01$export$2f93fdc3330233dc);
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $d5d23c94342aad01$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
    try {
        $d5d23c94342aad01$var$localStorage.set($d5d23c94342aad01$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $d5d23c94342aad01$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
    try {
        $d5d23c94342aad01$var$localStorage.set($d5d23c94342aad01$export$2f93fdc3330233dc, reverseTrialCohort);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("6kCnW", function(module, exports) {

$parcel$export(module.exports, "pollBackend", () => $72b53773fb858e3c$export$8420ef0cee98de);

var $95f8K = parcelRequire("95f8K");

var $6vrw7 = parcelRequire("6vrw7");

var $7dRgX = parcelRequire("7dRgX");
const $72b53773fb858e3c$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $95f8K.get)((0, $6vrw7.toBaseUrl)(''), {
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $7dRgX.PACKAGE_NAME),
            teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("95f8K", function(module, exports) {

$parcel$export(module.exports, "get", () => $4b3de6acfae5f7c4$export$3988ae62b71be9a3);

var $fUTZC = parcelRequire("fUTZC");

var $4vTMF = parcelRequire("4vTMF");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $JRB5w = parcelRequire("JRB5w");

var $lRmyA = parcelRequire("lRmyA");

var $3FyZ4 = parcelRequire("3FyZ4");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
let $4b3de6acfae5f7c4$var$ufoExperiencesMap = {};
const $4b3de6acfae5f7c4$var$getUfoExperience = (key)=>{
    if (!$4b3de6acfae5f7c4$var$ufoExperiencesMap[key]) $4b3de6acfae5f7c4$var$ufoExperiencesMap[key] = new (0, $kDfSL.UFOExperience)(key, {
        type: (0, $12kyE.ExperienceTypes).Operation,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom
    });
    return $4b3de6acfae5f7c4$var$ufoExperiencesMap[key];
};
const $4b3de6acfae5f7c4$export$c907f169d33b2e25 = ()=>{
    $4b3de6acfae5f7c4$var$ufoExperiencesMap = {};
};
const $4b3de6acfae5f7c4$export$a5b7a8c3b1c6e775 = (baseUrl, { userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4b3de6acfae5f7c4$var$patchProperties = (response, propertiesPath)=>((0, $eI5EY.fg)('handle_null_response_for_fe_config_properties_call') ? response : true) && (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $4b3de6acfae5f7c4$export$3988ae62b71be9a3 = async (baseUrl, options)=>{
    const ufoExperience = $4b3de6acfae5f7c4$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $4b3de6acfae5f7c4$export$a5b7a8c3b1c6e775(baseUrl, options);
        const response = await (0, $lRmyA.performGetRequest)(url);
        $4b3de6acfae5f7c4$var$patchProperties(response, 'user');
        $4b3de6acfae5f7c4$var$patchProperties(response, 'instance');
        $4b3de6acfae5f7c4$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return (0, $eI5EY.fg)('handle_null_response_for_fe_config_properties_call') ? response || {
            user: {},
            instance: {},
            project: {}
        } : response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $JRB5w.isClientFetchError)(error) && (0, $guiFP.default)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});


parcelRegister("lIoQU", function(module, exports) {

$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $d6df15178ffe1f85$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $d6df15178ffe1f85$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $d6df15178ffe1f85$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $d6df15178ffe1f85$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $d6df15178ffe1f85$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $d6df15178ffe1f85$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $d6df15178ffe1f85$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $d6df15178ffe1f85$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $d6df15178ffe1f85$export$6c39ca65ca354e59);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");

var $7dRgX = parcelRequire("7dRgX");

var $eVkIs = parcelRequire("eVkIs");
const $d6df15178ffe1f85$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $7dRgX.ACTION_SUBJECT_ID), attributes);
};
const $d6df15178ffe1f85$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $d6df15178ffe1f85$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $d6df15178ffe1f85$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $eVkIs.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $d6df15178ffe1f85$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $d6df15178ffe1f85$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("eVkIs", function(module, exports) {

$parcel$export(module.exports, "getProductType", () => $0947b77be3ed825c$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $0947b77be3ed825c$export$3b914201960fa7a6);

var $jh2R9 = parcelRequire("jh2R9");

var $7ZZxN = parcelRequire("7ZZxN");
const $0947b77be3ed825c$export$d64a7dd8c7cd80e0 = {
    [(0, $7ZZxN.CORE_PROJECT)]: 'workManagement',
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $0947b77be3ed825c$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $0947b77be3ed825c$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(projectType);
    return null;
};
const $0947b77be3ed825c$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(taskId.split('.').pop());
};

});


parcelRegister("71CzX", function(module, exports) {

$parcel$export(module.exports, "getTailoredOnboardingExperimentCohort", () => $d959c0b35b8f3323$export$fcb264347c366122);
$parcel$export(module.exports, "isUserEnrolledInTailoredOnboardingExperiment", () => $d959c0b35b8f3323$export$7b8159a372d92686);
$parcel$export(module.exports, "isTailoredQuickstartEnabled", () => $d959c0b35b8f3323$export$65a9481ea376f1be);

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $4vWp2 = parcelRequire("4vWp2");
const $d959c0b35b8f3323$export$fcb264347c366122 = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_tailored_onboarding');
    return expConfig.get('cohort', 'not-enrolled');
};
const $d959c0b35b8f3323$export$7b8159a372d92686 = ()=>{
    if ((0, $eI5EY.fg)('jwm_tailored_onboarding_gate')) {
        const userCohort = $d959c0b35b8f3323$export$fcb264347c366122();
        return userCohort !== 'not-enrolled';
    }
    return false;
};
const $d959c0b35b8f3323$export$65a9481ea376f1be = (personaExperience)=>Boolean(personaExperience && (0, $4vWp2.SUPPORTED_PERSONA_EXPERIENCES).includes(personaExperience) && (0, $79xbN.expValEquals)('jwm_tailored_onboarding', 'cohort', 'variation'));

});
parcelRegister("4vWp2", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCE_TYPE", () => $9d1a089e61b3d8e4$export$19cb56bee281315d);
$parcel$export(module.exports, "PERSONA_TYPE", () => $9d1a089e61b3d8e4$export$4fea3380347f1b0);
$parcel$export(module.exports, "PERSONA_TRAIT_NAME", () => $9d1a089e61b3d8e4$export$8cfac46d1cf13d0d);
$parcel$export(module.exports, "SUPPORTED_PERSONA_EXPERIENCES", () => $9d1a089e61b3d8e4$export$cbc64427de2881a9);
const $9d1a089e61b3d8e4$export$19cb56bee281315d = {
    MARKETER_LEAD: 'Campaign Management Marketing Lead',
    MARKETER_PROJECT: 'Project Management Marketing Lead',
    MARKETER_CONTENT: 'Content Management Content Marketer',
    MARKETER_PMM: 'Project Management PMM'
};
const $9d1a089e61b3d8e4$export$4fea3380347f1b0 = {
    MARKETING_GENERIC: 'Marketing Generic',
    PROJECT_MARKETING_LEAD: 'Project Management Marketing Lead',
    CAMPAIGN_MARKETING_LEAD: 'Campaign Management Marketing Lead',
    CONTENT_MARKETING_LEAD: 'Content Management Content Marketer',
    PMM: 'Project Management PMM'
};
const $9d1a089e61b3d8e4$export$8cfac46d1cf13d0d = 'marketing_track_tailored_onboarding_initialized_wacprovisioningscreen_changed';
const $9d1a089e61b3d8e4$export$cbc64427de2881a9 = [
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_LEAD,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_PROJECT,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_CONTENT,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_PMM
];

});


parcelRegister("kL6gJ", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $2a787116be621779$export$7f2186c37a3d095d);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $7dRgX = parcelRequire("7dRgX");

var $lmEST = parcelRequire("lmEST");
const $2a787116be621779$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $2a787116be621779$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $2a787116be621779$var$ONE_DAY = 86400000;
const $2a787116be621779$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$2a787116be621779$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $lRmyA.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $7dRgX.PACKAGE_NAME),
                teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $2a787116be621779$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $lmEST.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $2a787116be621779$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $2a787116be621779$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $2a787116be621779$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("lmEST", function(module, exports) {

$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $6d7ad5c5e3880914$export$99f3e48748c2a8c3);

var $89bO2 = parcelRequire("89bO2");

const $6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider = (0, $89bO2.createSessionExpirableStorageProvider)((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a));
const $6d7ad5c5e3880914$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider.set((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider.get((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
const $e2fa640244aa9949$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("74z6M", function(module, exports) {

$parcel$export(module.exports, "getIsDevOpsProject", () => $22fff37650eaf366$export$88ee873472aa9bb7);

var $7dRgX = parcelRequire("7dRgX");
const $22fff37650eaf366$var$projectPropertyUrl = (projectKey)=>`/rest/api/2/project/${projectKey}/properties/${0, $7dRgX.KEY_IS_DEVOPS_PROJECT}`;
const $22fff37650eaf366$export$88ee873472aa9bb7 = async (projectKey)=>{
    const url = $22fff37650eaf366$var$projectPropertyUrl(projectKey);
    const response = await fetch(url);
    if (response.ok) {
        const result = await response.json();
        return result.value;
    }
    return false;
};

});

parcelRegister("9vuWT", function(module, exports) {

$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $c73311db2e118d57$export$980c26b6f100081d);

var $lRmyA = parcelRequire("lRmyA");
const $c73311db2e118d57$export$980c26b6f100081d = ()=>(0, $lRmyA.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("egHFE", function(module, exports) {

$parcel$export(module.exports, "getNextNonCompleteTask", () => $e5132247b337604d$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $e5132247b337604d$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $e5132247b337604d$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $e5132247b337604d$export$93d719890ad66653);

var $aZaPn = parcelRequire("aZaPn");

var $bnszi = parcelRequire("bnszi");
const $e5132247b337604d$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $bnszi.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $e5132247b337604d$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $bnszi.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $e5132247b337604d$var$store = (0, $aZaPn.createLocalStorageProvider)('quickstart');
const $e5132247b337604d$export$5aa524d86254b4f = (key, value)=>{
    $e5132247b337604d$var$store.set(key, value);
};
const $e5132247b337604d$export$93d719890ad66653 = (key)=>$e5132247b337604d$var$store.get(key);

});
parcelRegister("bnszi", function(module, exports) {

$parcel$export(module.exports, "getTaskIndex", () => $1a376c852d3b72fa$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $1a376c852d3b72fa$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $1a376c852d3b72fa$export$995248f3b43d8505);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", () => $1a376c852d3b72fa$export$293f6b2affa6ea5a);

var $eVkIs = parcelRequire("eVkIs");






const $1a376c852d3b72fa$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $1a376c852d3b72fa$export$9711f11998d5795c = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $1a376c852d3b72fa$export$995248f3b43d8505 = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $1a376c852d3b72fa$export$293f6b2affa6ea5a = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});


parcelRegister("jssF8", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $ad333f190549603d$export$f24c05f83b880547);

var $eI5EY = parcelRequire("eI5EY");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");

var $egHFE = parcelRequire("egHFE");
const $ad333f190549603d$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED : (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        if ((0, $eI5EY.fg)('jsw_onboarding_reactufo_qs')) (0, $egHFE.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isDismissed in state
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN),
            value: true
        });
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN),
            value: false
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_DISMISSED),
            value: isDismissed
        });
    };

});

parcelRegister("ahbtR", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $42c7858c3f713220$export$4249eabbb34e2e69);

var $eI5EY = parcelRequire("eI5EY");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");

var $egHFE = parcelRequire("egHFE");
const $42c7858c3f713220$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        if ((0, $eI5EY.fg)('jsw_onboarding_reactufo_qs')) (0, $egHFE.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("g1Zgk", function(module, exports) {

$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $13a2c09b85cecff0$export$d6628d41a3bec42d);

var $8ppHd = parcelRequire("8ppHd");
const $13a2c09b85cecff0$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $8ppHd.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});

parcelRegister("fzDyP", function(module, exports) {

$parcel$export(module.exports, "getPersonaExperience", () => $b7c30df71a7183dd$export$f1d14f0838d6ea4f);

var $jRj3P = parcelRequire("jRj3P");

var $71CzX = parcelRequire("71CzX");

var $4vWp2 = parcelRequire("4vWp2");
const $b7c30df71a7183dd$var$getTrait = async (cloudId, userId)=>{
    const userTraits = await (0, $jRj3P.memoizedFetchSiteUserPersonalization)({
        cloudId: cloudId,
        userId: userId
    });
    const userTraitsPersona = userTraits?.find((trait)=>trait.name === (0, $4vWp2.PERSONA_TRAIT_NAME));
    return userTraitsPersona;
};
const $b7c30df71a7183dd$export$f1d14f0838d6ea4f = async (cloudId, userId, fireEvent)=>{
    const userTraitsPersona = await $b7c30df71a7183dd$var$getTrait(cloudId, userId);
    const personaExperience = $b7c30df71a7183dd$var$mapPersonaTraitsToExperienceOld(userTraitsPersona);
    fireEvent({
        personaExperience: personaExperience,
        persona: userTraitsPersona?.value,
        tailoredOnboardingExperiment1: (0, $71CzX.getTailoredOnboardingExperimentCohort)()
    });
    return personaExperience;
};
const $b7c30df71a7183dd$var$mapPersonaTraitsToExperienceOld = (userTraitsPersona)=>{
    switch(userTraitsPersona?.value){
        case (0, $4vWp2.PERSONA_TYPE).MARKETING_GENERIC:
        case (0, $4vWp2.PERSONA_TYPE).CAMPAIGN_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_LEAD;
        case (0, $4vWp2.PERSONA_TYPE).PROJECT_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PROJECT;
        case (0, $4vWp2.PERSONA_TYPE).CONTENT_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_CONTENT;
        case (0, $4vWp2.PERSONA_TYPE).PMM:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PMM;
        default:
            return undefined;
    }
};

});
parcelRegister("jRj3P", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", () => $4441cad18cc93774$export$de93ec54b11be450);
$parcel$export(module.exports, "useSiteUserPersonalization", () => $4441cad18cc93774$export$8dc79ff315095801);

var $5iWql = parcelRequire("5iWql");

var $eEzyV = parcelRequire("eEzyV");

var $2OdyW = parcelRequire("2OdyW");
const $4441cad18cc93774$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $4441cad18cc93774$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $2OdyW.default)($4441cad18cc93774$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $4441cad18cc93774$export$de93ec54b11be450 = (0, $5iWql.default)($4441cad18cc93774$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
const $4441cad18cc93774$export$8dc79ff315095801 = ()=>(0, $eEzyV.useService)($4441cad18cc93774$export$de93ec54b11be450);

});
parcelRegister("eEzyV", function(module, exports) {

$parcel$export(module.exports, "useService", () => $cbb15d4da2e9ab10$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $cbb15d4da2e9ab10$export$c963713a27525aaf);

var $eUqFw = parcelRequire("eUqFw");
const $cbb15d4da2e9ab10$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $eUqFw.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $eUqFw.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $cbb15d4da2e9ab10$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $eUqFw.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $cbb15d4da2e9ab10$export$6de4685a6c88b4e9(request, initialState);
    (0, $eUqFw.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});




parcelRegister("aI5eR", function(module, exports) {

$parcel$export(module.exports, "setNudgeStep", () => $970ae6c28ea9ba56$export$4debc323813b6997);
const $970ae6c28ea9ba56$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $970ae6c28ea9ba56$export$2e2bcd8739ae039 = $970ae6c28ea9ba56$export$4debc323813b6997;

});

parcelRegister("1jaP6", function(module, exports) {

$parcel$export(module.exports, "addMountedNudge", () => $d76ba5c46e283800$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $d76ba5c46e283800$export$748f4cda8ab98c91);
const $d76ba5c46e283800$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $d76ba5c46e283800$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("lCKeP", function(module, exports) {

$parcel$export(module.exports, "setShouldRenderComponent", () => $3e69fb4a25487c6b$export$1f9c6770ed938b6e);
const $3e69fb4a25487c6b$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $3e69fb4a25487c6b$export$2e2bcd8739ae039 = $3e69fb4a25487c6b$export$1f9c6770ed938b6e;

});

parcelRegister("9FTSc", function(module, exports) {

$parcel$export(module.exports, "setProjectState", () => $e8f28a5d91b40a98$export$1ba498e440c0a1e4);
const $e8f28a5d91b40a98$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $e8f28a5d91b40a98$export$2e2bcd8739ae039 = $e8f28a5d91b40a98$export$1ba498e440c0a1e4;

});

parcelRegister("iq74h", function(module, exports) {

$parcel$export(module.exports, "setHasNudgeActive", () => $d5d9f3bbfe59a243$export$497c281e6eb0786e);
const $d5d9f3bbfe59a243$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $d5d9f3bbfe59a243$export$2e2bcd8739ae039 = $d5d9f3bbfe59a243$export$497c281e6eb0786e;

});

parcelRegister("cKB0H", function(module, exports) {

$parcel$export(module.exports, "forceHideNudge", () => $395e6590b72e7adc$export$6d1ed97b83a62e8e);
// We use this action in cases where we want to hide the nudge no matter what.
const $395e6590b72e7adc$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("8n1zQ", function(module, exports) {

$parcel$export(module.exports, "setHasEverSeenRoute", () => $9526def4b4979224$export$28e0a4314a1ce52f);

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");
const $9526def4b4979224$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $9526def4b4979224$export$2e2bcd8739ae039 = $9526def4b4979224$export$28e0a4314a1ce52f;

});

parcelRegister("ioWKV", function(module, exports) {

$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $3aa7d72125406d8f$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $3aa7d72125406d8f$export$932967764e7a0b31);
const $3aa7d72125406d8f$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $3aa7d72125406d8f$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("P9NN5", function(module, exports) {

$parcel$export(module.exports, "openNextTask", () => $cc1aff9593d14250$export$867dbb6d61569ae9);

var $egHFE = parcelRequire("egHFE");

var $gn07r = parcelRequire("gn07r");
const $cc1aff9593d14250$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $egHFE.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $gn07r.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("gn07r", function(module, exports) {

$parcel$export(module.exports, "nextOpenTask", () => $4f8f6eacc80982cf$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $4f8f6eacc80982cf$export$cc5f3544a6cb2922);


var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $aI5eR = parcelRequire("aI5eR");

var $iq74h = parcelRequire("iq74h");
const $4f8f6eacc80982cf$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $4f8f6eacc80982cf$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($4f8f6eacc80982cf$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $iq74h.setHasNudgeActive)(false, taskId));
        else dispatch((0, $iq74h.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // This is a temporary solution for Scrum Onboarding.
        // See https://hello.atlassian.net/wiki/spaces/agile/pages/1321008806/Draft+Quickstart+Nudge+Interaction for details
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.SCRUM_ONBOARDING_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$b1a6ab17737f33e)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.KANBAN_ONBOARDING_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.ADD_COLUMNS_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112)));
        else dispatch((0, $aI5eR.setNudgeStep)(''));
    };
const $4f8f6eacc80982cf$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($4f8f6eacc80982cf$var$openTask(taskId));
        dispatch((0, $iq74h.setHasNudgeActive)(false, taskId));
        dispatch((0, $aI5eR.setNudgeStep)(''));
    };

});


parcelRegister("6GDwI", function(module, exports) {

$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $cf59d5b51193e99b$export$bda085a823763e5a);

var $7dRgX = parcelRequire("7dRgX");

var $5OjXh = parcelRequire("5OjXh");
const $cf59d5b51193e99b$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("N3EY7", function(module, exports) {

$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $0d6d286e80d61b67$export$87fe8079a4ed9766);


var $7dRgX = parcelRequire("7dRgX");

var $6kCnW = parcelRequire("6kCnW");

var $lIoQU = parcelRequire("lIoQU");

var $9vuWT = parcelRequire("9vuWT");

var $jssF8 = parcelRequire("jssF8");
const $0d6d286e80d61b67$export$87fe8079a4ed9766 = ({ taskList: taskList })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $7dRgX.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $7dRgX.QUICKSTART_TYPE)).map((type)=>(0, $7dRgX.getBackendVisibilityKey)(type));
        const backendState = await (0, $6kCnW.pollBackend)({
            keys: [
                (0, $7dRgX.KEY_OPEN),
                (0, $7dRgX.KEY_DISMISSED),
                (0, $7dRgX.KEY_OPEN_TASK),
                (0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $7dRgX.KEY_JSW_ONBOARDING),
                ...(0, $7dRgX.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $7dRgX.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $7dRgX.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $7dRgX.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $7dRgX.getBackendVisibilityKey)(type)];
                else if ((0, $7dRgX.KEY_DISMISSED) in backendState && backendState[0, $7dRgX.KEY_DISMISSED]) updatedState.visibility[type] = (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $7dRgX.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $7dRgX.KEY_OPEN] ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $7dRgX.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $7dRgX.KEY_DISMISSED];
            if ((0, $7dRgX.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $7dRgX.KEY_OPEN];
            if ((0, $7dRgX.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $7dRgX.KEY_OPEN_TASK];
            if ((0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $7dRgX.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $7dRgX.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $7dRgX.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $7dRgX.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $7dRgX.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $7dRgX.KEY_JSW_ONBOARDING] !== null && (0, $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe) in backendState[0, $7dRgX.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $7dRgX.KEY_JSW_ONBOARDING][0, $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $7dRgX.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $9vuWT.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $jssF8.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lIoQU.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("dn2YB", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $ae4dc9d92cd110b5$export$4eac017dcde0be8f);

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");
const $ae4dc9d92cd110b5$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $7dRgX.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("7I9OF", function(module, exports) {

$parcel$export(module.exports, "nextAutoExpand", () => $8c8cecc90fef13d0$export$3d24e97d30cfd09e);

var $7dRgX = parcelRequire("7dRgX");

var $cY793 = parcelRequire("cY793");

var $egHFE = parcelRequire("egHFE");

var $gn07r = parcelRequire("gn07r");
const $8c8cecc90fef13d0$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $cY793.localStorageProvider)().get({
            accountId: (0, $7dRgX.ACCOUNT_ID),
            key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $egHFE.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $gn07r.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("cY793", function(module, exports) {

$parcel$export(module.exports, "localStorageProvider", () => $f403f41047806be6$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $f403f41047806be6$export$f2666fae743fa5f);

var $89bO2 = parcelRequire("89bO2");

var $guiFP = parcelRequire("guiFP");

var $7dRgX = parcelRequire("7dRgX");
const $f403f41047806be6$var$DAYS_BEFORE_EXPIRY = 1;
const $f403f41047806be6$var$DAY = 86400000;
const $f403f41047806be6$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $f403f41047806be6$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $f403f41047806be6$var$DAYS_BEFORE_EXPIRY * $f403f41047806be6$var$DAY;
};
let $f403f41047806be6$var$localStorage;
const $f403f41047806be6$export$aa821bfb3308a1f5 = ()=>{
    if ($f403f41047806be6$var$localStorage) return $f403f41047806be6$var$localStorage;
    const provider = (0, $89bO2.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $guiFP.default)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }), value, $f403f41047806be6$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }));
    $f403f41047806be6$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $f403f41047806be6$var$localStorage;
};
const $f403f41047806be6$export$f2666fae743fa5f = (value)=>{
    $f403f41047806be6$export$aa821bfb3308a1f5().set({
        accountId: (0, $7dRgX.ACCOUNT_ID),
        key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("cDYe7", function(module, exports) {

$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $3949917718560fd8$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.

var $7dRgX = parcelRequire("7dRgX");

var $cY793 = parcelRequire("cY793");

var $iq74h = parcelRequire("iq74h");
const $3949917718560fd8$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $7dRgX.ACCOUNT_ID),
            key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $cY793.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $iq74h.setHasNudgeActive)(true));
            (0, $cY793.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("kDmv4", function(module, exports) {

$parcel$export(module.exports, "nextGetTasks", () => $2cffb9be55c6d345$export$15d877e1f3abf489);

var $a0vMn = parcelRequire("a0vMn");
const $2cffb9be55c6d345$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState })=>{
        const { taskList: taskList } = getState();
        const tasks = (0, $a0vMn.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
    };

});
parcelRegister("a0vMn", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $62ef3d093ab58a52$export$d1f442602a91e7cc);

var $dfBCt = parcelRequire("dfBCt");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");


var $6WXNs = parcelRequire("6WXNs");

var $7dRgX = parcelRequire("7dRgX");

var $jTgI9 = parcelRequire("jTgI9");

var $71CzX = parcelRequire("71CzX");

var $fricC = parcelRequire("fricC");

var $4vWp2 = parcelRequire("4vWp2");

var $kxycg = parcelRequire("kxycg");

var $3sCLn = parcelRequire("3sCLn");

var $2UWYK = parcelRequire("2UWYK");

var $c2fmF = parcelRequire("c2fmF");

var $2hhuw = parcelRequire("2hhuw");

var $5f5jN = parcelRequire("5f5jN");
const $62ef3d093ab58a52$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    if (variants.includes((0, $2UWYK.JSW).experiment.jswReverseTrial)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $7dRgX.ROOT_TASK) ? (0, $7dRgX.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $7dRgX.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $2hhuw.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $7dRgX.ROOT_TASK];
    return {
        title: title,
        items: (0, $2hhuw.getTasks)(variants, taskVariants, items)
    };
};
const $62ef3d093ab58a52$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $7dRgX.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    const isEligibleForKanbanTour = mountedNudges.includes((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112));
    if ((0, $dfBCt.isFedRamp)()) variants.add((0, $2UWYK.JSW).experience.fedRamp);
    if (premiumTrialOnSignup && (0, $eI5EY.fg)('jsw_reverse_trials_feature_gate')) variants.add((0, $2UWYK.JSW).experiment.jswReverseTrial);
    if ((0, $1ybV0.ff)('jsw.onboarding.rollout.kuro-2250') && isCustomerTemplateProject) variants.add((0, $2UWYK.JSW).projectProperties.isCreatedFromCustomerTemplate);
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $2UWYK.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $2UWYK.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $2UWYK.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS)) variants.add((0, $2UWYK.JSW).experience.kanbanOnboarding);
    if (canCreateProject === false) variants.add((0, $2UWYK.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $2UWYK.JSW).projectStyle.teamManaged);
    else variants.add((0, $2UWYK.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $2UWYK.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $2UWYK.JSW).userRole.jiraAdmin);
        variants.add((0, $2UWYK.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $2UWYK.JSW).userRole.siteAdmin);
        variants.add((0, $2UWYK.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $6WXNs.FREE_EDITION)) variants.add((0, $2UWYK.JSW).edition.free);
    else if (projectState?.edition === (0, $6WXNs.STANDARD_EDITION)) variants.add((0, $2UWYK.JSW).edition.standard);
    else if (projectState?.edition === (0, $6WXNs.PREMIUM_EDITION)) variants.add((0, $2UWYK.JSW).edition.premium);
    if ((0, $jTgI9.isRoadmapRoute)(routeName)) variants.add((0, $2UWYK.JSW).route.softwareRoadmap);
    else if (routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_BACKLOG)) variants.add((0, $2UWYK.JSW).route.softwareBacklog);
    else if (routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS)) variants.add((0, $2UWYK.JSW).route.softwareBoard);
    else if (routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST) || routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST_CLASSIC)) variants.add((0, $2UWYK.JSW).route.softwareList);
    else if (routeName === (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS)) variants.add((0, $2UWYK.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === (0, $exb0h.ROUTE_NAMES_ISSUE)) variants.add((0, $2UWYK.JSW).route.issue);
    else if ((0, $1ybV0.ff)('jsw-calendar-view-onboarding_q3bvy') && (routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR) || routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC))) variants.add((0, $2UWYK.JSW).route.softwareCalendar);
    if (isEligibleToUpdateSitename) variants.add((0, $2UWYK.JSW).experiment.customizeSiteName);
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $2UWYK.JSW).taskVariants,
        taskList: (0, $2UWYK.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createJwmTasks = (projectState, taskGroupParent, personaExperience, taskList = (0, $c2fmF.JWM).taskList)=>{
    const variants = [];
    variants.push((0, $c2fmF.JWM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $c2fmF.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) variants.push((0, $c2fmF.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) variants.push((0, $c2fmF.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $c2fmF.JWM).experiments.isSampleProject);
    else variants.push((0, $c2fmF.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $c2fmF.JWM).experiments.trelloCrossflow);
    if ((0, $71CzX.isTailoredQuickstartEnabled)(personaExperience)) {
        variants.push((0, $c2fmF.JWM).experiments.personalizedExperience);
        switch(personaExperience){
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_LEAD:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.marketingLeader);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PROJECT:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.projectMarketer);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_CONTENT:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.contentMarketer);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PMM:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.productMarketingManager);
                break;
            default:
                break;
        }
    }
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $c2fmF.JWM).taskVariants,
        taskList: taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $3sCLn.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $3sCLn.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) variants.push((0, $3sCLn.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) variants.push((0, $3sCLn.JSM).userRole.siteAdmin);
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $3sCLn.JSM).taskVariants,
        taskList: (0, $3sCLn.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createDevopsTasks = (taskGroupParent)=>{
    const variants = [];
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $kxycg.DEVOPS).taskVariants,
        taskList: (0, $kxycg.DEVOPS).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$export$d1f442602a91e7cc = ({ projectState: projectState, isDevOpsProject: isDevOpsProject, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCustomerTemplateProject: isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, personaExperience: personaExperience, taskList: taskList })=>{
    if ((0, $5f5jN.isJwmProject)(projectState)) return $62ef3d093ab58a52$var$createJwmTasks(projectState, taskGroupParent, personaExperience, taskList);
    if ((0, $5f5jN.isJsmProject)(projectState)) return $62ef3d093ab58a52$var$createJsmTasks(projectState, taskGroupParent);
    if (isDevOpsProject) return $62ef3d093ab58a52$var$createDevopsTasks(taskGroupParent);
    return $62ef3d093ab58a52$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("jTgI9", function(module, exports) {

$parcel$export(module.exports, "isRoadmapRoute", () => $2e4ffaed7bae8e69$export$d1fa67c1ffb68871);

var $exb0h = parcelRequire("exb0h");
const $2e4ffaed7bae8e69$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE) || routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC);
};

});

parcelRegister("fricC", function(module, exports) {

$parcel$export(module.exports, "USER_ROLE", () => $3def7289adf5e608$export$8eeb199b23203523);
const $3def7289adf5e608$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("kxycg", function(module, exports) {

$parcel$export(module.exports, "DEVOPS", () => $503385b7e39437c3$export$bb75b6064c92010c);

var $bxltp = parcelRequire("bxltp");
const $503385b7e39437c3$export$bb75b6064c92010c = {
    taskList: (0, $bxltp.TASK_LIST),
    taskVariants: (0, $bxltp.TASK_VARIANTS),
    experiment: (0, $bxltp.Experiment)
};

});
parcelRegister("bxltp", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $7cc3b723e4b7a76f$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "TASK_LIST", () => $7cc3b723e4b7a76f$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $7cc3b723e4b7a76f$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $ePWG3 = parcelRequire("ePWG3");
const $7cc3b723e4b7a76f$export$4e0ab25c8a7e4009 = {};
const $7cc3b723e4b7a76f$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $ePWG3.messages).rootTitle,
        items: [
            (0, $7dRgX.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK),
            (0, $7dRgX.DEVOPS_GET_TO_KNOW_JIRA_TASK),
            (0, $7dRgX.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK),
            (0, $7dRgX.DEVOPS_CAPTURE_INTEGRATIONS_TASK),
            (0, $7dRgX.DEVOPS_CREATE_AUTOMATION_RULES_TASK),
            (0, $7dRgX.DEVOPS_INVITE_TEAMMATES_TASK),
            (0, $7dRgX.DEVOPS_FIND_HELP_TASK)
        ]
    }
});
const $7cc3b723e4b7a76f$export$36f4d47dfe11b613 = {
    [(0, $7dRgX.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_GET_TO_KNOW_JIRA_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_CREATE_AUTOMATION_RULES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_FIND_HELP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("ePWG3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8c9ac3fc1eb167f1$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8c9ac3fc1eb167f1$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.devops.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("3sCLn", function(module, exports) {

$parcel$export(module.exports, "JSM", () => $9ce9aa4e7fe0438e$export$63f289f2da861d35);

var $4Euci = parcelRequire("4Euci");
const $9ce9aa4e7fe0438e$export$63f289f2da861d35 = {
    taskList: (0, $4Euci.JSM_TASK_LIST),
    taskVariants: (0, $4Euci.JSM_TASK_VARIANTS),
    userRole: (0, $4Euci.UserRole),
    experiments: (0, $4Euci.Experiments)
};

});
parcelRegister("4Euci", function(module, exports) {

$parcel$export(module.exports, "JSM_TASK_LIST", () => $fb74ace10b289ae1$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $fb74ace10b289ae1$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $fb74ace10b289ae1$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $fb74ace10b289ae1$export$5b68aef408c932d9);

var $7dRgX = parcelRequire("7dRgX");

var $aC2eo = parcelRequire("aC2eo");
const $fb74ace10b289ae1$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $aC2eo.messages).rootTitle,
        items: [
            (0, $7dRgX.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $7dRgX.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $7dRgX.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $fb74ace10b289ae1$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $fb74ace10b289ae1$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $fb74ace10b289ae1$export$5b68aef408c932d9 = {
    [(0, $7dRgX.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("aC2eo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c73088a9cd2645bf$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c73088a9cd2645bf$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("2UWYK", function(module, exports) {

$parcel$export(module.exports, "JSW", () => $bddfc54f60451b1f$export$4cfe6e52f2e72a54);

var $8nR1z = parcelRequire("8nR1z");
const $bddfc54f60451b1f$export$4cfe6e52f2e72a54 = {
    taskList: (0, $8nR1z.TASK_LIST),
    taskVariants: (0, $8nR1z.TASK_VARIANTS),
    experiment: (0, $8nR1z.Experiment),
    experience: (0, $8nR1z.Experience),
    projectStyle: (0, $8nR1z.ProjectStyle),
    projectProperties: (0, $8nR1z.ProjectProperties),
    userRole: (0, $8nR1z.UserRole),
    edition: (0, $8nR1z.Edition),
    route: (0, $8nR1z.Route),
    permissions: (0, $8nR1z.Permissions),
    trait: (0, $8nR1z.Trait)
};

});
parcelRegister("8nR1z", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $7a9145b1fc208f16$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $7a9145b1fc208f16$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $7a9145b1fc208f16$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "ProjectProperties", () => $7a9145b1fc208f16$export$543c19ee8dba9252);
$parcel$export(module.exports, "UserRole", () => $7a9145b1fc208f16$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $7a9145b1fc208f16$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $7a9145b1fc208f16$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $7a9145b1fc208f16$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $7a9145b1fc208f16$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $7a9145b1fc208f16$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $7a9145b1fc208f16$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $inMFY = parcelRequire("inMFY");
const $7a9145b1fc208f16$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    customizeSiteName: 'experiment.customizeSiteName',
    jswReverseTrial: 'experiment.jswReverseTrial'
};
const $7a9145b1fc208f16$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $7a9145b1fc208f16$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $7a9145b1fc208f16$export$543c19ee8dba9252 = {
    isCreatedFromCustomerTemplate: 'projectProperties.isCreatedFromCustomerTemplate'
};
const $7a9145b1fc208f16$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $7a9145b1fc208f16$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $7a9145b1fc208f16$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $7a9145b1fc208f16$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $7a9145b1fc208f16$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $7a9145b1fc208f16$var$DEFAULT_TASK_LIST = [
    (0, $7dRgX.ADD_COLUMNS_TASK),
    (0, $7dRgX.CREATE_PROJECT_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $7dRgX.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $7dRgX.INVITE_TEAMMATES_TASK),
    (0, $7dRgX.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $7dRgX.CAPTURE_INTEGRATIONS_TASK),
    (0, $7dRgX.FIND_HELP_TASK),
    (0, $7dRgX.SET_UP_BOARD_TASK),
    (0, $7dRgX.GET_MOBILE_APP_TASK),
    (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $7dRgX.MONITOR_MANAGE_RISK_TASK),
    (0, $7dRgX.SCRUM_ONBOARDING_TASK),
    (0, $7dRgX.CUSTOMIZE_SITE_NAME_TASK),
    (0, $7dRgX.GET_TO_KNOW_YOUR_TEMPLATE_TASK),
    (0, $7dRgX.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $7dRgX.GET_STARTED_LIST_TASK),
    (0, $7dRgX.CALENDAR_VIEW_TASK)
];
const $7a9145b1fc208f16$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $inMFY.messages).rootTitle,
        items: $7a9145b1fc208f16$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $inMFY.messages).reverseTrialRootTitle,
        items: $7a9145b1fc208f16$var$DEFAULT_TASK_LIST
    },
    [(0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $inMFY.messages).reverseTrialCardTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.CHANGE_CONTROL_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        title: (0, $inMFY.messages).premiumPlanTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.CHANGE_CONTROL_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        title: (0, $inMFY.messages).premiumPlanTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK)
        ]
    },
    [(0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK)]: {
        title: (0, $inMFY.messages).standardPlanTitle,
        items: [
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK)
        ]
    }
});
const $7a9145b1fc208f16$var$PLAN_ONBOARDING_TASKS = {
    [(0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    // This condition needs to be the opposite condition to PREMIUM_EDITION_OVERVIEW_TASK
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $7a9145b1fc208f16$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS = {
    [(0, $7dRgX.GET_TO_KNOW_YOUR_TEMPLATE_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$543c19ee8dba9252.isCreatedFromCustomerTemplate,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $7a9145b1fc208f16$export$36f4d47dfe11b613 = {
    ...$7a9145b1fc208f16$var$PLAN_ONBOARDING_TASKS,
    ...$7a9145b1fc208f16$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS,
    [(0, $7dRgX.CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$543c19ee8dba9252.isCreatedFromCustomerTemplate
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CUSTOMIZE_SITE_NAME_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin,
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.customizeSiteName
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CALENDAR_VIEW_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    value: true,
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareCalendar
                    ]
                }
            ]
        }
    },
    [(0, $7dRgX.SCRUM_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin,
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.scrumOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBacklog
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.MONITOR_MANAGE_RISK_TASK)]: {
        position: {
            default: 152
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.SET_UP_BOARD_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_ISSUE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_ISSUE_TASK_SIMPLIFIED)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.ADD_COLUMNS_TASK)]: {
        position: {
            default: 310
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 320
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.INVITE_TEAMMATES_VIDEO_TASK)]: {
        position: {
            default: 400,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.GET_MOBILE_APP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.FIND_HELP_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    }
};

});
parcelRegister("inMFY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $52d99860e7a60493$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $52d99860e7a60493$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("c2fmF", function(module, exports) {

$parcel$export(module.exports, "JWM", () => $562f552a719c049d$export$3ff26c80cb588e12);

var $l40o4 = parcelRequire("l40o4");

var $hBhFD = parcelRequire("hBhFD");

var $kN5DK = parcelRequire("kN5DK");
const $562f552a719c049d$export$3ff26c80cb588e12 = {
    taskList: (0, $l40o4.TASK_LIST),
    taskVariants: (0, $l40o4.TASK_VARIANTS),
    userRole: (0, $kN5DK.UserRole),
    experiments: (0, $hBhFD.Experiments),
    personalizedExperienceExperiments: (0, $hBhFD.PersonalizedExperienceExperiments)
};

});
parcelRegister("l40o4", function(module, exports) {

$parcel$export(module.exports, "TASK_LIST", () => $0a485b7af0b81750$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $0a485b7af0b81750$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $hBhFD = parcelRequire("hBhFD");

var $1deRh = parcelRequire("1deRh");

var $kN5DK = parcelRequire("kN5DK");
const $0a485b7af0b81750$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $1deRh.messages).rootTitle,
        items: [
            (0, $7dRgX.JWM_CREATE_PROJECT_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $7dRgX.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $7dRgX.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $7dRgX.JWM_PROJECT_SUMMARY_TASK),
            (0, $7dRgX.GET_STARTED_LIST_TASK),
            (0, $7dRgX.JWM_CALENDAR_TASK),
            (0, $7dRgX.JWM_BOARD_TASK),
            (0, $7dRgX.JWM_TIMELINE_TASK),
            (0, $7dRgX.JWM_BUILD_FORM_TASK),
            (0, $7dRgX.JWM_BACKGROUND_COLOR_TASK),
            (0, $7dRgX.JWM_FEEDBACK_TASK),
            (0, $7dRgX.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $7dRgX.JWM_SHARE_PROJECT_TASK),
            (0, $7dRgX.JWM_CREATE_YOUR_OWN_PROJECT_TASK),
            (0, $7dRgX.JWM_SUMMARY_TASK),
            (0, $7dRgX.JWM_INVITE_TEAM_TASK),
            (0, $7dRgX.JWM_PAGES_TASK)
        ]
    }
});
const $0a485b7af0b81750$export$db06b8e338ba9c65 = {
    [(0, $7dRgX.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $7dRgX.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $7dRgX.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        }
    },
    [(0, $7dRgX.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $7dRgX.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $7dRgX.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $7dRgX.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $7dRgX.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $7dRgX.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $7dRgX.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $7dRgX.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $7dRgX.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $7dRgX.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $7dRgX.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $7dRgX.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $7dRgX.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $7dRgX.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        }
    },
    [(0, $7dRgX.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $7dRgX.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $7dRgX.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        }
    },
    [(0, $7dRgX.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $7dRgX.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $7dRgX.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $0a485b7af0b81750$export$bda7075f98246874 = {
    [(0, $7dRgX.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $7dRgX.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $7dRgX.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $7dRgX.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $7dRgX.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        }
    },
    [(0, $7dRgX.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        }
    },
    [(0, $7dRgX.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $7dRgX.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $7dRgX.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $7dRgX.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $7dRgX.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $7dRgX.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $7dRgX.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $7dRgX.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $7dRgX.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $7dRgX.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $7dRgX.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $7dRgX.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $7dRgX.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $7dRgX.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $7dRgX.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $0a485b7af0b81750$export$36f4d47dfe11b613 = {
    ...$0a485b7af0b81750$export$db06b8e338ba9c65,
    ...$0a485b7af0b81750$export$bda7075f98246874,
    [(0, $7dRgX.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: 60
                }
            ]
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).projectMarketer
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BOARD_TASK)]: {
        position: {
            default: 250
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_PAGES_TASK)]: {
        position: {
            default: 375,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).projectMarketer
                    ],
                    value: 325
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).marketingLeader
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SUMMARY_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_INVITE_TEAM_TASK)]: {
        position: {
            default: 550
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("hBhFD", function(module, exports) {

$parcel$export(module.exports, "Experiments", () => $602d627ebd2e1820$export$c8d6ffd15214553a);
$parcel$export(module.exports, "PersonalizedExperienceExperiments", () => $602d627ebd2e1820$export$ce14e6ba2f059143);
const $602d627ebd2e1820$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow',
    personalizedExperience: 'personalizedExperience'
};
const $602d627ebd2e1820$export$ce14e6ba2f059143 = {
    marketingLeader: 'personalizedExperience.marketing-leader',
    contentMarketer: 'personalizedExperience.content-marketer',
    projectMarketer: 'personalizedExperience.project-marketer',
    productMarketingManager: 'personalizedExperience.pmm'
};

});

parcelRegister("1deRh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9c87cc11a21af694$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9c87cc11a21af694$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("kN5DK", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $c7f18eb8f889bc31$export$eb3485a690c2f0b8);
const $c7f18eb8f889bc31$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("2hhuw", function(module, exports) {

$parcel$export(module.exports, "getTasks", () => $1a771609d4c77a5c$export$20b82b4a32771893);

var $kfb7k = parcelRequire("kfb7k");
const $1a771609d4c77a5c$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $kfb7k.getConditional)(visibility, variants) : true;
const $1a771609d4c77a5c$var$getTaskPosition = (variants, position)=>(0, $kfb7k.getConditional)(position, variants);
const $1a771609d4c77a5c$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$1a771609d4c77a5c$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$1a771609d4c77a5c$var$getTaskPosition(variants, taskVariants[taskA].position) - $1a771609d4c77a5c$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("kfb7k", function(module, exports) {

$parcel$export(module.exports, "getConditional", () => $75b9324579affeba$export$fe3161cde0106bba);
const $75b9324579affeba$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("5f5jN", function(module, exports) {

$parcel$export(module.exports, "isJwmProject", () => $4c12cc14f77b8d26$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $4c12cc14f77b8d26$export$a972ed853ed1d469);

var $7ZZxN = parcelRequire("7ZZxN");
const $4c12cc14f77b8d26$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $7ZZxN.CORE_PROJECT);
const $4c12cc14f77b8d26$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);

});



parcelRegister("hmvAh", function(module, exports) {

$parcel$export(module.exports, "syncVisibilityWithLocal", () => $9f06cd693ed8e2c1$export$4aab9a98fc53b894);

var $5OjXh = parcelRequire("5OjXh");

var $egHFE = parcelRequire("egHFE");
const $9f06cd693ed8e2c1$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $egHFE.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});


parcelRegister("lCsoa", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $eba3eaa3fc426760$export$d4c72bab9d6cc13a);

var $7dRgX = parcelRequire("7dRgX");
const $eba3eaa3fc426760$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    isDevOpsProject: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $7dRgX.ROOT_TASK),
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isEligibleToUpdateSitename: false,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $7dRgX.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $7dRgX.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED
    }
};

});


parcelRegister("57SqH", function(module, exports) {

$parcel$export(module.exports, "useSidebarData", () => $d2cfb77d49815540$export$f9257874e114985c);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $44GOl = parcelRequire("44GOl");

var $dQZ5c = parcelRequire("dQZ5c");

var $f26dB = parcelRequire("f26dB");


var $3xyNB = parcelRequire("3xyNB");
const $d2cfb77d49815540$export$f9257874e114985c = ()=>{
    const { project: currentProject } = (0, $44GOl.useNavigationProject)();
    const { data: data, update: update, refresh: refresh, loading: loading } = (0, $f26dB.useNavigationResource)();
    const { changeFavorite: changeFavorite, items: { projects: changedItems } } = (0, $dQZ5c.useChangeFavorite)();
    const isRefreshingFavorites = (0, $eUqFw.useRef)(false);
    const hasRefreshedOnce = (0, $eUqFw.useRef)(false);
    const onFavoriteToggle = (0, $eUqFw.useCallback)((project)=>{
        changeFavorite({
            id: String(project.id),
            type: 'projects',
            value: !project.isFavorite
        });
    }, [
        changeFavorite
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(changedItems) && !Object.values(changedItems).some(({ pending: pending })=>pending)) {
            isRefreshingFavorites.current = true;
            refresh();
        }
    }, [
        changedItems,
        refresh
    ]);
    (0, $eUqFw.useEffect)(()=>{
        isRefreshingFavorites.current = false;
    }, [
        data
    ]);
    let recents;
    let favorites;
    let hasMoreFavorite;
    let overviews;
    let overviewsError;
    let isPremiumUserSeat;
    let showPlansOnboarding;
    let shouldHideOverviews;
    if (data == null || data === (0, $02a4cc31089f6443$export$e8958a6508ec5b71)) {
        // if the resource was initially fetched for a not applicable project (i.e. not a business project)
        // on the initial page load, then we have not yet fetched the list of sidebar business projects
        // we thus refresh the resource in the background now that we are in a business project
        if (data === (0, $02a4cc31089f6443$export$e8958a6508ec5b71) && !hasRefreshedOnce.current) {
            hasRefreshedOnce.current = true;
            refresh();
        }
        recents = [];
        favorites = [];
        hasMoreFavorite = false;
        overviews = [];
        overviewsError = null;
        isPremiumUserSeat = false;
        showPlansOnboarding = false;
        shouldHideOverviews = false;
    } else {
        recents = data.recents;
        favorites = data.favorites;
        hasMoreFavorite = data.hasMoreFavorite;
        overviews = data.overviews;
        overviewsError = data.overviewsError;
        isPremiumUserSeat = data.isPremiumUserSeat;
        showPlansOnboarding = data.showPlansOnboarding;
        shouldHideOverviews = data.shouldHideOverviews;
    }
    // if the current is not in either recents or favorites, push it to the top of recents
    if (currentProject != null && !recents.some((project)=>project.id === currentProject.id) && !favorites.some((project)=>project.id === currentProject.id)) {
        recents = (0, $3xyNB.prependProject)(currentProject, recents);
        // make sure that the reference doesn't get overwritten for the resource update below
        const newRecents = recents;
        update(()=>({
                recents: newRecents,
                favorites: favorites,
                hasMoreFavorite: hasMoreFavorite,
                overviews: overviews,
                overviewsError: overviewsError,
                isPremiumUserSeat: isPremiumUserSeat,
                showPlansOnboarding: showPlansOnboarding,
                shouldHideOverviews: shouldHideOverviews
            }));
    }
    // if there are changes to favorites, update projects
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(changedItems)) {
        recents = recents.map((project)=>(0, $3xyNB.mapProjectChanges)(project, changedItems));
        favorites = favorites.map((project)=>(0, $3xyNB.mapProjectChanges)(project, changedItems));
    }
    return {
        currentProject: currentProject,
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: hasMoreFavorite,
        onFavoriteToggle: onFavoriteToggle,
        overviews: overviews,
        overviewsError: overviewsError,
        shouldHideOverviews: shouldHideOverviews,
        loading: loading && !isRefreshingFavorites.current
    };
};

});
parcelRegister("44GOl", function(module, exports) {

$parcel$export(module.exports, "useNavigationProject", () => $8449ba04d8e31c91$export$befd5d7ebc77f264);

var $f26dB = parcelRequire("f26dB");


var $aeIT6 = parcelRequire("aeIT6");

var $lB25E = parcelRequire("lB25E");
const $8449ba04d8e31c91$export$befd5d7ebc77f264 = ()=>{
    const { data: currentProject, loading: currentProjectLoading } = (0, $aeIT6.useProject)();
    const { data: navigationData, loading: navigationDataLoading } = (0, $f26dB.useNavigationResource)();
    const [{ match: { params: { projectKey: projectKey } } }] = (0, $lB25E.useRouter)();
    if (currentProject != null) return {
        project: currentProject,
        loading: currentProjectLoading
    };
    if (projectKey != null && navigationData != null && navigationData !== (0, $02a4cc31089f6443$export$e8958a6508ec5b71)) {
        const project = navigationData.favorites.find((proj)=>proj.key === projectKey) ?? navigationData.recents.find((proj)=>proj.key === projectKey) ?? null;
        return {
            project: project,
            loading: navigationDataLoading
        };
    }
    return {
        project: null,
        loading: currentProjectLoading || navigationDataLoading
    };
};

});

parcelRegister("3xyNB", function(module, exports) {

$parcel$export(module.exports, "prependProject", () => $1f9254ac774c5f12$export$9e33a1a4f95ad56f);
$parcel$export(module.exports, "mapProjectChanges", () => $1f9254ac774c5f12$export$6cb16ed8ac180dfc);

const $1f9254ac774c5f12$export$9e33a1a4f95ad56f = (project, projects)=>[
        project,
        ...projects
    ].slice(0, (0, $02a4cc31089f6443$export$3349219a88ac77cd));
const $1f9254ac774c5f12$export$6cb16ed8ac180dfc = (project, changedItems)=>project.id in changedItems ? {
        ...project,
        isFavorite: changedItems[project.id].value
    } : project;

});


parcelRegister("lcKPv", function(module, exports) {

$parcel$export(module.exports, "CreateProjectCta", () => $93a4583b4dd3beb4$export$f49a4235d24dbad0);

var $eUqFw = parcelRequire("eUqFw");

var $j1JdL = parcelRequire("j1JdL");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");
const $93a4583b4dd3beb4$var$runtimeProps = {};
const $93a4583b4dd3beb4$var$entryPointParams = {};
const $93a4583b4dd3beb4$export$f49a4235d24dbad0 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $j1JdL.createProjectCtaEntryPoint), $93a4583b4dd3beb4$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-business-create-project-cta-entrypoint",
        packageName: "@atlassian/jira-business-create-project-cta",
        teamName: "jira-werewolves",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $93a4583b4dd3beb4$var$runtimeProps,
        errorFallback: "unmount"
    });
};

});
parcelRegister("j1JdL", function(module, exports) {

$parcel$export(module.exports, "createProjectCtaEntryPoint", () => $20f4d66eaf9284b5$export$7dadecc7d161da03);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $20f4d66eaf9284b5$export$7dadecc7d161da03 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("UMXPI")), {
        moduleId: "0c73c6d1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("UMXPI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("gcXnX")
]).then(()=>parcelRequire('1kWB8'));

});



parcelRegister("gTasH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c51ef7ea6f1c863$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $eFKPp = parcelRequire("eFKPp");

var $1Yimi = parcelRequire("1Yimi");

var $5xIu6 = parcelRequire("5xIu6");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1pW4J = parcelRequire("1pW4J");

var $hWTey = parcelRequire("hWTey");

var $3PsZt = parcelRequire("3PsZt");
const $8c51ef7ea6f1c863$var$FEEDBACK_GROUP_ID = 'jbus-feedback';
const $8c51ef7ea6f1c863$var$FeedbackButton = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const openFeedbackModal = (0, $5xIu6.useFeedbackCollector)();
    const buttonRef = (0, $eUqFw.useRef)(null);
    const renderNudgeWrapper = (0, $eUqFw.useCallback)((children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hWTey.FeedbackNudgeAsync), null, children), []);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        openFeedbackModal($8c51ef7ea6f1c863$var$FEEDBACK_GROUP_ID, (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), buttonRef);
    }, [
        openFeedbackModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1pW4J.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ref: buttonRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eFKPp))), {
            label: "",
            size: "small"
        }),
        appearance: "subtle-link",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "span",
        size: "UNSAFE_small",
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $3PsZt.default).feedback))));
};
var $8c51ef7ea6f1c863$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($8c51ef7ea6f1c863$var$FeedbackButton);

});
parcelRegister("eFKPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aae9381df7a9f99a$var$_react = $aae9381df7a9f99a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $aae9381df7a9f99a$var$_feedback = $aae9381df7a9f99a$var$_interopRequireDefault((parcelRequire("3kIcQ")));
function $aae9381df7a9f99a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $aae9381df7a9f99a$var$EditorFeedbackIcon = (props)=>/*#__PURE__*/ $aae9381df7a9f99a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M10.922 14.517 5.87 12.68l-.932-.339C4.418 12.151 4 11.552 4 11c0-.556.42-1.153.938-1.341l9.124-3.318c.52-.19.938.105.938.654v8.01c0 .54-.42.842-.938.654zM6 14.227l2 .728V17c0 .552-.405 1.202-.895 1.447l-.21.106C6.4 18.8 6 18.549 6 18.009zm11.224-4.78a.5.5 0 1 1-.448-.894l2-1a.5.5 0 1 1 .448.894zm-.448 4a.5.5 0 0 1 .448-.894l2 1a.5.5 0 0 1-.448.894zM17 11.5a.5.5 0 1 1 0-1h3a.5.5 0 1 1 0 1z"/></svg>`
    }, props, {
        newIcon: $aae9381df7a9f99a$var$_feedback.default
    }));
$aae9381df7a9f99a$var$EditorFeedbackIcon.displayName = 'EditorFeedbackIcon';
var $aae9381df7a9f99a$var$_default = module.exports.default = $aae9381df7a9f99a$var$EditorFeedbackIcon;

});
parcelRegister("3kIcQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8f50fdbec38c602b5aa9320deba7858>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26d587cb75b7e288$var$_react = $26d587cb75b7e288$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $26d587cb75b7e288$var$_UNSAFE_baseNew = $26d587cb75b7e288$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $26d587cb75b7e288$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26d587cb75b7e288$var$FeedbackIcon = (props)=>/*#__PURE__*/ $26d587cb75b7e288$var$_react.default.createElement($26d587cb75b7e288$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
    }, props));
$26d587cb75b7e288$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $26d587cb75b7e288$var$_default = module.exports.default = $26d587cb75b7e288$var$FeedbackIcon;

});


parcelRegister("5xIu6", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $41c842a9ff9149b0$export$4be696be8a3bff13);

var $eUqFw = parcelRequire("eUqFw");

var $1c02D = parcelRequire("1c02D");

var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $10fdS = parcelRequire("10fdS");

var $bNe1g = parcelRequire("bNe1g");

var $c7H0g = parcelRequire("c7H0g");

var $gd0Sp = parcelRequire("gd0Sp");

var $6YoSc = parcelRequire("6YoSc");

var $loHEm = parcelRequire("loHEm");
const $41c842a9ff9149b0$export$698ff856156a88fe = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $6YoSc.default).canContactPrompt), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: "https://www.atlassian.com/legal/privacy-policy",
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $6YoSc.default).canContactPromptLink)));
});
const $41c842a9ff9149b0$export$4f77effad9540593 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $6YoSc.default).enrollInResearchPrompt, {
        link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: "https://www.atlassian.com/research-group",
            target: "_blank",
            rel: "noopener noreferrer"
        }, formatMessage((0, $6YoSc.default).enrollInResearchLink))
    }));
});
const $41c842a9ff9149b0$export$4be696be8a3bff13 = ({ projectType: projectType = 'business' } = {})=>{
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const { licensedProducts: licensedProducts } = (0, $gd0Sp.useTenantContext)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: project } = (0, $bNe1g.useProjectContext)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const getFeedbackContext = (0, $eUqFw.useCallback)((feedbackGroupId)=>{
        const baseFeedbackContext = [
            {
                id: (0, $1c02D.EntryKeys).INLINE_FEEDBACK_ID,
                value: feedbackGroupId
            },
            {
                id: (0, $1c02D.EntryKeys).ROUTE_NAME,
                value: route.name ?? 'unknown'
            },
            {
                id: (0, $1c02D.EntryKeys).ROUTE_GROUP,
                value: route.group ?? 'unknown'
            },
            {
                id: (0, $1c02D.EntryKeys).IS_ADMIN,
                value: isAdmin
            },
            {
                id: (0, $1c02D.EntryKeys).PROJECT_TYPE,
                value: project?.projectType || projectType
            },
            {
                id: (0, $1c02D.EntryKeys).SUPPORTED_PROJECT_TYPES,
                value: (0, $loHEm.licensedProductsToString)(licensedProducts)
            }
        ];
        // Only send project specific information if project is available
        if (project) baseFeedbackContext.push({
            id: (0, $1c02D.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: project.simplified
        });
        return baseFeedbackContext;
    }, [
        isAdmin,
        licensedProducts,
        project,
        projectType,
        route.group,
        route.name
    ]);
    return (0, $eUqFw.useCallback)((feedbackGroupId, onClose, triggerRef)=>{
        const feedbackContext = getFeedbackContext(feedbackGroupId);
        openFeedbackCollector({
            entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: feedbackGroupId,
            canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41c842a9ff9149b0$export$698ff856156a88fe, null),
            enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41c842a9ff9149b0$export$4f77effad9540593, null),
            feedbackContext: feedbackContext,
            onClose: onClose,
            ...triggerRef != null ? {
                triggerRef: triggerRef
            } : {}
        });
    }, [
        getFeedbackContext,
        openFeedbackCollector
    ]);
};

});
parcelRegister("6YoSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bddfc6628ca4ec5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7bddfc6628ca4ec5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    canContactPrompt: {
        "id": "business-feedback-collector.can-contact-prompt",
        "defaultMessage": "Atlassian may contact me about this feedback."
    },
    canContactPromptLink: {
        "id": "business-feedback-collector.can-contact-prompt-link",
        "defaultMessage": "Privacy policy"
    },
    enrollInResearchPrompt: {
        "id": "business-feedback-collector.enroll-in-research-prompt",
        "defaultMessage": "I'd like to help improve Atlassian products by joining the {link}"
    },
    enrollInResearchLink: {
        "id": "business-feedback-collector.enroll-in-research-link",
        "defaultMessage": "Atlassian Research Group"
    }
});

});

parcelRegister("loHEm", function(module, exports) {

$parcel$export(module.exports, "licensedProductsToString", () => $7f7875a39a6a39a8$export$f57a7f1d32485807);
const $7f7875a39a6a39a8$export$f57a7f1d32485807 = (licensedProducts)=>Object.keys(licensedProducts).map((productKey)=>licensedProducts[productKey] ? productKey : '').join(', ');

});


parcelRegister("1pW4J", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $8dd307db4ae4d7c5$export$bd61ee610c74db6c);

var $eUqFw = parcelRequire("eUqFw");

var $ekN4Q = parcelRequire("ekN4Q");

var $16WDb = parcelRequire("16WDb");
const $8dd307db4ae4d7c5$export$bd61ee610c74db6c = (0, $16WDb.withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
    const isFullyExpanded = (0, $ekN4Q.useIsFullyExpanded)();
    return isFullyExpanded ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
});

});
parcelRegister("ekN4Q", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $b942586713a4c8ae$export$7212b6b01271f5d1);

var $eUqFw = parcelRequire("eUqFw");

var $kpmC0 = parcelRequire("kpmC0");
const $b942586713a4c8ae$var$TIMEOUT = 500;
const $b942586713a4c8ae$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $eUqFw.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $kpmC0.useLeftSidebarState)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $b942586713a4c8ae$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});

parcelRegister("16WDb", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $6f4a5382247c5f3b$export$ee1cb2a8280d8710);

var $eUqFw = parcelRequire("eUqFw");

var $cgrgx = parcelRequire("cgrgx");

var $knPb9 = parcelRequire("knPb9");
const $6f4a5382247c5f3b$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $cgrgx.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $knPb9.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});


parcelRegister("hWTey", function(module, exports) {

$parcel$export(module.exports, "FeedbackNudgeAsync", () => $0bc9252b272e4d4e$export$be3f2958452e7be9);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0bc9252b272e4d4e$var$FeedbackNudgeLazy = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("1JklV")).then((exportedModule)=>exportedModule.FeedbackNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-feedback/index.tsx"
});
const $0bc9252b272e4d4e$export$be3f2958452e7be9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$e9e47a7ad42e71f5),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$e9e47a7ad42e71f5)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "feedback-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc9252b272e4d4e$var$FeedbackNudgeLazy, null, children)));
$0bc9252b272e4d4e$export$be3f2958452e7be9.displayName = 'FeedbackNudgeAsync';

});
parcelRegister("ewdMq", function(module, exports) {

$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $adec59c10c54d3d1$export$3915a8814b99f0b);

var $eUqFw = parcelRequire("eUqFw");

var $kMhLP = parcelRequire("kMhLP");

var $7dRgX = parcelRequire("7dRgX");
const $adec59c10c54d3d1$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMhLP.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $7dRgX.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};

});
parcelRegister("kMhLP", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $5bd50febcd8eec1e$export$9171acf2e93b7d4d);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $7Aqzu = parcelRequire("7Aqzu");
const $5bd50febcd8eec1e$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $7Aqzu.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};

});
parcelRegister("7Aqzu", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $eee5ff621608f776$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $eee5ff621608f776$export$807be5f3f1ea996);

var $eUqFw = parcelRequire("eUqFw");

var $cs5mh = parcelRequire("cs5mh");
const $eee5ff621608f776$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $cs5mh.isLoaderError)(error)
    });
const $eee5ff621608f776$export$807be5f3f1ea996 = (attributes = {})=>(0, $eUqFw.useCallback)((error)=>({
            ...attributes,
            ...$eee5ff621608f776$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});



const $99a775c02d636a41$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99a775c02d636a41$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $99a775c02d636a41$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $99a775c02d636a41$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $99a775c02d636a41$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $99a775c02d636a41$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $99a775c02d636a41$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $99a775c02d636a41$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $99a775c02d636a41$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $99a775c02d636a41$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $99a775c02d636a41$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $99a775c02d636a41$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $99a775c02d636a41$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $99a775c02d636a41$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $99a775c02d636a41$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $99a775c02d636a41$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $99a775c02d636a41$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $99a775c02d636a41$export$4d6567e7ee0281bf = 'asyncManageProjectsNudge';
const $99a775c02d636a41$export$f8bf435a6066832c = 'button clicked';
const $99a775c02d636a41$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $99a775c02d636a41$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $99a775c02d636a41$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $99a775c02d636a41$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $99a775c02d636a41$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $99a775c02d636a41$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99a775c02d636a41$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $99a775c02d636a41$export$5908fa8acd2c0739 = 'filterListNudge';
const $99a775c02d636a41$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $99a775c02d636a41$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $99a775c02d636a41$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $99a775c02d636a41$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99a775c02d636a41$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $99a775c02d636a41$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $99a775c02d636a41$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $99a775c02d636a41$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $99a775c02d636a41$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $99a775c02d636a41$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $99a775c02d636a41$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $99a775c02d636a41$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $99a775c02d636a41$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $99a775c02d636a41$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $99a775c02d636a41$export$a1be34032ee24f78 = 'shareProjectNudge';
const $99a775c02d636a41$export$29fe6611cc093756 = 'summaryTabNudge';
const $99a775c02d636a41$export$f107c06c0830f09d = 'reportsTabNudge';
const $99a775c02d636a41$export$9749a972a54ad7ba = 'boardContainerNudge';

parcelRegister("1JklV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1VDSh").then(()=>parcelRequire('kaG0t'));

});


parcelRegister("3PsZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d43629c675088b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $18d43629c675088b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    feedback: {
        "id": "spa-apps-sidebar-core.multi-project-menu.feedback-button.feedback",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("8l70H", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d7d12471fcc325f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8d7d12471fcc325f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    companyManagedProject: {
        "id": "spa-apps-sidebar-core.multi-project-menu.company-managed-project",
        "defaultMessage": "You're in a company-managed project"
    },
    navigationLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.navigation-label",
        "defaultMessage": "Side"
    },
    teamManagedProject: {
        "id": "spa-apps-sidebar-core.multi-project-menu.team-managed-project",
        "defaultMessage": "You're in a team-managed project"
    },
    viewAllStarred: {
        "id": "spa-apps-sidebar-core.multi-project-menu.view-all-starred",
        "defaultMessage": "View all starred projects"
    }
});

});

parcelRegister("4h0Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $905750f428147679$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $dxopF = parcelRequire("dxopF");

var $fIhju = parcelRequire("fIhju");

var $3236p = parcelRequire("3236p");

var $5qKeD = parcelRequire("5qKeD");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $f26dB = parcelRequire("f26dB");

var $lB25E = parcelRequire("lB25E");

var $lg3mT = parcelRequire("lg3mT");

var $94rY2 = parcelRequire("94rY2");

var $dSHCZ = parcelRequire("dSHCZ");

var $gmtu6 = parcelRequire("gmtu6");

var $8MaWo = parcelRequire("8MaWo");
const $905750f428147679$var$Overviews = ({ overviews: overviews, hasError: hasError })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const refresh = (0, $eUqFw.useCallback)(()=>typeof window !== 'undefined' && window.location.reload(), []);
    const [{ match: match, route: route }] = (0, $lB25E.useRouter)();
    const routeOverviewId = match.params?.overviewId;
    const [isCreateModalOpen, setIsCreateModalOpen] = (0, $eUqFw.useState)(false);
    const openCreateModal = (0, $eUqFw.useCallback)(()=>{
        setIsCreateModalOpen(true);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createOverview');
    }, [
        createAnalyticsEvent
    ]);
    const closeCreateModal = (0, $eUqFw.useCallback)(()=>setIsCreateModalOpen(false), []);
    const showOverviewChangeboarding = (0, $f26dB.useTriggerOverviewChangeboarding)();
    if (showOverviewChangeboarding) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94rY2.default), {
        title: formatMessage((0, $gmtu6.default).overviewsHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qKeD.AsyncMigrationMessage), null));
    let content;
    if (hasError) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($905750f428147679$var$ErrorWrapper, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.overviews-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($905750f428147679$var$ErrorMessage, null, formatMessage((0, $gmtu6.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: refresh
    }, formatMessage((0, $gmtu6.default).refreshPage)));
    else if (overviews.length === 0) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($905750f428147679$var$EmptyState, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: openCreateModal
    }, formatMessage((0, $gmtu6.default).createOverview)));
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($905750f428147679$var$List, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.overviews-list"
    }, overviews.map((overview)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: overview.id
        }, routeOverviewId === overview.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8MaWo.default), {
            overview: overview,
            to: (0, $fIhju.getOverviewUrl)(overview),
            isActive: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8MaWo.default), {
            overview: overview,
            to: (0, $fIhju.getOverviewUrl)(overview, route)
        }))));
    const hasReachedLimit = overviews?.length >= (0, $lg3mT.OVERVIEW_MAX_LIMIT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94rY2.default), {
        title: formatMessage((0, $gmtu6.default).overviewsHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSHCZ.default), {
        onClick: openCreateModal,
        hasReachedLimit: hasReachedLimit
    })), content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isCreateModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3236p.default), {
        onClose: closeCreateModal
    })));
};
var $905750f428147679$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($905750f428147679$var$Overviews);
const $905750f428147679$var$EmptyState = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $905750f428147679$var$List = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $905750f428147679$var$ErrorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $905750f428147679$var$ErrorMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s85axq _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fIhju", function(module, exports) {

$parcel$export(module.exports, "getOverviewUrl", () => $3ba1ebdf548dd4c6$export$e314405e3f098e61);

var $exb0h = parcelRequire("exb0h");
const $3ba1ebdf548dd4c6$export$e314405e3f098e61 = (overview, currentRoute)=>{
    switch(currentRoute?.name){
        case 0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY:
        case 0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY:
            return `/jira/core/overviews/${overview.id}/summary`;
        case 0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR:
        case 0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR:
            return `/jira/core/overviews/${overview.id}/calendar`;
        case 0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE:
        case 0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE:
            return `/jira/core/overviews/${overview.id}/timeline`;
        default:
            return `/jira/core/overviews/${overview.id}`;
    }
};

});

parcelRegister("3236p", function(module, exports) {

$parcel$export(module.exports, "default", () => $7de253836bffed60$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $gGtKh = parcelRequire("gGtKh");

var $6VZoe = parcelRequire("6VZoe");

var $jXDc6 = parcelRequire("jXDc6");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7de253836bffed60$var$LazyCreateOverviewModal = (0, $6VZoe.lazy)(()=>(parcelRequire("7JNTg")), {
    ssr: false,
    moduleId: "./src/packages/business/entity/overview/src/ui/create-overview-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7de253836bffed60$export$2e2bcd8739ae039 = ({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $jXDc6.CREATE_OVERVIEW_EXPERIENCE),
        fallback: "unmount",
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "overview-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7de253836bffed60$var$LazyCreateOverviewModal, {
        onClose: onClose
    })));

});
parcelRegister("4G5xU", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $0afb98966ec8ac3d$export$675e0d25df38d426);
$parcel$export(module.exports, "useExperienceAbort", () => $0afb98966ec8ac3d$export$cc92b7ce453f4403);
$parcel$export(module.exports, "useExperienceSuccess", () => $0afb98966ec8ac3d$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceFail", () => $0afb98966ec8ac3d$export$606da7704d8eaf06);
$parcel$export(module.exports, "useQueryBasedViewAutomaticTracking", () => $0afb98966ec8ac3d$export$8ca25d6ff1437be3);
$parcel$export(module.exports, "ExperienceStart", () => $0afb98966ec8ac3d$export$f20b867e738a222c);
$parcel$export(module.exports, "ExperienceFailed", () => $0afb98966ec8ac3d$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceErrorBoundary", () => $0afb98966ec8ac3d$export$139c4a4ad101c3c5);
$parcel$export(module.exports, "ExperienceSuccess", () => $0afb98966ec8ac3d$export$4962f3898bd5c829);
$parcel$export(module.exports, "ExperienceAbort", () => $0afb98966ec8ac3d$export$c9b6bcd70239a39c);

var $eUqFw = parcelRequire("eUqFw");

var $053h2 = parcelRequire("053h2");

var $gCyQH = parcelRequire("gCyQH");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $1Fr7E = parcelRequire("1Fr7E");

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eI5EY = parcelRequire("eI5EY");
const $0afb98966ec8ac3d$export$675e0d25df38d426 = ({ experience: experience, experienceId: experienceId, packageName: packageName })=>(0, $bDhRl.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: packageName
    });
const $0afb98966ec8ac3d$export$cc92b7ce453f4403 = ({ experience: experience }, attributes)=>(0, $1Fr7E.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
const $0afb98966ec8ac3d$export$e94f0da4fc0603c6 = ({ experience: experience })=>(0, $fDZ6r.useExperienceSuccess)({
        experience: experience
    });
const $0afb98966ec8ac3d$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, packageName: packageName, teamName: teamName })=>{
    const onExperienceFail = (0, $4qhD6.useExperienceFail)({
        experience: experience
    });
    const onFail = (0, $eUqFw.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $guiFP.default)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: packageName,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        packageName,
        teamName
    ]);
    return onFail;
};
const $0afb98966ec8ac3d$export$8ca25d6ff1437be3 = (experience, { loading: loading, error: error, shouldStartExperience: shouldStartExperience })=>{
    const [hasStarted, setHasStarted] = (0, $eUqFw.useState)(loading);
    const [hasCompleted, setHasCompleted] = (0, $eUqFw.useState)(false);
    const [hasExperienceBeenTracked, setHasExperienceBeenTracked] = (0, $eUqFw.useState)(false);
    const startExperience = $0afb98966ec8ac3d$export$675e0d25df38d426(experience);
    const onFail = $0afb98966ec8ac3d$export$606da7704d8eaf06(experience);
    const onSuccess = $0afb98966ec8ac3d$export$e94f0da4fc0603c6(experience);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldStartExperience === true) startExperience();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldStartExperience
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasStarted === false && loading === true) setHasStarted(true);
        if (hasStarted === true && loading === false) {
            setHasCompleted(true);
            setHasExperienceBeenTracked(false);
        }
    }, [
        hasStarted,
        loading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasCompleted && !hasExperienceBeenTracked) {
            // make sure experience is tracked once despite re-rendering of the view
            setHasExperienceBeenTracked(true);
            if (typeof error !== 'undefined') {
                const errorAttributes = (0, $eI5EY.fg)('jira_list_partial_failures_instrumentation') ? (0, $053h2.getGraphqlErrorAttributes)(error) : {};
                onFail(`${experience.experience} ${experience.experienceId || ''} useEffect error handling`, error, errorAttributes);
                return;
            }
            onSuccess({
                loaded: true
            });
        }
    }, [
        error,
        experience,
        hasCompleted,
        hasExperienceBeenTracked,
        onFail,
        onSuccess
    ]);
};
const $0afb98966ec8ac3d$export$f20b867e738a222c = /*#__PURE__*/ (0, $eUqFw.memo)(({ experience: experience })=>{
    const start = $0afb98966ec8ac3d$export$675e0d25df38d426(experience);
    (0, $eUqFw.useEffect)(()=>{
        start();
    }, [
        start
    ]);
    return null;
});
const $0afb98966ec8ac3d$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $eUqFw.memo)(({ experience: experience, error: error, attributes: attributes })=>{
    const onFail = $0afb98966ec8ac3d$export$606da7704d8eaf06(experience);
    (0, $eUqFw.useEffect)(()=>{
        onFail(experience.experience, error, attributes);
    }, [
        attributes,
        error,
        experience,
        onFail
    ]);
    return null;
});
const $0afb98966ec8ac3d$export$139c4a4ad101c3c5 = ({ experience: experience, shouldStartExperience: shouldStartExperience, fallback: fallback = (0, $gCyQH.ErrorPage), children: children })=>{
    const onFail = $0afb98966ec8ac3d$export$606da7704d8eaf06(experience);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: experience.packageName,
        teamName: experience.teamName,
        id: experience.experience,
        onError: onFail,
        fallback: fallback
    }, shouldStartExperience === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0afb98966ec8ac3d$export$f20b867e738a222c, {
        experience: experience
    }), children);
};
const $0afb98966ec8ac3d$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $eUqFw.memo)(({ experience: experience, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: experience.experience,
        attributes: {
            ...experience.experienceId == null ? undefined : {
                experienceId: experience.experienceId
            },
            ...attributes
        }
    }));
const $0afb98966ec8ac3d$export$c9b6bcd70239a39c = /*#__PURE__*/ (0, $eUqFw.memo)(({ experience: experience, error: error })=>{
    const onAbort = $0afb98966ec8ac3d$export$cc92b7ce453f4403(experience);
    (0, $eUqFw.useEffect)(()=>{
        onAbort(experience.experience, {
            error: error.message
        });
    }, [
        error,
        experience,
        onAbort
    ]);
    return null;
});

});
parcelRegister("053h2", function(module, exports) {

$parcel$export(module.exports, "shouldHandleTheError", () => $26bb3a81152c05d0$export$47770c8b6d645cdb);
$parcel$export(module.exports, "getGraphqlErrorAttributes", () => $26bb3a81152c05d0$export$b19e649eafc62480);

var $jlBDe = parcelRequire("jlBDe");
const $26bb3a81152c05d0$var$errorWhitelist = [
    'EXPERIENCE_UNAVAILABLE',
    'FIELD_UNAVAILABLE'
];
const $26bb3a81152c05d0$export$47770c8b6d645cdb = (error)=>{
    if (error?.networkError) return true;
    // when issue links are disabled at the instance level and we request it, it throws an error but we still get the whole response
    // There is a issue links perm check that happens after loading the list so the UI already deals with this properly and we can ignore it
    // similarly, even when issue links are enabled, but the field itself is hidden in every screen it will throw an error but we'll still get the whole response
    const filterIssueLinksDisabledErrors = (graphQLError)=>{
        const isWhitelisted = $26bb3a81152c05d0$var$errorWhitelist.includes(graphQLError?.extensions?.errorType);
        return !isWhitelisted;
    };
    const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueLinksDisabledErrors);
    return errorsToShow.length > 0;
};
const $26bb3a81152c05d0$export$b19e649eafc62480 = (error)=>{
    const isApolloError = error instanceof (0, $jlBDe.ApolloError);
    if (!isApolloError) return {};
    const getErrorAttribute = (graphQLErrors, errorAttribute)=>{
        const errors = graphQLErrors.map((graphQLError)=>graphQLError?.extensions?.[errorAttribute]).filter(Boolean);
        return JSON.stringify(errors);
    };
    return {
        statusCodes: getErrorAttribute(error?.graphQLErrors || [], 'statusCode'),
        errorTypes: getErrorAttribute(error?.graphQLErrors || [], 'errorType')
    };
};

});
parcelRegister("jlBDe", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $03a288f5350d9e9d$export$bd096ddbd246c79c);
$parcel$export(module.exports, "ApolloError", () => $03a288f5350d9e9d$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $03a288f5350d9e9d$export$13f5a5f0f1dbab88);
$parcel$export(module.exports, "default", () => $03a288f5350d9e9d$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $6XJYy = parcelRequire("6XJYy");

var $8j2fP = parcelRequire("8j2fP");

var $961BR = parcelRequire("961BR");
var $03a288f5350d9e9d$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($03a288f5350d9e9d$export$bd096ddbd246c79c || ($03a288f5350d9e9d$export$bd096ddbd246c79c = {}));
function $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $03a288f5350d9e9d$var$Observable = function(_super) {
    (0, $fKE23.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $6XJYy.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $5ECju.default));
function $03a288f5350d9e9d$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $03a288f5350d9e9d$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $03a288f5350d9e9d$var$generateErrorMessage = function(err) {
    var message = '';
    if ($03a288f5350d9e9d$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $03a288f5350d9e9d$export$26a337512320b8c6 = function(_super) {
    (0, $fKE23.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $03a288f5350d9e9d$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $03a288f5350d9e9d$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($03a288f5350d9e9d$export$160bafb6ac1e0641 || ($03a288f5350d9e9d$export$160bafb6ac1e0641 = {}));
var $03a288f5350d9e9d$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $03a288f5350d9e9d$export$6c1b56eac59c9584 = function(_super) {
    (0, $fKE23.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $42BH7.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($03a288f5350d9e9d$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $03a288f5350d9e9d$export$bd096ddbd246c79c.loading : $03a288f5350d9e9d$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            stale: false
        }));
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $66hGB.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $8j2fP.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $66hGB.equal)(this.variables, variables)) this.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), variables);
        if (!(0, $66hGB.equal)(this.options.variables, this.variables)) this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $8j2fP.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $03a288f5350d9e9d$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $66hGB.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $42BH7.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $42BH7.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $66hGB.equal)(previousVariables, variables)) _this.refetch();
                        else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($03a288f5350d9e9d$var$Observable);
function $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback(error) {}
function $03a288f5350d9e9d$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $8j2fP.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $03a288f5350d9e9d$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $03a288f5350d9e9d$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $8j2fP.invariant)(!previousQuery || previousQuery.document === query.document || (0, $66hGB.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.loading) {
            if (!(0, $66hGB.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.refetch;
        else networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $03a288f5350d9e9d$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $03a288f5350d9e9d$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $42BH7.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $42BH7.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $42BH7.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $42BH7.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $8j2fP.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $fKE23.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $961BR.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $961BR.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $42BH7.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $fKE23.__generator)(this, function(_b) {
                mainDefinition = (0, $42BH7.getMainDefinition)(document);
                fragments = (0, $42BH7.getFragmentDefinitions)(document);
                fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $03a288f5350d9e9d$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $fKE23.__generator)(this, function(_a) {
                            if (!(0, $42BH7.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $42BH7.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $8j2fP.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $42BH7.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $42BH7.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $42BH7.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $03a288f5350d9e9d$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $03a288f5350d9e9d$var$asyncMap(observable, mapFn) {
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $03a288f5350d9e9d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $03a288f5350d9e9d$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $03a288f5350d9e9d$var$MutationStore();
        this.queryStore = new $03a288f5350d9e9d$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $42BH7.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $03a288f5350d9e9d$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $8j2fP.invariant)(mutation, 9);
                        (0, $8j2fP.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $03a288f5350d9e9d$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $42BH7.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $03a288f5350d9e9d$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($03a288f5350d9e9d$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $42BH7.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $42BH7.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($03a288f5350d9e9d$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $03a288f5350d9e9d$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $42BH7.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $42BH7.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $42BH7.getDefaultValues)((0, $42BH7.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $fKE23.__assign)({}, options);
        return new $03a288f5350d9e9d$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $8j2fP.invariant)(options.query, 12);
        (0, $8j2fP.invariant)(options.query.kind === 'Document', 13);
        (0, $8j2fP.invariant)(!options.returnPartialData, 14);
        (0, $8j2fP.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $42BH7.graphQLResultHasError)(result)) throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $03a288f5350d9e9d$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $8j2fP.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $42BH7.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation));
        } else {
            observable = $03a288f5350d9e9d$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $03a288f5350d9e9d$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(result.errors)) return reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.ready && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $8j2fP.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $03a288f5350d9e9d$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $03a288f5350d9e9d$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $42BH7.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $42BH7.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $42BH7.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $42BH7.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $42BH7.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $42BH7.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $42BH7.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $03a288f5350d9e9d$var$version = "2.6.10";
var $03a288f5350d9e9d$var$hasSuggestedDevtools = false;
var $03a288f5350d9e9d$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $bvQX6.ApolloLink).empty();
        if (!link || !cache) throw new (0, $8j2fP.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $03a288f5350d9e9d$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $03a288f5350d9e9d$var$version;
        this.localState = new $03a288f5350d9e9d$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $03a288f5350d9e9d$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.query), options);
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $bvQX6.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $03a288f5350d9e9d$export$2e2bcd8739ae039 = $03a288f5350d9e9d$export$13f5a5f0f1dbab88;

});
parcelRegister("42BH7", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $2f1496a7de754c2a$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $2f1496a7de754c2a$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $2f1496a7de754c2a$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $2f1496a7de754c2a$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $2f1496a7de754c2a$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $2f1496a7de754c2a$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $2f1496a7de754c2a$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $2f1496a7de754c2a$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $2f1496a7de754c2a$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $2f1496a7de754c2a$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $2f1496a7de754c2a$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $2f1496a7de754c2a$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $2f1496a7de754c2a$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $2f1496a7de754c2a$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $2f1496a7de754c2a$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $2f1496a7de754c2a$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $2f1496a7de754c2a$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $2f1496a7de754c2a$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $2f1496a7de754c2a$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $2f1496a7de754c2a$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $2f1496a7de754c2a$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $2f1496a7de754c2a$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $2f1496a7de754c2a$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $2f1496a7de754c2a$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $2f1496a7de754c2a$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $2f1496a7de754c2a$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $2f1496a7de754c2a$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $2f1496a7de754c2a$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $2f1496a7de754c2a$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $2f1496a7de754c2a$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $2f1496a7de754c2a$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $2f1496a7de754c2a$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $2f1496a7de754c2a$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $2f1496a7de754c2a$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $2f1496a7de754c2a$export$160070228be94b08);

var $961BR = parcelRequire("961BR");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $cGs0N = parcelRequire("cGs0N");

var $66hGB = parcelRequire("66hGB");

var $2fFJv = parcelRequire("2fFJv");
function $2f1496a7de754c2a$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $2f1496a7de754c2a$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $2f1496a7de754c2a$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $2f1496a7de754c2a$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $2f1496a7de754c2a$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $2f1496a7de754c2a$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $2f1496a7de754c2a$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $2f1496a7de754c2a$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $2f1496a7de754c2a$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($2f1496a7de754c2a$var$isIntValue(value) || $2f1496a7de754c2a$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($2f1496a7de754c2a$var$isBooleanValue(value) || $2f1496a7de754c2a$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($2f1496a7de754c2a$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($2f1496a7de754c2a$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($2f1496a7de754c2a$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $8j2fP.InvariantError)(17);
}
function $2f1496a7de754c2a$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $2f1496a7de754c2a$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $2f1496a7de754c2a$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $2f1496a7de754c2a$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $2f1496a7de754c2a$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($2f1496a7de754c2a$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $2f1496a7de754c2a$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $2f1496a7de754c2a$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $2f1496a7de754c2a$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $fKE23.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $2f1496a7de754c2a$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $2f1496a7de754c2a$var$defaultValueFromVariable(node) {
    throw new (0, $8j2fP.InvariantError)(18);
}
function $2f1496a7de754c2a$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $2f1496a7de754c2a$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $2f1496a7de754c2a$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $2f1496a7de754c2a$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $2f1496a7de754c2a$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $2f1496a7de754c2a$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $8j2fP.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $2f1496a7de754c2a$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $961BR.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $2f1496a7de754c2a$export$2dafb573e282fe8d(names, doc) {
    return $2f1496a7de754c2a$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a(document) {
    return document && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'client'
    ], document) && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $2f1496a7de754c2a$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($2f1496a7de754c2a$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $8j2fP.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $8j2fP.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $8j2fP.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $2f1496a7de754c2a$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $8j2fP.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, document), {
        definitions: (0, $fKE23.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $2f1496a7de754c2a$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $2f1496a7de754c2a$export$a92e7a440b22bdf0(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $8j2fP.invariant)(mutationDef, 1);
    return mutationDef;
}
function $2f1496a7de754c2a$export$a7d0d8111d2386df(doc) {
    (0, $8j2fP.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(3);
        return definition;
    });
    (0, $8j2fP.invariant)(operations.length <= 1, 4);
    return doc;
}
function $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $2f1496a7de754c2a$export$78a8e95d8d43ad7f(document) {
    var def = $2f1496a7de754c2a$export$7a5b1fa979d2c158(document);
    (0, $8j2fP.invariant)(def, 5);
    return def;
}
function $2f1496a7de754c2a$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $2f1496a7de754c2a$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $2f1496a7de754c2a$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc);
    (0, $8j2fP.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $2f1496a7de754c2a$export$772111caef41b3f5(doc) {
    (0, $8j2fP.invariant)(doc.kind === 'Document', 7);
    (0, $8j2fP.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $8j2fP.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $2f1496a7de754c2a$export$f431198736b7f96d(queryDoc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $8j2fP.InvariantError)(10);
}
function $2f1496a7de754c2a$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $2f1496a7de754c2a$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $2f1496a7de754c2a$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $2f1496a7de754c2a$export$e6e34fd1f2686227.apply(void 0, (0, $fKE23.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $2f1496a7de754c2a$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $2f1496a7de754c2a$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $2f1496a7de754c2a$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $2f1496a7de754c2a$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $2f1496a7de754c2a$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $2f1496a7de754c2a$var$nullIfDocIsEmpty(doc) {
    return $2f1496a7de754c2a$var$isEmpty($2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) || $2f1496a7de754c2a$export$772111caef41b3f5(doc), $2f1496a7de754c2a$export$193789b4c8246dd4($2f1496a7de754c2a$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $2f1496a7de754c2a$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $2f1496a7de754c2a$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($2f1496a7de754c2a$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$43b332f87950a467(doc) {
    return (0, $961BR.visit)($2f1496a7de754c2a$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($2f1496a7de754c2a$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    selections: (0, $fKE23.__spreadArrays)(selections, [
                        $2f1496a7de754c2a$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $2f1496a7de754c2a$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $2f1496a7de754c2a$export$74985f3324559867(doc) {
    return $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        $2f1496a7de754c2a$var$connectionRemoveConfig
    ], $2f1496a7de754c2a$export$a7d0d8111d2386df(doc));
}
function $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$2f1496a7de754c2a$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives)) || nestedCheck && $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $2f1496a7de754c2a$export$deed3420cb5d2e1d(directives, doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $2f1496a7de754c2a$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $2f1496a7de754c2a$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $2f1496a7de754c2a$var$getArgumentMatcher(config);
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $2f1496a7de754c2a$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($2f1496a7de754c2a$export$fb56ad75dd311c12(selection) || $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $2f1496a7de754c2a$export$57c368c23873f32b(document) {
    var definition = $2f1496a7de754c2a$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $961BR.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$8eae69e876ee321e(document) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(document);
    var modifiedDoc = $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $961BR.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $2f1496a7de754c2a$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $2f1496a7de754c2a$var$toString = Object.prototype.toString;
function $2f1496a7de754c2a$export$629a2bd3f5a49ecc(value) {
    return $2f1496a7de754c2a$var$cloneDeepHelper(value, new Map());
}
function $2f1496a7de754c2a$var$cloneDeepHelper(val, seen) {
    switch($2f1496a7de754c2a$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $2f1496a7de754c2a$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $2f1496a7de754c2a$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() {
    if (typeof $2fFJv !== 'undefined' && "production") return "production";
    return 'development';
}
function $2f1496a7de754c2a$export$f0cb0fda19c18b37(env) {
    return $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() === env;
}
function $2f1496a7de754c2a$export$f15d00aa73aafac4() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('production') === true;
}
function $2f1496a7de754c2a$export$df77466336fe5355() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('development') === true;
}
function $2f1496a7de754c2a$export$410cbc2864fa25b5() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('test') === true;
}
function $2f1496a7de754c2a$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $2f1496a7de754c2a$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $2f1496a7de754c2a$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $2f1496a7de754c2a$var$deepFreeze(o[prop]);
    });
    return o;
}
function $2f1496a7de754c2a$export$7f9c177735b71f18(obj) {
    if ($2f1496a7de754c2a$export$df77466336fe5355() || $2f1496a7de754c2a$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $2f1496a7de754c2a$var$deepFreeze(obj);
    }
    return obj;
}
var $2f1496a7de754c2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $2f1496a7de754c2a$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $2f1496a7de754c2a$export$160070228be94b08(sources);
}
function $2f1496a7de754c2a$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $2f1496a7de754c2a$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $2f1496a7de754c2a$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $2f1496a7de754c2a$var$mergeHelper(target, source, pastCopies) {
    if ($2f1496a7de754c2a$var$isObject(source) && $2f1496a7de754c2a$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($2f1496a7de754c2a$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $2f1496a7de754c2a$var$mergeHelper($2f1496a7de754c2a$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $2f1496a7de754c2a$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $fKE23.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $2f1496a7de754c2a$var$haveWarned = Object.create({});
function $2f1496a7de754c2a$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$2f1496a7de754c2a$export$f15d00aa73aafac4() && !$2f1496a7de754c2a$var$haveWarned[msg]) {
        if (!$2f1496a7de754c2a$export$410cbc2864fa25b5()) $2f1496a7de754c2a$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $2f1496a7de754c2a$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("8j2fP", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $60c1d8bb20ac9f24$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $60c1d8bb20ac9f24$export$f5708dca728d7177);

var $fKE23 = parcelRequire("fKE23");

var $2fFJv = parcelRequire("2fFJv");
var $60c1d8bb20ac9f24$var$genericMessage = "Invariant Violation";
var $60c1d8bb20ac9f24$var$_a = Object.setPrototypeOf, $60c1d8bb20ac9f24$var$setPrototypeOf = $60c1d8bb20ac9f24$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $60c1d8bb20ac9f24$var$_a;
var $60c1d8bb20ac9f24$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $60c1d8bb20ac9f24$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $60c1d8bb20ac9f24$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $60c1d8bb20ac9f24$var$genericMessage;
        $60c1d8bb20ac9f24$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $60c1d8bb20ac9f24$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $60c1d8bb20ac9f24$export$cea12affaee22fe8(message);
}
function $60c1d8bb20ac9f24$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $60c1d8bb20ac9f24$var$wrapConsoleMethod("warn");
    invariant.error = $60c1d8bb20ac9f24$var$wrapConsoleMethod("error");
})($60c1d8bb20ac9f24$export$f5708dca728d7177 || ($60c1d8bb20ac9f24$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $2fFJv === "object") $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = $2fFJv;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($60c1d8bb20ac9f24$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $60c1d8bb20ac9f24$var$invariant$1 = $60c1d8bb20ac9f24$export$f5708dca728d7177;
var $60c1d8bb20ac9f24$export$2e2bcd8739ae039 = $60c1d8bb20ac9f24$var$invariant$1;

});

parcelRegister("cGs0N", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("66hGB", function(module, exports) {

$parcel$export(module.exports, "equal", () => $471105b2f2fd38f1$export$411ce8e5a71e3069);
var $471105b2f2fd38f1$var$_a = Object.prototype, $471105b2f2fd38f1$var$toString = $471105b2f2fd38f1$var$_a.toString, $471105b2f2fd38f1$var$hasOwnProperty = $471105b2f2fd38f1$var$_a.hasOwnProperty;
var $471105b2f2fd38f1$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $471105b2f2fd38f1$export$411ce8e5a71e3069(a, b) {
    try {
        return $471105b2f2fd38f1$var$check(a, b);
    } finally{
        $471105b2f2fd38f1$var$previousComparisons.clear();
    }
}
function $471105b2f2fd38f1$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $471105b2f2fd38f1$var$toString.call(a);
    var bTag = $471105b2f2fd38f1$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$471105b2f2fd38f1$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$471105b2f2fd38f1$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$471105b2f2fd38f1$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $471105b2f2fd38f1$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $471105b2f2fd38f1$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $471105b2f2fd38f1$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $471105b2f2fd38f1$export$2e2bcd8739ae039 = $471105b2f2fd38f1$export$411ce8e5a71e3069;

});


parcelRegister("bvQX6", function(module, exports) {

$parcel$export(module.exports, "makePromise", () => makePromise);
$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "split", () => split);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("5ECju")).default);

var $5ECju = parcelRequire("5ECju");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $8j2fP.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $fKE23.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $5ECju.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $5ECju.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $42BH7.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $fKE23.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $fKE23.__assign)({}, context, next(context));
        else context = (0, $fKE23.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $fKE23.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $5ECju.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $5ECju.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $5ECju.default).of() : rightLink.request(operation) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $5ECju.default).of() : rightLink.request(operation, forward) || (0, $5ECju.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $8j2fP.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $5ECju.default).of();
}

});
parcelRegister("5ECju", function(module, exports) {

$parcel$export(module.exports, "default", () => $41de6865c2ff0290$export$2e2bcd8739ae039);

var $1eC02 = parcelRequire("1eC02");
var $41de6865c2ff0290$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($1eC02)));
var $41de6865c2ff0290$export$2e2bcd8739ae039 = $41de6865c2ff0290$export$77cea355fa80b5f4;

});
parcelRegister("1eC02", function(module, exports) {

module.exports = (parcelRequire("bhbKH")).Observable;

});
parcelRegister("bhbKH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $835a65fddbd60374$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $835a65fddbd60374$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $835a65fddbd60374$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $835a65fddbd60374$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $835a65fddbd60374$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $835a65fddbd60374$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $835a65fddbd60374$var$hasSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbols() && Boolean(Symbol[name]);
};
var $835a65fddbd60374$var$getSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($835a65fddbd60374$var$hasSymbols() && !$835a65fddbd60374$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $835a65fddbd60374$var$SymbolIterator = $835a65fddbd60374$var$getSymbol('iterator');
var $835a65fddbd60374$var$SymbolObservable = $835a65fddbd60374$var$getSymbol('observable');
var $835a65fddbd60374$var$SymbolSpecies = $835a65fddbd60374$var$getSymbol('species'); // === Abstract Operations ===
function $835a65fddbd60374$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $835a65fddbd60374$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$835a65fddbd60374$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $835a65fddbd60374$var$Observable;
}
function $835a65fddbd60374$var$isObservable(x) {
    return x instanceof $835a65fddbd60374$var$Observable; // SPEC: Brand check
}
function $835a65fddbd60374$var$hostReportError(e) {
    if ($835a65fddbd60374$var$hostReportError.log) $835a65fddbd60374$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $835a65fddbd60374$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $835a65fddbd60374$var$hostReportError(e);
        }
    });
}
function $835a65fddbd60374$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $835a65fddbd60374$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
}
function $835a65fddbd60374$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $835a65fddbd60374$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $835a65fddbd60374$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $835a65fddbd60374$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $835a65fddbd60374$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $835a65fddbd60374$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $835a65fddbd60374$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $835a65fddbd60374$var$enqueue(function() {
            return $835a65fddbd60374$var$flushSubscription(subscription);
        });
        return;
    }
    $835a65fddbd60374$var$notifySubscription(subscription, type, value);
}
var $835a65fddbd60374$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $835a65fddbd60374$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $835a65fddbd60374$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $835a65fddbd60374$var$closeSubscription(this);
                    $835a65fddbd60374$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $835a65fddbd60374$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $835a65fddbd60374$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $835a65fddbd60374$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $835a65fddbd60374$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $835a65fddbd60374$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $835a65fddbd60374$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $835a65fddbd60374$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($835a65fddbd60374$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($835a65fddbd60374$var$hasSymbol('iterator')) {
                    method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $835a65fddbd60374$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $835a65fddbd60374$var$Observable;
if ($835a65fddbd60374$var$hasSymbols()) Object.defineProperty($835a65fddbd60374$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $835a65fddbd60374$var$SymbolObservable,
        hostReportError: $835a65fddbd60374$var$hostReportError
    },
    configurable: true
});

});






parcelRegister("gCyQH", function(module, exports) {

$parcel$export(module.exports, "ErrorPage", () => $6c8115aba8656cec$export$c120a0e80fd44ca6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bEZRh = parcelRequire("bEZRh");
const $6c8115aba8656cec$export$c120a0e80fd44ca6 = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c8115aba8656cec$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.JSErrorPageAsync), {
        error: error
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c8115aba8656cec$var$ErrorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkvuon _syaz1fxt",
            __cmplp.className
        ])
    });
});

});


parcelRegister("jXDc6", function(module, exports) {

$parcel$export(module.exports, "CREATE_OVERVIEW_EXPERIENCE", () => $92a66ffd6a5018dc$export$9b5e8e07ff330ef2);
$parcel$export(module.exports, "EDIT_OVERVIEW_EXPERIENCE", () => $92a66ffd6a5018dc$export$a58227116ceb8b81);
$parcel$export(module.exports, "DELETE_OVERVIEW_EXPERIENCE", () => $92a66ffd6a5018dc$export$e17a11e4247a14f7);
$parcel$export(module.exports, "MODAL_WIDTH", () => $92a66ffd6a5018dc$export$3d931b64f46140b3);

var $c9TLT = parcelRequire("c9TLT");
const $92a66ffd6a5018dc$export$b8b9d90f9e5bd72b = 'jiraBusinessEntityOverview';
const $92a66ffd6a5018dc$export$9b5e8e07ff330ef2 = {
    experience: 'create-overview',
    packageName: $92a66ffd6a5018dc$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $92a66ffd6a5018dc$export$a58227116ceb8b81 = {
    experience: 'edit-overview',
    packageName: $92a66ffd6a5018dc$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $92a66ffd6a5018dc$export$e17a11e4247a14f7 = {
    experience: 'delete-overview',
    packageName: $92a66ffd6a5018dc$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $92a66ffd6a5018dc$export$d03d4e78ea5b909a = (0, $c9TLT.gridSize) * 2;
const $92a66ffd6a5018dc$export$57ee5df6bad94642 = 400;
const $92a66ffd6a5018dc$export$5785b84269e3e763 = 340;
const $92a66ffd6a5018dc$export$7c9c92ba6b198ac4 = (0, $c9TLT.gridSize) * 3;
const $92a66ffd6a5018dc$export$c4232794452dc6e3 = 480;
const $92a66ffd6a5018dc$export$3d931b64f46140b3 = $92a66ffd6a5018dc$export$c4232794452dc6e3 + $92a66ffd6a5018dc$export$57ee5df6bad94642 + $92a66ffd6a5018dc$export$7c9c92ba6b198ac4 * 2 + $92a66ffd6a5018dc$export$d03d4e78ea5b909a * 2;
const $92a66ffd6a5018dc$var$MODAL_DIALOG_MARGIN = 120;
const $92a66ffd6a5018dc$export$68bc124b0fa13de0 = $92a66ffd6a5018dc$export$3d931b64f46140b3 + $92a66ffd6a5018dc$var$MODAL_DIALOG_MARGIN;

});

parcelRegister("7JNTg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("he5e3")
]).then(()=>parcelRequire('jthZP'));

});


parcelRegister("5qKeD", function(module, exports) {

$parcel$export(module.exports, "AsyncMigrationMessage", () => $20b69e266ccb1e91$export$93794b6cb00009c5);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $fXgkp = parcelRequire("fXgkp");
const $20b69e266ccb1e91$var$runtimeProps = {};
const $20b69e266ccb1e91$var$entryPointParams = {};
const $20b69e266ccb1e91$export$93794b6cb00009c5 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $fXgkp.migrationMessageEntrypoint), $20b69e266ccb1e91$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "overviews-plans-onboarding-migration-message",
        packageName: "jiraBusinessOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $20b69e266ccb1e91$var$runtimeProps
    });
};

});
parcelRegister("fXgkp", function(module, exports) {

$parcel$export(module.exports, "migrationMessageEntrypoint", () => $8c5cd663e92125c4$export$2dea5f3fdc0ae86);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $8c5cd663e92125c4$export$2dea5f3fdc0ae86 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("f3TGp")).then((module)=>module.MigrationMessage), {
        moduleId: "cb473cb0"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("f3TGp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cyvEN")
]).then(()=>parcelRequire('7Sxem'));

});



parcelRegister("lg3mT", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $f1a163edcd3bb430$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "MENU_ID", () => $f1a163edcd3bb430$export$d4cd258d01c03112);
$parcel$export(module.exports, "SECTION_ID", () => $f1a163edcd3bb430$export$501955bd67991a25);
$parcel$export(module.exports, "REPORTS_ROUTES_SET", () => $f1a163edcd3bb430$export$f746f9acd7a66bdb);
$parcel$export(module.exports, "SETTINGS_ROUTES_SET", () => $f1a163edcd3bb430$export$e8d6319ab0eb2a27);
$parcel$export(module.exports, "ISSUES_ROUTES_SET", () => $f1a163edcd3bb430$export$6ca9a18cdf1b5a79);
$parcel$export(module.exports, "FORGE_ROUTES_SET", () => $f1a163edcd3bb430$export$6ad6f0faae6ab404);
$parcel$export(module.exports, "JIRA_AUTOMATION_ADDON_KEY", () => $f1a163edcd3bb430$export$75d31ae45b00712c);
$parcel$export(module.exports, "LOCATION", () => $f1a163edcd3bb430$export$87d0ca22edb7493a);
$parcel$export(module.exports, "OVERVIEW_MAX_LIMIT", () => $f1a163edcd3bb430$export$96f465f51836d3a2);

var $exb0h = parcelRequire("exb0h");

var $c9TLT = parcelRequire("c9TLT");
const $f1a163edcd3bb430$export$b8b9d90f9e5bd72b = 'jira.navigation.sidebar.core';
const $f1a163edcd3bb430$export$d4cd258d01c03112 = 'project/core';
const $f1a163edcd3bb430$export$501955bd67991a25 = {
    ISSUES: 'issues',
    REPORTS: 'reports',
    SETTINGS: 'settings',
    ISSUE_TYPES: 'issuetypes'
};
const $f1a163edcd3bb430$export$f746f9acd7a66bdb = new Set([
    (0, $exb0h.ROUTE_NAMES_LEGACY_ALL_REPORTS),
    (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_CONFIG),
    (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_AVERAGE_AGE),
    (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_CREATED_VS_RESOLVED),
    (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_PIE),
    (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_RECENTLY_CREATED),
    (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_RESOLUTION_TIME),
    (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY),
    (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_TIME_SINCE),
    (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_TIME_TRACKING_REPORT),
    (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_DEVELOPER_WORKLOAD),
    (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_VERSION_WORKLOAD),
    (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_WORKLOAD_PIE)
]);
const $f1a163edcd3bb430$export$e8d6319ab0eb2a27 = new Set([
    (0, $exb0h.ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_CONFIG),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_OPSGENIE),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SUMMARY),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
    (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
    (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS),
    (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV)
]);
const $f1a163edcd3bb430$export$6ca9a18cdf1b5a79 = new Set([
    (0, $exb0h.ROUTE_NAMES_LEGACY_PIN),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE)
]);
const $f1a163edcd3bb430$export$6ad6f0faae6ab404 = new Set([
    (0, $exb0h.ROUTE_NAMES_FORGE_PROJECT),
    (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS)
]);
const $f1a163edcd3bb430$export$75d31ae45b00712c = 'com.codebarrel.addons.automation';
const $f1a163edcd3bb430$export$33abecf3eb4ba30b = (0, $c9TLT.gridSize) * 5;
const $f1a163edcd3bb430$export$76ca6e18b275dcad = 24;
const $f1a163edcd3bb430$export$87d0ca22edb7493a = 'jwmNavigationCreateProject';
const $f1a163edcd3bb430$export$96f465f51836d3a2 = 10;

});

parcelRegister("94rY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2cfaa3cc51cd03b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $d2cfaa3cc51cd03b$var$SectionHeader = ({ children: children, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d2cfaa3cc51cd03b$export$960a49cc3d27a090, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d2cfaa3cc51cd03b$export$8b251419efc915eb, null, title), children);
var $d2cfaa3cc51cd03b$export$2e2bcd8739ae039 = $d2cfaa3cc51cd03b$var$SectionHeader;
const $d2cfaa3cc51cd03b$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4zamj _1e0c1txw _1bah1yb4 _zulpu2gc _4cvr1h6o _1tke1tcg _vchhusvi",
            __cmplp.className
        ])
    });
});
const $d2cfaa3cc51cd03b$export$8b251419efc915eb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1kw7 _19pkidpf _11c81bk4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dSHCZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab9b6c8e2a461a8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $5JgJ2 = parcelRequire("5JgJ2");

var $rRiBz = parcelRequire("rRiBz");

var $hOFzv = parcelRequire("hOFzv");

var $gxlwv = parcelRequire("gxlwv");
const $aab9b6c8e2a461a8$var$CREATE_BUTTON_TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.overviews.create-overview';
const $aab9b6c8e2a461a8$var$CreateOverview = ({ onClick: onClick, hasReachedLimit: hasReachedLimit })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isWarningOpen, setIsWarningOpen] = (0, $eUqFw.useState)(false);
    if (hasReachedLimit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        placement: "bottom-start",
        isOpen: isWarningOpen,
        onClose: ()=>setIsWarningOpen(false),
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $rRiBz.default), {
                ...triggerProps,
                onClick: ()=>setIsWarningOpen((isOpen)=>!isOpen),
                label: formatMessage((0, $hOFzv.default).createOverviewLabel),
                testId: $aab9b6c8e2a461a8$var$CREATE_BUTTON_TEST_ID,
                ref: ref
            }),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gxlwv.default), null)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $rRiBz.default), {
        onClick: onClick,
        label: formatMessage((0, $hOFzv.default).createOverviewLabel),
        testId: $aab9b6c8e2a461a8$var$CREATE_BUTTON_TEST_ID
    });
};
var $aab9b6c8e2a461a8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($aab9b6c8e2a461a8$var$CreateOverview);

});
parcelRegister("rRiBz", function(module, exports) {

$parcel$export(module.exports, "default", () => $76157c9c7cef0bf6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $bkIGg = parcelRequire("bkIGg");

var $lxfVR = parcelRequire("lxfVR");

var $2eG9N = parcelRequire("2eG9N");

var $8rQuz = parcelRequire("8rQuz");

var $bUVhp = parcelRequire("bUVhp");
const $76157c9c7cef0bf6$var$RoundCreateButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ label: label, onClick: onClick, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: label,
        hideTooltipOnClick: true
    }, (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        testId: testId,
        onClick: onClick,
        spacing: "compact",
        appearance: "default",
        shape: "circle",
        label: label,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lxfVR))), {
                label: label,
                color: "var(--ds-text, #172B4D)"
            })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bUVhp.StyledButton), {
        ...props,
        ref: ref,
        testId: testId,
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: label,
            primaryColor: "var(--ds-text, #172B4D)",
            size: "small"
        }),
        onClick: onClick
    })));
var $76157c9c7cef0bf6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($76157c9c7cef0bf6$var$RoundCreateButton);

});
parcelRegister("lxfVR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6930ecfe7b47077a4ac983ce0c975fdd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fad909d8570b5bbf$var$_react = $fad909d8570b5bbf$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $fad909d8570b5bbf$var$_UNSAFE_baseNew = $fad909d8570b5bbf$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $fad909d8570b5bbf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Add".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for creating and adding an object as a secondary/tertiary action in a menu item.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fad909d8570b5bbf$var$AddIcon = (props)=>/*#__PURE__*/ $fad909d8570b5bbf$var$_react.default.createElement($fad909d8570b5bbf$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M6 6h5M6 6H1m5 0V1m0 5v5"/>`,
        type: 'utility'
    }, props));
$fad909d8570b5bbf$var$AddIcon.displayName = 'AddIcon';
var $fad909d8570b5bbf$var$_default = module.exports.default = $fad909d8570b5bbf$var$AddIcon;

});

parcelRegister("bUVhp", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $b2fbec61fcc14fc7$export$2d5d2ba3c7c8c40b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $b2fbec61fcc14fc7$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1njd _1pbykb7n",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hOFzv", function(module, exports) {

$parcel$export(module.exports, "default", () => $413e172b8c878b47$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $413e172b8c878b47$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createOverviewLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.create-overview-label",
        "defaultMessage": "Create overview"
    }
});

});

parcelRegister("gxlwv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0b10dfebf342cc5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5YsMl = parcelRequire("5YsMl");

var $1Yimi = parcelRequire("1Yimi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lg3mT = parcelRequire("lg3mT");

var $4VuJA = parcelRequire("4VuJA");
const $f0b10dfebf342cc5$var$OverviewLimitPopup = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0b10dfebf342cc5$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: "",
        primaryColor: "var(--ds-icon-warning, #ffab00)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $4VuJA.default).overviewLimitReached, {
        overviewMaxLimit: (0, $lg3mT.OVERVIEW_MAX_LIMIT)
    })));
};
var $f0b10dfebf342cc5$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = /*#__PURE__*/ (0, $eUqFw.memo)($f0b10dfebf342cc5$var$OverviewLimitPopup);
const $f0b10dfebf342cc5$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _zulpu2gc _1yt44ar7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4VuJA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f6d7d156ba1ad3d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3f6d7d156ba1ad3d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    overviewLimitReached: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.overview-limit-popup.overview-limit-reached",
        "defaultMessage": "You've reached the limit of {overviewMaxLimit, plural, one {# overview} other {# overviews}}"
    }
});

});



parcelRegister("gmtu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c69d68e991d71af7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c69d68e991d71af7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createOverview: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview",
        "defaultMessage": "Create an overview"
    },
    overviewsHeader: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.overviews-header",
        "defaultMessage": "Overviews"
    },
    errorMessage: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.error-message",
        "defaultMessage": "We couldn't load overviews"
    },
    refreshPage: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.refresh-page",
        "defaultMessage": "Refresh page"
    }
});

});

parcelRegister("8MaWo", function(module, exports) {

$parcel$export(module.exports, "default", () => $85de1c4527c5fda3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gotST = parcelRequire("gotST");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7BoX4 = parcelRequire("7BoX4");

var $2Ucfd = parcelRequire("2Ucfd");

var $3YFEG = parcelRequire("3YFEG");
const $85de1c4527c5fda3$var$OverviewLink = ({ overview: overview, to: to, isActive: isActive = false })=>{
    const { name: name, theme: theme } = overview;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3YFEG.default), {
        to: to,
        isActive: isActive,
        prefetch: "hover",
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'overviewLink')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85de1c4527c5fda3$export$399e54fcdf2a48ec, {
        size: "small",
        themeName: theme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ucfd.default), null, name));
    return isActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BoX4.default), null, content) : content;
};
var $85de1c4527c5fda3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($85de1c4527c5fda3$var$OverviewLink);
const $85de1c4527c5fda3$export$399e54fcdf2a48ec = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $gotST.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gotST", function(module, exports) {

$parcel$export(module.exports, "default", () => $56ce495d3d442ffd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8NVUc = parcelRequire("8NVUc");

var $kar7l = parcelRequire("kar7l");

var $i4XFs = parcelRequire("i4XFs");
const $56ce495d3d442ffd$var$OverviewIcon = ({ size: size = 'medium', className: className, themeName: themeName })=>{
    const theme = themeName ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name;
    const Wrapper = (0, $i4XFs.WRAPPER)[size][theme];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": "business-entity-overview.common.ui.overview-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8NVUc))), {
        label: "",
        LEGACY_size: size,
        color: "currentColor"
    }));
};
var $56ce495d3d442ffd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($56ce495d3d442ffd$var$OverviewIcon);

});
parcelRegister("8NVUc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11cb281a8a3c00ed23350b20fbec23a2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $668fd129a11797f3$var$_react = $668fd129a11797f3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $668fd129a11797f3$var$_globe = $668fd129a11797f3$var$_interopRequireDefault((parcelRequire("9fTo0")));

var $668fd129a11797f3$var$_world = $668fd129a11797f3$var$_interopRequireDefault((parcelRequire("8tfNS")));
function $668fd129a11797f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for GlobeIcon.
 * This component is GlobeIcon, with `UNSAFE_fallbackIcon` set to "WorldIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $668fd129a11797f3$var$GlobeIcon = (props)=>/*#__PURE__*/ $668fd129a11797f3$var$_react.default.createElement($668fd129a11797f3$var$_globe.default, Object.assign({
        LEGACY_fallbackIcon: $668fd129a11797f3$var$_world.default
    }, props));
$668fd129a11797f3$var$GlobeIcon.Name = 'GlobeIconMigration';
var $668fd129a11797f3$var$_default = module.exports.default = $668fd129a11797f3$var$GlobeIcon;

});
parcelRegister("9fTo0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ad89a50f2d6c4ddd31d869ae54509dc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6bd07a4f409097d0$var$_react = $6bd07a4f409097d0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $6bd07a4f409097d0$var$_UNSAFE_baseNew = $6bd07a4f409097d0$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $6bd07a4f409097d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6bd07a4f409097d0$var$GlobeIcon = (props)=>/*#__PURE__*/ $6bd07a4f409097d0$var$_react.default.createElement($6bd07a4f409097d0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 8A7.25 7.25 0 0 1 8 15.25M15.25 8A7.25 7.25 0 0 0 8 .75M15.25 8H.75M8 15.25A7.25 7.25 0 0 1 .75 8M8 15.25c1.657 0 3-3.246 3-7.25S9.657.75 8 .75m0 14.5c-1.657 0-3-3.246-3-7.25S6.343.75 8 .75M.75 8A7.25 7.25 0 0 1 8 .75"/>`
    }, props));
$6bd07a4f409097d0$var$GlobeIcon.displayName = 'GlobeIcon';
var $6bd07a4f409097d0$var$_default = module.exports.default = $6bd07a4f409097d0$var$GlobeIcon;

});

parcelRegister("8tfNS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62ad4a6c20067d20$var$_react = $62ad4a6c20067d20$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $62ad4a6c20067d20$var$_globe = $62ad4a6c20067d20$var$_interopRequireDefault((parcelRequire("9fTo0")));
function $62ad4a6c20067d20$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $62ad4a6c20067d20$var$WorldIcon = (props)=>/*#__PURE__*/ $62ad4a6c20067d20$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-.9-1.863A7.19 7.19 0 0 1 4.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8zm6.21-2.286A1.79 1.79 0 0 0 15.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851"/></svg>`
    }, props, {
        newIcon: $62ad4a6c20067d20$var$_globe.default
    }));
$62ad4a6c20067d20$var$WorldIcon.displayName = 'WorldIcon';
var $62ad4a6c20067d20$var$_default = module.exports.default = $62ad4a6c20067d20$var$WorldIcon;

});


parcelRegister("i4XFs", function(module, exports) {

$parcel$export(module.exports, "WRAPPER", () => $4d118138298fb934$export$20b8431be300f03e);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $c9TLT = parcelRequire("c9TLT");
const $4d118138298fb934$var$iconWrapperStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    borderRadius: `${(0, $c9TLT.borderRadius)}px`,
    border: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N20A})`}`
};
const $4d118138298fb934$var$smallIconWrapperStyles = {
    ...$4d118138298fb934$var$iconWrapperStyles,
    width: '24px',
    height: '24px'
};
const $4d118138298fb934$var$mediumIconWrapperStyles = {
    ...$4d118138298fb934$var$iconWrapperStyles,
    width: '32px',
    height: '32px'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4d118138298fb934$var$WhiteSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1d6j _bfhk4zhb",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightPurpleSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazhbpo _bfhk63rr",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightBlueSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazynhg _bfhk1mdm",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightTealSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazig9t _bfhk16io",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightGreenSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz15qz _bfhkuuj7",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightLimeSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazz2ec _bfhktde4",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightYellowSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz13jf _bfhk1v42",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightRedSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz58wa _bfhkr8k0",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightMagentaSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz5ct2 _bfhku2x1",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightOrangeSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazmfbj _bfhkdpo0",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$DarkSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1d6j _bfhk4zhb",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$PurpleSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz63rr _bfhkhbpo",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$BlueSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1mdm _bfhkynhg",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$TealSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz16io _bfhkig9t",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$GreenSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazuuj7 _bfhk15qz",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LimeSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaztde4 _bfhkz2ec",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$YellowSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1v42 _bfhk13jf",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$RedSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazr8k0 _bfhk58wa",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$MagentaSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazu2x1 _bfhk5ct2",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$OrangeSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazdpo0 _bfhkmfbj",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$WhiteMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1d6j _bfhk4zhb",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightPurpleMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazhbpo _bfhk63rr",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightBlueMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazynhg _bfhk1mdm",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightTealMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazig9t _bfhk16io",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightGreenMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz15qz _bfhkuuj7",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightLimeMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazz2ec _bfhktde4",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightYellowMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz13jf _bfhk1v42",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightRedMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz58wa _bfhkr8k0",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightMagentaMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz5ct2 _bfhku2x1",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightOrangeMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazmfbj _bfhkdpo0",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$DarkMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1d6j _bfhk4zhb",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$PurpleMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz63rr _bfhkhbpo",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$BlueMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1mdm _bfhkynhg",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$TealMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz16io _bfhkig9t",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$GreenMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazuuj7 _bfhk15qz",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LimeMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaztde4 _bfhkz2ec",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$YellowMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1v42 _bfhk13jf",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$RedMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazr8k0 _bfhk58wa",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$MagentaMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazu2x1 _bfhk5ct2",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$OrangeMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazdpo0 _bfhkmfbj",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$export$20b8431be300f03e = {
    small: {
        white: $4d118138298fb934$var$WhiteSmallIconWrapper,
        'light-purple': $4d118138298fb934$var$LightPurpleSmallIconWrapper,
        'light-blue': $4d118138298fb934$var$LightBlueSmallIconWrapper,
        'light-teal': $4d118138298fb934$var$LightTealSmallIconWrapper,
        'light-green': $4d118138298fb934$var$LightGreenSmallIconWrapper,
        'light-yellow': $4d118138298fb934$var$LightYellowSmallIconWrapper,
        'light-red': $4d118138298fb934$var$LightRedSmallIconWrapper,
        'light-magenta': $4d118138298fb934$var$LightMagentaSmallIconWrapper,
        'light-orange': $4d118138298fb934$var$LightOrangeSmallIconWrapper,
        dark: $4d118138298fb934$var$DarkSmallIconWrapper,
        purple: $4d118138298fb934$var$PurpleSmallIconWrapper,
        blue: $4d118138298fb934$var$BlueSmallIconWrapper,
        teal: $4d118138298fb934$var$TealSmallIconWrapper,
        green: $4d118138298fb934$var$GreenSmallIconWrapper,
        yellow: $4d118138298fb934$var$YellowSmallIconWrapper,
        red: $4d118138298fb934$var$RedSmallIconWrapper,
        magenta: $4d118138298fb934$var$MagentaSmallIconWrapper,
        orange: $4d118138298fb934$var$OrangeSmallIconWrapper,
        'lightest-gray': $4d118138298fb934$var$WhiteSmallIconWrapper,
        'lightest-purple': $4d118138298fb934$var$LightPurpleSmallIconWrapper,
        'lightest-blue': $4d118138298fb934$var$LightBlueSmallIconWrapper,
        'lightest-teal': $4d118138298fb934$var$LightTealSmallIconWrapper,
        'lightest-green': $4d118138298fb934$var$LightGreenSmallIconWrapper,
        'lightest-lime': $4d118138298fb934$var$LightLimeSmallIconWrapper,
        'lightest-yellow': $4d118138298fb934$var$LightYellowSmallIconWrapper,
        'lightest-orange': $4d118138298fb934$var$LightOrangeSmallIconWrapper,
        'lightest-red': $4d118138298fb934$var$LightRedSmallIconWrapper,
        'lightest-magenta': $4d118138298fb934$var$LightMagentaSmallIconWrapper,
        'lighter-gray': $4d118138298fb934$var$WhiteSmallIconWrapper,
        'lighter-purple': $4d118138298fb934$var$LightPurpleSmallIconWrapper,
        'lighter-blue': $4d118138298fb934$var$LightBlueSmallIconWrapper,
        'lighter-teal': $4d118138298fb934$var$LightTealSmallIconWrapper,
        'lighter-green': $4d118138298fb934$var$LightGreenSmallIconWrapper,
        'lighter-lime': $4d118138298fb934$var$LightLimeSmallIconWrapper,
        'lighter-yellow': $4d118138298fb934$var$LightYellowSmallIconWrapper,
        'lighter-orange': $4d118138298fb934$var$LightOrangeSmallIconWrapper,
        'lighter-red': $4d118138298fb934$var$LightRedSmallIconWrapper,
        'lighter-magenta': $4d118138298fb934$var$LightMagentaSmallIconWrapper,
        'darker-gray': $4d118138298fb934$var$DarkSmallIconWrapper,
        'darker-purple': $4d118138298fb934$var$PurpleSmallIconWrapper,
        'darker-blue': $4d118138298fb934$var$BlueSmallIconWrapper,
        'darker-teal': $4d118138298fb934$var$TealSmallIconWrapper,
        'darker-green': $4d118138298fb934$var$GreenSmallIconWrapper,
        'darker-lime': $4d118138298fb934$var$LimeSmallIconWrapper,
        'darker-yellow': $4d118138298fb934$var$YellowSmallIconWrapper,
        'darker-orange': $4d118138298fb934$var$OrangeSmallIconWrapper,
        'darker-red': $4d118138298fb934$var$RedSmallIconWrapper,
        'darker-magenta': $4d118138298fb934$var$MagentaSmallIconWrapper,
        'darkest-gray': $4d118138298fb934$var$DarkSmallIconWrapper,
        'darkest-purple': $4d118138298fb934$var$PurpleSmallIconWrapper,
        'darkest-blue': $4d118138298fb934$var$BlueSmallIconWrapper,
        'darkest-teal': $4d118138298fb934$var$TealSmallIconWrapper,
        'darkest-green': $4d118138298fb934$var$GreenSmallIconWrapper,
        'darkest-lime': $4d118138298fb934$var$LimeSmallIconWrapper,
        'darkest-yellow': $4d118138298fb934$var$YellowSmallIconWrapper,
        'darkest-orange': $4d118138298fb934$var$OrangeSmallIconWrapper,
        'darkest-red': $4d118138298fb934$var$RedSmallIconWrapper,
        'darkest-magenta': $4d118138298fb934$var$MagentaSmallIconWrapper,
        'no-background': $4d118138298fb934$var$WhiteSmallIconWrapper
    },
    medium: {
        white: $4d118138298fb934$var$WhiteMediumIconWrapper,
        'light-purple': $4d118138298fb934$var$LightPurpleMediumIconWrapper,
        'light-blue': $4d118138298fb934$var$LightBlueMediumIconWrapper,
        'light-teal': $4d118138298fb934$var$LightTealMediumIconWrapper,
        'light-green': $4d118138298fb934$var$LightGreenMediumIconWrapper,
        'light-yellow': $4d118138298fb934$var$LightYellowMediumIconWrapper,
        'light-red': $4d118138298fb934$var$LightRedMediumIconWrapper,
        'light-magenta': $4d118138298fb934$var$LightMagentaMediumIconWrapper,
        'light-orange': $4d118138298fb934$var$LightOrangeMediumIconWrapper,
        dark: $4d118138298fb934$var$DarkMediumIconWrapper,
        purple: $4d118138298fb934$var$PurpleMediumIconWrapper,
        blue: $4d118138298fb934$var$BlueMediumIconWrapper,
        teal: $4d118138298fb934$var$TealMediumIconWrapper,
        green: $4d118138298fb934$var$GreenMediumIconWrapper,
        yellow: $4d118138298fb934$var$YellowMediumIconWrapper,
        red: $4d118138298fb934$var$RedMediumIconWrapper,
        magenta: $4d118138298fb934$var$MagentaMediumIconWrapper,
        orange: $4d118138298fb934$var$OrangeMediumIconWrapper,
        'lightest-gray': $4d118138298fb934$var$WhiteMediumIconWrapper,
        'lightest-purple': $4d118138298fb934$var$LightPurpleMediumIconWrapper,
        'lightest-blue': $4d118138298fb934$var$LightBlueMediumIconWrapper,
        'lightest-teal': $4d118138298fb934$var$LightTealMediumIconWrapper,
        'lightest-green': $4d118138298fb934$var$LightGreenMediumIconWrapper,
        'lightest-lime': $4d118138298fb934$var$LightLimeMediumIconWrapper,
        'lightest-yellow': $4d118138298fb934$var$LightYellowMediumIconWrapper,
        'lightest-orange': $4d118138298fb934$var$LightOrangeMediumIconWrapper,
        'lightest-red': $4d118138298fb934$var$LightRedMediumIconWrapper,
        'lightest-magenta': $4d118138298fb934$var$LightMagentaMediumIconWrapper,
        'lighter-gray': $4d118138298fb934$var$WhiteMediumIconWrapper,
        'lighter-purple': $4d118138298fb934$var$LightPurpleMediumIconWrapper,
        'lighter-blue': $4d118138298fb934$var$LightBlueMediumIconWrapper,
        'lighter-teal': $4d118138298fb934$var$LightTealMediumIconWrapper,
        'lighter-green': $4d118138298fb934$var$LightGreenMediumIconWrapper,
        'lighter-lime': $4d118138298fb934$var$LightLimeMediumIconWrapper,
        'lighter-yellow': $4d118138298fb934$var$LightYellowMediumIconWrapper,
        'lighter-orange': $4d118138298fb934$var$LightOrangeMediumIconWrapper,
        'lighter-red': $4d118138298fb934$var$LightRedMediumIconWrapper,
        'lighter-magenta': $4d118138298fb934$var$LightMagentaMediumIconWrapper,
        'darker-gray': $4d118138298fb934$var$DarkMediumIconWrapper,
        'darker-purple': $4d118138298fb934$var$PurpleMediumIconWrapper,
        'darker-blue': $4d118138298fb934$var$BlueMediumIconWrapper,
        'darker-teal': $4d118138298fb934$var$TealMediumIconWrapper,
        'darker-green': $4d118138298fb934$var$GreenMediumIconWrapper,
        'darker-lime': $4d118138298fb934$var$LimeMediumIconWrapper,
        'darker-yellow': $4d118138298fb934$var$YellowMediumIconWrapper,
        'darker-orange': $4d118138298fb934$var$OrangeMediumIconWrapper,
        'darker-red': $4d118138298fb934$var$RedMediumIconWrapper,
        'darker-magenta': $4d118138298fb934$var$MagentaMediumIconWrapper,
        'darkest-gray': $4d118138298fb934$var$DarkMediumIconWrapper,
        'darkest-purple': $4d118138298fb934$var$PurpleMediumIconWrapper,
        'darkest-blue': $4d118138298fb934$var$BlueMediumIconWrapper,
        'darkest-teal': $4d118138298fb934$var$TealMediumIconWrapper,
        'darkest-green': $4d118138298fb934$var$GreenMediumIconWrapper,
        'darkest-lime': $4d118138298fb934$var$LimeMediumIconWrapper,
        'darkest-yellow': $4d118138298fb934$var$YellowMediumIconWrapper,
        'darkest-orange': $4d118138298fb934$var$OrangeMediumIconWrapper,
        'darkest-red': $4d118138298fb934$var$RedMediumIconWrapper,
        'darkest-magenta': $4d118138298fb934$var$MagentaMediumIconWrapper,
        'no-background': $4d118138298fb934$var$WhiteMediumIconWrapper
    }
};

});


parcelRegister("7BoX4", function(module, exports) {

$parcel$export(module.exports, "default", () => $87c30ceaf64f4777$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $87c30ceaf64f4777$var$ActiveItem = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($87c30ceaf64f4777$var$ActiveItemWrapper, {
        "data-testid": testId
    }, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87c30ceaf64f4777$var$ActiveItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1sit _bfhkiw92",
            __cmplp.className
        ])
    });
});
var $87c30ceaf64f4777$export$2e2bcd8739ae039 = $87c30ceaf64f4777$var$ActiveItem;

});

parcelRegister("2Ucfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f309bbea3103a655$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $f309bbea3103a655$var$LinkLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h _1e0c1ule _o5721q9c _1reo15vq _18m915vq _1bto1l2s _k48p1wq8 _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
var $f309bbea3103a655$export$2e2bcd8739ae039 = $f309bbea3103a655$var$LinkLabel;

});

parcelRegister("3YFEG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b3c14587c33fc56$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $lB25E = parcelRequire("lB25E");
const $1b3c14587c33fc56$var$SidebarLink = ({ children: children, elemAfter: elemAfter, className: className, testId: testId, isActive: isActive = false, ...other })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b3c14587c33fc56$var$Wrapper, {
        isActive: isActive,
        className: className,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b3c14587c33fc56$var$StyledLink, {
        "aria-current": isActive ? 'page' : undefined,
        ...other
    }, children), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b3c14587c33fc56$var$ElementAfterWrapper, {
        "data-component-selector": "sidebar-link-elem-after"
    }, elemAfter));
const $1b3c14587c33fc56$var$showElementAfter = {
    width: 'inherit !important',
    opacity: 1
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b3c14587c33fc56$var$ElementAfterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsbgrf3 _tzy4idpf _2hwxu2gc _195pjdj5 _1mygkb7n",
            __cmplp.className
        ])
    });
});
const $1b3c14587c33fc56$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1b30gsy": (0, $9t7rW.default)(!__cmplp.isActive && `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$exports).N20A})`),
            "--_dpi1qg": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            !__cmplp.isActive && `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$exports).N20A})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _2rko1sit _4t3i1ylp _v5649dqc _1bqoyh40 _rhjqnqa1 _boy0v77o _i9oi194a _ylp5tjc1 _irr3tjc1 _7gg8jdj5 _7ih6kb7n _gnguyh40 _1bv6nqa1 _ygb3v77o _1qtp194a _sbojjewh",
            __cmplp.className
        ])
    });
});
const $1b3c14587c33fc56$var$StyledLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _1yt4u2gc _1e0c1txw _4cvr1h6o _syazjjyb _1q5t1r31 _nt751r31 _mizu1r31 _1dit1r31 _1ohyglyw _49pcglyw _ra3xglyw _ksodglyw _1r9x1o36 _1hvw1o36 _128m1o36 _4hz81o36 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _9h8h1fxt _f8pj1fxt _v0vw1fxt _30l31fxt",
            __cmplp.className
        ])
    });
});
var $1b3c14587c33fc56$export$2e2bcd8739ae039 = $1b3c14587c33fc56$var$SidebarLink;

});



parcelRegister("9QtHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7365cd4b1a70e60e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $e9T6i = parcelRequire("e9T6i");

var $15zK8 = parcelRequire("15zK8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8rQuz = parcelRequire("8rQuz");

var $kMUsV = parcelRequire("kMUsV");

var $8RzJd = parcelRequire("8RzJd");

var $bVacK = parcelRequire("bVacK");

var $1nRKu = parcelRequire("1nRKu");
const $7365cd4b1a70e60e$var$PROJECT_LINK_TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.project-link';
const $7365cd4b1a70e60e$var$getDefaultProjectUrl = (project)=>project.defaultView ? `/jira/core/projects/${project.key}/${project.defaultView}` : `/jira/core/projects/${project.key}`;
const $7365cd4b1a70e60e$var$ProjectGroup = ({ sectionId: sectionId, projects: projects, onFavoriteToggle: onFavoriteToggle, currentProjectKey: currentProjectKey, showViewAllProjects: showViewAllProjects = false, viewAllProjectsLabel: viewAllProjectsLabel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const title = sectionId === 'starred' ? formatMessage((0, $bVacK.default).favorites) : formatMessage((0, $bVacK.default).recents);
    const [isExpanded, setIsExpanded] = (0, $eUqFw.useState)(true);
    const onToggleExpand = (0, $eUqFw.useCallback)(()=>{
        setIsExpanded(!isExpanded);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'section toggled', 'sidebar', {
            sectionId: sectionId,
            collapse: isExpanded
        });
    }, [
        createAnalyticsEvent,
        isExpanded,
        sectionId
    ]);
    const chevronIcon = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7365cd4b1a70e60e$var$IconWrapper, {
            isExpanded: isExpanded,
            visualRefresh: (0, $8rQuz.isVisualRefreshEnabled)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
            label: formatMessage(isExpanded ? (0, $bVacK.default).collapseSection : (0, $bVacK.default).expandSection, {
                section: title
            }),
            color: "var(--ds-text-subtlest, #626F86)"
        })), [
        formatMessage,
        isExpanded,
        title
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7365cd4b1a70e60e$export$7d436a88869873b5, {
        "data-testid": `navigation-apps-sidebar-core.ui.multi-project-menu.project-group.${sectionId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7365cd4b1a70e60e$export$dca3dbf057c88c5f, {
        "aria-expanded": isExpanded,
        "aria-controls": `multi-project-menu-project-group-${sectionId}`,
        onClick: onToggleExpand,
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.project-group.toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        iconBefore: chevronIcon
    }), title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15zK8.Collapsible), {
        id: `multi-project-menu-project-group-${sectionId}`,
        isExpanded: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7365cd4b1a70e60e$export$99bffacbdbcb5195, null, projects.map((project)=>project.key === currentProjectKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: project.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8RzJd.default), {
            project: project,
            to: $7365cd4b1a70e60e$var$getDefaultProjectUrl(project),
            onFavoriteToggle: ()=>onFavoriteToggle(project)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: project.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMUsV.default), {
            project: project,
            to: $7365cd4b1a70e60e$var$getDefaultProjectUrl(project),
            onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmProjectLink', {
                    projectId: project.id,
                    starred: project.isFavorite,
                    current: false
                }),
            onFavoriteToggle: ()=>onFavoriteToggle(project),
            prefetch: "hover",
            testId: $7365cd4b1a70e60e$var$PROJECT_LINK_TEST_ID
        }))), showViewAllProjects && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1nRKu.default), {
        label: viewAllProjectsLabel
    })))));
};
var $7365cd4b1a70e60e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($7365cd4b1a70e60e$var$ProjectGroup);
const $7365cd4b1a70e60e$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_v5641b1u _k8m01e03",
            __cmplp.isExpanded ? "_t9ec1ul7" : "_t9ec2i46",
            __cmplp.visualRefresh && "_1yt412x7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7365cd4b1a70e60e$export$7d436a88869873b5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18s83l1n _onzypxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7365cd4b1a70e60e$export$dca3dbf057c88c5f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1 _1e0c1txw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt4otz2 _4cvr1h6o _80omtlke _1p1dangw _11c816g6 _zulptij8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7365cd4b1a70e60e$export$99bffacbdbcb5195 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41b66 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("15zK8", function(module, exports) {

$parcel$export(module.exports, "Collapsible", () => $cd108e84fbd541ee$export$6eb0f7ddcda6131f);

var $eUqFw = parcelRequire("eUqFw");

var $4WrKv = parcelRequire("4WrKv");
const $cd108e84fbd541ee$export$6eb0f7ddcda6131f = ({ children: children, id: id, isExpanded: isExpanded, animationDuration: animationDuration = 250 })=>{
    const didMountRef = (0, $eUqFw.useRef)(false);
    const [containerHeight, setContainerHeight] = (0, $eUqFw.useState)(isExpanded ? null : 0);
    const [isRendered, setIsRendered] = (0, $eUqFw.useState)(isExpanded);
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const contentRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        if (isExpanded) {
            setIsRendered(true);
            requestAnimationFrame(()=>{
                setContainerHeight(contentRef.current?.offsetHeight ?? null);
                Promise.all(wrapperRef.current?.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                    setContainerHeight(null);
                });
            });
        } else {
            setContainerHeight(contentRef.current?.offsetHeight ?? null);
            requestAnimationFrame(()=>{
                setContainerHeight(0);
                Promise.all(wrapperRef.current?.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                    setIsRendered(false);
                });
            });
        }
    }, [
        contentRef,
        isExpanded
    ]);
    if (!isRendered) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4WrKv.CollapsibleWrapper), {
        animationDuration: animationDuration,
        containerHeight: containerHeight,
        id: id,
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: contentRef
    }, children));
};

});
parcelRegister("4WrKv", function(module, exports) {

$parcel$export(module.exports, "CollapsibleWrapper", () => $932f846aacdec0cd$export$417956c58046108f);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $932f846aacdec0cd$export$417956c58046108f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { animationDuration: animationDuration, containerHeight: containerHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_3opy9g": (0, $9t7rW.default)(`max-height ${__cmplp.animationDuration}ms ease-in-out`),
            "--_3k6n1g": (0, $9t7rW.default)(__cmplp.containerHeight, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _v564plo1",
            __cmplp.containerHeight != null ? "_c71ld5na" : "_c71ln7od",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kMUsV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c19644e3c562f1f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JDHd = parcelRequire("5JDHd");

var $3YFEG = parcelRequire("3YFEG");
const $3c19644e3c562f1f$var$ProjectItem = ({ project: project, onClick: onClick, onFavoriteToggle: onFavoriteToggle, to: to, isActive: isActive, className: className, testId: testId, prefetch: prefetch })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3YFEG.default), {
        to: to,
        onClick: onClick,
        isActive: isActive,
        elemAfter: project.permissions.viewIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5JDHd.default), {
            project: project,
            onToggle: onFavoriteToggle
        }),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        testId: testId,
        prefetch: prefetch
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c19644e3c562f1f$var$Avatar, {
        src: project.avatarUrl,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c19644e3c562f1f$var$ProjectName, null, project.name));
var $3c19644e3c562f1f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3c19644e3c562f1f$var$ProjectItem);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c19644e3c562f1f$var$ProjectName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _y3gn1e5h _1e0c1ule _o5721q9c _1bto1l2s _k48p1wq8",
            __cmplp.className
        ])
    });
});
const $3c19644e3c562f1f$var$Avatar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _4t3i1tcg _1bsb1tcg _2hwxutpp _2rko1l7b",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5JDHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e54e45b65655165e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lJ1PS = parcelRequire("lJ1PS");

var $bqcDn = parcelRequire("bqcDn");

var $b5IAe = parcelRequire("b5IAe");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bJdnT = parcelRequire("bJdnT");

var $fVRXn = parcelRequire("fVRXn");
const $e54e45b65655165e$var$FavoriteButton = ({ project: project, onToggle: onToggle })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const label = project.isFavorite ? formatMessage((0, $bJdnT.default).unstar) : formatMessage((0, $bJdnT.default).star);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        const star = !project.isFavorite;
        onToggle(star);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'project starred', 'sidebar', {
            projectId: project.id,
            star: star
        });
    }, [
        project,
        onToggle,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: label,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fVRXn.Button), {
        isFavorite: project.isFavorite ?? false,
        onClick: onClick,
        "data-testid": "navigation-apps-sidebar-core.common.ui.favorite-button"
    }, project.isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lJ1PS))), {
        color: "currentColor",
        label: label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bqcDn))), {
        color: "currentColor",
        label: label
    }))));
};
var $e54e45b65655165e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e54e45b65655165e$var$FavoriteButton);

});
parcelRegister("lJ1PS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::242e612e93627bf1ae40440e3e2d4842>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd0f397f64127ab6$var$_react = $fd0f397f64127ab6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $fd0f397f64127ab6$var$_starStarred = $fd0f397f64127ab6$var$_interopRequireDefault((parcelRequire("23Ou2")));

var $fd0f397f64127ab6$var$_starFilled = $fd0f397f64127ab6$var$_interopRequireDefault((parcelRequire("hlWtt")));
function $fd0f397f64127ab6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for StarStarredIcon.
 * This component is StarStarredIcon, with `UNSAFE_fallbackIcon` set to "StarFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd0f397f64127ab6$var$StarStarredIcon = (props)=>/*#__PURE__*/ $fd0f397f64127ab6$var$_react.default.createElement($fd0f397f64127ab6$var$_starStarred.default, Object.assign({
        LEGACY_fallbackIcon: $fd0f397f64127ab6$var$_starFilled.default
    }, props));
$fd0f397f64127ab6$var$StarStarredIcon.Name = 'StarStarredIconMigration';
var $fd0f397f64127ab6$var$_default = module.exports.default = $fd0f397f64127ab6$var$StarStarredIcon;

});

parcelRegister("bqcDn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::12be4c85798841689adeb3e384422c25>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $850bec47eae966b4$var$_react = $850bec47eae966b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $850bec47eae966b4$var$_starUnstarred = $850bec47eae966b4$var$_interopRequireDefault((parcelRequire("7jsaI")));

var $850bec47eae966b4$var$_star = $850bec47eae966b4$var$_interopRequireDefault((parcelRequire("daM3L")));
function $850bec47eae966b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for StarUnstarredIcon.
 * This component is StarUnstarredIcon, with `UNSAFE_fallbackIcon` set to "StarIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $850bec47eae966b4$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $850bec47eae966b4$var$_react.default.createElement($850bec47eae966b4$var$_starUnstarred.default, Object.assign({
        LEGACY_fallbackIcon: $850bec47eae966b4$var$_star.default
    }, props));
$850bec47eae966b4$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
var $850bec47eae966b4$var$_default = module.exports.default = $850bec47eae966b4$var$StarUnstarredIcon;

});

parcelRegister("bJdnT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b07613b1e7eec39$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8b07613b1e7eec39$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    star: {
        "id": "spa-apps-sidebar-core.common.favorite-button.star",
        "defaultMessage": "Add to Starred"
    },
    unstar: {
        "id": "spa-apps-sidebar-core.common.favorite-button.unstar",
        "defaultMessage": "Remove from Starred"
    }
});

});

parcelRegister("fVRXn", function(module, exports) {

$parcel$export(module.exports, "Button", () => $2b3f0059348a9897$export$353f5b6fc5456de1);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $2b3f0059348a9897$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4v77o _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $2b3f0059348a9897$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFavorite: isFavorite, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _11q7glyw _80omtlke _2rko1sit _1spjglyw _157zglyw",
            __cmplp.isFavorite ? "_syazkizl" : "_syazjjyb",
            __cmplp.isFavorite ? "_f8pj1ov0 _30l31ov0 _17051ov0" : "_f8pj1wmz _30l31wmz _17051wmz",
            __cmplp.className
        ])
    });
});

});



parcelRegister("8RzJd", function(module, exports) {

$parcel$export(module.exports, "default", () => $37e313fba1125d29$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7BoX4 = parcelRequire("7BoX4");

var $kMUsV = parcelRequire("kMUsV");

var $4q3vw = parcelRequire("4q3vw");
const $37e313fba1125d29$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.current-project';
const $37e313fba1125d29$var$ActiveProject = ({ project: project, to: to, onFavoriteToggle: onFavoriteToggle })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmProjectLink', {
            projectId: project.id,
            starred: project.isFavorite,
            current: true
        });
    }, [
        createAnalyticsEvent,
        project
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BoX4.default), {
        testId: $37e313fba1125d29$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMUsV.default), {
        project: project,
        to: to,
        isActive: true,
        onClick: onClick,
        onFavoriteToggle: onFavoriteToggle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4q3vw.default), null));
};
var $37e313fba1125d29$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($37e313fba1125d29$var$ActiveProject);

});
parcelRegister("4q3vw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb5df3a65802a7af$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $exb0h = parcelRequire("exb0h");

var $elGVw = parcelRequire("elGVw");

var $hzZWH = parcelRequire("hzZWH");

var $zMQ0U = parcelRequire("zMQ0U");

var $10fdS = parcelRequire("10fdS");

var $lg3mT = parcelRequire("lg3mT");

var $kFwR2 = parcelRequire("kFwR2");

var $k5Z6m = parcelRequire("k5Z6m");

var $4ZQun = parcelRequire("4ZQun");

var $44AZS = parcelRequire("44AZS");

var $bp2TG = parcelRequire("bp2TG");

var $8Xc28 = parcelRequire("8Xc28");

var $aZ40y = parcelRequire("aZ40y");
const $eb5df3a65802a7af$var$calculateStack = (route, connectStack, forgeStack)=>{
    const routeName = route && route.name || '';
    // should be handled above generic PROJECT_SETTINGS_CORE logic
    if ((0, $lg3mT.FORGE_ROUTES_SET).has(routeName) && forgeStack) return forgeStack;
    if ((0, $elGVw.CONNECT_ROUTES_SET).has(routeName) && connectStack) return connectStack;
    return [];
};
const $eb5df3a65802a7af$var$ProjectMenu = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: project } = (0, $k5Z6m.default)();
    const { data: features, loading: isFeaturesLoading } = (0, $kFwR2.useFeatures)();
    const { stack: connectProjectStack } = (0, $kFwR2.useProjectConnectItems)();
    const { stack: connectReportsStack } = (0, $kFwR2.useProjectReportsConnectItems)();
    const { stack: connectSettingsStack } = (0, $kFwR2.useProjectSettingsConnectItems)();
    const connectStack = connectProjectStack || connectReportsStack || connectSettingsStack;
    const { loading: projectForgeAppsLoading, stack: forgeStack } = (0, $zMQ0U.useProjectForgeApps)((0, $exb0h.ROUTE_NAMES_FORGE_PROJECT));
    const [stack, setStack] = (0, $eUqFw.useState)(()=>$eb5df3a65802a7af$var$calculateStack(route, connectStack, forgeStack));
    (0, $eUqFw.useEffect)(()=>{
        setStack($eb5df3a65802a7af$var$calculateStack(route, connectStack, forgeStack));
    }, [
        route,
        connectStack,
        forgeStack
    ]);
    if (project == null || isFeaturesLoading || features == null || projectForgeAppsLoading) return null;
    let content = null;
    if ((0, $lg3mT.ISSUES_ROUTES_SET).has(route.name)) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bp2TG.default), {
        project: project
    });
    else if ((0, $lg3mT.REPORTS_ROUTES_SET).has(route.name) || connectReportsStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Xc28.default), null);
    else if ((0, $lg3mT.SETTINGS_ROUTES_SET).has(route.name) || route?.group === (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE) || connectSettingsStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZ40y.default), {
        project: project
    });
    else if ((0, $lg3mT.FORGE_ROUTES_SET).has(route.name) || forgeStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $44AZS.default), null);
    else if ((0, $elGVw.CONNECT_ROUTES_SET).has(route.name) || connectProjectStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZQun.default), {
        stack: stack,
        onStackChange: setStack,
        project: project
    });
    else return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hzZWH.ContextualAnalyticsData), {
        menuId: (0, $lg3mT.MENU_ID),
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb5df3a65802a7af$export$42a852a2b6b56249, null, content));
};
const $eb5df3a65802a7af$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4 _fshqh2mm _10p2glyw",
            __cmplp.className
        ])
    });
});
var $eb5df3a65802a7af$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($eb5df3a65802a7af$var$ProjectMenu);

});
parcelRegister("zMQ0U", function(module, exports) {

$parcel$export(module.exports, "useProjectForgeApps", () => $9e96c2833d013144$export$338edd25edcf3648);
$parcel$export(module.exports, "useProjectForgeAppsNav4", () => $9e96c2833d013144$export$80e84933a3e2f677);

var $eUqFw = parcelRequire("eUqFw");

var $8LJqN = parcelRequire("8LJqN");

var $eI5EY = parcelRequire("eI5EY");

var $fTsDx = parcelRequire("fTsDx");

var $enojT = parcelRequire("enojT");

var $l90Gp = parcelRequire("l90Gp");

var $bNe1g = parcelRequire("bNe1g");

var $iZJHG = parcelRequire("iZJHG");

var $6ibpp = parcelRequire("6ibpp");
const $9e96c2833d013144$var$useProjectForgeAppsV1 = (routeName, projectKey)=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)(projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const { data: data, loading: loading, error: error } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $l90Gp.forgeProjectModuleV1Resource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const projectData = (0, $eUqFw.useMemo)(()=>data?.extensions || null, [
        data
    ]);
    const accessNarrowedData = (0, $eUqFw.useMemo)(()=>data?.accessNarrowedExtensions || null, [
        data
    ]);
    const stack = (0, $6ibpp.useForgeItemStack)(projectData, routeName);
    // Instead of dumping projectContext as is we'd like to hardcode the context
    // to be sure that correct prop are exposed externally
    const context = (0, $eUqFw.useMemo)(()=>projectContext ? {
            projectKey: projectContext.projectKey,
            projectId: projectContext.projectId,
            projectName: projectContext.projectName,
            projectType: projectContext.projectType,
            isProjectAdmin: projectContext.isProjectAdmin,
            isProjectArchived: projectContext.isProjectArchived
        } : {}, [
        projectContext
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: projectData ? projectData.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, context)) : null,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        projectData,
        accessNarrowedData,
        loading,
        error,
        stack,
        context
    ]);
};
const $9e96c2833d013144$var$useProjectForgeAppsV2 = (routeName, projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $l90Gp.forgeProjectModuleV2Resource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const projectData = (0, $eUqFw.useMemo)(()=>data?.filter((0, $enojT.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $eUqFw.useMemo)(()=>data?.filter((0, $enojT.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const stack = (0, $6ibpp.useForgeItemStack)(projectData, routeName);
    return (0, $eUqFw.useMemo)(()=>({
            data: projectData,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        projectData,
        accessNarrowedData,
        loading,
        error,
        stack
    ]);
};
const $9e96c2833d013144$export$338edd25edcf3648 = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $9e96c2833d013144$var$useProjectForgeAppsV2, $9e96c2833d013144$var$useProjectForgeAppsV1);
const $9e96c2833d013144$export$80e84933a3e2f677 = (projectKey)=>$9e96c2833d013144$export$338edd25edcf3648(undefined, projectKey);

});
parcelRegister("enojT", function(module, exports) {

$parcel$export(module.exports, "isExtensionVisible", () => $d4424b55372df5cc$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $d4424b55372df5cc$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $d4424b55372df5cc$export$5c38dfa9d1f96e61);
const $d4424b55372df5cc$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $d4424b55372df5cc$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $d4424b55372df5cc$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $d4424b55372df5cc$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});

parcelRegister("6ibpp", function(module, exports) {

$parcel$export(module.exports, "useForgeItemStack", () => $f4e8d0de7e963f6a$export$462f82a278743d46);

var $eUqFw = parcelRequire("eUqFw");

var $eOutC = parcelRequire("eOutC");

var $lB25E = parcelRequire("lB25E");

var $jMYeN = parcelRequire("jMYeN");
const $f4e8d0de7e963f6a$export$462f82a278743d46 = (modules, routeName, parentStack)=>{
    const [{ match: match, route: route }] = (0, $lB25E.useRouter)();
    const matchedExtension = (0, $eOutC.useMatchedExtension)({
        modules: modules,
        match: match
    });
    return (0, $eUqFw.useMemo)(()=>{
        if (route.name !== routeName) return null;
        // match nested navigation view
        if (matchedExtension && (0, $jMYeN.toSections)(matchedExtension).length) {
            const stackId = `${matchedExtension.id}-subpages`;
            return parentStack ? [
                ...parentStack,
                stackId
            ] : [
                stackId
            ];
        }
        // match a simple navigation item (a single top-level page is defined in the manifest)
        if (matchedExtension && parentStack) return parentStack;
        // skip
        return null;
    }, [
        matchedExtension,
        parentStack,
        route.name,
        routeName
    ]);
};

});


parcelRegister("kFwR2", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $07989a85c9068e6d$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useProjectConnectItems", () => $07989a85c9068e6d$export$f23d0c24c77d7608);
$parcel$export(module.exports, "useProjectReportsConnectItems", () => $07989a85c9068e6d$export$a1c75c386c088992);
$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $07989a85c9068e6d$export$41a50100db18b578);
$parcel$export(module.exports, "useProjectSettingsForgeItems", () => $07989a85c9068e6d$export$84761bbf25a4f51f);

var $c4mKR = parcelRequire("c4mKR");

var $kIUmN = parcelRequire("kIUmN");

var $fpWGf = parcelRequire("fpWGf");

var $2RJCt = parcelRequire("2RJCt");

var $2jFgb = parcelRequire("2jFgb");

var $j65a5 = parcelRequire("j65a5");

var $bRhBg = parcelRequire("bRhBg");
const $07989a85c9068e6d$export$4a39035bacc4ed76 = (0, $kIUmN.withThrowOnError)((0, $bRhBg.useFeatures));
const $07989a85c9068e6d$export$f23d0c24c77d7608 = (0, $kIUmN.withThrowOnError)((0, $2jFgb.useProjectConnectItems));
const $07989a85c9068e6d$export$a1c75c386c088992 = (0, $kIUmN.withThrowOnError)((0, $fpWGf.useProjectReportsConnectItems));
const $07989a85c9068e6d$export$41a50100db18b578 = (0, $kIUmN.withThrowOnError)((0, $2RJCt.useProjectSettingsConnectItems));
const $07989a85c9068e6d$export$84761bbf25a4f51f = (0, $j65a5.useProjectSettingsForgeAppsForMenu);
const $07989a85c9068e6d$export$96e8a0c1f4717705 = (0, $kIUmN.withThrowOnError)((0, $c4mKR.useJiraWorkManagementProjectPagesLink));

});
parcelRegister("c4mKR", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareProjectPagesLink", () => $17dbd504b329aecd$export$50628ae0ad1a35f2);
$parcel$export(module.exports, "useJiraWorkManagementProjectPagesLink", () => $17dbd504b329aecd$export$96e8a0c1f4717705);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $2futN = parcelRequire("2futN");
const $17dbd504b329aecd$var$pagesLinkBaseUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/projects/1.0/pageslink/${projectKey}`;
const $17dbd504b329aecd$var$enablePagesLinkUrl = (baseUrl, projectKey)=>`${$17dbd504b329aecd$var$pagesLinkBaseUrl(baseUrl, projectKey)}/enable`;
const $17dbd504b329aecd$var$disablePagesLinkUrl = (baseUrl, projectKey)=>`${$17dbd504b329aecd$var$pagesLinkBaseUrl(baseUrl, projectKey)}/disable`;
const $17dbd504b329aecd$var$setPagesLinkService = ({ baseUrl: baseUrl, projectKey: projectKey, enable: enable })=>enable ? (0, $lRmyA.performPutRequest)($17dbd504b329aecd$var$enablePagesLinkUrl(baseUrl, projectKey)) : (0, $lRmyA.performPutRequest)($17dbd504b329aecd$var$disablePagesLinkUrl(baseUrl, projectKey));
const $17dbd504b329aecd$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
const $17dbd504b329aecd$export$50628ae0ad1a35f2 = ()=>{
    const { data: data, loading: loading, refresh: refresh, error: error } = (0, $2futN.useJiraSoftwareProjectNavigation)();
    const setPagesLink = (0, $eUqFw.useCallback)(async (...args)=>{
        await $17dbd504b329aecd$var$setPagesLinkService(...args);
        await refresh();
    }, [
        refresh
    ]);
    return {
        data: {
            isEnabled: data?.hasPages === true,
            canEdit: data?.permissionInfo != null && $17dbd504b329aecd$var$isProjectOrJiraAdmin(data.permissionInfo),
            pending: loading,
            setPagesLink: setPagesLink
        },
        loading: loading,
        error: error
    };
};
const $17dbd504b329aecd$export$96e8a0c1f4717705 = ()=>{
    const { loading: loading, refresh: refresh, error: error } = (0, $2futN.useJiraWorkmanagementProjectNavigation)();
    const setPagesLink = (0, $eUqFw.useCallback)(async (...args)=>{
        await $17dbd504b329aecd$var$setPagesLinkService(...args);
        await refresh();
    }, [
        refresh
    ]);
    return {
        data: {
            isEnabled: true,
            canEdit: false,
            pending: loading,
            setPagesLink: setPagesLink
        },
        loading: loading,
        error: error
    };
};

});

parcelRegister("j65a5", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsForgeApps", () => $952e927805fb78ba$export$bef2e514007d2f07);
$parcel$export(module.exports, "useProjectSettingsForgeAppsForMenu", () => $952e927805fb78ba$export$b741e3e3cfb39b82);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $8LJqN = parcelRequire("8LJqN");

var $eI5EY = parcelRequire("eI5EY");

var $2Rqjr = parcelRequire("2Rqjr");

var $70ON1 = parcelRequire("70ON1");

var $fTsDx = parcelRequire("fTsDx");

var $enojT = parcelRequire("enojT");

var $l90Gp = parcelRequire("l90Gp");

var $bNe1g = parcelRequire("bNe1g");

var $c7H0g = parcelRequire("c7H0g");

var $1R3n5 = parcelRequire("1R3n5");

var $gd0Sp = parcelRequire("gd0Sp");

var $lB25E = parcelRequire("lB25E");

var $6ibpp = parcelRequire("6ibpp");

var $jMYeN = parcelRequire("jMYeN");
const $952e927805fb78ba$export$3c509d6dc1f63bbe = ()=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)((0, $l90Gp.forgeProjectSettingsModuleV1Resource));
    const projectSettingsData = (0, $eUqFw.useMemo)(()=>data?.extensions || null, [
        data
    ]);
    const accessNarrowedData = (0, $eUqFw.useMemo)(()=>data?.accessNarrowedExtensions || null, [
        data
    ]);
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const hasPermissions = (0, $eUqFw.useMemo)(()=>(projectContext?.isProjectAdmin || isAdmin || isSiteAdmin) === true, [
        isAdmin,
        isSiteAdmin,
        projectContext?.isProjectAdmin
    ]);
    // Instead of dumping projectContext as is we'd like to hardcode the context
    // to be sure that correct prop are exposed externally
    const context = (0, $eUqFw.useMemo)(()=>projectContext ? {
            projectKey: projectContext.projectKey,
            projectId: projectContext.projectId,
            projectName: projectContext.projectName,
            projectType: projectContext.projectType
        } : {}, [
        projectContext
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: projectSettingsData ? projectSettingsData.filter((extension)=>hasPermissions && (0, $fTsDx.doesExtensionMeetConditions)(extension, context)) : null,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error
        }), [
        projectSettingsData,
        accessNarrowedData,
        loading,
        error,
        hasPermissions,
        context
    ]);
};
const $952e927805fb78ba$export$5aac3b333ac18e0d = ()=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)((0, $l90Gp.forgeProjectSettingsModuleV2Resource));
    const projectSettingsData = (0, $eUqFw.useMemo)(()=>data?.filter((0, $enojT.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $eUqFw.useMemo)(()=>data?.filter((0, $enojT.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const hasPermissions = (0, $eUqFw.useMemo)(()=>(projectContext?.isProjectAdmin || isAdmin || isSiteAdmin) === true, [
        isAdmin,
        isSiteAdmin,
        projectContext?.isProjectAdmin
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: projectSettingsData ? hasPermissions && projectSettingsData || [] : null,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error
        }), [
        projectSettingsData,
        accessNarrowedData,
        loading,
        error,
        hasPermissions
    ]);
};
const $952e927805fb78ba$export$bef2e514007d2f07 = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $952e927805fb78ba$export$5aac3b333ac18e0d, $952e927805fb78ba$export$3c509d6dc1f63bbe);
const $952e927805fb78ba$var$appsProjectTypeRouteMap = {
    tmp: {
        [(0, $7ZZxN.CORE_PROJECT)]: 'core',
        [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
        [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'servicedesk',
        // it's genuinely missing Jira Product Discovery and CUSTOMER_SERVICE_PROJECT support
        [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: undefined,
        [(0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)]: undefined
    },
    cmp: {
        [(0, $7ZZxN.CORE_PROJECT)]: 'core',
        [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software/c',
        [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: undefined,
        [(0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)]: undefined
    }
};
const $952e927805fb78ba$export$ed6342e0e28465a6 = (extension, projectType, projectKey, isSimplified)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return `/jira/${$952e927805fb78ba$var$appsProjectTypeRouteMap[isSimplified ? 'tmp' : 'cmp'][projectType]}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
};
const $952e927805fb78ba$export$b741e3e3cfb39b82 = (routeName, parentStack)=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const { data: data, loading: loading, error: error } = $952e927805fb78ba$export$bef2e514007d2f07();
    const stack = (0, $6ibpp.useForgeItemStack)(data, routeName, parentStack);
    const { projectType: projectType, projectKey: projectKey, simplified: isSimplified } = projectContext || {};
    return (0, $eUqFw.useMemo)(()=>({
            data: data ? data.map((extension)=>({
                    id: extension.id,
                    // @ts-expect-error - TS2345 - Argument of type 'ProjectType | undefined' is not assignable to parameter of type 'ProjectType'.
                    url: $952e927805fb78ba$export$ed6342e0e28465a6(extension, projectType, projectKey, isSimplified),
                    name: extension.properties.title,
                    iconUrl: extension.properties.icon,
                    environmentType: extension.environmentType,
                    environmentKey: extension.environmentKey,
                    moduleName: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE),
                    sections: (0, $jMYeN.toSections)(extension)
                })) : null,
            loading: loading,
            error: error,
            stack: stack
        }), [
        data,
        loading,
        error,
        stack,
        projectType,
        projectKey,
        isSimplified
    ]);
};

});

parcelRegister("bRhBg", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $8d33e1dc80dc383e$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useSettingFeatures", () => $8d33e1dc80dc383e$export$56022a3b83c8ed6a);
$parcel$export(module.exports, "useReportFeatures", () => $8d33e1dc80dc383e$export$4adaea9828b7ff13);

var $eUqFw = parcelRequire("eUqFw");

var $2futN = parcelRequire("2futN");

var $eL2Xo = parcelRequire("eL2Xo");

var $f26dB = parcelRequire("f26dB");

var $fz8wa = parcelRequire("fz8wa");

var $ly8Gh = parcelRequire("ly8Gh");
const $8d33e1dc80dc383e$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2futN.useJiraWorkmanagementProjectNavigation)();
    const isPremiumUserSeat = (0, $f26dB.useIsPremiumUserSeat)();
    const transformedData = (0, $eUqFw.useMemo)(()=>data && (0, $ly8Gh.getExtraData)(data, isPremiumUserSeat), [
        data,
        isPremiumUserSeat
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};
const $8d33e1dc80dc383e$export$56022a3b83c8ed6a = ()=>{
    const hasActiveSoftwareAccess = (0, $eL2Xo.useHasActiveSoftwareAccess)();
    const { data: data, loading: loading, error: error } = (0, $2futN.useJiraWorkmanagementProjectNavigation)();
    const transformedData = (0, $eUqFw.useMemo)(()=>data && (0, $ly8Gh.getExtraSettingsData)(data, hasActiveSoftwareAccess), [
        data,
        hasActiveSoftwareAccess
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};
const $8d33e1dc80dc383e$export$4adaea9828b7ff13 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2futN.useJiraWorkmanagementProjectNavigation)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $fz8wa.useApplicationPermissions)();
    const transformedData = (0, $eUqFw.useMemo)(()=>data && (0, $ly8Gh.getExtraReportData)(hasSoftwareAccess), [
        data,
        hasSoftwareAccess
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("eL2Xo", function(module, exports) {

$parcel$export(module.exports, "useHasActiveSoftwareAccess", () => $154cbdbba7c6a38b$export$895f9b38ce00671e);

var $ab6rA = parcelRequire("ab6rA");

var $fz8wa = parcelRequire("fz8wa");
const $154cbdbba7c6a38b$export$895f9b38ce00671e = ()=>{
    const { software: software } = (0, $ab6rA.useAppEditions)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $fz8wa.useApplicationPermissions)();
    return software !== 'UNLICENSED' && hasSoftwareAccess === true;
};

});

parcelRegister("ly8Gh", function(module, exports) {

$parcel$export(module.exports, "getExtraData", () => $755f4ca371b0583d$export$6c55c6c980ed2046);
$parcel$export(module.exports, "getExtraSettingsData", () => $755f4ca371b0583d$export$b77a5597b7177cfb);
$parcel$export(module.exports, "getExtraReportData", () => $755f4ca371b0583d$export$be58a1e7b06d1d3);

var $1ybV0 = parcelRequire("1ybV0");
const $755f4ca371b0583d$export$6c55c6c980ed2046 = (data, isPremium)=>{
    const { permissionInfo: permissionInfo, hasComponents: hasComponents = false, project: project } = data;
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
    const isProjectOrJiraAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true || isAdmin;
    const isSimplifiedProject = project.simplified;
    const hasSettings = isAdmin || projectPermissionsQueried.ADMINISTER_PROJECTS || projectPermissionsQueried.EDIT_ISSUE_LAYOUT || projectPermissionsQueried.EDIT_WORKFLOW;
    return {
        hasVersions: true,
        hasSettings: (0, $1ybV0.ff)('olympus-da-157-enable-project-settings-navigation_zxaq5') ? hasSettings : isProjectOrJiraAdmin,
        hasBoard: true,
        hasReports: true,
        hasAddItem: isProjectOrJiraAdmin,
        hasComponents: hasComponents,
        hasIssues: true,
        hasSummary: true,
        hasPages: true,
        hasChangeTheme: isProjectOrJiraAdmin,
        hasApprovals: isSimplifiedProject && (isPremium || isProjectOrJiraAdmin)
    };
};
const $755f4ca371b0583d$export$b77a5597b7177cfb = (data, hasActiveSoftwareAccess)=>{
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = data.permissionInfo;
    const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const isProjectOrJiraAdmin = isProjectAdmin || isAdmin;
    const hasEditWorkflowPermissions = projectPermissionsQueried.EDIT_WORKFLOW === true;
    const hasIssueLayoutPermissions = projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
    const hasDetails = isProjectOrJiraAdmin;
    const hasPeople = isProjectOrJiraAdmin;
    const hasIssueTypes = isAdmin;
    let hasAutomation = true;
    let hasSummary = true;
    let hasWorkflows = true;
    let hasScreens = true;
    let hasFields = true;
    let hasVersions = true;
    let hasComponents = true;
    let hasPermissions = true;
    let hasIssueSecurity = true;
    let hasNotifications = true;
    let hasIssueCollectors = true;
    let hasIssueLayout = true;
    const hasDevtools = isProjectAdmin && hasActiveSoftwareAccess;
    if ((0, $1ybV0.ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) {
        hasAutomation = isProjectOrJiraAdmin;
        hasSummary = isProjectOrJiraAdmin;
        hasWorkflows = hasEditWorkflowPermissions || isProjectOrJiraAdmin;
        hasScreens = isProjectOrJiraAdmin;
        hasFields = isProjectOrJiraAdmin;
        hasVersions = isProjectOrJiraAdmin;
        hasComponents = isProjectOrJiraAdmin;
        hasPermissions = isProjectOrJiraAdmin;
        hasIssueSecurity = isProjectOrJiraAdmin;
        hasNotifications = isProjectOrJiraAdmin;
        hasIssueCollectors = isProjectOrJiraAdmin;
        hasIssueLayout = hasIssueLayoutPermissions || isProjectOrJiraAdmin;
    }
    return {
        hasAutomation: hasAutomation,
        hasProjectGroupOneSection: hasDetails || hasPeople || hasSummary,
        hasIssueConfigSection: hasIssueTypes,
        hasProjectGroupTwoSection: hasWorkflows || hasScreens || hasFields,
        hasProjectGroupThreeSection: hasVersions || hasComponents,
        hasProjectGroupFourSection: hasPermissions || hasIssueSecurity || hasNotifications,
        hasgetIssueCollectorSection: hasIssueCollectors,
        hasComponents: hasComponents,
        hasDetails: hasDetails,
        hasFields: hasFields,
        hasIssueCollectors: hasIssueCollectors,
        hasIssueSecurity: hasIssueSecurity,
        hasIssueTypes: hasIssueTypes,
        hasNotifications: hasNotifications,
        hasPeople: hasPeople,
        hasPermissions: hasPermissions,
        hasScreens: hasScreens,
        hasSummary: hasSummary,
        hasVersions: hasVersions,
        hasWorkflows: hasWorkflows,
        hasDevtools: hasDevtools,
        hasIssueLayout: hasIssueLayout
    };
};
const $755f4ca371b0583d$export$be58a1e7b06d1d3 = (hasSoftwareAccess)=>({
        hasDeveloperWorkload: true,
        hasForcastSection: true,
        hasTimeTracking: true,
        hasVersionWorkloadReport: hasSoftwareAccess
    });

});



parcelRegister("k5Z6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f6745ef0d4252c6$export$2e2bcd8739ae039);

var $cPEpP = parcelRequire("cPEpP");

var $kIUmN = parcelRequire("kIUmN");
const $3f6745ef0d4252c6$var$useProject = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
var $3f6745ef0d4252c6$export$2e2bcd8739ae039 = $3f6745ef0d4252c6$var$useProject;

});

parcelRegister("4ZQun", function(module, exports) {

$parcel$export(module.exports, "default", () => $812aa24afbef38fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
var $7eyVf = parcelRequire("7eyVf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aWYQ8 = parcelRequire("aWYQ8");

var $2jFgb = parcelRequire("2jFgb");

var $asnZU = parcelRequire("asnZU");

var $6D5Hl = parcelRequire("6D5Hl");
const $812aa24afbef38fd$var$ConnectAppMenu = ({ stack: stack, project: project, onStackChange: onStackChange })=>{
    (0, $asnZU.default)();
    const { data: connectItems, stack: connectStack, selected: selectedConnectApp } = (0, $2jFgb.useProjectConnectItems)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectKey = String(project?.key);
    const getBackMenuItem = (0, $eUqFw.useCallback)(()=>({
            href: `/jira/core/projects/${projectKey}`,
            title: formatMessage((0, $6D5Hl.messages).itemBack)
        }), [
        formatMessage,
        projectKey
    ]);
    if (connectStack != null && connectStack.length > 0 && selectedConnectApp != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N3rk.default), {
        stack: stack,
        onChange: onStackChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aWYQ8.ConnectMenu), {
        items: connectItems,
        showIcons: true,
        overrides: {
            BackMenuItem: getBackMenuItem(),
            navigateOnBackMenuItemClick: true
        }
    })));
    return null;
};
var $812aa24afbef38fd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($812aa24afbef38fd$var$ConnectAppMenu);

});
parcelRegister("asnZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d95c59af01c6e5a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kpmC0 = parcelRequire("kpmC0");
const $7d95c59af01c6e5a$var$useAutoExpandSidebar = ()=>{
    const { expandLeftSidebar: expandLeftSidebar } = (0, $kpmC0.useLeftSidebarController)();
    const { isCollapsed: isCollapsed } = (0, $kpmC0.useLeftSidebarState)();
    const sidebarExpandedRef = (0, $eUqFw.useRef)(!isCollapsed);
    (0, $eUqFw.useEffect)(()=>{
        if (!sidebarExpandedRef.current && isCollapsed) {
            expandLeftSidebar();
            sidebarExpandedRef.current = true;
        }
    }, [
        expandLeftSidebar,
        isCollapsed
    ]);
};
var $7d95c59af01c6e5a$export$2e2bcd8739ae039 = $7d95c59af01c6e5a$var$useAutoExpandSidebar;

});

parcelRegister("6D5Hl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ef8bb497ae7cfecf$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ef8bb497ae7cfecf$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    itemBack: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.connect-app-menu.item-back",
        "defaultMessage": "Back to project"
    }
});

});


parcelRegister("44AZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ffa02dd9401c05b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $exb0h = parcelRequire("exb0h");

var $9zysr = parcelRequire("9zysr");

var $eI5EY = parcelRequire("eI5EY");

var $enojT = parcelRequire("enojT");

var $l90Gp = parcelRequire("l90Gp");

var $dCFoo = parcelRequire("dCFoo");

var $zMQ0U = parcelRequire("zMQ0U");

var $hinm7 = parcelRequire("hinm7");

var $10fdS = parcelRequire("10fdS");

var $lB25E = parcelRequire("lB25E");

var $asnZU = parcelRequire("asnZU");
const $5ffa02dd9401c05b$var$ForgeMenuV1 = ()=>{
    (0, $asnZU.default)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: forgeResourceData } = (0, $lB25E.useResource)((0, $l90Gp.forgeProjectModuleV1Resource));
    const projectData = (0, $eUqFw.useMemo)(()=>forgeResourceData?.extensions || null, [
        forgeResourceData
    ]);
    const selectedForgeApp = (0, $dCFoo.useForgeSelectedApp)(projectData, route.name);
    const { stack: forgeStack } = (0, $zMQ0U.useProjectForgeApps)((0, $exb0h.ROUTE_NAMES_FORGE_PROJECT));
    if (selectedForgeApp != null && forgeStack != null && forgeStack.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hinm7.ForgeProjectSection), {
        overrides: {
            showSelectedAppMenuOnly: true,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            selectedApp: selectedForgeApp
        }
    });
    return null;
};
const $5ffa02dd9401c05b$var$ForgeMenuV2 = ()=>{
    (0, $asnZU.default)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: forgeResourceData } = (0, $lB25E.useResource)((0, $l90Gp.forgeProjectModuleV2Resource));
    const projectData = (0, $eUqFw.useMemo)(()=>forgeResourceData?.filter((0, $enojT.isExtensionVisible)) || null, [
        forgeResourceData
    ]);
    const selectedForgeApp = (0, $dCFoo.useForgeSelectedApp)(projectData, route.name);
    const { stack: forgeStack } = (0, $zMQ0U.useProjectForgeApps)((0, $exb0h.ROUTE_NAMES_FORGE_PROJECT));
    if (selectedForgeApp != null && forgeStack != null && forgeStack.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hinm7.ForgeProjectSection), {
        overrides: {
            showSelectedAppMenuOnly: true,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            selectedApp: selectedForgeApp
        }
    });
    return null;
};
const $5ffa02dd9401c05b$var$ForgeMenu = (0, $9zysr.componentWithCondition)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $5ffa02dd9401c05b$var$ForgeMenuV2, $5ffa02dd9401c05b$var$ForgeMenuV1);
var $5ffa02dd9401c05b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5ffa02dd9401c05b$var$ForgeMenu);

});
parcelRegister("dCFoo", function(module, exports) {

$parcel$export(module.exports, "useForgeSelectedApp", () => $4f01126c9b52390e$export$e6dee8b777476118);

var $eOutC = parcelRequire("eOutC");

var $lB25E = parcelRequire("lB25E");
const $4f01126c9b52390e$export$e6dee8b777476118 = (modules, routeName)=>{
    const [{ match: match, route: route }] = (0, $lB25E.useRouter)();
    const matchedExtension = (0, $eOutC.useMatchedExtension)({
        modules: modules,
        match: match
    });
    if (route.name !== routeName || matchedExtension == null) return null;
    return matchedExtension;
};

});

parcelRegister("hinm7", function(module, exports) {

$parcel$export(module.exports, "ForgeProjectSection", () => $db59aca7aa23a0f8$export$fb7da191295a7e22);
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- PLEASE FIX - ENABLING FLAT LINT CONFIG

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");

var $7ZZxN = parcelRequire("7ZZxN");

var $1boRu = parcelRequire("1boRu");

var $5s6kd = parcelRequire("5s6kd");

var $2Rqjr = parcelRequire("2Rqjr");

var $70ON1 = parcelRequire("70ON1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bNe1g = parcelRequire("bNe1g");

var $l3JmK = parcelRequire("l3JmK");

var $jMYeN = parcelRequire("jMYeN");

var $zMQ0U = parcelRequire("zMQ0U");

var $4Kgsn = parcelRequire("4Kgsn");
// @ts-expect-error - It's genuinely missing Jira Product Discovery.
const $db59aca7aa23a0f8$var$projectTypeRouteMap = {
    [(0, $7ZZxN.CORE_PROJECT)]: 'core',
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'servicedesk'
};
const $db59aca7aa23a0f8$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return `/jira/${$db59aca7aa23a0f8$var$projectTypeRouteMap[projectType]}/projects/${projectKey}/apps/${appId}/${envId}`;
};
const $db59aca7aa23a0f8$export$fb7da191295a7e22 = ({ nestedMenuActive: nestedMenuActive, overrides: overrides })=>{
    const { data: data } = (0, $zMQ0U.useProjectForgeApps)();
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const filteredForgeAppsData = (0, $eUqFw.useMemo)(()=>overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
            overrides.selectedApp
        ] : data || [], [
        data,
        overrides
    ]);
    if (!data?.length || !projectContextData) return null;
    const { projectKey: projectKey, projectType: projectType } = projectContextData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5s6kd.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: overrides?.showSelectedAppMenuOnly ? undefined : formatMessage((0, $4Kgsn.messages).forgeSectionTitle)
    }, filteredForgeAppsData.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3JmK.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $db59aca7aa23a0f8$export$ed6342e0e28465a6(extension, projectType, projectKey),
            name: extension.properties.title,
            sections: (0, $jMYeN.toSections)(extension),
            moduleName: (0, $2Rqjr.PROJECT_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true,
            nestedMenuActive: nestedMenuActive,
            overrides: overrides
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $2Rqjr.PROJECT_PAGE_MODULE)
        }
    })));
};

});
parcelRegister("1boRu", function(module, exports) {

$parcel$export(module.exports, "ForgeScreenEvent", () => $e499aee6653ef75f$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $e499aee6653ef75f$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $e499aee6653ef75f$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $e499aee6653ef75f$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $e499aee6653ef75f$export$14e56d7f5d3f917c);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $2Rqjr = parcelRequire("2Rqjr");

var $2vJHJ = parcelRequire("2vJHJ");

var $9x02J = parcelRequire("9x02J");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $2qZHF = parcelRequire("2qZHF");

var $hRcYT = parcelRequire("hRcYT");

var $8XU7c = parcelRequire("8XU7c");

var $bBGpO = parcelRequire("bBGpO");

var $9Z5wa = parcelRequire("9Z5wa");

var $5syGA = parcelRequire("5syGA");

var $d6g7g = parcelRequire("d6g7g");
const $e499aee6653ef75f$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: (0, $bBGpO.createAttributes)(attributes)
    });
const $e499aee6653ef75f$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $9Z5wa.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $e499aee6653ef75f$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $9x02J.useHasForgeAccess)();
    const analyticsAttributes = (0, $bBGpO.createAttributes)({
        ...attributes,
        hasForgeAccess: hasForgeAccess
    });
    const fireEvent = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, (0, $8XU7c.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: fireEvent
    });
};
const $e499aee6653ef75f$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $e499aee6653ef75f$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $eUqFw.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $eUqFw.useCallback)((error)=>(0, $bBGpO.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $hRcYT.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $e499aee6653ef75f$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $8XU7c.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>(0, $bBGpO.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $2Rqjr.CUSTOM_FIELD_MODULE) || extensionModule === (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $2Rqjr.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $2Rqjr.GLOBAL_PAGE_MODULE),
        (0, $2Rqjr.ISSUE_ACTION_MODULE),
        (0, $2Rqjr.ISSUE_ACTIVITY_MODULE),
        (0, $2Rqjr.ISSUE_GLANCE_MODULE),
        (0, $2Rqjr.ISSUE_CONTEXT_MODULE),
        (0, $2Rqjr.ISSUE_PANEL_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE),
        (0, $2Rqjr.PROJECT_PAGE_MODULE),
        (0, $2Rqjr.ADMIN_PAGE_MODULE),
        (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $e499aee6653ef75f$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const startTime = (0, $eUqFw.useRef)(performance.now());
        const isCustomUI = (0, $2vJHJ.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $eUqFw.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $8XU7c.getEventId)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $8XU7c.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $2vJHJ.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $eUqFw.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $5syGA.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!$e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).start({
                startTime: startTime.current
            });
        }, // We want to run this code only once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
        const onError = (0, $eUqFw.useCallback)(()=>{
            extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $eUqFw.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $9Z5wa.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $eUqFw.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("2vJHJ", function(module, exports) {

$parcel$export(module.exports, "getForgeUIType", () => $0071fffa92d48f40$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $0071fffa92d48f40$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $0071fffa92d48f40$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $0071fffa92d48f40$export$42b85bc9b386c977);

var $8blac = parcelRequire("8blac");
const $0071fffa92d48f40$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
        extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $0071fffa92d48f40$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$0071fffa92d48f40$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $0071fffa92d48f40$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$0071fffa92d48f40$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $0071fffa92d48f40$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(propsToOverride)) return extension;
    const { resource: resource, requiresUserConsent: requiresUserConsent } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        },
        requiresUserConsent: requiresUserConsent
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});

parcelRegister("9x02J", function(module, exports) {

$parcel$export(module.exports, "useHasForgeAccess", () => $c88d1eb745d9d2ce$export$fd7f94d3d2bac7f2);

var $6yplV = parcelRequire("6yplV");
const $c88d1eb745d9d2ce$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return !isAnonymous;
};

});

parcelRegister("2qZHF", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $017cfdc2fc017c3b$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
// eslint-disable-next-line jira/react/no-class-components
class $017cfdc2fc017c3b$var$MountEventComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $017cfdc2fc017c3b$export$2c6963927dbc68f1 = (0, $2jDha.default)()($017cfdc2fc017c3b$var$MountEventComponent);

});

parcelRegister("8XU7c", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $ea56d020133ed4ec$export$5639f6a927500d9);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $ea56d020133ed4ec$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getEventActionName", () => $ea56d020133ed4ec$export$644ccb9a67b9a9c1);

var $2Rqjr = parcelRequire("2Rqjr");

var $TrUS5 = parcelRequire("TrUS5");

var $hRcYT = parcelRequire("hRcYT");
const $ea56d020133ed4ec$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $ea56d020133ed4ec$var$prepareModuleMode = (entryPoint)=>`${$ea56d020133ed4ec$var$capitalizeFirstLetter(entryPoint)}`;
const $ea56d020133ed4ec$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $ea56d020133ed4ec$var$prepareModuleName = (moduleName)=>(0, $2Rqjr.SUPPORTED_MODULES).includes(moduleName) ? $ea56d020133ed4ec$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $ea56d020133ed4ec$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $ea56d020133ed4ec$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
const $ea56d020133ed4ec$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hRcYT.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});

parcelRegister("9Z5wa", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $2660eb080e6928fb$export$add44f896fb31ba3);

var $hRcYT = parcelRequire("hRcYT");

var $cYWDh = parcelRequire("cYWDh");
const $2660eb080e6928fb$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});

parcelRegister("5syGA", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $05fce0f798595dcf$export$5d3b06ab08af139e);

var $2vJHJ = parcelRequire("2vJHJ");

var $70ON1 = parcelRequire("70ON1");
const $05fce0f798595dcf$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $2vJHJ.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});


parcelRegister("5s6kd", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $c4eafcc07a5a74f2$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $c4eafcc07a5a74f2$export$e1a79e3d472c925a);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");
const $c4eafcc07a5a74f2$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.PROJECT_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $c4eafcc07a5a74f2$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.PROJECT_PAGE_MODULE),
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("l3JmK", function(module, exports) {

$parcel$export(module.exports, "ForgeSubpagesView", () => $62555c33c4fca39e$export$9711365f685f75c0);
$parcel$export(module.exports, "ForgeItem", () => $62555c33c4fca39e$export$26a5287439a1d287);

var $eUqFw = parcelRequire("eUqFw");

var $iFXD5 = parcelRequire("iFXD5");

var $7eyVf = parcelRequire("7eyVf");

var $c9TLT = parcelRequire("c9TLT");

var $d6g7g = parcelRequire("d6g7g");

var $7eMp1 = parcelRequire("7eMp1");

var $1UelU = parcelRequire("1UelU");

var $5KxOv = parcelRequire("5KxOv");

var $4aKCU = parcelRequire("4aKCU");

var $2DHQu = parcelRequire("2DHQu");

var $bS2FN = parcelRequire("bS2FN");

var $jn9Rf = parcelRequire("jn9Rf");
const $62555c33c4fca39e$export$9ffb311b483a1e2b = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
const $62555c33c4fca39e$export$f04a61298a47a40f = ({ url: url })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jn9Rf.ForgeIcon), {
        src: url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), {
        label: ""
    });
const $62555c33c4fca39e$export$df3259e43d89ee7b = (props)=>{
    const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, moduleName: moduleName, overrides: overrides } = props;
    if (overrides?.showSelectedAppMenuOnly) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eMp1.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        href: url,
        selectedOn: (0, $bS2FN.matchPartialUrlPathname)(),
        analytics: {
            itemId: itemId,
            itemType: 'forge',
            module: moduleName
        },
        onClick: ()=>{
            (0, $d6g7g.forgeModulesConcurrentLoadTime)(itemId).start({
                startTime: performance.now()
            });
        }
    }, (0, $7eMp1.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};
const $62555c33c4fca39e$var$nestedHeaderAlignmentFix = ()=>({
        paddingLeft: `${(0, $c9TLT.gridSize) * 2.625}px`
    });
const $62555c33c4fca39e$export$961eebe0deda9ad3 = ({ ForgePageHeader: ForgePageHeader = (0, $4aKCU.ForgePageHeader), iconUrl: iconUrl, name: name, environmentType: environmentType, environmentKey: environmentKey, nestedMenuActive: nestedMenuActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ForgePageHeader, {
        avatarUrl: iconUrl || '',
        name: name,
        environmentType: environmentType,
        environmentKey: environmentKey,
        cssFn: // this to avoid sketchy-null-bool linting issue
        typeof nestedMenuActive === 'boolean' && Boolean(nestedMenuActive) ? $62555c33c4fca39e$var$nestedHeaderAlignmentFix : undefined
    });
const $62555c33c4fca39e$export$9711365f685f75c0 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, sections: sections, moduleName: moduleName } = props;
    const selectedOn = (0, $eUqFw.useCallback)((route)=>[
            '',
            '/'
        ].includes(String(route || '').trim()) ? (currentLocation, itemLocation)=>currentLocation.pathname.replace(/\/$/, '') === itemLocation.pathname.replace(/\/$/, '') : (0, $bS2FN.matchPartialUrlPathname)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jn9Rf.ForgeSubpagesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$961eebe0deda9ad3, props), sections?.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
            key: index
        }, typeof section.header === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KxOv.SectionHeader), null, section.header) : null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
                key: page.route,
                iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$f04a61298a47a40f, {
                    url: page.icon
                }) : null,
                href: $62555c33c4fca39e$export$9ffb311b483a1e2b(url, page.route),
                selectedOn: selectedOn(page.route),
                analytics: {
                    itemId: itemId,
                    itemType: 'forge',
                    module: moduleName
                },
                onClick: ()=>{
                    (0, $d6g7g.forgeModulesConcurrentLoadTime)(itemId).start({
                        startTime: performance.now()
                    });
                }
            }, page.title)))));
};
const $62555c33c4fca39e$export$26a5287439a1d287 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides } = props;
    const selectedOn = (0, $eUqFw.useCallback)((currentLocation)=>currentLocation.pathname.includes(url), [
        url
    ]);
    const onNestedMenuItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event);
    }, [
        overrides
    ]);
    if (!sections?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$df3259e43d89ee7b, props);
    if (overrides?.showSelectedAppMenuOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$9711365f685f75c0, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DHQu.NestingMenuItem), {
        analytics: {
            itemId: 'subpages'
        },
        id: `${itemId}-subpages`,
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eMp1.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        title: (0, $7eMp1.nameWithCustomEnvironment)(name, environmentType, environmentKey),
        selectedOn: selectedOn,
        onClick: onNestedMenuItemClick,
        // @ts-expect-error - overrides types mismatch
        overrides: overrides
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$9711365f685f75c0, props));
};

});
parcelRegister("7eMp1", function(module, exports) {

$parcel$export(module.exports, "EnvironmentLozenge", () => $cd44a5efa9c7c2f2$export$278f8e01799d0418);
$parcel$export(module.exports, "nameWithCustomEnvironment", () => $cd44a5efa9c7c2f2$export$f9338c21ba7c7334);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $2Rqjr = parcelRequire("2Rqjr");

var $8uD7Y = parcelRequire("8uD7Y");

var $aghg0 = parcelRequire("aghg0");
const $cd44a5efa9c7c2f2$export$50589a87e4fb3dae = (environmentType)=>{
    switch(environmentType){
        case 0, $2Rqjr.DEVELOPMENT_ENVIRONMENT:
            return (0, $aghg0.messages).developmentEnvironmentLozenge;
        case 0, $2Rqjr.STAGING_ENVIRONMENT:
            return (0, $aghg0.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $cd44a5efa9c7c2f2$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $cd44a5efa9c7c2f2$export$50589a87e4fb3dae(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
        appearance: environmentType === (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), labelKey)) : null;
};
const $cd44a5efa9c7c2f2$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
    if (environmentType === (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, $2Rqjr.DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
    return name;
};

});
parcelRegister("aghg0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ea116b14fefa1e63$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ea116b14fefa1e63$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    developmentEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
        "defaultMessage": "DEV"
    },
    stagingEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
        "defaultMessage": "STG"
    }
});

});


parcelRegister("5KxOv", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", () => $f60267b6fe4a2c5d$export$8adb256d999cd5a0);
/** Wrapper around <HeadingItem> adding custom theming
 * @see @atlaskit/side-navigation
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $b4txA = parcelRequire("b4txA");

var $8n4Bi = parcelRequire("8n4Bi");

var $jkEVK = parcelRequire("jkEVK");
const $f60267b6fe4a2c5d$export$8adb256d999cd5a0 = ({ children: children })=>{
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const cssFn = (0, $eUqFw.useMemo)(()=>(0, $jkEVK.generateCustomThemeCssFn)(theme), [
        theme
    ]);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b4txA.default), {
        cssFn: cssFn
    }, children);
};

});
parcelRegister("b4txA", function(module, exports) {

$parcel$export(module.exports, "default", () => $587c53f185e0b1ef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wpwq = parcelRequire("5wpwq");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
/**
 * __Heading item__
 *
 * Available for advanced use cases, for most situations providing a `title` to `section` should be enough.
 *
 */ const $587c53f185e0b1ef$var$HeadingItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssFn = (0, $jvM56.overrideStyleFunction)((0, $jvM56.sectionHeaderSpacingStyles), props.cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides, @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        ...props,
        cssFn: cssFn
    });
};
var $587c53f185e0b1ef$export$2e2bcd8739ae039 = $587c53f185e0b1ef$var$HeadingItem;

});

parcelRegister("jkEVK", function(module, exports) {

$parcel$export(module.exports, "generateCustomThemeCssFn", () => $0875611379df01fd$export$5ae7d20da3003de);

var $2vzCR = parcelRequire("2vzCR");

var $5vmRt = parcelRequire("5vmRt");
const $0875611379df01fd$export$5ae7d20da3003de = (theme)=>(0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
        if (theme?.navigation) {
            const { navigation: { item: item } } = theme;
            const themeStyles = {
                color: item?.color?.default,
                opacity: item?.opacity
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStyles, themeStyles);
        }
        return currentStyles;
    });

});


parcelRegister("4aKCU", function(module, exports) {

$parcel$export(module.exports, "ForgePageHeader", () => $ee80f8e9038197e4$export$a4f83f6df17decd4);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $iJlfe = parcelRequire("iJlfe");

var $iFXD5 = parcelRequire("iFXD5");

var $8SnT0 = parcelRequire("8SnT0");

var $7eMp1 = parcelRequire("7eMp1");

var $8n4Bi = parcelRequire("8n4Bi");

var $hukpV = parcelRequire("hukpV");

var $5jn4M = parcelRequire("5jn4M");
const $ee80f8e9038197e4$export$a4f83f6df17decd4 = ({ Avatar: Avatar = (0, $iJlfe.default), AddonIcon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
AddonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), CssFixContainer: CssFixContainer = (0, $5jn4M.CssFixContainerDI), Header: Header = (0, $8SnT0.default), cssFn: cssFn, EnvironmentLozenge: EnvironmentLozenge = (0, $7eMp1.EnvironmentLozenge), avatarUrl: avatarUrl, environmentType: environmentType, environmentKey: environmentKey, name: name })=>{
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const headerCssFn = (0, $eUqFw.useMemo)(()=>cssFn ? (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
            cssFn,
            (0, $hukpV.generateCustomThemeCssFn)(theme)
        ]) : (0, $hukpV.generateCustomThemeCssFn)(theme), [
        cssFn,
        theme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CssFixContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, {
        cssFn: headerCssFn,
        iconBefore: avatarUrl?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Avatar, {
            appearance: "square",
            borderColor: "transparent",
            size: "small",
            src: `${avatarUrl}?size=xxlarge`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AddonIcon, {
            label: "",
            size: "medium"
        }),
        // @ts-expect-error - TS2769 - No overload matches this call.
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EnvironmentLozenge, {
            environmentType: environmentType
        })
    }, (0, $7eMp1.nameWithCustomEnvironment)(name, environmentType, environmentKey)));
};

});
parcelRegister("hukpV", function(module, exports) {

$parcel$export(module.exports, "generateCustomThemeCssFn", () => $a917a148f3dfadbc$export$5ae7d20da3003de);

var $2vzCR = parcelRequire("2vzCR");

var $5vmRt = parcelRequire("5vmRt");
const $a917a148f3dfadbc$export$5ae7d20da3003de = (theme)=>(0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
        if (theme?.navigation) {
            const { navigation: { item: item } } = theme;
            const themeStyles = {
                backgroundColor: item?.background?.default ?? undefined,
                color: item?.color?.default ?? undefined,
                '[data-item-title]': {
                    color: item?.color?.default ?? undefined
                },
                '[data-item-description]': {
                    color: item?.color?.default ?? undefined
                }
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStyles, themeStyles);
        }
        return currentStyles;
    });

});

parcelRegister("5jn4M", function(module, exports) {

$parcel$export(module.exports, "CssFixContainerDI", () => $cf127d0288738b67$export$eee12c3955319ddc);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $cf127d0288738b67$export$eee12c3955319ddc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1lfu1kw7",
            __cmplp.className
        ])
    });
});

});


parcelRegister("jn9Rf", function(module, exports) {

$parcel$export(module.exports, "ForgeIcon", () => $d734c17ba92feb96$export$fe0464db4dc93ab4);
$parcel$export(module.exports, "ForgeSubpagesContainer", () => $d734c17ba92feb96$export$682ee8eb4890e553);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $d734c17ba92feb96$export$fe0464db4dc93ab4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});
const $d734c17ba92feb96$export$682ee8eb4890e553 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_14tkpxbi _t3zcv47k _1so4jjyb",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4Kgsn", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1af325f867f52a7e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1af325f867f52a7e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.project-section.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});



parcelRegister("bp2TG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b8601170973bccc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
var $7eyVf = parcelRequire("7eyVf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hzZWH = parcelRequire("hzZWH");

var $e00im = parcelRequire("e00im");

var $asnZU = parcelRequire("asnZU");

var $1V2xJ = parcelRequire("1V2xJ");
const $1b8601170973bccc$var$EMPTY_STACK = [];
const $1b8601170973bccc$var$IssuesMenu = ({ project: project })=>{
    (0, $asnZU.default)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N3rk.default), {
        initialStack: $1b8601170973bccc$var$EMPTY_STACK
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hzZWH.IssuesContextualAnalyticsData), {
        navigatorScope: "project"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e00im.Issues), {
        projectKey: project.key,
        pinUrl: `/jira/core/projects/${project.key}/issues/?filter=`,
        titleHeaderText: formatMessage((0, $1V2xJ.default).issues)
    }))));
};
var $1b8601170973bccc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($1b8601170973bccc$var$IssuesMenu);

});
parcelRegister("e00im", function(module, exports) {

$parcel$export(module.exports, "Issues", () => $da22c620e9d06640$export$1cb51167b20548a0);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $53ciZ = parcelRequire("53ciZ");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $2ijRB = parcelRequire("2ijRB");

var $0cdA8 = parcelRequire("0cdA8");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $bgNoL = parcelRequire("bgNoL");

var $1UelU = parcelRequire("1UelU");

var $jvL3n = parcelRequire("jvL3n");

var $1jPif = parcelRequire("1jPif");

var $9kVcv = parcelRequire("9kVcv");

var $J5kh6 = parcelRequire("J5kh6");

var $bS2FN = parcelRequire("bS2FN");

var $auisD = parcelRequire("auisD");

var $41gRk = parcelRequire("41gRk");

var $gs1oK = parcelRequire("gs1oK");

var $8lbgA = parcelRequire("8lbgA");
const $da22c620e9d06640$var$IssuesNew = ({ projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { data: features } = (0, $J5kh6.useDefaultPinFilters)();
    if (features === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const hasFilters = features.hasAllIssues || features.hasMyOpenIssues;
    const StyleOverrideWrapper = (0, $1ybV0.ff)('nin.global-scope_aqec8') ? $da22c620e9d06640$var$CompiledWrapper : (0, $eUqFw.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyleOverrideWrapper, {
        renderDividerBefore: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $auisD.DefaultFilters), {
        pinUrl: pinUrl,
        projectKey: projectKey,
        features: features,
        titleHeaderText: titleHeaderText
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jira-navigation-apps-sidebar-common",
        id: "issues.starred-filters-section",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jPif.StarredFiltersErrorFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyleOverrideWrapper, {
        renderDividerAfter: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvL3n.StarredFiltersContainer), {
        pinUrl: pinUrl,
        projectKey: projectKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyleOverrideWrapper, {
        renderDividerBefore: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gs1oK.FiltersFooter), {
        hasFilters: hasFilters
    })));
};
const $da22c620e9d06640$export$9bf0cad7d37c4925 = ({ projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ match: match, location: location }] = (0, $lB25E.useRouter)(); // @ts-expect-error - TS2322 - Type '"comma"' is not assignable to type '"none" | "bracket" | "index" | undefined'.
    const { jql: jql } = (0, $53ciZ.parse)(location.search, {
        arrayFormat: 'comma'
    });
    const { data: features } = (0, $J5kh6.useDefaultPinFilters)();
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const isOnLegacyPinRoute = !!match.url.match(/^\/projects.*$/);
    const shouldUseNinLayout = !isOnLegacyPinRoute;
    const pinUrlPrefix = pinUrl === null || pinUrl === undefined || isOnLegacyPinRoute // Force legacy PIN route everywhere if user browsed here themselves
     ? `/projects/${projectKey}/issues/?filter=` : pinUrl;
    const hasSomeFilters = features.hasAllIssues || features.hasMyOpenIssues;
    const allOpenIssuesSelector = !shouldUseNinLayout ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlParams)([
            'filter'
        ], false)(currentLocation, itemLocation) || !currentLocation.query.filter && currentLocation.pathname.includes(`/projects/${projectKey}/issues`) : (0, $bS2FN.matchUrlParams)([
        'filter'
    ], false); // NIN appends the corresponding jql to the URL for the selected filter so that it can
    // be read by integrated marketplace apps. So when determining if a MenuItem is selected, the
    // ?jql query param in the URL does not need to be considered (unless this is for legacy PIN)
    // When we can be sure legacy is no longer in use, this const can be deleted.
    const shouldIgnoreJqlUrlParam = shouldUseNinLayout;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, isOnLegacyPinRoute || titleHeaderText === null || titleHeaderText === undefined ? formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8lbgA.messages).issuesIssueTermRefresh : (0, $8lbgA.messages).issues) : titleHeaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (...args)=>(0, $41gRk.isInAllFiltersState)(undefined, '') || (!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false)(...args) : false),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8lbgA.messages).allIssuesIssueTermRefresh : (0, $8lbgA.messages).allIssues)), features.hasMyOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}myopenissues`
    }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8lbgA.messages).myOpenIssuesIssueTermRefresh : (0, $8lbgA.messages).myOpenIssues)), features.hasReportedByMe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}reportedbyme`
    }, formatMessage((0, $8lbgA.messages).reportedByMe)), !shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8lbgA.messages).allIssuesIssueTermRefresh : (0, $8lbgA.messages).allIssues)), features.hasAllOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? allOpenIssuesSelector : ()=>false,
        href: `${pinUrlPrefix}allopenissues`
    }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8lbgA.messages).allOpenIssuesIssueTermRefresh : (0, $8lbgA.messages).allOpenIssues)), features.hasDoneIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}doneissues`
    }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8lbgA.messages).doneIssuesIssueTermRefresh : (0, $8lbgA.messages).doneIssues)), features.hasViewedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}recentlyviewed`
    }, formatMessage((0, $8lbgA.messages).viewedRecently)), !shouldUseNinLayout && features.hasCreatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES)}`
        },
        selectedOn: !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}addedrecently`
    }, formatMessage((0, $8lbgA.messages).createdRecently)), features.hasResolvedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}resolvedrecently`
    }, formatMessage((0, $8lbgA.messages).resolvedRecently)), features.hasUpdatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}updatedrecently`
    }, formatMessage((0, $8lbgA.messages).updatedRecently))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: hasSomeFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'pin-manage-filters'
        },
        selectedOn: !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: "/secure/ManageFilters.jspa"
    }, formatMessage((0, $8lbgA.messages).viewAllFilters))));
};
const $da22c620e9d06640$export$1cb51167b20548a0 = (0, $2ijRB.default)(()=>(0, $1ybV0.ff)('nin.global-scope_aqec8'), $da22c620e9d06640$var$IssuesNew, $da22c620e9d06640$export$9bf0cad7d37c4925); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da22c620e9d06640$var$CompiledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { renderDividerBefore: renderDividerBefore, renderDividerAfter: renderDividerAfter, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1xlv12x7 _1rqn1fxt",
            __cmplp.renderDividerBefore && "_175u1crf",
            __cmplp.renderDividerAfter && "_1we51crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jvL3n", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersContainer", () => $6b45c28ee62250e5$export$f5b4503a4a7ca418);

var $dV4cd = parcelRequire("dV4cd");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $gLn5u = parcelRequire("gLn5u");

var $1ybV0 = parcelRequire("1ybV0");

var $1h6H8 = parcelRequire("1h6H8");

var $62ZdZ = parcelRequire("62ZdZ");

var $gGtKh = parcelRequire("gGtKh");

var $buJlM = parcelRequire("buJlM");

var $dV4cd = parcelRequire("dV4cd");

var $cINNO = parcelRequire("cINNO");

var $dWLk9 = parcelRequire("dWLk9");

var $lB25E = parcelRequire("lB25E");

var $de40W = parcelRequire("de40W");

var $g1pyf = parcelRequire("g1pyf");
const $6b45c28ee62250e5$export$3be6ba2fb4838e7e = ({ onFavouritesChanged: onFavouritesChanged, queryReference: queryReference, projectKey: projectKey, pinUrl: pinUrl })=>{
    // We store localStorageData as state so that it's not recalculated during subsequent renders. We want that as a
    // guarantee, not just as a performance optimisation, so we're using useState rather than useMemo.
    //
    // The reason we want to guarantee it's only fetched during the initial render is that we want
    // isNinGlobalScopeEnrolmentEnabled to be stable if there's localStorageData. This can prevent a bug where fetch
    // true from localStorage, we render NIN, the resource returns false, we update local storage to false, and then
    // GinRedirect is rendered again by a parent component and localStorage now returns false and we redirect later
    // than we should.;
    const [localStorageData] = (0, $eUqFw.useState)((0, $1h6H8.getIsGlobalScopeEnrolmentEnabledFromLocalStorage)());
    const { data: resourceData } = (0, $lB25E.useResource)((0, $cINNO.isNinGlobalScopeEnrolmentEnabledResource));
    // get value from localStorage if available, get from the resource if this code runs in SSR
    let isNinGlobalScopeEnrolmentEnabled;
    if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = !!localStorageData;
    else isNinGlobalScopeEnrolmentEnabled = !!resourceData;
    const baseHref = (0, $de40W.getStarredFilterLink)({
        projectKey: projectKey,
        pinUrl: pinUrl,
        shouldStayProjectScope: (0, $1ybV0.ff)('nin.global-scope_aqec8') && isNinGlobalScopeEnrolmentEnabled
    });
    const data = (0, $iWLL0.usePreloadedQuery)((0, $dV4cd.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g1pyf.StarredFiltersList), {
        baseHref: baseHref,
        jiraQuery: data.jira,
        onFavouritesChanged: onFavouritesChanged
    });
};
const $6b45c28ee62250e5$export$f5b4503a4a7ca418 = ({ projectKey: projectKey, pinUrl: pinUrl })=>{
    const { queryReference: resourceQueryRef } = (0, $buJlM.useRelayResource)((0, $62ZdZ.sidebarProjectIssuesResource));
    const [queryReference, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $dV4cd.default), resourceQueryRef);
    const cloudId = (0, $dWLk9.useCloudId)();
    const loadSidebarData = (0, $eUqFw.useCallback)(()=>{
        loadQuery({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network'
        });
    }, [
        cloudId,
        loadQuery
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!queryReference) loadSidebarData();
    }, [
        loadSidebarData,
        queryReference
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "starred-filters",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null)
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b45c28ee62250e5$export$3be6ba2fb4838e7e, {
        queryReference: queryReference,
        onFavouritesChanged: loadSidebarData,
        pinUrl: pinUrl,
        projectKey: projectKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null));
};

});
parcelRegister("de40W", function(module, exports) {

$parcel$export(module.exports, "getStarredFilterLink", () => $58b0dd58f177e334$export$7082c02465d0ecd4);
const $58b0dd58f177e334$export$7082c02465d0ecd4 = ({ projectKey: projectKey, pinUrl: pinUrl, shouldStayProjectScope: shouldStayProjectScope })=>{
    if (!projectKey) throw new Error(`Expected projectKey to be a valid string, got: ${projectKey}`);
    // xxx/issues?filter=123 -> xxx/issues
    const craftedPinUrl = !pinUrl ? `/projects/${projectKey}/issues` : pinUrl.replace(/\?.*$/, '');
    return shouldStayProjectScope ? craftedPinUrl : '/issues/';
};

});

parcelRegister("g1pyf", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersList", () => $35a2047bceaae71b$export$b7f4b26a8737eee0);

var $kwce8 = parcelRequire("kwce8");

var $lz8Mx = parcelRequire("lz8Mx");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7eyVf = parcelRequire("7eyVf");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hR6B0 = parcelRequire("hR6B0");

var $efIfB = parcelRequire("efIfB");

var $9GCal = parcelRequire("9GCal");
var $35a2047bceaae71b$var$_StyledSection = /*#__PURE__*/ (0, $kwce8.default)((0, $7eyVf.default)).withConfig({
    componentId: "sc-8ugvpc-0"
})`${(p)=>p._css}`;
const $35a2047bceaae71b$export$b7f4b26a8737eee0 = ({ baseHref: baseHref, jiraQuery: jiraQuery, onFavouritesChanged: onFavouritesChanged, sectionCustomCss: sectionCustomCss })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $lz8Mx.default), jiraQuery);
    (0, $hR6B0.useFavoritesChangeEffect)('filters', (hasPendingChanges, previousHasPendingChanges)=>{
        // refresh when transitioning from pending to NOT pending
        if (previousHasPendingChanges && !hasPendingChanges) onFavouritesChanged();
    });
    const starredFilterEdges = data.favouriteFilters?.edges || [];
    if (!starredFilterEdges.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35a2047bceaae71b$var$_StyledSection, {
        title: formatMessage((0, $1ybV0.ff)('nin.global-scope_aqec8') ? (0, $9GCal.messages).newStarredFiltersHeader : (0, $9GCal.messages).starredFiltersHeader),
        _css: sectionCustomCss
    }, starredFilterEdges.map((edge)=>edge?.node ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $efIfB.FilterItem), {
            key: edge.node.filterId,
            baseHref: baseHref,
            filter: edge.node,
            customAnalytics: {
                isStarred: true
            }
        }) : null));
};

});
parcelRegister("lz8Mx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8652eb61facff2a1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a0ff7cd83606b406c54bd970f933e48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8652eb61facff2a1$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "starredFiltersList_navigationAppsSidebarCommon",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraFilterConnection",
            "kind": "LinkedField",
            "name": "favouriteFilters",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "filterId"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "filterItem_navigationAppsSidebarCommon"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$8652eb61facff2a1$var$node.hash = "a0c4e11d2fa2d823ad4cac3d7e350cb3";
var $8652eb61facff2a1$export$2e2bcd8739ae039 = $8652eb61facff2a1$var$node;

});

parcelRegister("hR6B0", function(module, exports) {

$parcel$export(module.exports, "useFavoritesChangeEffect", () => $2f7c11e5ef943ce8$export$659f59218fc5dd14);

var $eUqFw = parcelRequire("eUqFw");

var $3LiTJ = parcelRequire("3LiTJ");

var $dQZ5c = parcelRequire("dQZ5c");

var $hzcvF = parcelRequire("hzcvF");
const $2f7c11e5ef943ce8$export$659f59218fc5dd14 = (type, effect)=>{
    const { items: items } = (0, $eUqFw.useContext)((0, $dQZ5c.FavoriteChangeContext));
    // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
    const typeItems = items[type];
    const pendingChanges = (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(typeItems, (item)=>item.pending);
    const hasPendingChanges = Boolean(Object.keys(pendingChanges).length);
    const previousHasPendingChanges = (0, $hzcvF.usePreviousWithInitial)(hasPendingChanges);
    (0, $eUqFw.useEffect)(()=>{
        effect(hasPendingChanges, previousHasPendingChanges);
    }, [
        effect,
        hasPendingChanges,
        previousHasPendingChanges
    ]);
};

});

parcelRegister("efIfB", function(module, exports) {

$parcel$export(module.exports, "FilterItem", () => $d52ff21ebba57816$export$3cf161fcd24b6b4f);

var $emcDd = parcelRequire("emcDd");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1UelU = parcelRequire("1UelU");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d52ff21ebba57816$var$selectedOn = (currentLocation, itemLocation)=>itemLocation.query.filter === (currentLocation.query.filterId || currentLocation.query.filter);
const $d52ff21ebba57816$export$3cf161fcd24b6b4f = ({ baseHref: baseHref, filter: filter, customAnalytics: customAnalytics })=>{
    const { filterId: filterId, name: name } = (0, $iWLL0.useFragment)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $emcDd.default), /* eslint-enable @atlassian/relay/unused-fields */ filter);
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            ...customAnalytics || {},
            itemId: `filter-${filterId}`
        }), [
        customAnalytics,
        filterId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        key: filterId,
        analytics: analyticsAttributes,
        selectedOn: $d52ff21ebba57816$var$selectedOn,
        href: `${baseHref}?filter=${filterId}`
    }, name);
};

});
parcelRegister("emcDd", function(module, exports) {

$parcel$export(module.exports, "default", () => $316231fa04a38c46$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<331a8e20fbd9d2a81b2d41dfa21f3810>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $316231fa04a38c46$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "filterItem_navigationAppsSidebarCommon",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$316231fa04a38c46$var$node.hash = "31464d108113d7084e471c226c3fe0aa";
var $316231fa04a38c46$export$2e2bcd8739ae039 = $316231fa04a38c46$var$node;

});


parcelRegister("9GCal", function(module, exports) {

$parcel$export(module.exports, "messages", () => $298836785675e03a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $298836785675e03a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    starredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-list.starred-filters-header",
        "defaultMessage": "Starred global filters"
    },
    // TODO: cleanup when tidying up FF: nin.global-scope_aqec8
    newStarredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-list.new-starred-filters-header",
        "defaultMessage": "Starred filters"
    }
});

});



parcelRegister("1jPif", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersErrorFallback", () => $d6c63c3350dd7b8a$export$70765d6359132b82);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $lRvnl = parcelRequire("lRvnl");

var $7eyVf = parcelRequire("7eyVf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $e7DJr = parcelRequire("e7DJr");
const $d6c63c3350dd7b8a$export$70765d6359132b82 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c63c3350dd7b8a$var$SectionWrapper, {
        // TODO remove SectionWrapper once @atlaskit/section design gets updated
        title: formatMessage((0, $e7DJr.default).starredFiltersHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "warning"
    }, formatMessage((0, $e7DJr.default).errorMessage, {
        link: (linkText)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                spacing: "none",
                onClick: ()=>window.location.reload()
            }, linkText)
    })));
};
// TODO remove SectionWrapper once @atlaskit/section design gets updated
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6c63c3350dd7b8a$var$SectionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7eyVf.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt3i2wt _euf41fxt _1qdg1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lRvnl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dc3a504e8cabc14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $gf4A3 = parcelRequire("gf4A3");
const $4dc3a504e8cabc14$var$containerStyles = (0, $1ZAYh.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'border.radius'
});
const $4dc3a504e8cabc14$var$bleedStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginBlock: 'space.negative.025'
});
const $4dc3a504e8cabc14$var$contentStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $4dc3a504e8cabc14$var$SectionMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $gf4A3.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "section",
        backgroundColor: $4dc3a504e8cabc14$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $4dc3a504e8cabc14$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4dc3a504e8cabc14$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        testId: testId && `${testId}--content`
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4dc3a504e8cabc14$var$contentStyles
    }, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        shouldWrap: true,
        testId: testId && `${testId}--actions`,
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0",
        role: "list"
    }, actionsArray.map((action, id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            role: "listitem",
            key: id
        }, action))))));
});
const $4dc3a504e8cabc14$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$4dc3a504e8cabc14$var$SectionMessage.displayName = 'SectionMessage';
var $4dc3a504e8cabc14$export$2e2bcd8739ae039 = $4dc3a504e8cabc14$var$SectionMessage;

});
parcelRegister("gf4A3", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $5e1f1f04e3e69c39$export$e9b82d2e21ac0c1f);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $ioiQ7 = parcelRequire("ioiQ7");

var $5YsMl = parcelRequire("5YsMl");

const $5e1f1f04e3e69c39$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $73a5c9d720aa66e1$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($96IgR))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $73a5c9d720aa66e1$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $73a5c9d720aa66e1$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $73a5c9d720aa66e1$export$147899de772240ec)})`
    }
};
function $5e1f1f04e3e69c39$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $5e1f1f04e3e69c39$export$faa35441caff5bb6[appearance] || $5e1f1f04e3e69c39$export$faa35441caff5bb6.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("aWvIp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f77ec2b05210607$var$_react = $7f77ec2b05210607$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7f77ec2b05210607$var$_success = $7f77ec2b05210607$var$_interopRequireDefault((parcelRequire("50qGm")));
function $7f77ec2b05210607$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7f77ec2b05210607$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $7f77ec2b05210607$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $7f77ec2b05210607$var$_success.default
    }));
$7f77ec2b05210607$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $7f77ec2b05210607$var$_default = module.exports.default = $7f77ec2b05210607$var$CheckCircleIcon;

});
parcelRegister("50qGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a51a662974016bc$var$_react = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a51a662974016bc$var$_UNSAFE_baseNew = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3a51a662974016bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a51a662974016bc$var$SuccessIcon = (props)=>/*#__PURE__*/ $3a51a662974016bc$var$_react.default.createElement($3a51a662974016bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$3a51a662974016bc$var$SuccessIcon.displayName = 'SuccessIcon';
var $3a51a662974016bc$var$_default = module.exports.default = $3a51a662974016bc$var$SuccessIcon;

});


parcelRegister("2bv8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1974c390fcca76c2$var$_react = $1974c390fcca76c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $1974c390fcca76c2$var$_information = $1974c390fcca76c2$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $1974c390fcca76c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1974c390fcca76c2$var$InfoIcon = (props)=>/*#__PURE__*/ $1974c390fcca76c2$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $1974c390fcca76c2$var$_information.default
    }));
$1974c390fcca76c2$var$InfoIcon.displayName = 'InfoIcon';
var $1974c390fcca76c2$var$_default = module.exports.default = $1974c390fcca76c2$var$InfoIcon;

});
parcelRegister("h6FFs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});




parcelRegister("e7DJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d36cc3357c6d79c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4d36cc3357c6d79c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.error-message",
        "defaultMessage": "We couldn't load your starred filters. <link>Refresh the page</link> to try again."
    },
    starredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.starred-filters-header",
        "defaultMessage": "Starred filters"
    }
});

});


parcelRegister("J5kh6", function(module, exports) {

$parcel$export(module.exports, "useDefaultPinFilters", () => $35f10d3662b33f51$export$3c69152f8409a017);

var $eUqFw = parcelRequire("eUqFw");

var $51qRF = parcelRequire("51qRF");

var $lB25E = parcelRequire("lB25E");
const $35f10d3662b33f51$export$3c69152f8409a017 = ()=>{
    const { data: data, loading: loading, refresh: refresh, error: error } = (0, $lB25E.useResource)((0, $51qRF.staticSidebarDefaultPINFiltersResource));
    (0, $eUqFw.useEffect)(()=>{
        if (data == null && error == null && loading === false) refresh();
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return {
        data: data,
        loading: loading
    };
};

});

parcelRegister("auisD", function(module, exports) {

$parcel$export(module.exports, "DefaultFilters", () => $755cdea7fe43675a$export$5df36bcfaa4d1f9d);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $7eyVf = parcelRequire("7eyVf");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $1UelU = parcelRequire("1UelU");

var $bS2FN = parcelRequire("bS2FN");

var $3Cmcu = parcelRequire("3Cmcu");

var $41gRk = parcelRequire("41gRk");
const $755cdea7fe43675a$export$5df36bcfaa4d1f9d = ({ features: features, projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ match: match, location: location }] = (0, $lB25E.useRouter)();
    // @ts-expect-error - TS2322 - Type '"comma"' is not assignable to type '"none" | "bracket" | "index" | undefined'.
    const { jql: jql } = (0, $53ciZ.parse)(location.search, {
        arrayFormat: 'comma'
    });
    const isOnLegacyPinRoute = !!match.url.match(/^\/projects.*$/);
    const shouldUseNinLayout = !isOnLegacyPinRoute;
    const pinUrlPrefix = pinUrl === null || pinUrl === undefined || isOnLegacyPinRoute // Force legacy PIN route everywhere if user browsed here themselves
     ? `/projects/${projectKey}/issues/?filter=` : pinUrl;
    const title = isOnLegacyPinRoute || titleHeaderText == null ? formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3Cmcu.messages).issuesIssueTermRefresh : (0, $3Cmcu.messages).issues) : titleHeaderText;
    const allOpenIssuesSelector = !shouldUseNinLayout ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlParams)([
            'filter'
        ], false)(currentLocation, itemLocation) || !currentLocation.query.filter && currentLocation.pathname.includes(`/projects/${projectKey}/issues`) : (0, $bS2FN.matchUrlParams)([
        'filter'
    ], false);
    // NIN appends the corresponding jql to the URL for the selected filter so that it can
    // be read by integrated marketplace apps. So when determining if a MenuItem is selected, the
    // ?jql query URL param should be ignored unless this is for legacy PIN.
    // When we can be sure legacy is no longer in use, this const can be deleted.
    const shouldIgnoreJqlUrlParam = shouldUseNinLayout;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: title
    }, shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).ninLayoutAllIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).ninLayoutAllIssues.selectedOn(jql),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3Cmcu.messages).allIssuesIssueTermRefresh : (0, $3Cmcu.messages).allIssues)), features.hasMyOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).myOpenIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).myOpenIssues.selectedOn(jql),
        href: `${pinUrlPrefix}myopenissues`
    }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3Cmcu.messages).myOpenIssuesIssueTermRefresh : (0, $3Cmcu.messages).myOpenIssues)), features.hasReportedByMe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).reportedByMe.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).reportedByMe.selectedOn(jql),
        href: `${pinUrlPrefix}reportedbyme`
    }, formatMessage((0, $3Cmcu.messages).reportedByMe)), !shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).notNinLayoutAllIssues.analytics,
        selectedOn: (0, $41gRk.itemMap).notNinLayoutAllIssues.selectedOn(jql),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3Cmcu.messages).allIssuesIssueTermRefresh : (0, $3Cmcu.messages).allIssues)), features.hasAllOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).allOpenIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).allOpenIssues.selectedOn(jql, allOpenIssuesSelector),
        href: `${pinUrlPrefix}allopenissues`
    }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3Cmcu.messages).allOpenIssuesIssueTermRefresh : (0, $3Cmcu.messages).allOpenIssues)), features.hasDoneIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).doneIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).doneIssues.selectedOn(jql),
        href: `${pinUrlPrefix}doneissues`
    }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3Cmcu.messages).doneIssuesIssueTermRefresh : (0, $3Cmcu.messages).doneIssues)), features.hasViewedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).viewedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).viewedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}recentlyviewed`
    }, formatMessage((0, $3Cmcu.messages).viewedRecently)), !shouldUseNinLayout && features.hasCreatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).createdRecently.analytics,
        selectedOn: (0, $41gRk.itemMap).createdRecently.selectedOn(jql),
        href: `${pinUrlPrefix}addedrecently`
    }, formatMessage((0, $3Cmcu.messages).createdRecently)), features.hasResolvedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).resolvedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).resolvedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}resolvedrecently`
    }, formatMessage((0, $3Cmcu.messages).resolvedRecently)), features.hasUpdatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).updatedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).updatedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}updatedrecently`
    }, formatMessage((0, $3Cmcu.messages).updatedRecently)));
};

});
parcelRegister("3Cmcu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $27be2807b2a35477$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $27be2807b2a35477$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues",
        "defaultMessage": "Issues and filters"
    },
    issuesFilters: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters",
        "defaultMessage": "Issues and Filters"
    },
    myOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues",
        "defaultMessage": "My open issues"
    },
    reportedByMe: {
        "id": "spa-apps-sidebar-common.issues.default-filters.reported-by-me",
        "defaultMessage": "Reported by me"
    },
    allIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-issues",
        "defaultMessage": "All issues"
    },
    allOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues",
        "defaultMessage": "Open issues"
    },
    doneIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.done-issues",
        "defaultMessage": "Done issues"
    },
    viewedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.viewed-recently",
        "defaultMessage": "Viewed recently"
    },
    createdRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.created-recently",
        "defaultMessage": "Created recently"
    },
    resolvedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.resolved-recently",
        "defaultMessage": "Resolved recently"
    },
    updatedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.updated-recently",
        "defaultMessage": "Updated recently"
    },
    issuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues-issue-term-refresh",
        "defaultMessage": "Issues and filters"
    },
    issuesFiltersIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters-issue-term-refresh",
        "defaultMessage": "Issues and Filters"
    },
    myOpenIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues-issue-term-refresh",
        "defaultMessage": "My open issues"
    },
    allIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-issues-issue-term-refresh",
        "defaultMessage": "All issues"
    },
    allOpenIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues-issue-term-refresh",
        "defaultMessage": "Open issues"
    },
    doneIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.done-issues-issue-term-refresh",
        "defaultMessage": "Done issues"
    }
});

});

parcelRegister("41gRk", function(module, exports) {

$parcel$export(module.exports, "isInAllFiltersState", () => $4de8f16c2cebce90$export$1596c397510d46b1);
$parcel$export(module.exports, "itemMap", () => $4de8f16c2cebce90$export$1072457701b9918d);

var $bgNoL = parcelRequire("bgNoL");

var $bS2FN = parcelRequire("bS2FN");
const $4de8f16c2cebce90$export$1596c397510d46b1 = (filter, jql)=>{
    // Initial load
    if ((typeof filter === 'undefined' || !filter.length) && typeof jql === 'undefined') return true;
    if (filter != null && filter !== 'allissues') return false;
    if (typeof jql === 'string' && jql.match(/^project = ".*" ORDER BY created (?:DESC|ASC)$/)) return true;
    return false;
};
const $4de8f16c2cebce90$export$1072457701b9918d = {
    ninLayoutAllIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: (jql)=>(...args)=>$4de8f16c2cebce90$export$1596c397510d46b1(undefined, '') || (!jql ? (0, $bS2FN.matchUrlParams)([
                    'filter'
                ], false)(...args) : false)
    },
    myOpenIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    reportedByMe: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    notNinLayoutAllIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    allOpenIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES)}`
        },
        selectedOn: (jql, allOpenIssuesSelector)=>!jql && allOpenIssuesSelector ? allOpenIssuesSelector : ()=>false
    },
    doneIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    viewedRecently: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    createdRecently: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    resolvedRecently: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    updatedRecently: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    }
};

});


parcelRegister("gs1oK", function(module, exports) {

$parcel$export(module.exports, "FiltersFooter", () => $b725eee24cc929f3$export$c131ccfc44bcd85c);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $fPhxv = parcelRequire("fPhxv");
const $b725eee24cc929f3$var$analyticsPayload = {
    itemId: 'pin-manage-filters'
};
const $b725eee24cc929f3$export$c131ccfc44bcd85c = ({ hasFilters: hasFilters })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: hasFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: $b725eee24cc929f3$var$analyticsPayload,
        href: "/jira/filters"
    }, formatMessage((0, $fPhxv.messages).viewAllFilters)));
};

});
parcelRegister("fPhxv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bd606415b82d3454$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $bd606415b82d3454$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    viewAllFilters: {
        "id": "spa-apps-sidebar-common.issues.filters-footer.view-all-filters",
        "defaultMessage": "View all filters"
    }
});

});


parcelRegister("8lbgA", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a62695030ba4b800$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a62695030ba4b800$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "spa-apps-sidebar-common.issues.issues",
        "defaultMessage": "Issues and filters"
    },
    issuesFilters: {
        "id": "spa-apps-sidebar-common.issues.issues-filters",
        "defaultMessage": "Issues and Filters"
    },
    myOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.my-open-issues",
        "defaultMessage": "My open issues"
    },
    reportedByMe: {
        "id": "spa-apps-sidebar-common.issues.reported-by-me",
        "defaultMessage": "Reported by me"
    },
    allIssues: {
        "id": "spa-apps-sidebar-common.issues.all-issues",
        "defaultMessage": "All issues"
    },
    allOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.all-open-issues",
        "defaultMessage": "Open issues"
    },
    doneIssues: {
        "id": "spa-apps-sidebar-common.issues.done-issues",
        "defaultMessage": "Done issues"
    },
    viewedRecently: {
        "id": "spa-apps-sidebar-common.issues.viewed-recently",
        "defaultMessage": "Viewed recently"
    },
    createdRecently: {
        "id": "spa-apps-sidebar-common.issues.created-recently",
        "defaultMessage": "Created recently"
    },
    resolvedRecently: {
        "id": "spa-apps-sidebar-common.issues.resolved-recently",
        "defaultMessage": "Resolved recently"
    },
    updatedRecently: {
        "id": "spa-apps-sidebar-common.issues.updated-recently",
        "defaultMessage": "Updated recently"
    },
    viewAllFilters: {
        "id": "spa-apps-sidebar-common.issues.view-all-filters",
        "defaultMessage": "View all filters"
    },
    issuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.issues-issue-term-refresh",
        "defaultMessage": "Issues and filters"
    },
    issuesFiltersIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.issues-filters-issue-term-refresh",
        "defaultMessage": "Issues and Filters"
    },
    myOpenIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.my-open-issues-issue-term-refresh",
        "defaultMessage": "My open issues"
    },
    allIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.all-issues-issue-term-refresh",
        "defaultMessage": "All issues"
    },
    allOpenIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.all-open-issues-issue-term-refresh",
        "defaultMessage": "Open issues"
    },
    doneIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.done-issues-issue-term-refresh",
        "defaultMessage": "Done issues"
    }
});

});


parcelRegister("1V2xJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff74a8dacf24a66b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $ff74a8dacf24a66b$var$messages = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.issues-menu.issues",
        "defaultMessage": "Issues"
    }
});
var $ff74a8dacf24a66b$export$2e2bcd8739ae039 = $ff74a8dacf24a66b$var$messages;

});


parcelRegister("8Xc28", function(module, exports) {

$parcel$export(module.exports, "default", () => $bebf29b281f05c6a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
var $7eyVf = parcelRequire("7eyVf");

var $elGVw = parcelRequire("elGVw");

var $10fdS = parcelRequire("10fdS");

var $lg3mT = parcelRequire("lg3mT");

var $kFwR2 = parcelRequire("kFwR2");

var $asnZU = parcelRequire("asnZU");

var $1gKca = parcelRequire("1gKca");
const $bebf29b281f05c6a$var$calculateStack = (route, connectStack)=>{
    if ((0, $elGVw.CONNECT_ROUTES_SET).has(route.name) && connectStack) {
        const [first, ...other] = connectStack;
        // omit the reports nesting level as we render the reports menu
        // as a top level menu in business projects
        if ((0, $lg3mT.SECTION_ID).REPORTS === first) return other;
        return connectStack;
    }
    return [];
};
const $bebf29b281f05c6a$var$ReportsMenu = ()=>{
    (0, $asnZU.default)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: connectItems, stack: connectStack } = (0, $kFwR2.useProjectReportsConnectItems)();
    const [stack, setStack] = (0, $eUqFw.useState)(()=>$bebf29b281f05c6a$var$calculateStack(route, connectStack));
    (0, $eUqFw.useEffect)(()=>{
        setStack($bebf29b281f05c6a$var$calculateStack(route, connectStack));
    }, [
        route,
        connectStack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N3rk.default), {
        stack: stack,
        onChange: setStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1gKca.Reports), {
        connectItems: connectItems
    })));
};
var $bebf29b281f05c6a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($bebf29b281f05c6a$var$ReportsMenu);

});
parcelRegister("1gKca", function(module, exports) {

$parcel$export(module.exports, "Reports", () => $c5c469348dcea9ef$export$883262dc952d8f59);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $5KxOv = parcelRequire("5KxOv");

var $cPEpP = parcelRequire("cPEpP");

var $kIUmN = parcelRequire("kIUmN");

var $bS2FN = parcelRequire("bS2FN");

var $aWYQ8 = parcelRequire("aWYQ8");

var $hX9N3 = parcelRequire("hX9N3");

var $aJGiK = parcelRequire("aJGiK");

var $bRhBg = parcelRequire("bRhBg");

var $lmMuP = parcelRequire("lmMuP");
const $c5c469348dcea9ef$var$useThrowDefaultReportItemsDI = (0, $kIUmN.withThrowOnError)((0, $aJGiK.useDefaultReportItems));
const $c5c469348dcea9ef$var$useThrowProjectDI = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
const $c5c469348dcea9ef$var$useThrowReportFeaturesDI = (0, $kIUmN.withThrowOnError)((0, $bRhBg.useReportFeatures));
const $c5c469348dcea9ef$export$883262dc952d8f59 = ({ ConnectMenu: ConnectMenu = (0, $aWYQ8.ConnectMenu), MenuItem: MenuItem = (0, $1UelU.MenuItem), Section: Section = (0, $7eyVf.default), SkeletonItem: SkeletonItem = (0, $gLn5u.default), connectItems: connectItems, SectionHeader: SectionHeader = (0, $5KxOv.SectionHeader), matchUrlParams: matchUrlParams = (0, $bS2FN.matchUrlParams), useDefaultReportItems: useDefaultReportItems = $c5c469348dcea9ef$var$useThrowDefaultReportItemsDI, useIntl: useIntl = (0, $5JgJ2.default), useProject: useProject = $c5c469348dcea9ef$var$useThrowProjectDI, useReportFeatures: useReportFeatures = $c5c469348dcea9ef$var$useThrowReportFeaturesDI })=>{
    const baseUrl = '';
    const { data: defaultItems } = useDefaultReportItems();
    const { data: features } = useReportFeatures();
    const { formatMessage: formatMessage } = useIntl();
    const { data: project } = useProject();
    if (project == null || features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SkeletonItem, null);
    const createReportUrl = (0, $hX9N3.createReportUrlFunc)({
        baseUrl: baseUrl,
        project: project
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, defaultItems && defaultItems.items.length > 0 && // @ts-expect-error - TS2769 - No overload matches this call.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        id: defaultItems.id,
        key: defaultItems.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SectionHeader, null, defaultItems.name), defaultItems.items && defaultItems.items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
            key: item.id,
            analytics: {
                itemId: item.id
            },
            selectedOn: matchUrlParams([
                'reportKey'
            ]),
            href: item.url
        }, item.name != null ? item.name : null))), features && features.hasForcastSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SectionHeader, null, formatMessage((0, $lmMuP.default).forecastAndManagement)), features.hasTimeTracking && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
        analytics: {
            itemId: 'time-tracking'
        },
        href: createReportUrl('com.atlassian.jira.plugin.system.reports:time-tracking'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $lmMuP.default).timeTracking)), features.hasDeveloperWorkload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
        analytics: {
            itemId: 'developer-workload'
        },
        href: createReportUrl('com.atlassian.jira.plugin.system.reports:developer-workload'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $lmMuP.default).userWorkload)), features.hasVersionWorkloadReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
        analytics: {
            itemId: 'version-workload'
        },
        href: createReportUrl('com.atlassian.jira.plugins.jira-software-plugin:version-workload-report'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $lmMuP.default).versionWorkload))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SectionHeader, null, formatMessage((0, $lmMuP.default).other)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
        analytics: {
            itemId: 'workloadpie'
        },
        href: createReportUrl('com.atlassian.jira.ext.charting:workloadpie-report'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $lmMuP.default).workloadPieChart)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ConnectMenu, {
        items: connectItems,
        overrides: {
            BackMenuItem: {
                href: `/projects/${project.key}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`,
                title: formatMessage((0, $lmMuP.default).itemBack)
            }
        }
    })));
};

});
parcelRegister("hX9N3", function(module, exports) {

$parcel$export(module.exports, "createReportUrlFunc", () => $aaeaad86945af36f$export$fe91ad5e718e4335);
const $aaeaad86945af36f$export$fe91ad5e718e4335 = ({ baseUrl: baseUrl, project: project })=>(reportKey)=>`${baseUrl}/secure/ConfigureReport!default.jspa?selectedProjectId=${project.id}&projectOrFilterId=project-${project.id}&projectOrFilterName=${project.name}&reportKey=${reportKey}`;

});

parcelRegister("aJGiK", function(module, exports) {

$parcel$export(module.exports, "useDefaultReportItems", () => $803b0b72c024ff00$export$ab2e8832e8916e83);

var $5JgJ2 = parcelRequire("5JgJ2");

var $cPEpP = parcelRequire("cPEpP");

var $hX9N3 = parcelRequire("hX9N3");

var $93Xzy = parcelRequire("93Xzy");
const $803b0b72c024ff00$export$ab2e8832e8916e83 = ()=>{
    const baseUrl = '';
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: project, loading: loading, error: error } = (0, $cPEpP.useProject)();
    let defaultIssueAnalysisSection = null;
    if (project) {
        const createReportUrl = (0, $hX9N3.createReportUrlFunc)({
            baseUrl: baseUrl,
            project: project
        });
        defaultIssueAnalysisSection = {
            name: formatMessage((0, $93Xzy.default).issueAnalysis),
            id: 'issue-analysis-sidebar-links',
            items: [
                {
                    id: 'averageage-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:averageage-report'),
                    name: formatMessage((0, $93Xzy.default).averageAgeReport)
                },
                {
                    id: 'createdvsresolved-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:createdvsresolved-report'),
                    name: formatMessage((0, $93Xzy.default).createdResolvedIssuesReport)
                },
                {
                    id: 'pie-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:pie-report'),
                    name: formatMessage((0, $93Xzy.default).pieChart)
                },
                {
                    id: 'recentlycreated-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:recentlycreated-report'),
                    name: formatMessage((0, $93Xzy.default).recentlyCreatedIssues)
                },
                {
                    id: 'resolutiontime-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:resolutiontime-report'),
                    name: formatMessage((0, $93Xzy.default).resolutionTime)
                },
                {
                    id: 'singlelevelgroupby',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:singlelevelgroupby'),
                    name: formatMessage((0, $93Xzy.default).singleLevelGroup)
                },
                {
                    id: 'timesince-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:timesince-report'),
                    name: formatMessage((0, $93Xzy.default).timeSinceIssues)
                }
            ]
        };
    }
    return {
        data: defaultIssueAnalysisSection,
        loading: loading,
        error: error
    };
};

});
parcelRegister("93Xzy", function(module, exports) {

$parcel$export(module.exports, "default", () => $af7783a38d48407a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $af7783a38d48407a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueAnalysis: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.issue-analysis",
        "defaultMessage": "Issue analysis"
    },
    averageAgeReport: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.average-age-report",
        "defaultMessage": "Average Age Report"
    },
    createdResolvedIssuesReport: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.created-resolved-issues-report",
        "defaultMessage": "Created vs Resolved Issues Report"
    },
    pieChart: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.pie-chart",
        "defaultMessage": "Pie Chart Report"
    },
    recentlyCreatedIssues: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.recently-created-issues",
        "defaultMessage": "Recently Created Issues Report"
    },
    resolutionTime: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.resolution-time",
        "defaultMessage": "Resolution Time Report"
    },
    singleLevelGroup: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.single-level-group",
        "defaultMessage": "Single Level Group By Report"
    },
    timeSinceIssues: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.time-since-issues",
        "defaultMessage": "Time Since Issues Report"
    }
});

});


parcelRegister("lmMuP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d0b546a275ef68c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7d0b546a275ef68c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    forecastAndManagement: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.forecast-and-management",
        "defaultMessage": "Forecast & management"
    },
    timeTracking: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.time-tracking",
        "defaultMessage": "Time Tracking Report"
    },
    userWorkload: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.user-workload",
        "defaultMessage": "User Workload Report"
    },
    versionWorkload: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.version-workload",
        "defaultMessage": "Version Workload Report"
    },
    workloadPieChart: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.workload-pie-chart",
        "defaultMessage": "Workload Pie Chart Report"
    },
    other: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.other",
        "defaultMessage": "Other"
    },
    itemBack: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.item-back",
        "defaultMessage": "Back to reports"
    }
});

});



parcelRegister("aZ40y", function(module, exports) {

$parcel$export(module.exports, "default", () => $578dbaa7eba68868$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
var $7eyVf = parcelRequire("7eyVf");

var $exb0h = parcelRequire("exb0h");

var $elGVw = parcelRequire("elGVw");

var $10fdS = parcelRequire("10fdS");

var $lg3mT = parcelRequire("lg3mT");

var $kFwR2 = parcelRequire("kFwR2");

var $asnZU = parcelRequire("asnZU");

var $eiI3i = parcelRequire("eiI3i");

var $1m2Xn = parcelRequire("1m2Xn");
const $578dbaa7eba68868$var$EMPTY_STACK = [];
const $578dbaa7eba68868$var$adjustAppStack = (appStack)=>{
    const [first, ...other] = appStack;
    // omit the settings nesting level as we render the settings menu
    // as a top level menu in business projects
    if ((0, $lg3mT.SECTION_ID).SETTINGS === first) return other;
    return appStack;
};
const $578dbaa7eba68868$var$calculateStack = (route, connectStack, forgeStack)=>{
    // should be handled above generic PROJECT_SETTINGS_CORE logic
    if ((0, $lg3mT.FORGE_ROUTES_SET).has(route.name) && forgeStack) return $578dbaa7eba68868$var$adjustAppStack(forgeStack);
    if (route.name.includes((0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE))) {
        // this is the same logic as the one in src/packages/navigation-apps/sidebar/next-gen/src/ui/menu/main.js
        const [view] = route.name.replace(`${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE)}-`, '').split('-');
        return view === 'issuetypes' ? [
            view
        ] : $578dbaa7eba68868$var$EMPTY_STACK;
    }
    if ((0, $elGVw.CONNECT_ROUTES_SET).has(route.name) && connectStack) return $578dbaa7eba68868$var$adjustAppStack(connectStack);
    return $578dbaa7eba68868$var$EMPTY_STACK;
};
const $578dbaa7eba68868$var$SettingsMenu = ({ project: project })=>{
    (0, $asnZU.default)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: connectItems, stack: connectStack } = (0, $kFwR2.useProjectSettingsConnectItems)();
    const { data: forgeItems, stack: forgeStack } = (0, $kFwR2.useProjectSettingsForgeItems)((0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS), $578dbaa7eba68868$var$EMPTY_STACK);
    const ecosystemItems = (0, $eUqFw.useMemo)(()=>({
            forge: forgeItems,
            connect: connectItems
        }), [
        forgeItems,
        connectItems
    ]);
    const [stack, setStack] = (0, $eUqFw.useState)(()=>$578dbaa7eba68868$var$calculateStack(route, connectStack, forgeStack));
    (0, $eUqFw.useEffect)(()=>{
        setStack($578dbaa7eba68868$var$calculateStack(route, connectStack, forgeStack));
    }, [
        route,
        connectStack,
        forgeStack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N3rk.default), {
        stack: stack,
        onChange: setStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, project.isSimplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eiI3i.SettingsMenu), {
        stack: stack
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1m2Xn.Settings), {
        ecosystemItems: ecosystemItems
    }))));
};
var $578dbaa7eba68868$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($578dbaa7eba68868$var$SettingsMenu);

});
parcelRegister("eiI3i", function(module, exports) {

$parcel$export(module.exports, "SettingsMenu", () => $c096d087fddf630b$export$1d7840d5cdc861d5);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3SvNA = parcelRequire("3SvNA");

var $1UelU = parcelRequire("1UelU");

var $9kVcv = parcelRequire("9kVcv");

var $cPEpP = parcelRequire("cPEpP");

var $2DHQu = parcelRequire("2DHQu");

var $bMXQ7 = parcelRequire("bMXQ7");

var $b7Flp = parcelRequire("b7Flp");

var $kIUmN = parcelRequire("kIUmN");

var $bS2FN = parcelRequire("bS2FN");

var $cqJw8 = parcelRequire("cqJw8");

var $6OSMM = parcelRequire("6OSMM");

var $f26dB = parcelRequire("f26dB");

var $fz8wa = parcelRequire("fz8wa");

var $8yhrX = parcelRequire("8yhrX");

var $lg3mT = parcelRequire("lg3mT");

var $g7sKB = parcelRequire("g7sKB");

var $eqBMI = parcelRequire("eqBMI");

var $7ugdf = parcelRequire("7ugdf");

var $f4Fss = parcelRequire("f4Fss");
const $c096d087fddf630b$export$a4007dc4843ca7f6 = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
const $c096d087fddf630b$var$DisplayNotificationsOptions = ({ hasCoreAccess: hasCoreAccess, formatMessage: formatMessage, baseSettingsUrl: baseSettingsUrl, projectId: projectId })=>{
    if (!hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    if ((0, $1ybV0.ff)('jlovep-1857-enable-project-email-audit-pages-for-business-projects_tz5uu')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3SvNA.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'notifications'
        },
        menuItemLabel: formatMessage((0, $f4Fss.messages).itemNotifications),
        forceExpand: true,
        submenuId: "core-notifications-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bMXQ7.NotificationsSubMenu), {
        settingsUrl: `${baseSettingsUrl}/notifications`,
        issueLogsUrl: `${baseSettingsUrl}/notifications/issue-logs?projectId=${projectId}`,
        displayLozenge: !(0, $1ybV0.ff)('jlovep-1857-remove-lozenge-for-pea-sidebar-for-business-project_z34bw')
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'notifications'
        },
        href: `${baseSettingsUrl}/notifications`,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $f4Fss.messages).itemNotifications));
};
const $c096d087fddf630b$export$c72f6eaae7b9adff = ({ stack: stack })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: project } = $c096d087fddf630b$export$a4007dc4843ca7f6();
    const { hasCoreAccess: hasCoreAccess } = (0, $fz8wa.useApplicationPermissions)();
    const hasDlpEnabled = (0, $8yhrX.useDlpEntitlement)();
    const isPremiumUserSeat = (0, $f26dB.useIsPremiumUserSeat)();
    const [{ data: connectAppsData }, { fetch: fetchConnectApps }] = (0, $6OSMM.useConnectApps)();
    // to remove on isAppControlsEnabled() cleanup
    (0, $eUqFw.useEffect)(()=>{
        if (project && !connectAppsData) fetchConnectApps(project.key);
    }, [
        connectAppsData,
        fetchConnectApps,
        project
    ]);
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const baseSettingsUrl = (0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.CORE_PROJECT), project.key);
    const showCoreForms = (0, $1ybV0.ff)('proforma-mvp-jwm-project-settings_5edja') && hasCoreAccess;
    const BackMenuItem = {
        href: baseSettingsUrl,
        title: formatMessage((0, $f4Fss.messages).title)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $f4Fss.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'details'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseSettingsUrl}/details`
    }, formatMessage((0, $f4Fss.messages).itemDetails)), hasCoreAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'access'
        },
        href: `${baseSettingsUrl}/access`,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $f4Fss.messages).itemAccess)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c096d087fddf630b$var$DisplayNotificationsOptions, {
        hasCoreAccess: hasCoreAccess,
        formatMessage: formatMessage,
        baseSettingsUrl: baseSettingsUrl,
        projectId: project.id
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseSettingsUrl}/automation`
    }, formatMessage((0, $f4Fss.messages).automation)), hasCoreAccess && (0, $eI5EY.fg)('project_fields_page_for_tmp_-_mvp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'fields'
        },
        href: `${baseSettingsUrl}/fields`,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $f4Fss.messages).itemFieldsNonFinal)), (0, $b7Flp.shouldRenderNesting)(hasCoreAccess, stack, (0, $lg3mT.SECTION_ID).ISSUE_TYPES) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DHQu.NestingMenuItem), {
        analytics: {
            itemId: 'issuetypes'
        },
        href: `${baseSettingsUrl}/issuetypes`,
        id: (0, $lg3mT.SECTION_ID).ISSUE_TYPES,
        overrides: {
            BackMenuItem: BackMenuItem
        },
        title: formatMessage((0, $f4Fss.messages).itemIssueTypes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ugdf.IssueTypes), null)), isPremiumUserSeat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'approvals'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseSettingsUrl}/approvals`
    }, formatMessage((0, $f4Fss.messages).itemApprovals)), showCoreForms && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'proforma-forms'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseSettingsUrl}/forms`
    }, formatMessage((0, $f4Fss.messages).itemAdvancedForms)), (0, $b7Flp.shouldRenderNesting)(hasCoreAccess, stack, 'apps') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3SvNA.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'apps'
        },
        menuItemLabel: formatMessage((0, $eqBMI.messages).apps),
        forceExpand: true,
        submenuId: "nextgen-apps-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g7sKB.EcosystemAppsMenu), null)), hasDlpEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'data-classification'
        },
        href: `${baseSettingsUrl}/data-classifications`,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $f4Fss.messages).dataClassificationNonFinal))));
};
const $c096d087fddf630b$export$1d7840d5cdc861d5 = (props)=>{
    const { data: project } = $c096d087fddf630b$export$a4007dc4843ca7f6();
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return(// to remove on isAppControlsEnabled() cleanup
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OSMM.ConnectAppsContainer), {
        onError: undefined,
        scope: project.key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c096d087fddf630b$export$c72f6eaae7b9adff, props)));
};

});
parcelRegister("3SvNA", function(module, exports) {

$parcel$export(module.exports, "ExpandableSubmenuItem", () => $df73afd5d0671194$export$16ba9a3b96f3ac6d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aqZcy = parcelRequire("aqZcy");

var $5RTd0 = parcelRequire("5RTd0");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $aipcc = parcelRequire("aipcc");

var $1UelU = parcelRequire("1UelU");
const $df73afd5d0671194$var$defaultExpandMenuState = {
    submenuActive: false,
    expanded: false
};
const $df73afd5d0671194$export$e5a6b8291f2460bc = ()=>{
    const getExpandableState = (submenuId)=>{
        const cookieData = (0, $aqZcy.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
        let parsedCookieData = null;
        try {
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            parsedCookieData = JSON.parse(cookieData);
        } catch  {
            // Rather than throw an error - just set the default state
            parsedCookieData = $df73afd5d0671194$var$defaultExpandMenuState;
        }
        return parsedCookieData;
    };
    const setExpandedState = (submenuId, newExpandedState)=>{
        if (submenuId != null) (0, $5RTd0.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newExpandedState));
    };
    return {
        getExpandableState: getExpandableState,
        setExpandedState: setExpandedState
    };
};
const $df73afd5d0671194$export$16ba9a3b96f3ac6d = ({ children: children, analytics: analytics, iconBefore: iconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null), menuItemLabel: menuItemLabel, expandButtonLabel: expandButtonLabel = 'expand', href: href, useButtonLink: useButtonLink = false, forceExpand: forceExpand = false, noListStyle: noListStyle = false, submenuId: submenuId = '', testId: testId = '' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { getExpandableState: getExpandableState, setExpandedState: setExpandedState } = $df73afd5d0671194$export$e5a6b8291f2460bc();
    const [subMenuActive, setSubMenuActive] = (0, $eUqFw.useState)(false);
    const [currentCookieData] = (0, $eUqFw.useState)(getExpandableState(submenuId));
    const expandButtonId = menuItemLabel.replace(/ /g, '-').toLowerCase();
    const [expanded, setExpanded] = (0, $eUqFw.useState)(currentCookieData?.expanded || (0, $eI5EY.fg)('jsm_simplified_project_settings_navigation') ? forceExpand : false);
    const expandableMenuItemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, $eI5EY.fg)('jsm_simplified_project_settings_navigation') && forceExpand) setExpanded(true);
    }, [
        forceExpand
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (currentCookieData?.expanded) {
            setExpanded(currentCookieData.expanded);
            setSubMenuActive(currentCookieData.submenuActive);
        }
    }, [
        currentCookieData
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (submenuId != null) setExpandedState(submenuId, {
            submenuActive: false,
            expanded: !expanded
        });
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'expandButton changed', 'projectSettings', {
            expandMenuId: analytics?.itemId,
            expanded: !expanded
        });
        setExpanded(!expanded);
        requestAnimationFrame(()=>{
            expandableMenuItemRef?.current?.focus();
        });
    }, [
        analytics,
        createAnalyticsEvent,
        expanded,
        setExpandedState,
        submenuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df73afd5d0671194$var$ExpandableSubmenuWrapper, {
        isExpanded: subMenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: analytics,
        href: href,
        useButtonLink: useButtonLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aipcc.ExpandButton), {
            id: expandButtonId,
            label: expandButtonLabel,
            isActive: true,
            isExpanded: expanded,
            size: "medium"
        }), iconBefore),
        onClick: onClick,
        "data-test-id": testId,
        ref: expandableMenuItemRef,
        tabIndex: -1
    }, menuItemLabel), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df73afd5d0671194$var$ExpandableSubmenuItemWrapper, {
        noListStyle: noListStyle
    }, children));
};
// Buttons inside the Expandable Menu indicate sub-expandable menus,
// these are styled differently that top level expandable menu items so the aligment look ok
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df73afd5d0671194$var$ExpandableSubmenuWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_hstcidpf _11lvidpf _44p6idpf _l7mvidpf _1gid5cnj _1t1q5cnj _qmbb5cnj _130y5cnj _cyds5cnj _wpy85cnj _da5j5cnj _14p45cnj _r3xj5cnj _1p1m5cnj _12kz5cnj _67om5cnj _1gw75cnj _1rnb5cnj _vxqc5cnj _1ve95cnj _1qslpxbi _16khpxbi _ek7jpxbi _1mdfpxbi _1mp8pxbi _40k9pxbi _15e4pxbi _3hrxpxbi _erbmpxbi _5vm1pxbi _1e43pxbi _f4s1pxbi _1fabpxbi _da52pxbi _1aolpxbi _qdxopxbi _zyjmqslr _4rtsqslr _1bb1qslr _gis0qslr _19ixqslr _qbnnqslr _ii9vqslr _176zqslr _qylaqslr _1xqvqslr _uzbcqslr _1ifwqslr _i6ubqslr _1u1wqslr _1ks5qslr _329dqslr _fe5pidpf _kywyt94y",
            __cmplp.isExpanded && "_4t3i1osq",
            __cmplp.className
        ])
    });
});
const $df73afd5d0671194$var$ExpandableSubmenuItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _18u0r5cr _ujmh1osq _1nx0u2gc _hstcidpf _fgl3wgn3 _fl8b12x7 _9b588aae _14tk72c6 _1u1didpf _1thcforw _19as19el _kk3x126e _14o4107n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aipcc", function(module, exports) {

$parcel$export(module.exports, "ExpandButton", () => $654b7872966b947d$export$5663c8f5aeb8c1c4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $c6CvK = parcelRequire("c6CvK");

var $fCmfi = parcelRequire("fCmfi");

var $b5IAe = parcelRequire("b5IAe");


var $8rQuz = parcelRequire("8rQuz");
const $654b7872966b947d$export$5663c8f5aeb8c1c4 = ({ id: id, label: label, isActive: isActive, isExpanded: isExpanded, onClick: onClick = ()=>null, size: size, isVisible: isVisible = true, removeCaret: removeCaret = false, tabIndex: // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'number'.
tabIndex = null })=>{
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    const ChevronOld = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))) : (0, (/*@__PURE__*/$parcel$interopDefault($dtaN9)));
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($c6CvK))) : (0, (/*@__PURE__*/$parcel$interopDefault($fCmfi)));
    const onKeydown = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    (event)=>{
        // Space bar or enter (Button A11y rules) triggers click of expand button
        if ([
            13,
            32
        ].includes(event.keyCode)) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    const chevronElement = (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.075",
        paddingBlockStart: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChevronIcon, {
        testId: `sidebar.expand-button.container-${id}`,
        color: "var(--ds-icon, #44546F)",
        label: label
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChevronOld, {
        testId: `sidebar.expand-button.container-${id}`,
        primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        label: label,
        size: size
    });
    // Performance optimisation - only render interactive button upon proxy interactions
    if (!isActive) return chevronElement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($654b7872966b947d$var$Container, {
        role: "button",
        "aria-expanded": isExpanded,
        onClick: onClick,
        onKeyDown: onKeydown,
        isVisible: isVisible,
        removeCaret: removeCaret,
        size: size,
        tabIndex: tabIndex
    }, chevronElement);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $654b7872966b947d$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, removeCaret: removeCaret, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _bfhk18uv _80omtlke _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _1spjglyw _1ejj12vo _19lvkb7n",
            __cmplp.size === 'medium' ? "_154imyb0" : "_154iidpf",
            __cmplp.isVisible ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.removeCaret ? "_1e0cglyw" : "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("bMXQ7", function(module, exports) {

$parcel$export(module.exports, "NotificationsSubMenu", () => $b13d7ac09c4e0728$export$f80567459a5e304a);

var $eUqFw = parcelRequire("eUqFw");

var $55pTl = parcelRequire("55pTl");

var $ffiyv = parcelRequire("ffiyv");

var $ltfxy = parcelRequire("ltfxy");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $gLn5u = parcelRequire("gLn5u");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $4ksts = parcelRequire("4ksts");

var $1UelU = parcelRequire("1UelU");

var $cPEpP = parcelRequire("cPEpP");

var $kIUmN = parcelRequire("kIUmN");

var $bS2FN = parcelRequire("bS2FN");

var $fceqQ = parcelRequire("fceqQ");
const $b13d7ac09c4e0728$export$51b1383ef8844a7 = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
const $b13d7ac09c4e0728$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY = 'issue-email-log-spotlight';
const $b13d7ac09c4e0728$export$f80567459a5e304a = ({ settingsUrl: settingsUrl, issueLogsUrl: issueLogsUrl, displayLozenge: displayLozenge = false })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { data: project, loading: projectLoading } = $b13d7ac09c4e0728$export$51b1383ef8844a7();
    if (projectLoading || !project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'notifications-settings'
        },
        href: settingsUrl,
        ref: /*#__PURE__*/ (0, $eUqFw.createRef)(),
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $fceqQ.messages).itemSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: $b13d7ac09c4e0728$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'notifications-issue-logs'
        },
        href: issueLogsUrl,
        ref: /*#__PURE__*/ (0, $eUqFw.createRef)(),
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b13d7ac09c4e0728$var$issueLogsContainerStyles
    }, (0, $1ybV0.ff)('platform.jlove-pulsar.jlovep-1440-issue-email-audit-ui-changes') ? formatMessage((0, $fceqQ.messages).itemProjectEmailAuditLogs) : formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fceqQ.messages).itemIssueLogsIssueTermRefresh : (0, $fceqQ.messages).itemIssueLogs), displayLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "new"
    }, formatMessage((0, $fceqQ.messages).newLozenge)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
        engagementId: $b13d7ac09c4e0728$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, content);
};
const $b13d7ac09c4e0728$var$issueLogsContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'space-between'
});

});
parcelRegister("fceqQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3aa19ea9e2fd6aa7$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $3aa19ea9e2fd6aa7$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    itemSettings: {
        "id": "spa-apps-sidebar-common.notifications-sub-menu.item-settings",
        "defaultMessage": "Settings"
    },
    itemProjectEmailAuditLogs: {
        "id": "spa-apps-sidebar-common.notifications-sub-menu.item-project-email-audit-logs",
        "defaultMessage": "Project email audit"
    },
    itemIssueLogs: {
        "id": "spa-apps-sidebar-common.notifications-sub-menu.item-issue-logs",
        "defaultMessage": "Issue email audit"
    },
    newLozenge: {
        "id": "spa-apps-sidebar-common.notifications-sub-menu.new-lozenge",
        "defaultMessage": "New"
    },
    itemIssueLogsIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.notifications-sub-menu.item-issue-logs-issue-term-refresh",
        "defaultMessage": "Issue email audit"
    }
});

});


parcelRegister("6OSMM", function(module, exports) {

$parcel$export(module.exports, "ConnectAppsSubscriber", () => $c63e072257e89081$export$2646f920b0e2e4de);
$parcel$export(module.exports, "useConnectApps", () => $c63e072257e89081$export$4864478dcab77643);
$parcel$export(module.exports, "ConnectAppsContainer", () => $c63e072257e89081$export$ac845603c8c91acd);

var $WBLbN = parcelRequire("WBLbN");

var $687k4 = parcelRequire("687k4");
const $c63e072257e89081$export$2646f920b0e2e4de = (0, $WBLbN.createSubscriber)((0, $687k4.default), {
    displayName: 'ConnectAppsSubscriber'
});
const $c63e072257e89081$export$4864478dcab77643 = (0, $WBLbN.createHook)((0, $687k4.default));
const $c63e072257e89081$export$ac845603c8c91acd = (0, $WBLbN.createContainer)((0, $687k4.default));

});
parcelRegister("687k4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c48d4b6f412e815$export$2e2bcd8739ae039);

var $WBLbN = parcelRequire("WBLbN");

var $h3kcT = parcelRequire("h3kcT");
const $6c48d4b6f412e815$export$d4c72bab9d6cc13a = {
    data: null,
    loading: false,
    error: null,
    hasFirstError: false
};
var $6c48d4b6f412e815$export$2e2bcd8739ae039 = (0, $WBLbN.createStore)({
    name: 'connect-apps',
    initialState: $6c48d4b6f412e815$export$d4c72bab9d6cc13a,
    actions: $h3kcT.actions
});

});
parcelRegister("h3kcT", function(module, exports) {

$parcel$export(module.exports, "actions", () => $fda0cfe4b5bc8c12$export$e324594224ef24da);

var $cxnOv = parcelRequire("cxnOv");
const $fda0cfe4b5bc8c12$export$e324594224ef24da = {
    fetch: $cxnOv.default
};

});
parcelRegister("cxnOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $128f0df4723431a5$export$2e2bcd8739ae039);

var $kjsaR = parcelRequire("kjsaR");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$128f0df4723431a5$export$2e2bcd8739ae039 = (projectKey)=>async ({ setState: setState, getState: getState }, { onError: onError })=>{
        const currentState = getState();
        if (!projectKey || currentState.loading) return;
        setState({
            loading: true,
            error: null
        });
        try {
            const data = await (0, $kjsaR.default)(projectKey);
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const { hasFirstError: hasFirstError, data: data } = getState();
            // It's the first error if it does not already have a first error and there is no data currently in state
            const isFirstError = !hasFirstError && data === null;
            setState({
                error: err,
                loading: false,
                hasFirstError: hasFirstError || isFirstError
            });
            if (onError) onError(isFirstError);
        }
    };

});
parcelRegister("kjsaR", function(module, exports) {

$parcel$export(module.exports, "default", () => $597ccf12213f1d63$export$2e2bcd8739ae039);

var $2OdyW = parcelRequire("2OdyW");

var $6ZTsa = parcelRequire("6ZTsa");

var $ft7kU = parcelRequire("ft7kU");

var $6Dpx1 = parcelRequire("6Dpx1");
const $597ccf12213f1d63$export$43bc37ac3360968f = (projectKey)=>`/rest/internal/2/connectprojectconfig/${projectKey}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$597ccf12213f1d63$export$2e2bcd8739ae039 = (projectKey)=>{
    const fetchPromise = (0, $ft7kU.famaCatchAndLogFetchError)((0, $2OdyW.default)($597ccf12213f1d63$export$43bc37ac3360968f(projectKey)), (0, $6Dpx1.PACKAGE_NAME), (0, $6ZTsa.toErrorId)('getConnectApps'), (0, $6ZTsa.toErrorMessage)('Failed to fetch connect apps for a project'));
    return fetchPromise.then((response)=>response.map((app)=>{
            // Server returns JSON as a string inside JSON as a string inside JSON as a string because reasons.
            // Let's parse it here
            const options = JSON.parse(app.iframe.options);
            const myApp = {
                title: app.title,
                id: options.uniqueKey,
                connectIframeProps: {
                    addon_key: app.iframe.addonKey,
                    key: app.iframe.moduleKey,
                    url: options.url,
                    options: {
                        ...options,
                        productContext: JSON.parse(options.productCtx),
                        structuredContext: JSON.parse(options.structuredContext),
                        user: {
                            uid: options.uid,
                            ukey: options.ukey,
                            timeZone: options.timeZone
                        }
                    }
                }
            };
            return myApp;
        }));
};

});
parcelRegister("ft7kU", function(module, exports) {

$parcel$export(module.exports, "famaCatchAndLogFetchError", () => $9e0e185518348035$export$c3948fffb56ff7bb);
$parcel$export(module.exports, "default", () => $9e0e185518348035$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $7byHA = parcelRequire("7byHA");

var $avawr = parcelRequire("avawr");
const $9e0e185518348035$var$HTTP_LOCATION = 'project-settings-apps.http.catch-and-log-fetch-error';
const $9e0e185518348035$var$getStatusCodeGroup = (error)=>{
    if (error instanceof (0, $7byHA.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode >= 100 && statusCode <= 199) return '1xx';
        if (statusCode >= 300 && statusCode <= 399) return '3xx';
        if (statusCode >= 400 && statusCode <= 499) return '4xx';
        if (statusCode >= 500 && statusCode <= 599) return '5xx';
    }
    if (error instanceof (0, $7byHA.ValidationError)) return '4xx';
    return 'unknown';
};
/**
 * All fetch calls made in project-settings should be wrapped by this method to ensure HTTP related errors can be
 * separated from JS errors in Splunk. The promise provided to this method MUST NOT perform any logic beside making
 * the fetch call (i.e. transforming responses). The caught error will be rethrown so any downstream methods can perform
 * their own error handling.
 *
 * @param promise Promise to wrap so any errors are caught and logged.
 * @param message Message to include in the log. This should provide context as to what action the user was taking.
 */ const $9e0e185518348035$var$catchAndLogFetchError = (promise, message)=>promise.catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData($9e0e185518348035$var$HTTP_LOCATION, message, error);
        throw error;
    });
const $9e0e185518348035$export$c3948fffb56ff7bb = (promise, packageName, errorId, message)=>promise.catch((error)=>{
        const statusCodeGroup = $9e0e185518348035$var$getStatusCodeGroup(error);
        (0, $avawr.logError)(packageName, errorId, message, error, {
            http: true,
            statusCodeGroup: statusCodeGroup
        });
        throw error;
    });
var $9e0e185518348035$export$2e2bcd8739ae039 = $9e0e185518348035$var$catchAndLogFetchError;

});

parcelRegister("6Dpx1", function(module, exports) {

$parcel$export(module.exports, "APP_ID", () => $f767aa89c33c344c$export$d76071d5de2774fc);
$parcel$export(module.exports, "PACKAGE_NAME", () => $f767aa89c33c344c$export$b8b9d90f9e5bd72b);

var $6bYiA = parcelRequire("6bYiA");
const $f767aa89c33c344c$export$d76071d5de2774fc = 'project-settings/connect-apps';
const $f767aa89c33c344c$export$b8b9d90f9e5bd72b = (0, $6bYiA.toPackageName)('jiraProjectSettingsAppsConnectApps');

});






parcelRegister("8yhrX", function(module, exports) {

$parcel$export(module.exports, "useDlpEntitlement", () => $e16f91d64a0cd31a$export$4472465702535e7);

var $gd0Sp = parcelRequire("gd0Sp");
const $e16f91d64a0cd31a$export$4472465702535e7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.hasDlpEnabled || false;
};

});

parcelRegister("g7sKB", function(module, exports) {

$parcel$export(module.exports, "EcosystemAppsMenu", () => $bc220bff2b37181b$export$e583660e6ee09caf);

var $eUqFw = parcelRequire("eUqFw");

var $gLn5u = parcelRequire("gLn5u");

var $7ZZxN = parcelRequire("7ZZxN");

var $1boRu = parcelRequire("1boRu");

var $7Xoh5 = parcelRequire("7Xoh5");

var $2Rqjr = parcelRequire("2Rqjr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $cPEpP = parcelRequire("cPEpP");

var $bS2FN = parcelRequire("bS2FN");

var $l3JmK = parcelRequire("l3JmK");

var $j65a5 = parcelRequire("j65a5");

var $cqJw8 = parcelRequire("cqJw8");

var $6OSMM = parcelRequire("6OSMM");

var $lg3mT = parcelRequire("lg3mT");

var $eqBMI = parcelRequire("eqBMI");
const $bc220bff2b37181b$export$c62cfdba33f43c7e = ({ baseSettingsUrl: baseSettingsUrl = '', projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ data: connectAppsData, loading: connectLoading }] = (0, $6OSMM.useConnectApps)();
    const { data: forgeApps, loading: forgeLoading } = (0, $j65a5.useProjectSettingsForgeAppsForMenu)();
    const filteredConnectAppsData = (0, $eUqFw.useMemo)(()=>connectAppsData?.filter((app)=>app?.connectIframeProps?.addon_key !== (0, $lg3mT.JIRA_AUTOMATION_ADDON_KEY)), [
        connectAppsData
    ]);
    const sortedApps = (0, $eUqFw.useMemo)(()=>[
            ...(forgeApps || []).map((app)=>({
                    type: 'forge',
                    name: app.name,
                    app: app
                })),
            ...(filteredConnectAppsData || []).map((app)=>({
                    type: 'connect',
                    name: app.title,
                    app: app
                }))
        ].sort((a, b)=>a.name.localeCompare(b.name)), [
        forgeApps,
        filteredConnectAppsData
    ]);
    const overrides = (0, $eUqFw.useMemo)(()=>({
            BackMenuItem: {
                href: `/jira/core/projects/${projectKey}/settings`,
                title: formatMessage((0, $eqBMI.messages).backItem),
                onClick: (ev)=>ev.preventDefault()
            }
        }), [
        projectKey,
        formatMessage
    ]);
    if (connectLoading || forgeLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'app-fields'
        },
        href: `${baseSettingsUrl}/apps/app-fields`,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $eqBMI.messages).appFields)), sortedApps.map((ecosystemItem)=>{
        const { type: type, app: app } = ecosystemItem;
        if (type === 'forge') {
            const item = app;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3JmK.ForgeItem), {
                key: item.id,
                ...item,
                showIcon: false,
                overrides: overrides
            });
        }
        const connectApp = app;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
            analytics: {
                itemId: connectApp.id
            },
            key: connectApp.id,
            href: `${baseSettingsUrl}/apps/${connectApp.id}`,
            selectedOn: (0, $bS2FN.matchUrlPathname)()
        }, connectApp.title);
    }), forgeApps?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
        }
    }) : null);
};
const $bc220bff2b37181b$export$e583660e6ee09caf = (props)=>{
    const { children: children } = props;
    const { data: project } = (0, $cPEpP.useProject)();
    const projectKey = project && project.key || ''; // flow
    const baseSettingsUrl = (0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.CORE_PROJECT), projectKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Xoh5.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OSMM.ConnectAppsContainer), {
        onError: undefined,
        scope: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc220bff2b37181b$export$c62cfdba33f43c7e, {
        baseSettingsUrl: baseSettingsUrl,
        projectKey: projectKey
    }), children != null && children));
};

});
parcelRegister("7Xoh5", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $8ad441f9c3783975$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $8ad441f9c3783975$export$e1a79e3d472c925a);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");
const $8ad441f9c3783975$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $8ad441f9c3783975$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE),
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("eqBMI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3a385b1f82c0fdb0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $3a385b1f82c0fdb0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    apps: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.apps",
        "defaultMessage": "Apps"
    },
    appFields: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.app-fields",
        "defaultMessage": "App fields"
    },
    backItem: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.back-item",
        "defaultMessage": "Back"
    }
});

});


parcelRegister("7ugdf", function(module, exports) {

$parcel$export(module.exports, "IssueTypes", () => $56d96fd9dd5cb0bb$export$15fef796fc6acc30);

var $eUqFw = parcelRequire("eUqFw");

var $gO9Xw = parcelRequire("gO9Xw");

var $7eyVf = parcelRequire("7eyVf");

var $2eG9N = parcelRequire("2eG9N");

var $7ZZxN = parcelRequire("7ZZxN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $9kVcv = parcelRequire("9kVcv");

var $cPEpP = parcelRequire("cPEpP");

var $1BKP5 = parcelRequire("1BKP5");

var $7Fu43 = parcelRequire("7Fu43");

var $kIUmN = parcelRequire("kIUmN");

var $4UslI = parcelRequire("4UslI");

var $cqJw8 = parcelRequire("cqJw8");

var $hnvmL = parcelRequire("hnvmL");

var $ecloj = parcelRequire("ecloj");
const $56d96fd9dd5cb0bb$export$a4007dc4843ca7f6 = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
const $56d96fd9dd5cb0bb$export$15fef796fc6acc30 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ asyncState: asyncState, topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel, addIssueTypeTooltip: addIssueTypeTooltip, isAddIssueTypeDisabled: isAddIssueTypeDisabled }] = (0, $hnvmL.useIssueTypesNavigationItems)();
    const [, addIssueTypesContextActions] = (0, $4UslI.useAddIssueTypeContext)();
    const { data: project } = $56d96fd9dd5cb0bb$export$a4007dc4843ca7f6();
    let baseSettingsUrl = '';
    if (project !== null) baseSettingsUrl = (0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.CORE_PROJECT), project.key);
    const hasAnyIssueTypes = topLevel.length > 0 || baseLevel.length > 0 || bottomLevel.length > 0;
    const isReady = asyncState === 'SUCCESS' || hasAnyIssueTypes;
    if (!project || !isReady) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $ecloj.default).issueTypes)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1BKP5.IssueTypesGroup), {
        baseSettingsUrl: baseSettingsUrl,
        hasSeparator: false,
        navigationItems: topLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1BKP5.IssueTypesGroup), {
        baseSettingsUrl: baseSettingsUrl,
        hasSeparator: true,
        navigationItems: baseLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1BKP5.IssueTypesGroup), {
        baseSettingsUrl: baseSettingsUrl,
        hasSeparator: true,
        navigationItems: bottomLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, (()=>{
        const addItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
            analytics: {
                itemId: 'add-issue-type'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                label: formatMessage((0, $ecloj.default).addIssueType)
            }),
            isDisabled: isAddIssueTypeDisabled,
            onClick: isAddIssueTypeDisabled ? undefined : addIssueTypesContextActions.openAddIssueTypeModal
        }, formatMessage((0, $ecloj.default).addIssueType));
        return addIssueTypeTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: addIssueTypeTooltip
        }, addItem) : addItem;
    })()));
};

});
parcelRegister("gO9Xw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3c90a7e02e55e7e$var$_react = $c3c90a7e02e55e7e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $c3c90a7e02e55e7e$var$_add = $c3c90a7e02e55e7e$var$_interopRequireDefault((parcelRequire("cS2gQ")));
function $c3c90a7e02e55e7e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c3c90a7e02e55e7e$var$AddIcon = (props)=>/*#__PURE__*/ $c3c90a7e02e55e7e$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $c3c90a7e02e55e7e$var$_add.default
    }));
$c3c90a7e02e55e7e$var$AddIcon.displayName = 'AddIcon';
var $c3c90a7e02e55e7e$var$_default = module.exports.default = $c3c90a7e02e55e7e$var$AddIcon;

});

parcelRegister("1BKP5", function(module, exports) {

$parcel$export(module.exports, "IssueTypesGroup", () => $21c5f892146ad62a$export$5bc39a07c26525ad);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $7eyVf = parcelRequire("7eyVf");

var $1UelU = parcelRequire("1UelU");

var $bS2FN = parcelRequire("bS2FN");
const $21c5f892146ad62a$export$5bc39a07c26525ad = ({ MenuItem: MenuItem = (0, $1UelU.MenuItem), Section: Section = (0, $7eyVf.default), baseSettingsUrl: baseSettingsUrl, hasSeparator: hasSeparator, navigationItems: navigationItems })=>{
    if (!navigationItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        hasSeparator: hasSeparator
    }, navigationItems.map((issueType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
            key: String(issueType.id),
            analytics: {
                itemId: String(issueType.id)
            },
            selectedOn: (0, $bS2FN.matchUrlPathname)(),
            href: `${baseSettingsUrl}/issuetypes/${issueType.id}`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                appearance: "square",
                size: "small",
                src: issueType.icon,
                borderColor: "transparent"
            })
        }, issueType.name)));
};

});

parcelRegister("4UslI", function(module, exports) {

$parcel$export(module.exports, "useAddIssueTypeContext", () => $6b794ec5bab5ffc3$export$40493c3e9059110a);

var $WBLbN = parcelRequire("WBLbN");
const $6b794ec5bab5ffc3$var$initialState = {
    isActive: false
};
const $6b794ec5bab5ffc3$var$openAddIssueTypeModal = ()=>({ setState: setState })=>{
        setState({
            isActive: true
        });
    };
const $6b794ec5bab5ffc3$var$closeAddIssueTypeModal = ()=>({ setState: setState })=>{
        setState({
            isActive: false
        });
    };
const $6b794ec5bab5ffc3$var$actions = {
    openAddIssueTypeModal: $6b794ec5bab5ffc3$var$openAddIssueTypeModal,
    closeAddIssueTypeModal: $6b794ec5bab5ffc3$var$closeAddIssueTypeModal
};
const $6b794ec5bab5ffc3$var$STORE_NAME = 'jira-project-settings-apps-add-issue-type-context';
const $6b794ec5bab5ffc3$var$Store = (0, $WBLbN.createStore)({
    name: $6b794ec5bab5ffc3$var$STORE_NAME,
    initialState: $6b794ec5bab5ffc3$var$initialState,
    actions: $6b794ec5bab5ffc3$var$actions
});
const $6b794ec5bab5ffc3$export$40493c3e9059110a = (0, $WBLbN.createHook)($6b794ec5bab5ffc3$var$Store);
const $6b794ec5bab5ffc3$export$a0f296f941567e3d = (0, $WBLbN.createSubscriber)($6b794ec5bab5ffc3$var$Store);
// instead of utilisling defaultRegistry, we will grab it from the render tree to have this singleton
// call useStoreReference in render tree before accessing the store instance
// https://github.com/atlassian/react-sweet-state/issues/139#issuecomment-890439621
const $6b794ec5bab5ffc3$var$storeInstance = {
    state: $6b794ec5bab5ffc3$var$initialState,
    actions: null
};
const $6b794ec5bab5ffc3$export$f1a20ca23c90093e = ()=>{
    const [issueTypeContextState, issueTypeContextActions] = $6b794ec5bab5ffc3$export$40493c3e9059110a();
    $6b794ec5bab5ffc3$var$storeInstance.state = issueTypeContextState;
    $6b794ec5bab5ffc3$var$storeInstance.actions = issueTypeContextActions;
    return null;
};
const $6b794ec5bab5ffc3$export$605f542240ea8e19 = ()=>$6b794ec5bab5ffc3$var$storeInstance.actions;

});

parcelRegister("hnvmL", function(module, exports) {

$parcel$export(module.exports, "useIssueTypesNavigationItems", () => $50b7672a8696556a$export$8facf5695da03580);
$parcel$export(module.exports, "useIssueTypesNavigationItemsActions", () => $50b7672a8696556a$export$502d4d04702890ce);

var $71ZqG = parcelRequire("71ZqG");

var $WBLbN = parcelRequire("WBLbN");

var $jEt1i = parcelRequire("jEt1i");

var $kcW9s = parcelRequire("kcW9s");
const $50b7672a8696556a$export$d4c72bab9d6cc13a = {
    projectId: null,
    asyncState: (0, $71ZqG.INIT),
    data: {
        limitPerProject: null,
        issueTypes: []
    },
    addIssueTypeTooltipMessage: ''
};
const $50b7672a8696556a$var$load = (projectId, productFeatures, intl)=>async ({ setState: setState, getState: getState })=>{
        try {
            const currentState = getState();
            if (currentState.asyncState === (0, $71ZqG.LOADING) && projectId === currentState.projectId) return;
            setState({
                ...projectId === currentState.projectId ? currentState : $50b7672a8696556a$export$d4c72bab9d6cc13a,
                projectId: projectId,
                asyncState: (0, $71ZqG.LOADING)
            });
            const result = await (0, $jEt1i.queryIssueTypesNavigationItems)(projectId, productFeatures);
            if (getState().projectId !== projectId) return;
            const { limitPerProject: limitPerProject, data: data } = result.data.simplifiedProject.issueTypeCollection;
            setState({
                projectId: projectId,
                asyncState: (0, $71ZqG.SUCCESS),
                data: {
                    limitPerProject: limitPerProject,
                    issueTypes: data
                },
                addIssueTypeTooltipMessage: intl.formatMessage(productFeatures.navigationMessages.addIssueTypeDisabledTooltip, {
                    limit: limitPerProject
                })
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                asyncState: (0, $71ZqG.FAILURE)
            });
        }
    };
const $50b7672a8696556a$var$remove = (issueTypeId)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.asyncState !== (0, $71ZqG.SUCCESS)) return;
        setState({
            ...state,
            data: {
                ...state.data,
                issueTypes: state.data.issueTypes.filter(({ id: id })=>id !== issueTypeId)
            }
        });
    };
const $50b7672a8696556a$var$update = (layoutOwners)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.asyncState !== (0, $71ZqG.SUCCESS)) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newDataById = {};
        for(let i = 0; i < layoutOwners.length; i += 1){
            const { data: data } = layoutOwners[i];
            newDataById[data.id] = {
                name: data.name,
                avatarId: data.avatarId,
                icon: data.iconUrl
            };
        }
        const issueTypes = state.data.issueTypes.map((issueType)=>{
            if (!newDataById[issueType.id]) return issueType;
            const { name: name, avatarId: avatarId } = newDataById[issueType.id];
            return {
                ...issueType,
                name: name,
                avatarId: avatarId || issueType.avatarId
            };
        });
        setState({
            ...state,
            data: {
                ...state.data,
                issueTypes: issueTypes
            }
        });
    };
const $50b7672a8696556a$export$e324594224ef24da = {
    load: $50b7672a8696556a$var$load,
    remove: $50b7672a8696556a$var$remove,
    update: $50b7672a8696556a$var$update
};
const $50b7672a8696556a$export$94d3eea6047656ad = ({ projectId: projectId, asyncState: asyncState, data: data, addIssueTypeTooltipMessage: addIssueTypeTooltipMessage })=>{
    const { issueTypes: issueTypes, limitPerProject: limitPerProject } = data;
    const { topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel } = (0, $kcW9s.getIssueTypeNavigationItemsLevels)(issueTypes);
    const isIssueTypeLimitReached = (0, $kcW9s.getIsIssueTypeLimitReached)(limitPerProject, issueTypes.length);
    const addIssueTypeTooltip = isIssueTypeLimitReached ? addIssueTypeTooltipMessage : '';
    return {
        asyncState: asyncState,
        projectId: projectId,
        isAddIssueTypeDisabled: asyncState !== (0, $71ZqG.SUCCESS) || isIssueTypeLimitReached,
        addIssueTypeTooltip: addIssueTypeTooltip,
        topLevel: topLevel,
        baseLevel: baseLevel,
        bottomLevel: bottomLevel
    };
};
// Made it const for visibility. Apparently, store name must be unique or it breaks the library
const $50b7672a8696556a$var$STORE_NAME = 'issue-type-page-navigation-items-new';
const $50b7672a8696556a$var$Store = (0, $WBLbN.createStore)({
    name: $50b7672a8696556a$var$STORE_NAME,
    initialState: $50b7672a8696556a$export$d4c72bab9d6cc13a,
    actions: $50b7672a8696556a$export$e324594224ef24da
});
const $50b7672a8696556a$export$8facf5695da03580 = (0, $WBLbN.createHook)($50b7672a8696556a$var$Store, {
    selector: $50b7672a8696556a$export$94d3eea6047656ad
});
// @ts-expect-error - TS2322 - Type 'HookActionsFunction<BoundActions<State, { readonly load: (projectId: number, productFeatures: Readonly<{ issueTypeHierarchy: boolean; addIssueTypeMessages: AddIssueTypeMessages | undefined; issueTypeTemplates: TemplateIntl[]; ... 43 more ...; countOfDisabledAppsEnabled: boolean; }>, intl: IntlShape) => Action<...>...' is not assignable to type 'HookActionsFunction<{ readonly load: (projectId: number, productFeatures: Readonly<{ issueTypeHierarchy: boolean; addIssueTypeMessages: AddIssueTypeMessages | undefined; issueTypeTemplates: TemplateIntl[]; ... 43 more ...; countOfDisabledAppsEnabled: boolean; }>, intl: IntlShape) => Action<...>; readonly remove: (...'.
const $50b7672a8696556a$export$502d4d04702890ce = (0, $WBLbN.createActionsHook)($50b7672a8696556a$var$Store);
const $50b7672a8696556a$export$313f907c8e339d1b = (0, $WBLbN.createSubscriber)($50b7672a8696556a$var$Store, {
    selector: $50b7672a8696556a$export$94d3eea6047656ad
});

});
parcelRegister("71ZqG", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $1d604ab09c97d0b8$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "INACTIVE_LIST", () => $1d604ab09c97d0b8$export$d7fec05af6b928f7);
$parcel$export(module.exports, "FIELD_TYPE_LIST", () => $1d604ab09c97d0b8$export$de26d0d1ef96d0ed);
$parcel$export(module.exports, "DELETE_DROPPABLE_ID", () => $1d604ab09c97d0b8$export$a155cb9d82798d65);
$parcel$export(module.exports, "IGNORE_CLICK_OUTSIDE_CLASS_NAME", () => $1d604ab09c97d0b8$export$8191ccc97ff9885c);
$parcel$export(module.exports, "DO_NOT_ANIMATE_WIDTH", () => $1d604ab09c97d0b8$export$c77ecc59e9e91e60);
$parcel$export(module.exports, "JSD_FIELD_HELPTEXT", () => $1d604ab09c97d0b8$export$663476c4863d5014);
$parcel$export(module.exports, "ID_REQUEST_OWNER_PROPERTY_KEY", () => $1d604ab09c97d0b8$export$9be9f574874c9a2f);
$parcel$export(module.exports, "NAME_REQUEST_OWNER_PROPERTY_KEY", () => $1d604ab09c97d0b8$export$b320c6b352dcb101);
$parcel$export(module.exports, "SUGGESTED_GROUP", () => $1d604ab09c97d0b8$export$e66b34cc29932bbf);
$parcel$export(module.exports, "ASSETS_GROUP", () => $1d604ab09c97d0b8$export$c87c7df18254969e);
$parcel$export(module.exports, "DATES_GROUP", () => $1d604ab09c97d0b8$export$fa8c310a8ac47d47);
$parcel$export(module.exports, "LABELS_GROUP", () => $1d604ab09c97d0b8$export$5b2dd1b457037e13);
$parcel$export(module.exports, "NUMBER_GROUP", () => $1d604ab09c97d0b8$export$2c2f344ca2ba1c03);
$parcel$export(module.exports, "PEOPLE_GROUP", () => $1d604ab09c97d0b8$export$1441c9d524a8c0f2);
$parcel$export(module.exports, "SELECT_GROUP", () => $1d604ab09c97d0b8$export$d3e4788fc90e5f8f);
$parcel$export(module.exports, "SYSTEM_GROUP", () => $1d604ab09c97d0b8$export$724e0d23ac7e9b03);
$parcel$export(module.exports, "TEXT_GROUP", () => $1d604ab09c97d0b8$export$bd76d204d15f4c6a);
$parcel$export(module.exports, "VERSION_GROUP", () => $1d604ab09c97d0b8$export$33d3fa5e989ba460);
$parcel$export(module.exports, "ADVANCED_GROUP", () => $1d604ab09c97d0b8$export$c58a10f3e3456974);
$parcel$export(module.exports, "OTHER_GROUP", () => $1d604ab09c97d0b8$export$591e195d295fd27e);
$parcel$export(module.exports, "RESTRICTED_GROUP", () => $1d604ab09c97d0b8$export$14785d7afcf55619);
$parcel$export(module.exports, "AI_SUGGESTED_GROUP", () => $1d604ab09c97d0b8$export$df593ebd3e7c9c2d);
$parcel$export(module.exports, "INIT", () => $1d604ab09c97d0b8$export$d788bc089976c004);
$parcel$export(module.exports, "LOADING", () => $1d604ab09c97d0b8$export$26d55645375ca9a);
$parcel$export(module.exports, "SUCCESS", () => $1d604ab09c97d0b8$export$638cc6e36b2a737a);
$parcel$export(module.exports, "FAILURE", () => $1d604ab09c97d0b8$export$5b1e245d5eac107);
$parcel$export(module.exports, "classicFieldTypesMap", () => $1d604ab09c97d0b8$export$369c1f8ac37104ce);
$parcel$export(module.exports, "ngFieldTypesMap", () => $1d604ab09c97d0b8$export$b361664c16c2ea91);
$parcel$export(module.exports, "SWIFT_VERSION_M2", () => $1d604ab09c97d0b8$export$527472231e0f6045);

var $lO4Or = parcelRequire("lO4Or");

var $6bYiA = parcelRequire("6bYiA");
const $1d604ab09c97d0b8$export$b8b9d90f9e5bd72b = (0, $6bYiA.toPackageName)('jiraProjectSettingsAppsIssueTypePageProductFeatures');
const $1d604ab09c97d0b8$export$d7fec05af6b928f7 = 'inactive-list';
const $1d604ab09c97d0b8$export$de26d0d1ef96d0ed = 'field-type-list';
const $1d604ab09c97d0b8$export$a155cb9d82798d65 = 'delete-droppable-id';
const $1d604ab09c97d0b8$export$8191ccc97ff9885c = '9|.^=*D(riA_=lUv787iQ7hwW5HIz=}t/OdJy%q';
const $1d604ab09c97d0b8$export$c77ecc59e9e91e60 = 'DO_NOT_ANIMATE_WIDTH';
const $1d604ab09c97d0b8$export$88ecd73c50643906 = 'swift_searchPreviouslyCreatedFields';
const $1d604ab09c97d0b8$export$663476c4863d5014 = 'jsd.field.helpText';
const $1d604ab09c97d0b8$export$aefba859678f04a = 'jsm.issue.type.associated.screen.id';
const $1d604ab09c97d0b8$export$9be9f574874c9a2f = 'jsm.issue.type.id';
const $1d604ab09c97d0b8$export$b320c6b352dcb101 = 'jsm.issue.type.name';
const $1d604ab09c97d0b8$export$97bca9c51480133e = 'jsm.issue.type.icon.id';
const $1d604ab09c97d0b8$export$b540ee71bad36b8b = 'jsm.issue.type.icon.url';
const $1d604ab09c97d0b8$export$27366eb417850f7c = [
    $1d604ab09c97d0b8$export$aefba859678f04a,
    $1d604ab09c97d0b8$export$b320c6b352dcb101,
    $1d604ab09c97d0b8$export$97bca9c51480133e,
    $1d604ab09c97d0b8$export$b540ee71bad36b8b
];
const $1d604ab09c97d0b8$export$e66b34cc29932bbf = 'suggestedGroup';
const $1d604ab09c97d0b8$export$c87c7df18254969e = 'assetsGroup';
const $1d604ab09c97d0b8$export$fa8c310a8ac47d47 = 'datesGroup';
const $1d604ab09c97d0b8$export$5b2dd1b457037e13 = 'labelsGroup';
const $1d604ab09c97d0b8$export$2c2f344ca2ba1c03 = 'numberGroup';
const $1d604ab09c97d0b8$export$1441c9d524a8c0f2 = 'peopleGroup';
const $1d604ab09c97d0b8$export$d3e4788fc90e5f8f = 'selectGroup';
const $1d604ab09c97d0b8$export$724e0d23ac7e9b03 = 'systemGroup';
const $1d604ab09c97d0b8$export$bd76d204d15f4c6a = 'textGroup';
const $1d604ab09c97d0b8$export$33d3fa5e989ba460 = 'versionGroup';
const $1d604ab09c97d0b8$export$c58a10f3e3456974 = 'advancedGroup';
const $1d604ab09c97d0b8$export$591e195d295fd27e = 'otherGroup';
const $1d604ab09c97d0b8$export$14785d7afcf55619 = 'restrictedGroup';
const $1d604ab09c97d0b8$export$df593ebd3e7c9c2d = 'aiSuggestedGroup';
const $1d604ab09c97d0b8$export$d788bc089976c004 = 'INIT';
const $1d604ab09c97d0b8$export$26d55645375ca9a = 'LOADING';
const $1d604ab09c97d0b8$export$638cc6e36b2a737a = 'SUCCESS';
const $1d604ab09c97d0b8$export$5b1e245d5eac107 = 'FAILURE';
const $1d604ab09c97d0b8$export$369c1f8ac37104ce = {
    assetspicker: $1d604ab09c97d0b8$export$c58a10f3e3456974,
    date: $1d604ab09c97d0b8$export$fa8c310a8ac47d47,
    datetime: $1d604ab09c97d0b8$export$fa8c310a8ac47d47,
    labelpicker: $1d604ab09c97d0b8$export$5b2dd1b457037e13,
    number: $1d604ab09c97d0b8$export$2c2f344ca2ba1c03,
    multiuserpicker: $1d604ab09c97d0b8$export$1441c9d524a8c0f2,
    userpicker: $1d604ab09c97d0b8$export$1441c9d524a8c0f2,
    checkbox: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    radio: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    cascadingselect: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    multiselect: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    select: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    attachment: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    text: $1d604ab09c97d0b8$export$bd76d204d15f4c6a,
    textarea: $1d604ab09c97d0b8$export$bd76d204d15f4c6a
};
const $1d604ab09c97d0b8$export$b361664c16c2ea91 = {
    [(0, $lO4Or.ASSETS_CF_TYPE)]: $1d604ab09c97d0b8$export$c58a10f3e3456974,
    [(0, $lO4Or.DATE_CF_TYPE)]: $1d604ab09c97d0b8$export$fa8c310a8ac47d47,
    [(0, $lO4Or.DATETIME_CF_TYPE)]: $1d604ab09c97d0b8$export$fa8c310a8ac47d47,
    [(0, $lO4Or.LABELS_CF_TYPE)]: $1d604ab09c97d0b8$export$5b2dd1b457037e13,
    [(0, $lO4Or.NUMBER_CF_TYPE)]: $1d604ab09c97d0b8$export$2c2f344ca2ba1c03,
    people: $1d604ab09c97d0b8$export$1441c9d524a8c0f2,
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    [(0, $lO4Or.SELECT_CF_TYPE)]: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    [(0, $lO4Or.ATTACHMENT_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.TEXT_CF_TYPE)]: $1d604ab09c97d0b8$export$bd76d204d15f4c6a,
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: $1d604ab09c97d0b8$export$bd76d204d15f4c6a,
    text: $1d604ab09c97d0b8$export$bd76d204d15f4c6a,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $1d604ab09c97d0b8$export$c58a10f3e3456974,
    [(0, $lO4Or.VERSION_CF_TYPE)]: $1d604ab09c97d0b8$export$c58a10f3e3456974,
    [(0, $lO4Or.SUMMARY_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.DESCRIPTION_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.LABELS_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: $1d604ab09c97d0b8$export$1441c9d524a8c0f2,
    [(0, $lO4Or.PRIORITY_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.DUE_DATE_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.REPORTER_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03
};
const $1d604ab09c97d0b8$export$8e333612d4b83b0e = 'M1';
const $1d604ab09c97d0b8$export$527472231e0f6045 = 'M2';

});

parcelRegister("jEt1i", function(module, exports) {

$parcel$export(module.exports, "queryIssueTypesNavigationItems", () => $e2b7fcab9d715067$export$d7f9b965a8cdf6ce);

var $2OdyW = parcelRequire("2OdyW");

var $6JubH = parcelRequire("6JubH");
const $e2b7fcab9d715067$var$getIssueTypesNavigationItemsQuery = (projectId)=>`query IssueTypesNavigationItems {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }
            }
        }
    }
  }`;
const $e2b7fcab9d715067$var$getIssueTypesNavigationItemsWithPropertiesQuery = (projectId, keys)=>`query IssueTypesNavigationItemsWithProperties {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }
                properties(keys: ${JSON.stringify(keys)})
            }
        }
    }
  }`;
const $e2b7fcab9d715067$export$d7f9b965a8cdf6ce = (projectId, productFeatures)=>{
    const propertyKeys = (0, $6JubH.getAllPropertiesKeys)(productFeatures);
    const query = propertyKeys.length ? $e2b7fcab9d715067$var$getIssueTypesNavigationItemsWithPropertiesQuery(projectId, propertyKeys) : $e2b7fcab9d715067$var$getIssueTypesNavigationItemsQuery(projectId);
    return (0, $2OdyW.default)('/rest/gira/latest/?issue-type-page-navigation', {
        method: 'POST',
        body: JSON.stringify({
            query: query
        })
    });
};

});
parcelRegister("6JubH", function(module, exports) {

$parcel$export(module.exports, "getAllPropertiesKeys", () => $cda94d5835810025$export$481a21941383de83);

const $cda94d5835810025$export$481a21941383de83 = (features)=>{
    const { issueTypeHelpText: issueTypeHelpText } = features;
    const allPropertiesKeys = [
        (0, $71863708d1e76c0d$export$97806a3c861a8076),
        (0, $71863708d1e76c0d$export$5a53542e76b69730)
    ];
    return issueTypeHelpText ? allPropertiesKeys : [];
};

});
const $71863708d1e76c0d$export$5a53542e76b69730 = 'jsd.simplified.issue.type.helpText';
const $71863708d1e76c0d$export$97806a3c861a8076 = 'jsd.simplified.issue.type.isEmail';
const $71863708d1e76c0d$export$ffd77ce47de6d72c = 'jsd.field.displayName';
const $71863708d1e76c0d$export$663476c4863d5014 = 'jsd.field.helpText';
const $71863708d1e76c0d$export$dc7a7283bd7cd216 = 'jsd.field.approval.config';
const $71863708d1e76c0d$export$79bc253bc6964b1 = 'jsd.field.approval.all.configs';



parcelRegister("kcW9s", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeNavigationItemsLevels", () => $381ebc40076882e7$export$fcf99cb11372431f);
$parcel$export(module.exports, "getIsIssueTypeLimitReached", () => $381ebc40076882e7$export$f9ef03d331bca3e6);

var $3l6tm = parcelRequire("3l6tm");

var $fPLIA = parcelRequire("fPLIA");
const $381ebc40076882e7$var$JSD_IS_EMAIL_REQUEST_TYPE = 'jsd.simplified.issue.type.isEmail';
const $381ebc40076882e7$export$fcf99cb11372431f = (issueTypes)=>issueTypes.reduce((acc, issueType)=>{
        const { id: id, avatarId: avatarId, name: name, hierarchyLevel: hierarchyLevel, properties: properties, operations: operations } = issueType;
        const issueTypeNavigationItem = {
            id: id,
            name: name,
            avatarId: avatarId,
            operations: operations,
            icon: (0, $fPLIA.getProjectAvatarUrl)(avatarId)
        };
        if ((0, $3l6tm.isEpicHierarchyLevel)(hierarchyLevel) || properties && properties[$381ebc40076882e7$var$JSD_IS_EMAIL_REQUEST_TYPE]) acc.topLevel.push(issueTypeNavigationItem);
        else if ((0, $3l6tm.isBaseHierarchyLevel)(hierarchyLevel)) acc.baseLevel.push(issueTypeNavigationItem);
        else if ((0, $3l6tm.isSubtaskHierarchyLevel)(hierarchyLevel)) acc.bottomLevel.push(issueTypeNavigationItem);
        return acc;
    }, {
        topLevel: [],
        baseLevel: [],
        bottomLevel: []
    });
const $381ebc40076882e7$export$f9ef03d331bca3e6 = (limitPerProject, numberOfIssueTypes)=>limitPerProject !== null && limitPerProject > 0 && numberOfIssueTypes >= limitPerProject;

});
parcelRegister("3l6tm", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $493876d3567385f4$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $493876d3567385f4$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $493876d3567385f4$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $493876d3567385f4$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $493876d3567385f4$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $493876d3567385f4$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $493876d3567385f4$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $493876d3567385f4$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $493876d3567385f4$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $493876d3567385f4$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $493876d3567385f4$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $493876d3567385f4$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $493876d3567385f4$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $493876d3567385f4$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $493876d3567385f4$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $493876d3567385f4$export$638ac52227e67c8);
const $493876d3567385f4$export$2294cfc7730248df = 4;
const $493876d3567385f4$export$961a1d6da881600c = 3;
const $493876d3567385f4$export$e11dea67b88ee556 = 2;
const $493876d3567385f4$export$9ad20e435294162a = 1;
const $493876d3567385f4$export$a454b3474c5ee5f5 = 0;
const $493876d3567385f4$export$b69c1b48ce8f83de = -1;
const $493876d3567385f4$export$ba7c785763a2a58f = 'BASE';
const $493876d3567385f4$export$e09d07f2dcff2603 = 'CHILD';
const $493876d3567385f4$export$1165245f61159842 = 'PARENT';
const $493876d3567385f4$export$8a96a83b3f957e58 = 'EPIC';
const $493876d3567385f4$export$c0c893ca5ccae9dd = (level)=>level;
const $493876d3567385f4$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $493876d3567385f4$export$a454b3474c5ee5f5;
};
const $493876d3567385f4$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $493876d3567385f4$export$9ad20e435294162a;
};
const $493876d3567385f4$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $493876d3567385f4$export$b69c1b48ce8f83de;
};
const $493876d3567385f4$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $493876d3567385f4$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $493876d3567385f4$export$e09d07f2dcff2603;
    return $493876d3567385f4$export$ba7c785763a2a58f;
};
const $493876d3567385f4$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $493876d3567385f4$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $493876d3567385f4$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $493876d3567385f4$export$e09d07f2dcff2603;
    return $493876d3567385f4$export$ba7c785763a2a58f;
};

});

parcelRegister("fPLIA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ca2223257c6a5a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getProjectAvatarUrl", () => $2ca2223257c6a5a8$export$65a50dd1fe88e116);
$parcel$export(module.exports, "normaliseSavedAvatar", () => $2ca2223257c6a5a8$export$b11f6166803b3fff);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2ca2223257c6a5a8$export$2e2bcd8739ae039 = (rawAvatars)=>rawAvatars.system.concat(rawAvatars.custom).map((raw)=>({
            id: Number(raw.id),
            uri: raw.urls['48x48'],
            fileName: raw.fileName
        }));
const $2ca2223257c6a5a8$export$65a50dd1fe88e116 = (avatarId)=>`/secure/viewavatar?avatarId=${avatarId}&avatarType=issuetype`;
const $2ca2223257c6a5a8$export$b11f6166803b3fff = (avatar)=>({
        id: parseInt(avatar.id, 10),
        uri: $2ca2223257c6a5a8$export$65a50dd1fe88e116(parseInt(avatar.id, 10)),
        fileName: avatar.fileName
    });

});



parcelRegister("ecloj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ef69dab8435bf50$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9ef69dab8435bf50$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueTypes: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.issue-types",
        "defaultMessage": "Issue types"
    },
    addIssueType: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.add-issue-type",
        "defaultMessage": "Add issue type"
    }
});

});


parcelRegister("f4Fss", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b38fe1c4155e2b35$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b38fe1c4155e2b35$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.title",
        "defaultMessage": "Project settings"
    },
    itemDetails: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-details",
        "defaultMessage": "Details"
    },
    itemAccess: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-access",
        "defaultMessage": "Access"
    },
    itemFieldsNonFinal: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-fields-non-final",
        "defaultMessage": "Fields"
    },
    itemIssueTypes: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-issue-types",
        "defaultMessage": "Issue types"
    },
    itemAdvancedForms: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-advanced-forms",
        "defaultMessage": "Advanced Forms"
    },
    newLozenge: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.new-lozenge",
        "defaultMessage": "New"
    },
    automation: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.automation",
        "defaultMessage": "Automation"
    },
    itemNotifications: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-notifications",
        "defaultMessage": "Notifications"
    },
    itemApprovals: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-approvals",
        "defaultMessage": "Approvals"
    },
    dataClassificationNonFinal: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.data-classification-non-final",
        "defaultMessage": "Data classification"
    }
});

});


parcelRegister("1m2Xn", function(module, exports) {

$parcel$export(module.exports, "useThrowSettingFeatures", () => $f542bb55240ab7c0$export$154ecbb867fd48f0);
$parcel$export(module.exports, "Settings", () => $f542bb55240ab7c0$export$c72f6eaae7b9adff);
/* eslint-disable complexity */ 
var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $lwZcK = parcelRequire("lwZcK");

var $7ZZxN = parcelRequire("7ZZxN");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $2Rqjr = parcelRequire("2Rqjr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fR9xM = parcelRequire("fR9xM");

var $3SvNA = parcelRequire("3SvNA");

var $gFuN0 = parcelRequire("gFuN0");

var $1UelU = parcelRequire("1UelU");

var $jFPBh = parcelRequire("jFPBh");

var $9kVcv = parcelRequire("9kVcv");

var $cPEpP = parcelRequire("cPEpP");

var $bMXQ7 = parcelRequire("bMXQ7");

var $kIUmN = parcelRequire("kIUmN");

var $bS2FN = parcelRequire("bS2FN");

var $atb9c = parcelRequire("atb9c");

var $gF5SK = parcelRequire("gF5SK");

var $6vrw7 = parcelRequire("6vrw7");

var $8yhrX = parcelRequire("8yhrX");

var $bRhBg = parcelRequire("bRhBg");

var $7eeF2 = parcelRequire("7eeF2");
const $f542bb55240ab7c0$export$a4007dc4843ca7f6 = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
const $f542bb55240ab7c0$export$154ecbb867fd48f0 = (0, $kIUmN.withThrowOnError)((0, $bRhBg.useSettingFeatures));
const $f542bb55240ab7c0$export$17eaab3b8c213998 = (0, $kIUmN.withThrowOnError)((0, $gF5SK.useNewIssueViewLockedInStatus));
const $f542bb55240ab7c0$var$NOTIFICATIONS_ROUTE_NAMES = [
    (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS),
    (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL),
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS)
];
// will be cleaned with FF cleanup
const $f542bb55240ab7c0$var$DisplayNotificationsOptions = ({ hasNotifications: hasNotifications, formatMessage: formatMessage, project: project })=>{
    if (!hasNotifications) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    if ((0, $1ybV0.ff)('jlovep-1857-enable-project-email-audit-pages-for-business-projects_tz5uu')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3SvNA.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'notifications'
        },
        menuItemLabel: formatMessage((0, $7eeF2.default).notifications),
        forceExpand: true,
        submenuId: "core-notifications-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bMXQ7.NotificationsSubMenu), {
        settingsUrl: `/plugins/servlet/project-config/${project.key}/notifications`,
        issueLogsUrl: `/jira/core/projects/${project.key}/settings/notifications/issue-logs?projectId=${project.id}`,
        displayLozenge: !(0, $1ybV0.ff)('jlovep-1857-remove-lozenge-for-pea-sidebar-for-business-project_z34bw')
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'notifications'
        },
        href: `/plugins/servlet/project-config/${project.key}/notifications`,
        selectedOn: $f542bb55240ab7c0$var$NOTIFICATIONS_ROUTE_NAMES
    }, formatMessage((0, $7eeF2.default).notifications));
};
// will be cleaned with FF cleanup
const $f542bb55240ab7c0$var$IssueLayoutOption = ({ isNewIssueViewLockedIn: isNewIssueViewLockedIn, hasIssueLayout: hasIssueLayout, formatMessage: formatMessage, project: project })=>{
    if ((0, $1ybV0.ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) return hasIssueLayout && isNewIssueViewLockedIn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'issue-layout'
        },
        href: `/plugins/servlet/project-config/${project.key}/issuelayout`
    }, formatMessage((0, $7eeF2.default).issueLayout));
    return isNewIssueViewLockedIn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'issue-layout'
        },
        href: `/plugins/servlet/project-config/${project.key}/issuelayout`
    }, formatMessage((0, $7eeF2.default).issueLayout));
};
const $f542bb55240ab7c0$export$c72f6eaae7b9adff = ({ ecosystemItems: ecosystemItems })=>{
    const { data: features } = $f542bb55240ab7c0$export$154ecbb867fd48f0();
    const { data: status } = $f542bb55240ab7c0$export$17eaab3b8c213998();
    const isNewIssueViewLockedIn = status?.newIssueViewTransitionLockingStatus !== (0, $gF5SK.DEFAULT_TO_OLD_ISSUE_VIEW);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: project } = $f542bb55240ab7c0$export$a4007dc4843ca7f6();
    const hasDlpEnabled = (0, $8yhrX.useDlpEntitlement)();
    if (features == null || project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $7eeF2.default).projectSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, features.hasDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'details'
        },
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS)
        ],
        href: `/jira/core/projects/${project.key}/settings/details`
    }, formatMessage((0, $7eeF2.default).details)), features.hasPeople && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'people'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `/plugins/servlet/project-config/${project.key}/people`
    }, formatMessage((0, $7eeF2.default).people)), features.hasAutomation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jFPBh.SpotlightTarget), {
        name: "spotlight-sidebar-project-automation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: (0, $lwZcK.getBaseAutomationUrl)({
            isSimplified: project.isSimplified,
            projectKey: (0, $6vrw7.toProjectKey)(project.key),
            projectType: (0, $7ZZxN.CORE_PROJECT)
        })
    }, formatMessage((0, $7eeF2.default).automation))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fR9xM.EngagementSpotlight), {
        engagementId: "spotlight-sidebar-project-automation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gFuN0.FireUiAnalytics), {
        actionSubject: "automationNavigationItem",
        action: "viewed"
    })), features.hasSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'summary'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `/plugins/servlet/project-config/${project.key}/summary`
    }, formatMessage((0, $7eeF2.default).summary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasIssueConfigSection || isNewIssueViewLockedIn || (0, $1ybV0.ff)('proforma-mvp-jwm-project-settings_5edja')
    }, features.hasIssueTypes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'issue-types'
        },
        href: `/plugins/servlet/project-config/${project.key}/issuetypes`
    }, formatMessage((0, $7eeF2.default).issueTypes)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f542bb55240ab7c0$var$IssueLayoutOption, {
        isNewIssueViewLockedIn: isNewIssueViewLockedIn,
        hasIssueLayout: features.hasIssueLayout,
        formatMessage: formatMessage,
        project: project
    }), (0, $1ybV0.ff)('proforma-mvp-jwm-project-settings_5edja') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'proforma-forms'
        },
        href: `/jira/core/projects/${project.key}/settings/forms`,
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS)
        ]
    }, formatMessage((0, $7eeF2.default).forms))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasProjectGroupTwoSection
    }, features.hasWorkflows && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'workflows'
        },
        href: `/plugins/servlet/project-config/${project.key}/workflows`
    }, formatMessage((0, $7eeF2.default).workflows)), features.hasScreens && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'screens'
        },
        href: `/plugins/servlet/project-config/${project.key}/screens`
    }, formatMessage((0, $7eeF2.default).screens)), features.hasFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'fields'
        },
        href: `/plugins/servlet/project-config/${project.key}/fields`
    }, formatMessage((0, $7eeF2.default).fields))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasProjectGroupThreeSection
    }, features.hasVersions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS)
        ],
        analytics: {
            itemId: 'versions'
        },
        href: `/plugins/servlet/project-config/${project.key}/administer-versions`
    }, formatMessage((0, $7eeF2.default).versions)), features.hasComponents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS)
        ],
        analytics: {
            itemId: 'components'
        },
        href: `/plugins/servlet/project-config/${project.key}/administer-components`
    }, formatMessage((0, $7eeF2.default).components))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasProjectGroupFourSection
    }, features.hasPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'permissions'
        },
        href: `/plugins/servlet/project-config/${project.key}/permissions`
    }, formatMessage((0, $7eeF2.default).permissions)), features.hasIssueSecurity && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'issue-security'
        },
        href: `/plugins/servlet/project-config/${project.key}/issuesecurity`
    }, formatMessage((0, $7eeF2.default).issueSecurity)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f542bb55240ab7c0$var$DisplayNotificationsOptions, {
        hasNotifications: features.hasNotifications,
        formatMessage: formatMessage,
        project: project
    }), features.hasDevtools && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'devtools'
        },
        href: `/secure/ConfigureDevStatus.jspa?projectKey=${project.key}`
    }, formatMessage((0, $7eeF2.default).devtools))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasgetIssueCollectorSection
    }, features.hasIssueCollectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS)
        ],
        analytics: {
            itemId: 'issue-collectors'
        },
        href: `/secure/ViewCollectors!default.jspa?projectKey=${project.key}`
    }, formatMessage((0, $7eeF2.default).issueCollectors))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atb9c.default), {
        hasSeparator: true,
        items: ecosystemItems,
        forgeModule: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE),
        overrides: {
            BackMenuItem: {
                href: `/plugins/servlet/project-config/${project.key}`,
                title: formatMessage((0, $7eeF2.default).itemBack)
            }
        }
    }), hasDlpEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'data-classifications'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `/plugins/servlet/project-config/${project.key}/data-classifications`
    }, formatMessage((0, $7eeF2.default).dataClassificationsNonFinal))));
};

});
parcelRegister("lwZcK", function(module, exports) {

$parcel$export(module.exports, "getBaseAutomationUrl", () => $c220e0172ef405d3$export$8e479e490e1e69bc);
const $c220e0172ef405d3$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'service_desk') return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    if (projectType === 'business') return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
};

});

parcelRegister("fR9xM", function(module, exports) {

$parcel$export(module.exports, "EngagementSpotlight", () => $56d259c5c8dc2f0b$export$f14689466e4eca7a);

var $eUqFw = parcelRequire("eUqFw");

var $55pTl = parcelRequire("55pTl");

var $ekN4Q = parcelRequire("ekN4Q");

var $16WDb = parcelRequire("16WDb");
const $56d259c5c8dc2f0b$export$f14689466e4eca7a = (0, $16WDb.withNestingOptimisation)(({ engagementId: engagementId })=>{
    const isFullyExpanded = (0, $ekN4Q.useIsFullyExpanded)();
    return isFullyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
        engagementId: engagementId
    });
});

});

parcelRegister("gFuN0", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $e57e9331bc8bc1d3$export$5a67e7291fd4569e);

var $d6f6c = parcelRequire("d6f6c");

var $16WDb = parcelRequire("16WDb");
const $e57e9331bc8bc1d3$export$5a67e7291fd4569e = (0, $16WDb.withNestingOptimisation)((0, $d6f6c.FireUiAnalytics));

});

parcelRegister("jFPBh", function(module, exports) {

$parcel$export(module.exports, "SpotlightTarget", () => $022d6d24d0c2da0b$export$e29577842f211e22);

var $eUqFw = parcelRequire("eUqFw");

var $ltfxy = parcelRequire("ltfxy");

var $16WDb = parcelRequire("16WDb");
const $022d6d24d0c2da0b$var$SpotlightTargetWrapper = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $022d6d24d0c2da0b$export$e29577842f211e22 = (0, $16WDb.withNestingOptimisation)($022d6d24d0c2da0b$var$SpotlightTargetWrapper);

});

parcelRegister("atb9c", function(module, exports) {

$parcel$export(module.exports, "default", () => $21ea6e374e29cd9c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");

var $9ui8T = parcelRequire("9ui8T");

var $fDNHa = parcelRequire("fDNHa");

var $l3JmK = parcelRequire("l3JmK");
const $21ea6e374e29cd9c$export$66569e9b4a285b16 = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '', nestedMenuActive: nestedMenuActive = true })=>{
    const forgeItems = (0, $eUqFw.useMemo)(()=>items.forge || [], [
        items.forge
    ]);
    const connectItems = (0, $9ui8T.useFilteredItems)(items.connect, shouldFilter);
    const sortedItems = (0, $eUqFw.useMemo)(()=>[
            ...forgeItems.map((item)=>({
                    type: 'forge',
                    item: item
                })),
            ...connectItems.map((item)=>({
                    type: 'connect',
                    item: item
                }))
        ].sort((a, b)=>a.item.name.localeCompare(b.item.name)), [
        connectItems,
        forgeItems
    ]);
    if (!sortedItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, sortedItems.map(({ type: type, item: item }, index)=>{
        if (type === 'forge') {
            // @ts-expect-error - TS2322 - Type 'ConnectDataItem | ForgeItemProps' is not assignable to type 'ForgeProjectSettingsItem'.
            const forgeItem = item;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3JmK.ForgeItem), {
                key: forgeItem.id,
                ...forgeItem,
                overrides: overrides,
                showIcon: showIcons,
                nestedMenuActive: nestedMenuActive
            });
        }
        const connectItem = item;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDNHa.ConnectItem), {
            item: connectItem,
            key: connectItem.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        });
    }), forgeItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), null) : null);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$21ea6e374e29cd9c$export$2e2bcd8739ae039 = ({ forgeModule: forgeModule, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: forgeModule,
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21ea6e374e29cd9c$export$66569e9b4a285b16, restProps));

});

parcelRegister("7eeF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3728eeca46b17d68$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3728eeca46b17d68$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectSettings: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.project-settings",
        "defaultMessage": "Project settings"
    },
    details: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.details",
        "defaultMessage": "Details"
    },
    people: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.people",
        "defaultMessage": "People"
    },
    summary: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.summary",
        "defaultMessage": "Summary"
    },
    deleteProject: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.delete-project",
        "defaultMessage": "Delete project"
    },
    issueTypes: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-types",
        "defaultMessage": "Issue types"
    },
    issueLayout: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-layout",
        "defaultMessage": "Issue layout"
    },
    workflows: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.workflows",
        "defaultMessage": "Workflows"
    },
    screens: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.screens",
        "defaultMessage": "Screens"
    },
    fields: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.fields",
        "defaultMessage": "Fields"
    },
    versions: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.versions",
        "defaultMessage": "Versions"
    },
    components: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.components",
        "defaultMessage": "Components"
    },
    permissions: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.permissions",
        "defaultMessage": "Permissions"
    },
    issueSecurity: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-security",
        "defaultMessage": "Issue security"
    },
    notifications: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.notifications",
        "defaultMessage": "Notifications"
    },
    notificationsEmail: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.notifications-email",
        "defaultMessage": "Notification email"
    },
    hipChat: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.hip-chat",
        "defaultMessage": "HipChat integration"
    },
    issueCollectors: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-collectors",
        "defaultMessage": "Issue collectors"
    },
    new: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.new",
        "defaultMessage": "New"
    },
    itemBack: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.item-back",
        "defaultMessage": "Back to project settings"
    },
    automation: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.automation",
        "defaultMessage": "Automation"
    },
    devtools: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.devtools",
        "defaultMessage": "Development tools"
    },
    forms: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.forms",
        "defaultMessage": "Advanced Forms"
    },
    dataClassificationsNonFinal: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.data-classifications-non-final",
        "defaultMessage": "Data classification"
    }
});

});





parcelRegister("bVacK", function(module, exports) {

$parcel$export(module.exports, "default", () => $13b69d7e9bc0f0ef$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $13b69d7e9bc0f0ef$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    favorites: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.favorites",
        "defaultMessage": "Starred"
    },
    recents: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.recents",
        "defaultMessage": "Recent"
    },
    expandSection: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.expand-section",
        "defaultMessage": "Expand {section} projects"
    },
    collapseSection: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.collapse-section",
        "defaultMessage": "Collapse {section} projects"
    }
});

});

parcelRegister("1nRKu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8307479266abafd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3YFEG = parcelRequire("3YFEG");

var $kCTcl = parcelRequire("kCTcl");
const $e8307479266abafd$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.view-all-projects';
const $e8307479266abafd$var$ViewAllProjects = ({ label: label })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3YFEG.default), {
        href: "/jira/projects?selectedProjectType=business",
        testId: $e8307479266abafd$var$TEST_ID,
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmViewAllProjectsLink')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $e8307479266abafd$var$textStyle
    }, label ?? formatMessage((0, $kCTcl.messages).viewAllProjectsLabel)));
};
var $e8307479266abafd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e8307479266abafd$var$ViewAllProjects);
const $e8307479266abafd$var$textStyle = (0, $1ZAYh.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: "var(--ds-font-weight-regular, 400)"
});

});
parcelRegister("kCTcl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a83bdf732a2f08ae$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a83bdf732a2f08ae$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    viewAllProjectsLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.view-all-projects.view-all-projects-label",
        "defaultMessage": "View all projects"
    }
});

});



parcelRegister("439fx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b2bfd1ec3623003$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lbttE = parcelRequire("lbttE");

var $2JncP = parcelRequire("2JncP");

var $94rY2 = parcelRequire("94rY2");

var $7LPMB = parcelRequire("7LPMB");

var $46qxU = parcelRequire("46qxU");
const $5b2bfd1ec3623003$var$ProjectsHeader = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data } = (0, $2JncP.useProjectCreatePermissionsResource)();
    const canCreateProject = Boolean(data?.canCreateProject);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94rY2.default), {
        title: formatMessage((0, $7LPMB.messages).projectsHeader)
    }, canCreateProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbttE.ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $46qxU.default), {
            openProjectCreateDrawer: open
        })));
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$5b2bfd1ec3623003$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5b2bfd1ec3623003$var$ProjectsHeader);

});
parcelRegister("7LPMB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1677fc3cc494a9e0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1677fc3cc494a9e0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    projectsHeader: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.projects-header",
        "defaultMessage": "Projects"
    }
});

});

parcelRegister("46qxU", function(module, exports) {

$parcel$export(module.exports, "default", () => $afa00e86d64bf3cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");

var $6VZoe = parcelRequire("6VZoe");

var $5RHM4 = parcelRequire("5RHM4");

var $eJ4Al = parcelRequire("eJ4Al");

const $afa00e86d64bf3cb$export$ef99f99721eacc0f = (0, $6VZoe.lazy)(()=>Promise.resolve((parcelRequire("eJ4Al"))), {
    ssr: false,
    moduleId: "./src/packages/business/navigation/sidebar/src/ui/multi-project-menu/projects-header/one-click-project/template-picker/index.tsx"
});
const $afa00e86d64bf3cb$var$OneClickProject = ({ openProjectCreateDrawer: openProjectCreateDrawer })=>{
    const renderContent = (0, $eUqFw.useCallback)((data, loading)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "sidebar-template-picker",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ4Al.TemplatePickerFallback), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($afa00e86d64bf3cb$export$ef99f99721eacc0f, {
            data: data,
            loading: loading,
            openProjectCreateDrawer: openProjectCreateDrawer
        })), [
        openProjectCreateDrawer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5RHM4.default), {
        renderContent: renderContent,
        openProjectCreateDrawer: openProjectCreateDrawer
    });
};
var $afa00e86d64bf3cb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($afa00e86d64bf3cb$var$OneClickProject);

});
parcelRegister("5RHM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2f62e632270fd1e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $ctuRV = parcelRequire("ctuRV");

var $kpmC0 = parcelRequire("kpmC0");

var $lg3mT = parcelRequire("lg3mT");

var $jPQKl = parcelRequire("jPQKl");

var $43dkR = parcelRequire("43dkR");
const $d2f62e632270fd1e$var$OneClickProjectButton = ({ renderContent: renderContent, openProjectCreateDrawer: openProjectCreateDrawer })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { data: data, loading: loading, error: error, fetch: fetchJwmTemplates } = (0, $jPQKl.useProjectTemplates)();
    const { isCollapsed: isLeftSidebarCollapsed } = (0, $kpmC0.useLeftSidebarState)();
    const { templates: templates, recommendationSessionId: recommendationSessionId } = data;
    const wasFetched = templates != null || loading || error != null;
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen && !wasFetched) fetchJwmTemplates();
    }, [
        isOpen,
        wasFetched,
        fetchJwmTemplates
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isLeftSidebarCollapsed && isOpen) onClose();
    }, [
        isLeftSidebarCollapsed,
        isOpen,
        onClose
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error && isOpen) {
            openProjectCreateDrawer((0, $ctuRV.getJwmCreateProjectDrawerOptions)((0, $lg3mT.LOCATION), recommendationSessionId));
            setIsOpen(false);
        }
    }, [
        error,
        isOpen,
        openProjectCreateDrawer,
        recommendationSessionId
    ]);
    const content = (0, $eUqFw.useCallback)(()=>renderContent(data, loading), [
        renderContent,
        data,
        loading
    ]);
    const trigger = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43dkR.default), {
            onClick: ()=>setIsOpen(!isOpen)
        })), [
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        placement: "right-start",
        onClose: onClose,
        content: content,
        trigger: trigger
    });
};
var $d2f62e632270fd1e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($d2f62e632270fd1e$var$OneClickProjectButton);

});
parcelRegister("ctuRV", function(module, exports) {

$parcel$export(module.exports, "getJwmCreateProjectDrawerOptions", () => $98e3a17d6f2eb763$export$c1785414279ee192);

var $7ZZxN = parcelRequire("7ZZxN");
const $98e3a17d6f2eb763$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED = 'com.atlassian.jira-core-project-templates:jira-work-management-blank-project-team-managed';
const $98e3a17d6f2eb763$export$c1785414279ee192 = (source, recommendationSessionId)=>({
        isNextGen: true,
        selectedProjectType: (0, $7ZZxN.CORE_PROJECT),
        showExperienceSelection: false,
        defaultSelectedTemplateKey: $98e3a17d6f2eb763$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
        recommendedTemplate: {
            templateKey: $98e3a17d6f2eb763$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
            isSimplified: false
        },
        source: source,
        recommendationSessionId: recommendationSessionId
    });

});

parcelRegister("jPQKl", function(module, exports) {

$parcel$export(module.exports, "useProjectTemplates", () => $fd9a9d07d5b37dc7$export$45e810e42086790f);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $2OdyW = parcelRequire("2OdyW");

var $lg3mT = parcelRequire("lg3mT");

var $8Rrw0 = parcelRequire("8Rrw0");
const $fd9a9d07d5b37dc7$var$initialState = {
    data: {
        templates: null
    },
    loading: false,
    error: null
};
const $fd9a9d07d5b37dc7$export$45e810e42086790f = ()=>{
    const [{ loading: loading, data: data, error: error }, setState] = (0, $eUqFw.useState)($fd9a9d07d5b37dc7$var$initialState);
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        setState({
            data: {
                templates: null
            },
            loading: true,
            error: null
        });
        try {
            const response = await (0, $2OdyW.default)('/rest/simplified/2.0/project-templates?recommendations');
            // * The exposure will be fired at the backend
            // eslint-disable-next-line jira/ff/unsafe-no-exposure
            const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('cb_jira_template_recs_with_for_all_products');
            const shouldUseNewRecommendations = expConfig.get('useNewRecommendations', false);
            const jwmTemplates = shouldUseNewRecommendations ? (0, $8Rrw0.getFilteredTemplatesNew)(response) : (0, $8Rrw0.getFilteredTemplates)(response);
            setState({
                data: {
                    templates: jwmTemplates,
                    recommendationSessionId: response.recommendationSessionId
                },
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useProjectTemplates',
                    packageName: (0, $lg3mT.PACKAGE_NAME),
                    teamName: 'jira-warepil'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                data: {
                    templates: null
                },
                loading: false,
                error: err
            });
        }
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        fetch: fetch
    };
};

});
parcelRegister("8Rrw0", function(module, exports) {

$parcel$export(module.exports, "getFilteredTemplates", () => $aefab5fdd7f61066$export$e9643d22c03c3a30);
$parcel$export(module.exports, "getFilteredTemplatesNew", () => $aefab5fdd7f61066$export$126495c59883efa);
const $aefab5fdd7f61066$var$NUM_TEMPLATES_TO_DISPLAY = 4;
const $aefab5fdd7f61066$var$NUM_TEMPLATES_TO_DISPLAY_NEW = 5;
const $aefab5fdd7f61066$var$MADE_FOR_YOU_CATEGORY = 'made-for-you-category';
// note: these 4 templates are hardcoded for the time being
const $aefab5fdd7f61066$var$TEMPLATE_KEYS = new Set([
    'jwm.blank-project',
    'jwm.project-management',
    'jwm.personal-task-planner',
    'jwm.task-tracking'
]);
const $aefab5fdd7f61066$export$e9643d22c03c3a30 = (response)=>{
    const { templates: templates, lastUsedTemplate: lastUsedTemplateKey, recommendedTemplate: recommendedTemplateKey } = response;
    const lastUsedTemplates = [];
    const recommendedTemplates = [];
    const additionalTemplates = [];
    templates.forEach((template)=>{
        const { projectTypeTemplates: projectTypeTemplates, key: key, categoryTypes: categoryTypes } = template;
        if (lastUsedTemplateKey != null && (projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey || projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey)) lastUsedTemplates.push({
            ...template,
            isLastUsed: true
        });
        else if (recommendedTemplateKey != null && (projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey || projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey || categoryTypes.includes($aefab5fdd7f61066$var$MADE_FOR_YOU_CATEGORY))) recommendedTemplates.push({
            ...template,
            isRecommended: true
        });
        else if ($aefab5fdd7f61066$var$TEMPLATE_KEYS.has(key)) additionalTemplates.push(template);
    });
    // templates are sorted in order of last used, recommended and fallback.
    // only use the first 4 templates
    const filteredTemplates = [
        ...lastUsedTemplates,
        ...recommendedTemplates,
        ...additionalTemplates
    ].slice(0, $aefab5fdd7f61066$var$NUM_TEMPLATES_TO_DISPLAY);
    return filteredTemplates;
};
const $aefab5fdd7f61066$export$126495c59883efa = (response)=>{
    const { templates: templates, lastUsedTemplate: lastUsedTemplateKey, recommendedTemplate: recommendedTemplateKey, recommendedTemplates: recommendedTemplateKeys } = response;
    const lastUsedTemplates = [];
    const recommendedTemplates = [];
    const additionalTemplates = [];
    recommendedTemplateKeys?.forEach((key, index)=>{
        const template = templates.find((t)=>t.key === key);
        if (template) {
            const { projectTypeTemplates: projectTypeTemplates } = template;
            // * The first recommended template will be the last used template if there is one
            if (index === 0 && lastUsedTemplateKey) {
                const isLastUsed = lastUsedTemplateKey && (projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey || projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey);
                lastUsedTemplates.push({
                    ...template,
                    ...isLastUsed && {
                        isLastUsed: isLastUsed
                    }
                });
                return;
            }
            const isRecommended = recommendedTemplateKey && (projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey || projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey);
            recommendedTemplates.push({
                ...template,
                ...isRecommended && {
                    isRecommended: isRecommended
                }
            });
        }
    });
    // * If there are not enough templates to display, add additional templates
    if (lastUsedTemplates.length + recommendedTemplates.length < $aefab5fdd7f61066$var$NUM_TEMPLATES_TO_DISPLAY) {
        // * Get the keys of the templates that are not last used or recommended
        const placeholderTemplateKeys = Array.from($aefab5fdd7f61066$var$TEMPLATE_KEYS).filter((key)=>!lastUsedTemplates.some((t)=>t.key === key) && !recommendedTemplates.some((t)=>t.key === key));
        templates.forEach((template)=>{
            if (placeholderTemplateKeys.includes(template.key)) additionalTemplates.push(template);
        });
    }
    // templates are sorted in order of last used, recommended and fallback.
    // only use the first 5 templates
    const filteredTemplates = [
        ...lastUsedTemplates,
        ...recommendedTemplates,
        ...additionalTemplates
    ].slice(0, $aefab5fdd7f61066$var$NUM_TEMPLATES_TO_DISPLAY_NEW);
    return filteredTemplates;
};

});


parcelRegister("43dkR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c15f45e40c9348dc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $lg3mT = parcelRequire("lg3mT");

var $rRiBz = parcelRequire("rRiBz");

var $bvh6n = parcelRequire("bvh6n");
const $c15f45e40c9348dc$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.create-project-button';
const $c15f45e40c9348dc$var$CreateProjectButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $rRiBz.default), {
        label: formatMessage((0, $bvh6n.default).createProjectLabel),
        testId: $c15f45e40c9348dc$var$TEST_ID,
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $lg3mT.LOCATION));
            onClick();
        }
    });
};
var $c15f45e40c9348dc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c15f45e40c9348dc$var$CreateProjectButton);

});
parcelRegister("bvh6n", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4df5be60050e5cd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e4df5be60050e5cd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createProjectLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.create-project-button.create-project-label",
        "defaultMessage": "Create project"
    }
});

});



parcelRegister("eJ4Al", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "TemplatePickerFallback", () => $ada0eacffac0a44d$export$675ac63e0637d34d);
$parcel$export(module.exports, "default", () => $ada0eacffac0a44d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ffiyv = parcelRequire("ffiyv");

var $bULPy = parcelRequire("bULPy");
var $eMD3i = parcelRequire("eMD3i");
var $8BKky = parcelRequire("8BKky");

var $4Bees = parcelRequire("4Bees");

var $dfBCt = parcelRequire("dfBCt");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c7H0g = parcelRequire("c7H0g");

var $1R3n5 = parcelRequire("1R3n5");

var $lg3mT = parcelRequire("lg3mT");

var $9euug = parcelRequire("9euug");
const $ada0eacffac0a44d$var$POPUP_WIDTH = 272;
const $ada0eacffac0a44d$export$675ac63e0637d34d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ada0eacffac0a44d$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium"
    }));
const $ada0eacffac0a44d$var$TemplatePicker = ({ data: { templates: templates, recommendationSessionId: recommendationSessionId }, loading: loading, openProjectCreateDrawer: openProjectCreateDrawer })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    // Exposure fired in BE
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('cb_jira_template_recs_with_for_all_products');
    const shouldUseNewRecommendations = expConfig.get('useNewRecommendations', false);
    const handleTemplateClick = (0, $eUqFw.useCallback)((projectTypeTemplates, isLastUsed, isRecommended, templateType)=>()=>{
            openProjectCreateDrawer({
                isNextGen: true,
                selectedProjectType: 'business',
                showExperienceSelection: false,
                defaultSelectedTemplateKey: projectTypeTemplates?.teamManaged?.key || projectTypeTemplates?.companyManaged?.key,
                source: (0, $lg3mT.LOCATION),
                ...shouldUseNewRecommendations && {
                    recommendationSessionId: recommendationSessionId
                }
            });
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateTemplate', {
                selectedTemplateKey: projectTypeTemplates?.teamManaged?.key || projectTypeTemplates?.companyManaged?.key,
                isLastUsed: isLastUsed,
                isRecommended: isRecommended,
                templateType: templateType,
                recommendationSessionId: recommendationSessionId
            });
        }, [
        createAnalyticsEvent,
        openProjectCreateDrawer,
        recommendationSessionId,
        shouldUseNewRecommendations
    ]);
    const handleMoreTemplatesClick = (0, $eUqFw.useCallback)(()=>{
        openProjectCreateDrawer({
            isNextGen: true,
            showExperienceSelection: false,
            source: (0, $lg3mT.LOCATION)
        });
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateMoreTemplates');
    }, [
        createAnalyticsEvent,
        openProjectCreateDrawer
    ]);
    const handleImportButtonClick = (0, $eUqFw.useCallback)(()=>{
        openProjectCreateDrawer({
            isNextGen: true,
            showExperienceSelection: false,
            source: (0, $lg3mT.LOCATION),
            isImportProjectOpenInitially: true
        });
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateImport');
    }, [
        createAnalyticsEvent,
        openProjectCreateDrawer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eMD3i.default), {
        minWidth: $ada0eacffac0a44d$var$POPUP_WIDTH,
        testId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.popup-menu-group"
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ada0eacffac0a44d$export$675ac63e0637d34d, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        title: formatMessage((0, $9euug.default).sectionTitle)
    }, Array.isArray(templates) && templates.map(({ iconUrl: iconUrl, key: key, projectTypeTemplates: projectTypeTemplates, title: title, isLastUsed: isLastUsed = false, isRecommended: isRecommended = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
            testId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.button-item",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ada0eacffac0a44d$var$StyledImage, {
                src: iconUrl,
                alt: `${title.label} icon`
            }),
            key: key,
            onClick: handleTemplateClick(projectTypeTemplates, isLastUsed, isRecommended, key)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ada0eacffac0a44d$var$ButtonText, null, title.label), isLastUsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, formatMessage((0, $9euug.default).lastCreated))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button",
        onClick: handleMoreTemplatesClick
    }, formatMessage((0, $9euug.default).moreTemplatesButtonText)), (isSiteAdmin || isAdmin && (0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv') || !isAdmin) && !(0, $dfBCt.isFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.import-button",
        onClick: handleImportButtonClick
    }, formatMessage((0, $9euug.default).importButtonText)))));
};
var $ada0eacffac0a44d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($ada0eacffac0a44d$var$TemplatePicker);
const $ada0eacffac0a44d$var$StyledImage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsbzwfg _5ral1dfr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ada0eacffac0a44d$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbclpc _1e0c1txw _4cvr1h6o _1bah1h6o _1yt4zu5n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ada0eacffac0a44d$var$ButtonText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eMD3i", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d4de9f5740e2589$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");
/**
 * @deprecated refer to MenuGroup, explicitly set maxWidth and minWidth
 */ const $6d4de9f5740e2589$var$PopupMenuGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, ...rest })=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    });
var $6d4de9f5740e2589$export$2e2bcd8739ae039 = $6d4de9f5740e2589$var$PopupMenuGroup;

});

parcelRegister("9euug", function(module, exports) {

$parcel$export(module.exports, "default", () => $2faf631161ec9357$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2faf631161ec9357$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sectionTitle: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.section-title",
        "defaultMessage": "Start a new project"
    },
    moreTemplatesButtonText: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button-text",
        "defaultMessage": "More templates"
    },
    importButtonText: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.import-button-text",
        "defaultMessage": "Import"
    },
    lastCreated: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.last-created",
        "defaultMessage": "Last created"
    }
});

});






parcelRegister("2AuYt", function(module, exports) {

$parcel$export(module.exports, "fieldSettingsRelayResource", () => $e4ed83fee98f8e09$export$68b4e700e00bad7a);

var $buJlM = parcelRequire("buJlM");

var $7cN8f = parcelRequire("7cN8f");

var $9zYls = parcelRequire("9zYls");
const $e4ed83fee98f8e09$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS = 'PROJECT_SETTINGS_FIELDS';
const $e4ed83fee98f8e09$export$68b4e700e00bad7a = (0, $buJlM.createRelayResource)({
    type: $e4ed83fee98f8e09$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(match, query);
        return {
            parameters: (0, $7cN8f.default),
            variables: {
                projectKey: projectKey ?? '',
                cloudId: tenantContext.cloudId ?? ''
            },
            options: {
                fetchPolicy: 'network-only'
            }
        };
    }
});

});
parcelRegister("7cN8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $16ee00e572cfc452$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<639123f3098dfbe0080eb9d0f07998a4>>
 * @relayHash 0d97a528caa2a6d7341f75a0b7e32ef5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e589a704e40ca871d5d0399051c6886caf28e7cb708afb3d92923e96ad4ce7c

var $cNy9K = parcelRequire("cNy9K");
const $16ee00e572cfc452$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        v2 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiFieldsPageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "fieldsTable_projectFields"
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "pageHeader_projectFields_Header"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiFieldsPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "key",
                                    "variableName": "projectKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraProjectWithIssueTypeIds",
                                    "kind": "LinkedField",
                                    "name": "projectWithVisibleIssueTypeIds",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldAssociationWithIssueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFieldAssociationWithIssueTypes",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldId"
                                                                        },
                                                                        v7 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "scope"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeKey"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "description"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueTypeConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueTypeEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v4 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        v7 /*: any*/ ,
                                                                                        v6 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraFieldOperation",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOperation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canRemove"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                                        },
                                        {
                                            "args": v8 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "fieldsTable_fieldAssociationWithIssueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "fieldAssociationWithIssueTypes"
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8e589a704e40ca871d5d0399051c6886caf28e7cb708afb3d92923e96ad4ce7c",
            "metadata": {},
            "name": "uiFieldsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$16ee00e572cfc452$var$node.hash = "befb21bfee3eccfd8224eedab696066f";
(0, $cNy9K.PreloadableQueryRegistry).set($16ee00e572cfc452$var$node.params.id, $16ee00e572cfc452$var$node);
var $16ee00e572cfc452$export$2e2bcd8739ae039 = $16ee00e572cfc452$var$node;

});


parcelRegister("aHr8P", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsAccessSkeleton", () => $4baa3ff9a8a11662$export$e6cc5ccd52c7fd63);
$parcel$export(module.exports, "ProjectSettingsDetailsSkeleton", () => $4baa3ff9a8a11662$export$bd7fd4005b84aec9);
$parcel$export(module.exports, "ProjectSettingsFeaturesSkeleton", () => $4baa3ff9a8a11662$export$ec1cdd0c8335373c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $dpuqa = parcelRequire("dpuqa");

var $iq1ke = parcelRequire("iq1ke");

var $fCyvs = parcelRequire("fCyvs");
const $4baa3ff9a8a11662$var$customCssStyles = null;
const $4baa3ff9a8a11662$var$listOnlyStyles = null;
const $4baa3ff9a8a11662$export$e6cc5ccd52c7fd63 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dpuqa))),
        className: (0, $7JEyt.default)([
            "_18s85ogf _p12f1qe4 _11y7oza4"
        ])
    });
const $4baa3ff9a8a11662$export$bd7fd4005b84aec9 = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iq1ke))),
        className: (0, $7JEyt.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_18s85ogf _p12f1qe4 _11y7oza4"
        ])
    });
const $4baa3ff9a8a11662$export$ec1cdd0c8335373c = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fCyvs))),
        className: (0, $7JEyt.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_18s85ogf _p12f1qe4 _11y7oza4"
        ])
    });

});
parcelRegister("dpuqa", function(module, exports) {
module.exports = new URL("project-settings-access-app-skeleton.tpl.21bb94b1.svg", import.meta.url).toString();

});

parcelRegister("iq1ke", function(module, exports) {
module.exports = new URL("project-settings-details-app-skeleton.tpl.c4ebc2fd.svg", import.meta.url).toString();

});

parcelRegister("fCyvs", function(module, exports) {
module.exports = new URL("project-settings-features-app-skeleton.tpl.b8e7f249.svg", import.meta.url).toString();

});


parcelRegister("9ratP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("eaxuB")
]).then(()=>parcelRequire('k0LLD'));

});

parcelRegister("3G5SQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("qUF2T")
]).then(()=>parcelRequire('7onSv'));

});

parcelRegister("34M7x", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("8s0qr")
]).then(()=>parcelRequire('cndzG'));

});

parcelRegister("5p5BW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("7kRau")
]).then(()=>parcelRequire('ary41'));

});

parcelRegister("c3BLd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("d2csC").then(()=>parcelRequire('3rBlh'));

});

parcelRegister("jS5ct", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("gkVK0")
]).then(()=>parcelRequire('iWHRQ'));

});

parcelRegister("c642p", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("9l2fw")
]).then(()=>parcelRequire('5KeHo'));

});

parcelRegister("epDvb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8zAor")
]).then(()=>parcelRequire('crJZY'));

});

parcelRegister("5R9nY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("kjKl7")
]).then(()=>parcelRequire('9WUwc'));

});

parcelRegister("gcYA0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("3Nm6L")
]).then(()=>parcelRequire('jaama'));

});

parcelRegister("bZFFJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dE1tw").then(()=>parcelRequire('1Pa6a'));

});

parcelRegister("6L9TO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("fnPO9")
]).then(()=>parcelRequire('5CBZ5'));

});

parcelRegister("65jMk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("jBbTa")
]).then(()=>parcelRequire('2vBQX'));

});

parcelRegister("1yOoT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4xGYF").then(()=>parcelRequire('48O9T'));

});

parcelRegister("ejPAV", function(module, exports) {

$parcel$export(module.exports, "jsmChangeManagementSettingsGitLabGatingResource", () => $b9fe8dd1f30ad1df$export$315b6278d34861b4);
$parcel$export(module.exports, "useGitLabGatingResource", () => $b9fe8dd1f30ad1df$export$dd3715dce02ee460);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $lB25E = parcelRequire("lB25E");

const $b9fe8dd1f30ad1df$var$getDataLoader = ()=>(parcelRequire("lYAQB"));
const $b9fe8dd1f30ad1df$export$315b6278d34861b4 = (0, $lB25E.createResource)({
    type: 'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
    getKey: ()=>'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
    getDataLoader: $b9fe8dd1f30ad1df$var$getDataLoader,
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $b9fe8dd1f30ad1df$export$dd3715dce02ee460 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)($b9fe8dd1f30ad1df$export$315b6278d34861b4);
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, $1ybV0.ff)('enable-gitlab-gating-frontend_k8rha')) return;
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: data?.data,
            pending: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: data?.error || error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("lYAQB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dKusC").then(()=>parcelRequire('dCO3E'));

});


parcelRegister("aspp6", function(module, exports) {

$parcel$export(module.exports, "jsmRepackagingBannerResource", () => $ae9431cdcb2d3b9b$export$760ca885f96dacb6);
$parcel$export(module.exports, "useJsmRepackagingBannerResource", () => $ae9431cdcb2d3b9b$export$f1444ccc5653a5cb);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $5F1Cw = parcelRequire("5F1Cw");

const $ae9431cdcb2d3b9b$var$getDataLoader = ()=>(parcelRequire("eAfm5"));
const $ae9431cdcb2d3b9b$export$760ca885f96dacb6 = (0, $lB25E.createResource)({
    type: 'JSM_REPACKAGING_BANNER',
    getKey: ()=>'JSM_REPACKAGING_BANNER',
    getDataLoader: $ae9431cdcb2d3b9b$var$getDataLoader,
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $ae9431cdcb2d3b9b$export$f1444ccc5653a5cb = (workCategory, accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)($ae9431cdcb2d3b9b$export$760ca885f96dacb6);
    (0, $eUqFw.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $eUqFw.useMemo)(()=>{
        if (error || loading || !data || !accountId) return {
            show: false
        };
        const { bannerMeta: bannerMeta, bannerDismissState: bannerDismissState } = data;
        const workCategoryDismissState = bannerDismissState?.[workCategory];
        if (!bannerMeta.show || !(bannerMeta.type === 'info' || bannerMeta.type === 'warning')) return {
            show: false
        };
        if (!workCategoryDismissState) return {
            ...bannerDismissState,
            ...bannerMeta,
            refresh: refresh
        };
        if (workCategoryDismissState.packagingChangeDate !== bannerMeta.data.packagingChangeDate) {
            (0, $5F1Cw.deleteBannerDismissState)({
                accountId: accountId
            });
            return {
                ...bannerMeta,
                refresh: refresh
            };
        }
        if (workCategoryDismissState.bannerHiddenUntil > Date.now()) return {
            show: false
        };
        return {
            ...bannerMeta,
            ...bannerDismissState,
            refresh: refresh
        };
    }, [
        data,
        loading,
        error,
        workCategory,
        accountId,
        refresh
    ]);
};

});
parcelRegister("5F1Cw", function(module, exports) {

$parcel$export(module.exports, "deleteBannerDismissState", () => $7f992f4a64e67267$export$e21bb99d98e8c8b4);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
async function $7f992f4a64e67267$export$e21bb99d98e8c8b4({ accountId: accountId }) {
    try {
        await (0, $lRmyA.performDeleteRequest)(`/rest/api/3/user/properties/jsm-repackaging-banners-dismiss-state?accountId=${accountId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // https://data-portal.internal.atlassian.com/analytics/registry/71209
        (0, $guiFP.default)({
            meta: {
                id: 'deleteBannerDismissState',
                packageName: 'jiraRouterResourcesJsmRepackagingBanner',
                teamName: 'jenga'
            },
            error: error
        });
    }
}

});

parcelRegister("eAfm5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lA3Xt").then(()=>parcelRequire('2hkql'));

});


parcelRegister("k82mP", function(module, exports) {

$parcel$export(module.exports, "customerPermissionsPageDataResource", () => $f1d9ad56edd9ae35$export$ae3446385906310c);

var $lB25E = parcelRequire("lB25E");


const $f1d9ad56edd9ae35$export$ae3446385906310c = (0, $lB25E.createResource)({
    type: (0, $e71a72bed0222680$export$34a89f9aaa677bb5),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("fE13j")),
    maxAge: Infinity
});

});
const $e71a72bed0222680$export$34a89f9aaa677bb5 = 'CUSTOMER_PERMISSIONS';

parcelRegister("fE13j", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6M06z").then(()=>parcelRequire('cl5I5'));

});


parcelRegister("3BZ46", function(module, exports) {

$parcel$export(module.exports, "portalSettingsContextResource", () => $e7c6da4ab4bcbc67$export$4a3e29f235f3320c);

var $lB25E = parcelRequire("lB25E");
const $e7c6da4ab4bcbc67$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT = 'PORTAL_SETTINGS_CONTEXT';

const $e7c6da4ab4bcbc67$export$4a3e29f235f3320c = (0, $lB25E.createResource)({
    type: $e7c6da4ab4bcbc67$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("5J0IX"))
});

});
parcelRegister("5J0IX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("eMmNt").then(()=>parcelRequire('amrnA'));

});


parcelRegister("baiUo", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksListRoute", () => $67357e9f36f92662$export$cbed08b5b0671f5f);
$parcel$export(module.exports, "servicedeskPlaybooksEditRoute", () => $67357e9f36f92662$export$5920ce3a2ccf6e2b);

var $exb0h = parcelRequire("exb0h");
const $67357e9f36f92662$var$getProjectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $67357e9f36f92662$export$5575497f0592ee94 = 'servicedesk';
const $67357e9f36f92662$export$cbed08b5b0671f5f = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PLAYBOOKS_LIST),
    path: `${$67357e9f36f92662$var$getProjectSettingsUrl($67357e9f36f92662$export$5575497f0592ee94)}/playbooks`,
    exact: true
};
const $67357e9f36f92662$export$5920ce3a2ccf6e2b = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PLAYBOOKS_EDIT),
    path: `${$67357e9f36f92662$var$getProjectSettingsUrl($67357e9f36f92662$export$5575497f0592ee94)}/playbooks/:id`,
    exact: true
};

});

parcelRegister("9am5k", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kjYmV")
]).then(()=>parcelRequire('fh8Xl'));

});

parcelRegister("gAnp3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4UXJR").then(()=>parcelRequire('7xUUr'));

});

parcelRegister("4eVqf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("dGs7u")
]).then(()=>parcelRequire('jKdac'));

});

parcelRegister("f0awX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jxM3K")
]).then(()=>parcelRequire('9wlAo'));

});

parcelRegister("iXLtr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("52HQq")
]).then(()=>parcelRequire('dzeZc'));

});

parcelRegister("5OFaK", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2QuJS")
]).then(()=>parcelRequire('3UTwM'));

});

parcelRegister("khQDR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("4tEwS")
]).then(()=>parcelRequire('gO1WW'));

});

parcelRegister("jXX3j", function(module, exports) {

$parcel$export(module.exports, "getSettingsPath", () => $a9e26640ff83992b$export$67417cd3aaee582d);
const $a9e26640ff83992b$export$67417cd3aaee582d = (path, isJCS)=>isJCS ? path.replace('/jira/servicedesk/', '/jira/helpcenter/') : path;

});

parcelRegister("7d0GR", function(module, exports) {

$parcel$export(module.exports, "isHelpCenterSettingsPath", () => $e84b84c01ab7c9cf$export$bf8b98b87d485657);

var $eI5EY = parcelRequire("eI5EY");
const $e84b84c01ab7c9cf$export$bf8b98b87d485657 = ()=>{
    if (!(0, $eI5EY.fg)('jcs_master_flag')) return false;
    if (!false) return window.location.pathname.includes('jira/helpcenter/');
    return false;
};

});

parcelRegister("khSOi", function(module, exports) {

$parcel$export(module.exports, "useIsJCS", () => $28171976a0aaa7b1$export$927b5354181b3adf);
$parcel$export(module.exports, "useAsyncIsJCS", () => $28171976a0aaa7b1$export$3894a8f24b665478);
$parcel$export(module.exports, "isJCSTemplate", () => $28171976a0aaa7b1$export$afee907b7a66ef2b);

var $8LJqN = parcelRequire("8LJqN");

var $eI5EY = parcelRequire("eI5EY");

var $dwCxb = parcelRequire("dwCxb");
// TODO BERRY-2997: Replace with data from project context from BE
// When changing this file, make sure to search codebase for references to com.atlassian.jcs:customer-service-management
const $28171976a0aaa7b1$var$useIsJCSUnderFF = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $dwCxb.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate === 'com.atlassian.jcs:customer-service-management';
};
const $28171976a0aaa7b1$export$927b5354181b3adf = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('jcs_master_flag'), $28171976a0aaa7b1$var$useIsJCSUnderFF, ()=>false);
// Undefined can be used to check if project properties has been resolved or not
const $28171976a0aaa7b1$var$useAsyncIsJCSUnderFF = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $dwCxb.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate ? initialProjectTemplate === 'com.atlassian.jcs:customer-service-management' : undefined;
};
const $28171976a0aaa7b1$export$3894a8f24b665478 = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('jcs_master_flag'), $28171976a0aaa7b1$var$useAsyncIsJCSUnderFF, ()=>false);
const $28171976a0aaa7b1$var$isJCSTemplateUnderFF = (template)=>template === 'com.atlassian.jcs:customer-service-management';
const $28171976a0aaa7b1$var$isJCSTemplateFallback = (template)=>false;
const $28171976a0aaa7b1$export$afee907b7a66ef2b = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('jcs_master_flag'), $28171976a0aaa7b1$var$isJCSTemplateUnderFF, $28171976a0aaa7b1$var$isJCSTemplateFallback);

});
parcelRegister("dwCxb", function(module, exports) {

$parcel$export(module.exports, "useProjectProperties", () => $261b340823618fbf$export$58be98885c2d686a);

var $eUqFw = parcelRequire("eUqFw");

var $3OXzs = parcelRequire("3OXzs");

var $hTLlD = parcelRequire("hTLlD");

var $3LiTJ = parcelRequire("3LiTJ");

var $cPEpP = parcelRequire("cPEpP");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $WBLbN = parcelRequire("WBLbN");

var $fML59 = parcelRequire("fML59");
const $261b340823618fbf$export$d4c72bab9d6cc13a = {};
const $261b340823618fbf$var$Store = (0, $WBLbN.createStore)({
    name: 'project-properties',
    initialState: $261b340823618fbf$export$d4c72bab9d6cc13a,
    actions: $fML59.actions
});
const $261b340823618fbf$export$eebf791068e870dd = (0, $WBLbN.createHook)($261b340823618fbf$var$Store);
const $261b340823618fbf$export$58be98885c2d686a = (propertyKeys, projectIdOverride)=>{
    const { data: data } = (0, $cPEpP.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const projectId = projectIdOverride !== undefined ? projectIdOverride : data?.id && `${data.id}`;
    const [state, { get: get }] = $261b340823618fbf$export$eebf791068e870dd();
    const prevPropertyKeys = (0, $hzcvF.usePrevious)(propertyKeys);
    (0, $eUqFw.useEffect)(()=>{
        if (projectId === undefined) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraProjectPropertiesServices undefinedProjectId');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(propertyKeys, prevPropertyKeys) && !projectIdOverride) return;
        if (projectId) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        get(projectId, propertyKeys);
    }, [
        projectId,
        propertyKeys,
        prevPropertyKeys,
        get,
        createAnalyticsEvent,
        projectIdOverride
    ]);
    return projectId !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(state[projectId], (_, key)=>(0, (/*@__PURE__*/$parcel$interopDefault($3OXzs)))(propertyKeys, key)) : {};
};

});
parcelRegister("3OXzs", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");

var $jxg5X = parcelRequire("jxg5X");

var $4ZYEI = parcelRequire("4ZYEI");

var $hNahz = parcelRequire("hNahz");

var $hvbu2 = parcelRequire("hvbu2");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2c84401faa0612b2$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $2c84401faa0612b2$var$includes(collection, value, fromIndex, guard) {
    collection = $jxg5X(collection) ? collection : $hvbu2(collection);
    fromIndex = fromIndex && !guard ? $hNahz(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $2c84401faa0612b2$var$nativeMax(length + fromIndex, 0);
    return $4ZYEI(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $jkhuN(collection, value, fromIndex) > -1;
}
module.exports = $2c84401faa0612b2$var$includes;

});
parcelRegister("4ZYEI", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $1c8hB = parcelRequire("1c8hB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $3a3be8dd1917bddc$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3a3be8dd1917bddc$var$isString(value) {
    return typeof value == 'string' || !$1c8hB(value) && $hYEMs(value) && $2OY5s(value) == $3a3be8dd1917bddc$var$stringTag;
}
module.exports = $3a3be8dd1917bddc$var$isString;

});


parcelRegister("fML59", function(module, exports) {

$parcel$export(module.exports, "actions", () => $25fe75f2cbd4ad0a$export$e324594224ef24da);

var $eoHhV = parcelRequire("eoHhV");
const $25fe75f2cbd4ad0a$export$e324594224ef24da = {
    get: $eoHhV.get
};

});
parcelRegister("eoHhV", function(module, exports) {

$parcel$export(module.exports, "get", () => $6126316a064d2715$export$3988ae62b71be9a3);

var $iVIEg = parcelRequire("iVIEg");

var $kkgbD = parcelRequire("kkgbD");

var $8nrDO = parcelRequire("8nrDO");

var $dw98K = parcelRequire("dw98K");
const $6126316a064d2715$export$3988ae62b71be9a3 = (projectId, properties)=>({ getState: getState, setState: setState })=>{
        const currentProperties = getState()[projectId] || {};
        const missingProperties = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(properties, (0, (/*@__PURE__*/$parcel$interopDefault($8nrDO)))(currentProperties));
        missingProperties.length && (0, $dw98K.default)({
            baseUrl: '',
            projectId: projectId,
            properties: missingProperties
        }).then((fetchedProperties)=>{
            const latestProperties = getState()[projectId] || {};
            setState({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [projectId]: {
                    ...latestProperties,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ...missingProperties.reduce((result, name)=>{
                        const reducedResult = result;
                        const fetchedProperty = fetchedProperties[name];
                        // `undefined` inside state means that property was never requested.
                        // If value returned for the property is `undefined`, we will set it to `null`,
                        // to differentiate it from the unrequested state. Otherwise, returned value will be set.
                        reducedResult[name] = (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(fetchedProperty) ? null : fetchedProperty;
                        return reducedResult;
                    }, {})
                }
            });
        });
    };

});
parcelRegister("iVIEg", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $hKE3p = parcelRequire("hKE3p");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $dc802f203e524f15$var$difference = $9eFtX(function(array, values) {
    return $cRpul(array) ? $fa0Ox(array, $hKE3p(values, 1, $cRpul, true)) : [];
});
module.exports = $dc802f203e524f15$var$difference;

});
parcelRegister("fa0Ox", function(module, exports) {

var $lYFvJ = parcelRequire("lYFvJ");

var $lqZWH = parcelRequire("lqZWH");

var $6v6uu = parcelRequire("6v6uu");

var $kJvGp = parcelRequire("kJvGp");

var $74vSq = parcelRequire("74vSq");

var $8AO5Q = parcelRequire("8AO5Q");
/** Used as the size to enable large array optimizations. */ var $b0986bd506ee8a3d$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $b0986bd506ee8a3d$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $lqZWH, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $kJvGp(values, $74vSq(iteratee));
    if (comparator) {
        includes = $6v6uu;
        isCommon = false;
    } else if (values.length >= $b0986bd506ee8a3d$var$LARGE_ARRAY_SIZE) {
        includes = $8AO5Q;
        isCommon = false;
        values = new $lYFvJ(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $b0986bd506ee8a3d$var$baseDifference;

});


parcelRegister("dw98K", function(module, exports) {

$parcel$export(module.exports, "default", () => $d933a28077a68115$export$2e2bcd8739ae039);

var $95f8K = parcelRequire("95f8K");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d933a28077a68115$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, projectId: projectId, properties: properties })=>{
    const { project: project } = await (0, $95f8K.get)(baseUrl, {
        projectId: projectId,
        projectProperties: properties,
        consumerMeta: {
            id: 'remoteGet',
            packageName: 'jiraProjectPropertiesServices',
            teamName: 'jsd-shield'
        }
    });
    return project;
};

});





parcelRegister("aWbMq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hB0FT")
]).then(()=>parcelRequire('b6r6l'));

});

parcelRegister("9XEQV", function(module, exports) {

$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskJourneysRoute", () => $1a8972663e3c2e94$export$94adf8e91b84b806);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskJourneyConfigurationRoute", () => $1a8972663e3c2e94$export$c0d493d5e7c848d0);

var $exb0h = parcelRequire("exb0h");
const $1a8972663e3c2e94$export$94adf8e91b84b806 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-journeys`,
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys',
    exact: true
};
const $1a8972663e3c2e94$export$c0d493d5e7c848d0 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-journey-configuration`,
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId',
    exact: true
};

});

parcelRegister("g2KfS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("eLmxS")
]).then(()=>parcelRequire('lNXnv'));

});

parcelRegister("7Y2NF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("gHTJb")
]).then(()=>parcelRequire('dVgub'));

});

parcelRegister("7v9X2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8Sm6g").then(()=>parcelRequire('7kngu'));

});

parcelRegister("6ATHt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("a7huj")
]).then(()=>parcelRequire('ev6Eb'));

});

parcelRegister("g2JMk", function(module, exports) {

$parcel$export(module.exports, "slaMetricsDataResource", () => $add69932c0c4ef8d$export$6cdfca3e816e9661);

var $lB25E = parcelRequire("lB25E");
const $add69932c0c4ef8d$export$c5fa03c9ad8df0e2 = 'SLA_METRICS';

const $add69932c0c4ef8d$export$6cdfca3e816e9661 = (0, $lB25E.createResource)({
    type: $add69932c0c4ef8d$export$c5fa03c9ad8df0e2,
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("cN8eG")),
    maxAge: Infinity
});

});
parcelRegister("cN8eG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1VMb9").then(()=>parcelRequire('c7jir'));

});


parcelRegister("Tz24F", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("et2J9")
]).then(()=>parcelRequire('iT5dz'));

});

parcelRegister("8wgDH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("65eqK")
]).then(()=>parcelRequire('ajwbB'));

});

parcelRegister("kxUYW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cEX9n")
]).then(()=>parcelRequire('caYq6'));

});

parcelRegister("1lYZg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("6Qme0")
]).then(()=>parcelRequire('g5qNM'));

});

parcelRegister("jIMNW", function(module, exports) {

$parcel$export(module.exports, "ErrorDisplay", () => $c1a21cced81113cb$export$d56b0569bceb92ae);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $ijwdS = parcelRequire("ijwdS");

var $4Es8k = parcelRequire("4Es8k");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFpyz = parcelRequire("bFpyz");
const $c1a21cced81113cb$export$d56b0569bceb92ae = ({ refetch: refetch })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $bFpyz.default).errorDisplayHeading),
        description: formatMessage((0, $bFpyz.default).errorDisplayDescription),
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $ijwdS.default)),
        imageWidth: 160,
        maxImageHeight: 220,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: refetch,
            appearance: "link"
        }, formatMessage((0, $bFpyz.default).reloadNowButtonText))
    });
};

});
parcelRegister("4Es8k", function(module, exports) {

$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $5b95caa215479c6b$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gyaWd = parcelRequire("gyaWd");
function $5b95caa215479c6b$export$ebf64b9217c1b2a3(JiraIllustration = (0, $gyaWd.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $9t7rW.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $9t7rW.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $7JEyt.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _18s81ixx",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("gyaWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f352d69c1b682860$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $9TZf5 = parcelRequire("9TZf5");

var $hu73q = parcelRequire("hu73q");

var $3Pbzd = parcelRequire("3Pbzd");
const $f352d69c1b682860$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3Pbzd)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hu73q))
});
var $f352d69c1b682860$export$2e2bcd8739ae039 = $f352d69c1b682860$var$Illustration;
// for advanced use only
const $f352d69c1b682860$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("hu73q", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("3Pbzd", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("bFpyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $dff82db7f47ee099$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dff82db7f47ee099$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorDisplayHeading: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-heading",
        "defaultMessage": "We couldn\u2019t load intent templates"
    },
    errorDisplayDescription: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-description",
        "defaultMessage": "Wait a moment and then try reloading."
    },
    reloadNowButtonText: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.reload-now-button-text",
        "defaultMessage": "Reload"
    }
});

});


parcelRegister("aDZUE", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentBrowseIntentsSkeleton", () => $2107e9b992980109$export$444026e4d4f156e4);
$parcel$export(module.exports, "VirtualAgentIntentsTableSkeleton", () => $2107e9b992980109$export$9dca41144a6398d2);
$parcel$export(module.exports, "VirtualAgentStatisticsSkeleton", () => $2107e9b992980109$export$538762e63d6466fe);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $63ley = parcelRequire("63ley");

var $a1joa = parcelRequire("a1joa");

var $5hba0 = parcelRequire("5hba0");
const $2107e9b992980109$var$customCssStyles = null;
const $2107e9b992980109$export$444026e4d4f156e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($63ley))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
const $2107e9b992980109$export$9dca41144a6398d2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a1joa))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
const $2107e9b992980109$export$538762e63d6466fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5hba0))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("63ley", function(module, exports) {
module.exports = new URL("virtual-agent-browse-intents-app-skeleton.tpl.1eeb33c1.svg", import.meta.url).toString();

});

parcelRegister("a1joa", function(module, exports) {
module.exports = new URL("virtual-agent-intents-table-app-skeleton.tpl.e28c55f7.svg", import.meta.url).toString();

});

parcelRegister("5hba0", function(module, exports) {
module.exports = new URL("virtual-agent-virtual-agent-statistics-app-skeleton.tpl.19ee5056.svg", import.meta.url).toString();

});


parcelRegister("jw4Ou", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4701379add50f34$export$2e2bcd8739ae039);

var $eI5EY = parcelRequire("eI5EY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e4701379add50f34$export$2e2bcd8739ae039 = {
    get () {
        return (0, $eI5EY.fg)('expose_channels_on_va_conversation_history');
    }
};

});

parcelRegister("bHwXn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("fZcmC")
]).then(()=>parcelRequire('el3hk'));

});

parcelRegister("cE8e4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("20sq1")
]).then(()=>parcelRequire('fgxZN'));

});

parcelRegister("8lHxq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("etJLF")
]).then(()=>parcelRequire('hOWr3'));

});

parcelRegister("hIbMf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("bYLIe")
]).then(()=>parcelRequire('ibVof'));

});

parcelRegister("1TSUO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("eYXxG")
]).then(()=>parcelRequire('2I6K7'));

});

parcelRegister("asVoY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("cWESH")
]).then(()=>parcelRequire('fs5SN'));

});

parcelRegister("8mp6E", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("lAPNY")
]).then(()=>parcelRequire('5Aoxl'));

});

parcelRegister("lL5d7", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("h5Mpb")
]).then(()=>parcelRequire('5gCgJ'));

});

parcelRegister("aje9D", function(module, exports) {

$parcel$export(module.exports, "changeManagementAssetConfigurationStatusResource", () => $2b5424021ed4802a$export$7570280d22ac9424);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $lB25E = parcelRequire("lB25E");
const $2b5424021ed4802a$export$4f27975b8a363797 = 'CHANGE_MANAGEMENT_ASSET_CONFIGURATION_STATUS';

const $2b5424021ed4802a$var$getDataLoader = ()=>(parcelRequire("f45LG"));
const $2b5424021ed4802a$var$getKey = ({ match: match })=>typeof match.params.projectKey === 'string' ? match.params.projectKey : '';
const $2b5424021ed4802a$export$7570280d22ac9424 = (0, $lB25E.createResource)({
    type: $2b5424021ed4802a$export$4f27975b8a363797,
    getKey: $2b5424021ed4802a$var$getKey,
    getDataLoader: $2b5424021ed4802a$var$getDataLoader,
    maxAge: Infinity
});

});
parcelRegister("f45LG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6C3D2").then(()=>parcelRequire('hGYFw'));

});


parcelRegister("6ebW2", function(module, exports) {

$parcel$export(module.exports, "changeManagementSettingsProjectConfigurationResource", () => $61b06a43a204901d$export$2413ba18ec38282d);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $lB25E = parcelRequire("lB25E");
const $61b06a43a204901d$export$c0636b6062501e0b = 'CHANGE_MANAGEMENT_SETTINGS_PROJECT_CONFIG';

const $61b06a43a204901d$var$getDataLoader = ()=>(parcelRequire("4Xon8"));
const $61b06a43a204901d$var$getKey = ({ match: match })=>typeof match.params.projectKey === 'string' ? match.params.projectKey : '';
const $61b06a43a204901d$export$2413ba18ec38282d = (0, $lB25E.createResource)({
    type: $61b06a43a204901d$export$c0636b6062501e0b,
    getKey: $61b06a43a204901d$var$getKey,
    getDataLoader: $61b06a43a204901d$var$getDataLoader,
    maxAge: Infinity
});

});
parcelRegister("4Xon8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aQwu1").then(()=>parcelRequire('bmyab'));

});


parcelRegister("9oI9i", function(module, exports) {

$parcel$export(module.exports, "LoadingComponent", () => $cfb8808f819670e5$export$7db30d367db7d20a);
$parcel$export(module.exports, "LazyCsatSettingsPage", () => $cfb8808f819670e5$export$32eb62914bae0e84);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $4Bees = parcelRequire("4Bees");

var $4FWw6 = parcelRequire("4FWw6");
const $cfb8808f819670e5$export$7db30d367db7d20a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4FWw6.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large"
    }));

const $cfb8808f819670e5$export$32eb62914bae0e84 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("89NMf")), {
    moduleId: "./src/packages/servicedesk/csat/src/index.tsx"
});

});
parcelRegister("4FWw6", function(module, exports) {

$parcel$export(module.exports, "SpinnerContainer", () => $7c2f7d4275f8833f$export$a5e06607a5ac6158);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line import/order

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $7c2f7d4275f8833f$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i68cl",
            __cmplp.className
        ])
    });
});

});

parcelRegister("89NMf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jBy3n").then(()=>parcelRequire('cH6gV'));

});


parcelRegister("lq02o", function(module, exports) {

$parcel$export(module.exports, "languageTranslationsResource", () => $056c0fb95de7914f$export$f51887e33895eab9);
$parcel$export(module.exports, "outgoingEmailStateModelResource", () => $056c0fb95de7914f$export$c460156a7e6b85b2);

var $lB25E = parcelRequire("lB25E");
const $056c0fb95de7914f$export$9f529be3aeae01ea = 'JSM Language Translations';
const $056c0fb95de7914f$export$ecd381e388e8c56f = "Language Support Customer Notification's Outgoing Email State";

const $056c0fb95de7914f$export$f51887e33895eab9 = (0, $lB25E.createResource)({
    type: 'Language Translations',
    getKey: ({ match: { params: { projectKey: projectKey, languageKey: languageKey } } })=>`${$056c0fb95de7914f$export$9f529be3aeae01ea}-${projectKey}-${languageKey}`,
    getDataLoader: ()=>(parcelRequire("1fWrp")),
    maxAge: Infinity
});

const $056c0fb95de7914f$export$c460156a7e6b85b2 = (0, $lB25E.createResource)({
    type: 'Outgoing Email State Model',
    getKey: ()=>`${$056c0fb95de7914f$export$ecd381e388e8c56f}`,
    getDataLoader: ()=>(parcelRequire("kwGAJ")),
    maxAge: Infinity
});

});
parcelRegister("1fWrp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("apMEE").then(()=>parcelRequire('bNtxL'));

});

parcelRegister("kwGAJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6jXt5").then(()=>parcelRequire('1aqBc'));

});


parcelRegister("ecIZv", function(module, exports) {

$parcel$export(module.exports, "LazyInternalNotificationSettingsPage", () => $6254efdc43440b61$export$501979bd6d492c43);

var $6VZoe = parcelRequire("6VZoe");

const $6254efdc43440b61$export$501979bd6d492c43 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("gUcox")), {
    moduleId: "./src/packages/servicedesk/notification-internal/src/ui/index.tsx"
});

});
parcelRegister("gUcox", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("5PlPP")
]).then(()=>parcelRequire('fpanz'));

});


parcelRegister("ILATv", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("b2AAQ")
]).then(()=>parcelRequire('iCpeT'));

});

parcelRegister("8ujhR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("eSQjy")
]).then(()=>parcelRequire('jnJkb'));

});

parcelRegister("9tVMM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9P7jz").then(()=>parcelRequire('1NzGW'));

});

parcelRegister("9vocX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("f4Ghb")
]).then(()=>parcelRequire('5Y1oO'));

});

parcelRegister("i7e33", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("d69y3")
]).then(()=>parcelRequire('b7PAf'));

});

parcelRegister("ihsby", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("gwFc6")
]).then(()=>parcelRequire('6shol'));

});

parcelRegister("jRUqc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("2piQf")
]).then(()=>parcelRequire('h6ySE'));

});

parcelRegister("63gAp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8T0Ei").then(()=>parcelRequire('iDchO'));

});

parcelRegister("giTdm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("f9VUQ")
]).then(()=>parcelRequire('n7EmG'));

});

parcelRegister("bAVNR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4PXFL").then(()=>parcelRequire('hWMFm'));

});

parcelRegister("jGi07", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("h6c0y")
]).then(()=>parcelRequire('5Aqtw'));

});

parcelRegister("h1RDW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bdRgO").then(()=>parcelRequire('1XDmP'));

});

parcelRegister("cyAlu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("4OxdX")
]).then(()=>parcelRequire('kiCAd'));

});

parcelRegister("it9xs", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("lOWsg")
]).then(()=>parcelRequire('84yQh'));

});

parcelRegister("9n4ZQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("65l4O")
]).then(()=>parcelRequire('fFAfT'));

});

parcelRegister("hbnZD", function(module, exports) {

$parcel$export(module.exports, "cardCoverImageResource", () => $0e21b8c7adec73cf$export$f37f52e28126ce75);

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $hYLcu = parcelRequire("hYLcu");

const $0e21b8c7adec73cf$export$f37f52e28126ce75 = (0, $buJlM.createRelayResource)({
    type: (0, $97128dcae00d9767$export$d9d248919fbd0611),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $hYLcu.default),
            variables: {
                boardId: (0, $huI7r.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("hYLcu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8da62d3ce09b83f2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<18030b1362ffffdd2f24b83852b88efd>>
 * @relayHash b790d69589aa0ef2a06a10dc57fc6bfc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4216a4fc24eb7ed0390f1effcdb5558af09a70f95660a0c572ae4b531ddc98fc
const $8da62d3ce09b83f2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cardCoverSettingsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "toggle_boardSettingsCard_CardCoverToggle"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "cardPreview_boardSettingsCard"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cardCoverSettingsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CardMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "cardMedia",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "4216a4fc24eb7ed0390f1effcdb5558af09a70f95660a0c572ae4b531ddc98fc",
            "metadata": {},
            "name": "cardCoverSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8da62d3ce09b83f2$var$node.hash = "eb3068eeffbe9ec2fb99186c54005ea6";
var $8da62d3ce09b83f2$export$2e2bcd8739ae039 = $8da62d3ce09b83f2$var$node;

});

const $97128dcae00d9767$export$d9d248919fbd0611 = 'BOARD_CONTEXT_CARD_COVER_SETTINGS';


parcelRegister("a0UvO", function(module, exports) {

$parcel$export(module.exports, "customFiltersResource", () => $f5c0157e9c9bc2c1$export$3e390340716755de);

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $KeWba = parcelRequire("KeWba");

const $f5c0157e9c9bc2c1$export$3e390340716755de = (0, $buJlM.createRelayResource)({
    type: (0, $95ba5feea0d7365a$export$5917fd27c14066cd),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $KeWba.default),
            variables: {
                boardId: (0, $huI7r.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("KeWba", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a849caa59de39c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c655bf5d42bc04990088e48dc6b757f>>
 * @relayHash 82ae1b9c2b4e7b31e211094a4e3f4f3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686
const $95a849caa59de39c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "customFiltersQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CustomFilter",
                                    "kind": "LinkedField",
                                    "name": "customFilters",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "card_projectSettingsCustomFilters_customFilterFragmentRef"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.customFilters"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "card_projectSettingsCustomFilters_boardScopeFragmentRef"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "expandedCard_projectSettingsCustomFilters_boardScopeFragmentRef"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "customFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "FilterQuery",
                                    "kind": "LinkedField",
                                    "name": "filterQuery",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "sanitisedJql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errors"
                                        }
                                    ]
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686",
            "metadata": {},
            "name": "customFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$95a849caa59de39c$var$node.hash = "2c5c0d030a87f3820766a2a896d71275";
var $95a849caa59de39c$export$2e2bcd8739ae039 = $95a849caa59de39c$var$node;

});

const $95ba5feea0d7365a$export$5917fd27c14066cd = 'NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS';


parcelRegister("3BLIV", function(module, exports) {

$parcel$export(module.exports, "projectSettingsToolchainResource", () => $4ca6c346e423908a$export$182dfe2bc7c28567);

var $buJlM = parcelRequire("buJlM");

var $gKd1x = parcelRequire("gKd1x");
const $4ca6c346e423908a$export$b8927fea69d9f414 = 'PROJECT_SETTINGS_TOOLCHAIN';
const $4ca6c346e423908a$export$182dfe2bc7c28567 = (0, $buJlM.createRelayResource)({
    type: $4ca6c346e423908a$export$b8927fea69d9f414,
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $gKd1x.default),
            variables: {
                cloudId: tenantContext?.cloudId || ''
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("gKd1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a36fb8785d94a5c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a2c9dc099d3b7d79cd74bd591996a945>>
 * @relayHash f5bf042c501578b47d326c7288427026
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409
const $8a36fb8785d94a5c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "concreteType": "DvcsQuery",
            "kind": "LinkedField",
            "name": "dvcs",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        }
                    ],
                    "concreteType": "DvcsBitbucketWorkspaceConnection",
                    "kind": "LinkedField",
                    "name": "bitbucketWorkspacesLinkedToSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DvcsBitbucketWorkspaceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_projectSettingsToolchainQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_projectSettingsToolchainQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409",
            "metadata": {},
            "name": "ui_projectSettingsToolchainQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8a36fb8785d94a5c$var$node.hash = "190735208b3c7baafbfc3c1808fa801b";
var $8a36fb8785d94a5c$export$2e2bcd8739ae039 = $8a36fb8785d94a5c$var$node;

});


parcelRegister("a3WTo", function(module, exports) {

$parcel$export(module.exports, "roadmapSettingsResource", () => $025d96f79795e52a$export$7901a008bd73bf46);

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $bAFgb = parcelRequire("bAFgb");

const $025d96f79795e52a$export$7901a008bd73bf46 = (0, $buJlM.createRelayResource)({
    type: (0, $1eef2c9e2260305d$export$e905b9170ecbb599),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $bAFgb.default),
            variables: {
                sourceAri: (0, $huI7r.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                locationAri: undefined
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});

});
parcelRegister("bAFgb", function(module, exports) {

$parcel$export(module.exports, "default", () => $284ffc3ab370ce43$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<549802b43e67112dd5fba3309099c2de>>
 * @relayHash 19ad9a547bce255c35adc444386a03af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80
const $284ffc3ab370ce43$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locationAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "locationARI",
            "variableName": "locationAri"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isSprintsFeatureEnabled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "roadmapSettingsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "RoadmapConfiguration",
                                        "kind": "LinkedField",
                                        "name": "roadmapConfiguration",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "RoadmapBoardConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "boardConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "childIssuesSchedulingToggle_boardSettingsRoadmap"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "childIssuesSchedulingPreview_boardSettingsRoadmap"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapForSource.roadmapConfiguration.boardConfiguration"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapForSource.roadmapConfiguration"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "roadmapSettingsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "RoadmapConfiguration",
                                    "kind": "LinkedField",
                                    "name": "roadmapConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "RoadmapBoardConfiguration",
                                            "kind": "LinkedField",
                                            "name": "boardConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isChildIssuePlanningEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "childIssuePlanningMode"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80",
            "metadata": {},
            "name": "roadmapSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$284ffc3ab370ce43$var$node.hash = "31c20159daaa03716587a1ccbe27ab14";
var $284ffc3ab370ce43$export$2e2bcd8739ae039 = $284ffc3ab370ce43$var$node;

});


parcelRegister("gvLvJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("l03hF")
]).then(()=>parcelRequire('ap7ak'));

});

parcelRegister("cFo24", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("dlJ5e")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("3vBNG")
]).then(()=>parcelRequire('anuF9'));

});

parcelRegister("dkNWL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("7igMR")
]).then(()=>parcelRequire('4Org5'));

});

parcelRegister("7e4qI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("7LTGd")
]).then(()=>parcelRequire('azOrC'));

});

parcelRegister("gDRUr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("l1KCV")
]).then(()=>parcelRequire('1g8fI'));

});

parcelRegister("5tF7w", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("79uJ5")),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("zWKyr")
]).then(()=>parcelRequire('9Ahcr'));

});

parcelRegister("5kZuD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("1Wl62")
]).then(()=>parcelRequire('j3tbx'));

});

parcelRegister("62C1J", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("03UdH").then(()=>parcelRequire('61eeP'));

});

parcelRegister("c1YRC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("2vPGy")
]).then(()=>parcelRequire('1Pujx'));

});

parcelRegister("2tF49", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("gw0m1")
]).then(()=>parcelRequire('lav0B'));

});

parcelRegister("gcXWF", function(module, exports) {

$parcel$export(module.exports, "jsmBoardRoute", () => $2bd2ada1d304a75f$export$a192088aab559fa1);

var $exb0h = parcelRequire("exb0h");
const $2bd2ada1d304a75f$export$a192088aab559fa1 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS),
    exact: true
};

});

parcelRegister("2VE1N", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("7SZy3")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("dATFB")
]).then(()=>parcelRequire('fTb4A'));

});

parcelRegister("59qvl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("a9oNj")
]).then(()=>parcelRequire('iLnp2'));

});

parcelRegister("fILpt", function(module, exports) {

$parcel$export(module.exports, "getCalendarFilterFieldsResource", () => $770b70483961ea68$export$5f02bf5f04197ed7);
$parcel$export(module.exports, "useCalendarFilterResource", () => $770b70483961ea68$export$70361b748d216408);

var $JRB5w = parcelRequire("JRB5w");

var $lRmyA = parcelRequire("lRmyA");

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $a8V3L = parcelRequire("a8V3L");


var $jaKS8 = parcelRequire("jaKS8");
const $770b70483961ea68$var$fetchFilterFields = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $fbdb8beb1b8cc007$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    contextFieldsFilter: {
                        searchString: (0, $a8V3L.REQUEST_TYPE_FILTER)
                    },
                    jqlContext: jqlContext
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return (0, $jaKS8.transformAndReport)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $JRB5w.isHttpClientErrorResponse)(error)) (0, $jaKS8.reportError)(error);
        return 0, $a8V3L.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $770b70483961ea68$var$filterFieldsResource = (0, $lB25E.createResource)({
    type: (0, $a8V3L.RESOURCE_TYPE_FILTER_FIELD),
    getKey: ()=>(0, $a8V3L.RESOURCE_TYPE_FILTER_FIELD),
    getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        const jqlContext = `project = '${projectIdOrKey}'`;
        return $770b70483961ea68$var$fetchFilterFields(cloudId, jqlContext);
    },
    maxAge: Infinity
});
const $770b70483961ea68$export$5f02bf5f04197ed7 = ()=>$770b70483961ea68$var$filterFieldsResource;
const $770b70483961ea68$export$70361b748d216408 = ()=>(0, $lB25E.useResource)($770b70483961ea68$var$filterFieldsResource);

});
parcelRegister("a8V3L", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NAME", () => $996bfa2502238e2c$export$186e93e8ef3f9358);
$parcel$export(module.exports, "PACKAGE_NAME", () => $996bfa2502238e2c$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $996bfa2502238e2c$export$d57b6b390e78d90f);
$parcel$export(module.exports, "REQUEST_TYPE_FILTER", () => $996bfa2502238e2c$export$2c388650eabddf5e);
$parcel$export(module.exports, "RESOURCE_TYPE_FILTER_FIELD", () => $996bfa2502238e2c$export$2019de80301f1da);
$parcel$export(module.exports, "DEFAULT_CALENDAR_FILTER_FIELDS", () => $996bfa2502238e2c$export$2912f30d4328fc00);
const $996bfa2502238e2c$export$186e93e8ef3f9358 = 'calendarFilterFieldResource';
const $996bfa2502238e2c$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskCalendar';
const $996bfa2502238e2c$export$d57b6b390e78d90f = 'jsd-shield';
const $996bfa2502238e2c$export$2c388650eabddf5e = 'request type';
const $996bfa2502238e2c$export$2019de80301f1da = 'RESOURCE_TYPE_FILTER_FIELD';
const $996bfa2502238e2c$export$2912f30d4328fc00 = [
    'status',
    'assignee'
];

});

const $fbdb8beb1b8cc007$export$2b91517d6d5b4365 = `
query findRequestTypeCustomFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;

parcelRegister("jaKS8", function(module, exports) {

$parcel$export(module.exports, "TARGET_FILTER_TYPE", () => $1da546145946fa4b$export$64f54b13b7aea793);
$parcel$export(module.exports, "reportError", () => $1da546145946fa4b$export$b33b857ad1d9900e);
$parcel$export(module.exports, "transformAndReport", () => $1da546145946fa4b$export$af2aa11c88c551af);

var $guiFP = parcelRequire("guiFP");

var $a8V3L = parcelRequire("a8V3L");
const $1da546145946fa4b$export$64f54b13b7aea793 = 'com.atlassian.servicedesk:vp-origin';
const $1da546145946fa4b$var$TARGET_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
const $1da546145946fa4b$export$b33b857ad1d9900e = (error)=>{
    (0, $guiFP.default)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: (0, $a8V3L.RESOURCE_TYPE_NAME),
            packageName: (0, $a8V3L.PACKAGE_NAME),
            teamName: (0, $a8V3L.TEAM_NAME)
        }
    });
};
const $1da546145946fa4b$export$af2aa11c88c551af = (response)=>{
    const edges = response.data?.jira?.jqlBuilder?.fields?.edges;
    // There may be ambigious custom fields with same name, so find the correct one and pass to JQLBuilder
    const requestType = edges?.find((edge)=>edge?.node?.type === $1da546145946fa4b$export$64f54b13b7aea793 && edge?.node?.searchTemplate?.key === $1da546145946fa4b$var$TARGET_FILTER_SEARCH_TEMPLATE)?.node;
    if (!requestType) $1da546145946fa4b$export$b33b857ad1d9900e(new Error('Unable to prefetch request type'));
    // if requestType field found, add it to existing default calendar filter fields
    return requestType ? [
        {
            ...requestType,
            searchTemplate: requestType.searchTemplate.key,
            fieldType: requestType.type
        },
        ...(0, $a8V3L.DEFAULT_CALENDAR_FILTER_FIELDS)
    ] : (0, $a8V3L.DEFAULT_CALENDAR_FILTER_FIELDS);
};

});


parcelRegister("3SuBN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("i6ssL")
]).then(()=>parcelRequire('2MHsR'));

});

parcelRegister("hFzUG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("b1WAv")
]).then(()=>parcelRequire('2vUTH'));

});

parcelRegister("2gjhx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("65y8b")
]).then(()=>parcelRequire('lIV48'));

});

parcelRegister("k0e1o", function(module, exports) {

$parcel$export(module.exports, "servicedeskChangeCalendarRoute", () => $c97df291f3cf4bc4$export$3dbc16ae422c469);

var $exb0h = parcelRequire("exb0h");
const $c97df291f3cf4bc4$export$3dbc16ae422c469 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR),
    path: '/jira/servicedesk/projects/:projectKey/change-calendar',
    exact: true
};

});

parcelRegister("1o2nL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jFTOZ")
]).then(()=>parcelRequire('7V0JL'));

});

parcelRegister("N1heu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3lcly").then(()=>parcelRequire('d4Bvf'));

});

parcelRegister("c4Cxp", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAssetsImportTypeForgeDataResource", () => $8aecdcc7d552ca0e$export$58d2462746e91c7d);

var $lB25E = parcelRequire("lB25E");

const $8aecdcc7d552ca0e$var$getDataLoader = ()=>(parcelRequire("eeILm"));
const $8aecdcc7d552ca0e$export$58d2462746e91c7d = (0, $lB25E.createResource)({
    type: 'ASSETS_IMPORT_TYPE_FORGE_DATA',
    getKey: ()=>'extensions',
    getDataLoader: $8aecdcc7d552ca0e$var$getDataLoader,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("eeILm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lGAOb").then(()=>parcelRequire('9tDIa'));

});


parcelRegister("2R39g", function(module, exports) {

$parcel$export(module.exports, "insightObjectResource", () => $6dcb08a484c7adbd$export$215464c8085c5e35);

var $lB25E = parcelRequire("lB25E");

var $gY2Nz = parcelRequire("gY2Nz");
const $6dcb08a484c7adbd$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT = 'SERVICEDESK_INSIGHT_OBJECT';
const $6dcb08a484c7adbd$export$215464c8085c5e35 = (0, $lB25E.createResource)({
    type: $6dcb08a484c7adbd$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT,
    getKey: ({ match: match })=>match.params.objectId || '',
    getData: $gY2Nz.default,
    isBrowserOnly: true
});

});
parcelRegister("gY2Nz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc074aaa670fd4e$export$2e2bcd8739ae039);

var $6iz4v = parcelRequire("6iz4v");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $2OdyW = parcelRequire("2OdyW");

var $5yh8X = parcelRequire("5yh8X");

var $1aPBP = parcelRequire("1aPBP");

var $eEeZ0 = parcelRequire("eEeZ0");

var $aeCba = parcelRequire("aeCba");

var $bhwgQ = parcelRequire("bhwgQ");
const $9fc074aaa670fd4e$var$fetchInsightObjectDetails = async (routeDataContext, routerContext)=>{
    try {
        const { match: { params: params } } = routeDataContext;
        const { objectId: objectId } = params;
        if (objectId == null) return null;
        const workspaceId = await (0, $aeCba.default)(routeDataContext, routerContext);
        if (workspaceId == null) return null;
        const data = await (0, $2OdyW.default)((0, $eEeZ0.getCmdbObjectByIdUrl)(workspaceId, objectId));
        (0, $6iz4v.setMark)((0, $5yh8X.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraServicedeskInsightObjectResource', error);
        (0, $guiFP.default)({
            meta: {
                id: 'jiraServicedeskInsightObjectResource',
                packageName: 'jiraSpa'
            },
            error: error
        });
        throw error;
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9fc074aaa670fd4e$export$2e2bcd8739ae039 = async (routeDataContext, routerContext)=>{
    const { tenantContext: tenantContext } = routerContext;
    if ((0, $eI5EY.fg)('jsm_throw_error_on_resource_auth_pre-check_failed')) {
        // Early exit on these cases and return a valid response. We don't want to flood sentry.
        if (!(0, $bhwgQ.checkAuthentication)(tenantContext)) throw (0, $1aPBP.createResourceError)({
            component: 'spa.view.routes.servicedesk.cmdb-object.getData',
            message: 'Current user is not authenticated',
            name: 'AuthenticationError',
            skipSentry: true
        });
    } else if (!(0, $bhwgQ.checkAuthentication)(tenantContext)) return null;
    return $9fc074aaa670fd4e$var$fetchInsightObjectDetails(routeDataContext, routerContext);
};

});
parcelRegister("eEeZ0", function(module, exports) {

$parcel$export(module.exports, "getCmdbObjectByIdUrl", () => $9c6f81b5e0e0cf6b$export$d33c3e25476d091d);
$parcel$export(module.exports, "getCmdbObjectByIdUrlWithoutQueryParams", () => $9c6f81b5e0e0cf6b$export$6ef8997552257871);
$parcel$export(module.exports, "getCmdbObjectByIdActivityUrl", () => $9c6f81b5e0e0cf6b$export$20c207abffb62450);
$parcel$export(module.exports, "getCmdbObjectByIdAvatarUrl", () => $9c6f81b5e0e0cf6b$export$31df868d16d545f8);
$parcel$export(module.exports, "getCmdbObjectByIdReferenceInfoUrl", () => $9c6f81b5e0e0cf6b$export$5044a1e9fc201773);
$parcel$export(module.exports, "getCmdbObjectCloneByIdUrl", () => $9c6f81b5e0e0cf6b$export$d7f6dc1d4f622458);
$parcel$export(module.exports, "getCmdbObjectCreateUrl", () => $9c6f81b5e0e0cf6b$export$9cdc19e8944d38cf);
$parcel$export(module.exports, "getCmdbObjectNavlistUrl", () => $9c6f81b5e0e0cf6b$export$bf9c534c2cd21829);
$parcel$export(module.exports, "getCmdbObjectNavlistQueryLanguageUrl", () => $9c6f81b5e0e0cf6b$export$b35334340ee827fa);
$parcel$export(module.exports, "getCmdbObjectRecentUrl", () => $9c6f81b5e0e0cf6b$export$a0a7c6f22bebdef0);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageTotalCountUrl", () => $9c6f81b5e0e0cf6b$export$ee74f95a469c4433);
$parcel$export(module.exports, "getCmdbObjectSearchUrl", () => $9c6f81b5e0e0cf6b$export$1016ae73c04d9079);
$parcel$export(module.exports, "getCmdbAttributeSearchUrl", () => $9c6f81b5e0e0cf6b$export$cb41514f2508b033);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageUrl", () => $9c6f81b5e0e0cf6b$export$84a34ee3f18e226);
$parcel$export(module.exports, "getCmdbAsyncObjectExportUrl", () => $9c6f81b5e0e0cf6b$export$878b627ac685384e);
$parcel$export(module.exports, "getCmdbAsyncBulkQrCodeUrl", () => $9c6f81b5e0e0cf6b$export$8eb3a6b36886db0);
$parcel$export(module.exports, "getCmdbAsyncBulkDeleteUrl", () => $9c6f81b5e0e0cf6b$export$b02201bcaeb75291);
$parcel$export(module.exports, "getCmdbAsyncBulkEditUrl", () => $9c6f81b5e0e0cf6b$export$f4d68a6f0e3217b5);

var $53ciZ = parcelRequire("53ciZ");

var $cPk3F = parcelRequire("cPk3F");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object
 */ const $9c6f81b5e0e0cf6b$var$getCmdbObjectUrl = (workspaceId)=>`${(0, $cPk3F.getCmdbRestBaseUrl)(workspaceId)}/object`;
const $9c6f81b5e0e0cf6b$export$d33c3e25476d091d = (workspaceId, objectId, includeExtendedInfo = false)=>{
    const path = $9c6f81b5e0e0cf6b$export$6ef8997552257871(workspaceId, objectId);
    if (!includeExtendedInfo) return `${path}?${(0, $53ciZ.stringify)({
        includeExtendedInfo: includeExtendedInfo
    })}`;
    return path;
};
const $9c6f81b5e0e0cf6b$export$6ef8997552257871 = (workspaceId, objectId)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/${objectId}`;
const $9c6f81b5e0e0cf6b$export$20c207abffb62450 = (workspaceId, objectId, queryParams)=>`${$9c6f81b5e0e0cf6b$export$6ef8997552257871(workspaceId, objectId)}/activity?${(0, $53ciZ.stringify)(queryParams)}`;
const $9c6f81b5e0e0cf6b$export$31df868d16d545f8 = (workspaceId, objectId)=>`${$9c6f81b5e0e0cf6b$export$6ef8997552257871(workspaceId, objectId)}/avatar`;
const $9c6f81b5e0e0cf6b$export$5044a1e9fc201773 = (workspaceId, objectId)=>`${$9c6f81b5e0e0cf6b$export$6ef8997552257871(workspaceId, objectId)}/referenceinfo`;
const $9c6f81b5e0e0cf6b$export$d7f6dc1d4f622458 = (workspaceId, objectId)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/clone/${objectId}`;
const $9c6f81b5e0e0cf6b$export$9cdc19e8944d38cf = (workspaceId)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/create`;
const $9c6f81b5e0e0cf6b$export$bf9c534c2cd21829 = (workspaceId)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/navlist`;
const $9c6f81b5e0e0cf6b$export$b35334340ee827fa = (workspaceId)=>`${$9c6f81b5e0e0cf6b$export$bf9c534c2cd21829(workspaceId)}/aql`;
const $9c6f81b5e0e0cf6b$export$a0a7c6f22bebdef0 = (workspaceId, queryParams)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/recent?${(0, $53ciZ.stringify)(queryParams)}`;
const $9c6f81b5e0e0cf6b$export$ee74f95a469c4433 = (workspaceId)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/aql/totalcount`;
const $9c6f81b5e0e0cf6b$export$1016ae73c04d9079 = (workspaceId, queryParams)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/search?${(0, $53ciZ.stringify)(queryParams)}`;
const $9c6f81b5e0e0cf6b$export$cb41514f2508b033 = (workspaceId, queryParams)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/searchbyattributes?${(0, $53ciZ.stringify)(queryParams)}`;
const $9c6f81b5e0e0cf6b$export$84a34ee3f18e226 = (workspaceId, queryParams)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/aql?${(0, $53ciZ.stringify)(queryParams)}`;
const $9c6f81b5e0e0cf6b$export$878b627ac685384e = (workspaceId)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/bulkexport`;
const $9c6f81b5e0e0cf6b$export$8eb3a6b36886db0 = (workspaceId, queryParams)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/bulkqrcode?${(0, $53ciZ.stringify)(queryParams)}`;
const $9c6f81b5e0e0cf6b$export$b02201bcaeb75291 = (workspaceId)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/bulkdelete`;
const $9c6f81b5e0e0cf6b$export$f4d68a6f0e3217b5 = (workspaceId)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/bulkedit`;

});
parcelRegister("cPk3F", function(module, exports) {

$parcel$export(module.exports, "getCmdbRestBaseUrl", () => $a20c166f3eb000cf$export$28b6c003daedf1c2);
const $a20c166f3eb000cf$export$28b6c003daedf1c2 = (workspaceId)=>`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;

});




parcelRegister("1xdVV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6MVV2").then(()=>parcelRequire('ob5Eg'));

});

parcelRegister("kYbZu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("1XhbT")
]).then(()=>parcelRequire('SFMYO'));

});

parcelRegister("5yuvk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("fluxa")
]).then(()=>parcelRequire('hAUgK'));

});

parcelRegister("elg6g", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2ozyE")
]).then(()=>parcelRequire('69gCp'));

});

parcelRegister("80TdY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("aruzd")
]).then(()=>parcelRequire('lmYMe'));

});

parcelRegister("gdgF7", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2EWfN")
]).then(()=>parcelRequire('14WKF'));

});

parcelRegister("kq8if", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("gR50v")
]).then(()=>parcelRequire('inhGb'));

});

parcelRegister("f4fU7", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("lfjBo")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("9ZqB6")
]).then(()=>parcelRequire('1zf9p'));

});

parcelRegister("TEE6P", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("7130r")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("5pyDL")
]).then(()=>parcelRequire('lQfg3'));

});

parcelRegister("9D9ow", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7Ij2K").then(()=>parcelRequire('9Q1at'));

});

parcelRegister("cgHBu", function(module, exports) {

$parcel$export(module.exports, "entitlementsCustomerQueryResource", () => $c91d400cbfcc7da5$export$78737979422d6907);

var $buJlM = parcelRequire("buJlM");

var $dxWcW = parcelRequire("dxWcW");
const $c91d400cbfcc7da5$export$78737979422d6907 = (0, $buJlM.createRelayResource)({
    type: 'ENTITLEMENTS_CUSTOMER_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $dxWcW.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("dxWcW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2062bc7e23061a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d711ace41d650be975013cf5a90d182>>
 * @relayHash 2d56ae07e9224712e6cbeb1d40c0d517
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38
const $5f2062bc7e23061a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v9 = [
        v7 /*: any*/ ,
        v6 /*: any*/ 
    ], v10 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "entitlementsCustomerQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v2 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v4 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "customerService.productConnections.edges"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW",
                                "path": "customerService.productConnections"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "individualByAccountId",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v7 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "customerService.individualByAccountId.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v7 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": true
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "customerService.individualByAccountId.entitlementList"
                                                },
                                                v8 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceIndividual"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.individualByAccountId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "entitlementsCustomerQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": v9 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "entity",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v9 /*: any*/ ,
                                                            "type": "CustomerServiceOrganization"
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38",
            "metadata": {},
            "name": "entitlementsCustomerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5f2062bc7e23061a$var$node.hash = "52b18fa6e520ef1142f20ddded30f5ba";
var $5f2062bc7e23061a$export$2e2bcd8739ae039 = $5f2062bc7e23061a$var$node;

});


parcelRegister("77XtT", function(module, exports) {

$parcel$export(module.exports, "uiCustomerDetailsPageQueryResource", () => $e26739e95b236549$export$d766b4bd7ad23814);

var $buJlM = parcelRequire("buJlM");

var $w2PKr = parcelRequire("w2PKr");
const $e26739e95b236549$export$d766b4bd7ad23814 = (0, $buJlM.createRelayResource)({
    type: 'UI_CUSTOMER_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $w2PKr.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("w2PKr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ec64d97b4d363e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c8ad796157e1391650689431c1c3f5b0>>
 * @relayHash 59943b4782061bd4a6290f594b5a905b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1258d3244f4ada1c9a11aa7b81632c4706c41bef3110bbfaff26f94c93a1ee49
const $4ec64d97b4d363e0$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1258d3244f4ada1c9a11aa7b81632c4706c41bef3110bbfaff26f94c93a1ee49",
        "metadata": {},
        "name": "uiCustomerDetailsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4ec64d97b4d363e0$export$2e2bcd8739ae039 = $4ec64d97b4d363e0$var$node;

});


parcelRegister("fjxAH", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomersV2Route", () => $6be329edd302ba66$export$89e9e350610ee31e);
$parcel$export(module.exports, "servicedeskCustomerDetailsRoute", () => $6be329edd302ba66$export$42c0f04d04ecd1f8);

var $exb0h = parcelRequire("exb0h");
const $6be329edd302ba66$export$89e9e350610ee31e = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/projects/:projectKey/customers',
    exact: true
};
const $6be329edd302ba66$export$42c0f04d04ecd1f8 = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/projects/:projectKey/customers/:customerId',
    exact: true
};

});

parcelRegister("ecIPx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("a2bnB")
]).then(()=>parcelRequire('2TEqc'));

});

parcelRegister("4ENX4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("7iYSs")
]).then(()=>parcelRequire('2OQhU'));

});

parcelRegister("1a6Wh", function(module, exports) {

$parcel$export(module.exports, "projectServiceDeskRoute", () => $48d1c095208636aa$export$1cfc858068dd8718);

var $exb0h = parcelRequire("exb0h");
const $48d1c095208636aa$export$1cfc858068dd8718 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REDIRECT),
    path: '/jira/servicedesk/projects/:projectKey',
    exact: true
};

});

parcelRegister("kOAof", function(module, exports) {

$parcel$export(module.exports, "gspPageRoute", () => $d21189e3ca632108$export$23f42abb017854bb);

var $exb0h = parcelRequire("exb0h");
const $d21189e3ca632108$export$23f42abb017854bb = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE),
    path: '/jira/servicedesk/projects/:projectKey/getting-started',
    exact: true
};

});

parcelRegister("8IADa", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("dqX8Z")
]).then(()=>parcelRequire('bfpCl'));

});

parcelRegister("eCfcK", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3ekWX").then(()=>parcelRequire('fTzcE'));

});

parcelRegister("1yEMG", function(module, exports) {

$parcel$export(module.exports, "AsyncKbNav", () => $6e677bdb585357fa$export$223f755b7799fe02);

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $gGtKh = parcelRequire("gGtKh");

const $6e677bdb585357fa$var$LazyKbNav = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("aLXTB")).then(({ KnowledgeBaseNav: KnowledgeBaseNav })=>KnowledgeBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/knowledge-base/src/ui/index.tsx"
});
const $6e677bdb585357fa$export$223f755b7799fe02 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-jsm-kb-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e677bdb585357fa$var$LazyKbNav, null));

});
parcelRegister("aLXTB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9kegF").then(()=>parcelRequire('crjTG'));

});


parcelRegister("fsmKq", function(module, exports) {

$parcel$export(module.exports, "getKnowledgeHubBaseUrl", () => $81fe88a10c85f36f$export$1fe78c01c9fe0ebd);
$parcel$export(module.exports, "knowledgeHubLandingRoute", () => $81fe88a10c85f36f$export$239eaf6a202e0f54);
$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRoute", () => $81fe88a10c85f36f$export$c8e99e3434791c0e);
$parcel$export(module.exports, "knowledgeHubDraftsRoute", () => $81fe88a10c85f36f$export$670f3b59aa55b7ae);
$parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRoute", () => $81fe88a10c85f36f$export$256f841794b3f077);
$parcel$export(module.exports, "knowledgeHubSuggestedArticlesRoute", () => $81fe88a10c85f36f$export$54edf5cef1c6b21b);
$parcel$export(module.exports, "knowledgeHubBrowseViewArticleRoute", () => $81fe88a10c85f36f$export$ef8a9ec2979d1b10);
$parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRoute", () => $81fe88a10c85f36f$export$bd512c426b095693);
$parcel$export(module.exports, "knowledgeHubAllArticlesRoute", () => $81fe88a10c85f36f$export$20e57a83f181da7b);
$parcel$export(module.exports, "knowledgeHubArticleInCategoryRoute", () => $81fe88a10c85f36f$export$3afe8482ce820835);
$parcel$export(module.exports, "knowledgeHubCategoryPageRoute", () => $81fe88a10c85f36f$export$79fb48a07e43639a);
$parcel$export(module.exports, "knowledgeHubCategoryRoute", () => $81fe88a10c85f36f$export$69ed5b0214ea6ee5);
$parcel$export(module.exports, "knowledgeHubSearchRoute", () => $81fe88a10c85f36f$export$a47c36fb081b544d);
$parcel$export(module.exports, "knowledgeHubSetupRoute", () => $81fe88a10c85f36f$export$f20770545704547d);

var $exb0h = parcelRequire("exb0h");
const $81fe88a10c85f36f$export$1fe78c01c9fe0ebd = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge`;
const $81fe88a10c85f36f$export$239eaf6a202e0f54 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_LANDING),
    path: '/jira/servicedesk/projects/:projectKey/knowledge',
    exact: true
};
const $81fe88a10c85f36f$export$c8e99e3434791c0e = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES),
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles',
    exact: true
};
const $81fe88a10c85f36f$export$670f3b59aa55b7ae = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS),
    path: '/jira/servicedesk/projects/:projectKey/knowledge/drafts',
    exact: true
};
const $81fe88a10c85f36f$export$256f841794b3f077 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES),
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories',
    exact: true
};
const $81fe88a10c85f36f$export$54edf5cef1c6b21b = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS),
    path: '/jira/servicedesk/projects/:projectKey/knowledge/suggested-topics',
    exact: true
};
const $81fe88a10c85f36f$export$ef8a9ec2979d1b10 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE),
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles/:articleId'
};
const $81fe88a10c85f36f$export$bd512c426b095693 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR),
    path: '/jira/servicedesk/projects/:projectKey/knowledge/space/:spaceKey/articles/:articleId/edit',
    query: [
        'draftShareId?'
    ]
};
const $81fe88a10c85f36f$export$20e57a83f181da7b = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES),
    path: '/jira/servicedesk/projects/:projectKey/knowledge/browse/page/:pageId'
};
const $81fe88a10c85f36f$export$3afe8482ce820835 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY),
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/articles/:articleId'
};
const $81fe88a10c85f36f$export$79fb48a07e43639a = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE),
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/browse/page/:pageId'
};
const $81fe88a10c85f36f$export$69ed5b0214ea6ee5 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY),
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId'
};
const $81fe88a10c85f36f$export$a47c36fb081b544d = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH),
    path: '/jira/servicedesk/projects/:projectKey/knowledge/search/articles/:articleId'
};
const $81fe88a10c85f36f$export$f20770545704547d = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SETUP),
    path: '/jira/servicedesk/projects/:projectKey/knowledge/setup'
};

});

parcelRegister("7QYCD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2q6S9")
]).then(()=>parcelRequire('fxVjP'));

});

parcelRegister("4cZKq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("iBwJJ")
]).then(()=>parcelRequire('1UxKS'));

});

parcelRegister("1mFuR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("klS1f")
]).then(()=>parcelRequire('eleJt'));

});

parcelRegister("2xZ7u", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("lNQM3")
]).then(()=>parcelRequire('gJBdY'));

});

parcelRegister("1fEyb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("in1ah")
]).then(()=>parcelRequire('fYSeu'));

});

parcelRegister("gN5sW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("2dMRf")
]).then(()=>parcelRequire('ccFSM'));

});

parcelRegister("acRp2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("4stfa")
]).then(()=>parcelRequire('gTFlF'));

});

parcelRegister("72qqt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("9as6I")
]).then(()=>parcelRequire('azbAe'));

});

parcelRegister("gwhoT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("82hO7")
]).then(()=>parcelRequire('3rmG2'));

});

parcelRegister("5Z6fS", function(module, exports) {

$parcel$export(module.exports, "notificationLogsRoute", () => $d910838a3fbf59ae$export$c947c80f138bc137);

var $exb0h = parcelRequire("exb0h");
const $d910838a3fbf59ae$export$c947c80f138bc137 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_NOTIFICATION_LOGS),
    path: '/jira/servicedesk/projects/:projectKey/notification-logs',
    exact: true
};

});

parcelRegister("ct7CZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("1CuF8")
]).then(()=>parcelRequire('5kwAW'));

});

parcelRegister("giKK2", function(module, exports) {

$parcel$export(module.exports, "servicedeskOncallScheduleRoute", () => $6347bb2f6d40dbe7$export$740e6e5e982b48a9);

var $exb0h = parcelRequire("exb0h");
const $6347bb2f6d40dbe7$export$e05c5e9dacfbd89d = '/jira/servicedesk/projects/:projectKey';
const $6347bb2f6d40dbe7$export$740e6e5e982b48a9 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE),
    path: `${$6347bb2f6d40dbe7$export$e05c5e9dacfbd89d}/on-call-schedule`,
    exact: true
};

});

parcelRegister("6rwbc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("50rQJ")
]).then(()=>parcelRequire('3Gs2y'));

});

parcelRegister("9LviW", function(module, exports) {

$parcel$export(module.exports, "serviceDeskOrganizationPanelForgeDataResource", () => $422aa623eb5a3ab0$export$f3c46a19f3594363);

var $lB25E = parcelRequire("lB25E");


const $422aa623eb5a3ab0$var$getDataLoader = ()=>(parcelRequire("cHj1g"));
const $422aa623eb5a3ab0$export$f3c46a19f3594363 = (0, $lB25E.createResource)({
    type: (0, $3f32b6d9d9e0b2f0$export$66d6e1e05866ee2f),
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `extension-${projectKey}`;
    },
    getDataLoader: $422aa623eb5a3ab0$var$getDataLoader,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
const $3f32b6d9d9e0b2f0$export$66d6e1e05866ee2f = 'ORGANIZATION_PANEL_FORGE_DATA';

parcelRegister("cHj1g", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5BykT").then(()=>parcelRequire('8STZb'));

});


parcelRegister("isMQ5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("k3pSH")
]).then(()=>parcelRequire('6cwa1'));

});

parcelRegister("a5AeJ", function(module, exports) {

$parcel$export(module.exports, "entitlementsOrganizationQueryResource", () => $a524c85d18fc84ca$export$fead08d66d56688e);

var $buJlM = parcelRequire("buJlM");

var $bNYVo = parcelRequire("bNYVo");
const $a524c85d18fc84ca$export$fead08d66d56688e = (0, $buJlM.createRelayResource)({
    type: 'ENTITLEMENTS_ORGANIZATION_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $bNYVo.default),
            variables: {
                organizationId: String(match.params.organizationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("bNYVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c04cf6e2bd324ba6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5505d7bd1e485943d52683e3e287125b>>
 * @relayHash 4fd7c02cf85ce43ff1f3b2c2885428f1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f
const $c04cf6e2bd324ba6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entitlementsOrganizationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "customerService.productConnections.edges"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW",
                                "path": "customerService.productConnections"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v6 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "customerService.organizationByOrganizationId.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v6 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": false
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "customerService.organizationByOrganizationId.entitlementList"
                                                },
                                                v7 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entitlementsOrganizationQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f",
            "metadata": {},
            "name": "entitlementsOrganizationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c04cf6e2bd324ba6$var$node.hash = "c2dbf2a99cb38657b66de75f23707712";
var $c04cf6e2bd324ba6$export$2e2bcd8739ae039 = $c04cf6e2bd324ba6$var$node;

});


parcelRegister("eJxBd", function(module, exports) {

$parcel$export(module.exports, "uiOrganizationDetailsPageQueryResource", () => $cb3bd8377436ecce$export$ab65064827d1831d);

var $buJlM = parcelRequire("buJlM");

var $anC01 = parcelRequire("anC01");
const $cb3bd8377436ecce$export$ab65064827d1831d = (0, $buJlM.createRelayResource)({
    type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $anC01.default),
            variables: {
                organizationId: String(match.params.organizationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("anC01", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b0b5acef3133ac7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a347bbd6ea006613b0f397206baf70e6>>
 * @relayHash e993c550e226578e30a64517a438661b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a225e51b1ca0507ed6d9b7fea04e9939f9f90322a81d41da48011ddeff62c4d3
const $0b0b5acef3133ac7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "errorType"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiOrganizationDetailsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "details",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "customDetailsSidebar_servicedeskCustomerServiceCustomDetailsSidebar_Inner"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiOrganizationDetailsPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "details",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceCustomDetailValue",
                                                            "kind": "LinkedField",
                                                            "name": "results",
                                                            "plural": true,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canEdit"
                                                                },
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "values"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailType",
                                                                    "kind": "LinkedField",
                                                                    "name": "type",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "options"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "config",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                            "kind": "LinkedField",
                                                                            "name": "styleConfiguration",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionValue"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "style",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "backgroundColour"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "CustomerServiceCustomDetailValues"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "QueryError"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a225e51b1ca0507ed6d9b7fea04e9939f9f90322a81d41da48011ddeff62c4d3",
            "metadata": {},
            "name": "uiOrganizationDetailsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0b0b5acef3133ac7$var$node.hash = "8781f4b4eca174196d95ee737ccdc3aa";
var $0b0b5acef3133ac7$export$2e2bcd8739ae039 = $0b0b5acef3133ac7$var$node;

});


parcelRegister("7FYcB", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationsRoute", () => $cef85bb01340f590$export$d4a712c5bc3c3434);
$parcel$export(module.exports, "servicedeskOrganizationDetailsRoute", () => $cef85bb01340f590$export$eacc4723293cbc36);

var $exb0h = parcelRequire("exb0h");
const $cef85bb01340f590$export$d4a712c5bc3c3434 = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/projects/:projectKey/organizations',
    exact: true
};
const $cef85bb01340f590$export$eacc4723293cbc36 = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/projects/:projectKey/organizations/:organizationId',
    exact: true
};

});

parcelRegister("8PUdS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("9ly9D")
]).then(()=>parcelRequire('5UWIV'));

});

parcelRegister("5XfxL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("eGahy")
]).then(()=>parcelRequire('cztsT'));

});

parcelRegister("jdx5X", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectSummaryRoute", () => $360db143cf0965e4$export$a23b752ff24027ae);

var $exb0h = parcelRequire("exb0h");
const $360db143cf0965e4$export$a23b752ff24027ae = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/projects/:projectKey/summary',
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY)
};

});

parcelRegister("lLKZW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");


module.exports = Promise.all([
    (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("5HPyU")),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("5Aqqd")
]).then(()=>parcelRequire('lbI34'));

});

parcelRegister("7JKBZ", function(module, exports) {

$parcel$export(module.exports, "newIssueViewLockInStatusResource", () => $e26e405609d1afdf$export$647de7516d081bd8);
$parcel$export(module.exports, "useNewIssueViewLockInStatus", () => $e26e405609d1afdf$export$d8ba398930f2f5f);

var $lB25E = parcelRequire("lB25E");

var $4abw7 = parcelRequire("4abw7");

const $e26e405609d1afdf$export$647de7516d081bd8 = (0, $lB25E.createResource)({
    type: (0, $4abw7.RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("itptj")),
    maxAge: Number.MAX_VALUE
});
const $e26e405609d1afdf$export$d8ba398930f2f5f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)($e26e405609d1afdf$export$647de7516d081bd8);
    return {
        loading: loading,
        error: error,
        newIssueViewLockedIn: data && data.newIssueViewLockedIn
    };
};

});
parcelRegister("itptj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7k3aJ").then(()=>parcelRequire('fU01i'));

});


parcelRegister("IsF0v", function(module, exports) {

$parcel$export(module.exports, "servicedeskIsItsmProjectResource", () => $07a4c10d5645b4e2$export$920308cef4e291b1);
$parcel$export(module.exports, "useIsItsmTemplateProject", () => $07a4c10d5645b4e2$export$7bb46948fb84f164);

var $eUqFw = parcelRequire("eUqFw");

var $8LJqN = parcelRequire("8LJqN");

var $eI5EY = parcelRequire("eI5EY");

var $iZJHG = parcelRequire("iZJHG");

var $8hg3R = parcelRequire("8hg3R");

var $lB25E = parcelRequire("lB25E");


const $07a4c10d5645b4e2$var$getDataLoader = ()=>(parcelRequire("alHP0"));
const $07a4c10d5645b4e2$var$ONE_DAY_IN_MILLIS = 86400000;
const $07a4c10d5645b4e2$export$920308cef4e291b1 = (0, $lB25E.createResource)({
    type: (0, $f57291778ecbd978$export$543a8644640f4092),
    getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
    getDataLoader: $07a4c10d5645b4e2$var$getDataLoader,
    maxAge: $07a4c10d5645b4e2$var$ONE_DAY_IN_MILLIS
});
const $07a4c10d5645b4e2$var$useIsItsmTemplateProjectNew = (projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $iZJHG.useResourceWithCustomRouterContext)($07a4c10d5645b4e2$export$920308cef4e291b1, projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined, {
        shouldPrefetch: true
    });
    return (0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};
const $07a4c10d5645b4e2$var$useIsItsmTemplateProjectOld = (_)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)($07a4c10d5645b4e2$export$920308cef4e291b1);
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if ((data === null || data === undefined) && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};
const $07a4c10d5645b4e2$export$7bb46948fb84f164 = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('fix_useinitresource_data_bug'), $07a4c10d5645b4e2$var$useIsItsmTemplateProjectNew, $07a4c10d5645b4e2$var$useIsItsmTemplateProjectOld);

});
const $f57291778ecbd978$export$543a8644640f4092 = 'SERVICEDESK_IS_ITSM_PROJECT';

parcelRegister("alHP0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iNHzY").then(()=>parcelRequire('hQH0C'));

});


parcelRegister("eD2UT", function(module, exports) {

$parcel$export(module.exports, "customQueueRoute", () => $4782d0a5c5a44372$export$e1fac82ca0b0d637);
$parcel$export(module.exports, "customPracticeQueueRoute", () => $4782d0a5c5a44372$export$59d0bd42aa07faad);

var $exb0h = parcelRequire("exb0h");
const $4782d0a5c5a44372$export$e1fac82ca0b0d637 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey?',
    query: [
        'oldIssueView?'
    ],
    exact: true
};
const $4782d0a5c5a44372$export$59d0bd42aa07faad = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("kDuGf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8xeQK")
]).then(()=>parcelRequire('7tq7f'));

});

parcelRegister("kl03w", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("6wERg")
]).then(()=>parcelRequire('kB9Uz'));

});

parcelRegister("4D5Tp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("eEZ3I")
]).then(()=>parcelRequire('4eVVM'));

});

parcelRegister("d23jC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("eq2Qr")
]).then(()=>parcelRequire('9u77E'));

});

parcelRegister("441DV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("lae99")
]).then(()=>parcelRequire('dDXUI'));

});

parcelRegister("8oMBZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ivWme")
]).then(()=>parcelRequire('dKCU6'));

});

parcelRegister("3GkTL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("h5wtr")
]).then(()=>parcelRequire('1dAi7'));

});

parcelRegister("2LH9h", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aU83l").then(()=>parcelRequire('74KcA'));

});

parcelRegister("1iICl", function(module, exports) {

$parcel$export(module.exports, "servicedeskAtlassianAnalyticsResource", () => $b43093f7acf3e3e2$export$eb2deca89cf3fb61);

var $lB25E = parcelRequire("lB25E");


const $b43093f7acf3e3e2$var$getDataLoader = ()=>(parcelRequire("lxPAG"));
const $b43093f7acf3e3e2$export$eb2deca89cf3fb61 = (0, $lB25E.createResource)({
    type: (0, $eb4e443cee49ddd3$export$73cf43fb073ce577),
    getKey: ()=>'atlassian analytics',
    getDataLoader: $b43093f7acf3e3e2$var$getDataLoader,
    isBrowserOnly: true
});

});
const $eb4e443cee49ddd3$export$73cf43fb073ce577 = 'SERVICEDESK_ATLASSIAN_ANALYTICS';

parcelRegister("lxPAG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4FH3Q").then(()=>parcelRequire('kk3KD'));

});


parcelRegister("5VjfX", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSummaryRoute", () => $a924b54989ebf010$export$44647b0fd2271ddb);
$parcel$export(module.exports, "servicedeskReports1Route", () => $a924b54989ebf010$export$f5adfd681a4e85ad);
$parcel$export(module.exports, "servicedeskAtlassianAnalyticsRoute", () => $a924b54989ebf010$export$399ef3a2d4288bba);
$parcel$export(module.exports, "servicedeskReportsWorkloadRoute", () => $a924b54989ebf010$export$ce9b409ccf53e93c);
$parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRoute", () => $a924b54989ebf010$export$da606765550c7e7);
$parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRoute", () => $a924b54989ebf010$export$64ae70b2d6b34c4e);
$parcel$export(module.exports, "servicedeskReportsSatisfaction2Route", () => $a924b54989ebf010$export$22fd25b495033fdf);
$parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRoute", () => $a924b54989ebf010$export$296aa46068d40f43);
$parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRoute", () => $a924b54989ebf010$export$1585b6f8f1838e19);
$parcel$export(module.exports, "servicedeskKbRequestsReports2Route", () => $a924b54989ebf010$export$276e2ed89304d21c);
$parcel$export(module.exports, "servicedeskReportsCustomEditRoute", () => $a924b54989ebf010$export$3b6b3105a9ef9b83);
$parcel$export(module.exports, "servicedeskReportsCustomCreateRoute", () => $a924b54989ebf010$export$333e623d5eb41af0);
$parcel$export(module.exports, "servicedeskReportsCustomIssueRoute", () => $a924b54989ebf010$export$1cfe539c854438e8);
$parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRoute", () => $a924b54989ebf010$export$eae9a65fe3f035ef);
$parcel$export(module.exports, "servicedeskReportsCustom4Route", () => $a924b54989ebf010$export$39325072940fb58c);
$parcel$export(module.exports, "servicedeskReportsTypeRoute", () => $a924b54989ebf010$export$b955ac7f09c5dbb);

var $exb0h = parcelRequire("exb0h");
const $a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX = '/jira/servicedesk/projects/:projectKey';
const $a924b54989ebf010$var$WORKLOAD_ROUTE_SUFFIX = '/reports/workload';
const $a924b54989ebf010$var$ATLASSIAN_ANALYTICS_ROUTE_SUFFIX = '/reports/atlassian-analytics';
const $a924b54989ebf010$var$CUSTOM_ROUTE_SUFFIX = '/reports/custom/:reportId';
const $a924b54989ebf010$var$REQUESTS_ROUTE_SUFFIX = '/reports/:reportId(kb-requests-resolved|kb-requests-deflected)';
const $a924b54989ebf010$var$TIME_SCALE = '/timescale/:timescaleId';
const $a924b54989ebf010$var$SATISFACTION_ROUTE_SUFFIX = '/reports/all-rating';
const $a924b54989ebf010$var$ISSUE_KEY = '/:issueKey';
const $a924b54989ebf010$export$44647b0fd2271ddb = {
    // HACK - the reports backbone code tries to refresh the page
    // in order to re-render the view. This route allows us to replicate that
    // behaviour in React.
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY),
    path: '(/jira/servicedesk/projects/[^/]+/reports/.+)/summary',
    exact: true
};
const $a924b54989ebf010$export$f5adfd681a4e85ad = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}/reports`,
    exact: true
};
const $a924b54989ebf010$export$399ef3a2d4288bba = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$ATLASSIAN_ANALYTICS_ROUTE_SUFFIX}`,
    exact: true
};
const $a924b54989ebf010$export$ce9b409ccf53e93c = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$WORKLOAD_ROUTE_SUFFIX}`,
    exact: true
};
const $a924b54989ebf010$export$da606765550c7e7 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$SATISFACTION_ROUTE_SUFFIX}${$a924b54989ebf010$var$TIME_SCALE}${$a924b54989ebf010$var$ISSUE_KEY}`,
    query: [
        'oldIssueView?'
    ],
    exact: true
};
const $a924b54989ebf010$export$64ae70b2d6b34c4e = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$SATISFACTION_ROUTE_SUFFIX}${$a924b54989ebf010$var$TIME_SCALE}`
};
const $a924b54989ebf010$export$22fd25b495033fdf = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$SATISFACTION_ROUTE_SUFFIX}`
};
const $a924b54989ebf010$export$296aa46068d40f43 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$REQUESTS_ROUTE_SUFFIX}${$a924b54989ebf010$var$TIME_SCALE}${$a924b54989ebf010$var$ISSUE_KEY}`,
    query: [
        'oldIssueView?'
    ],
    exact: true
};
const $a924b54989ebf010$export$1585b6f8f1838e19 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$REQUESTS_ROUTE_SUFFIX}${$a924b54989ebf010$var$TIME_SCALE}`
};
const $a924b54989ebf010$export$276e2ed89304d21c = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$REQUESTS_ROUTE_SUFFIX}`
};
const $a924b54989ebf010$export$3b6b3105a9ef9b83 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$CUSTOM_ROUTE_SUFFIX}/edit`
};
const $a924b54989ebf010$export$333e623d5eb41af0 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}/reports/custom/new`
};
const $a924b54989ebf010$export$1cfe539c854438e8 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$CUSTOM_ROUTE_SUFFIX}${$a924b54989ebf010$var$TIME_SCALE}${$a924b54989ebf010$var$ISSUE_KEY}`,
    query: [
        'oldIssueView?'
    ],
    exact: true
};
const $a924b54989ebf010$export$eae9a65fe3f035ef = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$CUSTOM_ROUTE_SUFFIX}${$a924b54989ebf010$var$TIME_SCALE}`
};
const $a924b54989ebf010$export$39325072940fb58c = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$CUSTOM_ROUTE_SUFFIX}`
};
const $a924b54989ebf010$export$b955ac7f09c5dbb = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE),
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}/reports/:reportType/:reportId?/:reportsAction?/:timescaleId?/:issueKey?`,
    query: [
        'oldIssueView?'
    ]
};

});

parcelRegister("kKBRu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("ehjSH")
]).then(()=>parcelRequire('aYPxW'));

});

parcelRegister("dwqqh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8rDHO")
]).then(()=>parcelRequire('29RNo'));

});

parcelRegister("KsImw", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("cXOmQ")
]).then(()=>parcelRequire('86VyB'));

});

parcelRegister("71sin", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("1HIlH")
]).then(()=>parcelRequire('aRYrF'));

});

parcelRegister("s7itf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("8gVpS")
]).then(()=>parcelRequire('a3ocp'));

});

parcelRegister("6qyuu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("dYyaC")
]).then(()=>parcelRequire('gxVjQ'));

});

parcelRegister("9ZKn1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("fUZPR")
]).then(()=>parcelRequire('hYS2a'));

});

parcelRegister("9XWNM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("6f7ti")
]).then(()=>parcelRequire('k9U6H'));

});

parcelRegister("4HzHQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("hcgRy")
]).then(()=>parcelRequire('hWny6'));

});

parcelRegister("h3Z7f", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("eOWRL")
]).then(()=>parcelRequire('2jUxe'));

});

parcelRegister("7OtSy", function(module, exports) {

$parcel$export(module.exports, "servicedeskServicesRoute", () => $89fe13db81497c0b$export$4a800381bda6d53c);
$parcel$export(module.exports, "servicedeskServiceDetailsRoute", () => $89fe13db81497c0b$export$fe5fe00b6d5eab87);
$parcel$export(module.exports, "servicedeskServiceModalNewRoute", () => $89fe13db81497c0b$export$5b5ea97286af2784);
$parcel$export(module.exports, "servicedeskServiceModalEditRoute", () => $89fe13db81497c0b$export$319fbbab5eb49cbf);
$parcel$export(module.exports, "serviceDeskServicesWithoutProjectRoute", () => $89fe13db81497c0b$export$3210e7c54c21be97);
$parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRoute", () => $89fe13db81497c0b$export$25e1d58db18a7c8b);

var $exb0h = parcelRequire("exb0h");
const $89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX = '/jira/servicedesk/projects/:projectKey';
const $89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT = '/jira/servicedesk';
const $89fe13db81497c0b$var$SERVICE_HASHED_ARI = '/:serviceAri';
const $89fe13db81497c0b$var$SERVICES_ROUTE_SUFFIX = '/services';
const $89fe13db81497c0b$var$SERVICE_MODAL_ROUTE_SUFFIX = '/service-modal';
const $89fe13db81497c0b$export$4a800381bda6d53c = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICES),
    path: `${$89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX}${$89fe13db81497c0b$var$SERVICES_ROUTE_SUFFIX}`,
    exact: true
};
const $89fe13db81497c0b$export$fe5fe00b6d5eab87 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS),
    path: `${$89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX}${$89fe13db81497c0b$var$SERVICES_ROUTE_SUFFIX}${$89fe13db81497c0b$var$SERVICE_HASHED_ARI}`
};
const $89fe13db81497c0b$export$5b5ea97286af2784 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_NEW),
    path: `${$89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$89fe13db81497c0b$var$SERVICE_MODAL_ROUTE_SUFFIX}`,
    exact: true
};
const $89fe13db81497c0b$export$319fbbab5eb49cbf = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_EDIT),
    path: `${$89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$89fe13db81497c0b$var$SERVICE_MODAL_ROUTE_SUFFIX}${$89fe13db81497c0b$var$SERVICE_HASHED_ARI}`
};
const $89fe13db81497c0b$export$3210e7c54c21be97 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT),
    path: `${$89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$89fe13db81497c0b$var$SERVICES_ROUTE_SUFFIX}`,
    exact: true,
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT),
            packageName: 'jiraSpaAppsServicedeskServicesWithoutProjectContext"',
            teamName: 'Falcons'
        }
    }
};
const $89fe13db81497c0b$export$25e1d58db18a7c8b = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT),
    path: `${$89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$89fe13db81497c0b$var$SERVICES_ROUTE_SUFFIX}${$89fe13db81497c0b$var$SERVICE_HASHED_ARI}`,
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT),
            packageName: 'jiraSpaAppsServicedeskServiceDetailsWithoutProjectContext"',
            teamName: 'Falcons'
        }
    }
};

});

parcelRegister("fNmCk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("dJcDS")
]).then(()=>parcelRequire('hOdgF'));

});

parcelRegister("7RQQm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("5KHj0")
]).then(()=>parcelRequire('sBnk2'));

});

parcelRegister("gU5K0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("egGuO")
]).then(()=>parcelRequire('aIz0v'));

});

parcelRegister("3tIPj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("lAQnM")
]).then(()=>parcelRequire('7NpH8'));

});

parcelRegister("c37zX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("bjoOq")
]).then(()=>parcelRequire('47wbX'));

});

parcelRegister("jNyby", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("dpITv")
]).then(()=>parcelRequire('dZkiU'));

});

parcelRegister("ieRGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $209cb7ee89940e6b$export$2e2bcd8739ae039);

var $78Ywx = parcelRequire("78Ywx");

var $kFGm5 = parcelRequire("kFGm5");
var /**
 * Use to remove query params from url without reload or change history
 * One use case is to remove any tracking id from the url to avoid problems in copy & paste urls or sharing links between users
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$209cb7ee89940e6b$export$2e2bcd8739ae039 = (paramsToStrip)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($78Ywx))).parse(window.location.href, true);
        const strippedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(parsedUrl.query || {}, paramsToStrip);
        let strippedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($78Ywx))).format({
            ...parsedUrl,
            search: undefined,
            query: strippedQuery
        });
        // we don't want to encode : to %3A in connect project pages
        const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.search);
        if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.history.replaceState({}, '', strippedUrl);
    } catch (e) {
    /* uri might be malformed */ }
};

});

parcelRegister("7BDEW", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fe7d84710661a6d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $hFmdR = parcelRequire("hFmdR");

var $5BRby = parcelRequire("5BRby");


var $5CH2F = parcelRequire("5CH2F");
const $9fe7d84710661a6d$var$defaultSource = 'dwellComponent';
const $9fe7d84710661a6d$var$defaultActionSubject = 'dwellComponent';
const $9fe7d84710661a6d$var$getDwellComponent = (source, actionSubject)=>(0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $hFmdR.AnalyticsSubject)(actionSubject || $9fe7d84710661a6d$var$defaultActionSubject), (0, $hFmdR.AnalyticsSource)(source || $9fe7d84710661a6d$var$defaultSource, (0, $41ea3621645e2acc$export$f636b5b56f1d624a)))((0, $5CH2F.default));
class $9fe7d84710661a6d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(props) {
        const { data: data } = props;
        return {
            DwellTimeComponent: $9fe7d84710661a6d$var$getDwellComponent(data.source, data.actionSubject)
        };
    }
    constructor(props){
        super(props);
        this.state = {
            DwellTimeComponent: null
        };
    }
    render() {
        const { sessionId: sessionId, data: data } = this.props;
        const { DwellTimeComponent: DwellTimeComponent } = this.state;
        const enrichedData = {
            ...data,
            source: data && data.source || $9fe7d84710661a6d$var$defaultSource,
            actionSubject: data && data.actionSubject || $9fe7d84710661a6d$var$defaultActionSubject
        };
        if (sessionId && DwellTimeComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DwellTimeComponent, {
            sessionId: sessionId,
            data: enrichedData
        }));
        return null;
    }
}

});
parcelRegister("5CH2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def25be35218960$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9LCN1 = parcelRequire("9LCN1");

var $eGI9v = parcelRequire("eGI9v");

var $jUhyG = parcelRequire("jUhyG");
class $6def25be35218960$export$1c7ccff61c195c75 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { data: data, sessionId: sessionId } = this.props;
        // @ts-expect-error - TS2741 - Property 'prototype' is missing in type 'DwellTimeHelper' but required in type 'typeof DwellTimeHelper'.
        this.dwellHelper = new (0, $9LCN1.default)(this.sendDwellEvent, data, sessionId);
        // @ts-expect-error - TS2339 - Property 'start' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.start();
    }
    componentDidUpdate(oldProps) {
        if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) // @ts-expect-error - TS2339 - Property 'newPage' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.newPage(this.props.data, this.props.sessionId);
    }
    componentWillUnmount() {
        if (this.dwellHelper) {
            // @ts-expect-error - TS2339 - Property 'stop' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.stop();
            // @ts-expect-error - TS2339 - Property 'destroy' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.destroy();
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.sendDwellEvent = (payload)=>(0, $jUhyG.fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
    }
}
var $6def25be35218960$export$2e2bcd8739ae039 = (0, $eGI9v.default)('dwellTime', {
    onDwell: 'dwelled'
})($6def25be35218960$export$1c7ccff61c195c75);

});
parcelRegister("jUhyG", function(module, exports) {

$parcel$export(module.exports, "fireTrackAnalytics", () => $5b05bd1f53288b4a$export$13990ad4625571ed);

var $3LiTJ = parcelRequire("3LiTJ");

var $etqm0 = parcelRequire("etqm0");

var $klunD = parcelRequire("klunD");
const $5b05bd1f53288b4a$var$isNotUndefined = (a)=>a !== undefined;
const $5b05bd1f53288b4a$var$mapPayload = (payload)=>{
    const context = (0, $klunD.default)(payload);
    const { action: action, actionSubjectId: actionSubjectId } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        action: action,
        actionSubjectId: actionSubjectId
    }, $5b05bd1f53288b4a$var$isNotUndefined);
};
const $5b05bd1f53288b4a$export$13990ad4625571ed = (event, payload)=>{
    event.update({
        ...$5b05bd1f53288b4a$var$mapPayload(payload),
        analyticsType: (0, $etqm0.TRACK_EVENT_TYPE)
    }).fire();
};

});



parcelRegister("cprue", function(module, exports) {

$parcel$export(module.exports, "CLEAR_SEARCH_SESSION", () => $994d5244595fd50a$export$b669eaa3e4786d5c);
$parcel$export(module.exports, "skipClearSessionURLs", () => $994d5244595fd50a$export$c092460ed33e0e35);
const $994d5244595fd50a$export$b669eaa3e4786d5c = 'CLEAR_SEARCH_SESSION';
const $994d5244595fd50a$export$c092460ed33e0e35 = [
    /.*RapidBoard.jspa.*/,
    /\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/,
    /\/jira\/people\/.*\/boards\/.*/
];

});

parcelRegister("4ea83", function(module, exports) {

$parcel$export(module.exports, "setPrefetchStartMark", () => $e69acff038046e8f$export$405fde3eab8e39f6);
$parcel$export(module.exports, "getPrefetchStartMark", () => $e69acff038046e8f$export$cbaceb7ffa84279);
$parcel$export(module.exports, "clearPrefetchStartMarks", () => $e69acff038046e8f$export$d6b0928f07bafe57);
const $e69acff038046e8f$var$prefetchTiming = new Map();
const $e69acff038046e8f$export$405fde3eab8e39f6 = (match)=>{
    const currentMatch = JSON.stringify(match);
    if (!$e69acff038046e8f$var$prefetchTiming.has(currentMatch)) $e69acff038046e8f$var$prefetchTiming.set(currentMatch, {
        startPrefetchTime: Date.now()
    });
};
const $e69acff038046e8f$export$cbaceb7ffa84279 = (match)=>{
    const currentMatch = JSON.stringify(match);
    const { startPrefetchTime: startPrefetchTime } = $e69acff038046e8f$var$prefetchTiming.get(currentMatch) || {
        startPrefetchTime: null
    };
    return startPrefetchTime;
};
const $e69acff038046e8f$export$d6b0928f07bafe57 = (match)=>{
    if (!$e69acff038046e8f$var$prefetchTiming || !$e69acff038046e8f$var$prefetchTiming.keys) return;
    const currentMatch = JSON.stringify(match);
    const keys = Array.from($e69acff038046e8f$var$prefetchTiming.keys());
    keys.forEach((mark)=>{
        if (mark !== currentMatch && $e69acff038046e8f$var$prefetchTiming.has(mark)) $e69acff038046e8f$var$prefetchTiming.delete(mark);
    });
};

});

parcelRegister("fGHk2", function(module, exports) {

$parcel$export(module.exports, "getSpaRouterContext", () => $4819b6a0bbaf9e3c$export$1f61c5e3f6410afa);
const $4819b6a0bbaf9e3c$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
        tenantContext: tenantContext
    });

});

parcelRegister("iE8ll", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a219f83d1047607$export$2e2bcd8739ae039);

var $6fjTb = parcelRequire("6fjTb");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $6rW04 = parcelRequire("6rW04");

var $6ZwQ5 = parcelRequire("6ZwQ5");

var $iWimt = parcelRequire("iWimt");

var $34jRK = parcelRequire("34jRK");

var $fYqUr = parcelRequire("fYqUr");

var $4XwAi = parcelRequire("4XwAi");

var $33zSj = parcelRequire("33zSj");
var $6q0D0 = parcelRequire("6q0D0");

var $84pUs = parcelRequire("84pUs");

var $kvBcO = parcelRequire("kvBcO");

var $8NQa5 = parcelRequire("8NQa5");

var $g62MK = parcelRequire("g62MK");
const $3a219f83d1047607$var$getUFOConfigFromFF = ()=>(0, $1ybV0.getFeatureFlagValue)('ufo.config', {});
function $3a219f83d1047607$var$getAdditionalJiraFields(interaction) {
    try {
        return {
            jira: (0, $iWimt.getJiraCustomData)(interaction)
        };
    } catch (error) {
        return {};
    }
}

function $3a219f83d1047607$var$loadJiraAnalyticsWebClient() {
    return Promise.resolve((parcelRequire("3FyZ4")));
}
function $3a219f83d1047607$export$2e2bcd8739ae039() {
    const ufoConfigFromFF = $3a219f83d1047607$var$getUFOConfigFromFF();
    (0, $6ZwQ5.retrieveAndSetPageLoadTrace)((0, $6rW04.default));
    (0, $33zSj.configure)((0, $8NQa5.jiraResourceTimingsConfig));
    (0, $6q0D0.startResourceTimingBuffer)();
    (0, $34jRK.configure)((0, $kvBcO.jiraBundleEvalTimingsConfig));
    (0, $84pUs.configure)((0, $g62MK.jiraSsrConfig));
    (0, $6fjTb.GlobalReactLooselyLazyProfiler).current = (0, $fYqUr.ModuleLoadingProfiler);
    const stopVCAtInteractionFinish = (0, $eI5EY.fg)('stop_vc_at_interaction_finish');
    const enableSegmentHighlighting = (0, $eI5EY.fg)('ufo_enable_segment_highlighting_jira');
    (0, $4XwAi.init)($3a219f83d1047607$var$loadJiraAnalyticsWebClient(), {
        ...ufoConfigFromFF,
        enableSegmentHighlighting: enableSegmentHighlighting,
        product: 'jira',
        region: (0, $6rW04.default)('ajs-region') || 'unknown',
        additionalPayloadData: $3a219f83d1047607$var$getAdditionalJiraFields,
        captureLateReRenders: (0, $eI5EY.fg)('ufo_capture_late_rerenders_jira'),
        vc: {
            enabled: (0, $1ybV0.ff)('uip.vc.partial', false),
            heatmapSize: (0, $1ybV0.getFeatureFlagValue)('uip.vc.size', 200),
            oldDomUpdates: false,
            devToolsEnabled: (0, $1ybV0.ff)('uip.vc.devtools', false),
            selectorConfig: {
                id: true,
                role: true,
                className: true,
                testId: false
            },
            ssr: (0, $1ybV0.ff)('uip.vc.ssr', false),
            stopVCAtInteractionFinish: stopVCAtInteractionFinish
        },
        enableBetterPageVisibilityApi: (0, $1ybV0.ff)('uip.vc.better-page-visibility', false)
    });
}

});
parcelRegister("6ZwQ5", function(module, exports) {

$parcel$export(module.exports, "retrieveAndSetPageLoadTrace", () => $1ac20787271a9005$export$1a71d2bbe236de99);

var $baC3k = parcelRequire("baC3k");
let $1ac20787271a9005$var$alreadySet = false;
const $1ac20787271a9005$export$1a71d2bbe236de99 = (getMeta)=>{
    if (false || $1ac20787271a9005$var$alreadySet) return;
    const traceId = getMeta('X-B3-TraceId') || '';
    const spanId = traceId?.substring(traceId.length - 16) || ''; // set root span ID by convention
    $1ac20787271a9005$var$alreadySet = true;
    (0, $baC3k.setActiveTrace)(traceId, spanId, 'page_load');
};

});

parcelRegister("iWimt", function(module, exports) {

$parcel$export(module.exports, "getJiraCustomData", () => $6e5e02981879d50b$export$abf5e20822fa925);

var $eUqFw = parcelRequire("eUqFw");

var $6rW04 = parcelRequire("6rW04");

var $beHKQ = parcelRequire("beHKQ");

var $dwuRd = parcelRequire("dwuRd");

var $kqUgM = parcelRequire("kqUgM");

var $8eEfr = parcelRequire("8eEfr");

var $aHzNY = parcelRequire("aHzNY");

var $5asE8 = parcelRequire("5asE8");

var $3J8Ab = parcelRequire("3J8Ab");

var $jRw2l = parcelRequire("jRw2l");

var $8Icn5 = parcelRequire("8Icn5");

var $eRsSp = parcelRequire("eRsSp");

var $byQ0F = parcelRequire("byQ0F");
function $6e5e02981879d50b$export$abf5e20822fa925(interaction) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let customData = {};
    const shard = (0, $6rW04.default)('ajs-shard');
    if (shard !== null && shard !== '') customData.shard = shard;
    customData['network:assetEncoding'] = (0, $beHKQ.getAssetEncoding)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const buildVariant = window.BUILD_VARIANT;
    if (buildVariant) customData['app:buildVariant'] = buildVariant;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const bundlerVersion = window.BUNDLER_VERSION;
    if (bundlerVersion) customData['app:bundlerVersion'] = bundlerVersion;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const useBifrostGateway = window.USE_BIFROST_GATEWAY;
    if (useBifrostGateway) customData['app:useBifrostGateway'] = useBifrostGateway;
    customData.httpProtocol = performance.getEntriesByType('resource')// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'. | TS2339 - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    .find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
    const { start: start, end: end, apdex: apdex } = interaction;
    const stop = apdex?.[0]?.stopTime ?? end;
    customData.memory = (0, $5asE8.getMemoryUsageReport)({
        start: start,
        stop: stop
    });
    const lightHouseMetrics = (0, $8eEfr.getLighthouseMetrics)({
        start: start,
        stop: stop
    });
    customData = {
        ...customData,
        ...lightHouseMetrics
    };
    if (interaction.type === 'page_load') customData = {
        ...customData,
        ...(0, $aHzNY.getMarks)({
            start: start
        }),
        ...(0, $3J8Ab.getPageSizeMetrics)(),
        ...(0, $3J8Ab.getExtraNavigationTimings)(),
        ...(0, $8Icn5.getServerDurationMetrics)(),
        ...(0, $jRw2l.getRouterResourceMetrics)(),
        ...(0, $byQ0F.getWRMStats)(),
        ...(0, $3J8Ab.getPageSizeInfo)({
            start: start,
            stop: stop
        }),
        ...(0, $dwuRd.getCacheHitRatio)({
            start: start
        }),
        ...(0, $kqUgM.getCHRInfo)({
            start: start
        }),
        ...(0, $eRsSp.getSSRStateInformation)(),
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        'app:version:web': window.BUILD_KEY,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        'app:version:ssr': window.SSR_BUILD_KEY,
        'app:framework:name': 'react',
        'app:framework:version': (0, $eUqFw.version)
    };
    return customData;
}

});
parcelRegister("beHKQ", function(module, exports) {

$parcel$export(module.exports, "getAssetEncoding", () => $ddd7bcb16f8788d2$export$fd12d8f45e126585);
function $ddd7bcb16f8788d2$export$fd12d8f45e126585() {
    const assetEncodings = Array.prototype.map// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    .call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, i)=>{
        // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
        acc[i] = true;
        return acc;
    }, {});
    const uniqueEncodings = Object.keys(assetEncodings).sort();
    let result = 'unknown';
    if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
    if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
    return result;
}

});

parcelRegister("dwuRd", function(module, exports) {

$parcel$export(module.exports, "getCacheHitRatio", () => $a8062b19e2d539f7$export$e8a9322c3d9da8a6);

var $hgcvd = parcelRequire("hgcvd");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $a8062b19e2d539f7$var$cacheableTypes = [
    'script',
    'link'
];
const $a8062b19e2d539f7$var$CACHE_NETWORK = 'network';
const $a8062b19e2d539f7$var$CACHE_MEMORY = 'memory';
const $a8062b19e2d539f7$var$CACHE_DISK = 'disk';
const $a8062b19e2d539f7$var$calculateTransferType = (type, duration, size)=>{
    if (!$a8062b19e2d539f7$var$cacheableTypes.includes(type)) return $a8062b19e2d539f7$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $a8062b19e2d539f7$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $a8062b19e2d539f7$var$CACHE_DISK;
    if (size === undefined) return null;
    return $a8062b19e2d539f7$var$CACHE_NETWORK;
};
const $a8062b19e2d539f7$export$e8a9322c3d9da8a6 = ({ start: start })=>{
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $hgcvd.default).getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $a8062b19e2d539f7$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
};

});

parcelRegister("kqUgM", function(module, exports) {

$parcel$export(module.exports, "getCHRInfo", () => $a49f9fd15e6ffe2a$export$9e005e111be93521);

var $6iz4v = parcelRequire("6iz4v");

var $hgcvd = parcelRequire("hgcvd");

var $3nE1C = parcelRequire("3nE1C");
const $a49f9fd15e6ffe2a$var$SPA_SSR_RENDERED = 'ssr.spa.rendered';
const $a49f9fd15e6ffe2a$export$1faf7d001841a41c = ()=>(0, $6iz4v.getMark)($a49f9fd15e6ffe2a$var$SPA_SSR_RENDERED)?.startTime || null;
const $a49f9fd15e6ffe2a$export$9e005e111be93521 = ({ start: start })=>{
    // initial load only
    if (start !== 0) return {};
    const ssrMark = $a49f9fd15e6ffe2a$export$1faf7d001841a41c();
    const reporter = new (0, $3nE1C.CHRReporter)(ssrMark);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $hgcvd.default).getEntriesByType('resource'))reporter.add(entry);
        const chr = reporter.get();
        return chr === null ? {} : {
            chr: chr
        };
    } catch (e) {
        return {};
    }
};

});
parcelRegister("3nE1C", function(module, exports) {

$parcel$export(module.exports, "CHRReporter", () => $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5);

var $80Pke = parcelRequire("80Pke");

var $eUF4z = parcelRequire("eUF4z");
class $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5 {
    constructor(ssrMark){
        this.preloaded = new (0, $eUF4z.CHRSummary)();
        this.all = new (0, $eUF4z.CHRSummary)();
        this.ssrMark = null;
        this.ssrMark = ssrMark;
    }
    add(item) {
        if (item.encodedBodySize === 0) return;
        if (item.initiatorType === 'link' && (0, $80Pke.cacheableTypes).includes(item.initiatorType) && (this.ssrMark === null || item.startTime < this.ssrMark)) this.preloaded.add(item);
        this.all.add(item);
    }
    static round(n) {
        return Math.round(n * 10000) / 10000;
    }
    makePayload(summary) {
        const bundlesLoadType = {
            mem: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $eUF4z.CHRSummary).MEMORY_KEY] / summary.bundlesCount),
            disk: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $eUF4z.CHRSummary).DISK_KEY] / summary.bundlesCount),
            net: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $eUF4z.CHRSummary).NETWORK_KEY] / summary.bundlesCount)
        };
        const bundlesRatio = $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, $eUF4z.CHRSummary).MEMORY_KEY] + summary.bundles[(0, $eUF4z.CHRSummary).DISK_KEY]) / summary.bundlesCount);
        const sizeLoadType = {
            mem: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.size[(0, $eUF4z.CHRSummary).MEMORY_KEY] / summary.sizeTotal),
            disk: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.size[(0, $eUF4z.CHRSummary).DISK_KEY] / summary.sizeTotal),
            net: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.size[(0, $eUF4z.CHRSummary).NETWORK_KEY] / summary.sizeTotal)
        };
        const sizeRatio = $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round((summary.size[(0, $eUF4z.CHRSummary).MEMORY_KEY] + summary.size[(0, $eUF4z.CHRSummary).DISK_KEY]) / summary.sizeTotal);
        return {
            bundles: {
                ratio: bundlesRatio,
                count: summary.bundlesCount,
                loadType: bundlesLoadType
            },
            size: {
                ratio: sizeRatio,
                total: summary.sizeTotal,
                loadType: sizeLoadType
            }
        };
    }
    get() {
        if (this.all.bundlesCount === 0) return null;
        return {
            preloaded: this.makePayload(this.preloaded),
            all: this.makePayload(this.all)
        };
    }
}

});
parcelRegister("80Pke", function(module, exports) {

$parcel$export(module.exports, "cacheableTypes", () => $b8a696433745e025$export$5e1aa91d6932ddaa);
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $b8a696433745e025$export$5e1aa91d6932ddaa = [
    'script',
    'link'
];

});

parcelRegister("eUF4z", function(module, exports) {

$parcel$export(module.exports, "CHRSummary", () => $d4108de44c777dc2$export$783d6618ee601ba);

var $80Pke = parcelRequire("80Pke");
const $d4108de44c777dc2$var$calculateTransferType = (type, duration, size)=>{
    if (!(0, $80Pke.cacheableTypes).includes(type)) return null;
    if ((size === undefined || size === 0) && duration === 0) return $d4108de44c777dc2$export$783d6618ee601ba.MEMORY_KEY;
    if (size === 0 && duration > 0) return $d4108de44c777dc2$export$783d6618ee601ba.DISK_KEY;
    if (size === undefined) return null;
    return $d4108de44c777dc2$export$783d6618ee601ba.NETWORK_KEY;
};
class $d4108de44c777dc2$export$783d6618ee601ba {
    static{
        this.MEMORY_KEY = 'mem';
    }
    static{
        this.DISK_KEY = 'disk';
    }
    static{
        this.NETWORK_KEY = 'net';
    }
    add(item) {
        const type = $d4108de44c777dc2$var$calculateTransferType(item.initiatorType, item.duration, item.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += item.encodedBodySize;
        this.sizeTotal += item.encodedBodySize;
    }
    constructor(){
        this.bundles = {
            [$d4108de44c777dc2$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$d4108de44c777dc2$export$783d6618ee601ba.DISK_KEY]: 0,
            [$d4108de44c777dc2$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [$d4108de44c777dc2$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$d4108de44c777dc2$export$783d6618ee601ba.DISK_KEY]: 0,
            [$d4108de44c777dc2$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.sizeTotal = 0;
    }
}

});



parcelRegister("8eEfr", function(module, exports) {

$parcel$export(module.exports, "getLighthouseMetrics", () => $c429933143d93b08$export$b46cecdf698e4bb5);

var $6yB0H = parcelRequire("6yB0H");

var $fU1DZ = parcelRequire("fU1DZ");

var $ki7im = parcelRequire("ki7im");

var $HvJRS = parcelRequire("HvJRS");

var $iv3lO = parcelRequire("iv3lO");
function $c429933143d93b08$export$5ecf2aafafee3e0() {
    (0, $iv3lO.startLSObserver)();
    (0, $iv3lO.startLTObserver)();
}
const $c429933143d93b08$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $ki7im.getTBT)(start, stop, (0, $HvJRS.EntriesBuffer)[(0, $fU1DZ.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $6yB0H.getCLS)(start, stop, (0, $HvJRS.EntriesBuffer)[(0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("6yB0H", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $d45da93e3b9b262f$export$fc6227831ee7c7);
const $d45da93e3b9b262f$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("fU1DZ", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $234a057f27dc569a$export$a4def92db6fc8e17);
const $234a057f27dc569a$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("ki7im", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $69d3b5006a881dee$export$2d6e933b35bd3407);
const $69d3b5006a881dee$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $69d3b5006a881dee$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $69d3b5006a881dee$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $69d3b5006a881dee$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $69d3b5006a881dee$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("HvJRS", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $726140cc85f82002$export$f7dc16cbd16f7bbe);

var $fU1DZ = parcelRequire("fU1DZ");
class $726140cc85f82002$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $726140cc85f82002$export$f7dc16cbd16f7bbe = {
    [(0, $fU1DZ.PerformanceObserverEntryTypes).LongTask]: new $726140cc85f82002$export$2c6e86519c9e8188(),
    [(0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift]: new $726140cc85f82002$export$2c6e86519c9e8188()
};

});

parcelRegister("iv3lO", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $dba5609f3cb4bc6f$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $dba5609f3cb4bc6f$export$54fb8b6aaf70ec9c);

var $fU1DZ = parcelRequire("fU1DZ");

var $HvJRS = parcelRequire("HvJRS");
let $dba5609f3cb4bc6f$var$pe = null;
const $dba5609f3cb4bc6f$var$getObserver = ()=>{
    if ($dba5609f3cb4bc6f$var$pe !== null) return $dba5609f3cb4bc6f$var$pe;
    $dba5609f3cb4bc6f$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift) (0, $HvJRS.EntriesBuffer)[(0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $fU1DZ.PerformanceObserverEntryTypes).LongTask) (0, $HvJRS.EntriesBuffer)[(0, $fU1DZ.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $dba5609f3cb4bc6f$var$pe;
};
const $dba5609f3cb4bc6f$export$768ccc3ab7bac3ea = ()=>{
    $dba5609f3cb4bc6f$var$getObserver().observe({
        type: (0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $dba5609f3cb4bc6f$export$54fb8b6aaf70ec9c = ()=>{
    $dba5609f3cb4bc6f$var$getObserver().observe({
        type: (0, $fU1DZ.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("aHzNY", function(module, exports) {

$parcel$export(module.exports, "getMarks", () => $060b26259ca6e3b9$export$9d952633c9c2237b);

var $llxpa = parcelRequire("llxpa");

var $hknOo = parcelRequire("hknOo");
const $060b26259ca6e3b9$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $llxpa.getUserTiming)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    // @ts-expect-error - TS7031 - Binding element 'baseName' implicitly has an 'any' type. | TS7031 - Binding element 'collection' implicitly has an 'any' type.
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter(// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    (item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, $hknOo.JS_EVAL_START)) && !item.name.endsWith((0, $hknOo.JS_EVAL_STOP)) && item.startTime >= data.start)// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    .forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};

});

parcelRegister("5asE8", function(module, exports) {

$parcel$export(module.exports, "getMemoryUsageReport", () => $94ae843e3148994a$export$e5bd2d61c7c80651);
/**
 * Memory usage report.
 *
 * In the future may be extended to contain `performance.measureUserAgentSpecificMemory` if Jira
 * front-end uses cross-origin isolation.
 */ const $94ae843e3148994a$export$e5bd2d61c7c80651 = ({ start: start, stop: stop })=>{
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    if (typeof performance === 'undefined' || performance?.memory == null) return null;
    const sessionTime = Math.round(stop - start);
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
    return {
        sessionTime: sessionTime,
        performanceMemoryEntry: {
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize
        }
    };
};

});

parcelRegister("3J8Ab", function(module, exports) {

$parcel$export(module.exports, "getPageSizeMetrics", () => $3c810a8de2a9a285$export$84e3d676f1564c75);
$parcel$export(module.exports, "getExtraNavigationTimings", () => $3c810a8de2a9a285$export$b37a70af06e58097);
$parcel$export(module.exports, "getPageSizeInfo", () => $3c810a8de2a9a285$export$b72e035af6568be7);

var $hgcvd = parcelRequire("hgcvd");
const $3c810a8de2a9a285$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) // @ts-expect-error - TS2345 - Argument of type 'ShadowRoot' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $3c810a8de2a9a285$export$b37a70af06e58097 = ()=>{
    if (!(0, $hgcvd.default)) return {};
    const navigation = (0, $hgcvd.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        // @ts-expect-error - TS2339 - Property 'decodedBodySize' does not exist on type 'PerformanceEntry'.
        decodedBodySize: navigation.decodedBodySize,
        // @ts-expect-error - TS2339 - Property 'encodedBodySize' does not exist on type 'PerformanceEntry'.
        encodedBodySize: navigation.encodedBodySize,
        // @ts-expect-error - TS2339 - Property 'transferSize' does not exist on type 'PerformanceEntry'.
        transferSize: navigation.transferSize
    };
};
const $3c810a8de2a9a285$var$assetsTypes = [
    'script',
    'link'
];
const $3c810a8de2a9a285$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $3c810a8de2a9a285$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const entry of (0, $hgcvd.default).getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($3c810a8de2a9a285$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    return returnValue;
};

});

parcelRegister("jRw2l", function(module, exports) {

$parcel$export(module.exports, "getRouterResourceMetrics", () => $408d5049c0fbe74b$export$e703af446a67c7f4);
const $408d5049c0fbe74b$export$e703af446a67c7f4 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
        if (key !== key.toUpperCase()) return false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resource = window.SPA_STATE[key];
        if (typeof resource !== 'object') return false;
        const resourceResponse = resource[Object.keys(resource)[0]];
        return resourceResponse?.error?.name === 'TimeoutError';
    }) : [];
    return {
        ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
    };
};

});

parcelRegister("8Icn5", function(module, exports) {

$parcel$export(module.exports, "getServerDurationMetrics", () => $812c01dc8d4942e0$export$efd8b60b870e5282);
const $812c01dc8d4942e0$export$efd8b60b870e5282 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const metrics = {};
    try {
        // server duration metric is buried in a hidden form near end of </body>
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
        if (serverDurationElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverDuration = Number(serverDurationElem.value);
            if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
        if (serverTraceIdElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceId = serverTraceIdElem.value;
            metrics.serverRequestTraceId = serverRequestTraceId;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
        if (serverTraceSampledElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceSampled = serverTraceSampledElem.value;
            switch(serverRequestTraceSampled){
                case 'true':
                    metrics.serverRequestTraceSampled = true;
                    break;
                case 'false':
                    metrics.serverRequestTraceSampled = false;
                    break;
                default:
                    metrics.serverRequestTraceSampled = null;
                    break;
            }
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
        if (concurrentRequestsElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const concurrentRequests = concurrentRequestsElem.value;
            metrics.concurrentRequests = concurrentRequests;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
        if (serverRequestStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestStartTime = serverRequestStartTimeElem.value;
            metrics.serverRequestStartTime = serverRequestStartTime;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
        if (frontendFlushStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const frontendFlushStartTime = frontendFlushStartTimeElem.value;
            metrics.frontendFlushStartTime = frontendFlushStartTime;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ignored) {
    /* noop */ }
    return metrics;
};

});

parcelRegister("eRsSp", function(module, exports) {

$parcel$export(module.exports, "getSSRStateInformation", () => $9d0a7886cfd1a973$export$9a46186893ad76bd);

var $6iz4v = parcelRequire("6iz4v");
const $9d0a7886cfd1a973$var$getState = ()=>{
    if ((0, $6iz4v.getMark)('ssr.spa.state')?.startTime) return 'success';
    if ((0, $6iz4v.getMark)('ssr.spa.early-common-flush:end')?.startTime) return 'spa-render-failure';
    return 'static-fallback';
};
const $9d0a7886cfd1a973$export$9a46186893ad76bd = ()=>{
    return {
        'ssr:state': $9d0a7886cfd1a973$var$getState()
    };
};

});

parcelRegister("byQ0F", function(module, exports) {

$parcel$export(module.exports, "getWRMStats", () => $3a9718319a9f67d8$export$d2d916ddd03b82bc);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3a9718319a9f67d8$export$d2d916ddd03b82bc = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
    return {
        wrmStats: wrmStats
    };
};

});


parcelRegister("34jRK", function(module, exports) {

$parcel$export(module.exports, "configure", () => $d2d279417773491d$export$8d21e34596265fa2);
$parcel$export(module.exports, "getBundleEvalTimings", () => $d2d279417773491d$export$2eda1519e91a4386);

var $1MfYa = parcelRequire("1MfYa");
let $d2d279417773491d$var$config = null;
function $d2d279417773491d$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $d2d279417773491d$var$config = bundleEvalTimingConfiguration;
}
const $d2d279417773491d$var$getPerformanceObject = ()=>(window ?? {}).performance;
function $d2d279417773491d$export$2eda1519e91a4386(interactionStartTime) {
    if ($d2d279417773491d$var$config == null) return {};
    const started = {};
    const timings = {};
    const cachedConfig = $d2d279417773491d$var$config;
    const performance = $d2d279417773491d$var$getPerformanceObject();
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, $1MfYa.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, $1MfYa.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

});
parcelRegister("1MfYa", function(module, exports) {

$parcel$export(module.exports, "roundEpsilon", () => $85eb44f9a062cabc$export$56014375de40214b);
const $85eb44f9a062cabc$export$56014375de40214b = (num, places = 3)=>{
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
};

});


parcelRegister("4XwAi", function(module, exports) {

$parcel$export(module.exports, "init", () => $aa4b1ad4bc799c98$export$2cd8252107eb640b);

var $9oL1R = parcelRequire("9oL1R");

var $iynnl = parcelRequire("iynnl");

var $fTZm7 = parcelRequire("fTZm7");

var $74uvx = parcelRequire("74uvx");

var $fYqUr = parcelRequire("fYqUr");

var $ku8gc = parcelRequire("ku8gc");
let $aa4b1ad4bc799c98$var$initialized = false;
function $aa4b1ad4bc799c98$var$sinkInteraction(instance, payloadPackage) {
    (0, $fYqUr.sinkInteractionHandler)((interactionId, interaction)=>{
        (0, $9oL1R.unstable_scheduleCallback)((0, $9oL1R.unstable_IdlePriority), ()=>{
            const payloads = payloadPackage.createPayloads(interactionId, interaction);
            payloads?.forEach((payload)=>{
                instance.sendOperationalEvent(payload);
            });
        });
    });
}
function $aa4b1ad4bc799c98$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $fYqUr.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $9oL1R.unstable_scheduleCallback)((0, $9oL1R.unstable_IdlePriority), ()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}


const $aa4b1ad4bc799c98$export$2cd8252107eb640b = (analyticsWebClientAsync, config)=>{
    if ($aa4b1ad4bc799c98$var$initialized) return;
    (0, $fTZm7.setUFOConfig)(config);
    if (config.vc?.enabled) (0, $ku8gc.getVCObserver)({
        heatmapSize: config.vc.heatmapSize,
        oldDomUpdates: config.vc.oldDomUpdates,
        devToolsEnabled: config.vc.devToolsEnabled,
        selectorConfig: config.vc.selectorConfig
    }).start({
        startTime: 0
    });
    (0, $74uvx.setupHiddenTimingCapture)();
    (0, $iynnl.startLighthouseObserver)();
    $aa4b1ad4bc799c98$var$initialized = true;
    Promise.all([
        analyticsWebClientAsync,
        // eslint-disable-next-line import/dynamic-import-chunkname
        (parcelRequire("bGv8I")),
        // eslint-disable-next-line import/dynamic-import-chunkname
        (parcelRequire("dogu1"))
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $aa4b1ad4bc799c98$var$sinkInteraction(instance, payloadPackage);
            if (config.captureLateReRenders) $aa4b1ad4bc799c98$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
        });
        else if (awc.sendOperationalEvent) {
            $aa4b1ad4bc799c98$var$sinkInteraction(awc, payloadPackage);
            if (config.captureLateReRenders) $aa4b1ad4bc799c98$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
        }
    });
};

});
parcelRegister("iynnl", function(module, exports) {

$parcel$export(module.exports, "startLighthouseObserver", () => $e729642948398237$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $e729642948398237$export$b46cecdf698e4bb5);

var $aFeyY = parcelRequire("aFeyY");

var $k35t3 = parcelRequire("k35t3");

var $7YNvs = parcelRequire("7YNvs");

var $4W159 = parcelRequire("4W159");

var $pVM50 = parcelRequire("pVM50");
function $e729642948398237$export$5ecf2aafafee3e0() {
    (0, $pVM50.startLSObserver)();
    (0, $pVM50.startLTObserver)();
}
const $e729642948398237$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $7YNvs.getTBT)(start, stop, (0, $4W159.EntriesBuffer)[(0, $k35t3.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $aFeyY.getCLS)(start, stop, (0, $4W159.EntriesBuffer)[(0, $k35t3.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("aFeyY", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $011a7ae913704706$export$fc6227831ee7c7);
const $011a7ae913704706$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("k35t3", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $ff6770e8e3754bf5$export$a4def92db6fc8e17);
const $ff6770e8e3754bf5$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("7YNvs", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $c3c22dfb8a80a14b$export$2d6e933b35bd3407);
const $c3c22dfb8a80a14b$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $c3c22dfb8a80a14b$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $c3c22dfb8a80a14b$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $c3c22dfb8a80a14b$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $c3c22dfb8a80a14b$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("4W159", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $91759d0d12d169e7$export$f7dc16cbd16f7bbe);

var $k35t3 = parcelRequire("k35t3");
class $91759d0d12d169e7$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $91759d0d12d169e7$export$f7dc16cbd16f7bbe = {
    [(0, $k35t3.PerformanceObserverEntryTypes).LongTask]: new $91759d0d12d169e7$export$2c6e86519c9e8188(),
    [(0, $k35t3.PerformanceObserverEntryTypes).LayoutShift]: new $91759d0d12d169e7$export$2c6e86519c9e8188()
};

});

parcelRegister("pVM50", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $b2f7c91c9c1f8ec6$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $b2f7c91c9c1f8ec6$export$54fb8b6aaf70ec9c);

var $k35t3 = parcelRequire("k35t3");

var $4W159 = parcelRequire("4W159");
let $b2f7c91c9c1f8ec6$var$pe = null;
const $b2f7c91c9c1f8ec6$var$getObserver = ()=>{
    if ($b2f7c91c9c1f8ec6$var$pe !== null) return $b2f7c91c9c1f8ec6$var$pe;
    $b2f7c91c9c1f8ec6$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $k35t3.PerformanceObserverEntryTypes).LayoutShift) (0, $4W159.EntriesBuffer)[(0, $k35t3.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $k35t3.PerformanceObserverEntryTypes).LongTask) (0, $4W159.EntriesBuffer)[(0, $k35t3.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $b2f7c91c9c1f8ec6$var$pe;
};
const $b2f7c91c9c1f8ec6$export$768ccc3ab7bac3ea = ()=>{
    $b2f7c91c9c1f8ec6$var$getObserver().observe({
        type: (0, $k35t3.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $b2f7c91c9c1f8ec6$export$54fb8b6aaf70ec9c = ()=>{
    $b2f7c91c9c1f8ec6$var$getObserver().observe({
        type: (0, $k35t3.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("74uvx", function(module, exports) {

$parcel$export(module.exports, "setupHiddenTimingCapture", () => $589b92b00bc9f3be$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $589b92b00bc9f3be$export$768b2008623433e1);

var $74BVL = parcelRequire("74BVL");
const $589b92b00bc9f3be$var$timings = [];
let $589b92b00bc9f3be$var$wasHiddenFlag;
let $589b92b00bc9f3be$var$setupFlag = false;
function $589b92b00bc9f3be$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $589b92b00bc9f3be$var$SIZE = 50;
let $589b92b00bc9f3be$var$insertIndex = 0;
function $589b92b00bc9f3be$var$pushHidden(isPageHiddenFlag, time) {
    $589b92b00bc9f3be$var$timings[$589b92b00bc9f3be$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $589b92b00bc9f3be$var$insertIndex = ($589b92b00bc9f3be$var$insertIndex + 1) % $589b92b00bc9f3be$var$SIZE;
    $589b92b00bc9f3be$var$wasHiddenFlag = isPageHiddenFlag;
}
function $589b92b00bc9f3be$var$handleChange() {
    const isPageHiddenFlag = $589b92b00bc9f3be$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$589b92b00bc9f3be$var$wasHiddenFlag) $589b92b00bc9f3be$var$pushHidden(isPageHiddenFlag);
        $589b92b00bc9f3be$var$wasHiddenFlag = true;
    } else {
        if ($589b92b00bc9f3be$var$wasHiddenFlag) $589b92b00bc9f3be$var$pushHidden(isPageHiddenFlag);
        $589b92b00bc9f3be$var$wasHiddenFlag = false;
    }
}
function $589b92b00bc9f3be$var$setup() {
    (0, $74BVL.bind)(window, {
        type: 'pageshow',
        listener: $589b92b00bc9f3be$var$handleChange
    });
    (0, $74BVL.bind)(window, {
        type: 'pagehide',
        listener: $589b92b00bc9f3be$var$handleChange
    });
    (0, $74BVL.bind)(document, {
        type: 'visibilitychange',
        listener: $589b92b00bc9f3be$var$handleChange
    });
}
function $589b92b00bc9f3be$export$554cefe0f0373da4() {
    if (!$589b92b00bc9f3be$var$setupFlag) {
        const isPageHiddenFlag = $589b92b00bc9f3be$var$isPageHidden();
        $589b92b00bc9f3be$var$pushHidden(isPageHiddenFlag, 0);
        $589b92b00bc9f3be$var$setup();
        $589b92b00bc9f3be$var$setupFlag = true;
    }
}
function $589b92b00bc9f3be$export$768b2008623433e1(start, end) {
    // Desirable default value is visible
    if ($589b92b00bc9f3be$var$timings.length === 0) return 'visible';
    const currentSize = $589b92b00bc9f3be$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $589b92b00bc9f3be$var$insertIndex;
    let endIdx = $589b92b00bc9f3be$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($589b92b00bc9f3be$var$insertIndex + i) % currentSize;
        if ($589b92b00bc9f3be$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($589b92b00bc9f3be$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    if (endIdx - startIdx === 0) {
        if ($589b92b00bc9f3be$var$timings[startIdx].hidden) hiddenState = 'hidden';
        else hiddenState = 'visible';
    }
    return hiddenState;
}

});

parcelRegister("bGv8I", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("75g9R").then(()=>parcelRequire('2de3e'));

});

parcelRegister("dogu1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("h2Xhv").then(()=>parcelRequire('5IODc'));

});


parcelRegister("33zSj", function(module, exports) {

$parcel$export(module.exports, "configure", () => $d7ebcd54c40c7c28$export$8d21e34596265fa2);
$parcel$export(module.exports, "getConfig", () => $d7ebcd54c40c7c28$export$44487a86467333c3);

var $fTZm7 = parcelRequire("fTZm7");
const $d7ebcd54c40c7c28$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
const $d7ebcd54c40c7c28$var$getAllowedParams = ()=>{
    const config = (0, $fTZm7.getConfig)();
    return config?.allowedResourcesParams || $d7ebcd54c40c7c28$var$defaultAllowedParams;
};
const $d7ebcd54c40c7c28$var$handleQueryParams = (urlString)=>{
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $d7ebcd54c40c7c28$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch (e) {
        return urlString;
    }
};
let $d7ebcd54c40c7c28$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $d7ebcd54c40c7c28$var$handleQueryParams(url);
    }
};
function $d7ebcd54c40c7c28$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $d7ebcd54c40c7c28$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $d7ebcd54c40c7c28$var$config = newConfig;
}
const $d7ebcd54c40c7c28$export$44487a86467333c3 = ()=>$d7ebcd54c40c7c28$var$config;

});

parcelRegister("6q0D0", function(module, exports) {

$parcel$export(module.exports, "startResourceTimingBuffer", () => $02954ab6ad465411$export$a311cb1baa7d2d62);

var $9n1yq = parcelRequire("9n1yq");
function $02954ab6ad465411$export$a311cb1baa7d2d62() {
    (0, $9n1yq.resourceTimingBuffer).start();
}

});
parcelRegister("9n1yq", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", () => $18abce7ca5936e3e$export$bea963256235a63e);
$parcel$export(module.exports, "filterResourceTimings", () => $18abce7ca5936e3e$export$4138a729ef1db028);

var $1MfYa = parcelRequire("1MfYa");
const $18abce7ca5936e3e$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $18abce7ca5936e3e$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $18abce7ca5936e3e$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>{
        const duration = (0, $1MfYa.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $1MfYa.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $1MfYa.roundEpsilon)(entry.startTime),
            duration: (0, $1MfYa.roundEpsilon)(entry.duration),
            fetchStart: (0, $1MfYa.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $1MfYa.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $1MfYa.roundEpsilon)(entry.responseStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $1MfYa.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $1MfYa.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start: ()=>{
        const performance = $18abce7ca5936e3e$var$getPerformanceObject();
        const PerformanceObserver = $18abce7ca5936e3e$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($18abce7ca5936e3e$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $18abce7ca5936e3e$export$bea963256235a63e.timings = resources.map((resource)=>$18abce7ca5936e3e$export$bea963256235a63e.transformResource(resource));
        $18abce7ca5936e3e$export$bea963256235a63e.observer = new PerformanceObserver($18abce7ca5936e3e$export$bea963256235a63e.addTimings);
        $18abce7ca5936e3e$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($18abce7ca5936e3e$export$bea963256235a63e.observer) {
            $18abce7ca5936e3e$export$bea963256235a63e.observer.disconnect();
            $18abce7ca5936e3e$export$bea963256235a63e.observer = null;
        }
        $18abce7ca5936e3e$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$18abce7ca5936e3e$export$bea963256235a63e.transformResource(entry));
        const overflow = $18abce7ca5936e3e$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $18abce7ca5936e3e$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $18abce7ca5936e3e$export$bea963256235a63e.maxSize;
            $18abce7ca5936e3e$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $18abce7ca5936e3e$export$bea963256235a63e.timings.push(...entries);
    }
};
const $18abce7ca5936e3e$var$isValidTiming = (timing, startTime, endTime)=>timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
const $18abce7ca5936e3e$export$4138a729ef1db028 = (startTime, endTime)=>{
    const performance = $18abce7ca5936e3e$var$getPerformanceObject();
    const PerformanceObserver = $18abce7ca5936e3e$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$18abce7ca5936e3e$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$18abce7ca5936e3e$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $18abce7ca5936e3e$export$bea963256235a63e.timings.filter((timing)=>$18abce7ca5936e3e$var$isValidTiming(timing, startTime, endTime));
};

});


parcelRegister("84pUs", function(module, exports) {

$parcel$export(module.exports, "configure", () => $c2e6a14d5d1c94ea$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $c2e6a14d5d1c94ea$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $c2e6a14d5d1c94ea$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRDoneTime", () => $c2e6a14d5d1c94ea$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $c2e6a14d5d1c94ea$export$1c4a9b5e6e22393d);
const $c2e6a14d5d1c94ea$var$NESTED_METRIC_SEPARATOR = '/';
const $c2e6a14d5d1c94ea$var$filterEntry = (entry)=>!(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
const $c2e6a14d5d1c94ea$var$mapEntry = (entry)=>({
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    });
const $c2e6a14d5d1c94ea$var$SSR_PREFIX = 'ssr';
const $c2e6a14d5d1c94ea$var$mapKey = (key)=>{
    if (key === 'total') return $c2e6a14d5d1c94ea$var$SSR_PREFIX;
    return `${$c2e6a14d5d1c94ea$var$SSR_PREFIX}${$c2e6a14d5d1c94ea$var$NESTED_METRIC_SEPARATOR}${key}`;
};
let $c2e6a14d5d1c94ea$var$config;
function $c2e6a14d5d1c94ea$export$8d21e34596265fa2(ssrConfig) {
    $c2e6a14d5d1c94ea$var$config = ssrConfig;
}
function $c2e6a14d5d1c94ea$export$bf7408e83532dcd0() {
    if (!$c2e6a14d5d1c94ea$var$config?.getTimings) return {};
    const timings = $c2e6a14d5d1c94ea$var$config.getTimings();
    if (!timings) return {};
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($c2e6a14d5d1c94ea$var$filterEntry(entry[1])) acc[$c2e6a14d5d1c94ea$var$mapKey(entry[0])] = $c2e6a14d5d1c94ea$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $c2e6a14d5d1c94ea$export$c7ad864055e75537() {
    return !!$c2e6a14d5d1c94ea$var$config?.getDoneMark();
}
function $c2e6a14d5d1c94ea$export$3def7672244bab0c() {
    return $c2e6a14d5d1c94ea$var$config?.getDoneMark() ?? undefined;
}
function $c2e6a14d5d1c94ea$export$1c4a9b5e6e22393d() {
    if (!$c2e6a14d5d1c94ea$var$config?.getFeatureFlags) return undefined;
    try {
        return $c2e6a14d5d1c94ea$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return undefined;
}

});

parcelRegister("kvBcO", function(module, exports) {

$parcel$export(module.exports, "jiraBundleEvalTimingsConfig", () => $90678e6868a8e976$export$791b8c0cbd574ea9);

var $hknOo = parcelRequire("hknOo");
const $90678e6868a8e976$export$791b8c0cbd574ea9 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $hknOo.JS_EVAL_START))) return {
            name: mark.substring(0, mark.indexOf((0, $hknOo.JS_EVAL_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $hknOo.JS_EVAL_STOP))) return {
            name: mark.substring(0, mark.indexOf((0, $hknOo.JS_EVAL_STOP))),
            type: 'end'
        };
        return null;
    }
};

});

parcelRegister("8NQa5", function(module, exports) {

$parcel$export(module.exports, "jiraResourceTimingsConfig", () => $0beb836a724a435f$export$8fa71550bcdc2104);

var $k4nIh = parcelRequire("k4nIh");

var $lCenZ = parcelRequire("lCenZ");
const $0beb836a724a435f$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
const $0beb836a724a435f$var$getWRMAssetName = (url)=>{
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = (0, $lCenZ.sanitiseAssetName)(false)(url);
    if (!resources) return assetName;
    return `wrm/${resources}/${assetName}`;
};
const $0beb836a724a435f$var$getFileName = (url)=>$0beb836a724a435f$var$isWRMResource(url) ? $0beb836a724a435f$var$getWRMAssetName(url) : (0, $lCenZ.sanitiseAssetName)(false)(url);
const $0beb836a724a435f$var$sanitiseEndpoints = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, true);
    /**
	 * For endpoints with operation or operationName queryParam we will shorten the url
	 * as ufo pipeline will only get the `operation` query param for aggregation
	 */ const { operation: operation, operationName: operationName } = parsedUrl.query;
    const operationNameOverride = operation ?? operationName;
    if (operationNameOverride) return `/${operation}?operation=${operation}`;
    const fileName = parsedUrl.pathname.replace(/\/(project|agent)(-config|s)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(servicedesk)(-data)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(browse|automation|pagination|permissions|async|dialog|itsm)\/([A-Z0-9]+)/g, '/$1/<project-key>').replace(/\/(board)(s)?\/([0-9]+)/g, '/$1$2/<board-id>').replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
    .replace(/\/user\/[a-fA-F0-9\-:]+/i, '/user/<user-id>') // engage targeting
    .replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/i, '<uuid>').replace(/\/\d+$/i, '/<id>');
    return fileName;
};
const $0beb836a724a435f$export$8fa71550bcdc2104 = {
    sanitiseEndpoints: $0beb836a724a435f$var$sanitiseEndpoints,
    mapResources: $0beb836a724a435f$var$getFileName,
    hasTimingHeaders: (url)=>url.includes('jira-frontend-static') || url.includes('jira-frontend-branch') || url.includes('jira-frontend-bifrost') || $0beb836a724a435f$var$isWRMResource(url),
    // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
    xhrFilter: (url)=>url.includes('/rest/greenhopper/')
};

});

parcelRegister("g62MK", function(module, exports) {

$parcel$export(module.exports, "jiraSsrConfig", () => $0781fcdae6ae9d6a$export$7bcf91e323db67dd);

var $kd0cS = parcelRequire("kd0cS");

var $6iz4v = parcelRequire("6iz4v");

var $eI5EY = parcelRequire("eI5EY");

var $6rW04 = parcelRequire("6rW04");

function $0781fcdae6ae9d6a$var$getTimings() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.SPA_STATE) return null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const detailRenderTrace = window.SPA_STATE['ssr/detail_render_trace'];
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const detailRequestTrace = window.SPA_STATE['ssr/detail_request_trace'];
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const highLevelMetrics = window.SPA_STATE['ssr/metrics'];
    const timings = (0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(detailRenderTrace?.data?.traces) || {};
    if (highLevelMetrics?.data) {
        if ('ssrTotal' in highLevelMetrics.data) timings.total = {
            startTime: 0,
            duration: highLevelMetrics.data.ssrTotal
        };
        if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
            startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
            duration: highLevelMetrics.data.ssrGetStyle
        };
        if ('ssrPrefetch' in highLevelMetrics.data) {
            const prefetchStartTime = Object.values(detailRenderTrace?.data?.traces || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
            timings.prefetch = {
                startTime: prefetchStartTime,
                duration: highLevelMetrics.data.ssrPrefetch
            };
        }
    }
    if (detailRequestTrace?.data) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
        timings[`prefetch/${key}`] = value;
    });
    return timings;
}
const $0781fcdae6ae9d6a$var$SSR_FF_META_TAG = 'spa-service-flags';
let $0781fcdae6ae9d6a$var$ffCache;
let $0781fcdae6ae9d6a$var$ffCacheInitialiser = ()=>{
    try {
        const metaTagValue = (0, $6rW04.default)($0781fcdae6ae9d6a$var$SSR_FF_META_TAG);
        if (metaTagValue === null) return null;
        $0781fcdae6ae9d6a$var$ffCache = JSON.parse(metaTagValue) || null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        $0781fcdae6ae9d6a$var$ffCache = null;
    }
    $0781fcdae6ae9d6a$var$ffCacheInitialiser = null;
};
function $0781fcdae6ae9d6a$var$getFeatureFlags() {
    if ($0781fcdae6ae9d6a$var$ffCacheInitialiser != null) $0781fcdae6ae9d6a$var$ffCacheInitialiser();
    return $0781fcdae6ae9d6a$var$ffCache;
}
const $0781fcdae6ae9d6a$export$7bcf91e323db67dd = {
    getDoneMark: ()=>{
        if ((0, $eI5EY.fg)('ssr_success_when_spa_success')) {
            const SPASSRRenderedMark = (0, $6iz4v.getMark)((0, $37f655a4e4d5690e$export$135c96ab5afee429))?.startTime;
            if (SPASSRRenderedMark && (0, $6iz4v.getMark)('ssr.spa.state')?.startTime) return SPASSRRenderedMark;
            return null;
        }
        return (0, $6iz4v.getMark)((0, $37f655a4e4d5690e$export$135c96ab5afee429))?.startTime || null;
    },
    getTimings: $0781fcdae6ae9d6a$var$getTimings,
    getFeatureFlags: $0781fcdae6ae9d6a$var$getFeatureFlags
};

});


parcelRegister("2ctsX", function(module, exports) {

$parcel$export(module.exports, "visualRefreshResolverOverride", () => $03418a879dc1bb78$export$73a94df81a7c0f2c);

var $8rQuz = parcelRequire("8rQuz");
const $03418a879dc1bb78$var$visualRefreshPlatformFlags = [
    'platform-component-visual-refresh',
    'platform-visual-refresh-icons-legacy-facade',
    'platform-visual-refresh-icons'
];
const $03418a879dc1bb78$export$73a94df81a7c0f2c = [
    (flagKey)=>$03418a879dc1bb78$var$visualRefreshPlatformFlags.includes(flagKey),
    (0, $8rQuz.isVisualRefreshEnabled)
];

});

parcelRegister("02rEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c49be5032b3fe78a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "updatePageloadName", () => $c49be5032b3fe78a$export$d0f99433cd4f4028);

var $hompL = parcelRequire("hompL");

var $66aNr = parcelRequire("66aNr");

var $fTZm7 = parcelRequire("fTZm7");

var $baC3k = parcelRequire("baC3k");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $41dmJ = parcelRequire("41dmJ");
const $c49be5032b3fe78a$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $c49be5032b3fe78a$export$2e2bcd8739ae039(ufoName, routeName = ufoName) {
    const activeInteraction = (0, $fYqUr.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $41dmJ.default).current = routeName || null;
    const rate = ufoName ? (0, $fTZm7.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $66aNr.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        const newId = (0, $hompL.v4)();
        (0, $51JrV.DefaultInteractionID).current = newId;
        (0, $fYqUr.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $baC3k.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $fYqUr.addHoldByID)(newId, [], $c49be5032b3fe78a$var$AWAITING_PAGELOAD_NAME, $c49be5032b3fe78a$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $fYqUr.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $fYqUr.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $fYqUr.removeHoldByID)(activeInteraction.id, $c49be5032b3fe78a$var$AWAITING_PAGELOAD_NAME);
    }
}
function $c49be5032b3fe78a$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    const interaction = (0, $fYqUr.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $fTZm7.getInteractionRate)(ufoName, 'page_load');
        (0, $fYqUr.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $66aNr.default)(rate)) (0, $41dmJ.default).current = ufoName;
        else (0, $fYqUr.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $fYqUr.removeHoldByID)(interaction.id, $c49be5032b3fe78a$var$AWAITING_PAGELOAD_NAME);
}

});

parcelRegister("foPCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3caef8d053fb2a2$export$2e2bcd8739ae039);

var $kFGm5 = parcelRequire("kFGm5");

var $ieRGA = parcelRequire("ieRGA");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $2aRps = parcelRequire("2aRps");

var $1Fe9v = parcelRequire("1Fe9v");
// eslint-disable-next-line jira/ff/inline-usage
const $d3caef8d053fb2a2$var$isHeartbeatEnabled = ()=>(0, $1ybV0.ff)('jfp.heartbeat_vfp2h', false);

const $d3caef8d053fb2a2$var$renderEngagementMessages = ()=>{
    (parcelRequire("ll5c1"));
};

const $d3caef8d053fb2a2$var$renderProfileCardNextLegacy = ()=>{
    (parcelRequire("2QHbi"));
};

const $d3caef8d053fb2a2$var$renderHeartbeat = ()=>{
    (parcelRequire("6i2jN"));
};

const $d3caef8d053fb2a2$var$loadUpFlowAPI = ()=>(parcelRequire("5WlWz"));

const $d3caef8d053fb2a2$var$installConnectModules = ()=>(parcelRequire("jPTXR"));
const $d3caef8d053fb2a2$var$markSafeForAnalytics = (str)=>str || null;
const $d3caef8d053fb2a2$var$renderSearchDwellTimeComponent = ()=>{
    const searchSessionId = (0, $6rW04.default)('ajs-search-session-id');
    const containerId = (0, $6rW04.default)('ajs-search-container-id');
    const objectId = (0, $6rW04.default)('ajs-search-object-id');
    const objectType = (0, $6rW04.default)('ajs-search-content-type');
    (0, $ieRGA.default)([
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ]);
    (0, $1Fe9v.default)('search-dwell-time', $d3caef8d053fb2a2$var$markSafeForAnalytics(searchSessionId), {
        containerId: $d3caef8d053fb2a2$var$markSafeForAnalytics(containerId),
        objectId: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectId),
        objectType: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectType),
        actionSubject: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectType),
        source: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectType)
    });
};
const $d3caef8d053fb2a2$var$installHighPriorityApps = (args)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'JiraContextContainer'.
    const priorityApps = [];
    if (args.flags) priorityApps.push((0, $2aRps.renderFlags)());
    if (args.navigation) priorityApps.push(args.renderNavigation());
    return priorityApps;
};
const $d3caef8d053fb2a2$var$installLowPriorityApps = (args)=>{
    if (args.upflow) $d3caef8d053fb2a2$var$loadUpFlowAPI();
    if (args.profileCardNextLegacy) $d3caef8d053fb2a2$var$renderProfileCardNextLegacy();
    if (args.connectModules) $d3caef8d053fb2a2$var$installConnectModules();
    if (args.engagementMessages) $d3caef8d053fb2a2$var$renderEngagementMessages();
    if (args.heartbeat) $d3caef8d053fb2a2$var$renderHeartbeat();
    if (args.searchDwellTimeComponent) $d3caef8d053fb2a2$var$renderSearchDwellTimeComponent();
};
const $d3caef8d053fb2a2$var$installAppsWithPriorityOrder = async (args)=>{
    await Promise.all($d3caef8d053fb2a2$var$installHighPriorityApps({
        flags: args.flags,
        navigation: args.navigation,
        renderNavigation: args.renderNavigation
    }));
    $d3caef8d053fb2a2$var$installLowPriorityApps((0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(args, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
};
const $d3caef8d053fb2a2$var$defaultArgs = {
    flags: true,
    navigation: true,
    upflow: true,
    profileCardNextLegacy: true,
    heartbeat: $d3caef8d053fb2a2$var$isHeartbeatEnabled(),
    connectModules: true,
    engagementMessages: true,
    searchDwellTimeComponent: true,
    renderNavigation: ()=>null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d3caef8d053fb2a2$export$2e2bcd8739ae039 = {
    install: (args)=>{
        const argsWithDefaults = {
            ...$d3caef8d053fb2a2$var$defaultArgs,
            ...args
        };
        // @ts-expect-error - TS2345 - Argument of type '{ flags: boolean; navigation: boolean; renderNavigation: (() => any) | (() => null); upflow: boolean; heartbeat: boolean; profileCardNextLegacy: boolean; connectModules: boolean; originTracing?: boolean | undefined; engagementMessages: boolean; searchDwellTimeComponent: boolean; }' is not assignable to parameter of type 'GlobalArgs'.
        $d3caef8d053fb2a2$var$installAppsWithPriorityOrder(argsWithDefaults);
    },
    installHighPriorityApps: (args)=>{
        const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
            ...$d3caef8d053fb2a2$var$defaultArgs,
            ...args
        };
        $d3caef8d053fb2a2$var$installHighPriorityApps({
            flags: flags,
            navigation: navigation,
            renderNavigation: renderNavigation
        });
    },
    installLowPriorityApps: (args)=>{
        const installArgs = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))({
            ...$d3caef8d053fb2a2$var$defaultArgs,
            ...args
        }, [
            'flags',
            'navigation',
            'renderNavigation'
        ]);
        $d3caef8d053fb2a2$var$installLowPriorityApps(installArgs);
    }
};

});
parcelRegister("2aRps", function(module, exports) {

$parcel$export(module.exports, "renderFlags", () => $6ef677b08ff57190$export$b6228dc14c5adf51);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $6VZoe = parcelRequire("6VZoe");

var $gUUjF = parcelRequire("gUUjF");

var $49235 = parcelRequire("49235");

var $5L0Jp = parcelRequire("5L0Jp");

var $geFaw = parcelRequire("geFaw");
const $6ef677b08ff57190$var$throwError = (message)=>{
    const error = new Error(message);
    (0, $gUUjF.default).safeErrorWithoutCustomerData('flags.entry', message, error);
    throw error;
};
const $6ef677b08ff57190$var$getContainer = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let container = document.getElementById('flags');
    if (container == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        container = document.createElement('div');
        container.id = 'flags';
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.appendChild(container);
        else $6ef677b08ff57190$var$throwError('document.body was not found whilst trying to create the flags container');
    }
    return container;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ef677b08ff57190$var$Flags = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("i5h8p")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ef677b08ff57190$var$AfterPaintFlags = (0, $6VZoe.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("i5h8p")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});
const $6ef677b08ff57190$export$b6228dc14c5adf51 = ()=>(0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: "flags-entry"
    }, __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ef677b08ff57190$var$AfterPaintFlags, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ef677b08ff57190$var$Flags, null)))), $6ef677b08ff57190$var$getContainer());

});
parcelRegister("49235", function(module, exports) {

$parcel$export(module.exports, "JiraContextContainer", () => $237d6228af360b7c$export$6f7845cc5e693f16);

var $eUqFw = parcelRequire("eUqFw");

var $3fQGY = parcelRequire("3fQGY");

var $ao0hp = parcelRequire("ao0hp");

var $fb5Sn = parcelRequire("fb5Sn");

var $eX2O4 = parcelRequire("eX2O4");

var $6rW04 = parcelRequire("6rW04");

var $7LFzI = parcelRequire("7LFzI");

var $jvfW6 = parcelRequire("jvfW6");

var $gXEQH = parcelRequire("gXEQH");

var $8WuJm = parcelRequire("8WuJm");

var $ln3W8 = parcelRequire("ln3W8");

var $jD3pk = parcelRequire("jD3pk");

var $gd0Sp = parcelRequire("gd0Sp");

var $4yYQo = parcelRequire("4yYQo");
const $237d6228af360b7c$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: (0, $gXEQH.routeAnalyticsAttributes)
    }, children);

const $237d6228af360b7c$export$6f7845cc5e693f16 = (props)=>{
    const state = {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        messages: (parcelRequire("7KGHt"))
    };
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($237d6228af360b7c$var$ContextualAnalyticsDataFeatureFlagged, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $6rW04.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7LFzI.IntlProvider), {
            messages: state.messages,
            locale: (0, $ao0hp.standardizeLocale)(tenantContext.locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3fQGY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fb5Sn.default), {
            orgId: orgId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX2O4.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ln3W8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvfW6.ModalContextProvider), null, props.children)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4yYQo.LoadingPhaseManager), null));
};

});
parcelRegister("4yYQo", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $01b326d4a0314926$export$6e4bfef9e80c7eb0);

var $eUqFw = parcelRequire("eUqFw");

var $a5cKA = parcelRequire("a5cKA");
const $01b326d4a0314926$export$6e4bfef9e80c7eb0 = ()=>{
    const { startNextPhase: startNextPhase } = (0, $a5cKA.useLazyPhase)();
    (0, $eUqFw.useEffect)(()=>{
        /**
     * Only start next phase if we are not in the SPA, because there is a second
     * LoadingPhaseManager specifically for the SPA, and we want it to transition at the correct time.
     * If we start this here inside the SPA, we will start RLL next phase and get lazyAfterPaint
     * bundles too early.
     */ if (__SPA__) return;
        /* Outside the SPA, we don't currently have a good proxy for page loads.
     * So for now we start the "after paint" phase a few seconds after mounting.
     */ setTimeout(()=>{
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        }, 2000);
    }, [
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("7KGHt", function(module, exports) {
module.exports = __LANG;

});


parcelRegister("5L0Jp", function(module, exports) {

$parcel$export(module.exports, "FlagsBoundary", () => $3e0b01ebb413784c$export$8b4a0fffcddd96f4);

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");
const $3e0b01ebb413784c$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "flags",
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, children));

});

parcelRegister("i5h8p", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("3WeJg")
]).then(()=>parcelRequire('dKe2f'));

});


parcelRegister("1Fe9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab81d3bccac6ed19$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $geFaw = parcelRequire("geFaw");

var $7BDEW = parcelRequire("7BDEW");
const $ab81d3bccac6ed19$var$getPlaceholder = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const existingPlaceholder = document.getElementById(placeholderId);
    if (existingPlaceholder) return existingPlaceholder;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const div = document.createElement('div');
    div.id = placeholderId;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body.appendChild(div);
    else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
    return div;
};
const $ab81d3bccac6ed19$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
    if (placeholder && sessionId) (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BDEW.default), {
        sessionId: sessionId,
        data: data
    })), $ab81d3bccac6ed19$var$getPlaceholder(placeholder));
};
var $ab81d3bccac6ed19$export$2e2bcd8739ae039 = $ab81d3bccac6ed19$var$renderDwellTimeComponent;

});

parcelRegister("ll5c1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("53zvZ")
]).then(()=>parcelRequire('jqtYH'));

});

parcelRegister("2QHbi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("fF7Ru")
]).then(()=>parcelRequire('9h92o'));

});

parcelRegister("6i2jN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cBElD").then(()=>parcelRequire('bq09U'));

});

parcelRegister("5WlWz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("kWrFZ"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("561Jq"),
    $d1Cng("1QYl5"),
    $d1Cng("hPzOn"),
    $d1Cng("2Lfdl"),
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("8Ny04")
]).then(()=>parcelRequire('gibLG'));

});

parcelRegister("jPTXR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("ihXca")
]).then(()=>parcelRequire('cfAPv'));

});


parcelRegister("jiReJ", function(module, exports) {

$parcel$export(module.exports, "layoutWithCondition", () => $b330a57b19ee3016$export$c5db53e93ba35c0f);
const $b330a57b19ee3016$export$c5db53e93ba35c0f = (conditionGetter, itemTrue, itemFalse)=>({
        get isChromeless () {
            return conditionGetter() ? itemTrue.isChromeless : itemFalse.isChromeless;
        },
        get globalComponents () {
            return conditionGetter() ? itemTrue.globalComponents : itemFalse.globalComponents;
        },
        get rightSidebars () {
            return conditionGetter() ? itemTrue.rightSidebars : itemFalse.rightSidebars;
        }
    });

});

$parcel$global.rwr("bz9bg", () => { parcelRequire("7QpAw");
parcelRequire("2EvGI");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $kFGm5 = parcelRequire("kFGm5");

var $8dloj = parcelRequire("8dloj");

var $gpO36 = parcelRequire("gpO36");

var $ek61b = parcelRequire("ek61b");
var $8dNND = parcelRequire("8dNND");

var $acbV3 = parcelRequire("acbV3");

var $dfiLi = parcelRequire("dfiLi");

var $9lmTX = parcelRequire("9lmTX");

var $zcJ0y = parcelRequire("zcJ0y");

var $e91YZ = parcelRequire("e91YZ");

var $guiFP = parcelRequire("guiFP");


var $gXEQH = parcelRequire("gXEQH");
const $0507482b123635a1$export$649804097de83b3b = [
    // https://jplat.jira.atlassian.cloud/browse/MAGMA-2440
    {
        browser: 'Chrome',
        browserVersion: '116.0.0',
        errorMessage: /Cannot read properties of undefined \(reading 'target'\)/
    }
];
const $0507482b123635a1$var$checkBrowserCondition = (error, filterCriteria)=>filterCriteria.browser != null ? (0, $zcJ0y.getBrowser)().name === filterCriteria.browser : true;
const $0507482b123635a1$var$checkBrowserVersionCondition = (error, filterCriteria)=>filterCriteria.browserVersion != null ? (0, $zcJ0y.getBrowser)().version === filterCriteria.browserVersion : true;
const $0507482b123635a1$var$checkErrorMessageCondition = (error, filterCriteria)=>filterCriteria.errorMessage != null ? error.message.match(filterCriteria.errorMessage) : true;
const $0507482b123635a1$export$a66ce4bea8340820 = (error, errorFilteringCriterias)=>{
    try {
        // condition checkers must return true if they don't apply, so an empty filterCriteria will match (and block) ALL errors
        const conditionCheckers = [
            $0507482b123635a1$var$checkBrowserCondition,
            $0507482b123635a1$var$checkBrowserVersionCondition,
            $0507482b123635a1$var$checkErrorMessageCondition
        ];
        // Should send analytics if no filtering conditions are met
        return !errorFilteringCriterias.some((filterCriteria)=>conditionCheckers.every((conditionChecker)=>conditionChecker(error, filterCriteria)));
    } catch (e) {
        // If any error occurs during filtering, experience analytics should still be sent
        return true;
    }
};
const $0507482b123635a1$export$a5c16644a2d3c205 = async (error)=>{
    const tenantContextData = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    // We probably already have analytics initialised but we could have failed earlier than it
    (0, $dfiLi.default)(tenantContextData);
    // Experience analytics should only be sent if it is not filtered
    if ($0507482b123635a1$export$a66ce4bea8340820(error, $0507482b123635a1$export$649804097de83b3b)) (0, $9lmTX.default)({
        analyticsSource: (0, $7688150c048b38d1$export$c9e16a15d65437),
        experience: (0, $7688150c048b38d1$export$b1534bc11f201efd),
        wasExperienceSuccesful: false,
        location: (0, $7688150c048b38d1$export$7dfef0177e883b05),
        application: (0, $7688150c048b38d1$export$aa6008fe0169b864),
        edition: (0, $7688150c048b38d1$export$39418a21fbb51487),
        additionalAttributes: (0, $gXEQH.routeAnalyticsAttributes)
    });
    (0, $guiFP.default)({
        meta: {
            packageName: 'jiraBootstrapSlaReporter',
            id: 'bootstrap-failure',
            teamName: 'magma'
        },
        error: error,
        attributes: (0, $gXEQH.routeAnalyticsAttributes)
    });
    throw error;
};



var $a5pCl = parcelRequire("a5pCl");
const $d07297a4af13004b$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $d07297a4af13004b$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $d07297a4af13004b$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $d07297a4af13004b$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $d07297a4af13004b$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $d07297a4af13004b$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $d07297a4af13004b$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $d07297a4af13004b$export$6d592df97fba16ca = 'GIN_GLOBAL_ISSUE_NAVIGATOR';
const $d07297a4af13004b$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $d07297a4af13004b$export$4695c1a423ffe431 = 'DASHBOARD';
const $d07297a4af13004b$export$4ce203fc8c0eb2d1 = 'ISSUE_MOVE';
const $d07297a4af13004b$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
const $d07297a4af13004b$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $d07297a4af13004b$export$9a80695e72849f84 = 'X-Atlassian-Capability';



var $gXgRp = parcelRequire("gXgRp");
parcelRequire("80E03");

var $6iz4v = parcelRequire("6iz4v");

var $e91YZ = parcelRequire("e91YZ");

var $8R80x = parcelRequire("8R80x");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");
var $d16Bc = parcelRequire("d16Bc");

var $eI5EY = parcelRequire("eI5EY");

var $6U1dF = parcelRequire("6U1dF");

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");


var $2B87Z = parcelRequire("2B87Z");

var $ibSOG = parcelRequire("ibSOG");

var $eUqFw = parcelRequire("eUqFw");

var $6WwlF = parcelRequire("6WwlF");

var $cEX90 = parcelRequire("cEX90");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $eUqFw = parcelRequire("eUqFw");

var $aYtGv = parcelRequire("aYtGv");
const $2fec3262065a5aa8$export$2fcd4100c556a49e = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `[data-ds--page-layout--slot="main"] { height: calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)}) }`
        }
    });



var $6FP8W = parcelRequire("6FP8W");

var $hwyJ1 = parcelRequire("hwyJ1");

var $inC6u = parcelRequire("inC6u");

var $eUqFw = parcelRequire("eUqFw");

var $5BRby = parcelRequire("5BRby");

var $h97Af = parcelRequire("h97Af");

var $2B87Z = parcelRequire("2B87Z");

var $eUqFw = parcelRequire("eUqFw");

var $fytMA = parcelRequire("fytMA");

var $1n0H8 = parcelRequire("1n0H8");

var $6iz4v = parcelRequire("6iz4v");

var $gUUjF = parcelRequire("gUUjF");

var $0cdA8 = parcelRequire("0cdA8");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2B87Z = parcelRequire("2B87Z");

var $lcJyp = parcelRequire("lcJyp");

var $hTLlD = parcelRequire("hTLlD");

var $exb0h = parcelRequire("exb0h");

var $3oscM = parcelRequire("3oscM");
const $a8644990a56a3865$var$isReplaceActionAndPIN = (action, route)=>action === 'REPLACE' && route.group === (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR);
const $a8644990a56a3865$export$ffb8c03de895ae3 = ()=>{
    let rapidBoardPaths = [];
    return ({ currentMatch: currentMatch, currentRoute: currentRoute, nextMatch: nextMatch, nextRoute: nextRoute, action: action })=>{
        let shouldReset = true;
        if ($a8644990a56a3865$var$isReplaceActionAndPIN(action, nextRoute) || currentRoute.isRedirect === true) shouldReset = false;
        else {
            const cleanMatch = (0, $3oscM.getApdexMatchObject)(currentMatch, currentRoute);
            const cleanNextMatch = (0, $3oscM.getApdexMatchObject)(nextMatch, nextRoute);
            shouldReset = !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(cleanMatch, cleanNextMatch) && shouldReset;
            if (shouldReset) {
                // RapidboardPaths is being persisted here.
                // resetDone boolean is calculated in the util function.
                const [paths, resetBoolean] = (0, $3oscM.calcRapidBoardResetStateV2)(rapidBoardPaths, nextRoute.name, !!nextMatch.query.useStoredSettings);
                rapidBoardPaths = paths;
                if ((0, $3oscM.isValidRoute)(nextRoute) || nextRoute.group === (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE)) shouldReset = !resetBoolean;
            }
        }
        return shouldReset;
    };
};



var $idiDE = parcelRequire("idiDE");

var $lB25E = parcelRequire("lB25E");

var $5XMmM = parcelRequire("5XMmM");
function $5e25b53b6ab9e2aa$export$2e2bcd8739ae039(route) {
    if (route.ufoName != null) return route.ufoName;
    return route.name;
}



var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $41dmJ = parcelRequire("41dmJ");
function $5712ab67e8b6b202$export$2e2bcd8739ae039(fromUfoName, nextUfoName, nextRouteName, time) {
    (0, $41dmJ.default).current = nextUfoName;
    const interactionId = (0, $51JrV.DefaultInteractionID).current;
    if (interactionId) (0, $fYqUr.addRedirect)(interactionId, fromUfoName, nextUfoName, nextRouteName, time);
}



var $eUqFw = parcelRequire("eUqFw");

var $gdW04 = parcelRequire("gdW04");
const $9aa509e99b18f723$export$f2b2f5ef0b498d26 = 5000;
const $9aa509e99b18f723$export$f2c0b74311ada874 = 3;
const $9aa509e99b18f723$export$af2ff676951003fe = 60000;
const $9aa509e99b18f723$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';


const $3afa8d6b9633d6ac$export$50dbcb44bba3aa5c = 60;
const $3afa8d6b9633d6ac$export$b21f5a6e7051e2c2 = (actionMetas)=>{
    const now = Date.now();
    const timeDiff = now - actionMetas.lastPerformAttemptedAt;
    return timeDiff > $3afa8d6b9633d6ac$export$50dbcb44bba3aa5c * 1000;
};
const $3afa8d6b9633d6ac$export$6c7cf2cb7d75fad3 = (actionMetas)=>actionMetas.attemptCounts < (0, $9aa509e99b18f723$export$f2c0b74311ada874);
const $3afa8d6b9633d6ac$export$6e0db227c9674096 = (action, metas)=>{
    const actionMetas = metas[action.id];
    if (!actionMetas) // No meta, we have not attempted to perform this action yet.
    return true;
    if (!$3afa8d6b9633d6ac$export$6c7cf2cb7d75fad3(actionMetas)) // TODO: send a "cancelled analytics event ?"
    return false;
    if (!$3afa8d6b9633d6ac$export$b21f5a6e7051e2c2(actionMetas)) return false;
    // All the conditions are satisfied, we can perform the action.
    return true;
};


const $f14ad3a187e7256b$export$1bfa74483a8ca772 = ({ actionName: actionName })=>{
    const metas = (0, $gdW04.useMeta)();
    const remoteActions = (0, $gdW04.useRemoteActionsData)();
    const { saveActionPerformedAttempt: saveActionPerformedAttempt } = (0, $gdW04.useRemoteActionsStoreActions)();
    const [actionToPerform, setActionToPerform] = (0, $eUqFw.useState)();
    const [shouldPerformAction, setShouldPerformAction] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        // Check whether or not the action (actionName) should be performed:
        // - when the remote actions available list changes
        // - when the metas for the actions change
        const matchedAction = Object.values(remoteActions).find((action)=>{
            if (action.name !== actionName) return false;
            return true;
        });
        if (!matchedAction) return;
        setActionToPerform(matchedAction);
        setShouldPerformAction((0, $3afa8d6b9633d6ac$export$6e0db227c9674096)(matchedAction, metas));
    }, [
        actionName,
        remoteActions,
        metas
    ]);
    const performAction = (onSuccess, onCancel)=>{
        if (!actionToPerform) // just in case someone calls the function and don't check if they should before
        // maybe throw an error?
        return;
        const metaForAnalytics = {
            attempts: metas[actionToPerform.id]?.attemptCounts ?? 0,
            lastAttemptedAt: metas[actionToPerform.id]?.lastPerformAttemptedAt
        };
        if (shouldPerformAction) // For now, the onSuccess will handle:
        // * create analytics event
        // * fire the event
        onSuccess(actionToPerform, metaForAnalytics);
        else // For now, the onCancel will handle:
        // * create analytics event
        // * fire the event
        onCancel(actionToPerform, metaForAnalytics);
        saveActionPerformedAttempt(actionToPerform.id);
        // We just attempted to perfom the action, reset.
        setShouldPerformAction(false);
    };
    return {
        shouldPerformAction: shouldPerformAction,
        performAction: performAction
    };
};



var $4nnPJ = parcelRequire("4nnPJ");

var $hTLlD = parcelRequire("hTLlD");

var $8q0kG = parcelRequire("8q0kG");

var $eI5EY = parcelRequire("eI5EY");
/**
 * Determines the feasibility of transitioning between routes in a SPA, considering initial loads,
 * user agent constraints, and predefined route conditions. Ensures seamless navigation by
 * evaluating route matches and permissions.
 */ const $036a05a78c408a0c$var$transitionValidator = (currentMatch, nextMatch)=>{
    // if we load SPA on a redirect route, we transition immediately skipping the checks
    if (!currentMatch) return true;
    // if next route missing (should not happen as we have a catch all route) or mobile, trigger reload
    if (!nextMatch || // For the infinite redirect loop fix (and future Mobile Web), we want to allow SPA transitions for mobile
    // ie be able to remove the `isMobileUserAgent()` check here
    //  - fg(...) = false: becomes `true` with the negation so the check is dependant on isMobileUserAgent() (ie existing behaviour)
    //  - fg(...) = true: becomes `false` with the negation so it doesn't matter what isMobileUserAgent() returns (can remove after rollout complete)
    (0, $8q0kG.default)() && !(0, $eI5EY.fg)('jira_mobile_web_infinite_redirect_fix_gate')) return false;
    // If we are still on same route and same match params, skip transition checks
    const isSameRoute = currentMatch.route === nextMatch.route;
    const isSameMatch = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(currentMatch.match, nextMatch.match);
    if (isSameRoute && isSameMatch) return true;
    // check we can transition into next route
    // @ts-expect-error - TS2339 - Property 'canTransitionIn' does not exist on type 'Route'.
    const canDoNext = nextMatch.route.canTransitionIn?.(currentMatch, nextMatch) ?? true;
    if (canDoNext) return true;
    return false;
};
var $036a05a78c408a0c$export$2e2bcd8739ae039 = $036a05a78c408a0c$var$transitionValidator;



var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $gUUjF = parcelRequire("gUUjF");

var $1FAd1 = parcelRequire("1FAd1");


var $8R80x = parcelRequire("8R80x");

var $3dxBh = parcelRequire("3dxBh");

var $iJHZm = parcelRequire("iJHZm");
const $ee11b761aa04a6e7$var$LOCATION = 'route-entry-point-container';
const $ee11b761aa04a6e7$export$fb85bbdbfb3e6869 = ()=>null;
const $ee11b761aa04a6e7$export$3e4cdfb894377bc9 = ({ location: location, route: route, match: match, action: action, query: query })=>{
    const entryPoint = (0, $eUqFw.useMemo)(()=>route.entryPoint?.(), [
        route
    ]);
    const entryPointReference = (0, $1FAd1.usePageLayoutEntryPoint)((0, $d619e185f38e9ae8$export$900ddb492c628f48));
    // in order to show a spinner while page loading -> `route.skeleton=Spinner`
    const Skeleton = route.skeleton || $ee11b761aa04a6e7$export$fb85bbdbfb3e6869;
    (0, $eUqFw.useEffect)(()=>{
        if (route.isRedirect) (0, $gUUjF.default).safeWarnWithoutCustomerData($ee11b761aa04a6e7$var$LOCATION, `EntryPoint was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    if (!entryPointReference || !entryPoint) return null;
    let pageId = route.name;
    if (route.pageId) {
        if (typeof route.pageId === 'function') pageId = route.pageId({
            route: route,
            action: action,
            location: location,
            match: match,
            query: query
        });
        else pageId = route.pageId;
    }
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholder), {
        // @ts-expect-error - TS2339 - entryPoint does not exist on the Route type, this will be fixed later
        entryPoint: entryPoint,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Skeleton, null),
        name: "route_entry_point_redirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: {}
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dxBh.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholder), {
        // @ts-expect-error - TS2339 - entryPoint does not exist on the Route type, this will be fixed later
        entryPoint: entryPoint,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Skeleton, null),
        name: "route_entry_point"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }))));
};


const $5ce39a2e342c0202$var$REMOTE_ACTIONS_OFF = 'OFF';
const $5ce39a2e342c0202$var$REMOTE_ACTIONS_PERFORM = 'PERFORM';
const $5ce39a2e342c0202$var$useRouterLocation = (0, $lB25E.createRouterSelector)((state)=>state.location);
const $5ce39a2e342c0202$var$useRouterAction = (0, $lB25E.createRouterSelector)((state)=>state.action);
const $5ce39a2e342c0202$var$useRouterQuery = (0, $lB25E.createRouterSelector)((state)=>state.query);
const $5ce39a2e342c0202$var$useRouterRoute = (0, $lB25E.createRouterSelector)((state)=>state.route);
const $5ce39a2e342c0202$var$useRouterMatch = (0, $lB25E.createRouterSelector)((state)=>state.match);
const $5ce39a2e342c0202$var$useRouterRoutes = (0, $lB25E.createRouterSelector)((state)=>state.routes);
let $5ce39a2e342c0202$var$hasPendingForceReloadAction = false;
const $5ce39a2e342c0202$var$getRemoteActionsRolloutStage = ()=>(0, $eI5EY.fg)('remote_actions_-_killswitch_-_temporary') ? $5ce39a2e342c0202$var$REMOTE_ACTIONS_PERFORM : $5ce39a2e342c0202$var$REMOTE_ACTIONS_OFF;
const $5ce39a2e342c0202$export$88fe66870dd8f843 = (value)=>{
    $5ce39a2e342c0202$var$hasPendingForceReloadAction = value;
};
const $5ce39a2e342c0202$export$39e8f9fc07dd3395 = ()=>$5ce39a2e342c0202$var$hasPendingForceReloadAction;
const $5ce39a2e342c0202$var$fireRemoteActionAnalytics = (analyticsEvent, eventAction, remoteAction, currentRoute, targetRoute, attempts, lastAttemptedAt)=>(0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
        source: 'transitionBlocker',
        actionId: remoteAction != null && remoteAction.id != null ? String(remoteAction.id) : '',
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        frontendVersion: window.BUILD_KEY,
        currentRouteName: currentRoute?.route.name || '',
        targetRouteName: targetRoute?.route.name || '',
        remoteActionsRolloutStage: $5ce39a2e342c0202$var$getRemoteActionsRolloutStage(),
        attempts: attempts,
        lastAttemptedAt: lastAttemptedAt
    });
const $5ce39a2e342c0202$var$updateSentryBreadcrumb = (route, nextRoute)=>{
    const from = route.path + (route.query ? `?${route.query.join('&')}` : '');
    const to = nextRoute?.path + (nextRoute?.query ? `?${nextRoute.query.join('&')}` : '');
    (0, $fytMA.addBreadcrumb)({
        type: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
};
/**
 * Manages the routing, analytics, and remote actions within a single-page application (SPA).
 * This component sets up initial routes, enables analytics tracking, and handles SPA transitions.
 * It incorporates custom logic for page reloading or redirection under certain conditions
 * and ensures safe rendering of route components within an error boundary context.
 */ const $5ce39a2e342c0202$var$Spa = ({ routes: routes, initRoute: initRoute = null })=>{
    (0, $eUqFw.useMemo)(()=>{
        (0, $6iz4v.setMark)('jira-spa/view.start');
    }, []);
    const checkShouldResetPage = (0, $eUqFw.useMemo)(()=>(0, $a8644990a56a3865$export$ffb8c03de895ae3)(), []);
    const currentMatchObjectRef = (0, $eUqFw.useRef)(initRoute);
    (0, $eUqFw.useEffect)(()=>{
        (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
    }, []);
    const { registerBlock: registerBlock } = (0, $lB25E.useRouterActions)();
    const location = $5ce39a2e342c0202$var$useRouterLocation();
    const action = $5ce39a2e342c0202$var$useRouterAction();
    const query = $5ce39a2e342c0202$var$useRouterQuery();
    const route = $5ce39a2e342c0202$var$useRouterRoute();
    const match = $5ce39a2e342c0202$var$useRouterMatch();
    const routerRoutes = $5ce39a2e342c0202$var$useRouterRoutes();
    // If the Lazy Route Map experiment is enabled, we want to use the routes from
    // the router, not from props as they will be changing dynamically during page lifetime
    if ((0, $5XMmM.isLazyRouteMapExperimentEnabled)()) // eslint-disable-next-line no-param-reassign
    routes = routerRoutes;
    const { shouldPerformAction: shouldPerformAction, performAction: performAction } = (0, $f14ad3a187e7256b$export$1bfa74483a8ca772)({
        actionName: 'forceReload'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    /* We update currentMatch only if it's not a redirect. So in canTransitionIn we can compare
	 * actual routes instead of comparing against the redirect one */ if (route.isRedirect !== true) currentMatchObjectRef.current = {
        route: route,
        match: match
    };
    const [, { resetCurrentPage: resetCurrentPage }] = (0, $lcJyp.useSpaStateActions)();
    /* We regiser the blocker on every render to be sure that it gets added as first item
	 * even when the route changes (so it gets called last). It will be added only once anyway.
	 * This is our custom block() API that accepts promises.
	 * This code allows us to disable an SPA transition and trigger a full page reload
	 * in case the route we are moving out (or in) needs it. */ const transitionBlocker = (0, $eUqFw.useCallback)(async (nextLocation, nextAction)=>{
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        const nextMatch = (0, $lB25E.matchRoute)(routes, nextLocation.pathname, nextLocation.search);
        const canDo = (0, $036a05a78c408a0c$export$2e2bcd8739ae039)(currentMatchObjectRef.current, nextMatch);
        if ((0, $5XMmM.isLazyRouteMapExperimentEnabled)()) // Checking how many routes is a proxy for determining whether the lazy routes have been loaded
        // canDo might still be true if this is a transition from an issue to an issue
        {
            if (!canDo && routes.length <= 3) await (0, $gUUjF.default).safeInfoWithoutCustomerData('lazy_routes.transition', 'failure', {
                route: nextMatch?.route.name
            });
        }
        if (!canDo) {
            const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location[windowAction]((0, $1n0H8.createPath)(nextLocation));
        }
        const remoteActionsRolloutStage = $5ce39a2e342c0202$var$getRemoteActionsRolloutStage();
        if (remoteActionsRolloutStage !== $5ce39a2e342c0202$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
            const currentMatch = currentMatchObjectRef.current;
            if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $5ce39a2e342c0202$var$hasPendingForceReloadAction === false) {
                $5ce39a2e342c0202$var$hasPendingForceReloadAction = true;
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $5ce39a2e342c0202$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location[windowAction]((0, $1n0H8.createPath)(nextLocation));
                }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $5ce39a2e342c0202$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                });
            }
        }
        return canDo;
    }, [
        performAction,
        routes,
        shouldPerformAction,
        createAnalyticsEvent
    ]);
    const resetCurrentPageBeforeRouteChangeBlocker = (0, $eUqFw.useCallback)((nextLocation, nextAction)=>{
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        const nextMatchObject = (0, $lB25E.matchRoute)(routes, nextLocation.pathname, nextLocation.search);
        if (nextMatchObject && match && route) {
            const { match: nextMatch, route: nextRoute } = nextMatchObject;
            const shouldReset = checkShouldResetPage({
                nextMatch: nextMatch,
                nextRoute: nextRoute,
                currentMatch: match,
                currentRoute: route,
                action: nextAction
            });
            const nextRouteUfoName = (0, $5e25b53b6ab9e2aa$export$2e2bcd8739ae039)(nextRoute);
            if (shouldReset) {
                resetCurrentPage(nextRouteUfoName, nextRoute.name);
                (0, $4nnPJ.GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
            }
            const isCurrentRouteRedirecting = route.isRedirect === true;
            if (isCurrentRouteRedirecting) {
                const currentRouteName = (0, $5e25b53b6ab9e2aa$export$2e2bcd8739ae039)(route);
                (0, $5712ab67e8b6b202$export$2e2bcd8739ae039)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
            }
        }
        $5ce39a2e342c0202$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
        return true;
    }, [
        checkShouldResetPage,
        match,
        resetCurrentPage,
        route,
        routes
    ]);
    registerBlock(transitionBlocker);
    registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
    if (!(route && match)) return null;
    const { component: RouteComponent, meta: meta } = route;
    const entryPoint = route.entryPoint?.();
    const { reporting: reporting } = meta || {};
    /* Render a <Route> component instead of the page directly so the match prop can be
	 * propagated down to components wrapped with the withRouter HOC. Unfortunately, this
	 * means we forfeit the right to access query params via match is provided by <Route>
	 * rather than our custom matchRoute function. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "route-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        // explicitly coerce undefined to string to make flow happy
        id: `routeApp.${String(route.name)}`,
        packageName: "jiraSpa",
        extraEventData: {
            routeGroup: route.group ?? '',
            isSSR: false
        },
        fallback: "page",
        sendToPrivacyUnsafeSplunk: Boolean(reporting),
        ...reporting
    }, entryPoint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ee11b761aa04a6e7$export$3e4cdfb894377bc9), {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    }) : RouteComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(RouteComponent, {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    })));
};
var $5ce39a2e342c0202$export$2e2bcd8739ae039 = $5ce39a2e342c0202$var$Spa;


const $08a5aa665e71bebd$var$onSpaShellReady = ()=>{
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/spa-shell/core', '_jira-spa/spa-shell.start', 'JIRA_SPA_SHELL_READY');
};
const $08a5aa665e71bebd$var$Spa = ({ initRoute: initRoute = null, routes: routes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: "JIRA_SPA_SHELL_READY",
        onSet: $08a5aa665e71bebd$var$onSpaShellReady
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ce39a2e342c0202$export$2e2bcd8739ae039), {
        initRoute: initRoute,
        routes: routes
    }));
var $08a5aa665e71bebd$export$2e2bcd8739ae039 = $08a5aa665e71bebd$var$Spa;



var $ghXjN = parcelRequire("ghXjN");
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $95616b66187196af$export$712225703044cda = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1bgi _2d3f16n6 _iu1g1fl4",
            __cmplp.className
        ])
    });
});


/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $b1974ec03c2a5bd2$var$SPA_TRACE_KEY = 'spa';
const $b1974ec03c2a5bd2$var$NewContent = (props)=>{
    const { isInset: isInset, hasTheming: hasTheming } = (0, $6WwlF.useBusinessLookAndFeel)();
    const renderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "mainContentSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.MainContentSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        traceKey: $b1974ec03c2a5bd2$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $08a5aa665e71bebd$export$2e2bcd8739ae039), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        traceKey: $b1974ec03c2a5bd2$var$SPA_TRACE_KEY,
        type: "end"
    }));
    if (hasTheming) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEX90.ThemedContentLayout), {
        appearance: isInset ? 'inset' : 'default'
    }, renderContent);
    return renderContent;
};
const $b1974ec03c2a5bd2$var$OldContent = (props)=>{
    const { isInset: isInset, hasProjectViewNavigation: hasProjectViewNavigation } = (0, $6WwlF.useBusinessLookAndFeel)();
    const renderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2fec3262065a5aa8$export$2fcd4100c556a49e), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "mainContentSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.MainContentSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.Main), {
        id: "ak-main-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        traceKey: $b1974ec03c2a5bd2$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $08a5aa665e71bebd$export$2e2bcd8739ae039), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        traceKey: $b1974ec03c2a5bd2$var$SPA_TRACE_KEY,
        type: "end"
    })));
    if (hasProjectViewNavigation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEX90.BusinessWrapper), {
        withWhiteBackground: isInset
    }, renderContent);
    return (0, $1ybV0.ff)('iph.enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $95616b66187196af$export$712225703044cda), null, renderContent) : renderContent;
};
const $b1974ec03c2a5bd2$export$7c6e2c02157bb7d2 = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $b1974ec03c2a5bd2$var$NewContent, $b1974ec03c2a5bd2$var$OldContent);


const $37f6df81ea368cad$export$6d4069f4b64f7492 = ({ baseUrl: baseUrl, locale: locale, messages: messages, isPrewarming: isPrewarming = false, Router: Router, routes: routes, routerLinkComponent: routerLinkComponent, initRoute: initRoute })=>{
    const pageContainerPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$21473105c510aacc), (0, $7688150c048b38d1$export$59f83d43fe209319), (0, $7688150c048b38d1$export$7114284ca03133ee), true, true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ibSOG.PageContainer), {
        baseUrl: baseUrl,
        id: false ? 'jira.entry.ssr' : 'spa',
        locale: locale,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$7114284ca03133ee),
        onSet: pageContainerPerformanceTiming
    }), isPrewarming !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1974ec03c2a5bd2$export$7c6e2c02157bb7d2), {
        initRoute: initRoute,
        routes: routes
    }));
};



var $10fdS = parcelRequire("10fdS");

var $keguF = parcelRequire("keguF");

var $geFaw = parcelRequire("geFaw");

var $gTSbo = parcelRequire("gTSbo");

var $9DIQe = parcelRequire("9DIQe");

var $dfBCt = parcelRequire("dfBCt");

var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $f0262204957799b7$export$12b9979f5c1ed5a4 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME),
    path: '/jira/settings/system/migration/home'
};
const $f0262204957799b7$export$b48d38ab4363f197 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD),
    path: '/jira/settings/system/migration/dashboard'
};
const $f0262204957799b7$export$50ae42a441766ba5 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE),
    path: '/jira/settings/system/migration/:step(how-it-works|plan-configuration|choose-projects|choose-group-membership|select-customer|check-for-errors|review|view-details)/:migrationId?'
};



var $dgH3j = parcelRequire("dgH3j");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $2B87Z = parcelRequire("2B87Z");
const $ded70d904ebbb134$export$ff83c57004505abd = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        (0, $2B87Z.setProductBundleReadyForInitialRender)();
    });
    return importedBundle;
};



var $59o4i = parcelRequire("59o4i");

const $6852d43bda4b6a44$export$422086745f2d10c4 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("7nM1S"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/migrations/migrations-dashboard/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6852d43bda4b6a44$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6852d43bda4b6a44$export$422086745f2d10c4,
        pageId: "system-c2c-migrations-dashboard",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $f2e7b5aca30ed911$export$e0c09a0ffb780ae2 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("go9vj"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/migrations/migrations-focus-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f2e7b5aca30ed911$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f2e7b5aca30ed911$export$e0c09a0ffb780ae2,
        pageId: "system-c2c-migrations-focus-page",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $e8ff9e4cef16c1d5$export$b78d99112db11162 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("1toPN"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/migrations/migrations-home/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8ff9e4cef16c1d5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e8ff9e4cef16c1d5$export$b78d99112db11162,
        pageId: "system-migrations-home",
        shouldShowSpinner: true
    });


const $799769b2797678db$export$debd9f352e8a3e70 = [
    (0, $bMm60.createEntry)((0, $f0262204957799b7$export$12b9979f5c1ed5a4), {
        ufoName: 'admin.c2c-migrations.home',
        canTransitionIn: ()=>(0, $1ybV0.ff)('jira-system-settings-cloud-to-cloud-migration'),
        component: (0, $9zysr.componentWithCondition)((0, $dfBCt.isFedRamp), (0, $dgH3j.default), (0, $e8ff9e4cef16c1d5$export$2e2bcd8739ae039)),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $e8ff9e4cef16c1d5$export$b78d99112db11162)
        ]
    }),
    (0, $bMm60.createEntry)((0, $f0262204957799b7$export$b48d38ab4363f197), {
        ufoName: 'admin.c2c-migrations.dashboard',
        canTransitionIn: ()=>(0, $1ybV0.ff)('jira-system-settings-cloud-to-cloud-migration'),
        component: (0, $9zysr.componentWithCondition)((0, $dfBCt.isFedRamp), (0, $dgH3j.default), (0, $6852d43bda4b6a44$export$2e2bcd8739ae039)),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6852d43bda4b6a44$export$422086745f2d10c4)
        ]
    }),
    (0, $bMm60.createEntry)((0, $f0262204957799b7$export$50ae42a441766ba5), {
        canTransitionIn: ()=>(0, $1ybV0.ff)('jira-system-settings-cloud-to-cloud-migration'),
        component: (0, $9zysr.componentWithCondition)((0, $dfBCt.isFedRamp), (0, $dgH3j.default), (0, $f2e7b5aca30ed911$export$2e2bcd8739ae039)),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f2e7b5aca30ed911$export$e0c09a0ffb780ae2)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $cernH = parcelRequire("cernH");


var $gXgRp = parcelRequire("gXgRp");

var $eI5EY = parcelRequire("eI5EY");

var $dVvIP = parcelRequire("dVvIP");

var $kLSws = parcelRequire("kLSws");

var $7vTKl = parcelRequire("7vTKl");

var $29Nmz = parcelRequire("29Nmz");

var $6VZoe = parcelRequire("6VZoe");

var $isbb2 = parcelRequire("isbb2");

const $81a924b88389d294$export$b6292b5f7e5b5fad = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("6ddy1")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx"
});
const $81a924b88389d294$export$94e1d79bf65579e2 = (0, $isbb2.createLayout)({
    globalComponents: [
        $81a924b88389d294$export$b6292b5f7e5b5fad
    ]
});



var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $drCAA = parcelRequire("drCAA");

var $2nflD = parcelRequire("2nflD");

var $hHrVM = parcelRequire("hHrVM");

var $692Sf = parcelRequire("692Sf");

var $atRHQ = parcelRequire("atRHQ");

var $7u7sK = parcelRequire("7u7sK");

var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $foc4i = parcelRequire("foc4i");

var $drCAA = parcelRequire("drCAA");

var $atRHQ = parcelRequire("atRHQ");

var $kY36r = parcelRequire("kY36r");

var $lB25E = parcelRequire("lB25E");
const $b1a6b20b73816189$var$PERSIST_SEARCH_PARAMS = [
    'search'
];
const $b1a6b20b73816189$var$RedirectLegacyPlanPageWithoutScenarioId = ()=>{
    const [{ query: query }] = (0, $lB25E.useRouter)();
    const { data: data, loading: loading } = (0, $lB25E.useResource)((0, $drCAA.advancedRoadmapsScenarioIdResource));
    if (loading || data === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: `/jira/plans/${query.id}/scenarios/${data.scenarioId}`,
        persistSearchParams: $b1a6b20b73816189$var$PERSIST_SEARCH_PARAMS
    });
};
const $b1a6b20b73816189$export$c3e4fda2290a52bf = ()=>{
    const [{ query: query }] = (0, $lB25E.useRouter)();
    const { id: id, sid: sid } = query;
    if (Number.isNaN(Number.parseFloat(sid))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1a6b20b73816189$var$RedirectLegacyPlanPageWithoutScenarioId, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: `/jira/plans/${id}/scenarios/${sid}`,
        persistSearchParams: $b1a6b20b73816189$var$PERSIST_SEARCH_PARAMS
    });
};
const $b1a6b20b73816189$export$ff420400c9900835 = ()=>{
    const [{ match: match }] = (0, $lB25E.useRouter)();
    const { planId: planId } = match.params;
    if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
    const { data: data, loading: loading } = (0, $lB25E.useResource)((0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource));
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kY36r.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
        persistSearchParams: $b1a6b20b73816189$var$PERSIST_SEARCH_PARAMS
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $atRHQ = parcelRequire("atRHQ");

var $lB25E = parcelRequire("lB25E");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$23beffab57eac402$export$2e2bcd8739ae039 = ()=>{
    const [{ query: query }] = (0, $lB25E.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: `/jira/plans/reports/${query.r}`,
        persistSearchParams: false
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $gXgRp = parcelRequire("gXgRp");

var $gC7XG = parcelRequire("gC7XG");

const $bf010c1b73a0efa7$export$56ea489e9d4bfa04 = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $d619e185f38e9ae8$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    }
                }
            }),
        toString: ()=>'ChromelessEntryPoint'
    });
const $bf010c1b73a0efa7$export$955a7619d2679b4c = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $d619e185f38e9ae8$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    },
                    [(0, $d619e185f38e9ae8$export$bec6dca2e63de4ae)]: {
                        entryPoint: (0, $gC7XG.topNavigationEntryPoint),
                        entryPointParams: {
                            menuId: page.topNavigationMenuId
                        }
                    },
                    ...page.horizontalNavigation ? {
                        [(0, $d619e185f38e9ae8$export$948d4d345566aed3)]: {
                            entryPoint: page.horizontalNavigation,
                            entryPointParams: {}
                        }
                    } : undefined,
                    ...page.rightSidebar ? {
                        [(0, $d619e185f38e9ae8$export$7bf43119a6b49ddb)]: {
                            entryPoint: page.rightSidebar,
                            entryPointParams: entryPointParams
                        }
                    } : undefined
                }
            }),
        toString: ()=>'PageEntryPoint'
    });



var $dnJL9 = parcelRequire("dnJL9");

var $eI5EY = parcelRequire("eI5EY");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $drCAA = parcelRequire("drCAA");

var $3MEW8 = parcelRequire("3MEW8");

var $exb0h = parcelRequire("exb0h");
const $822bacaa2afb3f4c$export$a60c43befc130169 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE_EMBED),
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline/embed'
};
const $822bacaa2afb3f4c$export$df82cc5024b7f316 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED),
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar/embed'
};
const $822bacaa2afb3f4c$export$2cee7cd37198b3fd = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY_EMBED),
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary/embed'
};
const $822bacaa2afb3f4c$export$a6b708cae2ed7f0c = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT_EMBED),
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId/embed'
};



var $dgH3j = parcelRequire("dgH3j");

var $7u7sK = parcelRequire("7u7sK");

var $eI5EY = parcelRequire("eI5EY");
/**
 * @generated SignedSource<<0f8dae1172251c99cec449062e0f0a81>>
 * @relayHash ca502405166110fab14d9c351fe3f6c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e277e4ddd2d16f6811b965abfa89ee6c4bc3c061c39fa920c3929718028291a9
const $ae4d1c21cb10f5ab$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e277e4ddd2d16f6811b965abfa89ee6c4bc3c061c39fa920c3929718028291a9",
        "metadata": {},
        "name": "ui_jiraCalendarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ae4d1c21cb10f5ab$export$2e2bcd8739ae039 = $ae4d1c21cb10f5ab$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");
function $3cdffbe977956bc3$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
    return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}
function $3cdffbe977956bc3$var$getStorageKeyFromScope(context) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/plan/${planId}/scenario/${scenarioId}`;
}
function $3cdffbe977956bc3$var$getStorageValueFromScope(key) {
    const storedData = globalThis.localStorage?.getItem(key) || '';
    return storedData;
}
function $3cdffbe977956bc3$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $3cdffbe977956bc3$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $3cdffbe977956bc3$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const { cloudId: cloudId, activationId: activationId } = tenantContext;
    const planScenarioAri = $3cdffbe977956bc3$var$toPlanScenarioAri({
        siteId: cloudId,
        activationId: activationId,
        planId: String(planId),
        scenarioId: String(scenarioId)
    });
    return {
        type: 'plan',
        ids: [
            planScenarioAri
        ]
    };
}
function $3cdffbe977956bc3$var$buildScopeInput(scope) {
    return {
        ids: scope.ids
    };
}
function $3cdffbe977956bc3$var$buildViewId(scope) {
    // plan scenario ARI is the view id
    return scope.ids?.[0] ?? '';
}
function $3cdffbe977956bc3$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $3cdffbe977956bc3$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $3cdffbe977956bc3$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, viewId: viewId }) {
    return {
        date: $3cdffbe977956bc3$var$toMidnightUTCString(selectedDate),
        mode: $3cdffbe977956bc3$var$toViewMode(viewRange),
        weekStart: $3cdffbe977956bc3$var$toWeekStart(weekStartsOn),
        viewId: viewId
    };
}
function $3cdffbe977956bc3$var$buildIssuesSearchInput(storageKey) {
    return {
        additionalFilterQuery: $3cdffbe977956bc3$var$getStorageValueFromScope(storageKey)
    };
}
function $3cdffbe977956bc3$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $3cdffbe977956bc3$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $3cdffbe977956bc3$var$buildCalendarCrossProjectVersionsInput() {
    return {
        statuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $3cdffbe977956bc3$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}

const $3cdffbe977956bc3$export$19cf4b398f638dc6 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("kSiCv")), {
        moduleId: "53aec496"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $3cdffbe977956bc3$var$createScope(entryPointRouteParams);
        const scopeInput = $3cdffbe977956bc3$var$buildScopeInput(scope);
        const { date: date } = context.query;
        const selectedDate = $3cdffbe977956bc3$var$toDate(date);
        const viewRange = 'month';
        const weekStartsOn = 'monday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const storageKey = $3cdffbe977956bc3$var$getStorageKeyFromScope(context);
        const viewId = $3cdffbe977956bc3$var$buildViewId(scope);
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $ae4d1c21cb10f5ab$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: scopeInput,
                        configurationInput: $3cdffbe977956bc3$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            viewId: viewId
                        }),
                        issuesSearchInput: $3cdffbe977956bc3$var$buildIssuesSearchInput(storageKey),
                        unscheduledIssuesSearchInput: $3cdffbe977956bc3$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $3cdffbe977956bc3$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $3cdffbe977956bc3$var$buildSprintsSearchInput(),
                        crossProjectVersionsSearchInput: $3cdffbe977956bc3$var$buildCalendarCrossProjectVersionsInput(),
                        viewId: viewId,
                        skipSprintSearch: !(0, $eI5EY.fg)('plan_calendar_enable_sprint_events'),
                        skipVersionSearch: false,
                        skipPanelIssueSearch: true,
                        skipCrossProjectVersionSearch: false,
                        schedulePermissionsEnabled: (0, $eI5EY.fg)('calendar_schedule_issue_permissions_check')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                storageKey: storageKey
            }
        };
    }
});




var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8ef7bc2d3c7f29f5$var$LazyPlanCalendarEmbed = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("5pnex"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-calendar/index.tsx"
});
const $8ef7bc2d3c7f29f5$var$PlanCalendarEmbedPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8ef7bc2d3c7f29f5$var$LazyPlanCalendarEmbed,
        pageId: "plan-calendar-embed",
        shouldShowSpinner: true
    });
const $8ef7bc2d3c7f29f5$var$planCalendarEmbedRouteEntry = (0, $bf010c1b73a0efa7$export$56ea489e9d4bfa04)({
    main: (0, $3cdffbe977956bc3$export$19cf4b398f638dc6)
});
const $8ef7bc2d3c7f29f5$export$309ed92381819b04 = (0, $bMm60.createEntry)((0, $822bacaa2afb3f4c$export$df82cc5024b7f316), {
    ufoName: 'software-advanced-roadmaps-calendar-embed',
    component: (0, $dnJL9.componentWithFG)('smart_links_for_plans', $8ef7bc2d3c7f29f5$var$PlanCalendarEmbedPage, (0, $dgH3j.default)),
    skeleton: ()=>{
        if ((0, $eI5EY.fg)('smart_links_for_plans')) return (0, $eI5EY.fg)('platform_calendar_adoption_in_plans') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u7sK.CalendarSkeleton), null) : undefined;
        return undefined;
    },
    entryPoint () {
        (0, $gXgRp.setCapability)((0, $d07297a4af13004b$export$f999749ac7a2cd1));
        if ((0, $eI5EY.fg)('smart_links_for_plans')) return (0, $eI5EY.fg)('platform_calendar_adoption_in_plans') ? $8ef7bc2d3c7f29f5$var$planCalendarEmbedRouteEntry : undefined;
        return undefined;
    },
    layout: (0, $isbb2.createLayout)({
        isChromeless: true
    }),
    resources: [
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
        (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
        (0, $3MEW8.themePreferenceResource)
    ],
    preloadOptions: {
        earlyChunks: [
            'advanced-roadmaps-early-entry'
        ]
    },
    meta: {
        capability: (0, $d07297a4af13004b$export$f999749ac7a2cd1)
    },
    forPaint: [
        $8ef7bc2d3c7f29f5$var$LazyPlanCalendarEmbed
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $dnJL9 = parcelRequire("dnJL9");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $drCAA = parcelRequire("drCAA");


var $dgH3j = parcelRequire("dgH3j");


var $59o4i = parcelRequire("59o4i");

const $b63430e2ebb7017f$export$51f2083dff1ee684 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("6iNQz"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index.tsx"
});
const $b63430e2ebb7017f$export$a2ae011b90c17927 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b63430e2ebb7017f$export$51f2083dff1ee684,
        pageId: "plan-increment-embed",
        shouldShowSpinner: true
    });
const $b63430e2ebb7017f$export$3feed0b4da010c52 = (0, $bMm60.createEntry)((0, $822bacaa2afb3f4c$export$a6b708cae2ed7f0c), {
    component: (0, $dnJL9.componentWithFG)('smart_links_for_plans', $b63430e2ebb7017f$export$a2ae011b90c17927, (0, $dgH3j.default)),
    layout: (0, $isbb2.createLayout)({
        isChromeless: true
    }),
    resources: [
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
        (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
    ],
    preloadOptions: {
        earlyChunks: [
            'advanced-roadmaps-early-entry'
        ]
    },
    forPaint: [
        $b63430e2ebb7017f$export$51f2083dff1ee684
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $dnJL9 = parcelRequire("dnJL9");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $drCAA = parcelRequire("drCAA");
parcelRequire("gkTS0");
var $2nflD = parcelRequire("2nflD");


var $dgH3j = parcelRequire("dgH3j");


var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4a8bb438da8b03a5$var$LazyPlanSummaryEmbed = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("97FCh"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
});
const $4a8bb438da8b03a5$var$PlanSummaryEmbedPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4a8bb438da8b03a5$var$LazyPlanSummaryEmbed,
        pageId: "plan-summary-embed",
        shouldShowSpinner: true
    });
const $4a8bb438da8b03a5$export$bdc2c75e02c29d7 = (0, $bMm60.createEntry)((0, $822bacaa2afb3f4c$export$2cee7cd37198b3fd), {
    component: (0, $dnJL9.componentWithFG)('smart_links_for_plans', $4a8bb438da8b03a5$var$PlanSummaryEmbedPage, (0, $dgH3j.default)),
    layout: (0, $isbb2.createLayout)({
        isChromeless: true
    }),
    resources: [
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
        (0, $2nflD.advancedRoadmapsSummaryDataResource)
    ],
    preloadOptions: {
        earlyChunks: [
            'advanced-roadmaps-early-entry'
        ]
    },
    forPaint: [
        $4a8bb438da8b03a5$var$LazyPlanSummaryEmbed
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $dnJL9 = parcelRequire("dnJL9");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $drCAA = parcelRequire("drCAA");


var $dgH3j = parcelRequire("dgH3j");


var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b95e00962496e38c$var$LazyPlanTimelineEmbed = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("aP9kF"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index.tsx"
});
const $b95e00962496e38c$var$PlanTimelineEmbedPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b95e00962496e38c$var$LazyPlanTimelineEmbed,
        pageId: "plan-timeline-embed",
        shouldShowSpinner: true
    });
const $b95e00962496e38c$export$a977d398db1904ff = (0, $bMm60.createEntry)((0, $822bacaa2afb3f4c$export$a60c43befc130169), {
    component: (0, $dnJL9.componentWithFG)('smart_links_for_plans', $b95e00962496e38c$var$PlanTimelineEmbedPage, (0, $dgH3j.default)),
    layout: (0, $isbb2.createLayout)({
        isChromeless: true
    }),
    resources: [
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
        (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
    ],
    preloadOptions: {
        earlyChunks: [
            'advanced-roadmaps-early-entry'
        ]
    },
    forPaint: [
        $b95e00962496e38c$var$LazyPlanTimelineEmbed
    ]
});


const $2eff0790babe0236$export$8535fa0728567020 = [
    (0, $8ef7bc2d3c7f29f5$export$309ed92381819b04),
    (0, $b63430e2ebb7017f$export$3feed0b4da010c52),
    (0, $4a8bb438da8b03a5$export$bdc2c75e02c29d7),
    (0, $b95e00962496e38c$export$a977d398db1904ff)
];



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $2hHs5 = parcelRequire("2hHs5");

var $hHrVM = parcelRequire("hHrVM");

var $5FB31 = parcelRequire("5FB31");


var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $atRHQ = parcelRequire("atRHQ");
const $5f079d10cc40bf07$export$9090339aecaa99f2 = (CurrentComponent, redirectUrl, redirectCondition)=>()=>{
        if (redirectCondition()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: redirectUrl
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CurrentComponent, null);
    };
const $5f079d10cc40bf07$export$2d47ce6f15e624e5 = (redirectUrl)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: redirectUrl
        });



const $757441de7a03322f$export$4fcc3c0f6e792efc = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("7vMNl"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/dependencies/index.tsx"
});
const $757441de7a03322f$export$d6f045c7c1aaff50 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $757441de7a03322f$export$4fcc3c0f6e792efc,
        pageId: "arj-settings-dependencies",
        shouldShowSpinner: true
    });
const $757441de7a03322f$export$70386609aff5ba12 = (0, $bMm60.createEntry)((0, $5FB31.softwareArjSettingsDependenciesRoute), {
    component: $757441de7a03322f$export$d6f045c7c1aaff50,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $2hHs5.issueLinkInformationResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $757441de7a03322f$export$4fcc3c0f6e792efc
    ]
});
const $757441de7a03322f$export$804f2d81dfbdd5c9 = (0, $bMm60.createEntry)((0, $5FB31.softwareArjSettingsDependenciesRedirectRoute), {
    component: (0, $5f079d10cc40bf07$export$2d47ce6f15e624e5)('/jira/plans/settings/dependencies'),
    isRedirect: true,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $2hHs5.issueLinkInformationResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $757441de7a03322f$export$4fcc3c0f6e792efc
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $gubiX = parcelRequire("gubiX");

var $hHrVM = parcelRequire("hHrVM");

var $5FB31 = parcelRequire("5FB31");


var $59o4i = parcelRequire("59o4i");


const $bac19dc5faaa37c5$export$64761ea1912fdcd9 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("lS6Rl"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/loading-limits/index.tsx"
});
const $bac19dc5faaa37c5$export$7bb4c0f22b467385 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $bac19dc5faaa37c5$export$64761ea1912fdcd9,
        pageId: "arj-settings-loading-limits",
        shouldShowSpinner: true
    });
const $bac19dc5faaa37c5$export$6786257309f86d8c = (0, $bMm60.createEntry)((0, $5FB31.softwareArjSettingsLoadingLimitsRoute), {
    component: $bac19dc5faaa37c5$export$7bb4c0f22b467385,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $gubiX.arjSettingsLoadingLimitsResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $bac19dc5faaa37c5$export$64761ea1912fdcd9
    ]
});
const $bac19dc5faaa37c5$export$9f80102c0f64ad9b = (0, $bMm60.createEntry)((0, $5FB31.softwareArjSettingsLoadingLimitsRedirectRoute), {
    component: (0, $5f079d10cc40bf07$export$2d47ce6f15e624e5)('/jira/plans/settings/loading-limits'),
    isRedirect: true,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $bac19dc5faaa37c5$export$64761ea1912fdcd9
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $bFKDs = parcelRequire("bFKDs");

var $hHrVM = parcelRequire("hHrVM");

var $5FB31 = parcelRequire("5FB31");


var $59o4i = parcelRequire("59o4i");


const $8fbf7c2c548ced9d$export$edb4ae7e85c7908d = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("c8iZb"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/permissions/index.tsx"
});
const $8fbf7c2c548ced9d$export$fa852ea42b98d3de = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8fbf7c2c548ced9d$export$edb4ae7e85c7908d,
        pageId: "arj-settings-permissions",
        shouldShowSpinner: true
    });
const $8fbf7c2c548ced9d$export$4e97658a5cc15eaa = (0, $bMm60.createEntry)((0, $5FB31.softwareArjSettingsPermissionsRoute), {
    component: $8fbf7c2c548ced9d$export$fa852ea42b98d3de,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $bFKDs.getGlobalPermissionPageResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $8fbf7c2c548ced9d$export$edb4ae7e85c7908d
    ]
});
const $8fbf7c2c548ced9d$export$949c8177281fcc39 = (0, $bMm60.createEntry)((0, $5FB31.softwareArjSettingsPermissionsRedirectRoute), {
    component: (0, $5f079d10cc40bf07$export$2d47ce6f15e624e5)('/jira/plans/settings/permissions'),
    isRedirect: true,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $bFKDs.getGlobalPermissionPageResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $8fbf7c2c548ced9d$export$edb4ae7e85c7908d
    ]
});


const $4b93a6a883195715$export$87af7d91a16be1cf = [
    (0, $757441de7a03322f$export$70386609aff5ba12),
    (0, $757441de7a03322f$export$804f2d81dfbdd5c9),
    (0, $bac19dc5faaa37c5$export$6786257309f86d8c),
    (0, $bac19dc5faaa37c5$export$9f80102c0f64ad9b),
    (0, $8fbf7c2c548ced9d$export$4e97658a5cc15eaa),
    (0, $8fbf7c2c548ced9d$export$949c8177281fcc39)
];



var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $efFTI = parcelRequire("efFTI");

var $kLSws = parcelRequire("kLSws");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $29Nmz = parcelRequire("29Nmz");


var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $drCAA = parcelRequire("drCAA");

var $1IXLY = parcelRequire("1IXLY");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $78UVv = parcelRequire("78UVv");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $24b1fd4bb94b112f$export$cf676f47aba10db8 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("a0t0M")).then((module)=>module.ArchivedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages/archived-plans/src/index.tsx"
});
const $24b1fd4bb94b112f$export$ed59bbc59461c00f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $24b1fd4bb94b112f$export$cf676f47aba10db8,
        pageId: "archived-plans",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $3999e44dd6fe3f68$export$e7b9f83d442bac51 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("6iNQz"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index.tsx"
});
const $3999e44dd6fe3f68$export$5e1035d0876d64db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3999e44dd6fe3f68$export$e7b9f83d442bac51,
        pageId: "plan-increment",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $7388e9bc82df2f72$export$9da4d4d5c4d7f749 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("gBtEq"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-program/index.tsx"
});
const $7388e9bc82df2f72$export$fb30c2b19a4f5d59 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7388e9bc82df2f72$export$9da4d4d5c4d7f749,
        pageId: "plan-program",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $bd3c4867adaafb7f$export$6ac18b311b7e51a1 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("gZ4gO")).then((module)=>module.TrashedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages/trashed-plans/src/index.tsx"
});
const $bd3c4867adaafb7f$export$b145fa65818ff157 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $bd3c4867adaafb7f$export$6ac18b311b7e51a1,
        pageId: "trashed-plans",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $de7246821d535f93$export$dd67c2f01a58231e = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("aROFY")).then((module)=>module.ArjSettingsFinancialYear)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/financial-year/index.tsx"
});
const $de7246821d535f93$export$785180185eba7ed9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $de7246821d535f93$export$dd67c2f01a58231e,
        pageId: "arj-settings-financial-year",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $0fec3bea6f800248$export$20a71ac28e6a3c8f = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("jjQof"))), {
    moduleId: "./src/packages/portfolio-3/plan-trashed-direct-link/src/index.tsx"
});
const $0fec3bea6f800248$export$38f3a061bb1fceee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0fec3bea6f800248$export$20a71ac28e6a3c8f,
        pageId: "trashed-plan-direct-link",
        shouldShowSpinner: false
    });


const $4aaa9ca7f7e53447$export$f7abc47036ff7dd9 = (0, $bMm60.createEntry)({
    ...(0, $78UVv.planIncrementsRoute),
    exact: true
}, {
    component: (0, $7388e9bc82df2f72$export$fb30c2b19a4f5d59),
    layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS,
        sidebar: (0, $29Nmz.default),
        horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
        onlyShowHorziontalOnNav4: true
    },
    preloadOptions: {
        earlyChunks: [
            'advanced-roadmaps-early-entry'
        ]
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
        (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
        (0, $drCAA.advancedRoadmapsLastVisitedProgramBoardIdResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7388e9bc82df2f72$export$9da4d4d5c4d7f749)
    ]
});
const $4aaa9ca7f7e53447$export$a26fa5cabff8bc7c = (0, $bMm60.createEntry)({
    ...(0, $78UVv.planIncrementRoute),
    exact: true
}, {
    component: (0, $3999e44dd6fe3f68$export$5e1035d0876d64db),
    layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS,
        sidebar: (0, $29Nmz.default),
        horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
        onlyShowHorziontalOnNav4: true
    },
    preloadOptions: {
        earlyChunks: [
            'advanced-roadmaps-early-entry'
        ]
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
        (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $3999e44dd6fe3f68$export$e7b9f83d442bac51)
    ]
});
const $4aaa9ca7f7e53447$export$b9921058a8a65710 = (0, $bMm60.createEntry)({
    ...(0, $78UVv.archivedPlansRoute),
    exact: true
}, {
    component: (0, $24b1fd4bb94b112f$export$ed59bbc59461c00f),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $24b1fd4bb94b112f$export$cf676f47aba10db8)
    ]
});
const $4aaa9ca7f7e53447$export$eabcbe4dd6fc9f1f = (0, $bMm60.createEntry)({
    ...(0, $78UVv.trashedPlansRoute),
    exact: true
}, {
    component: (0, $bd3c4867adaafb7f$export$b145fa65818ff157),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $bd3c4867adaafb7f$export$6ac18b311b7e51a1)
    ]
});
const $4aaa9ca7f7e53447$export$dbcd0bd16f12397d = (0, $bMm60.createEntry)((0, $78UVv.trashedPlanDirectLinkRoute), {
    component: (0, $0fec3bea6f800248$export$38f3a061bb1fceee),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $0fec3bea6f800248$export$20a71ac28e6a3c8f)
    ],
    ufoName: 'plan-trashed'
});
const $4aaa9ca7f7e53447$export$3907721420f39680 = (0, $bMm60.createEntry)({
    ...(0, $78UVv.arjSettingsFinancialYearPageRoute),
    exact: true
}, {
    component: (0, $de7246821d535f93$export$785180185eba7ed9),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        (0, $1IXLY.arjSettingsFinancialYearResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $de7246821d535f93$export$dd67c2f01a58231e)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $7vTKl = parcelRequire("7vTKl");



var $59o4i = parcelRequire("59o4i");

const $52e36f27e7c3f239$export$3b1de511e34cdb8f = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("5pnex"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-calendar/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$52e36f27e7c3f239$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $52e36f27e7c3f239$export$3b1de511e34cdb8f,
        pageId: "plan-calendar",
        shouldShowSpinner: true
    });
const $52e36f27e7c3f239$export$21806ebf23f23060 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $3cdffbe977956bc3$export$19cf4b398f638dc6),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PLANS
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $183ee29229724a27$export$d4669c7a2f17c261 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("4uOqv"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$183ee29229724a27$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $183ee29229724a27$export$d4669c7a2f17c261,
        pageId: "plan-dependencies-report",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $def3284302c0ab74$export$749f5d2513e04ec0 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("9fQ4G"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-releases/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$def3284302c0ab74$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $def3284302c0ab74$export$749f5d2513e04ec0,
        pageId: "plan-releases",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

/**
 * Report page
 */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b1aff7950ef934d8$var$LazyPlanReport = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("bwADu"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-report/index.tsx"
});
const $b1aff7950ef934d8$var$PlanReport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b1aff7950ef934d8$var$LazyPlanReport,
        pageId: "plan-report",
        shouldShowSpinner: true
    });
var $b1aff7950ef934d8$export$2e2bcd8739ae039 = $b1aff7950ef934d8$var$PlanReport;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $937e8f491e6cccea$export$81591fb347c2e0ac = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("7oMPg"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$937e8f491e6cccea$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $937e8f491e6cccea$export$81591fb347c2e0ac,
        pageId: "advanced-roadmaps-plan",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $cf2d4b7160b080e2$export$8bcf7155849993f5 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("4SaEy"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/auto-scheduler/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cf2d4b7160b080e2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $cf2d4b7160b080e2$export$8bcf7155849993f5,
        pageId: "plan-settings-auto-scheduler",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $6ea35b9284d75d26$export$72bf44dbae2383e5 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("6jX1f"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/custom-fields/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ea35b9284d75d26$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6ea35b9284d75d26$export$72bf44dbae2383e5,
        pageId: "plan-settings-custom-fields",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $9ada19f5a506fdb5$export$78f61b03c267e6d9 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("ctIcH"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/exclusion-rules/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9ada19f5a506fdb5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9ada19f5a506fdb5$export$78f61b03c267e6d9,
        pageId: "plan-settings-exclusion-rules",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $8400d45983020bda$export$731998664b7d5e72 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("4GZod"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/find-your-issue/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8400d45983020bda$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8400d45983020bda$export$731998664b7d5e72,
        pageId: "plan-settings-find-your-issue",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $9bb397f6e922a17b$export$7ba4b487efcedeb3 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("cwBdo"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/issue-sources/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9bb397f6e922a17b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9bb397f6e922a17b$export$7ba4b487efcedeb3,
        pageId: "plan-settings-issue-sources",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $6c9093541b145644$export$49f5b76ad5c06a42 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("hqCsS"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/permissions/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6c9093541b145644$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6c9093541b145644$export$49f5b76ad5c06a42,
        pageId: "plan-settings-permissions",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $254c61850a622af9$export$c1344fd7d24991b3 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("iUDtt"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/plan-info/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$254c61850a622af9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $254c61850a622af9$export$c1344fd7d24991b3,
        pageId: "plan-settings-plan-info",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $670b0c2817d02362$export$ffdec728a47c437c = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("8ITG4"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/program-boards/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$670b0c2817d02362$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $670b0c2817d02362$export$ffdec728a47c437c,
        pageId: "plan-settings-program-boards",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $3b91f4401c9b80db$export$759df6301ec72119 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("eAHcS"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/removed-issues/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3b91f4401c9b80db$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3b91f4401c9b80db$export$759df6301ec72119,
        pageId: "plan-settings-removed-issues",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $2b8c1d6440963d9b$export$a5398542699d356a = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("hA8gE"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/saved-views/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2b8c1d6440963d9b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2b8c1d6440963d9b$export$a5398542699d356a,
        pageId: "plan-settings-saved-views",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $7b43b2a67bea7871$export$94104fcc1a6f460f = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("bZ6a9"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scenarios/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b43b2a67bea7871$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7b43b2a67bea7871$export$94104fcc1a6f460f,
        pageId: "plan-settings-scenarios",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $4c88e6ccbbf6384f$export$3bf11db1bbeae73e = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("5ZWNJ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scheduling/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4c88e6ccbbf6384f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4c88e6ccbbf6384f$export$3bf11db1bbeae73e,
        pageId: "plan-settings-scheduling",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $42e79934d9e30f0d$export$c717f0d9d7f11b49 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("97FCh"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42e79934d9e30f0d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $42e79934d9e30f0d$export$c717f0d9d7f11b49,
        pageId: "plan-summary",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $f4897c15aa4b2194$export$f85952f98f28fed0 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("g0ZzM"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-teams/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f4897c15aa4b2194$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f4897c15aa4b2194$export$f85952f98f28fed0,
        pageId: "plan-teams",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $6b3ef2a0f2f0280b$export$bf48e5f1529ddaeb = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("aP9kF"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6b3ef2a0f2f0280b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6b3ef2a0f2f0280b$export$bf48e5f1529ddaeb,
        pageId: "plan-timeline",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $0751981f2e92b798$export$46bb3a1779d7815b = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("95ds7"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/setup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0751981f2e92b798$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0751981f2e92b798$export$46bb3a1779d7815b,
        pageId: "advanced-roadmaps-setup",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $atRHQ = parcelRequire("atRHQ");

var $lB25E = parcelRequire("lB25E");
function $4bb2b4782688a1bd$export$2c9e4550ef8bdea9(Component, { to: to, redirectCondition: redirectCondition }) {
    return ()=>{
        const [{ match: match }] = (0, $lB25E.useRouter)();
        if (match == null || match.params == null || match.params.planId == null || match.params.scenarioId == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: "/jira/plans"
        });
        if (!redirectCondition()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${to}`
        });
    };
}


const $8ca12770b5795d94$export$f43cc215b47dd576 = [
    (0, $4aaa9ca7f7e53447$export$b9921058a8a65710),
    (0, $4aaa9ca7f7e53447$export$eabcbe4dd6fc9f1f),
    (0, $4aaa9ca7f7e53447$export$dbcd0bd16f12397d),
    (0, $4aaa9ca7f7e53447$export$3907721420f39680),
    (0, $4aaa9ca7f7e53447$export$a26fa5cabff8bc7c),
    (0, $4aaa9ca7f7e53447$export$f7abc47036ff7dd9)
];
const $8ca12770b5795d94$export$bca2008b514578a0 = (0, $4bb2b4782688a1bd$export$2c9e4550ef8bdea9)((0, $937e8f491e6cccea$export$2e2bcd8739ae039), {
    to: '/timeline',
    redirectCondition: ()=>true
});
const $8ca12770b5795d94$export$f85a75f1604118ff = (0, $bMm60.createEntry)((0, $692Sf.softwareAdvancedRoadmapsRoute), {
    ufoName: 'software-advanced-roadmaps-scenario',
    component: $8ca12770b5795d94$export$bca2008b514578a0,
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
        (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
        (0, $drCAA.advancedRoadmapsLastVisitedProgramBoardIdResource)
    ],
    preloadOptions: {
        earlyChunks: [
            'advanced-roadmaps-early-entry'
        ]
    },
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $937e8f491e6cccea$export$81591fb347c2e0ac)
    ]
});
const $8ca12770b5795d94$export$189ae5546a081577 = [
    ...(0, $4b93a6a883195715$export$87af7d91a16be1cf),
    ...(0, $2eff0790babe0236$export$8535fa0728567020),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanDependenciesRoute), {
        component: (0, $183ee29229724a27$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
            (0, $drCAA.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default),
            horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
            onlyShowHorziontalOnNav4: true
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $183ee29229724a27$export$d4669c7a2f17c261)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanSummaryRoute), {
        ufoName: 'software-advanced-roadmaps-summary',
        component: (0, $42e79934d9e30f0d$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $2nflD.advancedRoadmapsSummaryDataResource),
            (0, $drCAA.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default),
            horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
            onlyShowHorziontalOnNav4: true
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $42e79934d9e30f0d$export$c717f0d9d7f11b49)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanCalendarRoute), {
        ufoName: 'software-advanced-roadmaps-calendar',
        component: (0, $52e36f27e7c3f239$export$2e2bcd8739ae039),
        skeleton: ()=>(0, $eI5EY.fg)('platform_calendar_adoption_in_plans') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u7sK.CalendarSkeleton), null) : undefined,
        entryPoint () {
            (0, $gXgRp.setCapability)((0, $d07297a4af13004b$export$f999749ac7a2cd1));
            return (0, $eI5EY.fg)('platform_calendar_adoption_in_plans') ? (0, $52e36f27e7c3f239$export$21806ebf23f23060) : undefined;
        },
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
            (0, $drCAA.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default),
            horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
            onlyShowHorziontalOnNav4: true
        },
        meta: {
            capability: (0, $d07297a4af13004b$export$f999749ac7a2cd1)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $52e36f27e7c3f239$export$3b1de511e34cdb8f)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanReleasesRoute), {
        component: (0, $def3284302c0ab74$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
            (0, $drCAA.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default),
            horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
            onlyShowHorziontalOnNav4: true
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $def3284302c0ab74$export$749f5d2513e04ec0)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanTimelineRoute), {
        component: (0, $6b3ef2a0f2f0280b$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
            (0, $drCAA.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default),
            horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
            onlyShowHorziontalOnNav4: true
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6b3ef2a0f2f0280b$export$bf48e5f1529ddaeb)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanSettingsPermissionsRoute), {
        component: (0, $6c9093541b145644$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6c9093541b145644$export$49f5b76ad5c06a42)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanSettingsSavedViewsRoute), {
        component: (0, $2b8c1d6440963d9b$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $2b8c1d6440963d9b$export$a5398542699d356a)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanSettingsPlanInfoRoute), {
        component: (0, $254c61850a622af9$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $254c61850a622af9$export$c1344fd7d24991b3)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanSettingsProgramBoardsRoute), {
        component: (0, $670b0c2817d02362$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $670b0c2817d02362$export$ffdec728a47c437c)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanSettingsSchedulingRoute), {
        component: (0, $4c88e6ccbbf6384f$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4c88e6ccbbf6384f$export$3bf11db1bbeae73e)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanSettingsScenariosRoute), {
        component: (0, $7b43b2a67bea7871$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7b43b2a67bea7871$export$94104fcc1a6f460f)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanSettingsAutoSchedulerRoute), {
        component: (0, $cf2d4b7160b080e2$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $cf2d4b7160b080e2$export$8bcf7155849993f5)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanSettingsCustomFieldsRoute), {
        component: (0, $6ea35b9284d75d26$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6ea35b9284d75d26$export$72bf44dbae2383e5)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanSettingsExclusionRulesRoute), {
        component: (0, $9ada19f5a506fdb5$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9ada19f5a506fdb5$export$78f61b03c267e6d9)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanSettingsIssueSourcesRoute), {
        component: (0, $9bb397f6e922a17b$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9bb397f6e922a17b$export$7ba4b487efcedeb3)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanSettingsFindYourIssueRoute), {
        component: (0, $8400d45983020bda$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $8400d45983020bda$export$731998664b7d5e72)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanSettingsRemovedIssuesRoute), {
        component: (0, $3b91f4401c9b80db$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $3b91f4401c9b80db$export$759df6301ec72119)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwarePlanTeamsRoute), {
        component: (0, $f4897c15aa4b2194$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default),
            horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
            onlyShowHorziontalOnNav4: true
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f4897c15aa4b2194$export$f85952f98f28fed0)
        ]
    }),
    (0, $bMm60.createEntry)((0, $692Sf.softwareAdvancedRoadmapsGettingStartedRedirectRoute), {
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
                to: "/jira/plans?create-sample-plan=true"
            }),
        isRedirect: true,
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $937e8f491e6cccea$export$81591fb347c2e0ac)
        ]
    })
];
const $8ca12770b5795d94$export$9cbef73b51558ef = (0, $bMm60.createEntry)((0, $692Sf.softwareAdvancedRoadmaps1Route), {
    ufoName: 'software-advanced-roadmaps-plan',
    component: (0, $b1a6b20b73816189$export$ff420400c9900835),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource)
    ],
    preloadOptions: {
        earlyChunks: [
            'advanced-roadmaps-early-entry'
        ]
    },
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $937e8f491e6cccea$export$81591fb347c2e0ac)
    ]
});
const $8ca12770b5795d94$export$e9cfdb950d40e917 = (0, $bMm60.createEntry)((0, $692Sf.softwareAdvancedRoadmapsRedirectRoute), {
    component: (0, $b1a6b20b73816189$export$c3e4fda2290a52bf),
    isRedirect: true,
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $drCAA.advancedRoadmapsScenarioIdResource)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $937e8f491e6cccea$export$81591fb347c2e0ac)
    ]
});
const $8ca12770b5795d94$export$e71031acce6d7e47 = (0, $bMm60.createEntry)((0, $692Sf.softwareAdvancedRoadmaps3Route), {
    ufoName: 'software-advanced-roadmaps-report',
    component: (0, $b1aff7950ef934d8$export$2e2bcd8739ae039),
    layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $drCAA.advancedRoadmapsPlanReportPageInitialChecksResource),
        (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
        (0, $drCAA.advancedRoadmapsLastVisitedProgramBoardIdResource)
    ],
    preloadOptions: {
        earlyChunks: [
            'advanced-roadmaps-early-entry'
        ]
    },
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $937e8f491e6cccea$export$81591fb347c2e0ac)
    ]
});
const $8ca12770b5795d94$export$c2a4c5c6576a704c = (0, $bMm60.createEntry)((0, $692Sf.softwareAdvancedRoadmapsRedirect1Route), {
    component: (0, $23beffab57eac402$export$2e2bcd8739ae039),
    isRedirect: true,
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $937e8f491e6cccea$export$81591fb347c2e0ac)
    ]
});
/**
 * Export Page
 */ const $8ca12770b5795d94$var$ExportPageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $937e8f491e6cccea$export$81591fb347c2e0ac), {
        viewType: "export"
    });
const $8ca12770b5795d94$var$ExportPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8ca12770b5795d94$var$ExportPageComponent,
        pageId: "advanced-roadmap",
        shouldShowSpinner: true
    });
const $8ca12770b5795d94$export$d751e3552b21c604 = (0, $bMm60.createEntry)((0, $692Sf.softwareAdvancedRoadmaps5Route), {
    ufoName: 'software-advanced-roadmaps-scenario-export',
    component: $8ca12770b5795d94$var$ExportPage,
    layout: {
        isChromeless: true,
        globalComponents: [],
        rightSidebars: []
    },
    resources: [
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource)
    ],
    forPaint: [
        (0, $937e8f491e6cccea$export$81591fb347c2e0ac)
    ]
});
const $8ca12770b5795d94$export$2a24acea4e628148 = (0, $bMm60.createEntry)((0, $692Sf.softwareAdvancedRoadmapsSetupRoute), {
    component: (0, $0751981f2e92b798$export$2e2bcd8739ae039),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $0751981f2e92b798$export$46bb3a1779d7815b)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $9f7d0d5c14b9d6eb$export$cd3fc26cf9f696e6 = {
    group: (0, $exb0h.ROUTE_GROUPS_REDIRECTS),
    name: (0, $exb0h.ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK),
    path: '/jira/errors/project-archived',
    exact: true
};




var $59o4i = parcelRequire("59o4i");

const $6c41e52c48634921$export$bcbb38b3c86dba1f = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("3mLaI"))), {
    moduleId: "./src/packages/project-pages/project-archive/project-archived-direct-link/src/index.tsx"
});
const $6c41e52c48634921$export$2e0968e4c0408481 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6c41e52c48634921$export$bcbb38b3c86dba1f,
        pageId: "archived-project-direct-link",
        shouldShowSpinner: false
    });
const $6c41e52c48634921$export$45e68d450757a753 = (0, $bMm60.createEntry)((0, $9f7d0d5c14b9d6eb$export$cd3fc26cf9f696e6), {
    component: $6c41e52c48634921$export$2e0968e4c0408481,
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $6c41e52c48634921$export$bcbb38b3c86dba1f
    ],
    ufoName: 'project-archived'
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7hF3Y = parcelRequire("7hF3Y");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $2b15d28b70731665$export$b60634d0fa43f719 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY),
    path: '/jira/settings/projects/archive',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $8c252442fd261df5$export$b220ffb582ee39aa = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("1juW0"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/archived-projects/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c252442fd261df5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8c252442fd261df5$export$b220ffb582ee39aa,
        pageId: "archived-projects",
        shouldShowSpinner: true
    });


const $ec5f66b3062a483b$export$dc5f9e3c3931cc36 = (0, $bMm60.createEntry)((0, $2b15d28b70731665$export$b60634d0fa43f719), {
    component: (0, $8c252442fd261df5$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7hF3Y.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $8c252442fd261df5$export$b220ffb582ee39aa)
    ],
    ufoName: 'admin.archived-projects'
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $b3nmi = parcelRequire("b3nmi");

var $bAQOb = parcelRequire("bAQOb");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");

var $buaC1 = parcelRequire("buaC1");

var $iOOlt = parcelRequire("iOOlt");

var $iTYGl = parcelRequire("iTYGl");

var $2Fzrk = parcelRequire("2Fzrk");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $14ec04bccc11883f$export$1bfee70ca366d995 = {
    group: (0, $exb0h.ROUTE_GROUPS_ARCHIVE_ISSUES),
    name: (0, $exb0h.ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
    path: '/jira/issues/archive',
    exact: true
};
const $14ec04bccc11883f$export$15745ddd07707d60 = {
    group: (0, $exb0h.ROUTE_GROUPS_ARCHIVE_ISSUES),
    name: (0, $exb0h.ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
    path: '/jira/software/projects/:projectKey/issues/archive',
    exact: true
};
const $14ec04bccc11883f$export$cd10ef5fdf01245b = {
    group: (0, $exb0h.ROUTE_GROUPS_ARCHIVE_ISSUES),
    name: (0, $exb0h.ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
    path: '/jira/software/c/projects/:projectKey/issues/archive',
    exact: true
};
const $14ec04bccc11883f$export$1c7220e12a2118ce = {
    group: (0, $exb0h.ROUTE_GROUPS_ARCHIVE_ISSUES),
    name: (0, $exb0h.ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
    path: '/jira/servicedesk/projects/:projectKey/issues/archive',
    exact: true
};
const $14ec04bccc11883f$export$4a6781d620bb402 = {
    group: (0, $exb0h.ROUTE_GROUPS_ARCHIVE_ISSUES),
    name: (0, $exb0h.ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
    path: '/jira/core/projects/:projectKey/issues/archive',
    exact: true
};



var $dgH3j = parcelRequire("dgH3j");

var $csLgO = parcelRequire("csLgO");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");


var $59o4i = parcelRequire("59o4i");

const $26cd51f541672008$export$5cb97f431a00807d = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("eSTky")).then(({ JiraIssuesArchive: JiraIssuesArchive })=>JiraIssuesArchive)), {
    moduleId: "./src/packages/spa-apps/archives/src/index.tsx"
});
const $26cd51f541672008$export$b8f3c7276fe36123 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $26cd51f541672008$export$5cb97f431a00807d,
        pageId: "spa-apps/archives",
        shouldShowSpinner: true
    });
const $26cd51f541672008$export$f7d3667678a21360 = (0, $bMm60.createEntry)((0, $14ec04bccc11883f$export$1bfee70ca366d995), {
    component: (0, $bAQOb.componentWithFF)('issues-archive-route_a4t84', $26cd51f541672008$export$b8f3c7276fe36123, (0, $dgH3j.default)),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $26cd51f541672008$export$5cb97f431a00807d
    ]
});
const $26cd51f541672008$var$getCommonProjectLayout = ()=>(0, $isbb2.createLayout)((0, $d1szd.genericProjectLayout));
const $26cd51f541672008$export$fdccb6efc62198e6 = [
    (0, $bMm60.createEntry)((0, $14ec04bccc11883f$export$15745ddd07707d60), {
        // Refer: softwareIssueNavigatorRoute from issue-navigator
        component: (0, $bAQOb.componentWithFF)('issues-archive-route_a4t84', $26cd51f541672008$export$b8f3c7276fe36123, (0, $dgH3j.default)),
        layout: (0, $isbb2.createLayout)((0, $soOXK.softwareProjectLayoutNoOnboarding)),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            // TODO: Add entry in `src/packages/navigation-apps/horizontal-nav/horizontal-nav-software/src/ui/index.tsx`
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $26cd51f541672008$export$5cb97f431a00807d
        ]
    }),
    (0, $bMm60.createEntry)((0, $14ec04bccc11883f$export$cd10ef5fdf01245b), {
        // Refer: projectIssueNavigatorClassicRoute from issue-navigator
        component: (0, $bAQOb.componentWithFF)('issues-archive-route_a4t84', $26cd51f541672008$export$b8f3c7276fe36123, (0, $dgH3j.default)),
        layout: $26cd51f541672008$var$getCommonProjectLayout(),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $26cd51f541672008$export$5cb97f431a00807d
        ]
    }),
    (0, $bMm60.createEntry)((0, $14ec04bccc11883f$export$1c7220e12a2118ce), {
        // Refer: servicedeskIssuesRoute from issue-navigator
        component: (0, $bAQOb.componentWithFF)('issues-archive-route_a4t84', $26cd51f541672008$export$b8f3c7276fe36123, (0, $dgH3j.default)),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default // src/packages/navigation-apps/sidebar/servicedesk/src/ui/menu/index.tsx
            )
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $26cd51f541672008$export$5cb97f431a00807d
        ]
    }),
    (0, $bMm60.createEntry)((0, $14ec04bccc11883f$export$4a6781d620bb402), {
        // Refer: projectIssueNavigatorCoreRoute from issue-navigator
        component: (0, $bAQOb.componentWithFF)('issues-archive-route_a4t84', $26cd51f541672008$export$b8f3c7276fe36123, (0, $dgH3j.default)),
        layout: $26cd51f541672008$var$getCommonProjectLayout(),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $4qvmP.getBusinessProjectResources)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $26cd51f541672008$export$5cb97f431a00807d
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $l90Gp = parcelRequire("l90Gp");

var $cbmC6 = parcelRequire("cbmC6");

var $kXWpU = parcelRequire("kXWpU");

var $eJCK9 = parcelRequire("eJCK9");

var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $hRe6W = parcelRequire("hRe6W");

var $fXKgc = parcelRequire("fXKgc");

var $4mBNF = parcelRequire("4mBNF");
const $4adee587f623ba77$export$c4cf7264f95bae78 = ()=>[
        (0, $ixwgj.projectContextResource),
        (0, $l90Gp.forgeProjectModuleResource),
        (0, $eJCK9.staticSidebarShortcutsResource),
        (0, $kXWpU.staticProjectSidebarNavigationResource),
        (0, $cbmC6.staticProjectSidebarConnectAddonsNavigationResource)
    ];
const $4adee587f623ba77$export$f9891419b34ab305 = (0, $bMm60.createEntry)((0, $fXKgc.browseProjectRedirectRoute), {
    component: (0, $4mBNF.RedirectToLastVisitedProjectPage),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...$4adee587f623ba77$export$c4cf7264f95bae78(),
        (0, $hRe6W.queuesNavigationItems),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $cernH = parcelRequire("cernH");

var $b3nmi = parcelRequire("b3nmi");

var $6VZoe = parcelRequire("6VZoe");

var $7ZZxN = parcelRequire("7ZZxN");

var $8QAGR = parcelRequire("8QAGR");

var $isbb2 = parcelRequire("isbb2");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5261aeeed823e572$var$Onboarding = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("3IGoo")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/onboarding/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5261aeeed823e572$var$withAnyBusinessProjectContext = (Component)=>(0, $isbb2.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $7ZZxN.CORE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5261aeeed823e572$var$RightSidebars = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("fwGk6")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/right-sidebars/index.tsx"
});
const $5261aeeed823e572$var$BusinessOnboarding = $5261aeeed823e572$var$withAnyBusinessProjectContext($5261aeeed823e572$var$Onboarding);
const $5261aeeed823e572$var$nonSettingsRightSidebars = [
    $5261aeeed823e572$var$withAnyBusinessProjectContext($5261aeeed823e572$var$RightSidebars)
];
const $5261aeeed823e572$var$sharedBusinessProjectLayout = (0, $isbb2.composeLayouts)((0, $8QAGR.projectLayout));
const $5261aeeed823e572$export$dfb0c3e0348f4429 = (0, $isbb2.composeLayouts)($5261aeeed823e572$var$sharedBusinessProjectLayout, {
    rightSidebars: $5261aeeed823e572$var$nonSettingsRightSidebars,
    globalComponents: [
        $5261aeeed823e572$var$BusinessOnboarding
    ]
});



var $7IBv4 = parcelRequire("7IBv4");

var $isbb2 = parcelRequire("isbb2");
const $eaa6d448b27830ba$export$17e73ed8c35891cb = (0, $isbb2.createLayout)({
    isChromeless: true
});



var $79xbN = parcelRequire("79xbN");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $buaC1 = parcelRequire("buaC1");

var $bMm60 = parcelRequire("bMm60");

var $cOkcY = parcelRequire("cOkcY");

var $4qvmP = parcelRequire("4qvmP");

var $XJw0F = parcelRequire("XJw0F");

var $dIJG1 = parcelRequire("dIJG1");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $cernH = parcelRequire("cernH");

var $b3nmi = parcelRequire("b3nmi");


var $7IBv4 = parcelRequire("7IBv4");

var $6VZoe = parcelRequire("6VZoe");

var $isbb2 = parcelRequire("isbb2");

var $dY715 = parcelRequire("dY715");

var $lB25E = parcelRequire("lB25E");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $71b4a5d883bcbfff$var$LazyIssuePage = (0, $6VZoe.lazyAfterPaint)(()=>(0, $dY715.markAsBentoBundleReady)((parcelRequire("bQUp7"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $71b4a5d883bcbfff$var$AsyncIssueAppComponent = (0, $6VZoe.lazyAfterPaint)(()=>(0, $dY715.markAsBentoBundleReady)((parcelRequire("7KNWV"))), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $71b4a5d883bcbfff$var$imports = {
    fullPage: ()=>$71b4a5d883bcbfff$var$LazyIssuePage.preload(),
    embedded: ()=>$71b4a5d883bcbfff$var$AsyncIssueAppComponent.preload()
};

const $71b4a5d883bcbfff$var$PrefetchCBBResourcesComponent = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("iD2Ab")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/prefetch-wrm-bundle/index.tsx"
});
// We can start the evaluation at module level if we ran the component in SSR
// This needs to be an empty string because the router breaks if it's null or undefined
let $71b4a5d883bcbfff$var$serverIssuePreloadIdentifier = '';
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
if (!false && window.SPA_STATE?.serverIssuePreload) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly fullPage: () => Promise<typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/spa-apps/issue/src/index")>; readonly embedded: () => Promise<...>; }'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const importSupplier = $71b4a5d883bcbfff$var$imports[window.SPA_STATE.serverIssuePreload];
    importSupplier && importSupplier();
}
const $71b4a5d883bcbfff$var$ISSUE_PRELOAD_COMPONENT_MARK = 'IssuePreloadComponent:rendered';
const $71b4a5d883bcbfff$var$useParamsSelector = (0, $lB25E.createRouterSelector)((state)=>({
        query: state.query,
        params: state.match.params
    }));
const $71b4a5d883bcbfff$var$IssuePreloadComponentBuilder = // @ts-expect-error - TS7006 - Parameter 'preloadSupplier' implicitly has an 'any' type.
(identifier, preloadSupplier, preloadContract)=>()=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { query: query, params: params } = $71b4a5d883bcbfff$var$useParamsSelector();
        if (// If we have an undefined contract, assume we want to preload
        !preloadContract || // Preload if we match the contract
        preloadContract.some((preloadingMatch)=>// Match query with router function
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            (!preloadingMatch.query || (0, $lB25E.matchQuery)(preloadingMatch.query, query)) && // Match path params with simple object structure, where if value is undefined
            // we assume we match all values
            (!preloadingMatch.params || preloadingMatch.params.every(({ key: key, value: value })=>params && params[key] !== undefined && (value === undefined || params[key] === value))))) {
            if (!false) preloadSupplier();
            if (false) $71b4a5d883bcbfff$var$serverIssuePreloadIdentifier = identifier;
            else performance.mark($71b4a5d883bcbfff$var$ISSUE_PRELOAD_COMPONENT_MARK);
        }
        return null;
    };
const $71b4a5d883bcbfff$export$f55e6973062dc859 = ()=>$71b4a5d883bcbfff$var$serverIssuePreloadIdentifier;
const $71b4a5d883bcbfff$var$FullPageIssuePreloadComponent = $71b4a5d883bcbfff$var$IssuePreloadComponentBuilder('fullPage', $71b4a5d883bcbfff$var$imports.fullPage);
// @ts-expect-error - TS2339 - Property 'displayName' does not exist on type '() => null'.
$71b4a5d883bcbfff$var$FullPageIssuePreloadComponent.displayName = 'FullPageIssuePreloadComponent';
const $71b4a5d883bcbfff$export$98e337c40eb151da = (0, $isbb2.createLayout)({
    globalComponents: [
        $71b4a5d883bcbfff$var$FullPageIssuePreloadComponent,
        $71b4a5d883bcbfff$var$PrefetchCBBResourcesComponent
    ]
});
const $71b4a5d883bcbfff$export$7b113174a456921a = (preloadContract)=>{
    const EmbeddedIssuePreloadComponent = $71b4a5d883bcbfff$var$IssuePreloadComponentBuilder('embedded', $71b4a5d883bcbfff$var$imports.embedded, preloadContract);
    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type '() => null'.
    EmbeddedIssuePreloadComponent.displayName = 'EmbeddedIssuePreloadComponent';
    return (0, $isbb2.createLayout)({
        globalComponents: [
            EmbeddedIssuePreloadComponent
        ]
    });
};



var $7vTKl = parcelRequire("7vTKl");

var $buaC1 = parcelRequire("buaC1");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $cOkcY = parcelRequire("cOkcY");

var $4qvmP = parcelRequire("4qvmP");

var $exb0h = parcelRequire("exb0h");
const $fe478ca0578dbdc3$export$14a5cbbd7e1e2dc2 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD),
    ufoName: 'jwm.jwm-board',
    exact: true,
    path: '/jira/core/projects/:projectKey/board',
    query: [
        'issue-key?'
    ]
};



var $6VZoe = parcelRequire("6VZoe");

const $56906cb72fe2b2c4$export$8c70dcc4643464f8 = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("7KNWV")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $b4e22da15c12b0bc$export$d663c6b2156921dd = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("96rh5")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/business/board/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b4e22da15c12b0bc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b4e22da15c12b0bc$export$d663c6b2156921dd,
        pageId: "async-business-board",
        shouldShowSpinner: true
    });


const $b07feb5e6e1164ae$export$c7fe0dd4417407a0 = (0, $bMm60.createEntry)((0, $fe478ca0578dbdc3$export$14a5cbbd7e1e2dc2), {
    component: (0, $b4e22da15c12b0bc$export$2e2bcd8739ae039),
    layout: (0, $isbb2.composeLayouts)((0, $5261aeeed823e572$export$dfb0c3e0348f4429), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'issue-key'
            ]
        }
    ])),
    skeleton: (0, $7IBv4.ThemedLazySkeleton),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $buaC1.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    resources: [
        ...(0, $4qvmP.getProjectViewResources)(),
        (0, $cOkcY.workflowIssuesResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $b4e22da15c12b0bc$export$d663c6b2156921dd)
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    preloadOptions: {
        earlyChunks: [
            'business-board-early-entry'
        ]
    }
});



var $cernH = parcelRequire("cernH");

var $b3nmi = parcelRequire("b3nmi");


var $7vTKl = parcelRequire("7vTKl");

var $buaC1 = parcelRequire("buaC1");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $6wsEw = parcelRequire("6wsEw");

var $4mBNF = parcelRequire("4mBNF");

var $eUqFw = parcelRequire("eUqFw");

var $atRHQ = parcelRequire("atRHQ");

var $lB25E = parcelRequire("lB25E");
const $17f93ffb3c053efc$var$OverviewRedirect = ()=>{
    const [overviewId] = (0, $lB25E.usePathParam)('overviewId');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: `/jira/core/overviews/${overviewId}/summary`
    });
};
var $17f93ffb3c053efc$export$2e2bcd8739ae039 = $17f93ffb3c053efc$var$OverviewRedirect;


const $946b535f25881faf$export$766e305da4c78de5 = (0, $bMm60.createEntry)((0, $6wsEw.jiraBusinessProjectRedirectRoute), {
    component: (0, $4mBNF.RedirectToLastVisitedProjectPage),
    layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $buaC1.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    resources: (0, $4qvmP.getProjectViewResources)(),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});
const $946b535f25881faf$export$3aa9116f715693e1 = (0, $bMm60.createEntry)((0, $6wsEw.jiraBusinessOverviewRedirectRoute), {
    component: (0, $17f93ffb3c053efc$export$2e2bcd8739ae039),
    layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $buaC1.default),
        horizontal: (0, $b3nmi.AsyncHorizontalOverviewNav)
    },
    resources: (0, $4qvmP.getOverviewViewResources)(),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $exb0h = parcelRequire("exb0h");
const $6bd52bd1c3447829$export$3008bdf5c6ced894 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY),
    path: '/jira/core/projects/:projectKey/summary',
    exact: true
};
const $6bd52bd1c3447829$export$ba1373c12ea65b4c = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR),
    path: '/jira/core/projects/:projectKey/calendar',
    exact: true
};
const $6bd52bd1c3447829$export$2dd4e8a37d8ac978 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT),
    path: '/jira/core/projects/:projectKey/shortcuts',
    exact: true
};
const $6bd52bd1c3447829$export$f1e14ce95022c93a = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST),
    path: '/jira/core/projects/:projectKey/list',
    exact: true
};
const $6bd52bd1c3447829$export$e98776bdf96c88ac = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM),
    path: '/jira/core/projects/:projectKey/form',
    exact: true
};
const $6bd52bd1c3447829$export$3cd93ff55b29f07f = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT),
    path: '/jira/core/projects/:projectKey/form/:formId',
    exact: true
};
const $6bd52bd1c3447829$export$5f684808e671de5 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER),
    path: '/jira/core/projects/:projectKey/form/:formId/builder',
    exact: true
};
const $6bd52bd1c3447829$export$4301c67fd317894a = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE),
    path: '/jira/core/projects/:projectKey/timeline',
    exact: true
};
const $6bd52bd1c3447829$export$3109a183a442a02d = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS),
    path: '/jira/core/projects/:projectKey/approvals',
    exact: true
};
const $6bd52bd1c3447829$export$54a218ca6d1c056a = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_PAGES),
    path: '/jira/core/projects/:projectKey/pages'
};
const $6bd52bd1c3447829$export$2d0c5d5ce5a00c = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS),
    path: '/jira/core/projects/:projectKey/attachments'
};
const $6bd52bd1c3447829$export$fb814f9911fc766e = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED),
    path: '/jira/core/projects/:projectKey/timeline/embed',
    exact: true
};
const $6bd52bd1c3447829$export$e237859f2fc7cc7 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED),
    path: '/jira/core/projects/:projectKey/calendar/embed',
    exact: true
};
const $6bd52bd1c3447829$export$f0d33cf104c15274 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED),
    path: '/jira/core/projects/:projectKey/list/embed',
    exact: true
};
const $6bd52bd1c3447829$export$7d6a91d85236417 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED),
    path: '/jira/core/projects/:projectKey/board/embed',
    exact: true
};
const $6bd52bd1c3447829$export$7e8fd15fdfa29385 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED),
    path: '/jira/core/projects/:projectKey/form/:formId/embed',
    exact: true
};
const $6bd52bd1c3447829$export$13164dbb379620e2 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY_EMBED),
    path: '/jira/core/projects/:projectKey/summary/embed',
    exact: true
};
const $6bd52bd1c3447829$export$cd9c218d7c968d2d = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SAMPLE_ONBOARDING),
    path: '/jira/core/sample/onboarding/:taskId',
    exact: true
};
const $6bd52bd1c3447829$export$13f0c823ff3059c2 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE),
    path: '/jira/core/overviews/:overviewId/timeline',
    exact: true
};
const $6bd52bd1c3447829$export$61383e5418d2ffe3 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
    path: '/jira/core/overviews/:overviewId/calendar',
    exact: true
};
const $6bd52bd1c3447829$export$4a86e6b12ce49af9 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
    path: '/jira/core/overviews/:overviewId/summary',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $4132dbcc62d1b4af$export$70abf918dfb890e = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("JL6YX")), {
    moduleId: "./src/packages/spa-apps/business/approvals/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4132dbcc62d1b4af$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4132dbcc62d1b4af$export$70abf918dfb890e,
        pageId: "async-business-approvals",
        shouldShowSpinner: true
    });




var $7vTKl = parcelRequire("7vTKl");
/**
 * @generated SignedSource<<c7c7f85de929efb2b03c746e74b7f372>>
 * @relayHash b573a817cc8750bab77217970b34b53a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77efda0b857a2c013283d7a49b7393ff8f7e07bcad70eba5f1702dac7b6315f8
const $adfc56cdc58211c0$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "77efda0b857a2c013283d7a49b7393ff8f7e07bcad70eba5f1702dac7b6315f8",
        "metadata": {},
        "name": "uiJWMAttachmentsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $adfc56cdc58211c0$export$2e2bcd8739ae039 = $adfc56cdc58211c0$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $ec31f7e83335bf8b$export$d94bafd9d893ec98 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("hLS6P")), {
        moduleId: "26a1d436"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        // This entry point should only load in this route
        // once overview is supported by backend, we should have a different entry point for it
        const { projectKey: projectKey } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                jwmAttachmentsQuery: {
                    parameters: $adfc56cdc58211c0$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: [
                            projectKey
                        ],
                        filters: {
                            fileName: '',
                            authorIds: [],
                            mimeTypes: [],
                            dateRange: {
                                before: undefined,
                                after: undefined
                            }
                        },
                        durationInSeconds: 900,
                        maxTokenLength: 65534,
                        attachmentCount: 100
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'network-only'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});


const $f1e3ab5e6207f9e3$export$d2dbce06a31f0f47 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $ec31f7e83335bf8b$export$d94bafd9d893ec98),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $bf03a688d4ae0a15$export$a21a9228b9e68b40 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("7c3cQ")), {
    moduleId: "./src/packages/spa-apps/business/board-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bf03a688d4ae0a15$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $bf03a688d4ae0a15$export$a21a9228b9e68b40,
        pageId: "async-business-board-embed",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $7vTKl = parcelRequire("7vTKl");

var $eI5EY = parcelRequire("eI5EY");


var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");
function $248baf63f84828c0$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $248baf63f84828c0$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $248baf63f84828c0$var$createScope({ context: context }) {
    return {
        type: 'project',
        projectKeys: [
            String(context.match.params.projectKey)
        ]
    };
}
function $248baf63f84828c0$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $248baf63f84828c0$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $248baf63f84828c0$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $248baf63f84828c0$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $248baf63f84828c0$var$toMidnightUTCString(selectedDate),
        mode: $248baf63f84828c0$var$toViewMode(viewRange),
        weekStart: $248baf63f84828c0$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField
    };
}
function $248baf63f84828c0$var$buildIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $248baf63f84828c0$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}

const $248baf63f84828c0$export$19cf4b398f638dc6 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("8ikSD")), {
        moduleId: "70b39bf1"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $248baf63f84828c0$var$createScope(entryPointRouteParams);
        const { date: date } = context.query;
        const selectedDate = $248baf63f84828c0$var$toDate(date);
        const viewRange = 'month';
        const weekStartsOn = 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $ae4d1c21cb10f5ab$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $248baf63f84828c0$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $248baf63f84828c0$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesSearchInput: $248baf63f84828c0$var$buildIssuesSearchInput(),
                        unscheduledIssuesSearchInput: $248baf63f84828c0$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: {
                            versionStatuses: [
                                'RELEASED',
                                'UNRELEASED'
                            ],
                            includeSharedReleases: true
                        },
                        sprintsSearchInput: null,
                        skipSprintSearch: true,
                        skipVersionSearch: false,
                        viewId: null,
                        schedulePermissionsEnabled: (0, $eI5EY.fg)('calendar_schedule_issue_permissions_check')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields
            }
        };
    }
});



var $59o4i = parcelRequire("59o4i");
const $1dfd46eba238fb8d$export$a3db41da3fd3ff21 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $248baf63f84828c0$export$19cf4b398f638dc6),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});

const $1dfd46eba238fb8d$export$ebca96bcc4698ee2 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("ghwYt")), {
    moduleId: "./src/packages/spa-apps/business/calendar/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1dfd46eba238fb8d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1dfd46eba238fb8d$export$ebca96bcc4698ee2,
        pageId: "async-business-calendar",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");



var $59o4i = parcelRequire("59o4i");
const $02b84759ee5d4ba1$export$146b7e01aca9816a = (0, $bf010c1b73a0efa7$export$56ea489e9d4bfa04)({
    main: (0, $248baf63f84828c0$export$19cf4b398f638dc6)
});

const $02b84759ee5d4ba1$export$152b9e0029b084e8 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("k5FoF")), {
    moduleId: "./src/packages/spa-apps/business/calendar-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$02b84759ee5d4ba1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $02b84759ee5d4ba1$export$152b9e0029b084e8,
        pageId: "async-business-calendar-embed",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $a1f16c40e224e100$export$240a58749ebba091 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("jvImZ")), {
    moduleId: "./src/packages/spa-apps/business/form/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a1f16c40e224e100$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a1f16c40e224e100$export$240a58749ebba091,
        pageId: "async-business-form",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $426c8094dec08e01$export$2076234d7fde1717 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("gar4m")), {
    moduleId: "./src/packages/spa-apps/business/form-builder/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$426c8094dec08e01$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $426c8094dec08e01$export$2076234d7fde1717,
        pageId: "async-business-form-builder",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $acbeef93bd66459b$export$258fcd204933dd75 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("yoNhc")), {
    moduleId: "./src/packages/spa-apps/business/form-submit/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$acbeef93bd66459b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $acbeef93bd66459b$export$258fcd204933dd75,
        pageId: "async-business-form-submit",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $97f2610e0a5d3593$export$4d2f42d18d020964 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("5IfHD")), {
    moduleId: "./src/packages/spa-apps/business/form-submit-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$97f2610e0a5d3593$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $97f2610e0a5d3593$export$4d2f42d18d020964,
        pageId: "async-business-form-submit-embed",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $7vTKl = parcelRequire("7vTKl");
/**
 * @generated SignedSource<<5883fb1edc7ab15af020f0e2872a12f9>>
 * @relayHash fe655b1c8f3fbc00448359fc7bbdb4a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19617cae23dba3619feb6b7d7006b077c3444a7b0f92752732863a7b7f39d16b
const $3abbc310e35c2066$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "19617cae23dba3619feb6b7d7006b077c3444a7b0f92752732863a7b7f39d16b",
        "metadata": {},
        "name": "formatRulesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $3abbc310e35c2066$export$2e2bcd8739ae039 = $3abbc310e35c2066$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");
const $f85376d700ee200d$var$FORMAT_RULES_FIRST = 20;

const $f85376d700ee200d$export$6be4f10150ff6073 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("8K9k0")), {
        moduleId: "b03343a1"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                formattingRulesQuery: {
                    parameters: $3abbc310e35c2066$export$2e2bcd8739ae039,
                    variables: {
                        projectKey: projectKey,
                        cloudId: tenantContext.cloudId,
                        first: $f85376d700ee200d$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'network-only'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});



var $59o4i = parcelRequire("59o4i");

const $569b2a77b8dc04fe$export$4bfa19c758c39608 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("8K9k0")), {
    moduleId: "./src/packages/spa-apps/business/list/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$569b2a77b8dc04fe$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $569b2a77b8dc04fe$export$4bfa19c758c39608,
        pageId: "async-business-list",
        shouldShowSpinner: true
    });
const $569b2a77b8dc04fe$export$c338b91a236e608a = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $f85376d700ee200d$export$6be4f10150ff6073),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $eb4cc28210026408$export$55704f3c7b8c3364 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("7TGsb")), {
    moduleId: "./src/packages/spa-apps/business/list-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb4cc28210026408$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $eb4cc28210026408$export$55704f3c7b8c3364,
        pageId: "async-business-list-embed",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $9642da6d5fe405a8$export$5b8a69e38f82df6c = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("ebtLZ")), {
    moduleId: "./src/packages/spa-apps/business/overview-calendar/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9642da6d5fe405a8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9642da6d5fe405a8$export$5b8a69e38f82df6c,
        pageId: "async-business-overview-calendar",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $3f0884381628f57d$export$125428653f4abe07 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("01KSG")), {
    moduleId: "./src/packages/spa-apps/business/overview-summary/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3f0884381628f57d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3f0884381628f57d$export$125428653f4abe07,
        pageId: "async-business-overview-summary",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $000469bfe10be32c$export$bfea8be13da0d217 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("7wsPY")), {
    moduleId: "./src/packages/spa-apps/business/overview-timeline/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$000469bfe10be32c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $000469bfe10be32c$export$bfea8be13da0d217,
        pageId: "async-business-overview-timeline",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ixwgj = parcelRequire("ixwgj");

var $78d1w = parcelRequire("78d1w");

var $lB25E = parcelRequire("lB25E");
const $ca2e025803a80923$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $lB25E.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $jMP2a.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useResource: useResource = (0, $lB25E.useResource), useRouter: useRouter = (0, $lB25E.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $78d1w.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $ixwgj.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eUqFw.useRef)(createAnalyticsEvent({}));
    (0, $eUqFw.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};



const $e0839b7a0543fee8$export$c2115a649411f570 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("aaBng"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/business/pages/src/index.tsx"
});
const $e0839b7a0543fee8$export$7c3b1828ada63555 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ca2e025803a80923$export$8a3df560509448b8), {
        page: "/pages"
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e0839b7a0543fee8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e0839b7a0543fee8$export$c2115a649411f570,
        pageId: "async-business-pages",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $5e139ca1bb32ee03$export$e39375ab6521f3ef = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("5jPNW")), {
    moduleId: "./src/packages/spa-apps/business/sample-onboarding/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5e139ca1bb32ee03$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5e139ca1bb32ee03$export$e39375ab6521f3ef,
        pageId: "async-business-sample-onboarding",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $91b86a7bc97ab47f$export$dfbcb99b55c05486 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("9Ice3")), {
    moduleId: "./src/packages/spa-apps/business/shortcut/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$91b86a7bc97ab47f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $91b86a7bc97ab47f$export$dfbcb99b55c05486,
        pageId: "async-business-shortcuts",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $7577dd410884db12$export$68c09444cc6f2843 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("4HRWR")), {
    moduleId: "./src/packages/spa-apps/business/summary/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7577dd410884db12$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7577dd410884db12$export$68c09444cc6f2843,
        pageId: "async-business-summary",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $2f2c03b70635264e$export$a860d403525d69a5 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("gXtGo")), {
    moduleId: "./src/packages/spa-apps/business/summary-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2f2c03b70635264e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2f2c03b70635264e$export$a860d403525d69a5,
        pageId: "async-business-summary-embed",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $219dcd90129280be$export$5ae50f261c16f52a = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("eJJ4Z")), {
    moduleId: "./src/packages/spa-apps/business/timeline/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$219dcd90129280be$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $219dcd90129280be$export$5ae50f261c16f52a,
        pageId: "async-business-timeline",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $2ad32d4b4510de44$export$49e7774ce1be17a4 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("eqzyN")), {
    moduleId: "./src/packages/spa-apps/business/timeline-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2ad32d4b4510de44$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2ad32d4b4510de44$export$49e7774ce1be17a4,
        pageId: "async-business-timeline-embed",
        shouldShowSpinner: true
    });


const $eb281330981e8e67$export$fb2091db9e7f9102 = [
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$3008bdf5c6ced894), {
        ufoName: 'jwm.summary-view',
        component: (0, $7577dd410884db12$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: [
            ...(0, $4qvmP.getProjectViewResources)(),
            (0, $dIJG1.summaryDataResource),
            (0, $XJw0F.activityFeedResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7577dd410884db12$export$68c09444cc6f2843)
        ]
    }),
    (0, $b07feb5e6e1164ae$export$c7fe0dd4417407a0),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$e237859f2fc7cc7), {
        ufoName: 'jwm.calendar-embed-view',
        component: (0, $02b84759ee5d4ba1$export$2e2bcd8739ae039),
        entryPoint () {
            return (0, $79xbN.expValEquals)('business_projects_shared_calendar', 'cohort', 'variation') ? (0, $02b84759ee5d4ba1$export$146b7e01aca9816a) : undefined;
        },
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $02b84759ee5d4ba1$export$152b9e0029b084e8)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$ba1373c12ea65b4c), {
        ufoName: 'jwm.calendar-view',
        component: (0, $1dfd46eba238fb8d$export$2e2bcd8739ae039),
        entryPoint () {
            return (0, $79xbN.expValEquals)('business_projects_shared_calendar', 'cohort', 'variation') ? (0, $1dfd46eba238fb8d$export$a3db41da3fd3ff21) : undefined;
        },
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1dfd46eba238fb8d$export$ebca96bcc4698ee2)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$2dd4e8a37d8ac978), {
        component: (0, $91b86a7bc97ab47f$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $91b86a7bc97ab47f$export$dfbcb99b55c05486)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$f1e14ce95022c93a), {
        ufoName: 'jwm.list-view',
        component: (0, $569b2a77b8dc04fe$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        entryPoint: ()=>(0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, $569b2a77b8dc04fe$export$c338b91a236e608a) : undefined,
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $569b2a77b8dc04fe$export$4bfa19c758c39608)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$e98776bdf96c88ac), {
        ufoName: 'jwm.form-directory-view',
        component: (0, $a1f16c40e224e100$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $a1f16c40e224e100$export$240a58749ebba091)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$3cd93ff55b29f07f), {
        ufoName: 'jwm.form-submit-view',
        component: (0, $acbeef93bd66459b$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $acbeef93bd66459b$export$258fcd204933dd75)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$5f684808e671de5), {
        ufoName: 'jwm.form-view',
        component: (0, $426c8094dec08e01$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $426c8094dec08e01$export$2076234d7fde1717)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$4301c67fd317894a), {
        ufoName: 'jwm.timeline-view',
        component: (0, $219dcd90129280be$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $219dcd90129280be$export$5ae50f261c16f52a)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$3109a183a442a02d), {
        ufoName: 'jwm.approvals-view',
        component: (0, $4132dbcc62d1b4af$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4132dbcc62d1b4af$export$70abf918dfb890e)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$54a218ca6d1c056a), {
        resources: [
            ...(0, $4qvmP.getBusinessProjectResources)(),
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $ixwgj.projectContextResource)
        ],
        component: (0, $e0839b7a0543fee8$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $e0839b7a0543fee8$export$c2115a649411f570)
        ],
        ufoName: 'jwm.jwm-pages'
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$2d0c5d5ce5a00c), {
        ufoName: 'jwm.attachments-view',
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        entryPoint: ()=>(0, $f1e3ab5e6207f9e3$export$d2dbce06a31f0f47),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)()
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$fb814f9911fc766e), {
        ufoName: 'jwm.timeline-embed-view',
        component: (0, $2ad32d4b4510de44$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $2ad32d4b4510de44$export$49e7774ce1be17a4)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$f0d33cf104c15274), {
        ufoName: 'jwm.list-embed-view',
        component: (0, $eb4cc28210026408$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        entryPoint: ()=>(0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, $569b2a77b8dc04fe$export$c338b91a236e608a) : undefined,
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $eb4cc28210026408$export$55704f3c7b8c3364)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$7d6a91d85236417), {
        ufoName: 'jwm.jwm-board-embed',
        component: (0, $bf03a688d4ae0a15$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        resources: [
            ...(0, $4qvmP.getProjectViewResources)(),
            (0, $cOkcY.workflowIssuesResource)
        ],
        forPaint: [
            (0, $bf03a688d4ae0a15$export$a21a9228b9e68b40)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$7e8fd15fdfa29385), {
        ufoName: 'jwm.form-submit-embed-view',
        component: (0, $97f2610e0a5d3593$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $97f2610e0a5d3593$export$4d2f42d18d020964)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$13164dbb379620e2), {
        ufoName: 'jwm.summary-view-embed',
        component: (0, $2f2c03b70635264e$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        resources: [
            ...(0, $4qvmP.getProjectViewResources)(),
            (0, $dIJG1.summaryDataResource),
            (0, $XJw0F.activityFeedResource)
        ],
        forPaint: [
            (0, $2f2c03b70635264e$export$a860d403525d69a5)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$cd9c218d7c968d2d), {
        component: (0, $5e139ca1bb32ee03$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        resources: (0, $hHrVM.getNavigationResources)(),
        forPaint: [
            (0, $5e139ca1bb32ee03$export$e39375ab6521f3ef)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$13f0c823ff3059c2), {
        component: (0, $000469bfe10be32c$export$2e2bcd8739ae039),
        layout: (0, $dVvIP.globalLayout),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalOverviewNav)
        },
        resources: (0, $4qvmP.getOverviewViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $000469bfe10be32c$export$bfea8be13da0d217)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$61383e5418d2ffe3), {
        component: (0, $9642da6d5fe405a8$export$2e2bcd8739ae039),
        layout: (0, $dVvIP.globalLayout),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalOverviewNav)
        },
        resources: (0, $4qvmP.getOverviewViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9642da6d5fe405a8$export$5b8a69e38f82df6c)
        ]
    }),
    (0, $bMm60.createEntry)((0, $6bd52bd1c3447829$export$4a86e6b12ce49af9), {
        component: (0, $3f0884381628f57d$export$2e2bcd8739ae039),
        layout: (0, $dVvIP.globalLayout),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalOverviewNav)
        },
        resources: (0, $4qvmP.getOverviewViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $3f0884381628f57d$export$125428653f4abe07)
        ]
    }),
    (0, $946b535f25881faf$export$766e305da4c78de5),
    (0, $946b535f25881faf$export$3aa9116f715693e1)
];



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $kYKYa = parcelRequire("kYKYa");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $82b5373c7482f6aa$export$b8abcf8aa8f4df56 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("74Iqa"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$82b5373c7482f6aa$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $82b5373c7482f6aa$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });


const $cec0a7d4441930b4$export$5b0670f37204a43d = (0, $bMm60.createEntry)((0, $kYKYa.classicProjectSettingsDataClassificationsRoute), {
    component: (0, $82b5373c7482f6aa$export$2e2bcd8739ae039),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $82b5373c7482f6aa$export$b8abcf8aa8f4df56)
    ]
});



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $67a90f29888309ea$export$c593179674352d0 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT),
    path: '/plugins/servlet/project-config/:projectKey/issuelayout',
    query: [
        'screenId'
    ],
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $aa1f52b15b58fdc3$export$36dcfb52d47cb93a = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("e3u5r"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aa1f52b15b58fdc3$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $aa1f52b15b58fdc3$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};


const $5d62d367f9442e26$export$47b3bdf88a7d176b = (0, $bMm60.createEntry)((0, $67a90f29888309ea$export$c593179674352d0), {
    ufoName: 'project-settings.issue-type.jsw-cmp',
    component: (0, $aa1f52b15b58fdc3$export$2e2bcd8739ae039),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $aa1f52b15b58fdc3$export$36dcfb52d47cb93a)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");



var $exb0h = parcelRequire("exb0h");

var $bmKiO = parcelRequire("bmKiO");

var $79xbN = parcelRequire("79xbN");

var $9zysr = parcelRequire("9zysr");

var $dnJL9 = parcelRequire("dnJL9");

var $d1szd = parcelRequire("d1szd");

var $dVvIP = parcelRequire("dVvIP");


var $7vTKl = parcelRequire("7vTKl");

var $5w4hM = parcelRequire("5w4hM");

var $2Fzrk = parcelRequire("2Fzrk");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $4qvmP = parcelRequire("4qvmP");

var $aeIT6 = parcelRequire("aeIT6");

var $5oyzN = parcelRequire("5oyzN");

var $0fOjG = parcelRequire("0fOjG");

var $a5edq = parcelRequire("a5edq");

var $gar3N = parcelRequire("gar3N");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $lY9wZ = parcelRequire("lY9wZ");

var $5GEOG = parcelRequire("5GEOG");

var $3MEW8 = parcelRequire("3MEW8");

var $4pu9Z = parcelRequire("4pu9Z");


var $dgH3j = parcelRequire("dgH3j");

var $4mBNF = parcelRequire("4mBNF");

var $jh2R9 = parcelRequire("jh2R9");

var $exb0h = parcelRequire("exb0h");


var $1ybV0 = parcelRequire("1ybV0");

var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $3vlQh = parcelRequire("3vlQh");

var $exb0h = parcelRequire("exb0h");
const $2ab19c36cf374220$export$12e1ca6c7cfdfd49 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_INCIDENTS),
    path: '/jira/software/projects/:projectKey/incidents'
};
const $2ab19c36cf374220$export$3356a7870a2717f4 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/incidents'
};



var $1hTYf = parcelRequire("1hTYf");

var $bEe6y = parcelRequire("bEe6y");
/**
 * @generated SignedSource<<755ee4fdc15eeb1d429180ce9f242ead>>
 * @relayHash 478a65a5e586d07574b5bbd2cc4ef630
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50f41ae3db36d1741d384023d13472ac68cccc88abdb8a72fb04d3f7c9bc8670
const $5b808c300e9a0435$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "50f41ae3db36d1741d384023d13472ac68cccc88abdb8a72fb04d3f7c9bc8670",
        "metadata": {
            "connection": [
                {
                    "count": "servicePageSize",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "linkedOperationsComponentsByProject"
                    ]
                }
            ]
        },
        "name": "srcIncidentsPageInternalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5b808c300e9a0435$export$2e2bcd8739ae039 = $5b808c300e9a0435$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");
const $8893b993517b1a81$var$AriGraphSortOrderInput = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $8893b993517b1a81$var$QUERY_PARAM_SEARCH = 'search';
const $8893b993517b1a81$var$QUERY_PARAM_PRIORITY = 'priority';
const $8893b993517b1a81$var$QUERY_PARAM_AFFECTED_SERVICE = 'affected-service';
const $8893b993517b1a81$var$QUERY_PARAM_STATUS = 'status';
const $8893b993517b1a81$var$QUERY_PARAM_SORT_BY = 'sortBy';
const $8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER = 'sortOrder';
const $8893b993517b1a81$var$STATUS_SORT_KEY = 'status';
const $8893b993517b1a81$var$CREATED_SORT_KEY = 'created';
const $8893b993517b1a81$var$PRIORITY_SORT_KEY = 'priority';
const $8893b993517b1a81$var$SUMMARY_SORT_KEY = 'key';
const $8893b993517b1a81$var$ASC_SORT_KEY = 'ASC';
const $8893b993517b1a81$var$DESC_SORT_KEY = 'DESC';
function $8893b993517b1a81$var$notEmpty(value) {
    return Boolean(value);
}
const $8893b993517b1a81$var$isPriority = $8893b993517b1a81$var$notEmpty;
const $8893b993517b1a81$var$isStatus = (val)=>val === 'resolved' || val === 'open';
const $8893b993517b1a81$var$isSortBy = (val)=>val === $8893b993517b1a81$var$STATUS_SORT_KEY || val === $8893b993517b1a81$var$CREATED_SORT_KEY || val === $8893b993517b1a81$var$PRIORITY_SORT_KEY || val === $8893b993517b1a81$var$SUMMARY_SORT_KEY;
const $8893b993517b1a81$var$isSortOrder = (val)=>val === $8893b993517b1a81$var$ASC_SORT_KEY || val === $8893b993517b1a81$var$DESC_SORT_KEY;
const $8893b993517b1a81$var$isAffectedService = $8893b993517b1a81$var$notEmpty;
function $8893b993517b1a81$var$parseParameter(parameter, parameterValidationFn) {
    return parameter == null ? undefined : parameter.split(',').map((str)=>str.trim()).filter(parameterValidationFn);
}
const $8893b993517b1a81$var$parseQueryParams = (paramsRaw)=>{
    const result = {
        [$8893b993517b1a81$var$QUERY_PARAM_SORT_BY]: paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_SORT_BY] && $8893b993517b1a81$var$isSortBy(paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_SORT_BY]) ? paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_SORT_BY] : $8893b993517b1a81$var$CREATED_SORT_KEY,
        [$8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER]: paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER] && $8893b993517b1a81$var$isSortOrder(paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER]) ? paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER] : $8893b993517b1a81$var$DESC_SORT_KEY
    };
    result[$8893b993517b1a81$var$QUERY_PARAM_AFFECTED_SERVICE] = $8893b993517b1a81$var$parseParameter(paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_AFFECTED_SERVICE], $8893b993517b1a81$var$isAffectedService);
    result[$8893b993517b1a81$var$QUERY_PARAM_STATUS] = $8893b993517b1a81$var$parseParameter(paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_STATUS], $8893b993517b1a81$var$isStatus);
    result[$8893b993517b1a81$var$QUERY_PARAM_SEARCH] = paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_SEARCH] ?? undefined;
    result[$8893b993517b1a81$var$QUERY_PARAM_PRIORITY] = $8893b993517b1a81$var$parseParameter(paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_PRIORITY], $8893b993517b1a81$var$isPriority);
    return result;
};
const $8893b993517b1a81$var$getFilterValue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
values)=>({
        ...values.length > 0 ? {
            is: values
        } : {}
    });
const $8893b993517b1a81$var$parseStatusToFilterValues = (status)=>status.flatMap((stat)=>{
        switch(stat){
            case 'open':
                return [
                    'NEW',
                    'INDETERMINATE'
                ];
            case 'resolved':
                return [
                    'DONE'
                ];
            default:
                return [
                    'UNDEFINED'
                ];
        }
    });
const $8893b993517b1a81$var$getGqlFiltersFromQueryParams = (parsedQueryParams)=>({
        and: [
            {
                to_status: $8893b993517b1a81$var$getFilterValue($8893b993517b1a81$var$parseStatusToFilterValues(parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_STATUS] ?? [])),
                to_priority: $8893b993517b1a81$var$getFilterValue(parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_PRIORITY] ?? []),
                to_affectedServiceAris: $8893b993517b1a81$var$getFilterValue(parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_AFFECTED_SERVICE] ?? [])
            }
        ]
    });
const $8893b993517b1a81$var$parseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $8893b993517b1a81$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $8893b993517b1a81$var$AriGraphSortOrderInput.ASC;
        case $8893b993517b1a81$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $8893b993517b1a81$var$AriGraphSortOrderInput.DESC;
        default:
            return defaultValue;
    }
};
const $8893b993517b1a81$var$getSortValue = (sortOrder)=>({
        priority: 2,
        direction: $8893b993517b1a81$var$parseSortDirection(sortOrder, $8893b993517b1a81$var$AriGraphSortOrderInput.DESC)
    });
// Added Inverse sort fn as data in AGS is indexed in reverse order for priority
const $8893b993517b1a81$var$parseInverseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $8893b993517b1a81$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $8893b993517b1a81$var$AriGraphSortOrderInput.DESC;
        case $8893b993517b1a81$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $8893b993517b1a81$var$AriGraphSortOrderInput.ASC;
        default:
            return defaultValue;
    }
};
const $8893b993517b1a81$var$getInverseSortValue = (sortOrder)=>({
        priority: 2,
        direction: $8893b993517b1a81$var$parseInverseSortDirection(sortOrder, $8893b993517b1a81$var$AriGraphSortOrderInput.ASC)
    });
const $8893b993517b1a81$var$getGraphStoreSortFromQueryParams = (parsedQueryParams)=>({
        lastModified: {
            priority: 1,
            direction: $8893b993517b1a81$var$AriGraphSortOrderInput.DESC
        },
        ...$8893b993517b1a81$var$STATUS_SORT_KEY === parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_SORT_BY] ? {
            to_status: $8893b993517b1a81$var$getSortValue(parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$8893b993517b1a81$var$PRIORITY_SORT_KEY === parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_SORT_BY] ? {
            to_priority: $8893b993517b1a81$var$getInverseSortValue(parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$8893b993517b1a81$var$CREATED_SORT_KEY === parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_SORT_BY] ? {
            createdAt: $8893b993517b1a81$var$getSortValue(parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER])
        } : {}
    });

const $8893b993517b1a81$export$a59477eea6e8cd7f = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("eRmFC")).then((mod)=>mod.IncidentsPageWrapper), {
        moduleId: "5b8b4ff7"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $5b808c300e9a0435$export$2e2bcd8739ae039,
                    variables: {
                        incidentPageSize: 30,
                        servicePageSize: 30,
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        filter: $8893b993517b1a81$var$getGqlFiltersFromQueryParams($8893b993517b1a81$var$parseQueryParams(context.query)),
                        sort: $8893b993517b1a81$var$getGraphStoreSortFromQueryParams($8893b993517b1a81$var$parseQueryParams(context.query)),
                        siteAri: `ari:cloud:jira::site/${cloudId}`
                    }
                }
            }
        })
});


/**
 * @generated SignedSource<<7699704d0995bbdc63133dc84290d5de>>
 * @relayHash bf929c95e6738104436e6a3b1e6f48cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf
const $415b79d5341f9d0c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "associatedComponents"
                    ]
                }
            ]
        },
        "name": "srcIncidentsLinkedServicesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $415b79d5341f9d0c$export$2e2bcd8739ae039 = $415b79d5341f9d0c$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $4c5fd999dd41f067$export$a59477eea6e8cd7f = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("ekzJW")).then((mod)=>mod.IncidentsPageLinkedServicesWrapper), {
        moduleId: "d6132459"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $415b79d5341f9d0c$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});



var $soOXK = parcelRequire("soOXK");
const $f7ee2b416e224377$var$entryPointDeprecated = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $4c5fd999dd41f067$export$a59477eea6e8cd7f),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $f7ee2b416e224377$var$entryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $8893b993517b1a81$export$a59477eea6e8cd7f),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $f7ee2b416e224377$export$fd29243dbe4103 = (0, $bMm60.createEntry)((0, $2ab19c36cf374220$export$12e1ca6c7cfdfd49), {
    entryPoint () {
        return (0, $1ybV0.ff)('corex-operandi-incidents-page-in-jira_5ebja') ? $f7ee2b416e224377$var$entryPoint : $f7ee2b416e224377$var$entryPointDeprecated;
    },
    layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
    skeleton: (0, $1hTYf.IncidentsPageSkeleton),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $3vlQh.incidentsInitialPageChecksResource),
        (0, $3vlQh.incidentsCustomFieldIdResource)
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES_SOFTWARE_INCIDENTS),
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_SOFTWARE_INCIDENTS)),
            teamName: 'operandi'
        }
    },
    ufoName: 'software-incidents'
});
const $f7ee2b416e224377$export$c7d98bfe75274932 = (0, $bMm60.createEntry)((0, $2ab19c36cf374220$export$3356a7870a2717f4), {
    entryPoint () {
        return (0, $1ybV0.ff)('corex-operandi-incidents-page-in-jira_5ebja') ? $f7ee2b416e224377$var$entryPoint : $f7ee2b416e224377$var$entryPointDeprecated;
    },
    layout: (0, $soOXK.classicSoftwareProjectLayout),
    skeleton: (0, $1hTYf.IncidentsPageSkeleton),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $2Fzrk.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $3vlQh.incidentsInitialPageChecksResource),
        (0, $3vlQh.incidentsCustomFieldIdResource)
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC)),
            teamName: 'operandi'
        }
    },
    ufoName: 'software-incidents'
});



var $dfBCt = parcelRequire("dfBCt");

var $cernH = parcelRequire("cernH");


var $bmKiO = parcelRequire("bmKiO");

var $dnJL9 = parcelRequire("dnJL9");

var $d1szd = parcelRequire("d1szd");


var $7vTKl = parcelRequire("7vTKl");

var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $5oyzN = parcelRequire("5oyzN");

var $0fOjG = parcelRequire("0fOjG");

var $a5edq = parcelRequire("a5edq");

var $hHrVM = parcelRequire("hHrVM");

var $gyys9 = parcelRequire("gyys9");

var $3MEW8 = parcelRequire("3MEW8");

var $ioEMP = parcelRequire("ioEMP");

var $jwzNs = parcelRequire("jwzNs");


var $dgH3j = parcelRequire("dgH3j");

var $4PVYj = parcelRequire("4PVYj");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $59o4i = parcelRequire("59o4i");

const $7ba63b5e616f6f5c$export$2164de18d39af313 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("3rNwL")), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
});

const $7ba63b5e616f6f5c$export$bcc6315cf211edab = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("chPFS")), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});

const $7ba63b5e616f6f5c$export$a1c59527bd5131cc = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("uz1ju")).then((module)=>module.BoardConfigSwitcher), {
    moduleId: "./src/packages/router-routes/software/classic/board-settings/switcher/entries/src/index.tsx"
});
const $7ba63b5e616f6f5c$export$4ceb6cf2934825b2 = (props)=>{
    const { route: route, query: query, match: match } = props;
    const basePageId = route && route.name || 'rapid-board';
    const chartParam = query.chart ? `-${query.chart}` : '';
    const boardId = query.rapidView ?? match.params.boardId;
    const pageId = `${basePageId}-${boardId}${chartParam}`;
    if ([
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BOARD)
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7ba63b5e616f6f5c$export$2164de18d39af313,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ([
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED)
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7ba63b5e616f6f5c$export$bcc6315cf211edab,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ((0, $1ybV0.ff)('simplified-boards-milestone-2_07hbk') && [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BOARD),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED)
    ].includes(route.name) && query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7ba63b5e616f6f5c$export$a1c59527bd5131cc,
        pageId: pageId,
        shouldShowSpinner: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7ba63b5e616f6f5c$export$9de09057ba255cc4,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

const $7ba63b5e616f6f5c$export$9de09057ba255cc4 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("bJkub")), {
    moduleId: "./src/packages/spa-apps/rapid-board/src/index.tsx"
});

const $7ba63b5e616f6f5c$export$bcb5bb6438a46dcb = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("8XiMb")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/wrm-bundle/get-data/index.tsx"
});

const $7ba63b5e616f6f5c$export$d4640ceb9bdd4b4 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("chLtd")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/data-api/get-data/index.tsx"
});

const $7ba63b5e616f6f5c$export$c96c36c0cbfb2c16 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("av4zI")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/config-api/get-data/index.tsx"
});

const $7ba63b5e616f6f5c$export$2ad64ed8eb98d9e = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("kXriO")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/rapidboard-resource/get-data/index.tsx"
});

const $7ba63b5e616f6f5c$export$4a8825f3e310b97 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("jAeda")), {
    moduleId: "./src/packages/entry-rapid-board-wrm-apps/src/index.tsx"
});


/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $268f6a81364c8ec2$exports = {};
$268f6a81364c8ec2$exports = new URL("classic-board-app-skeleton.tpl.bf1c26f5.svg", import.meta.url).toString();


const $e97d2ead64a3cd9f$var$customCssStyles = null;
const $e97d2ead64a3cd9f$export$631611c5fdf027d5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($268f6a81364c8ec2$exports))),
        className: (0, $7JEyt.default)([
            "_2zz1idpf"
        ])
    });



var $bEe6y = parcelRequire("bEe6y");
/**
 * Ordinarily it would be inadvisable to evaluate something like this in
 * a static route, as this could lead to inconsistent behaviour between
 * the server and the browser.
 *
 * In this case it is necessary and safe because:
 * 1) There are two versions of the board that share the same route
 *    and we can only tell them apart at runtime. When the old version
 *    is eventually removed, this should be cleaned up.
 * 2) No requests for board data are made on the server, so even
 *    if the value is incorrect on the server it won't be utilised
 * */ const $e679ac321a72d2f6$var$classicBoardCapability = !false ? (0, $d07297a4af13004b$export$664edf77d4c76110) : (0, $d07297a4af13004b$export$fc5f182fc9019b1c);
const $e679ac321a72d2f6$export$f2cd114cf8ab53aa = (0, $bMm60.createEntry)((0, $4PVYj.classicSoftwareBoardRoute), {
    component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
    skeleton: (0, $e97d2ead64a3cd9f$export$631611c5fdf027d5),
    layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue',
                'view=detail'
            ]
        },
        {
            query: [
                'selectedIssue',
                'modal=detail'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.classicBoardSidebars),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $a5edq.getRapidboardResources)(),
        (0, $a5edq.getRapidBoardDataResource)(),
        (0, $jwzNs.resourceWithCondition2)((0, $a5edq.shouldLoadUIFBoardResources), (0, $ioEMP.uifBoardResource)),
        // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $a5edq.shouldLoadUIFBoardResources)() && !(0, $dfBCt.isFedRamp)(), (0, $gyys9.nextBestTaskFeatureResource)),
        (0, $0fOjG.getEditModelResource)(),
        (0, $5oyzN.getBoardDetailsResource)()
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7ba63b5e616f6f5c$export$2164de18d39af313)
    ],
    preloadOptions: {
        earlyChunks: [
            'rapidboard-early-entry'
        ]
    },
    meta: {
        capability: $e679ac321a72d2f6$var$classicBoardCapability
    },
    earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
});
const $e679ac321a72d2f6$export$b5558b683e9c45a4 = (0, $bMm60.createEntry)((0, $4PVYj.classicSoftwareBoardEmbedRoute), {
    component: (0, $dnJL9.componentWithFG)('jira_board_smartlink_embed', (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2), (0, $dgH3j.default)),
    layout: (0, $isbb2.createLayout)({
        isChromeless: true
    }),
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $a5edq.getRapidboardResources)(),
        (0, $a5edq.getRapidBoardDataResource)(),
        (0, $jwzNs.resourceWithCondition2)((0, $a5edq.shouldLoadUIFBoardResources), (0, $ioEMP.uifBoardResource)),
        // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $a5edq.shouldLoadUIFBoardResources)() && !(0, $dfBCt.isFedRamp)(), (0, $gyys9.nextBestTaskFeatureResource)),
        (0, $0fOjG.getEditModelResource)(),
        (0, $5oyzN.getBoardDetailsResource)(),
        (0, $3MEW8.themePreferenceResource)
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $7ba63b5e616f6f5c$export$2164de18d39af313)
    ],
    meta: {
        capability: $e679ac321a72d2f6$var$classicBoardCapability
    }
});



var $dXIya = parcelRequire("dXIya");

var $cernH = parcelRequire("cernH");

var $dCvLw = parcelRequire("dCvLw");


var $bmKiO = parcelRequire("bmKiO");

var $bAQOb = parcelRequire("bAQOb");

var $dnJL9 = parcelRequire("dnJL9");

var $d1szd = parcelRequire("d1szd");


var $7vTKl = parcelRequire("7vTKl");

var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $5oyzN = parcelRequire("5oyzN");

var $a5edq = parcelRequire("a5edq");

var $hHrVM = parcelRequire("hHrVM");


var $exb0h = parcelRequire("exb0h");
const $c88d39e9a52c0785$export$9e1d275c8078512e = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
    query: [
        'config=insightsConfig'
    ]
};
const $c88d39e9a52c0785$export$8163d70aae333a78 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId',
    query: [
        'config=insightsConfig'
    ]
};





var $7msR2 = parcelRequire("7msR2");

var $bEe6y = parcelRequire("bEe6y");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $4c35f34b12fea73f$export$810ecaba1eb55cad = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("2b3mr")).then((module)=>module.InsightsSettingsCMPPageLoader), {
    moduleId: "./src/packages/spa-apps/project-settings/classic-board-settings/insights/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4c35f34b12fea73f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4c35f34b12fea73f$export$810ecaba1eb55cad,
        pageId: "classic-board-settings-insights",
        shouldShowSpinner: false
    });



var $1fF9e = parcelRequire("1fF9e");

var $lB25E = parcelRequire("lB25E");
const $4edc23cecc022916$export$f7bc2c5799e41684 = ()=>{
    const { setSelectedConfigTab: setSelectedConfigTab } = (0, $1fF9e.useSelectedConfigTab)();
    const [, setConfigParam] = (0, $lB25E.useQueryParam)('config');
    setSelectedConfigTab('filter');
    setConfigParam('filter');
    return null;
};


const $519a2e4aeaff06bf$export$4bab4a9393eceb86 = [
    (0, $bMm60.createEntry)((0, $c88d39e9a52c0785$export$9e1d275c8078512e), {
        ufoName: 'rapidboard-backlog-insights',
        component: (0, $dnJL9.componentWithFG)('remove_jsw_insights_settings_ui', (0, $4edc23cecc022916$export$f7bc2c5799e41684), (0, $bAQOb.componentWithFF)('simplified-boards-milestone-2_07hbk', (0, $4c35f34b12fea73f$export$2e2bcd8739ae039), (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2))),
        skeleton: (0, $7msR2.NextGenBacklogSkeleton),
        layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            (0, $a5edq.getRapidBoardDataResource)(),
            (0, $dCvLw.insightsBoardSettingsResource),
            (0, $dXIya.issueHierarchyPageResource),
            (0, $5oyzN.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
            (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97),
            (0, $7ba63b5e616f6f5c$export$d4640ceb9bdd4b4),
            (0, $7ba63b5e616f6f5c$export$c96c36c0cbfb2c16),
            (0, $7ba63b5e616f6f5c$export$bcb5bb6438a46dcb),
            (0, $7ba63b5e616f6f5c$export$2ad64ed8eb98d9e)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $d07297a4af13004b$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }),
    (0, $bMm60.createEntry)((0, $c88d39e9a52c0785$export$8163d70aae333a78), {
        ufoName: 'rapidboard-board-insights',
        component: (0, $dnJL9.componentWithFG)('remove_jsw_insights_settings_ui', (0, $4edc23cecc022916$export$f7bc2c5799e41684), (0, $bAQOb.componentWithFF)('simplified-boards-milestone-2_07hbk', (0, $4c35f34b12fea73f$export$2e2bcd8739ae039), (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2))),
        skeleton: (0, $e97d2ead64a3cd9f$export$631611c5fdf027d5),
        layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            (0, $a5edq.getRapidBoardDataResource)(),
            (0, $dCvLw.insightsBoardSettingsResource),
            (0, $dXIya.issueHierarchyPageResource),
            (0, $5oyzN.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
            (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97),
            (0, $7ba63b5e616f6f5c$export$d4640ceb9bdd4b4),
            (0, $7ba63b5e616f6f5c$export$c96c36c0cbfb2c16),
            (0, $7ba63b5e616f6f5c$export$bcb5bb6438a46dcb),
            (0, $7ba63b5e616f6f5c$export$2ad64ed8eb98d9e)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $d07297a4af13004b$export$fc5f182fc9019b1c)
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    })
];



var $cernH = parcelRequire("cernH");


var $bmKiO = parcelRequire("bmKiO");

var $d1szd = parcelRequire("d1szd");


var $7vTKl = parcelRequire("7vTKl");

var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $a5edq = parcelRequire("a5edq");

var $hHrVM = parcelRequire("hHrVM");


var $exb0h = parcelRequire("exb0h");
const $60358381106e6884$export$8163d70aae333a78 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD),
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView'
    ]
};





var $bEe6y = parcelRequire("bEe6y");
const $8bf5c03d336a3972$export$4a5b9e48e40676ad = (0, $bMm60.createEntry)((0, $60358381106e6884$export$8163d70aae333a78), {
    ufoName: 'classic-board',
    component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
    skeleton: (0, $e97d2ead64a3cd9f$export$631611c5fdf027d5),
    layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue',
                'view=detail'
            ]
        },
        {
            query: [
                'selectedIssue',
                'modal=detail'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.classicBoardSidebars),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $a5edq.getRapidboardResources)(),
        (0, $a5edq.getRapidBoardDataResource)(),
        ...(0, $hHrVM.getUserBoardNavigationResources)()
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
        (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97)
    ],
    preloadOptions: {
        earlyChunks: [
            'rapidboard-early-entry'
        ]
    },
    meta: {
        capability: (0, $d07297a4af13004b$export$fc5f182fc9019b1c)
    },
    earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
});



var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $9zysr = parcelRequire("9zysr");

var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $ezjOd = parcelRequire("ezjOd");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $00ae6a6eca65f558$export$3ba8dd9a7886e7d = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
    path: '/jira/software/projects/:projectKey/deployments'
};
const $00ae6a6eca65f558$export$485e4a7b82f29d70 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/deployments'
};



var $yyqSx = parcelRequire("yyqSx");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");


var $59o4i = parcelRequire("59o4i");

const $e7eb7b8d4a88bad8$export$ed6d152d5551715c = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("fjWga"))), {
    moduleId: "./src/packages/spa-apps/deployments/src/index.tsx"
});
const $e7eb7b8d4a88bad8$export$35822a21682c5ed8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e7eb7b8d4a88bad8$export$ed6d152d5551715c,
        pageId: "deploymentsNextGen",
        shouldShowSpinner: true
    });
const $e7eb7b8d4a88bad8$export$7361c0feb3154afe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e7eb7b8d4a88bad8$export$ed6d152d5551715c,
        pageId: "deploymentsClassic",
        shouldShowSpinner: true
    });
const $e7eb7b8d4a88bad8$export$7e5ccb20ad8e1612 = (0, $bMm60.createEntry)((0, $00ae6a6eca65f558$export$3ba8dd9a7886e7d), {
    component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), $e7eb7b8d4a88bad8$export$35822a21682c5ed8),
    layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ezjOd.deploymentPreconditionRelayResource),
        (0, $ixwgj.projectContextResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e7eb7b8d4a88bad8$export$ed6d152d5551715c
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS)),
            teamName: 'fusion-solaris'
        }
    }
});
const $e7eb7b8d4a88bad8$export$dcf1f9ba660dedf6 = (0, $bMm60.createEntry)((0, $00ae6a6eca65f558$export$485e4a7b82f29d70), {
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ezjOd.deploymentPreconditionRelayResource),
        (0, $ixwgj.projectContextResource)
    ],
    component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), $e7eb7b8d4a88bad8$export$7361c0feb3154afe),
    layout: (0, $soOXK.classicSoftwareProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $2Fzrk.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e7eb7b8d4a88bad8$export$ed6d152d5551715c
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC)),
            teamName: 'fusion-solaris'
        }
    }
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $7ed88a990676bb78$export$2076234d7fde1717 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("8GNim")), {
    moduleId: "./src/packages/spa-apps/software/form-builder/src/index.tsx"
});
const $7ed88a990676bb78$export$a4c73b2a16981930 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7ed88a990676bb78$export$2076234d7fde1717,
        pageId: "async-software-form-builder",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $70fff4c2dbe9dc25$export$240a58749ebba091 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("1iKNe")), {
    moduleId: "./src/packages/spa-apps/software/form/src/index.tsx"
});
const $70fff4c2dbe9dc25$export$7234abc5d81adb58 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $70fff4c2dbe9dc25$export$240a58749ebba091,
        pageId: "async-software-form",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $da107422e9535dbb$export$258fcd204933dd75 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("lSBiK")), {
    moduleId: "./src/packages/spa-apps/software/form-submit/src/index.tsx"
});
const $da107422e9535dbb$export$4258f48cc65dca00 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $da107422e9535dbb$export$258fcd204933dd75,
        pageId: "async-software-form-submit",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $6VZoe = parcelRequire("6VZoe");

var $dfBCt = parcelRequire("dfBCt");

var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $9zysr = parcelRequire("9zysr");

var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $iHeQd = parcelRequire("iHeQd");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $f052054c3d32cff3$export$7e7b18da5d3ceba0 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PERISCOPE),
    path: '/jira/software/projects/:projectKey/development'
};
const $f052054c3d32cff3$export$cb5cec74f302b3c6 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/development'
};



var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");


var $59o4i = parcelRequire("59o4i");

const $aefe7ae0a443cf30$export$9c25b4571a88e1f = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("gLCMH"))), {
    moduleId: "./src/packages/spa-apps/periscope/src/index.tsx"
});
const $aefe7ae0a443cf30$export$d86ed8d2756a4d4d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $aefe7ae0a443cf30$export$9c25b4571a88e1f,
        pageId: "softwarePeriscopeNextGen",
        shouldShowSpinner: true
    });
const $aefe7ae0a443cf30$export$fd5920cadc24919d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $aefe7ae0a443cf30$export$9c25b4571a88e1f,
        pageId: "softwarePeriscopeClassic",
        shouldShowSpinner: true
    });
const $aefe7ae0a443cf30$export$7db4d910357a4d89 = (0, $bMm60.createEntry)((0, $f052054c3d32cff3$export$7e7b18da5d3ceba0), {
    component: (0, $9zysr.componentWithCondition)((0, $dfBCt.isFedRamp), (0, $dgH3j.default), $aefe7ae0a443cf30$export$d86ed8d2756a4d4d),
    skeleton: (0, $iHeQd.Skeleton),
    layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $aefe7ae0a443cf30$export$9c25b4571a88e1f
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PERISCOPE),
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_SOFTWARE_PERISCOPE)),
            teamName: 'nova'
        }
    }
});
const $aefe7ae0a443cf30$export$d7d49c1a51b3c0a9 = (0, $bMm60.createEntry)((0, $f052054c3d32cff3$export$cb5cec74f302b3c6), {
    skeleton: (0, $iHeQd.Skeleton),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource)
    ],
    component: (0, $9zysr.componentWithCondition)((0, $dfBCt.isFedRamp), (0, $dgH3j.default), $aefe7ae0a443cf30$export$fd5920cadc24919d),
    layout: (0, $soOXK.classicSoftwareProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $2Fzrk.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $aefe7ae0a443cf30$export$9c25b4571a88e1f
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC)),
            teamName: 'nova'
        }
    }
});



var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $2ijRB = parcelRequire("2ijRB");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $drG7D = parcelRequire("drG7D");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $41e02700420f2857$export$3a4d4ecb82e1bfc8 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY),
    path: '/jira/software/projects/:projectKey/security'
};
const $41e02700420f2857$export$b7285748f1151353 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/security'
};



var $yyqSx = parcelRequire("yyqSx");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");


var $59o4i = parcelRequire("59o4i");
const $c13ea8e6d002db74$var$isSecurityPageEnabled = ()=>!(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && ((0, $1ybV0.ff)('corex-isotopes-security-page-in-jira_h0ex9') || (0, $eI5EY.fg)('isotopes-security-page-in-jira-enabled-v2'));

const $c13ea8e6d002db74$export$30c10c4b0cb1d8e3 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("kaFCx"))), {
    moduleId: "./src/packages/spa-apps/security/src/index.tsx"
});
const $c13ea8e6d002db74$export$c6cc344ea309349a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c13ea8e6d002db74$export$30c10c4b0cb1d8e3,
        pageId: "securityNextGen",
        shouldShowSpinner: true
    });
const $c13ea8e6d002db74$export$b4dc9ba40afbdd9f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c13ea8e6d002db74$export$30c10c4b0cb1d8e3,
        pageId: "securityClassic",
        shouldShowSpinner: true
    });
const $c13ea8e6d002db74$export$a8dcfae475505e7a = (0, $bMm60.createEntry)((0, $41e02700420f2857$export$3a4d4ecb82e1bfc8), {
    component: (0, $2ijRB.default)($c13ea8e6d002db74$var$isSecurityPageEnabled, $c13ea8e6d002db74$export$c6cc344ea309349a, (0, $dgH3j.default)),
    layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
    ufoName: 'software-security-combined',
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $drG7D.securityPageResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $c13ea8e6d002db74$export$30c10c4b0cb1d8e3
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY),
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY)),
            teamName: 'fusion-isotopes'
        }
    }
});
const $c13ea8e6d002db74$export$8acfebad16c9d6f2 = (0, $bMm60.createEntry)((0, $41e02700420f2857$export$b7285748f1151353), {
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $drG7D.securityPageResource)
    ],
    ufoName: 'software-security-combined',
    component: (0, $2ijRB.default)($c13ea8e6d002db74$var$isSecurityPageEnabled, $c13ea8e6d002db74$export$b4dc9ba40afbdd9f, (0, $dgH3j.default)),
    layout: (0, $soOXK.classicSoftwareProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $2Fzrk.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $c13ea8e6d002db74$export$30c10c4b0cb1d8e3
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC)),
            teamName: 'fusion-isotopes'
        }
    }
});



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");


var $7vTKl = parcelRequire("7vTKl");

var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $5oyzN = parcelRequire("5oyzN");

var $0fOjG = parcelRequire("0fOjG");

var $a5edq = parcelRequire("a5edq");

var $hHrVM = parcelRequire("hHrVM");

var $ioEMP = parcelRequire("ioEMP");

var $jwzNs = parcelRequire("jwzNs");


var $eaP1H = parcelRequire("eaP1H");


var $bEe6y = parcelRequire("bEe6y");

const $f5c4f93889a21dcb$export$cde4dacc737dc0f1 = (0, $bMm60.createEntry)((0, $eaP1H.userBoardRoute), {
    component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
    skeleton: (0, $e97d2ead64a3cd9f$export$631611c5fdf027d5),
    layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue',
                'view=detail'
            ]
        },
        {
            query: [
                'selectedIssue',
                'modal=detail'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.classicBoardSidebars),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $a5edq.getRapidboardResources)(),
        (0, $a5edq.getRapidBoardDataResource)(),
        ...(0, $hHrVM.getUserBoardNavigationResources)(),
        (0, $jwzNs.resourceWithCondition2)((0, $a5edq.shouldLoadUIFBoardResources), (0, $ioEMP.uifBoardResource)),
        (0, $0fOjG.getEditModelResource)(),
        (0, $5oyzN.getBoardDetailsResource)()
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
        (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97),
        (0, $7ba63b5e616f6f5c$export$d4640ceb9bdd4b4),
        (0, $7ba63b5e616f6f5c$export$c96c36c0cbfb2c16),
        (0, $7ba63b5e616f6f5c$export$bcb5bb6438a46dcb),
        (0, $7ba63b5e616f6f5c$export$2ad64ed8eb98d9e)
    ]
});




var $atRHQ = parcelRequire("atRHQ");

var $7u7sK = parcelRequire("7u7sK");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $86afd6af3d4cff65$exports = {};
$86afd6af3d4cff65$exports = new URL("classic-report-app-skeleton.tpl.1daae66d.svg", import.meta.url).toString();


const $5d6daf8364cb9d2d$export$d7667341f4db3b8d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($86afd6af3d4cff65$exports)))
    });



var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $665d537de1c9e4c0$exports = {};
$665d537de1c9e4c0$exports = new URL("list-app-skeleton.tpl.82508714.svg", import.meta.url).toString();


var $7711ff4b474d2ced$exports = {};
$7711ff4b474d2ced$exports = new URL("list-embed-app-skeleton.tpl.de94c811.svg", import.meta.url).toString();


const $f1174c8234e7b02e$export$cbc3335f7a517046 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($665d537de1c9e4c0$exports)))
    });
const $f1174c8234e7b02e$export$2638f1c98fe91c13 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7711ff4b474d2ced$exports)))
    });



var $7msR2 = parcelRequire("7msR2");

var $841Zr = parcelRequire("841Zr");

var $yyqSx = parcelRequire("yyqSx");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");


var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $2ab85918e3df7951$export$c70b8d9ef0c891b2 = ()=>{
    const [{ query: query, match: match }] = (0, $lB25E.useRouter)();
    const queryParams = new URLSearchParams(query).toString();
    const { projectKey: projectKey, boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: {
            pathname: `/jira/software/c/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};



var $GuBa2 = parcelRequire("GuBa2");

var $kKeF6 = parcelRequire("kKeF6");

var $5fOZm = parcelRequire("5fOZm");
const $d32f691d614fbc79$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $d32f691d614fbc79$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $25bdd577c53f4e0d$export$cabb458181f7566e = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("c9qT1"))), {
    moduleId: "./src/packages/spa-apps/goals/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$25bdd577c53f4e0d$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $25bdd577c53f4e0d$export$cabb458181f7566e,
        pageId: `classic-atlas-goals-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $e4bfa5aef8b74e4b$export$a0f04dd35569e11 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("jizTM")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e4bfa5aef8b74e4b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e4bfa5aef8b74e4b$export$a0f04dd35569e11,
        pageId: "proforma-issue-forms-direct",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $0422b48ebd76799e$export$22681210aaeb910f = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("bRIfe")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0422b48ebd76799e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0422b48ebd76799e$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $f236dbf41d815051$export$84165bb08bf42eef = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("2Om9s"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/classic/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f236dbf41d815051$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f236dbf41d815051$export$84165bb08bf42eef,
        pageId: `classic-roadmap-${boardId || ''}`,
        shouldShowSpinner: false
    });
};




var $7vTKl = parcelRequire("7vTKl");

var $eI5EY = parcelRequire("eI5EY");


var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");
function $f6122116660bea23$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $f6122116660bea23$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $f6122116660bea23$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
/* Given the current constraints that prevent importing route name constants into the entrypoint,
we are re-defining these constants here in order to perform a route name check.
Consider breaking this entrypoint per route to avoid these types of checks and dependencies. */ const $f6122116660bea23$var$SOFTWARE_CALENDAR = 'software-calendar';
const $f6122116660bea23$var$SOFTWARE_CALENDAR_EMBED = 'software-calendar-embed';
const $f6122116660bea23$var$TEAM_MANAGED_CALENDAR_ROUTES = [
    $f6122116660bea23$var$SOFTWARE_CALENDAR,
    $f6122116660bea23$var$SOFTWARE_CALENDAR_EMBED
];
function $f6122116660bea23$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { cloudId: cloudId } = tenantContext;
    const isTMP = $f6122116660bea23$var$TEAM_MANAGED_CALENDAR_ROUTES.includes(context.route.name);
    return {
        type: 'board',
        boardId: $f6122116660bea23$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: isTMP ? [
            String(context.match.params.projectKey)
        ] : []
    };
}
function $f6122116660bea23$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    const scopeInput = {
        ids: [
            scope.boardId
        ]
    };
    if (scope.projectKeys && scope.projectKeys.length > 0) return {
        ...scopeInput,
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
    return scopeInput;
}
function $f6122116660bea23$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $f6122116660bea23$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $f6122116660bea23$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $f6122116660bea23$var$toMidnightUTCString(selectedDate),
        mode: $f6122116660bea23$var$toViewMode(viewRange),
        weekStart: $f6122116660bea23$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField
    };
}
function $f6122116660bea23$var$buildIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $f6122116660bea23$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $f6122116660bea23$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $f6122116660bea23$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}

const $f6122116660bea23$export$19cf4b398f638dc6 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("1Bxc8")), {
        moduleId: "57ee20a5"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $f6122116660bea23$var$createScope(entryPointRouteParams);
        const { date: date } = context.query;
        const selectedDate = $f6122116660bea23$var$toDate(date);
        const boardId = String(context.match.params.boardId);
        const viewRange = 'month';
        const weekStartsOn = 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $ae4d1c21cb10f5ab$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $f6122116660bea23$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $f6122116660bea23$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesSearchInput: $f6122116660bea23$var$buildIssuesSearchInput(),
                        unscheduledIssuesSearchInput: $f6122116660bea23$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $f6122116660bea23$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $f6122116660bea23$var$buildSprintsSearchInput(),
                        skipSprintSearch: false,
                        skipVersionSearch: false,
                        viewId: null,
                        schedulePermissionsEnabled: (0, $eI5EY.fg)('calendar_schedule_issue_permissions_check')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                boardId: boardId
            }
        };
    }
});


const $9365a5bd739debe9$export$83b1b9036cc7961a = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $f6122116660bea23$export$19cf4b398f638dc6),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

var $53ciZ = parcelRequire("53ciZ");
const $7c06835a2dbad5f3$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search);
    return rapidView;
};



const $034dff1bd145500a$export$4beafd9dbad29bff = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("h9URe"))), {
    moduleId: "./src/packages/spa-apps/code/src/index.tsx"
});

const $034dff1bd145500a$export$faa081cb222383ac = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("6qRbE")), {
    moduleId: "./src/packages/spa-apps/business/jsw-list/src/index.tsx"
});

const $034dff1bd145500a$export$ce40123d7c2e29e7 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("8D7jN")), {
    moduleId: "./src/packages/spa-apps/business/jsw-list-embed/src/index.tsx"
});
const $034dff1bd145500a$export$d9e8184332f86b53 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $034dff1bd145500a$export$4beafd9dbad29bff,
        pageId: `next-gen-code-${(0, $7c06835a2dbad5f3$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
const $034dff1bd145500a$export$95e2389b7ca7ccf2 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $034dff1bd145500a$export$4beafd9dbad29bff,
        pageId: `classic-code-${(0, $7c06835a2dbad5f3$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
const $034dff1bd145500a$export$422a3a028ae77ad3 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $034dff1bd145500a$export$faa081cb222383ac,
        pageId: `software-${(0, $7c06835a2dbad5f3$export$557c2f222778cea6)({
            location: location,
            match: match
        })}-list`,
        shouldShowSpinner: true
    });
const $034dff1bd145500a$export$4a0539d19a2e2694 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $034dff1bd145500a$export$ce40123d7c2e29e7,
        pageId: `software-${(0, $7c06835a2dbad5f3$export$557c2f222778cea6)({
            location: location,
            match: match
        })}-list-embed`,
        shouldShowSpinner: true
    });




var $7vTKl = parcelRequire("7vTKl");


var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");
const $f1fff89849bb73a7$var$FORMAT_RULES_FIRST = 20;

const $f1fff89849bb73a7$export$6be4f10150ff6073 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("6qRbE")), {
        moduleId: "a7ba8596"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                formattingRulesQuery: {
                    parameters: $3abbc310e35c2066$export$2e2bcd8739ae039,
                    variables: {
                        projectKey: projectKey,
                        cloudId: tenantContext.cloudId,
                        first: $f1fff89849bb73a7$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'network-only'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});


const $37428a0d3257d57d$export$f30a66efa682bf2d = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $f1fff89849bb73a7$export$6be4f10150ff6073),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $ec8985514c6b606d$export$956f830ed027f1fb = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("4hDuf")), {
    moduleId: "./src/packages/spa-apps/cycle-time-report/src/index.tsx"
});
const $ec8985514c6b606d$export$e16ce0656a74a015 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ec8985514c6b606d$export$956f830ed027f1fb,
        pageId: "cycleTimeReportNextGen",
        shouldShowSpinner: true
    });
const $ec8985514c6b606d$export$237924ba64065cc3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ec8985514c6b606d$export$956f830ed027f1fb,
        pageId: "cycleTimeReportClassic",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $04403e5f90f4354e$export$5113b2b19ec1fb53 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("itkhw")), {
    moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
});
const $04403e5f90f4354e$export$e2db9c7426cdb53 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $04403e5f90f4354e$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportNextGen",
        shouldShowSpinner: true
    });
const $04403e5f90f4354e$export$655707e8ae1053d3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $04403e5f90f4354e$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportClassic",
        shouldShowSpinner: true
    });



const $20af5c394dfc25a4$export$edb4b8cf67d7d767 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("chPFS"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});
const $20af5c394dfc25a4$var$ProjectsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/projects"
    });
/**
 * Ordinarily it would be inadvisable to evaluate something like this in
 * a static route, as this could lead to inconsistent behaviour between
 * the server and the browser.
 *
 * In this case it is necessary and safe because:
 * 1) There are two versions of the backlog that share the same route
 *    and we can only tell them apart at runtime. When the old version
 *    is eventually removed, this should be cleaned up.
 * 2) No requests for backlog data are made on the server, so even
 *    if the value is incorrect on the server it won't be utilised
 * */ const $20af5c394dfc25a4$var$classicBacklogCapability = !false ? (0, $d07297a4af13004b$export$571692eec8a399e1) : (0, $d07297a4af13004b$export$93104dc4eba58ba4);
const $20af5c394dfc25a4$export$5b4e616b6b4b672a = [
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareRoadmapClassicRoute), {
        component: (0, $2ab85918e3df7951$export$c70b8d9ef0c891b2),
        skeleton: (0, $841Zr.RoadmapSkeleton),
        layout: (0, $isbb2.composeLayouts)((0, $soOXK.classicSoftwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $lY9wZ.classicRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f236dbf41d815051$export$84165bb08bf42eef)
        ],
        ufoName: 'classic-roadmap'
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareTimelineClassicRoute), {
        component: (0, $f236dbf41d815051$export$2e2bcd8739ae039),
        skeleton: (0, $841Zr.RoadmapSkeleton),
        layout: (0, $isbb2.composeLayouts)((0, $soOXK.classicSoftwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $lY9wZ.classicRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f236dbf41d815051$export$84165bb08bf42eef)
        ],
        ufoName: 'classic-roadmap'
    }),
    // This route need to be before backlog and board route
    ...(0, $519a2e4aeaff06bf$export$4bab4a9393eceb86),
    (0, $bMm60.createEntry)((0, $4pu9Z.rapidboardBacklogEmbedRoute), {
        ufoName: 'classic-backlog-embed',
        component: (0, $dnJL9.componentWithFG)('enable_backlog_smartlink_route', (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2), (0, $dgH3j.default)),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        resources: [
            ...(0, $a5edq.getUIFBacklogDataResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $a5edq.getRapidBoardDataResource)(),
            (0, $0fOjG.getEditModelResource)(),
            (0, $5oyzN.getBoardDetailsResource)(),
            (0, $3MEW8.themePreferenceResource)
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            $20af5c394dfc25a4$export$edb4b8cf67d7d767
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: $20af5c394dfc25a4$var$classicBacklogCapability
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.rapidboardBacklogRoute), {
        ufoName: 'classic-backlog',
        component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
        skeleton: (0, $7msR2.NextGenBacklogSkeleton),
        layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getUIFBacklogDataResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            (0, $a5edq.getRapidBoardDataResource)(),
            (0, $0fOjG.getEditModelResource)(),
            (0, $5oyzN.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $20af5c394dfc25a4$export$edb4b8cf67d7d767
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: $20af5c394dfc25a4$var$classicBacklogCapability
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareCalendarClassicEmbedRoute), {
        skeleton: (0, $7u7sK.CalendarEmbedSkeleton),
        component: (0, $7u7sK.CalendarEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $9365a5bd739debe9$export$83b1b9036cc7961a;
        },
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        resources: [
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $3MEW8.themePreferenceResource)
        ],
        ufoName: 'classic-calendar-embed'
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareCalendarClassicRoute), {
        skeleton: (0, $7u7sK.CalendarSkeleton),
        component: (0, $7u7sK.CalendarSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $9365a5bd739debe9$export$83b1b9036cc7961a;
        },
        layout: (0, $isbb2.composeLayouts)((0, $soOXK.classicSoftwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ],
        ufoName: 'classic-calendar'
    }),
    // This route is owned by JWM Keystone team
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareListEmbedClassicRoute), {
        component: (0, $9zysr.componentWithCondition)(()=>(0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $034dff1bd145500a$export$4a0539d19a2e2694), (0, $dgH3j.default)),
        skeleton: (0, $f1174c8234e7b02e$export$2638f1c98fe91c13),
        entryPoint () {
            return (0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, $37428a0d3257d57d$export$f30a66efa682bf2d) : undefined;
        },
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        resources: (0, $4qvmP.getProjectViewResources)(),
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $034dff1bd145500a$export$ce40123d7c2e29e7)
        ],
        ufoName: 'classic-list-embed'
    }),
    // This route is owned by JWM Keystone team
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareListClassicRoute), {
        component: (0, $9zysr.componentWithCondition)(()=>(0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $034dff1bd145500a$export$422a3a028ae77ad3), (0, $dgH3j.default)),
        skeleton: (0, $f1174c8234e7b02e$export$cbc3335f7a517046),
        entryPoint () {
            return (0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, $37428a0d3257d57d$export$f30a66efa682bf2d) : undefined;
        },
        layout: (0, $isbb2.composeLayouts)((0, $soOXK.classicSoftwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $034dff1bd145500a$export$faa081cb222383ac)
        ],
        ufoName: 'classic-list'
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.rapidboardReportRoute), {
        component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
        skeleton: (0, $5d6daf8364cb9d2d$export$d7667341f4db3b8d),
        layout: (0, $d1szd.genericProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            ...(0, $d32f691d614fbc79$export$8cb713295e6b7204)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
            (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report'
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareReportsCycleTimeClassicRoute), {
        component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $ec8985514c6b606d$export$237924ba64065cc3)),
        layout: (0, $d1szd.genericProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d32f691d614fbc79$export$8cb713295e6b7204)(),
            (0, $gar3N.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $ec8985514c6b606d$export$956f830ed027f1fb)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ec8985514c6b606d$export$956f830ed027f1fb)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC)),
                teamName: 'fusion-solaris'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareFormBuilderClassicRoute), {
        ufoName: 'classic-form-builder',
        component: (0, $dnJL9.componentWithFG)('jwm_forms_to_jsw', (0, $7ed88a990676bb78$export$a4c73b2a16981930), (0, $dgH3j.default)),
        layout: (0, $soOXK.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $aeIT6.projectDetailsResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7ed88a990676bb78$export$2076234d7fde1717)
        ],
        afterPaint: [
            (0, $da107422e9535dbb$export$258fcd204933dd75)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareFormSubmitClassicRoute), {
        ufoName: 'classic-form-submit',
        component: (0, $dnJL9.componentWithFG)('jwm_forms_to_jsw', (0, $da107422e9535dbb$export$4258f48cc65dca00), (0, $dgH3j.default)),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $aeIT6.projectDetailsResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $da107422e9535dbb$export$258fcd204933dd75)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareFormClassicRoute), {
        ufoName: 'classic-form',
        component: (0, $dnJL9.componentWithFG)('jwm_forms_to_jsw', (0, $70fff4c2dbe9dc25$export$7234abc5d81adb58), (0, $dgH3j.default)),
        layout: (0, $soOXK.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $aeIT6.projectDetailsResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $70fff4c2dbe9dc25$export$240a58749ebba091)
        ],
        afterPaint: [
            (0, $7ed88a990676bb78$export$2076234d7fde1717)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareGoalsClassicRoute), {
        component: (0, $25bdd577c53f4e0d$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)()
        ]
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareClassicProformaIssueFormsDirectRoute), {
        component: (0, $e4bfa5aef8b74e4b$export$2e2bcd8739ae039),
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $e4bfa5aef8b74e4b$export$a0f04dd35569e11)
        ],
        perfMetricKey: 'issue-forms-direct'
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareClassicProformaIssueFormsDirectEmbedRoute), {
        component: (0, $0422b48ebd76799e$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        forPaint: [
            (0, $0422b48ebd76799e$export$22681210aaeb910f)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareReportsDeploymentFrequencyClassicRoute), {
        component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $04403e5f90f4354e$export$655707e8ae1053d3)),
        layout: (0, $d1szd.genericProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d32f691d614fbc79$export$8cb713295e6b7204)(),
            (0, $gar3N.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $04403e5f90f4354e$export$5113b2b19ec1fb53)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $04403e5f90f4354e$export$5113b2b19ec1fb53)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC)),
                teamName: 'fusion-solaris'
            }
        }
    }),
    (0, $e679ac321a72d2f6$export$b5558b683e9c45a4),
    (0, $e679ac321a72d2f6$export$f2cd114cf8ab53aa),
    (0, $bMm60.createEntry)((0, $4pu9Z.rapidboardUserBacklogRoute), {
        component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
        skeleton: (0, $7msR2.NextGenBacklogSkeleton),
        layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getUIFBacklogDataResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            (0, $a5edq.getRapidBoardDataResource)(),
            ...(0, $hHrVM.getUserBoardNavigationResources)(),
            (0, $0fOjG.getEditModelResource)(),
            (0, $5oyzN.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $20af5c394dfc25a4$export$edb4b8cf67d7d767
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: $20af5c394dfc25a4$var$classicBacklogCapability
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.rapidboardUserReportRoute), {
        component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
        skeleton: (0, $5d6daf8364cb9d2d$export$d7667341f4db3b8d),
        layout: (0, $d1szd.genericProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            ...(0, $d32f691d614fbc79$export$8cb713295e6b7204)(),
            ...(0, $hHrVM.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
            (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }),
    (0, $f5c4f93889a21dcb$export$cde4dacc737dc0f1),
    (0, $bMm60.createEntry)((0, $4pu9Z.rapidboardBacklog1Route), {
        ufoName: 'classic-backlog',
        component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
        skeleton: (0, $7msR2.NextGenBacklogSkeleton),
        layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            (0, $a5edq.getRapidBoardDataResource)(),
            ...(0, $hHrVM.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
            (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $d07297a4af13004b$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.rapidboardReport1Route), {
        component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
        skeleton: (0, $5d6daf8364cb9d2d$export$d7667341f4db3b8d),
        layout: (0, $d1szd.genericProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            ...(0, $d32f691d614fbc79$export$8cb713295e6b7204)(),
            ...(0, $hHrVM.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
            (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report'
    }),
    (0, $8bf5c03d336a3972$export$4a5b9e48e40676ad),
    (0, $bMm60.createEntry)((0, $4pu9Z.softwareCodeClassicRoute), {
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $5GEOG.codePageResource)
        ],
        component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $034dff1bd145500a$export$95e2389b7ca7ccf2)),
        layout: (0, $soOXK.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $034dff1bd145500a$export$4beafd9dbad29bff)
        ]
    }),
    (0, $c13ea8e6d002db74$export$8acfebad16c9d6f2),
    (0, $e7eb7b8d4a88bad8$export$dcf1f9ba660dedf6),
    (0, $aefe7ae0a443cf30$export$d7d49c1a51b3c0a9),
    (0, $bMm60.createEntry)((0, $4pu9Z.rapidboardLastVisitedProjectRedirectRoute), {
        component: (0, $4mBNF.RedirectToLastVisitedProjectPage),
        layout: (0, $d1szd.genericProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        isRedirect: true,
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4pu9Z.projectDirectoryRedirectRoute), {
        component: $20af5c394dfc25a4$var$ProjectsDirectoryRedirect,
        layout: (0, $dVvIP.globalLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        isRedirect: true,
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $f7ee2b416e224377$export$c7d98bfe75274932)
];



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $dr1qL = parcelRequire("dr1qL");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $bdf17f7c0239b677$export$48d633ce1d0d2a0e = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_COMPASS_PRODUCT_SETTINGS),
    path: '/jira/settings/products/compass',
    exact: true
};




var $59o4i = parcelRequire("59o4i");

const $e9de4186004550fb$var$LazyCompassProductSettingsPage = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("aSuAs"))), {
    moduleId: "./src/packages/spa-apps/compass-product-settings/src/index.tsx"
});
const $e9de4186004550fb$export$cf9d12ec1710006a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e9de4186004550fb$var$LazyCompassProductSettingsPage,
        pageId: "async-compass-product-settings",
        shouldShowSpinner: true
    });
const $e9de4186004550fb$export$703b5090da478c9c = (0, $bMm60.createEntry)((0, $bdf17f7c0239b677$export$48d633ce1d0d2a0e), {
    component: $e9de4186004550fb$export$cf9d12ec1710006a,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $dr1qL.compassProductSettingsResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e9de4186004550fb$var$LazyCompassProductSettingsPage
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $49f2190082d643ec$export$7b2b015fe316fc5d = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_CONFLUENCE_PRODUCT_SETTINGS),
    path: '/jira/settings/products/confluence',
    exact: true
};




var $59o4i = parcelRequire("59o4i");

const $ff06b8de8295ef68$var$LazyConfluenceProductSettingsPage = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("fsuEu"))), {
    moduleId: "./src/packages/spa-apps/confluence-product-settings/src/index.tsx"
});
const $ff06b8de8295ef68$export$a094475e0d3636f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ff06b8de8295ef68$var$LazyConfluenceProductSettingsPage,
        pageId: "async-confluence-product-settings",
        shouldShowSpinner: true
    });
const $ff06b8de8295ef68$export$415552b116808717 = (0, $bMm60.createEntry)((0, $49f2190082d643ec$export$7b2b015fe316fc5d), {
    component: $ff06b8de8295ef68$export$a094475e0d3636f,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $ff06b8de8295ef68$var$LazyConfluenceProductSettingsPage
    ]
});



var $cernH = parcelRequire("cernH");
// must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
const $ae865171245ba4a0$export$2fdb05fdbf78d595 = [
    'mobile?!=true',
    'includeWebResources?!=true',
    'classifier?!=json',
    'project.key?',
    'project.id?'
];



var $exb0h = parcelRequire("exb0h");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $l90Gp = parcelRequire("l90Gp");

var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $4qvmP = parcelRequire("4qvmP");

var $aoOGZ = parcelRequire("aoOGZ");

var $bzNVg = parcelRequire("bzNVg");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $kbHFR = parcelRequire("kbHFR");

const $358ce19a1e550c84$export$9bb839aee83bf4d8 = [
    'selectedItem=(^com.atlassian.plugins.atlassian-connect-plugin.*)'
];



var $exb0h = parcelRequire("exb0h");
const $f088409542fd5ed5$export$1fda4850b6314ff0 = {
    name: (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL),
    group: (0, $exb0h.ROUTE_GROUPS_CONNECT),
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    query: (0, $ae865171245ba4a0$export$2fdb05fdbf78d595)
};
const $f088409542fd5ed5$export$486ffffd0a2797a5 = {
    name: (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_INVALID),
    group: (0, $exb0h.ROUTE_GROUPS_CONNECT),
    path: '/plugins/servlet/ac/:addonKey//:moduleKey',
    query: (0, $ae865171245ba4a0$export$2fdb05fdbf78d595)
};
const $f088409542fd5ed5$export$e8a58aee75961b55 = {
    name: (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
    group: (0, $exb0h.ROUTE_GROUPS_CONNECT),
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    query: [
        'project.key',
        'servicedesk.serviceDeskId'
    ]
};
const $f088409542fd5ed5$export$27e7531864dfb704 = {
    group: (0, $exb0h.ROUTE_GROUPS_CONNECT),
    name: (0, $exb0h.ROUTE_NAMES_CONNECT_PROJECT),
    path: '/projects/:projectKey',
    query: (0, $358ce19a1e550c84$export$9bb839aee83bf4d8)
};
const $f088409542fd5ed5$export$148fcbe26061b2c9 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT),
    path: '/jira/servicedesk/projects/:projectKey',
    query: (0, $358ce19a1e550c84$export$9bb839aee83bf4d8),
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $f0f661eabf62574e$export$c33275abe6c1e577 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("3CDoJ"))), {
    moduleId: "./src/packages/spa-apps/jira-connect/general-pages/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f0f661eabf62574e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f0f661eabf62574e$export$c33275abe6c1e577,
        pageId: "connect",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $40ca80f236752c2c$export$3dadc93ff144628f = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("3nYzG"))), {
    moduleId: "./src/packages/spa-apps/jira-connect/project-pages/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$40ca80f236752c2c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $40ca80f236752c2c$export$3dadc93ff144628f,
        pageId: "connect-projects",
        shouldShowSpinner: true
    });


const $d9c2a0c15a2b974b$export$4c06110e7d14ab3c = ()=>[
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $bzNVg.connectProjectResources)
    ];
const $d9c2a0c15a2b974b$export$42d81a9df7aca3f8 = {
    component: (0, $40ca80f236752c2c$export$2e2bcd8739ae039),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $40ca80f236752c2c$export$3dadc93ff144628f)
    ],
    layout: (0, $d1szd.genericProjectLayout),
    ufoName: 'jira-connect'
};
const $d9c2a0c15a2b974b$var$getGeneralConnectRouteResources = ()=>[
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $aoOGZ.connectGeneralResources),
        (0, $dAKwA.getConsolidationStateResource)()
    ];
const $d9c2a0c15a2b974b$var$generalConnectRouteEntry = {
    layout: (0, $isbb2.createLayout)(),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).ADDONS,
        sidebar: (0, $5w4hM.genericConnectSidebars)
    },
    component: (0, $f0f661eabf62574e$export$2e2bcd8739ae039),
    resources: $d9c2a0c15a2b974b$var$getGeneralConnectRouteResources(),
    canTransitionIn: (current, next)=>{
        const { query: query } = next.match;
        // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
        // block transitions to mobile version
        if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
        // block transitions to marketplace app as it requires specialised Connect API -
        const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
        const addonKey = next.match.params.addonKey || '';
        if (emceeKeyRegex.test(addonKey)) return false;
        return true;
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f0f661eabf62574e$export$c33275abe6c1e577)
    ],
    ufoName: 'jira-connect'
};
const $d9c2a0c15a2b974b$var$connectGeneralServiceDeskProjectRouteQuery = [
    ...(0, $ae865171245ba4a0$export$2fdb05fdbf78d595),
    ...(0, $f088409542fd5ed5$export$e8a58aee75961b55).query
];
const $d9c2a0c15a2b974b$export$b069a1c4b0240172 = [
    (0, $bMm60.createEntry)({
        ...(0, $f088409542fd5ed5$export$e8a58aee75961b55),
        group: (0, $exb0h.ROUTE_GROUPS_CONNECT),
        query: $d9c2a0c15a2b974b$var$connectGeneralServiceDeskProjectRouteQuery
    }, {
        ...$d9c2a0c15a2b974b$var$generalConnectRouteEntry,
        resources: [
            ...$d9c2a0c15a2b974b$var$getGeneralConnectRouteResources(),
            ...(0, $kbHFR.getServiceDeskNavigationSingleResources)()
        ]
    }),
    (0, $bMm60.createEntry)((0, $f088409542fd5ed5$export$1fda4850b6314ff0), {
        ...$d9c2a0c15a2b974b$var$generalConnectRouteEntry
    }),
    (0, $bMm60.createEntry)((0, $f088409542fd5ed5$export$486ffffd0a2797a5), {
        ...$d9c2a0c15a2b974b$var$generalConnectRouteEntry
    }),
    (0, $bMm60.createEntry)((0, $f088409542fd5ed5$export$27e7531864dfb704), {
        ...$d9c2a0c15a2b974b$export$42d81a9df7aca3f8,
        // Match resources that are fetched for legacyConnectProjectRouteEntry
        // See src/packages/router-routes/legacy/connect-project/entries/src/index.tsx
        resources: [
            ...$d9c2a0c15a2b974b$export$4c06110e7d14ab3c(),
            ...(0, $kbHFR.getServiceDeskSharedNavigationSingleResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ]
    })
];
const $d9c2a0c15a2b974b$export$72138a83eeba68eb = (0, $bMm60.createEntry)((0, $f088409542fd5ed5$export$148fcbe26061b2c9), {
    ...$d9c2a0c15a2b974b$export$42d81a9df7aca3f8,
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS
    },
    resources: [
        ...$d9c2a0c15a2b974b$export$4c06110e7d14ab3c(),
        ...(0, $kbHFR.getServiceDeskNavigationResources)(),
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $5c1fd3f0f3f9772c$export$5ce9108542315ac8 = {
    group: (0, $exb0h.ROUTE_GROUPS_COMPONENTS),
    name: (0, $exb0h.ROUTE_NAMES_CREATE_PROJECT),
    path: '/jira/create-project',
    exact: true
};



var $59o4i = parcelRequire("59o4i");

const $5a5a40256ffd86b1$export$5c005d1ab6cfe623 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("2FHVJ")), {
    moduleId: "./src/packages/spa-apps/create-project/src/index.tsx"
});
const $5a5a40256ffd86b1$export$43b852e2e1a047e8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5a5a40256ffd86b1$export$5c005d1ab6cfe623,
        pageId: "spa-apps/create-project",
        shouldShowSpinner: true
    });
const $5a5a40256ffd86b1$export$28887e2da22c839a = (0, $bMm60.createEntry)((0, $5c1fd3f0f3f9772c$export$5ce9108542315ac8), {
    component: $5a5a40256ffd86b1$export$43b852e2e1a047e8,
    layout: (0, $d1szd.genericProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $5a5a40256ffd86b1$export$5c005d1ab6cfe623
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $isbb2 = parcelRequire("isbb2");

var $6VZoe = parcelRequire("6VZoe");

const $5c266ca3d9a01d3f$export$d4768112536c9dc9 = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("1dv8j")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/dashboard/background-scripts/src/ui/index.tsx"
});


const $f26607abd0625889$export$4095842bb2e8d712 = (0, $5c266ca3d9a01d3f$export$d4768112536c9dc9);
$f26607abd0625889$export$4095842bb2e8d712.displayName = 'ConditionalDashboardBackgroundScripts';


const $1255c3ac4b25146e$export$f0a12e66953aa38a = (0, $isbb2.createLayout)({
    globalComponents: [
        (0, $f26607abd0625889$export$4095842bb2e8d712)
    ]
});





var $bmKiO = parcelRequire("bmKiO");

var $dVvIP = parcelRequire("dVvIP");

var $efFTI = parcelRequire("efFTI");

var $6VZoe = parcelRequire("6VZoe");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $isbb2 = parcelRequire("isbb2");

const $20a3759955606206$export$cb38f5a820347580 = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9'), // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("bCWHN")).then((module)=>module.TransitionHomeRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/ui/transition-home/main.tsx"
}), ()=>null);
$20a3759955606206$export$cb38f5a820347580.displayName = 'AsyncTransitionHomeRenderer';

const $20a3759955606206$export$9cda67d6c86d7b98 = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9'), // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("jofpJ")).then((module)=>module.WelcomeModalRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/ui/wizard/main.tsx"
}), ()=>null);
$20a3759955606206$export$9cda67d6c86d7b98.displayName = 'AsyncWelcomeModalRenderer';
const $20a3759955606206$export$b8fa7ac7019001bb = (0, $isbb2.createLayout)({
    get globalComponents () {
        return [
            $20a3759955606206$export$cb38f5a820347580,
            $20a3759955606206$export$9cda67d6c86d7b98
        ];
    }
});



var $dVvIP = parcelRequire("dVvIP");

var $isbb2 = parcelRequire("isbb2");
const $f7d46703104602dd$export$5b7fb151d60504c = (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), {
    // both of the components are wrapped with componentWithCondition
    globalComponents: [
        (0, $20a3759955606206$export$cb38f5a820347580),
        (0, $20a3759955606206$export$9cda67d6c86d7b98)
    ]
});



var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $01Qi5 = parcelRequire("01Qi5");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $3MEW8 = parcelRequire("3MEW8");

var $lMin2 = parcelRequire("lMin2");


var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $exb0h = parcelRequire("exb0h");

var $10fdS = parcelRequire("10fdS");

var $atRHQ = parcelRequire("atRHQ");

var $lB25E = parcelRequire("lB25E");
const $26050f43d4d16eb6$export$da833ddcffcc38ba = ()=>{
    const [{ query: query, location: { hash: hash } }] = (0, $lB25E.useRouter)();
    const { path: path } = (0, $10fdS.useRouteByName)((0, $exb0h.ROUTE_NAMES_DASHBOARD_VIEW)) ?? {};
    if (path == null) throw new Error('Dashboard view route not found');
    const { selectPageId: id } = query;
    const idParam = /^\d+$/.test(id) ? id : 'last-visited';
    const generatedPath = (0, $lB25E.generatePath)(path, {
        dashboardId: idParam
    });
    const maximizedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
    const pathWithQuery = maximizedId !== null ? `${generatedPath}?maximized=${maximizedId}` : generatedPath;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: pathWithQuery,
        persistSearchParams: false
    });
};


const $0307822c295b051f$var$dashboardResources = [
    (0, $01Qi5.dashboardConfigAndWRMResource),
    (0, $01Qi5.dashboardAMDModulesResource),
    (0, $01Qi5.dashboardReactGadgetsResource),
    (0, $01Qi5.dashboardForgeResource)
];

const $0307822c295b051f$var$LazyDashboardView = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("eOycC"))), {
    moduleId: "./src/packages/global-pages/dashboard/view/src/index.tsx"
});

const $0307822c295b051f$var$LazyDashboardViewEmbed = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("2Qy3v"))), {
    moduleId: "./src/packages/global-pages/dashboard/view-embed/src/index.tsx"
});

const $0307822c295b051f$var$LazyDashboardWallboard = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("nOTUX"))), {
    moduleId: "./src/packages/global-pages/dashboard/wallboard/src/index.tsx"
});

const $0307822c295b051f$var$LazyDashboardEdit = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("kZZqQ"))), {
    moduleId: "./src/packages/global-pages/dashboard/edit/src/index.tsx"
});

const $0307822c295b051f$export$c8d59d34c3e8f345 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("ltaAs"))), {
    moduleId: "./src/packages/spa-apps/dashboard/system-dashboard-edit/src/index.tsx"
});
const $0307822c295b051f$export$8d692f4ffba40a2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0307822c295b051f$var$LazyDashboardView,
        pageId: "dashboard",
        shouldShowSpinner: false
    });
const $0307822c295b051f$export$86d9f777f9d4e312 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0307822c295b051f$var$LazyDashboardViewEmbed,
        pageId: "dashboard",
        shouldShowSpinner: true
    });
const $0307822c295b051f$export$419b9eec5ed9880d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0307822c295b051f$var$LazyDashboardWallboard,
        pageId: "dashboard",
        shouldShowSpinner: true
    });
const $0307822c295b051f$export$fb2c0a1de056b738 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0307822c295b051f$var$LazyDashboardEdit,
        pageId: "dashboard",
        shouldShowSpinner: false
    });
const $0307822c295b051f$export$dcd19a888f8c85c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0307822c295b051f$export$c8d59d34c3e8f345,
        pageId: "system-dashboard-edit",
        shouldShowSpinner: false
    });
const $0307822c295b051f$export$9fbbaafb58999ac3 = (0, $bMm60.createEntry)((0, $lMin2.dashboardRoute), {
    component: (0, $26050f43d4d16eb6$export$da833ddcffcc38ba),
    layout: (0, $f7d46703104602dd$export$5b7fb151d60504c),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$0307822c295b051f$var$dashboardResources
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0307822c295b051f$var$LazyDashboardView
    ],
    meta: {
        capability: (0, $d07297a4af13004b$export$4695c1a423ffe431)
    },
    isRedirect: true,
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
});
const $0307822c295b051f$export$ac09a8d3ecbafc5 = (0, $bMm60.createEntry)((0, $lMin2.selectedDashboardRoute), {
    component: (0, $26050f43d4d16eb6$export$da833ddcffcc38ba),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$0307822c295b051f$var$dashboardResources
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0307822c295b051f$var$LazyDashboardView
    ],
    meta: {
        capability: (0, $d07297a4af13004b$export$4695c1a423ffe431)
    },
    isRedirect: true,
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
});
const $0307822c295b051f$export$9b0fdfd6a51a17de = (0, $bMm60.createEntry)((0, $lMin2.dashboardEditRoute), {
    component: $0307822c295b051f$export$fb2c0a1de056b738,
    layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $1255c3ac4b25146e$export$f0a12e66953aa38a)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$0307822c295b051f$var$dashboardResources,
        (0, $01Qi5.gadgetDirectoryResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0307822c295b051f$var$LazyDashboardEdit
    ],
    meta: {
        capability: (0, $d07297a4af13004b$export$4695c1a423ffe431)
    },
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
});
const $0307822c295b051f$export$6009dd8e88f1a7de = (0, $bMm60.createEntry)((0, $lMin2.dashboardWallboardRoute), {
    component: $0307822c295b051f$export$419b9eec5ed9880d,
    layout: (0, $isbb2.createLayout)({
        globalComponents: [
            (0, $f26607abd0625889$export$4095842bb2e8d712)
        ],
        // we don't want nav bar and right panel etc to appear in wallboard, so we use chromeless mode
        isChromeless: true
    }),
    resources: [
        (0, $3MEW8.themePreferenceResource),
        ...$0307822c295b051f$var$dashboardResources
    ],
    forPaint: [
        $0307822c295b051f$var$LazyDashboardWallboard
    ],
    meta: {
        capability: (0, $d07297a4af13004b$export$4695c1a423ffe431)
    },
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
});
const $0307822c295b051f$export$18226b6422149926 = (0, $bMm60.createEntry)((0, $lMin2.dashboardViewRoute), {
    component: $0307822c295b051f$export$8d692f4ffba40a2,
    layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $1255c3ac4b25146e$export$f0a12e66953aa38a)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$0307822c295b051f$var$dashboardResources
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0307822c295b051f$var$LazyDashboardView
    ],
    meta: {
        capability: (0, $d07297a4af13004b$export$4695c1a423ffe431)
    },
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY),
    ufoName: 'dashboard'
});
const $0307822c295b051f$export$73a377380ff671af = (0, $bMm60.createEntry)((0, $lMin2.dashboardViewEmbedRoute), {
    component: $0307822c295b051f$export$86d9f777f9d4e312,
    layout: (0, $isbb2.createLayout)({
        globalComponents: [
            (0, $f26607abd0625889$export$4095842bb2e8d712)
        ],
        isChromeless: true
    }),
    resources: [
        (0, $3MEW8.themePreferenceResource),
        ...$0307822c295b051f$var$dashboardResources
    ],
    forPaint: [
        $0307822c295b051f$var$LazyDashboardViewEmbed
    ],
    meta: {
        capability: (0, $d07297a4af13004b$export$4695c1a423ffe431)
    },
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
});
const $0307822c295b051f$export$15f76f1b0d2d671 = (0, $bMm60.createEntry)((0, $lMin2.systemDashboardEditRoute), {
    component: $0307822c295b051f$export$dcd19a888f8c85c,
    layout: (0, $isbb2.composeLayouts)((0, $efFTI.globalSettingsLayout), (0, $1255c3ac4b25146e$export$f0a12e66953aa38a)),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        // IMPORTANT - SSR requires wrm resource must come first
        ...$0307822c295b051f$var$dashboardResources,
        (0, $01Qi5.gadgetDirectoryResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0307822c295b051f$export$c8d59d34c3e8f345
    ],
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
});



var $cernH = parcelRequire("cernH");


var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $96cc6f4542e3daac$export$91257312631802bc = {
    group: (0, $exb0h.ROUTE_GROUPS_DEVOPS),
    name: (0, $exb0h.ROUTE_NAMES_DEVOPS_CONNECTED_PROJECT),
    path: '/jira/devops/connected-project'
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $99cde9418829e17b$export$dcd3d20b0038b35c = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("dlbLv"))), {
    moduleId: "./src/packages/spa-apps/devops-connected-project/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$99cde9418829e17b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $99cde9418829e17b$export$dcd3d20b0038b35c,
        pageId: "devops-connected-project",
        shouldShowSpinner: true
    });


const $7dbb3a67a6ba5746$export$ae258fb8ec2c1f86 = (0, $bMm60.createEntry)((0, $96cc6f4542e3daac$export$91257312631802bc), {
    ufoName: 'devops.connected-project',
    component: (0, $99cde9418829e17b$export$2e2bcd8739ae039),
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $99cde9418829e17b$export$dcd3d20b0038b35c)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $9qTfJ = parcelRequire("9qTfJ");

var $hHrVM = parcelRequire("hHrVM");

var $6JBWS = parcelRequire("6JBWS");

var $atRHQ = parcelRequire("atRHQ");

var $1usDU = parcelRequire("1usDU");


var $59o4i = parcelRequire("59o4i");
const $b5ce9d61d78c0c07$var$BoardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/boards"
    });

const $b5ce9d61d78c0c07$var$LazyBoardsDirectory = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("0bEtt"))), {
    moduleId: "./src/packages/spa-apps/directories/boards/src/index.tsx"
});
const $b5ce9d61d78c0c07$export$3184a385d45edd0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b5ce9d61d78c0c07$var$LazyBoardsDirectory,
        pageId: "boards-directory",
        shouldShowSpinner: false
    });
const $b5ce9d61d78c0c07$export$e78b34c999194638 = (0, $bMm60.createEntry)((0, $6JBWS.boardsDirectoryRoute), {
    component: $b5ce9d61d78c0c07$export$3184a385d45edd0d,
    skeleton: (0, $1usDU.BoardsDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9qTfJ.boardsDirectoryResource)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $b5ce9d61d78c0c07$var$LazyBoardsDirectory
    ]
});
const $b5ce9d61d78c0c07$export$2a34d21ecf479c40 = (0, $bMm60.createEntry)((0, $6JBWS.boardsDirectoryRedirectRoute), {
    component: $b5ce9d61d78c0c07$var$BoardsDirectoryRedirect,
    skeleton: (0, $1usDU.BoardsDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9qTfJ.boardsDirectoryResource)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $b5ce9d61d78c0c07$var$LazyBoardsDirectory
    ],
    isRedirect: true
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $iREws = parcelRequire("iREws");

var $hHrVM = parcelRequire("hHrVM");

var $bLGeo = parcelRequire("bLGeo");

var $atRHQ = parcelRequire("atRHQ");

var $1usDU = parcelRequire("1usDU");


var $59o4i = parcelRequire("59o4i");
const $de6e961a6ca28e92$var$DashboardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/dashboards"
    });

const $de6e961a6ca28e92$var$LazyDashboardsDirectory = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("1Djkn"))), {
    moduleId: "./src/packages/spa-apps/directories/dashboards/src/index.tsx"
});
const $de6e961a6ca28e92$export$1cc6cc01050e1215 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $de6e961a6ca28e92$var$LazyDashboardsDirectory,
        pageId: "dashboards-directory",
        shouldShowSpinner: false
    });
const $de6e961a6ca28e92$export$748e329bd0c282a = (0, $bMm60.createEntry)((0, $bLGeo.dashboardsDirectoryRoute), {
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $iREws.dashboardsDirectoryResource)
    ],
    component: $de6e961a6ca28e92$export$1cc6cc01050e1215,
    skeleton: (0, $1usDU.DashboardsDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $de6e961a6ca28e92$var$LazyDashboardsDirectory
    ]
});
const $de6e961a6ca28e92$export$8dae8091f8e43b97 = (0, $bMm60.createEntry)((0, $bLGeo.dashboardsDirectoryRedirectRoute), {
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $iREws.dashboardsDirectoryResource)
    ],
    component: !false ? $de6e961a6ca28e92$var$DashboardsDirectoryRedirect : $de6e961a6ca28e92$export$1cc6cc01050e1215,
    skeleton: (0, $1usDU.DashboardsDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $de6e961a6ca28e92$var$LazyDashboardsDirectory
    ],
    isRedirect: true
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $iDevf = parcelRequire("iDevf");

var $hHrVM = parcelRequire("hHrVM");

var $1cmFR = parcelRequire("1cmFR");

var $atRHQ = parcelRequire("atRHQ");

var $1usDU = parcelRequire("1usDU");


var $59o4i = parcelRequire("59o4i");
const $042c6b2255f2865a$export$c56e739d3bb1fe19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/filters"
    });

const $042c6b2255f2865a$var$LazyFiltersDirectory = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("e5dPp"))), {
    moduleId: "./src/packages/spa-apps/directories/filters/src/index.tsx"
});
const $042c6b2255f2865a$export$e5d735e83dacb7c7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $042c6b2255f2865a$var$LazyFiltersDirectory,
        pageId: "filters-directory",
        shouldShowSpinner: false
    });
const $042c6b2255f2865a$export$ca77bc660994f51f = (0, $bMm60.createEntry)((0, $1cmFR.filtersDirectoryRoute), {
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $iDevf.filtersDirectoryResource)
    ],
    component: $042c6b2255f2865a$export$e5d735e83dacb7c7,
    skeleton: (0, $1usDU.FiltersDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).FILTERS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $042c6b2255f2865a$var$LazyFiltersDirectory
    ]
});
const $042c6b2255f2865a$export$41fb3f2a3e68c7c3 = (0, $bMm60.createEntry)((0, $1cmFR.filtersDirectoryRedirectRoute), {
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $iDevf.filtersDirectoryResource)
    ],
    component: !false ? $042c6b2255f2865a$export$c56e739d3bb1fe19 : $042c6b2255f2865a$export$e5d735e83dacb7c7,
    skeleton: (0, $1usDU.FiltersDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).FILTERS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $042c6b2255f2865a$var$LazyFiltersDirectory
    ],
    isRedirect: true
});
const $042c6b2255f2865a$export$c2ec350ee9e78717 = (0, $bMm60.createEntry)((0, $1cmFR.secureFiltersDirectoryRedirectRoute), {
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $iDevf.filtersDirectoryResource)
    ],
    component: !false ? $042c6b2255f2865a$export$c56e739d3bb1fe19 : $042c6b2255f2865a$export$e5d735e83dacb7c7,
    skeleton: (0, $1usDU.FiltersDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).FILTERS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $042c6b2255f2865a$var$LazyFiltersDirectory
    ],
    isRedirect: true
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $jsQSa = parcelRequire("jsQSa");

var $1usDU = parcelRequire("1usDU");


var $59o4i = parcelRequire("59o4i");

const $0437c5d740028c1f$var$LazyPlansDirectory = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("84RpD"))), {
    moduleId: "./src/packages/spa-apps/directories/plans/src/index.tsx"
});
const $0437c5d740028c1f$export$8f357abd0af482a2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0437c5d740028c1f$var$LazyPlansDirectory,
        pageId: "plans-directory",
        shouldShowSpinner: false
    });
const $0437c5d740028c1f$export$4f9df77811fbdc1f = (0, $bMm60.createEntry)((0, $jsQSa.plansDirectoryRoute), {
    component: $0437c5d740028c1f$export$8f357abd0af482a2,
    skeleton: (0, $1usDU.PlansDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0437c5d740028c1f$var$LazyPlansDirectory
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");


var $1ybV0 = parcelRequire("1ybV0");

var $efFTI = parcelRequire("efFTI");

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $bUi2Q = parcelRequire("bUi2Q");

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $2uiE3 = parcelRequire("2uiE3");

var $dWLk9 = parcelRequire("dWLk9");
/**
 * @generated SignedSource<<2d435d64896d20bada0ea56f9c38679e>>
 * @relayHash 43bf8189b0a7cf4402292630132741e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 87629b64aa7ac7d7d4d664921553275ac07a44c6e87c79caf9659ff168ccd950
const $2cdac7441a902a1f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "87629b64aa7ac7d7d4d664921553275ac07a44c6e87c79caf9659ff168ccd950",
        "metadata": {},
        "name": "ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $2cdac7441a902a1f$export$2e2bcd8739ae039 = $2cdac7441a902a1f$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $e1ca44d7c1cebf1a$export$a9552895baaa7b3b = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("knTPF")), {
        moduleId: "6a9110b2"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                templatesQueryRef: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $2cdac7441a902a1f$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});


const $992ee0356fdc90ae$var$runtimeProps = {};
const $992ee0356fdc90ae$export$7ef72c7d51d7de1e = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $e1ca44d7c1cebf1a$export$a9552895baaa7b3b), {
        cloudId: cloudId
    });
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "right-side-panel",
        packageName: "jiraGrowthRecommendationsInProjectList",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $992ee0356fdc90ae$var$runtimeProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2uiE3.ProjectListSidebarSkeleton), null)
    });
};
var $992ee0356fdc90ae$export$2e2bcd8739ae039 = $992ee0356fdc90ae$export$7ef72c7d51d7de1e;



var $fvFzs = parcelRequire("fvFzs");

const $6f8e08a801c32f02$var$JiraProjectsTemplateListRightPanel = ()=>{
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    const { closeRightSidebar: closeRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [localPanelId, setLocalPanelId] = (0, $eUqFw.useState)();
    const prevPanelIdRef = (0, $eUqFw.useRef)();
    const delayRef = (0, $eUqFw.useRef)(undefined);
    const panelId = rightSidebarCurrentState?.panelId;
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $eUqFw.useEffect)(()=>{
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $fvFzs.PANEL_ID)) {
            /**
			 * The right-sidebar is showing the templates panel...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== PANEL_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            }, 310);
        } else /**
			 * If the right sidebar is not showing the templates panel,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            closeRightSidebar((0, $fvFzs.PANEL_ID));
        }, [
        closeRightSidebar
    ]);
    if (localPanelId !== (0, $fvFzs.PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $992ee0356fdc90ae$export$7ef72c7d51d7de1e), null);
};
const $6f8e08a801c32f02$export$521a9a721c9dad20 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-layout-component",
        packageName: "jiraGrowthRecommendationsInProjectList"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f8e08a801c32f02$var$JiraProjectsTemplateListRightPanel, null));


/**
 * @generated SignedSource<<1c85df49bf87849dab4d439bc70a8c3b>>
 * @relayHash a9b5647d8459f16784cadf784c08ee01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f31dd28adcaf6c18a0dc9713c957a224b1432a8978a87fc1069abdd23c838a83
const $a8a6716b19a8ee70$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f31dd28adcaf6c18a0dc9713c957a224b1432a8978a87fc1069abdd23c838a83",
        "metadata": {},
        "name": "ssrExperiment_ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a8a6716b19a8ee70$export$2e2bcd8739ae039 = $a8a6716b19a8ee70$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $20e7d770d18e7415$export$4707e15fd1e8e43a = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("45OsR")), {
        moduleId: "795c4be8"
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>({
            queries: {
                templatesQueryRef: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $a8a6716b19a8ee70$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        isAnonymous: tenantContext.isAnonymous
                    }
                }
            }
        })
});




var $7vTKl = parcelRequire("7vTKl");

var $7hF3Y = parcelRequire("7hF3Y");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $610DX = parcelRequire("610DX");

var $1iihP = parcelRequire("1iihP");

var $atRHQ = parcelRequire("atRHQ");

var $1usDU = parcelRequire("1usDU");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $huI7r = parcelRequire("huI7r");
/**
 * @generated SignedSource<<6b497dc8df78f1dce45893182e4dc7c8>>
 * @relayHash 30dd32919cc01646c2f07a87579c7d90
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c5bf480cfcc7e1667e0f3ca7923ae0e7fb82b6dc49abd4df64797411cc629cfd
const $1edfe7973f92fd6b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c5bf480cfcc7e1667e0f3ca7923ae0e7fb82b6dc49abd4df64797411cc629cfd",
        "metadata": {},
        "name": "pageLayout_projectsDirectoryLayout_RootQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1edfe7973f92fd6b$export$2e2bcd8739ae039 = $1edfe7973f92fd6b$var$node;



var $3S0d8 = parcelRequire("3S0d8");

var $8WtaH = parcelRequire("8WtaH");

var $1XFiH = parcelRequire("1XFiH");
const $3c41b60eee419211$var$cache = (0, $3S0d8.createCache)(new Map());
function $3c41b60eee419211$export$58f934f3d33a84b6(loader, opts) {
    return $3c41b60eee419211$var$cache.get(opts.moduleId, ()=>(0, $8WtaH.PreloadableJSResource)(()=>(0, $1XFiH.postTask)(loader, {
                priority: 'user-blocking'
            }), opts));
}



var $artI2 = parcelRequire("artI2");
const $10e750a37e6b8440$var$DEFAULT_LIMIT = 25;
const $10e750a37e6b8440$var$PROJECTS_DIRECTORY_MANAGE = 'projects-directory-manage';
const $10e750a37e6b8440$var$DefaultFilterFields = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
var $10e750a37e6b8440$var$TableColumns;
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
(function(TableColumns) {
    TableColumns["Favourites"] = "favourites";
    TableColumns["Key"] = "key";
    TableColumns["Name"] = "name";
    TableColumns["Type"] = "type";
    TableColumns["Lead"] = "lead";
    TableColumns["Category"] = "category";
    TableColumns["LastIssueUpdate"] = "last_issue_updated_time";
    TableColumns["Url"] = "url";
    TableColumns["Action"] = "actions";
})($10e750a37e6b8440$var$TableColumns || ($10e750a37e6b8440$var$TableColumns = {}));
const $10e750a37e6b8440$var$SortableColumns = [
    "key",
    "name",
    "lead",
    "category",
    "last_issue_updated_time"
];
const $10e750a37e6b8440$var$FilterFields = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectCategoryId: 'projectCategoryId',
    ...$10e750a37e6b8440$var$DefaultFilterFields
};
const $10e750a37e6b8440$var$filterAliasMap = {
    contains: $10e750a37e6b8440$var$FilterFields.Keyword,
    selectedProjectType: $10e750a37e6b8440$var$FilterFields.ProjectType,
    selectedCategory: $10e750a37e6b8440$var$FilterFields.ProjectCategoryId
};
const $10e750a37e6b8440$var$filterInitialState = {
    [$10e750a37e6b8440$var$FilterFields.Keyword]: '',
    [$10e750a37e6b8440$var$FilterFields.ProjectType]: '',
    [$10e750a37e6b8440$var$FilterFields.ProjectCategoryId]: '',
    [$10e750a37e6b8440$var$FilterFields.SortOrder]: 'ASC',
    [$10e750a37e6b8440$var$FilterFields.SortKey]: "name",
    [$10e750a37e6b8440$var$FilterFields.Page]: '1'
};
const $10e750a37e6b8440$var$LEGACY_ALL_VALUE = 'all';
const $10e750a37e6b8440$var$sanitizeLegacyQuery = (query = {})=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $10e750a37e6b8440$var$LEGACY_ALL_VALUE ? $10e750a37e6b8440$var$filterInitialState[$10e750a37e6b8440$var$FilterFields.ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $10e750a37e6b8440$var$LEGACY_ALL_VALUE ? $10e750a37e6b8440$var$filterInitialState[$10e750a37e6b8440$var$FilterFields.ProjectCategoryId] : query.selectedCategory
    });
const $10e750a37e6b8440$var$matchAliases = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $10e750a37e6b8440$var$CORE_PROJECT = 'business';
const $10e750a37e6b8440$var$SOFTWARE_PROJECT = 'software';
const $10e750a37e6b8440$var$SERVICE_DESK_PROJECT = 'service_desk';
const $10e750a37e6b8440$var$PRODUCT_DISCOVERY_PROJECT = 'product_discovery';
const $10e750a37e6b8440$var$PROJECT_TYPES = [
    $10e750a37e6b8440$var$CORE_PROJECT,
    $10e750a37e6b8440$var$SOFTWARE_PROJECT,
    $10e750a37e6b8440$var$SERVICE_DESK_PROJECT,
    $10e750a37e6b8440$var$PRODUCT_DISCOVERY_PROJECT
];
const $10e750a37e6b8440$var$mapQueryToFilter = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [$10e750a37e6b8440$var$FilterFields.Keyword]: keyword, [$10e750a37e6b8440$var$FilterFields.ProjectCategoryId]: projectCategoryId, [$10e750a37e6b8440$var$FilterFields.ProjectType]: types, [$10e750a37e6b8440$var$FilterFields.SortOrder]: sortOrder, [$10e750a37e6b8440$var$FilterFields.SortKey]: sortKey } = aliases && query ? $10e750a37e6b8440$var$matchAliases(filter, query, aliases) : filter;
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) variables.projectCategoryId = (0, $huI7r.isAri)(projectCategoryId) ? projectCategoryId : (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project-category',
        resourceId: projectCategoryId
    });
    if (sortKey || sortOrder) {
        const sortByValue = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortKey && $10e750a37e6b8440$var$SortableColumns.includes(sortKey) ? sortKey : $10e750a37e6b8440$var$filterInitialState[$10e750a37e6b8440$var$FilterFields.SortKey];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : $10e750a37e6b8440$var$filterInitialState[$10e750a37e6b8440$var$FilterFields.SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    variables.types = types.split(',') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((type)=>$10e750a37e6b8440$var$PROJECT_TYPES.includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

const $10e750a37e6b8440$export$80225215a10b2688 = (0, $artI2.createEntryPoint)({
    root: (0, $3c41b60eee419211$export$58f934f3d33a84b6)(()=>(parcelRequire("hLiAo")), {
        moduleId: "b77224b3"
    }),
    getPreloadProps ({ context: { query: query, route: route }, tenantContext: tenantContext }) {
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        const extraProps = {
            isAdminProjectDirectoryRoute: route.name === $10e750a37e6b8440$var$PROJECTS_DIRECTORY_MANAGE
        };
        if (false && isAnonymous) return {
            extraProps: extraProps
        };
        return {
            queries: {
                projectsDirectoryPage: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: (0, $1edfe7973f92fd6b$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        filter: $10e750a37e6b8440$var$mapQueryToFilter($10e750a37e6b8440$var$filterInitialState, {
                            cloudId: cloudId,
                            query: $10e750a37e6b8440$var$sanitizeLegacyQuery(query),
                            aliases: $10e750a37e6b8440$var$filterAliasMap
                        }),
                        first: query?.page ? $10e750a37e6b8440$var$DEFAULT_LIMIT * (parseInt(query.page, 10) || 1) : $10e750a37e6b8440$var$DEFAULT_LIMIT,
                        last: $10e750a37e6b8440$var$DEFAULT_LIMIT,
                        isAdminSettingsContext: route.name === $10e750a37e6b8440$var$PROJECTS_DIRECTORY_MANAGE,
                        isAnonymous: isAnonymous,
                        skipShouldShowRightSidebar: isAnonymous || (0, $1ybV0.ff)('server-render-projects-directory-sidebar_rj9ki'),
                        isImporterDiscoveryExperimentEnabled: (0, $eI5EY.fg)('jira_importer_projects_directory_cta_gate')
                    }
                }
            },
            extraProps: extraProps
        };
    }
});




var $59o4i = parcelRequire("59o4i");
const $f0febcd6986df40f$export$b68dd6112a931c10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/projects"
    });
const $f0febcd6986df40f$export$74316a0a4963952b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/settings/projects/manage"
    });

const $f0febcd6986df40f$var$LazyProjectsDirectory = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("949tN"))), {
    moduleId: "./src/packages/spa-apps/directories/projects-v3/src/index.tsx"
});
const $f0febcd6986df40f$var$LazyAdminProjectsDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0febcd6986df40f$var$LazyProjectsDirectory, {
        isAdminProjectDirectoryRoute: true
    });
const $f0febcd6986df40f$export$ba9ef00f25a4745e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f0febcd6986df40f$var$LazyAdminProjectsDirectory,
        pageId: "projects-directory-manage-v3",
        shouldShowSpinner: false
    });
const $f0febcd6986df40f$var$rightSidebars = ()=>{
    if (false) return [];
    return (0, $1ybV0.ff)('server-render-projects-directory-sidebar_rj9ki') ? [] : [
        (0, $6f8e08a801c32f02$export$521a9a721c9dad20)
    ];
};
const $f0febcd6986df40f$var$projectsDirectoryHomepageLayout = ()=>(0, $isbb2.composeLayouts)((0, $f7d46703104602dd$export$5b7fb151d60504c), {
        rightSidebars: $f0febcd6986df40f$var$rightSidebars()
    });
const $f0febcd6986df40f$var$projectsDirectorySettingsLayout = ()=>(0, $isbb2.composeLayouts)((0, $efFTI.globalSettingsLayout), {
        rightSidebars: $f0febcd6986df40f$var$rightSidebars()
    });
const $f0febcd6986df40f$var$ffOffProjectsDirectoryPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $10e750a37e6b8440$export$80225215a10b2688),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS,
    rightSidebar: undefined
});
const $f0febcd6986df40f$var$ffOnProjectsDirectoryPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $10e750a37e6b8440$export$80225215a10b2688),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS,
    rightSidebar: (0, $20e7d770d18e7415$export$4707e15fd1e8e43a)
});
const $f0febcd6986df40f$export$79292a834772288c = (0, $bMm60.createEntry)((0, $1iihP.projectsDirectoryRoute), {
    entryPoint () {
        return (0, $1ybV0.ff)('server-render-projects-directory-sidebar_rj9ki') ? $f0febcd6986df40f$var$ffOnProjectsDirectoryPageEntryPoint : $f0febcd6986df40f$var$ffOffProjectsDirectoryPageEntryPoint;
    },
    skeleton: (0, $1usDU.ProjectsDirectorySkeleton),
    layout: $f0febcd6986df40f$var$projectsDirectoryHomepageLayout(),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    ufoName: 'projects-directory-v3'
});
const $f0febcd6986df40f$var$adminProjectDirectoryResources = [
    (0, $9CFDS.navigationSidebarGlobalResource),
    (0, $610DX.projectsDirectoryPageResource)
];
const $f0febcd6986df40f$export$d5b1a46987369ee4 = (0, $bMm60.createEntry)((0, $1iihP.manageProjectsDirectoryRoute), {
    component: $f0febcd6986df40f$export$ba9ef00f25a4745e,
    skeleton: (0, $1usDU.ProjectsDirectorySkeleton),
    layout: $f0febcd6986df40f$var$projectsDirectorySettingsLayout(),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
        sidebar: (0, $7hF3Y.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$f0febcd6986df40f$var$adminProjectDirectoryResources
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $f0febcd6986df40f$var$LazyProjectsDirectory
    ],
    ufoName: 'projects-directory-v3-manage'
});
const $f0febcd6986df40f$export$445f7414e382a69c = [
    (0, $bMm60.createEntry)((0, $1iihP.projectsDirectoryRedirectRoute), {
        component: $f0febcd6986df40f$export$b68dd6112a931c10,
        skeleton: (0, $1usDU.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: $f0febcd6986df40f$var$projectsDirectoryHomepageLayout(),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $610DX.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $f0febcd6986df40f$var$LazyProjectsDirectory
        ]
    }),
    (0, $bMm60.createEntry)((0, $1iihP.projectsDirectoryLegacyPathRedirectRoute), {
        component: $f0febcd6986df40f$export$b68dd6112a931c10,
        skeleton: (0, $1usDU.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: $f0febcd6986df40f$var$projectsDirectoryHomepageLayout(),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $610DX.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $f0febcd6986df40f$var$LazyProjectsDirectory
        ]
    }),
    $f0febcd6986df40f$export$79292a834772288c,
    (0, $bMm60.createEntry)((0, $1iihP.projectsDirectoryManageRedirectRoute), {
        component: $f0febcd6986df40f$export$74316a0a4963952b,
        skeleton: (0, $1usDU.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: $f0febcd6986df40f$var$projectsDirectorySettingsLayout(),
        navigation: {
            sidebar: (0, $7hF3Y.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...$f0febcd6986df40f$var$adminProjectDirectoryResources
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $f0febcd6986df40f$var$LazyProjectsDirectory
        ]
    }),
    $f0febcd6986df40f$export$d5b1a46987369ee4,
    (0, $bMm60.createEntry)((0, $1iihP.projectsDirectoryManageRootRedirectRoute), {
        component: $f0febcd6986df40f$export$74316a0a4963952b,
        skeleton: (0, $1usDU.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: $f0febcd6986df40f$var$projectsDirectorySettingsLayout(),
        navigation: {
            sidebar: (0, $7hF3Y.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...$f0febcd6986df40f$var$adminProjectDirectoryResources
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $f0febcd6986df40f$var$LazyProjectsDirectory
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $afdaT = parcelRequire("afdaT");

var $jbEIb = parcelRequire("jbEIb");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $e7d9de3b8f852c57$export$a1b7c53ff39475a6 = (0, $6VZoe.lazyForPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("bTBRi")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/eoc-team-dashboard/src/index.tsx"
});
const $e7d9de3b8f852c57$var$TeamDashboardSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "eocTeamDashboard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7d9de3b8f852c57$export$a1b7c53ff39475a6, null));
$e7d9de3b8f852c57$var$TeamDashboardSidebar.displayName = 'TeamDashboardSidebar';
var $e7d9de3b8f852c57$export$2e2bcd8739ae039 = $e7d9de3b8f852c57$var$TeamDashboardSidebar;



var $7okz2 = parcelRequire("7okz2");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $755c1d456aaac5c2$export$aea682543f08e131 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("56Sfe")).then(({ HorizontalOperationsConfiguration: HorizontalOperationsConfiguration })=>HorizontalOperationsConfiguration), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-operations-configuration/src/ui/index.tsx"
});
const $755c1d456aaac5c2$export$1f7a0efe3746ea0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-operations-configurations-horizontal-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "asyncHorizontalOperationsConfigurationNav",
        packageName: "jiraOperationsConfigurationsHorizontalNav",
        fallback: "flag",
        teamName: "50cent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($755c1d456aaac5c2$export$aea682543f08e131, null)));



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $a459ac7703e332ad$export$409c821653bbc63b = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("3OiSV")).then(({ HorizontalOperationsNav: HorizontalOperationsNav })=>HorizontalOperationsNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-operations/src/ui/index.tsx"
});

const $a459ac7703e332ad$export$82108adf6887e32e = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("3OiSV")).then(({ OverviewNav: OverviewNav })=>OverviewNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-operations/src/ui/index.tsx"
});
const $a459ac7703e332ad$export$1eb785f071697cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-operations-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "asyncHorizontalOperationsNav",
        packageName: "jiraOperationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a459ac7703e332ad$export$409c821653bbc63b, null)));
const $a459ac7703e332ad$export$27e50c09ebb514f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-operations-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "asyncHorizontalOperationsOverviewNav",
        packageName: "jiraOperationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a459ac7703e332ad$export$82108adf6887e32e, null)));



var $6VZoe = parcelRequire("6VZoe");

var $isbb2 = parcelRequire("isbb2");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ecb9d07fa6a7199c$var$RightSidebars = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("5nFsF")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/right-sidebars/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ecb9d07fa6a7199c$var$Onboarding = (0, $6VZoe.lazyAfterPaint)(()=>(parcelRequire("6e47L")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/onboarding/index.tsx"
});
const $ecb9d07fa6a7199c$export$53dd27149810df73 = (0, $isbb2.createLayout)({
    get globalComponents () {
        return [
            $ecb9d07fa6a7199c$var$Onboarding
        ];
    },
    rightSidebars: [
        $ecb9d07fa6a7199c$var$RightSidebars
    ]
});



var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $86a7d9ee7fc180be$export$73d6a0dc298aae15 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING),
    path: '/jira/settings/products/ops/syncs',
    exact: true
};
const $86a7d9ee7fc180be$export$f271eef5f9ec6602 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_CREATE),
    path: '/jira/settings/products/ops/syncs/create',
    exact: true
};
const $86a7d9ee7fc180be$export$f1b4093ef603b98d = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_DETAIL),
    path: '/jira/settings/products/ops/syncs/:syncId',
    exact: true
};
const $86a7d9ee7fc180be$export$37ea7624561cbb89 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING),
    path: '/jira/ops/teams/:teamId/syncs',
    exact: true
};
const $86a7d9ee7fc180be$export$915ef1948fe4650a = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE),
    path: '/jira/ops/teams/:teamId/syncs/create',
    exact: true
};
const $86a7d9ee7fc180be$export$e91535fc2137c3b = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL),
    path: '/jira/ops/teams/:teamId/syncs/:syncId',
    exact: true
};



var $59o4i = parcelRequire("59o4i");

var $6VZoe = parcelRequire("6VZoe");

const $f47ef9a3a328c7b7$export$dbbcce89c7be1e71 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("jWByM")).then((module)=>module.AlertIssueSync), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $f47ef9a3a328c7b7$export$ff3e9ed7471eebce = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("jWByM")).then((module)=>module.AlertIssueSyncCreate), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $f47ef9a3a328c7b7$export$75137a2a583918e2 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("jWByM")).then((module)=>module.AlertIssueSyncDetail), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});


const $ff5a93f464a3dafa$export$5a4922ba79d730f4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $f47ef9a3a328c7b7$export$dbbcce89c7be1e71),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });
const $ff5a93f464a3dafa$export$c21f2a7e1aa801a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $f47ef9a3a328c7b7$export$75137a2a583918e2),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });
const $ff5a93f464a3dafa$export$a26f24c49385cf3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $f47ef9a3a328c7b7$export$ff3e9ed7471eebce),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });
const $ff5a93f464a3dafa$export$c63d0942ec0f93c = (0, $bMm60.createEntry)((0, $86a7d9ee7fc180be$export$73d6a0dc298aae15), {
    component: $ff5a93f464a3dafa$export$5a4922ba79d730f4,
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    slot: null,
    basePath: '/jira/settings/products/ops',
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $afdaT.resources).configuredSyncsResource,
        (0, $afdaT.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f47ef9a3a328c7b7$export$dbbcce89c7be1e71)
    ]
});
const $ff5a93f464a3dafa$export$7e604b22ae6e7c1e = (0, $bMm60.createEntry)((0, $86a7d9ee7fc180be$export$f1b4093ef603b98d), {
    component: $ff5a93f464a3dafa$export$5a4922ba79d730f4,
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    slot: $ff5a93f464a3dafa$export$c21f2a7e1aa801a7,
    basePath: '/jira/settings/products/ops',
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $afdaT.resources).configuredSyncsResource,
        (0, $afdaT.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f47ef9a3a328c7b7$export$dbbcce89c7be1e71)
    ]
});
const $ff5a93f464a3dafa$export$92f4b6644eb6cb88 = (0, $bMm60.createEntry)((0, $86a7d9ee7fc180be$export$f271eef5f9ec6602), {
    component: $ff5a93f464a3dafa$export$5a4922ba79d730f4,
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    slot: $ff5a93f464a3dafa$export$a26f24c49385cf3a,
    basePath: '/jira/settings/products/ops',
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $afdaT.resources).configuredSyncsResource,
        (0, $afdaT.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f47ef9a3a328c7b7$export$dbbcce89c7be1e71)
    ]
});
const $ff5a93f464a3dafa$export$be342a3401146aae = (0, $bMm60.createEntry)((0, $86a7d9ee7fc180be$export$37ea7624561cbb89), {
    component: $ff5a93f464a3dafa$export$5a4922ba79d730f4,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    slot: null,
    basePath: '/jira/ops/teams',
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $afdaT.resources).configuredSyncsResource,
        (0, $afdaT.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f47ef9a3a328c7b7$export$dbbcce89c7be1e71),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $ff5a93f464a3dafa$export$6298ff494c460e75 = (0, $bMm60.createEntry)((0, $86a7d9ee7fc180be$export$e91535fc2137c3b), {
    component: $ff5a93f464a3dafa$export$5a4922ba79d730f4,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    slot: $ff5a93f464a3dafa$export$c21f2a7e1aa801a7,
    basePath: '/jira/ops/teams',
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $afdaT.resources).configuredSyncsResource,
        (0, $afdaT.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f47ef9a3a328c7b7$export$dbbcce89c7be1e71),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $ff5a93f464a3dafa$export$8c07dc381591dc69 = (0, $bMm60.createEntry)((0, $86a7d9ee7fc180be$export$915ef1948fe4650a), {
    component: $ff5a93f464a3dafa$export$5a4922ba79d730f4,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    slot: $ff5a93f464a3dafa$export$a26f24c49385cf3a,
    basePath: '/jira/ops/teams',
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $afdaT.resources).configuredSyncsResource,
        (0, $afdaT.resources).userAccessRightsResource,
        (0, $afdaT.resources).getTeamResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f47ef9a3a328c7b7$export$dbbcce89c7be1e71),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $ff5a93f464a3dafa$export$cf5b5978205b681 = [
    $ff5a93f464a3dafa$export$be342a3401146aae,
    $ff5a93f464a3dafa$export$8c07dc381591dc69,
    $ff5a93f464a3dafa$export$6298ff494c460e75,
    $ff5a93f464a3dafa$export$c63d0942ec0f93c,
    $ff5a93f464a3dafa$export$92f4b6644eb6cb88,
    $ff5a93f464a3dafa$export$7e604b22ae6e7c1e
];



var $3co6Q = parcelRequire("3co6Q");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");


var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $4f0ea76b81d9faaf$export$84985159d5695f4d = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_API_KEY_MANAGEMENT),
    path: '/jira/settings/products/ops/api-key-management',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $2c4b41528d011ed4$export$6ae4b26c31b1b0d2 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("8UWae")), {
    moduleId: "./src/packages/eoc/api-key-management/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2c4b41528d011ed4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2c4b41528d011ed4$export$6ae4b26c31b1b0d2,
        pageId: "async-jira-eoc-api-key-management",
        shouldShowSpinner: false
    });


const $5f3f0c448e8043d7$export$e18a6be3d2ffad71 = (0, $bMm60.createEntry)((0, $4f0ea76b81d9faaf$export$84985159d5695f4d), {
    component: (0, $2c4b41528d011ed4$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $3co6Q.resources)
    ],
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $2c4b41528d011ed4$export$6ae4b26c31b1b0d2)
    ]
});



var $lYgVS = parcelRequire("lYgVS");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");


var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $e890e68c22b0e26c$export$79c37191a61ac94b = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_ASSIGN_CUSTOM_ROLES),
    path: '/jira/settings/products/ops/role-assignment',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $0abde6eadfb27723$export$fb6bafef9453a357 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("b53YK")), {
    moduleId: "./src/packages/eoc/assign-custom-roles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0abde6eadfb27723$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0abde6eadfb27723$export$fb6bafef9453a357,
        pageId: "async-eoc-assign-custom-roles",
        shouldShowSpinner: false
    });


const $836b69bb0e37d149$export$c51a4ee3e3f1b270 = (0, $bMm60.createEntry)((0, $e890e68c22b0e26c$export$79c37191a61ac94b), {
    component: (0, $0abde6eadfb27723$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $lYgVS.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $0abde6eadfb27723$export$fb6bafef9453a357)
    ]
});



var $jbEIb = parcelRequire("jbEIb");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");



var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $81df91959959d55f$export$4a84eb4d8d37c9d4 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_AUTOMATIONS),
    path: '/jira/ops/teams/:teamId/automations',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $4b364006ac7300d8$export$903a0a44cc0933c5 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("hgBRY")), {
    moduleId: "./src/packages/spa-apps/ops-team-scope-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b364006ac7300d8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4b364006ac7300d8$export$903a0a44cc0933c5,
        pageId: "ops-team-automation",
        shouldShowSpinner: true
    });


const $56a8577e9ca176db$export$6ff606556e19e12 = (0, $bMm60.createEntry)((0, $81df91959959d55f$export$4a84eb4d8d37c9d4), {
    component: (0, $4b364006ac7300d8$export$2e2bcd8739ae039),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $4b364006ac7300d8$export$903a0a44cc0933c5),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});



var $N5Dlu = parcelRequire("N5Dlu");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");


var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $5ffd604d51686cd6$export$3213a7325ca9911 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_CUSTOM_ROLES),
    path: '/jira/settings/products/ops/roles',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $70bbb4b7a9db4433$export$78ed54710f55f948 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("dgtUN")), {
    moduleId: "./src/packages/eoc/custom-roles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$70bbb4b7a9db4433$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $70bbb4b7a9db4433$export$78ed54710f55f948,
        pageId: "async-eoc-custom-roles",
        shouldShowSpinner: false
    });


const $497df763957e5b2d$export$9c9bab95d425eb6f = (0, $bMm60.createEntry)((0, $5ffd604d51686cd6$export$3213a7325ca9911), {
    component: (0, $70bbb4b7a9db4433$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $N5Dlu.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $70bbb4b7a9db4433$export$78ed54710f55f948)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $lKYxU = parcelRequire("lKYxU");

var $l96PT = parcelRequire("l96PT");

var $7IFpZ = parcelRequire("7IFpZ");

var $acZYh = parcelRequire("acZYh");

var $6Awrh = parcelRequire("6Awrh");

var $lWmk8 = parcelRequire("lWmk8");
const $869d34ef1fa542d1$export$bc99aaabaf7b70a7 = [
    (0, $lWmk8.uiPreferencesResource),
    (0, $6Awrh.savedSearchesResource),
    (0, $acZYh.compressionRatioResource),
    (0, $7IFpZ.alertGroupingStateResource),
    ...(0, $l96PT.eocCommonResources)()
];



var $cernH = parcelRequire("cernH");


var $7vTKl = parcelRequire("7vTKl");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

const $cb1b672dbf28422d$export$674fd99c08c90491 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("fnRsf")).then((bundle)=>bundle), {
    moduleId: "./src/packages/navigation-apps/sidebar/eoc-global-alerts/src/index.tsx"
});
const $cb1b672dbf28422d$export$a1c034c1031e8711 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "eocGlobalAlerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb1b672dbf28422d$export$674fd99c08c90491, null));



var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $fOu5W = parcelRequire("fOu5W");

var $59o4i = parcelRequire("59o4i");

const $723988f9339967b5$export$f4aafff31d950b6c = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("a2lIg")), {
    moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
});
const $723988f9339967b5$export$9333bfa567c9c31 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $723988f9339967b5$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });
const $723988f9339967b5$export$851a659e50436cff = (0, $bMm60.createEntry)((0, $fOu5W.eocGlobalAlertListRoute), {
    component: $723988f9339967b5$export$9333bfa567c9c31,
    layout: (0, $20a3759955606206$export$b8fa7ac7019001bb),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $869d34ef1fa542d1$export$bc99aaabaf7b70a7),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).HOME,
        sidebar: (0, $cb1b672dbf28422d$export$a1c034c1031e8711)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $723988f9339967b5$export$f4aafff31d950b6c,
        (0, $cb1b672dbf28422d$export$674fd99c08c90491)
    ]
});
const $723988f9339967b5$export$bcb93d8198d511b9 = (0, $bMm60.createEntry)((0, $fOu5W.eocGlobalAlertDetailRoute), {
    component: $723988f9339967b5$export$9333bfa567c9c31,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $869d34ef1fa542d1$export$bc99aaabaf7b70a7),
        ...(0, $lKYxU.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).HOME,
        sidebar: (0, $cb1b672dbf28422d$export$a1c034c1031e8711)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $723988f9339967b5$export$f4aafff31d950b6c,
        (0, $cb1b672dbf28422d$export$674fd99c08c90491)
    ]
});
const $723988f9339967b5$export$283761ff41b53cba = [
    $723988f9339967b5$export$851a659e50436cff,
    $723988f9339967b5$export$bcb93d8198d511b9
];




var $8gBS8 = parcelRequire("8gBS8");

var $jbEIb = parcelRequire("jbEIb");

var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $7vTKl = parcelRequire("7vTKl");




var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $45158a8fc0365467$export$e6569aff8dfd4c1d = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL),
    path: '/jira/ops/group-detail/:id',
    exact: true
};
const $45158a8fc0365467$export$aa8cf61e94739f21 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL),
    path: '/jira/ops/teams/:teamId/group-detail/:id',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $e8aa2f68dc64c9ba$export$8d4b3992eb19d436 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("boVHD")), {
    moduleId: "./src/packages/eoc/group-detail/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8aa2f68dc64c9ba$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e8aa2f68dc64c9ba$export$8d4b3992eb19d436,
        pageId: "async-jira-eoc-group-detail",
        shouldShowSpinner: false
    });


const $c7e50fdddf86bc76$export$66928ab349190059 = (0, $bMm60.createEntry)((0, $45158a8fc0365467$export$e6569aff8dfd4c1d), {
    component: (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('platform.aiops-smart-view_yf5qp'), (0, $e8aa2f68dc64c9ba$export$2e2bcd8739ae039), (0, $dgH3j.default)),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $8gBS8.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        ...(0, $869d34ef1fa542d1$export$bc99aaabaf7b70a7)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).HOME,
        sidebar: (0, $cb1b672dbf28422d$export$a1c034c1031e8711)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $e8aa2f68dc64c9ba$export$8d4b3992eb19d436),
        (0, $cb1b672dbf28422d$export$674fd99c08c90491)
    ]
});
const $c7e50fdddf86bc76$export$2b25520e20820251 = (0, $bMm60.createEntry)((0, $45158a8fc0365467$export$aa8cf61e94739f21), {
    component: (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('platform.aiops-smart-view_yf5qp'), (0, $e8aa2f68dc64c9ba$export$2e2bcd8739ae039), (0, $dgH3j.default)),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        ...(0, $8gBS8.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        ...(0, $869d34ef1fa542d1$export$bc99aaabaf7b70a7)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $e8aa2f68dc64c9ba$export$8d4b3992eb19d436),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $3APH6 = parcelRequire("3APH6");

var $jbEIb = parcelRequire("jbEIb");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");




var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $73a3755e2adcdefa$export$e935ec688da4c447 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_HEARTBEATS),
    path: '/jira/ops/teams/:teamId/heartbeats',
    exact: true
};



var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e24a5dc60e9548ab$var$LazyHeartbeats = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("jpbkT")), {
    moduleId: "./src/packages/eoc/heartbeats/src/index.tsx"
});
const $e24a5dc60e9548ab$var$HeartbeatsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e24a5dc60e9548ab$var$LazyHeartbeats,
        pageId: "async-jira-eoc-heartbeats",
        shouldShowSpinner: false
    });
const $e24a5dc60e9548ab$export$2c2d6115c4280a08 = (0, $bMm60.createEntry)((0, $73a3755e2adcdefa$export$e935ec688da4c447), {
    component: $e24a5dc60e9548ab$var$HeartbeatsComponent,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $3APH6.resources),
        ...(0, $jbEIb.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        $e24a5dc60e9548ab$var$LazyHeartbeats,
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $c0h5y = parcelRequire("c0h5y");

var $ksJxY = parcelRequire("ksJxY");
const $d90c9129201f307a$export$c83d9fd41123ab31 = [
    (0, $ksJxY.listResource)
];
const $d90c9129201f307a$export$63630293105c0f4e = [
    (0, $c0h5y.detailResource)
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");


var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $3327a57d6229c9c0$export$8dd2e8adca05d8a3 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_INCOMING_CALL),
    path: '/jira/settings/products/ops/incoming-call',
    exact: true
};
const $3327a57d6229c9c0$export$10f19333da6ac52c = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_INCOMING_CALL_DETAIL),
    path: '/jira/settings/products/ops/incoming-call/:id',
    exact: true
};



var $59o4i = parcelRequire("59o4i");

var $6VZoe = parcelRequire("6VZoe");

const $7f90b06af83f4670$export$d76e6607b7e88a7b = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("g1c5G")).then((module)=>module.IncomingCallPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});

const $7f90b06af83f4670$export$1c56f2b1fdd5d724 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("g1c5G")).then((module)=>module.IncomingCallDetailPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});


const $2424a38c91d6dd07$export$742ca8be503e0313 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $7f90b06af83f4670$export$d76e6607b7e88a7b),
        pageId: "async-jira-eoc-incoming-call",
        shouldShowSpinner: false
    });
const $2424a38c91d6dd07$export$6ec51edee1972588 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $7f90b06af83f4670$export$1c56f2b1fdd5d724),
        pageId: "async-jira-eoc-incoming-call-detail",
        shouldShowSpinner: false
    });
const $2424a38c91d6dd07$export$bf8ccc758901febd = (0, $bMm60.createEntry)((0, $3327a57d6229c9c0$export$8dd2e8adca05d8a3), {
    component: $2424a38c91d6dd07$export$742ca8be503e0313,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $d90c9129201f307a$export$c83d9fd41123ab31)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7f90b06af83f4670$export$d76e6607b7e88a7b)
    ]
});
const $2424a38c91d6dd07$export$39f40714591c98c0 = (0, $bMm60.createEntry)((0, $3327a57d6229c9c0$export$10f19333da6ac52c), {
    component: $2424a38c91d6dd07$export$6ec51edee1972588,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $d90c9129201f307a$export$63630293105c0f4e)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7f90b06af83f4670$export$d76e6607b7e88a7b)
    ]
});
const $2424a38c91d6dd07$export$5d3c7bc3dee8745d = [
    $2424a38c91d6dd07$export$bf8ccc758901febd,
    $2424a38c91d6dd07$export$39f40714591c98c0
];



var $eUqFw = parcelRequire("eUqFw");

var $l96PT = parcelRequire("l96PT");

var $ix1Bp = parcelRequire("ix1Bp");

var $aJvzf = parcelRequire("aJvzf");

var $aDS8U = parcelRequire("aDS8U");

var $2N7LD = parcelRequire("2N7LD");
const $da65b4fac0ccb24a$export$bc99aaabaf7b70a7 = [
    (0, $2N7LD.uiSettingsResource),
    (0, $aDS8U.logsResource),
    (0, $ix1Bp.byokInformationResource),
    ...(0, $l96PT.eocCommonResources)()
];
const $da65b4fac0ccb24a$export$8571305c82629fe4 = [
    (0, $aJvzf.downloadAuditLogsResource),
    ...(0, $l96PT.eocCommonResources)()
];



var $90Qu9 = parcelRequire("90Qu9");

var $jbEIb = parcelRequire("jbEIb");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");


var $7okz2 = parcelRequire("7okz2");




var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $eb65b0a90865591f$export$400ead354c81dee3 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATIONS),
    path: '/jira/ops/teams/:teamId/integrations',
    exact: true
};
const $eb65b0a90865591f$export$b8218f375778e6d7 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST),
    path: '/jira/ops/teams/:teamId/integrations/list',
    exact: true
};
const $eb65b0a90865591f$export$a2ec7da6c43acbbf = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE),
    path: '/jira/ops/teams/:teamId/integrations/create/:type',
    exact: true
};
const $eb65b0a90865591f$export$72169399df792b7c = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL),
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId',
    exact: true
};
const $eb65b0a90865591f$export$ca02d7b2c7df3d60 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG),
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId/logs',
    exact: true
};
const $eb65b0a90865591f$export$e196ff2390a1ec56 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_INTEGRATIONS),
    path: '/jira/settings/products/ops/integrations',
    exact: true
};
const $eb65b0a90865591f$export$270e16f240db883b = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_INTEGRATION_LIST),
    path: '/jira/settings/products/ops/integrations/list',
    exact: true
};
const $eb65b0a90865591f$export$bb272d36e3c3b7c1 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_INTEGRATION_CREATE),
    path: '/jira/settings/products/ops/integrations/create/:type',
    exact: true
};
const $eb65b0a90865591f$export$f826f15073eda98 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_INTEGRATION_DETAIL),
    path: '/jira/settings/products/ops/integrations/:type/:integrationId',
    exact: true
};
const $eb65b0a90865591f$export$71884dc820e415fc = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_INTEGRATION_LOG),
    path: '/jira/settings/products/ops/integrations/:type/:integrationId/logs',
    exact: true
};



var $59o4i = parcelRequire("59o4i");

var $6VZoe = parcelRequire("6VZoe");

const $47d50c35ad481237$export$68c40afda0287b61 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("j3qRC")).then((module)=>module.IntegrationAutomation), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $47d50c35ad481237$export$fd7f60e3df94c902 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("j3qRC")).then((module)=>module.IntegrationDetail), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $47d50c35ad481237$export$aa9358ade7cb53ee = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("j3qRC")).then((module)=>module.IntegrationCreate), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $47d50c35ad481237$export$993132b847f26efa = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("j3qRC")).then((module)=>module.IntegrationList), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $47d50c35ad481237$export$b02ef932401d95fc = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("j3qRC")).then((module)=>module.IntegrationLog), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});


const $0e57ebaaa2758857$export$434c3e2269913ac0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $47d50c35ad481237$export$68c40afda0287b61),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
const $0e57ebaaa2758857$export$8bb99f196e0be5b6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $47d50c35ad481237$export$fd7f60e3df94c902),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
const $0e57ebaaa2758857$export$5cb14595364f02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $47d50c35ad481237$export$aa9358ade7cb53ee),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
const $0e57ebaaa2758857$export$955768269b79c203 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $47d50c35ad481237$export$993132b847f26efa),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
const $0e57ebaaa2758857$export$b545b4a4c4cee016 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $47d50c35ad481237$export$b02ef932401d95fc),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
const $0e57ebaaa2758857$export$ded9494f81dd2a4d = (0, $bMm60.createEntry)((0, $eb65b0a90865591f$export$400ead354c81dee3), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/ops/teams',
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    slot: null,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $90Qu9.resources).configuredIntegrationsResource,
        (0, $90Qu9.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $0e57ebaaa2758857$export$52ee366e7b51f38d = (0, $bMm60.createEntry)((0, $eb65b0a90865591f$export$b8218f375778e6d7), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/ops/teams',
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    slot: $0e57ebaaa2758857$export$955768269b79c203,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $90Qu9.resources).integrationListResource,
        (0, $90Qu9.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $0e57ebaaa2758857$export$83aea99d18750f08 = (0, $bMm60.createEntry)((0, $eb65b0a90865591f$export$a2ec7da6c43acbbf), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/ops/teams',
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    slot: $0e57ebaaa2758857$export$5cb14595364f02c,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $90Qu9.resources).configuredIntegrationsResource,
        (0, $90Qu9.resources).integrationListResource,
        (0, $90Qu9.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $0e57ebaaa2758857$export$7e0b6b79953422c1 = (0, $bMm60.createEntry)((0, $eb65b0a90865591f$export$72169399df792b7c), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/ops/teams',
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    slot: $0e57ebaaa2758857$export$8bb99f196e0be5b6,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $90Qu9.resources).configuredIntegrationsResource,
        (0, $90Qu9.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $0e57ebaaa2758857$export$d5e169223d2a5d1d = (0, $bMm60.createEntry)((0, $eb65b0a90865591f$export$ca02d7b2c7df3d60), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/ops/teams',
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    slot: $0e57ebaaa2758857$export$b545b4a4c4cee016,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        ...(0, $da65b4fac0ccb24a$export$bc99aaabaf7b70a7),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $90Qu9.resources).configuredIntegrationsResource,
        (0, $90Qu9.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $0e57ebaaa2758857$export$6e5cd6656076550f = (0, $bMm60.createEntry)((0, $eb65b0a90865591f$export$e196ff2390a1ec56), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/settings/products/ops',
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    slot: null,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $90Qu9.resources).configuredIntegrationsResource,
        (0, $90Qu9.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61)
    ]
});
const $0e57ebaaa2758857$export$790602da39f8af00 = (0, $bMm60.createEntry)((0, $eb65b0a90865591f$export$270e16f240db883b), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/settings/products/ops',
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    slot: $0e57ebaaa2758857$export$955768269b79c203,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $90Qu9.resources).integrationListResource,
        (0, $90Qu9.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61)
    ]
});
const $0e57ebaaa2758857$export$62eef9a2917f041f = (0, $bMm60.createEntry)((0, $eb65b0a90865591f$export$bb272d36e3c3b7c1), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/settings/products/ops',
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    slot: $0e57ebaaa2758857$export$5cb14595364f02c,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $90Qu9.resources).configuredIntegrationsResource,
        (0, $90Qu9.resources).integrationListResource,
        (0, $90Qu9.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61)
    ]
});
const $0e57ebaaa2758857$export$b66abbccbf93e9ad = (0, $bMm60.createEntry)((0, $eb65b0a90865591f$export$f826f15073eda98), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/settings/products/ops',
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    slot: $0e57ebaaa2758857$export$8bb99f196e0be5b6,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $90Qu9.resources).configuredIntegrationsResource,
        (0, $90Qu9.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61)
    ]
});
const $0e57ebaaa2758857$export$d30f51d0f351bd8a = (0, $bMm60.createEntry)((0, $eb65b0a90865591f$export$71884dc820e415fc), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/settings/products/ops',
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    slot: $0e57ebaaa2758857$export$b545b4a4c4cee016,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $da65b4fac0ccb24a$export$bc99aaabaf7b70a7),
        (0, $90Qu9.resources).configuredIntegrationsResource,
        (0, $90Qu9.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61)
    ]
});
const $0e57ebaaa2758857$export$de0b5a5b87cf45f3 = [
    $0e57ebaaa2758857$export$ded9494f81dd2a4d,
    $0e57ebaaa2758857$export$52ee366e7b51f38d,
    $0e57ebaaa2758857$export$83aea99d18750f08,
    $0e57ebaaa2758857$export$7e0b6b79953422c1,
    $0e57ebaaa2758857$export$d5e169223d2a5d1d,
    $0e57ebaaa2758857$export$6e5cd6656076550f,
    $0e57ebaaa2758857$export$790602da39f8af00,
    $0e57ebaaa2758857$export$62eef9a2917f041f,
    $0e57ebaaa2758857$export$b66abbccbf93e9ad,
    $0e57ebaaa2758857$export$d30f51d0f351bd8a
];



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $6GkpX = parcelRequire("6GkpX");

var $jbEIb = parcelRequire("jbEIb");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");


var $7okz2 = parcelRequire("7okz2");




var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $d578ddb3405fb9b8$export$b997369a5c2dab54 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_MAINTENANCE),
    path: '/jira/ops/teams/:teamId/maintenance',
    exact: true
};
const $d578ddb3405fb9b8$export$9d65c6548c3b50e4 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_MAINTENANCE),
    path: '/jira/settings/products/ops/maintenance',
    exact: true
};



var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2ee957ede87673df$var$LazyMaintenance = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("h4iG3")), {
    moduleId: "./src/packages/eoc/maintenance/src/index.tsx"
});
const $2ee957ede87673df$var$MaintenanceComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2ee957ede87673df$var$LazyMaintenance,
        pageId: "async-jira-eoc-maintenance",
        shouldShowSpinner: false
    });
const $2ee957ede87673df$var$eocMaintenanceRouteEntry = (0, $bMm60.createEntry)((0, $d578ddb3405fb9b8$export$b997369a5c2dab54), {
    component: $2ee957ede87673df$var$MaintenanceComponent,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $6GkpX.resources),
        ...(0, $jbEIb.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        $2ee957ede87673df$var$LazyMaintenance,
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $2ee957ede87673df$var$eocGlobalMaintenanceRouteEntry = (0, $bMm60.createEntry)((0, $d578ddb3405fb9b8$export$9d65c6548c3b50e4), {
    component: $2ee957ede87673df$var$MaintenanceComponent,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $6GkpX.resources)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        $2ee957ede87673df$var$LazyMaintenance
    ]
});
const $2ee957ede87673df$export$ed40a3967b4f2617 = [
    $2ee957ede87673df$var$eocMaintenanceRouteEntry,
    $2ee957ede87673df$var$eocGlobalMaintenanceRouteEntry
];



var $a7OGS = parcelRequire("a7OGS");

var $jbEIb = parcelRequire("jbEIb");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");




var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $4cdf55d595c85e35$export$18cec3860c46aaf2 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_ON_CALL_REDIRECT),
    path: '/jira/ops/teams/:teamId',
    exact: true
};
const $4cdf55d595c85e35$export$5eaa466ae8a4d7d3 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_ON_CALL),
    path: '/jira/ops/teams/:teamId/on-call',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

var $lB25E = parcelRequire("lB25E");
const $6f9c82d4fbdfb1c3$export$659b7ce11c160b32 = ()=>{
    const [routeContext] = (0, $lB25E.useRouter)();
    const redirectionUrl = `${routeContext.location.pathname}/on-call`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: redirectionUrl
    });
};

const $6f9c82d4fbdfb1c3$export$772095aa22362f73 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("2t3Fl")), {
    moduleId: "./src/packages/eoc/on-call/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6f9c82d4fbdfb1c3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6f9c82d4fbdfb1c3$export$772095aa22362f73,
        pageId: "async-jira-eoc-on-call",
        shouldShowSpinner: false
    });


const $d6dfbe2316b32236$export$ac245212b12db871 = (0, $bMm60.createEntry)((0, $4cdf55d595c85e35$export$18cec3860c46aaf2), {
    component: (0, $6f9c82d4fbdfb1c3$export$659b7ce11c160b32),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ],
    isRedirect: true
});
const $d6dfbe2316b32236$export$8657ca08ca5cbfc6 = (0, $bMm60.createEntry)((0, $4cdf55d595c85e35$export$5eaa466ae8a4d7d3), {
    component: (0, $6f9c82d4fbdfb1c3$export$2e2bcd8739ae039),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        ...(0, $a7OGS.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $6f9c82d4fbdfb1c3$export$772095aa22362f73),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");


var $bMm60 = parcelRequire("bMm60");

var $4e1pR = parcelRequire("4e1pR");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $fda413a2ca3a89c5$export$cb929d46451a5c12 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_OVERVIEW),
    path: '/jira/ops/overview',
    exact: true
};
const $fda413a2ca3a89c5$export$dbe53627482b9f0f = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS),
    path: '/jira/ops/overview/teams',
    exact: true
};



var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e108d633ec33a0c8$var$LazyOverviewPage = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("joHFD")).then((m)=>m.OverviewPage), {
    moduleId: "./src/packages/eoc/overview/src/ui/overview-page/index.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e108d633ec33a0c8$var$LazyOverviewAllTeamsPage = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("3h9Fz")).then((m)=>m.AllTeamsPage), {
    moduleId: "./src/packages/eoc/overview/src/ui/all-teams-page/index.tsx"
});
const $e108d633ec33a0c8$var$EocOverviewComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e108d633ec33a0c8$var$LazyOverviewPage,
        pageId: "async-jira-eoc-overview",
        shouldShowSpinner: false
    });
const $e108d633ec33a0c8$var$EocOverviewAllTeamsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e108d633ec33a0c8$var$LazyOverviewAllTeamsPage,
        pageId: "async-jira-eoc-overview-all-teams",
        shouldShowSpinner: false
    });
const $e108d633ec33a0c8$export$f1a859c727c30be4 = (0, $bMm60.createEntry)((0, $fda413a2ca3a89c5$export$cb929d46451a5c12), {
    component: $e108d633ec33a0c8$var$EocOverviewComponent,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $4e1pR.getTeamsResource)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).HOME,
        horizontal: (0, $a459ac7703e332ad$export$27e50c09ebb514f),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $a459ac7703e332ad$export$82108adf6887e32e),
        $e108d633ec33a0c8$var$LazyOverviewPage
    ]
});
const $e108d633ec33a0c8$export$842d7c81068bb64e = (0, $bMm60.createEntry)((0, $fda413a2ca3a89c5$export$dbe53627482b9f0f), {
    component: $e108d633ec33a0c8$var$EocOverviewAllTeamsComponent,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $4e1pR.getTeamsResource)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).HOME,
        horizontal: (0, $a459ac7703e332ad$export$27e50c09ebb514f),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $a459ac7703e332ad$export$82108adf6887e32e),
        $e108d633ec33a0c8$var$LazyOverviewAllTeamsPage
    ]
});



var $kI7MG = parcelRequire("kI7MG");

var $jbEIb = parcelRequire("jbEIb");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");




var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $387f3f7779158766$export$8e6afd724de3be6e = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_PERMISSIONS),
    path: '/jira/ops/teams/:teamId/settings',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $786c0202514ba385$export$27b4fb95241ab47 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("cSbPW")), {
    moduleId: "./src/packages/eoc/member-roles/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$786c0202514ba385$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $786c0202514ba385$export$27b4fb95241ab47,
        pageId: "async-jira-eoc-member-roles",
        shouldShowSpinner: false
    });


const $ae796711ad3c7e93$export$c2ced436a30c60dc = (0, $bMm60.createEntry)((0, $387f3f7779158766$export$8e6afd724de3be6e), {
    component: (0, $786c0202514ba385$export$2e2bcd8739ae039),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        // pageAccessResource should be defined before memberRolesResources since they depend on it
        (0, $kI7MG.pageAccessResource),
        ...(0, $kI7MG.resources),
        ...(0, $jbEIb.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $786c0202514ba385$export$27b4fb95241ab47),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $gu8OT = parcelRequire("gu8OT");

var $jbEIb = parcelRequire("jbEIb");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");


var $7okz2 = parcelRequire("7okz2");




var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $4a150a7c155d6075$export$eab7ea9e54b67f16 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_TEAM_POLICIES),
    path: '/jira/ops/teams/:teamId/policies',
    exact: true
};
const $4a150a7c155d6075$export$4eb24a8e860a3df7 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_POLICIES),
    path: '/jira/settings/products/ops/policies',
    exact: true
};



var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2be3fd10da5a8d41$var$LazyAlertPolicies = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("4kZe2")), {
    moduleId: "./src/packages/eoc/policies/src/index.tsx"
});
const $2be3fd10da5a8d41$var$AlertPoliciesComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2be3fd10da5a8d41$var$LazyAlertPolicies,
        pageId: "async-jira-eoc-alert-policies",
        shouldShowSpinner: false
    });
const $2be3fd10da5a8d41$export$eb1e2324ca2031e2 = (0, $bMm60.createEntry)((0, $4a150a7c155d6075$export$eab7ea9e54b67f16), {
    component: $2be3fd10da5a8d41$var$AlertPoliciesComponent,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $gu8OT.resources),
        ...(0, $jbEIb.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        $2be3fd10da5a8d41$var$LazyAlertPolicies,
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $2be3fd10da5a8d41$export$2ee2f43d380cc210 = (0, $bMm60.createEntry)((0, $4a150a7c155d6075$export$4eb24a8e860a3df7), {
    component: $2be3fd10da5a8d41$var$AlertPoliciesComponent,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $gu8OT.resources)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        $2be3fd10da5a8d41$var$LazyAlertPolicies
    ]
});
const $2be3fd10da5a8d41$export$3a28949e52d2d60f = [
    $2be3fd10da5a8d41$export$eb1e2324ca2031e2,
    $2be3fd10da5a8d41$export$2ee2f43d380cc210
];



var $4iKIJ = parcelRequire("4iKIJ");

var $jbEIb = parcelRequire("jbEIb");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");




var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $6bded2ea1ecf081d$export$c71b9e52093cd3a = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_REPORTS),
    path: '/jira/ops/teams/:teamId/reports',
    exact: true
};
const $6bded2ea1ecf081d$export$4209bfa031a1bc9e = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_REPORTS),
    path: '/jira/ops/reports',
    exact: true
};
const $6bded2ea1ecf081d$export$72cde899ee974e6e = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE),
    path: '/jira/ops/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};
const $6bded2ea1ecf081d$export$2344cc35fd2eff4e = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD),
    path: '/jira/ops/reports/:dashboardId',
    exact: true
};
const $6bded2ea1ecf081d$export$c9e0796615c034f3 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_REPORTS_TEAM),
    path: '/jira/ops/teams/:teamId/reports/:dashboardId',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $a40f85b59bd30935$export$2404f0e35deca592 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("3mMNE")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $a40f85b59bd30935$export$d33ea1a773b744e = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("3mMNE")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $a40f85b59bd30935$export$66850ec5549adba6 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("3mMNE")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $a40f85b59bd30935$export$5fd77c3bbfb22cbd = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("3mMNE")).then((exportedMembers)=>exportedMembers.OpsReportsUnsubscribe), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $a40f85b59bd30935$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a40f85b59bd30935$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $a40f85b59bd30935$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a40f85b59bd30935$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $a40f85b59bd30935$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a40f85b59bd30935$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });
const $a40f85b59bd30935$export$7f366d77015c286f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a40f85b59bd30935$export$5fd77c3bbfb22cbd,
        pageId: "async-jira-eoc-ops-reports-unsubscribe",
        shouldShowSpinner: false
    });


const $662505a58c71f074$export$c5606e8eeca32c0f = (0, $bMm60.createEntry)((0, $6bded2ea1ecf081d$export$c71b9e52093cd3a), {
    component: (0, $a40f85b59bd30935$export$22253dbadb46d0cf),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        ...(0, $4iKIJ.resources),
        (0, $4iKIJ.opsReportsPermissionResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $a40f85b59bd30935$export$d33ea1a773b744e),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $662505a58c71f074$export$be0522f298067d5d = (0, $bMm60.createEntry)((0, $6bded2ea1ecf081d$export$4209bfa031a1bc9e), {
    component: (0, $a40f85b59bd30935$export$22253dbadb46d0cf),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $4iKIJ.resources),
        (0, $4iKIJ.opsReportsPermissionResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $a40f85b59bd30935$export$d33ea1a773b744e),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $662505a58c71f074$export$1016100af7c78cd = (0, $bMm60.createEntry)((0, $6bded2ea1ecf081d$export$2344cc35fd2eff4e), {
    component: (0, $a40f85b59bd30935$export$648ddf2d1f8b1c3f),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $4iKIJ.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).HOME
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $a40f85b59bd30935$export$66850ec5549adba6)
    ]
});
const $662505a58c71f074$export$df0202187c23a21d = (0, $bMm60.createEntry)((0, $6bded2ea1ecf081d$export$72cde899ee974e6e), {
    component: (0, $a40f85b59bd30935$export$7f366d77015c286f),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $a40f85b59bd30935$export$5fd77c3bbfb22cbd)
    ]
});
const $662505a58c71f074$export$cd1c1a81e516fec5 = (0, $bMm60.createEntry)((0, $6bded2ea1ecf081d$export$c9e0796615c034f3), {
    component: (0, $a40f85b59bd30935$export$87e6a54b4f5dc91e),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        ...(0, $4iKIJ.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $a40f85b59bd30935$export$2404f0e35deca592),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $662505a58c71f074$export$1d5f1cc699ecefa3 = [
    $662505a58c71f074$export$c5606e8eeca32c0f,
    $662505a58c71f074$export$df0202187c23a21d,
    $662505a58c71f074$export$be0522f298067d5d,
    $662505a58c71f074$export$1016100af7c78cd,
    $662505a58c71f074$export$cd1c1a81e516fec5
];



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $8tS6M = parcelRequire("8tS6M");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");


var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $5fd5c73d8d7e66bb$export$5a10092825ee32e4 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS),
    path: '/jira/settings/products/ops/role-based-notifications',
    exact: true
};
const $5fd5c73d8d7e66bb$export$659aa6d7cd021e4b = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS_DETAIL),
    path: '/jira/settings/products/ops/role-based-notifications/:id',
    exact: true
};



var $59o4i = parcelRequire("59o4i");

const $a21bbc0ffd429ece$export$15a244aba8f3b406 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("fkNXT")).then((module)=>module.RoleBasedNotificationsPage), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});

const $a21bbc0ffd429ece$export$5211e5a7ed694f98 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("fkNXT")).then((module)=>module.RoleBasedNotificationDetail), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});
const $a21bbc0ffd429ece$export$8994be6f8ad6a04a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a21bbc0ffd429ece$export$15a244aba8f3b406,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });
const $a21bbc0ffd429ece$export$445112c3a1089cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a21bbc0ffd429ece$export$5211e5a7ed694f98,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });
const $a21bbc0ffd429ece$export$60de9875bb8ef1d6 = (0, $bMm60.createEntry)((0, $5fd5c73d8d7e66bb$export$5a10092825ee32e4), {
    component: $a21bbc0ffd429ece$export$8994be6f8ad6a04a,
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $8tS6M.resources)[0],
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        $a21bbc0ffd429ece$export$15a244aba8f3b406
    ]
});
const $a21bbc0ffd429ece$export$565325825b04cec6 = (0, $bMm60.createEntry)((0, $5fd5c73d8d7e66bb$export$659aa6d7cd021e4b), {
    component: $a21bbc0ffd429ece$export$8994be6f8ad6a04a,
    layout: (0, $efFTI.globalSettingsLayout),
    // @ts-expect-error: 'slot' should be expected because it is being used inside platform package to show the slot inside a drawer
    slot: $a21bbc0ffd429ece$export$445112c3a1089cc5,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $8tS6M.resources)[0],
        (0, $8tS6M.resources)[1],
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        $a21bbc0ffd429ece$export$15a244aba8f3b406
    ]
});
const $a21bbc0ffd429ece$export$80002c8e4483fef1 = [
    $a21bbc0ffd429ece$export$60de9875bb8ef1d6,
    $a21bbc0ffd429ece$export$565325825b04cec6
];



var $lKYxU = parcelRequire("lKYxU");


var $jbEIb = parcelRequire("jbEIb");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");




var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $3f8aaf8df2315fa7$export$94efd60f23d97aa5 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERTS),
    path: '/jira/ops/teams/:teamId/alerts',
    exact: true
};
const $3f8aaf8df2315fa7$export$ac102dc13a0f4aff = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS),
    path: '/jira/ops/teams/:teamId/alerts/:id',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $ccd3d4fdd976cfb4$export$f4aafff31d950b6c = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("a2lIg")), {
    moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ccd3d4fdd976cfb4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ccd3d4fdd976cfb4$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });


const $24ddbaaaf46634ea$export$de37dab3b3ed8e5c = (0, $bMm60.createEntry)((0, $3f8aaf8df2315fa7$export$94efd60f23d97aa5), {
    component: (0, $ccd3d4fdd976cfb4$export$2e2bcd8739ae039),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        ...(0, $869d34ef1fa542d1$export$bc99aaabaf7b70a7),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039),
        horizontal: (0, $a459ac7703e332ad$export$1eb785f071697cc5),
        onlyShowHorziontalOnNav4: true
    },
    forPaint: [
        (0, $a459ac7703e332ad$export$409c821653bbc63b),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $ccd3d4fdd976cfb4$export$f4aafff31d950b6c),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $24ddbaaaf46634ea$export$94aaa7006da9d63a = (0, $bMm60.createEntry)((0, $3f8aaf8df2315fa7$export$ac102dc13a0f4aff), {
    component: (0, $ccd3d4fdd976cfb4$export$2e2bcd8739ae039),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jbEIb.resources),
        ...(0, $869d34ef1fa542d1$export$bc99aaabaf7b70a7),
        ...(0, $lKYxU.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $ccd3d4fdd976cfb4$export$f4aafff31d950b6c),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $24ddbaaaf46634ea$export$a727cbd3cbcc2153 = [
    $24ddbaaaf46634ea$export$de37dab3b3ed8e5c,
    $24ddbaaaf46634ea$export$94aaa7006da9d63a
];




var $cernH = parcelRequire("cernH");

var $bAQOb = parcelRequire("bAQOb");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");


var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $93552086e1f9a014$export$4b517044f5f7830d = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS),
    path: '/jira/settings/products/ops/jira-service-management-audit-logs',
    exact: true
};
const $93552086e1f9a014$export$678856ccddc0bc05 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD),
    path: '/jira/settings/products/ops/jira-service-management-audit-logs/download/:exportUniqueKey',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $84c32483c994d926$export$6e30e25faf4f6dce = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("cHWGN")), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});

const $84c32483c994d926$export$898c7cb3b28a6104 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("cHWGN")).then(({ CustomerLogsDownloadPage: CustomerLogsDownloadPage })=>CustomerLogsDownloadPage), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$84c32483c994d926$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $84c32483c994d926$export$6e30e25faf4f6dce,
        pageId: "async-jira-eoc-customer-logs",
        shouldShowSpinner: false
    });
const $84c32483c994d926$export$a5786cf859b7b457 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $84c32483c994d926$export$898c7cb3b28a6104,
        pageId: "async-jira-eoc-customer-logs-download",
        shouldShowSpinner: false
    });


const $d04302cded51ff20$export$42ca979ec2919b23 = (0, $bMm60.createEntry)((0, $93552086e1f9a014$export$4b517044f5f7830d), {
    component: (0, $84c32483c994d926$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $da65b4fac0ccb24a$export$bc99aaabaf7b70a7)
    ],
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $84c32483c994d926$export$6e30e25faf4f6dce)
    ]
});
const $d04302cded51ff20$export$d2ce6f09ef8aa840 = (0, $bMm60.createEntry)((0, $93552086e1f9a014$export$678856ccddc0bc05), {
    component: (0, $bAQOb.componentWithFF)('platform.pun.audit-logs-export-log-release_dvp2f', (0, $84c32483c994d926$export$a5786cf859b7b457), (0, $dgH3j.default)),
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $dAKwA.getConsolidationStateResource)(),
        ...(0, $da65b4fac0ccb24a$export$8571305c82629fe4)
    ],
    forPaint: [
        (0, $84c32483c994d926$export$898c7cb3b28a6104)
    ]
});



var $cernH = parcelRequire("cernH");


var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $ksvzS = parcelRequire("ksvzS");
const $3f0181bf3cd7db3b$export$bc99aaabaf7b70a7 = [
    (0, $ksvzS.transitioningDetailsResource)
];



var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $6bb87644c3ee7ae2$export$30306de7e00bc5a2 = {
    group: (0, $exb0h.ROUTE_GROUPS_EOC),
    name: (0, $exb0h.ROUTE_NAMES_EOC_UNLOCK_OPERATIONS),
    path: '/jira/settings/products/ops/unlock',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $9a9c3733894cd7fd$export$55e4754d556d072 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("9om2O")), {
    moduleId: "./src/packages/eoc/unlock-operations/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9a9c3733894cd7fd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9a9c3733894cd7fd$export$55e4754d556d072,
        pageId: "eoc-products-unlock-operations",
        shouldShowSpinner: false
    });


const $ef6b20ae22882fd6$export$c058f4d1c0667ce1 = (0, $bMm60.createEntry)((0, $6bb87644c3ee7ae2$export$30306de7e00bc5a2), {
    layout: (0, $20a3759955606206$export$b8fa7ac7019001bb),
    component: (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, $9a9c3733894cd7fd$export$2e2bcd8739ae039), (0, $dgH3j.default)),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $3f0181bf3cd7db3b$export$bc99aaabaf7b70a7)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $9a9c3733894cd7fd$export$55e4754d556d072)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $eNkBQ = parcelRequire("eNkBQ");

var $cernH = parcelRequire("cernH");


var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $79YNf = parcelRequire("79YNf");

var $59o4i = parcelRequire("59o4i");

const $413a11b1b14313fe$export$7b03e7437c5d4f77 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("k7oAV")), {
    moduleId: "./src/packages/eoc/who-is-on-call/src/ui/index.tsx"
});
const $413a11b1b14313fe$export$51430a0cf6ef3c09 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $413a11b1b14313fe$export$7b03e7437c5d4f77,
        pageId: "async-jira-eoc-who-is-on-call",
        shouldShowSpinner: false
    });
const $413a11b1b14313fe$export$fee33ca9661e49dd = (0, $bMm60.createEntry)((0, $79YNf.whoIsOnCallRoute), {
    layout: (0, $20a3759955606206$export$b8fa7ac7019001bb),
    component: $413a11b1b14313fe$export$51430a0cf6ef3c09,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)(),
        ...(0, $eNkBQ.resources)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $413a11b1b14313fe$export$7b03e7437c5d4f77
    ]
});



var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $6d9982f10bd9204a$export$465fa01c0f3a0551 = {
    group: (0, $exb0h.ROUTE_GROUPS_ERRORS),
    name: (0, $exb0h.ROUTE_NAMES_ERRORS_NOT_FOUND),
    path: '/jira/:projectType(software|servicedesk|core)'
};


const $70b0ad18f4a8155d$export$c4c012a49b465e94 = (0, $bMm60.createEntry)((0, $6d9982f10bd9204a$export$465fa01c0f3a0551), {
    component: (0, $dgH3j.default),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $dgH3j.LazyNotFoundErrorPage)
    ]
});



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");


var $l90Gp = parcelRequire("l90Gp");

var $6cIOm = parcelRequire("6cIOm");

var $5w4hM = parcelRequire("5w4hM");

var $hUM03 = parcelRequire("hUM03");

var $4JtEo = parcelRequire("4JtEo");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $1L86T = parcelRequire("1L86T");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $ixwgj = parcelRequire("ixwgj");

var $kbHFR = parcelRequire("kbHFR");

var $exb0h = parcelRequire("exb0h");
const $1070ef74b890835d$export$392534a80a0b9b11 = {
    name: (0, $exb0h.ROUTE_NAMES_FORGE_ADMIN_SETTINGS),
    path: '/jira/settings/apps/:settingsType(configure|get-started)/:appId/:envId/:route?'
};
const $1070ef74b890835d$export$157f97e6454c2a9f = {
    name: (0, $exb0h.ROUTE_NAMES_FORGE_ADMIN),
    path: '/jira/settings/apps/:appId/:envId/:route?'
};
const $1070ef74b890835d$export$998d01fc8f4c3224 = {
    name: (0, $exb0h.ROUTE_NAMES_FORGE_PROJECT),
    path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/apps/:appId/:envId/:route?'
};
const $1070ef74b890835d$export$b77275b989ab42a6 = {
    name: (0, $exb0h.ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE),
    path: '/jira/servicedesk/projects/:projectKey/queues/apps/:appId/:envId/:route?'
};
const $1070ef74b890835d$export$2ee4468dd8e9636f = {
    name: (0, $exb0h.ROUTE_NAMES_FORGE_FIELD_CONTEXTUAL_CONFIGURATION),
    path: '/jira/settings/issues/field/:fieldId/context/:contextId/configure/app'
};
const $1070ef74b890835d$export$4146dba061d1c72d = {
    name: (0, $exb0h.ROUTE_NAMES_FORGE_GLOBAL),
    path: '/jira/apps/:appId/:envId/:route?'
};



var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $b34bb9dfafeb551e$export$66ee65dcd4a6458d = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("742KF")), {
    moduleId: "./src/packages/spa-apps/forge/admin/src/index.tsx"
});
const $b34bb9dfafeb551e$export$c9e5f500ef472147 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b34bb9dfafeb551e$export$66ee65dcd4a6458d,
        pageId: "forge-spa-admin",
        shouldShowSpinner: true
    });
var $b34bb9dfafeb551e$export$2e2bcd8739ae039 = $b34bb9dfafeb551e$export$c9e5f500ef472147;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $7c029b413050cf74$export$c53e206c7fd6fb76 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("ficsS")), {
    moduleId: "./src/packages/spa-apps/forge/field-contextual-config/src/index.tsx"
});
const $7c029b413050cf74$export$50bd0baee0b2f946 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7c029b413050cf74$export$c53e206c7fd6fb76,
        pageId: "forge-spa-field-context-config",
        shouldShowSpinner: true
    });
var $7c029b413050cf74$export$2e2bcd8739ae039 = $7c029b413050cf74$export$50bd0baee0b2f946;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $d550fe7a86f223e9$export$332293feb5cffd72 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("4bUpA")), {
    moduleId: "./src/packages/spa-apps/forge/global/src/index.tsx"
});
const $d550fe7a86f223e9$export$4c36a7b018e5e5cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d550fe7a86f223e9$export$332293feb5cffd72,
        pageId: "forge-spa-global",
        shouldShowSpinner: true
    });
var $d550fe7a86f223e9$export$2e2bcd8739ae039 = $d550fe7a86f223e9$export$4c36a7b018e5e5cc;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $fa7f1adbdad82c38$export$27b0c9e982208d7e = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("dpEXh")), {
    moduleId: "./src/packages/spa-apps/forge/project/src/index.tsx"
});
const $fa7f1adbdad82c38$export$99737a64be9f5f1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $fa7f1adbdad82c38$export$27b0c9e982208d7e,
        pageId: "forge-spa-project",
        shouldShowSpinner: true
    });
var $fa7f1adbdad82c38$export$2e2bcd8739ae039 = $fa7f1adbdad82c38$export$99737a64be9f5f1;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $ee4c92d972c01d87$export$62e1bcb9c27c99b5 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("6mnfz")), {
    moduleId: "./src/packages/spa-apps/forge/servicedesk-queue/src/index.tsx"
});
const $ee4c92d972c01d87$export$e83b7c5b466e791a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ee4c92d972c01d87$export$62e1bcb9c27c99b5,
        pageId: "forge-spa-servicedesk-queue",
        shouldShowSpinner: true
    });
var $ee4c92d972c01d87$export$2e2bcd8739ae039 = $ee4c92d972c01d87$export$e83b7c5b466e791a;


const $be75b82ac5d10c81$export$fc82fa1ad8302441 = ()=>({
        component: (0, $b34bb9dfafeb551e$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $hUM03.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $b34bb9dfafeb551e$export$66ee65dcd4a6458d)
        ]
    });
const $be75b82ac5d10c81$export$1c55fbe0ae1da308 = ()=>({
        component: (0, $fa7f1adbdad82c38$export$2e2bcd8739ae039),
        layout: (0, $d1szd.genericProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.genericProjectSidebars),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $4qvmP.getBusinessProjectResources)(),
            ...(0, $kbHFR.getServiceDeskSharedNavigationSingleResources)(),
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $l90Gp.forgeProjectModuleResource),
            (0, $ixwgj.projectContextResourceWithCache),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $fa7f1adbdad82c38$export$27b0c9e982208d7e)
        ]
    });
const $be75b82ac5d10c81$export$95c93c3fcfde8901 = ()=>({
        component: (0, $7c029b413050cf74$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $l90Gp.forgeCustomFieldTypeResource),
            (0, $1L86T.fieldContextConfigPageResource),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7c029b413050cf74$export$c53e206c7fd6fb76)
        ]
    });
const $be75b82ac5d10c81$export$a2f53aa48e785c7 = ()=>({
        component: (0, $ee4c92d972c01d87$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ee4c92d972c01d87$export$62e1bcb9c27c99b5)
        ]
    });
const $be75b82ac5d10c81$export$dbdc27694c56b868 = ()=>({
        component: (0, $d550fe7a86f223e9$export$2e2bcd8739ae039),
        layout: (0, $isbb2.createLayout)(),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).ADDONS,
            sidebar: (0, $6cIOm.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $l90Gp.getNavigationForgeGlobalPageResources)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d550fe7a86f223e9$export$332293feb5cffd72)
        ]
    });
const $be75b82ac5d10c81$export$b1d92ac5cda62e7e = [
    (0, $bMm60.createEntry)((0, $1070ef74b890835d$export$392534a80a0b9b11), $be75b82ac5d10c81$export$fc82fa1ad8302441()),
    (0, $bMm60.createEntry)((0, $1070ef74b890835d$export$157f97e6454c2a9f), $be75b82ac5d10c81$export$fc82fa1ad8302441()),
    (0, $bMm60.createEntry)((0, $1070ef74b890835d$export$998d01fc8f4c3224), $be75b82ac5d10c81$export$1c55fbe0ae1da308()),
    (0, $bMm60.createEntry)((0, $1070ef74b890835d$export$b77275b989ab42a6), $be75b82ac5d10c81$export$a2f53aa48e785c7()),
    (0, $bMm60.createEntry)((0, $1070ef74b890835d$export$2ee4468dd8e9636f), $be75b82ac5d10c81$export$95c93c3fcfde8901()),
    (0, $bMm60.createEntry)((0, $1070ef74b890835d$export$4146dba061d1c72d), $be75b82ac5d10c81$export$dbdc27694c56b868())
];



var $cernH = parcelRequire("cernH");

var $2ijRB = parcelRequire("2ijRB");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $c7a08da0e4520818$export$e69b84daf70501b3 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_MAIL_SETTINGS),
    path: '/secure/admin/global-mail-settings',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $aUSBv = parcelRequire("aUSBv");

var $gUUjF = parcelRequire("gUUjF");

var $5oIBC = parcelRequire("5oIBC");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $lB25E = parcelRequire("lB25E");

var $90IgZ = parcelRequire("90IgZ");
const $cdf3eb6145229a81$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "redirect.legacy-routing.flags.error.title",
        "defaultMessage": "We can't find the page you're looking for"
    },
    description: {
        "id": "redirect.legacy-routing.flags.error.description",
        "defaultMessage": "Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content."
    },
    goHome: {
        "id": "redirect.legacy-routing.flags.error.go-home",
        "defaultMessage": "Go to the homepage"
    }
});


const $71d40e54e45bfb05$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        title: (0, $cdf3eb6145229a81$export$defe85febe8b728c).title,
        description: (0, $cdf3eb6145229a81$export$defe85febe8b728c).description,
        actions: [
            {
                content: (0, $cdf3eb6145229a81$export$defe85febe8b728c).goHome,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.assign('/')
            }
        ]
    });


const $9f087e464fef57a9$var$THRESHOLD = 30000;
const $9f087e464fef57a9$var$getScopeType = (scope)=>{
    switch(scope.identifierType){
        case 'boardId':
            return 'board';
        case 'projectId':
        case 'projectKey':
            return scope.pageType === 'settings' ? 'projectSettings' : 'project';
        default:
            return '';
    }
};
class $9f087e464fef57a9$export$836fe1ef2cfde075 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { location: { pathname: pathname, search: search }, flagService: flagService, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const redirectPathname = pathname.startsWith('//') ? pathname.substr(1) : pathname;
        const lastRedirectTime = Number(sessionStorage.getItem(redirectPathname));
        if (!lastRedirectTime) sessionStorage.setItem(redirectPathname, Date.now().toString());
        else if (Date.now() - lastRedirectTime < $9f087e464fef57a9$var$THRESHOLD) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const scopeData = (0, $aUSBv.default)(window.location.href, (0, $6rW04.default));
            const scope = $9f087e464fef57a9$var$getScopeType(scopeData);
            (0, $gUUjF.default).safeErrorWithoutCustomerData('redirect-loop.error', 'Redirect error caused by invalid url', {
                scope: scope
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                action: 'entered'
            }), 'redirect-loop entered', 'endeavour.spa.redirect-loop', {
                scope: scope
            });
            flagService.showFlag((0, $71d40e54e45bfb05$export$b9a7f1ebeaa76953)());
            sessionStorage.removeItem(redirectPathname);
            return;
        } else sessionStorage.removeItem(redirectPathname);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(redirectPathname + search);
    }
    render() {
        return null;
    }
}
var // @ts-expect-error - TS2345 - Argument of type 'ForwardRefExoticComponent<Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>>' is not assignable to parameter of type 'ComponentType<{ flagService: FlagService; }>'. | TS2345 - Argument of type 'typeof RedirectToLegacyRouting' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & typeof RedirectToLegacyRouting) | ((new (props: WithAnalyticsEventsProps) => Component<...>) & typeof RedirectToLegacyRouting)'.
$9f087e464fef57a9$export$2e2bcd8739ae039 = (0, $lB25E.withRouter)((0, $5oIBC.default)((0, $2jDha.default)()($9f087e464fef57a9$export$836fe1ef2cfde075)));


var /** This exists to be used as a route since the redirect as a route and redirect as a component
 * have different props, and flow complains. */ // @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': location, query, route, match, action
// eslint-disable-next-line jira/import/no-anonymous-default-export
$291599ef708fe49c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9f087e464fef57a9$export$2e2bcd8739ae039), null);



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $ddbf83b09ae1ab4d$export$a133d90b2004a90e = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("2biqf"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/global-mail-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ddbf83b09ae1ab4d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ddbf83b09ae1ab4d$export$a133d90b2004a90e,
        pageId: "global-mail-settings",
        shouldShowSpinner: false
    });


const $f7decf7961ae87b9$export$5e1236665a530df4 = (0, $bMm60.createEntry)((0, $c7a08da0e4520818$export$e69b84daf70501b3), {
    ufoName: 'admin.global-mail-settings',
    component: (0, $2ijRB.default)(()=>true, (0, $ddbf83b09ae1ab4d$export$2e2bcd8739ae039), (0, $291599ef708fe49c$export$2e2bcd8739ae039)),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $ddbf83b09ae1ab4d$export$a133d90b2004a90e)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $7pdDu = parcelRequire("7pdDu");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $190982ff9321149d$export$45e7d93edcc9507f = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS),
    path: '/secure/admin/ViewCustomFields(!default)?.jspa'
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $fafd69dd154a006a$export$55a5c16f39a046af = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("fxuL1"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/custom-fields-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fafd69dd154a006a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $fafd69dd154a006a$export$55a5c16f39a046af,
        pageId: "admin-pages-custom-fields-directory",
        shouldShowSpinner: true
    });


const $4cae923e7c81fee6$export$d83c2e469d070766 = (0, $bMm60.createEntry)((0, $190982ff9321149d$export$45e7d93edcc9507f), {
    ufoName: 'admin.custom-fields-directory',
    component: (0, $fafd69dd154a006a$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        (0, $7pdDu.customFieldsDirectoryResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $fafd69dd154a006a$export$55a5c16f39a046af)
    ]
});



var $918eN = parcelRequire("918eN");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $6611056fd52921ab$export$2eaffde3ad991b33 = {
    group: (0, $exb0h.ROUTE_GROUPS_HOME),
    name: (0, $exb0h.ROUTE_NAMES_HOME_ONBOARDING_REDIRECT),
    path: '/jira/your-work-onboarding',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $d6f6c = parcelRequire("d6f6c");

var $lB25E = parcelRequire("lB25E");
/**
 * This component will cause an SPA transition (and overwrite of current history) to Your work or the Projects directory
 * depending on whether nav-v3, Your work's deep dive cards, and the JSW onboarding flows in Your work are enabled.
 */ const $1dff71694523fcab$var$JiraHomeOnboardingRedirect = ()=>{
    const { replace: replace } = (0, $lB25E.useRouterActions)();
    replace('/jira/your-work');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        eventName: "JiraHomeOnboardingRedirect loaded",
        componentName: "JiraHomeOnboardingRedirect",
        attributes: {
            isRedirectionEnabled: true
        }
    });
};
var $1dff71694523fcab$export$2e2bcd8739ae039 = $1dff71694523fcab$var$JiraHomeOnboardingRedirect;


const $c21644fb8a992f95$export$2740cfaa979353b9 = (0, $bMm60.createEntry)((0, $6611056fd52921ab$export$2eaffde3ad991b33), {
    component: (0, $1dff71694523fcab$export$2e2bcd8739ae039),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    isRedirect: true,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $f073503a37a4d67a$export$f7a252c9d61f8f94 = {
    group: (0, $exb0h.ROUTE_GROUPS_HOME),
    name: (0, $exb0h.ROUTE_NAMES_HOME_REDIRECT),
    path: '/jira',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $4uxD3 = parcelRequire("4uxD3");

var $lB25E = parcelRequire("lB25E");
const $4b4ea64722ce8937$export$25a759e49d5049db = 'spa-apps.common.redirect.jira-base-routing';


const $69d3cca6c637e03e$var$JiraBaseRedirectWrapper = ()=>{
    const { data: data, loading: loading } = (0, $lB25E.useResource)((0, $4uxD3.userHomepageResource));
    (0, $eUqFw.useEffect)(()=>{
        if (!loading && data == null) (0, $gUUjF.default).safeInfoWithoutCustomerData((0, $4b4ea64722ce8937$export$25a759e49d5049db), 'userHomepage data is null');
    }, [
        loading,
        data
    ]);
    if (loading) return null;
    // redirect to monolith to handle "/jira" route if homepageData is null (should not happen)
    if (data == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.replace('/jira');
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: data.homepagePreference
    });
};
var $69d3cca6c637e03e$export$2e2bcd8739ae039 = $69d3cca6c637e03e$var$JiraBaseRedirectWrapper;


var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2a2e93d2ac19a203$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69d3cca6c637e03e$export$2e2bcd8739ae039), null);


const $5e7adb561c10220c$export$5379c026da4201e6 = (0, $bMm60.createEntry)((0, $f073503a37a4d67a$export$f7a252c9d61f8f94), {
    component: (0, $2a2e93d2ac19a203$export$2e2bcd8739ae039),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    isRedirect: true,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $bMm60 = parcelRequire("bMm60");

var $3MEW8 = parcelRequire("3MEW8");

var $exb0h = parcelRequire("exb0h");
const $909f2c4044c0d832$export$c155f4de16b62110 = {
    group: (0, $exb0h.ROUTE_GROUPS_ISSUE),
    name: (0, $exb0h.ROUTE_NAMES_ISSUE_CREATE_EMBED),
    path: '/jira/issues/create/embed'
};



var $bhwgQ = parcelRequire("bhwgQ");

var $59o4i = parcelRequire("59o4i");
const $b3df52e8783e1d6e$var$handleEmbedLinkClick = (e)=>{
    const eventTarget = e.target;
    // this is used for handling all the button clicks inside the iframe to open the new link in a new tab
    // as this view is mainly used an embed view inside an iframe.
    if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
    eventTarget.target = '_blank';
};

const $b3df52e8783e1d6e$export$980ea815ec2d0180 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("9CiS9")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/issue-create-embed/src/index.tsx"
});
const $b3df52e8783e1d6e$export$87fa8eff34eb030a = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', $b3df52e8783e1d6e$var$handleEmbedLinkClick, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', $b3df52e8783e1d6e$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b3df52e8783e1d6e$export$980ea815ec2d0180,
        pageId: "spa-apps/issue-create-embed",
        shouldShowSpinner: true
    }));
};
const $b3df52e8783e1d6e$export$abd0bbe95839baf7 = (0, $bMm60.createEntry)((0, $909f2c4044c0d832$export$c155f4de16b62110), {
    component: $b3df52e8783e1d6e$export$87fa8eff34eb030a,
    resources: [
        (0, $3MEW8.themePreferenceResource)
    ],
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
    forPaint: [
        $b3df52e8783e1d6e$export$980ea815ec2d0180
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");



var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $d1szd = parcelRequire("d1szd");


var $fnP3y = parcelRequire("fnP3y");

var $sFzm1 = parcelRequire("sFzm1");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $guDlK = parcelRequire("guDlK");

var $bNe1g = parcelRequire("bNe1g");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $dvBSb = parcelRequire("dvBSb");

var $5kTYh = parcelRequire("5kTYh");

var $iudJZ = parcelRequire("iudJZ");

var $kSgnh = parcelRequire("kSgnh");

var $lB25E = parcelRequire("lB25E");

var $2skem = parcelRequire("2skem");
const $8d305223106bbf32$export$3b5744f70b49a5c4 = (0, $lB25E.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_READ_PERM',
    getKey: ({ match: match })=>match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : '',
    getData: ()=>null,
    isBrowserOnly: true
}));



var $9PXNH = parcelRequire("9PXNH");

var $lB25E = parcelRequire("lB25E");

var $2skem = parcelRequire("2skem");
const $fffb40acdfdf7acd$export$80c2a5c658bd9e1e = (0, $lB25E.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_UPLOAD_PERM',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getData: ()=>null,
    isBrowserOnly: true
}));



var $9PXNH = parcelRequire("9PXNH");

var $lB25E = parcelRequire("lB25E");

var $2skem = parcelRequire("2skem");
const $8751cd044263fd79$export$48db4eb29e9be72c = (0, $lB25E.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_USER_AUTH',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getData: ()=>null,
    isBrowserOnly: true
}));



var $hHrVM = parcelRequire("hHrVM");

var $aBAel = parcelRequire("aBAel");

var $hRe6W = parcelRequire("hRe6W");

var $3MEW8 = parcelRequire("3MEW8");

var $jwzNs = parcelRequire("jwzNs");

var $3JUND = parcelRequire("3JUND");

var $cV47S = parcelRequire("cV47S");

var $c4qEZ = parcelRequire("c4qEZ");

var $dY715 = parcelRequire("dY715");

var $59o4i = parcelRequire("59o4i");

var $lB25E = parcelRequire("lB25E");
const $f020c38e81fdeaa8$var$pageId = 'spa-issue';
const $f020c38e81fdeaa8$var$conditionalIssueGiraNonCriticalDataResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w'), (0, $kSgnh.issueGiraNonCriticalDataResource));
const $f020c38e81fdeaa8$var$conditionalSmartRepliesOptInStatusResources = (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('smart_replies_m1_jira_labs'), (0, $fnP3y.smartRepliesOptInStatusResources));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f020c38e81fdeaa8$var$LazyIssuePage = (0, $6VZoe.lazyForPaint)(()=>(0, $dY715.markAsBentoBundleReady)((parcelRequire("bQUp7"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});
const $f020c38e81fdeaa8$export$c1a868ace2f38803 = ()=>{
    const { data: data } = (0, $bNe1g.useProjectContext)();
    const [issueKey] = (0, $lB25E.usePathParam)('issueKey');
    const [projectKey, issueSuffix] = issueKey !== undefined ? issueKey.split('-') : [];
    let actualIssueKey = issueKey;
    if (data?.projectKey && data.projectKey !== projectKey) actualIssueKey = `${data.projectKey}-${issueSuffix}`;
    // special handling for product discovery (=== Polaris) project issues. During the experimental phase of
    // the polaris idea view (product-specific issue view), we will redirect to a polaris-specific issue view
    // page here instead of bento.
    // this will only happen for issues of this specific project type, and only if the switchover FF is enabled
    if (!false && data?.projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT) && data?.projectKey !== undefined && actualIssueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/jira/polaris/projects/${data.projectKey}/ideas?selectedIssue=${actualIssueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f020c38e81fdeaa8$var$LazyIssuePage,
        pageId: $f020c38e81fdeaa8$var$pageId,
        shouldShowSpinner: false
    });
};
const $f020c38e81fdeaa8$export$ef02bcc0eb1d9ded = ()=>{
    const [issueKey] = (0, $lB25E.usePathParam)('issueKey');
    const projectKey = (0, $guDlK.useProjectKey)(issueKey || '');
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const projectId = (0, $guDlK.useProjectId)(projectKey);
    // Special handling for product discovery (=== Polaris) project issues in embed mode.
    // We have to redirect to Polaris issue embed view instead of loading Jira issue view.
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT) && projectKey !== undefined && projectId !== undefined && issueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/secure/JiraProductDiscoveryEmbedded.jspa?projectId=${projectId}&projectKey=${projectKey}&issueKey=${issueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sFzm1.EmbedModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f020c38e81fdeaa8$export$c1a868ace2f38803, null));
};
const $f020c38e81fdeaa8$export$cef770e7c16cfcc = (0, $bMm60.createEntry)((0, $3JUND.browseIssueRoute), {
    component: $f020c38e81fdeaa8$export$c1a868ace2f38803,
    skeleton: (0, $c4qEZ.IssueViewSkeleton),
    layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$98e337c40eb151da)),
    navigation: {
        sidebar: (0, $5w4hM.genericProjectSidebars),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $aBAel.getOfferingCatalogueFeaturesResource)(),
        (0, $8d305223106bbf32$export$3b5744f70b49a5c4),
        (0, $8751cd044263fd79$export$48db4eb29e9be72c),
        (0, $iudJZ.issueGiraDataResource),
        $f020c38e81fdeaa8$var$conditionalIssueGiraNonCriticalDataResource,
        (0, $fffb40acdfdf7acd$export$80c2a5c658bd9e1e),
        (0, $5kTYh.issueForgeDataResource),
        (0, $dvBSb.issueViewRelayResource),
        (0, $hRe6W.queuesNavigationItems),
        (0, $cV47S.workspaceResource),
        (0, $dAKwA.getConsolidationStateResource)(),
        $f020c38e81fdeaa8$var$conditionalSmartRepliesOptInStatusResources
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $f020c38e81fdeaa8$var$LazyIssuePage
    ],
    ufoName: 'issue-view',
    meta: {
        capability: (0, $d07297a4af13004b$export$ef94a84e2990361c)
    },
    bifrost: {
        bundling: {
            packageName: '@atlassian/jira-router-routes-issue-entries',
            whichExportToUse: 'browseIssueRouteEntry'
        },
        enabled: true
    }
});
const $f020c38e81fdeaa8$export$e275b3ca0c6ccb5e = (0, $bMm60.createEntry)((0, $3JUND.browseIssueEmbedRoute), {
    component: $f020c38e81fdeaa8$export$ef02bcc0eb1d9ded,
    skeleton: (0, $c4qEZ.IssueViewSkeleton),
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getModernIssueTransitionResources)(),
        (0, $8d305223106bbf32$export$3b5744f70b49a5c4),
        (0, $8751cd044263fd79$export$48db4eb29e9be72c),
        (0, $iudJZ.issueGiraDataResource),
        $f020c38e81fdeaa8$var$conditionalIssueGiraNonCriticalDataResource,
        (0, $fffb40acdfdf7acd$export$80c2a5c658bd9e1e),
        (0, $5kTYh.issueForgeDataResource),
        (0, $dvBSb.issueViewRelayResource),
        (0, $hRe6W.queuesNavigationItems),
        (0, $cV47S.workspaceResource),
        (0, $3MEW8.themePreferenceResource),
        $f020c38e81fdeaa8$var$conditionalSmartRepliesOptInStatusResources
    ],
    forPaint: [
        $f020c38e81fdeaa8$var$LazyIssuePage
    ],
    ufoName: 'issue-view-embed',
    meta: {
        capability: (0, $d07297a4af13004b$export$ef94a84e2990361c)
    },
    bifrost: {
        bundling: {
            packageName: '@atlassian/jira-router-routes-issue-entries',
            whichExportToUse: 'browseIssueEmbedRouteEntry'
        },
        enabled: true
    }
});



var $jh2R9 = parcelRequire("jh2R9");

var $cernH = parcelRequire("cernH");

var $b3nmi = parcelRequire("b3nmi");


var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $d1szd = parcelRequire("d1szd");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");


var $lw0Lc = parcelRequire("lw0Lc");

var $51qRF = parcelRequire("51qRF");

var $62ZdZ = parcelRequire("62ZdZ");

var $buaC1 = parcelRequire("buaC1");

var $fxlTA = parcelRequire("fxlTA");

var $5w4hM = parcelRequire("5w4hM");

var $kIY50 = parcelRequire("kIY50");

var $iOOlt = parcelRequire("iOOlt");

var $iTYGl = parcelRequire("iTYGl");

var $2Fzrk = parcelRequire("2Fzrk");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $cINNO = parcelRequire("cINNO");

var $cWgoa = parcelRequire("cWgoa");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $hRe6W = parcelRequire("hRe6W");

var $jwzNs = parcelRequire("jwzNs");


var $1tmBn = parcelRequire("1tmBn");

var $csLgO = parcelRequire("csLgO");

var $kKpAY = parcelRequire("kKpAY");

var $iPtkN = parcelRequire("iPtkN");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $eMdFV = parcelRequire("eMdFV");

var $1h6H8 = parcelRequire("1h6H8");

var $4D6hU = parcelRequire("4D6hU");

var $kKpAY = parcelRequire("kKpAY");


var $59o4i = parcelRequire("59o4i");

var $6yplV = parcelRequire("6yplV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$46cfd36e45863fc5$export$2e2bcd8739ae039 = ({ params: params }, { filter: filter, orderby: orderby, keyword: keyword })=>{
    const { projectKey: projectKey, issueKey: issueKey } = params;
    const pageIdPrefix = 'new-issue-navigator';
    let pageId = '';
    try {
        pageId = `${pageIdPrefix}${(projectKey !== null && projectKey !== undefined ? `-${projectKey}` : '') + (issueKey !== null && issueKey !== undefined ? `-${issueKey}` : '') + (filter !== undefined ? `-${filter}` : '') + (orderby !== undefined ? `-${orderby}` : '') + (keyword !== undefined ? `-${keyword}` : '')}`;
    } catch  {
        pageId = pageIdPrefix;
    }
    return pageId;
};



const $7f18d9588e93cd1d$export$5fcc10c40c224fbc = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("6Jtpt")).then((module)=>module.ProjectIssueNavigatorSPA)), {
    moduleId: "./src/packages/spa-apps/project-issue-navigator/src/index.tsx"
});
const $7f18d9588e93cd1d$export$2de79bdf33dbf27c = ({ match: match, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7f18d9588e93cd1d$export$5fcc10c40c224fbc,
        pageId: (0, $46cfd36e45863fc5$export$2e2bcd8739ae039)(match, query),
        shouldShowSpinner: false
    });

const $7f18d9588e93cd1d$export$8570b543078b8f17 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("6Jtpt")).then((module)=>module.ServiceDeskProjectIssueNavigatorSPA)), {
    moduleId: "./src/packages/spa-apps/project-issue-navigator/src/index.tsx"
});
const $7f18d9588e93cd1d$export$5cc1791bbdb6f266 = ({ match: match, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7f18d9588e93cd1d$export$8570b543078b8f17,
        pageId: (0, $46cfd36e45863fc5$export$2e2bcd8739ae039)(match, query),
        shouldShowSpinner: false
    });

const $7f18d9588e93cd1d$export$8ff267588532c2ce = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("aYTNj")), {
    moduleId: "./src/packages/spa-apps/global-issue-navigator/src/index.tsx"
});
const $7f18d9588e93cd1d$export$4bd5bc3fa8a52567 = ({ match: match, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7f18d9588e93cd1d$export$8ff267588532c2ce,
        pageId: (0, $46cfd36e45863fc5$export$2e2bcd8739ae039)(match, query),
        shouldShowSpinner: false
    });
const $7f18d9588e93cd1d$export$3b4f172f4310bbc = (props)=>{
    const [isNinGlobalScopeEnrolmentEnabled, resourceData] = (0, $eMdFV.useGlobalScopeEnrolmentEnable)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    // Regardless of the existing localStorageData value, we update the localStorage value once we get resourceData so
    // that future renders are fast and accurate.
    (0, $eUqFw.useEffect)(()=>{
        if (resourceData !== null && resourceData !== undefined) (0, $1h6H8.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(resourceData);
    }, [
        resourceData
    ]);
    // If NIN in global scope is not enabled then we redirect to legacy GIN by performing a reload
    (0, $eUqFw.useEffect)(()=>{
        if (isNinGlobalScopeEnrolmentEnabled === false) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, [
        isNinGlobalScopeEnrolmentEnabled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isNinGlobalScopeEnrolmentEnabled) {
            // If we are in global scope nin then reset/enable the forced opt out flag for GIN if we haven't done it already
            const globalGINFlagDisabled = (0, $1h6H8.getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage)();
            if (globalGINFlagDisabled !== false) {
                !isAnonymous && (0, $4D6hU.resetGlobalScopeForcedOptOutGinFlag)();
                (0, $1h6H8.setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage)();
            }
        }
    }, [
        isAnonymous,
        isNinGlobalScopeEnrolmentEnabled
    ]);
    // If NIN in global scope is enabled then we render it. If NIN in global scope is not enabled, or we're blocked
    // waiting on the resource to load then we render GlobalIssueNavigatorSkeleton.
    return isNinGlobalScopeEnrolmentEnabled === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7f18d9588e93cd1d$export$4bd5bc3fa8a52567, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKpAY.GlobalIssueNavigatorSkeleton), null);
};



var $eUqFw = parcelRequire("eUqFw");

var $atRHQ = parcelRequire("atRHQ");

var $lB25E = parcelRequire("lB25E");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$74828a2871cc60ec$export$2e2bcd8739ae039 = ()=>{
    const [{ match: match }] = (0, $lB25E.useRouter)();
    const issueKey = match.params.issueKey ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: `/issues/${issueKey}`
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $guiFP = parcelRequire("guiFP");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $ixwgj = parcelRequire("ixwgj");

var $lB25E = parcelRequire("lB25E");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a96138dd0c605115$export$2e2bcd8739ae039 = ()=>{
    const [{ match: match, query: query }] = (0, $lB25E.useRouter)();
    const { data: data, error: error, loading: loading } = (0, $lB25E.useResource)((0, $ixwgj.projectContextResource));
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $guiFP.default)({
            meta: {
                id: 'useResourceProjectContext',
                packageName: 'jiraRouterRoutesIssueNavigatorEntries'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error
    ]);
    if (!data && !loading || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "pinRedirectFailed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
    if (!data) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const issueKey = match.params.issueKey ?? '';
    const queryParams = new URLSearchParams(query).toString();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "pinRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/jira/${type}/projects/${projectKey}/issues/${issueKey}?${queryParams}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};


const $81a426de012c30b2$var$common = {
    apdexIgnoreParams: [
        'issueKey'
    ],
    meta: {
        capability: (0, $d07297a4af13004b$export$d0ad1160bb95ce50),
        reporting: {
            id: (0, $exb0h.ROUTE_GROUPS_ISSUE_NAVIGATOR),
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_GROUPS_ISSUE_NAVIGATOR)),
            teamName: 'empanada'
        }
    }
};
const $81a426de012c30b2$var$getCommonProjectResources = ()=>[
        (0, $cWgoa.issueNavigatorRelayResource),
        (0, $cWgoa.issueNavigatorFilterRelayResource),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('nin_request_hydrate_query_earlier'), (0, $cWgoa.issueNavigatorHydrationRelayResource)),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)(),
        (0, $jwzNs.resourceWithCondition)(()=>(0, $1ybV0.ff)('nin.global-scope_aqec8'), (0, $62ZdZ.sidebarProjectIssuesResource)),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('nin.global-scope_aqec8'), (0, $cINNO.isNinGlobalScopeEnrolmentEnabledResource)),
        // this resource is also used by the nav4 sidebar for JSM project's 'issues and filters'
        // src/packages/navigation-apps/sidebar-nav4/jsm-project-menu/src/ui/project-menu/issues-and-filters/default-filters/index.tsx
        (0, $51qRF.staticSidebarDefaultPINFiltersResource)
    ];
const $81a426de012c30b2$var$getCommonProject = ()=>({
        component: (0, $7f18d9588e93cd1d$export$2de79bdf33dbf27c),
        skeleton: (0, $iPtkN.ProjectIssueNavigatorSkeleton),
        resources: [
            ...$81a426de012c30b2$var$getCommonProjectResources()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ]
    });
const $81a426de012c30b2$var$getCommonProjectLayout = ()=>(0, $isbb2.createLayout)((0, $d1szd.genericProjectLayout));
const $81a426de012c30b2$var$getCommonGlobal = ()=>({
        component: (0, $7f18d9588e93cd1d$export$3b4f172f4310bbc),
        skeleton: (0, $kKpAY.GlobalIssueNavigatorSkeleton),
        layout: (0, $dVvIP.globalLayout),
        canTransitionIn: ()=>(0, $1ybV0.ff)('nin.global-scope_aqec8'),
        resources: [
            (0, $cWgoa.issueNavigatorRelayResource),
            (0, $cWgoa.issueNavigatorFilterRelayResource),
            (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('nin_request_hydrate_query_earlier'), (0, $cWgoa.issueNavigatorHydrationRelayResource)),
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $cINNO.isNinGlobalScopeEnrolmentEnabledResource),
            (0, $jwzNs.resourceWithCondition2)((0, $kIY50.getWillShowNav3), (0, $lw0Lc.sidebarFiltersGlobalResource))
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).FILTERS,
            sidebar: (0, $fxlTA.AsyncSidebarFiltersGlobal)
        }
    });
const $81a426de012c30b2$export$f9a1f59ec7d1f215 = [
    (0, $bMm60.createEntry)((0, $1tmBn.projectIssueNavigatorRoute), {
        ...$81a426de012c30b2$var$getCommonProject(),
        ...$81a426de012c30b2$var$common,
        component: (0, $a96138dd0c605115$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$5fcc10c40c224fbc)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.genericProjectSidebars),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...$81a426de012c30b2$var$getCommonProject().resources,
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        layout: $81a426de012c30b2$var$getCommonProjectLayout()
    }),
    (0, $bMm60.createEntry)((0, $1tmBn.softwareIssueNavigatorRoute), {
        ...$81a426de012c30b2$var$getCommonProject(),
        ...$81a426de012c30b2$var$common,
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$5fcc10c40c224fbc)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        layout: (0, $isbb2.createLayout)((0, $soOXK.softwareProjectLayoutNoOnboarding))
    }),
    (0, $bMm60.createEntry)((0, $1tmBn.projectIssueNavigatorClassicRoute), {
        ...$81a426de012c30b2$var$getCommonProject(),
        ...$81a426de012c30b2$var$common,
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$5fcc10c40c224fbc)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        layout: $81a426de012c30b2$var$getCommonProjectLayout()
    }),
    (0, $bMm60.createEntry)((0, $1tmBn.servicedeskIssuesRoute), {
        ...$81a426de012c30b2$var$getCommonProject(),
        ...$81a426de012c30b2$var$common,
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$8570b543078b8f17)
        ],
        component: (0, $7f18d9588e93cd1d$export$5cc1791bbdb6f266),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...$81a426de012c30b2$var$getCommonProjectResources(),
            (0, $hRe6W.queuesNavigationItems),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        layout: (0, $csLgO.serviceProjectLayout)
    }),
    (0, $bMm60.createEntry)((0, $1tmBn.projectIssueNavigatorCoreRoute), {
        ...$81a426de012c30b2$var$getCommonProject(),
        ...$81a426de012c30b2$var$common,
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$5fcc10c40c224fbc)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        layout: $81a426de012c30b2$var$getCommonProjectLayout()
    }),
    (0, $bMm60.createEntry)((0, $1tmBn.globalIssueNavigatorRoute), {
        ...$81a426de012c30b2$var$getCommonGlobal(),
        ...$81a426de012c30b2$var$common,
        ufoName: 'global-issue-navigator-jfe',
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$8ff267588532c2ce)
        ]
    }),
    (0, $bMm60.createEntry)((0, $1tmBn.globalIssueNavigator1Route), {
        ...$81a426de012c30b2$var$getCommonGlobal(),
        ...$81a426de012c30b2$var$common,
        ufoName: 'global-issue-navigator-jfe',
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$8ff267588532c2ce)
        ]
    }),
    (0, $bMm60.createEntry)((0, $1tmBn.globalIssueNavigatorBrowseIssueRedirectRoute), {
        ...$81a426de012c30b2$var$getCommonGlobal(),
        ...$81a426de012c30b2$var$common,
        component: (0, $74828a2871cc60ec$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$8ff267588532c2ce)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $eNkBQ = parcelRequire("eNkBQ");

var $cernH = parcelRequire("cernH");

var $jf8p7 = parcelRequire("jf8p7");

var $7z3So = parcelRequire("7z3So");


var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");


var $dAKwA = parcelRequire("dAKwA");

var $2BbQD = parcelRequire("2BbQD");

var $hHrVM = parcelRequire("hHrVM");

var $g08Zs = parcelRequire("g08Zs");

var $3yBpr = parcelRequire("3yBpr");


var $59o4i = parcelRequire("59o4i");

const $4f31ccd2cefdb1fe$var$LazyJiraHomePage = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("gLhzs"))), {
    moduleId: "./src/packages/spa-apps/jira-home/src/index.tsx"
});
const $4f31ccd2cefdb1fe$var$checkConsolidationOnRouteDependency = async (dependencies)=>{
    const data = await dependencies[0, $02315c431173f662$export$25ee35b01de9d734].promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $jf8p7.checkShouldUseJSM)(data);
};
const $4f31ccd2cefdb1fe$export$fe7946d7dc386f9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4f31ccd2cefdb1fe$var$LazyJiraHomePage,
        pageId: "jira-home",
        shouldShowSpinner: false
    });
const $4f31ccd2cefdb1fe$export$578dcb61ac3cb57a = (0, $bMm60.createEntry)((0, $g08Zs.jiraHomeRoute), {
    ufoName: 'jira-home',
    component: $4f31ccd2cefdb1fe$export$fe7946d7dc386f9c,
    skeleton: (0, $3yBpr.YourWorkSkeleton),
    layout: (0, $f7d46703104602dd$export$5b7fb151d60504c),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).HOME
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $2BbQD.jiraHomeResourceWithCache),
        (0, $7z3So.jiraHomePageRightSidePanelResource),
        (0, $dAKwA.getConsolidationStateResource)(),
        ...(0, $eNkBQ.widgetResources).map((resourceCreator)=>resourceCreator($4f31ccd2cefdb1fe$var$checkConsolidationOnRouteDependency, [
                (0, $02315c431173f662$export$25ee35b01de9d734)
            ]))
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $4f31ccd2cefdb1fe$var$LazyJiraHomePage
    ]
});



var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $7c351d9ec6c74c7c$export$a3a93dcf611b611a = {
    group: (0, $exb0h.ROUTE_GROUPS_REDIRECTS),
    name: (0, $exb0h.ROUTE_NAMES_JIRA_SEARCH),
    path: '/jira/search',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $c4qEZ = parcelRequire("c4qEZ");

var $lB25E = parcelRequire("lB25E");

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $10fdS = parcelRequire("10fdS");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cINNO = parcelRequire("cINNO");

var $lB25E = parcelRequire("lB25E");
const $a301dcdfb79d4ff5$export$968c2900ae111000 = ({ Redirect: Redirect = (0, $lB25E.Redirect), fireScreenAnalytics: fireScreenAnalytics = (0, $jMP2a.fireScreenAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useCurrentRoute: useCurrentRoute = (0, $10fdS.useCurrentRoute), useQueryParam: useQueryParam = (0, $lB25E.useQueryParam) })=>{
    const route = useCurrentRoute();
    const [searchString] = useQueryParam('searchString');
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    let isNinEnabled;
    if ((0, $1ybV0.ff)('nin_expose_text_option_jql_builder_4kwzo')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ data: isNinEnabled } = (0, $lB25E.useResource)((0, $cINNO.isNinGlobalScopeEnrolmentEnabledResource)));
    else isNinEnabled = true;
    (0, $eUqFw.useEffect)(()=>{
        if (!route) return;
        const screenEvent = createAnalyticsEvent({
            screenName: 'quickSearchRedirect',
            attributes: {
                type: route.name
            }
        });
        fireScreenAnalytics(screenEvent);
    }, [
        createAnalyticsEvent,
        fireScreenAnalytics,
        route
    ]);
    let jql;
    if (isNinEnabled && (0, $1ybV0.ff)('nin_expose_text_option_jql_builder_4kwzo')) jql = searchString != null ? `summary ~ "${searchString}" OR description ~ "${searchString}" ORDER BY created DESC` : 'ORDER BY created DESC';
    else jql = searchString != null ? `text ~ "${searchString}"` : 'order by created DESC';
    const redirectUrl = `/issues/?jql=${encodeURIComponent(jql)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: redirectUrl
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a301dcdfb79d4ff5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a301dcdfb79d4ff5$export$968c2900ae111000, null);



var $53ciZ = parcelRequire("53ciZ");

var $2OdyW = parcelRequire("2OdyW");

var $lB25E = parcelRequire("lB25E");
const $264f0048e7ca8a95$export$486bd66a4d919be7 = 'RESOURCE_TYPE_JIRA_SEARCH';
const $264f0048e7ca8a95$export$d23832be0ebf8a93 = (0, $lB25E.createResource)({
    type: $264f0048e7ca8a95$export$486bd66a4d919be7,
    getKey: ()=>'search',
    getData: ({ query: query }, { tenantContext: tenantContext })=>{
        const { atlassianAccountId: atlassianAccountId } = tenantContext;
        if (!atlassianAccountId || !query?.searchString) return null;
        const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
            searchString: query.searchString
        });
        return (0, $2OdyW.default)(`/rest/navigation/4/quicksearch?${queryStr}`);
    },
    isBrowserOnly: true
});


const $33847b51b7819bfd$export$ee180957879b33ac = ()=>{
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)((0, $264f0048e7ca8a95$export$d23832be0ebf8a93));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), null);
    if (error || !data?.url) // handle api error state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a301dcdfb79d4ff5$export$968c2900ae111000), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: data.url,
        push: false
    });
};



const $13903430967d785b$export$76b74d5744e69817 = (0, $bMm60.createEntry)((0, $7c351d9ec6c74c7c$export$a3a93dcf611b611a), {
    component: (0, $33847b51b7819bfd$export$ee180957879b33ac),
    isRedirect: true,
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $264f0048e7ca8a95$export$d23832be0ebf8a93)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $exb0h = parcelRequire("exb0h");
const $8e4b0143fd4c66be$export$176ff76c3ba7c4ce = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_REDIRECT)
};



// @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': query, location, route, match, action
const $aa194b628782eb2f$var$RedirectComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9f087e464fef57a9$export$2e2bcd8739ae039), null);
const $aa194b628782eb2f$export$27f123cb9320355 = (0, $bMm60.createEntry)((0, $8e4b0143fd4c66be$export$176ff76c3ba7c4ce), {
    component: $aa194b628782eb2f$var$RedirectComponent,
    layout: (0, $dVvIP.globalLayout),
    resources: [],
    isRedirect: true,
    canTransitionIn: ()=>false,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $bMm60 = parcelRequire("bMm60");

var $exb0h = parcelRequire("exb0h");
const $bd51edcd838bda29$export$9efae7a8e8e69866 = {
    group: (0, $exb0h.ROUTE_GROUPS_ERRORS),
    name: (0, $exb0h.ROUTE_NAMES_LOGIN_EMBED),
    path: '/jira-login/embed'
};



var $59o4i = parcelRequire("59o4i");

const $4edc8bb5aeebf389$export$53d5d548e4e9b86 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("9IDBB")), {
    moduleId: "./src/packages/spa-apps/login-embed/src/index.tsx"
});
const $4edc8bb5aeebf389$export$2a94dc6e96350c82 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4edc8bb5aeebf389$export$53d5d548e4e9b86,
        pageId: "spa-apps/login-embed",
        shouldShowSpinner: true
    });
const $4edc8bb5aeebf389$export$faa46f8c5e1f06d3 = (0, $bMm60.createEntry)((0, $bd51edcd838bda29$export$9efae7a8e8e69866), {
    component: $4edc8bb5aeebf389$export$2a94dc6e96350c82,
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb)
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $l90Gp = parcelRequire("l90Gp");

var $hUM03 = parcelRequire("hUM03");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $6ighq = parcelRequire("6ighq");


var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9556f709fc2a14de$var$LazyMarketplace = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("2EiXF"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/marketplace/src/index.tsx"
});
const $9556f709fc2a14de$var$MarketplaceComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9556f709fc2a14de$var$LazyMarketplace,
        pageId: "marketplace",
        shouldShowSpinner: true
    });
const $9556f709fc2a14de$var$findAppsRouteEntry = (0, $bMm60.createEntry)((0, $6ighq.findAppsRoute), {
    component: $9556f709fc2a14de$var$MarketplaceComponent,
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).ADDONS,
        sidebar: (0, $hUM03.default)
    },
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $9556f709fc2a14de$var$LazyMarketplace
    ],
    ufoName: 'embedded-marketplace'
});
const $9556f709fc2a14de$export$423a1c80bb2f8b9a = (0, $bMm60.createEntry)((0, $6ighq.appRequestRoute), {
    component: $9556f709fc2a14de$var$MarketplaceComponent,
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).ADDONS,
        sidebar: (0, $hUM03.default)
    },
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $9556f709fc2a14de$var$LazyMarketplace
    ]
});
const $9556f709fc2a14de$export$875d88a44b1ff74c = (0, $bMm60.createEntry)((0, $6ighq.promotionsRoute), {
    component: $9556f709fc2a14de$var$MarketplaceComponent,
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).ADDONS,
        sidebar: (0, $hUM03.default)
    },
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $9556f709fc2a14de$var$LazyMarketplace
    ]
});
const $9556f709fc2a14de$export$fd3c71e3bfb4df9e = ()=>[
        $9556f709fc2a14de$var$findAppsRouteEntry,
        $9556f709fc2a14de$export$423a1c80bb2f8b9a,
        $9556f709fc2a14de$export$875d88a44b1ff74c
    ];



var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $53ciZ = parcelRequire("53ciZ");

var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $9zysr = parcelRequire("9zysr");

var $dnJL9 = parcelRequire("dnJL9");

var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $bMm60 = parcelRequire("bMm60");

var $gar3N = parcelRequire("gar3N");

var $hHrVM = parcelRequire("hHrVM");

var $5GEOG = parcelRequire("5GEOG");


var $dgH3j = parcelRequire("dgH3j");


var $exb0h = parcelRequire("exb0h");
const $a9abc802715eecc6$export$5b818a6914ca8376 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burnup'
};
const $a9abc802715eecc6$export$cde83a6497756848 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/velocity'
};
const $a9abc802715eecc6$export$3c48ddd40d00b0d2 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cumulative'
};
const $a9abc802715eecc6$export$e0d8c26cb1430ae4 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burndown'
};
const $a9abc802715eecc6$export$c777bb8f2591081 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cycle-time'
};
const $a9abc802715eecc6$export$bbf45ab0423b990 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/deployment-frequency'
};
const $a9abc802715eecc6$export$8c91815cd4b1c078 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/control'
};
const $a9abc802715eecc6$export$5bf75a5d8c554930 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS),
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports'
};
const $a9abc802715eecc6$export$6072946fe7f2d45a = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_NEXTGEN_REDIRECT),
    path: '/secure/NextGen.jspa'
};
const $a9abc802715eecc6$export$9d24fc75b0f1d9a0 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_CODE),
    path: '/jira/software/projects/:projectKey/code'
};
const $a9abc802715eecc6$export$866215abd09c0f4d = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ROADMAP_REDIRECT),
    path: '/secure/Roadmap.jspa'
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");


var $dnJL9 = parcelRequire("dnJL9");


var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $hHrVM = parcelRequire("hHrVM");

var $bc7vB = parcelRequire("bc7vB");

var $gmVN5 = parcelRequire("gmVN5");

var $59z8J = parcelRequire("59z8J");

var $3MEW8 = parcelRequire("3MEW8");


var $dgH3j = parcelRequire("dgH3j");

var $8zRre = parcelRequire("8zRre");

var $7msR2 = parcelRequire("7msR2");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");


var $59o4i = parcelRequire("59o4i");

var $53ciZ = parcelRequire("53ciZ");
const $8fed448e8726ed96$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search);
    return rapidView;
};



const $afa4ca373a35f9b7$export$edb4b8cf67d7d767 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("chPFS"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});
const $afa4ca373a35f9b7$var$BacklogPage = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $afa4ca373a35f9b7$export$edb4b8cf67d7d767,
        pageId: `next-gen-backlog-${(0, $8fed448e8726ed96$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
const $afa4ca373a35f9b7$export$a5f8ba02d2755510 = (0, $bMm60.createEntry)((0, $8zRre.softwareBacklogRoute), {
    component: $afa4ca373a35f9b7$var$BacklogPage,
    skeleton: (0, $7msR2.NextGenBacklogSkeleton),
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $gmVN5.conditionalBacklogResource),
        (0, $bc7vB.conditionalBacklogRelayResource),
        (0, $59z8J.customFiltersResource)
    ],
    preloadOptions: {
        earlyChunks: [
            'software-backlog-early-entry'
        ]
    },
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $afa4ca373a35f9b7$export$edb4b8cf67d7d767
    ],
    ufoName: 'next-gen-backlog',
    meta: {
        capability: (0, $d07297a4af13004b$export$c17f34c425972af1)
    }
});
const $afa4ca373a35f9b7$export$7cd14dee22609378 = (0, $bMm60.createEntry)((0, $8zRre.softwareBacklogEmbedRoute), {
    component: (0, $dnJL9.componentWithFG)('enable_backlog_smartlink_route', $afa4ca373a35f9b7$var$BacklogPage, (0, $dgH3j.default)),
    layout: (0, $isbb2.createLayout)({
        isChromeless: true
    }),
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $gmVN5.conditionalBacklogResource),
        (0, $bc7vB.conditionalBacklogRelayResource),
        (0, $59z8J.customFiltersResource),
        (0, $3MEW8.themePreferenceResource)
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        $afa4ca373a35f9b7$export$edb4b8cf67d7d767
    ],
    ufoName: 'next-gen-backlog-embed',
    meta: {
        capability: (0, $d07297a4af13004b$export$c17f34c425972af1)
    }
});
var $afa4ca373a35f9b7$export$2e2bcd8739ae039 = $afa4ca373a35f9b7$var$BacklogPage;



var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $6VZoe = parcelRequire("6VZoe");

var $dfBCt = parcelRequire("dfBCt");

var $cernH = parcelRequire("cernH");


var $1ybV0 = parcelRequire("1ybV0");

var $dnJL9 = parcelRequire("dnJL9");


var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $chAei = parcelRequire("chAei");

var $hHrVM = parcelRequire("hHrVM");

var $gyys9 = parcelRequire("gyys9");

var $3MEW8 = parcelRequire("3MEW8");

var $jwzNs = parcelRequire("jwzNs");


var $dgH3j = parcelRequire("dgH3j");

var $7yAHk = parcelRequire("7yAHk");

var $j7Vfn = parcelRequire("j7Vfn");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");


var $59o4i = parcelRequire("59o4i");

const $9f5dd2b7ff8af740$export$bd9ede4ec384f41d = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("3rNwL"))), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
});
const $9f5dd2b7ff8af740$var$getBoardId = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search);
    return rapidView;
};
const $9f5dd2b7ff8af740$export$78e6ebf73d7f732b = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9f5dd2b7ff8af740$export$bd9ede4ec384f41d,
        pageId: `next-gen-board-${$9f5dd2b7ff8af740$var$getBoardId({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
const $9f5dd2b7ff8af740$var$conditionalBoardResource = (0, $jwzNs.resourceWithCondition)(()=>!(0, $1ybV0.ff)('jsw.perf.critical-board-with-relay'), (0, $chAei.boardResource));
const $9f5dd2b7ff8af740$var$conditionalBoardRelayResource = (0, $jwzNs.resourceWithCondition)(()=>(0, $1ybV0.ff)('jsw.perf.critical-board-with-relay'), (0, $chAei.boardRelayResource));
const $9f5dd2b7ff8af740$var$conditionalBoardNBTOptInResource = (0, $jwzNs.resourceWithCondition2)(()=>!(0, $dfBCt.isFedRamp)(), (0, $gyys9.nextBestTaskFeatureResource));
const $9f5dd2b7ff8af740$export$2964ea1cdd5afa39 = (0, $bMm60.createEntry)((0, $7yAHk.softwareBoardRoute), {
    component: $9f5dd2b7ff8af740$export$78e6ebf73d7f732b,
    skeleton: (0, $j7Vfn.NextGenBoardSkeleton),
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        $9f5dd2b7ff8af740$var$conditionalBoardResource,
        (0, $chAei.customFiltersResource),
        $9f5dd2b7ff8af740$var$conditionalBoardRelayResource,
        $9f5dd2b7ff8af740$var$conditionalBoardNBTOptInResource
    ],
    preloadOptions: {
        earlyChunks: [
            'software-board-early-entry'
        ]
    },
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $9f5dd2b7ff8af740$export$bd9ede4ec384f41d
    ],
    ufoName: 'next-gen-board',
    meta: {
        capability: (0, $d07297a4af13004b$export$f364828958cffad0)
    }
});
const $9f5dd2b7ff8af740$export$ff8632c8a0f5d984 = (0, $bMm60.createEntry)((0, $7yAHk.softwareBoardEmbedRoute), {
    component: (0, $dnJL9.componentWithFG)('jira_board_smartlink_embed', $9f5dd2b7ff8af740$export$78e6ebf73d7f732b, (0, $dgH3j.default)),
    layout: (0, $isbb2.createLayout)({
        isChromeless: true
    }),
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        $9f5dd2b7ff8af740$var$conditionalBoardNBTOptInResource,
        $9f5dd2b7ff8af740$var$conditionalBoardResource,
        $9f5dd2b7ff8af740$var$conditionalBoardRelayResource,
        (0, $chAei.customFiltersResource),
        (0, $3MEW8.themePreferenceResource)
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        $9f5dd2b7ff8af740$export$bd9ede4ec384f41d
    ],
    ufoName: 'next-gen-board-embed',
    meta: {
        capability: (0, $d07297a4af13004b$export$f364828958cffad0)
    }
});



var $cernH = parcelRequire("cernH");




var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $hHrVM = parcelRequire("hHrVM");

var $3MEW8 = parcelRequire("3MEW8");


var $exb0h = parcelRequire("exb0h");
const $71f996d450635d54$export$d6730f103a4ad844 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR),
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar',
    queries: [
        'date?'
    ]
};
const $71f996d450635d54$export$b55c4d4efb097c1c = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR_EMBED),
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/embed',
    queries: [
        'date?'
    ]
};



var $7u7sK = parcelRequire("7u7sK");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

const $bf82d83bb632614e$export$24fc07c22f0d06 = (0, $bMm60.createEntry)((0, $71f996d450635d54$export$b55c4d4efb097c1c), {
    skeleton: (0, $7u7sK.CalendarEmbedSkeleton),
    component: (0, $7u7sK.CalendarEmbedSkeleton),
    entryPoint () {
        if (false) return undefined;
        return $bf82d83bb632614e$export$d154630e8966be91;
    },
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $3MEW8.themePreferenceResource)
    ],
    ufoName: 'next-gen-calendar-embed'
});
const $bf82d83bb632614e$export$d154630e8966be91 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $f6122116660bea23$export$19cf4b398f638dc6),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $bf82d83bb632614e$export$83b1b9036cc7961a = (0, $bMm60.createEntry)((0, $71f996d450635d54$export$d6730f103a4ad844), {
    skeleton: (0, $7u7sK.CalendarSkeleton),
    component: (0, $7u7sK.CalendarSkeleton),
    entryPoint () {
        if (false) return undefined;
        return $bf82d83bb632614e$export$d154630e8966be91;
    },
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)()
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ],
    ufoName: 'next-gen-calendar'
});




var $cernH = parcelRequire("cernH");

var $9zysr = parcelRequire("9zysr");

var $dnJL9 = parcelRequire("dnJL9");

var $7vTKl = parcelRequire("7vTKl");

var $6FP8W = parcelRequire("6FP8W");

var $iOOlt = parcelRequire("iOOlt");

var $bMm60 = parcelRequire("bMm60");

var $aeIT6 = parcelRequire("aeIT6");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $c7156111f4230c57$export$c5589046ee2a390d = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_BUILDER),
    path: '/jira/software/projects/:projectKey/form/:formId/builder',
    exact: true
};




var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

const $6c1a759eb736ed83$export$e8dede7671fad23d = (0, $bMm60.createEntry)((0, $c7156111f4230c57$export$c5589046ee2a390d), {
    ufoName: 'next-gen-form-builder',
    component: (0, $dnJL9.componentWithFG)('jwm_forms_to_jsw', (0, $7ed88a990676bb78$export$a4c73b2a16981930), (0, $dgH3j.default)),
    layout: (0, $soOXK.softwareProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), (0, $bEe6y.AsyncHorizontalSoftwareProjectNav), ()=>null)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $aeIT6.projectDetailsResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7ed88a990676bb78$export$2076234d7fde1717)
    ],
    afterPaint: [
        (0, $da107422e9535dbb$export$258fcd204933dd75)
    ]
});



var $cernH = parcelRequire("cernH");

var $9zysr = parcelRequire("9zysr");

var $dnJL9 = parcelRequire("dnJL9");

var $7vTKl = parcelRequire("7vTKl");

var $6FP8W = parcelRequire("6FP8W");

var $iOOlt = parcelRequire("iOOlt");

var $bMm60 = parcelRequire("bMm60");

var $aeIT6 = parcelRequire("aeIT6");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");


var $exb0h = parcelRequire("exb0h");
const $87ee6540ff5b1f58$export$a46217d369231a5 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM),
    path: '/jira/software/projects/:projectKey/form',
    exact: true
};



var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

const $5d2ef3fbef19fc9e$export$563e3b39911993a0 = (0, $bMm60.createEntry)((0, $87ee6540ff5b1f58$export$a46217d369231a5), {
    ufoName: 'next-gen-form',
    component: (0, $dnJL9.componentWithFG)('jwm_forms_to_jsw', (0, $70fff4c2dbe9dc25$export$7234abc5d81adb58), (0, $dgH3j.default)),
    layout: (0, $soOXK.softwareProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), (0, $bEe6y.AsyncHorizontalSoftwareProjectNav), ()=>null)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $aeIT6.projectDetailsResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $70fff4c2dbe9dc25$export$240a58749ebba091)
    ],
    afterPaint: [
        (0, $7ed88a990676bb78$export$2076234d7fde1717)
    ]
});



var $cernH = parcelRequire("cernH");


var $dnJL9 = parcelRequire("dnJL9");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $aeIT6 = parcelRequire("aeIT6");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $0c74832f922fd8ee$export$75b28ee1c7f02f00 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_SUBMIT),
    path: '/jira/software/projects/:projectKey/form/:formId',
    exact: true
};



const $d61b74df132cb1c2$export$752724866670c36 = (0, $bMm60.createEntry)((0, $0c74832f922fd8ee$export$75b28ee1c7f02f00), {
    ufoName: 'next-gen-form-submit',
    component: (0, $dnJL9.componentWithFG)('jwm_forms_to_jsw', (0, $da107422e9535dbb$export$4258f48cc65dca00), (0, $dgH3j.default)),
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $aeIT6.projectDetailsResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $da107422e9535dbb$export$258fcd204933dd75)
    ]
});



var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $122398eee18b185f$export$2328fed7ebee3cce = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_GOALS),
    exact: true,
    path: '/jira/software/projects/:projectKey/goals'
};



var $bEe6y = parcelRequire("bEe6y");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $c4359f5b4095d323$export$69b07a7049b7beab = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("c9qT1"))), {
    moduleId: "./src/packages/spa-apps/goals/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c4359f5b4095d323$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c4359f5b4095d323$export$69b07a7049b7beab,
        pageId: `atlas-goals-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });


const $716a6814b23ca11c$export$d3fcc412edfa2068 = (0, $bMm60.createEntry)((0, $122398eee18b185f$export$2328fed7ebee3cce), {
    component: (0, $c4359f5b4095d323$export$2e2bcd8739ae039),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)()
    ]
});



var $cernH = parcelRequire("cernH");



var $79xbN = parcelRequire("79xbN");

var $9zysr = parcelRequire("9zysr");


var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $fD1Hq = parcelRequire("fD1Hq");

var $kMmsu = parcelRequire("kMmsu");

var $f26dB = parcelRequire("f26dB");

var $aeIT6 = parcelRequire("aeIT6");

var $hHrVM = parcelRequire("hHrVM");

var $2JncP = parcelRequire("2JncP");


var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $3a594ac4ee6eb737$export$f3a5b1b732315e13 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST),
    path: '/jira/software/projects/:projectKey/list'
};
const $3a594ac4ee6eb737$export$70dd8df584442004 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST_EMBED),
    path: '/jira/software/projects/:projectKey/list/embed'
};




var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");


var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $23852dc93c7d3399$export$26b97a235767fc3c = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("6qRbE"))), {
    moduleId: "./src/packages/spa-apps/business/jsw-list/src/index.tsx"
});

const $23852dc93c7d3399$export$8c61f5f5c58f351f = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("8D7jN"))), {
    moduleId: "./src/packages/spa-apps/business/jsw-list-embed/src/index.tsx"
});
const $23852dc93c7d3399$export$422a3a028ae77ad3 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $23852dc93c7d3399$export$26b97a235767fc3c,
        pageId: `next-gen-list-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });
const $23852dc93c7d3399$export$4a0539d19a2e2694 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $23852dc93c7d3399$export$8c61f5f5c58f351f,
        pageId: `next-gen-list-${match.params.boardId || ''}-embed`,
        shouldShowSpinner: false
    });


const $2df1207b13a402cc$var$getListProjectResources = ()=>[
        (0, $2JncP.projectCreatePermissionsResource),
        (0, $f26dB.navigationResource),
        (0, $aeIT6.projectDetailsResource),
        (0, $fD1Hq.configurationResource),
        (0, $kMmsu.fieldsResource)
    ];
const $2df1207b13a402cc$export$4425668b2cd90292 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $f1fff89849bb73a7$export$6be4f10150ff6073),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $2df1207b13a402cc$export$f30a66efa682bf2d = (0, $bMm60.createEntry)((0, $3a594ac4ee6eb737$export$f3a5b1b732315e13), {
    component: (0, $9zysr.componentWithCondition)(()=>(0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $23852dc93c7d3399$export$422a3a028ae77ad3), (0, $dgH3j.default)),
    skeleton: (0, $f1174c8234e7b02e$export$cbc3335f7a517046),
    entryPoint () {
        return (0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? $2df1207b13a402cc$export$4425668b2cd90292 : undefined;
    },
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...$2df1207b13a402cc$var$getListProjectResources()
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $23852dc93c7d3399$export$26b97a235767fc3c)
    ],
    ufoName: 'next-gen-list'
});
const $2df1207b13a402cc$export$1099e0e49394fa9a = (0, $bMm60.createEntry)((0, $3a594ac4ee6eb737$export$70dd8df584442004), {
    component: (0, $9zysr.componentWithCondition)(()=>(0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $23852dc93c7d3399$export$4a0539d19a2e2694), (0, $dgH3j.default)),
    skeleton: (0, $f1174c8234e7b02e$export$2638f1c98fe91c13),
    entryPoint () {
        return (0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? $2df1207b13a402cc$export$4425668b2cd90292 : undefined;
    },
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$2df1207b13a402cc$var$getListProjectResources()
    ],
    forPaint: [
        (0, $23852dc93c7d3399$export$8c61f5f5c58f351f)
    ],
    ufoName: 'next-gen-list-embed'
});





var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $9zysr = parcelRequire("9zysr");

var $eI5EY = parcelRequire("eI5EY");

var $bMm60 = parcelRequire("bMm60");

var $3MEW8 = parcelRequire("3MEW8");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $f04885cb083d2490$export$9f9c6c613d93c0e5 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_PRESENTATION_TOOLKIT_REPORT),
    path: '/jira/software/presentation-toolkit-report',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $ff4fb309e93ebd4d$export$d95295446c03a00c = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("9H2zQ"))), {
    moduleId: "./src/packages/spa-apps/software/presentation-toolkit-report/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff4fb309e93ebd4d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ff4fb309e93ebd4d$export$d95295446c03a00c,
        pageId: "jira-software-presentation-toolkit-report",
        shouldShowSpinner: true
    });


const $490b95a631ece100$var$getIsEnrolledInExperiment = ()=>{
    // Do not want to log exposure, because there are more conditions that will be checked when the component is rendered
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_presentation_toolkit_experiment');
    const isPassedGate = (0, $eI5EY.fg)('jsw_presentation_toolkit_gate');
    return expConfig.get('cohort', (0, $1Iui1.NOT_ENROLLED)) !== (0, $1Iui1.NOT_ENROLLED) && isPassedGate;
};
const $490b95a631ece100$export$60cf591eccf54b03 = (0, $bMm60.createEntry)((0, $f04885cb083d2490$export$9f9c6c613d93c0e5), {
    component: (0, $9zysr.componentWithCondition)($490b95a631ece100$var$getIsEnrolledInExperiment, (0, $ff4fb309e93ebd4d$export$2e2bcd8739ae039), (0, $dgH3j.default)),
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
    resources: [
        (0, $3MEW8.themePreferenceResource)
    ],
    forPaint: [
        (0, $ff4fb309e93ebd4d$export$d95295446c03a00c)
    ]
});



var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $7vTKl = parcelRequire("7vTKl");

var $51qRF = parcelRequire("51qRF");

var $62ZdZ = parcelRequire("62ZdZ");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $4qvmP = parcelRequire("4qvmP");

var $cINNO = parcelRequire("cINNO");

var $hHrVM = parcelRequire("hHrVM");

var $8hvlU = parcelRequire("8hvlU");

var $jwzNs = parcelRequire("jwzNs");


var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $7a57dca132bd422e$export$5a84dbc6e86abbed = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REQUESTS),
    path: '/jira/software/projects/:projectKey/requests'
};
const $7a57dca132bd422e$export$e45e557c8c37bcea = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC),
    path: '/jira/software/c/projects/:projectKey/requests'
};



var $iPtkN = parcelRequire("iPtkN");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");
var /**
 * Generates a unique identifier for pages based on various criteria to support features such as caching or analytics, ensuring each page is distinctly recognizable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$40e3d86990ee0839$export$2e2bcd8739ae039 = (pageIdPrefix, { params: params }, { filter: filter, orderby: orderby, keyword: keyword })=>{
    const { projectKey: projectKey, issueKey: issueKey } = params;
    let pageId = '';
    try {
        pageId = `${pageIdPrefix}${(projectKey !== null && projectKey !== undefined ? `-${projectKey}` : '') + (issueKey !== null && issueKey !== undefined ? `-${issueKey}` : '') + (filter !== undefined ? `-${filter}` : '') + (orderby !== undefined ? `-${orderby}` : '') + (keyword !== undefined ? `-${keyword}` : '')}`;
    } catch  {
        pageId = pageIdPrefix;
    }
    return pageId;
};



const $a43b25670d5fe7c8$export$3b235a8105f91b2b = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("jw6tz"))), {
    moduleId: "./src/packages/software/requests/requests-page/src/index.tsx"
});
const $a43b25670d5fe7c8$export$b357b5f614f36f9a = ({ match: match, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a43b25670d5fe7c8$export$3b235a8105f91b2b,
        pageId: (0, $40e3d86990ee0839$export$2e2bcd8739ae039)('next-gen-requests', match, query),
        shouldShowSpinner: false
    });
const $a43b25670d5fe7c8$export$f6b20eb362411299 = ({ match: match, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a43b25670d5fe7c8$export$3b235a8105f91b2b,
        pageId: (0, $40e3d86990ee0839$export$2e2bcd8739ae039)('classic-requests', match, query),
        shouldShowSpinner: false
    });


const $a14d5efc9298d717$var$isRequestsTabEnabled = ()=>{
    const requestTabFFValue = (0, $1ybV0.getMultivariateFeatureFlag)('growth.discovery-of-jsm-requests-tab.experiment', 'control', [
        'sticky',
        'not-enrolled-sticky',
        'non-sticky',
        'not-enrolled-non-sticky',
        'control',
        'not-enrolled'
    ]);
    return requestTabFFValue === 'sticky' || requestTabFFValue === 'non-sticky';
};
const $a14d5efc9298d717$var$getCommonProjectResources = ()=>[
        (0, $8hvlU.issueNavigatorRelayResource),
        (0, $8hvlU.issueNavigatorFilterRelayResource),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)(),
        // TODO: create skeleton for requests
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('nin.global-scope_aqec8'), (0, $62ZdZ.sidebarProjectIssuesResource)),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('nin.global-scope_aqec8'), (0, $cINNO.isNinGlobalScopeEnrolmentEnabledResource)),
        (0, $51qRF.staticSidebarDefaultPINFiltersResource)
    ];
const $a14d5efc9298d717$var$getCommonProject = ()=>({
        apdexIgnoreParams: [
            'issueKey'
        ],
        // TO-DO change this to Request page skelton after creating skeleton for Request page
        skeleton: (0, $iPtkN.ProjectIssueNavigatorSkeleton),
        resources: [
            ...$a14d5efc9298d717$var$getCommonProjectResources()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $a43b25670d5fe7c8$export$3b235a8105f91b2b)
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ]
    });
const $a14d5efc9298d717$export$fe880b76c2e8d7cf = (0, $bMm60.createEntry)((0, $7a57dca132bd422e$export$5a84dbc6e86abbed), {
    ...$a14d5efc9298d717$var$getCommonProject(),
    component: (0, $9zysr.componentWithCondition)($a14d5efc9298d717$var$isRequestsTabEnabled, (0, $a43b25670d5fe7c8$export$b357b5f614f36f9a), (0, $dgH3j.default)),
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    ufoName: 'next-gen-requests'
});
const $a14d5efc9298d717$export$db399ba51c2e38a6 = (0, $bMm60.createEntry)((0, $7a57dca132bd422e$export$e45e557c8c37bcea), {
    ...$a14d5efc9298d717$var$getCommonProject(),
    component: (0, $9zysr.componentWithCondition)($a14d5efc9298d717$var$isRequestsTabEnabled, (0, $a43b25670d5fe7c8$export$f6b20eb362411299), (0, $dgH3j.default)),
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $2Fzrk.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    ufoName: 'classic-requests'
});



var $eUqFw = parcelRequire("eUqFw");

var $cernH = parcelRequire("cernH");


var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $hHrVM = parcelRequire("hHrVM");

var $bU6C3 = parcelRequire("bU6C3");


var $exb0h = parcelRequire("exb0h");
const $fbae1e99819ee1b3$export$a4a573c36fc75b30 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ROADMAP),
    path: '/jira/software/projects/:projectKey/boards/:boardId/roadmap'
};



var $841Zr = parcelRequire("841Zr");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $lB25E = parcelRequire("lB25E");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $c7da89307acb6c95$export$1339c847cf4ab57 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("eoI8D"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c7da89307acb6c95$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c7da89307acb6c95$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });


const $3e4b1429136330d9$export$dd8650bb193f860b = ({ match: { params: { projectKey: projectKey, boardId: boardId } }, query: query })=>{
    const queryParams = new URLSearchParams(query).toString();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: {
            pathname: `/jira/software/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};
const $3e4b1429136330d9$export$c1d875e34d537389 = (0, $bMm60.createEntry)((0, $fbae1e99819ee1b3$export$a4a573c36fc75b30), {
    component: $3e4b1429136330d9$export$dd8650bb193f860b,
    skeleton: (0, $841Zr.RoadmapSkeleton),
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $bU6C3.nextGenRoadmapResource)
    ],
    preloadOptions: {
        earlyChunks: [
            'software-roadmap-early-entry'
        ]
    },
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $c7da89307acb6c95$export$1339c847cf4ab57)
    ],
    ufoName: 'next-gen-roadmap'
});




var $cernH = parcelRequire("cernH");


var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $hHrVM = parcelRequire("hHrVM");

var $bU6C3 = parcelRequire("bU6C3");


var $exb0h = parcelRequire("exb0h");
const $7542badf59123bb8$export$d25dafcda96d5af9 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE),
    path: '/jira/software/projects/:projectKey/boards/:boardId/timeline'
};



var $841Zr = parcelRequire("841Zr");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $f9cc26c53407a06d$export$1339c847cf4ab57 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("eoI8D"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f9cc26c53407a06d$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f9cc26c53407a06d$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });


const $712bd1e16f3f7c0a$export$ace6a996c7e99f3 = (0, $bMm60.createEntry)((0, $7542badf59123bb8$export$d25dafcda96d5af9), {
    component: (0, $f9cc26c53407a06d$export$2e2bcd8739ae039),
    skeleton: (0, $841Zr.RoadmapSkeleton),
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $bU6C3.nextGenRoadmapResource)
    ],
    preloadOptions: {
        earlyChunks: [
            'software-roadmap-early-entry'
        ]
    },
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f9cc26c53407a06d$export$1339c847cf4ab57)
    ],
    ufoName: 'next-gen-roadmap'
});



var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $llMVF = parcelRequire("llMVF");

var $73beW = parcelRequire("73beW");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $af9107e1ce3307b2$exports = {};
$af9107e1ce3307b2$exports = new URL("version-detail-skeleton.tpl.c4c4fc18.svg", import.meta.url).toString();


const $95cf873da74edc11$export$b3661a594ba34350 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($af9107e1ce3307b2$exports)))
    });



var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $lB25E = parcelRequire("lB25E");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $c80c2dd31bfa329e$export$2d31f5f47e6584e0 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("c3DFM"))), {
    moduleId: "./src/packages/spa-apps/version-detail/src/index.tsx"
});
const $c80c2dd31bfa329e$export$231cc5186b991031 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c80c2dd31bfa329e$export$2d31f5f47e6584e0,
        pageId: "version-detail",
        shouldShowSpinner: false
    });


const $02ebad1b1697b652$var$VersionDetailPageLegacyRedirect = ({ match: { params: { projectKey: projectKey, versionId: versionId, tab: tab } } })=>{
    // This should never happen as if it wasn't matched, this won't be rendered unless someone re-used this component in a wrong route.
    if (projectKey == null || versionId == null) throw Error('projectKey or versionId not found in match object of RouteContext');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/projects/${projectKey}/versions/${versionId}/tab/${tab != null ? tab : 'release-report-all-issues'}`
    });
};
const $02ebad1b1697b652$export$c97dabcfe9d495fa = (0, $bMm60.createEntry)((0, $73beW.softwareVersionDetailRoute), {
    component: (0, $c80c2dd31bfa329e$export$231cc5186b991031),
    skeleton: (0, $95cf873da74edc11$export$b3661a594ba34350),
    canTransitionIn: ()=>true,
    layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: [
            (0, $iOOlt.default),
            (0, $2Fzrk.default)
        ]
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $llMVF.versionDetailsRelayResourceCustom),
        (0, $ixwgj.projectContextResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $c80c2dd31bfa329e$export$2d31f5f47e6584e0)
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL)),
            teamName: 'fusion-solaris'
        }
    }
});
const $02ebad1b1697b652$export$28d16aae32969765 = (0, $bMm60.createEntry)({
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
    path: '/projects/:projectKey/versions/:versionId'
}, {
    component: $02ebad1b1697b652$var$VersionDetailPageLegacyRedirect,
    canTransitionIn: ()=>true,
    layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: [
            (0, $iOOlt.default),
            (0, $2Fzrk.default)
        ],
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $c80c2dd31bfa329e$export$2d31f5f47e6584e0)
    ]
});
const $02ebad1b1697b652$export$f29aafdff734071c = (0, $bMm60.createEntry)({
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT),
    path: '/browse/:projectKey/fixforversion/:versionId'
}, {
    component: $02ebad1b1697b652$var$VersionDetailPageLegacyRedirect,
    canTransitionIn: ()=>true,
    layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: [
            (0, $iOOlt.default),
            (0, $2Fzrk.default)
        ],
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $c80c2dd31bfa329e$export$2d31f5f47e6584e0)
    ]
});



var $yyqSx = parcelRequire("yyqSx");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $lB25E = parcelRequire("lB25E");

var $GuBa2 = parcelRequire("GuBa2");

var $kKeF6 = parcelRequire("kKeF6");

var $5fOZm = parcelRequire("5fOZm");
const $d87005bb78f4244b$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $d87005bb78f4244b$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];



var $53ciZ = parcelRequire("53ciZ");
const $5341544e238d5d38$var$PLAN = 'planning';
const $5341544e238d5d38$var$REPORTING = 'reporting';
const $5341544e238d5d38$var$REPORTS = 'reports';
const $5341544e238d5d38$var$constructUrlForView = (url, view, searchResult)=>{
    if (view.startsWith($5341544e238d5d38$var$PLAN)) return `${url}/backlog`;
    if (view.startsWith($5341544e238d5d38$var$REPORTING) || view.startsWith($5341544e238d5d38$var$REPORTS)) {
        if (searchResult.report) return `${url}/reports/${searchResult.report}`;
        return `${url}/reports`;
    }
    return url;
};
const $5341544e238d5d38$var$KNOWN_KEYS = [
    'rapidView',
    'projectKey',
    'view',
    'report'
];
const $5341544e238d5d38$var$forwardUnknownQueryParams = (url, queryParams)=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(Object.entries(queryParams).filter(([k])=>!$5341544e238d5d38$var$KNOWN_KEYS.includes(k)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, [k, v])=>({
            [k]: v,
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result
        }), {}));
    if (query) return `${url}?${query}`;
    return url;
};
const $5341544e238d5d38$export$8c47088cd9b527ba = (location)=>{
    const searchResult = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search);
    const url = `/jira/software/projects/${searchResult.projectKey}/boards/${searchResult.rapidView}`;
    if (searchResult.view) return $5341544e238d5d38$var$forwardUnknownQueryParams($5341544e238d5d38$var$constructUrlForView(url, searchResult.view, searchResult), searchResult);
    return $5341544e238d5d38$var$forwardUnknownQueryParams(url, searchResult);
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $1ac1fc409b478241$export$1339c847cf4ab57 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("eoI8D"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1ac1fc409b478241$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1ac1fc409b478241$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

var $53ciZ = parcelRequire("53ciZ");
const $1bf79051fed80f7f$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search);
    return rapidView;
};



const $5cd97f20ee6e4d57$export$4beafd9dbad29bff = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("h9URe"))), {
    moduleId: "./src/packages/spa-apps/code/src/index.tsx"
});
const $5cd97f20ee6e4d57$export$d9e8184332f86b53 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5cd97f20ee6e4d57$export$4beafd9dbad29bff,
        pageId: `next-gen-code-${(0, $1bf79051fed80f7f$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
const $5cd97f20ee6e4d57$export$95e2389b7ca7ccf2 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5cd97f20ee6e4d57$export$4beafd9dbad29bff,
        pageId: `classic-code-${(0, $1bf79051fed80f7f$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");


const $60a4eae38aab8e0b$export$10cd1e761434952 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("c5RN6"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/burndown/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$60a4eae38aab8e0b$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $60a4eae38aab8e0b$export$10cd1e761434952,
        pageId: `next-gen-reports-burndown-${(0, $1bf79051fed80f7f$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");


const $3e4a1cc841187c61$export$2ae7ab3b633c1d15 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("hNSE6"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/burnup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3e4a1cc841187c61$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3e4a1cc841187c61$export$2ae7ab3b633c1d15,
        pageId: `next-gen-reports-burnup-${(0, $1bf79051fed80f7f$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $98956695635c6d9e$export$3b0b331107fce76 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("bGbRd"))), {
    moduleId: "./src/packages/spa-apps/control-report/src/index.tsx"
});
const $98956695635c6d9e$export$90d0561918744b3b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $98956695635c6d9e$export$3b0b331107fce76,
        pageId: "controlReportNextGen",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");


const $4c67b3a1ed32bba6$export$c588973e5bd18a8d = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("biov4"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/cumulative/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4c67b3a1ed32bba6$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4c67b3a1ed32bba6$export$c588973e5bd18a8d,
        pageId: `next-gen-reports-cumulative-${(0, $1bf79051fed80f7f$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $5f6e3fe4d9f53d04$export$956f830ed027f1fb = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("4hDuf")), {
    moduleId: "./src/packages/spa-apps/cycle-time-report/src/index.tsx"
});
const $5f6e3fe4d9f53d04$export$e16ce0656a74a015 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5f6e3fe4d9f53d04$export$956f830ed027f1fb,
        pageId: "cycleTimeReportNextGen",
        shouldShowSpinner: true
    });
const $5f6e3fe4d9f53d04$export$237924ba64065cc3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5f6e3fe4d9f53d04$export$956f830ed027f1fb,
        pageId: "cycleTimeReportClassic",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $8ab0e4f8eec61b65$export$5113b2b19ec1fb53 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("itkhw")), {
    moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
});
const $8ab0e4f8eec61b65$export$e2db9c7426cdb53 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8ab0e4f8eec61b65$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportNextGen",
        shouldShowSpinner: true
    });
const $8ab0e4f8eec61b65$export$655707e8ae1053d3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8ab0e4f8eec61b65$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportClassic",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");


const $fd39322616372e6e$export$dbd12c5c20c26961 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("eHH82"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/overview/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fd39322616372e6e$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $fd39322616372e6e$export$dbd12c5c20c26961,
        pageId: `next-gen-reports-overview-${(0, $1bf79051fed80f7f$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");


const $679605082ab30589$export$a2ca519c668b2f72 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("95xdG"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/velocity/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$679605082ab30589$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $679605082ab30589$export$a2ca519c668b2f72,
        pageId: `next-gen-reports-velocity-${(0, $1bf79051fed80f7f$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });


const $f730f07a676cc8e2$var$SoftwareNextgenRedirectComponent = ({ location: location })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: (0, $5341544e238d5d38$export$8c47088cd9b527ba)(location)
    });
const $f730f07a676cc8e2$var$SoftwareTimelineLegacyRedirect = ({ query: query })=>{
    const { projectKey: projectKey, rapidView: rapidView, ...restQuery } = query;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: {
            pathname: `/jira/software/projects/${projectKey}/boards/${rapidView}/timeline`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(restQuery)
        }
    });
};
const $f730f07a676cc8e2$export$688b56fcbc2637ac = [
    (0, $9f5dd2b7ff8af740$export$ff8632c8a0f5d984),
    (0, $9f5dd2b7ff8af740$export$2964ea1cdd5afa39),
    (0, $afa4ca373a35f9b7$export$7cd14dee22609378),
    (0, $afa4ca373a35f9b7$export$a5f8ba02d2755510),
    (0, $6c1a759eb736ed83$export$e8dede7671fad23d),
    (0, $5d2ef3fbef19fc9e$export$563e3b39911993a0),
    (0, $d61b74df132cb1c2$export$752724866670c36),
    (0, $716a6814b23ca11c$export$d3fcc412edfa2068),
    (0, $bMm60.createEntry)((0, $a9abc802715eecc6$export$5b818a6914ca8376), {
        ufoName: 'software-reports.burnup-chart',
        component: (0, $3e4a1cc841187c61$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $3e4a1cc841187c61$export$2ae7ab3b633c1d15)
        ]
    }),
    (0, $bMm60.createEntry)((0, $a9abc802715eecc6$export$cde83a6497756848), {
        ufoName: 'software-reports.velocity-report',
        component: (0, $679605082ab30589$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $679605082ab30589$export$a2ca519c668b2f72)
        ]
    }),
    (0, $bMm60.createEntry)((0, $a9abc802715eecc6$export$3c48ddd40d00b0d2), {
        ufoName: 'software-reports.cumulative-flow-diagram',
        component: (0, $4c67b3a1ed32bba6$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4c67b3a1ed32bba6$export$c588973e5bd18a8d)
        ]
    }),
    (0, $bMm60.createEntry)((0, $a9abc802715eecc6$export$e0d8c26cb1430ae4), {
        ufoName: 'software-reports.burndown-chart',
        component: (0, $60a4eae38aab8e0b$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $60a4eae38aab8e0b$export$10cd1e761434952)
        ]
    }),
    (0, $bMm60.createEntry)((0, $a9abc802715eecc6$export$c777bb8f2591081), {
        component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $5f6e3fe4d9f53d04$export$e16ce0656a74a015)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)(),
            (0, $gar3N.devOpsProviderResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5f6e3fe4d9f53d04$export$956f830ed027f1fb)
        ],
        meta: {
            reporting: {
                id: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME)),
                teamName: 'fusion-solaris'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $a9abc802715eecc6$export$bbf45ab0423b990), {
        component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $8ab0e4f8eec61b65$export$e2db9c7426cdb53)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)(),
            (0, $gar3N.devOpsProviderResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $8ab0e4f8eec61b65$export$5113b2b19ec1fb53)
        ],
        meta: {
            reporting: {
                id: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY)),
                teamName: 'fusion-solaris'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $a9abc802715eecc6$export$8c91815cd4b1c078), {
        ufoName: 'software-reports.control-chart',
        component: (0, $dnJL9.componentWithFG)('jsw_enable_avp_control_chart', (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $98956695635c6d9e$export$90d0561918744b3b)), (0, $dgH3j.default)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $98956695635c6d9e$export$3b0b331107fce76)
        ],
        meta: {
            reporting: {
                id: (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL)),
                teamName: 'helios-reports'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $a9abc802715eecc6$export$5bf75a5d8c554930), {
        component: (0, $fd39322616372e6e$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $fd39322616372e6e$export$dbd12c5c20c26961)
        ],
        ufoName: 'software-reports.overview'
    }),
    (0, $bMm60.createEntry)((0, $a9abc802715eecc6$export$6072946fe7f2d45a), {
        component: $f730f07a676cc8e2$var$SoftwareNextgenRedirectComponent,
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9f5dd2b7ff8af740$export$bd9ede4ec384f41d)
        ]
    }),
    (0, $bMm60.createEntry)((0, $a9abc802715eecc6$export$9d24fc75b0f1d9a0), {
        component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $5cd97f20ee6e4d57$export$d9e8184332f86b53)),
        layout: (0, $soOXK.softwareProjectLayoutCode),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $5GEOG.codePageResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5cd97f20ee6e4d57$export$4beafd9dbad29bff)
        ],
        ufoName: 'next-gen-code'
    }),
    (0, $c13ea8e6d002db74$export$a8dcfae475505e7a),
    (0, $e7eb7b8d4a88bad8$export$7e5ccb20ad8e1612),
    (0, $aefe7ae0a443cf30$export$7db4d910357a4d89),
    (0, $02ebad1b1697b652$export$c97dabcfe9d495fa),
    (0, $02ebad1b1697b652$export$28d16aae32969765),
    (0, $02ebad1b1697b652$export$f29aafdff734071c),
    (0, $a14d5efc9298d717$export$fe880b76c2e8d7cf),
    (0, $a14d5efc9298d717$export$db399ba51c2e38a6),
    (0, $712bd1e16f3f7c0a$export$ace6a996c7e99f3),
    (0, $3e4b1429136330d9$export$c1d875e34d537389),
    (0, $bf82d83bb632614e$export$24fc07c22f0d06),
    (0, $bf82d83bb632614e$export$83b1b9036cc7961a),
    (0, $2df1207b13a402cc$export$1099e0e49394fa9a),
    (0, $2df1207b13a402cc$export$f30a66efa682bf2d),
    (0, $bMm60.createEntry)((0, $a9abc802715eecc6$export$866215abd09c0f4d), {
        component: $f730f07a676cc8e2$var$SoftwareTimelineLegacyRedirect,
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1ac1fc409b478241$export$1339c847cf4ab57)
        ]
    }),
    (0, $f7ee2b416e224377$export$fd29243dbe4103),
    (0, $490b95a631ece100$export$60cf591eccf54b03)
];



var $jh2R9 = parcelRequire("jh2R9");

var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $9zysr = parcelRequire("9zysr");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $7e733baddd3da8de$export$830cd0c207772936 = {
    group: (0, $exb0h.ROUTE_GROUPS_COMPONENTS),
    name: `${(0, $exb0h.ROUTE_NAMES_OPSGENIE_SCHEDULE)}-redirect`,
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page'
    ]
};
const $7e733baddd3da8de$export$534a7ac096cb1da2 = {
    group: (0, $exb0h.ROUTE_GROUPS_COMPONENTS),
    name: (0, $exb0h.ROUTE_NAMES_OPSGENIE_SCHEDULE),
    path: '/jira/:projectType(software|software/c)/projects/:projectKey/on-call-schedule'
};



var $yyqSx = parcelRequire("yyqSx");

var $bEe6y = parcelRequire("bEe6y");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ixwgj = parcelRequire("ixwgj");

var $78d1w = parcelRequire("78d1w");

var $lB25E = parcelRequire("lB25E");
const $7fdd7a8ecac65120$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $lB25E.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $jMP2a.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useResource: useResource = (0, $lB25E.useResource), useRouter: useRouter = (0, $lB25E.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $78d1w.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $ixwgj.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eUqFw.useRef)(createAnalyticsEvent({}));
    (0, $eUqFw.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};



const $8a0093a20afc4089$export$3a9c3ff70731bdd6 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("dExW6"))), {
    moduleId: "./src/packages/spa-apps/project/opsgenie-schedule/src/index.tsx"
});
const $8a0093a20afc4089$export$6ffd640c3062d976 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7fdd7a8ecac65120$export$8a3df560509448b8), {
        page: "/on-call-schedule"
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8a0093a20afc4089$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8a0093a20afc4089$export$3a9c3ff70731bdd6,
        pageId: "opsgenie-schedule",
        shouldShowSpinner: true
    });


const $2dcde5e112eb5768$export$f128c1c4a1f0d631 = (0, $bMm60.createEntry)((0, $7e733baddd3da8de$export$830cd0c207772936), {
    component: !false ? (0, $8a0093a20afc4089$export$6ffd640c3062d976) : (0, $8a0093a20afc4089$export$2e2bcd8739ae039),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $8a0093a20afc4089$export$3a9c3ff70731bdd6)
    ],
    isRedirect: true
});
const $2dcde5e112eb5768$export$924db6cf10ba8696 = (0, $bMm60.createEntry)((0, $7e733baddd3da8de$export$534a7ac096cb1da2), {
    ufoName: 'project-opsgenie-schedule',
    component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $8a0093a20afc4089$export$2e2bcd8739ae039)),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: [
            (0, $iOOlt.default),
            (0, $2Fzrk.default)
        ],
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $8a0093a20afc4089$export$3a9c3ff70731bdd6)
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES_OPSGENIE_SCHEDULE),
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_OPSGENIE_SCHEDULE)),
            teamName: 'fusion-solaris'
        }
    }
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $79xbN = parcelRequire("79xbN");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $jiReJ = parcelRequire("jiReJ");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $1TkEB = parcelRequire("1TkEB");

var $csLgO = parcelRequire("csLgO");


var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $621de40b0dd72f71$var$LazyPeopleProfiles = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("lufsf"))), {
    // becasue `@atlassian/ptc-embeddable-directory` package is not ready for SSR
    ssr: false,
    moduleId: "./src/packages/spa-apps/people-profiles/src/index.tsx"
});
const $621de40b0dd72f71$export$9e44232fa48ba2ee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $621de40b0dd72f71$var$LazyPeopleProfiles,
        pageId: "people-profiles",
        shouldShowSpinner: true
    });
const $621de40b0dd72f71$export$219b6cc00b2f91a0 = (0, $bMm60.createEntry)((0, $1TkEB.peopleProfilesRoute), {
    component: $621de40b0dd72f71$export$9e44232fa48ba2ee,
    layout: (0, $jiReJ.layoutWithCondition)(()=>(0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation'), (0, $csLgO.rightSidebarsLayout), (0, $dVvIP.globalLayout)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $621de40b0dd72f71$var$LazyPeopleProfiles
    ],
    ufoName: 'people-profiles'
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $dfBCt = parcelRequire("dfBCt");

var $fFJZu = parcelRequire("fFJZu");parcelRequire("l96PT");
var $3liNr = parcelRequire("3liNr");

var $cernH = parcelRequire("cernH");


var $jf8p7 = parcelRequire("jf8p7");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $b629e75643c51b94$var$LazyPersonalSettingsSidebar = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("Nf3GR")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/personal-settings/src/index.tsx"
});
const $b629e75643c51b94$var$PersonalSettingsSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "personalSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b629e75643c51b94$var$LazyPersonalSettingsSidebar, null));
var $b629e75643c51b94$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b629e75643c51b94$var$PersonalSettingsSidebar);



var $iJPUk = parcelRequire("iJPUk");

var $bMm60 = parcelRequire("bMm60");


var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $gF5SK = parcelRequire("gF5SK");

var $gyys9 = parcelRequire("gyys9");

var $jwzNs = parcelRequire("jwzNs");

var $7lcEz = parcelRequire("7lcEz");

var $atRHQ = parcelRequire("atRHQ");

var $kkmGZ = parcelRequire("kkmGZ");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $3628ae735fbebea2$export$44d710abd316d1f1 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("bvaDO")), {
        moduleId: "fe0c927e"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            // Queries your async component uses
            queries: {
                pageAndProject: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $kkmGZ.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context.query?.projectIds ? context.query.projectIds.split(',') : []
                    }
                }
            },
            // Optional - Anything extra you wish to pass to your component
            // Something from `EntryPointParams` for example
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});




var $59o4i = parcelRequire("59o4i");

const $624e6e140f752e29$var$LazyLegacyPersonalSettings = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("8Rx0G"))), {
    moduleId: "./src/packages/spa-apps/personal-settings-legacy/src/index.tsx"
});
const $624e6e140f752e29$var$personalSettingsNotificationsEntryPointPage = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $3628ae735fbebea2$export$44d710abd316d1f1),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).NOTIFICATIONS
});

const $624e6e140f752e29$var$LazyGeneralPersonalSettings = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("6sTVt"))), {
    moduleId: "./src/packages/spa-apps/personal-settings/general/src/index.tsx"
});

const $624e6e140f752e29$var$LazyOpsNotificationsPersonalSettings = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("kpP8d"))), {
    moduleId: "./src/packages/spa-apps/personal-settings/ops-notifications/src/index.tsx"
});
const $624e6e140f752e29$var$checkConsolidationOnRouteDependency = (dependencies)=>{
    const { data: data } = dependencies[0, $02315c431173f662$export$25ee35b01de9d734];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $jf8p7.checkShouldUseJSM)(data);
};
const $624e6e140f752e29$export$31dadfd5bc64c9c9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $624e6e140f752e29$var$LazyLegacyPersonalSettings,
        pageId: "personal-settings",
        shouldShowSpinner: true
    });
const $624e6e140f752e29$export$81bedf006ef32751 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $624e6e140f752e29$var$LazyGeneralPersonalSettings,
        pageId: "personal-settings-general",
        shouldShowSpinner: true
    });
const $624e6e140f752e29$export$e30af76ba1def364 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $624e6e140f752e29$var$LazyOpsNotificationsPersonalSettings,
        pageId: "personal-settings-notifications",
        shouldShowSpinner: true
    });
const $624e6e140f752e29$var$getLabsResources = ()=>[
        (0, $gF5SK.newIssueViewTransitionLockInStatusResource),
        (0, $jwzNs.resourceWithCondition2)(()=>!(0, $dfBCt.isFedRamp)(), (0, $gyys9.nextBestTaskFeatureResource))
    ];
const $624e6e140f752e29$export$89646e32fa7698db = (0, $bMm60.createEntry)((0, $7lcEz.legacyPersonalSettingsRoute), {
    component: (0, $bAQOb.componentWithFF)('sea-1973-personal-settings-sidebar', ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: (0, $iJPUk.GENERAL_PERSONAL_SETTINGS_PATH)
        }), $624e6e140f752e29$export$31dadfd5bc64c9c9),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PERSONAL_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).PROFILE
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $fFJZu.createContactsResource)($624e6e140f752e29$var$checkConsolidationOnRouteDependency, [
            (0, $02315c431173f662$export$25ee35b01de9d734)
        ]),
        (0, $fFJZu.createNotificationPreferencesResource)($624e6e140f752e29$var$checkConsolidationOnRouteDependency, [
            (0, $02315c431173f662$export$25ee35b01de9d734)
        ]),
        (0, $3liNr.eocUserResource),
        (0, $fFJZu.createMuteResource)($624e6e140f752e29$var$checkConsolidationOnRouteDependency, [
            (0, $02315c431173f662$export$25ee35b01de9d734)
        ]),
        (0, $fFJZu.createQuietHoursResource)($624e6e140f752e29$var$checkConsolidationOnRouteDependency, [
            (0, $02315c431173f662$export$25ee35b01de9d734)
        ]),
        (0, $fFJZu.createForwardingRulesResource)($624e6e140f752e29$var$checkConsolidationOnRouteDependency, [
            (0, $02315c431173f662$export$25ee35b01de9d734)
        ]),
        ...$624e6e140f752e29$var$getLabsResources()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $624e6e140f752e29$var$LazyLegacyPersonalSettings
    ]
});
const $624e6e140f752e29$export$e8b7e9281fc3db35 = (0, $bMm60.createEntry)((0, $7lcEz.generalPersonalSettingsRoute), {
    component: (0, $bAQOb.componentWithFF)('sea-1973-personal-settings-sidebar', $624e6e140f752e29$export$81bedf006ef32751, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: (0, $iJPUk.LEGACY_PERSONAL_SETTINGS_PATH)
        })),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PERSONAL_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).PROFILE,
        sidebar: (0, $b629e75643c51b94$export$2e2bcd8739ae039)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)(),
        ...$624e6e140f752e29$var$getLabsResources()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $624e6e140f752e29$var$LazyGeneralPersonalSettings
    ]
});
const $624e6e140f752e29$export$640c1b3b96c9032e = (0, $bMm60.createEntry)((0, $7lcEz.notificationsPersonalSettingsRoute), {
    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: (0, $iJPUk.getNotificationsPersonalSettingsPath)()
        }),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PERSONAL_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).PROFILE,
        sidebar: (0, $b629e75643c51b94$export$2e2bcd8739ae039)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    pageId: 'personal-settings-notifications',
    entryPoint () {
        return (0, $1ybV0.ff)('sea-1973-notifications-hub') ? $624e6e140f752e29$var$personalSettingsNotificationsEntryPointPage : undefined;
    }
});
const $624e6e140f752e29$export$d604d3ad2662a845 = [
    $624e6e140f752e29$export$89646e32fa7698db,
    $624e6e140f752e29$export$e8b7e9281fc3db35,
    $624e6e140f752e29$export$640c1b3b96c9032e,
    (0, $bMm60.createEntry)((0, $7lcEz.opsNotificationsPersonalSettingsRoute), {
        component: (0, $bAQOb.componentWithFF)('sea-1973-personal-settings-sidebar', $624e6e140f752e29$export$e30af76ba1def364, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
                to: (0, $iJPUk.LEGACY_PERSONAL_SETTINGS_PATH)
            })),
        layout: (0, $dVvIP.globalLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).PROFILE,
            sidebar: (0, $b629e75643c51b94$export$2e2bcd8739ae039)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $dAKwA.getConsolidationStateResource)(),
            (0, $fFJZu.createContactsResource)(),
            (0, $fFJZu.createNotificationPreferencesResource)(),
            (0, $3liNr.eocUserResource),
            (0, $fFJZu.createMuteResource)(),
            (0, $fFJZu.createQuietHoursResource)(),
            (0, $fFJZu.createForwardingRulesResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $624e6e140f752e29$var$LazyOpsNotificationsPersonalSettings
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $eI5EY = parcelRequire("eI5EY");

var $dVvIP = parcelRequire("dVvIP");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $6FP8W = parcelRequire("6FP8W");

var $8QAGR = parcelRequire("8QAGR");

var $isbb2 = parcelRequire("isbb2");
const $0d7e476d9154aa28$export$d5273c1a2e2fe212 = (0, $isbb2.composeLayouts)((0, $8QAGR.projectLayout));



var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $2JncP = parcelRequire("2JncP");

var $exb0h = parcelRequire("exb0h");
const $74541ef9f6eca715$export$54c333cd4ed2d70e = {
    group: (0, $exb0h.ROUTE_GROUPS_POLARIS),
    name: (0, $exb0h.ROUTE_NAMES_POLARIS_IDEAS),
    path: '/jira/polaris/projects/:projectKey/ideas/:section?/:resource?',
    exact: true
};
const $74541ef9f6eca715$export$d415b74f78a5f159 = {
    group: (0, $exb0h.ROUTE_GROUPS_POLARIS),
    name: (0, $exb0h.ROUTE_NAMES_POLARIS_COLLECTIONS),
    path: '/jira/polaris/roadmaps/:collectionUUID?/:section?/:resource?',
    query: [
        'projects?',
        'owners?'
    ],
    exact: true
};
const $74541ef9f6eca715$export$6696e9deb45fe980 = {
    group: (0, $exb0h.ROUTE_GROUPS_POLARIS),
    name: (0, $exb0h.ROUTE_NAMES_POLARIS_ONBOARDING),
    path: '/welcome/discovery',
    exact: true
};
const $74541ef9f6eca715$export$bfdcdf76e802d67d = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_POLARIS_SETTINGS_ACCESS),
    path: '/jira/settings/products/jira-product-discovery/access',
    exact: true
};
const $74541ef9f6eca715$export$d1d77b6a84982ab8 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_POLARIS_SETTINGS_GLOBAL_FIELDS),
    path: '/jira/settings/products/jira-product-discovery/global-fields',
    exact: true
};
const $74541ef9f6eca715$export$32b1bc71501d2751 = {
    group: (0, $exb0h.ROUTE_GROUPS_POLARIS),
    name: (0, $exb0h.ROUTE_NAMES_POLARIS_UNLICENSED),
    path: '/jira/polaris/unlicensed',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $fTgIJ = parcelRequire("fTgIJ");


var $59o4i = parcelRequire("59o4i");

var $gd0Sp = parcelRequire("gd0Sp");

var $lB25E = parcelRequire("lB25E");

const $b934a3aee34dfece$export$f7960e7dbd7e5265 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("4PiBX"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/collections/src/index.tsx"
});
const $b934a3aee34dfece$var$useJpdLicensed = ()=>{
    const context = (0, $gd0Sp.useTenantContext)();
    return context.licensedProducts['jira-product-discovery'];
};
const $b934a3aee34dfece$export$3bba33442c4150b1 = ()=>{
    const jpdLicensed = $b934a3aee34dfece$var$useJpdLicensed();
    const crossProjectViewsEnabled = (0, $fTgIJ.useIsCrossProjectViewsEnabled)();
    if (!jpdLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: "/jira/polaris/unlicensed"
    });
    if (!crossProjectViewsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: "/jira"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b934a3aee34dfece$export$f7960e7dbd7e5265,
        pageId: "async-polaris-collections",
        shouldShowSpinner: false
    });
};
var $b934a3aee34dfece$export$2e2bcd8739ae039 = $b934a3aee34dfece$export$3bba33442c4150b1;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

var $gd0Sp = parcelRequire("gd0Sp");

var $lB25E = parcelRequire("lB25E");

const $02e9517a92a29b91$export$3fd7cf4494189548 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("36nS2"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/ideas/src/index.tsx"
});
const $02e9517a92a29b91$var$useJpdLicensed = ()=>{
    const context = (0, $gd0Sp.useTenantContext)();
    return context.licensedProducts['jira-product-discovery'];
};
const $02e9517a92a29b91$export$8e495e768b5bbae5 = ()=>{
    const jpdLicensed = $02e9517a92a29b91$var$useJpdLicensed();
    if (!jpdLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: "/jira/polaris/unlicensed"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $02e9517a92a29b91$export$3fd7cf4494189548,
        pageId: "async-polaris-ideas",
        shouldShowSpinner: false
    });
};
var $02e9517a92a29b91$export$2e2bcd8739ae039 = $02e9517a92a29b91$export$8e495e768b5bbae5;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $eb26f02dfaf5ae08$export$13889cc3ce0d5a93 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("1sFiz"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/onboarding/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb26f02dfaf5ae08$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $eb26f02dfaf5ae08$export$13889cc3ce0d5a93,
        pageId: "async-polaris-onboarding",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $1491cb3188cdfe45$export$b66ea0dcd38af7f0 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("gSdsu"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/settings-access/src/index.tsx"
});
const $1491cb3188cdfe45$export$d46497fe68b0853c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1491cb3188cdfe45$export$b66ea0dcd38af7f0,
        pageId: "async-polaris-settings-access",
        shouldShowSpinner: false
    });




var $7vTKl = parcelRequire("7vTKl");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $cdb873a799c32a16$export$f2f24531058bc251 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("xzrGu")), {
        moduleId: "fead11bc"
    }),
    getPreloadProps: ()=>({})
});


const $13542dcb8c0b0569$export$c682ebcd2290352f = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $cdb873a799c32a16$export$f2f24531058bc251),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).SETTINGS
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $15fc721dd8245473$export$394984ca86b38b8f = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("eNvYa"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/unlicensed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$15fc721dd8245473$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $15fc721dd8245473$export$394984ca86b38b8f,
        pageId: "async-polaris-unlicensed",
        shouldShowSpinner: false
    });


const $8605a99074da660f$var$commonResources = [
    (0, $2JncP.projectCreatePermissionsResource)
];
const $8605a99074da660f$var$getPolarisProjectPermissionsResource = ()=>[
        ...$8605a99074da660f$var$commonResources
    ];
const $8605a99074da660f$export$44e0cb320cb148ed = [
    (0, $bMm60.createEntry)((0, $74541ef9f6eca715$export$54c333cd4ed2d70e), {
        ufoName: 'jpd.project',
        component: (0, $02e9517a92a29b91$export$2e2bcd8739ae039),
        layout: (0, $0d7e476d9154aa28$export$d5273c1a2e2fe212),
        canTransitionIn: (current, next)=>{
            if ((0, $6FP8W.getWillShowNav4)() && !(0, $eI5EY.fg)('jpd-nav-v4-disable-page-refresh-from-other-routes') && next?.match?.params?.projectKey && current.match.params.projectKey !== next.match.params.projectKey) return false;
            if ((0, $6FP8W.getWillShowNav4)() && !(0, $eI5EY.fg)('jpd-nav-v4-disable-page-refresh-between-projects') && current?.match?.params?.projectKey && next?.match?.params?.projectKey && current.match.params.projectKey !== next.match.params.projectKey) return false;
            return true;
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $02e9517a92a29b91$export$3fd7cf4494189548)
        ]
    }),
    (0, $bMm60.createEntry)((0, $74541ef9f6eca715$export$d415b74f78a5f159), {
        ufoName: 'jpd.collections',
        component: (0, $b934a3aee34dfece$export$2e2bcd8739ae039),
        layout: (0, $dVvIP.globalLayout),
        canTransitionIn: (current, next)=>{
            if ((0, $eI5EY.fg)('jira_nav4')) {
                if (!(0, $eI5EY.fg)('jpd-nav-v4-disable-page-refresh-to-collection')) {
                    if ((0, $eI5EY.fg)('jpd-sidebar-v4-for-roadmaps-overview')) {
                        // only refresh when we are transitioning from collections overview to collections detail or vice versa
                        if (current?.match?.params?.collectionUUID && !next?.match?.params?.collectionUUID || !current?.match?.params?.collectionUUID && next?.match?.params?.collectionUUID) return false;
                        return true;
                    }
                    // with gate off refresh when transitioning to or from collections app
                    if (current.match.path !== next.match.path) // refresh if we transition to the collections app from somewhere else or vice versa
                    return false;
                }
            }
            // default is no-refresh
            return true;
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $b934a3aee34dfece$export$f7960e7dbd7e5265)
        ]
    }),
    (0, $bMm60.createEntry)((0, $74541ef9f6eca715$export$6696e9deb45fe980), {
        component: (0, $eb26f02dfaf5ae08$export$2e2bcd8739ae039),
        layout: (0, $dVvIP.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...$8605a99074da660f$var$getPolarisProjectPermissionsResource()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $eb26f02dfaf5ae08$export$13889cc3ce0d5a93)
        ]
    }),
    (0, $bMm60.createEntry)((0, $74541ef9f6eca715$export$bfdcdf76e802d67d), {
        component: (0, $1491cb3188cdfe45$export$d46497fe68b0853c),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $7okz2.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1491cb3188cdfe45$export$b66ea0dcd38af7f0)
        ]
    }),
    (0, $bMm60.createEntry)((0, $74541ef9f6eca715$export$d1d77b6a84982ab8), {
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $7okz2.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $13542dcb8c0b0569$export$c682ebcd2290352f;
        }
    }),
    (0, $bMm60.createEntry)((0, $74541ef9f6eca715$export$32b1bc71501d2751), {
        component: (0, $15fc721dd8245473$export$2e2bcd8739ae039),
        layout: (0, $dVvIP.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...$8605a99074da660f$var$getPolarisProjectPermissionsResource()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $15fc721dd8245473$export$394984ca86b38b8f)
        ]
    })
];



var $dfBCt = parcelRequire("dfBCt");

var $cernH = parcelRequire("cernH");

var $9zysr = parcelRequire("9zysr");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");


var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $04cb986a314f8d60$export$7c663ddc097df1e8 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS),
    path: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $6dfb390f0b3cf43c$export$1b7f55251df02fe9 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("fObtr"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-chatops-and-video-tools/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6dfb390f0b3cf43c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6dfb390f0b3cf43c$export$1b7f55251df02fe9,
        pageId: "products-jsm-chatops-and-video-tools",
        shouldShowSpinner: false
    });


const $c0323c6c8a564bae$export$8b55e723205ec5f3 = (0, $bMm60.createEntry)((0, $04cb986a314f8d60$export$7c663ddc097df1e8), {
    component: (0, $9zysr.componentWithCondition)((0, $dfBCt.isFedRamp), (0, $dgH3j.default), (0, $6dfb390f0b3cf43c$export$2e2bcd8739ae039)),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default),
        horizontal: (0, $755c1d456aaac5c2$export$1f7a0efe3746ea0d),
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $755c1d456aaac5c2$export$aea682543f08e131),
        (0, $cernH.LazyAtlassianNavigation),
        (0, $6dfb390f0b3cf43c$export$1b7f55251df02fe9)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $70db59821f14819f$export$6196bf08f64419da = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSM_COMPLIANCE),
    path: '/jira/settings/products/jira-service-management-compliance',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $538dcf8f8fb3317d$export$159d8c0e1862cd2b = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("eRXem"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-compliance/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$538dcf8f8fb3317d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $538dcf8f8fb3317d$export$159d8c0e1862cd2b,
        pageId: "products-jsm-compliance",
        shouldShowSpinner: false
    });


const $5c45641d0f476bbd$export$9cc9423a3967333b = (0, $bMm60.createEntry)((0, $70db59821f14819f$export$6196bf08f64419da), {
    component: (0, $538dcf8f8fb3317d$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $538dcf8f8fb3317d$export$159d8c0e1862cd2b)
    ],
    ufoName: 'admin.jsm-compliance'
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $27df22921068d77e$export$2ad48fbde4743a97 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSM_CONFIGURATION),
    path: '/jira/settings/products/jira-service-management-configuration',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $db26d475d8796f34$export$aa3f3d5ca376f305 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("iegUT"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-configuration/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$db26d475d8796f34$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $db26d475d8796f34$export$aa3f3d5ca376f305,
        pageId: "products-jsm-configuration",
        shouldShowSpinner: false
    });


const $858ab70ef0ef29ff$export$461f2b06a7a914db = (0, $bMm60.createEntry)((0, $27df22921068d77e$export$2ad48fbde4743a97), {
    ufoName: 'admin.jsm-configuration',
    component: (0, $db26d475d8796f34$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $db26d475d8796f34$export$aa3f3d5ca376f305)
    ]
});



var $cernH = parcelRequire("cernH");

var $bAQOb = parcelRequire("bAQOb");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $585a2ff10242e3e9$export$6288bb6ea42acf0c = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSM_EMAIL_REQUESTS),
    path: '/jira/settings/products/jira-service-management-email-requests',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var /** This exists to be used as a route since the redirect as a route and redirect as a component
 * have different props, and flow complains. */ // @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': location, query, route, match, action
// eslint-disable-next-line jira/import/no-anonymous-default-export
$3c8a79d14172157f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9f087e464fef57a9$export$2e2bcd8739ae039), null);



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $3ece24aab4506b3d$export$4c9d90d0caf04d67 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("7W8Zj"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-email-requests/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3ece24aab4506b3d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3ece24aab4506b3d$export$4c9d90d0caf04d67,
        pageId: "products-jsm-email-requests",
        shouldShowSpinner: false
    });


const $ef3b2e76e978001d$export$3f8d7424a47f4dd = (0, $bMm60.createEntry)((0, $585a2ff10242e3e9$export$6288bb6ea42acf0c), {
    ufoName: 'admin.jsm-email-requests',
    component: (0, $bAQOb.componentWithFF)('migrate-jsm-email-requests-settings-page_xbqbk', (0, $3ece24aab4506b3d$export$2e2bcd8739ae039), (0, $3c8a79d14172157f$export$2e2bcd8739ae039)),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $3ece24aab4506b3d$export$4c9d90d0caf04d67)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $8aef35f9ad78b811$export$f98dec539fffaa15 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSM_FEATURE_USAGE),
    path: '/jira/settings/products/servicedesk/feature-usage',
    exact: true
};



var $cV47S = parcelRequire("cV47S");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $e9a8e42a27174b2e$export$5ad1c1e822bd5d34 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("iJk49"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-feature-usage/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e9a8e42a27174b2e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e9a8e42a27174b2e$export$5ad1c1e822bd5d34,
        pageId: "products-jsm-feature-usage",
        shouldShowSpinner: false
    });


const $d9a72e5e6bfe851d$export$80a3e4dda2dcd1a4 = (0, $bMm60.createEntry)((0, $8aef35f9ad78b811$export$f98dec539fffaa15), {
    component: (0, $e9a8e42a27174b2e$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $cV47S.workspaceResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $e9a8e42a27174b2e$export$5ad1c1e822bd5d34)
    ]
});



var $4iKIJ = parcelRequire("4iKIJ");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $d35b0cd5d9c27edc$export$d92d66762943b115 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS),
    path: '/jira/settings/products/ops/reports/:dashboardId',
    exact: true
};
const $d35b0cd5d9c27edc$export$6b3539e7e6bf13e8 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS),
    path: '/jira/settings/products/ops/reports',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $7475ccb852e24c87$export$2404f0e35deca592 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("3mMNE")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $7475ccb852e24c87$export$d33ea1a773b744e = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("3mMNE")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $7475ccb852e24c87$export$66850ec5549adba6 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("3mMNE")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $7475ccb852e24c87$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7475ccb852e24c87$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $7475ccb852e24c87$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7475ccb852e24c87$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $7475ccb852e24c87$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7475ccb852e24c87$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });


const $1052eb222a330200$export$6a7fc41fb2523290 = (0, $bMm60.createEntry)((0, $d35b0cd5d9c27edc$export$d92d66762943b115), {
    component: (0, $7475ccb852e24c87$export$648ddf2d1f8b1c3f),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $4iKIJ.resources),
        (0, $4iKIJ.opsReportsPermissionResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7475ccb852e24c87$export$d33ea1a773b744e)
    ]
});
const $1052eb222a330200$export$6d6efd297963f785 = (0, $bMm60.createEntry)((0, $d35b0cd5d9c27edc$export$6b3539e7e6bf13e8), {
    component: (0, $7475ccb852e24c87$export$22253dbadb46d0cf),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $4iKIJ.resources),
        (0, $4iKIJ.opsReportsPermissionResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7475ccb852e24c87$export$66850ec5549adba6)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $05eaec877d080121$export$da6d538ddabade32 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS),
    path: '/jira/settings/products/jira-service-management-incident-management-tools',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $17cfae62994fe651$export$f541eb9b8f00bfaf = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("bD7R1"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-incident-management-tools/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$17cfae62994fe651$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $17cfae62994fe651$export$f541eb9b8f00bfaf,
        pageId: "products-jsm-incident-management-tools",
        shouldShowSpinner: false
    });


const $20efdafd05df2f3a$export$773f8e3318be1dd5 = (0, $bMm60.createEntry)((0, $05eaec877d080121$export$da6d538ddabade32), {
    component: (0, $17cfae62994fe651$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $17cfae62994fe651$export$f541eb9b8f00bfaf)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $bb7dfdd2f8577352$export$339486410c7a783f = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSM_KB_PERMISSIONS),
    path: '/jira/settings/products/jira-service-management-knowledge-base-permissions',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $d37cbf2e11433c0e$export$a3e7bdc5dbf2d47e = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("5Hxsh"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-kb-permissions/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d37cbf2e11433c0e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d37cbf2e11433c0e$export$a3e7bdc5dbf2d47e,
        pageId: "products-jsm-kb-permissions",
        shouldShowSpinner: false
    });


const $706ea00b80585533$export$717e134eb971b450 = (0, $bMm60.createEntry)((0, $bb7dfdd2f8577352$export$339486410c7a783f), {
    component: (0, $d37cbf2e11433c0e$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $d37cbf2e11433c0e$export$a3e7bdc5dbf2d47e)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $b1sy2 = parcelRequire("b1sy2");

var $bU9Sz = parcelRequire("bU9Sz");

var $6Oo0P = parcelRequire("6Oo0P");

var $kCBYY = parcelRequire("kCBYY");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $b5130b545f640c4b$export$512fa30726e0049d = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS),
    path: '/jira/settings/products/servicedesk/organizations',
    exact: true
};
const $b5130b545f640c4b$export$3ae664dd3f8b73dc = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS),
    path: '/jira/settings/products/servicedesk/organizations/:organizationId',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $7e6711a4573576b1$export$ff149ceefa65ab70 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("d260x"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organization-details/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7e6711a4573576b1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7e6711a4573576b1$export$ff149ceefa65ab70,
        pageId: "products-jsm-organization-details",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $3264d0db5bce9a61$export$410bec6e06fd4723 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("7e0QF"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organizations-list/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3264d0db5bce9a61$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3264d0db5bce9a61$export$410bec6e06fd4723,
        pageId: "products-jsm-organizations-list",
        shouldShowSpinner: true
    });


const $7b162697914d48c2$export$34d843946d3894aa = (0, $bMm60.createEntry)((0, $b5130b545f640c4b$export$512fa30726e0049d), {
    ufoName: 'admin.jsm-organization-page-list',
    isRedirect: false,
    component: (0, $3264d0db5bce9a61$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $kCBYY.productsJsmOrganizationListResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $3264d0db5bce9a61$export$410bec6e06fd4723)
    ]
});
const $7b162697914d48c2$export$6d18fd46547afb8e = (0, $bMm60.createEntry)((0, $b5130b545f640c4b$export$3ae664dd3f8b73dc), {
    ufoName: 'admin.jsm-organization-page-list',
    isRedirect: false,
    component: (0, $7e6711a4573576b1$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $bU9Sz.productsJsmOrganizationDetailsResource),
        (0, $6Oo0P.productsJsmOrganizationMembersResource),
        (0, $kCBYY.productsJsmOrganizationListResource),
        (0, $b1sy2.jsmEmailDomainsListResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7e6711a4573576b1$export$ff149ceefa65ab70)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $8vc2n = parcelRequire("8vc2n");

var $esxKW = parcelRequire("esxKW");

var $i51fR = parcelRequire("i51fR");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $49352938dbf7be05$export$f9a32397033f9ced = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("iU03p"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-configuration/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$49352938dbf7be05$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $49352938dbf7be05$export$f9a32397033f9ced,
        pageId: "products-jsw-configuration",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $c4b843d79941daa9$export$a4f5e12ce817cbb8 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("8y1c8"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-storage-management/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c4b843d79941daa9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c4b843d79941daa9$export$a4f5e12ce817cbb8,
        pageId: "products-jsw-storage-management",
        shouldShowSpinner: true
    });


const $4497ae40fde48600$export$2f65b1ec4ed05f91 = (0, $bMm60.createEntry)((0, $i51fR.productsJswConfigurationRoute), {
    ufoName: 'admin.jsw-configuration',
    component: (0, $49352938dbf7be05$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $8vc2n.productsJswConfigurationResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $49352938dbf7be05$export$f9a32397033f9ced)
    ]
});
const $4497ae40fde48600$export$c62ca2d3fcc552a5 = (0, $bMm60.createEntry)((0, $i51fR.productsJswConfigurationStorageManagementRoute), {
    ufoName: 'admin.jsw-configuration.storage-management',
    component: (0, $c4b843d79941daa9$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $esxKW.productsJswStorageManagementResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $c4b843d79941daa9$export$a4f5e12ce817cbb8)
    ]
});



var $cernH = parcelRequire("cernH");


var $iZnNg = parcelRequire("iZnNg");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $exb0h = parcelRequire("exb0h");
const $7ccbe961b49f6771$var$CORE_PRODUCT = 'core';
const $7ccbe961b49f6771$var$SOFTWARE_PRODUCT = 'software';
const $7ccbe961b49f6771$var$SERVICE_DESK_PRODUCT = 'servicedesk';
const $7ccbe961b49f6771$var$jiraIssueFormCreateEndpoint = 'projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?'; // the 1 query param is "requestTypeId"
const $7ccbe961b49f6771$var$EXPORT_URL = '/jira/forms/export';
const $7ccbe961b49f6771$var$ISSUE_FORMS_GENERAL_URL = '/jira/forms/create';
const $7ccbe961b49f6771$export$158441d4f5c68fb9 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROFORMA),
    name: (0, $exb0h.ROUTE_NAMES_PROFORMA_EXPORT_SERVICEDESK),
    path: $7ccbe961b49f6771$var$EXPORT_URL,
    exact: true
};
const $7ccbe961b49f6771$export$416ac492f873673a = {
    group: (0, $exb0h.ROUTE_GROUPS_PROFORMA),
    name: (0, $exb0h.ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SERVICEDESK),
    path: $7ccbe961b49f6771$var$ISSUE_FORMS_GENERAL_URL,
    exact: true
};
const $7ccbe961b49f6771$export$574435c4e2f6a27e = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SERVICEDESK),
    path: `/jira/${$7ccbe961b49f6771$var$SERVICE_DESK_PRODUCT}/${$7ccbe961b49f6771$var$jiraIssueFormCreateEndpoint}`,
    exact: true
};
const $7ccbe961b49f6771$export$d48be9e2caaca83d = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SERVICEDESK),
    path: `/jira/${$7ccbe961b49f6771$var$SERVICE_DESK_PRODUCT}/${$7ccbe961b49f6771$var$jiraIssueFormCreateEndpoint}/embed`,
    exact: true
};
const $7ccbe961b49f6771$export$fb73a18f932b2c15 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROFORMA),
    name: (0, $exb0h.ROUTE_NAMES_PROFORMA_EXPORT_CLASSIC_BUSINESS),
    path: $7ccbe961b49f6771$var$EXPORT_URL,
    exact: true
};
const $7ccbe961b49f6771$export$ec7e58425379b5d0 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROFORMA),
    name: (0, $exb0h.ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_CLASSIC_BUSINESS),
    path: $7ccbe961b49f6771$var$ISSUE_FORMS_GENERAL_URL,
    exact: true
};
const $7ccbe961b49f6771$export$76ab9f3014b2e370 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_CLASSIC_BUSINESS),
    path: `/jira/${$7ccbe961b49f6771$var$CORE_PRODUCT}/${$7ccbe961b49f6771$var$jiraIssueFormCreateEndpoint}`,
    exact: true
};
const $7ccbe961b49f6771$export$55ce393dc053bec4 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_CLASSIC_BUSINESS),
    path: `/jira/${$7ccbe961b49f6771$var$CORE_PRODUCT}/${$7ccbe961b49f6771$var$jiraIssueFormCreateEndpoint}/embed`,
    exact: true
};
const $7ccbe961b49f6771$export$4c5d46fe4c460ef9 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROFORMA),
    name: (0, $exb0h.ROUTE_NAMES_PROFORMA_EXPORT_SOFTWARE),
    path: $7ccbe961b49f6771$var$EXPORT_URL,
    exact: true
};
const $7ccbe961b49f6771$export$7de22a6665b73706 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROFORMA),
    name: (0, $exb0h.ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SOFTWARE),
    path: $7ccbe961b49f6771$var$ISSUE_FORMS_GENERAL_URL,
    exact: true
};
const $7ccbe961b49f6771$export$c02a5b8ecf73713e = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SOFTWARE),
    path: `/jira/${$7ccbe961b49f6771$var$SOFTWARE_PRODUCT}/${$7ccbe961b49f6771$var$jiraIssueFormCreateEndpoint}`,
    exact: true
};
const $7ccbe961b49f6771$export$cd0e54104fd6e37c = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SOFTWARE),
    path: `/jira/${$7ccbe961b49f6771$var$SOFTWARE_PRODUCT}/${$7ccbe961b49f6771$var$jiraIssueFormCreateEndpoint}/embed`,
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $soOXK = parcelRequire("soOXK");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $7715e223327779be$export$5e0d802a5d865352 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("aK0h7")), {
    moduleId: "./src/packages/spa-apps/proforma-export/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7715e223327779be$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7715e223327779be$export$5e0d802a5d865352,
        pageId: "proforma-export",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $5f94abb64b62ae5b$export$a0f04dd35569e11 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("jizTM")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5f94abb64b62ae5b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5f94abb64b62ae5b$export$a0f04dd35569e11,
        pageId: "proforma-issue-forms-direct",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $89fa0a59411ddd45$export$22681210aaeb910f = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("bRIfe")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$89fa0a59411ddd45$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $89fa0a59411ddd45$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $357e75320b6357c0$export$7c16b09eb95f1c5d = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("88JsJ")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-general/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$357e75320b6357c0$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $357e75320b6357c0$export$7c16b09eb95f1c5d,
        pageId: "proforma-issue-forms-general",
        shouldShowSpinner: true
    });


const $2719ac30f4e07b26$export$786e5a0c86be676a = [
    (0, $bMm60.createEntry)((0, $7ccbe961b49f6771$export$158441d4f5c68fb9), {
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        component: (0, $7715e223327779be$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7715e223327779be$export$5e0d802a5d865352)
        ]
    }),
    (0, $bMm60.createEntry)((0, $7ccbe961b49f6771$export$416ac492f873673a), {
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        component: (0, $357e75320b6357c0$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $357e75320b6357c0$export$7c16b09eb95f1c5d)
        ],
        perfMetricKey: 'issue-forms-general'
    }),
    (0, $bMm60.createEntry)((0, $7ccbe961b49f6771$export$574435c4e2f6a27e), {
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        component: (0, $5f94abb64b62ae5b$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $5f94abb64b62ae5b$export$a0f04dd35569e11)
        ],
        perfMetricKey: 'issue-forms-direct'
    }),
    (0, $bMm60.createEntry)((0, $7ccbe961b49f6771$export$d48be9e2caaca83d), {
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        component: (0, $89fa0a59411ddd45$export$2e2bcd8739ae039),
        forPaint: [
            (0, $89fa0a59411ddd45$export$22681210aaeb910f)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    })
];
const $2719ac30f4e07b26$export$c4313dd46c85e3d3 = [
    (0, $bMm60.createEntry)((0, $7ccbe961b49f6771$export$fb73a18f932b2c15), {
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        component: (0, $7715e223327779be$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7715e223327779be$export$5e0d802a5d865352)
        ]
    }),
    (0, $bMm60.createEntry)((0, $7ccbe961b49f6771$export$ec7e58425379b5d0), {
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        component: (0, $357e75320b6357c0$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $357e75320b6357c0$export$7c16b09eb95f1c5d)
        ],
        perfMetricKey: 'issue-forms-general'
    }),
    (0, $bMm60.createEntry)((0, $7ccbe961b49f6771$export$76ab9f3014b2e370), {
        layout: (0, $iZnNg.coreProjectLayout),
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        component: (0, $5f94abb64b62ae5b$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $5f94abb64b62ae5b$export$a0f04dd35569e11)
        ],
        perfMetricKey: 'issue-forms-direct'
    }),
    (0, $bMm60.createEntry)((0, $7ccbe961b49f6771$export$55ce393dc053bec4), {
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        component: (0, $89fa0a59411ddd45$export$2e2bcd8739ae039),
        forPaint: [
            (0, $89fa0a59411ddd45$export$22681210aaeb910f)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    })
];
const $2719ac30f4e07b26$export$2e672712b21297b8 = [
    (0, $bMm60.createEntry)((0, $7ccbe961b49f6771$export$4c5d46fe4c460ef9), {
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        component: (0, $7715e223327779be$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7715e223327779be$export$5e0d802a5d865352)
        ]
    }),
    (0, $bMm60.createEntry)((0, $7ccbe961b49f6771$export$7de22a6665b73706), {
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        component: (0, $357e75320b6357c0$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $357e75320b6357c0$export$7c16b09eb95f1c5d)
        ],
        perfMetricKey: 'issue-forms-general'
    }),
    (0, $bMm60.createEntry)((0, $7ccbe961b49f6771$export$c02a5b8ecf73713e), {
        layout: (0, $soOXK.softwareProjectLayout),
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        component: (0, $5f94abb64b62ae5b$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $5f94abb64b62ae5b$export$a0f04dd35569e11)
        ],
        perfMetricKey: 'issue-forms-direct'
    }),
    (0, $bMm60.createEntry)((0, $7ccbe961b49f6771$export$cd0e54104fd6e37c), {
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        component: (0, $89fa0a59411ddd45$export$2e2bcd8739ae039),
        forPaint: [
            (0, $89fa0a59411ddd45$export$22681210aaeb910f)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    })
];
const $2719ac30f4e07b26$export$2763334cca1560d7 = [
    ...$2719ac30f4e07b26$export$786e5a0c86be676a,
    ...$2719ac30f4e07b26$export$c4313dd46c85e3d3,
    ...$2719ac30f4e07b26$export$2e672712b21297b8
];



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $8r1Yz = parcelRequire("8r1Yz");

var $ixwgj = parcelRequire("ixwgj");
const $c3b27776d577c96d$export$1d7a0c194c3e83f2 = [
    'selectedItem=com.atlassian.jira.jira-projects-plugin:components-page'
];



var $exb0h = parcelRequire("exb0h");
const $f7c9990bca772508$export$d370abe25253fa1b = {
    group: (0, $exb0h.ROUTE_GROUPS_COMPONENTS),
    name: `${(0, $exb0h.ROUTE_NAMES_PROJECT_COMPONENTS)}-redirect`,
    path: '/projects/:projectKey',
    query: (0, $c3b27776d577c96d$export$1d7a0c194c3e83f2)
};
const $f7c9990bca772508$export$f76189bea494b0b8 = {
    group: (0, $exb0h.ROUTE_GROUPS_COMPONENTS),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_COMPONENTS),
    path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/components'
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $k4nIh = parcelRequire("k4nIh");


var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ixwgj = parcelRequire("ixwgj");

var $78d1w = parcelRequire("78d1w");

var $lB25E = parcelRequire("lB25E");
const $f8aad89894949912$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $lB25E.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $jMP2a.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useResource: useResource = (0, $lB25E.useResource), useRouter: useRouter = (0, $lB25E.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $78d1w.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $ixwgj.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eUqFw.useRef)(createAnalyticsEvent({}));
    (0, $eUqFw.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};



const $2d1a09ddaa7fa887$export$f32c20cfbc84532c = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("lr08r"))), {
    moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
});
const $2d1a09ddaa7fa887$export$9cf9ae84482ff18e = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $k4nIh.qs).stringify(rest, true);
        return `/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8aad89894949912$export$8a3df560509448b8), {
        page: page
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2d1a09ddaa7fa887$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2d1a09ddaa7fa887$export$f32c20cfbc84532c,
        pageId: "project-components",
        shouldShowSpinner: false
    });


const $3637efef4b0c5bc2$export$e60f53ff5ae626cd = (0, $bMm60.createEntry)((0, $f7c9990bca772508$export$d370abe25253fa1b), {
    component: !false ? (0, $2d1a09ddaa7fa887$export$9cf9ae84482ff18e) : (0, $2d1a09ddaa7fa887$export$2e2bcd8739ae039),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $8r1Yz.projectsComponentsResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $2d1a09ddaa7fa887$export$f32c20cfbc84532c)
    ],
    isRedirect: true
});
const $3637efef4b0c5bc2$export$25cf284456caeeef = (0, $bMm60.createEntry)((0, $f7c9990bca772508$export$f76189bea494b0b8), {
    ufoName: 'project-components-view',
    component: (0, $2d1a09ddaa7fa887$export$2e2bcd8739ae039),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $8r1Yz.projectsComponentsResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $2d1a09ddaa7fa887$export$f32c20cfbc84532c)
    ]
});




var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $cc5275954e8b5636$export$ad23ddca45852d02 = {
    group: (0, $exb0h.ROUTE_GROUPS_ERRORS),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_NOT_FOUND),
    path: '/jira/:projectType(software|servicedesk|core|polaris)/projects/:projectKey/not-found',
    exact: true
};



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $e740fc46bb475e33$export$6ffa2f426ba3b25a = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("64DIX")), {
        moduleId: "51ed29c5"
    }),
    getPreloadProps: ()=>({})
});


const $65d35ca4bc52d7e7$export$f5a338b3fe5182bb = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $e740fc46bb475e33$export$6ffa2f426ba3b25a),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $65d35ca4bc52d7e7$export$beae48175e3016b8 = (0, $bMm60.createEntry)((0, $cc5275954e8b5636$export$ad23ddca45852d02), {
    entryPoint () {
        return $65d35ca4bc52d7e7$export$f5a338b3fe5182bb;
    },
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    pageId: 'project-not-found-page-id'
});



var $cernH = parcelRequire("cernH");

var $9zysr = parcelRequire("9zysr");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $07bae85033f836a2$export$2d09da22e737849e = {
    group: (0, $exb0h.ROUTE_GROUPS_COMPONENTS),
    name: `${(0, $exb0h.ROUTE_NAMES_PROJECT_PAGES)}-legacy`,
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page'
    ]
};
const $07bae85033f836a2$export$54a218ca6d1c056a = {
    group: (0, $exb0h.ROUTE_GROUPS_COMPONENTS),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_PAGES),
    path: '/jira/:projectType(software|software/c|servicedesk)/projects/:projectKey/pages'
};



var $yyqSx = parcelRequire("yyqSx");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ixwgj = parcelRequire("ixwgj");

var $78d1w = parcelRequire("78d1w");

var $lB25E = parcelRequire("lB25E");
const $0b738748b4c83495$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $lB25E.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $jMP2a.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useResource: useResource = (0, $lB25E.useResource), useRouter: useRouter = (0, $lB25E.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $78d1w.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $ixwgj.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eUqFw.useRef)(createAnalyticsEvent({}));
    (0, $eUqFw.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};



const $6da5e9c3e963df27$export$c2115a649411f570 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("jt6YF"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/project/pages/src/index.tsx"
});
const $6da5e9c3e963df27$export$7c3b1828ada63555 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0b738748b4c83495$export$8a3df560509448b8), {
        page: "/pages"
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6da5e9c3e963df27$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6da5e9c3e963df27$export$c2115a649411f570,
        pageId: "project-pages",
        shouldShowSpinner: false
    });


const $ffed543118f23d13$export$babf32528ef518e9 = (0, $bMm60.createEntry)((0, $07bae85033f836a2$export$2d09da22e737849e), {
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    component: !false ? (0, $6da5e9c3e963df27$export$7c3b1828ada63555) : (0, $6da5e9c3e963df27$export$2e2bcd8739ae039),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $6da5e9c3e963df27$export$c2115a649411f570)
    ],
    isRedirect: true
});
const $ffed543118f23d13$export$6e8865417e6a38c = (0, $bMm60.createEntry)((0, $07bae85033f836a2$export$54a218ca6d1c056a), {
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $6da5e9c3e963df27$export$2e2bcd8739ae039)),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $6da5e9c3e963df27$export$c2115a649411f570)
    ]
});



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $8r1Yz = parcelRequire("8r1Yz");

var $ixwgj = parcelRequire("ixwgj");

var $ktArR = parcelRequire("ktArR");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $k4nIh = parcelRequire("k4nIh");


var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ixwgj = parcelRequire("ixwgj");

var $78d1w = parcelRequire("78d1w");

var $lB25E = parcelRequire("lB25E");
const $e702f5143f2f0fb4$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $lB25E.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $jMP2a.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useResource: useResource = (0, $lB25E.useResource), useRouter: useRouter = (0, $lB25E.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $78d1w.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $ixwgj.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eUqFw.useRef)(createAnalyticsEvent({}));
    (0, $eUqFw.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};



const $d206bd5dee47a41e$export$bb69d8c36391123 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("lr08r"))), {
    moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
});
const $d206bd5dee47a41e$export$60cfbcd781a48d01 = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $k4nIh.qs).stringify(rest, true);
        return `/settings/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e702f5143f2f0fb4$export$8a3df560509448b8), {
        page: page
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d206bd5dee47a41e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d206bd5dee47a41e$export$bb69d8c36391123,
        pageId: "project-settings-components",
        shouldShowSpinner: true
    });


const $dba4682a95e5bab0$export$72497f4e39dd0df4 = (0, $bMm60.createEntry)((0, $ktArR.projectSettingsComponentsRoute), {
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $8r1Yz.projectsComponentsResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    component: (0, $d206bd5dee47a41e$export$2e2bcd8739ae039),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $d206bd5dee47a41e$export$bb69d8c36391123)
    ]
});



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $gVIF2 = parcelRequire("gVIF2");

var $3pqMH = parcelRequire("3pqMH");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $b5d8285e4e4394db$export$9036da4fa9f7a66f = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("a7kPQ"))), {
    moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
});
const $b5d8285e4e4394db$export$9aff7dab80671d9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b5d8285e4e4394db$export$9036da4fa9f7a66f,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });


const $00c9b0281306dc31$export$4791201b4877aa5d = (0, $bMm60.createEntry)((0, $3pqMH.projectSettingsVersionsRoute), {
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $gVIF2.projectVersionsRelayResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    component: (0, $b5d8285e4e4394db$export$9aff7dab80671d9),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $b5d8285e4e4394db$export$9036da4fa9f7a66f)
    ]
});



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $4mBNF = parcelRequire("4mBNF");

var $50N5G = parcelRequire("50N5G");
const $3dfca2b5a9cb36ce$export$56f9921db324f30 = (0, $bMm60.createEntry)((0, $50N5G.projectsRedirectRoute), {
    isRedirect: true,
    component: (0, $4mBNF.RedirectToLastVisitedProjectPage),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $gVIF2 = parcelRequire("gVIF2");
const $98900ab4c6b6a9b7$export$ad46185437bb571a = [
    'selectedItem=com.atlassian.jira.jira-projects-plugin:release-page'
];



var $exb0h = parcelRequire("exb0h");
const $6108f51b191ada48$export$fb5516756c3eba40 = {
    group: (0, $exb0h.ROUTE_GROUPS_COMPONENTS),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_VERSIONS),
    path: '/projects/:projectKey',
    query: (0, $98900ab4c6b6a9b7$export$ad46185437bb571a)
};




var $59o4i = parcelRequire("59o4i");

const $3a69954879d67a4b$export$9036da4fa9f7a66f = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("a7kPQ"))), {
    moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
});
const $3a69954879d67a4b$export$9aff7dab80671d9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3a69954879d67a4b$export$9036da4fa9f7a66f,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });
const $3a69954879d67a4b$export$982bc443ef89cc3f = (0, $bMm60.createEntry)((0, $6108f51b191ada48$export$fb5516756c3eba40), {
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $gVIF2.projectVersionsRelayResource)
    ],
    component: $3a69954879d67a4b$export$9aff7dab80671d9,
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $3a69954879d67a4b$export$9036da4fa9f7a66f
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $6CNdU = parcelRequire("6CNdU");

var $d4Gv0 = parcelRequire("d4Gv0");

var $1ODui = parcelRequire("1ODui");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");


var $59o4i = parcelRequire("59o4i");

const $0e750e81870ad8bd$var$LazyServicedeskCustomerServiceEscalations = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("3udVg"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-service-escalations/src/index.tsx"
});
const $0e750e81870ad8bd$export$1a08682f4847bb2f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0e750e81870ad8bd$var$LazyServicedeskCustomerServiceEscalations,
        pageId: "spa-apps/servicedesk/customer-service-escalations",
        shouldShowSpinner: true
    });
const $0e750e81870ad8bd$export$36a7c374f4474cc1 = (0, $bMm60.createEntry)((0, $1ODui.escalationsRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $kbHFR.getServiceDeskNavigationResources)(),
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $6CNdU.componentFilterResource),
        (0, $d4Gv0.priorityFilterResource)
    ],
    component: $0e750e81870ad8bd$export$1a08682f4847bb2f,
    perfMetricKey: 'jsm-customer-service-escalations-component-load',
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0e750e81870ad8bd$var$LazyServicedeskCustomerServiceEscalations
    ],
    meta: {
        reporting: {
            id: (0, $frZnw.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS,
            packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS),
            teamName: 'boysenberry'
        }
    }
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $gGtKh = parcelRequire("gGtKh");


const $eec12bcff4bffa70$var$LazyDirectoryNav = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("l2463")).then(({ DirectoryHorizontalNav: DirectoryHorizontalNav })=>DirectoryHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/directory/src/ui/index.tsx"
});
const $eec12bcff4bffa70$export$a237f415539577a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-jsm-directory-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eec12bcff4bffa70$var$LazyDirectoryNav, null));



var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $kbHFR = parcelRequire("kbHFR");

var $aP2Ra = parcelRequire("aP2Ra");

var $f7Fx7 = parcelRequire("f7Fx7");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");


var $59o4i = parcelRequire("59o4i");

const $e14bffeebd141c9d$var$LazyServicedeskCustomerServiceProducts = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("90XVg"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-service-products/src/index.tsx"
});
const $e14bffeebd141c9d$export$46ba99069f037d90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e14bffeebd141c9d$var$LazyServicedeskCustomerServiceProducts,
        pageId: "spa-apps/servicedesk/customer-service-products",
        shouldShowSpinner: true
    });
const $e14bffeebd141c9d$export$8e015e39dbc90d0b = (0, $bMm60.createEntry)((0, $f7Fx7.productsRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default),
        horizontal: (0, $eec12bcff4bffa70$export$a237f415539577a5),
        // TODO: Remove this during jira_nav4 cleanup
        onlyShowHorziontalOnNav4: true
    },
    resources: [
        ...(0, $kbHFR.getServiceDeskNavigationResources)(),
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $aP2Ra.customerServiceProductsQueryResource)
    ],
    component: $e14bffeebd141c9d$export$46ba99069f037d90,
    perfMetricKey: 'jsm-customer-service-products-component-load',
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e14bffeebd141c9d$var$LazyServicedeskCustomerServiceProducts
    ],
    meta: {
        reporting: {
            id: (0, $frZnw.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS,
            packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS),
            teamName: 'boysenberry'
        }
    }
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $e7f4080e2acdf189$export$b314ab31b2da625b = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_SETTINGS_AUTOMATION),
    path: '/jira/settings/automation',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $k4nIh = parcelRequire("k4nIh");


var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ixwgj = parcelRequire("ixwgj");

var $78d1w = parcelRequire("78d1w");

var $lB25E = parcelRequire("lB25E");
const $8c98e397e7108d42$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $lB25E.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $jMP2a.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useResource: useResource = (0, $lB25E.useResource), useRouter: useRouter = (0, $lB25E.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $78d1w.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $ixwgj.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eUqFw.useRef)(createAnalyticsEvent({}));
    (0, $eUqFw.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};



const $1f271376b40d6837$export$4189991a2992b828 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("hgLMC"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/automation/src/index.tsx"
});
const $1f271376b40d6837$export$7c85ddcd4f0a813f = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $k4nIh.qs).stringify(rest, true);
        return `/automation${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8c98e397e7108d42$export$8a3df560509448b8), {
        page: page
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f271376b40d6837$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1f271376b40d6837$export$4189991a2992b828,
        pageId: "global-automation",
        shouldShowSpinner: false
    });


const $cbfac00f5b372876$export$4df9f9dcaf8565c9 = (0, $bMm60.createEntry)((0, $e7f4080e2acdf189$export$b314ab31b2da625b), {
    component: (0, $1f271376b40d6837$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $1f271376b40d6837$export$4189991a2992b828)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $d48e699701a023d4$export$5097bfaa68f86ca6 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG),
    path: '/secure/admin/CmdbObjectFieldConfiguration'
};



var $cV47S = parcelRequire("cV47S");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $a4363cd77e921691$export$ccc6da5137e23637 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("hFcCh"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/cmdb-field-config/src/index.tsx"
});
const $a4363cd77e921691$export$8dfbe255f554ebab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a4363cd77e921691$export$ccc6da5137e23637,
        pageId: "admin-pages-cmdb-field-config",
        shouldShowSpinner: true
    });


const $31538ea633950fb6$export$c68a412f25295511 = (0, $bMm60.createEntry)((0, $d48e699701a023d4$export$5097bfaa68f86ca6), {
    ufoName: 'admin.cmdb-field-config',
    component: (0, $a4363cd77e921691$export$8dfbe255f554ebab),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        (0, $cV47S.workspaceResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $a4363cd77e921691$export$ccc6da5137e23637)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $l90Gp = parcelRequire("l90Gp");

var $hUM03 = parcelRequire("hUM03");

var $bMm60 = parcelRequire("bMm60");

var $3nZzB = parcelRequire("3nZzB");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $db93091f8ec8ae56$export$c0ee28def7ef8783 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS),
    path: '/secure/admin/oauth-credentials'
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $e643f050bed13082$export$101baa25055633e8 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("fVXRl"))), {
    moduleId: "./src/packages/spa-apps/admin-oauth-credentials/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e643f050bed13082$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e643f050bed13082$export$101baa25055633e8,
        pageId: "admin-oauth-credentials",
        shouldShowSpinner: true
    });


const $5c5c328d1a0c046c$export$d1c67ceb7c5e2d6a = (0, $bMm60.createEntry)((0, $db93091f8ec8ae56$export$c0ee28def7ef8783), {
    component: (0, $e643f050bed13082$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $hUM03.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        (0, $3nZzB.adminOauthCredentialsResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $e643f050bed13082$export$101baa25055633e8)
    ],
    ufoName: 'admin.oauth-credentials'
});



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");


var $9zysr = parcelRequire("9zysr");

var $eI5EY = parcelRequire("eI5EY");

var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $bMm60 = parcelRequire("bMm60");

var $9HzdP = parcelRequire("9HzdP");

var $hHrVM = parcelRequire("hHrVM");

var $3MEW8 = parcelRequire("3MEW8");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $7d81f8438b2c42a7$export$5e6c92d2f34c1e48 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ONBOARDING),
    path: '/welcome/software',
    exact: true
};
const $7d81f8438b2c42a7$export$c25273c48ccc0eb9 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED),
    path: '/jira/software/projects/:projectKey/get-started',
    exact: true
};



var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");


var $59o4i = parcelRequire("59o4i");

const $6fe987b31d848aa1$export$31e9f06d3389e445 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("dfgyM"))), {
    moduleId: "./src/packages/spa-apps/software/onboarding/src/index.tsx"
});

const $6fe987b31d848aa1$export$689f7402bb424709 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("eyzDx"))), {
    moduleId: "./src/packages/spa-apps/onboarding/get-started/src/index.tsx"
});
const $6fe987b31d848aa1$export$ee768d69c6e3a8bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6fe987b31d848aa1$export$31e9f06d3389e445,
        pageId: "software-onboarding",
        shouldShowSpinner: false
    });
const $6fe987b31d848aa1$export$d11bafa06a0717e3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6fe987b31d848aa1$export$689f7402bb424709,
        pageId: "onboarding-get-started",
        shouldShowSpinner: false
    });
const $6fe987b31d848aa1$export$23e1ab8ae95bd3a8 = [
    (0, $bMm60.createEntry)((0, $7d81f8438b2c42a7$export$5e6c92d2f34c1e48), {
        component: $6fe987b31d848aa1$export$ee768d69c6e3a8bd,
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        resources: [
            (0, $9HzdP.jswOnboardingResource),
            (0, $3MEW8.themePreferenceResource)
        ],
        forPaint: [
            $6fe987b31d848aa1$export$31e9f06d3389e445
        ],
        canTransitionIn: ()=>false
    })
];
const $6fe987b31d848aa1$export$d06c2ab36705e562 = [
    (0, $bMm60.createEntry)((0, $7d81f8438b2c42a7$export$c25273c48ccc0eb9), {
        component: (0, $9zysr.componentWithCondition)(()=>(0, $eI5EY.fg)('jira_one_screen_onboarding_feature_gate'), $6fe987b31d848aa1$export$d11bafa06a0717e3, (0, $dgH3j.default)),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $6fe987b31d848aa1$export$689f7402bb424709
        ],
        canTransitionIn: ()=>true,
        ufoName: 'software-onboarding-get-started'
    })
];



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7hF3Y = parcelRequire("7hF3Y");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $1160f58455475cf7$export$74ec9fecd42fa96e = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY),
    path: '/secure/projects/trash',
    exact: true
};
const $1160f58455475cf7$export$a788f0ca96b92194 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY),
    path: '/jira/settings/projects/trash',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $lB25E = parcelRequire("lB25E");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d7a6521eda4880f6$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "projectsTrashRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: "/jira/settings/projects/trash"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $0a22d45a48ec33de$export$dd65a8ee0a9ac24f = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("6l5vZ"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/trashed-projects/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0a22d45a48ec33de$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0a22d45a48ec33de$export$dd65a8ee0a9ac24f,
        pageId: "trashed-projects",
        shouldShowSpinner: true
    });


const $6700056f9681aaf5$export$27d1f352c2f7acae = (0, $bMm60.createEntry)((0, $1160f58455475cf7$export$74ec9fecd42fa96e), {
    ufoName: 'admin.trashed-projects',
    component: (0, $d7a6521eda4880f6$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7hF3Y.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $0a22d45a48ec33de$export$dd65a8ee0a9ac24f)
    ],
    isRedirect: true
});
const $6700056f9681aaf5$export$f52136d9a0848792 = (0, $bMm60.createEntry)((0, $1160f58455475cf7$export$a788f0ca96b92194), {
    ufoName: 'admin.trashed-projects',
    component: (0, $0a22d45a48ec33de$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7hF3Y.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $0a22d45a48ec33de$export$dd65a8ee0a9ac24f)
    ]
});




var $bMm60 = parcelRequire("bMm60");

var $exb0h = parcelRequire("exb0h");
const $736d45f5f6a0c234$export$b0b13170cadf6395 = {
    name: (0, $exb0h.ROUTE_NAMES_USER_SEGMENTATION),
    path: '/jira/get-started',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $08da66b78fd06c7d$export$bf9c9e0729c919f5 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("5G7YB"))), {
    moduleId: "./src/packages/user-segmentation/src/index.tsx"
});
const $08da66b78fd06c7d$export$15f8c5ccbb9c7ec3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $08da66b78fd06c7d$export$bf9c9e0729c919f5,
        pageId: "user-segmentation",
        shouldShowSpinner: true
    });


const $2f06ff747a0e9944$export$2af76482b576a135 = (0, $bMm60.createEntry)((0, $736d45f5f6a0c234$export$b0b13170cadf6395), {
    ufoName: 'user-segmentation',
    component: (0, $08da66b78fd06c7d$export$15f8c5ccbb9c7ec3),
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
    forPaint: [
        (0, $08da66b78fd06c7d$export$bf9c9e0729c919f5)
    ]
});



var $bW80q = parcelRequire("bW80q");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $b632b27b4ab3e384$export$146910ddc36bf151 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_CONTACT_ADMINISTRATOR),
    path: '/jira/contact-administrator'
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $ecd8ccfd623c2340$export$bf75747a931b9a2b = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("cmPGV"))), {
    moduleId: "./src/packages/admin-pages/contact-administrator/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ecd8ccfd623c2340$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ecd8ccfd623c2340$export$bf75747a931b9a2b,
        pageId: "jira-admin-pages-contact-administrator",
        shouldShowSpinner: true
    });


const $021c609a71aef057$export$1ca91576d82f7098 = [
    (0, $bMm60.createEntry)((0, $b632b27b4ab3e384$export$146910ddc36bf151), {
        ufoName: 'admin.contact-administrator',
        component: (0, $ecd8ccfd623c2340$export$2e2bcd8739ae039),
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ecd8ccfd623c2340$export$bf75747a931b9a2b)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");


var $1ybV0 = parcelRequire("1ybV0");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $87SmV = parcelRequire("87SmV");

var $exb0h = parcelRequire("exb0h");
const $7989cf88f1843569$export$aed294a4a292b909 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG),
    path: '/jira/settings/system/notification-logs',
    exact: true
};


/**
 * @generated SignedSource<<6106f34f1da05e19191cff41bffd4296>>
 * @relayHash 1d90cf309bc3da9c32297c3b1e952819
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d
const $3b082deb244ea614$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d",
        "metadata": {},
        "name": "uiNotificationLogsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $3b082deb244ea614$export$2e2bcd8739ae039 = $3b082deb244ea614$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $a1ea5eaf508d0c55$export$818d841e00bb3749 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("bW3HI")), {
        moduleId: "d533cc53"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $3b082deb244ea614$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context?.query?.projectId,
                        notificationType: 'INTERNAL_NOTIFICATION',
                        notificationActionType: 'USER_INVITE',
                        recipientId: ''
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});




var $59o4i = parcelRequire("59o4i");
const $fc291bfad8a02cf2$var$emailNotificationsLogEntryPointPage = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $a1ea5eaf508d0c55$export$818d841e00bb3749),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).SETTINGS
});

const $fc291bfad8a02cf2$export$b2f1a46be2e3ed3f = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("bW3HI"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/notification-logs/src/index.tsx"
});
const $fc291bfad8a02cf2$var$NotificationLogs = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $fc291bfad8a02cf2$export$b2f1a46be2e3ed3f,
        pageId: "Notification Logs",
        shouldShowSpinner: false
    });
const $fc291bfad8a02cf2$export$e3943daecc3985cb = [
    (0, $bMm60.createEntry)((0, $7989cf88f1843569$export$aed294a4a292b909), {
        component: $fc291bfad8a02cf2$var$NotificationLogs,
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $87SmV.systemConfigurationGeneralResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $fc291bfad8a02cf2$export$b2f1a46be2e3ed3f
        ],
        pageId: 'admin-settings-email-notifications-log',
        entryPoint () {
            return (0, $1ybV0.ff)('platform.jlove-pulsar.jlovep-423-jsw-notification-logs-ui') ? $fc291bfad8a02cf2$var$emailNotificationsLogEntryPointPage : undefined;
        }
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $782cc9d158b3be78$export$17c79100fc4c65a1 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_EXTERNAL_IMPORT),
    path: '/jira/settings/system/external-import'
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9b16e61bd30e0322$var$LazyExternalImport = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("bFoIb")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/admin-pages/external-import/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9b16e61bd30e0322$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9b16e61bd30e0322$var$LazyExternalImport,
        pageId: "external-import-general",
        shouldShowSpinner: false
    });


const $56d0c84c95c21918$export$c535ef4656da2cd9 = [
    (0, $bMm60.createEntry)((0, $782cc9d158b3be78$export$17c79100fc4c65a1), {
        component: (0, $9b16e61bd30e0322$export$2e2bcd8739ae039),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $dnJL9 = parcelRequire("dnJL9");

var $eI5EY = parcelRequire("eI5EY");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $8jcNY = parcelRequire("8jcNY");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $8228560afc8f1e0f$export$236ce89eb737f752 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_GLOBAL_PERMISSIONS),
    path: '/secure/admin/global-permissions'
};



var $dgH3j = parcelRequire("dgH3j");


var $59o4i = parcelRequire("59o4i");

const $bb9b0d3ef4010bcb$export$a97b1349c011eb4 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("3XFvl"))), {
    moduleId: "./src/packages/permissions-administration/pages/global-permissions/src/index.tsx"
});
const $bb9b0d3ef4010bcb$export$a8d149dea7df681c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $bb9b0d3ef4010bcb$export$a97b1349c011eb4,
        pageId: "jira-global-permissions",
        shouldShowSpinner: true
    });
const $bb9b0d3ef4010bcb$export$db45b991e5ee3460 = [
    (0, $bMm60.createEntry)((0, $8228560afc8f1e0f$export$236ce89eb737f752), {
        component: (0, $dnJL9.componentWithFG)('olympus-global-permissions-fe-modernisation', $bb9b0d3ef4010bcb$export$a8d149dea7df681c, (0, $dgH3j.default)),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $8jcNY.globalPermissionsResource)
        ],
        canTransitionIn: ()=>(0, $eI5EY.fg)('olympus-global-permissions-fe-modernisation'),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $bb9b0d3ef4010bcb$export$a97b1349c011eb4
        ],
        meta: {
            reporting: {
                id: 'GlobalPermissions',
                packageName: 'jiraAdminPagesGlobalPermissions',
                teamName: 'olympus'
            }
        }
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $dXIya = parcelRequire("dXIya");

var $8K5zM = parcelRequire("8K5zM");

var $eDggO = parcelRequire("eDggO");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $1MAZH = parcelRequire("1MAZH");

var $atRHQ = parcelRequire("atRHQ");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $de1ad3ad20337085$export$1ff7255ab4f7a2dd = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("45fT3"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-hierarchy-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$de1ad3ad20337085$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $de1ad3ad20337085$export$1ff7255ab4f7a2dd,
        pageId: "jira-admin-pages-issue-hierarchy-directory",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $767c3e340ddbb52b$export$611728a54ba37830 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("dcxZI"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-type-schemes-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$767c3e340ddbb52b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $767c3e340ddbb52b$export$611728a54ba37830,
        pageId: "jira-admin-pages-issue-type-schemes-directory",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $518e347d6dbe1cf4$export$661e1bf38bb82270 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("dJuWy"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-types-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$518e347d6dbe1cf4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $518e347d6dbe1cf4$export$661e1bf38bb82270,
        pageId: "jira-admin-pages-issue-types-directory",
        shouldShowSpinner: true
    });


const $653716d20d53efbb$export$84bb32992a534053 = [
    (0, $bMm60.createEntry)((0, $1MAZH.globalSettingsIssueHierarchyRoute), {
        ufoName: 'global-admin.issues.issue-hierarchy-config',
        component: (0, $de1ad3ad20337085$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $dXIya.issueHierarchyPageResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $de1ad3ad20337085$export$1ff7255ab4f7a2dd)
        ]
    }),
    (0, $bMm60.createEntry)((0, $1MAZH.globalSettingsIssueHierarchyRedirectRoute), {
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
                to: "/jira/settings/issues/issue-hierarchy"
            }),
        isRedirect: true,
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $dXIya.issueHierarchyPageResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $de1ad3ad20337085$export$1ff7255ab4f7a2dd)
        ]
    }),
    (0, $bMm60.createEntry)((0, $1MAZH.globalSettingsIssueTypesRoute), {
        ufoName: 'global-admin.issues.issue-types',
        component: (0, $518e347d6dbe1cf4$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $eDggO.issueTypesResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $518e347d6dbe1cf4$export$661e1bf38bb82270)
        ]
    }),
    (0, $bMm60.createEntry)((0, $1MAZH.globalSettingsIssueTypesSchemesRoute), {
        ufoName: 'global-admin.issues.view-issue-type-schemes',
        component: (0, $767c3e340ddbb52b$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $8K5zM.default)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $767c3e340ddbb52b$export$611728a54ba37830)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $d2cDI = parcelRequire("d2cDI");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $864b735c7a57a8e0$export$6395086ce7e72e37 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSM_AUTHENTICATION_SETTINGS),
    path: '/jira/settings/products/servicedesk/authentication',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $2d2f0d7c6647391c$export$6cd59b0135f3fe86 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("9zpPg"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-authentication-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2d2f0d7c6647391c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2d2f0d7c6647391c$export$6cd59b0135f3fe86,
        pageId: "spa-apps/admin-pages/jsm-authentication-settings",
        shouldShowSpinner: false
    });


const $6539e688c217108a$export$f2cf147a5850af7e = [
    (0, $bMm60.createEntry)((0, $864b735c7a57a8e0$export$6395086ce7e72e37), {
        ufoName: 'admin.jsm-authentication-settings',
        component: (0, $2d2f0d7c6647391c$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $7okz2.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
            (0, $d2cDI.jsmCustomerAuthenticationSettingsResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $2d2f0d7c6647391c$export$6cd59b0135f3fe86)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $eUcUT = parcelRequire("eUcUT");

var $fdikA = parcelRequire("fdikA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $a4a38d0701c0eb81$export$b97e3b6231be8149 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSM_CUSTOMER_ACCESS),
    path: '/jira/settings/products/servicedesk/customer-access',
    exact: true
};




var $59o4i = parcelRequire("59o4i");

const $975754e951894e46$export$1ae94ce2cc225b3d = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("ioNr7"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/customer-access/src/index.tsx"
});
const $975754e951894e46$export$fce5e73f94a6878 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $975754e951894e46$export$1ae94ce2cc225b3d,
        pageId: "spa-apps/admin-pages/customer-access",
        shouldShowSpinner: false
    });
const $975754e951894e46$export$15a1d95a862eb682 = [
    (0, $bMm60.createEntry)((0, $a4a38d0701c0eb81$export$b97e3b6231be8149), {
        ufoName: 'admin.jsm-customer-access',
        component: $975754e951894e46$export$fce5e73f94a6878,
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $7okz2.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
            (0, $fdikA.jsmGlobalCustomerAccessSettingsResource),
            (0, $eUcUT.jsmGlobalCustomerAccessAffectedProjectsResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $975754e951894e46$export$1ae94ce2cc225b3d
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $06c176f3dee7edd0$export$774dc60e785b8ae8 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH),
    path: '/jira/settings/issues/new-issue-search-transition'
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $7efc2490c799cfed$export$aa5e318abd957ad = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("4lDM6"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/new-issue-search-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7efc2490c799cfed$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7efc2490c799cfed$export$aa5e318abd957ad,
        pageId: "jira-admin-pages-new-issue-search-transition",
        shouldShowSpinner: true
    });


const $0309b5ec06bbad8a$export$8f3854f8ef3c4116 = [
    (0, $bMm60.createEntry)((0, $06c176f3dee7edd0$export$774dc60e785b8ae8), {
        ufoName: 'admin.new-issue-search-transition',
        component: (0, $7efc2490c799cfed$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7efc2490c799cfed$export$aa5e318abd957ad)
        ],
        canTransitionIn: ()=>true
    })
];



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $leDf8 = parcelRequire("leDf8");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $aBAel = parcelRequire("aBAel");

var $exb0h = parcelRequire("exb0h");
const $33e8c57e513fab5f$export$2b269dcf51f5a4d3 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_BULK_MAIL),
    path: '/jira/settings/system/send-email'
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $cf4dc26f651648bb$export$416f8039fbf50bea = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("e2wYK"))), {
    moduleId: "./src/packages/admin-pages/bulk-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cf4dc26f651648bb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $cf4dc26f651648bb$export$416f8039fbf50bea,
        pageId: "jira-admin-pages-bulk-email",
        shouldShowSpinner: true
    });


const $16d73d06eda2fcaa$export$d16163932c3babaa = [
    (0, $bMm60.createEntry)((0, $33e8c57e513fab5f$export$2b269dcf51f5a4d3), {
        component: (0, $cf4dc26f651648bb$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $leDf8.SidebarGlobalSettingsSystem)
        },
        layout: (0, $efFTI.globalSettingsLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $aBAel.getOfferingCatalogueFeaturesResource)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $cf4dc26f651648bb$export$416f8039fbf50bea)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $dnJL9 = parcelRequire("dnJL9");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $fI7ei = parcelRequire("fI7ei");

var $exb0h = parcelRequire("exb0h");
const $a6e33a090d141e00$export$677fc3a2086479d2 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW),
    path: '/jira/settings/system/performance/overview'
};
const $a6e33a090d141e00$export$d4f7a24791f8b506 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL),
    path: '/jira/settings/system/performance/metric/:metricKey'
};
const $a6e33a090d141e00$export$198b0dea5bcb104d = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD),
    path: '/jira/settings/system/performance/metrics/customfield'
};
const $a6e33a090d141e00$export$a615b79ae9fb06e5 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE),
    path: '/jira/settings/system/performance/metrics/issue'
};
const $a6e33a090d141e00$export$c81695f590e65a42 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR),
    path: '/jira/settings/system/performance/metrics/projectroleactor'
};
const $a6e33a090d141e00$export$c0d3487a9dc79ff3 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP),
    path: '/jira/settings/system/performance/metrics/projectCleanup'
};



var $dgH3j = parcelRequire("dgH3j");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $0f93f795403e872a$export$d323aa888b5be0c2 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("ga2uX"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-custom-field/src/index.tsx"
});
const $0f93f795403e872a$export$446bf9be075b3cb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0f93f795403e872a$export$d323aa888b5be0c2,
        pageId: "system-performance-metric-detail-custom-field",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $771fa191123b7cd0$export$e44cbefb7c57e031 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("ez4Wi"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-issue/src/index.tsx"
});
const $771fa191123b7cd0$export$30b22d5292fcd86f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $771fa191123b7cd0$export$e44cbefb7c57e031,
        pageId: "system-performance-metric-detail-issue",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $f2c29bc8b35211e8$export$a02cb3bfa11d0dc0 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("4EVQj"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-cleanup/src/index.tsx"
});
const $f2c29bc8b35211e8$export$2adb5abd6651c182 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f2c29bc8b35211e8$export$a02cb3bfa11d0dc0,
        pageId: "system-performance-metric-detail-project-cleanup",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $d736301ecdb5ddd4$export$41ecfa31d3d81e1c = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("WjI3O"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-role-actor/src/index.tsx"
});
const $d736301ecdb5ddd4$export$3c58376b89706313 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d736301ecdb5ddd4$export$41ecfa31d3d81e1c,
        pageId: "system-performance-metric-detail-project-role-actor",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $jMP2a = parcelRequire("jMP2a");

var $atRHQ = parcelRequire("atRHQ");

var $lB25E = parcelRequire("lB25E");
const $20aecad5f40673b9$export$dda90f06f8afe9ec = ()=>{
    const [{ match: match }] = (0, $lB25E.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        // If we have a metric key in the URL, we know the user has accessed the old route
        // and we should fire an operational analytics event.
        // Once the frequency of this event is 0, we can consider removing the redirect.
        if (match?.params?.metricKey) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'old-metric-detail-route visited', {
            metricKey: match.params.metricKey
        });
    }, [
        match?.params?.metricKey,
        createAnalyticsEvent
    ]);
    if (match == null || match.params == null || match.params.metricKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/settings/system/performance/overview"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: `/jira/settings/system/performance/metrics/${match.params.metricKey}`
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $6e96b35e33f9ab62$export$17b4d4eaede5f445 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("h7R8c"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/overview/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6e96b35e33f9ab62$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6e96b35e33f9ab62$export$17b4d4eaede5f445,
        pageId: "system-performance-overview",
        shouldShowSpinner: true
    });


const $e81e98739346c2ae$export$98e757ecbae3f469 = [
    (0, $bMm60.createEntry)((0, $a6e33a090d141e00$export$677fc3a2086479d2), {
        component: (0, $6e96b35e33f9ab62$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $fI7ei.metricsOverviewPageResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6e96b35e33f9ab62$export$17b4d4eaede5f445)
        ]
    }),
    // This is an old route that is not used anymore. It is kept here for backward compatibility.
    (0, $bMm60.createEntry)((0, $a6e33a090d141e00$export$d4f7a24791f8b506), {
        component: (0, $20aecad5f40673b9$export$dda90f06f8afe9ec),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $bMm60.createEntry)((0, $a6e33a090d141e00$export$c0d3487a9dc79ff3), {
        // On FF cleanup of site-optimizer-project-cleanup replace with ProjectCleanupMetricDetail
        component: (0, $dnJL9.componentWithFG)('site-optimizer-project-cleanup', (0, $f2c29bc8b35211e8$export$2adb5abd6651c182), (0, $dgH3j.default)),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f2c29bc8b35211e8$export$a02cb3bfa11d0dc0)
        ]
    }),
    (0, $bMm60.createEntry)((0, $a6e33a090d141e00$export$198b0dea5bcb104d), {
        component: (0, $0f93f795403e872a$export$446bf9be075b3cb),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $0f93f795403e872a$export$d323aa888b5be0c2)
        ]
    }),
    (0, $bMm60.createEntry)((0, $a6e33a090d141e00$export$a615b79ae9fb06e5), {
        component: (0, $771fa191123b7cd0$export$30b22d5292fcd86f),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $771fa191123b7cd0$export$e44cbefb7c57e031)
        ]
    }),
    (0, $bMm60.createEntry)((0, $a6e33a090d141e00$export$c81695f590e65a42), {
        component: (0, $d736301ecdb5ddd4$export$3c58376b89706313),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d736301ecdb5ddd4$export$41ecfa31d3d81e1c)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $bWR2E = parcelRequire("bWR2E");

var $i4OkI = parcelRequire("i4OkI");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $c84f82624ae4466a$export$d57f448badd0561f = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES),
    path: '/jira/settings/issues/permission-schemes/:schemeId'
};
const $c84f82624ae4466a$export$ceade8e040291782 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PERMISSION_SCHEMES),
    path: '/jira/settings/issues/permission-schemes-new/:schemeId'
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $238d4cd8561efc3d$export$4549705b02900c32 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("kpCRE"))), {
    moduleId: "./src/packages/permissions-administration/pages/edit-permission-scheme/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$238d4cd8561efc3d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $238d4cd8561efc3d$export$4549705b02900c32,
        pageId: "jira-edit-permission-scheme",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $61b2c43d81902f10$export$f7fcf8304eb17dda = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("iP71V"))), {
    moduleId: "./src/packages/permissions-administration/pages/permission-scheme/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61b2c43d81902f10$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $61b2c43d81902f10$export$f7fcf8304eb17dda,
        pageId: "jira-permission-scheme",
        shouldShowSpinner: true
    });


const $86aa54873b5e4d35$export$ac0fc473d7d21da1 = [
    (0, $bMm60.createEntry)((0, $c84f82624ae4466a$export$d57f448badd0561f), {
        ufoName: 'global-admin.issues.configure-permission-scheme',
        component: (0, $238d4cd8561efc3d$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $bWR2E.editPermissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $238d4cd8561efc3d$export$4549705b02900c32)
        ],
        meta: {
            reporting: {
                id: 'EditPermissionScheme',
                packageName: 'jiraAdminPagesEditPermissionScheme',
                teamName: 'olympus'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $c84f82624ae4466a$export$ceade8e040291782), {
        ufoName: 'global-admin.issues.configure-permission-scheme',
        component: (0, $61b2c43d81902f10$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $i4OkI.permissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $61b2c43d81902f10$export$f7fcf8304eb17dda)
        ],
        meta: {
            reporting: {
                id: 'PermissionScheme',
                packageName: 'jiraAdminPagesPermissionScheme',
                teamName: 'olympus'
            }
        }
    })
];



var $dnJL9 = parcelRequire("dnJL9");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $415HX = parcelRequire("415HX");

var $dgH3j = parcelRequire("dgH3j");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $75740b050e620f30$export$2b5843205130631c = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("aBYvY"))), {
    moduleId: "./src/packages/admin-pages/priorities/src/index.tsx"
});
const $75740b050e620f30$var$PrioritiesPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $75740b050e620f30$export$2b5843205130631c,
        pageId: "jira-admin-pages-priorities",
        shouldShowSpinner: true
    });
var $75740b050e620f30$export$2e2bcd8739ae039 = $75740b050e620f30$var$PrioritiesPage;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $a46153459398e263$export$20bb8a3b40a3add4 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("c7KuD"))), {
    moduleId: "./src/packages/admin-pages/priority-schemes/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a46153459398e263$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a46153459398e263$export$20bb8a3b40a3add4,
        pageId: "jira-admin-pages-priority-schemes",
        shouldShowSpinner: true
    });


const $32e3d440eb88e6f8$export$cd38898806de0f08 = [
    (0, $bMm60.createEntry)((0, $415HX.globalSettingsIssuesPrioritiesRoute), {
        component: (0, $dnJL9.componentWithFG)('priorities_page_frontend_statsig', (0, $75740b050e620f30$export$2e2bcd8739ae039), (0, $dgH3j.default)),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $75740b050e620f30$export$2b5843205130631c)
        ]
    }),
    (0, $bMm60.createEntry)((0, $415HX.globalSettingsIssuesPrioritySchemesRoute), {
        component: (0, $a46153459398e263$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $a46153459398e263$export$20bb8a3b40a3add4)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $3074b8c45ab4668d$export$6633247975d81f28 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS),
    path: '/jira/settings/forms/data-connections'
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $f5374854697f8a1a$export$a81885366284dc75 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("MOxZn"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/proforma/data-connections/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f5374854697f8a1a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f5374854697f8a1a$export$a81885366284dc75,
        pageId: "jira-admin-pages-forms-data-connections",
        shouldShowSpinner: true
    });


const $a7982332a48ff6de$export$2763334cca1560d7 = [
    (0, $bMm60.createEntry)((0, $3074b8c45ab4668d$export$6633247975d81f28), {
        component: (0, $f5374854697f8a1a$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f5374854697f8a1a$export$a81885366284dc75)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $589aed3f66931630$export$197fd5d0ee709ca4 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS),
    path: '/jira/settings/issues/screens'
};
const $589aed3f66931630$export$3c5a0cf6ecc1bdf1 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES),
    path: '/jira/settings/issues/screen-schemes'
};
const $589aed3f66931630$export$df93a4addc359237 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES),
    path: '/jira/settings/issues/issue-type-screen-schemes'
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $50c3458bd150401b$export$350edfb57b335a57 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("8xBSc"))), {
    moduleId: "./src/packages/admin-pages/screens/issue-type-screen-schemes-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$50c3458bd150401b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $50c3458bd150401b$export$350edfb57b335a57,
        pageId: "jira-admin-pages-issue-type-screen-schemes-page",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $65b62be276283c61$export$342ae41503f611f1 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("9XHQi"))), {
    moduleId: "./src/packages/admin-pages/screens/screen-schemes-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$65b62be276283c61$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $65b62be276283c61$export$342ae41503f611f1,
        pageId: "jira-admin-pages-screen-schemes-page",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $11214c2fba69fbea$export$f4e6d546d7f2894c = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("bzcVJ"))), {
    moduleId: "./src/packages/admin-pages/screens/screens-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$11214c2fba69fbea$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $11214c2fba69fbea$export$f4e6d546d7f2894c,
        pageId: "jira-admin-pages-screens-page",
        shouldShowSpinner: true
    });


const $bd05fba4111b1685$export$75afafbdb2230f9 = [
    (0, $bMm60.createEntry)((0, $589aed3f66931630$export$197fd5d0ee709ca4), {
        ufoName: 'global-admin.issues.screens',
        component: (0, $11214c2fba69fbea$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $11214c2fba69fbea$export$f4e6d546d7f2894c)
        ]
    }),
    (0, $bMm60.createEntry)((0, $589aed3f66931630$export$3c5a0cf6ecc1bdf1), {
        ufoName: 'global-admin.issues.screen-schemes',
        component: (0, $65b62be276283c61$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $65b62be276283c61$export$342ae41503f611f1)
        ]
    }),
    (0, $bMm60.createEntry)((0, $589aed3f66931630$export$df93a4addc359237), {
        ufoName: 'global-admin.issues.issue-type-screen-schemes',
        component: (0, $50c3458bd150401b$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $50c3458bd150401b$export$350edfb57b335a57)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $87SmV = parcelRequire("87SmV");

var $kcaE4 = parcelRequire("kcaE4");

var $eUqFw = parcelRequire("eUqFw");

var $atRHQ = parcelRequire("atRHQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8506fb65690d7c5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/settings/system/general-configuration"
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $d9bedf0f0026de5c$export$c452a8c622781ccd = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("4GPTc"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/system-configuration-general/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d9bedf0f0026de5c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d9bedf0f0026de5c$export$c452a8c622781ccd,
        pageId: "system-configuration-general",
        shouldShowSpinner: false
    });


const $c3b74d1b43e0bee0$export$e8714add09855505 = [
    (0, $bMm60.createEntry)((0, $kcaE4.systemConfigurationRoute), {
        component: (0, $d9bedf0f0026de5c$export$2e2bcd8739ae039),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $87SmV.systemConfigurationGeneralResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d9bedf0f0026de5c$export$c452a8c622781ccd)
        ]
    }),
    (0, $bMm60.createEntry)((0, $kcaE4.routeNamesSystemConfigurationRedirectRoute), {
        component: (0, $e8506fb65690d7c5$export$2e2bcd8739ae039),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $87SmV.systemConfigurationGeneralResource)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $8e18691fffc56315$export$20631ff3b13dafc0 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER),
    path: '/jira/settings/system/ui/announcement-banner'
};




var $59o4i = parcelRequire("59o4i");

const $292b65d10be54418$export$3c41e9fc9ec0d170 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("f9bq5"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/system/ui/announcement-banner/src/index.tsx"
});
const $292b65d10be54418$export$eb84257d269db72c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $292b65d10be54418$export$3c41e9fc9ec0d170,
        pageId: "admin-pages-system-ui-announcement-banner",
        shouldShowSpinner: true
    });
const $292b65d10be54418$export$7b7dd85536177527 = [
    (0, $bMm60.createEntry)((0, $8e18691fffc56315$export$20631ff3b13dafc0), {
        ufoName: 'global-admin.system.ui.announcement-banner',
        component: $292b65d10be54418$export$eb84257d269db72c,
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $292b65d10be54418$export$3c41e9fc9ec0d170
        ]
    })
];



var $cV7Hm = parcelRequire("cV7Hm");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $586860c5637a3c41$export$9d533f08a4447cc = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT),
    path: '/jira/settings/issues/workflows/:workflowId'
};
const $586860c5637a3c41$export$f8f2a617a2f4d53 = {
    group: (0, $exb0h.ROUTE_GROUPS_GLOBAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW),
    path: '/jira/settings/issues/workflows'
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $d4f17224fb536c43$export$cb79ebb337a95317 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("32Eub"))), {
    moduleId: "./src/packages/admin-pages/workflows/edit-workflow/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d4f17224fb536c43$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d4f17224fb536c43$export$cb79ebb337a95317,
        pageId: "jira-admin-pages-edit-workflow",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $b126a36b78f97fb9$export$4c64b4f1ecf22fc8 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("dudew"))), {
    moduleId: "./src/packages/admin-pages/workflows/list-workflows/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b126a36b78f97fb9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b126a36b78f97fb9$export$4c64b4f1ecf22fc8,
        pageId: "jira-admin-pages-list-workflows",
        shouldShowSpinner: true
    });


const $15f0e9867b3e1aec$export$401ea91784469e3a = [
    (0, $bMm60.createEntry)((0, $586860c5637a3c41$export$9d533f08a4447cc), {
        ufoName: 'global-admin.issues.edit-workflow',
        component: (0, $d4f17224fb536c43$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d4f17224fb536c43$export$cb79ebb337a95317)
        ]
    }),
    (0, $bMm60.createEntry)((0, $586860c5637a3c41$export$f8f2a617a2f4d53), {
        ufoName: 'global-admin.issues.view-workflows',
        component: (0, $b126a36b78f97fb9$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $cV7Hm.default)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $b126a36b78f97fb9$export$4c64b4f1ecf22fc8)
        ]
    })
];


const $b4bce7e4d8567b3c$export$c9b96dd6f5a7b454 = [
    ...(0, $bd05fba4111b1685$export$75afafbdb2230f9),
    ...(0, $15f0e9867b3e1aec$export$401ea91784469e3a),
    ...(0, $653716d20d53efbb$export$84bb32992a534053),
    ...(0, $021c609a71aef057$export$1ca91576d82f7098),
    ...(0, $292b65d10be54418$export$7b7dd85536177527),
    ...(0, $975754e951894e46$export$15a1d95a862eb682),
    ...(0, $6539e688c217108a$export$f2cf147a5850af7e),
    ...(0, $16d73d06eda2fcaa$export$d16163932c3babaa),
    ...(0, $86aa54873b5e4d35$export$ac0fc473d7d21da1),
    ...(0, $a7982332a48ff6de$export$2763334cca1560d7),
    ...(0, $0309b5ec06bbad8a$export$8f3854f8ef3c4116),
    ...(0, $e81e98739346c2ae$export$98e757ecbae3f469),
    ...(0, $32e3d440eb88e6f8$export$cd38898806de0f08),
    ...(0, $bb9b0d3ef4010bcb$export$db45b991e5ee3460),
    ...(0, $c3b74d1b43e0bee0$export$e8714add09855505),
    ...(0, $56d0c84c95c21918$export$c535ef4656da2cd9),
    ...(0, $fc291bfad8a02cf2$export$e3943daecc3985cb)
];



var $cernH = parcelRequire("cernH");

var $dnJL9 = parcelRequire("dnJL9");

var $7vTKl = parcelRequire("7vTKl");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $754936767cbd051f$export$ea77f88c1b841127 = (0, $6VZoe.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("8zjVA")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/help-center-settings/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $754936767cbd051f$var$HelpCenterSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($754936767cbd051f$export$ea77f88c1b841127, null)));
$754936767cbd051f$var$HelpCenterSettingsSidebar.displayName = 'HelpCenterSettingsSidebar';
var $754936767cbd051f$export$2e2bcd8739ae039 = $754936767cbd051f$var$HelpCenterSettingsSidebar;



var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $ixwgj = parcelRequire("ixwgj");

var $kbHFR = parcelRequire("kbHFR");

var $47r3J = parcelRequire("47r3J");

var $6RfAJ = parcelRequire("6RfAJ");

var $6bQqb = parcelRequire("6bQqb");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $8a16c55182848ccf$var$HELP_CENTER_SETTINGS_URL = '/jira/helpcenter/projects/:projectKey/settings';
const $8a16c55182848ccf$export$f544881b6385f520 = {
    group: (0, $exb0h.ROUTE_GROUPS_HELP_CENTER_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_HELP_CENTER_SETTINGS),
    path: $8a16c55182848ccf$var$HELP_CENTER_SETTINGS_URL,
    exact: true
};
const $8a16c55182848ccf$export$8a784299dc7faaff = {
    group: (0, $exb0h.ROUTE_GROUPS_HELP_CENTER_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_HELP_CENTER_SETTINGS_KNOWLEDGE_BASE),
    path: `${$8a16c55182848ccf$var$HELP_CENTER_SETTINGS_URL}/kb`,
    exact: true
};
const $8a16c55182848ccf$export$88fcb9acf40a0827 = {
    group: (0, $exb0h.ROUTE_GROUPS_HELP_CENTER_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_NOTIFICATIONS),
    path: `${$8a16c55182848ccf$var$HELP_CENTER_SETTINGS_URL}/customer-notifications`
};
const $8a16c55182848ccf$export$4515288a48c62087 = {
    group: (0, $exb0h.ROUTE_GROUPS_HELP_CENTER_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_HELP_CENTER_SETTINGS_EMAIL),
    path: `${$8a16c55182848ccf$var$HELP_CENTER_SETTINGS_URL}/email`,
    exact: true
};
const $8a16c55182848ccf$export$766193806f1c2ba8 = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS_HELP_CENTER_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPES),
    path: `${$8a16c55182848ccf$var$HELP_CENTER_SETTINGS_URL}/request-types/unassigned`
};
const $8a16c55182848ccf$export$dd1d3b3f528e7077 = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS_HELP_CENTER_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPE_FIELDS),
    path: `${$8a16c55182848ccf$var$HELP_CENTER_SETTINGS_URL}/request-types/unassigned/request-type/:requestTypeId/:tabKey?`
};



var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $b094d7f31889a702$export$b2b6550dec008a98 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("6ErPW"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/customer-notifications/src/index.tsx"
});
const $b094d7f31889a702$export$2f2f18f57014444a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b094d7f31889a702$export$b2b6550dec008a98,
        pageId: "help-center-settings-customer-notifications",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $3cfe67a93fd6dab7$export$e090cd3a62343249 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("60Ico")), {
    moduleId: "./src/packages/spa-apps/help-center-settings/email/src/index.tsx"
});
const $3cfe67a93fd6dab7$export$962f20e752738967 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3cfe67a93fd6dab7$export$e090cd3a62343249,
        pageId: "help-center-settings-email",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $9ae9ed18d17d7b80$export$92983043c677b1b1 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("lsy4i"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/knowledge-settings/src/index.tsx"
});
const $9ae9ed18d17d7b80$export$c1d58cf9dc0a2ed3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9ae9ed18d17d7b80$export$92983043c677b1b1,
        pageId: "help-center-settings-knowledge-base",
        shouldShowSpinner: true
    });



var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $ede9542b57e4c269$export$b7262fe486f4b412 = 'core';
const $ede9542b57e4c269$export$2954328f6207617a = 'software';
const $ede9542b57e4c269$export$5575497f0592ee94 = 'servicedesk';
const $ede9542b57e4c269$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $ede9542b57e4c269$export$586756e5c0542a50 = (product)=>{
    if (product === $ede9542b57e4c269$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $ede9542b57e4c269$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};



var $eUqFw = parcelRequire("eUqFw");

var $dgH3j = parcelRequire("dgH3j");


var $atRHQ = parcelRequire("atRHQ");

var $lB25E = parcelRequire("lB25E");
const $8ee2ddde41e1795b$export$2d8d895a0a0f636e = ()=>{
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const helpCenterSettingsEmail = (0, $8a16c55182848ccf$export$4515288a48c62087).path.replace(':projectKey', projectKey);
    return projectKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: helpCenterSettingsEmail,
        persistSearchParams: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dgH3j.default), null);
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $6e748ba2ed8cb30f$export$d0ea3970831afb33 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("5Xs8s")).then((module)=>module.HelpCenterSettingsTicketTypeFieldsPage), {
    moduleId: "./src/packages/spa-apps/help-center-settings/ticket-type-fields/src/ui/index.tsx"
});
const $6e748ba2ed8cb30f$export$76418008a8957579 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6e748ba2ed8cb30f$export$d0ea3970831afb33,
        pageId: "help-center-settings-ticket-type-fields",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $3d64bb7f9ad5a1ad$export$dcabea7d416bc1b4 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("4NVcr")).then((module)=>module.HelpCenterSettingsTicketTypesConfigPage), {
    moduleId: "./src/packages/spa-apps/help-center-settings/ticket-types-config/src/ui/index.tsx"
});
const $3d64bb7f9ad5a1ad$export$4aca0a164c4d76df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3d64bb7f9ad5a1ad$export$dcabea7d416bc1b4,
        pageId: "help-center-settings-ticket-types-config",
        shouldShowSpinner: true
    });


const $1e0e0f258ccb4a3b$var$navigation = {
    sidebarId: (0, $7vTKl.SIDEBAR_ID).HELP_CENTER_SETTINGS,
    menuId: (0, $7vTKl.MENU_ID).HELP_CENTER_SETTINGS,
    sidebar: (0, $754936767cbd051f$export$2e2bcd8739ae039)
};
const $1e0e0f258ccb4a3b$export$c4a6a8e840f7c6b1 = (0, $bMm60.createEntry)((0, $8a16c55182848ccf$export$f544881b6385f520), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: $1e0e0f258ccb4a3b$var$navigation,
    component: (0, $8ee2ddde41e1795b$export$2d8d895a0a0f636e),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ],
    resources: [
        ...(0, $ede9542b57e4c269$export$586756e5c0542a50)((0, $ede9542b57e4c269$export$5575497f0592ee94))
    ]
});
const $1e0e0f258ccb4a3b$export$caf568619a621961 = (0, $bMm60.createEntry)((0, $8a16c55182848ccf$export$8a784299dc7faaff), {
    perfMetricKey: 'help-center-settings.kb',
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: $1e0e0f258ccb4a3b$var$navigation,
    component: (0, $dnJL9.componentWithFG)('jcs_master_flag', (0, $9ae9ed18d17d7b80$export$c1d58cf9dc0a2ed3), (0, $dgH3j.default)),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $9ae9ed18d17d7b80$export$92983043c677b1b1)
    ],
    resources: [
        ...(0, $ede9542b57e4c269$export$586756e5c0542a50)((0, $ede9542b57e4c269$export$5575497f0592ee94)),
        // TODO: https://jplat.jira.atlassian.cloud/browse/BERRY-2884
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});
const $1e0e0f258ccb4a3b$export$4e4f38417d267cf6 = (0, $bMm60.createEntry)((0, $8a16c55182848ccf$export$88fcb9acf40a0827), {
    perfMetricKey: 'help-center-settings.customer-notifications',
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: $1e0e0f258ccb4a3b$var$navigation,
    component: (0, $dnJL9.componentWithFG)('jcs_master_flag', (0, $b094d7f31889a702$export$2f2f18f57014444a), (0, $dgH3j.default)),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $b094d7f31889a702$export$b2b6550dec008a98)
    ],
    resources: [
        ...(0, $ede9542b57e4c269$export$586756e5c0542a50)((0, $ede9542b57e4c269$export$5575497f0592ee94))
    ]
});
const $1e0e0f258ccb4a3b$export$f95717dac47e4db3 = (0, $bMm60.createEntry)((0, $8a16c55182848ccf$export$4515288a48c62087), {
    perfMetricKey: 'help-center-settings.email',
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: $1e0e0f258ccb4a3b$var$navigation,
    component: (0, $dnJL9.componentWithFG)('jcs_master_flag', (0, $3cfe67a93fd6dab7$export$962f20e752738967), (0, $dgH3j.default)),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $3cfe67a93fd6dab7$export$e090cd3a62343249)
    ],
    resources: [
        ...(0, $ede9542b57e4c269$export$586756e5c0542a50)((0, $ede9542b57e4c269$export$5575497f0592ee94))
    ]
});
const $1e0e0f258ccb4a3b$export$9803a0486e374df3 = (0, $bMm60.createEntry)((0, $8a16c55182848ccf$export$766193806f1c2ba8), {
    perfMetricKey: 'help-center-settings-request-types-configuration',
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: $1e0e0f258ccb4a3b$var$navigation,
    component: (0, $dnJL9.componentWithFG)('jcs_master_flag', (0, $3d64bb7f9ad5a1ad$export$4aca0a164c4d76df), (0, $dgH3j.default)),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $3d64bb7f9ad5a1ad$export$dcabea7d416bc1b4)
    ],
    resources: [
        ...(0, $ede9542b57e4c269$export$586756e5c0542a50)((0, $ede9542b57e4c269$export$5575497f0592ee94)),
        (0, $ixwgj.projectContextResource),
        (0, $6bQqb.servicedeskPracticesResource),
        (0, $47r3J.servicedeskIssueTypesResource),
        (0, $6RfAJ.servicedeskPortalGroupsResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});
const $1e0e0f258ccb4a3b$export$7da6f58628a74ff7 = (0, $bMm60.createEntry)((0, $8a16c55182848ccf$export$dd1d3b3f528e7077), {
    perfMetricKey: 'help-center-settings-request-types-fields',
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: $1e0e0f258ccb4a3b$var$navigation,
    component: (0, $dnJL9.componentWithFG)('jcs_master_flag', (0, $6e748ba2ed8cb30f$export$76418008a8957579), (0, $dgH3j.default)),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $6e748ba2ed8cb30f$export$d0ea3970831afb33)
    ],
    resources: [
        ...(0, $ede9542b57e4c269$export$586756e5c0542a50)((0, $ede9542b57e4c269$export$5575497f0592ee94))
    ]
});


const $159f64746bcc553c$export$633933bacdaefead = [
    (0, $1e0e0f258ccb4a3b$export$c4a6a8e840f7c6b1),
    (0, $1e0e0f258ccb4a3b$export$caf568619a621961),
    (0, $1e0e0f258ccb4a3b$export$4e4f38417d267cf6),
    (0, $1e0e0f258ccb4a3b$export$f95717dac47e4db3),
    (0, $1e0e0f258ccb4a3b$export$9803a0486e374df3),
    (0, $1e0e0f258ccb4a3b$export$7da6f58628a74ff7)
];



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $iZnNg = parcelRequire("iZnNg");


var $1ybV0 = parcelRequire("1ybV0");

var $dnJL9 = parcelRequire("dnJL9");

var $7vTKl = parcelRequire("7vTKl");


var $l90Gp = parcelRequire("l90Gp");

var $cbmC6 = parcelRequire("cbmC6");

var $iivTa = parcelRequire("iivTa");

var $kXWpU = parcelRequire("kXWpU");

var $eJCK9 = parcelRequire("eJCK9");

var $9urUx = parcelRequire("9urUx");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $l6RYU = parcelRequire("l6RYU");

var $gF5SK = parcelRequire("gF5SK");

var $ixwgj = parcelRequire("ixwgj");

var $2AuYt = parcelRequire("2AuYt");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $094dbb09a8724f35$export$322fe16ec991f12 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_DEFAULT_REDIRECT),
    path: '/jira/core/projects/:projectKey/settings'
};
const $094dbb09a8724f35$export$c3a32433c580b9ff = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES),
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};
const $094dbb09a8724f35$export$7c4ee74641923239 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_FIELDS),
    path: '/jira/core/projects/:projectKey/settings/fields',
    exact: true
};
const $094dbb09a8724f35$export$9e79ee307216071b = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES_WORKFLOW),
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};
const $094dbb09a8724f35$export$c7ac65fb0bbe767f = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS),
    path: '/jira/core/projects/:projectKey/settings/apps/:appId?',
    exact: true
};
const $094dbb09a8724f35$export$1c7e75ffaa491922 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS_FIELDS),
    path: '/jira/core/projects/:projectKey/settings/apps/app-fields',
    exact: true
};
const $094dbb09a8724f35$export$14535b40530c8690 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS),
    path: '/jira/core/projects/:projectKey/settings/details',
    exact: true
};
const $094dbb09a8724f35$export$fe93051d5b7385a1 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS),
    path: '/jira/core/projects/:projectKey/settings/access',
    exact: true
};
const $094dbb09a8724f35$export$59e3323ba0cc224a = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS_REDIRECT),
    path: '/jira/core/projects/:projectKey/settings/people',
    exact: true
};
const $094dbb09a8724f35$export$57fe8c5107a9c0de = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_PROJECT_FORMS),
    path: '/jira/core/projects/:projectKey/settings/forms',
    exact: true
};
const $094dbb09a8724f35$export$4e7ce7e6ced0f291 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_JIRA_FORM_BUILDER),
    path: '/jira/core/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};
const $094dbb09a8724f35$export$65a4d727336c49f4 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION),
    path: '/jira/core/projects/:projectKey/settings/automation'
};
const $094dbb09a8724f35$export$5437af2650f645e0 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION),
    path: '/jira/core/projects/:projectKey/settings/automate'
};
const $094dbb09a8724f35$export$7aae1006c82a79c0 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_DATA_CLASSIFICATIONS),
    path: '/jira/core/projects/:projectKey/settings/data-classifications',
    exact: true
};
const $094dbb09a8724f35$export$a1ee80066685b98d = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS),
    path: '/jira/core/projects/:projectKey/settings/notifications',
    exact: true
};
const $094dbb09a8724f35$export$56a8a0b88329b044 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS_ISSUE_LOGS),
    path: '/jira/core/projects/:projectKey/settings/notifications/issue-logs',
    exact: true
};
const $094dbb09a8724f35$export$b546589f1b048dc = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL),
    path: '/jira/core/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};
const $094dbb09a8724f35$export$b34160f55b6104e9 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS),
    path: '/jira/core/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};
const $094dbb09a8724f35$export$ba11c8f378a2c121 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPROVALS),
    path: '/jira/core/projects/:projectKey/settings/approvals',
    exact: true
};



var $aHr8P = parcelRequire("aHr8P");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $293f4e39ffc7b86c$export$1389a6ddf34f642e = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("9ratP")), {
        moduleId: "83e2f2c2"
    }),
    getPreloadProps: ()=>({})
});


/**
 * @generated SignedSource<<a829922c4d7e91622e88a1e75ca9c0ed>>
 * @relayHash ed735b233bfe7d6a34f4765ef97f56e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924
const $57faa9c1adc820e7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924",
        "metadata": {},
        "name": "uiIssueNotificationLogsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $57faa9c1adc820e7$export$2e2bcd8739ae039 = $57faa9c1adc820e7$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $4e9c2113e71dd730$export$97bbdefcbe0571ac = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("3G5SQ")), {
        moduleId: "b2136a4d"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $57faa9c1adc820e7$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectId: Number(context?.query?.projectId ?? 0),
                        notificationType: 'INTERNAL_NOTIFICATION_ISSUE'
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectIds: context?.query?.projectId,
                projectKey: context?.match.params.projectKey
            }
        })
});




var $59o4i = parcelRequire("59o4i");

var $lB25E = parcelRequire("lB25E");

var $eUqFw = parcelRequire("eUqFw");

var $bAQOb = parcelRequire("bAQOb");

var $2futN = parcelRequire("2futN");

var $lB25E = parcelRequire("lB25E");
const $7d101df27ecb8473$var$ProjectSettingsRedirectNew = ({ match: match })=>{
    const { data: data } = (0, $2futN.useJiraWorkmanagementProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/jira/core/projects/${String(projectKey)}/settings/details`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
    });
};
const $7d101df27ecb8473$var$ProjectSettingsRedirectOld = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
    });
const $7d101df27ecb8473$export$72130cf40a3c3778 = (0, $bAQOb.componentWithFF)('olympus-da-157-enable-project-settings-navigation_zxaq5', $7d101df27ecb8473$var$ProjectSettingsRedirectNew, $7d101df27ecb8473$var$ProjectSettingsRedirectOld);


const $e3dc9036898dfae5$var$approvalsProjectSettingsPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $293f4e39ffc7b86c$export$1389a6ddf34f642e),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $e3dc9036898dfae5$var$emailNotificationsLogEntryPointPage = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $4e9c2113e71dd730$export$97bbdefcbe0571ac),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $e3dc9036898dfae5$var$getNavigationSidebarProjectResource = ()=>[
        (0, $ixwgj.projectContextResource),
        (0, $l90Gp.forgeProjectModuleResource),
        (0, $eJCK9.staticSidebarShortcutsResource),
        (0, $kXWpU.staticProjectSidebarNavigationResource),
        (0, $cbmC6.staticProjectSidebarConnectAddonsNavigationResource)
    ];
const $e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource = ()=>[
        (0, $gF5SK.newIssueViewTransitionLockInStatusResource),
        (0, $l6RYU.navigationSidebarAutomationLegacyEnabledResource),
        (0, $ixwgj.projectContextResourceWithCache),
        (0, $l90Gp.forgeProjectSettingsModuleResource),
        (0, $iivTa.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

const $e3dc9036898dfae5$var$LazyIssueTypeSettings = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("e3u5r"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
const $e3dc9036898dfae5$export$b6450e98f3b2e500 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyIssueTypeSettings,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

const $e3dc9036898dfae5$var$LazyFieldsSettings = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("34M7x"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
const $e3dc9036898dfae5$export$642e36be5f0881cd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyFieldsSettings,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });

const $e3dc9036898dfae5$var$LazyWorkflowNavigationSettings = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("5p5BW"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
const $e3dc9036898dfae5$export$2fc344606596921e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyWorkflowNavigationSettings,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });

const $e3dc9036898dfae5$var$LazyConnectAppsSettings = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("c3BLd"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
const $e3dc9036898dfae5$export$a9e7f90b84deda9f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyConnectAppsSettings,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });

const $e3dc9036898dfae5$var$LazyConnectAppControlsSettings = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("jS5ct"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $e3dc9036898dfae5$export$ceddc4fc7b9c0729 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyConnectAppControlsSettings,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });

const $e3dc9036898dfae5$var$LazyDetailsSettings = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("c642p"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
const $e3dc9036898dfae5$export$3e8048d3cf2ba3fd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyDetailsSettings,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });

const $e3dc9036898dfae5$var$LazyPeopleSettings = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("epDvb"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $e3dc9036898dfae5$export$3026e5a52c747d2c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyPeopleSettings,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });

const $e3dc9036898dfae5$var$LazyProjectSettingsProformaProjectForms = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("5R9nY")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
const $e3dc9036898dfae5$export$4963607e49ab309f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyProjectSettingsProformaProjectForms,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });

const $e3dc9036898dfae5$var$LazyProjectSettingsProformaJiraFormBuilder = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("gcYA0")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
const $e3dc9036898dfae5$export$c32892afcc1da510 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyProjectSettingsProformaJiraFormBuilder,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });

const $e3dc9036898dfae5$var$LazyProjectSettingsJiraAutomation = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("bZFFJ")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
const $e3dc9036898dfae5$export$132a1e91790bf469 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyProjectSettingsJiraAutomation,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

const $e3dc9036898dfae5$var$LazyDataClassificationsSettings = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("74Iqa"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
const $e3dc9036898dfae5$export$a325b082c894541b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyDataClassificationsSettings,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });

const $e3dc9036898dfae5$var$LazyNotificationsSettings = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("6L9TO"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
});

const $e3dc9036898dfae5$var$LazyNotificationsIssueLogs = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("3G5SQ"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
});
const $e3dc9036898dfae5$export$36ba2f559d49a8f6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyNotificationsSettings,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });
const $e3dc9036898dfae5$export$361bca0a4a18e111 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyNotificationsIssueLogs,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });

const $e3dc9036898dfae5$var$LazyProjectSettingsNotificationEmail = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("65jMk"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
const $e3dc9036898dfae5$export$90c2f52b54888c20 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyProjectSettingsNotificationEmail,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });

const $e3dc9036898dfae5$var$LazyForgeProjectSettingsPage = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("1yOoT")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $e3dc9036898dfae5$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyForgeProjectSettingsPage,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
const $e3dc9036898dfae5$export$df1c02c3f28b7a95 = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$322fe16ec991f12), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: (0, $7d101df27ecb8473$export$72130cf40a3c3778),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});
const $e3dc9036898dfae5$export$95ecbacf0120fcfd = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$c3a32433c580b9ff), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$b6450e98f3b2e500,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyIssueTypeSettings
    ]
});
const $e3dc9036898dfae5$export$8d8dff75124dcebc = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$7c4ee74641923239), {
    ufoName: 'project-settings.fields.jwm-tmp',
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)(),
        (0, $2AuYt.fieldSettingsRelayResource)
    ],
    component: (0, $dnJL9.componentWithFG)('project_fields_page_for_tmp_-_mvp', $e3dc9036898dfae5$export$642e36be5f0881cd, (0, $dgH3j.default)),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyFieldsSettings
    ]
});
const $e3dc9036898dfae5$export$1dfd4811b9065dd6 = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$9e79ee307216071b), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$2fc344606596921e,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyWorkflowNavigationSettings
    ]
});
const $e3dc9036898dfae5$export$c038a2892f34f1a9 = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$c7ac65fb0bbe767f), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$a9e7f90b84deda9f,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyConnectAppsSettings
    ]
});
const $e3dc9036898dfae5$export$7870a0b1630a504e = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$1c7e75ffaa491922), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$ceddc4fc7b9c0729,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyConnectAppControlsSettings
    ]
});
const $e3dc9036898dfae5$export$438a330ccc1e7a91 = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$14535b40530c8690), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$3e8048d3cf2ba3fd,
    skeleton: (0, $aHr8P.ProjectSettingsDetailsSkeleton),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyDetailsSettings
    ]
});
const $e3dc9036898dfae5$export$8188648c76953df0 = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$fe93051d5b7385a1), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$3026e5a52c747d2c,
    skeleton: (0, $aHr8P.ProjectSettingsAccessSkeleton),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyPeopleSettings
    ],
    ufoName: 'project-settings.access'
});
const $e3dc9036898dfae5$export$36e1851c22975fc0 = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$59e3323ba0cc224a), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `/jira/core/projects/${String(match.params.projectKey)}/settings/access`,
            push: false
        }),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyPeopleSettings
    ]
});
const $e3dc9036898dfae5$export$5e9e27f116094fdf = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$57fe8c5107a9c0de), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$4963607e49ab309f,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyProjectSettingsProformaProjectForms
    ],
    perfMetricKey: 'forms-settings'
});
const $e3dc9036898dfae5$export$46d6b55ebf21ccc = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$4e7ce7e6ced0f291), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$c32892afcc1da510,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyProjectSettingsProformaJiraFormBuilder
    ],
    perfMetricKey: 'form-builder'
});
const $e3dc9036898dfae5$export$a244870e56f5c9a3 = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$65a4d727336c49f4), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$132a1e91790bf469,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyProjectSettingsJiraAutomation
    ],
    ufoName: 'project-settings-automation-core'
});
const $e3dc9036898dfae5$export$a2c8a6767edeeaed = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$5437af2650f645e0), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$132a1e91790bf469,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyProjectSettingsJiraAutomation
    ]
});
const $e3dc9036898dfae5$export$cf5194c476e8bcdb = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$7aae1006c82a79c0), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$a325b082c894541b,
    skeleton: (0, $aHr8P.ProjectSettingsDetailsSkeleton),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});
const $e3dc9036898dfae5$export$ed481b03aa858542 = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$a1ee80066685b98d), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$36ba2f559d49a8f6,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyNotificationsSettings
    ]
});
const $e3dc9036898dfae5$export$e562140c482cb0c = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$56a8a0b88329b044), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$361bca0a4a18e111,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyNotificationsIssueLogs
    ],
    entryPoint () {
        return (0, $1ybV0.ff)('jlovep-1857-enable-project-email-audit-pages-for-business-projects_tz5uu') ? $e3dc9036898dfae5$var$emailNotificationsLogEntryPointPage : undefined;
    }
});
const $e3dc9036898dfae5$export$da36a1671d868927 = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$b546589f1b048dc), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$90c2f52b54888c20,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyProjectSettingsNotificationEmail
    ]
});
const $e3dc9036898dfae5$export$1006fd9f5f02b1c2 = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$b34160f55b6104e9), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$b943f48844c671a5,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyForgeProjectSettingsPage
    ]
});
const $e3dc9036898dfae5$export$728033a86ab68014 = (0, $bMm60.createEntry)((0, $094dbb09a8724f35$export$ba11c8f378a2c121), {
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    entryPoint () {
        return $e3dc9036898dfae5$var$approvalsProjectSettingsPageEntryPoint;
    }
});
const $e3dc9036898dfae5$export$4bad3905623f839b = [
    $e3dc9036898dfae5$export$95ecbacf0120fcfd,
    $e3dc9036898dfae5$export$8d8dff75124dcebc,
    $e3dc9036898dfae5$export$1dfd4811b9065dd6,
    $e3dc9036898dfae5$export$7870a0b1630a504e,
    $e3dc9036898dfae5$export$c038a2892f34f1a9,
    $e3dc9036898dfae5$export$438a330ccc1e7a91,
    $e3dc9036898dfae5$export$8188648c76953df0,
    $e3dc9036898dfae5$export$36e1851c22975fc0,
    $e3dc9036898dfae5$export$5e9e27f116094fdf,
    $e3dc9036898dfae5$export$46d6b55ebf21ccc,
    $e3dc9036898dfae5$export$a2c8a6767edeeaed,
    $e3dc9036898dfae5$export$cf5194c476e8bcdb,
    $e3dc9036898dfae5$export$a244870e56f5c9a3,
    $e3dc9036898dfae5$export$ed481b03aa858542,
    $e3dc9036898dfae5$export$e562140c482cb0c,
    $e3dc9036898dfae5$export$da36a1671d868927,
    $e3dc9036898dfae5$export$1006fd9f5f02b1c2,
    $e3dc9036898dfae5$export$728033a86ab68014,
    $e3dc9036898dfae5$export$df1c02c3f28b7a95
];



var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $dnJL9 = parcelRequire("dnJL9");

var $7vTKl = parcelRequire("7vTKl");


var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $ejPAV = parcelRequire("ejPAV");

var $aspp6 = parcelRequire("aspp6");

var $ixwgj = parcelRequire("ixwgj");

var $2AuYt = parcelRequire("2AuYt");

var $ct0sQ = parcelRequire("ct0sQ");

var $k82mP = parcelRequire("k82mP");

var $3BZ46 = parcelRequire("3BZ46");

var $k1AKH = parcelRequire("k1AKH");

var $jwzNs = parcelRequire("jwzNs");

var $dgH3j = parcelRequire("dgH3j");

var $jh2R9 = parcelRequire("jh2R9");

var $exb0h = parcelRequire("exb0h");


var $eI5EY = parcelRequire("eI5EY");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $dgH3j = parcelRequire("dgH3j");

var $baiUo = parcelRequire("baiUo");

var $csLgO = parcelRequire("csLgO");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $e3c2c812ec3dfc79$var$playbookEditViewEntryPoint = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("9am5k")), {
        moduleId: "15e5be42"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectId: context?.query?.projectId || null,
                projectKey: context?.match.params.projectKey
            }
        };
    }
});
var $e3c2c812ec3dfc79$export$2e2bcd8739ae039 = $e3c2c812ec3dfc79$var$playbookEditViewEntryPoint;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $3365897c87df0f4d$var$playbookListViewEntryPoint = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("gAnp3")), {
        moduleId: "a498670b"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectIds: context?.query?.projectId,
                projectKey: context?.match.params.projectKey
            }
        };
    }
});
var $3365897c87df0f4d$export$2e2bcd8739ae039 = $3365897c87df0f4d$var$playbookListViewEntryPoint;


const $6a6e895e66357348$var$listEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $3365897c87df0f4d$export$2e2bcd8739ae039),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $6a6e895e66357348$var$editEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $e3c2c812ec3dfc79$export$2e2bcd8739ae039),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $6a6e895e66357348$var$getServiceDeskRoutesCommon = ()=>({
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        }
    });
const $6a6e895e66357348$export$89ee08578c593726 = [
    (0, $bMm60.createEntry)((0, $baiUo.servicedeskPlaybooksListRoute), {
        ...$6a6e895e66357348$var$getServiceDeskRoutesCommon(),
        entryPoint () {
            return (0, $eI5EY.fg)('playbooks-in-jsm') ? $6a6e895e66357348$var$listEntryPoint : undefined;
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskSettingsResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-list-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_PLAYBOOKS_LIST)),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $dgH3j.default),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        ufoName: 'playbook-list'
    }),
    (0, $bMm60.createEntry)((0, $baiUo.servicedeskPlaybooksEditRoute), {
        ...$6a6e895e66357348$var$getServiceDeskRoutesCommon(),
        entryPoint () {
            return (0, $eI5EY.fg)('playbooks-in-jsm') ? $6a6e895e66357348$var$editEntryPoint : undefined;
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskSettingsResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-edit-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES_PLAYBOOKS_EDIT)),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $dgH3j.default),
        navigation: {
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        ufoName: 'playbook-edit'
    })
];



var $EFSBh = parcelRequire("EFSBh");

var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $exb0h = parcelRequire("exb0h");
const $5f6fb6d0ff76930d$export$5575497f0592ee94 = 'servicedesk';
const $5f6fb6d0ff76930d$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $5f6fb6d0ff76930d$export$c581a12a4f58fa26 = {
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-edit-rule`,
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    path: `${$5f6fb6d0ff76930d$var$projectSettingsUrl($5f6fb6d0ff76930d$export$5575497f0592ee94)}/automation/ruleset/:ruleId`
};
const $5f6fb6d0ff76930d$export$5b3aca7bf312c9a3 = {
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-copy-rule`,
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    path: `${$5f6fb6d0ff76930d$var$projectSettingsUrl($5f6fb6d0ff76930d$export$5575497f0592ee94)}/automation/copy/:ruleId`
};
const $5f6fb6d0ff76930d$export$3b8691f4e10340a9 = {
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-create`,
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    path: `${$5f6fb6d0ff76930d$var$projectSettingsUrl($5f6fb6d0ff76930d$export$5575497f0592ee94)}/automation/blueprint/:blueprintKey`
};
const $5f6fb6d0ff76930d$export$e0ddfe5d87fb5601 = {
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-view-log`,
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    path: `${$5f6fb6d0ff76930d$var$projectSettingsUrl($5f6fb6d0ff76930d$export$5575497f0592ee94)}/automation/log/:ruleId`
};
const $5f6fb6d0ff76930d$export$3e9315c24fe609c3 = {
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-summary`,
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    path: `${$5f6fb6d0ff76930d$var$projectSettingsUrl($5f6fb6d0ff76930d$export$5575497f0592ee94)}/automation`
};



var $csLgO = parcelRequire("csLgO");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $4767bfb777d542fe$export$b7262fe486f4b412 = 'core';
const $4767bfb777d542fe$export$2954328f6207617a = 'software';
const $4767bfb777d542fe$export$5575497f0592ee94 = 'servicedesk';
const $4767bfb777d542fe$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $4767bfb777d542fe$export$586756e5c0542a50 = (product)=>{
    if (product === $4767bfb777d542fe$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $4767bfb777d542fe$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $ac421ac495e59f2a$export$4a3b5f6370555dbc = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("4eVqf")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-copy-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ac421ac495e59f2a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ac421ac495e59f2a$export$4a3b5f6370555dbc,
        pageId: "project-settings-automation-copy-rule",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $d848b22474133d3f$export$5b197b51eb5ad982 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("f0awX")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-create-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d848b22474133d3f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d848b22474133d3f$export$5b197b51eb5ad982,
        pageId: "project-settings-automation-create-rule",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $3f204af7fc304fe8$export$c1c9a68738a9ab36 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("iXLtr")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-edit-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3f204af7fc304fe8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3f204af7fc304fe8$export$c1c9a68738a9ab36,
        pageId: "project-settings-automation-edit-rule",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $cqJw8 = parcelRequire("cqJw8");

var $6vrw7 = parcelRequire("6vrw7");

var $lB25E = parcelRequire("lB25E");
const $e693f5ced85029ff$export$39684840f773be1e = (pageType)=>{
    switch(pageType){
        case 'edit':
            return 'ruleset/:ruleId';
        case 'copy':
            return 'copy/:ruleId';
        case 'create':
            return 'blueprint/:blueprintKey';
        case 'viewlog':
            return 'log/:ruleId';
        default:
            return '';
    }
};
const $e693f5ced85029ff$var$newAutomationUrl = (baseUrl, { match: match }, pageType)=>{
    const { projectKey: projectKey } = match.params;
    if (pageType === 'edit') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), String(projectKey))}/automation/ruleset/${ruleId || ''}`;
    }
    if (pageType === 'copy') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), String(projectKey))}/automation/copy/${ruleId || ''}`;
    }
    if (pageType === 'viewlog') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), String(projectKey))}/automation/log/${ruleId || ''}`;
    }
    if (pageType === 'create') {
        const { blueprintKey: blueprintKey } = match.params;
        return `${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), String(projectKey))}/automation/blueprint/${blueprintKey || ''}`;
    }
    return `${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), String(projectKey))}/automation`;
};
const $e693f5ced85029ff$export$d6674bfa636b8090 = (pageType)=>(routeContext)=>{
        // use empty string instead of actual baseUrl as router redirect handles it internally
        const emptyBaseUrl = (0, $6vrw7.toBaseUrl)('');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: $e693f5ced85029ff$var$newAutomationUrl(emptyBaseUrl, routeContext, pageType),
            push: false
        });
    };



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $4e1bf6178cdce58e$export$2fc8c3fcbb365b89 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("5OFaK")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-summary/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4e1bf6178cdce58e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4e1bf6178cdce58e$export$2fc8c3fcbb365b89,
        pageId: "project-settings-automation-summary",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $66b5660e6d185dcf$export$db6c5cdbc65b2b4a = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("khQDR")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-view-log/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$66b5660e6d185dcf$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $66b5660e6d185dcf$export$db6c5cdbc65b2b4a,
        pageId: "project-settings-automation-view-log",
        shouldShowSpinner: true
    });


const $38d72ec77f663f1e$var$getLegacyAutomationRoutesCommon = ()=>({
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $4767bfb777d542fe$export$586756e5c0542a50)((0, $4767bfb777d542fe$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)
    });
const $38d72ec77f663f1e$var$getOldAutomationRouteRedirectRoute = (pageType)=>({
        ...$38d72ec77f663f1e$var$getLegacyAutomationRoutesCommon(),
        name: `${0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK}-automation-redirect-${pageType}`,
        path: `/projects/:projectKey/settings/automation/${(0, $e693f5ced85029ff$export$39684840f773be1e)(pageType)}`,
        forPaint: [],
        component: (0, $e693f5ced85029ff$export$d6674bfa636b8090)(pageType)
    });
const $38d72ec77f663f1e$export$8521f0867b2d52e4 = [
    (0, $bMm60.createEntry)((0, $5f6fb6d0ff76930d$export$c581a12a4f58fa26), {
        ...$38d72ec77f663f1e$var$getLegacyAutomationRoutesCommon(),
        ufoName: 'service-management.automation.edit-rule',
        component: (0, $3f204af7fc304fe8$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $3f204af7fc304fe8$export$c1c9a68738a9ab36)
        ]
    }),
    (0, $bMm60.createEntry)((0, $5f6fb6d0ff76930d$export$5b3aca7bf312c9a3), {
        ...$38d72ec77f663f1e$var$getLegacyAutomationRoutesCommon(),
        ufoName: 'service-management.automation.copy-rule',
        component: (0, $ac421ac495e59f2a$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ac421ac495e59f2a$export$4a3b5f6370555dbc)
        ]
    }),
    (0, $bMm60.createEntry)((0, $5f6fb6d0ff76930d$export$3b8691f4e10340a9), {
        ...$38d72ec77f663f1e$var$getLegacyAutomationRoutesCommon(),
        ufoName: 'service-management.automation.create-rule',
        component: (0, $d848b22474133d3f$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d848b22474133d3f$export$5b197b51eb5ad982)
        ]
    }),
    (0, $bMm60.createEntry)((0, $5f6fb6d0ff76930d$export$e0ddfe5d87fb5601), {
        ...$38d72ec77f663f1e$var$getLegacyAutomationRoutesCommon(),
        ufoName: 'service-management.automation.log',
        component: (0, $66b5660e6d185dcf$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $66b5660e6d185dcf$export$db6c5cdbc65b2b4a)
        ]
    }),
    (0, $bMm60.createEntry)((0, $5f6fb6d0ff76930d$export$3e9315c24fe609c3), {
        ...$38d72ec77f663f1e$var$getLegacyAutomationRoutesCommon(),
        ufoName: 'service-management.automation.summary',
        component: (0, $4e1bf6178cdce58e$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4e1bf6178cdce58e$export$2fc8c3fcbb365b89)
        ]
    }),
    /* Old urls.
	 * Do not remove these redirects, ever.
	 * Because customers will have bookmarks and saved links and we need them to keep working forever.
	 */ $38d72ec77f663f1e$var$getOldAutomationRouteRedirectRoute('summary'),
    $38d72ec77f663f1e$var$getOldAutomationRouteRedirectRoute('create'),
    $38d72ec77f663f1e$var$getOldAutomationRouteRedirectRoute('edit'),
    $38d72ec77f663f1e$var$getOldAutomationRouteRedirectRoute('copy'),
    $38d72ec77f663f1e$var$getOldAutomationRouteRedirectRoute('viewlog')
];



var $cernH = parcelRequire("cernH");

var $dnJL9 = parcelRequire("dnJL9");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $fkRbQ = parcelRequire("fkRbQ");

var $csLgO = parcelRequire("csLgO");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $6439df9abef17671$export$b7262fe486f4b412 = 'core';
const $6439df9abef17671$export$2954328f6207617a = 'software';
const $6439df9abef17671$export$5575497f0592ee94 = 'servicedesk';
const $6439df9abef17671$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $6439df9abef17671$export$586756e5c0542a50 = (product)=>{
    if (product === $6439df9abef17671$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $6439df9abef17671$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $atRHQ = parcelRequire("atRHQ");

var $lB25E = parcelRequire("lB25E");

var $jXX3j = parcelRequire("jXX3j");

var $7d0GR = parcelRequire("7d0GR");

var $khSOi = parcelRequire("khSOi");
const $56ac3f4dbf97569a$export$c224e724e933fbea = (page, pathname)=>{
    if (page === 'customer-notifications') {
        const customerNotificationsPage = pathname.split('/settings/customer-notifications')[1];
        if (customerNotificationsPage === '/template') return 'customer-notifications-template';
        if (customerNotificationsPage === '/account-notification/invite-customer') return 'customer-notifications-invite-customer';
        if (/rule\/\d+/.test(customerNotificationsPage)) return 'customer-notifications-rule';
    }
    return page;
};
const $56ac3f4dbf97569a$export$2d1034e371a567c6 = (page, pathname)=>{
    switch(page){
        case 'kb':
            return (0, $jXX3j.getSettingsPath)(pathname.replace('/confluence-kb', '/kb'), true);
        default:
            return (0, $jXX3j.getSettingsPath)(pathname, true);
    }
};
const $56ac3f4dbf97569a$export$a24ec33acfeae48d = ({ page: page, children: children })=>{
    const [{ location: location }] = (0, $lB25E.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isJCS = (0, $khSOi.useIsJCS)();
    (0, $eUqFw.useEffect)(()=>{
        if (isJCS && !(0, $7d0GR.isHelpCenterSettingsPath)()) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
            page: $56ac3f4dbf97569a$export$c224e724e933fbea(page, location.pathname)
        });
    }, [
        createAnalyticsEvent,
        isJCS,
        location.pathname,
        page
    ]);
    if (isJCS && !(0, $7d0GR.isHelpCenterSettingsPath)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: $56ac3f4dbf97569a$export$2d1034e371a567c6(page, location.pathname),
        persistSearchParams: true
    });
    return children;
};



var $59o4i = parcelRequire("59o4i");

const $da92782cf07ad14e$export$c763ea321ade5f68 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("aWbMq")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$da92782cf07ad14e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56ac3f4dbf97569a$export$a24ec33acfeae48d), {
        page: "customer-notifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $da92782cf07ad14e$export$c763ea321ade5f68,
        pageId: "project-settings-customer-notifications",
        shouldShowSpinner: true
    }));



var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $99d7fd650d7e1870$export$8249a46a710af6da = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-notifications`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: url
    });
};


const $0b9b4e281f9618b2$export$d6bb339f4d05f5c5 = [
    (0, $bMm60.createEntry)((0, $fkRbQ.routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute), {
        component: (0, $da92782cf07ad14e$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $6439df9abef17671$export$586756e5c0542a50)((0, $6439df9abef17671$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $da92782cf07ad14e$export$c763ea321ade5f68)
        ]
    }),
    (0, $bMm60.createEntry)((0, $fkRbQ.routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute), {
        component: (0, $dnJL9.componentWithFG)('update_jsm_project_settings_pages_urls', (0, $99d7fd650d7e1870$export$8249a46a710af6da), (0, $da92782cf07ad14e$export$2e2bcd8739ae039)),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $6439df9abef17671$export$586756e5c0542a50)((0, $6439df9abef17671$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $da92782cf07ad14e$export$c763ea321ade5f68)
        ]
    })
];



var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $kbHFR = parcelRequire("kbHFR");

var $9XEQV = parcelRequire("9XEQV");

var $csLgO = parcelRequire("csLgO");


var $7vTKl = parcelRequire("7vTKl");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $cf03e269626b98d8$export$26f82de7820f0c3 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("g2KfS")), {
        moduleId: "6002b9c5"
    }),
    getPreloadProps: ()=>({})
});


const $cd416a4c790257f9$export$35537410b0bf07ea = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $cf03e269626b98d8$export$26f82de7820f0c3),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});




var $7vTKl = parcelRequire("7vTKl");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $bebac43a02515d44$export$4ded7f93dbe6eb63 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("7Y2NF")), {
        moduleId: "f4a962a9"
    }),
    getPreloadProps: ()=>({})
});


const $037bfd681118dfce$export$3b90f0eb27bdd52f = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $bebac43a02515d44$export$4ded7f93dbe6eb63),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});


const $3d75df320bcbde8d$export$5dfc85c70e03c102 = [
    (0, $bMm60.createEntry)((0, $9XEQV.routeGroupsProjectSettingsServicedeskJourneysRoute), {
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskSettingsResources)()
        ],
        entryPoint: ()=>(0, $037bfd681118dfce$export$3b90f0eb27bdd52f)
    }),
    (0, $bMm60.createEntry)((0, $9XEQV.routeGroupsProjectSettingsServicedeskJourneyConfigurationRoute), {
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskSettingsResources)()
        ],
        entryPoint: ()=>(0, $cd416a4c790257f9$export$35537410b0bf07ea)
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $eKJh0 = parcelRequire("eKJh0");

var $csLgO = parcelRequire("csLgO");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $6416cdf21853e6c6$export$b7262fe486f4b412 = 'core';
const $6416cdf21853e6c6$export$2954328f6207617a = 'software';
const $6416cdf21853e6c6$export$5575497f0592ee94 = 'servicedesk';
const $6416cdf21853e6c6$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $6416cdf21853e6c6$export$586756e5c0542a50 = (product)=>{
    if (product === $6416cdf21853e6c6$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $6416cdf21853e6c6$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");



var $59o4i = parcelRequire("59o4i");
const $5a209557cae2ae10$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $5a209557cae2ae10$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $5a209557cae2ae10$export$583a442626bd3345 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("7v9X2")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-knowledge-base/src/index.tsx"
});

const $5a209557cae2ae10$export$7c7186fdd8c56428 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("6ATHt"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-settings/src/index.tsx"
});
const $5a209557cae2ae10$export$6d92735e249274bb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56ac3f4dbf97569a$export$a24ec33acfeae48d), {
        page: "kb"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5a209557cae2ae10$export$7c7186fdd8c56428,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5a209557cae2ae10$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5a209557cae2ae10$export$583a442626bd3345,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    });


const $86d860750863d795$export$f90c0f16cffd8883 = [
    (0, $bMm60.createEntry)((0, $eKJh0.routeGroupsProjectSettingsServicedeskKbRoute), {
        perfMetricKey: 'service-management.kb-settings',
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        component: (0, $5a209557cae2ae10$export$6d92735e249274bb),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5a209557cae2ae10$export$7c7186fdd8c56428)
        ],
        resources: [
            ...(0, $6416cdf21853e6c6$export$586756e5c0542a50)((0, $6416cdf21853e6c6$export$5575497f0592ee94)),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $ixwgj = parcelRequire("ixwgj");

var $g2JMk = parcelRequire("g2JMk");

var $39wMP = parcelRequire("39wMP");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $fdb4f440b81f61c9$export$b7262fe486f4b412 = 'core';
const $fdb4f440b81f61c9$export$2954328f6207617a = 'software';
const $fdb4f440b81f61c9$export$5575497f0592ee94 = 'servicedesk';
const $fdb4f440b81f61c9$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $fdb4f440b81f61c9$export$586756e5c0542a50 = (product)=>{
    if (product === $fdb4f440b81f61c9$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $fdb4f440b81f61c9$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

var $jK1pm = parcelRequire("jK1pm");

const $75e8a1d09660963e$export$a6694c07cb5be8c1 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("Tz24F"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-sla-settings/src/index.tsx"
});
const $75e8a1d09660963e$export$c56fde3803c5a1a3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "project-settings-service-desk-sla-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $75e8a1d09660963e$export$a6694c07cb5be8c1,
        pageId: "project-settings-service-desk-sla-settings",
        shouldShowSpinner: true
    }));


const $792114e6a9cd6c10$export$fd1a58e6255623a = [
    (0, $bMm60.createEntry)((0, $39wMP.servicedeskSlaSettingsRoute), {
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).SLA_SETTINGS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).SLA_SETTINGS),
                teamName: 'bumblebee'
            }
        },
        perfMetricKey: 'jsm-sla-settings',
        component: (0, $75e8a1d09660963e$export$c56fde3803c5a1a3),
        resources: [
            ...(0, $fdb4f440b81f61c9$export$586756e5c0542a50)((0, $fdb4f440b81f61c9$export$5575497f0592ee94)),
            (0, $ixwgj.projectContextResource),
            (0, $g2JMk.slaMetricsDataResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $75e8a1d09660963e$export$a6694c07cb5be8c1)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $6bQqb = parcelRequire("6bQqb");

var $exb0h = parcelRequire("exb0h");
const $ca4e49b79a8433d9$export$5575497f0592ee94 = 'servicedesk';
const $ca4e49b79a8433d9$export$eeb615fb989a6e4d = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-unassigned-ticket-type-fields`,
    path: `/jira/${$ca4e49b79a8433d9$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/unassigned/request-type/:requestTypeId/:tabKey?`
};
const $ca4e49b79a8433d9$export$50e6baca5c1f7a5b = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-ticket-type-fields`,
    path: `/jira/${$ca4e49b79a8433d9$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/category/:practice/request-type/:requestTypeId/:tabKey?`
};
const $ca4e49b79a8433d9$export$51c2cd63e9954ab7 = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-ticket-type-fields`,
    path: `/jira/${$ca4e49b79a8433d9$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/request-type/:requestTypeId/:tabKey?`
};



var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $37132842683d0af2$export$b7262fe486f4b412 = 'core';
const $37132842683d0af2$export$2954328f6207617a = 'software';
const $37132842683d0af2$export$5575497f0592ee94 = 'servicedesk';
const $37132842683d0af2$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $37132842683d0af2$export$586756e5c0542a50 = (product)=>{
    if (product === $37132842683d0af2$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $37132842683d0af2$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $d19d2d8dc261c55c$export$471040ce01e559fc = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("8wgDH")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-type-fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d19d2d8dc261c55c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56ac3f4dbf97569a$export$a24ec33acfeae48d), {
        page: "ticket-type-fields"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d19d2d8dc261c55c$export$471040ce01e559fc,
        pageId: "project-settings-ticket-type-fields",
        shouldShowSpinner: true
    }));


const $c85fda19a90ea423$var$getTicketTypeFieldsRoutesCommon = ()=>({
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        component: (0, $d19d2d8dc261c55c$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $37132842683d0af2$export$586756e5c0542a50)((0, $37132842683d0af2$export$5575497f0592ee94)),
            (0, $6bQqb.servicedeskPracticesResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d19d2d8dc261c55c$export$471040ce01e559fc)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: `${0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK}-ticket-type-fields`
    });
const $c85fda19a90ea423$export$caa50198aadcf21c = [
    (0, $bMm60.createEntry)((0, $ca4e49b79a8433d9$export$eeb615fb989a6e4d), {
        ...$c85fda19a90ea423$var$getTicketTypeFieldsRoutesCommon(),
        component: (0, $d19d2d8dc261c55c$export$2e2bcd8739ae039)
    }),
    (0, $bMm60.createEntry)((0, $ca4e49b79a8433d9$export$50e6baca5c1f7a5b), {
        ...$c85fda19a90ea423$var$getTicketTypeFieldsRoutesCommon()
    }),
    (0, $bMm60.createEntry)((0, $ca4e49b79a8433d9$export$51c2cd63e9954ab7), {
        ...$c85fda19a90ea423$var$getTicketTypeFieldsRoutesCommon()
    })
];



var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $aspp6 = parcelRequire("aspp6");

var $ixwgj = parcelRequire("ixwgj");

var $47r3J = parcelRequire("47r3J");

var $6RfAJ = parcelRequire("6RfAJ");

var $6bQqb = parcelRequire("6bQqb");

var $jwzNs = parcelRequire("jwzNs");

var $4AXWs = parcelRequire("4AXWs");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $d32066f9293994b1$export$b7262fe486f4b412 = 'core';
const $d32066f9293994b1$export$2954328f6207617a = 'software';
const $d32066f9293994b1$export$5575497f0592ee94 = 'servicedesk';
const $d32066f9293994b1$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $d32066f9293994b1$export$586756e5c0542a50 = (product)=>{
    if (product === $d32066f9293994b1$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $d32066f9293994b1$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $646db37ffd41d2e1$export$c26e63f8b7d3b52c = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("kxUYW")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-types-config/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$646db37ffd41d2e1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56ac3f4dbf97569a$export$a24ec33acfeae48d), {
        page: "ticket-types-config"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $646db37ffd41d2e1$export$c26e63f8b7d3b52c,
        pageId: "project-settings-ticket-types-config",
        shouldShowSpinner: true
    }));


const $39723202b32651a7$var$commonTicketTypesConfigRouteEntry = {
    component: (0, $646db37ffd41d2e1$export$2e2bcd8739ae039),
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $d32066f9293994b1$export$586756e5c0542a50)((0, $d32066f9293994b1$export$5575497f0592ee94)),
        (0, $ixwgj.projectContextResource),
        (0, $6bQqb.servicedeskPracticesResource),
        (0, $47r3J.servicedeskIssueTypesResource),
        (0, $6RfAJ.servicedeskPortalGroupsResource),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9'), (0, $aspp6.jsmRepackagingBannerResource))
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $646db37ffd41d2e1$export$c26e63f8b7d3b52c)
    ],
    meta: {
        reporting: {
            id: (0, $frZnw.APP_NAMES).REQUEST_TYPES_CONFIG,
            packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).REQUEST_TYPES_CONFIG),
            teamName: 'jsd-shield'
        }
    },
    perfMetricKey: 'jsm-request-types-configuration',
    ufoName: 'jsm-request-types-configuration'
};
const $39723202b32651a7$export$fa9d0db1668a0662 = [
    (0, $bMm60.createEntry)((0, $4AXWs.routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute), {
        ...$39723202b32651a7$var$commonTicketTypesConfigRouteEntry,
        component: (0, $646db37ffd41d2e1$export$2e2bcd8739ae039)
    }),
    (0, $bMm60.createEntry)((0, $4AXWs.routeGroupsProjectSettingsServicedeskItsmTicketTypesConfigRoute), {
        ...$39723202b32651a7$var$commonTicketTypesConfigRouteEntry
    }),
    (0, $bMm60.createEntry)((0, $4AXWs.routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute), {
        ...$39723202b32651a7$var$commonTicketTypesConfigRouteEntry
    })
];



var $dfBCt = parcelRequire("dfBCt");


var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $exb0h = parcelRequire("exb0h");
const $ad4e15e96c4bd9a2$export$5575497f0592ee94 = 'servicedesk';
const $ad4e15e96c4bd9a2$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $ad4e15e96c4bd9a2$export$8c051c399fd812a5 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    // We name this virtualagentonboarding without the "-" as otherwise it would trigger
    // the nesting stack, which we don't want for onboarding
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagentonboarding`,
    exact: true,
    path: `${$ad4e15e96c4bd9a2$var$projectSettingsUrl($ad4e15e96c4bd9a2$export$5575497f0592ee94)}/virtual-agent`
};
const $ad4e15e96c4bd9a2$export$3e227412713bc57f = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-browse-intents`,
    exact: true,
    path: `${$ad4e15e96c4bd9a2$var$projectSettingsUrl($ad4e15e96c4bd9a2$export$5575497f0592ee94)}/virtual-agent/intents`
};
const $ad4e15e96c4bd9a2$export$bf8131fb060d0e73 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-view-intent`,
    exact: true,
    path: `${$ad4e15e96c4bd9a2$var$projectSettingsUrl($ad4e15e96c4bd9a2$export$5575497f0592ee94)}/virtual-agent/intents/:intentId/:tab(flow|training|settings)?`
};
const $ad4e15e96c4bd9a2$export$fd091ba8fa858397 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-standard-flows`,
    exact: true,
    path: `${$ad4e15e96c4bd9a2$var$projectSettingsUrl($ad4e15e96c4bd9a2$export$5575497f0592ee94)}/virtual-agent/standard-flows`
};
const $ad4e15e96c4bd9a2$export$c74dca8be49046ea = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-view-standard-flow`,
    exact: true,
    path: `${$ad4e15e96c4bd9a2$var$projectSettingsUrl($ad4e15e96c4bd9a2$export$5575497f0592ee94)}/virtual-agent/standard-flows/:flowId/:tab(flow|settings)?`
};
const $ad4e15e96c4bd9a2$export$c8ff4cf64e5540ec = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-browseconversations`,
    exact: true,
    path: `${$ad4e15e96c4bd9a2$var$projectSettingsUrl($ad4e15e96c4bd9a2$export$5575497f0592ee94)}/virtual-agent/conversations`
};
const $ad4e15e96c4bd9a2$export$847a7c378c11c645 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-settings`,
    exact: true,
    path: `${$ad4e15e96c4bd9a2$var$projectSettingsUrl($ad4e15e96c4bd9a2$export$5575497f0592ee94)}/virtual-agent/settings/:tab(basic|channels)?`
};



var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $7ZZxN = parcelRequire("7ZZxN");

var $isbb2 = parcelRequire("isbb2");

var $csLgO = parcelRequire("csLgO");
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $bUi2Q = parcelRequire("bUi2Q");

var $bNe1g = parcelRequire("bNe1g");
/**
 * @generated SignedSource<<01efc85df272e4d842e2a6d432874891>>
 * @relayHash 921934876c8f8ab5148af2a24828562f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 125329b9d4e888d6fdabbfee72c3e68f14cb83b841b09ddce260b26dc8ea5dce
const $f4972c8bde96023f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "125329b9d4e888d6fdabbfee72c3e68f14cb83b841b09ddce260b26dc8ea5dce",
        "metadata": {},
        "name": "uiVirtualAgentIntentTemplatesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $f4972c8bde96023f$export$2e2bcd8739ae039 = $f4972c8bde96023f$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $d7ac566cc37b6154$export$2b1d9dc27ee42f8f = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("1lYZg")), {
        moduleId: "a4e9afeb"
    }),
    getPreloadProps: ({ cloudId: cloudId, key: key })=>({
            queries: {
                intentTemplateQueryReference: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: (0, $f4972c8bde96023f$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: cloudId,
                        key: key
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});



var $jIMNW = parcelRequire("jIMNW");
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $9ae314ba6b2c89d2$exports = {};
$9ae314ba6b2c89d2$exports = new URL("virtual-agent-intent-template-sidebar-app-skeleton.tpl.e2ff8557.svg", import.meta.url).toString();


const $ea48e3a18124b16d$var$customCssStyles = null;
const $ea48e3a18124b16d$export$fa68b26760d5b66f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9ae314ba6b2c89d2$exports))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });



var $dWLk9 = parcelRequire("dWLk9");
const $2611ba4a4b9c48ee$var$runtimeProps = {};
const $2611ba4a4b9c48ee$export$36ad24b9ac79bdc8 = ()=>{
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    const panelId = rightSidebarCurrentState?.panelId ?? '';
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            cloudId: cloudId,
            key: projectContextData?.projectKey ?? ''
        }), [
        cloudId,
        projectContextData
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $d7ac566cc37b6154$export$2b1d9dc27ee42f8f), entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (panelId === 'intentTemplate') entryPointActions.load();
        else entryPointActions.unload();
    }, [
        entryPointActions,
        panelId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "createIntentTemplatesSidebar",
        packageName: "jiraServicedeskSettingsVirtualAgentCreateIntentTemplates",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ea48e3a18124b16d$export$fa68b26760d5b66f), null),
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2611ba4a4b9c48ee$var$SideBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jIMNW.ErrorDisplay), {
                refetch: ()=>window.location.reload()
            })),
        runtimeProps: $2611ba4a4b9c48ee$var$runtimeProps
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $2611ba4a4b9c48ee$var$SideBarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1kl7wsm2 _11q71bhr _vchhusvi _1p57u2gc _4t3i1osq _18m91wug",
            __cmplp.className
        ])
    });
});
var $2611ba4a4b9c48ee$export$2e2bcd8739ae039 = $2611ba4a4b9c48ee$export$36ad24b9ac79bdc8;


// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3da6a5b21870784d$var$withServiceProjectContext = (Component)=>(0, $isbb2.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $7ZZxN.SERVICE_DESK_PROJECT)
        }
    });
const $3da6a5b21870784d$export$6659f41b213bad05 = (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), {
    rightSidebars: [
        $3da6a5b21870784d$var$withServiceProjectContext((0, $2611ba4a4b9c48ee$export$2e2bcd8739ae039))
    ]
});


/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $f60e5832fbb56d43$exports = {};
$f60e5832fbb56d43$exports = new URL("virtual-agent-browse-conversations-app-skeleton.tpl.9f030add.svg", import.meta.url).toString();


const $ee9589c148891c91$var$customStyles = null;
const $ee9589c148891c91$export$4a6267fad85ca589 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f60e5832fbb56d43$exports))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });



var $aDZUE = parcelRequire("aDZUE");
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $4d38f4a610b25a19$exports = {};
$4d38f4a610b25a19$exports = new URL("virtual-agent-browse-standard-flows-app-skeleton.tpl.51e6e95a.svg", import.meta.url).toString();


const $5d33c8e57d2ae9fa$var$customCssStyles = null;
const $5d33c8e57d2ae9fa$export$c2bd83dd149452bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4d38f4a610b25a19$exports))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });


/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $cc81225b3b04dd2d$exports = {};
$cc81225b3b04dd2d$exports = new URL("virtual-agent-landing-app-skeleton.tpl.e8a7897b.svg", import.meta.url).toString();


const $7da2e5cae9546ea1$var$customStyles = null;
const $7da2e5cae9546ea1$export$f4b71d7b732df8a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cc81225b3b04dd2d$exports))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });


/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $0103cc070cb481c6$exports = {};
$0103cc070cb481c6$exports = new URL("virtual-agent-settings-app-skeleton.tpl.1a9c03fe.svg", import.meta.url).toString();


const $a5f272c37f7018ee$var$customCssStyles = null;
const $a5f272c37f7018ee$export$429c43ddcb09c14c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0103cc070cb481c6$exports))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });


/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $b5f9a3f1ff83c928$exports = {};
$b5f9a3f1ff83c928$exports = new URL("virtual-agent-view-intent-app-skeleton.tpl.5dd31cbb.svg", import.meta.url).toString();


const $ff6dbd89968fe1c3$var$customCssStyles = null;
const $ff6dbd89968fe1c3$export$72b20c10a0f18a2f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b5f9a3f1ff83c928$exports))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });


/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $9618c51d58c4d685$exports = {};
$9618c51d58c4d685$exports = new URL("virtual-agent-view-standard-flow-app-skeleton.tpl.ec3b149b.svg", import.meta.url).toString();


const $23c26c95d8e6cc8f$var$customCssStyles = null;
const $23c26c95d8e6cc8f$export$c6d3f04e6931e3f6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9618c51d58c4d685$exports))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });



var $1ybV0 = parcelRequire("1ybV0");
/**
 * @generated SignedSource<<9f129380be4be11ebffebf75dd5bc4d9>>
 * @relayHash 1fe2ed93013b48c5a46e637ab51649d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f33b0622a91566db2f969f1acf85aeb275e995bcfc0d44c36f5a9618fb4235be

var $jw4Ou = parcelRequire("jw4Ou");
const $ecb0b5ae979718a3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f33b0622a91566db2f969f1acf85aeb275e995bcfc0d44c36f5a9618fb4235be",
        "metadata": {},
        "name": "srcVirtualAgentBrowseConversationsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcisconversationfilterenabledrelayprovider": (0, $jw4Ou.default)
        }
    }
};
var $ecb0b5ae979718a3$export$2e2bcd8739ae039 = $ecb0b5ae979718a3$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");
const $a8f6b56040675aea$var$DEFAULT_RANGE_DAYS = 14;

const $a8f6b56040675aea$export$38549013d5d5a440 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("bHwXn")), {
        moduleId: "1bf85952"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const end = new Date();
        const start = new Date(end);
        start.setDate(start.getDate() - $a8f6b56040675aea$var$DEFAULT_RANGE_DAYS);
        return {
            extraProps: {
                initialDateRange: {
                    start: start,
                    end: end
                }
            },
            queries: {
                page: {
                    parameters: (0, $ecb0b5ae979718a3$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: start.toISOString(),
                        endDate: end.toISOString(),
                        checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
                    }
                }
            }
        };
    }
});



var $1ybV0 = parcelRequire("1ybV0");
/**
 * @generated SignedSource<<0a2c47ac432e504d8693a67627d1b346>>
 * @relayHash 9114d91fcebea81ad465cacf122c3ea9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 35983d7f2b4662d37dd74cd8f579a25c2cf6564d608ff39943ea5bc0a20cb909
const $68ca769f8ec90236$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "35983d7f2b4662d37dd74cd8f579a25c2cf6564d608ff39943ea5bc0a20cb909",
        "metadata": {},
        "name": "srcVirtualAgentBrowseIntentsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $68ca769f8ec90236$export$2e2bcd8739ae039 = $68ca769f8ec90236$var$node;


/**
 * @generated SignedSource<<8221a0384be3e0c7d78b1bbaa2f66504>>
 * @relayHash 7d72a8e1ec2336ed99383dd817c25c42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c5640c21c44dc3835a72f29fecfcb703a916b96913572926485bd4e862b315c
const $18a9373813a736ec$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4c5640c21c44dc3835a72f29fecfcb703a916b96913572926485bd4e862b315c",
        "metadata": {},
        "name": "srcVirtualAgentBrowseIntentsStatisticsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $18a9373813a736ec$export$2e2bcd8739ae039 = $18a9373813a736ec$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");
// When changing the default time range, make sure to also update jira/src/packages/servicedesk/virtual-agent/intents/browse-intents/src/ui/index.tsx
const $993f655e32e8f76f$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $993f655e32e8f76f$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10);

const $993f655e32e8f76f$export$f19c213ae2d7940f = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("cE8e4")), {
        moduleId: "85089c8d"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $68ca769f8ec90236$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
                    }
                },
                statistics: {
                    parameters: (0, $18a9373813a736ec$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: $993f655e32e8f76f$var$formatFetchDate(new Date(Date.now() - $993f655e32e8f76f$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $993f655e32e8f76f$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});



var $1ybV0 = parcelRequire("1ybV0");
/**
 * @generated SignedSource<<739047044a04affb48020f16b589a67b>>
 * @relayHash 3caa9fde75ad61c402696bca56249a4b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8dee2355fbdc129ba049a79fdc979156b50f2dc51a33bc3b2a89b3dc09884f25
const $70a9f1e91c27fff5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8dee2355fbdc129ba049a79fdc979156b50f2dc51a33bc3b2a89b3dc09884f25",
        "metadata": {},
        "name": "srcVirtualAgentBrowseStandardFlowsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $70a9f1e91c27fff5$export$2e2bcd8739ae039 = $70a9f1e91c27fff5$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $e66d796291623160$export$f7de8593c7455f1 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("8lHxq")), {
        moduleId: "c2d13204"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $70a9f1e91c27fff5$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
                    }
                }
            }
        })
});



var $1ybV0 = parcelRequire("1ybV0");
/**
 * @generated SignedSource<<d327b730e85a00f29719aa9ef0bedadb>>
 * @relayHash 2b16c4530e6a4991c643936f8b7f7a75
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 61418abde1b6f9e8308be8231e429dad5a1ab50e615aed86e4cf34c33e6a7d68
const $2f92e30f6ae3e526$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "61418abde1b6f9e8308be8231e429dad5a1ab50e615aed86e4cf34c33e6a7d68",
        "metadata": {},
        "name": "srcVirtualAgentLandingQuery",
        "operationKind": "query",
        "text": null
    }
};
var $2f92e30f6ae3e526$export$2e2bcd8739ae039 = $2f92e30f6ae3e526$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $cbf4357801ece501$export$ad927ca7512a3a01 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("hIbMf")), {
        moduleId: "06d84010"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $2f92e30f6ae3e526$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
                    }
                }
            }
        })
});



var $1ybV0 = parcelRequire("1ybV0");
/**
 * @generated SignedSource<<20bdf2f6a28a2f1106b529d91ed20817>>
 * @relayHash 511deef67eb8feb6cf7da5b022122f74
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cedf20e4b8b5da842afafec10bb661c651e0e28ffe617f9222244e8a14b0af11
const $412aef0a7481ae16$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "cedf20e4b8b5da842afafec10bb661c651e0e28ffe617f9222244e8a14b0af11",
        "metadata": {},
        "name": "srcVirtualAgentSettingsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $412aef0a7481ae16$export$2e2bcd8739ae039 = $412aef0a7481ae16$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $bc6c60221f4cf5b6$export$d34e7816b7ac181a = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("1TSUO")), {
        moduleId: "ed4de71b"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $412aef0a7481ae16$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
                    }
                }
            }
        })
});



var $1ybV0 = parcelRequire("1ybV0");
/**
 * @generated SignedSource<<122633496c89d816800ac0cc7ad197d8>>
 * @relayHash 1fff16012e9e82d351a4809512dd028b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 45bdb9c30dff6291e9de65ae33f52f1c1b2c01aacaf0e50196e285c9c83f41d7
const $6087ec5fc1dbe2d2$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "45bdb9c30dff6291e9de65ae33f52f1c1b2c01aacaf0e50196e285c9c83f41d7",
        "metadata": {},
        "name": "srcVirtualAgentViewIntentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6087ec5fc1dbe2d2$export$2e2bcd8739ae039 = $6087ec5fc1dbe2d2$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $9bd372a4e39a0dac$export$f51df662bd71ce39 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("asVoY")), {
        moduleId: "bc04de30"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $6087ec5fc1dbe2d2$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        intentId: context.match.params.intentId ?? '',
                        checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
                    }
                }
            }
        })
});



var $1ybV0 = parcelRequire("1ybV0");
/**
 * @generated SignedSource<<78ca456cd6160a4ce6ec83f2e6433d00>>
 * @relayHash aed7569699aee5dd3ad2ebc1c66c6544
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10c3f4debb1d42f2d9c4150d990a7fa92c6fdae9d8a3ed579a56d5027e1facbd
const $6e4a0a2b14b42bdd$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "10c3f4debb1d42f2d9c4150d990a7fa92c6fdae9d8a3ed579a56d5027e1facbd",
        "metadata": {},
        "name": "srcVirtualAgentViewStandardFlowQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6e4a0a2b14b42bdd$export$2e2bcd8739ae039 = $6e4a0a2b14b42bdd$var$node;



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $aa4382e1bbcff254$export$4fd7bf09308d4abd = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("8mp6E")), {
        moduleId: "8e1cdfbd"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $6e4a0a2b14b42bdd$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        flowId: context.match.params.flowId ?? '',
                        checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
                    }
                }
            }
        })
});



var $eUqFw = parcelRequire("eUqFw");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");

var $lB25E = parcelRequire("lB25E");
const $ad1944adf3170121$export$b7262fe486f4b412 = 'core';
const $ad1944adf3170121$export$2954328f6207617a = 'software';
const $ad1944adf3170121$export$5575497f0592ee94 = 'servicedesk';
const $ad1944adf3170121$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $ad1944adf3170121$export$586756e5c0542a50 = (product)=>{
    if (product === $ad1944adf3170121$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $ad1944adf3170121$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $ad1944adf3170121$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });


const $9168fc13fd51b5cc$var$browseConversationsPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $a8f6b56040675aea$export$38549013d5d5a440),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $9168fc13fd51b5cc$var$browseIntentsPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $993f655e32e8f76f$export$f19c213ae2d7940f),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $9168fc13fd51b5cc$var$browseStandardFlowsPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $e66d796291623160$export$f7de8593c7455f1),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $9168fc13fd51b5cc$var$landingPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $cbf4357801ece501$export$ad927ca7512a3a01),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $9168fc13fd51b5cc$var$settingsPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $bc6c60221f4cf5b6$export$d34e7816b7ac181a),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $9168fc13fd51b5cc$var$viewStandardFlowPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $aa4382e1bbcff254$export$4fd7bf09308d4abd),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $9168fc13fd51b5cc$var$viewIntentPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $9bd372a4e39a0dac$export$f51df662bd71ce39),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon = ()=>({
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        }
    });
const $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings = (0, $ad1944adf3170121$export$c9b0516439c55d7a)((0, $ad1944adf3170121$export$5575497f0592ee94));
const $9168fc13fd51b5cc$export$cf02bed1953597cb = [
    (0, $bMm60.createEntry)((0, $ad4e15e96c4bd9a2$export$8c051c399fd812a5), {
        ...$9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon(),
        entryPoint () {
            if ((0, $dfBCt.isFedRamp)()) return undefined;
            return $9168fc13fd51b5cc$var$landingPageEntryPoint;
        },
        component: $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings,
        skeleton: (0, $7da2e5cae9546ea1$export$f4b71d7b732df8a7),
        resources: [
            ...(0, $ad1944adf3170121$export$586756e5c0542a50)((0, $ad1944adf3170121$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $ad4e15e96c4bd9a2$export$3e227412713bc57f), {
        ...$9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon(),
        entryPoint () {
            if ((0, $dfBCt.isFedRamp)()) return undefined;
            return $9168fc13fd51b5cc$var$browseIntentsPageEntryPoint;
        },
        component: $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings,
        layout: (0, $3da6a5b21870784d$export$6659f41b213bad05),
        skeleton: (0, $aDZUE.VirtualAgentBrowseIntentsSkeleton),
        resources: [
            ...(0, $ad1944adf3170121$export$586756e5c0542a50)((0, $ad1944adf3170121$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $ad4e15e96c4bd9a2$export$bf8131fb060d0e73), {
        ...$9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon(),
        entryPoint () {
            if ((0, $dfBCt.isFedRamp)()) return undefined;
            return $9168fc13fd51b5cc$var$viewIntentPageEntryPoint;
        },
        component: $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings,
        skeleton: (0, $ff6dbd89968fe1c3$export$72b20c10a0f18a2f),
        resources: [
            ...(0, $ad1944adf3170121$export$586756e5c0542a50)((0, $ad1944adf3170121$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $ad4e15e96c4bd9a2$export$fd091ba8fa858397), {
        ...$9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon(),
        entryPoint () {
            if ((0, $dfBCt.isFedRamp)()) return undefined;
            return $9168fc13fd51b5cc$var$browseStandardFlowsPageEntryPoint;
        },
        component: $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings,
        skeleton: (0, $5d33c8e57d2ae9fa$export$c2bd83dd149452bd),
        resources: [
            ...(0, $ad1944adf3170121$export$586756e5c0542a50)((0, $ad1944adf3170121$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $ad4e15e96c4bd9a2$export$c74dca8be49046ea), {
        ...$9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon(),
        entryPoint () {
            if ((0, $dfBCt.isFedRamp)()) return undefined;
            return $9168fc13fd51b5cc$var$viewStandardFlowPageEntryPoint;
        },
        component: $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings,
        skeleton: (0, $23c26c95d8e6cc8f$export$c6d3f04e6931e3f6),
        resources: [
            ...(0, $ad1944adf3170121$export$586756e5c0542a50)((0, $ad1944adf3170121$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $ad4e15e96c4bd9a2$export$c8ff4cf64e5540ec), {
        ...$9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon(),
        entryPoint () {
            if ((0, $dfBCt.isFedRamp)()) return undefined;
            return $9168fc13fd51b5cc$var$browseConversationsPageEntryPoint;
        },
        component: $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings,
        skeleton: (0, $ee9589c148891c91$export$4a6267fad85ca589),
        resources: [
            ...(0, $ad1944adf3170121$export$586756e5c0542a50)((0, $ad1944adf3170121$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $ad4e15e96c4bd9a2$export$847a7c378c11c645), {
        ...$9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon(),
        entryPoint () {
            if ((0, $dfBCt.isFedRamp)()) return undefined;
            return $9168fc13fd51b5cc$var$settingsPageEntryPoint;
        },
        component: $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings,
        skeleton: (0, $a5f272c37f7018ee$export$429c43ddcb09c14c),
        resources: [
            ...(0, $ad1944adf3170121$export$586756e5c0542a50)((0, $ad1944adf3170121$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    })
];




var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $kbHFR = parcelRequire("kbHFR");

var $1HCPc = parcelRequire("1HCPc");

var $csLgO = parcelRequire("csLgO");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $0ecbe1f8642fe6d6$export$12ccdf1d30de8ac = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("lL5d7")), {
        moduleId: "6be3e66b"
    }),
    getPreloadProps: ()=>({})
});


const $fc1dda288890f345$var$workflowSchemeConfigPageEntrypoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $0ecbe1f8642fe6d6$export$12ccdf1d30de8ac),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $fc1dda288890f345$var$CORE_PRODUCT = 'core';
const $fc1dda288890f345$var$SERVICE_DESK_PRODUCT = 'servicedesk';
const $fc1dda288890f345$export$586756e5c0542a50 = (product)=>{
    if (product === $fc1dda288890f345$var$SERVICE_DESK_PRODUCT) return (0, $kbHFR.getServiceDeskSettingsResources)();
    const resources = [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
    if (product === $fc1dda288890f345$var$CORE_PRODUCT) return [
        ...resources,
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return resources;
};
const $fc1dda288890f345$export$212f7f79630d5adc = (0, $bMm60.createEntry)((0, $1HCPc.routeGroupsProjectSettingsWorkflowSchemeConfigRoute), {
    entryPoint () {
        return $fc1dda288890f345$var$workflowSchemeConfigPageEntrypoint;
    },
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...$fc1dda288890f345$export$586756e5c0542a50($fc1dda288890f345$var$SERVICE_DESK_PRODUCT),
        (0, $ixwgj.projectContextResource)
    ],
    meta: {
        reporting: {
            id: 'project-settings.workflow-scheme-config',
            packageName: 'projectSettingsWorkflowSchemeConfig',
            teamName: 'jsd-shield'
        }
    },
    ufoName: 'project-settings-workflow-scheme-config'
});



var $csLgO = parcelRequire("csLgO");

var $aje9D = parcelRequire("aje9D");

var $6ebW2 = parcelRequire("6ebW2");

var $frZnw = parcelRequire("frZnw");

var $9oI9i = parcelRequire("9oI9i");

var $lq02o = parcelRequire("lq02o");

var $ecIZv = parcelRequire("ecIZv");

var $aHr8P = parcelRequire("aHr8P");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $7ZZxN = parcelRequire("7ZZxN");

var $bNe1g = parcelRequire("bNe1g");


var $59o4i = parcelRequire("59o4i");

var $lB25E = parcelRequire("lB25E");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $c7e3207268af5ac9$export$fa3bc297af95f169 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("ILATv"))), {
    moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c7e3207268af5ac9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c7e3207268af5ac9$export$fa3bc297af95f169,
        pageId: "project-settings-app-discovery-settings",
        shouldShowSpinner: false
    });



const $580910a7f6b68948$export$246ec9cdadd2a163 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("jS5ct"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $580910a7f6b68948$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
    return shouldRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
        push: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c7e3207268af5ac9$export$2e2bcd8739ae039), null);
};
const $580910a7f6b68948$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($580910a7f6b68948$var$ConnectAppsRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$580910a7f6b68948$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $580910a7f6b68948$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });




var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $6c45d7b28c7d9a98$export$3633e017e520a1c2 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("c3BLd"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6c45d7b28c7d9a98$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6c45d7b28c7d9a98$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $07c4b3293ba0b7af$export$b8abcf8aa8f4df56 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("74Iqa"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07c4b3293ba0b7af$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $07c4b3293ba0b7af$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $559cd2af54dee24a$export$6f16b5efddd5c646 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("c642p"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$559cd2af54dee24a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $559cd2af54dee24a$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $329bbd15c94f6d16$export$e309780f520d125a = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("34M7x"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$329bbd15c94f6d16$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $329bbd15c94f6d16$export$e309780f520d125a,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $l90Gp = parcelRequire("l90Gp");

var $ixwgj = parcelRequire("ixwgj");

var $59o4i = parcelRequire("59o4i");

const $d047c23f9bddce75$export$ef66d3f49a9953d8 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("1yOoT")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $d047c23f9bddce75$export$33d85a1b2211b38 = [
    (0, $ixwgj.projectContextResourceWithCache),
    (0, $l90Gp.forgeProjectSettingsModuleResource)
];
const $d047c23f9bddce75$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d047c23f9bddce75$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
var $d047c23f9bddce75$export$2e2bcd8739ae039 = $d047c23f9bddce75$export$b943f48844c671a5;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $7c62d64db2daccf3$export$36dcfb52d47cb93a = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("e3u5r"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7c62d64db2daccf3$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7c62d64db2daccf3$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $da72a92622b3bdcb$export$dea5ad7e8eac12ae = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("bZFFJ")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$da72a92622b3bdcb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $da72a92622b3bdcb$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $f29c792a14c577ec$export$ea7d73c94d9369f4 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("65jMk"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f29c792a14c577ec$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f29c792a14c577ec$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

var $lB25E = parcelRequire("lB25E");

const $252a239e9d35912c$export$7eee4f97b7a1273 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("epDvb"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $252a239e9d35912c$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
const $252a239e9d35912c$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($252a239e9d35912c$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$252a239e9d35912c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $252a239e9d35912c$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");

var $lB25E = parcelRequire("lB25E");
const $8410513c5fe667e7$export$b7262fe486f4b412 = 'core';
const $8410513c5fe667e7$export$2954328f6207617a = 'software';
const $8410513c5fe667e7$export$5575497f0592ee94 = 'servicedesk';
const $8410513c5fe667e7$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $8410513c5fe667e7$export$586756e5c0542a50 = (product)=>{
    if (product === $8410513c5fe667e7$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $8410513c5fe667e7$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $8410513c5fe667e7$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $47269aa86ef517ac$export$a7d63246a10aedd = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("gcYA0")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47269aa86ef517ac$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $47269aa86ef517ac$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $13ec93ed6e57bb05$export$38414b624a749cec = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("5R9nY")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$13ec93ed6e57bb05$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $13ec93ed6e57bb05$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $b9037e72191a69bf$export$e674d93688e620b3 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("8ujhR"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-change-management-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b9037e72191a69bf$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b9037e72191a69bf$export$e674d93688e620b3,
        pageId: "project-settings-change-management",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $cqJw8 = parcelRequire("cqJw8");

var $lB25E = parcelRequire("lB25E");
const $8fd7e7e53e33ec12$export$c7e6c0ac0abe2336 = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), String(projectKey))}/channels/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: url,
            push: false
        });
    };



var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $a6450ebb4eaa0802$export$22c86ddb04b1359a = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/chat`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: url
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $1a74c443d51d759d$export$971347f9ac02f862 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("9tVMM")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-chat-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1a74c443d51d759d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1a74c443d51d759d$export$971347f9ac02f862,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $aa4ce00c6b5b5662$export$eb662b618d6247be = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("9vocX"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-classic-portal-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aa4ce00c6b5b5662$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $aa4ce00c6b5b5662$export$eb662b618d6247be,
        pageId: "project-settings-classic-portal-settings",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $76108e832f0b5581$export$5367e40a24f0bd54 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("i7e33"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-permissions/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$76108e832f0b5581$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $76108e832f0b5581$export$5367e40a24f0bd54,
        pageId: "project-settings-customer-permissions",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $a6902b3a7b811425$export$59eedcca37dbbafd = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-permissions`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: url
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $7bc7e4ae2435f6fb$export$66d0c668045080de = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("ihsby")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7bc7e4ae2435f6fb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56ac3f4dbf97569a$export$a24ec33acfeae48d), {
        page: "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7bc7e4ae2435f6fb$export$66d0c668045080de,
        pageId: "project-settings-email",
        shouldShowSpinner: true
    }));



var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $8b921182ec748f3f$export$86c8da903fb97c4f = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/email`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: url
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $d1e5bcf2bfdaa472$export$28482a53859ec466 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("jRUqc"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-external-links/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d1e5bcf2bfdaa472$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d1e5bcf2bfdaa472$export$28482a53859ec466,
        pageId: "project-settings-external-links",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");
const $0214761d0ab209ae$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $0214761d0ab209ae$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $0214761d0ab209ae$export$ff54bec6c7cb7d47 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("63gAp")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-feedback-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0214761d0ab209ae$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0214761d0ab209ae$export$ff54bec6c7cb7d47,
        pageId: "project-settings-feedback-settings",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $4282547c3530036f$export$7796b6d080b8c187 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("giTdm"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-incident-management-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4282547c3530036f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4282547c3530036f$export$7796b6d080b8c187,
        pageId: "project-settings-incident-management",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $f72b67be569f8585$export$9c9d293dc6de29d0 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("bAVNR"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-internal-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f72b67be569f8585$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f72b67be569f8585$export$9c9d293dc6de29d0,
        pageId: "project-settings-internal-notifications",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $999046d31b25bd09$export$49625f83fe7ecc69 = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/internal-notifications`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: url
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $e3524235223eda09$export$562be1021beb9882 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("jGi07"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-itsm-features/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e3524235223eda09$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3524235223eda09$export$562be1021beb9882,
        pageId: "project-settings-itsm-features",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $fa9f364df5e36006$export$213b8279037c9d98 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("h1RDW"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-support/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fa9f364df5e36006$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $fa9f364df5e36006$export$213b8279037c9d98,
        pageId: "project-settings-language-support",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $fb61fb9e176eaa7e$export$c029d3f514c7b3e0 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("cyAlu")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-translations/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fb61fb9e176eaa7e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $fb61fb9e176eaa7e$export$c029d3f514c7b3e0,
        pageId: "project-settings-language-translations",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $213742f3b8f99b33$export$735e58642f560ddc = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/notification-email`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: url
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $cqJw8 = parcelRequire("cqJw8");

var $lB25E = parcelRequire("lB25E");
const $72f95138eb01ac65$export$59144dd4441639fa = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = projectKey !== null && projectKey !== undefined ? `${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), projectKey)}/notifications/${pageUrlFragment}` : `/projects/${String(projectKey)}/settings/notifications/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: url,
            push: false
        });
    };



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $66b7677e7a3f168d$export$fdbd4b1e5ae0e422 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("it9xs")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-portal-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$66b7677e7a3f168d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $66b7677e7a3f168d$export$fdbd4b1e5ae0e422,
        pageId: "project-settings-portal-settings",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $eb2f50cfaf183727$export$8ba256148f9b998f = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/widget`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: url
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $f4c945aaafdab002$export$216a049c4d917b0 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("9n4ZQ")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-widget-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f4c945aaafdab002$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f4c945aaafdab002$export$216a049c4d917b0,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $f05fb14c94c470fa$export$cb608e3696682e76 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("5p5BW"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f05fb14c94c470fa$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f05fb14c94c470fa$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });


const $0ffaa8ee5786ed66$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $0ffaa8ee5786ed66$var$getUFOName = (name)=>$0ffaa8ee5786ed66$var$ufoNamesMap[name] || name;
const $0ffaa8ee5786ed66$var$commonRouteEntries = [
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskIssuetypesRoute), {
        ufoName: $0ffaa8ee5786ed66$var$getUFOName(`${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes`),
        component: (0, $7c62d64db2daccf3$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7c62d64db2daccf3$export$36dcfb52d47cb93a)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskIssuetypesWorkflowRoute), {
        component: (0, $f05fb14c94c470fa$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7c62d64db2daccf3$export$36dcfb52d47cb93a)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskFieldsRoute), {
        ufoName: 'project-settings.fields.jsm-tmp',
        component: (0, $dnJL9.componentWithFG)('project_fields_page_for_tmp_-_mvp', (0, $329bbd15c94f6d16$export$2e2bcd8739ae039), (0, $dgH3j.default)),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)(),
            (0, $2AuYt.fieldSettingsRelayResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $329bbd15c94f6d16$export$e309780f520d125a)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskAppsFieldsRoute), {
        component: (0, $580910a7f6b68948$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $580910a7f6b68948$export$246ec9cdadd2a163)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskApps1Route), {
        component: (0, $6c45d7b28c7d9a98$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6c45d7b28c7d9a98$export$3633e017e520a1c2)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskDetailsRoute), {
        component: (0, $559cd2af54dee24a$export$2e2bcd8739ae039),
        skeleton: (0, $aHr8P.ProjectSettingsDetailsSkeleton),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $559cd2af54dee24a$export$6f16b5efddd5c646)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskAccessRoute), {
        skeleton: (0, $aHr8P.ProjectSettingsAccessSkeleton),
        component: (0, $252a239e9d35912c$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $252a239e9d35912c$export$7eee4f97b7a1273)
        ],
        ufoName: 'project-settings.access'
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskAccessRedirectRoute), {
        component: (0, $252a239e9d35912c$export$45346ed2aa24e3f3)(`/jira/${(0, $8410513c5fe667e7$export$5575497f0592ee94)}`),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $252a239e9d35912c$export$7eee4f97b7a1273)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute), {
        component: (0, $13ec93ed6e57bb05$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $13ec93ed6e57bb05$export$38414b624a749cec)
        ],
        perfMetricKey: 'forms-settings'
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskProformaJiraFormBuilderRoute), {
        component: (0, $47269aa86ef517ac$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $47269aa86ef517ac$export$a7d63246a10aedd)
        ],
        perfMetricKey: 'form-builder'
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.projectSettingsServicedeskAutomationRoute), {
        ufoName: `project-settings-automation-${(0, $8410513c5fe667e7$export$5575497f0592ee94)}`,
        component: (0, $da72a92622b3bdcb$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $da72a92622b3bdcb$export$dea5ad7e8eac12ae)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskDataClassificationsRoute), {
        component: (0, $07c4b3293ba0b7af$export$2e2bcd8739ae039),
        skeleton: (0, $aHr8P.ProjectSettingsDetailsSkeleton),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $07c4b3293ba0b7af$export$b8abcf8aa8f4df56)
        ]
    })
];
const $0ffaa8ee5786ed66$export$37a8204dc4094049 = [
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskClassicAppsRoute), {
        ufoName: 'service-management.app-discovery',
        component: (0, $580910a7f6b68948$export$cc3414a2d9daf70d)(`/jira/${(0, $8410513c5fe667e7$export$5575497f0592ee94)}`),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        isRedirect: true,
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $c7e3207268af5ac9$export$fa3bc297af95f169)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).APP_DISCOVERY,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).APP_DISCOVERY),
                teamName: 'it-solutions-hermes'
            }
        }
    }),
    ...$0ffaa8ee5786ed66$var$commonRouteEntries,
    ...(0, $86d860750863d795$export$f90c0f16cffd8883),
    ...(0, $c85fda19a90ea423$export$caa50198aadcf21c),
    ...(0, $39723202b32651a7$export$fa9d0db1668a0662),
    ...(0, $38d72ec77f663f1e$export$8521f0867b2d52e4),
    ...(0, $0b9b4e281f9618b2$export$d6bb339f4d05f5c5),
    ...(0, $9168fc13fd51b5cc$export$cf02bed1953597cb),
    ...(0, $6a6e895e66357348$export$89ee08578c593726),
    ...(0, $3d75df320bcbde8d$export$5dfc85c70e03c102),
    (0, $fc1dda288890f345$export$212f7f79630d5adc),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskItsmFeaturesRoute), {
        ufoName: 'jsm-features-settings',
        component: (0, $e3524235223eda09$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $k1AKH.featuresResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $e3524235223eda09$export$562be1021beb9882)
        ],
        // Error boudnary is added to the component itself, so this layer won't capture the error
        // Remove meta when clean up add-error-boundary-to-issue-type-package-components_2ds9q
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).ITSM_FEATURES_SETTINGS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).ITSM_FEATURES_SETTINGS),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-features-settings'
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute), {
        ufoName: 'service-management.internal-notifications',
        component: (0, $dnJL9.componentWithFG)('update_jsm_project_settings_pages_urls', (0, $999046d31b25bd09$export$49625f83fe7ecc69), (0, $f72b67be569f8585$export$2e2bcd8739ae039)),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $f72b67be569f8585$export$9c9d293dc6de29d0),
            (0, $ecIZv.LazyInternalNotificationSettingsPage)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute), {
        ufoName: 'service-management.internal-notifications',
        component: (0, $f72b67be569f8585$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $f72b67be569f8585$export$9c9d293dc6de29d0),
            (0, $ecIZv.LazyInternalNotificationSettingsPage)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.projectSettingsServicedeskNotificationsNotificationEmailRoute), {
        component: (0, $dnJL9.componentWithFG)('update_jsm_project_settings_pages_urls', (0, $213742f3b8f99b33$export$735e58642f560ddc), (0, $f29c792a14c577ec$export$2e2bcd8739ae039)),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $f29c792a14c577ec$export$ea7d73c94d9369f4)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.projectSettingsServicedeskNotificationsEmailRoute), {
        component: (0, $f29c792a14c577ec$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $f29c792a14c577ec$export$ea7d73c94d9369f4)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.projectSettingsServicedeskNotifications1Route), {
        component: (0, $72f95138eb01ac65$export$59144dd4441639fa)('customer-notifications'),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskLanguageKeyRoute), {
        ufoName: 'service-management.translations',
        component: (0, $fb61fb9e176eaa7e$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)(),
            (0, $lq02o.languageTranslationsResource),
            (0, $lq02o.outgoingEmailStateModelResource)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).LANGUAGE_SETTINGS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).LANGUAGE_SETTINGS),
                teamName: 'jsm-nimbus'
            }
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $fb61fb9e176eaa7e$export$c029d3f514c7b3e0)
        ],
        perfMetricKey: 'jsm-language-translations'
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskLanguage1Route), {
        ufoName: 'service-management.languages',
        component: (0, $fa9f364df5e36006$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $fb61fb9e176eaa7e$export$c029d3f514c7b3e0)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute), {
        component: (0, $dnJL9.componentWithFG)('update_jsm_project_settings_pages_urls', (0, $a6902b3a7b811425$export$59eedcca37dbbafd), (0, $76108e832f0b5581$export$2e2bcd8739ae039)),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $ixwgj.projectContextResource),
            (0, $k82mP.customerPermissionsPageDataResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $76108e832f0b5581$export$5367e40a24f0bd54)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions'
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute), {
        component: (0, $76108e832f0b5581$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $ixwgj.projectContextResource),
            (0, $k82mP.customerPermissionsPageDataResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $76108e832f0b5581$export$5367e40a24f0bd54)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions'
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsEmailNextGenRoute), {
        component: (0, $dnJL9.componentWithFG)('update_jsm_project_settings_pages_urls', (0, $8b921182ec748f3f$export$86c8da903fb97c4f), (0, $7bc7e4ae2435f6fb$export$2e2bcd8739ae039)),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7bc7e4ae2435f6fb$export$66d0c668045080de)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskEmailRoute), {
        ufoName: 'service-management.settings.email-channels',
        component: (0, $7bc7e4ae2435f6fb$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7bc7e4ae2435f6fb$export$66d0c668045080de)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskPortalSettingsRoute), {
        component: (0, $aa4ce00c6b5b5662$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $aa4ce00c6b5b5662$export$eb662b618d6247be)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).PORTAL_SETTINGS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).PORTAL_SETTINGS),
                teamName: 'jsd-shield'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsPortalRoute), {
        component: (0, $66b7677e7a3f168d$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $ixwgj.projectContextResource),
            (0, $3BZ46.portalSettingsContextResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $66b7677e7a3f168d$export$fdbd4b1e5ae0e422)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskExternalLinksRoute), {
        component: (0, $d1e5bcf2bfdaa472$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $ixwgj.projectContextResource),
            (0, $k1AKH.featuresResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d1e5bcf2bfdaa472$export$28482a53859ec466)
        ],
        perfMetricKey: 'jsm-external-resources'
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsWidgetRoute), {
        component: (0, $dnJL9.componentWithFG)('update_jsm_project_settings_pages_urls', (0, $eb2f50cfaf183727$export$8ba256148f9b998f), (0, $f4c945aaafdab002$export$2e2bcd8739ae039)),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f4c945aaafdab002$export$216a049c4d917b0)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskWidgetRoute), {
        component: (0, $f4c945aaafdab002$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f4c945aaafdab002$export$216a049c4d917b0)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChangeManagementRoute), {
        ufoName: 'service-management.change-management-settings',
        component: (0, $b9037e72191a69bf$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $ct0sQ.serviceDeskContextResource),
            (0, $6ebW2.changeManagementSettingsProjectConfigurationResource),
            (0, $ejPAV.jsmChangeManagementSettingsGitLabGatingResource),
            (0, $aje9D.changeManagementAssetConfigurationStatusResource),
            (0, $k1AKH.featuresResource),
            (0, $dAKwA.getConsolidationStateResource)(),
            (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9'), (0, $aspp6.jsmRepackagingBannerResource))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $b9037e72191a69bf$export$e674d93688e620b3)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskIncidentManagementRoute), {
        component: (0, $4282547c3530036f$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $ct0sQ.serviceDeskContextResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4282547c3530036f$export$7796b6d080b8c187)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsChatRoute), {
        component: (0, $dnJL9.componentWithFG)('update_jsm_project_settings_pages_urls', (0, $a6450ebb4eaa0802$export$22c86ddb04b1359a), (0, $1a74c443d51d759d$export$2e2bcd8739ae039)),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1a74c443d51d759d$export$971347f9ac02f862)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChatRoute), {
        component: (0, $1a74c443d51d759d$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1a74c443d51d759d$export$971347f9ac02f862)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChannels5Route), {
        component: (0, $8fd7e7e53e33ec12$export$c7e6c0ac0abe2336)('customer-permissions'),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    ...(0, $792114e6a9cd6c10$export$fd1a58e6255623a),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskFeedbackRoute), {
        component: (0, $0214761d0ab209ae$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $0214761d0ab209ae$export$ff54bec6c7cb7d47),
            (0, $9oI9i.LazyCsatSettingsPage)
        ],
        perfMetricKey: 'jsm-feedback-settings',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).CSAT_CONFIG,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CSAT_CONFIG),
                teamName: 'jsm-request-intake'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.projectSettingsServicedeskForgeAppsRoute), {
        component: (0, $d047c23f9bddce75$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            ...(0, $d047c23f9bddce75$export$33d85a1b2211b38),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d047c23f9bddce75$export$ef66d3f49a9953d8)
        ]
    }),
    (0, $bMm60.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskRedirectRoute), {
        component: (0, $8410513c5fe667e7$export$c9b0516439c55d7a)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $cernH = parcelRequire("cernH");

var $hbnZD = parcelRequire("hbnZD");

var $dCvLw = parcelRequire("dCvLw");

var $exb0h = parcelRequire("exb0h");

var $2ijRB = parcelRequire("2ijRB");

var $1ybV0 = parcelRequire("1ybV0");

var $dnJL9 = parcelRequire("dnJL9");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $a0UvO = parcelRequire("a0UvO");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $guiFP = parcelRequire("guiFP");

var $lB25E = parcelRequire("lB25E");

var $ixwgj = parcelRequire("ixwgj");
const $a526b624614fa406$export$899fd1c46031ece8 = (teamName)=>{
    const { data: data, error: resourceError, loading: loading } = (0, $lB25E.useResource)((0, $ixwgj.projectContextResource));
    if (resourceError && data == null) {
        const isErrorErrorType = resourceError instanceof Error;
        const error = isErrorErrorType ? resourceError : new Error(`projectContextResource returned error resourceError: ${JSON.stringify(resourceError)}, loading: ${loading}, data: null`);
        (0, $guiFP.default)({
            meta: {
                id: 'useResourceProjectContext',
                packageName: 'jiraRouterResourcesProjectContext',
                teamName: teamName ?? 'magma'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            loading: false,
            error: error,
            projectKey: null
        };
    }
    if (loading) return {
        loading: true,
        error: null,
        projectKey: null
    };
    // This case never happens by type definition, which you can't even mock test data for this case due to type definition. But if you don't check this, TS is not happy
    if (data == null) return {
        loading: false,
        error: new Error('projectContextResource returned data=null when loading false'),
        projectKey: null
    };
    return {
        loading: false,
        projectKey: data.projectKey,
        error: null
    };
};



var $2AuYt = parcelRequire("2AuYt");

var $3BLIV = parcelRequire("3BLIV");

var $a3WTo = parcelRequire("a3WTo");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT = 'software';
const $4b91e3ee82bc8bc2$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $4b91e3ee82bc8bc2$var$boardSettingsUrl = (product)=>`${$4b91e3ee82bc8bc2$var$projectSettingsUrl(product)}/boards/:boardId`;
const $4b91e3ee82bc8bc2$export$dde867834e4a9f47 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-issuetypes`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/issuetypes/:issueTypeId?`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$955e8eef6e3bccfb = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-issuetypes-workflow`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/issuetypes/:issueTypeId/:initialSection(workflow)`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$8ddc76f4b4e66b2b = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_APPS_FIELDS),
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/apps/app-fields`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$d9dea7be10efa583 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-apps`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/apps/:appId?`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$18624b8612cb673d = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-details`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/details`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$9d5b42fcb82012dd = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-access`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/access`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$d782b5257932a66d = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-access-redirect`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/people`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$396cdbbd6f2abcea = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-proforma-project-forms`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/forms`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$394d8f4806a90d7 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-proforma-jira-form-builder`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/forms/form/:templateFormId/edit`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$4d430aeb28b702f8 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/automate`
};
const $4b91e3ee82bc8bc2$export$61d54e538063bb07 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-data-classifications`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/data-classifications`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$a598c3fe8cbf0c6c = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-next-gen-features`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/features`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$c1d1892d6c07135a = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS),
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/notifications`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$c7039de5a4b78802 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_OPSGENIE),
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/opsgenie`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$99b695c2b8299b5a = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: `${(0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE)}-redirect`,
    path: `/jira/${$4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT}/c/projects/:projectKey/settings`
};
const $4b91e3ee82bc8bc2$export$37e0dbac44df25b9 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS),
    path: '/jira/software/c/projects/:projectKey/settings/details',
    exact: true
};
const $4b91e3ee82bc8bc2$export$4e4a4b8762b611 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_OPSGENIE),
    path: '/jira/software/c/projects/:projectKey/settings/opsgenie',
    exact: true
};
const $4b91e3ee82bc8bc2$export$e3e3877ec9c5e840 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_TOOLCHAIN),
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/toolchain`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$7dbc23deac9553d4 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_TOOLCHAIN),
    path: '/jira/software/c/projects/:projectKey/settings/toolchain',
    exact: true
};
const $4b91e3ee82bc8bc2$export$d4bf23ba6f4199d7 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_FEATURES),
    path: '/jira/software/c/projects/:projectKey/settings/features',
    exact: true
};
const $4b91e3ee82bc8bc2$export$d4ed083331cb6e00 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL),
    path: '/jira/software/c/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};
const $4b91e3ee82bc8bc2$export$b2e044c3dffeca69 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL),
    path: '/jira/software/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};
const $4b91e3ee82bc8bc2$export$6ef734887b6da0c8 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE),
    path: '/jira/secure/ReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};
const $4b91e3ee82bc8bc2$export$a9509017cabb1e30 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE_CONFIG),
    path: '/secure/ConfigureReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};
const $4b91e3ee82bc8bc2$export$a0223091962262d4 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_RELEASE_NOTES),
    path: '/secure/ReleaseNote.jspa',
    query: [
        'projectId'
    ]
};
const $4b91e3ee82bc8bc2$export$46e979217c179afd = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-automation`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/automation`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$ff4977f79c273b29 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS),
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/notifications/issue-logs`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$5e2e0a895d6a14bd = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS),
    path: '/jira/software/c/projects/:projectKey/settings/notifications/issue-logs',
    query: [
        'projectId'
    ]
};
const $4b91e3ee82bc8bc2$export$2313ca001d58ab27 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_FORMS),
    path: '/jira/software/c/projects/:projectKey/settings/forms',
    exact: true
};
const $4b91e3ee82bc8bc2$export$811ace4fee984f0e = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_EDIT_FORMS),
    path: '/jira/software/c/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};
const $4b91e3ee82bc8bc2$export$989ca67485551616 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_REDIRECT),
    path: `${$4b91e3ee82bc8bc2$var$boardSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$88e68eb447e3db49 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CSM),
    path: `${$4b91e3ee82bc8bc2$var$boardSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/columns`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$9bc9b345958a301c = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CUSTOM_FILTERS),
    path: `${$4b91e3ee82bc8bc2$var$boardSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/custom-filters`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$d3f185a361401db7 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CARD),
    path: `${$4b91e3ee82bc8bc2$var$boardSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/card`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$17ccdaa366ec26b8 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_ROADMAP),
    path: `${$4b91e3ee82bc8bc2$var$boardSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/roadmap`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$e116d6b2a5f71426 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_TIMELINE),
    path: `${$4b91e3ee82bc8bc2$var$boardSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/timeline`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$ae89a2a3aaf095ef = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
    path: '/jira/software/c/projects/:projectKey/settings/automate'
};
const $4b91e3ee82bc8bc2$export$f74a0b1be9d5b9f6 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS),
    path: '/jira/software/c/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};
const $4b91e3ee82bc8bc2$export$1a2cbdfba83d21b = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_INSIGHTS),
    path: `${$4b91e3ee82bc8bc2$var$boardSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/insights/:location`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$8559c4a0b692890e = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS_NEXTGEN),
    path: '/jira/software/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};
const $4b91e3ee82bc8bc2$export$7ce9914683cb1572 = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-redirect`,
    path: `/jira/${$4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT}/projects/:projectKey/settings`
};
const $4b91e3ee82bc8bc2$export$ad2c16468a73b68 = {
    group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FIELDS),
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/fields`,
    exact: true
};



var $aHr8P = parcelRequire("aHr8P");

var $yyqSx = parcelRequire("yyqSx");

var $soOXK = parcelRequire("soOXK");

var $lB25E = parcelRequire("lB25E");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $7ZZxN = parcelRequire("7ZZxN");

var $bNe1g = parcelRequire("bNe1g");


var $59o4i = parcelRequire("59o4i");

var $lB25E = parcelRequire("lB25E");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $b827a20051659108$export$fa3bc297af95f169 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("ILATv"))), {
    moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b827a20051659108$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b827a20051659108$export$fa3bc297af95f169,
        pageId: "project-settings-app-discovery-settings",
        shouldShowSpinner: false
    });



const $dde06fb051adc26f$export$246ec9cdadd2a163 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("jS5ct"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $dde06fb051adc26f$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
    return shouldRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
        push: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b827a20051659108$export$2e2bcd8739ae039), null);
};
const $dde06fb051adc26f$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dde06fb051adc26f$var$ConnectAppsRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dde06fb051adc26f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $dde06fb051adc26f$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $b464c86d98b57f45$export$3633e017e520a1c2 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("c3BLd"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b464c86d98b57f45$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b464c86d98b57f45$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $ba34a105ae8fb62a$export$9d468faf674a5201 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("gvLvJ")), {
    moduleId: "./src/packages/spa-apps/project-settings/connections/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ba34a105ae8fb62a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ba34a105ae8fb62a$export$9d468faf674a5201,
        pageId: "devops-connections-settings",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $8f41cf732a1fc405$export$de293ea44d0410ca = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("cFo24"))), {
    moduleId: "./src/packages/spa-apps/project-settings/csm/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8f41cf732a1fc405$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8f41cf732a1fc405$export$de293ea44d0410ca,
        pageId: "project-settings-csm",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $ffcfbf688bad1c50$export$7e21d36a9d4548e6 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("dkNWL")), {
    moduleId: "./src/packages/spa-apps/project-settings/custom-filters/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ffcfbf688bad1c50$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ffcfbf688bad1c50$export$7e21d36a9d4548e6,
        pageId: "project-settings-custom-filters",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $ab8ddffeb833017d$export$b8abcf8aa8f4df56 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("74Iqa"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab8ddffeb833017d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ab8ddffeb833017d$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $55014e887c6e53d8$export$6f16b5efddd5c646 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("c642p"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$55014e887c6e53d8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $55014e887c6e53d8$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $e5402f581e17c9ca$export$e309780f520d125a = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("34M7x"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e5402f581e17c9ca$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e5402f581e17c9ca$export$e309780f520d125a,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $l90Gp = parcelRequire("l90Gp");

var $ixwgj = parcelRequire("ixwgj");

var $59o4i = parcelRequire("59o4i");

const $4cf1bb1e3f20f07f$export$ef66d3f49a9953d8 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("1yOoT")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $4cf1bb1e3f20f07f$export$33d85a1b2211b38 = [
    (0, $ixwgj.projectContextResourceWithCache),
    (0, $l90Gp.forgeProjectSettingsModuleResource)
];
const $4cf1bb1e3f20f07f$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4cf1bb1e3f20f07f$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
var $4cf1bb1e3f20f07f$export$2e2bcd8739ae039 = $4cf1bb1e3f20f07f$export$b943f48844c671a5;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $a823ae098f41111f$export$36dcfb52d47cb93a = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("e3u5r"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a823ae098f41111f$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a823ae098f41111f$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $f345a9b98bb36af2$export$dea5ad7e8eac12ae = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("bZFFJ")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f345a9b98bb36af2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f345a9b98bb36af2$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $4d907e26c708a2fe$export$ca5dba69148b337 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("7e4qI")), {
    moduleId: "./src/packages/spa-apps/project-settings/link-opsgenie/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4d907e26c708a2fe$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4d907e26c708a2fe$export$ca5dba69148b337,
        pageId: "link-opsgenie-page",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $8315385009b2701e$export$da4d608b99858bfc = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("gDRUr"))), {
    moduleId: "./src/packages/spa-apps/project-settings/next-gen-features/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8315385009b2701e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8315385009b2701e$export$da4d608b99858bfc,
        pageId: "project-settings-next-gen-features",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $43b053b48a4f88e5$export$ea7d73c94d9369f4 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("65jMk"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$43b053b48a4f88e5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $43b053b48a4f88e5$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

var $lB25E = parcelRequire("lB25E");

const $370b0b5abce37189$export$7eee4f97b7a1273 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("epDvb"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $370b0b5abce37189$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
const $370b0b5abce37189$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($370b0b5abce37189$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$370b0b5abce37189$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $370b0b5abce37189$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $2futN = parcelRequire("2futN");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");

var $lB25E = parcelRequire("lB25E");
const $d3544903dfb35bb2$export$b7262fe486f4b412 = 'core';
const $d3544903dfb35bb2$export$2954328f6207617a = 'software';
const $d3544903dfb35bb2$export$5575497f0592ee94 = 'servicedesk';
const $d3544903dfb35bb2$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $d3544903dfb35bb2$export$586756e5c0542a50 = (product)=>{
    if (product === $d3544903dfb35bb2$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $d3544903dfb35bb2$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $d3544903dfb35bb2$export$fb15a6ba8980fdac = ({ match: match })=>{
    const { data: data } = (0, $2futN.useJiraSoftwareProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if ((0, $1ybV0.ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) {
        if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
        });
        if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
        });
        if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
    });
};
const $d3544903dfb35bb2$export$f9befa0a4925b36d = ({ match: match })=>{
    const { data: data } = (0, $2futN.useJiraSoftwareProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if ((0, $1ybV0.ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) {
        if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
        });
        if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
        });
        if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $f45b19cba10dde76$export$40ff283c032abbc4 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("5tF7w")), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/card/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f45b19cba10dde76$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f45b19cba10dde76$export$40ff283c032abbc4,
        pageId: "board-settings-card",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $3e4476e542b17ea7$export$810ecaba1eb55cad = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("5kZuD")).then((module)=>module.InsightsSettingsPageLoader), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/insights/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3e4476e542b17ea7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3e4476e542b17ea7$export$810ecaba1eb55cad,
        pageId: "board-settings-insights",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $614d9ce626d4ee80$export$8eca5454e72ee961 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("62C1J")), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/roadmap/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$614d9ce626d4ee80$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $614d9ce626d4ee80$export$8eca5454e72ee961,
        pageId: "board-settings-roadmap",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $11bf8792bea72543$export$a7d63246a10aedd = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("gcYA0")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$11bf8792bea72543$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $11bf8792bea72543$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $5188faf12abd07fe$export$38414b624a749cec = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("5R9nY")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5188faf12abd07fe$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5188faf12abd07fe$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $569782473f887794$export$69a64a29d67ca160 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("6L9TO"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$569782473f887794$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $569782473f887794$export$69a64a29d67ca160,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $7vTKl = parcelRequire("7vTKl");



var $59o4i = parcelRequire("59o4i");
const $32a54e7cf7d2fc38$export$cd8964bea0e3c2 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $4e9c2113e71dd730$export$97bbdefcbe0571ac),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});

const $32a54e7cf7d2fc38$export$6960a46ebd209756 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("3G5SQ"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
});
const $32a54e7cf7d2fc38$export$4b75df09cc5b4e8e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $32a54e7cf7d2fc38$export$6960a46ebd209756,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $7f120fdbd168266c$export$cb608e3696682e76 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("5p5BW"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7f120fdbd168266c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7f120fdbd168266c$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $5b552fe98bc306e0$export$79fe16f960f3d89f = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("c1YRC"))), {
    moduleId: "./src/packages/spa-apps/project-settings/classic-features/src/index.tsx"
});
const $5b552fe98bc306e0$export$8e6f565615e921dd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5b552fe98bc306e0$export$79fe16f960f3d89f,
        pageId: "classic-features",
        shouldShowSpinner: true
    });


const $fc712355d0e1cea7$var$BoardSettingsRedirectToCSM = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/columns`,
        push: false
    });
const $fc712355d0e1cea7$var$RoadmapSettingsRedirectToTimelineSettings = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/timeline`,
        push: false
    });
const $fc712355d0e1cea7$var$SpaReleaseNoteRedirectToVersionDetails = ({ query: query })=>{
    const { version: versionId } = query;
    const { loading: loading, error: error, projectKey: projectKey } = (0, $a526b624614fa406$export$899fd1c46031ece8)();
    if (loading === false && error) return null;
    if (loading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: {
            pathname: `/projects/${projectKey}/versions/${versionId}/tab/release-report-all-issues`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
                isReleaseNoteModalOpen: true
            })
        }
    });
};
const $fc712355d0e1cea7$var$LegacyFrontendReleaseNoteRedirect = ({ query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: {
            pathname: '/secure/ReleaseNote.jspa',
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
                ...query,
                isRedirectedFromLegacy: true
            })
        }
    });
const $fc712355d0e1cea7$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $fc712355d0e1cea7$var$getUFOName = (name)=>$fc712355d0e1cea7$var$ufoNamesMap[name] || name;
const $fc712355d0e1cea7$var$commonRouteEntries = [
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$dde867834e4a9f47), {
        ufoName: $fc712355d0e1cea7$var$getUFOName(`${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-issuetypes`),
        component: (0, $a823ae098f41111f$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $a823ae098f41111f$export$36dcfb52d47cb93a)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$955e8eef6e3bccfb), {
        component: (0, $7f120fdbd168266c$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $a823ae098f41111f$export$36dcfb52d47cb93a)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$8ddc76f4b4e66b2b), {
        component: (0, $dde06fb051adc26f$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $dde06fb051adc26f$export$246ec9cdadd2a163)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$d9dea7be10efa583), {
        component: (0, $b464c86d98b57f45$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $b464c86d98b57f45$export$3633e017e520a1c2)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$18624b8612cb673d), {
        component: (0, $55014e887c6e53d8$export$2e2bcd8739ae039),
        skeleton: (0, $aHr8P.ProjectSettingsDetailsSkeleton),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $55014e887c6e53d8$export$6f16b5efddd5c646)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$ad2c16468a73b68), {
        ufoName: 'project-settings.fields.jsw-tmp',
        component: (0, $dnJL9.componentWithFG)('project_fields_page_for_tmp_-_mvp', (0, $e5402f581e17c9ca$export$2e2bcd8739ae039), (0, $dgH3j.default)),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            (0, $2AuYt.fieldSettingsRelayResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $e5402f581e17c9ca$export$e309780f520d125a)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$9d5b42fcb82012dd), {
        skeleton: (0, $aHr8P.ProjectSettingsAccessSkeleton),
        component: (0, $370b0b5abce37189$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $370b0b5abce37189$export$7eee4f97b7a1273)
        ],
        ufoName: 'project-settings.access'
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$d782b5257932a66d), {
        component: (0, $370b0b5abce37189$export$45346ed2aa24e3f3)(`/jira/${(0, $d3544903dfb35bb2$export$2954328f6207617a)}`),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $370b0b5abce37189$export$7eee4f97b7a1273)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$396cdbbd6f2abcea), {
        component: (0, $5188faf12abd07fe$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5188faf12abd07fe$export$38414b624a749cec)
        ],
        perfMetricKey: 'forms-settings'
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$394d8f4806a90d7), {
        component: (0, $11bf8792bea72543$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $11bf8792bea72543$export$a7d63246a10aedd)
        ],
        perfMetricKey: 'form-builder'
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$4d430aeb28b702f8), {
        ufoName: `project-settings-automation-${(0, $d3544903dfb35bb2$export$2954328f6207617a)}`,
        component: (0, $f345a9b98bb36af2$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f345a9b98bb36af2$export$dea5ad7e8eac12ae)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$61d54e538063bb07), {
        component: (0, $ab8ddffeb833017d$export$2e2bcd8739ae039),
        skeleton: (0, $aHr8P.ProjectSettingsDetailsSkeleton),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ab8ddffeb833017d$export$b8abcf8aa8f4df56)
        ]
    })
];
const $fc712355d0e1cea7$export$792d387b9973c378 = [
    ...$fc712355d0e1cea7$var$commonRouteEntries,
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$37e0dbac44df25b9), {
        component: (0, $55014e887c6e53d8$export$2e2bcd8739ae039),
        skeleton: (0, $aHr8P.ProjectSettingsDetailsSkeleton),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $55014e887c6e53d8$export$6f16b5efddd5c646)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$a598c3fe8cbf0c6c), {
        ufoName: 'project-settings.next-gen-features',
        component: (0, $8315385009b2701e$export$2e2bcd8739ae039),
        skeleton: (0, $aHr8P.ProjectSettingsFeaturesSkeleton),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $8315385009b2701e$export$da4d608b99858bfc)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$c1d1892d6c07135a), {
        ufoName: 'project-settings.software.notifications',
        component: (0, $569782473f887794$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $569782473f887794$export$69a64a29d67ca160)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$ff4977f79c273b29), {
        ufoName: 'project-settings.software.notifications.issue-logs',
        component: (0, $32a54e7cf7d2fc38$export$4b75df09cc5b4e8e),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $32a54e7cf7d2fc38$export$6960a46ebd209756)
        ],
        entryPoint () {
            return (0, $1ybV0.ff)('jlovep-692-changes-to-project-settings-notifications-page_jqk18') ? (0, $32a54e7cf7d2fc38$export$cd8964bea0e3c2) : undefined;
        }
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$c7039de5a4b78802), {
        component: (0, $2ijRB.default)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $4d907e26c708a2fe$export$2e2bcd8739ae039)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4d907e26c708a2fe$export$ca5dba69148b337)
        ],
        ufoName: 'project-settings.link-opsgenie'
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$4e4a4b8762b611), {
        component: (0, $2ijRB.default)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $4d907e26c708a2fe$export$2e2bcd8739ae039)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4d907e26c708a2fe$export$ca5dba69148b337)
        ],
        ufoName: 'project-settings.link-opsgenie'
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$e3e3877ec9c5e840), {
        component: (0, $2ijRB.default)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $ba34a105ae8fb62a$export$2e2bcd8739ae039)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            (0, $3BLIV.projectSettingsToolchainResource)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ba34a105ae8fb62a$export$9d468faf674a5201)
        ],
        ufoName: 'project-settings.devops-connections'
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$7dbc23deac9553d4), {
        component: (0, $2ijRB.default)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $ba34a105ae8fb62a$export$2e2bcd8739ae039)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource),
            (0, $3BLIV.projectSettingsToolchainResource)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ba34a105ae8fb62a$export$9d468faf674a5201)
        ],
        ufoName: 'project-settings.devops-connections'
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$d4bf23ba6f4199d7), {
        ufoName: 'classic-features-page',
        component: (0, $5b552fe98bc306e0$export$8e6f565615e921dd),
        skeleton: (0, $aHr8P.ProjectSettingsFeaturesSkeleton),
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5b552fe98bc306e0$export$79fe16f960f3d89f)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$5e2e0a895d6a14bd), {
        ufoName: 'project-settings.classic-issue-logs-page',
        component: (0, $32a54e7cf7d2fc38$export$4b75df09cc5b4e8e),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $32a54e7cf7d2fc38$export$6960a46ebd209756)
        ],
        entryPoint () {
            return (0, $1ybV0.ff)('jlovep-692-changes-to-project-settings-notifications-page_jqk18') ? (0, $32a54e7cf7d2fc38$export$cd8964bea0e3c2) : undefined;
        }
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$d4ed083331cb6e00), {
        component: (0, $43b053b48a4f88e5$export$2e2bcd8739ae039),
        skeleton: (0, $aHr8P.ProjectSettingsFeaturesSkeleton),
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5b552fe98bc306e0$export$79fe16f960f3d89f),
            (0, $43b053b48a4f88e5$export$ea7d73c94d9369f4)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$b2e044c3dffeca69), {
        component: (0, $d3544903dfb35bb2$export$fb15a6ba8980fdac),
        skeleton: (0, $aHr8P.ProjectSettingsFeaturesSkeleton),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$6ef734887b6da0c8), {
        resources: [
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        component: $fc712355d0e1cea7$var$LegacyFrontendReleaseNoteRedirect,
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.genericProjectSidebars),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$a9509017cabb1e30), {
        resources: [
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        component: $fc712355d0e1cea7$var$LegacyFrontendReleaseNoteRedirect,
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.genericProjectSidebars),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$a0223091962262d4), {
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        component: $fc712355d0e1cea7$var$SpaReleaseNoteRedirectToVersionDetails,
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.genericProjectSidebars),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$46e979217c179afd), {
        component: (0, $f345a9b98bb36af2$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f345a9b98bb36af2$export$dea5ad7e8eac12ae)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$2313ca001d58ab27), {
        component: (0, $5188faf12abd07fe$export$2e2bcd8739ae039),
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5188faf12abd07fe$export$38414b624a749cec)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$811ace4fee984f0e), {
        component: (0, $11bf8792bea72543$export$2e2bcd8739ae039),
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $11bf8792bea72543$export$a7d63246a10aedd)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$989ca67485551616), {
        component: $fc712355d0e1cea7$var$BoardSettingsRedirectToCSM,
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        isRedirect: true,
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$88e68eb447e3db49), {
        ufoName: 'software.next-gen.boards.column-status-mapping.page.load',
        component: (0, $8f41cf732a1fc405$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $8f41cf732a1fc405$export$de293ea44d0410ca)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$9bc9b345958a301c), {
        ufoName: 'project-settings.custom-filters',
        component: (0, $ffcfbf688bad1c50$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            (0, $a0UvO.customFiltersResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ffcfbf688bad1c50$export$7e21d36a9d4548e6)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$d3f185a361401db7), {
        ufoName: 'board-settings-apps.card-cover-settings-page.page.load',
        component: (0, $f45b19cba10dde76$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            (0, $hbnZD.cardCoverImageResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f45b19cba10dde76$export$40ff283c032abbc4)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$17ccdaa366ec26b8), {
        component: $fc712355d0e1cea7$var$RoadmapSettingsRedirectToTimelineSettings,
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            (0, $a3WTo.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $614d9ce626d4ee80$export$8eca5454e72ee961)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$e116d6b2a5f71426), {
        ufoName: 'board-settings-apps.roadmap-settings-page.page.load',
        component: (0, $614d9ce626d4ee80$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            (0, $a3WTo.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $614d9ce626d4ee80$export$8eca5454e72ee961)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$ae89a2a3aaf095ef), {
        ufoName: 'project-settings-automation-c',
        component: (0, $f345a9b98bb36af2$export$2e2bcd8739ae039),
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.genericProjectSidebars),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f345a9b98bb36af2$export$dea5ad7e8eac12ae)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$f74a0b1be9d5b9f6), {
        component: (0, $4cf1bb1e3f20f07f$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $4cf1bb1e3f20f07f$export$33d85a1b2211b38)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4cf1bb1e3f20f07f$export$ef66d3f49a9953d8)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$1a2cbdfba83d21b), {
        ufoName: 'board-settings-apps.insights-settings-page.page.load',
        component: (0, $dnJL9.componentWithFG)('remove_jsw_insights_settings_ui', (0, $d3544903dfb35bb2$export$fb15a6ba8980fdac), (0, $3e4476e542b17ea7$export$2e2bcd8739ae039)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            (0, $dCvLw.insightsBoardSettingsResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $3e4476e542b17ea7$export$810ecaba1eb55cad)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$8559c4a0b692890e), {
        component: (0, $4cf1bb1e3f20f07f$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            ...(0, $4cf1bb1e3f20f07f$export$33d85a1b2211b38)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4cf1bb1e3f20f07f$export$ef66d3f49a9953d8)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$7ce9914683cb1572), {
        component: (0, $d3544903dfb35bb2$export$fb15a6ba8980fdac),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $bMm60.createEntry)((0, $4b91e3ee82bc8bc2$export$99b695c2b8299b5a), {
        component: (0, $d3544903dfb35bb2$export$f9befa0a4925b36d),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    })
];


const $048cfffd237f6510$export$fd0ef3739cde76c1 = [
    ...(0, $fc712355d0e1cea7$export$792d387b9973c378),
    ...(0, $0ffaa8ee5786ed66$export$37a8204dc4094049),
    ...(0, $e3dc9036898dfae5$export$4bad3905623f839b)
];




var $cernH = parcelRequire("cernH");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $gGtKh = parcelRequire("gGtKh");

const $9bf9668bc89dcf42$var$LazyViewsNav = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("2tF49")).then(({ ViewsBaseNav: ViewsBaseNav })=>ViewsBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/views/src/ui/index.tsx"
});
const $9bf9668bc89dcf42$export$b43adc74b6a33bde = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-jsm-views-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9bf9668bc89dcf42$var$LazyViewsNav, null));



var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $a5edq = parcelRequire("a5edq");

var $dAKwA = parcelRequire("dAKwA");

var $ixwgj = parcelRequire("ixwgj");

var $kbHFR = parcelRequire("kbHFR");

var $ioEMP = parcelRequire("ioEMP");

var $jwzNs = parcelRequire("jwzNs");

var $gcXWF = parcelRequire("gcXWF");

var $csLgO = parcelRequire("csLgO");


var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $6VZoe = parcelRequire("6VZoe");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");


var $59o4i = parcelRequire("59o4i");

var $lB25E = parcelRequire("lB25E");

const $5c8e0d92b8478780$export$bb5ed4e7838cf30c = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("2VE1N"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/board/src/index.tsx"
});

const $5c8e0d92b8478780$export$6828c4b2d0ff0d5d = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("59qvl"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/legacy-board-settings/src/index.tsx"
});
const $5c8e0d92b8478780$export$f058c0d1561d67f3 = (props)=>{
    const { route: route, query: query } = props;
    if (route.name !== (0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS)) return null;
    const allowedConfigurations = [
        'columns',
        'filter',
        'quickFilters',
        'swimlanes',
        'cardColors',
        'cardLayout',
        ...(0, $1ybV0.ff)('jsm-board-settings-date-fields-tab_d75f4') ? [
            'dateFields'
        ] : []
    ];
    if (query.config && !allowedConfigurations.includes(query.config)) {
        const { config: config, ...restQuery } = query;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: {
                pathname: props.location.pathname,
                hash: '',
                search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
                    ...restQuery,
                    config: 'columns'
                })
            }
        });
    }
    return query.config ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5c8e0d92b8478780$export$6828c4b2d0ff0d5d,
        pageId: "spa-apps/servicedesk/boards/legacy-board-settings",
        shouldShowSpinner: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5c8e0d92b8478780$export$bb5ed4e7838cf30c,
        pageId: "spa-apps/servicedesk/boards/board",
        shouldShowSpinner: true
    });
};


const $2d3841ea93833e60$export$848a32cf0fcf8a61 = (0, $bMm60.createEntry)((0, $gcXWF.jsmBoardRoute), {
    component: (0, $5c8e0d92b8478780$export$f058c0d1561d67f3),
    layout: (0, $csLgO.serviceProjectLayout),
    skeleton: (0, $e97d2ead64a3cd9f$export$631611c5fdf027d5),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $5c8e0d92b8478780$export$bb5ed4e7838cf30c),
        (0, $5c8e0d92b8478780$export$6828c4b2d0ff0d5d)
    ],
    perfMetricKey: 'servicedesk-boards-load',
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default),
        horizontal: (0, $9bf9668bc89dcf42$export$b43adc74b6a33bde),
        horizontalFeatureFlag: 'jsm_views_of_work_phase_1'
    },
    resources: [
        ...(0, $kbHFR.getServiceDeskNavigationResources)(),
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $dAKwA.getConsolidationStateResource)(),
        ...(0, $a5edq.getRapidboardResources)(),
        (0, $a5edq.getRapidBoardDataResource)(),
        (0, $jwzNs.resourceWithCondition2)(()=>!false, (0, $ioEMP.uifBoardResource)),
        (0, $ixwgj.projectContextResource)
    ]
});
const $2d3841ea93833e60$export$97cc5f4d7ce032e1 = [
    $2d3841ea93833e60$export$848a32cf0fcf8a61
];



var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");
var $bAQOb = parcelRequire("bAQOb");


var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $fILpt = parcelRequire("fILpt");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $3e5f137bedbc111a$export$a47f5c93b8a4b678 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR_EAP),
    path: '/jira/servicedesk/projects/:projectKey/calendar',
    exact: true
};
const $3e5f137bedbc111a$export$28a386a00670c893 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR),
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/calendar',
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $f8583736be8fc5c7$exports = {};
$f8583736be8fc5c7$exports = new URL("classic-calendar-skeleton.tpl.3dcfde16.svg", import.meta.url).toString();


const $293e8909018b8407$export$49d3670908a8d8fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f8583736be8fc5c7$exports)))
    });




var $7vTKl = parcelRequire("7vTKl");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $fca2cbe2cad21ee5$export$d55f72843fab18f1 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("3SuBN")), {
        moduleId: "8920c8a8"
    }),
    getPreloadProps: ()=>({})
});



var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");


var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");
// This is the key used to store the calendar filters in the local storage
const $0efe2bd1b77b88ef$var$ISSUE_SEARCH_INPUT_STORAGE_KEY = 'calendar-issue-search-input';
// This is the key used to store the calendar view settings in the local storage
const $0efe2bd1b77b88ef$var$VIEW_SETTINGS_STORAGE_KEY = 'calendar-view-settings';
function $0efe2bd1b77b88ef$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $0efe2bd1b77b88ef$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $0efe2bd1b77b88ef$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $0efe2bd1b77b88ef$var$createScope({ context: context, tenantContext: tenantContext }, viewId) {
    const { cloudId: cloudId } = tenantContext;
    return {
        type: 'board',
        boardId: $0efe2bd1b77b88ef$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: [
            String(context.match.params.projectKey)
        ],
        viewId: viewId
    };
}
function $0efe2bd1b77b88ef$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        ids: [
            scope.boardId
        ],
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $0efe2bd1b77b88ef$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $0efe2bd1b77b88ef$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $0efe2bd1b77b88ef$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, viewId: viewId }) {
    return {
        date: $0efe2bd1b77b88ef$var$toMidnightUTCString(selectedDate),
        mode: $0efe2bd1b77b88ef$var$toViewMode(viewRange),
        weekStart: $0efe2bd1b77b88ef$var$toWeekStart(weekStartsOn),
        viewId: viewId
    };
}
function $0efe2bd1b77b88ef$var$buildStorageKey({ cloudId: cloudId, activationId: activationId, boardId: boardId, featureKey: featureKey }) {
    const viewId = $0efe2bd1b77b88ef$var$buildViewId({
        cloudId: cloudId,
        activationId: activationId,
        boardId: boardId
    });
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/view/${viewId}/${featureKey}`;
}
function $0efe2bd1b77b88ef$var$getStorageValue(storageKey) {
    // window check is needed because this code is also executed on the SSR
    if (typeof window !== 'undefined') return localStorage?.getItem(storageKey) || '';
    return '';
}
function $0efe2bd1b77b88ef$var$buildIssuesSearchInputNew(storageKey) {
    return {
        additionalFilterQuery: $0efe2bd1b77b88ef$var$getStorageValue(storageKey) || ''
    };
}
function $0efe2bd1b77b88ef$var$buildIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $0efe2bd1b77b88ef$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $0efe2bd1b77b88ef$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $0efe2bd1b77b88ef$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}
function $0efe2bd1b77b88ef$var$buildViewId({ cloudId: cloudId, activationId: activationId, boardId: boardId }) {
    // https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Ajira%3Aview
    return `ari:cloud:jira:${cloudId}:view/activation/${activationId}/board/${boardId}`;
}

const $0efe2bd1b77b88ef$export$19cf4b398f638dc6 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("hFzUG")), {
        moduleId: "7a55ad65"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const { date: date } = context.query;
        const selectedDate = $0efe2bd1b77b88ef$var$toDate(date);
        const { boardId: boardId, projectKey: projectKey } = context.match.params;
        if (!boardId || !projectKey) throw new Error('boardId and projectKey must be provided.');
        const viewId = (0, $1ybV0.ff)('jsm-board-settings-date-fields-tab_d75f4') ? $0efe2bd1b77b88ef$var$buildViewId({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId
        }) : null;
        const scope = $0efe2bd1b77b88ef$var$createScope(entryPointRouteParams, viewId || '');
        const storageKeyForIssueSearchInput = (0, $1ybV0.ff)('jsm-calendar-config-persist_orut6') ? $0efe2bd1b77b88ef$var$buildStorageKey({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId,
            featureKey: $0efe2bd1b77b88ef$var$ISSUE_SEARCH_INPUT_STORAGE_KEY
        }) : '';
        const storageKeyForViewSettings = (0, $1ybV0.ff)('jsm-calendar-config-persist_orut6') ? $0efe2bd1b77b88ef$var$buildStorageKey({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId,
            featureKey: $0efe2bd1b77b88ef$var$VIEW_SETTINGS_STORAGE_KEY
        }) : '';
        let viewSettingsConfig = {
            weekStartsOn: null,
            showWeekends: false,
            showIssueKey: true,
            showIn24HourClock: false
        };
        if ((0, $1ybV0.ff)('jsm-calendar-config-persist_orut6')) {
            const storedConfig = $0efe2bd1b77b88ef$var$getStorageValue(storageKeyForViewSettings);
            viewSettingsConfig = storedConfig ? JSON.parse(storedConfig) : {};
        }
        const viewRange = 'month';
        const weekStartsOn = (0, $1ybV0.ff)('jsm-calendar-config-persist_orut6') ? viewSettingsConfig.weekStartsOn ?? 'sunday' : 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const issuesSearchInput = (0, $1ybV0.ff)('jsm-calendar-config-persist_orut6') ? $0efe2bd1b77b88ef$var$buildIssuesSearchInputNew(storageKeyForIssueSearchInput) : $0efe2bd1b77b88ef$var$buildIssuesSearchInput();
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $ae4d1c21cb10f5ab$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $0efe2bd1b77b88ef$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $0efe2bd1b77b88ef$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            viewId: viewId
                        }),
                        issuesSearchInput: issuesSearchInput,
                        unscheduledIssuesSearchInput: $0efe2bd1b77b88ef$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $0efe2bd1b77b88ef$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $0efe2bd1b77b88ef$var$buildSprintsSearchInput(),
                        skipSprintSearch: false,
                        skipVersionSearch: false,
                        viewId: viewId,
                        ...(0, $eI5EY.fg)('jsd_shield_jsm_calendar_weekly_view') && {
                            skipFieldConfig: false
                        },
                        schedulePermissionsEnabled: (0, $eI5EY.fg)('calendar_schedule_issue_permissions_check')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                projectKey: projectKey,
                storageKeyForViewSettings: storageKeyForViewSettings,
                storageKeyForIssueSearchInput: storageKeyForIssueSearchInput,
                showWeekends: viewSettingsConfig.showWeekends,
                showIssueKey: viewSettingsConfig.showIssueKey,
                showIn24HourClock: viewSettingsConfig.showIn24HourClock
            }
        };
    }
});


const $c7dc61a1d5caf586$export$3d0fc2d19e97ca21 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $fca2cbe2cad21ee5$export$d55f72843fab18f1),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $c7dc61a1d5caf586$export$eda0c2fb67f7d7e7 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $0efe2bd1b77b88ef$export$19cf4b398f638dc6),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});


const $08d75f6faff765b2$export$6e125037f42a1f62 = [
    (0, $bMm60.createEntry)((0, $3e5f137bedbc111a$export$a47f5c93b8a4b678), {
        ufoName: 'jsm.calendar',
        component: (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('jsm-calendar-view_bplvu') || (0, $1ybV0.ff)('jsm-calendar-ga_81o9m'), ()=>null, (0, $dgH3j.default)),
        skeleton: (0, $293e8909018b8407$export$49d3670908a8d8fe),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $1ybV0.ff)('jsm-calendar-view_bplvu') || (0, $1ybV0.ff)('jsm-calendar-ga_81o9m') ? (0, $c7dc61a1d5caf586$export$3d0fc2d19e97ca21) : undefined,
        meta: {
            reporting: {
                id: 'calendar',
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CALENDAR),
                teamName: 'jsd-shield'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $3e5f137bedbc111a$export$28a386a00670c893), {
        ufoName: 'jsm-calendar',
        component: (0, $bAQOb.componentWithFF)('jsm-calendar-ga_81o9m', ()=>null, (0, $dgH3j.default)),
        skeleton: (0, $293e8909018b8407$export$49d3670908a8d8fe),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $9bf9668bc89dcf42$export$b43adc74b6a33bde),
            horizontalFeatureFlag: 'jsm_views_of_work_phase_1'
        },
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)(),
            (0, $fILpt.getCalendarFilterFieldsResource)()
        ],
        entryPoint: ()=>(0, $1ybV0.ff)('jsm-calendar-ga_81o9m') ? (0, $c7dc61a1d5caf586$export$eda0c2fb67f7d7e7) : undefined,
        meta: {
            reporting: {
                id: 'calendar',
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CALENDAR),
                teamName: 'jsd-shield'
            }
        }
    })
];



var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $46bb9ae4a6cbb829$export$d9802671a2b1aa20 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("2gjhx")).then(({ JSMOperationsHorizontalNav: JSMOperationsHorizontalNav })=>JSMOperationsHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/operations/src/ui/index.tsx"
});
const $46bb9ae4a6cbb829$export$d4493569f106c71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-operations-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "asyncHorizontalOperationsNav",
        packageName: "jiraHorizontalNavJsmOperations",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46bb9ae4a6cbb829$export$d9802671a2b1aa20, null)));



var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $aspp6 = parcelRequire("aspp6");

var $kbHFR = parcelRequire("kbHFR");

var $jwzNs = parcelRequire("jwzNs");

var $k0e1o = parcelRequire("k0e1o");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $ff89065b17fb0b7a$export$a6cec2d1c2e631eb = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("1o2nL"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/change-calendar/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff89065b17fb0b7a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ff89065b17fb0b7a$export$a6cec2d1c2e631eb,
        pageId: "spa-apps/servicedesk/change-calendar",
        shouldShowSpinner: true
    });


const $37ff03730865f0e2$export$38a3aa80b813d565 = [
    (0, $bMm60.createEntry)((0, $k0e1o.servicedeskChangeCalendarRoute), {
        ufoName: 'service-management.change-calendar',
        component: (0, $ff89065b17fb0b7a$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $46bb9ae4a6cbb829$export$d4493569f106c71),
            onlyShowHorziontalOnNav4: true
        },
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)(),
            (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9'), (0, $aspp6.jsmRepackagingBannerResource))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ff89065b17fb0b7a$export$a6cec2d1c2e631eb),
            (0, $46bb9ae4a6cbb829$export$d9802671a2b1aa20)
        ],
        meta: {
            reporting: {
                id: 'changeCalendar',
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CHANGE_CALENDAR),
                teamName: 'jenga'
            }
        }
    })
];



var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $9zysr = parcelRequire("9zysr");
var $bAQOb = parcelRequire("bAQOb");

var $eI5EY = parcelRequire("eI5EY");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $9RvDp = parcelRequire("9RvDp");

var $av9ef = parcelRequire("av9ef");

const $b745bc543ebd3bd3$export$2260a0528570f8da = (0, $6VZoe.lazyForPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("N1heu")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/assets-reports/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b745bc543ebd3bd3$var$AssetsReportsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "assets-reports-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b745bc543ebd3bd3$export$2260a0528570f8da, null)));
$b745bc543ebd3bd3$var$AssetsReportsSidebar.displayName = 'AssetsReportsSidebar';
var $b745bc543ebd3bd3$export$2e2bcd8739ae039 = $b745bc543ebd3bd3$var$AssetsReportsSidebar;



var $6FP8W = parcelRequire("6FP8W");

var $bMm60 = parcelRequire("bMm60");

var $c4Cxp = parcelRequire("c4Cxp");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");

var $2R39g = parcelRequire("2R39g");

var $jwzNs = parcelRequire("jwzNs");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $310955c5909c4e4e$export$152b5dead07808bc = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/assets',
    exact: true
};
const $310955c5909c4e4e$export$1efada07b7203f2d = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/insight',
    exact: true
};
const $310955c5909c4e4e$export$8629431cf690fe39 = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/assets/reports',
    exact: true
};
const $310955c5909c4e4e$export$a075d8b7c4c55c41 = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/assets/reports/:templateId',
    exact: true
};
const $310955c5909c4e4e$export$66ab60d374e8e458 = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/assets/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};
const $310955c5909c4e4e$export$246ae573df78317e = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/assets/object-schema/:objectSchemaId'
};
const $310955c5909c4e4e$export$fcde60ded71d4ae6 = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/insight/object-schemas/:objectSchemaId'
};
const $310955c5909c4e4e$export$73b901e16d5e5a02 = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/assets/configure/object-type/:objectTypeId'
};
const $310955c5909c4e4e$export$12e89d5d79d59785 = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/insight/configure/object-type/:objectTypeId'
};
const $310955c5909c4e4e$export$9f6d42997c66cc4b = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/assets/configure/global'
};
const $310955c5909c4e4e$export$96e5da52356f214c = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/insight/configure/global'
};
const $310955c5909c4e4e$export$b4a150d67181752 = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/assets/configure/object-schema/:objectSchemaId'
};
const $310955c5909c4e4e$export$f6b688a8729943b3 = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/insight/configure/object-schema/:objectSchemaId'
};
const $310955c5909c4e4e$export$e960ab4fcd3e80b6 = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/insight/configure'
};
const $310955c5909c4e4e$export$620f0fb687461e6 = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/assets/object/:objectId'
};
const $310955c5909c4e4e$export$223f5bacfd3d39fd = {
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT),
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/insight/assets/:objectId'
};



var $frZnw = parcelRequire("frZnw");

var $cV47S = parcelRequire("cV47S");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $7fbd4565ada151c8$export$8075d4042713bf6d = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("1xdVV")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure/src/index.tsx"
});
const $7fbd4565ada151c8$var$InsightConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7fbd4565ada151c8$export$8075d4042713bf6d,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
var $7fbd4565ada151c8$export$2e2bcd8739ae039 = $7fbd4565ada151c8$var$InsightConfigure;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $48483626dba3f677$export$926956539e1f72ba = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("kYbZu")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-object-type/src/index.tsx"
});
const $48483626dba3f677$var$InsightConfigureObjectType = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $48483626dba3f677$export$926956539e1f72ba,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure-object-type",
        shouldShowSpinner: true
    });
var $48483626dba3f677$export$2e2bcd8739ae039 = $48483626dba3f677$var$InsightConfigureObjectType;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $f23807fe571bd87e$export$b80bd807bad3fd0a = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("5yuvk")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-v2/src/index.tsx"
});
const $f23807fe571bd87e$var$GlobalConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f23807fe571bd87e$export$b80bd807bad3fd0a,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
var $f23807fe571bd87e$export$2e2bcd8739ae039 = $f23807fe571bd87e$var$GlobalConfigure;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $871b48bcf51415f4$export$f6c79e6ff37913ee = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("elg6g")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-landing-page/src/index.tsx"
});
const $871b48bcf51415f4$var$LandingPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $871b48bcf51415f4$export$f6c79e6ff37913ee,
        pageId: "spa-apps/servicedesk/insight/cmdb-landing-page",
        shouldShowSpinner: true
    });
var $871b48bcf51415f4$export$2e2bcd8739ae039 = $871b48bcf51415f4$var$LandingPage;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $06db742a65e6a624$export$411c1981ced22249 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("80TdY")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-v2/src/index.tsx"
});
const $06db742a65e6a624$export$3c208f927c6178ee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $06db742a65e6a624$export$411c1981ced22249,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-v2",
        shouldShowSpinner: true
    });
var $06db742a65e6a624$export$2e2bcd8739ae039 = $06db742a65e6a624$export$3c208f927c6178ee;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $9f4ca56c5db12e34$export$1e50d5a65ac4f5fc = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("gdgF7")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-v2/src/index.tsx"
});
const $9f4ca56c5db12e34$export$f90a4f33c79fd86e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9f4ca56c5db12e34$export$1e50d5a65ac4f5fc,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema",
        shouldShowSpinner: true
    });
var $9f4ca56c5db12e34$export$2e2bcd8739ae039 = $9f4ca56c5db12e34$export$f90a4f33c79fd86e;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $dd6bd5053e9cd5f1$export$8305a1bc1c5bee45 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("kq8if")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-configuration/src/index.tsx"
});
const $dd6bd5053e9cd5f1$var$ObjectSchemaConfiguration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $dd6bd5053e9cd5f1$export$8305a1bc1c5bee45,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema-configuration",
        shouldShowSpinner: true
    });
var $dd6bd5053e9cd5f1$export$2e2bcd8739ae039 = $dd6bd5053e9cd5f1$var$ObjectSchemaConfiguration;



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $5b5a57424a20f348$export$9f75cdfdfe8c8aaa = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("f4fU7")).then((exportedMembers)=>exportedMembers.CmdbAssetsReports), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});

const $5b5a57424a20f348$export$2534c3e9f8e70d0d = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("f4fU7")).then((exportedMembers)=>exportedMembers.CmdbDefaultReportsRedirect), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});

const $5b5a57424a20f348$export$dec85f15dd805ac4 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("TEE6P")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports-unsubscribe/src/index.tsx"
});

const $5b5a57424a20f348$export$c56cfef9aa68df09 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("f4fU7")).then((exportedMembers)=>exportedMembers.CmdbAssetsReportsNav4HomePage), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});
const $5b5a57424a20f348$export$d45b40d40442434 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5b5a57424a20f348$export$9f75cdfdfe8c8aaa,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports",
        shouldShowSpinner: true
    });
const $5b5a57424a20f348$export$541b39e6d5be07df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5b5a57424a20f348$export$dec85f15dd805ac4,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe",
        shouldShowSpinner: true
    });
const $5b5a57424a20f348$export$4155da54bfeacf74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5b5a57424a20f348$export$2534c3e9f8e70d0d,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-default-redirect",
        shouldShowSpinner: true
    });
const $5b5a57424a20f348$export$9d28551695f98cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5b5a57424a20f348$export$c56cfef9aa68df09,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-home-page",
        shouldShowSpinner: true
    });


const $c14f7e8a0471589a$var$sharedRouteProps = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).INSIGHT
    }
};
function $c14f7e8a0471589a$var$getCmdbResources() {
    const servicedeskPageContextResources = (0, $kbHFR.getServicedeskPageContextResources)().map((resource)=>(0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('add_service_desk_page_context_resources'), resource));
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...servicedeskPageContextResources,
        (0, $cV47S.workspaceResource)
    ];
}
const $c14f7e8a0471589a$export$5d38cb53852f589a = [
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$152b5dead07808bc), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $871b48bcf51415f4$export$2e2bcd8739ae039),
        resources: $c14f7e8a0471589a$var$getCmdbResources(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $871b48bcf51415f4$export$f6c79e6ff37913ee)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$1efada07b7203f2d), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $871b48bcf51415f4$export$2e2bcd8739ae039),
        resources: $c14f7e8a0471589a$var$getCmdbResources(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $871b48bcf51415f4$export$f6c79e6ff37913ee)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$8629431cf690fe39), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), (0, $5b5a57424a20f348$export$9d28551695f98cae), (0, $5b5a57424a20f348$export$4155da54bfeacf74)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5b5a57424a20f348$export$2534c3e9f8e70d0d),
            (0, $5b5a57424a20f348$export$c56cfef9aa68df09)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                teamName: 'ITSM SAGA'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$a075d8b7c4c55c41), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $bAQOb.componentWithFF)('jsm-assets-reporting_seqk0', (0, $5b5a57424a20f348$export$d45b40d40442434), (0, $dgH3j.default)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5b5a57424a20f348$export$9f75cdfdfe8c8aaa)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PEOPLE,
            sidebar: (0, $b745bc543ebd3bd3$export$2e2bcd8739ae039)
        },
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_ASSETS_REPORTS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_ASSETS_REPORTS),
                teamName: 'ITSM SAGA'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$66ab60d374e8e458), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $5b5a57424a20f348$export$541b39e6d5be07df),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5b5a57424a20f348$export$dec85f15dd805ac4)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                teamName: 'ITSM SAGA'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$246ae573df78317e), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $9f4ca56c5db12e34$export$f90a4f33c79fd86e),
        resources: $c14f7e8a0471589a$var$getCmdbResources(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9f4ca56c5db12e34$export$1e50d5a65ac4f5fc)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$fcde60ded71d4ae6), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $9f4ca56c5db12e34$export$f90a4f33c79fd86e),
        resources: $c14f7e8a0471589a$var$getCmdbResources(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9f4ca56c5db12e34$export$1e50d5a65ac4f5fc)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$73b901e16d5e5a02), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $48483626dba3f677$export$2e2bcd8739ae039),
        resources: $c14f7e8a0471589a$var$getCmdbResources(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $48483626dba3f677$export$926956539e1f72ba)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'falcons'
            }
        },
        ufoName: 'service-management.insight-cmdb-object-type-configuration'
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$12e89d5d79d59785), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $48483626dba3f677$export$2e2bcd8739ae039),
        resources: $c14f7e8a0471589a$var$getCmdbResources(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $48483626dba3f677$export$926956539e1f72ba)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'falcons'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$9f6d42997c66cc4b), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        ufoName: 'servicedesk-cmdb-assets-configure',
        component: (0, $f23807fe571bd87e$export$2e2bcd8739ae039),
        resources: $c14f7e8a0471589a$var$getCmdbResources(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f23807fe571bd87e$export$b80bd807bad3fd0a)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'falcons'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$96e5da52356f214c), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        ufoName: 'servicedesk-cmdb-insight-configure-global',
        component: (0, $f23807fe571bd87e$export$2e2bcd8739ae039),
        resources: $c14f7e8a0471589a$var$getCmdbResources(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f23807fe571bd87e$export$b80bd807bad3fd0a)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'falcons'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$b4a150d67181752), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $dd6bd5053e9cd5f1$export$2e2bcd8739ae039),
        resources: [
            ...$c14f7e8a0471589a$var$getCmdbResources(),
            (0, $c4Cxp.serviceDeskAssetsImportTypeForgeDataResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $dd6bd5053e9cd5f1$export$8305a1bc1c5bee45)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$f6b688a8729943b3), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $dd6bd5053e9cd5f1$export$2e2bcd8739ae039),
        resources: $c14f7e8a0471589a$var$getCmdbResources(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $dd6bd5053e9cd5f1$export$8305a1bc1c5bee45)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$e960ab4fcd3e80b6), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        ufoName: 'servicedesk-cmdb-insight-configure',
        component: (0, $7fbd4565ada151c8$export$2e2bcd8739ae039),
        resources: $c14f7e8a0471589a$var$getCmdbResources(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7fbd4565ada151c8$export$8075d4042713bf6d)
        ]
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$620f0fb687461e6), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $06db742a65e6a624$export$3c208f927c6178ee),
        resources: [
            ...$c14f7e8a0471589a$var$getCmdbResources(),
            (0, $2R39g.insightObjectResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $06db742a65e6a624$export$411c1981ced22249)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    }),
    (0, $bMm60.createEntry)((0, $310955c5909c4e4e$export$223f5bacfd3d39fd), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $06db742a65e6a624$export$3c208f927c6178ee),
        resources: [
            ...$c14f7e8a0471589a$var$getCmdbResources(),
            (0, $2R39g.insightObjectResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $06db742a65e6a624$export$411c1981ced22249)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $8566d343b6c4211f$export$1f409a894343952a = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT),
    path: '/jira/servicedesk/create-project',
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $59o4i = parcelRequire("59o4i");

const $2931ee7f95d0e303$export$5004e0d4f1e57790 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("9D9ow")), {
    moduleId: "./src/packages/spa-apps/servicedesk/create-project/src/index.tsx"
});
const $2931ee7f95d0e303$export$ffae8a2776195524 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2931ee7f95d0e303$export$5004e0d4f1e57790,
        pageId: "spa-apps/servicedesk/create-project",
        shouldShowSpinner: true
    });
const $2931ee7f95d0e303$export$ac25abe07ac3f570 = (0, $bMm60.createEntry)((0, $8566d343b6c4211f$export$1f409a894343952a), {
    isRedirect: true,
    component: $2931ee7f95d0e303$export$ffae8a2776195524,
    layout: (0, $csLgO.serviceProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $2931ee7f95d0e303$export$5004e0d4f1e57790
    ],
    meta: {
        reporting: {
            id: (0, $frZnw.APP_NAMES).CREATE_PROJECT,
            packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CREATE_PROJECT),
            teamName: 'itops-mithril'
        }
    }
});



var $cernH = parcelRequire("cernH");


var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $cgHBu = parcelRequire("cgHBu");

var $77XtT = parcelRequire("77XtT");

var $fjxAH = parcelRequire("fjxAH");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $1fae4e90433595fb$export$864b519a4059ac6b = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("ecIPx"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customers-v2/src/index.tsx"
});
const $1fae4e90433595fb$export$ac54d7814cf71dd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1fae4e90433595fb$export$864b519a4059ac6b,
        pageId: "spa-apps/servicedesk/customers-v2",
        shouldShowSpinner: true
    });

const $1fae4e90433595fb$export$6c5749ec31de847d = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("4ENX4"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-details/src/index.tsx"
});
const $1fae4e90433595fb$export$2412523c0e3657cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1fae4e90433595fb$export$6c5749ec31de847d,
        pageId: "spa-apps/servicedesk/customer-details",
        shouldShowSpinner: true
    });


const $b011af7098605060$var$getCustomersRoutesCommon = ()=>({
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ]
    });
const $b011af7098605060$export$6811a8ea7ba7651c = [
    (0, $bMm60.createEntry)((0, $fjxAH.servicedeskCustomerDetailsRoute), {
        ...$b011af7098605060$var$getCustomersRoutesCommon(),
        component: (0, $1fae4e90433595fb$export$2412523c0e3657cc),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1fae4e90433595fb$export$6c5749ec31de847d)
        ],
        perfMetricKey: 'jsm-customer-details-component-load',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).CUSTOMER_DETAILS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CUSTOMER_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...$b011af7098605060$var$getCustomersRoutesCommon().resources,
            (0, $cgHBu.entitlementsCustomerQueryResource),
            (0, $77XtT.uiCustomerDetailsPageQueryResource)
        ]
    }),
    (0, $bMm60.createEntry)((0, $fjxAH.servicedeskCustomersV2Route), {
        ...$b011af7098605060$var$getCustomersRoutesCommon(),
        component: (0, $1fae4e90433595fb$export$ac54d7814cf71dd),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1fae4e90433595fb$export$864b519a4059ac6b)
        ],
        perfMetricKey: 'jsm-customers-component-load',
        ufoName: 'jsm-customers-component-load',
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $eec12bcff4bffa70$export$a237f415539577a5),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorziontalOnNav4: true
        }
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $4mBNF = parcelRequire("4mBNF");

var $1a6Wh = parcelRequire("1a6Wh");

var $csLgO = parcelRequire("csLgO");
const $f1fa06bfbcc25698$export$8810bfd4f6a0eb22 = (0, $bMm60.createEntry)((0, $1a6Wh.projectServiceDeskRoute), {
    isRedirect: true,
    component: (0, $4mBNF.RedirectToLastVisitedProjectPage),
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $kbHFR.getServiceDeskNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});




var $1ybV0 = parcelRequire("1ybV0");

var $7vTKl = parcelRequire("7vTKl");

var $kXWpU = parcelRequire("kXWpU");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $kbHFR = parcelRequire("kbHFR");

var $47r3J = parcelRequire("47r3J");

var $dgH3j = parcelRequire("dgH3j");

var $kOAof = parcelRequire("kOAof");

var $csLgO = parcelRequire("csLgO");
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $d5efe34539370fcc$exports = {};
$d5efe34539370fcc$exports = new URL("getting-started-page-app-skeleton.tpl.b9c0d034.svg", import.meta.url).toString();


const $5ed68f414dfe3b03$var$customCssStyles = null;
const $5ed68f414dfe3b03$export$525669daa9599ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d5efe34539370fcc$exports))),
        className: (0, $7JEyt.default)([
            "_rcuj1wug _o81c1wug _1l6u1wug _149m1wug _701wukw8 _9qarbrur"
        ])
    });



var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $848d27189a48d1f7$export$a91a58d8bb93ad8e = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("8IADa")), {
        moduleId: "99c912b0"
    }),
    getPreloadProps: ()=>({})
});


const $72b362d5e9f1af01$var$gettingStartedPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $848d27189a48d1f7$export$a91a58d8bb93ad8e),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $72b362d5e9f1af01$export$9f5707c751b4b364 = (0, $bMm60.createEntry)((0, $kOAof.gspPageRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    perfMetricKey: 'servicedesk-getting-started-page-load',
    skeleton: (0, $5ed68f414dfe3b03$export$525669daa9599ec),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $kbHFR.getServiceDeskNavigationResources)(),
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $kXWpU.staticProjectSidebarNavigationResource),
        (0, $47r3J.servicedeskIssueTypesResource)
    ],
    entryPoint () {
        return (0, $1ybV0.ff)('getting_started_page_production_rollout') ? $72b362d5e9f1af01$var$gettingStartedPageEntryPoint : undefined;
    },
    component: (0, $dgH3j.default)
});
const $72b362d5e9f1af01$export$abec122151c24b1b = [
    $72b362d5e9f1af01$export$9f5707c751b4b364
];



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $af8cbc70a07773c6$export$5bc288fedb880892 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ITSM_SAMPLE_SPACE),
    path: '/jira/servicedesk/itsm-sample-space',
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $59o4i = parcelRequire("59o4i");

const $8ae74981a9e1a473$export$c1a5da0c35411fc1 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("eCfcK")), {
    moduleId: "./src/packages/spa-apps/servicedesk/itsm-sample-space/src/index.tsx"
});
const $8ae74981a9e1a473$export$389e7e12a5ae9f5a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8ae74981a9e1a473$export$c1a5da0c35411fc1,
        pageId: "spa-apps/servicedesk/itsm-sample-space",
        shouldShowSpinner: true
    });
const $8ae74981a9e1a473$export$61ad481262acd4e6 = (0, $bMm60.createEntry)((0, $af8cbc70a07773c6$export$5bc288fedb880892), {
    isRedirect: true,
    component: $8ae74981a9e1a473$export$389e7e12a5ae9f5a,
    layout: (0, $csLgO.serviceProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $8ae74981a9e1a473$export$c1a5da0c35411fc1
    ],
    perfMetricKey: 'jsm-sample-space-landing-page',
    meta: {
        reporting: {
            id: (0, $frZnw.APP_NAMES).ITSM_SAMPLE_SPACE,
            packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).ITSM_SAMPLE_SPACE),
            teamName: 'itops-mithril'
        }
    }
});



var $cernH = parcelRequire("cernH");

var $1yEMG = parcelRequire("1yEMG");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $bbvOQ = parcelRequire("bbvOQ");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $fsmKq = parcelRequire("fsmKq");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $5ddbc7aa2f37e5a3$export$c73ba7e80a805fb2 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("7QYCD"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-articles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5ddbc7aa2f37e5a3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5ddbc7aa2f37e5a3$export$c73ba7e80a805fb2,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-articles",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $b519a0ee4ed17684$export$a488cba75f18ade8 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("4cZKq"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-categories/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b519a0ee4ed17684$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b519a0ee4ed17684$export$a488cba75f18ade8,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-categories",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $6fd84daa3f325c54$export$c01a896b8d33aa9c = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("1mFuR"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-category/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6fd84daa3f325c54$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6fd84daa3f325c54$export$c01a896b8d33aa9c,
        pageId: "spa-apps/servicedesk/knowledge-hub/category",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $1809061a981fe2df$export$53decb9d1eb60aed = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("2xZ7u"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-drafts/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1809061a981fe2df$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1809061a981fe2df$export$53decb9d1eb60aed,
        pageId: "spa-apps/servicedesk/knowledge-hub/drafts",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $1f8dd3006287cca9$export$35c6d2a033ef4c42 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("1fEyb"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-article-embed-editor/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f8dd3006287cca9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1f8dd3006287cca9$export$35c6d2a033ef4c42,
        pageId: "knowledge-article-embed-editor",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $4e1b5edf2765a2ad$export$f1266a588cfc310b = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("gN5sW")), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-landing/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4e1b5edf2765a2ad$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4e1b5edf2765a2ad$export$f1266a588cfc310b,
        pageId: "spa-apps/servicedesk/knowledge-hub/landing-page",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $29e85ad8b84aab41$export$6c08040d2dc71e43 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("acRp2")), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-setup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$29e85ad8b84aab41$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $29e85ad8b84aab41$export$6c08040d2dc71e43,
        pageId: "spa-apps/servicedesk/knowledge-hub/setup",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $74cea6e2a2cb8d85$export$aee7d96c2ee4c388 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("72qqt"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-suggested-articles/src/index.tsx"
});
const $74cea6e2a2cb8d85$export$ee4623542ebd573e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $74cea6e2a2cb8d85$export$aee7d96c2ee4c388,
        pageId: "spa-apps/servicedesk/knowledge-hub/suggested-articles",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $9cedec9347cbc8b6$export$efd0ec49853aa81 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("gwhoT"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-view-article/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9cedec9347cbc8b6$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9cedec9347cbc8b6$export$efd0ec49853aa81,
        pageId: "spa-apps/servicedesk/knowledge-hub/view-article",
        shouldShowSpinner: true
    });


const $a254fc0ce0bc8828$var$getKnowledgeHubResources = ()=>[
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $bbvOQ.kbConfluenceContextResource)
    ];
const $a254fc0ce0bc8828$export$f1453c3517242ca1 = [
    (0, $bMm60.createEntry)((0, $fsmKq.knowledgeHubLandingRoute), {
        component: (0, $4e1b5edf2765a2ad$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $1yEMG.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4e1b5edf2765a2ad$export$f1266a588cfc310b)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_LANDING,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_LANDING),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $fsmKq.knowledgeHubBrowseAllArticlesRoute), {
        component: (0, $5ddbc7aa2f37e5a3$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $1yEMG.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5ddbc7aa2f37e5a3$export$c73ba7e80a805fb2)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $fsmKq.knowledgeHubDraftsRoute), {
        component: (0, $1809061a981fe2df$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $1yEMG.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1809061a981fe2df$export$53decb9d1eb60aed)
        ],
        perfMetricKey: 'service-management.kb-drafts',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_DRAFTS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_DRAFTS),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $fsmKq.knowledgeHubBrowseAllCategoriesRoute), {
        component: (0, $b519a0ee4ed17684$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $1yEMG.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $b519a0ee4ed17684$export$a488cba75f18ade8)
        ],
        perfMetricKey: 'service-management.kb-categories',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_BROWSE_CATEGORIES,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_BROWSE_CATEGORIES),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $fsmKq.knowledgeHubSuggestedArticlesRoute), {
        component: (0, $74cea6e2a2cb8d85$export$ee4623542ebd573e),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $1yEMG.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $74cea6e2a2cb8d85$export$aee7d96c2ee4c388)
        ],
        perfMetricKey: 'service-management.kb-suggested-articles',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_SUGGESTED_ARTICLES,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_SUGGESTED_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $fsmKq.knowledgeHubBrowseViewArticleRoute), {
        perfMetricKey: 'service-management.knowledge.article',
        component: (0, $9cedec9347cbc8b6$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9cedec9347cbc8b6$export$efd0ec49853aa81)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $fsmKq.knowledgeHubArticleEmbedEditorRoute), {
        component: (0, $1f8dd3006287cca9$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1f8dd3006287cca9$export$35c6d2a033ef4c42)
        ],
        perfMetricKey: 'service-management.knowledge.ep-editor'
    }),
    (0, $bMm60.createEntry)((0, $fsmKq.knowledgeHubAllArticlesRoute), {
        component: (0, $5ddbc7aa2f37e5a3$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $1yEMG.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5ddbc7aa2f37e5a3$export$c73ba7e80a805fb2)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $fsmKq.knowledgeHubArticleInCategoryRoute), {
        perfMetricKey: 'service-management.knowledge.article',
        component: (0, $9cedec9347cbc8b6$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9cedec9347cbc8b6$export$efd0ec49853aa81)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $fsmKq.knowledgeHubCategoryPageRoute), {
        component: (0, $6fd84daa3f325c54$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6fd84daa3f325c54$export$c01a896b8d33aa9c)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_CATEGORY,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $fsmKq.knowledgeHubCategoryRoute), {
        ufoName: 'service-management.knowledge.category',
        component: (0, $6fd84daa3f325c54$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6fd84daa3f325c54$export$c01a896b8d33aa9c)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_CATEGORY,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $fsmKq.knowledgeHubSearchRoute), {
        component: (0, $9cedec9347cbc8b6$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $1yEMG.AsyncKbNav),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9cedec9347cbc8b6$export$efd0ec49853aa81)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $fsmKq.knowledgeHubSetupRoute), {
        component: (0, $29e85ad8b84aab41$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $29e85ad8b84aab41$export$6c08040d2dc71e43)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_SETUP,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_SETUP),
                teamName: 'jsm-nebula'
            }
        }
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $5Z6fS = parcelRequire("5Z6fS");

var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $9607b86898869629$export$69cba5247233f8bc = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("ct7CZ"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/notification-logs/src/index.tsx"
});
const $9607b86898869629$export$1139895a5af7252e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9607b86898869629$export$69cba5247233f8bc,
        pageId: "spa-apps/servicedesk/notification-logs",
        shouldShowSpinner: true
    });


const $18d5247f51aff8ac$export$20ab3a955246df95 = (0, $bMm60.createEntry)((0, $5Z6fS.notificationLogsRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $kbHFR.getServiceDeskNavigationResources)(),
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    component: (0, $9607b86898869629$export$1139895a5af7252e),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $9607b86898869629$export$69cba5247233f8bc)
    ],
    perfMetricKey: 'jsm-notification-logs-component-load'
});



var $cernH = parcelRequire("cernH");


var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $giKK2 = parcelRequire("giKK2");

var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $c84e22fc3fbcbc34$export$e8392650fdcd92d5 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("6rwbc")), {
    moduleId: "./src/packages/spa-apps/servicedesk/opsgenie-schedule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c84e22fc3fbcbc34$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c84e22fc3fbcbc34$export$e8392650fdcd92d5,
        pageId: "spa-apps/servicedesk/opsgenie-schedule",
        shouldShowSpinner: true
    });


const $897b4311b3dc269c$export$8e210af71fea11c9 = [
    (0, $bMm60.createEntry)((0, $giKK2.servicedeskOncallScheduleRoute), {
        ufoName: 'service-management.on-call-schedule',
        component: (0, $c84e22fc3fbcbc34$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $46bb9ae4a6cbb829$export$d4493569f106c71),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $c84e22fc3fbcbc34$export$e8392650fdcd92d5),
            (0, $46bb9ae4a6cbb829$export$d9802671a2b1aa20)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $b1sy2 = parcelRequire("b1sy2");

var $bU9Sz = parcelRequire("bU9Sz");

var $kbHFR = parcelRequire("kbHFR");

var $9LviW = parcelRequire("9LviW");

var $exb0h = parcelRequire("exb0h");
const $75f62ade094ca022$export$7f878f9aeac61f1e = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2),
    path: '/jira/servicedesk/projects/:projectKey/organization/:organizationId',
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $2e7b4e8e97b4bc53$export$1c7fcdb58f42db03 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("isMQ5"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organization-v2/src/index.tsx"
});
const $2e7b4e8e97b4bc53$export$5f69663d85db303d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2e7b4e8e97b4bc53$export$1c7fcdb58f42db03,
        pageId: "spa-apps/servicedesk/organization-v2",
        shouldShowSpinner: true
    });


const $8c3a0add719ffed8$export$f32a63b509fcdb4f = [
    (0, $bMm60.createEntry)((0, $75f62ade094ca022$export$7f878f9aeac61f1e), {
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $9LviW.serviceDeskOrganizationPanelForgeDataResource),
            (0, $dAKwA.getConsolidationStateResource)(),
            (0, $bU9Sz.productsJsmOrganizationDetailsResource),
            (0, $b1sy2.jsmEmailDomainsListResource)
        ],
        component: (0, $2e7b4e8e97b4bc53$export$5f69663d85db303d),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $2e7b4e8e97b4bc53$export$1c7fcdb58f42db03)
        ],
        perfMetricKey: 'jsm-organizations-component-load'
    })
];



var $cernH = parcelRequire("cernH");


var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $b1sy2 = parcelRequire("b1sy2");

var $bU9Sz = parcelRequire("bU9Sz");

var $kbHFR = parcelRequire("kbHFR");

var $a5AeJ = parcelRequire("a5AeJ");

var $eJxBd = parcelRequire("eJxBd");

var $7FYcB = parcelRequire("7FYcB");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $40de1bba437701ab$export$b40b4bfa472057b9 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("8PUdS"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organizations/src/index.tsx"
});
const $40de1bba437701ab$export$4abec67d7b34dda2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $40de1bba437701ab$export$b40b4bfa472057b9,
        pageId: "spa-apps/servicedesk/organizations",
        shouldShowSpinner: true
    });

const $40de1bba437701ab$export$4a01866152e4a375 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("5XfxL"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organization-details/src/index.tsx"
});
const $40de1bba437701ab$export$709be875ca0a7ead = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $40de1bba437701ab$export$4a01866152e4a375,
        pageId: "spa-apps/servicedesk/organization-details",
        shouldShowSpinner: true
    });


const $be3c302f353d15b5$var$getOrganizationsRoutesCommon = ()=>({
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ]
    });
const $be3c302f353d15b5$export$7dd191d527f3ef6f = [
    (0, $bMm60.createEntry)((0, $7FYcB.servicedeskOrganizationDetailsRoute), {
        ...$be3c302f353d15b5$var$getOrganizationsRoutesCommon(),
        component: (0, $40de1bba437701ab$export$709be875ca0a7ead),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $40de1bba437701ab$export$4a01866152e4a375)
        ],
        perfMetricKey: 'jsm-organization-details-component-load',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).ORGANIZATION_DETAILS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).ORGANIZATION_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...$be3c302f353d15b5$var$getOrganizationsRoutesCommon().resources,
            (0, $a5AeJ.entitlementsOrganizationQueryResource),
            (0, $eJxBd.uiOrganizationDetailsPageQueryResource),
            (0, $bU9Sz.productsJsmOrganizationDetailsResource),
            (0, $b1sy2.jsmEmailDomainsListResource)
        ]
    }),
    (0, $bMm60.createEntry)((0, $7FYcB.servicedeskOrganizationsRoute), {
        ...$be3c302f353d15b5$var$getOrganizationsRoutesCommon(),
        component: (0, $40de1bba437701ab$export$4abec67d7b34dda2),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $40de1bba437701ab$export$b40b4bfa472057b9)
        ],
        perfMetricKey: 'jsm-organizations-component-load',
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $eec12bcff4bffa70$export$a237f415539577a5),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorziontalOnNav4: true
        },
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).ORGANIZATIONS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).ORGANIZATIONS),
                teamName: 'boysenberry'
            }
        }
    })
];



var $9zysr = parcelRequire("9zysr");

var $eI5EY = parcelRequire("eI5EY");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $dgH3j = parcelRequire("dgH3j");

var $jdx5X = parcelRequire("jdx5X");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");



var $7vTKl = parcelRequire("7vTKl");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $f7df5b839800d2da$export$95a2fe4e495efca5 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("lLKZW")), {
        moduleId: "ac794fd1"
    }),
    getPreloadProps: ()=>({})
});


const $9a9b1db23ce68fab$export$ae7c241893e7dab9 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $f7df5b839800d2da$export$95a2fe4e495efca5),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});


const $2e95eeae009810f4$export$cef6a6370e56c273 = [
    (0, $bMm60.createEntry)((0, $jdx5X.servicedeskProjectSummaryRoute), {
        ufoName: 'jsm.project-summary',
        component: (0, $9zysr.componentWithCondition)(()=>(0, $eI5EY.fg)('jsm-project-summary'), ()=>null, (0, $dgH3j.default)),
        // TODO - add skeleton
        skeleton: (0, $293e8909018b8407$export$49d3670908a8d8fe),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $eI5EY.fg)('jsm-project-summary') ? (0, $9a9b1db23ce68fab$export$ae7c241893e7dab9) : undefined,
        meta: {
            reporting: {
                id: 'project-summary',
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).PROJECT_SUMMARY),
                teamName: 'jsd-shield'
            }
        }
    })
];



var $cernH = parcelRequire("cernH");


var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $7JKBZ = parcelRequire("7JKBZ");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");


var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");


var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $7JKBZ = parcelRequire("7JKBZ");

var $dAKwA = parcelRequire("dAKwA");

var $aspp6 = parcelRequire("aspp6");

var $kbHFR = parcelRequire("kbHFR");

var $IsF0v = parcelRequire("IsF0v");

var $jwzNs = parcelRequire("jwzNs");


var $eD2UT = parcelRequire("eD2UT");

var $csLgO = parcelRequire("csLgO");


var $59o4i = parcelRequire("59o4i");

const $6a72616216ae3f5d$var$LazyServicedeskQueuesAgentAndIssueView = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("kDuGf"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-agent-and-issue-view/src/index.tsx"
});
const $6a72616216ae3f5d$export$59d555419fbaa611 = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    const issueKey = match.params && match.params.issueKey || '';
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6a72616216ae3f5d$var$LazyServicedeskQueuesAgentAndIssueView,
        pageId: `spa-apps/servicedesk/queues/${queueId}/${issueKey}/${oldIssueView}`,
        shouldShowSpinner: true
    });
};
const $6a72616216ae3f5d$export$54a295e04e6cea33 = (0, $bMm60.createEntry)((0, $eD2UT.customQueueRoute), {
    component: $6a72616216ae3f5d$export$59d555419fbaa611,
    layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            params: [
                {
                    key: 'issueKey'
                }
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $kbHFR.getQueuesResources)(),
        ...(0, $kbHFR.getInsightResources)(),
        ...(0, $kbHFR.getIssueListSsrResource)(),
        (0, $7JKBZ.newIssueViewLockInStatusResource),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $IsF0v.servicedeskIsItsmProjectResource)
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $6a72616216ae3f5d$var$LazyServicedeskQueuesAgentAndIssueView
    ]
});
const $6a72616216ae3f5d$export$b43128c9b5db2a5e = (0, $bMm60.createEntry)((0, $eD2UT.customPracticeQueueRoute), {
    component: $6a72616216ae3f5d$export$59d555419fbaa611,
    layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            params: [
                {
                    key: 'issueKey'
                }
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $kbHFR.getQueuesResources)(),
        ...(0, $kbHFR.getKnowledgeBaseResources)(),
        ...(0, $kbHFR.getInsightResources)(),
        ...(0, $kbHFR.getIssueListSsrResource)(),
        (0, $7JKBZ.newIssueViewLockInStatusResource),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9'), (0, $aspp6.jsmRepackagingBannerResource))
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $6a72616216ae3f5d$var$LazyServicedeskQueuesAgentAndIssueView
    ]
});



var $exb0h = parcelRequire("exb0h");
const $519a0f7740a57837$export$e146d4ae5415aa9 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ISSUE),
    path: '/jira/servicedesk/projects/:projectKey/issue/:issueKey',
    exact: true
};
const $519a0f7740a57837$export$52b4c044e4929ebc = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING),
    // Supporting optional /default for legacy backwards compatability
    path: '/jira/servicedesk/projects/:projectKey/queues/(default|custom)?',
    exact: true
};
const $519a0f7740a57837$export$c1908994722d1e73 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_NEW),
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};
const $519a0f7740a57837$export$f8fd3a1f8c33aff8 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT),
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit',
    exact: true
};
const $519a0f7740a57837$export$52a24b9cf42d208b = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE),
    path: '/jira/servicedesk/projects/:projectKey/queues/issue/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};
const $519a0f7740a57837$export$7f30d40b906894c5 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW),
    path: '/jira/servicedesk/projects/:projectKey/queues/queue-settings',
    exact: true
};
const $519a0f7740a57837$export$1465f05b88a63f13 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON),
    path: '/jira/servicedesk/projects/:projectKey/queues/addon/:addonKey',
    exact: true
};
const $519a0f7740a57837$export$3c859c71be33b36c = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING),
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/(custom)?',
    exact: true
};
const $519a0f7740a57837$export$8595a5452f93a1fd = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW),
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};
const $519a0f7740a57837$export$125e0ab662806584 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW),
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/queue-settings',
    exact: true
};
const $519a0f7740a57837$export$dfaa99f66db1aa2 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT),
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit',
    exact: true
};
const $519a0f7740a57837$export$38a6ee0f22e74bf3 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE),
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/issue/:issueKey',
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $10295f6ff28336b4$export$451a7cce84b6b1e6 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("kl03w")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-addon-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$10295f6ff28336b4$export$2e2bcd8739ae039 = ({ match: match })=>{
    const addonKey = match.params && match.params.addonKey || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $10295f6ff28336b4$export$451a7cce84b6b1e6,
        pageId: `spa-apps/servicedesk/queues/addon/${addonKey}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $a74339164dbab1b0$export$c050b699bf9e3e40 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("4D5Tp"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-create-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a74339164dbab1b0$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a74339164dbab1b0$export$c050b699bf9e3e40,
        pageId: "spa-apps/servicedesk/queues/create",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $8e13e6542c859d39$export$5bb02347e0261e6a = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("d23jC"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-edit-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8e13e6542c859d39$export$2e2bcd8739ae039 = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8e13e6542c859d39$export$5bb02347e0261e6a,
        pageId: `spa-apps/servicedesk/queues/edit/${queueId}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $e2dea19c4bd6b26b$export$164f2dfdd8dc056b = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("441DV")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view/src/index.tsx"
});
var /**
 * Constructs a URL path for navigating to a specific issue view within a service desk queue, incorporating optional parameters for issue identification and view customization.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$e2dea19c4bd6b26b$export$2e2bcd8739ae039 = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const queueId = `/${match.params && match.params.queueId || ''}`;
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e2dea19c4bd6b26b$export$164f2dfdd8dc056b,
        pageId: `spa-apps/servicedesk/queues/issue${queueId}${issueKey}${oldIssueView}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $ae55474111205677$export$bdf522692228bb6f = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("8oMBZ")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-landing/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ae55474111205677$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ae55474111205677$export$bdf522692228bb6f,
        pageId: "spa-apps/servicedesk/queues/landing",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $6884213eeaccf9b5$export$9f1e189198f08c4a = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("3GkTL"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-manage-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6884213eeaccf9b5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6884213eeaccf9b5$export$9f1e189198f08c4a,
        pageId: "spa-apps/servicedesk/queues/manage",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $0462d312b9b2dd3d$export$52593b5917c5e179 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("2LH9h")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view-redirect/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0462d312b9b2dd3d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0462d312b9b2dd3d$export$52593b5917c5e179,
        pageId: "spa-apps/servicedesk/queues/issue-view-redirect",
        shouldShowSpinner: true
    });


const $d0bc8c375af4b440$export$91a360c2f7f83db9 = [
    (0, $bMm60.createEntry)((0, $519a0f7740a57837$export$e146d4ae5415aa9), {
        component: (0, $0462d312b9b2dd3d$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            ...(0, $kbHFR.getKnowledgeBaseResources)(),
            ...(0, $kbHFR.getInsightResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $0462d312b9b2dd3d$export$52593b5917c5e179)
        ]
    }),
    (0, $bMm60.createEntry)((0, $519a0f7740a57837$export$52b4c044e4929ebc), {
        isRedirect: true,
        component: (0, $ae55474111205677$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            (0, $7JKBZ.newIssueViewLockInStatusResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ae55474111205677$export$bdf522692228bb6f)
        ]
    }),
    (0, $bMm60.createEntry)((0, $519a0f7740a57837$export$c1908994722d1e73), {
        component: (0, $a74339164dbab1b0$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $a74339164dbab1b0$export$c050b699bf9e3e40)
        ],
        ufoName: 'service-management.queues.new'
    }),
    (0, $bMm60.createEntry)((0, $519a0f7740a57837$export$f8fd3a1f8c33aff8), {
        component: (0, $8e13e6542c859d39$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            (0, $dAKwA.getConsolidationStateResource)(),
            ...(0, $kbHFR.getIssueListSsrResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $8e13e6542c859d39$export$5bb02347e0261e6a)
        ],
        ufoName: 'service-management.queues.edit'
    }),
    (0, $6a72616216ae3f5d$export$54a295e04e6cea33),
    (0, $bMm60.createEntry)((0, $519a0f7740a57837$export$52a24b9cf42d208b), {
        component: (0, $e2dea19c4bd6b26b$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            ...(0, $kbHFR.getKnowledgeBaseResources)(),
            ...(0, $kbHFR.getInsightResources)(),
            (0, $7JKBZ.newIssueViewLockInStatusResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $e2dea19c4bd6b26b$export$164f2dfdd8dc056b)
        ]
    }),
    (0, $bMm60.createEntry)((0, $519a0f7740a57837$export$7f30d40b906894c5), {
        component: (0, $6884213eeaccf9b5$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: (0, $kbHFR.getQueuesResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6884213eeaccf9b5$export$9f1e189198f08c4a)
        ]
    }),
    (0, $bMm60.createEntry)((0, $519a0f7740a57837$export$1465f05b88a63f13), {
        component: (0, $10295f6ff28336b4$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $10295f6ff28336b4$export$451a7cce84b6b1e6)
        ]
    }),
    (0, $bMm60.createEntry)((0, $519a0f7740a57837$export$3c859c71be33b36c), {
        isRedirect: true,
        component: (0, $ae55474111205677$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ae55474111205677$export$bdf522692228bb6f)
        ]
    }),
    (0, $bMm60.createEntry)((0, $519a0f7740a57837$export$8595a5452f93a1fd), {
        component: (0, $a74339164dbab1b0$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $a74339164dbab1b0$export$c050b699bf9e3e40)
        ]
    }),
    (0, $bMm60.createEntry)((0, $519a0f7740a57837$export$125e0ab662806584), {
        component: (0, $6884213eeaccf9b5$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: (0, $kbHFR.getQueuesResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6884213eeaccf9b5$export$9f1e189198f08c4a)
        ]
    }),
    (0, $bMm60.createEntry)((0, $519a0f7740a57837$export$dfaa99f66db1aa2), {
        component: (0, $8e13e6542c859d39$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            ...(0, $kbHFR.getIssueListSsrResource)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $8e13e6542c859d39$export$5bb02347e0261e6a)
        ]
    }),
    (0, $6a72616216ae3f5d$export$b43128c9b5db2a5e),
    (0, $bMm60.createEntry)((0, $519a0f7740a57837$export$38a6ee0f22e74bf3), {
        component: (0, $e2dea19c4bd6b26b$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)()),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            ...(0, $kbHFR.getKnowledgeBaseResources)(),
            ...(0, $kbHFR.getInsightResources)(),
            (0, $7JKBZ.newIssueViewLockInStatusResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $e2dea19c4bd6b26b$export$164f2dfdd8dc056b)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $cernH = parcelRequire("cernH");

var $9zysr = parcelRequire("9zysr");


var $7vTKl = parcelRequire("7vTKl");

var $6FP8W = parcelRequire("6FP8W");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $7JKBZ = parcelRequire("7JKBZ");

var $bbvOQ = parcelRequire("bbvOQ");

var $dAKwA = parcelRequire("dAKwA");

var $1iICl = parcelRequire("1iICl");

var $kbHFR = parcelRequire("kbHFR");


var $5VjfX = parcelRequire("5VjfX");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $lB25E = parcelRequire("lB25E");
const $d969dacb8f3e7e46$export$e4c007d05145b8c2 = '/reports/all-rating';
const $d969dacb8f3e7e46$export$5daa28d10e23592 = '/:issueKey';
const $d969dacb8f3e7e46$export$ddc580d759168f88 = '/reports/workload';
const $d969dacb8f3e7e46$export$13bdc187fca9c33e = '/reports';



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $bcc6627efeceef63$export$75e043cf7a4e3661 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("kKBRu")), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports/src/index.tsx"
});
var /**
 * Dynamically loads the ServicedeskReports component, enhancing user experience by using deferred loading with a visual feedback.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcc6627efeceef63$export$2e2bcd8739ae039 = ({ match: match })=>{
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $bcc6627efeceef63$export$75e043cf7a4e3661,
        pageId: `spa-apps/servicedesk/reports/${match ? match.url : ''}${oldIssueView}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $2e86ec7ecdee93de$export$78ffe2f6530d45d1 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("dwqqh"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/atlassian-analytics/src/index.tsx"
});
const $2e86ec7ecdee93de$export$6d23a188bb96b7ab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2e86ec7ecdee93de$export$78ffe2f6530d45d1,
        pageId: "spa-apps/servicedesk/atlassian-analytics",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $16827de33e5c7c9a$export$3ec5c3d7729889b9 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("KsImw"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$16827de33e5c7c9a$export$2e2bcd8739ae039 = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $16827de33e5c7c9a$export$3ec5c3d7729889b9,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $67cb0c7c9b4371f5$export$821b8201b24f8b7d = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("71sin"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-create/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$67cb0c7c9b4371f5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $67cb0c7c9b4371f5$export$821b8201b24f8b7d,
        pageId: "spa-apps/servicedesk/reports/custom/create",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $ae91bda248b14a12$export$53def03ace9a6c5b = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("s7itf"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-edit/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ae91bda248b14a12$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { reportId: reportId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ae91bda248b14a12$export$53def03ace9a6c5b,
        pageId: `spa-apps/servicedesk/reports/custom/${reportId || ''}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");


const $9d3435212bd0ab6d$export$121b9cfb2b001a53 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("6qyuu"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-home-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9d3435212bd0ab6d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9d3435212bd0ab6d$export$121b9cfb2b001a53,
        pageId: `spa-apps/servicedesk${(0, $d969dacb8f3e7e46$export$13bdc187fca9c33e)}}`,
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $27d48936eba74e39$export$c2f0d3c59c9d3bf3 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("9ZKn1")), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-issue-view/src/index.tsx"
});
var /**
 * Dynamically constructs and renders a lazy-loaded page tailored to specific Servicedesk report views. By leveraging URL parameters such as issue key and timescale ID, it enhances user navigation within the Servicedesk environment by directly accommodating varied user inquiries and historical data perspectives.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$27d48936eba74e39$export$2e2bcd8739ae039 = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const timescaleId = `/${match.params && match.params.timescaleId || ''}`;
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $27d48936eba74e39$export$c2f0d3c59c9d3bf3,
        pageId: `spa-apps/servicedesk/reports/issue${issueKey}${timescaleId}${oldIssueView}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $f3abba65b98481fb$export$f86e12b111395ad = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("9XWNM"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/kb-requests-reports/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f3abba65b98481fb$export$2e2bcd8739ae039 = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f3abba65b98481fb$export$f86e12b111395ad,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");


const $c3fd7ec3189cb801$export$8edc7b9d922cd22f = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("4HzHQ"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-satisfaction/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c3fd7ec3189cb801$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c3fd7ec3189cb801$export$8edc7b9d922cd22f,
        pageId: `spa-apps/servicedesk${(0, $d969dacb8f3e7e46$export$e4c007d05145b8c2)}}`,
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");


const $bf0505c82b3148c5$export$e805fb47fdcd991 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("h3Z7f"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-workload/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bf0505c82b3148c5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $bf0505c82b3148c5$export$e805fb47fdcd991,
        pageId: `spa-apps/servicedesk${(0, $d969dacb8f3e7e46$export$ddc580d759168f88)}}`,
        shouldShowSpinner: true
    });


const $782d56965097df84$var$DefaultReportsRedirect = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/jira/servicedesk/projects/${String(match.params.projectKey)}${(0, $d969dacb8f3e7e46$export$ddc580d759168f88)}`
    });
const $782d56965097df84$var$returnToSummary = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: String(match.params['0'])
    });
const $782d56965097df84$var$getReportsWithKbResources = ()=>[
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $bbvOQ.kbConfluenceContextResource)
    ];
const $782d56965097df84$export$721a27be140cb34d = [
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskReportsSummaryRoute), {
        component: $782d56965097df84$var$returnToSummary,
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskReports1Route), {
        component: (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), (0, $9d3435212bd0ab6d$export$2e2bcd8739ae039), $782d56965097df84$var$DefaultReportsRedirect),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$782d56965097df84$var$getReportsWithKbResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9d3435212bd0ab6d$export$121b9cfb2b001a53)
        ]
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskAtlassianAnalyticsRoute), {
        component: (0, $2e86ec7ecdee93de$export$6d23a188bb96b7ab),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $1iICl.servicedeskAtlassianAnalyticsResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $2e86ec7ecdee93de$export$78ffe2f6530d45d1)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).ATLASSIAN_ANALYTICS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).ATLASSIAN_ANALYTICS),
                teamName: 'ITSM Saga'
            }
        }
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskReportsWorkloadRoute), {
        component: (0, $bf0505c82b3148c5$export$2e2bcd8739ae039),
        perfMetricKey: 'service-management.reports.workload',
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $bf0505c82b3148c5$export$e805fb47fdcd991)
        ]
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskReportsSatisfactionIssueRoute), {
        component: (0, $27d48936eba74e39$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)()),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $7JKBZ.newIssueViewLockInStatusResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $27d48936eba74e39$export$c2f0d3c59c9d3bf3)
        ],
        ufoName: 'service-management.reports.issue'
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskReportsSatisfactionTimeScaleRoute), {
        perfMetricKey: 'service-management.reports.satisfaction',
        component: (0, $c3fd7ec3189cb801$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $c3fd7ec3189cb801$export$8edc7b9d922cd22f)
        ]
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskReportsSatisfaction2Route), {
        perfMetricKey: 'service-management.reports.satisfaction',
        component: (0, $c3fd7ec3189cb801$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $c3fd7ec3189cb801$export$8edc7b9d922cd22f)
        ]
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskKbRequestsReportsIssueRoute), {
        component: (0, $27d48936eba74e39$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)()),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $7JKBZ.newIssueViewLockInStatusResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $27d48936eba74e39$export$c2f0d3c59c9d3bf3)
        ],
        ufoName: 'service-management.reports.issue'
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskKbRequestsReportsTimeScaleRoute), {
        perfMetricKey: 'service-management.reports.kb-requests',
        component: (0, $f3abba65b98481fb$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f3abba65b98481fb$export$f86e12b111395ad)
        ]
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskKbRequestsReports2Route), {
        perfMetricKey: 'service-management.reports.kb-requests',
        component: (0, $f3abba65b98481fb$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f3abba65b98481fb$export$f86e12b111395ad)
        ]
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskReportsCustomEditRoute), {
        perfMetricKey: 'service-management.reports.custom-edit-view',
        component: (0, $ae91bda248b14a12$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ae91bda248b14a12$export$53def03ace9a6c5b)
        ]
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskReportsCustomCreateRoute), {
        perfMetricKey: 'service-management.reports.custom-create',
        component: (0, $67cb0c7c9b4371f5$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $67cb0c7c9b4371f5$export$821b8201b24f8b7d)
        ]
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskReportsCustomIssueRoute), {
        component: (0, $27d48936eba74e39$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)()),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $7JKBZ.newIssueViewLockInStatusResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $27d48936eba74e39$export$c2f0d3c59c9d3bf3)
        ],
        ufoName: 'service-management.reports.issue'
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskReportsCustomTimeScaleRoute), {
        component: (0, $16827de33e5c7c9a$export$2e2bcd8739ae039),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $16827de33e5c7c9a$export$3ec5c3d7729889b9)
        ],
        ufoName: 'service-management-custom-reports'
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskReportsCustom4Route), {
        component: (0, $16827de33e5c7c9a$export$2e2bcd8739ae039),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $16827de33e5c7c9a$export$3ec5c3d7729889b9)
        ],
        ufoName: 'service-management-custom-reports'
    }),
    (0, $bMm60.createEntry)((0, $5VjfX.servicedeskReportsTypeRoute), {
        component: (0, $bcc6627efeceef63$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$782d56965097df84$var$getReportsWithKbResources(),
            (0, $7JKBZ.newIssueViewLockInStatusResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $bcc6627efeceef63$export$75e043cf7a4e3661)
        ]
    })
];
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$782d56965097df84$export$2e2bcd8739ae039 = (0, $bcc6627efeceef63$export$2e2bcd8739ae039);



var $cernH = parcelRequire("cernH");


var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");

var $7OtSy = parcelRequire("7OtSy");

var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $35677c83952c16f3$export$7f4092c8e7b7d3ec = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("fNmCk")), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-create-modal-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$35677c83952c16f3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $35677c83952c16f3$export$7f4092c8e7b7d3ec,
        pageId: "spa-apps/servicedesk/service-create-modal",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $9dbecc4d2dc84380$export$b154597f29589502 = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("7RQQm"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-details-with-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9dbecc4d2dc84380$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9dbecc4d2dc84380$export$b154597f29589502,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");


var $59o4i = parcelRequire("59o4i");

const $405fe5f5e2d70961$export$ba1931edde0ce20c = (0, $6VZoe.lazyForPaint)(()=>(0, $ded70d904ebbb134$export$ff83c57004505abd)((parcelRequire("gU5K0"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-details-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$405fe5f5e2d70961$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $405fe5f5e2d70961$export$ba1931edde0ce20c,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $bbadc13aef817010$export$8984aadca7e15d1 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("3tIPj")), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-update-modal-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bbadc13aef817010$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $bbadc13aef817010$export$8984aadca7e15d1,
        pageId: "spa-apps/servicedesk/service-update-modal",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $7619f4f66245ba69$export$4aa60213b3477cf6 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("c37zX")), {
    moduleId: "./src/packages/spa-apps/servicedesk/services-with-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7619f4f66245ba69$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7619f4f66245ba69$export$4aa60213b3477cf6,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $6VZoe = parcelRequire("6VZoe");

var $59o4i = parcelRequire("59o4i");

const $c30aeed1bf92a640$export$fc385e1392a8e28 = (0, $6VZoe.lazyForPaint)(()=>(parcelRequire("jNyby")), {
    moduleId: "./src/packages/spa-apps/servicedesk/services-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c30aeed1bf92a640$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c30aeed1bf92a640$export$fc385e1392a8e28,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });


const $3fde294f25225173$export$837d7aa221731e74 = [
    (0, $bMm60.createEntry)((0, $7OtSy.servicedeskServicesRoute), {
        ufoName: 'service-management.services',
        component: (0, $7619f4f66245ba69$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $46bb9ae4a6cbb829$export$d4493569f106c71),
            onlyShowHorziontalOnNav4: true
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $46bb9ae4a6cbb829$export$d9802671a2b1aa20),
            (0, $7619f4f66245ba69$export$4aa60213b3477cf6)
        ]
    }),
    (0, $bMm60.createEntry)((0, $7OtSy.servicedeskServiceDetailsRoute), {
        ufoName: 'service-management.service-details',
        component: (0, $9dbecc4d2dc84380$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9dbecc4d2dc84380$export$b154597f29589502)
        ]
    }),
    (0, $bMm60.createEntry)((0, $7OtSy.serviceDeskServicesWithoutProjectRoute), {
        ufoName: 'service-management.services-without-project',
        component: (0, $c30aeed1bf92a640$export$2e2bcd8739ae039),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $c30aeed1bf92a640$export$fc385e1392a8e28)
        ]
    }),
    (0, $bMm60.createEntry)((0, $7OtSy.serviceDeskServiceDetailsWithoutProjectRoute), {
        ufoName: 'service-management.service-details-without-project',
        component: (0, $405fe5f5e2d70961$export$2e2bcd8739ae039),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $405fe5f5e2d70961$export$ba1931edde0ce20c)
        ]
    })
];
const $3fde294f25225173$export$27385b29970830e7 = [
    (0, $bMm60.createEntry)((0, $7OtSy.servicedeskServiceModalNewRoute), {
        component: (0, $35677c83952c16f3$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $35677c83952c16f3$export$7f4092c8e7b7d3ec)
        ]
    }),
    (0, $bMm60.createEntry)((0, $7OtSy.servicedeskServiceModalEditRoute), {
        component: (0, $bbadc13aef817010$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $bbadc13aef817010$export$8984aadca7e15d1)
        ]
    })
];
const $3fde294f25225173$export$57d6fec357eb220c = [
    ...$3fde294f25225173$export$837d7aa221731e74,
    ...$3fde294f25225173$export$27385b29970830e7
];


const $4e5597a91c1b7a52$export$b4944bd787708b82 = [
    ...(0, $a254fc0ce0bc8828$export$f1453c3517242ca1),
    ...(0, $782d56965097df84$export$721a27be140cb34d),
    ...(0, $d0bc8c375af4b440$export$91a360c2f7f83db9),
    ...(0, $2d3841ea93833e60$export$97cc5f4d7ce032e1),
    ...(0, $72b362d5e9f1af01$export$abec122151c24b1b),
    ...(0, $3fde294f25225173$export$57d6fec357eb220c),
    ...(0, $b011af7098605060$export$6811a8ea7ba7651c),
    ...(0, $be3c302f353d15b5$export$7dd191d527f3ef6f),
    ...(0, $8c3a0add719ffed8$export$f32a63b509fcdb4f),
    ...(0, $897b4311b3dc269c$export$8e210af71fea11c9),
    ...(0, $37ff03730865f0e2$export$38a3aa80b813d565),
    ...(0, $08d75f6faff765b2$export$6e125037f42a1f62),
    ...(0, $2e95eeae009810f4$export$cef6a6370e56c273),
    ...(0, $c14f7e8a0471589a$export$5d38cb53852f589a),
    (0, $18d5247f51aff8ac$export$20ab3a955246df95),
    (0, $d9c2a0c15a2b974b$export$72138a83eeba68eb),
    (0, $f1fa06bfbcc25698$export$8810bfd4f6a0eb22),
    (0, $8ae74981a9e1a473$export$61ad481262acd4e6),
    (0, $2931ee7f95d0e303$export$ac25abe07ac3f570)
];


const $2f417e9628081c2f$export$d47aca795954578 = ()=>[
        ...(0, $d9c2a0c15a2b974b$export$b069a1c4b0240172),
        ...(0, $be75b82ac5d10c81$export$b1d92ac5cda62e7e),
        ...(0, $f730f07a676cc8e2$export$688b56fcbc2637ac),
        ...(0, $8605a99074da660f$export$44e0cb320cb148ed),
        ...(0, $6fe987b31d848aa1$export$23e1ab8ae95bd3a8),
        ...(0, $6fe987b31d848aa1$export$d06c2ab36705e562),
        ...(0, $20af5c394dfc25a4$export$5b4e616b6b4b672a),
        ...(0, $048cfffd237f6510$export$fd0ef3739cde76c1),
        ...(0, $799769b2797678db$export$debd9f352e8a3e70),
        ...(0, $eb281330981e8e67$export$fb2091db9e7f9102),
        ...(0, $b4bce7e4d8567b3c$export$c9b96dd6f5a7b454),
        (0, $26cd51f541672008$export$f7d3667678a21360),
        ...(0, $26cd51f541672008$export$fdccb6efc62198e6),
        (0, $b3df52e8783e1d6e$export$abd0bbe95839baf7),
        ...(0, $81a426de012c30b2$export$f9a1f59ec7d1f215),
        ...(0, $9556f709fc2a14de$export$fd3c71e3bfb4df9e)(),
        ...(0, $2719ac30f4e07b26$export$2763334cca1560d7),
        (0, $f020c38e81fdeaa8$export$e275b3ca0c6ccb5e),
        (0, $f020c38e81fdeaa8$export$cef770e7c16cfcc),
        (0, $e9de4186004550fb$export$703b5090da478c9c),
        (0, $ff06b8de8295ef68$export$415552b116808717),
        (0, $4f31ccd2cefdb1fe$export$578dcb61ac3cb57a),
        (0, $13903430967d785b$export$76b74d5744e69817),
        (0, $5e7adb561c10220c$export$5379c026da4201e6),
        (0, $c21644fb8a992f95$export$2740cfaa979353b9),
        (0, $7dbb3a67a6ba5746$export$ae258fb8ec2c1f86),
        (0, $621de40b0dd72f71$export$219b6cc00b2f91a0),
        (0, $6700056f9681aaf5$export$27d1f352c2f7acae),
        (0, $cbfac00f5b372876$export$4df9f9dcaf8565c9),
        (0, $6700056f9681aaf5$export$f52136d9a0848792),
        (0, $ec5f66b3062a483b$export$dc5f9e3c3931cc36),
        ...(0, $f0febcd6986df40f$export$445f7414e382a69c),
        (0, $5d62d367f9442e26$export$47b3bdf88a7d176b),
        (0, $cec0a7d4441930b4$export$5b0670f37204a43d),
        (0, $3637efef4b0c5bc2$export$e60f53ff5ae626cd),
        (0, $3637efef4b0c5bc2$export$25cf284456caeeef),
        (0, $dba4682a95e5bab0$export$72497f4e39dd0df4),
        (0, $3a69954879d67a4b$export$982bc443ef89cc3f),
        (0, $5a5a40256ffd86b1$export$28887e2da22c839a),
        (0, $00c9b0281306dc31$export$4791201b4877aa5d),
        (0, $ffed543118f23d13$export$babf32528ef518e9),
        (0, $ffed543118f23d13$export$6e8865417e6a38c),
        (0, $2dcde5e112eb5768$export$f128c1c4a1f0d631),
        (0, $2dcde5e112eb5768$export$924db6cf10ba8696),
        (0, $0307822c295b051f$export$9b0fdfd6a51a17de),
        (0, $0307822c295b051f$export$6009dd8e88f1a7de),
        (0, $0307822c295b051f$export$18226b6422149926),
        (0, $0307822c295b051f$export$73a377380ff671af),
        (0, $de6e961a6ca28e92$export$8dae8091f8e43b97),
        (0, $de6e961a6ca28e92$export$748e329bd0c282a),
        (0, $b5ce9d61d78c0c07$export$2a34d21ecf479c40),
        (0, $b5ce9d61d78c0c07$export$e78b34c999194638),
        (0, $042c6b2255f2865a$export$41fb3f2a3e68c7c3),
        (0, $042c6b2255f2865a$export$ca77bc660994f51f),
        (0, $042c6b2255f2865a$export$c2ec350ee9e78717),
        ...(0, $624e6e140f752e29$export$d604d3ad2662a845),
        (0, $0e750e81870ad8bd$export$36a7c374f4474cc1),
        (0, $e14bffeebd141c9d$export$8e015e39dbc90d0b),
        ...(0, $8ca12770b5795d94$export$f43cc215b47dd576),
        (0, $4cae923e7c81fee6$export$d83c2e469d070766),
        (0, $918eN.globalSettingsIssuesExplicitFieldAssociationRouteEntry),
        (0, $31538ea633950fb6$export$c68a412f25295511),
        (0, $5c5c328d1a0c046c$export$d1c67ceb7c5e2d6a),
        (0, $3dfca2b5a9cb36ce$export$56f9921db324f30),
        (0, $4adee587f623ba77$export$f9891419b34ab305),
        (0, $4497ae40fde48600$export$2f65b1ec4ed05f91),
        (0, $4497ae40fde48600$export$c62ca2d3fcc552a5),
        (0, $7b162697914d48c2$export$34d843946d3894aa),
        (0, $7b162697914d48c2$export$6d18fd46547afb8e),
        (0, $858ab70ef0ef29ff$export$461f2b06a7a914db),
        (0, $5c45641d0f476bbd$export$9cc9423a3967333b),
        (0, $706ea00b80585533$export$717e134eb971b450),
        (0, $ef3b2e76e978001d$export$3f8d7424a47f4dd),
        (0, $d04302cded51ff20$export$42ca979ec2919b23),
        (0, $d04302cded51ff20$export$d2ce6f09ef8aa840),
        (0, $5f3f0c448e8043d7$export$e18a6be3d2ffad71),
        (0, $f7decf7961ae87b9$export$5e1236665a530df4),
        (0, $20efdafd05df2f3a$export$773f8e3318be1dd5),
        (0, $d9a72e5e6bfe851d$export$80a3e4dda2dcd1a4),
        ...(0, $4e5597a91c1b7a52$export$b4944bd787708b82),
        (0, $6c41e52c48634921$export$45e68d450757a753),
        (0, $0307822c295b051f$export$ac09a8d3ecbafc5),
        (0, $0307822c295b051f$export$9fbbaafb58999ac3),
        (0, $0307822c295b051f$export$15f76f1b0d2d671),
        ...(0, $8ca12770b5795d94$export$189ae5546a081577),
        (0, $8ca12770b5795d94$export$2a24acea4e628148),
        (0, $8ca12770b5795d94$export$d751e3552b21c604),
        (0, $8ca12770b5795d94$export$f85a75f1604118ff),
        (0, $8ca12770b5795d94$export$9cbef73b51558ef),
        (0, $8ca12770b5795d94$export$e9cfdb950d40e917),
        (0, $8ca12770b5795d94$export$e71031acce6d7e47),
        (0, $8ca12770b5795d94$export$c2a4c5c6576a704c),
        (0, $0437c5d740028c1f$export$4f9df77811fbdc1f),
        ...(0, $723988f9339967b5$export$283761ff41b53cba),
        ...(0, $24ddbaaaf46634ea$export$a727cbd3cbcc2153),
        (0, $c7e50fdddf86bc76$export$66928ab349190059),
        (0, $c7e50fdddf86bc76$export$2b25520e20820251),
        ...(0, $a21bbc0ffd429ece$export$80002c8e4483fef1),
        ...(0, $2424a38c91d6dd07$export$5d3c7bc3dee8745d),
        (0, $ef6b20ae22882fd6$export$c058f4d1c0667ce1),
        ...(0, $0e57ebaaa2758857$export$de0b5a5b87cf45f3),
        ...(0, $2be3fd10da5a8d41$export$3a28949e52d2d60f),
        (0, $e108d633ec33a0c8$export$f1a859c727c30be4),
        (0, $e108d633ec33a0c8$export$842d7c81068bb64e),
        (0, $e24a5dc60e9548ab$export$2c2d6115c4280a08),
        ...(0, $2ee957ede87673df$export$ed40a3967b4f2617),
        (0, $d6dfbe2316b32236$export$ac245212b12db871),
        (0, $d6dfbe2316b32236$export$8657ca08ca5cbfc6),
        (0, $413a11b1b14313fe$export$fee33ca9661e49dd),
        (0, $ae796711ad3c7e93$export$c2ced436a30c60dc),
        (0, $56a8577e9ca176db$export$6ff606556e19e12),
        ...(0, $ff5a93f464a3dafa$export$cf5b5978205b681),
        ...(0, $662505a58c71f074$export$1d5f1cc699ecefa3),
        (0, $497df763957e5b2d$export$9c9bab95d425eb6f),
        (0, $836b69bb0e37d149$export$c51a4ee3e3f1b270),
        (0, $1052eb222a330200$export$6a7fc41fb2523290),
        (0, $1052eb222a330200$export$6d6efd297963f785),
        (0, $c0323c6c8a564bae$export$8b55e723205ec5f3),
        (0, $65d35ca4bc52d7e7$export$beae48175e3016b8),
        (0, $70b0ad18f4a8155d$export$c4c012a49b465e94),
        (0, $4edc8bb5aeebf389$export$faa46f8c5e1f06d3),
        ...(0, $159f64746bcc553c$export$633933bacdaefead),
        (0, $2f06ff747a0e9944$export$2af76482b576a135),
        // [WARNING]: This route should be the last route.
        // This route redirects to the monolith for all routes we cannot match.
        // It is purposefully missing a path so it always matches and therefore needs to be last.
        // [WARNING]: Please don't add a new route below this. If you want to add, please contact the package owner team.
        (0, $aa194b628782eb2f$export$27f123cb9320355)
    ];
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $2f417e9628081c2f$var$rawRoutes = $2f417e9628081c2f$export$d47aca795954578();
const $2f417e9628081c2f$export$2f7745f2f5ab3897 = ()=>// filter out possible duplicate resources
    // route properties can be `getter`. Use object.assign instead of object spread to delay retrieving property if it's `getter`.
    $2f417e9628081c2f$var$rawRoutes.map((route)=>{
        const resources = [
            ...new Set(route.resources)
        ];
        return Object.assign(route, {
            resources: resources
        });
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2f417e9628081c2f$var$isPathBasedRoute(route) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Boolean(route.path);
}
const $2f417e9628081c2f$export$6ca4f07048df7206 = ()=>$2f417e9628081c2f$export$d47aca795954578().filter($2f417e9628081c2f$var$isPathBasedRoute) // Required for static routes webpack plugin due to dynamic paths
    .map((0, $bW80q.default)).map(({ earlyAssets: earlyAssets, entryPoint: entryPoint, exact: exact, forPaint: forPaint, group: group, meta: meta, name: name, path: path, preloadOptions: preloadOptions, query: query, bifrost: bifrost })=>({
            earlyAssets: earlyAssets,
            entryPoint: entryPoint,
            exact: exact,
            forPaint: forPaint,
            group: group,
            meta: meta,
            name: name,
            path: path,
            preloadOptions: preloadOptions,
            query: query,
            bifrost: bifrost
        }));



var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $78Ywx = parcelRequire("78Ywx");

var $8blac = parcelRequire("8blac");

var $ieRGA = parcelRequire("ieRGA");

var $6rW04 = parcelRequire("6rW04");

var $lB25E = parcelRequire("lB25E");

var $7BDEW = parcelRequire("7BDEW");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
const $ba619299535bad37$export$c9d44c736471c518 = (name)=>document.querySelector(`meta[name="${name}"]`);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $ba619299535bad37$var$getHead = ()=>document.head || document.querySelector('head');
const $ba619299535bad37$export$c79fd820617d7f = (name, content)=>{
    if (!name || !content) return;
    const existingMeta = $ba619299535bad37$export$c9d44c736471c518(name);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = name;
    meta.content = content;
    if (existingMeta) existingMeta.parentNode?.replaceChild(existingMeta, meta);
    else {
        const head = $ba619299535bad37$var$getHead();
        if (head) head.appendChild(meta);
    }
};
const $ba619299535bad37$export$4267657a25105d9d = (name)=>{
    const meta = $ba619299535bad37$export$c9d44c736471c518(name);
    if (meta) meta.parentNode?.removeChild(meta);
};



var $cprue = parcelRequire("cprue");
const $36d7090ac0dde683$var$sessionQueryParams = [
    'searchSessionId',
    'searchObjectId',
    'searchContainerId',
    'searchContentType'
];
const $36d7090ac0dde683$var$sessionMeta = [
    'ajs-search-session-id',
    'ajs-search-object-id',
    'ajs-search-container-id',
    'ajs-search-content-type'
];
const $36d7090ac0dde683$var$removeDwellComponent = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (placeholderId && document.getElementById(placeholderId)) // @ts-expect-error - TS2345 - Argument of type 'HTMLElement | null' is not assignable to parameter of type 'Element | DocumentFragment'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    (0, $lEfVV.unmountComponentAtNode)(document.getElementById(placeholderId));
};
const $36d7090ac0dde683$var$removeSessionMeta = ()=>$36d7090ac0dde683$var$sessionMeta.forEach((0, $ba619299535bad37$export$4267657a25105d9d));
// @ts-expect-error - TS7031 - Binding element 'sessionId' implicitly has an 'any' type. | TS7031 - Binding element 'objectId' implicitly has an 'any' type. | TS7031 - Binding element 'containerId' implicitly has an 'any' type. | TS7031 - Binding element 'objectType' implicitly has an 'any' type.
const $36d7090ac0dde683$var$addSessionMeta = ({ sessionId: sessionId, objectId: objectId, containerId: containerId, objectType: objectType })=>{
    const newMeta = {
        'ajs-search-session-id': sessionId,
        'ajs-search-object-id': objectId,
        'ajs-search-container-id': containerId,
        'ajs-search-content-type': objectType
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(newMeta).forEach(([name, content])=>(0, $ba619299535bad37$export$c79fd820617d7f)(name, content));
};
const $36d7090ac0dde683$var$getPreviousSessionId = ()=>(0, $6rW04.default)('ajs-search-session-id');
class $36d7090ac0dde683$export$f1e582dddb502dd6 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.onClearSessionEvent = ()=>{
            if (this.state.shouldRemoveSessionBeIgnored) this.setState({
                shouldRemoveSessionBeIgnored: false
            });
        };
        this.onHistoryChange = (location)=>{
            $36d7090ac0dde683$var$removeDwellComponent('search-dwell-time');
            const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($78Ywx))).parse(location.pathname + location.search, true);
            const queryString = parsedUrl.query || {};
            const { searchSessionId: searchSessionId, searchObjectId: searchObjectId, searchContainerId: searchContainerId, searchContentType: searchContentType } = queryString;
            const { path: path } = parsedUrl;
            const previousSessionId = $36d7090ac0dde683$var$getPreviousSessionId();
            const { shouldRemoveSessionBeIgnored: shouldRemoveSessionBeIgnored } = this.state;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(previousSessionId) && !shouldRemoveSessionBeIgnored) $36d7090ac0dde683$var$removeSessionMeta();
            if (searchSessionId) {
                (0, $ieRGA.default)($36d7090ac0dde683$var$sessionQueryParams);
                const newState = {
                    sessionId: searchSessionId,
                    objectId: searchObjectId,
                    objectType: searchContentType,
                    containerId: searchContainerId,
                    previousSessionId: $36d7090ac0dde683$var$getPreviousSessionId()
                };
                $36d7090ac0dde683$var$addSessionMeta(newState);
                const shouldRemoveSession = !!(0, $cprue.skipClearSessionURLs).find((skipUrlRegex)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(path) ? skipUrlRegex.test(path) : false);
                // @ts-expect-error - TS2345 - Argument of type '{ shouldRemoveSessionBeIgnored: boolean; sessionId: string | string[]; objectId: string | string[] | undefined; objectType: string | string[] | undefined; containerId: string | string[] | undefined; previousSessionId: string | null; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "containerId" | "objectType" | "objectId" | "sessionId" | "previousSessionId" | "shouldRemoveSessionBeIgnored"> | null) | Pick<...> | null'.
                this.setState({
                    ...newState,
                    shouldRemoveSessionBeIgnored: shouldRemoveSession
                });
            }
        };
        this.props.history.listen(this.onHistoryChange);
        this.state = {
            shouldRemoveSessionBeIgnored: false,
            sessionId: ''
        };
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener((0, $cprue.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener((0, $cprue.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    render() {
        if (this.state && this.state.sessionId) {
            const { objectId: objectId, containerId: containerId, objectType: objectType, sessionId: sessionId, previousSessionId: previousSessionId } = this.state;
            const data = {
                objectId: objectId,
                containerId: containerId,
                objectType: objectType,
                source: objectType,
                actionSubject: objectType,
                attributes: {
                    previousSessionId: previousSessionId
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BDEW.default), {
                sessionId: sessionId,
                data: data
            });
        }
        return null;
    }
}
var $36d7090ac0dde683$export$2e2bcd8739ae039 = (0, $lB25E.withRouter)($36d7090ac0dde683$export$f1e582dddb502dd6);



var $2B87Z = parcelRequire("2B87Z");

var $2B87Z = parcelRequire("2B87Z");
const $ce0678b5063705cb$export$ce440b3d0fa0d5ed = ()=>{
    if (false) return;
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush', 'ssr.spa.early-common-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/common-preload', 'ssr.spa.early-common-flush:start', 'ssr.spa.metatags:start');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/metatags', 'ssr.spa.metatags:start', 'ssr.spa.metatags:end');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig:start', 'ssr.spa.statsig:end');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/feature-flags', 'ssr.spa.feature-flags:start', 'ssr.spa.feature-flags:end');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts', 'ssr.spa.feature-flags:end', 'ssr.spa.early-common-flush:end');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/route-preload', 'ssr.spa.early-route-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('css-assets', 'ssr.spa.css-assets:start', 'ssr.spa.css-assets:end');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output', 'ssr.spa.start', 'ssr.spa.state');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/styles', 'ssr.spa.start', 'ssr.spa.styles');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/html', 'ssr.spa.styles', 'ssr.spa.html');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/state', 'ssr.spa.html', 'ssr.spa.state');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa', 'vendor-entry.js:eval-start', 'commons-entry.js:eval-stop');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/vendor', 'vendor-entry.js:eval-start', 'vendor-entry.js:eval-stop');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/commons', 'vendor-entry.js:eval-stop', 'commons-entry.js:eval-stop');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/commons/bundle-ready', 'vendor-entry.js:eval-stop', 'commons-entry.js:eval-start');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/commons/eval', 'commons-entry.js:eval-start', 'commons-entry.js:eval-stop');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/bundle-ready', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-start');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/language-pack', 'jira-spa/language-pack.start', 'jira-spa/language-pack.end', true, true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
};



var $4ea83 = parcelRequire("4ea83");
/* eslint-disable no-await-in-loop */ 
var $gUUjF = parcelRequire("gUUjF");

var $lB25E = parcelRequire("lB25E");
const $be11b329f399dd87$var$LOCATION = 'spa.create-spa-history';
const $be11b329f399dd87$var$createCustomHistoryBlock = (routeBlockFns, currentRoutes, history)=>(blockFn)=>{
        const matchedRoute = (0, $lB25E.matchRoute)(currentRoutes, history.location.pathname, // @ts-expect-error - wrong type of matchRoute (it accepts query param as string)
        history.location.search);
        // This should never be the case as in SPA we have a default route
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!matchedRoute) return ()=>{};
        if (!routeBlockFns.includes(blockFn)) routeBlockFns.push(blockFn);
        // returns an "unregister" block
        return ()=>{
            const idx = routeBlockFns.indexOf(blockFn);
            if (idx !== -1) routeBlockFns.splice(idx, 1);
        };
    };
const $be11b329f399dd87$var$createSpaHistory = (initialRoutes)=>{
    const routeBlockFns = [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let blockArgs = [];
    let nextMatchedRoute;
    const currentRoutes = initialRoutes;
    const history = (0, $lB25E.createBrowserHistory)({
        /* We abuse this api to allow us to run as many blockers as we want, allowing the transition
		 * to resume only when all return true or bail out as soon as the first one returns false */ getUserConfirmation: async (__, done)=>{
            try {
                const matchedRoute = (0, $lB25E.matchRoute)(currentRoutes, history.location.pathname, // @ts-expect-error - wrong type of matchRoute (it accepts query param as string)
                history.location.search);
                // This should never be the case as in SPA we have a default route
                if (!matchedRoute || !nextMatchedRoute) return done(true);
                /* We reverse loop block functions as we want the ones registered later to run first
				 * (respecing the render tree: Route > Page > Form > ...)
				 * we also do it serially, so if the last registed returns false we do not call the others */ for(let i = routeBlockFns.length - 1; i >= 0; i -= 1){
                    const result = await routeBlockFns[i](...blockArgs);
                    if (result === false) return done(false);
                }
                /* After running we clean up the blockers */ routeBlockFns.length = 0;
                return done(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData($be11b329f399dd87$var$LOCATION, 'Error with getUserConfirmation', err);
                return done(true);
            }
        }
    });
    // For lazy loaded route maps we need to keep track of the current routes here
    // as they will be changing. When we "match" for the route blocking code we need
    // to ensure we match against the current routes, not the routes at the time the function
    // was created.
    history.refreshRoutes = (newRoutes)=>{
        // Replace currentRoutes in place as it's captured in a closure above..
        currentRoutes.length = 0;
        currentRoutes.push(...newRoutes);
        // We reset these on the assumption that loading the routes will re-render the SPA components that
        // populate these and re-add them with the correct routes captured in the closure
        routeBlockFns.length = 0;
    };
    /* We set the main "blocker", that is also used enable next location access in getUserConfirmation
	 * (going around getUserConfirmation API limitations) */ history.block((location, action)=>{
        blockArgs = [
            location,
            action
        ];
        nextMatchedRoute = (0, $lB25E.matchRoute)(currentRoutes, location.pathname, // @ts-expect-error - wrong type of matchRoute (it accepts query param as string)
        location.search);
        // Must return a string or getUserConfirmation is not called
        return '';
    });
    // @ts-expect-error - we're using a custom blocker
    history.block = $be11b329f399dd87$var$createCustomHistoryBlock(routeBlockFns, currentRoutes, history);
    return history;
};
var /**
 * Monkey patches the push/replace methods of the react router history object to
 * perform a full page refresh instead of history push/replace when a route is not valid
 * (i.e. legacy pages). This is required to fix the browser back button not working correctly
 * after redirecting to a legacy page.
 * JSPA-900
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$be11b329f399dd87$export$2e2bcd8739ae039 = (routes)=>$be11b329f399dd87$var$createSpaHistory(routes);



var $fGHk2 = parcelRequire("fGHk2");

var $iE8ll = parcelRequire("iE8ll");

var $jK1pm = parcelRequire("jK1pm");

var $2ctsX = parcelRequire("2ctsX");

var $lB25E = parcelRequire("lB25E");


var $02rEB = parcelRequire("02rEB");

var $4fyxC = parcelRequire("4fyxC");

var $ku8gc = parcelRequire("ku8gc");

var $4nnPJ = parcelRequire("4nnPJ");

var $foPCo = parcelRequire("foPCo");
const $077123d74a10e7f8$var$isPreprodSlow = ()=>(0, $1ybV0.getFeatureFlagValue)('uip.preprod.slow', 0);
(0, $6iz4v.setMark)('JIRA_SPA_ENTRY_LOADED');
// Set SPA global
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window.__SPA__ = true;
(0, $ek61b.LooselyLazy).init({
    mode: (0, $8dNND.MODE).RENDER,
    crossOrigin: 'anonymous'
});
const $077123d74a10e7f8$var$tenantContext = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
(0, $6iz4v.setMark)('jira-spa/language-pack.start');

var $7KGHt = parcelRequire("7KGHt");
(0, $6iz4v.setMark)('jira-spa/language-pack.end');
const { locale: $077123d74a10e7f8$var$locale } = $077123d74a10e7f8$var$tenantContext;
const $077123d74a10e7f8$var$superbatchInit = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.DeferScripts = {
        deferState: 'done'
    };
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body && document.body.classList.remove('deferred');
};
const $077123d74a10e7f8$var$globalSettingsArgs = {
    navigation: false,
    upflow: false
};
const $077123d74a10e7f8$var$InstallGlobalComponentsOnce = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        (0, $foPCo.default).installLowPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'LowPriorityAppsArgs'.
        (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))($077123d74a10e7f8$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        (0, $6iz4v.setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
    }, []);
    return null;
};
const $077123d74a10e7f8$var$updateCapability = (capability)=>{
    (0, $gXgRp.setCapability)(capability);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $d07297a4af13004b$export$9a80695e72849f84]) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.AJS.$.ajaxSettings.headers[0, $d07297a4af13004b$export$9a80695e72849f84];
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS?.$?.ajaxSetup({
        headers: {
            [(0, $d07297a4af13004b$export$9a80695e72849f84)]: capability
        }
    });
};
// @ts-expect-error - TS7031 - Binding element 'routes' implicitly has an 'any' type.
const $077123d74a10e7f8$var$CapabilityTrackerConnector = ({ routes: routes })=>{
    const { registerBlock: registerBlock } = (0, $lB25E.useRouterActions)();
    registerBlock((nextLocation)=>{
        const nextMatchObject = (0, $lB25E.matchRoute)(routes, nextLocation.pathname, // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        nextLocation.search, '');
        $077123d74a10e7f8$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
        return true;
    });
    const route = (0, $10fdS.useCurrentRoute)();
    $077123d74a10e7f8$var$updateCapability(route.meta?.capability || null);
    return null;
};
const $077123d74a10e7f8$var$main = async ()=>{
    (0, $iE8ll.default)();
    (0, $a5pCl.initBrowserMetrics3)();
    (0, $d16Bc.initPlatformFeatureFlags)((0, $2ctsX.visualRefreshResolverOverride));
    (0, $ce0678b5063705cb$export$ce440b3d0fa0d5ed)();
    (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
    (0, $6iz4v.setMark)('jira-spa/setup.start');
    const routes = (0, $2B87Z.measureInitialPageLoadTiming)('jira-spa/setup/routes', ()=>(0, $2f417e9628081c2f$export$2f7745f2f5ab3897)());
    const history = (0, $2B87Z.measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, $be11b329f399dd87$export$2e2bcd8739ae039)(routes));
    const initRoute = (0, $2B87Z.measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const matchedRoute = (0, $lB25E.matchRoute)(routes, window.location.pathname, window.location.search);
        (0, $keguF.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        return matchedRoute;
    });
    if (initRoute != null) {
        const ufoName = (0, $5e25b53b6ab9e2aa$export$2e2bcd8739ae039)(initRoute.route);
        (0, $02rEB.default)(ufoName, initRoute.route.name);
    }
    const BrowserMetricsConnector = ()=>{
        const route = (0, $10fdS.useCurrentRoute)();
        (0, $acbV3.browserMetrics).setRoute(route.name);
        (0, $4fyxC.useUFOTransitionCompleter)();
        if ((0, $1ybV0.ff)('uip.ufo')) (0, $4nnPJ.GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
        return null;
    };
    if ((0, $1ybV0.ff)('uip.ufo')) (0, $4nnPJ.GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
    const routerProps = {
        history: history,
        routes: routes,
        basePath: '',
        initialRoute: initRoute?.route,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        resourceData: window.SPA_STATE,
        resourceContext: (0, $fGHk2.getSpaRouterContext)({
            tenantContext: $077123d74a10e7f8$var$tenantContext
        }),
        onPrefetch: ({ route: route, match: match })=>{
            (0, $4ea83.setPrefetchStartMark)(match);
            if (!route.forPaint) return;
            route.forPaint.map((component)=>component.preload && component.preload());
        }
    };
    const SpaClientRouter = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gTSbo.Router), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "spa-main.client-router",
            packageName: "jiraEntry",
            fallback: "unmount",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($077123d74a10e7f8$var$CapabilityTrackerConnector, {
            routes: routes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $36d7090ac0dde683$export$2e2bcd8739ae039), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6U1dF.NonCritical), {
            id: "spa-main.client-router.non-critical",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($077123d74a10e7f8$var$InstallGlobalComponentsOnce, null)));
    const App = ({ placeholders: placeholders })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "jira-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholderContext).Provider, {
            value: placeholders
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37f6df81ea368cad$export$6d4069f4b64f7492), {
            baseUrl: "",
            locale: $077123d74a10e7f8$var$locale,
            messages: $7KGHt,
            Router: SpaClientRouter,
            initRoute: initRoute,
            routes: routes,
            routerLinkComponent: (0, $9DIQe.JiraRouterLinkConfiguration)
        }))));
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__NAV_VERSION__ = '3.0.0';
    (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
    (0, $6iz4v.setMark)('_jira-spa/spa-shell.start');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const container = document.getElementById('jira-frontend');
    if (container) {
        if ((0, $1ybV0.ff)('uip.vc.partial', false)) {
            (0, $ku8gc.getVCObserver)().setSSRElement(container);
            (0, $ku8gc.getVCObserver)().setReactRootRenderStart();
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    (0, $ku8gc.getVCObserver)().setReactRootRenderStop();
                });
            });
        }
        const placeholders = (0, $8R80x.getPlaceholdersFromHTML)();
        // if the feature flag is false, do not opt into concurrent features
        // if the local env var is not set, or set to false, do not opt into concurrent features
        if (!(0, $eI5EY.fg)('jfp-magma-concurrent-root-jira-spa') && true) (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(App, {
            placeholders: placeholders
        }), container);
        if ((0, $eI5EY.fg)('jfp-magma-concurrent-root-jira-spa')) {
            const root = (0, $gpO36.createRoot)(container);
            root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(App, {
                placeholders: placeholders
            }));
        }
    }
    (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
    (0, $6iz4v.setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
    setTimeout(()=>{
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
    });
    if ($077123d74a10e7f8$var$isPreprodSlow() > 0) {
        (0, $6iz4v.setMark)('slow-start');
        const end = performance.now() + $077123d74a10e7f8$var$isPreprodSlow();
        while(performance.now() < end);
        (0, $6iz4v.setMark)('slow-stop');
    }
    (0, $foPCo.default).installHighPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'HighPriorityAppsArgs'.
    (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))($077123d74a10e7f8$var$globalSettingsArgs, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
    $077123d74a10e7f8$var$superbatchInit();
    return null;
};
$077123d74a10e7f8$var$main().catch((reason)=>(0, $0507482b123635a1$export$a5c16644a2d3c205)(reason));
 }, ["eNmuD","dsiAd","2Lfdl","hPzOn","1QYl5","561Jq","i5RRW","92sUi","kWrFZ","bYT2S","h2MrD","fr9NE","cM9em","lknvU"]);

$parcel$global.rlb("bz9bg")
//# sourceMappingURL=jira-spa.dd0389d5.js.map
